/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		17: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://us.fluidreview.com/media/c/bundles/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1220);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = __webpack_require__(1549);
Hogan.Template = __webpack_require__(1550).Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1562);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(88);
var hide = __webpack_require__(65);
var redefine = __webpack_require__(66);
var ctx = __webpack_require__(89);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Alert = __webpack_require__(10);
var Loader = __webpack_require__(93);
var progressTempl = __webpack_require__(1556);

var newProgressBar = function newProgressBar() {
  var _this = this;

  var xhr = new window.XMLHttpRequest();
  var startDate = void 0;
  var lastPercent = 0;
  var fakeIt = false;
  var grid = null;
  var tableWrap = this.progressData.tableWrap;

  var fadeOutProgress = function fadeOutProgress($el) {
    if (grid) {
      grid.load();
    }

    setTimeout(function () {
      if (tableWrap) {
        $el.find('td').slideUp(500);
        $el.find('td > div').slideUp(500, function () {
          return $el.remove();
        });
      } else {
        $el.slideUp(500, function () {
          return $el.remove();
        });
      }
    }, 3000);
  };

  // execute this when progress bar is 100%
  var done = function done($el) {
    $el.find('.sma-js-progress-cancel').replaceWith('<i class="nc-icon-mini ui-1_check-simple"></i>');
    fadeOutProgress($el);
  };

  // show progress state
  var displayProgress = function displayProgress(percentComplete, $el) {
    $el.find('.sma-js-percentage').text(percentComplete);
    $el.find('.progress').val(percentComplete);
  };

  // do this to simulate loading if the file is uploaded to fast
  var doFakeProgress = function doFakeProgress($el) {
    var fakePercent = 0;
    var fakeProgInterval = setInterval(function () {
      displayProgress(fakePercent, $el);

      if (fakePercent >= 100) {
        clearInterval(fakeProgInterval);
        done($el);
      }

      fakePercent += 1;
    }, 10);
  };

  // do this when starting the upload
  xhr.upload.onloadstart = function (evt) {
    var data = _this.progressData;
    data.$el = data.$el || $(progressTempl({
      filename: data.filename,
      cancelText: gettext('Cancel'),
      tableWrap: data.tableWrap || false
    }));

    grid = data.grid || null;

    data.$el.find('.sma-js-progress-cancel').click(function () {
      xhr.abort();
      data.$el.find('.sma-js-percentage-wrap').html('CANCELLED');
      fadeOutProgress(data.$el);

      new Alert({
        type: 'danger',
        message: gettext('File upload was cancelled.')
      });
      return false;
    });

    if (data.prepend) {
      data.$el.prependTo(data.$container).find('td').hide();
    } else {
      data.$el.appendTo(data.$container).find('td').hide();
    }
    data.$el.find('td').slideDown(500);
    data.$el.find('td > div').slideDown(500);

    startDate = new Date();
  };

  // do this every 30 or so milliseconds while uploading
  xhr.upload.addEventListener('progress', function (evt) {
    if (evt.lengthComputable) {
      var percentComplete = evt.loaded / evt.total;
      percentComplete = parseInt(percentComplete * 100);

      var timeDelta = new Date() - startDate;

      //tweak this value, it is the threshhold to determine if we will fake progress
      if (percentComplete - lastPercent > 10 && !fakeIt) {
        fakeIt = true;
      }

      // only display during progress if were not going to fake it
      if (!fakeIt) {
        displayProgress(percentComplete, _this.progressData.$el);
      }

      // either fake the progress or finish up once completed
      if (percentComplete === 100) {
        if (fakeIt) {
          doFakeProgress(_this.progressData.$el);
          percentComplete = 0;
        } else {
          done(_this.progressData.$el);
        }
      }

      lastPercent = percentComplete;
    }
  }, false);

  return xhr;
};

var REQUEST = function REQUEST(options) {
  if (options.loaderElement !== undefined) {
    options.loaderSize = options.loaderSize || 'md';
    options.loader = new Loader(options.loaderElement, options.loaderSize);
    options.loader.show();
  }

  var alertOnSuccess = 'alertOnSuccess' in options ? options.alertOnSuccess : true;
  var defaultSuccessAlert = 'defaultSuccessAlert' in options ? options.defaultSuccessAlert : '';
  var alertOnError = 'alertOnError' in options ? options.alertOnError : true;
  var noMultiple = 'noMultiple' in options ? options.noMultiple : false;
  var onFail = options.onFail || options.error || function () {};

  var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
  var data = 'data' in options ? options['data'] : {};

  // default datatype will be json and will set contentType to javascript
  // unless contentType is passed in
  if (options.type === 'POST' && (options.dataType === undefined || options.dataType === 'json') && !('contentType' in options)) {

    contentType = 'application/json; charset=UTF-8';
    data = JSON.stringify(data);
  }

  var ajaxOptions = {
    url: 'url' in options ? options['url'] : '',
    type: 'type' in options ? options['type'] : 'POST',
    data: data,
    async: 'async' in options ? options['async'] : true,
    processData: 'processData' in options ? options['processData'] : true,
    contentType: 'contentType' in options ? options['contentType'] : contentType,
    dataType: 'dataType' in options ? options['dataType'] : 'json',
    progressData: options.progressData || null,
    headers: options.headers || null,
    success: function success(response, textStatus, jqXHR) {
      var type = void 0;
      if (jqXHR.status === 204) {
        type = 'success';
      } else {
        if (response.success === false) {
          type = 'danger';
        } else {
          type = 'success';
        }
      }

      if (type === 'success' || 'alwaysCallback' in options) {
        var callback = 'callback' in options ? options['callback'] : function (_response) {};
        callback(response);
      }

      if (alertOnSuccess && type === 'success' || alertOnError && type === 'danger') {
        var oldAlerts = [];
        if (noMultiple) {
          oldAlerts = document.getElementsByClassName('alert-' + type);
        }
        if (!options.noAlert && oldAlerts.length === 0 && !(options.noSuccessAlert && type === 'success')) {
          new Alert({
            type: type,
            message: response && response.message ? response.message : defaultSuccessAlert
          });
        }
      }

      if (options.loader) {
        options.loader.hide();
      }
    }
  };

  if (options.progressBar) {
    ajaxOptions.xhr = newProgressBar;
  }

  $.ajax(ajaxOptions).fail(function (xhr, _textStatus, _errorThrown) {
    onFail(xhr);
    if (alertOnError) {
      if (xhr.status === 409) {
        new Alert({
          type: 'warning',
          message: xhr.responseJSON.detail
        });
      } else if (xhr.status === 400 && xhr.responseJSON.non_field_errors) {
        new Alert({
          type: 'danger',
          message: xhr.responseJSON.non_field_errors[0]
        });
      } else {
        new Alert({
          type: 'danger',
          message: gettext('Unknown Error')
        });
      }
    }
  });
};

var POST = function POST(options) {
  options['type'] = 'POST';
  REQUEST(options);
};

var PUT = function PUT(options) {
  options['type'] = 'PUT';
  REQUEST(options);
};

var DELETE = function DELETE(options) {
  options['type'] = 'DELETE';
  REQUEST(options);
};

var GET = function GET(options) {
  options['type'] = 'GET';
  options['noAlert'] = true;
  REQUEST(options);
};

$(function () {
  $('a.sma-ajax-post').unbind('click').click(function (e) {
    e.preventDefault();
    var $el = $(e.target);
    var url = $el.attr('href');
    POST({
      url: url,
      data: {}
    });
    return true;
  });
});

module.exports = {
  request: REQUEST,
  post: POST,
  delete: DELETE,
  get: GET,
  put: PUT
};

// options = {
// 	'url': SOMETHING_URL,
// 	'request_type': 'POST',
// 	'data': {
// 		'something': 1
// 	},
// 	'callback': (data) => {
// 		stuff(data)
// 	}
// }

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1567)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ContentModal = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backbone = __webpack_require__(40);

var Backbone = _interopRequireWildcard(_backbone);

var _loader = __webpack_require__(93);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ajax = __webpack_require__(4);
var Alert = __webpack_require__(10);

var baseModalTempl = __webpack_require__(1557);
var buttonTempl = __webpack_require__(1558);
var promptPartial = __webpack_require__(1559);
var deleteStatusPartial = __webpack_require__(1560);
var checkboxPartial = __webpack_require__(1561);

var Content = function () {
	function Content(options) {
		_classCallCheck(this, Content);

		this.html = options.html;
		this.events = options.events || {};
		this.title = options.title || '';
		this.subtitle = options.subtitle || '';
		this.buttons = options.buttons || [];
		this.modal = options.modal;
		this.extraData = {};
	}

	_createClass(Content, [{
		key: 'setHtml',
		value: function setHtml(html) {
			this.html = html;
		}
	}, {
		key: 'onSwitchTo',
		value: function onSwitchTo(_modal, _id) {
			var _reRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
		}
	}, {
		key: 'onSwitchOut',
		value: function onSwitchOut(_modal, _id) {}
	}, {
		key: 'onRendered',
		value: function onRendered(_modal) {}
	}, {
		key: 'isDelayed',
		get: function get() {
			return false;
		}
	}]);

	return Content;
}();

var Modal = function (_Backbone$View) {
	_inherits(Modal, _Backbone$View);

	function Modal() {
		_classCallCheck(this, Modal);

		return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	}

	_createClass(Modal, [{
		key: 'handleOptions',
		value: function handleOptions(options) {
			options = options || {};

			this.title = options.title || '';
			this.subtitle = options.subtitle || '';
			this.size = options.size || 'md';
			this.buttons = options.buttons || [];
			this.overwriteFooter = options.overwriteFooter || false;

			this.destroyCallback = options.destroyCallback || null;

			this.onShow = options.onShow || function () {
				return;
			};
			this.autoShow = options.autoShow || false;
			this.destroyOnClose = options.destroyOnClose || false;
			this.async = options.async || false;
			this.useButtonLoaders = options.useButtonLoaders || false;
			this.onClose = options.onClose || function () {
				return;
			};

			this.modalHeaderTemplate = options.headerTemplate || null;
			this.modalHeaderContext = options.headerContext || {};

			this.bodyClass = options.bodyClass || '';
			this.fromModal = options.fromModal || false;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			this.outerWrap = $('<div class="sma-modal-outer-wrap"></div>').appendTo('body').hide();

			var baseCtxt = {
				title: this.title,
				subtitle: this.subtitle,
				size: this.size,
				cls: this.cls,
				strings: {
					close: gettext('Close')
				}
			};

			this.wrap = $(baseModalTempl(baseCtxt));

			this.modalShade = $('<div class="sma-modal-shade"></div>');
			this.modalWindow = $('.sma-modal', this.wrap);
			this.modalBody = $('.sma-modal-content', this.wrap);
			this.modalFooter = $('.sma-modal-footer', this.wrap);
			this.modalClose = $('.sma-modal-close', this.wrap);
			this.modalHeader = $('.sma-modal-header', this.wrap);

			if (this.bodyClass) {
				this.modalBody.addClass(this.bodyClass);
			}

			if (this.modalHeaderTemplate !== null) {
				this.modalHeader.html(this.modalHeaderTemplate($.extend(baseCtxt, this.modalHeaderContext)));
			}

			if (this.buttons !== undefined && this.buttons.length) {
				this.renderButtons();
			}

			this.modalShade.appendTo('body');
			this.modalBody.append(this.$el);
			this.wrap.appendTo(this.outerWrap);

			this.modalClose.click(function (e) {
				_this2.closeModal(e);
			});

			if (this.autoShow) {
				this.show();
			}
		}
	}, {
		key: 'closeModal',
		value: function closeModal(e) {
			if (e) {
				e.preventDefault();
			}

			this.onClose();

			if (this.previouslyFocusedElement) {
				$(this.previouslyFocusedElement).focus();
			}

			this.onClose();

			this.hide();
		}
	}, {
		key: 'renderButtons',
		value: function renderButtons() {
			var _this3 = this;

			var that = this;
			this.modalFooter.empty();

			if (this.buttons.length > 0) {
				this.modalFooter.show();
				this.modalBody.removeClass('sma-modal-no-footer');

				var _loop = function _loop(cfg) {
					(function (buttoncfg) {
						var button = $(buttonTempl(_extends({}, buttoncfg, {
							useButtonLoaders: that.useButtonLoaders,
							cls: that.useButtonLoaders ? buttoncfg.cls + ' btn-with-loader' : buttoncfg.cls
						})));

						if (that.useButtonLoaders && cfg.footerLoader === undefined) {
							cfg.footerLoader = new _loader2.default(button.find('.btn-loader')[0], 'sm');
							cfg.footerLoader.hide();
						}

						button.click(function () {
							if (that.useButtonLoaders) {
								button.find('.btn-label')[0].classList.add('invisible');
								button.attr('disabled', 'disabled');
								cfg.footerLoader.show();
							}
							return buttoncfg.handler(that);
						});

						that.modalFooter.append(button);
						cfg.htmlNode = button;
					})(cfg);
				};

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.buttons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var cfg = _step.value;

						_loop(cfg);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				var _loop2 = function _loop2(button) {
					button.hideLoader = function () {
						if (_this3.useButtonLoaders) {
							button.footerLoader.hide();
							button.htmlNode.find('.btn-label')[0].classList.remove('invisible');
							button.htmlNode.removeAttr('disabled');
						}
					};
				};

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = this.buttons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var button = _step2.value;

						_loop2(button);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			} else {
				this.modalFooter.hide();
				if (!this.overwriteFooter) {
					this.modalBody.addClass('sma-modal-no-footer');
				}
			}
		}
	}, {
		key: 'setTitle',
		value: function setTitle(title) {
			var subtitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			$('.sma-modal-title', this.wrap).html(title);
			if (subtitle !== null) {
				$('.sma-modal-subtitle', this.wrap).html(subtitle);
			}
		}
	}, {
		key: 'setContent',
		value: function setContent(content) {
			this.modalBody.html(content);
		}
	}, {
		key: 'setButtons',
		value: function setButtons(buttons) {
			this.buttons = buttons;
			this.renderButtons();
		}
	}, {
		key: 'show',
		value: function show() {
			var _this4 = this;

			this.outerWrap.addClass('open');
			this.outerWrap.show();

			this.modalShade.show();

			this.modalWindow.css({
				opacity: 0
			}).show().animate({
				opacity: 1
			}, 200, function () {
				$(document).trigger('smaModalShown', [_this4]);
			});

			this.onShow();

			var focusableElements = this.modalWindow.find(':tabbable');

			var firstFocusableElement = focusableElements.first();
			var lastFocusableElement = focusableElements.last();

			lastFocusableElement.on('keydown', function (e) {
				if (e.which === 9 && !e.shiftKey) {
					e.preventDefault();
					firstFocusableElement.focus();
				}
			});

			firstFocusableElement.on('keydown', function (e) {
				if (e.which === 9 && e.shiftKey) {
					e.preventDefault();
					lastFocusableElement.focus();
				}
			});

			$(document).on('keydown', function (e) {
				if (e.keyCode == 27) {
					_this4.closeModal();
				}
			});

			this.previouslyFocusedElement = document.activeElement;

			// If there's nothing to focus in the body of the modal, set focus on the first tabbable item on the modal

			if (this.modalBody.find(':tabbable').length > 0) {
				this.modalBody.find(':tabbable').first().focus();
			} else {
				firstFocusableElement.focus();
			}

			if (this.fromModal) {
				var zindex = this.modalBody.parents('.sma-modal-outer-wrap').css('z-index');
				this.modalBody.parents('.sma-modal-outer-wrap').css('z-index', zindex + 1);
			}

			$('html').css('overflow', 'hidden');
		}
	}, {
		key: 'hide',
		value: function hide(destroy) {
			var _this5 = this;

			this.outerWrap.hide();
			this.outerWrap.removeClass('open');
			this.modalShade.hide();

			this.modalWindow.animate({
				opacity: 0
			}, 200, function () {
				if (destroy || _this5.destroyOnClose) {
					_this5.destroy();
				} else {
					_this5.modalWindow.hide();
				}
			});

			$('html').css('overflow', 'auto');

			$(document).trigger('smaModalHide', [this]);
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			$('html').css('overflow', 'auto');
			this.outerWrap.remove();
			this.wrap.remove();
			this.modalShade.remove();
			if (this.destroyCallback !== null) {
				this.destroyCallback();
			}
		}
	}, {
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-automation-popup-modal';
		}
	}]);

	return Modal;
}(Backbone.View);

var MultiModal = function (_Modal) {
	_inherits(MultiModal, _Modal);

	function MultiModal(options) {
		_classCallCheck(this, MultiModal);

		var _this6 = _possibleConstructorReturn(this, (MultiModal.__proto__ || Object.getPrototypeOf(MultiModal)).call(this, options));

		_this6.handleOptions(options);

		_this6.stack = [];
		_this6.history = [];
		_this6.boundEvents = [];
		_this6.currentContent = null;

		_this6.render();
		return _this6;
	}

	_createClass(MultiModal, [{
		key: 'closeModal',
		value: function closeModal(e) {
			if (e) {
				e.preventDefault();
			}

			this.onClose();

			if (this.history.length > 1) {
				this.back();
			} else {
				if (this.previouslyFocusedElement) {
					$(this.previouslyFocusedElement).focus();
				}

				this.hide();
			}
		}
	}, {
		key: 'addToStack',
		value: function addToStack(id, content) {
			var switchTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			this.stack.push({
				id: id,
				content: content
			});

			if (this.stack.length == 1 || switchTo) {
				this.switchToContent(id);
			}
		}
	}, {
		key: 'getStackItemById',
		value: function getStackItemById(id) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = this.stack[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var stackItem = _step3.value;

					if (stackItem.id == id) {
						return stackItem;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return null;
		}
	}, {
		key: 'getCurrentContent',
		value: function getCurrentContent() {
			var currentContent = this.getStackItemById(this.currentContent);
			return currentContent.content;
		}
	}, {
		key: 'updateModalContent',
		value: function updateModalContent(content) {
			this.setButtons(content.buttons);
			this.setTitle(content.title, content.subtitle);
			this.setContent(content.html);
			this.bindEvents(content);
			content.onRendered(this);
		}
	}, {
		key: 'switchToContent',
		value: function switchToContent(id) {
			var saveToHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var reRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			var stackItem = this.getStackItemById(id);
			if (stackItem == null) {
				return;
			}

			if (!stackItem.content.isDelayed) {
				this.updateModalContent(stackItem.content);
			}

			if (this.currentContent != null) {
				var oldItem = this.getStackItemById(this.currentContent.id);
				if (oldItem != null) {
					oldItem.content.onSwitchOut(this, this.currentContent.id);
				}
			}
			var oldContent = this.currentContent;

			this.currentContent = stackItem.id;
			stackItem.content.onSwitchTo(this, stackItem.id, reRender);

			if (saveToHistory) {
				if (this.history.indexOf(stackItem.id) > -1) {
					this.history.pop(oldContent.id);
				} else {
					this.history.push(stackItem.id);
				}
			}
		}
	}, {
		key: 'back',
		value: function back() {
			var pop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (this.history.length <= 1) {
				return;
			}

			var nextContentId = this.history[this.history.length - 2];
			if (pop) {
				this.history.pop();
			}
			this.switchToContent(nextContentId, false);
		}
	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = this.boundEvents[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var event = _step4.value;

					if (event.length == 1) {
						this.modalWindow.off(event);
					} else {
						this.modalWindow.off(event[0], event[1]);
					}
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			this.boundEvents.length = 0;
			this.boundEvents = [];
		}
	}, {
		key: 'bindEvents',
		value: function bindEvents(content) {
			if (content === undefined || content === null) {
				return;
			}

			this.unbindEvents();

			for (var eventSelector in content.events) {
				var handler = content.events[eventSelector];

				var splitSelector = eventSelector.split(' ');

				if (typeof handler == 'string') {
					handler = $.proxy(content[handler], content);
				}

				if (splitSelector.length == 1) {
					this.modalWindow.on(splitSelector, handler);
				} else {
					this.modalWindow.on(splitSelector[0], splitSelector[1], handler);
				}

				if (splitSelector !== null) {
					this.boundEvents.push(splitSelector);
				}
			}
		}
	}]);

	return MultiModal;
}(Modal);

var ContentModal = exports.ContentModal = function (_Modal2) {
	_inherits(ContentModal, _Modal2);

	function ContentModal(content, options) {
		_classCallCheck(this, ContentModal);

		var _this7 = _possibleConstructorReturn(this, (ContentModal.__proto__ || Object.getPrototypeOf(ContentModal)).call(this));

		_this7.handleOptions(options);

		_this7.element = content;

		if (content instanceof jQuery) {
			content = content[0];
		}
		_this7.setElement(content);
		_this7.render();
		return _this7;
	}

	return ContentModal;
}(Modal);

var AjaxFormContent = function (_Content) {
	_inherits(AjaxFormContent, _Content);

	function AjaxFormContent(url, options) {
		_classCallCheck(this, AjaxFormContent);

		var _this8 = _possibleConstructorReturn(this, (AjaxFormContent.__proto__ || Object.getPrototypeOf(AjaxFormContent)).call(this, options));

		_this8.url = url;
		_this8.responseData = null;
		_this8.onLoad = options.onLoad || function () {};
		_this8.onError = options.onError || function () {};
		_this8.footerContent = null;
		_this8.alwaysCallback = options.alwaysCallback || false;
		return _this8;
	}

	_createClass(AjaxFormContent, [{
		key: 'onSwitchTo',
		value: function onSwitchTo(modal, stackItemId) {
			var _this9 = this;

			var reRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			if (!reRender && this.html) {
				modal.updateModalContent(this);
				// If the buttons are configured in JS
				if (!modal.buttons.length) {
					modal.modalFooter.html(this.footerContent);
					modal.modalFooter.show();
				}
				return;
			}
			var options = {
				url: this.url,
				data: this.extraData,
				alertOnSuccess: false,
				alwaysCallback: this.alwaysCallback,
				contentType: 'json',
				callback: function callback(response) {
					if (response.success == false) {
						_this9.onError(response);
						return;
					}
					// Shouldn't use ids in dynamic content
					if ($(response.html).find('#modal-title').length > 0) {
						_this9.title = $(response.html).find('#modal-title').html();
					}
					_this9.responseData = response;
					_this9.html = response.html;

					// follow ajax-modal links
					_this9.events['click a.ajax-modal'] = function (e) {
						e.preventDefault();
						var $modalLink = $(_this9);
						var newSize = $modalLink.data('size') || modal.size;
						modalUrl[0] = $modalLink.attr('href');

						$.get(modalUrl[0], function (response) {
							if (response.redirect) {
								modal.onSuccess(response);
								modal.hide();
							} else {
								var title = $(response.html).find('#modal-title').html();
								var sizeClass = 'sma-modal-' + modal.size;
								var newSizeClass = 'sma-modal-' + newSize;
								var $sizeElement = modal.wrap.find('.' + sizeClass);

								$sizeElement.removeClass(sizeClass);
								$sizeElement.addClass(newSizeClass);
								modal.setTitle(title);
								modal.setContent(response.html);
							}
						});
					};

					// Submit forms using ajax
					// This is an ie fix
					var ua = window.navigator.userAgent;
					if (ua.indexOf('MSIE ') > -1 || ua.indexOf('rv:11.0') > -1 || ua.indexOf(' Edge') > -1) {
						_this9.events['click [type="submit"]'] = function (e) {
							modal.onSubmit(e);
						};
					} else {
						_this9.events['submit form'] = function (e) {
							modal.onSubmit(e);
						};
					}

					_this9.events['click [data-dismiss="modal"]'] = function (_e) {
						modal.hide();
					};

					modal.setTitle(_this9.title);
					modal.setContent(_this9.html);

					if (_this9.buttons.length) {
						// If the buttons are configured in JS
						modal.setButtons(_this9.buttons);
					} else {
						// If the buttons come from the servers in its own footer
						var footerSelector = '.sma-modal-footer';
						_this9.footerContent = modal.modalBody.find(footerSelector).html();
						modal.modalFooter.html(_this9.footerContent);
						modal.modalBody.find(footerSelector).remove();
						modal.modalFooter.show();
					}
					modal.bindEvents(_this9);
					_this9.onRendered(modal);
					_this9.onLoad();
				}
			};
			ajax.get(options);
		}
	}, {
		key: 'isDelayed',
		get: function get() {
			return true;
		}
	}]);

	return AjaxFormContent;
}(Content);

var AjaxFormModal = function (_MultiModal) {
	_inherits(AjaxFormModal, _MultiModal);

	function AjaxFormModal(options) {
		_classCallCheck(this, AjaxFormModal);

		var _this10 = _possibleConstructorReturn(this, (AjaxFormModal.__proto__ || Object.getPrototypeOf(AjaxFormModal)).call(this, options));

		options = options || {};
		return _this10;
	}

	_createClass(AjaxFormModal, [{
		key: 'onSubmit',
		value: function onSubmit(e) {
			var _this11 = this;

			if (e) {
				e.preventDefault();
			}

			var $form = this.modalBody.find('form');
			var $button = $(document.activeElement);

			// include submit button name/value if present
			if ($button.length && $form.has($button) && $button.is('[name]') && $button.is('button[type="submit"], input[type="submit"], input[type="image"]')) {
				$('<input type="hidden" value="" />').attr('name', $button.attr('name')).attr('value', $button.val()).prependTo($form);
			}
			var formData = new FormData($form[0]);
			var currentContent = this.getCurrentContent();

			var options = {
				method: 'POST',
				url: currentContent.url,
				data: formData,
				async: this.async,
				cache: false,
				contentType: false,
				processData: false,
				alwaysCallback: true,
				alertOnSuccess: false,
				alertOnError: false,
				callback: function callback(response) {
					if (response.html) {
						var footerSelector = '.sma-modal-footer';
						_this11.modalBody.html($(response.html));
						_this11.modalFooter.html(_this11.modalBody.find(footerSelector).html());
						_this11.modalBody.find(footerSelector).remove();
						currentContent.onLoad();
					}
					if (_this11.useButtonLoaders) {
						// Response received, so stop all loaders on buttons
						_this11.buttons.map(function (button) {
							return button.hideLoader();
						});
					}
					if (response.success) {
						_this11.onSuccess(response);
					}
					if (response.nextContentId) {
						_this11.switchToContent(response.nextContentId);
					}
				},
				onFail: function onFail(xhr) {
					var response = xhr.responseJSON;
					if (response) {
						_this11.modalBody.html($(response.html));
					} else {
						new Alert({
							type: 'danger',
							message: gettext('Unknown error occured')
						});
					}
				}
			};

			ajax.post(options);
		}
	}, {
		key: 'handleOptions',
		value: function handleOptions(options) {
			options = options || {};
			_get(AjaxFormModal.prototype.__proto__ || Object.getPrototypeOf(AjaxFormModal.prototype), 'handleOptions', this).call(this, options);
			this.onSuccess = function (response) {
				if (response.redirect !== undefined) {
					window.location.href = response.redirect;
				}
			};

			if (options.onSuccess) {
				this.onSuccess = options.onSuccess.bind(this);
			}
		}
	}]);

	return AjaxFormModal;
}(MultiModal);

var URLModal = function (_Modal3) {
	_inherits(URLModal, _Modal3);

	function URLModal(url, options) {
		_classCallCheck(this, URLModal);

		var _this12 = _possibleConstructorReturn(this, (URLModal.__proto__ || Object.getPrototypeOf(URLModal)).call(this));

		_this12.url = url;
		_this12.handleOptions(options);

		var modal = _this12;

		$.get(_this12.url, function (response) {
			modal.element = response;
			modal.setElement(response);
			modal.render();
		});
		return _this12;
	}

	return URLModal;
}(Modal);

var AjaxURLModal = function (_Modal4) {
	_inherits(AjaxURLModal, _Modal4);

	function AjaxURLModal(url, options) {
		_classCallCheck(this, AjaxURLModal);

		var _this13 = _possibleConstructorReturn(this, (AjaxURLModal.__proto__ || Object.getPrototypeOf(AjaxURLModal)).call(this));

		_this13.url = url;
		_this13.handleOptions(options);

		var modal = _this13;

		$.get(_this13.url, function (response) {
			if (response.success) {
				modal.element = response.html;
				modal.setElement(response.html);
				modal.render();
			}
		});
		return _this13;
	}

	return AjaxURLModal;
}(Modal);

var TemplateModal = function (_Modal5) {
	_inherits(TemplateModal, _Modal5);

	_createClass(TemplateModal, [{
		key: 'template',
		get: function get() {
			throw 'Please override and provide a template';
		}
	}]);

	function TemplateModal(options, ctx) {
		_classCallCheck(this, TemplateModal);

		var _this14 = _possibleConstructorReturn(this, (TemplateModal.__proto__ || Object.getPrototypeOf(TemplateModal)).call(this));

		_this14.handleOptions(options);

		_this14.element = $(_this14.template(ctx));
		_this14.setElement(_this14.element[0]);

		_this14.render();
		return _this14;
	}

	return TemplateModal;
}(Modal);

var Prompt = function (_Modal6) {
	_inherits(Prompt, _Modal6);

	_createClass(Prompt, [{
		key: 'cls',

		// Basic modal with a text input. The content of
		// the text box will get passed into your callback
		// function when clicking OK.
		get: function get() {
			return 'sma-modal sma-modal-prompt sma-automation-popup-modal';
		}
	}]);

	function Prompt(title, description, callback, options) {
		_classCallCheck(this, Prompt);

		var _this15 = _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call(this));

		options = options || {};
		options.maxLength = options.maxLength || 200;

		_this15.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-link btn-loud',
				id: 'sma-btn-modal-cancel',
				label: gettext('Cancel'),
				handler: function handler() {
					_this15.hide();

					setTimeout(function () {
						_this15.destroy();
					}, 1000);
				}
			}, {
				cls: 'btn-primary btn-loud sma-js-notify-ok',
				id: 'sma-btn-modal-ok',
				label: options.ok || gettext('OK'),
				handler: $.proxy(function () {
					var _this16 = this;

					var okButton = this.modalFooter.find('.sma-js-notify-ok');
					if (okButton.hasClass('disabled')) {
						return;
					}
					var value = this.modalBody.find('input[name="modal-prompt-input"]').val();
					callback(value);
					this.hide();

					setTimeout(function () {
						_this16.destroy();
					}, 1000);
				}, _this15)
			}]
		});

		_this15.element = promptPartial({
			description: description,
			value: options.default_value,
			maxLength: options.maxLength,
			max_length_text: gettext('characters maximum'),
			title: title
		});
		_this15.setElement(_this15.element);

		_this15.render();
		_this15.show();
		return _this15;
	}

	return Prompt;
}(Modal);

var CheckboxModal = function (_Modal7) {
	_inherits(CheckboxModal, _Modal7);

	_createClass(CheckboxModal, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-checkbox sma-automation-popup-modal';
		}
	}]);

	function CheckboxModal(title, description, checkboxText, callback) {
		var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

		_classCallCheck(this, CheckboxModal);

		var _this17 = _possibleConstructorReturn(this, (CheckboxModal.__proto__ || Object.getPrototypeOf(CheckboxModal)).call(this));

		var okLabel = gettext('OK');
		var buttonClass = 'btn-primary';

		if (options.isDelete) {
			okLabel = gettext('DELETE');
			buttonClass = 'btn-danger';
		}

		if (options.okLabel) {
			okLabel = options.okLabel;
		}

		if (options.buttonClass) {
			buttonClass = options.buttonClass;
		}

		_this17.handleOptions({
			title: title,
			destroyOnClose: true,
			onShow: options.onShow,
			buttons: [{
				cls: 'btn-default btn-loud',
				label: gettext('Cancel'),
				handler: function handler() {
					_this17.hide();

					setTimeout(function () {
						_this17.destroy();
					}, 1000);
				}
			}, {
				cls: 'sma-js-modal-ok btn-loud ' + buttonClass,
				label: okLabel,
				handler: $.proxy(function () {
					var _this18 = this;

					var value = this.modalBody.find('.sma-js-modal-checkbox').is(':checked');
					callback(value);
					this.hide();

					setTimeout(function () {
						_this18.destroy();
					}, 1000);
				}, _this17)
			}]
		});

		_this17.element = checkboxPartial({
			description: description,
			checkboxText: checkboxText
		});

		_this17.setElement(_this17.element);

		_this17.render();

		if (options.contingent) {
			$('.sma-js-modal-ok').prop('disabled', true);
			$('.sma-js-modal-checkbox').change(function () {
				if (_this17.modalBody.find('.sma-js-modal-checkbox').is(':checked')) {
					$('.sma-js-modal-ok').prop('disabled', false);
				} else {
					$('.sma-js-modal-ok').prop('disabled', true);
				}
			});
		}

		_this17.show();
		return _this17;
	}

	return CheckboxModal;
}(Modal);

var Notify = function (_Modal8) {
	_inherits(Notify, _Modal8);

	_createClass(Notify, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
		}
	}]);

	function Notify(title, description, okText, callback) {
		_classCallCheck(this, Notify);

		var _this19 = _possibleConstructorReturn(this, (Notify.__proto__ || Object.getPrototypeOf(Notify)).call(this));

		_this19.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-default btn-loud',
				label: okText,
				handler: function handler(value) {
					callback(value);
					_this19.hide();

					setTimeout(function () {
						_this19.destroy();
					}, 1000);
				}
			}]
		});

		_this19.element = $('<div class="sma-modal-desc"></div>').html(description);

		_this19.setElement(_this19.element[0]);

		_this19.render();
		_this19.modalClose.hide();

		_this19.show();
		return _this19;
	}

	return Notify;
}(Modal);

var LargeNotify = function (_Notify) {
	_inherits(LargeNotify, _Notify);

	function LargeNotify() {
		_classCallCheck(this, LargeNotify);

		return _possibleConstructorReturn(this, (LargeNotify.__proto__ || Object.getPrototypeOf(LargeNotify)).apply(this, arguments));
	}

	_createClass(LargeNotify, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-confirm sma-modal-lg sma-automation-popup-modal';
		}
	}]);

	return LargeNotify;
}(Notify);

var Confirm = function (_Modal9) {
	_inherits(Confirm, _Modal9);

	_createClass(Confirm, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
		}
	}]);

	function Confirm(title, description, callback, options) {
		_classCallCheck(this, Confirm);

		var _this21 = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this));

		options = options || {};

		_this21.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: options.no_class || 'btn-secondary',
				id: 'sma-btn-modal-no',
				label: options.no || gettext('No'),
				handler: function handler() {
					if (options.noCallback) {
						options.noCallback();
					}

					_this21.hide();

					setTimeout(function () {
						_this21.destroy();
					}, 1000);
				}
			}, {
				cls: options.yes_class || 'btn-primary',
				id: 'sma-btn-modal-yes',
				label: options.yes || gettext('Yes'),
				handler: function handler(value) {
					callback(value);
					_this21.hide();

					setTimeout(function () {
						_this21.destroy();
					}, 1000);
				}
			}]
		});

		_this21.element = $('<div class="sma-modal-desc"></div>').html(description);

		_this21.setElement(_this21.element[0]);

		_this21.render();
		_this21.show();
		return _this21;
	}

	return Confirm;
}(Modal);

var DeleteStatus = function (_Modal10) {
	_inherits(DeleteStatus, _Modal10);

	_createClass(DeleteStatus, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
		}
	}]);

	function DeleteStatus(title, description, replacement, statuses, callback, options) {
		_classCallCheck(this, DeleteStatus);

		var _this22 = _possibleConstructorReturn(this, (DeleteStatus.__proto__ || Object.getPrototypeOf(DeleteStatus)).call(this));

		options = options || {};

		_this22.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-default',
				label: options.no || gettext('No'),
				handler: function handler() {
					_this22.hide();

					setTimeout(function () {
						_this22.destroy();
					}, 1000);
				}
			}, {
				cls: 'btn-primary',
				label: options.yes || gettext('Yes'),
				handler: $.proxy(function (modal) {
					var value = modal.modalBody.find('select[name="new-status"]').val();
					callback(value);
					modal.hide();

					setTimeout(function () {
						modal.destroy();
					}, 1000);
				})
			}]
		});
		_this22.element = deleteStatusPartial({
			description: description, replacement: replacement, statuses: statuses
		});

		_this22.setElement(_this22.element);

		_this22.render();
		_this22.show();
		return _this22;
	}

	return DeleteStatus;
}(Modal);

module.exports = {
	Confirm: Confirm,
	Modal: Modal,
	MultiModal: MultiModal,
	Content: Content,
	ContentModal: ContentModal,
	AjaxFormModal: AjaxFormModal,
	AjaxURLModal: AjaxURLModal,
	AjaxFormContent: AjaxFormContent,
	TemplateModal: TemplateModal,
	URLModal: URLModal,
	Prompt: Prompt,
	Notify: Notify,
	LargeNotify: LargeNotify,
	DeleteStatus: DeleteStatus,
	CheckboxModal: CheckboxModal
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(79)(module)))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(919);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(26)):"function"==typeof define&&define.amd?define(["react","react-dom"],t):"object"==typeof exports?exports.wds=t(require("react"),require("react-dom")):e.wds=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,(function(e,t){return function(e){var t={};function a(n){if(t[n])return t[n].exports;var l=t[n]={i:n,l:!1,exports:{}};return e[n].call(l.exports,l,l.exports,a),l.l=!0,l.exports}return a.m=e,a.c=t,a.d=function(e,t,n){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(a.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var l in e)a.d(n,l,function(t){return e[t]}.bind(null,l));return n},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=96)}([function(e,t,a){e.exports=a(55)()},function(t,a){t.exports=e},function(e,t){e.exports=function(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}},function(e,t,a){var n;!function(){"use strict";var a={}.hasOwnProperty;function l(){for(var e=[],t=0;t<arguments.length;t++){var n=arguments[t];if(n){var o=typeof n;if("string"===o||"number"===o)e.push(n);else if(Array.isArray(n)&&n.length){var r=l.apply(null,n);r&&e.push(r)}else if("object"===o)for(var i in n)a.call(n,i)&&n[i]&&e.push(i)}}return e.join(" ")}e.exports?(l.default=l,e.exports=l):void 0===(n=function(){return l}.apply(t,[]))||(e.exports=n)}()},function(e,t,a){var n=a(57);e.exports=function(e,t){if(null==e)return{};var a,l,o=n(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(l=0;l<r.length;l++)a=r[l],t.indexOf(a)>=0||Object.prototype.propertyIsEnumerable.call(e,a)&&(o[a]=e[a])}return o}},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t){function a(e,t){for(var a=0;a<t.length;a++){var n=t[a];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}e.exports=function(e,t,n){return t&&a(e.prototype,t),n&&a(e,n),e}},function(e,t,a){var n=a(53),l=a(3);e.exports=function(e,t){return!t||"object"!==n(t)&&"function"!=typeof t?l(e):t}},function(e,t){function a(t){return e.exports=a=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},a(t)}e.exports=a},function(e,t,a){var n=a(54);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&n(e,t)}},function(e,t,a){var n=a(78),l=a(79);e.exports=function(e,t,a){var o=t&&a||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var r=(e=e||{}).random||(e.rng||n)();if(r[6]=15&r[6]|64,r[8]=63&r[8]|128,t)for(var i=0;i<16;++i)t[o+i]=r[i];return t||l(r)}},function(e,t,a){var n,l;"undefined"!=typeof self&&self,e.exports=(n=a(1),l=a(17),function(e){var t={};function a(n){if(t[n])return t[n].exports;var l=t[n]={i:n,l:!1,exports:{}};return e[n].call(l.exports,l,l.exports,a),l.l=!0,l.exports}return a.m=e,a.c=t,a.d=function(e,t,n){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(a.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var l in e)a.d(n,l,function(t){return e[t]}.bind(null,l));return n},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=12)}([function(e,t){e.exports=n},function(e,t,a){e.exports=a(7)()},function(e,t,a){var n=a(6);e.exports=function(e,t){if(null==e)return{};var a,l,o=n(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(l=0;l<r.length;l++)a=r[l],t.indexOf(a)>=0||Object.prototype.propertyIsEnumerable.call(e,a)&&(o[a]=e[a])}return o}},,function(e,t){e.exports=l},,function(e,t){e.exports=function(e,t){if(null==e)return{};var a,n,l={},o=Object.keys(e);for(n=0;n<o.length;n++)a=o[n],t.indexOf(a)>=0||(l[a]=e[a]);return l}},function(e,t,a){"use strict";var n=a(8);function l(){}function o(){}o.resetWarningCache=l,e.exports=function(){function e(e,t,a,l,o,r){if(r!==n){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:o,resetWarningCache:l};return a.PropTypes=a,a}},function(e,t,a){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){"use strict";a.r(t);var n=a(2),l=a.n(n),o=a(0),r=a.n(o),i=a(1),d=a.n(i);function u(){return(u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var n in a)Object.prototype.hasOwnProperty.call(a,n)&&(e[n]=a[n])}return e}).apply(this,arguments)}function s(e,t){if(null==e)return{};var a,n,l={},o=Object.keys(e);for(n=0;n<o.length;n++)a=o[n],t.indexOf(a)>=0||(l[a]=e[a]);return l}function c(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t}function p(e,t){return e.replace(new RegExp("(^|\\s)"+t+"(?:\\s|$)","g"),"$1").replace(/\s+/g," ").replace(/^\s*|\s*$/g,"")}var m=a(4),f=a.n(m),h=r.a.createContext(null),v="unmounted",y="exited",g="entering",b="entered",w=function(e){function t(t,a){var n;n=e.call(this,t,a)||this;var l,o=a&&!a.isMounting?t.enter:t.appear;return n.appearStatus=null,t.in?o?(l=y,n.appearStatus=g):l=b:l=t.unmountOnExit||t.mountOnEnter?v:y,n.state={status:l},n.nextCallback=null,n}c(t,e),t.getDerivedStateFromProps=function(e,t){return e.in&&t.status===v?{status:y}:null};var a=t.prototype;return a.componentDidMount=function(){this.updateStatus(!0,this.appearStatus)},a.componentDidUpdate=function(e){var t=null;if(e!==this.props){var a=this.state.status;this.props.in?a!==g&&a!==b&&(t=g):a!==g&&a!==b||(t="exiting")}this.updateStatus(!1,t)},a.componentWillUnmount=function(){this.cancelNextCallback()},a.getTimeouts=function(){var e,t,a,n=this.props.timeout;return e=t=a=n,null!=n&&"number"!=typeof n&&(e=n.exit,t=n.enter,a=void 0!==n.appear?n.appear:t),{exit:e,enter:t,appear:a}},a.updateStatus=function(e,t){if(void 0===e&&(e=!1),null!==t){this.cancelNextCallback();var a=f.a.findDOMNode(this);t===g?this.performEnter(a,e):this.performExit(a)}else this.props.unmountOnExit&&this.state.status===y&&this.setState({status:v})},a.performEnter=function(e,t){var a=this,n=this.props.enter,l=this.context?this.context.isMounting:t,o=this.getTimeouts(),r=l?o.appear:o.enter;t||n?(this.props.onEnter(e,l),this.safeSetState({status:g},(function(){a.props.onEntering(e,l),a.onTransitionEnd(e,r,(function(){a.safeSetState({status:b},(function(){a.props.onEntered(e,l)}))}))}))):this.safeSetState({status:b},(function(){a.props.onEntered(e)}))},a.performExit=function(e){var t=this,a=this.props.exit,n=this.getTimeouts();a?(this.props.onExit(e),this.safeSetState({status:"exiting"},(function(){t.props.onExiting(e),t.onTransitionEnd(e,n.exit,(function(){t.safeSetState({status:y},(function(){t.props.onExited(e)}))}))}))):this.safeSetState({status:y},(function(){t.props.onExited(e)}))},a.cancelNextCallback=function(){null!==this.nextCallback&&(this.nextCallback.cancel(),this.nextCallback=null)},a.safeSetState=function(e,t){t=this.setNextCallback(t),this.setState(e,t)},a.setNextCallback=function(e){var t=this,a=!0;return this.nextCallback=function(n){a&&(a=!1,t.nextCallback=null,e(n))},this.nextCallback.cancel=function(){a=!1},this.nextCallback},a.onTransitionEnd=function(e,t,a){this.setNextCallback(a);var n=null==t&&!this.props.addEndListener;e&&!n?(this.props.addEndListener&&this.props.addEndListener(e,this.nextCallback),null!=t&&setTimeout(this.nextCallback,t)):setTimeout(this.nextCallback,0)},a.render=function(){var e=this.state.status;if(e===v)return null;var t=this.props,a=t.children,n=s(t,["children"]);if(delete n.in,delete n.mountOnEnter,delete n.unmountOnExit,delete n.appear,delete n.enter,delete n.exit,delete n.timeout,delete n.addEndListener,delete n.onEnter,delete n.onEntering,delete n.onEntered,delete n.onExit,delete n.onExiting,delete n.onExited,"function"==typeof a)return r.a.createElement(h.Provider,{value:null},a(e,n));var l=r.a.Children.only(a);return r.a.createElement(h.Provider,{value:null},r.a.cloneElement(l,n))},t}(r.a.Component);function _(){}w.contextType=h,w.propTypes={},w.defaultProps={in:!1,mountOnEnter:!1,unmountOnExit:!1,appear:!1,enter:!0,exit:!0,onEnter:_,onEntering:_,onEntered:_,onExit:_,onExiting:_,onExited:_},w.UNMOUNTED=0,w.EXITED=1,w.ENTERING=2,w.ENTERED=3,w.EXITING=4;var x=w,q=function(e,t){return e&&t&&t.split(" ").forEach((function(t){return n=t,void((a=e).classList?a.classList.remove(n):"string"==typeof a.className?a.className=p(a.className,n):a.setAttribute("class",p(a.className&&a.className.baseVal||"",n)));var a,n}))},N=function(e){function t(){for(var t,a=arguments.length,n=new Array(a),l=0;l<a;l++)n[l]=arguments[l];return(t=e.call.apply(e,[this].concat(n))||this).appliedClasses={appear:{},enter:{},exit:{}},t.onEnter=function(e,a){t.removeClasses(e,"exit"),t.addClass(e,a?"appear":"enter","base"),t.props.onEnter&&t.props.onEnter(e,a)},t.onEntering=function(e,a){var n=a?"appear":"enter";t.addClass(e,n,"active"),t.props.onEntering&&t.props.onEntering(e,a)},t.onEntered=function(e,a){var n=a?"appear":"enter";t.removeClasses(e,n),t.addClass(e,n,"done"),t.props.onEntered&&t.props.onEntered(e,a)},t.onExit=function(e){t.removeClasses(e,"appear"),t.removeClasses(e,"enter"),t.addClass(e,"exit","base"),t.props.onExit&&t.props.onExit(e)},t.onExiting=function(e){t.addClass(e,"exit","active"),t.props.onExiting&&t.props.onExiting(e)},t.onExited=function(e){t.removeClasses(e,"exit"),t.addClass(e,"exit","done"),t.props.onExited&&t.props.onExited(e)},t.getClassNames=function(e){var a=t.props.classNames,n="string"==typeof a,l=n?(n&&a?a+"-":"")+e:a[e];return{baseClassName:l,activeClassName:n?l+"-active":a[e+"Active"],doneClassName:n?l+"-done":a[e+"Done"]}},t}c(t,e);var a=t.prototype;return a.addClass=function(e,t,a){var n=this.getClassNames(t)[a+"ClassName"];"appear"===t&&"done"===a&&(n+=" "+this.getClassNames("enter").doneClassName),"active"===a&&e&&e.scrollTop,this.appliedClasses[t][a]=n,function(e,t){e&&t&&t.split(" ").forEach((function(t){return n=t,void((a=e).classList?a.classList.add(n):function(e,t){return e.classList?!!t&&e.classList.contains(t):-1!==(" "+(e.className.baseVal||e.className)+" ").indexOf(" "+t+" ")}(a,n)||("string"==typeof a.className?a.className=a.className+" "+n:a.setAttribute("class",(a.className&&a.className.baseVal||"")+" "+n)));var a,n}))}(e,n)},a.removeClasses=function(e,t){var a=this.appliedClasses[t],n=a.base,l=a.active,o=a.done;this.appliedClasses[t]={},n&&q(e,n),l&&q(e,l),o&&q(e,o)},a.render=function(){var e=this.props,t=(e.classNames,s(e,["classNames"]));return r.a.createElement(x,u({},t,{onEnter:this.onEnter,onEntered:this.onEntered,onEntering:this.onEntering,onExit:this.onExit,onExiting:this.onExiting,onExited:this.onExited}))},t}(r.a.Component);N.defaultProps={classNames:""},N.propTypes={};var C=N,E=["slow","normal","fast"],V=(a(9),function(e){var t=e.children,a=e.timeout,n=e.direction,o=e.speed,i=e.distance,d=l()(e,["children","timeout","direction","speed","distance"]);return"fast"===o?a=150:"slow"===o&&(a=350),r.a.createElement(C,Object.assign({classNames:"wds-slide--".concat(n," wds-slide--speed-").concat(o," wds-slide--distance-").concat(i," wds-slide-"),timeout:{enter:a,exit:a},unmountOnExit:!0},d),t)});V.displayName="Slide",V.propTypes={children:d.a.node.isRequired,direction:d.a.oneOf(["up","right","down","left"]),timeout:d.a.number,speed:d.a.oneOf(E),distance:d.a.oneOf(["normal","near","far"])},V.defaultProps={direction:"up",speed:"normal",distance:"normal",timeout:200},V.__docgenInfo={description:"",methods:[],displayName:"Slide",props:{direction:{defaultValue:{value:"'up'",computed:!1},type:{name:"enum",computed:!0,value:"motionDirections"},required:!1,description:""},speed:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionSpeeds"},required:!1,description:""},distance:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionDistances"},required:!1,description:""},timeout:{defaultValue:{value:"200",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var k=V,O=(a(10),function(e){var t=e.children,a=e.timeout,n=e.speed,o=l()(e,["children","timeout","speed"]);return"fast"===n?a=150:"slow"===n&&(a=350),r.a.createElement(C,Object.assign({classNames:"wds-fade--".concat(n," wds-fade-"),timeout:{enter:a,exit:a},unmountOnExit:!0},o),t)});O.displayName="Fade",O.propTypes={children:d.a.node.isRequired,timeout:d.a.number,speed:d.a.oneOf(E)},O.defaultProps={timeout:250,speed:"normal"},O.__docgenInfo={description:"",methods:[],displayName:"Fade",props:{timeout:{defaultValue:{value:"250",computed:!1},type:{name:"number"},required:!1,description:""},speed:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionSpeeds"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var P=O,T=(a(11),function(e){var t=e.children,a=e.timeout,n=l()(e,["children","timeout"]);return r.a.createElement(C,Object.assign({classNames:"wds-zoom-",timeout:{enter:a,exit:a},unmountOnExit:!0},n),t)});T.displayName="Zoom",T.propTypes={children:d.a.node.isRequired,timeout:d.a.number},T.defaultProps={timeout:250},T.__docgenInfo={description:"",methods:[],displayName:"Zoom",props:{timeout:{defaultValue:{value:"250",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var S=T;a.d(t,"Slide",(function(){return k})),a.d(t,"Fade",(function(){return P})),a.d(t,"Zoom",(function(){return S}))}]))},function(e,t,a){var n=a(75),l=a(76),o=a(77);e.exports=function(e,t){return n(e)||l(e,t)||o()}},function(e){e.exports=JSON.parse('{"font-file":{"assets--font-version":"2","assets--font-path":"/fonts/National2Web","assets--font-name":"\'National 2\'"},"icon-font-file":{"assets--icon-version":"4","assets--icon-path":"/icons/Mateo","assets--icon-name":"Mateo"},"brand-color":{"color--sabaeus":"#00BF6F","color--midnight":"#05467E","color--link":"#007FAA","color--arctic":"#2DCCD3","color--concord":"#671E75","color--raspberry":"#AC145A","color--bengal":"#F05B24","color--bumblebee":"#F9BE00","color--black":"#000000","color--charcoal":"#333E48","color--slate":"#6B787F","color--stone":"#9DA5AA","color--flint":"#D0D2D3","color--pebble":"#EDEEEE","color--canvas":"#F7F8FA","color--white":"#FFFFFF"},"data-vis-color":{"color--data-midnight":"#507CB6","color--data-sabaeus":"#00BF6F","color--data-arctic":"#6BC8CD","color--data-bumblebee":"#F9BE00","color--data-concord":"#7D5E90","color--data-cherry":"#DB4D5C","color--data-slate":"#768086","color--data-raspberry":"#D25F90","color--data-gold":"#A38364","color--data-bengal":"#FF8B4F"},"semantic-color":{"color--primary":"#00BF6F","color--success":"#00BF6F","color--info":"#2DCCD3","color--warning":"#F05B24","color--upgrade":"#F9BE00","color--secondary":"#6B787F","color--muted":"#D0D2D3"},"type-color":{"color--type-dark":"#333E48","color--type-on-muted":"#333E48","color--type-on-upgrade":"#333E48","color--type-on-info":"#333E48","color--type-dark-muted":"#6B787F","color--type-light-muted":"#D0D2D3","color--type-light":"#FFFFFF","color--type-on-primary":"#FFFFFF","color--type-on-secondary":"#FFFFFF","color--type-on-success":"#FFFFFF","color--type-on-warning":"#FFFFFF","color--type-on-link":"#FFFFFF","color--type-on-black":"#FFFFFF","color--type-on-charcoal":"#FFFFFF","color--type-on-stone":"#FFFFFF","color--type-on-flint":"#333E48","color--type-on-pebble":"#333E48","color--type-on-canvas":"#333E48","color--type-on-white":"#333E48","color--type-on-midnight":"#FFFFFF","color--type-on-sabaeus":"#FFFFFF","color--type-on-arctic":"#333E48","color--type-on-bumblebee":"#333E48","color--type-on-concord":"#FFFFFF","color--type-on-cherry":"#FFFFFF","color--type-on-slate":"#FFFFFF","color--type-on-raspberry":"#FFFFFF","color--type-on-gold":"#FFFFFF","color--type-on-bengal":"#FFFFFF","color--type-link":"#007FAA"},"bg-color":{"color--bg-dark":"#333E48","color--bg-overlay":"rgba(107, 120, 127, .86)","color--bg":"#F7F8FA","color--bg-accent":"#EDEEEE","color--bg-light":"#FFFFFF"},"border-color":{"color--border-active":"#00BF6F","color--border-hover":"#9DA5AA","color--border":"#D0D2D3","color--border-muted":"#EDEEEE"},"border":{"border":"1px solid #D0D2D3","border--hover":"1px solid #9DA5AA","border--active":"1px solid #00BF6F","border--muted":"1px solid #EDEEEE"},"space":{"space--0":"0","space--1":"4px","space--2":"8px","space--3":"12px","space--4":"16px","space--5":"24px","space--6":"32px","space--7":"64px","space--8":"96px","space--9":"128px"},"border-radius":{"r--0":"0","r--sm":"2px","r--md":"24px","r--lg":"50%"},"elevation":{"shadow--none":"none","shadow--sky":"0 2px 4px 0 rgba(0, 0, 0, 0.14)","shadow--space":"0 2px 8px 0 rgba(0,0,0,0.14)"},"z-index":{"z--none":"0","z--sky":"999","z--space":"9999"},"font-size":{"fs--hero-1":"50px","fs--hero-2":"40px","fs--page-title":"34px","fs--section-title":"26px","fs--card-title":"16px","fs--body":"15px","fs--body-sm":"13px"},"font-weight":{"fw":{"Light":"300","Regular":"400","Medium":"500"},"fw--light":"300","fw--regular":"400","fw--medium":"500"},"font-family":{"ff--base":"\'National 2\', \'Helvetica Neue\', Helvetica, Arial, \'Hiragino Sans\', \'Hiragino Kaku Gothic Pro\', \'游ゴシック\', \'游ゴシック体\', YuGothic, \'Yu Gothic\', \'ＭＳ ゴシック\', \'MS Gothic\', sans-serif","ff--icon":"Mateo"},"icon-size":{"icon--sm":"13px","icon--md":"16px","icon--lg":"26px","icon--xl":"34px"},"motion":{"motion-curve--enter":"cubic-bezier(0, 0, 0, 1)","motion-curve--exit":"cubic-bezier(1, 0, 1, 1)","motion-curve--ease":"cubic-bezier(.2, 0, .1, 1)","motion-curve--ease-reverse":"cubic-bezier(.9, 0, .8, 1)","motion-curve--bounce-start":"cubic-bezier(0, 0, .1, 1)","motion-curve--bounce-end":"cubic-bezier(.2, 0, 0, 1)"},"breakpoints":{"breakpoints":{"xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px"},"bp--xs":"0","bp--sm":"576px","bp--md":"768px","bp--lg":"992px","bp--xl":"1200px"},"grid":{"grid-cols":"12","grid-order-elements":"12","grid-gutter--xs":"16px","grid-gutter--sm":"24px","grid-gutter--md":"24px","grid-gutter--lg":"24px","grid-gutter--xl":"24px","grid-bleed--xs":"16px","grid-bleed--sm":"32px","grid-bleed--md":"32px","grid-bleed--lg":"32px","grid-bleed--xl":"32px","grid-max-width--xs":"none","grid-max-width--sm":"576px","grid-max-width--md":"768px","grid-max-width--lg":"992px","grid-max-width--xl":"1400px"},"button":{"button__height--sm":"30px","button__height--md":"40px","button__height--lg":"50px","button__font-size--sm":"13px","button__font-size--md":"15px","button__font-size--lg":"15px","button__padding--sm":"12px","button__padding--md":"24px","button__padding--lg":"32px + 4px","button__border-radius":"2px","button__box-shadow":"none"},"alert":{"alert__box-shadow":"none","alert__bg-color":"#333E48","alert__type-color":"#FFFFFF","alert__padding--y":"16px","alert__link-color":"#FFFFFF"},"avatar":{"avatar__border":"2px solid #FFFFFF","avatar__border-radius--default":"50%","avatar__border-radius--square":"0","avatar__size--sm":"24px","avatar__size--md":"32px","avatar__size--lg":"64px","avatar__size--xl":"96px"},"banner":{"banner__border-radius":"2px","banner__bg-color":"#FFFFFF","banner__type-color":"#333E48","banner__mark-width":"8px","banner__border-size":"1px"},"coachmark":{"coachmark__bg-color":"#2DCCD3"},"table":{"table__th-type-color":"#333E48","table__th-bg-color":"transparent","table__th-divider-line-color":"transparent","table__td-type-color":"#333E48","table__td-bg-color":"transparent","table__cell-min-height":"50px","table__cell-padding":"16px 24px","table__font-size":"15px"},"input":{"input__height--sm":"30px","input__height--md":"40px","input__height--lg":"50px","input__font-size":"15px","input__padding--sm":"8px","input__padding--md":"12px","input__padding--lg":"16px","input__border-radius":"2px"},"input-group":{"input-group__height--sm":"30px","input-group__height--md":"40px","input-group__height--lg":"50px","input-group__border-radius":"2px","input-group__icon-color":"#333E48"},"textarea":{"textarea__font-size":"15px","textarea__padding--sm":"4px 8px 4px","textarea__padding--md":"8px 12px 8px","textarea__padding--lg":"12px 16px 12px","textarea__border-radius":"2px"},"select":{"select__height--sm":"30px","select__height--md":"40px","select__height--lg":"50px","select__padding--sm":"8px","select__padding--md":"12px","select__padding--lg":"16px","select__border-radius":"2px","select__icon-color":"#333E48","select__font-size":"15px"},"multiselect":{"multiselect__border-radius":"2px"},"list":{"list__addon-icon-color":"#333E48","list__affordance-icon-color":"#6B787F","list__label-font-size":"13px","list__item-height":"52px","list__mark-width":"4px"},"card":{"card__border-radius":"2px","card__box-shadow":"none","card__border":"1px solid #EDEEEE","card__padding":"24px"},"badge":{"badge__border-radius":"24px","badge__font-size--sm":"13px","badge__font-size--md":"13px","badge__font-size--lg":"15px","badge__height--sm":"22px","badge__height--md":"26px","badge__height--lg":"30px","badge__padding-x":"1em"},"slider":{"slider__handle-bg-color":"#333E48","slider__track-bg-color":"#D0D2D3","slider__fill-bg-color":"#00BF6F","slider__border-radius":"24px","slider__height":"16px"},"switch":{"switch__thumb-bg-color--on":"#00BF6F","switch__track-bg-color--on":"#333E48","switch__thumb-bg-color--off":"#FFFFFF","switch__thumb-border--off":"1px solid #D0D2D3","switch__track-bg-color--off":"#D0D2D3","switch__border-radius":"24px","switch__height":"16px","switch__width":"40px"},"checkbox":{"checkbox__bg-color--on":"#00BF6F","checkbox__icon-color--on":"#FFFFFF"},"radio":{"radio__bg-color--on":"#00BF6F","radio__icon-color--on":"#FFFFFF"},"modal":{"modal__border-radius":"0","modal__head-bg-color":"#FFFFFF","modal__head-type-color":"#333E48","modal__body-bg-color":"#EDEEEE","modal__body-type-color":"#333E48","modal__foot-bg-color":"#FFFFFF","modal__foot-type-color":"#333E48","modal__border":"1px solid #333E48","modal__box-shadow":"none"},"pane":{"pane__padding":"24px","pane__bg-color":"#EDEEEE"},"popout":{"popout__width--sm":"275px","popout__width--md":"360px","popout__width--lg":"445px","popout__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","popout__pip-size":"12px","popout__border-radius":"2px","popout__border":"none","popout__body-font-size":"13px"},"tab":{"tab__border-radius":"none","tab__indicator-height":"3px","tab__indicator-color":"#00BF6F","tab__type-color":"#6B787F","tab__font-size":"13px","tab__font-weight":"500","tab__padding-y":"12px","tab__padding-x":" 2px"},"progress-bar":{"progress-bar__border-radius":"none","progress-bar__height--sm":"4px","progress-bar__height--md":"8px","progress-bar__height--lg":"16px","progress-bar__fill-color":"#00BF6F","progress-bar__track-color":"#D0D2D3"},"menu":{"menu__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","menu__max-width":"300px","menu__min-width":"175px","menu__max-height":"325px"},"progress-spinner":{"progress-spinner__fill-color":"#00BF6F","progress-spinner__track-color":"#D0D2D3"},"toast":{"toast__padding":"24px","toast__bg-color":"#333E48","toast__type-color":"#FFFFFF","toast__border-radius":"2px","toast__width":"350px","toast__title-font-size":"16px","toast__body-type-size":"13px","toast__link-color":"#FFFFFF","toast__box-shadow":"none"},"tooltip":{"tooltip__bg-color":"#333E48","tooltip__type-color":"#FFFFFF","tooltip__border-radius":"2px","tooltip__pip-size":"12px","tooltip__font-size":"13px","tooltip__padding":"12px 16px","tooltip__font-weight":"400","tooltip__box-shadow":"none"},"form-group":{"form-group__space-between":"8px"},"sheet":{"sheet__width--sm":"320px","sheet__width--md":"50%","sheet__width--lg":"75%"}}')},,,function(e,a){e.exports=t},function(e,t,a){},function(e,t,a){},function(e,t,a){"use strict";e.exports=function(e,t,a,n,l,o,r,i){if(!e){var d;if(void 0===t)d=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[a,n,l,o,r,i],s=0;(d=new Error(t.replace(/%s/g,(function(){return u[s++]})))).name="Invariant Violation"}throw d.framesToPop=1,d}}},,function(e,t,a){},function(e,t,a){},,,function(e,t,a){},function(e,t,a){},function(e,t,a){var n=a(69),l=a(70),o=a(71);e.exports=function(e){return n(e)||l(e)||o()}},,,function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){(function(t){var a=1/0,n="[object Symbol]",l=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,o=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,r="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",i="["+r+"]",d="[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",u="\\d+",s="[\\u2700-\\u27bf]",c="[a-z\\xdf-\\xf6\\xf8-\\xff]",p="[^\\ud800-\\udfff"+r+u+"\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",m="(?:\\ud83c[\\udde6-\\uddff]){2}",f="[\\ud800-\\udbff][\\udc00-\\udfff]",h="[A-Z\\xc0-\\xd6\\xd8-\\xde]",v="(?:"+c+"|"+p+")",y="(?:"+h+"|"+p+")",g="(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?",b="[\\ufe0e\\ufe0f]?"+g+("(?:\\u200d(?:"+["[^\\ud800-\\udfff]",m,f].join("|")+")[\\ufe0e\\ufe0f]?"+g+")*"),w="(?:"+[s,m,f].join("|")+")"+b,_=RegExp("['’]","g"),x=RegExp(d,"g"),q=RegExp([h+"?"+c+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[i,h,"$"].join("|")+")",y+"+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[i,h+v,"$"].join("|")+")",h+"?"+v+"+(?:['’](?:d|ll|m|re|s|t|ve))?",h+"+(?:['’](?:D|LL|M|RE|S|T|VE))?",u,w].join("|"),"g"),N=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,C="object"==typeof t&&t&&t.Object===Object&&t,E="object"==typeof self&&self&&self.Object===Object&&self,V=C||E||Function("return this")();var k,O=(k={"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"ss"},function(e){return null==k?void 0:k[e]});var P=Object.prototype.toString,T=V.Symbol,S=T?T.prototype:void 0,F=S?S.toString:void 0;function I(e){if("string"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&P.call(e)==n}(e))return F?F.call(e):"";var t=e+"";return"0"==t&&1/e==-a?"-0":t}function M(e){return null==e?"":I(e)}var R,z=(R=function(e,t,a){return e+(a?"-":"")+t.toLowerCase()},function(e){return function(e,t,a,n){var l=-1,o=e?e.length:0;for(n&&o&&(a=e[++l]);++l<o;)a=t(a,e[l],l,e);return a}(function(e,t,a){return e=M(e),void 0===(t=a?void 0:t)?function(e){return N.test(e)}(e)?function(e){return e.match(q)||[]}(e):function(e){return e.match(l)||[]}(e):e.match(t)||[]}(function(e){return(e=M(e))&&e.replace(o,O).replace(x,"")}(e).replace(_,"")),R,"")});e.exports=z}).call(this,a(64))},function(e,t,a){var n=a(92),l=function(e){var t="",a=Object.keys(e);return a.forEach((function(l,o){var r=e[l];(function(e){return/[height|width]$/.test(e)})(l=n(l))&&"number"==typeof r&&(r+="px"),t+=!0===r?l:!1===r?"not "+l:"("+l+": "+r+")",o<a.length-1&&(t+=" and ")})),t};e.exports=function(e){var t="";return"string"==typeof e?e:e instanceof Array?(e.forEach((function(a,n){t+=l(a),n<e.length-1&&(t+=", ")})),t):l(e)}},,,,,,,,,,function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t){function a(t){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=a=function(e){return typeof e}:e.exports=a=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a(t)}e.exports=a},function(e,t){function a(t,n){return e.exports=a=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},a(t,n)}e.exports=a},function(e,t,a){"use strict";var n=a(56);function l(){}function o(){}o.resetWarningCache=l,e.exports=function(){function e(e,t,a,l,o,r){if(r!==n){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:o,resetWarningCache:l};return a.PropTypes=a,a}},function(e,t,a){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t){e.exports=function(e,t){if(null==e)return{};var a,n,l={},o=Object.keys(e);for(n=0;n<o.length;n++)a=o[n],t.indexOf(a)>=0||(l[a]=e[a]);return l}},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t){var a;a=function(){return this}();try{a=a||new Function("return this")()}catch(e){"object"==typeof window&&(a=window)}e.exports=a},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t){e.exports=function(e){if(Array.isArray(e)){for(var t=0,a=new Array(e.length);t<e.length;t++)a[t]=e[t];return a}}},function(e,t){e.exports=function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t){e.exports=function(e){if(Array.isArray(e))return e}},function(e,t){e.exports=function(e,t){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){var a=[],n=!0,l=!1,o=void 0;try{for(var r,i=e[Symbol.iterator]();!(n=(r=i.next()).done)&&(a.push(r.value),!t||a.length!==t);n=!0);}catch(e){l=!0,o=e}finally{try{n||null==i.return||i.return()}finally{if(l)throw o}}return a}}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},function(e,t){var a="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(a){var n=new Uint8Array(16);e.exports=function(){return a(n),n}}else{var l=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),l[t]=e>>>((3&t)<<3)&255;return l}}},function(e,t){for(var a=[],n=0;n<256;++n)a[n]=(n+256).toString(16).substr(1);e.exports=function(e,t){var n=t||0,l=a;return[l[e[n++]],l[e[n++]],l[e[n++]],l[e[n++]],"-",l[e[n++]],l[e[n++]],"-",l[e[n++]],l[e[n++]],"-",l[e[n++]],l[e[n++]],"-",l[e[n++]],l[e[n++]],l[e[n++]],l[e[n++]],l[e[n++]],l[e[n++]]].join("")}},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t){e.exports=function(e){return e.replace(/[A-Z]/g,(function(e){return"-"+e.toLowerCase()})).toLowerCase()}},function(e,t,a){},function(e,t,a){},function(e,t,a){},function(e,t,a){"use strict";a.r(t);a(50),a(51),a(52);var n=a(6),l=a.n(n),o=a(7),r=a.n(o),i=a(8),d=a.n(i),u=a(9),s=a.n(u),c=a(3),p=a.n(c),m=a(10),f=a.n(m),h=a(2),v=a.n(h),y=a(1),g=a.n(y),b=a(0),w=a.n(b),_=a(5),x=a.n(_),q=a(4),N=a.n(q),C=["lg","md","sm","xl"],E=function(e){var t=e.children,a=e.color,n=e.size,l=x()(e,["children","color","size"]),o=N()("wds-icon-svg",v()({},"wds-icon-svg--".concat(a),a),v()({},"wds-icon-svg--".concat(n),n));return g.a.createElement("svg",Object.assign({className:o,preserveAspectRatio:"xMidYMid meet"},l),t)};E.displayName="IconSVG",E.propTypes={children:w.a.node.isRequired,color:w.a.string,size:w.a.oneOf(C)},E.defaultProps={color:null,size:null},E.contextTypes={reactIconBase:w.a.shape(E.propTypes)},E.__docgenInfo={description:"",methods:[],displayName:"IconSVG",props:{color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}},context:{reactIconBase:{type:{name:"shape",value:"IconSVG.propTypes",computed:!0},required:!1}}};var V=E,k=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m14.04 11.77a.7467.7467 0 0 1 -.53-.22l-5.51-5.5095-5.51 5.51a.75.75 0 1 1 -1.06-1.0605l6.04-6.04a.75.75 0 0 1 .53-.22.7494.7494 0 0 1 .53.22l6.04 6.04a.75.75 0 0 1 -.53 1.28z"})))};k.displayName="IconChevronUp",k.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},k.defaultProps={title:"ChevronUp",color:null,size:null},k.__docgenInfo={description:"",methods:[],displayName:"IconChevronUp",props:{title:{defaultValue:{value:"'ChevronUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var O=k,P=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m8 11.77a.7494.7494 0 0 1 -.53-.22l-6.04-6.04a.75.75 0 1 1 1.0607-1.06l5.5093 5.5095 5.5088-5.51a.75.75 0 0 1 1.0612 1.0605l-6.0392 6.04a.75.75 0 0 1 -.5308.22z"})))};P.displayName="IconChevronDown",P.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},P.defaultProps={title:"ChevronDown",color:null,size:null},P.__docgenInfo={description:"",methods:[],displayName:"IconChevronDown",props:{title:{defaultValue:{value:"'ChevronDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var T=P,S=(a(32),function(e){var t=e.dense,a=e.interactive,n=e.noRules,l=e.transparent,o=e.children,r=e.role,i=e.id,d=e.className,u=x()(e,["dense","interactive","noRules","transparent","children","role","id","className"]),s=N()("wds-list",{"wds-list--no-rules":n},{"wds-list--interactive":a},{"wds-list--transparent":l},{"wds-list--dense":t},d),c=g.a.Children.map(o,(function(e,t){return g.a.isValidElement(e)&&g.a.cloneElement(e,{interactive:a,index:t})}));return g.a.createElement("ul",{className:s,role:r,id:i,"data-testid":u["data-testid"]},c)});S.displayName="List",S.propTypes={children:w.a.node.isRequired,dense:w.a.bool,id:w.a.string,interactive:w.a.bool,noRules:w.a.bool,role:w.a.string,className:w.a.string,transparent:w.a.bool,"data-testid":w.a.string},S.defaultProps={dense:!1,id:null,interactive:!1,noRules:!1,role:"",className:"",transparent:!1,"data-testid":void 0},S.__docgenInfo={description:"",methods:[],displayName:"List",props:{dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noRules:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},role:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var F=S;a(58);function I(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}var M=function(e){var t,a=e.children,n=e.hide,l=e.padding,o=e.transparent,r=e.id,i=e.role,d=x()(e,["children","hide","padding","transparent","id","role"]),u=function(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?I(Object(a),!0).forEach((function(t){v()(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):I(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}({},i&&{role:i},{},r&&{id:r});return g.a.createElement("div",Object.assign({className:N()("wds-pane",{"wds-pane--transparent":o},{"wds-pane--hide":n})},u,{"data-testid":d["data-testid"]}),(t=a,l?t=g.a.createElement("div",{className:"wds-pane__body"},a):t))};M.displayName="Pane",M.propTypes={children:w.a.node.isRequired,hide:w.a.bool,id:w.a.string,padding:w.a.bool,role:w.a.string,transparent:w.a.bool,"data-testid":w.a.string},M.defaultProps={hide:!1,id:null,padding:!1,role:null,transparent:!1,"data-testid":void 0},M.__docgenInfo={description:"",methods:[],displayName:"Pane",props:{hide:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},padding:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},role:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var R=M,z=(a(31),function(e,t,a,n){var l=n?"tabpanel":null,o={padding:!(e.type&&"List"===e.type.displayName),labelledBy:t,ariaHidden:!1,role:l};return g.a.createElement(R,o,e)});z.displayName="renderActivePane";var B=function(e){function t(e){var a;l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"handleOnClick",(function(e){var t=parseInt(e.split("-")[2],10),n=a.state.activeItems;a.props.multiple?n.indexOf(t)>=0?n=n.filter((function(e){return e!==t})):n.push(t):n=n[0]===t?[]:[t];a.setState({activeItems:n}),a.props.onChange&&a.props.onChange(n)})),v()(p()(a),"renderAccordionElement",(function(e,t,n,l){var o="accordion-body-".concat(t),r="accordion-title-".concat(t),i=z(e.props.children,r,o,l);return g.a.cloneElement(e,{expanded:n,key:r,collapsed:!n,children:e.props.title,id:r,ariaControls:o,expandedComponent:n?i:null,affordance:n?g.a.createElement(O,null):g.a.createElement(T,null),onClick:function(){return a.handleOnClick(r)},multiple:l})}));var n=[],o=a.props.children;return g.a.Children.forEach(o,(function(e,t){g.a.isValidElement(e)&&e.props.expanded&&(a.props.multiple?n.push(t):0===n.length&&n.push(t))})),a.state={activeItems:n},a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this,t=this.props,a=t.children,n=t.multiple,l=t.className,o=t.interactive,r=t.noRules,i=t.dense,d=t.transparent,u=t.id,s=[];return g.a.Children.forEach(a,(function(t,a){var l=e.state.activeItems.indexOf(a)>=0;g.a.isValidElement(t)&&("ListItem"===t.type.displayName?s.push(t):s.push(e.renderAccordionElement(t,a,l,n)))})),g.a.createElement(F,{role:n?"tablist":null,className:l,noRules:r,interactive:o,dense:i,transparent:d,id:u,"data-testid":this.props["data-testid"]},s)}}]),t}(y.Component);B.displayName="Accordion",B.propTypes={children:w.a.node.isRequired,multiple:w.a.bool,className:w.a.string,onChange:w.a.func,interactive:w.a.bool,id:w.a.string,dense:w.a.bool,transparent:w.a.bool,noRules:w.a.bool,"data-testid":w.a.string},B.defaultProps={multiple:!1,className:"",onChange:null,interactive:!1,id:null,dense:!1,transparent:!1,noRules:!1,"data-testid":void 0},B.__docgenInfo={description:"",methods:[{name:"handleOnClick",docblock:null,modifiers:[],params:[{name:"key",type:null}],returns:null},{name:"renderAccordionElement",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"expanded",type:null},{name:"multiple",type:null}],returns:null}],displayName:"Accordion",props:{multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noRules:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var j=B,D={info:"i",warning:"!",upgrade:"(",success:"3"},A=["lg","md","sm"],L=["bottom-right","bottom-left","top-right","top-left"],H=["top","bottom","right","left"],U=["xl"].concat(A),W=([].concat(A,["xl","xs"]),[].concat(A,["xl"])),G=[].concat(A,["xs"]),K=["success","warning"],J={DOWN:40,END:35,ESC:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,RIGHT:39,UP:38,ENTER:13,SPACE:32,BACKSPACE:8},Y=["sabaeus","midnight","link","arctic","concord","raspberry","bengal","bumblebee","black","charcoal","slate","stone","flint","pebble","canvas","white"],Z=["primary","secondary","muted","success","warning","upgrade","info"],$=["data-sabaeus","data-midnight","data-concord","data-arctic","data-bumblebee","data-bengal","data-raspberry","data-slate","data-gold","data-cherry"],X=[].concat($,Z,Y),Q=[].concat(Z),ee=["alt","link"].concat(Z),te=["primary","secondary","muted","success","warning","upgrade","info"],ae=["success","warning"],ne=["primary","upgrade","info","success","warning","secondary"],le=ne,oe=G,re={sm:"576px",md:"768px",lg:"992px",xl:"1200px"},ie=function(e){var t=e.color,a=e.addOn,n=e.addOnPlacement,l=e.addOnLeft,o=e.addOnRight,r=e.interactive,i=e.disabled,d=e.children,u=e.onClick,s=e.className,c=e.affordance,p=e.expandedComponent,m=e.marked,f=e.upgrade,h=e.id,y=e.index,b=e.innerRef,w=e.isNavigable,_=e.navigationTarget,q=e.isFocused,C=x()(e,["color","addOn","addOnPlacement","addOnLeft","addOnRight","interactive","disabled","children","onClick","className","affordance","expandedComponent","marked","upgrade","id","index","innerRef","isNavigable","navigationTarget","isFocused"]),E="section",V=N()("wds-list__row",s),k=N()("wds-list__item",v()({},"wds-list__item--marked-".concat(t),t),{"wds-list__item--marked":m},{"wds-list__item--disabled":i},{"wds-list__item--upgrade":f},{"wds-list__item--focused":q}),O=function(e){u&&u(e)},P=function(e){return g.a.createElement("div",{className:"wds-list__addon"},e)};w&&(E="a");var T,S=n;if(a&&!n&&(S="left"),n&&!a)throw new Error("You must supply an addOn component with an addonPlacement");return g.a.createElement("li",{className:V},g.a.createElement(E,Object.assign({className:k,onClick:O,onKeyPress:function(e){e.charCode!==J.ENTER&&e.charCode!==J.SPACE||O(e)},id:h,"data-index":y,ref:b},(T={},r&&(T.tabIndex=i?"-1":0,T.role="button"),w&&(T.href=_),T),C),"left"===S&&P(a),l&&P(l),g.a.createElement("span",{className:"wds-list__label"},d),"right"===S&&P(a),o&&P(o),c&&g.a.createElement("span",{className:"wds-list__affordance"},c)),p&&p)};ie.displayName="ListItem",ie.propTypes={addOn:w.a.node,addOnPlacement:w.a.oneOf(H),addOnLeft:w.a.node,addOnRight:w.a.node,affordance:w.a.node,children:w.a.node,className:w.a.string,disabled:w.a.bool,expandedComponent:w.a.node,id:w.a.string,interactive:w.a.bool,index:w.a.number,innerRef:w.a.func,onClick:w.a.func,marked:w.a.bool,color:w.a.oneOfType([w.a.oneOf(te),w.a.oneOf($)]),isNavigable:w.a.bool,navigationTarget:w.a.string,upgrade:w.a.bool,isFocused:w.a.bool,"data-testid":w.a.string},ie.defaultProps={addOn:null,addOnPlacement:null,addOnLeft:null,addOnRight:null,affordance:null,className:null,color:null,disabled:!1,expandedComponent:null,id:null,interactive:!1,index:null,innerRef:null,onClick:null,marked:!1,upgrade:!1,isNavigable:!1,children:null,navigationTarget:"javascript:void(0)",isFocused:!1,"data-testid":void 0},ie.__docgenInfo={description:"",methods:[],displayName:"ListItem",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},addOnLeft:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnRight:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},affordance:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},expandedComponent:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},index:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isNavigable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},navigationTarget:{defaultValue:{value:"'javascript:void(0)'",computed:!1},type:{name:"string"},required:!1,description:""},isFocused:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var de=ie,ue=function(e){var t=e.color,a=e.addOn,n=e.addOnPlacement,l=e.multiple,o=e.onClick,r=e.children,i=e.disabled,d=e.ariaControls,u=e.expandedComponent,s=e.affordance,c=e.marked,p=e.interactive,m=e.upgrade,f=x()(e,["color","addOn","addOnPlacement","multiple","onClick","children","disabled","ariaControls","expandedComponent","affordance","marked","interactive","upgrade"]),h=N()("wds-accordion__row",{"wds-accordion__row--collapsed":!u,"wds-accordion__row--expanded":u});return g.a.createElement(de,Object.assign({addOn:a,addOnPlacement:n,affordance:s,expandedComponent:u,color:t,className:h,onClick:o,disabled:i,marked:c,id:d,interactive:p,upgrade:m},{tabIndex:i?"-1":0,role:l?"tab":"button","aria-selected":!0===u,"aria-controls":d},{"data-testid":f["data-testid"]}),r)};ue.displayName="AccordionItem",ue.propTypes={affordance:w.a.node,addOn:w.a.node,addOnPlacement:w.a.oneOf(H),ariaControls:w.a.string,children:w.a.node.isRequired,color:w.a.string,disabled:w.a.bool,expandedComponent:w.a.node,marked:w.a.bool,multiple:w.a.bool,onClick:w.a.func,interactive:w.a.bool,upgrade:w.a.bool,"data-testid":w.a.string},ue.defaultProps={affordance:null,addOn:null,addOnPlacement:null,ariaControls:null,color:null,disabled:!1,expandedComponent:null,marked:!1,multiple:!1,onClick:null,interactive:!1,upgrade:!1,"data-testid":void 0},ue.__docgenInfo={description:"",methods:[],displayName:"AccordionItem",props:{affordance:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},ariaControls:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},expandedComponent:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var se=ue,ce=a(12),pe=function(e){var t=e.onClick;return g.a.createElement("div",{className:"wds-overlay wds-modal__overlay",onClick:t})};pe.displayName="Overlay",pe.propTypes={onClick:w.a.func},pe.defaultProps={onClick:null},pe.__docgenInfo={description:"",methods:[],displayName:"Overlay",props:{onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var me=pe,fe=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m9.0605 8 4.1395-4.1394a.75.75 0 0 0 -1.06-1.0606l-4.14 4.1394-4.14-4.1394a.75.75 0 0 0 -1.06 1.0606l4.1395 4.1394-4.1395 4.1394a.75.75 0 1 0 1.06 1.0606l4.14-4.1395 4.14 4.1395a.75.75 0 0 0 1.06-1.0606z"})))};fe.displayName="IconX",fe.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},fe.defaultProps={title:"X",color:null,size:null},fe.__docgenInfo={description:"",methods:[],displayName:"IconX",props:{title:{defaultValue:{value:"'X'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var he=fe,ve=(a(61),function(e){var t=e.onClick,a=e.variant,n=e.ariaLabel,l=e.className,o=x()(e,["onClick","variant","ariaLabel","className"]),r=N()("wds-close","wds-close--".concat(a),l);return g.a.createElement("button",{onClick:t,"aria-label":n,className:r,type:"button","data-testid":o["data-testid"]},g.a.createElement("span",{className:"wds-close__icon"},g.a.createElement(he,null)),g.a.createElement("span",{className:"wds-close__text"},n))});ve.displayName="CloseButton",ve.propTypes={className:w.a.string,onClick:w.a.func.isRequired,variant:w.a.oneOf(["dark","light"]),ariaLabel:w.a.string,"data-testid":w.a.string},ve.defaultProps={ariaLabel:"Close",className:"",variant:"dark","data-testid":void 0},ve.__docgenInfo={description:"",methods:[],displayName:"CloseButton",props:{ariaLabel:{defaultValue:{value:"'Close'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"'dark'",computed:!1},type:{name:"enum",value:[{value:"'dark'",computed:!1},{value:"'light'",computed:!1}]},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},onClick:{type:{name:"func"},required:!0,description:""}}};var ye=ve,ge=(a(60),function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"getSlideDirection",(function(){var e=a.props.placement;return e&&"right"!==e?"bottom"===e?"up":"right":"left"})),v()(p()(a),"closeButton",(function(){return a.props.closeButton&&g.a.createElement(ye,{className:a.props.closeButtonClass||null,onClick:a.handleClick,ariaLabel:a.props.ariaLabel})})),v()(p()(a),"handleClick",(function(){var e=a.props.onClose;e&&e()})),a}return f()(t,e),r()(t,[{key:"componentDidMount",value:function(){this.sheet&&this.sheet.focus()}},{key:"render",value:function(){var e=this,t=this.props,a=t.className,n=t.size,l=t.show,o=t.placement,r=t.blocking,i=t.children,d=t.offsetTop,u=N()("wds-sheet",a,"wds-sheet--".concat(n),"wds-sheet--".concat(o),{"wds-sheet--no-overlay":!r}),s={top:"".concat(d,"px")};return g.a.createElement(y.Fragment,null,r&&g.a.createElement(ce.Fade,{in:l,speed:"fast"},g.a.createElement(me,{onClick:this.handleClick})),g.a.createElement(ce.Slide,{in:l,direction:this.getSlideDirection()},g.a.createElement("div",{className:u,"data-testid":this.props["data-testid"]},g.a.createElement("div",{role:"dialog",className:"wds-sheet__sheet",ref:function(t){e.sheet=t},style:"bottom"==o?null:s,tabIndex:"-1"},this.closeButton(),i))))}}]),t}(g.a.Component));ge.displayName="Sheet",ge.defaultProps={className:"",closeButton:!1,closeButtonClass:"",onClose:null,show:!1,size:"sm",placement:"right",ariaLabel:"Close Modal",blocking:!0,offsetTop:0,"data-testid":void 0},ge.propTypes={children:w.a.node.isRequired,className:w.a.string,closeButton:w.a.bool,closeButtonClass:w.a.string,onClose:w.a.func,show:w.a.bool,size:w.a.oneOf(A),placement:w.a.oneOf(["bottom","right","left"]),ariaLabel:w.a.node,blocking:w.a.bool,offsetTop:w.a.number,"data-testid":w.a.string},ge.__docgenInfo={description:"",methods:[{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"closeButton",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Sheet",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},closeButton:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},closeButtonClass:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},placement:{defaultValue:{value:"'right'",computed:!1},type:{name:"enum",computed:!0,value:"sheetPlacements"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Modal'",computed:!1},type:{name:"node"},required:!1,description:""},blocking:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},offsetTop:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var be=ge,we=(a(63),function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"handleClick",(function(){var e=a.props.onClose;e&&e()})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this.props,t=e.color,a=e.children,n=e.size,l=e.dismissible,o=e.show,r=e.icon,i=N()("wds-badge","wds-badge--".concat(t),"wds-badge--".concat(n),{"wds-badge--dismissible":l}),d="light";return"muted"!=t&&"upgrade"!=t&&"info"!=t||(d="dark"),g.a.createElement(ce.Fade,{in:o},g.a.createElement("span",{className:i,"data-testid":this.props["data-testid"]},r,a,l&&g.a.createElement(ye,{variant:d,onClick:this.handleClick})))}}]),t}(g.a.Component));we.displayName="Badge",we.defaultProps={size:"md",color:"primary",dismissible:!1,show:!0,onClose:null,icon:null,"data-testid":void 0},we.propTypes={children:w.a.node.isRequired,size:w.a.oneOf(A),color:w.a.oneOf(X),dismissible:w.a.bool,show:w.a.bool,onClose:w.a.func,icon:w.a.node,"data-testid":w.a.string},we.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Badge",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",computed:!0,value:"badgeColors"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},icon:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var _e=we,xe=(a(62),[1,2,3,4,5,6,7,8,9]),qe=function(e){var t=e.component,a=e.children,n=e.className,l=e.containerRef,o=e.m,r=e.mx,i=e.my,d=e.mt,u=e.mb,s=e.ml,c=e.mr,p=e.p,m=e.px,f=e.py,h=e.pt,y=e.pb,b=e.pl,w=e.pr,_=e.flex,q=e.flexInline,C=e.flexDirection,E=e.flexJustify,V=e.flexAlign,k=e.flexWrap,O=e.flexItemGrow,P=x()(e,["component","children","className","containerRef","m","mx","my","mt","mb","ml","mr","p","px","py","pt","pb","pl","pr","flex","flexInline","flexDirection","flexJustify","flexAlign","flexWrap","flexItemGrow"]),T=N()("wds-container",v()({},"wds-m-".concat(o),o),v()({},"wds-m-x-".concat(r),r),v()({},"wds-m-y-".concat(i),i),v()({},"wds-m-t-".concat(d),d),v()({},"wds-m-b-".concat(u),u),v()({},"wds-m-l-".concat(s),s),v()({},"wds-m-r-".concat(c),c),v()({},"wds-p-".concat(p),p),v()({},"wds-p-x-".concat(m),m),v()({},"wds-p-y-".concat(f),f),v()({},"wds-p-t-".concat(h),h),v()({},"wds-p-b-".concat(y),y),v()({},"wds-p-l-".concat(b),b),v()({},"wds-p-r-".concat(w),w),{"wds-flex":_||q},{"wds-flex--inline":q},{"wds-flex--x":C&&"row"==C},{"wds-flex--y":C&&"column"==C},{"wds-flex--x-start":E&&"start"==E},{"wds-flex--x-end":E&&"end"==E},{"wds-flex--x-center":E&&"center"==E},{"wds-flex--x-between":E&&"between"==E},{"wds-flex--x-around":E&&"around"==E},{"wds-flex--y-start":V&&"start"==V},{"wds-flex--y-end":V&&"end"==V},{"wds-flex--y-center":V&&"center"==V},{"wds-flex--stretch":V&&"stretch"==V},{"wds-flex--wrap":k},{"wds-flex--nowrap":!1===k},{"wds-flex__item--grow":O},n),S=t;return g.a.createElement(S,Object.assign({className:T,ref:l},P),a)};qe.displayName="Container",qe.propTypes={component:w.a.string,children:w.a.node.isRequired,className:w.a.string,containerRef:w.a.func,m:w.a.oneOf(xe),mx:w.a.oneOf(xe),my:w.a.oneOf(xe),mt:w.a.oneOf(xe),mb:w.a.oneOf(xe),ml:w.a.oneOf(xe),mr:w.a.oneOf(xe),p:w.a.oneOf(xe),px:w.a.oneOf(xe),py:w.a.oneOf(xe),pt:w.a.oneOf(xe),pb:w.a.oneOf(xe),pl:w.a.oneOf(xe),pr:w.a.oneOf(xe),flex:w.a.bool,flexInline:w.a.bool,flexDirection:w.a.oneOf(["row","column"]),flexJustify:w.a.oneOf(["start","end","center","between","around"]),flexAlign:w.a.oneOf(["start","end","center","stretch"]),flexWrap:w.a.bool,flexItemGrow:w.a.bool},qe.defaultProps={component:"div",className:null,containerRef:null,m:null,mx:null,my:null,mt:null,mb:null,ml:null,mr:null,p:null,px:null,py:null,pt:null,pb:null,pl:null,pr:null,flex:null,flexInline:null,flexDirection:null,flexJustify:null,flexAlign:null,flexWrap:null,flexItemGrow:null},qe.__docgenInfo={description:"",methods:[],displayName:"Container",props:{component:{defaultValue:{value:"'div'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},containerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},m:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mx:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},my:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mt:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mb:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},ml:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mr:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},p:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},px:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},py:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pt:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pb:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pl:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pr:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},flex:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexInline:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexDirection:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'row'",computed:!1},{value:"'column'",computed:!1}]},required:!1,description:""},flexJustify:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'start'",computed:!1},{value:"'end'",computed:!1},{value:"'center'",computed:!1},{value:"'between'",computed:!1},{value:"'around'",computed:!1}]},required:!1,description:""},flexAlign:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'start'",computed:!1},{value:"'end'",computed:!1},{value:"'center'",computed:!1},{value:"'stretch'",computed:!1}]},required:!1,description:""},flexWrap:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexItemGrow:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ne=qe,Ce=a(39),Ee=a.n(Ce),Ve=(a(65),function(e){var t=e.align,a=e.children,n=e.className,l=e.color,o=e.component,r=e.variant,i=x()(e,["align","children","className","color","component","variant"]),d=N()(v()({},"wds-type--".concat(t),t),v()({},"wds-type--".concat(l),l),v()({},"wds-type--".concat(Ee()(r)),r),n),u=o;return g.a.createElement(u,Object.assign({},i,{className:d}),a)});Ve.displayName="Typography",Ve.propTypes={align:w.a.oneOf(["center","justify","left","right"]),children:w.a.node.isRequired,className:w.a.string,color:w.a.oneOf(["light","dark","primary","success","upgrade","info","warning","link","light-muted","dark-muted"]),component:w.a.string,variant:w.a.oneOf(["hero1","hero2","pageTitle","sectionTitle","cardTitle","body","bodySm","link"])},Ve.defaultProps={align:null,className:null,color:null,component:"div",variant:"body"},Ve.__docgenInfo={description:"",methods:[],displayName:"Typography",props:{align:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"alignment"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"typeColors"},required:!1,description:""},component:{defaultValue:{value:"'div'",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"'body'",computed:!1},type:{name:"enum",computed:!0,value:"typographyVariants"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ke=Ve,Oe=(a(59),function(e){var t=e.children,a=e.className,n=e.show,l=e.rightAddOn,o=e.numSelected,r=e.labelSelectedItems,i=x()(e,["children","className","show","rightAddOn","numSelected","labelSelectedItems"]),d=N()("wds-actionsheet",a);return g.a.createElement("div",Object.assign({className:d},i),g.a.createElement(be,{show:n,placement:"bottom",blocking:!1},g.a.createElement(Ne,{flex:!0,flexJustify:"between",flexAlign:"center",p:6},g.a.createElement(Ne,{flexInline:!0,flexAlign:"center",flexJustify:"between"},g.a.createElement(_e,null,o),g.a.createElement(Ne,{pl:2},g.a.createElement(ke,{variant:"body"},r))),g.a.createElement(Ne,{flexItemGrow:!0},g.a.createElement("div",{className:"wds-type--center"},t)),g.a.createElement("div",{className:"wds-type--right"},l))))});Oe.displayName="ActionSheet",Oe.propTypes={children:w.a.node.isRequired,className:w.a.string,show:w.a.bool,numSelected:w.a.number,labelSelectedItems:w.a.node,rightAddOn:w.a.node},Oe.defaultProps={className:"",show:!1,numSelected:0,labelSelectedItems:"Selected items",rightAddOn:null},Oe.__docgenInfo={description:"",methods:[],displayName:"ActionSheet",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numSelected:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},labelSelectedItems:{defaultValue:{value:"'Selected items'",computed:!1},type:{name:"node"},required:!1,description:""},rightAddOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Pe=Oe,Te=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.959 7.959 0 0 0 -7.95-7.95zm-.707 3.1956a.75.75 0 1 1 1.5 0v1.0264a.75.75 0 0 1 -1.5 0zm2.8428 8.7266-1.5626 1.5615a.751.751 0 0 1 -1.28-.53v-4.2464l-.2812.2813a.75.75 0 0 1 -1.0608-1.0606l1.5615-1.5615a.7511.7511 0 0 1 1.28.53v4.2469l.2822-.282a.75.75 0 1 1 1.0605 1.0605z"})))};Te.displayName="IconInfo",Te.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},Te.defaultProps={title:"Info",color:null,size:null},Te.__docgenInfo={description:"",methods:[],displayName:"IconInfo",props:{title:{defaultValue:{value:"'Info'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Se=Te,Fe=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m15.7051 12.9691-6.5513-11.2378a1.3042 1.3042 0 0 0 -2.3076 0l-6.5513 11.2387a1.3386 1.3386 0 0 0 -.0649 1.3638 1.3379 1.3379 0 0 0 1.2109.6313h13.1177a1.2682 1.2682 0 0 0 1.1465-1.9961zm-8.4551-7.5152a.75.75 0 0 1 1.5 0v4.3023a.75.75 0 1 1 -1.5 0zm.75 7.765a.875.875 0 1 1 .875-.875.875.875 0 0 1 -.875.875z"})))};Fe.displayName="IconWarning",Fe.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},Fe.defaultProps={title:"Warning",color:null,size:null},Fe.__docgenInfo={description:"",methods:[],displayName:"IconWarning",props:{title:{defaultValue:{value:"'Warning'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ie=Fe,Me=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m6.4372 13.125a.7475.7475 0 0 1 -.53-.22l-5.6247-5.6242a.75.75 0 0 1 1.0605-1.0608l5.0942 5.0942 8.22-8.22a.75.75 0 0 1 1.0605 1.0605l-8.75 8.75a.7476.7476 0 0 1 -.5305.2203z"})))};Me.displayName="IconCheck",Me.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},Me.defaultProps={title:"Check",color:null,size:null},Me.__docgenInfo={description:"",methods:[],displayName:"IconCheck",props:{title:{defaultValue:{value:"'Check'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Re=Me,ze=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m13.7268 6.3958h-2.083v-2.75a3.6527 3.6527 0 0 0 -7.2876.0068v2.7432h-2.083a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4536a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75zm-7.8706-2.7437a2.16 2.16 0 0 1 4.2876-.0068v2.75h-4.2876zm7.1206 10.5972h-9.9536v-6.3535h9.9536z"}),g.a.createElement("path",{d:"m8 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};ze.displayName="IconLock",ze.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},ze.defaultProps={title:"Lock",color:null,size:null},ze.__docgenInfo={description:"",methods:[],displayName:"IconLock",props:{title:{defaultValue:{value:"'Lock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Be=ze,je=(a(66),function(e){var t;return"info"===e?t=Se:"warning"===e?t=Ie:"success"===e?t=Re:"upgrade"===e&&(t=Be),g.a.createElement("span",{className:"wds-alert__icon"},g.a.createElement(t,null))});je.displayName="alertIcon";var De=function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"handleClick",(function(){var e=a.props.onClose;e&&e()})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this,t=this.props,a=t.color,n=t.showIcon,l=t.children,o=t.actions,r=t.placement,i=t.show,d=t.dismissible,u="top"===r?"down":"up",s=N()("wds-alert","wds-alert--".concat(this.props.color),v()({},"wds-alert--".concat(this.props.placement),r));return g.a.createElement(ce.Slide,{in:i,direction:u,distance:"far"},g.a.createElement("div",{className:s,ref:function(t){e.alert=t},role:"alert","data-testid":this.props["data-testid"]},d&&g.a.createElement(ye,{onClick:this.handleClick,ariaLabel:this.props.ariaLabel,variant:"light"}),n&&je(a),g.a.createElement("p",{className:"wds-alert__label"},l),o?g.a.createElement("div",{className:"wds-alert__actions"},o):null))}}]),t}(g.a.Component);De.displayName="Alert",De.propTypes={children:w.a.node.isRequired,onClose:w.a.func,showIcon:w.a.bool,color:w.a.oneOf(Object.keys(D)),ariaLabel:w.a.node,actions:w.a.node,placement:w.a.string,show:w.a.bool,dismissible:w.a.bool,"data-testid":w.a.string},De.defaultProps={onClose:null,showIcon:!1,color:"info",ariaLabel:"Close Alert",actions:null,placement:null,show:!0,dismissible:!0,"data-testid":void 0},De.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Alert",props:{onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},showIcon:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"'info'",computed:!1},type:{name:"enum",computed:!0,value:"Object.keys(iconColors)"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Alert'",computed:!1},type:{name:"node"},required:!1,description:""},actions:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},placement:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dismissible:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ae=De,Le=(a(67),function(e){var t=e.children,a=e.size,n=e.square,l=e.color,o=x()(e,["children","size","square","color"]),r=N()("wds-avatar","wds-avatar--".concat(a),{"wds-avatar--square":n},v()({},"wds-avatar--".concat(l),l));return g.a.createElement("span",{className:r,"data-testid":o["data-testid"]},g.a.createElement("span",{className:"wds-avatar__body"},t))});Le.displayName="Avatar",Le.defaultProps={size:"md",square:!1,color:null,"data-testid":void 0},Le.propTypes={children:w.a.node.isRequired,color:w.a.oneOf(["primary","secondary","muted","upgrade","info","success","warning","dark","light"]),size:w.a.oneOf(U),square:w.a.bool,"data-testid":w.a.string},Le.__docgenInfo={description:"",methods:[],displayName:"Avatar",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"avatarSizes"},required:!1,description:""},square:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"componentColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var He=Le,Ue=(a(68),function(e){var t;return"info"===e?t=Se:"warning"===e?t=Ie:"success"===e?t=Re:"upgrade"===e&&(t=Be),g.a.createElement("span",{className:"wds-banner__icon"},g.a.createElement(t,null))});Ue.displayName="bannerIcon";var We=function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"state",{close:!1}),v()(p()(a),"getOuterButtonClassNames",(function(){return N()("wds-banner","wds-banner--".concat(a.props.color))})),v()(p()(a),"handleClose",(function(){a.setState({close:!0}),a.props.onClose&&a.props.onClose()})),v()(p()(a),"renderActions",(function(){if(a.props.actions)return g.a.createElement("div",{className:"wds-banner__actions"},a.props.actions)})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this.props,t=e.color,a=e.showIcon,n=e.children,l=e.dismissible,o=e.show;return g.a.createElement(ce.Slide,{in:!this.state.close&&o,direction:"down",distance:"far"},g.a.createElement("div",{className:this.getOuterButtonClassNames()},l&&g.a.createElement(ye,{onClick:this.handleClose,ariaLabel:this.props.ariaLabel}),a&&Ue(t),g.a.createElement("div",{className:"wds-banner__body"},n,this.renderActions())))}}]),t}(g.a.Component);We.displayName="Banner",We.propTypes={children:w.a.node.isRequired,dismissible:w.a.bool,onClose:w.a.func,showIcon:w.a.bool,color:w.a.oneOf(Object.keys(D)),ariaLabel:w.a.node,actions:w.a.node,show:w.a.bool},We.defaultProps={dismissible:!1,onClose:null,showIcon:!1,color:"info",ariaLabel:"Close Banner",actions:null,show:!0},We.__docgenInfo={description:"",methods:[{name:"getOuterButtonClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClose",docblock:null,modifiers:[],params:[],returns:null},{name:"renderActions",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Banner",props:{dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},showIcon:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"'info'",computed:!1},type:{name:"enum",computed:!0,value:"Object.keys(iconColors)"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Banner'",computed:!1},type:{name:"node"},required:!1,description:""},actions:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ge=We,Ke=a(28),Je=a.n(Ke),Ye=(a(72),function(e){var t=e.stretched,a=e.children,n=e.size,l=e.className,o=e.color,r=e.variant,i=e.buttonType,d=e.href,u=x()(e,["stretched","children","size","className","color","variant","buttonType","href"]),s=g.a.Children.count(a),c=g.a.Children.toArray(a)[0].type,p=g.a.Children.toArray(a)[s-1].type,m=1===s&&c&&c.displayName&&c.displayName.indexOf("Icon")>=0,f=s>1&&c&&c.displayName&&c.displayName.indexOf("Icon")>=0,h=s>1&&p&&p.displayName&&p.displayName.indexOf("Icon")>=0,v=u.target&&"_blank"===u.target&&!u.rel,y=N()("wds-button",{"wds-button--stretched":t},"wds-button--".concat(o),"wds-button--".concat(r),"wds-button--".concat(n),{"wds-button--icon-left":f},{"wds-button--icon-right":h},{"wds-button--icon-only":m},l),b="button",w=i;return d&&(b="a",w=null),v&&(u.rel="noopener noreferrer"),g.a.createElement(b,Object.assign({type:w,className:y,href:d},u),a)});Ye.displayName="Button",Ye.defaultProps={className:"",stretched:!1,size:"md",color:"primary",buttonType:"button",variant:"solid",href:null},Ye.propTypes={children:w.a.node.isRequired,className:w.a.string,size:w.a.oneOf(A),stretched:w.a.bool,color:w.a.oneOf([].concat(Je()(ee),Je()(Y))),variant:w.a.oneOf(["solid","ghost","text"]),buttonType:w.a.oneOf(["button","reset","submit"]),href:w.a.string},Ye.__docgenInfo={description:"",methods:[],displayName:"Button",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",value:[{value:"...buttonColors",computed:!0},{value:"...brandColors",computed:!0}]},required:!1,description:""},buttonType:{defaultValue:{value:"'button'",computed:!1},type:{name:"enum",computed:!0,value:"buttonTypes"},required:!1,description:""},variant:{defaultValue:{value:"'solid'",computed:!1},type:{name:"enum",computed:!0,value:"variants"},required:!1,description:""},href:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ze=Ye,$e=(a(73),function(e){var t=N()("wds-button-group",{"wds-button-group--radio":e.radio});return g.a.createElement("div",{className:t,"data-testid":e["data-testid"]},e.children)});$e.displayName="ButtonGroup",$e.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string,radio:w.a.bool},$e.defaultProps={"data-testid":void 0,radio:!1},$e.__docgenInfo={description:"",methods:[],displayName:"ButtonGroup",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},radio:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Xe=$e,Qe=(a(74),function(e){var t,a=e.addOn,n=e.children,l=e.noRule,o=e.className,r=e.padding,i=e.title,d=e.selected,u=e.interactive,s=x()(e,["addOn","children","noRule","className","padding","title","selected","interactive"]),c=N()({"wds-card":!0,"wds-card--interactive":u,"wds-card--selected":d},o),p=N()("wds-card__header",{"wds-card__header--no-rule":l}),m=function(){return g.a.createElement("div",{className:"wds-card__addon"},a)};return g.a.createElement("div",Object.assign({className:c},s),i?g.a.createElement("header",{className:p},i,a&&m()):null,(t=!i&&a&&m(),r?g.a.createElement("div",{className:"wds-card__body"},t,n):g.a.createElement(y.Fragment,null,t,n)))});Qe.displayName="Card",Qe.propTypes={addOn:w.a.node,children:w.a.node.isRequired,className:w.a.string,title:w.a.node,noRule:w.a.bool,padding:w.a.bool,interactive:w.a.bool,selected:w.a.bool},Qe.defaultProps={addOn:null,className:"",title:null,noRule:!1,padding:!0,interactive:!1,selected:!1},Qe.__docgenInfo={description:"",methods:[],displayName:"Card",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},title:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},noRule:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},padding:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},selected:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var et=Qe,tt=a(13),at=a.n(tt),nt=a(11),lt=a.n(nt);function ot(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}var rt=function(e){return null!=e},it=function(e,t){return function(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?ot(Object(a),!0).forEach((function(t){v()(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):ot(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}({},e,{},t)},dt=(a(80),function(e){var t=e.checked,a=e.className,n=e["data-testid"],l=e.defaultChecked,o=e.disabled,r=e.id,i=e.name,d=e.onBlur,u=e.onChange,s=e.label,c=e.indeterminate,p=e.innerRef,m=x()(e,["checked","className","data-testid","defaultChecked","disabled","id","name","onBlur","onChange","label","indeterminate","innerRef"]),f=Object(y.useState)(!!l),h=at()(f,2),v=h[0],b=h[1],w=Object(y.useState)(!1),_=at()(w,2),q=_[0],C=_[1],E=Object(y.useState)(c),V=at()(E,2),k=V[0],O=V[1];Object(y.useEffect)((function(){O(c)}),[c]);var P=it({isChecked:v},t&&{isChecked:t}).isChecked,T=r||lt()(),S=N()("wds-checkbox",{"wds-checkbox--indeterminate":k}),F=N()("wds-checkbox__native",a),I=N()("wds-checkbox__faux",{"wds-checkbox--checked":P,"wds-checkbox--focused":q});return g.a.createElement("span",{className:S},g.a.createElement("input",Object.assign({className:F,"aria-checked":P,checked:P,disabled:o,id:T,name:i,onBlur:function(e){C(!q),d&&d(e)},onFocus:function(){C(!q)},onChange:function(e){b(!P),e.persist(),u&&u(e)},tabIndex:o?-1:0,type:"checkbox",ref:p,"data-testid":n},m)),g.a.createElement("span",{className:I,"aria-hidden":"true"},g.a.createElement(Re,{color:"light"})),s&&g.a.createElement("span",{className:"wds-checkbox__label"},g.a.createElement("label",{htmlFor:T},g.a.createElement(ke,{variant:"body",component:"span"},s))))});dt.displayName="Checkbox",dt.propTypes={checked:w.a.bool,className:w.a.string,"data-testid":w.a.string,defaultChecked:w.a.bool,disabled:w.a.bool,id:w.a.string,label:w.a.node,name:w.a.string,onBlur:w.a.func,onChange:w.a.func,indeterminate:w.a.bool,innerRef:w.a.func},dt.defaultProps={checked:void 0,className:null,"data-testid":void 0,defaultChecked:!1,disabled:!1,id:null,label:null,name:null,onBlur:function(){},onChange:function(){},indeterminate:!1,innerRef:null},dt.__docgenInfo={description:"",methods:[],displayName:"Checkbox",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},indeterminate:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var ut=dt,st=(a(81),function(e){e.className;var t=e.size,a=x()(e,["className","size"]);return g.a.createElement("span",Object.assign({},a,{className:"wds-coachmark wds-coachmark--".concat(t)}))});st.displayName="Coachmark",st.propTypes={className:w.a.string,size:w.a.oneOf(["md","sm"])},st.defaultProps={className:null,size:"md"},st.__docgenInfo={description:"",methods:[],displayName:"Coachmark",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"coachmarkSizes"},required:!1,description:""}}};var ct=st,pt=(a(33),function(e){var t=e.children,a=e.inline,n=e.label,l=x()(e,["children","inline","label"]),o=N()("wds-form-group",{"wds-form-group--inline":a});return g.a.createElement("fieldset",{className:o,"data-testid":l["data-testid"]},n&&g.a.createElement("legend",{className:"wds-form-group__legend wds-label"},n),t)});pt.displayName="FormGroup",pt.propTypes={children:w.a.node.isRequired,inline:w.a.bool,label:w.a.node,"data-testid":w.a.string},pt.defaultProps={inline:!1,label:null,"data-testid":void 0},pt.__docgenInfo={description:"",methods:[],displayName:"FormGroup",props:{inline:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var mt=pt,ft=function(e){var t=e.children,a=e.className,n=x()(e,["children","className"]),l=N()("wds-form-group__field",a);return g.a.createElement("div",{className:l,"data-testid":n["data-testid"]},t)};ft.displayName="FormField",ft.propTypes={children:w.a.node.isRequired,className:w.a.string,"data-testid":w.a.string},ft.defaultProps={className:null,"data-testid":void 0},ft.__docgenInfo={description:"",methods:[],displayName:"FormField",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ht=ft,vt=(a(26),function(e){var t=e.children,a=e.noBleeds,n=e.noGutters,l=e.fluid,o=e.className,r=x()(e,["children","noBleeds","noGutters","fluid","className"]),i=N()("wds-grid",{"wds-grid--no-bleeds":a},{"wds-grid--no-gutters":n},{"wds-grid--fluid":l},o);return g.a.createElement("div",Object.assign({className:i},r),t)});vt.displayName="Grid",vt.propTypes={children:w.a.node.isRequired,noBleeds:w.a.bool,fluid:w.a.bool,noGutters:w.a.bool,className:w.a.string},vt.defaultProps={noBleeds:!1,fluid:!1,noGutters:!1,className:""},vt.__docgenInfo={description:"",methods:[],displayName:"Grid",props:{noBleeds:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},fluid:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noGutters:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var yt=vt,gt=function(e){var t=e.children,a=e.className,n=e.xsOrder,l=e.smOrder,o=e.mdOrder,r=e.lgOrder,i=e.xlOrder,d=x()(e,["children","className","xsOrder","smOrder","mdOrder","lgOrder","xlOrder"]),u=N()("wds-grid__row",a,v()({},"wds-grid__row--lg-order-".concat(r),r),v()({},"wds-grid__row--md-order-".concat(o),o),v()({},"wds-grid__row--sm-order-".concat(l),l),v()({},"wds-grid__row--xs-order-".concat(n),n),v()({},"wds-grid__row--xl-order-".concat(i),i));return g.a.createElement("div",Object.assign({className:u},d),t)};gt.displayName="Row",gt.propTypes={children:w.a.node.isRequired,className:w.a.string,xsOrder:w.a.number,smOrder:w.a.number,mdOrder:w.a.number,lgOrder:w.a.number,xlOrder:w.a.number},gt.defaultProps={className:null,xsOrder:null,smOrder:null,mdOrder:null,lgOrder:null,xlOrder:null},gt.__docgenInfo={description:"",methods:[],displayName:"Row",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},xsOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},smOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},mdOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lgOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xlOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var bt=gt,wt=function(e){var t=e.className,a=e.children,n=e.lg,l=e.md,o=e.sm,r=e.xs,i=e.xl,d=e.lgOrder,u=e.mdOrder,s=e.smOrder,c=e.xlOrder,p=e.xsOrder,m=x()(e,["className","children","lg","md","sm","xs","xl","lgOrder","mdOrder","smOrder","xlOrder","xsOrder"]),f=N()(t,"wds-grid__col",v()({},"wds-grid__col-lg-".concat(n),n),v()({},"wds-grid__col-md-".concat(l),l),v()({},"wds-grid__col-sm-".concat(o),o),v()({},"wds-grid__col-xl-".concat(i),i),v()({},"wds-grid__col-".concat(r),r),v()({},"wds-grid__col--lg-order-".concat(d),d),v()({},"wds-grid__col--md-order-".concat(u),u),v()({},"wds-grid__col--sm-order-".concat(s),s),v()({},"wds-grid__col--xl-order-".concat(c),c),v()({},"wds-grid__col--xs-order".concat(p),p));return g.a.createElement("div",Object.assign({className:f},m),a)};wt.displayName="Col",wt.propTypes={children:w.a.node.isRequired,className:w.a.string,xs:w.a.number,sm:w.a.number,md:w.a.number,lg:w.a.number,xl:w.a.number,xsOrder:w.a.number,smOrder:w.a.number,mdOrder:w.a.number,lgOrder:w.a.number,xlOrder:w.a.number},wt.defaultProps={className:"",xs:null,sm:null,md:null,lg:null,xl:null,xsOrder:null,smOrder:null,mdOrder:null,lgOrder:null,xlOrder:null},wt.__docgenInfo={description:"",methods:[],displayName:"Col",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},xs:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},sm:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},md:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lg:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xl:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xsOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},smOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},mdOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lgOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xlOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var _t=wt,xt=(a(82),function(e){var t=e.children,a=e.color,n=e.className,l=e.size,o=x()(e,["children","color","className","size"]),r=N()("wds-icon",v()({},"wds-type--".concat(a),a),v()({},"wds-icon--".concat(l),l),n);return g.a.createElement("span",{className:r,"aria-hidden":"true","data-testid":o["data-testid"]},t)});xt.displayName="Icon",xt.propTypes={children:w.a.string.isRequired,size:w.a.oneOf(W),color:w.a.string,className:w.a.string,"data-testid":w.a.string},xt.defaultProps={className:"",size:null,color:"","data-testid":void 0},xt.__docgenInfo={description:"",methods:[],displayName:"Icon",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},color:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"string"},required:!0,description:""}}};var qt=xt,Nt=(a(84),function(e){var t=e.children,a=e.className,n=e.htmlFor,l=e.muted,o=e.plain,r=N()("wds-label",{"wds-label--muted":l},{"wds-label--plain":o},a);return g.a.createElement("label",{className:r,htmlFor:n},t)});Nt.displayName="Label",Nt.propTypes={children:w.a.oneOfType([w.a.string,w.a.node]).isRequired,className:w.a.string,htmlFor:w.a.string.isRequired,muted:w.a.bool,plain:w.a.bool},Nt.defaultProps={className:null,muted:!1,plain:!1},Nt.__docgenInfo={description:"",methods:[],displayName:"Label",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},muted:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},plain:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"union",value:[{name:"string"},{name:"node"}]},required:!0,description:""},htmlFor:{type:{name:"string"},required:!0,description:""}}};var Ct=Nt,Et=(a(83),function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"handleBlur",(function(e){a.props.onBlur&&a.props.onBlur(e)})),v()(p()(a),"handleChange",(function(e){a.state.isControlled&&e.target.value!==a.state.value&&(e.persist(),a.setState({value:e.target.value},(function(){a.props.onChange&&a.props.onChange(e)})))})),v()(p()(a),"renderErrorMessage",(function(){if("warning"===a.props.color&&a.props.errorMessage){var e=N()("wds-type--caption","wds-m-t-2","wds-type--".concat(a.props.color));return g.a.createElement("div",{className:e},a.props.errorMessage)}if(a.props.color&&a.props.errorMessage)throw new Error("Having an errorMessage and a success theme is not allowed");return null})),v()(p()(a),"renderLabel",(function(){return a.props.label?g.a.createElement(Ct,{className:"",htmlFor:a.inputID},a.props.label):null})),a.state={isControlled:rt(e.value),value:e.value},a.inputID=e.id||lt()(),a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.value!==this.state.value&&this.setState({value:e.value})}},{key:"renderInput",value:function(){var e=this.props,t=e.className,a=e.defaultValue,n=e.disabled,l=(e.errorMessage,e.inputRef),o=e.inputSize,r=(e.label,e.name),i=(e.onBlur,e.onChange,e.size),d=e.stretched,u=e.color,s=(e.value,x()(e,["className","defaultValue","disabled","errorMessage","inputRef","inputSize","label","name","onBlur","onChange","size","stretched","color","value"])),c=N()("wds-input","wds-input--".concat(i),{"wds-input--stretched":d},v()({},"wds-input--".concat(u),u),t);return g.a.createElement("input",Object.assign({},s,{className:c,defaultValue:a,disabled:n,id:this.inputID,ref:l,name:r,onBlur:this.handleBlur,onChange:this.handleChange,value:this.state.value,size:o}))}},{key:"render",value:function(){return g.a.createElement(y.Fragment,null,this.renderLabel(),this.renderInput(),this.renderErrorMessage())}}]),t}(g.a.Component));Et.displayName="Input",Et.propTypes={className:w.a.string,defaultValue:w.a.node,disabled:w.a.bool,errorMessage:w.a.node,id:w.a.string,inputRef:w.a.func,inputSize:w.a.number,label:w.a.node,name:w.a.string,onBlur:w.a.func,onChange:w.a.func,size:w.a.oneOf(A),stretched:w.a.bool,color:w.a.oneOf(ae),value:w.a.node},Et.defaultProps={className:null,defaultValue:void 0,disabled:!1,errorMessage:null,id:null,inputRef:null,inputSize:null,label:null,name:null,onBlur:null,onChange:null,size:"md",stretched:!1,color:null,value:void 0},Et.__docgenInfo={description:"",methods:[{name:"handleBlur",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"renderErrorMessage",docblock:null,modifiers:[],params:[],returns:null},{name:"renderInput",docblock:null,modifiers:[],params:[],returns:null},{name:"renderLabel",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Input",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},defaultValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},errorMessage:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},inputRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},inputSize:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputColors"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""}}};var Vt=Et,kt=(a(34),function(e){var t=e.children,a=e.className,n=e.id,l=e.label,o=e.stretched,r=e.disabled,i=e.color,d=x()(e,["children","className","id","label","stretched","disabled","color"]),u=n||lt()(),s=N()("wds-input-group",{"wds-input-group--stretched":o},{"wds-input-group--disabled":r},v()({},"wds-input-group--".concat(i),i),a);return g.a.createElement(y.Fragment,null,l&&g.a.createElement(Ct,{htmlFor:u},l),g.a.createElement("div",{id:u,className:s,"data-testid":d["data-testid"]},t))});kt.displayName="InputGroup",kt.propTypes={children:w.a.node.isRequired,className:w.a.string,id:w.a.string,label:w.a.node,stretched:w.a.bool,disabled:w.a.bool,color:w.a.oneOf(K),"data-testid":w.a.string},kt.defaultProps={className:null,id:null,label:null,stretched:!1,disabled:!1,color:null,"data-testid":void 0},kt.__docgenInfo={description:"",methods:[],displayName:"InputGroup",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ot=kt,Pt=function(e){var t=e.children,a=x()(e,["children"]);return g.a.createElement("div",{className:"wds-input-group__addon","data-testid":a["data-testid"]},t)};Pt.displayName="InputGroupAddon",Pt.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Pt.defaultProps={"data-testid":void 0},Pt.__docgenInfo={description:"",methods:[],displayName:"InputGroupAddon",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Tt=Pt,St=(a(85),function(e){var t=e.children,a=e.className,n=e.color,l=x()(e,["children","className","color"]),o=N()("wds-link",{"wds-link--light":"light"===n},a);return g.a.createElement("a",Object.assign({},l,{className:o}),t)});St.displayName="Link",St.propTypes={children:w.a.node.isRequired,className:w.a.string,color:w.a.oneOf(["light","dark"])},St.defaultProps={className:null,color:"dark"},St.__docgenInfo={description:"",methods:[],displayName:"Link",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"'dark'",computed:!1},type:{name:"enum",value:[{value:"'light'",computed:!1},{value:"'dark'",computed:!1}]},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ft=St,It=a(17),Mt=a.n(It),Rt=a(14),zt=(a(27),function(e){return g.a.createElement("section",{className:"wds-menu__group","data-testid":e["data-testid"]},e.children)});zt.displayName="MenuGroup",zt.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},zt.defaultProps={"data-testid":void 0},zt.__docgenInfo={description:"",methods:[],displayName:"MenuGroup",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Bt=zt,jt="undefined"!=typeof window,Dt=function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"setInitialRefs",(function(e){a.itemRefs=[],a.focusableItems=a.getFocusableItems(e)})),v()(p()(a),"setFocusableItemRefs",(function(e){return function(t){e>-1&&t&&(a.itemRefs[e]=t)}})),v()(p()(a),"getFocusableItems",(function(e){var t=e.children,a=[];return g.a.Children.forEach(t,(function(e){return g.a.isValidElement(e)&&(e.type&&"MenuGroup"===e.type.displayName?g.a.Children.forEach(e.props.children,(function(e){e.props.disabled||a.push(e)})):e.props.disabled||a.push(e)),null})),a})),v()(p()(a),"getSlideDirection",(function(){var e=a.props.placement;return e&&e.indexOf("top")>=0?"up":"down"})),v()(p()(a),"getOuterClassNames",(function(){var e=a.props,t=e.noMaxHeight,n=e.stretched;return N()("wds-has-menu",{"wds-has-menu--stretched":n},{"wds-menu--no-max-height":t})})),v()(p()(a),"getMenuClassNames",(function(){var e=a.props.placement;return N()("wds-menu",v()({},"wds-menu--".concat(e),e))})),v()(p()(a),"handleScroll",(function(){a.state.show&&a.props.renderTo&&a.updatePosition()})),v()(p()(a),"handleAutoScroll",(function(e){if(e>-1&&a.itemRefs[e]){var t=a.itemRefs[e].offsetTop+a.itemRefs[e].offsetHeight,n=a.innerMenu.offsetHeight;a.innerMenu.scrollTop=t<=n?0:t-n}})),v()(p()(a),"handleOnKeyDown",(function(e){var t=a.props.menuTrigger,n=a.state,l=n.focusIndex,o=n.show,r=l;if(t.props.onKeyDown&&t.props.onKeyDown(e),o){switch(e.keyCode){case J.UP:r=l>0?l-1:a.focusableItems.length-1,e.preventDefault();break;case J.DOWN:r=l===a.focusableItems.length-1?0:l+1,e.preventDefault();break;case J.ESC:a.setState({show:!1})}a.handleAutoScroll(r),a.setState({focusIndex:r})}o||e.keyCode!==J.UP&&e.keyCode!==J.DOWN||(a.handleOnClick(e),e.preventDefault())})),v()(p()(a),"handleOnKeyPress",(function(e){var t=a.props.menuTrigger,n=a.state.focusIndex;(e.charCode===J.ENTER||e.charCode===J.SPACE&&"Button"!==t.type.displayName&&"Input"!==t.type.displayName)&&(n>-1?a.itemRefs[n].click():a.handleOnClick(e),e.preventDefault()),a.setState({focusIndex:-1})})),v()(p()(a),"handleAutoCloseBlur",(function(){setTimeout((function(){a.menu&&!a.menu.contains(document.activeElement)&&a.menuChange(!1)}),0)})),v()(p()(a),"handleMenuClose",(function(){a.props.autoClose&&a.menuChange(!1)})),v()(p()(a),"handleOnClick",(function(e){var t=a.state.show;a.menuChange(!t),e.stopPropagation()})),v()(p()(a),"menuChange",(function(e){a.setState({show:e}),a.props.onChange&&a.props.onChange({show:e})})),v()(p()(a),"updatePosition",(function(){var e=a.props.placement,t=a.state.show;if(a.menu&&t&&a.innerMenu.children&&a.innerMenu.children.length){var n,l,o=a.menu.getBoundingClientRect(),r=a.innerMenu.getBoundingClientRect();"top-left"===e?(n=o.top-r.height,l=o.left):"top-right"===e?(n=o.top-r.height,l=o.right-r.width):"bottom-left"===e?(n=o.bottom,l=o.left):(n=o.bottom,l=o.right-r.width),a.setState({menuStyle:{top:"".concat(n,"px"),left:"".concat(l,"px"),zIndex:Rt["z-index"]["z--space"]+1,position:"fixed",right:"auto",bottom:"auto"}})}})),v()(p()(a),"menuRef",(function(e){return a.menu=e})),v()(p()(a),"renderMenu",(function(){var e=a.props,t=e.renderTo,n=e.role,l=g.a.createElement(ce.Fade,{in:a.state.show,speed:"fast"},g.a.createElement("div",{className:a.getMenuClassNames(),style:a.state.menuStyle,role:n},g.a.createElement("div",{className:"wds-menu__body",ref:function(e){a.innerMenu=e}},a.renderList())));return t?Mt.a.createPortal(l,t):l})),v()(p()(a),"renderList",(function(){var e=a.props,t=e.children,n=e.dense,l=g.a.Children.map(t,(function(e,t){return g.a.isValidElement(e)&&e.type&&"MenuGroup"===e.type.displayName?g.a.createElement(Bt,{"data-testid":e.props["data-testid"]},g.a.createElement(F,Object.assign({interactive:!0,noRules:!0,dense:n},a.props),a.renderListItems(e.props.children,t,a.handleMenuClose))):null}));return l.length?l:g.a.createElement(F,Object.assign({interactive:!0,dense:a.props.dense},a.props),a.props.children&&a.renderListItems(t,0,a.handleMenuClose))})),v()(p()(a),"renderListItems",(function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2?arguments[2]:void 0,l=a.state.focusIndex;return g.a.Children.map(e,(function(e){var o=a.focusableItems.indexOf(e);return g.a.isValidElement(e)?g.a.cloneElement(e,{groupindex:t,isFocused:o>-1&&l===o,innerRef:a.setFocusableItemRefs(o),handleMenuClose:n}):null}))})),v()(p()(a),"renderTrigger",(function(){var e=a.props,t=e.menuTrigger,n=e.show,l=e.role;return g.a.cloneElement(t,{"aria-haspopup":l,"aria-expanded":a.state.show,"aria-owns":n?a.id:null,onClick:a.handleOnClick,onKeyDown:a.handleOnKeyDown,onKeyPress:a.handleOnKeyPress,tabIndex:0})})),a.state={show:e.show,focusIndex:-1,menuStyle:null},a.setInitialRefs(e),a}return f()(t,e),r()(t,[{key:"componentDidMount",value:function(){this.state.show&&this.props.renderTo&&this.updatePosition(),jt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.show!==this.state.show&&e.show!==this.props.show&&this.setState({show:e.show}),this.setInitialRefs(e)}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.props.renderTo&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){jt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll))}},{key:"render",value:function(){return g.a.createElement("span",{className:this.getOuterClassNames(),onBlur:this.props.autoClose?this.handleAutoCloseBlur:null,ref:this.menuRef},this.renderTrigger(),this.renderMenu())}}]),t}(y.Component);Dt.displayName="Menu",Dt.propTypes={autoClose:w.a.bool,children:w.a.node.isRequired,dense:w.a.bool,placement:w.a.oneOf(L),menuTrigger:w.a.node.isRequired,noMaxHeight:w.a.bool,onChange:w.a.func,show:w.a.bool,stretched:w.a.bool,"data-testid":w.a.string,renderTo:w.a.oneOfType([w.a.func,w.a.shape({current:w.a.elementType})]),role:w.a.string},Dt.defaultProps={autoClose:!0,dense:!1,placement:null,noMaxHeight:!1,onChange:null,stretched:!1,show:!1,"data-testid":void 0,renderTo:null,role:"menu"},Dt.__docgenInfo={description:"",methods:[{name:"setInitialRefs",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null},{name:"setFocusableItemRefs",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null},{name:"getFocusableItems",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"getOuterClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"getMenuClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"handleAutoScroll",docblock:null,modifiers:[],params:[{name:"focusIndex",type:null}],returns:null},{name:"handleOnKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleOnKeyPress",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleAutoCloseBlur",docblock:null,modifiers:[],params:[],returns:null},{name:"handleMenuClose",docblock:null,modifiers:[],params:[],returns:null},{name:"handleOnClick",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"menuChange",docblock:null,modifiers:[],params:[{name:"show",type:null}],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"menuRef",docblock:null,modifiers:[],params:[{name:"menu",type:null}],returns:null},{name:"renderMenu",docblock:null,modifiers:[],params:[],returns:null},{name:"renderList",docblock:null,modifiers:[],params:[],returns:null},{name:"renderListItems",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"groupindex",type:null},{name:"handleMenuClose",type:null}],returns:null},{name:"renderTrigger",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Menu",props:{autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"menuPlacements"},required:!1,description:""},noMaxHeight:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},role:{defaultValue:{value:"'menu'",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},menuTrigger:{type:{name:"node"},required:!0,description:""}}};var At=Dt,Lt=function(e){var t=e.addOn,a=e.addOnPlacement,n=e.color,l=e.onClick,o=e.children,r=e.disabled,i=e.marked,d=e.upgrade,u=e.groupindex,s=e.handleMenuClose,c=e.index,p=e.role,m=x()(e,["addOn","addOnPlacement","color","onClick","children","disabled","marked","upgrade","groupindex","handleMenuClose","index","role"]);return g.a.createElement(de,Object.assign({addOn:t,addOnPlacement:a,color:n,onClick:function(e){l&&l(e),s(),e.stopPropagation()},disabled:r,marked:i,upgrade:d,index:c,"data-group":u},m,{tabIndex:r?"-1":0,role:p}),o)};Lt.displayName="MenuItem",Lt.propTypes={addOn:w.a.node,addOnPlacement:w.a.string,children:w.a.node.isRequired,color:w.a.string,disabled:w.a.bool,groupindex:w.a.number,index:w.a.number,marked:w.a.bool,onClick:w.a.func,upgrade:w.a.bool,isNavigable:w.a.bool,navigationTarget:w.a.string,isFocused:w.a.bool,handleMenuClose:w.a.func,role:w.a.string},Lt.defaultProps={addOn:null,addOnPlacement:null,color:null,disabled:!1,groupindex:null,index:null,marked:!1,onClick:null,upgrade:!1,isNavigable:!1,navigationTarget:"javascript:void(0)",isFocused:!1,handleMenuClose:function(){},role:"menuitem"},Lt.__docgenInfo={description:"",methods:[],displayName:"MenuItem",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},groupindex:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},index:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isNavigable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},navigationTarget:{defaultValue:{value:"'javascript:void(0)'",computed:!1},type:{name:"string"},required:!1,description:""},isFocused:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},handleMenuClose:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},role:{defaultValue:{value:"'menuitem'",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ht=Lt,Ut=(a(22),function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"closeButton",(function(){var e=a.props,t=e.ariaLabel,n=e.closeButtonClass;return a.props.dismissible?g.a.createElement(ye,{onClick:a.handleClick,ariaLabel:t,className:n||null,"data-testid":a.props["data-testid"]?"".concat(a.props["data-testid"],"_CloseModal"):void 0}):null})),v()(p()(a),"handleClick",(function(){if(a.props.dismissible){var e=a.props.onClose;e&&e()}})),a}return f()(t,e),r()(t,[{key:"componentDidMount",value:function(){this.modal&&this.modal.focus()}},{key:"render",value:function(){var e=this,t=this.props,a=t.className,n=t.size,l=t.show,o=N()("wds-modal",a,"wds-modal--".concat(n));return g.a.createElement(y.Fragment,null,g.a.createElement(ce.Fade,{in:l},g.a.createElement(me,{onClick:this.handleClick})),g.a.createElement(ce.Slide,{in:l,direction:"down",distance:"near",speed:"fast"},g.a.createElement("div",{className:o,"data-testid":this.props["data-testid"]},g.a.createElement("div",{role:"dialog",className:"wds-modal__modal",ref:function(t){e.modal=t},tabIndex:"-1"},this.closeButton(),this.props.children))))}}]),t}(y.Component));Ut.displayName="Modal",Ut.defaultProps={className:"",closeButtonClass:"",dismissible:!0,onClose:null,show:!1,size:"sm",ariaLabel:"Close Modal","data-testid":void 0},Ut.propTypes={children:w.a.node.isRequired,className:w.a.string,closeButtonClass:w.a.string,dismissible:w.a.bool,onClose:w.a.func,show:w.a.bool,size:w.a.oneOf(A),ariaLabel:w.a.node,"data-testid":w.a.string},Ut.__docgenInfo={description:"",methods:[{name:"closeButton",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Modal",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},closeButtonClass:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},dismissible:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Modal'",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Wt=Ut,Gt=function(e){var t=e.children,a=e.padding,n=x()(e,["children","padding"]);return g.a.createElement("section",{className:"wds-modal__body","data-testid":n["data-testid"]},g.a.createElement(R,{padding:a,transparent:!0},t))};Gt.displayName="ModalBody",Gt.propTypes={children:w.a.node.isRequired,padding:w.a.bool,"data-testid":w.a.string},Gt.defaultProps={padding:!0,"data-testid":void 0},Gt.__docgenInfo={description:"",methods:[],displayName:"ModalBody",props:{padding:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Kt=Gt,Jt=function(e){return g.a.createElement("footer",{className:"wds-modal__foot","data-testid":e["data-testid"]},e.children)};Jt.displayName="ModalFooter",Jt.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Jt.defaultProps={"data-testid":void 0},Jt.__docgenInfo={description:"",methods:[],displayName:"ModalFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Yt=Jt,Zt=function(e){var t=e.addOn,a=e.header,n=e.subHeader,l=e.stretched,o=x()(e,["addOn","header","subHeader","stretched"]);if(n&&t)throw new Error("You cannot have both subHeader and addon");if(!a&&n)throw new Error("You must provide a header if you provide a subHeader");var r=N()("wds-modal__addon",{"wds-modal__addon--stretched":l||!a});return g.a.createElement("header",{className:"wds-modal__head","data-testid":o["data-testid"]},g.a.createElement("div",{className:"wds-modal__title"},a&&g.a.createElement("h1",{className:"wds-modal__text"},a),n&&g.a.createElement("p",{className:"wds-modal__sub-text"},n)),t&&g.a.createElement("div",{className:r},t))};Zt.displayName="ModalHeader",Zt.defaultProps={addOn:null,header:null,stretched:!1,subHeader:null,"data-testid":void 0},Zt.propTypes={addOn:w.a.node,header:w.a.node,stretched:w.a.bool,subHeader:w.a.node,"data-testid":w.a.string},Zt.__docgenInfo={description:"",methods:[],displayName:"ModalHeader",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},header:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},subHeader:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var $t=Zt,Xt=function(e){var t=e.placement,a=e.children;return g.a.createElement("div",{className:"wds-modal__actions-".concat(t)},a)};Xt.displayName="Align",Xt.propTypes={children:w.a.node.isRequired,placement:w.a.oneOf(["left","right"]).isRequired},Xt.__docgenInfo={description:"",methods:[],displayName:"Align",props:{children:{type:{name:"node"},required:!0,description:""},placement:{type:{name:"enum",value:[{value:"'left'",computed:!1},{value:"'right'",computed:!1}]},required:!0,description:""}}};var Qt=Xt,ea=(a(35),function(e){function t(e){var a;l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"getSelectedOrder",(function(e){return e.map((function(e,t){return"MultiselectOption"===e.type.displayName&&e.props.selected?t:null})).filter((function(e){return null!==e}))})),v()(p()(a),"handleMenuChange",(function(e){var t=e.show;a.props.onMenuChange(t),a.setState({showMenu:t})})),v()(p()(a),"handleKeyDown",(function(e){var t,n=e.keyCode===J.BACKSPACE,l=""==e.target.value,o=0!==a.selectedMenuItems.length;n&&l&&o&&(g.a.Children.forEach(a.selectedMenuItems,(function(e){t=e.props["data-index"]})),a.removeBadge(t))})),v()(p()(a),"handleKeyUp",(function(e){var t=a.props.autocomplete;e.keyCode===J.ESC?(a.setState({filterBy:"",showMenu:!1}),a.inputRef&&a.inputRef.blur()):t&&a.setState({filterBy:e.target.value,showMenu:!0})})),v()(p()(a),"removeBadge",(function(e){var t=a.state.options,n=a.props.onRemove,l=g.a.cloneElement(t[e],{selected:!1});t[e]=l;var o=a.selectedOrder.indexOf(e);a.selectedOrder.splice(o,1),a.setState({options:t,showMenu:!0}),n&&n(e)}));var n=g.a.Children.toArray(e.children);return a.selectedMenuItems=[],a.menuItems=[],a.selectedOrder=a.getSelectedOrder(n),a.state={options:n,showMenu:e.show,filterBy:e.value||""},a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=g.a.Children.toArray(e.children);this.selectedOrder=this.getSelectedOrder(t),this.setState({options:t,showMenu:e.show})}},{key:"componentDidUpdate",value:function(){this.state.showMenu&&this.inputRef&&this.inputRef.focus()}},{key:"getBadge",value:function(e,t){var a=this,n="multiselect-child-".concat(t);return g.a.cloneElement(e,{key:n,id:n,"data-index":t,onClose:function(){return a.removeBadge(t)},dismissible:!0})}},{key:"getMenuItem",value:function(e,t,a){var n=this,l=this.props.autocomplete,o=this.state.filterBy,r="multiselect-child-".concat(t),i=e.props,d=i.children,u=i.className,s=i.disabled,c=i.icon,p=i.value||d,m="string"==typeof p&&p.toUpperCase().indexOf(o.toUpperCase())>=0,f=l&&!m,h=s||f,v=N()({"wds-display--none":f},u);return g.a.createElement(Ht,{className:v,key:r,id:r,disabled:h,onClick:function(){return n.clickMenuItem(t,a)},addOn:a&&g.a.createElement("span",{className:"multiselect__checked"},g.a.createElement(Re,{color:"success"})),"data-testid":e.props["data-testid"]},c,d)}},{key:"clickMenuItem",value:function(e,t){this[t?"removeBadge":"addBadge"](e)}},{key:"addBadge",value:function(e){var t=this.state.options,a=this.props.onAdd,n=g.a.cloneElement(t[e],{selected:!0});t[e]=n,this.selectedOrder.push(e),this.setState({options:t,showMenu:!0,filterBy:""}),a&&a(e)}},{key:"render",value:function(){var e=this,t=this.props,a=t.addOn,n=t.addOnPlacement,l=t.autoClose,o=t.className,r=t.id,i=t.label,d=t.disabled,u=t.color,s=t.placeholder,c=t.removeFromMenu,p=t.inputProps,m=t.value,f=t.useBadges,h=t.readOnly,b=this.state,w=b.options,_=b.showMenu,x=r||lt()(),q=N()("wds-multiselect",{"wds-multiselect--disabled":d},v()({},"wds-multiselect--".concat(u),u),o),C=g.a.createElement(Vt,Object.assign({},p,{id:x,inputRef:function(t){e.inputRef=t},placeholder:s,defaultValue:m,readOnly:h,onKeyDown:function(t){e.handleKeyDown(t),p&&p.onKeyDown&&p.onKeyDown(t)},onKeyUp:function(t){e.handleKeyUp(t),p&&p.onKeyUp&&p.onKeyUp(t)}})),E=function(){return a&&g.a.createElement("div",{className:"wds-multiselect__addon"},a)};return this.selectedMenuItems=[],this.menuItems=[],g.a.Children.forEach(w,(function(t,a){t.props.selected?!c&&t.props.selected&&e.menuItems.push(e.getMenuItem(t,a,t.props.selected)):e.menuItems.push(e.getMenuItem(t,a))})),this.selectedOrder.forEach((function(t){e.selectedMenuItems.push(e.getBadge(w[t],t))})),g.a.createElement(y.Fragment,null,i&&g.a.createElement(Ct,{htmlFor:x},i),g.a.createElement("div",{id:x,className:q,selection:this.selectedMenuItems,"data-testid":this.props["data-testid"]},"left"===n&&E(),g.a.createElement("div",{className:"wds-multiselect__main"},f&&this.selectedMenuItems,g.a.createElement(At,{autoClose:l,dense:!0,noRules:!0,menuTrigger:C,show:_,onChange:this.handleMenuChange},this.menuItems)),"right"===n&&E()))}}]),t}(y.Component));ea.displayName="Multiselect",ea.propTypes={addOnPlacement:w.a.oneOf(H),autoClose:w.a.bool,children:w.a.node.isRequired,className:w.a.string,id:w.a.string,label:w.a.node,disabled:w.a.bool,color:w.a.oneOf(K),placeholder:w.a.node,value:w.a.node,onAdd:w.a.func,onRemove:w.a.func,autocomplete:w.a.bool,readOnly:w.a.bool,removeFromMenu:function(e,t,a){return!e.useBadges&&e[t]?new Error("removeFromMenu prop should not be passed if `useBadges` is set to false"):"boolean"!=typeof e[t]?new Error("Invalid prop ".concat(t," supplied to ").concat(a,". Expected boolean")):null},addOn:w.a.node,"data-testid":w.a.string,inputProps:w.a.shape({onKeyUp:w.a.func,onKeyDown:w.a.func}),useBadges:w.a.bool,onMenuChange:w.a.func,show:w.a.bool},ea.defaultProps={id:null,label:null,placeholder:null,className:null,color:null,addOn:null,addOnPlacement:"left",autoClose:!0,inputProps:null,"data-testid":void 0,value:"",disabled:!1,autocomplete:!0,readOnly:!1,removeFromMenu:!1,useBadges:!0,show:!1,onAdd:function(){},onRemove:function(){},onMenuChange:function(){}},ea.__docgenInfo={description:"",methods:[{name:"getSelectedOrder",docblock:null,modifiers:[],params:[{name:"options",type:null}],returns:null},{name:"getBadge",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null}],returns:null},{name:"getMenuItem",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"handleMenuChange",docblock:null,modifiers:[],params:[{name:"{ show: showMenu }",type:null}],returns:null},{name:"clickMenuItem",docblock:null,modifiers:[],params:[{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"handleKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleKeyUp",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"addBadge",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null},{name:"removeBadge",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null}],displayName:"Multiselect",props:{id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},placeholder:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},inputProps:{defaultValue:{value:"null",computed:!1},type:{name:"shape",value:{onKeyUp:{name:"func",required:!1},onKeyDown:{name:"func",required:!1}}},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},value:{defaultValue:{value:"''",computed:!1},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},autocomplete:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},readOnly:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},removeFromMenu:{defaultValue:{value:"false",computed:!1},type:{name:"custom",raw:"(props, propName, componentName) => {\n  if (!props['useBadges'] && props[propName]) {\n    return new Error(\n      'removeFromMenu prop should not be passed if `useBadges` is set to false'\n    );\n  }\n\n  if (typeof props[propName] !== 'boolean') {\n    return new Error(\n      `Invalid prop ${propName} supplied to ${componentName}. Expected boolean`\n    );\n  }\n\n  return null;\n}"},required:!1,description:""},useBadges:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onAdd:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},onRemove:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},onMenuChange:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ta=ea,aa=function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"handleClick",(function(){var e=a.props.onClose;e&&e()})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this.props,t=e.className,a=e.color,n=e.children,l=e.dismissible,o=e.icon,r=e.value,i=N()("wds-badge","wds-badge--".concat(a),{"wds-badge--dismissible":l},t),d="light";return"muted"!=a&&"upgrade"!=a&&"info"!=a||(d="dark"),g.a.createElement("span",{className:i,"data-testid":this.props["data-testid"]},o,r||n,l&&g.a.createElement(ye,{variant:d,onClick:this.handleClick}))}}]),t}(g.a.Component);aa.displayName="MultiselectOption",aa.defaultProps={className:null,color:"primary",dismissible:!1,icon:null,onClose:null,value:"","data-testid":void 0},aa.propTypes={children:w.a.node.isRequired,className:w.a.string,color:w.a.oneOf(Q),dismissible:w.a.bool,onClose:w.a.func,icon:w.a.node,value:w.a.node,"data-testid":w.a.string},aa.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"MultiselectOption",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",computed:!0,value:"multiSelectColors"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},icon:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},value:{defaultValue:{value:"''",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var na=aa,la=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m15.2012 7.25h-14.4024a.75.75 0 0 0 0 1.5h14.4024a.75.75 0 0 0 0-1.5z"})))};la.displayName="IconMinus",la.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},la.defaultProps={title:"Minus",color:null,size:null},la.__docgenInfo={description:"",methods:[],displayName:"IconMinus",props:{title:{defaultValue:{value:"'Minus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var oa=la,ra=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m15.2012 7.25h-6.4512v-6.4512a.75.75 0 0 0 -1.5 0v6.4512h-6.4512a.75.75 0 0 0 0 1.5h6.4512v6.4512a.75.75 0 0 0 1.5 0v-6.4512h6.4512a.75.75 0 0 0 0-1.5z"})))};ra.displayName="IconPlus",ra.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},ra.defaultProps={title:"Plus",color:null,size:null},ra.__docgenInfo={description:"",methods:[],displayName:"IconPlus",props:{title:{defaultValue:{value:"'Plus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ia=ra,da=(a(86),function(e){function t(e){var a;l()(this,t),a=d()(this,s()(t).call(this,e));var n=e.min,o=e.value,r=e.max;return a.state={value:Math.round(o<n?n:r&&o>r?r:o)},a.manualInput=g.a.createRef(),a}return f()(t,e),r()(t,[{key:"shouldDisableMinus",value:function(){return this.state.value<=this.props.min}},{key:"shouldDisablePlus",value:function(){var e=this.props.max;return e&&this.state.value>=e}},{key:"handleMinus",value:function(){var e=this.props,t=e.min,a=e.step,n=this.state.value-a,l=n<t?t:n;this.handleChange(l),this.setState({value:l})}},{key:"handlePlus",value:function(){var e=this.props,t=e.max,a=e.step,n=this.state.value+a,l=t&&n>t?t:n;this.handleChange(l),this.setState({value:l})}},{key:"handleInputChange",value:function(){var e=this.props,t=e.min,a=e.max,n=this.manualInput.current.state.value,l=parseInt(n,10)||t,o=l<t?t:l,r=a&&o>a?a:o;this.handleChange(r),this.setState({value:r})}},{key:"handleChange",value:function(e){var t=this.props.onChange;t&&t(e)}},{key:"render",value:function(){var e=this,t=this.props,a=t.label,n=t.stretched,l=t.color,o=t.disabled,r=t.editable,i=this.state.value,d=N()({"wds-number-picker":!0,"wds-number-picker--stretched":n,"wds-number-picker--editable":r});return g.a.createElement("div",{className:d,"data-testid":this.props["data-testid"]},g.a.createElement(Ot,{label:a,stretched:n,color:l,disabled:o},g.a.createElement(Tt,{"data-testid":this.props["data-testid"]?"".concat(this.props["data-testid"],"_Minus"):void 0},g.a.createElement(Ze,{size:"sm",color:"muted",onClick:function(){return e.handleMinus()},disabled:this.shouldDisableMinus()},g.a.createElement(oa,null))),r&&g.a.createElement(Vt,{ref:this.manualInput,inputSize:3,value:i,onChange:function(){return e.handleInputChange()}}),!r&&g.a.createElement("div",{className:"wds-input"},i),g.a.createElement(Tt,{"data-testid":this.props["data-testid"]?"".concat(this.props["data-testid"],"_Plus"):void 0},g.a.createElement(Ze,{size:"sm",color:"muted",onClick:function(){return e.handlePlus()},disabled:this.shouldDisablePlus()},g.a.createElement(ia,null)))))}}]),t}(g.a.Component));da.displayName="NumberPicker",da.propTypes={label:w.a.node,stretched:w.a.bool,value:w.a.number,onChange:w.a.func,min:w.a.number,max:w.a.number,step:w.a.number,color:w.a.oneOf(K),disabled:w.a.bool,editable:w.a.bool,"data-testid":w.a.string},da.defaultProps={label:null,stretched:!1,value:0,onChange:function(){return null},min:0,max:null,step:1,color:null,disabled:!1,editable:!1,"data-testid":void 0},da.__docgenInfo={description:"",methods:[{name:"shouldDisableMinus",docblock:null,modifiers:[],params:[],returns:null},{name:"shouldDisablePlus",docblock:null,modifiers:[],params:[],returns:null},{name:"handleMinus",docblock:null,modifiers:[],params:[],returns:null},{name:"handlePlus",docblock:null,modifiers:[],params:[],returns:null},{name:"handleInputChange",docblock:null,modifiers:[],params:[],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null}],displayName:"NumberPicker",props:{label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},value:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},onChange:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},min:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},max:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},step:{defaultValue:{value:"1",computed:!1},type:{name:"number"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},editable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var ua=da,sa=(a(87),function(e){var t=e.addOn,a=e.centered,n=e.subTitle,l=e.title,o=x()(e,["addOn","centered","subTitle","title"]);return g.a.createElement("div",{className:N()("wds-pageheader",{"wds-pageheader--centered":a}),"data-testid":o["data-testid"]},g.a.createElement("div",{className:"wds-pageheader__text"},g.a.createElement("h1",{className:"wds-pageheader__title wds-type--section-title"},l),n?g.a.createElement("span",{className:"wds-pageheader__subtitle"},n):null),t?g.a.createElement("div",{className:"wds-pageheader__addon"},t):null)});sa.displayName="PageHeader",sa.propTypes={addOn:w.a.node,centered:w.a.bool,subTitle:w.a.node,title:w.a.node.isRequired,"data-testid":w.a.string},sa.defaultProps={addOn:null,centered:!1,subTitle:null,"data-testid":void 0},sa.__docgenInfo={description:"",methods:[],displayName:"PageHeader",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},centered:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},subTitle:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},title:{type:{name:"node"},required:!0,description:""}}};var ca=sa,pa=(a(36),function(e){var t=e.children,a=e.disabled,n=e.value,l=x()(e,["children","disabled","value"]);return g.a.createElement("option",{disabled:a,value:n,"data-testid":l["data-testid"]},t)});pa.displayName="Option",pa.propTypes={children:w.a.node.isRequired,disabled:w.a.bool,selectedValue:w.a.node,value:w.a.string.isRequired,"data-testid":w.a.string},pa.defaultProps={disabled:!1,selectedValue:null,"data-testid":void 0},pa.__docgenInfo={description:"",methods:[],displayName:"Option",props:{disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},selectedValue:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},value:{type:{name:"string"},required:!0,description:""}}};var ma=pa,fa=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m1.7438 4.55c-.605 0-.75.35-.3222.7778l5.8006 5.8006a1.1032 1.1032 0 0 0 1.5556 0l5.8006-5.8006c.4278-.4278.2828-.7778-.3222-.7778z"})))};fa.displayName="IconCaretDown",fa.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},fa.defaultProps={title:"CaretDown",color:null,size:null},fa.__docgenInfo={description:"",methods:[],displayName:"IconCaretDown",props:{title:{defaultValue:{value:"'CaretDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ha=fa;function va(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}var ya=function(e){function t(e){var a;l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"updateNewProps",(function(e){var t=g.a.Children.toArray(e.children),n=e.value;a.setState(function(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?va(Object(a),!0).forEach((function(t){v()(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):va(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}({},a.state,{options:t,value:n}))})),v()(p()(a),"handleChangeNative",(function(e){for(var t,n=[],l=a.props.multiple,o=e.target,r=o.options.length,i=null,d=0;d<r;d+=1)t=o.options[d],l&&t.selected?n.push(t.value):!l&&t.selected&&(i=t.value);e.persist(),a.setState({value:i||n},(function(){a.props.onChange&&a.props.onChange(e)}))})),v()(p()(a),"clickMenuItem",(function(e){var t=e.target.attributes.value.nodeValue;e.persist(),a.setState({value:t},(function(){a.props.onChange&&a.props.onChange(e)}))})),v()(p()(a),"handleMenuChange",(function(){a.setState({showMenu:!1})}));var n=g.a.Children.toArray(e.children);return a.state={isControlled:rt(e.value),value:e.value,options:n,showMenu:!1},a.selectedItem=e.placeholder,a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.state,a=t.options,n=t.value,l=g.a.Children.toArray(e.children),o=!!e.value&&e.value!==n;(a.length!==l.length||l.some((function(e,t){return Object.keys(a[t].props).find((function(n){return e.props[n]!==a[t].props[n]}))}))||o)&&this.updateNewProps(e)}},{key:"getMenuItem",value:function(e,t,a){var n="select-child-".concat(t),l=e.props,o=l.children,r=l.className,i=l.icon,d=l.value,u=N()(r);return g.a.createElement(Ht,{className:u,key:n,id:n,disabled:e.props.disabled,value:d,onClick:this.clickMenuItem,addOn:a&&g.a.createElement("span",{className:"select__checked"},g.a.createElement(Re,{color:"success"})),"data-testid":e.props["data-testid"],role:"option"},i,o)}},{key:"renderSelectedItem",value:function(e){var t=e.children;return g.a.createElement("div",{key:t.id,className:"wds-select__selected-item"},e.selectedValue||(t.props?t.props.children:t))}},{key:"render",value:function(){var e=this,t=this.props,a=t.addOn,n=t.className,l=t.id,o=t.label,r=t.disabled,i=t.color,d=t.defaultValue,u=t.placeholder,s=t.size,c=t.multiple,p=t.stretched,m=t.native,f=(t.selectSize,t.placement),h=t.name,b=x()(t,["addOn","className","id","label","disabled","color","defaultValue","placeholder","size","multiple","stretched","native","selectSize","placement","name"]),w=this.state,_=w.options,q=w.value,C=w.isControlled,E=l||lt()(),V=N()("wds-select",{"wds-select--stretched":p},{"wds-select--disabled":r},v()({},"wds-select--".concat(i),i),"wds-select--".concat(s),n),k=N()("wds-select__main");this.selectedItem=u;var O=g.a.Children.map(_,(function(t,a){var n=t.props,l=q==n.value;return l&&(e.selectedItem=e.renderSelectedItem(n,a)),e.getMenuItem(t,a,l)})),P=g.a.createElement("div",{className:k},a&&g.a.createElement("div",{className:"wds-select__addon"},a),this.selectedItem,g.a.createElement("div",{className:"wds-select__affordance"},g.a.createElement(ha,null))),T=m?null:this.props["data-testid"];return g.a.createElement(y.Fragment,null,!!o&&g.a.createElement(Ct,{htmlFor:E},o),g.a.createElement("div",{id:m?null:E,className:V,"data-testid":T,tabIndex:m?null:-1,role:"button","aria-haspopup":"listbox","aria-expanded":this.state.showMenu},!m&&g.a.createElement(At,{dense:!0,noRules:!0,menuTrigger:P,placement:f,show:this.state.showMenu,onChange:this.handleMenuChange,role:"listbox"},O),m&&!C&&g.a.createElement(y.Fragment,null,g.a.createElement("select",Object.assign({},b,{"aria-label":o,id:E,disabled:r,name:h,multiple:c,defaultValue:d}),_),!c&&g.a.createElement("span",{className:"wds-select__affordance"},g.a.createElement(ha,null))),m&&C&&g.a.createElement(y.Fragment,null,g.a.createElement("select",Object.assign({},b,{"aria-label":o,id:E,disabled:r,name:h,multiple:c,onChange:this.handleChangeNative,value:q}),_),!c&&g.a.createElement("span",{className:"wds-select__affordance"},g.a.createElement(ha,null)))))}}]),t}(y.Component);ya.displayName="Select",ya.propTypes={addOn:w.a.node,children:w.a.node.isRequired,className:w.a.string,id:w.a.string,label:w.a.node,name:w.a.string,disabled:w.a.bool,color:w.a.oneOf(K),placeholder:w.a.node,value:w.a.oneOfType([w.a.array,w.a.string,w.a.number]),onChange:w.a.func,selectSize:w.a.number,defaultValue:w.a.node,"data-testid":w.a.string,size:w.a.oneOf(A),stretched:w.a.bool,native:w.a.bool,multiple:w.a.bool,placement:w.a.oneOf(L)},ya.defaultProps={addOn:null,className:null,id:null,label:null,name:null,disabled:!1,color:null,placeholder:"Choose...",value:void 0,onChange:null,selectSize:null,defaultValue:void 0,"data-testid":void 0,size:"md",stretched:!1,native:!1,multiple:!1,placement:"bottom-left"},ya.__docgenInfo={description:"",methods:[{name:"getMenuItem",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"updateNewProps",docblock:null,modifiers:[],params:[{name:"nextProps",type:null}],returns:null},{name:"handleChangeNative",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"clickMenuItem",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleMenuChange",docblock:null,modifiers:[],params:[],returns:null},{name:"renderSelectedItem",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null}],displayName:"Select",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},placeholder:{defaultValue:{value:"'Choose...'",computed:!1},type:{name:"node"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"union",value:[{name:"array"},{name:"string"},{name:"number"}]},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},selectSize:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},defaultValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},native:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"'bottom-left'",computed:!1},type:{name:"enum",computed:!0,value:"menuPlacements"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ga=ya,ba=(a(88),function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"handleBackButtonClick",(function(e){var t=a.props;(0,t.onChangePage)(e,t.page-1)})),v()(p()(a),"handleNextButtonClick",(function(e){var t=a.props;(0,t.onChangePage)(e,t.page+1)})),v()(p()(a),"handleJumpToPage",(function(e){var t=e.target,n=t.value,l=t.attributes,o=n||l.value.nodeValue,r=parseInt(o)-1;a.props.onChangePage&&a.props.onChangePage(e,r)})),a}return f()(t,e),r()(t,[{key:"render",value:function(){for(var e=this.props,t=e.className,a=e.hasPageSelect,n=e.hasRowsPerPage,l=e.rowsPerPage,o=(e.onChangePage,e.onChangeRowsPerPage),r=e.page,i=e.count,d=e.labelLegend,u=e.labelJumpToPage,s=e.labelRowsPerPage,c=x()(e,["className","hasPageSelect","hasRowsPerPage","rowsPerPage","onChangePage","onChangeRowsPerPage","page","count","labelLegend","labelJumpToPage","labelRowsPerPage"]),p=N()("wds-pagination",t),m=0===i?0:r*l+1,f=Math.min(i,(r+1)*l),h=i,v=Math.ceil(i/l),y=r+1,b=[],w=0;w<v;w++)b.push(g.a.createElement(ma,{value:"".concat(w+1),key:"".concat(w+1)},u({page:w+1})));return g.a.createElement("div",Object.assign({className:p},c),g.a.createElement("span",{className:"wds-pagination__legend"},g.a.createElement(ke,{component:"div",variant:"bodySm",color:"dark-muted"},d({firstRowOnPage:m,lastRowOnPage:f,totalRows:h}))),n&&g.a.createElement("span",{className:"wds-pagination__per-page"},g.a.createElement(ga,{onChange:o,value:l},g.a.createElement(ma,{value:"10"},s({page:10})),g.a.createElement(ma,{value:"25"},s({page:25})),g.a.createElement(ma,{value:"50"},s({page:50})),g.a.createElement(ma,{value:"100"},s({page:100})))),a&&g.a.createElement("span",{className:"wds-pagination__page"},g.a.createElement(ga,{value:"".concat(y),onChange:this.handleJumpToPage},b)),g.a.createElement("span",{className:"wds-pagination__actions"},g.a.createElement(Xe,null,g.a.createElement(Ze,{color:"muted",onClick:this.handleBackButtonClick,disabled:0===r},g.a.createElement(qt,null,"Æ")),g.a.createElement(Ze,{color:"muted",onClick:this.handleNextButtonClick,disabled:r>=Math.ceil(h/l)-1},g.a.createElement(qt,null,"ÿ")))))}}]),t}(y.Component));ba.displayName="Pagination",ba.propTypes={className:w.a.string,page:w.a.number.isRequired,count:w.a.number.isRequired,rowsPerPage:w.a.number.isRequired,onChangePage:w.a.func,hasPageSelect:w.a.bool,hasRowsPerPage:w.a.bool,onChangeRowsPerPage:w.a.func,labelLegend:w.a.func,labelRowsPerPage:w.a.func,labelJumpToPage:w.a.func},ba.defaultProps={className:"",onChangePage:null,hasPageSelect:!1,hasRowsPerPage:!1,onChangeRowsPerPage:null,labelLegend:function(e){var t=e.firstRowOnPage,a=e.lastRowOnPage,n=e.totalRows;return"Showing ".concat(t," - ").concat(a," of ").concat(n)},labelRowsPerPage:function(e){var t=e.page;return"".concat(t," per page")},labelJumpToPage:function(e){var t=e.page;return"Page ".concat(t)}},ba.__docgenInfo={description:"",methods:[{name:"handleBackButtonClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleNextButtonClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleJumpToPage",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null}],displayName:"Pagination",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onChangePage:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},hasPageSelect:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},hasRowsPerPage:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChangeRowsPerPage:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},labelLegend:{defaultValue:{value:"({ firstRowOnPage, lastRowOnPage, totalRows }) =>\n  `Showing ${firstRowOnPage} - ${lastRowOnPage} of ${totalRows}`",computed:!1},type:{name:"func"},required:!1,description:""},labelRowsPerPage:{defaultValue:{value:"({ page }) => `${page} per page`",computed:!1},type:{name:"func"},required:!1,description:""},labelJumpToPage:{defaultValue:{value:"({ page }) => `Page ${page}`",computed:!1},type:{name:"func"},required:!1,description:""},page:{type:{name:"number"},required:!0,description:""},count:{type:{name:"number"},required:!0,description:""},rowsPerPage:{type:{name:"number"},required:!0,description:""}}};var wa,_a=ba;a(18);function xa(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}function qa(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?xa(Object(a),!0).forEach((function(t){v()(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):xa(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}var Na=function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"onMouseEnter",(function(){if(!a.props.clickable){if(a.props.delay)return void(wa=setTimeout(function(){this.setState({show:!0}),this.change(!0)}.bind(p()(a)),800));a.setState({show:!0,currentPlacement:a.props.placement}),a.change(!0)}})),v()(p()(a),"onMouseLeave",(function(){a.props.delay&&clearTimeout(wa),a.contextMenuOpen||a.props.clickable||(a.setState({show:!1}),a.change(!1))})),v()(p()(a),"onContextMenu",(function(){a.contextMenuOpen=!0,a.change(!0)})),v()(p()(a),"getSlideDirection",(function(){var e=a.state.currentPlacement;return e&&"top"!==e?"bottom"===e?"down":"left"===e?"left":"right":"up"})),v()(p()(a),"handleAutoCloseBlur",(function(e){a.popout.contains(e.target)||a.handleClose()})),v()(p()(a),"handleScroll",(function(){a.state.show&&a.props.renderTo&&a.updatePosition()})),v()(p()(a),"handleClick",(function(){a.props.clickable&&(a.change(!a.state.show),a.setState({show:!a.state.show}))})),v()(p()(a),"updatePosition",(function(){if(a.popout&&a.state.show&&a.popoutContent.children&&a.popoutContent.children.length&&(a.props.renderTo||a.props.autoFlip)){var e,t,n,l=a.popout.getBoundingClientRect(),o=a.popoutContent.children[0].getBoundingClientRect(),r=jt?document.documentElement.clientWidth:void 0,i=jt?document.documentElement.clientHeight:void 0,d={top:{width:r,height:l.top},right:{width:r-l.right,height:i},bottom:{width:r,height:i-l.bottom},left:{width:l.left,height:i}},u=Object.keys(d).map((function(e){return qa({key:e},d[e],{area:d[e].width*d[e].height})})).sort((function(e,t){return t.area-e.area})),s=u.filter((function(e){var t=e.width,a=e.height;return t>=o.width&&a>=o.height}));if("top"===(n=s.find((function(e){return e.key===a.props.placement}))||!a.props.autoFlip?a.props.placement:s.length?s[0].key:u[0].key))e=l.top-o.height,t=l.left+l.width/2;else if("left"===n){var c=parseInt(Rt.popout["popout__pip-size"],10)+parseInt(Rt.space["space--1"],10);e=l.top+l.height/2,t=l.left-(o.width+c)}else"right"===n?(e=l.top+l.height/2,t=l.left+l.width):(e=l.bottom,t=l.left+l.width/2);var p={currentPlacement:n};a.props.renderTo&&(p.popoutStyle={top:"".concat(e,"px"),left:"".concat(t,"px"),zIndex:Rt["z-index"]["z--space"]+1,position:"fixed"}),a.setState(qa({},p))}})),v()(p()(a),"change",(function(e){var t=a.props,n=t.onChange,l=t.renderTo;e&&l&&a.updatePosition(),n&&n(e)})),v()(p()(a),"handleClose",(function(){a.change(!1),a.setState({show:!1})})),v()(p()(a),"hasMastHead",(function(){var e=g.a.Children.toArray(a.props.children)[0];return!(!e.type||"PopoutMasthead"!==e.type.displayName)})),v()(p()(a),"popoutRef",(function(e){return a.popout=e})),v()(p()(a),"renderPopoutContent",(function(){var e=a.props,t=e.delay,n=e.children,l=e.size,o=e.className,r=e.renderTo,i=e.autoFlip,d=e.clickable,u=e.noCloseButton,s=a.state.currentPlacement,c=N()("wds-popout--".concat(s),"wds-popout",{"wds-popout--delay":t},v()({},"wds-popout--".concat(l),l),{"wds-popout--auto-flip":i},o),p=u&&!d,m=!a.hasMastHead()&&!p,f=g.a.createElement("div",{className:c,"data-testid":a.props["data-testid"]?"".concat(a.props["data-testid"],"_ContentWrapper"):void 0,style:a.state.popoutStyle,ref:function(e){return a.popoutContent=e}},g.a.createElement(ce.Slide,{in:a.state.show,direction:a.getSlideDirection(),speed:"fast",distance:"near"},g.a.createElement("div",{className:"wds-popout__popout","data-testid":a.props["data-testid"]},m&&g.a.createElement(ye,{onClick:a.handleClose,ariaLabel:a.props.ariaLabel,"data-testid":a.props["data-testid"]?"".concat(a.props["data-testid"],"_CloseModal"):void 0}),n)));return r?Mt.a.createPortal(f,r):f})),a.state={show:e.show,popoutStyle:null,currentPlacement:e.placement},a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillMount",value:function(){this.props.autoClose&&jt&&document.addEventListener("mousedown",this.handleAutoCloseBlur,!1)}},{key:"componentDidMount",value:function(){var e=this,t=this.props,a=t.clickable,n=t.renderTo;this.mousemove=function(){e.contextMenuOpen=!1},this.state.show&&n&&this.updatePosition(),(a||n)&&jt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillUpdate",value:function(e,t){jt&&(t.show?window.addEventListener("mousemove",this.mousemove):window.removeEventListener("mousemove",this.mousemove))}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){var e=this.props,t=e.clickable,a=e.renderTo;(t||a)&&jt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll)),this.props.autoClose&&jt&&document.removeEventListener("mousedown",this.handleAutoCloseBlur,!1)}},{key:"render",value:function(){var e=this.props,t=e.trigger,a=e.triggerClassName,n=e.clickable,l=N()("wds-has-popout",a,{"wds-has-popout--clickable":n});return g.a.createElement("span",{className:l,onMouseLeave:this.onMouseLeave,onBlur:this.onMouseLeave,onContextMenu:this.onContextMenu,ref:this.popoutRef},g.a.createElement("span",{className:"wds-popout__trigger",onClick:this.handleClick,onKeyDown:this.handleClick,onMouseEnter:this.onMouseEnter,onFocus:this.onMouseEnter},t),this.renderPopoutContent())}}]),t}(y.Component);Na.displayName="Popout",Na.propTypes={children:w.a.node.isRequired,delay:w.a.bool,onChange:w.a.func,placement:w.a.oneOf(H),show:w.a.bool,trigger:w.a.node.isRequired,size:w.a.string,className:w.a.string,triggerClassName:w.a.string,ariaLabel:w.a.node,noCloseButton:w.a.bool,clickable:w.a.bool,"data-testid":w.a.string,renderTo:w.a.oneOfType([w.a.func,w.a.shape({current:w.a.elementType})]),autoFlip:w.a.bool,autoClose:w.a.bool},Na.defaultProps={delay:!1,onChange:null,placement:"top",show:!1,size:"sm",className:"",triggerClassName:"",ariaLabel:"Close Popout",noCloseButton:!1,clickable:!1,"data-testid":void 0,renderTo:null,autoFlip:!1,autoClose:!1},Na.__docgenInfo={description:"",methods:[{name:"onMouseEnter",docblock:null,modifiers:[],params:[],returns:null},{name:"onMouseLeave",docblock:null,modifiers:[],params:[],returns:null},{name:"onContextMenu",docblock:null,modifiers:[],params:[],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"handleAutoCloseBlur",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"change",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null},{name:"handleClose",docblock:null,modifiers:[],params:[],returns:null},{name:"hasMastHead",docblock:null,modifiers:[],params:[],returns:null},{name:"popoutRef",docblock:null,modifiers:[],params:[{name:"popout",type:null}],returns:null},{name:"renderPopoutContent",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Popout",props:{delay:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},placement:{defaultValue:{value:"'top'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},triggerClassName:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Popout'",computed:!1},type:{name:"node"},required:!1,description:""},noCloseButton:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},clickable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},autoFlip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},autoClose:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},trigger:{type:{name:"node"},required:!0,description:""}}};var Ca=Na,Ea=function(e){return g.a.createElement("div",{className:"wds-popout__body","data-testid":e["data-testid"]},e.children)};Ea.displayName="PopoutBody",Ea.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Ea.defaultProps={"data-testid":void 0},Ea.__docgenInfo={description:"",methods:[],displayName:"PopoutBody",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Va=Ea,ka=function(e){var t=e.children,a=e.placement,n=N()(v()({},"wds-popout__actions-".concat(a),a));return g.a.createElement("div",{className:n},t)};ka.displayName="PopoutAlign",ka.propTypes={children:w.a.node.isRequired,placement:w.a.oneOf(H)},ka.defaultProps={placement:"left"},ka.__docgenInfo={description:"",methods:[],displayName:"PopoutAlign",props:{placement:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Oa=ka,Pa=function(e){return g.a.createElement("footer",{className:"wds-popout__foot","data-testid":e["data-testid"]},e.children)};Pa.displayName="PopoutFooter",Pa.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Pa.defaultProps={"data-testid":void 0},Pa.__docgenInfo={description:"",methods:[],displayName:"PopoutFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ta=Pa,Sa=function(e){return g.a.createElement("header",{className:"wds-popout__head","data-testid":e["data-testid"]},g.a.createElement("h2",{className:"wds-type--card-title"},e.children))};Sa.displayName="PopoutHeader",Sa.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Sa.defaultProps={"data-testid":void 0},Sa.__docgenInfo={description:"",methods:[],displayName:"PopoutHeader",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Fa=Sa,Ia=function(e){return g.a.createElement("div",{className:"wds-popout__masthead","data-testid":e["data-testid"]},e.children)};Ia.displayName="PopoutMasthead",Ia.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Ia.defaultProps={"data-testid":void 0},Ia.__docgenInfo={description:"",methods:[],displayName:"PopoutMasthead",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ma=Ia,Ra=(a(89),function(e){var t=e.percent,a=e.size,n=e.color,l=x()(e,["percent","size","color"]),o=N()("wds-progress-bar","wds-progress-bar--".concat(n),"wds-progress-bar--".concat(a)),r={width:"".concat(t,"%")};return g.a.createElement("div",{className:o,role:"progressbar","aria-valuenow":t,"aria-valuemin":"0","aria-valuemax":"100","data-testid":l["data-testid"]},g.a.createElement("div",{style:r,className:"wds-progress-bar__fill"}))});Ra.displayName="ProgressBar",Ra.propTypes={percent:w.a.string.isRequired,size:w.a.oneOf(A),color:w.a.oneOf(ne),"data-testid":w.a.string},Ra.defaultProps={size:"md",color:"success","data-testid":void 0},Ra.__docgenInfo={description:"",methods:[],displayName:"ProgressBar",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'success'",computed:!1},type:{name:"enum",computed:!0,value:"progressBarColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},percent:{type:{name:"string"},required:!0,description:""}}};var za=Ra,Ba=(a(90),function(e){var t=e.children,a=e.size,n=e.percent,l=e.color,o=e.continuous,r=N()("wds-progress-circle","wds-progress-circle--".concat(l),"wds-progress-circle--".concat(a),{"wds-progress-circle--continuous":o}),i=12,d=54;switch(a){case"lg":i=8,d=56;break;case"sm":i=16,d=52;break;case"xs":i=20,d=50}return g.a.createElement("div",{className:r},g.a.createElement("svg",{className:"wds-progress-circle__path",viewBox:"0 0 120 120","data-testid":e["data-testid"]},g.a.createElement("g",{className:"wds-progress-circle__path-group"},g.a.createElement("circle",{className:"wds-progress-circle__path-border",cx:"60",cy:"60",r:d,strokeWidth:i}),g.a.createElement("circle",{className:"wds-progress-circle__path-fill",cx:"60",cy:"60",r:d,strokeWidth:i,strokeDasharray:o?null:"339.292 339.292",strokeDashoffset:o?null:339.292*(1-n)}))),t&&g.a.createElement("div",{className:"wds-progress-circle__display"},t))});Ba.displayName="ProgressCircle",Ba.propTypes={children:w.a.node,percent:w.a.number,size:w.a.oneOf(oe),"data-testid":w.a.string,color:w.a.oneOf(le),continuous:w.a.bool},Ba.defaultProps={children:null,percent:null,color:"success",size:"md","data-testid":void 0,continuous:!1},Ba.__docgenInfo={description:"",methods:[],displayName:"ProgressCircle",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},percent:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},color:{defaultValue:{value:"'success'",computed:!1},type:{name:"enum",computed:!0,value:"progressCircleColors"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"progressCircleSizes"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},continuous:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""}}};var ja=Ba,Da=(a(91),function(e){var t=e.checked,a=e.className,n=e.defaultChecked,l=e.disabled,o=e.id,r=e.innerRef,i=e.label,d=e.name,u=e.onBlur,s=e.onChange,c=e.value,p=e["data-testid"],m=x()(e,["checked","className","defaultChecked","disabled","id","innerRef","label","name","onBlur","onChange","value","data-testid"]),f=Object(y.useState)(!!n),h=at()(f,2),v=h[0],b=h[1],w=Object(y.useState)(!1),_=at()(w,2),q=_[0],C=_[1],E=o||lt()(),V=it({isChecked:v},t&&{isChecked:t}).isChecked,k=N()("wds-radio__native",a),O=N()("wds-radio__faux",{"wds-radio--focused":q,"wds-radio--checked":V});return g.a.createElement("span",{className:"wds-radio"},g.a.createElement("input",Object.assign({"aria-checked":V,checked:t&&s&&V,defaultChecked:!!n||(t&&!s?V:void 0),className:k,disabled:l,id:E,name:d,onBlur:function(e){C(!q),u&&u(e)},onFocus:function(){C(!q)},onChange:function(e){b(!V),e.persist(),s&&s(e)},tabIndex:l?-1:0,type:"radio",value:c,ref:r,"data-testid":p},m)),g.a.createElement("span",{className:O,"aria-hidden":"true"}),i&&g.a.createElement("span",{className:"wds-radio__label"},g.a.createElement("label",{htmlFor:E},g.a.createElement(ke,{variant:"body",component:"span"},i))))});Da.displayName="Radio",Da.propTypes={checked:w.a.bool,className:w.a.string,"data-testid":w.a.string,defaultChecked:w.a.bool,disabled:w.a.bool,id:w.a.string,label:w.a.node,name:w.a.string,onBlur:w.a.func,onChange:w.a.func,value:w.a.string,innerRef:w.a.func},Da.defaultProps={checked:void 0,className:null,"data-testid":void 0,defaultChecked:!1,disabled:!1,id:null,label:null,name:null,onBlur:void 0,onChange:void 0,value:void 0,innerRef:null},Da.__docgenInfo={description:"",methods:[],displayName:"Radio",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var Aa=Da;function La(){return(La=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var n in a)Object.prototype.hasOwnProperty.call(a,n)&&(e[n]=a[n])}return e}).apply(this,arguments)}function Ha(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ua(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}var Wa=a(20),Ga=a.n(Wa),Ka=a(40),Ja=a.n(Ka),Ya=function(){function e(e,t,a){var n=this;this.nativeMediaQueryList=e.matchMedia(t),this.active=!0,this.cancellableListener=function(){n.matches=n.nativeMediaQueryList.matches,n.active&&a.apply(void 0,arguments)},this.nativeMediaQueryList.addListener(this.cancellableListener),this.matches=this.nativeMediaQueryList.matches}return e.prototype.cancel=function(){this.active=!1,this.nativeMediaQueryList.removeListener(this.cancellableListener)},e}(),Za=w.a.oneOfType([w.a.string,w.a.object,w.a.arrayOf(w.a.object.isRequired)]),$a=function(e){var t,a;function n(t){var a,n;return Ua(Ha(Ha(a=e.call(this,t)||this)),"queries",[]),Ua(Ha(Ha(a)),"getMatches",(function(){return function(e){var t=Object.keys(e);if(1===t.length&&"__DEFAULT__"===t[0])return e.__DEFAULT__;return e}(a.queries.reduce((function(e,t){var a,n=t.name,l=t.mqListener;return La({},e,((a={})[n]=l.matches,a))}),{}))})),Ua(Ha(Ha(a)),"updateMatches",(function(){var e=a.getMatches();a.setState((function(){return{matches:e}}),a.onChange)})),t.query||t.queries||t.query&&t.queries||Ga()(!1),void 0!==t.defaultMatches&&t.query&&"boolean"!=typeof t.defaultMatches&&Ga()(!1),void 0!==t.defaultMatches&&t.queries&&"object"!=typeof t.defaultMatches&&Ga()(!1),"object"!=typeof window?(n=void 0!==t.defaultMatches?t.defaultMatches:!!t.query||Object.keys(a.props.queries).reduce((function(e,t){var a;return La({},e,((a={})[t]=!0,a))}),{}),a.state={matches:n},Ha(a)):(a.initialize(),a.state={matches:void 0!==a.props.defaultMatches?a.props.defaultMatches:a.getMatches()},a.onChange(),a)}a=e,(t=n).prototype=Object.create(a.prototype),t.prototype.constructor=t,t.__proto__=a;var l=n.prototype;return l.initialize=function(){var e=this,t=this.props.targetWindow||window;"function"!=typeof t.matchMedia&&Ga()(!1);var a=this.props.queries||{__DEFAULT__:this.props.query};this.queries=Object.keys(a).map((function(n){var l=a[n],o="string"!=typeof l?Ja()(l):l;return{name:n,mqListener:new Ya(t,o,e.updateMatches)}}))},l.componentDidMount=function(){this.initialize(),void 0!==this.props.defaultMatches&&this.updateMatches()},l.onChange=function(){var e=this.props.onChange;e&&e(this.state.matches)},l.componentWillUnmount=function(){this.queries.forEach((function(e){return e.mqListener.cancel()}))},l.render=function(){var e=this.props,t=e.children,a=e.render,n=this.state.matches,l="object"==typeof n?Object.keys(n).some((function(e){return n[e]})):n;return a?l?a(n):null:t?"function"==typeof t?t(n):(!Array.isArray(t)||t.length)&&l?g.a.Children.only(t)&&"string"==typeof g.a.Children.only(t).type?g.a.Children.only(t):g.a.cloneElement(g.a.Children.only(t),{matches:n}):null:null},n}(g.a.Component);Ua($a,"propTypes",{defaultMatches:w.a.oneOfType([w.a.bool,w.a.objectOf(w.a.bool)]),query:Za,queries:w.a.objectOf(Za),render:w.a.func,children:w.a.oneOfType([w.a.node,w.a.func]),targetWindow:w.a.object,onChange:w.a.func});var Xa=$a,Qa=function(e){var t,a=e.children,n=e.minWidth,l=e.maxWidth;if(n&&l){var o=parseInt(re[l],10)-1+"px";t="(min-width: ".concat(re[n],") and (max-width: ").concat(o,")")}else if(l){var r=parseInt(re[l],10)-1+"px";t="(max-width: ".concat(r,")")}else t="(min-width: ".concat(re[n],")");return g.a.createElement(Xa,{query:t},a)};Qa.displayName="Respond",Qa.propTypes={children:w.a.node,minWidth:w.a.oneOf(["sm","md","lg","xl"]),maxWidth:w.a.oneOf(["sm","md","lg","xl"])},Qa.defaultProps={children:null,minWidth:void 0,maxWidth:void 0},Qa.__docgenInfo={description:"",methods:[],displayName:"Respond",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},minWidth:{defaultValue:{value:"undefined",computed:!0},type:{name:"enum",value:[{value:"'sm'",computed:!1},{value:"'md'",computed:!1},{value:"'lg'",computed:!1},{value:"'xl'",computed:!1}]},required:!1,description:""},maxWidth:{defaultValue:{value:"undefined",computed:!0},type:{name:"enum",value:[{value:"'sm'",computed:!1},{value:"'md'",computed:!1},{value:"'lg'",computed:!1},{value:"'xl'",computed:!1}]},required:!1,description:""}}};var en=Qa,tn=function(e){var t=e.style;return g.a.createElement("span",{className:"wds-slider__fill",style:t}," ")};tn.displayName="ProgressBar",tn.propTypes={style:w.a.shape({left:w.a.oneOfType([w.a.number,w.a.string])}).isRequired},tn.__docgenInfo={description:"",methods:[],displayName:"ProgressBar",props:{style:{type:{name:"shape",value:{left:{name:"union",value:[{name:"number"},{name:"string"}],required:!1}}},required:!0,description:""}}};var an,nn=tn,ln=0,on=100,rn=function(e,t,a){return(e-t)/(a-t)*100},dn=function(e,t,a){var n=e/100;return 0===e?t:100===e?a:Math.round((a-t)*n+t)},un=function(e,t){return t.length?t.reduce((function(t,a){return Math.abs(t-e)<Math.abs(a-e)?t:a})):e},sn=function(e){return Number(e.currentTarget.getAttribute("data-handle-key"))},cn=function(e){e.stopPropagation(),e.preventDefault()},pn=(a(37),a(93),function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"onMouseEnter",(function(){var e=a.props,t=e.disableHover,n=e.alwaysShow;if(!t&&!n){if(a.props.delay)return void(an=setTimeout(function(){this.setState({show:!0}),this.change(!0)}.bind(p()(a)),800));a.setState({show:!0}),a.change(!0)}})),v()(p()(a),"onMouseLeave",(function(){var e=a.props,t=e.disableHover,n=e.alwaysShow;a.props.delay&&clearTimeout(an),t||n||(a.setState({show:!1}),a.change(!1))})),v()(p()(a),"getSlideDirection",(function(){var e=a.props.placement;return e&&"top"!==e?"bottom"===e?"down":"left"===e?"left":"right":"up"})),v()(p()(a),"handleScroll",(function(){a.state.show&&a.props.renderTo&&a.updatePosition()})),v()(p()(a),"showTooltip",(function(e){a.setState({show:e}),a.change(e)})),v()(p()(a),"handleClick",(function(){var e=a.props,t=e.alwaysShow,n=e.show;t||(n&&a.showTooltip(!1),a.showTooltip(!0))})),v()(p()(a),"updatePosition",(function(){if(a.tooltip&&a.state.show&&a.tooltipContent.children&&a.tooltipContent.children.length){var e,t,n=a.tooltip.getBoundingClientRect(),l=a.tooltipContent.children[0].getBoundingClientRect();if("top"===a.props.placement){var o=parseInt(Rt.tooltip["tooltip__pip-size"],10)-parseInt(Rt.space["space--1"],10);e=n.top-l.height-n.height/2-o,t=n.left+n.width/2}else if("left"===a.props.placement){var r=parseInt(Rt.tooltip["tooltip__pip-size"],10)+parseInt(Rt.space["space--1"],10);e=n.top+n.height/2,t=n.left-(2*l.width+r)}else"right"===a.props.placement?(e=n.top+n.height/2,t=n.left+n.width):(e=n.bottom,t=n.left+n.width/2);a.setState({tooltipStyle:{top:"".concat(e,"px"),left:"".concat(t,"px"),zIndex:Rt["z-index"]["z--space"]+1,position:"fixed",bottom:"auto"}})}})),v()(p()(a),"tooltipRef",(function(e){return a.tooltip=e})),a.state={show:e.show},a}return f()(t,e),r()(t,[{key:"componentDidMount",value:function(){this.state.show&&this.props.renderTo&&this.updatePosition(),this.props.disableHover&&jt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillUpdate",value:function(e,t){jt&&(t.show?window.addEventListener("mousemove",this.mousemove):window.removeEventListener("mousemove",this.mousemove))}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.props.renderTo&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){this.props.disableHover&&this.props.renderTo&&jt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll))}},{key:"change",value:function(e){var t=this.props,a=t.onChange;t.renderTo&&e&&this.updatePosition(),a&&a(e)}},{key:"renderTooltipContent",value:function(){var e=this,t=this.props,a=t.delay,n=t.hideCaret,l=t.text,o=t.placement,r=t.renderTo,i=t.alwaysShow,d=x()(t,["delay","hideCaret","text","placement","renderTo","alwaysShow"]),u=N()("wds-tooltip--".concat(o),"wds-tooltip",{"wds-tooltip--show":this.state.show||i},{"wds-tooltip--delay":a},{"wds-tooltip--no-caret":n}),s=g.a.createElement("span",{className:u,style:this.state.tooltipStyle,"data-testid":d["data-testid"],ref:function(t){return e.tooltipContent=t},role:"tooltip"},g.a.createElement("span",{className:"wds-tooltip__body"},l));return r?Mt.a.createPortal(s,r):s}},{key:"render",value:function(){var e=this.props,t=e.children,a=e.disableHover,n=t.props,l=void 0===n?{}:n,o=N()("wds-has-tooltip",{"wds-has-tooltip--disable-hover":a},{"wds-has-tooltip--stretched":l.stretched});return g.a.createElement("span",{className:o,onMouseLeave:this.onMouseLeave,onBlur:this.onMouseLeave,onClick:a?this.handleClick:void 0,onKeyDown:a?this.handleClick:void 0,ref:this.tooltipRef,role:"button",tabIndex:0},this.renderTooltipContent(),g.a.createElement("span",{className:"wds-tooltip__trigger",onMouseEnter:this.onMouseEnter,onFocus:this.onMouseEnter},t))}}]),t}(y.Component));pn.displayName="Tooltip",pn.propTypes={children:w.a.node.isRequired,delay:w.a.bool,hideCaret:w.a.bool,placement:w.a.oneOf(H),text:w.a.node.isRequired,show:w.a.bool,disableHover:w.a.bool,"data-testid":w.a.string,renderTo:w.a.oneOfType([w.a.func,w.a.shape({current:w.a.elementType})]),onChange:w.a.func,alwaysShow:w.a.bool},pn.defaultProps={delay:!1,hideCaret:!1,placement:"top",show:!1,disableHover:!1,"data-testid":void 0,renderTo:null,onChange:function(){return null},alwaysShow:null},pn.__docgenInfo={description:"",methods:[{name:"onMouseEnter",docblock:null,modifiers:[],params:[],returns:null},{name:"onMouseLeave",docblock:null,modifiers:[],params:[],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"showTooltip",docblock:null,modifiers:[],params:[{name:"val",type:null}],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"change",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null},{name:"tooltipRef",docblock:null,modifiers:[],params:[{name:"tooltip",type:null}],returns:null},{name:"renderTooltipContent",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Tooltip",props:{delay:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},hideCaret:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"'top'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disableHover:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},onChange:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},alwaysShow:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},text:{type:{name:"node"},required:!0,description:""}}};var mn=pn,fn=function(e){function t(e){var a;l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"getPublicState",(function(){var e=a.props,t=e.min;return{max:e.max,min:t,values:a.state.values}})),v()(p()(a),"getSliderBoundingBox",(function(){var e=p()(a).slider,t=e.getDOMNode?e.getDOMNode():e,n=t.getBoundingClientRect();return{height:n.height||t.clientHeight,left:n.left,top:n.top,width:n.width||t.clientWidth}})),v()(p()(a),"getMinValue",(function(e){var t=a.props.min,n=a.state.values;return n[e-1]?Math.max(t,n[e-1]):t})),v()(p()(a),"getMaxValue",(function(e){var t=a.props.max,n=a.state.values;return n[e+1]?Math.min(t,n[e+1]):t})),v()(p()(a),"getHandleDimensions",(function(e,t){var a=e.currentTarget||null;return a?a.clientWidth/t.width*on/2:0})),v()(p()(a),"getSnapPosition",(function(e){var t=a.props,n=t.max,l=t.min,o=t.snap,r=t.snapPoints;if(!o)return e;var i=dn(e,l,n),d=un(i,r);return rn(d,l,n)})),v()(p()(a),"getNextPositionForKey",(function(e,t){var n,l=a.state,o=l.handlePos,r=l.values,i=a.props,d=i.max,u=i.min,s=i.snapPoints,c=i.snap,p=r[e],m=o[e],f=m,h=1;d>=100?m=Math.round(m):h=100/(d-u);var y=null;c&&(y=s.indexOf(un(r[e],s)));var g=(n={},v()(n,J.LEFT,(function(e){return-1*e})),v()(n,J.RIGHT,(function(e){return 1*e})),v()(n,J.UP,(function(e){return 1*e})),v()(n,J.DOWN,(function(e){return-1*e})),v()(n,J.PAGE_DOWN,(function(e){return e>1?-e:-10*e})),v()(n,J.PAGE_UP,(function(e){return e>1?e:10*e})),n);if(Object.prototype.hasOwnProperty.call(g,t))m+=g[t](h),c&&(m>f?y<s.length-1&&(p=s[y+1]):y>0&&(p=s[y-1]));else if(t===J.HOME){if(m=ln,c)p=at()(s,1)[0]}else{if(t!==J.END)return null;m=on,c&&(p=s[s.length-1])}return c?rn(p,u,d):m})),v()(p()(a),"setStartSlide",(function(e){var t=a.getSliderBoundingBox();a.setState({handleDimensions:a.getHandleDimensions(e,t),sliderBox:t,slidingIndex:sn(e)})})),v()(p()(a),"setRef",(function(e){a.slider=e})),v()(p()(a),"getProgressStyle",(function(e){var t=a.state.handlePos,n=t[e],l=t[e-1],o=n-l;return 0===e?{left:0,width:"".concat(n,"%")}:{left:"".concat(l,"%"),width:"".concat(o,"%")}})),v()(p()(a),"getNextState",(function(e,t){var n=a.state.handlePos,l=a.props,o=l.max,r=l.min,i=a.validatePosition(e,t),d=n.map((function(t,a){return a===e?i:t}));return{handlePos:d,values:d.map((function(e){return dn(e,r,o)}))}})),v()(p()(a),"getClosestHandle",(function(e){var t=a.state.handlePos;return t.reduce((function(a,n,l){return Math.abs(t[l]-e)<Math.abs(t[a]-e)?l:a}),0)})),v()(p()(a),"updateNewValues",(function(e){var t=e.max,n=e.min,l=e.values,o=a.validateValues(l,e);a.setState({handlePos:o.map((function(e){return rn(e,n,t)})),values:o},(function(){return a.fireChangeEvent()}))})),v()(p()(a),"fireChangeEvent",(function(){var e=a.props.onChange;e&&e(a.getPublicState())})),v()(p()(a),"canMove",(function(e,t){var n=a.state,l=n.handlePos,o=n.handleDimensions;return!(t<ln)&&(!(t>on)&&(!(t>(void 0!==l[e+1]?l[e+1]-o:1/0))&&t>=(void 0!==l[e-1]?l[e-1]+o:-1/0)))})),v()(p()(a),"validateValues",(function(e,t){var n=t||a.props,l=n.max,o=n.min;return e.map((function(e,t,a){var n=Math.max(Math.min(e,l),o);return n=isNaN(n)?o:n,a.length&&n<a[t-1]?a[t-1]:n}))})),v()(p()(a),"validatePosition",(function(e,t){var n=a.state,l=n.handlePos,o=n.handleDimensions;return Math.max(Math.min(t,void 0!==l[e+1]?l[e+1]-o:on),void 0!==l[e-1]?l[e-1]+o:ln)})),v()(p()(a),"handleKeydown",(function(e){var t=sn(e);if(e.keyCode!==J.ESC){var n=a.getNextPositionForKey(t,e.keyCode);null!==n&&(a.canMove(t,n)&&a.slideTo(t,n,(function(){return a.fireChangeEvent()})),cn(e))}else e.currentTarget.blur()})),v()(p()(a),"handleClick",(function(e){if(!e.target.getAttribute("data-handle-key")){var t=a.getSliderBoundingBox(),n=(e.clientX-t.left)/t.width*on,l=a.getClosestHandle(n),o=a.getSnapPosition(n);a.slideTo(l,o,(function(){return a.fireChangeEvent()}))}})),v()(p()(a),"endSlide",(function(){var e=a.props.snap,t=a.state,n=t.slidingIndex,l=t.handlePos;if(a.setState({slidingIndex:null}),"function"==typeof document.removeEventListener?(document.removeEventListener("mouseup",a.endSlide,!1),document.removeEventListener("touchend",a.endSlide,!1),document.removeEventListener("touchmove",a.handleTouchSlide,!1),document.removeEventListener("mousemove",a.handleMouseSlide,!1)):(document.detachEvent("onmousemove",a.handleMouseSlide),document.detachEvent("onmouseup",a.endSlide)),e){var o=a.getSnapPosition(l[n]);a.slideTo(n,o,(function(){return a.fireChangeEvent()}))}else a.fireChangeEvent()})),v()(p()(a),"handleSlide",(function(e){var t=a.state,n=t.slidingIndex,l=t.sliderBox,o=(e-l.left)/l.width*on;a.slideTo(n,o)})),v()(p()(a),"handleTouchSlide",(function(e){if(null!==a.state.slidingIndex)if(e.changedTouches.length>1)a.endSlide();else{var t=e.changedTouches[0];a.handleSlide(t.clientX,t.clientY),cn(e)}})),v()(p()(a),"handleMouseSlide",(function(e){null!==a.state.slidingIndex&&(a.handleSlide(e.clientX,e.clientY),cn(e))})),v()(p()(a),"startTouchSlide",(function(e){if(!(e.changedTouches.length>1)){var t=e.changedTouches[0];a.setStartSlide(e,t.clientX,t.clientY),document.addEventListener("touchmove",a.handleTouchSlide,!1),document.addEventListener("touchend",a.endSlide,!1),cn(e)}})),v()(p()(a),"startMouseSlide",(function(e){a.setStartSlide(e,e.clientX,e.clientY),"function"==typeof document.addEventListener?(document.addEventListener("mousemove",a.handleMouseSlide,!1),document.addEventListener("mouseup",a.endSlide,!1)):(document.attachEvent("onmousemove",a.handleMouseSlide),document.attachEvent("onmouseup",a.endSlide)),cn(e)})),v()(p()(a),"slideTo",(function(e,t,n){var l=a.getNextState(e,t);a.setState(l,(function(){n&&n()}))}));var n=a.props,o=n.max,r=n.min,i=n.values;return a.state={handlePos:i.map((function(e){return rn(e,r,o)})),handleDimensions:0,sliderBox:{},slidingIndex:null,values:i},a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.props,a=t.disabled,n=t.min,l=t.max,o=t.controlled,r=this.state,i=r.values,d=r.slidingIndex;if(!1!==o){var u=e.min!==n||e.max!==l,s=i.length!==e.values.length||i.some((function(t,a){return e.values[a]!==t})),c=e.disabled&&!a;(u||s)&&this.updateNewValues(e),c&&null!==d&&this.endSlide()}}},{key:"render",value:function(){var e=this,t=this.props,a=t.disabled,n=t.showTooltip,l=t.tooltipValue,o=t.alwaysShowTooltip,r=this.state,i=r.handlePos,d=r.values;return g.a.createElement("div",{className:"wds-slider",ref:this.setRef,onClick:a?void 0:this.handleClick,"data-testid":this.props["data-testid"]},g.a.createElement("div",{className:"wds-slider__track"},i.map((function(t,r){return g.a.createElement("button",{"aria-valuemax":e.getMaxValue(r),"aria-valuemin":e.getMinValue(r),"aria-valuenow":d[r],"aria-disabled":a,"data-handle-key":r,className:"wds-slider__handle",key:"handle-".concat(r),onClick:e.killEvent,onKeyDown:a?void 0:e.handleKeydown,onMouseDown:a?void 0:e.startMouseSlide,onTouchStart:a?void 0:e.startTouchSlide,role:"slider",style:{left:"".concat(t,"%")},tabIndex:0,"data-testid":e.props["data-testid"]?"".concat(e.props["data-testid"],"_SliderHandle"):void 0},(n||o)&&g.a.createElement(mn,{text:l?l(d[r]):d[r],alwaysShow:o},g.a.createElement("div",{className:"wds-slider__handle-fill"})))})),i.map((function(t,a,n){return 0===a&&n.length>1||!1===e.props.range?null:g.a.createElement(nn,{key:"progress-bar-".concat(a),style:e.getProgressStyle(a)})})),this.props.children&&g.a.createElement("ul",{className:"wds-slider__steps"},this.props.children)))}}]),t}(g.a.Component);fn.displayName="Slider",fn.propTypes={children:w.a.node,disabled:w.a.bool,max:w.a.number.isRequired,min:w.a.number.isRequired,onChange:w.a.func,snap:w.a.bool,snapPoints:w.a.arrayOf(w.a.number),range:w.a.bool,values:w.a.arrayOf(w.a.number).isRequired,controlled:w.a.bool,showTooltip:w.a.bool,tooltipValue:w.a.func,alwaysShowTooltip:w.a.bool,"data-testid":w.a.string},fn.defaultProps={children:null,disabled:!1,onChange:null,snap:!1,snapPoints:[],range:!0,controlled:!1,showTooltip:!1,tooltipValue:void 0,alwaysShowTooltip:!1,"data-testid":void 0},fn.__docgenInfo={description:"",methods:[{name:"getPublicState",docblock:null,modifiers:[],params:[],returns:null},{name:"getSliderBoundingBox",docblock:null,modifiers:[],params:[],returns:null},{name:"getMinValue",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getMaxValue",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getHandleDimensions",docblock:null,modifiers:[],params:[{name:"ev",type:null},{name:"sliderBox",type:null}],returns:null},{name:"getSnapPosition",docblock:null,modifiers:[],params:[{name:"positionPercent",type:null}],returns:null},{name:"getNextPositionForKey",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"keyCode",type:null}],returns:null},{name:"setStartSlide",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"setRef",docblock:null,modifiers:[],params:[{name:"ref",type:null}],returns:null},{name:"getProgressStyle",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getNextState",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"getClosestHandle",docblock:null,modifiers:[],params:[{name:"positionPercent",type:null}],returns:null},{name:"updateNewValues",docblock:null,modifiers:[],params:[{name:"nextProps",type:null}],returns:null},{name:"fireChangeEvent",docblock:null,modifiers:[],params:[],returns:null},{name:"canMove",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"validateValues",docblock:null,modifiers:[],params:[{name:"proposedValues",type:null},{name:"props",type:null}],returns:null},{name:"validatePosition",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"handleKeydown",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"endSlide",docblock:null,modifiers:[],params:[],returns:null},{name:"handleSlide",docblock:null,modifiers:[],params:[{name:"x",type:null}],returns:null},{name:"handleTouchSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"handleMouseSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"startTouchSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"startMouseSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"slideTo",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null},{name:"onAfterSet",type:null}],returns:null}],displayName:"Slider",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},snap:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},snapPoints:{defaultValue:{value:"[]",computed:!1},type:{name:"arrayOf",value:{name:"number"}},required:!1,description:""},range:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},controlled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},showTooltip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},tooltipValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},alwaysShowTooltip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},max:{type:{name:"number"},required:!0,description:""},min:{type:{name:"number"},required:!0,description:""},values:{type:{name:"arrayOf",value:{name:"number"}},required:!0,description:""}}};var hn=fn,vn=function(e){var t=e.children;return g.a.createElement("li",{className:"wds-slider__step"},t&&g.a.createElement("span",{className:"wds-label wds-label--muted"},t))};vn.displayName="Step",vn.propTypes={children:w.a.node},vn.defaultProps={children:null},vn.__docgenInfo={description:"",methods:[],displayName:"Step",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""}}};var yn=vn,gn=(a(94),function(e){var t=e.className,a=e.checked,n=e.defaultChecked,l=e.disabled,o=e.innerRef,r=e.onChange,i=e.id,d=x()(e,["className","checked","defaultChecked","disabled","innerRef","onChange","id"]),u=Object(y.useState)(!!n),s=at()(u,2),c=s[0],p=s[1],m=Object(y.useState)(!1),f=at()(m,2),h=f[0],v=f[1],b=it({isChecked:c},a&&{isChecked:a}).isChecked,w=N()("wds-switch__native",t),_=N()("wds-switch",{"wds-switch--focused":h}),q=i||lt()(),C=function(){v(!h)};return g.a.createElement("div",{className:_},g.a.createElement("input",{onFocus:C,onBlur:C,role:"switch","aria-checked":b,checked:b,className:w,disabled:l,id:q,onChange:function(e){p(!b),e.persist(),r&&r(e)},tabIndex:l?-1:0,type:"checkbox",ref:o,"data-testid":d["data-testid"]}),g.a.createElement("span",{className:"wds-switch__faux"}))});gn.displayName="Switch",gn.propTypes={checked:w.a.bool,className:w.a.string,defaultChecked:w.a.bool,disabled:w.a.bool,id:w.a.string,onChange:w.a.func,innerRef:w.a.func,"data-testid":w.a.string},gn.defaultProps={checked:void 0,className:null,defaultChecked:!1,disabled:!1,id:null,onChange:void 0,innerRef:null,"data-testid":void 0},gn.__docgenInfo={description:"",methods:[],displayName:"Switch",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onChange:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var bn=gn;a(95);function wn(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}var _n=function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"handleBlur",(function(e){a.props.onBlur&&a.props.onBlur(e)})),v()(p()(a),"handleChange",(function(e){a.state.isControlled&&e.target.value!==a.state.value&&(e.persist(),a.setState({value:e.target.value},(function(){a.props.onChange&&a.props.onChange(e)})))})),v()(p()(a),"renderLabel",(function(){return a.props.label?g.a.createElement(Ct,{className:"",htmlFor:a.inputID},a.props.label):null})),a.state={isControlled:rt(e.value),value:e.value},a.inputID=e.id||lt()(),a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.value!==this.state.value&&this.setState({value:e.value})}},{key:"render",value:function(){var e=this.props,t=e.className,a=e.disabled,n=(e.label,e.name),l=(e.onBlur,e.onChange,e.size),o=e.stretched,r=e.color,i=x()(e,["className","disabled","label","name","onBlur","onChange","size","stretched","color"]),d=N()("wds-textarea","wds-textarea--".concat(l),v()({},"wds-textarea--".concat(r),r),{"wds-textarea--stretched":o},t),u=function(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?wn(Object(a),!0).forEach((function(t){v()(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):wn(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}({},i,{value:this.state.value});return g.a.createElement(y.Fragment,null,this.renderLabel(),g.a.createElement("textarea",Object.assign({className:d,disabled:a,id:this.inputID,name:n,onBlur:this.handleBlur,onChange:this.handleChange},u)))}}]),t}(g.a.Component);_n.displayName="Textarea",_n.propTypes={className:w.a.string,disabled:w.a.bool,id:w.a.string,label:w.a.node,name:w.a.string,onBlur:w.a.func,onChange:w.a.func,size:w.a.oneOf(A),stretched:w.a.bool,color:w.a.oneOf(ae),value:w.a.node},_n.defaultProps={className:null,disabled:!1,id:null,label:null,name:null,onBlur:null,onChange:null,size:"md",stretched:!1,color:null,value:void 0},_n.__docgenInfo={description:"",methods:[{name:"handleBlur",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"renderLabel",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Textarea",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputColors"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""}}};var xn=_n,qn=(a(23),function(e){var t;return"info"===e?t=Se:"warning"===e?t=Ie:"success"===e?t=Re:"upgrade"===e&&(t=Be),g.a.createElement("span",{className:"wds-toast__icon"},g.a.createElement(t,null))});qn.displayName="toastIcon";var Nn=function(e){var t=e.onClose,a=e.autoClose,n=e.children,l=e.dismissible,o=e.color,r=e.className,i=e.show,d=x()(e,["onClose","autoClose","children","dismissible","color","className","show"]),u=N()("wds-toast",v()({},"wds-toast--".concat(o),o),r),s=Object(y.useState)(null),c=at()(s,2),p=c[0],m=c[1],f=Object(y.useState)(!1),h=at()(f,2),b=h[0],w=h[1],_=Object(y.useState)(!0),q=at()(_,2),C=q[0],E=q[1],V=function(){E(!0),m(setInterval((function(){return k()}),3e3))},k=function(){clearInterval(p),E(!1),t?t():a&&w(!0)};Object(y.useEffect)((function(){a&&i?V():clearInterval(p)}),[i]);var O=i&&!b,P=d["data-testid"]?"".concat(d["data-testid"],"_Close"):void 0;return g.a.createElement(ce.Slide,{in:O,distance:"far"},g.a.createElement("div",{onMouseEnter:function(){a&&p&&C&&clearInterval(p)},onMouseLeave:function(){a&&p&&C&&V()},className:u,"data-testid":d["data-testid"]},l&&g.a.createElement(ye,{onClick:k,ariaLabel:d.ariaLabel,variant:"light","data-testid":P}),o&&qn(o),n))};Nn.displayName="Toast",Nn.propTypes={autoClose:w.a.bool,children:w.a.node.isRequired,dismissible:w.a.bool,onClose:w.a.func,color:w.a.oneOf(["info","warning","upgrade","success"]),ariaLabel:w.a.string,show:w.a.bool,className:w.a.string,"data-testid":w.a.string},Nn.defaultProps={autoClose:!0,dismissible:!1,onClose:null,color:null,ariaLabel:"Close Toast",className:"",show:!0,"data-testid":void 0},Nn.__docgenInfo={description:"",methods:[],displayName:"Toast",props:{autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"toastColors"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Toast'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Cn=Nn,En=function(e){return g.a.createElement("div",{className:"wds-toast__body","data-testid":e["data-testid"]},e.children)};En.displayName="ToastBody",En.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},En.defaultProps={"data-testid":void 0},En.__docgenInfo={description:"",methods:[],displayName:"ToastBody",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Vn=En,kn=function(e){return g.a.createElement("div",{className:"wds-toast__footer","data-testid":e["data-testid"]},e.children)};kn.displayName="ToastFooter",kn.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},kn.defaultProps={"data-testid":void 0},kn.__docgenInfo={description:"",methods:[],displayName:"ToastFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var On=kn,Pn=function(e){return g.a.createElement("div",{className:"wds-toast__title","data-testid":e["data-testid"]},e.children)};Pn.displayName="ToastTitle",Pn.propTypes={children:w.a.node.isRequired,"data-testid":w.a.string},Pn.defaultProps={"data-testid":void 0},Pn.__docgenInfo={description:"",methods:[],displayName:"ToastTitle",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Tn=Pn,Sn=(a(38),function(e){function t(e){var a;return l()(this,t),a=d()(this,s()(t).call(this,e)),v()(p()(a),"getSelectedIndex",(function(e,t){var a=g.a.Children.map(e,(function(e,t){return g.a.isValidElement(e)&&e.props.selected?t:null}));return isNaN(a[0])?t||0:a[0]})),v()(p()(a),"bindSelectedTab",(function(e){a.selectedTab=e})),v()(p()(a),"handleChange",(function(e,t,n){t!==a.state.value&&(a.setState({value:t}),a.props.onChange&&a.props.onChange(t,n))})),a.state={value:a.getSelectedIndex(e.children)},a}return f()(t,e),r()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.props.children,a=this.getSelectedIndex(e.children);a!==this.getSelectedIndex(t)&&this.setState({value:a})}},{key:"componentDidUpdate",value:function(e,t){t.value!==this.state.value&&this.selectedTab.focus()}},{key:"getClassNames",value:function(){var e=this.props,t=e.color,a=e.align;return N()("wds-tab","wds-tab--".concat(t),"wds-tab--".concat(a))}},{key:"renderTabElement",value:function(e,t,a,n){var l=a?this.bindSelectedTab:null;return g.a.cloneElement(e,{selected:a,onChange:this.handleChange,value:t,children:e.props.title,id:n,key:n,innerRef:l})}},{key:"renderPaneElement",value:function(e,t,a,n){var l=t?{transparent:!0}:{padding:!0},o=N()({"wds-tab__pane":!0,"wds-tab__pane--hide":!n,"wds-tab__pane--show":n});return g.a.createElement("div",{key:a,className:o,"labelled-by":a,"aria-hidden":!n||null},g.a.createElement(R,l,e))}},{key:"render",value:function(){var e=this,t=this.props,a=t.fullWidth,n=t.children,l=[],o=[];return g.a.Children.forEach(n,(function(t,n){if(g.a.isValidElement(t)){var r=t.props.id||"tab-".concat(n,"-").concat(lt()()),i=n===e.state.value;l.push(e.renderTabElement(t,n,i,r)),t.props.children&&o.push(e.renderPaneElement(t.props.children,a,r,i))}})),g.a.createElement("div",{className:this.getClassNames(),"data-testid":this.props["data-testid"]},g.a.createElement("ul",{role:"tablist",className:"wds-tab__tabs"},l),g.a.createElement("div",{className:"wds-tab__panes"},o))}}]),t}(g.a.Component));Sn.displayName="Tabs",Sn.propTypes={align:w.a.oneOf(["left","right","even","center"]),children:w.a.node.isRequired,fullWidth:w.a.bool,onChange:w.a.func,color:w.a.oneOf(["primary","light","dark","transparent"]),"data-testid":w.a.string},Sn.defaultProps={align:"left",fullWidth:!1,onChange:null,color:"light","data-testid":void 0},Sn.__docgenInfo={description:"",methods:[{name:"getSelectedIndex",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"defaultIndex",type:null}],returns:null},{name:"getClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"bindSelectedTab",docblock:null,modifiers:[],params:[{name:"tab",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null},{name:"value",type:null},{name:"id",type:null}],returns:null},{name:"renderTabElement",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null},{name:"id",type:null}],returns:null},{name:"renderPaneElement",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"fullWidth",type:null},{name:"id",type:null},{name:"selected",type:null}],returns:null}],displayName:"Tabs",props:{align:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",value:[{value:"'left'",computed:!1},{value:"'right'",computed:!1},{value:"'even'",computed:!1},{value:"'center'",computed:!1}]},required:!1,description:""},fullWidth:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"'light'",computed:!1},type:{name:"enum",computed:!0,value:"TabColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Fn=Sn,In=function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"getOuterTabClasses",(function(){var e=a.props,t=e.selected,n=e.disabled;return N()("wds-tab__tab",{"wds-tab__tab--selected":t},{"wds-tab__tab--disabled":n})})),v()(p()(a),"handleChange",(function(e){var t=a.props;(0,t.onChange)(e,t.value,t.id)})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e=this.props,t=e.disabled,a=e.value,n=e.selected,l=e.id,o=e.innerRef;return g.a.createElement("li",{className:this.getOuterTabClasses()},g.a.createElement("button",{disabled:t,value:a,role:"tab",tabIndex:t?-1:0,"aria-selected":n,className:"wds-tab__tab-btn",onClick:this.handleChange,id:l,ref:o,"data-testid":this.props["data-testid"]},this.props.children))}}]),t}(g.a.Component);In.displayName="Tab",In.propTypes={children:w.a.oneOfType([w.a.node,w.a.string]),disabled:w.a.bool,id:w.a.string,innerRef:w.a.func,onChange:w.a.func,selected:w.a.bool,value:w.a.oneOfType([w.a.number,w.a.string]),"data-testid":w.a.string},In.defaultProps={children:"",disabled:!1,id:null,innerRef:null,onChange:null,selected:!1,value:0,"data-testid":void 0},In.__docgenInfo={description:"",methods:[{name:"getOuterTabClasses",docblock:null,modifiers:[],params:[],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null}],displayName:"Tab",props:{children:{defaultValue:{value:"''",computed:!1},type:{name:"union",value:[{name:"node"},{name:"string"}]},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},selected:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},value:{defaultValue:{value:"0",computed:!1},type:{name:"union",value:[{name:"number"},{name:"string"}]},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var Mn=In,Rn=(a(19),function(e){var t=e.children,a=e.xScroll,n=e.className,l=x()(e,["children","xScroll","className"]),o=N()({"wds-table":!0,"wds-table--x-scroll":a},n);return g.a.createElement("div",{className:o},g.a.createElement("table",{"data-testid":l["data-testid"]},t))});Rn.displayName="Table",Rn.propTypes={children:w.a.node.isRequired,xScroll:w.a.bool,className:w.a.string,"data-testid":w.a.string},Rn.defaultProps={xScroll:!1,className:"","data-testid":void 0},Rn.__docgenInfo={description:"",methods:[],displayName:"Table",props:{xScroll:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:"Allows the table to scroll on its x-axis."},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the table, normally `TableHeader` and `TableBody`."}}};var zn=Rn,Bn=function(e){var t=e.children,a=e.className,n=x()(e,["children","className"]);return g.a.createElement("tbody",Object.assign({className:a},n),g.a.Children.map(t,(function(e){if(e)return g.a.cloneElement(e,{parent:"TableBody"})})))};Bn.displayName="TableBody",Bn.propTypes={children:w.a.node.isRequired,className:w.a.string,"data-testid":w.a.string},Bn.defaultProps={className:"","data-testid":void 0},Bn.__docgenInfo={description:"",methods:[],displayName:"TableBody",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var jn=Bn,Dn=function(e){var t=e.children,a=e.className,n=x()(e,["children","className"]);return g.a.createElement("thead",{className:a,"data-testid":n["data-testid"]},g.a.Children.map(t,(function(e){if(e)return g.a.cloneElement(e,{parent:"TableHeader"})})))};Dn.displayName="TableHeader",Dn.propTypes={children:w.a.node.isRequired,className:w.a.string,"data-testid":w.a.string},Dn.defaultProps={className:"","data-testid":void 0},Dn.__docgenInfo={description:"",methods:[],displayName:"TableHeader",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var An=Dn,Ln=function(e){var t,a=e.numeric,n=e.variant,l=e.scope,o=e.className,r=e.parent,i=e.color,d=e.marked,u=e.children,s=x()(e,["numeric","variant","scope","className","parent","color","marked","children"]),c=N()(o,(t={"wds-table__cell":!0,"wds-table__cell--numeric":a,"wds-table__cell--more-action":"more-actions"===n,"wds-table__cell--bulk-action":"bulk-actions"===n},v()(t,"wds-table__cell--marked-".concat(i),i),v()(t,"wds-table__cell--marked",d),t)),p="TableHeader"===r,m=p?"th":"td",f=!l&&p?"col":l;return g.a.createElement(m,Object.assign({className:c,scope:f},s),u)};Ln.displayName="TableCell",Ln.propTypes={children:w.a.node,className:w.a.string,color:w.a.oneOfType([w.a.oneOf(te),w.a.oneOf($)]),marked:w.a.bool,numeric:w.a.bool,parent:w.a.oneOf(["TableHeader","TableBody",null]),scope:w.a.string,variant:w.a.oneOf(["more-actions","bulk-actions",null])},Ln.defaultProps={children:null,className:"",color:null,marked:!1,numeric:!1,parent:null,scope:"",variant:null},Ln.__docgenInfo={description:"",methods:[],displayName:"TableCell",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:"The table cell contents."},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numeric:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:"If `true`, content will align to the right."},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"'TableBody'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"Specify the cell type.\nBy default, the TableHead, TableBody or TableFooter parent component set the value."},scope:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:"Set scope attribute."},variant:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'more-actions'",computed:!1},{value:"'bulk-actions'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"sets the padding of the cell based on purpose"}}};var Hn=Ln,Un=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m14.57 6.2844-6.04-6.04a.75.75 0 0 0 -1.0605 0l-6.04 6.04a.75.75 0 0 0 1.0605 1.0606l4.76-4.7597v12.64a.75.75 0 0 0 1.5 0v-12.6401l4.76 4.76a.75.75 0 1 0 1.06-1.0608z"})))};Un.displayName="IconArrowUp",Un.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},Un.defaultProps={title:"ArrowUp",color:null,size:null},Un.__docgenInfo={description:"",methods:[],displayName:"IconArrowUp",props:{title:{defaultValue:{value:"'ArrowUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wn=Un,Gn=function(e){return g.a.createElement(V,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),g.a.createElement("g",null,g.a.createElement("path",{d:"m14.57 8.655a.75.75 0 0 0 -1.0605 0l-4.76 4.76v-12.6403a.75.75 0 1 0 -1.5 0v12.64l-4.7595-4.7597a.75.75 0 0 0 -1.06 1.0606l6.04 6.04a.7514.7514 0 0 0 1.0606 0l6.04-6.04a.75.75 0 0 0 -.0006-1.0606z"})))};Gn.displayName="IconArrowDown",Gn.propTypes={title:w.a.string,color:w.a.string,size:w.a.string},Gn.defaultProps={title:"ArrowDown",color:null,size:null},Gn.__docgenInfo={description:"",methods:[],displayName:"IconArrowDown",props:{title:{defaultValue:{value:"'ArrowDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kn=Gn,Jn=function(e){function t(){var e,a;l()(this,t);for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return a=d()(this,(e=s()(t)).call.apply(e,[this].concat(o))),v()(p()(a),"handleKeyDown",(function(e){var t=a.props,n=t.onClick;t.isSortable&&e.keyCode===J.ENTER&&n(e)})),v()(p()(a),"renderSortArrow",(function(){var e=a.props,t=e.isSortable,n=e.sortDirection;return!!t&&("descending"==n?g.a.createElement(Wn,null):g.a.createElement(Kn,null))})),a}return f()(t,e),r()(t,[{key:"render",value:function(){var e,t=this.props,a=t.children,n=t.numeric,l=t.variant,o=t.scope,r=t.className,i=t.parent,d=t.color,u=t.marked,s=t.isSortable,c=t.isSorted,p=t.sortDirection,m=t.textWrap,f=t.labelSort,h=x()(t,["children","numeric","variant","scope","className","parent","color","marked","isSortable","isSorted","sortDirection","textWrap","labelSort"]),y=N()(r,(e={"wds-table__cell":!0,"wds-table__header-cell":!0,"wds-table__cell--nowrap":!m,"wds-table__cell--numeric":n,"wds-table__cell--more-action":"more-actions"===l,"wds-table__bulk-action":"bulk-actions"===l},v()(e,"wds-table__cell--marked-".concat(d),d),v()(e,"wds-table__cell--marked",u),v()(e,"wds-table__cell--sortable",s),v()(e,"wds-table__cell--sorted",c),e)),b="TableHeader"===i,w=b?"th":"td",_=!o&&b?"col":o;return g.a.createElement(w,Object.assign({className:y,scope:_,tabIndex:0,role:"columnheader","aria-sort":p,onKeyDown:this.handleKeyDown,title:f},h),a,s&&g.a.createElement("span",{className:"wds-table__sort-icon"},this.renderSortArrow()))}}]),t}(g.a.Component);Jn.displayName="TableHeaderCell",Jn.propTypes={children:w.a.node,className:w.a.string,color:w.a.oneOfType([w.a.oneOf(te),w.a.oneOf($)]),marked:w.a.bool,numeric:w.a.bool,parent:w.a.oneOf(["TableHeader",null]),scope:w.a.string,variant:w.a.oneOf(["more-actions","bulk-actions",null]),isSortable:w.a.bool,isSorted:w.a.bool,sortDirection:w.a.oneOf(["ascending","descending",null]),textWrap:w.a.bool,onClick:w.a.func.isRequired,labelSort:w.a.node},Jn.defaultProps={children:null,className:"",color:null,marked:!1,numeric:!1,parent:null,scope:"",variant:null,isSortable:!1,isSorted:!1,sortDirection:"ascending",textWrap:!1,labelSort:"Sort"},Jn.__docgenInfo={description:"",methods:[{name:"handleKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"renderSortArrow",docblock:null,modifiers:[],params:[],returns:null}],displayName:"TableHeaderCell",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numeric:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},scope:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'more-actions'",computed:!1},{value:"'bulk-actions'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},isSortable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isSorted:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},sortDirection:{defaultValue:{value:"'ascending'",computed:!1},type:{name:"enum",value:[{value:"'ascending'",computed:!1},{value:"'descending'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},textWrap:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},labelSort:{defaultValue:{value:"'Sort'",computed:!1},type:{name:"node"},required:!1,description:""},onClick:{type:{name:"func"},required:!0,description:""}}};var Yn=Jn,Zn=function(e){var t,a=e.className,n=e.children,l=e.color,o=e.marked,r=e.disabled,i=e.parent,d=e.onClick,u=x()(e,["className","children","color","marked","disabled","parent","onClick"]),s=N()(a,(t={"wds-table__row--disabled":r},v()(t,"wds-table__row--marked-".concat(l),l),v()(t,"wds-table__row--marked",o),t));return g.a.createElement("tr",Object.assign({onClick:d,className:s},u),g.a.Children.map(n,(function(e){if(g.a.isValidElement(e))return g.a.cloneElement(e,{parent:i})})))};Zn.displayName="TableRow",Zn.propTypes={className:w.a.string,children:w.a.node.isRequired,parent:w.a.oneOf(["TableHeader","TableBody",null]),disabled:w.a.bool,onClick:w.a.func,color:w.a.oneOfType([w.a.oneOf(te),w.a.oneOf($)]),marked:w.a.bool},Zn.defaultProps={className:"",parent:null,disabled:!1,onClick:function(){return null},color:null,marked:!1},Zn.__docgenInfo={description:"",methods:[],displayName:"TableRow",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"'TableBody'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"By default, the TableHead, or TableBody parent component sets the value."},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The table cell contents."}}};var $n=Zn,Xn=function(e){var t=e.children,a=e.className,n=x()(e,["children","className"]);return g.a.createElement("tfoot",{className:a,"data-testid":n["data-testid"]},g.a.Children.map(t,(function(e){if(e)return g.a.cloneElement(e,{parent:"TableFooter"})})))};Xn.displayName="TableFooter",Xn.propTypes={children:w.a.node.isRequired,className:w.a.string,"data-testid":w.a.string},Xn.defaultProps={className:"","data-testid":void 0},Xn.__docgenInfo={description:"",methods:[],displayName:"TableFooter",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var Qn=Xn;a.d(t,"Accordion",(function(){return j})),a.d(t,"AccordionItem",(function(){return se})),a.d(t,"ActionSheet",(function(){return Pe})),a.d(t,"Alert",(function(){return Ae})),a.d(t,"Avatar",(function(){return He})),a.d(t,"Badge",(function(){return _e})),a.d(t,"Banner",(function(){return Ge})),a.d(t,"Button",(function(){return Ze})),a.d(t,"ButtonGroup",(function(){return Xe})),a.d(t,"Card",(function(){return et})),a.d(t,"Checkbox",(function(){return ut})),a.d(t,"Coachmark",(function(){return ct})),a.d(t,"Container",(function(){return Ne})),a.d(t,"FormGroup",(function(){return mt})),a.d(t,"FormField",(function(){return ht})),a.d(t,"Grid",(function(){return yt})),a.d(t,"Row",(function(){return bt})),a.d(t,"Col",(function(){return _t})),a.d(t,"Icon",(function(){return qt})),a.d(t,"Input",(function(){return Vt})),a.d(t,"InputGroup",(function(){return Ot})),a.d(t,"InputGroupAddon",(function(){return Tt})),a.d(t,"Link",(function(){return Ft})),a.d(t,"List",(function(){return F})),a.d(t,"ListItem",(function(){return de})),a.d(t,"Menu",(function(){return At})),a.d(t,"MenuGroup",(function(){return Bt})),a.d(t,"MenuItem",(function(){return Ht})),a.d(t,"Modal",(function(){return Wt})),a.d(t,"ModalBody",(function(){return Kt})),a.d(t,"ModalFooter",(function(){return Yt})),a.d(t,"ModalHeader",(function(){return $t})),a.d(t,"Align",(function(){return Qt})),a.d(t,"Multiselect",(function(){return ta})),a.d(t,"MultiselectOption",(function(){return na})),a.d(t,"NumberPicker",(function(){return ua})),a.d(t,"PageHeader",(function(){return ca})),a.d(t,"Pagination",(function(){return _a})),a.d(t,"Pane",(function(){return R})),a.d(t,"Popout",(function(){return Ca})),a.d(t,"PopoutBody",(function(){return Va})),a.d(t,"PopoutAlign",(function(){return Oa})),a.d(t,"PopoutFooter",(function(){return Ta})),a.d(t,"PopoutHeader",(function(){return Fa})),a.d(t,"PopoutMasthead",(function(){return Ma})),a.d(t,"ProgressBar",(function(){return za})),a.d(t,"ProgressCircle",(function(){return ja})),a.d(t,"Radio",(function(){return Aa})),a.d(t,"Respond",(function(){return en})),a.d(t,"Select",(function(){return ga})),a.d(t,"Option",(function(){return ma})),a.d(t,"Sheet",(function(){return be})),a.d(t,"Slider",(function(){return hn})),a.d(t,"Step",(function(){return yn})),a.d(t,"getClosestSnapPoint",(function(){return un})),a.d(t,"Switch",(function(){return bn})),a.d(t,"Textarea",(function(){return xn})),a.d(t,"Tooltip",(function(){return mn})),a.d(t,"Toast",(function(){return Cn})),a.d(t,"ToastBody",(function(){return Vn})),a.d(t,"ToastFooter",(function(){return On})),a.d(t,"ToastTitle",(function(){return Tn})),a.d(t,"Tabs",(function(){return Fn})),a.d(t,"Tab",(function(){return Mn})),a.d(t,"Typography",(function(){return ke})),a.d(t,"Table",(function(){return zn})),a.d(t,"TableBody",(function(){return jn})),a.d(t,"TableHeader",(function(){return An})),a.d(t,"TableCell",(function(){return Hn})),a.d(t,"TableHeaderCell",(function(){return Yn})),a.d(t,"TableRow",(function(){return $n})),a.d(t,"TableFooter",(function(){return Qn}))}])}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alertTempl = __webpack_require__(1555);

var Alert = function (_Backbone$View) {
	_inherits(Alert, _Backbone$View);

	function Alert() {
		_classCallCheck(this, Alert);

		return _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));
	}

	_createClass(Alert, [{
		key: 'initialize',
		value: function initialize(options) {
			// Check if a message was passed in
			if (options.message === undefined) {
				throw new Error('Message is not defined.');
			}

			this.message = options.message;

			// Types of alerts with their associated icon class
			var alertTypes = {
				success: { name: 'success', icon: 'ui-1_check-bold' },
				warning: { name: 'warning', icon: 'ui-3_alert' },
				danger: { name: 'danger', icon: 'ui-3_alert' },
				info: { name: 'info', icon: 'ui-2_alert-circle-i' }
			};

			// Check if a type was passed in
			if (options.type) {
				var type = options.type.toLowerCase();

				if (type in alertTypes) {
					this.type = alertTypes[type];
				} else {
					throw new Error(type + ' is not a valid alert type');
				}
			} else {
				throw new Error('type is not defined');
			}

			this.setElement($('body'));
			this.render();
		}
	}, {
		key: 'closeAlert',
		value: function closeAlert(e) {
			$(e.currentTarget).closest('.sma-alert').remove();
		}
	}, {
		key: 'render',
		value: function render() {
			var context = {
				type: this.type,
				message: this.message
			};

			// Build the alert mand add it to the start of the body
			this.$el.prepend($(alertTempl(context)));

			// Get the first element in dom. Since they're prepended, the newest alert will
			// be the first element returned.
			var ele = this.$el.find('.sma-alert:first');

			// Animate and remove after a couple seconds
			ele.animate({
				right: 32,
				opacity: 1
			}, 400, function () {
				setTimeout(function () {
					ele.animate({
						right: -300,
						opacity: 0
					}, 400, function () {
						ele.remove();
					});
				}, 3000);
			});
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-alert-close': 'closeAlert'
			};
		}
	}]);

	return Alert;
}(Backbone.View);

module.exports = Alert;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(344);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(473);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__(169);


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dropselect = __webpack_require__(114);

var _dropselect2 = _interopRequireDefault(_dropselect);

var _dropselecteditable = __webpack_require__(102);

var _dropselecteditable2 = _interopRequireDefault(_dropselecteditable);

var _dropselectextendable = __webpack_require__(1578);

var _dropselectextendable2 = _interopRequireDefault(_dropselectextendable);

var _dropdown = __webpack_require__(22);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modals = __webpack_require__(6);

var _alert = __webpack_require__(10);

var _alert2 = _interopRequireDefault(_alert);

var _loader = __webpack_require__(93);

var _loader2 = _interopRequireDefault(_loader);

var _utils = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ajax = __webpack_require__(4);

var emptyTempl = __webpack_require__(1581);
var checkboxTemplate = __webpack_require__(1582);
var nestedRowTempl = __webpack_require__(1583);
var rowsPerPageSelector = __webpack_require__(1584);

var Grid = Backbone.View.extend({
	columns: [],
	visibleColumns: [],
	filters: [],
	gridLabel: '',
	nothingSelectedErrorMessage: '',

	actions: [],
	extraToolbarItems: function extraToolbarItems(grid) {
		return [];
	},

	noDataMessage: gettext('There is no data to display'),

	showSelectorColumn: true,
	rowClass: '',

	loading: false,
	loadingUid: null,

	page: 1,
	perPage: 25,
	perPageAmounts: [25, 50, 100, 250],
	showPagination: true,
	total: 0,
	orderedBy: '',
	orderDir: 'asc',

	base_query: 'active', // Base query_set of data to return (active, inactive, archived)
	grid_id: undefined, // To pass in URL if necessary

	selected: {},
	numSelected: 0,
	searchterm: '',
	expandableCols: [],
	container: null,

	title: '',
	showToolbar: true,
	showTitlebar: true,
	showFooter: true,
	showColumnDropSelect: true,
	showSearchBar: true,
	showExtraToggle: false,
	selectedIds: [],
	selectedRows: [],
	extraData: {}, // Passed on all ajax requests

	loaderSize: 'sm',
	sortCacheKey: '',

	tallyExtraLabel: false, // Show string "x of y selected" next to selected count

	cls: 'sma-grid',

	folderGrid: false,
	intID: true,

	events: {
		'change tbody td[role="select"] input[type="checkbox"]': 'rowSelectionChanged',

		'click .pager-previous': 'loadPrev',
		'click .pager-next': 'loadNext',
		'click .grid-column-name': 'orderingSelectionChanged',
		'click .js-grid-search-btn': 'search',
		'click .sma-js-nested-table': 'expandNestedTable',
		'click .sma-js-nested-content': 'expandNestedContent',
		'click tbody > tr': 'rowClicked',
		'click .sma-js-select-all': 'selectAll',
		'change .sma-js-rows-per-page-selector': 'changedRowsPerPage',

		'click .sma-js-triggers-folder-cell': 'expandFolderContent',
		'click .sma-js-funds-folder-cell': 'expandFolderContent',

		'keyup .sma-grid-search': 'searchKeyup'
	},

	initialize: function initialize(config) {
		this.url = config.url;
		this.columnsUrl = config.columnsUrl || '';

		this.extraToolbarItems = config.extraToolbarItems || this.extraToolbarItems;
		this.onLoad = this.onLoad || config.onLoad;

		if (config.extraData !== undefined) {
			this.extraData = config.extraData;
		}

		if (config.container !== undefined) {
			this.container = config.container;
		}

		if (config.columns !== undefined) {
			this.columns = config.columns;
		}

		if (config.hasOwnProperty('showToolbar')) {
			this.showToolbar = config.showToolbar;
		}

		if (config.showFooter !== undefined) {
			this.showFooter = config.showFooter;
		}

		if (config.showTitlebar !== undefined) {
			this.showTitlebar = config.showTitlebar;
		}

		if (config.showSearchBar !== undefined) {
			this.showSearchBar = config.showSearchBar;
		}

		if (config.showColumnDropSelect !== undefined) {
			this.showColumnDropSelect = config.showColumnDropSelect;
		}

		if (config.award_id !== undefined) {
			this.award_id = config.award_id;
		}

		if (config.workflow_id !== undefined) {
			this.workflow_id = config.workflow_id;
		}

		if (config.grid_id !== undefined) {
			this.grid_id = config.grid_id;
		}

		if (config.title !== undefined) {
			this.title = config.title;
		}

		if (config.results !== undefined) {
			this.results = config.results;
		}

		if (config.actions !== undefined) {
			this.actions = config.actions;
		}

		this.hiddenColumns = [];

		if (config.hiddenColumns !== undefined) {
			this.hiddenColumns = config.hiddenColumns;
		}

		if (config.resultsKey !== undefined) {
			this.resultsKey = config.resultsKey;
		}

		if (config.sortCacheKey !== undefined) {
			this.sortCacheKey = config.sortCacheKey;
		}

		if (config.updateTallyCallback !== undefined) {
			this.updateTallyCallback = config.updateTallyCallback;
		}

		this.preRenderInit(config);

		if (config.intID !== undefined) {
			this.intID = config.intID;
		}

		this.setElement(config.element[0]);
		this.element = config.element;

		if (config.kwargs !== undefined) {
			this.kwargs = config.kwargs;
		}

		this.acceptType == 'json';
		if (config.acceptType !== undefined) {
			this.acceptType == config.acceptType;
		};

		this.actionDropdown = null;

		this.render();
		this.postInit(config);
		this.results = undefined;
	},
	preRenderInit: function preRenderInit(config) {},
	postInit: function postInit(config) {},
	hideColumn: function hideColumn(column_id) {
		if (this.hiddenColumns.indexOf(column_id) < 0) {
			this.hiddenColumns.push(column_id);
		}

		var columnInfo = null;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = this.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var column = _step.value;

				if (column.id == column_id) {
					columnInfo = column;
					break;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		if (columnInfo == null) return;

		var index = this.visibleColumns.indexOf(columnInfo);
		if (index > -1) {
			this.visibleColumns.splice(index, 1);
		}
	},
	showColumn: function showColumn(column_id) {
		var index = this.hiddenColumns.indexOf(column_id);
		if (index > -1) {
			this.hiddenColumns.splice(index, 1);
		}

		var columnInfo = null;
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = this.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var column = _step2.value;

				if (column.id == column_id) {
					columnInfo = column;
					break;
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		if (columnInfo == null) return;

		if (this.visibleColumns.indexOf(columnInfo) == -1) {
			this.visibleColumns.push(columnInfo);
		}
	},
	nothingSelected: function nothingSelected() {
		this.alertMessage('danger', this.nothingSelectedErrorMessage);
	},
	alertMessage: function alertMessage(type, msg) {
		new _alert2.default({
			type: type,
			message: msg
		});
	},
	setExtraColumns: function setExtraColumns() {
		this.extraColumns = [];
		return [];
	},
	initializeFilters: function initializeFilters() {},
	buildVisibleColumns: function buildVisibleColumns(columnList) {
		if (columnList === undefined) {
			columnList = [];

			var _arr = [].concat(_toConsumableArray(this.columns), _toConsumableArray(this.extraColumns));

			for (var _i = 0; _i < _arr.length; _i++) {
				var c = _arr[_i];
				columnList.push(c.id);
			}
		}

		this.visibleColumns = [];

		var _arr2 = [].concat(_toConsumableArray(this.columns), _toConsumableArray(this.extraColumns));

		for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
			var column = _arr2[_i2];
			if (columnList.indexOf(column.id) > -1 && this.hiddenColumns.indexOf(column.id) == -1) {
				this.visibleColumns.push(column);
			}
		}
	},
	render: function render() {
		var _this = this;

		this.$el.empty();

		this.wraps = $('<div></div>'); //$('<div class="table-responsive"></div>');
		this.tableWrapperRow = $('<div></div>', { 'class': 'sma-table-wrapper' });
		this.tableWrapperCol = $('<div></div>', { 'class': 'sma-js-table-left' });

		this.table = $('<table></table>', { 'class': 'table table-hover' });
		if (this.kwargs && this.kwargs.tableClass) {
			this.table.addClass(this.kwargs.tableClass);
		}
		this.head = $('<thead></thead>');
		this.body = $('<tbody></tbody>');
		this.footer = $('<div class="grid-footer"></div>');

		this.tableWrapperCol.append(this.table);
		this.tableWrapperRow.append(this.tableWrapperCol);

		this.table.append(this.head, this.body);
		this.wraps.append(this.tableWrapperRow);

		if (this.showFooter) {
			this.table.after(this.footer);
		}

		this.$el.append(this.wraps);
		this.$el.addClass(this.cls);

		this.loader = new _loader2.default(this.tableWrapperRow, this.loaderSize);
		this.loader.hide();

		var defaultColumns = [];

		this.extraColumnContainers = this.setExtraColumns();

		if (this.columnsUrl) {
			var options = {
				url: this.columnsUrl,
				callback: function callback(response) {
					_this.visibleColumns = [];
					_this.buildVisibleColumns(response.columns);

					_this.extraColumnContainers = _this.setExtraColumns();
					_this.reOrderColumns();
					_this.renderColumnHeaders();
					_this.renderHeaders();

					_this.cachedSort();
					if (_this.orderedBy && _this.orderDir) {
						_this.updateSortColumn(_this.orderedBy, _this.orderDir);
					}

					_this.load();
				}
			};

			ajax.get(options);
			return;
		}

		this.columns.forEach(function (column) {
			var isDefault = column.isDefault !== undefined ? column.isDefault : true;
			if (isDefault) {
				defaultColumns.push(column);
			}
		});
		this.visibleColumns = defaultColumns;
		this.reOrderColumns();
		this.renderHeaders();

		this.cachedSort();
		if (this.orderedBy && this.orderDir) {
			this.updateSortColumn(this.orderedBy, this.orderDir);
		}

		this.load();
	},
	renderSearchBar: function renderSearchBar() {
		var searchInput = $('<div></div>', { 'class': 'input-group sma-grid-search' });

		this.searchBox = $('<input>', {
			type: 'text',
			'class': 'form-control',
			placeholder: gettext('Search...')
		});

		searchInput.append(this.searchBox);

		searchInput.append($('<span></span>', { 'class': 'input-group-btn' }).append($('<button></button>', {
			'class': 'btn btn-default btn-icononly js-grid-search-btn',
			type: 'button'
		}).append($('<i class="nc-icon-mini ui-1_zoom"></i>'))));

		this.searchBox.val(this.searchterm);

		return searchInput;
	},
	renderExtraToggle: function renderExtraToggle() {},
	rowClicked: function rowClicked(e) {},
	searchKeyup: function searchKeyup(e) {
		if (e.which == 13) {
			this.search();
		}
	},
	getColumnsForDropSelect: function getColumnsForDropSelect() {
		return this.columns;
	},
	renderColumnDropdown: function renderColumnDropdown() {
		var _this2 = this;

		this.checkableColumns = _.filter(this.getColumnsForDropSelect(), function (item) {
			return !item.alwaysDisplayed && !item.hideFromDropdown;
		});

		// Sort columns by index
		this.checkableColumns = this.checkableColumns.sort(function (a, b) {
			return a.index - b.index;
		});

		var columns = _.map(this.checkableColumns, function (column) {
			var visibleColumnIds = _.map(_this2.visibleColumns, function (column) {
				return column.id;
			});

			return {
				name: column.id,
				text: column.name || 'blank',
				checked: visibleColumnIds.indexOf(column.id) > -1
			};
		});

		var columnSelect = new _dropselectextendable2.default({
			title: '<i class="nc-icon-mini ui-2_menu-bold sma-rotate-90"></i>',
			items: columns,
			extraItems: this.extraColumnContainers,
			onDone: this.refreshColumns.bind(this)
		}).$el;

		return columnSelect;
	},
	getSelectedIds: function getSelectedIds() {
		return this.selectedIds;
	},
	getSelectedRows: function getSelectedRows() {
		return this.selectedRows;
	},
	getActionData: function getActionData() {
		return {
			grid: this, // TODO: returning itself?? Look into and cleanup
			ids: this.getSelectedIds(),
			rows: this.getSelectedRows()
		};
	},
	renderActionsDropdown: function renderActionsDropdown() {
		var actionSelect = new _dropdown2.default({
			title: gettext('Actions'),
			btnclass: 'btn-default',
			items: this.actions,
			addActionData: this.getActionData.bind(this)
		});

		actionSelect.$el.addClass('form-group btn-group');

		return actionSelect;
	},
	renderDropSelectEditable: function renderDropSelectEditable(options) {
		options.additionalScope = this;

		var select = new _dropselecteditable2.default(options).$el;

		select.addClass('form-group btn-group sma-grid-toolbar-extra');

		return select;
	},
	renderDropdown: function renderDropdown(dropdown) {
		var select = new _dropdown2.default({
			title: dropdown.title,
			btnclass: 'btn-default',
			items: dropdown.actions,
			addActionData: this.getActionData.bind(this)
		}).$el;

		select.addClass('form-group btn-group sma-grid-toolbar-extra');

		return select;
	},
	renderDropselect: function renderDropselect(dropselect) {
		var select = new _dropselect2.default({
			title: dropselect.title,
			items: dropselect.items,
			addActionData: this.getActionData.bind(this),
			onDone: dropselect.onDone.bind(this),
			onClick: dropselect.onClick.bind(this)
		}).$el;

		return select;
	},
	renderItem: function renderItem(item) {
		/* Renders a non-dropdown for toolbar */
		var el = $(item.html);
		var that = this;

		el.addClass('sma-grid-toolbar-extra');

		el.on(item.trigger, function () {
			return item.action(that.getActionData());
		});
		return el;
	},
	updateTallyCallback: function updateTallyCallback(grid) {},
	updateTally: function updateTally() {
		if (this.tally == undefined) return;

		this.tally.text(this.numSelected);

		if (this.numSelected == 0) {
			this.tally.addClass('zero');
			if (this.actionDropdown) {
				this.actionDropdown.disable();
			}
		} else {
			this.tally.removeClass('zero');
			if (this.actionDropdown) {
				this.actionDropdown.enable();
			}
		}

		this.updateTallyCallback(this);
	},
	renderTally: function renderTally() {
		this.tally = $('<div class="sma-grid-tally zero"></div>');
		this.tally.text(this.numSelected);

		return this.tally;
	},
	renderTallyExtra: function renderTallyExtra() {
		if (this.tallyExtraLabel) {
			if (!this.tallyExtra) {
				this.tallyExtra = $('<div class="sma-grid-tally-extra mr-2"></div>');

				var total = this.total;

				this.tallyExtra.text(gettext('/ ' + total));
				this.tallyExtra.insertAfter(this.tally);
			} else {
				var _total = this.total;

				this.tallyExtra.text(gettext('/ ' + _total));
			}
		}
	},
	renderExtraToolbarItems: function renderExtraToolbarItems(grid, left) {
		this.extraToolbarItems(this).forEach(function (item) {
			switch (item.type) {
				case 'dropdown':
					left.append(grid.renderDropdown(item));
					break;
				case 'dropselect':
					left.append(grid.renderDropselect(item));
					break;
				case 'dropselecteditable':
					left.append(grid.renderDropSelectEditable(item));
					break;
				case 'custom':
					left.append(item.rendered);
					break;
				case 'custom_renderer':
					left.append(item.customRenderer(item));
					break;
				default:
					left.append(grid.renderItem(item));
			}
		});
	},
	renderToolbar: function renderToolbar() {
		if (!this.showToolbar) return;

		var toolbar = $('<div class="row sma-grid-toolbar"></div>');

		var left = $('<div class="form-inline"></div>');
		var right = $('<div></div>');

		if (this.showSelectorColumn === true) {
			left.append(this.renderTally());
			if (this.tallyExtra) {
				left.append(this.tallyExtra);
			}
		}

		if (this.actions.length > 0) {
			this.actionDropdown = this.renderActionsDropdown();
			left.append(this.actionDropdown.$el);
		}

		this.renderExtraToolbarItems(this, left);

		left.append(this.showExtraToggle ? this.renderExtraToggle() : null);

		if (this.showSearchBar || this.showColumnDropSelect) {
			left.addClass('col-sm-7');
			right.addClass('col-sm-5');
			right.append($('<div class="form-inline float-sm-right"></div>').append(this.showSearchBar ? this.renderSearchBar() : null, this.showColumnDropSelect ? this.renderColumnDropdown() : null));
		} else {
			left.addClass('col-12');
			right.removeClass('col-sm-5');
		}

		toolbar.append(left, right);

		if (this.postRenderToolbar) {
			this.postRenderToolbar(left, right);
		}

		return toolbar;
	},
	renderTitle: function renderTitle() {
		return $('<h5></h5>').append(this.title);
	},
	addToLeftTitlebar: function addToLeftTitlebar($left) {
		$left.append(this.renderTitle());
	},
	addToRightTitlebar: function addToRightTitlebar($right) {},
	renderTitlebar: function renderTitlebar() {
		var $titlebar = $('<div class="row sma-grid-titlebar"></div>');

		if (!this.showTitlebar) return;

		var $left = $('<div class="col-sm-6 sma-titlebar-left"></div>');

		var $rightInner = $('<div class="ml-auto"></div>');
		var $rightOuter = $('<div class="col-sm-6 sma-titlebar-right"></div>').append($('<div class="d-flex justify-content-start"></div>').append($rightInner));

		this.addToLeftTitlebar($left);
		this.addToRightTitlebar($rightInner);

		$titlebar.append($left, $rightOuter);

		return $titlebar;
	},
	renderColumnHeaders: function renderColumnHeaders() {
		var _this3 = this;

		if (this.$columnHeaders !== undefined) {
			this.$columnHeaders.empty();
		} else {
			this.$columnHeaders = $('<tr></tr>');
		}

		if (this.showSelectorColumn === true) {
			this.$columnHeaders.append($('<th></th>', {
				role: 'select',
				html: checkboxTemplate({
					class: 'sma-js-select-all'
				}) // '<input type="checkbox">'
			}));
		}

		this.visibleColumns.forEach(function (col) {
			var className = '';

			if (col.sortable) {
				className = 'grid-column-name';
			}

			var header = $('<th></th>', {
				text: col.name,
				role: col.id,
				'class': className
			});
			if (col.htmlHeader) {
				header.html(col.htmlHeader);
			}

			var htmlTooltip = col.htmlTooltip ? true : false;

			if (col.tooltip) {
				var tooltip = $('<i data-toggle="tooltip" data-html="' + htmlTooltip + '" data-placement="bottom" class="mx-1 nc-icon-mini ui-e_round-e-info"></i>');
				tooltip.attr('title', col.tooltip);

				header.append(tooltip);
				header.tooltip({
					selector: '[data-toggle=tooltip]',
					html: htmlTooltip
				});
			}

			_this3.$columnHeaders.append(header);
		});
	},
	renderHeaders: function renderHeaders() {
		this.wraps.find('.sma-grid-toolbar, .sma-grid-titlebar, .sma-grid-filterbar-container').remove();
		this.wraps.prepend(this.renderToolbar());
		this.wraps.prepend(this.renderTitlebar());

		this.renderColumnHeaders();
		this.head.append(this.$columnHeaders);
		this.wraps.prepend($('<div class="sma-grid-filterbar-container"></div>'));
		if (this.gridFilter) {
			this.gridFilter.undelegateEvents();
		}
		this.initializeFilters();
	},
	renderFooter: function renderFooter(data) {
		var _this4 = this;

		this.footer.empty();

		var row = $('<div class="sma-pager d-sm-flex justify-content-center align-items-center">');
		var tools = $('<div class="sma-pager-refresh"></div>');

		tools.append($('<a></a>', {
			'href': '#',
			'class': 'sma-link-text',
			'html': '<i class="nc-icon-mini arrows-1_refresh-69"></i>',
			'click': function click() {
				return _this4.load();
			}
		}));

		if (this.showPagination) {
			var page = $('<div class="sma-pager-current"></div>');
			var pager = $('<div class="sma-pager-navigaton"></div>');
			var totals = $('<div class="sma-pager-applications"></div>');
			var rowsPerPage = $('<div class="sma-pager-rows-per-page"></div>');
			var pagerList = $('<ul class="pager"></ul>');

			var lbound = (this.page - 1) * this.perPage;

			page.append($('<div></div>', {
				text: gettext('Page: ') + this.page
			}));

			totals.append($('<div></div>', {
				text: '(' + (lbound + 1) + ' - ' + (lbound + data.results.length) + gettext(' of ') + this.total + ')'
			}));

			var items = [];

			this.perPageAmounts.forEach(function (amount) {
				items.push({
					name: amount.toString(),
					value: amount,
					selected: amount === _this4.perPage
				});
			});

			rowsPerPage.append($(rowsPerPageSelector({
				items: items
			})));

			if (data.previous != null) {
				pagerList.append($('<li></li>').append($('<a></a>', {
					href: data.previous,
					'class': 'btn btn-default pager-previous',
					text: gettext('Previous')
				})));
			}

			if (data.next != null) {
				pagerList.append($('<li></li>').append($('<a></a>', {
					href: data.next,
					'class': 'btn btn-default pager-next',
					text: gettext('Next')
				})));
			}
			pager.append(pagerList);
			row.append(page, totals, rowsPerPage, pager, tools);
		} else {
			row.append(tools);
		}

		this.footer.append(row);
	},
	getColSorting: function getColSorting() {
		if (this.orderDir == 'desc') {
			return '-' + this.orderedBy;
		}
		return this.orderedBy;
	},
	getParams: function getParams() {
		var params = {
			page: this.page,
			per_page: this.perPage,
			ordering: this.getColSorting(),
			base_query: this.base_query,
			search: this.searchterm
		};

		for (var key in this.extraData) {
			params[key] = this.extraData[key];
		}

		if (this.filters.length > 0) {
			params.filters = JSON.stringify(this.filters);
		}

		return params;
	},
	reOrderColumns: function reOrderColumns() {
		// Sort columns by index
		this.visibleColumns = this.visibleColumns.sort(function (a, b) {
			return a.index - b.index;
		});
	},
	refreshColumns: function refreshColumns(checkedItems) {
		var _this5 = this;

		this.visibleColumns = [];

		this.columns.concat(this.extraColumns).forEach(function (col) {
			var isChecked = _.find(checkedItems, function (item) {
				return item.name === col.id && item.checked === true;
			});

			if (isChecked !== undefined || col.alwaysDisplayed || col.hideFromDropdown) {
				_this5.visibleColumns.push(col);
			}
		});

		this.setVisibleColumns(this.visibleColumns);
	},
	setVisibleColumns: function setVisibleColumns(visibleColumns) {
		var _this6 = this;

		var asIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		if (this.columnsUrl) {
			var columns = [];
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = visibleColumns[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var col = _step3.value;

					if (asIds) {
						columns.push(col);
					} else {
						columns.push(col.id);
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			;

			var options = {
				url: this.columnsUrl,
				data: {
					columns: columns
				},
				alertOnSuccess: false,
				callback: function callback(response) {
					_this6.buildVisibleColumns(response.columns);
					_this6.reOrderColumns();
					_this6.renderColumnHeaders();
					_this6.load();
				}
			};
			ajax.post(options);
			return;
		}

		this.reOrderColumns();
		this.renderColumnHeaders();
		this.load();
	},
	load: function load(callback) {
		var loadingUid = (0, _utils.randomString)(20);
		this.loadingUid = loadingUid;
		this.element.addClass('sma-grid-loading');

		this.loading = true;
		var that = this;

		this.body.empty();

		this.selectedIds = [];
		this.selectedRows = [];
		this.numSelected = 0;

		this.table.hide();
		this.footer.hide();

		this.loader.show();

		if (this.results === undefined) {
			var ajaxOptions = {
				type: 'GET',
				url: this.url,
				data: this.getParams(),
				success: $.proxy(function (response) {
					if (loadingUid === this.loadingUid) {
						this.loadResults(response);
						if (callback !== undefined) callback(this);
						if (this.onLoad !== undefined) {
							this.onLoad(this, response);
						}
						this.renderTallyExtra();
						this.table.trigger('smagrid:reloaded');
					}
				}, this),
				dataType: 'json'
			};

			if (this.acceptType) {
				ajaxOptions['headers'] = {
					Accept: this.acceptType
				};
			}

			$.ajax(ajaxOptions);
		} else {
			this.loadResults(this.results);
			if (this.onLoad !== undefined) {
				this.onLoad(this, this.results);
			}
			this.table.trigger('smagrid:reloaded');
		}
	},
	refreshColumn: function refreshColumn(column, columnIndex) {
		var _this7 = this;

		return $.proxy(function (e) {
			var i = 0;
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = _this7.data.results[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var row = _step4.value;

					var cellVal = column.formatter.call(_this7, row[i], _this7, i);
					if (cellVal instanceof $) {
						_this7.body.find('tr').eq(i).find('td').eq(columnIndex).append(cellVal);
					} else {
						_this7.body.find('tr').eq(i).find('td').eq(columnIndex).html(cellVal);
					}
					i++;
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
		}, this);
	},
	loadEachResult: function loadEachResult(data, folder_id) {
		var that = this;

		var columnIndex = 0;
		var _iteratorNormalCompletion5 = true;
		var _didIteratorError5 = false;
		var _iteratorError5 = undefined;

		try {
			for (var _iterator5 = that.visibleColumns[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
				var column = _step5.value;

				if (column.reformatOn !== undefined) {
					that.table.on(column.reformatOn, $.proxy(this.refreshColumn(column, columnIndex + 1), this));
				}
				columnIndex++;
			}
		} catch (err) {
			_didIteratorError5 = true;
			_iteratorError5 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion5 && _iterator5.return) {
					_iterator5.return();
				}
			} finally {
				if (_didIteratorError5) {
					throw _iteratorError5;
				}
			}
		}

		data.results.forEach(function (item, i) {
			var row = $('<tr></tr>', { 'name': item.id, 'class': that.rowClass });

			if (that.showSelectorColumn === true) {
				if (!item.is_unselectable) {
					row.append($('<td></td>', {
						role: 'select',
						html: checkboxTemplate() // '<input type="checkbox">'
					}));
				} else {
					row.append($('<td></td>'));
				}
			}

			// Render each row's column value
			that.visibleColumns.forEach(function (col) {
				var cellVal = that.buildCell(item, col, i);
				row.append(cellVal);
			});

			var speed = i * 50;

			if (speed > 400) {
				speed = 400;
			}

			row = row.css({ opacity: 0 }).animate({ opacity: 1 }, speed);

			if (folder_id) {
				row.addClass('sma-trigger-folder-item');
				row.data('folder_id', folder_id);
				row.hide();
			}

			that.body.append(row);

			if (that.folderGrid && item.folder) {
				row.data('folder', true);

				that.loadEachResult({ results: item.items }, item.id);
			}

			// Add all of the hidden nested tables
			// below the relevant rows
			that.expandableCols.forEach(function (col) {
				var ident = col.name.toString() + '-' + i.toString();

				var nestedRow = nestedRowTempl({
					id: 'table-row-' + ident,
					nestedId: 'nested-table-' + ident
				});

				that.body.append(nestedRow);

				var results = col.loadresults ? item[col.loadresults] : false;

				that.nestedTables['#table-row-' + ident] = new col.grid({
					item_id: item['id'],
					results: results,
					element: $('#nested-table-' + ident)
				});
			});

			// for nested content
			if (that.nestedContent && that.nestedContentTriggerClass) {
				var nestedRow = nestedRowTempl({
					id: 'table-row-content-' + i,
					nestedId: 'nested-table-content-' + i
				});
				that.body.append(nestedRow);

				that.nestedContentRows['#table-row-content-' + i] = new that.nestedContent({
					parentGrid: that,
					item_id: item['id'],
					element: $('#nested-table-content-' + i, that.body)
				});
			}
		});
	},
	loadResults: function loadResults(data) {
		var that = this;

		if (this.folderGrid) {
			this.folders = [];
		}

		this.body.empty();
		this.data = data;
		this.total = data.count;

		this.nestedTables = {};
		this.nestedContentRows = {};

		if (data.count == 0) {
			var row = $('<tr></tr>', {
				colspan: '100%'
			}).append($('<td></td>', {
				colspan: '100%',
				html: emptyTempl({
					message: this.noDataMessage
				})
			}));

			that.body.append(row);
		}

		this.table.find('.sma-js-select-all:first').prop('checked', false);
		this.table.find('.sma-js-select-all:first').prop('indeterminate', false);

		this.loadEachResult(data);

		this.renderFooter(data);

		this.table.show();
		this.footer.show();
		this.updateTally();

		this.loader.hide();
		this.loading = false;

		this.element.removeClass('sma-grid-loading');
	},
	loadPrev: function loadPrev(e) {
		if (e) e.preventDefault();

		this.page--;

		this.load();
	},
	loadNext: function loadNext(e) {
		if (e) e.preventDefault();

		this.page++;

		this.load();
	},
	getRowById: function getRowById(id) {
		var _iteratorNormalCompletion6 = true;
		var _didIteratorError6 = false;
		var _iteratorError6 = undefined;

		try {
			for (var _iterator6 = this.body.find('tr')[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
				var row = _step6.value;

				if ($(row).attr('name') == id) {
					return $(row);
				}
			}
		} catch (err) {
			_didIteratorError6 = true;
			_iteratorError6 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion6 && _iterator6.return) {
					_iterator6.return();
				}
			} finally {
				if (_didIteratorError6) {
					throw _iteratorError6;
				}
			}
		}

		return null;
	},
	disableRow: function disableRow(row, id) {
		this.unselectRow(row, id);
		$(row).find('td[role="select"] input').prop('checked', false);

		$(row).find('td[role="select"] input').prop('disabled', true);
	},
	disableRowById: function disableRowById(id) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.disableRow(row, id);

		this.updateTally();
	},
	enableAll: function enableAll() {
		var _iteratorNormalCompletion7 = true;
		var _didIteratorError7 = false;
		var _iteratorError7 = undefined;

		try {
			for (var _iterator7 = this.body.find('tr')[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
				var row = _step7.value;

				$(row).find('td[role="select"] input').prop('disabled', false);
			}
		} catch (err) {
			_didIteratorError7 = true;
			_iteratorError7 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion7 && _iterator7.return) {
					_iterator7.return();
				}
			} finally {
				if (_didIteratorError7) {
					throw _iteratorError7;
				}
			}
		}
	},
	enableRow: function enableRow(row, id) {
		$(row).find('td[role="select"] input').prop('disabled', false);
	},
	enableRowById: function enableRowById(id) {
		var row = this.getRowById(id);

		if (row == null) return;

		this.enableRow(row, id);

		this.updateTally();
	},
	selectRow: function selectRow(row, id) {
		row.addClass('sma-grid-row-selected');
		this.selectedIds.push(id);
		this.selectedRows.push(_.find(this.data.results, function (obj) {
			return obj.id == id;
		}));
		this.numSelected = this.selectedRows.length;
		this.table.trigger('rowSelectionChanged', null, id, row);
	},
	selectRowById: function selectRowById(id) {
		var fireEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		var row = this.getRowById(id);

		if (row == null) return;

		this.selectRow(row, id);
		$(row).find('td[role="select"] input').prop('checked', true);

		if (fireEvent) {
			this.table.trigger('rowSelectionChanged', null, id, row);
		}

		this.updateTally();
	},
	unselectRowById: function unselectRowById(id) {
		var fireEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		var row = this.getRowById(id);

		if (row == null) return;

		this.unselectRow(row, id);
		$(row).find('td[role="select"] input').prop('checked', false);

		if (fireEvent) {
			this.table.trigger('rowSelectionChanged', null, id, row);
		}

		this.updateTally();
	},
	unselectRow: function unselectRow(row, id) {
		row.removeClass('sma-grid-row-selected');
		this.selectedIds = _.without(this.selectedIds, id);
		this.selectedRows = _.without(this.selectedRows, _.find(this.data.results, function (obj) {
			return obj.id == id;
		}));
		this.numSelected = this.selectedRows.length;
	},
	clearSelections: function clearSelections() {
		this.selectedIds = [];
		this.selectedRows = [];
		var _iteratorNormalCompletion8 = true;
		var _didIteratorError8 = false;
		var _iteratorError8 = undefined;

		try {
			for (var _iterator8 = this.body.find('tr')[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
				var row = _step8.value;

				this.unselectRowById($(row).attr('name'), false);
			}
		} catch (err) {
			_didIteratorError8 = true;
			_iteratorError8 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion8 && _iterator8.return) {
					_iterator8.return();
				}
			} finally {
				if (_didIteratorError8) {
					throw _iteratorError8;
				}
			}
		}
	},
	selectAll: function selectAll(e) {
		var box = $(e.currentTarget);
		// All rows that aren't folder rows or diabled
		var rows = this.body.find('tr').map(function (i, row) {
			if (!$(row).data('folder') && !$(row).find('td[role="select"] input').prop('disabled')) {
				return row;
			}
		});

		var inputs = box.is(':checked') ? rows.find('td[role="select"] input:not(:checked)') : rows.find('td[role="select"] input:checked');

		inputs.each(function (i, input) {
			$(input).trigger('click');
		});
	},
	changedRowsPerPage: function changedRowsPerPage(e) {
		var selectedValue = parseInt($(e.currentTarget).val(), 10);

		if (this.perPageAmounts.includes(selectedValue)) {
			this.perPage = selectedValue;
			this.page = 1;
			this.load();
		}
	},
	rowSelectionChanged: function rowSelectionChanged(e) {
		// Check if all checkboxes are selected
		var rows = this.body.find('tr').map(function (i, row) {
			var returnRow = void 0;
			if (!$(row).data('folder')) {
				returnRow = row;
			}
			return returnRow;
		});

		var numChecked = rows.find('td[role="select"] input:checked').length;
		var num = rows.find('td[role="select"] input').length;

		this.table.find('.sma-js-select-all:first').prop('indeterminate', numChecked && numChecked !== num);
		this.table.find('.sma-js-select-all:first').prop('checked', numChecked === num);

		e.preventDefault();
		var box = $(e.currentTarget);
		var row = box.parents('tr:first');
		var id = row.attr('name');
		if (this.intID) {
			id = parseInt(id, 10);
		}

		// Makes nearly nested tables work (org profile teams for example)
		if (!$.contains(this.body[0], box[0])) return;

		// Click on folder row
		if (row.data('folder')) {
			box.next().removeClass('mixed-checkbox').text('');

			var checked = true;

			if (box.is(':checked')) {
				checked = false;
			}

			this.getFolderSubRows(id).each(function (i, item) {
				$(item).find('td[role="select"] input').prop('checked', checked).trigger('click');
			});
		} else {
			// Click on a normal row
			if (box.is(':checked')) {
				this.selectRow(row, id);
			} else {
				this.unselectRow(row, id);
			}

			var folderId = row.data('folder_id');
			// If the row is inside a folder
			if (folderId) {
				this.handleFolderCheckbox(folderId);
			}
		}

		this.table.trigger('rowSelectionChanged', e, id, row);

		this.updateTally();
	},
	handleFolderCheckbox: function handleFolderCheckbox(folderId) {
		var $folderRow = this.getFolderRow(folderId);
		var $folderInput = $folderRow.find('td[role="select"] input');

		var $folderSubRows = this.getFolderSubRows(folderId);
		var $selectedSubRows = $folderSubRows.filter('.sma-grid-row-selected');

		if (!$selectedSubRows.length) {
			$folderInput.prop('checked', false);
			$folderInput.next().removeClass('mixed-checkbox').text('');
		} else if ($folderSubRows.length > $selectedSubRows.length) {
			$folderInput.prop('checked', false);
			$folderInput.next().addClass('mixed-checkbox').text('-');
		} else {
			$folderInput.prop('checked', true);
			$folderInput.next().removeClass('mixed-checkbox').text('');
		}
	},
	setSortCache: function setSortCache(col, dir) {
		localStorage.setItem(this.sortCacheKey, col);

		var dirCacheKey = 'dir.' + this.sortCacheKey;
		localStorage.setItem(dirCacheKey, dir);
	},
	cachedSort: function cachedSort() {
		var sortColumn = localStorage.getItem(this.sortCacheKey);

		var dirCacheKey = 'dir.' + this.sortCacheKey;
		var sortDir = localStorage.getItem(dirCacheKey);

		this.orderedBy = sortColumn;
		this.orderDir = sortDir;
	},
	updateSortColumn: function updateSortColumn(col, dir) {
		if (this.sortCacheKey !== '') {
			this.setSortCache(col, dir);
		}

		var column = this.table.find('.grid-column-name[role="' + col + '"]');
		column.siblings().removeClass('desc').removeClass('asc');

		column.removeClass('desc').removeClass('asc');
		if (dir) {
			column.addClass(dir);
		}
		if (col === '' || col === undefined) {
			/* no sorting, so no column should have asc and desc */
			this.table.find('.grid-column-name').removeClass('desc').removeClass('asc');
		}

		this.orderedBy = col;
		this.orderDir = dir;
	},
	orderingSelectionChanged: function orderingSelectionChanged(e) {
		e.preventDefault();
		var target = $(e.currentTarget);
		var orderedBy = target.attr('role');
		var orderDir = this.orderDir;


		if (this.orderedBy !== orderedBy || orderDir === '') {
			orderDir = 'asc';
		} else if (orderDir === 'asc') {
			orderDir = 'desc';
		} else {
			orderDir = '';
			orderedBy = '';
		}

		this.updateSortColumn(orderedBy, orderDir);
		this.load();
	},
	search: function search(e) {
		if (e) {
			e.preventDefault();
		}
		this.searchterm = this.searchBox.val();
		this.page = 1;
		this.load();
	},
	updateColumn: function updateColumn(col) {
		return col;
	},
	defaultCellFormatter: function defaultCellFormatter(item, col) {
		return item[col.id] || '';
	},
	formatCell: function formatCell(item, col) {
		col = this.updateColumn(col);
	},
	formatCellValue: function formatCellValue(item, col, rowIndex) {
		var html = typeof col.formatter !== 'undefined' ? col.formatter.call(this, item, this, rowIndex) : this.defaultCellFormatter(item, col);

		return html;
	},
	buildCell: function buildCell(item, col, i) {
		var value = this.formatCellValue(item, col, i);

		var cell = $('<td></td>', {
			role: col.id,
			class: col.class
		}).append(value);

		// Add additional button to load nested tables
		if (this.isExpandable(col.id)) {
			cell.append($('<button></button>', {
				'class': 'btn btn-sm btn-icononly dropdown-toggle sma-js-nested-table',
				'data-target': '#table-row-' + col.id.toString() + '-' + i.toString()
			}));
		}

		// Set nested content loader class and target info
		if (this.nestedContent && this.nestedContentTriggerClass) {
			var $item = cell.find('.' + this.nestedContentTriggerClass);

			$item.addClass('sma-js-nested-content');
			$item.data('target', '#table-row-content-' + i.toString());
		}

		return cell;
	},
	isExpandable: function isExpandable(name) {
		for (var k in this.expandableCols) {
			if (this.expandableCols[k].name == name) {
				return true;
			}
		}
		return false;
	},
	expandNestedTable: function expandNestedTable(e) {
		e.preventDefault();
		var curr = $(e.currentTarget);
		var row = curr.parent();

		$(curr.data('target')).toggle();
		row.toggleClass('sma-users-detail-row-expanded');

		// Don't call render when hiding
		if (row.hasClass('sma-users-detail-row-expanded')) {
			this.nestedTables[curr.data('target')].render();
		}
	},
	expandNestedContent: function expandNestedContent(e) {
		e.preventDefault();
		var curr = $(e.currentTarget);
		var row = curr.closest('tr');

		$(curr.data('target')).toggle();
		row.toggleClass('sma-users-detail-row-expanded');

		// Don't call render when hiding
		if (row.hasClass('sma-users-detail-row-expanded')) {
			this.nestedContentRows[curr.data('target')].render(curr);
		}
	},
	getFolderSubRows: function getFolderSubRows(id) {
		return this.body.find('tr').filter(function () {
			return $(this).data('folder_id') === id;
		});
	},
	getFolderRow: function getFolderRow(id) {
		return this.body.find('tr').filter(function () {
			return $(this).data('folder') === true && $(this).attr('name') === id.toString();
		});
	},
	expandFolderContent: function expandFolderContent(e) {
		var curr = $(e.currentTarget);
		var row = curr.closest('tr');

		var id = parseInt(row.attr('name'));
		this.getFolderSubRows(id).fadeToggle();

		curr.find('.sma-js-triggers-folder-arrow').toggle();
	},


	// use this as a generic post for your actions.
	// It will pass the selected ids to your url and execute your callback
	postIds: function postIds(options) {
		var _this8 = this;

		var postData = options.ids ? { ids: options.ids } : { ids: options.data.ids };

		new _modals.Confirm(options.title, options.message, function () {
			ajax.post({
				url: options.url,
				data: postData,
				callback: function callback(result) {
					if (options.callback) {
						options.callback(result);
					}
					_this8.load();
				}
			});
		}, {});
	}
});

var InnerGrid = Grid.extend({
	columns: [],
	isLoaded: false,

	initialize: function initialize(config) {
		this.item_id = config.item_id;
		this.results = config.results;
		this.visibleColumns = this.columns;
		this.element = $(config.element[0]);
		this.setElement(config.element[0]);
	},
	renderHeaders: function renderHeaders() {
		var row = $('<tr></tr>');

		if (this.showSelectorColumn == true) {
			row.append($('<th></th>', {
				role: 'select'
			}));
		}

		this.columns.forEach(function (col, j) {
			row.append($('<th></th>', {
				text: col.name,
				role: col.id
			}));
		});

		this.head.append(row);
	},
	renderFooter: function renderFooter(data) {
		return;
	},
	render: function render() {
		if (!this.isLoaded) {
			Grid.prototype.render.call(this);
		}
		this.isLoaded = true;
	},
	getURL: function getURL() {
		return '';
	},
	load: function load() {
		var that = this;

		this.body.empty();

		this.table.hide();
		this.footer.hide();

		this.loader.show();

		if (this.results === false) {
			$.get(this.getUrl(), this.getParams(), function (response) {
				that.loadResults(response);
			}, 'json');
		} else {
			this.loadResults(this.results);
		}
	}
});

var InnerContentGrid = Backbone.View.extend({
	initialize: function initialize(config) {
		this.parentGrid = config.parentGrid;
		this.item_id = config.item_id;
		this.results = config.results;
		this.element = config.element[0];
		this.loader = new _loader2.default(this.$el, 'md');
	},
	render: function render($opener) {
		this.setElement(this.element);
		this.load();
		this.onOpen($opener);
	},
	getURL: function getURL() {
		return '';
	},
	onOpen: function onOpen($opener) {
		return '';
	},
	close: function close() {
		var expander = 'sma-users-detail-row-expanded';
		var $row = this.$el.closest('tr').hide();
		$row.prev('.' + expander).toggleClass(expander);
		this.onClose();
	},
	load: function load() {
		var _this9 = this;

		this.loader.show();

		$.get(this.getUrl(), this.getParams(), function (response) {
			_this9.loader.hide();
			_this9.$el.html(_this9.formatter(response));
		}, 'json');
	}
});

module.exports = {
	Grid: Grid,
	InnerGrid: InnerGrid,
	InnerContentGrid: InnerContentGrid
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
items = [{ //make a header
	text: gettext('Visibility'),
	header: true
}, { //make a button
	name: 'make_live',
	text: gettext('Set as live'),
	action: function (data) {
		//do stuff here
	},
}, { //make a divider
	divider: true,
}]
*/
var dropdownButtonTempl = __webpack_require__(440);
var dropdownHeadingTempl = __webpack_require__(1574);

var Dropdown = Backbone.View.extend({
	initialize: function initialize(options) {
		this.noCaret = options.noCaret || false;
		this.type = options.type || 'button';
		this.btnclass = options.btnclass || 'btn-default';
		this.extraClass = options.extraClass || '';
		this.items = options.items;
		this.title = options.title;
		this.textStyleButton = options.textStyleButton || false;
		this.rightAligned = options.rightAligned || false;
		this.href = options.href || '#';
		this.ariaLabel = options.ariaLabel || gettext('Perform action');
		this.addActionData = options.addActionData || function () {
			return {};
		};
		this.render();
	},

	disable: function disable() {
		this.$el.find('button').attr('disabled', 'true');
	},

	enable: function enable() {
		this.$el.find('button').removeAttr('disabled');
	},

	render: function render() {
		this.$el.empty();

		var templ = void 0;
		if (this.type == 'heading') {
			templ = dropdownHeadingTempl;
		} else {
			templ = dropdownButtonTempl;
		}

		this.$el.html(templ({
			title: this.title,
			btnclass: this.btnclass,
			noCaret: this.noCaret,
			items: this.items,
			textStyleButton: this.textStyleButton ? 'text-style-button' : '',
			type: this.type,
			extraClass: this.extraClass,
			extraItemClass: this.extraItemClass,
			rightAligned: this.rightAligned,
			ariaLabel: this.ariaLabel,
			attribute: this.attribute
		}));

		this.setEvents();
	},

	setEvents: function setEvents() {
		var _this = this;

		this.items.forEach(function (action) {
			if (action && action.action !== undefined && action.action !== null) {
				var $el = _this.$el.find('a[name=\'' + action.name + '\']');

				$el.click(function (_e) {
					_this.doAction(action.action.bind(_this));
				});
			}
		});
	},

	doAction: function doAction(action) {
		var data = this.addActionData();
		action(data);
	},

	changeTitle: function changeTitle(newTitle) {
		this.title = newTitle;
		this.render();
	}
});

module.exports = Dropdown;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1563);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.escapeHtml = escapeHtml;
exports.readFromFile = readFromFile;
exports.decimalPlaces = decimalPlaces;
exports.round = round;
var entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
	'/': '&#x2F;',
	'`': '&#x60;',
	'=': '&#x3D;'
};

function escapeHtml(string) {
	return String(string).replace(/[&<>"'`=\/]/g, function (s) {
		return entityMap[s];
	});
}

var randomString = exports.randomString = function randomString(length) {
	var chars = '0123456789' + 'ABCDEFGHIJKLMNOPQRSTUVWXTZ' + 'abcdefghiklmnopqrstuvwxyz';

	var random = '';
	for (var i = 0; i < length; i++) {
		var rnum = Math.floor(Math.random() * chars.length);
		random += chars.substring(rnum, rnum + 1);
	}

	return random;
};

var smartRound = exports.smartRound = function smartRound(val) {
	if (val < 1) {
		return 1;
	}

	var logValue = Math.floor(Math.log10(val));
	return Math.pow(10, logValue);
};

var destroyBackboneView = exports.destroyBackboneView = function destroyBackboneView(view) {
	if (view) {
		view.undelegateEvents();
		$(view.el).removeData().unbind();
	}
};

var makeStringFileSafe = exports.makeStringFileSafe = function makeStringFileSafe(str) {
	return str.replace(/[^a-z0-9]/gi, '_').toLowerCase();
};

function readFromFile(file) {
	return new Promise(function (resolve) {
		var reader = new FileReader();

		reader.addEventListener('load', function () {
			resolve(reader.result);
		}, false);

		reader.readAsDataURL(file);
	});
}

function decimalPlaces(num) {
	var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	if (!match) {
		return 0;
	}
	return Math.max(0,
	// Number of digits right of decimal point.
	(match[1] ? match[1].length : 0) - (
	// Adjust for scientific notation.
	match[2] ? +match[2] : 0));
}

function round(value, decimals) {
	return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

var spectrumDefaults = exports.spectrumDefaults = {
	showAlpha: false,
	allowAlpha: false,
	showPalette: true,
	showButtons: true,
	allowEmpty: true,
	showInitial: true,
	showInput: true,
	preferredFormat: 'hex',
	palette: [['#333e48', '#7c878e', '#9DA5AA', '#d0d2d3', '#e1e4e6', '#efefef', '#f7f8f8', '#ffffff'], ['#05467e', '#00bf6f', '#f9be00', '#F05B24', '#1F8FB0', '#E0F1FF'], ['#125A98', '#318DBC', '#51B3D0', '#7ECCC3', '#A9DCB6']]
};

//natural sort i.e. [1, 4, 10]
var natSort = exports.natSort = function natSort(list) {
	list.sort(new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }).compare);
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Avatar__ = __webpack_require__(1757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Button__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Card__ = __webpack_require__(1760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Checkbox__ = __webpack_require__(1766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_3__components_Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Error__ = __webpack_require__(1768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Error", function() { return __WEBPACK_IMPORTED_MODULE_4__components_Error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormGroup__ = __webpack_require__(1770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_5__components_FormGroup__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormField", function() { return __WEBPACK_IMPORTED_MODULE_5__components_FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Grid__ = __webpack_require__(1773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_6__components_Grid__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return __WEBPACK_IMPORTED_MODULE_6__components_Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_6__components_Grid__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Icon__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Input__ = __webpack_require__(466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Tooltip__ = __webpack_require__(1778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InputGroup__ = __webpack_require__(1781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_10__components_InputGroup__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupAddon", function() { return __WEBPACK_IMPORTED_MODULE_10__components_InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_List__ = __webpack_require__(921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_11__components_List__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() { return __WEBPACK_IMPORTED_MODULE_11__components_List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Label__ = __webpack_require__(1786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_12__components_Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Menu__ = __webpack_require__(1788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_13__components_Menu__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuGroup", function() { return __WEBPACK_IMPORTED_MODULE_13__components_Menu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_13__components_Menu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Modal__ = __webpack_require__(1792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_14__components_Modal__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return __WEBPACK_IMPORTED_MODULE_14__components_Modal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return __WEBPACK_IMPORTED_MODULE_14__components_Modal__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return __WEBPACK_IMPORTED_MODULE_14__components_Modal__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Align", function() { return __WEBPACK_IMPORTED_MODULE_14__components_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pane__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pane", function() { return __WEBPACK_IMPORTED_MODULE_15__components_Pane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Radio__ = __webpack_require__(1803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_16__components_Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Select__ = __webpack_require__(1805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_17__components_Select__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return __WEBPACK_IMPORTED_MODULE_17__components_Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Spinner__ = __webpack_require__(1808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_18__components_Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Switch__ = __webpack_require__(1810);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_19__components_Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Tabs__ = __webpack_require__(1812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_20__components_Tabs__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_20__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Textarea__ = __webpack_require__(1815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Textarea", function() { return __WEBPACK_IMPORTED_MODULE_21__components_Textarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdvancedSelect__ = __webpack_require__(1817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AdvancedSelect", function() { return __WEBPACK_IMPORTED_MODULE_22__components_AdvancedSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_GroupedInline__ = __webpack_require__(1959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GroupedInline", function() { return __WEBPACK_IMPORTED_MODULE_23__components_GroupedInline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_withFetcher__ = __webpack_require__(1961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withFetcher", function() { return __WEBPACK_IMPORTED_MODULE_24__components_withFetcher__["a"]; });
























// Higher order components

//# sourceMappingURL=index.js.map

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(232)('wks');
var uid = __webpack_require__(159);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(91);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.wds=t(require("react")):e.wds=t(e.react)}("undefined"!=typeof self?self:this,(function(e){return function(e){var t={};function a(l){if(t[l])return t[l].exports;var r=t[l]={i:l,l:!1,exports:{}};return e[l].call(r.exports,r,r.exports,a),r.l=!0,r.exports}return a.m=e,a.c=t,a.d=function(e,t,l){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:l})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var l=Object.create(null);if(a.r(l),Object.defineProperty(l,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)a.d(l,r,function(t){return e[t]}.bind(null,r));return l},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=8)}([function(t,a){t.exports=e},function(e,t,a){e.exports=a(6)()},function(e,t){e.exports=function(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}},function(e,t,a){var l=a(5);e.exports=function(e,t){if(null==e)return{};var a,r,n=l(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)a=i[r],t.indexOf(a)>=0||Object.prototype.propertyIsEnumerable.call(e,a)&&(n[a]=e[a])}return n}},function(e,t,a){var l;!function(){"use strict";var a={}.hasOwnProperty;function r(){for(var e=[],t=0;t<arguments.length;t++){var l=arguments[t];if(l){var n=typeof l;if("string"===n||"number"===n)e.push(l);else if(Array.isArray(l)&&l.length){var i=r.apply(null,l);i&&e.push(i)}else if("object"===n)for(var o in l)a.call(l,o)&&l[o]&&e.push(o)}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):void 0===(l=function(){return r}.apply(t,[]))||(e.exports=l)}()},function(e,t){e.exports=function(e,t){if(null==e)return{};var a,l,r={},n=Object.keys(e);for(l=0;l<n.length;l++)a=n[l],t.indexOf(a)>=0||(r[a]=e[a]);return r}},function(e,t,a){"use strict";var l=a(7);function r(){}function n(){}n.resetWarningCache=r,e.exports=function(){function e(e,t,a,r,n,i){if(i!==l){var o=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw o.name="Invariant Violation",o}}function t(){return e}e.isRequired=e;var a={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:n,resetWarningCache:r};return a.PropTypes=a,a}},function(e,t,a){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,a){"use strict";a.r(t);var l=a(2),r=a.n(l),n=a(3),i=a.n(n),o=a(0),u=a.n(o),c=a(1),s=a.n(c),d=a(4),p=a.n(d),m=["lg","md","sm","xl"],g=function(e){var t=e.children,a=e.color,l=e.size,n=i()(e,["children","color","size"]),o=p()("wds-icon-svg",r()({},"wds-icon-svg--".concat(a),a),r()({},"wds-icon-svg--".concat(l),l));return u.a.createElement("svg",Object.assign({className:o,preserveAspectRatio:"xMidYMid meet"},n),t)};g.displayName="IconSVG",g.propTypes={children:s.a.node.isRequired,color:s.a.string,size:s.a.oneOf(m)},g.defaultProps={color:null,size:null},g.contextTypes={reactIconBase:s.a.shape(g.propTypes)},g.__docgenInfo={description:"",methods:[],displayName:"IconSVG",props:{color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}},context:{reactIconBase:{type:{name:"shape",value:"IconSVG.propTypes",computed:!0},required:!1}}};var z=g,v=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.89 1.1893-.001-.0092a.6981.6981 0 0 0 -.1324-.2468c-.0128-.0154-.0311-.0222-.0449-.0362-.0089-.009-.01-.0225-.02-.0311-.0151-.0138-.0367-.0147-.0527-.0271a.6751.6751 0 0 0 -.229-.1178.66.66 0 0 0 -.08-.0235.6882.6882 0 0 0 -.33.0224l-.01.0007-14.1487 4.9079a1.12 1.12 0 0 0 -.1929 2.0278l4.0235 2.3215.0009 4.0863a1.1819 1.1819 0 0 0 .7319 1.1543 1.182 1.182 0 0 0 1.3369-.2925l2.2522-2.4545 1.97 1.1366a1.4349 1.4349 0 0 0 2.1074-.8906l2.8262-11.1641c.0035-.0141-.0036-.0278-.0009-.042a.691.691 0 0 0 -.0065-.3221zm-4.07 2.1121-6.5134 5.4262-3.4273-1.9776zm-5.7478 10.2838v-2.7994l1.68.9691zm5.5913-1.19-5.0643-2.9219 7.4014-6.1659z"})))};v.displayName="IconAirplane",v.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},v.defaultProps={title:"Airplane",color:null,size:null},v.__docgenInfo={description:"",methods:[],displayName:"IconAirplane",props:{title:{defaultValue:{value:"'Airplane'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var h=v,f=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7941 11.7632c-.0051-.012-.0153-.0206-.0209-.0322a.7353.7353 0 0 0 -.13-.2017l-2.2046-2.2632a.75.75 0 0 0 -1.0742 1.0469l.9645.99h-7.34a4.342 4.342 0 1 1 0-8.6841h9.1094a.75.75 0 0 0 0-1.5h-9.1089a5.842 5.842 0 1 0 0 11.6841h7.2892l-.8039.794a.75.75 0 0 0 1.0547 1.0674l2.1035-2.0781a.7475.7475 0 0 0 .1612-.8231z"})))};f.displayName="IconArrow180",f.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},f.defaultProps={title:"Arrow180",color:null,size:null},f.__docgenInfo={description:"",methods:[],displayName:"IconArrow180",props:{title:{defaultValue:{value:"'Arrow180'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var y=f,I=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.4021 3.3418a.75.75 0 1 0 -.0576 1.498 4.2814 4.2814 0 0 1 -.167 8.56h-4.3545a4.2813 4.2813 0 1 1 0-8.5625h.2044l-.78.7705a.75.75 0 1 0 1.0551 1.0661l2.0775-2.0539a.75.75 0 0 0 .01-1.0566l-2.1769-2.2362a.75.75 0 0 0 -1.0751 1.0469l.9375.9629h-.2525a5.7812 5.7812 0 1 0 0 11.5625h4.3545a5.781 5.781 0 0 0 .2246-11.5576z"})))};I.displayName="IconArrow360",I.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},I.defaultProps={title:"Arrow360",color:null,size:null},I.__docgenInfo={description:"",methods:[],displayName:"IconArrow360",props:{title:{defaultValue:{value:"'Arrow360'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var E=I,V=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M12.429,14.422H1.8a.6636.6636,0,0,1-.6644-.6644V3.1281A.6635.6635,0,0,1,1.8,2.4638H5.3426a.6644.6644,0,1,1,0,1.3287H2.4638v9.3008h9.3008V10.2145a.6644.6644,0,1,1,1.3287,0v3.5431A.6635.6635,0,0,1,12.429,14.422Z"}),u.a.createElement("path",{id:"ArrowBox-2","data-name":"ArrowBox",d:"M14.3733,1.5559c0-.0045,0-.0089-.0045-.0089a.6783.6783,0,0,0-.3631-.3632c-.0045,0-.0089,0-.0089-.0044a.6952.6952,0,0,0-.2392-.0443H8.4429a.6644.6644,0,0,0,0,1.3287h3.7115L7.9734,6.6447a.66.66,0,0,0,0,.939.6629.6629,0,0,0,.939,0l4.1809-4.181V7.1142a.6644.6644,0,1,0,1.3287,0V1.8A.646.646,0,0,0,14.3733,1.5559Z"}),u.a.createElement("rect",{x:"0.0279",y:"0.0279",width:"15.9442",height:"15.9442",fill:"none"})))};V.displayName="IconArrowBox",V.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},V.defaultProps={title:"ArrowBox",color:null,size:null},V.__docgenInfo={description:"",methods:[],displayName:"IconArrowBox",props:{title:{defaultValue:{value:"'ArrowBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var q=V,b=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5322 7.3935-4.125-2.3814a.7.7 0 0 0 -1.05.6065v1.6814h-1.6912a5.0313 5.0313 0 0 1 -4.3092-2.3146 2.3761 2.3761 0 0 0 .56-1.522 2.4 2.4 0 1 0 -2.4 2.4 2.3665 2.3665 0 0 0 .6751-.1086 6.816 6.816 0 0 0 2.5032 2.2452 6.816 6.816 0 0 0 -2.5034 2.2453 2.3665 2.3665 0 0 0 -.6751-.1086 2.4 2.4 0 1 0 2.4 2.4 2.376 2.376 0 0 0 -.56-1.522 5.0312 5.0312 0 0 1 4.3094-2.3147h1.6914v1.6811a.7.7 0 0 0 1.05.6065l4.125-2.3814a.7.7 0 0 0 0-1.2129zm-14.0146-3.9301a1 1 0 1 1 .999 1 1 1 0 0 1 -.999-1zm.999 10.0727a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm9.2412-4.3672v-2.3379l2.0244 1.169z"})))};b.displayName="IconArrowCombine",b.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},b.defaultProps={title:"ArrowCombine",color:null,size:null},b.__docgenInfo={description:"",methods:[],displayName:"IconArrowCombine",props:{title:{defaultValue:{value:"'ArrowCombine'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var N=b,_=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.9956 14.9531a.75.75 0 0 1 -.53-1.28l5.6726-5.6731-5.6729-5.6729a.75.75 0 1 1 1.0606-1.0605l6.2031 6.2034a.75.75 0 0 1 0 1.0605l-6.2031 6.2029a.7467.7467 0 0 1 -.5303.2197z"}),u.a.createElement("path",{d:"m4.5386 8.75h-3.7373a.75.75 0 1 1 0-1.5h3.7373a.75.75 0 0 1 0 1.5z"}),u.a.createElement("path",{d:"m11.1353 8.75h-3.7383a.75.75 0 0 1 0-1.5h3.7383a.75.75 0 0 1 0 1.5z"})))};_.displayName="IconArrowDashed",_.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_.defaultProps={title:"ArrowDashed",color:null,size:null},_.__docgenInfo={description:"",methods:[],displayName:"IconArrowDashed",props:{title:{defaultValue:{value:"'ArrowDashed'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var w=_,x=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.57 8.655a.75.75 0 0 0 -1.0605 0l-4.76 4.76v-12.6403a.75.75 0 1 0 -1.5 0v12.64l-4.7595-4.7597a.75.75 0 0 0 -1.06 1.0606l6.04 6.04a.7514.7514 0 0 0 1.0606 0l6.04-6.04a.75.75 0 0 0 -.0006-1.0606z"})))};x.displayName="IconArrowDown",x.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},x.defaultProps={title:"ArrowDown",color:null,size:null},x.__docgenInfo={description:"",methods:[],displayName:"IconArrowDown",props:{title:{defaultValue:{value:"'ArrowDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var T=x,P=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6843 7.47-4.97-4.97a.75.75 0 1 0 -1.0603 1.06l3.69 3.69h-9.254a.75.75 0 0 0 0 1.5h9.2539l-3.6898 3.6895a.75.75 0 1 0 1.0605 1.0605l4.97-4.97a.75.75 0 0 0 -.0003-1.06z"}),u.a.createElement("path",{d:"m4.6585 13.875h-3.0625v-11.75h3.0625a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5z"})))};P.displayName="IconArrowExit",P.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},P.defaultProps={title:"ArrowExit",color:null,size:null},P.__docgenInfo={description:"",methods:[],displayName:"IconArrowExit",props:{title:{defaultValue:{value:"'ArrowExit'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var B=P,O=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.9035 7.7136a.75.75 0 0 0 -.1618-.2436l-6.0517-6.0518a.75.75 0 1 0 -1.06 1.0606l4.7709 4.7712h-7.02c-2.6695 0-4.8409-1.5237-4.8409-3.3972a.75.75 0 1 0 -1.5 0c0 2.7007 2.8443 4.8972 6.3414 4.8972h7.02l-4.7714 4.7712a.75.75 0 1 0 1.06 1.0606l6.0513-6.0513a.7527.7527 0 0 0 .1618-.8169z"})))};O.displayName="IconArrowForward",O.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},O.defaultProps={title:"ArrowForward",color:null,size:null},O.__docgenInfo={description:"",methods:[],displayName:"IconArrowForward",props:{title:{defaultValue:{value:"'ArrowForward'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var C=O,j=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.26 12.1213a4.1328 4.1328 0 1 1 4.2429-5.368l-.76-.4582a.65.65 0 0 0 -.6719 1.1133l2.06 1.2422a.6508.6508 0 0 0 .8926-.2207l1.2422-2.0591a.65.65 0 0 0 -1.1133-.6719l-.3274.5429a5.5316 5.5316 0 1 0 -5.6726 7.275c.0181.0015.0366.0024.0547.0024a.7.7 0 0 0 .0527-1.398z"}),u.a.createElement("path",{d:"m10.894 2.4871a.7.7 0 0 0 -.1191 1.3945 4.1327 4.1327 0 1 1 -4.2899 5.3274l.783.4724a.65.65 0 0 0 .672-1.1133l-2.06-1.2422a.6506.6506 0 0 0 -.8926.2207l-1.2418 2.0591a.65.65 0 0 0 1.1133.6719l.3147-.5218a5.5316 5.5316 0 1 0 5.72-7.2687z"})))};j.displayName="IconArrowIntegrate",j.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},j.defaultProps={title:"ArrowIntegrate",color:null,size:null},j.__docgenInfo={description:"",methods:[],displayName:"IconArrowIntegrate",props:{title:{defaultValue:{value:"'ArrowIntegrate'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var L=j,A=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2246 7.25h-12.6397l4.7593-4.76a.75.75 0 1 0 -1.0605-1.06l-6.0396 6.04a.7527.7527 0 0 0 0 1.0605l6.04 6.04a.75.75 0 1 0 1.0601-1.0605l-4.7593-4.76h12.64a.75.75 0 1 0 0-1.5z"})))};A.displayName="IconArrowLeft",A.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},A.defaultProps={title:"ArrowLeft",color:null,size:null},A.__docgenInfo={description:"",methods:[],displayName:"IconArrowLeft",props:{title:{defaultValue:{value:"'ArrowLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var S=A,k=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.6768 7.2315h-5.3477a.75.75 0 0 0 0 1.5h5.3477a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.7222 2.5977-1.7281-2.2549c-.0084-.011-.0226-.0145-.0317-.0249a.7247.7247 0 0 0 -1.1271 0c-.009.01-.0232.0139-.0317.0249l-1.728 2.2549a.75.75 0 1 0 1.19.9121l.3828-.4993v4.7131c0 1.3574-.7622 2.5049-1.6641 2.5049h-5.6552a.75.75 0 0 0 0 1.5h5.6558c1.7446 0 3.1641-1.7969 3.1641-4.0049v-4.7136l.3828.4993a.75.75 0 1 0 1.19-.9121z"}),u.a.createElement("path",{d:"m3.7339 12.49-.3828.4993v-4.7129c0-1.3574.7622-2.5049 1.6641-2.5049h5.6616a.75.75 0 0 0 0-1.5h-5.6617c-1.7446 0-3.1641 1.7969-3.1641 4.0049v4.7136l-.3827-.5a.75.75 0 1 0 -1.19.9121l1.728 2.2549c.009.0118.0238.0164.0334.0275a.7354.7354 0 0 0 .1714.1411.7224.7224 0 0 0 .0779.0525.7068.7068 0 0 0 .6249 0 .7222.7222 0 0 0 .0779-.0525.7358.7358 0 0 0 .1714-.1411c.01-.0112.0245-.0157.0334-.0275l1.728-2.2549a.75.75 0 1 0 -1.19-.9121z"})))};k.displayName="IconArrowRandom",k.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},k.defaultProps={title:"ArrowRandom",color:null,size:null},k.__docgenInfo={description:"",methods:[],displayName:"IconArrowRandom",props:{title:{defaultValue:{value:"'ArrowRandom'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var D=k,F=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.1851 5.54a.7531.7531 0 0 0 .6921.4634h2.9321a.75.75 0 0 0 0-1.5h-1.1212l.4073-.4072a5.5215 5.5215 0 0 1 9.4258 3.8462.75.75 0 0 0 .75.7422h.0078a.75.75 0 0 0 .7422-.7578 7.0216 7.0216 0 0 0 -11.9863-4.8916l-.4077.4076v-1.1215a.75.75 0 0 0 -1.5 0v2.9317l.001.0048a.75.75 0 0 0 .0569.2822z"}),u.a.createElement("path",{d:"m14.4089 10.055a.75.75 0 0 0 -.2866-.0579h-2.9316a.75.75 0 0 0 0 1.5h1.1211l-.4072.4072a5.5216 5.5216 0 0 1 -9.4259-3.8452.7408.7408 0 0 0 -.7578-.7422.75.75 0 0 0 -.7422.7578 7.0241 7.0241 0 0 0 11.9863 4.89l.4072-.4072v1.1211a.75.75 0 0 0 1.5 0v-2.9315a.753.753 0 0 0 -.4634-.6921z"})))};F.displayName="IconArrowRefresh",F.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},F.defaultProps={title:"ArrowRefresh",color:null,size:null},F.__docgenInfo={description:"",methods:[],displayName:"IconArrowRefresh",props:{title:{defaultValue:{value:"'ArrowRefresh'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var M=F,U=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.9177 7.7134a.75.75 0 0 0 -.1618-.2436l-6.04-6.04a.75.75 0 1 0 -1.0601 1.0602l4.7593 4.76h-12.6397a.75.75 0 1 0 0 1.5h12.64l-4.7596 4.76a.75.75 0 1 0 1.0605 1.06l6.04-6.04a.7527.7527 0 0 0 .1618-.8169z"})))};U.displayName="IconArrowRight",U.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},U.defaultProps={title:"ArrowRight",color:null,size:null},U.__docgenInfo={description:"",methods:[],displayName:"IconArrowRight",props:{title:{defaultValue:{value:"'ArrowRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var H=U,G=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.7925 7.7344a2.2473 2.2473 0 1 0 2.2475 2.2475 2.25 2.25 0 0 0 -2.2475-2.2475zm0 2.9946a.7473.7473 0 1 1 .7475-.7471.7481.7481 0 0 1 -.7475.7471z"}),u.a.createElement("path",{d:"m15.6963 8.4951a.75.75 0 0 0 -1.0605 0l-.6894.6894a6.1941 6.1941 0 0 0 -11.9356-1.4177 2.2477 2.2477 0 1 0 1.4834.3015 4.7067 4.7067 0 0 1 8.9123.9623l-.5355-.5355a.75.75 0 0 0 -1.0605 1.0605l1.9126 1.9126a.75.75 0 0 0 1.0605 0l1.9126-1.9126a.75.75 0 0 0 .0001-1.0605z"})))};G.displayName="IconArrowSkip",G.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},G.defaultProps={title:"ArrowSkip",color:null,size:null},G.__docgenInfo={description:"",methods:[],displayName:"IconArrowSkip",props:{title:{defaultValue:{value:"'ArrowSkip'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var R=G,W=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6584 7.4678-1.9062-1.9073a.75.75 0 1 0 -1.0605 1.0606l.6345.6348h-6.0568a10.26 10.26 0 0 0 2.3232-3.211l.2152.7422a.7514.7514 0 0 0 .7207.541.74.74 0 0 0 .209-.03.75.75 0 0 0 .5117-.9292l-.751-2.5879a.783.783 0 0 0 -.1367-.2622.7506.7506 0 0 0 -.7959-.251l-2.5869.7544a.75.75 0 0 0 .42 1.44l.9394-.2742c-1.4122 2.9261-2.9222 4.06-5.3281 4.06h-2.1377a.75.75 0 0 0 -.75.75l.0004.002v.0022a.75.75 0 0 0 .75.75h.1038c.006 0 .0109.0034.0169.0034h2.0658c2.376.0159 3.877 1.1516 5.2789 4.0561l-.94-.2739a.75.75 0 0 0 -.42 1.44l2.5869.7544a.7238.7238 0 0 0 .208.03.7579.7579 0 0 0 .59-.2832.767.767 0 0 0 .1348-.26l.751-2.5879a.75.75 0 0 0 -1.4414-.418l-.2152.7423a10.2837 10.2837 0 0 0 -2.3109-3.2h6.0337l-.6234.6235a.75.75 0 1 0 1.0606 1.0611l1.9063-1.9067a.7567.7567 0 0 0 0-1.0654z"})))};W.displayName="IconArrowSpread",W.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},W.defaultProps={title:"ArrowSpread",color:null,size:null},W.__docgenInfo={description:"",methods:[],displayName:"IconArrowSpread",props:{title:{defaultValue:{value:"'ArrowSpread'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var X=W,Y=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.57 6.2844-6.04-6.04a.75.75 0 0 0 -1.0605 0l-6.04 6.04a.75.75 0 0 0 1.0605 1.0606l4.76-4.7597v12.64a.75.75 0 0 0 1.5 0v-12.6401l4.76 4.76a.75.75 0 1 0 1.06-1.0608z"})))};Y.displayName="IconArrowUp",Y.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Y.defaultProps={title:"ArrowUp",color:null,size:null},Y.__docgenInfo={description:"",methods:[],displayName:"IconArrowUp",props:{title:{defaultValue:{value:"'ArrowUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var K=Y,Z=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.4 6.7383a.7.7 0 0 0 .7.7h3.7715a.7.7 0 0 0 0-1.4h-3.7709a.7.7 0 0 0 -.7006.7z"}),u.a.createElement("path",{d:"m12.8721 8.2729h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z"}),u.a.createElement("path",{d:"m12.8721 10.5083h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z"}),u.a.createElement("path",{d:"m6.6738 6.0381h-3.5361a.7.7 0 0 0 -.7.7v4.47a.7.7 0 0 0 .7.7h3.5361a.7.7 0 0 0 .7-.7v-4.47a.7.7 0 0 0 -.7-.7zm-.7 4.47h-2.1359v-3.07h2.1357z"}),u.a.createElement("path",{d:"m15.1943 2.8745h-5.4648v-.0361a1.4179 1.4179 0 0 0 -1.416-1.4155h-.6279a1.417 1.417 0 0 0 -1.415 1.4155v.0361h-5.4649a.7.7 0 0 0 -.7.7v10.3025a.7.7 0 0 0 .7.7h14.3886a.7.7 0 0 0 .7-.7v-10.3023a.7.7 0 0 0 -.7-.7002zm-7.5234 0h.6582v1.4h-.6582zm6.8232 10.3022h-12.9882v-8.9018h4.7646v.0361a1.417 1.417 0 0 0 1.415 1.4155h.6279a1.4179 1.4179 0 0 0 1.4166-1.4155v-.0361h4.7647v8.9019z"})))};Z.displayName="IconBadge",Z.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Z.defaultProps={title:"Badge",color:null,size:null},Z.__docgenInfo={description:"",methods:[],displayName:"IconBadge",props:{title:{defaultValue:{value:"'Badge'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var J=Z,Q=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.5237 3.1748a2.4426 2.4426 0 0 0 -1.42 2.5727.7.7 0 0 0 .6983.6611l.04-.0015a.7.7 0 0 0 .66-.7378c-.05-.9038.4438-1.1528.5117-1.1831a.7.7 0 0 0 -.4888-1.3115z"}),u.a.createElement("path",{d:"m15.4441 14.4673c-1.5093-1.8726-4.6255-.7515-6.1226-.2119a1.9249 1.9249 0 0 1 -1.5532-.0264 1.6173 1.6173 0 0 1 -.54-.458h.4779a.7.7 0 0 0 .6748-.8867l-.4623-1.6717a5.7087 5.7087 0 1 0 -3.6393 0l-.4623 1.6716a.7.7 0 0 0 .6748.8867h1.05a3.2844 3.2844 0 0 0 1.5461 1.7944 3.1557 3.1557 0 0 0 1.44.3369 3.852 3.852 0 0 0 1.3022-.2358c1.08-.3887 3.6084-1.3 4.4468-.2578a.75.75 0 1 0 1.1679-.9414zm-13.5541-8.6612a4.2087 4.2087 0 1 1 4.2085 4.209 4.213 4.213 0 0 1 -4.2085-4.209zm4.2085 5.709c.15 0 .2974-.0111.4446-.0225l.2429.878h-1.3746l.2429-.878c.1471.0114.2942.0225.4441.0225z"})))};Q.displayName="IconBalloon",Q.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Q.defaultProps={title:"Balloon",color:null,size:null},Q.__docgenInfo={description:"",methods:[],displayName:"IconBalloon",props:{title:{defaultValue:{value:"'Balloon'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $=Q,ee=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4976 12.4153-1.0464-3.13v-2.0053a5.455 5.455 0 0 0 -4.7012-5.3938v-1.1076a.75.75 0 1 0 -1.5 0v1.1076a5.455 5.455 0 0 0 -4.7007 5.3938v2.0049l-1.0469 3.13a.75.75 0 0 0 .7114.9878h3.2062a2.58 2.58 0 0 0 5.16 0h3.2059a.75.75 0 0 0 .7114-.9878zm-6.4976 2.0561a1.0811 1.0811 0 0 1 -1.0784-1.0684h2.1573a1.0815 1.0815 0 0 1 -1.0789 1.0684zm-4.7446-2.5683.7554-2.2583a.7556.7556 0 0 0 .0386-.2378v-2.127a3.9509 3.9509 0 1 1 7.9018 0v2.127a.7556.7556 0 0 0 .0386.2378l.7549 2.2583z"})))};ee.displayName="IconBell",ee.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ee.defaultProps={title:"Bell",color:null,size:null},ee.__docgenInfo={description:"",methods:[],displayName:"IconBell",props:{title:{defaultValue:{value:"'Bell'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var te=ee,ae=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M15.2 15.95H.8a.75.75 0 0 1-.75-.75v-4.8a.75.75 0 0 1 .75-.75h4.05V5.6a.75.75 0 0 1 .75-.75h4.05V.8a.75.75 0 0 1 .75-.75h4.8a.75.75 0 0 1 .75.75v14.4a.75.75 0 0 1-.75.75zm-4.05-1.5h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm9.6-4.8h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm4.8-4.8h3.3v-3.3h-3.3z"})))};ae.displayName="IconBlocks",ae.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ae.defaultProps={title:"Blocks",color:null,size:null},ae.__docgenInfo={description:"",methods:[],displayName:"IconBlocks",props:{title:{defaultValue:{value:"'Blocks'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var le=ae,re=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.45 1.7785a2.017 2.017 0 0 0 -2.8184.166l-7.2196 7.1743a3.03 3.03 0 0 0 -1.2645.3658c-.3232.1807-.6318.3867-.9395.5928-.2217.1484-.4434.2978-.6728.4346a2.78 2.78 0 0 1 -1.6768.5156.75.75 0 0 0 -.6631 1.2139 7.22 7.22 0 0 0 1.9756 1.7725 4.9041 4.9041 0 0 0 2.4795.7109c.0693 0 .1387-.001.208-.0049a3.7971 3.7971 0 0 0 2.6367-1.21 3.0057 3.0057 0 0 0 .7539-1.6658l7.0664-7.29a1.949 1.949 0 0 0 .1346-2.7757zm-9.07 10.7276a2.3227 2.3227 0 0 1 -1.5947.7158 3.4039 3.4039 0 0 1 -1.8535-.501 4.7472 4.7472 0 0 1 -.6182-.4355 6.0144 6.0144 0 0 0 .9922-.4863c.251-.15.4941-.3125.7373-.4756.2744-.1836.5488-.3691.8379-.53a1.5834 1.5834 0 0 1 1.1924-.1279 1.0268 1.0268 0 0 1 .625.5127 1.3188 1.3188 0 0 1 -.3184 1.3278zm7.8672-9.0049-6.4341 6.64a2.4777 2.4777 0 0 0 -.6817-.616l6.5586-6.5182c.2139-.2139.5674-.2988.6992-.167.1528.1524.0522.4668-.1421.6612z"})))};re.displayName="IconBrush",re.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},re.defaultProps={title:"Brush",color:null,size:null},re.__docgenInfo={description:"",methods:[],displayName:"IconBrush",props:{title:{defaultValue:{value:"'Brush'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ne=re,ie=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6943 1.38h-1.5343v-.5958a.7.7 0 0 0 -1.4 0v.5958h-5.52v-.5958a.7.7 0 0 0 -1.4 0v.5958h-1.5343a1.7021 1.7021 0 0 0 -1.7 1.7v11.1358a1.7021 1.7021 0 0 0 1.7 1.7h11.3886a1.7021 1.7021 0 0 0 1.7-1.7v-11.1358a1.7021 1.7021 0 0 0 -1.7-1.7zm-11.3886 1.4h1.5343v.5967a.7.7 0 0 0 1.4 0v-.5967h5.52v.5967a.7.7 0 0 0 1.4 0v-.5967h1.5342a.303.303 0 0 1 .3.3v1.8721h-11.9883v-1.8721a.3031.3031 0 0 1 .2998-.3zm11.3886 11.7356h-11.3886a.303.303 0 0 1 -.3-.3v-7.8631h11.9884v7.8633a.303.303 0 0 1 -.2998.2998z"}),u.a.createElement("path",{d:"m8.3125 7.291a.7011.7011 0 0 0 -.75.1113l-1.36 1.19a.7.7 0 1 0 .9215 1.0532l.1992-.1738v3.63a.7.7 0 1 0 1.4 0v-5.173a.701.701 0 0 0 -.4107-.6377z"})))};ie.displayName="IconCalendar",ie.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ie.defaultProps={title:"Calendar",color:null,size:null},ie.__docgenInfo={description:"",methods:[],displayName:"IconCalendar",props:{title:{defaultValue:{value:"'Calendar'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var oe=ie,ue=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2065 3.4824h-3.7486l-.6005-2.084a.7008.7008 0 0 0 -.6728-.5068h-4.37a.7008.7008 0 0 0 -.6729.5068l-.6 2.084h-3.7482a.7.7 0 0 0 -.7.7v10.2258a.7.7 0 0 0 .7.7h14.413a.7.7 0 0 0 .7-.7v-10.2256a.7.7 0 0 0 -.7-.7002zm-8.8647-1.1904h3.3159l.3433 1.19h-4.002zm8.1645 11.416h-13.0126v-8.8252h13.0127z"}),u.a.createElement("path",{d:"m8 5.6846a3.61 3.61 0 1 0 3.61 3.61 3.6148 3.6148 0 0 0 -3.61-3.61zm0 5.82a2.21 2.21 0 1 1 2.21-2.21 2.2122 2.2122 0 0 1 -2.21 2.2103z"})))};ue.displayName="IconCamera",ue.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ue.defaultProps={title:"Camera",color:null,size:null},ue.__docgenInfo={description:"",methods:[],displayName:"IconCamera",props:{title:{defaultValue:{value:"'Camera'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ce=ue,se=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.7438 4.55c-.605 0-.75.35-.3222.7778l5.8006 5.8006a1.1032 1.1032 0 0 0 1.5556 0l5.8006-5.8006c.4278-.4278.2828-.7778-.3222-.7778z"})))};se.displayName="IconCaretDown",se.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},se.defaultProps={title:"CaretDown",color:null,size:null},se.__docgenInfo={description:"",methods:[],displayName:"IconCaretDown",props:{title:{defaultValue:{value:"'CaretDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var de=se,pe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.45 1.7437c0-.605-.35-.75-.7778-.3222l-5.801 5.8007a1.1032 1.1032 0 0 0 0 1.5556l5.8006 5.8006c.4278.4278.7778.2828.7778-.3222z"})))};pe.displayName="IconCaretLeft",pe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},pe.defaultProps={title:"CaretLeft",color:null,size:null},pe.__docgenInfo={description:"",methods:[],displayName:"IconCaretLeft",props:{title:{defaultValue:{value:"'CaretLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var me=pe,ge=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.55 14.2562c0 .605.35.75.7778.3222l5.8006-5.8006a1.1032 1.1032 0 0 0 0-1.5556l-5.8002-5.8006c-.4282-.4278-.7782-.2828-.7782.3222z"})))};ge.displayName="IconCaretRight",ge.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ge.defaultProps={title:"CaretRight",color:null,size:null},ge.__docgenInfo={description:"",methods:[],displayName:"IconCaretRight",props:{title:{defaultValue:{value:"'CaretRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ze=ge,ve=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.2563 11.45c.605 0 .75-.35.3222-.7778l-5.8007-5.801a1.1032 1.1032 0 0 0 -1.5556 0l-5.8006 5.8006c-.4278.4278-.2828.7778.3222.7778h12.5125z"})))};ve.displayName="IconCaretUp",ve.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ve.defaultProps={title:"CaretUp",color:null,size:null},ve.__docgenInfo={description:"",methods:[],displayName:"IconCaretUp",props:{title:{defaultValue:{value:"'CaretUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var he=ve,fe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.8884 6.7694c.605 0 .75-.35.3222-.7778l-5.4328-5.4328a1.1033 1.1033 0 0 0 -1.5557 0l-5.4327 5.4328c-.4278.4278-.2828.7778.3222.7778z"}),u.a.createElement("path",{d:"m2.1116 9.2306c-.605 0-.75.35-.3222.7778l5.4328 5.4328a1.1033 1.1033 0 0 0 1.5557 0l5.4328-5.4328c.4278-.4278.2828-.7778-.3222-.7778z"})))};fe.displayName="IconCaretUpDown",fe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},fe.defaultProps={title:"CaretUpDown",color:null,size:null},fe.__docgenInfo={description:"",methods:[],displayName:"IconCaretUpDown",props:{title:{defaultValue:{value:"'CaretUpDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ye=fe,Ie=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.746 3.2629a.75.75 0 0 0 -.5781-.272h-10.6861l-.1113-1.8886a.75.75 0 0 0 -.7485-.7061h-2.7901a.75.75 0 1 0 0 1.5h2.083l.4439 7.5259a.75.75 0 0 0 .7485.706h9.9827a.7506.7506 0 0 0 .7368-.6094l1.0776-5.6372a.75.75 0 0 0 -.1584-.6186zm-2.276 5.3653h-8.6556l-.2437-4.1372h9.69z"}),u.a.createElement("path",{d:"m5.5448 11.3289a2.1375 2.1375 0 1 0 2.1372 2.1372 2.14 2.14 0 0 0 -2.1372-2.1372zm0 2.8745a.7371.7371 0 1 1 .7368-.7373.7379.7379 0 0 1 -.7368.7373z"}),u.a.createElement("path",{d:"m12.1576 11.3289a2.1375 2.1375 0 1 0 2.1377 2.1372 2.14 2.14 0 0 0 -2.1377-2.1372zm0 2.8745a.7371.7371 0 1 1 .7373-.7373.7378.7378 0 0 1 -.7373.7373z"})))};Ie.displayName="IconCart",Ie.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ie.defaultProps={title:"Cart",color:null,size:null},Ie.__docgenInfo={description:"",methods:[],displayName:"IconCart",props:{title:{defaultValue:{value:"'Cart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ee=Ie,Ve=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8389 8.9814h-1.6055v-2.663a.7.7 0 0 0 -.7-.7h-4.3654v-2.6624a.7.7 0 0 0 -.7-.7h-5.6067v-1.2746a.7.7 0 0 0 -1.4 0v14.0372a.7.7 0 1 0 1.4 0v-1.2745h12.9776a.7.7 0 0 0 .7-.7v-3.3625a.7.7 0 0 0 -.7-.7002zm-3.0059 0h-9.9707v-1.9629h9.9707zm-9.9707-5.3252h4.9053v1.962h-4.9053zm12.2764 8.6875h-12.2764v-1.9619h12.2764z"})))};Ve.displayName="IconChartBarHorz",Ve.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ve.defaultProps={title:"ChartBarHorz",color:null,size:null},Ve.__docgenInfo={description:"",methods:[],displayName:"IconChartBarHorz",props:{title:{defaultValue:{value:"'ChartBarHorz'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qe=Ve,be=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0185 14.1387h-1.2744v-12.9776a.7.7 0 0 0 -.7-.7h-3.3625a.7.7 0 0 0 -.7.7v1.6055h-2.6632a.7.7 0 0 0 -.7.7v4.3654h-2.6624a.7.7 0 0 0 -.7.7v5.6065h-1.2746a.7.7 0 0 0 0 1.4h14.0372a.7.7 0 1 0 0-1.4zm-4.6367-12.2774h1.9619v12.2764h-1.9619zm-3.3633 2.3057h1.9629v9.9707h-1.9629zm-3.3623 5.0654h1.962v4.9053h-1.962z"})))};be.displayName="IconChartBarVert",be.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},be.defaultProps={title:"ChartBarVert",color:null,size:null},be.__docgenInfo={description:"",methods:[],displayName:"IconChartBarVert",props:{title:{defaultValue:{value:"'ChartBarVert'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ne=be,_e=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8538 11.9136a7.84 7.84 0 0 0 0-7.8271c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0222-.022-.0312-.0353a7.9476 7.9476 0 0 0 -2.8259-2.826c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0061-.0242.012-.0357zm-6.1538-7.9287v-2.4456a6.44 6.44 0 0 1 1.9222.5181l-1.2233 2.1192a4.0331 4.0331 0 0 0 -.6989-.1917zm-.7 1.3295a2.6855 2.6855 0 1 1 -2.6856 2.6856 2.689 2.689 0 0 1 2.6856-2.6856zm3.8234 1.2866 2.1193-1.2235a6.4482 6.4482 0 0 1 0 5.2448l-2.1194-1.2231a3.8586 3.8586 0 0 0 0-2.7982zm1.4148-2.4334-2.12 1.2238a4.09 4.09 0 0 0 -.51-.51l1.2238-2.12a6.546 6.546 0 0 1 1.4062 1.4063zm-5.2382 10.3324a6.4992 6.4992 0 0 1 -.7-12.9607v2.4456a4.0789 4.0789 0 1 0 3.8184 6.6238l2.12 1.2236a6.4887 6.4887 0 0 1 -5.2384 2.6677z"})))};_e.displayName="IconChartDonut",_e.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_e.defaultProps={title:"ChartDonut",color:null,size:null},_e.__docgenInfo={description:"",methods:[],displayName:"IconChartDonut",props:{title:{defaultValue:{value:"'ChartDonut'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var we=_e,xe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.95 7.95 0 0 0 -7.95-7.95zm0 4.8891a3.0609 3.0609 0 1 1 -3.0609 3.0609 3.0609 3.0609 0 0 1 3.0609-3.0609zm0 9.3053a6.2444 6.2444 0 0 1 -6.2444-6.2444v-.0027a.5185.5185 0 1 1 1.0369 0l.0025.0027a5.205 5.205 0 1 0 5.205-5.2049v-1.0394a6.2444 6.2444 0 1 1 0 12.4887z"})))};xe.displayName="IconChartDonutFilled",xe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},xe.defaultProps={title:"ChartDonutFilled",color:null,size:null},xe.__docgenInfo={description:"",methods:[],displayName:"IconChartDonutFilled",props:{title:{defaultValue:{value:"'ChartDonutFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Te=xe,Pe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.7813.8164a2.1616 2.1616 0 0 0 -2.1582 2.1592 2.1377 2.1377 0 0 0 .46 1.3164l-2.5626 4.1357-2.3916-3.0312a.71.71 0 0 0 -.6358-.2832.7482.7482 0 0 0 -.5957.36l-3.2774 5.4325a2.1577 2.1577 0 1 0 1.757 2.1186 2.1381 2.1381 0 0 0 -.4762-1.3359l2.7213-4.5118 2.3838 3.0205a.75.75 0 0 0 1.2266-.0693l3.1209-5.0364a2.159 2.159 0 1 0 .4279-4.2751zm-11.5625 12.9668a.7588.7588 0 1 1 .7578-.7588.7589.7589 0 0 1 -.7578.7588zm11.5625-10.0488a.7588.7588 0 1 1 .7588-.7588.7587.7587 0 0 1 -.7588.7588z"})))};Pe.displayName="IconChartLine",Pe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Pe.defaultProps={title:"ChartLine",color:null,size:null},Pe.__docgenInfo={description:"",methods:[],displayName:"IconChartLine",props:{title:{defaultValue:{value:"'ChartLine'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Be=Pe,Oe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8538 11.9135a7.84 7.84 0 0 0 0-7.827c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0223-.0221-.0313-.0355a7.9482 7.9482 0 0 0 -2.8258-2.8258c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0062-.0243.012-.0358zm-6.1538-10.3742a6.44 6.44 0 0 1 1.9222.5181l-1.9222 3.3296zm5.8 6.4607a6.4553 6.4553 0 0 1 -.5573 2.6224l-4.5427-2.6224 4.5426-2.6224a6.4553 6.4553 0 0 1 .5574 2.6224zm-1.2618-3.8323-3.3261 1.92 1.92-3.3261a6.5459 6.5459 0 0 1 1.4061 1.4061zm-5.2382 10.3323a6.4992 6.4992 0 0 1 -.7-12.9607v6.4607c0 .0147.0075.0269.0084.0414a.6676.6676 0 0 0 .0123.0909.7319.7319 0 0 0 .06.178c.0064.0127.006.0269.0132.0393.0061.01.018.0143.0245.0244a.6711.6711 0 0 0 .0585.0792.681.681 0 0 0 .11.0971.6594.6594 0 0 0 .0637.0562l5.5878 3.2258a6.4887 6.4887 0 0 1 -5.2384 2.6677z"})))};Oe.displayName="IconChartPie",Oe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Oe.defaultProps={title:"ChartPie",color:null,size:null},Oe.__docgenInfo={description:"",methods:[],displayName:"IconChartPie",props:{title:{defaultValue:{value:"'ChartPie'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ce=Oe,je=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.12 9.3642a.7517.7517 0 0 0 -.9072.55 5.8884 5.8884 0 1 1 -7.3105-7.0793.75.75 0 0 0 -.4043-1.4443 7.3886 7.3886 0 1 0 9.172 8.8809.75.75 0 0 0 -.55-.9073z"}),u.a.createElement("path",{d:"m8.5049.1074a.75.75 0 0 0 -.75.75v6.6377a.75.75 0 0 0 .75.75h6.6377a.75.75 0 0 0 .75-.75 7.3962 7.3962 0 0 0 -7.3877-7.3877zm.75 6.6377v-5.09a5.9 5.9 0 0 1 5.09 5.09z"})))};je.displayName="IconChartSegment",je.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},je.defaultProps={title:"ChartSegment",color:null,size:null},je.__docgenInfo={description:"",methods:[],displayName:"IconChartSegment",props:{title:{defaultValue:{value:"'ChartSegment'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Le=je,Ae=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.6372 4.3755h-2.958v-1.8008a1.2139 1.2139 0 0 0 -1.2041-1.2207h-9.1094a1.216 1.216 0 0 0 -1.208 1.2207v6.0908a1.2181 1.2181 0 0 0 1.208 1.2245h.916l.002 1.0381a.7.7 0 0 0 1.2256.46l.8125-.924v1.2249a1.2139 1.2139 0 0 0 1.2041 1.221h5.6494l1.3184 1.498a.7.7 0 0 0 1.2256-.4619v-1.0361h.918a1.2148 1.2148 0 0 0 1.2051-1.2207v-6.0931a1.2147 1.2147 0 0 0 -1.2052-1.2207zm-10.6523 4.3525-.3125.3555a.7011.7011 0 0 0 -.6924-.5935h-1.4219v-5.7356h8.7207v1.6211h-4.7529a1.2139 1.2139 0 0 0 -1.2041 1.2207v2.9343a.6865.6865 0 0 0 -.3369.1975zm10.457 2.7812h-1.4219a.7.7 0 0 0 -.6914.5918l-.3115-.3535a.6991.6991 0 0 0 -.5254-.2383h-5.77v-5.7333h8.72z"})))};Ae.displayName="IconChat",Ae.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ae.defaultProps={title:"Chat",color:null,size:null},Ae.__docgenInfo={description:"",methods:[],displayName:"IconChat",props:{title:{defaultValue:{value:"'Chat'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Se=Ae,ke=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m6.4372 13.125a.7475.7475 0 0 1 -.53-.22l-5.6247-5.6242a.75.75 0 0 1 1.0605-1.0608l5.0942 5.0942 8.22-8.22a.75.75 0 0 1 1.0605 1.0605l-8.75 8.75a.7476.7476 0 0 1 -.5305.2203z"})))};ke.displayName="IconCheck",ke.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ke.defaultProps={title:"Check",color:null,size:null},ke.__docgenInfo={description:"",methods:[],displayName:"IconCheck",props:{title:{defaultValue:{value:"'Check'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var De=ke,Fe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6646 2.33a.75.75 0 0 0 -1.0605 0l-7.2341 7.234-3.2191-3.2193a.75.75 0 1 0 -1.0609 1.0606l3.75 3.75a.75.75 0 0 0 1.0605 0l7.7642-7.7642a.75.75 0 0 0 -.0001-1.0611z"}),u.a.createElement("path",{d:"m13.8457 7.12a.75.75 0 0 0 -.75.75v6.5835h-11.48v-12.9071h11.5288a.75.75 0 0 0 0-1.5h-12.2788a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-7.3336a.75.75 0 0 0 -.75-.75z"})))};Fe.displayName="IconCheckBox",Fe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Fe.defaultProps={title:"CheckBox",color:null,size:null},Fe.__docgenInfo={description:"",methods:[],displayName:"IconCheckBox",props:{title:{defaultValue:{value:"'CheckBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Me=Fe,Ue=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8877 7.3a.75.75 0 0 0 -1.4941.1328c.0166.1865.0244.376.0244.5669a6.4161 6.4161 0 1 1 -2.83-5.3228.75.75 0 0 0 .84-1.2432 7.9194 7.9194 0 1 0 3.49 6.5663q0-.3538-.0303-.7z"}),u.a.createElement("path",{d:"m5.2451 6.4853a.75.75 0 0 0 -1.0605 1.0606l3.2854 3.2841a.75.75 0 0 0 1.0605 0l6.8005-6.8007a.75.75 0 0 0 -1.061-1.0606l-6.27 6.2706z"})))};Ue.displayName="IconCheckCircle",Ue.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ue.defaultProps={title:"CheckCircle",color:null,size:null},Ue.__docgenInfo={description:"",methods:[],displayName:"IconCheckCircle",props:{title:{defaultValue:{value:"'CheckCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var He=Ue,Ge=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 11.77a.7494.7494 0 0 1 -.53-.22l-6.04-6.04a.75.75 0 1 1 1.0607-1.06l5.5093 5.5095 5.5088-5.51a.75.75 0 0 1 1.0612 1.0605l-6.0392 6.04a.75.75 0 0 1 -.5308.22z"})))};Ge.displayName="IconChevronDown",Ge.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ge.defaultProps={title:"ChevronDown",color:null,size:null},Ge.__docgenInfo={description:"",methods:[],displayName:"IconChevronDown",props:{title:{defaultValue:{value:"'ChevronDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Re=Ge,We=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.02 14.79a.7467.7467 0 0 1 -.53-.22l-6.04-6.0395a.75.75 0 0 1 0-1.0605l6.0391-6.04a.75.75 0 1 1 1.0609 1.06l-5.509 5.51 5.509 5.51a.75.75 0 0 1 -.53 1.28z"})))};We.displayName="IconChevronLeft",We.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},We.defaultProps={title:"ChevronLeft",color:null,size:null},We.__docgenInfo={description:"",methods:[],displayName:"IconChevronLeft",props:{title:{defaultValue:{value:"'ChevronLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xe=We,Ye=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.98 14.79a.75.75 0 0 1 -.53-1.28l5.5095-5.51-5.5095-5.51a.75.75 0 0 1 1.06-1.06l6.04 6.04a.75.75 0 0 1 0 1.0605l-6.04 6.0395a.7467.7467 0 0 1 -.53.22z"})))};Ye.displayName="IconChevronRight",Ye.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ye.defaultProps={title:"ChevronRight",color:null,size:null},Ye.__docgenInfo={description:"",methods:[],displayName:"IconChevronRight",props:{title:{defaultValue:{value:"'ChevronRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ke=Ye,Ze=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.04 11.77a.7467.7467 0 0 1 -.53-.22l-5.51-5.5095-5.51 5.51a.75.75 0 1 1 -1.06-1.0605l6.04-6.04a.75.75 0 0 1 .53-.22.7494.7494 0 0 1 .53.22l6.04 6.04a.75.75 0 0 1 -.53 1.28z"})))};Ze.displayName="IconChevronUp",Ze.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ze.defaultProps={title:"ChevronUp",color:null,size:null},Ze.__docgenInfo={description:"",methods:[],displayName:"IconChevronUp",props:{title:{defaultValue:{value:"'ChevronUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Je=Ze,Qe=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 15.8574a7.8574 7.8574 0 1 1 7.8572-7.8574 7.8661 7.8661 0 0 1 -7.8572 7.8574zm0-14.2148a6.3574 6.3574 0 1 0 6.3572 6.3574 6.3645 6.3645 0 0 0 -6.3572-6.3574z"})))};Qe.displayName="IconCircle",Qe.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Qe.defaultProps={title:"Circle",color:null,size:null},Qe.__docgenInfo={description:"",methods:[],displayName:"IconCircle",props:{title:{defaultValue:{value:"'Circle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $e=Qe,et=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .0874a7.9126 7.9126 0 1 0 7.9128 7.9126 7.9217 7.9217 0 0 0 -7.9128-7.9126zm0 14.3252a6.4126 6.4126 0 1 1 6.4128-6.4126 6.42 6.42 0 0 1 -6.4128 6.4126z"}),u.a.createElement("path",{d:"m12.6746 9.896-3.9246-2.3243v-3.9917a.75.75 0 1 0 -1.5 0v4.42a.6964.6964 0 0 0 .0175.0865.7258.7258 0 0 0 .0308.1525.94.94 0 0 0 .14.2449.7266.7266 0 0 0 .1112.1.7083.7083 0 0 0 .068.0613l4.2925 2.5418a.75.75 0 0 0 .7646-1.291z"})))};et.displayName="IconClock",et.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},et.defaultProps={title:"Clock",color:null,size:null},et.__docgenInfo={description:"",methods:[],displayName:"IconClock",props:{title:{defaultValue:{value:"'Clock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tt=et,at=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1826 5.79h-3.4883v-3.663a.75.75 0 0 0 -.75-.75h-10.1269a.75.75 0 0 0 -.75.75v7.333a.75.75 0 0 0 .75.75h3.4883v3.663a.75.75 0 0 0 .75.75h10.1269a.75.75 0 0 0 .75-.75v-7.333a.75.75 0 0 0 -.75-.75zm-13.6152 2.92v-5.833h8.627v2.913h-5.1387a.75.75 0 0 0 -.75.75v2.17zm12.8652 4.413h-8.6269v-5.833h8.6269z"})))};at.displayName="IconClone",at.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},at.defaultProps={title:"Clone",color:null,size:null},at.__docgenInfo={description:"",methods:[],displayName:"IconClone",props:{title:{defaultValue:{value:"'Clone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var lt=at,rt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6689 8.2637a5.3086 5.3086 0 1 0 -10.3534-2.305 4.2991 4.2991 0 0 0 1.0678 8.4656h8.3877a3.1445 3.1445 0 0 0 .8979-6.1606zm-.8979 4.6606h-8.3877a2.8079 2.8079 0 1 1 .7944-5.502.75.75 0 0 0 .4229-1.4394 4.2852 4.2852 0 0 0 -.7358-.14 3.8234 3.8234 0 1 1 6.1166 4.001.75.75 0 1 0 .959 1.1533 5.3486 5.3486 0 0 0 .7949-.8193 5.3688 5.3688 0 0 0 .3472-.5286 1.6523 1.6523 0 0 1 -.3116 3.2752z"})))};rt.displayName="IconCloud",rt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},rt.defaultProps={title:"Cloud",color:null,size:null},rt.__docgenInfo={description:"",methods:[],displayName:"IconCloud",props:{title:{defaultValue:{value:"'Cloud'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nt=rt,it=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.1821 6.9551a4.7865 4.7865 0 0 0 .1328-1.1172 4.9125 4.9125 0 0 0 -4.9072-4.9072 4.8593 4.8593 0 0 0 -4.291 2.5449 2.898 2.898 0 0 0 -.4009-.0283 2.9707 2.9707 0 0 0 -2.9673 2.9677 2.8726 2.8726 0 0 0 .0532.5488 3.47 3.47 0 0 0 -1.7685 3.0313 3.506 3.506 0 0 0 3.5019 3.502h2.0137a.75.75 0 0 0 0-1.5h-2.0136a1.9941 1.9941 0 0 1 -.5869-3.9023.75.75 0 0 0 .4531-1.0448 1.4437 1.4437 0 0 1 -.1528-.6348 1.4767 1.4767 0 0 1 2.0088-1.36.7509.7509 0 0 0 .977-.4287 3.3992 3.3992 0 1 1 6.3325 2.4717.75.75 0 0 0 .478.9951 1.9837 1.9837 0 0 1 1.4219 1.9023 2.0044 2.0044 0 0 1 -2.002 2.002h-2.0141a.75.75 0 1 0 0 1.5h2.0142a3.506 3.506 0 0 0 3.502-3.502 3.4662 3.4662 0 0 0 -1.7848-3.0405z"}),u.a.createElement("path",{d:"m9.92 10.0391a.75.75 0 1 0 1.061-1.0606l-2.451-2.4502a.7527.7527 0 0 0 -1.0605 0l-2.4512 2.45a.75.75 0 1 0 1.0605 1.0605l1.1712-1.17v5.4506a.75.75 0 1 0 1.5 0v-5.4504z"})))};it.displayName="IconCloudArrow",it.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},it.defaultProps={title:"CloudArrow",color:null,size:null},it.__docgenInfo={description:"",methods:[],displayName:"IconCloudArrow",props:{title:{defaultValue:{value:"'CloudArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ot=it,ut=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.3594.6035h-4.7188a5.6035 5.6035 0 0 0 0 11.207h1.6094v2.8359a.7512.7512 0 0 0 .4385.6826.7588.7588 0 0 0 .3115.0675.7494.7494 0 0 0 .4922-.1836l5.7978-5.0381c.0137-.0117.0264-.0244.0391-.0371a5.5412 5.5412 0 0 0 1.6338-3.9307 5.61 5.61 0 0 0 -5.6035-5.6035zm2.9248 8.457-4.5342 3.9405v-1.94a.75.75 0 0 0 -.75-.75h-2.3594a4.1035 4.1035 0 0 1 0-8.207h4.7187a4.1082 4.1082 0 0 1 4.1036 4.103 4.0463 4.0463 0 0 1 -1.1787 2.8535z"})))};ut.displayName="IconComment",ut.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ut.defaultProps={title:"Comment",color:null,size:null},ut.__docgenInfo={description:"",methods:[],displayName:"IconComment",props:{title:{defaultValue:{value:"'Comment'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ct=ut,st=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.7926 4.3838a.7414.7414 0 0 0 -1.0485 1.0485l3.1759 3.1771a.7412.7412 0 0 0 1.0484 0l6.4516-6.4509a.7414.7414 0 1 0 -1.0488-1.0485l-5.9266 5.9268z"}),u.a.createElement("path",{d:"m15.8638 6.2316a5.6034 5.6034 0 0 0 -.0608-.8206.7419.7419 0 0 0 -1.4674.22 3.9891 3.9891 0 0 1 -1.1264 3.4241l-4.4673 3.8832v-1.9144a.7416.7416 0 0 0 -.7419-.7414h-2.33a4.0514 4.0514 0 1 1 0-8.1027h5.24a.7414.7414 0 0 0 0-1.4829h-5.2391a5.5342 5.5342 0 1 0 0 11.0685h1.5881v2.8a.7575.7575 0 0 0 .4335.6748.7872.7872 0 0 0 .7945-.1149l5.7249-4.9757-.006-.007c.0139-.0119.0315-.0164.0447-.03a5.4657 5.4657 0 0 0 1.6132-3.881z"})))};st.displayName="IconCommentCheck",st.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},st.defaultProps={title:"CommentCheck",color:null,size:null},st.__docgenInfo={description:"",methods:[],displayName:"IconCommentCheck",props:{title:{defaultValue:{value:"'CommentCheck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dt=st,pt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.2436.93h-4.4873a5.3652 5.3652 0 0 0 0 10.73h1.4937v2.66a.75.75 0 0 0 1.2417.5659l5.5137-4.791c.0137-.0117.0273-.0239.04-.0366a5.3073 5.3073 0 0 0 1.5635-3.7637 5.3712 5.3712 0 0 0 -5.3653-5.3646z"})))};pt.displayName="IconCommentFilled",pt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},pt.defaultProps={title:"CommentFilled",color:null,size:null},pt.__docgenInfo={description:"",methods:[],displayName:"IconCommentFilled",props:{title:{defaultValue:{value:"'CommentFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var mt=pt,gt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.97 7.97 7.9787 7.9787 0 0 0 -7.97-7.97zm0 14.44a6.47 6.47 0 1 1 6.47-6.47 6.4773 6.4773 0 0 1 -6.47 6.47z"}),u.a.createElement("path",{d:"m9.8665 6.1333a.75.75 0 1 0 1.0605-1.0605 4.14 4.14 0 1 0 0 5.8535.75.75 0 1 0 -1.0605-1.0606 2.7 2.7 0 0 1 -3.7329 0 2.6394 2.6394 0 1 1 3.7329-3.7324z"})))};gt.displayName="IconCopyright",gt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},gt.defaultProps={title:"Copyright",color:null,size:null},gt.__docgenInfo={description:"",methods:[],displayName:"IconCopyright",props:{title:{defaultValue:{value:"'Copyright'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var zt=gt,vt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6357 2.3672a7.9653 7.9653 0 1 0 0 11.2705 7.9164 7.9164 0 0 0 0-11.2705zm-1.0605 1.0605a6.4766 6.4766 0 0 1 .497 8.5858l-9.0839-9.0828a6.462 6.462 0 0 1 8.5869.4971zm-9.15 9.1494a6.4766 6.4766 0 0 1 -.4969-8.5858l9.0834 9.0825a6.4791 6.4791 0 0 1 -8.5869-.4967z"})))};vt.displayName="IconDanger",vt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},vt.defaultProps={title:"Danger",color:null,size:null},vt.__docgenInfo={description:"",methods:[],displayName:"IconDanger",props:{title:{defaultValue:{value:"'Danger'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ht=vt,ft=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 11.8784a2 2 0 0 0 1.3146-3.5136l.7772-2.0655a.7.7 0 0 0 -1.3105-.4932l-.774 2.0569-.0073-.0007a2.0081 2.0081 0 0 0 0 4.0161zm0-2.6157a.6077.6077 0 1 1 -.6074.6079.6082.6082 0 0 1 .6074-.6079z"}),u.a.createElement("path",{d:"m15.8877 9.8706a7.8787 7.8787 0 0 0 -.1211-1.33c-.0016-.0136.0034-.0263.001-.04-.002-.0109-.0092-.019-.0117-.03a7.8824 7.8824 0 0 0 -2.6607-4.6116c-.01-.0094-.0143-.0222-.0249-.0311-.0071-.006-.0162-.0071-.0235-.0128a7.8646 7.8646 0 0 0 -10.0936 0c-.0073.0057-.0164.0068-.0235.0128-.0106.0089-.015.0217-.0249.0311a7.8825 7.8825 0 0 0 -2.6607 4.611c-.0024.0109-.01.019-.0117.03-.0024.0137.0026.0263.001.04a7.7236 7.7236 0 0 0 .7988 5.0184.6854.6854 0 0 0 .033.0707l.009.0194c.0032.0058.01.0077.0131.0134a.6869.6869 0 0 0 .2322.2385c.0112.007.02.0151.0318.0214a.6812.6812 0 0 0 .3323.0954h12.625a.6888.6888 0 0 0 .5806-.3318.6526.6526 0 0 0 .0464-.0554 7.9037 7.9037 0 0 0 .9521-3.7594zm-12.5644-4.4847.6718.8011a.7.7 0 1 0 1.0723-.8994l-.6754-.8054a6.4462 6.4462 0 0 1 2.908-1.06v1.0524a.7.7 0 1 0 1.4 0v-1.0524a6.4462 6.4462 0 0 1 2.9078 1.06l-.6754.8054a.7.7 0 1 0 1.0723.8994l.6718-.8011a6.4832 6.4832 0 0 1 1.549 2.6757l-1.0342.1826a.7.7 0 1 0 .2441 1.3789l1.03-.1818c.0094.1426.0218.2844.0218.4294a6.4994 6.4994 0 0 1 -.6221 2.7466h-11.7303a6.497 6.497 0 0 1 -.6221-2.7466c0-.145.0124-.2868.0218-.4294l1.03.1818a.7.7 0 0 0 .2441-1.3789l-1.0342-.1826a6.4832 6.4832 0 0 1 1.5489-2.6757z"})))};ft.displayName="IconDashboard",ft.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ft.defaultProps={title:"Dashboard",color:null,size:null},ft.__docgenInfo={description:"",methods:[],displayName:"IconDashboard",props:{title:{defaultValue:{value:"'Dashboard'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var yt=ft,It=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.1773 1.1894h-12.3545a1.7021 1.7021 0 0 0 -1.7 1.7v7.4824a1.7021 1.7021 0 0 0 1.7 1.7h3.9658l-.4847 1.3382h-1.2199a.7.7 0 1 0 0 1.4h7.832a.7.7 0 0 0 0-1.4h-1.22l-.4847-1.3379h3.9658a1.7021 1.7021 0 0 0 1.7-1.7v-7.4821a1.7021 1.7021 0 0 0 -1.6998-1.7006zm-4.9703 12.2206h-2.414l.4847-1.3379h1.4447zm5.27-3.0381a.3.3 0 0 1 -.3.3h-12.3542a.3.3 0 0 1 -.3-.3v-7.4819a.3.3 0 0 1 .3-.3h12.3544a.3.3 0 0 1 .3.3z"})))};It.displayName="IconDesktop",It.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},It.defaultProps={title:"Desktop",color:null,size:null},It.__docgenInfo={description:"",methods:[],displayName:"IconDesktop",props:{title:{defaultValue:{value:"'Desktop'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Et=It,Vt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4845.0425h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5236a.7433.7433 0 0 0 -.2158.55v10.871a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.4146a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.02h-2.02zm8.918 12.3849h-11.4687v-8.8646h3.3008a.75.75 0 0 0 .75-.75v-3.3h7.418z"})))};Vt.displayName="IconDocument",Vt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Vt.defaultProps={title:"Document",color:null,size:null},Vt.__docgenInfo={description:"",methods:[],displayName:"IconDocument",props:{title:{defaultValue:{value:"'Document'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qt=Vt,bt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.2545 10.671-2.0971-2.0968a.75.75 0 0 0 -1.0606 1.0606l3.3774 3.377a.7527.7527 0 0 0 1.0605 0l3.377-3.377a.75.75 0 0 0 -1.0605-1.0605l-2.0967 2.0966v-4.6582a.75.75 0 0 0 -1.5 0z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-11.4687v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};bt.displayName="IconDocumentArrow",bt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},bt.defaultProps={title:"DocumentArrow",color:null,size:null},bt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentArrow",props:{title:{defaultValue:{value:"'DocumentArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Nt=bt,_t=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5185 3.2832h-2.356v-2.3555a.75.75 0 0 0 -.75-.75h-6.2836a.7608.7608 0 0 0 -.53.22l-3.6477 3.6472a.7608.7608 0 0 0 -.22.53v7.3916a.75.75 0 0 0 .75.75h2.3562v2.3555a.75.75 0 0 0 .75.75h9.9312a.75.75 0 0 0 .75-.75v-11.0388a.75.75 0 0 0 -.7501-.75zm-9.9546-.73v1.4568h-1.4565zm-2.3325 2.9568h3.0826a.75.75 0 0 0 .75-.75v-3.0823h4.5986v9.5391h-8.4312zm11.5371 8.8125h-8.4311v-1.6057h6.0752a.75.75 0 0 0 .75-.75v-7.1836h1.606z"})))};_t.displayName="IconDocumentClone",_t.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_t.defaultProps={title:"DocumentClone",color:null,size:null},_t.__docgenInfo={description:"",methods:[],displayName:"IconDocumentClone",props:{title:{defaultValue:{value:"'DocumentClone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wt=_t,xt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.3628.1875h-12.7256a.75.75 0 0 0 -.75.75v14.125a.75.75 0 0 0 .75.75h12.7256a.75.75 0 0 0 .75-.75v-14.125a.75.75 0 0 0 -.75-.75zm-.75 14.125h-11.2256v-12.625h11.2256z"}),u.a.createElement("path",{d:"m6.895 6.0313h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m4.28 6.09a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07.8924.8924 0 0 0 .54-.81.8947.8947 0 0 0 -.26-.62.92.92 0 0 0 -1.24 0 .8834.8834 0 0 0 -.25.62.8542.8542 0 0 0 .54.81z"}),u.a.createElement("path",{d:"m4.28 8.81a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07 1.0578 1.0578 0 0 0 .28-.19.8719.8719 0 0 0 .26-.62.7543.7543 0 0 0 -.07-.33.81.81 0 0 0 -.19-.29.9018.9018 0 0 0 -.95-.19.9414.9414 0 0 0 -.48.48.916.916 0 0 0 -.06.33.87.87 0 0 0 .26.62.9127.9127 0 0 0 .28.19z"}),u.a.createElement("path",{d:"m6.895 8.75h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m3.99 11.34a.9035.9035 0 0 0 .62.25.9934.9934 0 0 0 .34-.06 1.085 1.085 0 0 0 .28-.19.81.81 0 0 0 .19-.29.726.726 0 0 0 .07-.33.8.8 0 0 0 -.07-.34.8744.8744 0 0 0 -.19-.28.8736.8736 0 0 0 -1.24 0 .8355.8355 0 0 0 -.18.28.7933.7933 0 0 0 -.07.34.8788.8788 0 0 0 .06.33.9634.9634 0 0 0 .19.29z"}),u.a.createElement("path",{d:"m6.895 11.4688h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"})))};xt.displayName="IconDocumentList",xt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},xt.defaultProps={title:"DocumentList",color:null,size:null},xt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentList",props:{title:{defaultValue:{value:"'DocumentList'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Tt=xt,Pt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.2482 8.3848h-2.5933a.75.75 0 0 0 0 1.5h2.5933v2.5937a.75.75 0 1 0 1.5 0v-2.5937h2.5933a.75.75 0 0 0 0-1.5h-2.5933v-2.5928a.75.75 0 0 0 -1.5 0z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-11.4687v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};Pt.displayName="IconDocumentPlus",Pt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Pt.defaultProps={title:"DocumentPlus",color:null,size:null},Pt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentPlus",props:{title:{defaultValue:{value:"'DocumentPlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Bt=Pt,Ot=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7432 12.8037-2.31-2.31a4.3289 4.3289 0 0 0 -1.4194-6.2927v-2.5535a.75.75 0 0 0 -.75-.75h-6.901a.7607.7607 0 0 0 -.53.22l-3.576 3.5754a.7609.7609 0 0 0 -.22.53v9.1294a.75.75 0 0 0 .75.75h10.4774a.75.75 0 0 0 .75-.75v-2.584c.1215-.0693.2449-.1335.3588-.2137l2.31 2.31a.75.75 0 0 0 1.0605-1.0605zm-5.8794-1.9468a2.8721 2.8721 0 1 1 2.8726-2.8721 2.8755 2.8755 0 0 1 -2.8726 2.8721zm-5.9131-7.7369v1.691h-1.6907zm6.5635 10.4824h-8.9771v-7.2914h3.1636a.75.75 0 0 0 .75-.75v-3.1635h5.0635v1.281a4.32 4.32 0 0 0 -.65-.0657 4.3721 4.3721 0 1 0 0 8.7441 4.3216 4.3216 0 0 0 .65-.0657z"})))};Ot.displayName="IconDocumentSearch",Ot.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ot.defaultProps={title:"DocumentSearch",color:null,size:null},Ot.__docgenInfo={description:"",methods:[],displayName:"IconDocumentSearch",props:{title:{defaultValue:{value:"'DocumentSearch'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ct=Ot,jt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 10.7448c1.4893 0 2.271-2.3412 1.6728-3.6546a1.7923 1.7923 0 0 0 -1.6728-1.0416 1.7924 1.7924 0 0 0 -1.6728 1.0414c-.598 1.3136.1836 3.6548 1.6728 3.6548z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-1.6045c-.0039-2.8742-1.004-2.07-2.5243-3.0574a.407.407 0 0 0 -.5287.0661l-.8569.8625a.31.31 0 0 1 -.44 0l-.8569-.8625a.4072.4072 0 0 0 -.5287-.0661c-1.52.9879-2.52.1833-2.524 3.0574h-1.6047v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};jt.displayName="IconDocumentUser",jt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},jt.defaultProps={title:"DocumentUser",color:null,size:null},jt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentUser",props:{title:{defaultValue:{value:"'DocumentUser'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Lt=jt,At=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.822 9.877-2.259 2.889h2.108l1.202-1.624 1.191 1.624h2.2l-2.317-2.95 2.13-2.665h-2.115l-1.087 1.435-1.032-1.435h-2.191z"}),u.a.createElement("path",{d:"m14.4845.0425h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5236a.7433.7433 0 0 0 -.2158.55v10.871a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.4146a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.02h-2.02zm8.918 12.3849h-11.4687v-8.8646h3.3008a.75.75 0 0 0 .75-.75v-3.3h7.418z"})))};At.displayName="IconDocumentX",At.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},At.defaultProps={title:"DocumentX",color:null,size:null},At.__docgenInfo={description:"",methods:[],displayName:"IconDocumentX",props:{title:{defaultValue:{value:"'DocumentX'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var St=At,kt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.91 2.7692a.7258.7258 0 0 0 -.0319-.1581.7209.7209 0 0 0 -.0787-.1371.7092.7092 0 0 0 -.0547-.0951c-.0056-.0064-.0137-.0087-.0195-.0148a.7418.7418 0 0 0 -.1309-.0994.7537.7537 0 0 0 -.1047-.0706.7531.7531 0 0 0 -.1281-.0338.7384.7384 0 0 0 -.1564-.0316c-.0084 0-.0154-.0048-.0239-.0048h-14.3624c-.0085 0-.0156.0045-.024.0048a.7447.7447 0 0 0 -.1571.0317.7581.7581 0 0 0 -.1277.0337.7553.7553 0 0 0 -.1058.0714.7392.7392 0 0 0 -.13.0987c-.0052.0058-.0132.0084-.0188.0147a.711.711 0 0 0 -.0547.0951.7218.7218 0 0 0 -.0787.1371.7258.7258 0 0 0 -.032.1581.7021.7021 0 0 0 -.0212.1048v10.252a.75.75 0 0 0 .75.75h14.3624a.75.75 0 0 0 .75-.75v-10.252a.7018.7018 0 0 0 -.0212-.1048zm-2.7191.8548-5.1909 4.5601-5.1909-4.5601zm-11.6221 8.752v-7.8447l5.936 5.2148a.75.75 0 0 0 .99 0l5.936-5.2148v7.8447z"})))};kt.displayName="IconEmail",kt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},kt.defaultProps={title:"Email",color:null,size:null},kt.__docgenInfo={description:"",methods:[],displayName:"IconEmail",props:{title:{defaultValue:{value:"'Email'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Dt=kt,Ft=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 4.43a3.57 3.57 0 1 0 3.57 3.57 3.574 3.574 0 0 0 -3.57-3.57zm0 5.74a2.17 2.17 0 1 1 2.1694-2.17 2.1715 2.1715 0 0 1 -2.1694 2.17z"}),u.a.createElement("path",{d:"m15.7974 7.635c-.1174-.1914-2.919-4.6894-7.7974-4.6894s-7.68 4.498-7.7974 4.6894a.7.7 0 0 0 0 .7295c.1172.1914 2.919 4.69 7.7969 4.69s7.6807-4.4985 7.7978-4.69a.7.7 0 0 0 .0001-.7295zm-7.7974 4.0191c-3.3394 0-5.6167-2.6631-6.3491-3.6541.7324-.9914 3.0098-3.654 6.3491-3.654s5.6167 2.6626 6.3491 3.654c-.7324.991-3.0097 3.6541-6.3491 3.6541z"})))};Ft.displayName="IconEye",Ft.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ft.defaultProps={title:"Eye",color:null,size:null},Ft.__docgenInfo={description:"",methods:[],displayName:"IconEye",props:{title:{defaultValue:{value:"'Eye'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Mt=Ft,Ut=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.83 1.2461a.75.75 0 0 0 -.689-.4541h-14.2821a.75.75 0 0 0 -.544 1.2666l5.5933 5.8887v6.5107a.75.75 0 0 0 1.5 0v-6.8105a.7506.7506 0 0 0 -.206-.5166l-4.5967-4.8389h10.789l-4.5967 4.8389a.7506.7506 0 0 0 -.206.5166v5.2334a.75.75 0 1 0 1.5 0v-4.9336l5.5933-5.8887a.75.75 0 0 0 .1449-.8125z"})))};Ut.displayName="IconFilter",Ut.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ut.defaultProps={title:"Filter",color:null,size:null},Ut.__docgenInfo={description:"",methods:[],displayName:"IconFilter",props:{title:{defaultValue:{value:"'Filter'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ht=Ut,Gt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4082 2.12a.708.708 0 0 0 -.0214-.1058.7057.7057 0 0 0 -.01-.109c-.0042-.0138-.0147-.0232-.02-.0366a.72.72 0 0 0 -.0731-.1368.7418.7418 0 0 0 -.076-.1127.7343.7343 0 0 0 -.1107-.0907.7377.7377 0 0 0 -.118-.08.7329.7329 0 0 0 -.1264-.0395.72.72 0 0 0 -.1572-.0318c-.0133-.0007-.0245-.0076-.0379-.0076a.7042.7042 0 0 0 -.103.0208.6983.6983 0 0 0 -.1118.01 8.312 8.312 0 0 1 -3.3877.3511 4.0238 4.0238 0 0 1 -1.0928-.6006 5.0583 5.0583 0 0 0 -3.0335-1.1056 6.2638 6.2638 0 0 0 -2.9206.752.7451.7451 0 0 0 -1.4163.3285v14.0791a.75.75 0 0 0 1.5 0v-5.0821c.0184-.0124.04-.0159.0576-.03a4.9274 4.9274 0 0 1 2.7793-.9219 3.6482 3.6482 0 0 1 2.19.8467 5.2365 5.2365 0 0 0 1.5283.8042 4.3089 4.3089 0 0 0 1.1553.1372 12.2 12.2 0 0 0 3.07-.4941c.0139-.0042.0232-.0147.0366-.02a.7193.7193 0 0 0 .1355-.0723.628.628 0 0 0 .3243-.4354.7248.7248 0 0 0 .0313-.1509c.0008-.0141.0081-.0261.0081-.04zm-4.3525 7.2582a4.024 4.024 0 0 1 -1.0928-.6006 5.0583 5.0583 0 0 0 -3.0342-1.1069 6.2394 6.2394 0 0 0 -2.8369.7093v-5.8829c.0184-.0123.04-.0159.0576-.03a4.9274 4.9274 0 0 1 2.7793-.9219 3.6481 3.6481 0 0 1 2.19.8467 5.2364 5.2364 0 0 0 1.5283.8042 4.3089 4.3089 0 0 0 1.1553.1372 10.4541 10.4541 0 0 0 2.1059-.2533v6.086a7.0647 7.0647 0 0 1 -2.8525.2122z"})))};Gt.displayName="IconFlag",Gt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Gt.defaultProps={title:"Flag",color:null,size:null},Gt.__docgenInfo={description:"",methods:[],displayName:"IconFlag",props:{title:{defaultValue:{value:"'Flag'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rt=Gt,Wt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.5547 4.5806v-3.0684h.73a.7.7 0 1 0 0-1.4h-6.57a.7.7 0 1 0 0 1.4h.73v3.0684a5.95 5.95 0 1 0 5.1094 0zm-2.5547 9.9072a4.5327 4.5327 0 0 1 -3.6412-1.85h1.7867a.7.7 0 1 0 0-1.4h-2.4833a4.47 4.47 0 0 1 -.1412-.6h2.6245a.7.7 0 1 0 0-1.4h-2.642a4.5027 4.5027 0 0 1 .1392-.6h2.5028a.7.7 0 0 0 0-1.4h-1.7955a4.561 4.561 0 0 1 2.0436-1.5415.699.699 0 0 0 .4521-.6543v-3.53h2.3086v3.53a.699.699 0 0 0 .4522.6543 4.5409 4.5409 0 0 1 -1.6065 8.7915z"})))};Wt.displayName="IconFlask",Wt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Wt.defaultProps={title:"Flask",color:null,size:null},Wt.__docgenInfo={description:"",methods:[],displayName:"IconFlask",props:{title:{defaultValue:{value:"'Flask'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xt=Wt,Yt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.5547 4.5806v-3.0684h.73a.7.7 0 1 0 0-1.4h-6.57a.7.7 0 1 0 0 1.4h.73v3.0684a5.95 5.95 0 1 0 5.1094 0zm-2.5547 9.9072a4.5327 4.5327 0 0 1 -3.6412-1.85h1.7867a.7.7 0 1 0 0-1.4h-2.4833a4.47 4.47 0 0 1 -.1412-.6h2.6245a.7.7 0 1 0 0-1.4h-2.642a4.5027 4.5027 0 0 1 .1392-.6h2.5028a.7.7 0 0 0 0-1.4h-1.7955a4.561 4.561 0 0 1 2.0436-1.5415.699.699 0 0 0 .4521-.6543v-3.53h2.3086v3.53a.699.699 0 0 0 .4522.6543 4.5409 4.5409 0 0 1 -1.6065 8.7915z"})))};Yt.displayName="IconFlowChart",Yt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Yt.defaultProps={title:"FlowChart",color:null,size:null},Yt.__docgenInfo={description:"",methods:[],displayName:"IconFlowChart",props:{title:{defaultValue:{value:"'FlowChart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kt=Yt,Zt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1772 3.63h-7.0947l-1.3476-2.3453a.75.75 0 0 0 -.65-.377h-5.2621a.75.75 0 0 0 -.75.75v12.6846a.75.75 0 0 0 .75.75h14.3544a.75.75 0 0 0 .75-.75v-9.9623a.75.75 0 0 0 -.75-.75zm-9.5272-1.2223.7024 1.2223h-4.78v-1.2223zm8.7773 11.1846h-12.8545v-8.4623h12.8545v8.4619z"})))};Zt.displayName="IconFolder",Zt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Zt.defaultProps={title:"Folder",color:null,size:null},Zt.__docgenInfo={description:"",methods:[],displayName:"IconFolder",props:{title:{defaultValue:{value:"'Folder'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Jt=Zt,Qt=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.828 9.7124a.75.75 0 0 0 -.647-.3706h-2.102v-2.1343a.75.75 0 0 0 -.75-.75h-5.8447v-.9253a.75.75 0 0 0 -.75-.75h-4.9155a.75.75 0 0 0 -.75.75v9.6631l.0008.0041c0 .009.0049.017.0053.026a.733.733 0 0 0 .0865.3117c.0062.0119.0036.026.01.0377.0111.0188.0324.0269.0449.0445a.7311.7311 0 0 0 .1841.1821.7088.7088 0 0 0 .08.054.7318.7318 0 0 0 .3378.09h11.51a.7506.7506 0 0 0 .6548-.3843l2.852-5.1035a.749.749 0 0 0 -.007-.7452zm-10.8437-3.4302v.9253a.75.75 0 0 0 .75.75h5.8447v1.3843h-7.9077a.7506.7506 0 0 0 -.6548.3843l-1.4477 2.59v-6.0339zm6.9048 8.1631h-9.792l2.0142-3.6035h9.7915z"}),u.a.createElement("path",{d:"m11.8339 5.7422a.7029.7029 0 0 0 .99 0l2.0991-2.0991a.7.7 0 0 0 -.99-.99l-.9038.9041v-2.8023a.7.7 0 0 0 -1.4 0v2.802l-.9038-.9041a.7.7 0 0 0 -.99.99z"})))};Qt.displayName="IconFolderArrow",Qt.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Qt.defaultProps={title:"FolderArrow",color:null,size:null},Qt.__docgenInfo={description:"",methods:[],displayName:"IconFolderArrow",props:{title:{defaultValue:{value:"'FolderArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $t=Qt,ea=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.769 8.1772a.75.75 0 0 0 -.75.75v4.127h-10.4843v-7.8174h7.0141a.75.75 0 1 0 0-1.5h-1.6315l-1.0897-1.8968a.7506.7506 0 0 0 -.65-.376h-4.3929a.75.75 0 0 0 -.75.75v11.59a.75.75 0 0 0 .75.75h11.9844a.75.75 0 0 0 .75-.75v-4.8768a.75.75 0 0 0 -.7501-.75zm-8.0258-5.2128.4437.7725h-3.6522v-.7725z"}),u.a.createElement("path",{d:"m15.7456 3.5474-1.8906-1.8907a.772.772 0 0 0 -1.0605 0l-1.6129 1.6133-4.0293 4.0293a.75.75 0 0 0 -.22.541l.0277 1.8633a.75.75 0 0 0 .7388.7393l1.8632.0271h.0112a.75.75 0 0 0 .53-.22l4.0268-4.0262.0018-.0009.0022-.0029 1.6116-1.6118a.75.75 0 0 0 0-1.0608zm-2.4209-.3.83.83-.5531.5531-.83-.83zm-4.0576 5.7179-.8179-.0117-.0122-.8183 3.2743-3.2743.83.83z"})))};ea.displayName="IconFolderPencil",ea.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ea.defaultProps={title:"FolderPencil",color:null,size:null},ea.__docgenInfo={description:"",methods:[],displayName:"IconFolderPencil",props:{title:{defaultValue:{value:"'FolderPencil'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ta=ea,aa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1775 3.63h-7.0952l-1.3477-2.3458a.7506.7506 0 0 0 -.65-.376h-5.2621a.75.75 0 0 0 -.75.75v12.6836a.75.75 0 0 0 .75.75h14.355a.75.75 0 0 0 .75-.75v-9.9618a.75.75 0 0 0 -.75-.75zm-9.5275-1.2218.702 1.2218h-4.78v-1.2218zm8.7773 11.1836h-2.2115c-.1233-2.3251-1.1139-1.6335-2.5717-2.5808a.4166.4166 0 0 0 -.5413.0677l-.8774.8831a.3173.3173 0 0 1 -.45 0l-.8775-.8831a.4168.4168 0 0 0 -.5414-.0677c-1.4575.9473-2.4481.2557-2.5714 2.5808h-2.2126v-8.4618h12.855z"}),u.a.createElement("path",{d:"m6.2872 7.0741c-.6124 1.3449.188 3.7421 1.7128 3.7421s2.3256-2.3972 1.7131-3.7421a1.8353 1.8353 0 0 0 -1.7131-1.0666 1.8353 1.8353 0 0 0 -1.7128 1.0666z"})))};aa.displayName="IconFolderUser",aa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},aa.defaultProps={title:"FolderUser",color:null,size:null},aa.__docgenInfo={description:"",methods:[],displayName:"IconFolderUser",props:{title:{defaultValue:{value:"'FolderUser'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var la=aa,ra=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.3337.3208a2.4263 2.4263 0 0 0 -2.0928.0492c-.2773.172-2.6709 1.8619-1.3838 7.9728a.6989.6989 0 0 0 .6846.5562h3.1583a.7.7 0 0 0 .52-.231c.0684-.0752 1.6572-1.8867.8789-5.5566a3.6918 3.6918 0 0 0 -1.7652-2.7906zm.0063 7.1777h-2.2221c-.832-4.6367.82-5.9077.8047-5.9077a1.017 1.017 0 0 1 .8213 0 2.5268 2.5268 0 0 1 .9854 1.811 5.6227 5.6227 0 0 1 -.3893 4.0967z"}),u.a.createElement("path",{d:"m5.5983 9.4346h-2.955a.7.7 0 0 0 -.7.7109c.0039.2378.0664 2.3511 1.124 3.3125a1.8293 1.8293 0 0 0 1.2539.4888c.0527 0 .1065-.002.1611-.0063a2.097 2.097 0 0 0 1.6416-.8755 3.6706 3.6706 0 0 0 .1473-3.125.7009.7009 0 0 0 -.6729-.5054zm-.627 2.8345c-.041.06-.167.2412-.6006.2759a.4356.4356 0 0 1 -.3613-.1221 2.9743 2.9743 0 0 1 -.6016-1.5879h1.6422a2.0206 2.0206 0 0 1 -.0786 1.434z"}),u.a.createElement("path",{d:"m14.2819 4.1748a2.529 2.529 0 0 0 -1.6719-1.9986 2.9173 2.9173 0 0 0 -2.498.99c-.1074.1328-2.623 3.2959-1.3945 6.98a.7011.7011 0 0 0 .48.4546l3.0059.8149a.7246.7246 0 0 0 .1836.0244.6994.6994 0 0 0 .5967-.335c.0932-.1496 2.2406-3.7145 1.2982-6.9303zm-2.2451 5.7452-2.0947-.568a6.7518 6.7518 0 0 1 1.2187-5.26c.2627-.271.8047-.6367 1.12-.5552.2432.06.4834.436.6572 1.0313.5939 2.0266-.41 4.3796-.9012 5.3519z"}),u.a.createElement("path",{d:"m12.0769 11.9541-3.1084-.917a.6943.6943 0 0 0 -.82.3506c-.1934.3735-1.123 2.3018-.4883 3.5493a1.7356 1.7356 0 0 0 1.36.9277 2.69 2.69 0 0 0 .4131.0322c1.7978 0 2.8008-1.894 3.1211-3.09a.6994.6994 0 0 0 -.4775-.8528zm-2.8438 2.5268c-.2539-.0391-.3018-.1333-.3252-.1787a2.7692 2.7692 0 0 1 .252-1.749l1.8018.5317c-.294.646-.8624 1.5332-1.7286 1.396z"})))};ra.displayName="IconFootprint",ra.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ra.defaultProps={title:"Footprint",color:null,size:null},ra.__docgenInfo={description:"",methods:[],displayName:"IconFootprint",props:{title:{defaultValue:{value:"'Footprint'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var na=ra,ia=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.4419 5.4429a3.617 3.617 0 1 0 5.1152 0 3.6231 3.6231 0 0 0 -5.1152 0zm4.125 4.125a2.2166 2.2166 0 1 1 0-3.1348 2.2174 2.2174 0 0 1 0 3.1348z"}),u.a.createElement("path",{d:"m15.3511 6.3462-.875-.1934a6.6869 6.6869 0 0 0 -.59-1.4277l.4815-.7539a.7.7 0 0 0 -.0956-.8712l-1.372-1.372a.7006.7006 0 0 0 -.8711-.0947l-.7539.4795a6.7171 6.7171 0 0 0 -1.458-.5986l-.1593-.8428a.6993.6993 0 0 0 -.6877-.5714h-1.9412a.6992.6992 0 0 0 -.6875.5713l-.1592.8428a6.6222 6.6222 0 0 0 -1.4863.6133l-.7058-.4824a.6979.6979 0 0 0 -.89.083l-1.3729 1.372a.7.7 0 0 0 -.083.89l.4824.707a6.6218 6.6218 0 0 0 -.6133 1.4863l-.8432.159a.6993.6993 0 0 0 -.57.6877v1.9412a.6993.6993 0 0 0 .57.6875l.8428.1592a6.6222 6.6222 0 0 0 .6133 1.4863l-.4824.706a.7.7 0 0 0 .083.89l1.3733 1.3727a.7016.7016 0 0 0 .89.083l.706-.4824a6.6818 6.6818 0 0 0 1.456.6025l.1934.875a.7009.7009 0 0 0 .6836.5488h1.941a.7009.7009 0 0 0 .6836-.5488l.1934-.875a6.6713 6.6713 0 0 0 1.4277-.5889l.7529.48a.7013.7013 0 0 0 .8721-.0947l1.3723-1.3724a.7.7 0 0 0 .0957-.8711l-.48-.7539a6.6923 6.6923 0 0 0 .5889-1.4277l.874-.1924a.7.7 0 0 0 .55-.6836v-1.9413a.7009.7009 0 0 0 -.5495-.6838zm-.8511 2.0625-.7109.1563a.7.7 0 0 0 -.5723.5469 5.27 5.27 0 0 1 -.74 1.793.7035.7035 0 0 0 -.0879.5654.69.69 0 0 0 .0986.2119l.3975.625-.5781.5791-.707-.4482a.6922.6922 0 0 0 -.6953.0391 5.2924 5.2924 0 0 1 -1.793.74.7041.7041 0 0 0 -.541.5508l-.1629.732h-.8164l-.1572-.71a.7.7 0 0 0 -.5459-.5723 5.29 5.29 0 0 1 -1.8282-.7612.7007.7007 0 0 0 -.78.0059l-.6006.41-.5518-.5518.41-.6006a.7005.7005 0 0 0 .0059-.7812 5.277 5.277 0 0 1 -.7705-1.8651.6972.6972 0 0 0 -.5557-.5479l-.7168-.1358v-.7792l.7168-.1357a.6972.6972 0 0 0 .5557-.5479 5.277 5.277 0 0 1 .7705-1.8652.7005.7005 0 0 0 -.0059-.7812l-.41-.6006.5518-.5518.6006.41a.7023.7023 0 0 0 .7813.0059 5.277 5.277 0 0 1 1.8652-.7705.6971.6971 0 0 0 .5479-.5566l.1356-.7172h.7793l.1357.7168a.6971.6971 0 0 0 .5478.5566 5.2681 5.2681 0 0 1 1.831.75.7049.7049 0 0 0 .77-.0049l.6338-.4033.5772.5772-.3945.62a.7.7 0 0 0 -.0137.7832 5.289 5.289 0 0 1 .74 1.792.7015.7015 0 0 0 .5723.5469l.7109.1572z"})))};ia.displayName="IconGear",ia.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ia.defaultProps={title:"Gear",color:null,size:null},ia.__docgenInfo={description:"",methods:[],displayName:"IconGear",props:{title:{defaultValue:{value:"'Gear'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var oa=ia,ua=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1626a7.8374 7.8374 0 1 0 7.8374 7.8374 7.847 7.847 0 0 0 -7.8374-7.8374zm5.7029 4.8638h-2.7229a10.76 10.76 0 0 0 -1.465-3.2764 6.4548 6.4548 0 0 1 4.1884 3.2764zm.7341 2.9736a6.4073 6.4073 0 0 1 -.247 1.7466h-3.1179a10.8857 10.8857 0 0 0 .1641-3.32h2.9984a6.4075 6.4075 0 0 1 .2024 1.5734zm-8.367 1.7466a9.2635 9.2635 0 0 1 .03-3.32h3.7392a9.46 9.46 0 0 1 -.1564 3.32zm3.2011 1.4a12.8 12.8 0 0 1 -1.3688 2.6967 10.0518 10.0518 0 0 1 -1.46-2.6967zm-7.7081-3.1466a6.407 6.407 0 0 1 .2026-1.5732h2.95a10.7047 10.7047 0 0 0 -.0457 3.32h-2.8599a6.407 6.407 0 0 1 -.247-1.7468zm4.8963-2.9736a12.7285 12.7285 0 0 1 1.4935-3.06 9.907 9.907 0 0 1 1.58 3.06zm-.0082-3.267a14.544 14.544 0 0 0 -1.4149 3.267h-2.74a6.455 6.455 0 0 1 4.1549-3.267zm-4.0606 9.3876h2.5867a10.9571 10.9571 0 0 0 1.4957 3.0992 6.4546 6.4546 0 0 1 -4.0824-3.0992zm6.8552 3.1667a14.6892 14.6892 0 0 0 1.4648-3.1667h2.8995a6.4525 6.4525 0 0 1 -4.3643 3.1667z"})))};ua.displayName="IconGlobe",ua.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ua.defaultProps={title:"Globe",color:null,size:null},ua.__docgenInfo={description:"",methods:[],displayName:"IconGlobe",props:{title:{defaultValue:{value:"'Globe'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ca=ua,sa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.0078 6.1713h1.8522v5.49h-.3922a.7.7 0 0 0 0 1.4h11.0644a.7.7 0 0 0 0-1.4h-.3922v-5.49h1.8525a.7.7 0 0 0 .3506-1.3057l-6.9925-4.0522a.6977.6977 0 0 0 -.7012 0l-6.9922 4.0522a.7.7 0 0 0 .3506 1.3057zm3.2529 0h1.5593v5.49h-1.56zm4.52 0v5.49h-1.56v-5.49zm2.959 5.49h-1.559v-5.49h1.5586zm-3.7397-9.4334 4.3887 2.543h-8.7774z"}),u.a.createElement("path",{d:"m15.083 13.8807h-14.166a.7.7 0 0 0 0 1.4h14.166a.7.7 0 1 0 0-1.4z"})))};sa.displayName="IconGovBuilding",sa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},sa.defaultProps={title:"GovBuilding",color:null,size:null},sa.__docgenInfo={description:"",methods:[],displayName:"IconGovBuilding",props:{title:{defaultValue:{value:"'GovBuilding'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var da=sa,pa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5341 5.5032-7.1768-3.25a.75.75 0 0 0 -.5967-.01l-7.2724 3.0105a.75.75 0 0 0 -.4629.6929c0 .3547.0131.4552 3.0049 1.835v3.8491a.7478.7478 0 0 0 .1475.4458c.78 1.0552 2.6934 1.7368 4.874 1.7368a6.56 6.56 0 0 0 4.7266-1.5561.75.75 0 0 0 .1914-.5v-3.8261l.78-.3229v2.3486a.75.75 0 1 0 1.5 0v-2.9693l.2617-.1083a.75.75 0 0 0 .0225-1.376zm-4.0644 5.93a5.8766 5.8766 0 0 1 -3.418.88 5.5877 5.5877 0 0 1 -3.5217-.9663v-2.8789c.8657.394 1.88.8534 3.1123 1.4112a.75.75 0 0 0 .5967.01l3.23-1.337zm-3.5039-3.0545c-.8858-.4009-3.5625-1.6128-5.3037-2.4009l5.372-2.2237 5.3037 2.4014z"})))};pa.displayName="IconGraduationHat",pa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},pa.defaultProps={title:"GraduationHat",color:null,size:null},pa.__docgenInfo={description:"",methods:[],displayName:"IconGraduationHat",props:{title:{defaultValue:{value:"'GraduationHat'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ma=pa,ga=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.146.1533h-14.292a.7.7 0 0 0 -.7.7v14.293a.7.7 0 0 0 .7.7h14.292a.7.7 0 0 0 .7-.7v-14.2928a.7.7 0 0 0 -.7-.7002zm-13.5918 6.1651h3.3638v3.3632h-3.3638zm4.7642 0h3.3632v3.3632h-3.3632zm4.7637 0h3.3638v3.3632h-3.3639zm3.3638-1.4h-3.3639v-3.3647h3.3638zm-4.7642 0h-3.3633v-3.3647h3.3632zm-8.1275-3.3647h3.3638v3.3643h-3.3638zm0 9.5283h3.3638v3.3643h-3.3638zm4.7642 0h3.3632v3.3643h-3.3632zm8.1274 3.3643h-3.3638v-3.3643h3.3638z"})))};ga.displayName="IconGrid",ga.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ga.defaultProps={title:"Grid",color:null,size:null},ga.__docgenInfo={description:"",methods:[],displayName:"IconGrid",props:{title:{defaultValue:{value:"'Grid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var za=ga,va=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m6.98 2.1757h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7257 4.505a.3624.3624 0 0 0 .6746 0l2.7259-4.505c.1856-.3065.0441-.5574-.3144-.5574z"}),u.a.createElement("path",{d:"m11.4315 7.2381a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3142-.5574h-5.4977c-.3584 0-.5.2508-.3143.5574z"}),u.a.createElement("path",{d:"m6.98 8.532h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1856-.3066.0441-.5574-.3144-.5574z"}),u.a.createElement("path",{d:"m14.5176 8.532h-5.4976c-.3584 0-.5.2508-.3143.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3143-.5574z"})))};va.displayName="IconGridCarets",va.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},va.defaultProps={title:"GridCarets",color:null,size:null},va.__docgenInfo={description:"",methods:[],displayName:"IconGridCarets",props:{title:{defaultValue:{value:"'GridCarets'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ha=va,fa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m2.6357.1377a2.4981 2.4981 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 .1377a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 5.1338a2.498 2.498 0 1 0 -2.498-2.498 2.5015 2.5015 0 0 0 2.498 2.498zm0-3.5957a1.0977 1.0977 0 1 1 -1.0977 1.0977 1.0986 1.0986 0 0 1 1.0977-1.0977z"}),u.a.createElement("path",{d:"m2.6357 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m2.6357 5.5019a2.498 2.498 0 1 0 2.4981 2.4981 2.5015 2.5015 0 0 0 -2.4981-2.4981zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0976 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 5.5019a2.498 2.498 0 1 0 2.498 2.4981 2.5015 2.5015 0 0 0 -2.498-2.4981zm0 3.5958a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 5.5019a2.498 2.498 0 1 0 2.498 2.4981 2.5015 2.5015 0 0 0 -2.498-2.4981zm0 3.5957a1.0977 1.0977 0 1 1 1.0976-1.0976 1.0986 1.0986 0 0 1 -1.0976 1.0977z"})))};fa.displayName="IconGridCircles",fa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},fa.defaultProps={title:"GridCircles",color:null,size:null},fa.__docgenInfo={description:"",methods:[],displayName:"IconGridCircles",props:{title:{defaultValue:{value:"'GridCircles'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ya=fa,Ia=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.873 8.83a.7482.7482 0 0 0 -.96.4522 3.074 3.074 0 0 1 -5.7754-.001.75.75 0 0 0 -1.41.51 4.5741 4.5741 0 0 0 8.5977-.001.7513.7513 0 0 0 -.4523-.9602z"}),u.a.createElement("path",{d:"m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8833 7.8833 0 0 0 -7.875-7.875zm0 14.25a6.375 6.375 0 1 1 6.375-6.375 6.3817 6.3817 0 0 1 -6.375 6.375z"}),u.a.createElement("circle",{cx:"4.6871",cy:"6.3912",r:"1.1271"}),u.a.createElement("circle",{cx:"11.4028",cy:"6.3912",r:"1.1271"})))};Ia.displayName="IconHappy",Ia.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ia.defaultProps={title:"Happy",color:null,size:null},Ia.__docgenInfo={description:"",methods:[],displayName:"IconHappy",props:{title:{defaultValue:{value:"'Happy'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ea=Ia,Va=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8839 7.8839 0 0 0 -7.875-7.875zm-3.3129 5.2833a.9829.9829 0 1 1 -.983.9829.9829.9829 0 0 1 .983-.9829zm7.497 4.3317a4.4245 4.4245 0 0 1 -8.3159 0 .6.6 0 1 1 1.1289-.4072 3.2244 3.2244 0 0 0 6.0581 0 .6.6 0 1 1 1.1289.4072zm-.7812-2.3657a.9829.9829 0 1 1 .9829-.9829.9829.9829 0 0 1 -.983.9827z"})))};Va.displayName="IconHappyFilled",Va.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Va.defaultProps={title:"HappyFilled",color:null,size:null},Va.__docgenInfo={description:"",methods:[],displayName:"IconHappyFilled",props:{title:{defaultValue:{value:"'HappyFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qa=Va,ba=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.8716 9.9934a2.0425 2.0425 0 0 0 -1.4516 3.4808 2.0536 2.0536 0 0 1 -2.4937.8375 2.2821 2.2821 0 0 1 -1.6463-2.2241v-1.5143a5.295 5.295 0 0 0 4.6953-5.1351c.001-.0137.001-.0273.001-.041v-4.5893a.75.75 0 0 0 -.75-.75h-1.925a.75.75 0 1 0 0 1.5h1.1748v3.7714a3.809 3.809 0 0 1 -3.8047 3.8047h-.2832a3.809 3.809 0 0 1 -3.8047-3.8047v-3.7714h1.1865a.75.75 0 1 0 0-1.5h-1.9365a.75.75 0 0 0 -.75.75v4.5893c0 .0137 0 .0273.001.041a5.295 5.295 0 0 0 4.6955 5.1351v1.4938a3.796 3.796 0 0 0 2.7129 3.6807 4.3132 4.3132 0 0 0 1.2461.1943 3.5329 3.5329 0 0 0 3.073-1.8659c.02.0006.0393.006.06.006a2.0444 2.0444 0 1 0 0-4.0889zm0 2.6885a.644.644 0 1 1 .6445-.644.6445.6445 0 0 1 -.6445.644z"})))};ba.displayName="IconHealth",ba.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ba.defaultProps={title:"Health",color:null,size:null},ba.__docgenInfo={description:"",methods:[],displayName:"IconHealth",props:{title:{defaultValue:{value:"'Health'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Na=ba,_a=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.72 2.4795a4.1282 4.1282 0 0 0 -5.84 0l-.8811.8805-.8809-.8805a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1914a.7509.7509 0 0 0 1.0615 0l6.1905-6.1916a4.1282 4.1282 0 0 0 0-5.84zm-1.0609 4.7793-5.6602 5.6612-5.66-5.6611a2.63 2.63 0 1 1 3.7186-3.7189l1.4111 1.4112a.75.75 0 0 0 1.0606 0l1.4108-1.4112a2.6912 2.6912 0 0 1 3.7188 0 2.6287 2.6287 0 0 1 0 3.7187z"})))};_a.displayName="IconHeart",_a.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_a.defaultProps={title:"Heart",color:null,size:null},_a.__docgenInfo={description:"",methods:[],displayName:"IconHeart",props:{title:{defaultValue:{value:"'Heart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wa=_a,xa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.7192 2.48a4.1282 4.1282 0 0 0 -5.84 0l-.8809.88-.8809-.88a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1909a.7509.7509 0 0 0 1.0615 0l6.1903-6.1909a4.1282 4.1282 0 0 0 0-5.84z"})))};xa.displayName="IconHeartFilled",xa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},xa.defaultProps={title:"HeartFilled",color:null,size:null},xa.__docgenInfo={description:"",methods:[],displayName:"IconHeartFilled",props:{title:{defaultValue:{value:"'HeartFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ta=xa,Pa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.9813 8.3425a.7008.7008 0 0 0 .9907 0l3.644-3.6445a2.69 2.69 0 1 0 -3.8042-3.8037l-.3354.3357-.3355-.3357a2.69 2.69 0 0 0 -3.8037 3.8037zm-2.6539-6.458a1.292 1.292 0 0 1 1.8237 0l.83.8306a.7.7 0 0 0 .99 0l.83-.8306a1.29 1.29 0 1 1 1.8242 1.8232l-3.1494 3.15-3.1489-3.15a1.29 1.29 0 0 1 .0004-1.8232z"}),u.a.createElement("path",{d:"m15.7479 10.5974a1.799 1.799 0 0 0 -2.2363-.977.7071.7071 0 0 0 -.1069.0405l-2.2222 1.0649a1.7737 1.7737 0 0 0 -1.2838-1.3681.7072.7072 0 0 0 -.1753-.0225h-1.7485a4.3161 4.3161 0 0 0 -2.9014-1.5781h-4.2729a.7.7 0 0 0 -.7.7v5.2529a.7.7 0 0 0 .7.7h2.1959l2.7758 1.041a4.4955 4.4955 0 0 0 1.9751.4409 4.968 4.968 0 0 0 2.07-.4609l5.272-2.7666a1.5438 1.5438 0 0 0 .6585-2.067zm-14.2471-1.4399h.9228v3.8525h-.9228zm12.9678 2.2525-5.2657 2.7641a3.2594 3.2594 0 0 1 -2.7964.0293.6873.6873 0 0 0 -.1016-.0474l-2.481-.93v-4.0707l1.16-.0037c.4053.0518 1.625.3706 1.9053 1.127a.7.7 0 0 0 .6563.457h2.061a.3085.3085 0 0 1 .2041.2671.6649.6649 0 0 1 -.1123.42h-3.2747a.7.7 0 1 0 0 1.4h3.375a1.2212 1.2212 0 0 0 .773-.3063.6881.6881 0 0 0 .2421-.0613l3.13-1.5c.127-.0254.416-.0581.5044.1616.0292.0733.0893.2488.0205.2933z"})))};Pa.displayName="IconHeartHand",Pa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Pa.defaultProps={title:"HeartHand",color:null,size:null},Pa.__docgenInfo={description:"",methods:[],displayName:"IconHeartHand",props:{title:{defaultValue:{value:"'HeartHand'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ba=Pa,Oa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.9591 7.9591 0 0 0 -7.95-7.95zm.75 12.5654a.75.75 0 0 1 -1.5 0v-.6a.75.75 0 0 1 1.5 0zm.7685-4.3047a1.5452 1.5452 0 0 0 -.7685 1.3321.75.75 0 1 1 -1.5 0 3.05 3.05 0 0 1 1.5171-2.63 1.5379 1.5379 0 1 0 -2.3049-1.3339.75.75 0 0 1 -1.5 0 3.0376 3.0376 0 1 1 4.5561 2.6319z"})))};Oa.displayName="IconHelp",Oa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Oa.defaultProps={title:"Help",color:null,size:null},Oa.__docgenInfo={description:"",methods:[],displayName:"IconHelp",props:{title:{defaultValue:{value:"'Help'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ca=Oa,ja=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7173 7.4534-7.2227-6.3179a.7515.7515 0 0 0 -.9883 0l-3.8154 3.337v-2.0225h1.0117a.75.75 0 0 0 0-1.5h-1.7617a.75.75 0 0 0 -.75.75v4.0844l-1.9082 1.669a.75.75 0 0 0 .9883 1.1289l.92-.8046v6.5223a.75.75 0 0 0 .75.75h10.1181a.75.75 0 0 0 .75-.75v-6.5224l.92.8047a.75.75 0 0 0 .9883-1.1289zm-6.7803 6.0966h-1.873v-4.7822h1.873zm3.3721 0h-1.8721v-5.5322a.75.75 0 0 0 -.75-.75h-3.373a.75.75 0 0 0 -.75.75v5.5322h-1.8731v-7.0842l4.3091-3.7693 4.3086 3.7689z"})))};ja.displayName="IconHouse",ja.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ja.defaultProps={title:"House",color:null,size:null},ja.__docgenInfo={description:"",methods:[],displayName:"IconHouse",props:{title:{defaultValue:{value:"'House'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var La=ja,Aa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1553 1.145h-14.3106a.75.75 0 0 0 -.75.75v12.21a.75.75 0 0 0 .75.75h14.3106a.75.75 0 0 0 .75-.75v-12.21a.75.75 0 0 0 -.75-.75zm-.75 1.5v6.9432l-2.1084-1.8982a.77.77 0 0 0 -.544-.1914.7531.7531 0 0 0 -.52.2515l-2.0288 2.2909-3.3135-3.314a.7517.7517 0 0 0 -1.0117-.0454l-3.2842 2.7452v-6.7818zm-12.8106 10.71v-1.972l3.7207-3.11 3.3916 3.392a.71.71 0 0 0 .5527.2192.7493.7493 0 0 0 .5391-.252l2.0567-2.3212 2.55 2.2961v1.7479z"}),u.a.createElement("path",{d:"m8.99 7.9575a2.35 2.35 0 1 0 -2.35-2.3501 2.3523 2.3523 0 0 0 2.35 2.3501zm0-3.3a.95.95 0 1 1 -.95.95.95.95 0 0 1 .95-.9498z"})))};Aa.displayName="IconImage",Aa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Aa.defaultProps={title:"Image",color:null,size:null},Aa.__docgenInfo={description:"",methods:[],displayName:"IconImage",props:{title:{defaultValue:{value:"'Image'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Sa=Aa,ka=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8957 7.3561a.7411.7411 0 0 0 -.0678-.2561.706.706 0 0 0 -.0413-.1035l-3.2295-4.9413a.751.751 0 0 0 -.6279-.34h-8.1064a.7494.7494 0 0 0 -.6426.3638l-2.9802 4.9576c-.0089.0148-.009.0317-.0167.0468a.7269.7269 0 0 0 -.0544.1525.73.73 0 0 0 -.0264.1307c-.002.0204-.0125.0379-.0125.0587v4.6856a2.2378 2.2378 0 0 0 2.292 2.1738h11.2357a2.2378 2.2378 0 0 0 2.292-2.1738v-4.6856a.6916.6916 0 0 0 -.014-.0692zm-11.6491-4.1408h7.2764l2.2618 3.46h-2.88a.7567.7567 0 0 0 -.7129.5171 2.5184 2.5184 0 0 1 -2.3232 1.6919 2.2048 2.2048 0 0 1 -2.333-1.6113.75.75 0 0 0 -.7344-.5976h-2.6348zm10.1634 8.8955a.75.75 0 0 1 -.792.6738h-11.2357a.75.75 0 0 1 -.792-.6738v-3.9355h2.6739a3.7578 3.7578 0 0 0 3.6045 2.209 3.9485 3.9485 0 0 0 3.53-2.209h3.0113z"})))};ka.displayName="IconInbox",ka.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ka.defaultProps={title:"Inbox",color:null,size:null},ka.__docgenInfo={description:"",methods:[],displayName:"IconInbox",props:{title:{defaultValue:{value:"'Inbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Da=ka,Fa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.959 7.959 0 0 0 -7.95-7.95zm-.707 3.1956a.75.75 0 1 1 1.5 0v1.0264a.75.75 0 0 1 -1.5 0zm2.8428 8.7266-1.5626 1.5615a.751.751 0 0 1 -1.28-.53v-4.2464l-.2812.2813a.75.75 0 0 1 -1.0608-1.0606l1.5615-1.5615a.7511.7511 0 0 1 1.28.53v4.2469l.2822-.282a.75.75 0 1 1 1.0605 1.0605z"})))};Fa.displayName="IconInfo",Fa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Fa.defaultProps={title:"Info",color:null,size:null},Fa.__docgenInfo={description:"",methods:[],displayName:"IconInfo",props:{title:{defaultValue:{value:"'Info'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ma=Fa,Ua=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m3.5095 3.5115a1.9416 1.9416 0 0 0 2.7461 2.7456 1.9451 1.9451 0 0 0 0-2.7451 1.99 1.99 0 0 0 -2.7461-.0005zm1.7558 1.7553a.5533.5533 0 0 1 -.7656 0 .5414.5414 0 1 1 .7656 0z"}),u.a.createElement("path",{d:"m15.6481 13.0544a.7523.7523 0 0 0 -.2139-.4346l-4.8166-4.8166a5.5361 5.5361 0 1 0 -2.8157 2.8168l4.816 4.816a.7474.7474 0 0 0 .4346.2134l2.0156.26a.701.701 0 0 0 .0957.0063.7505.7505 0 0 0 .7441-.8457zm-12.8916-4.6298a4.0066 4.0066 0 1 1 5.666 0 4.0127 4.0127 0 0 1 -5.666 0zm10.7412 5.77-4.3971-4.3972c.1268-.1058.2635-.1933.3825-.3123s.2067-.2559.3125-.3828l4.3975 4.3977.1025.7974z"})))};Ua.displayName="IconKey",Ua.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ua.defaultProps={title:"Key",color:null,size:null},Ua.__docgenInfo={description:"",methods:[],displayName:"IconKey",props:{title:{defaultValue:{value:"'Key'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ha=Ua,Ga=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1594 2.5762h-14.3188a.7.7 0 0 0 -.7.7v9.4473a.7.7 0 0 0 .7.7h14.3188a.7.7 0 0 0 .7-.7v-9.4471a.7.7 0 0 0 -.7-.7002zm-.7 9.4473h-12.9186v-8.0469h12.9184z"}),u.a.createElement("circle",{cx:"3.7196",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"6.5092",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"9.2988",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"12.0884",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"5.175",cy:"8.1272",r:".7916"}),u.a.createElement("circle",{cx:"7.9646",cy:"8.1272",r:".7916"}),u.a.createElement("circle",{cx:"10.7543",cy:"8.1272",r:".7916"}),u.a.createElement("path",{d:"m11.44 9.7661h-7.033a.625.625 0 0 0 0 1.25h7.033a.625.625 0 0 0 0-1.25z"})))};Ga.displayName="IconKeyboard",Ga.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ga.defaultProps={title:"Keyboard",color:null,size:null},Ga.__docgenInfo={description:"",methods:[],displayName:"IconKeyboard",props:{title:{defaultValue:{value:"'Keyboard'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ra=Ga,Wa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.9178.274h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m.9178 6.0685h2.5754a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m.9178 11.863h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"}),u.a.createElement("path",{d:"m6.7123.274h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m6.7123 6.0685h2.5754a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m6.7123 11.863h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"}),u.a.createElement("path",{d:"m12.5069.274h2.5753a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m12.5069 6.0685h2.5753a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m12.5069 11.863h2.5753a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"})))};Wa.displayName="IconLaunchpad",Wa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Wa.defaultProps={title:"Launchpad",color:null,size:null},Wa.__docgenInfo={description:"",methods:[],displayName:"IconLaunchpad",props:{title:{defaultValue:{value:"'Launchpad'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xa=Wa,Ya=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.6086 7.25h-5.4067l5.937-5.9365a.75.75 0 0 0 -1.0605-1.0606l-7.2173 7.2171a.75.75 0 0 0 .53 1.28h5.407l-5.937 5.9365a.75.75 0 1 0 1.0605 1.0605l7.2173-7.217a.75.75 0 0 0 -.53-1.28z"})))};Ya.displayName="IconLighting",Ya.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ya.defaultProps={title:"Lighting",color:null,size:null},Ya.__docgenInfo={description:"",methods:[],displayName:"IconLighting",props:{title:{defaultValue:{value:"'Lighting'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ka=Ya,Za=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.25 11.0693-2.6753 2.6758a2.4111 2.4111 0 0 1 -3.3193 0 2.35 2.35 0 0 1 0-3.3193l2.6757-2.6758a2.3509 2.3509 0 0 1 3.3193 0 .75.75 0 0 0 1.0606-1.0605 3.8512 3.8512 0 0 0 -5.44 0l-2.6762 2.6757a3.847 3.847 0 0 0 5.44 5.44l2.6762-2.6752a.75.75 0 1 0 -1.061-1.0607z"}),u.a.createElement("path",{d:"m14.8052 1.1963a3.8512 3.8512 0 0 0 -5.44 0l-2.6772 2.6758a.75.75 0 0 0 1.0605 1.0605l2.6768-2.6758a2.3471 2.3471 0 0 1 3.3193 3.3193l-2.6767 2.6759a2.3518 2.3518 0 0 1 -3.3193 0 .75.75 0 0 0 -1.0606 1.0605 3.8512 3.8512 0 0 0 5.44 0l2.6768-2.6758a3.853 3.853 0 0 0 .0004-5.4404z"})))};Za.displayName="IconLink",Za.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Za.defaultProps={title:"Link",color:null,size:null},Za.__docgenInfo={description:"",methods:[],displayName:"IconLink",props:{title:{defaultValue:{value:"'Link'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ja=Za,Qa=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.7891 2.4619h14.4218a.75.75 0 0 0 0-1.5h-14.4218a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m15.2109 5.1543h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.2109 9.3457h-14.4218a.75.75 0 1 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.2109 13.5381h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"})))};Qa.displayName="IconList",Qa.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Qa.defaultProps={title:"List",color:null,size:null},Qa.__docgenInfo={description:"",methods:[],displayName:"IconList",props:{title:{defaultValue:{value:"'List'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $a=Qa,el=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.56 3.3535 9.6226-.0029a.75.75 0 0 0 0-1.5l-9.6226.0029a.75.75 0 1 0 0 1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"2.5735",r:"1.2876"}),u.a.createElement("path",{d:"m15.1821 7.2774-9.6221.0019a.75.75 0 0 0 0 1.5l9.6226-.002a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"8",r:"1.2877"}),u.a.createElement("path",{d:"m15.1821 12.7031-9.6221.003a.75.75 0 0 0 0 1.5l9.6226-.0029a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"13.4265",r:"1.2877"})))};el.displayName="IconListBulleted",el.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},el.defaultProps={title:"ListBulleted",color:null,size:null},el.__docgenInfo={description:"",methods:[],displayName:"IconListBulleted",props:{title:{defaultValue:{value:"'ListBulleted'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tl=el,al=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1895 12.627h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"3.0315",cy:"13.3504",r:"1.5143"}),u.a.createElement("path",{d:"m6.92 4.4707h8.269a.75.75 0 0 0 0-1.5h-8.269a.75.75 0 1 0 0 1.5z"}),u.a.createElement("path",{d:"m4.7222 1.355-2.1734 2.1733-1.208-1.2075a.75.75 0 1 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 0 0 -1.0605-1.0606z"}),u.a.createElement("path",{d:"m15.1895 7.8115h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 1 0 0-1.5z"}),u.a.createElement("path",{d:"m4.7222 6.1958-2.1734 2.1734-1.208-1.2076a.75.75 0 0 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 1 0 -1.0605-1.0606z"})))};al.displayName="IconListChecks",al.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},al.defaultProps={title:"ListChecks",color:null,size:null},al.__docgenInfo={description:"",methods:[],displayName:"IconListChecks",props:{title:{defaultValue:{value:"'ListChecks'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ll=al,rl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.7268 6.3958h-2.083v-2.75a3.6527 3.6527 0 0 0 -7.2876.0068v2.7432h-2.083a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4536a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75zm-7.8706-2.7437a2.16 2.16 0 0 1 4.2876-.0068v2.75h-4.2876zm7.1206 10.5972h-9.9536v-6.3535h9.9536z"}),u.a.createElement("path",{d:"m8 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};rl.displayName="IconLock",rl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},rl.defaultProps={title:"Lock",color:null,size:null},rl.__docgenInfo={description:"",methods:[],displayName:"IconLock",props:{title:{defaultValue:{value:"'Lock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nl=rl,il=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.258 9.786h-4.726l-4.887-8.466h4.726z"}),u.a.createElement("path",{d:"m4.038 14.68 2.35-4.129h9.163l-2.351 4.129z"}),u.a.createElement("path",{d:"m2.817 14.603-2.368-4.123 4.523-8.11 2.405 4.235z"})))};il.displayName="IconLogoDrive",il.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},il.defaultProps={title:"LogoDrive",color:null,size:null},il.__docgenInfo={description:"",methods:[],displayName:"IconLogoDrive",props:{title:{defaultValue:{value:"'LogoDrive'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ol=il,ul=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.89 4.5583v-1.1128c0-.64.5731-.8688 1.2133-.8688a5.56 5.56 0 0 1 1.326.1982l.4118-2.4388a10.3689 10.3689 0 0 0 -2.9511-.2961 2.9276 2.9276 0 0 0 -2.5546 1.1985 4.2757 4.2757 0 0 0 -.53 2.4662v1.6h-1.6465v2.3813h1.6462v8.274h3.0849v-8.2741h2.4417l.1829-2.3808h-2.6246z"})))};ul.displayName="IconLogoFacebook",ul.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ul.defaultProps={title:"LogoFacebook",color:null,size:null},ul.__docgenInfo={description:"",methods:[],displayName:"IconLogoFacebook",props:{title:{defaultValue:{value:"'LogoFacebook'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var cl=ul,sl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.398 1.6h-12.796a1.6042 1.6042 0 0 0 -1.602 1.6015v9.597a1.6068 1.6068 0 0 0 1.602 1.6015h12.796a1.6068 1.6068 0 0 0 1.602-1.6015v-9.597a1.6043 1.6043 0 0 0 -1.602-1.6015zm0 11.199h-1.597v-7.039l-4.801 3.0385-4.801-3.0385v7.039h-1.597v-9.5975h.957l5.441 3.359 5.441-3.359h.957z"})))};sl.displayName="IconLogoGmail",sl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},sl.defaultProps={title:"LogoGmail",color:null,size:null},sl.__docgenInfo={description:"",methods:[],displayName:"IconLogoGmail",props:{title:{defaultValue:{value:"'LogoGmail'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dl=sl,pl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.092 8.7862a1.9006 1.9006 0 0 0 -.4508.0561 5.81 5.81 0 0 0 -4.6-4.2858c-.1-.0181-.1908-.0314-.2928-.0443a1.9049 1.9049 0 0 1 .85-1.7536l-.1284-.3219s-1.573.4888-1.7553 1.8349c-.0784-.3663-.812-.8245-1.1752-.9114l-.1806.2913a1.266 1.266 0 0 1 .5987.9052 5.81 5.81 0 0 0 -4.5988 4.2856 1.8847 1.8847 0 1 0 .2376 3.5819 5.7775 5.7775 0 0 0 .6123 1.139l1.564-1.0544-.0133-.0174a3.853 3.853 0 0 1 -.7094-2.0933 2.787 2.787 0 0 1 .7113-2.2146 2.0953 2.0953 0 0 1 3.1347.3991h.2074a2.0953 2.0953 0 0 1 3.1347-.3991 2.787 2.787 0 0 1 .7113 2.2146 3.853 3.853 0 0 1 -.7091 2.0933l-.0133.0174 1.564 1.0544a5.7786 5.7786 0 0 0 .6123-1.139 1.8842 1.8842 0 1 0 .6884-3.6381zm-12.22 2.44a.556.556 0 0 1 0-1.1121.5608.5608 0 0 1 .3116.0961 8.4468 8.4468 0 0 0 .0593.8735.5563.5563 0 0 1 -.3711.1424zm12.2565 0a.5563.5563 0 0 1 -.3709-.1425 8.4467 8.4467 0 0 0 .0592-.8735.5551.5551 0 0 1 .8673.4611.5547.5547 0 0 1 -.5559.5548z"})))};pl.displayName="IconLogoGoldie",pl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},pl.defaultProps={title:"LogoGoldie",color:null,size:null},pl.__docgenInfo={description:"",methods:[],displayName:"IconLogoGoldie",props:{title:{defaultValue:{value:"'LogoGoldie'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ml=pl,gl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.06 7.34h-6.8181v2.0054h4.8523c-.2368 2.8126-2.5768 4.0121-4.7856 4.0121a5.2707 5.2707 0 0 1 -5.2919-5.34 5.28 5.28 0 0 1 5.2982-5.374 5.2027 5.2027 0 0 1 3.6139 1.45l1.4044-1.4543a7.14 7.14 0 0 0 -5.0902-2.007 7.49 7.49 0 0 0 -7.425 7.35 7.4656 7.4656 0 0 0 7.532 7.3856 6.4875 6.4875 0 0 0 6.832-6.6983 6.0112 6.0112 0 0 0 -.122-1.3295z"}),u.a.createElement("path",{d:"m15.06 7.339v.001z"})))};gl.displayName="IconLogoGoogle",gl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},gl.defaultProps={title:"LogoGoogle",color:null,size:null},gl.__docgenInfo={description:"",methods:[],displayName:"IconLogoGoogle",props:{title:{defaultValue:{value:"'LogoGoogle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var zl=gl,vl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.1407 7.2852v1.7155h2.8379a2.7022 2.7022 0 0 1 -2.8379 2.1593 3.16 3.16 0 0 1 0-6.319 2.8159 2.8159 0 0 1 1.9943.772l1.3582-1.3086a4.7965 4.7965 0 0 0 -3.3525-1.3081 5.0037 5.0037 0 1 0 0 10.0075 4.6155 4.6155 0 0 0 4.8036-4.8894 4.6022 4.6022 0 0 0 -.0786-.8292z"}),u.a.createElement("path",{d:"m15.863 7.285h-1.43v-1.429h-1.429v1.429h-1.43v1.43h1.43v1.429h1.429v-1.429h1.43z"})))};vl.displayName="IconLogoGooglePlus",vl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},vl.defaultProps={title:"LogoGooglePlus",color:null,size:null},vl.__docgenInfo={description:"",methods:[],displayName:"IconLogoGooglePlus",props:{title:{defaultValue:{value:"'LogoGooglePlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hl=vl,fl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4777.3973h-12.9587a1.11 1.11 0 0 0 -1.1215 1.0964v13.0118a1.11 1.11 0 0 0 1.1215 1.0972h12.9587a1.1124 1.1124 0 0 0 1.1248-1.0972v-13.0118a1.1116 1.1116 0 0 0 -1.1248-1.0964zm-9.57 12.9565h-2.2577v-7.2561h2.2579zm-1.1277-8.2475a1.3078 1.3078 0 1 1 1.3069-1.308 1.3072 1.3072 0 0 1 -1.3069 1.308zm9.5747 8.2476h-2.2547v-3.5287c0-.8415-.0145-1.924-1.1719-1.924-1.1735 0-1.3525.9171-1.3525 1.8638v3.5889h-2.2529v-7.2562h2.1617v.9923h.0309a2.3689 2.3689 0 0 1 2.1337-1.1721c2.2835 0 2.7054 1.5024 2.7054 3.4567z"})))};fl.displayName="IconLogoLinkedIn",fl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},fl.defaultProps={title:"LogoLinkedIn",color:null,size:null},fl.__docgenInfo={description:"",methods:[],displayName:"IconLogoLinkedIn",props:{title:{defaultValue:{value:"'LogoLinkedIn'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var yl=fl,Il=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8486 7.9624a.4584.4584 0 0 0 -.3658-.1735h-.0028c-.201 0-.3877.1526-.5707.4664l-.0145.025-.0094-.0274c-.0462-.1345-.0874-.2466-.112-.3135-.0171-.0468-.0248-.0677-.0266-.0745a.0739.0739 0 0 0 -.0759-.0551.1356.1356 0 0 0 -.0718.0229.0839.0839 0 0 0 -.0409.0572l-.0012.0036c-.1831.5712-.3342.8487-.4621.8487a.057.057 0 0 1 -.044-.0182c-.0335-.0371-.0253-.1252-.0139-.2472a2.2622 2.2622 0 0 0 .0139-.2986.3017.3017 0 0 0 -.3027-.3325c-.2313 0-.3812.2463-.45.3931l-.0206.0439-.0046-.0483c-.0172-.1817-.0782-.3987-.2708-.4-.2246 0-.3957.2636-.5.4848l-.028.0593.0028-.0655c.0125-.295.0226-.4691.03-.5175a.125.125 0 0 0 -.0123-.1.1.1 0 0 0 -.0848-.0213c-.0719.0046-.1087.0483-.164.195-.0909.241-.3222.8014-.5069.8014a.1105.1105 0 0 1 -.0869-.0371c-.0774-.0889-.0465-.3288-.0036-.661l.0032-.0251c.02-.1573-.0143-.1908-.1-.2065a.1434.1434 0 0 0 -.026-.0026c-.0682 0-.1.0653-.1638.2468-.1133.3231-.2591.6628-.43.6628l-.0187-.0015c-.09-.0153-.0884-.1494-.0859-.3191a1.8166 1.8166 0 0 0 -.0113-.29c-.0254-.1686-.1248-.274-.2593-.275-.2685 0-.45.3438-.5337.5487l-.0191.0464-.0064-.05c-.0113-.0889-.0261-.23-.0326-.3963v-.0049l.0031-.0038a2.6277 2.6277 0 0 0 .7308-1.48c.0019-.25-.1133-.4-.3083-.4014-.1425 0-.4815.1187-.5993 1.2186-.0218.204-.0338.4131-.0356.6216v.004l-.0024.0034c-.23.3327-.72.905-1.2007.905-.434 0-.78-.3511-.78-.9708a1.2485 1.2485 0 0 1 1.0307-1.3404h.0036a.3706.3706 0 0 1 .2385.0776.2629.2629 0 0 1 .0939.2108.3839.3839 0 0 1 -.0743.2306c-.0093.0146-.0185.0292-.027.0447a.0589.0589 0 0 0 -.005.0576.09.09 0 0 0 .0776.0325.3637.3637 0 0 0 .2664-.3822.5147.5147 0 0 0 -.5621-.4883 1.4961 1.4961 0 0 0 -1.2833 1.5743 1.0567 1.0567 0 0 0 1.0167 1.1652 1.6058 1.6058 0 0 0 1.19-.7936l.0223-.03.0016.0375c.0077.1816.0209.3249.0305.4295.0062.0673.0107.1158.0106.1426a.1953.1953 0 0 0 .0294.1244.1215.1215 0 0 0 .1011.0373c.0817 0 .098-.0557.13-.1931l.0091-.0398c.04-.1665.1886-.71.4119-.71a.112.112 0 0 1 .0846.0323c.0493.0523.044.16.0377.2839a1.5841 1.5841 0 0 0 0 .2358c.021.2107.112.3138.2782.315.1707 0 .3487-.1837.4426-.3546l.0178-.0322.0068.0361c.0174.0914.095.3915.3378.3915.22 0 .4089-.2318.6159-.7087l.027-.0624-.0016.0679c-.0044.1808-.0142.4016-.0142.5722 0 .132.0132.1823.0742.1823l.0138.0007c.0586 0 .0983-.035.1181-.1041.1557-.5427.29-.7955.4236-.7955.1306.001.1429.24.1534.6616l.0007.03c.0032.1476.0084.2128.1.2136.07 0 .0869-.0546.1228-.1891.0068-.0257.0144-.0538.0231-.0842.1257-.4363.23-.6143.36-.6143.1111.0008.1173.1154.1193.1531a1.65 1.65 0 0 1 -.012.2465 1.6857 1.6857 0 0 0 -.0122.2269.2463.2463 0 0 0 .2631.2665c.2114 0 .4022-.2472.5693-.7347l.0117-.0339.0132.0334c.03.0765.07.18.1064.304l.0014.0047-.002.0045a2.9569 2.9569 0 0 0 -.2775.9732c-.0022.2817.1252.4647.3246.4662h.0035c.1085 0 .3613-.0435.3661-.4466a2.7759 2.7759 0 0 0 -.1159-.6942l-.009-.0338.0292.0194a.6021.6021 0 0 0 .3284.1034h.0054a.5339.5339 0 0 0 .56-.5507.651.651 0 0 0 -.1314-.4133zm-5.8826-.4024c.0045-.101.013-.1993.0251-.2923.0782-.5991.2415-1.0176.3972-1.0176h.0007c.0742.0006.1114.0567.1105.1668a2.3986 2.3986 0 0 1 -.5095 1.1512l-.0262.0386zm4.9649 2.1541a.1218.1218 0 0 1 -.1025.05.1329.1329 0 0 1 -.1122-.0516c-.071-.095-.051-.3181.0649-.7233.0138-.0483.0289-.097.0447-.1446l.0135-.04.0118.0409c.135.4669.1619.7593.0798.8686zm.6931-1.0641a.36.36 0 0 1 -.2275.0816.5569.5569 0 0 1 -.4237-.2159l-.0028-.0041-.0049-.0155.0023-.0047c.154-.3173.3305-.4993.4841-.4993h.0016c.1734.0014.2933.1574.2916.3793a.35.35 0 0 1 -.1207.2786z"}),u.a.createElement("path",{d:"m7.3411 8.5746-.0106.01a.4713.4713 0 0 1 -.2644.1542c-.1343.0066-.2336-.0737-.2978-.2394l-.0027-.007.0044-.0057a2.99 2.99 0 0 0 .6029-1.7143c-.0118-.2288-.0784-.5015-.3282-.5015h-.0187a.3691.3691 0 0 0 -.2587.1356 2.5312 2.5312 0 0 0 -.3091 1.6265 1.6361 1.6361 0 0 0 .0781.42l.0024.0071-.0049.0057a.5851.5851 0 0 1 -.3807.2484c-.2611 0-.2523-.4376-.2316-.8007.0045-.0782.0111-.1281-.0121-.1564a.104.104 0 0 0 -.0846-.0306h-.0048c-.0928 0-.1122.0191-.16.1569-.0988.2864-.294.767-.49.767a.15.15 0 0 1 -.1244-.0553c-.0952-.1216-.023-.4248.0352-.6685.01-.0438.0205-.0859.029-.1248a.15.15 0 0 0 -.0116-.1254.1313.1313 0 0 0 -.1153-.0314c-.0841.0067-.1379.0419-.1638.2018l-.0052.0333-.02-.0237a.2745.2745 0 0 0 -.2412-.1188l-.0356.0024a.6553.6553 0 0 0 -.4215.2579.8632.8632 0 0 0 -.1856.6137l.0044.0345.001.0062-.0043.0047a.3506.3506 0 0 1 -.25.1356c-.1287-.001-.2025-.0967-.2025-.2559 0-.2681.1816-1.0761.1816-1.3686 0-.3113-.1387-.4808-.38-.4827h-.0032c-.3517 0-.6259.3992-.8882 1.22-.024.0752-.05.1621-.0726.2372l-.0368.1235.0106-.1283c.0243-.2861.0411-.5644.05-.8273a1.1083 1.1083 0 0 0 -.164-.7805.3566.3566 0 0 0 -.2693-.1043h-.0031c-.43 0-.6367.7259-.7868 1.2382-.0344.1175-.0942.3466-.1471.5547.032-.3469.0908-.9671.0863-1.3306-.0054-.438-.1512-.6343-.4726-.6368h-.004a.4978.4978 0 0 0 -.3606.157.6256.6256 0 0 0 -.1777.4279c.0023.0881.0565.1666.0975.1666.0267 0 .0415-.0356.0479-.0569.0994-.3288.2281-.4887.3935-.4887a.2049.2049 0 0 1 .1577.0617c.129.1385.1056.5123.063 1.191-.0137.2188-.0293.4665-.0424.7485-.0023.0483-.0052.0952-.0081.14-.0126.1958-.0225.35.0518.362a.157.157 0 0 0 .1916-.12c.0477-.1419.1547-.53.3618-1.2383.1987-.68.3489-.9275.5409-.9275.2219 0 .2385.381.1978 1.1851-.0087.17-.02.3635-.0292.5736l-.004.0857c-.0085.1739-.0153.3113.0344.3639a.0847.0847 0 0 0 .0645.0247c.0962 0 .1251-.0843.173-.2241.0084-.0247.0175-.051.0275-.0787.33-.9093.5733-1.6981.9-1.6981.0981 0 .1744.08.1744.2352 0 .3588-.1754 1.0521-.1754 1.4035a.4846.4846 0 0 0 .1047.3184.367.367 0 0 0 .2844.1259h.0025a.5171.5171 0 0 0 .3391-.158l.0108-.01.0087.0117a.3716.3716 0 0 0 .3314.147.5606.5606 0 0 0 .4373-.3675l.0125-.0334.0124.0334a.3511.3511 0 0 0 .3671.2617c.2377-.0191.4263-.3424.4964-.48l.0181-.0356.0068.0394c.0336.1943.1393.5208.47.5232h.0027a.7113.7113 0 0 0 .4692-.2529l.012-.0121.0087.0147a.4748.4748 0 0 0 .4161.2746.3943.3943 0 0 0 .3854-.2908.0964.0964 0 0 0 -.0212-.075.0489.0489 0 0 0 -.0733-.0054zm-2.5731-.4751c-.0712.2864-.2076.6319-.4536.6517l-.02.0008c-.102 0-.1592-.0668-.17-.1986a.6838.6838 0 0 1 .1811-.4922.3565.3565 0 0 1 .25-.1324h.0017a.2456.2456 0 0 1 .2105.1622l.0018.0041zm1.9349.1343-.0049-.0376c-.0144-.11-.0215-.2237-.0265-.3209-.0354-.6851.1718-1.3675.3524-1.3769h.0035a.0747.0747 0 0 1 .0606.0346 1.4766 1.4766 0 0 1 -.0569.9608 3.2342 3.2342 0 0 1 -.3085.7076z"}),u.a.createElement("path",{d:"m5.9066 7.3713.0013.0132v-.0132a.1631.1631 0 1 0 -.0013 0z"}),u.a.createElement("path",{d:"m11.6161 7.3713.0013.0132v-.0132a.163.163 0 1 0 -.0013 0z"})))};Il.displayName="IconLogoMailChimp",Il.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Il.defaultProps={title:"LogoMailChimp",color:null,size:null},Il.__docgenInfo={description:"",methods:[],displayName:"IconLogoMailChimp",props:{title:{defaultValue:{value:"'LogoMailChimp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var El=Il,Vl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .3147a7.3851 7.3851 0 0 0 -7.5824 7.1707 7.0108 7.0108 0 0 0 2.7448 5.5216v2.6783l2.5813-1.3521a7.9818 7.9818 0 0 0 2.2563.3228 7.3851 7.3851 0 0 0 7.5824-7.1707 7.3851 7.3851 0 0 0 -7.5824-7.1706zm.7891 9.6753-1.99-2.1272-3.8426 2.0585 4.1171-4.3913 1.99 1.99 3.8426-2.0586z"})))};Vl.displayName="IconLogoMessenger",Vl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Vl.defaultProps={title:"LogoMessenger",color:null,size:null},Vl.__docgenInfo={description:"",methods:[],displayName:"IconLogoMessenger",props:{title:{defaultValue:{value:"'LogoMessenger'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ql=Vl,bl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.879.16-8.434 3.256v9.406l.004.001 3.018-1.259v-7.409l5.464-1.261v11.034l-8.472-1.101 8.42 3.013 4.676-1.509v-12.596z"})))};bl.displayName="IconLogoOffice",bl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},bl.defaultProps={title:"LogoOffice",color:null,size:null},bl.__docgenInfo={description:"",methods:[],displayName:"IconLogoOffice",props:{title:{defaultValue:{value:"'LogoOffice'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Nl=bl,_l=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.9909 7.834a1.5044 1.5044 0 0 1 -2.075-.2048v4.0976h5.1559s.7546-.1049.6917-1.0947l.0037-5.3533z"}),u.a.createElement("path",{d:"m15.7254 3.9976a.571.571 0 0 0 -.6116-.6243h-5.1979v3.046l1.1108.7081z"}),u.a.createElement("ellipse",{cx:"4.7894",cy:"7.8613",rx:".998",ry:"1.6371"}),u.a.createElement("path",{d:"m.2328 14.0021 9.1172 1.7864v-15.577l-9.1172 1.5732zm4.581-8.8994c1.1464 0 2.0757 1.237 2.0757 2.763s-.9294 2.763-2.0757 2.763-2.0759-1.2369-2.0759-2.7629.9294-2.763 2.0758-2.763z"})))};_l.displayName="IconLogoOutlook",_l.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_l.defaultProps={title:"LogoOutlook",color:null,size:null},_l.__docgenInfo={description:"",methods:[],displayName:"IconLogoOutlook",props:{title:{defaultValue:{value:"'LogoOutlook'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wl=_l,xl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .16a7.84 7.84 0 0 0 -3.147 15.0206 6.8852 6.8852 0 0 1 .1365-1.8c.1507-.6365 1.0088-4.2719 1.0088-4.2719a3.0115 3.0115 0 0 1 -.25-1.24c0-1.1618.6734-2.0295 1.512-2.0295a1.05 1.05 0 0 1 1.0576 1.177 16.8753 16.8753 0 0 1 -.6929 2.7815 1.2134 1.2134 0 0 0 1.2374 1.51c1.4854 0 2.4858-1.9078 2.4858-4.1682a2.9349 2.9349 0 0 0 -3.2622-3.0044 3.7124 3.7124 0 0 0 -3.8597 3.7549 2.2633 2.2633 0 0 0 .5168 1.5377.38.38 0 0 1 .1127.437c-.0376.1443-.124.4915-.16.6292a.27.27 0 0 1 -.3925.1962 3.0194 3.0194 0 0 1 -1.6052-2.9957c0-2.227 1.8783-4.8975 5.6031-4.8975a4.6858 4.6858 0 0 1 4.9632 4.491c0 3.0754-1.71 5.3731-4.23 5.3731a2.2482 2.2482 0 0 1 -1.9153-.9772s-.4553 1.8062-.5517 2.1552a6.5628 6.5628 0 0 1 -.7891 1.6795 7.84 7.84 0 1 0 2.2217-15.3585z"})))};xl.displayName="IconLogoPinterest",xl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},xl.defaultProps={title:"LogoPinterest",color:null,size:null},xl.__docgenInfo={description:"",methods:[],displayName:"IconLogoPinterest",props:{title:{defaultValue:{value:"'LogoPinterest'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Tl=xl,Pl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6 3.2859a6.2331 6.2331 0 0 1 -1.791.491 3.1278 3.1278 0 0 0 1.371-1.7252 6.2435 6.2435 0 0 1 -1.98.7567 3.1214 3.1214 0 0 0 -5.314 2.8443 8.8531 8.8531 0 0 1 -6.4278-3.2583 3.1219 3.1219 0 0 0 .9651 4.1634 3.1063 3.1063 0 0 1 -1.4125-.39v.0393a3.12 3.12 0 0 0 2.5012 3.0577 3.1237 3.1237 0 0 1 -1.4083.0535 3.1214 3.1214 0 0 0 2.9131 2.1656 6.2564 6.2564 0 0 1 -3.8729 1.335 6.328 6.328 0 0 1 -.7439-.0437 8.8264 8.8264 0 0 0 4.78 1.4011 8.8122 8.8122 0 0 0 8.873-8.8727q0-.2028-.009-.4034a6.3362 6.3362 0 0 0 1.556-1.6143z"})))};Pl.displayName="IconLogoTwitter",Pl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Pl.defaultProps={title:"LogoTwitter",color:null,size:null},Pl.__docgenInfo={description:"",methods:[],displayName:"IconLogoTwitter",props:{title:{defaultValue:{value:"'LogoTwitter'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Bl=Pl,Ol=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.1135.16a7.6428 7.6428 0 0 0 -7.6428 7.6428 8.8145 8.8145 0 0 0 1.1093 3.9672l-1.3363 4.07 4.1878-1.3383a7.7472 7.7472 0 0 0 3.682.9438 7.6428 7.6428 0 1 0 0-15.2855zm0 14.0628a7.0167 7.0167 0 0 1 -3.5381-1.0621l-2.4139.7877.7833-2.3371a7.2986 7.2986 0 0 1 -1.2512-3.8085 6.42 6.42 0 1 1 6.42 6.42z"}),u.a.createElement("path",{d:"m11.87 9.419s-1.2522-.6065-1.51-.7242a.3.3 0 0 0 -.3883.0742s-.38.48-.5018.637-.1919.2967-.51.192a4.9275 4.9275 0 0 1 -1.4791-.9163 6.1161 6.1161 0 0 1 -1.0341-1.274.2356.2356 0 0 1 .0175-.3055s.3306-.3807.4887-.5847a.503.503 0 0 0 .0219-.5236c-.0378-.092-.5454-1.2847-.62-1.4529a.3423.3423 0 0 0 -.2356-.1964h-.6019a.8961.8961 0 0 0 -.3141.1309 2.1144 2.1144 0 0 0 -.7416 1.52 2.5162 2.5162 0 0 0 .29 1.3361 9.6893 9.6893 0 0 0 2.11 2.6 7.3472 7.3472 0 0 0 2.9535 1.442 2.2844 2.2844 0 0 0 1.876-.5889 1.3689 1.3689 0 0 0 .34-1.1692.2035.2035 0 0 0 -.1611-.1965z"})))};Ol.displayName="IconLogoWhatsApp",Ol.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ol.defaultProps={title:"LogoWhatsApp",color:null,size:null},Ol.__docgenInfo={description:"",methods:[],displayName:"IconLogoWhatsApp",props:{title:{defaultValue:{value:"'LogoWhatsApp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Cl=Ol,jl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.62 7.8574c.0776-.01.2133-.0291.2424-.0291a1.6112 1.6112 0 0 1 .2327.0291c-.4849-.97-.8632-1.9495-1.2415-2.9-.0679.01-.1454.029-.1745.029a.9247.9247 0 0 1 -.165-.0388c-.3976.97-.7661 1.94-1.2414 2.91a1.4689 1.4689 0 0 1 .2327-.0291 1.87 1.87 0 0 1 .2425.0291l.3491-.8535h1.1737c.1163.281.2327.572.3493.8533zm-1.4453-1.0574.5045-1.3288.5139 1.3288z"}),u.a.createElement("path",{d:"m2.5248 5.2677c.1358-.2424.2911-.4655.4365-.6984a1.431 1.431 0 0 1 -.2424.0292 1.3726 1.3726 0 0 1 -.2232-.0292l-.9893 1.61-.96-1.61a1.7778 1.7778 0 0 1 -.2521.0292 1.4577 1.4577 0 0 1 -.2327-.0292c.446.6887.8632 1.4355 1.2511 2.1339l-.0387 1.542a1.4744 1.4744 0 0 1 .2327-.029 1.4457 1.4457 0 0 1 .2424.029l-.0291-1.5614c.2617-.4753.5236-.9602.8048-1.4161z"}),u.a.createElement("path",{d:"m15.9386 4.8313a.2224.2224 0 0 0 -.2521-.223c-.32 0-.2038.3879-.2523.543-.01.0776-.01.1552-.0193.2231-.01.0776-.01.1553-.0194.2329l-.0291.3491c-.01.1067-.0194.223-.029.33-.0388.3784-.0873.7565-.1358 1.1446a.5488.5488 0 0 1 .1746.0291c.0968-.7472.5624-2.5124.5624-2.6288z"}),u.a.createElement("path",{d:"m5.7546 7.8574-.029-1.3481h1.62l-.0295 1.3481a1.4725 1.4725 0 0 1 .2329-.0291 1.3516 1.3516 0 0 1 .2328.0291v-2.9a1.4748 1.4748 0 0 1 -.2328.0291 1.8713 1.8713 0 0 1 -.2329-.0388.03.03 0 0 0 -.01.0194l.0389 1.3384h-1.62l.029-1.3578a1.7047 1.7047 0 0 1 -.2424.0388 1.866 1.866 0 0 1 -.2329-.0388v2.91a1.6112 1.6112 0 0 1 .2329-.0291 1.5585 1.5585 0 0 1 .243.0288z"}),u.a.createElement("path",{d:"m11.07 6.4122a1.4213 1.4213 0 0 0 -1.5715-1.4936 1.4206 1.4206 0 0 0 -1.5616 1.3772v.2329a2.0192 2.0192 0 0 0 .1163.5334 1.454 1.454 0 0 0 1.4453.8341 1.414 1.414 0 0 0 1.5715-1.484zm-1.5715 1.3191a1.1088 1.1088 0 0 1 -1.0766-1.2313v-.1751c.0388-.8049.4364-1.2221 1.0766-1.2221.8632 0 1.0862.6984 1.0862 1.3093 0 .6209-.2424 1.3192-1.0862 1.3192z"}),u.a.createElement("path",{d:"m15.182 7.7895a.2114.2114 0 0 0 -.223.2327c0 .1649.1164.223.2521.223a.207.207 0 0 0 .223-.2327.2265.2265 0 0 0 -.2521-.223z"}),u.a.createElement("path",{d:"m13.058 4.744a1.6328 1.6328 0 0 0 -1.804 1.4742v.3977a2.8436 2.8436 0 0 0 .1261.514 1.7024 1.7024 0 0 0 1.6779.9408 1.6087 1.6087 0 0 0 1.8137-1.6585 1.627 1.627 0 0 0 -1.8137-1.6682zm0 3.1521a1.2329 1.2329 0 0 1 -1.2415-.8729c0-.01-.0776-.3685-.0776-.4364v-.359a1.2332 1.2332 0 0 1 1.3191-1.3 1.2944 1.2944 0 0 1 1.3287 1.4742 1.3125 1.3125 0 0 1 -1.3287 1.4941z"}),u.a.createElement("path",{d:"m5.53 10.911h-.018l-.869-1.713h-.383v2.233h.166v-1.816h.025l.926 1.816h.077l.915-1.829h.013v1.829h.376v-2.233h-.376z"}),u.a.createElement("path",{d:"m8.1224 9.1475-1.0754 2.2832h.1876l.3524-.7451h.9568l.3414.7451h.3813l-1.0514-2.2832zm-.47 1.394.4165-.883.4055.883z"}),u.a.createElement("path",{d:"m9.5546 9.1985h.3751v2.2322h-.3751z"}),u.a.createElement("path",{d:"m10.866 9.198h-.376v2.233h1.499v-.144h-1.123z"})))};jl.displayName="IconLogoYahooMail",jl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},jl.defaultProps={title:"LogoYahooMail",color:null,size:null},jl.__docgenInfo={description:"",methods:[],displayName:"IconLogoYahooMail",props:{title:{defaultValue:{value:"'LogoYahooMail'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ll=jl,Al=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5361 4.1894a1.9764 1.9764 0 0 0 -1.3906-1.4 46.7 46.7 0 0 0 -6.1455-.3305 46.7 46.7 0 0 0 -6.1454.3311 1.9764 1.9764 0 0 0 -1.3906 1.4 20.7343 20.7343 0 0 0 -.3287 3.81 20.7338 20.7338 0 0 0 .3287 3.8105 1.9764 1.9764 0 0 0 1.3906 1.4 46.7 46.7 0 0 0 6.1454.3306 46.7 46.7 0 0 0 6.1455-.3309 1.9764 1.9764 0 0 0 1.3906-1.4 20.7338 20.7338 0 0 0 .3286-3.8102 20.7341 20.7341 0 0 0 -.3286-3.8106zm-9.0893 6.1377v-4.6542l4.0907 2.3271z"})))};Al.displayName="IconLogoYouTube",Al.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Al.defaultProps={title:"LogoYouTube",color:null,size:null},Al.__docgenInfo={description:"",methods:[],displayName:"IconLogoYouTube",props:{title:{defaultValue:{value:"'LogoYouTube'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Sl=Al,kl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0146 1.6543a.7.7 0 0 0 -.7.7v.7484l-10.9982 2.0173a.6936.6936 0 0 0 -.4283.2687l-1.685-.5513a.7.7 0 0 0 -.918.665v4.7251a.699.699 0 0 0 .918.665l1.6849-.5514a.6936.6936 0 0 0 .4283.2687l.9512.1744v1.8978a.7005.7005 0 0 0 .5762.689l5.3506.9634a.71.71 0 0 0 .124.0112.7.7 0 0 0 .7-.7v-1.623l3.2959.6045v.7484a.7.7 0 0 0 1.4 0v-11.021a.7.7 0 0 0 -.6996-.7002zm-5.3964 11.1538-3.95-.7114v-1.0318l3.95.7114zm-7.9326-6.34 1.0566.3457v2.1022l-1.0566.3457zm2.457 2.87v-2.946l10.1719-1.8662v6.6782z"})))};kl.displayName="IconMegaphone",kl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},kl.defaultProps={title:"Megaphone",color:null,size:null},kl.__docgenInfo={description:"",methods:[],displayName:"IconMegaphone",props:{title:{defaultValue:{value:"'Megaphone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Dl=kl,Fl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.8555 3.9287h14.289a.75.75 0 0 0 0-1.5h-14.289a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m15.1445 7.25h-14.289a.75.75 0 0 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.1445 12.0713h-14.289a.75.75 0 1 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z"})))};Fl.displayName="IconMenu",Fl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Fl.defaultProps={title:"Menu",color:null,size:null},Fl.__docgenInfo={description:"",methods:[],displayName:"IconMenu",props:{title:{defaultValue:{value:"'Menu'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ml=Fl,Ul=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2012 7.25h-14.4024a.75.75 0 0 0 0 1.5h14.4024a.75.75 0 0 0 0-1.5z"})))};Ul.displayName="IconMinus",Ul.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ul.defaultProps={title:"Minus",color:null,size:null},Ul.__docgenInfo={description:"",methods:[],displayName:"IconMinus",props:{title:{defaultValue:{value:"'Minus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Hl=Ul,Gl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.9794 7.9794 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4781 6.4781 0 0 1 -6.4707 6.47z"}),u.a.createElement("path",{d:"m11.3569 7.25h-6.7133a.75.75 0 0 0 0 1.5h6.7134a.75.75 0 1 0 0-1.5z"})))};Gl.displayName="IconMinusCircle",Gl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Gl.defaultProps={title:"MinusCircle",color:null,size:null},Gl.__docgenInfo={description:"",methods:[],displayName:"IconMinusCircle",props:{title:{defaultValue:{value:"'MinusCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rl=Gl,Wl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.4248.0893h-6.85a1.7021 1.7021 0 0 0 -1.7 1.7v12.4207a1.7021 1.7021 0 0 0 1.7 1.7h6.85a1.7021 1.7021 0 0 0 1.7-1.7v-12.42a1.7021 1.7021 0 0 0 -1.7-1.7007zm-6.85 1.4h6.85a.3.3 0 0 1 .3.3v.9189h-7.4494v-.9182a.3.3 0 0 1 .2998-.3zm7.1494 2.6191v6.6826h-7.4488v-6.6821zm-.3 10.4014h-6.85a.3.3 0 0 1 -.3-.3v-2.0179h7.4492v2.0181a.3005.3005 0 0 1 -.2986.3z"}),u.a.createElement("path",{d:"m8.8906 12.647h-1.7806a.7.7 0 1 0 0 1.4h1.78a.7.7 0 1 0 0-1.4z"})))};Wl.displayName="IconMobile",Wl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Wl.defaultProps={title:"Mobile",color:null,size:null},Wl.__docgenInfo={description:"",methods:[],displayName:"IconMobile",props:{title:{defaultValue:{value:"'Mobile'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xl=Wl,Yl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("circle",{cx:"1.9236",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"14.0764",cy:"8",r:"1.8436"})))};Yl.displayName="IconMore",Yl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Yl.defaultProps={title:"More",color:null,size:null},Yl.__docgenInfo={description:"",methods:[],displayName:"IconMore",props:{title:{defaultValue:{value:"'More'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kl=Yl,Zl=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("circle",{cx:"8",cy:"1.9236",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"14.0764",r:"1.8436"})))};Zl.displayName="IconMoreAndroid",Zl.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Zl.defaultProps={title:"MoreAndroid",color:null,size:null},Zl.__docgenInfo={description:"",methods:[],displayName:"IconMoreAndroid",props:{title:{defaultValue:{value:"'MoreAndroid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Jl=Zl,Ql=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 12 18",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("g",{fillRule:"evenodd"},u.a.createElement("path",{d:"M2 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 012 6.54zM2 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 012 .085zM9 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 019 6.54zM9 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 019 .085z"}))))};Ql.displayName="IconMove",Ql.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ql.defaultProps={title:"Move",color:null,size:null},Ql.__docgenInfo={description:"",methods:[],displayName:"IconMove",props:{title:{defaultValue:{value:"'Move'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $l=Ql,er=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m2.4427 15.1711.6325.003h10.4922a2.3733 2.3733 0 0 0 2.3706-2.3706v-11.2276a.75.75 0 0 0 -.75-.75h-11.1543a.75.75 0 0 0 -.75.75v2.8872h-2.4717a.75.75 0 0 0 -.75.75v7.59a2.3711 2.3711 0 0 0 2.3315 2.3669c.0069 0 .0126.004.02.004l.01-.0009.0092.0009.0156-.0031m-.0253-1.4988a.8706.8706 0 0 1 -.8608-.8687v-6.84h1.7215v6.84a.8706.8706 0 0 1 -.8609.8687zm2.3607-11.3462h9.6543v10.4776a.8717.8717 0 0 1 -.8706.8706h-8.9492a2.3564 2.3564 0 0 0 .1655-.8706z"}),u.a.createElement("path",{d:"m6.9346 8.6965h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m6.9346 11.7234h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m6.9346 5.7068h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"})))};er.displayName="IconNews",er.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},er.defaultProps={title:"News",color:null,size:null},er.__docgenInfo={description:"",methods:[],displayName:"IconNews",props:{title:{defaultValue:{value:"'News'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tr=er,ar=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.1025 7.7486a.7366.7366 0 0 1 -.5231-.2167 6.4767 6.4767 0 0 0 -9.1589 0 .74.74 0 0 1 -1.0461-1.0462 7.9558 7.9558 0 0 1 11.2511 0 .74.74 0 0 1 -.5231 1.2629z"}),u.a.createElement("path",{d:"m15.1466 4.5861a.7366.7366 0 0 1 -.5231-.2167 9.3674 9.3674 0 0 0 -13.2471 0 .74.74 0 0 1 -1.0464-1.0461 10.8465 10.8465 0 0 1 15.3393 0 .74.74 0 0 1 -.5231 1.2629z"}),u.a.createElement("path",{d:"m5.534 15.8536a.74.74 0 0 1 -.5231-1.2629l4.932-4.932a.74.74 0 0 1 1.0461 1.0461l-4.932 4.932a.7366.7366 0 0 1 -.523.2168z"}),u.a.createElement("path",{d:"m10.466 15.8536a.7366.7366 0 0 1 -.5231-.2167l-4.932-4.932a.74.74 0 0 1 1.0462-1.0461l4.932 4.932a.74.74 0 0 1 -.5231 1.2629z"})))};ar.displayName="IconNoWifi",ar.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ar.defaultProps={title:"NoWifi",color:null,size:null},ar.__docgenInfo={description:"",methods:[],displayName:"IconNoWifi",props:{title:{defaultValue:{value:"'NoWifi'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var lr=ar,rr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.8181 7.8181 7.818 7.818 0 0 0 -7.8181-7.8181zm.9717 11.631h-1.4375v-6.2099l-1.7242.4258v-1.2764l3.1621-.7481z"})))};rr.displayName="IconNumber1",rr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},rr.defaultProps={title:"Number1",color:null,size:null},rr.__docgenInfo={description:"",methods:[],displayName:"IconNumber1",props:{title:{defaultValue:{value:"'Number1'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nr=rr,ir=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8063 11.6314h-5.3955v-1.0585c2.1972-1.6797 3.7617-2.7608 3.7617-4.2569a1.1908 1.1908 0 0 0 -1.2425-1.3457 1.1447 1.1447 0 0 0 -1.1852 1.2188 1.3668 1.3668 0 0 0 .23.748l-1.1963.4834a2.0961 2.0961 0 0 1 -.3916-1.3115 2.3853 2.3853 0 0 1 2.5893-2.3009 2.3743 2.3743 0 0 1 2.623 2.4736c0 1.7715-1.875 3.2207-3.2441 4.1182h3.4512z"})))};ir.displayName="IconNumber2",ir.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ir.defaultProps={title:"Number2",color:null,size:null},ir.__docgenInfo={description:"",methods:[],displayName:"IconNumber2",props:{title:{defaultValue:{value:"'Number2'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var or=ir,ur=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.1981 11.7692a2.5763 2.5763 0 0 1 -2.7842-1.99l1.2315-.4717a1.49 1.49 0 0 0 1.542 1.3467 1.2383 1.2383 0 0 0 1.3915-1.2434c0-.7588-.5752-1.1728-1.4375-1.1728h-.7832v-1.0245h.7256c.8975 0 1.2881-.4717 1.2881-1.208a1.0614 1.0614 0 0 0 -1.1621-1.0474 1.3524 1.3524 0 0 0 -1.3574 1.2544l-1.208-.4834a2.5238 2.5238 0 0 1 2.6118-1.921c1.5185 0 2.4853.794 2.4853 2.082a1.6881 1.6881 0 0 1 -1.4614 1.7833v.0234a1.7685 1.7685 0 0 1 1.668 1.7949c0 1.4264-1.208 2.2775-2.75 2.2775z"})))};ur.displayName="IconNumber3",ur.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ur.defaultProps={title:"Number3",color:null,size:null},ur.__docgenInfo={description:"",methods:[],displayName:"IconNumber3",props:{title:{defaultValue:{value:"'Number3'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var cr=ur,sr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.917 8.569v.046h2.186v-2.876h-.046z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.9562 9.48h-1.4727v2.1514h-1.3808v-2.1513h-3.4278v-1.1045l3.417-4.43h1.3916v4.4876h1.4727z"})))};sr.displayName="IconNumber4",sr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},sr.defaultProps={title:"Number4",color:null,size:null},sr.__docgenInfo={description:"",methods:[],displayName:"IconNumber4",props:{title:{defaultValue:{value:"'Number4'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dr=sr,pr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.03 11.7692a2.613 2.613 0 0 1 -2.7838-2.0362l1.2538-.4482a1.5052 1.5052 0 0 0 1.53 1.3574 1.3438 1.3438 0 0 0 1.4037-1.4961 1.2671 1.2671 0 0 0 -1.3-1.4033 1.3677 1.3677 0 0 0 -1.0586.4482h-1.1619l.2068-4.2451h4.292v1.208h-3.1756l-.1035 2.0254a2.1587 2.1587 0 0 1 1.3691-.4951 2.2726 2.2726 0 0 1 2.3242 2.4394 2.5983 2.5983 0 0 1 -2.7962 2.6456z"})))};pr.displayName="IconNumber5",pr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},pr.defaultProps={title:"Number5",color:null,size:null},pr.__docgenInfo={description:"",methods:[],displayName:"IconNumber5",props:{title:{defaultValue:{value:"'Number5'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var mr=pr,gr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.025 7.994a1.3285 1.3285 0 0 0 -1.3691 1.415 1.329 1.329 0 0 0 1.3691 1.415 1.3378 1.3378 0 0 0 1.4033-1.415 1.3373 1.3373 0 0 0 -1.4033-1.415z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm.0826 11.7691a2.6606 2.6606 0 0 1 -2.3359-1.2187 4.5691 4.5691 0 0 1 -.6787-2.5664c0-2.4619 1.2539-4.1759 3.2676-4.1759a2.4 2.4 0 0 1 2.3809 1.4492l-1.0117.667a1.4185 1.4185 0 0 0 -1.3809-.9775c-1.2422 0-1.9326 1.22-1.9326 2.8418v.1953h.0342a1.9914 1.9914 0 0 1 1.9101-1.2658 2.3065 2.3065 0 0 1 2.4044 2.4514 2.5032 2.5032 0 0 1 -2.6574 2.5997z"})))};gr.displayName="IconNumber6",gr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},gr.defaultProps={title:"Number6",color:null,size:null},gr.__docgenInfo={description:"",methods:[],displayName:"IconNumber6",props:{title:{defaultValue:{value:"'Number6'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var zr=gr,vr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8854 5.0045-2.6924 6.627h-1.4961l2.6924-6.5h-2.75v1.23h-1.2422v-2.4156h5.4883z"})))};vr.displayName="IconNumber7",vr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},vr.defaultProps={title:"Number7",color:null,size:null},vr.__docgenInfo={description:"",methods:[],displayName:"IconNumber7",props:{title:{defaultValue:{value:"'Number7'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hr=vr,fr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.9518 8.4081c-.8518 0-1.4268.4482-1.4268 1.2419s.575 1.2317 1.4268 1.2317c.8633 0 1.4385-.4375 1.4385-1.2315s-.5752-1.2421-1.4385-1.2421z"}),u.a.createElement("path",{d:"m7.9518 7.3378a1.119 1.119 0 0 0 1.2539-1.1621 1.1052 1.1052 0 0 0 -1.2539-1.15 1.096 1.096 0 0 0 -1.2418 1.15 1.11 1.11 0 0 0 1.2418 1.1621z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.0482 11.7692c-1.7139 0-2.8418-.8511-2.8418-2.1973a1.957 1.957 0 0 1 1.542-1.875v-.0235a1.7811 1.7811 0 0 1 -1.2891-1.7832c0-1.22 1.0127-2.082 2.5889-2.082 1.5879 0 2.6006.8623 2.6006 2.082a1.7811 1.7811 0 0 1 -1.2891 1.7833v.0234a1.957 1.957 0 0 1 1.542 1.875c0 1.3462-1.1279 2.1973-2.8535 2.1973z"})))};fr.displayName="IconNumber8",fr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},fr.defaultProps={title:"Number8",color:null,size:null},fr.__docgenInfo={description:"",methods:[],displayName:"IconNumber8",props:{title:{defaultValue:{value:"'Number8'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var yr=fr,Ir=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.3129 11.7692a2.4015 2.4015 0 0 1 -2.3818-1.4492l1.0127-.667a1.4173 1.4173 0 0 0 1.38.9775c1.2432 0 1.9336-1.22 1.9336-2.8418v-.1953h-.0353a1.99 1.99 0 0 1 -1.9092 1.2656 2.3067 2.3067 0 0 1 -2.4052-2.4509 2.504 2.504 0 0 1 2.6581-2.6 2.6587 2.6587 0 0 1 2.335 1.22 4.5579 4.5579 0 0 1 .6787 2.5654c0 2.4618-1.2537 4.1757-3.2666 4.1757z"}),u.a.createElement("path",{d:"m7.9977 5.1171a1.3381 1.3381 0 0 0 -1.4043 1.415 1.3383 1.3383 0 0 0 1.4043 1.416 1.33 1.33 0 0 0 1.3691-1.416 1.33 1.33 0 0 0 -1.3691-1.415z"})))};Ir.displayName="IconNumber9",Ir.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ir.defaultProps={title:"Number9",color:null,size:null},Ir.__docgenInfo={description:"",methods:[],displayName:"IconNumber9",props:{title:{defaultValue:{value:"'Number9'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Er=Ir,Vr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-2.1058 11.3649h-1.375v-5.94l-1.65.4063v-1.2212l3.025-.7149zm4.2129.1318c-1.87 0-2.8935-1.6611-2.8935-3.8066 0-2.1562 1.0234-3.8066 2.8935-3.8066s2.8935 1.65 2.8935 3.8066c0 2.1455-1.0234 3.8066-2.8935 3.8066z"}),u.a.createElement("path",{d:"m10.1071 5.2206c-1.0674 0-1.5185 1.1006-1.5185 2.6514s.4512 2.6514 1.5185 2.6514c1.0781 0 1.5293-1.1 1.5293-2.6514s-.4512-2.6514-1.5293-2.6514z"})))};Vr.displayName="IconNumber10",Vr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Vr.defaultProps={title:"Number10",color:null,size:null},Vr.__docgenInfo={description:"",methods:[],displayName:"IconNumber10",props:{title:{defaultValue:{value:"'Number10'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qr=Vr,br=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.0029.1411h-8.3955a4.36 4.36 0 0 0 0 8.7207h1.439v6.2471a.75.75 0 0 0 1.5 0v-13.4678h2.1685v13.4678a.75.75 0 0 0 1.5 0v-13.4678h1.7881a.75.75 0 1 0 0-1.5zm-6.9565 7.2207h-1.439a2.86 2.86 0 1 1 0-5.7207h1.439z"})))};br.displayName="IconParagraph",br.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},br.defaultProps={title:"Paragraph",color:null,size:null},br.__docgenInfo={description:"",methods:[],displayName:"IconParagraph",props:{title:{defaultValue:{value:"'Paragraph'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Nr=br,_r=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.1787 8.1489a.75.75 0 0 0 -.75.75v5.3462h-9.8467v-9.8467h5.9629a.75.75 0 0 0 0-1.5h-6.7129a.75.75 0 0 0 -.75.75v11.3467a.75.75 0 0 0 .75.75h11.3467a.75.75 0 0 0 .75-.75v-6.0962a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m15.6982 2.6489-2.1738-2.1743a.75.75 0 0 0 -1.0605 0l-1.64 1.64-.0015.001-.001.0015-4.8458 4.8458a.75.75 0 0 0 -.22.53v2.1746a.75.75 0 0 0 .75.75h2.1744a.7494.7494 0 0 0 .53-.22l4.8462-4.8462.001-.0005.0014-.0019 1.64-1.64a.75.75 0 0 0 -.0004-1.06zm-2.7041-.5835 1.1133 1.1138-.58.58-1.114-1.113zm-4.625 6.8521h-1.1132v-1.1138l4.097-4.097 1.1136 1.1133z"})))};_r.displayName="IconPencilBox",_r.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},_r.defaultProps={title:"PencilBox",color:null,size:null},_r.__docgenInfo={description:"",methods:[],displayName:"IconPencilBox",props:{title:{defaultValue:{value:"'PencilBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wr=_r,xr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.95 12.915h4.0085a.7033.7033 0 0 0 .4951-.2051l.5527-.5527.0029-.002.0019-.0029 4.8662-4.8662.0029-.0019.002-.0029 1.9024-1.9023a.7.7 0 0 0 0-.99l-4.0087-4.009a.7.7 0 0 0 -.99 0l-1.9026 1.9022-.0029.002-.0019.0029-4.8663 4.8662-.0029.0019-.002.0029-.5527.5527a.7033.7033 0 0 0 -.2051.4951v4.0088a.7.7 0 0 0 .7005.7003zm.7-4.1289 2.7285 2.7285h-2.7285zm4.726-5.0161 3.0185 3.0186-3.8808 3.8808-3.0186-3.0185zm1.9048-1.9048 3.0185 3.0185-.9145.9146-3.0186-3.0183z"}),u.a.createElement("path",{d:"m14.05 14.4248h-12.1a.7.7 0 1 0 0 1.4h12.1a.7.7 0 1 0 0-1.4z"})))};xr.displayName="IconPencilPaper",xr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},xr.defaultProps={title:"PencilPaper",color:null,size:null},xr.__docgenInfo={description:"",methods:[],displayName:"IconPencilPaper",props:{title:{defaultValue:{value:"'PencilPaper'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Tr=xr,Pr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2012 7.25h-6.4512v-6.4512a.75.75 0 0 0 -1.5 0v6.4512h-6.4512a.75.75 0 0 0 0 1.5h6.4512v6.4512a.75.75 0 0 0 1.5 0v-6.4512h6.4512a.75.75 0 0 0 0-1.5z"})))};Pr.displayName="IconPlus",Pr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Pr.defaultProps={title:"Plus",color:null,size:null},Pr.__docgenInfo={description:"",methods:[],displayName:"IconPlus",props:{title:{defaultValue:{value:"'Plus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Br=Pr,Or=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.979 7.979 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4778 6.4778 0 0 1 -6.4707 6.47z"}),u.a.createElement("path",{d:"m11.3564 7.25h-2.6064v-2.6067a.75.75 0 1 0 -1.5 0v2.6067h-2.6064a.75.75 0 1 0 0 1.5h2.6064v2.6069a.75.75 0 1 0 1.5 0v-2.6069h2.6065a.75.75 0 1 0 0-1.5z"})))};Or.displayName="IconPlusCircle",Or.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Or.defaultProps={title:"PlusCircle",color:null,size:null},Or.__docgenInfo={description:"",methods:[],displayName:"IconPlusCircle",props:{title:{defaultValue:{value:"'PlusCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Cr=Or,jr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1406 4.1345h-1.6806v-3.2754a.7.7 0 0 0 -.7-.7h-9.5208a.7.7 0 0 0 -.7.7v3.2754h-1.6798a.7.7 0 0 0 -.7.7v6.9736a.7.7 0 0 0 .7.7h1.68v2.6323a.7.7 0 0 0 .7.7h9.5206a.7.7 0 0 0 .7-.7v-2.6319h1.6807a.7.7 0 0 0 .7-.7v-6.9738a.7.7 0 0 0 -.7001-.7002zm-11.2012-2.5752h8.12v2.5752h-8.12zm8.12 12.8813h-8.12v-4.4106h8.12zm2.3806-3.3324h-.98v-1.7782a.7.7 0 0 0 -.7-.7h-9.52a.7.7 0 0 0 -.7.7v1.7783h-.98v-5.5734h12.88z"}),u.a.createElement("path",{d:"m3.2334 7.7947a.7025.7025 0 0 0 .5-.2.6887.6887 0 0 0 0-.99.7253.7253 0 0 0 -.9893 0 .6887.6887 0 0 0 0 .99.6959.6959 0 0 0 .4893.2z"})))};jr.displayName="IconPrinter",jr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},jr.defaultProps={title:"Printer",color:null,size:null},jr.__docgenInfo={description:"",methods:[],displayName:"IconPrinter",props:{title:{defaultValue:{value:"'Printer'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Lr=jr,Ar=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.0752 15.5062h-.0185a.725.725 0 0 1 -.6953-.6l-1.7755-10.1436-1.582 6.5a.7237.7237 0 0 1 -.5879.5444.7143.7143 0 0 1 -.7295-.33l-1.5565-2.4752h-1.3a.7251.7251 0 0 1 0-1.45h1.7a.7228.7228 0 0 1 .6133.3394l.8577 1.3621 1.997-8.2051a.7246.7246 0 0 1 1.418.0464l1.7529 10.0137 1.6885-7.4136a.7252.7252 0 0 1 1.3779-.1147l1.6309 3.9688h1.3038a.7251.7251 0 0 1 0 1.45h-1.79a.7262.7262 0 0 1 -.6709-.45l-.9464-2.3018-1.98 8.6953a.7249.7249 0 0 1 -.7075.5639z"})))};Ar.displayName="IconPulse",Ar.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ar.defaultProps={title:"Pulse",color:null,size:null},Ar.__docgenInfo={description:"",methods:[],displayName:"IconPulse",props:{title:{defaultValue:{value:"'Pulse'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Sr=Ar,kr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7 14.6392-4.09-4.0892a6.4833 6.4833 0 1 0 -1.06 1.0605l4.0892 4.0895a.75.75 0 0 0 1.0608-1.0608zm-14.1194-8.0938a4.9646 4.9646 0 1 1 4.9648 4.9646 4.9706 4.9706 0 0 1 -4.9648-4.9646z"})))};kr.displayName="IconSearch",kr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},kr.defaultProps={title:"Search",color:null,size:null},kr.__docgenInfo={description:"",methods:[],displayName:"IconSearch",props:{title:{defaultValue:{value:"'Search'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Dr=kr,Fr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 7.8437a3.5591 3.5591 0 1 0 -3.559-3.559 3.5632 3.5632 0 0 0 3.559 3.559zm0-5.6181a2.0591 2.0591 0 1 1 -2.059 2.0591 2.0616 2.0616 0 0 1 2.059-2.0591z"}),u.a.createElement("path",{d:"m15.0635 8.6909h-5.0835a.75.75 0 0 0 -.75.75v5.0835a.75.75 0 0 0 .75.75h5.0835a.75.75 0 0 0 .75-.75v-5.0835a.75.75 0 0 0 -.75-.75zm-.75 5.0835h-3.5835v-3.5835h3.5835z"}),u.a.createElement("path",{d:"m4.83 8.5312a.78.78 0 0 0 -1.2988 0l-3.244 5.6182a.75.75 0 0 0 .6494 1.125h6.4878a.75.75 0 0 0 .6494-1.125zm-2.5946 5.2432 1.9446-3.3682 1.9448 3.3682z"})))};Fr.displayName="IconShapes",Fr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Fr.defaultProps={title:"Shapes",color:null,size:null},Fr.__docgenInfo={description:"",methods:[],displayName:"IconShapes",props:{title:{defaultValue:{value:"'Shapes'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Mr=Fr,Ur=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.65 9.3564a3.2646 3.2646 0 0 0 -2.5011 1.18l-3.6189-1.7537a3.0256 3.0256 0 0 0 .0181-1.5073l3.629-1.7778a3.268 3.268 0 1 0 -.8121-2.1392 3.2482 3.2482 0 0 0 .1133.8107l-3.5975 1.7623a3.2852 3.2852 0 1 0 -.0389 4.1843l3.6235 1.7565a3.2556 3.2556 0 0 0 -.1.7694 3.2852 3.2852 0 1 0 3.2846-3.2852zm0-7.7832a1.7852 1.7852 0 1 1 -1.785 1.7852 1.7871 1.7871 0 0 1 1.785-1.7852zm-9.311 8.2119a1.7871 1.7871 0 0 1 -1.7852-1.7851 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0004a1.7816 1.7816 0 1 1 1.5747 2.6082zm9.311 4.6417a1.7871 1.7871 0 0 1 -1.7852-1.7852 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0008a1.7816 1.7816 0 1 1 1.5747 2.6087z"})))};Ur.displayName="IconShareAndroid",Ur.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ur.defaultProps={title:"ShareAndroid",color:null,size:null},Ur.__docgenInfo={description:"",methods:[],displayName:"IconShareAndroid",props:{title:{defaultValue:{value:"'ShareAndroid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Hr=Ur,Gr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.791 5.314a.7266.7266 0 0 0 .0519-.077.7066.7066 0 0 0 0-.6249.7223.7223 0 0 0 -.0525-.0779.7358.7358 0 0 0 -.1411-.1715c-.0112-.01-.0157-.0245-.0275-.0335l-4.2812-3.2807a.75.75 0 1 0 -.9121 1.19l2.5257 1.9356h-3.3412c-3.8208 0-6.93 2.3926-6.93 5.3335a.75.75 0 1 0 1.5 0c0-2.1138 2.4356-3.8335 5.43-3.8335h3.3413l-2.5259 1.936a.75.75 0 1 0 .9121 1.19l4.2813-3.2801c.0118-.009.0163-.0238.0275-.0335a.7364.7364 0 0 0 .1417-.1725z"}),u.a.createElement("path",{d:"m12.2869 9.6066a.75.75 0 0 0 -.75.75v3.25h-9.9527v-9.9526h4.9912a.75.75 0 0 0 0-1.5h-5.7412a.75.75 0 0 0 -.75.75v11.4526a.75.75 0 0 0 .75.75h11.4527a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0 -.75-.75z"})))};Gr.displayName="IconShare",Gr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Gr.defaultProps={title:"Share",color:null,size:null},Gr.__docgenInfo={description:"",methods:[],displayName:"IconShare",props:{title:{defaultValue:{value:"'Share'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rr=Gr,Wr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.2988 6.5522h-3.6826a.75.75 0 0 0 0 1.5h2.9326v6.36h-11.0976v-6.36h2.9326a.75.75 0 0 0 0-1.5h-3.6826a.75.75 0 0 0 -.75.75v7.86a.75.75 0 0 0 .75.75h12.5976a.75.75 0 0 0 .75-.75v-7.86a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m5.22 4.6768 2.03-2.03v7.9049a.75.75 0 0 0 1.5 0v-7.9048l2.03 2.03a.75.75 0 1 0 1.0605-1.0605l-3.3105-3.3102a.7527.7527 0 0 0 -1.0605 0l-3.3106 3.31a.75.75 0 0 0 1.0611 1.0606z"})))};Wr.displayName="IconShareIOS",Wr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Wr.defaultProps={title:"ShareIOS",color:null,size:null},Wr.__docgenInfo={description:"",methods:[],displayName:"IconShareIOS",props:{title:{defaultValue:{value:"'ShareIOS'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xr=Wr,Yr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8811 12.09a.7506.7506 0 0 0 -.1614-.2416l-2.3975-2.397a.75.75 0 0 0 -1.0605 1.0605l1.1167 1.1164h-1.4077l-.0057.0012-.0051-.0012c-1.249.0483-3.4619-.4619-4.6035-3.8662-1.8935-5.6521-6.6357-4.8485-6.6826-4.8378a.75.75 0 0 0 .2685 1.4757c.1406-.023 3.5215-.5513 4.9922 3.8384 1.4688 4.3843 4.6045 4.89 5.9688 4.89h.0779 1.3978l-1.1172 1.1169a.75.75 0 1 0 1.0605 1.0605l2.3975-2.397a.7476.7476 0 0 0 .1614-.819z"}),u.a.createElement("path",{d:"m7.7666 6.523a.747.747 0 0 0 .6034-.3038 4.227 4.227 0 0 1 3.59-1.8472l.0057-.001.0051.001h1.4077l-1.1168 1.1163a.75.75 0 1 0 1.0605 1.0605l2.3978-2.3969a.7513.7513 0 0 0 -.0006-1.0611l-2.3972-2.3965a.75.75 0 1 0 -1.0605 1.0605l1.1173 1.1169h-1.4083a5.8241 5.8241 0 0 0 -4.8057 2.455.75.75 0 0 0 .6016 1.1963z"}),u.a.createElement("path",{d:"m4.9394 9.7544a4.2617 4.2617 0 0 1 -3.9971 1.8456.75.75 0 0 0 -.2676 1.4756 4.2116 4.2116 0 0 0 .7178.0532 5.792 5.792 0 0 0 4.7575-2.4888.75.75 0 0 0 -1.2109-.8857z"})))};Yr.displayName="IconShuffle",Yr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Yr.defaultProps={title:"Shuffle",color:null,size:null},Yr.__docgenInfo={description:"",methods:[],displayName:"IconShuffle",props:{title:{defaultValue:{value:"'Shuffle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kr=Yr,Zr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2.1h-14.4a.7.7 0 0 0 -.7.7v14.4a.7.7 0 0 0 .7.7h14.4a.7.7 0 0 0 .7-.7v-14.4a.7.7 0 0 0 -.7-.7zm-.7 14.4h-13v-13h13z"}),u.a.createElement("path",{d:"m5.5576 8.9414a3.33 3.33 0 0 1 -2.8618 1.1206.7.7 0 0 0 -.2158 1.3833 3.6491 3.6491 0 0 0 .5352.0342 4.6867 4.6867 0 0 0 3.6088-1.6309.6887.6887 0 0 0 .151-.5579 4.6624 4.6624 0 0 0 4.0189 2.1888h.7383l-.5777.5775a.7.7 0 0 0 .99.99l1.7725-1.7725c.0054-.0054.007-.0129.0122-.0184a.681.681 0 0 0 .0033-.9485c-.0065-.0071-.0086-.0164-.0155-.0233l-1.7722-1.7721a.7.7 0 0 0 -.99.99l.577.5768h-.6893-.0083a3.3521 3.3521 0 0 1 -3.2769-2.334l-.0016-.0024a5.9911 5.9911 0 0 0 -.3221-.683.6529.6529 0 0 0 .0439.0566.7.7 0 0 0 .9873-.0732 3.29 3.29 0 0 1 2.5272-1.123h.05.69l-.5775.5773a.7.7 0 0 0 .99.99l1.7725-1.7725a.6522.6522 0 0 0 .0361-.0544.6252.6252 0 0 0 .1689-.4409l-.002-.0108a.69.69 0 0 0 -.2-.48l-.0023-.0034-.0006-.0006-1.7723-1.7716a.7.7 0 1 0 -.99.99l.5772.577h-.69l-.0029.0006a4.6157 4.6157 0 0 0 -3.635 1.6087.6883.6883 0 0 0 -.13.6486 4.69 4.69 0 0 0 -4.5941-2.2233.7.7 0 0 0 .22 1.3828 3.3245 3.3245 0 0 1 3.5521 2.3151v.0018a6.3017 6.3017 0 0 0 .2716.5961.6976.6976 0 0 0 -.9661.0909z"})))};Zr.displayName="IconShuffleBox",Zr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Zr.defaultProps={title:"ShuffleBox",color:null,size:null},Zr.__docgenInfo={description:"",methods:[],displayName:"IconShuffleBox",props:{title:{defaultValue:{value:"'ShuffleBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Jr=Zr,Qr=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.15 0h-14.4a.75.75 0 0 0 -.75.75v14.4a.75.75 0 0 0 .75.75h14.4a.75.75 0 0 0 .75-.75v-14.4a.75.75 0 0 0 -.75-.75zm-1.253 5.1707a.685.685 0 0 1 -.1908.48c-.0089.01-.012.0229-.0216.0325l-1.772 1.7729a.7251.7251 0 0 1 -1.0254-1.0254l.5348-.5348h-.63-.05a3.2657 3.2657 0 0 0 -2.5081 1.1141.7032.7032 0 0 1 -.9568.1147 6.1626 6.1626 0 0 1 .2532.5621 3.2918 3.2918 0 0 0 3.2534 2.3179l.0049.0008.0039-.0008h.629l-.5343-.5347a.7251.7251 0 1 1 1.0254-1.0254l1.7725 1.7725a.7277.7277 0 0 1 0 1.0254l-1.7725 1.7725a.7251.7251 0 1 1 -1.0254-1.025l.535-.535h-.6781a4.6892 4.6892 0 0 1 -3.9858-2.12.7159.7159 0 0 1 -.1656.4811 4.71 4.71 0 0 1 -3.6274 1.6387 3.6929 3.6929 0 0 1 -.5386-.0342.725.725 0 0 1 .2233-1.4333 3.3007 3.3007 0 0 0 2.8393-1.1123.7155.7155 0 0 1 .9221-.1371c-.0814-.1648-.1594-.3389-.2314-.524a3.2986 3.2986 0 0 0 -3.5257-2.3018.7248.7248 0 1 1 -.2275-1.4321 4.7114 4.7114 0 0 1 4.5351 2.1082.7222.7222 0 0 1 .1733-.5247 4.7475 4.7475 0 0 1 3.6548-1.6173h.0013.63l-.5345-.5345a.7251.7251 0 0 1 1.0254-1.0254l1.7709 1.7709a.7174.7174 0 0 1 .2113.5008l.0026.0129z"})))};Qr.displayName="IconShuffleBoxFilled",Qr.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Qr.defaultProps={title:"ShuffleBoxFilled",color:null,size:null},Qr.__docgenInfo={description:"",methods:[],displayName:"IconShuffleBoxFilled",props:{title:{defaultValue:{value:"'ShuffleBoxFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $r=Qr,en=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.3677 6.24h-4.7531a3.5191 3.5191 0 0 0 -6.1369.0082c-.0143-.0006-.0263-.0082-.0407-.0082h-1.8047a1.5717 1.5717 0 0 0 -1.57 1.57v.3789a1.5717 1.5717 0 0 0 1.57 1.57h1.7813c.0219 0 .04-.0106.0618-.0125a3.5191 3.5191 0 0 0 6.1392.0136h4.7531a1.5717 1.5717 0 0 0 1.57-1.57v-.3794a1.5716 1.5716 0 0 0 -1.57-1.5706zm-12.8057 2.02v-.52h1.4609c-.0065.0873-.0263.1708-.0263.26s.02.1724.0263.26zm4.9863 1.792a2.0518 2.0518 0 1 1 2.0517-2.052 2.0547 2.0547 0 0 1 -2.0516 2.0518zm7.89-1.792h-4.3645c.0062-.0876.0262-.1711.0262-.26s-.02-.1724-.0263-.26h4.3643z"})))};en.displayName="IconSlider",en.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},en.defaultProps={title:"Slider",color:null,size:null},en.__docgenInfo={description:"",methods:[],displayName:"IconSlider",props:{title:{defaultValue:{value:"'Slider'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tn=en,an=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M14.417 10.2363H9.6162a.75.75 0 0 1 0-1.5h4.8008a.75.75 0 1 1 0 1.5zM12.1128 15.8057a.75.75 0 0 1-.75-.75V11.791a.75.75 0 0 1 1.5 0v3.2647a.75.75 0 0 1-.75.75z"}),u.a.createElement("path",{d:"M12.1128 10.2363a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v8.6421a.75.75 0 0 1-.75.75zM6.7354 6.3955H2.1265a.75.75 0 0 1 0-1.5h4.6089a.75.75 0 0 1 0 1.5zM4.4307 15.8057a.75.75 0 0 1-.75-.75V7.95a.75.75 0 0 1 1.5 0v7.1055a.75.75 0 0 1-.75.7502z"}),u.a.createElement("path",{d:"M4.4307 6.3955a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v4.8013a.75.75 0 0 1-.75.75z"})))};an.displayName="IconSlidersVert",an.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},an.defaultProps={title:"Options",color:null,size:null},an.__docgenInfo={description:"",methods:[],displayName:"IconSlidersVert",props:{title:{defaultValue:{value:"'Options'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ln=an,rn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.874 6.13a.75.75 0 0 0 -.7134-.519h-4.84l-1.615-4.5138a.75.75 0 0 0 -1.4121 0l-1.615 4.5141h-4.8391a.75.75 0 0 0 -.4394 1.3574l3.807 2.7547-1.6723 4.6745a.75.75 0 0 0 1.1162.88l4.3491-2.8394 4.3491 2.84a.75.75 0 0 0 1.1162-.88l-1.6726-4.6745 3.8073-2.7553a.7494.7494 0 0 0 .274-.8387zm-5.4165 2.709c-.0118.0085-.0173.0218-.0285.0309a.7183.7183 0 0 0 -.1079.1168.6315.6315 0 0 0 -.1589.5143.7215.7215 0 0 0 .0226.1552c.0042.014.0012.0283.0062.0422l1.11 3.1045-2.891-1.8879a.7488.7488 0 0 0 -.82 0l-2.8918 1.8877 1.11-3.104c.0049-.0137.0019-.0276.006-.0414a.7184.7184 0 0 0 .0233-.16.7392.7392 0 0 0 .0043-.1291.6374.6374 0 0 0 -.1675-.386.7192.7192 0 0 0 -.1021-.11c-.0118-.01-.0176-.0236-.03-.0327l-2.3869-1.7282h3.0512a.7419.7419 0 0 0 .2626-.053.7252.7252 0 0 0 .0748-.0366.6923.6923 0 0 0 .3192-.3174.7081.7081 0 0 0 .0383-.07c.0029-.0074.0085-.0129.0112-.02l1.0874-3.0386 1.0859 3.0356c.0026.0071.0085.0117.0113.0187a.73.73 0 0 0 .0952.1574.7558.7558 0 0 0 .0585.0867.6491.6491 0 0 0 .4216.2129.7214.7214 0 0 0 .0906.0183c.0105 0 .0193.006.03.006h3.0518z"})))};rn.displayName="IconStar",rn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},rn.defaultProps={title:"Star",color:null,size:null},rn.__docgenInfo={description:"",methods:[],displayName:"IconStar",props:{title:{defaultValue:{value:"'Star'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nn=rn,on=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.874 6.13a.7507.7507 0 0 0 -.7139-.5191h-4.8388l-1.6152-4.5137a.75.75 0 0 0 -1.4121 0l-1.6163 4.5141h-4.8377a.75.75 0 0 0 -.44 1.3575l3.807 2.7548-1.6728 4.6739a.75.75 0 0 0 1.1162.8809l4.3496-2.8399 4.3486 2.84a.75.75 0 0 0 1.1162-.8809l-1.6728-4.6735 3.808-2.7554a.75.75 0 0 0 .274-.8387z"})))};on.displayName="IconStarFilled",on.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},on.defaultProps={title:"StarFilled",color:null,size:null},on.__docgenInfo={description:"",methods:[],displayName:"IconStarFilled",props:{title:{defaultValue:{value:"'StarFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var un=on,cn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M1.6678 16.0038a1.6437 1.6437 0 0 1-1.096-.4313A1.7177 1.7177 0 0 1 0 14.3057V1.6943A1.6963 1.6963 0 0 1 1.6943 0h12.6114A1.6963 1.6963 0 0 1 16 1.6943v12.6114A1.6963 1.6963 0 0 1 14.3057 16H1.779c-.0369.0027-.0743.0038-.1112.0038zm.0265-14.6149a.302.302 0 0 0-.3054.3054v12.6114a.3361.3361 0 0 0 .115.237.2452.2452 0 0 0 .1769.0717l.0689-.0033h12.556a.302.302 0 0 0 .3054-.3054V1.6943a.302.302 0 0 0-.3054-.3054z"}),u.a.createElement("path",{d:"M3.7224.6668h1.3889v14.6664H3.7224z"}),u.a.createElement("path",{d:"M.23679062 12.69208759l.7378489-1.17619835 4.00974785 2.5153819-.7378489 1.17619835zM.23653838 9.1358777l.73833393-1.17674962 4.01045281 2.51629857-.73833392 1.17674961zM.23652695 5.58003623l.73833392-1.17674961L4.9853137 6.91958518l-.73833392 1.17674961zM.23652376 2.02481365L.97485768.84806404 4.9853105 3.3643626 4.24697658 4.5411122z"})))};cn.displayName="IconTableCol",cn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},cn.defaultProps={title:"TableCol",color:null,size:null},cn.__docgenInfo={description:"",methods:[],displayName:"IconTableCol",props:{title:{defaultValue:{value:"'TableCol'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var sn=cn,dn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M14.3061 15.9959H1.6983A1.6959 1.6959 0 0 1 .0041 14.302V1.7785A1.63 1.63 0 0 1 .4312.5722 1.7188 1.7188 0 0 1 1.6983 0h12.6078A1.6958 1.6958 0 0 1 16 1.6939V14.302a1.6958 1.6958 0 0 1-1.6939 1.6939zM1.6983 1.3885a.3369.3369 0 0 0-.2373.1156.2475.2475 0 0 0-.0719.1763l.0035.0688V14.302a.3022.3022 0 0 0 .3057.3054h12.6078a.302.302 0 0 0 .3054-.3054V1.6939a.302.302 0 0 0-.3054-.3054z"}),u.a.createElement("path",{d:"M.6707 3.7214h14.6627v1.3885H.6707z"}),u.a.createElement("path",{d:"M.79621001 4.24571892L3.31230328.2367901l1.17622688.73822626L1.9724369 4.98394518zM4.35097781 4.24562379L6.86701792.23677967 8.0432448.97500593 5.5272047 4.98385005zM7.9056546 4.2456449L10.42180101.23663138 11.5981126.9749108 9.08196617 4.98392432zM11.46010098 4.24587677l2.51578674-4.0093573 1.1764723.73821144-2.51578674 4.0093573z"})))};dn.displayName="IconTableRow",dn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},dn.defaultProps={title:"TableRow",color:null,size:null},dn.__docgenInfo={description:"",methods:[],displayName:"IconTableRow",props:{title:{defaultValue:{value:"'TableRow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var pn=dn,mn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.1072.1226h-10.2144a1.7021 1.7021 0 0 0 -1.7 1.7v12.3546a1.7021 1.7021 0 0 0 1.7 1.7h10.2144a1.7021 1.7021 0 0 0 1.7-1.7v-12.3544a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.2144 1.4h10.2144a.3.3 0 0 1 .3.3v.9074h-10.8142v-.9072a.3.3 0 0 1 .2998-.2999zm10.5142 2.6074v6.6455h-10.814v-6.6455zm-.3 10.3467h-10.2142a.3.3 0 0 1 -.3-.3v-2.001h10.8142v2.001a.3.3 0 0 1 -.2998.3004z"}),u.a.createElement("path",{d:"m8.886 12.6216h-1.7715a.7.7 0 1 0 0 1.4h1.7715a.7.7 0 1 0 0-1.4z"})))};mn.displayName="IconTablet",mn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},mn.defaultProps={title:"Tablet",color:null,size:null},mn.__docgenInfo={description:"",methods:[],displayName:"IconTablet",props:{title:{defaultValue:{value:"'Tablet'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var gn=mn,zn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.9468 8.5571 1.665 1.665a.75.75 0 0 0 1.0605 0l3.3809-3.3809a.75.75 0 1 0 -1.0605-1.0604l-2.8506 2.8505-1.1348-1.1347a.75.75 0 0 0 -1.0605 1.0605z"}),u.a.createElement("path",{d:"m13.1772.0405h-10.3544a1.7021 1.7021 0 0 0 -1.7 1.7v12.5188a1.7021 1.7021 0 0 0 1.7 1.7h10.3544a1.7021 1.7021 0 0 0 1.7-1.7v-12.5186a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.3545 1.4h10.3545a.3.3 0 0 1 .3.3v1.0666h-10.9543v-1.0664a.3.3 0 0 1 .2999-.2998zm10.6544 2.767v7.5859h-10.9542v-7.5859zm-.3 10.3516h-10.3543a.3.3 0 0 1 -.3-.3v-1.0653h10.9543v1.0654a.3.3 0 0 1 -.2999.2999z"})))};zn.displayName="IconTabletCheck",zn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},zn.defaultProps={title:"TabletCheck",color:null,size:null},zn.__docgenInfo={description:"",methods:[],displayName:"IconTabletCheck",props:{title:{defaultValue:{value:"'TabletCheck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var vn=zn,hn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7124.2871a.75.75 0 0 0 -1.0605 0l-1.4839 1.4839-.708-.7075a.7515.7515 0 0 0 -.51-.22l-4.1546-.116a.8061.8061 0 0 0 -.5508.22l-6.957 6.9558a.75.75 0 0 0 0 1.0606l6.7481 6.749a.75.75 0 0 0 1.0605 0l6.957-6.957a.75.75 0 0 0 .22-.5508l-.1165-4.1551a.7515.7515 0 0 0 -.22-.51l-.7085-.7085 1.4839-1.4839a.75.75 0 0 0 .0003-1.0605zm-2.0469 4.1029.0986 3.5342-6.1982 6.1979-5.6875-5.6885 6.1983-6.1973 3.5342.0986.4966.4966-.7216.7216a2.2343 2.2343 0 1 0 1.061 1.06l.7211-.7211zm-2.7109.6563a.7368.7368 0 1 1 -.52-.2139.7338.7338 0 0 1 .52.2135z"})))};hn.displayName="IconTag",hn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},hn.defaultProps={title:"Tag",color:null,size:null},hn.__docgenInfo={description:"",methods:[],displayName:"IconTag",props:{title:{defaultValue:{value:"'Tag'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var fn=hn,yn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1563 5.126h-14.3125a.75.75 0 0 0 -.75.75v4.248a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.248a.75.75 0 0 0 -.75-.75zm-.75 4.248h-12.8125v-2.748h12.8125z"})))};yn.displayName="IconTextbox",yn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},yn.defaultProps={title:"Textbox",color:null,size:null},yn.__docgenInfo={description:"",methods:[],displayName:"IconTextbox",props:{title:{defaultValue:{value:"'Textbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var In=yn,En=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1563 1.5332h-14.3125a.75.75 0 0 0 -.75.75v4.2468a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2468a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z"}),u.a.createElement("path",{d:"m15.1563 8.72h-14.3125a.75.75 0 0 0 -.75.75v4.2471a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2471a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z"})))};En.displayName="IconTextboxMultiple",En.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},En.defaultProps={title:"TextboxMultiple",color:null,size:null},En.__docgenInfo={description:"",methods:[],displayName:"IconTextboxMultiple",props:{title:{defaultValue:{value:"'TextboxMultiple'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Vn=En,qn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.23 8.3875a1.7682 1.7682 0 0 0 -1.107-3.1537h-.0225l-.0048-.001h-3.5552a7.5592 7.5592 0 0 0 .2266-1.3672c.0469-1.1729-.5-2.4668-1.813-2.5371-1.3672-.084-1.6941 1.2822-1.8641 2.0115a3.09 3.09 0 0 1 -.2236.7266 5.5528 5.5528 0 0 1 -1.83 1.5458.6877.6877 0 0 0 -.5431-.2762h-3.6925a.7.7 0 0 0 -.7.7v7.7338a.7.7 0 0 0 .7.7h3.6929a.6881.6881 0 0 0 .5384-.2694 4.5665 4.5665 0 0 0 1.8219.4744h5.876a1.6406 1.6406 0 0 0 1.6108-1.665 1.6938 1.6938 0 0 0 -.0772-.4832 1.6591 1.6591 0 0 0 .64-2.2564 1.6595 1.6595 0 0 0 .3267-1.883zm-11.4365 4.6825h-2.2925v-6.3333h2.2925zm8.9365.2051h-5.8579c-.0134 0-1.3372-.0631-1.6782-.7835v-5.3543a7.8387 7.8387 0 0 0 2.8554-2.3215 3.754 3.754 0 0 0 .4043-1.1572c.189-.8086.2876-.919.4258-.9316.4014.0215.5029.7383.49 1.0723a6.3983 6.3983 0 0 1 -.4429 1.8623.7005.7005 0 0 0 .645.9717h2.4781l.0048.001h2.0689a.3755.3755 0 1 1 0 .751h-2.0691a.7.7 0 0 0 0 1.4h1.5967a.3081.3081 0 1 1 0 .6133h-1.9966a.7.7 0 1 0 0 1.4h.45l.0048.001h1.36a.2736.2736 0 0 1 0 .5439h-1.8148a.7.7 0 1 0 0 1.4h1.0757a.2722.2722 0 0 1 0 .53z"})))};qn.displayName="IconThumbsUp",qn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},qn.defaultProps={title:"ThumbsUp",color:null,size:null},qn.__docgenInfo={description:"",methods:[],displayName:"IconThumbsUp",props:{title:{defaultValue:{value:"'ThumbsUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var bn=qn,Nn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m3.1267 5.8447h-2.288a.7.7 0 0 0 -.7.7v7.2253a.7.7 0 0 0 .7.7h2.288a.7.7 0 0 0 .7-.7v-7.2251a.7.7 0 0 0 -.7-.7002z"}),u.a.createElement("path",{d:"m15.8615 6.8935a1.2052 1.2052 0 0 0 -1.2015-1.2017v-.0006h-5.0846a7.8507 7.8507 0 0 0 .5546-2.3419c.0334-.8345-.2845-1.9677-1.2861-2.0212-1.3154-.07-1.1233 1.8988-1.6292 2.6971a6.95 6.95 0 0 1 -2.3737 2.0164v8.17a4.3175 4.3175 0 0 0 1.6992.4622h6.5631a1.08 1.08 0 0 0 0-2.1565l.8259-.0006a1.0864 1.0864 0 0 0 0-2.1719l.2027-.0006a1.125 1.125 0 1 0 0-2.249h.528a1.2052 1.2052 0 0 0 1.2016-1.2017z"})))};Nn.displayName="IconThumbsUpFilled",Nn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Nn.defaultProps={title:"ThumbsUpFilled",color:null,size:null},Nn.__docgenInfo={description:"",methods:[],displayName:"IconThumbsUpFilled",props:{title:{defaultValue:{value:"'ThumbsUpFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var _n=Nn,wn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.5977 2.1677v-.5823h1.1406a.75.75 0 1 0 0-1.5h-3.7813a.75.75 0 0 0 0 1.5h1.1407v.5846a6.9273 6.9273 0 0 0 -4.8177 2.7817 6.8959 6.8959 0 1 0 6.3177-2.784zm-.75 12.2468a5.3948 5.3948 0 1 1 5.3945-5.3945 5.401 5.401 0 0 1 -5.3945 5.3945z"}),u.a.createElement("path",{d:"m10.0957 5.9941-1.5051 1.4938a1.9617 1.9617 0 1 0 1.0411 1.08l1.5206-1.5092a.75.75 0 1 0 -1.0566-1.0644zm-2.248 3.7715a.52.52 0 0 1 0-1.04.5184.5184 0 0 1 .52.52.5206.5206 0 0 1 -.52.52z"}),u.a.createElement("path",{d:"m14.8272 3.3818-1.0372-1.0371a.75.75 0 0 0 -1.0605 1.0605l1.0371 1.0371a.75.75 0 0 0 1.0605-1.0605z"})))};wn.displayName="IconTimer",wn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},wn.defaultProps={title:"Timer",color:null,size:null},wn.__docgenInfo={description:"",methods:[],displayName:"IconTimer",props:{title:{defaultValue:{value:"'Timer'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var xn=wn,Tn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.1719 3.3008h-6.3438a4.6992 4.6992 0 0 0 0 9.3984h6.3438a4.6992 4.6992 0 0 0 0-9.3984zm-9.543 4.6992a3.203 3.203 0 0 1 3.1992-3.1992h2.9219a4.6454 4.6454 0 0 0 0 6.3984h-2.9219a3.203 3.203 0 0 1 -3.1992-3.1992z"})))};Tn.displayName="IconToggle",Tn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Tn.defaultProps={title:"Toggle",color:null,size:null},Tn.__docgenInfo={description:"",methods:[],displayName:"IconToggle",props:{title:{defaultValue:{value:"'Toggle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pn=Tn,Bn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1941 3.4219h-4.1436v-2.4483a.75.75 0 0 0 -.75-.75h-4.601a.75.75 0 0 0 -.75.75v2.4483h-4.1436a.75.75 0 0 0 -.75.75v10.8545a.75.75 0 0 0 .75.75h14.3882a.75.75 0 0 0 .75-.75v-10.8545a.75.75 0 0 0 -.75-.75zm-8.7446-1.6983h3.101v1.6983h-3.101zm7.9946 3.1982v3.3468h-12.8882v-3.3467zm-12.8882 9.3546v-4.5078h2.5527v.86a.75.75 0 0 0 1.5 0v-.86h4.7827v.86a.75.75 0 0 0 1.5 0v-.86h2.5527v4.5078z"})))};Bn.displayName="IconToolbox",Bn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Bn.defaultProps={title:"Toolbox",color:null,size:null},Bn.__docgenInfo={description:"",methods:[],displayName:"IconToolbox",props:{title:{defaultValue:{value:"'Toolbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var On=Bn,Cn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0019 2.9858h-3.9575v-1.1093a1.82 1.82 0 0 0 -1.8178-1.8179h-2.4532a1.82 1.82 0 0 0 -1.8178 1.8179v1.1093h-3.9576a.75.75 0 0 0 0 1.5h1.0365l.2917 9.6548a1.7922 1.7922 0 0 0 1.7529 1.8008h7.7524a1.793 1.793 0 0 0 1.7525-1.7814l.38-9.6738h1.038a.75.75 0 1 0 0-1.5zm-8.5463-1.1093a.3182.3182 0 0 1 .3179-.3179h2.4531a.3182.3182 0 0 1 .3179.3179v1.1093h-3.0889zm5.6294 12.2285a.3163.3163 0 0 1 -.2534.3364h-7.7525c-.1182 0-.2485-.1367-.2539-.3428l-.29-9.6128h8.9276z"}),u.a.createElement("path",{d:"m6.3779 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 0 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m9.6221 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 1 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z"})))};Cn.displayName="IconTrash",Cn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Cn.defaultProps={title:"Trash",color:null,size:null},Cn.__docgenInfo={description:"",methods:[],displayName:"IconTrash",props:{title:{defaultValue:{value:"'Trash'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var jn=Cn,Ln=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.59 1.2607h-6.2077a1.3186 1.3186 0 0 0 -1.3173 1.3169v.0664h-2.7364a1.9174 1.9174 0 0 0 -1.627.895l-2.2255 3.5152a2.4663 2.4663 0 0 0 -.2081.4622.67.67 0 0 0 -.0466.1036 2.4634 2.4634 0 0 0 -.1292.7593v3.4736a1.3963 1.3963 0 0 0 1.3945 1.3945h1.1785a2.17 2.17 0 0 0 4.0994 0h2.593a2.1692 2.1692 0 0 0 4.1217 0h1.1107a1.3186 1.3186 0 0 0 1.3177-1.3174v-9.3524a1.3185 1.3185 0 0 0 -1.3177-1.3169zm-10.7057 3.0274a.5248.5248 0 0 1 .4443-.2436l2.7364-.0009v3.0995h-4.9878zm.83 9.0166a.783.783 0 1 1 .7832-.7832.7832.7832 0 0 1 -.7831.7832zm6.7041.0342a.783.783 0 1 1 .7769-.8139c0 .0077-.0045.0142-.0045.0219 0 .0111.0058.02.0063.0312a.7814.7814 0 0 1 -.7786.7608zm3.0889-1.4922h-1.0337a2.17 2.17 0 0 0 -4.11 0h-2.5836a2.1683 2.1683 0 0 0 -4.1315.002l-1.1561.0039v-3.3091h6.2727a.7.7 0 0 0 .7-.7v-5.1824h6.042z"})))};Ln.displayName="IconTruck",Ln.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Ln.defaultProps={title:"Truck",color:null,size:null},Ln.__docgenInfo={description:"",methods:[],displayName:"IconTruck",props:{title:{defaultValue:{value:"'Truck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var An=Ln,Sn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.3184.2507a3.7 3.7 0 0 0 -3.6514 3.4014v2.7437h-7.8711a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4541a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75h-2.083v-2.7437a2.1594 2.1594 0 0 1 4.2871-.0068v3.5a.75.75 0 0 0 1.5 0v-3.5a3.6882 3.6882 0 0 0 -3.6357-3.3946zm-.8184 13.9986h-9.9541v-6.3535h9.9541z"}),u.a.createElement("path",{d:"m6.5234 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};Sn.displayName="IconUnlock",Sn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Sn.defaultProps={title:"Unlock",color:null,size:null},Sn.__docgenInfo={description:"",methods:[],displayName:"IconUnlock",props:{title:{defaultValue:{value:"'Unlock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var kn=Sn,Dn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 9.0117a3.3467 3.3467 0 0 0 2.8086-1.7031 5.789 5.789 0 0 0 .53-5.1592 3.6049 3.6049 0 0 0 -3.3386-2.0937 3.605 3.605 0 0 0 -3.3389 2.0937 5.789 5.789 0 0 0 .53 5.1592 3.3468 3.3468 0 0 0 2.8089 1.7031zm-1.9736-6.2412a2.0942 2.0942 0 0 1 1.9736-1.2148 2.0942 2.0942 0 0 1 1.9736 1.2148 4.3225 4.3225 0 0 1 -.4268 3.7256 1.9264 1.9264 0 0 1 -1.5468 1.0156 1.9265 1.9265 0 0 1 -1.5469-1.0156 4.3225 4.3225 0 0 1 -.4267-3.7256z"}),u.a.createElement("path",{d:"m13.1025 10.1055a7.1174 7.1174 0 0 1 -2.3135-1.1514.7514.7514 0 0 0 -1.0723.1621l-1.7167 2.4424-1.7168-2.4424a.7514.7514 0 0 0 -1.0723-.1621 7.1174 7.1174 0 0 1 -2.3135 1.1514c-1.7734.5938-2.86 1.1572-2.86 5.0889a.75.75 0 0 0 .75.75h14.4255a.75.75 0 0 0 .75-.75c0-3.9317-1.0869-4.4952-2.8604-5.0889zm-11.5525 4.3388c.0889-2.3359.6406-2.5205 1.8232-2.916a9.2307 9.2307 0 0 0 2.1121-.9383l1.9014 2.7041a.7787.7787 0 0 0 1.2266 0l1.9013-2.7041a9.2314 9.2314 0 0 0 2.1123.9385c1.1826.3955 1.7344.58 1.8232 2.916z"})))};Dn.displayName="IconUser",Dn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Dn.defaultProps={title:"User",color:null,size:null},Dn.__docgenInfo={description:"",methods:[],displayName:"IconUser",props:{title:{defaultValue:{value:"'User'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Fn=Dn,Mn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.0767 9.6787a5.8791 5.8791 0 0 1 -1.9023-.9453.6995.6995 0 0 0 -1.1192.4466 1.6175 1.6175 0 0 1 -1.2021.4766 1.8506 1.8506 0 0 1 -1.2931-.496.7.7 0 0 0 -1.1162-.4272 5.8792 5.8792 0 0 1 -1.9024.9453c-1.5114.5059-2.4306 1.0479-2.4306 4.3032a.7.7 0 0 0 .7.7h11.9963a.7.7 0 0 0 .7-.7c.0002-3.2553-.9187-3.7973-2.4304-4.3032zm-9.5527 3.603c.0781-1.8125.5-1.9536 1.4619-2.2754a7.8626 7.8626 0 0 0 1.6973-.7417 3.3275 3.3275 0 0 0 2.17.7925 3.161 3.161 0 0 0 2.0918-.7866 7.9062 7.9062 0 0 0 1.6875.7358c.9619.3218 1.3838.4629 1.4619 2.2754z"}),u.a.createElement("path",{d:"m6.8091 8.918a2.8562 2.8562 0 0 0 2.3994-1.4512 4.8954 4.8954 0 0 0 .4463-4.3643 3.0732 3.0732 0 0 0 -2.8457-1.7846 3.0694 3.0694 0 0 0 -2.8447 1.7851 4.8923 4.8923 0 0 0 .4456 4.3628 2.8552 2.8552 0 0 0 2.3991 1.4522zm-1.57-5.2353a1.6638 1.6638 0 0 1 1.57-.9644 1.668 1.668 0 0 1 1.5723.9648 3.5125 3.5125 0 0 1 -.35 3.0259 1.5321 1.5321 0 0 1 -1.2227.8086 1.5326 1.5326 0 0 1 -1.2227-.8091 3.5115 3.5115 0 0 1 -.3472-3.0259z"}),u.a.createElement("path",{d:"m15.8387 4.7439a.651.651 0 0 0 -.14-.7094l-2.4765-2.4759a.65.65 0 1 0 -.92.919l1.3678 1.3666h-2.314a.65.65 0 1 0 0 1.3h2.314l-1.3678 1.367a.65.65 0 0 0 .92.919l2.4764-2.4764a.65.65 0 0 0 .1401-.2099z"})))};Mn.displayName="IconUserArrow",Mn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Mn.defaultProps={title:"UserArrow",color:null,size:null},Mn.__docgenInfo={description:"",methods:[],displayName:"IconUserArrow",props:{title:{defaultValue:{value:"'UserArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Un=Mn,Hn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.1924 2.1516a3.4447 3.4447 0 0 0 -3.1924-1.9995 3.4447 3.4447 0 0 0 -3.1924 2 5.602 5.602 0 0 0 .5161 4.99 3.1937 3.1937 0 0 0 2.6763 1.6291 3.1946 3.1946 0 0 0 2.6768-1.63 5.6 5.6 0 0 0 .5156-4.9896z"}),u.a.createElement("path",{d:"m13.1748 10.5749a7.76 7.76 0 0 1 -2.5254-1.2607.3711.3711 0 0 0 -.5308.0806l-2.1186 3.0127-2.1182-3.0127a.3711.3711 0 0 0 -.5308-.0806 7.76 7.76 0 0 1 -2.5254 1.2607c-1.7211.5757-2.6947 1.087-2.6947 4.9019a.3709.3709 0 0 0 .3711.3711h14.996a.3709.3709 0 0 0 .3711-.3711c0-3.8149-.9736-4.3262-2.6943-4.9019z"})))};Hn.displayName="IconUserFilled",Hn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Hn.defaultProps={title:"UserFilled",color:null,size:null},Hn.__docgenInfo={description:"",methods:[],displayName:"IconUserFilled",props:{title:{defaultValue:{value:"'UserFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Gn=Hn,Rn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.0769 9.6787a5.8726 5.8726 0 0 1 -1.9019-.9453.7.7 0 0 0 -1.12.4468 1.6166 1.6166 0 0 1 -1.2021.4766 1.8521 1.8521 0 0 1 -1.292-.4956.7.7 0 0 0 -1.1167-.4277 5.8727 5.8727 0 0 1 -1.9019.9453c-1.5123.5058-2.4307 1.0478-2.4307 4.3031a.7.7 0 0 0 .7.7h11.9958a.7.7 0 0 0 .7-.7c.0002-3.2553-.9183-3.7973-2.4305-4.3032zm-9.5518 3.603c.0771-1.8125.5-1.9536 1.4614-2.2754a7.8833 7.8833 0 0 0 1.6973-.7417 3.3238 3.3238 0 0 0 2.169.7925 3.1591 3.1591 0 0 0 2.0918-.7866 7.9087 7.9087 0 0 0 1.688.7358c.9619.3218 1.3843.4629 1.4614 2.2754z"}),u.a.createElement("path",{d:"m6.8093 8.918a2.859 2.859 0 0 0 2.4-1.4521 4.897 4.897 0 0 0 .4457-4.3629 3.0723 3.0723 0 0 0 -2.8457-1.7851 3.0733 3.0733 0 0 0 -2.8457 1.7851 4.8983 4.8983 0 0 0 .4458 4.3633 2.8577 2.8577 0 0 0 2.3999 1.4517zm-1.5718-5.2344a1.6679 1.6679 0 0 1 1.5718-.9653 1.6654 1.6654 0 0 1 1.5713.9648 3.5112 3.5112 0 0 1 -.3481 3.0249 1.5328 1.5328 0 0 1 -1.2232.81 1.5318 1.5318 0 0 1 -1.2222-.8091 3.51 3.51 0 0 1 -.3496-3.0253z"}),u.a.createElement("path",{d:"m15.2385 3.31h-1.2915v-1.2919a.65.65 0 0 0 -1.3 0v1.2919h-1.291a.65.65 0 1 0 0 1.3h1.291v1.2909a.65.65 0 0 0 1.3 0v-1.2915h1.2915a.65.65 0 1 0 0-1.3z"})))};Rn.displayName="IconUserPlus",Rn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Rn.defaultProps={title:"UserPlus",color:null,size:null},Rn.__docgenInfo={description:"",methods:[],displayName:"IconUserPlus",props:{title:{defaultValue:{value:"'UserPlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wn=Rn,Xn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.3755 11.1333-.9423-.9483a.4476.4476 0 0 0 -.5813-.0726c-1.6744 1.0883-2.7756.16-2.7756 3.3421h4.2764a7.1494 7.1494 0 0 1 .2781-2.2245c-.0054 0-.0081.0039-.0135.0039a.3763.3763 0 0 1 -.2418-.1006z"}),u.a.createElement("path",{d:"m12.6417 9.503a.529.529 0 0 0 -.6873.0859l-1.1139 1.1211a.4027.4027 0 0 1 -.5718 0l-1.1141-1.1211a.5291.5291 0 0 0 -.6873-.0859c-1.98 1.2867-3.2817.1893-3.2817 3.9515h10.738c0-3.7623-1.3018-2.6645-3.2819-3.9515z"}),u.a.createElement("path",{d:"m4.6172 9.3914c1.6375 0 2.497-2.5742 1.8393-4.0182a1.9705 1.9705 0 0 0 -1.8393-1.1452 1.9705 1.9705 0 0 0 -1.8392 1.1453c-.658 1.444.202 4.0181 1.8392 4.0181z"}),u.a.createElement("path",{d:"m10.5546 8.65c1.9361 0 2.9523-3.0435 2.1747-4.7509a2.33 2.33 0 0 0 -2.1747-1.3541 2.33 2.33 0 0 0 -2.1746 1.355c-.7776 1.707.2385 4.75 2.1746 4.75z"})))};Xn.displayName="IconUsers",Xn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Xn.defaultProps={title:"Users",color:null,size:null},Xn.__docgenInfo={description:"",methods:[],displayName:"IconUsers",props:{title:{defaultValue:{value:"'Users'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Yn=Xn,Kn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.4665 9.1189c-1.2526 0-1.91-1.9691-1.407-3.0737a1.5678 1.5678 0 0 1 2.8139 0c.5031 1.1048-.1544 3.0737-1.4069 3.0737z"}),u.a.createElement("path",{d:"m12.66 12.1179h3.28c0-2.434-.8423-1.724-2.1234-2.5565a.3423.3423 0 0 0 -.4446.0556l-.7206.7254a.288.288 0 0 1 -.185.0771c-.0065 0-.01-.0041-.0159-.0046a5.41 5.41 0 0 1 .2095 1.703z"}),u.a.createElement("path",{d:"m3.5334 9.1189c-1.2526 0-1.91-1.9691-1.4069-3.0737a1.5074 1.5074 0 0 1 1.4069-.876 1.5074 1.5074 0 0 1 1.4069.876c.5031 1.1048-.1543 3.0737-1.4069 3.0737z"}),u.a.createElement("path",{d:"m3.5585 10.4121c-.01.0013-.015.0073-.0252.0073a.2879.2879 0 0 1 -.1849-.0771c-.2343-.2357-.7208-.7254-.7208-.7254a.3423.3423 0 0 0 -.4447-.0556c-1.2807.8325-2.1229.1225-2.1229 2.5566h3.2918a5.4688 5.4688 0 0 1 .2067-1.7058z"}),u.a.createElement("path",{d:"m9.6029 9.0951a.4048.4048 0 0 0 -.5258.0658l-.8521.8576a.308.308 0 0 1 -.4374 0l-.8522-.8576a.4048.4048 0 0 0 -.5254-.0658c-1.5144.9843-2.51.1448-2.51 3.0227h8.214c-.0006-2.8778-.9965-2.0384-2.5111-3.0227z"}),u.a.createElement("path",{d:"m8.0064 8.5521c-1.481 0-2.2583-2.3281-1.6635-3.6342a1.7823 1.7823 0 0 1 1.6635-1.0358 1.7823 1.7823 0 0 1 1.6636 1.0358c.5947 1.3061-.1826 3.6342-1.6636 3.6342z"})))};Kn.displayName="IconUsersGroup",Kn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Kn.defaultProps={title:"UsersGroup",color:null,size:null},Kn.__docgenInfo={description:"",methods:[],displayName:"IconUsersGroup",props:{title:{defaultValue:{value:"'UsersGroup'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Zn=Kn,Jn=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.8438 2.125a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5h-3.0625v-11.75z"}),u.a.createElement("path",{d:"m13.9688.625h-3.8125a.75.75 0 0 0 0 1.5h3.0625v11.75h-3.0625a.75.75 0 0 0 0 1.5h3.8125a.75.75 0 0 0 .75-.75v-13.25a.75.75 0 0 0 -.75-.75z"})))};Jn.displayName="IconVariable",Jn.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},Jn.defaultProps={title:"Variable",color:null,size:null},Jn.__docgenInfo={description:"",methods:[],displayName:"IconVariable",props:{title:{defaultValue:{value:"'Variable'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Qn=Jn,$n=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.4724 3.0515a.75.75 0 0 0 -.7685.0342l-4.0093 2.6443v-2.0589a.75.75 0 0 0 -.75-.75h-9.0615a.75.75 0 0 0 -.75.75v8.6577a.75.75 0 0 0 .75.75h9.0615a.75.75 0 0 0 .75-.75v-2.0588l4.0092 2.6447a.75.75 0 0 0 1.1631-.626v-8.577a.7489.7489 0 0 0 -.3945-.6602zm-6.2778 8.5274h-7.5615v-7.1578h7.5615zm5.1723-.6836-3.6631-2.4165v-.9576l3.6631-2.4165z"})))};$n.displayName="IconVideo",$n.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},$n.defaultProps={title:"Video",color:null,size:null},$n.__docgenInfo={description:"",methods:[],displayName:"IconVideo",props:{title:{defaultValue:{value:"'Video'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ei=$n,ti=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.165.1309a.75.75 0 0 0 -.75.75v5.82l-11.205-6.4695a.75.75 0 0 0 -1.125.6495v14.2382a.75.75 0 0 0 1.125.6494l11.2051-6.47v5.82a.75.75 0 0 0 1.5 0v-14.2376a.75.75 0 0 0 -.7501-.75zm-11.58 13.6891v-11.64l10.08 5.82z"})))};ti.displayName="IconVideoEnd",ti.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ti.defaultProps={title:"VideoEnd",color:null,size:null},ti.__docgenInfo={description:"",methods:[],displayName:"IconVideoEnd",props:{title:{defaultValue:{value:"'VideoEnd'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ai=ti,li=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.46 15.7687a.7509.7509 0 0 0 .75 0l12.33-7.1187a.75.75 0 0 0 0-1.2988l-12.33-7.1196a.75.75 0 0 0 -1.125.6494v14.2383a.7487.7487 0 0 0 .375.6494zm1.125-13.5887 10.08 5.82-10.08 5.82z"})))};li.displayName="IconVideoNext",li.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},li.defaultProps={title:"VideoNext",color:null,size:null},li.__docgenInfo={description:"",methods:[],displayName:"IconVideoNext",props:{title:{defaultValue:{value:"'VideoNext'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ri=li,ni=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.54.2313a.7509.7509 0 0 0 -.75 0l-12.33 7.1187a.75.75 0 0 0 0 1.2988l12.33 7.1191a.75.75 0 0 0 1.125-.6494v-14.2378a.7487.7487 0 0 0 -.375-.6494zm-1.125 13.5887-10.08-5.82 10.08-5.82z"})))};ni.displayName="IconVideoPrev",ni.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ni.defaultProps={title:"VideoPrev",color:null,size:null},ni.__docgenInfo={description:"",methods:[],displayName:"IconVideoPrev",props:{title:{defaultValue:{value:"'VideoPrev'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ii=ni,oi=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5405.2314a.7509.7509 0 0 0 -.75 0l-11.206 6.4697v-5.8202a.75.75 0 0 0 -1.5 0v14.2382a.75.75 0 0 0 1.5 0v-5.82l11.206 6.47a.75.75 0 0 0 1.125-.6494v-14.2388a.75.75 0 0 0 -.375-.6495zm-1.125 13.5886-10.081-5.82 10.081-5.82z"})))};oi.displayName="IconVideoStart",oi.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},oi.defaultProps={title:"VideoStart",color:null,size:null},oi.__docgenInfo={description:"",methods:[],displayName:"IconVideoStart",props:{title:{defaultValue:{value:"'VideoStart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ui=oi,ci=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.49.0464h-12.98a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-14.4072a.75.75 0 0 0 -.75-.75zm-.75 14.4072h-11.48v-12.9072h11.48z"})))};ci.displayName="IconVideoStop",ci.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},ci.defaultProps={title:"VideoStop",color:null,size:null},ci.__docgenInfo={description:"",methods:[],displayName:"IconVideoStop",props:{title:{defaultValue:{value:"'VideoStop'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var si=ci,di=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7051 12.9691-6.5513-11.2378a1.3042 1.3042 0 0 0 -2.3076 0l-6.5513 11.2387a1.3386 1.3386 0 0 0 -.0649 1.3638 1.3379 1.3379 0 0 0 1.2109.6313h13.1177a1.2682 1.2682 0 0 0 1.1465-1.9961zm-8.4551-7.5152a.75.75 0 0 1 1.5 0v4.3023a.75.75 0 1 1 -1.5 0zm.75 7.765a.875.875 0 1 1 .875-.875.875.875 0 0 1 -.875.875z"})))};di.displayName="IconWarning",di.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},di.defaultProps={title:"Warning",color:null,size:null},di.__docgenInfo={description:"",methods:[],displayName:"IconWarning",props:{title:{defaultValue:{value:"'Warning'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var pi=di,mi=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5235 9.27c-.0154-.0092-.0323-.0139-.0478-.0228a6.4808 6.4808 0 0 0 -3.1207-5.7864 6.5189 6.5189 0 0 0 -.64-.3136 2.7625 2.7625 0 0 0 -5.5227.0574 6.4851 6.4851 0 0 0 -2.733 2.4686 6.3907 6.3907 0 0 0 -.9023 3.5756 2.7591 2.7591 0 0 0 -.0781 4.7784 2.7507 2.7507 0 0 0 1.4233.398 2.7844 2.7844 0 0 0 1.1992-.2722 6.5339 6.5339 0 0 0 .57.4162 6.4471 6.4471 0 0 0 2.3359.8511 6.3818 6.3818 0 0 0 .9956.0776 6.5282 6.5282 0 0 0 3.97-1.349 2.731 2.731 0 0 0 1.1174.266 2.8026 2.8026 0 0 0 .6733-.083 2.77 2.77 0 0 0 .76-5.062zm-7.6616-6.6519a1.2705 1.2705 0 1 1 -.144.9614 1.2593 1.2593 0 0 1 .144-.9614zm-3.6484 10.268a1.27 1.27 0 0 1 -1.395-1.8872 1.27 1.27 0 1 1 1.395 1.8872zm4.0259 1.0527a4.96 4.96 0 0 1 -1.7954-.6553c-.0721-.0431-.1334-.1015-.2032-.1484.012-.0189.028-.0341.04-.0533a2.7493 2.7493 0 0 0 -2.244-4.1818 4.9551 4.9551 0 0 1 2.5376-4.226 2.7289 2.7289 0 0 0 2.3705 1.37 2.8025 2.8025 0 0 0 .6733-.083 2.7527 2.7527 0 0 0 1.7051-1.26c.0129-.0214.019-.0446.0313-.0662.0748.04.1548.0679.2275.1116a4.9887 4.9887 0 0 1 2.4108 4.1309 2.826 2.826 0 0 0 -.5661.0776 2.7584 2.7584 0 0 0 -1.6518 4.1812 5.0105 5.0105 0 0 1 -3.5357.8028zm6.9439-1.6406a1.27 1.27 0 1 1 -.4331-1.7432 1.2721 1.2721 0 0 1 .433 1.7432z"})))};mi.displayName="IconWorkgroup",mi.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},mi.defaultProps={title:"Workgroup",color:null,size:null},mi.__docgenInfo={description:"",methods:[],displayName:"IconWorkgroup",props:{title:{defaultValue:{value:"'Workgroup'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var gi=mi,zi=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.353 2.6743a.7.7 0 0 0 -1.1206-.1807l-2.1055 2.1055-.7269-.7265 2.1055-2.1055a.7.7 0 0 0 -.1807-1.12 4.56 4.56 0 0 0 -6.35 5.6708l-3.8757 3.8759c-.0138.0139-.0187.0322-.0311.0469a2.8047 2.8047 0 1 0 1.8793 4.7861 2.7957 2.7957 0 0 0 .8112-2.0949c.0146-.0124.033-.0173.0468-.0311l3.8758-3.8758a4.5673 4.5673 0 0 0 5.6719-6.3507zm-11.3955 11.3623a1.4092 1.4092 0 1 1 0-1.9941 1.4134 1.4134 0 0 1 0 1.9941zm1.3165-2.5846a2.8 2.8 0 0 0 -.3262-.4 2.7973 2.7973 0 0 0 -.4-.3266l3.148-3.1484a4.5956 4.5956 0 0 0 .3277.3988 4.6 4.6 0 0 0 .3985.3276zm8.25-4.4662a3.2659 3.2659 0 0 1 -4.5107 0 3.1768 3.1768 0 0 1 2.6938-5.4l-1.792 1.792a.7.7 0 0 0 0 .99l1.7163 1.7168a.7.7 0 0 0 .99 0l1.7925-1.793a3.16 3.16 0 0 1 -.8895 2.6942z"})))};zi.displayName="IconWrench",zi.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},zi.defaultProps={title:"Wrench",color:null,size:null},zi.__docgenInfo={description:"",methods:[],displayName:"IconWrench",props:{title:{defaultValue:{value:"'Wrench'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var vi=zi,hi=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.0605 8 4.1395-4.1394a.75.75 0 0 0 -1.06-1.0606l-4.14 4.1394-4.14-4.1394a.75.75 0 0 0 -1.06 1.0606l4.1395 4.1394-4.1395 4.1394a.75.75 0 1 0 1.06 1.0606l4.14-4.1395 4.14 4.1395a.75.75 0 0 0 1.06-1.0606z"})))};hi.displayName="IconX",hi.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},hi.defaultProps={title:"X",color:null,size:null},hi.__docgenInfo={description:"",methods:[],displayName:"IconX",props:{title:{defaultValue:{value:"'X'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var fi=hi,yi=function(e){return u.a.createElement(z,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6233 2.3787a7.95 7.95 0 1 0 -11.2427 11.2426 7.95 7.95 0 0 0 11.2427-11.2426zm-1.0606 10.1821a6.45 6.45 0 1 1 -9.1215-9.1216 6.45 6.45 0 1 1 9.1216 9.1216z"}),u.a.createElement("path",{d:"m10.8987 5.1033a.75.75 0 0 0 -1.0605 0l-1.8365 1.8367-1.8364-1.8367a.75.75 0 1 0 -1.0606 1.0605l1.8365 1.8362-1.8365 1.8367a.75.75 0 1 0 1.0605 1.0605l1.8365-1.8364 1.8364 1.8364a.75.75 0 1 0 1.0605-1.0605l-1.8363-1.8367 1.8364-1.8364a.75.75 0 0 0 0-1.0603z"})))};yi.displayName="IconXcircle",yi.propTypes={title:s.a.string,color:s.a.string,size:s.a.string},yi.defaultProps={title:"XCircle",color:null,size:null},yi.__docgenInfo={description:"",methods:[],displayName:"IconXcircle",props:{title:{defaultValue:{value:"'XCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ii=yi;a.d(t,"IconSVG",(function(){return z})),a.d(t,"IconAirplane",(function(){return h})),a.d(t,"IconArrow180",(function(){return y})),a.d(t,"IconArrow360",(function(){return E})),a.d(t,"IconArrowBox",(function(){return q})),a.d(t,"IconArrowCombine",(function(){return N})),a.d(t,"IconArrowDashed",(function(){return w})),a.d(t,"IconArrowDown",(function(){return T})),a.d(t,"IconArrowExit",(function(){return B})),a.d(t,"IconArrowForward",(function(){return C})),a.d(t,"IconArrowIntegrate",(function(){return L})),a.d(t,"IconArrowLeft",(function(){return S})),a.d(t,"IconArrowRandom",(function(){return D})),a.d(t,"IconArrowRefresh",(function(){return M})),a.d(t,"IconArrowRight",(function(){return H})),a.d(t,"IconArrowSkip",(function(){return R})),a.d(t,"IconArrowSpread",(function(){return X})),a.d(t,"IconArrowUp",(function(){return K})),a.d(t,"IconBadge",(function(){return J})),a.d(t,"IconBalloon",(function(){return $})),a.d(t,"IconBell",(function(){return te})),a.d(t,"IconBlocks",(function(){return le})),a.d(t,"IconBrush",(function(){return ne})),a.d(t,"IconCalendar",(function(){return oe})),a.d(t,"IconCamera",(function(){return ce})),a.d(t,"IconCaretDown",(function(){return de})),a.d(t,"IconCaretLeft",(function(){return me})),a.d(t,"IconCaretRight",(function(){return ze})),a.d(t,"IconCaretUp",(function(){return he})),a.d(t,"IconCaretUpDown",(function(){return ye})),a.d(t,"IconCart",(function(){return Ee})),a.d(t,"IconChartBarHorz",(function(){return qe})),a.d(t,"IconChartBarVert",(function(){return Ne})),a.d(t,"IconChartDonut",(function(){return we})),a.d(t,"IconChartDonutFilled",(function(){return Te})),a.d(t,"IconChartLine",(function(){return Be})),a.d(t,"IconChartPie",(function(){return Ce})),a.d(t,"IconChartSegment",(function(){return Le})),a.d(t,"IconChat",(function(){return Se})),a.d(t,"IconCheck",(function(){return De})),a.d(t,"IconCheckBox",(function(){return Me})),a.d(t,"IconCheckCircle",(function(){return He})),a.d(t,"IconChevronDown",(function(){return Re})),a.d(t,"IconChevronLeft",(function(){return Xe})),a.d(t,"IconChevronRight",(function(){return Ke})),a.d(t,"IconChevronUp",(function(){return Je})),a.d(t,"IconCircle",(function(){return $e})),a.d(t,"IconClock",(function(){return tt})),a.d(t,"IconClone",(function(){return lt})),a.d(t,"IconCloud",(function(){return nt})),a.d(t,"IconCloudArrow",(function(){return ot})),a.d(t,"IconComment",(function(){return ct})),a.d(t,"IconCommentCheck",(function(){return dt})),a.d(t,"IconCommentFilled",(function(){return mt})),a.d(t,"IconCopyright",(function(){return zt})),a.d(t,"IconDanger",(function(){return ht})),a.d(t,"IconDashboard",(function(){return yt})),a.d(t,"IconDesktop",(function(){return Et})),a.d(t,"IconDocument",(function(){return qt})),a.d(t,"IconDocumentArrow",(function(){return Nt})),a.d(t,"IconDocumentClone",(function(){return wt})),a.d(t,"IconDocumentList",(function(){return Tt})),a.d(t,"IconDocumentPlus",(function(){return Bt})),a.d(t,"IconDocumentSearch",(function(){return Ct})),a.d(t,"IconDocumentUser",(function(){return Lt})),a.d(t,"IconDocumentX",(function(){return St})),a.d(t,"IconEmail",(function(){return Dt})),a.d(t,"IconEye",(function(){return Mt})),a.d(t,"IconFilter",(function(){return Ht})),a.d(t,"IconFlag",(function(){return Rt})),a.d(t,"IconFlask",(function(){return Xt})),a.d(t,"IconFlowChart",(function(){return Kt})),a.d(t,"IconFolder",(function(){return Jt})),a.d(t,"IconFolderArrow",(function(){return $t})),a.d(t,"IconFolderPencil",(function(){return ta})),a.d(t,"IconFolderUser",(function(){return la})),a.d(t,"IconFootprint",(function(){return na})),a.d(t,"IconGear",(function(){return oa})),a.d(t,"IconGlobe",(function(){return ca})),a.d(t,"IconGovBuilding",(function(){return da})),a.d(t,"IconGraduationHat",(function(){return ma})),a.d(t,"IconGrid",(function(){return za})),a.d(t,"IconGridCarets",(function(){return ha})),a.d(t,"IconGridCircles",(function(){return ya})),a.d(t,"IconHappy",(function(){return Ea})),a.d(t,"IconHappyFilled",(function(){return qa})),a.d(t,"IconHealth",(function(){return Na})),a.d(t,"IconHeart",(function(){return wa})),a.d(t,"IconHeartFilled",(function(){return Ta})),a.d(t,"IconHeartHand",(function(){return Ba})),a.d(t,"IconHelp",(function(){return Ca})),a.d(t,"IconHouse",(function(){return La})),a.d(t,"IconImage",(function(){return Sa})),a.d(t,"IconInbox",(function(){return Da})),a.d(t,"IconInfo",(function(){return Ma})),a.d(t,"IconKey",(function(){return Ha})),a.d(t,"IconKeyboard",(function(){return Ra})),a.d(t,"IconLaunchpad",(function(){return Xa})),a.d(t,"IconLighting",(function(){return Ka})),a.d(t,"IconLink",(function(){return Ja})),a.d(t,"IconList",(function(){return $a})),a.d(t,"IconListBulleted",(function(){return tl})),a.d(t,"IconListChecks",(function(){return ll})),a.d(t,"IconLock",(function(){return nl})),a.d(t,"IconLogoDrive",(function(){return ol})),a.d(t,"IconLogoFacebook",(function(){return cl})),a.d(t,"IconLogoGmail",(function(){return dl})),a.d(t,"IconLogoGoldie",(function(){return ml})),a.d(t,"IconLogoGoogle",(function(){return zl})),a.d(t,"IconLogoGooglePlus",(function(){return hl})),a.d(t,"IconLogoLinkedIn",(function(){return yl})),a.d(t,"IconLogoMailChimp",(function(){return El})),a.d(t,"IconLogoMessenger",(function(){return ql})),a.d(t,"IconLogoOffice",(function(){return Nl})),a.d(t,"IconLogoOutlook",(function(){return wl})),a.d(t,"IconLogoPinterest",(function(){return Tl})),a.d(t,"IconLogoTwitter",(function(){return Bl})),a.d(t,"IconLogoWhatsApp",(function(){return Cl})),a.d(t,"IconLogoYahooMail",(function(){return Ll})),a.d(t,"IconLogoYouTube",(function(){return Sl})),a.d(t,"IconMegaphone",(function(){return Dl})),a.d(t,"IconMenu",(function(){return Ml})),a.d(t,"IconMinus",(function(){return Hl})),a.d(t,"IconMinusCircle",(function(){return Rl})),a.d(t,"IconMobile",(function(){return Xl})),a.d(t,"IconMore",(function(){return Kl})),a.d(t,"IconMoreAndroid",(function(){return Jl})),a.d(t,"IconMove",(function(){return $l})),a.d(t,"IconNews",(function(){return tr})),a.d(t,"IconNoWifi",(function(){return lr})),a.d(t,"IconNumber1",(function(){return nr})),a.d(t,"IconNumber2",(function(){return or})),a.d(t,"IconNumber3",(function(){return cr})),a.d(t,"IconNumber4",(function(){return dr})),a.d(t,"IconNumber5",(function(){return mr})),a.d(t,"IconNumber6",(function(){return zr})),a.d(t,"IconNumber7",(function(){return hr})),a.d(t,"IconNumber8",(function(){return yr})),a.d(t,"IconNumber9",(function(){return Er})),a.d(t,"IconNumber10",(function(){return qr})),a.d(t,"IconParagraph",(function(){return Nr})),a.d(t,"IconPencilBox",(function(){return wr})),a.d(t,"IconPencilPaper",(function(){return Tr})),a.d(t,"IconPlus",(function(){return Br})),a.d(t,"IconPlusCircle",(function(){return Cr})),a.d(t,"IconPrinter",(function(){return Lr})),a.d(t,"IconPulse",(function(){return Sr})),a.d(t,"IconSearch",(function(){return Dr})),a.d(t,"IconShapes",(function(){return Mr})),a.d(t,"IconShareAndroid",(function(){return Hr})),a.d(t,"IconShare",(function(){return Rr})),a.d(t,"IconShareIOS",(function(){return Xr})),a.d(t,"IconShuffle",(function(){return Kr})),a.d(t,"IconShuffleBox",(function(){return Jr})),a.d(t,"IconShuffleBoxFilled",(function(){return $r})),a.d(t,"IconSlider",(function(){return tn})),a.d(t,"IconSlidersVert",(function(){return ln})),a.d(t,"IconStar",(function(){return nn})),a.d(t,"IconStarFilled",(function(){return un})),a.d(t,"IconTableCol",(function(){return sn})),a.d(t,"IconTableRow",(function(){return pn})),a.d(t,"IconTablet",(function(){return gn})),a.d(t,"IconTabletCheck",(function(){return vn})),a.d(t,"IconTag",(function(){return fn})),a.d(t,"IconTextbox",(function(){return In})),a.d(t,"IconTextboxMultiple",(function(){return Vn})),a.d(t,"IconThumbsUp",(function(){return bn})),a.d(t,"IconThumbsUpFilled",(function(){return _n})),a.d(t,"IconTimer",(function(){return xn})),a.d(t,"IconToggle",(function(){return Pn})),a.d(t,"IconToolbox",(function(){return On})),a.d(t,"IconTrash",(function(){return jn})),a.d(t,"IconTruck",(function(){return An})),a.d(t,"IconUnlock",(function(){return kn})),a.d(t,"IconUser",(function(){return Fn})),a.d(t,"IconUserArrow",(function(){return Un})),a.d(t,"IconUserFilled",(function(){return Gn})),a.d(t,"IconUserPlus",(function(){return Wn})),a.d(t,"IconUsers",(function(){return Yn})),a.d(t,"IconUsersGroup",(function(){return Zn})),a.d(t,"IconVariable",(function(){return Qn})),a.d(t,"IconVideo",(function(){return ei})),a.d(t,"IconVideoEnd",(function(){return ai})),a.d(t,"IconVideoNext",(function(){return ri})),a.d(t,"IconVideoPrev",(function(){return ii})),a.d(t,"IconVideoStart",(function(){return ui})),a.d(t,"IconVideoStop",(function(){return si})),a.d(t,"IconWarning",(function(){return pi})),a.d(t,"IconWorkgroup",(function(){return gi})),a.d(t,"IconWrench",(function(){return vi})),a.d(t,"IconX",(function(){return fi})),a.d(t,"IconXCircle",(function(){return Ii}))}])}));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(21)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Wrapper for pickadate

var DatePicker = function () {
	function DatePicker(el) {
		var customConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		_classCallCheck(this, DatePicker);

		this.el = el || $('<input></input>');

		this.format = 'yyyy mmm dd';
		if (window.DATE_FORMAT === '0') {
			this.format = 'mmm dd yyyy';
		} else if (window.DATE_FORMAT === '1') {
			this.format = 'dd mmm yyyy';
		} else if (window.DATE_FORMAT === '2') {
			this.format = 'yyyy mmm dd';
		}

		if (el.val instanceof Function && this.el.val()) {
			// http://amsul.ca/pickadate.js/date/#formats_prefill
			var jsDate = new Date(this.el.val());
			var day = jsDate.getDate();
			var month = jsDate.getMonth() + 1;
			var year = jsDate.getFullYear();
			var formattedDate = '' + (month <= 9 ? '0' + month : month) + ('/' + (day <= 9 ? '0' + day : day)) + ('/' + year);
			this.el.data('value', formattedDate);
		}

		var config = {
			selectYears: 200,
			selectMonths: true,
			format: this.format,
			formatSubmit: 'mm/dd/yyyy',
			hiddenName: true,
			klass: {
				selectMonth: 'picker__select--month',
				selectYear: 'picker__select--year'
			}
		};

		if (customConfig !== null) {
			_.extend(config, customConfig);
		}

		this.picker = $(this.el).pickadate(config).pickadate('picker');
	}

	_createClass(DatePicker, [{
		key: 'get',
		value: function get() {
			return this.picker.get('select', 'yyyy/mm/dd');
		}
	}]);

	return DatePicker;
}();

module.exports = DatePicker;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(857);
var toPrimitive = __webpack_require__(98);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(99);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(t){var e=typeof self=="object"&&self.self===self&&self||typeof global=="object"&&global.global===global&&global;if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53),__webpack_require__(137),exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(i,r,n){e.Backbone=t(e,n,i,r)}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof exports!=="undefined"){var i=require("underscore"),r;try{r=require("jquery")}catch(n){}t(e,exports,i,r)}else{e.Backbone=t(e,{},e._,e.jQuery||e.Zepto||e.ender||e.$)}})(function(t,e,i,r){var n=t.Backbone;var s=Array.prototype.slice;e.VERSION="1.3.3";e.$=r;e.noConflict=function(){t.Backbone=n;return this};e.emulateHTTP=false;e.emulateJSON=false;var a=function(t,e,r){switch(t){case 1:return function(){return i[e](this[r])};case 2:return function(t){return i[e](this[r],t)};case 3:return function(t,n){return i[e](this[r],o(t,this),n)};case 4:return function(t,n,s){return i[e](this[r],o(t,this),n,s)};default:return function(){var t=s.call(arguments);t.unshift(this[r]);return i[e].apply(i,t)}}};var h=function(t,e,r){i.each(e,function(e,n){if(i[n])t.prototype[n]=a(e,n,r)})};var o=function(t,e){if(i.isFunction(t))return t;if(i.isObject(t)&&!e._isModel(t))return l(t);if(i.isString(t))return function(e){return e.get(t)};return t};var l=function(t){var e=i.matches(t);return function(t){return e(t.attributes)}};var u=e.Events={};var c=/\s+/;var f=function(t,e,r,n,s){var a=0,h;if(r&&typeof r==="object"){if(n!==void 0&&"context"in s&&s.context===void 0)s.context=n;for(h=i.keys(r);a<h.length;a++){e=f(t,e,h[a],r[h[a]],s)}}else if(r&&c.test(r)){for(h=r.split(c);a<h.length;a++){e=t(e,h[a],n,s)}}else{e=t(e,r,n,s)}return e};u.on=function(t,e,i){return d(this,t,e,i)};var d=function(t,e,i,r,n){t._events=f(v,t._events||{},e,i,{context:r,ctx:t,listening:n});if(n){var s=t._listeners||(t._listeners={});s[n.id]=n}return t};u.listenTo=function(t,e,r){if(!t)return this;var n=t._listenId||(t._listenId=i.uniqueId("l"));var s=this._listeningTo||(this._listeningTo={});var a=s[n];if(!a){var h=this._listenId||(this._listenId=i.uniqueId("l"));a=s[n]={obj:t,objId:n,id:h,listeningTo:s,count:0}}d(t,e,r,this,a);return this};var v=function(t,e,i,r){if(i){var n=t[e]||(t[e]=[]);var s=r.context,a=r.ctx,h=r.listening;if(h)h.count++;n.push({callback:i,context:s,ctx:s||a,listening:h})}return t};u.off=function(t,e,i){if(!this._events)return this;this._events=f(g,this._events,t,e,{context:i,listeners:this._listeners});return this};u.stopListening=function(t,e,r){var n=this._listeningTo;if(!n)return this;var s=t?[t._listenId]:i.keys(n);for(var a=0;a<s.length;a++){var h=n[s[a]];if(!h)break;h.obj.off(e,r,this)}return this};var g=function(t,e,r,n){if(!t)return;var s=0,a;var h=n.context,o=n.listeners;if(!e&&!r&&!h){var l=i.keys(o);for(;s<l.length;s++){a=o[l[s]];delete o[a.id];delete a.listeningTo[a.objId]}return}var u=e?[e]:i.keys(t);for(;s<u.length;s++){e=u[s];var c=t[e];if(!c)break;var f=[];for(var d=0;d<c.length;d++){var v=c[d];if(r&&r!==v.callback&&r!==v.callback._callback||h&&h!==v.context){f.push(v)}else{a=v.listening;if(a&&--a.count===0){delete o[a.id];delete a.listeningTo[a.objId]}}}if(f.length){t[e]=f}else{delete t[e]}}return t};u.once=function(t,e,r){var n=f(p,{},t,e,i.bind(this.off,this));if(typeof t==="string"&&r==null)e=void 0;return this.on(n,e,r)};u.listenToOnce=function(t,e,r){var n=f(p,{},e,r,i.bind(this.stopListening,this,t));return this.listenTo(t,n)};var p=function(t,e,r,n){if(r){var s=t[e]=i.once(function(){n(e,s);r.apply(this,arguments)});s._callback=r}return t};u.trigger=function(t){if(!this._events)return this;var e=Math.max(0,arguments.length-1);var i=Array(e);for(var r=0;r<e;r++)i[r]=arguments[r+1];f(m,this._events,t,void 0,i);return this};var m=function(t,e,i,r){if(t){var n=t[e];var s=t.all;if(n&&s)s=s.slice();if(n)_(n,r);if(s)_(s,[e].concat(r))}return t};var _=function(t,e){var i,r=-1,n=t.length,s=e[0],a=e[1],h=e[2];switch(e.length){case 0:while(++r<n)(i=t[r]).callback.call(i.ctx);return;case 1:while(++r<n)(i=t[r]).callback.call(i.ctx,s);return;case 2:while(++r<n)(i=t[r]).callback.call(i.ctx,s,a);return;case 3:while(++r<n)(i=t[r]).callback.call(i.ctx,s,a,h);return;default:while(++r<n)(i=t[r]).callback.apply(i.ctx,e);return}};u.bind=u.on;u.unbind=u.off;i.extend(e,u);var y=e.Model=function(t,e){var r=t||{};e||(e={});this.cid=i.uniqueId(this.cidPrefix);this.attributes={};if(e.collection)this.collection=e.collection;if(e.parse)r=this.parse(r,e)||{};var n=i.result(this,"defaults");r=i.defaults(i.extend({},n,r),n);this.set(r,e);this.changed={};this.initialize.apply(this,arguments)};i.extend(y.prototype,u,{changed:null,validationError:null,idAttribute:"id",cidPrefix:"c",initialize:function(){},toJSON:function(t){return i.clone(this.attributes)},sync:function(){return e.sync.apply(this,arguments)},get:function(t){return this.attributes[t]},escape:function(t){return i.escape(this.get(t))},has:function(t){return this.get(t)!=null},matches:function(t){return!!i.iteratee(t,this)(this.attributes)},set:function(t,e,r){if(t==null)return this;var n;if(typeof t==="object"){n=t;r=e}else{(n={})[t]=e}r||(r={});if(!this._validate(n,r))return false;var s=r.unset;var a=r.silent;var h=[];var o=this._changing;this._changing=true;if(!o){this._previousAttributes=i.clone(this.attributes);this.changed={}}var l=this.attributes;var u=this.changed;var c=this._previousAttributes;for(var f in n){e=n[f];if(!i.isEqual(l[f],e))h.push(f);if(!i.isEqual(c[f],e)){u[f]=e}else{delete u[f]}s?delete l[f]:l[f]=e}if(this.idAttribute in n)this.id=this.get(this.idAttribute);if(!a){if(h.length)this._pending=r;for(var d=0;d<h.length;d++){this.trigger("change:"+h[d],this,l[h[d]],r)}}if(o)return this;if(!a){while(this._pending){r=this._pending;this._pending=false;this.trigger("change",this,r)}}this._pending=false;this._changing=false;return this},unset:function(t,e){return this.set(t,void 0,i.extend({},e,{unset:true}))},clear:function(t){var e={};for(var r in this.attributes)e[r]=void 0;return this.set(e,i.extend({},t,{unset:true}))},hasChanged:function(t){if(t==null)return!i.isEmpty(this.changed);return i.has(this.changed,t)},changedAttributes:function(t){if(!t)return this.hasChanged()?i.clone(this.changed):false;var e=this._changing?this._previousAttributes:this.attributes;var r={};for(var n in t){var s=t[n];if(i.isEqual(e[n],s))continue;r[n]=s}return i.size(r)?r:false},previous:function(t){if(t==null||!this._previousAttributes)return null;return this._previousAttributes[t]},previousAttributes:function(){return i.clone(this._previousAttributes)},fetch:function(t){t=i.extend({parse:true},t);var e=this;var r=t.success;t.success=function(i){var n=t.parse?e.parse(i,t):i;if(!e.set(n,t))return false;if(r)r.call(t.context,e,i,t);e.trigger("sync",e,i,t)};B(this,t);return this.sync("read",this,t)},save:function(t,e,r){var n;if(t==null||typeof t==="object"){n=t;r=e}else{(n={})[t]=e}r=i.extend({validate:true,parse:true},r);var s=r.wait;if(n&&!s){if(!this.set(n,r))return false}else if(!this._validate(n,r)){return false}var a=this;var h=r.success;var o=this.attributes;r.success=function(t){a.attributes=o;var e=r.parse?a.parse(t,r):t;if(s)e=i.extend({},n,e);if(e&&!a.set(e,r))return false;if(h)h.call(r.context,a,t,r);a.trigger("sync",a,t,r)};B(this,r);if(n&&s)this.attributes=i.extend({},o,n);var l=this.isNew()?"create":r.patch?"patch":"update";if(l==="patch"&&!r.attrs)r.attrs=n;var u=this.sync(l,this,r);this.attributes=o;return u},destroy:function(t){t=t?i.clone(t):{};var e=this;var r=t.success;var n=t.wait;var s=function(){e.stopListening();e.trigger("destroy",e,e.collection,t)};t.success=function(i){if(n)s();if(r)r.call(t.context,e,i,t);if(!e.isNew())e.trigger("sync",e,i,t)};var a=false;if(this.isNew()){i.defer(t.success)}else{B(this,t);a=this.sync("delete",this,t)}if(!n)s();return a},url:function(){var t=i.result(this,"urlRoot")||i.result(this.collection,"url")||F();if(this.isNew())return t;var e=this.get(this.idAttribute);return t.replace(/[^\/]$/,"$&/")+encodeURIComponent(e)},parse:function(t,e){return t},clone:function(){return new this.constructor(this.attributes)},isNew:function(){return!this.has(this.idAttribute)},isValid:function(t){return this._validate({},i.extend({},t,{validate:true}))},_validate:function(t,e){if(!e.validate||!this.validate)return true;t=i.extend({},this.attributes,t);var r=this.validationError=this.validate(t,e)||null;if(!r)return true;this.trigger("invalid",this,r,i.extend(e,{validationError:r}));return false}});var b={keys:1,values:1,pairs:1,invert:1,pick:0,omit:0,chain:1,isEmpty:1};h(y,b,"attributes");var x=e.Collection=function(t,e){e||(e={});if(e.model)this.model=e.model;if(e.comparator!==void 0)this.comparator=e.comparator;this._reset();this.initialize.apply(this,arguments);if(t)this.reset(t,i.extend({silent:true},e))};var w={add:true,remove:true,merge:true};var E={add:true,remove:false};var I=function(t,e,i){i=Math.min(Math.max(i,0),t.length);var r=Array(t.length-i);var n=e.length;var s;for(s=0;s<r.length;s++)r[s]=t[s+i];for(s=0;s<n;s++)t[s+i]=e[s];for(s=0;s<r.length;s++)t[s+n+i]=r[s]};i.extend(x.prototype,u,{model:y,initialize:function(){},toJSON:function(t){return this.map(function(e){return e.toJSON(t)})},sync:function(){return e.sync.apply(this,arguments)},add:function(t,e){return this.set(t,i.extend({merge:false},e,E))},remove:function(t,e){e=i.extend({},e);var r=!i.isArray(t);t=r?[t]:t.slice();var n=this._removeModels(t,e);if(!e.silent&&n.length){e.changes={added:[],merged:[],removed:n};this.trigger("update",this,e)}return r?n[0]:n},set:function(t,e){if(t==null)return;e=i.extend({},w,e);if(e.parse&&!this._isModel(t)){t=this.parse(t,e)||[]}var r=!i.isArray(t);t=r?[t]:t.slice();var n=e.at;if(n!=null)n=+n;if(n>this.length)n=this.length;if(n<0)n+=this.length+1;var s=[];var a=[];var h=[];var o=[];var l={};var u=e.add;var c=e.merge;var f=e.remove;var d=false;var v=this.comparator&&n==null&&e.sort!==false;var g=i.isString(this.comparator)?this.comparator:null;var p,m;for(m=0;m<t.length;m++){p=t[m];var _=this.get(p);if(_){if(c&&p!==_){var y=this._isModel(p)?p.attributes:p;if(e.parse)y=_.parse(y,e);_.set(y,e);h.push(_);if(v&&!d)d=_.hasChanged(g)}if(!l[_.cid]){l[_.cid]=true;s.push(_)}t[m]=_}else if(u){p=t[m]=this._prepareModel(p,e);if(p){a.push(p);this._addReference(p,e);l[p.cid]=true;s.push(p)}}}if(f){for(m=0;m<this.length;m++){p=this.models[m];if(!l[p.cid])o.push(p)}if(o.length)this._removeModels(o,e)}var b=false;var x=!v&&u&&f;if(s.length&&x){b=this.length!==s.length||i.some(this.models,function(t,e){return t!==s[e]});this.models.length=0;I(this.models,s,0);this.length=this.models.length}else if(a.length){if(v)d=true;I(this.models,a,n==null?this.length:n);this.length=this.models.length}if(d)this.sort({silent:true});if(!e.silent){for(m=0;m<a.length;m++){if(n!=null)e.index=n+m;p=a[m];p.trigger("add",p,this,e)}if(d||b)this.trigger("sort",this,e);if(a.length||o.length||h.length){e.changes={added:a,removed:o,merged:h};this.trigger("update",this,e)}}return r?t[0]:t},reset:function(t,e){e=e?i.clone(e):{};for(var r=0;r<this.models.length;r++){this._removeReference(this.models[r],e)}e.previousModels=this.models;this._reset();t=this.add(t,i.extend({silent:true},e));if(!e.silent)this.trigger("reset",this,e);return t},push:function(t,e){return this.add(t,i.extend({at:this.length},e))},pop:function(t){var e=this.at(this.length-1);return this.remove(e,t)},unshift:function(t,e){return this.add(t,i.extend({at:0},e))},shift:function(t){var e=this.at(0);return this.remove(e,t)},slice:function(){return s.apply(this.models,arguments)},get:function(t){if(t==null)return void 0;return this._byId[t]||this._byId[this.modelId(t.attributes||t)]||t.cid&&this._byId[t.cid]},has:function(t){return this.get(t)!=null},at:function(t){if(t<0)t+=this.length;return this.models[t]},where:function(t,e){return this[e?"find":"filter"](t)},findWhere:function(t){return this.where(t,true)},sort:function(t){var e=this.comparator;if(!e)throw new Error("Cannot sort a set without a comparator");t||(t={});var r=e.length;if(i.isFunction(e))e=i.bind(e,this);if(r===1||i.isString(e)){this.models=this.sortBy(e)}else{this.models.sort(e)}if(!t.silent)this.trigger("sort",this,t);return this},pluck:function(t){return this.map(t+"")},fetch:function(t){t=i.extend({parse:true},t);var e=t.success;var r=this;t.success=function(i){var n=t.reset?"reset":"set";r[n](i,t);if(e)e.call(t.context,r,i,t);r.trigger("sync",r,i,t)};B(this,t);return this.sync("read",this,t)},create:function(t,e){e=e?i.clone(e):{};var r=e.wait;t=this._prepareModel(t,e);if(!t)return false;if(!r)this.add(t,e);var n=this;var s=e.success;e.success=function(t,e,i){if(r)n.add(t,i);if(s)s.call(i.context,t,e,i)};t.save(null,e);return t},parse:function(t,e){return t},clone:function(){return new this.constructor(this.models,{model:this.model,comparator:this.comparator})},modelId:function(t){return t[this.model.prototype.idAttribute||"id"]},_reset:function(){this.length=0;this.models=[];this._byId={}},_prepareModel:function(t,e){if(this._isModel(t)){if(!t.collection)t.collection=this;return t}e=e?i.clone(e):{};e.collection=this;var r=new this.model(t,e);if(!r.validationError)return r;this.trigger("invalid",this,r.validationError,e);return false},_removeModels:function(t,e){var i=[];for(var r=0;r<t.length;r++){var n=this.get(t[r]);if(!n)continue;var s=this.indexOf(n);this.models.splice(s,1);this.length--;delete this._byId[n.cid];var a=this.modelId(n.attributes);if(a!=null)delete this._byId[a];if(!e.silent){e.index=s;n.trigger("remove",n,this,e)}i.push(n);this._removeReference(n,e)}return i},_isModel:function(t){return t instanceof y},_addReference:function(t,e){this._byId[t.cid]=t;var i=this.modelId(t.attributes);if(i!=null)this._byId[i]=t;t.on("all",this._onModelEvent,this)},_removeReference:function(t,e){delete this._byId[t.cid];var i=this.modelId(t.attributes);if(i!=null)delete this._byId[i];if(this===t.collection)delete t.collection;t.off("all",this._onModelEvent,this)},_onModelEvent:function(t,e,i,r){if(e){if((t==="add"||t==="remove")&&i!==this)return;if(t==="destroy")this.remove(e,r);if(t==="change"){var n=this.modelId(e.previousAttributes());var s=this.modelId(e.attributes);if(n!==s){if(n!=null)delete this._byId[n];if(s!=null)this._byId[s]=e}}}this.trigger.apply(this,arguments)}});var S={forEach:3,each:3,map:3,collect:3,reduce:0,foldl:0,inject:0,reduceRight:0,foldr:0,find:3,detect:3,filter:3,select:3,reject:3,every:3,all:3,some:3,any:3,include:3,includes:3,contains:3,invoke:0,max:3,min:3,toArray:1,size:1,first:3,head:3,take:3,initial:3,rest:3,tail:3,drop:3,last:3,without:0,difference:0,indexOf:3,shuffle:1,lastIndexOf:3,isEmpty:1,chain:1,sample:3,partition:3,groupBy:3,countBy:3,sortBy:3,indexBy:3,findIndex:3,findLastIndex:3};h(x,S,"models");var k=e.View=function(t){this.cid=i.uniqueId("view");i.extend(this,i.pick(t,P));this._ensureElement();this.initialize.apply(this,arguments)};var T=/^(\S+)\s*(.*)$/;var P=["model","collection","el","id","attributes","className","tagName","events"];i.extend(k.prototype,u,{tagName:"div",$:function(t){return this.$el.find(t)},initialize:function(){},render:function(){return this},remove:function(){this._removeElement();this.stopListening();return this},_removeElement:function(){this.$el.remove()},setElement:function(t){this.undelegateEvents();this._setElement(t);this.delegateEvents();return this},_setElement:function(t){this.$el=t instanceof e.$?t:e.$(t);this.el=this.$el[0]},delegateEvents:function(t){t||(t=i.result(this,"events"));if(!t)return this;this.undelegateEvents();for(var e in t){var r=t[e];if(!i.isFunction(r))r=this[r];if(!r)continue;var n=e.match(T);this.delegate(n[1],n[2],i.bind(r,this))}return this},delegate:function(t,e,i){this.$el.on(t+".delegateEvents"+this.cid,e,i);return this},undelegateEvents:function(){if(this.$el)this.$el.off(".delegateEvents"+this.cid);return this},undelegate:function(t,e,i){this.$el.off(t+".delegateEvents"+this.cid,e,i);return this},_createElement:function(t){return document.createElement(t)},_ensureElement:function(){if(!this.el){var t=i.extend({},i.result(this,"attributes"));if(this.id)t.id=i.result(this,"id");if(this.className)t["class"]=i.result(this,"className");this.setElement(this._createElement(i.result(this,"tagName")));this._setAttributes(t)}else{this.setElement(i.result(this,"el"))}},_setAttributes:function(t){this.$el.attr(t)}});e.sync=function(t,r,n){var s=H[t];i.defaults(n||(n={}),{emulateHTTP:e.emulateHTTP,emulateJSON:e.emulateJSON});var a={type:s,dataType:"json"};if(!n.url){a.url=i.result(r,"url")||F()}if(n.data==null&&r&&(t==="create"||t==="update"||t==="patch")){a.contentType="application/json";a.data=JSON.stringify(n.attrs||r.toJSON(n))}if(n.emulateJSON){a.contentType="application/x-www-form-urlencoded";a.data=a.data?{model:a.data}:{}}if(n.emulateHTTP&&(s==="PUT"||s==="DELETE"||s==="PATCH")){a.type="POST";if(n.emulateJSON)a.data._method=s;var h=n.beforeSend;n.beforeSend=function(t){t.setRequestHeader("X-HTTP-Method-Override",s);if(h)return h.apply(this,arguments)}}if(a.type!=="GET"&&!n.emulateJSON){a.processData=false}var o=n.error;n.error=function(t,e,i){n.textStatus=e;n.errorThrown=i;if(o)o.call(n.context,t,e,i)};var l=n.xhr=e.ajax(i.extend(a,n));r.trigger("request",r,l,n);return l};var H={create:"POST",update:"PUT",patch:"PATCH","delete":"DELETE",read:"GET"};e.ajax=function(){return e.$.ajax.apply(e.$,arguments)};var $=e.Router=function(t){t||(t={});if(t.routes)this.routes=t.routes;this._bindRoutes();this.initialize.apply(this,arguments)};var A=/\((.*?)\)/g;var C=/(\(\?)?:\w+/g;var R=/\*\w+/g;var j=/[\-{}\[\]+?.,\\\^$|#\s]/g;i.extend($.prototype,u,{initialize:function(){},route:function(t,r,n){if(!i.isRegExp(t))t=this._routeToRegExp(t);if(i.isFunction(r)){n=r;r=""}if(!n)n=this[r];var s=this;e.history.route(t,function(i){var a=s._extractParameters(t,i);if(s.execute(n,a,r)!==false){s.trigger.apply(s,["route:"+r].concat(a));s.trigger("route",r,a);e.history.trigger("route",s,r,a)}});return this},execute:function(t,e,i){if(t)t.apply(this,e)},navigate:function(t,i){e.history.navigate(t,i);return this},_bindRoutes:function(){if(!this.routes)return;this.routes=i.result(this,"routes");var t,e=i.keys(this.routes);while((t=e.pop())!=null){this.route(t,this.routes[t])}},_routeToRegExp:function(t){t=t.replace(j,"\\$&").replace(A,"(?:$1)?").replace(C,function(t,e){return e?t:"([^/?]+)"}).replace(R,"([^?]*?)");return new RegExp("^"+t+"(?:\\?([\\s\\S]*))?$")},_extractParameters:function(t,e){var r=t.exec(e).slice(1);return i.map(r,function(t,e){if(e===r.length-1)return t||null;return t?decodeURIComponent(t):null})}});var N=e.History=function(){this.handlers=[];this.checkUrl=i.bind(this.checkUrl,this);if(typeof window!=="undefined"){this.location=window.location;this.history=window.history}};var M=/^[#\/]|\s+$/g;var O=/^\/+|\/+$/g;var U=/#.*$/;N.started=false;i.extend(N.prototype,u,{interval:50,atRoot:function(){var t=this.location.pathname.replace(/[^\/]$/,"$&/");return t===this.root&&!this.getSearch()},matchRoot:function(){var t=this.decodeFragment(this.location.pathname);var e=t.slice(0,this.root.length-1)+"/";return e===this.root},decodeFragment:function(t){return decodeURI(t.replace(/%25/g,"%2525"))},getSearch:function(){var t=this.location.href.replace(/#.*/,"").match(/\?.+/);return t?t[0]:""},getHash:function(t){var e=(t||this).location.href.match(/#(.*)$/);return e?e[1]:""},getPath:function(){var t=this.decodeFragment(this.location.pathname+this.getSearch()).slice(this.root.length-1);return t.charAt(0)==="/"?t.slice(1):t},getFragment:function(t){if(t==null){if(this._usePushState||!this._wantsHashChange){t=this.getPath()}else{t=this.getHash()}}return t.replace(M,"")},start:function(t){if(N.started)throw new Error("Backbone.history has already been started");N.started=true;this.options=i.extend({root:"/"},this.options,t);this.root=this.options.root;this._wantsHashChange=this.options.hashChange!==false;this._hasHashChange="onhashchange"in window&&(document.documentMode===void 0||document.documentMode>7);this._useHashChange=this._wantsHashChange&&this._hasHashChange;this._wantsPushState=!!this.options.pushState;this._hasPushState=!!(this.history&&this.history.pushState);this._usePushState=this._wantsPushState&&this._hasPushState;this.fragment=this.getFragment();this.root=("/"+this.root+"/").replace(O,"/");if(this._wantsHashChange&&this._wantsPushState){if(!this._hasPushState&&!this.atRoot()){var e=this.root.slice(0,-1)||"/";this.location.replace(e+"#"+this.getPath());return true}else if(this._hasPushState&&this.atRoot()){this.navigate(this.getHash(),{replace:true})}}if(!this._hasHashChange&&this._wantsHashChange&&!this._usePushState){this.iframe=document.createElement("iframe");this.iframe.src="javascript:0";this.iframe.style.display="none";this.iframe.tabIndex=-1;var r=document.body;var n=r.insertBefore(this.iframe,r.firstChild).contentWindow;n.document.open();n.document.close();n.location.hash="#"+this.fragment}var s=window.addEventListener||function(t,e){return attachEvent("on"+t,e)};if(this._usePushState){s("popstate",this.checkUrl,false)}else if(this._useHashChange&&!this.iframe){s("hashchange",this.checkUrl,false)}else if(this._wantsHashChange){this._checkUrlInterval=setInterval(this.checkUrl,this.interval)}if(!this.options.silent)return this.loadUrl()},stop:function(){var t=window.removeEventListener||function(t,e){return detachEvent("on"+t,e)};if(this._usePushState){t("popstate",this.checkUrl,false)}else if(this._useHashChange&&!this.iframe){t("hashchange",this.checkUrl,false)}if(this.iframe){document.body.removeChild(this.iframe);this.iframe=null}if(this._checkUrlInterval)clearInterval(this._checkUrlInterval);N.started=false},route:function(t,e){this.handlers.unshift({route:t,callback:e})},checkUrl:function(t){var e=this.getFragment();if(e===this.fragment&&this.iframe){e=this.getHash(this.iframe.contentWindow)}if(e===this.fragment)return false;if(this.iframe)this.navigate(e);this.loadUrl()},loadUrl:function(t){if(!this.matchRoot())return false;t=this.fragment=this.getFragment(t);return i.some(this.handlers,function(e){if(e.route.test(t)){e.callback(t);return true}})},navigate:function(t,e){if(!N.started)return false;if(!e||e===true)e={trigger:!!e};t=this.getFragment(t||"");var i=this.root;if(t===""||t.charAt(0)==="?"){i=i.slice(0,-1)||"/"}var r=i+t;t=this.decodeFragment(t.replace(U,""));if(this.fragment===t)return;this.fragment=t;if(this._usePushState){this.history[e.replace?"replaceState":"pushState"]({},document.title,r)}else if(this._wantsHashChange){this._updateHash(this.location,t,e.replace);if(this.iframe&&t!==this.getHash(this.iframe.contentWindow)){var n=this.iframe.contentWindow;if(!e.replace){n.document.open();n.document.close()}this._updateHash(n.location,t,e.replace)}}else{return this.location.assign(r)}if(e.trigger)return this.loadUrl(t)},_updateHash:function(t,e,i){if(i){var r=t.href.replace(/(javascript:|#).*$/,"");t.replace(r+"#"+e)}else{t.hash="#"+e}}});e.history=new N;var q=function(t,e){var r=this;var n;if(t&&i.has(t,"constructor")){n=t.constructor}else{n=function(){return r.apply(this,arguments)}}i.extend(n,r,e);n.prototype=i.create(r.prototype,t);n.prototype.constructor=n;n.__super__=r.prototype;return n};y.extend=x.extend=$.extend=k.extend=N.extend=q;var F=function(){throw new Error('A "url" property or function must be specified')};var B=function(t,e){var i=e.error;e.error=function(r){if(i)i.call(e.context,t,r,e);t.trigger("error",t,r,e)}};return e});
//# sourceMappingURL=backbone-min.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(48);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {
/*
Survey logic, filter and branching implementation. Classes in this file are
used by the offline survey implementation and in the editor.
 */
var AndNode, ArrayNode, AttrNode, AvgNode, BranchAction, BranchingRule, CIntNode, CRealNode, CRealTwoNode, CStrNode, CoalesceNode, CompareNode, ConcatNode, ConnectiveNode, ConstNode, ContinueAction, DisableAction, DivideNode, EmailAction, EvaluationVisitor, ExprEqualsNode, ExprGreaterEqualsNode, ExprGreaterthanNode, ExprLessEqualsNode, ExprLessthanNode, ExprNode, ExprNotEqualsNode, FinishBranchAction, FormatVisitor, FuncNode, HideAction, HidePageAction, IdentifierNode, IndexNode, IndexofNode, InvalidAction, JSONVisitor, LogicNode, LogicVisitor, MarkCompleteAction, MaxNode, MinNode, MinusNode, OrNode, PageBranchAction, PlusNode, PredicateNode, RandomBranchAction, RandomRangeAction, RedirectBranchAction, ShowAction, SimplifyVisitor, SubstrNode, SumNode, SurveyAction, SurveyFinishException, SurveyRedirectException, SurveyTerminateException, TargetAction, TerminateBranchAction, TimesNode, ValidationVisitor, _, cls, gettext, j, len, ref1, ref2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice;

_ = (typeof window === "undefined" || window === null) && (typeof module !== "undefined" && module !== null) ? __webpack_require__(53) : window._;

gettext = (ref1 = typeof window !== "undefined" && window !== null ? window.gettext : void 0) != null ? ref1 : function() {};

LogicNode = (function() {
  function LogicNode() {}

  LogicNode.prototype.type = 'logic';

  LogicNode.prototype.parse = function(info) {
    var child, items, negated, ref2, ref3, ref4, ref5, ref6, ref7, ref8, type, variable;
    type = ((ref2 = (ref3 = (ref4 = info.predicate) != null ? ref4 : info.logic) != null ? ref3 : info.type) != null ? ref2 : '').toLowerCase();
    if (info.op != null) {
      items = [];
      if (info.left != null) {
        items.push(info.left);
      }
      if (info.right != null) {
        items.push(info.right);
      }
      return new (info.op === 'or' ? OrNode : AndNode)(items, info.op === 'not');
    } else if (type === 'and' || type === 'or' || type === 'not') {
      items = [];
      if ((info.left != null) && info.left !== true) {
        items.push(LogicNode.prototype.parse(info.left));
      }
      if ((info.right != null) && info.right !== true) {
        items.push(LogicNode.prototype.parse(info.right));
      }
      items = _.compact(items.concat((function() {
        var j, len, ref5, ref6, results;
        ref6 = (ref5 = info.items) != null ? ref5 : [];
        results = [];
        for (j = 0, len = ref6.length; j < len; j++) {
          child = ref6[j];
          results.push(LogicNode.prototype.parse(child));
        }
        return results;
      })()));
      negated = !!info.negated || type === 'not';
      if (items.length === 0) {
        return null;
      }
      if (items.length === 1 && !negated) {
        return items[0];
      }
      return new (type === 'or' ? OrNode : AndNode)(items, negated);
    }
    type = (function() {
      switch (type) {
        case 'before':
        case 'datelessthan':
        case 'timelessthan':
          return 'before';
        case 'after':
        case 'dategreaterthan':
        case 'timegreaterthan':
          return 'after';
        default:
          return type;
      }
    })();
    info = _.extend({}, info);
    variable = (ref5 = info.variable) != null ? ref5 : (ref6 = info.left) != null ? ref6.name : void 0;
    if (((ref7 = info.left) != null ? ref7.meta : void 0) != null) {
      variable = (function() {
        switch (info.left.meta) {
          case 'meta_language':
            return '_language';
          case 'meta_ipaddress':
            return '_ip_address';
          case 'meta_user':
            return '_invite_email';
          case 'meta_score':
            return '_weighted_score';
        }
      })();
    }
    info.value = (ref8 = info.value) != null ? ref8 : info.right;
    delete info.variable;
    delete info.left;
    delete info.right;
    delete info.logic;
    delete info.type;
    delete info.predicate;
    return new PredicateNode(variable, type, info);
  };

  LogicNode.prototype.format = function(survey) {
    return new FormatVisitor(survey).format(this);
  };

  LogicNode.prototype.validate = function(survey) {
    return new ValidationVisitor(survey).visit(this);
  };

  LogicNode.prototype.evaluate = function(handler) {
    return new EvaluationVisitor(handler).visit(this);
  };

  LogicNode.prototype.serialize = function(survey) {
    return new JSONVisitor(survey).visit(this);
  };

  LogicNode.prototype.simplify = function() {
    return new SimplifyVisitor().simplify(this);
  };

  return LogicNode;

})();

ExprNode = (function(superClass) {
  extend(ExprNode, superClass);

  ExprNode.prototype.type = 'expression';

  function ExprNode(left1, right1) {
    this.left = left1;
    this.right = right1;
  }

  ExprNode.prototype.parse = function(info) {
    switch (info.op) {
      case '+':
        return new PlusNode(info.left, info.right);
      case '-':
        return new MinusNode(info.left, info.right);
      case '*':
        return new TimesNode(info.left, info.right);
      case '/':
        return new DivideNode(info.left, info.right);
    }
  };

  return ExprNode;

})(LogicNode);

PlusNode = (function(superClass) {
  extend(PlusNode, superClass);

  function PlusNode() {
    return PlusNode.__super__.constructor.apply(this, arguments);
  }

  PlusNode.prototype.type = 'plus';

  return PlusNode;

})(ExprNode);

MinusNode = (function(superClass) {
  extend(MinusNode, superClass);

  function MinusNode() {
    return MinusNode.__super__.constructor.apply(this, arguments);
  }

  MinusNode.prototype.type = 'minus';

  return MinusNode;

})(ExprNode);

TimesNode = (function(superClass) {
  extend(TimesNode, superClass);

  function TimesNode() {
    return TimesNode.__super__.constructor.apply(this, arguments);
  }

  TimesNode.prototype.type = 'times';

  return TimesNode;

})(ExprNode);

DivideNode = (function(superClass) {
  extend(DivideNode, superClass);

  function DivideNode() {
    return DivideNode.__super__.constructor.apply(this, arguments);
  }

  DivideNode.prototype.type = 'divide';

  return DivideNode;

})(ExprNode);

CompareNode = (function(superClass) {
  extend(CompareNode, superClass);

  function CompareNode() {
    return CompareNode.__super__.constructor.apply(this, arguments);
  }

  CompareNode.prototype.type = 'compare';

  CompareNode.prototype.parse = function(info) {
    switch (info.op) {
      case '=':
        return new ExprEqualsNode(info.left, info.right);
      case '>':
        return new ExprGreaterthanNode(info.left, info.right);
      case '<':
        return new ExprLessthanNode(info.left, info.right);
      case '>=':
        return new ExprGreaterEqualsNode(info.left, info.right);
      case '<=':
        return new ExprLessEqualsNode(info.left, info.right);
      case '!=':
        return new ExprNotEqualsNode(info.left, info.right);
    }
  };

  return CompareNode;

})(ExprNode);

ExprEqualsNode = (function(superClass) {
  extend(ExprEqualsNode, superClass);

  function ExprEqualsNode() {
    return ExprEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprEqualsNode.prototype.type = 'expr_equals';

  return ExprEqualsNode;

})(CompareNode);

ExprGreaterthanNode = (function(superClass) {
  extend(ExprGreaterthanNode, superClass);

  function ExprGreaterthanNode() {
    return ExprGreaterthanNode.__super__.constructor.apply(this, arguments);
  }

  ExprGreaterthanNode.prototype.type = 'expr_greaterthan';

  return ExprGreaterthanNode;

})(CompareNode);

ExprLessthanNode = (function(superClass) {
  extend(ExprLessthanNode, superClass);

  function ExprLessthanNode() {
    return ExprLessthanNode.__super__.constructor.apply(this, arguments);
  }

  ExprLessthanNode.prototype.type = 'expr_lessthan';

  return ExprLessthanNode;

})(CompareNode);

ExprGreaterEqualsNode = (function(superClass) {
  extend(ExprGreaterEqualsNode, superClass);

  function ExprGreaterEqualsNode() {
    return ExprGreaterEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprGreaterEqualsNode.prototype.type = 'expr_greaterequals';

  return ExprGreaterEqualsNode;

})(CompareNode);

ExprLessEqualsNode = (function(superClass) {
  extend(ExprLessEqualsNode, superClass);

  function ExprLessEqualsNode() {
    return ExprLessEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprLessEqualsNode.prototype.type = 'expr_lessequals';

  return ExprLessEqualsNode;

})(CompareNode);

ExprNotEqualsNode = (function(superClass) {
  extend(ExprNotEqualsNode, superClass);

  function ExprNotEqualsNode() {
    return ExprNotEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprNotEqualsNode.prototype.type = 'expr_notequals';

  return ExprNotEqualsNode;

})(CompareNode);

ConnectiveNode = (function(superClass) {
  extend(ConnectiveNode, superClass);

  ConnectiveNode.prototype.negated = false;

  ConnectiveNode.prototype.type = 'connective';

  ConnectiveNode.prototype.evaluator = null;

  function ConnectiveNode(items1, negated1) {
    this.items = items1;
    this.negated = negated1 != null ? negated1 : false;
  }

  return ConnectiveNode;

})(LogicNode);

AndNode = (function(superClass) {
  extend(AndNode, superClass);

  function AndNode() {
    return AndNode.__super__.constructor.apply(this, arguments);
  }

  AndNode.prototype.type = 'and';

  AndNode.prototype.evaluator = _.all;

  return AndNode;

})(ConnectiveNode);

OrNode = (function(superClass) {
  extend(OrNode, superClass);

  function OrNode() {
    return OrNode.__super__.constructor.apply(this, arguments);
  }

  OrNode.prototype.type = 'or';

  OrNode.prototype.evaluator = _.any;

  return OrNode;

})(ConnectiveNode);

ArrayNode = (function(superClass) {
  extend(ArrayNode, superClass);

  ArrayNode.prototype.type = 'array';

  function ArrayNode(id, start1, end1) {
    this.id = id;
    this.start = start1;
    this.end = end1;
  }

  ArrayNode.prototype.parse = function(info) {
    return new ArrayNode(info.id, info.start, info.end);
  };

  return ArrayNode;

})(LogicNode);

FuncNode = (function(superClass) {
  extend(FuncNode, superClass);

  FuncNode.prototype.type = 'func';

  function FuncNode(id, params1) {
    this.id = id;
    this.params = params1;
  }

  FuncNode.prototype.parse = function(info) {
    var functions;
    functions = {
      'SUM': SumNode,
      'MAX': MaxNode,
      'MIN': MinNode,
      'AVG': AvgNode,
      'CONCAT': ConcatNode,
      'SUBSTR': SubstrNode,
      'INDEXOF': IndexofNode,
      'STR': CStrNode,
      'INT': CIntNode,
      'REAL': CRealNode,
      'REALTWO': CRealTwoNode,
      'COALESCE': CoalesceNode
    };
    if (functions[info.id.value] != null) {
      return new functions[info.id.value](info.id, info.params);
    } else {
      throw new Error('Function ' + info.id.value + ' doesn\'t exist.');
    }
  };

  FuncNode.prototype.visit_func = function(initial, visitor) {
    var item, j, k, len, len1, p, param, params, ref, ref2, value;
    params = (function() {
      var j, len, ref2, results;
      ref2 = this.params;
      results = [];
      for (j = 0, len = ref2.length; j < len; j++) {
        p = ref2[j];
        results.push(p);
      }
      return results;
    }).call(this);
    ref2 = params.reverse();
    for (j = 0, len = ref2.length; j < len; j++) {
      param = ref2[j];
      ref = visitor.visit(param);
      value = ref && ref.value ? ref.value() : ref;
      if (value instanceof Array) {
        for (k = 0, len1 = value.length; k < len1; k++) {
          item = value[k];
          if (!visitor.is_empty(item)) {
            initial = this.func(item, initial);
          }
        }
      } else if (!visitor.is_empty(value)) {
        initial = this.func(value, initial);
      }
    }
    return initial;
  };

  return FuncNode;

})(LogicNode);

SumNode = (function(superClass) {
  extend(SumNode, superClass);

  function SumNode() {
    return SumNode.__super__.constructor.apply(this, arguments);
  }

  SumNode.prototype.type = 'func';

  SumNode.prototype.func = function(param, sum) {
    return EvaluationVisitor.prototype.convert_float(param) + sum;
  };

  SumNode.prototype.visit = function(visitor) {
    return this.visit_func(0, visitor);
  };

  return SumNode;

})(FuncNode);

MaxNode = (function(superClass) {
  extend(MaxNode, superClass);

  function MaxNode() {
    return MaxNode.__super__.constructor.apply(this, arguments);
  }

  MaxNode.prototype.type = 'func';

  MaxNode.prototype.func = function(param, max) {
    if (EvaluationVisitor.prototype.convert_float(param) > max) {
      return EvaluationVisitor.prototype.convert_float(param);
    } else {
      return max;
    }
  };

  MaxNode.prototype.visit = function(visitor) {
    var result;
    result = this.visit_func(-2e308, visitor);
    if (result !== -2e308) {
      return result;
    } else {
      return '';
    }
  };

  return MaxNode;

})(FuncNode);

MinNode = (function(superClass) {
  extend(MinNode, superClass);

  function MinNode() {
    return MinNode.__super__.constructor.apply(this, arguments);
  }

  MinNode.prototype.type = 'func';

  MinNode.prototype.func = function(param, min) {
    if (EvaluationVisitor.prototype.convert_float(param) < min) {
      return EvaluationVisitor.prototype.convert_float(param);
    } else {
      return min;
    }
  };

  MinNode.prototype.visit = function(visitor) {
    var result;
    result = this.visit_func(2e308, visitor);
    if (result !== 2e308) {
      return result;
    } else {
      return '';
    }
  };

  return MinNode;

})(FuncNode);

AvgNode = (function(superClass) {
  extend(AvgNode, superClass);

  function AvgNode() {
    return AvgNode.__super__.constructor.apply(this, arguments);
  }

  AvgNode.prototype.type = 'func';

  AvgNode.prototype.func = function(param, acc) {
    return [acc[0] + EvaluationVisitor.prototype.convert_float(param), acc[1] + 1];
  };

  AvgNode.prototype.visit = function(visitor) {
    var count, ref2, sum;
    ref2 = this.visit_func([0, 0], visitor), sum = ref2[0], count = ref2[1];
    if (count) {
      return sum / count;
    } else {
      return '';
    }
  };

  return AvgNode;

})(FuncNode);

SubstrNode = (function(superClass) {
  extend(SubstrNode, superClass);

  function SubstrNode() {
    return SubstrNode.__super__.constructor.apply(this, arguments);
  }

  SubstrNode.prototype.type = 'func';

  SubstrNode.prototype.visit = function(visitor) {
    var length, p, params, ref2, ref3, ref4, start, target;
    if (this.params.length !== 2 && this.params.length !== 3) {
      throw new Error("The number of parameters is not correct!");
    }
    params = (function() {
      var j, len, ref2, results;
      ref2 = this.params;
      results = [];
      for (j = 0, len = ref2.length; j < len; j++) {
        p = ref2[j];
        results.push(p);
      }
      return results;
    }).call(this);
    params.reverse();
    target = visitor.visit(params[0]);
    target = (ref2 = typeof target.label === "function" ? target.label() : void 0) != null ? ref2 : target;
    start = visitor.visit(params[1]);
    start = (ref3 = typeof start.value === "function" ? start.value() : void 0) != null ? ref3 : start;
    if (params.length > 2) {
      length = visitor.visit(params[2]);
      length = (ref4 = typeof length.value === "function" ? length.value() : void 0) != null ? ref4 : length;
    }
    if (length) {
      return target.substring(visitor.convert_int(start), visitor.convert_int(start) + visitor.convert_int(length));
    } else {
      return target.substring(visitor.convert_int(start));
    }
  };

  return SubstrNode;

})(FuncNode);

IndexofNode = (function(superClass) {
  extend(IndexofNode, superClass);

  function IndexofNode() {
    return IndexofNode.__super__.constructor.apply(this, arguments);
  }

  IndexofNode.prototype.type = 'func';

  IndexofNode.prototype.visit = function(visitor) {
    var index, p, params, ref2, ref3, ref4, start, substr, target;
    if (this.params.length !== 2 && this.params.length !== 3) {
      throw new Error("The number of parameters is not correct!");
    }
    params = (function() {
      var j, len, ref2, results;
      ref2 = this.params;
      results = [];
      for (j = 0, len = ref2.length; j < len; j++) {
        p = ref2[j];
        results.push(p);
      }
      return results;
    }).call(this);
    params.reverse();
    target = visitor.visit(params[0]);
    target = (ref2 = typeof target.label === "function" ? target.label() : void 0) != null ? ref2 : target;
    substr = visitor.visit(params[1]);
    substr = (ref3 = typeof substr.value === "function" ? substr.value() : void 0) != null ? ref3 : substr;
    if (params.length > 2) {
      start = visitor.visit(params[2]);
      start = (ref4 = typeof start.value === "function" ? start.value() : void 0) != null ? ref4 : start;
    }
    return index = start ? target.indexOf(substr, visitor.convert_int(start)) : target.indexOf(substr);
  };

  return IndexofNode;

})(FuncNode);

ConcatNode = (function(superClass) {
  extend(ConcatNode, superClass);

  function ConcatNode() {
    return ConcatNode.__super__.constructor.apply(this, arguments);
  }

  ConcatNode.prototype.type = 'func';

  ConcatNode.prototype.func = function(param, acc) {
    return acc + param;
  };

  ConcatNode.prototype.visit = function(visitor) {
    return this.visit_func('', visitor);
  };

  return ConcatNode;

})(FuncNode);

CStrNode = (function(superClass) {
  extend(CStrNode, superClass);

  function CStrNode() {
    return CStrNode.__super__.constructor.apply(this, arguments);
  }

  CStrNode.prototype.type = 'func';

  CStrNode.prototype.visit = function(visitor) {
    var ref, ref2;
    if (this.params.length !== 1) {
      throw new Error("CStr function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return ((ref2 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref2 : ref).toString();
  };

  return CStrNode;

})(FuncNode);

CIntNode = (function(superClass) {
  extend(CIntNode, superClass);

  function CIntNode() {
    return CIntNode.__super__.constructor.apply(this, arguments);
  }

  CIntNode.prototype.type = 'func';

  CIntNode.prototype.visit = function(visitor) {
    var ref, ref2, value;
    if (this.params.length !== 1) {
      throw new Error("CInt function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    value = (ref2 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref2 : ref;
    if (isNaN(value)) {
      throw new Error("The operator is not a number");
    } else {
      return parseInt(value);
    }
  };

  return CIntNode;

})(FuncNode);

CRealNode = (function(superClass) {
  extend(CRealNode, superClass);

  function CRealNode() {
    return CRealNode.__super__.constructor.apply(this, arguments);
  }

  CRealNode.prototype.type = 'func';

  CRealNode.prototype.visit = function(visitor) {
    var ref, ref2;
    if (this.params.length !== 1) {
      throw new Error("CReal function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return visitor.convert_float((ref2 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref2 : ref);
  };

  return CRealNode;

})(FuncNode);

CRealTwoNode = (function(superClass) {
  extend(CRealTwoNode, superClass);

  function CRealTwoNode() {
    return CRealTwoNode.__super__.constructor.apply(this, arguments);
  }

  CRealTwoNode.prototype.type = 'func';

  CRealTwoNode.prototype.visit = function(visitor) {
    var ref, ref2;
    if (this.params.length !== 1) {
      throw new Error("CReal function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return visitor.convert_float_tofixed_two((ref2 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref2 : ref);
  };

  return CRealTwoNode;

})(FuncNode);

CoalesceNode = (function(superClass) {
  extend(CoalesceNode, superClass);

  function CoalesceNode() {
    return CoalesceNode.__super__.constructor.apply(this, arguments);
  }

  CoalesceNode.prototype.type = 'func';

  CoalesceNode.prototype.func = function(param, initial) {
    if (initial) {
      return initial;
    } else if (!EvaluationVisitor.prototype.is_empty(param)) {
      return param;
    } else {
      return '';
    }
  };

  CoalesceNode.prototype.visit = function(visitor) {
    return this.visit_func('', visitor);
  };

  return CoalesceNode;

})(FuncNode);

IndexNode = (function(superClass) {
  extend(IndexNode, superClass);

  IndexNode.prototype.type = 'index';

  function IndexNode(id, index1) {
    this.id = id;
    this.index = index1;
  }

  IndexNode.prototype.parse = function(info) {
    return new IndexNode(info.id, info.index);
  };

  return IndexNode;

})(LogicNode);

AttrNode = (function(superClass) {
  extend(AttrNode, superClass);

  AttrNode.prototype.type = 'attr';

  function AttrNode(id, attr) {
    this.id = id;
    this.attr = attr;
  }

  AttrNode.prototype.parse = function(info) {
    return new AttrNode(info.id, info.attr);
  };

  return AttrNode;

})(LogicNode);

IdentifierNode = (function(superClass) {
  extend(IdentifierNode, superClass);

  IdentifierNode.prototype.type = 'id';

  function IdentifierNode(value1) {
    this.value = value1;
  }

  IdentifierNode.prototype.parse = function(info) {
    return new IdentifierNode(info.value);
  };

  return IdentifierNode;

})(LogicNode);

ConstNode = (function(superClass) {
  extend(ConstNode, superClass);

  ConstNode.prototype.type = 'const';

  function ConstNode(value1) {
    this.value = value1;
  }

  ConstNode.prototype.parse = function(info) {
    return new ConstNode(info.value);
  };

  return ConstNode;

})(LogicNode);

PredicateNode = (function(superClass) {
  extend(PredicateNode, superClass);

  PredicateNode.prototype.type = 'predicate';

  function PredicateNode(variable1, predicate, options) {
    this.variable = variable1;
    this.predicate = predicate;
    this.options = options != null ? options : {};
    this.value = this.options.value;
  }

  PredicateNode.prototype.getVariable = function(survey) {
    return survey.resolveVariable(this.variable);
  };

  return PredicateNode;

})(LogicNode);

LogicVisitor = (function() {
  function LogicVisitor() {}


  /*
  	Superclass for logic visitors. Calling visitor.visit(node) will
  	start a recursive tree walk which can be customized for LogicNode
  	subclasses by implementing visitNode_<type>.
   */

  LogicVisitor.prototype.visit = function() {
    var args, node, type;
    node = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    type = node.constructor;
    while (type !== LogicNode) {
      if (this["visitNode_" + type.prototype.type]) {
        return this["visitNode_" + type.prototype.type].apply(this, [node].concat(slice.call(args)));
      }
      type = type.__super__.constructor;
    }
    return this.visitNode.apply(this, [node].concat(slice.call(args)));
  };

  LogicVisitor.prototype.visitNode = function(node) {
    return node;
  };

  return LogicVisitor;

})();

SimplifyVisitor = (function(superClass) {
  extend(SimplifyVisitor, superClass);

  function SimplifyVisitor() {
    return SimplifyVisitor.__super__.constructor.apply(this, arguments);
  }


  /*
  	Visitor which performs basic logic simplification:
  
  	* removes nested connectives of the same type
  	* (FIXME) reduces predicates using isoneof
  
  	TODO: add a Boolean SAT solver for ultimate nerd points.
   */

  SimplifyVisitor.prototype.simplify = function(node) {
    node = this.visit(node, 1);
    return node;
  };

  SimplifyVisitor.prototype.visitNode_connective = function(node, state) {
    var el, item, items, j, len, ref2;
    node.items = (function() {
      var j, len, ref2, results;
      ref2 = node.items;
      results = [];
      for (j = 0, len = ref2.length; j < len; j++) {
        item = ref2[j];
        results.push(this.visit(item, state));
      }
      return results;
    }).call(this);
    if (state === 1) {
      items = [];
      ref2 = node.items;
      for (j = 0, len = ref2.length; j < len; j++) {
        item = ref2[j];
        if (item instanceof ConnectiveNode && item.type === node.type && !item.negated) {
          items = items.concat(item.items);
        } else {
          items.push(item);
        }
      }
      node.items = items;
    } else if (state === 2) {
      if (node.items.length >= 2 && node.type === 'or' && _.all(node.items, function(el) {
        return el.predicate === 'contains' && el.variable === node.items[0].variable;
      })) {
        node.items = [
          new PredicateNode(node.items[0].variable, 'containsoneof', {
            value: (function() {
              var k, len1, ref3, results;
              ref3 = node.items;
              results = [];
              for (k = 0, len1 = ref3.length; k < len1; k++) {
                el = ref3[k];
                results.push(el.value);
              }
              return results;
            })()
          })
        ];
      }
    } else if (state === 3) {
      if (node.items.length >= 2 && node.type === 'or' && _.all(node.items, function(el) {
        return el.predicate === 'equals' && el.variable === node.items[0].variable;
      })) {
        node.items = [
          new PredicateNode(node.items[0].variable, 'isoneof', {
            value: (function() {
              var k, len1, ref3, results;
              ref3 = node.items;
              results = [];
              for (k = 0, len1 = ref3.length; k < len1; k++) {
                el = ref3[k];
                results.push(el.value);
              }
              return results;
            })()
          })
        ];
      }
    }
    return node;
  };

  return SimplifyVisitor;

})(LogicVisitor);

ValidationVisitor = (function(superClass) {
  extend(ValidationVisitor, superClass);


  /*
  	Logic visitor which validates all survey object references.
  
  	Note that this visitor will also update certain types of predicates (in
  	particular, yes/no) since we have the survey at this point and can figure
  	out variable types.
   */

  function ValidationVisitor(survey1) {
    this.survey = survey1;
  }

  ValidationVisitor.prototype.visitNode_connective = function(node) {
    return _.all(node.items, (function(_this) {
      return function(item) {
        return _this.visit(item);
      };
    })(this));
  };

  ValidationVisitor.prototype.visitNode_predicate = function(node) {
    var variable;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return false;
    }
    if (variable.type === 'boolean' && node.predicate === 'equals') {
      if (node.options.value === '0') {
        node.predicate = 'yes';
      } else {
        node.predicate = 'no';
      }
      delete node.options.value;
    }
    return true;
  };

  return ValidationVisitor;

})(LogicVisitor);

JSONVisitor = (function(superClass) {
  extend(JSONVisitor, superClass);


  /*
  	Visitor which serializes logic into JSON.
   */

  function JSONVisitor(survey1) {
    this.survey = survey1;
  }

  JSONVisitor.prototype.visitNode_connective = function(node) {
    var item, result;
    result = {
      type: node.type,
      items: (function() {
        var j, len, ref2, results;
        ref2 = node.items;
        results = [];
        for (j = 0, len = ref2.length; j < len; j++) {
          item = ref2[j];
          results.push(this.visit(item));
        }
        return results;
      }).call(this)
    };
    if (node.negated) {
      result.negated = true;
    }
    return result;
  };

  JSONVisitor.prototype.visitNode_predicate = function(node) {
    return {
      type: node.type,
      predicate: node.predicate,
      variable: node.getVariable(this.survey).id,
      value: node.value
    };
  };

  return JSONVisitor;

})(LogicVisitor);

FormatVisitor = (function(superClass) {
  extend(FormatVisitor, superClass);


  /*
  	Visitor which formats the logic into a human-readable expression. Accepts
  	a config parameter with the following options:
  
  	truncate: <int> | <bool>
   */

  function FormatVisitor(survey1, config) {
    this.survey = survey1;
    this.config = config != null ? config : {};
    this.predicates = 0;
  }

  FormatVisitor.prototype.format = function(node) {
    var length, result;
    result = this.visit(node);
    if (this.config.truncate !== false) {
      length = _.isNumber(this.config.truncate) ? this.config.truncate : 100;
      if (result.length > length) {
        result = result.substring(0, length) + ("... [" + this.predicates + " " + (gettext('predicates')) + "]");
      }
    }
    return result;
  };

  FormatVisitor.prototype.varLabel = function(variable) {

    /*
    		Returns a string suitable for identifiying the given variable. Note
    		that the argument can either be a Variable instance (in offline mode)
    		or an object parsed from server-returned JSON.
     */
    if (_.isString(variable.label)) {
      return variable.label;
    } else {
      return variable.toString();
    }
  };

  FormatVisitor.prototype.choiceLabel = function(variable, choice) {

    /*
    		Returns the label for a variable choice. This is a bit hacky in order
    		to support variables from either formatInfo() in the editor or from offline.
     */
    var choices;
    choices = _.isFunction(variable.choices) ? variable.choices() : variable.choices;
    choice = choices[parseInt(choice, 10)];
    if (_.isString(choice)) {
      return choice;
    } else if (choice != null) {
      return choice.label();
    } else {
      return '-';
    }
  };

  FormatVisitor.prototype.visitNode_connective = function(node, nest) {
    var child, expr, j, len, ref2, result;
    if (nest == null) {
      nest = true;
    }
    if (nest) {
      result = (function() {
        var j, len, ref2, results;
        ref2 = node.items;
        results = [];
        for (j = 0, len = ref2.length; j < len; j++) {
          child = ref2[j];
          expr = this.visit(child, true);
          if (child instanceof ConnectiveNode) {
            expr = "(" + expr + ")";
          }
          results.push(expr);
        }
        return results;
      }).call(this);
      result = result.join(" " + (node.type.toUpperCase()) + " ");
      if (node.negated) {
        result = "not (" + result + ")";
      }
      return result;
    }
    result = (function() {
      switch (node.type) {
        case 'and':
          if (node.negated) {
            return "not all";
          } else {
            return "all";
          }
        case 'or':
          if (node.negated) {
            return "none";
          } else {
            return "any";
          }
      }
    })();
    result = result + " of the following:";
    ref2 = node.items;
    for (j = 0, len = ref2.length; j < len; j++) {
      child = ref2[j];
      result += "\n- " + (this.visit(child, true));
    }
    return result;
  };

  FormatVisitor.prototype.visitNode_predicate = function(node) {
    var variable;
    this.predicates++;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return "[" + node.variable + "]";
    }
    if (this["visit_" + node.predicate + "_" + variable.type] != null) {
      return this["visit_" + node.predicate + "_" + variable.type](variable, node.value);
    } else if (this["visit_" + node.predicate] != null) {
      return this["visit_" + node.predicate](variable, node.value);
    } else {
      throw new Error("predicate '" + node.predicate + "' not implemented for type '" + variable.type + "'");
    }
  };

  FormatVisitor.prototype.visit_noresponse = function(left) {
    return (this.varLabel(left)) + " has no response";
  };

  FormatVisitor.prototype.visit_hasresponse = function(left) {
    return (this.varLabel(left)) + " has a response";
  };

  FormatVisitor.prototype.visit_yes_boolean = function(left) {
    return (this.varLabel(left)) + " is yes";
  };

  FormatVisitor.prototype.visit_no_boolean = function(left) {
    return (this.varLabel(left)) + " is no";
  };

  FormatVisitor.prototype.visit_equals = function(left, right) {
    return (this.varLabel(left)) + " = \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_notequals = function(left, right) {
    return (this.varLabel(left)) + " != \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_equals_boolean = function(left, right) {
    return (this.varLabel(left)) + " is " + (right === '0' ? 'yes' : 'no');
  };

  FormatVisitor.prototype.visit_equals_single = function(left, right) {
    return (this.varLabel(left)) + " = \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_contains_string = function(left, right) {
    return (this.varLabel(left)) + " contains \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_contains_multi = function(left, right) {
    return (this.varLabel(left)) + " contains \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_containsoneof_multi = function(left, right) {
    return (this.varLabel(left)) + " contains one of \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_notcontainsoneof_multi = function(left, right) {
    return (this.varLabel(left)) + " does not contain any of \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_numberselected_multi = function(left, right) {
    return (this.varLabel(left)) + " has " + (parseInt(right, 10)) + " selected";
  };

  FormatVisitor.prototype.visit_isoneof_single = function(left, right) {
    var el;
    return (this.varLabel(left)) + " is one of [" + (((function() {
      var j, len, results;
      results = [];
      for (j = 0, len = right.length; j < len; j++) {
        el = right[j];
        results.push('"' + this.choiceLabel(left, el) + '"');
      }
      return results;
    }).call(this)).join(', ')) + "]";
  };

  FormatVisitor.prototype.visit_notisoneof_single = function(left, right) {
    var el;
    return (this.varLabel(left)) + " is not one of [" + (((function() {
      var j, len, results;
      results = [];
      for (j = 0, len = right.length; j < len; j++) {
        el = right[j];
        results.push('"' + this.choiceLabel(left, el) + '"');
      }
      return results;
    }).call(this)).join(', ')) + "]";
  };

  FormatVisitor.prototype.visit_greaterthan_string = function(left, right) {
    return (this.varLabel(left)) + " > " + right;
  };

  FormatVisitor.prototype.visit_lessthan_string = function(left, right) {
    return (this.varLabel(left)) + " < " + right;
  };

  FormatVisitor.prototype.visit_after_datetime = function(left, right) {
    return (this.varLabel(left)) + " is after " + right;
  };

  FormatVisitor.prototype.visit_before_datetime = function(left, right) {
    return (this.varLabel(left)) + " is before " + right;
  };

  return FormatVisitor;

})(LogicVisitor);

EvaluationVisitor = (function(superClass) {
  extend(EvaluationVisitor, superClass);


  /*
  	Evaluates the logic node with a given handler.
  
  	Predicates are specialized by implementing visit_<predicate> (which implements
  	a default for all variable types) and/or visit_<predicate>_<type> (for specific
  	predicate/variable type pairs).
   */

  function EvaluationVisitor(handler1) {
    this.handler = handler1;
    if (this.handler) {
      this.context = this.handler.buildContext();
      this.survey = this.handler.survey;
      this.response = this.handler.response;
    }
  }

  EvaluationVisitor.prototype.visitNode_connective = function(node) {
    var child, result;
    result = node.evaluator((function() {
      var j, len, ref2, results;
      ref2 = node.items;
      results = [];
      for (j = 0, len = ref2.length; j < len; j++) {
        child = ref2[j];
        results.push(this.visit(child));
      }
      return results;
    }).call(this), function(el) {
      return !!el;
    });
    if (node.negated) {
      result = !result;
    }
    return result;
  };

  EvaluationVisitor.prototype.visitNode_predicate = function(node) {
    var result, value, variable;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return false;
    }
    value = this.response.values[variable.id];
    if (this["visit_" + node.predicate + "_" + variable.type] != null) {
      result = this["visit_" + node.predicate + "_" + variable.type](value, node.value, node.options);
      return result;
    } else if (this["visit_" + node.predicate] != null) {
      result = this["visit_" + node.predicate](value, node.value, node.options);
      return result;
    } else {
      throw new Error("predicate '" + node.predicate + "' not implemented for type '" + variable.type + "'");
    }
  };

  EvaluationVisitor.prototype.visitNode_id = function(node) {
    return this.context[node.value];
  };

  EvaluationVisitor.prototype.visitNode_const = function(node) {
    return node.value;
  };

  EvaluationVisitor.prototype.visitNode_index = function(node) {
    return this.visit(node.id).variables[parseInt(this.visit(node.index))];
  };

  EvaluationVisitor.prototype.visitNode_attr = function(node) {
    var name, ref, ref2;
    ref = this.visit(node.id);
    return (ref2 = typeof ref[name = node.attr.value] === "function" ? ref[name]() : void 0) != null ? ref2 : '';
  };

  EvaluationVisitor.prototype.convert_float = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseFloat(num);
    }
  };

  EvaluationVisitor.prototype.convert_float_tofixed_two = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseFloat(num).toFixed(2);
    }
  };

  EvaluationVisitor.prototype.convert_int = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseInt(num);
    }
  };

  EvaluationVisitor.prototype.is_empty = function(value) {
    return value === 'None' || value === null || value === void 0 || value === '' || (value instanceof Object ? (new trans(value)).toString() === '' : void 0);
  };

  EvaluationVisitor.prototype.visitNode_array = function(node) {
    var end, ref, start;
    ref = this.visit(node.id);
    if (node.start != null) {
      start = this.visit(node.start);
    }
    if (node.end != null) {
      end = this.visit(node.end);
    }
    if ((start != null) && (end != null)) {
      return ref.slice(start, end);
    } else if (start != null) {
      return ref.row(start);
    } else if (end != null) {
      return ref.col(end);
    } else {
      return ref;
    }
  };

  EvaluationVisitor.prototype.visit_binary = function(func, node) {
    var left, ref2, ref3, right;
    left = this.visit(node.left);
    right = this.visit(node.right);
    return func(((ref2 = typeof left.value === "function" ? left.value() : void 0) != null ? ref2 : left) || 0, ((ref3 = typeof right.value === "function" ? right.value() : void 0) != null ? ref3 : right) || 0);
  };

  EvaluationVisitor.prototype.visitNode_plus = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) + EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_minus = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) - EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_times = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) * EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_divide = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) / EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_func = function(node) {
    return node.visit(this);
  };

  EvaluationVisitor.prototype.visitNode_expr_equals = function(node) {
    return this.visit_binary((function(left, right) {
      return left.toString() === right.toString();
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_notequals = function(node) {
    return this.visit_binary((function(left, right) {
      return left.toString() !== right.toString();
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_greaterthan = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) > EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() > right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_lessthan = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) < EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() < right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_greaterequals = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) >= EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() >= right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_lessequals = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) <= EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() <= right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.convert_integer = function(value) {
    var item, j, len, new_list;
    if (value instanceof Array) {
      new_list = [];
      for (j = 0, len = value.length; j < len; j++) {
        item = value[j];
        if (typeof item === 'string') {
          new_list.push(parseInt(item, 10));
        } else {
          new_list.push(item);
        }
      }
      return new_list;
    } else {
      if (typeof value === 'string') {
        return parseInt(value, 10);
      }
    }
  };

  EvaluationVisitor.prototype.visit_noresponse = function(value) {
    return value == null;
  };

  EvaluationVisitor.prototype.visit_noresponse_string = function(value) {
    return !(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_noresponse_multi = function(value) {
    return !(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_nofile = function(value) {
    return value == null;
  };

  EvaluationVisitor.prototype.visit_hasresponse = function(value) {
    return value != null;
  };

  EvaluationVisitor.prototype.visit_hasresponse_multi = function(value) {
    return !!(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_hasfile = function(value) {
    return value != null;
  };

  EvaluationVisitor.prototype.visit_yes_boolean = function(value) {
    return value === true;
  };

  EvaluationVisitor.prototype.visit_no_boolean = function(value) {
    return value === false;
  };

  EvaluationVisitor.prototype.visit_equals = function(left, right) {
    return left === right;
  };

  EvaluationVisitor.prototype.visit_notequals = function(left, right) {
    return left !== right;
  };

  EvaluationVisitor.prototype.visit_equals_boolean = function(left, right) {
    return left === (right === "0" || right === 0);
  };

  EvaluationVisitor.prototype.visit_equals_single = function(left, right) {
    return left === parseInt(right, 10);
  };

  EvaluationVisitor.prototype.visit_equals_multi = function(left, right) {
    var i, j, len, ref2;
    left = left != null ? left : [];
    right = right != null ? right : [];
    if (left.length === right.length) {
      right = this.convert_integer(right);
      ref2 = [0, left.length];
      for (j = 0, len = ref2.length; j < len; j++) {
        i = ref2[j];
        if (left[i] !== right[i]) {
          false;
        }
      }
      return true;
    } else {
      return false;
    }
  };

  EvaluationVisitor.prototype.visit_contains_string = function(left, right) {
    return (left != null) && left.indexOf(right) >= 0;
  };

  EvaluationVisitor.prototype.visit_contains_multi = function(left, right) {
    return (left != null) && left.indexOf(parseInt(right, 10)) >= 0;
  };

  EvaluationVisitor.prototype.visit_containsoneof_multi = function(left, right) {
    var intersection;
    right = this.convert_integer(right != null ? right : []);
    intersection = (left != null ? left : []).filter(function(n) {
      if ((right.indexOf(n)) === -1) {
        return false;
      }
      return true;
    });
    return intersection.length > 0;
  };

  EvaluationVisitor.prototype.visit_notcontainsoneof_multi = function(left, right) {
    var intersection;
    right = this.convert_integer(right != null ? right : []);
    intersection = (left != null ? left : []).filter(function(n) {
      if ((right.indexOf(n)) === -1) {
        return false;
      }
      return true;
    });
    return intersection.length === 0;
  };

  EvaluationVisitor.prototype.visit_numberselected_multi = function(left, right) {
    return (left != null ? left : []).length === parseInt(right, 10);
  };

  EvaluationVisitor.prototype.visit_isoneof_single = function(left, right) {
    right = this.convert_integer(right != null ? right : []);
    return (right != null ? right : []).indexOf(left) >= 0;
  };

  EvaluationVisitor.prototype.visit_notisoneof_single = function(left, right) {
    right = this.convert_integer(right != null ? right : []);
    return (right != null ? right : []).indexOf(left) === -1;
  };

  EvaluationVisitor.prototype.visit_greaterthan_string = function(left, right) {
    return parseFloat(left, 10) > parseFloat(right, 10);
  };

  EvaluationVisitor.prototype.visit_lessthan_string = function(left, right) {
    return parseFloat(left, 10) < parseFloat(right, 10);
  };

  EvaluationVisitor.prototype.visit_after_datetime = function(left, right) {
    return (left != null) && (right != null) && left > right;
  };

  EvaluationVisitor.prototype.visit_before_datetime = function(left, right) {
    return (left != null) && (right != null) && left < right;
  };

  return EvaluationVisitor;

})(LogicVisitor);

SurveyFinishException = (function(superClass) {
  extend(SurveyFinishException, superClass);

  function SurveyFinishException() {
    SurveyFinishException.__super__.constructor.apply(this, arguments);
  }

  return SurveyFinishException;

})(Error);

SurveyTerminateException = (function(superClass) {
  extend(SurveyTerminateException, superClass);

  function SurveyTerminateException() {
    SurveyTerminateException.__super__.constructor.apply(this, arguments);
  }

  return SurveyTerminateException;

})(Error);

SurveyRedirectException = (function(superClass) {
  extend(SurveyRedirectException, superClass);

  function SurveyRedirectException() {
    SurveyRedirectException.__super__.constructor.apply(this, arguments);
  }

  return SurveyRedirectException;

})(Error);

SurveyAction = (function() {
  function SurveyAction() {}

  SurveyAction.prototype.type = void 0;

  SurveyAction.prototype.label = void 0;


  /*
  	Whether this action is a branching action (i.e. final). If a rule has multiple actions, only
  	the first branching action applies.
   */

  SurveyAction.prototype.isBranch = false;


  /*
  	Whether this action has targets (hide/show/disable rules). These actions need to be handled
  	by their targets rather than the source page.
   */

  SurveyAction.prototype.hasTargets = false;

  SurveyAction.prototype.format = function(survey) {
    return this.label;
  };

  SurveyAction.prototype.validate = function(survey) {
    return true;
  };

  SurveyAction.prototype.serialize = function(survey) {
    return {
      type: this.type
    };
  };

  return SurveyAction;

})();

BranchAction = (function(superClass) {
  extend(BranchAction, superClass);

  function BranchAction() {
    return BranchAction.__super__.constructor.apply(this, arguments);
  }

  BranchAction.prototype.isBranch = true;

  return BranchAction;

})(SurveyAction);

PageBranchAction = (function(superClass) {
  extend(PageBranchAction, superClass);

  PageBranchAction.prototype.type = 'skip';

  PageBranchAction.prototype.label = gettext('skip to page');

  function PageBranchAction(page) {
    this.page = page;
  }

  PageBranchAction.prototype.apply = function(survey) {
    var ref2;
    return ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages)[this.page];
  };

  PageBranchAction.prototype.format = function(survey) {
    var ref2;
    return interpolate(gettext('skip to %(page)s'), {
      page: ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages)[this.page].page
    });
  };

  PageBranchAction.prototype.validate = function(survey) {
    var ref2;
    return this.page in ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages);
  };

  PageBranchAction.prototype.serialize = function(survey) {
    return _.extend(PageBranchAction.__super__.serialize.apply(this, arguments), {
      page: this.page
    });
  };

  return PageBranchAction;

})(BranchAction);

RedirectBranchAction = (function(superClass) {
  extend(RedirectBranchAction, superClass);

  RedirectBranchAction.prototype.type = 'redirect';

  RedirectBranchAction.prototype.label = gettext('redirect to a URL');

  function RedirectBranchAction(url) {
    this.url = url;
  }

  RedirectBranchAction.prototype.apply = function(survey) {};

  RedirectBranchAction.prototype.format = function(survey) {
    return interpolate(gettext('redirect to %(url)s'), {
      url: this.url
    });
  };

  RedirectBranchAction.prototype.serialize = function() {
    return _.extend(RedirectBranchAction.__super__.serialize.apply(this, arguments), {
      url: this.url
    });
  };

  return RedirectBranchAction;

})(BranchAction);

ContinueAction = (function(superClass) {
  extend(ContinueAction, superClass);

  function ContinueAction() {
    return ContinueAction.__super__.constructor.apply(this, arguments);
  }

  ContinueAction.prototype.type = 'continue';

  ContinueAction.prototype.label = gettext('skip to the next loop iteration');

  return ContinueAction;

})(BranchAction);

RandomBranchAction = (function(superClass) {
  extend(RandomBranchAction, superClass);

  RandomBranchAction.prototype.type = 'random';

  RandomBranchAction.prototype.label = gettext('skip to a random page');

  RandomBranchAction.prototype.format = function(survey) {
    return interpolate(gettext('skip to %(pages)s'), {
      pages: this.pages
    });
  };

  function RandomBranchAction(pages) {
    this.pages = pages;
  }

  RandomBranchAction.prototype.validate = function(survey) {
    return _.all(this.pages.split(','), function(n) {
      return parseFloat(n) && isFinite(n) && n < survey.pages.length;
    });
  };

  RandomBranchAction.prototype.serialize = function() {
    return {
      pages: this.pages,
      type: this.type
    };
  };

  return RandomBranchAction;

})(PageBranchAction);

RandomRangeAction = (function(superClass) {
  extend(RandomRangeAction, superClass);

  RandomRangeAction.prototype.type = 'random-range';

  RandomRangeAction.prototype.label = gettext('randomly traverse a page range');

  function RandomRangeAction(pages, after) {
    this.pages = pages;
    this.after = after;
  }

  RandomRangeAction.prototype.serialize = function() {
    return _.extend(RandomRangeAction.__super__.serialize.apply(this, arguments), {
      pages: this.pages,
      after: this.after
    });
  };

  return RandomRangeAction;

})(BranchAction);

TargetAction = (function(superClass) {
  extend(TargetAction, superClass);

  TargetAction.prototype.hasTargets = true;

  TargetAction.prototype.ROW_RE = /^([-a-zA-Z0-9]+)\[(.+?):\]$/;

  TargetAction.prototype.COLUMN_RE = /^([-a-zA-Z0-9]+)\[:(.+?)\]$/;

  function TargetAction(target1, exclude) {
    var match;
    this.target = target1;
    this.exclude = exclude;
    if ((match = this.ROW_RE.exec(this.target)) != null) {
      this.target = match[1];
      this.row = parseInt(match[2], 10);
    } else if ((match = this.COLUMN_RE.exec(this.target)) != null) {
      this.target = match[1];
      this.column = parseInt(match[2], 10);
    }
  }

  TargetAction.prototype.getElSelector = function() {
    if (this.row != null) {
      return ".x_" + (escapeSelector(this.target)) + "_" + this.row;
    } else if (this.column != null) {
      return ".x_" + (escapeSelector(this.target)) + "__" + this.column;
    } else {
      return "#x_" + (escapeSelector(this.target));
    }
  };

  TargetAction.prototype.getTargetId = function() {
    if (this.row != null) {
      return this.target + "[" + this.row + ":]";
    } else if (this.column != null) {
      return this.target + "[:" + this.column + "]";
    } else {
      return this.target;
    }
  };

  TargetAction.prototype.getTargetLabel = function(survey) {
    var question;
    question = survey.questions[this.target];
    if ((this.row != null) && ((question != null ? question.rows : void 0) != null)) {
      return question.rows[this.row].text;
    } else if ((this.column != null) && ((question != null ? question.types : void 0) != null)) {
      return question.types[this.column].text;
    } else if (question != null) {
      return question.label;
    } else if (this.target in survey.variables) {
      return survey.variables[this.target].label;
    }
  };

  TargetAction.prototype.apply = function(matches, el) {};

  TargetAction.prototype.validate = function(survey) {
    return this.getTargetLabel(survey) != null;
  };

  TargetAction.prototype.serialize = function() {
    return _.extend(TargetAction.__super__.serialize.apply(this, arguments), {
      target: this.getTargetId()
    });
  };

  return TargetAction;

})(SurveyAction);

FinishBranchAction = (function(superClass) {
  extend(FinishBranchAction, superClass);

  function FinishBranchAction() {
    return FinishBranchAction.__super__.constructor.apply(this, arguments);
  }

  FinishBranchAction.prototype.type = 'finish';

  FinishBranchAction.prototype.label = gettext('complete the form');

  FinishBranchAction.prototype.apply = function(survey) {
    throw new SurveyFinishException();
  };

  return FinishBranchAction;

})(BranchAction);

TerminateBranchAction = (function(superClass) {
  extend(TerminateBranchAction, superClass);

  function TerminateBranchAction() {
    return TerminateBranchAction.__super__.constructor.apply(this, arguments);
  }

  TerminateBranchAction.prototype.type = 'terminate';

  TerminateBranchAction.prototype.label = gettext('terminate the form');

  TerminateBranchAction.prototype.apply = function(survey) {
    throw new SurveyTerminateException();
  };

  return TerminateBranchAction;

})(BranchAction);

HideAction = (function(superClass) {
  extend(HideAction, superClass);

  function HideAction() {
    return HideAction.__super__.constructor.apply(this, arguments);
  }

  HideAction.prototype.type = 'hide';

  HideAction.prototype.label = gettext('hide a question');

  HideAction.prototype.apply = function(matches, el) {
    if (matches) {
      return el.find(this.getElSelector()).addClass('hidden');
    } else {
      return el.find(this.getElSelector()).removeClass('hidden');
    }
  };

  HideAction.prototype.format = function(survey) {
    return interpolate(gettext('hide %(target)s'), {
      target: this.getTargetLabel(survey)
    });
  };

  return HideAction;

})(TargetAction);

ShowAction = (function(superClass) {
  extend(ShowAction, superClass);

  function ShowAction() {
    return ShowAction.__super__.constructor.apply(this, arguments);
  }

  ShowAction.prototype.type = 'show';

  ShowAction.prototype.label = gettext('show a question');

  ShowAction.prototype.apply = function(matches, el) {
    if (matches) {
      return el.find(this.getElSelector()).removeClass('hidden');
    } else {
      return el.find(this.getElSelector()).addClass('hidden');
    }
  };

  ShowAction.prototype.format = function(survey) {
    return interpolate(gettext('show %(target)s'), {
      target: this.getTargetLabel(survey)
    });
  };

  return ShowAction;

})(TargetAction);

DisableAction = (function(superClass) {
  extend(DisableAction, superClass);

  function DisableAction() {
    return DisableAction.__super__.constructor.apply(this, arguments);
  }

  DisableAction.prototype.type = 'disable';

  DisableAction.prototype.label = gettext('disable a question');

  DisableAction.prototype.apply = function(matches, el) {
    var inputs;
    inputs = el.find(this.getElSelector()).find(':input');
    if (this.exclude) {
      inputs = inputs.filter(":not([name=" + this.exclude + "])");
    }
    return inputs.prop('disabled', matches);
  };

  DisableAction.prototype.format = function(survey) {
    return interpolate(gettext('disable %(target)s'), {
      target: this.getTargetLabel(survey)
    });
  };

  return DisableAction;

})(TargetAction);

InvalidAction = (function(superClass) {
  extend(InvalidAction, superClass);

  InvalidAction.prototype.type = 'mark-invalid';

  InvalidAction.prototype.label = gettext('mark as an invalid question');

  function InvalidAction(target1, feedback) {
    this.target = target1;
    this.feedback = feedback;
    InvalidAction.__super__.constructor.call(this, this.target);
  }

  InvalidAction.prototype.format = function(survey) {
    return interpolate(gettext('mark %(target)s as an invalid question'), {
      target: this.getTargetLabel(survey)
    });
  };

  InvalidAction.prototype.serialize = function() {
    return _.extend(InvalidAction.__super__.serialize.apply(this, arguments), {
      feedback: this.feedback
    });
  };

  return InvalidAction;

})(TargetAction);

HidePageAction = (function(superClass) {
  extend(HidePageAction, superClass);

  HidePageAction.prototype.type = 'hide-page';

  HidePageAction.prototype.label = gettext('hide a page');

  function HidePageAction(page) {
    this.page = page;
  }

  HidePageAction.prototype.getPage = function(survey) {
    var ref2;
    return ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages)[this.page];
  };

  HidePageAction.prototype.format = function(survey) {
    var ref2;
    return interpolate(gettext('hide page %(page)s'), {
      page: ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages)[this.page].page
    });
  };

  HidePageAction.prototype.validate = function(survey) {
    var ref2;
    return this.page in ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages);
  };

  HidePageAction.prototype.serialize = function(survey) {
    return _.extend(HidePageAction.__super__.serialize.apply(this, arguments), {
      page: this.page
    });
  };

  return HidePageAction;

})(SurveyAction);

MarkCompleteAction = (function(superClass) {
  extend(MarkCompleteAction, superClass);

  function MarkCompleteAction() {
    return MarkCompleteAction.__super__.constructor.apply(this, arguments);
  }

  MarkCompleteAction.prototype.type = 'mark-complete';

  MarkCompleteAction.prototype.label = gettext('mark the response as completed');

  return MarkCompleteAction;

})(SurveyAction);

EmailAction = (function(superClass) {
  extend(EmailAction, superClass);

  EmailAction.prototype.type = 'email';

  EmailAction.prototype.label = gettext('send an email');

  function EmailAction(settings) {
    this.settings = settings;
  }

  EmailAction.prototype.serialize = function() {
    return _.extend(EmailAction.__super__.serialize.apply(this, arguments), this.settings);
  };

  return EmailAction;

})(SurveyAction);

SurveyAction.TYPES = {};

ref2 = [TargetAction, PageBranchAction, FinishBranchAction, TerminateBranchAction, RedirectBranchAction, ContinueAction, RandomBranchAction, RandomRangeAction, HideAction, ShowAction, DisableAction, InvalidAction, HidePageAction, MarkCompleteAction, EmailAction];
for (j = 0, len = ref2.length; j < len; j++) {
  cls = ref2[j];
  SurveyAction.TYPES[cls.prototype.type] = cls;
}

BranchingRule = (function() {
  function BranchingRule() {
    var actions1, condition1;
    condition1 = arguments[0], actions1 = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    this.condition = condition1;
    this.actions = actions1;
  }

  BranchingRule.prototype.parseAction = function(info) {
    var ref10, ref11, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    switch ((ref3 = info.type) != null ? ref3 : info.skip) {
      case 'mark-complete':
        return new MarkCompleteAction();
      case 'redirect':
        return new RedirectBranchAction((ref4 = info.url) != null ? ref4 : info.redirect);
      case 'hide':
        return new HideAction((ref5 = info.target) != null ? ref5 : info.hideQuestion);
      case 'show':
        return new ShowAction((ref6 = info.target) != null ? ref6 : info.showQuestion);
      case 'disable':
        return new DisableAction((ref7 = info.target) != null ? ref7 : info.disableVariable);
      case 'mark-invalid':
        return new InvalidAction(info.target, info.feedback);
      case 'hide-page':
        return new HidePageAction(info.page);
      case 'finish':
        return new FinishBranchAction();
      case 'terminate':
        return new TerminateBranchAction();
      case 'random':
        return new RandomBranchAction((ref8 = info.pages) != null ? ref8 : info.pageRange);
      case 'random-range':
        return new RandomRangeAction((ref9 = info.pages) != null ? ref9 : info.pageRange, (ref10 = info.after) != null ? ref10 : info.skipToPage);
      case 'email':
        return new EmailAction((ref11 = info.emailsettings) != null ? ref11 : info);
      case 'skip':
        return new PageBranchAction(info.page);
      case 'continue':
        return new ContinueAction();
      default:
        return new PageBranchAction(info.skip);
    }
  };

  BranchingRule.prototype.parse = function(info) {
    var action, actions, condition;
    condition = LogicNode.prototype.parse(info.condition).simplify();
    if (info.skip != null) {
      actions = [BranchingRule.prototype.parseAction(info)];
    } else if (info.action != null) {
      actions = [BranchingRule.prototype.parseAction(info.action)];
    } else if (info.actions != null) {
      actions = (function() {
        var k, len1, ref3, results;
        ref3 = info.actions;
        results = [];
        for (k = 0, len1 = ref3.length; k < len1; k++) {
          action = ref3[k];
          results.push(BranchingRule.prototype.parseAction(action));
        }
        return results;
      })();
    } else {
      return null;
    }
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(BranchingRule, [condition].concat(slice.call(actions)), function(){});
  };

  BranchingRule.prototype.validate = function(survey) {
    return this.condition.validate(survey) && _.all(this.actions, function(action) {
      return action.validate(survey);
    });
  };

  BranchingRule.prototype.format = function(survey) {
    var action, actions;
    actions = ((function() {
      var k, len1, ref3, results;
      ref3 = this.actions;
      results = [];
      for (k = 0, len1 = ref3.length; k < len1; k++) {
        action = ref3[k];
        results.push(action.format(survey));
      }
      return results;
    }).call(this)).join(', ');
    return "If " + (this.condition.format(survey)) + " then " + actions;
  };

  BranchingRule.prototype.serialize = function(survey) {
    var action, result;
    result = {
      condition: this.condition.serialize(survey)
    };
    if (this.actions.length === 1) {
      result.action = this.actions[0].serialize(survey);
    } else {
      result.actions = (function() {
        var k, len1, ref3, results;
        ref3 = this.actions;
        results = [];
        for (k = 0, len1 = ref3.length; k < len1; k++) {
          action = ref3[k];
          results.push(action.serialize(survey));
        }
        return results;
      }).call(this);
    }
    return result;
  };

  BranchingRule.prototype.parseSimple = function(question, rules) {
    var action, condition, k, len1, ref3, results, rule;
    ref3 = rules != null ? rules : [];
    results = [];
    for (k = 0, len1 = ref3.length; k < len1; k++) {
      rule = ref3[k];
      condition = new PredicateNode(question.id, 'equals', {
        value: rule.val
      });
      action = (function() {
        switch (rule.page) {
          case 'finish':
            return new FinishBranchAction();
          case 'terminate':
            return new TerminateBranchAction();
          default:
            return new PageBranchAction(rule.page);
        }
      })();
      results.push(new BranchingRule(condition, action));
    }
    return results;
  };

  return BranchingRule;

})();

_.extend(exports, {
  LogicNode: LogicNode,
  OrNode: OrNode,
  PredicateNode: PredicateNode,
  SurveyFinishException: SurveyFinishException,
  SurveyTerminateException: SurveyTerminateException,
  SurveyRedirectException: SurveyRedirectException,
  SurveyAction: SurveyAction,
  EvaluationVisitor: EvaluationVisitor,
  DisableAction: DisableAction,
  BranchingRule: BranchingRule,
  InvalidAction: InvalidAction,
  HidePageAction: HidePageAction,
  ExprNode: ExprNode,
  CompareNode: CompareNode,
  ConnectiveNode: ConnectiveNode,
  ArrayNode: ArrayNode,
  FuncNode: FuncNode,
  IndexNode: IndexNode,
  AttrNode: AttrNode,
  IdentifierNode: IdentifierNode,
  ConstNode: ConstNode
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)(module)))

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(924);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(204);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__ = __webpack_require__(1858);



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__["a" /* default */]);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFlatten);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function(){function n(n){function t(t,r,e,u,i,o){for(;i>=0&&o>i;i+=n){var a=u?u[i]:i;e=r(e,t[a],a,t)}return e}return function(r,e,u,i){e=b(e,i,4);var o=!k(r)&&m.keys(r),a=(o||r).length,c=n>0?0:a-1;return arguments.length<3&&(u=r[o?o[c]:c],c+=n),t(r,e,u,o,c,a)}}function t(n){return function(t,r,e){r=x(r,e);for(var u=O(t),i=n>0?0:u-1;i>=0&&u>i;i+=n)if(r(t[i],i,t))return i;return-1}}function r(n,t,r){return function(e,u,i){var o=0,a=O(e);if("number"==typeof i)n>0?o=i>=0?i:Math.max(i+a,o):a=i>=0?Math.min(i+1,a):i+a+1;else if(r&&i&&a)return i=r(e,u),e[i]===u?i:-1;if(u!==u)return i=t(l.call(e,o,a),m.isNaN),i>=0?i+o:-1;for(i=n>0?o:a-1;i>=0&&a>i;i+=n)if(e[i]===u)return i;return-1}}function e(n,t){var r=I.length,e=n.constructor,u=m.isFunction(e)&&e.prototype||a,i="constructor";for(m.has(n,i)&&!m.contains(t,i)&&t.push(i);r--;)i=I[r],i in n&&n[i]!==u[i]&&!m.contains(t,i)&&t.push(i)}var u=this,i=u._,o=Array.prototype,a=Object.prototype,c=Function.prototype,f=o.push,l=o.slice,s=a.toString,p=a.hasOwnProperty,h=Array.isArray,v=Object.keys,g=c.bind,y=Object.create,d=function(){},m=function(n){return n instanceof m?n:this instanceof m?void(this._wrapped=n):new m(n)}; true?("undefined"!=typeof module&&module.exports&&(exports=module.exports=m),exports._=m):u._=m,m.VERSION="1.8.3";var b=function(n,t,r){if(t===void 0)return n;switch(null==r?3:r){case 1:return function(r){return n.call(t,r)};case 2:return function(r,e){return n.call(t,r,e)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,i){return n.call(t,r,e,u,i)}}return function(){return n.apply(t,arguments)}},x=function(n,t,r){return null==n?m.identity:m.isFunction(n)?b(n,t,r):m.isObject(n)?m.matcher(n):m.property(n)};m.iteratee=function(n,t){return x(n,t,1/0)};var _=function(n,t){return function(r){var e=arguments.length;if(2>e||null==r)return r;for(var u=1;e>u;u++)for(var i=arguments[u],o=n(i),a=o.length,c=0;a>c;c++){var f=o[c];t&&r[f]!==void 0||(r[f]=i[f])}return r}},j=function(n){if(!m.isObject(n))return{};if(y)return y(n);d.prototype=n;var t=new d;return d.prototype=null,t},w=function(n){return function(t){return null==t?void 0:t[n]}},A=Math.pow(2,53)-1,O=w("length"),k=function(n){var t=O(n);return"number"==typeof t&&t>=0&&A>=t};m.each=m.forEach=function(n,t,r){t=b(t,r);var e,u;if(k(n))for(e=0,u=n.length;u>e;e++)t(n[e],e,n);else{var i=m.keys(n);for(e=0,u=i.length;u>e;e++)t(n[i[e]],i[e],n)}return n},m.map=m.collect=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=Array(u),o=0;u>o;o++){var a=e?e[o]:o;i[o]=t(n[a],a,n)}return i},m.reduce=m.foldl=m.inject=n(1),m.reduceRight=m.foldr=n(-1),m.find=m.detect=function(n,t,r){var e;return e=k(n)?m.findIndex(n,t,r):m.findKey(n,t,r),e!==void 0&&e!==-1?n[e]:void 0},m.filter=m.select=function(n,t,r){var e=[];return t=x(t,r),m.each(n,function(n,r,u){t(n,r,u)&&e.push(n)}),e},m.reject=function(n,t,r){return m.filter(n,m.negate(x(t)),r)},m.every=m.all=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(!t(n[o],o,n))return!1}return!0},m.some=m.any=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(t(n[o],o,n))return!0}return!1},m.contains=m.includes=m.include=function(n,t,r,e){return k(n)||(n=m.values(n)),("number"!=typeof r||e)&&(r=0),m.indexOf(n,t,r)>=0},m.invoke=function(n,t){var r=l.call(arguments,2),e=m.isFunction(t);return m.map(n,function(n){var u=e?t:n[t];return null==u?u:u.apply(n,r)})},m.pluck=function(n,t){return m.map(n,m.property(t))},m.where=function(n,t){return m.filter(n,m.matcher(t))},m.findWhere=function(n,t){return m.find(n,m.matcher(t))},m.max=function(n,t,r){var e,u,i=-1/0,o=-1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],e>i&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(u>o||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},m.min=function(n,t,r){var e,u,i=1/0,o=1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],i>e&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(o>u||1/0===u&&1/0===i)&&(i=n,o=u)});return i},m.shuffle=function(n){for(var t,r=k(n)?n:m.values(n),e=r.length,u=Array(e),i=0;e>i;i++)t=m.random(0,i),t!==i&&(u[i]=u[t]),u[t]=r[i];return u},m.sample=function(n,t,r){return null==t||r?(k(n)||(n=m.values(n)),n[m.random(n.length-1)]):m.shuffle(n).slice(0,Math.max(0,t))},m.sortBy=function(n,t,r){return t=x(t,r),m.pluck(m.map(n,function(n,r,e){return{value:n,index:r,criteria:t(n,r,e)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),"value")};var F=function(n){return function(t,r,e){var u={};return r=x(r,e),m.each(t,function(e,i){var o=r(e,i,t);n(u,e,o)}),u}};m.groupBy=F(function(n,t,r){m.has(n,r)?n[r].push(t):n[r]=[t]}),m.indexBy=F(function(n,t,r){n[r]=t}),m.countBy=F(function(n,t,r){m.has(n,r)?n[r]++:n[r]=1}),m.toArray=function(n){return n?m.isArray(n)?l.call(n):k(n)?m.map(n,m.identity):m.values(n):[]},m.size=function(n){return null==n?0:k(n)?n.length:m.keys(n).length},m.partition=function(n,t,r){t=x(t,r);var e=[],u=[];return m.each(n,function(n,r,i){(t(n,r,i)?e:u).push(n)}),[e,u]},m.first=m.head=m.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:m.initial(n,n.length-t)},m.initial=function(n,t,r){return l.call(n,0,Math.max(0,n.length-(null==t||r?1:t)))},m.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:m.rest(n,Math.max(0,n.length-t))},m.rest=m.tail=m.drop=function(n,t,r){return l.call(n,null==t||r?1:t)},m.compact=function(n){return m.filter(n,m.identity)};var S=function(n,t,r,e){for(var u=[],i=0,o=e||0,a=O(n);a>o;o++){var c=n[o];if(k(c)&&(m.isArray(c)||m.isArguments(c))){t||(c=S(c,t,r));var f=0,l=c.length;for(u.length+=l;l>f;)u[i++]=c[f++]}else r||(u[i++]=c)}return u};m.flatten=function(n,t){return S(n,t,!1)},m.without=function(n){return m.difference(n,l.call(arguments,1))},m.uniq=m.unique=function(n,t,r,e){m.isBoolean(t)||(e=r,r=t,t=!1),null!=r&&(r=x(r,e));for(var u=[],i=[],o=0,a=O(n);a>o;o++){var c=n[o],f=r?r(c,o,n):c;t?(o&&i===f||u.push(c),i=f):r?m.contains(i,f)||(i.push(f),u.push(c)):m.contains(u,c)||u.push(c)}return u},m.union=function(){return m.uniq(S(arguments,!0,!0))},m.intersection=function(n){for(var t=[],r=arguments.length,e=0,u=O(n);u>e;e++){var i=n[e];if(!m.contains(t,i)){for(var o=1;r>o&&m.contains(arguments[o],i);o++);o===r&&t.push(i)}}return t},m.difference=function(n){var t=S(arguments,!0,!0,1);return m.filter(n,function(n){return!m.contains(t,n)})},m.zip=function(){return m.unzip(arguments)},m.unzip=function(n){for(var t=n&&m.max(n,O).length||0,r=Array(t),e=0;t>e;e++)r[e]=m.pluck(n,e);return r},m.object=function(n,t){for(var r={},e=0,u=O(n);u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},m.findIndex=t(1),m.findLastIndex=t(-1),m.sortedIndex=function(n,t,r,e){r=x(r,e,1);for(var u=r(t),i=0,o=O(n);o>i;){var a=Math.floor((i+o)/2);r(n[a])<u?i=a+1:o=a}return i},m.indexOf=r(1,m.findIndex,m.sortedIndex),m.lastIndexOf=r(-1,m.findLastIndex),m.range=function(n,t,r){null==t&&(t=n||0,n=0),r=r||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=Array(e),i=0;e>i;i++,n+=r)u[i]=n;return u};var E=function(n,t,r,e,u){if(!(e instanceof t))return n.apply(r,u);var i=j(n.prototype),o=n.apply(i,u);return m.isObject(o)?o:i};m.bind=function(n,t){if(g&&n.bind===g)return g.apply(n,l.call(arguments,1));if(!m.isFunction(n))throw new TypeError("Bind must be called on a function");var r=l.call(arguments,2),e=function(){return E(n,e,t,this,r.concat(l.call(arguments)))};return e},m.partial=function(n){var t=l.call(arguments,1),r=function(){for(var e=0,u=t.length,i=Array(u),o=0;u>o;o++)i[o]=t[o]===m?arguments[e++]:t[o];for(;e<arguments.length;)i.push(arguments[e++]);return E(n,r,this,this,i)};return r},m.bindAll=function(n){var t,r,e=arguments.length;if(1>=e)throw new Error("bindAll must be passed function names");for(t=1;e>t;t++)r=arguments[t],n[r]=m.bind(n[r],n);return n},m.memoize=function(n,t){var r=function(e){var u=r.cache,i=""+(t?t.apply(this,arguments):e);return m.has(u,i)||(u[i]=n.apply(this,arguments)),u[i]};return r.cache={},r},m.delay=function(n,t){var r=l.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},m.defer=m.partial(m.delay,m,1),m.throttle=function(n,t,r){var e,u,i,o=null,a=0;r||(r={});var c=function(){a=r.leading===!1?0:m.now(),o=null,i=n.apply(e,u),o||(e=u=null)};return function(){var f=m.now();a||r.leading!==!1||(a=f);var l=t-(f-a);return e=this,u=arguments,0>=l||l>t?(o&&(clearTimeout(o),o=null),a=f,i=n.apply(e,u),o||(e=u=null)):o||r.trailing===!1||(o=setTimeout(c,l)),i}},m.debounce=function(n,t,r){var e,u,i,o,a,c=function(){var f=m.now()-o;t>f&&f>=0?e=setTimeout(c,t-f):(e=null,r||(a=n.apply(i,u),e||(i=u=null)))};return function(){i=this,u=arguments,o=m.now();var f=r&&!e;return e||(e=setTimeout(c,t)),f&&(a=n.apply(i,u),i=u=null),a}},m.wrap=function(n,t){return m.partial(t,n)},m.negate=function(n){return function(){return!n.apply(this,arguments)}},m.compose=function(){var n=arguments,t=n.length-1;return function(){for(var r=t,e=n[t].apply(this,arguments);r--;)e=n[r].call(this,e);return e}},m.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},m.before=function(n,t){var r;return function(){return--n>0&&(r=t.apply(this,arguments)),1>=n&&(t=null),r}},m.once=m.partial(m.before,2);var M=!{toString:null}.propertyIsEnumerable("toString"),I=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];m.keys=function(n){if(!m.isObject(n))return[];if(v)return v(n);var t=[];for(var r in n)m.has(n,r)&&t.push(r);return M&&e(n,t),t},m.allKeys=function(n){if(!m.isObject(n))return[];var t=[];for(var r in n)t.push(r);return M&&e(n,t),t},m.values=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},m.mapObject=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=u.length,o={},a=0;i>a;a++)e=u[a],o[e]=t(n[e],e,n);return o},m.pairs=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},m.invert=function(n){for(var t={},r=m.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},m.functions=m.methods=function(n){var t=[];for(var r in n)m.isFunction(n[r])&&t.push(r);return t.sort()},m.extend=_(m.allKeys),m.extendOwn=m.assign=_(m.keys),m.findKey=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=0,o=u.length;o>i;i++)if(e=u[i],t(n[e],e,n))return e},m.pick=function(n,t,r){var e,u,i={},o=n;if(null==o)return i;m.isFunction(t)?(u=m.allKeys(o),e=b(t,r)):(u=S(arguments,!1,!1,1),e=function(n,t,r){return t in r},o=Object(o));for(var a=0,c=u.length;c>a;a++){var f=u[a],l=o[f];e(l,f,o)&&(i[f]=l)}return i},m.omit=function(n,t,r){if(m.isFunction(t))t=m.negate(t);else{var e=m.map(S(arguments,!1,!1,1),String);t=function(n,t){return!m.contains(e,t)}}return m.pick(n,t,r)},m.defaults=_(m.allKeys,!0),m.create=function(n,t){var r=j(n);return t&&m.extendOwn(r,t),r},m.clone=function(n){return m.isObject(n)?m.isArray(n)?n.slice():m.extend({},n):n},m.tap=function(n,t){return t(n),n},m.isMatch=function(n,t){var r=m.keys(t),e=r.length;if(null==n)return!e;for(var u=Object(n),i=0;e>i;i++){var o=r[i];if(t[o]!==u[o]||!(o in u))return!1}return!0};var N=function(n,t,r,e){if(n===t)return 0!==n||1/n===1/t;if(null==n||null==t)return n===t;n instanceof m&&(n=n._wrapped),t instanceof m&&(t=t._wrapped);var u=s.call(n);if(u!==s.call(t))return!1;switch(u){case"[object RegExp]":case"[object String]":return""+n==""+t;case"[object Number]":return+n!==+n?+t!==+t:0===+n?1/+n===1/t:+n===+t;case"[object Date]":case"[object Boolean]":return+n===+t}var i="[object Array]"===u;if(!i){if("object"!=typeof n||"object"!=typeof t)return!1;var o=n.constructor,a=t.constructor;if(o!==a&&!(m.isFunction(o)&&o instanceof o&&m.isFunction(a)&&a instanceof a)&&"constructor"in n&&"constructor"in t)return!1}r=r||[],e=e||[];for(var c=r.length;c--;)if(r[c]===n)return e[c]===t;if(r.push(n),e.push(t),i){if(c=n.length,c!==t.length)return!1;for(;c--;)if(!N(n[c],t[c],r,e))return!1}else{var f,l=m.keys(n);if(c=l.length,m.keys(t).length!==c)return!1;for(;c--;)if(f=l[c],!m.has(t,f)||!N(n[f],t[f],r,e))return!1}return r.pop(),e.pop(),!0};m.isEqual=function(n,t){return N(n,t)},m.isEmpty=function(n){return null==n?!0:k(n)&&(m.isArray(n)||m.isString(n)||m.isArguments(n))?0===n.length:0===m.keys(n).length},m.isElement=function(n){return!(!n||1!==n.nodeType)},m.isArray=h||function(n){return"[object Array]"===s.call(n)},m.isObject=function(n){var t=typeof n;return"function"===t||"object"===t&&!!n},m.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(n){m["is"+n]=function(t){return s.call(t)==="[object "+n+"]"}}),m.isArguments(arguments)||(m.isArguments=function(n){return m.has(n,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(m.isFunction=function(n){return"function"==typeof n||!1}),m.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},m.isNaN=function(n){return m.isNumber(n)&&n!==+n},m.isBoolean=function(n){return n===!0||n===!1||"[object Boolean]"===s.call(n)},m.isNull=function(n){return null===n},m.isUndefined=function(n){return n===void 0},m.has=function(n,t){return null!=n&&p.call(n,t)},m.noConflict=function(){return u._=i,this},m.identity=function(n){return n},m.constant=function(n){return function(){return n}},m.noop=function(){},m.property=w,m.propertyOf=function(n){return null==n?function(){}:function(t){return n[t]}},m.matcher=m.matches=function(n){return n=m.extendOwn({},n),function(t){return m.isMatch(t,n)}},m.times=function(n,t,r){var e=Array(Math.max(0,n));t=b(t,r,1);for(var u=0;n>u;u++)e[u]=t(u);return e},m.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))},m.now=Date.now||function(){return(new Date).getTime()};var B={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},T=m.invert(B),R=function(n){var t=function(t){return n[t]},r="(?:"+m.keys(n).join("|")+")",e=RegExp(r),u=RegExp(r,"g");return function(n){return n=null==n?"":""+n,e.test(n)?n.replace(u,t):n}};m.escape=R(B),m.unescape=R(T),m.result=function(n,t,r){var e=null==n?void 0:n[t];return e===void 0&&(e=r),m.isFunction(e)?e.call(n):e};var q=0;m.uniqueId=function(n){var t=++q+"";return n?n+t:t},m.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var K=/(.)^/,z={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\u2028|\u2029/g,L=function(n){return"\\"+z[n]};m.template=function(n,t,r){!t&&r&&(t=r),t=m.defaults({},t,m.templateSettings);var e=RegExp([(t.escape||K).source,(t.interpolate||K).source,(t.evaluate||K).source].join("|")+"|$","g"),u=0,i="__p+='";n.replace(e,function(t,r,e,o,a){return i+=n.slice(u,a).replace(D,L),u=a+t.length,r?i+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'":e?i+="'+\n((__t=("+e+"))==null?'':__t)+\n'":o&&(i+="';\n"+o+"\n__p+='"),t}),i+="';\n",t.variable||(i="with(obj||{}){\n"+i+"}\n"),i="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{var o=new Function(t.variable||"obj","_",i)}catch(a){throw a.source=i,a}var c=function(n){return o.call(this,n,m)},f=t.variable||"obj";return c.source="function("+f+"){\n"+i+"}",c},m.chain=function(n){var t=m(n);return t._chain=!0,t};var P=function(n,t){return n._chain?m(t).chain():t};m.mixin=function(n){m.each(m.functions(n),function(t){var r=m[t]=n[t];m.prototype[t]=function(){var n=[this._wrapped];return f.apply(n,arguments),P(this,r.apply(m,n))}})},m.mixin(m),m.each(["pop","push","reverse","shift","sort","splice","unshift"],function(n){var t=o[n];m.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!==n&&"splice"!==n||0!==r.length||delete r[0],P(this,r)}}),m.each(["concat","join","slice"],function(n){var t=o[n];m.prototype[n]=function(){return P(this,t.apply(this._wrapped,arguments))}}),m.prototype.value=function(){return this._wrapped},m.prototype.valueOf=m.prototype.toJSON=m.prototype.value,m.prototype.toString=function(){return""+this._wrapped},"function"=="function"&&__webpack_require__(299)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return m}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}).call(this);
//# sourceMappingURL=underscore-min.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Rely = function () {
	function Rely() {
		var showWhenChecked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

		_classCallCheck(this, Rely);

		this.showWhenChecked = showWhenChecked;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = $('[data-sma-js-relies-on]').toArray()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var el = _step.value;

				this.initializeElement($(el));
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	_createClass(Rely, [{
		key: 'initializeElement',
		value: function initializeElement(element) {
			var _this = this;

			var targets = $(element).attr('data-sma-js-relies-on').split(',');
			$(targets).each(function (i, target) {
				target = $(target);
				if (target.length) {
					if (target.is(':checkbox')) {
						_this.initializeCheckbox(target, element);
					} else if (target.is(':radio')) {
						_this.initializeRadio(target, element);
					}
				}
			});
		}
	}, {
		key: 'initializeCheckbox',
		value: function initializeCheckbox(target, element) {
			var _this2 = this;

			var modifier = function modifier(e) {
				if (_this2.showWhenChecked === target.is(':checked')) {
					element.fadeIn();
				} else {
					element.hide();
				}
			};

			target.bind('change', modifier);
			target.bind('draft-loaded', modifier);

			modifier();
		}
	}, {
		key: 'initializeRadio',
		value: function initializeRadio(target, element) {
			var _this3 = this;

			var modifier = function modifier(e) {
				if (_this3.showWhenChecked === target.is(':checked')) {
					element.fadeIn();
				} else {
					element.hide();
				}
			};

			$('[name=' + target.attr('name') + ']').bind('change', modifier);

			modifier();
		}
	}]);

	return Rely;
}();

module.exports = Rely;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(48);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports=function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){"use strict";e.exports=n(8)},function(e,t,n){e.exports=n(9)()},function(e,t,n){var a,r;"undefined"!=typeof self&&self,e.exports=(a=n(0),r=n(11),function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=96)}([function(e,t,n){e.exports=n(55)()},function(e,t){e.exports=a},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}},function(e,t,n){var a;!function(){"use strict";var n={}.hasOwnProperty;function r(){for(var e=[],t=0;t<arguments.length;t++){var a=arguments[t];if(a){var l=typeof a;if("string"===l||"number"===l)e.push(a);else if(Array.isArray(a)&&a.length){var o=r.apply(null,a);o&&e.push(o)}else if("object"===l)for(var i in a)n.call(a,i)&&a[i]&&e.push(i)}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):void 0===(a=function(){return r}.apply(t,[]))||(e.exports=a)}()},function(e,t,n){var a=n(57);e.exports=function(e,t){if(null==e)return{};var n,r,l=a(e,t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(l[n]=e[n])}return l}},function(e,t){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t){function n(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}e.exports=function(e,t,a){return t&&n(e.prototype,t),a&&n(e,a),e}},function(e,t,n){var a=n(53),r=n(3);e.exports=function(e,t){return!t||"object"!==a(t)&&"function"!=typeof t?r(e):t}},function(e,t){function n(t){return e.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},n(t)}e.exports=n},function(e,t,n){var a=n(54);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&a(e,t)}},function(e,t,n){var a=n(78),r=n(79);e.exports=function(e,t,n){var l=t&&n||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var o=(e=e||{}).random||(e.rng||a)();if(o[6]=15&o[6]|64,o[8]=63&o[8]|128,t)for(var i=0;i<16;++i)t[l+i]=o[i];return t||r(o)}},function(e,t,n){var a,r;"undefined"!=typeof self&&self,e.exports=(a=n(1),r=n(17),function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=12)}([function(e,t){e.exports=a},function(e,t,n){e.exports=n(7)()},function(e,t,n){var a=n(6);e.exports=function(e,t){if(null==e)return{};var n,r,l=a(e,t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(l[n]=e[n])}return l}},,function(e,t){e.exports=r},,function(e,t){e.exports=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}},function(e,t,n){"use strict";var a=n(8);function r(){}function l(){}l.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,l,o){if(o!==a){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:l,resetWarningCache:r};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";n.r(t);var a=n(2),r=n.n(a),l=n(0),o=n.n(l),i=n(1),u=n.n(i);function s(){return(s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function c(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}function d(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t}function p(e,t){return e.replace(new RegExp("(^|\\s)"+t+"(?:\\s|$)","g"),"$1").replace(/\s+/g," ").replace(/^\s*|\s*$/g,"")}var m=n(4),f=n.n(m),h=o.a.createContext(null),v="unmounted",g="exited",y="entering",b="entered",E=function(e){function t(t,n){var a;a=e.call(this,t,n)||this;var r,l=n&&!n.isMounting?t.enter:t.appear;return a.appearStatus=null,t.in?l?(r=g,a.appearStatus=y):r=b:r=t.unmountOnExit||t.mountOnEnter?v:g,a.state={status:r},a.nextCallback=null,a}d(t,e),t.getDerivedStateFromProps=function(e,t){return e.in&&t.status===v?{status:g}:null};var n=t.prototype;return n.componentDidMount=function(){this.updateStatus(!0,this.appearStatus)},n.componentDidUpdate=function(e){var t=null;if(e!==this.props){var n=this.state.status;this.props.in?n!==y&&n!==b&&(t=y):n!==y&&n!==b||(t="exiting")}this.updateStatus(!1,t)},n.componentWillUnmount=function(){this.cancelNextCallback()},n.getTimeouts=function(){var e,t,n,a=this.props.timeout;return e=t=n=a,null!=a&&"number"!=typeof a&&(e=a.exit,t=a.enter,n=void 0!==a.appear?a.appear:t),{exit:e,enter:t,appear:n}},n.updateStatus=function(e,t){if(void 0===e&&(e=!1),null!==t){this.cancelNextCallback();var n=f.a.findDOMNode(this);t===y?this.performEnter(n,e):this.performExit(n)}else this.props.unmountOnExit&&this.state.status===g&&this.setState({status:v})},n.performEnter=function(e,t){var n=this,a=this.props.enter,r=this.context?this.context.isMounting:t,l=this.getTimeouts(),o=r?l.appear:l.enter;t||a?(this.props.onEnter(e,r),this.safeSetState({status:y},(function(){n.props.onEntering(e,r),n.onTransitionEnd(e,o,(function(){n.safeSetState({status:b},(function(){n.props.onEntered(e,r)}))}))}))):this.safeSetState({status:b},(function(){n.props.onEntered(e)}))},n.performExit=function(e){var t=this,n=this.props.exit,a=this.getTimeouts();n?(this.props.onExit(e),this.safeSetState({status:"exiting"},(function(){t.props.onExiting(e),t.onTransitionEnd(e,a.exit,(function(){t.safeSetState({status:g},(function(){t.props.onExited(e)}))}))}))):this.safeSetState({status:g},(function(){t.props.onExited(e)}))},n.cancelNextCallback=function(){null!==this.nextCallback&&(this.nextCallback.cancel(),this.nextCallback=null)},n.safeSetState=function(e,t){t=this.setNextCallback(t),this.setState(e,t)},n.setNextCallback=function(e){var t=this,n=!0;return this.nextCallback=function(a){n&&(n=!1,t.nextCallback=null,e(a))},this.nextCallback.cancel=function(){n=!1},this.nextCallback},n.onTransitionEnd=function(e,t,n){this.setNextCallback(n);var a=null==t&&!this.props.addEndListener;e&&!a?(this.props.addEndListener&&this.props.addEndListener(e,this.nextCallback),null!=t&&setTimeout(this.nextCallback,t)):setTimeout(this.nextCallback,0)},n.render=function(){var e=this.state.status;if(e===v)return null;var t=this.props,n=t.children,a=c(t,["children"]);if(delete a.in,delete a.mountOnEnter,delete a.unmountOnExit,delete a.appear,delete a.enter,delete a.exit,delete a.timeout,delete a.addEndListener,delete a.onEnter,delete a.onEntering,delete a.onEntered,delete a.onExit,delete a.onExiting,delete a.onExited,"function"==typeof n)return o.a.createElement(h.Provider,{value:null},n(e,a));var r=o.a.Children.only(n);return o.a.createElement(h.Provider,{value:null},o.a.cloneElement(r,a))},t}(o.a.Component);function w(){}E.contextType=h,E.propTypes={},E.defaultProps={in:!1,mountOnEnter:!1,unmountOnExit:!1,appear:!1,enter:!0,exit:!0,onEnter:w,onEntering:w,onEntered:w,onExit:w,onExiting:w,onExited:w},E.UNMOUNTED=0,E.EXITED=1,E.ENTERING=2,E.ENTERED=3,E.EXITING=4;var z=E,_=function(e,t){return e&&t&&t.split(" ").forEach((function(t){return a=t,void((n=e).classList?n.classList.remove(a):"string"==typeof n.className?n.className=p(n.className,a):n.setAttribute("class",p(n.className&&n.className.baseVal||"",a)));var n,a}))},x=function(e){function t(){for(var t,n=arguments.length,a=new Array(n),r=0;r<n;r++)a[r]=arguments[r];return(t=e.call.apply(e,[this].concat(a))||this).appliedClasses={appear:{},enter:{},exit:{}},t.onEnter=function(e,n){t.removeClasses(e,"exit"),t.addClass(e,n?"appear":"enter","base"),t.props.onEnter&&t.props.onEnter(e,n)},t.onEntering=function(e,n){var a=n?"appear":"enter";t.addClass(e,a,"active"),t.props.onEntering&&t.props.onEntering(e,n)},t.onEntered=function(e,n){var a=n?"appear":"enter";t.removeClasses(e,a),t.addClass(e,a,"done"),t.props.onEntered&&t.props.onEntered(e,n)},t.onExit=function(e){t.removeClasses(e,"appear"),t.removeClasses(e,"enter"),t.addClass(e,"exit","base"),t.props.onExit&&t.props.onExit(e)},t.onExiting=function(e){t.addClass(e,"exit","active"),t.props.onExiting&&t.props.onExiting(e)},t.onExited=function(e){t.removeClasses(e,"exit"),t.addClass(e,"exit","done"),t.props.onExited&&t.props.onExited(e)},t.getClassNames=function(e){var n=t.props.classNames,a="string"==typeof n,r=a?(a&&n?n+"-":"")+e:n[e];return{baseClassName:r,activeClassName:a?r+"-active":n[e+"Active"],doneClassName:a?r+"-done":n[e+"Done"]}},t}d(t,e);var n=t.prototype;return n.addClass=function(e,t,n){var a=this.getClassNames(t)[n+"ClassName"];"appear"===t&&"done"===n&&(a+=" "+this.getClassNames("enter").doneClassName),"active"===n&&e&&e.scrollTop,this.appliedClasses[t][n]=a,function(e,t){e&&t&&t.split(" ").forEach((function(t){return a=t,void((n=e).classList?n.classList.add(a):function(e,t){return e.classList?!!t&&e.classList.contains(t):-1!==(" "+(e.className.baseVal||e.className)+" ").indexOf(" "+t+" ")}(n,a)||("string"==typeof n.className?n.className=n.className+" "+a:n.setAttribute("class",(n.className&&n.className.baseVal||"")+" "+a)));var n,a}))}(e,a)},n.removeClasses=function(e,t){var n=this.appliedClasses[t],a=n.base,r=n.active,l=n.done;this.appliedClasses[t]={},a&&_(e,a),r&&_(e,r),l&&_(e,l)},n.render=function(){var e=this.props,t=(e.classNames,c(e,["classNames"]));return o.a.createElement(z,s({},t,{onEnter:this.onEnter,onEntered:this.onEntered,onEntering:this.onEntering,onExit:this.onExit,onExiting:this.onExiting,onExited:this.onExited}))},t}(o.a.Component);x.defaultProps={classNames:""},x.propTypes={};var C=x,N=["slow","normal","fast"],q=(n(9),function(e){var t=e.children,n=e.timeout,a=e.direction,l=e.speed,i=e.distance,u=r()(e,["children","timeout","direction","speed","distance"]);return"fast"===l?n=150:"slow"===l&&(n=350),o.a.createElement(C,Object.assign({classNames:"wds-slide--".concat(a," wds-slide--speed-").concat(l," wds-slide--distance-").concat(i," wds-slide-"),timeout:{enter:n,exit:n},unmountOnExit:!0},u),t)});q.displayName="Slide",q.propTypes={children:u.a.node.isRequired,direction:u.a.oneOf(["up","right","down","left"]),timeout:u.a.number,speed:u.a.oneOf(N),distance:u.a.oneOf(["normal","near","far"])},q.defaultProps={direction:"up",speed:"normal",distance:"normal",timeout:200},q.__docgenInfo={description:"",methods:[],displayName:"Slide",props:{direction:{defaultValue:{value:"'up'",computed:!1},type:{name:"enum",computed:!0,value:"motionDirections"},required:!1,description:""},speed:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionSpeeds"},required:!1,description:""},distance:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionDistances"},required:!1,description:""},timeout:{defaultValue:{value:"200",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var I=q,k=(n(10),function(e){var t=e.children,n=e.timeout,a=e.speed,l=r()(e,["children","timeout","speed"]);return"fast"===a?n=150:"slow"===a&&(n=350),o.a.createElement(C,Object.assign({classNames:"wds-fade--".concat(a," wds-fade-"),timeout:{enter:n,exit:n},unmountOnExit:!0},l),t)});k.displayName="Fade",k.propTypes={children:u.a.node.isRequired,timeout:u.a.number,speed:u.a.oneOf(N)},k.defaultProps={timeout:250,speed:"normal"},k.__docgenInfo={description:"",methods:[],displayName:"Fade",props:{timeout:{defaultValue:{value:"250",computed:!1},type:{name:"number"},required:!1,description:""},speed:{defaultValue:{value:"'normal'",computed:!1},type:{name:"enum",computed:!0,value:"motionSpeeds"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var V=k,O=(n(11),function(e){var t=e.children,n=e.timeout,a=r()(e,["children","timeout"]);return o.a.createElement(C,Object.assign({classNames:"wds-zoom-",timeout:{enter:n,exit:n},unmountOnExit:!0},a),t)});O.displayName="Zoom",O.propTypes={children:u.a.node.isRequired,timeout:u.a.number},O.defaultProps={timeout:250},O.__docgenInfo={description:"",methods:[],displayName:"Zoom",props:{timeout:{defaultValue:{value:"250",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var T=O;n.d(t,"Slide",(function(){return I})),n.d(t,"Fade",(function(){return V})),n.d(t,"Zoom",(function(){return T}))}]))},function(e,t,n){var a=n(75),r=n(76),l=n(77);e.exports=function(e,t){return a(e)||r(e,t)||l()}},function(e){e.exports=JSON.parse('{"font-file":{"assets--font-version":"2","assets--font-path":"/fonts/National2Web","assets--font-name":"\'National 2\'"},"icon-font-file":{"assets--icon-version":"4","assets--icon-path":"/icons/Mateo","assets--icon-name":"Mateo"},"brand-color":{"color--sabaeus":"#00BF6F","color--midnight":"#05467E","color--link":"#007FAA","color--arctic":"#2DCCD3","color--concord":"#671E75","color--raspberry":"#AC145A","color--bengal":"#F05B24","color--bumblebee":"#F9BE00","color--black":"#000000","color--charcoal":"#333E48","color--slate":"#6B787F","color--stone":"#9DA5AA","color--flint":"#D0D2D3","color--pebble":"#EDEEEE","color--canvas":"#F7F8FA","color--white":"#FFFFFF"},"data-vis-color":{"color--data-midnight":"#507CB6","color--data-sabaeus":"#00BF6F","color--data-arctic":"#6BC8CD","color--data-bumblebee":"#F9BE00","color--data-concord":"#7D5E90","color--data-cherry":"#DB4D5C","color--data-slate":"#768086","color--data-raspberry":"#D25F90","color--data-gold":"#A38364","color--data-bengal":"#FF8B4F"},"semantic-color":{"color--primary":"#00BF6F","color--success":"#00BF6F","color--info":"#2DCCD3","color--warning":"#F05B24","color--upgrade":"#F9BE00","color--secondary":"#6B787F","color--muted":"#D0D2D3"},"type-color":{"color--type-dark":"#333E48","color--type-on-muted":"#333E48","color--type-on-upgrade":"#333E48","color--type-on-info":"#333E48","color--type-dark-muted":"#6B787F","color--type-light-muted":"#D0D2D3","color--type-light":"#FFFFFF","color--type-on-primary":"#FFFFFF","color--type-on-secondary":"#FFFFFF","color--type-on-success":"#FFFFFF","color--type-on-warning":"#FFFFFF","color--type-on-link":"#FFFFFF","color--type-on-black":"#FFFFFF","color--type-on-charcoal":"#FFFFFF","color--type-on-stone":"#FFFFFF","color--type-on-flint":"#333E48","color--type-on-pebble":"#333E48","color--type-on-canvas":"#333E48","color--type-on-white":"#333E48","color--type-on-midnight":"#FFFFFF","color--type-on-sabaeus":"#FFFFFF","color--type-on-arctic":"#333E48","color--type-on-bumblebee":"#333E48","color--type-on-concord":"#FFFFFF","color--type-on-cherry":"#FFFFFF","color--type-on-slate":"#FFFFFF","color--type-on-raspberry":"#FFFFFF","color--type-on-gold":"#FFFFFF","color--type-on-bengal":"#FFFFFF","color--type-link":"#007FAA"},"bg-color":{"color--bg-dark":"#333E48","color--bg-overlay":"rgba(107, 120, 127, .86)","color--bg":"#F7F8FA","color--bg-accent":"#EDEEEE","color--bg-light":"#FFFFFF"},"border-color":{"color--border-active":"#00BF6F","color--border-hover":"#9DA5AA","color--border":"#D0D2D3","color--border-muted":"#EDEEEE"},"border":{"border":"1px solid #D0D2D3","border--hover":"1px solid #9DA5AA","border--active":"1px solid #00BF6F","border--muted":"1px solid #EDEEEE"},"space":{"space--0":"0","space--1":"4px","space--2":"8px","space--3":"12px","space--4":"16px","space--5":"24px","space--6":"32px","space--7":"64px","space--8":"96px","space--9":"128px"},"border-radius":{"r--0":"0","r--sm":"2px","r--md":"24px","r--lg":"50%"},"elevation":{"shadow--none":"none","shadow--sky":"0 2px 4px 0 rgba(0, 0, 0, 0.14)","shadow--space":"0 2px 8px 0 rgba(0,0,0,0.14)"},"z-index":{"z--none":"0","z--sky":"999","z--space":"9999"},"font-size":{"fs--hero-1":"50px","fs--hero-2":"40px","fs--page-title":"34px","fs--section-title":"26px","fs--card-title":"16px","fs--body":"15px","fs--body-sm":"13px"},"font-weight":{"fw":{"Light":"300","Regular":"400","Medium":"500"},"fw--light":"300","fw--regular":"400","fw--medium":"500"},"font-family":{"ff--base":"\'National 2\', \'Helvetica Neue\', Helvetica, Arial, \'Hiragino Sans\', \'Hiragino Kaku Gothic Pro\', \'游ゴシック\', \'游ゴシック体\', YuGothic, \'Yu Gothic\', \'ＭＳ ゴシック\', \'MS Gothic\', sans-serif","ff--icon":"Mateo"},"icon-size":{"icon--sm":"13px","icon--md":"16px","icon--lg":"26px","icon--xl":"34px"},"motion":{"motion-curve--enter":"cubic-bezier(0, 0, 0, 1)","motion-curve--exit":"cubic-bezier(1, 0, 1, 1)","motion-curve--ease":"cubic-bezier(.2, 0, .1, 1)","motion-curve--ease-reverse":"cubic-bezier(.9, 0, .8, 1)","motion-curve--bounce-start":"cubic-bezier(0, 0, .1, 1)","motion-curve--bounce-end":"cubic-bezier(.2, 0, 0, 1)"},"breakpoints":{"breakpoints":{"xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px"},"bp--xs":"0","bp--sm":"576px","bp--md":"768px","bp--lg":"992px","bp--xl":"1200px"},"grid":{"grid-cols":"12","grid-order-elements":"12","grid-gutter--xs":"16px","grid-gutter--sm":"24px","grid-gutter--md":"24px","grid-gutter--lg":"24px","grid-gutter--xl":"24px","grid-bleed--xs":"16px","grid-bleed--sm":"32px","grid-bleed--md":"32px","grid-bleed--lg":"32px","grid-bleed--xl":"32px","grid-max-width--xs":"none","grid-max-width--sm":"576px","grid-max-width--md":"768px","grid-max-width--lg":"992px","grid-max-width--xl":"1400px"},"button":{"button__height--sm":"30px","button__height--md":"40px","button__height--lg":"50px","button__font-size--sm":"13px","button__font-size--md":"15px","button__font-size--lg":"15px","button__padding--sm":"12px","button__padding--md":"24px","button__padding--lg":"32px + 4px","button__border-radius":"2px","button__box-shadow":"none"},"alert":{"alert__box-shadow":"none","alert__bg-color":"#333E48","alert__type-color":"#FFFFFF","alert__padding--y":"16px","alert__link-color":"#FFFFFF"},"avatar":{"avatar__border":"2px solid #FFFFFF","avatar__border-radius--default":"50%","avatar__border-radius--square":"0","avatar__size--sm":"24px","avatar__size--md":"32px","avatar__size--lg":"64px","avatar__size--xl":"96px"},"banner":{"banner__border-radius":"2px","banner__bg-color":"#FFFFFF","banner__type-color":"#333E48","banner__mark-width":"8px","banner__border-size":"1px"},"coachmark":{"coachmark__bg-color":"#2DCCD3"},"table":{"table__th-type-color":"#333E48","table__th-bg-color":"transparent","table__th-divider-line-color":"transparent","table__td-type-color":"#333E48","table__td-bg-color":"transparent","table__cell-min-height":"50px","table__cell-padding":"16px 24px","table__font-size":"15px"},"input":{"input__height--sm":"30px","input__height--md":"40px","input__height--lg":"50px","input__font-size":"15px","input__padding--sm":"8px","input__padding--md":"12px","input__padding--lg":"16px","input__border-radius":"2px"},"input-group":{"input-group__height--sm":"30px","input-group__height--md":"40px","input-group__height--lg":"50px","input-group__border-radius":"2px","input-group__icon-color":"#333E48"},"textarea":{"textarea__font-size":"15px","textarea__padding--sm":"4px 8px 4px","textarea__padding--md":"8px 12px 8px","textarea__padding--lg":"12px 16px 12px","textarea__border-radius":"2px"},"select":{"select__height--sm":"30px","select__height--md":"40px","select__height--lg":"50px","select__padding--sm":"8px","select__padding--md":"12px","select__padding--lg":"16px","select__border-radius":"2px","select__icon-color":"#333E48","select__font-size":"15px"},"multiselect":{"multiselect__border-radius":"2px"},"list":{"list__addon-icon-color":"#333E48","list__affordance-icon-color":"#6B787F","list__label-font-size":"13px","list__item-height":"52px","list__mark-width":"4px"},"card":{"card__border-radius":"2px","card__box-shadow":"none","card__border":"1px solid #EDEEEE","card__padding":"24px"},"badge":{"badge__border-radius":"24px","badge__font-size--sm":"13px","badge__font-size--md":"13px","badge__font-size--lg":"15px","badge__height--sm":"22px","badge__height--md":"26px","badge__height--lg":"30px","badge__padding-x":"1em"},"slider":{"slider__handle-bg-color":"#333E48","slider__track-bg-color":"#D0D2D3","slider__fill-bg-color":"#00BF6F","slider__border-radius":"24px","slider__height":"16px"},"switch":{"switch__thumb-bg-color--on":"#00BF6F","switch__track-bg-color--on":"#333E48","switch__thumb-bg-color--off":"#FFFFFF","switch__thumb-border--off":"1px solid #D0D2D3","switch__track-bg-color--off":"#D0D2D3","switch__border-radius":"24px","switch__height":"16px","switch__width":"40px"},"checkbox":{"checkbox__bg-color--on":"#00BF6F","checkbox__icon-color--on":"#FFFFFF"},"radio":{"radio__bg-color--on":"#00BF6F","radio__icon-color--on":"#FFFFFF"},"modal":{"modal__border-radius":"0","modal__head-bg-color":"#FFFFFF","modal__head-type-color":"#333E48","modal__body-bg-color":"#EDEEEE","modal__body-type-color":"#333E48","modal__foot-bg-color":"#FFFFFF","modal__foot-type-color":"#333E48","modal__border":"1px solid #333E48","modal__box-shadow":"none"},"pane":{"pane__padding":"24px","pane__bg-color":"#EDEEEE"},"popout":{"popout__width--sm":"275px","popout__width--md":"360px","popout__width--lg":"445px","popout__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","popout__pip-size":"12px","popout__border-radius":"2px","popout__border":"none","popout__body-font-size":"13px"},"tab":{"tab__border-radius":"none","tab__indicator-height":"3px","tab__indicator-color":"#00BF6F","tab__type-color":"#6B787F","tab__font-size":"13px","tab__font-weight":"500","tab__padding-y":"12px","tab__padding-x":" 2px"},"progress-bar":{"progress-bar__border-radius":"none","progress-bar__height--sm":"4px","progress-bar__height--md":"8px","progress-bar__height--lg":"16px","progress-bar__fill-color":"#00BF6F","progress-bar__track-color":"#D0D2D3"},"menu":{"menu__box-shadow":"0 2px 8px 0 rgba(0,0,0,0.14)","menu__max-width":"300px","menu__min-width":"175px","menu__max-height":"325px"},"progress-spinner":{"progress-spinner__fill-color":"#00BF6F","progress-spinner__track-color":"#D0D2D3"},"toast":{"toast__padding":"24px","toast__bg-color":"#333E48","toast__type-color":"#FFFFFF","toast__border-radius":"2px","toast__width":"350px","toast__title-font-size":"16px","toast__body-type-size":"13px","toast__link-color":"#FFFFFF","toast__box-shadow":"none"},"tooltip":{"tooltip__bg-color":"#333E48","tooltip__type-color":"#FFFFFF","tooltip__border-radius":"2px","tooltip__pip-size":"12px","tooltip__font-size":"13px","tooltip__padding":"12px 16px","tooltip__font-weight":"400","tooltip__box-shadow":"none"},"form-group":{"form-group__space-between":"8px"},"sheet":{"sheet__width--sm":"320px","sheet__width--md":"50%","sheet__width--lg":"75%"}}')},,,function(e,t){e.exports=r},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";e.exports=function(e,t,n,a,r,l,o,i){if(!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var s=[n,a,r,l,o,i],c=0;(u=new Error(t.replace(/%s/g,(function(){return s[c++]})))).name="Invariant Violation"}throw u.framesToPop=1,u}}},,function(e,t,n){},function(e,t,n){},,,function(e,t,n){},function(e,t,n){},function(e,t,n){var a=n(69),r=n(70),l=n(71);e.exports=function(e){return a(e)||r(e)||l()}},,,function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){(function(t){var n,a=1/0,r="[object Symbol]",l=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,o=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,i="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",u="["+i+"]",s="\\d+",c="[a-z\\xdf-\\xf6\\xf8-\\xff]",d="[^\\ud800-\\udfff"+i+s+"\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",p="(?:\\ud83c[\\udde6-\\uddff]){2}",m="[\\ud800-\\udbff][\\udc00-\\udfff]",f="[A-Z\\xc0-\\xd6\\xd8-\\xde]",h="(?:"+c+"|"+d+")",v="(?:"+f+"|"+d+")",g="(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?",y="[\\ufe0e\\ufe0f]?"+g+"(?:\\u200d(?:"+["[^\\ud800-\\udfff]",p,m].join("|")+")[\\ufe0e\\ufe0f]?"+g+")*",b="(?:"+["[\\u2700-\\u27bf]",p,m].join("|")+")"+y,E=RegExp("['’]","g"),w=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]","g"),z=RegExp([f+"?"+c+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[u,f,"$"].join("|")+")",v+"+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[u,f+h,"$"].join("|")+")",f+"?"+h+"+(?:['’](?:d|ll|m|re|s|t|ve))?",f+"+(?:['’](?:D|LL|M|RE|S|T|VE))?",s,b].join("|"),"g"),_=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,x="object"==typeof t&&t&&t.Object===Object&&t,C="object"==typeof self&&self&&self.Object===Object&&self,N=x||C||Function("return this")(),q=(n={"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"ss"},function(e){return null==n?void 0:n[e]}),I=Object.prototype.toString,k=N.Symbol,V=k?k.prototype:void 0,O=V?V.toString:void 0;function T(e){return null==e?"":function(e){if("string"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&I.call(e)==r}(e))return O?O.call(e):"";var t=e+"";return"0"==t&&1/e==-a?"-0":t}(e)}var P,S=(P=function(e,t,n){return e+(n?"-":"")+t.toLowerCase()},function(e){return function(e,t,n,a){for(var r=-1,l=e?e.length:0;++r<l;)n=t(n,e[r],r,e);return n}(function(e,t,n){return e=T(e),void 0===(t=t)?function(e){return _.test(e)}(e)?function(e){return e.match(z)||[]}(e):function(e){return e.match(l)||[]}(e):e.match(t)||[]}(function(e){return(e=T(e))&&e.replace(o,q).replace(w,"")}(e).replace(E,"")),P,"")});e.exports=S}).call(this,n(64))},function(e,t,n){var a=n(92),r=function(e){var t="",n=Object.keys(e);return n.forEach((function(r,l){var o=e[r];(function(e){return/[height|width]$/.test(e)})(r=a(r))&&"number"==typeof o&&(o+="px"),t+=!0===o?r:!1===o?"not "+r:"("+r+": "+o+")",l<n.length-1&&(t+=" and ")})),t};e.exports=function(e){var t="";return"string"==typeof e?e:e instanceof Array?(e.forEach((function(n,a){t+=r(n),a<e.length-1&&(t+=", ")})),t):r(e)}},,,,,,,,,,function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t){function n(t){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=n=function(e){return typeof e}:e.exports=n=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(t)}e.exports=n},function(e,t){function n(t,a){return e.exports=n=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},n(t,a)}e.exports=n},function(e,t,n){"use strict";var a=n(56);function r(){}function l(){}l.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,l,o){if(o!==a){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:l,resetWarningCache:r};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t){e.exports=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t){e.exports=function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}},function(e,t){e.exports=function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t){e.exports=function(e){if(Array.isArray(e))return e}},function(e,t){e.exports=function(e,t){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)){var n=[],a=!0,r=!1,l=void 0;try{for(var o,i=e[Symbol.iterator]();!(a=(o=i.next()).done)&&(n.push(o.value),!t||n.length!==t);a=!0);}catch(e){r=!0,l=e}finally{try{a||null==i.return||i.return()}finally{if(r)throw l}}return n}}},function(e,t){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}},function(e,t){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var a=new Uint8Array(16);e.exports=function(){return n(a),a}}else{var r=new Array(16);e.exports=function(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),r[t]=e>>>((3&t)<<3)&255;return r}}},function(e,t){for(var n=[],a=0;a<256;++a)n[a]=(a+256).toString(16).substr(1);e.exports=function(e,t){var a=t||0,r=n;return[r[e[a++]],r[e[a++]],r[e[a++]],r[e[a++]],"-",r[e[a++]],r[e[a++]],"-",r[e[a++]],r[e[a++]],"-",r[e[a++]],r[e[a++]],"-",r[e[a++]],r[e[a++]],r[e[a++]],r[e[a++]],r[e[a++]],r[e[a++]]].join("")}},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t){e.exports=function(e){return e.replace(/[A-Z]/g,(function(e){return"-"+e.toLowerCase()})).toLowerCase()}},function(e,t,n){},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";n.r(t),n(50),n(51),n(52);var a=n(6),r=n.n(a),l=n(7),o=n.n(l),i=n(8),u=n.n(i),s=n(9),c=n.n(s),d=n(3),p=n.n(d),m=n(10),f=n.n(m),h=n(2),v=n.n(h),g=n(1),y=n.n(g),b=n(0),E=n.n(b),w=n(5),z=n.n(w),_=n(4),x=n.n(_),C=function(e){var t=e.children,n=e.color,a=e.size,r=z()(e,["children","color","size"]),l=x()("wds-icon-svg",v()({},"wds-icon-svg--".concat(n),n),v()({},"wds-icon-svg--".concat(a),a));return y.a.createElement("svg",Object.assign({className:l,preserveAspectRatio:"xMidYMid meet"},r),t)};C.displayName="IconSVG",C.propTypes={children:E.a.node.isRequired,color:E.a.string,size:E.a.oneOf(["lg","md","sm","xl"])},C.defaultProps={color:null,size:null},C.contextTypes={reactIconBase:E.a.shape(C.propTypes)},C.__docgenInfo={description:"",methods:[],displayName:"IconSVG",props:{color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}},context:{reactIconBase:{type:{name:"shape",value:"IconSVG.propTypes",computed:!0},required:!1}}};var N=C,q=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m14.04 11.77a.7467.7467 0 0 1 -.53-.22l-5.51-5.5095-5.51 5.51a.75.75 0 1 1 -1.06-1.0605l6.04-6.04a.75.75 0 0 1 .53-.22.7494.7494 0 0 1 .53.22l6.04 6.04a.75.75 0 0 1 -.53 1.28z"})))};q.displayName="IconChevronUp",q.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},q.defaultProps={title:"ChevronUp",color:null,size:null},q.__docgenInfo={description:"",methods:[],displayName:"IconChevronUp",props:{title:{defaultValue:{value:"'ChevronUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var I=q,k=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m8 11.77a.7494.7494 0 0 1 -.53-.22l-6.04-6.04a.75.75 0 1 1 1.0607-1.06l5.5093 5.5095 5.5088-5.51a.75.75 0 0 1 1.0612 1.0605l-6.0392 6.04a.75.75 0 0 1 -.5308.22z"})))};k.displayName="IconChevronDown",k.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},k.defaultProps={title:"ChevronDown",color:null,size:null},k.__docgenInfo={description:"",methods:[],displayName:"IconChevronDown",props:{title:{defaultValue:{value:"'ChevronDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var V=k,O=(n(32),function(e){var t=e.dense,n=e.interactive,a=e.noRules,r=e.transparent,l=e.children,o=e.role,i=e.id,u=e.className,s=z()(e,["dense","interactive","noRules","transparent","children","role","id","className"]),c=x()("wds-list",{"wds-list--no-rules":a},{"wds-list--interactive":n},{"wds-list--transparent":r},{"wds-list--dense":t},u),d=y.a.Children.map(l,(function(e,t){return y.a.isValidElement(e)&&y.a.cloneElement(e,{interactive:n,index:t})}));return y.a.createElement("ul",{className:c,role:o,id:i,"data-testid":s["data-testid"]},d)});O.displayName="List",O.propTypes={children:E.a.node.isRequired,dense:E.a.bool,id:E.a.string,interactive:E.a.bool,noRules:E.a.bool,role:E.a.string,className:E.a.string,transparent:E.a.bool,"data-testid":E.a.string},O.defaultProps={dense:!1,id:null,interactive:!1,noRules:!1,role:"",className:"",transparent:!1,"data-testid":void 0},O.__docgenInfo={description:"",methods:[],displayName:"List",props:{dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noRules:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},role:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var T=O;function P(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}n(58);var S=function(e){var t,n=e.children,a=e.hide,r=e.padding,l=e.transparent,o=e.id,i=e.role,u=z()(e,["children","hide","padding","transparent","id","role"]),s=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?P(Object(n),!0).forEach((function(t){v()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):P(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},i&&{role:i},{},o&&{id:o});return y.a.createElement("div",Object.assign({className:x()("wds-pane",{"wds-pane--transparent":l},{"wds-pane--hide":a})},s,{"data-testid":u["data-testid"]}),(t=n,r?t=y.a.createElement("div",{className:"wds-pane__body"},n):t))};S.displayName="Pane",S.propTypes={children:E.a.node.isRequired,hide:E.a.bool,id:E.a.string,padding:E.a.bool,role:E.a.string,transparent:E.a.bool,"data-testid":E.a.string},S.defaultProps={hide:!1,id:null,padding:!1,role:null,transparent:!1,"data-testid":void 0},S.__docgenInfo={description:"",methods:[],displayName:"Pane",props:{hide:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},padding:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},role:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var j=S,F=(n(31),function(e,t,n,a){var r=a?"tabpanel":null,l={padding:!(e.type&&"List"===e.type.displayName),labelledBy:t,ariaHidden:!1,role:r};return y.a.createElement(j,l,e)});F.displayName="renderActivePane";var B=function(e){function t(e){var n;r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"handleOnClick",(function(e){var t=parseInt(e.split("-")[2],10),a=n.state.activeItems;n.props.multiple?a.indexOf(t)>=0?a=a.filter((function(e){return e!==t})):a.push(t):a=a[0]===t?[]:[t],n.setState({activeItems:a}),n.props.onChange&&n.props.onChange(a)})),v()(p()(n),"renderAccordionElement",(function(e,t,a,r){var l="accordion-body-".concat(t),o="accordion-title-".concat(t),i=F(e.props.children,o,l,r);return y.a.cloneElement(e,{expanded:a,key:o,collapsed:!a,children:e.props.title,id:o,ariaControls:l,expandedComponent:a?i:null,affordance:a?y.a.createElement(I,null):y.a.createElement(V,null),onClick:function(){return n.handleOnClick(o)},multiple:r})}));var a=[],l=n.props.children;return y.a.Children.forEach(l,(function(e,t){y.a.isValidElement(e)&&e.props.expanded&&(n.props.multiple?a.push(t):0===a.length&&a.push(t))})),n.state={activeItems:a},n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.children,a=t.multiple,r=t.className,l=t.interactive,o=t.noRules,i=t.dense,u=t.transparent,s=t.id,c=[];return y.a.Children.forEach(n,(function(t,n){var r=e.state.activeItems.indexOf(n)>=0;y.a.isValidElement(t)&&("ListItem"===t.type.displayName?c.push(t):c.push(e.renderAccordionElement(t,n,r,a)))})),y.a.createElement(T,{role:a?"tablist":null,className:r,noRules:o,interactive:l,dense:i,transparent:u,id:s,"data-testid":this.props["data-testid"]},c)}}]),t}(g.Component);B.displayName="Accordion",B.propTypes={children:E.a.node.isRequired,multiple:E.a.bool,className:E.a.string,onChange:E.a.func,interactive:E.a.bool,id:E.a.string,dense:E.a.bool,transparent:E.a.bool,noRules:E.a.bool,"data-testid":E.a.string},B.defaultProps={multiple:!1,className:"",onChange:null,interactive:!1,id:null,dense:!1,transparent:!1,noRules:!1,"data-testid":void 0},B.__docgenInfo={description:"",methods:[{name:"handleOnClick",docblock:null,modifiers:[],params:[{name:"key",type:null}],returns:null},{name:"renderAccordionElement",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"expanded",type:null},{name:"multiple",type:null}],returns:null}],displayName:"Accordion",props:{multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},transparent:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noRules:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var M=B,R={info:"i",warning:"!",upgrade:"(",success:"3"},L=["lg","md","sm"],A=["bottom-right","bottom-left","top-right","top-left"],D=["top","bottom","right","left"],U=["xl"].concat(L),H=([].concat(L,["xl","xs"]),[].concat(L,["xl"])),W=[].concat(L,["xs"]),G=["success","warning"],K={DOWN:40,END:35,ESC:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,RIGHT:39,UP:38,ENTER:13,SPACE:32,BACKSPACE:8},$=["sabaeus","midnight","link","arctic","concord","raspberry","bengal","bumblebee","black","charcoal","slate","stone","flint","pebble","canvas","white"],Q=["primary","secondary","muted","success","warning","upgrade","info"],Y=["data-sabaeus","data-midnight","data-concord","data-arctic","data-bumblebee","data-bengal","data-raspberry","data-slate","data-gold","data-cherry"],X=[].concat(Y,Q,$),J=[].concat(Q),Z=["alt","link"].concat(Q),ee=["primary","secondary","muted","success","warning","upgrade","info"],te=["success","warning"],ne=["primary","upgrade","info","success","warning","secondary"],ae=ne,re=W,le={sm:"576px",md:"768px",lg:"992px",xl:"1200px"},oe=function(e){var t=e.color,n=e.addOn,a=e.addOnPlacement,r=e.addOnLeft,l=e.addOnRight,o=e.interactive,i=e.disabled,u=e.children,s=e.onClick,c=e.className,d=e.affordance,p=e.expandedComponent,m=e.marked,f=e.upgrade,h=e.id,g=e.index,b=e.innerRef,E=e.isNavigable,w=e.navigationTarget,_=e.isFocused,C=z()(e,["color","addOn","addOnPlacement","addOnLeft","addOnRight","interactive","disabled","children","onClick","className","affordance","expandedComponent","marked","upgrade","id","index","innerRef","isNavigable","navigationTarget","isFocused"]),N="section",q=x()("wds-list__row",c),I=x()("wds-list__item",v()({},"wds-list__item--marked-".concat(t),t),{"wds-list__item--marked":m},{"wds-list__item--disabled":i},{"wds-list__item--upgrade":f},{"wds-list__item--focused":_}),k=function(e){s&&s(e)},V=function(e){return y.a.createElement("div",{className:"wds-list__addon"},e)};E&&(N="a");var O,T=a;if(n&&!a&&(T="left"),a&&!n)throw new Error("You must supply an addOn component with an addonPlacement");return y.a.createElement("li",{className:q},y.a.createElement(N,Object.assign({className:I,onClick:k,onKeyPress:function(e){e.charCode!==K.ENTER&&e.charCode!==K.SPACE||k(e)},id:h,"data-index":g,ref:b},(O={},o&&(O.tabIndex=i?"-1":0,O.role="button"),E&&(O.href=w),O),C),"left"===T&&V(n),r&&V(r),y.a.createElement("span",{className:"wds-list__label"},u),"right"===T&&V(n),l&&V(l),d&&y.a.createElement("span",{className:"wds-list__affordance"},d)),p&&p)};oe.displayName="ListItem",oe.propTypes={addOn:E.a.node,addOnPlacement:E.a.oneOf(D),addOnLeft:E.a.node,addOnRight:E.a.node,affordance:E.a.node,children:E.a.node,className:E.a.string,disabled:E.a.bool,expandedComponent:E.a.node,id:E.a.string,interactive:E.a.bool,index:E.a.number,innerRef:E.a.func,onClick:E.a.func,marked:E.a.bool,color:E.a.oneOfType([E.a.oneOf(ee),E.a.oneOf(Y)]),isNavigable:E.a.bool,navigationTarget:E.a.string,upgrade:E.a.bool,isFocused:E.a.bool,"data-testid":E.a.string},oe.defaultProps={addOn:null,addOnPlacement:null,addOnLeft:null,addOnRight:null,affordance:null,className:null,color:null,disabled:!1,expandedComponent:null,id:null,interactive:!1,index:null,innerRef:null,onClick:null,marked:!1,upgrade:!1,isNavigable:!1,children:null,navigationTarget:"javascript:void(0)",isFocused:!1,"data-testid":void 0},oe.__docgenInfo={description:"",methods:[],displayName:"ListItem",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},addOnLeft:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnRight:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},affordance:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},expandedComponent:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},index:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isNavigable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},navigationTarget:{defaultValue:{value:"'javascript:void(0)'",computed:!1},type:{name:"string"},required:!1,description:""},isFocused:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var ie=oe,ue=function(e){var t=e.color,n=e.addOn,a=e.addOnPlacement,r=e.multiple,l=e.onClick,o=e.children,i=e.disabled,u=e.ariaControls,s=e.expandedComponent,c=e.affordance,d=e.marked,p=e.interactive,m=e.upgrade,f=z()(e,["color","addOn","addOnPlacement","multiple","onClick","children","disabled","ariaControls","expandedComponent","affordance","marked","interactive","upgrade"]),h=x()("wds-accordion__row",{"wds-accordion__row--collapsed":!s,"wds-accordion__row--expanded":s});return y.a.createElement(ie,Object.assign({addOn:n,addOnPlacement:a,affordance:c,expandedComponent:s,color:t,className:h,onClick:l,disabled:i,marked:d,id:u,interactive:p,upgrade:m},{tabIndex:i?"-1":0,role:r?"tab":"button","aria-selected":!0===s,"aria-controls":u},{"data-testid":f["data-testid"]}),o)};ue.displayName="AccordionItem",ue.propTypes={affordance:E.a.node,addOn:E.a.node,addOnPlacement:E.a.oneOf(D),ariaControls:E.a.string,children:E.a.node.isRequired,color:E.a.string,disabled:E.a.bool,expandedComponent:E.a.node,marked:E.a.bool,multiple:E.a.bool,onClick:E.a.func,interactive:E.a.bool,upgrade:E.a.bool,"data-testid":E.a.string},ue.defaultProps={affordance:null,addOn:null,addOnPlacement:null,ariaControls:null,color:null,disabled:!1,expandedComponent:null,marked:!1,multiple:!1,onClick:null,interactive:!1,upgrade:!1,"data-testid":void 0},ue.__docgenInfo={description:"",methods:[],displayName:"AccordionItem",props:{affordance:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},ariaControls:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},expandedComponent:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var se=ue,ce=n(12),de=function(e){var t=e.onClick;return y.a.createElement("div",{className:"wds-overlay wds-modal__overlay",onClick:t})};de.displayName="Overlay",de.propTypes={onClick:E.a.func},de.defaultProps={onClick:null},de.__docgenInfo={description:"",methods:[],displayName:"Overlay",props:{onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var pe=de,me=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m9.0605 8 4.1395-4.1394a.75.75 0 0 0 -1.06-1.0606l-4.14 4.1394-4.14-4.1394a.75.75 0 0 0 -1.06 1.0606l4.1395 4.1394-4.1395 4.1394a.75.75 0 1 0 1.06 1.0606l4.14-4.1395 4.14 4.1395a.75.75 0 0 0 1.06-1.0606z"})))};me.displayName="IconX",me.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},me.defaultProps={title:"X",color:null,size:null},me.__docgenInfo={description:"",methods:[],displayName:"IconX",props:{title:{defaultValue:{value:"'X'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var fe=me,he=(n(61),function(e){var t=e.onClick,n=e.variant,a=e.ariaLabel,r=e.className,l=z()(e,["onClick","variant","ariaLabel","className"]),o=x()("wds-close","wds-close--".concat(n),r);return y.a.createElement("button",{onClick:t,"aria-label":a,className:o,type:"button","data-testid":l["data-testid"]},y.a.createElement("span",{className:"wds-close__icon"},y.a.createElement(fe,null)),y.a.createElement("span",{className:"wds-close__text"},a))});he.displayName="CloseButton",he.propTypes={className:E.a.string,onClick:E.a.func.isRequired,variant:E.a.oneOf(["dark","light"]),ariaLabel:E.a.string,"data-testid":E.a.string},he.defaultProps={ariaLabel:"Close",className:"",variant:"dark","data-testid":void 0},he.__docgenInfo={description:"",methods:[],displayName:"CloseButton",props:{ariaLabel:{defaultValue:{value:"'Close'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"'dark'",computed:!1},type:{name:"enum",value:[{value:"'dark'",computed:!1},{value:"'light'",computed:!1}]},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},onClick:{type:{name:"func"},required:!0,description:""}}};var ve=he,ge=(n(60),function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"getSlideDirection",(function(){var e=n.props.placement;return e&&"right"!==e?"bottom"===e?"up":"right":"left"})),v()(p()(n),"closeButton",(function(){return n.props.closeButton&&y.a.createElement(ve,{className:n.props.closeButtonClass||null,onClick:n.handleClick,ariaLabel:n.props.ariaLabel})})),v()(p()(n),"handleClick",(function(){var e=n.props.onClose;e&&e()})),n}return f()(t,e),o()(t,[{key:"componentDidMount",value:function(){this.sheet&&this.sheet.focus()}},{key:"render",value:function(){var e=this,t=this.props,n=t.className,a=t.size,r=t.show,l=t.placement,o=t.blocking,i=t.children,u=t.offsetTop,s=x()("wds-sheet",n,"wds-sheet--".concat(a),"wds-sheet--".concat(l),{"wds-sheet--no-overlay":!o}),c={top:"".concat(u,"px")};return y.a.createElement(g.Fragment,null,o&&y.a.createElement(ce.Fade,{in:r,speed:"fast"},y.a.createElement(pe,{onClick:this.handleClick})),y.a.createElement(ce.Slide,{in:r,direction:this.getSlideDirection()},y.a.createElement("div",{className:s,"data-testid":this.props["data-testid"]},y.a.createElement("div",{role:"dialog",className:"wds-sheet__sheet",ref:function(t){e.sheet=t},style:"bottom"==l?null:c,tabIndex:"-1"},this.closeButton(),i))))}}]),t}(y.a.Component));ge.displayName="Sheet",ge.defaultProps={className:"",closeButton:!1,closeButtonClass:"",onClose:null,show:!1,size:"sm",placement:"right",ariaLabel:"Close Modal",blocking:!0,offsetTop:0,"data-testid":void 0},ge.propTypes={children:E.a.node.isRequired,className:E.a.string,closeButton:E.a.bool,closeButtonClass:E.a.string,onClose:E.a.func,show:E.a.bool,size:E.a.oneOf(L),placement:E.a.oneOf(["bottom","right","left"]),ariaLabel:E.a.node,blocking:E.a.bool,offsetTop:E.a.number,"data-testid":E.a.string},ge.__docgenInfo={description:"",methods:[{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"closeButton",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Sheet",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},closeButton:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},closeButtonClass:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},placement:{defaultValue:{value:"'right'",computed:!1},type:{name:"enum",computed:!0,value:"sheetPlacements"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Modal'",computed:!1},type:{name:"node"},required:!1,description:""},blocking:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},offsetTop:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ye=ge,be=(n(63),function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"handleClick",(function(){var e=n.props.onClose;e&&e()})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this.props,t=e.color,n=e.children,a=e.size,r=e.dismissible,l=e.show,o=e.icon,i=x()("wds-badge","wds-badge--".concat(t),"wds-badge--".concat(a),{"wds-badge--dismissible":r}),u="light";return"muted"!=t&&"upgrade"!=t&&"info"!=t||(u="dark"),y.a.createElement(ce.Fade,{in:l},y.a.createElement("span",{className:i,"data-testid":this.props["data-testid"]},o,n,r&&y.a.createElement(ve,{variant:u,onClick:this.handleClick})))}}]),t}(y.a.Component));be.displayName="Badge",be.defaultProps={size:"md",color:"primary",dismissible:!1,show:!0,onClose:null,icon:null,"data-testid":void 0},be.propTypes={children:E.a.node.isRequired,size:E.a.oneOf(L),color:E.a.oneOf(X),dismissible:E.a.bool,show:E.a.bool,onClose:E.a.func,icon:E.a.node,"data-testid":E.a.string},be.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Badge",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",computed:!0,value:"badgeColors"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},icon:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ee=be,we=(n(62),[1,2,3,4,5,6,7,8,9]),ze=function(e){var t=e.component,n=e.children,a=e.className,r=e.containerRef,l=e.m,o=e.mx,i=e.my,u=e.mt,s=e.mb,c=e.ml,d=e.mr,p=e.p,m=e.px,f=e.py,h=e.pt,g=e.pb,b=e.pl,E=e.pr,w=e.flex,_=e.flexInline,C=e.flexDirection,N=e.flexJustify,q=e.flexAlign,I=e.flexWrap,k=e.flexItemGrow,V=z()(e,["component","children","className","containerRef","m","mx","my","mt","mb","ml","mr","p","px","py","pt","pb","pl","pr","flex","flexInline","flexDirection","flexJustify","flexAlign","flexWrap","flexItemGrow"]),O=x()("wds-container",v()({},"wds-m-".concat(l),l),v()({},"wds-m-x-".concat(o),o),v()({},"wds-m-y-".concat(i),i),v()({},"wds-m-t-".concat(u),u),v()({},"wds-m-b-".concat(s),s),v()({},"wds-m-l-".concat(c),c),v()({},"wds-m-r-".concat(d),d),v()({},"wds-p-".concat(p),p),v()({},"wds-p-x-".concat(m),m),v()({},"wds-p-y-".concat(f),f),v()({},"wds-p-t-".concat(h),h),v()({},"wds-p-b-".concat(g),g),v()({},"wds-p-l-".concat(b),b),v()({},"wds-p-r-".concat(E),E),{"wds-flex":w||_},{"wds-flex--inline":_},{"wds-flex--x":C&&"row"==C},{"wds-flex--y":C&&"column"==C},{"wds-flex--x-start":N&&"start"==N},{"wds-flex--x-end":N&&"end"==N},{"wds-flex--x-center":N&&"center"==N},{"wds-flex--x-between":N&&"between"==N},{"wds-flex--x-around":N&&"around"==N},{"wds-flex--y-start":q&&"start"==q},{"wds-flex--y-end":q&&"end"==q},{"wds-flex--y-center":q&&"center"==q},{"wds-flex--stretch":q&&"stretch"==q},{"wds-flex--wrap":I},{"wds-flex--nowrap":!1===I},{"wds-flex__item--grow":k},a),T=t;return y.a.createElement(T,Object.assign({className:O,ref:r},V),n)};ze.displayName="Container",ze.propTypes={component:E.a.string,children:E.a.node.isRequired,className:E.a.string,containerRef:E.a.func,m:E.a.oneOf(we),mx:E.a.oneOf(we),my:E.a.oneOf(we),mt:E.a.oneOf(we),mb:E.a.oneOf(we),ml:E.a.oneOf(we),mr:E.a.oneOf(we),p:E.a.oneOf(we),px:E.a.oneOf(we),py:E.a.oneOf(we),pt:E.a.oneOf(we),pb:E.a.oneOf(we),pl:E.a.oneOf(we),pr:E.a.oneOf(we),flex:E.a.bool,flexInline:E.a.bool,flexDirection:E.a.oneOf(["row","column"]),flexJustify:E.a.oneOf(["start","end","center","between","around"]),flexAlign:E.a.oneOf(["start","end","center","stretch"]),flexWrap:E.a.bool,flexItemGrow:E.a.bool},ze.defaultProps={component:"div",className:null,containerRef:null,m:null,mx:null,my:null,mt:null,mb:null,ml:null,mr:null,p:null,px:null,py:null,pt:null,pb:null,pl:null,pr:null,flex:null,flexInline:null,flexDirection:null,flexJustify:null,flexAlign:null,flexWrap:null,flexItemGrow:null},ze.__docgenInfo={description:"",methods:[],displayName:"Container",props:{component:{defaultValue:{value:"'div'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},containerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},m:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mx:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},my:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mt:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mb:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},ml:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},mr:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},p:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},px:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},py:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pt:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pb:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pl:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},pr:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"1",computed:!1},{value:"2",computed:!1},{value:"3",computed:!1},{value:"4",computed:!1},{value:"5",computed:!1},{value:"6",computed:!1},{value:"7",computed:!1},{value:"8",computed:!1},{value:"9",computed:!1}]},required:!1,description:""},flex:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexInline:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexDirection:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'row'",computed:!1},{value:"'column'",computed:!1}]},required:!1,description:""},flexJustify:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'start'",computed:!1},{value:"'end'",computed:!1},{value:"'center'",computed:!1},{value:"'between'",computed:!1},{value:"'around'",computed:!1}]},required:!1,description:""},flexAlign:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'start'",computed:!1},{value:"'end'",computed:!1},{value:"'center'",computed:!1},{value:"'stretch'",computed:!1}]},required:!1,description:""},flexWrap:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},flexItemGrow:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var _e=ze,xe=n(39),Ce=n.n(xe),Ne=(n(65),function(e){var t=e.align,n=e.children,a=e.className,r=e.color,l=e.component,o=e.variant,i=z()(e,["align","children","className","color","component","variant"]),u=x()(v()({},"wds-type--".concat(t),t),v()({},"wds-type--".concat(r),r),v()({},"wds-type--".concat(Ce()(o)),o),a),s=l;return y.a.createElement(s,Object.assign({},i,{className:u}),n)});Ne.displayName="Typography",Ne.propTypes={align:E.a.oneOf(["center","justify","left","right"]),children:E.a.node.isRequired,className:E.a.string,color:E.a.oneOf(["light","dark","primary","success","upgrade","info","warning","link","light-muted","dark-muted"]),component:E.a.string,variant:E.a.oneOf(["hero1","hero2","pageTitle","sectionTitle","cardTitle","body","bodySm","link"])},Ne.defaultProps={align:null,className:null,color:null,component:"div",variant:"body"},Ne.__docgenInfo={description:"",methods:[],displayName:"Typography",props:{align:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"alignment"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"typeColors"},required:!1,description:""},component:{defaultValue:{value:"'div'",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"'body'",computed:!1},type:{name:"enum",computed:!0,value:"typographyVariants"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var qe=Ne,Ie=(n(59),function(e){var t=e.children,n=e.className,a=e.show,r=e.rightAddOn,l=e.numSelected,o=e.labelSelectedItems,i=z()(e,["children","className","show","rightAddOn","numSelected","labelSelectedItems"]),u=x()("wds-actionsheet",n);return y.a.createElement("div",Object.assign({className:u},i),y.a.createElement(ye,{show:a,placement:"bottom",blocking:!1},y.a.createElement(_e,{flex:!0,flexJustify:"between",flexAlign:"center",p:6},y.a.createElement(_e,{flexInline:!0,flexAlign:"center",flexJustify:"between"},y.a.createElement(Ee,null,l),y.a.createElement(_e,{pl:2},y.a.createElement(qe,{variant:"body"},o))),y.a.createElement(_e,{flexItemGrow:!0},y.a.createElement("div",{className:"wds-type--center"},t)),y.a.createElement("div",{className:"wds-type--right"},r))))});Ie.displayName="ActionSheet",Ie.propTypes={children:E.a.node.isRequired,className:E.a.string,show:E.a.bool,numSelected:E.a.number,labelSelectedItems:E.a.node,rightAddOn:E.a.node},Ie.defaultProps={className:"",show:!1,numSelected:0,labelSelectedItems:"Selected items",rightAddOn:null},Ie.__docgenInfo={description:"",methods:[],displayName:"ActionSheet",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numSelected:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},labelSelectedItems:{defaultValue:{value:"'Selected items'",computed:!1},type:{name:"node"},required:!1,description:""},rightAddOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ke=Ie,Ve=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.959 7.959 0 0 0 -7.95-7.95zm-.707 3.1956a.75.75 0 1 1 1.5 0v1.0264a.75.75 0 0 1 -1.5 0zm2.8428 8.7266-1.5626 1.5615a.751.751 0 0 1 -1.28-.53v-4.2464l-.2812.2813a.75.75 0 0 1 -1.0608-1.0606l1.5615-1.5615a.7511.7511 0 0 1 1.28.53v4.2469l.2822-.282a.75.75 0 1 1 1.0605 1.0605z"})))};Ve.displayName="IconInfo",Ve.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Ve.defaultProps={title:"Info",color:null,size:null},Ve.__docgenInfo={description:"",methods:[],displayName:"IconInfo",props:{title:{defaultValue:{value:"'Info'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Oe=Ve,Te=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m15.7051 12.9691-6.5513-11.2378a1.3042 1.3042 0 0 0 -2.3076 0l-6.5513 11.2387a1.3386 1.3386 0 0 0 -.0649 1.3638 1.3379 1.3379 0 0 0 1.2109.6313h13.1177a1.2682 1.2682 0 0 0 1.1465-1.9961zm-8.4551-7.5152a.75.75 0 0 1 1.5 0v4.3023a.75.75 0 1 1 -1.5 0zm.75 7.765a.875.875 0 1 1 .875-.875.875.875 0 0 1 -.875.875z"})))};Te.displayName="IconWarning",Te.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Te.defaultProps={title:"Warning",color:null,size:null},Te.__docgenInfo={description:"",methods:[],displayName:"IconWarning",props:{title:{defaultValue:{value:"'Warning'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pe=Te,Se=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m6.4372 13.125a.7475.7475 0 0 1 -.53-.22l-5.6247-5.6242a.75.75 0 0 1 1.0605-1.0608l5.0942 5.0942 8.22-8.22a.75.75 0 0 1 1.0605 1.0605l-8.75 8.75a.7476.7476 0 0 1 -.5305.2203z"})))};Se.displayName="IconCheck",Se.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Se.defaultProps={title:"Check",color:null,size:null},Se.__docgenInfo={description:"",methods:[],displayName:"IconCheck",props:{title:{defaultValue:{value:"'Check'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var je=Se,Fe=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m13.7268 6.3958h-2.083v-2.75a3.6527 3.6527 0 0 0 -7.2876.0068v2.7432h-2.083a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4536a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75zm-7.8706-2.7437a2.16 2.16 0 0 1 4.2876-.0068v2.75h-4.2876zm7.1206 10.5972h-9.9536v-6.3535h9.9536z"}),y.a.createElement("path",{d:"m8 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};Fe.displayName="IconLock",Fe.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Fe.defaultProps={title:"Lock",color:null,size:null},Fe.__docgenInfo={description:"",methods:[],displayName:"IconLock",props:{title:{defaultValue:{value:"'Lock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Be=Fe,Me=(n(66),function(e){var t;return"info"===e?t=Oe:"warning"===e?t=Pe:"success"===e?t=je:"upgrade"===e&&(t=Be),y.a.createElement("span",{className:"wds-alert__icon"},y.a.createElement(t,null))});Me.displayName="alertIcon";var Re=function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"handleClick",(function(){var e=n.props.onClose;e&&e()})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.color,a=t.showIcon,r=t.children,l=t.actions,o=t.placement,i=t.show,u=t.dismissible,s="top"===o?"down":"up",c=x()("wds-alert","wds-alert--".concat(this.props.color),v()({},"wds-alert--".concat(this.props.placement),o));return y.a.createElement(ce.Slide,{in:i,direction:s,distance:"far"},y.a.createElement("div",{className:c,ref:function(t){e.alert=t},role:"alert","data-testid":this.props["data-testid"]},u&&y.a.createElement(ve,{onClick:this.handleClick,ariaLabel:this.props.ariaLabel,variant:"light"}),a&&Me(n),y.a.createElement("p",{className:"wds-alert__label"},r),l?y.a.createElement("div",{className:"wds-alert__actions"},l):null))}}]),t}(y.a.Component);Re.displayName="Alert",Re.propTypes={children:E.a.node.isRequired,onClose:E.a.func,showIcon:E.a.bool,color:E.a.oneOf(Object.keys(R)),ariaLabel:E.a.node,actions:E.a.node,placement:E.a.string,show:E.a.bool,dismissible:E.a.bool,"data-testid":E.a.string},Re.defaultProps={onClose:null,showIcon:!1,color:"info",ariaLabel:"Close Alert",actions:null,placement:null,show:!0,dismissible:!0,"data-testid":void 0},Re.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Alert",props:{onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},showIcon:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"'info'",computed:!1},type:{name:"enum",computed:!0,value:"Object.keys(iconColors)"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Alert'",computed:!1},type:{name:"node"},required:!1,description:""},actions:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},placement:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dismissible:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Le=Re,Ae=(n(67),function(e){var t=e.children,n=e.size,a=e.square,r=e.color,l=z()(e,["children","size","square","color"]),o=x()("wds-avatar","wds-avatar--".concat(n),{"wds-avatar--square":a},v()({},"wds-avatar--".concat(r),r));return y.a.createElement("span",{className:o,"data-testid":l["data-testid"]},y.a.createElement("span",{className:"wds-avatar__body"},t))});Ae.displayName="Avatar",Ae.defaultProps={size:"md",square:!1,color:null,"data-testid":void 0},Ae.propTypes={children:E.a.node.isRequired,color:E.a.oneOf(["primary","secondary","muted","upgrade","info","success","warning","dark","light"]),size:E.a.oneOf(U),square:E.a.bool,"data-testid":E.a.string},Ae.__docgenInfo={description:"",methods:[],displayName:"Avatar",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"avatarSizes"},required:!1,description:""},square:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"componentColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var De=Ae,Ue=(n(68),function(e){var t;return"info"===e?t=Oe:"warning"===e?t=Pe:"success"===e?t=je:"upgrade"===e&&(t=Be),y.a.createElement("span",{className:"wds-banner__icon"},y.a.createElement(t,null))});Ue.displayName="bannerIcon";var He=function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"state",{close:!1}),v()(p()(n),"getOuterButtonClassNames",(function(){return x()("wds-banner","wds-banner--".concat(n.props.color))})),v()(p()(n),"handleClose",(function(){n.setState({close:!0}),n.props.onClose&&n.props.onClose()})),v()(p()(n),"renderActions",(function(){if(n.props.actions)return y.a.createElement("div",{className:"wds-banner__actions"},n.props.actions)})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this.props,t=e.color,n=e.showIcon,a=e.children,r=e.dismissible,l=e.show;return y.a.createElement(ce.Slide,{in:!this.state.close&&l,direction:"down",distance:"far"},y.a.createElement("div",{className:this.getOuterButtonClassNames()},r&&y.a.createElement(ve,{onClick:this.handleClose,ariaLabel:this.props.ariaLabel}),n&&Ue(t),y.a.createElement("div",{className:"wds-banner__body"},a,this.renderActions())))}}]),t}(y.a.Component);He.displayName="Banner",He.propTypes={children:E.a.node.isRequired,dismissible:E.a.bool,onClose:E.a.func,showIcon:E.a.bool,color:E.a.oneOf(Object.keys(R)),ariaLabel:E.a.node,actions:E.a.node,show:E.a.bool},He.defaultProps={dismissible:!1,onClose:null,showIcon:!1,color:"info",ariaLabel:"Close Banner",actions:null,show:!0},He.__docgenInfo={description:"",methods:[{name:"getOuterButtonClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClose",docblock:null,modifiers:[],params:[],returns:null},{name:"renderActions",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Banner",props:{dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},showIcon:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"'info'",computed:!1},type:{name:"enum",computed:!0,value:"Object.keys(iconColors)"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Banner'",computed:!1},type:{name:"node"},required:!1,description:""},actions:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var We=He,Ge=n(28),Ke=n.n(Ge),$e=(n(72),function(e){var t=e.stretched,n=e.children,a=e.size,r=e.className,l=e.color,o=e.variant,i=e.buttonType,u=e.href,s=z()(e,["stretched","children","size","className","color","variant","buttonType","href"]),c=y.a.Children.count(n),d=y.a.Children.toArray(n)[0].type,p=y.a.Children.toArray(n)[c-1].type,m=1===c&&d&&d.displayName&&d.displayName.indexOf("Icon")>=0,f=c>1&&d&&d.displayName&&d.displayName.indexOf("Icon")>=0,h=c>1&&p&&p.displayName&&p.displayName.indexOf("Icon")>=0,v=s.target&&"_blank"===s.target&&!s.rel,g=x()("wds-button",{"wds-button--stretched":t},"wds-button--".concat(l),"wds-button--".concat(o),"wds-button--".concat(a),{"wds-button--icon-left":f},{"wds-button--icon-right":h},{"wds-button--icon-only":m},r),b="button",E=i;return u&&(b="a",E=null),v&&(s.rel="noopener noreferrer"),y.a.createElement(b,Object.assign({type:E,className:g,href:u},s),n)});$e.displayName="Button",$e.defaultProps={className:"",stretched:!1,size:"md",color:"primary",buttonType:"button",variant:"solid",href:null},$e.propTypes={children:E.a.node.isRequired,className:E.a.string,size:E.a.oneOf(L),stretched:E.a.bool,color:E.a.oneOf([].concat(Ke()(Z),Ke()($))),variant:E.a.oneOf(["solid","ghost","text"]),buttonType:E.a.oneOf(["button","reset","submit"]),href:E.a.string},$e.__docgenInfo={description:"",methods:[],displayName:"Button",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",value:[{value:"...buttonColors",computed:!0},{value:"...brandColors",computed:!0}]},required:!1,description:""},buttonType:{defaultValue:{value:"'button'",computed:!1},type:{name:"enum",computed:!0,value:"buttonTypes"},required:!1,description:""},variant:{defaultValue:{value:"'solid'",computed:!1},type:{name:"enum",computed:!0,value:"variants"},required:!1,description:""},href:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Qe=$e,Ye=(n(73),function(e){var t=x()("wds-button-group",{"wds-button-group--radio":e.radio});return y.a.createElement("div",{className:t,"data-testid":e["data-testid"]},e.children)});Ye.displayName="ButtonGroup",Ye.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string,radio:E.a.bool},Ye.defaultProps={"data-testid":void 0,radio:!1},Ye.__docgenInfo={description:"",methods:[],displayName:"ButtonGroup",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},radio:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Xe=Ye,Je=(n(74),function(e){var t,n=e.addOn,a=e.children,r=e.noRule,l=e.className,o=e.padding,i=e.title,u=e.selected,s=e.interactive,c=z()(e,["addOn","children","noRule","className","padding","title","selected","interactive"]),d=x()({"wds-card":!0,"wds-card--interactive":s,"wds-card--selected":u},l),p=x()("wds-card__header",{"wds-card__header--no-rule":r}),m=function(){return y.a.createElement("div",{className:"wds-card__addon"},n)};return y.a.createElement("div",Object.assign({className:d},c),i?y.a.createElement("header",{className:p},i,n&&m()):null,(t=!i&&n&&m(),o?y.a.createElement("div",{className:"wds-card__body"},t,a):y.a.createElement(g.Fragment,null,t,a)))});Je.displayName="Card",Je.propTypes={addOn:E.a.node,children:E.a.node.isRequired,className:E.a.string,title:E.a.node,noRule:E.a.bool,padding:E.a.bool,interactive:E.a.bool,selected:E.a.bool},Je.defaultProps={addOn:null,className:"",title:null,noRule:!1,padding:!0,interactive:!1,selected:!1},Je.__docgenInfo={description:"",methods:[],displayName:"Card",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},title:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},noRule:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},padding:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},interactive:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},selected:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ze=Je,et=n(13),tt=n.n(et),nt=n(11),at=n.n(nt);function rt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}var lt=function(e){return null!=e},ot=function(e,t){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?rt(Object(n),!0).forEach((function(t){v()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):rt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},e,{},t)},it=(n(80),function(e){var t=e.checked,n=e.className,a=e["data-testid"],r=e.defaultChecked,l=e.disabled,o=e.id,i=e.name,u=e.onBlur,s=e.onChange,c=e.label,d=e.indeterminate,p=e.innerRef,m=z()(e,["checked","className","data-testid","defaultChecked","disabled","id","name","onBlur","onChange","label","indeterminate","innerRef"]),f=Object(g.useState)(!!r),h=tt()(f,2),v=h[0],b=h[1],E=Object(g.useState)(!1),w=tt()(E,2),_=w[0],C=w[1],N=Object(g.useState)(d),q=tt()(N,2),I=q[0],k=q[1];Object(g.useEffect)((function(){k(d)}),[d]);var V=ot({isChecked:v},t&&{isChecked:t}).isChecked,O=o||at()(),T=x()("wds-checkbox",{"wds-checkbox--indeterminate":I}),P=x()("wds-checkbox__native",n),S=x()("wds-checkbox__faux",{"wds-checkbox--checked":V,"wds-checkbox--focused":_});return y.a.createElement("span",{className:T},y.a.createElement("input",Object.assign({className:P,"aria-checked":V,checked:V,disabled:l,id:O,name:i,onBlur:function(e){C(!_),u&&u(e)},onFocus:function(){C(!_)},onChange:function(e){b(!V),e.persist(),s&&s(e)},tabIndex:l?-1:0,type:"checkbox",ref:p,"data-testid":a},m)),y.a.createElement("span",{className:S,"aria-hidden":"true"},y.a.createElement(je,{color:"light"})),c&&y.a.createElement("span",{className:"wds-checkbox__label"},y.a.createElement("label",{htmlFor:O},y.a.createElement(qe,{variant:"body",component:"span"},c))))});it.displayName="Checkbox",it.propTypes={checked:E.a.bool,className:E.a.string,"data-testid":E.a.string,defaultChecked:E.a.bool,disabled:E.a.bool,id:E.a.string,label:E.a.node,name:E.a.string,onBlur:E.a.func,onChange:E.a.func,indeterminate:E.a.bool,innerRef:E.a.func},it.defaultProps={checked:void 0,className:null,"data-testid":void 0,defaultChecked:!1,disabled:!1,id:null,label:null,name:null,onBlur:function(){},onChange:function(){},indeterminate:!1,innerRef:null},it.__docgenInfo={description:"",methods:[],displayName:"Checkbox",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},indeterminate:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var ut=it,st=(n(81),function(e){e.className;var t=e.size,n=z()(e,["className","size"]);return y.a.createElement("span",Object.assign({},n,{className:"wds-coachmark wds-coachmark--".concat(t)}))});st.displayName="Coachmark",st.propTypes={className:E.a.string,size:E.a.oneOf(["md","sm"])},st.defaultProps={className:null,size:"md"},st.__docgenInfo={description:"",methods:[],displayName:"Coachmark",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"coachmarkSizes"},required:!1,description:""}}};var ct=st,dt=(n(33),function(e){var t=e.children,n=e.inline,a=e.label,r=z()(e,["children","inline","label"]),l=x()("wds-form-group",{"wds-form-group--inline":n});return y.a.createElement("fieldset",{className:l,"data-testid":r["data-testid"]},a&&y.a.createElement("legend",{className:"wds-form-group__legend wds-label"},a),t)});dt.displayName="FormGroup",dt.propTypes={children:E.a.node.isRequired,inline:E.a.bool,label:E.a.node,"data-testid":E.a.string},dt.defaultProps={inline:!1,label:null,"data-testid":void 0},dt.__docgenInfo={description:"",methods:[],displayName:"FormGroup",props:{inline:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var pt=dt,mt=function(e){var t=e.children,n=e.className,a=z()(e,["children","className"]),r=x()("wds-form-group__field",n);return y.a.createElement("div",{className:r,"data-testid":a["data-testid"]},t)};mt.displayName="FormField",mt.propTypes={children:E.a.node.isRequired,className:E.a.string,"data-testid":E.a.string},mt.defaultProps={className:null,"data-testid":void 0},mt.__docgenInfo={description:"",methods:[],displayName:"FormField",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var ft=mt,ht=(n(26),function(e){var t=e.children,n=e.noBleeds,a=e.noGutters,r=e.fluid,l=e.className,o=z()(e,["children","noBleeds","noGutters","fluid","className"]),i=x()("wds-grid",{"wds-grid--no-bleeds":n},{"wds-grid--no-gutters":a},{"wds-grid--fluid":r},l);return y.a.createElement("div",Object.assign({className:i},o),t)});ht.displayName="Grid",ht.propTypes={children:E.a.node.isRequired,noBleeds:E.a.bool,fluid:E.a.bool,noGutters:E.a.bool,className:E.a.string},ht.defaultProps={noBleeds:!1,fluid:!1,noGutters:!1,className:""},ht.__docgenInfo={description:"",methods:[],displayName:"Grid",props:{noBleeds:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},fluid:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},noGutters:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var vt=ht,gt=function(e){var t=e.children,n=e.className,a=e.xsOrder,r=e.smOrder,l=e.mdOrder,o=e.lgOrder,i=e.xlOrder,u=z()(e,["children","className","xsOrder","smOrder","mdOrder","lgOrder","xlOrder"]),s=x()("wds-grid__row",n,v()({},"wds-grid__row--lg-order-".concat(o),o),v()({},"wds-grid__row--md-order-".concat(l),l),v()({},"wds-grid__row--sm-order-".concat(r),r),v()({},"wds-grid__row--xs-order-".concat(a),a),v()({},"wds-grid__row--xl-order-".concat(i),i));return y.a.createElement("div",Object.assign({className:s},u),t)};gt.displayName="Row",gt.propTypes={children:E.a.node.isRequired,className:E.a.string,xsOrder:E.a.number,smOrder:E.a.number,mdOrder:E.a.number,lgOrder:E.a.number,xlOrder:E.a.number},gt.defaultProps={className:null,xsOrder:null,smOrder:null,mdOrder:null,lgOrder:null,xlOrder:null},gt.__docgenInfo={description:"",methods:[],displayName:"Row",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},xsOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},smOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},mdOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lgOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xlOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var yt=gt,bt=function(e){var t=e.className,n=e.children,a=e.lg,r=e.md,l=e.sm,o=e.xs,i=e.xl,u=e.lgOrder,s=e.mdOrder,c=e.smOrder,d=e.xlOrder,p=e.xsOrder,m=z()(e,["className","children","lg","md","sm","xs","xl","lgOrder","mdOrder","smOrder","xlOrder","xsOrder"]),f=x()(t,"wds-grid__col",v()({},"wds-grid__col-lg-".concat(a),a),v()({},"wds-grid__col-md-".concat(r),r),v()({},"wds-grid__col-sm-".concat(l),l),v()({},"wds-grid__col-xl-".concat(i),i),v()({},"wds-grid__col-".concat(o),o),v()({},"wds-grid__col--lg-order-".concat(u),u),v()({},"wds-grid__col--md-order-".concat(s),s),v()({},"wds-grid__col--sm-order-".concat(c),c),v()({},"wds-grid__col--xl-order-".concat(d),d),v()({},"wds-grid__col--xs-order".concat(p),p));return y.a.createElement("div",Object.assign({className:f},m),n)};bt.displayName="Col",bt.propTypes={children:E.a.node.isRequired,className:E.a.string,xs:E.a.number,sm:E.a.number,md:E.a.number,lg:E.a.number,xl:E.a.number,xsOrder:E.a.number,smOrder:E.a.number,mdOrder:E.a.number,lgOrder:E.a.number,xlOrder:E.a.number},bt.defaultProps={className:"",xs:null,sm:null,md:null,lg:null,xl:null,xsOrder:null,smOrder:null,mdOrder:null,lgOrder:null,xlOrder:null},bt.__docgenInfo={description:"",methods:[],displayName:"Col",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},xs:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},sm:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},md:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lg:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xl:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xsOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},smOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},mdOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},lgOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},xlOrder:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Et=bt,wt=(n(82),function(e){var t=e.children,n=e.color,a=e.className,r=e.size,l=z()(e,["children","color","className","size"]),o=x()("wds-icon",v()({},"wds-type--".concat(n),n),v()({},"wds-icon--".concat(r),r),a);return y.a.createElement("span",{className:o,"aria-hidden":"true","data-testid":l["data-testid"]},t)});wt.displayName="Icon",wt.propTypes={children:E.a.string.isRequired,size:E.a.oneOf(H),color:E.a.string,className:E.a.string,"data-testid":E.a.string},wt.defaultProps={className:"",size:null,color:"","data-testid":void 0},wt.__docgenInfo={description:"",methods:[],displayName:"Icon",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},color:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"string"},required:!0,description:""}}};var zt=wt,_t=(n(84),function(e){var t=e.children,n=e.className,a=e.htmlFor,r=e.muted,l=e.plain,o=x()("wds-label",{"wds-label--muted":r},{"wds-label--plain":l},n);return y.a.createElement("label",{className:o,htmlFor:a},t)});_t.displayName="Label",_t.propTypes={children:E.a.oneOfType([E.a.string,E.a.node]).isRequired,className:E.a.string,htmlFor:E.a.string.isRequired,muted:E.a.bool,plain:E.a.bool},_t.defaultProps={className:null,muted:!1,plain:!1},_t.__docgenInfo={description:"",methods:[],displayName:"Label",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},muted:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},plain:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"union",value:[{name:"string"},{name:"node"}]},required:!0,description:""},htmlFor:{type:{name:"string"},required:!0,description:""}}};var xt=_t,Ct=(n(83),function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"handleBlur",(function(e){n.props.onBlur&&n.props.onBlur(e)})),v()(p()(n),"handleChange",(function(e){n.state.isControlled&&e.target.value!==n.state.value&&(e.persist(),n.setState({value:e.target.value},(function(){n.props.onChange&&n.props.onChange(e)})))})),v()(p()(n),"renderErrorMessage",(function(){if("warning"===n.props.color&&n.props.errorMessage){var e=x()("wds-type--caption","wds-m-t-2","wds-type--".concat(n.props.color));return y.a.createElement("div",{className:e},n.props.errorMessage)}if(n.props.color&&n.props.errorMessage)throw new Error("Having an errorMessage and a success theme is not allowed");return null})),v()(p()(n),"renderLabel",(function(){return n.props.label?y.a.createElement(xt,{className:"",htmlFor:n.inputID},n.props.label):null})),n.state={isControlled:lt(e.value),value:e.value},n.inputID=e.id||at()(),n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.value!==this.state.value&&this.setState({value:e.value})}},{key:"renderInput",value:function(){var e=this.props,t=e.className,n=e.defaultValue,a=e.disabled,r=(e.errorMessage,e.inputRef),l=e.inputSize,o=(e.label,e.name),i=(e.onBlur,e.onChange,e.size),u=e.stretched,s=e.color,c=(e.value,z()(e,["className","defaultValue","disabled","errorMessage","inputRef","inputSize","label","name","onBlur","onChange","size","stretched","color","value"])),d=x()("wds-input","wds-input--".concat(i),{"wds-input--stretched":u},v()({},"wds-input--".concat(s),s),t);return y.a.createElement("input",Object.assign({},c,{className:d,defaultValue:n,disabled:a,id:this.inputID,ref:r,name:o,onBlur:this.handleBlur,onChange:this.handleChange,value:this.state.value,size:l}))}},{key:"render",value:function(){return y.a.createElement(g.Fragment,null,this.renderLabel(),this.renderInput(),this.renderErrorMessage())}}]),t}(y.a.Component));Ct.displayName="Input",Ct.propTypes={className:E.a.string,defaultValue:E.a.node,disabled:E.a.bool,errorMessage:E.a.node,id:E.a.string,inputRef:E.a.func,inputSize:E.a.number,label:E.a.node,name:E.a.string,onBlur:E.a.func,onChange:E.a.func,size:E.a.oneOf(L),stretched:E.a.bool,color:E.a.oneOf(te),value:E.a.node},Ct.defaultProps={className:null,defaultValue:void 0,disabled:!1,errorMessage:null,id:null,inputRef:null,inputSize:null,label:null,name:null,onBlur:null,onChange:null,size:"md",stretched:!1,color:null,value:void 0},Ct.__docgenInfo={description:"",methods:[{name:"handleBlur",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"renderErrorMessage",docblock:null,modifiers:[],params:[],returns:null},{name:"renderInput",docblock:null,modifiers:[],params:[],returns:null},{name:"renderLabel",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Input",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},defaultValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},errorMessage:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},inputRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},inputSize:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputColors"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""}}};var Nt=Ct,qt=(n(34),function(e){var t=e.children,n=e.className,a=e.id,r=e.label,l=e.stretched,o=e.disabled,i=e.color,u=z()(e,["children","className","id","label","stretched","disabled","color"]),s=a||at()(),c=x()("wds-input-group",{"wds-input-group--stretched":l},{"wds-input-group--disabled":o},v()({},"wds-input-group--".concat(i),i),n);return y.a.createElement(g.Fragment,null,r&&y.a.createElement(xt,{htmlFor:s},r),y.a.createElement("div",{id:s,className:c,"data-testid":u["data-testid"]},t))});qt.displayName="InputGroup",qt.propTypes={children:E.a.node.isRequired,className:E.a.string,id:E.a.string,label:E.a.node,stretched:E.a.bool,disabled:E.a.bool,color:E.a.oneOf(G),"data-testid":E.a.string},qt.defaultProps={className:null,id:null,label:null,stretched:!1,disabled:!1,color:null,"data-testid":void 0},qt.__docgenInfo={description:"",methods:[],displayName:"InputGroup",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var It=qt,kt=function(e){var t=e.children,n=z()(e,["children"]);return y.a.createElement("div",{className:"wds-input-group__addon","data-testid":n["data-testid"]},t)};kt.displayName="InputGroupAddon",kt.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},kt.defaultProps={"data-testid":void 0},kt.__docgenInfo={description:"",methods:[],displayName:"InputGroupAddon",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Vt=kt,Ot=(n(85),function(e){var t=e.children,n=e.className,a=e.color,r=z()(e,["children","className","color"]),l=x()("wds-link",{"wds-link--light":"light"===a},n);return y.a.createElement("a",Object.assign({},r,{className:l}),t)});Ot.displayName="Link",Ot.propTypes={children:E.a.node.isRequired,className:E.a.string,color:E.a.oneOf(["light","dark"])},Ot.defaultProps={className:null,color:"dark"},Ot.__docgenInfo={description:"",methods:[],displayName:"Link",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"'dark'",computed:!1},type:{name:"enum",value:[{value:"'light'",computed:!1},{value:"'dark'",computed:!1}]},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Tt=Ot,Pt=n(17),St=n.n(Pt),jt=n(14),Ft=(n(27),function(e){return y.a.createElement("section",{className:"wds-menu__group","data-testid":e["data-testid"]},e.children)});Ft.displayName="MenuGroup",Ft.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Ft.defaultProps={"data-testid":void 0},Ft.__docgenInfo={description:"",methods:[],displayName:"MenuGroup",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Bt=Ft,Mt="undefined"!=typeof window,Rt=function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"setInitialRefs",(function(e){n.itemRefs=[],n.focusableItems=n.getFocusableItems(e)})),v()(p()(n),"setFocusableItemRefs",(function(e){return function(t){e>-1&&t&&(n.itemRefs[e]=t)}})),v()(p()(n),"getFocusableItems",(function(e){var t=e.children,n=[];return y.a.Children.forEach(t,(function(e){return y.a.isValidElement(e)&&(e.type&&"MenuGroup"===e.type.displayName?y.a.Children.forEach(e.props.children,(function(e){e.props.disabled||n.push(e)})):e.props.disabled||n.push(e)),null})),n})),v()(p()(n),"getSlideDirection",(function(){var e=n.props.placement;return e&&e.indexOf("top")>=0?"up":"down"})),v()(p()(n),"getOuterClassNames",(function(){var e=n.props,t=e.noMaxHeight,a=e.stretched;return x()("wds-has-menu",{"wds-has-menu--stretched":a},{"wds-menu--no-max-height":t})})),v()(p()(n),"getMenuClassNames",(function(){var e=n.props.placement;return x()("wds-menu",v()({},"wds-menu--".concat(e),e))})),v()(p()(n),"handleScroll",(function(){n.state.show&&n.props.renderTo&&n.updatePosition()})),v()(p()(n),"handleAutoScroll",(function(e){if(e>-1&&n.itemRefs[e]){var t=n.itemRefs[e].offsetTop+n.itemRefs[e].offsetHeight,a=n.innerMenu.offsetHeight;n.innerMenu.scrollTop=t<=a?0:t-a}})),v()(p()(n),"handleOnKeyDown",(function(e){var t=n.props.menuTrigger,a=n.state,r=a.focusIndex,l=a.show,o=r;if(t.props.onKeyDown&&t.props.onKeyDown(e),l){switch(e.keyCode){case K.UP:o=r>0?r-1:n.focusableItems.length-1,e.preventDefault();break;case K.DOWN:o=r===n.focusableItems.length-1?0:r+1,e.preventDefault();break;case K.ESC:n.setState({show:!1})}n.handleAutoScroll(o),n.setState({focusIndex:o})}l||e.keyCode!==K.UP&&e.keyCode!==K.DOWN||(n.handleOnClick(e),e.preventDefault())})),v()(p()(n),"handleOnKeyPress",(function(e){var t=n.props.menuTrigger,a=n.state.focusIndex;(e.charCode===K.ENTER||e.charCode===K.SPACE&&"Button"!==t.type.displayName&&"Input"!==t.type.displayName)&&(a>-1?n.itemRefs[a].click():n.handleOnClick(e),e.preventDefault()),n.setState({focusIndex:-1})})),v()(p()(n),"handleAutoCloseBlur",(function(){setTimeout((function(){n.menu&&!n.menu.contains(document.activeElement)&&n.menuChange(!1)}),0)})),v()(p()(n),"handleMenuClose",(function(){n.props.autoClose&&n.menuChange(!1)})),v()(p()(n),"handleOnClick",(function(e){var t=n.state.show;n.menuChange(!t),e.stopPropagation()})),v()(p()(n),"menuChange",(function(e){n.setState({show:e}),n.props.onChange&&n.props.onChange({show:e})})),v()(p()(n),"updatePosition",(function(){var e=n.props.placement,t=n.state.show;if(n.menu&&t&&n.innerMenu.children&&n.innerMenu.children.length){var a,r,l=n.menu.getBoundingClientRect(),o=n.innerMenu.getBoundingClientRect();"top-left"===e?(a=l.top-o.height,r=l.left):"top-right"===e?(a=l.top-o.height,r=l.right-o.width):"bottom-left"===e?(a=l.bottom,r=l.left):(a=l.bottom,r=l.right-o.width),n.setState({menuStyle:{top:"".concat(a,"px"),left:"".concat(r,"px"),zIndex:jt["z-index"]["z--space"]+1,position:"fixed",right:"auto",bottom:"auto"}})}})),v()(p()(n),"menuRef",(function(e){return n.menu=e})),v()(p()(n),"renderMenu",(function(){var e=n.props,t=e.renderTo,a=e.role,r=y.a.createElement(ce.Fade,{in:n.state.show,speed:"fast"},y.a.createElement("div",{className:n.getMenuClassNames(),style:n.state.menuStyle,role:a},y.a.createElement("div",{className:"wds-menu__body",ref:function(e){n.innerMenu=e}},n.renderList())));return t?St.a.createPortal(r,t):r})),v()(p()(n),"renderList",(function(){var e=n.props,t=e.children,a=e.dense,r=y.a.Children.map(t,(function(e,t){return y.a.isValidElement(e)&&e.type&&"MenuGroup"===e.type.displayName?y.a.createElement(Bt,{"data-testid":e.props["data-testid"]},y.a.createElement(T,Object.assign({interactive:!0,noRules:!0,dense:a},n.props),n.renderListItems(e.props.children,t,n.handleMenuClose))):null}));return r.length?r:y.a.createElement(T,Object.assign({interactive:!0,dense:n.props.dense},n.props),n.props.children&&n.renderListItems(t,0,n.handleMenuClose))})),v()(p()(n),"renderListItems",(function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,a=arguments.length>2?arguments[2]:void 0,r=n.state.focusIndex;return y.a.Children.map(e,(function(e){var l=n.focusableItems.indexOf(e);return y.a.isValidElement(e)?y.a.cloneElement(e,{groupindex:t,isFocused:l>-1&&r===l,innerRef:n.setFocusableItemRefs(l),handleMenuClose:a}):null}))})),v()(p()(n),"renderTrigger",(function(){var e=n.props,t=e.menuTrigger,a=e.show,r=e.role;return y.a.cloneElement(t,{"aria-haspopup":r,"aria-expanded":n.state.show,"aria-owns":a?n.id:null,onClick:n.handleOnClick,onKeyDown:n.handleOnKeyDown,onKeyPress:n.handleOnKeyPress,tabIndex:0})})),n.state={show:e.show,focusIndex:-1,menuStyle:null},n.setInitialRefs(e),n}return f()(t,e),o()(t,[{key:"componentDidMount",value:function(){this.state.show&&this.props.renderTo&&this.updatePosition(),Mt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.show!==this.state.show&&e.show!==this.props.show&&this.setState({show:e.show}),this.setInitialRefs(e)}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.props.renderTo&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){Mt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll))}},{key:"render",value:function(){return y.a.createElement("span",{className:this.getOuterClassNames(),onBlur:this.props.autoClose?this.handleAutoCloseBlur:null,ref:this.menuRef},this.renderTrigger(),this.renderMenu())}}]),t}(g.Component);Rt.displayName="Menu",Rt.propTypes={autoClose:E.a.bool,children:E.a.node.isRequired,dense:E.a.bool,placement:E.a.oneOf(A),menuTrigger:E.a.node.isRequired,noMaxHeight:E.a.bool,onChange:E.a.func,show:E.a.bool,stretched:E.a.bool,"data-testid":E.a.string,renderTo:E.a.oneOfType([E.a.func,E.a.shape({current:E.a.elementType})]),role:E.a.string},Rt.defaultProps={autoClose:!0,dense:!1,placement:null,noMaxHeight:!1,onChange:null,stretched:!1,show:!1,"data-testid":void 0,renderTo:null,role:"menu"},Rt.__docgenInfo={description:"",methods:[{name:"setInitialRefs",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null},{name:"setFocusableItemRefs",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null},{name:"getFocusableItems",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"getOuterClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"getMenuClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"handleAutoScroll",docblock:null,modifiers:[],params:[{name:"focusIndex",type:null}],returns:null},{name:"handleOnKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleOnKeyPress",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleAutoCloseBlur",docblock:null,modifiers:[],params:[],returns:null},{name:"handleMenuClose",docblock:null,modifiers:[],params:[],returns:null},{name:"handleOnClick",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"menuChange",docblock:null,modifiers:[],params:[{name:"show",type:null}],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"menuRef",docblock:null,modifiers:[],params:[{name:"menu",type:null}],returns:null},{name:"renderMenu",docblock:null,modifiers:[],params:[],returns:null},{name:"renderList",docblock:null,modifiers:[],params:[],returns:null},{name:"renderListItems",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"groupindex",type:null},{name:"handleMenuClose",type:null}],returns:null},{name:"renderTrigger",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Menu",props:{autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dense:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"menuPlacements"},required:!1,description:""},noMaxHeight:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},role:{defaultValue:{value:"'menu'",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},menuTrigger:{type:{name:"node"},required:!0,description:""}}};var Lt=Rt,At=function(e){var t=e.addOn,n=e.addOnPlacement,a=e.color,r=e.onClick,l=e.children,o=e.disabled,i=e.marked,u=e.upgrade,s=e.groupindex,c=e.handleMenuClose,d=e.index,p=e.role,m=z()(e,["addOn","addOnPlacement","color","onClick","children","disabled","marked","upgrade","groupindex","handleMenuClose","index","role"]);return y.a.createElement(ie,Object.assign({addOn:t,addOnPlacement:n,color:a,onClick:function(e){r&&r(e),c(),e.stopPropagation()},disabled:o,marked:i,upgrade:u,index:d,"data-group":s},m,{tabIndex:o?"-1":0,role:p}),l)};At.displayName="MenuItem",At.propTypes={addOn:E.a.node,addOnPlacement:E.a.string,children:E.a.node.isRequired,color:E.a.string,disabled:E.a.bool,groupindex:E.a.number,index:E.a.number,marked:E.a.bool,onClick:E.a.func,upgrade:E.a.bool,isNavigable:E.a.bool,navigationTarget:E.a.string,isFocused:E.a.bool,handleMenuClose:E.a.func,role:E.a.string},At.defaultProps={addOn:null,addOnPlacement:null,color:null,disabled:!1,groupindex:null,index:null,marked:!1,onClick:null,upgrade:!1,isNavigable:!1,navigationTarget:"javascript:void(0)",isFocused:!1,handleMenuClose:function(){},role:"menuitem"},At.__docgenInfo={description:"",methods:[],displayName:"MenuItem",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},groupindex:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},index:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},upgrade:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isNavigable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},navigationTarget:{defaultValue:{value:"'javascript:void(0)'",computed:!1},type:{name:"string"},required:!1,description:""},isFocused:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},handleMenuClose:{defaultValue:{value:"() => {}",computed:!1},type:{name:"func"},required:!1,description:""},role:{defaultValue:{value:"'menuitem'",computed:!1},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Dt=At,Ut=(n(22),function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"closeButton",(function(){var e=n.props,t=e.ariaLabel,a=e.closeButtonClass;return n.props.dismissible?y.a.createElement(ve,{onClick:n.handleClick,ariaLabel:t,className:a||null,"data-testid":n.props["data-testid"]?"".concat(n.props["data-testid"],"_CloseModal"):void 0}):null})),v()(p()(n),"handleClick",(function(){if(n.props.dismissible){var e=n.props.onClose;e&&e()}})),n}return f()(t,e),o()(t,[{key:"componentDidMount",value:function(){this.modal&&this.modal.focus()}},{key:"render",value:function(){var e=this,t=this.props,n=t.className,a=t.size,r=t.show,l=x()("wds-modal",n,"wds-modal--".concat(a));return y.a.createElement(g.Fragment,null,y.a.createElement(ce.Fade,{in:r},y.a.createElement(pe,{onClick:this.handleClick})),y.a.createElement(ce.Slide,{in:r,direction:"down",distance:"near",speed:"fast"},y.a.createElement("div",{className:l,"data-testid":this.props["data-testid"]},y.a.createElement("div",{role:"dialog",className:"wds-modal__modal",ref:function(t){e.modal=t},tabIndex:"-1"},this.closeButton(),this.props.children))))}}]),t}(g.Component));Ut.displayName="Modal",Ut.defaultProps={className:"",closeButtonClass:"",dismissible:!0,onClose:null,show:!1,size:"sm",ariaLabel:"Close Modal","data-testid":void 0},Ut.propTypes={children:E.a.node.isRequired,className:E.a.string,closeButtonClass:E.a.string,dismissible:E.a.bool,onClose:E.a.func,show:E.a.bool,size:E.a.oneOf(L),ariaLabel:E.a.node,"data-testid":E.a.string},Ut.__docgenInfo={description:"",methods:[{name:"closeButton",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Modal",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},closeButtonClass:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},dismissible:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Modal'",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ht=Ut,Wt=function(e){var t=e.children,n=e.padding,a=z()(e,["children","padding"]);return y.a.createElement("section",{className:"wds-modal__body","data-testid":a["data-testid"]},y.a.createElement(j,{padding:n,transparent:!0},t))};Wt.displayName="ModalBody",Wt.propTypes={children:E.a.node.isRequired,padding:E.a.bool,"data-testid":E.a.string},Wt.defaultProps={padding:!0,"data-testid":void 0},Wt.__docgenInfo={description:"",methods:[],displayName:"ModalBody",props:{padding:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Gt=Wt,Kt=function(e){return y.a.createElement("footer",{className:"wds-modal__foot","data-testid":e["data-testid"]},e.children)};Kt.displayName="ModalFooter",Kt.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Kt.defaultProps={"data-testid":void 0},Kt.__docgenInfo={description:"",methods:[],displayName:"ModalFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var $t=Kt,Qt=function(e){var t=e.addOn,n=e.header,a=e.subHeader,r=e.stretched,l=z()(e,["addOn","header","subHeader","stretched"]);if(a&&t)throw new Error("You cannot have both subHeader and addon");if(!n&&a)throw new Error("You must provide a header if you provide a subHeader");var o=x()("wds-modal__addon",{"wds-modal__addon--stretched":r||!n});return y.a.createElement("header",{className:"wds-modal__head","data-testid":l["data-testid"]},y.a.createElement("div",{className:"wds-modal__title"},n&&y.a.createElement("h1",{className:"wds-modal__text"},n),a&&y.a.createElement("p",{className:"wds-modal__sub-text"},a)),t&&y.a.createElement("div",{className:o},t))};Qt.displayName="ModalHeader",Qt.defaultProps={addOn:null,header:null,stretched:!1,subHeader:null,"data-testid":void 0},Qt.propTypes={addOn:E.a.node,header:E.a.node,stretched:E.a.bool,subHeader:E.a.node,"data-testid":E.a.string},Qt.__docgenInfo={description:"",methods:[],displayName:"ModalHeader",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},header:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},subHeader:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var Yt=Qt,Xt=function(e){var t=e.placement,n=e.children;return y.a.createElement("div",{className:"wds-modal__actions-".concat(t)},n)};Xt.displayName="Align",Xt.propTypes={children:E.a.node.isRequired,placement:E.a.oneOf(["left","right"]).isRequired},Xt.__docgenInfo={description:"",methods:[],displayName:"Align",props:{children:{type:{name:"node"},required:!0,description:""},placement:{type:{name:"enum",value:[{value:"'left'",computed:!1},{value:"'right'",computed:!1}]},required:!0,description:""}}};var Jt=Xt,Zt=(n(35),function(e){function t(e){var n;r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"getSelectedOrder",(function(e){return e.map((function(e,t){return"MultiselectOption"===e.type.displayName&&e.props.selected?t:null})).filter((function(e){return null!==e}))})),v()(p()(n),"handleMenuChange",(function(e){var t=e.show;n.props.onMenuChange(t),n.setState({showMenu:t})})),v()(p()(n),"handleKeyDown",(function(e){var t,a=e.keyCode===K.BACKSPACE,r=""==e.target.value,l=0!==n.selectedMenuItems.length;a&&r&&l&&(y.a.Children.forEach(n.selectedMenuItems,(function(e){t=e.props["data-index"]})),n.removeBadge(t))})),v()(p()(n),"handleKeyUp",(function(e){var t=n.props.autocomplete;e.keyCode===K.ESC?(n.setState({filterBy:"",showMenu:!1}),n.inputRef&&n.inputRef.blur()):t&&n.setState({filterBy:e.target.value,showMenu:!0})})),v()(p()(n),"removeBadge",(function(e){var t=n.state.options,a=n.props.onRemove,r=y.a.cloneElement(t[e],{selected:!1});t[e]=r;var l=n.selectedOrder.indexOf(e);n.selectedOrder.splice(l,1),n.setState({options:t,showMenu:!0}),a&&a(e)}));var a=y.a.Children.toArray(e.children);return n.selectedMenuItems=[],n.menuItems=[],n.selectedOrder=n.getSelectedOrder(a),n.state={options:a,showMenu:e.show,filterBy:e.value||""},n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=y.a.Children.toArray(e.children);this.selectedOrder=this.getSelectedOrder(t),this.setState({options:t,showMenu:e.show})}},{key:"componentDidUpdate",value:function(){this.state.showMenu&&this.inputRef&&this.inputRef.focus()}},{key:"getBadge",value:function(e,t){var n=this,a="multiselect-child-".concat(t);return y.a.cloneElement(e,{key:a,id:a,"data-index":t,onClose:function(){return n.removeBadge(t)},dismissible:!0})}},{key:"getMenuItem",value:function(e,t,n){var a=this,r=this.props.autocomplete,l=this.state.filterBy,o="multiselect-child-".concat(t),i=e.props,u=i.children,s=i.className,c=i.disabled,d=i.icon,p=i.value||u,m="string"==typeof p&&p.toUpperCase().indexOf(l.toUpperCase())>=0,f=r&&!m,h=c||f,v=x()({"wds-display--none":f},s);return y.a.createElement(Dt,{className:v,key:o,id:o,disabled:h,onClick:function(){return a.clickMenuItem(t,n)},addOn:n&&y.a.createElement("span",{className:"multiselect__checked"},y.a.createElement(je,{color:"success"})),"data-testid":e.props["data-testid"]},d,u)}},{key:"clickMenuItem",value:function(e,t){this[t?"removeBadge":"addBadge"](e)}},{key:"addBadge",value:function(e){var t=this.state.options,n=this.props.onAdd,a=y.a.cloneElement(t[e],{selected:!0});t[e]=a,this.selectedOrder.push(e),this.setState({options:t,showMenu:!0,filterBy:""}),n&&n(e)}},{key:"render",value:function(){var e=this,t=this.props,n=t.addOn,a=t.addOnPlacement,r=t.autoClose,l=t.className,o=t.id,i=t.label,u=t.disabled,s=t.color,c=t.placeholder,d=t.removeFromMenu,p=t.inputProps,m=t.value,f=t.useBadges,h=t.readOnly,b=this.state,E=b.options,w=b.showMenu,z=o||at()(),_=x()("wds-multiselect",{"wds-multiselect--disabled":u},v()({},"wds-multiselect--".concat(s),s),l),C=y.a.createElement(Nt,Object.assign({},p,{id:z,inputRef:function(t){e.inputRef=t},placeholder:c,defaultValue:m,readOnly:h,onKeyDown:function(t){e.handleKeyDown(t),p&&p.onKeyDown&&p.onKeyDown(t)},onKeyUp:function(t){e.handleKeyUp(t),p&&p.onKeyUp&&p.onKeyUp(t)}})),N=function(){return n&&y.a.createElement("div",{className:"wds-multiselect__addon"},n)};return this.selectedMenuItems=[],this.menuItems=[],y.a.Children.forEach(E,(function(t,n){t.props.selected?!d&&t.props.selected&&e.menuItems.push(e.getMenuItem(t,n,t.props.selected)):e.menuItems.push(e.getMenuItem(t,n))})),this.selectedOrder.forEach((function(t){e.selectedMenuItems.push(e.getBadge(E[t],t))})),y.a.createElement(g.Fragment,null,i&&y.a.createElement(xt,{htmlFor:z},i),y.a.createElement("div",{id:z,className:_,selection:this.selectedMenuItems,"data-testid":this.props["data-testid"]},"left"===a&&N(),y.a.createElement("div",{className:"wds-multiselect__main"},f&&this.selectedMenuItems,y.a.createElement(Lt,{autoClose:r,dense:!0,noRules:!0,menuTrigger:C,show:w,onChange:this.handleMenuChange},this.menuItems)),"right"===a&&N()))}}]),t}(g.Component));Zt.displayName="Multiselect",Zt.propTypes={addOnPlacement:E.a.oneOf(D),autoClose:E.a.bool,children:E.a.node.isRequired,className:E.a.string,id:E.a.string,label:E.a.node,disabled:E.a.bool,color:E.a.oneOf(G),placeholder:E.a.node,value:E.a.node,onAdd:E.a.func,onRemove:E.a.func,autocomplete:E.a.bool,readOnly:E.a.bool,removeFromMenu:function(e,t,n){return!e.useBadges&&e[t]?new Error("removeFromMenu prop should not be passed if `useBadges` is set to false"):"boolean"!=typeof e[t]?new Error("Invalid prop ".concat(t," supplied to ").concat(n,". Expected boolean")):null},addOn:E.a.node,"data-testid":E.a.string,inputProps:E.a.shape({onKeyUp:E.a.func,onKeyDown:E.a.func}),useBadges:E.a.bool,onMenuChange:E.a.func,show:E.a.bool},Zt.defaultProps={id:null,label:null,placeholder:null,className:null,color:null,addOn:null,addOnPlacement:"left",autoClose:!0,inputProps:null,"data-testid":void 0,value:"",disabled:!1,autocomplete:!0,readOnly:!1,removeFromMenu:!1,useBadges:!0,show:!1,onAdd:function(){},onRemove:function(){},onMenuChange:function(){}},Zt.__docgenInfo={description:"",methods:[{name:"getSelectedOrder",docblock:null,modifiers:[],params:[{name:"options",type:null}],returns:null},{name:"getBadge",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null}],returns:null},{name:"getMenuItem",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"handleMenuChange",docblock:null,modifiers:[],params:[{name:"{ show: showMenu }",type:null}],returns:null},{name:"clickMenuItem",docblock:null,modifiers:[],params:[{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"handleKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleKeyUp",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"addBadge",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null},{name:"removeBadge",docblock:null,modifiers:[],params:[{name:"index",type:null}],returns:null}],displayName:"Multiselect",props:{id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},placeholder:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},addOnPlacement:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},inputProps:{defaultValue:{value:"null",computed:!1},type:{name:"shape",value:{onKeyUp:{name:"func",required:!1},onKeyDown:{name:"func",required:!1}}},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},value:{defaultValue:{value:"''",computed:!1},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},autocomplete:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},readOnly:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},removeFromMenu:{defaultValue:{value:"false",computed:!1},type:{name:"custom",raw:"(props, propName, componentName) => {\n  if (!props['useBadges'] && props[propName]) {\n    return new Error(\n      'removeFromMenu prop should not be passed if `useBadges` is set to false'\n    );\n  }\n\n  if (typeof props[propName] !== 'boolean') {\n    return new Error(\n      `Invalid prop ${propName} supplied to ${componentName}. Expected boolean`\n    );\n  }\n\n  return null;\n}"},required:!1,description:""},useBadges:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onAdd:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},onRemove:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},onMenuChange:{defaultValue:{value:"function() {}",computed:!1},type:{name:"func"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var en=Zt,tn=function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"handleClick",(function(){var e=n.props.onClose;e&&e()})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this.props,t=e.className,n=e.color,a=e.children,r=e.dismissible,l=e.icon,o=e.value,i=x()("wds-badge","wds-badge--".concat(n),{"wds-badge--dismissible":r},t),u="light";return"muted"!=n&&"upgrade"!=n&&"info"!=n||(u="dark"),y.a.createElement("span",{className:i,"data-testid":this.props["data-testid"]},l,o||a,r&&y.a.createElement(ve,{variant:u,onClick:this.handleClick}))}}]),t}(y.a.Component);tn.displayName="MultiselectOption",tn.defaultProps={className:null,color:"primary",dismissible:!1,icon:null,onClose:null,value:"","data-testid":void 0},tn.propTypes={children:E.a.node.isRequired,className:E.a.string,color:E.a.oneOf(J),dismissible:E.a.bool,onClose:E.a.func,icon:E.a.node,value:E.a.node,"data-testid":E.a.string},tn.__docgenInfo={description:"",methods:[{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null}],displayName:"MultiselectOption",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"'primary'",computed:!1},type:{name:"enum",computed:!0,value:"multiSelectColors"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},icon:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},value:{defaultValue:{value:"''",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var nn=tn,an=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m15.2012 7.25h-14.4024a.75.75 0 0 0 0 1.5h14.4024a.75.75 0 0 0 0-1.5z"})))};an.displayName="IconMinus",an.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},an.defaultProps={title:"Minus",color:null,size:null},an.__docgenInfo={description:"",methods:[],displayName:"IconMinus",props:{title:{defaultValue:{value:"'Minus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var rn=an,ln=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m15.2012 7.25h-6.4512v-6.4512a.75.75 0 0 0 -1.5 0v6.4512h-6.4512a.75.75 0 0 0 0 1.5h6.4512v6.4512a.75.75 0 0 0 1.5 0v-6.4512h6.4512a.75.75 0 0 0 0-1.5z"})))};ln.displayName="IconPlus",ln.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},ln.defaultProps={title:"Plus",color:null,size:null},ln.__docgenInfo={description:"",methods:[],displayName:"IconPlus",props:{title:{defaultValue:{value:"'Plus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var on=ln,un=(n(86),function(e){function t(e){var n;r()(this,t),n=u()(this,c()(t).call(this,e));var a=e.min,l=e.value,o=e.max;return n.state={value:Math.round(l<a?a:o&&l>o?o:l)},n.manualInput=y.a.createRef(),n}return f()(t,e),o()(t,[{key:"shouldDisableMinus",value:function(){return this.state.value<=this.props.min}},{key:"shouldDisablePlus",value:function(){var e=this.props.max;return e&&this.state.value>=e}},{key:"handleMinus",value:function(){var e=this.props,t=e.min,n=e.step,a=this.state.value-n,r=a<t?t:a;this.handleChange(r),this.setState({value:r})}},{key:"handlePlus",value:function(){var e=this.props,t=e.max,n=e.step,a=this.state.value+n,r=t&&a>t?t:a;this.handleChange(r),this.setState({value:r})}},{key:"handleInputChange",value:function(){var e=this.props,t=e.min,n=e.max,a=this.manualInput.current.state.value,r=parseInt(a,10)||t,l=r<t?t:r,o=n&&l>n?n:l;this.handleChange(o),this.setState({value:o})}},{key:"handleChange",value:function(e){var t=this.props.onChange;t&&t(e)}},{key:"render",value:function(){var e=this,t=this.props,n=t.label,a=t.stretched,r=t.color,l=t.disabled,o=t.editable,i=this.state.value,u=x()({"wds-number-picker":!0,"wds-number-picker--stretched":a,"wds-number-picker--editable":o});return y.a.createElement("div",{className:u,"data-testid":this.props["data-testid"]},y.a.createElement(It,{label:n,stretched:a,color:r,disabled:l},y.a.createElement(Vt,{"data-testid":this.props["data-testid"]?"".concat(this.props["data-testid"],"_Minus"):void 0},y.a.createElement(Qe,{size:"sm",color:"muted",onClick:function(){return e.handleMinus()},disabled:this.shouldDisableMinus()},y.a.createElement(rn,null))),o&&y.a.createElement(Nt,{ref:this.manualInput,inputSize:3,value:i,onChange:function(){return e.handleInputChange()}}),!o&&y.a.createElement("div",{className:"wds-input"},i),y.a.createElement(Vt,{"data-testid":this.props["data-testid"]?"".concat(this.props["data-testid"],"_Plus"):void 0},y.a.createElement(Qe,{size:"sm",color:"muted",onClick:function(){return e.handlePlus()},disabled:this.shouldDisablePlus()},y.a.createElement(on,null)))))}}]),t}(y.a.Component));un.displayName="NumberPicker",un.propTypes={label:E.a.node,stretched:E.a.bool,value:E.a.number,onChange:E.a.func,min:E.a.number,max:E.a.number,step:E.a.number,color:E.a.oneOf(G),disabled:E.a.bool,editable:E.a.bool,"data-testid":E.a.string},un.defaultProps={label:null,stretched:!1,value:0,onChange:function(){return null},min:0,max:null,step:1,color:null,disabled:!1,editable:!1,"data-testid":void 0},un.__docgenInfo={description:"",methods:[{name:"shouldDisableMinus",docblock:null,modifiers:[],params:[],returns:null},{name:"shouldDisablePlus",docblock:null,modifiers:[],params:[],returns:null},{name:"handleMinus",docblock:null,modifiers:[],params:[],returns:null},{name:"handlePlus",docblock:null,modifiers:[],params:[],returns:null},{name:"handleInputChange",docblock:null,modifiers:[],params:[],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null}],displayName:"NumberPicker",props:{label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},value:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},onChange:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},min:{defaultValue:{value:"0",computed:!1},type:{name:"number"},required:!1,description:""},max:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},step:{defaultValue:{value:"1",computed:!1},type:{name:"number"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},editable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var sn=un,cn=(n(87),function(e){var t=e.addOn,n=e.centered,a=e.subTitle,r=e.title,l=z()(e,["addOn","centered","subTitle","title"]);return y.a.createElement("div",{className:x()("wds-pageheader",{"wds-pageheader--centered":n}),"data-testid":l["data-testid"]},y.a.createElement("div",{className:"wds-pageheader__text"},y.a.createElement("h1",{className:"wds-pageheader__title wds-type--section-title"},r),a?y.a.createElement("span",{className:"wds-pageheader__subtitle"},a):null),t?y.a.createElement("div",{className:"wds-pageheader__addon"},t):null)});cn.displayName="PageHeader",cn.propTypes={addOn:E.a.node,centered:E.a.bool,subTitle:E.a.node,title:E.a.node.isRequired,"data-testid":E.a.string},cn.defaultProps={addOn:null,centered:!1,subTitle:null,"data-testid":void 0},cn.__docgenInfo={description:"",methods:[],displayName:"PageHeader",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},centered:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},subTitle:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},title:{type:{name:"node"},required:!0,description:""}}};var dn=cn,pn=(n(36),function(e){var t=e.children,n=e.disabled,a=e.value,r=z()(e,["children","disabled","value"]);return y.a.createElement("option",{disabled:n,value:a,"data-testid":r["data-testid"]},t)});pn.displayName="Option",pn.propTypes={children:E.a.node.isRequired,disabled:E.a.bool,selectedValue:E.a.node,value:E.a.string.isRequired,"data-testid":E.a.string},pn.defaultProps={disabled:!1,selectedValue:null,"data-testid":void 0},pn.__docgenInfo={description:"",methods:[],displayName:"Option",props:{disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},selectedValue:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},value:{type:{name:"string"},required:!0,description:""}}};var mn=pn,fn=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m1.7438 4.55c-.605 0-.75.35-.3222.7778l5.8006 5.8006a1.1032 1.1032 0 0 0 1.5556 0l5.8006-5.8006c.4278-.4278.2828-.7778-.3222-.7778z"})))};fn.displayName="IconCaretDown",fn.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},fn.defaultProps={title:"CaretDown",color:null,size:null},fn.__docgenInfo={description:"",methods:[],displayName:"IconCaretDown",props:{title:{defaultValue:{value:"'CaretDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hn=fn;function vn(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}var gn=function(e){function t(e){var n;r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"updateNewProps",(function(e){var t=y.a.Children.toArray(e.children),a=e.value;n.setState(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?vn(Object(n),!0).forEach((function(t){v()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):vn(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},n.state,{options:t,value:a}))})),v()(p()(n),"handleChangeNative",(function(e){for(var t,a=[],r=n.props.multiple,l=e.target,o=l.options.length,i=null,u=0;u<o;u+=1)t=l.options[u],r&&t.selected?a.push(t.value):!r&&t.selected&&(i=t.value);e.persist(),n.setState({value:i||a},(function(){n.props.onChange&&n.props.onChange(e)}))})),v()(p()(n),"clickMenuItem",(function(e){var t=e.target.attributes.value.nodeValue;e.persist(),n.setState({value:t},(function(){n.props.onChange&&n.props.onChange(e)}))})),v()(p()(n),"handleMenuChange",(function(){n.setState({showMenu:!1})}));var a=y.a.Children.toArray(e.children);return n.state={isControlled:lt(e.value),value:e.value,options:a,showMenu:!1},n.selectedItem=e.placeholder,n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.state,n=t.options,a=t.value,r=y.a.Children.toArray(e.children),l=!!e.value&&e.value!==a;(n.length!==r.length||r.some((function(e,t){return Object.keys(n[t].props).find((function(a){return e.props[a]!==n[t].props[a]}))}))||l)&&this.updateNewProps(e)}},{key:"getMenuItem",value:function(e,t,n){var a="select-child-".concat(t),r=e.props,l=r.children,o=r.className,i=r.icon,u=r.value,s=x()(o);return y.a.createElement(Dt,{className:s,key:a,id:a,disabled:e.props.disabled,value:u,onClick:this.clickMenuItem,addOn:n&&y.a.createElement("span",{className:"select__checked"},y.a.createElement(je,{color:"success"})),"data-testid":e.props["data-testid"],role:"option"},i,l)}},{key:"renderSelectedItem",value:function(e){var t=e.children;return y.a.createElement("div",{key:t.id,className:"wds-select__selected-item"},e.selectedValue||(t.props?t.props.children:t))}},{key:"render",value:function(){var e=this,t=this.props,n=t.addOn,a=t.className,r=t.id,l=t.label,o=t.disabled,i=t.color,u=t.defaultValue,s=t.placeholder,c=t.size,d=t.multiple,p=t.stretched,m=t.native,f=(t.selectSize,t.placement),h=t.name,b=z()(t,["addOn","className","id","label","disabled","color","defaultValue","placeholder","size","multiple","stretched","native","selectSize","placement","name"]),E=this.state,w=E.options,_=E.value,C=E.isControlled,N=r||at()(),q=x()("wds-select",{"wds-select--stretched":p},{"wds-select--disabled":o},v()({},"wds-select--".concat(i),i),"wds-select--".concat(c),a),I=x()("wds-select__main");this.selectedItem=s;var k=y.a.Children.map(w,(function(t,n){var a=t.props,r=_==a.value;return r&&(e.selectedItem=e.renderSelectedItem(a,n)),e.getMenuItem(t,n,r)})),V=y.a.createElement("div",{className:I},n&&y.a.createElement("div",{className:"wds-select__addon"},n),this.selectedItem,y.a.createElement("div",{className:"wds-select__affordance"},y.a.createElement(hn,null))),O=m?null:this.props["data-testid"];return y.a.createElement(g.Fragment,null,!!l&&y.a.createElement(xt,{htmlFor:N},l),y.a.createElement("div",{id:m?null:N,className:q,"data-testid":O,tabIndex:m?null:-1,role:"button","aria-haspopup":"listbox","aria-expanded":this.state.showMenu},!m&&y.a.createElement(Lt,{dense:!0,noRules:!0,menuTrigger:V,placement:f,show:this.state.showMenu,onChange:this.handleMenuChange,role:"listbox"},k),m&&!C&&y.a.createElement(g.Fragment,null,y.a.createElement("select",Object.assign({},b,{"aria-label":l,id:N,disabled:o,name:h,multiple:d,defaultValue:u}),w),!d&&y.a.createElement("span",{className:"wds-select__affordance"},y.a.createElement(hn,null))),m&&C&&y.a.createElement(g.Fragment,null,y.a.createElement("select",Object.assign({},b,{"aria-label":l,id:N,disabled:o,name:h,multiple:d,onChange:this.handleChangeNative,value:_}),w),!d&&y.a.createElement("span",{className:"wds-select__affordance"},y.a.createElement(hn,null)))))}}]),t}(g.Component);gn.displayName="Select",gn.propTypes={addOn:E.a.node,children:E.a.node.isRequired,className:E.a.string,id:E.a.string,label:E.a.node,name:E.a.string,disabled:E.a.bool,color:E.a.oneOf(G),placeholder:E.a.node,value:E.a.oneOfType([E.a.array,E.a.string,E.a.number]),onChange:E.a.func,selectSize:E.a.number,defaultValue:E.a.node,"data-testid":E.a.string,size:E.a.oneOf(L),stretched:E.a.bool,native:E.a.bool,multiple:E.a.bool,placement:E.a.oneOf(A)},gn.defaultProps={addOn:null,className:null,id:null,label:null,name:null,disabled:!1,color:null,placeholder:"Choose...",value:void 0,onChange:null,selectSize:null,defaultValue:void 0,"data-testid":void 0,size:"md",stretched:!1,native:!1,multiple:!1,placement:"bottom-left"},gn.__docgenInfo={description:"",methods:[{name:"getMenuItem",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null}],returns:null},{name:"updateNewProps",docblock:null,modifiers:[],params:[{name:"nextProps",type:null}],returns:null},{name:"handleChangeNative",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"clickMenuItem",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleMenuChange",docblock:null,modifiers:[],params:[],returns:null},{name:"renderSelectedItem",docblock:null,modifiers:[],params:[{name:"props",type:null}],returns:null}],displayName:"Select",props:{addOn:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputThemes"},required:!1,description:""},placeholder:{defaultValue:{value:"'Choose...'",computed:!1},type:{name:"node"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"union",value:[{name:"array"},{name:"string"},{name:"number"}]},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},selectSize:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},defaultValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},native:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},multiple:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"'bottom-left'",computed:!1},type:{name:"enum",computed:!0,value:"menuPlacements"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var yn=gn,bn=(n(88),function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"handleBackButtonClick",(function(e){var t=n.props;(0,t.onChangePage)(e,t.page-1)})),v()(p()(n),"handleNextButtonClick",(function(e){var t=n.props;(0,t.onChangePage)(e,t.page+1)})),v()(p()(n),"handleJumpToPage",(function(e){var t=e.target,a=t.value,r=t.attributes,l=a||r.value.nodeValue,o=parseInt(l)-1;n.props.onChangePage&&n.props.onChangePage(e,o)})),n}return f()(t,e),o()(t,[{key:"render",value:function(){for(var e=this.props,t=e.className,n=e.hasPageSelect,a=e.hasRowsPerPage,r=e.rowsPerPage,l=(e.onChangePage,e.onChangeRowsPerPage),o=e.page,i=e.count,u=e.labelLegend,s=e.labelJumpToPage,c=e.labelRowsPerPage,d=z()(e,["className","hasPageSelect","hasRowsPerPage","rowsPerPage","onChangePage","onChangeRowsPerPage","page","count","labelLegend","labelJumpToPage","labelRowsPerPage"]),p=x()("wds-pagination",t),m=0===i?0:o*r+1,f=Math.min(i,(o+1)*r),h=i,v=Math.ceil(i/r),g=o+1,b=[],E=0;E<v;E++)b.push(y.a.createElement(mn,{value:"".concat(E+1),key:"".concat(E+1)},s({page:E+1})));return y.a.createElement("div",Object.assign({className:p},d),y.a.createElement("span",{className:"wds-pagination__legend"},y.a.createElement(qe,{component:"div",variant:"bodySm",color:"dark-muted"},u({firstRowOnPage:m,lastRowOnPage:f,totalRows:h}))),a&&y.a.createElement("span",{className:"wds-pagination__per-page"},y.a.createElement(yn,{onChange:l,value:r},y.a.createElement(mn,{value:"10"},c({page:10})),y.a.createElement(mn,{value:"25"},c({page:25})),y.a.createElement(mn,{value:"50"},c({page:50})),y.a.createElement(mn,{value:"100"},c({page:100})))),n&&y.a.createElement("span",{className:"wds-pagination__page"},y.a.createElement(yn,{value:"".concat(g),onChange:this.handleJumpToPage},b)),y.a.createElement("span",{className:"wds-pagination__actions"},y.a.createElement(Xe,null,y.a.createElement(Qe,{color:"muted",onClick:this.handleBackButtonClick,disabled:0===o},y.a.createElement(zt,null,"Æ")),y.a.createElement(Qe,{color:"muted",onClick:this.handleNextButtonClick,disabled:o>=Math.ceil(h/r)-1},y.a.createElement(zt,null,"ÿ")))))}}]),t}(g.Component));bn.displayName="Pagination",bn.propTypes={className:E.a.string,page:E.a.number.isRequired,count:E.a.number.isRequired,rowsPerPage:E.a.number.isRequired,onChangePage:E.a.func,hasPageSelect:E.a.bool,hasRowsPerPage:E.a.bool,onChangeRowsPerPage:E.a.func,labelLegend:E.a.func,labelRowsPerPage:E.a.func,labelJumpToPage:E.a.func},bn.defaultProps={className:"",onChangePage:null,hasPageSelect:!1,hasRowsPerPage:!1,onChangeRowsPerPage:null,labelLegend:function(e){var t=e.firstRowOnPage,n=e.lastRowOnPage,a=e.totalRows;return"Showing ".concat(t," - ").concat(n," of ").concat(a)},labelRowsPerPage:function(e){var t=e.page;return"".concat(t," per page")},labelJumpToPage:function(e){var t=e.page;return"Page ".concat(t)}},bn.__docgenInfo={description:"",methods:[{name:"handleBackButtonClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleNextButtonClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleJumpToPage",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null}],displayName:"Pagination",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},onChangePage:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},hasPageSelect:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},hasRowsPerPage:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChangeRowsPerPage:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},labelLegend:{defaultValue:{value:"({ firstRowOnPage, lastRowOnPage, totalRows }) =>\n  `Showing ${firstRowOnPage} - ${lastRowOnPage} of ${totalRows}`",computed:!1},type:{name:"func"},required:!1,description:""},labelRowsPerPage:{defaultValue:{value:"({ page }) => `${page} per page`",computed:!1},type:{name:"func"},required:!1,description:""},labelJumpToPage:{defaultValue:{value:"({ page }) => `Page ${page}`",computed:!1},type:{name:"func"},required:!1,description:""},page:{type:{name:"number"},required:!0,description:""},count:{type:{name:"number"},required:!0,description:""},rowsPerPage:{type:{name:"number"},required:!0,description:""}}};var En,wn=bn;function zn(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}function _n(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?zn(Object(n),!0).forEach((function(t){v()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):zn(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}n(18);var xn=function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"onMouseEnter",(function(){if(!n.props.clickable){if(n.props.delay)return void(En=setTimeout(function(){this.setState({show:!0}),this.change(!0)}.bind(p()(n)),800));n.setState({show:!0,currentPlacement:n.props.placement}),n.change(!0)}})),v()(p()(n),"onMouseLeave",(function(){n.props.delay&&clearTimeout(En),n.contextMenuOpen||n.props.clickable||(n.setState({show:!1}),n.change(!1))})),v()(p()(n),"onContextMenu",(function(){n.contextMenuOpen=!0,n.change(!0)})),v()(p()(n),"getSlideDirection",(function(){var e=n.state.currentPlacement;return e&&"top"!==e?"bottom"===e?"down":"left"===e?"left":"right":"up"})),v()(p()(n),"handleAutoCloseBlur",(function(e){n.popout.contains(e.target)||n.handleClose()})),v()(p()(n),"handleScroll",(function(){n.state.show&&n.props.renderTo&&n.updatePosition()})),v()(p()(n),"handleClick",(function(){n.props.clickable&&(n.change(!n.state.show),n.setState({show:!n.state.show}))})),v()(p()(n),"updatePosition",(function(){if(n.popout&&n.state.show&&n.popoutContent.children&&n.popoutContent.children.length&&(n.props.renderTo||n.props.autoFlip)){var e,t,a,r=n.popout.getBoundingClientRect(),l=n.popoutContent.children[0].getBoundingClientRect(),o=Mt?document.documentElement.clientWidth:void 0,i=Mt?document.documentElement.clientHeight:void 0,u={top:{width:o,height:r.top},right:{width:o-r.right,height:i},bottom:{width:o,height:i-r.bottom},left:{width:r.left,height:i}},s=Object.keys(u).map((function(e){return _n({key:e},u[e],{area:u[e].width*u[e].height})})).sort((function(e,t){return t.area-e.area})),c=s.filter((function(e){var t=e.width,n=e.height;return t>=l.width&&n>=l.height}));if("top"===(a=c.find((function(e){return e.key===n.props.placement}))||!n.props.autoFlip?n.props.placement:c.length?c[0].key:s[0].key))e=r.top-l.height,t=r.left+r.width/2;else if("left"===a){var d=parseInt(jt.popout["popout__pip-size"],10)+parseInt(jt.space["space--1"],10);e=r.top+r.height/2,t=r.left-(l.width+d)}else"right"===a?(e=r.top+r.height/2,t=r.left+r.width):(e=r.bottom,t=r.left+r.width/2);var p={currentPlacement:a};n.props.renderTo&&(p.popoutStyle={top:"".concat(e,"px"),left:"".concat(t,"px"),zIndex:jt["z-index"]["z--space"]+1,position:"fixed"}),n.setState(_n({},p))}})),v()(p()(n),"change",(function(e){var t=n.props,a=t.onChange,r=t.renderTo;e&&r&&n.updatePosition(),a&&a(e)})),v()(p()(n),"handleClose",(function(){n.change(!1),n.setState({show:!1})})),v()(p()(n),"hasMastHead",(function(){var e=y.a.Children.toArray(n.props.children)[0];return!(!e.type||"PopoutMasthead"!==e.type.displayName)})),v()(p()(n),"popoutRef",(function(e){return n.popout=e})),v()(p()(n),"renderPopoutContent",(function(){var e=n.props,t=e.delay,a=e.children,r=e.size,l=e.className,o=e.renderTo,i=e.autoFlip,u=e.clickable,s=e.noCloseButton,c=n.state.currentPlacement,d=x()("wds-popout--".concat(c),"wds-popout",{"wds-popout--delay":t},v()({},"wds-popout--".concat(r),r),{"wds-popout--auto-flip":i},l),p=s&&!u,m=!n.hasMastHead()&&!p,f=y.a.createElement("div",{className:d,"data-testid":n.props["data-testid"]?"".concat(n.props["data-testid"],"_ContentWrapper"):void 0,style:n.state.popoutStyle,ref:function(e){return n.popoutContent=e}},y.a.createElement(ce.Slide,{in:n.state.show,direction:n.getSlideDirection(),speed:"fast",distance:"near"},y.a.createElement("div",{className:"wds-popout__popout","data-testid":n.props["data-testid"]},m&&y.a.createElement(ve,{onClick:n.handleClose,ariaLabel:n.props.ariaLabel,"data-testid":n.props["data-testid"]?"".concat(n.props["data-testid"],"_CloseModal"):void 0}),a)));return o?St.a.createPortal(f,o):f})),n.state={show:e.show,popoutStyle:null,currentPlacement:e.placement},n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillMount",value:function(){this.props.autoClose&&Mt&&document.addEventListener("mousedown",this.handleAutoCloseBlur,!1)}},{key:"componentDidMount",value:function(){var e=this,t=this.props,n=t.clickable,a=t.renderTo;this.mousemove=function(){e.contextMenuOpen=!1},this.state.show&&a&&this.updatePosition(),(n||a)&&Mt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillUpdate",value:function(e,t){Mt&&(t.show?window.addEventListener("mousemove",this.mousemove):window.removeEventListener("mousemove",this.mousemove))}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){var e=this.props,t=e.clickable,n=e.renderTo;(t||n)&&Mt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll)),this.props.autoClose&&Mt&&document.removeEventListener("mousedown",this.handleAutoCloseBlur,!1)}},{key:"render",value:function(){var e=this.props,t=e.trigger,n=e.triggerClassName,a=e.clickable,r=x()("wds-has-popout",n,{"wds-has-popout--clickable":a});return y.a.createElement("span",{className:r,onMouseLeave:this.onMouseLeave,onBlur:this.onMouseLeave,onContextMenu:this.onContextMenu,ref:this.popoutRef},y.a.createElement("span",{className:"wds-popout__trigger",onClick:this.handleClick,onKeyDown:this.handleClick,onMouseEnter:this.onMouseEnter,onFocus:this.onMouseEnter},t),this.renderPopoutContent())}}]),t}(g.Component);xn.displayName="Popout",xn.propTypes={children:E.a.node.isRequired,delay:E.a.bool,onChange:E.a.func,placement:E.a.oneOf(D),show:E.a.bool,trigger:E.a.node.isRequired,size:E.a.string,className:E.a.string,triggerClassName:E.a.string,ariaLabel:E.a.node,noCloseButton:E.a.bool,clickable:E.a.bool,"data-testid":E.a.string,renderTo:E.a.oneOfType([E.a.func,E.a.shape({current:E.a.elementType})]),autoFlip:E.a.bool,autoClose:E.a.bool},xn.defaultProps={delay:!1,onChange:null,placement:"top",show:!1,size:"sm",className:"",triggerClassName:"",ariaLabel:"Close Popout",noCloseButton:!1,clickable:!1,"data-testid":void 0,renderTo:null,autoFlip:!1,autoClose:!1},xn.__docgenInfo={description:"",methods:[{name:"onMouseEnter",docblock:null,modifiers:[],params:[],returns:null},{name:"onMouseLeave",docblock:null,modifiers:[],params:[],returns:null},{name:"onContextMenu",docblock:null,modifiers:[],params:[],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"handleAutoCloseBlur",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"change",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null},{name:"handleClose",docblock:null,modifiers:[],params:[],returns:null},{name:"hasMastHead",docblock:null,modifiers:[],params:[],returns:null},{name:"popoutRef",docblock:null,modifiers:[],params:[{name:"popout",type:null}],returns:null},{name:"renderPopoutContent",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Popout",props:{delay:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},placement:{defaultValue:{value:"'top'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},size:{defaultValue:{value:"'sm'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},triggerClassName:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Popout'",computed:!1},type:{name:"node"},required:!1,description:""},noCloseButton:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},clickable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},autoFlip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},autoClose:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},trigger:{type:{name:"node"},required:!0,description:""}}};var Cn=xn,Nn=function(e){return y.a.createElement("div",{className:"wds-popout__body","data-testid":e["data-testid"]},e.children)};Nn.displayName="PopoutBody",Nn.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Nn.defaultProps={"data-testid":void 0},Nn.__docgenInfo={description:"",methods:[],displayName:"PopoutBody",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var qn=Nn,In=function(e){var t=e.children,n=e.placement,a=x()(v()({},"wds-popout__actions-".concat(n),n));return y.a.createElement("div",{className:a},t)};In.displayName="PopoutAlign",In.propTypes={children:E.a.node.isRequired,placement:E.a.oneOf(D)},In.defaultProps={placement:"left"},In.__docgenInfo={description:"",methods:[],displayName:"PopoutAlign",props:{placement:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var kn=In,Vn=function(e){return y.a.createElement("footer",{className:"wds-popout__foot","data-testid":e["data-testid"]},e.children)};Vn.displayName="PopoutFooter",Vn.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Vn.defaultProps={"data-testid":void 0},Vn.__docgenInfo={description:"",methods:[],displayName:"PopoutFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var On=Vn,Tn=function(e){return y.a.createElement("header",{className:"wds-popout__head","data-testid":e["data-testid"]},y.a.createElement("h2",{className:"wds-type--card-title"},e.children))};Tn.displayName="PopoutHeader",Tn.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Tn.defaultProps={"data-testid":void 0},Tn.__docgenInfo={description:"",methods:[],displayName:"PopoutHeader",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Pn=Tn,Sn=function(e){return y.a.createElement("div",{className:"wds-popout__masthead","data-testid":e["data-testid"]},e.children)};Sn.displayName="PopoutMasthead",Sn.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Sn.defaultProps={"data-testid":void 0},Sn.__docgenInfo={description:"",methods:[],displayName:"PopoutMasthead",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var jn=Sn,Fn=(n(89),function(e){var t=e.percent,n=e.size,a=e.color,r=z()(e,["percent","size","color"]),l=x()("wds-progress-bar","wds-progress-bar--".concat(a),"wds-progress-bar--".concat(n)),o={width:"".concat(t,"%")};return y.a.createElement("div",{className:l,role:"progressbar","aria-valuenow":t,"aria-valuemin":"0","aria-valuemax":"100","data-testid":r["data-testid"]},y.a.createElement("div",{style:o,className:"wds-progress-bar__fill"}))});Fn.displayName="ProgressBar",Fn.propTypes={percent:E.a.string.isRequired,size:E.a.oneOf(L),color:E.a.oneOf(ne),"data-testid":E.a.string},Fn.defaultProps={size:"md",color:"success","data-testid":void 0},Fn.__docgenInfo={description:"",methods:[],displayName:"ProgressBar",props:{size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},color:{defaultValue:{value:"'success'",computed:!1},type:{name:"enum",computed:!0,value:"progressBarColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},percent:{type:{name:"string"},required:!0,description:""}}};var Bn=Fn,Mn=(n(90),function(e){var t=e.children,n=e.size,a=e.percent,r=e.color,l=e.continuous,o=x()("wds-progress-circle","wds-progress-circle--".concat(r),"wds-progress-circle--".concat(n),{"wds-progress-circle--continuous":l}),i=12,u=54;switch(n){case"lg":i=8,u=56;break;case"sm":i=16,u=52;break;case"xs":i=20,u=50}return y.a.createElement("div",{className:o},y.a.createElement("svg",{className:"wds-progress-circle__path",viewBox:"0 0 120 120","data-testid":e["data-testid"]},y.a.createElement("g",{className:"wds-progress-circle__path-group"},y.a.createElement("circle",{className:"wds-progress-circle__path-border",cx:"60",cy:"60",r:u,strokeWidth:i}),y.a.createElement("circle",{className:"wds-progress-circle__path-fill",cx:"60",cy:"60",r:u,strokeWidth:i,strokeDasharray:l?null:"339.292 339.292",strokeDashoffset:l?null:339.292*(1-a)}))),t&&y.a.createElement("div",{className:"wds-progress-circle__display"},t))});Mn.displayName="ProgressCircle",Mn.propTypes={children:E.a.node,percent:E.a.number,size:E.a.oneOf(re),"data-testid":E.a.string,color:E.a.oneOf(ae),continuous:E.a.bool},Mn.defaultProps={children:null,percent:null,color:"success",size:"md","data-testid":void 0,continuous:!1},Mn.__docgenInfo={description:"",methods:[],displayName:"ProgressCircle",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},percent:{defaultValue:{value:"null",computed:!1},type:{name:"number"},required:!1,description:""},color:{defaultValue:{value:"'success'",computed:!1},type:{name:"enum",computed:!0,value:"progressCircleColors"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"progressCircleSizes"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},continuous:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""}}};var Rn=Mn,Ln=(n(91),function(e){var t=e.checked,n=e.className,a=e.defaultChecked,r=e.disabled,l=e.id,o=e.innerRef,i=e.label,u=e.name,s=e.onBlur,c=e.onChange,d=e.value,p=e["data-testid"],m=z()(e,["checked","className","defaultChecked","disabled","id","innerRef","label","name","onBlur","onChange","value","data-testid"]),f=Object(g.useState)(!!a),h=tt()(f,2),v=h[0],b=h[1],E=Object(g.useState)(!1),w=tt()(E,2),_=w[0],C=w[1],N=l||at()(),q=ot({isChecked:v},t&&{isChecked:t}).isChecked,I=x()("wds-radio__native",n),k=x()("wds-radio__faux",{"wds-radio--focused":_,"wds-radio--checked":q});return y.a.createElement("span",{className:"wds-radio"},y.a.createElement("input",Object.assign({"aria-checked":q,checked:t&&c&&q,defaultChecked:!!a||(t&&!c?q:void 0),className:I,disabled:r,id:N,name:u,onBlur:function(e){C(!_),s&&s(e)},onFocus:function(){C(!_)},onChange:function(e){b(!q),e.persist(),c&&c(e)},tabIndex:r?-1:0,type:"radio",value:d,ref:o,"data-testid":p},m)),y.a.createElement("span",{className:k,"aria-hidden":"true"}),i&&y.a.createElement("span",{className:"wds-radio__label"},y.a.createElement("label",{htmlFor:N},y.a.createElement(qe,{variant:"body",component:"span"},i))))});Ln.displayName="Radio",Ln.propTypes={checked:E.a.bool,className:E.a.string,"data-testid":E.a.string,defaultChecked:E.a.bool,disabled:E.a.bool,id:E.a.string,label:E.a.node,name:E.a.string,onBlur:E.a.func,onChange:E.a.func,value:E.a.string,innerRef:E.a.func},Ln.defaultProps={checked:void 0,className:null,"data-testid":void 0,defaultChecked:!1,disabled:!1,id:null,label:null,name:null,onBlur:void 0,onChange:void 0,value:void 0,innerRef:null},Ln.__docgenInfo={description:"",methods:[],displayName:"Radio",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""}}};var An=Ln;function Dn(){return(Dn=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function Un(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Hn(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var Wn=n(20),Gn=n.n(Wn),Kn=n(40),$n=n.n(Kn),Qn=function(){function e(e,t,n){var a=this;this.nativeMediaQueryList=e.matchMedia(t),this.active=!0,this.cancellableListener=function(){a.matches=a.nativeMediaQueryList.matches,a.active&&n.apply(void 0,arguments)},this.nativeMediaQueryList.addListener(this.cancellableListener),this.matches=this.nativeMediaQueryList.matches}return e.prototype.cancel=function(){this.active=!1,this.nativeMediaQueryList.removeListener(this.cancellableListener)},e}(),Yn=E.a.oneOfType([E.a.string,E.a.object,E.a.arrayOf(E.a.object.isRequired)]),Xn=function(e){var t,n;function a(t){var n,a;return Hn(Un(Un(n=e.call(this,t)||this)),"queries",[]),Hn(Un(Un(n)),"getMatches",(function(){return function(e){var t=Object.keys(e);return 1===t.length&&"__DEFAULT__"===t[0]?e.__DEFAULT__:e}(n.queries.reduce((function(e,t){var n,a=t.name,r=t.mqListener;return Dn({},e,((n={})[a]=r.matches,n))}),{}))})),Hn(Un(Un(n)),"updateMatches",(function(){var e=n.getMatches();n.setState((function(){return{matches:e}}),n.onChange)})),t.query||t.queries||t.query&&t.queries||Gn()(!1),void 0!==t.defaultMatches&&t.query&&"boolean"!=typeof t.defaultMatches&&Gn()(!1),void 0!==t.defaultMatches&&t.queries&&"object"!=typeof t.defaultMatches&&Gn()(!1),"object"!=typeof window?(a=void 0!==t.defaultMatches?t.defaultMatches:!!t.query||Object.keys(n.props.queries).reduce((function(e,t){var n;return Dn({},e,((n={})[t]=!0,n))}),{}),n.state={matches:a},Un(n)):(n.initialize(),n.state={matches:void 0!==n.props.defaultMatches?n.props.defaultMatches:n.getMatches()},n.onChange(),n)}n=e,(t=a).prototype=Object.create(n.prototype),t.prototype.constructor=t,t.__proto__=n;var r=a.prototype;return r.initialize=function(){var e=this,t=this.props.targetWindow||window;"function"!=typeof t.matchMedia&&Gn()(!1);var n=this.props.queries||{__DEFAULT__:this.props.query};this.queries=Object.keys(n).map((function(a){var r=n[a],l="string"!=typeof r?$n()(r):r;return{name:a,mqListener:new Qn(t,l,e.updateMatches)}}))},r.componentDidMount=function(){this.initialize(),void 0!==this.props.defaultMatches&&this.updateMatches()},r.onChange=function(){var e=this.props.onChange;e&&e(this.state.matches)},r.componentWillUnmount=function(){this.queries.forEach((function(e){return e.mqListener.cancel()}))},r.render=function(){var e=this.props,t=e.children,n=e.render,a=this.state.matches,r="object"==typeof a?Object.keys(a).some((function(e){return a[e]})):a;return n?r?n(a):null:t?"function"==typeof t?t(a):Array.isArray(t)&&!t.length||!r?null:y.a.Children.only(t)&&"string"==typeof y.a.Children.only(t).type?y.a.Children.only(t):y.a.cloneElement(y.a.Children.only(t),{matches:a}):null},a}(y.a.Component);Hn(Xn,"propTypes",{defaultMatches:E.a.oneOfType([E.a.bool,E.a.objectOf(E.a.bool)]),query:Yn,queries:E.a.objectOf(Yn),render:E.a.func,children:E.a.oneOfType([E.a.node,E.a.func]),targetWindow:E.a.object,onChange:E.a.func});var Jn=Xn,Zn=function(e){var t,n=e.children,a=e.minWidth,r=e.maxWidth;if(a&&r){var l=parseInt(le[r],10)-1+"px";t="(min-width: ".concat(le[a],") and (max-width: ").concat(l,")")}else if(r){var o=parseInt(le[r],10)-1+"px";t="(max-width: ".concat(o,")")}else t="(min-width: ".concat(le[a],")");return y.a.createElement(Jn,{query:t},n)};Zn.displayName="Respond",Zn.propTypes={children:E.a.node,minWidth:E.a.oneOf(["sm","md","lg","xl"]),maxWidth:E.a.oneOf(["sm","md","lg","xl"])},Zn.defaultProps={children:null,minWidth:void 0,maxWidth:void 0},Zn.__docgenInfo={description:"",methods:[],displayName:"Respond",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},minWidth:{defaultValue:{value:"undefined",computed:!0},type:{name:"enum",value:[{value:"'sm'",computed:!1},{value:"'md'",computed:!1},{value:"'lg'",computed:!1},{value:"'xl'",computed:!1}]},required:!1,description:""},maxWidth:{defaultValue:{value:"undefined",computed:!0},type:{name:"enum",value:[{value:"'sm'",computed:!1},{value:"'md'",computed:!1},{value:"'lg'",computed:!1},{value:"'xl'",computed:!1}]},required:!1,description:""}}};var ea=Zn,ta=function(e){var t=e.style;return y.a.createElement("span",{className:"wds-slider__fill",style:t}," ")};ta.displayName="ProgressBar",ta.propTypes={style:E.a.shape({left:E.a.oneOfType([E.a.number,E.a.string])}).isRequired},ta.__docgenInfo={description:"",methods:[],displayName:"ProgressBar",props:{style:{type:{name:"shape",value:{left:{name:"union",value:[{name:"number"},{name:"string"}],required:!1}}},required:!0,description:""}}};var na,aa=ta,ra=0,la=100,oa=function(e,t,n){return(e-t)/(n-t)*100},ia=function(e,t,n){var a=e/100;return 0===e?t:100===e?n:Math.round((n-t)*a+t)},ua=function(e,t){return t.length?t.reduce((function(t,n){return Math.abs(t-e)<Math.abs(n-e)?t:n})):e},sa=function(e){return Number(e.currentTarget.getAttribute("data-handle-key"))},ca=function(e){e.stopPropagation(),e.preventDefault()},da=(n(37),n(93),function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"onMouseEnter",(function(){var e=n.props,t=e.disableHover,a=e.alwaysShow;if(!t&&!a){if(n.props.delay)return void(na=setTimeout(function(){this.setState({show:!0}),this.change(!0)}.bind(p()(n)),800));n.setState({show:!0}),n.change(!0)}})),v()(p()(n),"onMouseLeave",(function(){var e=n.props,t=e.disableHover,a=e.alwaysShow;n.props.delay&&clearTimeout(na),t||a||(n.setState({show:!1}),n.change(!1))})),v()(p()(n),"getSlideDirection",(function(){var e=n.props.placement;return e&&"top"!==e?"bottom"===e?"down":"left"===e?"left":"right":"up"})),v()(p()(n),"handleScroll",(function(){n.state.show&&n.props.renderTo&&n.updatePosition()})),v()(p()(n),"showTooltip",(function(e){n.setState({show:e}),n.change(e)})),v()(p()(n),"handleClick",(function(){var e=n.props,t=e.alwaysShow,a=e.show;t||(a&&n.showTooltip(!1),n.showTooltip(!0))})),v()(p()(n),"updatePosition",(function(){if(n.tooltip&&n.state.show&&n.tooltipContent.children&&n.tooltipContent.children.length){var e,t,a=n.tooltip.getBoundingClientRect(),r=n.tooltipContent.children[0].getBoundingClientRect();if("top"===n.props.placement){var l=parseInt(jt.tooltip["tooltip__pip-size"],10)-parseInt(jt.space["space--1"],10);e=a.top-r.height-a.height/2-l,t=a.left+a.width/2}else if("left"===n.props.placement){var o=parseInt(jt.tooltip["tooltip__pip-size"],10)+parseInt(jt.space["space--1"],10);e=a.top+a.height/2,t=a.left-(2*r.width+o)}else"right"===n.props.placement?(e=a.top+a.height/2,t=a.left+a.width):(e=a.bottom,t=a.left+a.width/2);n.setState({tooltipStyle:{top:"".concat(e,"px"),left:"".concat(t,"px"),zIndex:jt["z-index"]["z--space"]+1,position:"fixed",bottom:"auto"}})}})),v()(p()(n),"tooltipRef",(function(e){return n.tooltip=e})),n.state={show:e.show},n}return f()(t,e),o()(t,[{key:"componentDidMount",value:function(){this.state.show&&this.props.renderTo&&this.updatePosition(),this.props.disableHover&&Mt&&(window.addEventListener("scroll",this.handleScroll),window.addEventListener("resize",this.handleScroll),window.addEventListener("orientationchange",this.handleScroll))}},{key:"UNSAFE_componentWillUpdate",value:function(e,t){Mt&&(t.show?window.addEventListener("mousemove",this.mousemove):window.removeEventListener("mousemove",this.mousemove))}},{key:"componentDidUpdate",value:function(e,t){!t.show&&this.state.show&&this.props.renderTo&&this.updatePosition()}},{key:"componentWillUnmount",value:function(){this.props.disableHover&&this.props.renderTo&&Mt&&(window.removeEventListener("scroll",this.handleScroll),window.removeEventListener("resize",this.handleScroll),window.removeEventListener("orientationchange",this.handleScroll))}},{key:"change",value:function(e){var t=this.props,n=t.onChange;t.renderTo&&e&&this.updatePosition(),n&&n(e)}},{key:"renderTooltipContent",value:function(){var e=this,t=this.props,n=t.delay,a=t.hideCaret,r=t.text,l=t.placement,o=t.renderTo,i=t.alwaysShow,u=z()(t,["delay","hideCaret","text","placement","renderTo","alwaysShow"]),s=x()("wds-tooltip--".concat(l),"wds-tooltip",{"wds-tooltip--show":this.state.show||i},{"wds-tooltip--delay":n},{"wds-tooltip--no-caret":a}),c=y.a.createElement("span",{className:s,style:this.state.tooltipStyle,"data-testid":u["data-testid"],ref:function(t){return e.tooltipContent=t},role:"tooltip"},y.a.createElement("span",{className:"wds-tooltip__body"},r));return o?St.a.createPortal(c,o):c}},{key:"render",value:function(){var e=this.props,t=e.children,n=e.disableHover,a=t.props,r=void 0===a?{}:a,l=x()("wds-has-tooltip",{"wds-has-tooltip--disable-hover":n},{"wds-has-tooltip--stretched":r.stretched});return y.a.createElement("span",{className:l,onMouseLeave:this.onMouseLeave,onBlur:this.onMouseLeave,onClick:n?this.handleClick:void 0,onKeyDown:n?this.handleClick:void 0,ref:this.tooltipRef,role:"button",tabIndex:0},this.renderTooltipContent(),y.a.createElement("span",{className:"wds-tooltip__trigger",onMouseEnter:this.onMouseEnter,onFocus:this.onMouseEnter},t))}}]),t}(g.Component));da.displayName="Tooltip",da.propTypes={children:E.a.node.isRequired,delay:E.a.bool,hideCaret:E.a.bool,placement:E.a.oneOf(D),text:E.a.node.isRequired,show:E.a.bool,disableHover:E.a.bool,"data-testid":E.a.string,renderTo:E.a.oneOfType([E.a.func,E.a.shape({current:E.a.elementType})]),onChange:E.a.func,alwaysShow:E.a.bool},da.defaultProps={delay:!1,hideCaret:!1,placement:"top",show:!1,disableHover:!1,"data-testid":void 0,renderTo:null,onChange:function(){return null},alwaysShow:null},da.__docgenInfo={description:"",methods:[{name:"onMouseEnter",docblock:null,modifiers:[],params:[],returns:null},{name:"onMouseLeave",docblock:null,modifiers:[],params:[],returns:null},{name:"getSlideDirection",docblock:null,modifiers:[],params:[],returns:null},{name:"handleScroll",docblock:null,modifiers:[],params:[],returns:null},{name:"showTooltip",docblock:null,modifiers:[],params:[{name:"val",type:null}],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[],returns:null},{name:"updatePosition",docblock:null,modifiers:[],params:[],returns:null},{name:"change",docblock:null,modifiers:[],params:[{name:"value",type:null}],returns:null},{name:"tooltipRef",docblock:null,modifiers:[],params:[{name:"tooltip",type:null}],returns:null},{name:"renderTooltipContent",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Tooltip",props:{delay:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},hideCaret:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},placement:{defaultValue:{value:"'top'",computed:!1},type:{name:"enum",computed:!0,value:"placements"},required:!1,description:""},show:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disableHover:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},renderTo:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"func"},{name:"shape",value:{current:{name:"elementType",required:!1}}}]},required:!1,description:""},onChange:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},alwaysShow:{defaultValue:{value:"null",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""},text:{type:{name:"node"},required:!0,description:""}}};var pa=da,ma=function(e){function t(e){var n;r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"getPublicState",(function(){var e=n.props,t=e.min;return{max:e.max,min:t,values:n.state.values}})),v()(p()(n),"getSliderBoundingBox",(function(){var e=p()(n).slider,t=e.getDOMNode?e.getDOMNode():e,a=t.getBoundingClientRect();return{height:a.height||t.clientHeight,left:a.left,top:a.top,width:a.width||t.clientWidth}})),v()(p()(n),"getMinValue",(function(e){var t=n.props.min,a=n.state.values;return a[e-1]?Math.max(t,a[e-1]):t})),v()(p()(n),"getMaxValue",(function(e){var t=n.props.max,a=n.state.values;return a[e+1]?Math.min(t,a[e+1]):t})),v()(p()(n),"getHandleDimensions",(function(e,t){var n=e.currentTarget||null;return n?n.clientWidth/t.width*la/2:0})),v()(p()(n),"getSnapPosition",(function(e){var t=n.props,a=t.max,r=t.min,l=t.snap,o=t.snapPoints;if(!l)return e;var i=ia(e,r,a),u=ua(i,o);return oa(u,r,a)})),v()(p()(n),"getNextPositionForKey",(function(e,t){var a,r=n.state,l=r.handlePos,o=r.values,i=n.props,u=i.max,s=i.min,c=i.snapPoints,d=i.snap,p=o[e],m=l[e],f=m,h=1;u>=100?m=Math.round(m):h=100/(u-s);var g=null;d&&(g=c.indexOf(ua(o[e],c)));var y=(a={},v()(a,K.LEFT,(function(e){return-1*e})),v()(a,K.RIGHT,(function(e){return 1*e})),v()(a,K.UP,(function(e){return 1*e})),v()(a,K.DOWN,(function(e){return-1*e})),v()(a,K.PAGE_DOWN,(function(e){return e>1?-e:-10*e})),v()(a,K.PAGE_UP,(function(e){return e>1?e:10*e})),a);if(Object.prototype.hasOwnProperty.call(y,t))m+=y[t](h),d&&(m>f?g<c.length-1&&(p=c[g+1]):g>0&&(p=c[g-1]));else if(t===K.HOME)m=ra,d&&(p=tt()(c,1)[0]);else{if(t!==K.END)return null;m=la,d&&(p=c[c.length-1])}return d?oa(p,s,u):m})),v()(p()(n),"setStartSlide",(function(e){var t=n.getSliderBoundingBox();n.setState({handleDimensions:n.getHandleDimensions(e,t),sliderBox:t,slidingIndex:sa(e)})})),v()(p()(n),"setRef",(function(e){n.slider=e})),v()(p()(n),"getProgressStyle",(function(e){var t=n.state.handlePos,a=t[e],r=t[e-1],l=a-r;return 0===e?{left:0,width:"".concat(a,"%")}:{left:"".concat(r,"%"),width:"".concat(l,"%")}})),v()(p()(n),"getNextState",(function(e,t){var a=n.state.handlePos,r=n.props,l=r.max,o=r.min,i=n.validatePosition(e,t),u=a.map((function(t,n){return n===e?i:t}));return{handlePos:u,values:u.map((function(e){return ia(e,o,l)}))}})),v()(p()(n),"getClosestHandle",(function(e){var t=n.state.handlePos;return t.reduce((function(n,a,r){return Math.abs(t[r]-e)<Math.abs(t[n]-e)?r:n}),0)})),v()(p()(n),"updateNewValues",(function(e){var t=e.max,a=e.min,r=e.values,l=n.validateValues(r,e);n.setState({handlePos:l.map((function(e){return oa(e,a,t)})),values:l},(function(){return n.fireChangeEvent()}))})),v()(p()(n),"fireChangeEvent",(function(){var e=n.props.onChange;e&&e(n.getPublicState())})),v()(p()(n),"canMove",(function(e,t){var a=n.state,r=a.handlePos,l=a.handleDimensions;return!(t<ra||t>la||t>(void 0!==r[e+1]?r[e+1]-l:1/0)||!(t>=(void 0!==r[e-1]?r[e-1]+l:-1/0)))})),v()(p()(n),"validateValues",(function(e,t){var a=t||n.props,r=a.max,l=a.min;return e.map((function(e,t,n){var a=Math.max(Math.min(e,r),l);return a=isNaN(a)?l:a,n.length&&a<n[t-1]?n[t-1]:a}))})),v()(p()(n),"validatePosition",(function(e,t){var a=n.state,r=a.handlePos,l=a.handleDimensions;return Math.max(Math.min(t,void 0!==r[e+1]?r[e+1]-l:la),void 0!==r[e-1]?r[e-1]+l:ra)})),v()(p()(n),"handleKeydown",(function(e){var t=sa(e);if(e.keyCode!==K.ESC){var a=n.getNextPositionForKey(t,e.keyCode);null!==a&&(n.canMove(t,a)&&n.slideTo(t,a,(function(){return n.fireChangeEvent()})),ca(e))}else e.currentTarget.blur()})),v()(p()(n),"handleClick",(function(e){if(!e.target.getAttribute("data-handle-key")){var t=n.getSliderBoundingBox(),a=(e.clientX-t.left)/t.width*la,r=n.getClosestHandle(a),l=n.getSnapPosition(a);n.slideTo(r,l,(function(){return n.fireChangeEvent()}))}})),v()(p()(n),"endSlide",(function(){var e=n.props.snap,t=n.state,a=t.slidingIndex,r=t.handlePos;if(n.setState({slidingIndex:null}),"function"==typeof document.removeEventListener?(document.removeEventListener("mouseup",n.endSlide,!1),document.removeEventListener("touchend",n.endSlide,!1),document.removeEventListener("touchmove",n.handleTouchSlide,!1),document.removeEventListener("mousemove",n.handleMouseSlide,!1)):(document.detachEvent("onmousemove",n.handleMouseSlide),document.detachEvent("onmouseup",n.endSlide)),e){var l=n.getSnapPosition(r[a]);n.slideTo(a,l,(function(){return n.fireChangeEvent()}))}else n.fireChangeEvent()})),v()(p()(n),"handleSlide",(function(e){var t=n.state,a=t.slidingIndex,r=t.sliderBox,l=(e-r.left)/r.width*la;n.slideTo(a,l)})),v()(p()(n),"handleTouchSlide",(function(e){if(null!==n.state.slidingIndex)if(e.changedTouches.length>1)n.endSlide();else{var t=e.changedTouches[0];n.handleSlide(t.clientX,t.clientY),ca(e)}})),v()(p()(n),"handleMouseSlide",(function(e){null!==n.state.slidingIndex&&(n.handleSlide(e.clientX,e.clientY),ca(e))})),v()(p()(n),"startTouchSlide",(function(e){if(!(e.changedTouches.length>1)){var t=e.changedTouches[0];n.setStartSlide(e,t.clientX,t.clientY),document.addEventListener("touchmove",n.handleTouchSlide,!1),document.addEventListener("touchend",n.endSlide,!1),ca(e)}})),v()(p()(n),"startMouseSlide",(function(e){n.setStartSlide(e,e.clientX,e.clientY),"function"==typeof document.addEventListener?(document.addEventListener("mousemove",n.handleMouseSlide,!1),document.addEventListener("mouseup",n.endSlide,!1)):(document.attachEvent("onmousemove",n.handleMouseSlide),document.attachEvent("onmouseup",n.endSlide)),ca(e)})),v()(p()(n),"slideTo",(function(e,t,a){var r=n.getNextState(e,t);n.setState(r,(function(){a&&a()}))}));var a=n.props,l=a.max,o=a.min,i=a.values;return n.state={handlePos:i.map((function(e){return oa(e,o,l)})),handleDimensions:0,sliderBox:{},slidingIndex:null,values:i},n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.props,n=t.disabled,a=t.min,r=t.max,l=t.controlled,o=this.state,i=o.values,u=o.slidingIndex;if(!1!==l){var s=e.min!==a||e.max!==r,c=i.length!==e.values.length||i.some((function(t,n){return e.values[n]!==t})),d=e.disabled&&!n;(s||c)&&this.updateNewValues(e),d&&null!==u&&this.endSlide()}}},{key:"render",value:function(){var e=this,t=this.props,n=t.disabled,a=t.showTooltip,r=t.tooltipValue,l=t.alwaysShowTooltip,o=this.state,i=o.handlePos,u=o.values;return y.a.createElement("div",{className:"wds-slider",ref:this.setRef,onClick:n?void 0:this.handleClick,"data-testid":this.props["data-testid"]},y.a.createElement("div",{className:"wds-slider__track"},i.map((function(t,o){return y.a.createElement("button",{"aria-valuemax":e.getMaxValue(o),"aria-valuemin":e.getMinValue(o),"aria-valuenow":u[o],"aria-disabled":n,"data-handle-key":o,className:"wds-slider__handle",key:"handle-".concat(o),onClick:e.killEvent,onKeyDown:n?void 0:e.handleKeydown,onMouseDown:n?void 0:e.startMouseSlide,onTouchStart:n?void 0:e.startTouchSlide,role:"slider",style:{left:"".concat(t,"%")},tabIndex:0,"data-testid":e.props["data-testid"]?"".concat(e.props["data-testid"],"_SliderHandle"):void 0},(a||l)&&y.a.createElement(pa,{text:r?r(u[o]):u[o],alwaysShow:l},y.a.createElement("div",{className:"wds-slider__handle-fill"})))})),i.map((function(t,n,a){return 0===n&&a.length>1||!1===e.props.range?null:y.a.createElement(aa,{key:"progress-bar-".concat(n),style:e.getProgressStyle(n)})})),this.props.children&&y.a.createElement("ul",{className:"wds-slider__steps"},this.props.children)))}}]),t}(y.a.Component);ma.displayName="Slider",ma.propTypes={children:E.a.node,disabled:E.a.bool,max:E.a.number.isRequired,min:E.a.number.isRequired,onChange:E.a.func,snap:E.a.bool,snapPoints:E.a.arrayOf(E.a.number),range:E.a.bool,values:E.a.arrayOf(E.a.number).isRequired,controlled:E.a.bool,showTooltip:E.a.bool,tooltipValue:E.a.func,alwaysShowTooltip:E.a.bool,"data-testid":E.a.string},ma.defaultProps={children:null,disabled:!1,onChange:null,snap:!1,snapPoints:[],range:!0,controlled:!1,showTooltip:!1,tooltipValue:void 0,alwaysShowTooltip:!1,"data-testid":void 0},ma.__docgenInfo={description:"",methods:[{name:"getPublicState",docblock:null,modifiers:[],params:[],returns:null},{name:"getSliderBoundingBox",docblock:null,modifiers:[],params:[],returns:null},{name:"getMinValue",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getMaxValue",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getHandleDimensions",docblock:null,modifiers:[],params:[{name:"ev",type:null},{name:"sliderBox",type:null}],returns:null},{name:"getSnapPosition",docblock:null,modifiers:[],params:[{name:"positionPercent",type:null}],returns:null},{name:"getNextPositionForKey",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"keyCode",type:null}],returns:null},{name:"setStartSlide",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"setRef",docblock:null,modifiers:[],params:[{name:"ref",type:null}],returns:null},{name:"getProgressStyle",docblock:null,modifiers:[],params:[{name:"idx",type:null}],returns:null},{name:"getNextState",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"getClosestHandle",docblock:null,modifiers:[],params:[{name:"positionPercent",type:null}],returns:null},{name:"updateNewValues",docblock:null,modifiers:[],params:[{name:"nextProps",type:null}],returns:null},{name:"fireChangeEvent",docblock:null,modifiers:[],params:[],returns:null},{name:"canMove",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"validateValues",docblock:null,modifiers:[],params:[{name:"proposedValues",type:null},{name:"props",type:null}],returns:null},{name:"validatePosition",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null}],returns:null},{name:"handleKeydown",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"handleClick",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"endSlide",docblock:null,modifiers:[],params:[],returns:null},{name:"handleSlide",docblock:null,modifiers:[],params:[{name:"x",type:null}],returns:null},{name:"handleTouchSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"handleMouseSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"startTouchSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"startMouseSlide",docblock:null,modifiers:[],params:[{name:"ev",type:null}],returns:null},{name:"slideTo",docblock:null,modifiers:[],params:[{name:"idx",type:null},{name:"proposedPosition",type:null},{name:"onAfterSet",type:null}],returns:null}],displayName:"Slider",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},snap:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},snapPoints:{defaultValue:{value:"[]",computed:!1},type:{name:"arrayOf",value:{name:"number"}},required:!1,description:""},range:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},controlled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},showTooltip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},tooltipValue:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},alwaysShowTooltip:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},max:{type:{name:"number"},required:!0,description:""},min:{type:{name:"number"},required:!0,description:""},values:{type:{name:"arrayOf",value:{name:"number"}},required:!0,description:""}}};var fa=ma,ha=function(e){var t=e.children;return y.a.createElement("li",{className:"wds-slider__step"},t&&y.a.createElement("span",{className:"wds-label wds-label--muted"},t))};ha.displayName="Step",ha.propTypes={children:E.a.node},ha.defaultProps={children:null},ha.__docgenInfo={description:"",methods:[],displayName:"Step",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""}}};var va=ha,ga=(n(94),function(e){var t=e.className,n=e.checked,a=e.defaultChecked,r=e.disabled,l=e.innerRef,o=e.onChange,i=e.id,u=z()(e,["className","checked","defaultChecked","disabled","innerRef","onChange","id"]),s=Object(g.useState)(!!a),c=tt()(s,2),d=c[0],p=c[1],m=Object(g.useState)(!1),f=tt()(m,2),h=f[0],v=f[1],b=ot({isChecked:d},n&&{isChecked:n}).isChecked,E=x()("wds-switch__native",t),w=x()("wds-switch",{"wds-switch--focused":h}),_=i||at()(),C=function(){v(!h)};return y.a.createElement("div",{className:w},y.a.createElement("input",{onFocus:C,onBlur:C,role:"switch","aria-checked":b,checked:b,className:E,disabled:r,id:_,onChange:function(e){p(!b),e.persist(),o&&o(e)},tabIndex:r?-1:0,type:"checkbox",ref:l,"data-testid":u["data-testid"]}),y.a.createElement("span",{className:"wds-switch__faux"}))});ga.displayName="Switch",ga.propTypes={checked:E.a.bool,className:E.a.string,defaultChecked:E.a.bool,disabled:E.a.bool,id:E.a.string,onChange:E.a.func,innerRef:E.a.func,"data-testid":E.a.string},ga.defaultProps={checked:void 0,className:null,defaultChecked:!1,disabled:!1,id:null,onChange:void 0,innerRef:null,"data-testid":void 0},ga.__docgenInfo={description:"",methods:[],displayName:"Switch",props:{checked:{defaultValue:{value:"undefined",computed:!0},type:{name:"bool"},required:!1,description:""},className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},defaultChecked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onChange:{defaultValue:{value:"undefined",computed:!0},type:{name:"func"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var ya=ga;function ba(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}n(95);var Ea=function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"handleBlur",(function(e){n.props.onBlur&&n.props.onBlur(e)})),v()(p()(n),"handleChange",(function(e){n.state.isControlled&&e.target.value!==n.state.value&&(e.persist(),n.setState({value:e.target.value},(function(){n.props.onChange&&n.props.onChange(e)})))})),v()(p()(n),"renderLabel",(function(){return n.props.label?y.a.createElement(xt,{className:"",htmlFor:n.inputID},n.props.label):null})),n.state={isControlled:lt(e.value),value:e.value},n.inputID=e.id||at()(),n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){e.value!==this.state.value&&this.setState({value:e.value})}},{key:"render",value:function(){var e=this.props,t=e.className,n=e.disabled,a=(e.label,e.name),r=(e.onBlur,e.onChange,e.size),l=e.stretched,o=e.color,i=z()(e,["className","disabled","label","name","onBlur","onChange","size","stretched","color"]),u=x()("wds-textarea","wds-textarea--".concat(r),v()({},"wds-textarea--".concat(o),o),{"wds-textarea--stretched":l},t),s=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ba(Object(n),!0).forEach((function(t){v()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ba(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({},i,{value:this.state.value});return y.a.createElement(g.Fragment,null,this.renderLabel(),y.a.createElement("textarea",Object.assign({className:u,disabled:n,id:this.inputID,name:a,onBlur:this.handleBlur,onChange:this.handleChange},s)))}}]),t}(y.a.Component);Ea.displayName="Textarea",Ea.propTypes={className:E.a.string,disabled:E.a.bool,id:E.a.string,label:E.a.node,name:E.a.string,onBlur:E.a.func,onChange:E.a.func,size:E.a.oneOf(L),stretched:E.a.bool,color:E.a.oneOf(te),value:E.a.node},Ea.defaultProps={className:null,disabled:!1,id:null,label:null,name:null,onBlur:null,onChange:null,size:"md",stretched:!1,color:null,value:void 0},Ea.__docgenInfo={description:"",methods:[{name:"handleBlur",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null},{name:"renderLabel",docblock:null,modifiers:[],params:[],returns:null}],displayName:"Textarea",props:{className:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},label:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},name:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},onBlur:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},size:{defaultValue:{value:"'md'",computed:!1},type:{name:"enum",computed:!0,value:"sizes"},required:!1,description:""},stretched:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"inputColors"},required:!1,description:""},value:{defaultValue:{value:"undefined",computed:!0},type:{name:"node"},required:!1,description:""}}};var wa=Ea,za=(n(23),function(e){var t;return"info"===e?t=Oe:"warning"===e?t=Pe:"success"===e?t=je:"upgrade"===e&&(t=Be),y.a.createElement("span",{className:"wds-toast__icon"},y.a.createElement(t,null))});za.displayName="toastIcon";var _a=function(e){var t=e.onClose,n=e.autoClose,a=e.children,r=e.dismissible,l=e.color,o=e.className,i=e.show,u=z()(e,["onClose","autoClose","children","dismissible","color","className","show"]),s=x()("wds-toast",v()({},"wds-toast--".concat(l),l),o),c=Object(g.useState)(null),d=tt()(c,2),p=d[0],m=d[1],f=Object(g.useState)(!1),h=tt()(f,2),b=h[0],E=h[1],w=Object(g.useState)(!0),_=tt()(w,2),C=_[0],N=_[1],q=function(){N(!0),m(setInterval((function(){return I()}),3e3))},I=function(){clearInterval(p),N(!1),t?t():n&&E(!0)};Object(g.useEffect)((function(){n&&i?q():clearInterval(p)}),[i]);var k=i&&!b,V=u["data-testid"]?"".concat(u["data-testid"],"_Close"):void 0;return y.a.createElement(ce.Slide,{in:k,distance:"far"},y.a.createElement("div",{onMouseEnter:function(){n&&p&&C&&clearInterval(p)},onMouseLeave:function(){n&&p&&C&&q()},className:s,"data-testid":u["data-testid"]},r&&y.a.createElement(ve,{onClick:I,ariaLabel:u.ariaLabel,variant:"light","data-testid":V}),l&&za(l),a))};_a.displayName="Toast",_a.propTypes={autoClose:E.a.bool,children:E.a.node.isRequired,dismissible:E.a.bool,onClose:E.a.func,color:E.a.oneOf(["info","warning","upgrade","success"]),ariaLabel:E.a.string,show:E.a.bool,className:E.a.string,"data-testid":E.a.string},_a.defaultProps={autoClose:!0,dismissible:!1,onClose:null,color:null,ariaLabel:"Close Toast",className:"",show:!0,"data-testid":void 0},_a.__docgenInfo={description:"",methods:[],displayName:"Toast",props:{autoClose:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},dismissible:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClose:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"toastColors"},required:!1,description:""},ariaLabel:{defaultValue:{value:"'Close Toast'",computed:!1},type:{name:"string"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},show:{defaultValue:{value:"true",computed:!1},type:{name:"bool"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var xa=_a,Ca=function(e){return y.a.createElement("div",{className:"wds-toast__body","data-testid":e["data-testid"]},e.children)};Ca.displayName="ToastBody",Ca.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},Ca.defaultProps={"data-testid":void 0},Ca.__docgenInfo={description:"",methods:[],displayName:"ToastBody",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Na=Ca,qa=function(e){return y.a.createElement("div",{className:"wds-toast__footer","data-testid":e["data-testid"]},e.children)};qa.displayName="ToastFooter",qa.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},qa.defaultProps={"data-testid":void 0},qa.__docgenInfo={description:"",methods:[],displayName:"ToastFooter",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ia=qa,ka=function(e){return y.a.createElement("div",{className:"wds-toast__title","data-testid":e["data-testid"]},e.children)};ka.displayName="ToastTitle",ka.propTypes={children:E.a.node.isRequired,"data-testid":E.a.string},ka.defaultProps={"data-testid":void 0},ka.__docgenInfo={description:"",methods:[],displayName:"ToastTitle",props:{"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Va=ka,Oa=(n(38),function(e){function t(e){var n;return r()(this,t),n=u()(this,c()(t).call(this,e)),v()(p()(n),"getSelectedIndex",(function(e,t){var n=y.a.Children.map(e,(function(e,t){return y.a.isValidElement(e)&&e.props.selected?t:null}));return isNaN(n[0])?t||0:n[0]})),v()(p()(n),"bindSelectedTab",(function(e){n.selectedTab=e})),v()(p()(n),"handleChange",(function(e,t,a){t!==n.state.value&&(n.setState({value:t}),n.props.onChange&&n.props.onChange(t,a))})),n.state={value:n.getSelectedIndex(e.children)},n}return f()(t,e),o()(t,[{key:"UNSAFE_componentWillReceiveProps",value:function(e){var t=this.props.children,n=this.getSelectedIndex(e.children);n!==this.getSelectedIndex(t)&&this.setState({value:n})}},{key:"componentDidUpdate",value:function(e,t){t.value!==this.state.value&&this.selectedTab.focus()}},{key:"getClassNames",value:function(){var e=this.props,t=e.color,n=e.align;return x()("wds-tab","wds-tab--".concat(t),"wds-tab--".concat(n))}},{key:"renderTabElement",value:function(e,t,n,a){var r=n?this.bindSelectedTab:null;return y.a.cloneElement(e,{selected:n,onChange:this.handleChange,value:t,children:e.props.title,id:a,key:a,innerRef:r})}},{key:"renderPaneElement",value:function(e,t,n,a){var r=t?{transparent:!0}:{padding:!0},l=x()({"wds-tab__pane":!0,"wds-tab__pane--hide":!a,"wds-tab__pane--show":a});return y.a.createElement("div",{key:n,className:l,"labelled-by":n,"aria-hidden":!a||null},y.a.createElement(j,r,e))}},{key:"render",value:function(){var e=this,t=this.props,n=t.fullWidth,a=t.children,r=[],l=[];return y.a.Children.forEach(a,(function(t,a){if(y.a.isValidElement(t)){var o=t.props.id||"tab-".concat(a,"-").concat(at()()),i=a===e.state.value;r.push(e.renderTabElement(t,a,i,o)),t.props.children&&l.push(e.renderPaneElement(t.props.children,n,o,i))}})),y.a.createElement("div",{className:this.getClassNames(),"data-testid":this.props["data-testid"]},y.a.createElement("ul",{role:"tablist",className:"wds-tab__tabs"},r),y.a.createElement("div",{className:"wds-tab__panes"},l))}}]),t}(y.a.Component));Oa.displayName="Tabs",Oa.propTypes={align:E.a.oneOf(["left","right","even","center"]),children:E.a.node.isRequired,fullWidth:E.a.bool,onChange:E.a.func,color:E.a.oneOf(["primary","light","dark","transparent"]),"data-testid":E.a.string},Oa.defaultProps={align:"left",fullWidth:!1,onChange:null,color:"light","data-testid":void 0},Oa.__docgenInfo={description:"",methods:[{name:"getSelectedIndex",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"defaultIndex",type:null}],returns:null},{name:"getClassNames",docblock:null,modifiers:[],params:[],returns:null},{name:"bindSelectedTab",docblock:null,modifiers:[],params:[{name:"tab",type:null}],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null},{name:"value",type:null},{name:"id",type:null}],returns:null},{name:"renderTabElement",docblock:null,modifiers:[],params:[{name:"child",type:null},{name:"index",type:null},{name:"selected",type:null},{name:"id",type:null}],returns:null},{name:"renderPaneElement",docblock:null,modifiers:[],params:[{name:"children",type:null},{name:"fullWidth",type:null},{name:"id",type:null},{name:"selected",type:null}],returns:null}],displayName:"Tabs",props:{align:{defaultValue:{value:"'left'",computed:!1},type:{name:"enum",value:[{value:"'left'",computed:!1},{value:"'right'",computed:!1},{value:"'even'",computed:!1},{value:"'center'",computed:!1}]},required:!1,description:""},fullWidth:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"'light'",computed:!1},type:{name:"enum",computed:!0,value:"TabColors"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}}};var Ta=Oa,Pa=function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"getOuterTabClasses",(function(){var e=n.props,t=e.selected,a=e.disabled;return x()("wds-tab__tab",{"wds-tab__tab--selected":t},{"wds-tab__tab--disabled":a})})),v()(p()(n),"handleChange",(function(e){var t=n.props;(0,t.onChange)(e,t.value,t.id)})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e=this.props,t=e.disabled,n=e.value,a=e.selected,r=e.id,l=e.innerRef;return y.a.createElement("li",{className:this.getOuterTabClasses()},y.a.createElement("button",{disabled:t,value:n,role:"tab",tabIndex:t?-1:0,"aria-selected":a,className:"wds-tab__tab-btn",onClick:this.handleChange,id:r,ref:l,"data-testid":this.props["data-testid"]},this.props.children))}}]),t}(y.a.Component);Pa.displayName="Tab",Pa.propTypes={children:E.a.oneOfType([E.a.node,E.a.string]),disabled:E.a.bool,id:E.a.string,innerRef:E.a.func,onChange:E.a.func,selected:E.a.bool,value:E.a.oneOfType([E.a.number,E.a.string]),"data-testid":E.a.string},Pa.defaultProps={children:"",disabled:!1,id:null,innerRef:null,onChange:null,selected:!1,value:0,"data-testid":void 0},Pa.__docgenInfo={description:"",methods:[{name:"getOuterTabClasses",docblock:null,modifiers:[],params:[],returns:null},{name:"handleChange",docblock:null,modifiers:[],params:[{name:"event",type:null}],returns:null}],displayName:"Tab",props:{children:{defaultValue:{value:"''",computed:!1},type:{name:"union",value:[{name:"node"},{name:"string"}]},required:!1,description:""},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},id:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},innerRef:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},onChange:{defaultValue:{value:"null",computed:!1},type:{name:"func"},required:!1,description:""},selected:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},value:{defaultValue:{value:"0",computed:!1},type:{name:"union",value:[{name:"number"},{name:"string"}]},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""}}};var Sa=Pa,ja=(n(19),function(e){var t=e.children,n=e.xScroll,a=e.className,r=z()(e,["children","xScroll","className"]),l=x()({"wds-table":!0,"wds-table--x-scroll":n},a);return y.a.createElement("div",{className:l},y.a.createElement("table",{"data-testid":r["data-testid"]},t))});ja.displayName="Table",ja.propTypes={children:E.a.node.isRequired,xScroll:E.a.bool,className:E.a.string,"data-testid":E.a.string},ja.defaultProps={xScroll:!1,className:"","data-testid":void 0},ja.__docgenInfo={description:"",methods:[],displayName:"Table",props:{xScroll:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:"Allows the table to scroll on its x-axis."},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the table, normally `TableHeader` and `TableBody`."}}};var Fa=ja,Ba=function(e){var t=e.children,n=e.className,a=z()(e,["children","className"]);return y.a.createElement("tbody",Object.assign({className:n},a),y.a.Children.map(t,(function(e){if(e)return y.a.cloneElement(e,{parent:"TableBody"})})))};Ba.displayName="TableBody",Ba.propTypes={children:E.a.node.isRequired,className:E.a.string,"data-testid":E.a.string},Ba.defaultProps={className:"","data-testid":void 0},Ba.__docgenInfo={description:"",methods:[],displayName:"TableBody",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var Ma=Ba,Ra=function(e){var t=e.children,n=e.className,a=z()(e,["children","className"]);return y.a.createElement("thead",{className:n,"data-testid":a["data-testid"]},y.a.Children.map(t,(function(e){if(e)return y.a.cloneElement(e,{parent:"TableHeader"})})))};Ra.displayName="TableHeader",Ra.propTypes={children:E.a.node.isRequired,className:E.a.string,"data-testid":E.a.string},Ra.defaultProps={className:"","data-testid":void 0},Ra.__docgenInfo={description:"",methods:[],displayName:"TableHeader",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var La=Ra,Aa=function(e){var t,n=e.numeric,a=e.variant,r=e.scope,l=e.className,o=e.parent,i=e.color,u=e.marked,s=e.children,c=z()(e,["numeric","variant","scope","className","parent","color","marked","children"]),d=x()(l,(t={"wds-table__cell":!0,"wds-table__cell--numeric":n,"wds-table__cell--more-action":"more-actions"===a,"wds-table__cell--bulk-action":"bulk-actions"===a},v()(t,"wds-table__cell--marked-".concat(i),i),v()(t,"wds-table__cell--marked",u),t)),p="TableHeader"===o,m=p?"th":"td",f=!r&&p?"col":r;return y.a.createElement(m,Object.assign({className:d,scope:f},c),s)};Aa.displayName="TableCell",Aa.propTypes={children:E.a.node,className:E.a.string,color:E.a.oneOfType([E.a.oneOf(ee),E.a.oneOf(Y)]),marked:E.a.bool,numeric:E.a.bool,parent:E.a.oneOf(["TableHeader","TableBody",null]),scope:E.a.string,variant:E.a.oneOf(["more-actions","bulk-actions",null])},Aa.defaultProps={children:null,className:"",color:null,marked:!1,numeric:!1,parent:null,scope:"",variant:null},Aa.__docgenInfo={description:"",methods:[],displayName:"TableCell",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:"The table cell contents."},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numeric:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:"If `true`, content will align to the right."},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"'TableBody'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"Specify the cell type.\nBy default, the TableHead, TableBody or TableFooter parent component set the value."},scope:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:"Set scope attribute."},variant:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'more-actions'",computed:!1},{value:"'bulk-actions'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"sets the padding of the cell based on purpose"}}};var Da=Aa,Ua=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m14.57 6.2844-6.04-6.04a.75.75 0 0 0 -1.0605 0l-6.04 6.04a.75.75 0 0 0 1.0605 1.0606l4.76-4.7597v12.64a.75.75 0 0 0 1.5 0v-12.6401l4.76 4.76a.75.75 0 1 0 1.06-1.0608z"})))};Ua.displayName="IconArrowUp",Ua.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Ua.defaultProps={title:"ArrowUp",color:null,size:null},Ua.__docgenInfo={description:"",methods:[],displayName:"IconArrowUp",props:{title:{defaultValue:{value:"'ArrowUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ha=Ua,Wa=function(e){return y.a.createElement(N,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),y.a.createElement("g",null,y.a.createElement("path",{d:"m14.57 8.655a.75.75 0 0 0 -1.0605 0l-4.76 4.76v-12.6403a.75.75 0 1 0 -1.5 0v12.64l-4.7595-4.7597a.75.75 0 0 0 -1.06 1.0606l6.04 6.04a.7514.7514 0 0 0 1.0606 0l6.04-6.04a.75.75 0 0 0 -.0006-1.0606z"})))};Wa.displayName="IconArrowDown",Wa.propTypes={title:E.a.string,color:E.a.string,size:E.a.string},Wa.defaultProps={title:"ArrowDown",color:null,size:null},Wa.__docgenInfo={description:"",methods:[],displayName:"IconArrowDown",props:{title:{defaultValue:{value:"'ArrowDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ga=Wa,Ka=function(e){function t(){var e,n;r()(this,t);for(var a=arguments.length,l=new Array(a),o=0;o<a;o++)l[o]=arguments[o];return n=u()(this,(e=c()(t)).call.apply(e,[this].concat(l))),v()(p()(n),"handleKeyDown",(function(e){var t=n.props,a=t.onClick;t.isSortable&&e.keyCode===K.ENTER&&a(e)})),v()(p()(n),"renderSortArrow",(function(){var e=n.props,t=e.isSortable,a=e.sortDirection;return!!t&&("descending"==a?y.a.createElement(Ha,null):y.a.createElement(Ga,null))})),n}return f()(t,e),o()(t,[{key:"render",value:function(){var e,t=this.props,n=t.children,a=t.numeric,r=t.variant,l=t.scope,o=t.className,i=t.parent,u=t.color,s=t.marked,c=t.isSortable,d=t.isSorted,p=t.sortDirection,m=t.textWrap,f=t.labelSort,h=z()(t,["children","numeric","variant","scope","className","parent","color","marked","isSortable","isSorted","sortDirection","textWrap","labelSort"]),g=x()(o,(e={"wds-table__cell":!0,"wds-table__header-cell":!0,"wds-table__cell--nowrap":!m,"wds-table__cell--numeric":a,"wds-table__cell--more-action":"more-actions"===r,"wds-table__bulk-action":"bulk-actions"===r},v()(e,"wds-table__cell--marked-".concat(u),u),v()(e,"wds-table__cell--marked",s),v()(e,"wds-table__cell--sortable",c),v()(e,"wds-table__cell--sorted",d),e)),b="TableHeader"===i,E=b?"th":"td",w=!l&&b?"col":l;return y.a.createElement(E,Object.assign({className:g,scope:w,tabIndex:0,role:"columnheader","aria-sort":p,onKeyDown:this.handleKeyDown,title:f},h),n,c&&y.a.createElement("span",{className:"wds-table__sort-icon"},this.renderSortArrow()))}}]),t}(y.a.Component);Ka.displayName="TableHeaderCell",Ka.propTypes={children:E.a.node,className:E.a.string,color:E.a.oneOfType([E.a.oneOf(ee),E.a.oneOf(Y)]),marked:E.a.bool,numeric:E.a.bool,parent:E.a.oneOf(["TableHeader",null]),scope:E.a.string,variant:E.a.oneOf(["more-actions","bulk-actions",null]),isSortable:E.a.bool,isSorted:E.a.bool,sortDirection:E.a.oneOf(["ascending","descending",null]),textWrap:E.a.bool,onClick:E.a.func.isRequired,labelSort:E.a.node},Ka.defaultProps={children:null,className:"",color:null,marked:!1,numeric:!1,parent:null,scope:"",variant:null,isSortable:!1,isSorted:!1,sortDirection:"ascending",textWrap:!1,labelSort:"Sort"},Ka.__docgenInfo={description:"",methods:[{name:"handleKeyDown",docblock:null,modifiers:[],params:[{name:"e",type:null}],returns:null},{name:"renderSortArrow",docblock:null,modifiers:[],params:[],returns:null}],displayName:"TableHeaderCell",props:{children:{defaultValue:{value:"null",computed:!1},type:{name:"node"},required:!1,description:""},className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},numeric:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},scope:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},variant:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'more-actions'",computed:!1},{value:"'bulk-actions'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},isSortable:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},isSorted:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},sortDirection:{defaultValue:{value:"'ascending'",computed:!1},type:{name:"enum",value:[{value:"'ascending'",computed:!1},{value:"'descending'",computed:!1},{value:"null",computed:!1}]},required:!1,description:""},textWrap:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},labelSort:{defaultValue:{value:"'Sort'",computed:!1},type:{name:"node"},required:!1,description:""},onClick:{type:{name:"func"},required:!0,description:""}}};var $a=Ka,Qa=function(e){var t,n=e.className,a=e.children,r=e.color,l=e.marked,o=e.disabled,i=e.parent,u=e.onClick,s=z()(e,["className","children","color","marked","disabled","parent","onClick"]),c=x()(n,(t={"wds-table__row--disabled":o},v()(t,"wds-table__row--marked-".concat(r),r),v()(t,"wds-table__row--marked",l),t));return y.a.createElement("tr",Object.assign({onClick:u,className:c},s),y.a.Children.map(a,(function(e){if(y.a.isValidElement(e))return y.a.cloneElement(e,{parent:i})})))};Qa.displayName="TableRow",Qa.propTypes={className:E.a.string,children:E.a.node.isRequired,parent:E.a.oneOf(["TableHeader","TableBody",null]),disabled:E.a.bool,onClick:E.a.func,color:E.a.oneOfType([E.a.oneOf(ee),E.a.oneOf(Y)]),marked:E.a.bool},Qa.defaultProps={className:"",parent:null,disabled:!1,onClick:function(){return null},color:null,marked:!1},Qa.__docgenInfo={description:"",methods:[],displayName:"TableRow",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},parent:{defaultValue:{value:"null",computed:!1},type:{name:"enum",value:[{value:"'TableHeader'",computed:!1},{value:"'TableBody'",computed:!1},{value:"null",computed:!1}]},required:!1,description:"By default, the TableHead, or TableBody parent component sets the value."},disabled:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},onClick:{defaultValue:{value:"() => null",computed:!1},type:{name:"func"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"union",value:[{name:"enum",computed:!0,value:"markColors"},{name:"enum",computed:!0,value:"dataVizThemes"}]},required:!1,description:""},marked:{defaultValue:{value:"false",computed:!1},type:{name:"bool"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The table cell contents."}}};var Ya=Qa,Xa=function(e){var t=e.children,n=e.className,a=z()(e,["children","className"]);return y.a.createElement("tfoot",{className:n,"data-testid":a["data-testid"]},y.a.Children.map(t,(function(e){if(e)return y.a.cloneElement(e,{parent:"TableFooter"})})))};Xa.displayName="TableFooter",Xa.propTypes={children:E.a.node.isRequired,className:E.a.string,"data-testid":E.a.string},Xa.defaultProps={className:"","data-testid":void 0},Xa.__docgenInfo={description:"",methods:[],displayName:"TableFooter",props:{className:{defaultValue:{value:"''",computed:!1},type:{name:"string"},required:!1,description:""},"data-testid":{defaultValue:{value:"undefined",computed:!0},type:{name:"string"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:"The content of the component, normally `TableRow`."}}};var Ja=Xa;n.d(t,"Accordion",(function(){return M})),n.d(t,"AccordionItem",(function(){return se})),n.d(t,"ActionSheet",(function(){return ke})),n.d(t,"Alert",(function(){return Le})),n.d(t,"Avatar",(function(){return De})),n.d(t,"Badge",(function(){return Ee})),n.d(t,"Banner",(function(){return We})),n.d(t,"Button",(function(){return Qe})),n.d(t,"ButtonGroup",(function(){return Xe})),n.d(t,"Card",(function(){return Ze})),n.d(t,"Checkbox",(function(){return ut})),n.d(t,"Coachmark",(function(){return ct})),n.d(t,"Container",(function(){return _e})),n.d(t,"FormGroup",(function(){return pt})),n.d(t,"FormField",(function(){return ft})),n.d(t,"Grid",(function(){return vt})),n.d(t,"Row",(function(){return yt})),n.d(t,"Col",(function(){return Et})),n.d(t,"Icon",(function(){return zt})),n.d(t,"Input",(function(){return Nt})),n.d(t,"InputGroup",(function(){return It})),n.d(t,"InputGroupAddon",(function(){return Vt})),n.d(t,"Link",(function(){return Tt})),n.d(t,"List",(function(){return T})),n.d(t,"ListItem",(function(){return ie})),n.d(t,"Menu",(function(){return Lt})),n.d(t,"MenuGroup",(function(){return Bt})),n.d(t,"MenuItem",(function(){return Dt})),n.d(t,"Modal",(function(){return Ht})),n.d(t,"ModalBody",(function(){return Gt})),n.d(t,"ModalFooter",(function(){return $t})),n.d(t,"ModalHeader",(function(){return Yt})),n.d(t,"Align",(function(){return Jt})),n.d(t,"Multiselect",(function(){return en})),n.d(t,"MultiselectOption",(function(){return nn})),n.d(t,"NumberPicker",(function(){return sn})),n.d(t,"PageHeader",(function(){return dn})),n.d(t,"Pagination",(function(){return wn})),n.d(t,"Pane",(function(){return j})),n.d(t,"Popout",(function(){return Cn})),n.d(t,"PopoutBody",(function(){return qn})),n.d(t,"PopoutAlign",(function(){return kn})),n.d(t,"PopoutFooter",(function(){return On})),n.d(t,"PopoutHeader",(function(){return Pn})),n.d(t,"PopoutMasthead",(function(){return jn})),n.d(t,"ProgressBar",(function(){return Bn})),n.d(t,"ProgressCircle",(function(){return Rn})),n.d(t,"Radio",(function(){return An})),n.d(t,"Respond",(function(){return ea})),n.d(t,"Select",(function(){return yn})),n.d(t,"Option",(function(){return mn})),n.d(t,"Sheet",(function(){return ye})),n.d(t,"Slider",(function(){return fa})),n.d(t,"Step",(function(){return va})),n.d(t,"getClosestSnapPoint",(function(){return ua})),n.d(t,"Switch",(function(){return ya})),n.d(t,"Textarea",(function(){return wa})),n.d(t,"Tooltip",(function(){return pa})),n.d(t,"Toast",(function(){return xa})),n.d(t,"ToastBody",(function(){return Na})),n.d(t,"ToastFooter",(function(){return Ia})),n.d(t,"ToastTitle",(function(){return Va})),n.d(t,"Tabs",(function(){return Ta})),n.d(t,"Tab",(function(){return Sa})),n.d(t,"Typography",(function(){return qe})),n.d(t,"Table",(function(){return Fa})),n.d(t,"TableBody",(function(){return Ma})),n.d(t,"TableHeader",(function(){return La})),n.d(t,"TableCell",(function(){return Da})),n.d(t,"TableHeaderCell",(function(){return $a})),n.d(t,"TableRow",(function(){return Ya})),n.d(t,"TableFooter",(function(){return Ja}))}]))},function(e,t,n){var a;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/!function(){"use strict";var n={}.hasOwnProperty;function r(){for(var e=[],t=0;t<arguments.length;t++){var a=arguments[t];if(a){var l=typeof a;if("string"===l||"number"===l)e.push(a);else if(Array.isArray(a)&&a.length){var o=r.apply(null,a);o&&e.push(o)}else if("object"===l)for(var i in a)n.call(a,i)&&a[i]&&e.push(i)}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):void 0===(a=function(){return r}.apply(t,[]))||(e.exports=a)}()},function(e,t,n){var a;"undefined"!=typeof self&&self,e.exports=(a=n(0),function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:a})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=8)}([function(e,t){e.exports=a},function(e,t,n){e.exports=n(6)()},function(e,t){e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t,n){var a=n(5);e.exports=function(e,t){if(null==e)return{};var n,r,l=a(e,t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(l[n]=e[n])}return l}},function(e,t,n){var a;!function(){"use strict";var n={}.hasOwnProperty;function r(){for(var e=[],t=0;t<arguments.length;t++){var a=arguments[t];if(a){var l=typeof a;if("string"===l||"number"===l)e.push(a);else if(Array.isArray(a)&&a.length){var o=r.apply(null,a);o&&e.push(o)}else if("object"===l)for(var i in a)n.call(a,i)&&a[i]&&e.push(i)}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):void 0===(a=function(){return r}.apply(t,[]))||(e.exports=a)}()},function(e,t){e.exports=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}},function(e,t,n){"use strict";var a=n(7);function r(){}function l(){}l.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,l,o){if(o!==a){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:l,resetWarningCache:r};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";n.r(t);var a=n(2),r=n.n(a),l=n(3),o=n.n(l),i=n(0),u=n.n(i),s=n(1),c=n.n(s),d=n(4),p=n.n(d),m=function(e){var t=e.children,n=e.color,a=e.size,l=o()(e,["children","color","size"]),i=p()("wds-icon-svg",r()({},"wds-icon-svg--".concat(n),n),r()({},"wds-icon-svg--".concat(a),a));return u.a.createElement("svg",Object.assign({className:i,preserveAspectRatio:"xMidYMid meet"},l),t)};m.displayName="IconSVG",m.propTypes={children:c.a.node.isRequired,color:c.a.string,size:c.a.oneOf(["lg","md","sm","xl"])},m.defaultProps={color:null,size:null},m.contextTypes={reactIconBase:c.a.shape(m.propTypes)},m.__docgenInfo={description:"",methods:[],displayName:"IconSVG",props:{color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"enum",computed:!0,value:"iconSizes"},required:!1,description:""},children:{type:{name:"node"},required:!0,description:""}},context:{reactIconBase:{type:{name:"shape",value:"IconSVG.propTypes",computed:!0},required:!1}}};var f=m,h=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.89 1.1893-.001-.0092a.6981.6981 0 0 0 -.1324-.2468c-.0128-.0154-.0311-.0222-.0449-.0362-.0089-.009-.01-.0225-.02-.0311-.0151-.0138-.0367-.0147-.0527-.0271a.6751.6751 0 0 0 -.229-.1178.66.66 0 0 0 -.08-.0235.6882.6882 0 0 0 -.33.0224l-.01.0007-14.1487 4.9079a1.12 1.12 0 0 0 -.1929 2.0278l4.0235 2.3215.0009 4.0863a1.1819 1.1819 0 0 0 .7319 1.1543 1.182 1.182 0 0 0 1.3369-.2925l2.2522-2.4545 1.97 1.1366a1.4349 1.4349 0 0 0 2.1074-.8906l2.8262-11.1641c.0035-.0141-.0036-.0278-.0009-.042a.691.691 0 0 0 -.0065-.3221zm-4.07 2.1121-6.5134 5.4262-3.4273-1.9776zm-5.7478 10.2838v-2.7994l1.68.9691zm5.5913-1.19-5.0643-2.9219 7.4014-6.1659z"})))};h.displayName="IconAirplane",h.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},h.defaultProps={title:"Airplane",color:null,size:null},h.__docgenInfo={description:"",methods:[],displayName:"IconAirplane",props:{title:{defaultValue:{value:"'Airplane'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var v=h,g=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7941 11.7632c-.0051-.012-.0153-.0206-.0209-.0322a.7353.7353 0 0 0 -.13-.2017l-2.2046-2.2632a.75.75 0 0 0 -1.0742 1.0469l.9645.99h-7.34a4.342 4.342 0 1 1 0-8.6841h9.1094a.75.75 0 0 0 0-1.5h-9.1089a5.842 5.842 0 1 0 0 11.6841h7.2892l-.8039.794a.75.75 0 0 0 1.0547 1.0674l2.1035-2.0781a.7475.7475 0 0 0 .1612-.8231z"})))};g.displayName="IconArrow180",g.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},g.defaultProps={title:"Arrow180",color:null,size:null},g.__docgenInfo={description:"",methods:[],displayName:"IconArrow180",props:{title:{defaultValue:{value:"'Arrow180'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var y=g,b=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.4021 3.3418a.75.75 0 1 0 -.0576 1.498 4.2814 4.2814 0 0 1 -.167 8.56h-4.3545a4.2813 4.2813 0 1 1 0-8.5625h.2044l-.78.7705a.75.75 0 1 0 1.0551 1.0661l2.0775-2.0539a.75.75 0 0 0 .01-1.0566l-2.1769-2.2362a.75.75 0 0 0 -1.0751 1.0469l.9375.9629h-.2525a5.7812 5.7812 0 1 0 0 11.5625h4.3545a5.781 5.781 0 0 0 .2246-11.5576z"})))};b.displayName="IconArrow360",b.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},b.defaultProps={title:"Arrow360",color:null,size:null},b.__docgenInfo={description:"",methods:[],displayName:"IconArrow360",props:{title:{defaultValue:{value:"'Arrow360'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var E=b,w=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M12.429,14.422H1.8a.6636.6636,0,0,1-.6644-.6644V3.1281A.6635.6635,0,0,1,1.8,2.4638H5.3426a.6644.6644,0,1,1,0,1.3287H2.4638v9.3008h9.3008V10.2145a.6644.6644,0,1,1,1.3287,0v3.5431A.6635.6635,0,0,1,12.429,14.422Z"}),u.a.createElement("path",{id:"ArrowBox-2","data-name":"ArrowBox",d:"M14.3733,1.5559c0-.0045,0-.0089-.0045-.0089a.6783.6783,0,0,0-.3631-.3632c-.0045,0-.0089,0-.0089-.0044a.6952.6952,0,0,0-.2392-.0443H8.4429a.6644.6644,0,0,0,0,1.3287h3.7115L7.9734,6.6447a.66.66,0,0,0,0,.939.6629.6629,0,0,0,.939,0l4.1809-4.181V7.1142a.6644.6644,0,1,0,1.3287,0V1.8A.646.646,0,0,0,14.3733,1.5559Z"}),u.a.createElement("rect",{x:"0.0279",y:"0.0279",width:"15.9442",height:"15.9442",fill:"none"})))};w.displayName="IconArrowBox",w.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},w.defaultProps={title:"ArrowBox",color:null,size:null},w.__docgenInfo={description:"",methods:[],displayName:"IconArrowBox",props:{title:{defaultValue:{value:"'ArrowBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var z=w,_=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5322 7.3935-4.125-2.3814a.7.7 0 0 0 -1.05.6065v1.6814h-1.6912a5.0313 5.0313 0 0 1 -4.3092-2.3146 2.3761 2.3761 0 0 0 .56-1.522 2.4 2.4 0 1 0 -2.4 2.4 2.3665 2.3665 0 0 0 .6751-.1086 6.816 6.816 0 0 0 2.5032 2.2452 6.816 6.816 0 0 0 -2.5034 2.2453 2.3665 2.3665 0 0 0 -.6751-.1086 2.4 2.4 0 1 0 2.4 2.4 2.376 2.376 0 0 0 -.56-1.522 5.0312 5.0312 0 0 1 4.3094-2.3147h1.6914v1.6811a.7.7 0 0 0 1.05.6065l4.125-2.3814a.7.7 0 0 0 0-1.2129zm-14.0146-3.9301a1 1 0 1 1 .999 1 1 1 0 0 1 -.999-1zm.999 10.0727a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm9.2412-4.3672v-2.3379l2.0244 1.169z"})))};_.displayName="IconArrowCombine",_.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},_.defaultProps={title:"ArrowCombine",color:null,size:null},_.__docgenInfo={description:"",methods:[],displayName:"IconArrowCombine",props:{title:{defaultValue:{value:"'ArrowCombine'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var x=_,C=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.9956 14.9531a.75.75 0 0 1 -.53-1.28l5.6726-5.6731-5.6729-5.6729a.75.75 0 1 1 1.0606-1.0605l6.2031 6.2034a.75.75 0 0 1 0 1.0605l-6.2031 6.2029a.7467.7467 0 0 1 -.5303.2197z"}),u.a.createElement("path",{d:"m4.5386 8.75h-3.7373a.75.75 0 1 1 0-1.5h3.7373a.75.75 0 0 1 0 1.5z"}),u.a.createElement("path",{d:"m11.1353 8.75h-3.7383a.75.75 0 0 1 0-1.5h3.7383a.75.75 0 0 1 0 1.5z"})))};C.displayName="IconArrowDashed",C.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},C.defaultProps={title:"ArrowDashed",color:null,size:null},C.__docgenInfo={description:"",methods:[],displayName:"IconArrowDashed",props:{title:{defaultValue:{value:"'ArrowDashed'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var N=C,q=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.57 8.655a.75.75 0 0 0 -1.0605 0l-4.76 4.76v-12.6403a.75.75 0 1 0 -1.5 0v12.64l-4.7595-4.7597a.75.75 0 0 0 -1.06 1.0606l6.04 6.04a.7514.7514 0 0 0 1.0606 0l6.04-6.04a.75.75 0 0 0 -.0006-1.0606z"})))};q.displayName="IconArrowDown",q.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},q.defaultProps={title:"ArrowDown",color:null,size:null},q.__docgenInfo={description:"",methods:[],displayName:"IconArrowDown",props:{title:{defaultValue:{value:"'ArrowDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var I=q,k=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6843 7.47-4.97-4.97a.75.75 0 1 0 -1.0603 1.06l3.69 3.69h-9.254a.75.75 0 0 0 0 1.5h9.2539l-3.6898 3.6895a.75.75 0 1 0 1.0605 1.0605l4.97-4.97a.75.75 0 0 0 -.0003-1.06z"}),u.a.createElement("path",{d:"m4.6585 13.875h-3.0625v-11.75h3.0625a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5z"})))};k.displayName="IconArrowExit",k.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},k.defaultProps={title:"ArrowExit",color:null,size:null},k.__docgenInfo={description:"",methods:[],displayName:"IconArrowExit",props:{title:{defaultValue:{value:"'ArrowExit'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var V=k,O=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.9035 7.7136a.75.75 0 0 0 -.1618-.2436l-6.0517-6.0518a.75.75 0 1 0 -1.06 1.0606l4.7709 4.7712h-7.02c-2.6695 0-4.8409-1.5237-4.8409-3.3972a.75.75 0 1 0 -1.5 0c0 2.7007 2.8443 4.8972 6.3414 4.8972h7.02l-4.7714 4.7712a.75.75 0 1 0 1.06 1.0606l6.0513-6.0513a.7527.7527 0 0 0 .1618-.8169z"})))};O.displayName="IconArrowForward",O.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},O.defaultProps={title:"ArrowForward",color:null,size:null},O.__docgenInfo={description:"",methods:[],displayName:"IconArrowForward",props:{title:{defaultValue:{value:"'ArrowForward'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var T=O,P=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.26 12.1213a4.1328 4.1328 0 1 1 4.2429-5.368l-.76-.4582a.65.65 0 0 0 -.6719 1.1133l2.06 1.2422a.6508.6508 0 0 0 .8926-.2207l1.2422-2.0591a.65.65 0 0 0 -1.1133-.6719l-.3274.5429a5.5316 5.5316 0 1 0 -5.6726 7.275c.0181.0015.0366.0024.0547.0024a.7.7 0 0 0 .0527-1.398z"}),u.a.createElement("path",{d:"m10.894 2.4871a.7.7 0 0 0 -.1191 1.3945 4.1327 4.1327 0 1 1 -4.2899 5.3274l.783.4724a.65.65 0 0 0 .672-1.1133l-2.06-1.2422a.6506.6506 0 0 0 -.8926.2207l-1.2418 2.0591a.65.65 0 0 0 1.1133.6719l.3147-.5218a5.5316 5.5316 0 1 0 5.72-7.2687z"})))};P.displayName="IconArrowIntegrate",P.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},P.defaultProps={title:"ArrowIntegrate",color:null,size:null},P.__docgenInfo={description:"",methods:[],displayName:"IconArrowIntegrate",props:{title:{defaultValue:{value:"'ArrowIntegrate'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var S=P,j=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2246 7.25h-12.6397l4.7593-4.76a.75.75 0 1 0 -1.0605-1.06l-6.0396 6.04a.7527.7527 0 0 0 0 1.0605l6.04 6.04a.75.75 0 1 0 1.0601-1.0605l-4.7593-4.76h12.64a.75.75 0 1 0 0-1.5z"})))};j.displayName="IconArrowLeft",j.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},j.defaultProps={title:"ArrowLeft",color:null,size:null},j.__docgenInfo={description:"",methods:[],displayName:"IconArrowLeft",props:{title:{defaultValue:{value:"'ArrowLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var F=j,B=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.6768 7.2315h-5.3477a.75.75 0 0 0 0 1.5h5.3477a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.7222 2.5977-1.7281-2.2549c-.0084-.011-.0226-.0145-.0317-.0249a.7247.7247 0 0 0 -1.1271 0c-.009.01-.0232.0139-.0317.0249l-1.728 2.2549a.75.75 0 1 0 1.19.9121l.3828-.4993v4.7131c0 1.3574-.7622 2.5049-1.6641 2.5049h-5.6552a.75.75 0 0 0 0 1.5h5.6558c1.7446 0 3.1641-1.7969 3.1641-4.0049v-4.7136l.3828.4993a.75.75 0 1 0 1.19-.9121z"}),u.a.createElement("path",{d:"m3.7339 12.49-.3828.4993v-4.7129c0-1.3574.7622-2.5049 1.6641-2.5049h5.6616a.75.75 0 0 0 0-1.5h-5.6617c-1.7446 0-3.1641 1.7969-3.1641 4.0049v4.7136l-.3827-.5a.75.75 0 1 0 -1.19.9121l1.728 2.2549c.009.0118.0238.0164.0334.0275a.7354.7354 0 0 0 .1714.1411.7224.7224 0 0 0 .0779.0525.7068.7068 0 0 0 .6249 0 .7222.7222 0 0 0 .0779-.0525.7358.7358 0 0 0 .1714-.1411c.01-.0112.0245-.0157.0334-.0275l1.728-2.2549a.75.75 0 1 0 -1.19-.9121z"})))};B.displayName="IconArrowRandom",B.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},B.defaultProps={title:"ArrowRandom",color:null,size:null},B.__docgenInfo={description:"",methods:[],displayName:"IconArrowRandom",props:{title:{defaultValue:{value:"'ArrowRandom'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var M=B,R=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.1851 5.54a.7531.7531 0 0 0 .6921.4634h2.9321a.75.75 0 0 0 0-1.5h-1.1212l.4073-.4072a5.5215 5.5215 0 0 1 9.4258 3.8462.75.75 0 0 0 .75.7422h.0078a.75.75 0 0 0 .7422-.7578 7.0216 7.0216 0 0 0 -11.9863-4.8916l-.4077.4076v-1.1215a.75.75 0 0 0 -1.5 0v2.9317l.001.0048a.75.75 0 0 0 .0569.2822z"}),u.a.createElement("path",{d:"m14.4089 10.055a.75.75 0 0 0 -.2866-.0579h-2.9316a.75.75 0 0 0 0 1.5h1.1211l-.4072.4072a5.5216 5.5216 0 0 1 -9.4259-3.8452.7408.7408 0 0 0 -.7578-.7422.75.75 0 0 0 -.7422.7578 7.0241 7.0241 0 0 0 11.9863 4.89l.4072-.4072v1.1211a.75.75 0 0 0 1.5 0v-2.9315a.753.753 0 0 0 -.4634-.6921z"})))};R.displayName="IconArrowRefresh",R.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},R.defaultProps={title:"ArrowRefresh",color:null,size:null},R.__docgenInfo={description:"",methods:[],displayName:"IconArrowRefresh",props:{title:{defaultValue:{value:"'ArrowRefresh'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var L=R,A=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.9177 7.7134a.75.75 0 0 0 -.1618-.2436l-6.04-6.04a.75.75 0 1 0 -1.0601 1.0602l4.7593 4.76h-12.6397a.75.75 0 1 0 0 1.5h12.64l-4.7596 4.76a.75.75 0 1 0 1.0605 1.06l6.04-6.04a.7527.7527 0 0 0 .1618-.8169z"})))};A.displayName="IconArrowRight",A.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},A.defaultProps={title:"ArrowRight",color:null,size:null},A.__docgenInfo={description:"",methods:[],displayName:"IconArrowRight",props:{title:{defaultValue:{value:"'ArrowRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var D=A,U=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.7925 7.7344a2.2473 2.2473 0 1 0 2.2475 2.2475 2.25 2.25 0 0 0 -2.2475-2.2475zm0 2.9946a.7473.7473 0 1 1 .7475-.7471.7481.7481 0 0 1 -.7475.7471z"}),u.a.createElement("path",{d:"m15.6963 8.4951a.75.75 0 0 0 -1.0605 0l-.6894.6894a6.1941 6.1941 0 0 0 -11.9356-1.4177 2.2477 2.2477 0 1 0 1.4834.3015 4.7067 4.7067 0 0 1 8.9123.9623l-.5355-.5355a.75.75 0 0 0 -1.0605 1.0605l1.9126 1.9126a.75.75 0 0 0 1.0605 0l1.9126-1.9126a.75.75 0 0 0 .0001-1.0605z"})))};U.displayName="IconArrowSkip",U.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},U.defaultProps={title:"ArrowSkip",color:null,size:null},U.__docgenInfo={description:"",methods:[],displayName:"IconArrowSkip",props:{title:{defaultValue:{value:"'ArrowSkip'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var H=U,W=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6584 7.4678-1.9062-1.9073a.75.75 0 1 0 -1.0605 1.0606l.6345.6348h-6.0568a10.26 10.26 0 0 0 2.3232-3.211l.2152.7422a.7514.7514 0 0 0 .7207.541.74.74 0 0 0 .209-.03.75.75 0 0 0 .5117-.9292l-.751-2.5879a.783.783 0 0 0 -.1367-.2622.7506.7506 0 0 0 -.7959-.251l-2.5869.7544a.75.75 0 0 0 .42 1.44l.9394-.2742c-1.4122 2.9261-2.9222 4.06-5.3281 4.06h-2.1377a.75.75 0 0 0 -.75.75l.0004.002v.0022a.75.75 0 0 0 .75.75h.1038c.006 0 .0109.0034.0169.0034h2.0658c2.376.0159 3.877 1.1516 5.2789 4.0561l-.94-.2739a.75.75 0 0 0 -.42 1.44l2.5869.7544a.7238.7238 0 0 0 .208.03.7579.7579 0 0 0 .59-.2832.767.767 0 0 0 .1348-.26l.751-2.5879a.75.75 0 0 0 -1.4414-.418l-.2152.7423a10.2837 10.2837 0 0 0 -2.3109-3.2h6.0337l-.6234.6235a.75.75 0 1 0 1.0606 1.0611l1.9063-1.9067a.7567.7567 0 0 0 0-1.0654z"})))};W.displayName="IconArrowSpread",W.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},W.defaultProps={title:"ArrowSpread",color:null,size:null},W.__docgenInfo={description:"",methods:[],displayName:"IconArrowSpread",props:{title:{defaultValue:{value:"'ArrowSpread'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var G=W,K=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.57 6.2844-6.04-6.04a.75.75 0 0 0 -1.0605 0l-6.04 6.04a.75.75 0 0 0 1.0605 1.0606l4.76-4.7597v12.64a.75.75 0 0 0 1.5 0v-12.6401l4.76 4.76a.75.75 0 1 0 1.06-1.0608z"})))};K.displayName="IconArrowUp",K.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},K.defaultProps={title:"ArrowUp",color:null,size:null},K.__docgenInfo={description:"",methods:[],displayName:"IconArrowUp",props:{title:{defaultValue:{value:"'ArrowUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $=K,Q=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.4 6.7383a.7.7 0 0 0 .7.7h3.7715a.7.7 0 0 0 0-1.4h-3.7709a.7.7 0 0 0 -.7006.7z"}),u.a.createElement("path",{d:"m12.8721 8.2729h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z"}),u.a.createElement("path",{d:"m12.8721 10.5083h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z"}),u.a.createElement("path",{d:"m6.6738 6.0381h-3.5361a.7.7 0 0 0 -.7.7v4.47a.7.7 0 0 0 .7.7h3.5361a.7.7 0 0 0 .7-.7v-4.47a.7.7 0 0 0 -.7-.7zm-.7 4.47h-2.1359v-3.07h2.1357z"}),u.a.createElement("path",{d:"m15.1943 2.8745h-5.4648v-.0361a1.4179 1.4179 0 0 0 -1.416-1.4155h-.6279a1.417 1.417 0 0 0 -1.415 1.4155v.0361h-5.4649a.7.7 0 0 0 -.7.7v10.3025a.7.7 0 0 0 .7.7h14.3886a.7.7 0 0 0 .7-.7v-10.3023a.7.7 0 0 0 -.7-.7002zm-7.5234 0h.6582v1.4h-.6582zm6.8232 10.3022h-12.9882v-8.9018h4.7646v.0361a1.417 1.417 0 0 0 1.415 1.4155h.6279a1.4179 1.4179 0 0 0 1.4166-1.4155v-.0361h4.7647v8.9019z"})))};Q.displayName="IconBadge",Q.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Q.defaultProps={title:"Badge",color:null,size:null},Q.__docgenInfo={description:"",methods:[],displayName:"IconBadge",props:{title:{defaultValue:{value:"'Badge'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Y=Q,X=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.5237 3.1748a2.4426 2.4426 0 0 0 -1.42 2.5727.7.7 0 0 0 .6983.6611l.04-.0015a.7.7 0 0 0 .66-.7378c-.05-.9038.4438-1.1528.5117-1.1831a.7.7 0 0 0 -.4888-1.3115z"}),u.a.createElement("path",{d:"m15.4441 14.4673c-1.5093-1.8726-4.6255-.7515-6.1226-.2119a1.9249 1.9249 0 0 1 -1.5532-.0264 1.6173 1.6173 0 0 1 -.54-.458h.4779a.7.7 0 0 0 .6748-.8867l-.4623-1.6717a5.7087 5.7087 0 1 0 -3.6393 0l-.4623 1.6716a.7.7 0 0 0 .6748.8867h1.05a3.2844 3.2844 0 0 0 1.5461 1.7944 3.1557 3.1557 0 0 0 1.44.3369 3.852 3.852 0 0 0 1.3022-.2358c1.08-.3887 3.6084-1.3 4.4468-.2578a.75.75 0 1 0 1.1679-.9414zm-13.5541-8.6612a4.2087 4.2087 0 1 1 4.2085 4.209 4.213 4.213 0 0 1 -4.2085-4.209zm4.2085 5.709c.15 0 .2974-.0111.4446-.0225l.2429.878h-1.3746l.2429-.878c.1471.0114.2942.0225.4441.0225z"})))};X.displayName="IconBalloon",X.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},X.defaultProps={title:"Balloon",color:null,size:null},X.__docgenInfo={description:"",methods:[],displayName:"IconBalloon",props:{title:{defaultValue:{value:"'Balloon'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var J=X,Z=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4976 12.4153-1.0464-3.13v-2.0053a5.455 5.455 0 0 0 -4.7012-5.3938v-1.1076a.75.75 0 1 0 -1.5 0v1.1076a5.455 5.455 0 0 0 -4.7007 5.3938v2.0049l-1.0469 3.13a.75.75 0 0 0 .7114.9878h3.2062a2.58 2.58 0 0 0 5.16 0h3.2059a.75.75 0 0 0 .7114-.9878zm-6.4976 2.0561a1.0811 1.0811 0 0 1 -1.0784-1.0684h2.1573a1.0815 1.0815 0 0 1 -1.0789 1.0684zm-4.7446-2.5683.7554-2.2583a.7556.7556 0 0 0 .0386-.2378v-2.127a3.9509 3.9509 0 1 1 7.9018 0v2.127a.7556.7556 0 0 0 .0386.2378l.7549 2.2583z"})))};Z.displayName="IconBell",Z.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Z.defaultProps={title:"Bell",color:null,size:null},Z.__docgenInfo={description:"",methods:[],displayName:"IconBell",props:{title:{defaultValue:{value:"'Bell'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ee=Z,te=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M15.2 15.95H.8a.75.75 0 0 1-.75-.75v-4.8a.75.75 0 0 1 .75-.75h4.05V5.6a.75.75 0 0 1 .75-.75h4.05V.8a.75.75 0 0 1 .75-.75h4.8a.75.75 0 0 1 .75.75v14.4a.75.75 0 0 1-.75.75zm-4.05-1.5h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm9.6-4.8h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm4.8-4.8h3.3v-3.3h-3.3z"})))};te.displayName="IconBlocks",te.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},te.defaultProps={title:"Blocks",color:null,size:null},te.__docgenInfo={description:"",methods:[],displayName:"IconBlocks",props:{title:{defaultValue:{value:"'Blocks'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ne=te,ae=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.45 1.7785a2.017 2.017 0 0 0 -2.8184.166l-7.2196 7.1743a3.03 3.03 0 0 0 -1.2645.3658c-.3232.1807-.6318.3867-.9395.5928-.2217.1484-.4434.2978-.6728.4346a2.78 2.78 0 0 1 -1.6768.5156.75.75 0 0 0 -.6631 1.2139 7.22 7.22 0 0 0 1.9756 1.7725 4.9041 4.9041 0 0 0 2.4795.7109c.0693 0 .1387-.001.208-.0049a3.7971 3.7971 0 0 0 2.6367-1.21 3.0057 3.0057 0 0 0 .7539-1.6658l7.0664-7.29a1.949 1.949 0 0 0 .1346-2.7757zm-9.07 10.7276a2.3227 2.3227 0 0 1 -1.5947.7158 3.4039 3.4039 0 0 1 -1.8535-.501 4.7472 4.7472 0 0 1 -.6182-.4355 6.0144 6.0144 0 0 0 .9922-.4863c.251-.15.4941-.3125.7373-.4756.2744-.1836.5488-.3691.8379-.53a1.5834 1.5834 0 0 1 1.1924-.1279 1.0268 1.0268 0 0 1 .625.5127 1.3188 1.3188 0 0 1 -.3184 1.3278zm7.8672-9.0049-6.4341 6.64a2.4777 2.4777 0 0 0 -.6817-.616l6.5586-6.5182c.2139-.2139.5674-.2988.6992-.167.1528.1524.0522.4668-.1421.6612z"})))};ae.displayName="IconBrush",ae.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ae.defaultProps={title:"Brush",color:null,size:null},ae.__docgenInfo={description:"",methods:[],displayName:"IconBrush",props:{title:{defaultValue:{value:"'Brush'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var re=ae,le=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6943 1.38h-1.5343v-.5958a.7.7 0 0 0 -1.4 0v.5958h-5.52v-.5958a.7.7 0 0 0 -1.4 0v.5958h-1.5343a1.7021 1.7021 0 0 0 -1.7 1.7v11.1358a1.7021 1.7021 0 0 0 1.7 1.7h11.3886a1.7021 1.7021 0 0 0 1.7-1.7v-11.1358a1.7021 1.7021 0 0 0 -1.7-1.7zm-11.3886 1.4h1.5343v.5967a.7.7 0 0 0 1.4 0v-.5967h5.52v.5967a.7.7 0 0 0 1.4 0v-.5967h1.5342a.303.303 0 0 1 .3.3v1.8721h-11.9883v-1.8721a.3031.3031 0 0 1 .2998-.3zm11.3886 11.7356h-11.3886a.303.303 0 0 1 -.3-.3v-7.8631h11.9884v7.8633a.303.303 0 0 1 -.2998.2998z"}),u.a.createElement("path",{d:"m8.3125 7.291a.7011.7011 0 0 0 -.75.1113l-1.36 1.19a.7.7 0 1 0 .9215 1.0532l.1992-.1738v3.63a.7.7 0 1 0 1.4 0v-5.173a.701.701 0 0 0 -.4107-.6377z"})))};le.displayName="IconCalendar",le.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},le.defaultProps={title:"Calendar",color:null,size:null},le.__docgenInfo={description:"",methods:[],displayName:"IconCalendar",props:{title:{defaultValue:{value:"'Calendar'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var oe=le,ie=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2065 3.4824h-3.7486l-.6005-2.084a.7008.7008 0 0 0 -.6728-.5068h-4.37a.7008.7008 0 0 0 -.6729.5068l-.6 2.084h-3.7482a.7.7 0 0 0 -.7.7v10.2258a.7.7 0 0 0 .7.7h14.413a.7.7 0 0 0 .7-.7v-10.2256a.7.7 0 0 0 -.7-.7002zm-8.8647-1.1904h3.3159l.3433 1.19h-4.002zm8.1645 11.416h-13.0126v-8.8252h13.0127z"}),u.a.createElement("path",{d:"m8 5.6846a3.61 3.61 0 1 0 3.61 3.61 3.6148 3.6148 0 0 0 -3.61-3.61zm0 5.82a2.21 2.21 0 1 1 2.21-2.21 2.2122 2.2122 0 0 1 -2.21 2.2103z"})))};ie.displayName="IconCamera",ie.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ie.defaultProps={title:"Camera",color:null,size:null},ie.__docgenInfo={description:"",methods:[],displayName:"IconCamera",props:{title:{defaultValue:{value:"'Camera'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ue=ie,se=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.7438 4.55c-.605 0-.75.35-.3222.7778l5.8006 5.8006a1.1032 1.1032 0 0 0 1.5556 0l5.8006-5.8006c.4278-.4278.2828-.7778-.3222-.7778z"})))};se.displayName="IconCaretDown",se.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},se.defaultProps={title:"CaretDown",color:null,size:null},se.__docgenInfo={description:"",methods:[],displayName:"IconCaretDown",props:{title:{defaultValue:{value:"'CaretDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ce=se,de=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.45 1.7437c0-.605-.35-.75-.7778-.3222l-5.801 5.8007a1.1032 1.1032 0 0 0 0 1.5556l5.8006 5.8006c.4278.4278.7778.2828.7778-.3222z"})))};de.displayName="IconCaretLeft",de.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},de.defaultProps={title:"CaretLeft",color:null,size:null},de.__docgenInfo={description:"",methods:[],displayName:"IconCaretLeft",props:{title:{defaultValue:{value:"'CaretLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var pe=de,me=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.55 14.2562c0 .605.35.75.7778.3222l5.8006-5.8006a1.1032 1.1032 0 0 0 0-1.5556l-5.8002-5.8006c-.4282-.4278-.7782-.2828-.7782.3222z"})))};me.displayName="IconCaretRight",me.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},me.defaultProps={title:"CaretRight",color:null,size:null},me.__docgenInfo={description:"",methods:[],displayName:"IconCaretRight",props:{title:{defaultValue:{value:"'CaretRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var fe=me,he=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.2563 11.45c.605 0 .75-.35.3222-.7778l-5.8007-5.801a1.1032 1.1032 0 0 0 -1.5556 0l-5.8006 5.8006c-.4278.4278-.2828.7778.3222.7778h12.5125z"})))};he.displayName="IconCaretUp",he.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},he.defaultProps={title:"CaretUp",color:null,size:null},he.__docgenInfo={description:"",methods:[],displayName:"IconCaretUp",props:{title:{defaultValue:{value:"'CaretUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ve=he,ge=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.8884 6.7694c.605 0 .75-.35.3222-.7778l-5.4328-5.4328a1.1033 1.1033 0 0 0 -1.5557 0l-5.4327 5.4328c-.4278.4278-.2828.7778.3222.7778z"}),u.a.createElement("path",{d:"m2.1116 9.2306c-.605 0-.75.35-.3222.7778l5.4328 5.4328a1.1033 1.1033 0 0 0 1.5557 0l5.4328-5.4328c.4278-.4278.2828-.7778-.3222-.7778z"})))};ge.displayName="IconCaretUpDown",ge.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ge.defaultProps={title:"CaretUpDown",color:null,size:null},ge.__docgenInfo={description:"",methods:[],displayName:"IconCaretUpDown",props:{title:{defaultValue:{value:"'CaretUpDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ye=ge,be=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.746 3.2629a.75.75 0 0 0 -.5781-.272h-10.6861l-.1113-1.8886a.75.75 0 0 0 -.7485-.7061h-2.7901a.75.75 0 1 0 0 1.5h2.083l.4439 7.5259a.75.75 0 0 0 .7485.706h9.9827a.7506.7506 0 0 0 .7368-.6094l1.0776-5.6372a.75.75 0 0 0 -.1584-.6186zm-2.276 5.3653h-8.6556l-.2437-4.1372h9.69z"}),u.a.createElement("path",{d:"m5.5448 11.3289a2.1375 2.1375 0 1 0 2.1372 2.1372 2.14 2.14 0 0 0 -2.1372-2.1372zm0 2.8745a.7371.7371 0 1 1 .7368-.7373.7379.7379 0 0 1 -.7368.7373z"}),u.a.createElement("path",{d:"m12.1576 11.3289a2.1375 2.1375 0 1 0 2.1377 2.1372 2.14 2.14 0 0 0 -2.1377-2.1372zm0 2.8745a.7371.7371 0 1 1 .7373-.7373.7378.7378 0 0 1 -.7373.7373z"})))};be.displayName="IconCart",be.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},be.defaultProps={title:"Cart",color:null,size:null},be.__docgenInfo={description:"",methods:[],displayName:"IconCart",props:{title:{defaultValue:{value:"'Cart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ee=be,we=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8389 8.9814h-1.6055v-2.663a.7.7 0 0 0 -.7-.7h-4.3654v-2.6624a.7.7 0 0 0 -.7-.7h-5.6067v-1.2746a.7.7 0 0 0 -1.4 0v14.0372a.7.7 0 1 0 1.4 0v-1.2745h12.9776a.7.7 0 0 0 .7-.7v-3.3625a.7.7 0 0 0 -.7-.7002zm-3.0059 0h-9.9707v-1.9629h9.9707zm-9.9707-5.3252h4.9053v1.962h-4.9053zm12.2764 8.6875h-12.2764v-1.9619h12.2764z"})))};we.displayName="IconChartBarHorz",we.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},we.defaultProps={title:"ChartBarHorz",color:null,size:null},we.__docgenInfo={description:"",methods:[],displayName:"IconChartBarHorz",props:{title:{defaultValue:{value:"'ChartBarHorz'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ze=we,_e=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0185 14.1387h-1.2744v-12.9776a.7.7 0 0 0 -.7-.7h-3.3625a.7.7 0 0 0 -.7.7v1.6055h-2.6632a.7.7 0 0 0 -.7.7v4.3654h-2.6624a.7.7 0 0 0 -.7.7v5.6065h-1.2746a.7.7 0 0 0 0 1.4h14.0372a.7.7 0 1 0 0-1.4zm-4.6367-12.2774h1.9619v12.2764h-1.9619zm-3.3633 2.3057h1.9629v9.9707h-1.9629zm-3.3623 5.0654h1.962v4.9053h-1.962z"})))};_e.displayName="IconChartBarVert",_e.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},_e.defaultProps={title:"ChartBarVert",color:null,size:null},_e.__docgenInfo={description:"",methods:[],displayName:"IconChartBarVert",props:{title:{defaultValue:{value:"'ChartBarVert'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var xe=_e,Ce=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8538 11.9136a7.84 7.84 0 0 0 0-7.8271c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0222-.022-.0312-.0353a7.9476 7.9476 0 0 0 -2.8259-2.826c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0061-.0242.012-.0357zm-6.1538-7.9287v-2.4456a6.44 6.44 0 0 1 1.9222.5181l-1.2233 2.1192a4.0331 4.0331 0 0 0 -.6989-.1917zm-.7 1.3295a2.6855 2.6855 0 1 1 -2.6856 2.6856 2.689 2.689 0 0 1 2.6856-2.6856zm3.8234 1.2866 2.1193-1.2235a6.4482 6.4482 0 0 1 0 5.2448l-2.1194-1.2231a3.8586 3.8586 0 0 0 0-2.7982zm1.4148-2.4334-2.12 1.2238a4.09 4.09 0 0 0 -.51-.51l1.2238-2.12a6.546 6.546 0 0 1 1.4062 1.4063zm-5.2382 10.3324a6.4992 6.4992 0 0 1 -.7-12.9607v2.4456a4.0789 4.0789 0 1 0 3.8184 6.6238l2.12 1.2236a6.4887 6.4887 0 0 1 -5.2384 2.6677z"})))};Ce.displayName="IconChartDonut",Ce.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ce.defaultProps={title:"ChartDonut",color:null,size:null},Ce.__docgenInfo={description:"",methods:[],displayName:"IconChartDonut",props:{title:{defaultValue:{value:"'ChartDonut'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ne=Ce,qe=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.95 7.95 0 0 0 -7.95-7.95zm0 4.8891a3.0609 3.0609 0 1 1 -3.0609 3.0609 3.0609 3.0609 0 0 1 3.0609-3.0609zm0 9.3053a6.2444 6.2444 0 0 1 -6.2444-6.2444v-.0027a.5185.5185 0 1 1 1.0369 0l.0025.0027a5.205 5.205 0 1 0 5.205-5.2049v-1.0394a6.2444 6.2444 0 1 1 0 12.4887z"})))};qe.displayName="IconChartDonutFilled",qe.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},qe.defaultProps={title:"ChartDonutFilled",color:null,size:null},qe.__docgenInfo={description:"",methods:[],displayName:"IconChartDonutFilled",props:{title:{defaultValue:{value:"'ChartDonutFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ie=qe,ke=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.7813.8164a2.1616 2.1616 0 0 0 -2.1582 2.1592 2.1377 2.1377 0 0 0 .46 1.3164l-2.5626 4.1357-2.3916-3.0312a.71.71 0 0 0 -.6358-.2832.7482.7482 0 0 0 -.5957.36l-3.2774 5.4325a2.1577 2.1577 0 1 0 1.757 2.1186 2.1381 2.1381 0 0 0 -.4762-1.3359l2.7213-4.5118 2.3838 3.0205a.75.75 0 0 0 1.2266-.0693l3.1209-5.0364a2.159 2.159 0 1 0 .4279-4.2751zm-11.5625 12.9668a.7588.7588 0 1 1 .7578-.7588.7589.7589 0 0 1 -.7578.7588zm11.5625-10.0488a.7588.7588 0 1 1 .7588-.7588.7587.7587 0 0 1 -.7588.7588z"})))};ke.displayName="IconChartLine",ke.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ke.defaultProps={title:"ChartLine",color:null,size:null},ke.__docgenInfo={description:"",methods:[],displayName:"IconChartLine",props:{title:{defaultValue:{value:"'ChartLine'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ve=ke,Oe=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.8538 11.9135a7.84 7.84 0 0 0 0-7.827c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0223-.0221-.0313-.0355a7.9482 7.9482 0 0 0 -2.8258-2.8258c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0062-.0243.012-.0358zm-6.1538-10.3742a6.44 6.44 0 0 1 1.9222.5181l-1.9222 3.3296zm5.8 6.4607a6.4553 6.4553 0 0 1 -.5573 2.6224l-4.5427-2.6224 4.5426-2.6224a6.4553 6.4553 0 0 1 .5574 2.6224zm-1.2618-3.8323-3.3261 1.92 1.92-3.3261a6.5459 6.5459 0 0 1 1.4061 1.4061zm-5.2382 10.3323a6.4992 6.4992 0 0 1 -.7-12.9607v6.4607c0 .0147.0075.0269.0084.0414a.6676.6676 0 0 0 .0123.0909.7319.7319 0 0 0 .06.178c.0064.0127.006.0269.0132.0393.0061.01.018.0143.0245.0244a.6711.6711 0 0 0 .0585.0792.681.681 0 0 0 .11.0971.6594.6594 0 0 0 .0637.0562l5.5878 3.2258a6.4887 6.4887 0 0 1 -5.2384 2.6677z"})))};Oe.displayName="IconChartPie",Oe.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Oe.defaultProps={title:"ChartPie",color:null,size:null},Oe.__docgenInfo={description:"",methods:[],displayName:"IconChartPie",props:{title:{defaultValue:{value:"'ChartPie'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Te=Oe,Pe=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.12 9.3642a.7517.7517 0 0 0 -.9072.55 5.8884 5.8884 0 1 1 -7.3105-7.0793.75.75 0 0 0 -.4043-1.4443 7.3886 7.3886 0 1 0 9.172 8.8809.75.75 0 0 0 -.55-.9073z"}),u.a.createElement("path",{d:"m8.5049.1074a.75.75 0 0 0 -.75.75v6.6377a.75.75 0 0 0 .75.75h6.6377a.75.75 0 0 0 .75-.75 7.3962 7.3962 0 0 0 -7.3877-7.3877zm.75 6.6377v-5.09a5.9 5.9 0 0 1 5.09 5.09z"})))};Pe.displayName="IconChartSegment",Pe.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Pe.defaultProps={title:"ChartSegment",color:null,size:null},Pe.__docgenInfo={description:"",methods:[],displayName:"IconChartSegment",props:{title:{defaultValue:{value:"'ChartSegment'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Se=Pe,je=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.6372 4.3755h-2.958v-1.8008a1.2139 1.2139 0 0 0 -1.2041-1.2207h-9.1094a1.216 1.216 0 0 0 -1.208 1.2207v6.0908a1.2181 1.2181 0 0 0 1.208 1.2245h.916l.002 1.0381a.7.7 0 0 0 1.2256.46l.8125-.924v1.2249a1.2139 1.2139 0 0 0 1.2041 1.221h5.6494l1.3184 1.498a.7.7 0 0 0 1.2256-.4619v-1.0361h.918a1.2148 1.2148 0 0 0 1.2051-1.2207v-6.0931a1.2147 1.2147 0 0 0 -1.2052-1.2207zm-10.6523 4.3525-.3125.3555a.7011.7011 0 0 0 -.6924-.5935h-1.4219v-5.7356h8.7207v1.6211h-4.7529a1.2139 1.2139 0 0 0 -1.2041 1.2207v2.9343a.6865.6865 0 0 0 -.3369.1975zm10.457 2.7812h-1.4219a.7.7 0 0 0 -.6914.5918l-.3115-.3535a.6991.6991 0 0 0 -.5254-.2383h-5.77v-5.7333h8.72z"})))};je.displayName="IconChat",je.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},je.defaultProps={title:"Chat",color:null,size:null},je.__docgenInfo={description:"",methods:[],displayName:"IconChat",props:{title:{defaultValue:{value:"'Chat'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Fe=je,Be=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m6.4372 13.125a.7475.7475 0 0 1 -.53-.22l-5.6247-5.6242a.75.75 0 0 1 1.0605-1.0608l5.0942 5.0942 8.22-8.22a.75.75 0 0 1 1.0605 1.0605l-8.75 8.75a.7476.7476 0 0 1 -.5305.2203z"})))};Be.displayName="IconCheck",Be.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Be.defaultProps={title:"Check",color:null,size:null},Be.__docgenInfo={description:"",methods:[],displayName:"IconCheck",props:{title:{defaultValue:{value:"'Check'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Me=Be,Re=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6646 2.33a.75.75 0 0 0 -1.0605 0l-7.2341 7.234-3.2191-3.2193a.75.75 0 1 0 -1.0609 1.0606l3.75 3.75a.75.75 0 0 0 1.0605 0l7.7642-7.7642a.75.75 0 0 0 -.0001-1.0611z"}),u.a.createElement("path",{d:"m13.8457 7.12a.75.75 0 0 0 -.75.75v6.5835h-11.48v-12.9071h11.5288a.75.75 0 0 0 0-1.5h-12.2788a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-7.3336a.75.75 0 0 0 -.75-.75z"})))};Re.displayName="IconCheckBox",Re.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Re.defaultProps={title:"CheckBox",color:null,size:null},Re.__docgenInfo={description:"",methods:[],displayName:"IconCheckBox",props:{title:{defaultValue:{value:"'CheckBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Le=Re,Ae=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8877 7.3a.75.75 0 0 0 -1.4941.1328c.0166.1865.0244.376.0244.5669a6.4161 6.4161 0 1 1 -2.83-5.3228.75.75 0 0 0 .84-1.2432 7.9194 7.9194 0 1 0 3.49 6.5663q0-.3538-.0303-.7z"}),u.a.createElement("path",{d:"m5.2451 6.4853a.75.75 0 0 0 -1.0605 1.0606l3.2854 3.2841a.75.75 0 0 0 1.0605 0l6.8005-6.8007a.75.75 0 0 0 -1.061-1.0606l-6.27 6.2706z"})))};Ae.displayName="IconCheckCircle",Ae.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ae.defaultProps={title:"CheckCircle",color:null,size:null},Ae.__docgenInfo={description:"",methods:[],displayName:"IconCheckCircle",props:{title:{defaultValue:{value:"'CheckCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var De=Ae,Ue=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 11.77a.7494.7494 0 0 1 -.53-.22l-6.04-6.04a.75.75 0 1 1 1.0607-1.06l5.5093 5.5095 5.5088-5.51a.75.75 0 0 1 1.0612 1.0605l-6.0392 6.04a.75.75 0 0 1 -.5308.22z"})))};Ue.displayName="IconChevronDown",Ue.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ue.defaultProps={title:"ChevronDown",color:null,size:null},Ue.__docgenInfo={description:"",methods:[],displayName:"IconChevronDown",props:{title:{defaultValue:{value:"'ChevronDown'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var He=Ue,We=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.02 14.79a.7467.7467 0 0 1 -.53-.22l-6.04-6.0395a.75.75 0 0 1 0-1.0605l6.0391-6.04a.75.75 0 1 1 1.0609 1.06l-5.509 5.51 5.509 5.51a.75.75 0 0 1 -.53 1.28z"})))};We.displayName="IconChevronLeft",We.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},We.defaultProps={title:"ChevronLeft",color:null,size:null},We.__docgenInfo={description:"",methods:[],displayName:"IconChevronLeft",props:{title:{defaultValue:{value:"'ChevronLeft'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ge=We,Ke=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.98 14.79a.75.75 0 0 1 -.53-1.28l5.5095-5.51-5.5095-5.51a.75.75 0 0 1 1.06-1.06l6.04 6.04a.75.75 0 0 1 0 1.0605l-6.04 6.0395a.7467.7467 0 0 1 -.53.22z"})))};Ke.displayName="IconChevronRight",Ke.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ke.defaultProps={title:"ChevronRight",color:null,size:null},Ke.__docgenInfo={description:"",methods:[],displayName:"IconChevronRight",props:{title:{defaultValue:{value:"'ChevronRight'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $e=Ke,Qe=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.04 11.77a.7467.7467 0 0 1 -.53-.22l-5.51-5.5095-5.51 5.51a.75.75 0 1 1 -1.06-1.0605l6.04-6.04a.75.75 0 0 1 .53-.22.7494.7494 0 0 1 .53.22l6.04 6.04a.75.75 0 0 1 -.53 1.28z"})))};Qe.displayName="IconChevronUp",Qe.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Qe.defaultProps={title:"ChevronUp",color:null,size:null},Qe.__docgenInfo={description:"",methods:[],displayName:"IconChevronUp",props:{title:{defaultValue:{value:"'ChevronUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ye=Qe,Xe=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 15.8574a7.8574 7.8574 0 1 1 7.8572-7.8574 7.8661 7.8661 0 0 1 -7.8572 7.8574zm0-14.2148a6.3574 6.3574 0 1 0 6.3572 6.3574 6.3645 6.3645 0 0 0 -6.3572-6.3574z"})))};Xe.displayName="IconCircle",Xe.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Xe.defaultProps={title:"Circle",color:null,size:null},Xe.__docgenInfo={description:"",methods:[],displayName:"IconCircle",props:{title:{defaultValue:{value:"'Circle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Je=Xe,Ze=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .0874a7.9126 7.9126 0 1 0 7.9128 7.9126 7.9217 7.9217 0 0 0 -7.9128-7.9126zm0 14.3252a6.4126 6.4126 0 1 1 6.4128-6.4126 6.42 6.42 0 0 1 -6.4128 6.4126z"}),u.a.createElement("path",{d:"m12.6746 9.896-3.9246-2.3243v-3.9917a.75.75 0 1 0 -1.5 0v4.42a.6964.6964 0 0 0 .0175.0865.7258.7258 0 0 0 .0308.1525.94.94 0 0 0 .14.2449.7266.7266 0 0 0 .1112.1.7083.7083 0 0 0 .068.0613l4.2925 2.5418a.75.75 0 0 0 .7646-1.291z"})))};Ze.displayName="IconClock",Ze.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ze.defaultProps={title:"Clock",color:null,size:null},Ze.__docgenInfo={description:"",methods:[],displayName:"IconClock",props:{title:{defaultValue:{value:"'Clock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var et=Ze,tt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1826 5.79h-3.4883v-3.663a.75.75 0 0 0 -.75-.75h-10.1269a.75.75 0 0 0 -.75.75v7.333a.75.75 0 0 0 .75.75h3.4883v3.663a.75.75 0 0 0 .75.75h10.1269a.75.75 0 0 0 .75-.75v-7.333a.75.75 0 0 0 -.75-.75zm-13.6152 2.92v-5.833h8.627v2.913h-5.1387a.75.75 0 0 0 -.75.75v2.17zm12.8652 4.413h-8.6269v-5.833h8.6269z"})))};tt.displayName="IconClone",tt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},tt.defaultProps={title:"Clone",color:null,size:null},tt.__docgenInfo={description:"",methods:[],displayName:"IconClone",props:{title:{defaultValue:{value:"'Clone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nt=tt,at=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6689 8.2637a5.3086 5.3086 0 1 0 -10.3534-2.305 4.2991 4.2991 0 0 0 1.0678 8.4656h8.3877a3.1445 3.1445 0 0 0 .8979-6.1606zm-.8979 4.6606h-8.3877a2.8079 2.8079 0 1 1 .7944-5.502.75.75 0 0 0 .4229-1.4394 4.2852 4.2852 0 0 0 -.7358-.14 3.8234 3.8234 0 1 1 6.1166 4.001.75.75 0 1 0 .959 1.1533 5.3486 5.3486 0 0 0 .7949-.8193 5.3688 5.3688 0 0 0 .3472-.5286 1.6523 1.6523 0 0 1 -.3116 3.2752z"})))};at.displayName="IconCloud",at.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},at.defaultProps={title:"Cloud",color:null,size:null},at.__docgenInfo={description:"",methods:[],displayName:"IconCloud",props:{title:{defaultValue:{value:"'Cloud'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var rt=at,lt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.1821 6.9551a4.7865 4.7865 0 0 0 .1328-1.1172 4.9125 4.9125 0 0 0 -4.9072-4.9072 4.8593 4.8593 0 0 0 -4.291 2.5449 2.898 2.898 0 0 0 -.4009-.0283 2.9707 2.9707 0 0 0 -2.9673 2.9677 2.8726 2.8726 0 0 0 .0532.5488 3.47 3.47 0 0 0 -1.7685 3.0313 3.506 3.506 0 0 0 3.5019 3.502h2.0137a.75.75 0 0 0 0-1.5h-2.0136a1.9941 1.9941 0 0 1 -.5869-3.9023.75.75 0 0 0 .4531-1.0448 1.4437 1.4437 0 0 1 -.1528-.6348 1.4767 1.4767 0 0 1 2.0088-1.36.7509.7509 0 0 0 .977-.4287 3.3992 3.3992 0 1 1 6.3325 2.4717.75.75 0 0 0 .478.9951 1.9837 1.9837 0 0 1 1.4219 1.9023 2.0044 2.0044 0 0 1 -2.002 2.002h-2.0141a.75.75 0 1 0 0 1.5h2.0142a3.506 3.506 0 0 0 3.502-3.502 3.4662 3.4662 0 0 0 -1.7848-3.0405z"}),u.a.createElement("path",{d:"m9.92 10.0391a.75.75 0 1 0 1.061-1.0606l-2.451-2.4502a.7527.7527 0 0 0 -1.0605 0l-2.4512 2.45a.75.75 0 1 0 1.0605 1.0605l1.1712-1.17v5.4506a.75.75 0 1 0 1.5 0v-5.4504z"})))};lt.displayName="IconCloudArrow",lt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},lt.defaultProps={title:"CloudArrow",color:null,size:null},lt.__docgenInfo={description:"",methods:[],displayName:"IconCloudArrow",props:{title:{defaultValue:{value:"'CloudArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ot=lt,it=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.3594.6035h-4.7188a5.6035 5.6035 0 0 0 0 11.207h1.6094v2.8359a.7512.7512 0 0 0 .4385.6826.7588.7588 0 0 0 .3115.0675.7494.7494 0 0 0 .4922-.1836l5.7978-5.0381c.0137-.0117.0264-.0244.0391-.0371a5.5412 5.5412 0 0 0 1.6338-3.9307 5.61 5.61 0 0 0 -5.6035-5.6035zm2.9248 8.457-4.5342 3.9405v-1.94a.75.75 0 0 0 -.75-.75h-2.3594a4.1035 4.1035 0 0 1 0-8.207h4.7187a4.1082 4.1082 0 0 1 4.1036 4.103 4.0463 4.0463 0 0 1 -1.1787 2.8535z"})))};it.displayName="IconComment",it.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},it.defaultProps={title:"Comment",color:null,size:null},it.__docgenInfo={description:"",methods:[],displayName:"IconComment",props:{title:{defaultValue:{value:"'Comment'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ut=it,st=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.7926 4.3838a.7414.7414 0 0 0 -1.0485 1.0485l3.1759 3.1771a.7412.7412 0 0 0 1.0484 0l6.4516-6.4509a.7414.7414 0 1 0 -1.0488-1.0485l-5.9266 5.9268z"}),u.a.createElement("path",{d:"m15.8638 6.2316a5.6034 5.6034 0 0 0 -.0608-.8206.7419.7419 0 0 0 -1.4674.22 3.9891 3.9891 0 0 1 -1.1264 3.4241l-4.4673 3.8832v-1.9144a.7416.7416 0 0 0 -.7419-.7414h-2.33a4.0514 4.0514 0 1 1 0-8.1027h5.24a.7414.7414 0 0 0 0-1.4829h-5.2391a5.5342 5.5342 0 1 0 0 11.0685h1.5881v2.8a.7575.7575 0 0 0 .4335.6748.7872.7872 0 0 0 .7945-.1149l5.7249-4.9757-.006-.007c.0139-.0119.0315-.0164.0447-.03a5.4657 5.4657 0 0 0 1.6132-3.881z"})))};st.displayName="IconCommentCheck",st.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},st.defaultProps={title:"CommentCheck",color:null,size:null},st.__docgenInfo={description:"",methods:[],displayName:"IconCommentCheck",props:{title:{defaultValue:{value:"'CommentCheck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ct=st,dt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.2436.93h-4.4873a5.3652 5.3652 0 0 0 0 10.73h1.4937v2.66a.75.75 0 0 0 1.2417.5659l5.5137-4.791c.0137-.0117.0273-.0239.04-.0366a5.3073 5.3073 0 0 0 1.5635-3.7637 5.3712 5.3712 0 0 0 -5.3653-5.3646z"})))};dt.displayName="IconCommentFilled",dt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},dt.defaultProps={title:"CommentFilled",color:null,size:null},dt.__docgenInfo={description:"",methods:[],displayName:"IconCommentFilled",props:{title:{defaultValue:{value:"'CommentFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var pt=dt,mt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.97 7.97 7.9787 7.9787 0 0 0 -7.97-7.97zm0 14.44a6.47 6.47 0 1 1 6.47-6.47 6.4773 6.4773 0 0 1 -6.47 6.47z"}),u.a.createElement("path",{d:"m9.8665 6.1333a.75.75 0 1 0 1.0605-1.0605 4.14 4.14 0 1 0 0 5.8535.75.75 0 1 0 -1.0605-1.0606 2.7 2.7 0 0 1 -3.7329 0 2.6394 2.6394 0 1 1 3.7329-3.7324z"})))};mt.displayName="IconCopyright",mt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},mt.defaultProps={title:"Copyright",color:null,size:null},mt.__docgenInfo={description:"",methods:[],displayName:"IconCopyright",props:{title:{defaultValue:{value:"'Copyright'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ft=mt,ht=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6357 2.3672a7.9653 7.9653 0 1 0 0 11.2705 7.9164 7.9164 0 0 0 0-11.2705zm-1.0605 1.0605a6.4766 6.4766 0 0 1 .497 8.5858l-9.0839-9.0828a6.462 6.462 0 0 1 8.5869.4971zm-9.15 9.1494a6.4766 6.4766 0 0 1 -.4969-8.5858l9.0834 9.0825a6.4791 6.4791 0 0 1 -8.5869-.4967z"})))};ht.displayName="IconDanger",ht.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ht.defaultProps={title:"Danger",color:null,size:null},ht.__docgenInfo={description:"",methods:[],displayName:"IconDanger",props:{title:{defaultValue:{value:"'Danger'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var vt=ht,gt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 11.8784a2 2 0 0 0 1.3146-3.5136l.7772-2.0655a.7.7 0 0 0 -1.3105-.4932l-.774 2.0569-.0073-.0007a2.0081 2.0081 0 0 0 0 4.0161zm0-2.6157a.6077.6077 0 1 1 -.6074.6079.6082.6082 0 0 1 .6074-.6079z"}),u.a.createElement("path",{d:"m15.8877 9.8706a7.8787 7.8787 0 0 0 -.1211-1.33c-.0016-.0136.0034-.0263.001-.04-.002-.0109-.0092-.019-.0117-.03a7.8824 7.8824 0 0 0 -2.6607-4.6116c-.01-.0094-.0143-.0222-.0249-.0311-.0071-.006-.0162-.0071-.0235-.0128a7.8646 7.8646 0 0 0 -10.0936 0c-.0073.0057-.0164.0068-.0235.0128-.0106.0089-.015.0217-.0249.0311a7.8825 7.8825 0 0 0 -2.6607 4.611c-.0024.0109-.01.019-.0117.03-.0024.0137.0026.0263.001.04a7.7236 7.7236 0 0 0 .7988 5.0184.6854.6854 0 0 0 .033.0707l.009.0194c.0032.0058.01.0077.0131.0134a.6869.6869 0 0 0 .2322.2385c.0112.007.02.0151.0318.0214a.6812.6812 0 0 0 .3323.0954h12.625a.6888.6888 0 0 0 .5806-.3318.6526.6526 0 0 0 .0464-.0554 7.9037 7.9037 0 0 0 .9521-3.7594zm-12.5644-4.4847.6718.8011a.7.7 0 1 0 1.0723-.8994l-.6754-.8054a6.4462 6.4462 0 0 1 2.908-1.06v1.0524a.7.7 0 1 0 1.4 0v-1.0524a6.4462 6.4462 0 0 1 2.9078 1.06l-.6754.8054a.7.7 0 1 0 1.0723.8994l.6718-.8011a6.4832 6.4832 0 0 1 1.549 2.6757l-1.0342.1826a.7.7 0 1 0 .2441 1.3789l1.03-.1818c.0094.1426.0218.2844.0218.4294a6.4994 6.4994 0 0 1 -.6221 2.7466h-11.7303a6.497 6.497 0 0 1 -.6221-2.7466c0-.145.0124-.2868.0218-.4294l1.03.1818a.7.7 0 0 0 .2441-1.3789l-1.0342-.1826a6.4832 6.4832 0 0 1 1.5489-2.6757z"})))};gt.displayName="IconDashboard",gt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},gt.defaultProps={title:"Dashboard",color:null,size:null},gt.__docgenInfo={description:"",methods:[],displayName:"IconDashboard",props:{title:{defaultValue:{value:"'Dashboard'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var yt=gt,bt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.1773 1.1894h-12.3545a1.7021 1.7021 0 0 0 -1.7 1.7v7.4824a1.7021 1.7021 0 0 0 1.7 1.7h3.9658l-.4847 1.3382h-1.2199a.7.7 0 1 0 0 1.4h7.832a.7.7 0 0 0 0-1.4h-1.22l-.4847-1.3379h3.9658a1.7021 1.7021 0 0 0 1.7-1.7v-7.4821a1.7021 1.7021 0 0 0 -1.6998-1.7006zm-4.9703 12.2206h-2.414l.4847-1.3379h1.4447zm5.27-3.0381a.3.3 0 0 1 -.3.3h-12.3542a.3.3 0 0 1 -.3-.3v-7.4819a.3.3 0 0 1 .3-.3h12.3544a.3.3 0 0 1 .3.3z"})))};bt.displayName="IconDesktop",bt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},bt.defaultProps={title:"Desktop",color:null,size:null},bt.__docgenInfo={description:"",methods:[],displayName:"IconDesktop",props:{title:{defaultValue:{value:"'Desktop'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Et=bt,wt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4845.0425h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5236a.7433.7433 0 0 0 -.2158.55v10.871a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.4146a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.02h-2.02zm8.918 12.3849h-11.4687v-8.8646h3.3008a.75.75 0 0 0 .75-.75v-3.3h7.418z"})))};wt.displayName="IconDocument",wt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},wt.defaultProps={title:"Document",color:null,size:null},wt.__docgenInfo={description:"",methods:[],displayName:"IconDocument",props:{title:{defaultValue:{value:"'Document'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var zt=wt,_t=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.2545 10.671-2.0971-2.0968a.75.75 0 0 0 -1.0606 1.0606l3.3774 3.377a.7527.7527 0 0 0 1.0605 0l3.377-3.377a.75.75 0 0 0 -1.0605-1.0605l-2.0967 2.0966v-4.6582a.75.75 0 0 0 -1.5 0z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-11.4687v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};_t.displayName="IconDocumentArrow",_t.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},_t.defaultProps={title:"DocumentArrow",color:null,size:null},_t.__docgenInfo={description:"",methods:[],displayName:"IconDocumentArrow",props:{title:{defaultValue:{value:"'DocumentArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var xt=_t,Ct=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5185 3.2832h-2.356v-2.3555a.75.75 0 0 0 -.75-.75h-6.2836a.7608.7608 0 0 0 -.53.22l-3.6477 3.6472a.7608.7608 0 0 0 -.22.53v7.3916a.75.75 0 0 0 .75.75h2.3562v2.3555a.75.75 0 0 0 .75.75h9.9312a.75.75 0 0 0 .75-.75v-11.0388a.75.75 0 0 0 -.7501-.75zm-9.9546-.73v1.4568h-1.4565zm-2.3325 2.9568h3.0826a.75.75 0 0 0 .75-.75v-3.0823h4.5986v9.5391h-8.4312zm11.5371 8.8125h-8.4311v-1.6057h6.0752a.75.75 0 0 0 .75-.75v-7.1836h1.606z"})))};Ct.displayName="IconDocumentClone",Ct.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ct.defaultProps={title:"DocumentClone",color:null,size:null},Ct.__docgenInfo={description:"",methods:[],displayName:"IconDocumentClone",props:{title:{defaultValue:{value:"'DocumentClone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Nt=Ct,qt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.3628.1875h-12.7256a.75.75 0 0 0 -.75.75v14.125a.75.75 0 0 0 .75.75h12.7256a.75.75 0 0 0 .75-.75v-14.125a.75.75 0 0 0 -.75-.75zm-.75 14.125h-11.2256v-12.625h11.2256z"}),u.a.createElement("path",{d:"m6.895 6.0313h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m4.28 6.09a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07.8924.8924 0 0 0 .54-.81.8947.8947 0 0 0 -.26-.62.92.92 0 0 0 -1.24 0 .8834.8834 0 0 0 -.25.62.8542.8542 0 0 0 .54.81z"}),u.a.createElement("path",{d:"m4.28 8.81a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07 1.0578 1.0578 0 0 0 .28-.19.8719.8719 0 0 0 .26-.62.7543.7543 0 0 0 -.07-.33.81.81 0 0 0 -.19-.29.9018.9018 0 0 0 -.95-.19.9414.9414 0 0 0 -.48.48.916.916 0 0 0 -.06.33.87.87 0 0 0 .26.62.9127.9127 0 0 0 .28.19z"}),u.a.createElement("path",{d:"m6.895 8.75h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m3.99 11.34a.9035.9035 0 0 0 .62.25.9934.9934 0 0 0 .34-.06 1.085 1.085 0 0 0 .28-.19.81.81 0 0 0 .19-.29.726.726 0 0 0 .07-.33.8.8 0 0 0 -.07-.34.8744.8744 0 0 0 -.19-.28.8736.8736 0 0 0 -1.24 0 .8355.8355 0 0 0 -.18.28.7933.7933 0 0 0 -.07.34.8788.8788 0 0 0 .06.33.9634.9634 0 0 0 .19.29z"}),u.a.createElement("path",{d:"m6.895 11.4688h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z"})))};qt.displayName="IconDocumentList",qt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},qt.defaultProps={title:"DocumentList",color:null,size:null},qt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentList",props:{title:{defaultValue:{value:"'DocumentList'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var It=qt,kt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.2482 8.3848h-2.5933a.75.75 0 0 0 0 1.5h2.5933v2.5937a.75.75 0 1 0 1.5 0v-2.5937h2.5933a.75.75 0 0 0 0-1.5h-2.5933v-2.5928a.75.75 0 0 0 -1.5 0z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-11.4687v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};kt.displayName="IconDocumentPlus",kt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},kt.defaultProps={title:"DocumentPlus",color:null,size:null},kt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentPlus",props:{title:{defaultValue:{value:"'DocumentPlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Vt=kt,Ot=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7432 12.8037-2.31-2.31a4.3289 4.3289 0 0 0 -1.4194-6.2927v-2.5535a.75.75 0 0 0 -.75-.75h-6.901a.7607.7607 0 0 0 -.53.22l-3.576 3.5754a.7609.7609 0 0 0 -.22.53v9.1294a.75.75 0 0 0 .75.75h10.4774a.75.75 0 0 0 .75-.75v-2.584c.1215-.0693.2449-.1335.3588-.2137l2.31 2.31a.75.75 0 0 0 1.0605-1.0605zm-5.8794-1.9468a2.8721 2.8721 0 1 1 2.8726-2.8721 2.8755 2.8755 0 0 1 -2.8726 2.8721zm-5.9131-7.7369v1.691h-1.6907zm6.5635 10.4824h-8.9771v-7.2914h3.1636a.75.75 0 0 0 .75-.75v-3.1635h5.0635v1.281a4.32 4.32 0 0 0 -.65-.0657 4.3721 4.3721 0 1 0 0 8.7441 4.3216 4.3216 0 0 0 .65-.0657z"})))};Ot.displayName="IconDocumentSearch",Ot.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ot.defaultProps={title:"DocumentSearch",color:null,size:null},Ot.__docgenInfo={description:"",methods:[],displayName:"IconDocumentSearch",props:{title:{defaultValue:{value:"'DocumentSearch'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Tt=Ot,Pt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 10.7448c1.4893 0 2.271-2.3412 1.6728-3.6546a1.7923 1.7923 0 0 0 -1.6728-1.0416 1.7924 1.7924 0 0 0 -1.6728 1.0414c-.598 1.3136.1836 3.6548 1.6728 3.6548z"}),u.a.createElement("path",{d:"m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-1.6045c-.0039-2.8742-1.004-2.07-2.5243-3.0574a.407.407 0 0 0 -.5287.0661l-.8569.8625a.31.31 0 0 1 -.44 0l-.8569-.8625a.4072.4072 0 0 0 -.5287-.0661c-1.52.9879-2.52.1833-2.524 3.0574h-1.6047v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z"})))};Pt.displayName="IconDocumentUser",Pt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Pt.defaultProps={title:"DocumentUser",color:null,size:null},Pt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentUser",props:{title:{defaultValue:{value:"'DocumentUser'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var St=Pt,jt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.822 9.877-2.259 2.889h2.108l1.202-1.624 1.191 1.624h2.2l-2.317-2.95 2.13-2.665h-2.115l-1.087 1.435-1.032-1.435h-2.191z"}),u.a.createElement("path",{d:"m14.4845.0425h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5236a.7433.7433 0 0 0 -.2158.55v10.871a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.4146a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.02h-2.02zm8.918 12.3849h-11.4687v-8.8646h3.3008a.75.75 0 0 0 .75-.75v-3.3h7.418z"})))};jt.displayName="IconDocumentX",jt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},jt.defaultProps={title:"DocumentX",color:null,size:null},jt.__docgenInfo={description:"",methods:[],displayName:"IconDocumentX",props:{title:{defaultValue:{value:"'DocumentX'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ft=jt,Bt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.91 2.7692a.7258.7258 0 0 0 -.0319-.1581.7209.7209 0 0 0 -.0787-.1371.7092.7092 0 0 0 -.0547-.0951c-.0056-.0064-.0137-.0087-.0195-.0148a.7418.7418 0 0 0 -.1309-.0994.7537.7537 0 0 0 -.1047-.0706.7531.7531 0 0 0 -.1281-.0338.7384.7384 0 0 0 -.1564-.0316c-.0084 0-.0154-.0048-.0239-.0048h-14.3624c-.0085 0-.0156.0045-.024.0048a.7447.7447 0 0 0 -.1571.0317.7581.7581 0 0 0 -.1277.0337.7553.7553 0 0 0 -.1058.0714.7392.7392 0 0 0 -.13.0987c-.0052.0058-.0132.0084-.0188.0147a.711.711 0 0 0 -.0547.0951.7218.7218 0 0 0 -.0787.1371.7258.7258 0 0 0 -.032.1581.7021.7021 0 0 0 -.0212.1048v10.252a.75.75 0 0 0 .75.75h14.3624a.75.75 0 0 0 .75-.75v-10.252a.7018.7018 0 0 0 -.0212-.1048zm-2.7191.8548-5.1909 4.5601-5.1909-4.5601zm-11.6221 8.752v-7.8447l5.936 5.2148a.75.75 0 0 0 .99 0l5.936-5.2148v7.8447z"})))};Bt.displayName="IconEmail",Bt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Bt.defaultProps={title:"Email",color:null,size:null},Bt.__docgenInfo={description:"",methods:[],displayName:"IconEmail",props:{title:{defaultValue:{value:"'Email'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Mt=Bt,Rt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 4.43a3.57 3.57 0 1 0 3.57 3.57 3.574 3.574 0 0 0 -3.57-3.57zm0 5.74a2.17 2.17 0 1 1 2.1694-2.17 2.1715 2.1715 0 0 1 -2.1694 2.17z"}),u.a.createElement("path",{d:"m15.7974 7.635c-.1174-.1914-2.919-4.6894-7.7974-4.6894s-7.68 4.498-7.7974 4.6894a.7.7 0 0 0 0 .7295c.1172.1914 2.919 4.69 7.7969 4.69s7.6807-4.4985 7.7978-4.69a.7.7 0 0 0 .0001-.7295zm-7.7974 4.0191c-3.3394 0-5.6167-2.6631-6.3491-3.6541.7324-.9914 3.0098-3.654 6.3491-3.654s5.6167 2.6626 6.3491 3.654c-.7324.991-3.0097 3.6541-6.3491 3.6541z"})))};Rt.displayName="IconEye",Rt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Rt.defaultProps={title:"Eye",color:null,size:null},Rt.__docgenInfo={description:"",methods:[],displayName:"IconEye",props:{title:{defaultValue:{value:"'Eye'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Lt=Rt,At=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.83 1.2461a.75.75 0 0 0 -.689-.4541h-14.2821a.75.75 0 0 0 -.544 1.2666l5.5933 5.8887v6.5107a.75.75 0 0 0 1.5 0v-6.8105a.7506.7506 0 0 0 -.206-.5166l-4.5967-4.8389h10.789l-4.5967 4.8389a.7506.7506 0 0 0 -.206.5166v5.2334a.75.75 0 1 0 1.5 0v-4.9336l5.5933-5.8887a.75.75 0 0 0 .1449-.8125z"})))};At.displayName="IconFilter",At.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},At.defaultProps={title:"Filter",color:null,size:null},At.__docgenInfo={description:"",methods:[],displayName:"IconFilter",props:{title:{defaultValue:{value:"'Filter'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Dt=At,Ut=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4082 2.12a.708.708 0 0 0 -.0214-.1058.7057.7057 0 0 0 -.01-.109c-.0042-.0138-.0147-.0232-.02-.0366a.72.72 0 0 0 -.0731-.1368.7418.7418 0 0 0 -.076-.1127.7343.7343 0 0 0 -.1107-.0907.7377.7377 0 0 0 -.118-.08.7329.7329 0 0 0 -.1264-.0395.72.72 0 0 0 -.1572-.0318c-.0133-.0007-.0245-.0076-.0379-.0076a.7042.7042 0 0 0 -.103.0208.6983.6983 0 0 0 -.1118.01 8.312 8.312 0 0 1 -3.3877.3511 4.0238 4.0238 0 0 1 -1.0928-.6006 5.0583 5.0583 0 0 0 -3.0335-1.1056 6.2638 6.2638 0 0 0 -2.9206.752.7451.7451 0 0 0 -1.4163.3285v14.0791a.75.75 0 0 0 1.5 0v-5.0821c.0184-.0124.04-.0159.0576-.03a4.9274 4.9274 0 0 1 2.7793-.9219 3.6482 3.6482 0 0 1 2.19.8467 5.2365 5.2365 0 0 0 1.5283.8042 4.3089 4.3089 0 0 0 1.1553.1372 12.2 12.2 0 0 0 3.07-.4941c.0139-.0042.0232-.0147.0366-.02a.7193.7193 0 0 0 .1355-.0723.628.628 0 0 0 .3243-.4354.7248.7248 0 0 0 .0313-.1509c.0008-.0141.0081-.0261.0081-.04zm-4.3525 7.2582a4.024 4.024 0 0 1 -1.0928-.6006 5.0583 5.0583 0 0 0 -3.0342-1.1069 6.2394 6.2394 0 0 0 -2.8369.7093v-5.8829c.0184-.0123.04-.0159.0576-.03a4.9274 4.9274 0 0 1 2.7793-.9219 3.6481 3.6481 0 0 1 2.19.8467 5.2364 5.2364 0 0 0 1.5283.8042 4.3089 4.3089 0 0 0 1.1553.1372 10.4541 10.4541 0 0 0 2.1059-.2533v6.086a7.0647 7.0647 0 0 1 -2.8525.2122z"})))};Ut.displayName="IconFlag",Ut.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ut.defaultProps={title:"Flag",color:null,size:null},Ut.__docgenInfo={description:"",methods:[],displayName:"IconFlag",props:{title:{defaultValue:{value:"'Flag'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ht=Ut,Wt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.5547 4.5806v-3.0684h.73a.7.7 0 1 0 0-1.4h-6.57a.7.7 0 1 0 0 1.4h.73v3.0684a5.95 5.95 0 1 0 5.1094 0zm-2.5547 9.9072a4.5327 4.5327 0 0 1 -3.6412-1.85h1.7867a.7.7 0 1 0 0-1.4h-2.4833a4.47 4.47 0 0 1 -.1412-.6h2.6245a.7.7 0 1 0 0-1.4h-2.642a4.5027 4.5027 0 0 1 .1392-.6h2.5028a.7.7 0 0 0 0-1.4h-1.7955a4.561 4.561 0 0 1 2.0436-1.5415.699.699 0 0 0 .4521-.6543v-3.53h2.3086v3.53a.699.699 0 0 0 .4522.6543 4.5409 4.5409 0 0 1 -1.6065 8.7915z"})))};Wt.displayName="IconFlask",Wt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Wt.defaultProps={title:"Flask",color:null,size:null},Wt.__docgenInfo={description:"",methods:[],displayName:"IconFlask",props:{title:{defaultValue:{value:"'Flask'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Gt=Wt,Kt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m10.5547 4.5806v-3.0684h.73a.7.7 0 1 0 0-1.4h-6.57a.7.7 0 1 0 0 1.4h.73v3.0684a5.95 5.95 0 1 0 5.1094 0zm-2.5547 9.9072a4.5327 4.5327 0 0 1 -3.6412-1.85h1.7867a.7.7 0 1 0 0-1.4h-2.4833a4.47 4.47 0 0 1 -.1412-.6h2.6245a.7.7 0 1 0 0-1.4h-2.642a4.5027 4.5027 0 0 1 .1392-.6h2.5028a.7.7 0 0 0 0-1.4h-1.7955a4.561 4.561 0 0 1 2.0436-1.5415.699.699 0 0 0 .4521-.6543v-3.53h2.3086v3.53a.699.699 0 0 0 .4522.6543 4.5409 4.5409 0 0 1 -1.6065 8.7915z"})))};Kt.displayName="IconFlowChart",Kt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Kt.defaultProps={title:"FlowChart",color:null,size:null},Kt.__docgenInfo={description:"",methods:[],displayName:"IconFlowChart",props:{title:{defaultValue:{value:"'FlowChart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var $t=Kt,Qt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1772 3.63h-7.0947l-1.3476-2.3453a.75.75 0 0 0 -.65-.377h-5.2621a.75.75 0 0 0 -.75.75v12.6846a.75.75 0 0 0 .75.75h14.3544a.75.75 0 0 0 .75-.75v-9.9623a.75.75 0 0 0 -.75-.75zm-9.5272-1.2223.7024 1.2223h-4.78v-1.2223zm8.7773 11.1846h-12.8545v-8.4623h12.8545v8.4619z"})))};Qt.displayName="IconFolder",Qt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Qt.defaultProps={title:"Folder",color:null,size:null},Qt.__docgenInfo={description:"",methods:[],displayName:"IconFolder",props:{title:{defaultValue:{value:"'Folder'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Yt=Qt,Xt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.828 9.7124a.75.75 0 0 0 -.647-.3706h-2.102v-2.1343a.75.75 0 0 0 -.75-.75h-5.8447v-.9253a.75.75 0 0 0 -.75-.75h-4.9155a.75.75 0 0 0 -.75.75v9.6631l.0008.0041c0 .009.0049.017.0053.026a.733.733 0 0 0 .0865.3117c.0062.0119.0036.026.01.0377.0111.0188.0324.0269.0449.0445a.7311.7311 0 0 0 .1841.1821.7088.7088 0 0 0 .08.054.7318.7318 0 0 0 .3378.09h11.51a.7506.7506 0 0 0 .6548-.3843l2.852-5.1035a.749.749 0 0 0 -.007-.7452zm-10.8437-3.4302v.9253a.75.75 0 0 0 .75.75h5.8447v1.3843h-7.9077a.7506.7506 0 0 0 -.6548.3843l-1.4477 2.59v-6.0339zm6.9048 8.1631h-9.792l2.0142-3.6035h9.7915z"}),u.a.createElement("path",{d:"m11.8339 5.7422a.7029.7029 0 0 0 .99 0l2.0991-2.0991a.7.7 0 0 0 -.99-.99l-.9038.9041v-2.8023a.7.7 0 0 0 -1.4 0v2.802l-.9038-.9041a.7.7 0 0 0 -.99.99z"})))};Xt.displayName="IconFolderArrow",Xt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Xt.defaultProps={title:"FolderArrow",color:null,size:null},Xt.__docgenInfo={description:"",methods:[],displayName:"IconFolderArrow",props:{title:{defaultValue:{value:"'FolderArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Jt=Xt,Zt=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.769 8.1772a.75.75 0 0 0 -.75.75v4.127h-10.4843v-7.8174h7.0141a.75.75 0 1 0 0-1.5h-1.6315l-1.0897-1.8968a.7506.7506 0 0 0 -.65-.376h-4.3929a.75.75 0 0 0 -.75.75v11.59a.75.75 0 0 0 .75.75h11.9844a.75.75 0 0 0 .75-.75v-4.8768a.75.75 0 0 0 -.7501-.75zm-8.0258-5.2128.4437.7725h-3.6522v-.7725z"}),u.a.createElement("path",{d:"m15.7456 3.5474-1.8906-1.8907a.772.772 0 0 0 -1.0605 0l-1.6129 1.6133-4.0293 4.0293a.75.75 0 0 0 -.22.541l.0277 1.8633a.75.75 0 0 0 .7388.7393l1.8632.0271h.0112a.75.75 0 0 0 .53-.22l4.0268-4.0262.0018-.0009.0022-.0029 1.6116-1.6118a.75.75 0 0 0 0-1.0608zm-2.4209-.3.83.83-.5531.5531-.83-.83zm-4.0576 5.7179-.8179-.0117-.0122-.8183 3.2743-3.2743.83.83z"})))};Zt.displayName="IconFolderPencil",Zt.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Zt.defaultProps={title:"FolderPencil",color:null,size:null},Zt.__docgenInfo={description:"",methods:[],displayName:"IconFolderPencil",props:{title:{defaultValue:{value:"'FolderPencil'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var en=Zt,tn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1775 3.63h-7.0952l-1.3477-2.3458a.7506.7506 0 0 0 -.65-.376h-5.2621a.75.75 0 0 0 -.75.75v12.6836a.75.75 0 0 0 .75.75h14.355a.75.75 0 0 0 .75-.75v-9.9618a.75.75 0 0 0 -.75-.75zm-9.5275-1.2218.702 1.2218h-4.78v-1.2218zm8.7773 11.1836h-2.2115c-.1233-2.3251-1.1139-1.6335-2.5717-2.5808a.4166.4166 0 0 0 -.5413.0677l-.8774.8831a.3173.3173 0 0 1 -.45 0l-.8775-.8831a.4168.4168 0 0 0 -.5414-.0677c-1.4575.9473-2.4481.2557-2.5714 2.5808h-2.2126v-8.4618h12.855z"}),u.a.createElement("path",{d:"m6.2872 7.0741c-.6124 1.3449.188 3.7421 1.7128 3.7421s2.3256-2.3972 1.7131-3.7421a1.8353 1.8353 0 0 0 -1.7131-1.0666 1.8353 1.8353 0 0 0 -1.7128 1.0666z"})))};tn.displayName="IconFolderUser",tn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},tn.defaultProps={title:"FolderUser",color:null,size:null},tn.__docgenInfo={description:"",methods:[],displayName:"IconFolderUser",props:{title:{defaultValue:{value:"'FolderUser'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var nn=tn,an=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.3337.3208a2.4263 2.4263 0 0 0 -2.0928.0492c-.2773.172-2.6709 1.8619-1.3838 7.9728a.6989.6989 0 0 0 .6846.5562h3.1583a.7.7 0 0 0 .52-.231c.0684-.0752 1.6572-1.8867.8789-5.5566a3.6918 3.6918 0 0 0 -1.7652-2.7906zm.0063 7.1777h-2.2221c-.832-4.6367.82-5.9077.8047-5.9077a1.017 1.017 0 0 1 .8213 0 2.5268 2.5268 0 0 1 .9854 1.811 5.6227 5.6227 0 0 1 -.3893 4.0967z"}),u.a.createElement("path",{d:"m5.5983 9.4346h-2.955a.7.7 0 0 0 -.7.7109c.0039.2378.0664 2.3511 1.124 3.3125a1.8293 1.8293 0 0 0 1.2539.4888c.0527 0 .1065-.002.1611-.0063a2.097 2.097 0 0 0 1.6416-.8755 3.6706 3.6706 0 0 0 .1473-3.125.7009.7009 0 0 0 -.6729-.5054zm-.627 2.8345c-.041.06-.167.2412-.6006.2759a.4356.4356 0 0 1 -.3613-.1221 2.9743 2.9743 0 0 1 -.6016-1.5879h1.6422a2.0206 2.0206 0 0 1 -.0786 1.434z"}),u.a.createElement("path",{d:"m14.2819 4.1748a2.529 2.529 0 0 0 -1.6719-1.9986 2.9173 2.9173 0 0 0 -2.498.99c-.1074.1328-2.623 3.2959-1.3945 6.98a.7011.7011 0 0 0 .48.4546l3.0059.8149a.7246.7246 0 0 0 .1836.0244.6994.6994 0 0 0 .5967-.335c.0932-.1496 2.2406-3.7145 1.2982-6.9303zm-2.2451 5.7452-2.0947-.568a6.7518 6.7518 0 0 1 1.2187-5.26c.2627-.271.8047-.6367 1.12-.5552.2432.06.4834.436.6572 1.0313.5939 2.0266-.41 4.3796-.9012 5.3519z"}),u.a.createElement("path",{d:"m12.0769 11.9541-3.1084-.917a.6943.6943 0 0 0 -.82.3506c-.1934.3735-1.123 2.3018-.4883 3.5493a1.7356 1.7356 0 0 0 1.36.9277 2.69 2.69 0 0 0 .4131.0322c1.7978 0 2.8008-1.894 3.1211-3.09a.6994.6994 0 0 0 -.4775-.8528zm-2.8438 2.5268c-.2539-.0391-.3018-.1333-.3252-.1787a2.7692 2.7692 0 0 1 .252-1.749l1.8018.5317c-.294.646-.8624 1.5332-1.7286 1.396z"})))};an.displayName="IconFootprint",an.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},an.defaultProps={title:"Footprint",color:null,size:null},an.__docgenInfo={description:"",methods:[],displayName:"IconFootprint",props:{title:{defaultValue:{value:"'Footprint'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var rn=an,ln=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.4419 5.4429a3.617 3.617 0 1 0 5.1152 0 3.6231 3.6231 0 0 0 -5.1152 0zm4.125 4.125a2.2166 2.2166 0 1 1 0-3.1348 2.2174 2.2174 0 0 1 0 3.1348z"}),u.a.createElement("path",{d:"m15.3511 6.3462-.875-.1934a6.6869 6.6869 0 0 0 -.59-1.4277l.4815-.7539a.7.7 0 0 0 -.0956-.8712l-1.372-1.372a.7006.7006 0 0 0 -.8711-.0947l-.7539.4795a6.7171 6.7171 0 0 0 -1.458-.5986l-.1593-.8428a.6993.6993 0 0 0 -.6877-.5714h-1.9412a.6992.6992 0 0 0 -.6875.5713l-.1592.8428a6.6222 6.6222 0 0 0 -1.4863.6133l-.7058-.4824a.6979.6979 0 0 0 -.89.083l-1.3729 1.372a.7.7 0 0 0 -.083.89l.4824.707a6.6218 6.6218 0 0 0 -.6133 1.4863l-.8432.159a.6993.6993 0 0 0 -.57.6877v1.9412a.6993.6993 0 0 0 .57.6875l.8428.1592a6.6222 6.6222 0 0 0 .6133 1.4863l-.4824.706a.7.7 0 0 0 .083.89l1.3733 1.3727a.7016.7016 0 0 0 .89.083l.706-.4824a6.6818 6.6818 0 0 0 1.456.6025l.1934.875a.7009.7009 0 0 0 .6836.5488h1.941a.7009.7009 0 0 0 .6836-.5488l.1934-.875a6.6713 6.6713 0 0 0 1.4277-.5889l.7529.48a.7013.7013 0 0 0 .8721-.0947l1.3723-1.3724a.7.7 0 0 0 .0957-.8711l-.48-.7539a6.6923 6.6923 0 0 0 .5889-1.4277l.874-.1924a.7.7 0 0 0 .55-.6836v-1.9413a.7009.7009 0 0 0 -.5495-.6838zm-.8511 2.0625-.7109.1563a.7.7 0 0 0 -.5723.5469 5.27 5.27 0 0 1 -.74 1.793.7035.7035 0 0 0 -.0879.5654.69.69 0 0 0 .0986.2119l.3975.625-.5781.5791-.707-.4482a.6922.6922 0 0 0 -.6953.0391 5.2924 5.2924 0 0 1 -1.793.74.7041.7041 0 0 0 -.541.5508l-.1629.732h-.8164l-.1572-.71a.7.7 0 0 0 -.5459-.5723 5.29 5.29 0 0 1 -1.8282-.7612.7007.7007 0 0 0 -.78.0059l-.6006.41-.5518-.5518.41-.6006a.7005.7005 0 0 0 .0059-.7812 5.277 5.277 0 0 1 -.7705-1.8651.6972.6972 0 0 0 -.5557-.5479l-.7168-.1358v-.7792l.7168-.1357a.6972.6972 0 0 0 .5557-.5479 5.277 5.277 0 0 1 .7705-1.8652.7005.7005 0 0 0 -.0059-.7812l-.41-.6006.5518-.5518.6006.41a.7023.7023 0 0 0 .7813.0059 5.277 5.277 0 0 1 1.8652-.7705.6971.6971 0 0 0 .5479-.5566l.1356-.7172h.7793l.1357.7168a.6971.6971 0 0 0 .5478.5566 5.2681 5.2681 0 0 1 1.831.75.7049.7049 0 0 0 .77-.0049l.6338-.4033.5772.5772-.3945.62a.7.7 0 0 0 -.0137.7832 5.289 5.289 0 0 1 .74 1.792.7015.7015 0 0 0 .5723.5469l.7109.1572z"})))};ln.displayName="IconGear",ln.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ln.defaultProps={title:"Gear",color:null,size:null},ln.__docgenInfo={description:"",methods:[],displayName:"IconGear",props:{title:{defaultValue:{value:"'Gear'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var on=ln,un=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1626a7.8374 7.8374 0 1 0 7.8374 7.8374 7.847 7.847 0 0 0 -7.8374-7.8374zm5.7029 4.8638h-2.7229a10.76 10.76 0 0 0 -1.465-3.2764 6.4548 6.4548 0 0 1 4.1884 3.2764zm.7341 2.9736a6.4073 6.4073 0 0 1 -.247 1.7466h-3.1179a10.8857 10.8857 0 0 0 .1641-3.32h2.9984a6.4075 6.4075 0 0 1 .2024 1.5734zm-8.367 1.7466a9.2635 9.2635 0 0 1 .03-3.32h3.7392a9.46 9.46 0 0 1 -.1564 3.32zm3.2011 1.4a12.8 12.8 0 0 1 -1.3688 2.6967 10.0518 10.0518 0 0 1 -1.46-2.6967zm-7.7081-3.1466a6.407 6.407 0 0 1 .2026-1.5732h2.95a10.7047 10.7047 0 0 0 -.0457 3.32h-2.8599a6.407 6.407 0 0 1 -.247-1.7468zm4.8963-2.9736a12.7285 12.7285 0 0 1 1.4935-3.06 9.907 9.907 0 0 1 1.58 3.06zm-.0082-3.267a14.544 14.544 0 0 0 -1.4149 3.267h-2.74a6.455 6.455 0 0 1 4.1549-3.267zm-4.0606 9.3876h2.5867a10.9571 10.9571 0 0 0 1.4957 3.0992 6.4546 6.4546 0 0 1 -4.0824-3.0992zm6.8552 3.1667a14.6892 14.6892 0 0 0 1.4648-3.1667h2.8995a6.4525 6.4525 0 0 1 -4.3643 3.1667z"})))};un.displayName="IconGlobe",un.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},un.defaultProps={title:"Globe",color:null,size:null},un.__docgenInfo={description:"",methods:[],displayName:"IconGlobe",props:{title:{defaultValue:{value:"'Globe'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var sn=un,cn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.0078 6.1713h1.8522v5.49h-.3922a.7.7 0 0 0 0 1.4h11.0644a.7.7 0 0 0 0-1.4h-.3922v-5.49h1.8525a.7.7 0 0 0 .3506-1.3057l-6.9925-4.0522a.6977.6977 0 0 0 -.7012 0l-6.9922 4.0522a.7.7 0 0 0 .3506 1.3057zm3.2529 0h1.5593v5.49h-1.56zm4.52 0v5.49h-1.56v-5.49zm2.959 5.49h-1.559v-5.49h1.5586zm-3.7397-9.4334 4.3887 2.543h-8.7774z"}),u.a.createElement("path",{d:"m15.083 13.8807h-14.166a.7.7 0 0 0 0 1.4h14.166a.7.7 0 1 0 0-1.4z"})))};cn.displayName="IconGovBuilding",cn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},cn.defaultProps={title:"GovBuilding",color:null,size:null},cn.__docgenInfo={description:"",methods:[],displayName:"IconGovBuilding",props:{title:{defaultValue:{value:"'GovBuilding'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dn=cn,pn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5341 5.5032-7.1768-3.25a.75.75 0 0 0 -.5967-.01l-7.2724 3.0105a.75.75 0 0 0 -.4629.6929c0 .3547.0131.4552 3.0049 1.835v3.8491a.7478.7478 0 0 0 .1475.4458c.78 1.0552 2.6934 1.7368 4.874 1.7368a6.56 6.56 0 0 0 4.7266-1.5561.75.75 0 0 0 .1914-.5v-3.8261l.78-.3229v2.3486a.75.75 0 1 0 1.5 0v-2.9693l.2617-.1083a.75.75 0 0 0 .0225-1.376zm-4.0644 5.93a5.8766 5.8766 0 0 1 -3.418.88 5.5877 5.5877 0 0 1 -3.5217-.9663v-2.8789c.8657.394 1.88.8534 3.1123 1.4112a.75.75 0 0 0 .5967.01l3.23-1.337zm-3.5039-3.0545c-.8858-.4009-3.5625-1.6128-5.3037-2.4009l5.372-2.2237 5.3037 2.4014z"})))};pn.displayName="IconGraduationHat",pn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},pn.defaultProps={title:"GraduationHat",color:null,size:null},pn.__docgenInfo={description:"",methods:[],displayName:"IconGraduationHat",props:{title:{defaultValue:{value:"'GraduationHat'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var mn=pn,fn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.146.1533h-14.292a.7.7 0 0 0 -.7.7v14.293a.7.7 0 0 0 .7.7h14.292a.7.7 0 0 0 .7-.7v-14.2928a.7.7 0 0 0 -.7-.7002zm-13.5918 6.1651h3.3638v3.3632h-3.3638zm4.7642 0h3.3632v3.3632h-3.3632zm4.7637 0h3.3638v3.3632h-3.3639zm3.3638-1.4h-3.3639v-3.3647h3.3638zm-4.7642 0h-3.3633v-3.3647h3.3632zm-8.1275-3.3647h3.3638v3.3643h-3.3638zm0 9.5283h3.3638v3.3643h-3.3638zm4.7642 0h3.3632v3.3643h-3.3632zm8.1274 3.3643h-3.3638v-3.3643h3.3638z"})))};fn.displayName="IconGrid",fn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},fn.defaultProps={title:"Grid",color:null,size:null},fn.__docgenInfo={description:"",methods:[],displayName:"IconGrid",props:{title:{defaultValue:{value:"'Grid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hn=fn,vn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m6.98 2.1757h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7257 4.505a.3624.3624 0 0 0 .6746 0l2.7259-4.505c.1856-.3065.0441-.5574-.3144-.5574z"}),u.a.createElement("path",{d:"m11.4315 7.2381a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3142-.5574h-5.4977c-.3584 0-.5.2508-.3143.5574z"}),u.a.createElement("path",{d:"m6.98 8.532h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1856-.3066.0441-.5574-.3144-.5574z"}),u.a.createElement("path",{d:"m14.5176 8.532h-5.4976c-.3584 0-.5.2508-.3143.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3143-.5574z"})))};vn.displayName="IconGridCarets",vn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},vn.defaultProps={title:"GridCarets",color:null,size:null},vn.__docgenInfo={description:"",methods:[],displayName:"IconGridCarets",props:{title:{defaultValue:{value:"'GridCarets'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var gn=vn,yn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m2.6357.1377a2.4981 2.4981 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 .1377a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 5.1338a2.498 2.498 0 1 0 -2.498-2.498 2.5015 2.5015 0 0 0 2.498 2.498zm0-3.5957a1.0977 1.0977 0 1 1 -1.0977 1.0977 1.0986 1.0986 0 0 1 1.0977-1.0977z"}),u.a.createElement("path",{d:"m2.6357 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 10.8662a2.498 2.498 0 1 0 2.498 2.498 2.5015 2.5015 0 0 0 -2.498-2.498zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m2.6357 5.5019a2.498 2.498 0 1 0 2.4981 2.4981 2.5015 2.5015 0 0 0 -2.4981-2.4981zm0 3.5957a1.0977 1.0977 0 1 1 1.0977-1.0976 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m8 5.5019a2.498 2.498 0 1 0 2.498 2.4981 2.5015 2.5015 0 0 0 -2.498-2.4981zm0 3.5958a1.0977 1.0977 0 1 1 1.0977-1.0977 1.0986 1.0986 0 0 1 -1.0977 1.0977z"}),u.a.createElement("path",{d:"m13.3643 5.5019a2.498 2.498 0 1 0 2.498 2.4981 2.5015 2.5015 0 0 0 -2.498-2.4981zm0 3.5957a1.0977 1.0977 0 1 1 1.0976-1.0976 1.0986 1.0986 0 0 1 -1.0976 1.0977z"})))};yn.displayName="IconGridCircles",yn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},yn.defaultProps={title:"GridCircles",color:null,size:null},yn.__docgenInfo={description:"",methods:[],displayName:"IconGridCircles",props:{title:{defaultValue:{value:"'GridCircles'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var bn=yn,En=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.873 8.83a.7482.7482 0 0 0 -.96.4522 3.074 3.074 0 0 1 -5.7754-.001.75.75 0 0 0 -1.41.51 4.5741 4.5741 0 0 0 8.5977-.001.7513.7513 0 0 0 -.4523-.9602z"}),u.a.createElement("path",{d:"m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8833 7.8833 0 0 0 -7.875-7.875zm0 14.25a6.375 6.375 0 1 1 6.375-6.375 6.3817 6.3817 0 0 1 -6.375 6.375z"}),u.a.createElement("circle",{cx:"4.6871",cy:"6.3912",r:"1.1271"}),u.a.createElement("circle",{cx:"11.4028",cy:"6.3912",r:"1.1271"})))};En.displayName="IconHappy",En.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},En.defaultProps={title:"Happy",color:null,size:null},En.__docgenInfo={description:"",methods:[],displayName:"IconHappy",props:{title:{defaultValue:{value:"'Happy'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wn=En,zn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8839 7.8839 0 0 0 -7.875-7.875zm-3.3129 5.2833a.9829.9829 0 1 1 -.983.9829.9829.9829 0 0 1 .983-.9829zm7.497 4.3317a4.4245 4.4245 0 0 1 -8.3159 0 .6.6 0 1 1 1.1289-.4072 3.2244 3.2244 0 0 0 6.0581 0 .6.6 0 1 1 1.1289.4072zm-.7812-2.3657a.9829.9829 0 1 1 .9829-.9829.9829.9829 0 0 1 -.983.9827z"})))};zn.displayName="IconHappyFilled",zn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},zn.defaultProps={title:"HappyFilled",color:null,size:null},zn.__docgenInfo={description:"",methods:[],displayName:"IconHappyFilled",props:{title:{defaultValue:{value:"'HappyFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var _n=zn,xn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.8716 9.9934a2.0425 2.0425 0 0 0 -1.4516 3.4808 2.0536 2.0536 0 0 1 -2.4937.8375 2.2821 2.2821 0 0 1 -1.6463-2.2241v-1.5143a5.295 5.295 0 0 0 4.6953-5.1351c.001-.0137.001-.0273.001-.041v-4.5893a.75.75 0 0 0 -.75-.75h-1.925a.75.75 0 1 0 0 1.5h1.1748v3.7714a3.809 3.809 0 0 1 -3.8047 3.8047h-.2832a3.809 3.809 0 0 1 -3.8047-3.8047v-3.7714h1.1865a.75.75 0 1 0 0-1.5h-1.9365a.75.75 0 0 0 -.75.75v4.5893c0 .0137 0 .0273.001.041a5.295 5.295 0 0 0 4.6955 5.1351v1.4938a3.796 3.796 0 0 0 2.7129 3.6807 4.3132 4.3132 0 0 0 1.2461.1943 3.5329 3.5329 0 0 0 3.073-1.8659c.02.0006.0393.006.06.006a2.0444 2.0444 0 1 0 0-4.0889zm0 2.6885a.644.644 0 1 1 .6445-.644.6445.6445 0 0 1 -.6445.644z"})))};xn.displayName="IconHealth",xn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},xn.defaultProps={title:"Health",color:null,size:null},xn.__docgenInfo={description:"",methods:[],displayName:"IconHealth",props:{title:{defaultValue:{value:"'Health'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Cn=xn,Nn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.72 2.4795a4.1282 4.1282 0 0 0 -5.84 0l-.8811.8805-.8809-.8805a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1914a.7509.7509 0 0 0 1.0615 0l6.1905-6.1916a4.1282 4.1282 0 0 0 0-5.84zm-1.0609 4.7793-5.6602 5.6612-5.66-5.6611a2.63 2.63 0 1 1 3.7186-3.7189l1.4111 1.4112a.75.75 0 0 0 1.0606 0l1.4108-1.4112a2.6912 2.6912 0 0 1 3.7188 0 2.6287 2.6287 0 0 1 0 3.7187z"})))};Nn.displayName="IconHeart",Nn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Nn.defaultProps={title:"Heart",color:null,size:null},Nn.__docgenInfo={description:"",methods:[],displayName:"IconHeart",props:{title:{defaultValue:{value:"'Heart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qn=Nn,In=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.7192 2.48a4.1282 4.1282 0 0 0 -5.84 0l-.8809.88-.8809-.88a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1909a.7509.7509 0 0 0 1.0615 0l6.1903-6.1909a4.1282 4.1282 0 0 0 0-5.84z"})))};In.displayName="IconHeartFilled",In.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},In.defaultProps={title:"HeartFilled",color:null,size:null},In.__docgenInfo={description:"",methods:[],displayName:"IconHeartFilled",props:{title:{defaultValue:{value:"'HeartFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var kn=In,Vn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.9813 8.3425a.7008.7008 0 0 0 .9907 0l3.644-3.6445a2.69 2.69 0 1 0 -3.8042-3.8037l-.3354.3357-.3355-.3357a2.69 2.69 0 0 0 -3.8037 3.8037zm-2.6539-6.458a1.292 1.292 0 0 1 1.8237 0l.83.8306a.7.7 0 0 0 .99 0l.83-.8306a1.29 1.29 0 1 1 1.8242 1.8232l-3.1494 3.15-3.1489-3.15a1.29 1.29 0 0 1 .0004-1.8232z"}),u.a.createElement("path",{d:"m15.7479 10.5974a1.799 1.799 0 0 0 -2.2363-.977.7071.7071 0 0 0 -.1069.0405l-2.2222 1.0649a1.7737 1.7737 0 0 0 -1.2838-1.3681.7072.7072 0 0 0 -.1753-.0225h-1.7485a4.3161 4.3161 0 0 0 -2.9014-1.5781h-4.2729a.7.7 0 0 0 -.7.7v5.2529a.7.7 0 0 0 .7.7h2.1959l2.7758 1.041a4.4955 4.4955 0 0 0 1.9751.4409 4.968 4.968 0 0 0 2.07-.4609l5.272-2.7666a1.5438 1.5438 0 0 0 .6585-2.067zm-14.2471-1.4399h.9228v3.8525h-.9228zm12.9678 2.2525-5.2657 2.7641a3.2594 3.2594 0 0 1 -2.7964.0293.6873.6873 0 0 0 -.1016-.0474l-2.481-.93v-4.0707l1.16-.0037c.4053.0518 1.625.3706 1.9053 1.127a.7.7 0 0 0 .6563.457h2.061a.3085.3085 0 0 1 .2041.2671.6649.6649 0 0 1 -.1123.42h-3.2747a.7.7 0 1 0 0 1.4h3.375a1.2212 1.2212 0 0 0 .773-.3063.6881.6881 0 0 0 .2421-.0613l3.13-1.5c.127-.0254.416-.0581.5044.1616.0292.0733.0893.2488.0205.2933z"})))};Vn.displayName="IconHeartHand",Vn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Vn.defaultProps={title:"HeartHand",color:null,size:null},Vn.__docgenInfo={description:"",methods:[],displayName:"IconHeartHand",props:{title:{defaultValue:{value:"'HeartHand'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var On=Vn,Tn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.9591 7.9591 0 0 0 -7.95-7.95zm.75 12.5654a.75.75 0 0 1 -1.5 0v-.6a.75.75 0 0 1 1.5 0zm.7685-4.3047a1.5452 1.5452 0 0 0 -.7685 1.3321.75.75 0 1 1 -1.5 0 3.05 3.05 0 0 1 1.5171-2.63 1.5379 1.5379 0 1 0 -2.3049-1.3339.75.75 0 0 1 -1.5 0 3.0376 3.0376 0 1 1 4.5561 2.6319z"})))};Tn.displayName="IconHelp",Tn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Tn.defaultProps={title:"Help",color:null,size:null},Tn.__docgenInfo={description:"",methods:[],displayName:"IconHelp",props:{title:{defaultValue:{value:"'Help'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pn=Tn,Sn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7173 7.4534-7.2227-6.3179a.7515.7515 0 0 0 -.9883 0l-3.8154 3.337v-2.0225h1.0117a.75.75 0 0 0 0-1.5h-1.7617a.75.75 0 0 0 -.75.75v4.0844l-1.9082 1.669a.75.75 0 0 0 .9883 1.1289l.92-.8046v6.5223a.75.75 0 0 0 .75.75h10.1181a.75.75 0 0 0 .75-.75v-6.5224l.92.8047a.75.75 0 0 0 .9883-1.1289zm-6.7803 6.0966h-1.873v-4.7822h1.873zm3.3721 0h-1.8721v-5.5322a.75.75 0 0 0 -.75-.75h-3.373a.75.75 0 0 0 -.75.75v5.5322h-1.8731v-7.0842l4.3091-3.7693 4.3086 3.7689z"})))};Sn.displayName="IconHouse",Sn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Sn.defaultProps={title:"House",color:null,size:null},Sn.__docgenInfo={description:"",methods:[],displayName:"IconHouse",props:{title:{defaultValue:{value:"'House'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var jn=Sn,Fn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1553 1.145h-14.3106a.75.75 0 0 0 -.75.75v12.21a.75.75 0 0 0 .75.75h14.3106a.75.75 0 0 0 .75-.75v-12.21a.75.75 0 0 0 -.75-.75zm-.75 1.5v6.9432l-2.1084-1.8982a.77.77 0 0 0 -.544-.1914.7531.7531 0 0 0 -.52.2515l-2.0288 2.2909-3.3135-3.314a.7517.7517 0 0 0 -1.0117-.0454l-3.2842 2.7452v-6.7818zm-12.8106 10.71v-1.972l3.7207-3.11 3.3916 3.392a.71.71 0 0 0 .5527.2192.7493.7493 0 0 0 .5391-.252l2.0567-2.3212 2.55 2.2961v1.7479z"}),u.a.createElement("path",{d:"m8.99 7.9575a2.35 2.35 0 1 0 -2.35-2.3501 2.3523 2.3523 0 0 0 2.35 2.3501zm0-3.3a.95.95 0 1 1 -.95.95.95.95 0 0 1 .95-.9498z"})))};Fn.displayName="IconImage",Fn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Fn.defaultProps={title:"Image",color:null,size:null},Fn.__docgenInfo={description:"",methods:[],displayName:"IconImage",props:{title:{defaultValue:{value:"'Image'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Bn=Fn,Mn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8957 7.3561a.7411.7411 0 0 0 -.0678-.2561.706.706 0 0 0 -.0413-.1035l-3.2295-4.9413a.751.751 0 0 0 -.6279-.34h-8.1064a.7494.7494 0 0 0 -.6426.3638l-2.9802 4.9576c-.0089.0148-.009.0317-.0167.0468a.7269.7269 0 0 0 -.0544.1525.73.73 0 0 0 -.0264.1307c-.002.0204-.0125.0379-.0125.0587v4.6856a2.2378 2.2378 0 0 0 2.292 2.1738h11.2357a2.2378 2.2378 0 0 0 2.292-2.1738v-4.6856a.6916.6916 0 0 0 -.014-.0692zm-11.6491-4.1408h7.2764l2.2618 3.46h-2.88a.7567.7567 0 0 0 -.7129.5171 2.5184 2.5184 0 0 1 -2.3232 1.6919 2.2048 2.2048 0 0 1 -2.333-1.6113.75.75 0 0 0 -.7344-.5976h-2.6348zm10.1634 8.8955a.75.75 0 0 1 -.792.6738h-11.2357a.75.75 0 0 1 -.792-.6738v-3.9355h2.6739a3.7578 3.7578 0 0 0 3.6045 2.209 3.9485 3.9485 0 0 0 3.53-2.209h3.0113z"})))};Mn.displayName="IconInbox",Mn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Mn.defaultProps={title:"Inbox",color:null,size:null},Mn.__docgenInfo={description:"",methods:[],displayName:"IconInbox",props:{title:{defaultValue:{value:"'Inbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rn=Mn,Ln=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.959 7.959 0 0 0 -7.95-7.95zm-.707 3.1956a.75.75 0 1 1 1.5 0v1.0264a.75.75 0 0 1 -1.5 0zm2.8428 8.7266-1.5626 1.5615a.751.751 0 0 1 -1.28-.53v-4.2464l-.2812.2813a.75.75 0 0 1 -1.0608-1.0606l1.5615-1.5615a.7511.7511 0 0 1 1.28.53v4.2469l.2822-.282a.75.75 0 1 1 1.0605 1.0605z"})))};Ln.displayName="IconInfo",Ln.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ln.defaultProps={title:"Info",color:null,size:null},Ln.__docgenInfo={description:"",methods:[],displayName:"IconInfo",props:{title:{defaultValue:{value:"'Info'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var An=Ln,Dn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m3.5095 3.5115a1.9416 1.9416 0 0 0 2.7461 2.7456 1.9451 1.9451 0 0 0 0-2.7451 1.99 1.99 0 0 0 -2.7461-.0005zm1.7558 1.7553a.5533.5533 0 0 1 -.7656 0 .5414.5414 0 1 1 .7656 0z"}),u.a.createElement("path",{d:"m15.6481 13.0544a.7523.7523 0 0 0 -.2139-.4346l-4.8166-4.8166a5.5361 5.5361 0 1 0 -2.8157 2.8168l4.816 4.816a.7474.7474 0 0 0 .4346.2134l2.0156.26a.701.701 0 0 0 .0957.0063.7505.7505 0 0 0 .7441-.8457zm-12.8916-4.6298a4.0066 4.0066 0 1 1 5.666 0 4.0127 4.0127 0 0 1 -5.666 0zm10.7412 5.77-4.3971-4.3972c.1268-.1058.2635-.1933.3825-.3123s.2067-.2559.3125-.3828l4.3975 4.3977.1025.7974z"})))};Dn.displayName="IconKey",Dn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Dn.defaultProps={title:"Key",color:null,size:null},Dn.__docgenInfo={description:"",methods:[],displayName:"IconKey",props:{title:{defaultValue:{value:"'Key'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Un=Dn,Hn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1594 2.5762h-14.3188a.7.7 0 0 0 -.7.7v9.4473a.7.7 0 0 0 .7.7h14.3188a.7.7 0 0 0 .7-.7v-9.4471a.7.7 0 0 0 -.7-.7002zm-.7 9.4473h-12.9186v-8.0469h12.9184z"}),u.a.createElement("circle",{cx:"3.7196",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"6.5092",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"9.2988",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"12.0884",cy:"5.8834",r:".7916"}),u.a.createElement("circle",{cx:"5.175",cy:"8.1272",r:".7916"}),u.a.createElement("circle",{cx:"7.9646",cy:"8.1272",r:".7916"}),u.a.createElement("circle",{cx:"10.7543",cy:"8.1272",r:".7916"}),u.a.createElement("path",{d:"m11.44 9.7661h-7.033a.625.625 0 0 0 0 1.25h7.033a.625.625 0 0 0 0-1.25z"})))};Hn.displayName="IconKeyboard",Hn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Hn.defaultProps={title:"Keyboard",color:null,size:null},Hn.__docgenInfo={description:"",methods:[],displayName:"IconKeyboard",props:{title:{defaultValue:{value:"'Keyboard'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wn=Hn,Gn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.9178.274h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m.9178 6.0685h2.5754a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m.9178 11.863h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"}),u.a.createElement("path",{d:"m6.7123.274h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m6.7123 6.0685h2.5754a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m6.7123 11.863h2.5754a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5754a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"}),u.a.createElement("path",{d:"m12.5069.274h2.5753a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5753a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m12.5069 6.0685h2.5753a.6438.6438 0 0 1 .6438.6438v2.5754a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5754a.6438.6438 0 0 1 .6438-.6438z"}),u.a.createElement("path",{d:"m12.5069 11.863h2.5753a.6438.6438 0 0 1 .6438.6438v2.5753a.6438.6438 0 0 1 -.6438.6438h-2.5753a.6438.6438 0 0 1 -.6438-.6438v-2.5752a.6438.6438 0 0 1 .6438-.6439z"})))};Gn.displayName="IconLaunchpad",Gn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Gn.defaultProps={title:"Launchpad",color:null,size:null},Gn.__docgenInfo={description:"",methods:[],displayName:"IconLaunchpad",props:{title:{defaultValue:{value:"'Launchpad'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kn=Gn,$n=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.6086 7.25h-5.4067l5.937-5.9365a.75.75 0 0 0 -1.0605-1.0606l-7.2173 7.2171a.75.75 0 0 0 .53 1.28h5.407l-5.937 5.9365a.75.75 0 1 0 1.0605 1.0605l7.2173-7.217a.75.75 0 0 0 -.53-1.28z"})))};$n.displayName="IconLighting",$n.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},$n.defaultProps={title:"Lighting",color:null,size:null},$n.__docgenInfo={description:"",methods:[],displayName:"IconLighting",props:{title:{defaultValue:{value:"'Lighting'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Qn=$n,Yn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.25 11.0693-2.6753 2.6758a2.4111 2.4111 0 0 1 -3.3193 0 2.35 2.35 0 0 1 0-3.3193l2.6757-2.6758a2.3509 2.3509 0 0 1 3.3193 0 .75.75 0 0 0 1.0606-1.0605 3.8512 3.8512 0 0 0 -5.44 0l-2.6762 2.6757a3.847 3.847 0 0 0 5.44 5.44l2.6762-2.6752a.75.75 0 1 0 -1.061-1.0607z"}),u.a.createElement("path",{d:"m14.8052 1.1963a3.8512 3.8512 0 0 0 -5.44 0l-2.6772 2.6758a.75.75 0 0 0 1.0605 1.0605l2.6768-2.6758a2.3471 2.3471 0 0 1 3.3193 3.3193l-2.6767 2.6759a2.3518 2.3518 0 0 1 -3.3193 0 .75.75 0 0 0 -1.0606 1.0605 3.8512 3.8512 0 0 0 5.44 0l2.6768-2.6758a3.853 3.853 0 0 0 .0004-5.4404z"})))};Yn.displayName="IconLink",Yn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Yn.defaultProps={title:"Link",color:null,size:null},Yn.__docgenInfo={description:"",methods:[],displayName:"IconLink",props:{title:{defaultValue:{value:"'Link'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xn=Yn,Jn=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.7891 2.4619h14.4218a.75.75 0 0 0 0-1.5h-14.4218a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m15.2109 5.1543h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.2109 9.3457h-14.4218a.75.75 0 1 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.2109 13.5381h-14.4218a.75.75 0 0 0 0 1.5h14.4218a.75.75 0 0 0 0-1.5z"})))};Jn.displayName="IconList",Jn.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Jn.defaultProps={title:"List",color:null,size:null},Jn.__docgenInfo={description:"",methods:[],displayName:"IconList",props:{title:{defaultValue:{value:"'List'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Zn=Jn,ea=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.56 3.3535 9.6226-.0029a.75.75 0 0 0 0-1.5l-9.6226.0029a.75.75 0 1 0 0 1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"2.5735",r:"1.2876"}),u.a.createElement("path",{d:"m15.1821 7.2774-9.6221.0019a.75.75 0 0 0 0 1.5l9.6226-.002a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"8",r:"1.2877"}),u.a.createElement("path",{d:"m15.1821 12.7031-9.6221.003a.75.75 0 0 0 0 1.5l9.6226-.0029a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"1.3556",cy:"13.4265",r:"1.2877"})))};ea.displayName="IconListBulleted",ea.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ea.defaultProps={title:"ListBulleted",color:null,size:null},ea.__docgenInfo={description:"",methods:[],displayName:"IconListBulleted",props:{title:{defaultValue:{value:"'ListBulleted'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ta=ea,na=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1895 12.627h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 0 0 0-1.5z"}),u.a.createElement("circle",{cx:"3.0315",cy:"13.3504",r:"1.5143"}),u.a.createElement("path",{d:"m6.92 4.4707h8.269a.75.75 0 0 0 0-1.5h-8.269a.75.75 0 1 0 0 1.5z"}),u.a.createElement("path",{d:"m4.7222 1.355-2.1734 2.1733-1.208-1.2075a.75.75 0 1 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 0 0 -1.0605-1.0606z"}),u.a.createElement("path",{d:"m15.1895 7.8115h-8.2695a.75.75 0 1 0 0 1.5h8.269a.75.75 0 1 0 0-1.5z"}),u.a.createElement("path",{d:"m4.7222 6.1958-2.1734 2.1734-1.208-1.2076a.75.75 0 0 0 -1.0608 1.0606l1.7386 1.7378a.75.75 0 0 0 1.0605 0l2.7036-2.7036a.75.75 0 1 0 -1.0605-1.0606z"})))};na.displayName="IconListChecks",na.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},na.defaultProps={title:"ListChecks",color:null,size:null},na.__docgenInfo={description:"",methods:[],displayName:"IconListChecks",props:{title:{defaultValue:{value:"'ListChecks'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var aa=na,ra=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.7268 6.3958h-2.083v-2.75a3.6527 3.6527 0 0 0 -7.2876.0068v2.7432h-2.083a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4536a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75zm-7.8706-2.7437a2.16 2.16 0 0 1 4.2876-.0068v2.75h-4.2876zm7.1206 10.5972h-9.9536v-6.3535h9.9536z"}),u.a.createElement("path",{d:"m8 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};ra.displayName="IconLock",ra.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ra.defaultProps={title:"Lock",color:null,size:null},ra.__docgenInfo={description:"",methods:[],displayName:"IconLock",props:{title:{defaultValue:{value:"'Lock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var la=ra,oa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.258 9.786h-4.726l-4.887-8.466h4.726z"}),u.a.createElement("path",{d:"m4.038 14.68 2.35-4.129h9.163l-2.351 4.129z"}),u.a.createElement("path",{d:"m2.817 14.603-2.368-4.123 4.523-8.11 2.405 4.235z"})))};oa.displayName="IconLogoDrive",oa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},oa.defaultProps={title:"LogoDrive",color:null,size:null},oa.__docgenInfo={description:"",methods:[],displayName:"IconLogoDrive",props:{title:{defaultValue:{value:"'LogoDrive'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ia=oa,ua=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.89 4.5583v-1.1128c0-.64.5731-.8688 1.2133-.8688a5.56 5.56 0 0 1 1.326.1982l.4118-2.4388a10.3689 10.3689 0 0 0 -2.9511-.2961 2.9276 2.9276 0 0 0 -2.5546 1.1985 4.2757 4.2757 0 0 0 -.53 2.4662v1.6h-1.6465v2.3813h1.6462v8.274h3.0849v-8.2741h2.4417l.1829-2.3808h-2.6246z"})))};ua.displayName="IconLogoFacebook",ua.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ua.defaultProps={title:"LogoFacebook",color:null,size:null},ua.__docgenInfo={description:"",methods:[],displayName:"IconLogoFacebook",props:{title:{defaultValue:{value:"'LogoFacebook'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var sa=ua,ca=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.398 1.6h-12.796a1.6042 1.6042 0 0 0 -1.602 1.6015v9.597a1.6068 1.6068 0 0 0 1.602 1.6015h12.796a1.6068 1.6068 0 0 0 1.602-1.6015v-9.597a1.6043 1.6043 0 0 0 -1.602-1.6015zm0 11.199h-1.597v-7.039l-4.801 3.0385-4.801-3.0385v7.039h-1.597v-9.5975h.957l5.441 3.359 5.441-3.359h.957z"})))};ca.displayName="IconLogoGmail",ca.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ca.defaultProps={title:"LogoGmail",color:null,size:null},ca.__docgenInfo={description:"",methods:[],displayName:"IconLogoGmail",props:{title:{defaultValue:{value:"'LogoGmail'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var da=ca,pa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.092 8.7862a1.9006 1.9006 0 0 0 -.4508.0561 5.81 5.81 0 0 0 -4.6-4.2858c-.1-.0181-.1908-.0314-.2928-.0443a1.9049 1.9049 0 0 1 .85-1.7536l-.1284-.3219s-1.573.4888-1.7553 1.8349c-.0784-.3663-.812-.8245-1.1752-.9114l-.1806.2913a1.266 1.266 0 0 1 .5987.9052 5.81 5.81 0 0 0 -4.5988 4.2856 1.8847 1.8847 0 1 0 .2376 3.5819 5.7775 5.7775 0 0 0 .6123 1.139l1.564-1.0544-.0133-.0174a3.853 3.853 0 0 1 -.7094-2.0933 2.787 2.787 0 0 1 .7113-2.2146 2.0953 2.0953 0 0 1 3.1347.3991h.2074a2.0953 2.0953 0 0 1 3.1347-.3991 2.787 2.787 0 0 1 .7113 2.2146 3.853 3.853 0 0 1 -.7091 2.0933l-.0133.0174 1.564 1.0544a5.7786 5.7786 0 0 0 .6123-1.139 1.8842 1.8842 0 1 0 .6884-3.6381zm-12.22 2.44a.556.556 0 0 1 0-1.1121.5608.5608 0 0 1 .3116.0961 8.4468 8.4468 0 0 0 .0593.8735.5563.5563 0 0 1 -.3711.1424zm12.2565 0a.5563.5563 0 0 1 -.3709-.1425 8.4467 8.4467 0 0 0 .0592-.8735.5551.5551 0 0 1 .8673.4611.5547.5547 0 0 1 -.5559.5548z"})))};pa.displayName="IconLogoGoldie",pa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},pa.defaultProps={title:"LogoGoldie",color:null,size:null},pa.__docgenInfo={description:"",methods:[],displayName:"IconLogoGoldie",props:{title:{defaultValue:{value:"'LogoGoldie'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ma=pa,fa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.06 7.34h-6.8181v2.0054h4.8523c-.2368 2.8126-2.5768 4.0121-4.7856 4.0121a5.2707 5.2707 0 0 1 -5.2919-5.34 5.28 5.28 0 0 1 5.2982-5.374 5.2027 5.2027 0 0 1 3.6139 1.45l1.4044-1.4543a7.14 7.14 0 0 0 -5.0902-2.007 7.49 7.49 0 0 0 -7.425 7.35 7.4656 7.4656 0 0 0 7.532 7.3856 6.4875 6.4875 0 0 0 6.832-6.6983 6.0112 6.0112 0 0 0 -.122-1.3295z"}),u.a.createElement("path",{d:"m15.06 7.339v.001z"})))};fa.displayName="IconLogoGoogle",fa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},fa.defaultProps={title:"LogoGoogle",color:null,size:null},fa.__docgenInfo={description:"",methods:[],displayName:"IconLogoGoogle",props:{title:{defaultValue:{value:"'LogoGoogle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ha=fa,va=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.1407 7.2852v1.7155h2.8379a2.7022 2.7022 0 0 1 -2.8379 2.1593 3.16 3.16 0 0 1 0-6.319 2.8159 2.8159 0 0 1 1.9943.772l1.3582-1.3086a4.7965 4.7965 0 0 0 -3.3525-1.3081 5.0037 5.0037 0 1 0 0 10.0075 4.6155 4.6155 0 0 0 4.8036-4.8894 4.6022 4.6022 0 0 0 -.0786-.8292z"}),u.a.createElement("path",{d:"m15.863 7.285h-1.43v-1.429h-1.429v1.429h-1.43v1.43h1.43v1.429h1.429v-1.429h1.43z"})))};va.displayName="IconLogoGooglePlus",va.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},va.defaultProps={title:"LogoGooglePlus",color:null,size:null},va.__docgenInfo={description:"",methods:[],displayName:"IconLogoGooglePlus",props:{title:{defaultValue:{value:"'LogoGooglePlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ga=va,ya=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.4777.3973h-12.9587a1.11 1.11 0 0 0 -1.1215 1.0964v13.0118a1.11 1.11 0 0 0 1.1215 1.0972h12.9587a1.1124 1.1124 0 0 0 1.1248-1.0972v-13.0118a1.1116 1.1116 0 0 0 -1.1248-1.0964zm-9.57 12.9565h-2.2577v-7.2561h2.2579zm-1.1277-8.2475a1.3078 1.3078 0 1 1 1.3069-1.308 1.3072 1.3072 0 0 1 -1.3069 1.308zm9.5747 8.2476h-2.2547v-3.5287c0-.8415-.0145-1.924-1.1719-1.924-1.1735 0-1.3525.9171-1.3525 1.8638v3.5889h-2.2529v-7.2562h2.1617v.9923h.0309a2.3689 2.3689 0 0 1 2.1337-1.1721c2.2835 0 2.7054 1.5024 2.7054 3.4567z"})))};ya.displayName="IconLogoLinkedIn",ya.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ya.defaultProps={title:"LogoLinkedIn",color:null,size:null},ya.__docgenInfo={description:"",methods:[],displayName:"IconLogoLinkedIn",props:{title:{defaultValue:{value:"'LogoLinkedIn'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ba=ya,Ea=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8486 7.9624a.4584.4584 0 0 0 -.3658-.1735h-.0028c-.201 0-.3877.1526-.5707.4664l-.0145.025-.0094-.0274c-.0462-.1345-.0874-.2466-.112-.3135-.0171-.0468-.0248-.0677-.0266-.0745a.0739.0739 0 0 0 -.0759-.0551.1356.1356 0 0 0 -.0718.0229.0839.0839 0 0 0 -.0409.0572l-.0012.0036c-.1831.5712-.3342.8487-.4621.8487a.057.057 0 0 1 -.044-.0182c-.0335-.0371-.0253-.1252-.0139-.2472a2.2622 2.2622 0 0 0 .0139-.2986.3017.3017 0 0 0 -.3027-.3325c-.2313 0-.3812.2463-.45.3931l-.0206.0439-.0046-.0483c-.0172-.1817-.0782-.3987-.2708-.4-.2246 0-.3957.2636-.5.4848l-.028.0593.0028-.0655c.0125-.295.0226-.4691.03-.5175a.125.125 0 0 0 -.0123-.1.1.1 0 0 0 -.0848-.0213c-.0719.0046-.1087.0483-.164.195-.0909.241-.3222.8014-.5069.8014a.1105.1105 0 0 1 -.0869-.0371c-.0774-.0889-.0465-.3288-.0036-.661l.0032-.0251c.02-.1573-.0143-.1908-.1-.2065a.1434.1434 0 0 0 -.026-.0026c-.0682 0-.1.0653-.1638.2468-.1133.3231-.2591.6628-.43.6628l-.0187-.0015c-.09-.0153-.0884-.1494-.0859-.3191a1.8166 1.8166 0 0 0 -.0113-.29c-.0254-.1686-.1248-.274-.2593-.275-.2685 0-.45.3438-.5337.5487l-.0191.0464-.0064-.05c-.0113-.0889-.0261-.23-.0326-.3963v-.0049l.0031-.0038a2.6277 2.6277 0 0 0 .7308-1.48c.0019-.25-.1133-.4-.3083-.4014-.1425 0-.4815.1187-.5993 1.2186-.0218.204-.0338.4131-.0356.6216v.004l-.0024.0034c-.23.3327-.72.905-1.2007.905-.434 0-.78-.3511-.78-.9708a1.2485 1.2485 0 0 1 1.0307-1.3404h.0036a.3706.3706 0 0 1 .2385.0776.2629.2629 0 0 1 .0939.2108.3839.3839 0 0 1 -.0743.2306c-.0093.0146-.0185.0292-.027.0447a.0589.0589 0 0 0 -.005.0576.09.09 0 0 0 .0776.0325.3637.3637 0 0 0 .2664-.3822.5147.5147 0 0 0 -.5621-.4883 1.4961 1.4961 0 0 0 -1.2833 1.5743 1.0567 1.0567 0 0 0 1.0167 1.1652 1.6058 1.6058 0 0 0 1.19-.7936l.0223-.03.0016.0375c.0077.1816.0209.3249.0305.4295.0062.0673.0107.1158.0106.1426a.1953.1953 0 0 0 .0294.1244.1215.1215 0 0 0 .1011.0373c.0817 0 .098-.0557.13-.1931l.0091-.0398c.04-.1665.1886-.71.4119-.71a.112.112 0 0 1 .0846.0323c.0493.0523.044.16.0377.2839a1.5841 1.5841 0 0 0 0 .2358c.021.2107.112.3138.2782.315.1707 0 .3487-.1837.4426-.3546l.0178-.0322.0068.0361c.0174.0914.095.3915.3378.3915.22 0 .4089-.2318.6159-.7087l.027-.0624-.0016.0679c-.0044.1808-.0142.4016-.0142.5722 0 .132.0132.1823.0742.1823l.0138.0007c.0586 0 .0983-.035.1181-.1041.1557-.5427.29-.7955.4236-.7955.1306.001.1429.24.1534.6616l.0007.03c.0032.1476.0084.2128.1.2136.07 0 .0869-.0546.1228-.1891.0068-.0257.0144-.0538.0231-.0842.1257-.4363.23-.6143.36-.6143.1111.0008.1173.1154.1193.1531a1.65 1.65 0 0 1 -.012.2465 1.6857 1.6857 0 0 0 -.0122.2269.2463.2463 0 0 0 .2631.2665c.2114 0 .4022-.2472.5693-.7347l.0117-.0339.0132.0334c.03.0765.07.18.1064.304l.0014.0047-.002.0045a2.9569 2.9569 0 0 0 -.2775.9732c-.0022.2817.1252.4647.3246.4662h.0035c.1085 0 .3613-.0435.3661-.4466a2.7759 2.7759 0 0 0 -.1159-.6942l-.009-.0338.0292.0194a.6021.6021 0 0 0 .3284.1034h.0054a.5339.5339 0 0 0 .56-.5507.651.651 0 0 0 -.1314-.4133zm-5.8826-.4024c.0045-.101.013-.1993.0251-.2923.0782-.5991.2415-1.0176.3972-1.0176h.0007c.0742.0006.1114.0567.1105.1668a2.3986 2.3986 0 0 1 -.5095 1.1512l-.0262.0386zm4.9649 2.1541a.1218.1218 0 0 1 -.1025.05.1329.1329 0 0 1 -.1122-.0516c-.071-.095-.051-.3181.0649-.7233.0138-.0483.0289-.097.0447-.1446l.0135-.04.0118.0409c.135.4669.1619.7593.0798.8686zm.6931-1.0641a.36.36 0 0 1 -.2275.0816.5569.5569 0 0 1 -.4237-.2159l-.0028-.0041-.0049-.0155.0023-.0047c.154-.3173.3305-.4993.4841-.4993h.0016c.1734.0014.2933.1574.2916.3793a.35.35 0 0 1 -.1207.2786z"}),u.a.createElement("path",{d:"m7.3411 8.5746-.0106.01a.4713.4713 0 0 1 -.2644.1542c-.1343.0066-.2336-.0737-.2978-.2394l-.0027-.007.0044-.0057a2.99 2.99 0 0 0 .6029-1.7143c-.0118-.2288-.0784-.5015-.3282-.5015h-.0187a.3691.3691 0 0 0 -.2587.1356 2.5312 2.5312 0 0 0 -.3091 1.6265 1.6361 1.6361 0 0 0 .0781.42l.0024.0071-.0049.0057a.5851.5851 0 0 1 -.3807.2484c-.2611 0-.2523-.4376-.2316-.8007.0045-.0782.0111-.1281-.0121-.1564a.104.104 0 0 0 -.0846-.0306h-.0048c-.0928 0-.1122.0191-.16.1569-.0988.2864-.294.767-.49.767a.15.15 0 0 1 -.1244-.0553c-.0952-.1216-.023-.4248.0352-.6685.01-.0438.0205-.0859.029-.1248a.15.15 0 0 0 -.0116-.1254.1313.1313 0 0 0 -.1153-.0314c-.0841.0067-.1379.0419-.1638.2018l-.0052.0333-.02-.0237a.2745.2745 0 0 0 -.2412-.1188l-.0356.0024a.6553.6553 0 0 0 -.4215.2579.8632.8632 0 0 0 -.1856.6137l.0044.0345.001.0062-.0043.0047a.3506.3506 0 0 1 -.25.1356c-.1287-.001-.2025-.0967-.2025-.2559 0-.2681.1816-1.0761.1816-1.3686 0-.3113-.1387-.4808-.38-.4827h-.0032c-.3517 0-.6259.3992-.8882 1.22-.024.0752-.05.1621-.0726.2372l-.0368.1235.0106-.1283c.0243-.2861.0411-.5644.05-.8273a1.1083 1.1083 0 0 0 -.164-.7805.3566.3566 0 0 0 -.2693-.1043h-.0031c-.43 0-.6367.7259-.7868 1.2382-.0344.1175-.0942.3466-.1471.5547.032-.3469.0908-.9671.0863-1.3306-.0054-.438-.1512-.6343-.4726-.6368h-.004a.4978.4978 0 0 0 -.3606.157.6256.6256 0 0 0 -.1777.4279c.0023.0881.0565.1666.0975.1666.0267 0 .0415-.0356.0479-.0569.0994-.3288.2281-.4887.3935-.4887a.2049.2049 0 0 1 .1577.0617c.129.1385.1056.5123.063 1.191-.0137.2188-.0293.4665-.0424.7485-.0023.0483-.0052.0952-.0081.14-.0126.1958-.0225.35.0518.362a.157.157 0 0 0 .1916-.12c.0477-.1419.1547-.53.3618-1.2383.1987-.68.3489-.9275.5409-.9275.2219 0 .2385.381.1978 1.1851-.0087.17-.02.3635-.0292.5736l-.004.0857c-.0085.1739-.0153.3113.0344.3639a.0847.0847 0 0 0 .0645.0247c.0962 0 .1251-.0843.173-.2241.0084-.0247.0175-.051.0275-.0787.33-.9093.5733-1.6981.9-1.6981.0981 0 .1744.08.1744.2352 0 .3588-.1754 1.0521-.1754 1.4035a.4846.4846 0 0 0 .1047.3184.367.367 0 0 0 .2844.1259h.0025a.5171.5171 0 0 0 .3391-.158l.0108-.01.0087.0117a.3716.3716 0 0 0 .3314.147.5606.5606 0 0 0 .4373-.3675l.0125-.0334.0124.0334a.3511.3511 0 0 0 .3671.2617c.2377-.0191.4263-.3424.4964-.48l.0181-.0356.0068.0394c.0336.1943.1393.5208.47.5232h.0027a.7113.7113 0 0 0 .4692-.2529l.012-.0121.0087.0147a.4748.4748 0 0 0 .4161.2746.3943.3943 0 0 0 .3854-.2908.0964.0964 0 0 0 -.0212-.075.0489.0489 0 0 0 -.0733-.0054zm-2.5731-.4751c-.0712.2864-.2076.6319-.4536.6517l-.02.0008c-.102 0-.1592-.0668-.17-.1986a.6838.6838 0 0 1 .1811-.4922.3565.3565 0 0 1 .25-.1324h.0017a.2456.2456 0 0 1 .2105.1622l.0018.0041zm1.9349.1343-.0049-.0376c-.0144-.11-.0215-.2237-.0265-.3209-.0354-.6851.1718-1.3675.3524-1.3769h.0035a.0747.0747 0 0 1 .0606.0346 1.4766 1.4766 0 0 1 -.0569.9608 3.2342 3.2342 0 0 1 -.3085.7076z"}),u.a.createElement("path",{d:"m5.9066 7.3713.0013.0132v-.0132a.1631.1631 0 1 0 -.0013 0z"}),u.a.createElement("path",{d:"m11.6161 7.3713.0013.0132v-.0132a.163.163 0 1 0 -.0013 0z"})))};Ea.displayName="IconLogoMailChimp",Ea.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ea.defaultProps={title:"LogoMailChimp",color:null,size:null},Ea.__docgenInfo={description:"",methods:[],displayName:"IconLogoMailChimp",props:{title:{defaultValue:{value:"'LogoMailChimp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wa=Ea,za=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .3147a7.3851 7.3851 0 0 0 -7.5824 7.1707 7.0108 7.0108 0 0 0 2.7448 5.5216v2.6783l2.5813-1.3521a7.9818 7.9818 0 0 0 2.2563.3228 7.3851 7.3851 0 0 0 7.5824-7.1707 7.3851 7.3851 0 0 0 -7.5824-7.1706zm.7891 9.6753-1.99-2.1272-3.8426 2.0585 4.1171-4.3913 1.99 1.99 3.8426-2.0586z"})))};za.displayName="IconLogoMessenger",za.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},za.defaultProps={title:"LogoMessenger",color:null,size:null},za.__docgenInfo={description:"",methods:[],displayName:"IconLogoMessenger",props:{title:{defaultValue:{value:"'LogoMessenger'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var _a=za,xa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.879.16-8.434 3.256v9.406l.004.001 3.018-1.259v-7.409l5.464-1.261v11.034l-8.472-1.101 8.42 3.013 4.676-1.509v-12.596z"})))};xa.displayName="IconLogoOffice",xa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},xa.defaultProps={title:"LogoOffice",color:null,size:null},xa.__docgenInfo={description:"",methods:[],displayName:"IconLogoOffice",props:{title:{defaultValue:{value:"'LogoOffice'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ca=xa,Na=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.9909 7.834a1.5044 1.5044 0 0 1 -2.075-.2048v4.0976h5.1559s.7546-.1049.6917-1.0947l.0037-5.3533z"}),u.a.createElement("path",{d:"m15.7254 3.9976a.571.571 0 0 0 -.6116-.6243h-5.1979v3.046l1.1108.7081z"}),u.a.createElement("ellipse",{cx:"4.7894",cy:"7.8613",rx:".998",ry:"1.6371"}),u.a.createElement("path",{d:"m.2328 14.0021 9.1172 1.7864v-15.577l-9.1172 1.5732zm4.581-8.8994c1.1464 0 2.0757 1.237 2.0757 2.763s-.9294 2.763-2.0757 2.763-2.0759-1.2369-2.0759-2.7629.9294-2.763 2.0758-2.763z"})))};Na.displayName="IconLogoOutlook",Na.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Na.defaultProps={title:"LogoOutlook",color:null,size:null},Na.__docgenInfo={description:"",methods:[],displayName:"IconLogoOutlook",props:{title:{defaultValue:{value:"'LogoOutlook'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qa=Na,Ia=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .16a7.84 7.84 0 0 0 -3.147 15.0206 6.8852 6.8852 0 0 1 .1365-1.8c.1507-.6365 1.0088-4.2719 1.0088-4.2719a3.0115 3.0115 0 0 1 -.25-1.24c0-1.1618.6734-2.0295 1.512-2.0295a1.05 1.05 0 0 1 1.0576 1.177 16.8753 16.8753 0 0 1 -.6929 2.7815 1.2134 1.2134 0 0 0 1.2374 1.51c1.4854 0 2.4858-1.9078 2.4858-4.1682a2.9349 2.9349 0 0 0 -3.2622-3.0044 3.7124 3.7124 0 0 0 -3.8597 3.7549 2.2633 2.2633 0 0 0 .5168 1.5377.38.38 0 0 1 .1127.437c-.0376.1443-.124.4915-.16.6292a.27.27 0 0 1 -.3925.1962 3.0194 3.0194 0 0 1 -1.6052-2.9957c0-2.227 1.8783-4.8975 5.6031-4.8975a4.6858 4.6858 0 0 1 4.9632 4.491c0 3.0754-1.71 5.3731-4.23 5.3731a2.2482 2.2482 0 0 1 -1.9153-.9772s-.4553 1.8062-.5517 2.1552a6.5628 6.5628 0 0 1 -.7891 1.6795 7.84 7.84 0 1 0 2.2217-15.3585z"})))};Ia.displayName="IconLogoPinterest",Ia.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ia.defaultProps={title:"LogoPinterest",color:null,size:null},Ia.__docgenInfo={description:"",methods:[],displayName:"IconLogoPinterest",props:{title:{defaultValue:{value:"'LogoPinterest'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ka=Ia,Va=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.6 3.2859a6.2331 6.2331 0 0 1 -1.791.491 3.1278 3.1278 0 0 0 1.371-1.7252 6.2435 6.2435 0 0 1 -1.98.7567 3.1214 3.1214 0 0 0 -5.314 2.8443 8.8531 8.8531 0 0 1 -6.4278-3.2583 3.1219 3.1219 0 0 0 .9651 4.1634 3.1063 3.1063 0 0 1 -1.4125-.39v.0393a3.12 3.12 0 0 0 2.5012 3.0577 3.1237 3.1237 0 0 1 -1.4083.0535 3.1214 3.1214 0 0 0 2.9131 2.1656 6.2564 6.2564 0 0 1 -3.8729 1.335 6.328 6.328 0 0 1 -.7439-.0437 8.8264 8.8264 0 0 0 4.78 1.4011 8.8122 8.8122 0 0 0 8.873-8.8727q0-.2028-.009-.4034a6.3362 6.3362 0 0 0 1.556-1.6143z"})))};Va.displayName="IconLogoTwitter",Va.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Va.defaultProps={title:"LogoTwitter",color:null,size:null},Va.__docgenInfo={description:"",methods:[],displayName:"IconLogoTwitter",props:{title:{defaultValue:{value:"'LogoTwitter'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Oa=Va,Ta=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.1135.16a7.6428 7.6428 0 0 0 -7.6428 7.6428 8.8145 8.8145 0 0 0 1.1093 3.9672l-1.3363 4.07 4.1878-1.3383a7.7472 7.7472 0 0 0 3.682.9438 7.6428 7.6428 0 1 0 0-15.2855zm0 14.0628a7.0167 7.0167 0 0 1 -3.5381-1.0621l-2.4139.7877.7833-2.3371a7.2986 7.2986 0 0 1 -1.2512-3.8085 6.42 6.42 0 1 1 6.42 6.42z"}),u.a.createElement("path",{d:"m11.87 9.419s-1.2522-.6065-1.51-.7242a.3.3 0 0 0 -.3883.0742s-.38.48-.5018.637-.1919.2967-.51.192a4.9275 4.9275 0 0 1 -1.4791-.9163 6.1161 6.1161 0 0 1 -1.0341-1.274.2356.2356 0 0 1 .0175-.3055s.3306-.3807.4887-.5847a.503.503 0 0 0 .0219-.5236c-.0378-.092-.5454-1.2847-.62-1.4529a.3423.3423 0 0 0 -.2356-.1964h-.6019a.8961.8961 0 0 0 -.3141.1309 2.1144 2.1144 0 0 0 -.7416 1.52 2.5162 2.5162 0 0 0 .29 1.3361 9.6893 9.6893 0 0 0 2.11 2.6 7.3472 7.3472 0 0 0 2.9535 1.442 2.2844 2.2844 0 0 0 1.876-.5889 1.3689 1.3689 0 0 0 .34-1.1692.2035.2035 0 0 0 -.1611-.1965z"})))};Ta.displayName="IconLogoWhatsApp",Ta.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ta.defaultProps={title:"LogoWhatsApp",color:null,size:null},Ta.__docgenInfo={description:"",methods:[],displayName:"IconLogoWhatsApp",props:{title:{defaultValue:{value:"'LogoWhatsApp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pa=Ta,Sa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.62 7.8574c.0776-.01.2133-.0291.2424-.0291a1.6112 1.6112 0 0 1 .2327.0291c-.4849-.97-.8632-1.9495-1.2415-2.9-.0679.01-.1454.029-.1745.029a.9247.9247 0 0 1 -.165-.0388c-.3976.97-.7661 1.94-1.2414 2.91a1.4689 1.4689 0 0 1 .2327-.0291 1.87 1.87 0 0 1 .2425.0291l.3491-.8535h1.1737c.1163.281.2327.572.3493.8533zm-1.4453-1.0574.5045-1.3288.5139 1.3288z"}),u.a.createElement("path",{d:"m2.5248 5.2677c.1358-.2424.2911-.4655.4365-.6984a1.431 1.431 0 0 1 -.2424.0292 1.3726 1.3726 0 0 1 -.2232-.0292l-.9893 1.61-.96-1.61a1.7778 1.7778 0 0 1 -.2521.0292 1.4577 1.4577 0 0 1 -.2327-.0292c.446.6887.8632 1.4355 1.2511 2.1339l-.0387 1.542a1.4744 1.4744 0 0 1 .2327-.029 1.4457 1.4457 0 0 1 .2424.029l-.0291-1.5614c.2617-.4753.5236-.9602.8048-1.4161z"}),u.a.createElement("path",{d:"m15.9386 4.8313a.2224.2224 0 0 0 -.2521-.223c-.32 0-.2038.3879-.2523.543-.01.0776-.01.1552-.0193.2231-.01.0776-.01.1553-.0194.2329l-.0291.3491c-.01.1067-.0194.223-.029.33-.0388.3784-.0873.7565-.1358 1.1446a.5488.5488 0 0 1 .1746.0291c.0968-.7472.5624-2.5124.5624-2.6288z"}),u.a.createElement("path",{d:"m5.7546 7.8574-.029-1.3481h1.62l-.0295 1.3481a1.4725 1.4725 0 0 1 .2329-.0291 1.3516 1.3516 0 0 1 .2328.0291v-2.9a1.4748 1.4748 0 0 1 -.2328.0291 1.8713 1.8713 0 0 1 -.2329-.0388.03.03 0 0 0 -.01.0194l.0389 1.3384h-1.62l.029-1.3578a1.7047 1.7047 0 0 1 -.2424.0388 1.866 1.866 0 0 1 -.2329-.0388v2.91a1.6112 1.6112 0 0 1 .2329-.0291 1.5585 1.5585 0 0 1 .243.0288z"}),u.a.createElement("path",{d:"m11.07 6.4122a1.4213 1.4213 0 0 0 -1.5715-1.4936 1.4206 1.4206 0 0 0 -1.5616 1.3772v.2329a2.0192 2.0192 0 0 0 .1163.5334 1.454 1.454 0 0 0 1.4453.8341 1.414 1.414 0 0 0 1.5715-1.484zm-1.5715 1.3191a1.1088 1.1088 0 0 1 -1.0766-1.2313v-.1751c.0388-.8049.4364-1.2221 1.0766-1.2221.8632 0 1.0862.6984 1.0862 1.3093 0 .6209-.2424 1.3192-1.0862 1.3192z"}),u.a.createElement("path",{d:"m15.182 7.7895a.2114.2114 0 0 0 -.223.2327c0 .1649.1164.223.2521.223a.207.207 0 0 0 .223-.2327.2265.2265 0 0 0 -.2521-.223z"}),u.a.createElement("path",{d:"m13.058 4.744a1.6328 1.6328 0 0 0 -1.804 1.4742v.3977a2.8436 2.8436 0 0 0 .1261.514 1.7024 1.7024 0 0 0 1.6779.9408 1.6087 1.6087 0 0 0 1.8137-1.6585 1.627 1.627 0 0 0 -1.8137-1.6682zm0 3.1521a1.2329 1.2329 0 0 1 -1.2415-.8729c0-.01-.0776-.3685-.0776-.4364v-.359a1.2332 1.2332 0 0 1 1.3191-1.3 1.2944 1.2944 0 0 1 1.3287 1.4742 1.3125 1.3125 0 0 1 -1.3287 1.4941z"}),u.a.createElement("path",{d:"m5.53 10.911h-.018l-.869-1.713h-.383v2.233h.166v-1.816h.025l.926 1.816h.077l.915-1.829h.013v1.829h.376v-2.233h-.376z"}),u.a.createElement("path",{d:"m8.1224 9.1475-1.0754 2.2832h.1876l.3524-.7451h.9568l.3414.7451h.3813l-1.0514-2.2832zm-.47 1.394.4165-.883.4055.883z"}),u.a.createElement("path",{d:"m9.5546 9.1985h.3751v2.2322h-.3751z"}),u.a.createElement("path",{d:"m10.866 9.198h-.376v2.233h1.499v-.144h-1.123z"})))};Sa.displayName="IconLogoYahooMail",Sa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Sa.defaultProps={title:"LogoYahooMail",color:null,size:null},Sa.__docgenInfo={description:"",methods:[],displayName:"IconLogoYahooMail",props:{title:{defaultValue:{value:"'LogoYahooMail'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ja=Sa,Fa=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.5361 4.1894a1.9764 1.9764 0 0 0 -1.3906-1.4 46.7 46.7 0 0 0 -6.1455-.3305 46.7 46.7 0 0 0 -6.1454.3311 1.9764 1.9764 0 0 0 -1.3906 1.4 20.7343 20.7343 0 0 0 -.3287 3.81 20.7338 20.7338 0 0 0 .3287 3.8105 1.9764 1.9764 0 0 0 1.3906 1.4 46.7 46.7 0 0 0 6.1454.3306 46.7 46.7 0 0 0 6.1455-.3309 1.9764 1.9764 0 0 0 1.3906-1.4 20.7338 20.7338 0 0 0 .3286-3.8102 20.7341 20.7341 0 0 0 -.3286-3.8106zm-9.0893 6.1377v-4.6542l4.0907 2.3271z"})))};Fa.displayName="IconLogoYouTube",Fa.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Fa.defaultProps={title:"LogoYouTube",color:null,size:null},Fa.__docgenInfo={description:"",methods:[],displayName:"IconLogoYouTube",props:{title:{defaultValue:{value:"'LogoYouTube'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ba=Fa,Ma=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0146 1.6543a.7.7 0 0 0 -.7.7v.7484l-10.9982 2.0173a.6936.6936 0 0 0 -.4283.2687l-1.685-.5513a.7.7 0 0 0 -.918.665v4.7251a.699.699 0 0 0 .918.665l1.6849-.5514a.6936.6936 0 0 0 .4283.2687l.9512.1744v1.8978a.7005.7005 0 0 0 .5762.689l5.3506.9634a.71.71 0 0 0 .124.0112.7.7 0 0 0 .7-.7v-1.623l3.2959.6045v.7484a.7.7 0 0 0 1.4 0v-11.021a.7.7 0 0 0 -.6996-.7002zm-5.3964 11.1538-3.95-.7114v-1.0318l3.95.7114zm-7.9326-6.34 1.0566.3457v2.1022l-1.0566.3457zm2.457 2.87v-2.946l10.1719-1.8662v6.6782z"})))};Ma.displayName="IconMegaphone",Ma.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ma.defaultProps={title:"Megaphone",color:null,size:null},Ma.__docgenInfo={description:"",methods:[],displayName:"IconMegaphone",props:{title:{defaultValue:{value:"'Megaphone'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ra=Ma,La=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m.8555 3.9287h14.289a.75.75 0 0 0 0-1.5h-14.289a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m15.1445 7.25h-14.289a.75.75 0 0 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z"}),u.a.createElement("path",{d:"m15.1445 12.0713h-14.289a.75.75 0 1 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z"})))};La.displayName="IconMenu",La.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},La.defaultProps={title:"Menu",color:null,size:null},La.__docgenInfo={description:"",methods:[],displayName:"IconMenu",props:{title:{defaultValue:{value:"'Menu'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Aa=La,Da=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2012 7.25h-14.4024a.75.75 0 0 0 0 1.5h14.4024a.75.75 0 0 0 0-1.5z"})))};Da.displayName="IconMinus",Da.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Da.defaultProps={title:"Minus",color:null,size:null},Da.__docgenInfo={description:"",methods:[],displayName:"IconMinus",props:{title:{defaultValue:{value:"'Minus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ua=Da,Ha=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.9794 7.9794 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4781 6.4781 0 0 1 -6.4707 6.47z"}),u.a.createElement("path",{d:"m11.3569 7.25h-6.7133a.75.75 0 0 0 0 1.5h6.7134a.75.75 0 1 0 0-1.5z"})))};Ha.displayName="IconMinusCircle",Ha.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ha.defaultProps={title:"MinusCircle",color:null,size:null},Ha.__docgenInfo={description:"",methods:[],displayName:"IconMinusCircle",props:{title:{defaultValue:{value:"'MinusCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wa=Ha,Ga=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.4248.0893h-6.85a1.7021 1.7021 0 0 0 -1.7 1.7v12.4207a1.7021 1.7021 0 0 0 1.7 1.7h6.85a1.7021 1.7021 0 0 0 1.7-1.7v-12.42a1.7021 1.7021 0 0 0 -1.7-1.7007zm-6.85 1.4h6.85a.3.3 0 0 1 .3.3v.9189h-7.4494v-.9182a.3.3 0 0 1 .2998-.3zm7.1494 2.6191v6.6826h-7.4488v-6.6821zm-.3 10.4014h-6.85a.3.3 0 0 1 -.3-.3v-2.0179h7.4492v2.0181a.3005.3005 0 0 1 -.2986.3z"}),u.a.createElement("path",{d:"m8.8906 12.647h-1.7806a.7.7 0 1 0 0 1.4h1.78a.7.7 0 1 0 0-1.4z"})))};Ga.displayName="IconMobile",Ga.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ga.defaultProps={title:"Mobile",color:null,size:null},Ga.__docgenInfo={description:"",methods:[],displayName:"IconMobile",props:{title:{defaultValue:{value:"'Mobile'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ka=Ga,$a=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("circle",{cx:"1.9236",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"14.0764",cy:"8",r:"1.8436"})))};$a.displayName="IconMore",$a.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},$a.defaultProps={title:"More",color:null,size:null},$a.__docgenInfo={description:"",methods:[],displayName:"IconMore",props:{title:{defaultValue:{value:"'More'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Qa=$a,Ya=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("circle",{cx:"8",cy:"1.9236",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"8",r:"1.8436"}),u.a.createElement("circle",{cx:"8",cy:"14.0764",r:"1.8436"})))};Ya.displayName="IconMoreAndroid",Ya.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ya.defaultProps={title:"MoreAndroid",color:null,size:null},Ya.__docgenInfo={description:"",methods:[],displayName:"IconMoreAndroid",props:{title:{defaultValue:{value:"'MoreAndroid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xa=Ya,Ja=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 12 18",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("g",{fillRule:"evenodd"},u.a.createElement("path",{d:"M2 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 012 6.54zM2 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 012 .085zM9 12.997a1.959 1.959 0 110 3.918 1.959 1.959 0 010-3.918zm0-6.456a1.959 1.959 0 110 3.918A1.959 1.959 0 019 6.54zM9 .085a1.959 1.959 0 110 3.918A1.959 1.959 0 019 .085z"}))))};Ja.displayName="IconMove",Ja.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ja.defaultProps={title:"Move",color:null,size:null},Ja.__docgenInfo={description:"",methods:[],displayName:"IconMove",props:{title:{defaultValue:{value:"'Move'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Za=Ja,er=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m2.4427 15.1711.6325.003h10.4922a2.3733 2.3733 0 0 0 2.3706-2.3706v-11.2276a.75.75 0 0 0 -.75-.75h-11.1543a.75.75 0 0 0 -.75.75v2.8872h-2.4717a.75.75 0 0 0 -.75.75v7.59a2.3711 2.3711 0 0 0 2.3315 2.3669c.0069 0 .0126.004.02.004l.01-.0009.0092.0009.0156-.0031m-.0253-1.4988a.8706.8706 0 0 1 -.8608-.8687v-6.84h1.7215v6.84a.8706.8706 0 0 1 -.8609.8687zm2.3607-11.3462h9.6543v10.4776a.8717.8717 0 0 1 -.8706.8706h-8.9492a2.3564 2.3564 0 0 0 .1655-.8706z"}),u.a.createElement("path",{d:"m6.9346 8.6965h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m6.9346 11.7234h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"}),u.a.createElement("path",{d:"m6.9346 5.7068h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z"})))};er.displayName="IconNews",er.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},er.defaultProps={title:"News",color:null,size:null},er.__docgenInfo={description:"",methods:[],displayName:"IconNews",props:{title:{defaultValue:{value:"'News'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tr=er,nr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.1025 7.7486a.7366.7366 0 0 1 -.5231-.2167 6.4767 6.4767 0 0 0 -9.1589 0 .74.74 0 0 1 -1.0461-1.0462 7.9558 7.9558 0 0 1 11.2511 0 .74.74 0 0 1 -.5231 1.2629z"}),u.a.createElement("path",{d:"m15.1466 4.5861a.7366.7366 0 0 1 -.5231-.2167 9.3674 9.3674 0 0 0 -13.2471 0 .74.74 0 0 1 -1.0464-1.0461 10.8465 10.8465 0 0 1 15.3393 0 .74.74 0 0 1 -.5231 1.2629z"}),u.a.createElement("path",{d:"m5.534 15.8536a.74.74 0 0 1 -.5231-1.2629l4.932-4.932a.74.74 0 0 1 1.0461 1.0461l-4.932 4.932a.7366.7366 0 0 1 -.523.2168z"}),u.a.createElement("path",{d:"m10.466 15.8536a.7366.7366 0 0 1 -.5231-.2167l-4.932-4.932a.74.74 0 0 1 1.0462-1.0461l4.932 4.932a.74.74 0 0 1 -.5231 1.2629z"})))};nr.displayName="IconNoWifi",nr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},nr.defaultProps={title:"NoWifi",color:null,size:null},nr.__docgenInfo={description:"",methods:[],displayName:"IconNoWifi",props:{title:{defaultValue:{value:"'NoWifi'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ar=nr,rr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.8181 7.8181 7.818 7.818 0 0 0 -7.8181-7.8181zm.9717 11.631h-1.4375v-6.2099l-1.7242.4258v-1.2764l3.1621-.7481z"})))};rr.displayName="IconNumber1",rr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},rr.defaultProps={title:"Number1",color:null,size:null},rr.__docgenInfo={description:"",methods:[],displayName:"IconNumber1",props:{title:{defaultValue:{value:"'Number1'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var lr=rr,or=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8063 11.6314h-5.3955v-1.0585c2.1972-1.6797 3.7617-2.7608 3.7617-4.2569a1.1908 1.1908 0 0 0 -1.2425-1.3457 1.1447 1.1447 0 0 0 -1.1852 1.2188 1.3668 1.3668 0 0 0 .23.748l-1.1963.4834a2.0961 2.0961 0 0 1 -.3916-1.3115 2.3853 2.3853 0 0 1 2.5893-2.3009 2.3743 2.3743 0 0 1 2.623 2.4736c0 1.7715-1.875 3.2207-3.2441 4.1182h3.4512z"})))};or.displayName="IconNumber2",or.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},or.defaultProps={title:"Number2",color:null,size:null},or.__docgenInfo={description:"",methods:[],displayName:"IconNumber2",props:{title:{defaultValue:{value:"'Number2'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ir=or,ur=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.1981 11.7692a2.5763 2.5763 0 0 1 -2.7842-1.99l1.2315-.4717a1.49 1.49 0 0 0 1.542 1.3467 1.2383 1.2383 0 0 0 1.3915-1.2434c0-.7588-.5752-1.1728-1.4375-1.1728h-.7832v-1.0245h.7256c.8975 0 1.2881-.4717 1.2881-1.208a1.0614 1.0614 0 0 0 -1.1621-1.0474 1.3524 1.3524 0 0 0 -1.3574 1.2544l-1.208-.4834a2.5238 2.5238 0 0 1 2.6118-1.921c1.5185 0 2.4853.794 2.4853 2.082a1.6881 1.6881 0 0 1 -1.4614 1.7833v.0234a1.7685 1.7685 0 0 1 1.668 1.7949c0 1.4264-1.208 2.2775-2.75 2.2775z"})))};ur.displayName="IconNumber3",ur.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ur.defaultProps={title:"Number3",color:null,size:null},ur.__docgenInfo={description:"",methods:[],displayName:"IconNumber3",props:{title:{defaultValue:{value:"'Number3'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var sr=ur,cr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.917 8.569v.046h2.186v-2.876h-.046z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.9562 9.48h-1.4727v2.1514h-1.3808v-2.1513h-3.4278v-1.1045l3.417-4.43h1.3916v4.4876h1.4727z"})))};cr.displayName="IconNumber4",cr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},cr.defaultProps={title:"Number4",color:null,size:null},cr.__docgenInfo={description:"",methods:[],displayName:"IconNumber4",props:{title:{defaultValue:{value:"'Number4'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dr=cr,pr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.03 11.7692a2.613 2.613 0 0 1 -2.7838-2.0362l1.2538-.4482a1.5052 1.5052 0 0 0 1.53 1.3574 1.3438 1.3438 0 0 0 1.4037-1.4961 1.2671 1.2671 0 0 0 -1.3-1.4033 1.3677 1.3677 0 0 0 -1.0586.4482h-1.1619l.2068-4.2451h4.292v1.208h-3.1756l-.1035 2.0254a2.1587 2.1587 0 0 1 1.3691-.4951 2.2726 2.2726 0 0 1 2.3242 2.4394 2.5983 2.5983 0 0 1 -2.7962 2.6456z"})))};pr.displayName="IconNumber5",pr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},pr.defaultProps={title:"Number5",color:null,size:null},pr.__docgenInfo={description:"",methods:[],displayName:"IconNumber5",props:{title:{defaultValue:{value:"'Number5'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var mr=pr,fr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.025 7.994a1.3285 1.3285 0 0 0 -1.3691 1.415 1.329 1.329 0 0 0 1.3691 1.415 1.3378 1.3378 0 0 0 1.4033-1.415 1.3373 1.3373 0 0 0 -1.4033-1.415z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm.0826 11.7691a2.6606 2.6606 0 0 1 -2.3359-1.2187 4.5691 4.5691 0 0 1 -.6787-2.5664c0-2.4619 1.2539-4.1759 3.2676-4.1759a2.4 2.4 0 0 1 2.3809 1.4492l-1.0117.667a1.4185 1.4185 0 0 0 -1.3809-.9775c-1.2422 0-1.9326 1.22-1.9326 2.8418v.1953h.0342a1.9914 1.9914 0 0 1 1.9101-1.2658 2.3065 2.3065 0 0 1 2.4044 2.4514 2.5032 2.5032 0 0 1 -2.6574 2.5997z"})))};fr.displayName="IconNumber6",fr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},fr.defaultProps={title:"Number6",color:null,size:null},fr.__docgenInfo={description:"",methods:[],displayName:"IconNumber6",props:{title:{defaultValue:{value:"'Number6'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hr=fr,vr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm2.8854 5.0045-2.6924 6.627h-1.4961l2.6924-6.5h-2.75v1.23h-1.2422v-2.4156h5.4883z"})))};vr.displayName="IconNumber7",vr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},vr.defaultProps={title:"Number7",color:null,size:null},vr.__docgenInfo={description:"",methods:[],displayName:"IconNumber7",props:{title:{defaultValue:{value:"'Number7'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var gr=vr,yr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m7.9518 8.4081c-.8518 0-1.4268.4482-1.4268 1.2419s.575 1.2317 1.4268 1.2317c.8633 0 1.4385-.4375 1.4385-1.2315s-.5752-1.2421-1.4385-1.2421z"}),u.a.createElement("path",{d:"m7.9518 7.3378a1.119 1.119 0 0 0 1.2539-1.1621 1.1052 1.1052 0 0 0 -1.2539-1.15 1.096 1.096 0 0 0 -1.2418 1.15 1.11 1.11 0 0 0 1.2418 1.1621z"}),u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.0482 11.7692c-1.7139 0-2.8418-.8511-2.8418-2.1973a1.957 1.957 0 0 1 1.542-1.875v-.0235a1.7811 1.7811 0 0 1 -1.2891-1.7832c0-1.22 1.0127-2.082 2.5889-2.082 1.5879 0 2.6006.8623 2.6006 2.082a1.7811 1.7811 0 0 1 -1.2891 1.7833v.0234a1.957 1.957 0 0 1 1.542 1.875c0 1.3462-1.1279 2.1973-2.8535 2.1973z"})))};yr.displayName="IconNumber8",yr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},yr.defaultProps={title:"Number8",color:null,size:null},yr.__docgenInfo={description:"",methods:[],displayName:"IconNumber8",props:{title:{defaultValue:{value:"'Number8'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var br=yr,Er=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.3129 11.7692a2.4015 2.4015 0 0 1 -2.3818-1.4492l1.0127-.667a1.4173 1.4173 0 0 0 1.38.9775c1.2432 0 1.9336-1.22 1.9336-2.8418v-.1953h-.0353a1.99 1.99 0 0 1 -1.9092 1.2656 2.3067 2.3067 0 0 1 -2.4052-2.4509 2.504 2.504 0 0 1 2.6581-2.6 2.6587 2.6587 0 0 1 2.335 1.22 4.5579 4.5579 0 0 1 .6787 2.5654c0 2.4618-1.2537 4.1757-3.2666 4.1757z"}),u.a.createElement("path",{d:"m7.9977 5.1171a1.3381 1.3381 0 0 0 -1.4043 1.415 1.3383 1.3383 0 0 0 1.4043 1.416 1.33 1.33 0 0 0 1.3691-1.416 1.33 1.33 0 0 0 -1.3691-1.415z"})))};Er.displayName="IconNumber9",Er.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Er.defaultProps={title:"Number9",color:null,size:null},Er.__docgenInfo={description:"",methods:[],displayName:"IconNumber9",props:{title:{defaultValue:{value:"'Number9'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wr=Er,zr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-2.1058 11.3649h-1.375v-5.94l-1.65.4063v-1.2212l3.025-.7149zm4.2129.1318c-1.87 0-2.8935-1.6611-2.8935-3.8066 0-2.1562 1.0234-3.8066 2.8935-3.8066s2.8935 1.65 2.8935 3.8066c0 2.1455-1.0234 3.8066-2.8935 3.8066z"}),u.a.createElement("path",{d:"m10.1071 5.2206c-1.0674 0-1.5185 1.1006-1.5185 2.6514s.4512 2.6514 1.5185 2.6514c1.0781 0 1.5293-1.1 1.5293-2.6514s-.4512-2.6514-1.5293-2.6514z"})))};zr.displayName="IconNumber10",zr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},zr.defaultProps={title:"Number10",color:null,size:null},zr.__docgenInfo={description:"",methods:[],displayName:"IconNumber10",props:{title:{defaultValue:{value:"'Number10'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var _r=zr,xr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.0029.1411h-8.3955a4.36 4.36 0 0 0 0 8.7207h1.439v6.2471a.75.75 0 0 0 1.5 0v-13.4678h2.1685v13.4678a.75.75 0 0 0 1.5 0v-13.4678h1.7881a.75.75 0 1 0 0-1.5zm-6.9565 7.2207h-1.439a2.86 2.86 0 1 1 0-5.7207h1.439z"})))};xr.displayName="IconParagraph",xr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},xr.defaultProps={title:"Paragraph",color:null,size:null},xr.__docgenInfo={description:"",methods:[],displayName:"IconParagraph",props:{title:{defaultValue:{value:"'Paragraph'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Cr=xr,Nr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.1787 8.1489a.75.75 0 0 0 -.75.75v5.3462h-9.8467v-9.8467h5.9629a.75.75 0 0 0 0-1.5h-6.7129a.75.75 0 0 0 -.75.75v11.3467a.75.75 0 0 0 .75.75h11.3467a.75.75 0 0 0 .75-.75v-6.0962a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m15.6982 2.6489-2.1738-2.1743a.75.75 0 0 0 -1.0605 0l-1.64 1.64-.0015.001-.001.0015-4.8458 4.8458a.75.75 0 0 0 -.22.53v2.1746a.75.75 0 0 0 .75.75h2.1744a.7494.7494 0 0 0 .53-.22l4.8462-4.8462.001-.0005.0014-.0019 1.64-1.64a.75.75 0 0 0 -.0004-1.06zm-2.7041-.5835 1.1133 1.1138-.58.58-1.114-1.113zm-4.625 6.8521h-1.1132v-1.1138l4.097-4.097 1.1136 1.1133z"})))};Nr.displayName="IconPencilBox",Nr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Nr.defaultProps={title:"PencilBox",color:null,size:null},Nr.__docgenInfo={description:"",methods:[],displayName:"IconPencilBox",props:{title:{defaultValue:{value:"'PencilBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var qr=Nr,Ir=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.95 12.915h4.0085a.7033.7033 0 0 0 .4951-.2051l.5527-.5527.0029-.002.0019-.0029 4.8662-4.8662.0029-.0019.002-.0029 1.9024-1.9023a.7.7 0 0 0 0-.99l-4.0087-4.009a.7.7 0 0 0 -.99 0l-1.9026 1.9022-.0029.002-.0019.0029-4.8663 4.8662-.0029.0019-.002.0029-.5527.5527a.7033.7033 0 0 0 -.2051.4951v4.0088a.7.7 0 0 0 .7005.7003zm.7-4.1289 2.7285 2.7285h-2.7285zm4.726-5.0161 3.0185 3.0186-3.8808 3.8808-3.0186-3.0185zm1.9048-1.9048 3.0185 3.0185-.9145.9146-3.0186-3.0183z"}),u.a.createElement("path",{d:"m14.05 14.4248h-12.1a.7.7 0 1 0 0 1.4h12.1a.7.7 0 1 0 0-1.4z"})))};Ir.displayName="IconPencilPaper",Ir.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ir.defaultProps={title:"PencilPaper",color:null,size:null},Ir.__docgenInfo={description:"",methods:[],displayName:"IconPencilPaper",props:{title:{defaultValue:{value:"'PencilPaper'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var kr=Ir,Vr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2012 7.25h-6.4512v-6.4512a.75.75 0 0 0 -1.5 0v6.4512h-6.4512a.75.75 0 0 0 0 1.5h6.4512v6.4512a.75.75 0 0 0 1.5 0v-6.4512h6.4512a.75.75 0 0 0 0-1.5z"})))};Vr.displayName="IconPlus",Vr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Vr.defaultProps={title:"Plus",color:null,size:null},Vr.__docgenInfo={description:"",methods:[],displayName:"IconPlus",props:{title:{defaultValue:{value:"'Plus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Or=Vr,Tr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 .03a7.97 7.97 0 1 0 7.9707 7.97 7.979 7.979 0 0 0 -7.9707-7.97zm0 14.44a6.47 6.47 0 1 1 6.4707-6.47 6.4778 6.4778 0 0 1 -6.4707 6.47z"}),u.a.createElement("path",{d:"m11.3564 7.25h-2.6064v-2.6067a.75.75 0 1 0 -1.5 0v2.6067h-2.6064a.75.75 0 1 0 0 1.5h2.6064v2.6069a.75.75 0 1 0 1.5 0v-2.6069h2.6065a.75.75 0 1 0 0-1.5z"})))};Tr.displayName="IconPlusCircle",Tr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Tr.defaultProps={title:"PlusCircle",color:null,size:null},Tr.__docgenInfo={description:"",methods:[],displayName:"IconPlusCircle",props:{title:{defaultValue:{value:"'PlusCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pr=Tr,Sr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1406 4.1345h-1.6806v-3.2754a.7.7 0 0 0 -.7-.7h-9.5208a.7.7 0 0 0 -.7.7v3.2754h-1.6798a.7.7 0 0 0 -.7.7v6.9736a.7.7 0 0 0 .7.7h1.68v2.6323a.7.7 0 0 0 .7.7h9.5206a.7.7 0 0 0 .7-.7v-2.6319h1.6807a.7.7 0 0 0 .7-.7v-6.9738a.7.7 0 0 0 -.7001-.7002zm-11.2012-2.5752h8.12v2.5752h-8.12zm8.12 12.8813h-8.12v-4.4106h8.12zm2.3806-3.3324h-.98v-1.7782a.7.7 0 0 0 -.7-.7h-9.52a.7.7 0 0 0 -.7.7v1.7783h-.98v-5.5734h12.88z"}),u.a.createElement("path",{d:"m3.2334 7.7947a.7025.7025 0 0 0 .5-.2.6887.6887 0 0 0 0-.99.7253.7253 0 0 0 -.9893 0 .6887.6887 0 0 0 0 .99.6959.6959 0 0 0 .4893.2z"})))};Sr.displayName="IconPrinter",Sr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Sr.defaultProps={title:"Printer",color:null,size:null},Sr.__docgenInfo={description:"",methods:[],displayName:"IconPrinter",props:{title:{defaultValue:{value:"'Printer'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var jr=Sr,Fr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.0752 15.5062h-.0185a.725.725 0 0 1 -.6953-.6l-1.7755-10.1436-1.582 6.5a.7237.7237 0 0 1 -.5879.5444.7143.7143 0 0 1 -.7295-.33l-1.5565-2.4752h-1.3a.7251.7251 0 0 1 0-1.45h1.7a.7228.7228 0 0 1 .6133.3394l.8577 1.3621 1.997-8.2051a.7246.7246 0 0 1 1.418.0464l1.7529 10.0137 1.6885-7.4136a.7252.7252 0 0 1 1.3779-.1147l1.6309 3.9688h1.3038a.7251.7251 0 0 1 0 1.45h-1.79a.7262.7262 0 0 1 -.6709-.45l-.9464-2.3018-1.98 8.6953a.7249.7249 0 0 1 -.7075.5639z"})))};Fr.displayName="IconPulse",Fr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Fr.defaultProps={title:"Pulse",color:null,size:null},Fr.__docgenInfo={description:"",methods:[],displayName:"IconPulse",props:{title:{defaultValue:{value:"'Pulse'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Br=Fr,Mr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7 14.6392-4.09-4.0892a6.4833 6.4833 0 1 0 -1.06 1.0605l4.0892 4.0895a.75.75 0 0 0 1.0608-1.0608zm-14.1194-8.0938a4.9646 4.9646 0 1 1 4.9648 4.9646 4.9706 4.9706 0 0 1 -4.9648-4.9646z"})))};Mr.displayName="IconSearch",Mr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Mr.defaultProps={title:"Search",color:null,size:null},Mr.__docgenInfo={description:"",methods:[],displayName:"IconSearch",props:{title:{defaultValue:{value:"'Search'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rr=Mr,Lr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 7.8437a3.5591 3.5591 0 1 0 -3.559-3.559 3.5632 3.5632 0 0 0 3.559 3.559zm0-5.6181a2.0591 2.0591 0 1 1 -2.059 2.0591 2.0616 2.0616 0 0 1 2.059-2.0591z"}),u.a.createElement("path",{d:"m15.0635 8.6909h-5.0835a.75.75 0 0 0 -.75.75v5.0835a.75.75 0 0 0 .75.75h5.0835a.75.75 0 0 0 .75-.75v-5.0835a.75.75 0 0 0 -.75-.75zm-.75 5.0835h-3.5835v-3.5835h3.5835z"}),u.a.createElement("path",{d:"m4.83 8.5312a.78.78 0 0 0 -1.2988 0l-3.244 5.6182a.75.75 0 0 0 .6494 1.125h6.4878a.75.75 0 0 0 .6494-1.125zm-2.5946 5.2432 1.9446-3.3682 1.9448 3.3682z"})))};Lr.displayName="IconShapes",Lr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Lr.defaultProps={title:"Shapes",color:null,size:null},Lr.__docgenInfo={description:"",methods:[],displayName:"IconShapes",props:{title:{defaultValue:{value:"'Shapes'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ar=Lr,Dr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.65 9.3564a3.2646 3.2646 0 0 0 -2.5011 1.18l-3.6189-1.7537a3.0256 3.0256 0 0 0 .0181-1.5073l3.629-1.7778a3.268 3.268 0 1 0 -.8121-2.1392 3.2482 3.2482 0 0 0 .1133.8107l-3.5975 1.7623a3.2852 3.2852 0 1 0 -.0389 4.1843l3.6235 1.7565a3.2556 3.2556 0 0 0 -.1.7694 3.2852 3.2852 0 1 0 3.2846-3.2852zm0-7.7832a1.7852 1.7852 0 1 1 -1.785 1.7852 1.7871 1.7871 0 0 1 1.785-1.7852zm-9.311 8.2119a1.7871 1.7871 0 0 1 -1.7852-1.7851 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0004a1.7816 1.7816 0 1 1 1.5747 2.6082zm9.311 4.6417a1.7871 1.7871 0 0 1 -1.7852-1.7852 1.7618 1.7618 0 0 1 .2087-.82l.0018-.0027v-.0008a1.7816 1.7816 0 1 1 1.5747 2.6087z"})))};Dr.displayName="IconShareAndroid",Dr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Dr.defaultProps={title:"ShareAndroid",color:null,size:null},Dr.__docgenInfo={description:"",methods:[],displayName:"IconShareAndroid",props:{title:{defaultValue:{value:"'ShareAndroid'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ur=Dr,Hr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.791 5.314a.7266.7266 0 0 0 .0519-.077.7066.7066 0 0 0 0-.6249.7223.7223 0 0 0 -.0525-.0779.7358.7358 0 0 0 -.1411-.1715c-.0112-.01-.0157-.0245-.0275-.0335l-4.2812-3.2807a.75.75 0 1 0 -.9121 1.19l2.5257 1.9356h-3.3412c-3.8208 0-6.93 2.3926-6.93 5.3335a.75.75 0 1 0 1.5 0c0-2.1138 2.4356-3.8335 5.43-3.8335h3.3413l-2.5259 1.936a.75.75 0 1 0 .9121 1.19l4.2813-3.2801c.0118-.009.0163-.0238.0275-.0335a.7364.7364 0 0 0 .1417-.1725z"}),u.a.createElement("path",{d:"m12.2869 9.6066a.75.75 0 0 0 -.75.75v3.25h-9.9527v-9.9526h4.9912a.75.75 0 0 0 0-1.5h-5.7412a.75.75 0 0 0 -.75.75v11.4526a.75.75 0 0 0 .75.75h11.4527a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0 -.75-.75z"})))};Hr.displayName="IconShare",Hr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Hr.defaultProps={title:"Share",color:null,size:null},Hr.__docgenInfo={description:"",methods:[],displayName:"IconShare",props:{title:{defaultValue:{value:"'Share'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wr=Hr,Gr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.2988 6.5522h-3.6826a.75.75 0 0 0 0 1.5h2.9326v6.36h-11.0976v-6.36h2.9326a.75.75 0 0 0 0-1.5h-3.6826a.75.75 0 0 0 -.75.75v7.86a.75.75 0 0 0 .75.75h12.5976a.75.75 0 0 0 .75-.75v-7.86a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m5.22 4.6768 2.03-2.03v7.9049a.75.75 0 0 0 1.5 0v-7.9048l2.03 2.03a.75.75 0 1 0 1.0605-1.0605l-3.3105-3.3102a.7527.7527 0 0 0 -1.0605 0l-3.3106 3.31a.75.75 0 0 0 1.0611 1.0606z"})))};Gr.displayName="IconShareIOS",Gr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Gr.defaultProps={title:"ShareIOS",color:null,size:null},Gr.__docgenInfo={description:"",methods:[],displayName:"IconShareIOS",props:{title:{defaultValue:{value:"'ShareIOS'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kr=Gr,$r=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.8811 12.09a.7506.7506 0 0 0 -.1614-.2416l-2.3975-2.397a.75.75 0 0 0 -1.0605 1.0605l1.1167 1.1164h-1.4077l-.0057.0012-.0051-.0012c-1.249.0483-3.4619-.4619-4.6035-3.8662-1.8935-5.6521-6.6357-4.8485-6.6826-4.8378a.75.75 0 0 0 .2685 1.4757c.1406-.023 3.5215-.5513 4.9922 3.8384 1.4688 4.3843 4.6045 4.89 5.9688 4.89h.0779 1.3978l-1.1172 1.1169a.75.75 0 1 0 1.0605 1.0605l2.3975-2.397a.7476.7476 0 0 0 .1614-.819z"}),u.a.createElement("path",{d:"m7.7666 6.523a.747.747 0 0 0 .6034-.3038 4.227 4.227 0 0 1 3.59-1.8472l.0057-.001.0051.001h1.4077l-1.1168 1.1163a.75.75 0 1 0 1.0605 1.0605l2.3978-2.3969a.7513.7513 0 0 0 -.0006-1.0611l-2.3972-2.3965a.75.75 0 1 0 -1.0605 1.0605l1.1173 1.1169h-1.4083a5.8241 5.8241 0 0 0 -4.8057 2.455.75.75 0 0 0 .6016 1.1963z"}),u.a.createElement("path",{d:"m4.9394 9.7544a4.2617 4.2617 0 0 1 -3.9971 1.8456.75.75 0 0 0 -.2676 1.4756 4.2116 4.2116 0 0 0 .7178.0532 5.792 5.792 0 0 0 4.7575-2.4888.75.75 0 0 0 -1.2109-.8857z"})))};$r.displayName="IconShuffle",$r.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},$r.defaultProps={title:"Shuffle",color:null,size:null},$r.__docgenInfo={description:"",methods:[],displayName:"IconShuffle",props:{title:{defaultValue:{value:"'Shuffle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Qr=$r,Yr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.2.1h-14.4a.7.7 0 0 0 -.7.7v14.4a.7.7 0 0 0 .7.7h14.4a.7.7 0 0 0 .7-.7v-14.4a.7.7 0 0 0 -.7-.7zm-.7 14.4h-13v-13h13z"}),u.a.createElement("path",{d:"m5.5576 8.9414a3.33 3.33 0 0 1 -2.8618 1.1206.7.7 0 0 0 -.2158 1.3833 3.6491 3.6491 0 0 0 .5352.0342 4.6867 4.6867 0 0 0 3.6088-1.6309.6887.6887 0 0 0 .151-.5579 4.6624 4.6624 0 0 0 4.0189 2.1888h.7383l-.5777.5775a.7.7 0 0 0 .99.99l1.7725-1.7725c.0054-.0054.007-.0129.0122-.0184a.681.681 0 0 0 .0033-.9485c-.0065-.0071-.0086-.0164-.0155-.0233l-1.7722-1.7721a.7.7 0 0 0 -.99.99l.577.5768h-.6893-.0083a3.3521 3.3521 0 0 1 -3.2769-2.334l-.0016-.0024a5.9911 5.9911 0 0 0 -.3221-.683.6529.6529 0 0 0 .0439.0566.7.7 0 0 0 .9873-.0732 3.29 3.29 0 0 1 2.5272-1.123h.05.69l-.5775.5773a.7.7 0 0 0 .99.99l1.7725-1.7725a.6522.6522 0 0 0 .0361-.0544.6252.6252 0 0 0 .1689-.4409l-.002-.0108a.69.69 0 0 0 -.2-.48l-.0023-.0034-.0006-.0006-1.7723-1.7716a.7.7 0 1 0 -.99.99l.5772.577h-.69l-.0029.0006a4.6157 4.6157 0 0 0 -3.635 1.6087.6883.6883 0 0 0 -.13.6486 4.69 4.69 0 0 0 -4.5941-2.2233.7.7 0 0 0 .22 1.3828 3.3245 3.3245 0 0 1 3.5521 2.3151v.0018a6.3017 6.3017 0 0 0 .2716.5961.6976.6976 0 0 0 -.9661.0909z"})))};Yr.displayName="IconShuffleBox",Yr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Yr.defaultProps={title:"ShuffleBox",color:null,size:null},Yr.__docgenInfo={description:"",methods:[],displayName:"IconShuffleBox",props:{title:{defaultValue:{value:"'ShuffleBox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xr=Yr,Jr=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.15 0h-14.4a.75.75 0 0 0 -.75.75v14.4a.75.75 0 0 0 .75.75h14.4a.75.75 0 0 0 .75-.75v-14.4a.75.75 0 0 0 -.75-.75zm-1.253 5.1707a.685.685 0 0 1 -.1908.48c-.0089.01-.012.0229-.0216.0325l-1.772 1.7729a.7251.7251 0 0 1 -1.0254-1.0254l.5348-.5348h-.63-.05a3.2657 3.2657 0 0 0 -2.5081 1.1141.7032.7032 0 0 1 -.9568.1147 6.1626 6.1626 0 0 1 .2532.5621 3.2918 3.2918 0 0 0 3.2534 2.3179l.0049.0008.0039-.0008h.629l-.5343-.5347a.7251.7251 0 1 1 1.0254-1.0254l1.7725 1.7725a.7277.7277 0 0 1 0 1.0254l-1.7725 1.7725a.7251.7251 0 1 1 -1.0254-1.025l.535-.535h-.6781a4.6892 4.6892 0 0 1 -3.9858-2.12.7159.7159 0 0 1 -.1656.4811 4.71 4.71 0 0 1 -3.6274 1.6387 3.6929 3.6929 0 0 1 -.5386-.0342.725.725 0 0 1 .2233-1.4333 3.3007 3.3007 0 0 0 2.8393-1.1123.7155.7155 0 0 1 .9221-.1371c-.0814-.1648-.1594-.3389-.2314-.524a3.2986 3.2986 0 0 0 -3.5257-2.3018.7248.7248 0 1 1 -.2275-1.4321 4.7114 4.7114 0 0 1 4.5351 2.1082.7222.7222 0 0 1 .1733-.5247 4.7475 4.7475 0 0 1 3.6548-1.6173h.0013.63l-.5345-.5345a.7251.7251 0 0 1 1.0254-1.0254l1.7709 1.7709a.7174.7174 0 0 1 .2113.5008l.0026.0129z"})))};Jr.displayName="IconShuffleBoxFilled",Jr.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Jr.defaultProps={title:"ShuffleBoxFilled",color:null,size:null},Jr.__docgenInfo={description:"",methods:[],displayName:"IconShuffleBoxFilled",props:{title:{defaultValue:{value:"'ShuffleBoxFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Zr=Jr,el=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.3677 6.24h-4.7531a3.5191 3.5191 0 0 0 -6.1369.0082c-.0143-.0006-.0263-.0082-.0407-.0082h-1.8047a1.5717 1.5717 0 0 0 -1.57 1.57v.3789a1.5717 1.5717 0 0 0 1.57 1.57h1.7813c.0219 0 .04-.0106.0618-.0125a3.5191 3.5191 0 0 0 6.1392.0136h4.7531a1.5717 1.5717 0 0 0 1.57-1.57v-.3794a1.5716 1.5716 0 0 0 -1.57-1.5706zm-12.8057 2.02v-.52h1.4609c-.0065.0873-.0263.1708-.0263.26s.02.1724.0263.26zm4.9863 1.792a2.0518 2.0518 0 1 1 2.0517-2.052 2.0547 2.0547 0 0 1 -2.0516 2.0518zm7.89-1.792h-4.3645c.0062-.0876.0262-.1711.0262-.26s-.02-.1724-.0263-.26h4.3643z"})))};el.displayName="IconSlider",el.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},el.defaultProps={title:"Slider",color:null,size:null},el.__docgenInfo={description:"",methods:[],displayName:"IconSlider",props:{title:{defaultValue:{value:"'Slider'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var tl=el,nl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M14.417 10.2363H9.6162a.75.75 0 0 1 0-1.5h4.8008a.75.75 0 1 1 0 1.5zM12.1128 15.8057a.75.75 0 0 1-.75-.75V11.791a.75.75 0 0 1 1.5 0v3.2647a.75.75 0 0 1-.75.75z"}),u.a.createElement("path",{d:"M12.1128 10.2363a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v8.6421a.75.75 0 0 1-.75.75zM6.7354 6.3955H2.1265a.75.75 0 0 1 0-1.5h4.6089a.75.75 0 0 1 0 1.5zM4.4307 15.8057a.75.75 0 0 1-.75-.75V7.95a.75.75 0 0 1 1.5 0v7.1055a.75.75 0 0 1-.75.7502z"}),u.a.createElement("path",{d:"M4.4307 6.3955a.75.75 0 0 1-.75-.75V.8442a.75.75 0 0 1 1.5 0v4.8013a.75.75 0 0 1-.75.75z"})))};nl.displayName="IconSlidersVert",nl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},nl.defaultProps={title:"Options",color:null,size:null},nl.__docgenInfo={description:"",methods:[],displayName:"IconSlidersVert",props:{title:{defaultValue:{value:"'Options'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var al=nl,rl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.874 6.13a.75.75 0 0 0 -.7134-.519h-4.84l-1.615-4.5138a.75.75 0 0 0 -1.4121 0l-1.615 4.5141h-4.8391a.75.75 0 0 0 -.4394 1.3574l3.807 2.7547-1.6723 4.6745a.75.75 0 0 0 1.1162.88l4.3491-2.8394 4.3491 2.84a.75.75 0 0 0 1.1162-.88l-1.6726-4.6745 3.8073-2.7553a.7494.7494 0 0 0 .274-.8387zm-5.4165 2.709c-.0118.0085-.0173.0218-.0285.0309a.7183.7183 0 0 0 -.1079.1168.6315.6315 0 0 0 -.1589.5143.7215.7215 0 0 0 .0226.1552c.0042.014.0012.0283.0062.0422l1.11 3.1045-2.891-1.8879a.7488.7488 0 0 0 -.82 0l-2.8918 1.8877 1.11-3.104c.0049-.0137.0019-.0276.006-.0414a.7184.7184 0 0 0 .0233-.16.7392.7392 0 0 0 .0043-.1291.6374.6374 0 0 0 -.1675-.386.7192.7192 0 0 0 -.1021-.11c-.0118-.01-.0176-.0236-.03-.0327l-2.3869-1.7282h3.0512a.7419.7419 0 0 0 .2626-.053.7252.7252 0 0 0 .0748-.0366.6923.6923 0 0 0 .3192-.3174.7081.7081 0 0 0 .0383-.07c.0029-.0074.0085-.0129.0112-.02l1.0874-3.0386 1.0859 3.0356c.0026.0071.0085.0117.0113.0187a.73.73 0 0 0 .0952.1574.7558.7558 0 0 0 .0585.0867.6491.6491 0 0 0 .4216.2129.7214.7214 0 0 0 .0906.0183c.0105 0 .0193.006.03.006h3.0518z"})))};rl.displayName="IconStar",rl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},rl.defaultProps={title:"Star",color:null,size:null},rl.__docgenInfo={description:"",methods:[],displayName:"IconStar",props:{title:{defaultValue:{value:"'Star'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ll=rl,ol=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.874 6.13a.7507.7507 0 0 0 -.7139-.5191h-4.8388l-1.6152-4.5137a.75.75 0 0 0 -1.4121 0l-1.6163 4.5141h-4.8377a.75.75 0 0 0 -.44 1.3575l3.807 2.7548-1.6728 4.6739a.75.75 0 0 0 1.1162.8809l4.3496-2.8399 4.3486 2.84a.75.75 0 0 0 1.1162-.8809l-1.6728-4.6735 3.808-2.7554a.75.75 0 0 0 .274-.8387z"})))};ol.displayName="IconStarFilled",ol.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ol.defaultProps={title:"StarFilled",color:null,size:null},ol.__docgenInfo={description:"",methods:[],displayName:"IconStarFilled",props:{title:{defaultValue:{value:"'StarFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var il=ol,ul=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M1.6678 16.0038a1.6437 1.6437 0 0 1-1.096-.4313A1.7177 1.7177 0 0 1 0 14.3057V1.6943A1.6963 1.6963 0 0 1 1.6943 0h12.6114A1.6963 1.6963 0 0 1 16 1.6943v12.6114A1.6963 1.6963 0 0 1 14.3057 16H1.779c-.0369.0027-.0743.0038-.1112.0038zm.0265-14.6149a.302.302 0 0 0-.3054.3054v12.6114a.3361.3361 0 0 0 .115.237.2452.2452 0 0 0 .1769.0717l.0689-.0033h12.556a.302.302 0 0 0 .3054-.3054V1.6943a.302.302 0 0 0-.3054-.3054z"}),u.a.createElement("path",{d:"M3.7224.6668h1.3889v14.6664H3.7224z"}),u.a.createElement("path",{d:"M.23679062 12.69208759l.7378489-1.17619835 4.00974785 2.5153819-.7378489 1.17619835zM.23653838 9.1358777l.73833393-1.17674962 4.01045281 2.51629857-.73833392 1.17674961zM.23652695 5.58003623l.73833392-1.17674961L4.9853137 6.91958518l-.73833392 1.17674961zM.23652376 2.02481365L.97485768.84806404 4.9853105 3.3643626 4.24697658 4.5411122z"})))};ul.displayName="IconTableCol",ul.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ul.defaultProps={title:"TableCol",color:null,size:null},ul.__docgenInfo={description:"",methods:[],displayName:"IconTableCol",props:{title:{defaultValue:{value:"'TableCol'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var sl=ul,cl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"M14.3061 15.9959H1.6983A1.6959 1.6959 0 0 1 .0041 14.302V1.7785A1.63 1.63 0 0 1 .4312.5722 1.7188 1.7188 0 0 1 1.6983 0h12.6078A1.6958 1.6958 0 0 1 16 1.6939V14.302a1.6958 1.6958 0 0 1-1.6939 1.6939zM1.6983 1.3885a.3369.3369 0 0 0-.2373.1156.2475.2475 0 0 0-.0719.1763l.0035.0688V14.302a.3022.3022 0 0 0 .3057.3054h12.6078a.302.302 0 0 0 .3054-.3054V1.6939a.302.302 0 0 0-.3054-.3054z"}),u.a.createElement("path",{d:"M.6707 3.7214h14.6627v1.3885H.6707z"}),u.a.createElement("path",{d:"M.79621001 4.24571892L3.31230328.2367901l1.17622688.73822626L1.9724369 4.98394518zM4.35097781 4.24562379L6.86701792.23677967 8.0432448.97500593 5.5272047 4.98385005zM7.9056546 4.2456449L10.42180101.23663138 11.5981126.9749108 9.08196617 4.98392432zM11.46010098 4.24587677l2.51578674-4.0093573 1.1764723.73821144-2.51578674 4.0093573z"})))};cl.displayName="IconTableRow",cl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},cl.defaultProps={title:"TableRow",color:null,size:null},cl.__docgenInfo={description:"",methods:[],displayName:"IconTableRow",props:{title:{defaultValue:{value:"'TableRow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var dl=cl,pl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.1072.1226h-10.2144a1.7021 1.7021 0 0 0 -1.7 1.7v12.3546a1.7021 1.7021 0 0 0 1.7 1.7h10.2144a1.7021 1.7021 0 0 0 1.7-1.7v-12.3544a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.2144 1.4h10.2144a.3.3 0 0 1 .3.3v.9074h-10.8142v-.9072a.3.3 0 0 1 .2998-.2999zm10.5142 2.6074v6.6455h-10.814v-6.6455zm-.3 10.3467h-10.2142a.3.3 0 0 1 -.3-.3v-2.001h10.8142v2.001a.3.3 0 0 1 -.2998.3004z"}),u.a.createElement("path",{d:"m8.886 12.6216h-1.7715a.7.7 0 1 0 0 1.4h1.7715a.7.7 0 1 0 0-1.4z"})))};pl.displayName="IconTablet",pl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},pl.defaultProps={title:"Tablet",color:null,size:null},pl.__docgenInfo={description:"",methods:[],displayName:"IconTablet",props:{title:{defaultValue:{value:"'Tablet'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ml=pl,fl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.9468 8.5571 1.665 1.665a.75.75 0 0 0 1.0605 0l3.3809-3.3809a.75.75 0 1 0 -1.0605-1.0604l-2.8506 2.8505-1.1348-1.1347a.75.75 0 0 0 -1.0605 1.0605z"}),u.a.createElement("path",{d:"m13.1772.0405h-10.3544a1.7021 1.7021 0 0 0 -1.7 1.7v12.5188a1.7021 1.7021 0 0 0 1.7 1.7h10.3544a1.7021 1.7021 0 0 0 1.7-1.7v-12.5186a1.7021 1.7021 0 0 0 -1.7-1.7002zm-10.3545 1.4h10.3545a.3.3 0 0 1 .3.3v1.0666h-10.9543v-1.0664a.3.3 0 0 1 .2999-.2998zm10.6544 2.767v7.5859h-10.9542v-7.5859zm-.3 10.3516h-10.3543a.3.3 0 0 1 -.3-.3v-1.0653h10.9543v1.0654a.3.3 0 0 1 -.2999.2999z"})))};fl.displayName="IconTabletCheck",fl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},fl.defaultProps={title:"TabletCheck",color:null,size:null},fl.__docgenInfo={description:"",methods:[],displayName:"IconTabletCheck",props:{title:{defaultValue:{value:"'TabletCheck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var hl=fl,vl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7124.2871a.75.75 0 0 0 -1.0605 0l-1.4839 1.4839-.708-.7075a.7515.7515 0 0 0 -.51-.22l-4.1546-.116a.8061.8061 0 0 0 -.5508.22l-6.957 6.9558a.75.75 0 0 0 0 1.0606l6.7481 6.749a.75.75 0 0 0 1.0605 0l6.957-6.957a.75.75 0 0 0 .22-.5508l-.1165-4.1551a.7515.7515 0 0 0 -.22-.51l-.7085-.7085 1.4839-1.4839a.75.75 0 0 0 .0003-1.0605zm-2.0469 4.1029.0986 3.5342-6.1982 6.1979-5.6875-5.6885 6.1983-6.1973 3.5342.0986.4966.4966-.7216.7216a2.2343 2.2343 0 1 0 1.061 1.06l.7211-.7211zm-2.7109.6563a.7368.7368 0 1 1 -.52-.2139.7338.7338 0 0 1 .52.2135z"})))};vl.displayName="IconTag",vl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},vl.defaultProps={title:"Tag",color:null,size:null},vl.__docgenInfo={description:"",methods:[],displayName:"IconTag",props:{title:{defaultValue:{value:"'Tag'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var gl=vl,yl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1563 5.126h-14.3125a.75.75 0 0 0 -.75.75v4.248a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.248a.75.75 0 0 0 -.75-.75zm-.75 4.248h-12.8125v-2.748h12.8125z"})))};yl.displayName="IconTextbox",yl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},yl.defaultProps={title:"Textbox",color:null,size:null},yl.__docgenInfo={description:"",methods:[],displayName:"IconTextbox",props:{title:{defaultValue:{value:"'Textbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var bl=yl,El=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1563 1.5332h-14.3125a.75.75 0 0 0 -.75.75v4.2468a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2468a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z"}),u.a.createElement("path",{d:"m15.1563 8.72h-14.3125a.75.75 0 0 0 -.75.75v4.2471a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.2471a.75.75 0 0 0 -.75-.75zm-.75 4.2471h-12.8125v-2.7471h12.8125z"})))};El.displayName="IconTextboxMultiple",El.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},El.defaultProps={title:"TextboxMultiple",color:null,size:null},El.__docgenInfo={description:"",methods:[],displayName:"IconTextboxMultiple",props:{title:{defaultValue:{value:"'TextboxMultiple'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var wl=El,zl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.23 8.3875a1.7682 1.7682 0 0 0 -1.107-3.1537h-.0225l-.0048-.001h-3.5552a7.5592 7.5592 0 0 0 .2266-1.3672c.0469-1.1729-.5-2.4668-1.813-2.5371-1.3672-.084-1.6941 1.2822-1.8641 2.0115a3.09 3.09 0 0 1 -.2236.7266 5.5528 5.5528 0 0 1 -1.83 1.5458.6877.6877 0 0 0 -.5431-.2762h-3.6925a.7.7 0 0 0 -.7.7v7.7338a.7.7 0 0 0 .7.7h3.6929a.6881.6881 0 0 0 .5384-.2694 4.5665 4.5665 0 0 0 1.8219.4744h5.876a1.6406 1.6406 0 0 0 1.6108-1.665 1.6938 1.6938 0 0 0 -.0772-.4832 1.6591 1.6591 0 0 0 .64-2.2564 1.6595 1.6595 0 0 0 .3267-1.883zm-11.4365 4.6825h-2.2925v-6.3333h2.2925zm8.9365.2051h-5.8579c-.0134 0-1.3372-.0631-1.6782-.7835v-5.3543a7.8387 7.8387 0 0 0 2.8554-2.3215 3.754 3.754 0 0 0 .4043-1.1572c.189-.8086.2876-.919.4258-.9316.4014.0215.5029.7383.49 1.0723a6.3983 6.3983 0 0 1 -.4429 1.8623.7005.7005 0 0 0 .645.9717h2.4781l.0048.001h2.0689a.3755.3755 0 1 1 0 .751h-2.0691a.7.7 0 0 0 0 1.4h1.5967a.3081.3081 0 1 1 0 .6133h-1.9966a.7.7 0 1 0 0 1.4h.45l.0048.001h1.36a.2736.2736 0 0 1 0 .5439h-1.8148a.7.7 0 1 0 0 1.4h1.0757a.2722.2722 0 0 1 0 .53z"})))};zl.displayName="IconThumbsUp",zl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},zl.defaultProps={title:"ThumbsUp",color:null,size:null},zl.__docgenInfo={description:"",methods:[],displayName:"IconThumbsUp",props:{title:{defaultValue:{value:"'ThumbsUp'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var _l=zl,xl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m3.1267 5.8447h-2.288a.7.7 0 0 0 -.7.7v7.2253a.7.7 0 0 0 .7.7h2.288a.7.7 0 0 0 .7-.7v-7.2251a.7.7 0 0 0 -.7-.7002z"}),u.a.createElement("path",{d:"m15.8615 6.8935a1.2052 1.2052 0 0 0 -1.2015-1.2017v-.0006h-5.0846a7.8507 7.8507 0 0 0 .5546-2.3419c.0334-.8345-.2845-1.9677-1.2861-2.0212-1.3154-.07-1.1233 1.8988-1.6292 2.6971a6.95 6.95 0 0 1 -2.3737 2.0164v8.17a4.3175 4.3175 0 0 0 1.6992.4622h6.5631a1.08 1.08 0 0 0 0-2.1565l.8259-.0006a1.0864 1.0864 0 0 0 0-2.1719l.2027-.0006a1.125 1.125 0 1 0 0-2.249h.528a1.2052 1.2052 0 0 0 1.2016-1.2017z"})))};xl.displayName="IconThumbsUpFilled",xl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},xl.defaultProps={title:"ThumbsUpFilled",color:null,size:null},xl.__docgenInfo={description:"",methods:[],displayName:"IconThumbsUpFilled",props:{title:{defaultValue:{value:"'ThumbsUpFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Cl=xl,Nl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8.5977 2.1677v-.5823h1.1406a.75.75 0 1 0 0-1.5h-3.7813a.75.75 0 0 0 0 1.5h1.1407v.5846a6.9273 6.9273 0 0 0 -4.8177 2.7817 6.8959 6.8959 0 1 0 6.3177-2.784zm-.75 12.2468a5.3948 5.3948 0 1 1 5.3945-5.3945 5.401 5.401 0 0 1 -5.3945 5.3945z"}),u.a.createElement("path",{d:"m10.0957 5.9941-1.5051 1.4938a1.9617 1.9617 0 1 0 1.0411 1.08l1.5206-1.5092a.75.75 0 1 0 -1.0566-1.0644zm-2.248 3.7715a.52.52 0 0 1 0-1.04.5184.5184 0 0 1 .52.52.5206.5206 0 0 1 -.52.52z"}),u.a.createElement("path",{d:"m14.8272 3.3818-1.0372-1.0371a.75.75 0 0 0 -1.0605 1.0605l1.0371 1.0371a.75.75 0 0 0 1.0605-1.0605z"})))};Nl.displayName="IconTimer",Nl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Nl.defaultProps={title:"Timer",color:null,size:null},Nl.__docgenInfo={description:"",methods:[],displayName:"IconTimer",props:{title:{defaultValue:{value:"'Timer'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ql=Nl,Il=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.1719 3.3008h-6.3438a4.6992 4.6992 0 0 0 0 9.3984h6.3438a4.6992 4.6992 0 0 0 0-9.3984zm-9.543 4.6992a3.203 3.203 0 0 1 3.1992-3.1992h2.9219a4.6454 4.6454 0 0 0 0 6.3984h-2.9219a3.203 3.203 0 0 1 -3.1992-3.1992z"})))};Il.displayName="IconToggle",Il.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Il.defaultProps={title:"Toggle",color:null,size:null},Il.__docgenInfo={description:"",methods:[],displayName:"IconToggle",props:{title:{defaultValue:{value:"'Toggle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var kl=Il,Vl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.1941 3.4219h-4.1436v-2.4483a.75.75 0 0 0 -.75-.75h-4.601a.75.75 0 0 0 -.75.75v2.4483h-4.1436a.75.75 0 0 0 -.75.75v10.8545a.75.75 0 0 0 .75.75h14.3882a.75.75 0 0 0 .75-.75v-10.8545a.75.75 0 0 0 -.75-.75zm-8.7446-1.6983h3.101v1.6983h-3.101zm7.9946 3.1982v3.3468h-12.8882v-3.3467zm-12.8882 9.3546v-4.5078h2.5527v.86a.75.75 0 0 0 1.5 0v-.86h4.7827v.86a.75.75 0 0 0 1.5 0v-.86h2.5527v4.5078z"})))};Vl.displayName="IconToolbox",Vl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Vl.defaultProps={title:"Toolbox",color:null,size:null},Vl.__docgenInfo={description:"",methods:[],displayName:"IconToolbox",props:{title:{defaultValue:{value:"'Toolbox'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ol=Vl,Tl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.0019 2.9858h-3.9575v-1.1093a1.82 1.82 0 0 0 -1.8178-1.8179h-2.4532a1.82 1.82 0 0 0 -1.8178 1.8179v1.1093h-3.9576a.75.75 0 0 0 0 1.5h1.0365l.2917 9.6548a1.7922 1.7922 0 0 0 1.7529 1.8008h7.7524a1.793 1.793 0 0 0 1.7525-1.7814l.38-9.6738h1.038a.75.75 0 1 0 0-1.5zm-8.5463-1.1093a.3182.3182 0 0 1 .3179-.3179h2.4531a.3182.3182 0 0 1 .3179.3179v1.1093h-3.0889zm5.6294 12.2285a.3163.3163 0 0 1 -.2534.3364h-7.7525c-.1182 0-.2485-.1367-.2539-.3428l-.29-9.6128h8.9276z"}),u.a.createElement("path",{d:"m6.3779 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 0 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z"}),u.a.createElement("path",{d:"m9.6221 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 1 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z"})))};Tl.displayName="IconTrash",Tl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Tl.defaultProps={title:"Trash",color:null,size:null},Tl.__docgenInfo={description:"",methods:[],displayName:"IconTrash",props:{title:{defaultValue:{value:"'Trash'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Pl=Tl,Sl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.59 1.2607h-6.2077a1.3186 1.3186 0 0 0 -1.3173 1.3169v.0664h-2.7364a1.9174 1.9174 0 0 0 -1.627.895l-2.2255 3.5152a2.4663 2.4663 0 0 0 -.2081.4622.67.67 0 0 0 -.0466.1036 2.4634 2.4634 0 0 0 -.1292.7593v3.4736a1.3963 1.3963 0 0 0 1.3945 1.3945h1.1785a2.17 2.17 0 0 0 4.0994 0h2.593a2.1692 2.1692 0 0 0 4.1217 0h1.1107a1.3186 1.3186 0 0 0 1.3177-1.3174v-9.3524a1.3185 1.3185 0 0 0 -1.3177-1.3169zm-10.7057 3.0274a.5248.5248 0 0 1 .4443-.2436l2.7364-.0009v3.0995h-4.9878zm.83 9.0166a.783.783 0 1 1 .7832-.7832.7832.7832 0 0 1 -.7831.7832zm6.7041.0342a.783.783 0 1 1 .7769-.8139c0 .0077-.0045.0142-.0045.0219 0 .0111.0058.02.0063.0312a.7814.7814 0 0 1 -.7786.7608zm3.0889-1.4922h-1.0337a2.17 2.17 0 0 0 -4.11 0h-2.5836a2.1683 2.1683 0 0 0 -4.1315.002l-1.1561.0039v-3.3091h6.2727a.7.7 0 0 0 .7-.7v-5.1824h6.042z"})))};Sl.displayName="IconTruck",Sl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Sl.defaultProps={title:"Truck",color:null,size:null},Sl.__docgenInfo={description:"",methods:[],displayName:"IconTruck",props:{title:{defaultValue:{value:"'Truck'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var jl=Sl,Fl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.3184.2507a3.7 3.7 0 0 0 -3.6514 3.4014v2.7437h-7.8711a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4541a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75h-2.083v-2.7437a2.1594 2.1594 0 0 1 4.2871-.0068v3.5a.75.75 0 0 0 1.5 0v-3.5a3.6882 3.6882 0 0 0 -3.6357-3.3946zm-.8184 13.9986h-9.9541v-6.3535h9.9541z"}),u.a.createElement("path",{d:"m6.5234 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z"})))};Fl.displayName="IconUnlock",Fl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Fl.defaultProps={title:"Unlock",color:null,size:null},Fl.__docgenInfo={description:"",methods:[],displayName:"IconUnlock",props:{title:{defaultValue:{value:"'Unlock'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Bl=Fl,Ml=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m8 9.0117a3.3467 3.3467 0 0 0 2.8086-1.7031 5.789 5.789 0 0 0 .53-5.1592 3.6049 3.6049 0 0 0 -3.3386-2.0937 3.605 3.605 0 0 0 -3.3389 2.0937 5.789 5.789 0 0 0 .53 5.1592 3.3468 3.3468 0 0 0 2.8089 1.7031zm-1.9736-6.2412a2.0942 2.0942 0 0 1 1.9736-1.2148 2.0942 2.0942 0 0 1 1.9736 1.2148 4.3225 4.3225 0 0 1 -.4268 3.7256 1.9264 1.9264 0 0 1 -1.5468 1.0156 1.9265 1.9265 0 0 1 -1.5469-1.0156 4.3225 4.3225 0 0 1 -.4267-3.7256z"}),u.a.createElement("path",{d:"m13.1025 10.1055a7.1174 7.1174 0 0 1 -2.3135-1.1514.7514.7514 0 0 0 -1.0723.1621l-1.7167 2.4424-1.7168-2.4424a.7514.7514 0 0 0 -1.0723-.1621 7.1174 7.1174 0 0 1 -2.3135 1.1514c-1.7734.5938-2.86 1.1572-2.86 5.0889a.75.75 0 0 0 .75.75h14.4255a.75.75 0 0 0 .75-.75c0-3.9317-1.0869-4.4952-2.8604-5.0889zm-11.5525 4.3388c.0889-2.3359.6406-2.5205 1.8232-2.916a9.2307 9.2307 0 0 0 2.1121-.9383l1.9014 2.7041a.7787.7787 0 0 0 1.2266 0l1.9013-2.7041a9.2314 9.2314 0 0 0 2.1123.9385c1.1826.3955 1.7344.58 1.8232 2.916z"})))};Ml.displayName="IconUser",Ml.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ml.defaultProps={title:"User",color:null,size:null},Ml.__docgenInfo={description:"",methods:[],displayName:"IconUser",props:{title:{defaultValue:{value:"'User'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Rl=Ml,Ll=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.0767 9.6787a5.8791 5.8791 0 0 1 -1.9023-.9453.6995.6995 0 0 0 -1.1192.4466 1.6175 1.6175 0 0 1 -1.2021.4766 1.8506 1.8506 0 0 1 -1.2931-.496.7.7 0 0 0 -1.1162-.4272 5.8792 5.8792 0 0 1 -1.9024.9453c-1.5114.5059-2.4306 1.0479-2.4306 4.3032a.7.7 0 0 0 .7.7h11.9963a.7.7 0 0 0 .7-.7c.0002-3.2553-.9187-3.7973-2.4304-4.3032zm-9.5527 3.603c.0781-1.8125.5-1.9536 1.4619-2.2754a7.8626 7.8626 0 0 0 1.6973-.7417 3.3275 3.3275 0 0 0 2.17.7925 3.161 3.161 0 0 0 2.0918-.7866 7.9062 7.9062 0 0 0 1.6875.7358c.9619.3218 1.3838.4629 1.4619 2.2754z"}),u.a.createElement("path",{d:"m6.8091 8.918a2.8562 2.8562 0 0 0 2.3994-1.4512 4.8954 4.8954 0 0 0 .4463-4.3643 3.0732 3.0732 0 0 0 -2.8457-1.7846 3.0694 3.0694 0 0 0 -2.8447 1.7851 4.8923 4.8923 0 0 0 .4456 4.3628 2.8552 2.8552 0 0 0 2.3991 1.4522zm-1.57-5.2353a1.6638 1.6638 0 0 1 1.57-.9644 1.668 1.668 0 0 1 1.5723.9648 3.5125 3.5125 0 0 1 -.35 3.0259 1.5321 1.5321 0 0 1 -1.2227.8086 1.5326 1.5326 0 0 1 -1.2227-.8091 3.5115 3.5115 0 0 1 -.3472-3.0259z"}),u.a.createElement("path",{d:"m15.8387 4.7439a.651.651 0 0 0 -.14-.7094l-2.4765-2.4759a.65.65 0 1 0 -.92.919l1.3678 1.3666h-2.314a.65.65 0 1 0 0 1.3h2.314l-1.3678 1.367a.65.65 0 0 0 .92.919l2.4764-2.4764a.65.65 0 0 0 .1401-.2099z"})))};Ll.displayName="IconUserArrow",Ll.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Ll.defaultProps={title:"UserArrow",color:null,size:null},Ll.__docgenInfo={description:"",methods:[],displayName:"IconUserArrow",props:{title:{defaultValue:{value:"'UserArrow'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Al=Ll,Dl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.1924 2.1516a3.4447 3.4447 0 0 0 -3.1924-1.9995 3.4447 3.4447 0 0 0 -3.1924 2 5.602 5.602 0 0 0 .5161 4.99 3.1937 3.1937 0 0 0 2.6763 1.6291 3.1946 3.1946 0 0 0 2.6768-1.63 5.6 5.6 0 0 0 .5156-4.9896z"}),u.a.createElement("path",{d:"m13.1748 10.5749a7.76 7.76 0 0 1 -2.5254-1.2607.3711.3711 0 0 0 -.5308.0806l-2.1186 3.0127-2.1182-3.0127a.3711.3711 0 0 0 -.5308-.0806 7.76 7.76 0 0 1 -2.5254 1.2607c-1.7211.5757-2.6947 1.087-2.6947 4.9019a.3709.3709 0 0 0 .3711.3711h14.996a.3709.3709 0 0 0 .3711-.3711c0-3.8149-.9736-4.3262-2.6943-4.9019z"})))};Dl.displayName="IconUserFilled",Dl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Dl.defaultProps={title:"UserFilled",color:null,size:null},Dl.__docgenInfo={description:"",methods:[],displayName:"IconUserFilled",props:{title:{defaultValue:{value:"'UserFilled'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ul=Dl,Hl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m11.0769 9.6787a5.8726 5.8726 0 0 1 -1.9019-.9453.7.7 0 0 0 -1.12.4468 1.6166 1.6166 0 0 1 -1.2021.4766 1.8521 1.8521 0 0 1 -1.292-.4956.7.7 0 0 0 -1.1167-.4277 5.8727 5.8727 0 0 1 -1.9019.9453c-1.5123.5058-2.4307 1.0478-2.4307 4.3031a.7.7 0 0 0 .7.7h11.9958a.7.7 0 0 0 .7-.7c.0002-3.2553-.9183-3.7973-2.4305-4.3032zm-9.5518 3.603c.0771-1.8125.5-1.9536 1.4614-2.2754a7.8833 7.8833 0 0 0 1.6973-.7417 3.3238 3.3238 0 0 0 2.169.7925 3.1591 3.1591 0 0 0 2.0918-.7866 7.9087 7.9087 0 0 0 1.688.7358c.9619.3218 1.3843.4629 1.4614 2.2754z"}),u.a.createElement("path",{d:"m6.8093 8.918a2.859 2.859 0 0 0 2.4-1.4521 4.897 4.897 0 0 0 .4457-4.3629 3.0723 3.0723 0 0 0 -2.8457-1.7851 3.0733 3.0733 0 0 0 -2.8457 1.7851 4.8983 4.8983 0 0 0 .4458 4.3633 2.8577 2.8577 0 0 0 2.3999 1.4517zm-1.5718-5.2344a1.6679 1.6679 0 0 1 1.5718-.9653 1.6654 1.6654 0 0 1 1.5713.9648 3.5112 3.5112 0 0 1 -.3481 3.0249 1.5328 1.5328 0 0 1 -1.2232.81 1.5318 1.5318 0 0 1 -1.2222-.8091 3.51 3.51 0 0 1 -.3496-3.0253z"}),u.a.createElement("path",{d:"m15.2385 3.31h-1.2915v-1.2919a.65.65 0 0 0 -1.3 0v1.2919h-1.291a.65.65 0 1 0 0 1.3h1.291v1.2909a.65.65 0 0 0 1.3 0v-1.2915h1.2915a.65.65 0 1 0 0-1.3z"})))};Hl.displayName="IconUserPlus",Hl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Hl.defaultProps={title:"UserPlus",color:null,size:null},Hl.__docgenInfo={description:"",methods:[],displayName:"IconUserPlus",props:{title:{defaultValue:{value:"'UserPlus'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Wl=Hl,Gl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m4.3755 11.1333-.9423-.9483a.4476.4476 0 0 0 -.5813-.0726c-1.6744 1.0883-2.7756.16-2.7756 3.3421h4.2764a7.1494 7.1494 0 0 1 .2781-2.2245c-.0054 0-.0081.0039-.0135.0039a.3763.3763 0 0 1 -.2418-.1006z"}),u.a.createElement("path",{d:"m12.6417 9.503a.529.529 0 0 0 -.6873.0859l-1.1139 1.1211a.4027.4027 0 0 1 -.5718 0l-1.1141-1.1211a.5291.5291 0 0 0 -.6873-.0859c-1.98 1.2867-3.2817.1893-3.2817 3.9515h10.738c0-3.7623-1.3018-2.6645-3.2819-3.9515z"}),u.a.createElement("path",{d:"m4.6172 9.3914c1.6375 0 2.497-2.5742 1.8393-4.0182a1.9705 1.9705 0 0 0 -1.8393-1.1452 1.9705 1.9705 0 0 0 -1.8392 1.1453c-.658 1.444.202 4.0181 1.8392 4.0181z"}),u.a.createElement("path",{d:"m10.5546 8.65c1.9361 0 2.9523-3.0435 2.1747-4.7509a2.33 2.33 0 0 0 -2.1747-1.3541 2.33 2.33 0 0 0 -2.1746 1.355c-.7776 1.707.2385 4.75 2.1746 4.75z"})))};Gl.displayName="IconUsers",Gl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Gl.defaultProps={title:"Users",color:null,size:null},Gl.__docgenInfo={description:"",methods:[],displayName:"IconUsers",props:{title:{defaultValue:{value:"'Users'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Kl=Gl,$l=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m12.4665 9.1189c-1.2526 0-1.91-1.9691-1.407-3.0737a1.5678 1.5678 0 0 1 2.8139 0c.5031 1.1048-.1544 3.0737-1.4069 3.0737z"}),u.a.createElement("path",{d:"m12.66 12.1179h3.28c0-2.434-.8423-1.724-2.1234-2.5565a.3423.3423 0 0 0 -.4446.0556l-.7206.7254a.288.288 0 0 1 -.185.0771c-.0065 0-.01-.0041-.0159-.0046a5.41 5.41 0 0 1 .2095 1.703z"}),u.a.createElement("path",{d:"m3.5334 9.1189c-1.2526 0-1.91-1.9691-1.4069-3.0737a1.5074 1.5074 0 0 1 1.4069-.876 1.5074 1.5074 0 0 1 1.4069.876c.5031 1.1048-.1543 3.0737-1.4069 3.0737z"}),u.a.createElement("path",{d:"m3.5585 10.4121c-.01.0013-.015.0073-.0252.0073a.2879.2879 0 0 1 -.1849-.0771c-.2343-.2357-.7208-.7254-.7208-.7254a.3423.3423 0 0 0 -.4447-.0556c-1.2807.8325-2.1229.1225-2.1229 2.5566h3.2918a5.4688 5.4688 0 0 1 .2067-1.7058z"}),u.a.createElement("path",{d:"m9.6029 9.0951a.4048.4048 0 0 0 -.5258.0658l-.8521.8576a.308.308 0 0 1 -.4374 0l-.8522-.8576a.4048.4048 0 0 0 -.5254-.0658c-1.5144.9843-2.51.1448-2.51 3.0227h8.214c-.0006-2.8778-.9965-2.0384-2.5111-3.0227z"}),u.a.createElement("path",{d:"m8.0064 8.5521c-1.481 0-2.2583-2.3281-1.6635-3.6342a1.7823 1.7823 0 0 1 1.6635-1.0358 1.7823 1.7823 0 0 1 1.6636 1.0358c.5947 1.3061-.1826 3.6342-1.6636 3.6342z"})))};$l.displayName="IconUsersGroup",$l.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},$l.defaultProps={title:"UsersGroup",color:null,size:null},$l.__docgenInfo={description:"",methods:[],displayName:"IconUsersGroup",props:{title:{defaultValue:{value:"'UsersGroup'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Ql=$l,Yl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m5.8438 2.125a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5h-3.0625v-11.75z"}),u.a.createElement("path",{d:"m13.9688.625h-3.8125a.75.75 0 0 0 0 1.5h3.0625v11.75h-3.0625a.75.75 0 0 0 0 1.5h3.8125a.75.75 0 0 0 .75-.75v-13.25a.75.75 0 0 0 -.75-.75z"})))};Yl.displayName="IconVariable",Yl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Yl.defaultProps={title:"Variable",color:null,size:null},Yl.__docgenInfo={description:"",methods:[],displayName:"IconVariable",props:{title:{defaultValue:{value:"'Variable'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Xl=Yl,Jl=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.4724 3.0515a.75.75 0 0 0 -.7685.0342l-4.0093 2.6443v-2.0589a.75.75 0 0 0 -.75-.75h-9.0615a.75.75 0 0 0 -.75.75v8.6577a.75.75 0 0 0 .75.75h9.0615a.75.75 0 0 0 .75-.75v-2.0588l4.0092 2.6447a.75.75 0 0 0 1.1631-.626v-8.577a.7489.7489 0 0 0 -.3945-.6602zm-6.2778 8.5274h-7.5615v-7.1578h7.5615zm5.1723-.6836-3.6631-2.4165v-.9576l3.6631-2.4165z"})))};Jl.displayName="IconVideo",Jl.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},Jl.defaultProps={title:"Video",color:null,size:null},Jl.__docgenInfo={description:"",methods:[],displayName:"IconVideo",props:{title:{defaultValue:{value:"'Video'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Zl=Jl,eo=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.165.1309a.75.75 0 0 0 -.75.75v5.82l-11.205-6.4695a.75.75 0 0 0 -1.125.6495v14.2382a.75.75 0 0 0 1.125.6494l11.2051-6.47v5.82a.75.75 0 0 0 1.5 0v-14.2376a.75.75 0 0 0 -.7501-.75zm-11.58 13.6891v-11.64l10.08 5.82z"})))};eo.displayName="IconVideoEnd",eo.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},eo.defaultProps={title:"VideoEnd",color:null,size:null},eo.__docgenInfo={description:"",methods:[],displayName:"IconVideoEnd",props:{title:{defaultValue:{value:"'VideoEnd'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var to=eo,no=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m1.46 15.7687a.7509.7509 0 0 0 .75 0l12.33-7.1187a.75.75 0 0 0 0-1.2988l-12.33-7.1196a.75.75 0 0 0 -1.125.6494v14.2383a.7487.7487 0 0 0 .375.6494zm1.125-13.5887 10.08 5.82-10.08 5.82z"})))};no.displayName="IconVideoNext",no.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},no.defaultProps={title:"VideoNext",color:null,size:null},no.__docgenInfo={description:"",methods:[],displayName:"IconVideoNext",props:{title:{defaultValue:{value:"'VideoNext'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var ao=no,ro=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.54.2313a.7509.7509 0 0 0 -.75 0l-12.33 7.1187a.75.75 0 0 0 0 1.2988l12.33 7.1191a.75.75 0 0 0 1.125-.6494v-14.2378a.7487.7487 0 0 0 -.375-.6494zm-1.125 13.5887-10.08-5.82 10.08-5.82z"})))};ro.displayName="IconVideoPrev",ro.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ro.defaultProps={title:"VideoPrev",color:null,size:null},ro.__docgenInfo={description:"",methods:[],displayName:"IconVideoPrev",props:{title:{defaultValue:{value:"'VideoPrev'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var lo=ro,oo=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5405.2314a.7509.7509 0 0 0 -.75 0l-11.206 6.4697v-5.8202a.75.75 0 0 0 -1.5 0v14.2382a.75.75 0 0 0 1.5 0v-5.82l11.206 6.47a.75.75 0 0 0 1.125-.6494v-14.2388a.75.75 0 0 0 -.375-.6495zm-1.125 13.5886-10.081-5.82 10.081-5.82z"})))};oo.displayName="IconVideoStart",oo.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},oo.defaultProps={title:"VideoStart",color:null,size:null},oo.__docgenInfo={description:"",methods:[],displayName:"IconVideoStart",props:{title:{defaultValue:{value:"'VideoStart'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var io=oo,uo=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.49.0464h-12.98a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-14.4072a.75.75 0 0 0 -.75-.75zm-.75 14.4072h-11.48v-12.9072h11.48z"})))};uo.displayName="IconVideoStop",uo.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},uo.defaultProps={title:"VideoStop",color:null,size:null},uo.__docgenInfo={description:"",methods:[],displayName:"IconVideoStop",props:{title:{defaultValue:{value:"'VideoStop'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var so=uo,co=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.7051 12.9691-6.5513-11.2378a1.3042 1.3042 0 0 0 -2.3076 0l-6.5513 11.2387a1.3386 1.3386 0 0 0 -.0649 1.3638 1.3379 1.3379 0 0 0 1.2109.6313h13.1177a1.2682 1.2682 0 0 0 1.1465-1.9961zm-8.4551-7.5152a.75.75 0 0 1 1.5 0v4.3023a.75.75 0 1 1 -1.5 0zm.75 7.765a.875.875 0 1 1 .875-.875.875.875 0 0 1 -.875.875z"})))};co.displayName="IconWarning",co.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},co.defaultProps={title:"Warning",color:null,size:null},co.__docgenInfo={description:"",methods:[],displayName:"IconWarning",props:{title:{defaultValue:{value:"'Warning'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var po=co,mo=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m14.5235 9.27c-.0154-.0092-.0323-.0139-.0478-.0228a6.4808 6.4808 0 0 0 -3.1207-5.7864 6.5189 6.5189 0 0 0 -.64-.3136 2.7625 2.7625 0 0 0 -5.5227.0574 6.4851 6.4851 0 0 0 -2.733 2.4686 6.3907 6.3907 0 0 0 -.9023 3.5756 2.7591 2.7591 0 0 0 -.0781 4.7784 2.7507 2.7507 0 0 0 1.4233.398 2.7844 2.7844 0 0 0 1.1992-.2722 6.5339 6.5339 0 0 0 .57.4162 6.4471 6.4471 0 0 0 2.3359.8511 6.3818 6.3818 0 0 0 .9956.0776 6.5282 6.5282 0 0 0 3.97-1.349 2.731 2.731 0 0 0 1.1174.266 2.8026 2.8026 0 0 0 .6733-.083 2.77 2.77 0 0 0 .76-5.062zm-7.6616-6.6519a1.2705 1.2705 0 1 1 -.144.9614 1.2593 1.2593 0 0 1 .144-.9614zm-3.6484 10.268a1.27 1.27 0 0 1 -1.395-1.8872 1.27 1.27 0 1 1 1.395 1.8872zm4.0259 1.0527a4.96 4.96 0 0 1 -1.7954-.6553c-.0721-.0431-.1334-.1015-.2032-.1484.012-.0189.028-.0341.04-.0533a2.7493 2.7493 0 0 0 -2.244-4.1818 4.9551 4.9551 0 0 1 2.5376-4.226 2.7289 2.7289 0 0 0 2.3705 1.37 2.8025 2.8025 0 0 0 .6733-.083 2.7527 2.7527 0 0 0 1.7051-1.26c.0129-.0214.019-.0446.0313-.0662.0748.04.1548.0679.2275.1116a4.9887 4.9887 0 0 1 2.4108 4.1309 2.826 2.826 0 0 0 -.5661.0776 2.7584 2.7584 0 0 0 -1.6518 4.1812 5.0105 5.0105 0 0 1 -3.5357.8028zm6.9439-1.6406a1.27 1.27 0 1 1 -.4331-1.7432 1.2721 1.2721 0 0 1 .433 1.7432z"})))};mo.displayName="IconWorkgroup",mo.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},mo.defaultProps={title:"Workgroup",color:null,size:null},mo.__docgenInfo={description:"",methods:[],displayName:"IconWorkgroup",props:{title:{defaultValue:{value:"'Workgroup'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var fo=mo,ho=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m15.353 2.6743a.7.7 0 0 0 -1.1206-.1807l-2.1055 2.1055-.7269-.7265 2.1055-2.1055a.7.7 0 0 0 -.1807-1.12 4.56 4.56 0 0 0 -6.35 5.6708l-3.8757 3.8759c-.0138.0139-.0187.0322-.0311.0469a2.8047 2.8047 0 1 0 1.8793 4.7861 2.7957 2.7957 0 0 0 .8112-2.0949c.0146-.0124.033-.0173.0468-.0311l3.8758-3.8758a4.5673 4.5673 0 0 0 5.6719-6.3507zm-11.3955 11.3623a1.4092 1.4092 0 1 1 0-1.9941 1.4134 1.4134 0 0 1 0 1.9941zm1.3165-2.5846a2.8 2.8 0 0 0 -.3262-.4 2.7973 2.7973 0 0 0 -.4-.3266l3.148-3.1484a4.5956 4.5956 0 0 0 .3277.3988 4.6 4.6 0 0 0 .3985.3276zm8.25-4.4662a3.2659 3.2659 0 0 1 -4.5107 0 3.1768 3.1768 0 0 1 2.6938-5.4l-1.792 1.792a.7.7 0 0 0 0 .99l1.7163 1.7168a.7.7 0 0 0 .99 0l1.7925-1.793a3.16 3.16 0 0 1 -.8895 2.6942z"})))};ho.displayName="IconWrench",ho.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},ho.defaultProps={title:"Wrench",color:null,size:null},ho.__docgenInfo={description:"",methods:[],displayName:"IconWrench",props:{title:{defaultValue:{value:"'Wrench'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var vo=ho,go=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m9.0605 8 4.1395-4.1394a.75.75 0 0 0 -1.06-1.0606l-4.14 4.1394-4.14-4.1394a.75.75 0 0 0 -1.06 1.0606l4.1395 4.1394-4.1395 4.1394a.75.75 0 1 0 1.06 1.0606l4.14-4.1395 4.14 4.1395a.75.75 0 0 0 1.06-1.0606z"})))};go.displayName="IconX",go.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},go.defaultProps={title:"X",color:null,size:null},go.__docgenInfo={description:"",methods:[],displayName:"IconX",props:{title:{defaultValue:{value:"'X'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var yo=go,bo=function(e){return u.a.createElement(f,Object.assign({viewBox:"0 0 16 16",size:e.size,color:e.color,"aria-label":e.title},e),u.a.createElement("g",null,u.a.createElement("path",{d:"m13.6233 2.3787a7.95 7.95 0 1 0 -11.2427 11.2426 7.95 7.95 0 0 0 11.2427-11.2426zm-1.0606 10.1821a6.45 6.45 0 1 1 -9.1215-9.1216 6.45 6.45 0 1 1 9.1216 9.1216z"}),u.a.createElement("path",{d:"m10.8987 5.1033a.75.75 0 0 0 -1.0605 0l-1.8365 1.8367-1.8364-1.8367a.75.75 0 1 0 -1.0606 1.0605l1.8365 1.8362-1.8365 1.8367a.75.75 0 1 0 1.0605 1.0605l1.8365-1.8364 1.8364 1.8364a.75.75 0 1 0 1.0605-1.0605l-1.8363-1.8367 1.8364-1.8364a.75.75 0 0 0 0-1.0603z"})))};bo.displayName="IconXcircle",bo.propTypes={title:c.a.string,color:c.a.string,size:c.a.string},bo.defaultProps={title:"XCircle",color:null,size:null},bo.__docgenInfo={description:"",methods:[],displayName:"IconXcircle",props:{title:{defaultValue:{value:"'XCircle'",computed:!1},type:{name:"string"},required:!1,description:""},color:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""},size:{defaultValue:{value:"null",computed:!1},type:{name:"string"},required:!1,description:""}}};var Eo=bo;n.d(t,"IconSVG",(function(){return f})),n.d(t,"IconAirplane",(function(){return v})),n.d(t,"IconArrow180",(function(){return y})),n.d(t,"IconArrow360",(function(){return E})),n.d(t,"IconArrowBox",(function(){return z})),n.d(t,"IconArrowCombine",(function(){return x})),n.d(t,"IconArrowDashed",(function(){return N})),n.d(t,"IconArrowDown",(function(){return I})),n.d(t,"IconArrowExit",(function(){return V})),n.d(t,"IconArrowForward",(function(){return T})),n.d(t,"IconArrowIntegrate",(function(){return S})),n.d(t,"IconArrowLeft",(function(){return F})),n.d(t,"IconArrowRandom",(function(){return M})),n.d(t,"IconArrowRefresh",(function(){return L})),n.d(t,"IconArrowRight",(function(){return D})),n.d(t,"IconArrowSkip",(function(){return H})),n.d(t,"IconArrowSpread",(function(){return G})),n.d(t,"IconArrowUp",(function(){return $})),n.d(t,"IconBadge",(function(){return Y})),n.d(t,"IconBalloon",(function(){return J})),n.d(t,"IconBell",(function(){return ee})),n.d(t,"IconBlocks",(function(){return ne})),n.d(t,"IconBrush",(function(){return re})),n.d(t,"IconCalendar",(function(){return oe})),n.d(t,"IconCamera",(function(){return ue})),n.d(t,"IconCaretDown",(function(){return ce})),n.d(t,"IconCaretLeft",(function(){return pe})),n.d(t,"IconCaretRight",(function(){return fe})),n.d(t,"IconCaretUp",(function(){return ve})),n.d(t,"IconCaretUpDown",(function(){return ye})),n.d(t,"IconCart",(function(){return Ee})),n.d(t,"IconChartBarHorz",(function(){return ze})),n.d(t,"IconChartBarVert",(function(){return xe})),n.d(t,"IconChartDonut",(function(){return Ne})),n.d(t,"IconChartDonutFilled",(function(){return Ie})),n.d(t,"IconChartLine",(function(){return Ve})),n.d(t,"IconChartPie",(function(){return Te})),n.d(t,"IconChartSegment",(function(){return Se})),n.d(t,"IconChat",(function(){return Fe})),n.d(t,"IconCheck",(function(){return Me})),n.d(t,"IconCheckBox",(function(){return Le})),n.d(t,"IconCheckCircle",(function(){return De})),n.d(t,"IconChevronDown",(function(){return He})),n.d(t,"IconChevronLeft",(function(){return Ge})),n.d(t,"IconChevronRight",(function(){return $e})),n.d(t,"IconChevronUp",(function(){return Ye})),n.d(t,"IconCircle",(function(){return Je})),n.d(t,"IconClock",(function(){return et})),n.d(t,"IconClone",(function(){return nt})),n.d(t,"IconCloud",(function(){return rt})),n.d(t,"IconCloudArrow",(function(){return ot})),n.d(t,"IconComment",(function(){return ut})),n.d(t,"IconCommentCheck",(function(){return ct})),n.d(t,"IconCommentFilled",(function(){return pt})),n.d(t,"IconCopyright",(function(){return ft})),n.d(t,"IconDanger",(function(){return vt})),n.d(t,"IconDashboard",(function(){return yt})),n.d(t,"IconDesktop",(function(){return Et})),n.d(t,"IconDocument",(function(){return zt})),n.d(t,"IconDocumentArrow",(function(){return xt})),n.d(t,"IconDocumentClone",(function(){return Nt})),n.d(t,"IconDocumentList",(function(){return It})),n.d(t,"IconDocumentPlus",(function(){return Vt})),n.d(t,"IconDocumentSearch",(function(){return Tt})),n.d(t,"IconDocumentUser",(function(){return St})),n.d(t,"IconDocumentX",(function(){return Ft})),n.d(t,"IconEmail",(function(){return Mt})),n.d(t,"IconEye",(function(){return Lt})),n.d(t,"IconFilter",(function(){return Dt})),n.d(t,"IconFlag",(function(){return Ht})),n.d(t,"IconFlask",(function(){return Gt})),n.d(t,"IconFlowChart",(function(){return $t})),n.d(t,"IconFolder",(function(){return Yt})),n.d(t,"IconFolderArrow",(function(){return Jt})),n.d(t,"IconFolderPencil",(function(){return en})),n.d(t,"IconFolderUser",(function(){return nn})),n.d(t,"IconFootprint",(function(){return rn})),n.d(t,"IconGear",(function(){return on})),n.d(t,"IconGlobe",(function(){return sn})),n.d(t,"IconGovBuilding",(function(){return dn})),n.d(t,"IconGraduationHat",(function(){return mn})),n.d(t,"IconGrid",(function(){return hn})),n.d(t,"IconGridCarets",(function(){return gn})),n.d(t,"IconGridCircles",(function(){return bn})),n.d(t,"IconHappy",(function(){return wn})),n.d(t,"IconHappyFilled",(function(){return _n})),n.d(t,"IconHealth",(function(){return Cn})),n.d(t,"IconHeart",(function(){return qn})),n.d(t,"IconHeartFilled",(function(){return kn})),n.d(t,"IconHeartHand",(function(){return On})),n.d(t,"IconHelp",(function(){return Pn})),n.d(t,"IconHouse",(function(){return jn})),n.d(t,"IconImage",(function(){return Bn})),n.d(t,"IconInbox",(function(){return Rn})),n.d(t,"IconInfo",(function(){return An})),n.d(t,"IconKey",(function(){return Un})),n.d(t,"IconKeyboard",(function(){return Wn})),n.d(t,"IconLaunchpad",(function(){return Kn})),n.d(t,"IconLighting",(function(){return Qn})),n.d(t,"IconLink",(function(){return Xn})),n.d(t,"IconList",(function(){return Zn})),n.d(t,"IconListBulleted",(function(){return ta})),n.d(t,"IconListChecks",(function(){return aa})),n.d(t,"IconLock",(function(){return la})),n.d(t,"IconLogoDrive",(function(){return ia})),n.d(t,"IconLogoFacebook",(function(){return sa})),n.d(t,"IconLogoGmail",(function(){return da})),n.d(t,"IconLogoGoldie",(function(){return ma})),n.d(t,"IconLogoGoogle",(function(){return ha})),n.d(t,"IconLogoGooglePlus",(function(){return ga})),n.d(t,"IconLogoLinkedIn",(function(){return ba})),n.d(t,"IconLogoMailChimp",(function(){return wa})),n.d(t,"IconLogoMessenger",(function(){return _a})),n.d(t,"IconLogoOffice",(function(){return Ca})),n.d(t,"IconLogoOutlook",(function(){return qa})),n.d(t,"IconLogoPinterest",(function(){return ka})),n.d(t,"IconLogoTwitter",(function(){return Oa})),n.d(t,"IconLogoWhatsApp",(function(){return Pa})),n.d(t,"IconLogoYahooMail",(function(){return ja})),n.d(t,"IconLogoYouTube",(function(){return Ba})),n.d(t,"IconMegaphone",(function(){return Ra})),n.d(t,"IconMenu",(function(){return Aa})),n.d(t,"IconMinus",(function(){return Ua})),n.d(t,"IconMinusCircle",(function(){return Wa})),n.d(t,"IconMobile",(function(){return Ka})),n.d(t,"IconMore",(function(){return Qa})),n.d(t,"IconMoreAndroid",(function(){return Xa})),n.d(t,"IconMove",(function(){return Za})),n.d(t,"IconNews",(function(){return tr})),n.d(t,"IconNoWifi",(function(){return ar})),n.d(t,"IconNumber1",(function(){return lr})),n.d(t,"IconNumber2",(function(){return ir})),n.d(t,"IconNumber3",(function(){return sr})),n.d(t,"IconNumber4",(function(){return dr})),n.d(t,"IconNumber5",(function(){return mr})),n.d(t,"IconNumber6",(function(){return hr})),n.d(t,"IconNumber7",(function(){return gr})),n.d(t,"IconNumber8",(function(){return br})),n.d(t,"IconNumber9",(function(){return wr})),n.d(t,"IconNumber10",(function(){return _r})),n.d(t,"IconParagraph",(function(){return Cr})),n.d(t,"IconPencilBox",(function(){return qr})),n.d(t,"IconPencilPaper",(function(){return kr})),n.d(t,"IconPlus",(function(){return Or})),n.d(t,"IconPlusCircle",(function(){return Pr})),n.d(t,"IconPrinter",(function(){return jr})),n.d(t,"IconPulse",(function(){return Br})),n.d(t,"IconSearch",(function(){return Rr})),n.d(t,"IconShapes",(function(){return Ar})),n.d(t,"IconShareAndroid",(function(){return Ur})),n.d(t,"IconShare",(function(){return Wr})),n.d(t,"IconShareIOS",(function(){return Kr})),n.d(t,"IconShuffle",(function(){return Qr})),n.d(t,"IconShuffleBox",(function(){return Xr})),n.d(t,"IconShuffleBoxFilled",(function(){return Zr})),n.d(t,"IconSlider",(function(){return tl})),n.d(t,"IconSlidersVert",(function(){return al})),n.d(t,"IconStar",(function(){return ll})),n.d(t,"IconStarFilled",(function(){return il})),n.d(t,"IconTableCol",(function(){return sl})),n.d(t,"IconTableRow",(function(){return dl})),n.d(t,"IconTablet",(function(){return ml})),n.d(t,"IconTabletCheck",(function(){return hl})),n.d(t,"IconTag",(function(){return gl})),n.d(t,"IconTextbox",(function(){return bl})),n.d(t,"IconTextboxMultiple",(function(){return wl})),n.d(t,"IconThumbsUp",(function(){return _l})),n.d(t,"IconThumbsUpFilled",(function(){return Cl})),n.d(t,"IconTimer",(function(){return ql})),n.d(t,"IconToggle",(function(){return kl})),n.d(t,"IconToolbox",(function(){return Ol})),n.d(t,"IconTrash",(function(){return Pl})),n.d(t,"IconTruck",(function(){return jl})),n.d(t,"IconUnlock",(function(){return Bl})),n.d(t,"IconUser",(function(){return Rl})),n.d(t,"IconUserArrow",(function(){return Al})),n.d(t,"IconUserFilled",(function(){return Ul})),n.d(t,"IconUserPlus",(function(){return Wl})),n.d(t,"IconUsers",(function(){return Kl})),n.d(t,"IconUsersGroup",(function(){return Ql})),n.d(t,"IconVariable",(function(){return Xl})),n.d(t,"IconVideo",(function(){return Zl})),n.d(t,"IconVideoEnd",(function(){return to})),n.d(t,"IconVideoNext",(function(){return ao})),n.d(t,"IconVideoPrev",(function(){return lo})),n.d(t,"IconVideoStart",(function(){return io})),n.d(t,"IconVideoStop",(function(){return so})),n.d(t,"IconWarning",(function(){return po})),n.d(t,"IconWorkgroup",(function(){return fo})),n.d(t,"IconWrench",(function(){return vo})),n.d(t,"IconX",(function(){return yo})),n.d(t,"IconXCircle",(function(){return Eo}))}]))},function(e,t,n){"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var a=Object.getOwnPropertySymbols,r=Object.prototype.hasOwnProperty,l=Object.prototype.propertyIsEnumerable;function o(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}e.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var a={};return"abcdefghijklmnopqrst".split("").forEach((function(e){a[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},a)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var n,i,u=o(e),s=1;s<arguments.length;s++){for(var c in n=Object(arguments[s]))r.call(n,c)&&(u[c]=n[c]);if(a){i=a(n);for(var d=0;d<i.length;d++)l.call(n,i[d])&&(u[i[d]]=n[i[d]])}}return u}},function(e,t,n){e.exports=n(17)},function(e,t,n){},function(e,t,n){"use strict";
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var a=n(5),r="function"==typeof Symbol&&Symbol.for,l=r?Symbol.for("react.element"):60103,o=r?Symbol.for("react.portal"):60106,i=r?Symbol.for("react.fragment"):60107,u=r?Symbol.for("react.strict_mode"):60108,s=r?Symbol.for("react.profiler"):60114,c=r?Symbol.for("react.provider"):60109,d=r?Symbol.for("react.context"):60110,p=r?Symbol.for("react.forward_ref"):60112,m=r?Symbol.for("react.suspense"):60113,f=r?Symbol.for("react.suspense_list"):60120,h=r?Symbol.for("react.memo"):60115,v=r?Symbol.for("react.lazy"):60116;r&&Symbol.for("react.fundamental"),r&&Symbol.for("react.responder");var g="function"==typeof Symbol&&Symbol.iterator;function y(e){for(var t=e.message,n="https://reactjs.org/docs/error-decoder.html?invariant="+t,a=1;a<arguments.length;a++)n+="&args[]="+encodeURIComponent(arguments[a]);return e.message="Minified React error #"+t+"; visit "+n+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e}var b={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function w(e,t,n){this.props=e,this.context=t,this.refs=E,this.updater=n||b}function z(){}function _(e,t,n){this.props=e,this.context=t,this.refs=E,this.updater=n||b}w.prototype.isReactComponent={},w.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw y(Error(85));this.updater.enqueueSetState(this,e,t,"setState")},w.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},z.prototype=w.prototype;var x=_.prototype=new z;x.constructor=_,a(x,w.prototype),x.isPureReactComponent=!0;var C={current:null},N={suspense:null},q={current:null},I=Object.prototype.hasOwnProperty,k={key:!0,ref:!0,__self:!0,__source:!0};function V(e,t,n){var a=void 0,r={},o=null,i=null;if(null!=t)for(a in void 0!==t.ref&&(i=t.ref),void 0!==t.key&&(o=""+t.key),t)I.call(t,a)&&!k.hasOwnProperty(a)&&(r[a]=t[a]);var u=arguments.length-2;if(1===u)r.children=n;else if(1<u){for(var s=Array(u),c=0;c<u;c++)s[c]=arguments[c+2];r.children=s}if(e&&e.defaultProps)for(a in u=e.defaultProps)void 0===r[a]&&(r[a]=u[a]);return{$$typeof:l,type:e,key:o,ref:i,props:r,_owner:q.current}}function O(e){return"object"==typeof e&&null!==e&&e.$$typeof===l}var T=/\/+/g,P=[];function S(e,t,n,a){if(P.length){var r=P.pop();return r.result=e,r.keyPrefix=t,r.func=n,r.context=a,r.count=0,r}return{result:e,keyPrefix:t,func:n,context:a,count:0}}function j(e){e.result=null,e.keyPrefix=null,e.func=null,e.context=null,e.count=0,10>P.length&&P.push(e)}function F(e,t,n){return null==e?0:function e(t,n,a,r){var i=typeof t;"undefined"!==i&&"boolean"!==i||(t=null);var u=!1;if(null===t)u=!0;else switch(i){case"string":case"number":u=!0;break;case"object":switch(t.$$typeof){case l:case o:u=!0}}if(u)return a(r,t,""===n?"."+B(t,0):n),1;if(u=0,n=""===n?".":n+":",Array.isArray(t))for(var s=0;s<t.length;s++){var c=n+B(i=t[s],s);u+=e(i,c,a,r)}else if(null===t||"object"!=typeof t?c=null:c="function"==typeof(c=g&&t[g]||t["@@iterator"])?c:null,"function"==typeof c)for(t=c.call(t),s=0;!(i=t.next()).done;)u+=e(i=i.value,c=n+B(i,s++),a,r);else if("object"===i)throw a=""+t,y(Error(31),"[object Object]"===a?"object with keys {"+Object.keys(t).join(", ")+"}":a,"");return u}(e,"",t,n)}function B(e,t){return"object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return"$"+(""+e).replace(/[=:]/g,(function(e){return t[e]}))}(e.key):t.toString(36)}function M(e,t){e.func.call(e.context,t,e.count++)}function R(e,t,n){var a=e.result,r=e.keyPrefix;e=e.func.call(e.context,t,e.count++),Array.isArray(e)?L(e,a,n,(function(e){return e})):null!=e&&(O(e)&&(e=function(e,t){return{$$typeof:l,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}(e,r+(!e.key||t&&t.key===e.key?"":(""+e.key).replace(T,"$&/")+"/")+n)),a.push(e))}function L(e,t,n,a,r){var l="";null!=n&&(l=(""+n).replace(T,"$&/")+"/"),F(e,R,t=S(t,l,a,r)),j(t)}function A(){var e=C.current;if(null===e)throw y(Error(321));return e}var D={Children:{map:function(e,t,n){if(null==e)return e;var a=[];return L(e,a,null,t,n),a},forEach:function(e,t,n){if(null==e)return e;F(e,M,t=S(null,null,t,n)),j(t)},count:function(e){return F(e,(function(){return null}),null)},toArray:function(e){var t=[];return L(e,t,null,(function(e){return e})),t},only:function(e){if(!O(e))throw y(Error(143));return e}},createRef:function(){return{current:null}},Component:w,PureComponent:_,createContext:function(e,t){return void 0===t&&(t=null),(e={$$typeof:d,_calculateChangedBits:t,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null}).Provider={$$typeof:c,_context:e},e.Consumer=e},forwardRef:function(e){return{$$typeof:p,render:e}},lazy:function(e){return{$$typeof:v,_ctor:e,_status:-1,_result:null}},memo:function(e,t){return{$$typeof:h,type:e,compare:void 0===t?null:t}},useCallback:function(e,t){return A().useCallback(e,t)},useContext:function(e,t){return A().useContext(e,t)},useEffect:function(e,t){return A().useEffect(e,t)},useImperativeHandle:function(e,t,n){return A().useImperativeHandle(e,t,n)},useDebugValue:function(){},useLayoutEffect:function(e,t){return A().useLayoutEffect(e,t)},useMemo:function(e,t){return A().useMemo(e,t)},useReducer:function(e,t,n){return A().useReducer(e,t,n)},useRef:function(e){return A().useRef(e)},useState:function(e){return A().useState(e)},Fragment:i,Profiler:s,StrictMode:u,Suspense:m,unstable_SuspenseList:f,createElement:V,cloneElement:function(e,t,n){if(null==e)throw y(Error(267),e);var r=void 0,o=a({},e.props),i=e.key,u=e.ref,s=e._owner;if(null!=t){void 0!==t.ref&&(u=t.ref,s=q.current),void 0!==t.key&&(i=""+t.key);var c=void 0;for(r in e.type&&e.type.defaultProps&&(c=e.type.defaultProps),t)I.call(t,r)&&!k.hasOwnProperty(r)&&(o[r]=void 0===t[r]&&void 0!==c?c[r]:t[r])}if(1===(r=arguments.length-2))o.children=n;else if(1<r){c=Array(r);for(var d=0;d<r;d++)c[d]=arguments[d+2];o.children=c}return{$$typeof:l,type:e.type,key:i,ref:u,props:o,_owner:s}},createFactory:function(e){var t=V.bind(null,e);return t.type=e,t},isValidElement:O,version:"16.9.0",unstable_withSuspenseConfig:function(e,t){var n=N.suspense;N.suspense=void 0===t?null:t;try{e()}finally{N.suspense=n}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:C,ReactCurrentBatchConfig:N,ReactCurrentOwner:q,IsSomeRendererActing:{current:!1},assign:a}},U={default:D},H=U&&D||U;e.exports=H.default||H},function(e,t,n){"use strict";var a=n(10);function r(){}function l(){}l.resetWarningCache=r,e.exports=function(){function e(e,t,n,r,l,o){if(o!==a){var i=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw i.name="Invariant Violation",i}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:l,resetWarningCache:r};return n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";!function e(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE){0;try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e)}catch(e){console.error(e)}}}(),e.exports=n(12)},function(e,t,n){"use strict";
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var a=n(0),r=n(5),l=n(13);function o(e){for(var t=e.message,n="https://reactjs.org/docs/error-decoder.html?invariant="+t,a=1;a<arguments.length;a++)n+="&args[]="+encodeURIComponent(arguments[a]);return e.message="Minified React error #"+t+"; visit "+n+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e}if(!a)throw o(Error(227));var i=null,u={};function s(){if(i)for(var e in u){var t=u[e],n=i.indexOf(e);if(!(-1<n))throw o(Error(96),e);if(!d[n]){if(!t.extractEvents)throw o(Error(97),e);for(var a in d[n]=t,n=t.eventTypes){var r=void 0,l=n[a],s=t,m=a;if(p.hasOwnProperty(m))throw o(Error(99),m);p[m]=l;var f=l.phasedRegistrationNames;if(f){for(r in f)f.hasOwnProperty(r)&&c(f[r],s,m);r=!0}else l.registrationName?(c(l.registrationName,s,m),r=!0):r=!1;if(!r)throw o(Error(98),a,e)}}}}function c(e,t,n){if(m[e])throw o(Error(100),e);m[e]=t,f[e]=t.eventTypes[n].dependencies}var d=[],p={},m={},f={};function h(e,t,n,a,r,l,o,i,u){var s=Array.prototype.slice.call(arguments,3);try{t.apply(n,s)}catch(e){this.onError(e)}}var v=!1,g=null,y=!1,b=null,E={onError:function(e){v=!0,g=e}};function w(e,t,n,a,r,l,o,i,u){v=!1,g=null,h.apply(E,arguments)}var z=null,_=null,x=null;function C(e,t,n){var a=e.type||"unknown-event";e.currentTarget=x(n),function(e,t,n,a,r,l,i,u,s){if(w.apply(this,arguments),v){if(!v)throw o(Error(198));var c=g;v=!1,g=null,y||(y=!0,b=c)}}(a,t,void 0,e),e.currentTarget=null}function N(e,t){if(null==t)throw o(Error(30));return null==e?t:Array.isArray(e)?Array.isArray(t)?(e.push.apply(e,t),e):(e.push(t),e):Array.isArray(t)?[e].concat(t):[e,t]}function q(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)}var I=null;function k(e){if(e){var t=e._dispatchListeners,n=e._dispatchInstances;if(Array.isArray(t))for(var a=0;a<t.length&&!e.isPropagationStopped();a++)C(e,t[a],n[a]);else t&&C(e,t,n);e._dispatchListeners=null,e._dispatchInstances=null,e.isPersistent()||e.constructor.release(e)}}function V(e){if(null!==e&&(I=N(I,e)),e=I,I=null,e){if(q(e,k),I)throw o(Error(95));if(y)throw e=b,y=!1,b=null,e}}var O={injectEventPluginOrder:function(e){if(i)throw o(Error(101));i=Array.prototype.slice.call(e),s()},injectEventPluginsByName:function(e){var t,n=!1;for(t in e)if(e.hasOwnProperty(t)){var a=e[t];if(!u.hasOwnProperty(t)||u[t]!==a){if(u[t])throw o(Error(102),t);u[t]=a,n=!0}}n&&s()}};function T(e,t){var n=e.stateNode;if(!n)return null;var a=z(n);if(!a)return null;n=a[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":(a=!a.disabled)||(a=!("button"===(e=e.type)||"input"===e||"select"===e||"textarea"===e)),e=!a;break e;default:e=!1}if(e)return null;if(n&&"function"!=typeof n)throw o(Error(231),t,typeof n);return n}var P=Math.random().toString(36).slice(2),S="__reactInternalInstance$"+P,j="__reactEventHandlers$"+P;function F(e){if(e[S])return e[S];for(;!e[S];){if(!e.parentNode)return null;e=e.parentNode}return 5===(e=e[S]).tag||6===e.tag?e:null}function B(e){return!(e=e[S])||5!==e.tag&&6!==e.tag?null:e}function M(e){if(5===e.tag||6===e.tag)return e.stateNode;throw o(Error(33))}function R(e){return e[j]||null}function L(e){do{e=e.return}while(e&&5!==e.tag);return e||null}function A(e,t,n){(t=T(e,n.dispatchConfig.phasedRegistrationNames[t]))&&(n._dispatchListeners=N(n._dispatchListeners,t),n._dispatchInstances=N(n._dispatchInstances,e))}function D(e){if(e&&e.dispatchConfig.phasedRegistrationNames){for(var t=e._targetInst,n=[];t;)n.push(t),t=L(t);for(t=n.length;0<t--;)A(n[t],"captured",e);for(t=0;t<n.length;t++)A(n[t],"bubbled",e)}}function U(e,t,n){e&&n&&n.dispatchConfig.registrationName&&(t=T(e,n.dispatchConfig.registrationName))&&(n._dispatchListeners=N(n._dispatchListeners,t),n._dispatchInstances=N(n._dispatchInstances,e))}function H(e){e&&e.dispatchConfig.registrationName&&U(e._targetInst,null,e)}function W(e){q(e,D)}var G=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement);function K(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n}var $={animationend:K("Animation","AnimationEnd"),animationiteration:K("Animation","AnimationIteration"),animationstart:K("Animation","AnimationStart"),transitionend:K("Transition","TransitionEnd")},Q={},Y={};function X(e){if(Q[e])return Q[e];if(!$[e])return e;var t,n=$[e];for(t in n)if(n.hasOwnProperty(t)&&t in Y)return Q[e]=n[t];return e}G&&(Y=document.createElement("div").style,"AnimationEvent"in window||(delete $.animationend.animation,delete $.animationiteration.animation,delete $.animationstart.animation),"TransitionEvent"in window||delete $.transitionend.transition);var J=X("animationend"),Z=X("animationiteration"),ee=X("animationstart"),te=X("transitionend"),ne="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),ae=null,re=null,le=null;function oe(){if(le)return le;var e,t,n=re,a=n.length,r="value"in ae?ae.value:ae.textContent,l=r.length;for(e=0;e<a&&n[e]===r[e];e++);var o=a-e;for(t=1;t<=o&&n[a-t]===r[l-t];t++);return le=r.slice(e,1<t?1-t:void 0)}function ie(){return!0}function ue(){return!1}function se(e,t,n,a){for(var r in this.dispatchConfig=e,this._targetInst=t,this.nativeEvent=n,e=this.constructor.Interface)e.hasOwnProperty(r)&&((t=e[r])?this[r]=t(n):"target"===r?this.target=a:this[r]=n[r]);return this.isDefaultPrevented=(null!=n.defaultPrevented?n.defaultPrevented:!1===n.returnValue)?ie:ue,this.isPropagationStopped=ue,this}function ce(e,t,n,a){if(this.eventPool.length){var r=this.eventPool.pop();return this.call(r,e,t,n,a),r}return new this(e,t,n,a)}function de(e){if(!(e instanceof this))throw o(Error(279));e.destructor(),10>this.eventPool.length&&this.eventPool.push(e)}function pe(e){e.eventPool=[],e.getPooled=ce,e.release=de}r(se.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=ie)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=ie)},persist:function(){this.isPersistent=ie},isPersistent:ue,destructor:function(){var e,t=this.constructor.Interface;for(e in t)this[e]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null,this.isPropagationStopped=this.isDefaultPrevented=ue,this._dispatchInstances=this._dispatchListeners=null}}),se.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null},se.extend=function(e){function t(){}function n(){return a.apply(this,arguments)}var a=this;t.prototype=a.prototype;var l=new t;return r(l,n.prototype),n.prototype=l,n.prototype.constructor=n,n.Interface=r({},a.Interface,e),n.extend=a.extend,pe(n),n},pe(se);var me=se.extend({data:null}),fe=se.extend({data:null}),he=[9,13,27,32],ve=G&&"CompositionEvent"in window,ge=null;G&&"documentMode"in document&&(ge=document.documentMode);var ye=G&&"TextEvent"in window&&!ge,be=G&&(!ve||ge&&8<ge&&11>=ge),Ee=String.fromCharCode(32),we={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},ze=!1;function _e(e,t){switch(e){case"keyup":return-1!==he.indexOf(t.keyCode);case"keydown":return 229!==t.keyCode;case"keypress":case"mousedown":case"blur":return!0;default:return!1}}function xe(e){return"object"==typeof(e=e.detail)&&"data"in e?e.data:null}var Ce=!1;var Ne={eventTypes:we,extractEvents:function(e,t,n,a){var r=void 0,l=void 0;if(ve)e:{switch(e){case"compositionstart":r=we.compositionStart;break e;case"compositionend":r=we.compositionEnd;break e;case"compositionupdate":r=we.compositionUpdate;break e}r=void 0}else Ce?_e(e,n)&&(r=we.compositionEnd):"keydown"===e&&229===n.keyCode&&(r=we.compositionStart);return r?(be&&"ko"!==n.locale&&(Ce||r!==we.compositionStart?r===we.compositionEnd&&Ce&&(l=oe()):(re="value"in(ae=a)?ae.value:ae.textContent,Ce=!0)),r=me.getPooled(r,t,n,a),l?r.data=l:null!==(l=xe(n))&&(r.data=l),W(r),l=r):l=null,(e=ye?function(e,t){switch(e){case"compositionend":return xe(t);case"keypress":return 32!==t.which?null:(ze=!0,Ee);case"textInput":return(e=t.data)===Ee&&ze?null:e;default:return null}}(e,n):function(e,t){if(Ce)return"compositionend"===e||!ve&&_e(e,t)?(e=oe(),le=re=ae=null,Ce=!1,e):null;switch(e){case"paste":return null;case"keypress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"compositionend":return be&&"ko"!==t.locale?null:t.data;default:return null}}(e,n))?((t=fe.getPooled(we.beforeInput,t,n,a)).data=e,W(t)):t=null,null===l?t:null===t?l:[l,t]}},qe=null,Ie=null,ke=null;function Ve(e){if(e=_(e)){if("function"!=typeof qe)throw o(Error(280));var t=z(e.stateNode);qe(e.stateNode,e.type,t)}}function Oe(e){Ie?ke?ke.push(e):ke=[e]:Ie=e}function Te(){if(Ie){var e=Ie,t=ke;if(ke=Ie=null,Ve(e),t)for(e=0;e<t.length;e++)Ve(t[e])}}function Pe(e,t){return e(t)}function Se(e,t,n,a){return e(t,n,a)}function je(){}var Fe=Pe,Be=!1;function Me(){null===Ie&&null===ke||(je(),Te())}var Re={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Le(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!Re[e.type]:"textarea"===t}function Ae(e){return(e=e.target||e.srcElement||window).correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}function De(e){if(!G)return!1;var t=(e="on"+e)in document;return t||((t=document.createElement("div")).setAttribute(e,"return;"),t="function"==typeof t[e]),t}function Ue(e){var t=e.type;return(e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function He(e){e._valueTracker||(e._valueTracker=function(e){var t=Ue(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),a=""+e[t];if(!e.hasOwnProperty(t)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var r=n.get,l=n.set;return Object.defineProperty(e,t,{configurable:!0,get:function(){return r.call(this)},set:function(e){a=""+e,l.call(this,e)}}),Object.defineProperty(e,t,{enumerable:n.enumerable}),{getValue:function(){return a},setValue:function(e){a=""+e},stopTracking:function(){e._valueTracker=null,delete e[t]}}}}(e))}function We(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var n=t.getValue(),a="";return e&&(a=Ue(e)?e.checked?"true":"false":e.value),(e=a)!==n&&(t.setValue(e),!0)}var Ge=a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ge.hasOwnProperty("ReactCurrentDispatcher")||(Ge.ReactCurrentDispatcher={current:null}),Ge.hasOwnProperty("ReactCurrentBatchConfig")||(Ge.ReactCurrentBatchConfig={suspense:null});var Ke=/^(.*)[\\\/]/,$e="function"==typeof Symbol&&Symbol.for,Qe=$e?Symbol.for("react.element"):60103,Ye=$e?Symbol.for("react.portal"):60106,Xe=$e?Symbol.for("react.fragment"):60107,Je=$e?Symbol.for("react.strict_mode"):60108,Ze=$e?Symbol.for("react.profiler"):60114,et=$e?Symbol.for("react.provider"):60109,tt=$e?Symbol.for("react.context"):60110,nt=$e?Symbol.for("react.concurrent_mode"):60111,at=$e?Symbol.for("react.forward_ref"):60112,rt=$e?Symbol.for("react.suspense"):60113,lt=$e?Symbol.for("react.suspense_list"):60120,ot=$e?Symbol.for("react.memo"):60115,it=$e?Symbol.for("react.lazy"):60116;$e&&Symbol.for("react.fundamental"),$e&&Symbol.for("react.responder");var ut="function"==typeof Symbol&&Symbol.iterator;function st(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=ut&&e[ut]||e["@@iterator"])?e:null}function ct(e){if(null==e)return null;if("function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case Xe:return"Fragment";case Ye:return"Portal";case Ze:return"Profiler";case Je:return"StrictMode";case rt:return"Suspense";case lt:return"SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case tt:return"Context.Consumer";case et:return"Context.Provider";case at:var t=e.render;return t=t.displayName||t.name||"",e.displayName||(""!==t?"ForwardRef("+t+")":"ForwardRef");case ot:return ct(e.type);case it:if(e=1===e._status?e._result:null)return ct(e)}return null}function dt(e){var t="";do{e:switch(e.tag){case 3:case 4:case 6:case 7:case 10:case 9:var n="";break e;default:var a=e._debugOwner,r=e._debugSource,l=ct(e.type);n=null,a&&(n=ct(a.type)),a=l,l="",r?l=" (at "+r.fileName.replace(Ke,"")+":"+r.lineNumber+")":n&&(l=" (created by "+n+")"),n="\n    in "+(a||"Unknown")+l}t+=n,e=e.return}while(e);return t}var pt=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mt=Object.prototype.hasOwnProperty,ft={},ht={};function vt(e,t,n,a,r,l){this.acceptsBooleans=2===t||3===t||4===t,this.attributeName=a,this.attributeNamespace=r,this.mustUseProperty=n,this.propertyName=e,this.type=t,this.sanitizeURL=l}var gt={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(e){gt[e]=new vt(e,0,!1,e,null,!1)})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(e){var t=e[0];gt[t]=new vt(t,1,!1,e[1],null,!1)})),["contentEditable","draggable","spellCheck","value"].forEach((function(e){gt[e]=new vt(e,2,!1,e.toLowerCase(),null,!1)})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(e){gt[e]=new vt(e,2,!1,e,null,!1)})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(e){gt[e]=new vt(e,3,!1,e.toLowerCase(),null,!1)})),["checked","multiple","muted","selected"].forEach((function(e){gt[e]=new vt(e,3,!0,e,null,!1)})),["capture","download"].forEach((function(e){gt[e]=new vt(e,4,!1,e,null,!1)})),["cols","rows","size","span"].forEach((function(e){gt[e]=new vt(e,6,!1,e,null,!1)})),["rowSpan","start"].forEach((function(e){gt[e]=new vt(e,5,!1,e.toLowerCase(),null,!1)}));var yt=/[\-:]([a-z])/g;function bt(e){return e[1].toUpperCase()}function Et(e,t,n,a){var r=gt.hasOwnProperty(t)?gt[t]:null;(null!==r?0===r.type:!a&&(2<t.length&&("o"===t[0]||"O"===t[0])&&("n"===t[1]||"N"===t[1])))||(function(e,t,n,a){if(null==t||function(e,t,n,a){if(null!==n&&0===n.type)return!1;switch(typeof t){case"function":case"symbol":return!0;case"boolean":return!a&&(null!==n?!n.acceptsBooleans:"data-"!==(e=e.toLowerCase().slice(0,5))&&"aria-"!==e);default:return!1}}(e,t,n,a))return!0;if(a)return!1;if(null!==n)switch(n.type){case 3:return!t;case 4:return!1===t;case 5:return isNaN(t);case 6:return isNaN(t)||1>t}return!1}(t,n,r,a)&&(n=null),a||null===r?function(e){return!!mt.call(ht,e)||!mt.call(ft,e)&&(pt.test(e)?ht[e]=!0:(ft[e]=!0,!1))}(t)&&(null===n?e.removeAttribute(t):e.setAttribute(t,""+n)):r.mustUseProperty?e[r.propertyName]=null===n?3!==r.type&&"":n:(t=r.attributeName,a=r.attributeNamespace,null===n?e.removeAttribute(t):(n=3===(r=r.type)||4===r&&!0===n?"":""+n,a?e.setAttributeNS(a,t,n):e.setAttribute(t,n))))}function wt(e){switch(typeof e){case"boolean":case"number":case"object":case"string":case"undefined":return e;default:return""}}function zt(e,t){var n=t.checked;return r({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=n?n:e._wrapperState.initialChecked})}function _t(e,t){var n=null==t.defaultValue?"":t.defaultValue,a=null!=t.checked?t.checked:t.defaultChecked;n=wt(null!=t.value?t.value:n),e._wrapperState={initialChecked:a,initialValue:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value}}function xt(e,t){null!=(t=t.checked)&&Et(e,"checked",t,!1)}function Ct(e,t){xt(e,t);var n=wt(t.value),a=t.type;if(null!=n)"number"===a?(0===n&&""===e.value||e.value!=n)&&(e.value=""+n):e.value!==""+n&&(e.value=""+n);else if("submit"===a||"reset"===a)return void e.removeAttribute("value");t.hasOwnProperty("value")?qt(e,t.type,n):t.hasOwnProperty("defaultValue")&&qt(e,t.type,wt(t.defaultValue)),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked)}function Nt(e,t,n){if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var a=t.type;if(!("submit"!==a&&"reset"!==a||void 0!==t.value&&null!==t.value))return;t=""+e._wrapperState.initialValue,n||t===e.value||(e.value=t),e.defaultValue=t}""!==(n=e.name)&&(e.name=""),e.defaultChecked=!e.defaultChecked,e.defaultChecked=!!e._wrapperState.initialChecked,""!==n&&(e.name=n)}function qt(e,t,n){"number"===t&&e.ownerDocument.activeElement===e||(null==n?e.defaultValue=""+e._wrapperState.initialValue:e.defaultValue!==""+n&&(e.defaultValue=""+n))}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(e){var t=e.replace(yt,bt);gt[t]=new vt(t,1,!1,e,null,!1)})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(e){var t=e.replace(yt,bt);gt[t]=new vt(t,1,!1,e,"http://www.w3.org/1999/xlink",!1)})),["xml:base","xml:lang","xml:space"].forEach((function(e){var t=e.replace(yt,bt);gt[t]=new vt(t,1,!1,e,"http://www.w3.org/XML/1998/namespace",!1)})),["tabIndex","crossOrigin"].forEach((function(e){gt[e]=new vt(e,1,!1,e.toLowerCase(),null,!1)})),gt.xlinkHref=new vt("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0),["src","href","action","formAction"].forEach((function(e){gt[e]=new vt(e,1,!1,e.toLowerCase(),null,!0)}));var It={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function kt(e,t,n){return(e=se.getPooled(It.change,e,t,n)).type="change",Oe(n),W(e),e}var Vt=null,Ot=null;function Tt(e){V(e)}function Pt(e){if(We(M(e)))return e}function St(e,t){if("change"===e)return t}var jt=!1;function Ft(){Vt&&(Vt.detachEvent("onpropertychange",Bt),Ot=Vt=null)}function Bt(e){if("value"===e.propertyName&&Pt(Ot))if(e=kt(Ot,e,Ae(e)),Be)V(e);else{Be=!0;try{Pe(Tt,e)}finally{Be=!1,Me()}}}function Mt(e,t,n){"focus"===e?(Ft(),Ot=n,(Vt=t).attachEvent("onpropertychange",Bt)):"blur"===e&&Ft()}function Rt(e){if("selectionchange"===e||"keyup"===e||"keydown"===e)return Pt(Ot)}function Lt(e,t){if("click"===e)return Pt(t)}function At(e,t){if("input"===e||"change"===e)return Pt(t)}G&&(jt=De("input")&&(!document.documentMode||9<document.documentMode));var Dt={eventTypes:It,_isInputEventSupported:jt,extractEvents:function(e,t,n,a){var r=t?M(t):window,l=void 0,o=void 0,i=r.nodeName&&r.nodeName.toLowerCase();if("select"===i||"input"===i&&"file"===r.type?l=St:Le(r)?jt?l=At:(l=Rt,o=Mt):(i=r.nodeName)&&"input"===i.toLowerCase()&&("checkbox"===r.type||"radio"===r.type)&&(l=Lt),l&&(l=l(e,t)))return kt(l,n,a);o&&o(e,r,t),"blur"===e&&(e=r._wrapperState)&&e.controlled&&"number"===r.type&&qt(r,"number",r.value)}},Ut=se.extend({view:null,detail:null}),Ht={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Wt(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=Ht[e])&&!!t[e]}function Gt(){return Wt}var Kt=0,$t=0,Qt=!1,Yt=!1,Xt=Ut.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Gt,button:null,buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)},movementX:function(e){if("movementX"in e)return e.movementX;var t=Kt;return Kt=e.screenX,Qt?"mousemove"===e.type?e.screenX-t:0:(Qt=!0,0)},movementY:function(e){if("movementY"in e)return e.movementY;var t=$t;return $t=e.screenY,Yt?"mousemove"===e.type?e.screenY-t:0:(Yt=!0,0)}}),Jt=Xt.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Zt={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},en={eventTypes:Zt,extractEvents:function(e,t,n,a){var r="mouseover"===e||"pointerover"===e,l="mouseout"===e||"pointerout"===e;if(r&&(n.relatedTarget||n.fromElement)||!l&&!r)return null;if(r=a.window===a?a:(r=a.ownerDocument)?r.defaultView||r.parentWindow:window,l?(l=t,t=(t=n.relatedTarget||n.toElement)?F(t):null):l=null,l===t)return null;var o=void 0,i=void 0,u=void 0,s=void 0;"mouseout"===e||"mouseover"===e?(o=Xt,i=Zt.mouseLeave,u=Zt.mouseEnter,s="mouse"):"pointerout"!==e&&"pointerover"!==e||(o=Jt,i=Zt.pointerLeave,u=Zt.pointerEnter,s="pointer");var c=null==l?r:M(l);if(r=null==t?r:M(t),(e=o.getPooled(i,l,n,a)).type=s+"leave",e.target=c,e.relatedTarget=r,(n=o.getPooled(u,t,n,a)).type=s+"enter",n.target=r,n.relatedTarget=c,a=t,l&&a)e:{for(r=a,s=0,o=t=l;o;o=L(o))s++;for(o=0,u=r;u;u=L(u))o++;for(;0<s-o;)t=L(t),s--;for(;0<o-s;)r=L(r),o--;for(;s--;){if(t===r||t===r.alternate)break e;t=L(t),r=L(r)}t=null}else t=null;for(r=t,t=[];l&&l!==r&&(null===(s=l.alternate)||s!==r);)t.push(l),l=L(l);for(l=[];a&&a!==r&&(null===(s=a.alternate)||s!==r);)l.push(a),a=L(a);for(a=0;a<t.length;a++)U(t[a],"bubbled",e);for(a=l.length;0<a--;)U(l[a],"captured",n);return[e,n]}};function tn(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t}var nn=Object.prototype.hasOwnProperty;function an(e,t){if(tn(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),a=Object.keys(t);if(n.length!==a.length)return!1;for(a=0;a<n.length;a++)if(!nn.call(t,n[a])||!tn(e[n[a]],t[n[a]]))return!1;return!0}function rn(e,t){return{responder:e,props:t}}function ln(e){var t=e;if(e.alternate)for(;t.return;)t=t.return;else{if(0!=(2&t.effectTag))return 1;for(;t.return;)if(0!=(2&(t=t.return).effectTag))return 1}return 3===t.tag?2:3}function on(e){if(2!==ln(e))throw o(Error(188))}function un(e){if(!(e=function(e){var t=e.alternate;if(!t){if(3===(t=ln(e)))throw o(Error(188));return 1===t?null:e}for(var n=e,a=t;;){var r=n.return;if(null===r)break;var l=r.alternate;if(null===l){if(null!==(a=r.return)){n=a;continue}break}if(r.child===l.child){for(l=r.child;l;){if(l===n)return on(r),e;if(l===a)return on(r),t;l=l.sibling}throw o(Error(188))}if(n.return!==a.return)n=r,a=l;else{for(var i=!1,u=r.child;u;){if(u===n){i=!0,n=r,a=l;break}if(u===a){i=!0,a=r,n=l;break}u=u.sibling}if(!i){for(u=l.child;u;){if(u===n){i=!0,n=l,a=r;break}if(u===a){i=!0,a=l,n=r;break}u=u.sibling}if(!i)throw o(Error(189))}}if(n.alternate!==a)throw o(Error(190))}if(3!==n.tag)throw o(Error(188));return n.stateNode.current===n?e:t}(e)))return null;for(var t=e;;){if(5===t.tag||6===t.tag)return t;if(t.child)t.child.return=t,t=t.child;else{if(t===e)break;for(;!t.sibling;){if(!t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}}return null}new Map,new Map,new Set,new Map;var sn=se.extend({animationName:null,elapsedTime:null,pseudoElement:null}),cn=se.extend({clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),dn=Ut.extend({relatedTarget:null});function pn(e){var t=e.keyCode;return"charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,10===e&&(e=13),32<=e||13===e?e:0}for(var mn={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},fn={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},hn=Ut.extend({key:function(e){if(e.key){var t=mn[e.key]||e.key;if("Unidentified"!==t)return t}return"keypress"===e.type?13===(e=pn(e))?"Enter":String.fromCharCode(e):"keydown"===e.type||"keyup"===e.type?fn[e.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Gt,charCode:function(e){return"keypress"===e.type?pn(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?pn(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),vn=Xt.extend({dataTransfer:null}),gn=Ut.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Gt}),yn=se.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),bn=Xt.extend({deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null}),En=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[J,"animationEnd",2],[Z,"animationIteration",2],[ee,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[te,"transitionEnd",2],["waiting","waiting",2]],wn={},zn={},_n=0;_n<En.length;_n++){var xn=En[_n],Cn=xn[0],Nn=xn[1],qn=xn[2],In="on"+(Nn[0].toUpperCase()+Nn.slice(1)),kn={phasedRegistrationNames:{bubbled:In,captured:In+"Capture"},dependencies:[Cn],eventPriority:qn};wn[Nn]=kn,zn[Cn]=kn}var Vn={eventTypes:wn,getEventPriority:function(e){return void 0!==(e=zn[e])?e.eventPriority:2},extractEvents:function(e,t,n,a){var r=zn[e];if(!r)return null;switch(e){case"keypress":if(0===pn(n))return null;case"keydown":case"keyup":e=hn;break;case"blur":case"focus":e=dn;break;case"click":if(2===n.button)return null;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":e=Xt;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":e=vn;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":e=gn;break;case J:case Z:case ee:e=sn;break;case te:e=yn;break;case"scroll":e=Ut;break;case"wheel":e=bn;break;case"copy":case"cut":case"paste":e=cn;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":e=Jt;break;default:e=se}return W(t=e.getPooled(r,t,n,a)),t}},On=Vn.getEventPriority,Tn=[];function Pn(e){var t=e.targetInst,n=t;do{if(!n){e.ancestors.push(n);break}var a;for(a=n;a.return;)a=a.return;if(!(a=3!==a.tag?null:a.stateNode.containerInfo))break;e.ancestors.push(n),n=F(a)}while(n);for(n=0;n<e.ancestors.length;n++){t=e.ancestors[n];var r=Ae(e.nativeEvent);a=e.topLevelType;for(var l=e.nativeEvent,o=null,i=0;i<d.length;i++){var u=d[i];u&&(u=u.extractEvents(a,t,l,r))&&(o=N(o,u))}V(o)}}var Sn=!0;function jn(e,t){Fn(t,e,!1)}function Fn(e,t,n){switch(On(t)){case 0:var a=Bn.bind(null,t,1);break;case 1:a=Mn.bind(null,t,1);break;default:a=Rn.bind(null,t,1)}n?e.addEventListener(t,a,!0):e.addEventListener(t,a,!1)}function Bn(e,t,n){Be||je();var a=Rn,r=Be;Be=!0;try{Se(a,e,t,n)}finally{(Be=r)||Me()}}function Mn(e,t,n){Rn(e,t,n)}function Rn(e,t,n){if(Sn){if(null===(t=F(t=Ae(n)))||"number"!=typeof t.tag||2===ln(t)||(t=null),Tn.length){var a=Tn.pop();a.topLevelType=e,a.nativeEvent=n,a.targetInst=t,e=a}else e={topLevelType:e,nativeEvent:n,targetInst:t,ancestors:[]};try{if(n=e,Be)Pn(n);else{Be=!0;try{Fe(Pn,n,void 0)}finally{Be=!1,Me()}}}finally{e.topLevelType=null,e.nativeEvent=null,e.targetInst=null,e.ancestors.length=0,10>Tn.length&&Tn.push(e)}}}var Ln=new("function"==typeof WeakMap?WeakMap:Map);function An(e){var t=Ln.get(e);return void 0===t&&(t=new Set,Ln.set(e,t)),t}function Dn(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}function Un(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function Hn(e,t){var n,a=Un(e);for(e=0;a;){if(3===a.nodeType){if(n=e+a.textContent.length,e<=t&&n>=t)return{node:a,offset:t-e};e=n}e:{for(;a;){if(a.nextSibling){a=a.nextSibling;break e}a=a.parentNode}a=void 0}a=Un(a)}}function Wn(){for(var e=window,t=Dn();t instanceof e.HTMLIFrameElement;){try{var n="string"==typeof t.contentWindow.location.href}catch(e){n=!1}if(!n)break;t=Dn((e=t.contentWindow).document)}return t}function Gn(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&("text"===e.type||"search"===e.type||"tel"===e.type||"url"===e.type||"password"===e.type)||"textarea"===t||"true"===e.contentEditable)}var Kn=G&&"documentMode"in document&&11>=document.documentMode,$n={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Qn=null,Yn=null,Xn=null,Jn=!1;function Zn(e,t){var n=t.window===t?t.document:9===t.nodeType?t:t.ownerDocument;return Jn||null==Qn||Qn!==Dn(n)?null:("selectionStart"in(n=Qn)&&Gn(n)?n={start:n.selectionStart,end:n.selectionEnd}:n={anchorNode:(n=(n.ownerDocument&&n.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:n.anchorOffset,focusNode:n.focusNode,focusOffset:n.focusOffset},Xn&&an(Xn,n)?null:(Xn=n,(e=se.getPooled($n.select,Yn,e,t)).type="select",e.target=Qn,W(e),e))}var ea={eventTypes:$n,extractEvents:function(e,t,n,a){var r,l=a.window===a?a.document:9===a.nodeType?a:a.ownerDocument;if(!(r=!l)){e:{l=An(l),r=f.onSelect;for(var o=0;o<r.length;o++)if(!l.has(r[o])){l=!1;break e}l=!0}r=!l}if(r)return null;switch(l=t?M(t):window,e){case"focus":(Le(l)||"true"===l.contentEditable)&&(Qn=l,Yn=t,Xn=null);break;case"blur":Xn=Yn=Qn=null;break;case"mousedown":Jn=!0;break;case"contextmenu":case"mouseup":case"dragend":return Jn=!1,Zn(n,a);case"selectionchange":if(Kn)break;case"keydown":case"keyup":return Zn(n,a)}return null}};function ta(e,t){return e=r({children:void 0},t),(t=function(e){var t="";return a.Children.forEach(e,(function(e){null!=e&&(t+=e)})),t}(t.children))&&(e.children=t),e}function na(e,t,n,a){if(e=e.options,t){t={};for(var r=0;r<n.length;r++)t["$"+n[r]]=!0;for(n=0;n<e.length;n++)r=t.hasOwnProperty("$"+e[n].value),e[n].selected!==r&&(e[n].selected=r),r&&a&&(e[n].defaultSelected=!0)}else{for(n=""+wt(n),t=null,r=0;r<e.length;r++){if(e[r].value===n)return e[r].selected=!0,void(a&&(e[r].defaultSelected=!0));null!==t||e[r].disabled||(t=e[r])}null!==t&&(t.selected=!0)}}function aa(e,t){if(null!=t.dangerouslySetInnerHTML)throw o(Error(91));return r({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function ra(e,t){var n=t.value;if(null==n){if(n=t.defaultValue,null!=(t=t.children)){if(null!=n)throw o(Error(92));if(Array.isArray(t)){if(!(1>=t.length))throw o(Error(93));t=t[0]}n=t}null==n&&(n="")}e._wrapperState={initialValue:wt(n)}}function la(e,t){var n=wt(t.value),a=wt(t.defaultValue);null!=n&&((n=""+n)!==e.value&&(e.value=n),null==t.defaultValue&&e.defaultValue!==n&&(e.defaultValue=n)),null!=a&&(e.defaultValue=""+a)}function oa(e){var t=e.textContent;t===e._wrapperState.initialValue&&(e.value=t)}O.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")),z=R,_=B,x=M,O.injectEventPluginsByName({SimpleEventPlugin:Vn,EnterLeaveEventPlugin:en,ChangeEventPlugin:Dt,SelectEventPlugin:ea,BeforeInputEventPlugin:Ne});var ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function ua(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function sa(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?ua(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}var ca=void 0,da=function(e){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(t,n,a,r){MSApp.execUnsafeLocalFunction((function(){return e(t,n)}))}:e}((function(e,t){if(e.namespaceURI!==ia.svg||"innerHTML"in e)e.innerHTML=t;else{for((ca=ca||document.createElement("div")).innerHTML="<svg>"+t+"</svg>",t=ca.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}}));function pa(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t}var ma={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},fa=["Webkit","ms","Moz","O"];function ha(e,t,n){return null==t||"boolean"==typeof t||""===t?"":n||"number"!=typeof t||0===t||ma.hasOwnProperty(e)&&ma[e]?(""+t).trim():t+"px"}function va(e,t){for(var n in e=e.style,t)if(t.hasOwnProperty(n)){var a=0===n.indexOf("--"),r=ha(n,t[n],a);"float"===n&&(n="cssFloat"),a?e.setProperty(n,r):e[n]=r}}Object.keys(ma).forEach((function(e){fa.forEach((function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),ma[t]=ma[e]}))}));var ga=r({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function ya(e,t){if(t){if(ga[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML))throw o(Error(137),e,"");if(null!=t.dangerouslySetInnerHTML){if(null!=t.children)throw o(Error(60));if(!("object"==typeof t.dangerouslySetInnerHTML&&"__html"in t.dangerouslySetInnerHTML))throw o(Error(61))}if(null!=t.style&&"object"!=typeof t.style)throw o(Error(62),"")}}function ba(e,t){if(-1===e.indexOf("-"))return"string"==typeof t.is;switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}function Ea(e,t){var n=An(e=9===e.nodeType||11===e.nodeType?e:e.ownerDocument);t=f[t];for(var a=0;a<t.length;a++){var r=t[a];if(!n.has(r)){switch(r){case"scroll":Fn(e,"scroll",!0);break;case"focus":case"blur":Fn(e,"focus",!0),Fn(e,"blur",!0),n.add("blur"),n.add("focus");break;case"cancel":case"close":De(r)&&Fn(e,r,!0);break;case"invalid":case"submit":case"reset":break;default:-1===ne.indexOf(r)&&jn(r,e)}n.add(r)}}}function wa(){}var za=null,_a=null;function xa(e,t){switch(e){case"button":case"input":case"select":case"textarea":return!!t.autoFocus}return!1}function Ca(e,t){return"textarea"===e||"option"===e||"noscript"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&null!=t.dangerouslySetInnerHTML.__html}var Na="function"==typeof setTimeout?setTimeout:void 0,qa="function"==typeof clearTimeout?clearTimeout:void 0;function Ia(e){for(;null!=e;e=e.nextSibling){var t=e.nodeType;if(1===t||3===t)break}return e}new Set;var ka=[],Va=-1;function Oa(e){0>Va||(e.current=ka[Va],ka[Va]=null,Va--)}function Ta(e,t){ka[++Va]=e.current,e.current=t}var Pa={},Sa={current:Pa},ja={current:!1},Fa=Pa;function Ba(e,t){var n=e.type.contextTypes;if(!n)return Pa;var a=e.stateNode;if(a&&a.__reactInternalMemoizedUnmaskedChildContext===t)return a.__reactInternalMemoizedMaskedChildContext;var r,l={};for(r in n)l[r]=t[r];return a&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=l),l}function Ma(e){return null!=(e=e.childContextTypes)}function Ra(e){Oa(ja),Oa(Sa)}function La(e){Oa(ja),Oa(Sa)}function Aa(e,t,n){if(Sa.current!==Pa)throw o(Error(168));Ta(Sa,t),Ta(ja,n)}function Da(e,t,n){var a=e.stateNode;if(e=t.childContextTypes,"function"!=typeof a.getChildContext)return n;for(var l in a=a.getChildContext())if(!(l in e))throw o(Error(108),ct(t)||"Unknown",l);return r({},n,a)}function Ua(e){var t=e.stateNode;return t=t&&t.__reactInternalMemoizedMergedChildContext||Pa,Fa=Sa.current,Ta(Sa,t),Ta(ja,ja.current),!0}function Ha(e,t,n){var a=e.stateNode;if(!a)throw o(Error(169));n?(t=Da(e,t,Fa),a.__reactInternalMemoizedMergedChildContext=t,Oa(ja),Oa(Sa),Ta(Sa,t)):Oa(ja),Ta(ja,n)}var Wa=l.unstable_runWithPriority,Ga=l.unstable_scheduleCallback,Ka=l.unstable_cancelCallback,$a=l.unstable_shouldYield,Qa=l.unstable_requestPaint,Ya=l.unstable_now,Xa=l.unstable_getCurrentPriorityLevel,Ja=l.unstable_ImmediatePriority,Za=l.unstable_UserBlockingPriority,er=l.unstable_NormalPriority,tr=l.unstable_LowPriority,nr=l.unstable_IdlePriority,ar={},rr=void 0!==Qa?Qa:function(){},lr=null,or=null,ir=!1,ur=Ya(),sr=1e4>ur?Ya:function(){return Ya()-ur};function cr(){switch(Xa()){case Ja:return 99;case Za:return 98;case er:return 97;case tr:return 96;case nr:return 95;default:throw o(Error(332))}}function dr(e){switch(e){case 99:return Ja;case 98:return Za;case 97:return er;case 96:return tr;case 95:return nr;default:throw o(Error(332))}}function pr(e,t){return e=dr(e),Wa(e,t)}function mr(e,t,n){return e=dr(e),Ga(e,t,n)}function fr(e){return null===lr?(lr=[e],or=Ga(Ja,vr)):lr.push(e),ar}function hr(){null!==or&&Ka(or),vr()}function vr(){if(!ir&&null!==lr){ir=!0;var e=0;try{var t=lr;pr(99,(function(){for(;e<t.length;e++){var n=t[e];do{n=n(!0)}while(null!==n)}})),lr=null}catch(t){throw null!==lr&&(lr=lr.slice(e+1)),Ga(Ja,hr),t}finally{ir=!1}}}function gr(e,t){return 1073741823===t?99:1===t?95:0>=(e=10*(1073741821-t)-10*(1073741821-e))?99:250>=e?98:5250>=e?97:95}function yr(e,t){if(e&&e.defaultProps)for(var n in t=r({},t),e=e.defaultProps)void 0===t[n]&&(t[n]=e[n]);return t}var br={current:null},Er=null,wr=null,zr=null;function _r(){zr=wr=Er=null}function xr(e,t){var n=e.type._context;Ta(br,n._currentValue),n._currentValue=t}function Cr(e){var t=br.current;Oa(br),e.type._context._currentValue=t}function Nr(e,t){for(;null!==e;){var n=e.alternate;if(e.childExpirationTime<t)e.childExpirationTime=t,null!==n&&n.childExpirationTime<t&&(n.childExpirationTime=t);else{if(!(null!==n&&n.childExpirationTime<t))break;n.childExpirationTime=t}e=e.return}}function qr(e,t){Er=e,zr=wr=null,null!==(e=e.dependencies)&&null!==e.firstContext&&(e.expirationTime>=t&&(co=!0),e.firstContext=null)}function Ir(e,t){if(zr!==e&&!1!==t&&0!==t)if("number"==typeof t&&1073741823!==t||(zr=e,t=1073741823),t={context:e,observedBits:t,next:null},null===wr){if(null===Er)throw o(Error(308));wr=t,Er.dependencies={expirationTime:0,firstContext:t,responders:null}}else wr=wr.next=t;return e._currentValue}var kr=!1;function Vr(e){return{baseState:e,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Or(e){return{baseState:e.baseState,firstUpdate:e.firstUpdate,lastUpdate:e.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Tr(e,t){return{expirationTime:e,suspenseConfig:t,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pr(e,t){null===e.lastUpdate?e.firstUpdate=e.lastUpdate=t:(e.lastUpdate.next=t,e.lastUpdate=t)}function Sr(e,t){var n=e.alternate;if(null===n){var a=e.updateQueue,r=null;null===a&&(a=e.updateQueue=Vr(e.memoizedState))}else a=e.updateQueue,r=n.updateQueue,null===a?null===r?(a=e.updateQueue=Vr(e.memoizedState),r=n.updateQueue=Vr(n.memoizedState)):a=e.updateQueue=Or(r):null===r&&(r=n.updateQueue=Or(a));null===r||a===r?Pr(a,t):null===a.lastUpdate||null===r.lastUpdate?(Pr(a,t),Pr(r,t)):(Pr(a,t),r.lastUpdate=t)}function jr(e,t){var n=e.updateQueue;null===(n=null===n?e.updateQueue=Vr(e.memoizedState):Fr(e,n)).lastCapturedUpdate?n.firstCapturedUpdate=n.lastCapturedUpdate=t:(n.lastCapturedUpdate.next=t,n.lastCapturedUpdate=t)}function Fr(e,t){var n=e.alternate;return null!==n&&t===n.updateQueue&&(t=e.updateQueue=Or(t)),t}function Br(e,t,n,a,l,o){switch(n.tag){case 1:return"function"==typeof(e=n.payload)?e.call(o,a,l):e;case 3:e.effectTag=-2049&e.effectTag|64;case 0:if(null==(l="function"==typeof(e=n.payload)?e.call(o,a,l):e))break;return r({},a,l);case 2:kr=!0}return a}function Mr(e,t,n,a,r){kr=!1;for(var l=(t=Fr(e,t)).baseState,o=null,i=0,u=t.firstUpdate,s=l;null!==u;){var c=u.expirationTime;c<r?(null===o&&(o=u,l=s),i<c&&(i=c)):(Di(c,u.suspenseConfig),s=Br(e,0,u,s,n,a),null!==u.callback&&(e.effectTag|=32,u.nextEffect=null,null===t.lastEffect?t.firstEffect=t.lastEffect=u:(t.lastEffect.nextEffect=u,t.lastEffect=u))),u=u.next}for(c=null,u=t.firstCapturedUpdate;null!==u;){var d=u.expirationTime;d<r?(null===c&&(c=u,null===o&&(l=s)),i<d&&(i=d)):(s=Br(e,0,u,s,n,a),null!==u.callback&&(e.effectTag|=32,u.nextEffect=null,null===t.lastCapturedEffect?t.firstCapturedEffect=t.lastCapturedEffect=u:(t.lastCapturedEffect.nextEffect=u,t.lastCapturedEffect=u))),u=u.next}null===o&&(t.lastUpdate=null),null===c?t.lastCapturedUpdate=null:e.effectTag|=32,null===o&&null===c&&(l=s),t.baseState=l,t.firstUpdate=o,t.firstCapturedUpdate=c,e.expirationTime=i,e.memoizedState=s}function Rr(e,t,n){null!==t.firstCapturedUpdate&&(null!==t.lastUpdate&&(t.lastUpdate.next=t.firstCapturedUpdate,t.lastUpdate=t.lastCapturedUpdate),t.firstCapturedUpdate=t.lastCapturedUpdate=null),Lr(t.firstEffect,n),t.firstEffect=t.lastEffect=null,Lr(t.firstCapturedEffect,n),t.firstCapturedEffect=t.lastCapturedEffect=null}function Lr(e,t){for(;null!==e;){var n=e.callback;if(null!==n){e.callback=null;var a=t;if("function"!=typeof n)throw o(Error(191),n);n.call(a)}e=e.nextEffect}}var Ar=Ge.ReactCurrentBatchConfig,Dr=(new a.Component).refs;function Ur(e,t,n,a){n=null==(n=n(a,t=e.memoizedState))?t:r({},t,n),e.memoizedState=n,null!==(a=e.updateQueue)&&0===e.expirationTime&&(a.baseState=n)}var Hr={isMounted:function(e){return!!(e=e._reactInternalFiber)&&2===ln(e)},enqueueSetState:function(e,t,n){e=e._reactInternalFiber;var a=ki(),r=Ar.suspense;(r=Tr(a=Vi(a,e,r),r)).payload=t,null!=n&&(r.callback=n),Sr(e,r),Ti(e,a)},enqueueReplaceState:function(e,t,n){e=e._reactInternalFiber;var a=ki(),r=Ar.suspense;(r=Tr(a=Vi(a,e,r),r)).tag=1,r.payload=t,null!=n&&(r.callback=n),Sr(e,r),Ti(e,a)},enqueueForceUpdate:function(e,t){e=e._reactInternalFiber;var n=ki(),a=Ar.suspense;(a=Tr(n=Vi(n,e,a),a)).tag=2,null!=t&&(a.callback=t),Sr(e,a),Ti(e,n)}};function Wr(e,t,n,a,r,l,o){return"function"==typeof(e=e.stateNode).shouldComponentUpdate?e.shouldComponentUpdate(a,l,o):!t.prototype||!t.prototype.isPureReactComponent||(!an(n,a)||!an(r,l))}function Gr(e,t,n){var a=!1,r=Pa,l=t.contextType;return"object"==typeof l&&null!==l?l=Ir(l):(r=Ma(t)?Fa:Sa.current,l=(a=null!=(a=t.contextTypes))?Ba(e,r):Pa),t=new t(n,l),e.memoizedState=null!==t.state&&void 0!==t.state?t.state:null,t.updater=Hr,e.stateNode=t,t._reactInternalFiber=e,a&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=r,e.__reactInternalMemoizedMaskedChildContext=l),t}function Kr(e,t,n,a){e=t.state,"function"==typeof t.componentWillReceiveProps&&t.componentWillReceiveProps(n,a),"function"==typeof t.UNSAFE_componentWillReceiveProps&&t.UNSAFE_componentWillReceiveProps(n,a),t.state!==e&&Hr.enqueueReplaceState(t,t.state,null)}function $r(e,t,n,a){var r=e.stateNode;r.props=n,r.state=e.memoizedState,r.refs=Dr;var l=t.contextType;"object"==typeof l&&null!==l?r.context=Ir(l):(l=Ma(t)?Fa:Sa.current,r.context=Ba(e,l)),null!==(l=e.updateQueue)&&(Mr(e,l,n,r,a),r.state=e.memoizedState),"function"==typeof(l=t.getDerivedStateFromProps)&&(Ur(e,t,l,n),r.state=e.memoizedState),"function"==typeof t.getDerivedStateFromProps||"function"==typeof r.getSnapshotBeforeUpdate||"function"!=typeof r.UNSAFE_componentWillMount&&"function"!=typeof r.componentWillMount||(t=r.state,"function"==typeof r.componentWillMount&&r.componentWillMount(),"function"==typeof r.UNSAFE_componentWillMount&&r.UNSAFE_componentWillMount(),t!==r.state&&Hr.enqueueReplaceState(r,r.state,null),null!==(l=e.updateQueue)&&(Mr(e,l,n,r,a),r.state=e.memoizedState)),"function"==typeof r.componentDidMount&&(e.effectTag|=4)}var Qr=Array.isArray;function Yr(e,t,n){if(null!==(e=n.ref)&&"function"!=typeof e&&"object"!=typeof e){if(n._owner){n=n._owner;var a=void 0;if(n){if(1!==n.tag)throw o(Error(309));a=n.stateNode}if(!a)throw o(Error(147),e);var r=""+e;return null!==t&&null!==t.ref&&"function"==typeof t.ref&&t.ref._stringRef===r?t.ref:((t=function(e){var t=a.refs;t===Dr&&(t=a.refs={}),null===e?delete t[r]:t[r]=e})._stringRef=r,t)}if("string"!=typeof e)throw o(Error(284));if(!n._owner)throw o(Error(290),e)}return e}function Xr(e,t){if("textarea"!==e.type)throw o(Error(31),"[object Object]"===Object.prototype.toString.call(t)?"object with keys {"+Object.keys(t).join(", ")+"}":t,"")}function Jr(e){function t(t,n){if(e){var a=t.lastEffect;null!==a?(a.nextEffect=n,t.lastEffect=n):t.firstEffect=t.lastEffect=n,n.nextEffect=null,n.effectTag=8}}function n(n,a){if(!e)return null;for(;null!==a;)t(n,a),a=a.sibling;return null}function a(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function r(e,t,n){return(e=lu(e,t)).index=0,e.sibling=null,e}function l(t,n,a){return t.index=a,e?null!==(a=t.alternate)?(a=a.index)<n?(t.effectTag=2,n):a:(t.effectTag=2,n):n}function i(t){return e&&null===t.alternate&&(t.effectTag=2),t}function u(e,t,n,a){return null===t||6!==t.tag?((t=uu(n,e.mode,a)).return=e,t):((t=r(t,n)).return=e,t)}function s(e,t,n,a){return null!==t&&t.elementType===n.type?((a=r(t,n.props)).ref=Yr(e,t,n),a.return=e,a):((a=ou(n.type,n.key,n.props,null,e.mode,a)).ref=Yr(e,t,n),a.return=e,a)}function c(e,t,n,a){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?((t=su(n,e.mode,a)).return=e,t):((t=r(t,n.children||[])).return=e,t)}function d(e,t,n,a,l){return null===t||7!==t.tag?((t=iu(n,e.mode,a,l)).return=e,t):((t=r(t,n)).return=e,t)}function p(e,t,n){if("string"==typeof t||"number"==typeof t)return(t=uu(""+t,e.mode,n)).return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case Qe:return(n=ou(t.type,t.key,t.props,null,e.mode,n)).ref=Yr(e,null,t),n.return=e,n;case Ye:return(t=su(t,e.mode,n)).return=e,t}if(Qr(t)||st(t))return(t=iu(t,e.mode,n,null)).return=e,t;Xr(e,t)}return null}function m(e,t,n,a){var r=null!==t?t.key:null;if("string"==typeof n||"number"==typeof n)return null!==r?null:u(e,t,""+n,a);if("object"==typeof n&&null!==n){switch(n.$$typeof){case Qe:return n.key===r?n.type===Xe?d(e,t,n.props.children,a,r):s(e,t,n,a):null;case Ye:return n.key===r?c(e,t,n,a):null}if(Qr(n)||st(n))return null!==r?null:d(e,t,n,a,null);Xr(e,n)}return null}function f(e,t,n,a,r){if("string"==typeof a||"number"==typeof a)return u(t,e=e.get(n)||null,""+a,r);if("object"==typeof a&&null!==a){switch(a.$$typeof){case Qe:return e=e.get(null===a.key?n:a.key)||null,a.type===Xe?d(t,e,a.props.children,r,a.key):s(t,e,a,r);case Ye:return c(t,e=e.get(null===a.key?n:a.key)||null,a,r)}if(Qr(a)||st(a))return d(t,e=e.get(n)||null,a,r,null);Xr(t,a)}return null}function h(r,o,i,u){for(var s=null,c=null,d=o,h=o=0,v=null;null!==d&&h<i.length;h++){d.index>h?(v=d,d=null):v=d.sibling;var g=m(r,d,i[h],u);if(null===g){null===d&&(d=v);break}e&&d&&null===g.alternate&&t(r,d),o=l(g,o,h),null===c?s=g:c.sibling=g,c=g,d=v}if(h===i.length)return n(r,d),s;if(null===d){for(;h<i.length;h++)null!==(d=p(r,i[h],u))&&(o=l(d,o,h),null===c?s=d:c.sibling=d,c=d);return s}for(d=a(r,d);h<i.length;h++)null!==(v=f(d,r,h,i[h],u))&&(e&&null!==v.alternate&&d.delete(null===v.key?h:v.key),o=l(v,o,h),null===c?s=v:c.sibling=v,c=v);return e&&d.forEach((function(e){return t(r,e)})),s}function v(r,i,u,s){var c=st(u);if("function"!=typeof c)throw o(Error(150));if(null==(u=c.call(u)))throw o(Error(151));for(var d=c=null,h=i,v=i=0,g=null,y=u.next();null!==h&&!y.done;v++,y=u.next()){h.index>v?(g=h,h=null):g=h.sibling;var b=m(r,h,y.value,s);if(null===b){null===h&&(h=g);break}e&&h&&null===b.alternate&&t(r,h),i=l(b,i,v),null===d?c=b:d.sibling=b,d=b,h=g}if(y.done)return n(r,h),c;if(null===h){for(;!y.done;v++,y=u.next())null!==(y=p(r,y.value,s))&&(i=l(y,i,v),null===d?c=y:d.sibling=y,d=y);return c}for(h=a(r,h);!y.done;v++,y=u.next())null!==(y=f(h,r,v,y.value,s))&&(e&&null!==y.alternate&&h.delete(null===y.key?v:y.key),i=l(y,i,v),null===d?c=y:d.sibling=y,d=y);return e&&h.forEach((function(e){return t(r,e)})),c}return function(e,a,l,u){var s="object"==typeof l&&null!==l&&l.type===Xe&&null===l.key;s&&(l=l.props.children);var c="object"==typeof l&&null!==l;if(c)switch(l.$$typeof){case Qe:e:{for(c=l.key,s=a;null!==s;){if(s.key===c){if(7===s.tag?l.type===Xe:s.elementType===l.type){n(e,s.sibling),(a=r(s,l.type===Xe?l.props.children:l.props)).ref=Yr(e,s,l),a.return=e,e=a;break e}n(e,s);break}t(e,s),s=s.sibling}l.type===Xe?((a=iu(l.props.children,e.mode,u,l.key)).return=e,e=a):((u=ou(l.type,l.key,l.props,null,e.mode,u)).ref=Yr(e,a,l),u.return=e,e=u)}return i(e);case Ye:e:{for(s=l.key;null!==a;){if(a.key===s){if(4===a.tag&&a.stateNode.containerInfo===l.containerInfo&&a.stateNode.implementation===l.implementation){n(e,a.sibling),(a=r(a,l.children||[])).return=e,e=a;break e}n(e,a);break}t(e,a),a=a.sibling}(a=su(l,e.mode,u)).return=e,e=a}return i(e)}if("string"==typeof l||"number"==typeof l)return l=""+l,null!==a&&6===a.tag?(n(e,a.sibling),(a=r(a,l)).return=e,e=a):(n(e,a),(a=uu(l,e.mode,u)).return=e,e=a),i(e);if(Qr(l))return h(e,a,l,u);if(st(l))return v(e,a,l,u);if(c&&Xr(e,l),void 0===l&&!s)switch(e.tag){case 1:case 0:throw e=e.type,o(Error(152),e.displayName||e.name||"Component")}return n(e,a)}}var Zr=Jr(!0),el=Jr(!1),tl={},nl={current:tl},al={current:tl},rl={current:tl};function ll(e){if(e===tl)throw o(Error(174));return e}function ol(e,t){Ta(rl,t),Ta(al,e),Ta(nl,tl);var n=t.nodeType;switch(n){case 9:case 11:t=(t=t.documentElement)?t.namespaceURI:sa(null,"");break;default:t=sa(t=(n=8===n?t.parentNode:t).namespaceURI||null,n=n.tagName)}Oa(nl),Ta(nl,t)}function il(e){Oa(nl),Oa(al),Oa(rl)}function ul(e){ll(rl.current);var t=ll(nl.current),n=sa(t,e.type);t!==n&&(Ta(al,e),Ta(nl,n))}function sl(e){al.current===e&&(Oa(nl),Oa(al))}var cl=1,dl=1,pl=2,ml={current:0};function fl(e){for(var t=e;null!==t;){if(13===t.tag){if(null!==t.memoizedState)return t}else if(19===t.tag&&void 0!==t.memoizedProps.revealOrder){if(0!=(64&t.effectTag))return t}else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}return null}var hl=0,vl=2,gl=4,yl=8,bl=16,El=32,wl=64,zl=128,_l=Ge.ReactCurrentDispatcher,xl=0,Cl=null,Nl=null,ql=null,Il=null,kl=null,Vl=null,Ol=0,Tl=null,Pl=0,Sl=!1,jl=null,Fl=0;function Bl(){throw o(Error(321))}function Ml(e,t){if(null===t)return!1;for(var n=0;n<t.length&&n<e.length;n++)if(!tn(e[n],t[n]))return!1;return!0}function Rl(e,t,n,a,r,l){if(xl=l,Cl=t,ql=null!==e?e.memoizedState:null,_l.current=null===ql?Jl:Zl,t=n(a,r),Sl){do{Sl=!1,Fl+=1,ql=null!==e?e.memoizedState:null,Vl=Il,Tl=kl=Nl=null,_l.current=Zl,t=n(a,r)}while(Sl);jl=null,Fl=0}if(_l.current=Xl,(e=Cl).memoizedState=Il,e.expirationTime=Ol,e.updateQueue=Tl,e.effectTag|=Pl,e=null!==Nl&&null!==Nl.next,xl=0,Vl=kl=Il=ql=Nl=Cl=null,Ol=0,Tl=null,Pl=0,e)throw o(Error(300));return t}function Ll(){_l.current=Xl,xl=0,Vl=kl=Il=ql=Nl=Cl=null,Ol=0,Tl=null,Pl=0,Sl=!1,jl=null,Fl=0}function Al(){var e={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};return null===kl?Il=kl=e:kl=kl.next=e,kl}function Dl(){if(null!==Vl)Vl=(kl=Vl).next,ql=null!==(Nl=ql)?Nl.next:null;else{if(null===ql)throw o(Error(310));var e={memoizedState:(Nl=ql).memoizedState,baseState:Nl.baseState,queue:Nl.queue,baseUpdate:Nl.baseUpdate,next:null};kl=null===kl?Il=e:kl.next=e,ql=Nl.next}return kl}function Ul(e,t){return"function"==typeof t?t(e):t}function Hl(e){var t=Dl(),n=t.queue;if(null===n)throw o(Error(311));if(n.lastRenderedReducer=e,0<Fl){var a=n.dispatch;if(null!==jl){var r=jl.get(n);if(void 0!==r){jl.delete(n);var l=t.memoizedState;do{l=e(l,r.action),r=r.next}while(null!==r);return tn(l,t.memoizedState)||(co=!0),t.memoizedState=l,t.baseUpdate===n.last&&(t.baseState=l),n.lastRenderedState=l,[l,a]}}return[t.memoizedState,a]}a=n.last;var i=t.baseUpdate;if(l=t.baseState,null!==i?(null!==a&&(a.next=null),a=i.next):a=null!==a?a.next:null,null!==a){var u=r=null,s=a,c=!1;do{var d=s.expirationTime;d<xl?(c||(c=!0,u=i,r=l),d>Ol&&(Ol=d)):(Di(d,s.suspenseConfig),l=s.eagerReducer===e?s.eagerState:e(l,s.action)),i=s,s=s.next}while(null!==s&&s!==a);c||(u=i,r=l),tn(l,t.memoizedState)||(co=!0),t.memoizedState=l,t.baseUpdate=u,t.baseState=r,n.lastRenderedState=l}return[t.memoizedState,n.dispatch]}function Wl(e,t,n,a){return e={tag:e,create:t,destroy:n,deps:a,next:null},null===Tl?(Tl={lastEffect:null}).lastEffect=e.next=e:null===(t=Tl.lastEffect)?Tl.lastEffect=e.next=e:(n=t.next,t.next=e,e.next=n,Tl.lastEffect=e),e}function Gl(e,t,n,a){var r=Al();Pl|=e,r.memoizedState=Wl(t,n,void 0,void 0===a?null:a)}function Kl(e,t,n,a){var r=Dl();a=void 0===a?null:a;var l=void 0;if(null!==Nl){var o=Nl.memoizedState;if(l=o.destroy,null!==a&&Ml(a,o.deps))return void Wl(hl,n,l,a)}Pl|=e,r.memoizedState=Wl(t,n,l,a)}function $l(e,t){return"function"==typeof t?(e=e(),t(e),function(){t(null)}):null!=t?(e=e(),t.current=e,function(){t.current=null}):void 0}function Ql(){}function Yl(e,t,n){if(!(25>Fl))throw o(Error(301));var a=e.alternate;if(e===Cl||null!==a&&a===Cl)if(Sl=!0,e={expirationTime:xl,suspenseConfig:null,action:n,eagerReducer:null,eagerState:null,next:null},null===jl&&(jl=new Map),void 0===(n=jl.get(t)))jl.set(t,e);else{for(t=n;null!==t.next;)t=t.next;t.next=e}else{var r=ki(),l=Ar.suspense;l={expirationTime:r=Vi(r,e,l),suspenseConfig:l,action:n,eagerReducer:null,eagerState:null,next:null};var i=t.last;if(null===i)l.next=l;else{var u=i.next;null!==u&&(l.next=u),i.next=l}if(t.last=l,0===e.expirationTime&&(null===a||0===a.expirationTime)&&null!==(a=t.lastRenderedReducer))try{var s=t.lastRenderedState,c=a(s,n);if(l.eagerReducer=a,l.eagerState=c,tn(c,s))return}catch(e){}Ti(e,r)}}var Xl={readContext:Ir,useCallback:Bl,useContext:Bl,useEffect:Bl,useImperativeHandle:Bl,useLayoutEffect:Bl,useMemo:Bl,useReducer:Bl,useRef:Bl,useState:Bl,useDebugValue:Bl,useResponder:Bl},Jl={readContext:Ir,useCallback:function(e,t){return Al().memoizedState=[e,void 0===t?null:t],e},useContext:Ir,useEffect:function(e,t){return Gl(516,zl|wl,e,t)},useImperativeHandle:function(e,t,n){return n=null!=n?n.concat([e]):null,Gl(4,gl|El,$l.bind(null,t,e),n)},useLayoutEffect:function(e,t){return Gl(4,gl|El,e,t)},useMemo:function(e,t){var n=Al();return t=void 0===t?null:t,e=e(),n.memoizedState=[e,t],e},useReducer:function(e,t,n){var a=Al();return t=void 0!==n?n(t):t,a.memoizedState=a.baseState=t,e=(e=a.queue={last:null,dispatch:null,lastRenderedReducer:e,lastRenderedState:t}).dispatch=Yl.bind(null,Cl,e),[a.memoizedState,e]},useRef:function(e){return e={current:e},Al().memoizedState=e},useState:function(e){var t=Al();return"function"==typeof e&&(e=e()),t.memoizedState=t.baseState=e,e=(e=t.queue={last:null,dispatch:null,lastRenderedReducer:Ul,lastRenderedState:e}).dispatch=Yl.bind(null,Cl,e),[t.memoizedState,e]},useDebugValue:Ql,useResponder:rn},Zl={readContext:Ir,useCallback:function(e,t){var n=Dl();t=void 0===t?null:t;var a=n.memoizedState;return null!==a&&null!==t&&Ml(t,a[1])?a[0]:(n.memoizedState=[e,t],e)},useContext:Ir,useEffect:function(e,t){return Kl(516,zl|wl,e,t)},useImperativeHandle:function(e,t,n){return n=null!=n?n.concat([e]):null,Kl(4,gl|El,$l.bind(null,t,e),n)},useLayoutEffect:function(e,t){return Kl(4,gl|El,e,t)},useMemo:function(e,t){var n=Dl();t=void 0===t?null:t;var a=n.memoizedState;return null!==a&&null!==t&&Ml(t,a[1])?a[0]:(e=e(),n.memoizedState=[e,t],e)},useReducer:Hl,useRef:function(){return Dl().memoizedState},useState:function(e){return Hl(Ul)},useDebugValue:Ql,useResponder:rn},eo=null,to=null,no=!1;function ao(e,t){var n=au(5,null,null,0);n.elementType="DELETED",n.type="DELETED",n.stateNode=t,n.return=e,n.effectTag=8,null!==e.lastEffect?(e.lastEffect.nextEffect=n,e.lastEffect=n):e.firstEffect=e.lastEffect=n}function ro(e,t){switch(e.tag){case 5:var n=e.type;return null!==(t=1!==t.nodeType||n.toLowerCase()!==t.nodeName.toLowerCase()?null:t)&&(e.stateNode=t,!0);case 6:return null!==(t=""===e.pendingProps||3!==t.nodeType?null:t)&&(e.stateNode=t,!0);case 13:default:return!1}}function lo(e){if(no){var t=to;if(t){var n=t;if(!ro(e,t)){if(!(t=Ia(n.nextSibling))||!ro(e,t))return e.effectTag|=2,no=!1,void(eo=e);ao(eo,n)}eo=e,to=Ia(t.firstChild)}else e.effectTag|=2,no=!1,eo=e}}function oo(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag&&18!==e.tag;)e=e.return;eo=e}function io(e){if(e!==eo)return!1;if(!no)return oo(e),no=!0,!1;var t=e.type;if(5!==e.tag||"head"!==t&&"body"!==t&&!Ca(t,e.memoizedProps))for(t=to;t;)ao(e,t),t=Ia(t.nextSibling);return oo(e),to=eo?Ia(e.stateNode.nextSibling):null,!0}function uo(){to=eo=null,no=!1}var so=Ge.ReactCurrentOwner,co=!1;function po(e,t,n,a){t.child=null===e?el(t,null,n,a):Zr(t,e.child,n,a)}function mo(e,t,n,a,r){n=n.render;var l=t.ref;return qr(t,r),a=Rl(e,t,n,a,l,r),null===e||co?(t.effectTag|=1,po(e,t,a,r),t.child):(t.updateQueue=e.updateQueue,t.effectTag&=-517,e.expirationTime<=r&&(e.expirationTime=0),Co(e,t,r))}function fo(e,t,n,a,r,l){if(null===e){var o=n.type;return"function"!=typeof o||ru(o)||void 0!==o.defaultProps||null!==n.compare||void 0!==n.defaultProps?((e=ou(n.type,null,a,null,t.mode,l)).ref=t.ref,e.return=t,t.child=e):(t.tag=15,t.type=o,ho(e,t,o,a,r,l))}return o=e.child,r<l&&(r=o.memoizedProps,(n=null!==(n=n.compare)?n:an)(r,a)&&e.ref===t.ref)?Co(e,t,l):(t.effectTag|=1,(e=lu(o,a)).ref=t.ref,e.return=t,t.child=e)}function ho(e,t,n,a,r,l){return null!==e&&an(e.memoizedProps,a)&&e.ref===t.ref&&(co=!1,r<l)?Co(e,t,l):go(e,t,n,a,l)}function vo(e,t){var n=t.ref;(null===e&&null!==n||null!==e&&e.ref!==n)&&(t.effectTag|=128)}function go(e,t,n,a,r){var l=Ma(n)?Fa:Sa.current;return l=Ba(t,l),qr(t,r),n=Rl(e,t,n,a,l,r),null===e||co?(t.effectTag|=1,po(e,t,n,r),t.child):(t.updateQueue=e.updateQueue,t.effectTag&=-517,e.expirationTime<=r&&(e.expirationTime=0),Co(e,t,r))}function yo(e,t,n,a,r){if(Ma(n)){var l=!0;Ua(t)}else l=!1;if(qr(t,r),null===t.stateNode)null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),Gr(t,n,a),$r(t,n,a,r),a=!0;else if(null===e){var o=t.stateNode,i=t.memoizedProps;o.props=i;var u=o.context,s=n.contextType;"object"==typeof s&&null!==s?s=Ir(s):s=Ba(t,s=Ma(n)?Fa:Sa.current);var c=n.getDerivedStateFromProps,d="function"==typeof c||"function"==typeof o.getSnapshotBeforeUpdate;d||"function"!=typeof o.UNSAFE_componentWillReceiveProps&&"function"!=typeof o.componentWillReceiveProps||(i!==a||u!==s)&&Kr(t,o,a,s),kr=!1;var p=t.memoizedState;u=o.state=p;var m=t.updateQueue;null!==m&&(Mr(t,m,a,o,r),u=t.memoizedState),i!==a||p!==u||ja.current||kr?("function"==typeof c&&(Ur(t,n,c,a),u=t.memoizedState),(i=kr||Wr(t,n,i,a,p,u,s))?(d||"function"!=typeof o.UNSAFE_componentWillMount&&"function"!=typeof o.componentWillMount||("function"==typeof o.componentWillMount&&o.componentWillMount(),"function"==typeof o.UNSAFE_componentWillMount&&o.UNSAFE_componentWillMount()),"function"==typeof o.componentDidMount&&(t.effectTag|=4)):("function"==typeof o.componentDidMount&&(t.effectTag|=4),t.memoizedProps=a,t.memoizedState=u),o.props=a,o.state=u,o.context=s,a=i):("function"==typeof o.componentDidMount&&(t.effectTag|=4),a=!1)}else o=t.stateNode,i=t.memoizedProps,o.props=t.type===t.elementType?i:yr(t.type,i),u=o.context,"object"==typeof(s=n.contextType)&&null!==s?s=Ir(s):s=Ba(t,s=Ma(n)?Fa:Sa.current),(d="function"==typeof(c=n.getDerivedStateFromProps)||"function"==typeof o.getSnapshotBeforeUpdate)||"function"!=typeof o.UNSAFE_componentWillReceiveProps&&"function"!=typeof o.componentWillReceiveProps||(i!==a||u!==s)&&Kr(t,o,a,s),kr=!1,u=t.memoizedState,p=o.state=u,null!==(m=t.updateQueue)&&(Mr(t,m,a,o,r),p=t.memoizedState),i!==a||u!==p||ja.current||kr?("function"==typeof c&&(Ur(t,n,c,a),p=t.memoizedState),(c=kr||Wr(t,n,i,a,u,p,s))?(d||"function"!=typeof o.UNSAFE_componentWillUpdate&&"function"!=typeof o.componentWillUpdate||("function"==typeof o.componentWillUpdate&&o.componentWillUpdate(a,p,s),"function"==typeof o.UNSAFE_componentWillUpdate&&o.UNSAFE_componentWillUpdate(a,p,s)),"function"==typeof o.componentDidUpdate&&(t.effectTag|=4),"function"==typeof o.getSnapshotBeforeUpdate&&(t.effectTag|=256)):("function"!=typeof o.componentDidUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=4),"function"!=typeof o.getSnapshotBeforeUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=256),t.memoizedProps=a,t.memoizedState=p),o.props=a,o.state=p,o.context=s,a=c):("function"!=typeof o.componentDidUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=4),"function"!=typeof o.getSnapshotBeforeUpdate||i===e.memoizedProps&&u===e.memoizedState||(t.effectTag|=256),a=!1);return bo(e,t,n,a,l,r)}function bo(e,t,n,a,r,l){vo(e,t);var o=0!=(64&t.effectTag);if(!a&&!o)return r&&Ha(t,n,!1),Co(e,t,l);a=t.stateNode,so.current=t;var i=o&&"function"!=typeof n.getDerivedStateFromError?null:a.render();return t.effectTag|=1,null!==e&&o?(t.child=Zr(t,e.child,null,l),t.child=Zr(t,null,i,l)):po(e,t,i,l),t.memoizedState=a.state,r&&Ha(t,n,!0),t.child}function Eo(e){var t=e.stateNode;t.pendingContext?Aa(0,t.pendingContext,t.pendingContext!==t.context):t.context&&Aa(0,t.context,!1),ol(e,t.containerInfo)}var wo={};function zo(e,t,n){var a,r=t.mode,l=t.pendingProps,o=ml.current,i=null,u=!1;if((a=0!=(64&t.effectTag))||(a=0!=(o&pl)&&(null===e||null!==e.memoizedState)),a?(i=wo,u=!0,t.effectTag&=-65):null!==e&&null===e.memoizedState||void 0===l.fallback||!0===l.unstable_avoidThisFallback||(o|=dl),Ta(ml,o&=cl),null===e)if(u){if(l=l.fallback,(e=iu(null,r,0,null)).return=t,0==(2&t.mode))for(u=null!==t.memoizedState?t.child.child:t.child,e.child=u;null!==u;)u.return=e,u=u.sibling;(n=iu(l,r,n,null)).return=t,e.sibling=n,r=e}else r=n=el(t,null,l.children,n);else{if(null!==e.memoizedState)if(r=(o=e.child).sibling,u){if(l=l.fallback,(n=lu(o,o.pendingProps)).return=t,0==(2&t.mode)&&(u=null!==t.memoizedState?t.child.child:t.child)!==o.child)for(n.child=u;null!==u;)u.return=n,u=u.sibling;(l=lu(r,l,r.expirationTime)).return=t,n.sibling=l,r=n,n.childExpirationTime=0,n=l}else r=n=Zr(t,o.child,l.children,n);else if(o=e.child,u){if(u=l.fallback,(l=iu(null,r,0,null)).return=t,l.child=o,null!==o&&(o.return=l),0==(2&t.mode))for(o=null!==t.memoizedState?t.child.child:t.child,l.child=o;null!==o;)o.return=l,o=o.sibling;(n=iu(u,r,n,null)).return=t,l.sibling=n,n.effectTag|=2,r=l,l.childExpirationTime=0}else n=r=Zr(t,o,l.children,n);t.stateNode=e.stateNode}return t.memoizedState=i,t.child=r,n}function _o(e,t,n,a,r){var l=e.memoizedState;null===l?e.memoizedState={isBackwards:t,rendering:null,last:a,tail:n,tailExpiration:0,tailMode:r}:(l.isBackwards=t,l.rendering=null,l.last=a,l.tail=n,l.tailExpiration=0,l.tailMode=r)}function xo(e,t,n){var a=t.pendingProps,r=a.revealOrder,l=a.tail;if(po(e,t,a.children,n),0!=((a=ml.current)&pl))a=a&cl|pl,t.effectTag|=64;else{if(null!==e&&0!=(64&e.effectTag))e:for(e=t.child;null!==e;){if(13===e.tag){if(null!==e.memoizedState){e.expirationTime<n&&(e.expirationTime=n);var o=e.alternate;null!==o&&o.expirationTime<n&&(o.expirationTime=n),Nr(e.return,n)}}else if(null!==e.child){e.child.return=e,e=e.child;continue}if(e===t)break e;for(;null===e.sibling;){if(null===e.return||e.return===t)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}a&=cl}if(Ta(ml,a),0==(2&t.mode))t.memoizedState=null;else switch(r){case"forwards":for(n=t.child,r=null;null!==n;)null!==(a=n.alternate)&&null===fl(a)&&(r=n),n=n.sibling;null===(n=r)?(r=t.child,t.child=null):(r=n.sibling,n.sibling=null),_o(t,!1,r,n,l);break;case"backwards":for(n=null,r=t.child,t.child=null;null!==r;){if(null!==(a=r.alternate)&&null===fl(a)){t.child=r;break}a=r.sibling,r.sibling=n,n=r,r=a}_o(t,!0,n,null,l);break;case"together":_o(t,!1,null,null,void 0);break;default:t.memoizedState=null}return t.child}function Co(e,t,n){if(null!==e&&(t.dependencies=e.dependencies),t.childExpirationTime<n)return null;if(null!==e&&t.child!==e.child)throw o(Error(153));if(null!==t.child){for(n=lu(e=t.child,e.pendingProps,e.expirationTime),t.child=n,n.return=t;null!==e.sibling;)e=e.sibling,(n=n.sibling=lu(e,e.pendingProps,e.expirationTime)).return=t;n.sibling=null}return t.child}function No(e){e.effectTag|=4}var qo=void 0,Io=void 0,ko=void 0,Vo=void 0;function Oo(e,t){switch(e.tailMode){case"hidden":t=e.tail;for(var n=null;null!==t;)null!==t.alternate&&(n=t),t=t.sibling;null===n?e.tail=null:n.sibling=null;break;case"collapsed":n=e.tail;for(var a=null;null!==n;)null!==n.alternate&&(a=n),n=n.sibling;null===a?t||null===e.tail?e.tail=null:e.tail.sibling=null:a.sibling=null}}function To(e){switch(e.tag){case 1:Ma(e.type)&&Ra();var t=e.effectTag;return 2048&t?(e.effectTag=-2049&t|64,e):null;case 3:if(il(),La(),0!=(64&(t=e.effectTag)))throw o(Error(285));return e.effectTag=-2049&t|64,e;case 5:return sl(e),null;case 13:return Oa(ml),2048&(t=e.effectTag)?(e.effectTag=-2049&t|64,e):null;case 18:return null;case 19:return Oa(ml),null;case 4:return il(),null;case 10:return Cr(e),null;default:return null}}function Po(e,t){return{value:e,source:t,stack:dt(t)}}qo=function(e,t){for(var n=t.child;null!==n;){if(5===n.tag||6===n.tag)e.appendChild(n.stateNode);else if(20===n.tag)e.appendChild(n.stateNode.instance);else if(4!==n.tag&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===t)break;for(;null===n.sibling;){if(null===n.return||n.return===t)return;n=n.return}n.sibling.return=n.return,n=n.sibling}},Io=function(){},ko=function(e,t,n,a,l){var o=e.memoizedProps;if(o!==a){var i=t.stateNode;switch(ll(nl.current),e=null,n){case"input":o=zt(i,o),a=zt(i,a),e=[];break;case"option":o=ta(i,o),a=ta(i,a),e=[];break;case"select":o=r({},o,{value:void 0}),a=r({},a,{value:void 0}),e=[];break;case"textarea":o=aa(i,o),a=aa(i,a),e=[];break;default:"function"!=typeof o.onClick&&"function"==typeof a.onClick&&(i.onclick=wa)}ya(n,a),i=n=void 0;var u=null;for(n in o)if(!a.hasOwnProperty(n)&&o.hasOwnProperty(n)&&null!=o[n])if("style"===n){var s=o[n];for(i in s)s.hasOwnProperty(i)&&(u||(u={}),u[i]="")}else"dangerouslySetInnerHTML"!==n&&"children"!==n&&"suppressContentEditableWarning"!==n&&"suppressHydrationWarning"!==n&&"autoFocus"!==n&&(m.hasOwnProperty(n)?e||(e=[]):(e=e||[]).push(n,null));for(n in a){var c=a[n];if(s=null!=o?o[n]:void 0,a.hasOwnProperty(n)&&c!==s&&(null!=c||null!=s))if("style"===n)if(s){for(i in s)!s.hasOwnProperty(i)||c&&c.hasOwnProperty(i)||(u||(u={}),u[i]="");for(i in c)c.hasOwnProperty(i)&&s[i]!==c[i]&&(u||(u={}),u[i]=c[i])}else u||(e||(e=[]),e.push(n,u)),u=c;else"dangerouslySetInnerHTML"===n?(c=c?c.__html:void 0,s=s?s.__html:void 0,null!=c&&s!==c&&(e=e||[]).push(n,""+c)):"children"===n?s===c||"string"!=typeof c&&"number"!=typeof c||(e=e||[]).push(n,""+c):"suppressContentEditableWarning"!==n&&"suppressHydrationWarning"!==n&&(m.hasOwnProperty(n)?(null!=c&&Ea(l,n),e||s===c||(e=[])):(e=e||[]).push(n,c))}u&&(e=e||[]).push("style",u),l=e,(t.updateQueue=l)&&No(t)}},Vo=function(e,t,n,a){n!==a&&No(t)};var So="function"==typeof WeakSet?WeakSet:Set;function jo(e,t){var n=t.source,a=t.stack;null===a&&null!==n&&(a=dt(n)),null!==n&&ct(n.type),t=t.value,null!==e&&1===e.tag&&ct(e.type);try{console.error(t)}catch(e){setTimeout((function(){throw e}))}}function Fo(e){var t=e.ref;if(null!==t)if("function"==typeof t)try{t(null)}catch(t){Yi(e,t)}else t.current=null}function Bo(e,t,n){if(null!==(n=null!==(n=n.updateQueue)?n.lastEffect:null)){var a=n=n.next;do{if((a.tag&e)!==hl){var r=a.destroy;a.destroy=void 0,void 0!==r&&r()}(a.tag&t)!==hl&&(r=a.create,a.destroy=r()),a=a.next}while(a!==n)}}function Mo(e,t){switch("function"==typeof tu&&tu(e),e.tag){case 0:case 11:case 14:case 15:var n=e.updateQueue;if(null!==n&&null!==(n=n.lastEffect)){var a=n.next;pr(97<t?97:t,(function(){var t=a;do{var n=t.destroy;if(void 0!==n){var r=e;try{n()}catch(e){Yi(r,e)}}t=t.next}while(t!==a)}))}break;case 1:Fo(e),"function"==typeof(t=e.stateNode).componentWillUnmount&&function(e,t){try{t.props=e.memoizedProps,t.state=e.memoizedState,t.componentWillUnmount()}catch(t){Yi(e,t)}}(e,t);break;case 5:Fo(e);break;case 4:Do(e,t)}}function Ro(e,t){for(var n=e;;)if(Mo(n,t),null!==n.child&&4!==n.tag)n.child.return=n,n=n.child;else{if(n===e)break;for(;null===n.sibling;){if(null===n.return||n.return===e)return;n=n.return}n.sibling.return=n.return,n=n.sibling}}function Lo(e){return 5===e.tag||3===e.tag||4===e.tag}function Ao(e){e:{for(var t=e.return;null!==t;){if(Lo(t)){var n=t;break e}t=t.return}throw o(Error(160))}switch(t=n.stateNode,n.tag){case 5:var a=!1;break;case 3:case 4:t=t.containerInfo,a=!0;break;default:throw o(Error(161))}16&n.effectTag&&(pa(t,""),n.effectTag&=-17);e:t:for(n=e;;){for(;null===n.sibling;){if(null===n.return||Lo(n.return)){n=null;break e}n=n.return}for(n.sibling.return=n.return,n=n.sibling;5!==n.tag&&6!==n.tag&&18!==n.tag;){if(2&n.effectTag)continue t;if(null===n.child||4===n.tag)continue t;n.child.return=n,n=n.child}if(!(2&n.effectTag)){n=n.stateNode;break e}}for(var r=e;;){var l=5===r.tag||6===r.tag;if(l||20===r.tag){var i=l?r.stateNode:r.stateNode.instance;if(n)if(a){var u=i;i=n,8===(l=t).nodeType?l.parentNode.insertBefore(u,i):l.insertBefore(u,i)}else t.insertBefore(i,n);else a?(8===(u=t).nodeType?(l=u.parentNode).insertBefore(i,u):(l=u).appendChild(i),null!=(u=u._reactRootContainer)||null!==l.onclick||(l.onclick=wa)):t.appendChild(i)}else if(4!==r.tag&&null!==r.child){r.child.return=r,r=r.child;continue}if(r===e)break;for(;null===r.sibling;){if(null===r.return||r.return===e)return;r=r.return}r.sibling.return=r.return,r=r.sibling}}function Do(e,t){for(var n=e,a=!1,r=void 0,l=void 0;;){if(!a){a=n.return;e:for(;;){if(null===a)throw o(Error(160));switch(r=a.stateNode,a.tag){case 5:l=!1;break e;case 3:case 4:r=r.containerInfo,l=!0;break e}a=a.return}a=!0}if(5===n.tag||6===n.tag)if(Ro(n,t),l){var i=r,u=n.stateNode;8===i.nodeType?i.parentNode.removeChild(u):i.removeChild(u)}else r.removeChild(n.stateNode);else if(20===n.tag)u=n.stateNode.instance,Ro(n,t),l?8===(i=r).nodeType?i.parentNode.removeChild(u):i.removeChild(u):r.removeChild(u);else if(4===n.tag){if(null!==n.child){r=n.stateNode.containerInfo,l=!0,n.child.return=n,n=n.child;continue}}else if(Mo(n,t),null!==n.child){n.child.return=n,n=n.child;continue}if(n===e)break;for(;null===n.sibling;){if(null===n.return||n.return===e)return;4===(n=n.return).tag&&(a=!1)}n.sibling.return=n.return,n=n.sibling}}function Uo(e,t){switch(t.tag){case 0:case 11:case 14:case 15:Bo(gl,yl,t);break;case 1:break;case 5:var n=t.stateNode;if(null!=n){var a=t.memoizedProps,r=null!==e?e.memoizedProps:a;e=t.type;var l=t.updateQueue;if(t.updateQueue=null,null!==l){for(n[j]=a,"input"===e&&"radio"===a.type&&null!=a.name&&xt(n,a),ba(e,r),t=ba(e,a),r=0;r<l.length;r+=2){var i=l[r],u=l[r+1];"style"===i?va(n,u):"dangerouslySetInnerHTML"===i?da(n,u):"children"===i?pa(n,u):Et(n,i,u,t)}switch(e){case"input":Ct(n,a);break;case"textarea":la(n,a);break;case"select":t=n._wrapperState.wasMultiple,n._wrapperState.wasMultiple=!!a.multiple,null!=(e=a.value)?na(n,!!a.multiple,e,!1):t!==!!a.multiple&&(null!=a.defaultValue?na(n,!!a.multiple,a.defaultValue,!0):na(n,!!a.multiple,a.multiple?[]:"",!1))}}}break;case 6:if(null===t.stateNode)throw o(Error(162));t.stateNode.nodeValue=t.memoizedProps;break;case 3:case 12:break;case 13:if(n=t,null===t.memoizedState?a=!1:(a=!0,n=t.child,hi=sr()),null!==n)e:for(e=n;;){if(5===e.tag)l=e.stateNode,a?"function"==typeof(l=l.style).setProperty?l.setProperty("display","none","important"):l.display="none":(l=e.stateNode,r=null!=(r=e.memoizedProps.style)&&r.hasOwnProperty("display")?r.display:null,l.style.display=ha("display",r));else if(6===e.tag)e.stateNode.nodeValue=a?"":e.memoizedProps;else{if(13===e.tag&&null!==e.memoizedState){(l=e.child.sibling).return=e,e=l;continue}if(null!==e.child){e.child.return=e,e=e.child;continue}}if(e===n)break e;for(;null===e.sibling;){if(null===e.return||e.return===n)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}Ho(t);break;case 19:Ho(t);break;case 17:case 20:break;default:throw o(Error(163))}}function Ho(e){var t=e.updateQueue;if(null!==t){e.updateQueue=null;var n=e.stateNode;null===n&&(n=e.stateNode=new So),t.forEach((function(t){var a=Ji.bind(null,e,t);n.has(t)||(n.add(t),t.then(a,a))}))}}var Wo="function"==typeof WeakMap?WeakMap:Map;function Go(e,t,n){(n=Tr(n,null)).tag=3,n.payload={element:null};var a=t.value;return n.callback=function(){yi||(yi=!0,bi=a),jo(e,t)},n}function Ko(e,t,n){(n=Tr(n,null)).tag=3;var a=e.type.getDerivedStateFromError;if("function"==typeof a){var r=t.value;n.payload=function(){return jo(e,t),a(r)}}var l=e.stateNode;return null!==l&&"function"==typeof l.componentDidCatch&&(n.callback=function(){"function"!=typeof a&&(null===Ei?Ei=new Set([this]):Ei.add(this),jo(e,t));var n=t.stack;this.componentDidCatch(t.value,{componentStack:null!==n?n:""})}),n}var $o=Math.ceil,Qo=Ge.ReactCurrentDispatcher,Yo=Ge.ReactCurrentOwner,Xo=0,Jo=8,Zo=16,ei=32,ti=0,ni=1,ai=2,ri=3,li=4,oi=Xo,ii=null,ui=null,si=0,ci=ti,di=1073741823,pi=1073741823,mi=null,fi=!1,hi=0,vi=500,gi=null,yi=!1,bi=null,Ei=null,wi=!1,zi=null,_i=90,xi=0,Ci=null,Ni=0,qi=null,Ii=0;function ki(){return(oi&(Zo|ei))!==Xo?1073741821-(sr()/10|0):0!==Ii?Ii:Ii=1073741821-(sr()/10|0)}function Vi(e,t,n){if(0==(2&(t=t.mode)))return 1073741823;var a=cr();if(0==(4&t))return 99===a?1073741823:1073741822;if((oi&Zo)!==Xo)return si;if(null!==n)e=1073741821-25*(1+((1073741821-e+(0|n.timeoutMs||5e3)/10)/25|0));else switch(a){case 99:e=1073741823;break;case 98:e=1073741821-10*(1+((1073741821-e+15)/10|0));break;case 97:case 96:e=1073741821-25*(1+((1073741821-e+500)/25|0));break;case 95:e=1;break;default:throw o(Error(326))}return null!==ii&&e===si&&--e,e}var Oi=0;function Ti(e,t){if(50<Ni)throw Ni=0,qi=null,o(Error(185));if(null!==(e=Pi(e,t))){e.pingTime=0;var n=cr();if(1073741823===t)if((oi&Jo)!==Xo&&(oi&(Zo|ei))===Xo)for(var a=Ai(e,1073741823,!0);null!==a;)a=a(!0);else Si(e,99,1073741823),oi===Xo&&hr();else Si(e,n,t);(4&oi)===Xo||98!==n&&99!==n||(null===Ci?Ci=new Map([[e,t]]):(void 0===(n=Ci.get(e))||n>t)&&Ci.set(e,t))}}function Pi(e,t){e.expirationTime<t&&(e.expirationTime=t);var n=e.alternate;null!==n&&n.expirationTime<t&&(n.expirationTime=t);var a=e.return,r=null;if(null===a&&3===e.tag)r=e.stateNode;else for(;null!==a;){if(n=a.alternate,a.childExpirationTime<t&&(a.childExpirationTime=t),null!==n&&n.childExpirationTime<t&&(n.childExpirationTime=t),null===a.return&&3===a.tag){r=a.stateNode;break}a=a.return}return null!==r&&(t>r.firstPendingTime&&(r.firstPendingTime=t),0===(e=r.lastPendingTime)||t<e)&&(r.lastPendingTime=t),r}function Si(e,t,n){if(e.callbackExpirationTime<n){var a=e.callbackNode;null!==a&&a!==ar&&Ka(a),e.callbackExpirationTime=n,1073741823===n?e.callbackNode=fr(ji.bind(null,e,Ai.bind(null,e,n))):(a=null,1!==n&&(a={timeout:10*(1073741821-n)-sr()}),e.callbackNode=mr(t,ji.bind(null,e,Ai.bind(null,e,n)),a))}}function ji(e,t,n){var a=e.callbackNode,r=null;try{return null!==(r=t(n))?ji.bind(null,e,r):null}finally{null===r&&a===e.callbackNode&&(e.callbackNode=null,e.callbackExpirationTime=0)}}function Fi(){(oi&(1|Zo|ei))===Xo&&(function(){if(null!==Ci){var e=Ci;Ci=null,e.forEach((function(e,t){fr(Ai.bind(null,t,e))})),hr()}}(),Ki())}function Bi(e,t){var n=oi;oi|=1;try{return e(t)}finally{(oi=n)===Xo&&hr()}}function Mi(e,t,n,a){var r=oi;oi|=4;try{return pr(98,e.bind(null,t,n,a))}finally{(oi=r)===Xo&&hr()}}function Ri(e,t){var n=oi;oi&=-2,oi|=Jo;try{return e(t)}finally{(oi=n)===Xo&&hr()}}function Li(e,t){e.finishedWork=null,e.finishedExpirationTime=0;var n=e.timeoutHandle;if(-1!==n&&(e.timeoutHandle=-1,qa(n)),null!==ui)for(n=ui.return;null!==n;){var a=n;switch(a.tag){case 1:var r=a.type.childContextTypes;null!=r&&Ra();break;case 3:il(),La();break;case 5:sl(a);break;case 4:il();break;case 13:case 19:Oa(ml);break;case 10:Cr(a)}n=n.return}ii=e,ui=lu(e.current,null),si=t,ci=ti,pi=di=1073741823,mi=null,fi=!1}function Ai(e,t,n){if((oi&(Zo|ei))!==Xo)throw o(Error(327));if(e.firstPendingTime<t)return null;if(n&&e.finishedExpirationTime===t)return Wi.bind(null,e);if(Ki(),e!==ii||t!==si)Li(e,t);else if(ci===ri)if(fi)Li(e,t);else{var a=e.lastPendingTime;if(a<t)return Ai.bind(null,e,a)}if(null!==ui){a=oi,oi|=Zo;var r=Qo.current;if(null===r&&(r=Xl),Qo.current=Xl,n){if(1073741823!==t){var l=ki();if(l<t)return oi=a,_r(),Qo.current=r,Ai.bind(null,e,l)}}else Ii=0;for(;;)try{if(n)for(;null!==ui;)ui=Ui(ui);else for(;null!==ui&&!$a();)ui=Ui(ui);break}catch(n){if(_r(),Ll(),null===(l=ui)||null===l.return)throw Li(e,t),oi=a,n;e:{var i=e,u=l.return,s=l,c=n,d=si;if(s.effectTag|=1024,s.firstEffect=s.lastEffect=null,null!==c&&"object"==typeof c&&"function"==typeof c.then){var p=c,m=0!=(ml.current&dl);c=u;do{var f;if((f=13===c.tag)&&(null!==c.memoizedState?f=!1:f=void 0!==(f=c.memoizedProps).fallback&&(!0!==f.unstable_avoidThisFallback||!m)),f){if(null===(u=c.updateQueue)?((u=new Set).add(p),c.updateQueue=u):u.add(p),0==(2&c.mode)){c.effectTag|=64,s.effectTag&=-1957,1===s.tag&&(null===s.alternate?s.tag=17:((d=Tr(1073741823,null)).tag=2,Sr(s,d))),s.expirationTime=1073741823;break e}s=i,i=d,null===(m=s.pingCache)?(m=s.pingCache=new Wo,u=new Set,m.set(p,u)):void 0===(u=m.get(p))&&(u=new Set,m.set(p,u)),u.has(i)||(u.add(i),s=Xi.bind(null,s,p,i),p.then(s,s)),c.effectTag|=2048,c.expirationTime=d;break e}c=c.return}while(null!==c);c=Error((ct(s.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+dt(s))}ci!==li&&(ci=ni),c=Po(c,s),s=u;do{switch(s.tag){case 3:s.effectTag|=2048,s.expirationTime=d,jr(s,d=Go(s,c,d));break e;case 1:if(p=c,i=s.type,u=s.stateNode,0==(64&s.effectTag)&&("function"==typeof i.getDerivedStateFromError||null!==u&&"function"==typeof u.componentDidCatch&&(null===Ei||!Ei.has(u)))){s.effectTag|=2048,s.expirationTime=d,jr(s,d=Ko(s,p,d));break e}}s=s.return}while(null!==s)}ui=Hi(l)}if(oi=a,_r(),Qo.current=r,null!==ui)return Ai.bind(null,e,t)}if(e.finishedWork=e.current.alternate,e.finishedExpirationTime=t,function(e,t){var n=e.firstBatch;return!!(null!==n&&n._defer&&n._expirationTime>=t)&&(mr(97,(function(){return n._onComplete(),null})),!0)}(e,t))return null;switch(ii=null,ci){case ti:throw o(Error(328));case ni:return(a=e.lastPendingTime)<t?Ai.bind(null,e,a):n?Wi.bind(null,e):(Li(e,t),fr(Ai.bind(null,e,t)),null);case ai:return 1073741823===di&&!n&&10<(n=hi+vi-sr())?fi?(Li(e,t),Ai.bind(null,e,t)):(a=e.lastPendingTime)<t?Ai.bind(null,e,a):(e.timeoutHandle=Na(Wi.bind(null,e),n),null):Wi.bind(null,e);case ri:if(!n){if(fi)return Li(e,t),Ai.bind(null,e,t);if((n=e.lastPendingTime)<t)return Ai.bind(null,e,n);if(1073741823!==pi?n=10*(1073741821-pi)-sr():1073741823===di?n=0:(n=10*(1073741821-di)-5e3,0>(n=(a=sr())-n)&&(n=0),(t=10*(1073741821-t)-a)<(n=(120>n?120:480>n?480:1080>n?1080:1920>n?1920:3e3>n?3e3:4320>n?4320:1960*$o(n/1960))-n)&&(n=t)),10<n)return e.timeoutHandle=Na(Wi.bind(null,e),n),null}return Wi.bind(null,e);case li:return!n&&1073741823!==di&&null!==mi&&(a=di,0>=(t=0|(r=mi).busyMinDurationMs)?t=0:(n=0|r.busyDelayMs,t=(a=sr()-(10*(1073741821-a)-(0|r.timeoutMs||5e3)))<=n?0:n+t-a),10<t)?(e.timeoutHandle=Na(Wi.bind(null,e),t),null):Wi.bind(null,e);default:throw o(Error(329))}}function Di(e,t){e<di&&1<e&&(di=e),null!==t&&e<pi&&1<e&&(pi=e,mi=t)}function Ui(e){var t=Zi(e.alternate,e,si);return e.memoizedProps=e.pendingProps,null===t&&(t=Hi(e)),Yo.current=null,t}function Hi(e){ui=e;do{var t=ui.alternate;if(e=ui.return,0==(1024&ui.effectTag)){e:{var n=t,a=si,l=(t=ui).pendingProps;switch(t.tag){case 2:case 16:break;case 15:case 0:break;case 1:Ma(t.type)&&Ra();break;case 3:il(),La(),(a=t.stateNode).pendingContext&&(a.context=a.pendingContext,a.pendingContext=null),null!==n&&null!==n.child||(io(t),t.effectTag&=-3),Io(t);break;case 5:sl(t),a=ll(rl.current);var i=t.type;if(null!==n&&null!=t.stateNode)ko(n,t,i,l,a),n.ref!==t.ref&&(t.effectTag|=128);else if(l){var u=ll(nl.current);if(io(t)){l=void 0,i=(n=t).stateNode;var s=n.type,c=n.memoizedProps;switch(i[S]=n,i[j]=c,s){case"iframe":case"object":case"embed":jn("load",i);break;case"video":case"audio":for(var d=0;d<ne.length;d++)jn(ne[d],i);break;case"source":jn("error",i);break;case"img":case"image":case"link":jn("error",i),jn("load",i);break;case"form":jn("reset",i),jn("submit",i);break;case"details":jn("toggle",i);break;case"input":_t(i,c),jn("invalid",i),Ea(a,"onChange");break;case"select":i._wrapperState={wasMultiple:!!c.multiple},jn("invalid",i),Ea(a,"onChange");break;case"textarea":ra(i,c),jn("invalid",i),Ea(a,"onChange")}for(l in ya(s,c),d=null,c)c.hasOwnProperty(l)&&(u=c[l],"children"===l?"string"==typeof u?i.textContent!==u&&(d=["children",u]):"number"==typeof u&&i.textContent!==""+u&&(d=["children",""+u]):m.hasOwnProperty(l)&&null!=u&&Ea(a,l));switch(s){case"input":He(i),Nt(i,c,!0);break;case"textarea":He(i),oa(i);break;case"select":case"option":break;default:"function"==typeof c.onClick&&(i.onclick=wa)}a=d,n.updateQueue=a,null!==a&&No(t)}else{c=i,n=l,s=t,d=9===a.nodeType?a:a.ownerDocument,u===ia.html&&(u=ua(c)),u===ia.html?"script"===c?((c=d.createElement("div")).innerHTML="<script><\/script>",d=c.removeChild(c.firstChild)):"string"==typeof n.is?d=d.createElement(c,{is:n.is}):(d=d.createElement(c),"select"===c&&(c=d,n.multiple?c.multiple=!0:n.size&&(c.size=n.size))):d=d.createElementNS(u,c),(c=d)[S]=s,c[j]=n,qo(n=c,t,!1,!1),s=n;var p=a,f=ba(i,l);switch(i){case"iframe":case"object":case"embed":jn("load",s),a=l;break;case"video":case"audio":for(a=0;a<ne.length;a++)jn(ne[a],s);a=l;break;case"source":jn("error",s),a=l;break;case"img":case"image":case"link":jn("error",s),jn("load",s),a=l;break;case"form":jn("reset",s),jn("submit",s),a=l;break;case"details":jn("toggle",s),a=l;break;case"input":_t(s,l),a=zt(s,l),jn("invalid",s),Ea(p,"onChange");break;case"option":a=ta(s,l);break;case"select":s._wrapperState={wasMultiple:!!l.multiple},a=r({},l,{value:void 0}),jn("invalid",s),Ea(p,"onChange");break;case"textarea":ra(s,l),a=aa(s,l),jn("invalid",s),Ea(p,"onChange");break;default:a=l}ya(i,a),c=void 0,d=i,u=s;var h=a;for(c in h)if(h.hasOwnProperty(c)){var v=h[c];"style"===c?va(u,v):"dangerouslySetInnerHTML"===c?null!=(v=v?v.__html:void 0)&&da(u,v):"children"===c?"string"==typeof v?("textarea"!==d||""!==v)&&pa(u,v):"number"==typeof v&&pa(u,""+v):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(m.hasOwnProperty(c)?null!=v&&Ea(p,c):null!=v&&Et(u,c,v,f))}switch(i){case"input":He(s),Nt(s,l,!1);break;case"textarea":He(s),oa(s);break;case"option":null!=l.value&&s.setAttribute("value",""+wt(l.value));break;case"select":a=s,s=l,a.multiple=!!s.multiple,null!=(c=s.value)?na(a,!!s.multiple,c,!1):null!=s.defaultValue&&na(a,!!s.multiple,s.defaultValue,!0);break;default:"function"==typeof a.onClick&&(s.onclick=wa)}xa(i,l)&&No(t),t.stateNode=n}null!==t.ref&&(t.effectTag|=128)}else if(null===t.stateNode)throw o(Error(166));break;case 6:if(n&&null!=t.stateNode)Vo(n,t,n.memoizedProps,l);else{if("string"!=typeof l&&null===t.stateNode)throw o(Error(166));n=ll(rl.current),ll(nl.current),io(t)?(a=t.stateNode,n=t.memoizedProps,a[S]=t,a.nodeValue!==n&&No(t)):(a=t,(n=(9===n.nodeType?n:n.ownerDocument).createTextNode(l))[S]=t,a.stateNode=n)}break;case 11:break;case 13:if(Oa(ml),l=t.memoizedState,0!=(64&t.effectTag)){t.expirationTime=a;break e}a=null!==l,l=!1,null===n?io(t):(l=null!==(i=n.memoizedState),a||null===i||null!==(i=n.child.sibling)&&(null!==(s=t.firstEffect)?(t.firstEffect=i,i.nextEffect=s):(t.firstEffect=t.lastEffect=i,i.nextEffect=null),i.effectTag=8)),a&&!l&&0!=(2&t.mode)&&(null===n&&!0!==t.memoizedProps.unstable_avoidThisFallback||0!=(ml.current&dl)?ci===ti&&(ci=ai):ci!==ti&&ci!==ai||(ci=ri)),(a||l)&&(t.effectTag|=4);break;case 7:case 8:case 12:break;case 4:il(),Io(t);break;case 10:Cr(t);break;case 9:case 14:break;case 17:Ma(t.type)&&Ra();break;case 18:break;case 19:if(Oa(ml),null===(l=t.memoizedState))break;if(i=0!=(64&t.effectTag),null===(s=l.rendering)){if(i)Oo(l,!1);else if(ci!==ti||null!==n&&0!=(64&n.effectTag))for(n=t.child;null!==n;){if(null!==(s=fl(n))){for(t.effectTag|=64,Oo(l,!1),null!==(n=s.updateQueue)&&(t.updateQueue=n,t.effectTag|=4),t.firstEffect=t.lastEffect=null,n=t.child;null!==n;)i=a,(l=n).effectTag&=2,l.nextEffect=null,l.firstEffect=null,l.lastEffect=null,null===(s=l.alternate)?(l.childExpirationTime=0,l.expirationTime=i,l.child=null,l.memoizedProps=null,l.memoizedState=null,l.updateQueue=null,l.dependencies=null):(l.childExpirationTime=s.childExpirationTime,l.expirationTime=s.expirationTime,l.child=s.child,l.memoizedProps=s.memoizedProps,l.memoizedState=s.memoizedState,l.updateQueue=s.updateQueue,i=s.dependencies,l.dependencies=null===i?null:{expirationTime:i.expirationTime,firstContext:i.firstContext,responders:i.responders}),n=n.sibling;Ta(ml,ml.current&cl|pl),t=t.child;break e}n=n.sibling}}else{if(!i)if(null!==(n=fl(s))){if(t.effectTag|=64,i=!0,Oo(l,!0),null===l.tail&&"hidden"===l.tailMode){null!==(a=n.updateQueue)&&(t.updateQueue=a,t.effectTag|=4),null!==(t=t.lastEffect=l.lastEffect)&&(t.nextEffect=null);break}}else sr()>l.tailExpiration&&1<a&&(t.effectTag|=64,i=!0,Oo(l,!1),t.expirationTime=t.childExpirationTime=a-1);l.isBackwards?(s.sibling=t.child,t.child=s):(null!==(a=l.last)?a.sibling=s:t.child=s,l.last=s)}if(null!==l.tail){0===l.tailExpiration&&(l.tailExpiration=sr()+500),a=l.tail,l.rendering=a,l.tail=a.sibling,l.lastEffect=t.lastEffect,a.sibling=null,n=ml.current,Ta(ml,n=i?n&cl|pl:n&cl),t=a;break e}break;case 20:break;default:throw o(Error(156))}t=null}if(a=ui,1===si||1!==a.childExpirationTime){for(n=0,l=a.child;null!==l;)(i=l.expirationTime)>n&&(n=i),(s=l.childExpirationTime)>n&&(n=s),l=l.sibling;a.childExpirationTime=n}if(null!==t)return t;null!==e&&0==(1024&e.effectTag)&&(null===e.firstEffect&&(e.firstEffect=ui.firstEffect),null!==ui.lastEffect&&(null!==e.lastEffect&&(e.lastEffect.nextEffect=ui.firstEffect),e.lastEffect=ui.lastEffect),1<ui.effectTag&&(null!==e.lastEffect?e.lastEffect.nextEffect=ui:e.firstEffect=ui,e.lastEffect=ui))}else{if(null!==(t=To(ui)))return t.effectTag&=1023,t;null!==e&&(e.firstEffect=e.lastEffect=null,e.effectTag|=1024)}if(null!==(t=ui.sibling))return t;ui=e}while(null!==ui);return ci===ti&&(ci=li),null}function Wi(e){var t=cr();return pr(99,Gi.bind(null,e,t)),null!==zi&&mr(97,(function(){return Ki(),null})),null}function Gi(e,t){if(Ki(),(oi&(Zo|ei))!==Xo)throw o(Error(327));var n=e.finishedWork,a=e.finishedExpirationTime;if(null===n)return null;if(e.finishedWork=null,e.finishedExpirationTime=0,n===e.current)throw o(Error(177));e.callbackNode=null,e.callbackExpirationTime=0;var r=n.expirationTime,l=n.childExpirationTime;if(r=l>r?l:r,e.firstPendingTime=r,r<e.lastPendingTime&&(e.lastPendingTime=r),e===ii&&(ui=ii=null,si=0),1<n.effectTag?null!==n.lastEffect?(n.lastEffect.nextEffect=n,r=n.firstEffect):r=n:r=n.firstEffect,null!==r){l=oi,oi|=ei,Yo.current=null,za=Sn;var i=Wn();if(Gn(i)){if("selectionStart"in i)var u={start:i.selectionStart,end:i.selectionEnd};else e:{var s=(u=(u=i.ownerDocument)&&u.defaultView||window).getSelection&&u.getSelection();if(s&&0!==s.rangeCount){u=s.anchorNode;var c=s.anchorOffset,d=s.focusNode;s=s.focusOffset;try{u.nodeType,d.nodeType}catch(e){u=null;break e}var p=0,m=-1,f=-1,h=0,v=0,g=i,y=null;t:for(;;){for(var b;g!==u||0!==c&&3!==g.nodeType||(m=p+c),g!==d||0!==s&&3!==g.nodeType||(f=p+s),3===g.nodeType&&(p+=g.nodeValue.length),null!==(b=g.firstChild);)y=g,g=b;for(;;){if(g===i)break t;if(y===u&&++h===c&&(m=p),y===d&&++v===s&&(f=p),null!==(b=g.nextSibling))break;y=(g=y).parentNode}g=b}u=-1===m||-1===f?null:{start:m,end:f}}else u=null}u=u||{start:0,end:0}}else u=null;_a={focusedElem:i,selectionRange:u},Sn=!1,gi=r;do{try{for(;null!==gi;){if(0!=(256&gi.effectTag)){var E=gi.alternate;switch((i=gi).tag){case 0:case 11:case 15:Bo(vl,hl,i);break;case 1:if(256&i.effectTag&&null!==E){var w=E.memoizedProps,z=E.memoizedState,_=i.stateNode,x=_.getSnapshotBeforeUpdate(i.elementType===i.type?w:yr(i.type,w),z);_.__reactInternalSnapshotBeforeUpdate=x}break;case 3:case 5:case 6:case 4:case 17:break;default:throw o(Error(163))}}gi=gi.nextEffect}}catch(e){if(null===gi)throw o(Error(330));Yi(gi,e),gi=gi.nextEffect}}while(null!==gi);gi=r;do{try{for(E=t;null!==gi;){var C=gi.effectTag;if(16&C&&pa(gi.stateNode,""),128&C){var N=gi.alternate;if(null!==N){var q=N.ref;null!==q&&("function"==typeof q?q(null):q.current=null)}}switch(14&C){case 2:Ao(gi),gi.effectTag&=-3;break;case 6:Ao(gi),gi.effectTag&=-3,Uo(gi.alternate,gi);break;case 4:Uo(gi.alternate,gi);break;case 8:Do(w=gi,E),w.return=null,w.child=null,w.memoizedState=null,w.updateQueue=null,w.dependencies=null;var I=w.alternate;null!==I&&(I.return=null,I.child=null,I.memoizedState=null,I.updateQueue=null,I.dependencies=null)}gi=gi.nextEffect}}catch(e){if(null===gi)throw o(Error(330));Yi(gi,e),gi=gi.nextEffect}}while(null!==gi);if(q=_a,N=Wn(),C=q.focusedElem,E=q.selectionRange,N!==C&&C&&C.ownerDocument&&function e(t,n){return!(!t||!n)&&(t===n||(!t||3!==t.nodeType)&&(n&&3===n.nodeType?e(t,n.parentNode):"contains"in t?t.contains(n):!!t.compareDocumentPosition&&!!(16&t.compareDocumentPosition(n))))}(C.ownerDocument.documentElement,C)){null!==E&&Gn(C)&&(N=E.start,void 0===(q=E.end)&&(q=N),"selectionStart"in C?(C.selectionStart=N,C.selectionEnd=Math.min(q,C.value.length)):(q=(N=C.ownerDocument||document)&&N.defaultView||window).getSelection&&(q=q.getSelection(),w=C.textContent.length,I=Math.min(E.start,w),E=void 0===E.end?I:Math.min(E.end,w),!q.extend&&I>E&&(w=E,E=I,I=w),w=Hn(C,I),z=Hn(C,E),w&&z&&(1!==q.rangeCount||q.anchorNode!==w.node||q.anchorOffset!==w.offset||q.focusNode!==z.node||q.focusOffset!==z.offset)&&((N=N.createRange()).setStart(w.node,w.offset),q.removeAllRanges(),I>E?(q.addRange(N),q.extend(z.node,z.offset)):(N.setEnd(z.node,z.offset),q.addRange(N))))),N=[];for(q=C;q=q.parentNode;)1===q.nodeType&&N.push({element:q,left:q.scrollLeft,top:q.scrollTop});for("function"==typeof C.focus&&C.focus(),C=0;C<N.length;C++)(q=N[C]).element.scrollLeft=q.left,q.element.scrollTop=q.top}_a=null,Sn=!!za,za=null,e.current=n,gi=r;do{try{for(C=a;null!==gi;){var k=gi.effectTag;if(36&k){var V=gi.alternate;switch(q=C,(N=gi).tag){case 0:case 11:case 15:Bo(bl,El,N);break;case 1:var O=N.stateNode;if(4&N.effectTag)if(null===V)O.componentDidMount();else{var T=N.elementType===N.type?V.memoizedProps:yr(N.type,V.memoizedProps);O.componentDidUpdate(T,V.memoizedState,O.__reactInternalSnapshotBeforeUpdate)}var P=N.updateQueue;null!==P&&Rr(0,P,O);break;case 3:var S=N.updateQueue;if(null!==S){if(I=null,null!==N.child)switch(N.child.tag){case 5:I=N.child.stateNode;break;case 1:I=N.child.stateNode}Rr(0,S,I)}break;case 5:var j=N.stateNode;null===V&&4&N.effectTag&&(q=j,xa(N.type,N.memoizedProps)&&q.focus());break;case 6:case 4:case 12:break;case 13:case 19:case 17:case 20:break;default:throw o(Error(163))}}if(128&k){var F=gi.ref;if(null!==F){var B=gi.stateNode;switch(gi.tag){case 5:var M=B;break;default:M=B}"function"==typeof F?F(M):F.current=M}}512&k&&(wi=!0),gi=gi.nextEffect}}catch(e){if(null===gi)throw o(Error(330));Yi(gi,e),gi=gi.nextEffect}}while(null!==gi);gi=null,rr(),oi=l}else e.current=n;if(wi)wi=!1,zi=e,xi=a,_i=t;else for(gi=r;null!==gi;)t=gi.nextEffect,gi.nextEffect=null,gi=t;if(0!==(t=e.firstPendingTime)?Si(e,k=gr(k=ki(),t),t):Ei=null,"function"==typeof eu&&eu(n.stateNode,a),1073741823===t?e===qi?Ni++:(Ni=0,qi=e):Ni=0,yi)throw yi=!1,e=bi,bi=null,e;return(oi&Jo)!==Xo?null:(hr(),null)}function Ki(){if(null===zi)return!1;var e=zi,t=xi,n=_i;return zi=null,xi=0,_i=90,pr(97<n?97:n,$i.bind(null,e,t))}function $i(e){if((oi&(Zo|ei))!==Xo)throw o(Error(331));var t=oi;for(oi|=ei,e=e.current.firstEffect;null!==e;){try{var n=e;if(0!=(512&n.effectTag))switch(n.tag){case 0:case 11:case 15:Bo(zl,hl,n),Bo(hl,wl,n)}}catch(t){if(null===e)throw o(Error(330));Yi(e,t)}n=e.nextEffect,e.nextEffect=null,e=n}return oi=t,hr(),!0}function Qi(e,t,n){Sr(e,t=Go(e,t=Po(n,t),1073741823)),null!==(e=Pi(e,1073741823))&&Si(e,99,1073741823)}function Yi(e,t){if(3===e.tag)Qi(e,e,t);else for(var n=e.return;null!==n;){if(3===n.tag){Qi(n,e,t);break}if(1===n.tag){var a=n.stateNode;if("function"==typeof n.type.getDerivedStateFromError||"function"==typeof a.componentDidCatch&&(null===Ei||!Ei.has(a))){Sr(n,e=Ko(n,e=Po(t,e),1073741823)),null!==(n=Pi(n,1073741823))&&Si(n,99,1073741823);break}}n=n.return}}function Xi(e,t,n){var a=e.pingCache;null!==a&&a.delete(t),ii===e&&si===n?ci===ri||ci===ai&&1073741823===di&&sr()-hi<vi?Li(e,si):fi=!0:e.lastPendingTime<n||(0!==(t=e.pingTime)&&t<n||(e.pingTime=n,e.finishedExpirationTime===n&&(e.finishedExpirationTime=0,e.finishedWork=null),Si(e,t=gr(t=ki(),n),n)))}function Ji(e,t){var n=e.stateNode;null!==n&&n.delete(t),n=gr(n=ki(),t=Vi(n,e,null)),null!==(e=Pi(e,t))&&Si(e,n,t)}var Zi=void 0;Zi=function(e,t,n){var a=t.expirationTime;if(null!==e){var r=t.pendingProps;if(e.memoizedProps!==r||ja.current)co=!0;else if(a<n){switch(co=!1,t.tag){case 3:Eo(t),uo();break;case 5:if(ul(t),4&t.mode&&1!==n&&r.hidden)return t.expirationTime=t.childExpirationTime=1,null;break;case 1:Ma(t.type)&&Ua(t);break;case 4:ol(t,t.stateNode.containerInfo);break;case 10:xr(t,t.memoizedProps.value);break;case 13:if(null!==t.memoizedState)return 0!==(a=t.child.childExpirationTime)&&a>=n?zo(e,t,n):(Ta(ml,ml.current&cl),null!==(t=Co(e,t,n))?t.sibling:null);Ta(ml,ml.current&cl);break;case 19:if(a=t.childExpirationTime>=n,0!=(64&e.effectTag)){if(a)return xo(e,t,n);t.effectTag|=64}if(null!==(r=t.memoizedState)&&(r.rendering=null,r.tail=null),Ta(ml,ml.current),!a)return null}return Co(e,t,n)}}else co=!1;switch(t.expirationTime=0,t.tag){case 2:if(a=t.type,null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),e=t.pendingProps,r=Ba(t,Sa.current),qr(t,n),r=Rl(null,t,a,e,r,n),t.effectTag|=1,"object"==typeof r&&null!==r&&"function"==typeof r.render&&void 0===r.$$typeof){if(t.tag=1,Ll(),Ma(a)){var l=!0;Ua(t)}else l=!1;t.memoizedState=null!==r.state&&void 0!==r.state?r.state:null;var i=a.getDerivedStateFromProps;"function"==typeof i&&Ur(t,a,i,e),r.updater=Hr,t.stateNode=r,r._reactInternalFiber=t,$r(t,a,e,n),t=bo(null,t,a,!0,l,n)}else t.tag=0,po(null,t,r,n),t=t.child;return t;case 16:switch(r=t.elementType,null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),e=t.pendingProps,r=function(e){var t=e._result;switch(e._status){case 1:return t;case 2:case 0:throw t;default:switch(e._status=0,(t=(t=e._ctor)()).then((function(t){0===e._status&&(t=t.default,e._status=1,e._result=t)}),(function(t){0===e._status&&(e._status=2,e._result=t)})),e._status){case 1:return e._result;case 2:throw e._result}throw e._result=t,t}}(r),t.type=r,l=t.tag=function(e){if("function"==typeof e)return ru(e)?1:0;if(null!=e){if((e=e.$$typeof)===at)return 11;if(e===ot)return 14}return 2}(r),e=yr(r,e),l){case 0:t=go(null,t,r,e,n);break;case 1:t=yo(null,t,r,e,n);break;case 11:t=mo(null,t,r,e,n);break;case 14:t=fo(null,t,r,yr(r.type,e),a,n);break;default:throw o(Error(306),r,"")}return t;case 0:return a=t.type,r=t.pendingProps,go(e,t,a,r=t.elementType===a?r:yr(a,r),n);case 1:return a=t.type,r=t.pendingProps,yo(e,t,a,r=t.elementType===a?r:yr(a,r),n);case 3:if(Eo(t),null===(a=t.updateQueue))throw o(Error(282));return r=null!==(r=t.memoizedState)?r.element:null,Mr(t,a,t.pendingProps,null,n),(a=t.memoizedState.element)===r?(uo(),t=Co(e,t,n)):(r=t.stateNode,(r=(null===e||null===e.child)&&r.hydrate)&&(to=Ia(t.stateNode.containerInfo.firstChild),eo=t,r=no=!0),r?(t.effectTag|=2,t.child=el(t,null,a,n)):(po(e,t,a,n),uo()),t=t.child),t;case 5:return ul(t),null===e&&lo(t),a=t.type,r=t.pendingProps,l=null!==e?e.memoizedProps:null,i=r.children,Ca(a,r)?i=null:null!==l&&Ca(a,l)&&(t.effectTag|=16),vo(e,t),4&t.mode&&1!==n&&r.hidden?(t.expirationTime=t.childExpirationTime=1,t=null):(po(e,t,i,n),t=t.child),t;case 6:return null===e&&lo(t),null;case 13:return zo(e,t,n);case 4:return ol(t,t.stateNode.containerInfo),a=t.pendingProps,null===e?t.child=Zr(t,null,a,n):po(e,t,a,n),t.child;case 11:return a=t.type,r=t.pendingProps,mo(e,t,a,r=t.elementType===a?r:yr(a,r),n);case 7:return po(e,t,t.pendingProps,n),t.child;case 8:case 12:return po(e,t,t.pendingProps.children,n),t.child;case 10:e:{if(a=t.type._context,r=t.pendingProps,i=t.memoizedProps,xr(t,l=r.value),null!==i){var u=i.value;if(0===(l=tn(u,l)?0:0|("function"==typeof a._calculateChangedBits?a._calculateChangedBits(u,l):1073741823))){if(i.children===r.children&&!ja.current){t=Co(e,t,n);break e}}else for(null!==(u=t.child)&&(u.return=t);null!==u;){var s=u.dependencies;if(null!==s){i=u.child;for(var c=s.firstContext;null!==c;){if(c.context===a&&0!=(c.observedBits&l)){1===u.tag&&((c=Tr(n,null)).tag=2,Sr(u,c)),u.expirationTime<n&&(u.expirationTime=n),null!==(c=u.alternate)&&c.expirationTime<n&&(c.expirationTime=n),Nr(u.return,n),s.expirationTime<n&&(s.expirationTime=n);break}c=c.next}}else i=10===u.tag&&u.type===t.type?null:u.child;if(null!==i)i.return=u;else for(i=u;null!==i;){if(i===t){i=null;break}if(null!==(u=i.sibling)){u.return=i.return,i=u;break}i=i.return}u=i}}po(e,t,r.children,n),t=t.child}return t;case 9:return r=t.type,a=(l=t.pendingProps).children,qr(t,n),a=a(r=Ir(r,l.unstable_observedBits)),t.effectTag|=1,po(e,t,a,n),t.child;case 14:return l=yr(r=t.type,t.pendingProps),fo(e,t,r,l=yr(r.type,l),a,n);case 15:return ho(e,t,t.type,t.pendingProps,a,n);case 17:return a=t.type,r=t.pendingProps,r=t.elementType===a?r:yr(a,r),null!==e&&(e.alternate=null,t.alternate=null,t.effectTag|=2),t.tag=1,Ma(a)?(e=!0,Ua(t)):e=!1,qr(t,n),Gr(t,a,r),$r(t,a,r,n),bo(null,t,a,!0,e,n);case 19:return xo(e,t,n)}throw o(Error(156))};var eu=null,tu=null;function nu(e,t,n,a){this.tag=e,this.key=n,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=t,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=a,this.effectTag=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.childExpirationTime=this.expirationTime=0,this.alternate=null}function au(e,t,n,a){return new nu(e,t,n,a)}function ru(e){return!(!(e=e.prototype)||!e.isReactComponent)}function lu(e,t){var n=e.alternate;return null===n?((n=au(e.tag,t,e.key,e.mode)).elementType=e.elementType,n.type=e.type,n.stateNode=e.stateNode,n.alternate=e,e.alternate=n):(n.pendingProps=t,n.effectTag=0,n.nextEffect=null,n.firstEffect=null,n.lastEffect=null),n.childExpirationTime=e.childExpirationTime,n.expirationTime=e.expirationTime,n.child=e.child,n.memoizedProps=e.memoizedProps,n.memoizedState=e.memoizedState,n.updateQueue=e.updateQueue,t=e.dependencies,n.dependencies=null===t?null:{expirationTime:t.expirationTime,firstContext:t.firstContext,responders:t.responders},n.sibling=e.sibling,n.index=e.index,n.ref=e.ref,n}function ou(e,t,n,a,r,l){var i=2;if(a=e,"function"==typeof e)ru(e)&&(i=1);else if("string"==typeof e)i=5;else e:switch(e){case Xe:return iu(n.children,r,l,t);case nt:i=8,r|=7;break;case Je:i=8,r|=1;break;case Ze:return(e=au(12,n,t,8|r)).elementType=Ze,e.type=Ze,e.expirationTime=l,e;case rt:return(e=au(13,n,t,r)).type=rt,e.elementType=rt,e.expirationTime=l,e;case lt:return(e=au(19,n,t,r)).elementType=lt,e.expirationTime=l,e;default:if("object"==typeof e&&null!==e)switch(e.$$typeof){case et:i=10;break e;case tt:i=9;break e;case at:i=11;break e;case ot:i=14;break e;case it:i=16,a=null;break e}throw o(Error(130),null==e?e:typeof e,"")}return(t=au(i,n,t,r)).elementType=e,t.type=a,t.expirationTime=l,t}function iu(e,t,n,a){return(e=au(7,e,a,t)).expirationTime=n,e}function uu(e,t,n){return(e=au(6,e,null,t)).expirationTime=n,e}function su(e,t,n){return(t=au(4,null!==e.children?e.children:[],e.key,t)).expirationTime=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function cu(e,t,n){this.tag=t,this.current=null,this.containerInfo=e,this.pingCache=this.pendingChildren=null,this.finishedExpirationTime=0,this.finishedWork=null,this.timeoutHandle=-1,this.pendingContext=this.context=null,this.hydrate=n,this.callbackNode=this.firstBatch=null,this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function du(e,t,n){return e=new cu(e,t,n),t=au(3,null,null,2===t?7:1===t?3:0),e.current=t,t.stateNode=e}function pu(e,t,n,a,r,l){var i=t.current;e:if(n){t:{if(2!==ln(n=n._reactInternalFiber)||1!==n.tag)throw o(Error(170));var u=n;do{switch(u.tag){case 3:u=u.stateNode.context;break t;case 1:if(Ma(u.type)){u=u.stateNode.__reactInternalMemoizedMergedChildContext;break t}}u=u.return}while(null!==u);throw o(Error(171))}if(1===n.tag){var s=n.type;if(Ma(s)){n=Da(n,s,u);break e}}n=u}else n=Pa;return null===t.context?t.context=n:t.pendingContext=n,t=l,(r=Tr(a,r)).payload={element:e},null!==(t=void 0===t?null:t)&&(r.callback=t),Sr(i,r),Ti(i,a),a}function mu(e,t,n,a){var r=t.current,l=ki(),o=Ar.suspense;return pu(e,t,n,r=Vi(l,r,o),o,a)}function fu(e){if(!(e=e.current).child)return null;switch(e.child.tag){case 5:default:return e.child.stateNode}}function hu(e){var t=1073741821-25*(1+((1073741821-ki()+500)/25|0));t<=Oi&&--t,this._expirationTime=Oi=t,this._root=e,this._callbacks=this._next=null,this._hasChildren=this._didComplete=!1,this._children=null,this._defer=!0}function vu(){this._callbacks=null,this._didCommit=!1,this._onCommit=this._onCommit.bind(this)}function gu(e,t,n){this._internalRoot=du(e,t,n)}function yu(e,t){this._internalRoot=du(e,2,t)}function bu(e){return!(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function Eu(e,t,n,a,r){var l=n._reactRootContainer,o=void 0;if(l){if(o=l._internalRoot,"function"==typeof r){var i=r;r=function(){var e=fu(o);i.call(e)}}mu(t,o,e,r)}else{if(l=n._reactRootContainer=function(e,t){if(t||(t=!(!(t=e?9===e.nodeType?e.documentElement:e.firstChild:null)||1!==t.nodeType||!t.hasAttribute("data-reactroot"))),!t)for(var n;n=e.lastChild;)e.removeChild(n);return new gu(e,0,t)}(n,a),o=l._internalRoot,"function"==typeof r){var u=r;r=function(){var e=fu(o);u.call(e)}}Ri((function(){mu(t,o,e,r)}))}return fu(o)}function wu(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!bu(t))throw o(Error(200));return function(e,t,n){var a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ye,key:null==a?null:""+a,children:e,containerInfo:t,implementation:n}}(e,t,null,n)}qe=function(e,t,n){switch(t){case"input":if(Ct(e,n),t=n.name,"radio"===n.type&&null!=t){for(n=e;n.parentNode;)n=n.parentNode;for(n=n.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<n.length;t++){var a=n[t];if(a!==e&&a.form===e.form){var r=R(a);if(!r)throw o(Error(90));We(a),Ct(a,r)}}}break;case"textarea":la(e,n);break;case"select":null!=(t=n.value)&&na(e,!!n.multiple,t,!1)}},hu.prototype.render=function(e){if(!this._defer)throw o(Error(250));this._hasChildren=!0,this._children=e;var t=this._root._internalRoot,n=this._expirationTime,a=new vu;return pu(e,t,null,n,null,a._onCommit),a},hu.prototype.then=function(e){if(this._didComplete)e();else{var t=this._callbacks;null===t&&(t=this._callbacks=[]),t.push(e)}},hu.prototype.commit=function(){var e=this._root._internalRoot,t=e.firstBatch;if(!this._defer||null===t)throw o(Error(251));if(this._hasChildren){var n=this._expirationTime;if(t!==this){this._hasChildren&&(n=this._expirationTime=t._expirationTime,this.render(this._children));for(var a=null,r=t;r!==this;)a=r,r=r._next;if(null===a)throw o(Error(251));a._next=r._next,this._next=t,e.firstBatch=this}if(this._defer=!1,t=n,(oi&(Zo|ei))!==Xo)throw o(Error(253));fr(Ai.bind(null,e,t)),hr(),t=this._next,this._next=null,null!==(t=e.firstBatch=t)&&t._hasChildren&&t.render(t._children)}else this._next=null,this._defer=!1},hu.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var e=this._callbacks;if(null!==e)for(var t=0;t<e.length;t++)(0,e[t])()}},vu.prototype.then=function(e){if(this._didCommit)e();else{var t=this._callbacks;null===t&&(t=this._callbacks=[]),t.push(e)}},vu.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var e=this._callbacks;if(null!==e)for(var t=0;t<e.length;t++){var n=e[t];if("function"!=typeof n)throw o(Error(191),n);n()}}},yu.prototype.render=gu.prototype.render=function(e,t){var n=this._internalRoot,a=new vu;return null!==(t=void 0===t?null:t)&&a.then(t),mu(e,n,null,a._onCommit),a},yu.prototype.unmount=gu.prototype.unmount=function(e){var t=this._internalRoot,n=new vu;return null!==(e=void 0===e?null:e)&&n.then(e),mu(null,t,null,n._onCommit),n},yu.prototype.createBatch=function(){var e=new hu(this),t=e._expirationTime,n=this._internalRoot,a=n.firstBatch;if(null===a)n.firstBatch=e,e._next=null;else{for(n=null;null!==a&&a._expirationTime>=t;)n=a,a=a._next;e._next=a,null!==n&&(n._next=e)}return e},Pe=Bi,Se=Mi,je=Fi,Fe=function(e,t){var n=oi;oi|=2;try{return e(t)}finally{(oi=n)===Xo&&hr()}};var zu,_u,xu={createPortal:wu,findDOMNode:function(e){if(null==e)e=null;else if(1!==e.nodeType){var t=e._reactInternalFiber;if(void 0===t){if("function"==typeof e.render)throw o(Error(188));throw o(Error(268),Object.keys(e))}e=null===(e=un(t))?null:e.stateNode}return e},hydrate:function(e,t,n){if(!bu(t))throw o(Error(200));return Eu(null,e,t,!0,n)},render:function(e,t,n){if(!bu(t))throw o(Error(200));return Eu(null,e,t,!1,n)},unstable_renderSubtreeIntoContainer:function(e,t,n,a){if(!bu(n))throw o(Error(200));if(null==e||void 0===e._reactInternalFiber)throw o(Error(38));return Eu(e,t,n,!1,a)},unmountComponentAtNode:function(e){if(!bu(e))throw o(Error(40));return!!e._reactRootContainer&&(Ri((function(){Eu(null,null,e,!1,(function(){e._reactRootContainer=null}))})),!0)},unstable_createPortal:function(){return wu.apply(void 0,arguments)},unstable_batchedUpdates:Bi,unstable_interactiveUpdates:function(e,t,n,a){return Fi(),Mi(e,t,n,a)},unstable_discreteUpdates:Mi,unstable_flushDiscreteUpdates:Fi,flushSync:function(e,t){if((oi&(Zo|ei))!==Xo)throw o(Error(187));var n=oi;oi|=1;try{return pr(99,e.bind(null,t))}finally{oi=n,hr()}},unstable_createRoot:function(e,t){if(!bu(e))throw o(Error(299),"unstable_createRoot");return new yu(e,null!=t&&!0===t.hydrate)},unstable_createSyncRoot:function(e,t){if(!bu(e))throw o(Error(299),"unstable_createRoot");return new gu(e,1,null!=t&&!0===t.hydrate)},unstable_flushControlled:function(e){var t=oi;oi|=1;try{pr(99,e)}finally{(oi=t)===Xo&&hr()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[B,M,R,O.injectEventPluginsByName,p,W,function(e){q(e,H)},Oe,Te,Rn,V,Ki,{current:!1}]}};_u=(zu={findFiberByHostInstance:F,bundleType:0,version:"16.9.0",rendererPackageName:"react-dom"}).findFiberByHostInstance,function(e){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var t=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(t.isDisabled||!t.supportsFiber)return!0;try{var n=t.inject(e);eu=function(e){try{t.onCommitFiberRoot(n,e,void 0,64==(64&e.current.effectTag))}catch(e){}},tu=function(e){try{t.onCommitFiberUnmount(n,e)}catch(e){}}}catch(e){}}(r({},zu,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ge.ReactCurrentDispatcher,findHostInstanceByFiber:function(e){return null===(e=un(e))?null:e.stateNode},findFiberByHostInstance:function(e){return _u?_u(e):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}));var Cu={default:xu},Nu=Cu&&xu||Cu;e.exports=Nu.default||Nu},function(e,t,n){"use strict";e.exports=n(14)},function(e,t,n){"use strict";
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */Object.defineProperty(t,"__esModule",{value:!0});var a=void 0,r=void 0,l=void 0,o=void 0,i=void 0;if(t.unstable_now=void 0,t.unstable_forceFrameRate=void 0,"undefined"==typeof window||"function"!=typeof MessageChannel){var u=null,s=null,c=function(){if(null!==u)try{var e=t.unstable_now();u(!0,e),u=null}catch(e){throw setTimeout(c,0),e}};t.unstable_now=function(){return Date.now()},a=function(e){null!==u?setTimeout(a,0,e):(u=e,setTimeout(c,0))},r=function(e,t){s=setTimeout(e,t)},l=function(){clearTimeout(s)},o=function(){return!1},i=t.unstable_forceFrameRate=function(){}}else{var d=window.performance,p=window.Date,m=window.setTimeout,f=window.clearTimeout,h=window.requestAnimationFrame,v=window.cancelAnimationFrame;"undefined"!=typeof console&&("function"!=typeof h&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!=typeof v&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")),t.unstable_now="object"==typeof d&&"function"==typeof d.now?function(){return d.now()}:function(){return p.now()};var g=!1,y=null,b=-1,E=-1,w=33.33,z=-1,_=-1,x=0,C=!1;o=function(){return t.unstable_now()>=x},i=function(){},t.unstable_forceFrameRate=function(e){0>e||125<e?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<e?(w=Math.floor(1e3/e),C=!0):(w=33.33,C=!1)};var N=function(){if(null!==y){var e=t.unstable_now(),n=0<x-e;try{y(n,e)||(y=null)}catch(e){throw I.postMessage(null),e}}},q=new MessageChannel,I=q.port2;q.port1.onmessage=N;var k=function(e){if(null===y)_=z=-1,g=!1;else{g=!0,h((function(e){f(b),k(e)}));var n=function(){x=t.unstable_now()+w/2,N(),b=m(n,3*w)};if(b=m(n,3*w),-1!==z&&.1<e-z){var a=e-z;!C&&-1!==_&&a<w&&_<w&&(8.33>(w=a<_?_:a)&&(w=8.33)),_=a}z=e,x=e+w,I.postMessage(null)}};a=function(e){y=e,g||(g=!0,h((function(e){k(e)})))},r=function(e,n){E=m((function(){e(t.unstable_now())}),n)},l=function(){f(E),E=-1}}var V=null,O=null,T=null,P=3,S=!1,j=!1,F=!1;function B(e,t){var n=e.next;if(n===e)V=null;else{e===V&&(V=n);var a=e.previous;a.next=n,n.previous=a}e.next=e.previous=null,n=e.callback,a=P;var r=T;P=e.priorityLevel,T=e;try{var l=e.expirationTime<=t;switch(P){case 1:var o=n(l);break;case 2:case 3:case 4:o=n(l);break;case 5:o=n(l)}}catch(e){throw e}finally{P=a,T=r}if("function"==typeof o)if(t=e.expirationTime,e.callback=o,null===V)V=e.next=e.previous=e;else{o=null,l=V;do{if(t<=l.expirationTime){o=l;break}l=l.next}while(l!==V);null===o?o=V:o===V&&(V=e),(t=o.previous).next=o.previous=e,e.next=o,e.previous=t}}function M(e){if(null!==O&&O.startTime<=e)do{var t=O,n=t.next;if(t===n)O=null;else{O=n;var a=t.previous;a.next=n,n.previous=a}t.next=t.previous=null,D(t,t.expirationTime)}while(null!==O&&O.startTime<=e)}function R(e){F=!1,M(e),j||(null!==V?(j=!0,a(L)):null!==O&&r(R,O.startTime-e))}function L(e,n){j=!1,F&&(F=!1,l()),M(n),S=!0;try{if(e){if(null!==V)do{B(V,n),M(n=t.unstable_now())}while(null!==V&&!o())}else for(;null!==V&&V.expirationTime<=n;)B(V,n),M(n=t.unstable_now());return null!==V||(null!==O&&r(R,O.startTime-n),!1)}finally{S=!1}}function A(e){switch(e){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1e4;default:return 5e3}}function D(e,t){if(null===V)V=e.next=e.previous=e;else{var n=null,a=V;do{if(t<a.expirationTime){n=a;break}a=a.next}while(a!==V);null===n?n=V:n===V&&(V=e),(t=n.previous).next=n.previous=e,e.next=n,e.previous=t}}var U=i;t.unstable_ImmediatePriority=1,t.unstable_UserBlockingPriority=2,t.unstable_NormalPriority=3,t.unstable_IdlePriority=5,t.unstable_LowPriority=4,t.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3}var n=P;P=e;try{return t()}finally{P=n}},t.unstable_next=function(e){switch(P){case 1:case 2:case 3:var t=3;break;default:t=P}var n=P;P=t;try{return e()}finally{P=n}},t.unstable_scheduleCallback=function(e,n,o){var i=t.unstable_now();if("object"==typeof o&&null!==o){var u=o.delay;u="number"==typeof u&&0<u?i+u:i,o="number"==typeof o.timeout?o.timeout:A(e)}else o=A(e),u=i;if(e={callback:n,priorityLevel:e,startTime:u,expirationTime:o=u+o,next:null,previous:null},u>i){if(o=u,null===O)O=e.next=e.previous=e;else{n=null;var s=O;do{if(o<s.startTime){n=s;break}s=s.next}while(s!==O);null===n?n=O:n===O&&(O=e),(o=n.previous).next=n.previous=e,e.next=n,e.previous=o}null===V&&O===e&&(F?l():F=!0,r(R,u-i))}else D(e,o),j||S||(j=!0,a(L));return e},t.unstable_cancelCallback=function(e){var t=e.next;if(null!==t){if(e===t)e===V?V=null:e===O&&(O=null);else{e===V?V=t:e===O&&(O=t);var n=e.previous;n.next=t,t.previous=n}e.next=e.previous=null}},t.unstable_wrapCallback=function(e){var t=P;return function(){var n=P;P=t;try{return e.apply(this,arguments)}finally{P=n}}},t.unstable_getCurrentPriorityLevel=function(){return P},t.unstable_shouldYield=function(){var e=t.unstable_now();return M(e),null!==T&&null!==V&&V.startTime<=e&&V.expirationTime<T.expirationTime||o()},t.unstable_requestPaint=U,t.unstable_continueExecution=function(){j||S||(j=!0,a(L))},t.unstable_pauseExecution=function(){},t.unstable_getFirstCallbackNode=function(){return V}},function(e,t,n){},function(e,t,n){},function(e,t,n){"use strict";n.r(t);n(7);var a=n(0),r=n.n(a),l=n(1),o=n.n(l),i=n(3),u=n.n(i);function s(e){return(s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function p(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function m(e,t){return(m=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var f=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=function(e,t){return!t||"object"!==s(t)&&"function"!=typeof t?p(e):t}(this,d(t).call(this,e))).state={isResizing:!1},n.onDrop=n.onDrop.bind(p(n)),n.onResizeStart=n.onResizeStart.bind(p(n)),n.onResize=n.onResize.bind(p(n)),n.onResizeEnd=n.onResizeEnd.bind(p(n)),n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&m(e,t)}(t,e),n=t,l=[{key:"onDragStart",value:function(e,t){e.dataTransfer.setData("colId",t)}},{key:"onDragOver",value:function(e){e.preventDefault()}}],(a=[{key:"onResizeStart",value:function(e){e.stopPropagation(),e.target.classList.add("ads-resizing"),this.setState({isResizing:!0});var t=document.createElement("img");t.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",document.body.appendChild(t),e.dataTransfer.setDragImage(t,0,0)}},{key:"onResize",value:function(e){var t=this.state.isResizing,n=this.props.id;if(t&&e.pageX>500){var a=document.getElementsByClassName("ads-column-".concat(n))[0],r=a.offsetLeft,l=e.pageX,o=parseInt(window.getComputedStyle(a,null).getPropertyValue("padding-left").replace(/px/,""),10)+parseInt(window.getComputedStyle(a,null).getPropertyValue("padding-right").replace(/px/,""),10);a.style.width="".concat(l-r-o,"px")}}},{key:"onResizeEnd",value:function(e){this.setState({isResizing:!1}),e.target.classList.remove("ads-resizing")}},{key:"onDrop",value:function(e,t){var n=e.dataTransfer.getData("colId");n&&(0,this.props.reorderColumn)(parseInt(n,10),t)}},{key:"render",value:function(){var e=this,n=this.props,a=n.className,l=n.children,o=n.id,i=n.onClick,s=n.resizeable,c=n.isDraggable;return r.a.createElement("th",{onDragStart:function(e){t.onDragStart(e,o)},onDragOver:function(e){t.onDragOver(e)},onDrop:function(t){e.onDrop(t,o)},draggable:c,onClick:i,className:u()("ads-column","ads-column-".concat(o),"".concat(c?"ads-column-sortable":""),a)},l,s&&r.a.createElement("div",{className:"ads-column-resizer",draggable:!0,onDragStart:function(t){e.onResizeStart(t)},onDrag:function(t){e.onResize(t)},onDragEnd:function(t){e.onResizeEnd(t)}}))}}])&&c(n.prototype,a),l&&c(n,l),t}(r.a.Component);f.propTypes={resizeable:o.a.bool,isDraggable:o.a.bool,onClick:o.a.func,id:o.a.number.isRequired,children:o.a.node,reorderColumn:o.a.func,className:o.a.string},f.defaultProps={isDraggable:!1,children:null,className:"",resizeable:!1,onClick:function(){},reorderColumn:function(){}};var h=n(4);function v(e){return(v="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function g(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function y(e,t){return!t||"object"!==v(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function b(e){return(b=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function E(e,t){return(E=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var w=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=y(this,b(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&E(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.direction,n=e.className,a="asc"===t?r.a.createElement(h.IconArrowUp,null):r.a.createElement(h.IconArrowDown,null);return r.a.createElement("span",{className:n},a)}}])&&g(n.prototype,a),l&&g(n,l),t}(r.a.Component);w.propTypes={direction:o.a.string,className:o.a.string},w.defaultProps={direction:"asc",className:""};var z=n(2);function _(e){return(_="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function x(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function C(e,t){return!t||"object"!==_(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function N(e){return(N=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function q(e,t){return(q=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var I=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=C(this,N(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&q(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu")},t)}}])&&x(n.prototype,a),l&&x(n,l),t}(r.a.Component);function k(e){return(k="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function V(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function O(e,t){return!t||"object"!==k(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function T(e){return(T=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function P(e,t){return(P=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}I.propTypes={children:o.a.node.isRequired,className:o.a.string},I.defaultProps={className:""};var S=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=O(this,T(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&P(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu-header")},t)}}])&&V(n.prototype,a),l&&V(n,l),t}(r.a.Component);function j(e){return(j="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function F(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function B(e,t){return!t||"object"!==j(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function M(e){return(M=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function R(e,t){return(R=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}S.propTypes={children:o.a.node.isRequired,className:o.a.string},S.defaultProps={className:""};var L=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=B(this,M(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&R(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu-body")},t)}}])&&F(n.prototype,a),l&&F(n,l),t}(r.a.Component);function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function D(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function U(e,t){return!t||"object"!==A(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function H(e){return(H=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function W(e,t){return(W=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}L.propTypes={children:o.a.node.isRequired,className:o.a.string},L.defaultProps={className:""};var G=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=U(this,H(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&W(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu-body-left")},t)}}])&&D(n.prototype,a),l&&D(n,l),t}(r.a.Component);function K(e){return(K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function $(){return($=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function Q(e,t){if(null==e)return{};var n,a,r=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}(e,t);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(r[n]=e[n])}return r}function Y(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function X(e,t){return!t||"object"!==K(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function J(e){return(J=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Z(e,t){return(Z=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}G.propTypes={children:o.a.node.isRequired,className:o.a.string},G.defaultProps={className:""};var ee=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=X(this,J(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Z(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.disabled,a=e.className,l=e.onClick,o=Q(e,["children","disabled","className","onClick"]);return r.a.createElement("div",$({role:"button",onClick:l,onKeyUp:l,className:u()(a,"ads-grouped-menu-item",n?"ads-disabled":""),tabIndex:0,disabled:!0},o),t)}}])&&Y(n.prototype,a),l&&Y(n,l),t}(r.a.Component);function te(e){return(te="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ne(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ae(e,t){return!t||"object"!==te(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function re(e){return(re=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function le(e,t){return(le=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}ee.propTypes={disabled:o.a.bool,children:o.a.node.isRequired,className:o.a.string,onClick:o.a.func},ee.defaultProps={disabled:!1,className:"",onClick:null};var oe=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=ae(this,re(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&le(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu-footer")},t)}}])&&ne(n.prototype,a),l&&ne(n,l),t}(r.a.Component);function ie(e){return(ie="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ue(e){return(ue=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function se(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ce(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function de(e,t,n){return t&&ce(e.prototype,t),n&&ce(e,n),e}function pe(e,t){return(pe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}oe.propTypes={children:o.a.node.isRequired,className:o.a.string},oe.defaultProps={className:""};var me=function(e){function t(e){var n;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var a=(n=function(e,t){return!t||"object"!==ie(t)&&"function"!=typeof t?se(e):t}(this,ue(t).call(this,e))).props.data;return n.state={data:a,leftPane:a,selected:[],searchTerm:""},n.handleChildClick=n.handleChildClick.bind(se(n)),n.handleSearch=n.handleSearch.bind(se(n)),n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&pe(e,t)}(t,e),de(t,null,[{key:"paneHasParent",value:function(e){return e.map((function(e){return Object.keys(e).includes("children")})).length>0}}]),de(t,[{key:"handleSearch",value:function(e){var t=e.target.value,n=this.props,a=n.data,r=n.valueField,l=[];l=t?a.filter((function(e){return e[r].toLowerCase().indexOf(t.toLowerCase())>-1})):a,this.setState({data:l,leftPane:l,searchTerm:t})}},{key:"handleChildClick",value:function(e,t){var n=this.state.selected,a=n;n.includes(t)?a.splice(n.indexOf(t),1):a.push(t),this.setState({selected:a}),(0,this.props.onChange)(e,a)}},{key:"paneRenderer",value:function(e){var t=this,n=this.state.selected,a=this.props.keyField,l=[];return l.push(e.map((function(e){var l=n.includes(e.id);return r.a.createElement(ee,{key:e.id,onClick:function(n){return t.handleChildClick(n,e[a])}},r.a.createElement(z.Checkbox,{checked:l,label:e.label}))}))),l}},{key:"render",value:function(){var e=this.props.placeholder,t=this.state,n=t.data,a=t.leftPane,l=t.selected,o=t.searchTerm;return r.a.createElement(I,null,r.a.createElement(S,null,r.a.createElement(z.InputGroup,{stretched:!0},r.a.createElement(z.Input,{data:n,placeholder:e,value:o,onChange:this.handleSearch}),r.a.createElement(z.InputGroupAddon,null,r.a.createElement(h.IconSearch,null)))),r.a.createElement(L,{className:"wds-flex"},r.a.createElement(G,{className:"wds-flex__item--grow"},this.paneRenderer(a))),r.a.createElement(oe,null,r.a.createElement("div",{className:"wds-flex wds-flex--y-center wds-flex--between"},r.a.createElement("div",null,"".concat(l.length," selected")))))}}]),t}(r.a.Component);function fe(e){return(fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function he(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ve(e,t){return!t||"object"!==fe(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function ge(e){return(ge=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ye(e,t){return(ye=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}me.propTypes={data:o.a.arrayOf(o.a.shape({id:o.a.any,label:o.a.string})),onChange:o.a.func,valueField:o.a.string,keyField:o.a.string,placeholder:o.a.string},me.defaultProps={data:"",onChange:function(){},valueField:"label",keyField:"id",placeholder:"Filter..."};var be=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=ve(this,ge(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ye(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"wds-menu")},t)}}])&&he(n.prototype,a),l&&he(n,l),t}(r.a.Component);be.propTypes={children:o.a.node.isRequired,className:o.a.string},be.defaultProps={className:""};n(15);function Ee(e){return(Ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function we(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ze(e){return(ze=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _e(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function xe(e,t){return(xe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var Ce=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=function(e,t){return!t||"object"!==Ee(t)&&"function"!=typeof t?_e(e):t}(this,ze(t).call(this,e))).itemSelected=n.itemSelected.bind(_e(n)),n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&xe(e,t)}(t,e),n=t,(a=[{key:"itemSelected",value:function(){var e=this.props;(0,e.handleSelected)(e.data.data.id)}},{key:"render",value:function(){var e=this.props,t=e.data,n=e.labelField,a=r.a.createElement(z.Checkbox,{onClick:this.itemSelected,checked:t.selected});return r.a.createElement(z.MenuItem,{addOnPlacement:"left",addOn:a},t.data[n])}}])&&we(n.prototype,a),l&&we(n,l),t}(a.Component);function Ne(e){return(Ne="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function qe(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function Ie(e){return(Ie=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ke(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ve(e,t){return(Ve=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Ce.propTypes={data:o.a.shape({selected:o.a.bool.isRequired,data:o.a.any.isRequired}),labelField:o.a.string.isRequired,handleSelected:o.a.func},Ce.defaultProps={data:o.a.shape({selected:!1,data:{}}),handleSelected:function(){}};var Oe=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=function(e,t){return!t||"object"!==Ne(t)&&"function"!=typeof t?ke(e):t}(this,Ie(t).call(this,e))).state={show:!1,searchTerm:e.searchTerm,data:e.data},n.search=n.search.bind(ke(n)),n.handleItemSelected=n.handleItemSelected.bind(ke(n)),n.handleMenuChange=n.handleMenuChange.bind(ke(n)),n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Ve(e,t)}(t,e),n=t,(a=[{key:"search",value:function(e){var t=e.target.value,n=this.props,a=n.data,r=n.labelField,l=[];l=t?a.filter((function(e){return e.data[r].toLowerCase().indexOf(t.toLowerCase())>-1})):a,this.setState({data:l,searchTerm:t})}},{key:"handleItemSelected",value:function(e){var t=this.props,n=t.handleChange,a=t.data;a.forEach((function(t,n){t.data.id===e&&(a[n].selected=!t.selected)})),n(a)}},{key:"handleMenuChange",value:function(e){var t=e.show;this.setState({show:t})}},{key:"render",value:function(){var e=this,t=this.state,n=t.searchTerm,a=t.data,l=t.show,o=this.props,i=o.labelField,u=o.trigger,s=o.searchPlaceholder;return r.a.createElement(r.a.Fragment,null,r.a.createElement(z.Menu,{show:l,dense:!0,noRules:!0,menuTrigger:u,onChange:this.handleMenuChange},r.a.createElement(z.InputGroup,{className:"ads-menu-search"},r.a.createElement(z.Input,{type:"text",name:"searchInput",id:"menuSearchInput",value:n,onChange:this.search,stretched:!0,tabIndex:"0",placeholder:s}),r.a.createElement(z.InputGroupAddon,null,r.a.createElement(h.IconSearch,null))),a.map((function(t){return r.a.createElement(Ce,{data:t,labelField:i,key:t.data.id,handleSelected:e.handleItemSelected})}))))}}])&&qe(n.prototype,a),l&&qe(n,l),t}(a.Component);function Te(e){return(Te="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Pe(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function Se(e,t){return!t||"object"!==Te(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function je(e){return(je=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Fe(e,t){return(Fe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Oe.propTypes={data:o.a.arrayOf(o.a.shape({selected:o.a.bool.isRequired,data:o.a.any})),searchPlaceholder:o.a.string,searchTerm:o.a.string,trigger:o.a.node,handleChange:o.a.func.isRequired,labelField:o.a.string.isRequired},Oe.defaultProps={data:[],searchPlaceholder:"",searchTerm:"",trigger:r.a.createElement(z.Button,null,"Searchable Menu")};var Be=function(e){function t(e){var n;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),(n=Se(this,je(t).call(this,e))).state={},n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Fe(e,t)}(t,e),n=t,(a=[{key:"render",value:function(){var e=this.props,t=e.children,n=e.className;return r.a.createElement("div",{className:u()(n,"ads-grouped-menu-body-right")},t)}}])&&Pe(n.prototype,a),l&&Pe(n,l),t}(r.a.Component);function Me(e){return(Me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Re(){return(Re=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function Le(e,t){if(null==e)return{};var n,a,r=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}(e,t);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(r[n]=e[n])}return r}function Ae(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function De(e){return(De=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Ue(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function He(e,t){return(He=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function We(e,t){var n=function(n){function a(e){var t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),t=function(e,t){return!t||"object"!==Me(t)&&"function"!=typeof t?Ue(e):t}(this,De(a).call(this,e));var n=e.value;return t.state={value:n},t.dataElementRef=r.a.createRef(),t.handleChange=t.handleChange.bind(Ue(t)),t}var l,o,i;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&He(e,t)}(a,n),l=a,(o=[{key:"componentDidMount",value:function(){var e=this.dataElementRef.current;e.dataset.bound||(e.dataset.bound=btoa(JSON.stringify("")))}},{key:"handleChange",value:function(e){var t=e.target.value,n=this.props.onChange,a=this.dataElementRef.current,r="value",l=t;t===Object(t)&&(r="object",l=JSON.stringify(t));var o=btoa(encodeURIComponent(l).replace(/%([0-9A-F]{2})/g,(function(e,t){return String.fromCharCode("0x".concat(t))})));a.dataset.bound=o,a.dataset.type=r,this.setState({value:t}),n&&n(e)}},{key:"render",value:function(){var n=this.state.value,a=this.props,l=(a.onChange,Le(a,["onChange"]));return r.a.createElement(r.a.Fragment,null,r.a.createElement("div",{id:t,ref:this.dataElementRef}),r.a.createElement(e,Re({onChange:this.handleChange,value:n},l)))}}])&&Ae(l.prototype,o),i&&Ae(l,i),a}(r.a.Component);return n.displayName="Bridged(".concat(function(e){return e.displayName||e.name||"Component"}(n),")"),n.propTypes={value:o.a.node.isRequired,onChange:o.a.node.isRequired},n}function Ge(e){var t,n=document.getElementById(e);if(n)try{var a=n.dataset.type||"value";t=decodeURIComponent(atob(n.dataset.bound).split("").map((function(e){var t="00".concat(e.charCodeAt(0).toString(16));return"%".concat(t.slice(-2))})).join("")),"object"===a&&(t=JSON.parse(t))}catch(n){console.error("Could not extract data from component (".concat(e,"): ").concat(n)),t=void 0}return t}function Ke(e){return(Ke="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function $e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function Qe(e){return(Qe=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Ye(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Xe(e,t){return(Xe=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}Be.propTypes={children:o.a.node.isRequired,className:o.a.string},Be.defaultProps={className:""};var Je=function(e){function t(e){var n;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),n=function(e,t){return!t||"object"!==Ke(t)&&"function"!=typeof t?Ye(e):t}(this,Qe(t).call(this,e));var a=e.text;return n.state={existingText:a,newText:a,isEditing:!1},n.inlineEditor=r.a.createRef(),n.handleChange=n.handleChange.bind(Ye(n)),n.handleFocus=n.handleFocus.bind(Ye(n)),n.handleKeyPress=n.handleKeyPress.bind(Ye(n)),n.acceptChanges=n.acceptChanges.bind(Ye(n)),n.rejectChanges=n.rejectChanges.bind(Ye(n)),n.handleClick=n.handleClick.bind(Ye(n)),n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Xe(e,t)}(t,e),n=t,(a=[{key:"componentWillMount",value:function(){document.addEventListener("mousedown",this.handleClick,!1)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("mousedown",this.handleClick,!1)}},{key:"handleClick",value:function(e){this.inlineEditor&&this.inlineEditor.current&&(this.inlineEditor.current.contains(e.target)||this.rejectChanges())}},{key:"acceptChanges",value:function(){var e=this.state.newText,t=this.props.minimumLength;e.trim().length<t||(this.setState({existingText:e}),this.handleFocus())}},{key:"rejectChanges",value:function(){var e=this.state.existingText;this.setState({newText:e}),this.handleFocus()}},{key:"handleFocus",value:function(){var e=this.state,t=e.isEditing,n=e.newText,a=this.props.onFocusOut;t&&a(n),this.setState({isEditing:!t})}},{key:"handleChange",value:function(e){this.setState({newText:e.target.value})}},{key:"handleKeyPress",value:function(e){"Enter"===e.key?this.acceptChanges():"Escape"===e.key&&this.rejectChanges()}},{key:"render",value:function(){var e=this,t=this.props,n=t.placeholder,a=t.editIcon,l=t.acceptIcon,o=t.rejectIcon,i=this.state,u=i.existingText,s=i.newText;return i.isEditing?r.a.createElement("div",{className:"ads-inline-editor-editing",ref:this.inlineEditor},r.a.createElement(z.Input,{value:s,onChange:function(t){e.handleChange(t)},onKeyDown:function(t){e.handleKeyPress(t)},placeholder:n,autoFocus:!0}),r.a.createElement("div",{className:"ads-inline-editor-buttons"},r.a.createElement(z.ButtonGroup,null,r.a.createElement(z.Button,{size:"sm",color:"secondary",onClick:this.rejectChanges},o),r.a.createElement(z.Button,{size:"sm",color:"primary",onClick:this.acceptChanges},l)))):r.a.createElement("div",{className:"ads-inline-editor-display",onClick:this.handleFocus,onKeyDown:this.handleFocus,role:"button",tabIndex:0},r.a.createElement("span",null,u),r.a.createElement(z.Button,{variant:"text",size:"sm",color:"secondary"},a))}}])&&$e(n.prototype,a),l&&$e(n,l),t}(r.a.Component);Je.propTypes={text:o.a.string,placeholder:o.a.string,onFocusOut:o.a.func,editIcon:o.a.element,acceptIcon:o.a.element,rejectIcon:o.a.element,minimumLength:o.a.number},Je.defaultProps={text:"",placeholder:"",onFocusOut:function(){},editIcon:r.a.createElement(h.IconPencilPaper,null),acceptIcon:r.a.createElement(h.IconCheck,null),rejectIcon:r.a.createElement(h.IconX,null),minimumLength:0};n(16);function Ze(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a)}return n}function et(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ze(n,!0).forEach((function(t){tt(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ze(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function tt(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function nt(e){return(nt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function at(){return(at=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function rt(e,t){if(null==e)return{};var n,a,r=function(e,t){if(null==e)return{};var n,a,r={},l=Object.keys(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}(e,t);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(e);for(a=0;a<l.length;a++)n=l[a],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(r[n]=e[n])}return r}function lt(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ot(e){return(ot=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function it(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ut(e,t){return(ut=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}var st=function(e){function t(e){var n;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),n=function(e,t){return!t||"object"!==nt(t)&&"function"!=typeof t?it(e):t}(this,ot(t).call(this,e));var a=e.value,r=e.color,l=0;return a&&(l=a.length),n.state={value:a||"",color:r||null,currentCharacterCount:l},n.countCharacters=n.countCharacters.bind(it(n)),n}var n,a,l;return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ut(e,t)}(t,e),n=t,(a=[{key:"countCharacters",value:function(e){var t=this.props.characterLimit,n=e.target.value,a=n.length;null!==t&&a<=t?this.setState({value:n,currentCharacterCount:a}):t?this.setState({value:n.substr(0,t),currentCharacterCount:t}):this.setState({value:n,currentCharacterCount:a});var r=this.props.onChange;r&&r(e)}},{key:"render",value:function(){var e=this.props,t=e.strings,n=e.characterCount,a=e.characterLimit,l=(e.onChange,e.stretched),o=rt(e,["strings","characterCount","characterLimit","onChange","stretched"]),i=this.state,u=i.currentCharacterCount,s=i.value,c=i.color;return r.a.createElement("div",{className:l?"":"ads-textarea__wrapper"},r.a.createElement(z.Textarea,at({},o,{stretched:l,onChange:this.countCharacters,value:s,color:c})),r.a.createElement("p",{className:"".concat(a&&n?"padding-right":""," ")+"ads-textarea__subtext wds-type--dark-muted wds-type--body-sm"},n&&r.a.createElement("span",null,"".concat(t.charactersEntered," ").concat(u)),a&&r.a.createElement("span",null,"".concat(t.maximum," ").concat(a))))}}])&&lt(n.prototype,a),l&&lt(n,l),t}(a.Component);st.propTypes=et({strings:o.a.shape({charactersEntered:o.a.string.isRequired,maximum:o.a.string.isRequired}),characterCount:o.a.bool,characterLimit:o.a.number},z.Textarea.propTypes),st.defaultProps=et({},z.Textarea.defaultProps,{characterCount:!1,characterLimit:null,strings:{charactersEntered:"Characters entered: ",maximum:"Maximum: "}}),n.d(t,"TableColumnHeader",(function(){return f})),n.d(t,"TableColumnSorter",(function(){return w})),n.d(t,"MultiSelect",(function(){return me})),n.d(t,"Menu",(function(){return be})),n.d(t,"SearchableMenu",(function(){return Oe})),n.d(t,"GroupedMenu",(function(){return I})),n.d(t,"GroupedMenuBody",(function(){return L})),n.d(t,"GroupedMenuBodyLeft",(function(){return G})),n.d(t,"GroupedMenuBodyRight",(function(){return Be})),n.d(t,"GroupedMenuFooter",(function(){return oe})),n.d(t,"GroupedMenuHeader",(function(){return S})),n.d(t,"GroupedMenuItem",(function(){return ee})),n.d(t,"bridged",(function(){return We})),n.d(t,"getBridgedData",(function(){return Ge})),n.d(t,"InlineEditor",(function(){return Je})),n.d(t,"Textarea",(function(){return st}))}]);
//# sourceMappingURL=main.js.map

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.NotificationPreferences = exports.CancelDeleteAccount = exports.Account = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(6);

var _strength = __webpack_require__(304);

var _image_uploader = __webpack_require__(193);

var _grid = __webpack_require__(20);

var _backbone = __webpack_require__(40);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ajax = __webpack_require__(4);
var Alert = __webpack_require__(10);
var formError = __webpack_require__(192);
var DatePicker = __webpack_require__(35);

var profilePictureTempl = __webpack_require__(1624);
var tempEmailTempl = __webpack_require__(1625);
var initialGroupTempl = __webpack_require__(442);

var _require = __webpack_require__(1626),
    cancelAccountDeletionDialog = _require.cancelAccountDeletionDialog,
    accountDeleteDialog = _require.accountDeleteDialog;

var STRINGS = {
	profile_picture: gettext('Profile picture'),
	remove_photo: gettext('Remove photo'),
	upload_photo: gettext('Upload a photo'),
	upload_new_photo: gettext('Upload a new photo'),
	cancel_change: gettext('Cancel this change'),
	resend: gettext('Resend confirmation'),

	upload_picture: gettext('Upload profile picture'),
	applicant: gettext('Applicant'),
	reason: gettext('Reason'),
	date_made: gettext('Date made'),
	delete_conflict: gettext('Remove conflict of interest'),
	delete_conflict_confirm: gettext('Are you sure you want to remove this conflict of interest?'),

	cancelDeletionConfirmation: gettext('Are you sure you want to cancel your delete account request? Site administrators will be notified that no further action is required'),
	invalidPassword: gettext('The password entered is not the correct password for the account')
};

var conflictColumns = [{
	name: STRINGS.applicant,
	id: 'applicant',
	formatter: function formatter(item) {
		return initialGroupTempl({
			top: item.applicant.full_name,
			bottom: item.applicant.email
		});
	}
}, {
	name: STRINGS.reason,
	id: 'reason'
}, {
	name: STRINGS.date_made,
	id: 'created_at'
}, {
	name: '',
	id: 'delete',
	formatter: function formatter(item) {
		return '<a href="#" class="sma-hideable-menu sma-js-delete-conflict" data-id=' + item.id + ' \t\t\t\tdata-applicant_first=' + item.applicant.first_name + ' data-applicant_last=' + item.applicant.last_name + '><i class="nc-icon-mini ui-1_trash-simple"></i></a>';
	}
}];

var ConflictsGrid = _grid.Grid.extend({
	showTitlebar: false,
	showSearchBar: false,
	showColumnDropSelect: false,
	showPagination: false,
	loaderSize: 'md',
	columns: conflictColumns,
	showSelectorColumn: false,
	rowClass: 'sma-menu-container',

	onLoad: function onLoad(resonse) {
		var _this = this;

		$('.sma-js-delete-conflict').click(function (e) {
			e.preventDefault();
			var conflictId = $(e.currentTarget).data('id');
			var applicantFirstName = $(e.currentTarget).data('applicant_first');
			var applicantLastName = $(e.currentTarget).data('applicant_last');

			var delete_conflict_confirm = interpolate(gettext('Removing this conflict of interest will allow you to review applications from this \
					applicant in the future.<br><br><strong>Applicant:</strong> %(applicantFirstName)s %(applicantLastName)s'), { applicantFirstName: applicantFirstName, applicantLastName: applicantLastName }, true);

			var modal = new _modals.Confirm(STRINGS.delete_conflict, delete_conflict_confirm, function () {
				var url = reverse('reviewer-conflict-delete', {
					conflict_id: conflictId
				});

				ajax.post({
					url: url,
					callback: $.proxy(function () {
						this.load();
					}, _this)
				});
			});
		});
	}
});

function accountDeletionRequest(password, callback) {
	$('.sma-js-delete-dialog-delete-button').addClass('disabled').attr('disabled', 'disabled');

	$.post(reverse('admin-account-delete-request'), JSON.stringify({
		password: password
	}), function (response) {
		$('.sma-js-delete-dialog-delete-button').removeClass('disabled').removeAttr('disabled');
		callback(response);
	}, 'json');
}

var Account = exports.Account = function (_Backbone$View) {
	_inherits(Account, _Backbone$View);

	function Account(config) {
		_classCallCheck(this, Account);

		var _this2 = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this));

		_this2.setElement('body');

		var context = config;
		context.strings = STRINGS;

		_this2.sites = config.sites;
		_this2.role = config.role;
		_this2.gdpr_delay = parseInt(config.gdpr_delay);

		_this2.toggleTempEmailDisplay(config);
		_this2.setProfilePicture(config);

		_this2.deletionInfo = config.deletionInfo !== undefined ? config.deletionInfo : {};

		var imageUploaderConfig = {
			wrapper: $('#profile-picture-container'),
			inputField: '.sma-js-img-upload-field',
			onCropHandler: function onCropHandler(croppedImg) {
				var data = {
					strings: STRINGS,
					picture: croppedImg
				};

				_this2.setProfilePicture(data);
				$('#sma-hidden-profile-img').val(croppedImg);
				_this2.addProfilePicture();
			}
		};

		new _image_uploader.ImageCropper(imageUploaderConfig);

		new _strength.Strength({
			element: $('#id_password'),
			confirm: $('#id_password_confirmation')
		});

		new _strength.PasswordEye($('#id_password_old'));

		$('.sma-js-date-picker').each(function () {
			new DatePicker($(this));
		});

		if (_this2.role === 'reviewer') {
			_this2.renderConflictsTable();
		}

		if (window.location.hash) {
			$('a[data-toggle="tab"][href="' + window.location.hash + '"]').click();
		}
		return _this2;
	}

	_createClass(Account, [{
		key: 'navDropdownItemClicked',
		value: function navDropdownItemClicked(e) {
			e.preventDefault();
			$(e.currentTarget).tab('show');
		}
	}, {
		key: 'setProfilePicture',
		value: function setProfilePicture(data) {
			var content = profilePictureTempl(data);
			$("#profile-picture-container").html(content);
			window.localize(); // To translate the file widget
		}
	}, {
		key: 'toggleTempEmailDisplay',
		value: function toggleTempEmailDisplay(context) {
			if (context && context.temp_email) {
				var email = context.temp_email;
			}

			var tempEmailDiv = $('.sma-js-temp-email');

			if (email) {
				var context = STRINGS;

				context.temp_email = interpolate(gettext('Check your email %(email)s to confirm your new email address. \
					Until you confirm, notifications will continue to be sent to your current email address.'), { email: email }, true);

				var content = tempEmailTempl({ 'strings': context, 'temp_email': email });

				tempEmailDiv.html(content);
			} else {
				tempEmailDiv.html('');
			}
		}
	}, {
		key: 'disconnectSocial',
		value: function disconnectSocial(e) {
			var modal = new _modals.AjaxFormModal({
				title: gettext('Disconnect your social account'),
				subtitle: gettext('In order to disconnect from your social profile, we require \
				a password to be created so you can continue to access this account.'),
				destroyOnClose: true
			});

			modal.addToStack('DisconnectSocialAccount', new _modals.AjaxFormContent(reverse('disconnect-social-login'), {
				onLoad: function onLoad() {
					new _strength.Strength({
						element: $('#id_password'),
						confirm: $('#id_password_confirmation')
					});
					modal.show();
				}
			}));
		}
	}, {
		key: 'addProfilePicture',
		value: function addProfilePicture() {
			var form = $('#sma-profile-picture-form')[0];
			var data = new FormData(form);

			var options = {
				url: reverse('add-profile-picture'),
				data: data,
				cache: false,
				datatype: 'json',
				processData: false,
				contentType: false,
				alertOnSuccess: true
			};

			ajax.post(options);
		}
	}, {
		key: 'removeProfilePicture',
		value: function removeProfilePicture(e) {
			var _this3 = this;

			e.preventDefault();
			ajax.post({
				url: reverse('remove-profile-picture'),
				callback: function callback(result) {
					result.strings = STRINGS;
					_this3.setProfilePicture(result);
				}
			});
		}
	}, {
		key: 'submitForm',
		value: function submitForm(href, form, _callback) {
			var data = new FormData(form);

			var options = {
				url: href,
				data: data,
				cache: false,
				datatype: 'json',
				processData: false,
				contentType: false,
				alwaysCallback: true,
				callback: function callback(result) {
					var elem = $(form);
					if (result.errors) {
						formError.removeErrors(elem);
						formError.addErrors(elem, result.errors);
					} else {
						formError.removeErrors(elem);
						if (_callback) {
							_callback(result);
						}
					}
				}
			};
			ajax.post(options);
		}
	}, {
		key: 'submitPassword',
		value: function submitPassword(e) {
			e.preventDefault();
			var target = $(e.currentTarget);
			var href = target.attr('href');
			var form = $('#sma-account-password-form')[0];
			var callback = function callback() {
				form.reset();
			};

			this.submitForm(href, form, callback);
		}
	}, {
		key: 'submitNotifications',
		value: function submitNotifications(e) {
			e.preventDefault();
			var target = $(e.currentTarget);
			var href = target.attr('href');
			var form = $('#sma-account-notification-form')[0];

			this.submitForm(href, form);
		}
	}, {
		key: 'submitSettings',
		value: function submitSettings(e) {
			var _this4 = this;

			e.preventDefault();
			var target = $(e.currentTarget);
			var href = target.attr('href');

			var form = $('#sma-account-settings-form')[0];

			var callback = function callback(data) {
				_this4.toggleTempEmailDisplay(data);
				data.strings = STRINGS;
				_this4.setProfilePicture(data);
			};
			this.submitForm(href, form, callback);
		}
	}, {
		key: 'submitApiTokens',
		value: function submitApiTokens(e) {
			e.preventDefault();
			var target = $(e.currentTarget);
			var href = target.attr('href');
			var form = $('#sma-api-tokens-form')[0];
			var callback = function callback(data) {
				$('#sma-js-api').removeClass('d-none');
				$('#sma-js-api-client-id').text(data.clientId);
				$('#sma-js-api-client-secret').text(data.clientSecret);
				$('#sma-js-api-refresh-token').text(data.refreshToken);
				$('#sma-js-api-access-token').text(data.accessToken);
				$('#sma-js-api-scope').text(data.scope);
			};
			this.submitForm(href, form, callback);
		}
	}, {
		key: 'cancelEmailChange',
		value: function cancelEmailChange(e) {
			var _this5 = this;

			e.preventDefault();

			var options = {
				url: reverse('cancel-email-change'),
				callback: function callback(result) {
					_this5.toggleTempEmailDisplay();
				}
			};
			ajax.post(options);
		}
	}, {
		key: 'resendConfirmation',
		value: function resendConfirmation(e) {
			e.preventDefault();

			var options = {
				url: reverse('resend-email-confirmation'),
				data: {
					role: this.role
				}
			};

			ajax.post(options);
		}
	}, {
		key: 'becomeApplicant',
		value: function becomeApplicant(e) {
			e.preventDefault();

			var options = {
				url: reverse('accounts-become-applicant'),
				callback: function callback(result) {
					$(e.currentTarget).parent().remove();
				}
			};

			ajax.post(options);
		}
	}, {
		key: 'renderConflictsTable',
		value: function renderConflictsTable() {
			var url = reverse('reviewer-conflict-list');

			this.conflictsGrid = new ConflictsGrid({
				element: $('#conflicts-table'),
				url: url
			});
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-account-disconnect': 'disconnectSocial',
				'click #remove_picture': 'removeProfilePicture',
				'click #save-settings': 'submitSettings',
				'click #generate-new-api-tokens': 'submitApiTokens',
				'click #save-password': 'submitPassword',
				'click #save-notifications': 'submitNotifications',
				'click #cancel_change': 'cancelEmailChange',
				'click #resend_confirmation': 'resendConfirmation',
				'click #sma-js-become-applicant': 'becomeApplicant',
				'click .sma-applicant-tab-item': 'navDropdownItemClicked'
			};
		}
	}]);

	return Account;
}(_backbone2.default.View);

var CancelDeleteAccount = exports.CancelDeleteAccount = function (_Backbone$View2) {
	_inherits(CancelDeleteAccount, _Backbone$View2);

	function CancelDeleteAccount(config) {
		_classCallCheck(this, CancelDeleteAccount);

		var _this6 = _possibleConstructorReturn(this, (CancelDeleteAccount.__proto__ || Object.getPrototypeOf(CancelDeleteAccount)).call(this));

		_this6.setElement('body');
		return _this6;
	}

	_createClass(CancelDeleteAccount, [{
		key: 'cancelDeleteAccount',
		value: function cancelDeleteAccount(e) {
			e.preventDefault();

			cancelAccountDeletionDialog({
				title: gettext('Cancel account deletion'),
				strings: STRINGS,
				deletionInfo: this.deletionInfo,
				handler: function handler(modal) {
					$('#sma-js-cancel-account-deletion').addClass('disabled').attr('disabled', 'disabled');

					$.post(reverse('admin-account-delete-request-cancel'), {}, function (response) {
						$('#sma-js-cancel-account-deletion').removeClass('disabled').removeAttr('disabled');
						if (response.success) {
							modal.hide();
							window.location.reload();
						}
					}, 'json');
				}
			});
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-account-cancel-delete': 'cancelDeleteAccount'
			};
		}
	}]);

	return CancelDeleteAccount;
}(_backbone2.default.View);

var NotificationPreferences = exports.NotificationPreferences = function NotificationPreferences() {
	_classCallCheck(this, NotificationPreferences);

	var disableChecks = function disableChecks($sel) {
		$sel.prop('disabled', true);
		$sel.prop('checked', false);
	};

	var enableChecks = function enableChecks($sel) {
		$sel.removeAttr('disabled');
	};

	$(function () {
		var $notificationForm = $('#sma-account-notification-form');
		var $notifications = $notificationForm.find('.sma-js-notification-field input');
		var $unsubscribe_from_all = $notificationForm.find('.sma-js-unsubscribe-from-all input');

		if ($unsubscribe_from_all[0].checked) {
			disableChecks($notifications);
		}

		$unsubscribe_from_all.on('click', function (e) {
			if ($unsubscribe_from_all[0].checked) {
				disableChecks($notifications);
			} else {
				enableChecks($notifications);
			}
		});
	});
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(6);

var _dropselector = __webpack_require__(115);

var _dropselector2 = _interopRequireDefault(_dropselector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var STRINGS = __webpack_require__(195);

var ajax = __webpack_require__(4);

var downloadModalTempl = __webpack_require__(1658);

var DownloadPoll = function () {
	function DownloadPoll(config) {
		var _this = this;

		_classCallCheck(this, DownloadPoll);

		this.url = config.url;

		this.interval = setInterval(function () {
			_this.poll(0);
		}, 2000);

		$('.sma-js-download-cancel').click(function () {
			window.close();
		});

		$('.sma-js-redownload').click(function () {
			window.location.reload();
		});
	}

	_createClass(DownloadPoll, [{
		key: 'poll',
		value: function poll() {
			var _this2 = this;

			var options = {
				url: this.url,
				dataType: 'json',
				callback: function callback(response) {
					var current = parseInt(response.current);
					var total = parseInt(response.total);
					var comment = response.comment;

					var percentage = total == 0 ? 1.0 : current / total;

					$('#sma-js-downloads-progress-message').text('Step ' + current.toString() + ' of ' + total.toString() + ': ' + comment);

					$('.progress-bar').width(percentage * 100 + "%");

					if (response.success) {
						$('#sma-js-downloads-complete-container').show();
						$('#sma-js-downloads-pending-container').hide();
						$('#sma-js-download-filesize').html(response.size);

						$('#sma-js-download-button').attr('href', response.url);

						$('#sma-js-download-button').click(function () {
							$('.sma-js-download-finished-tools').hide();
							$('.sma-js-download-finished').show();
						});

						clearInterval(_this2.interval);
					} else if (response.error) {
						$('#sma-js-downloads-error-container').show();
						$('#sma-js-downloads-pending-container').hide();
						$('#sma-js-download-error-message').html(response.error);
						clearInterval(_this2.interval);
					}
				}
			};

			ajax.get(options);
		}
	}]);

	return DownloadPoll;
}();

var DownloadModal = function (_Modal) {
	_inherits(DownloadModal, _Modal);

	_createClass(DownloadModal, [{
		key: 'template',
		get: function get() {
			return downloadModalTempl;
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click #download-btn': 'beginDownload',
				'click #cancel-btn': 'hide',
				'click #include_all_tasks': 'toggleTaskSelection',
				'click #include_selected_tasks': 'toggleTaskSelection',
				'change #id_download_format': 'togglePrefixVisiblity'
			};
		}
	}]);

	function DownloadModal(ctx) {
		_classCallCheck(this, DownloadModal);

		var _this3 = _possibleConstructorReturn(this, (DownloadModal.__proto__ || Object.getPrototypeOf(DownloadModal)).call(this));

		_this3.submission_ids = ctx.submission_ids || [];
		_this3.round_ids = ctx.round_ids || [];
		_this3.from_round_id = ctx.from_round_id || null;
		_this3.applicantRoundsOnly = ctx.applicantOnlyRounds || false;

		var options = {
			title: STRINGS.downloadOptions,
			autoShow: true,
			destroyOnClose: true
		};

		if (_this3.submission_ids.length > 1) {
			options["subtitle"] = STRINGS.applicationsSelected + ' ' + _this3.submission_ids.length + ' ';
		} else {
			options["subtitle"] = STRINGS.customizeYourDownload;
		}

		_this3.handleOptions(options);

		ctx['STRINGS'] = STRINGS;

		ctx.isFullDownload = ctx.isFullDownload ? true : false;

		_this3.ctx = ctx;

		_this3.buildModal();
		return _this3;
	}

	_createClass(DownloadModal, [{
		key: 'buildModal',
		value: function buildModal() {
			var _this4 = this;

			var url = reverse('download-modal-data');

			var options = {
				url: url,
				data: {
					submission_ids: this.submission_ids,
					round_ids: this.round_ids,
					from_round_id: this.from_round_id
				},
				alertOnSuccess: false,
				alertOnError: false,
				callback: function callback(response) {
					_this4.ctx.review_stages = response.review_stages;
					_this4.ctx.tasks = response.applicant_tasks;
					_this4.ctx.applicant_fields = response.applicant_fields;
					_this4.ctx.application_fields = response.application_fields;
					_this4.ctx.name_visible = response.name_visible;
					_this4.ctx.title_visible = response.title_visible;

					_this4.element = $(_this4.template(_this4.ctx));
					_this4.setElement(_this4.element[0]);

					_this4.taskSelect = new _dropselector2.default({
						$selectEl: _this4.element.find("#sma-js-task-selector"),
						multiple: true,
						fullWidth: true,
						dropdownToggle: true,
						buttonSize: 'btn-sm'
					});

					_this4.render();

					_this4.includeAllTasksInput = $("#include_all_tasks", _this4.modalBody);

					_this4.toggleTaskSelection();
				}
			};

			ajax.post(options);
		}
	}, {
		key: 'toggleTaskSelection',
		value: function toggleTaskSelection() {
			var el = this.includeAllTasksInput;
			if (el.is(":checked")) {
				$("#sma-js-task-selection-wrap .sma-js-dropdown-toggle", this.modalBody).attr("disabled", true);
			} else {
				$("#sma-js-task-selection-wrap .sma-js-dropdown-toggle", this.modalBody).attr("disabled", false);
			}
		}
	}, {
		key: 'togglePrefixVisiblity',
		value: function togglePrefixVisiblity(e) {
			var target = $(e.currentTarget);
			var prefixContainer = this.modalBody.find('.sma-js-filename-prefix-container');

			if (target.val() == "as_single_file") {
				prefixContainer.hide();
			} else {
				prefixContainer.show();
			}
		}
	}, {
		key: 'buildDownloadConfig',
		value: function buildDownloadConfig() {
			var config = {};

			config['submission_ids'] = this.submission_ids;
			config['from_round_id'] = this.from_round_id;
			config['stage_ids'] = this.round_ids;

			var downloadFormat = $("select[name=download_format]", this.modalBody).val();
			config['download_format'] = downloadFormat;

			var filenamePrefix = $("input[name=filename_prefix]:checked", this.modalBody).val();
			config['filename_prefix'] = filenamePrefix;

			//if this is true, all tasks are included no matter what
			var includeAllTasks = this.includeAllTasksInput.is(":checked");
			config['task_selection'] = includeAllTasks;
			config['task_ids'] = [];

			if (!includeAllTasks) {
				config['task_ids'] = this.taskSelect.val();
			}

			// include selected stage and misc details
			$("input[name^='include_']", this.modalBody).each(function (i, el) {
				el = $(el);

				var name = el.attr('name');
				var isChecked = el.is(":checked");
				// skip previously handled tasks
				if (name.includes('include_task')) {
					return;
				}

				if (name.includes('include_stage') && !isChecked) {
					var stageId = parseInt(name.replace(/^include_stage__/, ""));
					config['stage_ids'] = config['stage_ids'].filter(function (x) {
						return x != stageId;
					});
				} else {
					config[name] = isChecked;
				}
			});

			return config;
		}
	}, {
		key: 'beginDownload',
		value: function beginDownload() {
			var config = this.buildDownloadConfig();
			var redirectWindow = window.open();
			var options = {
				data: config,
				url: reverse('download-redirect'),
				noAlert: true,
				callback: function callback(response) {
					if (response.url) {
						redirectWindow.location.assign(response.url, '_blank');
					}
				}
			};
			ajax.post(options);
		}
	}]);

	return DownloadModal;
}(_modals.Modal);

module.exports = {
	DownloadModal: DownloadModal,
	DownloadPoll: DownloadPoll
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1821);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(36);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(37);
var createDesc = __webpack_require__(158);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var hide = __webpack_require__(65);
var has = __webpack_require__(75);
var SRC = __webpack_require__(159)('src');
var $toString = __webpack_require__(1224);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(88).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(21);
var defined = __webpack_require__(99);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Class = __webpack_require__(157);
var chide = __webpack_require__(230);
var Fields = __webpack_require__(844);
var GuideStar = __webpack_require__(846);
var PageStatus = __webpack_require__(2360);
var AdvancedBranching = __webpack_require__(1208);
var modals = __webpack_require__(6);
var Dropdown = __webpack_require__(22);
var ElementSearch = __webpack_require__(1207);

var _require = __webpack_require__(406),
    Looping = _require.Looping,
    Branching = _require.Branching;

var _require2 = __webpack_require__(27),
    randomString = _require2.randomString;

var Callout = __webpack_require__(901).default;

// TODO: make params to Editor
var EDIT_URL = '.';
var ALLOW_SAVE = true;

var hashCode = function hashCode(str) {
	var hash = 0;
	var i = void 0;
	var char = void 0;

	if (str.length == 0) {
		return hash;
	}
	for (var _i = 0; _i < str.length; _i++) {
		char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
};

var truncate = function truncate(val, limit) {
	if (val.length > limit) {
		return val.substring(0, limit - 3) + '...';
	}
	return val;
};

var Page = $.klass({
	placeholder: '<li class="placeholder">' + gettext('You haven\'t added any questions yet. To get started, drag a question from the left panel onto this area.') + ' </li>',
	visible: false,
	rendered: false,

	options: {
		label: Class.create(chide.opts.Text, {
			inputClass: 'text short',
			help: gettext('About Page Labels - Page labels allow you to create named pages of your survey that can then be branched to.'),
			label: gettext('Page Label'),
			display: function display(justIndex) {
				return this.get() ? this.get() : justIndex ? this.page.index + 1 : gettext('Page') + ' ' + (this.page.index + 1);
			},
			changed: function changed(_value) {
				this.page.element.trigger('pageLabelChanged', [this.page, this]);
			}
		}),

		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize questions on this page'),
			help: gettext('About Randomize - Check this option if you would like the questions on this page to be shown in a random order every time this survey is taken.'),
			enabled: true
		})
	},

	initialize: function initialize(config) {
		this.id = randomString(10);
		this.fields = [];
		$.extend(this, config);

		this.editor = this.survey.editor;

		this.randomize = new this.options.randomize({
			value: this.info === undefined ? false : !!this.info.randomize
		});

		this.label = new this.options.label({
			page: this,
			value: config.info && config.info.label ? config.info.label : undefined
		});

		if (this.element) {
			this.element.html(this.placeholder);
		}

		if (this.info && this.info.children.length) {
			for (var j = 0; j < this.info.children.length; j++) {
				this.addField(undefined, this.info.children[j]);
			}
		}
	},

	renderOptions: function renderOptions() {
		return $('<div/>', {
			class: 'option-group'
		}).append(this.label.render(), this.randomize.render());
	},

	render: function render() {
		if (!this.rendered) {
			$.each(this.fields, function () {
				this.render();
			});
			this.rendered = true;
		}

		this.bind('fieldRemoved', this.fieldRemoved);
		this.survey.resizeSideBySide();
	},

	isBranched: function isBranched() {
		if (this.branching && this.branching.length) {
			return true;
		}

		var result = false;

		$.each(this.fields, function () {
			if (this.choices && this.choices.value) {
				$.each(this.choices.value, function () {
					if (this.branching && this.branching.value) {
						result = true;
					} else if (this.field && this.field.branchingOptions) {
						$.each(this.field.branchingOptions, function () {
							if (this.value && this.value !== '-1') {
								result = true;
							}
						});
					}
				});
			}
		});

		return result;
	},

	isLooped: function isLooped() {
		return this.survey.looping.pageIsLooped(this);
	},

	removeField: function removeField(field, remove, fade) {
		var index = this.fields.indexOf(field);
		this.fields.splice(index, 1);

		if (remove === undefined ? true : remove) {
			this.survey.removeBranchingRulesWithVariable(field.id);
			field.removed = true;
			if (fade !== false) {
				field.element.fadeOut(500, function () {
					$(this).remove();
				});
			} else {
				field.element.remove();
			}
		}
		this.trigger('fieldRemoved', {
			survey: this.survey,
			field: field
		});
	},

	addExistingField: function addExistingField(field, pos) {
		var before = undefined;

		field.page = this;

		try {
			if (typeof pos == 'undefined' || pos === undefined) {
				before = undefined;
			} else if (typeof pos == 'number' && pos >= -1) {
				before = this.fields[pos < 0 ? 0 : pos];
			} else if (pos.element !== undefined) {
				before = pos;
			} else {
				before = $(pos).firstAttached(Fields.Field);
			}
		} catch (ex) {
			before = undefined;
		}

		if (before !== undefined) {
			if (pos < 0) {
				this.fields.splice(0, 0, field);
				field.element.insertBefore(before.element);
			} else {
				field.element.insertAfter(before.element);
				this.fields.splice(this.fields.indexOf(before) + 1, 0, field);
			}
		} else {
			field.element.appendTo(this.element).css('display', 'none').fadeIn(500);

			this.fields.push(field);
		}

		if (this.visible) {
			field.render();
			//Fix cursor for chrome
			field.element[0].onselectstart = function () {
				return false;
			};
		}
	},

	buildField: function buildField(type, info) {
		return $('<li class="field"></li>').attr('name', type.qlass).attachAndReturn(type.constructor, info, this.editor)[0];
	},

	addField: function addField(type, info, pos, _bank) {
		// no type specified, find the type from the info
		if (type === undefined && info !== undefined) {
			if (info.idname === undefined) {
				/*
    YOU SHOULD NOT HAVE TO ADD NEW QUESTION TYPES TO THIS SECTION
    ANYMORE IT IS HERE FOR BACKWARDS COMPATABILITY
    */
				if (info.grouped === true) {
					if (info.children && info.children[0] && info.children[0].name && info.children[0].name.split('_')[info.children[0].name.split('_').length - 1] === '0') {
						info.children[0].name = info.children[0].name.substring(0, info.children[0].name.length - 2);
					}

					if (info.custom == true) {
						type = Fields.Natrix.prototype;
						if (info.threed == true) {
							type = Fields.ThreeDGridField;
						}
					} else if (info.children[0].type == 'string') {
						type = Fields.TextGridField;
					} else if (info.children[0].type == 'dropdown') {
						type = Fields.DropDownGridField;
					} else if (info.children[0].type == 'multiple') {
						type = Fields.MultipleChoiceGridField;
					}
				} else if (info.children.length === 0) {
					type = Fields.SectionField;
				} else if (info.children[0].type == 'datetime') {
					type = Fields.DateTimeField;
				} else if (info.children[0].type == 'string') {
					type = Fields.TextField;
				} else if (info.children[0].type == 'single') {
					type = Fields.SingleChoiceField;
				} else if (info.children[0].type == 'dropdown') {
					type = Fields.DropDownChoiceField;
				} else if (info.children[0].type == 'multiple') {
					type = Fields.MultipleChoiceField;
				}
			} else {
				type = info.idname;
			}
		}

		if (typeof type === 'string') {
			// it's a name, lookup type in the type mapping
			type = this.survey.fieldTypes[type];
		} else if (typeof type === 'function') {
			// it's a constructor, get the prototype
			type = type.prototype;
		}

		// bad or unknown field type
		if (type === undefined || type.qlass === undefined) {
			return;
		}

		var field = this.buildField(type, info);

		this.addExistingField(field, pos);

		if (this.visible) {
			this.rendered = true;
		}

		this.survey.resizeSideBySide();

		return field;
	},

	fieldRemoved: function fieldRemoved(event, info) {
		info.survey._formatInfo = null;
		info.survey.editor.pageStatusView.render();
		info.survey.editor.toolbox.css('margin-top', 0);
	},

	formatInfo: function formatInfo() {
		var questions = [];

		$('li.field', this.element).each(function (_j) {
			questions.push($(this).firstAttached(Fields.Field).id);
		});

		return {
			page: this.label.display(),
			index: this.index,
			id: this.id,
			questions: questions
		};
	},

	/// Shows the advanced branching wizard dialog for this page.
	showBranchingWizard: function showBranchingWizard() {
		var that = this;

		// force-regenerate the survey info
		this.survey._formatInfo = null;

		var wizard = new AdvancedBranching({
			survey: this.survey,
			branching: this.branching,
			page: this,
			callback: function callback(branching, _otherwise) {
				that.branching = branching;

				that.survey.editor.pageStatusView.render();

				$('#survey-editor-page-options').empty().append(that.renderOptions().attr('id', 'survey-editor-page-options'));
			}
		});

		wizard.show();
	},

	renderBranchingSelect: function renderBranchingSelect() {
		var choices = [];

		$.each(this.survey.pages.slice(this.index + 1), function (_i) {
			choices.push([this.id, this.label.get() || gettext('Page') + ' ' + (this.index + 1)]);
		});

		return chide.opts.renderSelect(choices, '---');
	},

	getBranchingSelect: function getBranchingSelect() {
		return (this._branchingSelect || (this._branchingSelect = this.renderBranchingSelect())).clone();
	}
});

var Survey = $.klass({
	defaults: {
		title: gettext('Title'),
		description: ''
	},

	fieldTypes: undefined,

	stripScriptTags: function stripScriptTags(val) {
		return val.replace(/<script/g, '<!--<script').replace(/<\/script>/g, '</script>-->');
	},

	initialize: function initialize(config) {
		$.extend(this, config);

		var that = this;

		this.title = new (Class.create(chide.opts.Text, {
			changed: function changed(val) {
				$('.sma-js-form-title').html(truncate(that.stripScriptTags(val), 50));
			}
		}))({
			value: this.defaults.title
		});

		this.description = new (Class.create(chide.opts.Html, {
			changed: function changed(val) {
				$('.sma-js-form-description').html(that.stripScriptTags(val));
			}
		}))({
			value: this.defaults.description
		});

		this.looping = new Looping(this);

		this.pages = [];
		this.currentPage = undefined;
		this.questions = {};
		this.nameMapping = {};
		this.pageMapping = {};

		this._refreshPages();
	},

	_refreshPages: function _refreshPages() {
		var _this = this;

		var that = this;

		this._formatInfo = undefined;

		this.pageMapping = {};

		var refresh = function refresh() {
			$('a.page-button').text(function (i) {
				return that.pages[i].label.display(true);
			});
			try {
				$('.page-buttons').sortable('refresh');
			} catch (e) {
				// eslint-disable-line
			}
		};

		for (var i = 0; i < this.pages.length; i++) {
			this.pages[i].index = i;
			this.pageMapping[this.pages[i].id] = this.pages[i];
		}

		// HACK
		Fields.Helpers.mapping = this.pageMapping;

		this.questions = {};

		var _loop = function _loop(_i2) {
			$.each(_this.pages[_i2].fields, function () {
				that.questions[this.id] = this;
				if (this.hasChoiceBranching) {
					if (!Branching.Simple.prototype.isValid(this)) {
						alert($.format(gettext('Please note that skipping on page {0} has been removed due to this change.'), [_i2 + 1]));
						Branching.Simple.prototype.reset(this);
					}
				}
			});
		};

		for (var _i2 = 0; _i2 < this.pages.length; _i2++) {
			_loop(_i2);
		}

		this.looping.checkLoops();
		refresh();
	},

	removeBranchingConditionWithVariable: function removeBranchingConditionWithVariable(condition, variableId) {
		var that = this;

		if (condition.items === undefined) {
			// normal condition
			if (variableId === condition.variable) {
				return null;
			}
		} else {
			// sub conditions
			var someInvalidCondition = condition.items.filter(function (subcondition) {
				return that.removeBranchingConditionWithVariable(subcondition, variableId) === null;
			});

			if (someInvalidCondition.length !== 0) {
				return null; // if any condition is invalid, remove the rule or condition (the parent)
			}
		}

		return condition;
	},

	removeBranchingRulesWithVariable: function removeBranchingRulesWithVariable(variableId) {
		var that = this;

		$.each(this.pages, function (_p) {
			if (this.branching) {
				this.branching = this.branching.map(function (rule) {
					rule.condition = that.removeBranchingConditionWithVariable(rule.condition, variableId);
					return rule;
				}).filter(function (rule) {
					return rule.condition !== null;
				});
			}
		});
	},

	getBranchTargets: function getBranchTargets(fromPage) {
		if (fromPage == undefined) {
			fromPage = this.currentPage;
		}

		var index = this.pages.indexOf(this.currentPage);

		return this.pages.slice(index + 1);
	},

	getPageById: function getPageById(id) {
		return this.pageMapping[id];
	},

	getFieldCount: function getFieldCount() {
		var total = 0;
		$.each(this.pages, function () {
			total += this.fields.length;
		});
		return total;
	},

	getFieldArray: function getFieldArray(fields, page) {
		page = page === undefined ? this.currentPage : page;

		return $.map($.makeArray(fields), function (el) {
			try {
				if (typeof el === 'number' && el >= 0) {
					return page.fields[el];
				} else if (el instanceof Fields.Field) {
					return el;
				} else {
					return $(el).firstAttached(Fields.Field);
				}
			} catch (ex) {
				return null;
			}
		});
	},

	getAllFields: function getAllFields() {
		var result = [];
		$.each(this.pages, function (i, page) {
			$.each(page.fields, function (i, field) {
				result.push(field);
			});
		});
		return result;
	},

	getTarget: function getTarget(target, info) {
		var rowRe = /^([-a-zA-Z0-9]+)\[(.+?):\]$/;
		var colRe = /^([-a-zA-Z0-9]+)\[:(.+?)\]$/;

		var row = rowRe.exec(target);
		try {
			if (row != null) {
				return {
					id: target,
					label: info.questions[row[1]].rows[row[2]].label
				};
			}

			var col = colRe.exec(target);
			if (col != null) {
				return {
					id: target,
					label: info.questions[col[1]].types[col[2]].label
				};
			}

			if (info.variables[target]) {
				return {
					id: target,
					label: info.variables[target].label
				};
			}

			if (info.questions[target]) {
				return {
					id: target,
					label: info.questions[target].label
				};
			}

			if (this.nameMapping[target]) {
				return {
					id: this.nameMapping[target].id,
					label: info.questions[this.nameMapping[target].id].label
				};
			}
		} catch (e) {
			return {
				id: '-',
				label: 'INVALID'
			};
		}

		return {
			id: '-',
			label: 'INVALID'
		};
	},

	removePage: function removePage(i) {
		var _this2 = this;

		var that = this;

		if (i === undefined) {
			i = this.pages.indexOf(this.currentPage);
		}

		if (this.pages.length <= 1) {
			return false;
		}

		new modals.CheckboxModal(gettext('Delete page'), gettext('Deleting this page from this form will also delete any associated data that has been collected from users of this form.'), gettext('Yes, I understand that upon saving this form the questions within this page and any associated data will be permanently deleted and that this action cannot be undone.'), function () {
			var page = _this2.pages[i];

			_this2.trigger('fieldsRemoved', {
				fields: page.fields
			});

			_this2.trigger('pageRemoved', {
				page: page,
				index: i
			});

			// TODO: make this bind instead of calling
			_this2.looping.pageRemoved({
				page: page,
				index: i
			});

			$.each(page.fields, function () {
				var name = this.name.get();

				if (name !== undefined && that.nameMapping[name]) {
					delete that.nameMapping[name];
				}
			});

			page.element.remove();

			_this2.pages.splice(i, 1);

			_this2._refreshPages();

			if (page === _this2.currentPage) {
				_this2.switchPage(i >= _this2.pages.length ? _this2.pages.length - 1 : i);
			}

			_this2.trigger('afterPageRemoved', {
				page: page,
				index: i
			});
		}, {
			destroyOnClose: true,
			contingent: true,
			isDelete: true
		});
	},

	removeFields: function removeFields(fields) {
		fields = this.getFieldArray(fields);

		this.trigger('fieldsRemoved', {
			fields: fields
		});
		for (var i = 0; i < fields.length; i++) {
			fields[i].page.removeField(fields[i]);
			this.looping.fieldRemoved(fields[i].id);
			if (fields[i].name.value in this.nameMapping) {
				delete this.nameMapping[fields[i].name.value];
			}
		}
	},

	moveFields: function moveFields(fields, page) {
		fields = this.getFieldArray(fields);

		for (var i = 0; i < fields.length; i++) {
			fields[i].page.removeField(fields[i], false);
			page.addExistingField(fields[i]);
		}
	},

	movePage: function movePage(oldPos, newPos) {
		if (oldPos != newPos) {
			$('> .page', this.element).eq(oldPos)[oldPos > newPos ? 'insertBefore' : 'insertAfter']($('> .page', this.element).eq(newPos));

			var removed = this.pages.splice(oldPos, 1)[0];
			this.pages.splice(newPos, 0, removed);

			this._refreshPages();

			this.switchPage(newPos, true);
		}
	},

	switchPage: function switchPage(i, pageMove) {
		var oldPage = this.currentPage;

		if (oldPage !== undefined) {
			oldPage.visible = false;
		}

		this.currentPage = this.pages[i];
		this.currentPage.visible = true;

		$('> .page', this.element).removeClass('active');
		this.currentPage.element.addClass('active');
		this.currentPage.render();

		this.trigger('pageSwitched', {
			page: this.currentPage,
			index: i,
			pageMove: !!pageMove
		});
	},

	addEmptyPage: function addEmptyPage(index) {
		if (index === undefined) {
			index = this.pages.indexOf(this.currentPage);
			if (index === -1) {
				index = undefined;
			} else {
				index += 1;
			}
		}
		return this.addPage(undefined, index, true);
	},

	beforeAddPage: function beforeAddPage() {
		return true;
	},

	addPage: function addPage(info, index, show) {
		if (show && this.element.triggerHandler('beforeAddPage', {}) === false) {
			return false;
		}

		var page = $('<ol class="page"></ol>').attachAndReturn(Page, {
			survey: this,
			info: info,
			// when loading pages, use the index as the page ID to avoid hacks for branching
			id: info !== undefined ? this.pages.length.toString() : undefined,
			visible: !!show
		})[0];

		if (index === undefined || index >= this.pages.length) {
			index = undefined;
			this.element.append(page.element);
			this.pages.push(page);
		} else {
			page.element.insertBefore($('ol.page', this.element).eq(index));
			this.pages.splice(index, 0, page);
		}

		this._refreshPages();

		this.trigger('pageAdded', {
			page: page,
			index: index,
			show: show
		});

		if (show) {
			this.switchPage(page.index);
		}

		return page;
	},

	formatInfo: function formatInfo() {
		if (!this._formatInfo) {
			var pages = [];
			var pageMapping = {};
			var metas = ['_ip_address', '_locale', '_language', '_invite_email', '_weighted_score'];
			var questions = {};
			var languages = {};

			_.each(this.editor.languages.list, function (el) {
				languages[el.code] = el.name;
			});

			var variables = {};
			var namedVars = {};

			$.each(this.pages, function (i, el) {
				pages.push(pageMapping[el.id] = el.formatInfo());
				$.each(el.fields, function (i, el) {
					var q = el;
					questions[el.id] = el.formatInfo();
					$.each(el.getVariables(), function (i, el) {
						variables[el.id] = el.serialize();
						if (q.name.get()) {
							namedVars[q.name.get()] = namedVars[q.name.get() + '_' + i] = variables[el.id];
						}
					});
				});
			});

			this._formatInfo = {
				pages: pages,
				pageMapping: pageMapping,
				questions: questions,
				variables: variables,
				namedVars: namedVars,
				metas: metas,
				resolveVariable: function resolveVariable(name) {
					if (name in namedVars) {
						return namedVars[name];
					} else if (/^_cv_/.test(name)) {
						return {
							id: name,
							label: 'Collector variable [' + name.substring(4) + ']',
							type: 'string'
						};
					} else if (/^_gv_/.test(name)) {
						return {
							id: name,
							label: 'GET variable [' + name.substring(4) + ']',
							type: 'string'
						};
					} else if (name in variables) {
						return variables[name];
					} else {
						return null;
					}
				}
			};
		}

		return this._formatInfo;
	},

	load: function load(info) {
		this.title.set(info.title);
		this.description.set(info.description);

		this.render();

		if (!info.form) {
			this.addEmptyPage();
			return;
		}

		for (var i = 0; i < info.form.length; i++) {
			this.addPage(info.form[i], undefined, false);
		}

		/* update branching rules to use page IDs */
		$.each(this.pages, function () {
			var page = this;

			if (page.info.branching) {
				page.branching = page.info.branching;
			}

			$.each(page.fields, function () {
				Fields.Helpers.normalizeField(this);
			});
		});

		this.resizeSideBySide();
	},

	serialize: function serialize() {
		var that = this;
		var pages = [];

		_.each(this.pages, function (el) {
			var page = {
				type: 'page',
				children: []
			};

			$('li.field', el.element).each(function () {
				page.children.push($(this).firstAttached(Fields.Field).serialize());
			});

			if (el.randomize.get()) {
				page.randomize = true;
			}

			if (el.branching) {
				var rules = AdvancedBranching.updateRules(that.formatInfo(), el.branching);

				page.branching = _.map(rules, function (rule) {
					return rule.serialize(that.formatInfo());
				});

				page.branching = AdvancedBranching.unserializePageIDs(that.formatInfo(), page.branching);
			}

			if (el.label.value && el.label.get()) {
				page.label = el.label.value;
			}

			pages.push(page);
		});

		return {
			title: this.title.value,
			description: this.description.value,
			languages: this.editor.languages.list,
			languageDisplayStyle: this.editor.languages.displayStyle,
			form: pages
		};
	},

	resizeSideBySide: function resizeSideBySide() {
		var max = 64;
		var group = $('.field-inline');

		$(group).each(function (x, el) {
			if ($(el).height() > max) {
				max = $(el).height();
			}
		});

		$(group).height(max);
	},

	render: function render() {
		var that = this;

		$('> div.title', this.element).empty().append($('<p class="description text-muted"></p>').append(that.description.render()).append('<a href="#" class="sma-js-form-description-edit sma-form-description-edit float-right">' + gettext('Edit description') + '<i class="nc-icon-mini ui-1_pencil ml-2"></i></a>\
			<a href="#" class="sma-js-form-description-edit-done btn btn-primary" style="display:none">' + gettext('Done') + '</a>\
			<span class="sma-js-form-description">' + this.description.get() + '</span>'));

		this.element.delegate('ol.page > li.field > div > a.remove', 'click', function (e) {
			that.editor.removeField($(this).parents('.page').find('li.field.active'), e);
		});

		this.element.delegate('ol.page > li.field > div > a.duplicate', 'click', function (e) {
			that.editor.duplicateField($(this).parents('.page').find('li.field.active'), e);
		});

		this.element.delegate('ol.page > li.field > div > a.move', 'click', function (e) {
			that.editor.moveField($(this).parents('.page').find('li.field.active'), e);
		});

		this.element.delegate('ol.page > li.field > div > a.looping', 'click', function (e) {
			that.editor.openLooping($(this).closest('li.field'), e);
		});

		$(this.title._input).hide();
		$(this.description._input).hide();
	},

	renderOptions: function renderOptions() {
		var result = $('<div></div>').addClass('option-group');
		return result;
	},

	getPageDropdown: function getPageDropdown(extra_choices, blankChoice, exclude_pages) {
		var choices = [];

		$.each(this.pages, function (i, page) {
			if (exclude_pages && exclude_pages.indexOf(i) > -1) {
				return true;
			}
			choices.push([i, page.label.display(false)]);
		});
		return chide.opts.renderSelect($.merge(choices, extra_choices), blankChoice, false);
	}
});

var Editor = $.klass({
	/* the content shown for field options when no field is selected */
	emptyFieldOptionContent: '<div class="alert alert-info no-options">' + gettext('Please select a field on the right.') + '</div>',

	multipleFieldOptionContent: '<div class="alert alert-info">' + gettext('You cannot change the properties on multiple fields at a time.') + '</div>',

	clipboardUrl: '',
	form_is_live: false,

	fieldTypes: function () {
		var types = {};

		$.each(['SectionField', 'TextField', 'TextGridField', 'SingleChoiceField', 'SingleChoiceGridField', 'DropDownChoiceField', 'DropDownGridField', 'MultipleChoiceField', 'MultipleChoiceGridField', 'Natrix', 'ThreeDGridField', 'HiddenField', 'NetPromoter', 'DateTimeField', 'DatasourceField', 'DrillDownField', 'RankingField', 'FileField', 'JavaScript', 'Signature', 'UploadField'], function () {
			types[Fields[this].prototype.qlass] = Fields[this].prototype;
		});
		$.each(GuideStar.GuideStarFields, function () {
			types[this.prototype.qlass] = this.prototype;
		});

		return types;
	}(),

	initialize: function initialize(options) {
		var _this3 = this;

		// Need to clear existing instances of the Editor, the array can build up
		// if there's no page refresh while jumping between forms in the workflow.
		Fields.Field.instances = [];
		Editor.instances = [];

		var that = this;

		$.extend(this, options);

		this.loader = new sma.components.Loader(this.element);

		if (options.hideBackButton !== undefined && options.hideBackButton) {
			this.backButton = '';
		} else {
			this.backButton = $('<a></a>', {
				href: options.backURL !== undefined ? options.backURL : '#',
				html: '<i class="nc-icon-mini arrows-1_minimal-left"></i><span class="sma-back-to-referrer">' + gettext('Back') + '</span>',
				click: function click(_e) {
					if (options.backURL) {
						return;
					}
					history.back();
					return false;
				}
			});
		}

		this.closeWindow = options.closeWindow !== undefined ? options.closeWindow : false;

		this.element.append($('<div class="row sma-back-row"></div>').append($('<div class="col-12"></div>').append(this.backButton)));

		this.topRow = $('<div class="row"></div>');
		this.topRow.appendTo(this.element);

		this.initializeToolbox();

		this.pages = $('<div class="pages"><div class="page-status"></div><div class="title"></div></div>').click(function (e) {
			if ($(e.target).is('a.remove')) {
				return false;
			}
			var chain = $(e.target).parents('ol.page, li.field').add(e.target);
			if (chain.filter('ol.page').length) {
				if (chain.filter('li.field').length) {
					_this3.fieldsSelected(chain.filter('li.field'), e);
				} else {
					_this3.fieldsSelected();
				}
			}
		});

		this.pages[0].onselectstart = function () {
			return false;
		};

		this.pages.prepend($('<div class="float-sm-right"></div>').append(this.previewButton).append(this.topSaveButton));

		this.initializeLanguages();

		chide.opts.Text.prototype.languages = this.languages;

		// TODO: this should come much earlier
		this.survey = this.pages.attachAndReturn(Survey, {
			editor: this,
			fieldTypes: this.fieldTypes
		})[0];

		$(this.survey.element).bind({
			beforeRemovePage: $.proxy(this.beforeRemovePage, this),
			pageRemoved: $.proxy(this.pageRemoved, this),
			pageSwitched: $.proxy(this.pageSwitched, this),
			beforeAddPage: $.proxy(this.beforeAddPage, this)
		});

		this.pageStatusView = new PageStatus({
			survey: this.survey,
			el: this.pages.find('.page-status')
		});

		if (ALLOW_SAVE) {
			this.showConfirmMessage = true;
			$('.tools li.tool:not(.delete, .preview, .groups, .duplicate, .rename) a, .back-to-surveys, #view-options a').mouseup(function (e) {
				/* Only do these for the left mouse button
     * 0 - Left Button
     * 1 - Middle Button
     * 2 - Right Button
     */
				if (e.button == 0) {
					var target = $(this);

					if (that.showConfirmMessage && (!target.attr('target') || target.hasClass('preview-link'))) {

						e.preventDefault();
						window.onbeforeunload = function () {};

						that.save(function () {
							that.showConfirmMessage = false;
							if (target.attr('target') == '_blank') {
								window.open(target.attr('href'));
							} else {
								window.location = target.attr('href');
							}
						});
					}
				}
			});
		}

		$('.survey-tools li.tool.delete, .survey-tools li.tool.rename').click(function () {
			window.onbeforeunload = function () {};
		});

		var isCtrl = false;
		$(document).keydown(function (e) {
			if (e.which == 17) {
				isCtrl = true;
				setTimeout(function () {
					isCtrl = false;
				}, 2000);
				return;
			}
			if (e.which == 'S'.charCodeAt(0) && isCtrl) {
				//s
				that.save();
				e.preventDefault();
			}
		});
		$(document).keyup(function (e) {
			if (e.which == 17) {
				setTimeout(function () {
					isCtrl = false;
				}, 0);
				return;
			}
		});

		this.keydownHotKeys = function (e) {
			if ($('ol.page.active li.field.active').length == 1 && $('ol.page.active li.field.active').eq(0).attr('name') == 'javascript') {
				return;
			}
			if (e.which == 'A'.charCodeAt(0) && isCtrl) {
				//a
				e.preventDefault();
				that.fieldsSelected($('ol.page.active li.field'));
			} else if (e.which == 'D'.charCodeAt(0) && isCtrl) {
				//d
				e.preventDefault();
				var numberOfQuestions = $('ol.page li.field.active').length;

				if (numberOfQuestions > 0) {
					sma.components.Dialog.ConfirmDialog(gettext('Delete the selected questions?'), function () {
						var surv = Survey.instances[0];
						surv.removeFields($('ol.page li.field.active'));
						that.fieldsSelected();
					});
				}
			} else if (e.which == 46) {
				//del
				if ($('ol.page li.field.active').length > 0) {
					e.preventDefault();
					sma.components.Dialog.ConfirmDialog(gettext('Delete the selected questions?'), function () {
						var surv = Survey.instances[0];
						surv.removeFields($('ol.page li.field.active'));
						that.fieldsSelected();
					});
				}
			} else if (e.which == 34) {
				//Page Down
				e.preventDefault();
				var surv = Survey.instances[0];
				if (that.getPages().length - 1 == surv.currentPage.index) {
					return;
				}
				surv.switchPage(surv.currentPage.index + 1);
			} else if (e.which == 33) {
				//Page Up
				e.preventDefault();
				var _surv = Survey.instances[0];
				if (_surv.currentPage.index == 0) {
					return;
				}
				_surv.switchPage(_surv.currentPage.index - 1);
			} else if (e.which == 'C'.charCodeAt(0) && isCtrl) {
				//c
				if (!$('input[type=text]:focus, textarea:focus').length) {
					e.preventDefault();
					Fields.Actions.copy.handler.apply(this, [$('ol.page li.field.active'), null, null, false]);
				}
			} else if (e.which == 'V'.charCodeAt(0) && isCtrl) {
				//v
				if (!$('input[type=text]:focus, textarea:focus').length) {
					e.preventDefault();
					Fields.Actions.paste.handler.apply(this, [$('ol.page li.field.active'), true]);
				}
			}
		};

		this.load(function () {
			_this3.initializeLoaded();
			_this3.hashedJson = hashCode(_this3.serialize().survey);
		});

		$('[data-toggle="tooltip"]').tooltip();

		var guidestarFields = $('.sma-guidestar-questions');
		this.element_search = new ElementSearch({
			container: guidestarFields,
			showAllOnEmpty: true
		});
		guidestarFields.prev().toggle();
	},

	initializeLoaded: function initializeLoaded() {
		var _this4 = this;

		var that = this;

		this.viewport = $('<div class="viewport"></div>');

		this.previewButton = $('<a></a>', {
			html: gettext('Preview'),
			class: 'page-preview-link btn btn-default',
			id: 'sma-btn-preview',
			href: reverse('surveys-preview', {
				survey_id: this.surveyID
			}),
			click: function click(e) {
				var redirectWindow = window.open($(e.currentTarget).attr('href'), '_blank');
				e.preventDefault();
				$.ajax({
					type: 'post',
					url: reverse('surveys-preview-save', {
						survey_id: _this4.surveyID
					}),
					data: {
						survey: _this4.serialize().survey
					},
					success: function success(_response) {
						redirectWindow.location();
					}
				});
			}
		});

		var surveyFullTitle = that.survey.title.get();
		var surveyDisplayTitle = truncate(surveyFullTitle, 50);

		this.viewport.append($('<div class="survey-top"></div>').append($('<div class="top-left">').append(that.survey.title.render()).append('<span class="sma-js-form-title" title="' + surveyFullTitle + '">' + surveyDisplayTitle + '</span>\n\t\t\t\t<i class="nc-icon-mini ui-1_pencil sma-js-form-title-edit sma-form-title-edit ml-2"></i>')).append($('<div class="top-right">').append($('<a class="top-right-button advanced-branching" href="#" data-toggle="tooltip" title="' + gettext('Branching Editor') + '"><i class="nc-icon-outline arrows-2_split-round"></i></a>'), $('<span class="languages d-inline-block" data-toggle="tooltip" title="' + gettext('Editing Language') + '"/>').append(this.languageSelector.$el.addClass('btn-group')), this.buildPageButtons(), $('<span class="page d-inline-block"/>').append(this.buildPageSelect())))).append(this.pages);

		var footer = $('<div class="sma-button-footer fixed-bottom"></div>');

		var footerLeft = $('<div class="sma-button-footer-left"></div>').append(this.previewButton);
		footer.append(footerLeft);

		var footerCenter = $('<div class="sma-button-footer-center"></div>').append($('<a></a>', {
			class: 'btn btn-default btn-loud',
			id: 'sma-btn-cancel',
			href: '#',
			html: gettext('Cancel'),
			click: function click(e) {
				e.preventDefault();
				if (that.closeWindow) {
					window.close();
				}
				window.history.back();
			}
		}),

		// Save button
		$('<a></a>', {
			class: 'save-top-link btn btn-primary btn-loud',
			id: 'sma-btn-save',
			href: '#',
			html: gettext('Save'),
			click: function click(e) {
				e.preventDefault();
				that.save();
				that.survey.editor.pageStatusView.render();
			}
		}),

		// Save and close button
		$('<a></a>', {
			class: 'save-top-link btn btn-primary btn-loud',
			id: 'sma-btn-save-close',
			href: '#',
			html: gettext('Save & close'),
			click: function click(e) {
				e.preventDefault();
				that.save(function () {
					if (that.closeWindow) {
						window.close();
					}
					if (that.backURL !== undefined) {
						window.location.href = that.backURL;
					} else {
						window.history.back();
					}
				});
			}
		}));
		footer.append(footerCenter);

		var footerRight = $('<div class="sma-button-footer-right"></div>');
		footer.append(footerRight);

		this.viewport.append(footer);

		this.viewport.on('click', '.advanced-branching', function (e) {
			e.preventDefault();
			that.survey.currentPage.showBranchingWizard();
			return false;
		});

		$(that.survey.title._input).hide();

		this.viewport.on('click', '.sma-js-form-title-edit', function () {
			$(that.survey.title._input).show();
			$(that.survey.title._input).focus();
			$('.sma-js-form-title').hide();
			$('.sma-js-form-title-edit').hide();
		});

		$(that.survey.title._input).keypress(function (e) {
			if (e.which != 13) {
				return;
			}
			$(that.survey.title._input).hide();
			$('.sma-js-form-title').show();
			$('.sma-js-form-title-edit').show();
		});

		$(that.survey.title._input).blur(function () {
			$(that.survey.title._input).hide();
			$('.sma-js-form-title').show();
			$('.sma-js-form-title-edit').show();
		});

		this.viewport.on('click', '.sma-js-form-description-edit', function () {
			$(that.survey.description._input).show();
			$(that.survey.description._input).focus();
			$('.sma-js-form-description-edit-done').show();
			$('.sma-js-form-description').hide();
			$('.sma-js-form-description-edit').hide();
		});

		this.viewport.on('click', '.sma-js-form-description-edit-done', function () {
			$(that.survey.description._input).hide();
			$('.sma-js-form-description-edit-done').hide();
			$('.sma-js-form-description').show();
			$('.sma-js-form-description-edit').show();
		});

		this.topRow.append($('<div class="col-8"></div>').append(this.viewport));

		if (!this.pages.length) {
			this.survey.addEmptyPage();
		}

		this.survey.switchPage(0);
	},

	buildPageSelect: function buildPageSelect() {
		var that = this;
		var survey = this.survey;

		var refresh = function refresh(e, val) {
			pageSelect.empty();

			$.each(survey.pages, function (i, page) {
				var current;

				if (this.survey.currentPage !== undefined) {
					current = this.survey.currentPage.index;
				} else {
					current = val ? val !== undefined : 0;
				}

				var opt = $('<option>', {
					text: page.label.display(),
					value: i
				});

				if (current == i) {
					opt.attr('selected', 'selected');
				}

				opt.appendTo(pageSelect);

				$.each(page.fields, function (i, field) {
					var title = field.name.get() ? '[' + field.name.get() + '] ' + $('<div/>', {
						html: field.title.get()
					}).text() : $('<div/>', {
						html: field.title.get()
					}).text();
					var label = '&nbsp;&nbsp;&nbsp;&#8627;&nbsp;' + (title.length > 40 ? title.substring(0, 35) + '...' : title);
					var inner = $('<option>', {
						disabled: true,
						html: label,
						value: field.id
					});
					inner.appendTo(pageSelect);
				});
			});

			if (survey.pages.length == 1) {
				that.removePageButton.hide();
			} else {
				that.removePageButton.show();
			}
		};

		var pageSelect = $('<select/>').addClass('form-control').bind('focus', function (e) {
			var val = $(this).val();
			refresh(e, val);
		}).change(function () {
			survey.switchPage($(this).val());
		});

		refresh();

		survey.element.bind({
			'pageAdded pageRemoved afterPageRemoved': refresh,
			pageLabelChanged: function pageLabelChanged(e, page, label) {
				$('option:selected', pageSelect).text(label.display());
			},
			pageSwitched: function pageSwitched(e, info) {
				if (info.pageMove) {
					refresh();
				}
				pageSelect.val(info.index);
			}
		});

		return pageSelect;
	},

	buildPageButtons: function buildPageButtons() {
		var that = this;

		this.addPageButton = $('<a/>', {
			href: '#',
			text: gettext('Add'),
			title: gettext('Add new page'),
			'data-toggle': 'tooltip',
			html: '<i class="nc-icon-mini ui-1_bold-add"></li>',
			click: function click(e) {
				e.preventDefault();
				that.survey.addEmptyPage();
			}
		});

		this.removePageButton = $('<a/>', {
			href: '#',
			text: gettext('Remove'),
			title: gettext('Delete current page'),
			'data-toggle': 'tooltip',
			html: '<i class="nc-icon-mini ui-1_trash-simple"></li>',
			click: function click(e) {
				e.preventDefault();
				that.survey.removePage();
			}
		});

		return $('<span/>', {
			class: 'd-inline-block page-buttons'
		}).append(this.addPageButton, this.removePageButton);
	},

	getPages: function getPages() {
		return $('ol.page', this.pages);
	},

	escapeHtml: function escapeHtml(unsafe) {
		return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
	},

	initializeLanguages: function initializeLanguages() {
		var that = this;

		var available_languages = [];
		var current_language = {};
		var langItem = {};

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = window.__LANGUAGES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var lang = _step.value;

				langItem = {
					code: lang[0],
					name: lang[1]
				};
				available_languages.push(langItem);

				if (langItem.code === window.__LANGUAGE) {
					current_language = langItem;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		this.languages = {
			current: current_language,
			available: available_languages
		};

		this.languages.displayStyle = '';
		this.languages.list = this.languages.available;

		var languageSelector = this.languageSelector = $('<select/>');

		languageSelector.addClass('form-control');

		this.languages.add = function (c, n, d) {
			if ($.grep(that.languages.list, function (el) {
				return el.code === c;
			}).length === 0) {
				that.languages.list.push({
					code: c,
					name: n,
					isDefault: !!d
				});
				var lang = languageSelector.val();
				languageSelector.addOption(c, n, false);
				languageSelector.sortOptions();
				languageSelector.val(lang);
			}
		};

		this.languages.selected = function () {
			return that.languages.current.code;
		};

		this.languages.defaultLanguage = function (c) {
			if (c !== undefined) {
				$.map(that.languages.list, function (el) {
					el.isDefault = el.code == c;
				});
				if ($.grep(that.languages.list, function (el) {
					return el.isDefault === true;
				}).length === 0) {
					that.languages.list[0].isDefault = true;
				}
			} else {
				var defaul = $.grep(that.languages.list, function (el) {
					return el.isDefault;
				})[0];
				if (!defaul) {
					defaul = that.languages.list[0];
				}
				return defaul;
			}
		};

		this.languages.switchTo = function (lang) {
			that.languages.current = lang;

			_.each(that.survey.pages, function (el) {
				el.rendered = false;
			});
			if (that.survey.currentPage !== undefined) {
				that.survey.currentPage.render();
			}
			that.survey.render();

			that.fieldsSelected($('ol.page li.field.active'), undefined, true);

			that.refreshPreviewLink();

			if (['ar', 'fa', 'he'].indexOf(that.languages.selected()) != -1) {
				$('#survey-editor .pages').addClass('rtl');
			} else {
				$('#survey-editor .pages').removeClass('rtl');
			}
		};

		this.languages.translate = function (obj, code) {
			if (typeof obj == 'string') {
				return obj;
			} else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object') {
				if (obj[code] && obj[code].length) {
					return obj[code];
				} else if (obj[that.languages.selected()] !== undefined) {
					return obj[that.languages.selected()];
				} else if (obj[that.languages.defaultLanguage().code] !== undefined) {
					return obj[that.languages.defaultLanguage().code];
				} else if (obj[0] !== undefined) {
					return obj[0];
				} else if (obj['en']) {
					return obj['en'];
				} else {
					return '';
				}
			}
		};
		this.languages.objectify = function (obj) {
			if (typeof obj == 'string') {
				var out = {
					en: obj
				};

				$.map(that.languages.list, function (el) {
					out[el.code] = obj;
				});

				return out;
			}
			return obj;
		};

		var items = [];

		this.languages.available.forEach(function (lang) {
			items.push({
				name: lang.code,
				text: lang.name,
				action: function action(_obj) {
					that.languages.switchTo(lang);
					this.changeTitle('<i class="nc-icon-mini business_globe"></i> ' + lang.code.toUpperCase());
				}
			});
		});

		this.languageSelector = new Dropdown({
			title: '<i class="nc-icon-mini business_globe"></i> ' + this.languages.current.code.toUpperCase(),
			noCaret: true,
			rightAligned: true,
			items: items
		});
	},

	renderFieldTypes: function renderFieldTypes() {
		var tools = $('<div></div>');

		var fields = $('<ul class="tools clearfix"></ul>');

		var advancedFields = $('<ul class="tools clearfix"></ul>').css('display', 'none');

		var guidestarFields = $('<ul class="tools clearfix sma-guidestar-questions"></ul>').css('display', 'none');

		$.each(this.fieldTypes, function (qlass, field) {
			if (field.isVisible && field.isQuestion && field.isGuideStar) {
				var hierarchicalIdentifier = 'sma-guidestar-question-indent-' + field.depth;

				var el = $('<li></li>').attr('field-type', qlass).addClass(['text-truncate', 'sma-guidestar-question', hierarchicalIdentifier, 'tool', qlass].join(' ')).attr('title', field.helpText ? field.displayName + ' - ' + field.helpText : '').tooltip({
					showURL: false,
					fade: 250,
					delay: 0,
					track: true,
					showBody: '-'
				}).html('<span class="' + qlass + '-text">' + gettext(field.displayName) + '</span>');

				if (field.parentIdentifier) {
					el.attr('data-parent', field.parentIdentifier);
					el.addClass('sma-child-collapsed');
				}
				if (field.isParent) {
					el.addClass(['sma-parent', 'sma-js-parent', 'sma-collapsed'].join(' '));
					var icon = '<i class="sma-guidestar-tree-expander nc-icon-mini arrows-1_minimal-up"></i>';
					el.append(icon);
					if (!field.isLastParent) {
						el.addClass('sma-js-non-draggable');
					}
				}
				el.appendTo(guidestarFields);
			} else if (field.isVisible && (field.isQuestion && !field.isCustom || field.type == 'section-separator')) {

				$('<li></li>').attr('field-type', qlass).addClass(['tool', qlass].join(' ')).attr('title', field.helpText ? field.displayName + ' - ' + field.helpText : '').tooltip({
					showURL: false,
					fade: 250,
					delay: 0,
					track: true,
					showBody: '-'
				}).html('<span class="' + qlass + '-text">' + gettext(field.displayName) + '</span>').appendTo(fields);
			} else if (field.isVisible) {
				$('<li></li>').attr('field-type', qlass).addClass(['tool', qlass].join(' ')).attr('title', field.helpText ? field.displayName + ' - ' + field.helpText : '').tooltip({
					showURL: false,
					fade: 250,
					delay: 0,
					track: true,
					showBody: '-'
				}).html('<span class="' + qlass + '-text">' + gettext(field.displayName) + '</span>').appendTo(advancedFields);
			}
		});

		if (!fields.children('li').length || !advancedFields.children('li').length) {
			tools.append(fields, advancedFields);
		} else {
			if (fields.length) {
				tools.append($('<div class="questiongroup"></div>').append($('<h3>').append($('<a class="expanded" href="#">' + gettext('Basic Question Types') + '</a>').click(function () {
					$(this).toggleClass('expanded');
					fields.toggle();
					return false;
				}))).append(fields));
			}
			if (advancedFields.length) {
				tools.append($('<div class="questiongroup"></div>').append($('<h3>').append($('<a href="#">' + gettext('Advanced Question Types') + '</a>').click(function () {
					$(this).toggleClass('expanded');
					advancedFields.toggle();
					return false;
				}))).append(advancedFields));
			}
			if (guidestarFields.length && this.isGuideStarEnabled) {
				tools.append($('<div class="questiongroup"></div>').append($('<h3>').append($('<a href="#">' + gettext('GuideStar Questions') + '</a>').click(function () {
					$(this).toggleClass('expanded');
					guidestarFields.prev().toggle();
					guidestarFields.toggle();
					return false;
				}))).append(guidestarFields));
			}
		}
		return tools;
	},

	initializeToolbox: function initializeToolbox() {
		var that = this;

		this.toolbox = $('<div class="toolbox"></div>');

		this.tabs = $('\n\t  <ul class="sma-submenu-container" role="tablist">\n\t\t<li class="nav-item">\n\t\t  <a class="nav-link active sma-submenu-item" data-toggle="tab" href="#survey-editor-fields" aria-control="survey-editor-fields">\n\t\t\t' + gettext('Questions') + '\n\t\t  </a>\n\t\t</li>\n\t\t<li class="nav-item">\n\t\t  <a class="nav-link sma-submenu-item" data-toggle="tab" href="#survey-editor-branching" aria-control="survey-editor-branching">\n\t\t\t' + gettext('Page') + '\n\t\t  </a>\n\t\t</li>\n\t\t<li class="nav-item">\n\t\t  <a class="nav-link sma-submenu-item" data-toggle="tab" href="#survey-editor-field-options-tab" aria-control="survey-editor-field-options-tab">\n\t\t\t' + gettext('Options') + '\n\t\t  </a>\n\t\t</li>\n\t  </ul>').appendTo(this.toolbox);

		this.panels = $('<div class="panels clearfix"></div>');

		this.tools = this.renderFieldTypes();

		var $allQuestions = $('li.tool', this.tools);
		var $draggableQuestions = $allQuestions.filter(':not(.sma-js-non-draggable)');
		var $nonDraggableQuestions = $allQuestions.filter('.sma-js-non-draggable');

		$nonDraggableQuestions.draggable({
			drag: function drag(_e, _ui) {
				new sma.components.Alert({
					message: gettext('This question cannot be used directly. Please click on it to expand and use the sub-questions.'),
					type: 'warning'
				});
				return false;
			}
		});

		$draggableQuestions.draggable({
			helper: 'clone',
			revert: 'invalid',
			connectToSortable: '#' + that.element.attr('id') + ' div.pages ol.page',
			start: function start(e) {
				$(e.target).parent().find('li:not(:last-child)').css('opacity', 0.2);
				$(e.target).parent().parent().siblings().css('opacity', 0.2);
				$(e.target).parent().parent().parent().find('h3').css('opacity', 0.2);
			},
			stop: function stop(e) {
				$('li.tool').css('opacity', 1);
				$(e.target).parent().parent().parent().find('h3').css('opacity', 1);
				$(e.target).parent().parent().siblings().css('opacity', 1);
			}
		}).click(function () {
			$('li.tool', this.tools).removeClass('selected');
			$(this).addClass('selected');
		}).dblclick(function () {
			that.addField($(this).attr('field-type'));
			if ($('ol.page.active li.field').length === 0) {
				$('ol.page.active li.placeholder').show();
			} else {
				$('ol.page.active li.placeholder').hide();
			}
		});

		var subtools = $('<div></div>');
		this.tools.appendTo(subtools);

		subtools.appendTo($('<div id="survey-editor-fields" class="field-type-list panel clearfix"></div>').appendTo(this.panels));

		//Question Options Tab
		$('<div id="survey-editor-field-options-tab" class="panel clearfix">' + '<div class="property-group" id="survey-editor-field-options"></div>').appendTo(this.panels);

		$('#survey-editor-field-options').html(this.emptyFieldOptionContent);

		//Page Options Tab
		$('<div id="survey-editor-branching" class="panel clearfix"></div>').append('<div class="property-group" id="survey-editor-page-options"></div>').appendTo(this.panels);

		this.toolbox.append(this.tabs).append(this.panels);

		this.topRow.append($('<div class="col-4"></div>').append(this.toolbox));

		this.toolbox.tabs({
			hideClass: 'hidden',
			selectedClass: 'active',
			select: function select(e, ui) {
				return that.tabActivated(e, ui);
			},
			show: function show(e, ui) {
				return that.tabShown(e, ui);
			}
		});

		$('.sma-js-parent').click(function (e) {
			var target = $(e.currentTarget);
			var fieldType = target.attr('field-type');
			var shouldItOpen = target.hasClass('sma-collapsed');
			target.toggleClass('sma-collapsed');

			target.nextAll().each(function (i, el) {
				var $el = $(el);
				var parentFieldType = $el.data('parent') || '';

				// stop the moment which hit a non descendant
				if (!parentFieldType.includes(fieldType)) {
					return false;
				}

				// if it's a direct child expand it
				if (shouldItOpen) {
					if (fieldType == parentFieldType) {
						$el.removeClass('sma-child-collapsed');
					}
				} else {
					$el.addClass('sma-child-collapsed');
					if ($el.hasClass('sma-js-parent')) {
						$el.addClass('sma-collapsed');
					}
				}
			});
		});
	},

	/* activates the passed tab by highlighting it and switching to the appropriate panel */
	tabActivated: function tabActivated(e, ui) {
		var that = this;
		$('li.tool', that.tools).removeClass('selected');
		if (ui.tab.hash == '#survey-editor-survey-options') {
			$('ol.page li.field', this.pages).each(function (i, el) {
				if ($(el).attr('name') == 'javascript') {
					$(el).children('form').hide();
					if (that.survey.getFieldArray($(el))[0].javascripter && that.survey.getFieldArray($(el))[0].javascripter.builder_dialog) {
						that.survey.getFieldArray($(el))[0].javascripter.builder_dialog.dialog('destroy');
						that.survey.getFieldArray($(el))[0].javascripter.builder_dialog = null;
					}
				}
				$(el).removeClass('active');
			});
		}
	},

	/* called after a tab is shown */
	tabShown: function tabShown() {
		/* if (ui.tab.hash == '#survey-editor-survey-options') {
   * } */
	},

	onFieldSelected: function onFieldSelected(field) {
		var _this5 = this;

		var delta = field.element.position().top + 120;

		this.toolbox.fadeOut(100, function () {
			_this5.toolbox.css('margin-top', field.element.position().top + 120).fadeIn(100, function () {
				if (delta + _this5.toolbox.height() > _this5.viewport.height()) {
					_this5.toolbox[0].scrollIntoView();
				}
			});
		});
	},

	/* fields were selected, so show the correct options*/
	fieldsSelected: function fieldsSelected(fields, e, forceRefresh) {
		// TODO: make this take a list of either field objects, field elements, or field ids
		var page = this.survey.editor.currentPage;
		var pageEl = page === undefined ? $('ol.page.active') : page.element;
		var allFields = $('li.field', pageEl);
		var oldFields = this.survey.getFieldArray(allFields.filter('.active'));

		// Remove All indications that something was selected
		allFields.removeClass('active').removeClass('ui-selected');
		$('.sma-js-field-actions').show();
		$('.sma-js-field-num').remove();

		if (allFields.length === 0 || this.survey.currentPage && this.survey.currentPage.fields.length === 0) {
			$('li.placeholder', pageEl).show();
		} else {
			$('li.placeholder', pageEl).hide();
		}

		fields = this.survey.getFieldArray(fields);

		if (e !== undefined && e.shiftKey) {
			var fieldsToAdd = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var field = _step2.value;

					if (oldFields.indexOf(field) > -1) {
						oldFields.splice(oldFields.indexOf(field), 1);
					} else {
						fieldsToAdd.push(field);
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			fields = oldFields.concat(fieldsToAdd);
		}

		if (oldFields.length === 1 && oldFields[0].type == 'javascript' && oldFields[0] !== fields[0]) {

			oldFields[0].element.children('form').hide();
			if (oldFields[0].javascripter.builder_dialog) {
				oldFields[0].javascripter.builder_dialog.dialog('destroy');
				oldFields[0].javascripter.builder_dialog = null;
			}
		}

		if (!fields.length || fields.length <= 0) {
			// With React types, we need to clear taking into account a potential React DOM
			var element = $('#survey-editor-field-options');
			_reactDom2.default.unmountComponentAtNode(element[0]);
			element.empty();
			element.html(this.emptyFieldOptionContent);

			// Set Question tab as active
			this.toolbox.tabs('option', 'active', 0);
			$(this.toolbox.find('.sma-submenu-item').removeClass('active')[0]).addClass('active');
			return;
		}

		this.onFieldSelected(fields[0]);

		for (var i = 0; i < fields.length; i++) {
			fields[i].element.addClass('ui-selected').addClass('active');
			if (i > 0) {
				fields[i].element.find('.sma-js-field-actions').hide();
			} else if (fields.length > 1) {
				fields[i].element.find('.sma-js-field-actions').before('<small class="sma-js-field-num selected-num">' + fields.length + ' ' + gettext('selected') + '</small>');
			}
		}

		var active_tab = $('.sma-submenu-container a.active', this.toolbox).attr('href');

		if (active_tab !== '#survey-editor-field-options-tab' && active_tab !== '#survey-editor-branching') {
			this.toolbox.tabs('option', 'active', 2);
			$(this.toolbox.find('.sma-submenu-item').removeClass('active')[2]).addClass('active');
		}
		if (!forceRefresh && fields.length === 1 && oldFields.length === 1 && this.survey.getFieldArray(oldFields)[0] === fields[0]) {
			return;
		}

		if (fields.length == 1) {
			fields[0].showOptions($('#survey-editor-field-options'));
			if (fields[0].type == 'javascript') {
				fields[0].javascripter.update_piper(this.survey, fields[0].globalpiper.value, fields[0].noids.value);
				fields[0].element.children('form').show();
			}
		} else {
			$('#survey-editor-field-options').html(this.multipleFieldOptionContent);
		}

		this.toolbox.tabs('option', 'active', 2);
		$(this.toolbox.find('.sma-submenu-item').removeClass('active')[2]).addClass('active');
	},

	removeField: function removeField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.del_field.handler(field, e);
	},

	duplicateField: function duplicateField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.duplicate.handler(field, e);
	},

	moveField: function moveField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.move_field.handler(field, e);
	},

	openLooping: function openLooping(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.looping.handler(field, e);
	},

	addField: function addField(type, info, page, pos, e) {
		if (e) {
			e.preventDefault();
		}

		if (page === undefined) {
			page = this.survey.currentPage;
		}

		return page.addField(type, info, pos);
	},

	beforeAddPage: function beforeAddPage() {
		return true;
	},

	pageSwitched: function pageSwitched(e, info) {
		var that = this;
		var allPages = $('ol.page');
		var page = info.page;
		var pageEl = info.page.element;

		if (page.fields.length > 0) {
			$('li.placeholder', pageEl).hide();
		} else {
			$('li.placeholder', pageEl).show();
		}

		try {
			allPages.sortable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		try {
			allPages.selectable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		_reactDom2.default.unmountComponentAtNode($('#survey-editor-field-options')[0]);
		$('#survey-editor-field-options').empty();
		$('#survey-editor-field-options').html(this.emptyFieldOptionContent);

		$('ol.page li.field.active', this.pages).each(function (i, el) {
			if ($(el).attr('name') == 'javascript') {
				$(el).children('form').hide();
				if (that.survey.getFieldArray($(el))[0].javascripter.builder_dialog) {
					that.survey.getFieldArray($(el))[0].javascripter.builder_dialog.dialog('destroy');
					that.survey.getFieldArray($(el))[0].javascripter.builder_dialog = null;
				}
			}
			$(el).removeClass('active');
		});

		page._branchingSelect = undefined;

		$('#survey-editor-page-options').empty().append(page.renderOptions().attr('id', 'survey-editor-page-options'));

		setTimeout(function () {
			if (that.toolbox.tabs('option', 'selected') !== 1) {
				that.toolbox.tabs('option', 'active', 0);
				$(that.toolbox.find('.sma-submenu-item').removeClass('active')[0]).addClass('active');
			}
		}, 0);

		this.refreshPreviewLink();

		this.pageStatusView.render();

		if (this.viewport) {
			if (this.element.offset().top + this.element.height() - this.viewport.offset().top - this.viewport.height() > 20) {
				$(window).scrollTop(this.viewport.offset().top + this.viewport.height() - $(window).height());
			} else {
				$(window).scroll();
			}
		}

		$('ol.page.active', this.pages).sortable({
			axis: 'y',
			revert: false,
			dropOnEmpty: true,
			cursor: 'pointer',
			tolerance: 'pointer',
			distance: 5,
			items: '> .field',
			cancel: '.field:not(.active),#scriptform',
			placeholder: 'field ui-sortable-placeholder',
			over: function over(e, ui) {
				ui.item.addClass('field-sorting');
			},
			sort: function sort() {
				$('.page.active').selectable('disable');
			},
			stop: function stop(_e, ui) {
				$('.page.active').selectable('enable');
				$(this).sortable('refresh');
				$(this).selectable('refresh');
				ui.item.removeClass('field-sorting');
			},
			deactivate: function deactivate() {
				$('body').css('cursor', 'default');
			},
			out: function out() {
				$(this).removeClass('ui-selectable-disabled ui-state-disabled');
			},
			receive: function receive(e, ui) {
				if ($(e.target).hasClass('active')) {
					if (ui.item.hasClass('tool')) {
						var tool = $('> li.tool', this);

						var pos = $(this).find('> li.field:not(.ui-sortable-placeholder), > li.tool').index(tool);
						var temp = that.addField(ui.item.attr('field-type'), undefined, undefined, pos - 1);

						tool.remove();

						try {
							that.fieldsSelected(temp.element, {});
						} catch (e) {
							// eslint-disable-line
						}
					}
				}

				$(this).sortable('refresh');
			}
		});

		try {
			$('ol.page').selectable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		$('ol.page.active').selectable({
			distance: 5,
			filter: 'li.field',
			cancel: 'li.field.active',
			autoRefresh: true,
			selected: function selected(e, ui) {
				$(ui.selected).addClass('active');
			},
			selecting: function selecting(e, ui) {
				$(ui.selecting).addClass('active');
			},
			unselected: function unselected(e, ui) {
				$(ui.unselected).removeClass('active');
			},
			unselecting: function unselecting(e, ui) {
				if ($(ui.target).hasClass('remove')) {
					$(ui.unselecting).removeClass('ui-unselecting').addClass('ui-selected');
					return;
				}
				$(ui.unselecting).removeClass('active');
			},
			stop: function stop(e) {
				that.fieldsSelected($('ol.page.active .field.ui-selected').removeClass('active'), e);
			}
		});

		this.toolbox.css('margin-top', 0);
	},

	refreshPreviewLink: function refreshPreviewLink() {
		if (this.previewButton === undefined) return;
		if (this.survey.currentPage) {
			var index = this.survey.currentPage.index;
			this.previewButton.attr('href', reverse('surveys-preview', {
				survey_id: this.surveyID
			}) + '?preview=1&lang=' + this.languages.selected() + (index !== 0 ? '&_previewpage=' + index : '') + '&TEST_DATA');
		}
	},

	/**********************
  * Loading and Saving *
  **********************/

	load: function load(callback) {
		var that = this;

		//this.drafting = new Drafting(this);

		$.ajax({
			type: 'get',
			url: reverse('surveys-versions', {
				survey_id: this.surveyID
			}) + '?c=' + randomString(20),
			success: function success(data) {
				if (data.versions.length > 0) {
					that.currentrevision = parseInt(data.versions[0]['revision'].substring(1));
				} else {
					that.currentrevision = 0;
				}
			}
		});

		that.languages.list = [{
			code: this.languages.current.code,
			name: this.languages.current.name,
			isDefault: true
		}];
		that.languages.displayStyle = 'dropdown';

		var handleSurveyData = function handleSurveyData(data) {
			if (!data.data) {
				that.survey.addEmptyPage();
				callback();
				return;
			}

			that.form_is_live = data.form_is_live;

			if (data.form_is_live) {
				$('#survey-editor .sma-back-row').before('<div class="row mb-2"><div class="col-md-12"><div id="sma-formlive-callout-container"></div>');

				var markup = gettext('<strong>Warning: It appears that this form has live data</strong>. Making changes to the form after collecting data is strongly discouraged as it could harm the integrity of your data. Read more about editing live forms from our <a href="https://smapply.zendesk.com/hc/en-us/articles/115001423873-How-to-Safely-Make-Changes-to-a-Live-Form" target="_blank" class="sma-underline-blue-link">Help Center</a>.');

				new Callout({
					attachTo: $('#sma-formlive-callout-container'),
					content: markup,
					callout_class: 'callout-warning'
				});
			}

			var survey = data.data;
			that.languages.list = [];
			$.map(that.languages.available || [{
				code: that.languages.current.code,
				name: that.languages.current.name,
				isDefault: true
			}], function (el) {
				that.languages.add(el.code, el.name, el.isDefault);
			});

			that.languageSelector.changeTitle('<i class="nc-icon-mini business_globe"></i> ' + that.languages.defaultLanguage().code.toUpperCase());

			that.languages.displayStyle = survey.languageDisplayStyle || 'dropdown';

			that.survey.load(survey);
			callback();
			that.survey.switchPage(0);
			//that.drafting.startPolling();
		};

		var draft = null; //this.drafting.get();

		if (draft != null) {
			handleSurveyData({
				data: draft
			});
			//this.drafting.notifyLoaded();
		} else {
			$.ajax({
				type: 'get',
				url: reverse('surveys-datasource', {
					survey_id: this.surveyID
				}) + '?c=' + randomString(20),
				dataType: 'json',
				success: function success(data, _status) {
					handleSurveyData(data);
				}
			});
		}
	},

	saveSuccess: function saveSuccess(callback, response) {
		var _this6 = this;

		var that = this;
		that.currentrevision = response.revision;

		new sma.components.Alert({
			message: gettext('Your form has been saved.'),
			type: 'success'
		});

		setTimeout(function () {
			_this6.loader.hide();
			callback(true);
		}, 1000);
	},

	saveError: function saveError(callback, response) {
		var that = this;
		this.response_error = 'N/A';

		if (response.status === 0) {
			this.response_message = gettext('An error has occured and your form was NOT saved. Make sure that you have an active internet connection and try saving your form again.');
		} else if (response && response.message) {
			this.response_message = response.message;
			if (response.error) {
				this.response_error = response.error;
			}
		} else if (response && response.error) {
			this.response_message = gettext('An error has occured and your form was NOT saved. If you continue having issues, contact customer support with the error details listed below.');
			if (response.error && typeof response.error == 'string') {
				this.response_error = response.error;
			} else {
				this.response_error = response.statusText;
			}
		}

		if (response && response.versions) {
			that.changeToHistory(callback, response.versions);
		} else {
			var dialog = $('<div>').append($('<p>', {
				style: 'color:darkred;'
			}).html(this.response_message), $('<br />'), $('<p>').append($('<br />'), $('<strong>', {
				text: gettext('Error Details:')
			}), $('<div>', {
				style: 'color:darkred;'
			}).html(this.response_error))).dialog({
				title: gettext('Error Saving Survey'),
				width: 500,
				height: 300,
				autoResize: true,
				zIndex: 30000,
				dialogClass: 'subscribermail',
				close: function close() {
					dialog.dialog('destroy');
					callback(false);
				}
			}).dialog('option', 'buttons', [{
				class: 'icon icon-check',
				text: gettext('OK'),
				click: function click() {
					dialog.dialog('close');
				}
			}]);
		}
	},

	changeToHistory: function changeToHistory(callback, versions) {
		var that = this;
		if (!callback) callback = function callback() {};
		this.revisions = {};
		this.revisions.versions = versions;

		that.revisions.selectBox = $('<select class="version"></select>');
		$.map(that.revisions.versions, function (el) {
			that.revisions.selectBox.append('<option value="' + el.id + '">' + el.revision + ': ' + el.label + '</option>');
		});

		this.revisions.showDialog = function () {
			if (that.revisions.dialogDiv === undefined) {
				that.revisions.infoDiv = $('<div class="version"></div>');
				that.revisions.selectBox.unbind('change').change(function () {
					var version = $.grep(that.revisions.versions, function (el) {
						if (that.revisions.selectBox.val() == el.id) {
							return el;
						}
					})[0];
					that.revisions.infoDiv.html(version.created_at);
				}).change();

				that.revisions.dialogDiv = $('<div></div>').append($('<div class="versions"><div class="help">' + gettext('Newer revisions of this survey have been made since the survey was loaded or saved on this page. Newer revisions are listed below. Click on "View" to open a window which will display the state of your survey for the given version. Click "Load" to replace your current survey with the specified version. Click "Cancel" to cancel the current save. Click "Save" to save your modifications in a new revision.') + '</div></div>').append(that.revisions.selectBox).append(that.revisions.infoDiv)).dialog({
					title: gettext('Warning'),
					width: 400,
					height: 300,
					zIndex: 30000,
					modal: true,
					bgiframe: true,
					close: function close() {
						$(this).dialog('destroy');
					}
				}).dialog('option', 'buttons', [{
					class: 'icon icon-save',
					text: gettext('Save'),
					click: function click() {
						$(this).dialog('destroy');
						that.save(that.callback, true);
					}
				}, {
					class: 'icon icon-preview',
					text: gettext('View'),
					click: function click() {
						var version = $.grep(that.revisions.versions, function (el) {
							if (that.revisions.selectBox.val() == el.id) {
								return el;
							}
						})[0];
						that.revisions.showVersion(version);
					}
				}, {
					class: 'icon icon-upload',
					text: gettext('Load'),
					click: function click() {
						var version = $.grep(that.revisions.versions, function (el) {
							if (that.revisions.selectBox.val() == el.id) {
								return el;
							}
						})[0];
						that.revisions.loadVersion(version);
						$(this).dialog('destroy');
					}
				}, {
					class: 'icon icon-cancel',
					text: gettext('Cancel'),
					click: function click() {
						$(this).dialog('destroy');
					}
				}]);
			} else {
				that.revisions.dialogDiv.dialog('open');
			}
		};
		this.revisions.loadVersion = function (version) {
			$.ajax({
				type: 'post',
				url: EDIT_URL + version.id + '/?c=' + randomString(20),
				data: {
					action: 'revert'
				},
				success: function success() {
					window.onbeforeunload = function () {};
					window.location.reload();
				}
			});
		};
		this.revisions.showVersion = function (version) {
			window.open(EDIT_URL + version.id + '/', 'previous_version_' + version.id, 'width=980,height=500,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no,scrollbars=yes');
		};
		that.revisions.showDialog();
	},

	save: function save(callback, force) {
		var that = this;
		var saveURL = reverse('surveys-save', {
			survey_id: this.surveyID
		}) + '?c=' + randomString(20);

		if (!ALLOW_SAVE) return;
		if (!callback) callback = function callback() {};
		if (!force) force = false;

		this.loader.show();

		var DO_SAVE = function DO_SAVE(data) {
			that.hashedJson = hashCode(that.serialize().survey);

			$.ajax({
				type: 'post',
				url: saveURL,
				data: {
					survey: data,
					force: false,
					revision: that.currentrevision
				},
				dataType: 'json',
				async: true,
				success: function success(response) {
					that.saveSuccess(callback, response);
				},
				error: function error(response) {
					that.saveError(callback, response);
				}
			});
		};

		var DO_SAVE_FORCE = function DO_SAVE_FORCE(data) {
			that.hashedJson = hashCode(that.serialize().survey);

			$.ajax({
				type: 'post',
				timeout: 30000,
				url: saveURL,
				data: {
					survey: data,
					force: true,
					revision: that.currentrevision
				},
				dataType: 'json',
				async: true,
				success: function success(response) {
					that.saveSuccess(callback, response);
				},
				error: function error(response) {
					that.saveError(callback, response);
				}
			});
		};

		setTimeout(function () {
			try {
				var survey = that.serialize();
			} catch (e) {
				var response = {
					error: e,
					message: interpolate(gettext("We're sorry, but an error occurred while serializing your survey."), [gettext('Form')])
				};
				that.saveError(function () {}, response);
				return;
			}

			that.embedded_script = survey.survey.toString().match(/<script[^>]*>.*?<\/script>/gi) ? true : false;

			if (force) {
				DO_SAVE_FORCE(survey.survey, false);
			} else {
				DO_SAVE(survey.survey, false);
			}
		}, 50);

		return true;
	},

	serialize: function serialize() {
		return {
			survey: JSON.stringify(this.survey.serialize())
		};
	}
});

module.exports = {
	Editor: Editor,
	Survey: Survey
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(233);
var defined = __webpack_require__(99);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(234);
var createDesc = __webpack_require__(158);
var toIObject = __webpack_require__(76);
var toPrimitive = __webpack_require__(98);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(857);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(75);
var toObject = __webpack_require__(39);
var IE_PROTO = __webpack_require__(412)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TextEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pipes = __webpack_require__(237);

var _pipes2 = _interopRequireDefault(_pipes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ajax = __webpack_require__(4);

// Create a default icon template and set it as the active icon set
$.FroalaEditor.DefineIconTemplate('nucleo', '<i class="nc-icon-mini [NAME]"></i>');
$.FroalaEditor.ICON_DEFAULT_TEMPLATE = 'nucleo';

// Assign buttons to new icon identifiers
$.FroalaEditor.DefineIcon('fullscreen', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('fullscreenCompress', { NAME: 'gestures_pinch' });

$.FroalaEditor.DefineIcon('bold', { NAME: 'text_bold' });
$.FroalaEditor.DefineIcon('italic', { NAME: 'text_italic' });
$.FroalaEditor.DefineIcon('underline', { NAME: 'text_underline' });
$.FroalaEditor.DefineIcon('strikeThrough', { NAME: 'text_strikethrough' });
$.FroalaEditor.DefineIcon('paragraphFormat', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('specialCharacters', { NAME: 'business_currency-euro' });
$.FroalaEditor.DefineIcon('subscript', { NAME: 'text_subscript' });
$.FroalaEditor.DefineIcon('superscript', { NAME: 'text_superscript' });

$.FroalaEditor.DefineIcon('fontFamily', { NAME: 'text_edit' });
$.FroalaEditor.DefineIcon('fontSize', { NAME: 'text_size' });
$.FroalaEditor.DefineIcon('color', { NAME: 'text_color' });

$.FroalaEditor.DefineIcon('align', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('align-justify', { NAME: 'text_align-justify' });

$.FroalaEditor.DefineIcon('formatOL', { NAME: 'text_list-numbers' });
$.FroalaEditor.DefineIcon('formatUL', { NAME: 'text_list-bullet' });
$.FroalaEditor.DefineIcon('outdent', { NAME: 'text_margin-right' });
$.FroalaEditor.DefineIcon('indent', { NAME: 'text_margin-left' });
$.FroalaEditor.DefineIcon('quote', { NAME: 'text_quote' });

$.FroalaEditor.DefineIcon('insertLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('insertImage', { NAME: 'design_image' });
$.FroalaEditor.DefineIcon('insertTable', { NAME: 'media-1_grid' });

$.FroalaEditor.DefineIcon('insertHR', { NAME: 'ui-1_simple-delete' });
$.FroalaEditor.DefineIcon('clearFormatting', { NAME: 'ui-2_ban' });

$.FroalaEditor.DefineIcon('html', { NAME: 'design_code' });
$.FroalaEditor.DefineIcon('piping', { NAME: 'arrows-2_round-up-right' });

$.FroalaEditor.DefineIcon('undo', { NAME: 'arrows-1_refresh-68 flip-y' });
$.FroalaEditor.DefineIcon('redo', { NAME: 'arrows-1_refresh-68' });

$.FroalaEditor.DefineIcon('linkOpen', { NAME: 'arrows-e_share-26' });
$.FroalaEditor.DefineIcon('linkStyle', { NAME: 'design_wand' });
$.FroalaEditor.DefineIcon('linkEdit', { NAME: 'ui-1_edit-76' });
$.FroalaEditor.DefineIcon('linkRemove', { NAME: 'ui-2_link-broken-70' });

$.FroalaEditor.DefineIcon('linkBack', { NAME: 'arrows-1_simple-left' });
$.FroalaEditor.DefineIcon('linkList', { NAME: 'ui-1_zoom' });

$.FroalaEditor.DefineIcon('imageReplace', { NAME: 'arrows-1_direction-53' });
$.FroalaEditor.DefineIcon('image-align-left', { NAME: 'text_align-left' });
$.FroalaEditor.DefineIcon('image-align-right', { NAME: 'text_align-right' });
$.FroalaEditor.DefineIcon('image-align-center', { NAME: 'text_align-center' });
$.FroalaEditor.DefineIcon('imageRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('imageLink', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageDisplay', { NAME: 'text_capitalize' });
$.FroalaEditor.DefineIcon('imageStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('imageAlt', { NAME: 'ui-2_alert-i' });
$.FroalaEditor.DefineIcon('imageSize', { NAME: 'gestures_stretch' });
$.FroalaEditor.DefineIcon('imageUpload', { NAME: 'arrows-2_square-upload' });
$.FroalaEditor.DefineIcon('imageByURL', { NAME: 'ui-2_link-72' });
$.FroalaEditor.DefineIcon('imageBack', { NAME: 'arrows-1_simple-left' });

$.FroalaEditor.DefineIcon('tableHeader', { NAME: 'travel_hotel-symbol' });
$.FroalaEditor.DefineIcon('tableRemove', { NAME: 'ui-1_trash-simple' });
$.FroalaEditor.DefineIcon('tableRows', { NAME: 'ui-2_menu-34' });
$.FroalaEditor.DefineIcon('tableColumns', { NAME: 'ui-2_menu-34 rotate-90' });
$.FroalaEditor.DefineIcon('tableStyle', { NAME: 'design_brush' });
$.FroalaEditor.DefineIcon('tableCells', { NAME: 'design_slice' });
$.FroalaEditor.DefineIcon('tableCellBackground', { NAME: 'ui-1_drop' });
$.FroalaEditor.DefineIcon('tableCellVerticalAlign', { NAME: 'arrows-1_enlarge-vertical' });
$.FroalaEditor.DefineIcon('tableCellStyle', { NAME: 'design_wand' });

// $.FE.DEFAULTS.imageInsertButtons = ['imageBack', '|', 'imageByURL'];


/**
 * We have to disable this rule since the function to convert texteditors to Froalas will not work.
 * This is a bit of a hack and just works because of how it ends up being imported.  Should likely
 * be a bit more explicit - update when upgrade to Froala v3.
 */
/* eslint-disable import/prefer-default-export */

var TextEditor = exports.TextEditor = function () {
	function TextEditor(options) {
		var _this = this;

		_classCallCheck(this, TextEditor);

		this.pipingContext = options.piping || null;
		this.el = $(options.textarea);
		this.fromModal = options.fromModal || false;

		var buttons = options.buttons || ['fullscreen', '|', 'bold', 'italic', 'underline', 'paragraphFormat', 'fontSize', 'color', 'strikeThrough', 'subscript', 'superscript', '|', 'align', '|', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', 'insertImage', 'insertTable', 'specialCharacters', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', '|', 'html', '|', 'piping'];

		var config = {};

		if (this.pipingContext) {
			var pipingContext = this.pipingContext,
			    el = this.el,
			    fromModal = this.fromModal;

			var that = this;
			// Assign piping logic to piping button
			$.FroalaEditor.RegisterCommand('piping', {
				title: 'Piping',
				focus: false,
				undo: false,
				refreshAfterCallback: false,
				/* eslint-disable func-names, object-shorthand */
				callback: function callback() {
					/* eslint-disable no-new */
					new _pipes2.default({
						context: pipingContext,
						$textField: this.$oel,
						froala: that,
						fromModal: fromModal
					});
					/* eslint-enable no-new */
					this.selection.save();
				}
				/* eslint-enable func-names, object-shorthand */
			});

			config = {
				at: '{{',
				lookUpOnClick: false,
				callbacks: {
					remoteFilter: function remoteFilter(query, queryCallback) {
						var pipeOptions = {
							url: reverse('pipes-index'),

							data: {
								q: query.trim(),
								context: _this.pipingContext
							},
							callback: function callback(data) {
								var id = 1;
								var pipes = [];

								for (var groupKey in data.result) {
									var pipeGroup = data.result[groupKey];

									for (var pipeIndex in pipeGroup.data) {
										var pipe = pipeGroup.data[pipeIndex];

										var pipeObj = {
											id: id,
											name: pipe.label,
											value: '{{ ' + pipe.value + ' }}'
										};
										id++;
										pipes.push(pipeObj);
									}
								}
								queryCallback(pipes);
							}
						};
						ajax.get(pipeOptions);
					},
					// Overwrite matcher so we can accept spaces
					matcher: function matcher(flag, subtext, shouldStartWithSpace) {
						var _a = void 0;
						var _y = void 0;
						var match = void 0;
						var regexp = void 0;
						var space = void 0;
						flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

						if (shouldStartWithSpace) {
							flag = '(?:^|\\s)' + flag;
						}

						_a = decodeURI('%C3%80');
						_y = decodeURI('%C3%BF');
						space = '\ '; // these spaces
						regexp = new RegExp(flag + "([A-Za-z" + _a + "-" + _y + "0-9_" + space + "\'\.\+\-]*)$|" + flag + "([^\\x00-\\xff]*)$", 'gi');
						match = regexp.exec(subtext);
						if (match) {
							return match[2] || match[1];
						} else {
							return null;
						}
					},
					// Overwrote sorter so we can trim whitespace
					sorter: function sorter(query, items, searchKey) {
						var _results = void 0;
						var i = void 0;
						var item = void 0;
						var len = void 0;
						if (!query) {
							return items;
						}
						_results = [];
						for (i = 0, len = items.length; i < len; i++) {
							item = items[i];
							item.atwho_order = new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase().trim()); // trims here
							if (item.atwho_order > -1) {
								_results.push(item);
							}
						}
						return _results.sort(function (a, b) {
							return a.atwho_order - b.atwho_order;
						});
					}
				},
				displayTpl: '<li>${name} <small>${value}</small></li>',
				insertTpl: '<span class="sma-pipe" data-toggle="tooltip" data-placement="top" title="${name}">${value}</span>',
				limit: 100
			};
		} else {
			var index = buttons.indexOf('piping');
			if (index > -1) {
				buttons.splice(index, 1);
			}
		}

		this.el.on('froalaEditor.initialized', function (e, editor) {
			if (_this.pipingContext) {
				editor.$el.atwho(config).on('inserted.atwho', function () {
					editor.$el.find('.atwho-inserted').removeAttr('contenteditable');
				});
			}

			editor.events.on('keydown', function (keydownEvent) {
				var returnValue = void 0;
				if (keydownEvent.which === $.FroalaEditor.KEYCODE.ENTER && editor.$el.atwho('isSelecting')) {
					returnValue = false;
				}
				return returnValue;
			}, true);
		}).froalaEditor({
			heightMin: options.heightMin || 200,
			imageEditButtons: ['imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '|', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],
			imageInsertButtons: ['imageBack', '|', 'imageByURL'],
			imagePaste: false,
			imageUploadRemoteUrls: false,
			language: window.__LANGUAGE,
			placeholderText: options.placeholderText || null,
			toolbarButtons: buttons
		});

		this.el.on('froalaEditor.contentChanged', function () {
			_this.el.val(_this.getContent()).change();
		});
	}

	_createClass(TextEditor, [{
		key: 'setContent',
		value: function setContent(content) {
			this.el.froalaEditor('html.set', content);
			this.el.froalaEditor('events.trigger', 'charCounter.update');
		}
	}, {
		key: 'getContent',
		value: function getContent() {
			return this.el.froalaEditor('html.get', true);
		}
	}, {
		key: 'insertText',
		value: function insertText(tags, el) {
			var insertedContent = tags.map(function (tag) {
				return '\n\t\t\t\t<span class="atwho-inserted" data-atwho-at-query="{{">\n\t\t\t\t\t<span\n\t\t\t\t\t\tclass="sma-pipe"\n\t\t\t\t\t\tdata-toggle="tooltip"\n\t\t\t\t\t\tdata-placement="top"\n\t\t\t\t\t\ttitle="' + tag.group + ' ' + tag.label + '"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ ' + tag.value + ' }}\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\t\t\t';
			});
			insertedContent = insertedContent.join(' ');
			el.froalaEditor('selection.restore');
			el.froalaEditor('html.insert', insertedContent, true);
		}
	}]);

	return TextEditor;
}();
/* eslint-enable import/prefer-default-export */

// convert all sma-text-editor textareas


$(function () {
	$('textarea.sma-text-editor').each(function (i, textarea) {
		var contextString = $(textarea).attr('data-context');
		var context = contextString ? contextString.split(' ') : null;

		new TextEditor({
			textarea: textarea,
			piping: context
		});
	});
});

module.exports = TextEditor;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Wrapper for pickatime

var TimePicker = function TimePicker(el, options) {
	_classCallCheck(this, TimePicker);

	this.el = el;
	this.showMeridian = window.TIME_FORMAT !== '1';

	$(this.el).timepicker(_extends({
		template: false,
		minuteStep: 1,
		showMeridian: this.showMeridian,
		defaultTime: false
	}, options));
};

module.exports = TimePicker;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var BooleanVariable, ChoiceVariable, CoffeeKup, DateTimeVariable, HiddenVariable, MultipleChoiceVariable, RequiredError, SingleChoiceVariable, StringVariable, UniqueError, Validation, ValidationError, Variable,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

CoffeeKup = __webpack_require__(843);

ValidationError = (function(superClass) {
  extend(ValidationError, superClass);

  ValidationError.prototype.name = "ValidationError";

  function ValidationError(message1) {
    this.message = message1;
  }

  return ValidationError;

})(Error);

RequiredError = (function(superClass) {
  extend(RequiredError, superClass);

  RequiredError.prototype.name = "RequiredError";

  function RequiredError() {
    RequiredError.__super__.constructor.call(this, trans.make(TRANSLATIONS['strings.required']));
  }

  return RequiredError;

})(ValidationError);

UniqueError = (function(superClass) {
  extend(UniqueError, superClass);

  UniqueError.prototype.name = "UniqueError";

  function UniqueError() {
    UniqueError.__super__.constructor.call(this, trans.make(TRANSLATIONS['strings.unique']));
  }

  return UniqueError;

})(ValidationError);

Validation = (function(superClass) {
  extend(Validation, superClass);

  function Validation() {
    return Validation.__super__.constructor.apply(this, arguments);
  }

  Validation.TYPES = {};

  Validation["new"] = function(cls) {
    return this.TYPES[cls.prototype.type] = cls;
  };

  Validation.prototype.regex = /^.*$/;

  Validation.prototype.inputAttrs = {
    'type': 'text'
  };

  Validation.prototype.defaults = {
    message: ''
  };

  Validation.prototype.initialize = function() {
    if (("" + (this.get('message'))).indexOf('{min}') > -1 || ("" + (this.get('message'))).indexOf('{max}') > -1) {
      return this.useCustomMsg = true;
    }
  };

  Validation.prototype.validate = function(value) {
    var max, message, min, ref, ref1;
    if (!value) {
      return;
    }
    if (!this.regex.test(value)) {
      throw new ValidationError(this.get('message'));
    }
    ref = [parseInt(this.get('minLength', 1), 10), parseInt(this.get('maxLength', -1), 10)], min = ref[0], max = ref[1];
    if (min || max) {
      message = max < 0 ? "This value must contain at least " + min + " characters." : min < 0 ? "This value must contain at least " + min + " characters." : "This value must be between " + min + " and " + max + " characters.";
      if (max < 0) {
        if (value.length < min) {
          throw new ValidationError(this.use_custom_msg ? this.get('message') : message);
        }
      } else {
        if (!((min <= (ref1 = value.length) && ref1 <= max))) {
          throw new ValidationError(this.use_custom_msg ? this.get('message') : message);
        }
      }
    }
  };

  return Validation;

})(Backbone.Model);

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'email';

  _Class.prototype.regex = /^\ *[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\ *$/;

  _Class.prototype.inputAttrs = {
    type: 'email'
  };

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'num';

  _Class.prototype.regex = /^[0-9]*$/;

  _Class.prototype.inputAttrs = {
    type: 'tel'
  };

  _Class.prototype.validate = function(value) {
    var max, min, ref, ref1;
    _Class.__super__.validate.call(this, value);
    if (!value) {
      return;
    }
    ref = [parseInt(this.get('minValue', 0), 10), parseInt(this.get('maxValue', -1), 10)], min = ref[0], max = ref[1];
    if (!_.isNaN(min) && !_.isNaN(max) && !((min <= (ref1 = parseInt(value, 10)) && ref1 <= max))) {
      throw new ValidationError("This value must be between " + min + " and " + max + ".");
    }
  };

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'pos-neg-num';

  _Class.prototype.regex = /^-?[0-9]*$/;

  _Class.prototype.inputAttrs = {
    type: 'number'
  };

  return _Class;

})(Validation.TYPES['num']));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'float';

  _Class.prototype.regex = /^[0-9]*((\.|,)?[0-9]+)?$/;

  _Class.prototype.inputAttrs = {
    type: 'number',
    step: 'any'
  };

  return _Class;

})(Validation.TYPES['num']));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'alpha';

  _Class.prototype.regex = /^[A-Za-z \r\n]*$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'alphanum';

  _Class.prototype.regex = /^[A-Za-z0-9 \r\n]*$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'phoneint';

  _Class.prototype.regex = /^[+]*[0-9 \-().]*$/;

  _Class.prototype.inputAttrs = {
    type: 'tel'
  };

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'phone10';

  _Class.prototype.regex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;

  _Class.prototype.inputAttrs = {
    type: 'tel'
  };

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'phoneint-ext';

  _Class.prototype.regex = /^[+]*[0-9 \-().]*?$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'phone10-ext';

  _Class.prototype.regex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}(-[0-9]{1,10})?$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'uk-phone-number';

  _Class.prototype.regex = /^((\+44)?)([ ]?)(0?)([0-9]{2,5})([ ]?)(([0-9]{3,4})?)([ ]?)([0-9]{4,6})$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'uk-postal-code';

  _Class.prototype.regex = /^([A-Z][A-Z]?)(([0-9][0-9]?)|([0-9][A-Z]))[ ][0-9][A-Z][A-Z]$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'postal';

  _Class.prototype.regex = /^([0-9]{1,5}|[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9])$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'postal-ca';

  _Class.prototype.regex = /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'postal-three-digit';

  _Class.prototype.regex = /^[A-Za-z][0-9][A-Za-z]$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'uniform-resource-locator';

  _Class.prototype.regex = /^((https?:\/\/)|(HTTPS?:\/\/))?((([A-Za-z0-9\-]+)(\.))+)?([A-Za-z0-9\-])+(\.)([A-Za-z0-9]{2,4})/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'domain-validation';

  _Class.prototype.regex = /^((https?:\/\/)|(HTTPS?:\/\/))?((([A-Za-z0-9\-]+)(\.))+)?([A-Za-z0-9\-])+(\.)([A-Za-z0-9]{2,4})$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'postal-us';

  _Class.prototype.regex = /^([0-9]{5})$|^([0-9]{5}-[0-9]{4})$/;

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'currency';

  _Class.prototype.regex = /(^[\$]?\d+((\.|,)?\d{2,})*((\.|,)[0-9]{1,2})?[\$]?$)/;

  _Class.prototype.prefix = '$';

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'percentage-bound';

  _Class.prototype.regex = /^(([0-9][0-9]?|100)([.,][0-9]*)?\%?)$/;

  _Class.prototype.suffix = '%';

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'percentage-unbound';

  _Class.prototype.regex = /^(\%)?[0-9]*([.,][0-9]*)?(\%)?$/;

  _Class.prototype.suffix = '%';

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'wordCount';

  _Class.prototype.regex = /^.*$/m;

  _Class.prototype.validate = function(value) {
    var counted_words, f, max, min, ref;
    _Class.__super__.validate.call(this, value);
    if (!value) {
      return;
    }
    ref = [parseInt(this.get('minWords', 0), 10), parseInt(this.get('maxWords', -1), 10)], min = ref[0], max = ref[1];
    counted_words = ((function() {
      var j, len, ref1, results;
      ref1 = value.trim().replace('\r\n', ' ').replace('\r', ' ').replace('\n', ' ').split(' ');
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        f = ref1[j];
        if (f.trim() !== '') {
          results.push(f);
        }
      }
      return results;
    })()).length;
    if (!((min <= counted_words && counted_words <= max))) {
      throw new ValidationError("This value must be between " + min + " and " + max + " words.");
    }
  };

  return _Class;

})(Validation));

Validation["new"]((function(superClass) {
  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.type = 'all';

  _Class.prototype.regex = /^.*$/;

  return _Class;

})(Validation));

Variable = (function(superClass) {
  extend(Variable, superClass);

  function Variable() {
    return Variable.__super__.constructor.apply(this, arguments);
  }

  Variable.prototype.defaults = {
    required: false
  };

  Variable.prototype.type = void 0;

  Variable.prototype.label = function() {
    var ref;
    return (ref = this.get('label')) != null ? ref.toString() : void 0;
  };

  Variable.prototype.name = function() {
    return this.get('name');
  };

  Variable.prototype.title = function() {
    return this.get('title');
  };

  Variable.prototype.rightLabel = function() {
    var ref;
    return ((ref = this.get('rightLabel')) != null ? ref : '').toString();
  };

  Variable.prototype.escapedId = function() {

    /* Returns this variable's identifier suitable for use in a jQuery selector. */
    return this.id.replace(/([\.:])/g, "\\$1");
  };

  Variable.prototype.exportId = function() {

    /* Returns the identifier to be used when exporting to tables/CSV. */
    var ref;
    return (ref = this.get('exportId')) != null ? ref : this.id;
  };

  Variable.prototype.toString = function() {
    var ref;
    return (ref = this.get('name')) != null ? ref : this.id;
  };

  Variable.prototype.render = function(include_error_placeholder) {
    if (include_error_placeholder == null) {
      include_error_placeholder = true;
    }
    return this.template({
      context: this
    }, include_error_placeholder);
  };

  Variable.prototype.getFormValue = function(value) {
    if (value != null) {
      return [value];
    } else {
      return [];
    }
  };

  Variable.prototype.fromFormValue = function(value) {
    var ref;
    return (ref = value != null ? value[0] : void 0) != null ? ref : void 0;
  };

  Variable.prototype.loadForm = function(form, value) {

    /* Updates form elements for this variable with the given value. */
    var j, len, ref, results, x;
    ref = form.childNodes;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      x = ref[j];
      results.push($(":input[name=" + (this.escapedId()) + "]", x).val(this.getFormValue(value)));
    }
    return results;
  };

  Variable.prototype.saveForm = function(form, values) {
    return values[this.id] = this.fromFormValue(form[this.id]);
  };

  Variable.prototype.getExportValues = function(value) {
    return [value != null ? value : ""];
  };

  Variable.prototype.fromExportValues = function(values) {
    var ref;
    return (ref = values[0]) != null ? ref : void 0;
  };

  Variable.prototype.getPipedValue = function(value) {
    return value != null ? value : "";
  };

  Variable.prototype.needsPiping = function() {
    var ref;
    return /\{\{\s*([^\{\}]+)\s*\}\}/g.test((ref = this.initialValue) != null ? ref : '');
  };

  Variable.prototype.getScore = function(value) {
    return 0;
  };

  Variable.prototype.validateResponse = function(response) {
    if (this.get('required') && (_.isArray(response.values[this.id]) ? _.isEmpty(response.values[this.id]) : response.values[this.id] == null) && !$('[name=' + this.id + ']').closest('.hidden').length) {
      throw new RequiredError;
    }
  };

  Variable.makeList = function(idPrefix, namePrefix, info, questionTitle) {
    var attrs, child, i, j, len, results;
    results = [];
    for (i = j = 0, len = info.length; j < len; i = ++j) {
      child = info[i];
      attrs = {
        id: idPrefix + "_" + i,
        title: questionTitle + " | " + (trans.make(child.label)),
        name: namePrefix + "." + i,
        label: trans.make(child.label),
        required: child.required,
        appearance: (function() {
          switch (child.type) {
            case 'single':
              return child.choiceAppearance;
            case 'dropdown':
              return 'dropdown';
            default:
              return child.appearance;
          }
        })(),
        rows: child.rows,
        columns: child.cols,
        choices: child.choices != null ? Choice.makeList(child.choices) : void 0,
        validation: child.validation
      };
      results.push(new ((function() {
        switch (child.type) {
          case 'checkbox':
          case 'boolean':
            return BooleanVariable;
          case 'string':
          case 'text':
            return StringVariable;
          case 'single':
          case 'dropdown':
            return SingleChoiceVariable;
        }
      })())(attrs));
    }
    return results;
  };

  return Variable;

})(Backbone.Model);

StringVariable = (function(superClass) {
  extend(StringVariable, superClass);

  StringVariable.prototype.defaults = _.extend(Variable.prototype.defaults, {
    columns: 20,
    rows: 1,
    prefix: void 0,
    suffix: void 0,
    validation: void 0
  });

  StringVariable.prototype.type = 'string';

  StringVariable.prototype.rows = function() {
    return this.get('rows');
  };

  StringVariable.prototype.columns = function() {
    return this.get('columns');
  };

  function StringVariable(info) {
    var validation;
    if (info.appearance === 'full') {
      if (info.rows == null) {
        info.rows = 5;
      }
      if (info.columns == null) {
        info.columns = 50;
      }
    } else {
      info.rows = 1;
    }
    if ((info.validation != null) && info.validation.type in Validation.TYPES) {
      info.validation = validation = new Validation.TYPES[info.validation.type](_.extendAttrs({
        message: trans.make(info.validation.errorMsg)
      }, ['minLength', 'maxLength', 'minValue', 'maxValue', 'minWords', 'maxWords'], info.validation));
      if (info.prefix == null) {
        info.prefix = validation.prefix;
      }
      if (info.suffix == null) {
        info.suffix = validation.suffix;
      }
    } else {
      info.validation = void 0;
    }
    if (info.initialValue) {
      this.initialValue = trans.make(info.initialValue);
    }
    StringVariable.__super__.constructor.call(this, info);
  }

  StringVariable.prototype.validateResponse = function(response) {
    var ref;
    if (this.get('required') && !response.values[this.id] && !$('input[name=' + this.id + '], textarea[name=' + this.id + ']').closest('.hidden').length) {
      if (!this.get('choice') || this.get('choice').id === response.values[this.get('choice').get('variable').id] || ((ref = response.values[this.get('choice').get('variable').id]) != null ? typeof ref.indexOf === "function" ? ref.indexOf(this.get('choice').id) : void 0 : void 0) > -1) {
        throw new RequiredError;
      }
    }
    if (this.get('validation') != null) {
      return this.get('validation').validate(response.values[this.id]);
    }
  };

  StringVariable.prototype.template = CoffeeKup.compile(function(include_error_placeholder) {
    if (include_error_placeholder) {
      div({
        "class": 'error-placeholder',
        id: "error_" + this.id
      });
    }
    if (this.rows() === 1) {
      return div({
        "class": "input-wrap " + (this.get('prefix') ? 'input-prepend' : '') + " " + (this.get('suffix') ? 'input-append' : '')
      }, function() {
        var attrs, ref;
        if (this.get('prefix')) {
          span({
            "class": 'add-on'
          }, function() {
            return this.get('prefix');
          });
        }
        attrs = {
          id: "id_" + this.id,
          name: this.id,
          type: 'text',
          size: this.columns(),
          value: this.initialValue,
          "class": this.get('choice') ? 'other' : void 0
        };
        if (this.needsPiping()) {
          attrs['data-needsPiping'] = this.initialValue.toString().replace(/\{\{\s*([^\{\}]+)\s*\}\}/g, '$1');
        }
        input(_.extend(attrs, ((ref = this.get('validation')) != null ? ref.inputAttrs : void 0)));
        if (this.get('suffix')) {
          return span({
            "class": 'add-on'
          }, function() {
            return this.get('suffix');
          });
        }
      });
    } else {
      return textarea({
        id: "id_" + this.id,
        name: this.id,
        rows: this.rows(),
        cols: this.columns()
      }, function() {
        if (this.initialValue) {
          return text(this.initialValue);
        }
      });
    }
  });

  return StringVariable;

})(Variable);

HiddenVariable = (function(superClass) {
  extend(HiddenVariable, superClass);

  HiddenVariable.prototype.type = 'string';

  function HiddenVariable(info) {
    if (info.initialValue) {
      this.initialValue = trans.make(info.initialValue);
    }
    HiddenVariable.__super__.constructor.call(this, info);
  }

  HiddenVariable.prototype.template = CoffeeKup.compile(function() {
    var attrs;
    attrs = {
      id: "id_" + this.id,
      name: this.id,
      type: 'hidden',
      value: this.get('initialValue')
    };
    if (this.needsPiping()) {
      attrs['data-needsPiping'] = this.initialValue.toString().replace(/\{\{\s*([^\{\}]+)\s*\}\}/g, '$1');
    }
    return input(attrs);
  });

  return HiddenVariable;

})(Variable);

BooleanVariable = (function(superClass) {
  extend(BooleanVariable, superClass);

  function BooleanVariable() {
    return BooleanVariable.__super__.constructor.apply(this, arguments);
  }

  BooleanVariable.prototype.defaults = {
    appearance: 'default'
  };

  BooleanVariable.prototype.type = 'boolean';

  BooleanVariable.prototype.template = CoffeeKup.compile(function() {
    var class_value, ref;
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    if ((ref = this.get('appearance')) === 'radio' || ref === 'horizontal' || ref === 'slider' || ref === 'vertical') {
      if (this.get('appearance') === 'horizontal') {
        class_value = 'choices horizontal';
      } else {
        class_value = 'choices';
      }
      return ul({
        "class": class_value
      }, function() {
        li(function() {
          input({
            type: 'radio',
            name: this.id,
            value: '1',
            id: "id_" + this.id
          });
          return label({
            "for": "id_" + this.id
          }, function() {
            return (trans.make(TRANSLATIONS["strings.Yes"])).toString();
          });
        });
        return li(function() {
          input({
            type: 'radio',
            name: this.id,
            value: '0',
            id: "id_" + this.id + "_on"
          });
          return label({
            "for": "id_" + this.id + "_on"
          }, function() {
            return (trans.make(TRANSLATIONS["strings.No"])).toString();
          });
        });
      });
    } else {
      return input({
        type: 'checkbox',
        name: this.id,
        value: 'on',
        id: "id_" + this.id
      });
    }
  });

  BooleanVariable.prototype.getFormValue = function(value) {
    var ref;
    if ((ref = this.get('appearance')) === 'radio' || ref === 'horizontal') {
      if (value == null) {
        return [];
      } else {
        return [value ? '1' : '0'];
      }
    } else {
      if (!value) {
        return [];
      } else {
        return ['on'];
      }
    }
  };

  BooleanVariable.prototype.fromFormValue = function(value) {
    var ref;
    if ((ref = this.get('appearance')) === 'radio' || ref === 'horizontal') {
      if (!(value != null ? value.length : void 0)) {
        return void 0;
      } else {
        return !!Number(value[0]);
      }
    } else {
      return !!(value != null ? value.length : void 0);
    }
  };

  BooleanVariable.prototype.getScore = function(value) {
    if (value == null) {
      return 0;
    } else if (value) {
      return 1;
    } else {
      return 0;
    }
  };

  BooleanVariable.prototype.getExportValues = function(value) {
    return [value == null ? "" : !value ? "False" : "True"];
  };

  BooleanVariable.prototype.fromExportValues = function(values) {
    if (values[0] === "True") {
      return true;
    } else if (values[0] === "False") {
      return false;
    } else {
      return void 0;
    }
  };

  BooleanVariable.prototype.getPipedValue = function(value) {
    if (value == null) {
      return "";
    } else if (value === "0" || value === true) {
      return "Yes";
    } else {
      return "No";
    }
  };

  BooleanVariable.prototype.validateResponse = function(response) {
    var ref;
    if (this.get('required') && ((ref = this.get('appearance')) === 'radio' || ref === 'horizontal') && (response.values[this.id] == null) && !$('input[name=' + this.id + ']').closest('.hidden').length) {
      throw new RequiredError;
    }
  };


  /*getScore: (value) ->
  		if Boolean value then 1 else 0
   */

  return BooleanVariable;

})(Variable);

ChoiceVariable = (function(superClass) {
  extend(ChoiceVariable, superClass);

  function ChoiceVariable() {
    return ChoiceVariable.__super__.constructor.apply(this, arguments);
  }

  ChoiceVariable.prototype.defaults = _.extend(Variable.prototype.defaults, {
    randomize: false,
    appearance: 'vertical'
  });

  ChoiceVariable.prototype.choices = function() {
    return this.get('choices');
  };

  ChoiceVariable.prototype.appearance = function() {
    return this.get('appearance');
  };

  ChoiceVariable.prototype.initialValue = function() {
    return this.get('initialValue');
  };

  ChoiceVariable.prototype.alphabetize = function() {
    return this.get('alphabetize');
  };

  ChoiceVariable.prototype.choicesDisplay = function() {
    var choice, choices, fixed, i, j, k, len, len1, ref, shuffled, sortfunc;
    choices = this.choices();
    if (this.get('randomize')) {
      fixed = [];
      shuffled = [];
      for (i = j = 0, len = choices.length; j < len; i = ++j) {
        choice = choices[i];
        if (choice.get('other') || choice.get('na') || choice.get('static')) {
          fixed.push([i, choice]);
        } else {
          shuffled.push(choice);
        }
      }
      shuffled = _(shuffled).shuffled();
      for (k = 0, len1 = fixed.length; k < len1; k++) {
        ref = fixed[k], i = ref[0], choice = ref[1];
        shuffled.splice(i, 0, choice);
      }
      return shuffled;
    }
    if (this.get('alphabetize')) {
      sortfunc = (function(_this) {
        return function(a, b) {
          if (a.label() < b.label()) {
            return -1;
          } else {
            return 1;
          }
        };
      })(this);
      choices = _.toArray(choices);
      choices.sort(sortfunc);
    }
    return choices;
  };

  ChoiceVariable.prototype.template = CoffeeKup.compile(function() {
    var attrs, classes;
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    if (this.appearance() === 'dropdown' || this.appearance() === 'combo' || this.appearance() === 'drilldown') {
      attrs = {
        id: "id_" + this.id,
        name: this.id
      };
      if (this.appearance() === 'combo' || this.appearance() === 'drilldown') {
        attrs.size = 5;
      }
      if (this.type === 'multi') {
        attrs.multiple = 'multiple';
      }
      if (this.appearance() === 'drilldown') {
        attrs["class"] = 'drilldown';
      }
      return select(attrs, function() {
        var category, choice, i, j, k, len, len1, ref, ref1, results, results1;
        if (this.appearance() === 'dropdown') {
          option({
            value: ''
          }, function() {
            return "---";
          });
        }
        if (this.get('categories') != null) {
          i = 0;
          ref = this.get('categories');
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            category = ref[j];
            results.push(optgroup({
              label: category.label()
            }, function() {
              var choice, k, len1, ref1, results1;
              ref1 = category.get('choices');
              results1 = [];
              for (k = 0, len1 = ref1.length; k < len1; k++) {
                choice = ref1[k];
                option({
                  value: i
                }, function() {
                  return choice.label();
                });
                results1.push(i++);
              }
              return results1;
            }));
          }
          return results;
        } else {
          ref1 = this.choicesDisplay();
          results1 = [];
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            choice = ref1[k];
            attrs = {};
            if (this.get('extraction')) {
              attrs['data-extraction'] = choice.id;
            }
            if (choice.id === this.get('initialValue')) {
              results1.push(option({
                selected: 'selected',
                value: choice.id
              }, attrs, function() {
                return choice.label();
              }));
            } else {
              results1.push(option({
                value: choice.id
              }, attrs, function() {
                return choice.label();
              }));
            }
          }
          return results1;
        }
      });
    } else if (this.appearance() === 'star') {
      return div({
        "class": 'choices star-container clearfix'
      }, function() {
        var choice, id, j, len, ref, results;
        ref = this.choicesDisplay();
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          choice = ref[j];
          id = "id_" + this.id + "_" + choice.id;
          results.push(input({
            type: (this.type === 'multi' ? 'checkbox' : 'radio'),
            name: this.id,
            value: choice.id,
            id: id
          }));
        }
        return results;
      });
    } else {
      classes = 'choices';
      if (this.appearance() === 'horizontal') {
        classes += ' horizontal';
      }
      return ul({
        "class": classes
      }, function() {
        var choice, choiceLabel, j, len, ref, results;
        ref = this.choicesDisplay();
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          choice = ref[j];
          attrs = {};
          choiceLabel = choice.label();
          if (this.get('extraction')) {
            attrs['data-extraction'] = choice.id;
            choiceLabel = this.get('extraction').labelForChoice(choice.id);
          }
          results.push(li(attrs, function() {
            var id, other, v;
            other = this.type === 'multi' ? this.id + "_" + choice.id + "_other" : this.id + "_other";
            if (choice.get('other')) {
              div({
                "class": 'error-placeholder',
                id: "error_" + other
              });
            }
            id = "id_" + this.id + "_" + choice.id;
            attrs = {
              type: (this.type === 'multi' ? 'checkbox' : 'radio'),
              name: this.id,
              value: choice.id,
              id: id
            };
            if (choice.id === this.get('initialValue')) {
              attrs['checked'] = 'checked';
            }
            if (choice.get('na') && choice.get('check_all')) {
              attrs['class'] = 'na-choice check-all';
            } else if (choice.get('na')) {
              attrs['class'] = 'na-choice';
            } else if (choice.get('check_all')) {
              attrs['class'] = 'check-all';
            }
            input(attrs);
            label({
              "for": id
            }, function() {
              return Survey.pipe(choiceLabel);
            });
            if (choice.get('other')) {
              v = choice.get('other');
              text(' ');
              return html(v.render(false));
            }
          }));
        }
        return results;
      });
    }
  });

  return ChoiceVariable;

})(Variable);

SingleChoiceVariable = (function(superClass) {
  extend(SingleChoiceVariable, superClass);

  function SingleChoiceVariable() {
    return SingleChoiceVariable.__super__.constructor.apply(this, arguments);
  }

  SingleChoiceVariable.prototype.type = 'single';

  SingleChoiceVariable.prototype.inputType = 'radio';

  SingleChoiceVariable.prototype.getFormValue = function(value) {
    if (value != null) {
      return [value.toString()];
    } else if (this.appearance() === 'dropdown') {
      return [''];
    } else {
      return [];
    }
  };

  SingleChoiceVariable.prototype.fromFormValue = function(value) {
    if ((value != null ? value.length : void 0) && value[0].length) {
      return parseInt(value[0], 10);
    } else {
      return void 0;
    }
  };

  SingleChoiceVariable.prototype.getExportValues = function(value, options) {
    var cat, categories, category, ch, choice, i, j, k, label, len, len1, ref;
    categories = this.get('categories');
    category = void 0;
    choice = this.choices()[value];
    label = choice != null ? choice.label() : '';
    if (categories) {
      i = 0;
      for (j = 0, len = categories.length; j < len; j++) {
        cat = categories[j];
        ref = cat.get('choices');
        for (k = 0, len1 = ref.length; k < len1; k++) {
          ch = ref[k];
          if (ch.id === value) {
            category = cat;
            break;
          }
        }
        if (category != null) {
          break;
        }
        i++;
      }
      return [String(category != null ? category.label() + ': ' + label : label)];
    } else if (options != null ? options.label : void 0) {
      return [String(label)];
    } else {
      if ((value != null) && (choice != null)) {
        return ["" + (this.getScore(value))];
      } else {
        return [''];
      }
    }
  };

  SingleChoiceVariable.prototype.fromExportValues = function(values) {
    var categories, category, choice, j, k, l, len, len1, len2, ref, ref1;
    if (values[0] == null) {
      return void 0;
    }
    categories = this.get('categories');
    if (categories) {
      for (j = 0, len = categories.length; j < len; j++) {
        category = categories[j];
        ref = category.get('choices');
        for (k = 0, len1 = ref.length; k < len1; k++) {
          choice = ref[k];
          if (String(category.label() + ': ' + choice.label()) === values[0]) {
            return choice.id;
          }
        }
      }
    } else {
      ref1 = this.choices();
      for (l = 0, len2 = ref1.length; l < len2; l++) {
        choice = ref1[l];
        if (String(choice.score()) === values[0] || String(choice.label()) === values[0]) {
          return choice.id;
        }
      }
    }
    return void 0;
  };

  SingleChoiceVariable.prototype.getScore = function(value) {
    var choice;
    if (value != null) {
      value = parseInt(value, 10);
    }
    choice = this.choices()[value];
    if (choice != null) {
      return choice.score();
    } else {
      return void 0;
    }
  };

  SingleChoiceVariable.prototype.getPipedValue = function(value) {
    var choice;
    if (value != null) {
      value = parseInt(value, 10);
    }
    choice = this.choices()[value];
    return String(choice != null ? choice.label() : "");
  };

  return SingleChoiceVariable;

})(ChoiceVariable);


/*	getScore: (value) ->
		debugger
		return 0 unless value?
		choice = @choices()[value]
		return choice.get('score')
 */

MultipleChoiceVariable = (function(superClass) {
  extend(MultipleChoiceVariable, superClass);

  function MultipleChoiceVariable() {
    return MultipleChoiceVariable.__super__.constructor.apply(this, arguments);
  }

  MultipleChoiceVariable.prototype.type = 'multi';

  MultipleChoiceVariable.prototype.inputType = 'checkbox';

  MultipleChoiceVariable.prototype.validateResponse = function(response) {
    var checked, max, min, ref, ref1;
    MultipleChoiceVariable.__super__.validateResponse.call(this, response);
    if (this.get('restrictions')) {
      min = this.get('restrictions').minChecked;
      max = this.get('restrictions').maxChecked;
      checked = (ref = response.values[this.id]) != null ? ref.length : void 0;
      if (checked > max || (checked > 0 && checked < min)) {
        throw new ValidationError((ref1 = this.get('restrictions').message) != null ? ref1 : "You must select between " + min + " and " + max + " choices.");
      }
    }
  };

  MultipleChoiceVariable.prototype.getFormValue = function(value) {
    var el, j, len, ref, results;
    ref = value != null ? value : [];
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      el = ref[j];
      results.push(el.toString());
    }
    return results;
  };

  MultipleChoiceVariable.prototype.fromFormValue = function(value) {
    var el, j, len, ref, results;
    ref = value != null ? value : [];
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      el = ref[j];
      results.push(parseInt(el, 10));
    }
    return results;
  };

  MultipleChoiceVariable.prototype.getExportValues = function(value, opts) {
    var choice, j, len, ref, results;
    if (opts == null) {
      opts = {};
    }
    ref = this.choices();
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      choice = ref[j];
      if (_.include(value != null ? value : [], choice.id)) {
        if (opts.label) {
          results.push(choice.label());
        } else {
          results.push("1");
        }
      } else {
        results.push("");
      }
    }
    return results;
  };

  MultipleChoiceVariable.prototype.fromExportValues = function(values) {
    var choice, i, j, len, ref, result;
    result = [];
    ref = this.choices();
    for (i = j = 0, len = ref.length; j < len; i = ++j) {
      choice = ref[i];
      if (values[i] === "1") {
        result.push(choice.id);
      }
    }
    return result;
  };

  MultipleChoiceVariable.prototype.getScore = function(value) {
    var choice, j, len, score, scores, sum;
    scores = (function() {
      var j, len, ref, results;
      ref = this.choices();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        choice = ref[j];
        if (_.include(value != null ? value : [], choice.id)) {
          results.push(choice.score());
        }
      }
      return results;
    }).call(this);
    sum = 0;
    for (j = 0, len = scores.length; j < len; j++) {
      score = scores[j];
      sum += score;
    }
    return sum;
  };

  MultipleChoiceVariable.prototype.getPipedValue = function(value) {
    var choice;
    return ((function() {
      var j, len, ref, results;
      ref = this.choices();
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        choice = ref[j];
        if (_.include(value != null ? value : [], choice.id)) {
          results.push(choice.label());
        }
      }
      return results;
    }).call(this)).join(", ");
  };

  return MultipleChoiceVariable;

})(ChoiceVariable);

DateTimeVariable = (function(superClass) {
  extend(DateTimeVariable, superClass);

  function DateTimeVariable() {
    return DateTimeVariable.__super__.constructor.apply(this, arguments);
  }

  DateTimeVariable.prototype.FORMATS = {
    datetime: 'yyyy-MM-dd HH:mm:ss',
    datetimetz: 'yyyy-MM-dd HH:mm:sso',
    date: 'yyyy-MM-dd',
    time: 'HH:mm:ss',
    monthday: "MM/dd",
    yearmonth: "yyyy/MM"
  };

  DateTimeVariable.prototype.defaults = _.extend(Variable.prototype.defaults, {
    format: 'datetime',
    showNowButton: false
  });

  DateTimeVariable.prototype.type = 'datetime';

  DateTimeVariable.prototype.validateResponse = function(response) {
    DateTimeVariable.__super__.validateResponse.call(this, response);
    if (response.values[this.id] && response.values[this.id].indexOf("NaN") >= 0) {
      throw new ValidationError("Please enter the date in the form YYYY/MM/DD");
    }
  };

  DateTimeVariable.prototype.getExportValues = function(value) {
    if (value != null) {
      value = new _.date(value);
      return [value.format(this.FORMATS[this.get('format')])];
    } else {
      return [''];
    }
  };

  DateTimeVariable.prototype.fromExportValues = function(values) {
    var format, ref, value;
    value = (ref = values[0]) != null ? ref : void 0;
    if (value == null) {
      return;
    }
    format = this.get('format');
    if (format === 'datetime' || format === 'datetimetz' || format === 'date') {
      value = new _.date(value.replace(' ', 'T'));
    } else if (format === 'time') {
      value = _.date.parseTime(value);
    } else if (format === 'monthday') {
      value = new _.date(new _.date().getFullYear() + "/" + value);
    }
    return value;
  };

  DateTimeVariable.prototype.loadForm = function(form, value) {
    var dateInput, format, j, len, node, ref, results, timeInput;
    format = this.get('format');
    if (value != null) {
      value = new _.date(value);
      ref = form.childNodes;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        if (format === 'datetime' || format === 'datetimetz' || format === 'date') {
          dateInput = $(":input[name=" + (this.escapedId()) + "_date]", node).val([value.format('yyyy/MM/dd')]);
        }
        if (format === 'datetime' || format === 'datetimetz' || format === 'time') {
          timeInput = $(":input[name=" + (this.escapedId()) + "_time]", node).val([value.format(format === 'datetimetz' ? 'HH:mm:ss' : 'h:mmtt')]);
        }
        if (format === "monthday") {
          results.push(dateInput = $(":input[name=" + (this.escapedId()) + "_date]", node).val([value.format('MM/dd')]));
        } else {
          results.push(void 0);
        }
      }
      return results;
    }
  };

  DateTimeVariable.prototype.saveForm = function(form, values) {
    var date, format, time, value;
    format = this.get('format');
    date = form[this.id + "_date"];
    time = form[this.id + "_time"];
    value = null;
    if (format === 'datetime' || format === 'datetimetz' || format === 'date') {
      if (date != null ? date[0] : void 0) {
        value = new _.date(date[0]);
      }
    }
    if (format === 'datetime' || format === 'datetimetz' || format === 'time') {
      if ((time != null ? time[0] : void 0) && (value != null)) {
        value.setHMS(_.date.parseTime(time[0]));
      } else if (time != null ? time[0] : void 0) {
        value = _.date.parseTime(time[0]);
      }
    }
    if (format === 'monthday' && (date != null ? date[0] : void 0)) {
      value = new _.date(new _.date().getFullYear() + "/" + date[0]);
    }
    return values[this.id] = value != null ? value.format(this.FORMATS[format]) : void 0;
  };

  DateTimeVariable.prototype.template = CoffeeKup.compile(function() {
    var attrs, format;
    format = this.get('format');
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    attrs = this.get('showNowButton') ? {
      readonly: true
    } : {};
    if (format === 'datetime' || format === 'datetimetz' || format === 'date') {
      input({
        id: "id_" + this.id + "_date",
        name: this.id + "_date",
        type: 'text',
        "class": 'date',
        placeholder: "YYYY/MM/DD"
      }, attrs);
    }
    if (format === 'datetime' || format === 'datetimetz' || format === 'time') {
      input({
        id: "id_" + this.id + "_time",
        name: this.id + "_time",
        type: 'text',
        "class": 'time',
        placeholder: "HH:MM"
      }, attrs);
    }
    if (format === 'monthday') {
      input({
        id: "id_" + this.id + "_date",
        name: this.id + "_date",
        type: 'text',
        "class": 'month-day',
        placeholder: "MM/DD"
      }, attrs);
    }
    if (this.get('showNowButton')) {
      return a({
        "class": 'button datetime-now',
        href: '#'
      }, function() {
        return "Record Now";
      });
    }
  });

  return DateTimeVariable;

})(Variable);

module.exports = {
  StringVariable: StringVariable,
  SingleChoiceVariable: SingleChoiceVariable,
  MultipleChoiceVariable: MultipleChoiceVariable,
  DateTimeVariable: DateTimeVariable,
  BooleanVariable: BooleanVariable,
  HiddenVariable: HiddenVariable,
  Variable: Variable
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(52);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(21);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var templ = __webpack_require__(1554);

var Loader = function () {
	function Loader(element, size, options) {
		_classCallCheck(this, Loader);

		this.element = $(element);

		var isTranslated = false;
		if (options !== undefined) {
			isTranslated = options.isTranslated;
		}

		this.loader = $(templ({
			size: size,
			isTranslated: isTranslated
		}));

		this.element.prepend(this.loader);
	}

	_createClass(Loader, [{
		key: 'show',
		value: function show() {
			this.loader.show();
		}
	}, {
		key: 'hide',
		value: function hide() {
			this.loader.hide();
		}
	}]);

	return Loader;
}();

module.exports = Loader;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(36);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSlice);


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(24);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(88);
var fails = __webpack_require__(21);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(89);
var IObject = __webpack_require__(233);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(31);
var asc = __webpack_require__(428);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropSelect = __webpack_require__(114);

var _require = __webpack_require__(6),
    Prompt = _require.Prompt;

var ajax = __webpack_require__(4);

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     checked: true
 * }
 * onDone is a callback that is passed the item list in the same format as above */

var DropSelectEditable = function (_DropSelect) {
	_inherits(DropSelectEditable, _DropSelect);

	function DropSelectEditable() {
		_classCallCheck(this, DropSelectEditable);

		return _possibleConstructorReturn(this, (DropSelectEditable.__proto__ || Object.getPrototypeOf(DropSelectEditable)).apply(this, arguments));
	}

	_createClass(DropSelectEditable, [{
		key: 'initialize',
		value: function initialize(options) {
			var _this2 = this;

			this.editable = true;
			this.createButton = true;
			this.noCancelButton = true;
			this.createUrl = options.createUrl;
			this.doneButtonSize = 'sm';
			this.doneCallback = options.doneCallback || null;
			this.createCallback = options.createCallback || null;
			this.dataType = options.dataType || 'json';
			this.name = options.name || '';
			this.localized = options.localized || false;
			this.language = options.language || '';
			_get(DropSelectEditable.prototype.__proto__ || Object.getPrototypeOf(DropSelectEditable.prototype), 'initialize', this).call(this, options);
			if (this.localized) {
				if (!this.language && window.__EDIT_LANGUAGE) {
					this.language = window.__EDIT_LANGUAGE;
					this.getItems();
				}
				postal.subscribe({
					channel: "i18n",
					topic: "language.changed",
					callback: function callback(data, envelope) {
						_this2.languageChange(data.lang);
					}
				});
			}
		}
	}, {
		key: 'languageChange',
		value: function languageChange(newLanguage) {
			this.language = newLanguage;
			this.getItems();
		}
	}, {
		key: 'adjustUrlForLanguage',
		value: function adjustUrlForLanguage(url) {
			if (this.language !== '') if (url.includes('?')) url += '&lang_override=' + this.language;else url += '?lang_override=' + this.language;
			return url;
		}
	}, {
		key: 'addLabels',
		value: function addLabels() {
			if (this.doneCallback) {
				this.doneCallback();
			}

			this.handleDone();
		}
	}, {
		key: 'handleDone',
		value: function handleDone() {
			_get(DropSelectEditable.prototype.__proto__ || Object.getPrototypeOf(DropSelectEditable.prototype), 'handleDone', this).call(this);
		}
	}, {
		key: 'createNewItem',
		value: function createNewItem() {
			var _this3 = this;

			var createItem = function createItem(value) {
				var that = _this3;
				var url = _this3.adjustUrlForLanguage(_this3.createUrl);
				ajax.post({
					url: url,
					dataType: that.dataType,
					data: { 'name': value },
					callback: function callback(data) {
						that.updateChangedItems();
						that.getItems();
						if (_this3.createCallback) {
							_this3.createCallback(data);
						}
					}
				});
			};

			var dlg = new Prompt(this.createButtonLabel || gettext('New'), this.name, createItem);

			var ok = dlg.modalFooter.find('.sma-js-notify-ok');
			ok.addClass('disabled');
			$('.sma-js-validate-input').on('input', function () {
				var value = dlg.modalBody.find('.sma-js-validate-input').val();
				ok.toggleClass('disabled', value.length === 0);
			});
		}
	}, {
		key: 'events',
		get: function get() {
			var events = _get(DropSelectEditable.prototype.__proto__ || Object.getPrototypeOf(DropSelectEditable.prototype), 'events', this);

			events['click .sma-js-dropselect-create-new'] = 'createNewItem';
			events['click .sma-js-dropselect-done'] = 'addLabels';

			return events;
		}
	}]);

	return DropSelectEditable;
}(DropSelect);

module.exports = DropSelectEditable;

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(68);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(68);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(120);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(68);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(47);


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (castFunction);


/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(33)) {
  var LIBRARY = __webpack_require__(134);
  var global = __webpack_require__(18);
  var fails = __webpack_require__(21);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(295);
  var $buffer = __webpack_require__(436);
  var ctx = __webpack_require__(89);
  var anInstance = __webpack_require__(165);
  var propertyDesc = __webpack_require__(158);
  var hide = __webpack_require__(65);
  var redefineAll = __webpack_require__(167);
  var toInteger = __webpack_require__(91);
  var toLength = __webpack_require__(31);
  var toIndex = __webpack_require__(885);
  var toAbsoluteIndex = __webpack_require__(161);
  var toPrimitive = __webpack_require__(98);
  var has = __webpack_require__(75);
  var classof = __webpack_require__(188);
  var isObject = __webpack_require__(24);
  var toObject = __webpack_require__(39);
  var isArrayIter = __webpack_require__(425);
  var create = __webpack_require__(162);
  var getPrototypeOf = __webpack_require__(78);
  var gOPN = __webpack_require__(163).f;
  var getIterFn = __webpack_require__(427);
  var uid = __webpack_require__(159);
  var wks = __webpack_require__(30);
  var createArrayMethod = __webpack_require__(101);
  var createArrayIncludes = __webpack_require__(285);
  var speciesConstructor = __webpack_require__(236);
  var ArrayIterators = __webpack_require__(430);
  var Iterators = __webpack_require__(190);
  var $iterDetect = __webpack_require__(290);
  var setSpecies = __webpack_require__(164);
  var arrayFill = __webpack_require__(429);
  var arrayCopyWithin = __webpack_require__(874);
  var $DP = __webpack_require__(37);
  var $GOPD = __webpack_require__(77);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(880);
var $export = __webpack_require__(2);
var shared = __webpack_require__(232)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(883))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(27);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var selectTempl = __webpack_require__(1575);
var itemsTempl = __webpack_require__(898);
var groupTempl = __webpack_require__(899);
var itemActionsTempl = __webpack_require__(1576);
var wrapsTempl = __webpack_require__(1577);

/* pass in items as a list of objects like this:
 * {
 *	   name: 'foo',
 *	   text: 'foobar',
 *	   checked: true,
 *	   ignoreItemActions: false
 * }
 * onDone is a callback that is passed the item list in the same format as above */

var DropSelect = function (_Backbone$View) {
	_inherits(DropSelect, _Backbone$View);

	function DropSelect() {
		_classCallCheck(this, DropSelect);

		return _possibleConstructorReturn(this, (DropSelect.__proto__ || Object.getPrototypeOf(DropSelect)).apply(this, arguments));
	}

	_createClass(DropSelect, [{
		key: 'initialize',
		value: function initialize(options) {
			$(document).on('click', '.sma-dropselect, .sma-dropselect .dropdown-item', function (e) {
				return e.stopPropagation();
			});

			if (_.has(options, 'itemNameFromSelectBox')) this.itemNameFromSelectBox = options.itemNameFromSelectBox;

			this.handleSelectElement(options);

			this.loading = false;

			//pass in this for access to an extra object (ie. grid)
			this.additionalScope = options.additionalScope || null;

			this.buttonSize = options.buttonSize || 'btn-md';
			this.textStyleButton = options.textStyleButton || false;
			this.btnClass = options.btnClass || 'btn-default';

			this.itemActions = options.itemActions || null;

			this.inline = options.inline || null;

			this.closeOnItemSelect = options.closeOnItemSelect || false;
			this.popoverPlacement = options.popoverPlacement || 'right';

			this.populateItemsFromDatasource = options.populateItemsFromDatasource || false;
			this.itemsFromDatasource = options.itemsFromDatasource;

			this.checkboxItems = 'checkboxItems' in options ? options.checkboxItems : true;

			if (_.has(options, 'selectedCount')) this.selectedCount = options.checkboxItems;

			if (_.has(options, 'noDropdown')) this.noDropdown = options.noDropdown;

			if (_.has(options, 'createButtonLabel')) this.createButtonLabel = options.createButtonLabel;

			if (_.has(options, 'noDoneButton')) this.noDoneButton = options.noDoneButton;

			if (_.has(options, 'singleSelect')) this.singleSelect = options.singleSelect;

			if (_.has(options, 'selector')) this.selector = options.selector;

			if (_.has(options, 'minimumSelected')) this.minimumSelected = options.minimumSelected;

			this.setItems(options.items);

			this.onDone = options.onDone || function () {
				return;
			};
			this.alignRight = options.alignRight || false;

			this.fullWidth = options.fullWidth || false;
			this.dropup = options.dropup || false;

			this.doneClass = 'sma-js-dropselect-done';
			this.cancelClass = 'sma-js-dropselect-cancel';

			this.title = options.title;
			this.dropdownToggle = options.dropdownToggle || false;

			this.filtering = null;

			this.disabledItems = {};

			this.render();

			this.onSelectChange = options.onSelectChange;
			if (this.$selectEl) {
				this.$selectEl.after(this.$el);
			}
		}
	}, {
		key: 'filterValues',
		value: function filterValues(values) {
			this.filtering = values;

			this.renderItems();
			this.updateSelectControls();
		}
	}, {
		key: 'itemNameFromSelectBox',
		value: function itemNameFromSelectBox($item) {
			return $item.val();
		}
	}, {
		key: 'populateFromSelectBox',
		value: function populateFromSelectBox(options) {
			var _this2 = this;

			this.$selectEl.hide();

			if (this.$selectEl.attr('multiple')) {
				this.singleSelect = false;
			}

			var $options = this.$selectEl.find('option');
			var items = [];

			// Create the list of items
			if ($options.length > 0) {
				$options.each(function (i, item) {
					var $item = $(item);
					var selected = _this2.$selectEl.val() ? $item.is(':selected') : false;
					var disabled = $item.attr('disabled');

					if (parseInt($item.val()) > -1 || isNaN($item.val()) || $item.val() == '') {
						items.push({
							name: _this2.itemNameFromSelectBox($item),
							text: (0, _utils.escapeHtml)($item.text()),
							selected: selected,
							header: disabled
						});
					}
				});
			}

			options.items = items;

			var title = this.updateTitleFromSelect();
			if (title) {
				options.title = title;
			}
		}
	}, {
		key: 'handleSelectElement',
		value: function handleSelectElement(options) {
			this.$selectEl = options.$selectEl || null;

			if (this.$selectEl) {
				if (typeof this.populateFromSelectBox == 'function') {
					this.populateFromSelectBox(options);
				}
			}
		}
	}, {
		key: 'visibleItems',
		value: function visibleItems() {
			var visibleItems = this.changedItems;

			if (this.filtering != null) {
				visibleItems = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.changedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (this.filtering.indexOf(item.name) > -1) {
							visibleItems.push(item);
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}

			return visibleItems;
		}
	}, {
		key: 'getItems',
		value: function getItems() {
			if (this.populateItemsFromDatasource) {
				this.loading = true;
				this.$items.empty();
				this.items = this.itemsFromDatasource.call(this);
			}
		}
	}, {
		key: 'changeTitle',
		value: function changeTitle(newTitle) {
			var $title = this.$el.find('.sma-js-dropdown-toggle');

			$title.html(newTitle);
		}
	}, {
		key: 'formatTitle',
		value: function formatTitle(item) {
			return item.text;
		}
	}, {
		key: 'itemSelectDone',
		value: function itemSelectDone() {
			return;
		}
	}, {
		key: 'updateChangedItems',
		value: function updateChangedItems() {
			this.changedItems = this.displayedItems;
		}
	}, {
		key: 'enableAllItems',
		value: function enableAllItems() {
			this.disabledItems.length = 0;
			this.disabledItems = {};

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = this.$el.find('.sma-js-action-item.disabled')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var el = _step2.value;

					var $el = $(el);

					$el.removeClass('disabled');

					if ($el.attr('data-toggle') === 'tooltip') {
						$el.removeAttr('data-toggle');
						$el.removeAttr('title');
						$el.removeAttr('data-placement');
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	}, {
		key: 'disableItem',
		value: function disableItem(id, reason) {
			this.disabledItems[id] = reason;
			try {
				id = id.replace(/"/g, '\\"');
			} catch (err) {}

			var $el = this.$el.find('.sma-js-action-item[name="' + id + '"]');

			$el.addClass('disabled');

			if (reason !== undefined) {
				$el.attr('data-toggle', 'tooltip').attr('data-placement', 'left').attr('title', reason).tooltip();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			this._el = selectTempl({
				title: this.title,
				dropdownToggle: this.dropdownToggle,
				alignRight: this.alignRight,
				dropup: this.dropup,
				go: gettext('Go'),
				searchfor: gettext('Search for...'),
				cancel: gettext('Cancel'),
				done: gettext('Done'),
				btnClass: this.btnClass,
				doneClass: this.doneClass,
				inline: this.inline,
				cancelClass: this.cancelClass,
				drilldown: this.drilldown || false,
				noFooter: this.noFooter || false,
				createButton: this.createButton || false,
				noCancelButton: this.noCancelButton || false,
				noDoneButton: this.noDoneButton || false,
				showSelectControls: this.showSelectControls || false,
				doneButtonSize: 'btn-' + (this.doneButtonSize || 'md'),
				createButtonLabel: this.createButtonLabel || gettext('Create'),
				textStyleButton: this.textStyleButton ? 'text-style-button' : '',
				editable: this.editable || false,
				closeButton: this.editable || false,
				noDropdown: this.noDropdown || false,
				strings: {
					all: gettext('All'),
					none: gettext('None'),
					selected: gettext('Selected:')
				},
				buttonSize: this.buttonSize,
				fullWidth: this.fullWidth,
				selectedCount: this.selectedCount
			});

			this.setElement(this._el);

			this.renderContents();

			if (this.$selectEl) {
				this.$selectEl.hide();
			}

			this.updateSelectControls();
			this.updateSelectedCount();
		}
	}, {
		key: 'renderContents',
		value: function renderContents() {
			this.renderItems();
		}
	}, {
		key: 'setItems',
		value: function setItems(items) {
			if (this.refreshSelectBox && this.changedItems) {
				items = this.refreshSelectBox(items);
			}

			this.items = items;
			this.changedItems = $.extend(true, [], items);
			this.updateSelectControls();
		}
	}, {
		key: 'setEvents',
		value: function setEvents(e) {
			var _this3 = this;

			this.items.forEach(function (action) {
				var $el = void 0;
				var actionFunc = void 0;

				if (action.name) {
					var n = action.name;
					try {
						n = n.replace(/"/g, '\\"');
					} catch (err) {}
					$el = _this3.$el.find('a[name="' + n + '"]');
				}

				if (typeof action.action === 'function') {
					actionFunc = action.action;
				} else if (typeof _this3.globalItemAction === 'function') {
					actionFunc = _this3.globalItemAction;
				}

				if ($el && actionFunc) {
					$el.click(function (e) {
						if (!_this3.actionItemWasClicked(e)) {
							actionFunc.bind(_this3)(action);
						}
					});
				}
			});
		}
	}, {
		key: 'renderItemsFromDatasource',
		value: function renderItemsFromDatasource(items) {
			this.setItems(items);
			this.renderItems();
		}
	}, {
		key: 'hideDropdown',
		value: function hideDropdown(e) {
			var modalCount = $('.sma-modal:visible').length;

			if (this.$el.closest('.sma-modal').length && modalCount > 1 || this.loading || $('.popover').length !== 0) {
				return false;
			} else {
				this.renderItems();
			}
		}
	}, {
		key: 'handlePopovers',
		value: function handlePopovers() {
			var _this4 = this;

			for (var disabledItem in this.disabledItems) {
				var $item = this.$items.find('.sma-js-action-item[name="' + disabledItem + '"]');

				$item.addClass('disabled').attr('data-toggle', 'tooltip').attr('data-placement', 'left').attr('title', this.disabledItems[disabledItem]).tooltip();
			}

			var itemMap = _.indexBy(this.items, 'name');

			this.$items.find('.sma-js-dropselect-editable-itemactions').each(function (i, target) {
				var $item = $(target);
				var itemName = $item.prop("name");
				var item = itemMap[itemName];
				var itemActions = _this4.itemActions;

				if (!item) {
					return;
				}

				if (item.hideActions) {
					itemActions = _.filter(itemActions, function (action) {
						return !item.hideActions.includes(action.name);
					});
				}

				$item.popover({
					placement: _this4.popoverPlacement,
					html: true,
					content: itemActionsTempl({
						items: itemActions,
						itemName: itemName
					}),
					template: wrapsTempl,
					trigger: 'focus',
					animation: false,
					delay: { show: 0, hide: 300 }
				});
			});
		}
	}, {
		key: 'renderItems',
		value: function renderItems() {
			this.$items = this.$el.find('.sma-dropselect-items');
			this.$items.empty();

			var items = {
				items: this.visibleItems(),
				checkboxes: this.checkboxItems,
				itemActions: this.itemActions ? true : false,
				strings: {
					noItems: gettext('No items')
				}
			};

			this.$items.append(itemsTempl(items));

			this.$items.find('.custom-control-indicator').each(function (i, el) {
				if ($(el).hasClass('sma-js-mixed-check')) {
					$(el).siblings('.custom-control-input').prop('indeterminate', true);
				}
			});

			this.handlePopovers();

			if (this.$selectEl) {
				this.selectItemFromSelect();
			}

			if (this.items !== undefined) {
				this.setEvents();
			}
		}
	}, {
		key: 'selectItemFromSelect',
		value: function selectItemFromSelect() {
			var value = this.$selectEl.val();
			try {
				value = value.replace(/"/g, '\\"');
			} catch (err) {}

			var $el = this.$el.find('.sma-js-action-item[name="' + value + '"]');

			$el.addClass('active');
		}
	}, {
		key: 'bindItemActions',
		value: function bindItemActions() {
			var that = this;

			$('.sma-js-dropselect-popover-item').click(function () {
				var $target = $(this);
				var actionName = $target.prop("name");
				var itemName = $target.data("item");
				var item = _.findWhere(that.items, { name: itemName });
				// Need to handle the case where itemName was an integer
				if (!item) item = _.findWhere(that.items, { name: itemName.toString() });
				var itemText = item.text;
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = that.itemActions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var action = _step3.value;

						if (actionName === action.name) {
							that.updateChangedItems();
							action.action.call(that, itemName, itemText);
							return false;
						}
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
			});
		}
	}, {
		key: 'selectMixedCheckbox',
		value: function selectMixedCheckbox(e) {
			$(e.currentTarget).siblings('.sma-js-mixed-check').removeClass('sma-js-mixed-check');
		}
	}, {
		key: 'unSelectAll',
		value: function unSelectAll() {
			this.$el.find('.sma-js-action-item').removeClass('active');

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = this.changedItems[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var item = _step4.value;

					item.selected = false;
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}
		}

		//this let's us know if the action item popover button was clicked.
		//If it was, then we only want do open it and not do anything else.

	}, {
		key: 'actionItemWasClicked',
		value: function actionItemWasClicked(e) {
			if (e) {
				var $target = $(e.target);

				if ($target.hasClass('sma-js-dropselect-editable-itemactions') || $target.parent().hasClass('sma-js-dropselect-editable-itemactions')) {
					return true;
				}
			}
			return false;
		}
	}, {
		key: 'selectItem',
		value: function selectItem(e) {
			if (this.actionItemWasClicked(e)) {
				return false;
			}

			if (this.selector) {
				var $target = $(e.currentTarget);

				if (this.disabledItems[$target.attr('name')] !== undefined) {
					return false;
				}

				if (!this.checkboxItems && this.singleSelect) {
					this.unSelectAll();
				}

				if ($target.hasClass('active') && this.$selectEl.find('option:selected').length - 1 < this.minimumSelected) {
					return;
				}

				$target.toggleClass('active');

				this.updateChangedItems();

				if (this.$selectEl) {
					var name = $target.attr('name');
					var esc_name = name.replace(/"/g, '\\"');
					var $option = this.$selectEl.find('option[value="' + esc_name + '"]');

					if (this.singleSelect) {
						this.$selectEl.val(name);
						if (this.onSelectChange) {
							this.onSelectChange(name);
						}
					} else {
						var active = $target.hasClass('active');

						if (active) {
							$option.prop('selected', true);
						} else {
							$option.prop('selected', false);
						}
					}

					this.$selectEl.change();
					this.itemSelectDone();

					this.updateTitleFromSelect();
				}
				if (this.closeOnItemSelect || this.$selectEl && this.singleSelect) {
					this.handleDone();
				}
			}
			return false;
		}
	}, {
		key: 'updateTitleFromSelect',
		value: function updateTitleFromSelect() {
			var _this5 = this;

			var title = void 0;

			if (this.changeTitleAfterSelection) {
				if (this.singleSelect) {
					var item = this.parseItem(this.$selectEl.find(':selected'));
					title = this.formatTitle(item);
				} else {
					var item_names = [];
					this.$selectEl.find(':selected').each(function (i, item) {
						if ($(item).val() !== '-1') {
							// Ignore the "null" option when creating the title
							item_names.push(_this5.parseItem($(item)).text);
						}
					});

					title = item_names.join(', ');
				}

				if (!title.length) {
					title = this.$selectEl.find('option[value=""]').text();

					if (!title.length) {
						title = gettext('Please select...');
					}
				}

				this.changeTitle(title);

				return title;
			}
		}
	}, {
		key: 'getPretext',
		value: function getPretext($item) {
			return null;
		}
	}, {
		key: 'parseItem',
		value: function parseItem($item) {
			var selected = $item.is(':selected');
			var value = _.escape($item.val());

			return {
				name: value,
				pretext: this.getPretext(value),
				text: (0, _utils.escapeHtml)($item.text()),
				selected: selected
			};
		}
	}, {
		key: 'itemChanged',
		value: function itemChanged(e) {
			this.updateSelectControls();

			if (this.$selectEl) {
				var $option = this.$selectEl.find('option[value="' + $(e.currentTarget).prop('name') + '"]');

				$option.prop('selected', $(e.currentTarget).is(':checked'));
			}

			this.updateSelectedCount();
		}
	}, {
		key: 'selectAll',
		value: function selectAll(e) {
			if (e) e.preventDefault();

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = this.changedItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var ci = _step5.value;

					ci.checked = true;
					ci.selected = true;
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			this.renderItems();
			this.updateSelectElement();
			this.updateSelectControls();
			this.updateTitleFromSelect();
		}
	}, {
		key: 'selectNone',
		value: function selectNone(e) {
			if (e) e.preventDefault();

			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = this.changedItems[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var ci = _step6.value;

					ci.checked = false;
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}

			this.renderItems();
			this.updateSelectElement();
			this.updateSelectControls();
		}
	}, {
		key: 'updateSelectElement',
		value: function updateSelectElement() {
			var _iteratorNormalCompletion7 = true;
			var _didIteratorError7 = false;
			var _iteratorError7 = undefined;

			try {
				for (var _iterator7 = this.changedItems[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
					var item = _step7.value;

					var $option = this.$selectEl.find('option[value="' + item.name + '"]');

					$option.prop('selected', item.checked);
				}
			} catch (err) {
				_didIteratorError7 = true;
				_iteratorError7 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion7 && _iterator7.return) {
						_iterator7.return();
					}
				} finally {
					if (_didIteratorError7) {
						throw _iteratorError7;
					}
				}
			}
		}
	}, {
		key: 'updateSelectControls',
		value: function updateSelectControls() {
			if (!this.showSelectControls || this.$items === undefined) {
				return;
			}

			this.$selectControlsCount.text(this.selectedItems.length);
		}
	}, {
		key: 'updateSelectedCount',
		value: function updateSelectedCount() {
			if (this.selectedCount) {
				this.$el.find('.sma-js-selected-count').text(gettext('Selected: ') + this.selectedItems.length);
			}
		}
	}, {
		key: 'handleCancel',
		value: function handleCancel() {
			this.renderItems();
			this.changedItems = $.extend(true, [], this.items);
			this.$el.removeClass('show');
			return false;
		}
	}, {
		key: 'handleDone',
		value: function handleDone() {
			this.updateChangedItems();
			this.items = $.extend(true, [], this.changedItems);
			this.onDone(this.changedItems);
			this.$el.removeClass('show');
			return false;
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-dropselect-done': 'handleDone',
				'click .sma-js-dropselect-cancel': 'handleCancel',
				'click .sma-js-dropselect-editable-itemactions': 'bindItemActions',
				'click .custom-control-input': 'selectMixedCheckbox',
				'click .sma-js-action-item': 'selectItem',
				'click .sma-js-dropselect-select-all': 'selectAll',
				'click .sma-js-dropselect-select-none': 'selectNone',
				'change .dropdown-item input[type="checkbox"]': 'itemChanged',
				'hide.bs.dropdown': 'hideDropdown',
				'shown.bs.dropdown': 'getItems'
			};
		}
	}, {
		key: 'displayedItems',
		get: function get() {
			var items = [];

			if (this.selector) {
				_.each(this.$items.children(), function (item) {
					//items are different when it's a selector
					var $item = $(item);
					var name = $item.attr('name');
					var text = _.escape($item.text());

					items.push({
						name: name,
						text: text,
						selected: $item.hasClass('active'),
						header: $item.is('h6')
					});
				});
			} else {
				_.each(this.$items.children(), function (item) {
					var $item = $(item).find('input');
					items.push({
						name: _.escape($item.attr('name')),
						text: _.escape($item.parent().text()),
						checked: $item.is(':checked'),
						mixedCheck: $(item).find('.custom-control-indicator').hasClass('sma-js-mixed-check'),
						header: $item.is('h6')
					});
				});
			}
			return items;
		}
	}, {
		key: '$selectControls',
		get: function get() {
			return this.$el.find('.sma-js-dropselect-select-controls');
		}
	}, {
		key: '$selectControlsCount',
		get: function get() {
			return this.$selectControls.find('.sma-js-dropselect-selected-count');
		}
	}, {
		key: 'selectedItems',
		get: function get() {
			return _.filter(this.displayedItems, function (item) {
				return item.checked || false;
			});
		}
	}]);

	return DropSelect;
}(Backbone.View);

module.exports = DropSelect;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropSelect = __webpack_require__(114);
var DropSelectorDrilldown = __webpack_require__(446);

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */

var DropSelectorBase = function (_DropSelect) {
	_inherits(DropSelectorBase, _DropSelect);

	function DropSelectorBase() {
		_classCallCheck(this, DropSelectorBase);

		return _possibleConstructorReturn(this, (DropSelectorBase.__proto__ || Object.getPrototypeOf(DropSelectorBase)).apply(this, arguments));
	}

	_createClass(DropSelectorBase, [{
		key: 'initialize',
		value: function initialize(options) {
			this.checkboxItems = false;
			this.selector = true;
			this.noFooter = true;
			this.changeTitleAfterSelection = true;
			this.singleSelect = true;

			options.checkboxItems = false;

			_get(DropSelectorBase.prototype.__proto__ || Object.getPrototypeOf(DropSelectorBase.prototype), 'initialize', this).call(this, options);
		}
	}, {
		key: 'val',
		value: function val(newSelected) {
			var change = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (newSelected) {
				this.unSelectAll();

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.changedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var item = _step.value;

						if (this.singleSelect && item.name === newSelected || !this.singleSelect && newSelected.indexOf(item.name) >= 0) {
							item.selected = true;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.$selectEl.val(newSelected);
				this.renderItems();

				this.updateTitleFromSelect();
			}

			return this.$selectEl.val();
		}
	}, {
		key: 'wrapped',
		get: function get() {
			return $('<div></div>').append(this.$selectEl).append(this.$el);
		}
	}]);

	return DropSelectorBase;
}(DropSelect);

var DropSelector = function DropSelector(options) {
	_classCallCheck(this, DropSelector);

	if (options.$selectEl.find('optgroup').length) {
		var instance = new DropSelectorDrilldown(options);
	} else {
		var instance = new DropSelectorBase(options);
	}

	return instance;
};

//make new dropselectors for anything with sma-js-dropselector class


$(function () {
	$('.sma-js-dropselector').each(function (i, item) {
		new DropSelector({
			$selectEl: $(item)
		});
	});
});

module.exports = DropSelector;

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClickableArea", function() { return ClickableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_popper_js__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var enhance = Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["setDisplayName"])('Popper'), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["setPropTypes"])({
  renderRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
  renderPop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  defaultIsOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withStateHandlers"])({
  reference: null
}, {
  setReference: function setReference() {
    return function (reference) {
      if (reference) {
        return {
          reference: reference
        };
      }
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withStateHandlers"])({
  pop: null,
  popper: null
}, {
  setPop: function setPop(_ref, props) {
    var prevPopper = _ref.popper;
    return function (pop) {
      if (prevPopper) {
        prevPopper.destroy();
      }
      var popper = pop ? new __WEBPACK_IMPORTED_MODULE_3_popper_js__["a" /* default */](props.reference, pop, props.options) : null;
      return { pop: pop, popper: popper };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withStateHandlers"])(function (_ref2) {
  var _ref2$defaultIsOpened = _ref2.defaultIsOpened,
      defaultIsOpened = _ref2$defaultIsOpened === undefined ? false : _ref2$defaultIsOpened;
  return {
    isOpened: defaultIsOpened
  };
}, {
  open: function open(_, props) {
    return function () {
      return {
        isOpened: true
      };
    };
  },
  close: function close() {
    return function () {
      return {
        isOpened: false
      };
    };
  },
  toggle: function toggle(_ref3, props) {
    var isOpened = _ref3.isOpened;
    return function () {
      return {
        isOpened: !isOpened
      };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["withHandlers"])({
  onClick: function onClick(props) {
    return function (e) {
      if (props.reference && !props.canClickOutside && !e.canBeIgnoredByReactPopper) {
        var isInsidePop = props.pop && props.pop.contains(e.target);
        if (!props.reference.contains(e.target) && !isInsidePop) {
          // click outside
          props.close();
        }
      }
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["lifecycle"])({
  componentDidUpdate: function componentDidUpdate() {
    if (this.props.popper) {
      this.props.popper.scheduleUpdate();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.options != nextProps.options && this.props.pop) {
      this.props.setPop(this.props.pop);
    }
  },
  componentWillMount: function componentWillMount() {
    document.addEventListener('mousedown', this.props.onClick);
  },
  componentWillUnmount: function componentWillUnmount() {
    document.removeEventListener('mousedown', this.props.onClick);
    if (this.props.popper) {
      this.props.popper.destroy();
    }
  }
}));

/* harmony default export */ __webpack_exports__["default"] = (enhance(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    props.renderRef(_extends({}, props)),
    props.isOpened && __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(props.renderPop ? props.renderPop(_extends({}, props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        ref: props.setPop,
        style: props.style,
        className: props.className },
      props.children
    ), document.body)
  );
}));

var ClickableArea = function ClickableArea(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { ref: function ref(el) {
        return el && el.addEventListener('mousedown', ignoreEvent);
      } },
    props.children
  );
};

function ignoreEvent(e) {
  e.canBeIgnoredByReactPopper = true;
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBind_js__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createCurry_js__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createHybrid_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createPartial_js__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getData_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeData_js__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setData_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setWrapToString_js__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toInteger_js__ = __webpack_require__(16);











/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(Object(__WEBPACK_IMPORTED_MODULE_9__toInteger_js__["a" /* default */])(ary), 0);
  arity = arity === undefined ? arity : Object(__WEBPACK_IMPORTED_MODULE_9__toInteger_js__["a" /* default */])(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : Object(__WEBPACK_IMPORTED_MODULE_5__getData_js__["a" /* default */])(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    Object(__WEBPACK_IMPORTED_MODULE_6__mergeData_js__["a" /* default */])(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__createBind_js__["a" /* default */])(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = Object(__WEBPACK_IMPORTED_MODULE_2__createCurry_js__["a" /* default */])(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = Object(__WEBPACK_IMPORTED_MODULE_4__createPartial_js__["a" /* default */])(func, bitmask, thisArg, partials);
  } else {
    result = __WEBPACK_IMPORTED_MODULE_3__createHybrid_js__["a" /* default */].apply(undefined, newData);
  }
  var setter = data ? __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_7__setData_js__["a" /* default */];
  return Object(__WEBPACK_IMPORTED_MODULE_8__setWrapToString_js__["a" /* default */])(setter(result, newData), func, bitmask);
}

/* harmony default export */ __webpack_exports__["a"] = (createWrap);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLodash_js__ = __webpack_require__(318);



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__baseLodash_js__["a" /* default */].prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LazyWrapper);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(941);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(247);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(314)(module)))

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(473);




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, undefined, __WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (flatRest);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(34);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignValue_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseAssign_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__copySymbols_js__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isMap_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isSet_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__keys_js__ = __webpack_require__(41);






















/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_18__isObject_js__["a" /* default */])(value)) {
    return value;
  }
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_15__isArray_js__["a" /* default */])(value);
  if (isArr) {
    result = Object(__WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__["a" /* default */])(value);
    if (!isDeep) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__copyArray_js__["a" /* default */])(value, result);
    }
  } else {
    var tag = Object(__WEBPACK_IMPORTED_MODULE_11__getTag_js__["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (Object(__WEBPACK_IMPORTED_MODULE_16__isBuffer_js__["a" /* default */])(value)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : Object(__WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? Object(__WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__["a" /* default */])(result, value))
          : Object(__WEBPACK_IMPORTED_MODULE_7__copySymbols_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_3__baseAssign_js__["a" /* default */])(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = Object(__WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__["a" /* default */])(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (Object(__WEBPACK_IMPORTED_MODULE_19__isSet_js__["a" /* default */])(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (Object(__WEBPACK_IMPORTED_MODULE_17__isMap_js__["a" /* default */])(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__["a" /* default */])
    : (isFlat ? keysIn : __WEBPACK_IMPORTED_MODULE_20__keys_js__["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  Object(__WEBPACK_IMPORTED_MODULE_1__arrayEach_js__["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    Object(__WEBPACK_IMPORTED_MODULE_2__assignValue_js__["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(930);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(159)('meta');
var isObject = __webpack_require__(24);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(37).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(21)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(30)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(65)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery v3.0.0 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.0.0",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:f.call(this)},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=r.isArray(d)))?(e?(e=!1,f=c&&r.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return a&&"[object Object]"===k.call(a)?(b=e(a))?(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n):!0:!1},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;d>f;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;return"string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a)?(d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e):void 0},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"===c||r.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\x00-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,ca=function(a,b){return b?"\x00"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+sa(o[h]);r=o.join(","),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return function(b){return"label"in b&&b.disabled===a||"form"in b&&b.disabled===a||"form"in b&&b.disabled===!1&&(b.isDisabled===a||b.isDisabled!==!a&&("label"in b||!ea(b))!==a)}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+"").replace(ba,ca)},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[0>c?c+b:c]}),even:pa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e)}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,e>i&&ya(a.slice(i,e)),f>e&&ya(a=a.slice(e)),f>e&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(_,aa),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=V.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(_,aa),$.test(j[0].type)&&qa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&sa(j),!a)return G.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||$.test(a)&&qa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(J,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext,B=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,C=/^.[^:#\[\.,]*$/;function D(a,b,c){if(r.isFunction(b))return r.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return r.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(C.test(b))return r.filter(b,a,c);b=r.filter(b,a)}return r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType})}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;d>b;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;d>b;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(D(this,a||[],!1))},not:function(a){return this.pushStack(D(this,a||[],!0))},is:function(a){return!!D(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var E,F=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,G=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||E,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:F.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),B.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};G.prototype=r.fn,E=r(d);var H=/^(?:parents|prev(?:Until|All))/,I={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function J(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return J(a,"nextSibling")},prev:function(a){return J(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return a.contentDocument||r.merge([],a.childNodes)}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(I[a]||r.uniqueSort(e),H.test(a)&&e.reverse()),this.pushStack(e)}});var K=/\S+/g;function L(a){var b={};return r.each(a.match(K)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?L(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function M(a){return a}function N(a){throw a}function O(a,b,c){var d;try{a&&r.isFunction(d=a.promise)?d.call(a).done(b).fail(c):a&&r.isFunction(d=a.then)?d.call(a,b,c):b.call(void 0,a)}catch(a){c.call(void 0,a)}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},"catch":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(f>b)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,M,e),g(f,c,N,e)):(f++,j.call(a,g(f,c,M,e),g(f,c,N,e),g(f,c,M,c.notifyWith))):(d!==M&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==N&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:M,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:M)),c[2][3].add(g(0,a,r.isFunction(d)?d:N))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(1>=b&&(O(a,g.done(h(c)).resolve,g.reject),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)O(e[c],h(c),g.reject);return g.promise()}});var P=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&P.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)};var Q=r.Deferred();r.fn.ready=function(a){return Q.then(a),this},r.extend({isReady:!1,readyWait:1,holdReady:function(a){a?r.readyWait++:r.ready(!0)},ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||Q.resolveWith(d,[r]))}}),r.ready.then=Q.then;function R(){d.removeEventListener("DOMContentLoaded",R),a.removeEventListener("load",R),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",R),a.addEventListener("load",R));var S=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)S(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){
return j.call(r(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},T=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function U(){this.expando=r.expando+U.uid++}U.uid=1,U.prototype={cache:function(a){var b=a[this.expando];return b||(b={},T(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){r.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(K)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var V=new U,W=new U,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Y=/[A-Z]/g;function Z(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Y,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:X.test(c)?JSON.parse(c):c}catch(e){}W.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return W.hasData(a)||V.hasData(a)},data:function(a,b,c){return W.access(a,b,c)},removeData:function(a,b){W.remove(a,b)},_data:function(a,b,c){return V.access(a,b,c)},_removeData:function(a,b){V.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=W.get(f),1===f.nodeType&&!V.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),Z(f,d,e[d])));V.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){W.set(this,a)}):S(this,function(b){var c;if(f&&void 0===b){if(c=W.get(f,a),void 0!==c)return c;if(c=Z(f,a),void 0!==c)return c}else this.each(function(){W.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){W.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=V.get(a,b),c&&(!d||r.isArray(c)?d=V.access(a,b,r.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return V.get(a,c)||V.access(a,c,{empty:r.Callbacks("once memory").add(function(){V.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=V.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var $=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,_=new RegExp("^(?:([+-])=|)("+$+")([a-z%]*)$","i"),aa=["Top","Right","Bottom","Left"],ba=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},ca=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function da(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&_.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ea={};function fa(a){var b,c=a.ownerDocument,d=a.nodeName,e=ea[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),ea[d]=e,e)}function ga(a,b){for(var c,d,e=[],f=0,g=a.length;g>f;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=V.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&ba(d)&&(e[f]=fa(d))):"none"!==c&&(e[f]="none",V.set(d,"display",c)));for(f=0;g>f;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ga(this,!0)},hide:function(){return ga(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){ba(this)?r(this).show():r(this).hide()})}});var ha=/^(?:checkbox|radio)$/i,ia=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,ja=/^$|\/(?:java|ecma)script/i,ka={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ka.optgroup=ka.option,ka.tbody=ka.tfoot=ka.colgroup=ka.caption=ka.thead,ka.th=ka.td;function la(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&r.nodeName(a,b)?r.merge([a],c):c}function ma(a,b){for(var c=0,d=a.length;d>c;c++)V.set(a[c],"globalEval",!b||V.get(b[c],"globalEval"))}var na=/<|&#?\w+;/;function oa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;o>n;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(na.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ia.exec(f)||["",""])[1].toLowerCase(),i=ka[h]||ka._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=la(l.appendChild(f),"script"),j&&ma(g),c){k=0;while(f=g[k++])ja.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var pa=d.documentElement,qa=/^key/,ra=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,sa=/^([^.]*)(?:\.(.+)|)/;function ta(){return!0}function ua(){return!1}function va(){try{return d.activeElement}catch(a){}}function wa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)wa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ua;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(pa,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(K)||[""],j=b.length;while(j--)h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.hasData(a)&&V.get(a);if(q&&(i=q.events)){b=(b||"").match(K)||[""],j=b.length;while(j--)if(h=sa.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&V.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(V.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?r(e,this).index(i)>-1:r.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){return this.originalEvent?b(this.originalEvent):void 0}:function(){return this.originalEvent?this.originalEvent[a]:void 0},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==va()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===va()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&r.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return r.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ta:ua,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:ua,isPropagationStopped:ua,isImmediatePropagationStopped:ua,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ta,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ta,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ta,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&qa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ra.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return wa(this,a,b,c,d)},one:function(a,b,c,d){return wa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ua),this.each(function(){r.event.remove(this,a,c,b)})}});var xa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ya=/<script|<style|<link/i,za=/checked\s*(?:[^=]|=\s*.checked.)/i,Aa=/^true\/(.*)/,Ba=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ca(a,b){return r.nodeName(a,"table")&&r.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function Da(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Ea(a){var b=Aa.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Fa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(V.hasData(a)&&(f=V.access(a),g=V.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)r.event.add(b,e,j[e][c])}W.hasData(a)&&(h=W.access(a),i=r.extend({},h),W.set(b,i))}}function Ga(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ha.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ha(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&za.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ha(f,b,c,d)});if(m&&(e=oa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(la(e,"script"),Da),i=h.length;m>l;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,la(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ea),l=0;i>l;l++)j=h[l],ja.test(j.type||"")&&!V.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Ba,""),k))}return a}function Ia(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(la(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&ma(la(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(xa,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=la(h),f=la(a),d=0,e=f.length;e>d;d++)Ga(f[d],g[d]);if(b)if(c)for(f=f||la(a),g=g||la(h),d=0,e=f.length;e>d;d++)Fa(f[d],g[d]);else Fa(a,h);return g=la(h,"script"),g.length>0&&ma(g,!i&&la(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(T(c)){if(b=c[V.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[V.expando]=void 0}c[W.expando]&&(c[W.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ia(this,a,!0)},remove:function(a){return Ia(this,a)},text:function(a){return S(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.appendChild(a)}})},prepend:function(){return Ha(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ca(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ha(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(la(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return S(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!ya.test(a)&&!ka[(ia.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(la(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ha(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(la(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;f>=g;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var Ja=/^margin/,Ka=new RegExp("^("+$+")(?!px)[a-z%]+$","i"),La=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",pa.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,pa.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Ma(a,b,c){var d,e,f,g,h=a.style;return c=c||La(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ka.test(g)&&Ja.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Na(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Oa=/^(none|table(?!-c[ea]).+)/,Pa={position:"absolute",visibility:"hidden",display:"block"},Qa={letterSpacing:"0",fontWeight:"400"},Ra=["Webkit","Moz","ms"],Sa=d.createElement("div").style;function Ta(a){if(a in Sa)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ra.length;while(c--)if(a=Ra[c]+b,a in Sa)return a}function Ua(a,b,c){var d=_.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Va(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=r.css(a,c+aa[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+aa[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+aa[f]+"Width",!0,e))):(g+=r.css(a,"padding"+aa[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+aa[f]+"Width",!0,e)));return g}function Wa(a,b,c){var d,e=!0,f=La(a),g="border-box"===r.css(a,"boxSizing",!1,f);if(a.getClientRects().length&&(d=a.getBoundingClientRect()[b]),0>=d||null==d){if(d=Ma(a,b,f),(0>d||null==d)&&(d=a.style[b]),Ka.test(d))return d;e=g&&(o.boxSizingReliable()||d===a.style[b]),d=parseFloat(d)||0}return d+Va(a,b,c||(g?"border":"content"),e,f)+"px"}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ma(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=a.style;return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=_.exec(c))&&e[1]&&(c=da(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b);return b=r.cssProps[h]||(r.cssProps[h]=Ta(h)||h),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Ma(a,b,d)),"normal"===e&&b in Qa&&(e=Qa[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){return c?!Oa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?Wa(a,b,d):ca(a,Pa,function(){return Wa(a,b,d)}):void 0},set:function(a,c,d){var e,f=d&&La(a),g=d&&Va(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=_.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Ua(a,c,g)}}}),r.cssHooks.marginLeft=Na(o.reliableMarginLeft,function(a,b){return b?(parseFloat(Ma(a,"marginLeft"))||a.getBoundingClientRect().left-ca(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+aa[d]+b]=f[d]||f[d-2]||f[0];return e}},Ja.test(a)||(r.cssHooks[a+b].set=Ua)}),r.fn.extend({css:function(a,b){return S(this,function(a,b,c){var d,e,f={},g=0;if(r.isArray(b)){for(d=La(a),e=b.length;e>g;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function Xa(a,b,c,d,e){return new Xa.prototype.init(a,b,c,d,e)}r.Tween=Xa,Xa.prototype={constructor:Xa,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=Xa.propHooks[this.prop];return a&&a.get?a.get(this):Xa.propHooks._default.get(this)},run:function(a){var b,c=Xa.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Xa.propHooks._default.set(this),this}},Xa.prototype.init.prototype=Xa.prototype,Xa.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},Xa.propHooks.scrollTop=Xa.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=Xa.prototype.init,r.fx.step={};var Ya,Za,$a=/^(?:toggle|show|hide)$/,_a=/queueHooks$/;function ab(){Za&&(a.requestAnimationFrame(ab),r.fx.tick())}function bb(){return a.setTimeout(function(){Ya=void 0}),Ya=r.now()}function cb(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=aa[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function db(a,b,c){for(var d,e=(gb.tweeners[b]||[]).concat(gb.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function eb(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&ba(a),q=V.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],$a.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=V.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ga([a],!0),j=a.style.display||j,k=r.css(a,"display"),ga([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=V.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ga([a],!0),m.done(function(){p||ga([a]),V.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=db(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function fb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],r.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function gb(a,b,c){var d,e,f=0,g=gb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Ya||bb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:Ya||bb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(fb(k,j.opts.specialEasing);g>f;f++)if(d=gb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,db,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}r.Animation=r.extend(gb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return da(c.elem,a,_.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(K);for(var c,d=0,e=a.length;e>d;d++)c=a[d],gb.tweeners[c]=gb.tweeners[c]||[],gb.tweeners[c].unshift(b)},prefilters:[eb],prefilter:function(a,b){b?gb.prefilters.unshift(a):gb.prefilters.push(a)}}),r.speed=function(a,b,c){var e=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off||d.hidden?e.duration=0:e.duration="number"==typeof e.duration?e.duration:e.duration in r.fx.speeds?r.fx.speeds[e.duration]:r.fx.speeds._default,null!=e.queue&&e.queue!==!0||(e.queue="fx"),e.old=e.complete,e.complete=function(){r.isFunction(e.old)&&e.old.call(this),e.queue&&r.dequeue(this,e.queue)},e},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(ba).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=gb(this,r.extend({},a),f);(e||V.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=V.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&_a.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=V.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(cb(b,!0),a,d,e)}}),r.each({slideDown:cb("show"),slideUp:cb("hide"),slideToggle:cb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(Ya=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),Ya=void 0},r.fx.timer=function(a){r.timers.push(a),a()?r.fx.start():r.timers.pop()},r.fx.interval=13,r.fx.start=function(){Za||(Za=a.requestAnimationFrame?a.requestAnimationFrame(ab):a.setInterval(r.fx.tick,r.fx.interval))},r.fx.stop=function(){a.cancelAnimationFrame?a.cancelAnimationFrame(Za):a.clearInterval(Za),Za=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var hb,ib=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return S(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?hb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&r.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(K);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c);
}}),hb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=ib[b]||r.find.attr;ib[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=ib[g],ib[g]=e,e=null!=c(a,b,d)?g:null,ib[g]=f),e}});var jb=/^(?:input|select|textarea|button)$/i,kb=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return S(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):jb.test(a.nodeName)||kb.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});var lb=/[\t\r\n\f]/g;function mb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,mb(this)))});if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,mb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=mb(c),d=1===c.nodeType&&(" "+e+" ").replace(lb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=r.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,mb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(K)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=mb(this),b&&V.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":V.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+mb(c)+" ").replace(lb," ").indexOf(b)>-1)return!0;return!1}});var nb=/\r/g,ob=/[\x20\t\r\n\f]+/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":r.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(nb,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:r.trim(r.text(a)).replace(ob," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&!c.disabled&&(!c.parentNode.disabled||!r.nodeName(c.parentNode,"optgroup"))){if(b=r(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){return r.isArray(b)?a.checked=r.inArray(r(a).val(),b)>-1:void 0}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var pb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!pb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,pb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(V.get(h,"events")||{})[b.type]&&V.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&T(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!T(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?r.event.trigger(a,b,c,!0):void 0}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=V.access(d,b);e||d.addEventListener(a,c,!0),V.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=V.access(d,b)-1;e?V.access(d,b,e):(d.removeEventListener(a,c,!0),V.remove(d,b))}}});var qb=a.location,rb=r.now(),sb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var tb=/\[\]$/,ub=/\r?\n/g,vb=/^(?:submit|button|image|reset|file)$/i,wb=/^(?:input|select|textarea|keygen)/i;function xb(a,b,c,d){var e;if(r.isArray(b))r.each(b,function(b,e){c||tb.test(a)?d(a,e):xb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)xb(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(r.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)xb(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&wb.test(this.nodeName)&&!vb.test(a)&&(this.checked||!ha.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:r.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(ub,"\r\n")}}):{name:b.name,value:c.replace(ub,"\r\n")}}).get()}});var yb=/%20/g,zb=/#.*$/,Ab=/([?&])_=[^&]*/,Bb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Cb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Db=/^(?:GET|HEAD)$/,Eb=/^\/\//,Fb={},Gb={},Hb="*/".concat("*"),Ib=d.createElement("a");Ib.href=qb.href;function Jb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(K)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Kb(a,b,c,d){var e={},f=a===Gb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Lb(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Mb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Nb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:qb.href,type:"GET",isLocal:Cb.test(qb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Hb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Lb(Lb(a,r.ajaxSettings),b):Lb(r.ajaxSettings,a)},ajaxPrefilter:Jb(Fb),ajaxTransport:Jb(Gb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Bb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||qb.href)+"").replace(Eb,qb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(K)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Ib.protocol+"//"+Ib.host!=j.protocol+"//"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Kb(Fb,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Db.test(o.type),f=o.url.replace(zb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(yb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(sb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Ab,""),n=(sb.test(f)?"&":"?")+"_="+rb++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Hb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Kb(Gb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,"No Transport");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(v=Mb(o,y,d)),v=Nb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",0>b&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Ob={0:200,1223:204},Pb=r.ajaxSettings.xhr();o.cors=!!Pb&&"withCredentials"in Pb,o.ajax=Pb=!!Pb,r.ajaxTransport(function(b){var c,d;return o.cors||Pb&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Ob[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Qb=[],Rb=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Qb.pop()||r.expando+"_"+rb++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Rb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Rb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Rb,"$1"+e):b.jsonp!==!1&&(b.url+=(sb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Qb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=B.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=oa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=r.trim(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length};function Sb(a){return r.isWindow(a)?a:9===a.nodeType&&a.defaultView}r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),d.width||d.height?(e=f.ownerDocument,c=Sb(e),b=e.documentElement,{top:d.top+c.pageYOffset-b.clientTop,left:d.left+c.pageXOffset-b.clientLeft}):d):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),r.nodeName(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||pa})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return S(this,function(a,d,e){var f=Sb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Na(o.pixelPosition,function(a,c){return c?(c=Ma(a,b),Ka.test(c)?r(a).position()[b]+"px":c):void 0})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return S(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.parseJSON=JSON.parse,"function"=="function"&&__webpack_require__(299)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return r}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Tb=a.jQuery,Ub=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Ub),b&&a.jQuery===r&&(a.jQuery=Tb),r},b||(a.jQuery=a.$=r),r});


/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _popover = __webpack_require__(140);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ajax = __webpack_require__(4);
var modals = __webpack_require__(6);

// Partials
var stagePreviewPartial = __webpack_require__(1703);
var collaboratorsPartial = __webpack_require__(1704);

var SubmitConfirm = __webpack_require__(310);

var taskRecordPreviewUrlName = 'submission-taskrecord-preview';
var adminTaskRecordPreviewUrlName = 'submission-admin-taskrecord-preview';

var TaskRecordPreview = function (_Backbone$View) {
	_inherits(TaskRecordPreview, _Backbone$View);

	_createClass(TaskRecordPreview, [{
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-taskrecord-reset': 'resetTaskRecord',
				'click .sma-js-taskrecord-delete': 'deleteTaskRecord',
				'click .sma-js-taskrecord-edit': 'editTaskRecord',
				'click .sma-js-task-hide': 'hideTask',
				'click .sma-js-task-show': 'showTask',
				'click .sma-js-taskrecord-email': 'initiateEmail'
			};
		}
	}]);

	function TaskRecordPreview(config) {
		_classCallCheck(this, TaskRecordPreview);

		var _this = _possibleConstructorReturn(this, (TaskRecordPreview.__proto__ || Object.getPrototypeOf(TaskRecordPreview)).call(this));

		_this.isAdmin = config.isAdmin;
		_this.recordId = config.recordId;
		_this.appId = config.appId;

		var previewUrlString = _this.isAdmin ? adminTaskRecordPreviewUrlName : taskRecordPreviewUrlName;
		_this.previewUrl = reverse(previewUrlString, {
			submission_id: _this.appId,
			taskrecord_id: _this.recordId
		});

		var id = _this.recordId.toString();
		_this.setElement($('#sma-js-task-preview-' + id)[0]);
		return _this;
	}

	_createClass(TaskRecordPreview, [{
		key: 'renderPreview',
		value: function renderPreview() {
			var options = {
				url: this.previewUrl,
				callback: $.proxy(function (data) {
					var preview = data.html;
					if (preview) {
						var newHtml = $(preview);
						var innerHtml = newHtml.find('.sma-application-preview-task-container').html();
						$(this.el).html(innerHtml);
					}
				}, this)
			};
			ajax.get(options);
		}
	}, {
		key: 'postAndRefresh',
		value: function postAndRefresh(url, title, description) {
			var rerenderPreview = $.proxy(function () {
				this.renderPreview();
			}, this);

			new modals.Confirm(title, description, function () {
				var options = {
					url: url,
					callback: rerenderPreview
				};
				ajax.post(options);
			});
		}
	}, {
		key: 'hideTask',
		value: function hideTask(e) {
			e.preventDefault();

			this.postAndRefresh($(e.currentTarget).attr('href'), gettext('Hide task'), gettext('Are you sure that you want to hide this task from the applicant?'));
		}
	}, {
		key: 'showTask',
		value: function showTask(e) {
			e.preventDefault();

			this.postAndRefresh($(e.currentTarget).attr('href'), gettext('Show task'), gettext('Are you sure that you want to show this task to the applicant?'));
		}
	}, {
		key: 'resetTaskRecord',
		value: function resetTaskRecord(e) {
			e.preventDefault();

			var rerenderPreview = $.proxy(function () {
				this.renderPreview();
			}, this);

			new modals.CheckboxModal(gettext('Reset task'), gettext('Resetting the task will delete any task data previously collected for this application.'), gettext('Yes, I understand that resetting this task will permanently delete its data and that this action cannot be undone.'), function () {
				var options = {
					url: $(e.currentTarget).attr('href'),
					callback: rerenderPreview
				};
				ajax.post(options);
			}, {
				contingent: true,
				isDelete: true,
				okLabel: gettext('RESET')
			});
		}
	}, {
		key: 'deleteTaskRecord',
		value: function deleteTaskRecord(e) {
			e.preventDefault();

			this.postAndRefresh($(e.currentTarget).attr('href'), gettext('Delete task'), gettext('Are you sure that you want to delete this record?'));
		}
	}, {
		key: 'initiateEmail',
		value: function initiateEmail(e) {
			e.preventDefault();

			$(e.currentTarget).find('form').submit();
		}
	}, {
		key: 'editTaskRecord',
		value: function editTaskRecord(e) {
			e.preventDefault();

			// Cheating a bit here, but this avoids having to hit the server for info that's already here just innacessible
			var taskTitle = $(e.currentTarget).parents('.sma-application-preview-task-header:first').find('.sma-application-preview-task-text h2').text().trim();
			var applicant = $('.sma-admin-app-view-user-name').text();
			var recordId = $(e.currentTarget).data('record');

			$('body').trigger('taskrecord:edit', [recordId, taskTitle, applicant]);
		}
	}]);

	return TaskRecordPreview;
}(Backbone.View);

var StagePreview = function (_Backbone$View2) {
	_inherits(StagePreview, _Backbone$View2);

	function StagePreview(config) {
		_classCallCheck(this, StagePreview);

		var _this2 = _possibleConstructorReturn(this, (StagePreview.__proto__ || Object.getPrototypeOf(StagePreview)).call(this));

		_this2.isAdmin = config.isAdmin;
		_this2.stageId = config.stageId;
		_this2.previewEl = config.previewEl;
		_this2.appId = config.appId;
		_this2.include_keys = config.include_keys || [];

		_this2.fromRound = config.fromRound || null;

		_this2.previewUrl = reverse(config.previewUrl, {
			submission_id: _this2.appId,
			stage_id: _this2.stageId
		});

		var partial = stagePreviewPartial({ id: _this2.stageId });
		$(_this2.previewEl).append(partial);

		_this2.setElement($('#sma-js-stage-preview-' + _this2.stageId.toString())[0]);

		_this2.renderPreview();
		return _this2;
	}

	_createClass(StagePreview, [{
		key: 'renderPreview',
		value: function renderPreview() {
			var options = {
				url: this.previewUrl,
				data: {
					fromRound: this.fromRound,
					include_keys: this.include_keys
				},
				callback: $.proxy(function (data) {
					var preview = data.html;
					var taskRecordIds = data.task_record_ids;
					var applicationId = data.application_id;

					if (preview) {
						$(this.el).html(preview);
					}
					if (taskRecordIds) {
						this.generateTasks(taskRecordIds, applicationId);
					}
				}, this)
			};
			ajax.get(options);
		}
	}, {
		key: 'generateTasks',
		value: function generateTasks(taskRecordIds, applicationId) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = taskRecordIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var taskRecordId = _step.value;

					var config = {
						recordId: taskRecordId,
						appId: applicationId,
						isAdmin: this.isAdmin
					};
					new TaskRecordPreview(config);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}]);

	return StagePreview;
}(Backbone.View);

var ApplicationDetails = function (_Backbone$View3) {
	_inherits(ApplicationDetails, _Backbone$View3);

	_createClass(ApplicationDetails, [{
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-remove-collaborator': 'removeCollaborator',
				'click .sma-js-make-owner': 'makeOwner',
				'click .sma-js-change-collaborator-access': 'changeCollaboratorAccess',
				'click .sma-js-download-application': 'downloadApplication',
				'click .sma-js-remove-team': 'removeTeam'
			};
		}
	}]);

	function ApplicationDetails(config) {
		_classCallCheck(this, ApplicationDetails);

		var _this3 = _possibleConstructorReturn(this, (ApplicationDetails.__proto__ || Object.getPrototypeOf(ApplicationDetails)).call(this));

		_this3.isAdmin = config.isAdmin;
		_this3.isApplicant = config.isApplicant;
		_this3.el = config.el;
		_this3.appId = config.appId;
		_this3.awardId = config.awardId;
		_this3.collaboratorsEl = [];
		_this3.collaborators = config.collaborators || [];

		_this3.url = reverse(config.url, {
			submission_id: _this3.appId
		});

		if (_this3.isApplicant) {
			_this3.url += '?is_applicant=True';
		} else if (_this3.isAdmin) {
			_this3.url += '?is_admin=True';
		}
		_this3.setElement(_this3.el);

		_this3.render();
		return _this3;
	}

	_createClass(ApplicationDetails, [{
		key: 'render',
		value: function render() {
			var _this4 = this;

			var options = {
				url: this.url,
				callback: function callback(response) {
					$(_this4.el).html(response.html);
					_this4.collaboratorsEl = $('.sma-collaborators-popover-wrapper');
					if (_this4.collaboratorsEl.length > 0) {
						_this4.renderCollaboratorsPopover();
					}
				}
			};

			ajax.get(options);
		}
	}, {
		key: 'removeCollaborator',
		value: function removeCollaborator(e) {
			var _this5 = this;

			e.preventDefault();
			var target = $(e.currentTarget);

			var memberId = target.data('member-id');
			var url = void 0;

			if (!this.isAdmin) {
				url = reverse('remove-collaborator', {
					app_id: this.appId,
					member_id: memberId
				});
			} else {
				url = reverse('admin-awards-remove-collaborator', {
					app_id: this.appId,
					member_id: memberId,
					pk: this.awardId
				});
			}

			var options = {
				url: url,
				callback: function callback(response) {
					if (response.return_url) {
						window.location.href = response.return_url;
						return;
					}
					_this5.render();
				}
			};
			new modals.Confirm(gettext('Remove collaborator'), gettext('Are you sure that you want to remove this collaborator?'), function () {
				ajax.post(options);
			});
		}
	}, {
		key: 'removeTeam',
		value: function removeTeam(e) {
			var _this6 = this;

			e.preventDefault();

			var url = reverse('admin-awards-remove-team', {
				pk: this.awardId,
				app_id: this.appId,
				team_id: $(e.currentTarget).data('team-id')
			});

			new modals.Confirm(gettext('Remove team'), gettext('Are you sure that you want to remove this team?'), function () {
				ajax.post({
					url: url,
					callback: function callback(response) {
						if (response.return_url) {
							window.location.href = response.return_url;
							return;
						}
						_this6.render();
					}
				});
			});
		}
	}, {
		key: 'makeOwner',
		value: function makeOwner(e) {
			var _this7 = this;

			e.preventDefault();
			var target = $(e.currentTarget);

			var memberId = target.data('member-id');

			var url = reverse('admin-awards-make-owner', {
				app_id: this.appId,
				member_id: memberId,
				pk: this.awardId
			});

			var options = {
				url: url,
				callback: function callback(_response) {
					_this7.render();
				}
			};

			new modals.Confirm(gettext('Make owner'), gettext('Are you sure that you want to make this collaborator the application owner? The current owner will then become a collaborator.'), function () {
				ajax.post(options);
			});
		}
	}, {
		key: 'changeCollaboratorAccess',
		value: function changeCollaboratorAccess(e) {
			var _this8 = this;

			e.preventDefault();
			var target = $(e.currentTarget);

			var memberId = target.data('member-id');

			var url = reverse('admin-awards-change-collaborator-access', {
				app_id: this.appId,
				member_id: memberId,
				pk: this.awardId
			});

			var options = {
				url: url,
				callback: function callback(_response) {
					_this8.render();
				}
			};

			ajax.post(options);
		}
	}, {
		key: 'downloadApplication',
		value: function downloadApplication(e) {
			e.preventDefault();

			var config = {
				download_format: 'as_single_file',
				submission_ids: this.appId,
				include_application_profiles: true
			};

			ajax.post({
				url: reverse('download-redirect'),
				alertOnSuccess: false,
				data: config,
				callback: function callback(response) {
					if (response.url) {
						window.open(response.url, '_blank');
					}
				}
			});
		}
	}, {
		key: 'renderCollaboratorsPopover',
		value: function renderCollaboratorsPopover() {
			var content = collaboratorsPartial({
				collaborators: this.collaborators,
				strings: {
					profile_picture: gettext('Profile picture')
				}
			});
			var el = this.collaboratorsEl;

			var popover = new _popover.Popover({
				attachTo: el,
				content: content
			});

			el.on('click', function (e) {
				if ($(e.target).hasClass('sma-popover') || $(e.target).parents('.sma-popover').length) {
					return false;
				}
				$('.sma-js-popover.sma-popover').fadeOut();
				popover.toggle();
			});

			$('body').on('click', function (e) {
				if ($(e.target).hasClass('sma-collaborators-popover-wrapper') || $(e.target).parents('.sma-collaborators-popover-wrapper').length) {
					return false;
				}
				$('.sma-js-popover.sma-popover').fadeOut();
			});
		}
	}]);

	return ApplicationDetails;
}(Backbone.View);

var SubmitButtonArea = function (_Backbone$View4) {
	_inherits(SubmitButtonArea, _Backbone$View4);

	_createClass(SubmitButtonArea, [{
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-application-submit-button': 'showApplicationSubmitModal'
			};
		}
	}]);

	function SubmitButtonArea(config) {
		_classCallCheck(this, SubmitButtonArea);

		var _this9 = _possibleConstructorReturn(this, (SubmitButtonArea.__proto__ || Object.getPrototypeOf(SubmitButtonArea)).call(this));

		_this9.el = config.el;
		_this9.appId = config.appId;
		_this9.setElement(_this9.el);

		_this9.render();
		return _this9;
	}

	_createClass(SubmitButtonArea, [{
		key: 'showApplicationSubmitModal',
		value: function showApplicationSubmitModal(e) {
			e.preventDefault();

			new SubmitConfirm({
				appId: this.appId,
				hideReviewButton: true,
				description: gettext('Please confirm submission of your application.')
			});
		}
	}]);

	return SubmitButtonArea;
}(Backbone.View);

var ApplicationPreviewBase = function (_Backbone$View5) {
	_inherits(ApplicationPreviewBase, _Backbone$View5);

	function ApplicationPreviewBase(config) {
		_classCallCheck(this, ApplicationPreviewBase);

		var _this10 = _possibleConstructorReturn(this, (ApplicationPreviewBase.__proto__ || Object.getPrototypeOf(ApplicationPreviewBase)).call(this));

		_this10.isAdmin = config.isAdmin || false;
		_this10.previewEl = config.previewEl;
		_this10.appId = config.application;
		_this10.stageIds = config.stageIds;
		_this10.previewUrl = config.previewUrl;
		_this10.detailsEl = config.detailsEl;
		_this10.isApplicant = config.isApplicant || false;
		_this10.detailsUrl = config.detailsUrl;
		_this10.fromRound = config.fromRound || null;
		_this10.include_keys = config.include_keys || [];
		_this10.submitButton = config.submitButton;
		_this10.collaborators = config.collaborators || [];

		_this10.setElement(_this10.previewEl);

		_this10.jumpToDropdown = $(_this10.el).find('.sma-js-jump-to-task');

		if (_this10.detailsEl) {
			_this10.renderDetails();
		}

		if (_this10.submitButton) {
			_this10.renderSubmitButton();
		}

		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = _this10.stageIds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var stageId = _step2.value;

				_this10.createStage(stageId);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		return _this10;
	}

	_createClass(ApplicationPreviewBase, [{
		key: 'renderDetails',
		value: function renderDetails() {
			new ApplicationDetails({
				el: this.detailsEl,
				isAdmin: this.isAdmin,
				isApplicant: this.isApplicant,
				url: this.detailsUrl,
				appId: this.appId,
				collaborators: this.collaborators
			});
		}
	}, {
		key: 'renderSubmitButton',
		value: function renderSubmitButton() {
			new SubmitButtonArea({
				el: this.submitButton,
				appId: this.appId
			});
		}
	}, {
		key: 'createStage',
		value: function createStage(stageId) {
			new StagePreview({
				previewEl: this.previewEl,
				appId: this.appId,
				stageId: stageId,
				previewUrl: this.previewUrl,
				isAdmin: this.isAdmin,
				fromRound: this.fromRound,
				include_keys: this.include_keys
			});
		}
	}]);

	return ApplicationPreviewBase;
}(Backbone.View);

var ApplicationPreviewModal = function (_modals$Modal) {
	_inherits(ApplicationPreviewModal, _modals$Modal);

	function ApplicationPreviewModal(config) {
		_classCallCheck(this, ApplicationPreviewModal);

		var _this11 = _possibleConstructorReturn(this, (ApplicationPreviewModal.__proto__ || Object.getPrototypeOf(ApplicationPreviewModal)).call(this));

		_this11.handleOptions(config);
		_this11.render();
		config.previewEl = _this11.modalBody;
		_this11.modalBody.addClass('sma-js-application-preview-container');

		_this11.applicationPreview = new ApplicationPreviewBase(config);
		return _this11;
	}

	return ApplicationPreviewModal;
}(modals.Modal);

module.exports = {
	ApplicationPreviewBase: ApplicationPreviewBase,
	TaskRecordPreview: TaskRecordPreview,
	ApplicationPreviewModal: ApplicationPreviewModal,
	ApplicationDetails: ApplicationDetails
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var basePopoverTempl = __webpack_require__(1702);

var Popover = function () {
	function Popover(options) {
		_classCallCheck(this, Popover);

		this.attachTo = options.attachTo;

		this.placement = options.placement || 'bottom';

		this.content = options.content || '';

		this.build();
	}

	_createClass(Popover, [{
		key: 'build',
		value: function build() {
			var _this = this;

			this.element = $(basePopoverTempl({
				placement: this.placement,
				content: this.content
			})).hide();

			this.element.find('.sma-js-popover-x').on('click', function () {
				return _this.hide();
			});

			this.attachTo.append(this.element);
		}
	}, {
		key: 'changeContent',
		value: function changeContent(content) {
			this.content = content;
			this.$content.html(content);
		}
	}, {
		key: 'show',
		value: function show() {
			this.element.css('top', this.attachTo.position().top + 10 + this.attachTo.outerHeight() + 'px');
			this.element.css('left', this.attachTo.position().left + this.attachTo.outerWidth() / 2.0 - this.element.outerWidth() / 2.0);
			this.element.fadeIn();
		}
	}, {
		key: 'hide',
		value: function hide() {
			this.element.fadeOut();
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			if (this.visible) {
				this.hide();
			} else {
				this.show();
			}
		}
	}, {
		key: '$content',
		get: function get() {
			return this.element.find('sma-js-popover-content');
		}
	}, {
		key: 'visible',
		get: function get() {
			return this.element.is(':visible');
		}
	}]);

	return Popover;
}();

module.exports = {
	Popover: Popover
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (castSlice);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__ = __webpack_require__(1860);




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__["a" /* default */])(string)
    : Object(__WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringToArray);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__ = __webpack_require__(965);



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = Object(__WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (baseEach);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class = function () {
	var subclass = function subclass() {};

	var argumentNames = function argumentNames(func) {
		var names = func.toString().match(/^[\s\(]*function[^(]*\(([^)]*)\)/)[1].replace(/\/\/.*?[\r\n]|\/\*(?:.|[\r\n])*?\*\//g, '').replace(/\s+/g, '').split(',');
		return names.length == 1 && !names[0] ? [] : names;
	};

	var create = function create() {
		var parent = null,
		    properties = $.makeArray(arguments);

		if ($.isFunction(properties[0])) parent = properties.shift();

		var klass = function klass() {
			this.initialize.apply(this, arguments);
		};

		$.extend(klass, Class.Methods);
		klass.superclass = parent;
		klass.subclasses = [];

		if (parent) {
			subclass.prototype = parent.prototype;
			klass.prototype = new subclass();
			parent.subclasses.push(klass);
		}

		for (var i = 0; i < properties.length; i++) {
			klass.addMethods(properties[i]);
		}if (!klass.prototype.initialize) klass.prototype.initialize = $.noop;

		klass.prototype.constructor = klass;
		return klass;
	};

	var keyfunc = function keyfunc(obj) {
		var keys = [];for (var key in obj) {
			keys.push(key);
		}return keys;
	};

	var addMethods = function addMethods(source) {
		if (typeof source == 'undefined') {
			return;
		}

		var ancestor = this.superclass && this.superclass.prototype;
		var properties = keyfunc(source);

		if (!keyfunc({ toString: true }).length) {
			if (source.toString != Object.prototype.toString) properties.push("toString");
			if (source.valueOf != Object.prototype.valueOf) properties.push("valueOf");
		}

		for (var i = 0, length = properties.length; i < length; i++) {
			var property = properties[i],
			    value = source[property];
			if (ancestor && $.isFunction(value) && argumentNames(value)[0] == "$super") {
				var method = value;
				value = function (p, m) {
					return function () {
						var that = this;
						return m.apply(this, $.merge([function () {
							return ancestor[p].apply(that, arguments);
						}], arguments));
					};
				}(property, method);

				value.valueOf = method.valueOf.bind(method);
				value.toString = method.toString.bind(method);
			}
			this.prototype[property] = value;
		}

		return this;
	};

	return {
		create: create,
		Methods: {
			addMethods: addMethods
		}
	};
}();

module.exports = Class;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(859);
var enumBugKeys = __webpack_require__(413);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(91);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(860);
var enumBugKeys = __webpack_require__(413);
var IE_PROTO = __webpack_require__(412)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(410)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(414).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(859);
var hiddenKeys = __webpack_require__(413).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var dP = __webpack_require__(37);
var DESCRIPTORS = __webpack_require__(33);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(89);
var call = __webpack_require__(872);
var isArrayIter = __webpack_require__(425);
var anObject = __webpack_require__(13);
var toLength = __webpack_require__(31);
var getIterFn = __webpack_require__(427);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(66);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(104);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1823);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseLodash_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObjectLike_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wrapperClone_js__ = __webpack_require__(937);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) && !(value instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */])) {
    if (value instanceof __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */]) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__wrapperClone_js__["a" /* default */])(value);
    }
  }
  return new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = __WEBPACK_IMPORTED_MODULE_2__baseLodash_js__["a" /* default */].prototype;
lodash.prototype.constructor = lodash;

/* harmony default export */ __webpack_exports__["a"] = (lodash);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLodash_js__ = __webpack_require__(318);



/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__baseLodash_js__["a" /* default */].prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LodashWrapper);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (replaceHolders);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cacheHas_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createSet_js__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(343);







/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */];
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : Object(__WEBPACK_IMPORTED_MODULE_4__createSet_js__["a" /* default */])(array);
    if (set) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */])(set);
    }
    isCommon = false;
    includes = __WEBPACK_IMPORTED_MODULE_3__cacheHas_js__["a" /* default */];
    seen = new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */];
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseUniq);


/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(37).f;
var has = __webpack_require__(75);
var TAG = __webpack_require__(30)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(90);
var TAG = __webpack_require__(30)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(99);
var fails = __webpack_require__(21);
var spaces = __webpack_require__(416);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Util = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var transition = false;

  var MAX_UID = 1000000;

  var TransitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd otransitionend',
    transition: 'transitionend'

    // shoutout AngusCroll (https://goo.gl/pxwQGp)
  };function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function isElement(obj) {
    return (obj[0] || obj).nodeType;
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: transition.end,
      delegateType: transition.end,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
        return undefined;
      }
    };
  }

  function transitionEndTest() {
    if (window.QUnit) {
      return false;
    }

    var el = document.createElement('bootstrap');

    for (var name in TransitionEndEvent) {
      if (el.style[name] !== undefined) {
        return {
          end: TransitionEndEvent[name]
        };
      }
    }

    return false;
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;

    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });

    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);

    return this;
  }

  function setTransitionEndSupport() {
    transition = transitionEndTest();

    $.fn.emulateTransitionEnd = transitionEndEmulator;

    if (Util.supportsTransitionEnd()) {
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
  }

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Util = {

    TRANSITION_END: 'bsTransitionEnd',

    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));
      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector) {
        selector = element.getAttribute('href') || '';
        selector = /^#[a-z]/i.test(selector) ? selector : null;
      }

      return selector;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(transition.end);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(transition);
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (configTypes.hasOwnProperty(property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
          }
        }
      }
    }
  };

  setTransitionEndSupport();

  return Util;
}(jQuery);

exports.default = Util;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errorTempl = __webpack_require__(1597);

var addErrors = function addErrors(elem, errors) {
	for (var id in errors) {
		var temp = errorTempl({
			message: errors[id]
		});
		var field = elem.find("#id_" + id);
		var parent = field.parent();
		if (!parent.find('.errorlist').length) {
			$(temp).insertAfter(field);
		}
	}
};

var removeErrors = function removeErrors(elem) {
	elem.find('.errorlist').remove();
};

module.exports = {
	addErrors: addErrors,
	removeErrors: removeErrors
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var croppie = __webpack_require__(1622);
var baseModalTempl = __webpack_require__(1623);

var FileUploader = function (_Backbone$View) {
	_inherits(FileUploader, _Backbone$View);

	function FileUploader() {
		_classCallCheck(this, FileUploader);

		return _possibleConstructorReturn(this, (FileUploader.__proto__ || Object.getPrototypeOf(FileUploader)).apply(this, arguments));
	}

	_createClass(FileUploader, [{
		key: 'initialize',
		value: function initialize(config) {
			this.setElement(config.inputElement);

			this.imageContainer = config.imageContainer;
			this.existingImageURL = config.existingImageURL || '';

			this.render();
		}
	}, {
		key: 'newImageUploaded',
		value: function newImageUploaded() {
			var _this2 = this;

			this.imageContainer.empty();

			var fileReader = new FileReader();

			// Get DOM element from jquery object to access .files
			var selectedImage = this.$el.get(0).files[0];

			fileReader.onload = function (e) {
				_this2.renderImage(e.target.result);
			};

			$.when(this.updateInputText(selectedImage.name)).done(function () {
				if (selectedImage && selectedImage.size < 10000000) {
					fileReader.readAsDataURL(selectedImage);
				}
			});
		}
	}, {
		key: 'updateInputText',
		value: function updateInputText(imageName) {
			this.imageContainer.prepend($('<div />').html(imageName));
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.existingImageURL) {
				this.renderImage(this.existingImageURL);
			}
		}
	}, {
		key: 'renderImage',
		value: function renderImage(imgURL) {
			var img = $('<img class="img-md">');
			if (imgURL.indexOf('text/csv') === -1) {
				img.attr('src', imgURL);
				img.appendTo(this.imageContainer);
			}
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				change: 'newImageUploaded'
			};
		}
	}]);

	return FileUploader;
}(Backbone.View);

var ImageCropper = function (_Backbone$View2) {
	_inherits(ImageCropper, _Backbone$View2);

	function ImageCropper() {
		_classCallCheck(this, ImageCropper);

		return _possibleConstructorReturn(this, (ImageCropper.__proto__ || Object.getPrototypeOf(ImageCropper)).apply(this, arguments));
	}

	_createClass(ImageCropper, [{
		key: 'initialize',
		value: function initialize(config) {
			this.setElement(config.wrapper);

			this.inputField = config.inputField;
			this.onCrop = config.onCropHandler;

			this.events = this.events || {};
			var eventKey = 'change ' + this.inputField;
			this.events[eventKey] = 'fileUploaded';
			this.delegateEvents();
		}
	}, {
		key: 'clearField',
		value: function clearField() {
			$(this.inputField).val('');
		}
	}, {
		key: 'fileUploaded',
		value: function fileUploaded(e) {
			var _this4 = this;

			var target = e.currentTarget;
			var content = baseModalTempl();
			var uploadModal = new _modals.ContentModal(content, {
				destroyOnClose: true,
				title: gettext('Create Profile Photo'),
				buttons: [{
					label: gettext('Cancel'),
					cls: 'btn btn-link',
					handler: function handler(modal) {
						modal.hide();
					}
				}, {
					label: gettext('Save'),
					cls: 'btn btn-primary',
					handler: function handler(modal) {
						$('#sma-js-picture-preview').croppie('result', {
							type: 'canvas',
							size: { width: 512, height: 512 }
						}).then(function (croppedImg) {
							_this4.onCrop(croppedImg);
						});
						modal.hide();
					}
				}],
				destroyCallback: function destroyCallback() {
					_this4.clearField();
				}
			});

			var imagePreview = $('#sma-js-picture-preview').croppie({
				enableExif: true,
				viewport: {
					width: 512,
					height: 512,
					type: 'square'
				},
				boundary: {
					width: 500,
					height: 500
				}
			});

			if (target.files && target.files[0]) {
				var reader = new FileReader();

				reader.onload = function (event) {
					imagePreview.croppie('bind', {
						url: event.target.result
					});
				};

				reader.readAsDataURL(target.files[0]);
			}

			uploadModal.show();
		}
	}]);

	return ImageCropper;
}(Backbone.View);

module.exports = {
	FileUploader: FileUploader,
	ImageCropper: ImageCropper
};

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = (_module$exports = {
	/* Grid label */
	application_label: gettext('application'),

	/* Error messages */
	nothing_selected_error_message: gettext('Must select at least one application'),

	/* Actions/buttons in topbar of grid */
	move_stage: gettext('Move Stage'),
	status: gettext('Status'),
	review_status: gettext('Review status'),
	changeStatus: gettext('Change status'),
	labels: gettext('Labels'),
	download: gettext('Download'),
	downloadOptions: gettext('Download Options'),
	singleApplicationsSelected: gettext('Single Applications selected'),
	multipleApplicationsSelected: gettext('Multiple Applications selected'),
	applicationsSelected: gettext('Applications selected:'),
	hide: gettext('Hide from applicant'),
	unhide: gettext('Show to applicant'),
	lock: gettext('Lock'),
	unlock: gettext('Unlock'),
	submit: gettext('Submit'),
	reopen: gettext('Reopen'),
	export: gettext('Export'),
	archive: gettext('Archive'),
	trash: gettext('Move to Trash'),
	revert: gettext('Revert'),
	restore: gettext('Restore'),
	delete_perm: gettext('Delete Permanently'),
	email: gettext('Email'),
	more: gettext('More'),
	create_application: gettext('Create Application'),
	workflow: gettext('Workflow'),
	downloadPDF: gettext('Download (PDF)'),
	exportCSV: gettext('Export (CSV)'),

	/* Award/Decline modal */
	update_apps: gettext('Update Applications'),
	communicate: gettext('Communicate'),
	review_and_award: gettext('Review and Award'),
	award: gettext('Award'),
	save: gettext('Save'),
	decline: gettext('Decline'),
	decision: gettext('Decision'),
	next: gettext('Next'),
	back: gettext('Back'),
	award_apps: gettext('Award Applications'),
	decline_apps: gettext('Decline Applications'),
	award_app: gettext('Award Application'),
	decline_app: gettext('Decline Application'),
	awarded_apps: gettext('Awarded Applications'),
	declined_apps: gettext('Declined Applications'),
	decline_singl: gettext("You've selected one application to decline"),
	decline_mult: gettext("You've selected %s applications to decline"),
	award_singl: gettext("You've selected one application to award!"),
	award_mult: gettext("You've selected %s applications to award!"),
	award_ready: gettext("You're all ready to award!"),
	applicants: gettext('Applicants'),
	award_amount: gettext('Award Amount'),
	no: gettext('No'),
	yes: gettext('Yes'),
	no_status_updates: gettext('(No status updates)'),
	no_stage_updates: gettext('(No stage updates)'),
	no_email: gettext('(No email to send)'),
	render_prev: gettext('Could not render preview'),
	from: gettext('From'),
	subject: gettext('subject'),
	attachments: gettext('Attachments'),
	message: gettext('Message'),
	confirm: gettext('Confirm'),
	award_instructions: gettext('Applicants will be able to see that their applications have been awarded'),
	decline_instructions: gettext('Applicants will be able to see that their applications have been declined'),
	revert_decision: gettext('Revert decision'),
	clear_decision: gettext('Clear decision'),
	awarded_count_sing: gettext('%s Awarded application'),
	awarded_count_mult: gettext('%s Awarded applications'),
	declined_count_sing: gettext('%s Declined application'),
	declined_count_mult: gettext('%s Declined applications'),
	confirm_clear_decision_sing: gettext('Are you sure you want to clear the award decision for the selected application?'),
	confirm_clear_decision_mult: gettext('Are you sure you want to clear the award decisions for the selected applications?'),
	selected_no_decision: gettext('The selected applications do not have a decision'),
	modify_award: gettext('Modify award value'),
	new_award_val: gettext('New award value'),
	edit_custom_field: gettext('Edit custom field'),
	custom_field_updated: gettext('Custom field updated'),

	/* Move to stage modal */
	move_to_stage: gettext('Move to stage'),
	move: gettext('Move'),
	cancel: gettext('Cancel'),
	email_applicant: gettext('Email applicants'),
	set_status: gettext('Set status'),
	reopen_application: gettext('Reopen application'),

	change_status_alert: gettext('Cannot change custom status if applications are in multiple stages'),

	/* Grid titles */
	active: gettext('Active'),
	active_apps: gettext('Active Applications'),
	awarded: gettext('Awarded')
}, _defineProperty(_module$exports, 'awarded_apps', gettext('Awarded Applications')), _defineProperty(_module$exports, 'declined', gettext('Declined')), _defineProperty(_module$exports, 'declined_apps', gettext('Declined Applications')), _defineProperty(_module$exports, 'incomplete', gettext('Incomplete')), _defineProperty(_module$exports, 'incomplete_apps', gettext('Incomplete Applications')), _defineProperty(_module$exports, 'archived', gettext('Archived')), _defineProperty(_module$exports, 'archived_apps', gettext('Archived Applications')), _defineProperty(_module$exports, 'trashed', gettext('Trashed')), _defineProperty(_module$exports, 'trashed_apps', gettext('Trashed Applications')), _defineProperty(_module$exports, 'assigned', gettext('Assigned')), _defineProperty(_module$exports, 'assigned_apps', gettext('Assigned Applications')), _defineProperty(_module$exports, 'delete_applications', gettext('Delete applications?')), _defineProperty(_module$exports, 'confirm_delete', gettext('Are you sure you want to delete the selected applications?')), _defineProperty(_module$exports, 'permanently_delete_applications', gettext('Permanently delete applications?')), _defineProperty(_module$exports, 'confirm_permanently_delete', gettext('Are you sure you want to permanently delete the selected applications?')), _defineProperty(_module$exports, 'title', gettext('Title')), _defineProperty(_module$exports, 'ID', gettext('ID')), _defineProperty(_module$exports, 'applicant', gettext('Applicant')), _defineProperty(_module$exports, 'reviews_completed', gettext('Reviews completed')), _defineProperty(_module$exports, 'collaborators', gettext('collaborators')), _defineProperty(_module$exports, 'status', gettext('Status')), _defineProperty(_module$exports, 'label', gettext('Label')), _defineProperty(_module$exports, 'last_submitted', gettext('Last submitted')), _defineProperty(_module$exports, 'last_edited', gettext('Last edited')), _defineProperty(_module$exports, 'not_submitted', gettext('Not submitted')), _defineProperty(_module$exports, 'stage', gettext('Stage')), _defineProperty(_module$exports, 'date_created', gettext('Date created')), _defineProperty(_module$exports, 'stage_completion', gettext('Stage completion')), _defineProperty(_module$exports, 'custom_fields', gettext('Custom fields')), _defineProperty(_module$exports, 'review_scores', gettext('Review scores')), _defineProperty(_module$exports, 'date_submitted', gettext('Date submitted')), _defineProperty(_module$exports, 'not_started', gettext('Not started')), _defineProperty(_module$exports, 'profile_image', gettext('Profile image')), _defineProperty(_module$exports, 'updated_at', gettext('Updated on')), _defineProperty(_module$exports, 'overall_score', gettext('Overall Score')), _defineProperty(_module$exports, 'average_score', gettext('Average Score')), _defineProperty(_module$exports, 'weighted_score', gettext('Weighted Score')), _defineProperty(_module$exports, 'score', gettext('Score')), _defineProperty(_module$exports, 'recommendations', gettext('Recommendations Received/Sent')), _defineProperty(_module$exports, 'view_review', gettext('View Review ...')), _defineProperty(_module$exports, 'view_conflict', gettext('View conflict of interest')), _defineProperty(_module$exports, 'conflict_of_interest', gettext('Conflict of Interest')), _defineProperty(_module$exports, 'add_conflict_of_interest', gettext('Add conflict of interest')), _defineProperty(_module$exports, 'add', gettext('Add')), _defineProperty(_module$exports, 'view_conflict', gettext('View conflict of interest')), _defineProperty(_module$exports, 'ok', gettext('OK')), _defineProperty(_module$exports, 'members', gettext('members')), _defineProperty(_module$exports, 'assignments', gettext('Assignments')), _defineProperty(_module$exports, 'application', gettext('Application')), _defineProperty(_module$exports, 'applications', gettext('Applications')), _defineProperty(_module$exports, 'team', gettext('Team')), _defineProperty(_module$exports, 'teams', gettext('Teams')), _defineProperty(_module$exports, 'completed_on', gettext('Completed on')), _defineProperty(_module$exports, 'completed_at', gettext('Completed at')), _defineProperty(_module$exports, 'review', gettext('Review')), _defineProperty(_module$exports, 'download_review', gettext('Download Review')), _defineProperty(_module$exports, 'clear_review', gettext('Clear Review')), _defineProperty(_module$exports, 'unassign', gettext('Unassign')), _defineProperty(_module$exports, 'not_started', gettext('Not started')), _defineProperty(_module$exports, 'in_progress', gettext('In progress')), _defineProperty(_module$exports, 'completed', gettext('Completed')), _defineProperty(_module$exports, 'all_assignments', gettext('All Assignments')), _defineProperty(_module$exports, 'no_team', gettext('No team')), _defineProperty(_module$exports, 'currently_assigned_to', gettext('Currently assigned to')), _defineProperty(_module$exports, 'no_reviewers_in_stage', gettext('There are no reviewers in this stage')), _defineProperty(_module$exports, 'no_teams_in_stage', gettext('There are no teams in this stage')), _defineProperty(_module$exports, 'select_at_least', gettext('Please select at least one reviewer or team and one application')), _defineProperty(_module$exports, 'assign', gettext('Assign')), _defineProperty(_module$exports, 'cannot_unassign_team', gettext('You cannot unassign team assignments individually')), _defineProperty(_module$exports, 'and_others', gettext('(%s more)')), _defineProperty(_module$exports, 'review_stage', gettext('Review stage')), _defineProperty(_module$exports, 'select_review_stage', gettext('Select a review stage')), _defineProperty(_module$exports, 'assign_by_selecting', gettext('Assign by selecting')), _defineProperty(_module$exports, 'reviewers_and_teams', gettext('Reviewers and Teams')), _defineProperty(_module$exports, 'select_reviewers_first', gettext('Select reviewers and teams first')), _defineProperty(_module$exports, 'select_applications_first', gettext('Select applications first')), _defineProperty(_module$exports, 'select_people', gettext('Select the reviewers & teams to assign applications to:')), _defineProperty(_module$exports, 'assigned', gettext('# Assigned')), _defineProperty(_module$exports, 'selected', gettext('Selected:')), _defineProperty(_module$exports, 'reviewers', gettext('Reviewers')), _defineProperty(_module$exports, 'teams', gettext('Teams')), _defineProperty(_module$exports, 'name', gettext('Name')), _defineProperty(_module$exports, 'view_applicant_profile', gettext('View applicant profile')), _defineProperty(_module$exports, 'view_application', gettext('View application')), _defineProperty(_module$exports, 'or', gettext('or')), _defineProperty(_module$exports, 'unassigned_applications', gettext('unassigned applications')), _defineProperty(_module$exports, 'unassigned', gettext('Unassigned')), _defineProperty(_module$exports, 'total', gettext('total')), _defineProperty(_module$exports, 'currently_assigned', gettext('Currently assigned')), _defineProperty(_module$exports, 'completed_percentage', gettext('% Completed')), _defineProperty(_module$exports, 'tentative_assignments', gettext('Tentative assignments')), _defineProperty(_module$exports, 'reviewer', gettext('Reviewer')), _defineProperty(_module$exports, 'reviewer_name', gettext('Name')), _defineProperty(_module$exports, 'leave_unassigned', gettext('Leave unassigned')), _defineProperty(_module$exports, 'continue_distribution', gettext('Continue distribution even if limits are met')), _defineProperty(_module$exports, 'manually_assign', gettext('Manually assign applications')), _defineProperty(_module$exports, 'teams_only', gettext('Show review teams only')), _defineProperty(_module$exports, 'select_reviewers_and_teams', gettext('Select reviewers & teams to assign applications to')), _defineProperty(_module$exports, 'assign_to_selected_applications', gettext('How would you like to assign selected applications (%s) to reviewers?')), _defineProperty(_module$exports, 'assign_to_selected_reviewers', gettext('How would you like to assign applications to selected reviewers (%s)?')), _defineProperty(_module$exports, 'select_applications', gettext('Select applications to assign')), _defineProperty(_module$exports, 'unassign_selected_applications', gettext('Unassign selected applications')), _defineProperty(_module$exports, 'unassign_selected_applications_singular', gettext('Unassign selected application')), _defineProperty(_module$exports, 'unassign_applications_description', gettext('Yes, I understand that unassigning these applications will permanently delete the review data and that this action cannot be undone.')), _defineProperty(_module$exports, 'unassign_applications_description_singular', gettext('Yes, I understand that unassigning this application will permanently delete the review data and that this action cannot be undone.')), _defineProperty(_module$exports, 'unassign_applications_message_singular', gettext('Unassigning the application from this reviewer will also delete any associated review data collected from the reviewer.')), _defineProperty(_module$exports, 'unassign_applications_message', gettext('Unassigning these applications from this reviewer will also delete any associated review data collected from the reviewer.')), _defineProperty(_module$exports, 'unassign_team_warning', gettext('If any of the selected applications are assigned to a review team, the unassign action will not be applied to those applications.')), _defineProperty(_module$exports, 'submit_reviews', gettext('Submit reviews')), _defineProperty(_module$exports, 'reopen_reviews', gettext('Reopen reviews')), _defineProperty(_module$exports, 'clear_selected_reviews_team_description_singular', gettext('Are you sure you want to remove all review data from the selected review team for the selected applications?')), _defineProperty(_module$exports, 'clear_selected_reviews_singular', gettext('Clear selected review')), _defineProperty(_module$exports, 'clear_selected_reviews', gettext('Clear selected reviews')), _defineProperty(_module$exports, 'clear_review_description', gettext('Yes, I understand that these reviews will be permanently deleted and that this action cannot be undone.')), _defineProperty(_module$exports, 'clear_review_description_singular', gettext('Yes, I understand that this review will be permanently deleted and that this action cannot be undone.')), _defineProperty(_module$exports, 'clear_review_message_singular', gettext('Clearing this reviewer\'s responses will delete all their data collected for this review.')), _defineProperty(_module$exports, 'clear_review_message', gettext('Clearing this reviewer\'s responses will delete all their data collected for these reviews.')), _defineProperty(_module$exports, 'all_apps_assigned_to_all_reviewers', gettext('All applications are assigned to all selected reviewers')), _defineProperty(_module$exports, 'distribute_reviewer_assignments', gettext('Distribute reviewer assignments <strong>randomly</strong>, \
				and <strong>evenly</strong> over selected reviewers')), _defineProperty(_module$exports, 'allow_selected_reviewers_previous_stage', gettext('Allow selected reviewers to be assigned \
			applications they reviewed in a previous stage')), _defineProperty(_module$exports, 'num_review_assignments_per_app', gettext('Number of review assignments per application')), _defineProperty(_module$exports, 'max_number_of_apps_per_reviewer', gettext('Maximum number of applications per reviewer')), _defineProperty(_module$exports, 'previous_reviews', gettext('Previous reviews')), _defineProperty(_module$exports, 'profile_picture', gettext('Profile picture')), _defineProperty(_module$exports, 'customizeYourDownload', gettext('Customize your download')), _defineProperty(_module$exports, 'downloadSelectedApplicationsAs', gettext('Download selected applications as...')), _defineProperty(_module$exports, 'pdfWithAttachments', gettext('Separate PDF for each selected application (with attachments in original format)')), _defineProperty(_module$exports, 'pdfPerApplication', gettext('Separate PDF for each selected application')), _defineProperty(_module$exports, 'singleFile', gettext('Single PDF of all selected applications')), _defineProperty(_module$exports, 'formatFilesAs', gettext('Format files as')), _defineProperty(_module$exports, 'pdf', gettext('PDF')), _defineProperty(_module$exports, 'originalFormatAsOriginallyUploadedWhereApplicable', gettext('Original format (as originally uploaded, where applicable)')), _defineProperty(_module$exports, 'choose_application_tasks', gettext('Choose application tasks')), _defineProperty(_module$exports, 'includeInDownloadedFilename', gettext('Include in downloaded file name')), _defineProperty(_module$exports, 'applicationId', gettext('Application ID')), _defineProperty(_module$exports, 'applicationTitle', gettext('Application Title')), _defineProperty(_module$exports, 'applicantName', gettext('Applicant Name')), _defineProperty(_module$exports, 'applicationTasksToInclude', gettext('Application tasks to include')), _defineProperty(_module$exports, 'allApplicationTasks', gettext('All application tasks')), _defineProperty(_module$exports, 'includeEllipses', gettext('Include...')), _defineProperty(_module$exports, 'applicationProfiles', gettext('Application Profiles')), _defineProperty(_module$exports, 'notes', gettext('Notes')), _defineProperty(_module$exports, 'applicationCustomFields', gettext('Application custom fields')), _defineProperty(_module$exports, 'applicantCustomFields', gettext('Applicant custom fields')), _defineProperty(_module$exports, 'cancel', gettext('Cancel')), _defineProperty(_module$exports, 'reviews', gettext('Reviews')), _defineProperty(_module$exports, 'select_tasks', gettext('Select tasks')), _defineProperty(_module$exports, 'decision_visible', gettext('Decision visible')), _defineProperty(_module$exports, 'applicant_decision', gettext('Applicant decision')), _defineProperty(_module$exports, 'total_awarded', gettext('Total awarded')), _defineProperty(_module$exports, 'amount', gettext('Amount')), _defineProperty(_module$exports, 'payments', gettext('Payments')), _defineProperty(_module$exports, 'date', gettext('Date')), _defineProperty(_module$exports, 'show_decision', gettext('Show decision to applicant')), _defineProperty(_module$exports, 'hide_decision', gettext('Hide decision from applicant')), _defineProperty(_module$exports, 'edit_award', gettext('Edit award')), _module$exports);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1663);
var v4 = __webpack_require__(197);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(909);
var bytesToUuid = __webpack_require__(910);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(36);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__(1831);




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? Object(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/* harmony default export */ __webpack_exports__["a"] = (getHolder);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(924);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(314)(module)))

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(106);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicode);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deburr_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__words_js__ = __webpack_require__(334);




/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__words_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__deburr_js__["a" /* default */])(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCompounder);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseMap_js__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseMap_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(34);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (negate);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiSize_js__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__ = __webpack_require__(1914);




/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__["a" /* default */])(string)
    : Object(__WEBPACK_IMPORTED_MODULE_0__asciiSize_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringSize);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method is like `_.tap` except that it returns the result of `interceptor`.
 * The purpose of this method is to "pass thru" values replacing intermediate
 * results in a method chain sequence.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns the result of `interceptor`.
 * @example
 *
 * _('  abc  ')
 *  .chain()
 *  .trim()
 *  .thru(function(value) {
 *    return [value];
 *  })
 *  .value();
 * // => ['abc']
 */
function thru(value, interceptor) {
  return interceptor(value);
}

/* harmony default export */ __webpack_exports__["a"] = (thru);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseWrapperValue_js__ = __webpack_require__(992);


/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseWrapperValue_js__["a" /* default */])(this.__wrapped__, this.__actions__);
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperValue);


/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cookies = __webpack_require__(308);

var COOKIES_ACCEPTED_KEY = 'gdpr_consent';
var COOKIES_DENIED_KEY = 'gdpr_consent_denied';

var bannerTempl = __webpack_require__(2209);
var ajax = __webpack_require__(4);

var STRINGS = {
	accept: gettext('AGREE'),
	no: gettext('NO'),
	title: interpolate('Our <a href="%(cookie)s" target="_blank">Cookie Policy</a> and <a href="%(privacy)s" target="_blank">Privacy Policy</a> outline how we use cookies to help personalize content, tailor and measure our marketing, and improve your user experience. I agree to use cookies for these purposes.', {
		cookie: 'https://apply.surveymonkey.com/cookie-policy/',
		privacy: 'https://www.surveymonkey.com/mp/legal/privacy-basics-enterprise/'
	}, true)
};

var CookieBanner = function (_Backbone$View) {
	_inherits(CookieBanner, _Backbone$View);

	function CookieBanner() {
		_classCallCheck(this, CookieBanner);

		return _possibleConstructorReturn(this, (CookieBanner.__proto__ || Object.getPrototypeOf(CookieBanner)).apply(this, arguments));
	}

	_createClass(CookieBanner, [{
		key: 'events',
		value: function events() {
			return {
				'click .sma-js-cookie-accept': 'clickedAgree',
				'click .sma-js-cookie-reject': 'clickedNo'
			};
		}
	}, {
		key: 'eitherCookieExists',
		value: function eitherCookieExists() {
			var cookies_accepted = Cookies.get(COOKIES_ACCEPTED_KEY);
			var cookies_rejected = Cookies.get(COOKIES_DENIED_KEY);

			return cookies_accepted || cookies_rejected ? true : false;
		}
	}, {
		key: 'banner',
		value: function banner() {
			return $('.sma-js-cookie-banner');
		}
	}, {
		key: 'deleteCookies',
		value: function deleteCookies() {
			// Google Analytics cookies
			var gaCookies = ['_ga', '_gid', '_gat'];

			gaCookies.forEach(function (cookie) {
				Cookies.remove(cookie, {
					domain: location.hostname
				});
			});

			gaCookies.forEach(function (cookie) {
				Cookies.remove(cookie, {
					domain: '.' + location.hostname
				});
			});
		}
	}, {
		key: 'showBanner',
		value: function showBanner() {
			var banner = $(bannerTempl({
				strings: STRINGS
			}));

			$('.sma-js-topbar').prepend(banner);
		}
	}, {
		key: 'initialize',
		value: function initialize() {
			var _this2 = this;

			this.setElement('.sma-js-topbar');

			// Check if a cookie exists (accepted or rejected)
			// If neither cookie exists, delete all existing cookies and show the banner
			if (this.eitherCookieExists()) {
				return;
			} else {
				ajax.get({
					url: reverse('in-gdpr-country'),
					alertOnSuccess: false,
					alertOnError: false,
					callback: function callback(result) {
						if (result.is_in_region) {
							_this2.deleteCookies();
							_this2.showBanner();
						} else {
							_this2.setAcceptedCookie();
						}
					}
				});
			}
		}
	}, {
		key: 'clickedAgree',
		value: function clickedAgree(e) {
			e.preventDefault();

			this.banner().remove();

			// GDPR states the accepted cookie can remain for 1 year
			this.setAcceptedCookie();
		}
	}, {
		key: 'setAcceptedCookie',
		value: function setAcceptedCookie() {
			Cookies.set(COOKIES_ACCEPTED_KEY, 1, {
				expires: 365
			});
		}
	}, {
		key: 'clickedNo',
		value: function clickedNo(e) {
			e.preventDefault();

			this.deleteCookies();
			this.banner().remove();

			// GDPR states the rejected cookie can remain for 1 week
			Cookies.set(COOKIES_DENIED_KEY, 1, {
				expires: 7
			});
		}
	}], [{
		key: 'canAcceptCookies',
		value: function canAcceptCookies() {
			var cookies_accepted = Cookies.get(COOKIES_ACCEPTED_KEY);

			return cookies_accepted ? true : false;
		}
	}]);

	return CookieBanner;
}(Backbone.View);

module.exports = CookieBanner;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backbone = __webpack_require__(40);

var Backbone = _interopRequireWildcard(_backbone);

var _utils = __webpack_require__(27);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TEMPLATES = {
	baseFileViewer: __webpack_require__(2210),
	fileViewerBar: __webpack_require__(2211),
	fileViewerDocument: __webpack_require__(2212),
	fileViewerImage: __webpack_require__(2213),
	fileViewerVideo: __webpack_require__(2214),
	fileViewerAudio: __webpack_require__(2215),
	fileFiewerLinkedVideo: __webpack_require__(2216),
	fileViewerCantPreview: __webpack_require__(2217)
};

var STRINGS = {
	download: gettext('DOWNLOAD'),
	files: gettext('files'),
	cantDisplay: gettext('The file format cannot be displayed in the browser.')
};

var FilePreviewer = function (_Backbone$View) {
	_inherits(FilePreviewer, _Backbone$View);

	function FilePreviewer() {
		_classCallCheck(this, FilePreviewer);

		return _possibleConstructorReturn(this, (FilePreviewer.__proto__ || Object.getPrototypeOf(FilePreviewer)).apply(this, arguments));
	}

	_createClass(FilePreviewer, [{
		key: 'initialize',


		/**
   * @param {Object[]} files - Files to populate the viewer with
   */
		value: function initialize(config) {
			var _this2 = this;

			if (!config) {
				console.warn('Missing parameter: "config"');
				return;
			}

			if (!config.hasOwnProperty('files')) {
				console.warn('Missing property: "files"');
				return;
			}

			this.files = config.files;
			this.indexOfActiveFile = config.indexOfActiveFile || 0;
			this.id = (0, _utils.randomString)(20);

			// Generic key events to traverse the file viewer
			$(document).on('keyup', function (_e) {
				if (_e.keyCode == 27) {
					// Escape
					_this2.closeViewer();
				} else if (_e.keyCode == 37) {
					// Left arrow
					_this2.previousFile();
				} else if (_e.keyCode == 39) {
					// Right arrow
					_this2.nextFile();
				}
			});

			this.files.forEach(function (file) {
				file.url = FilePreviewer.convertLinkedVideoToEmbeddedURL(file.url);
			});
			this.render();
		}
	}, {
		key: 'render',
		value: function render() {
			var renderedBase = TEMPLATES.baseFileViewer({
				id: this.id
			});

			$('body').prepend(renderedBase);

			this.viewer = $('#' + this.id);
			this.setElement(this.viewer);

			this.populateViewerWithFileData();
		}
	}, {
		key: 'populateViewerWithFileData',
		value: function populateViewerWithFileData() {
			var file = this.files[this.indexOfActiveFile];
			file.icon = this.activeFileIcon();

			// FILE VIEWER BAR
			var fileViewerBar = this.viewer.find('.sma-file-viewer-bar');
			var disableNavButtons = this.files.length == 1 ? true : false;
			var fileViewerBarRendered = TEMPLATES.fileViewerBar({
				index: this.indexOfActiveFile + 1,
				numFiles: this.files.length,
				file: file,
				strings: STRINGS,
				enableDownload: file.type != 'link',
				disableNavButtons: disableNavButtons
			});
			fileViewerBar.html(fileViewerBarRendered);

			// FILE VIEWER CONTENT AREA
			var fileViewerCanvas = this.viewer.find('.sma-file-viewer-content');
			var template = this.activeFileTemplate();

			if (this.fileIsPdf(file)) {
				file.src = window.MEDIA_URL + 'js/pdfjs/web/viewer.html?file=' + encodeURIComponent(file.url);
			} else if (file.converted_url) {
				file.src = window.MEDIA_URL + 'js/pdfjs/web/viewer.html?file=' + encodeURIComponent(file.converted_url);
			}

			var fileViewerCanvasRendered = template({
				file: file,
				strings: STRINGS
			});
			fileViewerCanvas.html(fileViewerCanvasRendered);
		}
	}, {
		key: 'stopPropagation',
		value: function stopPropagation(e) {
			e.stopPropagation();
		}
	}, {
		key: 'closeViewer',
		value: function closeViewer(_e) {
			this.destroy();
		}
	}, {
		key: 'nextFile',
		value: function nextFile(_e) {
			// Last file in the list
			if (this.indexOfActiveFile + 1 == this.files.length) {
				this.indexOfActiveFile = 0;
			} else {
				this.indexOfActiveFile += 1;
			}
			this.populateViewerWithFileData();
		}
	}, {
		key: 'previousFile',
		value: function previousFile(_e) {
			// First file in the list
			if (this.indexOfActiveFile == 0) {
				this.indexOfActiveFile = this.files.length - 1;
			} else {
				this.indexOfActiveFile -= 1;
			}
			this.populateViewerWithFileData();
		}
	}, {
		key: 'activeFileIcon',
		value: function activeFileIcon() {
			var file = this.files[this.indexOfActiveFile];
			switch (file.type) {
				case 'file':
					return 'files_single-content-03';
				case 'image':
					return 'files_image';
				case 'video':
					return 'files_play';
				case 'audio':
					return 'files_music';
				case 'link':
					return 'ui-2_link-72';
				default:
					return 'files_single-folded';
			}
		}
	}, {
		key: 'fileIsPdf',
		value: function fileIsPdf(file) {
			var isPdfRegex = /\.pdf.*$/i;
			return isPdfRegex.test(file.url);
		}
	}, {
		key: 'activeFileTemplate',
		value: function activeFileTemplate() {
			var file = this.files[this.indexOfActiveFile];

			if (file.converted_url || this.fileIsPdf(file)) {
				return TEMPLATES.fileViewerDocument;
			}

			switch (file.type) {
				case 'file':
					return TEMPLATES.fileViewerImage;
				case 'image':
					return TEMPLATES.fileViewerImage;
				case 'video':
					return TEMPLATES.fileViewerVideo;
				case 'audio':
					return TEMPLATES.fileViewerAudio;
				case 'link':
					return TEMPLATES.fileFiewerLinkedVideo;
				default:
					return TEMPLATES.fileViewerCantPreview;
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.viewer.remove();
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-file-viewer-previous-file': 'previousFile',
				'click .sma-file-viewer-next-file': 'nextFile',
				'click .sma-file-viewer': 'closeViewer',
				'click .sma-file-viewer-bar': 'stopPropagation',
				'click .sma-file-viewer-media': 'stopPropagation',
				'click .sma-file-viewer-linked-video-inner-wrap': 'stopPropagation',
				'click .sma-file-viewer-close': 'closeViewer'
			};
		}
	}], [{
		key: 'convertLinkedVideoToEmbeddedURL',
		value: function convertLinkedVideoToEmbeddedURL(url) {
			url = decodeURIComponent(url);
			var vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
			var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

			// Check if it's already the embedded link (probably not the best way, but it's aight)
			if (url.includes('player.') || url.includes('/embed/')) {
				return url;
			} else {
				if (vimeoPattern.test(url)) {
					url = url.replace(vimeoPattern, 'https://player.vimeo.com/video/$1');
				} else if (youtubePattern.test(url)) {
					url = url.replace(youtubePattern, 'https://www.youtube.com/embed/$1');
				}
			}
			return url;
		}
	}]);

	return FilePreviewer;
}(Backbone.View);

module.exports = FilePreviewer;

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modals = __webpack_require__(6);

var _utils = __webpack_require__(27);

var Alert = __webpack_require__(10);
var Class = __webpack_require__(157);
var Bulk = __webpack_require__(231).Bulk;
var ToggleField = __webpack_require__(1181).ToggleField;
var modals = __webpack_require__(6);

var TextEditor = __webpack_require__(80);

var removeHTMLTags = function removeHTMLTags(htmlString) {
	if (htmlString) {
		htmlString = htmlString.replace(/\</g, "&lt;");
		htmlString = htmlString.replace(/\>/g, "&gt;");
		htmlString = htmlString.replace(/\"/g, "&quot;");
		return htmlString;
	}
};

var Button = function Button(config) {
	var config = $.extend({}, Button.defaults, config || {});
	var button, text, el;

	var result = {};

	if (!config.el) {
		button = el = $('<a/>', { href: '#', 'class': config.classes });

		if (config.dropdown) {
			el = $('<span class="dropdown"></span>').appendTo(el);
		}

		if (config.icon) {
			el = $('<span class="icon icon-' + config.icon + '"></span>').appendTo(el);
		}
	} else {
		button = config.el;
	}

	result.el = button;

	result.setDisabled = function (disabled) {
		button.toggleClass('ui-state-disabled', disabled);
	};

	result.getLabelEl = function () {
		var textEl = $(button);
		while (textEl.children().length > 0) {
			textEl = textEl.children().eq(0);
		}
		return textEl;
	};
	result.html = function (val) {
		result.getLabelEl().html(val);
	};
	result.text = function (val) {
		result.getLabelEl().text(val);
	};

	if (config.label) {
		result.text(config.label);
	} else if (config.labelHtml) {
		result.html(config.labelHtml);
	}

	if (config.menu) {
		var getMenu = function getMenu(button) {
			button = button || result.el;

			var menu = button.data('menu');

			if (!menu) {
				menu = config.menu;

				var el = menu.element || menu.$el;

				if (!el) {
					el = menu === true ? button.next() : $(menu);
					menu = new $.Menu({ classes: '', menuClass: config.menuClass, element: el, align: config.align });
				}

				(menu.element || el).on({
					'menushow show.chide-menu': function menushowShowChideMenu(e) {
						b = button.bind ? button : e.target.closest(button);
						e = $.Event('menushow', { menu: menu, originalTarget: e.target });
						b.trigger(e);
					},
					'menuselect select.chide-menu': function menuselectSelectChideMenu(e) {
						b = button.bind ? button : e.target.closest(button);
						e = $.Event('menuselect', { menu: menu, originalTarget: e.target });
						b.trigger(e);
					},
					'menuhide hide.chide-menu': function menuhideHideChideMenu(e) {
						b = button.bind ? button : e.target.closest(button);
						b.removeClass('ui-state-active');
						e = $.Event('menuhide', { menu: menu, originalTarget: e.target });
						b.trigger(e);
					}
				});

				button.data('menu', menu);

				button.bind('remove', function (e) {
					menu.destroy();
				});
			}

			return menu;
		};

		var onClick = function onClick(e) {
			e.preventDefault();

			var b = $(e.target).closest(button);

			if (b.hasClass('ui-state-disabled')) {
				return false;
			}

			var menu = getMenu(b);

			if (b.hasClass('ui-state-active')) {
				menu.hide();
			} else {
				menu.show(b);
				setTimeout(function () {
					b.addClass('ui-state-active');
				}, 0);
			}
		};

		if (button.bind) {
			button.bind($.extend({}, {
				click: $.proxy(onClick, button),
				menushow: $.proxy(config.menushow, button),
				menuselect: $.proxy(config.menuselect, button),
				menuhide: $.proxy(config.menuhide, button)
			}));
		} else {
			$(document).off('click', button).on('click', button, onClick);

			if (config.menushow) {
				$(document).off('menushow', button).on('menushow', button, config.menushow);
			}
			if (config.menuselect) {
				$(document).off('menuselect select.chide-menu', button).on('menuselect select.chide-menu', button, config.menuselect);
			}
			if (config.menuhide) {
				$(document).off('menuhide', button).on('menuhide', button, config.menuhide);
			}
		}

		result.getMenu = getMenu;
	} else {
		if (button.bind) {
			$(button).bind($.extend({}, {
				click: config.click
			}));
		} else {
			if (config.click) {
				$(document).off('click', button).on('click', button, config.click);
			}
		}
	}

	return result;
};

// Notify
var Notifier = Class.create({
	classes: 'chide-notifier notifier',

	hideTimeout: null,
	actionTimeout: null,

	shown: false,

	initialize: function initialize() {
		_.bindAll(this, 'setupTimeouts', 'hide', 'setActionHandler');

		this.el = $('<div></div>').addClass(this.classes).appendTo('body');

		this.el.position({
			my: 'center',
			at: 'center',
			of: window,
			offset: '0 0'
		});

		if (this.el.hide) this.el.hide();
	},

	show: function show(msg, opts, callback) {
		opts = opts ? opts : {};
		this.callback = callback ? callback : null;
		if (opts.type === 'error') {
			this.el.empty().append($('<div/>', { 'class': 'error', html: msg }));
		} else if (opts.type === 'warning') {
			this.el.empty().append($('<div/>', { 'class': 'warning', html: msg }));
		} else {
			this.el.html(msg);
		}

		if (!this.shown) {
			this.el.stop(true);
		}

		this.shown = true;

		this.el.show().position({
			my: 'center',
			at: 'center',
			of: window,
			offset: '0 0'
		});

		this.el.css('opacity', 0).animate({ opacity: '1' }, 350, this.setupTimeouts);
	},

	setupTimeouts: function setupTimeouts() {
		var that = this;

		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
			clearTimeout(this.actionTimeout);
		}
		this.hideTimeout = setTimeout(this.hide, 5000);
		this.actionTimeout = setTimeout(this.setActionHandler, 800);

		$('body').unbind('.notifier');
		this.el.unbind('.notifier');
	},
	setActionHandler: function setActionHandler() {
		this.el.bind('mousemove.notifier', this.hide);
		$('body').bind('click.notifier keypress.notifier', this.hide);
	},

	hide: function hide(e) {
		var that = this;

		this.shown = false;

		$('body').unbind('.notifier');

		setTimeout(function () {
			that.el.fadeOut(300);
		}, 800);

		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}

		if (this.actionTimeout) {
			clearTimeout(this.actionTimeout);
			this.actionTimeout = null;
		}

		if (this.callback) {
			this.callback();
		}
	}
});

var notify = function () {
	var notifier = function notifier(msg, opts, callback) {
		if (!notifier.instance) {
			notifier.instance = new Notifier();
		}

		notifier.instance.show(msg, opts, callback);
	};

	return notifier;
}();

// Prompter
var Prompter = Class.create({
	dialog: null,

	initialize: function initialize() {

		this.dialog = $('<div/>').dialog({
			title: null,
			dialogClass: 'prompt-box',
			width: 400,
			height: 180,
			modal: true,
			resizable: false
		});
	},

	show: function show(msg, opts, result_callback) {
		var that = this;
		var dialog = this.dialog;

		dialog.empty();
		var textbox = $("<input type='text' class='prompt_text_box text' style='width:90%;'>").keyup(function (e) {
			if (e.keyCode == 13) {
				//pressed enter: submit dialog
				dialog.dialog("close");
				result_callback.apply(this, [textbox.val()]);
			}
		});
		if ('default' in opts) {
			$(textbox).val(opts['default']);
		}
		dialog.append(textbox);
		dialog.dialog('option', 'title', msg);
		dialog.dialog('option', 'buttons', [{
			'class': 'icon icon-check',
			'text': gettext('Ok'),
			'click': function click() {
				dialog.dialog("close");
				result_callback.apply(this, [textbox.val()]);
			}
		}, {
			'class': 'icon icon-cancel',
			'text': gettext('Cancel'),
			'click': function click() {
				dialog.dialog("close");
			}
		}]);
		dialog.dialog("open");
		textbox[0].select();
	}
});

var aprompt = function () {
	var prompter = function prompter(msg, opts, result_callback) {
		if (!prompter.instance) {
			prompter.instance = new Prompter();
		}

		prompter.instance.show(msg, opts, result_callback);
	};

	return prompter;
}();

// Confirmation
var Confirmer = Class.create({
	dialog: null,

	initialize: function initialize() {

		this.dialog = $('<div/>').dialog({
			title: null,
			dialogClass: 'prompt-box',
			width: 400,
			height: 240,
			modal: true,
			resizable: false
		});
	},

	show: function show(msg, result_callback) {
		var that = this;
		var dialog = this.dialog;

		dialog.empty();
		dialog.dialog('option', 'title', '');
		dialog.html(msg);
		dialog.dialog('option', 'buttons', [{
			'class': 'icon icon-check',
			'text': gettext('Yes'),
			'click': function click() {
				dialog.dialog("close");
				result_callback.apply(this, [true]);
			}
		}, {
			'class': 'icon icon-cancel',
			'text': gettext('No'),
			'click': function click() {
				dialog.dialog("close");
				result_callback.apply(this, [false]);
			}
		}]);

		dialog.dialog('option', 'position', { of: window });

		dialog.dialog("open");
	}
});

var renderSelect = function renderSelect(choices, blankChoice, multi) {
	var item = $('<select>').attr('multiple', !!multi).addClass('custom-select');

	if (blankChoice) {
		item.append($('<option>', { val: '', html: blankChoice, 'class': 'blank' }));
	}

	$.each(choices, function (i, el) {
		if (el) {
			item.append($('<option>', { val: el[0], html: el[1] }));
		}
	});

	return item;
};

var delayCallback = function delayCallback(callback, ms) {
	var timer = 0;
	var that, args;
	var func = function func() {
		callback.apply(that, args);
	};
	return function () {
		that = this;
		args = arguments;
		clearTimeout(timer);
		timer = setTimeout(func, ms);
	};
};

var Value = Class.create({
	value: undefined,
	enabled: true,
	help: undefined,
	label: undefined,
	labelClass: 'inline',
	labelTag: 'strong',
	optionClass: 'opt row',
	fromInfo: undefined,
	defaultBlank: false,
	clearValue: null,

	initialize: function initialize(config) {
		$.extend(this, config);

		this.value = this.fromInfo ? this.fromInfo(this.info || this.value) : this.value;
	},

	renderHelp: function renderHelp() {
		return this.help ? '<a href="#" data-toggle="tooltip" class="help" title="' + this.help + '">(?)<\/a>' : '';
	},

	renderLabel: function renderLabel() {
		var help = this.renderHelp();
		var result = this.label ? '<' + this.labelTag + ' class="' + this.labelClass + '">' + this.label + ' ' + help + '</' + this.labelTag + '>' : '';

		return result;
	},

	render: function render() {
		return $('<div></div>', {
			'class': this.optionClass + ' col-sm-12',
			html: this.label ? '<label>' + this.renderLabel() + '</label>' : ''
		});
	},

	get: function get() {
		return this.value;
	},

	set: function set(value) {
		this.value = value;
	},

	changed: function changed(_value) {},
	refresh: function refresh(_e) {}
});

var Single = Class.create(Value, {
	cloneEl: undefined,
	blankChoice: undefined,
	initialValue: undefined,
	choices: [],

	renderChoices: function renderChoices() {
		return renderSelect(this.choices, this.blankChoice);
	},

	render: function render($super) {
		var that = this;

		var rendered;

		if (this.cloneEl === true) {
			this.constructor.prototype.cloneEl = this.renderChoices();
			rendered = this.cloneEl.clone();
		} else if (typeof this.cloneEl === 'function') {
			rendered = this.cloneEl().clone();
		} else {
			rendered = this.renderChoices();
		}

		rendered.val(this.value !== undefined ? this.value : this.initialValue || '').attr('disabled', !this.enabled).bind('change', function (e) {
			that.changed(that.value = $(this).val());
		});

		if (this.label) {
			return $super().find('label').append(rendered).end();
		}

		return $super().append(rendered);
	}
});

var Select = Single;

var Checkbox = Class.create(Value, {
	render: function render(items) {
		var that = this;
		var managed = void 0;
		var rand = (0, _utils.randomString)(20);

		var toggleField = new ToggleField({ element: $('<div class="col-sm-4 sma-js-toggle-field">\
			<input type="checkbox" class="sma-js-slide-toggle-checkbox sma-slide-toggle-checkbox" id="' + rand + '-slide-toggler">\
			<label class="float-sm-right" for="' + rand + '-slide-toggler">rand</label></div>') });

		toggleField.state = !!this.value;
		toggleField.determineState();

		var rendered = $('<div class="opt row"><label class="col-sm-8"><strong class="inline">' + this.label + '</strong></label></div>').append(toggleField.$el).bind('changed', function (e, value) {
			that.value = value;
			that.changed(value);

			toggleField.state = !!this.value;
			toggleField.determineState();

			if (managed) {
				managed.toggle(value);
			}
		});

		setTimeout(function () {
			rendered.find('input[type=checkbox]:eq(0)').attr('disabled', !that.enabled).attr('checked', !!that.value).bind('refresh', function (e) {
				$(this).attr('disabled', !that.enabled).attr('checked', !!that.value);
				rendered.trigger('changed', [!!this.checked]);
			}).bind('click', function (e) {
				rendered.trigger('changed', [!!this.checked]);
			}).end();
		}, 0);

		if (items) {
			managed = $('<div class="managed"/>');
			$.each(items, function (i, el) {
				managed.append(el.render ? el.render() : el);
			});
			rendered.append(managed.toggle(!!this.value));
		}
		this.set = function (value) {
			that.value = value;
			rendered.trigger('changed', [!!that.value]);
			return that;
		};
		this.refresh = function () {
			return rendered.find('input').trigger('refresh', [!!that.value]);
		};
		return rendered;
	}
});

var Text = Class.create(Value, {
	languages: undefined,
	translatable: true,
	applyEdit: false,
	inputClass: 'text',
	initialValue: '',
	continuous_change: true,
	blankText: function blankText() {
		return gettext('None');
	},
	fromInfo: function fromInfo(value) {
		value = this.clearU200D(value);
		return this.translatable ? this.languages.objectify(value) : value;
	},

	refresh: function refresh() {
		if (this._input) {
			this._input.val(this.get());
		}
	},

	clearU200D: function clearU200D(value) {
		if (value === undefined || value == null) {
			return;
		}

		var retValue = value;

		if (typeof value == 'string') {
			retValue = value.replace('\u200D', '');
		} else {
			for (var k in value) {
				value[k] = value[k].replace('\u200D', '');
			}

			retValue = value;
		}

		return retValue;
	},

	render: function render($super, index) {
		var that = this;
		var input = void 0;

		if (this.applyEdit) {
			this._input = input = this.renderApplyEdit(index);
		} else {
			var handleChange = function handleChange(e) {
				if (!input.is(':visible')) {
					return;
				}
				try {
					that.set(that.clearU200D(input.val()));
				} catch (err) {
					// Do nothing
				}

				if (!e) {
					input.val(that.value === undefined || that.get() === '' ? '' : that.get());
				}

				that.changed(that.get());
			};

			this._input = input = $('<input type="text" class="form-control ' + this.inputClass + '" />').val(this.get() ? this.get() : this.initialValue).bind('change', function () {
				handleChange();
			}).bind('keyup blur mouseup', delayCallback(handleChange, 100));

			if (this.size) {
				input.attr('size', this.size);
			}

			this.refresh = function () {
				input.val(this.get());
			};
		}

		if (this.label) {
			return $super().find('label').append(input).end();
		}
		return $super().append(input);
	},

	renderApplyEdit: function renderApplyEdit(index) {
		var that = this;

		var editDisplay = $('<a>', {
			'class': 'label label-primary identifier',
			href: '#',
			text: this.get() !== undefined && this.get() !== '' ? this.get() : this.blankText(index)
		}).click(function (e) {
			e.preventDefault();

			var applyHandler = function applyHandler(_event) {
				var val = input.val();
				if (val == '') {
					val = undefined;
				}
				var old = void 0;
				try {
					old = that.get();
					that.set(val);
					that.changed(val, old);
				} catch (err) {
					if (input.val() === '') {
						that.value = '';
					}
					that.changed(val, old);
				}

				if (that.value === undefined || that.get() === '') {
					if (that.clearValue !== null) {
						that.set(that.clearValue);
						that.changed(that.clearValue, '');
						editDisplay.text(that.clearValue);
					} else {
						editDisplay.text(that.blankText(index));
					}
				} else {
					editDisplay.text(that.get());
				}

				edit.before(editDisplay);
				edit.remove();
			};

			var input = $('<input type="text" />').attr('maxlength', '40').css('display', 'inline').val(that.get() !== undefined ? that.get() : that.defaultBlank ? that.blankText(index) : '').addClass('text inline short').bind('change blur', applyHandler);

			var edit = $('<span>', { 'class': '' }).append(input);

			$(this).before(edit).detach();

			input.focus();
		});

		return editDisplay;
	},

	set: function set(value) {
		if (this.translatable && typeof value === 'string') {
			this.value = this.value === undefined ? {} : this.value;
			this.value[this.languages.selected()] = value;
		} else {
			this.value = value;
		}

		if (this._input && this._input.val() != this.get()) {
			this._input.val(this.get());
		}
	},

	get: function get() {
		if (this.translatable) {
			return this.languages.translate(this.value);
		} else {
			return this.value;
		}
	}
});

var Html = Class.create(Text, {
	labelClass: '',

	dialogOptions: {
		width: 700,
		height: 480,
		bgiframe: true,
		modal: false,
		zIndex: -1,
		resizable: false,
		closeOnEscape: false,
		title: gettext('Visual Editor')
	},

	showHtmlEditor: function showHtmlEditor() {
		var _this = this;

		this.editArea = $('<div><textarea class="form-control"></textarea></div>');
		this.textarea = $('textarea', this.editArea);

		this.dialog = new _modals.ContentModal(this.textarea, {
			title: gettext('Visual Editor'),
			destroyOnClose: true,
			buttons: [{
				label: gettext('OK'),
				cls: 'button-default',
				handler: function handler() {
					_this._input.val(_this.editor.getContent());
					_this.set(_this.editor.getContent());
					_this.changed(_this.editor.getContent());
					_this._input.focus();
					_this.dialog.hide();
				}
			}]
		});

		this.editor = new TextEditor({
			textarea: this.textarea,
			piping: ['all']
		});

		this.editor.setContent(this.get());
		this.dialog.show();
	},

	render: function render() {
		var that = this;
		var input = void 0;

		var handleChange = function handleChange(event) {
			if (!input.is(':visible')) {
				return;
			}
			try {
				that.set(input.val());
			} catch (err) {
				// Do nothing
			}
			if (!event) {
				input.val((that.value === undefined || that.get()) === '' ? '' : that.get());
			}
			that.changed(that.get());
		};

		this._input = input = $('<textarea>', { 'class': 'form-control ' + this.inputClass });

		input.val(this.get() ? this.get() : this.initialValue).bind('change', function () {
			handleChange();
		}).bind('keyup mouseup', handleChange).focus(function () {
			editHtml.show();
		}).blur(function () {
			handleChange();
			editHtml.hide(function () {
				if (that.blurred) {
					that.blurred();
				}
			});
		});

		var editHtml = $('<a href="#" class="edit-html">' + gettext('Open Visual Editor') + '</a>').click(function () {
			that.showHtmlEditor();
			return false;
		}).css('display', 'none');

		return Value.prototype.render.call(this).append(input, editHtml);
	}
});

var Number = Class.create(Text, {
	allowBlank: false,
	translatable: false,
	inputClass: 'text short float-sm-right',
	max: null,
	min: null,
	type: 'float',
	set: function set(value) {
		var number = (this.type == 'int' ? parseInt : parseFloat)(isNaN(value) ? this.value : value, 10);
		if (value === undefined || value === '') {
			if (!this.allowBlank) {
				throw new Error();
			} else {
				this.value = undefined;
			}
		} else if (isNaN(number) || number == Infinity) {
			if (!this.allowBlank) {
				throw new Error();
			} else {
				this.value = undefined;
			}
		} else if (this.min != null && number < this.min) {
			new Alert({
				message: gettext('Value is smaller than allowed minimum - Setting to minimum value.'),
				type: 'warning'
			});
			this.value = this.min;
		} else if (this.max != null && number > this.max) {
			new Alert({
				message: gettext('Value is greater than allowed maximum - Setting to maximum value.'),
				type: 'warning'
			});
			this.value = this.max;
		} else {
			this.value = number;
		}
		return this.value;
	}
});

var DateTime = Class.create(Value, {
	translatable: false,
	hasDate: true,
	hasTime: true,
	ampm: true, //Flag to show AM/PM dropdown
	is12: false, //What format is the time currently stored in comes from the server, and is exported, as 24 so default false
	optionClass: 'opt date-time',
	datePicker: undefined,
	changeMonth: false,
	changeYear: false,
	fromInfo: function fromInfo(info) {
		this.set(info);
		if (this.hasTime && this.ampm) this._24to12(); //Make it 12 if ampm active
		return this.value;
	},

	update: function update(toUpdate) {
		if (this.element === undefined) return;
		if (toUpdate === undefined) toUpdate = { 'date': true, 'time': true };
		if (this.hasDate && toUpdate['date']) {
			var date = this.datePicker.datepicker('getDate');
			date && $('span.date-label', this.element).text(date.format("mmm dS, yyyy"));
		}
		if (this.hasTime && toUpdate['time']) {
			$('input.time-hours', this.element).val(this.value.time.hours);
			$('input.time-minutes', this.element).val(this.value.time.minutes);
			$('select.time-ampm', this.element).val(this.value.time.ampm);
		}
	},

	_24to12: function _24to12() {
		if (!this.ampm || !this.hasTime || this.is12) return;
		var hours = parseInt(this.value.time.hours, 10);
		if (hours >= 12) {
			if (hours > 12) {
				hours -= 12;
			}
			this.value.time.ampm = 'PM';
		} else {
			this.value.time.ampm = 'AM';
			if (hours == 0) hours = 12;
		}
		this.value.time.hours = hours.toString();
		if (this.value.time.hours.length == 1) {
			this.value.time.hours = "0" + this.value.time.hours;
		}
		if (this.value.time.minutes.length == 1) {
			this.value.time.minutes = "0" + this.value.time.minutes;
		}
		this.update({ 'date': false, 'time': true });
		this.is12 = true;
	},

	_12to24: function _12to24() {
		if (!this.ampm || !this.hasTime || !this.is12) return;
		var hours = parseInt(this.value.time.hours, 10);

		if (this.value.time.ampm == 'AM') {
			if (hours == 12) {
				this.value.time.hours = "00";
			}
		} else {
			if (hours == 12) return;
			hours = hours + 12;
			if (hours >= 24) {
				this.value.time.hours = "23";
				this.value.time.minutes = "59";
			} else this.value.time.hours = hours.toString();
		}

		this.is12 = false;
	},

	getJSDate: function getJSDate() {
		var d = this.datePicker.datepicker('getDate');
		var was12 = this.is12;
		if (this.hasTime && was12) {
			this._12to24();
		}
		var d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), this.value.time.hours, this.value.time.minutes, 0, 0);
		if (was12) {
			this._24to12();
		}
		return d;
	},

	setDate: function setDate(date) {
		if (date === undefined || date.indexOf('-') == -1) return;
		var splitDate = date.split('-');
		this.value['date'] = new Date(parseInt(splitDate[0], 10), parseInt(splitDate[1], 10), parseInt(splitDate[2], 10));
	},

	setTime: function setTime(time) {
		if (time === undefined || time.indexOf(':') == -1) return;
		if (this.value['time'] == undefined) this.value['time'] = {};
		var splitTime = time.split(':');
		splitTime[0] = parseInt(splitTime[0], 10).toString();
		splitTime[1] = parseInt(splitTime[1], 10).toString();
		if (this.is12 && parseInt(splitTime[0], 10) > 12) {
			splitTime[0] = (parseInt(splitTime[0], 10) - 12).toString();
			if (parseInt(splitTime[0], 10) > 12) {
				splitTime[0] = '12';
			}
			this.value['time']['ampm'] = 'PM';
		}
		if (parseInt(splitTime[0], 10) < 0) {
			splitTime[0] = -1 * parseInt(splitTime[0], 10).toString();
		}
		if (parseInt(splitTime[1], 10) < 0) {
			splitTime[1] = -1 * parseInt(splitTime[1], 10).toString();
		}
		if (splitTime[0].length == 1) {
			splitTime[0] = "0" + splitTime[0];
		}
		if (splitTime[1].length == 1) {
			splitTime[1] = "0" + splitTime[1];
		}
		this.value['time']['hours'] = splitTime[0];
		this.value['time']['minutes'] = splitTime[1];
		this.update({ date: false, time: true });
	},

	set: function set(value) {
		if (!this.value) {
			this.value = {};
		}
		if (value === undefined || !value || typeof value != "string" || value.constructor.toString().indexOf('Date') > 0) {
			if (this.hasTime) {
				if (value && value.constructor.toString().indexOf('Date')) {
					this.value['time'] = { 'hours': value.getHours(), 'minutes': value.getMinutes() };
					this._24to12();
				} else {
					this.value['time'] = { 'hours': '12', 'minutes': '00', 'ampm': 'PM' };
				}
				this.is12 = true;
			}
			if (this.hasDate) {
				if (value && value.constructor.toString().indexOf('Date')) {
					this.value['date'] = value;
				} else {
					this.value['date'] = new Date();
				}
			}
		} else {
			if (value.indexOf(' ') > -1) {
				//Its both a date and a time
				var date = value.split(' ');
				var dateStr = date[0].split('-'); //Python stores month 1-12, js stores them 0-11, conversion time

				dateStr[1] = (parseInt(dateStr[1], 10) - 1).toString();
				this.setDate(dateStr.join('-'));
				this.setTime(date[1]);
			} else //It's just a date or just a time figure which one
				if (value.indexOf(':') > -1) //Its a time
					this.setTime(value);else //We've got to assume date here
					this.setDate(value);
			if (value.toLowerCase().indexOf('am') > -1) {
				this.is12 = true;
				this.value['time']['ampm'] = 'AM';
			} else if (value.toLowerCase().indexOf('pm') > -1) {
				this.is12 = true;
				this.value['time']['ampm'] = 'PM';
			}
		}
	},

	render: function render($super) {
		var that = this;
		this.element = $super();

		if (this.hasDate) {
			var dateLabel = $('<span></span>', {
				'class': 'date-label',
				html: gettext('Please select a date &raquo;')
			});

			var datePicker = $('<input \/>', {
				name: 'date-picker-text'
			}).hide();

			datePicker.datepicker({
				dateFormat: 'yyyy-m-d',
				changeMonth: this.changeMonth,
				changeYear: this.changeYear,
				onSelect: function onSelect(dateText) {
					that.setDate($(this).datepicker('getDate').format("yyyy-m-d"));
					$('span.date-label', that.element).text($(this).datepicker('getDate').format("mmm dS, yyyy"));
					datePicker.datepicker('hide');
				},
				beforeShow: function beforeShow(input, inst) {
					setTimeout(function () {
						var position = $('a.datepicker-button', that.element).offset();
						inst.dpDiv.css('position', 'absolute');
						inst.dpDiv.css('top', (position.top + $('a.datepicker-button', that.element).height()).toString() + 'px');
						inst.dpDiv.css('left', position.left.toString() + 'px');
					}, 10);
				}
			});

			if (this.value['date']) {
				datePicker.datepicker('setDate', this.value.date);

				dateLabel.html(datePicker.datepicker('getDate').format("mmm dS, yyyy"));
			}

			if (this.datePicker == undefined) this.datePicker = datePicker;

			var datePickerImage = $('<a></a>', {
				href: '#',
				title: gettext('Choose a Date'),
				'class': 'datepicker-button',
				click: function click(e) {
					e.preventDefault();
					datePicker.datepicker('show');
				}
			}).append($('<img\/>', {
				src: '/media/img/icons/fugue/icons/calendar-blue.png'
			}));
			this.element.append(dateLabel).append('&nbsp;').append(datePicker).append(datePickerImage);
		}

		if (this.hasTime) {
			var timeContainer = $('<span><\/span>', {
				"class": 'time-container'
			});

			if (this.hasDate) timeContainer.append(' @ ');

			timeContainer.append($('<input \/>', {
				type: 'text',
				name: 'hours',
				'class': 'time-hours',
				change: function change() {
					that.setTime($(this).val() + ':' + $('input[name=minutes]', $(this).parent()).val());
					that.update({ 'date': false, 'time': true });
				},
				val: this.value.time.hours,
				css: {
					width: '20px'
				}
			})).append(' : ').append($('<input \/>', {
				type: 'text',
				name: 'minutes',
				'class': 'time-minutes',
				change: function change() {
					that.setTime($('input[name=hours]', $(this).parent()).val() + ':' + $(this).val());
					that.update({ 'date': false, 'time': true });
				},
				val: this.value.time.minutes,
				css: {
					width: '20px'
				}
			}));

			if (this.ampm) {
				var ampmSelect = $('<select><\/select>', {
					"class": 'time-ampm',
					change: function change() {
						if (that.value['time']) that.value.time['ampm'] = $(this).val();
					}
				}).append($('<option><\/option>', {
					val: 'AM',
					text: gettext('AM')
				})).append($('<option></option>', {
					val: 'PM',
					text: gettext('PM')
				}));
				if (this.value['time'] && this.value['time']['ampm']) ampmSelect.val(this.value.time.ampm);
				timeContainer.append(ampmSelect);
			}

			this.element.append(timeContainer);
		}
		this.update();
		return this.element;
	},

	serialize: function serialize() {
		//Format from value dict to: yyyy-mm-dd 00:00:00
		was12 = this.is12;
		if (this.hasTime && was12) this._12to24();
		var timeString = this.hasTime ? this.value.time.hours + ':' + this.value.time.minutes + ':00' : '00:00:00';
		var date = this.datePicker.datepicker('getDate');
		var dateString = this.hasDate && date ? date.format('yyyy-mm-dd') : '';
		if (was12) this._24to12();
		return dateString + (this.hasTime ? ' ' + timeString : '');
	}
});

var TextList = Class.create(Value, {
	enableExtraction: true,
	hasSubOptions: false,
	textClass: Text,
	tabOffset: 1,
	direction: 'vertical',

	fromInfo: function fromInfo(value) {
		var items = [];

		if (value && value.length) {
			if (this.extraction) {
				for (var i = 0; i < value.length; i++) {
					if (this.extraction.multiline && this.extraction.multiline == true) {
						value[i].appearance = 'full';
						value[i].rows = this.extraction.rows;
						value[i].cols = this.extraction.cols;
					}
					if (this.extraction.required) {
						value[i].required = this.extraction.required;
					}
					items.push(this.itemFromValue(value[i]));
				}
			} else {
				for (var i = 0; i < value.length; i++) {
					items.push(this.itemFromValue(value[i]));
				}
			}
		}

		if (this.enableExtraction) {
			var Extraction = __webpack_require__(406).Extraction;
			this.extraction = new Extraction(this.field, { value: this.extraction, textlist: this });
		}

		return items;
	},

	length: function length() {
		return this.value.length;
	},

	getAt: function getAt(i) {
		return this.value[i].text.get();
	},

	setAt: function setAt(i, value) {
		this.value[i].text.set(value);

		this.itemChanged(i, this.value[i]);

		if (this._rendered && this._rendered.is(':visible')) {
			$('> li > div.option > input.text', this._rendered).eq(i).val(this.getAt(i));
		}
	},

	updateExtracted: function updateExtracted(value, triggerChanged) {
		var choices = [];
		if (value) {
			var that = this;
			_.each(this.extraction.question.getField().getExtractionChoices(), function (el) {
				choices.push(that.itemFromValue({ label: el[1] }));
			});
			that.value = choices;
			this.itemsChanged(choices);
			return choices;
		}
	},

	render: function render() {
		var that = this;

		var el = $('<li><div class="option"><a href="#" class="remove">Remove<\/a><input type="text" class="text" /><\/div><\/li>');

		var handleChange = function handleChange(e) {
			if (!$(e.target).is(':visible')) {
				return;
			}
			var item = $(e.target).closest('li');
			var index = rendered.find('> li').index(item);
			var val = $(e.target).val();

			if (index >= 0) {
				that.value[index].text.set(val);
				that.itemChanged(index, that.value[index]);
				if (e.type === 'keyup') that.itemsChanged(that);
			}
		};

		var rendered = this._rendered = $('<ul>', { 'class': 'text-list' }).delegate('li > div.option > input.text', 'change', handleChange)
		/*.delegate('li > div.option > input.text', 'focus', function (e) {
  	e.target.select();
  })*/
		.delegate('li > div.option > input.text', 'mouseup', function (e) {
			// fix autoselection in Chrome
			e.preventDefault();
		}).delegate('li > div.option > input.text', 'keyup blur mouseup', delayCallback(handleChange, 100)).delegate('li > div.option > a.remove', 'click', function (e) {

			e.preventDefault();

			if (that.value.length <= 1) {
				return;
			}

			var item = $(this).closest('li');
			var index = rendered.find('> li').index(item);

			var editor = __webpack_require__(74).Editor.instances[0];

			if (index >= 0 && editor && editor.form_is_live) {
				var modalTitle = gettext('Change form field');
				var modalBody = that.getChoiceChangeModalBody(true);
				new modals.Confirm(modalTitle, modalBody, function () {
					item.remove();
					that.value.splice(index, 1);
					that.itemRemoved(index);
					that.itemsChanged(that);
				}, {
					destroyOnClose: true,
					yes: gettext("Make Change"),
					no: gettext("Cancel"),
					yes_class: "btn-danger",
					no_class: "btn-white"
				});
			} else if (index >= 0) {
				item.remove();
				that.value.splice(index, 1);
				that.itemRemoved(index);
				that.itemsChanged(that);
			}
		});

		if (this.hasSubOptions) {
			rendered.delegate('li > div.option > input.text', 'focus', function (e) {
				var item = $(this).closest('li');
				var index = rendered.find('> li').index(item);

				if (index >= 0) {
					var sub = item.find('.suboptions');
					if (!sub.length) {
						sub = that.renderSubOptions(that.value[index], index).appendTo(item);
					}

					$(this).trigger('subOptionsShown', [sub, index, that.value[index]]);

					rendered.find('> li > div.suboptions').not(sub).remove();
					sub.show();
				}
			});
		}

		var refreshForValue = function refreshForValue(value) {
			rendered.empty();

			for (var i = 0; i < value.length; i++) {
				rendered.append(el.clone());
			}

			$('> li > div.option > input.text', rendered).each(function (i, el) {
				$(el).val(value[i].text.get()).attr('tabIndex', that.tabOffset);
			});

			if (that.value !== value) {
				that.value = value;
				that.itemsChanged(value);
			}
		};
		$(rendered).sortable({
			axis: 'y',
			containment: 'parent',
			handle: 'a.move',
			update: function update(e, ui) {
				value = [];
				$('> li > div.option > input.text', rendered).each(function (i, el) {
					$.each(that.value, function (index, item) {
						if (item.text.get() == $(el).val()) {
							value.push(item);
							return false;
						}
					});
				});
				if (that.value !== value) {
					that.value = value;
					that.itemsChanged(value);
				}
			}
		});
		var add = this._add = function (value) {
			var item = that.addItem(that.itemFromValue(value));

			var clone = el.clone();

			rendered.append(clone);

			$('> div.option > input.text', clone).attr('tabindex', that.tabOffset).val(item.text.get() || '').trigger('focus').focus();

			that.itemsChanged(that);
		};

		refreshForValue(this.value);

		var addButton = $('<a>', { 'class': 'btn btn-secondary btn-sm add', text: gettext('Add'), href: '#' }).click(function (e) {
			e.preventDefault();

			var editor = __webpack_require__(74).Editor.instances[0];
			if (editor && editor.form_is_live) {
				var modalTitle = gettext('Change form field');
				var modalBody = that.getChoiceChangeModalBody(true);

				new modals.Confirm(modalTitle, modalBody, function () {
					add();
				}, {
					destroyOnClose: true,
					yes: gettext("Make Change"),
					no: gettext("Cancel"),
					yes_class: "btn-danger",
					no_class: "btn-white"
				});
			} else {
				add();
			}
		});

		var bulkAction = function bulkAction() {
			Bulk.show(that.direction, that.value ? that.value : undefined, function (value) {
				refreshForValue($.map(value, function (el, i) {
					var parsedValues = that.parseBulks(el),
					    returnItem; //returnItem will be our option variable

					if (parsedValues.index !== null) {
						i = parsedValues.index;
					}

					if (that.value[i] && (that.value[i].type == undefined || that.value[i].type.value == parsedValues.type)) {
						that.value[i].text.value = parsedValues['labels'];
						returnItem = that.value[i];
					} else {
						returnItem = that.itemFromValue({ label: el });
					}

					if (!isNaN(parsedValues.score) && returnItem.score) {
						returnItem.score.value = parsedValues.score;
					}

					if (parsedValues.type && returnItem.type) {
						var items = _.find(returnItem.type.choices, function (item) {
							return _.contains(item, parsedValues.type);
						});
						if (items) {
							returnItem.type.value = parsedValues.type;
						}
					} else if (!parsedValues.type && returnItem.type) {
						returnItem.type.value = 'string';
					}

					if (parsedValues.options) {
						$.each(Bulk.availableOptions, function (i, keyword) {
							if (returnItem[keyword] && parsedValues.options.indexOf(keyword) > -1) {
								returnItem[keyword].value = true;
								if (keyword === 'other_required' && returnItem.other) {
									//automatically set other to true when other_required is true
									returnItem.other.value = true;
								}
							} else if (returnItem[keyword]) {
								returnItem[keyword].value = false;
							}
						});
					}
					return returnItem;
				}));
			});
		};

		var bulkButton = $('<a>', { 'class': 'btn btn-secondary btn-sm bulk', text: gettext('Bulk'), href: '#' }).click(function (e) {
			e.preventDefault();

			var editor = __webpack_require__(74).Editor.instances[0];

			if (editor && editor.form_is_live) {
				var modalTitle = gettext('Change form field');
				var modalBody = that.getChoiceChangeModalBody(true);

				new modals.Confirm(modalTitle, modalBody, function () {
					bulkAction();
				}, {
					destroyOnClose: true,
					yes: gettext("Make Change"),
					no: gettext("Cancel"),
					yes_class: "btn-danger",
					no_class: "btn-white"
				});
			} else {
				bulkAction();
			}
		});

		var extraction;

		if (this.enableExtraction) {
			extraction = this.extraction.render();

			$(this.extraction.question).unbind('change.textlist').bind('change.textlist', function (e, value, old) {
				this.value = value;
				if (value) {
					choices = that.updateExtracted(value);
					refreshForValue(choices);
				}
			});

			var manualButton = $('<a>', { 'class': 'button back', text: gettext('Back to Manual Mode'), href: '#' }).click(function (e) {
				e.preventDefault();
				manualButton.hide();
				addButton.show();
				bulkButton.show();
				extractionButton.show();

				extraction.before(rendered).detach();

				that.extraction.question.set('');

				rendered.trigger('extraction', [true]);
			});

			var extractionButton = $('<a>', { 'class': 'btn btn-secondary btn-sm extraction', text: gettext('Extraction'), href: '#' }).click(function (e) {
				e.preventDefault();

				manualButton.show();
				addButton.hide();
				bulkButton.hide();
				extractionButton.hide();

				rendered.trigger('extraction', [false]);

				rendered.after(extraction).detach();
			});
		}

		return $('<div>', { 'class': 'clearfix option' }).append(this.enableExtraction && extraction && this.extraction.question.value ? extraction : rendered, addButton.toggle(!this.enableExtraction || !this.extraction.value), bulkButton.toggle(!this.enableExtraction || !this.extraction.value), this.enableExtraction ? extractionButton.toggle(!this.extraction.value) : false, this.enableExtraction ? manualButton.toggle(!!this.extraction.value) : false);
	},

	getChoiceChangeModalBody: function getChoiceChangeModalBody(form_is_live) {
		if (form_is_live) {
			return '<i class="nc-icon-mini ui-3_alert sma-danger-icon mr-1"></i> ' + gettext('<strong>Warning:</strong> you may lose data by making changes to form fields on a live form. See our help article for more information on <a href="https://smapply.zendesk.com/hc/en-us/articles/115001423873-How-to-Safely-Make-Changes-to-a-Live-Form" class="sma-underline-blue-link" target="_blank">How to Safely Make Changes to a Live Form</a>.<br><br>This cannot be undone.');
		} else {
			return gettext('Are you sure you want to make changes to this form field?');
		}
	},

	parseBulks: function parseBulks(input) {
		//input is an object with language codes: {'en': 'This is the english string | 3'}
		var parsed = '',
		    type = null;
		var that = this,
		    score = null,
		    options = null,
		    index = null;

		$.each(input, function (key, value) {
			var buildOptions = [];
			var match = value.match(/^\[\*A(\d+)\*\]\s*(.*)/);

			if (match) {
				index = parseInt(match[1], 10) - 1;
				value = match[2];
			}

			parsed = $.map(value.split('|'), function (el, i) {
				return el.trim();
			});
			input[key] = parsed.shift();

			match = input[key].match(/\[\[(.*?)\]\]/);
			type = type || (match ? match[1].trim() : '');
			input[key] = input[key].replace(/\[\[(.*?)\]\]/, '').trim();

			$.each(parsed, function (i, element) {
				if (!score && !isNaN(parseInt(element, 10))) {
					score = parseFloat(element, 10);
				} else if (!options && $.inArray(element, Bulk.availableOptions) > -1) {
					buildOptions.push(element);
				}
			});

			if (!options && buildOptions.length > 0) {
				options = buildOptions;
			}
		});

		return { 'index': index, 'labels': input, 'type': type, 'score': score, 'options': options ? options : [] };
	},

	itemFromValue: function itemFromValue(value) {
		return {
			text: new this.textClass({ value: value && value.label ? value.label : value && value.text ? value.text : '' })
		};
	},

	renderSubOptions: function renderSubOptions() {
		var sub = $('<div class="suboptions" style="display: none;"></div>');
		return sub;
	},

	addItem: function addItem(item) {
		this.value.push(item);
		this.itemAdded(item);
		return item;
	},

	itemAdded: function itemAdded(item) {},

	itemChanged: function itemChanged(index, value) {},

	itemsChanged: function itemsChanged(value) {},

	itemRemoved: function itemRemoved(index) {}
});

module.exports = {
	opts: {
		Value: Value,
		Button: Button,
		Text: Text,
		TextList: TextList,
		DateTime: DateTime,
		Html: Html,
		Single: Single,
		Select: Select,
		Number: Number,
		Checkbox: Checkbox,
		renderSelect: renderSelect
	}
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _utils = __webpack_require__(27);

var bulkUrl = reverse('surveys-bulk');
var Modals = __webpack_require__(6);

var Option = $.klass({
	label: undefined,
	inContextMenu: false,
	help: undefined,
	optional: true,
	enabled: true,
	classes: 'option clearfix',

	initialize: function initialize(field, config) {
		if (field !== undefined && field.editor === undefined) {
			this.editor = field;
		} else if (field !== undefined) {
			this.field = field;
			this.editor = field.editor;
		}
		$.extend(this, config);
	},

	render: function render() {
		return $('<div></div>').addClass(this.classes);
	},

	renderHelp: function renderHelp() {
		return this.help ? $(this.renderHelpString()) : undefined;
	},

	renderHelpString: function renderHelpString() {
		if (this.help !== undefined) {
			return ' <a href="#" class="help" title="' + this.help + '">(?)</a>';
		}
		return '';
	}
});

Option.renderGroup = function (label, items, collapsed, delayed) {

	var renderer = function renderer() {
		var result = $('<div class="optgroup">').toggleClass('collapsable', collapsed !== undefined).toggleClass('collapsed', collapsed === true);
		if (label) {
			var title = $('<h3 class="collapsable-title"/>').appendTo(result).append($('<a/>', {
				href: '#',
				text: label
			}).click(function (e) {
				e.preventDefault();
				options.toggle(!result.toggleClass('collapsed').hasClass('collapsed'));
			}));
		}

		var options = $('<div/>');

		$.each(items, function (i, el) {
			if (el) {
				options.append(el.render ? el.render() : el);
			}
		});

		options.appendTo(result).toggle(!collapsed);

		return result;
	};
	return !!delayed ? { render: function render() {
			return this.rendered = renderer.apply(this, arguments);
		} } : renderer(label, items, collapsed);
};

Option.Collapsable = $.klass({
	classes: 'option collapsable-options',
	label: '',
	collapsed: false,
	id: '',

	initialize: function initialize(config) {
		$.extend(this, config);
	},

	render: function render(nodes) {
		return Option.renderGroup(this.label, nodes, this.collapsed);
	}
});

Option.Group = $.klass({
	classes: 'option-group clearfix',

	initialize: function initialize(field, config) {
		if (field.editor === undefined) {
			this.editor = field;
		} else {
			this.field = field;
			this.editor = field.editor;
		}

		this.options = [];

		$.extend(this, config);
	},

	render: function render() {
		var result = $('<div><\/div>').addClass(this.classes);

		_.each(this.options, function (el) {
			result.append(el.render());
		});

		return result;
	}
});

Option.Value = $.klass(Option, {
	value: undefined,

	blockUpdate: false,

	initialize: function initialize($super, field, config) {
		var that = this;

		$super(field, config);

		$(this).bind('change', function (e, value, old) {
			return that.changed(value, old);
		});
	},

	get: function get() {
		return this.value;
	},

	set: function set(value, propagate) {
		var old = this.get();

		this.value = value;
		if (propagate !== false) {
			$(this).trigger('change', [value, old]);
		}

		if (this.input && this.refresh) {
			this.refresh();
		}
	},

	changed: function changed(value, old) {}
});

Option.Radio = $.klass(Option.Value, {
	display: 'radio',
	value: undefined,
	showLabel: false,
	choices: [],
	label: '',

	refresh: function refresh() {
		this.input.val(this.get());
	},

	render: function render($super) {
		var that = this;
		var id = (0, _utils.randomString)(10);

		if (this.display == 'radio') {
			this.choiceDisplay = $('<ul></ul>');

			_.each(this.choices, function (el, i) {
				that.choiceDisplay.append($.format('<li class="choice"><label for="{0}">' + '<input type="radio" id="{0}" value="{3}" name="{1}" /> ' + '<span class="choice-value">{2}</span></label></li>', [(0, _utils.randomString)(10), id, el[1], el[0]]));
			});

			this.input = $('input', this.choiceDisplay).click(function () {
				//that.set($.getCheckedValue($('input', that.choiceDisplay)));
			});
			$.setCheckedValue($('input', this.choiceDisplay), this.get());

			if (!this.enabled) {
				$('input', this.choiceDisplay).attr('disabled', 'disabled');
			}
		} else {
			this.input = this.choiceDisplay = $('<select class="custom-select custom-select-sm"></select>');

			_.each(this.choices, function (el, i) {
				that.choiceDisplay.append($.format('<option value="{0}">{1}</option>', [el[0], el[1]]));
			});

			this.choiceDisplay.change(function () {
				that.set(that.choiceDisplay.selectedOptions().val());
			}).val(this.value);

			if (!this.enabled) {
				this.choiceDisplay.attr('disabled', 'disabled');
			}
		}

		var label = '';
		if (this.showLabel) {
			label = '<span class="option-label">' + this.label + '<\/span>';
		}

		return $super().append(label).append(this.choiceDisplay).append(this.renderHelpString());
	}
});

Option.Multiple = $.klass(Option.Value, {
	display: 'checkbox',
	value: undefined,
	choices: [],
	label_getter: function label_getter(a, i) {
		return a[1];
	},
	id_getter: function id_getter(a, i) {
		return a[0];
	},
	render: function render($super) {
		var that = this;
		$(this).css('display', this.display);
		if (this.display == 'checkbox') {
			this.choiceDisplay = $('<ul></ul>');
			_.each(this.choices, function (el, i) {
				that.choiceDisplay.append($.format('<li class="choice"><label for="{0}">' + '<input type="checkbox" id="{0}" value="{3}" name="{1}" /> ' + '<span class="choice-value">{2}</span></label></li>', [(0, _utils.randomString)(10), el.id, that.label_getter(el), that.id_getter(el, i)]));
			});

			$('input', this.choiceDisplay).change(function () {
				that.set($('input:checked', that.choiceDisplay).map(function () {
					return $(this).val();
				}));
			});

			$('input', this.choiceDisplay).prop('checked', false);

			$.each(this.value || [], function () {
				$('input', that.choiceDisplay).eq(this).prop('checked', true);
			});
		} else {
			this.choiceDisplay = $('<select multiple="multiple"></select>');

			_.each(this.choices, function (el, i) {
				that.choiceDisplay.append($.format('<option value="{0}">{1}</option>', [el[0], el[1]]));
			});

			this.choiceDisplay.change(function () {
				that.set(that.choiceDisplay.selectedOptions().val());
			}).selectOptions(this.value);
		}
		if (this.hide) {
			return $super().append(this.choiceDisplay).css('display', 'none');
		}
		return $super().append(this.choiceDisplay);
	}
});

var Bulk = {
	presets: undefined,
	custom: undefined,
	languages: undefined,
	availableOptions: ['static', 'other', 'other_required', 'optional', 'alphabetize', 'randomize'],

	initialize: function initialize() {
		var that = this;

		if (!this.languages) {
			this.languages = __webpack_require__(74).Editor.instances[0].languages;
			this.lang_codes = $.map(this.languages.list, function (el, i) {
				return el.code;
			});
		}

		if (!this.presets || !this.custom) {
			this.lang_codes = $.map(this.languages.list, function (el, i) {
				return el.code;
			});
			this.presets = [];
			this.custom = [];

			$.ajax({
				async: false,
				url: bulkUrl,
				type: 'GET',
				dataType: 'json',
				data: {
					langs: $.map(this.languages.list, function (el, i) {
						return el.code;
					}),
					c: (0, _utils.randomString)(10)
				},
				success: function success(data) {
					that.presets = data.presets;
					that.custom = data.custom;
				}
			});
		}
	},

	buildLoadSelect: function buildLoadSelect(type, callback) {
		var that = this;

		var el = $('<select>', { id: 'bulk-selector', class: 'custom-select ml-2' });

		el.append($('<option>', { text: '---', value: '-' }));

		var presets = $('<optgroup>', { label: gettext('Presets') }).appendTo(el);

		$.each(this.presets, function (i, el) {
			if (el.type.indexOf(type) >= 0) {
				presets.append($('<option>', { text: el.name, value: el.name, data: { bulk: el.values, cust: false } }));
			}
		});

		if (this.custom.length) {
			var custom = $('<optgroup>', { label: gettext('Custom') }).appendTo(el);

			$.each(this.custom, function (i, el) {
				custom.append($('<option>', { text: el.name, value: el.id, data: { bulk: el.values, cust: true } }));
			});
		}

		el.val('-').bind('change', function (e) {
			that._cached_id = undefined;

			var option_el = $(this).find('option[value="' + $(this).val() + '"]');

			callback.apply(this, [option_el.data('bulk'), option_el.data('cust')]);

			return false;
		});

		return el;
	},

	buildTexts: function buildTexts() {
		var texts = {};

		$.each(this.languages.list, function (i, el) {
			texts[el.code] = $('<textarea/>').addClass('edit');
		});

		return texts;
	},

	setTextsFromValue: function setTextsFromValue(texts, value) {
		var langs = this.languages;
		var that = this;
		var defaultLanguage = this.languages.defaultLanguage().code;
		var printOptions = function printOptions(el) {
			//return a string to append options to bulk variables
			var options = [];
			if (el.score && el.score.value != undefined) {
				options.push(el.score.value);
			}
			$.each(that.availableOptions, function (i, keyword) {
				if (el[keyword] && el[keyword].value) {
					options.push(keyword);
				}
			});
			if (options.length > 0) {
				return ' | ' + options.join(' | ');
			}
			return '';
		};

		var addQuestionType = function addQuestionType(ele) {
			if (ele.type && ele.type.value) {
				return ' [[' + ele.type.value + ']]';
			}

			return '';
		};

		$.each(langs.list, function (i, el) {
			var code = el.code;
			texts[code].val($.map(value, function (ele, j) {
				//presets are just simple objects
				var text = (ele.text && ele.text.value ? ele.text.value : null) || ele;
				var variableId = '';

				if (ele.type !== undefined) {
					variableId = '[*A' + (j + 1) + '*] ';
				}

				if (text) {
					if (code === defaultLanguage) {
						return variableId + langs.translate(text, code) + addQuestionType(ele) + printOptions(ele);
					}
					return langs.translate(text, code);
				}
			}).join('\r\n'));
		});
	},

	valueFromTexts: function valueFromTexts(texts) {
		var val = {};

		$.each(this.languages.list, function (i, el) {
			val[el.code] = texts[el.code].val().split('\r\n').join('\n').split('\r').join('\n').split('\n');
		});

		var result = [];

		var defaultLang = this.languages.defaultLanguage();

		$.each(this.languages.list, function (i, el) {
			if (val[el.code].length != val[defaultLang.code].length) {
				throw interpolate(gettext('Bulk list for language "%s" does not have the same number of elements as the default language.'), [el.name]);
			}
		});

		for (var i = 0; i < val[defaultLang.code].length; i++) {
			result[i] = {};
			for (var j = 0; j < this.languages.list.length; j++) {
				result[i][this.languages.list[j].code] = val[this.languages.list[j].code][i];
			}
		}

		return result;
	},

	show: function show(type, value, callback) {
		var that = this,
		    allAttributes = value,
		    //value is now pased as all attributes so we can access scores + others
		dialog = $('<div>'),
		    langSelect = false,
		    needsIndex = false;

		var printOptions = function printOptions() {
			var options = new Set([]);
			$.each(Bulk.availableOptions, function (i, v) {
				$.each(allAttributes, function (j, attribute) {
					if (attribute[v]) {
						options.add(v);
					}
				});
			});

			return $('<ul/>').append(options.has('optional') ? $('<li/>').append(gettext('Make an item <b>optional</b> by appending "| optional" after the label (e.g. <b>Age | optional</b>)')) : false, options.has('alphabetize') || options.has('randomize') ? $('<li/>').append(gettext('<b>Randomize</b> or <b>alphabetize</b> the choices within a variable by appending ' + '"| randomize" or "| alphabetize" after the label. (e.g. <b>Preference | alphabetize</b>)')) : false, options.size == 0 ? $('<li/>').append(gettext('Add a <b>score</b> value to an item by appending "|" and the score after the label ' + '(e.g. <b>apples | 10</b>)')) : false);
		};

		value = $.map(value, function (el, i) {
			//map value to its original purpose
			return el.text.value;
		});

		this.initialize();

		if (allAttributes.length > 0 && allAttributes[0].type !== undefined) {
			needsIndex = true;
		}

		var bulk = this.buildTexts();
		var defaultLang = this.languages.defaultLanguage();

		this.setTextsFromValue(bulk, allAttributes);

		var loadSelect = this.buildLoadSelect(type, function (val, cust) {
			if (cust) {
				$('#bulk-name').val($('option:selected', this).text());
			} else {
				$('#bulk-name').val($('', this).text());
			}

			if ($(this).find(':selected').parent().prop('tagName').toLowerCase() == 'optgroup' && $(this).find(':selected').parent().attr('label') == 'Custom') that._cached_id = $(this).val();else that._cached_id = undefined;

			that.setTextsFromValue(bulk, val);
		});

		if (this.languages.list.length > 1) {
			langSelect = $('<select/>', { 'class': 'custom-select' });

			var curLang = false;
			var langLabel = '';

			$.each(this.languages.list, function (i, el) {
				if (el.code === defaultLang.code) {
					langLabel = $('<h3/>').addClass('bulk-current-lang').html(el.name);
				} else {
					$('<option/>', { value: el.code, text: el.name }).appendTo(langSelect);

					if (!curLang) {
						langSelect.val(curLang = el.code);
					}
				}
			});

			dialog.addClass('sidebyside');

			var loaded = langSelect.val();

			langSelect.change(function (e) {
				bulk[loaded].replaceWith(bulk[$(this).val()]);

				loaded = $(this).val();
			});
		}

		var nameInput = $('<input type="text" id="bulk-name" class="form-control" />');
		var buttons = [{
			cls: 'btn-primary',
			label: gettext('OK'),
			handler: function handler(modal) {
				try {
					var value = that.valueFromTexts(bulk);
				} catch (e) {

					new sma.components.Alert({
						message: e,
						type: 'danger'
					});

					return false;
				}

				var data = {
					name: nameInput.val(),
					values: JSON.stringify(value)
				};

				if (that._cached_id) {
					data.id = that._cached_id;
				}

				callback(value);
				modal.hide();
			}
		}, {
			'cls': 'btn-default',
			label: gettext('Cancel'),
			handler: function handler(modal) {
				modal.hide();
			}
		}, {
			'cls': 'btn-primary',
			label: gettext('Save'),
			handler: function handler(modal) {
				try {
					var value = that.valueFromTexts(bulk);
				} catch (e) {
					new sma.components.Alert({
						message: e,
						type: 'danger'
					});
					return false;
				}

				var data = {
					name: nameInput.val(),
					values: JSON.stringify(value)
				};

				if (that._cached_id) {
					data.id = that._cached_id;
				}

				if (nameInput.val()) {
					$.ajax({
						async: false,
						url: bulkUrl,
						type: 'POST',
						dataType: 'json',
						data: data,
						success: function success(data) {
							if (!data.success) {
								throw new Error();
							}
							if (that._cached_id) {
								for (var i = 0; i < that.custom.length; i++) {
									if (that.custom[i].id == that._cached_id) {
										that.custom[i].values = value;
										that.custom[i].name = nameInput.val();
										$('.bulk option[value=' + that.custom[i].id + ']').text(that.custom[i].name).data('bulk', that.custom[i].values);
										break;
									}
								}
							} else {
								that.custom.push({ id: data.bulk, name: nameInput.val(), values: value });
								$('.bulk optgroup[label=Custom]').append($('<option>', { text: nameInput.val(), value: data.bulk, data: { bulk: value, cust: true } }));
							}

							new sma.components.Alert({
								message: gettext("Bulk List Saved Successfully"),
								type: 'success'
							});
						}
					});
				} else {
					new sma.components.Alert({
						message: gettext("Bulk List Name Required"),
						type: 'danger'
					});
				}
			}
		}, {
			'cls': 'btn-danger',
			label: gettext('Delete'),
			handler: function handler(modal) {

				if ($(':selected', 'optgroup[label=Custom]').length == 1) {
					if (nameInput.val() != $(':selected', 'optgroup[label=Custom]').html()) {
						nameInput.val("");
					}
				}

				if (!nameInput.val()) {
					if ($(':selected', 'optgroup[label=Custom]').length == 1) {
						nameInput.val($(':selected', 'optgroup[label=Custom]').html());
					}
				}

				if (nameInput.val()) {
					try {
						var value = that.valueFromTexts(bulk);
					} catch (e) {
						return false;
					}

					var data = {
						name: nameInput.val(),
						action: 'delete',
						values: JSON.stringify(value)
					};

					if (that._cached_id) {
						data.id = that._cached_id;
					}

					var outerscope = this;

					new Modals.Confirm(gettext('Delete List'), gettext("Are you sure you'd like to delete this list? This action cannot be undone."), function () {
						$.ajax({
							async: false,
							url: bulkUrl,
							type: 'POST',
							dataType: 'json',
							data: data,
							success: function success(data) {
								if (!data.success) {
									throw new Error();
								}
								// lazy way of making custom bulks reload next time the dialog is shown
								that._cached_id = undefined;
								that.custom = undefined;
								modal.hide();
							}
						});
					});

					callback(value);
				} else {
					alert(gettext('Cannot delete non-custom bulk presets'));
				}
				that.custom = undefined;
				that._cached_id = undefined;
			}
		}];

		var modalOptions = {
			title: gettext('Bulk Editor'),
			buttons: buttons,
			autoShow: true,
			destroyOnClose: true
		};

		var bulkEdit = $('<div class="row mb-3 mt-5"></div>').append($('<div class="col-6">', { 'class': 'lang clearfix' }).append(langLabel)).append($('<div class="col-6">', { 'class': 'lang clearfix' }).append(langSelect));

		var modalContent = $('<div/>').append($('<p/>').append('<label for="bulk-selector">' + gettext('Load preset or saved bulk:') + '<\/label>', loadSelect), $('<p/>').append('<label for="bulk-name">' + gettext('Enter a name to save as custom:') + '<\/label>', nameInput), needsIndex ? $('<div/>').append(gettext('Specify the variable type with "[[type]]" after the label. Type options are: single, dropdown, checkbox, and string.')) : false, $('<p/>').append($('<b/>').append("</br>" + gettext("Options:"))), printOptions(), needsIndex ? $('<div class="callout callout-warning" role="alert"/>').append(gettext("<b>Do not modify the identifier shown at the beginning of each item (e.g. [*A1*]).</b> " + "If you want to change the order, select and move the entire line including the identifier. " + "Additionally, when adding a new item, do not include an identifier.")) : false, langSelect ? bulkEdit : false, $('<div>', { 'class': 'row' }).append($('<p/>', { 'class': 'col-6 edit bulk-edit' }).append(bulk[defaultLang.code])).append(langSelect ? $('<p>', { 'class': 'col-6 edit bulk-edit' }).append(bulk[langSelect.val()]) : false));

		var modal = new Modals.ContentModal(modalContent, modalOptions);
	}
};

module.exports = {
	Bulk: Bulk,
	Option: Option
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(88);
var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(134) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(90);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(13);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(52);
var SPECIES = __webpack_require__(30)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(6);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _piper = __webpack_require__(1566);

var _piper2 = _interopRequireDefault(_piper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ajax = __webpack_require__(4);

var PipingModal = function (_Backbone$View) {
	_inherits(PipingModal, _Backbone$View);

	function PipingModal() {
		_classCallCheck(this, PipingModal);

		return _possibleConstructorReturn(this, (PipingModal.__proto__ || Object.getPrototypeOf(PipingModal)).apply(this, arguments));
	}

	_createClass(PipingModal, [{
		key: 'initialize',
		value: function initialize(options) {
			this.context = options.context || null;
			if (typeof this.context === 'string') {
				this.context = [this.context];
			}
			this.froala = options.froala || null;
			this.$textField = options.$textField || null;
			this.fromModal = options.fromModal || false;
			this.updateQueue = this.updateQueue.bind(this);

			this.createModal();
		}
	}, {
		key: 'createModal',
		value: function createModal() {
			var _this2 = this;

			var modalContent = '<div id="sma-js-piping-container"></div>';

			this.modal = new _modals.ContentModal(modalContent, {
				destroyOnClose: true,
				size: 'md',
				title: gettext('Add piping'),
				fromModal: this.fromModal,
				buttons: [{
					label: gettext('Cancel'),
					cls: 'btn btn-link btn-loud',
					handler: function handler(modal) {
						modal.hide();
					}
				}, {
					label: gettext('Add'),
					cls: 'btn btn-primary btn-loud',
					handler: function handler(modal) {
						_this2.submitQueue();
						modal.hide();
					}
				}]
			});

			this.setElement(this.modal.modalWindow);
			this.loadData();
		}
	}, {
		key: 'submitQueue',
		value: function submitQueue() {
			var delimSelectElement = document.getElementById('sma-js-pipes-delim-selector');
			var delim = delimSelectElement ? delimSelectElement.value : null;

			if (this.froala) {
				this.froala.insertText(this.queue.map(function (variable) {
					var value = variable.value;


					if (variable.isMulti && delim) {
						value = value + '__' + delim;
					}

					return {
						label: variable.label,
						group: variable.group,
						value: value
					};
				}), this.$textField);
			} else {
				var existingContent = this.$textField.val();
				var tags = this.queue.map(function (variable) {
					var value = variable.value;


					if (variable.isMulti && delim) {
						value = value + '__' + delim;
					}

					return '{{ ' + value + ' }}';
				}).join(' ');

				this.$textField.val(existingContent + tags);
			}
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this3 = this;

			ajax.get({
				url: reverse('pipes-index'),
				data: {
					context: this.context
				},
				callback: function callback(data) {
					_this3.injectReact(data.result);
				}
			});
		}
	}, {
		key: 'updateQueue',
		value: function updateQueue(newQueue) {
			this.queue = newQueue;
		}
	}, {
		key: 'injectReact',
		value: function injectReact(data) {
			_reactDom2.default.render(_react2.default.createElement(_piper2.default, {
				data: data,
				updateQueue: this.updateQueue
			}), document.getElementById('sma-js-piping-container'));

			this.modal.show();
		}
	}]);

	return PipingModal;
}(Backbone.View);

// activate all piping text fields


$(function () {
	$('.sma-js-piping-text-button').each(function (i, item) {
		var $pipingButton = $(item);

		var contextString = $pipingButton.attr('data-context');

		if (contextString) {
			var context = contextString.split(' ');
		} else {
			var context = null;
		}

		$pipingButton.on('click', function () {
			this.modal = new PipingModal({
				context: context,
				$textField: $pipingButton.parent().find('input')
			});
		});
	});
});

module.exports = PipingModal;

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (noop);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(69);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(55);




/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex, customizer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */])(source), object, customizer);
});

/* harmony default export */ __webpack_exports__["a"] = (assignInWith);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPlainObject_js__ = __webpack_require__(123);




/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value)) {
    return false;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPlainObject_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (isError);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__ = __webpack_require__(947);


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = Object(__WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__["a" /* default */])('toUpperCase');

/* harmony default export */ __webpack_exports__["a"] = (upperFirst);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(962);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__ = __webpack_require__(342);







/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = Object(__WEBPACK_IMPORTED_MODULE_3__arrayMap_js__["a" /* default */])(values, Object(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(iteratee));
  }
  if (comparator) {
    includes = __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */];
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */];
    isCommon = false;
    values = new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */](values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseDifference);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__last_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parent_js__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(106);






/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = Object(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);
  object = Object(__WEBPACK_IMPORTED_MODULE_3__parent_js__["a" /* default */])(object, path);
  var func = object == null ? object : object[Object(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__last_js__["a" /* default */])(path))];
  return func == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, object, args);
}

/* harmony default export */ __webpack_exports__["a"] = (baseInvoke);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsRegExp_js__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsRegExp = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsRegExp) : __WEBPACK_IMPORTED_MODULE_0__baseIsRegExp_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isRegExp);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(106);






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return object;
  }
  path = Object(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(objValue)
          ? objValue
          : (Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(path[index + 1]) ? [] : {});
      }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSet);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseProperty_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseTimes_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__ = __webpack_require__(50);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(array, function(group) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */])(group)) {
      length = nativeMax(group.length, length);
      return true;
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_3__baseTimes_js__["a" /* default */])(length, function(index) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_2__baseProperty_js__["a" /* default */])(index));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (unzip);


/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(76);
var toLength = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(161);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 286 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(90);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(91);
var defined = __webpack_require__(99);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(24);
var cof = __webpack_require__(90);
var MATCH = __webpack_require__(30)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(30)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(188);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(876);
var redefine = __webpack_require__(66);
var hide = __webpack_require__(65);
var fails = __webpack_require__(21);
var defined = __webpack_require__(99);
var wks = __webpack_require__(30);
var regexpExec = __webpack_require__(431);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(66);
var redefineAll = __webpack_require__(167);
var meta = __webpack_require__(135);
var forOf = __webpack_require__(166);
var anInstance = __webpack_require__(165);
var isObject = __webpack_require__(24);
var fails = __webpack_require__(21);
var $iterDetect = __webpack_require__(290);
var setToStringTag = __webpack_require__(187);
var inheritIfRequired = __webpack_require__(417);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var hide = __webpack_require__(65);
var uid = __webpack_require__(159);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(134) || !__webpack_require__(21)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(18)[K];
});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(52);
var ctx = __webpack_require__(89);
var forOf = __webpack_require__(166);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1443);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backbone = __webpack_require__(40);

var Backbone = _interopRequireWildcard(_backbone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This component can NOT go within a custom-select.
// There's a focus event that will close this component, making thee events useless.
var MultiSelectSearch = function (_Backbone$View) {
	_inherits(MultiSelectSearch, _Backbone$View);

	function MultiSelectSearch() {
		_classCallCheck(this, MultiSelectSearch);

		return _possibleConstructorReturn(this, (MultiSelectSearch.__proto__ || Object.getPrototypeOf(MultiSelectSearch)).apply(this, arguments));
	}

	_createClass(MultiSelectSearch, [{
		key: 'updateDropdownText',
		value: function updateDropdownText(component) {
			var checkedLabels = $(component).find('.sma-checkbox-input:checked').next();
			var dropdownButton = $(component).find('.sma-multi-select-dropdown-button');

			var dropdownButtonText = gettext('Select...');
			if (checkedLabels.length == 1) {
				dropdownButtonText = checkedLabels.first().text();
			} else if (checkedLabels.length > 1) {
				dropdownButtonText = interpolate(ngettext('%(label)s  (+%(num)s item)', '%(label)s  (+%(num)s items)', checkedLabels.length - 1), {
					label: checkedLabels.first().text(),
					num: checkedLabels.length - 1
				}, true);

				var titleText = checkedLabels.map(function () {
					return $(this).text();
				}).get().join(', ');

				dropdownButton.attr('title', titleText);
			}

			dropdownButton.text(dropdownButtonText);
		}
	}, {
		key: 'initialize',
		value: function initialize(config) {
			var _this2 = this;

			this.setElement($('body'));

			$('.sma-multi-select-dropdown').each(function (i, component) {
				_this2.updateDropdownText(component);
			});
		}
	}, {
		key: 'clickedContainer',
		value: function clickedContainer(e) {
			e.stopPropagation();
		}
	}, {
		key: 'clickedDone',
		value: function clickedDone(e) {
			$(e.currentTarget).dropdown('toggle');
		}
	}, {
		key: 'checkboxChanged',
		value: function checkboxChanged(e) {
			var count = $(e.currentTarget).closest('.sma-multi-select-menu').find('input:checked').length;
			var minCount = $(e.currentTarget).closest('.sma-multi-select-menu').data('min_count');
			if (minCount && count < minCount) {
				$(e.currentTarget).prop('checked', true);
				return;
			}
			$(e.currentTarget).closest('.sma-multi-select-container').find('.sma-multi-select-selected-count').text(count);

			this.updateDropdownText($(e.currentTarget).closest('.sma-multi-select-dropdown'));

			e.stopPropagation();
		}
	}, {
		key: 'onSearchInput',
		value: function onSearchInput(e) {
			var checkboxes = $(e.currentTarget).closest('.sma-multi-select-menu').find('.sma-multi-select-row');
			var searchTerm = $(e.currentTarget).closest('.sma-multi-select-menu').find('.sma-multi-select-search').val().toLowerCase();

			checkboxes.each(function (i, checkbox) {
				if ($(checkbox).find('label').text().toLowerCase().includes(searchTerm)) {
					$(checkbox).show();
				} else {
					$(checkbox).hide();
				}
			});
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-multi-select-menu': 'clickedContainer',
				'click .sma-multi-select-done': 'clickedDone',
				'change .sma-multi-select-dropdown .sma-checkbox-input': 'checkboxChanged',
				'input .sma-multi-select-search': 'onSearchInput'
			};
		}
	}]);

	return MultiSelectSearch;
}(Backbone.View);

module.exports = {
	MultiSelectSearch: MultiSelectSearch
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var requirementsTempl = __webpack_require__(1621);

var Strings = {
	helptext: gettext('Your password must contain at least'),
	chars: gettext('8 characters'),
	lowercase: gettext('One lowercase letter'),
	uppercase: gettext('One uppercase letter'),
	number: gettext('One number'),
	specchar: gettext('One special character'),
	show: gettext('Show password'),
	hide: gettext('Hide password')
};

var PasswordEye = function (_Backbone$View) {
	_inherits(PasswordEye, _Backbone$View);

	function PasswordEye() {
		_classCallCheck(this, PasswordEye);

		return _possibleConstructorReturn(this, (PasswordEye.__proto__ || Object.getPrototypeOf(PasswordEye)).apply(this, arguments));
	}

	_createClass(PasswordEye, [{
		key: 'initialize',
		value: function initialize(element) {
			$(element).wrap('<div class="sma-input-icon-right"></div>');
			$(element).after('<i class="nc-icon-mini ui-1_eye-19 sma-pwd-view sma-js-pwd-view" aria-hidden="true"></i>');

			this.setElement(element.parent());

			this.STATES = {
				visible: 0,
				hidden: 1
			};

			this.state = this.STATES.hidden;
		}
	}, {
		key: 'showPassword',
		value: function showPassword(e) {
			e.preventDefault();

			$(e.currentTarget).toggleClass('ui-1_eye-19, ui-1_eye-ban-20');

			var input = this.$el.find('input');

			if (input.prop('type') == 'password') {
				input.prop('type', 'text');
			} else {
				input.prop('type', 'password');
			}

			input.focus();
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-pwd-view': 'showPassword'
			};
		}
	}]);

	return PasswordEye;
}(Backbone.View);

var Strength = Backbone.View.extend({
	strongRe: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\-!@#\$%\^&\*\)\(+=._,;:'\"\<\>/|}{\[\\\]\~\`\? \\\\])(?=.{8,})"),

	lowercaseRe: new RegExp("(?=.*[a-z])"),
	uppercaseRe: new RegExp("(?=.*[A-Z])"),
	numberRe: new RegExp("(?=.*[0-9])"),
	speccharRe: new RegExp("(?=.*[\-!@#\$%\^&\*\)\(+=._,;:'\"\<\>/|}{\[\\\]\~\`\? \\\\])"),

	events: {
		'input': 'onKeyup',
		'blur': 'onBlur',
		'focus': 'onKeyup'
	},

	initialize: function initialize(config) {
		var _this2 = this;

		this.setElement(config.element[0]);
		this.element = config.element;
		this.confirm = config.confirm;

		if (this.confirm) {
			this.confirm.prop('disabled', true);

			this.confirm.keyup(_.debounce(function () {
				_this2.checkConfirm();
			}, 100));
		}

		new PasswordEye(this.element);
		new PasswordEye(this.confirm);

		var popoverTemplate = '<div class="popover hidden-sm-down" role="tooltip">\
			<div class="popover-arrow"></div>\
			<div class="popover-content"></div></div>';

		this.element.popover({
			html: true,
			content: requirementsTempl({ strings: Strings }),
			container: 'body',
			trigger: 'focus',
			template: popoverTemplate
		});

		var reqString = Strings.helptext + ': ' + Strings.chars + ', ' + Strings.uppercase + ', ' + Strings.lowercase + ', ' + Strings.number + ', ' + Strings.specchar;
		this.element.parent().after('<div class="hidden-sm-up">' + reqString + '</div>');
	},
	getStrengthElement: function getStrengthElement() {
		return $('.sma-js-pwd-strength-reqs');
	},
	onBlur: function onBlur() {
		this.checkConfirm();
	},
	requirementMet: function requirementMet(cls) {
		this.getStrengthElement().find(cls).find('i').removeClass('ui-1_bold-delete').addClass('ui-1_check-simple');
	},
	requirementNotMet: function requirementNotMet(cls) {
		this.getStrengthElement().find(cls).find('i').addClass('ui-1_bold-delete').removeClass('ui-1_check-simple');
	},
	checkConfirm: function checkConfirm() {
		if (!this.confirm) {
			return;
		}

		this.confirm.removeClass('bad');
		this.confirm.removeClass('good');

		if (this.element.val()) {
			if (this.element.val() != this.confirm.val()) {
				this.confirm.addClass('bad');
			} else {
				this.confirm.addClass('good');
			}
		}
	},


	onKeyup: _.debounce(function (e) {
		var value = $(e.currentTarget).val();
		value = value.trim();

		this.element.removeClass('bad');
		this.element.removeClass('okay');
		this.element.removeClass('good');

		if (!value || value.length < 8) {
			this.element.addClass('bad');
			this.requirementNotMet('.sma-js-pwd-chars');
		} else {
			this.requirementMet('.sma-js-pwd-chars');
		}

		if (this.lowercaseRe.test(value)) {
			this.requirementMet('.sma-js-pwd-lowercase');
		} else {
			this.requirementNotMet('.sma-js-pwd-lowercase');
		}

		if (this.uppercaseRe.test(value)) {
			this.requirementMet('.sma-js-pwd-uppercase');
		} else {
			this.requirementNotMet('.sma-js-pwd-uppercase');
		}

		if (this.numberRe.test(value)) {
			this.requirementMet('.sma-js-pwd-number');
		} else {
			this.requirementNotMet('.sma-js-pwd-number');
		}

		if (this.speccharRe.test(value)) {
			this.requirementMet('.sma-js-pwd-specchar');
		} else {
			this.requirementNotMet('.sma-js-pwd-specchar');
		}

		if (this.strongRe.test(value)) {
			this.confirm.prop('disabled', false);

			if (value.length > 8) {
				this.element.addClass('good');
			} else {
				this.element.addClass('okay');
			}

			return;
		}

		this.confirm.prop('disabled', true);
		this.element.addClass('bad');
	}, 100)
});

module.exports = {
	Strength: Strength,
	PasswordEye: PasswordEye
};

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var blockPartial = __webpack_require__(1647);

var block = function block(elem, msg) {
	msg = msg || '';

	var $blockedElement = $(blockPartial({ msg: msg }));
	elem.addClass('blocked-element').prepend($blockedElement);

	$blockedElement.css("width", elem.width() + 'px');
	$blockedElement.css("height", elem.height() + 'px');
	elem.css("pointer-events", "none");
};

var unblock = function unblock(elem) {
	elem.find('.form-block').remove();
	elem.removeClass('blocked-element');
	elem.css("pointer-events", "auto");
};

module.exports = {
	block: block,
	unblock: unblock
};

/***/ }),
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ajax = __webpack_require__(4);
var modals = __webpack_require__(6);

var SubmitConfirm = function (_modals$Modal) {
	_inherits(SubmitConfirm, _modals$Modal);

	_createClass(SubmitConfirm, [{
		key: 'cls',
		get: function get() {
			return 'sma-modal sma-modal-confirm sma-modal-confirm-application sma-automation-popup-modal';
		}
	}]);

	function SubmitConfirm(options) {
		_classCallCheck(this, SubmitConfirm);

		var _this = _possibleConstructorReturn(this, (SubmitConfirm.__proto__ || Object.getPrototypeOf(SubmitConfirm)).call(this));

		var appId = options.appId;


		var title = options.title || gettext('Submit application');
		var description = options.description || gettext('Please confirm submission of your application.<br><br>If you wish to take a look at the application before submitting, please <b>Review</b> it.');
		var hideReviewButton = options.hideReviewButton || false;

		var url = reverse('application-save', { app_id: appId });
		var reviewUrl = reverse('application-submit-preview', { app_id: appId });

		var buttons = [{
			cls: 'float-left btn-secondary',
			id: 'sma-btn-modal-no',
			label: gettext('Cancel'),
			handler: function handler() {
				_this.hide();

				setTimeout(function () {
					_this.destroy();
				}, 1000);
			}
		}, hideReviewButton ? null : {
			cls: 'btn-secondary',
			id: 'sma-btn-modal-other',
			label: gettext('Review'),
			handler: function handler() {
				window.location.href = reviewUrl;
			}
		}, {
			cls: 'btn-primary',
			id: 'sma-btn-modal-yes',
			label: gettext('Submit'),
			handler: function handler() {
				ajax.post({
					url: url,
					alertOnSuccess: false,
					alwaysCallback: true,
					callback: function callback(response) {
						if (response.success) {
							window.location.href = reverse('application-completion-message', {
								app_id: response.app_id,
								round_id: response.round_id
							});
						} else {
							_this.hide();
							if (_this.useButtonLoaders) {
								_this.buttons.map(function (button) {
									return button.hideLoader();
								});
							}
							setTimeout(function () {
								_this.destroy();
							}, 1000);
						}
					}
				});
			}
		}].filter(function (btn) {
			return btn !== null;
		});

		_this.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: buttons,
			useButtonLoaders: true
		});

		_this.element = $('<div class="sma-modal-desc"></div>').html(description);

		_this.setElement(_this.element[0]);

		_this.render();
		_this.show();
		return _this;
	}

	return SubmitConfirm;
}(modals.Modal);

module.exports = SubmitConfirm;

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToNumber_js__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__(103);



/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(value);
        other = Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(other);
      } else {
        value = Object(__WEBPACK_IMPORTED_MODULE_0__baseToNumber_js__["a" /* default */])(value);
        other = Object(__WEBPACK_IMPORTED_MODULE_0__baseToNumber_js__["a" /* default */])(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createMathOperation);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWrap_js__ = __webpack_require__(117);


/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return Object(__WEBPACK_IMPORTED_MODULE_0__createWrap_js__["a" /* default */])(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

/* harmony default export */ __webpack_exports__["a"] = (ary);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(36);



/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result) ? result : thisBinding;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCtor);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (baseLodash);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(201);


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(array, value, 0) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayIncludes);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(55);




/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source) {
  Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */])(source), object);
});

/* harmony default export */ __webpack_exports__["a"] = (assignIn);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(481);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1852);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(69);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1854);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(array, 1) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (flatten);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isError_js__ = __webpack_require__(250);




/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(func, args) {
  try {
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, undefined, args);
  } catch (e) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__isError_js__["a" /* default */])(e) ? e : new Error(e);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (attempt);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(945);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_js__ = __webpack_require__(16);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_js__["a" /* default */])(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (before);


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createWrap_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__ = __webpack_require__(174);





/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = Object(__WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__["a" /* default */])(partials, Object(__WEBPACK_IMPORTED_MODULE_2__getHolder_js__["a" /* default */])(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__createWrap_js__["a" /* default */])(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (bind);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upperFirst_js__ = __webpack_require__(251);



/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__upperFirst_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(string).toLowerCase());
}

/* harmony default export */ __webpack_exports__["a"] = (capitalize);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(25);



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = Object(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(string);
  return string && string.replace(reLatin, __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__["a" /* default */]).replace(reComboMark, '');
}

/* harmony default export */ __webpack_exports__["a"] = (deburr);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiWords_js__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toString_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__ = __webpack_require__(1864);





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = Object(__WEBPACK_IMPORTED_MODULE_2__toString_js__["a" /* default */])(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__["a" /* default */])(string) ? Object(__WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__["a" /* default */])(string) : Object(__WEBPACK_IMPORTED_MODULE_0__asciiWords_js__["a" /* default */])(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (words);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperLodash_js__ = __webpack_require__(171);


/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__wrapperLodash_js__["a" /* default */])(value);
  result.__chain__ = true;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (chain);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1869);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsSet = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsSet) : __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isSet);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LodashWrapper_js__ = __webpack_require__(172);


/**
 * Executes the chain sequence and returns the wrapped result.
 *
 * @name commit
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2];
 * var wrapped = _(array).push(3);
 *
 * console.log(array);
 * // => [1, 2]
 *
 * wrapped = wrapped.commit();
 * console.log(array);
 * // => [1, 2, 3]
 *
 * wrapped.last();
 * // => 3
 *
 * console.log(array);
 * // => [1, 2, 3]
 */
function wrapperCommit() {
  return new __WEBPACK_IMPORTED_MODULE_0__LodashWrapper_js__["a" /* default */](this.value(), this.__chain__);
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperCommit);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(1884);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(106);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayAggregator_js__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAggregator_js__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayAggregator_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseAggregator_js__["a" /* default */],
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 2), accumulator);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createAggregator);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(104);




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(55);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(203);



/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex, customizer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex, customizer);
});

/* harmony default export */ __webpack_exports__["a"] = (mergeWith);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);


/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

/* harmony default export */ __webpack_exports__["a"] = (baseWhile);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forEach);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEachRight_js__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEachRight_js__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEachRight_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEachRight_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forEachRight);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createToPairs_js__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = Object(__WEBPACK_IMPORTED_MODULE_0__createToPairs_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (toPairs);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createToPairs_js__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(55);



/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = Object(__WEBPACK_IMPORTED_MODULE_0__createToPairs_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (toPairsIn);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escapeHtmlChar_js__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(25);



/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = Object(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, __WEBPACK_IMPORTED_MODULE_0__escapeHtmlChar_js__["a" /* default */])
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (escape);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(value), 0, MAX_ARRAY_LENGTH) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toLength);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3), index);
}

/* harmony default export */ __webpack_exports__["a"] = (findIndex);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3), index, true);
}

/* harmony default export */ __webpack_exports__["a"] = (findLastIndex);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (head);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(94);



/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(props, function(key) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(object[key]);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseFunctions);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(104);


/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
      other = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(other);
    }
    return operator(value, other);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createRelationalOperation);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_js__ = __webpack_require__(16);


/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isInteger);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == numberTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isNumber);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(68);


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseExtremum);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFunctions_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keys_js__ = __webpack_require__(41);








/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin(object, source, options) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_6__keys_js__["a" /* default */])(source),
      methodNames = Object(__WEBPACK_IMPORTED_MODULE_2__baseFunctions_js__["a" /* default */])(source, props);

  var chain = !(Object(__WEBPACK_IMPORTED_MODULE_5__isObject_js__["a" /* default */])(options) && 'chain' in options) || !!options.chain,
      isFunc = Object(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(object);

  Object(__WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */])(methodNames, function(methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function() {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
              actions = result.__actions__ = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(this.__actions__);

          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, Object(__WEBPACK_IMPORTED_MODULE_1__arrayPush_js__["a" /* default */])([this.value()], arguments));
      };
    }
  });

  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (mixin);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toArray_js__ = __webpack_require__(367);


/**
 * Gets the next value on a wrapped object following the
 * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
 *
 * @name next
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the next iterator value.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 1 }
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 2 }
 *
 * wrapped.next();
 * // => { 'done': true, 'value': undefined }
 */
function wrapperNext() {
  if (this.__values__ === undefined) {
    this.__values__ = Object(__WEBPACK_IMPORTED_MODULE_0__toArray_js__["a" /* default */])(this.value());
  }
  var done = this.__index__ >= this.__values__.length,
      value = done ? undefined : this.__values__[this.__index__++];

  return { 'done': done, 'value': value };
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperNext);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isString_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iteratorToArray_js__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapToArray_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setToArray_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__values_js__ = __webpack_require__(151);











/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__isString_js__["a" /* default */])(value) ? Object(__WEBPACK_IMPORTED_MODULE_8__stringToArray_js__["a" /* default */])(value) : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(value);
  }
  if (symIterator && value[symIterator]) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__iteratorToArray_js__["a" /* default */])(value[symIterator]());
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_2__getTag_js__["a" /* default */])(value),
      func = tag == mapTag ? __WEBPACK_IMPORTED_MODULE_6__mapToArray_js__["a" /* default */] : (tag == setTag ? __WEBPACK_IMPORTED_MODULE_7__setToArray_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__values_js__["a" /* default */]);

  return func(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toArray);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basePickBy_js__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getAllKeysIn_js__ = __webpack_require__(495);





/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__getAllKeysIn_js__["a" /* default */])(object), function(prop) {
    return [prop];
  });
  predicate = Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate);
  return Object(__WEBPACK_IMPORTED_MODULE_2__basePickBy_js__["a" /* default */])(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (pickBy);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createWrap_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__ = __webpack_require__(174);





/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(func, partials) {
  var holders = Object(__WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__["a" /* default */])(partials, Object(__WEBPACK_IMPORTED_MODULE_2__getHolder_js__["a" /* default */])(partial));
  return Object(__WEBPACK_IMPORTED_MODULE_1__createWrap_js__["a" /* default */])(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (partial);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseLodash_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapperClone_js__ = __webpack_require__(937);



/**
 * Creates a clone of the chain sequence planting `value` as the wrapped value.
 *
 * @name plant
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @param {*} value The value to plant.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2]).map(square);
 * var other = wrapped.plant([3, 4]);
 *
 * other.value();
 * // => [9, 16]
 *
 * wrapped.value();
 * // => [1, 4]
 */
function wrapperPlant(value) {
  var result,
      parent = this;

  while (parent instanceof __WEBPACK_IMPORTED_MODULE_0__baseLodash_js__["a" /* default */]) {
    var clone = Object(__WEBPACK_IMPORTED_MODULE_1__wrapperClone_js__["a" /* default */])(parent);
    clone.__index__ = 0;
    clone.__values__ = undefined;
    if (result) {
      previous.__wrapped__ = clone;
    } else {
      result = clone;
    }
    var previous = clone;
    parent = parent.__wrapped__;
  }
  previous.__wrapped__ = value;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperPlant);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePullAll_js__ = __webpack_require__(647);


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__basePullAll_js__["a" /* default */])(array, values)
    : array;
}

/* harmony default export */ __webpack_exports__["a"] = (pullAll);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

/* harmony default export */ __webpack_exports__["a"] = (reverse);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRandom_js__ = __webpack_require__(652);


/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = Object(__WEBPACK_IMPORTED_MODULE_0__baseRandom_js__["a" /* default */])(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (shuffleSelf);


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedIndexBy_js__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isSymbol_js__ = __webpack_require__(68);




/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !Object(__WEBPACK_IMPORTED_MODULE_2__isSymbol_js__["a" /* default */])(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedIndexBy_js__["a" /* default */])(array, value, __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */], retHighest);
}

/* harmony default export */ __webpack_exports__["a"] = (baseSortedIndex);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escape_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reEscape_js__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reEvaluate_js__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reInterpolate_js__ = __webpack_require__(991);





/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': __WEBPACK_IMPORTED_MODULE_1__reEscape_js__["a" /* default */],

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': __WEBPACK_IMPORTED_MODULE_2__reEvaluate_js__["a" /* default */],

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': __WEBPACK_IMPORTED_MODULE_3__reInterpolate_js__["a" /* default */],

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': __WEBPACK_IMPORTED_MODULE_0__escape_js__["a" /* default */] }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (templateSettings);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Enables the wrapper to be iterable.
 *
 * @name Symbol.iterator
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the wrapper object.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped[Symbol.iterator]() === wrapped;
 * // => true
 *
 * Array.from(wrapped);
 * // => [1, 2]
 */
function wrapperToIterator() {
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperToIterator);


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unzip_js__ = __webpack_require__(258);




/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = Object(__WEBPACK_IMPORTED_MODULE_2__unzip_js__["a" /* default */])(array);
  if (iteratee == null) {
    return result;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(result, function(group) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(iteratee, undefined, group);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (unzipWith);


/***/ }),
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ajax = __webpack_require__(4);

var EmailVerification = function (_Backbone$View) {
	_inherits(EmailVerification, _Backbone$View);

	function EmailVerification(config) {
		_classCallCheck(this, EmailVerification);

		var _this = _possibleConstructorReturn(this, (EmailVerification.__proto__ || Object.getPrototypeOf(EmailVerification)).call(this));

		_this.setElement($('.sma-js-unverified-email-notification'));
		return _this;
	}

	_createClass(EmailVerification, [{
		key: 'resendEmailVerification',
		value: function resendEmailVerification(e) {
			e.preventDefault();

			ajax.post({
				url: reverse('resend-email-verification'),
				callback: function callback(response) {
					$('.sma-js-unverified-email-notification').remove();
				}
			});
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-send-verification': 'resendEmailVerification'
			};
		}
	}]);

	return EmailVerification;
}(Backbone.View);

module.exports = EmailVerification;

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Class = __webpack_require__(157);
var chide = __webpack_require__(230);
var Fields = __webpack_require__(844);
var Option = __webpack_require__(231).Option;
var modals = __webpack_require__(6);
var Survey = __webpack_require__(74).Survey;

var Branching = $.klass({});

Branching.Simple = $.klass({
	getChoicesForField: function getChoicesForField(field) {
		return this.getChoicesForPage(field.page.index);
	},

	getChoicesForPage: function getChoicesForPage(page) {
		var choices = [[-1, '---']];
		var survey = Survey.instances[0];

		$.each(survey.pages.slice(page + 1), function (_i) {
			choices.push([this.id, interpolate(gettext('Page %(page_label)s'), {
				page_label: this.label && this.label.length ? survey.editor.languages.translate(this.label, survey.editor.languages.selected()) : this.index + 1
			}, true)]);
		});

		choices.push(['terminate', gettext('Termination Page')]);
		choices.push(['finish', gettext('The Finish Page')]);

		return choices;
	},

	isValid: function isValid(field) {
		var result = true;
		if (field.choices) {
			$.each(field.choices.value, function (i, value) {
				if (value.branching && value.branching.value != '' && value.branching.value <= field.page.index) {
					result = false;
				}
			});
		}
		return result;
	},

	reset: function reset(field) {
		if (field.choices) {
			$.each(field.choices.value, function (i, value) {
				if (value.branching) {
					value.branching.value = '';
				}
			});
		}
	}
});

Branching.Simple.Rule = Class.create(chide.opts.Single, {
	enabled: true,
	label: gettext('Branch to'),
	help: gettext('About Simple Branching - Simple branching allows you to skip the survey to a different page based on the responses to this question.'),
	renderChoices: function renderChoices() {
		return (this.page || this.field.page).getBranchingSelect();
	},
	changed: function changed(val) {
		if (val) {
			$('#page-skip-image').show();
		}
	},
	getPage: function getPage() {
		var e = this.page || this.field.page;

		var page = Fields.Helpers.getPageIndexByPageId(this.value);

		if (page === undefined || page === '' || page === '-1') {
			return undefined;
		}

		if (parseInt(page, 10) === page && (page < e.index || page >= Survey.instances[0].pages.length)) {
			return undefined;
		}

		return page;
	}
});

var Extraction = $.klass(Option.Value, {
	classes: 'option',
	help: gettext('About Extraction - The choices for this question are determined based on a user\'s answers to a previous question. The question to be extracted from must have an identifier assigned to it.'),

	initialize: function initialize($super, field, config) {
		var Survey = __webpack_require__(74).Survey;

		var that = this;
		this.survey = Survey.instances[0];

		$super(field, config);
		this.config = config;
		if (!this.value || !this.value.question) {
			this.value = undefined;
		}

		this.question = new Option.Radio(field, {
			classes: 'option',
			display: 'dropdown',
			value: this.value ? this.value.question : undefined,

			getField: function getField() {
				return this.value ? this.editor.survey.nameMapping[this.value] : undefined;
			},

			changed: function changed(value) {
				if (value) {
					var field = that.editor.survey.nameMapping[value];
					that.value = { question: value };
					that.setExtractionOptions(field);
				} else {
					that.value = undefined;
					that.options = undefined;
					that.optionsPlaceholder.hide().empty();
					that.choiceOptionsPlaceholder.hide();
				}
			}
		});

		this.extractChoicesUI = new chide.opts.Checkbox({
			value: this.value ? this.value.extractChoices : false,
			label: gettext('Extract Choices'),
			help: gettext('About Extract Choices - If selected, this will extract choices from a dropdown menu or MC question instead of the variable label.')
		});

		this.setSelectChoices = new chide.opts.Select({
			label: '<strong>' + gettext('Extraction Variable: ') + '</strong>',
			help: gettext('Extraction Variable - The variables for this question are determined based on a user\'s answers to a previous question. Select a variable to see available options for it.'),

			renderChoices: function renderChoices(values) {
				var choices = [];
				var values = that.question.getField().getExtractionChoices();
				var lang = that.survey.editor.languages.selected();
				this.value = undefined;

				$.each(values, function (pos, name) {
					if (_typeof(name[1]) == 'object') {
						choices.push([name[0], name[1][lang]]);
					} else {
						choices.push([name[0], name[1]]);
					}
				});

				return chide.opts.renderSelect(choices, '---');
			},

			changed: function changed(value) {
				if (value) {
					that.choiceOptionsPlaceholder.empty();
					that.choiceOptionsPlaceholder.show();
					that.choiceOptionsPlaceholder.append(that.textlist.renderSubOptions(that.textlist.value[value], value).show());
				} else {
					that.choiceOptionsPlaceholder.empty();
					that.choiceOptionsPlaceholder.hide();
				}
			}
		});

		this.options = undefined;
	},

	setExtractionOptions: function setExtractionOptions(field, value) {
		try {
			this.options = field.getExtractionOptions(value);
		} catch (e) {
			this.options = field.getExtractionOptions();
		}
		this.choices = field.getExtractionChoices();

		if (this.options) {
			this.optionsPlaceholder.empty().append('<h4>' + gettext('Extraction Options') + '<\/h4>').append(this.options.render()).append(this.extractChoicesUI.render());

			if (this.choices) {
				this.optionsPlaceholder.append(this.setSelectChoices.render(this.choices, '---'));
			}
			// Show default options
			this.optionsPlaceholder.show();
		}
	},

	serialize: function serialize() {
		if (this.question.value) {
			var question = this.question.getField();

			if (!question) {
				return;
			}

			var serialized = {
				question: this.question.value
			};

			if (this.options || this.value.options) {
				serialized.options = this.options ? this.question.getField().serializeExtractionOptions(this.options) : this.value.options;
				serialized.extractChoices = this.extractChoicesUI ? this.extractChoicesUI.value || false : false;
			}

			return serialized;
		}
	},

	render: function render($super) {
		var that = this;
		this.question.choices = [['', '---']];

		$.each(this.editor.survey.nameMapping, function (name, field) {
			if (field.page.index < that.field.page.index && field.extractable) {
				that.question.choices.push([name, name]);
			}
		});

		this.questionDisplay = this.question.render().prepend('<strong>' + gettext('Extraction Source: ') + '<\/strong>');

		if (!this.optionsPlaceholder) {
			this.optionsPlaceholder = new Option.Group(this.field, { classes: 'option-group' }).render().hide();
		}

		if (!this.choiceOptionsPlaceholder) {
			this.choiceOptionsPlaceholder = new Option.Group(this.field, { classes: 'option-group' }).render().hide();
		} else {
			that.choiceOptionsPlaceholder.empty();
			that.choiceOptionsPlaceholder.hide();
		}

		var options = this.options ? this.question.getField().serializeExtractionOptions(this.options) : this.value ? this.value.options : undefined;

		if (options) {
			var old_textlist = this.textlist.value;
			this.textlist.updateExtracted(this.question.value);
			this.setExtractionOptions(this.question.getField(), options);
			for (i = 0; i < this.textlist.value.length; i++) {
				for (j = 0; j < old_textlist.length; j++) {
					if (old_textlist[j].text.value[this.survey.editor.languages.selected()] == this.textlist.value[i].text.value[this.survey.editor.languages.selected()]) {
						this.textlist.value[i] = old_textlist[j];
					}
				}
			}
			this.textlist.itemsChanged(this.textlist.value);
		}

		return $super().append(this.questionDisplay.append(this.renderHelpString())).append(this.optionsPlaceholder).append(this.extractChoicesUI).append(this.setSelectChoices).append(this.choiceOptionsPlaceholder);
	}
});

var Looping = $.klass({
	help: '<p>' + gettext('Select the pages that will be looped based on the responses to this question.') + '<\/p><p>' + gettext('Inverted Extraction allows you to loop over all the choices that were <strong>not</strong> selected by a user') + '<\/p><p>' + gettext('If this is a single text response question, the loop will be iterated with respect to a number given by the respondent.') + '</p>',

	initialize: function initialize(survey) {
		this.survey = survey;

		this.loops = {};
	},

	addLoopRule: function addLoopRule(id, loop, using_ids) {
		var that = this;

		this.loops[id] = {};

		if (!using_ids) {
			try {
				this.loops[id].range = this.convertRuleToPageIds(loop.range);
			} catch (e) {
				// Looping is no longer valid./ Remove it.
				delete this.loops[id];
				return;
			}
		} else {
			this.loops[id].range = loop.range;
		}

		if (loop.options) {
			this.loops[id].options = loop.options;
		}

		var rule = this.loops[id];

		this.loops[id].serialize = function () {
			var out = {
				options: rule.options,
				range: that.convertRuleToPageIndexes(rule.range)
			};
			return out;
		};
	},

	convertRuleToPageIds: function convertRuleToPageIds(range) {
		return [Fields.Helpers.getPageIdByPageIndex(range[0]), Fields.Helpers.getPageIdByPageIndex(range[1])];
	},

	convertRuleToPageIndexes: function convertRuleToPageIndexes(range) {
		return [Fields.Helpers.getPageIndexByPageId(range[0]), Fields.Helpers.getPageIndexByPageId(range[1])];
	},

	convertRules: function convertRules() {
		$.each(this.loops, function (name, loop) {
			loop.range[0] = Fields.Helpers.getPageIdByPageIndex(loop.range[0]);
			loop.range[1] = Fields.Helpers.getPageIdByPageIndex(loop.range[1]);
		});
	},

	refreshChoices: function refreshChoices(dropdown, page, skipClear) {
		var that = this;

		if (!skipClear) {
			dropdown.removeOption(/./);
		}

		var min = this.pageMin.val();

		$.each(this.survey.getBranchTargets(page), function () {
			var pageId = this.id;
			var index = this.index;
			var disabled = false;
			var loopedBy = [];

			$.each(that.loops, function (id, val) {
				var question = that.survey.questions[id];
				if (Fields.Helpers.getPageIndexByPageId(val.range[0]) <= index && index <= Fields.Helpers.getPageIndexByPageId(val.range[1]) && id != that.id) {
					disabled = true;
					loopedBy.push(question.name.get());
				}
			});

			if (min != '-1' && this.index < Fields.Helpers.getPageIndexByPageId(min)) {
				return;
			}

			var label = void 0;
			if (this.survey) {
				label = this.survey.pages[index].label.display(false);
			} else {
				label = $.format(gettext('Page {0}'), index + 1);
			}

			if (loopedBy.length > 0) {
				label += $.format(gettext(' (Looped by {0})'), loopedBy.join(', '));
			}

			dropdown.addOption(this.id, label, false);

			if (disabled) {
				$('option[value=' + index + ']', dropdown).attr('disabled', 'disabled').addClass('disabled').css('color', '#CCC');
			}
		});
	},

	pageRemoved: function pageRemoved(info) {
		if (!this.loops) {
			return;
		}

		var that = this;

		$.each(info.page.fields, function (i) {
			if (that.loops[this.id] !== undefined) {
				delete that.loops[this.id];
			}
		});
	},

	checkLoops: function checkLoops() {
		var that = this;

		var messages = [];

		$.each(this.loops, function (id, loop) {
			var field = that.survey.questions[id];
			var range = [Fields.Helpers.getPageIndexByPageId(loop.range[0]), Fields.Helpers.getPageIndexByPageId(loop.range[1])];

			if (!field || parseInt(range[0], 10) !== range[0] || parseInt(range[1], 10) !== range[1] || field.page.index >= range[0] || field.page.index >= range[1]) {
				messages.push(interpolate('Please note that looping from question "%s" has been removed due to this change.', [field.name.get()]));

				delete that.loops[id];
			}

			if (range[0] > range[1]) {
				loop.range = [loop.range[1], loop.range[0]];
			}
		});

		if (messages.length > 0) {
			alert(messages.join('\n'));
		}
	},

	pageIsLooped: function pageIsLooped(page) {
		var index = page.index || page;
		var result = false;

		$.each(this.loops, function (name, loop) {
			if (Fields.Helpers.getPageIndexByPageId(loop.range[0]) <= index && index <= Fields.Helpers.getPageIndexByPageId(loop.range[1])) {
				result = true;
				return;
			}
		});

		return result;
	},

	getLoopedQuestions: function getLoopedQuestions(page) {
		var looped = [];
		var that = this;

		if (page === undefined) {
			page = this.survey.currentPage;
		}

		$.each(this.loops, function (id, loop) {
			if (Fields.Helpers.getPageIndexByPageId(loop.range[0]) <= page.index && page.index <= Fields.Helpers.getPageIndexByPageId(loop.range[1])) {
				looped.push({
					page: that.survey.questions[id].page.index,
					field: that.survey.questions[id]
				});
			}
		});

		return looped;
	},

	updateLoopingKeys: function updateLoopingKeys(old, value) {
		if (this.loops[old]) {
			this.loops[value] = {
				range: this.loops[old].range,
				options: this.loops[old].options,
				serialize: this.loops[old].serialize
			};
			delete this.loops[old];
		}
	},

	fieldRemoved: function fieldRemoved(key) {
		if (key in this.loops) {
			this.deleteLoop(key);
		}
	},

	deleteLoop: function deleteLoop(value) {
		delete this.loops[value];
	},

	showForQuestion: function showForQuestion(field) {
		var that = this;

		this.name = field.name.value;
		this.id = field.id;

		var looping = void 0;

		if (field.id in this.loops) {
			looping = this.loops[field.id];
		}

		var options = field.getExtractionOptions(looping && looping.options ? looping.options : undefined);

		var pageMinContainer = $('<p>' + gettext('First looped page:') + ' </p>');

		this.pageMin = $('<select></select>', { 'class': 'custom-select' }).addOption(-1, '---').change(function () {
			if ($(this).selectedOptions().eq(0).hasClass('disabled')) {
				$(this).val('-1');
			}

			if ($(this).val() == '-1') {
				pageMaxContainer.fadeOut();
			} else {
				that.refreshChoices(that.pageMax, field.editor.survey.pageMapping[$(this).val()].index);
				pageMaxContainer.fadeIn();
			}
		}).appendTo(pageMinContainer);

		var pageMaxContainer = $('<p>' + gettext('Last looped page:') + ' </p>').hide();

		this.pageMax = $('<select></select>', { 'class': 'custom-select' }).appendTo(pageMaxContainer).change(function () {
			if ($(this).selectedOptions().eq(0).hasClass('disabled')) {
				$(this).val('-1');
			}
		});

		var dialogContent = $('<div><\/div>').append(this.help).append(options && options.render ? options.render() : undefined).append('<div class="callout callout-warning">' + gettext('<strong>Warning:</strong> data from looped pages may be deleted when changing this option after collecting responses') + '<\/div>').append(pageMinContainer).append(pageMaxContainer);

		var pages = [];

		this.refreshChoices(that.pageMin, field.page, true);

		if (looping) {
			this.pageMin.val(looping.range[0]);
			this.refreshChoices(that.pageMax, looping.range[0] - 1);
			this.pageMax.val(looping.range[1]);
			pageMaxContainer.show();
		}

		dialogContent.append(pages);

		var dialog = new modals.ContentModal(dialogContent, {
			title: gettext('Question Looping'),
			buttons: [{
				label: gettext("Save"),
				cls: 'btn-primary btn-loud',
				handler: function handler() {
					if (field.qlass == "text-response") {
						if (field.serializeExtractionOptions(options).max < 1) {
							new sma.components.Alert({
								message: gettext('Your form has been saved.'),
								type: 'error'
							});
							return;
						}
					}

					if (that.pageMin.val() != '-1') {
						that.addLoopRule(field.id, {
							range: [that.pageMin.val(), that.pageMax.val()],
							options: field.serializeExtractionOptions(options)
						}, true);
					} else {
						try {
							delete that.loops[field.id];
						} catch (e) {
							// do nothing
						}
					}

					dialog.destroy();
				}
			}]
		});

		dialog.show();
	}
});

var Dynamics = $.klass({
	initialize: function initialize(config) {
		$.extend(this, config);
		if (!this.value) {
			this.value = {
				rules: []
			};
		}
	},

	render: function render(_triggers) {
		this.choices = [['current-row', gettext('This row')]
		//['current-column', gettext('This column')] Not implemented
		];
		var that = this;

		$.each(this.survey.nameMapping, function (key, field) {
			that.choices.push([key, key]);

			if (!field.isDynamic) {
				return;
			}

			if (field.columns != undefined) {
				var attr = 'columns';
			} else {
				var attr = 'choices';
			}

			$.each(field[attr].value, function (i, variable) {
				that.choices.push([key + '[:' + i + ']', key + ' - ' + gettext('Column') + ' ' + (i + 1)]);
			});

			$.each(field.variables.value, function (i, variable) {
				that.choices.push([key + '[' + i + ':]', key + ' - ' + gettext('Variable') + ' ' + (i + 1)]);
			});
		});

		if (!_triggers) {
			var triggers = this.field.variables !== undefined ? this.field.variables.value : this.field.choices.value;
		} else {
			var triggers = _triggers;
		}

		this.triggerOptions = new Dynamics.SelectionHelper(this.survey.editor, {
			choices: triggers,
			label_getter: function label_getter(choice, i) {
				return choice.text.get();
			},
			id_getter: function id_getter(choice, i) {
				return i;
			},
			value: this.value && this.value.choices ? this.value.choices : [],
			changed: function changed(set) {
				if (!that.value) {
					that.value = { action: 'disable' };
				}
				that.value.choices = $.map(set, function (value) {
					return parseInt(value, 10);
				});
			}
		});
		$(this).bind('choiceChanged', function (e, choices) {
			this.triggerOptions.choices = choices;
			var rendered = this.triggerOptions.render();
			this.triggerOptionsEl.replaceWith(rendered);
			this.triggerOptionsEl = rendered;
		});
		if (this.rendered) {
			this.rendered.remove();
		}

		this.rendered = $('<div><\/div>');
		this.triggerOptionsEl = this.triggerOptions.render();
		this.rendered.append(this.triggerOptionsEl);

		var selector = $('<select><\/select>', { multiple: 'multiple', size: '5' }).change(function (e) {
			that.value.rules = [];

			var isUnnamedOption = function isUnnamedOption(val) {
				return ['current-row', 'current-column'].indexOf(val) != -1;
			};

			$.each($(this).val(), function (index, value) {
				that.value.rules[index] = {
					target: value,
					action: 'disable',
					exclusive: false
				};
				if (value.split('[').length > 1) {
					var question = value.split('[')[0];
					that.value.rules[index].isSamePage = that.survey.nameMapping[question].page.index == that.survey.currentPage.index;
				} else {
					that.value.rules[index].type = 'question';
					if (isUnnamedOption(value)) {
						that.value.rules[index].isSamePage = true;
						that.value.rules[index].exclusive = true;
					} else {
						that.value.rules[index].isSamePage = that.survey.nameMapping[value].page.index == that.survey.currentPage.index;
					}
				}
			});
		});

		$.each(this.choices, function (i, choice) {
			var option = $('<option><\/option>', {
				value: choice[0],
				text: choice[1]
			});

			selector.append(option);
		});

		if (this.value.rules && this.value.rules.length) {
			$.each(this.value.rules, function (i, value) {
				$('option[value=' + value.target.replace(/([\.\[\]:])/g, "\\$1") + ']', selector).attr('selected', 'selected');
			});
		}

		this.rendered.append($('<div><\/div>', {
			text: gettext('These choices should disable:')
		}).append(selector));

		return this.rendered;
	},

	serializeForVariable: function serializeForVariable(variable) {
		if (_typeof(variable.dynamics) == 'object' && variable.dynamics.value) {
			return variable.dynamics.value;
		}
		return [];
	}
});

Dynamics.SelectionHelper = $.klass(Option.Multiple, {
	label: gettext('Choices which should trigger dynamic behaviour:'),
	render: function render($super) {
		return $super().prepend(this.label);
	}
});

module.exports = {
	Looping: Looping,
	Branching: Branching,
	Extraction: Extraction,
	Dynamics: Dynamics
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var fileOptions = {
	display: 'flex',
	flexFlow: 'row'
};

var fileOption = {
	padding: '0 1rem 0.5rem 0'
};

var acceptedFormats = {
	display: 'inline',
	paddingLeft: '1rem'
};

var fileDescription = {
	paddingTop: '0.5rem'
};

var fileUploadSelector = {
	padding: '1rem 0'
};

var fileInput = {
	display: 'none'
};

var fileFieldList = {
	listStyleType: 'decimal',
	margin: 0
};

var fileUploadButton = {
	display: 'inline-block',
	fontWeight: 500,
	textTransform: 'unset',
	marginLeft: '-40px',
	paddingTop: '7px'
};

var fileUploadButtonIcon = {
	paddingRight: '0.5rem'
};

var fileDescriptionTextarea = {
	width: '100%'
};

var fileNameInput = {
	// using pixels here since the legacy survey uses pixels
	maxWidth: '200px',
	display: 'inline',
	marginRight: '0.5rem'
};

var displayWithFile = function displayWithFile(hasFile) {
	var style = {
		display: 'block'
	};
	if (hasFile) {
		style = {
			display: 'none'
		};
	}
	return style;
};

exports.fileOptions = fileOptions;
exports.fileOption = fileOption;
exports.acceptedFormats = acceptedFormats;
exports.fileDescription = fileDescription;
exports.fileUploadSelector = fileUploadSelector;
exports.fileInput = fileInput;
exports.fileFieldList = fileFieldList;
exports.fileUploadButton = fileUploadButton;
exports.fileUploadButtonIcon = fileUploadButtonIcon;
exports.fileDescriptionTextarea = fileDescriptionTextarea;
exports.fileNameInput = fileNameInput;
exports.displayWithFile = displayWithFile;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

var AndNode, ArrayNode, AttrNode, AvgNode, BranchAction, BranchingRule, CIntNode, CRealNode, CRealTwoNode, CStrNode, CoalesceNode, CompareNode, ConcatNode, ConnectiveNode, ConstNode, ContinueAction, DisableAction, DivideNode, EmailAction, EvaluationVisitor, ExprEqualsNode, ExprGreaterEqualsNode, ExprGreaterthanNode, ExprLessEqualsNode, ExprLessthanNode, ExprNode, ExprNotEqualsNode, FinishBranchAction, FormatVisitor, FuncNode, HideAction, HidePageAction, IdentifierNode, IndexNode, IndexofNode, InvalidAction, JSONVisitor, LogicNode, LogicVisitor, MarkCompleteAction, MaxNode, MinNode, MinusNode, OrNode, PageBranchAction, PlusNode, PredicateNode, RandomBranchAction, RandomRangeAction, RedirectBranchAction, ShowAction, SimplifyVisitor, SubstrNode, SumNode, SurveyAction, SurveyFinishException, SurveyRedirectException, SurveyTerminateException, TargetAction, TerminateBranchAction, TimesNode, ValidationVisitor, cls, j, len, ref1,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice;

LogicNode = (function() {
  function LogicNode() {}

  LogicNode.prototype.type = 'logic';

  LogicNode.prototype.parse = function(info) {
    var child, items, negated, ref1, ref2, ref3, ref4, ref5, ref6, ref7, type, variable;
    type = ((ref1 = (ref2 = (ref3 = info.predicate) != null ? ref3 : info.logic) != null ? ref2 : info.type) != null ? ref1 : '').toLowerCase();
    if (info.op != null) {
      items = [];
      if (info.left != null) {
        items.push(info.left);
      }
      if (info.right != null) {
        items.push(info.right);
      }
      return new (info.op === 'or' ? OrNode : AndNode)(items, info.op === 'not');
    } else if (type === 'and' || type === 'or' || type === 'not') {
      items = [];
      if ((info.left != null) && info.left !== true) {
        items.push(LogicNode.prototype.parse(info.left));
      }
      if ((info.right != null) && info.right !== true) {
        items.push(LogicNode.prototype.parse(info.right));
      }
      items = _.compact(items.concat((function() {
        var j, len, ref4, ref5, results;
        ref5 = (ref4 = info.items) != null ? ref4 : [];
        results = [];
        for (j = 0, len = ref5.length; j < len; j++) {
          child = ref5[j];
          results.push(LogicNode.prototype.parse(child));
        }
        return results;
      })()));
      negated = !!info.negated || type === 'not';
      if (items.length === 0) {
        return null;
      }
      if (items.length === 1 && !negated) {
        return items[0];
      }
      return new (type === 'or' ? OrNode : AndNode)(items, negated);
    }
    type = (function() {
      switch (type) {
        case 'before':
        case 'datelessthan':
        case 'timelessthan':
          return 'before';
        case 'after':
        case 'dategreaterthan':
        case 'timegreaterthan':
          return 'after';
        default:
          return type;
      }
    })();
    info = _.extend({}, info);
    variable = (ref4 = info.variable) != null ? ref4 : (ref5 = info.left) != null ? ref5.name : void 0;
    if (((ref6 = info.left) != null ? ref6.meta : void 0) != null) {
      variable = (function() {
        switch (info.left.meta) {
          case 'meta_language':
            return '_language';
          case 'meta_ipaddress':
            return '_ip_address';
          case 'meta_user':
            return '_invite_email';
          case 'meta_score':
            return '_weighted_score';
        }
      })();
    }
    info.value = (ref7 = info.value) != null ? ref7 : info.right;
    delete info.variable;
    delete info.left;
    delete info.right;
    delete info.logic;
    delete info.type;
    delete info.predicate;
    return new PredicateNode(variable, type, info);
  };

  LogicNode.prototype.format = function(survey) {
    return new FormatVisitor(survey).format(this);
  };

  LogicNode.prototype.validate = function(survey) {
    return new ValidationVisitor(survey).visit(this);
  };

  LogicNode.prototype.evaluate = function(handler) {
    return new EvaluationVisitor(handler).visit(this);
  };

  LogicNode.prototype.serialize = function(survey) {
    return new JSONVisitor(survey).visit(this);
  };

  LogicNode.prototype.simplify = function() {
    return new SimplifyVisitor().simplify(this);
  };

  return LogicNode;

})();

ExprNode = (function(superClass) {
  extend(ExprNode, superClass);

  ExprNode.prototype.type = 'expression';

  function ExprNode(left1, right1) {
    this.left = left1;
    this.right = right1;
  }

  ExprNode.prototype.parse = function(info) {
    switch (info.op) {
      case '+':
        return new PlusNode(info.left, info.right);
      case '-':
        return new MinusNode(info.left, info.right);
      case '*':
        return new TimesNode(info.left, info.right);
      case '/':
        return new DivideNode(info.left, info.right);
    }
  };

  return ExprNode;

})(LogicNode);

PlusNode = (function(superClass) {
  extend(PlusNode, superClass);

  function PlusNode() {
    return PlusNode.__super__.constructor.apply(this, arguments);
  }

  PlusNode.prototype.type = 'plus';

  return PlusNode;

})(ExprNode);

MinusNode = (function(superClass) {
  extend(MinusNode, superClass);

  function MinusNode() {
    return MinusNode.__super__.constructor.apply(this, arguments);
  }

  MinusNode.prototype.type = 'minus';

  return MinusNode;

})(ExprNode);

TimesNode = (function(superClass) {
  extend(TimesNode, superClass);

  function TimesNode() {
    return TimesNode.__super__.constructor.apply(this, arguments);
  }

  TimesNode.prototype.type = 'times';

  return TimesNode;

})(ExprNode);

DivideNode = (function(superClass) {
  extend(DivideNode, superClass);

  function DivideNode() {
    return DivideNode.__super__.constructor.apply(this, arguments);
  }

  DivideNode.prototype.type = 'divide';

  return DivideNode;

})(ExprNode);

CompareNode = (function(superClass) {
  extend(CompareNode, superClass);

  function CompareNode() {
    return CompareNode.__super__.constructor.apply(this, arguments);
  }

  CompareNode.prototype.type = 'compare';

  CompareNode.prototype.parse = function(info) {
    switch (info.op) {
      case '=':
        return new ExprEqualsNode(info.left, info.right);
      case '>':
        return new ExprGreaterthanNode(info.left, info.right);
      case '<':
        return new ExprLessthanNode(info.left, info.right);
      case '>=':
        return new ExprGreaterEqualsNode(info.left, info.right);
      case '<=':
        return new ExprLessEqualsNode(info.left, info.right);
      case '!=':
        return new ExprNotEqualsNode(info.left, info.right);
    }
  };

  return CompareNode;

})(ExprNode);

ExprEqualsNode = (function(superClass) {
  extend(ExprEqualsNode, superClass);

  function ExprEqualsNode() {
    return ExprEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprEqualsNode.prototype.type = 'expr_equals';

  return ExprEqualsNode;

})(CompareNode);

ExprGreaterthanNode = (function(superClass) {
  extend(ExprGreaterthanNode, superClass);

  function ExprGreaterthanNode() {
    return ExprGreaterthanNode.__super__.constructor.apply(this, arguments);
  }

  ExprGreaterthanNode.prototype.type = 'expr_greaterthan';

  return ExprGreaterthanNode;

})(CompareNode);

ExprLessthanNode = (function(superClass) {
  extend(ExprLessthanNode, superClass);

  function ExprLessthanNode() {
    return ExprLessthanNode.__super__.constructor.apply(this, arguments);
  }

  ExprLessthanNode.prototype.type = 'expr_lessthan';

  return ExprLessthanNode;

})(CompareNode);

ExprGreaterEqualsNode = (function(superClass) {
  extend(ExprGreaterEqualsNode, superClass);

  function ExprGreaterEqualsNode() {
    return ExprGreaterEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprGreaterEqualsNode.prototype.type = 'expr_greaterequals';

  return ExprGreaterEqualsNode;

})(CompareNode);

ExprLessEqualsNode = (function(superClass) {
  extend(ExprLessEqualsNode, superClass);

  function ExprLessEqualsNode() {
    return ExprLessEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprLessEqualsNode.prototype.type = 'expr_lessequals';

  return ExprLessEqualsNode;

})(CompareNode);

ExprNotEqualsNode = (function(superClass) {
  extend(ExprNotEqualsNode, superClass);

  function ExprNotEqualsNode() {
    return ExprNotEqualsNode.__super__.constructor.apply(this, arguments);
  }

  ExprNotEqualsNode.prototype.type = 'expr_notequals';

  return ExprNotEqualsNode;

})(CompareNode);

ConnectiveNode = (function(superClass) {
  extend(ConnectiveNode, superClass);

  ConnectiveNode.prototype.negated = false;

  ConnectiveNode.prototype.type = 'connective';

  ConnectiveNode.prototype.evaluator = null;

  function ConnectiveNode(items1, negated1) {
    this.items = items1;
    this.negated = negated1 != null ? negated1 : false;
  }

  return ConnectiveNode;

})(LogicNode);

AndNode = (function(superClass) {
  extend(AndNode, superClass);

  function AndNode() {
    return AndNode.__super__.constructor.apply(this, arguments);
  }

  AndNode.prototype.type = 'and';

  AndNode.prototype.evaluator = _.all;

  return AndNode;

})(ConnectiveNode);

OrNode = (function(superClass) {
  extend(OrNode, superClass);

  function OrNode() {
    return OrNode.__super__.constructor.apply(this, arguments);
  }

  OrNode.prototype.type = 'or';

  OrNode.prototype.evaluator = _.any;

  return OrNode;

})(ConnectiveNode);

ArrayNode = (function(superClass) {
  extend(ArrayNode, superClass);

  ArrayNode.prototype.type = 'array';

  function ArrayNode(id, start1, end1) {
    this.id = id;
    this.start = start1;
    this.end = end1;
  }

  ArrayNode.prototype.parse = function(info) {
    return new ArrayNode(info.id, info.start, info.end);
  };

  return ArrayNode;

})(LogicNode);

FuncNode = (function(superClass) {
  extend(FuncNode, superClass);

  FuncNode.prototype.type = 'func';

  function FuncNode(id, params1) {
    this.id = id;
    this.params = params1;
  }

  FuncNode.prototype.parse = function(info) {
    var functions;
    functions = {
      'SUM': SumNode,
      'MAX': MaxNode,
      'MIN': MinNode,
      'AVG': AvgNode,
      'CONCAT': ConcatNode,
      'SUBSTR': SubstrNode,
      'INDEXOF': IndexofNode,
      'STR': CStrNode,
      'INT': CIntNode,
      'REAL': CRealNode,
      'REALTWO': CRealTwoNode,
      'COALESCE': CoalesceNode
    };
    if (functions[info.id.value] != null) {
      return new functions[info.id.value](info.id, info.params);
    } else {
      throw new Error('Function ' + info.id.value + ' doesn\'t exist.');
    }
  };

  FuncNode.prototype.visit_func = function(initial, visitor) {
    var item, j, k, len, len1, p, param, params, ref, ref1, value;
    params = (function() {
      var j, len, ref1, results;
      ref1 = this.params;
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        p = ref1[j];
        results.push(p);
      }
      return results;
    }).call(this);
    ref1 = params.reverse();
    for (j = 0, len = ref1.length; j < len; j++) {
      param = ref1[j];
      ref = visitor.visit(param);
      value = ref && ref.value ? ref.value() : ref;
      if (value instanceof Array) {
        for (k = 0, len1 = value.length; k < len1; k++) {
          item = value[k];
          if (!visitor.is_empty(item)) {
            initial = this.func(item, initial);
          }
        }
      } else if (!visitor.is_empty(value)) {
        initial = this.func(value, initial);
      }
    }
    return initial;
  };

  return FuncNode;

})(LogicNode);

SumNode = (function(superClass) {
  extend(SumNode, superClass);

  function SumNode() {
    return SumNode.__super__.constructor.apply(this, arguments);
  }

  SumNode.prototype.type = 'func';

  SumNode.prototype.func = function(param, sum) {
    return EvaluationVisitor.prototype.convert_float(param) + sum;
  };

  SumNode.prototype.visit = function(visitor) {
    return this.visit_func(0, visitor);
  };

  return SumNode;

})(FuncNode);

MaxNode = (function(superClass) {
  extend(MaxNode, superClass);

  function MaxNode() {
    return MaxNode.__super__.constructor.apply(this, arguments);
  }

  MaxNode.prototype.type = 'func';

  MaxNode.prototype.func = function(param, max) {
    if (EvaluationVisitor.prototype.convert_float(param) > max) {
      return EvaluationVisitor.prototype.convert_float(param);
    } else {
      return max;
    }
  };

  MaxNode.prototype.visit = function(visitor) {
    var result;
    result = this.visit_func(-2e308, visitor);
    if (result !== -2e308) {
      return result;
    } else {
      return '';
    }
  };

  return MaxNode;

})(FuncNode);

MinNode = (function(superClass) {
  extend(MinNode, superClass);

  function MinNode() {
    return MinNode.__super__.constructor.apply(this, arguments);
  }

  MinNode.prototype.type = 'func';

  MinNode.prototype.func = function(param, min) {
    if (EvaluationVisitor.prototype.convert_float(param) < min) {
      return EvaluationVisitor.prototype.convert_float(param);
    } else {
      return min;
    }
  };

  MinNode.prototype.visit = function(visitor) {
    var result;
    result = this.visit_func(2e308, visitor);
    if (result !== 2e308) {
      return result;
    } else {
      return '';
    }
  };

  return MinNode;

})(FuncNode);

AvgNode = (function(superClass) {
  extend(AvgNode, superClass);

  function AvgNode() {
    return AvgNode.__super__.constructor.apply(this, arguments);
  }

  AvgNode.prototype.type = 'func';

  AvgNode.prototype.func = function(param, acc) {
    return [acc[0] + EvaluationVisitor.prototype.convert_float(param), acc[1] + 1];
  };

  AvgNode.prototype.visit = function(visitor) {
    var count, ref1, sum;
    ref1 = this.visit_func([0, 0], visitor), sum = ref1[0], count = ref1[1];
    if (count) {
      return sum / count;
    } else {
      return '';
    }
  };

  return AvgNode;

})(FuncNode);

SubstrNode = (function(superClass) {
  extend(SubstrNode, superClass);

  function SubstrNode() {
    return SubstrNode.__super__.constructor.apply(this, arguments);
  }

  SubstrNode.prototype.type = 'func';

  SubstrNode.prototype.visit = function(visitor) {
    var length, p, params, ref1, ref2, ref3, start, target;
    if (this.params.length !== 2 && this.params.length !== 3) {
      throw new Error("The number of parameters is not correct!");
    }
    params = (function() {
      var j, len, ref1, results;
      ref1 = this.params;
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        p = ref1[j];
        results.push(p);
      }
      return results;
    }).call(this);
    params.reverse();
    target = visitor.visit(params[0]);
    target = (ref1 = typeof target.label === "function" ? target.label() : void 0) != null ? ref1 : target;
    start = visitor.visit(params[1]);
    start = (ref2 = typeof start.value === "function" ? start.value() : void 0) != null ? ref2 : start;
    if (params.length > 2) {
      length = visitor.visit(params[2]);
      length = (ref3 = typeof length.value === "function" ? length.value() : void 0) != null ? ref3 : length;
    }
    if (length) {
      return target.substring(visitor.convert_int(start), visitor.convert_int(start) + visitor.convert_int(length));
    } else {
      return target.substring(visitor.convert_int(start));
    }
  };

  return SubstrNode;

})(FuncNode);

IndexofNode = (function(superClass) {
  extend(IndexofNode, superClass);

  function IndexofNode() {
    return IndexofNode.__super__.constructor.apply(this, arguments);
  }

  IndexofNode.prototype.type = 'func';

  IndexofNode.prototype.visit = function(visitor) {
    var index, p, params, ref1, ref2, ref3, start, substr, target;
    if (this.params.length !== 2 && this.params.length !== 3) {
      throw new Error("The number of parameters is not correct!");
    }
    params = (function() {
      var j, len, ref1, results;
      ref1 = this.params;
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        p = ref1[j];
        results.push(p);
      }
      return results;
    }).call(this);
    params.reverse();
    target = visitor.visit(params[0]);
    target = (ref1 = typeof target.label === "function" ? target.label() : void 0) != null ? ref1 : target;
    substr = visitor.visit(params[1]);
    substr = (ref2 = typeof substr.value === "function" ? substr.value() : void 0) != null ? ref2 : substr;
    if (params.length > 2) {
      start = visitor.visit(params[2]);
      start = (ref3 = typeof start.value === "function" ? start.value() : void 0) != null ? ref3 : start;
    }
    return index = start ? target.indexOf(substr, visitor.convert_int(start)) : target.indexOf(substr);
  };

  return IndexofNode;

})(FuncNode);

ConcatNode = (function(superClass) {
  extend(ConcatNode, superClass);

  function ConcatNode() {
    return ConcatNode.__super__.constructor.apply(this, arguments);
  }

  ConcatNode.prototype.type = 'func';

  ConcatNode.prototype.func = function(param, acc) {
    return acc + param;
  };

  ConcatNode.prototype.visit = function(visitor) {
    return this.visit_func('', visitor);
  };

  return ConcatNode;

})(FuncNode);

CStrNode = (function(superClass) {
  extend(CStrNode, superClass);

  function CStrNode() {
    return CStrNode.__super__.constructor.apply(this, arguments);
  }

  CStrNode.prototype.type = 'func';

  CStrNode.prototype.visit = function(visitor) {
    var ref, ref1;
    if (this.params.length !== 1) {
      throw new Error("CStr function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return ((ref1 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref1 : ref).toString();
  };

  return CStrNode;

})(FuncNode);

CIntNode = (function(superClass) {
  extend(CIntNode, superClass);

  function CIntNode() {
    return CIntNode.__super__.constructor.apply(this, arguments);
  }

  CIntNode.prototype.type = 'func';

  CIntNode.prototype.visit = function(visitor) {
    var ref, ref1, value;
    if (this.params.length !== 1) {
      throw new Error("CInt function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    value = (ref1 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref1 : ref;
    if (isNaN(value)) {
      throw new Error("The operator is not a number");
    } else {
      return parseInt(value);
    }
  };

  return CIntNode;

})(FuncNode);

CRealNode = (function(superClass) {
  extend(CRealNode, superClass);

  function CRealNode() {
    return CRealNode.__super__.constructor.apply(this, arguments);
  }

  CRealNode.prototype.type = 'func';

  CRealNode.prototype.visit = function(visitor) {
    var ref, ref1;
    if (this.params.length !== 1) {
      throw new Error("CReal function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return visitor.convert_float((ref1 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref1 : ref);
  };

  return CRealNode;

})(FuncNode);

CRealTwoNode = (function(superClass) {
  extend(CRealTwoNode, superClass);

  function CRealTwoNode() {
    return CRealTwoNode.__super__.constructor.apply(this, arguments);
  }

  CRealTwoNode.prototype.type = 'func';

  CRealTwoNode.prototype.visit = function(visitor) {
    var ref, ref1;
    if (this.params.length !== 1) {
      throw new Error("CReal function only allows one parameter!");
    }
    ref = visitor.visit(this.params[0]);
    return visitor.convert_float_tofixed_two((ref1 = typeof ref.value === "function" ? ref.value() : void 0) != null ? ref1 : ref);
  };

  return CRealTwoNode;

})(FuncNode);

CoalesceNode = (function(superClass) {
  extend(CoalesceNode, superClass);

  function CoalesceNode() {
    return CoalesceNode.__super__.constructor.apply(this, arguments);
  }

  CoalesceNode.prototype.type = 'func';

  CoalesceNode.prototype.func = function(param, initial) {
    if (initial) {
      return initial;
    } else if (!EvaluationVisitor.prototype.is_empty(param)) {
      return param;
    } else {
      return '';
    }
  };

  CoalesceNode.prototype.visit = function(visitor) {
    return this.visit_func('', visitor);
  };

  return CoalesceNode;

})(FuncNode);

IndexNode = (function(superClass) {
  extend(IndexNode, superClass);

  IndexNode.prototype.type = 'index';

  function IndexNode(id, index1) {
    this.id = id;
    this.index = index1;
  }

  IndexNode.prototype.parse = function(info) {
    return new IndexNode(info.id, info.index);
  };

  return IndexNode;

})(LogicNode);

AttrNode = (function(superClass) {
  extend(AttrNode, superClass);

  AttrNode.prototype.type = 'attr';

  function AttrNode(id, attr) {
    this.id = id;
    this.attr = attr;
  }

  AttrNode.prototype.parse = function(info) {
    return new AttrNode(info.id, info.attr);
  };

  return AttrNode;

})(LogicNode);

IdentifierNode = (function(superClass) {
  extend(IdentifierNode, superClass);

  IdentifierNode.prototype.type = 'id';

  function IdentifierNode(value1) {
    this.value = value1;
  }

  IdentifierNode.prototype.parse = function(info) {
    return new IdentifierNode(info.value);
  };

  return IdentifierNode;

})(LogicNode);

ConstNode = (function(superClass) {
  extend(ConstNode, superClass);

  ConstNode.prototype.type = 'const';

  function ConstNode(value1) {
    this.value = value1;
  }

  ConstNode.prototype.parse = function(info) {
    return new ConstNode(info.value);
  };

  return ConstNode;

})(LogicNode);

PredicateNode = (function(superClass) {
  extend(PredicateNode, superClass);

  PredicateNode.prototype.type = 'predicate';

  function PredicateNode(variable1, predicate, options) {
    this.variable = variable1;
    this.predicate = predicate;
    this.options = options != null ? options : {};
    this.value = this.options.value;
  }

  PredicateNode.prototype.getVariable = function(survey) {
    return survey.resolveVariable(this.variable);
  };

  return PredicateNode;

})(LogicNode);

LogicVisitor = (function() {
  function LogicVisitor() {}


  /*
  	Superclass for logic visitors. Calling visitor.visit(node) will
  	start a recursive tree walk which can be customized for LogicNode
  	subclasses by implementing visitNode_<type>.
   */

  LogicVisitor.prototype.visit = function() {
    var args, node, type;
    node = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    type = node.constructor;
    while (type !== LogicNode) {
      if (this["visitNode_" + type.prototype.type]) {
        return this["visitNode_" + type.prototype.type].apply(this, [node].concat(slice.call(args)));
      }
      type = type.__super__.constructor;
    }
    return this.visitNode.apply(this, [node].concat(slice.call(args)));
  };

  LogicVisitor.prototype.visitNode = function(node) {
    return node;
  };

  return LogicVisitor;

})();

SimplifyVisitor = (function(superClass) {
  extend(SimplifyVisitor, superClass);

  function SimplifyVisitor() {
    return SimplifyVisitor.__super__.constructor.apply(this, arguments);
  }


  /*
  	Visitor which performs basic logic simplification:
  
  	* removes nested connectives of the same type
  	* (FIXME) reduces predicates using isoneof
  
  	TODO: add a Boolean SAT solver for ultimate nerd points.
   */

  SimplifyVisitor.prototype.simplify = function(node) {
    node = this.visit(node, 1);
    return node;
  };

  SimplifyVisitor.prototype.visitNode_connective = function(node, state) {
    var el, item, items, j, len, ref1;
    node.items = (function() {
      var j, len, ref1, results;
      ref1 = node.items;
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        item = ref1[j];
        results.push(this.visit(item, state));
      }
      return results;
    }).call(this);
    if (state === 1) {
      items = [];
      ref1 = node.items;
      for (j = 0, len = ref1.length; j < len; j++) {
        item = ref1[j];
        if (item instanceof ConnectiveNode && item.type === node.type && !item.negated) {
          items = items.concat(item.items);
        } else {
          items.push(item);
        }
      }
      node.items = items;
    } else if (state === 2) {
      if (node.items.length >= 2 && node.type === 'or' && _.all(node.items, function(el) {
        return el.predicate === 'contains' && el.variable === node.items[0].variable;
      })) {
        node.items = [
          new PredicateNode(node.items[0].variable, 'containsoneof', {
            value: (function() {
              var k, len1, ref2, results;
              ref2 = node.items;
              results = [];
              for (k = 0, len1 = ref2.length; k < len1; k++) {
                el = ref2[k];
                results.push(el.value);
              }
              return results;
            })()
          })
        ];
      }
    } else if (state === 3) {
      if (node.items.length >= 2 && node.type === 'or' && _.all(node.items, function(el) {
        return el.predicate === 'equals' && el.variable === node.items[0].variable;
      })) {
        node.items = [
          new PredicateNode(node.items[0].variable, 'isoneof', {
            value: (function() {
              var k, len1, ref2, results;
              ref2 = node.items;
              results = [];
              for (k = 0, len1 = ref2.length; k < len1; k++) {
                el = ref2[k];
                results.push(el.value);
              }
              return results;
            })()
          })
        ];
      }
    }
    return node;
  };

  return SimplifyVisitor;

})(LogicVisitor);

ValidationVisitor = (function(superClass) {
  extend(ValidationVisitor, superClass);


  /*
  	Logic visitor which validates all survey object references.
  
  	Note that this visitor will also update certain types of predicates (in
  	particular, yes/no) since we have the survey at this point and can figure
  	out variable types.
   */

  function ValidationVisitor(survey1) {
    this.survey = survey1;
  }

  ValidationVisitor.prototype.visitNode_connective = function(node) {
    return _.all(node.items, (function(_this) {
      return function(item) {
        return _this.visit(item);
      };
    })(this));
  };

  ValidationVisitor.prototype.visitNode_predicate = function(node) {
    var variable;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return false;
    }
    if (variable.type === 'boolean' && node.predicate === 'equals') {
      if (node.options.value === '0') {
        node.predicate = 'yes';
      } else {
        node.predicate = 'no';
      }
      delete node.options.value;
    }
    return true;
  };

  return ValidationVisitor;

})(LogicVisitor);

JSONVisitor = (function(superClass) {
  extend(JSONVisitor, superClass);


  /*
  	Visitor which serializes logic into JSON.
   */

  function JSONVisitor(survey1) {
    this.survey = survey1;
  }

  JSONVisitor.prototype.visitNode_connective = function(node) {
    var item, result;
    result = {
      type: node.type,
      items: (function() {
        var j, len, ref1, results;
        ref1 = node.items;
        results = [];
        for (j = 0, len = ref1.length; j < len; j++) {
          item = ref1[j];
          results.push(this.visit(item));
        }
        return results;
      }).call(this)
    };
    if (node.negated) {
      result.negated = true;
    }
    return result;
  };

  JSONVisitor.prototype.visitNode_predicate = function(node) {
    return {
      type: node.type,
      predicate: node.predicate,
      variable: node.getVariable(this.survey).id,
      value: node.value
    };
  };

  return JSONVisitor;

})(LogicVisitor);

FormatVisitor = (function(superClass) {
  extend(FormatVisitor, superClass);


  /*
  	Visitor which formats the logic into a human-readable expression. Accepts
  	a config parameter with the following options:
  
  	truncate: <int> | <bool>
   */

  function FormatVisitor(survey1, config) {
    this.survey = survey1;
    this.config = config != null ? config : {};
    this.predicates = 0;
  }

  FormatVisitor.prototype.format = function(node) {
    var length, result;
    result = this.visit(node);
    if (this.config.truncate !== false) {
      length = _.isNumber(this.config.truncate) ? this.config.truncate : 100;
      if (result.length > length) {
        result = result.substring(0, length) + ("... [" + this.predicates + " " + (gettext('predicates')) + "]");
      }
    }
    return result;
  };

  FormatVisitor.prototype.varLabel = function(variable) {

    /*
    		Returns a string suitable for identifiying the given variable. Note
    		that the argument can either be a Variable instance (in offline mode)
    		or an object parsed from server-returned JSON.
     */
    if (_.isString(variable.label)) {
      return variable.label;
    } else {
      return variable.toString();
    }
  };

  FormatVisitor.prototype.choiceLabel = function(variable, choice) {

    /*
    		Returns the label for a variable choice. This is a bit hacky in order
    		to support variables from either formatInfo() in the editor or from offline.
     */
    var choices;
    choices = _.isFunction(variable.choices) ? variable.choices() : variable.choices;
    choice = choices[parseInt(choice, 10)];
    if (_.isString(choice)) {
      return choice;
    } else if (choice != null) {
      return choice.label();
    } else {
      return '-';
    }
  };

  FormatVisitor.prototype.visitNode_connective = function(node, nest) {
    var child, expr, j, len, ref1, result;
    if (nest == null) {
      nest = true;
    }
    if (nest) {
      result = (function() {
        var j, len, ref1, results;
        ref1 = node.items;
        results = [];
        for (j = 0, len = ref1.length; j < len; j++) {
          child = ref1[j];
          expr = this.visit(child, true);
          if (child instanceof ConnectiveNode) {
            expr = "(" + expr + ")";
          }
          results.push(expr);
        }
        return results;
      }).call(this);
      result = result.join(" " + (node.type.toUpperCase()) + " ");
      if (node.negated) {
        result = "not (" + result + ")";
      }
      return result;
    }
    result = (function() {
      switch (node.type) {
        case 'and':
          if (node.negated) {
            return "not all";
          } else {
            return "all";
          }
        case 'or':
          if (node.negated) {
            return "none";
          } else {
            return "any";
          }
      }
    })();
    result = result + " of the following:";
    ref1 = node.items;
    for (j = 0, len = ref1.length; j < len; j++) {
      child = ref1[j];
      result += "\n- " + (this.visit(child, true));
    }
    return result;
  };

  FormatVisitor.prototype.visitNode_predicate = function(node) {
    var variable;
    this.predicates++;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return "[" + node.variable + "]";
    }
    if (this["visit_" + node.predicate + "_" + variable.type] != null) {
      return this["visit_" + node.predicate + "_" + variable.type](variable, node.value);
    } else if (this["visit_" + node.predicate] != null) {
      return this["visit_" + node.predicate](variable, node.value);
    } else {
      throw new Error("predicate '" + node.predicate + "' not implemented for type '" + variable.type + "'");
    }
  };

  FormatVisitor.prototype.visit_noresponse = function(left) {
    return (this.varLabel(left)) + " has no response";
  };

  FormatVisitor.prototype.visit_hasresponse = function(left) {
    return (this.varLabel(left)) + " has a response";
  };

  FormatVisitor.prototype.visit_nofile = function(left) {
    return (this.varLabel(left)) + " does not have an uploaded file";
  };

  FormatVisitor.prototype.visit_hasfile = function(left) {
    return (this.varLabel(left)) + " has an uploaded file";
  };

  FormatVisitor.prototype.visit_yes_boolean = function(left) {
    return (this.varLabel(left)) + " is yes";
  };

  FormatVisitor.prototype.visit_no_boolean = function(left) {
    return (this.varLabel(left)) + " is no";
  };

  FormatVisitor.prototype.visit_equals = function(left, right) {
    return (this.varLabel(left)) + " = \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_notequals = function(left, right) {
    return (this.varLabel(left)) + " != \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_equals_boolean = function(left, right) {
    return (this.varLabel(left)) + " is " + (right === '0' ? 'yes' : 'no');
  };

  FormatVisitor.prototype.visit_equals_single = function(left, right) {
    return (this.varLabel(left)) + " = \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_contains_string = function(left, right) {
    return (this.varLabel(left)) + " contains \"" + right + "\"";
  };

  FormatVisitor.prototype.visit_contains_multi = function(left, right) {
    return (this.varLabel(left)) + " contains \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_containsoneof_multi = function(left, right) {
    return (this.varLabel(left)) + " contains one of \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_notcontainsoneof_multi = function(left, right) {
    return (this.varLabel(left)) + " does not contain any of \"" + (this.choiceLabel(left, right)) + "\"";
  };

  FormatVisitor.prototype.visit_numberselected_multi = function(left, right) {
    return (this.varLabel(left)) + " has " + (parseInt(right, 10)) + " selected";
  };

  FormatVisitor.prototype.visit_isoneof_single = function(left, right) {
    var el;
    return (this.varLabel(left)) + " is one of [" + (((function() {
      var j, len, results;
      results = [];
      for (j = 0, len = right.length; j < len; j++) {
        el = right[j];
        results.push('"' + this.choiceLabel(left, el) + '"');
      }
      return results;
    }).call(this)).join(', ')) + "]";
  };

  FormatVisitor.prototype.visit_notisoneof_single = function(left, right) {
    var el;
    return (this.varLabel(left)) + " is not one of [" + (((function() {
      var j, len, results;
      results = [];
      for (j = 0, len = right.length; j < len; j++) {
        el = right[j];
        results.push('"' + this.choiceLabel(left, el) + '"');
      }
      return results;
    }).call(this)).join(', ')) + "]";
  };

  FormatVisitor.prototype.visit_greaterthan_string = function(left, right) {
    return (this.varLabel(left)) + " > " + right;
  };

  FormatVisitor.prototype.visit_lessthan_string = function(left, right) {
    return (this.varLabel(left)) + " < " + right;
  };

  FormatVisitor.prototype.visit_after_datetime = function(left, right) {
    return (this.varLabel(left)) + " is after " + right;
  };

  FormatVisitor.prototype.visit_before_datetime = function(left, right) {
    return (this.varLabel(left)) + " is before " + right;
  };

  return FormatVisitor;

})(LogicVisitor);

EvaluationVisitor = (function(superClass) {
  extend(EvaluationVisitor, superClass);


  /*
  	Evaluates the logic node with a given handler.
  
  	Predicates are specialized by implementing visit_<predicate> (which implements
  	a default for all variable types) and/or visit_<predicate>_<type> (for specific
  	predicate/variable type pairs).
   */

  function EvaluationVisitor(handler1) {
    this.handler = handler1;
    if (this.handler) {
      this.context = this.handler.buildContext();
      this.survey = this.handler.survey;
      this.response = this.handler.response;
    }
  }

  EvaluationVisitor.prototype.visitNode_connective = function(node) {
    var child, result;
    result = node.evaluator((function() {
      var j, len, ref1, results;
      ref1 = node.items;
      results = [];
      for (j = 0, len = ref1.length; j < len; j++) {
        child = ref1[j];
        results.push(this.visit(child));
      }
      return results;
    }).call(this), function(el) {
      return !!el;
    });
    if (node.negated) {
      result = !result;
    }
    return result;
  };

  EvaluationVisitor.prototype.visitNode_predicate = function(node) {
    var result, value, variable;
    variable = node.getVariable(this.survey);
    if (variable == null) {
      return false;
    }
    value = this.response.values[variable.id];
    if (this["visit_" + node.predicate + "_" + variable.type] != null) {
      result = this["visit_" + node.predicate + "_" + variable.type](value, node.value, node.options);
      return result;
    } else if (this["visit_" + node.predicate] != null) {
      result = this["visit_" + node.predicate](value, node.value, node.options);
      return result;
    } else {
      throw new Error("predicate '" + node.predicate + "' not implemented for type '" + variable.type + "'");
    }
  };

  EvaluationVisitor.prototype.visitNode_id = function(node) {
    return this.context[node.value];
  };

  EvaluationVisitor.prototype.visitNode_const = function(node) {
    return node.value;
  };

  EvaluationVisitor.prototype.visitNode_index = function(node) {
    return this.visit(node.id).variables[parseInt(this.visit(node.index))];
  };

  EvaluationVisitor.prototype.visitNode_attr = function(node) {
    var name, ref, ref1;
    ref = this.visit(node.id);
    return (ref1 = typeof ref[name = node.attr.value] === "function" ? ref[name]() : void 0) != null ? ref1 : '';
  };

  EvaluationVisitor.prototype.convert_float = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseFloat(num);
    }
  };

  EvaluationVisitor.prototype.convert_float_tofixed_two = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseFloat(num).toFixed(2);
    }
  };

  EvaluationVisitor.prototype.convert_int = function(num) {
    if (isNaN(num)) {
      throw new Error("The operator is not a number");
    } else if (typeof num !== 'string' && typeof num !== 'number') {
      throw new Error("The operator is not a number");
    } else {
      return parseInt(num);
    }
  };

  EvaluationVisitor.prototype.is_empty = function(value) {
    return value === 'None' || value === null || value === void 0 || value === '' || (value instanceof Object ? (new trans(value)).toString() === '' : void 0);
  };

  EvaluationVisitor.prototype.visitNode_array = function(node) {
    var end, ref, start;
    ref = this.visit(node.id);
    if (node.start != null) {
      start = this.visit(node.start);
    }
    if (node.end != null) {
      end = this.visit(node.end);
    }
    if ((start != null) && (end != null)) {
      return ref.slice(start, end);
    } else if (start != null) {
      return ref.row(start);
    } else if (end != null) {
      return ref.col(end);
    } else {
      return ref;
    }
  };

  EvaluationVisitor.prototype.visit_binary = function(func, node) {
    var left, ref1, ref2, right;
    left = this.visit(node.left);
    right = this.visit(node.right);
    return func(((ref1 = typeof left.value === "function" ? left.value() : void 0) != null ? ref1 : left) || 0, ((ref2 = typeof right.value === "function" ? right.value() : void 0) != null ? ref2 : right) || 0);
  };

  EvaluationVisitor.prototype.visitNode_plus = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) + EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_minus = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) - EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_times = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) * EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_divide = function(node) {
    return this.visit_binary((function(left, right) {
      return EvaluationVisitor.prototype.convert_float(left) / EvaluationVisitor.prototype.convert_float(right);
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_func = function(node) {
    return node.visit(this);
  };

  EvaluationVisitor.prototype.visitNode_expr_equals = function(node) {
    return this.visit_binary((function(left, right) {
      return left.toString() === right.toString();
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_notequals = function(node) {
    return this.visit_binary((function(left, right) {
      return left.toString() !== right.toString();
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_greaterthan = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) > EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() > right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_lessthan = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) < EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() < right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_greaterequals = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) >= EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() >= right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.visitNode_expr_lessequals = function(node) {
    return this.visit_binary((function(left, right) {
      if (!isNaN(left) && !isNaN(right)) {
        return EvaluationVisitor.prototype.convert_float(left) <= EvaluationVisitor.prototype.convert_float(right);
      } else {
        return left.toString() <= right.toString();
      }
    }), node);
  };

  EvaluationVisitor.prototype.convert_integer = function(value) {
    var item, j, len, new_list;
    if (value instanceof Array) {
      new_list = [];
      for (j = 0, len = value.length; j < len; j++) {
        item = value[j];
        if (typeof item === 'string') {
          new_list.push(parseInt(item, 10));
        } else {
          new_list.push(item);
        }
      }
      return new_list;
    } else {
      if (typeof value === 'string') {
        return parseInt(value, 10);
      }
    }
  };

  EvaluationVisitor.prototype.visit_noresponse = function(value) {
    return value == null;
  };

  EvaluationVisitor.prototype.visit_noresponse_string = function(value) {
    return !(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_noresponse_multi = function(value) {
    return !(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_nofile = function(value) {
    return value == null;
  };

  EvaluationVisitor.prototype.visit_hasresponse = function(value) {
    return value != null;
  };

  EvaluationVisitor.prototype.visit_hasresponse_multi = function(value) {
    return !!(value != null ? value.length : void 0);
  };

  EvaluationVisitor.prototype.visit_hasfile = function(value) {
    return value != null;
  };

  EvaluationVisitor.prototype.visit_yes_boolean = function(value) {
    return value === true;
  };

  EvaluationVisitor.prototype.visit_no_boolean = function(value) {
    return value === false;
  };

  EvaluationVisitor.prototype.visit_equals = function(left, right) {
    return left === right;
  };

  EvaluationVisitor.prototype.visit_notequals = function(left, right) {
    return left !== right;
  };

  EvaluationVisitor.prototype.visit_equals_boolean = function(left, right) {
    return left === (right === "0" || right === 0);
  };

  EvaluationVisitor.prototype.visit_equals_single = function(left, right) {
    return left === parseInt(right, 10);
  };

  EvaluationVisitor.prototype.visit_equals_multi = function(left, right) {
    var i, j, len, ref1;
    left = left != null ? left : [];
    right = right != null ? right : [];
    if (left.length === right.length) {
      right = this.convert_integer(right);
      ref1 = [0, left.length];
      for (j = 0, len = ref1.length; j < len; j++) {
        i = ref1[j];
        if (left[i] !== right[i]) {
          false;
        }
      }
      return true;
    } else {
      return false;
    }
  };

  EvaluationVisitor.prototype.visit_contains_string = function(left, right) {
    return (left != null) && left.indexOf(right) >= 0;
  };

  EvaluationVisitor.prototype.visit_contains_multi = function(left, right) {
    return (left != null) && left.indexOf(parseInt(right, 10)) >= 0;
  };

  EvaluationVisitor.prototype.visit_containsoneof_multi = function(left, right) {
    var intersection;
    right = this.convert_integer(right != null ? right : []);
    intersection = (left != null ? left : []).filter(function(n) {
      if ((right.indexOf(n)) === -1) {
        return false;
      }
      return true;
    });
    return intersection.length > 0;
  };

  EvaluationVisitor.prototype.visit_notcontainsoneof_multi = function(left, right) {
    var intersection;
    right = this.convert_integer(right != null ? right : []);
    intersection = (left != null ? left : []).filter(function(n) {
      if ((right.indexOf(n)) === -1) {
        return false;
      }
      return true;
    });
    return intersection.length === 0;
  };

  EvaluationVisitor.prototype.visit_numberselected_multi = function(left, right) {
    return (left != null ? left : []).length === parseInt(right, 10);
  };

  EvaluationVisitor.prototype.visit_isoneof_single = function(left, right) {
    right = this.convert_integer(right != null ? right : []);
    return (right != null ? right : []).indexOf(left) >= 0;
  };

  EvaluationVisitor.prototype.visit_notisoneof_single = function(left, right) {
    right = this.convert_integer(right != null ? right : []);
    return (right != null ? right : []).indexOf(left) === -1;
  };

  EvaluationVisitor.prototype.visit_greaterthan_string = function(left, right) {
    return parseFloat(left, 10) > parseFloat(right, 10);
  };

  EvaluationVisitor.prototype.visit_lessthan_string = function(left, right) {
    return parseFloat(left, 10) < parseFloat(right, 10);
  };

  EvaluationVisitor.prototype.visit_after_datetime = function(left, right) {
    return (left != null) && (right != null) && left > right;
  };

  EvaluationVisitor.prototype.visit_before_datetime = function(left, right) {
    return (left != null) && (right != null) && left < right;
  };

  return EvaluationVisitor;

})(LogicVisitor);

SurveyFinishException = (function(superClass) {
  extend(SurveyFinishException, superClass);

  function SurveyFinishException() {
    SurveyFinishException.__super__.constructor.apply(this, arguments);
  }

  return SurveyFinishException;

})(Error);

SurveyTerminateException = (function(superClass) {
  extend(SurveyTerminateException, superClass);

  function SurveyTerminateException() {
    SurveyTerminateException.__super__.constructor.apply(this, arguments);
  }

  return SurveyTerminateException;

})(Error);

SurveyRedirectException = (function(superClass) {
  extend(SurveyRedirectException, superClass);

  function SurveyRedirectException() {
    SurveyRedirectException.__super__.constructor.apply(this, arguments);
  }

  return SurveyRedirectException;

})(Error);

SurveyAction = (function() {
  function SurveyAction() {}

  SurveyAction.prototype.type = void 0;

  SurveyAction.prototype.label = void 0;


  /*
  	Whether this action is a branching action (i.e. final). If a rule has multiple actions, only
  	the first branching action applies.
   */

  SurveyAction.prototype.isBranch = false;


  /*
  	Whether this action has targets (hide/show/disable rules). These actions need to be handled
  	by their targets rather than the source page.
   */

  SurveyAction.prototype.hasTargets = false;

  SurveyAction.prototype.format = function(survey) {
    return this.label;
  };

  SurveyAction.prototype.validate = function(survey) {
    return true;
  };

  SurveyAction.prototype.serialize = function(survey) {
    return {
      type: this.type
    };
  };

  return SurveyAction;

})();

BranchAction = (function(superClass) {
  extend(BranchAction, superClass);

  function BranchAction() {
    return BranchAction.__super__.constructor.apply(this, arguments);
  }

  BranchAction.prototype.isBranch = true;

  return BranchAction;

})(SurveyAction);

PageBranchAction = (function(superClass) {
  extend(PageBranchAction, superClass);

  PageBranchAction.prototype.type = 'skip';

  PageBranchAction.prototype.label = gettext('skip to page');

  function PageBranchAction(page) {
    this.page = page;
  }

  PageBranchAction.prototype.apply = function(survey) {
    var ref1;
    return ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages)[this.page];
  };

  PageBranchAction.prototype.format = function(survey) {
    var ref1;
    return interpolate(gettext('skip to %(page)s'), {
      page: ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages)[this.page].page
    });
  };

  PageBranchAction.prototype.validate = function(survey) {
    var ref1;
    return this.page in ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages);
  };

  PageBranchAction.prototype.serialize = function(survey) {
    return _.extend(PageBranchAction.__super__.serialize.apply(this, arguments), {
      page: this.page
    });
  };

  return PageBranchAction;

})(BranchAction);

FinishBranchAction = (function(superClass) {
  extend(FinishBranchAction, superClass);

  function FinishBranchAction() {
    return FinishBranchAction.__super__.constructor.apply(this, arguments);
  }

  FinishBranchAction.prototype.type = 'finish';

  FinishBranchAction.prototype.label = gettext('complete the form');

  FinishBranchAction.prototype.apply = function(survey) {
    throw new SurveyFinishException();
  };

  return FinishBranchAction;

})(BranchAction);

TerminateBranchAction = (function(superClass) {
  extend(TerminateBranchAction, superClass);

  function TerminateBranchAction() {
    return TerminateBranchAction.__super__.constructor.apply(this, arguments);
  }

  TerminateBranchAction.prototype.type = 'terminate';

  TerminateBranchAction.prototype.label = gettext('terminate the form');

  TerminateBranchAction.prototype.apply = function(survey) {
    throw new SurveyTerminateException();
  };

  return TerminateBranchAction;

})(BranchAction);

RedirectBranchAction = (function(superClass) {
  extend(RedirectBranchAction, superClass);

  RedirectBranchAction.prototype.type = 'redirect';

  RedirectBranchAction.prototype.label = gettext('redirect to a URL');

  function RedirectBranchAction(url) {
    this.url = url;
  }

  RedirectBranchAction.prototype.apply = function(survey) {};

  RedirectBranchAction.prototype.format = function(survey) {
    return interpolate(gettext('redirect to %(url)s'), {
      url: this.url
    });
  };

  RedirectBranchAction.prototype.serialize = function() {
    return _.extend(RedirectBranchAction.__super__.serialize.apply(this, arguments), {
      url: this.url
    });
  };

  return RedirectBranchAction;

})(BranchAction);

ContinueAction = (function(superClass) {
  extend(ContinueAction, superClass);

  function ContinueAction() {
    return ContinueAction.__super__.constructor.apply(this, arguments);
  }

  ContinueAction.prototype.type = 'continue';

  ContinueAction.prototype.label = gettext('skip to the next loop iteration');

  return ContinueAction;

})(BranchAction);

RandomBranchAction = (function(superClass) {
  extend(RandomBranchAction, superClass);

  RandomBranchAction.prototype.type = 'random';

  RandomBranchAction.prototype.label = gettext('skip to a random page');

  RandomBranchAction.prototype.format = function(survey) {
    return interpolate(gettext('skip to %(pages)s'), {
      pages: this.pages
    });
  };

  function RandomBranchAction(pages) {
    this.pages = pages;
  }

  RandomBranchAction.prototype.validate = function(survey) {
    return _.all(this.pages.split(','), function(n) {
      return parseFloat(n) && isFinite(n) && n < survey.pages.length;
    });
  };

  RandomBranchAction.prototype.serialize = function() {
    return {
      pages: this.pages,
      type: this.type
    };
  };

  return RandomBranchAction;

})(PageBranchAction);

RandomRangeAction = (function(superClass) {
  extend(RandomRangeAction, superClass);

  RandomRangeAction.prototype.type = 'random-range';

  RandomRangeAction.prototype.label = gettext('randomly traverse a page range');

  function RandomRangeAction(pages, after) {
    this.pages = pages;
    this.after = after;
  }

  RandomRangeAction.prototype.serialize = function() {
    return _.extend(RandomRangeAction.__super__.serialize.apply(this, arguments), {
      pages: this.pages,
      after: this.after
    });
  };

  return RandomRangeAction;

})(BranchAction);

TargetAction = (function(superClass) {
  extend(TargetAction, superClass);

  TargetAction.prototype.hasTargets = true;

  TargetAction.prototype.ROW_RE = /^([-a-zA-Z0-9]+)\[(.+?):\]$/;

  TargetAction.prototype.COLUMN_RE = /^([-a-zA-Z0-9]+)\[:(.+?)\]$/;

  function TargetAction(target1, exclude) {
    var match;
    this.target = target1;
    this.exclude = exclude;
    if ((match = this.ROW_RE.exec(this.target)) != null) {
      this.target = match[1];
      this.row = parseInt(match[2], 10);
    } else if ((match = this.COLUMN_RE.exec(this.target)) != null) {
      this.target = match[1];
      this.column = parseInt(match[2], 10);
    }
  }

  TargetAction.prototype.getElSelector = function() {
    if (this.row != null) {
      return ".x_" + (escapeSelector(this.target)) + "_" + this.row;
    } else if (this.column != null) {
      return ".x_" + (escapeSelector(this.target)) + "__" + this.column;
    } else {
      return "#x_" + (escapeSelector(this.target));
    }
  };

  TargetAction.prototype.getTargetId = function() {
    if (this.row != null) {
      return this.target + "[" + this.row + ":]";
    } else if (this.column != null) {
      return this.target + "[:" + this.column + "]";
    } else {
      return this.target;
    }
  };

  TargetAction.prototype.getTargetLabel = function(survey) {
    var question;
    question = survey.questions[this.target];
    if ((this.row != null) && ((question != null ? question.rows : void 0) != null)) {
      return question.rows[this.row].text;
    } else if ((this.column != null) && ((question != null ? question.types : void 0) != null)) {
      return question.types[this.column].text;
    } else if (question != null) {
      return question.label;
    } else if (this.target in survey.variables) {
      return survey.variables[this.target].label;
    }
  };

  TargetAction.prototype.apply = function(matches, el) {};

  TargetAction.prototype.validate = function(survey) {
    return this.getTargetLabel(survey) != null;
  };

  TargetAction.prototype.serialize = function() {
    return _.extend(TargetAction.__super__.serialize.apply(this, arguments), {
      target: this.getTargetId()
    });
  };

  return TargetAction;

})(SurveyAction);

HideAction = (function(superClass) {
  extend(HideAction, superClass);

  function HideAction() {
    return HideAction.__super__.constructor.apply(this, arguments);
  }

  HideAction.prototype.type = 'hide';

  HideAction.prototype.label = gettext('hide a question');

  HideAction.prototype.apply = function(matches, el) {
    if (matches) {
      return el.find(this.getElSelector()).addClass('hidden');
    } else {
      return el.find(this.getElSelector()).removeClass('hidden');
    }
  };

  HideAction.prototype.format = function(survey) {
    var t;
    t = this.getTargetLabel(survey);
    return interpolate(gettext('hide %(target)s'), {
      target: t
    }, true);
  };

  return HideAction;

})(TargetAction);

ShowAction = (function(superClass) {
  extend(ShowAction, superClass);

  function ShowAction() {
    return ShowAction.__super__.constructor.apply(this, arguments);
  }

  ShowAction.prototype.type = 'show';

  ShowAction.prototype.label = gettext('show a question');

  ShowAction.prototype.apply = function(matches, el) {
    if (matches) {
      return el.find(this.getElSelector()).removeClass('hidden');
    } else {
      return el.find(this.getElSelector()).addClass('hidden');
    }
  };

  ShowAction.prototype.format = function(survey) {
    return interpolate(gettext('show %(target)s'), {
      target: this.getTargetLabel(survey)
    }, true);
  };

  return ShowAction;

})(TargetAction);

DisableAction = (function(superClass) {
  extend(DisableAction, superClass);

  function DisableAction() {
    return DisableAction.__super__.constructor.apply(this, arguments);
  }

  DisableAction.prototype.type = 'disable';

  DisableAction.prototype.label = gettext('disable a question');

  DisableAction.prototype.apply = function(matches, el) {
    var inputs;
    inputs = el.find(this.getElSelector()).find(':input');
    if (this.exclude) {
      inputs = inputs.filter(":not([name=" + this.exclude + "])");
    }
    return inputs.prop('disabled', matches);
  };

  DisableAction.prototype.format = function(survey) {
    return interpolate(gettext('disable %(target)s'), {
      target: this.getTargetLabel(survey)
    }, true);
  };

  return DisableAction;

})(TargetAction);

InvalidAction = (function(superClass) {
  extend(InvalidAction, superClass);

  InvalidAction.prototype.type = 'mark-invalid';

  InvalidAction.prototype.label = gettext('mark as an invalid question');

  function InvalidAction(target1, feedback) {
    this.target = target1;
    this.feedback = feedback;
    InvalidAction.__super__.constructor.call(this, this.target);
  }

  InvalidAction.prototype.format = function(survey) {
    return interpolate(gettext('mark %(target)s as an invalid question'), {
      target: this.getTargetLabel(survey)
    });
  };

  InvalidAction.prototype.serialize = function() {
    return _.extend(InvalidAction.__super__.serialize.apply(this, arguments), {
      feedback: this.feedback
    });
  };

  return InvalidAction;

})(TargetAction);

HidePageAction = (function(superClass) {
  extend(HidePageAction, superClass);

  HidePageAction.prototype.type = 'hide-page';

  HidePageAction.prototype.label = gettext('hide a page');

  function HidePageAction(page) {
    this.page = page;
  }

  HidePageAction.prototype.getPage = function(survey) {
    var ref1;
    return ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages)[this.page];
  };

  HidePageAction.prototype.format = function(survey) {
    var ref1;
    return interpolate(gettext('hide page %(page)s'), {
      page: ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages)[this.page].page
    });
  };

  HidePageAction.prototype.validate = function(survey) {
    var ref1;
    return this.page in ((ref1 = survey.pageMapping) != null ? ref1 : survey.pages);
  };

  HidePageAction.prototype.serialize = function(survey) {
    return _.extend(HidePageAction.__super__.serialize.apply(this, arguments), {
      page: this.page
    });
  };

  return HidePageAction;

})(SurveyAction);

MarkCompleteAction = (function(superClass) {
  extend(MarkCompleteAction, superClass);

  function MarkCompleteAction() {
    return MarkCompleteAction.__super__.constructor.apply(this, arguments);
  }

  MarkCompleteAction.prototype.type = 'mark-complete';

  MarkCompleteAction.prototype.label = gettext('mark the response as completed');

  return MarkCompleteAction;

})(SurveyAction);

EmailAction = (function(superClass) {
  extend(EmailAction, superClass);

  EmailAction.prototype.type = 'email';

  EmailAction.prototype.label = gettext('send an email');

  function EmailAction(settings) {
    this.settings = settings;
  }

  EmailAction.prototype.serialize = function() {
    return _.extend(EmailAction.__super__.serialize.apply(this, arguments), this.settings);
  };

  return EmailAction;

})(SurveyAction);

SurveyAction.TYPES = {};

ref1 = [TargetAction, PageBranchAction, FinishBranchAction, TerminateBranchAction, RedirectBranchAction, ContinueAction, RandomBranchAction, RandomRangeAction, HideAction, ShowAction, DisableAction, InvalidAction, HidePageAction, MarkCompleteAction, EmailAction];
for (j = 0, len = ref1.length; j < len; j++) {
  cls = ref1[j];
  SurveyAction.TYPES[cls.prototype.type] = cls;
}

BranchingRule = (function() {
  function BranchingRule() {
    var actions1, condition1;
    condition1 = arguments[0], actions1 = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    this.condition = condition1;
    this.actions = actions1;
  }

  BranchingRule.prototype.parseAction = function(info) {
    var ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    switch ((ref2 = info.type) != null ? ref2 : info.skip) {
      case 'mark-complete':
        return new MarkCompleteAction();
      case 'redirect':
        return new RedirectBranchAction((ref3 = info.url) != null ? ref3 : info.redirect);
      case 'hide':
        return new HideAction((ref4 = info.target) != null ? ref4 : info.hideQuestion);
      case 'show':
        return new ShowAction((ref5 = info.target) != null ? ref5 : info.showQuestion);
      case 'disable':
        return new DisableAction((ref6 = info.target) != null ? ref6 : info.disableVariable);
      case 'mark-invalid':
        return new InvalidAction(info.target, info.feedback);
      case 'hide-page':
        return new HidePageAction(info.page);
      case 'finish':
        return new FinishBranchAction();
      case 'terminate':
        return new TerminateBranchAction();
      case 'random':
        return new RandomBranchAction((ref7 = info.pages) != null ? ref7 : info.pageRange);
      case 'random-range':
        return new RandomRangeAction((ref8 = info.pages) != null ? ref8 : info.pageRange, (ref9 = info.after) != null ? ref9 : info.skipToPage);
      case 'email':
        return new EmailAction((ref10 = info.emailsettings) != null ? ref10 : info);
      case 'skip':
        return new PageBranchAction(info.page);
      case 'continue':
        return new ContinueAction();
      default:
        return new PageBranchAction(info.skip);
    }
  };

  BranchingRule.prototype.parse = function(info) {
    var action, actions, condition;
    condition = LogicNode.prototype.parse(info.condition).simplify();
    if (info.skip != null) {
      actions = [BranchingRule.prototype.parseAction(info)];
    } else if (info.action != null) {
      actions = [BranchingRule.prototype.parseAction(info.action)];
    } else if (info.actions != null) {
      actions = (function() {
        var k, len1, ref2, results;
        ref2 = info.actions;
        results = [];
        for (k = 0, len1 = ref2.length; k < len1; k++) {
          action = ref2[k];
          results.push(BranchingRule.prototype.parseAction(action));
        }
        return results;
      })();
    } else {
      return null;
    }
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(BranchingRule, [condition].concat(slice.call(actions)), function(){});
  };

  BranchingRule.prototype.validate = function(survey) {
    return this.condition.validate(survey) && _.all(this.actions, function(action) {
      return action.validate(survey);
    });
  };

  BranchingRule.prototype.format = function(survey) {
    var action, actions;
    actions = ((function() {
      var k, len1, ref2, results;
      ref2 = this.actions;
      results = [];
      for (k = 0, len1 = ref2.length; k < len1; k++) {
        action = ref2[k];
        results.push(action.format(survey));
      }
      return results;
    }).call(this)).join(', ');
    return "If " + (this.condition.format(survey)) + " then " + actions;
  };

  BranchingRule.prototype.serialize = function(survey) {
    var action, result;
    result = {
      condition: this.condition.serialize(survey)
    };
    if (this.actions.length === 1) {
      result.action = this.actions[0].serialize(survey);
    } else {
      result.actions = (function() {
        var k, len1, ref2, results;
        ref2 = this.actions;
        results = [];
        for (k = 0, len1 = ref2.length; k < len1; k++) {
          action = ref2[k];
          results.push(action.serialize(survey));
        }
        return results;
      }).call(this);
    }
    return result;
  };

  BranchingRule.prototype.parseSimple = function(question, rules) {
    var action, condition, k, len1, ref2, results, rule;
    ref2 = rules != null ? rules : [];
    results = [];
    for (k = 0, len1 = ref2.length; k < len1; k++) {
      rule = ref2[k];
      condition = new PredicateNode(question.id, 'equals', {
        value: rule.val
      });
      action = (function() {
        switch (rule.page) {
          case 'finish':
            return new FinishBranchAction();
          case 'terminate':
            return new TerminateBranchAction();
          default:
            return new PageBranchAction(rule.page);
        }
      })();
      results.push(new BranchingRule(condition, action));
    }
    return results;
  };

  return BranchingRule;

})();

module.exports = {
  LogicNode: LogicNode,
  OrNode: OrNode,
  PredicateNode: PredicateNode,
  SurveyFinishException: SurveyFinishException,
  SurveyTerminateException: SurveyTerminateException,
  SurveyRedirectException: SurveyRedirectException,
  SurveyAction: SurveyAction,
  EvaluationVisitor: EvaluationVisitor,
  DisableAction: DisableAction,
  BranchingRule: BranchingRule,
  InvalidAction: InvalidAction,
  HidePageAction: HidePageAction,
  ExprNode: ExprNode,
  CompareNode: CompareNode,
  ConnectiveNode: ConnectiveNode,
  ArrayNode: ArrayNode,
  FuncNode: FuncNode,
  IndexNode: IndexNode,
  AttrNode: AttrNode,
  IdentifierNode: IdentifierNode,
  ConstNode: ConstNode
};


/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(88);
var LIBRARY = __webpack_require__(134);
var wksExt = __webpack_require__(858);
var defineProperty = __webpack_require__(37).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(232)('keys');
var uid = __webpack_require__(159);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 413 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(24);
var anObject = __webpack_require__(13);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(89)(Function.call, __webpack_require__(77).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);
var setPrototypeOf = __webpack_require__(415).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(91);
var defined = __webpack_require__(99);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(134);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(66);
var hide = __webpack_require__(65);
var Iterators = __webpack_require__(190);
var $iterCreate = __webpack_require__(422);
var setToStringTag = __webpack_require__(187);
var getPrototypeOf = __webpack_require__(78);
var ITERATOR = __webpack_require__(30)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(162);
var descriptor = __webpack_require__(158);
var setToStringTag = __webpack_require__(187);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(65)(IteratorPrototype, __webpack_require__(30)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(289);
var defined = __webpack_require__(99);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(30)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(190);
var ITERATOR = __webpack_require__(30)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(37);
var createDesc = __webpack_require__(158);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(188);
var ITERATOR = __webpack_require__(30)('iterator');
var Iterators = __webpack_require__(190);
module.exports = __webpack_require__(88).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1313);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(161);
var toLength = __webpack_require__(31);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(136);
var step = __webpack_require__(875);
var Iterators = __webpack_require__(190);
var toIObject = __webpack_require__(76);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(421)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(235);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(288)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(89);
var invoke = __webpack_require__(865);
var html = __webpack_require__(414);
var cel = __webpack_require__(410);
var global = __webpack_require__(18);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(90)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var macrotask = __webpack_require__(433).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(90)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(52);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(33);
var LIBRARY = __webpack_require__(134);
var $typed = __webpack_require__(295);
var hide = __webpack_require__(65);
var redefineAll = __webpack_require__(167);
var fails = __webpack_require__(21);
var anInstance = __webpack_require__(165);
var toInteger = __webpack_require__(91);
var toLength = __webpack_require__(31);
var toIndex = __webpack_require__(885);
var gOPN = __webpack_require__(163).f;
var dP = __webpack_require__(37).f;
var arrayFill = __webpack_require__(429);
var setToStringTag = __webpack_require__(187);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<button type=\"button\" class=\"sma-dropdown-button ");t.b(t.v(t.f("extraClass",c,p,0)));t.b(" btn ");t.b(t.v(t.f("btnclass",c,p,0)));t.b(" ");if(!t.s(t.f("noCaret",c,p,1),c,p,1,0,0,"")){t.b("dropdown-toggle");};t.b("\" aria-label=\"");t.b(t.v(t.f("ariaLabel",c,p,0)));t.b("\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">");t.b("\n" + i);if(t.s(t.f("icon",c,p,1),c,p,0,228,259,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<i class=\"");t.b(t.v(t.f("icon",c,p,0)));t.b("\"></i>");t.b("\n" + i);});c.pop();}t.b("	");t.b(t.t(t.f("title",c,p,0)));t.b("\n" + i);t.b(" </button>");t.b("\n");t.b("\n" + i);t.b(" <div class=\"dropdown-menu ");if(t.s(t.f("rightAligned",c,p,1),c,p,0,340,359,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("dropdown-menu-right");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("items",c,p,1),c,p,0,390,732,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("header",c,p,1),c,p,0,404,453,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<h6 class=\"dropdown-header\">");t.b(t.t(t.f("text",c,p,0)));t.b("</h6>");t.b("\n" + i);});c.pop();}if(t.s(t.f("divider",c,p,1),c,p,0,479,522,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"dropdown-divider\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("header",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("divider",c,p,1),c,p,1,0,0,"")){t.b("		<a ");t.b(t.v(t.f("attribute",c,p,0)));t.b(" class=\"");t.b(t.v(t.f("extraItemClass",c,p,0)));t.b(" dropdown-item\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" href=\"");if(t.s(t.f("href",c,p,1),c,p,0,652,660,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("href",c,p,0)));});c.pop();}if(!t.s(t.f("href",c,p,1),c,p,1,0,0,"")){t.b("#");};t.b("\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);};};});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<button type=\"button\" class=\"sma-dropdown-button {{extraClass}} btn {{btnclass}} {{^noCaret}}dropdown-toggle{{/noCaret}}\" aria-label=\"{{ ariaLabel }}\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n\t{{#icon}}\n\t\t<i class=\"{{ icon }}\"></i>\n\t{{/icon}}\n\t{{{ title }}}\n </button>\n\n <div class=\"dropdown-menu {{#rightAligned}}dropdown-menu-right{{/rightAligned}}\">\n\t{{#items}}\n\t\t{{#header}}\n\t\t<h6 class=\"dropdown-header\">{{{text}}}</h6>\n\t\t{{/header}}\n\t\t{{#divider}}\n\t\t\t<div class=\"dropdown-divider\"></div>\n\t\t{{/divider}}\n\t\t{{^header}}{{^divider}}\n\t\t<a {{attribute}} class=\"{{extraItemClass}} dropdown-item\" name=\"{{name}}\" href=\"{{#href}}{{href}}{{/href}}{{^href}}#{{/href}}\">{{{text}}}</a>\n\t\t{{/divider}}{{/header}}\n\t{{/items}}\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 441 */,
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-profile-icon-group\">");t.b("\n" + i);if(t.s(t.f("initials",c,p,1),c,p,0,51,226,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("team",c,p,1),c,p,0,63,138,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"sma-avatar-sm sma-avatar-inverse\">");t.b(t.t(t.f("initials",c,p,0)));t.b("</div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("team",c,p,1),c,p,1,0,0,"")){t.b("			<div class=\"sma-avatar-sm\">");t.b(t.t(t.f("initials",c,p,0)));t.b("</div>");t.b("\n" + i);};});c.pop();}t.b("\n" + i);t.b("	<div style=\"display:inline-block\" class=\"sma-avatar-user\">");t.b("\n" + i);t.b("		<div class=\"sma-avatar-name\">");t.b(t.v(t.f("top",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("		<small class=\"sma-avatar-email text-muted\">");t.b(t.v(t.f("bottom",c,p,0)));t.b("</small>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-profile-icon-group\">\n\t{{#initials}}\n\t\t{{#team}}\n\t\t\t<div class=\"sma-avatar-sm sma-avatar-inverse\">{{{ initials }}}</div>\n\t\t{{/team}}\n\t\t{{^team}}\n\t\t\t<div class=\"sma-avatar-sm\">{{{ initials }}}</div>\n\t\t{{/team}}\n\t{{/initials}}\n\n\t<div style=\"display:inline-block\" class=\"sma-avatar-user\">\n\t\t<div class=\"sma-avatar-name\">{{ top }}</div>\n\t\t<small class=\"sma-avatar-email text-muted\">{{ bottom }}</small>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropSelectDrilldown = __webpack_require__(907);

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */

var DropSelectorDrilldown = function (_DropSelectDrilldown) {
	_inherits(DropSelectorDrilldown, _DropSelectDrilldown);

	function DropSelectorDrilldown() {
		_classCallCheck(this, DropSelectorDrilldown);

		return _possibleConstructorReturn(this, (DropSelectorDrilldown.__proto__ || Object.getPrototypeOf(DropSelectorDrilldown)).apply(this, arguments));
	}

	_createClass(DropSelectorDrilldown, [{
		key: 'initialize',
		value: function initialize(options) {
			this.checkboxItems = false;
			this.selector = true;
			this.noFooter = true;
			this.noCount = true;
			this.changeTitleAfterSelection = true;
			this.singleSelect = true;

			options.checkboxItems = false;

			_get(DropSelectorDrilldown.prototype.__proto__ || Object.getPrototypeOf(DropSelectorDrilldown.prototype), 'initialize', this).call(this, options);
		}
	}, {
		key: 'populateFromSelectBox',
		value: function populateFromSelectBox(options) {
			var _this2 = this;

			if (this.$selectEl.attr('multiple')) {
				this.singleSelect = false;
			}

			var $optGroups = this.$selectEl.find('optgroup');
			var groups = [];

			//create the list of items
			if ($optGroups.length > 0) {
				$optGroups.each(function (i, group) {
					var $group = $(group);

					var group = {
						name: i.toString(),
						text: $group.prop('label'),
						items: []
					};

					var $items = $group.find('option');

					$items.each(function (j, item) {
						var $item = $(item);
						var selected = $item.is(':selected');
						var disabled = $item.attr('disabled');

						group.items.push({
							name: $item.val(),
							text: $item.text(),
							selected: selected,
							header: disabled
						});

						if (selected) {
							_this2.selectedGroupIndex = i;
						}
					});

					groups.push(group);
				});
			} else {}

			options.items = groups;
			var title = this.updateTitleFromSelect();
			if (title) {
				options.title = title;
			}
		}
	}, {
		key: 'unSelectAll',
		value: function unSelectAll() {
			this.$el.find('.sma-js-action-item').removeClass('active');

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.changedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var group = _step.value;
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = group.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var item = _step2.value;

							item.selected = false;
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'val',
		value: function val(newSelected) {
			if (newSelected) {
				this.unSelectAll();
				this.updateChangedItems();

				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = this.changedItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var group = _step3.value;
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = group.items[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var item = _step4.value;

								if (newSelected instanceof Array && newSelected.indexOf(item.name) !== -1 || item.name === newSelected) {
									item.selected = true;
									this.changeTitle(item.text);
								}
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}

				this.$selectEl.val(newSelected);
				this.renderContents();
			}

			return this.$selectEl.val();
		}
	}, {
		key: 'wrapped',
		get: function get() {
			return $('<div></div>').append(this.$selectEl).append(this.$el);
		}
	}]);

	return DropSelectorDrilldown;
}(DropSelectDrilldown);

module.exports = DropSelectorDrilldown;

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pane__ = __webpack_require__(1799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Pane__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(469);
/* unused harmony reexport add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__after_js__ = __webpack_require__(470);
/* unused harmony reexport after */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ary_js__ = __webpack_require__(316);
/* unused harmony reexport ary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assign_js__ = __webpack_require__(474);
/* unused harmony reexport assign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assignIn_js__ = __webpack_require__(321);
/* unused harmony reexport assignIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assignInWith_js__ = __webpack_require__(248);
/* unused harmony reexport assignInWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assignWith_js__ = __webpack_require__(477);
/* unused harmony reexport assignWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__at_js__ = __webpack_require__(478);
/* unused harmony reexport at */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__attempt_js__ = __webpack_require__(328);
/* unused harmony reexport attempt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__before_js__ = __webpack_require__(330);
/* unused harmony reexport before */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bind_js__ = __webpack_require__(331);
/* unused harmony reexport bind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bindAll_js__ = __webpack_require__(483);
/* unused harmony reexport bindAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bindKey_js__ = __webpack_require__(484);
/* unused harmony reexport bindKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__camelCase_js__ = __webpack_require__(485);
/* unused harmony reexport camelCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__capitalize_js__ = __webpack_require__(332);
/* unused harmony reexport capitalize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__castArray_js__ = __webpack_require__(488);
/* unused harmony reexport castArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ceil_js__ = __webpack_require__(489);
/* unused harmony reexport ceil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chain_js__ = __webpack_require__(335);
/* unused harmony reexport chain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chunk_js__ = __webpack_require__(491);
/* unused harmony reexport chunk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__clamp_js__ = __webpack_require__(492);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__clone_js__ = __webpack_require__(493);
/* unused harmony reexport clone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cloneDeep_js__ = __webpack_require__(497);
/* unused harmony reexport cloneDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__cloneDeepWith_js__ = __webpack_require__(498);
/* unused harmony reexport cloneDeepWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__cloneWith_js__ = __webpack_require__(499);
/* unused harmony reexport cloneWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commit_js__ = __webpack_require__(339);
/* unused harmony reexport commit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__compact_js__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_25__compact_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__concat_js__ = __webpack_require__(501);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cond_js__ = __webpack_require__(502);
/* unused harmony reexport cond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__conforms_js__ = __webpack_require__(508);
/* unused harmony reexport conforms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__conformsTo_js__ = __webpack_require__(509);
/* unused harmony reexport conformsTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constant_js__ = __webpack_require__(244);
/* unused harmony reexport constant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__countBy_js__ = __webpack_require__(510);
/* unused harmony reexport countBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__create_js__ = __webpack_require__(512);
/* unused harmony reexport create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__curry_js__ = __webpack_require__(513);
/* unused harmony reexport curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__curryRight_js__ = __webpack_require__(514);
/* unused harmony reexport curryRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__debounce_js__ = __webpack_require__(346);
/* unused harmony reexport debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__deburr_js__ = __webpack_require__(333);
/* unused harmony reexport deburr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__defaultTo_js__ = __webpack_require__(515);
/* unused harmony reexport defaultTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__defaults_js__ = __webpack_require__(516);
/* unused harmony reexport defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__defaultsDeep_js__ = __webpack_require__(517);
/* unused harmony reexport defaultsDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__defer_js__ = __webpack_require__(519);
/* unused harmony reexport defer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__delay_js__ = __webpack_require__(520);
/* unused harmony reexport delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__difference_js__ = __webpack_require__(521);
/* unused harmony reexport difference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__differenceBy_js__ = __webpack_require__(523);
/* unused harmony reexport differenceBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__differenceWith_js__ = __webpack_require__(524);
/* unused harmony reexport differenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__divide_js__ = __webpack_require__(525);
/* unused harmony reexport divide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__drop_js__ = __webpack_require__(526);
/* unused harmony reexport drop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__dropRight_js__ = __webpack_require__(527);
/* unused harmony reexport dropRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__dropRightWhile_js__ = __webpack_require__(528);
/* unused harmony reexport dropRightWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__dropWhile_js__ = __webpack_require__(529);
/* unused harmony reexport dropWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__each_js__ = __webpack_require__(530);
/* unused harmony reexport each */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__eachRight_js__ = __webpack_require__(531);
/* unused harmony reexport eachRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__endsWith_js__ = __webpack_require__(533);
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__entries_js__ = __webpack_require__(534);
/* unused harmony reexport entries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__entriesIn_js__ = __webpack_require__(535);
/* unused harmony reexport entriesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__eq_js__ = __webpack_require__(69);
/* unused harmony reexport eq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__escape_js__ = __webpack_require__(355);
/* unused harmony reexport escape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__escapeRegExp_js__ = __webpack_require__(536);
/* unused harmony reexport escapeRegExp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__every_js__ = __webpack_require__(537);
/* unused harmony reexport every */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__extend_js__ = __webpack_require__(538);
/* unused harmony reexport extend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__extendWith_js__ = __webpack_require__(539);
/* unused harmony reexport extendWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__fill_js__ = __webpack_require__(540);
/* unused harmony reexport fill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__filter_js__ = __webpack_require__(541);
/* unused harmony reexport filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__find_js__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_63__find_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__findIndex_js__ = __webpack_require__(357);
/* unused harmony reexport findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__findKey_js__ = __webpack_require__(543);
/* unused harmony reexport findKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__findLast_js__ = __webpack_require__(544);
/* unused harmony reexport findLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__findLastIndex_js__ = __webpack_require__(358);
/* unused harmony reexport findLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__findLastKey_js__ = __webpack_require__(545);
/* unused harmony reexport findLastKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__first_js__ = __webpack_require__(546);
/* unused harmony reexport first */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__flatMap_js__ = __webpack_require__(547);
/* unused harmony reexport flatMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__flatMapDeep_js__ = __webpack_require__(548);
/* unused harmony reexport flatMapDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__flatMapDepth_js__ = __webpack_require__(549);
/* unused harmony reexport flatMapDepth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__flatten_js__ = __webpack_require__(327);
/* unused harmony reexport flatten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__flattenDeep_js__ = __webpack_require__(550);
/* unused harmony reexport flattenDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__flattenDepth_js__ = __webpack_require__(551);
/* unused harmony reexport flattenDepth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__flip_js__ = __webpack_require__(552);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__floor_js__ = __webpack_require__(553);
/* unused harmony reexport floor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__flow_js__ = __webpack_require__(554);
/* unused harmony reexport flow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__flowRight_js__ = __webpack_require__(555);
/* unused harmony reexport flowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__forEach_js__ = __webpack_require__(351);
/* unused harmony reexport forEach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__forEachRight_js__ = __webpack_require__(352);
/* unused harmony reexport forEachRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__forIn_js__ = __webpack_require__(556);
/* unused harmony reexport forIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__forInRight_js__ = __webpack_require__(557);
/* unused harmony reexport forInRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__forOwn_js__ = __webpack_require__(558);
/* unused harmony reexport forOwn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__forOwnRight_js__ = __webpack_require__(559);
/* unused harmony reexport forOwnRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__fromPairs_js__ = __webpack_require__(560);
/* unused harmony reexport fromPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__functions_js__ = __webpack_require__(561);
/* unused harmony reexport functions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__functionsIn_js__ = __webpack_require__(562);
/* unused harmony reexport functionsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__get_js__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_89__get_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__groupBy_js__ = __webpack_require__(563);
/* unused harmony reexport groupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__gt_js__ = __webpack_require__(564);
/* unused harmony reexport gt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__gte_js__ = __webpack_require__(566);
/* unused harmony reexport gte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__has_js__ = __webpack_require__(567);
/* unused harmony reexport has */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__hasIn_js__ = __webpack_require__(253);
/* unused harmony reexport hasIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__head_js__ = __webpack_require__(359);
/* unused harmony reexport head */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__identity_js__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_96__identity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__inRange_js__ = __webpack_require__(568);
/* unused harmony reexport inRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__includes_js__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_98__includes_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__indexOf_js__ = __webpack_require__(571);
/* unused harmony reexport indexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__initial_js__ = __webpack_require__(572);
/* unused harmony reexport initial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__intersection_js__ = __webpack_require__(573);
/* unused harmony reexport intersection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__intersectionBy_js__ = __webpack_require__(576);
/* unused harmony reexport intersectionBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__intersectionWith_js__ = __webpack_require__(577);
/* unused harmony reexport intersectionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__invert_js__ = __webpack_require__(578);
/* unused harmony reexport invert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__invertBy_js__ = __webpack_require__(579);
/* unused harmony reexport invertBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__invoke_js__ = __webpack_require__(580);
/* unused harmony reexport invoke */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__invokeMap_js__ = __webpack_require__(581);
/* unused harmony reexport invokeMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__isArguments_js__ = __webpack_require__(142);
/* unused harmony reexport isArguments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__isArray_js__ = __webpack_require__(14);
/* unused harmony reexport isArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__isArrayBuffer_js__ = __webpack_require__(582);
/* unused harmony reexport isArrayBuffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__isArrayLike_js__ = __webpack_require__(48);
/* unused harmony reexport isArrayLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__isArrayLikeObject_js__ = __webpack_require__(50);
/* unused harmony reexport isArrayLikeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__isBoolean_js__ = __webpack_require__(583);
/* unused harmony reexport isBoolean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__isBuffer_js__ = __webpack_require__(121);
/* unused harmony reexport isBuffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__isDate_js__ = __webpack_require__(584);
/* unused harmony reexport isDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__isElement_js__ = __webpack_require__(585);
/* unused harmony reexport isElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__isEmpty_js__ = __webpack_require__(586);
/* unused harmony reexport isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__isEqual_js__ = __webpack_require__(587);
/* unused harmony reexport isEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__isEqualWith_js__ = __webpack_require__(588);
/* unused harmony reexport isEqualWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__isError_js__ = __webpack_require__(250);
/* unused harmony reexport isError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__isFinite_js__ = __webpack_require__(589);
/* unused harmony reexport isFinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__isFunction_js__ = __webpack_require__(94);
/* unused harmony reexport isFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__isInteger_js__ = __webpack_require__(362);
/* unused harmony reexport isInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__isLength_js__ = __webpack_require__(204);
/* unused harmony reexport isLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__isMap_js__ = __webpack_require__(337);
/* unused harmony reexport isMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__isMatch_js__ = __webpack_require__(590);
/* unused harmony reexport isMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__isMatchWith_js__ = __webpack_require__(591);
/* unused harmony reexport isMatchWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__isNaN_js__ = __webpack_require__(592);
/* unused harmony reexport isNaN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__isNative_js__ = __webpack_require__(593);
/* unused harmony reexport isNative */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__isNil_js__ = __webpack_require__(594);
/* unused harmony reexport isNil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__isNull_js__ = __webpack_require__(595);
/* unused harmony reexport isNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__isNumber_js__ = __webpack_require__(363);
/* unused harmony reexport isNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__isObject_js__ = __webpack_require__(36);
/* unused harmony reexport isObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__isObjectLike_js__ = __webpack_require__(34);
/* unused harmony reexport isObjectLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__isPlainObject_js__ = __webpack_require__(123);
/* unused harmony reexport isPlainObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__isRegExp_js__ = __webpack_require__(256);
/* unused harmony reexport isRegExp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__isSafeInteger_js__ = __webpack_require__(596);
/* unused harmony reexport isSafeInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__isSet_js__ = __webpack_require__(338);
/* unused harmony reexport isSet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__isString_js__ = __webpack_require__(210);
/* unused harmony reexport isString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__isSymbol_js__ = __webpack_require__(68);
/* unused harmony reexport isSymbol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__isTypedArray_js__ = __webpack_require__(143);
/* unused harmony reexport isTypedArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__isUndefined_js__ = __webpack_require__(597);
/* unused harmony reexport isUndefined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__isWeakMap_js__ = __webpack_require__(598);
/* unused harmony reexport isWeakMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__isWeakSet_js__ = __webpack_require__(599);
/* unused harmony reexport isWeakSet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__iteratee_js__ = __webpack_require__(600);
/* unused harmony reexport iteratee */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__join_js__ = __webpack_require__(601);
/* unused harmony reexport join */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__kebabCase_js__ = __webpack_require__(602);
/* unused harmony reexport kebabCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__keyBy_js__ = __webpack_require__(603);
/* unused harmony reexport keyBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__keys_js__ = __webpack_require__(41);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__keysIn_js__ = __webpack_require__(55);
/* unused harmony reexport keysIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__last_js__ = __webpack_require__(63);
/* unused harmony reexport last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__lastIndexOf_js__ = __webpack_require__(604);
/* unused harmony reexport lastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__wrapperLodash_js__ = __webpack_require__(171);
/* unused harmony reexport lodash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__lowerCase_js__ = __webpack_require__(605);
/* unused harmony reexport lowerCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__lowerFirst_js__ = __webpack_require__(606);
/* unused harmony reexport lowerFirst */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__lt_js__ = __webpack_require__(607);
/* unused harmony reexport lt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__lte_js__ = __webpack_require__(609);
/* unused harmony reexport lte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__map_js__ = __webpack_require__(209);
/* unused harmony reexport map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__mapKeys_js__ = __webpack_require__(610);
/* unused harmony reexport mapKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__mapValues_js__ = __webpack_require__(611);
/* unused harmony reexport mapValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__matches_js__ = __webpack_require__(612);
/* unused harmony reexport matches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__matchesProperty_js__ = __webpack_require__(613);
/* unused harmony reexport matchesProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__max_js__ = __webpack_require__(614);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__maxBy_js__ = __webpack_require__(615);
/* unused harmony reexport maxBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__mean_js__ = __webpack_require__(616);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__meanBy_js__ = __webpack_require__(618);
/* unused harmony reexport meanBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__memoize_js__ = __webpack_require__(322);
/* unused harmony reexport memoize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__merge_js__ = __webpack_require__(619);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__mergeWith_js__ = __webpack_require__(349);
/* unused harmony reexport mergeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__method_js__ = __webpack_require__(620);
/* unused harmony reexport method */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__methodOf_js__ = __webpack_require__(621);
/* unused harmony reexport methodOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__min_js__ = __webpack_require__(622);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__minBy_js__ = __webpack_require__(623);
/* unused harmony reexport minBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__mixin_js__ = __webpack_require__(365);
/* unused harmony reexport mixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__multiply_js__ = __webpack_require__(624);
/* unused harmony reexport multiply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__negate_js__ = __webpack_require__(211);
/* unused harmony reexport negate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__next_js__ = __webpack_require__(366);
/* unused harmony reexport next */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__noop_js__ = __webpack_require__(243);
/* unused harmony reexport noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__now_js__ = __webpack_require__(347);
/* unused harmony reexport now */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__nth_js__ = __webpack_require__(625);
/* unused harmony reexport nth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__nthArg_js__ = __webpack_require__(626);
/* unused harmony reexport nthArg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__omit_js__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_182__omit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__omitBy_js__ = __webpack_require__(629);
/* unused harmony reexport omitBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__once_js__ = __webpack_require__(630);
/* unused harmony reexport once */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__orderBy_js__ = __webpack_require__(631);
/* unused harmony reexport orderBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__over_js__ = __webpack_require__(632);
/* unused harmony reexport over */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__overArgs_js__ = __webpack_require__(634);
/* unused harmony reexport overArgs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__overEvery_js__ = __webpack_require__(635);
/* unused harmony reexport overEvery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__overSome_js__ = __webpack_require__(636);
/* unused harmony reexport overSome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__pad_js__ = __webpack_require__(637);
/* unused harmony reexport pad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__padEnd_js__ = __webpack_require__(639);
/* unused harmony reexport padEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__padStart_js__ = __webpack_require__(640);
/* unused harmony reexport padStart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__parseInt_js__ = __webpack_require__(641);
/* unused harmony reexport parseInt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__partial_js__ = __webpack_require__(369);
/* unused harmony reexport partial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__partialRight_js__ = __webpack_require__(642);
/* unused harmony reexport partialRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__partition_js__ = __webpack_require__(643);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__pick_js__ = __webpack_require__(644);
/* unused harmony reexport pick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__pickBy_js__ = __webpack_require__(368);
/* unused harmony reexport pickBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__plant_js__ = __webpack_require__(370);
/* unused harmony reexport plant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__property_js__ = __webpack_require__(344);
/* unused harmony reexport property */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__propertyOf_js__ = __webpack_require__(645);
/* unused harmony reexport propertyOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__pull_js__ = __webpack_require__(646);
/* unused harmony reexport pull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__pullAll_js__ = __webpack_require__(371);
/* unused harmony reexport pullAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__pullAllBy_js__ = __webpack_require__(648);
/* unused harmony reexport pullAllBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__pullAllWith_js__ = __webpack_require__(649);
/* unused harmony reexport pullAllWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__pullAt_js__ = __webpack_require__(650);
/* unused harmony reexport pullAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__random_js__ = __webpack_require__(651);
/* unused harmony reexport random */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__range_js__ = __webpack_require__(653);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__rangeRight_js__ = __webpack_require__(654);
/* unused harmony reexport rangeRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__rearg_js__ = __webpack_require__(655);
/* unused harmony reexport rearg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__reduce_js__ = __webpack_require__(656);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__reduceRight_js__ = __webpack_require__(657);
/* unused harmony reexport reduceRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__reject_js__ = __webpack_require__(658);
/* unused harmony reexport reject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__remove_js__ = __webpack_require__(659);
/* unused harmony reexport remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__repeat_js__ = __webpack_require__(660);
/* unused harmony reexport repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__replace_js__ = __webpack_require__(661);
/* unused harmony reexport replace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__rest_js__ = __webpack_require__(662);
/* unused harmony reexport rest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__result_js__ = __webpack_require__(663);
/* unused harmony reexport result */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__reverse_js__ = __webpack_require__(372);
/* unused harmony reexport reverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__round_js__ = __webpack_require__(664);
/* unused harmony reexport round */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__sample_js__ = __webpack_require__(665);
/* unused harmony reexport sample */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__sampleSize_js__ = __webpack_require__(666);
/* unused harmony reexport sampleSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__set_js__ = __webpack_require__(667);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__setWith_js__ = __webpack_require__(668);
/* unused harmony reexport setWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__shuffle_js__ = __webpack_require__(669);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__size_js__ = __webpack_require__(670);
/* unused harmony reexport size */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__slice_js__ = __webpack_require__(671);
/* unused harmony reexport slice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__snakeCase_js__ = __webpack_require__(672);
/* unused harmony reexport snakeCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__some_js__ = __webpack_require__(673);
/* unused harmony reexport some */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__sortBy_js__ = __webpack_require__(674);
/* unused harmony reexport sortBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__sortedIndex_js__ = __webpack_require__(675);
/* unused harmony reexport sortedIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__sortedIndexBy_js__ = __webpack_require__(677);
/* unused harmony reexport sortedIndexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__sortedIndexOf_js__ = __webpack_require__(678);
/* unused harmony reexport sortedIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__sortedLastIndex_js__ = __webpack_require__(679);
/* unused harmony reexport sortedLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__sortedLastIndexBy_js__ = __webpack_require__(680);
/* unused harmony reexport sortedLastIndexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__sortedLastIndexOf_js__ = __webpack_require__(681);
/* unused harmony reexport sortedLastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__sortedUniq_js__ = __webpack_require__(682);
/* unused harmony reexport sortedUniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__sortedUniqBy_js__ = __webpack_require__(683);
/* unused harmony reexport sortedUniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__split_js__ = __webpack_require__(684);
/* unused harmony reexport split */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__spread_js__ = __webpack_require__(685);
/* unused harmony reexport spread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__startCase_js__ = __webpack_require__(686);
/* unused harmony reexport startCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__startsWith_js__ = __webpack_require__(687);
/* unused harmony reexport startsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__stubArray_js__ = __webpack_require__(252);
/* unused harmony reexport stubArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__stubFalse_js__ = __webpack_require__(247);
/* unused harmony reexport stubFalse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__stubObject_js__ = __webpack_require__(688);
/* unused harmony reexport stubObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__stubString_js__ = __webpack_require__(689);
/* unused harmony reexport stubString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__stubTrue_js__ = __webpack_require__(690);
/* unused harmony reexport stubTrue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__subtract_js__ = __webpack_require__(691);
/* unused harmony reexport subtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__sum_js__ = __webpack_require__(692);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__sumBy_js__ = __webpack_require__(693);
/* unused harmony reexport sumBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__tail_js__ = __webpack_require__(694);
/* unused harmony reexport tail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__take_js__ = __webpack_require__(695);
/* unused harmony reexport take */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__takeRight_js__ = __webpack_require__(696);
/* unused harmony reexport takeRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__takeRightWhile_js__ = __webpack_require__(697);
/* unused harmony reexport takeRightWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__takeWhile_js__ = __webpack_require__(698);
/* unused harmony reexport takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__tap_js__ = __webpack_require__(699);
/* unused harmony reexport tap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__template_js__ = __webpack_require__(700);
/* unused harmony reexport template */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__templateSettings_js__ = __webpack_require__(375);
/* unused harmony reexport templateSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__throttle_js__ = __webpack_require__(701);
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__thru_js__ = __webpack_require__(213);
/* unused harmony reexport thru */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__times_js__ = __webpack_require__(702);
/* unused harmony reexport times */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__toArray_js__ = __webpack_require__(367);
/* unused harmony reexport toArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__toFinite_js__ = __webpack_require__(169);
/* unused harmony reexport toFinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__toInteger_js__ = __webpack_require__(16);
/* unused harmony reexport toInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__toIterator_js__ = __webpack_require__(376);
/* unused harmony reexport toIterator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__toJSON_js__ = __webpack_require__(703);
/* unused harmony reexport toJSON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__toLength_js__ = __webpack_require__(356);
/* unused harmony reexport toLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__toLower_js__ = __webpack_require__(704);
/* unused harmony reexport toLower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__toNumber_js__ = __webpack_require__(104);
/* unused harmony reexport toNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__toPairs_js__ = __webpack_require__(353);
/* unused harmony reexport toPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__toPairsIn_js__ = __webpack_require__(354);
/* unused harmony reexport toPairsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__toPath_js__ = __webpack_require__(705);
/* unused harmony reexport toPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__toPlainObject_js__ = __webpack_require__(348);
/* unused harmony reexport toPlainObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__toSafeInteger_js__ = __webpack_require__(706);
/* unused harmony reexport toSafeInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__toString_js__ = __webpack_require__(25);
/* unused harmony reexport toString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__toUpper_js__ = __webpack_require__(707);
/* unused harmony reexport toUpper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__transform_js__ = __webpack_require__(708);
/* unused harmony reexport transform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__trim_js__ = __webpack_require__(709);
/* unused harmony reexport trim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__trimEnd_js__ = __webpack_require__(710);
/* unused harmony reexport trimEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__trimStart_js__ = __webpack_require__(711);
/* unused harmony reexport trimStart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__truncate_js__ = __webpack_require__(712);
/* unused harmony reexport truncate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__unary_js__ = __webpack_require__(713);
/* unused harmony reexport unary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__unescape_js__ = __webpack_require__(714);
/* unused harmony reexport unescape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__union_js__ = __webpack_require__(715);
/* unused harmony reexport union */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__unionBy_js__ = __webpack_require__(716);
/* unused harmony reexport unionBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__unionWith_js__ = __webpack_require__(717);
/* unused harmony reexport unionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__uniq_js__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_287__uniq_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__uniqBy_js__ = __webpack_require__(719);
/* unused harmony reexport uniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__uniqWith_js__ = __webpack_require__(720);
/* unused harmony reexport uniqWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__uniqueId_js__ = __webpack_require__(721);
/* unused harmony reexport uniqueId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__unset_js__ = __webpack_require__(722);
/* unused harmony reexport unset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__unzip_js__ = __webpack_require__(258);
/* unused harmony reexport unzip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__unzipWith_js__ = __webpack_require__(377);
/* unused harmony reexport unzipWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__update_js__ = __webpack_require__(723);
/* unused harmony reexport update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__updateWith_js__ = __webpack_require__(724);
/* unused harmony reexport updateWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__upperCase_js__ = __webpack_require__(725);
/* unused harmony reexport upperCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__upperFirst_js__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_297__upperFirst_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__value_js__ = __webpack_require__(1931);
/* unused harmony reexport value */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__valueOf_js__ = __webpack_require__(726);
/* unused harmony reexport valueOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__values_js__ = __webpack_require__(151);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__valuesIn_js__ = __webpack_require__(727);
/* unused harmony reexport valuesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__without_js__ = __webpack_require__(728);
/* unused harmony reexport without */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__words_js__ = __webpack_require__(334);
/* unused harmony reexport words */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__wrap_js__ = __webpack_require__(729);
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__wrapperAt_js__ = __webpack_require__(730);
/* unused harmony reexport wrapperAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__wrapperChain_js__ = __webpack_require__(731);
/* unused harmony reexport wrapperChain */
/* unused harmony reexport wrapperCommit */
/* unused harmony reexport wrapperLodash */
/* unused harmony reexport wrapperNext */
/* unused harmony reexport wrapperPlant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__wrapperReverse_js__ = __webpack_require__(732);
/* unused harmony reexport wrapperReverse */
/* unused harmony reexport wrapperToIterator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__wrapperValue_js__ = __webpack_require__(214);
/* unused harmony reexport wrapperValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__xor_js__ = __webpack_require__(733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_309__xor_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__xorBy_js__ = __webpack_require__(735);
/* unused harmony reexport xorBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__xorWith_js__ = __webpack_require__(736);
/* unused harmony reexport xorWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__zip_js__ = __webpack_require__(737);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__zipObject_js__ = __webpack_require__(738);
/* unused harmony reexport zipObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__zipObjectDeep_js__ = __webpack_require__(739);
/* unused harmony reexport zipObjectDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__zipWith_js__ = __webpack_require__(740);
/* unused harmony reexport zipWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__lodash_default_js__ = __webpack_require__(1932);
/* unused harmony reexport default */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */




































































































































































































































































































































/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__ = __webpack_require__(315);


/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = Object(__WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__["a" /* default */])(function(augend, addend) {
  return augend + addend;
}, 0);

/* harmony default export */ __webpack_exports__["a"] = (add);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_js__ = __webpack_require__(16);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_js__["a" /* default */])(n);
  return function() {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (after);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeArgs_js__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countHolders_js__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCtor_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createRecurry_js__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reorder_js__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__replaceHolders_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__root_js__ = __webpack_require__(46);










/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : Object(__WEBPACK_IMPORTED_MODULE_3__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = Object(__WEBPACK_IMPORTED_MODULE_5__getHolder_js__["a" /* default */])(wrapper),
          holdersCount = Object(__WEBPACK_IMPORTED_MODULE_2__countHolders_js__["a" /* default */])(args, placeholder);
    }
    if (partials) {
      args = Object(__WEBPACK_IMPORTED_MODULE_0__composeArgs_js__["a" /* default */])(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = Object(__WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__["a" /* default */])(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = Object(__WEBPACK_IMPORTED_MODULE_7__replaceHolders_js__["a" /* default */])(args, placeholder);
      return Object(__WEBPACK_IMPORTED_MODULE_4__createRecurry_js__["a" /* default */])(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = Object(__WEBPACK_IMPORTED_MODULE_6__reorder_js__["a" /* default */])(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== __WEBPACK_IMPORTED_MODULE_8__root_js__["a" /* default */] && this instanceof wrapper) {
      fn = Ctor || Object(__WEBPACK_IMPORTED_MODULE_3__createCtor_js__["a" /* default */])(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createHybrid);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metaMap_js__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(243);



/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !__WEBPACK_IMPORTED_MODULE_0__metaMap_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */] : function(func) {
  return __WEBPACK_IMPORTED_MODULE_0__metaMap_js__["a" /* default */].get(func);
};

/* harmony default export */ __webpack_exports__["a"] = (getData);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(939);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createAssigner_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isPrototype_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys_js__ = __webpack_require__(41);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = Object(__WEBPACK_IMPORTED_MODULE_2__createAssigner_js__["a" /* default */])(function(object, source) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isPrototype_js__["a" /* default */])(source) || Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(source)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_5__keys_js__["a" /* default */])(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, source[key]);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (assign);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1837);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(41);




/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex, customizer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(source), object, customizer);
});

/* harmony default export */ __webpack_exports__["a"] = (assignWith);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAt_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(122);



/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = Object(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseAt_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (at);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_js__ = __webpack_require__(249);


/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__get_js__["a" /* default */])(object, paths[index]);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseAt);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(68);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1857);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flatRest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(106);






/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = Object(__WEBPACK_IMPORTED_MODULE_3__flatRest_js__["a" /* default */])(function(object, methodNames) {
  Object(__WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */])(methodNames, function(key) {
    key = Object(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(key);
    Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, Object(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(object[key], object));
  });
  return object;
});

/* harmony default export */ __webpack_exports__["a"] = (bindAll);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createWrap_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__ = __webpack_require__(174);





/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes the method at `object[key]` with `partials`
 * prepended to the arguments it receives.
 *
 * This method differs from `_.bind` by allowing bound functions to reference
 * methods that may be redefined or don't yet exist. See
 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
 * for more details.
 *
 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Function
 * @param {Object} object The object to invoke the method on.
 * @param {string} key The key of the method.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var object = {
 *   'user': 'fred',
 *   'greet': function(greeting, punctuation) {
 *     return greeting + ' ' + this.user + punctuation;
 *   }
 * };
 *
 * var bound = _.bindKey(object, 'greet', 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * object.greet = function(greeting, punctuation) {
 *   return greeting + 'ya ' + this.user + punctuation;
 * };
 *
 * bound('!');
 * // => 'hiya fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bindKey(object, 'greet', _, '!');
 * bound('hi');
 * // => 'hiya fred!'
 */
var bindKey = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, key, partials) {
  var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
  if (partials.length) {
    var holders = Object(__WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__["a" /* default */])(partials, Object(__WEBPACK_IMPORTED_MODULE_2__getHolder_js__["a" /* default */])(bindKey));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__createWrap_js__["a" /* default */])(key, bitmask, object, partials, holders);
});

// Assign default placeholders.
bindKey.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (bindKey);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCompounder_js__ = __webpack_require__(208);



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = Object(__WEBPACK_IMPORTED_MODULE_1__createCompounder_js__["a" /* default */])(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? Object(__WEBPACK_IMPORTED_MODULE_0__capitalize_js__["a" /* default */])(word) : word);
});

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayReduce);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyOf);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(14);


/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value) ? value : [value];
}

/* harmony default export */ __webpack_exports__["a"] = (castArray);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRound_js__ = __webpack_require__(490);


/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = Object(__WEBPACK_IMPORTED_MODULE_0__createRound_js__["a" /* default */])('ceil');

/* harmony default export */ __webpack_exports__["a"] = (ceil);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(number);
    precision = precision == null ? 0 : nativeMin(Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createRound);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, index, (index += size));
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (chunk);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(104);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);


/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (clone);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(252);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(55);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(954);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeep);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeepWith);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);


/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneWith);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (compact);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(array) ? Object(__WEBPACK_IMPORTED_MODULE_2__copyArray_js__["a" /* default */])(array) : [array], Object(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(args, 1));
}

/* harmony default export */ __webpack_exports__["a"] = (concat);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseRest_js__ = __webpack_require__(15);





/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */];

  pairs = !length ? [] : Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return Object(__WEBPACK_IMPORTED_MODULE_3__baseRest_js__["a" /* default */])(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(pair[0], this, args)) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(pair[1], this, args);
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (cond);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(340);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseConforms_js__ = __webpack_require__(1889);



/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseConforms_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(source, CLONE_DEEP_FLAG));
}

/* harmony default export */ __webpack_exports__["a"] = (conforms);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseConformsTo_js__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || Object(__WEBPACK_IMPORTED_MODULE_0__baseConformsTo_js__["a" /* default */])(object, source, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source));
}

/* harmony default export */ __webpack_exports__["a"] = (conformsTo);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAggregator_js__ = __webpack_require__(345);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = Object(__WEBPACK_IMPORTED_MODULE_1__createAggregator_js__["a" /* default */])(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, 1);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (countBy);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(964);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssign_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseCreate_js__ = __webpack_require__(200);



/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__baseCreate_js__["a" /* default */])(prototype);
  return properties == null ? result : Object(__WEBPACK_IMPORTED_MODULE_0__baseAssign_js__["a" /* default */])(result, properties);
}

/* harmony default export */ __webpack_exports__["a"] = (create);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWrap_js__ = __webpack_require__(117);


/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__createWrap_js__["a" /* default */])(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (curry);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWrap_js__ = __webpack_require__(117);


/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__createWrap_js__["a" /* default */])(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (curryRight);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

/* harmony default export */ __webpack_exports__["a"] = (defaultTo);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keysIn_js__ = __webpack_require__(55);





/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && Object(__WEBPACK_IMPORTED_MODULE_2__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = Object(__WEBPACK_IMPORTED_MODULE_3__keysIn_js__["a" /* default */])(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/* harmony default export */ __webpack_exports__["a"] = (defaults);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customDefaultsMerge_js__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mergeWith_js__ = __webpack_require__(349);





/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(args) {
  args.push(undefined, __WEBPACK_IMPORTED_MODULE_2__customDefaultsMerge_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__mergeWith_js__["a" /* default */], undefined, args);
});

/* harmony default export */ __webpack_exports__["a"] = (defaultsDeep);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(967);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDelay_js__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);



/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(func, args) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseDelay_js__["a" /* default */])(func, 1, args);
});

/* harmony default export */ __webpack_exports__["a"] = (defer);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDelay_js__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(104);




/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(func, wait, args) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseDelay_js__["a" /* default */])(func, Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0, args);
});

/* harmony default export */ __webpack_exports__["a"] = (delay);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);





/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(array, values) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */])(array)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(values, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true))
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (difference);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayIncludesWith);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__last_js__ = __webpack_require__(63);







/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = Object(__WEBPACK_IMPORTED_MODULE_3__baseRest_js__["a" /* default */])(function(array, values) {
  var iteratee = Object(__WEBPACK_IMPORTED_MODULE_5__last_js__["a" /* default */])(values);
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */])(iteratee)) {
    iteratee = undefined;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */])(array)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(values, 1, __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */], true), Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 2))
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (differenceBy);


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__last_js__ = __webpack_require__(63);






/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(array, values) {
  var comparator = Object(__WEBPACK_IMPORTED_MODULE_4__last_js__["a" /* default */])(values);
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */])(comparator)) {
    comparator = undefined;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */])(array)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(values, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true), undefined, comparator)
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (differenceWith);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__ = __webpack_require__(315);


/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = Object(__WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__["a" /* default */])(function(dividend, divisor) {
  return dividend / divisor;
}, 1);

/* harmony default export */ __webpack_exports__["a"] = (divide);


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ __webpack_exports__["a"] = (drop);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  n = length - n;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ __webpack_exports__["a"] = (dropRight);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseWhile_js__ = __webpack_require__(350);



/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseWhile_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3), true, true)
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (dropRightWhile);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseWhile_js__ = __webpack_require__(350);



/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseWhile_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3), true)
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (dropWhile);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEach_js__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__forEach_js__["a"]; });



/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEachRight_js__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__forEachRight_js__["a"]; });



/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForRight_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseForRight_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwnRight);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  target = Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(target);

  var length = string.length;
  position = position === undefined
    ? length
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

/* harmony default export */ __webpack_exports__["a"] = (endsWith);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPairs_js__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__toPairs_js__["a"]; });



/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPairsIn_js__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__toPairsIn_js__["a"]; });



/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (escapeRegExp);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEvery_js__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__ = __webpack_require__(62);






/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEvery_js__["a" /* default */];
  if (guard && Object(__WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__["a" /* default */])(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (every);


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignIn_js__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__assignIn_js__["a"]; });



/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignInWith_js__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__assignInWith_js__["a"]; });



/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFill_js__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);



/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(array, value, start)) {
    start = 0;
    end = length;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFill_js__["a" /* default */])(array, value, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (fill);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);





/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (filter);


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFind_js__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(357);



/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = Object(__WEBPACK_IMPORTED_MODULE_0__createFind_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (find);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindKey_js__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);




/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFindKey_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3), __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (findKey);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFind_js__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findLastIndex_js__ = __webpack_require__(358);



/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = Object(__WEBPACK_IMPORTED_MODULE_0__createFind_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__findLastIndex_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (findLast);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindKey_js__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwnRight_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);




/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFindKey_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3), __WEBPACK_IMPORTED_MODULE_1__baseForOwnRight_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (findLastKey);


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__head_js__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__head_js__["a"]; });



/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(209);



/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(collection, iteratee), 1);
}

/* harmony default export */ __webpack_exports__["a"] = (flatMap);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(209);



/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(collection, iteratee), INFINITY);
}

/* harmony default export */ __webpack_exports__["a"] = (flatMapDeep);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(depth);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__map_js__["a" /* default */])(collection, iteratee), depth);
}

/* harmony default export */ __webpack_exports__["a"] = (flatMapDepth);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(array, INFINITY) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (flattenDeep);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(depth);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(array, depth);
}

/* harmony default export */ __webpack_exports__["a"] = (flattenDepth);


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWrap_js__ = __webpack_require__(117);


/** Used to compose bitmasks for function metadata. */
var WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that invokes `func` with arguments reversed.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to flip arguments for.
 * @returns {Function} Returns the new flipped function.
 * @example
 *
 * var flipped = _.flip(function() {
 *   return _.toArray(arguments);
 * });
 *
 * flipped('a', 'b', 'c', 'd');
 * // => ['d', 'c', 'b', 'a']
 */
function flip(func) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__createWrap_js__["a" /* default */])(func, WRAP_FLIP_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (flip);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRound_js__ = __webpack_require__(490);


/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = Object(__WEBPACK_IMPORTED_MODULE_0__createRound_js__["a" /* default */])('floor');

/* harmony default export */ __webpack_exports__["a"] = (floor);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFlow_js__ = __webpack_require__(977);


/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = Object(__WEBPACK_IMPORTED_MODULE_0__createFlow_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (flow);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFlow_js__ = __webpack_require__(977);


/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = Object(__WEBPACK_IMPORTED_MODULE_0__createFlow_js__["a" /* default */])(true);

/* harmony default export */ __webpack_exports__["a"] = (flowRight);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(55);




/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee), __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (forIn);


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForRight_js__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(55);




/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseForRight_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee), __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (forInRight);


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);



/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forOwn);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwnRight_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);



/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseForOwnRight_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forOwnRight);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (fromPairs);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFunctions_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseFunctions_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (functions);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFunctions_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(55);



/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseFunctions_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (functionsIn);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAggregator_js__ = __webpack_require__(345);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = Object(__WEBPACK_IMPORTED_MODULE_1__createAggregator_js__["a" /* default */])(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, [value]);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (groupBy);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGt_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRelationalOperation_js__ = __webpack_require__(361);



/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = Object(__WEBPACK_IMPORTED_MODULE_1__createRelationalOperation_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseGt_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (gt);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGt);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRelationalOperation_js__ = __webpack_require__(361);


/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = Object(__WEBPACK_IMPORTED_MODULE_0__createRelationalOperation_js__["a" /* default */])(function(value, other) {
  return value >= other;
});

/* harmony default export */ __webpack_exports__["a"] = (gte);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHas_js__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(962);



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHas_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (has);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInRange_js__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toFinite_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(104);




/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = Object(__WEBPACK_IMPORTED_MODULE_1__toFinite_js__["a" /* default */])(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = Object(__WEBPACK_IMPORTED_MODULE_1__toFinite_js__["a" /* default */])(end);
  }
  number = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(number);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseInRange_js__["a" /* default */])(number, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (inRange);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__(151);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : Object(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(array, value, index);
}

/* harmony default export */ __webpack_exports__["a"] = (indexOf);


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);


/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 0, -1) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (initial);


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__ = __webpack_require__(575);





/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(arrays) {
  var mapped = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__["a" /* default */]);
  return (mapped.length && mapped[0] === arrays[0])
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__["a" /* default */])(mapped)
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (intersection);


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__ = __webpack_require__(342);







/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = Object(__WEBPACK_IMPORTED_MODULE_3__arrayMap_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */](othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? Object(__WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */])(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? Object(__WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */])(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIntersection);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLikeObject_js__ = __webpack_require__(50);


/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLikeObject_js__["a" /* default */])(value) ? value : [];
}

/* harmony default export */ __webpack_exports__["a"] = (castArrayLikeObject);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__castArrayLikeObject_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__last_js__ = __webpack_require__(63);







/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = Object(__WEBPACK_IMPORTED_MODULE_3__baseRest_js__["a" /* default */])(function(arrays) {
  var iteratee = Object(__WEBPACK_IMPORTED_MODULE_5__last_js__["a" /* default */])(arrays),
      mapped = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_4__castArrayLikeObject_js__["a" /* default */]);

  if (iteratee === Object(__WEBPACK_IMPORTED_MODULE_5__last_js__["a" /* default */])(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__["a" /* default */])(mapped, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 2))
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (intersectionBy);


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__last_js__ = __webpack_require__(63);






/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(arrays) {
  var comparator = Object(__WEBPACK_IMPORTED_MODULE_4__last_js__["a" /* default */])(arrays),
      mapped = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__["a" /* default */]);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__["a" /* default */])(mapped, undefined, comparator)
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (intersectionWith);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createInverter_js__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(47);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = Object(__WEBPACK_IMPORTED_MODULE_1__createInverter_js__["a" /* default */])(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (invert);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createInverter_js__ = __webpack_require__(978);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = Object(__WEBPACK_IMPORTED_MODULE_1__createInverter_js__["a" /* default */])(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  if (hasOwnProperty.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (invertBy);


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);



/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (invoke);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseInvoke_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(48);






/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = Object(__WEBPACK_IMPORTED_MODULE_3__baseRest_js__["a" /* default */])(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(collection) ? Array(collection.length) : [];

  Object(__WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */])(collection, function(value) {
    result[++index] = isFunc ? Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(path, value, args) : Object(__WEBPACK_IMPORTED_MODULE_2__baseInvoke_js__["a" /* default */])(value, path, args);
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (invokeMap);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArrayBuffer_js__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsArrayBuffer = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsArrayBuffer) : __WEBPACK_IMPORTED_MODULE_0__baseIsArrayBuffer_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isArrayBuffer);


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == boolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isBoolean);


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsDate_js__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(205);




/* Node.js helper references. */
var nodeIsDate = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsDate) : __WEBPACK_IMPORTED_MODULE_0__baseIsDate_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isDate);


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObjectLike_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlainObject_js__ = __webpack_require__(123);



/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isObjectLike_js__["a" /* default */])(value) && value.nodeType === 1 && !Object(__WEBPACK_IMPORTED_MODULE_1__isPlainObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isElement);


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(143);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(340);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(340);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isFinite);


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(506);



/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source));
}

/* harmony default export */ __webpack_exports__["a"] = (isMatch);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(506);



/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source), customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (isMatchWith);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isNumber_js__ = __webpack_require__(363);


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return Object(__WEBPACK_IMPORTED_MODULE_0__isNumber_js__["a" /* default */])(value) && value != +value;
}

/* harmony default export */ __webpack_exports__["a"] = (isNaN);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMaskable_js__ = __webpack_require__(1905);



/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isMaskable_js__["a" /* default */])(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isNative);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNull);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isInteger_js__ = __webpack_require__(362);


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isInteger_js__["a" /* default */])(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isSafeInteger);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == weakMapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isWeakMap);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == weakSetTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isWeakSet);


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);



/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(typeof func == 'function' ? func : Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(func, CLONE_DEEP_FLAG));
}

/* harmony default export */ __webpack_exports__["a"] = (iteratee);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/* harmony default export */ __webpack_exports__["a"] = (join);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(208);


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/* harmony default export */ __webpack_exports__["a"] = (kebabCase);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAggregator_js__ = __webpack_require__(345);



/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = Object(__WEBPACK_IMPORTED_MODULE_1__createAggregator_js__["a" /* default */])(function(result, value, key) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, value);
});

/* harmony default export */ __webpack_exports__["a"] = (keyBy);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictLastIndexOf_js__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(16);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex);
    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
  }
  return value === value
    ? Object(__WEBPACK_IMPORTED_MODULE_2__strictLastIndexOf_js__["a" /* default */])(array, value, index)
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], index, true);
}

/* harmony default export */ __webpack_exports__["a"] = (lastIndexOf);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(208);


/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

/* harmony default export */ __webpack_exports__["a"] = (lowerCase);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__ = __webpack_require__(947);


/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = Object(__WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__["a" /* default */])('toLowerCase');

/* harmony default export */ __webpack_exports__["a"] = (lowerFirst);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseLt_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRelationalOperation_js__ = __webpack_require__(361);



/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = Object(__WEBPACK_IMPORTED_MODULE_1__createRelationalOperation_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseLt_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (lt);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/* harmony default export */ __webpack_exports__["a"] = (baseLt);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRelationalOperation_js__ = __webpack_require__(361);


/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = Object(__WEBPACK_IMPORTED_MODULE_0__createRelationalOperation_js__["a" /* default */])(function(value, other) {
  return value <= other;
});

/* harmony default export */ __webpack_exports__["a"] = (lte);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);




/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, iteratee(value, key, object), value);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapKeys);


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatches_js__ = __webpack_require__(957);



/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseMatches_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(source, CLONE_DEEP_FLAG));
}

/* harmony default export */ __webpack_exports__["a"] = (matches);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(961);



/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 */
function matchesProperty(path, srcValue) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(path, Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(srcValue, CLONE_DEEP_FLAG));
}

/* harmony default export */ __webpack_exports__["a"] = (matchesProperty);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseGt_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(47);




/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__baseGt_js__["a" /* default */])
    : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (max);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseGt_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);




/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 2), __WEBPACK_IMPORTED_MODULE_1__baseGt_js__["a" /* default */])
    : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (maxBy);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMean_js__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(47);



/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseMean_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (mean);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSum);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMean_js__ = __webpack_require__(980);



/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseMean_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2));
}

/* harmony default export */ __webpack_exports__["a"] = (meanBy);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(203);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);



/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(path, args) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__["a" /* default */])(object, path, args);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (method);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);



/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(object, args) {
  return function(path) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__["a" /* default */])(object, path, args);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (methodOf);


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLt_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(47);




/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__baseLt_js__["a" /* default */])
    : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (min);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseLt_js__ = __webpack_require__(608);




/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 2), __WEBPACK_IMPORTED_MODULE_2__baseLt_js__["a" /* default */])
    : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (minBy);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__ = __webpack_require__(315);


/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = Object(__WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__["a" /* default */])(function(multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

/* harmony default export */ __webpack_exports__["a"] = (multiply);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseNth_js__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseNth_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n)) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (nth);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseNth_js__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(n);
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(args) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseNth_js__["a" /* default */])(args, n);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (nthArg);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseClone_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUnset_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customOmitClone_js__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flatRest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getAllKeysIn_js__ = __webpack_require__(495);









/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = Object(__WEBPACK_IMPORTED_MODULE_6__flatRest_js__["a" /* default */])(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(paths, function(path) {
    path = Object(__WEBPACK_IMPORTED_MODULE_3__castPath_js__["a" /* default */])(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  Object(__WEBPACK_IMPORTED_MODULE_4__copyObject_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_7__getAllKeysIn_js__["a" /* default */])(object), result);
  if (isDeep) {
    result = Object(__WEBPACK_IMPORTED_MODULE_1__baseClone_js__["a" /* default */])(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, __WEBPACK_IMPORTED_MODULE_5__customOmitClone_js__["a" /* default */]);
  }
  var length = paths.length;
  while (length--) {
    Object(__WEBPACK_IMPORTED_MODULE_2__baseUnset_js__["a" /* default */])(result, paths[length]);
  }
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (omit);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__last_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parent_js__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(106);





/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);
  object = Object(__WEBPACK_IMPORTED_MODULE_2__parent_js__["a" /* default */])(object, path);
  return object == null || delete object[Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__last_js__["a" /* default */])(path))];
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnset);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__negate_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pickBy_js__ = __webpack_require__(368);




/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__pickBy_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate)));
}

/* harmony default export */ __webpack_exports__["a"] = (omitBy);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__before_js__ = __webpack_require__(330);


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__before_js__["a" /* default */])(2, func);
}

/* harmony default export */ __webpack_exports__["a"] = (once);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseOrderBy_js__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(14);



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseOrderBy_js__["a" /* default */])(collection, iteratees, orders);
}

/* harmony default export */ __webpack_exports__["a"] = (orderBy);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createOver_js__ = __webpack_require__(633);



/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = Object(__WEBPACK_IMPORTED_MODULE_1__createOver_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (over);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatRest_js__ = __webpack_require__(122);







/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__flatRest_js__["a" /* default */])(function(iteratees) {
    iteratees = Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(iteratees, Object(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */]));
    return Object(__WEBPACK_IMPORTED_MODULE_3__baseRest_js__["a" /* default */])(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(iteratee, thisArg, args);
      });
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createOver);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__castRest_js__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArray_js__ = __webpack_require__(14);









/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function that invokes `func` with its arguments transformed.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Function
 * @param {Function} func The function to wrap.
 * @param {...(Function|Function[])} [transforms=[_.identity]]
 *  The argument transforms.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function doubled(n) {
 *   return n * 2;
 * }
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var func = _.overArgs(function(x, y) {
 *   return [x, y];
 * }, [square, doubled]);
 *
 * func(9, 3);
 * // => [81, 6]
 *
 * func(10, 5);
 * // => [100, 10]
 */
var overArgs = Object(__WEBPACK_IMPORTED_MODULE_6__castRest_js__["a" /* default */])(function(func, transforms) {
  transforms = (transforms.length == 1 && Object(__WEBPACK_IMPORTED_MODULE_7__isArray_js__["a" /* default */])(transforms[0]))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(transforms[0], Object(__WEBPACK_IMPORTED_MODULE_5__baseUnary_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__["a" /* default */]))
    : Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__baseFlatten_js__["a" /* default */])(transforms, 1), Object(__WEBPACK_IMPORTED_MODULE_5__baseUnary_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__["a" /* default */]));

  var funcsLength = transforms.length;
  return Object(__WEBPACK_IMPORTED_MODULE_4__baseRest_js__["a" /* default */])(function(args) {
    var index = -1,
        length = nativeMin(args.length, funcsLength);

    while (++index < length) {
      args[index] = transforms[index].call(this, args[index]);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, args);
  });
});

/* harmony default export */ __webpack_exports__["a"] = (overArgs);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createOver_js__ = __webpack_require__(633);



/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = Object(__WEBPACK_IMPORTED_MODULE_1__createOver_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (overEvery);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySome_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createOver_js__ = __webpack_require__(633);



/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 */
var overSome = Object(__WEBPACK_IMPORTED_MODULE_1__createOver_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__arraySome_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (overSome);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPadding_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringSize_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeFloor = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  length = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(length);

  var strLength = length ? Object(__WEBPACK_IMPORTED_MODULE_1__stringSize_js__["a" /* default */])(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return (
    Object(__WEBPACK_IMPORTED_MODULE_0__createPadding_js__["a" /* default */])(nativeFloor(mid), chars) +
    string +
    Object(__WEBPACK_IMPORTED_MODULE_0__createPadding_js__["a" /* default */])(nativeCeil(mid), chars)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (pad);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringSize_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringToArray_js__ = __webpack_require__(147);







/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? Object(__WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__["a" /* default */])(chars, length) : chars;
  }
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__["a" /* default */])(chars, nativeCeil(length / Object(__WEBPACK_IMPORTED_MODULE_4__stringSize_js__["a" /* default */])(chars)));
  return Object(__WEBPACK_IMPORTED_MODULE_3__hasUnicode_js__["a" /* default */])(chars)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__castSlice_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__stringToArray_js__["a" /* default */])(result), 0, length).join('')
    : result.slice(0, length);
}

/* harmony default export */ __webpack_exports__["a"] = (createPadding);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPadding_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringSize_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  length = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(length);

  var strLength = length ? Object(__WEBPACK_IMPORTED_MODULE_1__stringSize_js__["a" /* default */])(string) : 0;
  return (length && strLength < length)
    ? (string + Object(__WEBPACK_IMPORTED_MODULE_0__createPadding_js__["a" /* default */])(length - strLength, chars))
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (padEnd);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPadding_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringSize_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  length = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(length);

  var strLength = length ? Object(__WEBPACK_IMPORTED_MODULE_1__stringSize_js__["a" /* default */])(string) : 0;
  return (length && strLength < length)
    ? (Object(__WEBPACK_IMPORTED_MODULE_0__createPadding_js__["a" /* default */])(length - strLength, chars) + string)
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (padStart);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(25);



/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(Object(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(string).replace(reTrimStart, ''), radix || 0);
}

/* harmony default export */ __webpack_exports__["a"] = (parseInt);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createWrap_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__ = __webpack_require__(174);





/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(func, partials) {
  var holders = Object(__WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__["a" /* default */])(partials, Object(__WEBPACK_IMPORTED_MODULE_2__getHolder_js__["a" /* default */])(partialRight));
  return Object(__WEBPACK_IMPORTED_MODULE_1__createWrap_js__["a" /* default */])(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (partialRight);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAggregator_js__ = __webpack_require__(345);


/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = Object(__WEBPACK_IMPORTED_MODULE_0__createAggregator_js__["a" /* default */])(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

/* harmony default export */ __webpack_exports__["a"] = (partition);


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePick_js__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(122);



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = Object(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(function(object, paths) {
  return object == null ? {} : Object(__WEBPACK_IMPORTED_MODULE_0__basePick_js__["a" /* default */])(object, paths);
});

/* harmony default export */ __webpack_exports__["a"] = (pick);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);


/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function(path) {
    return object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (propertyOf);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pullAll_js__ = __webpack_require__(371);



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__pullAll_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (pull);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIndexOf_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIndexOfWith_js__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__copyArray_js__ = __webpack_require__(83);






/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? __WEBPACK_IMPORTED_MODULE_2__baseIndexOfWith_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseIndexOf_js__["a" /* default */],
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = Object(__WEBPACK_IMPORTED_MODULE_4__copyArray_js__["a" /* default */])(values);
  }
  if (iteratee) {
    seen = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_3__baseUnary_js__["a" /* default */])(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (basePullAll);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePullAll_js__ = __webpack_require__(647);



/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__basePullAll_js__["a" /* default */])(array, values, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2))
    : array;
}

/* harmony default export */ __webpack_exports__["a"] = (pullAllBy);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePullAll_js__ = __webpack_require__(647);


/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__basePullAll_js__["a" /* default */])(array, values, undefined, comparator)
    : array;
}

/* harmony default export */ __webpack_exports__["a"] = (pullAllWith);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAt_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basePullAt_js__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compareAscending_js__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flatRest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isIndex_js__ = __webpack_require__(119);







/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = Object(__WEBPACK_IMPORTED_MODULE_4__flatRest_js__["a" /* default */])(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = Object(__WEBPACK_IMPORTED_MODULE_1__baseAt_js__["a" /* default */])(array, indexes);

  Object(__WEBPACK_IMPORTED_MODULE_2__basePullAt_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(indexes, function(index) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__isIndex_js__["a" /* default */])(index, length) ? +index : index;
  }).sort(__WEBPACK_IMPORTED_MODULE_3__compareAscending_js__["a" /* default */]));

  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (pullAt);


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRandom_js__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toFinite_js__ = __webpack_require__(169);




/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = Object(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = Object(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRandom_js__["a" /* default */])(lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (random);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

/* harmony default export */ __webpack_exports__["a"] = (baseRandom);


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRange_js__ = __webpack_require__(987);


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = Object(__WEBPACK_IMPORTED_MODULE_0__createRange_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (range);


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRange_js__ = __webpack_require__(987);


/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = Object(__WEBPACK_IMPORTED_MODULE_0__createRange_js__["a" /* default */])(true);

/* harmony default export */ __webpack_exports__["a"] = (rangeRight);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createWrap_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(122);



/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = Object(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(function(func, indexes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__createWrap_js__["a" /* default */])(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

/* harmony default export */ __webpack_exports__["a"] = (rearg);


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArray_js__ = __webpack_require__(14);






/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_4__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__["a" /* default */],
      initAccum = arguments.length < 3;

  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 4), accumulator, initAccum, __WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (reduce);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduceRight_js__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEachRight_js__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArray_js__ = __webpack_require__(14);






/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_4__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayReduceRight_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__["a" /* default */],
      initAccum = arguments.length < 3;

  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 4), accumulator, initAccum, __WEBPACK_IMPORTED_MODULE_1__baseEachRight_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (reduceRight);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__negate_js__ = __webpack_require__(211);






/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__["a" /* default */];
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_4__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3)));
}

/* harmony default export */ __webpack_exports__["a"] = (reject);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePullAt_js__ = __webpack_require__(986);



/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__basePullAt_js__["a" /* default */])(array, indexes);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (remove);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(n);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string), n);
}

/* harmony default export */ __webpack_exports__["a"] = (repeat);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);


/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

/* harmony default export */ __webpack_exports__["a"] = (replace);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = start === undefined ? start : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(start);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(func, start);
}

/* harmony default export */ __webpack_exports__["a"] = (rest);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toKey_js__ = __webpack_require__(106);




/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[Object(__WEBPACK_IMPORTED_MODULE_2__toKey_js__["a" /* default */])(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = Object(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(value) ? value.call(object) : value;
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (result);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRound_js__ = __webpack_require__(490);


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = Object(__WEBPACK_IMPORTED_MODULE_0__createRound_js__["a" /* default */])('round');

/* harmony default export */ __webpack_exports__["a"] = (round);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySample_js__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSample_js__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);




/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arraySample_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseSample_js__["a" /* default */];
  return func(collection);
}

/* harmony default export */ __webpack_exports__["a"] = (sample);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySampleSize_js__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSampleSize_js__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toInteger_js__ = __webpack_require__(16);






/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? Object(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = Object(__WEBPACK_IMPORTED_MODULE_4__toInteger_js__["a" /* default */])(n);
  }
  var func = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arraySampleSize_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseSampleSize_js__["a" /* default */];
  return func(collection, n);
}

/* harmony default export */ __webpack_exports__["a"] = (sampleSize);


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSet_js__ = __webpack_require__(257);


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : Object(__WEBPACK_IMPORTED_MODULE_0__baseSet_js__["a" /* default */])(object, path, value);
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSet_js__ = __webpack_require__(257);


/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : Object(__WEBPACK_IMPORTED_MODULE_0__baseSet_js__["a" /* default */])(object, path, value, customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (setWith);


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayShuffle_js__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseShuffle_js__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);




/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayShuffle_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseShuffle_js__["a" /* default */];
  return func(collection);
}

/* harmony default export */ __webpack_exports__["a"] = (shuffle);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isString_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringSize_js__ = __webpack_require__(212);






/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(collection)) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isString_js__["a" /* default */])(collection) ? Object(__WEBPACK_IMPORTED_MODULE_4__stringSize_js__["a" /* default */])(collection) : collection.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(collection).length;
}

/* harmony default export */ __webpack_exports__["a"] = (size);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(start);
    end = end === undefined ? length : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(end);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (slice);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(208);


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/* harmony default export */ __webpack_exports__["a"] = (snakeCase);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySome_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseSome_js__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__ = __webpack_require__(62);






/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arraySome_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseSome_js__["a" /* default */];
  if (guard && Object(__WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__["a" /* default */])(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (some);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseOrderBy_js__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__ = __webpack_require__(62);





/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && Object(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && Object(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseOrderBy_js__["a" /* default */])(collection, Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(iteratees, 1), []);
});

/* harmony default export */ __webpack_exports__["a"] = (sortBy);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__ = __webpack_require__(374);


/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__["a" /* default */])(array, value);
}

/* harmony default export */ __webpack_exports__["a"] = (sortedIndex);


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(68);


/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  value = iteratee(value);

  var low = 0,
      high = array == null ? 0 : array.length,
      valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin(high, MAX_ARRAY_INDEX);
}

/* harmony default export */ __webpack_exports__["a"] = (baseSortedIndexBy);


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSortedIndexBy_js__ = __webpack_require__(676);



/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseSortedIndexBy_js__["a" /* default */])(array, value, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2));
}

/* harmony default export */ __webpack_exports__["a"] = (sortedIndexBy);


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(69);



/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__["a" /* default */])(array, value);
    if (index < length && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (sortedIndexOf);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__ = __webpack_require__(374);


/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__["a" /* default */])(array, value, true);
}

/* harmony default export */ __webpack_exports__["a"] = (sortedLastIndex);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSortedIndexBy_js__ = __webpack_require__(676);



/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseSortedIndexBy_js__["a" /* default */])(array, value, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2), true);
}

/* harmony default export */ __webpack_exports__["a"] = (sortedLastIndexBy);


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(69);



/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedIndex_js__["a" /* default */])(array, value, true) - 1;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (sortedLastIndexOf);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSortedUniq_js__ = __webpack_require__(990);


/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseSortedUniq_js__["a" /* default */])(array)
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (sortedUniq);


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSortedUniq_js__ = __webpack_require__(990);



/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseSortedUniq_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2))
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (sortedUniqBy);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isRegExp_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(25);








/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && Object(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !Object(__WEBPACK_IMPORTED_MODULE_4__isRegExp_js__["a" /* default */])(separator))
      )) {
    separator = Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(separator);
    if (!separator && Object(__WEBPACK_IMPORTED_MODULE_2__hasUnicode_js__["a" /* default */])(string)) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__castSlice_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__stringToArray_js__["a" /* default */])(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

/* harmony default export */ __webpack_exports__["a"] = (split);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toInteger_js__ = __webpack_require__(16);






/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = start == null ? 0 : nativeMax(Object(__WEBPACK_IMPORTED_MODULE_4__toInteger_js__["a" /* default */])(start), 0);
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(args) {
    var array = args[start],
        otherArgs = Object(__WEBPACK_IMPORTED_MODULE_3__castSlice_js__["a" /* default */])(args, 0, start);

    if (array) {
      Object(__WEBPACK_IMPORTED_MODULE_1__arrayPush_js__["a" /* default */])(otherArgs, array);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (spread);


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upperFirst_js__ = __webpack_require__(251);



/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? ' ' : '') + Object(__WEBPACK_IMPORTED_MODULE_1__upperFirst_js__["a" /* default */])(word);
});

/* harmony default export */ __webpack_exports__["a"] = (startCase);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  position = position == null
    ? 0
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(position), 0, string.length);

  target = Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(target);
  return string.slice(position, position + target.length) == target;
}

/* harmony default export */ __webpack_exports__["a"] = (startsWith);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (stubObject);


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (stubString);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (stubTrue);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__ = __webpack_require__(315);


/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = Object(__WEBPACK_IMPORTED_MODULE_0__createMathOperation_js__["a" /* default */])(function(minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

/* harmony default export */ __webpack_exports__["a"] = (subtract);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSum_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(47);



/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseSum_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */])
    : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (sum);


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSum_js__ = __webpack_require__(617);



/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseSum_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2))
    : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (sumBy);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);


/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 1, length) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (tail);


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ __webpack_exports__["a"] = (take);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  n = length - n;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ __webpack_exports__["a"] = (takeRight);


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseWhile_js__ = __webpack_require__(350);



/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseWhile_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3), false, true)
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (takeRightWhile);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseWhile_js__ = __webpack_require__(350);



/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? Object(__WEBPACK_IMPORTED_MODULE_1__baseWhile_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3))
    : [];
}

/* harmony default export */ __webpack_exports__["a"] = (takeWhile);


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method invokes `interceptor` and returns `value`. The interceptor
 * is invoked with one argument; (value). The purpose of this method is to
 * "tap into" a method chain sequence in order to modify intermediate results.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns `value`.
 * @example
 *
 * _([1, 2, 3])
 *  .tap(function(array) {
 *    // Mutate input array.
 *    array.pop();
 *  })
 *  .reverse()
 *  .value();
 * // => [2, 1]
 */
function tap(value, interceptor) {
  interceptor(value);
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (tap);


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignInWith_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attempt_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseValues_js__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customDefaultsAssignIn_js__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__escapeStringChar_js__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isError_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reInterpolate_js__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__templateSettings_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toString_js__ = __webpack_require__(25);












/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = __WEBPACK_IMPORTED_MODULE_9__templateSettings_js__["a" /* default */].imports._.templateSettings || __WEBPACK_IMPORTED_MODULE_9__templateSettings_js__["a" /* default */];

  if (guard && Object(__WEBPACK_IMPORTED_MODULE_6__isIterateeCall_js__["a" /* default */])(string, options, guard)) {
    options = undefined;
  }
  string = Object(__WEBPACK_IMPORTED_MODULE_10__toString_js__["a" /* default */])(string);
  options = Object(__WEBPACK_IMPORTED_MODULE_0__assignInWith_js__["a" /* default */])({}, options, settings, __WEBPACK_IMPORTED_MODULE_3__customDefaultsAssignIn_js__["a" /* default */]);

  var imports = Object(__WEBPACK_IMPORTED_MODULE_0__assignInWith_js__["a" /* default */])({}, options.imports, settings.imports, __WEBPACK_IMPORTED_MODULE_3__customDefaultsAssignIn_js__["a" /* default */]),
      importsKeys = Object(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(imports),
      importsValues = Object(__WEBPACK_IMPORTED_MODULE_2__baseValues_js__["a" /* default */])(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === __WEBPACK_IMPORTED_MODULE_8__reInterpolate_js__["a" /* default */] ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
  // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
  var sourceURL = hasOwnProperty.call(options, 'sourceURL')
    ? ('//# sourceURL=' +
       (options.sourceURL + '').replace(/[\r\n]/g, ' ') +
       '\n')
    : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, __WEBPACK_IMPORTED_MODULE_4__escapeStringChar_js__["a" /* default */]);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  // Like with sourceURL, we take care to not check the option's prototype,
  // as this configuration is a code injection vector.
  var variable = hasOwnProperty.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = Object(__WEBPACK_IMPORTED_MODULE_1__attempt_js__["a" /* default */])(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (Object(__WEBPACK_IMPORTED_MODULE_5__isError_js__["a" /* default */])(result)) {
    throw result;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (template);


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debounce_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(36);



/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__debounce_js__["a" /* default */])(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ __webpack_exports__["a"] = (throttle);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(16);




/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (times);


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperValue_js__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__wrapperValue_js__["a"]; });



/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);


/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(value).toLowerCase();
}

/* harmony default export */ __webpack_exports__["a"] = (toLower);


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(25);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(16);



/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

/* harmony default export */ __webpack_exports__["a"] = (toSafeInteger);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);


/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(value).toUpperCase();
}

/* harmony default export */ __webpack_exports__["a"] = (toUpper);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseCreate_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getPrototype_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isTypedArray_js__ = __webpack_require__(143);











/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      isArrLike = isArr || Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_9__isTypedArray_js__["a" /* default */])(object);

  iteratee = Object(__WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__["a" /* default */])(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_8__isObject_js__["a" /* default */])(object)) {
      accumulator = Object(__WEBPACK_IMPORTED_MODULE_7__isFunction_js__["a" /* default */])(Ctor) ? Object(__WEBPACK_IMPORTED_MODULE_1__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__getPrototype_js__["a" /* default */])(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseForOwn_js__["a" /* default */])(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (transform);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charsEndIndex_js__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charsStartIndex_js__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toString_js__ = __webpack_require__(25);







/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = Object(__WEBPACK_IMPORTED_MODULE_5__toString_js__["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_4__stringToArray_js__["a" /* default */])(string),
      chrSymbols = Object(__WEBPACK_IMPORTED_MODULE_4__stringToArray_js__["a" /* default */])(chars),
      start = Object(__WEBPACK_IMPORTED_MODULE_3__charsStartIndex_js__["a" /* default */])(strSymbols, chrSymbols),
      end = Object(__WEBPACK_IMPORTED_MODULE_2__charsEndIndex_js__["a" /* default */])(strSymbols, chrSymbols) + 1;

  return Object(__WEBPACK_IMPORTED_MODULE_1__castSlice_js__["a" /* default */])(strSymbols, start, end).join('');
}

/* harmony default export */ __webpack_exports__["a"] = (trim);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charsEndIndex_js__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toString_js__ = __webpack_require__(25);






/** Used to match leading and trailing whitespace. */
var reTrimEnd = /\s+$/;

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = Object(__WEBPACK_IMPORTED_MODULE_4__toString_js__["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimEnd, '');
  }
  if (!string || !(chars = Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_3__stringToArray_js__["a" /* default */])(string),
      end = Object(__WEBPACK_IMPORTED_MODULE_2__charsEndIndex_js__["a" /* default */])(strSymbols, Object(__WEBPACK_IMPORTED_MODULE_3__stringToArray_js__["a" /* default */])(chars)) + 1;

  return Object(__WEBPACK_IMPORTED_MODULE_1__castSlice_js__["a" /* default */])(strSymbols, 0, end).join('');
}

/* harmony default export */ __webpack_exports__["a"] = (trimEnd);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charsStartIndex_js__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toString_js__ = __webpack_require__(25);






/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = Object(__WEBPACK_IMPORTED_MODULE_4__toString_js__["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_3__stringToArray_js__["a" /* default */])(string),
      start = Object(__WEBPACK_IMPORTED_MODULE_2__charsStartIndex_js__["a" /* default */])(strSymbols, Object(__WEBPACK_IMPORTED_MODULE_3__stringToArray_js__["a" /* default */])(chars));

  return Object(__WEBPACK_IMPORTED_MODULE_1__castSlice_js__["a" /* default */])(strSymbols, start).join('');
}

/* harmony default export */ __webpack_exports__["a"] = (trimStart);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isRegExp_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringSize_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__toString_js__ = __webpack_require__(25);










/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? Object(__WEBPACK_IMPORTED_MODULE_7__toInteger_js__["a" /* default */])(options.length) : length;
    omission = 'omission' in options ? Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(options.omission) : omission;
  }
  string = Object(__WEBPACK_IMPORTED_MODULE_8__toString_js__["a" /* default */])(string);

  var strLength = string.length;
  if (Object(__WEBPACK_IMPORTED_MODULE_2__hasUnicode_js__["a" /* default */])(string)) {
    var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_6__stringToArray_js__["a" /* default */])(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - Object(__WEBPACK_IMPORTED_MODULE_5__stringSize_js__["a" /* default */])(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? Object(__WEBPACK_IMPORTED_MODULE_1__castSlice_js__["a" /* default */])(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isRegExp_js__["a" /* default */])(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, Object(__WEBPACK_IMPORTED_MODULE_8__toString_js__["a" /* default */])(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

/* harmony default export */ __webpack_exports__["a"] = (truncate);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ary_js__ = __webpack_require__(316);


/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ary_js__["a" /* default */])(func, 1);
}

/* harmony default export */ __webpack_exports__["a"] = (unary);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescapeHtmlChar_js__ = __webpack_require__(1929);



/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, __WEBPACK_IMPORTED_MODULE_1__unescapeHtmlChar_js__["a" /* default */])
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (unescape);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUniq_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);





/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(arrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseUniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(arrays, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true));
});

/* harmony default export */ __webpack_exports__["a"] = (union);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseUniq_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__last_js__ = __webpack_require__(63);







/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(arrays) {
  var iteratee = Object(__WEBPACK_IMPORTED_MODULE_5__last_js__["a" /* default */])(arrays);
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */])(iteratee)) {
    iteratee = undefined;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__baseUniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(arrays, 1, __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */], true), Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 2));
});

/* harmony default export */ __webpack_exports__["a"] = (unionBy);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUniq_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__last_js__ = __webpack_require__(63);






/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(arrays) {
  var comparator = Object(__WEBPACK_IMPORTED_MODULE_4__last_js__["a" /* default */])(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseUniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(arrays, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true), undefined, comparator);
});

/* harmony default export */ __webpack_exports__["a"] = (unionWith);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUniq_js__ = __webpack_require__(176);


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseUniq_js__["a" /* default */])(array) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (uniq);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUniq_js__ = __webpack_require__(176);



/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUniq_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(iteratee, 2)) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (uniqBy);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUniq_js__ = __webpack_require__(176);


/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseUniq_js__["a" /* default */])(array, undefined, comparator) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (uniqWith);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(25);


/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(prefix) + id;
}

/* harmony default export */ __webpack_exports__["a"] = (uniqueId);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUnset_js__ = __webpack_require__(628);


/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : Object(__WEBPACK_IMPORTED_MODULE_0__baseUnset_js__["a" /* default */])(object, path);
}

/* harmony default export */ __webpack_exports__["a"] = (unset);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUpdate_js__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);



/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update(object, path, updater) {
  return object == null ? object : Object(__WEBPACK_IMPORTED_MODULE_0__baseUpdate_js__["a" /* default */])(object, path, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(updater));
}

/* harmony default export */ __webpack_exports__["a"] = (update);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUpdate_js__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(107);



/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : Object(__WEBPACK_IMPORTED_MODULE_0__baseUpdate_js__["a" /* default */])(object, path, Object(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(updater), customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (updateWith);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(208);


/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

/* harmony default export */ __webpack_exports__["a"] = (upperCase);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperValue_js__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__wrapperValue_js__["a"]; });



/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(55);



/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (valuesIn);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLikeObject_js__ = __webpack_require__(50);




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(array, values) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLikeObject_js__["a" /* default */])(array)
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, values)
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (without);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castFunction_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partial_js__ = __webpack_require__(369);



/**
 * Creates a function that provides `value` to `wrapper` as its first
 * argument. Any additional arguments provided to the function are appended
 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
 * binding of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {*} value The value to wrap.
 * @param {Function} [wrapper=identity] The wrapper function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var p = _.wrap(_.escape, function(func, text) {
 *   return '<p>' + func(text) + '</p>';
 * });
 *
 * p('fred, barney, & pebbles');
 * // => '<p>fred, barney, &amp; pebbles</p>'
 */
function wrap(value, wrapper) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__partial_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__castFunction_js__["a" /* default */])(wrapper), value);
}

/* harmony default export */ __webpack_exports__["a"] = (wrap);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseAt_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flatRest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__thru_js__ = __webpack_require__(213);







/**
 * This method is the wrapper version of `_.at`.
 *
 * @name at
 * @memberOf _
 * @since 1.0.0
 * @category Seq
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _(object).at(['a[0].b.c', 'a[1]']).value();
 * // => [3, 4]
 */
var wrapperAt = Object(__WEBPACK_IMPORTED_MODULE_3__flatRest_js__["a" /* default */])(function(paths) {
  var length = paths.length,
      start = length ? paths[0] : 0,
      value = this.__wrapped__,
      interceptor = function(object) { return Object(__WEBPACK_IMPORTED_MODULE_2__baseAt_js__["a" /* default */])(object, paths); };

  if (length > 1 || this.__actions__.length ||
      !(value instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */]) || !Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(start)) {
    return this.thru(interceptor);
  }
  value = value.slice(start, +start + (length ? 1 : 0));
  value.__actions__.push({
    'func': __WEBPACK_IMPORTED_MODULE_5__thru_js__["a" /* default */],
    'args': [interceptor],
    'thisArg': undefined
  });
  return new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](value, this.__chain__).thru(function(array) {
    if (length && !array.length) {
      array.push(undefined);
    }
    return array;
  });
});

/* harmony default export */ __webpack_exports__["a"] = (wrapperAt);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chain_js__ = __webpack_require__(335);


/**
 * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
 *
 * @name chain
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * // A sequence without explicit chaining.
 * _(users).head();
 * // => { 'user': 'barney', 'age': 36 }
 *
 * // A sequence with explicit chaining.
 * _(users)
 *   .chain()
 *   .head()
 *   .pick('user')
 *   .value();
 * // => { 'user': 'barney' }
 */
function wrapperChain() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__chain_js__["a" /* default */])(this);
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperChain);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reverse_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__thru_js__ = __webpack_require__(213);





/**
 * This method is the wrapper version of `_.reverse`.
 *
 * **Note:** This method mutates the wrapped array.
 *
 * @name reverse
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _(array).reverse().value()
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function wrapperReverse() {
  var value = this.__wrapped__;
  if (value instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */]) {
    var wrapped = value;
    if (this.__actions__.length) {
      wrapped = new __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */](this);
    }
    wrapped = wrapped.reverse();
    wrapped.__actions__.push({
      'func': __WEBPACK_IMPORTED_MODULE_3__thru_js__["a" /* default */],
      'args': [__WEBPACK_IMPORTED_MODULE_2__reverse_js__["a" /* default */]],
      'thisArg': undefined
    });
    return new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](wrapped, this.__chain__);
  }
  return this.thru(__WEBPACK_IMPORTED_MODULE_2__reverse_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperReverse);


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseXor_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);





/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(arrays) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseXor_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */]));
});

/* harmony default export */ __webpack_exports__["a"] = (xor);


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUniq_js__ = __webpack_require__(176);




/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? Object(__WEBPACK_IMPORTED_MODULE_2__baseUniq_js__["a" /* default */])(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = Object(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseUniq_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(result, 1), iteratee, comparator);
}

/* harmony default export */ __webpack_exports__["a"] = (baseXor);


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseXor_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__last_js__ = __webpack_require__(63);







/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = Object(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(arrays) {
  var iteratee = Object(__WEBPACK_IMPORTED_MODULE_5__last_js__["a" /* default */])(arrays);
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */])(iteratee)) {
    iteratee = undefined;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__baseXor_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_4__isArrayLikeObject_js__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 2));
});

/* harmony default export */ __webpack_exports__["a"] = (xorBy);


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseXor_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__last_js__ = __webpack_require__(63);






/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = Object(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(arrays) {
  var comparator = Object(__WEBPACK_IMPORTED_MODULE_4__last_js__["a" /* default */])(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_2__baseXor_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */]), undefined, comparator);
});

/* harmony default export */ __webpack_exports__["a"] = (xorWith);


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzip_js__ = __webpack_require__(258);



/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unzip_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (zip);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseZipObject_js__ = __webpack_require__(996);



/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseZipObject_js__["a" /* default */])(props || [], values || [], __WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (zipObject);


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSet_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseZipObject_js__ = __webpack_require__(996);



/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseZipObject_js__["a" /* default */])(props || [], values || [], __WEBPACK_IMPORTED_MODULE_0__baseSet_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (zipObjectDeep);


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzipWith_js__ = __webpack_require__(377);



/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_1__unzipWith_js__["a" /* default */])(arrays, iteratee);
});

/* harmony default export */ __webpack_exports__["a"] = (zipWith);


/***/ }),
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(843);
__webpack_require__(2342);
__webpack_require__(1201);
__webpack_require__(1209);
__webpack_require__(843);
__webpack_require__(87);
__webpack_require__(1210);
__webpack_require__(2363);
window.simplify = __webpack_require__(2364);
__webpack_require__(2365);
__webpack_require__(2366);
__webpack_require__(1211);

var survey = __webpack_require__(2367);
var page = __webpack_require__(1211).Page;
var question = __webpack_require__(1210).Question;
var logic = __webpack_require__(45);
var expr = __webpack_require__(2369);
var utils = __webpack_require__(2370);
var dateTools = __webpack_require__(2371);
var context = __webpack_require__(1209);
var variables = __webpack_require__(87);

window.EvaluationVisitor = logic.EvaluationVisitor;
window.SurveyLogic = survey.SurveyLogic;
window.onSurveyLoad = survey.onSurveyLoad;
window.ExprParser = expr;
window.randomString = utils.randomString;
window.dateTools = dateTools;
window.Page = page;
window.Question = question;
window.trans = utils.trans;
window.Choice = utils.Choice;
window.QuestionContext = context.QuestionContext;
window.ThreeDMatrixContext = context.ThreeDMatrixContext;
window.StringVariable = variables.StringVariable;
window.VariableContext = context.VariableContext;
window.getVariableQuery = survey.getVariableQuery;

/***/ }),
/* 843 */
/***/ (function(module, exports) {

var _CoffeeKup, beget, ck, global,
  slice = [].slice,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

global = typeof exports !== "undefined" && exports !== null ? exports : (window.CoffeeKup != null ? window.CoffeeKup : window.CoffeeKup = {});

beget = function(obj) {
  var F;
  F = function() {};
  F.prototype = obj;
  return new F();
};

global.CoffeeKup = _CoffeeKup = (function() {
  var i, len, ref, tag;

  _CoffeeKup.prototype._doctypes = {
    '5': '<!DOCTYPE html>',
    'xml': '<?xml version="1.0" encoding="utf-8" ?>',
    'default': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">',
    'transitional': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">',
    'strict': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">',
    'frameset': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Frameset//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-frameset.dtd">',
    '1.1': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">',
    'basic': '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML Basic 1.1//EN" "http://www.w3.org/TR/xhtml-basic/xhtml-basic11.dtd">',
    'mobile': '<!DOCTYPE html PUBLIC "-//WAPFORUM//DTD XHTML Mobile 1.2//EN" "http://www.openmobilealliance.org/tech/DTD/xhtml-mobile12.dtd">'
  };

  _CoffeeKup.prototype._tags = 'a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdo|big|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|keygen|kbd|label|legend|li|link|map|mark|menu|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|u|ul|video|xmp'.split('|');

  _CoffeeKup.prototype._selfClosing = ['area', 'base', 'basefont', 'br', 'col', 'frame', 'hr', 'img', 'input', 'link', 'meta', 'param'];

  _CoffeeKup.prototype._support = 'var __slice = Array.prototype.slice;\nvar __hasProp = Object.prototype.hasOwnProperty;\nvar __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };\nvar __extends = function(child, parent) {\n	for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; }\n	function ctor() { this.constructor = child; }\n	ctor.prototype = parent.prototype; child.prototype = new ctor; child.__super__ = parent.prototype;\n	return child;\n};\nvar __indexOf = Array.prototype.indexOf || function(item) {\n	for (var i = 0, l = this.length; i < l; i++) {\n		if (this[i] === item) return i;\n	}\n	return -1;\n};';

  _CoffeeKup.prototype._htmlEscape = function(txt) {
    return String(txt).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  _CoffeeKup.prototype._escape = function(txt) {
    if (this._options.autoescape) {
      return this._htmlEscape(txt);
    } else {
      return String(txt);
    }
  };

  _CoffeeKup.prototype._renderAttrs = function(attrs) {
    var key, val;
    return ((function() {
      var ref, results;
      ref = attrs != null ? attrs : {};
      results = [];
      for (key in ref) {
        val = ref[key];
        results.push(" " + key + "=\"" + (this._escape(val != null ? val : '')) + "\"");
      }
      return results;
    }).call(this)).join('');
  };

  _CoffeeKup.prototype._repeat = function(string, count) {
    return Array(count + 1).join(string);
  };

  _CoffeeKup.prototype._indent = function() {
    if (this._options.format) {
      return this.text(this._repeat('  ', this._tabs));
    }
  };

  _CoffeeKup.prototype._extend = function(options, args) {
    var key, obj, ref, ref1, ref2, ref3, ref4, ref5, ref6, val;
    obj = beget(this);
    obj.templates = beget(this.templates);
    if (options != null) {
      obj._options = options;
    }
    obj._buffer = (ref = options._buffer) != null ? ref : [];
    obj._tabs = (ref1 = options._tabs) != null ? ref1 : 0;
    if (options != null ? options.locals : void 0) {
      ref2 = options.locals;
      for (key in ref2) {
        val = ref2[key];
        obj[key] = val;
      }
    }
    obj.__context = (ref3 = (ref4 = options != null ? options.context : void 0) != null ? ref4 : options != null ? options.__context : void 0) != null ? ref3 : {};
    obj.__arguments = (ref5 = (ref6 = args != null ? args : options != null ? options["arguments"] : void 0) != null ? ref6 : options != null ? options.__arguments : void 0) != null ? ref5 : [];
    return obj;
  };

  _CoffeeKup.prototype._makeTag = function(tag) {
    return function() {
      var opts;
      opts = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      this.tag.apply(this, [tag].concat(slice.call(opts)));
      return null;
    };
  };

  ref = _CoffeeKup.prototype._tags;
  for (i = 0, len = ref.length; i < len; i++) {
    tag = ref[i];
    _CoffeeKup.prototype[tag] = _CoffeeKup.prototype._makeTag(tag);
  }

  function _CoffeeKup(options) {
    if (options == null) {
      options = {};
    }
    this._options = options;
  }

  _CoffeeKup.prototype.doctype = function(type) {
    if (type == null) {
      type = 5;
    }
    this.text(this._doctypes[type]);
    if (this._options.format) {
      return this.text('\n');
    }
  };

  _CoffeeKup.prototype.coffeescript = function(code) {
    return this.script(";(" + code + ")();");
  };

  _CoffeeKup.prototype.comment = function(cmt) {
    this.text("<!--" + cmt + "-->");
    if (this._options.format) {
      return this.text('\n');
    }
  };

  _CoffeeKup.prototype.h = function(txt) {
    return this._htmlEscape(txt);
  };

  _CoffeeKup.prototype.text = function(txt) {
    return this._buffer.push(String(txt));
  };

  _CoffeeKup.prototype.tag = function() {
    var args, j, k, len1, len2, name, o, result;
    name = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    this._indent();
    this.text("<" + name);
    for (j = 0, len1 = args.length; j < len1; j++) {
      o = args[j];
      if (typeof o === 'object') {
        this.text(this._renderAttrs(o));
      }
    }
    if (indexOf.call(this._selfClosing, name) >= 0) {
      this.text(" />");
      if (this._options.format) {
        return this.text("\n");
      }
    } else {
      this.text(">");
      for (k = 0, len2 = args.length; k < len2; k++) {
        o = args[k];
        switch (typeof o) {
          case 'string':
          case 'number':
            this.text(this._escape(o));
            break;
          case 'function':
            if (this._options.format) {
              this.text("\n");
            }
            this._tabs++;
            result = o.call(this.__context);
            if (typeof result === 'string') {
              this._indent();
              this.text(this._escape(result));
              if (this._options.format) {
                this.text("\n");
              }
            }
            this._tabs--;
            this._indent();
        }
      }
      this.text("</" + name + ">");
      if (this._options.format) {
        return this.text("\n");
      }
    }
  };

  _CoffeeKup.prototype.include = function(template) {
    var args;
    args = _.rest(arguments);
    args.unshift(this);
    return template.apply(this, args);
  };

  _CoffeeKup.prototype.compile = function(template) {
    return (new Function('__ck', this._support + "\n\nreturn function(__options) {\n	var __arguments = _.rest(arguments);\n	var __locals = __ck._extend(__options, __arguments);\n	with (__locals) {\n		(" + (template.toString()) + ").apply(__context, __arguments);\n		return _buffer.join('');\n	}\n}"))(this);
  };

  _CoffeeKup.prototype.render = function(template, options) {
    var cached;
    cached = this.compile(template);
    return cached(options);
  };

  return _CoffeeKup;

})();

global["default"] = ck = new _CoffeeKup;

global.render = function(template, options) {
  return global["default"].render(template, options);
};

global.compile = function(template) {
  return global["default"].compile(template);
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Class$create, _Class$create2, _Class$create3, _$$klass;

var _utils = __webpack_require__(27);

var _baseField = __webpack_require__(1203);

var _baseField2 = _interopRequireDefault(_baseField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var l = __webpack_require__(7);
var Class = __webpack_require__(157);
var chide = __webpack_require__(230);
var Javascripter = __webpack_require__(2347);
var Variable = __webpack_require__(1204);
var Validation = __webpack_require__(2348);

var _require = __webpack_require__(231),
    Option = _require.Option;

var UploadField = __webpack_require__(2349);

_baseField2.default.SectionField = $.klass(_baseField2.default.Field, {
	type: 'section-separator',
	qlass: 'section-separator',
	cssType: 'field',

	displayName: gettext('Section Heading'),

	isQuestion: false,

	showOptions: function showOptions($super, options) {
		$super(options);

		options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));
	},
	serialize: function serialize($super) {
		return $.extend($super(), {
			children: []
		});
	}
});

_baseField2.default.JavaScript = $.klass(_baseField2.default.Field, {
	type: 'javascript',
	qlass: 'javascript',
	cssType: 'field',
	displayName: gettext('JavaScript'),
	helpText: gettext('Add custom JavaScript to your survey') + ' ' + gettext('WARNING: Only use if you are familiar with JavaScript.' + 'Any issues caused by the introduction of faulty JavaScript are the responsibilty of the user.'),
	isQuestion: false,
	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		globalpiper: Class.create(chide.opts.Checkbox, {
			label: gettext('Limit Piper'),
			help: gettext('Limit Piper - Use a simplified piper list.'),
			changed: function changed(value) {
				this.field.javascripter.update_piper(this.field.survey, value, this.field.noids.value);
			}
		}),
		noids: Class.create(chide.opts.Checkbox, {
			label: gettext('Remove Question IDs'),
			help: gettext('Remove Question IDs - Limit piper list to piped variables and question answers.'),
			changed: function changed(value) {
				this.field.javascripter.update_piper(this.field.survey, this.field.globalpiper.value, value);
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;
		$super(info, editor);

		info = info || {};

		this.info = info;
		this.editor = editor;
		this.survey = editor.survey;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Script Name'),
			changed: function changed(value) {
				$('.title', that.element).html(that.survey.stripScriptTags(value));
			}
		}))({
			value: info.title || gettext('JavaScript')
		});

		this.description = new (Class.create(chide.opts.Html, {}))({
			translatable: false,
			value: info.description || '$(function (){\n//place script here\n\n\n});'
		});

		this.globalpiper = new this.options.globalpiper({
			value: info.globalpiper !== undefined ? !!info.globalpiper : true,
			field: this
		});
		this.noids = new this.options.noids({ value: info.noids !== undefined ? !!info.noids : true, field: this });
	},

	showOptions: function showOptions($super, options) {
		options.html('');
		options.append(this.name.render()).append(this.title.render());
		options.append(Option.renderGroup(gettext('Options'), [this.globalpiper, this.noids], true));
	},

	serialize: function serialize($super) {
		var result = $.extend($super(), {
			globalpiper: this.globalpiper.get(),
			noids: this.noids.get()
		});
		return result;
	},

	renderContent: function renderContent() {},

	render: function render() {
		var that = this;

		this.javascripter = $('<div class="javascripter"/>').attachAndReturn(Javascripter, this.survey, this.editor)[0];

		this.element.empty();

		var options = $('<div class="sma-js-field-actions"></div>').append($('<a data-variable-name="' + this.id + '"></a>')).append($('<a href="#" class="nc-icon-mini gestures_drag-31 move" title=' + gettext('Move') + '></a>').tooltip()).append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate" title=' + gettext('Duplicate') + '></a>').tooltip()).append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove" title=' + gettext('Delete') + '></a>').tooltip());

		this.element.append(options);

		this.element.append('<span class="status"></span>', '<span class="name">' + (that.name.get() ? that.name.get() : '') + '</span>', '<span class="title fr-view">' + that.title.get() + '</span>',
		//'<div class="description">' + that.description.get() + '<\/div>',
		this.javascripter.element);

		var settings = {};
		settings['field'] = this;
		settings['globalpiper'] = this.globalpiper.value;
		settings['noids'] = this.noids.value;

		this.javascripter.set(settings);
		this.element.children('form').hide();

		this.renderContent();
	}
});

_baseField2.default.TextField = $.klass(_baseField2.default.Field, {
	type: 'text-response',
	qlass: 'text-response',
	cssType: 'text-response',

	displayName: gettext('Text Response'),
	isBranchable: true,

	supportedActions: _baseField2.default.Field.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	options: $.extend({}, _baseField2.default.Field.prototype.options, {

		appearance: Class.create(chide.opts.Checkbox, {
			label: gettext('Multiline'),
			changed: function changed(_value) {
				this.field.renderContent();
			},
			render: function render($super, field) {
				field = field || this.field;

				var rows = field.rows.render();
				var cols = field.cols.render();

				return $super([rows]).append(cols).bind('changed', function (_e, _value) {
					if (field.cols.value === undefined) {
						cols.find('input').val(field.cols.get().toString());
					}

					if (field.rows.value === undefined) {
						rows.find('input').val(field.rows.get());
					}
				});
			}
		}),

		rows: Class.create(chide.opts.Number, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Rows:'),
			max: 25,
			min: 1,
			type: 'int',
			changed: function changed(_value) {
				this.field.renderContent();
			},
			get: function get() {
				return this.value || 6;
			}
		}),

		cols: Class.create(chide.opts.Number, {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Columns:'),
			max: 100,
			min: 1,
			type: 'int',
			changed: function changed(_value) {
				this.field.renderContent();
			},
			get: function get() {
				return this.value || (this.field.appearance.get() ? 50 : 20);
			}
		}),

		initialValue: Class.create(chide.opts.Text, (_Class$create = {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Value'),
			help: gettext('About Initial Values - Initial values allow you to specify pre-populated answers to questions in your survey.')
		}, _defineProperty(_Class$create, 'inputClass', 'text short'), _defineProperty(_Class$create, 'changed', function changed(value) {
			this.field.input.val(value);
		}), _Class$create)),

		hide_input: Class.create(chide.opts.Checkbox, {
			label: gettext('Hide Input'),
			help: gettext('About Hide Input - When a user types in this input box, the text will appear as dots.'),
			changed: function changed(_value) {}
		}),

		restore_default: Class.create(chide.opts.Checkbox, {
			label: gettext('Restore Initial Value'),
			help: gettext('About Restore Initial Value - When a user comes back to this form page, this question will have its default value.'),
			changed: function changed(_value) {}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		var validation = void 0;
		if (info.children && info.children.length) {
			if (info.children[0].validation && _typeof(info.children[0].validation) == 'object') {
				validation = info.children[0].validation;
			} else {
				validation = { type: 'none', minLength: '', maxLength: '', regex: '^.*$', errorMsg: { en: 'Invalid Entry' } };
			}
		} else {
			validation = { type: 'none', minLength: '0', maxLength: '', regex: '^.*$', errorMsg: { en: 'Invalid Entry' } };
		}

		this.appearance = new this.options.appearance({
			field: this,
			value: info.children && info.children.length ? info.children[0].appearance === 'full' : false
		});

		this.rows = new this.options.rows({
			field: this,
			value: info.children && info.children.length ? info.children[0].rows : info.rows
		});

		this.cols = new this.options.cols({
			field: this,
			value: info.children && info.children.length ? info.children[0].cols : info.cols
		});

		this.optional = new this.options.optional({
			info: info,
			changed: function changed(_value) {
				that.render();
			}
		});

		this.hide_input = new this.options.hide_input({
			field: this,
			value: info.children && info.children.length && info.children[0].hide_input || info.hide_input || undefined
		});

		this.restore_default = new this.options.restore_default({
			field: this,
			value: info.children && info.children.length && info.children[0].restore_default || info.restore_default || undefined
		});

		this.initialValue = new this.options.initialValue({
			field: this,
			value: info.children && info.children.length && info.children[0].initialValue || info.initialValue || undefined
		});

		// If you do this on the top of the file things fail. Try to drag a new GuideStar field
		var GuideStar = __webpack_require__(846);
		this.guideStarMapping = new GuideStar.Mapping(this, {
			value: info.children && info.children.length && info.children[0].guideStarMapping || info.guideStarMapping || this.guideStarDefaultMapping
		});

		this.validation = new Validation(this, {
			value: validation
		});

		this.prefix = $('<span></span>');
		this.suffix = $('<span></span>');

		this.validation.render();
	},

	getVariables: function getVariables() {
		return [new Variable.String({ id: this.id, label: this.getIdentifier() })];
	},

	getInput: function getInput() {
		if (this.appearance.get()) {
			return $('<textarea/>', {
				rows: this.rows.get(),
				cols: this.cols.get()
			}).val(this.initialValue.get() || '');
		} else {
			return $('<input class="text" type="text" />').css('width', this.cols.get() * 10 + 'px').val(this.initialValue.get() || '');
		}
	},

	renderContent: function renderContent() {
		if (this.input) {
			this.input.remove();
		}

		this.input = this.getInput();

		this.element.append(this.prefix, this.input, this.suffix);
	},

	showOptions: function showOptions($super, options) {
		var uiElements = [this.optional, this.hide_input, this.restore_default, this.validation.render(), this.initialValue];

		$super(options);

		if (this.editor.isGuideStarEnabled) {
			uiElements.push(this.guideStarMapping);
		}
		options.append(Option.renderGroup(gettext('Display'), [this.appearance.render(this), this.displayInline, this.appendToPrevious, this.widthOption], true), Option.renderGroup(gettext('Options'), uiElements, true));
	},

	getExtractionOptions: function getExtractionOptions(config) {
		return new chide.opts.Number({
			showLabel: true,
			type: 'int',
			label: gettext('Maximum number of loop iterations:'),
			value: config && config.max || 10
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(options) {
		return {
			max: options.value
		};
	},

	serialize: function serialize($super) {
		return $.extend($super(), {
			children: [$.extend({}, {
				type: 'string',
				required: !this.optional.value,
				appearance: this.appearance.value ? 'full' : undefined,
				rows: this.rows.value,
				cols: this.cols.value,
				validation: this.validation.value && this.validation.value.type && this.validation.value.type !== 'none' && this.validation.get() || undefined,
				guideStarMapping: this.guideStarMapping.get(),
				initialValue: this.initialValue.get() && this.initialValue.value || undefined,
				hide_input: this.hide_input.value,
				restore_default: this.restore_default.value
			})]
		});
	}
});

_baseField2.default.ChoiceField = $.klass(_baseField2.default.Field, {
	type: 'single-choice',
	qlass: 'single-choice',
	cssType: 'choice',

	displayName: gettext('Multiple Choice'),
	inputType: 'radio',

	extraDisplay: null,

	hasOther: true,
	hasStatic: true,
	hasNA: false,
	hasCheckAll: false,
	hasChoiceChildren: true,
	hasChoiceBranching: false,
	multiSelect: false,
	maxPerCombo: 15,
	displayAsCombo: false,

	isScorable: true,

	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		appearance: Class.create(chide.opts.Single, {
			label: gettext('Appearance'),
			changed: function changed(value) {
				this.field.renderContent();
			},
			choices: [['default', gettext('Default')], ['horizontal', gettext('Horizontal')], ['combo', gettext('Combo box')]]
		}),

		columns: Class.create(chide.opts.Single, {
			label: gettext('Columns'),
			help: gettext('About columns - This number will determine how many columns these choices should be displayed in. Preview is not available for this function.'),
			choices: [[1, '1'], [2, '2'], [3, '3'], [4, '4'], [5, '5']]
		}),

		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize choices'),
			help: gettext('About Randomize - Check this option if you would like this question\'s choices to be shown in a random order every time the page is viewed.'),
			changed: function changed(value) {
				if (value) {
					this.field.alphabetize && this.field.alphabetize.set(false).refresh();
				}
			}
		}),

		alphabetize: Class.create(chide.opts.Checkbox, {
			label: gettext('Alphabetize choices'),
			help: gettext('About Alphabetization - Check this option if you would like this question\'s choices to be shown in alphabetical order.'),
			changed: function changed(value) {
				if (value) {
					this.field.randomize && this.field.randomize.set(false).refresh();
				}
			}
		}),

		show_range: Class.create(chide.opts.Checkbox, {
			label: gettext('Show number of options checked'),
			help: gettext('About Show Range - Shows the number of checkboxes that have been checked. Great to use if you restrict the number of selected choices.'),
			changed: function changed(value) {
				if (value) {
					this.show_range && this.show_range.set(false).refresh();
				}
			}
		}),

		choiceList: Class.create(chide.opts.TextList, {

			hasSubOptions: true,
			score: Class.create(chide.opts.Number, {
				label: gettext('Score'),
				help: gettext('About Scoring - Scoring allows you to assign a value to each choice (for use with analytics).'),
				applyEdit: true,
				defaultBlank: true,
				clearValue: 0,
				blankText: function blankText(index) {
					return index + 1;
				},
				changed: function changed(value) {
					this.field.renderContent();
				},
				initialize: function initialize($super, config) {
					$super(config);
					if (config.min !== null) {
						if (Number.isInteger(config.min)) {
							this.min = config.min;
						}
						// Am not setting value for min otherwise as will default to call defaults
					}
				}
			}),

			other: Class.create(chide.opts.Checkbox, {
				label: gettext('Add text response'),
				changed: function changed(value) {
					if (value) {
						this.field.other_required && this.field.other_required.rendered && this.field.other_required.rendered.toggle(value);
					}
				}
			}),

			static: Class.create(chide.opts.Checkbox, {
				label: gettext('Static Choice'),
				changed: function changed(value) {
					//if (value) { this.field.static && this.field.other_required.rendered && this.field.other_required.rendered.toggle(value); }
				}
			}),

			na: Class.create(chide.opts.Checkbox, {
				label: gettext('Exclusive choice'),
				changed: function changed(value) {
					if (value) {
						this.field.check_all && this.field.check_all.set(false).refresh();
					}
				}
			}),

			check_all: Class.create(chide.opts.Checkbox, {
				label: gettext('Select All'),
				help: gettext('About Check All - If this option is checked, when the user selects this choice, all other choices are selected.'),
				changed: function changed(value) {
					if (value) {
						this.field.na && this.field.na.set(false).refresh();
					}
				}
			}),

			other_required: Class.create(chide.opts.Checkbox, {
				label: gettext('Make text response mandatory'),
				help: gettext('About Required response - If this option is checked, if the user selects this option, the text field is required.')
			}),

			itemFromValue: function itemFromValue(value) {
				var Branching = __webpack_require__(406).Branching;
				var that = this;
				var item = {};

				item = $.extend(item, {
					static: this.field.hasStatic ? new this.static({
						value: value && value.static !== undefined ? !!value.static : false
					}) : undefined,
					text: new this.textClass({ value: value && value.label ? value.label : '' }),
					score: new this.score({
						value: value !== undefined && value !== null && value != '' && value.score !== undefined && value.score !== '' ? value.score : undefined,
						min: this.field.editor.isReviewerForm ? 0 : null
					}),
					other: this.field.hasOther ? new this.other({
						value: value && value.other !== undefined ? !!value.other : false,
						changed: function changed(value) {
							that.itemChanged(that.value.indexOf(item), item);
							item.other_required && item.other_required.rendered && item.other_required.rendered.toggle(value);
						}
					}) : undefined,
					validation: this.field.hasOther ? new Validation(this.field, { value: value ? value.validation : undefined }) : undefined,
					na: this.field.hasNA ? new this.na({ value: value && value.na !== undefined ? !!value.na : false, field: item }) : undefined,
					check_all: this.field.hasCheckAll ? new this.check_all({ value: value && value.check_all !== undefined ? !!value.check_all : false, field: item }) : undefined,
					other_required: this.field.hasOther ? new this.other_required({
						value: value && value.other_required !== undefined ? !!value.other_required : false,
						field: item,
						changed: function changed(value) {
							return false;
						}
					}) : undefined,
					branching: this.field.hasChoiceBranching ? new Branching.Simple.Rule({ field: this.field, value: value && value.branching ? value.branching : undefined }) : undefined
				});

				item.score.field = this.field;

				return item;
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				var sub = $super(item, index);

				if (this.field.hasNA) {
					sub.append(item.na.render());
				}
				if (this.field.hasCheckAll) {
					sub.append(item.check_all.render());
				}
				if (this.field.hasOther) {
					sub.append(item.other.render([item.validation]));
					sub.append((item.other_required.rendered = item.other_required.render()).toggle(item.other.get()));
				}
				if (this.field.hasStatic) {
					sub.append(item.static.render());
				}

				sub.append(item.score.render(index));

				if (this.field.hasChoiceBranching) {
					sub.append(item.branching.render());
				}

				return sub;
			},

			itemAdded: function itemAdded(item) {
				this.field.choiceAdded(item);
			},
			itemChanged: function itemChanged(index, value) {
				this.field.choiceChanged(index, value);
			},
			itemRemoved: function itemRemoved(index) {
				this.field.choiceRemoved(index);
			},
			itemsChanged: function itemsChanged(value) {
				this.field.initialValue && this.field.initialValue.refresh();this.field.renderContent();
			}
		}),

		initialValue: Class.create(chide.opts.Select, {
			label: gettext('Initial Value'),
			help: gettext('About Initial Values - Initial values allow you to specify pre-populated answers to questions in your survey.'),
			renderChoices: function renderChoices() {
				var choices = [];
				var value = this.field.choices.value;

				for (var i = 0; i < value.length; i++) {
					choices.push([i, value[i].text.get()]);
				}

				return chide.opts.renderSelect(choices, '---');
			},
			render: function render($super) {
				return this.rendered = $super();
			},
			refresh: function refresh() {
				var old = this.rendered;
				if (old) {
					this.rendered = undefined;
					old.replaceWith(this.render());
				}
			},
			changed: function changed(value) {
				if (value) {
					this.value = parseInt(value, 10);
					this.field.choiceDisplay && this.field.choiceDisplay.children(':not(.blank)').eq(value).attr('checked', true).attr('selected', true);
				} else {
					this.value = undefined;
				}
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;
		info = info || {};

		$super(info, editor);

		var choices;

		if (info.choices) {
			choices = info.choices;
		} else if (info.children && info.children.length && info.children[0].choices) {
			choices = info.children[0].choices;
		} else {
			choices = [{ label: gettext('Choice 1') }, { label: gettext('Choice 2') }];
		}

		var extraction = info.extraction ? info.extraction : info.children && info.children.length ? info.children[0].extraction : undefined;

		var appearance = info.appearance ? info.appearance : info.children && info.children.length ? info.children[0].choiceAppearance : 'default';

		// pre-2.0 compatibility
		if (this.hasOther && info.children && info.children.length && info.children[0].other) {
			choices.push({
				label: info.children[0].otherlabel || gettext('Other, please specify:'),
				other: true
			});
		}

		// pre-2.0 compatibility
		if (this.hasNA && info.children && info.children.length && info.children[0].NA) {
			choices.push({
				label: info.children[0].NA.text || gettext('Not Applicable'),
				na: true,
				score: info.children[0].NA.score
			});
		}

		// convert old branching
		if (this.hasChoiceBranching) {
			var branching = info.children && info.children.length && info.children[0].branch ? info.children[0].branch : undefined;

			if (branching) {
				for (var i = 0; i < branching.length; i++) {
					var j = branching[i].val;
					if (j >= 0 && j < choices.length) {
						choices[j].branching = branching[i].page;
					}
				}
			}
		}

		this.appearance = this.options.appearance ? new this.options.appearance({ value: appearance, field: this }) : undefined;

		this.choices = new this.options.choiceList({ value: choices, extraction: extraction, field: this });

		this.columns = this.options.columns ? new this.options.columns({ value: info.children && info.children[0] ? info.children[0].columns : info.columns }) : undefined;

		this.optional = new this.options.optional({ info: info, changed: function changed(value) {
				that.render();
			} });

		this.randomize = new this.options.randomize({ field: this, value: info.children && info.children[0] ? !!info.children[0].randomize : !!info.randomize });

		this.alphabetize = new this.options.alphabetize({ field: this, value: info.children && info.children[0] ? !!info.children[0].alphabetize : !!info.alphabetize });

		this.initialValue = this.options.initialValue ? new this.options.initialValue({ field: this, value: info.children && info.children[0] && info.children[0].initialValue !== undefined && info.children[0].initialValue !== false ? info.children[0].initialValue : undefined }) : undefined;
	},

	getVariables: function getVariables() {
		return [new Variable.Single({ id: this.id, label: this.getIdentifier(), choices: $.map(this.choices.get(), function (el) {
				return el.text.get();
			}) })];
	},

	choiceAdded: function choiceAdded(item) {
		this.choiceDisplay && this.choiceDisplay.append(this.renderChoice(item));

		if (this.appearance && this.appearance.get() === 'combo') {
			this.choiceDisplay.attr('size', Math.min(this.maxPerCombo, this.choices.value.length));
		}

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choiceChanged: function choiceChanged(index, value) {
		this.choiceDisplay && this.choiceDisplay.children(':not(.blank)').eq(index).replaceWith(this.renderChoice(value, index + 1));

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choiceRemoved: function choiceRemoved(index) {
		this.choiceDisplay && this.choiceDisplay.children(':not(.blank)').eq(index).remove();

		if (this.appearance && this.appearance.get() === 'combo') {
			this.choiceDisplay.attr('size', Math.min(this.maxPerCombo, this.choices.value.length));
		}

		// could optimize
		this.initialValue && this.initialValue.refresh();
	},

	choicesArranged: function choicesArranged(oldIndex, newIndex) {
		if (newIndex == 0) {
			$('ul.choices', this.element).prepend($('ul.choices li.choice', this.element).eq(oldIndex));
		} else {
			$('ul.choices li.choice', this.element).eq(newIndex).after($('ul.choices li.choice', this.element).eq(oldIndex));
		}
		this.refreshChoices();
	},

	showOptions: function showOptions($super, options) {
		$super(options);

		var that = this;
		var choices = this.choices.render();
		var otherButton = false;

		if (this.hasOther) {
			otherButton = $('<a/>', {
				href: '#',
				'class': 'btn btn-secondary btn-sm add',
				text: gettext('Add Other Choice'),
				click: function click(e) {
					e.preventDefault();
					that.choices._add({ label: gettext('Other, please specify...'), other: true, static: true });
					return false;
				}
			}).appendTo(choices);

			choices.bind('extraction', function (e, enabled) {
				otherButton.toggle(enabled);
			});
			if (this.choices.extraction.question.get()) {
				otherButton.toggle(false);
			}
		}

		options.append(Option.renderGroup(gettext('Choices'), [choices], true), Option.renderGroup(gettext('Display'), [this.appearance, this.columns, this.displayInline, this.appendToPrevious, this.widthOption], true), Option.renderGroup(gettext('Options'), [this.optional, this.randomize, this.alphabetize, this.initialValue, this.blankChoice, this.restrictions, this.show_range], true));
	},

	renderChoice: function renderChoice(item, index) {
		if (this.displayAsCombo || this.appearance && this.appearance.get() === 'combo') {
			return '<option>' + item.text.get() + '<\/option>';
		} else if (this.inputType == 'checkbox') {
			return '<li class="choice"><label class="custom-control custom-checkbox">\
				<input name="' + this.id + '"type="checkbox" class="custom-control-input ">\
				<span class="custom-control-indicator"></span>\
				<span class="custom-control-description">\
				<label for="' + this.id + '">' + item.text.get() + (item.other && item.other.value ? '<input type="text" class="text dummy"><\/input>' : '') + '</label></span>\
				</label></li>';
		} else if (this.appearance.get() === undefined || this.appearance.get() === 'default' || this.appearance.get() === 'horizontal') {
			var score = l.get(item, 'score.value', null);
			if (score == null) {
				score = index;
			}

			return '<li class="choice"><label class="custom-control custom-radio">\
				<input name="' + this.id + '" type="radio" class="custom-control-input ">\
				<span class="custom-control-indicator"></span>\
				<span class="custom-control-description">\
				<label for="' + this.id + '">' + item.text.get() + (item.other && item.other.value ? '<input type="text" class="text dummy"><\/input>' : '') + ' <small class="sma-score-value">(' + gettext('Score') + ': ' + score + ')</small>' + '</label></span></label></li>';
		} else {
			return '<li class="choice"><label><input type="' + this.inputType + '" name="' + this.id + '" /> <span class="choice-value">' + item.text.get() + '<\/span>' + (item.other && item.other.value ? '<input type="text" class="text dummy"><\/input>' : '') + ' <small class="sma-score-value">(' + gettext('Score') + ': ' + l.get(item, 'score.value', 0) + ')</small>' + '<\/label><\/li>';
		}
	},

	renderChoices: function renderChoices() {
		var maxScore = 0;
		var numNone = 0;
		for (var i = 0; i < this.choices.value.length; i++) {
			this.choiceDisplay.append(this.renderChoice(this.choices.value[i], i + 1));

			if (this.choices.value[i].score.value !== undefined && this.choices.value[i].score.value != '') {
				if (this.choices.value[i].score.value > maxScore) {
					maxScore = this.choices.value[i].score.value;
				}
			} else {
				numNone++;
			}
		}

		if (numNone == this.choices.value.length) {
			maxScore = this.choices.value.length;
		}

		var extra = [];

		if (this.displayAsCombo || this.appearance && this.appearance.get() === 'combo' && maxScore > 0) {
			extra.push($('<small class="sma-score-value"> (' + gettext('Score out of') + ' ' + maxScore + ')</small>'));
		}

		return extra;
	},

	getChoiceContainer: function getChoiceContainer() {
		if (this.displayAsCombo || this.appearance && this.appearance.get() === 'combo') {
			return $('<select/>', {
				'class': 'choices custom-select',
				multiple: this.multiSelect,
				size: !this.displayAsCombo ? Math.min(this.maxPerCombo, this.choices.value.length) : undefined
			});
		} else {
			return $('<ul/>', {
				'class': 'choices' + (this.appearance.get() === 'horizontal' ? ' horizontal' : '')
			});
		}
	},

	renderContent: function renderContent() {
		var old = this.choiceDisplay;
		var oldExtra = this.extraDisplay;

		this.choiceDisplay = this.getChoiceContainer();

		this.extraDisplay = this.renderChoices();

		if (old) {
			old.remove();
		}
		if (oldExtra) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = oldExtra[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var el = _step.value;

					el.remove();
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}

		this.element.append(this.choiceDisplay).append(this.extraDisplay);
	},

	serialize: function serialize($super) {
		var ca = this.appearance && this.appearance.get();

		var child = $.extend({}, {
			choices: [],
			required: !this.optional.value,
			branch: [],
			randomize: this.randomize.get() || undefined,
			alphabetize: this.alphabetize.get() || undefined,
			extraction: this.choices.extraction.question.get() && this.choices.extraction.serialize() || undefined,
			columns: this.columns && this.columns.get() > 1 && this.columns.get() || undefined,
			choiceAppearance: ca !== 'default' && ca !== 'vertical' && ca || undefined,
			initialValue: this.initialValue && this.initialValue.value
		});

		for (var i = 0; i < this.choices.length(); i++) {
			var el = this.choices.value[i];
			child.choices.push($.extend({}, {
				label: el.text.value,
				score: el.score.value,
				static: this.hasStatic && el.static.value || undefined,
				other: this.hasOther && el.other.value || undefined,
				other_required: this.hasOther && el.other_required.value || undefined,
				validation: this.hasOther && el.other.value && el.validation.value && el.validation.value.type && el.validation.value.type !== 'none' && el.validation.get() || undefined,
				na: this.hasNA && el.na.value || undefined,
				check_all: this.hasCheckAll && el.check_all.value || undefined
			}));

			if (this.hasChoiceBranching) {
				var page = el.branching.getPage();
				if (page !== undefined) {
					child.branch.push({ val: i, page: page });
				}
			}
		}

		if (!child.branch.length) {
			//sometimes this throws an illegal access error, but never does if you wrap it. no idea why not
			try {
				delete child.branch;
			} catch (ex) {
				console.log(ex);
			}
		}

		return $.extend($super(), {
			children: [child]
		});
	},

	refreshChoices: function refreshChoices() {}
});

_baseField2.default.SingleChoiceField = $.klass(_baseField2.default.ChoiceField, {
	type: 'single-choice',
	qlass: 'single-choice',
	cssType: 'single-choice',

	displayName: gettext('Multiple Choice'),
	extractable: false,
	hasChoiceChildren: true,
	hasChoiceBranching: false,

	isBranchable: true,

	isScorable: true,

	options: $.extend({}, _baseField2.default.ChoiceField.prototype.options, {
		appearance: Class.create(_baseField2.default.ChoiceField.prototype.options.appearance, {
			choices: [['default', gettext('Default')], ['horizontal', gettext('Horizontal')], ['star', gettext('Star Rating')], ['slider', gettext('Slide Bar')], ['combo', gettext('Combo box')]],
			changed: function changed($super) {
				$super();
				this.field.showOptions($('#survey-editor-field-options'));
			}
		})
	}),

	getChoiceContainer: function getChoiceContainer($super) {
		try {
			if (this.appearance.get() === 'star') {
				return $super().addClass('star clearfix').append('<li class="blank"><\/li>');
			} else if (this.appearance.get() === 'slider') {
				return $super().append($('<div\/>').slider({ 'min': 0, 'max': this.choices.value.length - 1 }));
			} else {
				return $super();
			}
		} catch (e) {
			return $super();
		}
	},

	renderChoices: function renderChoices($super) {

		if (this.appearance.get() === 'slider') {

			var choices = [];
			var value = this.choices.value;

			for (var i = 0; i < value.length; i++) {
				choices.push([i, value[i].text.get()]);
			}
			var cell_width = 100 / choices.length;
			var table = $("<table\/>", { 'width': '100%' }).append("<tr\/>");
			$.each(choices, function (i, choice) {
				var new_cell = $("<td\/>", { 'width': cell_width + '%', 'display': 'inline' }).html(choice[1]);
				$("tr", table).append(new_cell);
			});

			return this.choiceDisplay.prepend(table);
		} else {
			return $super();
		}
	},

	choiceAdded: function choiceAdded($super, item) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		} else {
			$super(item);
		}
	},

	choiceChanged: function choiceChanged($super, index, value) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		} else {
			$super(index, value);
		}
	},

	choiceRemoved: function choiceRemoved($super, index) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		} else {
			$super(index);
		}
	},

	choicesArranged: function choicesArranged($super, oldIndex, newIndex) {
		if (this.appearance.get() === 'slider') {
			this.renderContent();
		} else {
			$super(oldIndex, newIndex);
		}
	},

	showOptions: function showOptions($super, options) {
		if (this.appearance.value == 'slider') {

			_baseField2.default.Field.prototype.showOptions.call(this, options);

			var that = this;
			var choices = this.choices.render();
			var otherButton = false;

			if (this.hasOther) {
				otherButton = $('<a/>', {
					href: '#',
					'class': 'btn btn-secondary btn-sm add',
					text: gettext('Add Other Choice'),
					click: function click(e) {
						e.preventDefault();
						that.choices._add({ label: gettext('Other, please specify...'), other: true, static: true });
						return false;
					}
				}).appendTo(choices);

				choices.bind('extraction', function (e, enabled) {
					otherButton.toggle(enabled);
				});
				if (this.choices.extraction.question.get()) {
					otherButton.toggle(false);
				}
			}

			options.append(Option.renderGroup(gettext('Choices'), [choices], false), Option.renderGroup(gettext('Display'), [this.appearance, this.displayInline, this.appendToPrevious, this.widthOption], true), Option.renderGroup(gettext('Options'), [this.optional, this.initialValue], true));
		} else {
			$super(options);
		}
	},

	serialize: function serialize($super) {
		var info = $super();

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'single'
			})]
		});
	}
});

_baseField2.default.DropDownChoiceField = $.klass(_baseField2.default.ChoiceField, {
	type: 'dropdown-choice',
	qlass: 'dropdown-choice',
	cssType: 'dropdown-choice',

	displayName: gettext('Dropdown'),

	hasOther: false,
	hasChoiceBranching: false,
	isBranchable: true,
	extractable: false,
	displayAsCombo: true,

	options: $.extend({}, _baseField2.default.ChoiceField.prototype.options, {
		blankChoice: Class.create(chide.opts.Text, {
			label: gettext('Blank choice'),
			help: gettext('Blank choice - The initial value displayed, indicating that a selection has not been made. (This will not count towards a response if selected)'),
			inputClass: 'text short',
			changed: function changed(value) {
				this.field.choiceDisplay.children().eq(0).text(this.get());
			},
			get: function get($super) {
				return this.value ? $super() : '---';
			}
		}),
		appearance: false,
		columns: false
	}),

	initialize: function initialize($super, info, editor) {
		$super(info = info || {}, editor);

		this.blankChoice = new this.options.blankChoice({ field: this, value: info.children && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined });
	},

	getChoiceContainer: function getChoiceContainer($super) {
		return $super().append($('<option class="blank"/>').text(this.blankChoice.get()));
	},

	serialize: function serialize($super) {
		var info = $super();

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'dropdown',
				blank_choice: this.blankChoice.get() && this.blankChoice.value
			})]
		});
	}
});

_baseField2.default.MultipleChoiceField = $.klass(_baseField2.default.ChoiceField, {
	type: 'multiple-choice',
	qlass: 'multiple-choice',
	cssType: 'multiple-choice',

	displayName: gettext('Checkbox'),
	inputType: 'checkbox',

	extractable: true,
	isBranchable: true,
	multiSelect: true,

	hasCheckAll: true,
	hasNA: true,

	supportedActions: _baseField2.default.Field.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	options: $.extend({}, _baseField2.default.ChoiceField.prototype.options, {
		initialValue: false
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		$super(info, editor);

		info = info || {};

		var restrictions = undefined;
		var errorMsg = undefined;

		if (info.children && info.children[0] && info.children[0].restrictions) {
			restrictions = [info.children[0].restrictions.minChecked, info.children[0].restrictions.maxChecked];

			if (restrictions[0] === undefined && restrictions[1] === undefined) {
				restrictions = undefined;
			}
		}

		if (info.children && info.children[0] && info.children[0].err_msg) {
			errorMsg = info.children[0].err_msg;
		}

		this.restrictions = new Validation.Restriction({ field: this, value: restrictions, errorMsg: errorMsg });

		this.show_range = new this.options.show_range({ field: this, value: info.children && info.children[0] ? !!info.children[0].show_range : !!info.show_range });
	},

	getVariables: function getVariables() {
		return [new Variable.Multi({
			id: this.id,
			label: this.getIdentifier(),
			choices: this.choices ? $.map(this.choices.value, function (el) {
				return el.text.get();
			}) : undefined
		})];
	},

	getExtractionChoices: function getExtractionChoices() {
		var result = [];
		$.each(this.choices.value, function (i, val) {
			result.push([i, val.text.value]);
		});
		return result;
	},

	getExtractionOptions: function getExtractionOptions(config) {
		return new chide.opts.Checkbox({
			label: gettext('Inverted extraction'),
			value: config && config.inverted
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(options) {
		return {
			inverted: !!(options && options.value)
		};
	},

	serialize: function serialize($super) {
		var info = $super();

		var loops = this.survey.looping.loops;

		return $.extend(info, {
			children: [$.extend(info.children[0], {
				type: 'multiple',
				restrictions: this.restrictions && this.restrictions.serialize() || undefined,
				show_range: this.show_range.get() || undefined,
				err_msg: this.restrictions && this.restrictions.errorMsg.get() && this.restrictions.errorMsg.value || undefined
			})]
		});
	}
});

_baseField2.default.GridField = $.klass(_baseField2.default.Field, {
	type: 'grid',
	qlass: 'grid',
	cssType: 'grid',

	displayName: gettext('Grid Field'),

	baseType: undefined,

	isGrouped: true,
	questionSize: 30,

	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize Variables'),
			help: gettext('Randomize Variables - Check this option if you would like this question\'s rows to be shown in a random order every time the page is viewed.'),
			changed: function changed(value) {
				if (value) {
					this.field.alphabetize && this.field.alphabetize.set(false).refresh();
				}
			}
		}),

		alphabetize: Class.create(chide.opts.Checkbox, {
			label: gettext('Alphabetize Variables'),
			help: gettext('Alphabetize Variables - Check this option if you would like this question\'s rows to be shown in alphabetical order.'),
			changed: function changed(value) {
				if (value) {
					this.field.randomize && this.field.randomize.set(false).refresh();
				}
			}
		}),

		unique: Class.create(chide.opts.Checkbox, {
			label: gettext('Force Unique Responses')
		}),

		staticcol: Class.create(chide.opts.Checkbox, {
			label: gettext('Make First Column Static'),
			help: gettext('Make First Column Static - Check this option if you would like this question\'s row titles to always be visible on the left hand side during column scrolling.')
		}),

		showBorders: Class.create(chide.opts.Checkbox, {
			label: gettext('Show Borders'),
			help: gettext("Show Borders - Show borders separating the rows and columns of this question (Makes complex 3D matrices easier to understand)")
		}),

		alternateBackground: Class.create(chide.opts.Checkbox, {
			label: gettext('Alternate Background Color'),
			help: gettext("Alternate Background Colors - Each column in the matrix will have an alternating background color making it stand out from the previous column and easier to understand.")
		}),

		firstColSize: Class.create(chide.opts.Single, {
			help: gettext("1st Column Size - This option allows you to modify the space reserved for variables and choices in real time."),
			label: gettext("1st Column Size: "),
			optionClass: 'opt clearfix',
			choices: [[10, '10%'], [20, '20%'], [30, '30%'], [40, '40%'], [50, '50%'], [60, '60%'], [70, '70%'], [80, '80%'], [90, '90%']],
			changed: function changed(value) {
				this.field.renderContent();
			}
		}),

		variableList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,

			itemFromValue: function itemFromValue(value) {
				return {
					text: new this.textClass({ value: value && value.label ? value.label : '' }),
					optional: new this.field.options.optional({ info: value })
				};
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				var superF = $super(item, index);
				if (!(this.field instanceof _baseField2.default.RankingField)) superF.append(item.optional.render());
				return superF;
			},

			itemAdded: function itemAdded(item) {
				this.field.variableAdded(item);
			},
			itemChanged: function itemChanged(index, value) {
				this.field.variableChanged(index, value);
			},
			itemRemoved: function itemRemoved(index) {
				this.field.variableRemoved(index);
			},
			itemsChanged: function itemsChanged(value) {
				this.field.renderContent();
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		$super(info, editor);

		info = info || {};

		var variables;

		if (info.children && info.children.length) {
			variables = info.children;
		} else {
			variables = this.getDefaultVariables();
		}

		this.uniqueError = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Error Message for Unique Responses.'),
			value: info && info.uniqueError || gettext('Responses must be unique'),
			help: gettext('Unique Responses - The label that will show beneath the question informing the user of the restraint.')
		});

		this.randomize = new this.options.randomize({ field: this, value: !!info.randomize });

		this.alphabetize = new this.options.alphabetize({ field: this, value: !!info.alphabetize });

		this.unique = new this.options.unique({ value: !!info.unique });

		if (this.options.staticcol) {
			this.staticcol = new this.options.staticcol({
				value: !!info.staticcol
			});
		}

		this.firstColSize = new this.options.firstColSize({ field: this, value: info.questionSize || this.questionSize || 30 });

		this.variables = new this.options.variableList({ field: this, value: variables, extraction: info.extraction || undefined });

		this.showBorders = new this.options.showBorders({ value: !!info.showBorders });

		this.alternateBackground = new this.options.alternateBackground({ value: !!info.alternateBackground });
	},

	getDefaultVariables: function getDefaultVariables() {
		return [{
			label: gettext('Variable 1')
		}, {
			label: gettext('Variable 2')
		}];
	},

	getVariables: function getVariables() {
		var that = this;

		return $.map(this.variables.value, function (el, i) {
			var choices = el.choices ? el.choices : that.choices;
			return new that.baseType($.extend({}, {
				id: that.id + '_' + i,
				label: that.name.get() ? '[' + that.name.get() + '.' + i + '] ' + el.text.get() : el.text.get(),
				choices: choices ? $.map(choices.value, function (el) {
					return el.text.get();
				}) : undefined
			}));
		});
	},

	variableAdded: function variableAdded(value) {
		var row = $('<tr><td style="width:' + this.firstColSize.get() + '%"><label><span class="variable"><\/span><\/label><\/td><td class="input"><\/td><\/tr>').appendTo(this.tableDisplay);

		if (value) {
			$('span.variable', row).html(value.text.get());
			$('td.input', row).append(value.input = this.getInput(value));
		}

		return row;
	},

	variableChanged: function variableChanged(index, value) {
		$('span.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function variableRemoved(index) {
		$('tr', this.tableDisplay).eq(index).remove();
	},

	variablesCleared: function variablesCleared() {
		$('tr', this.tableDisplay).remove();
	},

	serialize: function serialize() {
		var children = [];

		for (var i = 0; i < this.variables.length(); i++) {
			children.push(this.serializeVariable(i, this.variables.value[i]));
		}
		return $.extend(_baseField2.default.Field.prototype.serialize.call(this), {
			grouped: true,
			randomize: this.randomize.get() || false,
			alphabetize: this.alphabetize.get() || false,
			questionSize: this.firstColSize.get() || 30,
			unique: this.unique.get() || false,
			uniqueError: this.uniqueError.get() || gettext('These answers must be unique'),
			staticcol: (this['staticcol'] ? this.staticcol.get() : false) || false,
			showBorders: this.showBorders.get() || false,
			alternateBackground: this.alternateBackground.get() || false,
			extraction: this.variables.extraction.serialize(),
			children: children
		});
	},

	renderContent: function renderContent() {
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<table class="variables"></table>');

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	serializeVariable: function serializeVariable(i, info) {}
});

_baseField2.default.TextGridField = $.klass(_baseField2.default.GridField, {
	type: 'text-response-grid',
	qlass: 'text-response-grid',
	cssType: 'text-response-grid',
	extractable: true,
	isBranchable: true,
	displayName: gettext('Text Response Grid'),
	questionSize: 20,
	isVisible: false,

	baseType: Variable.String,

	supportedActions: _baseField2.default.GridField.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	options: $.extend({}, _baseField2.default.GridField.prototype.options, {
		variableList: Class.create(_baseField2.default.GridField.prototype.options.variableList, {
			options: _baseField2.default.TextField.prototype.options,

			itemFromValue: function itemFromValue($super, value) {
				var that = this;

				var item = $super(value);

				return $.extend(item, {
					appearance: new this.options.appearance({ field: item, value: value && value.appearance === 'full' }),
					rows: new this.options.rows({ field: item, value: value && value.rows || undefined }),
					cols: new this.options.cols({ field: item, value: value && value.cols || undefined }),
					initialValue: new this.options.initialValue({ field: item, value: value && value.initialValue || undefined }),
					restore_default: new this.options.restore_default({ field: item, value: value && value.restore_default || undefined }),
					validation: new Validation(this.field, { value: value && value.validation || undefined }),
					renderContent: function renderContent() {
						item.input.replaceWith(item.input = that.field.getInput(item));
					}
				});
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				return $super(item, index).append(item.appearance.render(item), Option.renderGroup(gettext('Additional Options'), [item.validation, item.initialValue, item.restore_default], true));
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		$super(info, editor);
		this.sum = new chide.opts.Text({
			displayInline: true,
			allowBlank: true,
			inputClass: 'text inline medium',
			label: gettext('Sum'),
			value: info && info.sum || undefined,
			help: gettext("About Sum - Sum validates that all answers given add up to a certain value. (Enter '-' to show, but not validate, the sum.)")
		});

		this.sum.set = function (value) {
			this.value = value;
		};

		this.sum_label = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Sum Label ({x} - Total, {y} - Current)'),
			value: info && info.sum_label || gettext('The values should add up to {x}. Currently: {y}'),
			help: gettext('Sum Label - The label that will show beneath the question informing the user of the restraint. Place {x} or {y} in your text and they will be replaced with their appropriate values. Leave blank to show nothing.')
		});

		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables')
		});

		this.options_panel = new Option.Collapsable({
			collapsed: true,
			label: gettext('Options')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});
	},

	getInput: function getInput(value) {
		return _baseField2.default.TextField.prototype.getInput.call(value);
	},

	renderContent: function renderContent() {
		var that = this;
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<table class="variables"></table>');
		var value = this.variables.value;

		for (var i = 0; i < this.variables.length(); i++) {
			this.variableAdded();
		}

		$('span.variable', table).text(function (i) {
			return value[i].text.get();
		});
		$('td.input', table).append(function (i) {
			return value[i].input = that.getInput(value[i]);
		});

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	showOptions: function showOptions($super, options) {
		var that = this;

		$super(options);

		options.append(this.variables_panel.render([this.variables.render()])).append(this.display_panel.render([this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()])).append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render(), this.uniqueError.render(), this.sum.render(), this.sum_label.render()]));
	},

	serializeVariable: function serializeVariable(i, info) {
		return $.extend({}, {
			type: 'string',
			label: info.text.get() && info.text.value,
			required: !info.optional.value,
			validation: info.validation.value && info.validation.value.type && info.validation.value.type !== 'none' && info.validation.get() || undefined,
			initialValue: info.initialValue.get() && info.initialValue.value || undefined,
			restore_default: info.restore_default.get() && info.restore_default.value || undefined,
			appearance: info.appearance.get() && 'full' || undefined,
			rows: info.rows.value || undefined,
			cols: info.cols.value || undefined
		});
	},

	getExtractionChoices: function getExtractionChoices() {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.value]];
		});
	},

	getExtractionOptions: function getExtractionOptions(config) {
		return new chide.opts.Checkbox({
			label: gettext('Extract only unique responses'),
			value: config && config.unique
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(options) {
		return {
			unique: options && options.value ? options.value : false
		};
	},

	serialize: function serialize($super) {
		var info = $super();

		if (!isNaN(this.sum.get()) || this.sum.get() == "-" || typeof this.sum.get() === 'string' && this.sum.get().match(/{{.*}}/)) {
			info.sum = this.sum.get();
		}

		info.sum_label = this.sum_label.value;

		return info;
	}
});

_baseField2.default.ChoiceGridField = $.klass(_baseField2.default.GridField, {
	type: 'choice-grid',
	qlass: 'choice-grid',
	cssType: 'choice-grid',

	displayName: gettext('Choice Grid'),

	baseType: Variable.Single,

	isGrouped: true,
	hasOther: false,
	hasChoiceChildren: true,

	options: $.extend({}, _baseField2.default.GridField.prototype.options, {
		choiceList: Class.create(_baseField2.default.ChoiceField.prototype.options.choiceList, {
			direction: 'horizontal',
			tabOffset: 10000
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		var choices;

		if (info.children && info.children[0] && info.children[0].choices) {
			choices = info.children[0].choices;
		} else if (info.choices) {
			choices = info.choices;
		} else {
			choices = this.getDefaultChoices();
		}

		this.choices = new this.options.choiceList({ field: this, value: choices, extraction: info.choice_extraction });

		this.choices_panel = new Option.Collapsable({
			label: gettext('Choices'),
			collapsed: false
		});
		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables'),
			collapsed: false
		});
		this.options_panel = new Option.Collapsable({
			label: gettext('Options'),
			collapsed: true,
			id: 'options'
		});
		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true,
			id: 'display'
		});
	},

	getDefaultChoices: function getDefaultChoices() {
		return [{
			label: gettext('Choice 1')
		}, {
			label: gettext('Choice 2')
		}];
	},

	choiceAdded: function choiceAdded(value) {
		var that = this;
		var len = $('span.choice', this.tableHeader).length;

		var choice = $('<td><span class="choice"></span></td>');

		if (len) {
			choice.insertAfter($('td', this.tableHeader).eq(len));
		} else {
			choice.appendTo(this.tableHeader);
		}

		if (value) {
			$('span.choice', choice).html(value.text.get());
		}

		$('tbody tr', this.tableDisplay).each(function (i) {
			var cell = $('<td><input type="radio" name="' + that.id + '_' + i + '"></td>');

			if (len) {
				cell.insertAfter($('td', this).eq(len));
			} else {
				cell.appendTo(this);
			}
		});
	},

	choiceChanged: function choiceChanged(index, value) {
		$('span.choice', this.tableHeader).eq(index).html(value.text.get());
	},

	choiceRemoved: function choiceRemoved(index) {
		$('td:nth-child(' + (index + 2) + ')', this.tableDisplay).remove();
	},

	variableAdded: function variableAdded(value) {
		var row = '<tr><td style="width:' + this.firstColSize.get() + '%"><span class="variable"></span><\/td>';
		var index = this.variables.length();

		for (var j = 0; j < this.choices.value.length; j++) {
			row += '<td><input type="radio" name="' + this.id + '_' + index + '"></td>';
		}

		row = $(row + '<\/tr>');

		if (value) {
			$('span.variable', row).html(value.text.get());
		}

		return row.appendTo($('tbody', this.tableDisplay));
	},

	variableChanged: function variableChanged(index, value) {
		$('tbody span.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function variableRemoved(index) {
		$('tbody tr', this.tableDisplay).eq(index).remove();
	},

	variablesCleared: function variablesCleared() {
		$('tbody tr', this.tableDisplay).remove();
	},

	renderContent: function renderContent() {
		var that = this;
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<table class="variables"></table>');

		this.tableHeader = $('<thead><tr><td style="width:' + this.firstColSize.get() + '%"></td></tr></thead>').appendTo(table).find('tr');

		table.append('<tbody><\/tbody>');

		for (var j = 0; j < this.choices.length(); j++) {
			this.choiceAdded();
		}

		for (var j = 0; j < this.variables.length(); j++) {
			this.variableAdded(this.variables.value[j]);
		}

		$('span.choice', table).html(function (i) {
			return that.choices.value[i].text.get();
		});

		if (old) {
			old.remove();
		}
		table.appendTo(this.element);
	},

	showOptions: function showOptions($super, options) {
		_baseField2.default.Field.prototype.showOptions.call(this, options);

		options.append(this.choices_panel.render([this.choices.render()])).append(this.variables_panel.render([this.variables.render()])).append(this.display_panel.render([this.staticcol ? this.staticcol.render() : undefined, this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render(), this.showBorders.render(), this.alternateBackground.render()])).append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render()]));
	},

	serialize: function serialize($super) {
		var info = $super();

		if (this.choices.extraction.question.get()) {
			info.choice_extraction = this.choices.extraction.serialize();
		}

		info.choices = [];

		for (var i = 0; i < this.choices.length(); i++) {
			info.choices.push($.extend({}, {
				label: this.choices.value[i].text.value,
				score: this.choices.value[i].score.value
			}));
		}

		return info;
	},

	serializeVariable: function serializeVariable(i, info) {
		return {
			type: 'single',
			label: info.text.value,
			required: !info.optional.value
		};
	}
});

_baseField2.default.SingleChoiceGridField = $.klass(_baseField2.default.ChoiceGridField, {
	type: 'single-choice-grid',
	qlass: 'single-choice-grid',
	cssType: 'single-choice-grid',

	displayName: gettext('Rating Scale'),
	isBranchable: true,

	extractable: true,

	supportedActions: _baseField2.default.ChoiceGridField.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	getDefaultVariables: function getDefaultVariables() {
		return [{
			label: gettext('Row 1')
		}];
	},

	getDefaultChoices: function getDefaultChoices() {
		return [{
			label: gettext('Choice 1')
		}, {
			label: gettext('Choice 2')
		}, {
			label: gettext('Choice 3')
		}, {
			label: gettext('Choice 4')
		}];
	},

	getExtractionChoices: function getExtractionChoices() {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.get()]];
		});
	},

	getExtractionOptions: function getExtractionOptions(config) {
		var choices;

		if (this.choices.extraction.question.get()) {
			choices = this.choices.extraction.question.getField().getExtractionChoices();
		} else {
			choices = $.map(this.choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		}

		choices.push([-1, 'No Choice']);

		var selectAll = $.map(choices, function (val, i) {
			return [i];
		});

		return new ($.klass(Option.Multiple, {
			render: function render($super) {
				return $super().prepend(this.label);
			}
		}))(this, {
			label: gettext('Choices which should trigger extraction:'),
			value: config ? config.choices : selectAll,
			choices: choices
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(options) {
		return {
			choices: options ? $.map(options.value, function (i) {
				return parseInt(i, 10);
			}) : []
		};
	}
});

_baseField2.default.DropDownGridField = $.klass(_baseField2.default.ChoiceGridField, {
	type: 'dropdown-grid',
	qlass: 'dropdown-grid',
	cssType: 'dropdown-grid',

	displayName: gettext('Dropdown Grid'),

	isGrouped: true,
	isBranchable: true,
	isVisible: false,

	extractable: true,

	supportedActions: _baseField2.default.ChoiceGridField.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	options: $.extend({}, _baseField2.default.ChoiceGridField.prototype.options, {
		variableList: Class.create(_baseField2.default.ChoiceGridField.prototype.options.variableList, {
			options: _baseField2.default.ChoiceField.prototype.options,

			itemFromValue: function itemFromValue($super, value) {
				var that = this;

				var item = $super(value);

				return $.extend(item, {
					randomize: new this.options.randomize({ field: item, value: value && value.randomize || false }),
					alphabetize: new this.options.alphabetize({ field: item, value: value && value.alphabetize || false })
				});
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				return $super(item, index).append(item.alphabetize.render(), item.randomize.render());
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		info = info || {};

		$super(info, editor);

		var that = this;

		this.blankChoice = new _baseField2.default.DropDownChoiceField.prototype.options.blankChoice({
			field: this,
			value: info.children && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined,
			changed: function changed(value) {
				$('select.choices option.blank', that.tableDisplay).text(value);
			}
		});
	},

	showOptions: function showOptions($super, options) {
		_baseField2.default.Field.prototype.showOptions.call(this, options);

		options.append(this.choices_panel.render([this.choices.render()])).append(this.variables_panel.render([this.variables.render()])).append(this.display_panel.render([this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]).append(this.options_panel.render([this.randomize.render(), this.alphabetize.render(), this.unique.render(), this.uniqueError.render(), this.blankChoice.render()])));
	},

	choiceAdded: function choiceAdded(value) {
		$('select.choices', this.tableDisplay).append($('<option><\/option>').text(value.text.get()));
	},

	choiceChanged: function choiceChanged(index, value) {
		$('select.choices option:nth-child(' + (index + 2) + ')', this.tableDisplay).text(value.text.get());
	},

	choiceRemoved: function choiceRemoved(index) {
		$('select.choices option:nth-child(' + (index + 2) + ')', this.tableDisplay).remove();
	},

	variableAdded: function variableAdded(value, input) {
		var row = $('<tr><td style="width:' + this.firstColSize.get() + '%"><span class="variable"><\/span><\/td><td class="input"><\/td><\/tr>');

		if (value) {
			$('span.variable', row).html(value.text.get());
		}

		$('td.input', row).append(this.getInput());

		return row.appendTo(this.tableDisplay);
	},

	getInput: function getInput() {
		var choices = $('<select class="choices custom-select"/>');

		choices.append('<option class="blank">' + this.blankChoice.get() + '</option>');

		for (var i = 0; i < this.choices.length(); i++) {
			choices.append('<option>' + this.choices.getAt(i) + '</option>');
		}

		return choices;
	},

	renderContent: function renderContent() {
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<table class="variables"></table>');

		for (var i = 0; i < this.variables.length(); i++) {
			this.variableAdded(this.variables.value[i]);
		}

		if (old) {
			old.remove();
		}

		table.appendTo(this.element);
	},

	serializeVariable: function serializeVariable(i, info) {
		return $.extend({}, {
			type: 'dropdown',
			label: info.text.value,
			required: !info.optional.value,
			blank_choice: this.blankChoice.value,
			randomize: info.randomize.value || false,
			alphabetize: info.alphabetize.value || false
		});
	},

	getExtractionChoices: function getExtractionChoices() {
		var that = this;

		if (this.variables.extraction.question.get()) {
			return this.variables.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.variables.value, function (val, i) {
			return [[i, val.text.get()]];
		});
	},

	getExtractionOptions: function getExtractionOptions(config) {
		var choices;

		if (this.choices.extraction.question.get()) {
			choices = this.choices.extraction.question.getField().getExtractionChoices();
		} else {
			choices = $.map(this.choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		}
		choices.push([-1, 'No Choice']);
		return new ($.klass(Option.Multiple, {
			render: function render($super) {
				return $super().prepend(this.label);
			}
		}))(this, {
			label: gettext('Choices which should trigger extraction:'),
			value: config ? config.choices : [],
			choices: choices
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(options) {
		return {
			choices: options ? $.map(options.value, function (i) {
				return parseInt(i, 10);
			}) : []
		};
	}
});

_baseField2.default.DateTimeField = $.klass(_baseField2.default.Field, {
	type: 'datetime',
	qlass: 'datetime',
	cssType: 'datetime',
	isBranchable: true,
	isQuestion: false,
	displayName: gettext('Date/Time'),

	timezones: [[0, '(GMT -12:00) Eniwetok, Kwajalein'], [1, '(GMT -11:00) Midway Island, Samoa'], [2, '(GMT -10:00) Hawaii'], [3, '(GMT -9:00) Alaska'], [4, '(GMT -8:00) Pacific Time (US, Canada'], [5, '(GMT -7:00) Mountain Time (US, Canada)'], [6, '(GMT -6:00) Central Time (US, Canada)'], [7, '(GMT -5:00) Eastern Time (US, Canada)'], [8, '(GMT -4:00) Atlantic Time (Canada), Caracas'], [9, '(GMT -3:30) Newfoundland'], [10, '(GMT -3:00) Brazil, Buenos Aires, Georgetown'], [11, '(GMT -2:00) Mid-Atlantic'], [12, '(GMT -1:00 hour) Azores, Cape Verde Islands'], [13, '(GMT) UTC, London, Lisbon, Casablanca'], [14, '(GMT +1:00 hour) Brussels, Madrid, Paris'], [15, '(GMT +2:00) Kaliningrad, South Africa'], [16, '(GMT +3:00) Baghdad, Riyadh, Moscow'], [17, '(GMT +3:30) Tehran'], [18, '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi'], [19, '(GMT +4:30) Kabul'], [20, '(GMT +5:00) Ekaterinburg, Islamabad'], [21, '(GMT +5:30) Bombay, Calcutta, Madras'], [22, '(GMT +6:00) Almaty, Dhaka, Colombo'], [23, '(GMT +7:00) Bangkok, Hanoi, Jakarta'], [24, '(GMT +8:00) Beijing, Singapore, Hong Kong'], [25, '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo'], [26, '(GMT +9:30) Adelaide, Darwin'], [27, '(GMT +10:00) Eastern Australia, Guam'], [28, '(GMT +11:00) Magadan, Solomon Islands'], [29, '(GMT +12:00) Auckland, Wellington, Fiji']],

	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		dateFormat: Class.create(chide.opts.Single, {
			label: gettext('Display Format'),
			choices: [[0, gettext('Date/time')], [1, gettext('Date only')], [2, gettext('Time only')], [3, gettext('Day/Month')], [4, gettext('Month/Year')]],
			get: function get() {
				return this.value === undefined ? 0 : this.value;
			},
			set: function set(value) {
				this.value = value == 0 ? undefined : value;
			},
			changed: function changed() {
				this.field.renderContent();
			}
		}),

		showTimezone: Class.create(chide.opts.Checkbox, {
			label: gettext('Timezone'),
			changed: function changed(value) {
				this.field.renderContent();
			}
		}),

		initialValueDate: Class.create(chide.opts.Text, (_Class$create2 = {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Date'),
			help: gettext('Optional - Choose an initial value for the date.')
		}, _defineProperty(_Class$create2, 'inputClass', 'text short iDate'), _defineProperty(_Class$create2, 'changed', function changed(value) {
			this.field.input.val(value);
		}), _Class$create2)),

		initialValueTime: Class.create(chide.opts.Text, (_Class$create3 = {
			displayInline: true,
			inputClass: 'text inline short',
			label: gettext('Initial Time'),
			help: gettext('Optional - Choose an initial value for the time.')
		}, _defineProperty(_Class$create3, 'inputClass', 'text short iTime'), _defineProperty(_Class$create3, 'changed', function changed(value) {
			this.field.input.val(value);
		}), _Class$create3)),

		giveInitialValue: Class.create(chide.opts.Checkbox, {
			label: gettext('Set to now by default'),
			changed: function changed(value) {
				this.field.renderContent();
			}
		}),

		showNowButton: Class.create(chide.opts.Checkbox, {
			label: gettext('Show "Record Now" button'),
			changed: function changed(value) {
				this.field.renderContent();this.field.showOptions($('#survey-editor-field-options'));
			}
		}),

		NowButtonText: Class.create(chide.opts.Text, {
			displayInline: true,
			inputClass: 'text inline medium',
			label: gettext('Customize text'),
			labelClass: 'inline',
			changed: function changed(value) {
				this.field.renderContent();
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		$super(info, editor);

		var that = this;

		this.optional = new this.options.optional({ info: info, changed: function changed(value) {
				that.render();
			} });

		this.dateFormat = new this.options.dateFormat({ field: this, value: info && info.format !== undefined ? info.format : info && info.children && info.children.length && info.children[0].dateFormat !== undefined ? info.children[0].dateFormat : '0' });

		this.initialValueDate = new this.options.initialValueDate({ field: this, value: info && info.children && info.children[0] && info.children[0].initialValueDate || info && info.initialValueDate || undefined });

		this.initialValueTime = new this.options.initialValueTime({ field: this, value: info && info.children && info.children[0] && info.children[0].initialValueTime || info && info.initialValueTime || undefined });

		this.showTimezone = new this.options.showTimezone({ field: this, value: info && info.timezone !== undefined ? info.timezone : info && info.children && info.children.length && info.children[0].timezone !== undefined ? info.children[0].timezone : false });

		this.giveInitialValue = new this.options.giveInitialValue({ field: this, value: info && info.giveInitialValue !== undefined ? info.giveInitialValue : info && info.children && info.children.length && info.children[0].giveInitialValue !== undefined ? info.children[0].giveInitialValue : false });

		this.showNowButton = new this.options.showNowButton({ field: this, value: info && info.showNowButton !== undefined ? info.showNowButton : info && info.children && info.children.length && info.children[0].showNowButton !== undefined ? info.children[0].showNowButton : false });

		this.nowButtonText = new this.options.NowButtonText({ field: this, value: info && info.nowButtonText !== undefined ? info.nowButtonText : info && info.children && info.children.length && info.children[0].nowButtonText !== undefined ? info.children[0].nowButtonText : 'Record Now' });
	},

	getVariables: function getVariables() {
		return [new Variable.DateTime({ id: this.id, label: this.getIdentifier() })];
	},

	getInput: function getInput() {
		var mode = this.dateFormat.get();

		var result = $('<div/>');

		if (mode == 0 || mode == 1) {
			var placeholder = gettext("YYYY/MM/DD");

			if (window.DATE_FORMAT == '0') {
				placeholder = 'MM/DD/YYYY';
			} else if (window.DATE_FORMAT == '1') {
				placeholder = 'DD/MM/YYYY';
			}

			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="' + placeholder + '" />');
		}

		if (mode == 3) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="MM/DD" />');
		}

		if (mode == 4) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="MM/YY" />');
		}

		if (mode == 5 || mode == 7) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="' + gettext("MM/DD/YYYY") + '" />');
		}

		if (mode == 6 || mode == 8) {
			result.append('<input type="text" class="form-control d-inline mr-3" style="width: 9em;" value="' + gettext("DD/MM/YYYY") + '" />');
		}

		if (mode == 0 || mode == 2 || mode == 5 || mode == 6) {
			result.append('<input type="text" class="form-control d-inline" style="width: 4em;" value="HH" />:', '<input type="text" class="form-control d-inline mr-1" style="width: 4em;" value="MM" />', '<input type="text" class="form-control d-inline" style="width: 6em;" value="AM/PM" />');
		}

		if (this.showTimezone.get()) {
			chide.opts.renderSelect(this.timezones, '---').appendTo(result);
		}

		if (this.showNowButton.get()) {
			result.append('<a href="#" class="btn btn-default">' + this.nowButtonText.get() + '</a>');
		}

		return result;
	},

	showOptions: function showOptions($super, options) {
		$super(options);

		options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));
		var sub_options = [this.optional, this.dateFormat, this.showTimezone, this.giveInitialValue, this.showNowButton];

		if (this.showNowButton.get()) {
			sub_options.push(this.nowButtonText);
		}

		sub_options.concat([this.initialValueDate, this.initialValueTime]);
		options.append(Option.renderGroup(gettext('Options'), sub_options, true));
		//who knows how to set the placeholder when creating the object?
		$('.iDate').attr('placeholder', 'YYYY/MM/DD');
		$('.iTime').attr('placeholder', '18:00');
	},

	renderContent: function renderContent() {
		if (this.input) {
			this.input.remove();
		}

		this.element.append(this.input = this.getInput());
	},

	serialize: function serialize($super) {
		var info = $super();

		info.children = [];

		info.children.push($.extend({}, {
			type: this.type,
			required: !this.optional.value,
			dateFormat: this.dateFormat.value,
			timezone: this.showTimezone.get(),
			giveInitialValue: this.giveInitialValue.get(),
			showNowButton: this.showNowButton.get(),
			nowButtonText: this.nowButtonText.value,
			initialValueDate: this.initialValueDate.get() && this.initialValueDate.value || undefined,
			initialValueTime: this.initialValueTime.get() && this.initialValueTime.value || undefined

		}));

		return info;
	}
});

_baseField2.default.Helpers = {
	useMapping: false,

	mapping: {},

	normalizeField: function normalizeField(field) {
		/* Perform any post load/paste actions to prepare this field for use in the editor */

		/*
  if (field.choices && field.choices.value && field.branching) {
  	field.choices.value.each(function (i) {
  		if (this.branching && this.branching.value == undefined) {
  			for (var j = 0; j < field.branching.length; j++) {
  				if (field.branching[j].val == i) {
  					this.branching.set(Fields.Helpers.getPageIdByPageIndex(field.branching[j].page));
  				}
  			}
  		}
  	});
  }
  */

		/* hack for BooleanField */
		/*
  if (field.branchingOptions) {
  	field.branchingOptions.each(function (i) {
  		for (var j = 0; j < field.branching.length; j++) {
  			if (field.branching[j].val == i) {
  				this.set(Fields.Helpers.getPageIdByPageIndex(field.branching[j].page));
  			}
  		}
  	});
  }*/

	},

	removeBranching: function removeBranching(field) {
		/* Takes in a serialized field and strips branching. For use in copy operations. */

		if (field.children && field.children[0]) {
			$(field.children).each(function () {
				if (this.branch) {
					this.branch = [];
				}
			});
		}
	},

	specialIDs: ['finish', 'terminate', 'redirect', 'random', 'random-range', 'hide', 'email', 'continue', 'mark-complete'],

	getPageIdByPageIndex: function getPageIdByPageIndex(pageIdx) {
		var survey = __webpack_require__(74).Survey.instances[0];

		if (pageIdx == -10) return 'terminate';
		if (this.specialIDs.indexOf(pageIdx) != -1) return pageIdx;
		//if (pageIdx in survey.sectionMapping) return pageIdx;

		return survey.pages[pageIdx] ? survey.pages[pageIdx].id : pageIdx;
	},
	getPageIdByPageNumber: function getPageIdByPageNumber(pageNum) {
		if (this.specialIDs.indexOf(pageNum) != -1) return pageNum;
		return _baseField2.default.Helpers.getPageIdByPageIndex(pageNum - 1);
	},

	getPageIndexByPageId: function getPageIndexByPageId(pageId) {
		if (pageId == -10) {
			pageId = 'terminate';
		}

		if (this.specialIDs.indexOf(pageId) != -1) return pageId;

		/*if (pageId in Surveys.Survey.instances[0].sectionMapping){
  	//Named section
  	return pageId;
  }*/

		if (pageId in this.mapping) {
			return this.mapping[pageId].index;
		} else if (parseInt(pageId, 10) == pageId) {
			return pageId;
		}
	},

	getPageNumberByPageId: function getPageNumberByPageId(pageId) {
		if (this.specialIDs.indexOf(pageId) != -1) return pageId;
		return _baseField2.default.Helpers.getPageIndexByPageId(pageId) + 1;
	}
};

_baseField2.default.Natrix = $.klass(_baseField2.default.Field, {
	type: 'custom-grid',
	qlass: 'custom-grid',
	cssType: 'custom-grid',

	displayName: gettext('Single Column Grid'),
	helpText: gettext('One answer per row (Dropdown, Text Response, Checkbox, or Radio Buttons)'),
	isEnabled: true,

	isGrouped: true,
	isCustom: true,
	isDynamic: false,
	choiceAppearanceTypes: ['vertical', 'horizontal', 'star', 'combo'],
	getVarContainer: function getVarContainer(index) {
		return index === undefined ? $('table.variables tr', this.element) : $('table.variables tr', this.element).eq(index);
	},
	getVarLabels: function getVarLabels(index) {
		return $('table.variables tr', this.element).eq(index).find('th .variable');
	},
	getVarFields: function getVarFields(index) {
		return $('table.variables tr', this.element).eq(index).find('td').not('.sma-natrix-guidestar-container');
	},
	options: $.extend({}, _baseField2.default.TextField.prototype.options, _baseField2.default.GridField.prototype.options, {
		firstColSize: _baseField2.default.GridField.prototype.options.firstColSize,

		variableList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,
			label: gettext('Variables'),
			enableExtraction: false,
			itemFromValue: function itemFromValue($super, value) {
				var item = $super(value);
				return $.extend(item, this.field.getVariableSubOptions(value, item));
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				return this.field.renderVariableSubOptions($super(item, index), item);
			},

			itemAdded: function itemAdded(item) {
				this.field.variableAdded(item);
			},
			itemChanged: function itemChanged(index, value) {
				this.field.variableChanged(index, value);
			},
			itemRemoved: function itemRemoved(index) {
				this.field.variableRemoved(index);
			},
			itemsChanged: function itemsChanged(value) {
				this.field.renderContent();
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length && info.children) {
			var variables = $.map(info.children, function (el) {
				return ['string', 'dropdown', 'single', 'checkbox'].indexOf(el.type) >= 0 ? el : undefined;
			});
		} else {
			var variables = this.getDefaultVariables();
		}

		this.variables = new this.options.variableList({
			field: this,
			value: variables
		});

		this.variables_panel = new Option.Collapsable({
			label: gettext('Variables')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});

		this.firstColSize = new this.options.firstColSize({
			field: this,
			value: info.questionSize || this.questionSize || 30
		});
	},

	getVariables: function getVariables() {
		var that = this;
		return $.map(this.variables.value, function (el, i) {
			return new Variable[{
				'string': 'String',
				'checkbox': 'Boolean',
				'single': 'Single',
				'dropdown': 'Single'
			}[el.type.get()]]($.extend({}, {
				id: that.id + '_' + i,
				label: that.name.get() ? '{ ' + that.name.get() + '[' + i + '] } ' + el.text.get() : el.text.get(),
				choices: el.choices ? $.map(el.choices.value, function (el) {
					return el.text.get();
				}) : undefined
			}));
		});
	},

	getDefaultChoices: function getDefaultChoices() {
		return [{ label: gettext('Choice 1') }, { label: gettext('Choice 2') }];
	},

	getDefaultVariables: function getDefaultVariables() {
		return [{
			label: gettext('Variable 1'),
			required: false,
			type: 'string'
		}, {
			label: gettext('Variable 2'),
			required: false,
			type: 'dropdown',
			choices: this.getDefaultChoices()
		}, {
			label: gettext('Variable 3'),
			required: false,
			type: 'single',
			choices: this.getDefaultChoices()
		}];
	},

	getInput: function getInput(variable, index) {
		var type = variable.type.get();
		var appearance = variable.appearance.get();
		if (type == 'string') {
			if (appearance) {
				return $('<textarea>', { 'class': 'text', 'text': variable.initialValue.get(), 'cols': variable.cols.get(), 'rows': variable.rows.get() });
			} else {
				return $('<input>', { 'type': 'text', 'class': 'text', 'value': variable.initialValue.get(), 'cols': variable.cols.get() * 10 + 'px' });
			}
		} else if (type == 'checkbox') {
			return $('<label class="custom-control custom-checkbox">\
				<input type="checkbox" class="custom-control-input ">\
				<span class="custom-control-indicator"></span></label>');
		} else {
			var id = (0, _utils.randomString)(10);
			appearance = variable.choiceAppearance.get();
			var input;
			if (type == 'dropdown' || appearance == "combo") {
				input = $('<select>', { 'size': type == "dropdown" ? undefined : '3', 'class': type == "dropdown" ? 'choices custom-select' : 'choices combo' });
				if (type == 'dropdown') {
					input.prepend($('<option>', { 'class': 'dummy', text: variable.blankChoice.get() }));
				}
				$.each(variable.choices.value, function (i, choice) {
					$('<option>', { value: i, html: variable.choices.getAt(i), 'class': 'choice label' }).appendTo(input);
				});
			} else if (appearance == "column") {
				input = $($.map(variable.choices.value, function (el, i) {
					return $('<td>', { 'class': 'choice column-' + index }).append($('<input>', { type: 'radio', 'name': id }))[0];
				}));
			} else if (appearance === 'vertical' || appearance === 'horizontal') {
				input = appearance === 'horizontal' ? $('<ul class="d-flex">') : $('<ul>');

				$.each(variable.choices.value, function (i, choice) {
					$('<li class="choice"><label class="custom-control custom-radio">\
						<input name="' + this.id + '" type="radio" class="custom-control-input ">\
						<span class="custom-control-indicator"></span>\
						<span class="custom-control-description">\
						<label for="' + this.id + '">' + variable.choices.getAt(i) + '</label></span></label></li>').appendTo(input);
				});
			} else {
				input = $('<ul>', { 'class': appearance == 'star' ? 'choices star' : 'choices' });
				$.each(variable.choices.value, function (i, choice) {
					$('<li>', { 'class': 'choice', css: appearance == 'horizontal' ? { 'float': 'left', 'padding-right': '5px' } : {} }).append($('<input>', { type: 'radio', 'name': id }), $('<span>', { 'class': 'label', text: variable.choices.getAt(i) })).appendTo(input);
				});
			}
			return input;
		}
	},
	renderContent: function renderContent() {
		var that = this;

		if (this.tableDisplay) {
			this.tableDisplay.remove();
		}

		var table = this.tableDisplay = $('<table class="variables"></table>');

		$.each(this.variables.value, function (i) {
			var guideStarLogo = '<img width="18px" class="sma-guidestar-logo" src="' + MEDIA_URL + 'img/smapply/GuideStarLogo.svg">';

			var tempGuideStarLogo = that.variables.value[i].guideStarMapping.value ? guideStarLogo : '';

			table.append($('<tr>').addClass('align-items-center').append($('<th>').width(that.firstColSize.get() + '%').append($('<span><\/span>').addClass('variable').text(that.variables.getAt(i)))).append($('<td class="sma-natrix-guidestar-container">').width(18).append(tempGuideStarLogo)).append($('<td>').append(that.getInput(that.variables.value[i]))));
		});

		table.appendTo(this.element);
	},

	choiceAdded: function choiceAdded(index, value) {
		var variable = this.variables.value[index];
		if (variable.choices.value.length <= 1) {
			this.variableMorphed(index, variable.type.get());
			return true;
		}
		this.getVarFields(index).find('.choices').find('.choice:last').each(function () {
			$(this).clone().insertAfter(this).find('.label').addBack().filter('.label').html(value ? value.text.get() : '').end().find('input, option').addBack().filter('input, option').val(variable.choices.length - 1);
		});
	},
	choiceChanged: function choiceChanged(index, choice, label) {
		this.getVarFields(index).each(function () {
			$(this).find('.choice .label, .choice.label').eq(choice).html(label.text.get());
		});
	},
	choiceRemoved: function choiceRemoved(index, choice) {
		this.getVarFields(index).find('.choices').find('.choice:eq(' + choice + ')').remove();
	},
	choicesCleared: function choicesCleared(index) {
		this.variableMorphed(index, this.variables.value[index].type.get());
	},
	blankChoiceChanged: function blankChoiceChanged(index, value) {
		this.getVarFields(index).find('select option:first').text(value);
	},
	appearanceChanged: function appearanceChanged(index, value) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},
	choiceAppearanceChanged: function choiceAppearanceChanged(index, value, old) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},
	variableAdded: function variableAdded(value) {
		if (this.variables.value.length > 1) {
			var input = this.getInput(value, this.variables.value.indexOf(value));
			$('.variables tr', this.element).last().clone().find('th:first .variable').html(value.text.get()).end().find('td').empty().each(function () {
				$(this).append(input.clone());
			}).end().appendTo($('.variables', this.element));
		} else {
			this.renderContent();
		}
	},

	variableRemoved: function variableRemoved(index) {
		this.getVarContainer(index).remove();
	},

	variableChanged: function variableChanged(index, value) {
		this.getVarLabels(index).html(value.text.get());
	},

	variablesCleared: function variablesCleared() {
		this.getVarContainer().remove();
	},

	variableMorphed: function variableMorphed(index, newType, update) {
		var variable = this.variables.value[index];

		var input = this.getInput(this.variables.value[index]);
		this.getVarFields(index).empty().each(function () {
			$(this).append(input.clone());
		});
		if (update !== false) {
			$(this.variables.value[index]).trigger('variableMorphed', [newType]);
		}
	},

	renderVariableSubOptions: function renderVariableSubOptions(el, child) {
		var that = this;

		var type = child.type.get();

		if (this.isDynamic) {
			this.dynamics = function (fn, scope, args) {
				return {
					render: function render() {
						return fn.apply(scope, args);
					}
				};
			}(child.dynamics.render, child.dynamics, [child.choices.value]);

			$(child).unbind('choiceChanged').bind('choiceChanged', function (event, choices) {
				$(child.dynamics).trigger('choiceChanged', [choices]);
			});
		}

		var result = el;

		child._subOptions = function (type, el) {
			var renderedOptions = [];
			var singleColumnGridOptions = [child.validation, child.initialValue, child.restore_default];
			var options = [child.type];

			if (that.isDynamic) {
				var dynamics = Option.renderGroup(gettext('Dynamic Options'), [that.dynamics], true, true);
			} else {
				dynamics = undefined;
			}

			if (that.editor.isGuideStarEnabled) {
				singleColumnGridOptions.push(child.guideStarMapping);
			}

			options = options.concat({
				'string': [child.optional, child.appearance, Option.renderGroup(gettext('Additional Options'), that.type == "threed-grid" ? [child.validation, child.initialValue, child.sum, child.sumLabel, child.restore_default] : singleColumnGridOptions, true, true)],
				'single': [child.optional, child.choiceAppearance, Option.renderGroup(gettext('Choices'), [child.choices, child.alphabetize, child.randomize], false, true), dynamics],
				'dropdown': [child.optional, child.blankChoice, Option.renderGroup(gettext('Choices'), [child.choices, child.alphabetize, child.randomize], false, true), dynamics],
				'checkbox': []
			}[type]);

			for (var i = 0; i < options.length; i++) {
				!!options[i] && renderedOptions.push(options[i].render().hide().appendTo(el));
			}
			return renderedOptions;
		};

		$(child).unbind('variableMorphed').bind('variableMorphed', function (event, newType) {
			result.empty();

			$(child._subOptions(newType, result)).each(function () {
				$(this).fadeIn();
			});
		});

		$(child).trigger('variableMorphed', type);

		return result;
	},

	getVariableSubOptions: function getVariableSubOptions(value, child) {
		var that = this;
		// If you do this on the top of the file things fail. Try to drag a new GuideStar field
		var GuideStar = __webpack_require__(846);

		return {
			optional: new chide.opts.Checkbox({
				label: gettext('Optional'),
				value: value && value.required !== undefined ? !value.required : true
			}),
			type: new Option.Radio(this, {
				label: gettext('Switch to type:'),
				showLabel: true,
				display: 'dropdown',
				choices: [['dropdown', gettext('Dropdown')], ['string', gettext('Text Response')], ['checkbox', gettext('Checkbox')], ['single', gettext('Radio Buttons')]],
				value: value && value.type || 'string',
				changed: function changed(val) {
					var variableIndex = that.variables.value.indexOf(child);
					this.editor.survey.removeBranchingRulesWithVariable(that.id + '_' + variableIndex);
					that.variableMorphed(variableIndex, val);
				}
			}),
			choices: new _baseField2.default.ChoiceField.prototype.options.choiceList({
				field: this,
				hasSubOptions: true,
				value: value ? value.choices : this.getDefaultChoices(),
				extraction: value && value.extraction ? value.extraction : undefined,
				itemAdded: function itemAdded(item) {
					that.choiceAdded(that.variables.value.indexOf(child), item);
				},
				itemChanged: function itemChanged(index, value) {
					that.choiceChanged(that.variables.value.indexOf(child), index, value);
				},
				itemRemoved: function itemRemoved(index) {
					that.choiceRemoved(that.variables.value.indexOf(child), index);
				},
				itemsChanged: function itemsChanged(value) {
					that.variableMorphed(that.variables.value.indexOf(child), child.type.get(), false);
				}
			}),
			choiceAppearance: new _baseField2.default.ChoiceField.prototype.options.appearance({
				field: this,
				display: 'dropdown',
				showLabel: true,
				choices: $.map([['vertical', gettext("Vertical")], ['horizontal', gettext("Horizontal (Adjacent Labels)")], ['column', gettext("Horizontal (Column Labels)")], ['star', gettext("Star Rating")], ['combo', gettext("Combo Box")]], function (el, i) {
					return _(that.choiceAppearanceTypes).contains(el[0]) ? [el] : false;
				}),
				value: value && value.choiceAppearance || "vertical",
				changed: function changed(value, old) {
					that.choiceAppearanceChanged(that.variables.value.indexOf(child), value, old);
				}
			}),
			alphabetize: new _baseField2.default.ChoiceField.prototype.options.alphabetize({
				value: value && value.alphabetize !== undefined ? value.alphabetize : false,
				field: child,
				changed: function changed(value) {
					if (value) {
						this.field.randomize && this.field.randomize.set(false).refresh();
					}
				}
			}),
			randomize: new _baseField2.default.ChoiceField.prototype.options.randomize({
				value: value && value.randomize !== undefined ? value.randomize : false,
				field: child,
				changed: function changed(value) {
					if (value) {
						this.field.alphabetize && this.field.alphabetize.set(false).refresh();
					}
				}
			}),
			appearance: new this.options.appearance({
				field: child,
				value: value && (value.appearance == 'full' || value.isTextArea) || false,
				changed: function changed(val) {
					that.appearanceChanged(that.variables.value.indexOf(child), val);
				}
			}),
			sumLabel: new chide.opts.Text({
				displayInline: false,
				label: gettext('Sum Label'),
				value: value && value.sumLabel || gettext('The values of column: {x} should add up to {y}. Currently: {z}'),
				help: gettext('Sum Label - The label that will show beneath the question informing the user of the restraint. Place {x}, {y} and {z} in your text and they will be replaced with their appropriate values. Leave blank to show nothing.')
			}),
			sum: new chide.opts.Text({
				displayInline: true,
				allowBlank: true,
				translatable: false,
				label: gettext('Sum'),
				value: value && value.sum || undefined,
				help: gettext("About Sum - Sum validates that all answers given add up to a certain value. (Enter '-' to show, but not validate, the sum.)"),
				changed: function changed(val) {
					that.sumChanged(that.variables.value.indexOf(child), val);
				}
			}),
			rows: new this.options.rows({
				field: child,
				value: value && value.rows || 5,
				changed: function changed(val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').attr('rows', val);
				}
			}),
			cols: new this.options.cols({
				field: child,
				value: value && value.cols || 20,
				changed: function changed(val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').attr('cols', val);
				}
			}),
			initialValue: new this.options.initialValue({
				field: child,
				value: value && value.initialValue || '',
				changed: function changed(val) {
					var index = that.variables.value.indexOf(child);
					that.getVarFields(index).find('input[type="text"], textarea').val(val).text(val);
				}
			}),

			restore_default: new this.options.restore_default({
				field: child,
				value: value && value.restore_default || '',
				changed: function changed(val) {}
			}),

			blankChoice: new _baseField2.default.DropDownChoiceField.prototype.options.blankChoice({
				value: value && value.blank_choice || { en: '---' },
				changed: function changed(val) {
					that.blankChoiceChanged(that.variables.value.indexOf(child), val);
				}
			}),

			validation: new Validation(this, {
				value: value && value.validation || undefined
			}),

			guideStarMapping: new GuideStar.Mapping(this, {
				value: value && (value.guideStarMapping || value.guideStarDefaultMapping),
				subvariable: child
			})
		};
	},

	showOptions: function showOptions($super, options) {
		$super(options);
		var that = this;

		var variables = this.variables.render();

		options.append(this.variables_panel.render([variables])).append(this.display_panel.render([this.firstColSize.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()]));
	},

	serialize: function serialize() {
		var info = _baseField2.default.Field.prototype.serialize.call(this);

		info.grouped = true;
		info.custom = true;
		info.questionSize = this.firstColSize.get();
		info.children = [];

		$.each(this.variables.value, function (i, variable) {
			var serialized = $.extend({}, {
				label: variable.text.value,
				blank_choice: variable.blankChoice.value,
				appearance: variable.appearance.get() ? 'full' : 'default',
				choiceAppearance: variable.choiceAppearance.get(),
				alphabetize: variable.alphabetize.get(),
				rows: variable.rows.get(),
				cols: variable.cols.get(),
				type: variable.type.get(),
				validation: variable.validation.get(),
				initialValue: variable.initialValue.value,
				restore_default: variable.restore_default.get(),
				required: !variable.optional.value,
				choices: $.map(variable.choices.value, function (value) {
					return $.extend({}, {
						label: value.text.value,
						score: value.score.value
					});
				})
			});

			if (variable.choices.extraction.question.get()) {
				serialized.extraction = variable.choices.extraction.serialize();
			}

			if (variable.type.get() === 'string') {
				serialized.guideStarMapping = variable.guideStarMapping.value;
			}

			info.children.push(serialized);
		});

		return info;
	}
});

_baseField2.default.ThreeDGridField = $.klass(_baseField2.default.Natrix, {
	type: 'threed-grid',
	qlass: 'threed-grid',
	cssType: 'threed-grid',

	displayName: gettext('Multi-column Grid'),
	helpText: gettext('Multiple answers per row (Dropdown, Text Response, Checkbox, or Radio Buttons)'),
	isEnabled: true,
	isCustom: true,

	isGrouped: true,
	extractable: true,
	choiceAppearanceTypes: ['vertical', 'horizontal', 'column', 'star', 'combo'],
	isDynamic: true,

	isScorable: true,

	getVarContainer: function getVarContainer(index) {
		return index === undefined ? $('table.variables tr th, table.variables tr td', this.element).filter(':not(.column)') : $('table.variables tr th, table.variables tr td', this.element).filter('.column-' + index);
	},
	getVarLabels: function getVarLabels(index) {
		return this.getVarContainer(index).filter('th').find('.variable');
	},
	getVarFields: function getVarFields(index) {
		return this.getVarContainer(index).filter('td');
	},

	options: $.extend({}, _baseField2.default.TextField.prototype.options, _baseField2.default.GridField.prototype.options, _baseField2.default.Natrix.prototype.options, {
		rowList: Class.create(_baseField2.default.GridField.prototype.options.variableList, {
			itemAdded: function itemAdded(item) {
				this.field.rowAdded(item);
			},
			itemChanged: function itemChanged(index, value) {
				this.field.rowChanged(index, value);
			},
			itemRemoved: function itemRemoved(index) {
				this.field.rowRemoved(index);
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		var variableExtraction = info.extraction;
		var rows = [];
		var columns = [];

		if (info.children) {
			$.each(info.children, function (i, variable) {
				if (variable.row == 0) {
					var _columns$push;

					columns.push((_columns$push = {
						label: variable.colname,
						type: variable.type,
						validation: variable.validation,
						appearance: variable.appearance,
						choiceAppearance: variable.choiceAppearance,
						alphabetize: variable.alphabetize,
						randomize: variable.randomize,
						sum: variable.sum,
						sumLabel: variable.sumLabel,
						rows: variable.rows || 5,
						initialValue: variable.initialValue || '',
						restore_default: variable.restore_default || false,
						cols: variable.cols || 20,
						extraction: variable.extraction,
						blank_choice: variable.blank_choice
					}, _defineProperty(_columns$push, 'extraction', variable.extraction), _defineProperty(_columns$push, 'choices', variable.choices || that.getDefaultChoices()), _defineProperty(_columns$push, 'dynamics', variable.dynamics), _columns$push));
				}
				if (variable.column == 0) {
					rows.push({
						label: variable.label,
						required: variable.required
					});
				}
			});
		} else {
			rows = [{
				label: gettext('Row 1'),
				required: false
			}, {
				label: gettext('Row 2'),
				required: false
			}];
			columns = [{
				label: gettext('Column 1'),
				type: 'dropdown',
				choices: this.getDefaultChoices()
			}, {
				label: gettext('Column 2'),
				type: 'string',
				choices: this.getDefaultChoices()
			}];
		}

		//for compatibility with version 2.0
		if (info.radioCustom) {
			$.each(columns, function (i, column) {
				if (column.type == 'single' || column.type == 'dropdown') {
					column.type = 'single';
					column.appearance = 'single';
					column.choiceAppearance = 'column';
				}
			});
		}

		this.unique = new this.options.unique({ value: !!info.unique });

		this.uniqueError = new chide.opts.Text({
			displayInline: false,
			labelClass: '',
			label: gettext('Error Message for Unique Responses.'),
			value: info && info.uniqueError || gettext('Responses must be unique.'),
			help: gettext('Unique Responses - The label that will show beneath the question informing the user of the restraint.')
		});

		this.staticcol = new this.options.staticcol({ value: !!info.staticcol });

		this.notUsed = new chide.opts.Checkbox({
			help: gettext("Not Used - Show an additional column that will uncheck all other columns for this row."),
			label: gettext('Show Not Used Column'),
			value: info.showNotUsed || false,
			changed: function changed(value) {
				$('.na', that.element).css('display', '')[value ? 'fadeIn' : 'fadeOut']().css('display', '');
			}
		});

		this.sumLabel = new chide.opts.Text({
			displayInline: true,
			inputClass: 'text inline medium',
			labelClass: 'inline',
			label: gettext('Sum Label'),
			value: info.sumLabel || gettext('Total'),
			help: gettext('Sum Label - The label that will show in the total row. This will only appear if you have one or more text columns with sum restrictions.'),
			changed: function changed(value) {
				that.renderContent();
			}
		});

		this.showBorders = new chide.opts.Checkbox({
			help: gettext("Show Borders - Show borders separating the rows and columns of this question (Makes complex 3D matrices easier to understand)"),
			label: gettext('Show Borders'),
			value: info.showBorders !== false
		});

		this.alternateBackground = new chide.opts.Checkbox({
			help: gettext("Alternate Background Colors - Each column in the matrix will have an alternating background color making it stand out from the previous column and easier to understand."),
			label: gettext('Alternate Background Colors'),
			value: info.alternateBackground !== false
		});

		this.notUsedText = new chide.opts.Text({
			label: gettext('Text for "Not Used" column'),
			labelClass: '',
			value: info.notUsedText || gettext('Not Used'),
			changed: function changed(value) {
				$('.na-text', that.element).text(value);
			}
		});

		this.topLeftText = new chide.opts.Text({
			displayInline: true,
			inputClass: 'text inline medium',
			label: gettext('Top Left Label'),
			labelClass: 'inline',
			value: info.topLeftText || "",
			changed: function changed(value) {
				$('.top-left-text', that.element).text(value);
			}
		});

		this.randomize = new _baseField2.default.GridField.prototype.options.randomize({ field: this, value: !!info.randomize });

		this.alphabetize = new _baseField2.default.GridField.prototype.options.alphabetize({ field: this, value: !!info.alphabetize });

		this.rows = new this.options.rowList({
			field: this,
			value: rows,
			extraction: variableExtraction
		});

		this.columns = this.variables = new this.options.variableList({
			field: this,
			value: columns,
			enableExtraction: false
		});

		this.columns_panel = new Option.Collapsable({ label: gettext('Columns') });
		this.choices_panel = new Option.Collapsable({ label: gettext('Choices') });
		this.rows_panel = new Option.Collapsable({ label: gettext('Rows') });

		this.options_panel = new Option.Collapsable({ collapsed: true, label: gettext('Options') });
		this.display_panel = new Option.Collapsable({ label: gettext('Display'), collapsed: true });
	},

	getTypes: function getTypes() {
		var that = this;

		return $.map(this.variables.value, function (el, i) {
			return {
				type: el.type.get(),
				index: i,
				id: that.id + '[:' + i + ']',
				text: el.text.get(),
				label: that.name.get() ? '{ ' + that.name.get() + '[:' + i + '] } ' + el.text.get() : el.text.get(),
				choices: el.choices ? $.map(el.choices.value, function (el) {
					return el.text.get();
				}) : undefined
			};
		});
	},

	getRows: function getRows() {
		var that = this;

		var typeLength = this.variables.value.length;

		return $.map(this.rows.value, function (el, i) {
			var items = [];
			for (var j = 0; j < that.columns.value.length; j++) {
				items.push(that.id + '_' + (typeLength * i + j));
			}

			return {
				index: i,
				id: that.id + '[' + i + ':]',
				text: el.text.get(),
				items: items,
				label: that.name.get() ? '{ ' + that.name.get() + '[' + i + ':] } ' + el.text.get() : el.text.get()
			};
		});
	},

	getVariables: function getVariables() {
		var that = this;
		var variables = [];

		$.each(that.getRows(), function (i, rowInfo) {
			$.each(that.getTypes(), function (j, typeInfo) {
				var labelPrefix = that.name.get() ? '{ ' + that.name.get() + '[' + rowInfo.index + ':' + typeInfo.index + '] } ' : '';
				variables.push(new Variable[{
					string: 'String',
					checkbox: 'Boolean',
					single: 'Single',
					dropdown: 'Single'
				}[typeInfo.type]]($.extend({}, {
					id: that.id + '_' + variables.length,
					label: labelPrefix + rowInfo.text + ' | ' + typeInfo.text,
					choices: typeInfo.choices
				})));
			});
		});

		return variables;
	},

	formatInfo: function formatInfo($super) {
		return $.extend($super(), {
			types: this.getTypes(),
			rows: this.getRows()
		});
	},

	renderContent: function renderContent() {
		var that = this;
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<table class="variables"></table>');

		var firstRow = $('<tr>').addClass('header').appendTo($('<thead>').appendTo(table));

		$('<th>', { rowspan: 2 }).addClass('top-left-text').html(this.topLeftText.get()).width(this.firstColSize.get() + '%').appendTo(firstRow);

		$('<th>', { rowspan: 2 }).addClass('na').addClass('na-text').appendTo(firstRow).html(this.notUsedText.get()).css('display', this.notUsed.get() ? '' : 'none');
		var choiceHeaders = $('<tr>', { 'class': 'choiceHeader' }).insertAfter(firstRow);

		var tbody = $('<tbody>').appendTo(table);

		$.each(this.rows.value, function (i) {
			var row = $('<tr>').append($('<th>').html(that.rows.getAt(i))).appendTo(tbody);

			$('<td>', { 'class': 'na' }).append('<input type="checkbox">').css('display', that.notUsed.get() ? 'block' : 'none').appendTo(row);
		});
		if (old) {
			old.remove();
		}
		var totalRow = false;
		_.each(this.variables.value, function (el) {
			if (el.sum.value !== '' && el.sum.value !== undefined) {
				totalRow = true;
			}
		});

		if (totalRow) {
			var row = $('<tr>', { 'class': 'total-row' }).append($('<th>').html(that.sumLabel.get())).appendTo($('<tfoot>').appendTo(table));
			if (!that.sumLabel.get()) {
				row.css('display', 'none');
			}
			$('<td>', { 'class': 'na' }).css('display', that.notUsed.get() ? 'block' : 'none').appendTo(row);
		}
		table.appendTo(this.element);

		_.each(this.variables.value, function (el, i) {
			that.buildVariable(i, el.type.get());
		});
	},

	buildVariable: function buildVariable(index, type) {
		var variable = this.variables.value[index];
		var input = this.getInput(variable, index);
		this.getVarContainer(index).remove();
		$('.variables tr', this.element).each(function (i) {
			if ($(this).hasClass('header')) {
				$('<th>', { 'class': 'column-' + index }).append($('<span>', { 'class': 'variable', html: variable.text.get() })).attr('colspan', Math.max(type == 'single' && variable.choiceAppearance.get() == 'column' ? variable.choices.value.length : 1, 1)).insertAfter($(index === 0 ? '.na:last' : '.column-' + (index - 1) + ':last', this));
			} else if ($(this).hasClass('total-row')) {
				$('<td>', { 'class': 'column-' + index }).append($('<span>', { text: type == 'string' && variable.sum.get() ? '---' : '' })).attr('colspan', Math.max(type == 'single' && variable.choiceAppearance.get() == 'column' ? variable.choices.value.length : 1, 1)).insertAfter($(index === 0 ? '.na:last' : '.column-' + (index - 1) + ':last', this));
			} else if ($(this).hasClass('choiceHeader')) {
				var choiceHeaders = $('<tr>');
				if (type == 'single' && variable.choiceAppearance.get() == 'column' && variable.choices.value.length) {
					_.each(variable.choices.value, function (el, j) {
						choiceHeaders.append($('<th>', { 'class': 'choice column-' + index }).append($('<span>', { 'class': ' label', html: variable.choices.getAt(j) })));
					});
				} else {
					choiceHeaders.append($('<th>', { 'class': 'column-' + index }));
				}
				if (index === 0) {
					choiceHeaders.contents().prependTo($(this));
				} else {
					choiceHeaders.contents().insertAfter($(this).find('.column-' + (index - 1) + ':last'));
				}
			} else {
				if (input.is('td,th')) {
					input.clone().insertAfter($(index === 0 ? '.na:last' : '.column-' + (index - 1) + ':last', this));
				} else {
					$('<td>', { 'class': 'column-' + index }).append(input.clone()).insertAfter($(index === 0 ? '.na:last' : '.column-' + (index - 1) + ':last', this));
				}
			}
		});
	},

	rowAdded: function rowAdded(value) {
		if (this.rows.value.length > 1) {
			$('.variables tbody tr', this.element).last().clone().find('th:first').html(value.text.get()).end().appendTo($('.variables tbody', this.element));
		} else {
			this.renderContent();
		}
	},

	rowRemoved: function rowRemoved(index) {
		$('.variables tbody tr', this.element).eq(index).remove();
	},

	rowChanged: function rowChanged(index, value) {
		$('.variables tbody tr', this.element).eq(index).find('th:first').html(value.text.get());
	},

	choiceAdded: function choiceAdded($super, index, value) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);
		if ($super(index, value)) {
			return;
		}

		if (variable.type.get() == 'single' && variable.choiceAppearance.get() == 'column') {
			$('.variables tr', this.element).find('.choice.column-' + index + ':last').each(function () {
				$(this).clone().insertAfter(this).find('.label').html(value ? value.text.get() : '').end().find('input, option').val(variable.choices.value.length - 1);
			});
			$('.variables tr.header .column-' + index, this.element).attr('colspan', variable.choices.value.length);
		}
	},

	choiceChanged: function choiceChanged($super, index, choice, label) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);

		if (variable.type.get() == 'single' && variable.choiceAppearance.get() == 'column') {
			this.getVarContainer(index).filter('.choice').find('.label').eq(choice).html(label.text.get());
		} else {
			$super(index, choice, label);
		}
	},

	choiceRemoved: function choiceRemoved($super, index, choice) {
		var variable = this.variables.value[index];
		$(variable).trigger('choiceChanged', [variable.choices.value]);
		$super(index, index);

		if (variable.type.get() == 'single' && variable.choiceAppearance.get() == 'column') {
			var choiceEl = $('.variables tr', this.element).find('.choice.column-' + index + ':eq(' + choice + ')');
			if (variable.choices.value.length === 0) {
				choiceEl.empty();
			} else {
				choiceEl.remove();
			}
			$('.variables tr.header .column-' + index, this.element).attr('colspan', Math.max(variable.choices.value.length, 1));
		}
	},

	variableAdded: function variableAdded(value) {
		this.variableMorphed(this.variables.value.length - 1, value.type.get());
	},

	variableRemoved: function variableRemoved(index) {
		this.getVarContainer(index).remove();
		for (var i = index; i < this.variables.value.length; i++) {
			this.getVarContainer(i + 1).removeClass('column-' + (i + 1)).addClass('column-' + i);
		}
	},

	variableChanged: function variableChanged(index, value) {
		this.getVarLabels(index).html(value.text.get());
	},

	variablesCleared: function variablesCleared() {
		this.getVarContainer().remove();
	},

	variableMorphed: function variableMorphed($super, index, newType, update) {
		this.buildVariable(index, newType);
		if (update !== false) {
			$(this.variables.value[index]).trigger('variableMorphed', [newType]);
		}
	},

	getVariableSubOptions: function getVariableSubOptions($super, value, child) {
		var that = this;
		var base = $super(value, child);
		delete base['optional'];
		base.validation.displayInline = true;

		var Dynamics = __webpack_require__(406).Dynamics;

		return $.extend({}, base, {
			dynamics: new Dynamics({
				survey: this.editor.survey,
				value: value && value.dynamics ? value.dynamics : undefined,
				field: this
			})
		});
	},

	choiceAppearanceChanged: function choiceAppearanceChanged(index, value, old) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},

	appearanceChanged: function appearanceChanged(index, value) {
		return this.variableMorphed(index, this.variables.value[index].type.get());
	},

	sumChanged: function sumChanged(index, value) {
		return this.renderContent();
	},

	blankChoiceChanged: function blankChoiceChanged(index, value) {
		this.getVarFields(index).find('select option.dummy').text(value);
		return this.renderContent();
	},

	showOptions: function showOptions($super, options) {
		_baseField2.default.Field.prototype.showOptions.call(this, options);

		options.append(this.columns_panel.render([this.columns.render()])).append(this.rows_panel.render([this.rows.render()])).append(this.display_panel.render([this.staticcol.render(), this.firstColSize.render(), this.topLeftText.render(), this.sumLabel.render(), this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render(), this.showBorders.render(), this.alternateBackground.render()])).append(this.options_panel.render([this.notUsed.render(), this.notUsedText.render(), this.randomize.render(), this.alphabetize.render(), this.unique.render(), this.uniqueError.render()]));
	},

	getExtractionChoices: function getExtractionChoices() {
		var that = this;

		if (this.rows.extraction.question.get()) {
			return this.rows.extraction.question.getField().getExtractionChoices();
		}

		return $.map(this.rows.value, function (val, i) {
			return [[i, val.text.value]];
		});
	},

	getExtractionOptions: function getExtractionOptions(config) {
		var that = this;
		this.config = config;
		var columns;
		var choicesSelect;

		var updateChoices = function updateChoices(values, choices) {
			choicesSelect = new ($.klass(Option.Multiple, {
				render: function render($super) {
					return $super().prepend(this.label);
				}
			}))(this, {
				label: gettext('Choices which should trigger extraction:'),
				help: gettext('Trigger Choices - Choices which should trigger row variable extraction.'),
				value: values,
				choices: choices
			});
			that.column_select.choicesSelect = choicesSelect;
			return choicesSelect.render();
		},
		    columns = $.map(this.columns.value, function (val, i) {
			return [[i, val.text.get()]];
		});
		if (config && config.column) {
			if (that.variables.value[config.column].type.value == 'dropdown' || that.variables.value[config.column].type.value == 'single') {
				this.choices = $.map(this.variables.value[config.column].choices.value, function (val, i) {
					return [[i, val.text.get()]];
				});
			} else {
				this.choices = [];
			}
		} else if (that.variables.value[0].type.value == 'dropdown' || that.variables.value[0].type.value == 'single') {
			this.choices = $.map(this.variables.value[0].choices.value, function (val, i) {
				return [[i, val.text.get()]];
			});
		} else {
			this.choices = [];
		}
		this.column_select = new (Class.create(chide.opts.Single, {
			render: function render($super) {
				var rendered = $super();
				if (that.choices.length > 0) {
					if (config && config.choices) {
						this.columnOptions = $('<div/>').append(updateChoices(config.choices, that.choices)).appendTo(rendered);
					} else {
						this.columnOptions = $('<div/>').append(updateChoices([], that.choices)).appendTo(rendered);
					}
				} else {
					this.columnOptions = $('<div/>').appendTo(rendered);
				}
				return rendered;
			}
		}))({
			showLabel: true,
			label: gettext('Column which should trigger extraction:'),
			help: gettext('Column Trigger - Only a single column can be used to trigger extraction.'),
			value: config ? config.column : 0,
			choices: columns,
			changed: function changed(value) {
				if (that.variables.value[value].type.value == 'dropdown' || that.variables.value[value].type.value == 'single') {
					that.choices = $.map(that.variables.value[value].choices.value, function (val, i) {
						return [[i, val.text.get()]];
					});
					this.columnOptions.empty();
					this.columnOptions.append(updateChoices([], that.choices));
				} else {
					that.choices = [];
					this.columnOptions.empty();
					that.choicesSelect = undefined;
				}
			}
		});

		this.unique_select = new chide.opts.Checkbox({
			showLabel: true,
			label: gettext('Only extract unique responses'),
			value: config ? config.unique : 0
		});

		return new Option.Group(this, {
			options: [this.column_select, this.unique_select]
		});
	},

	serializeExtractionOptions: function serializeExtractionOptions(group) {
		if (group.options[0].choicesSelect) {
			choices = $.map(group.options[0].choicesSelect.value, function (val, i) {
				return [val];
			});
		} else {
			choices = [];
		}

		return {
			column: group.options[0].get(),
			choices: choices,
			unique: group.options[1].get()
		};
	},

	serialize: function serialize() {
		// TODO: file upload field
		var that = this;
		var info = _baseField2.default.Field.prototype.serialize.call(this);

		info.grouped = info.custom = info.hascolumn = true;
		$.extend(info, {
			showNotUsed: this.notUsed.get(),
			showBorders: this.showBorders.get(),
			alternateBackground: this.alternateBackground.get(),
			notUsedText: this.notUsedText.value,
			topLeftText: this.topLeftText.value,
			sumLabel: this.sumLabel.value,
			randomize: this.randomize.get() || false,
			alphabetize: this.alphabetize.get() || false,
			questionSize: this.firstColSize.get(),
			staticcol: this.staticcol.get(),
			unique: this.unique.get(),
			uniqueError: this.uniqueError.get() || gettext('Responses must be unique'),
			children: [],
			extraction: this.rows.extraction && this.rows.extraction.serialize()
		});

		$.each(this.rows.value, function (i, row) {
			$.each(that.columns.value, function (j, column) {
				var type = column.type.get();
				var choices = undefined;

				if (type === 'dropdown' || type === 'single') {
					choices = [];
					for (var k = 0; k < column.choices.length(); k++) {
						choices.push($.extend({}, {
							label: column.choices.value[k].text.value,
							score: column.choices.value[k].score.value
						}));
					}
				}
				var serialized = $.extend({}, {
					label: row.text.value,
					row: i,
					column: j,
					colname: column.text.value,
					blank_choice: column.blankChoice.value,
					appearance: column.appearance.get() ? 'full' : 'default',
					choiceAppearance: column.choiceAppearance.get(),
					alphabetize: column.alphabetize.get(),
					randomize: column.randomize.get(),
					type: column.type.get(),
					validation: column.validation.get(),
					rows: column.rows.get(),
					cols: column.cols.get(),
					sum: column.sum.get(),
					sumLabel: column.sumLabel.value,
					initialValue: column.initialValue.value,
					restore_default: column.restore_default.get(),
					required: !row.optional.value,
					dynamics: column.dynamics.serializeForVariable(column),
					choices: choices
				});

				if (column.choices.extraction.question.get()) {
					serialized.extraction = column.choices.extraction.serialize();
				}

				info.children.push(serialized);
			});
		});

		return info;
	}
});

_baseField2.default.DrillDownField = $.klass(_baseField2.default.Field, {
	type: 'drill-down',
	qlass: 'drill-down',
	cssType: 'drill-down',

	displayName: gettext('Drill Down'),
	helpText: gettext('Category based choice selection'),
	isEnabled: true,
	isBranchable: true,
	hasChoiceBranching: false,

	isGrouped: true,
	isCustom: true,
	defaultFlipOrder: false,
	defaultLeftLabel: gettext('Left Label'),
	defaultRightLabel: gettext('Right Label'),
	appearanceChoices: [['default', gettext('Default')], ['dropdown', gettext('Dropdown')], ['likert', gettext('Likert')]],

	isScorable: true,

	getDefaultCategories: function getDefaultCategories() {
		return [{
			label: gettext('Category 1'),
			required: false,
			choices: [{ label: gettext('Choice 1') }, { label: gettext('Choice 2') }]
		}, {
			label: gettext('Category 2'),
			required: false,
			choices: [{ label: gettext('Choice 1') }, { label: gettext('Choice 2') }]
		}];
	},
	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		categoryList: Class.create(chide.opts.TextList, {
			hasSubOptions: true,
			label: gettext('Categories'),
			enableExtraction: false,

			choices: Class.create(_baseField2.default.ChoiceField.prototype.options.choiceList, {
				itemFromValue: function itemFromValue($super, value) {
					return $super(value && value.label ? value : { label: value });
				},

				// lazy
				itemAdded: function itemAdded(item) {
					this.field.choiceAdded(item);
				},
				itemChanged: function itemChanged(index, value) {
					this.field.choiceChanged(index, value);
				},
				itemRemoved: function itemRemoved(index) {
					this.field.choiceRemoved(index);
				},
				itemsChanged: function itemsChanged(value) {
					this.field.choicesChanged(value);
				}
			}),

			itemFromValue: function itemFromValue($super, value) {
				var item = $super(value);

				return $.extend(item, {
					choices: new this.choices({ tabOffset: Math.floor(Math.random() * 60000 + 1), field: this.field, value: value ? value.choices : this.field.getDefaultChoices() })
				});
			},

			renderSubOptions: function renderSubOptions($super, item, index) {
				return $super(item, index).append(item.choices.render());
			},

			itemAdded: function itemAdded(item) {
				this.field.variableAdded(item);
			},
			itemChanged: function itemChanged(index, value) {
				this.field.variableChanged(index, value);
			},
			itemRemoved: function itemRemoved(index) {
				this.field.variableRemoved(index);
			},
			itemsChanged: function itemsChanged(value) {
				this.field.renderContent();
			}
		}),
		appearance: Class.create(chide.opts.Single, {
			label: gettext('Appearance:'),
			help: gettext('About Appearance - This will determine how the choices and categories to this question will be displayed.'),
			changed: function changed(value) {
				this.field.likert_options.rendered.toggleClass('collapsed', value == 'likert').children().toggle(value == 'likert');
				this.field.choicefield_options.rendered.toggleClass('collapsed', value != 'likert').children().toggle(value != 'likert');
				this.field.dropdown_options.rendered.toggleClass('collapsed', value == 'dropdown').children().toggle(value == 'dropdown');
				this.field.renderContent();
			},
			initialize: function initialize($super, config) {
				this.choices = config.field.appearanceChoices;
				$super(config);
			}
		}),
		likertLabel: Class.create(chide.opts.Text, {
			inputClass: 'text short',
			changed: function changed() {
				this.field.renderContent();
			}
		}),
		alphabetize: _baseField2.default.ChoiceField.prototype.options.alphabetize,
		randomize: _baseField2.default.ChoiceField.prototype.options.randomize,
		blankChoice: _baseField2.default.DropDownChoiceField.prototype.options.blankChoice
	}),
	buildChoices: function buildChoices() {
		this.choices.value = $.map(this.categories.value, function (el) {
			return el.choices.value;
		});
	},
	initialize: function initialize($super, info, editor) {
		var that = this;
		info = info || {};
		$super(info, editor);

		var categories, display;
		var hasChild = info.children && info.children[0];
		if (info.children && info.children[0] && info.children[0].categories) {
			categories = info.children[0].categories;
		} else {
			categories = this.getDefaultCategories();
		}

		this.categories = new this.options.categoryList({ field: this, value: categories });
		this.choices = {
			getAt: function getAt(i) {
				return this.value[i].text.get();
			},
			setAt: function setAt(i, val) {
				return this.value[i].text.set(val);
			}
		};
		this.buildChoices();

		// convert old branching
		if (this.hasChoiceBranching) {
			var branching = info.children && info.children.length && info.children[0].branch ? info.children[0].branch : undefined;
			if (branching) {
				for (var i = 0; i < branching.length; i++) {
					var j = branching[i].val;
					if (j >= 0 && j < this.choices.value.length) {
						this.choices.value[j].branching = new Branching.Simple.Rule({ field: this, value: branching[i].page ? branching[i].page : undefined });
					}
				}
			}
		}

		var get_appearance = function get_appearance(value) {
			var choices = $.map(that.appearanceChoices, function (el, i) {
				return el[0];
			});
			if (value && _(choices).contains(value)) return value;else return choices[0];
		};

		this.appearance = new this.options.appearance({ field: this, value: get_appearance(hasChild && info.children[0].display) });

		this.leftLabel = new this.options.likertLabel({ field: this, label: 'Left Label', value: hasChild && info.children[0].leftLabel ? info.children[0].leftLabel : this.defaultLeftLabel });
		this.rightLabel = new this.options.likertLabel({ field: this, label: 'Right Label', value: hasChild && info.children[0].rightLabel ? info.children[0].rightLabel : this.defaultRightLabel });
		this.showCatLabels = new chide.opts.Checkbox({ field: this,
			label: gettext('Show Category Labels'),
			value: hasChild && info.children[0].showCatLabels != undefined ? info.children[0].showCatLabels : true,
			changed: function changed(value) {
				$('tr.category-labels', this.field.rendered).toggle(value);
			}
		});
		this.flipOrder = new chide.opts.Checkbox({ field: this,
			label: gettext('Flip choice order'),
			value: hasChild && info.children[0].flipOrder != undefined ? info.children[0].flipOrder : this.defaultFlipOrder,
			changed: function changed(value) {
				this.field.renderContent();
			}
		});
		this.likert_options = Option.renderGroup('', [this.flipOrder, this.showCatLabels, this.leftLabel, this.rightLabel], this.appearance.value != 'likert', true);

		this.randomize = new this.options.randomize({ field: this, value: hasChild && !!info.children[0].randomize });

		this.alphabetize = new this.options.alphabetize({ field: this, value: hasChild && !!info.children[0].alphabetize });

		this.blankChoice = new this.options.blankChoice({ field: this, value: hasChild && info.children[0] && info.children[0].blank_choice || info.blankChoice || undefined });

		this.choicefield_options = Option.renderGroup('', [this.randomize, this.alphabetize], this.appearance.value == 'likert', true);

		this.dropdown_options = Option.renderGroup('', [this.blankChoice], this.appearance.value != 'dropdown', true);

		this.optional = new this.options.optional({ info: info, changed: function changed(value) {
				that.render();
			} });

		this.options_panel = new Option.Collapsable({
			collapsed: true,
			label: gettext('Options')
		});

		this.categories_panel = new Option.Collapsable({
			label: gettext('Categories')
		});

		this.display_panel = new Option.Collapsable({
			label: gettext('Display'),
			collapsed: true
		});
	},

	getDefaultChoices: function getDefaultChoices() {
		return [{ label: gettext('Choice 1') }, { label: gettext('Choice 2') }];
	},

	renderContent: function renderContent() {
		var that = this;
		var old = this.rendered;

		var rendered = this.rendered = $('<div/>', { 'class': 'variables drilldown' });

		var maxScore = 0;
		var numNone = 0;

		for (var i = 0; i < this.choices.value.length; i++) {
			if (this.choices.value[i].score.value !== undefined && this.choices.value[i].score.value != '' && this.choices.value[i].score.value > maxScore) {
				maxScore = this.choices.value[i].score.value;
			} else {
				numNone++;
			}
		}

		if (numNone == this.choices.value.length) {
			for (var i = 0; i < this.categories.value.length; i++) {
				if (this.categories.value[i].choices.value.length > maxScore) {
					maxScore = this.categories.value[i].choices.value.length;
				}
			}
		}

		this.rendered.append($('<div>', { text: gettext('(Score out of ') + maxScore + ')', 'class': 'sma-score-value' }));

		if (this.appearance.value == 'default') {
			var first = $('<select/>', { 'class': 'drill-down-selector', change: function change() {
					that.refresh();
				} }).attr('size', 5).appendTo(rendered);

			$('<select/>', { 'class': 'drill-down-selector' }).attr('size', 5).appendTo(rendered);

			$.each(this.categories.value, function (i, category) {
				$('<option/>', { html: category.text.get() }).appendTo(first);
			});
		} else if (this.appearance.value == 'dropdown') {
			var select = this.choiceDisplay = $('<select/>', { 'class': 'choices custom-select' }).appendTo(rendered);
			$('<option/>', { html: this.blankChoice.get() }).appendTo(select);
			$.each(this.categories.value, function (i, category) {
				var optgroup = $('<optgroup/>', { label: category.text.get() }).appendTo(select);
				$.each(category.choices.value, function (j, choice) {
					$('<option/>', { html: choice.text.get() }).appendTo(optgroup);
				});
			});
		} else if (this.appearance.value == "likert") {
			var table = $('<table class="variables"></table>').appendTo(rendered);

			var head = $('<thead><tr class="category-labels"><td class="left-side"></td><td class="right-side"></td></tr><tr class="choice-labels"><td class="left-side"></td><td class="right-side"></td></tr></thead>').appendTo(table);

			var body = $('<tbody><tr class="choices"></tr><\/tbody>').appendTo(table);
			$('<td class="left-side"></td>').append($('<span>', {
				'class': 'variable',
				'html': this.leftLabel.get()
			})).appendTo($('tr', body));
			$('<td class="right-side"></td>').append($('<span>', {
				'class': 'rlabel',
				'html': this.rightLabel.get()
			})).appendTo($('tr', body));
			$.each(this.categories.value, function (i, category) {
				that.variableAdded(category);
			});

			if (!this.showCatLabels.value) {
				$('tr.category-labels', head).hide();
			}
		}
		if (old) {
			old.remove();
		}
		rendered.appendTo(this.element);
	},

	refresh: function refresh() {
		var index = $('select:first option', this.rendered).index($('select:first option:selected', this.rendered));

		if (index >= 0) {
			var choiceSelector = $('select:last', this.rendered).empty();

			$.each(this.categories.value[index].choices.value, function (i, choice) {
				$('<option/>', { html: choice.text.get() }).appendTo(choiceSelector);
			});
		}
	},
	choiceAdded: function choiceAdded(value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choiceChanged: function choiceChanged(index, value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choiceRemoved: function choiceRemoved(index) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	choicesChanged: function choicesChanged(value) {
		if (this.appearance.value == 'default') {
			this.refresh();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	variableAdded: function variableAdded(value) {
		var that = this;
		if (this.appearance.value == 'default') {
			$('select:first', this.rendered).append($('<option/>', {
				html: value.text.get()
			}));
		} else if (this.appearance.value == "likert") {
			var action = !!this.flipOrder.value ? 'prependTo' : 'appendTo';
			var vals = $.map(value.choices.value, function (el) {
				return el;
			});
			$('<td></td>', { 'colspan': vals.length }).append($('<span>', { 'class': 'category', 'html': value.text.get() }))[action]($('tr.category-labels', this.rendered));
			$.each(vals, function (i, choice) {
				$('<td></td>').append($('<span>', { 'class': 'choice', 'html': choice.text.get() }))[action]($('tr.choice-labels', that.rendered));
				$('<td></td>').append($('<input>', { 'type': 'radio', 'name': that.id }))[action]($('tr.choices', that.rendered));
			});
			$('td.right-side', this.rendered).each(function () {
				$(this)[!that.flipOrder.value ? 'appendTo' : 'prependTo']($(this).parent());
			});
			$('td.left-side', this.rendered).each(function () {
				$(this)[!that.flipOrder.value ? 'prependTo' : 'appendTo']($(this).parent());
			});
		}
		this.buildChoices();
	},
	variableRemoved: function variableRemoved(index) {
		if (this.appearance.value == 'default') {
			$('select:first option', this.rendered).eq(index).remove();
		} else if (this.appearance.value == "likert") {
			this.renderContent();
		}
		this.buildChoices();
	},
	variableChanged: function variableChanged(index, value) {
		if (this.appearance.value == 'default') {
			$('select:first option', this.rendered).eq(index).html(this.categories.getAt(index));
		} else if (this.appearance.value == "likert") {
			$('tr.category-labels span.category', this.rendered).eq(!!this.flipOrder.value ? this.categories.value.length - index - 1 : index).html(this.categories.getAt(index));
		}
		this.buildChoices();
	},

	showOptions: function showOptions($super, options) {
		$super(options);
		var that = this;

		options.append(this.categories_panel.render([this.categories.render()])).append(this.display_panel.render([this.appearance.render(), this.likert_options, this.choicefield_options, this.dropdown_options, this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()])).append(this.options_panel.render([this.optional.render()]));
	},

	getVariables: function getVariables() {
		return [new Variable.Single({ id: this.id, label: this.getIdentifier(), choices: $.map(this.choices.value, function (el) {
				return el.text.get();
			}) })];
	},

	serialize: function serialize() {
		var that = this;
		var info = _baseField2.default.Field.prototype.serialize.call(this);
		var categories = [];

		info.children = [];
		info.grouped = true;
		info.type = 'question';
		var choiceIndex = 0;
		var branch = [];
		$.each(this.categories.value, function (i, category) {
			var choices = [];

			$.each(category.choices.value, function (j, choice) {
				var el = category.choices.value[j];

				choices.push($.extend({}, {
					label: choice.text.value,
					score: choice.score.value
				}));

				if (that.hasChoiceBranching) {
					var page = el.branching.getPage();
					if (page !== undefined) {
						branch.push({ val: choiceIndex, page: page });
					}
				}
				choiceIndex++;
			});

			categories.push({
				label: category.text.value,
				choices: choices
			});
		});
		var question_info = {
			type: 'drill-down',
			categories: categories,
			required: !this.optional.value,
			display: this.appearance.value
		};
		if (branch.length) {
			$.extend(question_info, { branch: branch });
		}

		if (this.appearance.value == 'likert') {
			$.extend(question_info, {
				display: this.appearance.value,
				flipOrder: this.flipOrder.value,
				showCatLabels: this.showCatLabels.value,
				leftLabel: this.leftLabel.value,
				rightLabel: this.rightLabel.value
			});
		} else {
			$.extend(question_info, {
				alphabetize: this.alphabetize.value,
				randomize: this.randomize.value
			});
			if (this.appearance.value == 'dropdown') {
				$.extend(question_info, {
					blank_choice: this.blankChoice.get() && this.blankChoice.value
				});
			}
		}
		info.children.push(question_info);

		return info;
	}
});

_baseField2.default.RankingField = $.klass(_baseField2.default.SingleChoiceGridField, {
	type: 'ranking',
	qlass: 'ranking',
	cssType: 'ranking',
	isEnabled: true,
	isQuestion: false,
	displayName: gettext('Ranking Question'),
	helpText: gettext('Rank variables by dragging variables and dropping to choices'),
	isBranchable: false,
	initialize: function initialize($super, info, editor) {
		$super(info, editor);
		this.optional = new this.options.optional({ info: info, changed: function changed(value) {
				that.render();
			} });
	},
	choiceAdded: function choiceAdded(value) {
		$('.choices', this.tableDisplay).append('<div class="choice">' + value.text.get() + '</div>');
	},
	choiceChanged: function choiceChanged(index, value) {
		$('div.choice', this.tableDisplay).eq(index).html(value.text.get());
	},

	choiceRemoved: function choiceRemoved(index) {
		$('div.choice', this.tableDisplay).eq(index).remove();
	},
	variableAdded: function variableAdded(value) {
		$('.variables', this.tableDisplay).append('<div class="variable">' + value.text.get() + '</div>');
	},
	variableChanged: function variableChanged(index, value) {
		$('div.variable', this.tableDisplay).eq(index).html(value.text.get());
	},

	variableRemoved: function variableRemoved(index) {
		$('div.variable', this.tableDisplay).eq(index).remove();
	},

	renderContent: function renderContent() {
		var that = this;
		var old = this.tableDisplay;
		var table = this.tableDisplay = $('<div class="var-and-choice"></div>');
		table.append('<div class="variables"><\/div>');
		table.append('<div class="choices"><\/div>');
		for (var j = 0; j < this.choices.length(); j++) {
			this.choiceAdded(this.choices.value[j]);
		}

		for (var j = 0; j < this.variables.length(); j++) {
			this.variableAdded(this.variables.value[j]);
		}

		if (old) {
			old.remove();
		}
		table.appendTo(this.element);
	},
	showOptions: function showOptions($super, options) {
		_baseField2.default.Field.prototype.showOptions.call(this, options);
		options.append(this.choices_panel.render([this.choices.render()])).append(this.variables_panel.render([this.variables.render()])).append(this.display_panel.render([this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()])).append(this.options_panel.render([this.optional, this.randomize.render(), this.alphabetize.render()]));
	},
	serialize: function serialize($super) {
		var info = $super();
		info.required = !this.optional.value;
		return info;
	}

});

_baseField2.default.NetPromoter = $.klass(_baseField2.default.DrillDownField, {
	type: 'net-promoter',
	qlass: 'net-promoter',
	cssType: 'net-promoter',
	isBranchable: true,
	displayName: gettext('Net Promoter'),
	helpText: gettext('0 to 10 rating scale'),

	isEnabled: true,
	isCustom: true,
	isVisible: false,
	defaultFlipOrder: true,
	defaultLeftLabel: gettext('Very Likely'),
	defaultRightLabel: gettext('Not at all Likely'),
	appearanceChoices: [['likert', gettext('Likert')]],

	isScorable: true,

	getDefaultCategories: function getDefaultCategories() {
		return [{
			label: gettext('Promoter'),
			required: false,
			choices: [{ label: '10', score: 10 }, { label: '9', score: 9 }]
		}, {
			label: gettext('Passive'),
			required: false,
			choices: [{ label: '8', score: 8 }, { label: '7', score: 7 }]
		}, {
			label: gettext('Detractor'),
			required: false,
			choices: [{ label: '6', score: 6 }, { label: '5', score: 5 }, { label: '4', score: 4 }, { label: '3', score: 3 }, { label: '2', score: 2 }, { label: '1', score: 1 }, { label: '0', score: 0 }]
		}];
	},
	initialize: function initialize($super, info, editor) {
		var that = this;
		info = info || {};
		$super(info, editor);
		this.categories.value = this.categories.fromInfo(this.getDefaultCategories());
		this.choices = {
			getAt: function getAt(i) {
				return this.value[i].text.get();
			},
			setAt: function setAt(i, value) {
				return this.value[i].text.set(value);
			},
			value: $.map(this.categories.value, function (el) {
				return el.choices.value;
			})
		};
		this.showCatLabels.set(false);
		this.likert_options = Option.renderGroup('', [this.flipOrder, this.leftLabel, this.rightLabel], this.appearance.value != 'likert', true);
		this.display_panel.collapsed = false;
		this.title.value = this.editor.languages.objectify(info.title || gettext('How likely is it that you would recommend our company to a friend or colleague?'));
	},

	showOptions: function showOptions(options) {
		_baseField2.default.Field.prototype.showOptions.apply(this, [options]);
		var that = this;

		options.append(this.display_panel.render([this.likert_options, this.displayInline.render(), this.appendToPrevious.render(), this.widthOption.render()])).append(this.options_panel.render([this.optional.render()]));
	}
});

_baseField2.default.MultipleChoiceGridField = $.klass(_baseField2.default.ChoiceGridField, (_$$klass = {
	type: 'multiple-choice-grid',
	qlass: 'multiple-choice-grid',
	cssType: 'multiple-choice-grid',

	isEnabled: true,
	isVisible: false,
	displayName: gettext('Checkbox Grid'),
	helpText: gettext('Multiple checkbox answers per row'),
	isDynamic: true,
	baseType: Variable.Multi,
	extractable: true,

	supportedActions: _baseField2.default.Field.prototype.supportedActions.concat([_baseField2.default.Actions.looping]),

	getExtractionChoices: _baseField2.default.SingleChoiceGridField.prototype.getExtractionChoices,
	getExtractionOptions: _baseField2.default.SingleChoiceGridField.prototype.getExtractionOptions,
	serializeExtractionOptions: _baseField2.default.SingleChoiceGridField.prototype.serializeExtractionOptions

}, _defineProperty(_$$klass, 'serializeExtractionOptions', function serializeExtractionOptions(options) {
	return {
		choices: options ? $.map(options.value, function (i) {
			return parseInt(i, 10);
		}) : []
	};
}), _defineProperty(_$$klass, 'choiceAdded', function choiceAdded(value) {
	var that = this;
	var choice = $('<td><span class="choice"></span></td>').appendTo(this.tableHeader);

	if (value) {
		$('span.choice', choice).html(value.text.get());
	}

	$('tbody tr', this.tableDisplay).each(function (i) {
		$(this).append('<td><input type="checkbox" name="' + that.id + '_' + i + '"></td>');
	});
}), _defineProperty(_$$klass, 'variableAdded', function variableAdded(value) {
	var row = '<tr><td><span class="variable"></span><\/td>';
	var index = this.variables.length();

	for (var j = 0; j < this.choices.value.length; j++) {
		row += '<td><input type="checkbox" name="' + this.id + '_' + index + '"></td>';
	}

	row = $(row + '<\/tr>');

	if (value) {
		$('span.variable', row).html(value.text.get());
	}

	return row.appendTo($('tbody', this.tableDisplay));
}), _defineProperty(_$$klass, 'serializeVariable', function serializeVariable(i, info) {
	return {
		type: 'multiple',
		label: info.text.value,
		required: !info.optional.value
	};
}), _$$klass));

// @Deprecated Version from FS/FR
// FR-ONLY
_baseField2.default.FileField = $.klass(_baseField2.default.Field, {
	type: 'file-field',
	qlass: 'file-field',
	cssType: 'file-field',

	isEnabled: true,
	isVisible: false,

	isCustom: true,

	displayName: gettext('File Upload'),
	options: $.extend({}, _baseField2.default.Field.prototype.options),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length) {
			var optional = info.children[0].required !== undefined ? !info.children[0].required : false;
		} else {
			var optional = true;
		}

		this.optional = new chide.opts.Checkbox({
			label: gettext('Optional'),
			value: optional,
			changed: function changed(value) {
				that.render();
			}
		});

		this.input = $('<input type="file" />');
	},

	render: function render($super) {
		$super();

		if (!this.input) {
			this.input = $('<input type="file" />');
		}

		this.element.append(this.input);
	},

	showOptions: function showOptions($super, options) {
		var that = this;

		$super(options);

		options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true), Option.renderGroup(gettext('Options'), [this.optional, this.remote_upload], false));
	},

	serialize: function serialize($super) {
		var info = $super();
		info.children = [{
			type: 'file'
		}];

		if (this.optional.value) {
			info.children[0].required = false;
		}

		return info;
	}
});

_baseField2.default.HiddenField = $.klass(_baseField2.default.Field, {
	type: 'hidden-field',
	cssType: 'hidden-field',
	qlass: 'hidden-field',

	displayName: gettext('Hidden Field'),
	isEnabled: true,
	isQuestion: true,
	isBranchable: true,
	isCustom: true,
	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		if (info.label !== undefined) {
			var label_value = info.label;
		} else {
			var label_value = gettext("Hidden Value");
		}

		this.label = this.title = new chide.opts.Text({
			label: gettext('Variable Name'),
			value: label_value,
			inputClass: 'text short',
			help: gettext("Variable Name - This value will show up when viewing responses. Note that this question will not be visible anywhere in the survey, and can only be used to pass through a value."),
			changed: function changed(value) {
				if (value != "") $('.title', that.element).text(value);
			}
		});

		this.initialValue = new chide.opts.Text({
			field: this,
			translatable: false,
			value: info.children && info.children.length && info.children[0].initialValue || info.initialValue || undefined,
			label: gettext('Hidden Value'),
			inputClass: 'text short',
			help: gettext('About Hidden Values - The hidden value allows you to pass through values through your survey. You can pipe values into this field.'),
			changed: function changed(value) {
				$('.description', this.field.element).text(value);
			}
		});

		this.restore_default = new chide.opts.Checkbox({
			label: gettext('Restore Initial Value'),
			value: info.children && info.children.length && info.children[0].restore_default || info.restore_default || undefined,
			help: gettext('About Restore Initial Value - When a user comes back to this form page, this question will have its default value.'),
			changed: function changed(value) {}
		});
	},

	getVariables: function getVariables() {
		return [new Variable.String({ id: this.id, label: this.getIdentifier(), name: this.name.get() })];
	},

	serialize: function serialize() {
		return $.extend({
			type: 'question',
			id: this.id,
			idname: this.qlass,
			label: this.label.value
		}, {
			name: this.name.value || undefined,
			children: [$.extend({}, {
				type: 'hidden',
				initialValue: this.initialValue.get() && this.initialValue.value || undefined,
				restore_default: this.restore_default.get() || undefined
			})]
		});
	},

	render: function render() {
		var that = this;

		this.element.empty();

		var options = $('<div class="sma-js-field-actions"></div>').append($('<a data-variable-name="' + this.id + '"></a>')).append($('<a href="#" class="nc-icon-mini gestures_drag-31 move" title=' + gettext('Move') + '></a>').tooltip()).append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate" title=' + gettext('Duplicate') + '></a>').tooltip()).append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove" title=' + gettext('Delete') + '></a>').tooltip());

		this.element.append(options);

		this.element.append('<span class="status"><\/span>', '<span class="name">' + (that.name.get() ? that.name.get() : '') + '<\/span>', '<span class="title fr-view">' + this.label.get() + '<\/span>', '<p class="description fr-view">' + (this.initialValue.get() || '') + '<\/p>');
	},

	showOptions: function showOptions(options) {
		var that = this;

		options.empty().append(this.name.render()).append(this.label.render()).append(this.initialValue.render()).append(this.restore_default.render());
	}
});

_baseField2.default.DatasourceField = $.klass(_baseField2.default.Field, {
	type: 'datasource',
	cssType: 'datasource',
	qlass: 'datasource',

	displayName: gettext('Datasource Question'),
	isEnabled: true,

	isQuestion: true,
	isBranchable: false,
	isCustom: true,

	options: $.extend({}, _baseField2.default.Field.prototype.options, {
		dataSource: Class.create(chide.opts.Text, _defineProperty({
			displayInline: false,
			translatable: false,
			inputClass: 'text inline short',
			label: gettext('Datasource URL'),
			help: gettext('Enter the URL for the datasource here. This URL should return a JSON encoded dictionary (keys will be choice values, values will be choice labels).')
		}, 'inputClass', 'text short')),

		width: Class.create(chide.opts.Number, {
			label: gettext('Width'),
			inputClass: 'text inline medium',
			help: gettext('Question Width - Percentage of the survey width that this question will take up. (This will not be reflected in the editor)'),
			applyEdit: false,
			min: 0,
			max: 200,
			changed: function changed(value) {
				if (value > 0 && value <= 200) {
					this.field.element.width(value + '%').width(this.field.element.width() - 22);
				} else {
					this.field.element.width('auto');
					this.set(100);
				}
			}

		}),

		optional: Class.create(chide.opts.Checkbox, {
			label: gettext('Optional'),
			fromInfo: function fromInfo(info) {
				if (info && info.required !== undefined) return !info.required;
				if (info && info.children && info.children.length) return info.children[0].required !== undefined ? !info.children[0].required : false;
				return true;
			}
		})
	}),

	initialize: function initialize($super, info, editor) {
		var that = this;

		info = info || {};

		$super(info, editor);

		this.optional = new this.options.optional({ info: info, changed: function changed(value) {
				that.render();
			} });

		this.dataSource = new this.options.dataSource({
			field: this,
			value: info.children && info.children.length && info.children[0].dataSource || info.dataSource || undefined,
			changed: function changed(value) {
				if (this.field._preview) {
					this.field._preview.text(value);
				}
			}
		});

		this.widthOption = new this.options.width({ value: info.width || 100, field: this });
	},

	render: function render($super) {
		$super();

		this._preview = $('<div></div>', {
			text: this.dataSource && this.dataSource.get(),
			'class': 'datasource'
		});

		this.element.append(this._preview);
	},

	showOptions: function showOptions($super, options) {
		$super(options);

		options.append(Option.renderGroup(gettext('Options'), [this.optional, this.dataSource], true), Option.renderGroup(gettext('Display'), [this.widthOption], true));
	},

	serialize: function serialize($super) {
		return $.extend($super(), {
			children: [$.extend({}, {
				type: 'datasource',
				required: !this.optional.value,
				width: this.widthOption.get() || undefined,
				dataSource: this.dataSource.get() && this.dataSource.value || undefined
			})]
		});
	}
});

_baseField2.default.Signature = $.klass(_baseField2.default.TextField, {
	type: 'signature',
	qlass: 'signature',
	cssType: 'signature',
	displayName: gettext('Signature'),
	isEnabled: true,
	isBranchable: false,
	isCustom: true,

	options: $.extend({}, _baseField2.default.TextField.prototype.options, {}),

	showOptions: function showOptions($super, options) {
		var that = this;
		$super(options);

		options.html('');

		options.append(Option.renderGroup(gettext('General'), [this.name, this.title, this.description], false));

		options.append(Option.renderGroup(gettext('Display'), [this.displayInline, this.appendToPrevious, this.widthOption], true));

		options.append(Option.renderGroup(gettext('Options'), [this.optional], true));
	},

	initialize: function initialize($super, info, editor) {
		$super(info, editor);
		info = info || {};

		$super(info, editor);

		if (info.children && info.children.length) {
			var optional = info.children[0].required !== undefined ? !info.children[0].required : false;
		} else {
			var optional = true;
		}

		this.optional = new chide.opts.Checkbox({
			label: gettext('Optional'),
			value: optional,
			changed: function changed(value) {
				that.render();
			}
		});
	},

	serialize: function serialize($super) {
		var info = $super();
		info.children = [{ type: 'file' }];

		if (this.optional.value) {
			info.children[0].required = false;
		}

		return info;
	},

	getChoiceContainer: function getChoiceContainer($super) {
		$super();
	},

	renderContent: function renderContent($super) {
		if ($('.signature', this.element).length == 0) {
			this.element.append($('<div\/>', { 'class': 'signature' }));
			$('.signature', this.element).jSignature();
		}
	}
});

_baseField2.default.UploadField = UploadField;

module.exports = _baseField2.default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var configuration = {
	defaults: {
		maxFileSize: 1000,
		minFiles: 1,
		maxFiles: 2,
		allowMultiple: false,
		limitUploads: false,
		limitFileFormat: false,
		includeDescription: false,
		fileFormats: '',
		required: true
	}
};

exports.default = configuration;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Fields = __webpack_require__(844);
var Class = __webpack_require__(157);
var chide = __webpack_require__(230);
var Option = __webpack_require__(231).Option;
var ElementSearch = __webpack_require__(1207);
var block = __webpack_require__(306);

var guideStarSchemaTree = [{ 'identifier': 'also_known_as', 'name': gettext('Also known as') }, { 'children': [{ 'identifier': 'affiliation', 'name': gettext('Affiliation') }, { 'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true }, { 'identifier': 'compensation', 'name': gettext('Compensation') }, { 'identifier': 'email', 'name': gettext('Email') }, { 'identifier': 'end_month', 'name': gettext('End month') }, { 'identifier': 'end_year', 'name': gettext('End year') }, { 'identifier': 'first_name', 'name': gettext('First name') }, { 'identifier': 'last_name', 'name': gettext('Last name') }, { 'identifier': 'middle_name', 'name': gettext('Middle name') }, { 'identifier': 'picture', 'name': gettext('Picture') }, { 'identifier': 'prefix', 'name': gettext('Prefix') }, { 'identifier': 'start_month', 'name': gettext('Start month') }, { 'identifier': 'start_year', 'name': gettext('Start year') }, { 'identifier': 'status', 'name': gettext('Status') }, { 'identifier': 'suffix', 'name': gettext('Suffix') }, { 'identifier': 'title', 'name': gettext('Title') }],
	'identifier': 'board_chair',
	'name': gettext('Board chair') }, { 'children': [{ 'identifier': 'affiliation', 'name': gettext('Affiliation') }, { 'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true }, { 'identifier': 'compensation', 'name': gettext('Compensation') }, { 'identifier': 'email', 'name': gettext('Email') }, { 'identifier': 'end_month', 'name': gettext('End month') }, { 'identifier': 'end_year', 'name': gettext('End year') }, { 'identifier': 'first_name', 'name': gettext('First name') }, { 'identifier': 'last_name', 'name': gettext('Last name') }, { 'identifier': 'middle_name', 'name': gettext('Middle name') }, { 'identifier': 'picture', 'name': gettext('Picture') }, { 'identifier': 'prefix', 'name': gettext('Prefix') }, { 'identifier': 'start_month', 'name': gettext('Start month') }, { 'identifier': 'start_year', 'name': gettext('Start year') }, { 'identifier': 'status', 'name': gettext('Status') }, { 'identifier': 'suffix', 'name': gettext('Suffix') }, { 'identifier': 'title', 'name': gettext('Title') }],
	'identifier': 'board_co_chair',
	'name': gettext('Board co-chair') }, { 'children': [{ 'identifier': 'board_composition', 'name': gettext('Board composition') }, { 'identifier': 'board_orientation_and_education', 'name': gettext('Board orientation and education') }, { 'identifier': 'board_performance', 'name': gettext('Board performance') }, { 'identifier': 'ceo_oversight', 'name': gettext('CEO oversight') }, { 'identifier': 'ethnics_and_transparency', 'name': gettext('Ethics and transparency') }],
	'identifier': 'board_source',
	'name': gettext('Board source') }, { 'identifier': 'bridge_id', 'name': gettext('Bridge ID') }, { 'children': [{ 'identifier': 'affiliation', 'name': gettext('Affiliation') }, { 'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true }, { 'identifier': 'compensation', 'name': gettext('Compensation') }, { 'identifier': 'email', 'name': gettext('Email') }, { 'identifier': 'end_month', 'name': gettext('End month') }, { 'identifier': 'end_year', 'name': gettext('End year') }, { 'identifier': 'first_name', 'name': gettext('First name') }, { 'identifier': 'last_name', 'name': gettext('Last name') }, { 'identifier': 'middle_name', 'name': gettext('Middle name') }, { 'identifier': 'picture', 'name': gettext('Picture') }, { 'identifier': 'prefix', 'name': gettext('Prefix') }, { 'identifier': 'start_month', 'name': gettext('Start month') }, { 'identifier': 'start_year', 'name': gettext('Start year') }, { 'identifier': 'status', 'name': gettext('Status') }, { 'identifier': 'suffix', 'name': gettext('Suffix') }, { 'identifier': 'title', 'name': gettext('Title') }],
	'identifier': 'co_executive_director',
	'name': gettext('Co-executive director') }, { 'children': [{ 'identifier': 'diversity_committee', 'name': gettext('Diversity committee') }, { 'identifier': 'diversity_manager', 'name': gettext('Diversity manager') }, { 'identifier': 'diversity_manager_full_time', 'name': gettext('Diversity manager full-time') }, { 'identifier': 'diversity_plan', 'name': gettext('Diversity plan') }, { 'identifier': 'support_diversity_other_methods', 'name': gettext('Support diversity by other methods') }, { 'identifier': 'track_age_of_staff', 'name': gettext('Track age of staff') }, { 'identifier': 'track_diversity_of_vendors', 'name': gettext('Track diversity of vendors') }, { 'identifier': 'track_income_levels', 'name': gettext('Track income levels') }, { 'identifier': 'track_retention', 'name': gettext('Track retention') }],
	'identifier': 'demographics',
	'name': gettext('Demographics') }, { 'children': [{ 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'personWithDisability',
		'name': gettext('Person with disability') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'unknownOrDeclinedToState',
		'name': gettext('Unknown or declined to state') }],
	'identifier': 'demographics_by_disability',
	'name': gettext('Demographics by disability') }, { 'children': [{ 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'asianOrAsianAmerican',
		'name': gettext('Asian or Asian American') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'blackOrAfricanAmerican',
		'name': gettext('Black or African American') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'hispanicOrLatinoOrLatina',
		'name': gettext('Hispanic or Latino or Latina') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'multiRacialOrMultiEthnic',
		'name': gettext('Multi-racial or Multi-ethnic') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'nativeAmericanOrAmericanIndianOrAlaskaNativeOrNativeHawaiian',
		'name': gettext('Native American or American Indian or Alaska Native or Native Hawaiian') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'unknownOrDeclinedToState',
		'name': gettext('Unknown or declined to state') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'white',
		'name': gettext('White') }],
	'identifier': 'demographics_by_ethnicity',
	'name': gettext('Demographics by ethnicity') }, { 'children': [{ 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'female',
		'name': gettext('Female') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'male',
		'name': gettext('Male') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'transgenderOrUnspecifiedNonConforming',
		'name': gettext('Transgender or Unspecified or Non-conforming') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'unknownOrDeclinedToState',
		'name': gettext('Unknown or declined to state') }],
	'identifier': 'demographics_by_gender',
	'name': gettext('Demographics by gender') }, { 'children': [{ 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'lesbianGayBisexual',
		'name': gettext('Lesbian or Gay or Bisexual') }, { 'children': [{ 'identifier': 'board_members', 'name': gettext('Board members') }, { 'identifier': 'senior_staff', 'name': gettext('Senior staff') }, { 'identifier': 'staff_members_full_time', 'name': gettext('Staff members full-time') }, { 'identifier': 'staff_members_part_time', 'name': gettext('Staff members part-time') }, { 'identifier': 'volunteers', 'name': gettext('Volunteers') }],
		'identifier': 'unknownOrDeclinedToState',
		'name': gettext('Unknown or declined to state') }],
	'identifier': 'demographics_by_sexual_orientation',
	'name': gettext('Demographics by sexual orientation') }, { 'identifier': 'doing_business_as', 'name': gettext('Doing business as') }, { 'children': [{ 'identifier': 'affiliation', 'name': gettext('Affiliation') }, { 'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true }, { 'identifier': 'compensation', 'name': gettext('Compensation') }, { 'identifier': 'email', 'name': gettext('Email') }, { 'identifier': 'end_month', 'name': gettext('End month') }, { 'identifier': 'end_year', 'name': gettext('End year') }, { 'identifier': 'first_name', 'name': gettext('First name') }, { 'identifier': 'last_name', 'name': gettext('Last name') }, { 'identifier': 'middle_name', 'name': gettext('Middle name') }, { 'identifier': 'picture', 'name': gettext('Picture') }, { 'identifier': 'prefix', 'name': gettext('Prefix') }, { 'identifier': 'start_month', 'name': gettext('Start month') }, { 'identifier': 'start_year', 'name': gettext('Start year') }, { 'identifier': 'status', 'name': gettext('Status') }, { 'identifier': 'suffix', 'name': gettext('Suffix') }, { 'identifier': 'title', 'name': gettext('Title') }],
	'identifier': 'executive_director',
	'name': gettext('Executive director') }, { 'identifier': 'fax', 'name': gettext('Fax') }, { 'identifier': 'funding_needs', 'name': gettext('Funding needs') }, { 'identifier': 'geographic_areas_served_narrative', 'name': gettext('Geographic areas served') }, { 'identifier': 'geographic_areas_served', 'name': gettext('Geographic areas served') }, { 'identifier': 'government_issued_id', 'name': gettext('Government issued ID') }, { 'identifier': 'government_issued_ruling_year', 'name': gettext('Government issued ruling year') }, { 'identifier': 'government_registered_name', 'name': gettext('Government registered name') }, { 'identifier': 'irs_509a_status', 'name': gettext('IRS 509a status') }, { 'identifier': 'irs_subsection_code', 'name': gettext('IRS subsection code') }, { 'identifier': 'form_990', 'name': gettext('Form 990') }, { 'identifier': 'impact_statement', 'name': gettext('Impact statement'), 'isTextArea': true }, { 'identifier': 'incorporation_year', 'name': gettext('Incorporation year') }, { 'children': [{ 'identifier': 'address_line_1', 'name': gettext('Address') }, { 'identifier': 'address_line_2', 'name': gettext('Address line 2') }, { 'identifier': 'city', 'name': gettext('City') }, { 'identifier': 'country_abbrev', 'name': gettext('Country') }, { 'identifier': 'postal_code', 'name': gettext('Postal code') }, { 'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province') }],
	'identifier': 'international_address',
	'name': gettext('International address') }, { 'identifier': 'international_phone', 'name': gettext('International phone') }, { 'identifier': 'keywords', 'name': gettext("Keywords describing your organization's work") }, { 'identifier': 'logo_name', 'name': gettext('Logo name') }, { 'identifier': 'logo_path', 'name': gettext('Logo path') }, { 'identifier': 'notes', 'name': gettext('Notes') }, { 'identifier': 'organization_id', 'name': gettext('Organization ID') }, { 'identifier': 'organization_blog', 'name': gettext('Organization blog') }, { 'identifier': 'organization_email', 'name': gettext('Organization email') }, { 'identifier': 'mission_statement', 'name': gettext('Organization mission statement'), 'isTextArea': true }, { 'identifier': 'organization_website', 'name': gettext('Organization website') }, { 'identifier': 'participation_level', 'name': gettext('Participation level') }, { 'children': [{ 'identifier': 'address_line_1', 'name': gettext('Address') }, { 'identifier': 'address_line_2', 'name': gettext('Address line 2') }, { 'identifier': 'city', 'name': gettext('City') }, { 'identifier': 'country_abbrev', 'name': gettext('Country') }, { 'identifier': 'postal_code', 'name': gettext('Postal code') }, { 'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province') }],
	'identifier': 'physical_address',
	'name': gettext('Physical address') }, { 'children': [{ 'identifier': 'address_line_1', 'name': gettext('Address') }, { 'identifier': 'address_line_2', 'name': gettext('Address line 2') }, { 'identifier': 'city', 'name': gettext('City') }, { 'identifier': 'country_abbrev', 'name': gettext('Country') }, { 'identifier': 'postal_code', 'name': gettext('Postal code') }, { 'identifier': 'country_subdivision_abbrev_', 'name': gettext('State / Province') }],
	'identifier': 'primary_address',
	'name': gettext('Primary address') }, { 'children': [{ 'identifier': 'affiliation', 'name': gettext('Affiliation') }, { 'identifier': 'bio', 'name': gettext('Bio'), 'isTextArea': true }, { 'identifier': 'compensation', 'name': gettext('Compensation') }, { 'identifier': 'email', 'name': gettext('Email') }, { 'identifier': 'end_month', 'name': gettext('End month') }, { 'identifier': 'end_year', 'name': gettext('End year') }, { 'identifier': 'first_name', 'name': gettext('First name') }, { 'identifier': 'last_name', 'name': gettext('Last name') }, { 'identifier': 'middle_name', 'name': gettext('Middle name') }, { 'identifier': 'picture', 'name': gettext('Picture') }, { 'identifier': 'prefix', 'name': gettext('Prefix') }, { 'identifier': 'start_month', 'name': gettext('Start month') }, { 'identifier': 'start_year', 'name': gettext('Start year') }, { 'identifier': 'status', 'name': gettext('Status') }, { 'identifier': 'suffix', 'name': gettext('Suffix') }, { 'identifier': 'title', 'name': gettext('Title') }],
	'identifier': 'primary_contact',
	'name': gettext('Primary contact') }, { 'identifier': 'primary_organization_name', 'name': gettext('Primary organization name') }, { 'identifier': 'primary_telephone', 'name': gettext('Primary telephone') }, { 'children': [{ 'identifier': 'facebook', 'name': gettext('Facebook') }, { 'identifier': 'flickr', 'name': gettext('Flickr') }, { 'identifier': 'foursquare', 'name': gettext('Foursquare') }, { 'identifier': 'google', 'name': gettext('Google') }, { 'identifier': 'instagram', 'name': gettext('Instagram') }, { 'identifier': 'linkedin', 'name': gettext('Linkedin') }, { 'identifier': 'pinterest', 'name': gettext('Pinterest') }, { 'identifier': 'tumblr', 'name': gettext('Tumblr') }, { 'identifier': 'twitter', 'name': gettext('Twitter') }, { 'identifier': 'vimeo', 'name': gettext('Vimeo') }, { 'identifier': 'youtube', 'name': gettext('Youtube') }],
	'identifier': 'social',
	'name': gettext('Social') }, { 'identifier': 'year_founded', 'name': gettext('Year founded') }];

var GuideStarTextField = $.klass(Fields.TextField, {
	isGuideStar: true,
	isTextArea: false,
	defaultTitle: '',

	initialize: function initialize($super, info, editor) {
		info = info || {};
		$super(info, editor);
		var that = this;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function changed(value) {
				var title = value + (that.optional && that.optional.get() ? ' <small>' + gettext('(optional)') + '</small>' : '');
				$('.title', that.element).html(that.survey.stripScriptTags(title));
			}
		}))({
			value: this.defaultTitle
		});
		this.appearance = new this.options.appearance({
			field: this,
			value: info.children && info.children.length ? info.children[0].appearance === 'full' : this.isTextArea
		});
	},

	serialize: function serialize($super) {
		return $.extend($super(), {
			idname: 'text-response'
		});
	}
});

var GuideStarSingleColumnGridField = $.klass(Fields.Natrix, {
	isGuideStar: true,
	defaultTitle: '',

	initialize: function initialize($super, info, editor) {
		$super(info, editor);
		var that = this;

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function changed(value) {
				var title = value + (that.optional && that.optional.get() ? ' <small>' + gettext('(optional)') + '</small>' : '');
				$('.title', that.element).html(that.survey.stripScriptTags(title));
			}
		}))({
			value: this.defaultTitle
		});
	},

	serialize: function serialize($super) {
		return $.extend($super(), {
			idname: 'custom-grid'
		});
	}
});

function createGuideStarTextField(identifier, name, fullName, isTextArea, parentIdentifier, depth) {
	return $.klass(GuideStarTextField, {
		guideStarDefaultMapping: identifier,
		type: identifier,
		qlass: identifier,
		cssType: identifier,
		depth: depth,
		parentIdentifier: parentIdentifier,

		displayName: name,
		defaultFullName: fullName,
		defaultTitle: fullName,
		isTextArea: isTextArea
	});
}

function createGuideStarSingleColumnGrid(identifier, name, fullName, children, parentIdentifier, depth) {
	return $.klass(GuideStarSingleColumnGridField, {
		guideStarDefaultMapping: identifier,
		type: identifier,
		qlass: identifier,
		cssType: identifier,
		depth: depth,
		parentIdentifier: parentIdentifier,

		isParent: true,
		isLastParent: !children[0].children,

		displayName: name,
		defaultFullName: fullName,
		defaultTitle: name,

		getDefaultVariables: function getDefaultVariables() {
			return children.map(function (field) {
				return {
					label: field.name,
					required: false,
					type: 'string',
					guideStarDefaultMapping: identifier + '__' + field.identifier,
					isTextArea: field.isTextArea
				};
			});
		}
	});
}

function createGuideStarUIFields(arr, parentIdentifier, parentName, depth) {
	depth = depth ? depth + 1 : 1;

	return arr.reduce(function (newArray, field) {
		var identifier = parentIdentifier ? parentIdentifier + '__' + field.identifier : field.identifier;
		var fullName = parentName ? parentName + ' / ' + field.name : field.name;

		if (field.children) {
			newArray.push(createGuideStarSingleColumnGrid(identifier, field.name, fullName, field.children, parentIdentifier, depth));
			newArray = newArray.concat(createGuideStarUIFields(field.children, identifier, fullName, depth));
		} else {
			newArray.push(createGuideStarTextField(identifier, field.name, fullName, field.isTextArea, parentIdentifier, depth));
		}

		return newArray;
	}, []);
}

var GuideStarFields = createGuideStarUIFields(guideStarSchemaTree);

var Mapping = $.klass(Option.Value, {
	label: gettext('Mapping'),

	initialize: function initialize($super, field, config) {
		$super(field, config);
		this.subvariable = config.subvariable;
		this.set(config.value);
	},

	render: function render($super) {
		var that = this;
		var $mappingSelect = $('<select class="custom-select custom-select-sm"><\/select>').css('width', '145px');
		var $searchContainer = $('<div id="search" class="sma-guidestar-mapping-option-search" style="display: none;"></div>');
		var $searchItems = $('<div id="search-items" class="sma-guidestar-mapping-option-search-items"></div>');
		var addGuideStarField = function addGuideStarField(guideStarFieldData) {
			$mappingSelect.append($.format('<option value="{0}">{1}<\/option>', [guideStarFieldData.identifier, guideStarFieldData.name]));
			var searchItem = $($.format('<div class="add-cursor" data-value="{0}">{1}<\/div>', [guideStarFieldData.identifier, guideStarFieldData.name]));
			$searchItems.append(searchItem);
			searchItem.click(function (e) {
				var value = $(e.target).data('value');
				that.set(value);
				$mappingSelect.val(value);
				$mappingSelect.change();
				$searchContainer.hide();
				that.elementSearch.clearSearch();
				that.toggleGuidestarLogo(e);
			});
		};

		$searchContainer.append($searchItems);

		addGuideStarField({
			identifier: '',
			name: gettext('None')
		});
		_.each(GuideStarFields.filter(function (x) {
			return !x.prototype.isParent;
		}).map(function (x) {
			return {
				identifier: x.prototype.guideStarDefaultMapping,
				name: x.prototype.defaultFullName
			};
		}), addGuideStarField);

		$mappingSelect.val(this.value).css('margin-bottom', '0').mousedown(function (e) {
			e.preventDefault();
			$searchContainer.show();
			that.elementSearch.input.focus();
		});
		this.updateTypeField(this.value);

		var result = $super().addClass('col-sm-12');
		result.append("<strong class='inline'>" + this.label + "</strong>");
		result.append($mappingSelect);
		result.append($searchContainer);

		that.elementSearch = new ElementSearch({
			container: $searchItems,
			showAllOnEmpty: true
		});

		return result;
	},

	toggleGuidestarLogo: function toggleGuidestarLogo(e) {
		// Single column grid
		if (this.subvariable) {
			if (e) {
				var target = $(e.currentTarget).closest('li');
				var index = target.index();
				var questionContainer = this.field.element.find('.variables');
				var question = $(questionContainer.find('tr')[index]);
				var guidestarLogoContainer = question.find('.sma-natrix-guidestar-container');
				var existingGuidestarLogo = question.find('.sma-guidestar-logo');

				var guideStarLogo = '<img width="18px" class="sma-guidestar-logo" src="' + MEDIA_URL + 'img/smapply/GuideStarLogo.svg">';

				if (existingGuidestarLogo) {
					existingGuidestarLogo.remove();
				}

				if (this.value) {
					guidestarLogoContainer.prepend(guideStarLogo);
				}
			}
		} else {
			var _guideStarLogo = '<img width="18px" class="mr-1 sma-guidestar-logo" src="' + MEDIA_URL + 'img/smapply/GuideStarLogo.svg">';

			var container = $(this.field.element).find('.title');

			var _existingGuidestarLogo = container.find('.sma-guidestar-logo');

			if (_existingGuidestarLogo) {
				_existingGuidestarLogo.remove();
			}

			if (this.value) {
				container.prepend(_guideStarLogo);
			}
		}
	},

	changed: function changed(value, old) {
		this.updateTypeField(value);
	},

	updateTypeField: function updateTypeField(value) {
		if (this.subvariable == undefined || this.subvariable.type == undefined) {
			return;
		}
		var typeField = this.subvariable.type;

		if (value) {
			var disableMessage = gettext('Set the GuideStar mapping to "None" in order to change the type');
			block.block(typeField.input);
			$('.sma-js-switch-to-type-warning').remove();
			$(typeField.input).after('<div class="sma-js-switch-to-type-warning">' + '<i class="nc-icon-mini ui-2_alert-circle-i"></i>' + '<small>&nbsp;' + disableMessage + '</small>' + '</div>');
		} else {
			block.unblock(typeField.input);
			$('.sma-js-switch-to-type-warning').remove();
		}
	}
});

module.exports = {
	GuideStarFields: GuideStarFields,
	Mapping: Mapping
};

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backbone = __webpack_require__(40);

var _backbone2 = _interopRequireDefault(_backbone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileMenu = function (_Backbone$View) {
    _inherits(MobileMenu, _Backbone$View);

    function MobileMenu() {
        _classCallCheck(this, MobileMenu);

        return _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).apply(this, arguments));
    }

    _createClass(MobileMenu, [{
        key: 'initialize',
        value: function initialize() {
            this.setElement('body');
        }
    }, {
        key: 'clickMenuTrigger',
        value: function clickMenuTrigger(el) {
            var target = $(el.currentTarget);
            var id = target.data('container-id');

            // Mobile menu container
            this.mobileMenu = $('#' + id);

            // Add shade to body
            this.menuShade = $('<div class="sma-menu-shade hidden-md-up"></div>');
            this.menuShade.appendTo('.sma-applicant-nav');

            this.menuShade.show();

            this.menuShade.animate({
                opacity: 1
            }, 400);

            // Add Close button
            var ariaLabel = gettext('Close');
            this.mobileMenu.prepend('<a href="#" class="sma-js-close-mobile-menu sma-close-mobile-menu" aria-label="' + ariaLabel + '"><i class="nc-icon-mini ui-1_simple-remove" aria-hidden="true"></i></a>');

            // Get mobile menu width and move it the left/right offscreen by the width 
            this.elementWidth = this.mobileMenu.width();

            var direction = this.mobileMenu.hasClass('sma-mobile-menu-right') ? 'right' : 'left';
            this.mobileMenu.css(direction, this.elementWidth * -1);

            // Show the mobile menu
            this.mobileMenu.show();

            // Animate the mobile menu from offscreen into position
            if (this.mobileMenu.hasClass('sma-mobile-menu-right')) {
                this.mobileMenu.animate({
                    right: 0
                }, 400);
            } else if (this.mobileMenu.hasClass('sma-mobile-menu-left')) {
                this.mobileMenu.animate({
                    left: 0
                }, 400);
            }
        }
    }, {
        key: 'clickMenuClose',
        value: function clickMenuClose(el) {
            var _this2 = this;

            this.menuShade.animate({
                opacity: 0
            }, 400);

            if (this.mobileMenu.hasClass('sma-mobile-menu-right')) {
                this.mobileMenu.animate({
                    right: this.elementWidth * -1
                }, 400, function () {
                    _this2.menuShade.hide();
                    var target = $(el.currentTarget);
                    target.closest('.sma-mobile-menu-container').hide();
                });
            } else if (this.mobileMenu.hasClass('sma-mobile-menu-left')) {
                this.mobileMenu.animate({
                    left: this.elementWidth * -1
                }, 400, function () {
                    _this2.menuShade.hide();
                    var target = $(el.currentTarget);
                    target.closest('.sma-mobile-menu-container').hide();
                });
            }
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click .sma-mobile-menu-trigger': 'clickMenuTrigger',
                'click .sma-js-close-mobile-menu': 'clickMenuClose'
            };
        }
    }]);

    return MobileMenu;
}(_backbone2.default.View);

module.exports = {
    MobileMenu: MobileMenu
};

/***/ }),
/* 855 */,
/* 856 */,
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(21)(function () {
  return Object.defineProperty(__webpack_require__(410)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(30);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(75);
var toIObject = __webpack_require__(76);
var arrayIndexOf = __webpack_require__(285)(false);
var IE_PROTO = __webpack_require__(412)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(37);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(160);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(76);
var gOPN = __webpack_require__(163).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(160);
var gOPS = __webpack_require__(286);
var pIE = __webpack_require__(234);
var toObject = __webpack_require__(39);
var IObject = __webpack_require__(233);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(21)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(52);
var isObject = __webpack_require__(24);
var invoke = __webpack_require__(865);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 865 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(18).parseInt;
var $trim = __webpack_require__(189).trim;
var ws = __webpack_require__(416);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(18).parseFloat;
var $trim = __webpack_require__(189).trim;

module.exports = 1 / $parseFloat(__webpack_require__(416) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(90);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(24);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 870 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(419);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(52);
var toObject = __webpack_require__(39);
var IObject = __webpack_require__(233);
var toLength = __webpack_require__(31);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(161);
var toLength = __webpack_require__(31);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(431);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(33) && /./g.flags != 'g') __webpack_require__(37).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(235)
});


/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var isObject = __webpack_require__(24);
var newPromiseCapability = __webpack_require__(435);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(881);
var validate = __webpack_require__(168);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(294)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(37).f;
var create = __webpack_require__(162);
var redefineAll = __webpack_require__(167);
var ctx = __webpack_require__(89);
var anInstance = __webpack_require__(165);
var forOf = __webpack_require__(166);
var $iterDefine = __webpack_require__(421);
var step = __webpack_require__(875);
var setSpecies = __webpack_require__(164);
var DESCRIPTORS = __webpack_require__(33);
var fastKey = __webpack_require__(135).fastKey;
var validate = __webpack_require__(168);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(881);
var validate = __webpack_require__(168);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(294)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var each = __webpack_require__(101)(0);
var redefine = __webpack_require__(66);
var meta = __webpack_require__(135);
var assign = __webpack_require__(862);
var weak = __webpack_require__(884);
var isObject = __webpack_require__(24);
var validate = __webpack_require__(168);
var NATIVE_WEAK_MAP = __webpack_require__(168);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(294)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(167);
var getWeak = __webpack_require__(135).getWeak;
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(24);
var anInstance = __webpack_require__(165);
var forOf = __webpack_require__(166);
var createArrayMethod = __webpack_require__(101);
var $has = __webpack_require__(75);
var validate = __webpack_require__(168);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(91);
var toLength = __webpack_require__(31);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(163);
var gOPS = __webpack_require__(286);
var anObject = __webpack_require__(13);
var Reflect = __webpack_require__(18).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(287);
var isObject = __webpack_require__(24);
var toLength = __webpack_require__(31);
var ctx = __webpack_require__(89);
var IS_CONCAT_SPREADABLE = __webpack_require__(30)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(31);
var repeat = __webpack_require__(418);
var defined = __webpack_require__(99);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(160);
var toIObject = __webpack_require__(76);
var isEnum = __webpack_require__(234).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(188);
var from = __webpack_require__(891);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(166);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 892 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 893 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * clipboard.js v1.5.12
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Clipboard = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}

},{"matches-selector":5}],2:[function(require,module,exports){
var closest = require('closest');

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector, true);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;

},{"closest":1}],3:[function(require,module,exports){
/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};

},{}],4:[function(require,module,exports){
var is = require('./is');
var delegate = require('delegate');

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;

},{"./is":3,"delegate":2}],5:[function(require,module,exports){

/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}
},{}],6:[function(require,module,exports){
function select(element) {
    var selectedText;

    if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        element.focus();
        element.setSelectionRange(0, element.value.length);

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;

},{}],7:[function(require,module,exports){
function E () {
	// Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
	on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;

},{}],8:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', 'select'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */

        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        ClipboardAction.prototype.resolveOptions = function resolveOptions() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

            this.action = options.action;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        };

        ClipboardAction.prototype.initSelection = function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        };

        ClipboardAction.prototype.selectFake = function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            this.fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            document.body.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        };

        ClipboardAction.prototype.removeFake = function removeFake() {
            if (this.fakeHandler) {
                document.body.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                document.body.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        };

        ClipboardAction.prototype.selectTarget = function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        };

        ClipboardAction.prototype.copyText = function copyText() {
            var succeeded = undefined;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        };

        ClipboardAction.prototype.handleResult = function handleResult(succeeded) {
            if (succeeded) {
                this.emitter.emit('success', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            } else {
                this.emitter.emit('error', {
                    action: this.action,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        };

        ClipboardAction.prototype.clearSelection = function clearSelection() {
            if (this.target) {
                this.target.blur();
            }

            window.getSelection().removeAllRanges();
        };

        ClipboardAction.prototype.destroy = function destroy() {
            this.removeFake();
        };

        _createClass(ClipboardAction, [{
            key: 'action',
            set: function set() {
                var action = arguments.length <= 0 || arguments[0] === undefined ? 'copy' : arguments[0];

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

},{"select":6}],9:[function(require,module,exports){
(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', './clipboard-action', 'tiny-emitter', 'good-listener'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */

        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, _Emitter.call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        Clipboard.prototype.resolveOptions = function resolveOptions() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
        };

        Clipboard.prototype.listenClick = function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        };

        Clipboard.prototype.onClick = function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                trigger: trigger,
                emitter: this
            });
        };

        Clipboard.prototype.defaultAction = function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        };

        Clipboard.prototype.defaultTarget = function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        };

        Clipboard.prototype.defaultText = function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        };

        Clipboard.prototype.destroy = function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        };

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

},{"./clipboard-action":8,"good-listener":4,"tiny-emitter":7}]},{},[9])(9)
});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global Tether */

var _util = __webpack_require__(191);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tooltip = function ($) {

  /**
   * Check for Tether dependency
   * Tether - http://tether.io/
   */
  if (typeof Tether === 'undefined') {
    throw new Error('Bootstrap tooltips require Tether (http://tether.io/)');
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tooltip';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tether';

  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: '0 0',
    constraints: [],
    container: false
  };

  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: 'string',
    constraints: 'array',
    container: '(string|element|boolean)'
  };

  var AttachmentMap = {
    TOP: 'bottom center',
    RIGHT: 'middle left',
    BOTTOM: 'top center',
    LEFT: 'middle right'
  };

  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY
  };

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner'
  };

  var TetherClass = {
    element: false,
    enabled: false
  };

  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Tooltip = function () {
    function Tooltip(element, config) {
      _classCallCheck(this, Tooltip);

      // private
      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._isTransitioning = false;
      this._tether = null;

      // protected
      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    }

    // getters

    _createClass(Tooltip, [{
      key: 'enable',


      // public

      value: function enable() {
        this._isEnabled = true;
      }
    }, {
      key: 'disable',
      value: function disable() {
        this._isEnabled = false;
      }
    }, {
      key: 'toggleEnabled',
      value: function toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      }
    }, {
      key: 'toggle',
      value: function toggle(event) {
        if (event) {
          var dataKey = this.constructor.DATA_KEY;
          var context = $(event.currentTarget).data(dataKey);

          if (!context) {
            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
            $(event.currentTarget).data(dataKey, context);
          }

          context._activeTrigger.click = !context._activeTrigger.click;

          if (context._isWithActiveTrigger()) {
            context._enter(null, context);
          } else {
            context._leave(null, context);
          }
        } else {

          if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
            this._leave(null, this);
            return;
          }

          this._enter(null, this);
        }
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        clearTimeout(this._timeout);

        this.cleanupTether();

        $.removeData(this.element, this.constructor.DATA_KEY);

        $(this.element).off(this.constructor.EVENT_KEY);
        $(this.element).closest('.modal').off('hide.bs.modal');

        if (this.tip) {
          $(this.tip).remove();
        }

        this._isEnabled = null;
        this._timeout = null;
        this._hoverState = null;
        this._activeTrigger = null;
        this._tether = null;

        this.element = null;
        this.config = null;
        this.tip = null;
      }
    }, {
      key: 'show',
      value: function show() {
        var _this = this;

        if ($(this.element).css('display') === 'none') {
          throw new Error('Please use show on visible elements');
        }

        var showEvent = $.Event(this.constructor.Event.SHOW);
        if (this.isWithContent() && this._isEnabled) {
          if (this._isTransitioning) {
            // throw new Error('Tooltip is transitioning')
            return;
          }
          $(this.element).trigger(showEvent);

          var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

          if (showEvent.isDefaultPrevented() || !isInTheDom) {
            return;
          }

          var tip = this.getTipElement();
          var tipId = _util2.default.getUID(this.constructor.NAME);

          tip.setAttribute('id', tipId);
          this.element.setAttribute('aria-describedby', tipId);

          this.setContent();

          if (this.config.animation) {
            $(tip).addClass(ClassName.FADE);
          }

          var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

          var attachment = this._getAttachment(placement);

          var container = this.config.container === false ? document.body : $(this.config.container);

          $(tip).data(this.constructor.DATA_KEY, this).appendTo(container);

          $(this.element).trigger(this.constructor.Event.INSERTED);

          this._tether = new Tether({
            attachment: attachment,
            element: tip,
            target: this.element,
            classes: TetherClass,
            classPrefix: CLASS_PREFIX,
            offset: this.config.offset,
            constraints: this.config.constraints,
            addTargetClasses: false
          });

          _util2.default.reflow(tip);
          this._tether.position();

          $(tip).addClass(ClassName.SHOW);

          var complete = function complete() {
            var prevHoverState = _this._hoverState;
            _this._hoverState = null;
            _this._isTransitioning = false;

            $(_this.element).trigger(_this.constructor.Event.SHOWN);

            if (prevHoverState === HoverState.OUT) {
              _this._leave(null, _this);
            }
          };

          if (_util2.default.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
            this._isTransitioning = true;
            $(this.tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
            return;
          }

          complete();
        }
      }
    }, {
      key: 'hide',
      value: function hide(callback) {
        var _this2 = this;

        var tip = this.getTipElement();
        var hideEvent = $.Event(this.constructor.Event.HIDE);
        if (this._isTransitioning) {
          // throw new Error('Tooltip is transitioning')
        }
        var complete = function complete() {
          if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
            tip.parentNode.removeChild(tip);
          }

          _this2.element.removeAttribute('aria-describedby');
          $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);
          _this2._isTransitioning = false;
          _this2.cleanupTether();

          if (callback) {
            callback();
          }
        };

        $(this.element).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          return;
        }

        $(tip).removeClass(ClassName.SHOW);

        this._activeTrigger[Trigger.CLICK] = false;
        this._activeTrigger[Trigger.FOCUS] = false;
        this._activeTrigger[Trigger.HOVER] = false;

        if (_util2.default.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          this._isTransitioning = true;
          $(tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
        } else {
          complete();
        }

        this._hoverState = '';
      }

      // protected

    }, {
      key: 'isWithContent',
      value: function isWithContent() {
        return Boolean(this.getTitle());
      }
    }, {
      key: 'getTipElement',
      value: function getTipElement() {
        return this.tip = this.tip || $(this.config.template)[0];
      }
    }, {
      key: 'setContent',
      value: function setContent() {
        var $tip = $(this.getTipElement());

        this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());

        $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

        this.cleanupTether();
      }
    }, {
      key: 'setElementContent',
      value: function setElementContent($element, content) {
        var html = this.config.html;
        if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
          // content is a DOM node or a jQuery
          if (html) {
            if (!$(content).parent().is($element)) {
              $element.empty().append(content);
            }
          } else {
            $element.text($(content).text());
          }
        } else {
          $element[html ? 'html' : 'text'](content);
        }
      }
    }, {
      key: 'getTitle',
      value: function getTitle() {
        var title = this.element.getAttribute('data-original-title');

        if (!title) {
          title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
        }

        return title;
      }
    }, {
      key: 'cleanupTether',
      value: function cleanupTether() {
        if (this._tether) {
          this._tether.destroy();
        }
      }

      // private

    }, {
      key: '_getAttachment',
      value: function _getAttachment(placement) {
        return AttachmentMap[placement.toUpperCase()];
      }
    }, {
      key: '_setListeners',
      value: function _setListeners() {
        var _this3 = this;

        var triggers = this.config.trigger.split(' ');

        triggers.forEach(function (trigger) {
          if (trigger === 'click') {
            $(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
              return _this3.toggle(event);
            });
          } else if (trigger !== Trigger.MANUAL) {
            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;

            $(_this3.element).on(eventIn, _this3.config.selector, function (event) {
              return _this3._enter(event);
            }).on(eventOut, _this3.config.selector, function (event) {
              return _this3._leave(event);
            });
          }

          $(_this3.element).closest('.modal').on('hide.bs.modal', function () {
            return _this3.hide();
          });
        });

        if (this.config.selector) {
          this.config = $.extend({}, this.config, {
            trigger: 'manual',
            selector: ''
          });
        } else {
          this._fixTitle();
        }
      }
    }, {
      key: '_fixTitle',
      value: function _fixTitle() {
        var titleType = _typeof(this.element.getAttribute('data-original-title'));
        if (this.element.getAttribute('title') || titleType !== 'string') {
          this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
          this.element.setAttribute('title', '');
        }
      }
    }, {
      key: '_enter',
      value: function _enter(event, context) {
        var dataKey = this.constructor.DATA_KEY;

        context = context || $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
        }

        if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
          context._hoverState = HoverState.SHOW;
          return;
        }

        clearTimeout(context._timeout);

        context._hoverState = HoverState.SHOW;

        if (!context.config.delay || !context.config.delay.show) {
          context.show();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.SHOW) {
            context.show();
          }
        }, context.config.delay.show);
      }
    }, {
      key: '_leave',
      value: function _leave(event, context) {
        var dataKey = this.constructor.DATA_KEY;

        context = context || $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
        }

        if (context._isWithActiveTrigger()) {
          return;
        }

        clearTimeout(context._timeout);

        context._hoverState = HoverState.OUT;

        if (!context.config.delay || !context.config.delay.hide) {
          context.hide();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.OUT) {
            context.hide();
          }
        }, context.config.delay.hide);
      }
    }, {
      key: '_isWithActiveTrigger',
      value: function _isWithActiveTrigger() {
        for (var trigger in this._activeTrigger) {
          if (this._activeTrigger[trigger]) {
            return true;
          }
        }

        return false;
      }
    }, {
      key: '_getConfig',
      value: function _getConfig(config) {
        config = $.extend({}, this.constructor.Default, $(this.element).data(), config);

        if (config.delay && typeof config.delay === 'number') {
          config.delay = {
            show: config.delay,
            hide: config.delay
          };
        }

        _util2.default.typeCheckConfig(NAME, config, this.constructor.DefaultType);

        return config;
      }
    }, {
      key: '_getDelegateConfig',
      value: function _getDelegateConfig() {
        var config = {};

        if (this.config) {
          for (var key in this.config) {
            if (this.constructor.Default[key] !== this.config[key]) {
              config[key] = this.config[key];
            }
          }
        }

        return config;
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var data = $(this).data(DATA_KEY);
          var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

          if (!data && /dispose|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Tooltip(this, _config);
            $(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config]();
          }
        });
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}(jQuery);

exports.default = Tooltip;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * pickadate.js v3.5.6, 2015/04/20
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */

(function ( factory ) {

    // AMD.
    if ( true )
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(137)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

    // Node.js/browserify.
    else if ( typeof exports == 'object' )
        module.exports = factory( require('jquery') )

    // Browser globals.
    else this.Picker = factory( jQuery )

}(function( $ ) {

var $window = $( window )
var $document = $( document )
var $html = $( document.documentElement )
var supportsTransitions = document.documentElement.style.transition != null


/**
 * The picker constructor that creates a blank picker.
 */
function PickerConstructor( ELEMENT, NAME, COMPONENT, OPTIONS ) {

    // If there’s no element, return the picker constructor.
    if ( !ELEMENT ) return PickerConstructor


    var
        IS_DEFAULT_THEME = false,


        // The state of the picker.
        STATE = {
            id: ELEMENT.id || 'P' + Math.abs( ~~(Math.random() * new Date()) )
        },


        // Merge the defaults and options passed.
        SETTINGS = COMPONENT ? $.extend( true, {}, COMPONENT.defaults, OPTIONS ) : OPTIONS || {},


        // Merge the default classes with the settings classes.
        CLASSES = $.extend( {}, PickerConstructor.klasses(), SETTINGS.klass ),


        // The element node wrapper into a jQuery object.
        $ELEMENT = $( ELEMENT ),


        // Pseudo picker constructor.
        PickerInstance = function() {
            return this.start()
        },


        // The picker prototype.
        P = PickerInstance.prototype = {

            constructor: PickerInstance,

            $node: $ELEMENT,


            /**
             * Initialize everything
             */
            start: function() {

                // If it’s already started, do nothing.
                if ( STATE && STATE.start ) return P


                // Update the picker states.
                STATE.methods = {}
                STATE.start = true
                STATE.open = false
                STATE.type = ELEMENT.type


                // Confirm focus state, convert into text input to remove UA stylings,
                // and set as readonly to prevent keyboard popup.
                ELEMENT.autofocus = ELEMENT == getActiveElement()
                ELEMENT.readOnly = !SETTINGS.editable
                ELEMENT.id = ELEMENT.id || STATE.id
                if ( ELEMENT.type != 'text' ) {
                    ELEMENT.type = 'text'
                }


                // Create a new picker component with the settings.
                P.component = new COMPONENT(P, SETTINGS)


                // Create the picker root and then prepare it.
                P.$root = $( '<div class="' + CLASSES.picker + '" id="' + ELEMENT.id + '_root" />' )
                prepareElementRoot()


                // Create the picker holder and then prepare it.
                P.$holder = $( createWrappedComponent() ).appendTo( P.$root )
                prepareElementHolder()


                // If there’s a format for the hidden input element, create the element.
                if ( SETTINGS.formatSubmit ) {
                    prepareElementHidden()
                }


                // Prepare the input element.
                prepareElement()


                // Insert the hidden input as specified in the settings.
                if ( SETTINGS.containerHidden ) $( SETTINGS.containerHidden ).append( P._hidden )
                else $ELEMENT.after( P._hidden )


                // Insert the root as specified in the settings.
                if ( SETTINGS.container ) $( SETTINGS.container ).append( P.$root )
                else $ELEMENT.after( P.$root )


                // Bind the default component and settings events.
                P.on({
                    start: P.component.onStart,
                    render: P.component.onRender,
                    stop: P.component.onStop,
                    open: P.component.onOpen,
                    close: P.component.onClose,
                    set: P.component.onSet
                }).on({
                    start: SETTINGS.onStart,
                    render: SETTINGS.onRender,
                    stop: SETTINGS.onStop,
                    open: SETTINGS.onOpen,
                    close: SETTINGS.onClose,
                    set: SETTINGS.onSet
                })


                // Once we’re all set, check the theme in use.
                IS_DEFAULT_THEME = isUsingDefaultTheme( P.$holder[0] )


                // If the element has autofocus, open the picker.
                if ( ELEMENT.autofocus ) {
                    P.open()
                }


                // Trigger queued the “start” and “render” events.
                return P.trigger( 'start' ).trigger( 'render' )
            }, //start


            /**
             * Render a new picker
             */
            render: function( entireComponent ) {

                // Insert a new component holder in the root or box.
                if ( entireComponent ) {
                    P.$holder = $( createWrappedComponent() )
                    prepareElementHolder()
                    P.$root.html( P.$holder )
                }
                else P.$root.find( '.' + CLASSES.box ).html( P.component.nodes( STATE.open ) )

                // Trigger the queued “render” events.
                return P.trigger( 'render' )
            }, //render


            /**
             * Destroy everything
             */
            stop: function() {

                // If it’s already stopped, do nothing.
                if ( !STATE.start ) return P

                // Then close the picker.
                P.close()

                // Remove the hidden field.
                if ( P._hidden ) {
                    P._hidden.parentNode.removeChild( P._hidden )
                }

                // Remove the root.
                P.$root.remove()

                // Remove the input class, remove the stored data, and unbind
                // the events (after a tick for IE - see `P.close`).
                $ELEMENT.removeClass( CLASSES.input ).removeData( NAME )
                setTimeout( function() {
                    $ELEMENT.off( '.' + STATE.id )
                }, 0)

                // Restore the element state
                ELEMENT.type = STATE.type
                ELEMENT.readOnly = false

                // Trigger the queued “stop” events.
                P.trigger( 'stop' )

                // Reset the picker states.
                STATE.methods = {}
                STATE.start = false

                return P
            }, //stop


            /**
             * Open up the picker
             */
            open: function( dontGiveFocus ) {

                // If it’s already open, do nothing.
                if ( STATE.open ) return P

                // Add the “active” class.
                $ELEMENT.addClass( CLASSES.active )
                aria( ELEMENT, 'expanded', true )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So add the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Add the “opened” class to the picker root.
                    P.$root.addClass( CLASSES.opened )
                    aria( P.$root[0], 'hidden', false )

                }, 0 )

                // If we have to give focus, bind the element and doc events.
                if ( dontGiveFocus !== false ) {

                    // Set it as open.
                    STATE.open = true

                    // Prevent the page from scrolling.
                    if ( IS_DEFAULT_THEME ) {
                        $html.
                            css( 'overflow', 'hidden' ).
                            css( 'padding-right', '+=' + getScrollbarWidth() )
                    }

                    // Pass focus to the root element’s jQuery object.
                    focusPickerOnceOpened()

                    // Bind the document events.
                    $document.on( 'click.' + STATE.id + ' focusin.' + STATE.id, function( event ) {

                        var target = event.target

                        // If the target of the event is not the element, close the picker picker.
                        // * Don’t worry about clicks or focusins on the root because those don’t bubble up.
                        //   Also, for Firefox, a click on an `option` element bubbles up directly
                        //   to the doc. So make sure the target wasn't the doc.
                        // * In Firefox stopPropagation() doesn’t prevent right-click events from bubbling,
                        //   which causes the picker to unexpectedly close when right-clicking it. So make
                        //   sure the event wasn’t a right-click.
                        if ( target != ELEMENT && target != document && event.which != 3 ) {

                            // If the target was the holder that covers the screen,
                            // keep the element focused to maintain tabindex.
                            P.close( target === P.$holder[0] )
                        }

                    }).on( 'keydown.' + STATE.id, function( event ) {

                        var
                            // Get the keycode.
                            keycode = event.keyCode,

                            // Translate that to a selection change.
                            keycodeToMove = P.component.key[ keycode ],

                            // Grab the target.
                            target = event.target


                        // On escape, close the picker and give focus.
                        if ( keycode == 27 ) {
                            P.close( true )
                        }


                        // Check if there is a key movement or “enter” keypress on the element.
                        else if ( target == P.$holder[0] && ( keycodeToMove || keycode == 13 ) ) {

                            // Prevent the default action to stop page movement.
                            event.preventDefault()

                            // Trigger the key movement action.
                            if ( keycodeToMove ) {
                                PickerConstructor._.trigger( P.component.key.go, P, [ PickerConstructor._.trigger( keycodeToMove ) ] )
                            }

                            // On “enter”, if the highlighted item isn’t disabled, set the value and close.
                            else if ( !P.$root.find( '.' + CLASSES.highlighted ).hasClass( CLASSES.disabled ) ) {
                                P.set( 'select', P.component.item.highlight )
                                if ( SETTINGS.closeOnSelect ) {
                                    P.close( true )
                                }
                            }
                        }


                        // If the target is within the root and “enter” is pressed,
                        // prevent the default action and trigger a click on the target instead.
                        else if ( $.contains( P.$root[0], target ) && keycode == 13 ) {
                            event.preventDefault()
                            target.click()
                        }
                    })
                }

                // Trigger the queued “open” events.
                return P.trigger( 'open' )
            }, //open


            /**
             * Close the picker
             */
            close: function( giveFocus ) {

                // If we need to give focus, do it before changing states.
                if ( giveFocus ) {
                    if ( SETTINGS.editable ) {
                        ELEMENT.focus()
                    }
                    else {
                        // ....ah yes! It would’ve been incomplete without a crazy workaround for IE :|
                        // The focus is triggered *after* the close has completed - causing it
                        // to open again. So unbind and rebind the event at the next tick.
                        P.$holder.off( 'focus.toOpen' ).focus()
                        setTimeout( function() {
                            P.$holder.on( 'focus.toOpen', handleFocusToOpenEvent )
                        }, 0 )
                    }
                }

                // Remove the “active” class.
                $ELEMENT.removeClass( CLASSES.active )
                aria( ELEMENT, 'expanded', false )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So remove the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Remove the “opened” and “focused” class from the picker root.
                    P.$root.removeClass( CLASSES.opened + ' ' + CLASSES.focused )
                    aria( P.$root[0], 'hidden', true )

                }, 0 )

                // If it’s already closed, do nothing more.
                if ( !STATE.open ) return P

                // Set it as closed.
                STATE.open = false

                // Allow the page to scroll.
                if ( IS_DEFAULT_THEME ) {
                    $html.
                        css( 'overflow', '' ).
                        css( 'padding-right', '-=' + getScrollbarWidth() )
                }

                // Unbind the document events.
                $document.off( '.' + STATE.id )

                // Trigger the queued “close” events.
                return P.trigger( 'close' )
            }, //close


            /**
             * Clear the values
             */
            clear: function( options ) {
                return P.set( 'clear', null, options )
            }, //clear


            /**
             * Set something
             */
            set: function( thing, value, options ) {

                var thingItem, thingValue,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                // Make sure we have usable options.
                options = thingIsObject && $.isPlainObject( value ) ? value : options || {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = value
                    }

                    // Go through the things of items to set.
                    for ( thingItem in thingObject ) {

                        // Grab the value of the thing.
                        thingValue = thingObject[ thingItem ]

                        // First, if the item exists and there’s a value, set it.
                        if ( thingItem in P.component.item ) {
                            if ( thingValue === undefined ) thingValue = null
                            P.component.set( thingItem, thingValue, options )
                        }

                        // Then, check to update the element value and broadcast a change.
                        if ( thingItem == 'select' || thingItem == 'clear' ) {
                            $ELEMENT.
                                val( thingItem == 'clear' ? '' : P.get( thingItem, SETTINGS.format ) ).
                                trigger( 'change' )
                        }
                    }

                    // Render a new picker.
                    P.render()
                }

                // When the method isn’t muted, trigger queued “set” events and pass the `thingObject`.
                return options.muted ? P : P.trigger( 'set', thingObject )
            }, //set


            /**
             * Get something
             */
            get: function( thing, format ) {

                // Make sure there’s something to get.
                thing = thing || 'value'

                // If a picker state exists, return that.
                if ( STATE[ thing ] != null ) {
                    return STATE[ thing ]
                }

                // Return the submission value, if that.
                if ( thing == 'valueSubmit' ) {
                    if ( P._hidden ) {
                        return P._hidden.value
                    }
                    thing = 'value'
                }

                // Return the value, if that.
                if ( thing == 'value' ) {
                    return ELEMENT.value
                }

                // Check if a component item exists, return that.
                if ( thing in P.component.item ) {
                    if ( typeof format == 'string' ) {
                        var thingValue = P.component.get( thing )
                        return thingValue ?
                            PickerConstructor._.trigger(
                                P.component.formats.toString,
                                P.component,
                                [ format, thingValue ]
                            ) : ''
                    }
                    return P.component.get( thing )
                }
            }, //get



            /**
             * Bind events on the things.
             */
            on: function( thing, method, internal ) {

                var thingName, thingMethod,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = method
                    }

                    // Go through the things to bind to.
                    for ( thingName in thingObject ) {

                        // Grab the method of the thing.
                        thingMethod = thingObject[ thingName ]

                        // If it was an internal binding, prefix it.
                        if ( internal ) {
                            thingName = '_' + thingName
                        }

                        // Make sure the thing methods collection exists.
                        STATE.methods[ thingName ] = STATE.methods[ thingName ] || []

                        // Add the method to the relative method collection.
                        STATE.methods[ thingName ].push( thingMethod )
                    }
                }

                return P
            }, //on



            /**
             * Unbind events on the things.
             */
            off: function() {
                var i, thingName,
                    names = arguments;
                for ( i = 0, namesCount = names.length; i < namesCount; i += 1 ) {
                    thingName = names[i]
                    if ( thingName in STATE.methods ) {
                        delete STATE.methods[thingName]
                    }
                }
                return P
            },


            /**
             * Fire off method events.
             */
            trigger: function( name, data ) {
                var _trigger = function( name ) {
                    var methodList = STATE.methods[ name ]
                    if ( methodList ) {
                        methodList.map( function( method ) {
                            PickerConstructor._.trigger( method, P, [ data ] )
                        })
                    }
                }
                _trigger( '_' + name )
                _trigger( name )
                return P
            } //trigger
        } //PickerInstance.prototype


    /**
     * Wrap the picker holder components together.
     */
    function createWrappedComponent() {

        // Create a picker wrapper holder
        return PickerConstructor._.node( 'div',

            // Create a picker wrapper node
            PickerConstructor._.node( 'div',

                // Create a picker frame
                PickerConstructor._.node( 'div',

                    // Create a picker box node
                    PickerConstructor._.node( 'div',

                        // Create the components nodes.
                        P.component.nodes( STATE.open ),

                        // The picker box class
                        CLASSES.box
                    ),

                    // Picker wrap class
                    CLASSES.wrap
                ),

                // Picker frame class
                CLASSES.frame
            ),

            // Picker holder class
            CLASSES.holder,

            'tabindex="-1"'
        ) //endreturn
    } //createWrappedComponent



    /**
     * Prepare the input element with all bindings.
     */
    function prepareElement() {

        $ELEMENT.

            // Store the picker data by component name.
            data(NAME, P).

            // Add the “input” class name.
            addClass(CLASSES.input).

            // If there’s a `data-value`, update the value of the element.
            val( $ELEMENT.data('value') ?
                P.get('select', SETTINGS.format) :
                ELEMENT.value
            )


        // Only bind keydown events if the element isn’t editable.
        if ( !SETTINGS.editable ) {

            $ELEMENT.

                // On focus/click, open the picker.
                on( 'focus.' + STATE.id + ' click.' + STATE.id, function(event) {
                    event.preventDefault()
                    P.open()
                }).

                // Handle keyboard event based on the picker being opened or not.
                on( 'keydown.' + STATE.id, handleKeydownEvent )
        }


        // Update the aria attributes.
        aria(ELEMENT, {
            haspopup: true,
            expanded: false,
            readonly: false,
            owns: ELEMENT.id + '_root'
        })
    }


    /**
     * Prepare the root picker element with all bindings.
     */
    function prepareElementRoot() {
        aria( P.$root[0], 'hidden', true )
    }


     /**
      * Prepare the holder picker element with all bindings.
      */
    function prepareElementHolder() {

        P.$holder.

            on({

                // For iOS8.
                keydown: handleKeydownEvent,

                'focus.toOpen': handleFocusToOpenEvent,

                blur: function() {
                    // Remove the “target” class.
                    $ELEMENT.removeClass( CLASSES.target )
                },

                // When something within the holder is focused, stop from bubbling
                // to the doc and remove the “focused” state from the root.
                focusin: function( event ) {
                    P.$root.removeClass( CLASSES.focused )
                    event.stopPropagation()
                },

                // When something within the holder is clicked, stop it
                // from bubbling to the doc.
                'mousedown click': function( event ) {

                    var target = event.target

                    // Make sure the target isn’t the root holder so it can bubble up.
                    if ( target != P.$holder[0] ) {

                        event.stopPropagation()

                        // * For mousedown events, cancel the default action in order to
                        //   prevent cases where focus is shifted onto external elements
                        //   when using things like jQuery mobile or MagnificPopup (ref: #249 & #120).
                        //   Also, for Firefox, don’t prevent action on the `option` element.
                        if ( event.type == 'mousedown' && !$( target ).is( 'input, select, textarea, button, option' )) {

                            event.preventDefault()

                            // Re-focus onto the holder so that users can click away
                            // from elements focused within the picker.
                            P.$holder[0].focus()
                        }
                    }
                }

            }).

            // If there’s a click on an actionable element, carry out the actions.
            on( 'click', '[data-pick], [data-nav], [data-clear], [data-close]', function() {

                var $target = $( this ),
                    targetData = $target.data(),
                    targetDisabled = $target.hasClass( CLASSES.navDisabled ) || $target.hasClass( CLASSES.disabled ),

                    // * For IE, non-focusable elements can be active elements as well
                    //   (http://stackoverflow.com/a/2684561).
                    activeElement = getActiveElement()
                    activeElement = activeElement && ( activeElement.type || activeElement.href )

                // If it’s disabled or nothing inside is actively focused, re-focus the element.
                if ( targetDisabled || activeElement && !$.contains( P.$root[0], activeElement ) ) {
                    P.$holder[0].focus()
                }

                // If something is superficially changed, update the `highlight` based on the `nav`.
                if ( !targetDisabled && targetData.nav ) {
                    P.set( 'highlight', P.component.item.highlight, { nav: targetData.nav } )
                }

                // If something is picked, set `select` then close with focus.
                else if ( !targetDisabled && 'pick' in targetData ) {
                    P.set( 'select', targetData.pick )
                    if ( SETTINGS.closeOnSelect ) {
                        P.close( true )
                    }
                }

                // If a “clear” button is pressed, empty the values and close with focus.
                else if ( targetData.clear ) {
                    P.clear()
                    if ( SETTINGS.closeOnClear ) {
                        P.close( true )
                    }
                }

                else if ( targetData.close ) {
                    P.close( true )
                }

            }) //P.$holder

    }


     /**
      * Prepare the hidden input element along with all bindings.
      */
    function prepareElementHidden() {

        var name

        if ( SETTINGS.hiddenName === true ) {
            name = ELEMENT.name
            ELEMENT.name = ''
        }
        else {
            name = [
                typeof SETTINGS.hiddenPrefix == 'string' ? SETTINGS.hiddenPrefix : '',
                typeof SETTINGS.hiddenSuffix == 'string' ? SETTINGS.hiddenSuffix : '_submit'
            ]
            name = name[0] + ELEMENT.name + name[1]
        }

        P._hidden = $(
            '<input ' +
            'type=hidden ' +

            // Create the name using the original input’s with a prefix and suffix.
            'name="' + name + '"' +

            // If the element has a value, set the hidden value as well.
            (
                $ELEMENT.data('value') || ELEMENT.value ?
                    ' value="' + P.get('select', SETTINGS.formatSubmit) + '"' :
                    ''
            ) +
            '>'
        )[0]

        $ELEMENT.

            // If the value changes, update the hidden input with the correct format.
            on('change.' + STATE.id, function() {
                P._hidden.value = ELEMENT.value ?
                    P.get('select', SETTINGS.formatSubmit) :
                    ''
            })
    }


    // Wait for transitions to end before focusing the holder. Otherwise, while
    // using the `container` option, the view jumps to the container.
    function focusPickerOnceOpened() {

        if (IS_DEFAULT_THEME && supportsTransitions) {
            P.$holder.find('.' + CLASSES.frame).one('transitionend', function() {
                P.$holder[0].focus()
            })
        }
        else {
            P.$holder[0].focus()
        }
    }


    function handleFocusToOpenEvent(event) {

        // Stop the event from propagating to the doc.
        event.stopPropagation()

        // Add the “target” class.
        $ELEMENT.addClass( CLASSES.target )

        // Add the “focused” class to the root.
        P.$root.addClass( CLASSES.focused )

        // And then finally open the picker.
        P.open()
    }


    // For iOS8.
    function handleKeydownEvent( event ) {

        var keycode = event.keyCode,

            // Check if one of the delete keys was pressed.
            isKeycodeDelete = /^(8|46)$/.test(keycode)

        // For some reason IE clears the input value on “escape”.
        if ( keycode == 27 ) {
            P.close( true )
            return false
        }

        // Check if `space` or `delete` was pressed or the picker is closed with a key movement.
        if ( keycode == 32 || isKeycodeDelete || !STATE.open && P.component.key[keycode] ) {

            // Prevent it from moving the page and bubbling to doc.
            event.preventDefault()
            event.stopPropagation()

            // If `delete` was pressed, clear the values and close the picker.
            // Otherwise open the picker.
            if ( isKeycodeDelete ) { P.clear().close() }
            else { P.open() }
        }
    }


    // Return a new picker instance.
    return new PickerInstance()
} //PickerConstructor



/**
 * The default classes and prefix to use for the HTML classes.
 */
PickerConstructor.klasses = function( prefix ) {
    prefix = prefix || 'picker'
    return {

        picker: prefix,
        opened: prefix + '--opened',
        focused: prefix + '--focused',

        input: prefix + '__input',
        active: prefix + '__input--active',
        target: prefix + '__input--target',

        holder: prefix + '__holder',

        frame: prefix + '__frame',
        wrap: prefix + '__wrap',

        box: prefix + '__box'
    }
} //PickerConstructor.klasses



/**
 * Check if the default theme is being used.
 */
function isUsingDefaultTheme( element ) {

    var theme,
        prop = 'position'

    // For IE.
    if ( element.currentStyle ) {
        theme = element.currentStyle[prop]
    }

    // For normal browsers.
    else if ( window.getComputedStyle ) {
        theme = getComputedStyle( element )[prop]
    }

    return theme == 'fixed'
}



/**
 * Get the width of the browser’s scrollbar.
 * Taken from: https://github.com/VodkaBears/Remodal/blob/master/src/jquery.remodal.js
 */
function getScrollbarWidth() {

    if ( $html.height() <= $window.height() ) {
        return 0
    }

    var $outer = $( '<div style="visibility:hidden;width:100px" />' ).
        appendTo( 'body' )

    // Get the width without scrollbars.
    var widthWithoutScroll = $outer[0].offsetWidth

    // Force adding scrollbars.
    $outer.css( 'overflow', 'scroll' )

    // Add the inner div.
    var $inner = $( '<div style="width:100%" />' ).appendTo( $outer )

    // Get the width with scrollbars.
    var widthWithScroll = $inner[0].offsetWidth

    // Remove the divs.
    $outer.remove()

    // Return the difference between the widths.
    return widthWithoutScroll - widthWithScroll
}



/**
 * PickerConstructor helper methods.
 */
PickerConstructor._ = {

    /**
     * Create a group of nodes. Expects:
     * `
        {
            min:    {Integer},
            max:    {Integer},
            i:      {Integer},
            node:   {String},
            item:   {Function}
        }
     * `
     */
    group: function( groupObject ) {

        var
            // Scope for the looped object
            loopObjectScope,

            // Create the nodes list
            nodesList = '',

            // The counter starts from the `min`
            counter = PickerConstructor._.trigger( groupObject.min, groupObject )


        // Loop from the `min` to `max`, incrementing by `i`
        for ( ; counter <= PickerConstructor._.trigger( groupObject.max, groupObject, [ counter ] ); counter += groupObject.i ) {

            // Trigger the `item` function within scope of the object
            loopObjectScope = PickerConstructor._.trigger( groupObject.item, groupObject, [ counter ] )

            // Splice the subgroup and create nodes out of the sub nodes
            nodesList += PickerConstructor._.node(
                groupObject.node,
                loopObjectScope[ 0 ],   // the node
                loopObjectScope[ 1 ],   // the classes
                loopObjectScope[ 2 ]    // the attributes
            )
        }

        // Return the list of nodes
        return nodesList
    }, //group


    /**
     * Create a dom node string
     */
    node: function( wrapper, item, klass, attribute ) {

        // If the item is false-y, just return an empty string
        if ( !item ) return ''

        // If the item is an array, do a join
        item = $.isArray( item ) ? item.join( '' ) : item

        // Check for the class
        klass = klass ? ' class="' + klass + '"' : ''

        // Check for any attributes
        attribute = attribute ? ' ' + attribute : ''

        // Return the wrapped item
        return '<' + wrapper + klass + attribute + '>' + item + '</' + wrapper + '>'
    }, //node


    /**
     * Lead numbers below 10 with a zero.
     */
    lead: function( number ) {
        return ( number < 10 ? '0': '' ) + number
    },


    /**
     * Trigger a function otherwise return the value.
     */
    trigger: function( callback, scope, args ) {
        return typeof callback == 'function' ? callback.apply( scope, args || [] ) : callback
    },


    /**
     * If the second character is a digit, length is 2 otherwise 1.
     */
    digits: function( string ) {
        return ( /\d/ ).test( string[ 1 ] ) ? 2 : 1
    },


    /**
     * Tell if something is a date object.
     */
    isDate: function( value ) {
        return {}.toString.call( value ).indexOf( 'Date' ) > -1 && this.isInteger( value.getDate() )
    },


    /**
     * Tell if something is an integer.
     */
    isInteger: function( value ) {
        return {}.toString.call( value ).indexOf( 'Number' ) > -1 && value % 1 === 0
    },


    /**
     * Create ARIA attribute strings.
     */
    ariaAttr: ariaAttr
} //PickerConstructor._



/**
 * Extend the picker with a component and defaults.
 */
PickerConstructor.extend = function( name, Component ) {

    // Extend jQuery.
    $.fn[ name ] = function( options, action ) {

        // Grab the component data.
        var componentData = this.data( name )

        // If the picker is requested, return the data object.
        if ( options == 'picker' ) {
            return componentData
        }

        // If the component data exists and `options` is a string, carry out the action.
        if ( componentData && typeof options == 'string' ) {
            return PickerConstructor._.trigger( componentData[ options ], componentData, [ action ] )
        }

        // Otherwise go through each matched element and if the component
        // doesn’t exist, create a new picker using `this` element
        // and merging the defaults and options with a deep copy.
        return this.each( function() {
            var $this = $( this )
            if ( !$this.data( name ) ) {
                new PickerConstructor( this, name, Component, options )
            }
        })
    }

    // Set the defaults.
    $.fn[ name ].defaults = Component.defaults
} //PickerConstructor.extend



function aria(element, attribute, value) {
    if ( $.isPlainObject(attribute) ) {
        for ( var key in attribute ) {
            ariaSet(element, key, attribute[key])
        }
    }
    else {
        ariaSet(element, attribute, value)
    }
}
function ariaSet(element, attribute, value) {
    element.setAttribute(
        (attribute == 'role' ? '' : 'aria-') + attribute,
        value
    )
}
function ariaAttr(attribute, data) {
    if ( !$.isPlainObject(attribute) ) {
        attribute = { attribute: data }
    }
    data = ''
    for ( var key in attribute ) {
        var attr = (key == 'role' ? '' : 'aria-') + key,
            attrVal = attribute[key]
        data += attrVal == null ? '' : attr + '="' + attribute[key] + '"'
    }
    return data
}

// IE8 bug throws an error for activeElements within iframes.
function getActiveElement() {
    try {
        return document.activeElement
    } catch ( err ) { }
}



// Expose the picker constructor.
return PickerConstructor


}));





/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("items",c,p,1),c,p,0,10,1758,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("checkboxes",c,p,1),c,p,0,27,705,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<span class=\"dropdown-item\">");t.b("\n" + i);t.b("			<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("				<input class=\"custom-control-input ");t.b(t.v(t.f("extraClasses",c,p,0)));t.b("\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" type=\"checkbox\" ");if(t.s(t.f("checked",c,p,1),c,p,0,210,247,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("mixedCheck",c,p,1),c,p,1,0,0,"")){t.b("checked");};});c.pop();}t.b(">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator ");if(t.s(t.f("mixedCheck",c,p,1),c,p,0,318,336,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-js-mixed-check");});c.pop();}t.b("\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b(t.v(t.f("text",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);if(t.s(t.f("itemActions",c,p,1),c,p,0,453,677,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<button type=\"button\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" class=\"btn btn-link sma-hideable-menu sma-dropselect-editable-itemactions sma-js-dropselect-editable-itemactions\">");t.b("\n" + i);t.b("					<i class=\"nc-icon-mini ui-2_menu-dots\"></i>");t.b("\n" + i);t.b("				</button>");t.b("\n" + i);});c.pop();}t.b("		</span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("checkboxes",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("header",c,p,1),c,p,0,751,801,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<h6 class=\"dropdown-header\">");t.b(t.t(t.f("text",c,p,0)));t.b("</h6>");t.b("\n" + i);});c.pop();}if(t.s(t.f("divider",c,p,1),c,p,0,827,870,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"dropdown-divider\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("header",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("divider",c,p,1),c,p,1,0,0,"")){t.b("\n" + i);t.b("\n" + i);t.b("			<a class=\"dropdown-item sma-js-action-item ");if(t.s(t.f("selected",c,p,1),c,p,0,1121,1127,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("active");});c.pop();}t.b("\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" href=\"#\">");t.b("\n" + i);if(t.s(t.f("beforeItem",c,p,1),c,p,0,1187,1261,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("					<div class=\"sma-pre-action-item\">");t.b("\n" + i);t.b("						");t.b(t.v(t.f("pretext",c,p,0)));t.b("\n" + i);t.b("					</div>");t.b("\n" + i);});c.pop();}t.b("				<div class=\"sma-js-action-item-text\">");t.b("\n" + i);t.b("					");t.b(t.t(t.f("text",c,p,0)));t.b("\n" + i);t.b("				</div>");t.b("\n" + i);if(!t.s(t.f("ignoreItemActions",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("itemActions",c,p,1),c,p,0,1394,1647,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("						<button type=\"button\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" class=\"btn btn-link sma-hideable-menu sma-btn-icon-nostyle sma-dropselect-editable-itemactions sma-js-dropselect-editable-itemactions\">");t.b("\n" + i);t.b("							<i class=\"nc-icon-mini ui-2_menu-dots\"></i>");t.b("\n" + i);t.b("						</button>");t.b("\n" + i);});c.pop();}};t.b("			</a>");t.b("\n");t.b("\n" + i);};};};});c.pop();}if(t.s(t.f("extraItems",c,p,1),c,p,0,1784,1994,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<span class=\"dropdown-item sma-js-select-parent\" data-key=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("		<a href=\"#\">");t.b("\n" + i);t.b("			<strong>");t.b(t.t(t.f("name",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("		</a>		");t.b("\n" + i);t.b("		<i class=\"nc-icon-mini arrows-2_small-right sma-condition-arrow\"></i>");t.b("\n" + i);t.b("	</span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("items",c,p,1),c,p,1,0,0,"")){t.b("	<h6 class=\"dropdown-header\">");t.b(t.v(t.d("strings.noItems",c,p,0)));t.b("</h6>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{#items}}\n\t{{#checkboxes}}\n\t\t<span class=\"dropdown-item\">\n\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t<input class=\"custom-control-input {{extraClasses}}\" name=\"{{name}}\" type=\"checkbox\" {{#checked}}{{^mixedCheck}}checked{{/mixedCheck}}{{/checked}}>\n\t\t\t\t<span class=\"custom-control-indicator {{#mixedCheck}}sma-js-mixed-check{{/mixedCheck}}\"></span>\n\t\t\t\t<span class=\"custom-control-description\">{{text}}</span>\n\t\t\t</label>\n\t\t\t{{#itemActions}}\n\t\t\t\t<button type=\"button\" name=\"{{name}}\" class=\"btn btn-link sma-hideable-menu sma-dropselect-editable-itemactions sma-js-dropselect-editable-itemactions\">\n\t\t\t\t\t<i class=\"nc-icon-mini ui-2_menu-dots\"></i>\n\t\t\t\t</button>\n\t\t\t{{/itemActions}}\n\t\t</span>\n\t{{/checkboxes}}\n\t{{^checkboxes}}\n\t\t{{#header}}\n\t\t\t<h6 class=\"dropdown-header\">{{{text}}}</h6>\n\t\t{{/header}}\n\t\t{{#divider}}\n\t\t\t<div class=\"dropdown-divider\"></div>\n\t\t{{/divider}}\n\t\t{{^header}}{{^divider}}\n\n\t\t{{!this span cannot be here because it messes everything up, don't add it unless you fix EVERY DROPSELECT}}\n\t\t{{!<span class=\"sma-menu-container\">}}\n\n\t\t\t<a class=\"dropdown-item sma-js-action-item {{#selected}}active{{/selected}}\" name=\"{{name}}\" href=\"#\">\n\t\t\t\t{{#beforeItem}}\n\t\t\t\t\t<div class=\"sma-pre-action-item\">\n\t\t\t\t\t\t{{pretext}}\n\t\t\t\t\t</div>\n\t\t\t\t{{/beforeItem}}\n\t\t\t\t<div class=\"sma-js-action-item-text\">\n\t\t\t\t\t{{{text}}}\n\t\t\t\t</div>\n\t\t\t\t{{^ignoreItemActions}}\n\t\t\t\t\t{{#itemActions}}\n\t\t\t\t\t\t<button type=\"button\" name=\"{{name}}\" class=\"btn btn-link sma-hideable-menu sma-btn-icon-nostyle sma-dropselect-editable-itemactions sma-js-dropselect-editable-itemactions\">\n\t\t\t\t\t\t\t<i class=\"nc-icon-mini ui-2_menu-dots\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t{{/itemActions}}\n\t\t\t\t{{/ignoreItemActions}}\n\t\t\t</a>\n\n\t\t{{!</span>}}\n\t\t{{/divider}}{{/header}}\n\t{{/checkboxes}}\n{{/items}}\n{{#extraItems}}\n\t<span class=\"dropdown-item sma-js-select-parent\" data-key=\"{{ id }}\">\n\t\t<a href=\"#\">\n\t\t\t<strong>{{{ name }}}</strong>\n\t\t</a>\t\t\n\t\t<i class=\"nc-icon-mini arrows-2_small-right sma-condition-arrow\"></i>\n\t</span>\n{{/extraItems}}\n{{^items}}\n\t<h6 class=\"dropdown-header\">{{strings.noItems}}</h6>\n{{/items}}\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("active",c,p,1),c,p,0,11,280,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<a class=\"dropdown-item sma-js-dropselect-group active\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" href=\"#\">");t.b(t.v(t.f("text",c,p,0)));t.b("\n" + i);t.b("		<span class=\"sma-dropselect-selectedamount float-sm-right\">");if(!t.s(t.f("noCount",c,p,1),c,p,1,0,0,"")){t.b(t.v(t.f("itemCount",c,p,0)));};t.b("\n" + i);t.b("			<i class=\"nc-icon-mini arrows-1_small-triangle-right\"></i>");t.b("\n" + i);t.b("		</span>");t.b("\n" + i);t.b("	</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("active",c,p,1),c,p,1,0,0,"")){t.b("	<a class=\"dropdown-item sma-js-dropselect-group\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" href=\"#\">");t.b(t.v(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);};return t.fl(); },partials: {}, subs: {  }}, "{{#active}}\n\t<a class=\"dropdown-item sma-js-dropselect-group active\" name=\"{{name}}\" href=\"#\">{{text}}\n\t\t<span class=\"sma-dropselect-selectedamount float-sm-right\">{{^noCount}}{{itemCount}}{{/noCount}}\n\t\t\t<i class=\"nc-icon-mini arrows-1_small-triangle-right\"></i>\n\t\t</span>\n\t</a>\n{{/active}}\n{{^active}}\n\t<a class=\"dropdown-item sma-js-dropselect-group\" name=\"{{name}}\" href=\"#\">{{text}}</a>\n{{/active}}\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 900 */,
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var baseCalloutTempl = __webpack_require__(1605);

var Callout = function () {
	function Callout(options) {
		_classCallCheck(this, Callout);

		this.attachTo = options.attachTo;
		this.content = options.content || '';
		this.callout_class = options.callout_class || 'callout-warning';
		this.callout_close = 'callout_close' in options ? options.callout_close : false;

		this.build();
	}

	_createClass(Callout, [{
		key: 'build',
		value: function build() {
			this.element = $(baseCalloutTempl({
				content: this.content,
				callout_class: this.callout_class,
				callout_close: this.callout_close
			}));

			this.attachTo.append(this.element);
			$('.callout a.close').click(function (e) {
				$(e.currentTarget).parents('.callout').remove();
			});
		}
	}]);

	return Callout;
}();

exports.default = Callout;

/***/ }),
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropSelect = __webpack_require__(114);

var groupTempl = __webpack_require__(899);

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */

var DropSelectDrilldown = function (_DropSelect) {
	_inherits(DropSelectDrilldown, _DropSelect);

	function DropSelectDrilldown() {
		_classCallCheck(this, DropSelectDrilldown);

		return _possibleConstructorReturn(this, (DropSelectDrilldown.__proto__ || Object.getPrototypeOf(DropSelectDrilldown)).apply(this, arguments));
	}

	_createClass(DropSelectDrilldown, [{
		key: 'initialize',
		value: function initialize(options) {
			this.selectedGroupIndex = 0;
			this.drilldown = true;

			if (options.changeGroupCallback) {
				this.changeGroupCallback = options.changeGroupCallback;
			}

			if (options.itemSelectDone) {
				this.itemSelectDone = options.itemSelectDone;
			}

			_get(DropSelectDrilldown.prototype.__proto__ || Object.getPrototypeOf(DropSelectDrilldown.prototype), 'initialize', this).call(this, options);
		}
	}, {
		key: 'renderContents',
		value: function renderContents() {
			this.renderGroups();
			this.renderItems();
		}
	}, {
		key: 'renderGroups',
		value: function renderGroups() {
			var _this2 = this;

			this.$groups = this.$el.find('.sma-dropselect-sections');
			this.$groups.empty();
			this.groups.forEach(function (group) {
				_this2.$groups.append(groupTempl(group));
			});
			this.activateSelectedGroup();
		}
	}, {
		key: 'changeGroupEvent',
		value: function changeGroupEvent(e) {
			var groupName = $(e.target).prop('name');
			this.updateChangedItems();
			this.changeGroup(groupName);

			return false;
		}
	}, {
		key: 'changeGroup',
		value: function changeGroup(groupName) {
			this.deactivateCurrentGroup();
			this.selectedGroupIndex = _.findIndex(this.changedItems, function (item) {
				return item.name === groupName;
			});
			this.activateSelectedGroup(this.selectedGroupIndex);
			this.changeGroupCallback(this.selectedGroupIndex);
		}
	}, {
		key: 'changeGroupCallback',
		value: function changeGroupCallback(selectedGroupIndex) {
			return;
		}
	}, {
		key: 'deactivateCurrentGroup',
		value: function deactivateCurrentGroup() {
			var group = this.changedItems[this.selectedGroupIndex];

			this.$groups.find('[name="' + group.name + '"]').replaceWith(groupTempl({
				text: group.text,
				name: group.name
			}));
		}
	}, {
		key: 'activateSelectedGroup',
		value: function activateSelectedGroup() {

			var group = this.changedItems[this.selectedGroupIndex];
			this.$groups.find('[name="' + group.name + '"]').replaceWith(groupTempl({
				text: group.text,
				name: group.name,
				itemCount: group.items.length,
				active: true,
				noCount: this.noCount || false
			}));

			this.renderItems();
		}
	}, {
		key: 'visibleItems',
		value: function visibleItems() {
			return this.changedItems[this.selectedGroupIndex].items;
		}
	}, {
		key: 'updateChangedItems',
		value: function updateChangedItems() {
			this.changedItems[this.selectedGroupIndex].items = this.displayedItems;
		}
	}, {
		key: 'events',
		get: function get() {
			var events = _get(DropSelectDrilldown.prototype.__proto__ || Object.getPrototypeOf(DropSelectDrilldown.prototype), 'events', this);

			events['click .sma-js-dropselect-group'] = 'changeGroupEvent';

			return events;
		}
	}, {
		key: 'groups',
		get: function get() {
			return this.changedItems;
		}
	}]);

	return DropSelectDrilldown;
}(DropSelect);

module.exports = DropSelectDrilldown;

/***/ }),
/* 908 */,
/* 909 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(1759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1764);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12), __webpack_require__(314)(module)))

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(1783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem__ = __webpack_require__(922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ListItem__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var ListItem = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? "" : _b, _c = _a.addOn, addOn = _c === void 0 ? null : _c, _d = _a.addOnDirection, addOnDirection = _d === void 0 ? null : _d, _e = _a.interactive, interactive = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? "" : _g, _h = _a.affordance, affordance = _h === void 0 ? null : _h, _j = _a.expandedComponent, expandedComponent = _j === void 0 ? null : _j, _k = _a.marked, marked = _k === void 0 ? false : _k, _l = _a.upgrade, upgrade = _l === void 0 ? false : _l, _m = _a.id, id = _m === void 0 ? "" : _m, _o = _a.index, index = _o === void 0 ? null : _o, _p = _a.isNavigable, isNavigable = _p === void 0 ? false : _p, _q = _a.navigationTarget, navigationTarget = _q === void 0 ? "javascript:void(0)" : _q, other = __rest(_a, ["children", "color", "addOn", "addOnDirection", "interactive", "disabled", "className", "affordance", "expandedComponent", "marked", "upgrade", "id", "index", "isNavigable", "navigationTarget"]);
    var _r;
    var ListItemWrapper = "section";
    var outerClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-list__row", className);
    var interClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-list__item", (_r = {}, _r["wds-list__item--marked-" + color] = !!color, _r), { "wds-list__item--marked": marked }, { "wds-list__item--disabled": disabled }, { "wds-list__item--upgrade": upgrade });
    var getProps = function () {
        var props = {};
        if (interactive) {
            props.tabIndex = disabled ? "-1" : 0;
            props.role = "button";
        }
        if (isNavigable) {
            props.href = navigationTarget;
        }
        return props;
    };
    var renderLabel = function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-list__label" }, children); };
    var renderAddOn = function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-list__addon" }, addOn); };
    if (isNavigable) {
        ListItemWrapper = "a";
    }
    var direction = addOnDirection;
    if (addOn && !addOnDirection) {
        direction = "left";
    }
    if (addOnDirection && !addOn) {
        throw new Error("You must supply an addOn component with an addonDirection");
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: outerClassNames },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItemWrapper, __assign({ className: interClassNames, id: id, "data-index": index }, getProps(), other),
            direction === "left" && renderAddOn(),
            renderLabel(),
            direction === "right" && renderAddOn(),
            affordance && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-list__affordance" }, affordance))),
        expandedComponent && expandedComponent));
};
/* harmony default export */ __webpack_exports__["a"] = (ListItem);
//# sourceMappingURL=ListItem.js.map

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var MenuGroup = function (_a) {
    var children = _a.children;
    return (
    // TODO require children to be List
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "wds-menu__group" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (MenuGroup);
//# sourceMappingURL=MenuGroup.js.map

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metaMap_js__ = __webpack_require__(926);



/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !__WEBPACK_IMPORTED_MODULE_1__metaMap_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */] : function(func, data) {
  __WEBPACK_IMPORTED_MODULE_1__metaMap_js__["a" /* default */].set(func, data);
  return func;
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetData);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__ = __webpack_require__(927);


/** Used to store function metadata. */
var metaMap = __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__["a" /* default */] && new __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (metaMap);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(930);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgs);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgsRight);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isLaziable_js__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setData_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setWrapToString_js__ = __webpack_require__(940);




/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isLaziable_js__["a" /* default */])(func)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__setData_js__["a" /* default */])(result, newData);
  }
  result.placeholder = placeholder;
  return Object(__WEBPACK_IMPORTED_MODULE_2__setWrapToString_js__["a" /* default */])(result, func, bitmask);
}

/* harmony default export */ __webpack_exports__["a"] = (createRecurry);


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getData_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFuncName_js__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__ = __webpack_require__(171);





/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = Object(__WEBPACK_IMPORTED_MODULE_2__getFuncName_js__["a" /* default */])(func),
      other = __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__["a" /* default */][funcName];

  if (typeof other != 'function' || !(funcName in __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */].prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = Object(__WEBPACK_IMPORTED_MODULE_1__getData_js__["a" /* default */])(other);
  return !!data && func === data[0];
}

/* harmony default export */ __webpack_exports__["a"] = (isLaziable);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__realNames_js__ = __webpack_require__(936);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = __WEBPACK_IMPORTED_MODULE_0__realNames_js__["a" /* default */][result],
      length = hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_0__realNames_js__["a" /* default */], result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getFuncName);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to lookup unminified function names. */
var realNames = {};

/* harmony default export */ __webpack_exports__["a"] = (realNames);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__copyArray_js__ = __webpack_require__(83);




/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */]) {
    return wrapper.clone();
  }
  var result = new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = Object(__WEBPACK_IMPORTED_MODULE_2__copyArray_js__["a" /* default */])(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperClone);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(939);



/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetData_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setData);


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWrapDetails_js__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__insertWrapDetails_js__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updateWrapDetails_js__ = __webpack_require__(1830);





/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(wrapper, Object(__WEBPACK_IMPORTED_MODULE_1__insertWrapDetails_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_3__updateWrapDetails_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__getWrapDetails_js__["a" /* default */])(source), bitmask)));
}

/* harmony default export */ __webpack_exports__["a"] = (setWrapToString);


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(143);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1840);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castSlice_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToArray_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(25);





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);

    var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__stringToArray_js__["a" /* default */])(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? Object(__WEBPACK_IMPORTED_MODULE_0__castSlice_js__["a" /* default */])(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCaseFirst);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssign);


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(314)(module)))

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(252);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(41);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(14);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(46);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(496);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(246);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(960);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(342);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(36);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(106);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(106);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseConformsTo);


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(48);


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseEach);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(69);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/* harmony default export */ __webpack_exports__["a"] = (baseDelay);


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwnRight_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__ = __webpack_require__(965);



/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = Object(__WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseForOwnRight_js__["a" /* default */], true);

/* harmony default export */ __webpack_exports__["a"] = (baseEachRight);


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(964);


/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])(true);

/* harmony default export */ __webpack_exports__["a"] = (baseForRight);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToPairs_js__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapToArray_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setToPairs_js__ = __webpack_require__(1896);





/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(object);
    if (tag == mapTag) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__mapToArray_js__["a" /* default */])(object);
    }
    if (tag == setTag) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__setToPairs_js__["a" /* default */])(object);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseToPairs_js__["a" /* default */])(object, keysFunc(object));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createToPairs);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEvery);


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(149);


/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFilter);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(41);




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection)) {
      var iteratee = Object(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3);
      collection = Object(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createFind);


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindKey);


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(48);



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? Array(collection.length) : [];

  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseMap);


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getData_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getFuncName_js__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isLaziable_js__ = __webpack_require__(934);







/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = __WEBPACK_IMPORTED_MODULE_0__LodashWrapper_js__["a" /* default */].prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && Object(__WEBPACK_IMPORTED_MODULE_3__getFuncName_js__["a" /* default */])(func) == 'wrapper') {
        var wrapper = new __WEBPACK_IMPORTED_MODULE_0__LodashWrapper_js__["a" /* default */]([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = Object(__WEBPACK_IMPORTED_MODULE_3__getFuncName_js__["a" /* default */])(func),
          data = funcName == 'wrapper' ? Object(__WEBPACK_IMPORTED_MODULE_2__getData_js__["a" /* default */])(func) : undefined;

      if (data && Object(__WEBPACK_IMPORTED_MODULE_5__isLaziable_js__["a" /* default */])(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[Object(__WEBPACK_IMPORTED_MODULE_3__getFuncName_js__["a" /* default */])(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && Object(__WEBPACK_IMPORTED_MODULE_5__isLaziable_js__["a" /* default */])(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && Object(__WEBPACK_IMPORTED_MODULE_4__isArray_js__["a" /* default */])(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createFlow);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInverter_js__ = __webpack_require__(1902);


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseInverter_js__["a" /* default */])(object, setter, toIteratee(iteratee), {});
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createInverter);


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSlice_js__ = __webpack_require__(95);



/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__baseSlice_js__["a" /* default */])(path, 0, -1));
}

/* harmony default export */ __webpack_exports__["a"] = (parent);


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSum_js__ = __webpack_require__(617);


/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? (Object(__WEBPACK_IMPORTED_MODULE_0__baseSum_js__["a" /* default */])(array, iteratee) / length) : NAN;
}

/* harmony default export */ __webpack_exports__["a"] = (baseMean);


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isIndex_js__ = __webpack_require__(119);


/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isIndex_js__["a" /* default */])(n, length) ? array[n] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseNth);


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSet_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castPath_js__ = __webpack_require__(144);




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);

    if (predicate(value, path)) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseSet_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__castPath_js__["a" /* default */])(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (basePickBy);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseMap_js__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseSortBy_js__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__compareMultiple_js__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity_js__ = __webpack_require__(47);








/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(iteratees.length ? iteratees : [__WEBPACK_IMPORTED_MODULE_6__identity_js__["a" /* default */]], Object(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */]));

  var result = Object(__WEBPACK_IMPORTED_MODULE_2__baseMap_js__["a" /* default */])(collection, function(value, key, collection) {
    var criteria = Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return Object(__WEBPACK_IMPORTED_MODULE_3__baseSortBy_js__["a" /* default */])(result, function(object, other) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__compareMultiple_js__["a" /* default */])(object, other, orders);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseOrderBy);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(68);


/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/* harmony default export */ __webpack_exports__["a"] = (compareAscending);


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseRepeat);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUnset_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIndex_js__ = __webpack_require__(119);



/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (Object(__WEBPACK_IMPORTED_MODULE_1__isIndex_js__["a" /* default */])(index)) {
        splice.call(array, index, 1);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_0__baseUnset_js__["a" /* default */])(array, index);
      }
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (basePullAt);


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRange_js__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toFinite_js__ = __webpack_require__(169);




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = Object(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = Object(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : Object(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(step);
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseRange_js__["a" /* default */])(start, end, step, fromRight);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createRange);


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseReduce);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRandom_js__ = __webpack_require__(652);


/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[Object(__WEBPACK_IMPORTED_MODULE_0__baseRandom_js__["a" /* default */])(0, length - 1)] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySample);


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(69);


/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSortedUniq);


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/* harmony default export */ __webpack_exports__["a"] = (reInterpolate);


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayReduce_js__ = __webpack_require__(486);




/**
 * The base implementation of `wrapperValue` which returns the result of
 * performing a sequence of actions on the unwrapped `value`, where each
 * successive action is supplied the return value of the previous.
 *
 * @private
 * @param {*} value The unwrapped value.
 * @param {Array} actions Actions to perform to resolve the unwrapped value.
 * @returns {*} Returns the resolved value.
 */
function baseWrapperValue(value, actions) {
  var result = value;
  if (result instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */]) {
    result = result.value();
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__arrayReduce_js__["a" /* default */])(actions, function(result, action) {
    return action.func.apply(action.thisArg, Object(__WEBPACK_IMPORTED_MODULE_1__arrayPush_js__["a" /* default */])([result], action.args));
  }, result);
}

/* harmony default export */ __webpack_exports__["a"] = (baseWrapperValue);


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(201);


/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (charsEndIndex);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(201);


/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (charsStartIndex);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSet_js__ = __webpack_require__(257);



/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__baseSet_js__["a" /* default */])(object, path, updater(Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path)), customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (baseUpdate);


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseZipObject);


/***/ }),
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _PredicateTypes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PredicateTypes = (_PredicateTypes = {
	// RR types
	'id': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }],
	'text': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }],
	'string_extra': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }],
	'datasource': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }],
	'boolean': [{ type: 'noop', value: 'yes', label: gettext('Value is true') }, { type: 'noop', value: 'no', label: gettext('Value is false') }],
	'rankedby': [{ type: 'choice', value: 'yes', label: gettext('Value is true for') }, { type: 'choice', value: 'no', label: gettext('Value is not true for') }],
	'task': [{ type: 'noop', value: 'yes', label: gettext('Value is complete') }, { type: 'noop', value: 'no', label: gettext('Value is not complete') }],
	'select': [{ type: 'choice', value: 'equals', label: gettext('Value is exactly') }, { type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of') }, { type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of') }],
	'text_choice': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }, { type: 'choice', value: 'equals_var', label: gettext('Value equals custom field') }, { type: 'choice', value: 'contains_var', label: gettext('Value contains custom field') }],
	'smarttext': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }, { type: 'choice', value: 'equals_reviewer_information', label: gettext('Value equals reviewer information') }],
	'datecreated': [{ type: 'datetime', value: 'before', label: gettext('Date is before') }, { type: 'datetime', value: 'after', label: gettext('Date is after') }, { type: 'datetime', value: 'equals', label: gettext('Date is exactly') }],
	'responseedited': [{ type: 'datetime', value: 'before', label: gettext('Date is before') }, { type: 'datetime', value: 'after', label: gettext('Date is after') }, { type: 'datetime', value: 'equals', label: gettext('Date is exactly') }],
	'team_metadata': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }, { type: 'choice', value: 'award_property', label: gettext('Value equals award property') }],

	'categories': [{ type: 'noop', value: 'nocategory', label: gettext('Value has no category') }, { type: 'noop', value: 'hascategory', label: gettext('Value has a category') }, { type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of') }, { type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of') }, { type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly') }],

	'money': [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'greaterthan', label: gettext('Value is greater than') }, { type: 'text', value: 'lessthan', label: gettext('Value is less than') }],

	// FS types
	'string': [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }, { type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'notequals', label: gettext('Value is not') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }, { type: 'text', value: 'greaterthan', label: gettext('Value is greater than') }, { type: 'text', value: 'lessthan', label: gettext('Value is less than') }],
	'single': [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }, { type: 'choice', value: 'equals', label: gettext('Value is exactly') }, { type: 'choice', value: 'notequals', label: gettext('Value is not') }, { type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of') }, { type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of') }],
	'multi': [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }, { type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of') }, { type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of') }, { type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly') }, { type: 'multiplechoice', value: 'notequals', label: gettext('Value is not') }],
	'checkbox': [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }, { type: 'noop', value: 'yes', label: gettext('Value was checked') }, { type: 'noop', value: 'no', label: gettext('Value was not checked') }],
	'datetime': [{ type: 'noop', value: 'noresponse', label: gettext('Date has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Date has a response') }, { type: 'datetime', value: 'before', label: gettext('Date is before') }, { type: 'datetime', value: 'after', label: gettext('Date is after') }, { type: 'datetime', value: 'equals', label: gettext('Date is exactly') }],
	'hidden': [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }, { type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'notequals', label: gettext('Value is not') }, { type: 'text', value: 'contains', label: gettext('Value contains ') }, { type: 'text', value: 'greaterthan', label: gettext('Value is greater than') }, { type: 'text', value: 'lessthan', label: gettext('Value is less than') }],

	//SMAPPLY CLEANED UP TYPES THAT SUPPORT MULTITYPE-TYPES
	'date': [{ type: 'datetime', value: 'before', label: gettext('Date is before') }, { type: 'datetime', value: 'after', label: gettext('Date is after') }, { type: 'datetime', value: 'equals', label: gettext('Date is exactly') }, { type: 'datetime', value: 'notequals', label: gettext('Date is not') }],
	'list': [{ type: 'choice', value: 'equals', label: gettext('Value is exactly') }, { type: 'choice', value: 'notequals', label: gettext('Value is not') }, { type: 'multiplechoice', value: 'isoneof', label: gettext('Value is one of') }, { type: 'multiplechoice', value: 'notisoneof', label: gettext('Value is not any of') }]
}, _defineProperty(_PredicateTypes, 'text', [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'notequals', label: gettext('Value is not') }, { type: 'text', value: 'contains', label: gettext('Value contains') }, { type: 'text', value: 'doesnotcontain', label: gettext('Value does not contain') }]), _defineProperty(_PredicateTypes, 'number', [{ type: 'text', value: 'equals', label: gettext('Value is exactly') }, { type: 'text', value: 'notequals', label: gettext('Value is not') }, { type: 'text', value: 'greaterthan', label: gettext('Value is greater than') }, { type: 'text', value: 'lessthan', label: gettext('Value is less than') }]), _defineProperty(_PredicateTypes, 'response', [{ type: 'noop', value: 'noresponse', label: gettext('Value has no response') }, { type: 'noop', value: 'hasresponse', label: gettext('Value has a response') }]), _defineProperty(_PredicateTypes, 'multilist', [{ type: 'multiplechoice', value: 'containsoneof', label: gettext('Value contains one of') }, { type: 'multiplechoice', value: 'notcontainsoneof', label: gettext('Value does not contain any of') }, { type: 'multiplechoice', value: 'equals', label: gettext('Value is exactly') }, { type: 'multiplechoice', value: 'notequals', label: gettext('Value is not') }]), _defineProperty(_PredicateTypes, 'booleanlist', [{ type: 'choice', value: 'yes', label: gettext("Is true") }, { type: 'choice', value: 'no', label: gettext("Is false") }]), _defineProperty(_PredicateTypes, 'number_and_multilist', [{ type: 'value_and_multi', value: 'equals', label: gettext('Value is exactly') }, { type: 'value_and_multi', value: 'notequals', label: gettext('Value is not') }, { type: 'value_and_multi', value: 'greaterthan', label: gettext('Value is greater than') }, { type: 'value_and_multi', value: 'lessthan', label: gettext('Value is less than') }]), _defineProperty(_PredicateTypes, 'status_and_payment', [{ type: 'choice_and_choice', value: 'equals', label: gettext('Value is exactly') }, { type: 'choice_and_choice', value: 'notequals', label: gettext('Value is not') }, { type: 'multi_and_choice', value: 'isoneof', label: gettext('Value is one of') }, { type: 'multi_and_choice', value: 'notisoneof', label: gettext('Value is not any of') }]), _defineProperty(_PredicateTypes, 'file', [{ type: 'noop', value: 'nofile', label: gettext('Does not have a file uploaded') }, { type: 'noop', value: 'hasfile', label: gettext('Has a file uploaded') }]), _defineProperty(_PredicateTypes, 'sma-file-upload', [{ type: 'noop', value: 'nofile', label: gettext('Does not have a file uploaded') }, { type: 'noop', value: 'hasfile', label: gettext('Has a file uploaded') }]), _defineProperty(_PredicateTypes, 'team_and_stage', [{ type: 'team_and_stage', value: 'equals', label: gettext('equals') }]), _defineProperty(_PredicateTypes, 'select_programs', [{ type: 'multi_with_search', value: 'isoneof', label: gettext('Selected program(s)') }, { type: 'noop', value: 'anyprogram', label: gettext('Any program') }]), _PredicateTypes);

module.exports = PredicateTypes;

/***/ }),
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toggleSwitchTemplate = __webpack_require__(2226);
var DatePicker = __webpack_require__(35);

var ToggleField = Backbone.View.extend({
	events: {
		'change .sma-js-slide-toggle-checkbox': 'clickToggle'
	},

	States: {
		TOGGLE_OFF: 0,
		TOGGLE_ON: 1
	},

	initialize: function initialize(config) {
		this.setElement(config.element[0]);

		this.$parent = this.$el.parents('fieldset:first');
		this.$inputs = this.$parent.find('input,select,textarea').not('input[type="checkbox"],.sma-js-slide-toggle-checkbox');

		this.build();

		this.determineState();
	},

	build: function build() {
		if (this.$el.find('.sma-js-slide-toggle-checkbox:first').length > 0) {
			this.$toggler = this.$parent.find('.sma-js-slide-toggle-checkbox:first');
			return;
		}

		var label = this.$el.data('label') ? this.$el.data('label') : '';

		this.$el.append($(toggleSwitchTemplate({
			id: this.$inputs.eq(0).attr('id'),
			label: label
		})));

		this.$toggler = this.$parent.find('.sma-js-slide-toggle-checkbox:first');
	},

	clickToggle: function clickToggle(e) {
		e.preventDefault();

		if (this.state === this.States.TOGGLE_OFF) {
			this.state = this.States.TOGGLE_ON;
		} else {
			this.state = this.States.TOGGLE_OFF;
			this.toggleOff();
		}

		this.update();
	},

	toggleOff: function toggleOff() {
		this.$inputs.not(':button, :submit, :reset, :hidden, .sma-js-slide-toggle-checkbox').val('').removeAttr('checked').removeAttr('selected');
	},

	determineState: function determineState() {
		var _this = this;

		this.state = this.States.TOGGLE_OFF;

		this.$inputs.each(function (i, input) {
			var input_val = input.val();

			if (input_val !== null && input_val.hasOwnProperty('length') && input_val.length > 0 && input_val !== '' && input_val !== '-1') {
				_this.state = _this.States.TOGGLE_ON;
				return false;
			}
		});

		this.update();
	},

	update: function update() {
		if (this.state === this.States.TOGGLE_ON) {
			this.$toggler.attr('checked', 'checked');
			this.$parent.find('.sma-js-toggle-content').show();
		} else {
			this.$toggler.removeAttr('checked');
			this.$parent.find('.sma-js-toggle-content').hide();
		}
	}
});

var LockedInput = Backbone.View.extend({
	events: {
		'click .sma-js-confirm-lock': 'confirm',
		'click .sma-js-edit-lock': 'edit'
	},

	States: {
		LOCKED: 0,
		EDITING: 1
	},

	initialize: function initialize(config) {
		this.setElement(config.element[0]);

		this.$edit_button = this.$el.find('.sma-js-edit-lock');
		this.$confirm_button = this.$el.find('.sma-js-confirm-lock');
		this.$input = this.$el.find('input:first');

		this.state = this.States.LOCKED;
		this.update();
	},

	update: function update() {
		if (this.state === this.States.LOCKED) {
			this.setLocked();
		} else if (this.state === this.States.EDITING) {
			this.setEditable();
		}
	},

	setLocked: function setLocked() {
		this.$input.addClass('disabled');
		this.$input.attr('readonly', 'readonly');
		this.$confirm_button.hide();
		this.$edit_button.show();
	},

	setEditable: function setEditable() {
		this.$input.removeClass('disabled');
		this.$input.removeAttr('readonly');
		this.$edit_button.hide();
		this.$confirm_button.show();
	},

	edit: function edit(e) {
		e.preventDefault();

		this.state = this.States.EDITING;
		this.update();
	},

	confirm: function confirm(e) {
		e.preventDefault();

		this.state = this.States.LOCKED;
		this.update();
	}
});

//When using SectionedForm and FormSections with nested forms
// this is handy to show a form based on another fields current
// value
var FormToggler = Backbone.View.extend({
	initialize: function initialize(config) {
		//When the elements affected don't exist in the DOM yet
		//   this needs to be passed in to be bound on
		this.parentElement = config.parentElement || $('body');
		this.setElement(config.element[0]);
		this.$input = config.input;

		var affects = this.$el.attr('data-form-toggler').split(',');

		this.affectMap = {};

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = affects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var affect = _step.value;

				var affectEl = this.parentElement.find(affect);

				var val = affectEl.attr('data-selector-val');

				this.affectMap[val] = affectEl;
				affectEl.hide();
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		this.$input.on('change', $.proxy(this.update, this));
		this.update();
	},

	update: function update(e) {
		var val = this.$input.val();

		for (var k in this.affectMap) {
			if (k == val) {
				this.affectMap[k].show();
			} else {
				this.affectMap[k].hide();
			}
		}
	}
});

/*
For radio buttons and checkboxes despite name.
Checkbox usage is simple
element - the div to be shown and hidden
data-when-checked - the checkbox or radio(use input[name='group name']) to monitor
when using radio buttons make sure it also has
data-check-for-value set to the value of the radio button you want to make show the div
*/
var WhenChecked = Backbone.View.extend({
	initialize: function initialize(config) {
		//When the elements affected don't exist in the DOM yet
		//   this needs to be passed in to be bound on

		this.setElement(config.element[0]);

		this.parentElement = config.parentElement || $('body');

		if (this.$el.attr('data-from-parent') !== undefined) {
			this.parentElement = this.$el.parents(this.$el.attr('data-from-parent'));
		}

		var $input = this.parentElement.find(this.$el.attr('data-when-checked'));

		this.isSelect = $input.length ? $input[0].tagName.toLowerCase() == 'select' : false;

		this.parentElement.on('change', this.$el.attr('data-when-checked'), $.proxy(this.inputChanged, this));

		this.inputChanged();
	},

	inputChanged: function inputChanged(e) {
		var $input = this.parentElement.find(this.$el.attr('data-when-checked'));
		var isChecked = false;
		var action = this.$el.attr('data-action') || 'show';
		var $target = this.$el;
		var targetSelector = this.$el.attr('data-target');

		if (targetSelector) {
			$target = $(targetSelector);
		}

		if (this.isSelect) {
			if ($input.val() == this.$el.attr('data-check-for-value')) {
				isChecked = true;
			}
		} else if ($input.length > 1) {
			for (var i = 0; i < $input.length; i++) {
				if ($input.eq(i).attr('value') == this.$el.attr('data-check-for-value') && $input.eq(i).is(':checked')) {
					isChecked = true;
					break;
				}
			}
		} else {
			isChecked = $input.is(':checked');
			var checkForValue = this.$el.attr('data-check-for-value');

			if (checkForValue != undefined) {
				checkForValue = checkForValue == 'true';
				isChecked = isChecked == checkForValue;
			}
		}

		if (action === 'show') {
			if (isChecked) $target.show();else $target.hide();
		} else if (action === 'disable') {
			if (isChecked) $target.prop('disabled', true);else $target.prop('disabled', false);
		}
	}
});

var initWhenChecked = function initWhenChecked() {
	$('.sma-js-toggled-by-checkbox').each(function () {
		new sma.components.Forms.WhenChecked({
			element: $(this)
		});
	});
};

var datePickerInit = function datePickerInit() {
	$('.sma-js-date-picker').each(function () {
		new DatePicker($(this));
	});
};

module.exports = {
	LockedInput: LockedInput,
	ToggleField: ToggleField,
	FormToggler: FormToggler,
	WhenChecked: WhenChecked,
	initWhenChecked: initWhenChecked,
	datePickerInit: datePickerInit
};

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nodes = __webpack_require__(1183);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Filter = function () {
	_createClass(Filter, [{
		key: 'defaults',
		get: function get() {
			return {
				container: $('<div></div>', { class: 'filters-ui-container' })
			};
		}
	}]);

	function Filter(config, filtersInfo) {
		_classCallCheck(this, Filter);

		this.filterInfo = null;
		this.idMap = null;
		this.root = null;

		if (config.container !== undefined) {
			config.container.addClass('filters-ui-container');
		}

		this.options = $.extend({}, this.defaults, config);

		this.buildElement();
		if (filtersInfo !== undefined) {
			this.loadFilterInfo(filtersInfo);
		}
	}

	_createClass(Filter, [{
		key: 'buildFilters',
		value: function buildFilters() {
			if (this.filterInfo === null) {
				return;
			}

			this.idMap = {};
			this.sourceDropdown = $('<select></select>');

			$('<option></option>', {
				value: '',
				text: gettext('Select a filter...')
			}).appendTo(this.sourceDropdown);

			for (var group in this.filterInfo) {
				var groupFilters = this.filterInfo[group];

				var optgroup = $('<optgroup></optgroup>', {
					label: group
				});

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = groupFilters.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var option = _step.value;

						var value = '';
						var text = void 0;
						var disabled = void 0;

						if ('id' in option) {
							this.idMap[option.id] = option;
							value = option.id;
							text = option.label;
							disabled = false;
						} else {
							text = option.text;
							disabled = true;
						}

						optgroup.append($('<option></option>', {
							value: value,
							text: text,
							disabled: disabled
						}));
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.sourceDropdown.append(optgroup);
			}
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty() {
			return this.root === null || this.root.children.length == 1 && this.root.children[0].variable == null;
		}
	}, {
		key: 'clearFilters',
		value: function clearFilters() {
			if (this.root !== null) {
				this.root.element.empty();
				this.root = null;
			}

			this.root = new _nodes.ConnectiveNode(this, { type: 'AND', isRoot: true });
			this.root.newNode();

			this.element.append(this.root.element);
			this.element.children('.connective-node').removeClass('nested');
		}
	}, {
		key: 'loadFilterInfo',
		value: function loadFilterInfo(info) {
			this.filterInfo = info.filters;
			this.buildFilters();

			this.changeFilters(info.current_filters);
			this.element.children('.connective-node').removeClass('nested');

			if (this.root === null) {
				this.clearFilters();
			}
		}
	}, {
		key: 'changeFilters',
		value: function changeFilters(firstNode) {
			this.element.empty();
			this.root = this.parse(firstNode, true);
		}
	}, {
		key: 'parse',
		value: function parse(info, firstNode) {
			var type = info.type || '';

			if (['AND', 'OR'].indexOf(type.toUpperCase()) > -1) {
				var node = new _nodes.ConnectiveNode(this, { type: type.toUpperCase(), isRoot: firstNode });

				if (info.items !== undefined) {
					node.negated = info.negated || false;

					for (var i = 0; i < info.items.length; i++) {
						var item = this.parse(info.items[i], false);

						if (item !== null) {
							node.addNode(item);
						}
					}
				}

				if (node.children.length === 0) {
					return null;
				}

				this.element.append(node.element);
				return node;
			} else if (info.hasOwnProperty('variable')) {
				return new _nodes.VariableNode(this, this.idMap[info.variable], {
					predicate: info.predicate,
					variable: info.variable,
					value: info.value
				});
			}

			return null;
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.element = this.options.container;
		}
	}, {
		key: '_stringify',
		value: function _stringify(obj, isRoot) {
			var result = '';
			if (obj.children.length > 0) {
				for (var i = 0; i < obj.children.length; i++) {
					var child = obj.children[i];
					if ($.type(child) === 'string') {
						result += '<div class="description">' + child + '</div>';
					} else {
						result += '<div class="nested">' + this._stringify(child, false) + '</div>';
						if (isRoot) {
							result += '<hr>';
						}
					}
					if (i < obj.children.length - 1) {
						result += '<div class="connector">' + obj.connector + '</div>';
					}
				}
			}

			return result;
		}
	}, {
		key: 'stringify',
		value: function stringify() {
			if (this.root === null) {
				return '';
			}

			var htmlOutput = '<div class="filter-info">';
			var logicObj = this.root.stringify();

			htmlOutput += this._stringify(logicObj, true);
			htmlOutput += '</div>';

			return htmlOutput;
		}
	}, {
		key: 'serialize',
		value: function serialize() {
			var result = this.root.serialize();
			return result;
		}
	}]);

	return Filter;
}();

module.exports = Filter;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _values = __webpack_require__(2227);

var _types = __webpack_require__(1176);

var _types2 = _interopRequireDefault(_types);

var _dropselectordrilldown = __webpack_require__(446);

var _dropselectordrilldown2 = _interopRequireDefault(_dropselectordrilldown);

var _dropselector = __webpack_require__(115);

var _dropselector2 = _interopRequireDefault(_dropselector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConnectiveNode = function () {
	function ConnectiveNode(filters, info) {
		_classCallCheck(this, ConnectiveNode);

		this.nodeType = 'Connective', this.negated = false;
		this.type = 'AND';
		this.isRoot = false;
		this.filters = filters;

		this.parent = null;

		this.children = [];

		this.buildElement();

		if (info !== undefined) {
			this.loadFromInfo(info);
		}

		this.delegate();
	}

	_createClass(ConnectiveNode, [{
		key: 'loadFromInfo',
		value: function loadFromInfo(info) {
			this.isRoot = info.isRoot;

			this.type = info.type || 'AND';
			this.negated = info.negated || false;
			this.element.find('select.node-type').val(this.type);
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.element = $(ConnectiveNode.BaseTemplate());
			this.element.find('select.node-type').val(this.type);
		}
	}, {
		key: 'setParent',
		value: function setParent(parentNode) {
			//This will not reset the structure, use this only on init
			this.parent = parentNode;
		}
	}, {
		key: 'addNode',
		value: function addNode(node) {
			node.setParent(this);
			this.children.push(node);
			this.element.children('.contents').append(node.element);

			if (this.isRoot) {
				this.element.children('.contents').append($('<hr>'));
			}
		}
	}, {
		key: 'newNode',
		value: function newNode() {
			var node = new VariableNode(this.filters);
			this.addNode(node);
		}
	}, {
		key: 'nestNode',
		value: function nestNode(node) {
			if (this.children.length <= 1) {
				//Don't allow nesting on only 1 rule
				return;
			}

			var newConnective = new ConnectiveNode(this.filters);
			var nodeIndex = this.children.indexOf(node);

			this.children.splice(nodeIndex, 1);

			node.element.before(newConnective.element);

			newConnective.addNode(node);
			newConnective.setParent(this);

			//Make a new node, cause it only makes sense to nest with multiple rules
			newConnective.newNode();
			this.children.splice(nodeIndex, 0, newConnective);
		}
	}, {
		key: 'spliceNode',
		value: function spliceNode(node, beforeNode) {
			//Inserts the node before the 'beforeNode' node
			//Doesn't handle element detaching
			var beforeIndex = this.children.indexOf(beforeNode);

			if (beforeIndex < 0) {
				return;
			}

			this.children.splice(beforeIndex, 0, node);
			node.setParent(this);

			beforeNode.element.before(node.element);

			if (this.isRoot) {
				beforeNode.element.before($('<hr>'));
			}
		}
	}, {
		key: 'removeNode',
		value: function removeNode(node, force) {
			if (force === undefined) {
				force = false;
			}

			var nodeIndex = this.children.indexOf(node);

			this.children.splice(nodeIndex, 1);

			if (this.isRoot) {
				node.element.next('hr:first').remove();
			}

			node.element.remove();

			if (!force && this.isRoot && this.variableNodes().length < 1) {
				this.newNode();
				return;
			}

			if (this.variableNodes().length == 1 && this.parent !== null) {
				//Only 1 var left in this nested non-root connective, collapse and give the parent the variable node
				this.parent.spliceNode(this.variableNodes()[0], this);
				this.children.splice(0, 1);
				this.children.length = 0;
			}

			if (this.children.length == 0 && this.parent !== null) {
				this.parent.removeNode(this, true);
			}
		}
	}, {
		key: 'variableNodes',
		value: function variableNodes() {
			return this.children.filter(function (val) {
				return !!(val.nodeType === 'Variable');
			});
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.element.on('change', 'select.node-type', $.proxy(function () {
				this.type = this.element.find('select.node-type').val();
			}, this));
		}
	}, {
		key: 'stringify',
		value: function stringify() {
			var childrenStrings = [];
			for (var i = 0; i < this.children.length; i++) {
				childrenStrings.push(this.children[i].stringify());
			}

			return {
				children: childrenStrings,
				connector: this.type == 'AND' ? 'and' : 'or'
			};
		}
	}, {
		key: 'serialize',
		value: function serialize() {
			var items = [];

			for (var i = 0; i < this.children.length; i++) {
				items.push(this.children[i].serialize());
			}

			var obj = {
				type: this.type,
				items: items
			};

			if (this.negated) {
				obj['negated'] = true;
			}

			return obj;
		}
	}]);

	return ConnectiveNode;
}();

ConnectiveNode.BaseTemplate = _.template("\
<div class='connective-node nested'>\
	<div class='type-container'>\
		" + gettext('Conditions to match') + "&nbsp;&nbsp;<select class='node-type form-control custom-select'>\
			<option value='AND'>" + gettext('All') + "</option>\
			<option value='OR'>" + gettext('Any') + "</option>\
		</select>\
	</div>\
	<div class='contents'>\
	</div>\
</div>\
");

var VariableNode = function () {
	function VariableNode(filters, filterInfo, info) {
		_classCallCheck(this, VariableNode);

		this.nodeType = 'Variable';
		this.parent = null;
		this.filters = filters;

		this.variable = null;
		this.predicate = null;
		this.value = null; //This becomes an instance of a class
		/*
  * this._value - Used for initially loading from a previous serialized filter
  * Do not use this ever, it will not change once set, instead use
  * this.value.value
  */
		this._value = null;
		this.filterInfo = filterInfo;

		if (info !== undefined) {
			this.loadFromInfo(info);
		}

		this.buildElement(this.filters.sourceDropdown);
	}

	_createClass(VariableNode, [{
		key: 'setParent',
		value: function setParent(parentNode) {
			// This will not reset the structure, use this only on init
			this.parent = parentNode;
		}
	}, {
		key: 'loadFromInfo',
		value: function loadFromInfo(info) {
			this.variable = info.variable || null;
			this.predicate = info.predicate || null;
			this._value = info.value || null;
		}
	}, {
		key: 'buildElement',
		value: function buildElement(sourceDropdown) {
			var tools = VariableNode.ToolsTemplate();
			var element = $(VariableNode.BaseTemplate({ tools: tools }));

			this.sourceDropdown = sourceDropdown.clone();
			this.dropSelect = new _dropselectordrilldown2.default({
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: this.sourceDropdown
			});

			this.variableElement = element.find('.variable');
			this.variableElement.append(this.dropSelect.wrapped);

			this.predicateElement = element.find('.predicate');
			this.valueElement = element.find('.value');

			this.predicateElement.empty();
			this.valueElement.empty();

			this.element = element;

			this.delegate();

			if (this.variable !== null) {
				this.dropSelect.val(this.variable);
				if (this.filterInfo !== undefined) {
					this.rebuildPredicate(true);
				}
			}
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.sourceDropdown.on('change', $.proxy(this.variableChanged, this));
			this.predicateElement.on('change', 'select', $.proxy(this.predicateChanged, this));

			this.element.on('click', '.node-tools .add-rule', $.proxy(function (e) {
				e.preventDefault();
				this.parent.newNode();
			}, this));

			this.element.on('click', '.node-tools .nest-rule', $.proxy(function (e) {
				e.preventDefault();
				this.parent.nestNode(this);
			}, this));

			this.element.on('click', '.node-tools .remove-rule', $.proxy(function (e) {
				e.preventDefault();
				this.parent.removeNode(this);
			}, this));
		}
	}, {
		key: 'variableChanged',
		value: function variableChanged(_e) {
			this.variable = this.sourceDropdown.val();

			this.filterInfo = this.filters.idMap[this.variable];
			this.predicate = null;

			if (this.filterInfo !== undefined) {
				this.rebuildPredicate();
			}
		}
	}, {
		key: 'rebuildPredicate',
		value: function rebuildPredicate(isInitial) {
			this.predicateElement.empty();
			var typeInfo = [];

			if (this.filterInfo.type.indexOf('+') > -1) {
				var splitTypes = this.filterInfo.type.split('+');

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = splitTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var splitType = _step.value;

						typeInfo = typeInfo.concat(_types2.default[splitType]);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else if (this.filterInfo.type in _types2.default) {
				typeInfo = _types2.default[this.filterInfo.type];
			}

			var dropdown = $('<select></select>', { class: 'predicate-selector' });

			for (var i = 0; i < typeInfo.length; i++) {
				dropdown.append($('<option></option>', {
					value: typeInfo[i].value,
					text: typeInfo[i].label
				}));
			}

			var dropselector = new _dropselector2.default({
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: dropdown
			});

			this.predicateElement.append(dropselector.wrapped);

			if (this.predicate !== null) {
				dropselector.val(this.predicate);
			} else {
				var firstVal = dropdown.find('option:first').attr('value');
				dropselector.val(firstVal);
				this.predicate = firstVal;
			}

			this.predicateChanged(null, isInitial);

			this.predicateElement.append(dropselector.wrapped);
			if (this.value && this.value.hasOwnProperty('noPredicate') && this.value.noPredicate) {
				this.predicateElement.hide().css('display', 'none');
				this.valueElement.addClass('sma-value-fullwidth');
			} else {
				this.predicateElement.show().css('display', 'inline-block');
				this.valueElement.removeClass('sma-value-fullwidth');
			}
		}
	}, {
		key: 'getPredicateType',
		value: function getPredicateType(val) {
			var typeInfo = [];
			if (this.filterInfo.type.indexOf('+') > -1) {
				var splitTypes = this.filterInfo.type.split('+');

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = splitTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var splitType = _step2.value;

						typeInfo = typeInfo.concat(_types2.default[splitType]);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			} else if (this.filterInfo.type in _types2.default) {
				typeInfo = _types2.default[this.filterInfo.type];
			}

			for (var i = 0; i < typeInfo.length; i++) {
				if (val === typeInfo[i].value) {
					return typeInfo[i].type;
				}
			}

			return null;
		}
	}, {
		key: 'predicateChanged',
		value: function predicateChanged(e, isInitial) {
			this.valueElement.empty();

			this.predicate = this.predicateElement.find('select').val();

			var type = this.getPredicateType(this.predicateElement.find('select').val());
			var valueClass = _values.Value.TypeMap[type];

			if (valueClass === null || valueClass === undefined) {
				this.value = null;
				this.valueElement.empty();
				return;
			} else {
				this.value = new valueClass(this.filterInfo);
			}

			this.valueElement.append(this.value.getElement());

			this.value.afterAppended();

			if (isInitial && this.value !== null && this._value !== null) {
				this.value.set(this._value); //Set Default
			}

			this.valueElement.show().css('display', 'inline-block');
		}
	}, {
		key: 'stringify',
		value: function stringify() {
			var val = this.valueElement.find('option:selected').text();

			if (this.value !== null && $.isArray(this.value.value)) {
				if (this.value.value.length <= 3) {
					val = $.map(this.valueElement.find('option:selected'), function (j) {
						return $(j).text();
					}).join(', ');
				} else {
					val = this.value.value.length + gettext(' Selected');
				}
			}

			return 'If <span class="var">' + this.variableElement.find('.rr-ds-disp').text().replace('...', '').toLowerCase() + '</span> ' + '<span class="predicate">' + this.predicateElement.find('option:selected').text().toLowerCase() + '</span> ' + '<span class="value">' + val + '</span>';
		}
	}, {
		key: 'serialize',
		value: function serialize() {
			var type = this.getPredicateType(this.predicateElement.find('select').val());

			var obj = {
				variable: this.variable,
				predicate: this.predicate
			};

			if (type !== 'noop') {
				obj['value'] = this.value.value;
			}

			return obj;
		}
	}]);

	return VariableNode;
}();

VariableNode.BaseTemplate = _.template("\
<div class='variable-node'>\
	<div class='variable'></div>\
	<div class='predicate'></div>\
	<div class='value'></div>\
	<%= tools %>\
</div>\
");

VariableNode.ToolsTemplate = _.template("\
<div class='node-tools'>\
	<a href='#' class='add-rule' title='" + gettext('Add rule below') + "'><i class='nc-icon-mini ui-1_bold-add'></i></a>\
	<a href='#' class='remove-rule' title='" + gettext('Remove rule') + "'><i class='nc-icon-mini ui-1_trash-simple'></i></a>\
	<a href='#' class='nest-rule' title='" + gettext('Nest rule') + "'><i class='nc-icon-mini arrows-1_redo-79'></i></a>\
</div>\
");

module.exports = {
	VariableNode: VariableNode,
	ConnectiveNode: ConnectiveNode
};

/***/ }),
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {

/* parser generated by jison 0.4.2 */
var exprParser = function () {
    var parser = { trace: function trace() {},
        yy: {},
        symbols_: { "error": 2, "expressions": 3, "logic_expr": 4, "EOF": 5, "math_expr": 6, "compare_expr": 7, "AND": 8, "OR": 9, "NOT": 10, "(": 11, ")": 12, "=": 13, ">": 14, "<": 15, ">=": 16, "<=": 17, "!=": 18, "identifier": 19, "const": 20, "array": 21, "func": 22, "index": 23, "attr": 24, "+": 25, "-": 26, "*": 27, "/": 28, "params": 29, ",": 30, "ID": 31, "INT": 32, "REAL": 33, "STR": 34, "[": 35, "list": 36, "]": 37, "int": 38, ".": 39, ":": 40, "$accept": 0, "$end": 1 },
        terminals_: { 2: "error", 5: "EOF", 8: "AND", 9: "OR", 10: "NOT", 11: "(", 12: ")", 13: "=", 14: ">", 15: "<", 16: ">=", 17: "<=", 18: "!=", 25: "+", 26: "-", 27: "*", 28: "/", 30: ",", 31: "ID", 32: "INT", 33: "REAL", 34: "STR", 35: "[", 37: "]", 39: ".", 40: ":" },
        productions_: [0, [3, 2], [3, 2], [4, 1], [4, 3], [4, 3], [4, 2], [4, 3], [7, 3], [7, 3], [7, 3], [7, 3], [7, 3], [7, 3], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 3], [6, 3], [6, 3], [6, 3], [6, 3], [29, 1], [29, 3], [19, 1], [20, 1], [20, 1], [20, 1], [20, 3], [38, 1], [36, 1], [36, 1], [36, 1], [36, 3], [36, 3], [36, 3], [24, 3], [24, 3], [24, 3], [21, 6], [21, 5], [21, 5], [22, 4], [23, 4], [23, 4], [23, 3], [23, 3]],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {

            var $0 = $$.length - 1;
            switch (yystate) {
                case 1:
                    return $$[$0 - 1];
                    break;
                case 2:
                    return $$[$0 - 1];
                    break;
                case 3:
                    this.$ = $$[$0];
                    break;
                case 4:
                    this.$ = { type: 'connective', op: 'and', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 5:
                    this.$ = { type: 'connective', op: 'or', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 6:
                    this.$ = { type: 'connective', op: 'not', left: $$[$0] };
                    break;
                case 7:
                    this.$ = $$[$0 - 1];
                    break;
                case 8:
                    this.$ = { type: 'compare', op: '=', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 9:
                    this.$ = { type: 'compare', op: '>', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 10:
                    this.$ = { type: 'compare', op: '<', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 11:
                    this.$ = { type: 'compare', op: '>=', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 12:
                    this.$ = { type: 'compare', op: '<=', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 13:
                    this.$ = { type: 'compare', op: '!=', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 14:
                    this.$ = $$[$0];
                    break;
                case 15:
                    this.$ = $$[$0];
                    break;
                case 16:
                    this.$ = $$[$0];
                    break;
                case 17:
                    this.$ = $$[$0];
                    break;
                case 18:
                    this.$ = $$[$0];
                    break;
                case 19:
                    this.$ = $$[$0];
                    break;
                case 20:
                    this.$ = { type: 'math', op: '+', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 21:
                    this.$ = { type: 'math', op: '-', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 22:
                    this.$ = { type: 'math', op: '*', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 23:
                    this.$ = { type: 'math', op: '/', left: $$[$0 - 2], right: $$[$0] };
                    break;
                case 24:
                    this.$ = $$[$0 - 1];
                    break;
                case 25:
                    this.$ = [$$[$0]];
                    break;
                case 26:
                    this.$ = $$[$0].concat([$$[$0 - 2]]);
                    break;
                case 27:
                    this.$ = { type: 'id', value: yytext };
                    break;
                case 28:
                    this.$ = { type: 'const', value: parseInt(yytext) };
                    break;
                case 29:
                    this.$ = { type: 'const', value: parseFloat(yytext) };
                    break;
                case 30:
                    this.$ = { type: 'const', value: yytext.replace(/\'|\"/g, '') };
                    break;
                case 31:
                    this.$ = { type: 'const', value: $$[$0 - 1] };
                    break;
                case 32:
                    this.$ = { type: 'const', value: parseInt(yytext) };
                    break;
                case 33:
                    this.$ = [$$[$0]];
                    break;
                case 34:
                    this.$ = [$$[$0]];
                    break;
                case 35:
                    this.$ = [$$[$0].replace(/\'|\"/g, '')];
                    break;
                case 36:
                    this.$ = $$[$0].concat([$$[$0 - 2]]);
                    break;
                case 37:
                    this.$ = $$[$0].concat([$$[$0 - 2]]);
                    break;
                case 38:
                    this.$ = $$[$0].concat([$$[$0 - 2].replace(/\'|\"/g, '')]);
                    break;
                case 39:
                    this.$ = { type: 'attr', id: $$[$0 - 2], attr: $$[$0] };
                    break;
                case 40:
                    this.$ = { type: 'attr', id: $$[$0 - 2], attr: $$[$0] };
                    break;
                case 41:
                    this.$ = { type: 'attr', id: $$[$0 - 2], attr: $$[$0] };
                    break;
                case 42:
                    this.$ = { type: 'array', id: $$[$0 - 5], start: $$[$0 - 3], end: $$[$0 - 1] };
                    break;
                case 43:
                    this.$ = { type: 'array', id: $$[$0 - 4], start: $$[$0 - 2] };
                    break;
                case 44:
                    this.$ = { type: 'array', id: $$[$0 - 4], end: $$[$0 - 1] };
                    break;
                case 45:
                    this.$ = { type: 'func', id: $$[$0 - 3], params: $$[$0 - 1] };
                    break;
                case 46:
                    this.$ = { type: 'index', id: $$[$0 - 3], index: $$[$0 - 1] };
                    break;
                case 47:
                    this.$ = { type: 'index', id: $$[$0 - 3], index: $$[$0 - 1] };
                    break;
                case 48:
                    this.$ = { type: 'index', id: $$[$0 - 2], index: $$[$0] };
                    break;
                case 49:
                    this.$ = { type: 'index', id: $$[$0 - 2], index: $$[$0] };
                    break;
            }
        },
        table: [{ 3: 1, 4: 2, 6: 3, 7: 4, 10: [1, 5], 11: [1, 6], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 1: [3] }, { 5: [1, 18], 8: [1, 19], 9: [1, 20] }, { 5: [1, 21], 13: [1, 26], 14: [1, 27], 15: [1, 28], 16: [1, 29], 17: [1, 30], 18: [1, 31], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 3], 8: [2, 3], 9: [2, 3], 12: [2, 3] }, { 4: 32, 6: 33, 7: 4, 10: [1, 5], 11: [1, 6], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 4: 34, 6: 35, 7: 4, 10: [1, 5], 11: [1, 6], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 5: [2, 14], 8: [2, 14], 9: [2, 14], 11: [1, 37], 12: [2, 14], 13: [2, 14], 14: [2, 14], 15: [2, 14], 16: [2, 14], 17: [2, 14], 18: [2, 14], 25: [2, 14], 26: [2, 14], 27: [2, 14], 28: [2, 14], 30: [2, 14], 35: [1, 36], 37: [2, 14], 39: [1, 38], 40: [2, 14] }, { 5: [2, 15], 8: [2, 15], 9: [2, 15], 12: [2, 15], 13: [2, 15], 14: [2, 15], 15: [2, 15], 16: [2, 15], 17: [2, 15], 18: [2, 15], 25: [2, 15], 26: [2, 15], 27: [2, 15], 28: [2, 15], 30: [2, 15], 37: [2, 15], 40: [2, 15] }, { 5: [2, 16], 8: [2, 16], 9: [2, 16], 12: [2, 16], 13: [2, 16], 14: [2, 16], 15: [2, 16], 16: [2, 16], 17: [2, 16], 18: [2, 16], 25: [2, 16], 26: [2, 16], 27: [2, 16], 28: [2, 16], 30: [2, 16], 35: [1, 39], 37: [2, 16], 39: [1, 40], 40: [2, 16] }, { 5: [2, 17], 8: [2, 17], 9: [2, 17], 12: [2, 17], 13: [2, 17], 14: [2, 17], 15: [2, 17], 16: [2, 17], 17: [2, 17], 18: [2, 17], 25: [2, 17], 26: [2, 17], 27: [2, 17], 28: [2, 17], 30: [2, 17], 37: [2, 17], 40: [2, 17] }, { 5: [2, 18], 8: [2, 18], 9: [2, 18], 12: [2, 18], 13: [2, 18], 14: [2, 18], 15: [2, 18], 16: [2, 18], 17: [2, 18], 18: [2, 18], 25: [2, 18], 26: [2, 18], 27: [2, 18], 28: [2, 18], 30: [2, 18], 37: [2, 18], 39: [1, 41], 40: [2, 18] }, { 5: [2, 19], 8: [2, 19], 9: [2, 19], 12: [2, 19], 13: [2, 19], 14: [2, 19], 15: [2, 19], 16: [2, 19], 17: [2, 19], 18: [2, 19], 25: [2, 19], 26: [2, 19], 27: [2, 19], 28: [2, 19], 30: [2, 19], 37: [2, 19], 40: [2, 19] }, { 5: [2, 27], 8: [2, 27], 9: [2, 27], 11: [2, 27], 12: [2, 27], 13: [2, 27], 14: [2, 27], 15: [2, 27], 16: [2, 27], 17: [2, 27], 18: [2, 27], 25: [2, 27], 26: [2, 27], 27: [2, 27], 28: [2, 27], 30: [2, 27], 35: [2, 27], 37: [2, 27], 39: [2, 27], 40: [2, 27] }, { 5: [2, 28], 8: [2, 28], 9: [2, 28], 12: [2, 28], 13: [2, 28], 14: [2, 28], 15: [2, 28], 16: [2, 28], 17: [2, 28], 18: [2, 28], 25: [2, 28], 26: [2, 28], 27: [2, 28], 28: [2, 28], 30: [2, 28], 37: [2, 28], 40: [2, 28] }, { 5: [2, 29], 8: [2, 29], 9: [2, 29], 12: [2, 29], 13: [2, 29], 14: [2, 29], 15: [2, 29], 16: [2, 29], 17: [2, 29], 18: [2, 29], 25: [2, 29], 26: [2, 29], 27: [2, 29], 28: [2, 29], 30: [2, 29], 37: [2, 29], 40: [2, 29] }, { 5: [2, 30], 8: [2, 30], 9: [2, 30], 12: [2, 30], 13: [2, 30], 14: [2, 30], 15: [2, 30], 16: [2, 30], 17: [2, 30], 18: [2, 30], 25: [2, 30], 26: [2, 30], 27: [2, 30], 28: [2, 30], 30: [2, 30], 37: [2, 30], 40: [2, 30] }, { 32: [1, 43], 33: [1, 44], 34: [1, 45], 36: 42 }, { 1: [2, 1] }, { 4: 46, 6: 33, 7: 4, 10: [1, 5], 11: [1, 6], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 4: 47, 6: 33, 7: 4, 10: [1, 5], 11: [1, 6], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 1: [2, 2] }, { 6: 48, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 50, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 51, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 52, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 53, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 54, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 55, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 56, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 57, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 6: 58, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 5: [2, 6], 8: [2, 6], 9: [2, 6], 12: [2, 6] }, { 13: [1, 26], 14: [1, 27], 15: [1, 28], 16: [1, 29], 17: [1, 30], 18: [1, 31], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 8: [1, 19], 9: [1, 20], 12: [1, 59] }, { 12: [1, 60], 13: [1, 26], 14: [1, 27], 15: [1, 28], 16: [1, 29], 17: [1, 30], 18: [1, 31], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 6: 61, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17], 40: [1, 62] }, { 6: 64, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 29: 63, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 19: 66, 31: [1, 13], 32: [1, 67], 38: 65 }, { 6: 68, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 19: 70, 31: [1, 13], 32: [1, 67], 38: 69 }, { 19: 71, 31: [1, 13] }, { 37: [1, 72] }, { 30: [1, 73], 37: [2, 33] }, { 30: [1, 74], 37: [2, 34] }, { 30: [1, 75], 37: [2, 35] }, { 5: [2, 4], 8: [2, 4], 9: [2, 4], 12: [2, 4] }, { 5: [2, 5], 8: [1, 19], 9: [2, 5], 12: [2, 5] }, { 5: [2, 20], 8: [2, 20], 9: [2, 20], 12: [2, 20], 13: [2, 20], 14: [2, 20], 15: [2, 20], 16: [2, 20], 17: [2, 20], 18: [2, 20], 25: [2, 20], 26: [2, 20], 27: [1, 24], 28: [1, 25], 30: [2, 20], 37: [2, 20], 40: [2, 20] }, { 6: 76, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 5: [2, 21], 8: [2, 21], 9: [2, 21], 12: [2, 21], 13: [2, 21], 14: [2, 21], 15: [2, 21], 16: [2, 21], 17: [2, 21], 18: [2, 21], 25: [2, 21], 26: [2, 21], 27: [1, 24], 28: [1, 25], 30: [2, 21], 37: [2, 21], 40: [2, 21] }, { 5: [2, 22], 8: [2, 22], 9: [2, 22], 12: [2, 22], 13: [2, 22], 14: [2, 22], 15: [2, 22], 16: [2, 22], 17: [2, 22], 18: [2, 22], 25: [2, 22], 26: [2, 22], 27: [2, 22], 28: [2, 22], 30: [2, 22], 37: [2, 22], 40: [2, 22] }, { 5: [2, 23], 8: [2, 23], 9: [2, 23], 12: [2, 23], 13: [2, 23], 14: [2, 23], 15: [2, 23], 16: [2, 23], 17: [2, 23], 18: [2, 23], 25: [2, 23], 26: [2, 23], 27: [2, 23], 28: [2, 23], 30: [2, 23], 37: [2, 23], 40: [2, 23] }, { 5: [2, 8], 8: [2, 8], 9: [2, 8], 12: [2, 8], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 9], 8: [2, 9], 9: [2, 9], 12: [2, 9], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 10], 8: [2, 10], 9: [2, 10], 12: [2, 10], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 11], 8: [2, 11], 9: [2, 11], 12: [2, 11], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 12], 8: [2, 12], 9: [2, 12], 12: [2, 12], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 13], 8: [2, 13], 9: [2, 13], 12: [2, 13], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 5: [2, 7], 8: [2, 7], 9: [2, 7], 12: [2, 7] }, { 5: [2, 24], 8: [2, 24], 9: [2, 24], 12: [2, 24], 13: [2, 24], 14: [2, 24], 15: [2, 24], 16: [2, 24], 17: [2, 24], 18: [2, 24], 25: [2, 24], 26: [2, 24], 27: [2, 24], 28: [2, 24], 30: [2, 24], 37: [2, 24], 40: [2, 24] }, { 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25], 37: [1, 78], 40: [1, 77] }, { 6: 79, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 12: [1, 80] }, { 12: [2, 25], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25], 30: [1, 81] }, { 5: [2, 48], 8: [2, 48], 9: [2, 48], 12: [2, 48], 13: [2, 48], 14: [2, 48], 15: [2, 48], 16: [2, 48], 17: [2, 48], 18: [2, 48], 25: [2, 48], 26: [2, 48], 27: [2, 48], 28: [2, 48], 30: [2, 48], 37: [2, 48], 39: [2, 48], 40: [2, 48] }, { 5: [2, 39], 8: [2, 39], 9: [2, 39], 12: [2, 39], 13: [2, 39], 14: [2, 39], 15: [2, 39], 16: [2, 39], 17: [2, 39], 18: [2, 39], 25: [2, 39], 26: [2, 39], 27: [2, 39], 28: [2, 39], 30: [2, 39], 37: [2, 39], 40: [2, 39] }, { 5: [2, 32], 8: [2, 32], 9: [2, 32], 12: [2, 32], 13: [2, 32], 14: [2, 32], 15: [2, 32], 16: [2, 32], 17: [2, 32], 18: [2, 32], 25: [2, 32], 26: [2, 32], 27: [2, 32], 28: [2, 32], 30: [2, 32], 37: [2, 32], 39: [2, 32], 40: [2, 32] }, { 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25], 37: [1, 82] }, { 5: [2, 49], 8: [2, 49], 9: [2, 49], 12: [2, 49], 13: [2, 49], 14: [2, 49], 15: [2, 49], 16: [2, 49], 17: [2, 49], 18: [2, 49], 25: [2, 49], 26: [2, 49], 27: [2, 49], 28: [2, 49], 30: [2, 49], 37: [2, 49], 39: [2, 49], 40: [2, 49] }, { 5: [2, 41], 8: [2, 41], 9: [2, 41], 12: [2, 41], 13: [2, 41], 14: [2, 41], 15: [2, 41], 16: [2, 41], 17: [2, 41], 18: [2, 41], 25: [2, 41], 26: [2, 41], 27: [2, 41], 28: [2, 41], 30: [2, 41], 37: [2, 41], 40: [2, 41] }, { 5: [2, 40], 8: [2, 40], 9: [2, 40], 12: [2, 40], 13: [2, 40], 14: [2, 40], 15: [2, 40], 16: [2, 40], 17: [2, 40], 18: [2, 40], 25: [2, 40], 26: [2, 40], 27: [2, 40], 28: [2, 40], 30: [2, 40], 37: [2, 40], 40: [2, 40] }, { 5: [2, 31], 8: [2, 31], 9: [2, 31], 12: [2, 31], 13: [2, 31], 14: [2, 31], 15: [2, 31], 16: [2, 31], 17: [2, 31], 18: [2, 31], 25: [2, 31], 26: [2, 31], 27: [2, 31], 28: [2, 31], 30: [2, 31], 37: [2, 31], 40: [2, 31] }, { 32: [1, 43], 33: [1, 44], 34: [1, 45], 36: 83 }, { 32: [1, 43], 33: [1, 44], 34: [1, 45], 36: 84 }, { 32: [1, 43], 33: [1, 44], 34: [1, 45], 36: 85 }, { 12: [1, 60], 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25] }, { 6: 86, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17], 37: [1, 87] }, { 5: [2, 46], 8: [2, 46], 9: [2, 46], 12: [2, 46], 13: [2, 46], 14: [2, 46], 15: [2, 46], 16: [2, 46], 17: [2, 46], 18: [2, 46], 25: [2, 46], 26: [2, 46], 27: [2, 46], 28: [2, 46], 30: [2, 46], 37: [2, 46], 39: [2, 46], 40: [2, 46] }, { 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25], 37: [1, 88] }, { 5: [2, 45], 8: [2, 45], 9: [2, 45], 12: [2, 45], 13: [2, 45], 14: [2, 45], 15: [2, 45], 16: [2, 45], 17: [2, 45], 18: [2, 45], 25: [2, 45], 26: [2, 45], 27: [2, 45], 28: [2, 45], 30: [2, 45], 37: [2, 45], 40: [2, 45] }, { 6: 64, 11: [1, 49], 19: 7, 20: 8, 21: 9, 22: 10, 23: 11, 24: 12, 29: 89, 31: [1, 13], 32: [1, 14], 33: [1, 15], 34: [1, 16], 35: [1, 17] }, { 5: [2, 47], 8: [2, 47], 9: [2, 47], 12: [2, 47], 13: [2, 47], 14: [2, 47], 15: [2, 47], 16: [2, 47], 17: [2, 47], 18: [2, 47], 25: [2, 47], 26: [2, 47], 27: [2, 47], 28: [2, 47], 30: [2, 47], 37: [2, 47], 39: [2, 47], 40: [2, 47] }, { 37: [2, 36] }, { 37: [2, 37] }, { 37: [2, 38] }, { 25: [1, 22], 26: [1, 23], 27: [1, 24], 28: [1, 25], 37: [1, 90] }, { 5: [2, 43], 8: [2, 43], 9: [2, 43], 12: [2, 43], 13: [2, 43], 14: [2, 43], 15: [2, 43], 16: [2, 43], 17: [2, 43], 18: [2, 43], 25: [2, 43], 26: [2, 43], 27: [2, 43], 28: [2, 43], 30: [2, 43], 35: [2, 43], 37: [2, 43], 39: [2, 43], 40: [2, 43] }, { 5: [2, 44], 8: [2, 44], 9: [2, 44], 12: [2, 44], 13: [2, 44], 14: [2, 44], 15: [2, 44], 16: [2, 44], 17: [2, 44], 18: [2, 44], 25: [2, 44], 26: [2, 44], 27: [2, 44], 28: [2, 44], 30: [2, 44], 35: [2, 44], 37: [2, 44], 39: [2, 44], 40: [2, 44] }, { 12: [2, 26] }, { 5: [2, 42], 8: [2, 42], 9: [2, 42], 12: [2, 42], 13: [2, 42], 14: [2, 42], 15: [2, 42], 16: [2, 42], 17: [2, 42], 18: [2, 42], 25: [2, 42], 26: [2, 42], 27: [2, 42], 28: [2, 42], 30: [2, 42], 35: [2, 42], 37: [2, 42], 39: [2, 42], 40: [2, 42] }],
        defaultActions: { 18: [2, 1], 21: [2, 2], 83: [2, 36], 84: [2, 37], 85: [2, 38], 89: [2, 26] },
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this,
                stack = [0],
                vstack = [null],
                lstack = [],
                table = this.table,
                yytext = "",
                yylineno = 0,
                yyleng = 0,
                recovering = 0,
                TERROR = 2,
                EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            function lex() {
                var token;
                token = self.lexer.lex() || 1;
                if (typeof token !== "number") {
                    token = self.symbols_[token] || token;
                }
                return token;
            }
            var symbol,
                preErrorSymbol,
                state,
                action,
                a,
                r,
                yyval = {},
                p,
                len,
                newState,
                expected;
            while (true) {
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                } else {
                    if (symbol === null || typeof symbol == "undefined") {
                        symbol = lex();
                    }
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    if (!recovering) {
                        expected = [];
                        for (p in table[state]) {
                            if (this.terminals_[p] && p > 2) {
                                expected.push("'" + this.terminals_[p] + "'");
                            }
                        }if (this.lexer.showPosition) {
                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        } else {
                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                        }
                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
                    }
                }
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                }
                switch (action[0]) {
                    case 1:
                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
                        if (ranges) {
                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                        }
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                        if (typeof r !== "undefined") {
                            return r;
                        }
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* generated by jison-lex 0.1.0 */
    var lexer = function () {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) {
                    this.yy.parser.parseError(str, hash);
                } else {
                    throw new Error(str);
                }
            },
            setInput: function setInput(input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
                if (this.options.ranges) this.yylloc.range = [0, 0];
                this.offset = 0;
                return this;
            },
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else {
                    this.yylloc.last_column++;
                }
                if (this.options.ranges) this.yylloc.range[1]++;

                this._input = this._input.slice(1);
                return ch;
            },
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);

                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);

                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;

                this.yylloc = { first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };

                if (this.options.ranges) {
                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
                }
                return this;
            },
            more: function more() {
                this._more = true;
                return this;
            },
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20 - next.length);
                }
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) this.done = true;

                var token, match, tempMatch, index, col, lines;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i = 0; i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/(?:\r\n?|\n).*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = { first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
                    this.yytext += match[0];
                    this.match += match[0];
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    if (this.options.ranges) {
                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
                    }
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;else return;
                }
                if (this._input === "") {
                    return this.EOF;
                } else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
                }
            },
            lex: function lex() {
                var r = this.next();
                if (typeof r !== 'undefined') {
                    return r;
                } else {
                    return this.lex();
                }
            },
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState: function popState() {
                return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
                return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
                this.begin(condition);
            },
            options: {},
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

                var YYSTATE = YY_START;
                switch ($avoiding_name_collisions) {
                    case 0:
                        /* skip whitespace */
                        break;
                    case 1:
                        return 8;
                        break;
                    case 2:
                        return 9;
                        break;
                    case 3:
                        return 10;
                        break;
                    case 4:
                        return 33;
                        break;
                    case 5:
                        return 32;
                        break;
                    case 6:
                        return 34;
                        break;
                    case 7:
                        return 31;
                        break;
                    case 8:
                        return 25;
                        break;
                    case 9:
                        return 26;
                        break;
                    case 10:
                        return 27;
                        break;
                    case 11:
                        return 28;
                        break;
                    case 12:
                        return 16;
                        break;
                    case 13:
                        return 17;
                        break;
                    case 14:
                        return 13;
                        break;
                    case 15:
                        return 14;
                        break;
                    case 16:
                        return 15;
                        break;
                    case 17:
                        return 18;
                        break;
                    case 18:
                        return 11;
                        break;
                    case 19:
                        return 12;
                        break;
                    case 20:
                        return 35;
                        break;
                    case 21:
                        return 37;
                        break;
                    case 22:
                        return 39;
                        break;
                    case 23:
                        return 30;
                        break;
                    case 24:
                        return 40;
                        break;
                    case 25:
                        return 5;
                        break;
                }
            },
            rules: [/^(?:\s+)/, /^(?:and\b)/, /^(?:or\b)/, /^(?:not\b)/, /^(?:[0-9]+\.[0-9]+\b)/, /^(?:[0-9]+\b)/, /^(?:'([^\']*)'|"([^\"]*)"\b)/, /^(?:[A-Za-z_][_:A-Za-z0-9]*\b)/, /^(?:\+)/, /^(?:-)/, /^(?:\*)/, /^(?:\/)/, /^(?:>=)/, /^(?:<=)/, /^(?:=)/, /^(?:>)/, /^(?:<)/, /^(?:!=)/, /^(?:\()/, /^(?:\))/, /^(?:\[)/, /^(?:\])/, /^(?:\.)/, /^(?:,)/, /^(?::)/, /^(?:$)/],
            conditions: { "INITIAL": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25], "inclusive": true } }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }Parser.prototype = parser;parser.Parser = Parser;
    return new Parser();
}();
if (true) {
    exports.parser = exprParser;
    exports.Parser = exprParser.Parser;
    exports.parse = function () {
        return exprParser.parse.apply(exprParser, arguments);
    };
    exports.main = function commonjsMain(args) {
        if (!args[1]) {
            console.log('Usage: ' + args[0] + ' FILE');
            process.exit(1);
        }
        var source = __webpack_require__(1202).readFileSync(__webpack_require__(2362).normalize(args[1]), "utf8");
        return exports.parser.parse(source);
    };
    if (typeof module !== 'undefined' && __webpack_require__.c[__webpack_require__.s] === module) {
        exports.main(process.argv.slice(1));
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(301), __webpack_require__(79)(module)))

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2343);
__webpack_require__(2344);

__webpack_require__(2345);
__webpack_require__(2346);

module.exports = {
	Editor: __webpack_require__(74).Editor
};

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(27);

var _options = __webpack_require__(231);

var _modals = __webpack_require__(6);

var modals = _interopRequireWildcard(_modals);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Class = __webpack_require__(157);
var chide = __webpack_require__(230);

var Fields = {};

Fields.Actions = {
	copy: {
		action: 'copy',
		cls: 'btn-default',
		displayName: gettext('Copy'),
		toolTip: gettext('Copy'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e, callback, keepBranching) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			var editor = __webpack_require__(74).Editor.instances[0];
			var field = void 0;
			var copied = [];
			for (var i = fields.length - 1; i >= 0; i--) {
				field = $(fields[i]).firstAttached(Fields.Field).serialize();
				field.name = '';
				if (!keepBranching) {
					Fields.Helpers.removeBranching(field);
				}
				copied.push(field);
			}
			$.ajax({
				url: editor.clipboardUrl + '?c=' + (0, _utils.randomString)(10),
				data: {
					clipboard: JSON.stringify(copied)
				},
				block: false,
				dataType: 'json',
				type: 'post',
				success: function success(_data) {
					if (callback && (typeof callback === 'undefined' ? 'undefined' : _typeof(callback)) == _typeof(function () {})) {
						callback(true);
					}
				},
				error: function error(_data) {
					if (callback && (typeof callback === 'undefined' ? 'undefined' : _typeof(callback)) == _typeof(function () {})) {
						callback(false);
					}
				}
			});
		}
	},
	cut: {
		action: 'cut',
		cls: 'btn-default',
		displayName: gettext('Cut'),
		toolTip: gettext('Cut'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e) {
			Fields.Actions.copy.handler(fields, e, function (success) {
				if (success) {
					var editor = __webpack_require__(74).Editor.instances[0];
					editor.survey.removeFields(fields);
					editor.fieldsSelected(undefined, e);
				}
			}, true);
		}
	},
	paste: {
		cls: 'btn-default',
		action: 'paste',
		displayName: gettext('Paste'),
		toolTip: gettext('Paste'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e, _click) {
			var editor = __webpack_require__(74).Editor.instances[0];
			var target = -1;
			if (!fields || !fields.length) {
				var clickTop = parseInt(editor.fieldContextMenu.container.css('top'), 10);
				_.each(editor.survey.currentPage.fields, function (el, i) {
					if (el.element.offset().top + el.element.height() <= clickTop) {
						target = i;
					}
				});
			}

			$.ajax({
				type: 'get',
				url: editor.clipboardUrl,
				data: { c: (0, _utils.randomString)(10) },
				block: false,
				success: function success(data) {
					if (!data.success || !data.clipboard) {
						return;
					}
					var clipboard = data.clipboard;
					var fieldInfo = void 0;
					var duplicates = [];
					for (var i = 0; i < clipboard.length; i++) {
						fieldInfo = $.extend(true, {}, clipboard[i]);
						fieldInfo.id = (0, _utils.randomString)(10);
						if (fieldInfo.children && fieldInfo.children.length && fieldInfo.children[0].looping) {
							delete fieldInfo.children[0]['looping'];
						}

						duplicates.push(editor.addField(undefined, fieldInfo, undefined, fields && fields.length ? fields[fields.length - 1] : target).element);
					}

					$(duplicates).each(function () {
						Fields.Helpers.normalizeField($(this).firstAttached(Fields.Field));
					});

					editor.fieldsSelected(duplicates, e);
				}
			});
		}
	},
	del_field: {
		cls: 'btn-danger',
		action: 'del_field',
		className: 'separator',
		displayName: gettext('Delete'),
		toolTip: gettext('Delete'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e, _skipPrompt) {
			fields = $.makeArray(fields);

			if (!fields.length) {
				return;
			}

			var modalTitle = gettext('Delete Fields');
			var modalBody = gettext('Are you sure you want to delete the selected fields? This cannot be undone.');
			// const firstField = fields[0];

			var editor = _.last(__webpack_require__(74).Editor.instances);
			// const warningHTML = '<br/><i class="nc-icon-mini ui-3_alert sma-danger-icon mr-1"></i>';

			if (fields.length == 1 && fields[0].attributes.name.nodeValue == 'section-separator') {
				modalTitle = gettext('Delete section heading');
				modalBody = gettext('Are you sure you want to delete this section heading?');
				new modals.Confirm(modalTitle, modalBody, function () {
					editor.survey.removeFields(fields);
					editor.fieldsSelected(undefined, e);
				}, {
					destroyOnClose: true,
					yes: gettext('Delete'),
					no: gettext('Cancel'),
					yes_class: 'btn-danger',
					no_class: 'btn-white'
				});
			} else {
				new modals.CheckboxModal(gettext('Delete form question', 'Delete form questions', fields.length), gettext('Deleting this question from this form will also delete any associated data that has been collected from users of this form.', 'Deleting these questions from this form will also delete any associated data that has been collected from users of this form.', fields.length), gettext('Yes, I understand that upon saving this form this question and any associated data will be permanently deleted and that this action cannot be undone.', 'Yes, I understand that upon saving this form these questions and any associated data will be permanently deleted and that this action cannot be undone.', fields.length), function () {
					editor.survey.removeFields(fields);
					editor.fieldsSelected(undefined, e);
				}, {
					destroyOnClose: true,
					contingent: true,
					isDelete: true
				});
			}
		}
	},
	move_field: {
		cls: 'btn-default',
		action: 'move_field',
		className: '',
		displayName: gettext('Move To'),
		toolTip: gettext('Click here to move the selected questions to another page'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			var editor = __webpack_require__(74).Editor.instances[0];
			var survey = editor.survey;

			var pageSelector = $('<select class="custom-select" id="moveToPage"><\/select>');

			$.each(editor.survey.pages, function (i) {
				if (this !== survey.currentPage) {
					var label = editor.languages.translate(this.label.value, editor.languages.selected());
					if (!label) {
						label = gettext('Page') + ' ' + (this.index + 1);
					} else {
						label = gettext('Page') + ' ' + (this.index + 1) + " - " + label;
					}
					pageSelector.addOption(this.id, label, false);
				}
			});

			var dialogContent = $('<div class="move-to-page">' + gettext('Move the selected questions to: ') + '<\/div>').append(pageSelector);

			var dialog = new modals.ContentModal(dialogContent, {
				title: gettext('Move Question'),
				destroyOnClose: true,
				buttons: [{
					'cls': 'btn-default',
					'label': 'Move',
					handler: function handler() {
						// Unmount potential react components
						var element = $('#survey-editor-field-options');
						_reactDom2.default.unmountComponentAtNode(element[0]);
						// Move the field to another page
						var page = survey.pageMapping[pageSelector.selectedValues()[0]];
						survey.moveFields(fields, page);
						survey.switchPage(page.index);
						editor.fieldsSelected(fields, e);
						// Hide dialog.
						dialog.destroy();
					}
				}]
			});
			dialog.show();
		}
	},
	duplicate: {
		cls: 'btn-default',
		action: 'duplicate',
		className: '',
		displayName: gettext('Duplicate'),
		toolTip: gettext('Duplicate'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, e) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}

			var editor = void 0;
			if (fields[0].editor) {
				editor = fields[0].editor;
			} else {
				editor = $(fields[0]).firstAttached(Fields.Field).editor;
			}

			var fieldInfo = void 0;
			var duplicates = [];
			for (var i = fields.length - 1; i >= 0; i--) {
				if (!fields[i].editor) {
					fieldInfo = $.extend(true, {}, $(fields[i]).firstAttached(Fields.Field).serialize());
				} else {
					fieldInfo = $.extend(true, {}, fields[i].serialize());
				}

				fieldInfo.id = (0, _utils.randomString)(10);
				fieldInfo.name = '';

				if (fieldInfo.children && fieldInfo.children.length && fieldInfo.children[0].looping) {
					delete fieldInfo.children[0]['looping'];
				}

				duplicates.push(editor.addField(undefined, fieldInfo, undefined, fields[fields.length - 1]).element);
			}
			try {
				editor.fieldsSelected(duplicates, e);
			} catch (e) {
				// Do nothing
			}
		}
	},
	edit_rules: {
		cls: 'btn-default',
		action: 'edit_rules',
		className: '',
		displayName: gettext('Edit Rules'),
		toolTip: gettext('Edit Rules'),
		groupAction: false,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return false;
		},
		handler: null
	},
	mark_optional: {
		cls: 'btn-default',
		action: 'mark_optional',
		className: '',
		displayName: gettext('Mark all as optional'),
		toolTip: gettext('Mark all as optional'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, _e) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			$(fields).each(function (_i) {
				var obj = $(this).firstAttached(Fields.Field);
				if (obj.optional) {
					obj.optional.set(true);
					obj.optional.refresh();
				} else if (obj.rows) {
					_.each(obj.rows.value, function (el) {
						el.optional.set(true);
						el.optional.refresh();
					});
				} else if (obj.variables) {
					_.each(obj.variables.value, function (el) {
						el.optional.set(true);
						el.optional.refresh();
					});
				}
			});
		}
	},
	mark_unoptional: {
		cls: 'btn-default',
		action: 'mark_unoptional',
		className: '',
		displayName: gettext('Mark all as required'),
		toolTip: gettext('Mark all as required'),
		groupAction: true,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, _e) {
			if (!fields) {
				return;
			}
			if (!fields.length) {
				fields = [fields];
			}
			$(fields).each(function (_i) {
				var obj = $(this).firstAttached(Fields.Field);
				if (obj.optional) {
					obj.optional.set(false);
					obj.optional.refresh();
				} else if (obj.rows) {
					_.each(obj.rows.value, function (el) {
						el.optional.set(false);
						el.optional.refresh();
					});
				} else if (obj.variables) {
					_.each(obj.variables.value, function (el) {
						el.optional.set(false);
						el.optional.refresh();
					});
				}
			});
		}
	},
	looping: {
		cls: 'btn-default',
		action: 'looping',
		className: 'separator',
		displayName: gettext('Looping'),
		toolTip: gettext('Looping'),
		groupAction: false,
		groupOnlyAction: false,
		inToolbox: false,
		inContextMenu: function inContextMenu() {
			return true;
		},
		handler: function handler(fields, _e) {
			// let editor = require('sma.fs/surveys/editor').Editor.instances[0];

			var field = $(fields[0]).firstAttached(Fields.Field);
			if (field.survey.looping.pageIsLooped(field.page)) {
				alert(gettext('We\'re sorry, looping within a loop is not currently supported.'));
			} else {
				field.editor.survey.looping.showForQuestion(field);
			}
		}
	},
	intersection: function intersection(fields) {
		if (!fields || !fields.length && !fields.supportedActions) {
			return [];
		}
		if (fields.length === 1) {
			fields = fields[0];
		}
		if (fields.supportedActions) {
			return $.grep(fields.supportedActions, function (el, _i) {
				return el && el.groupOnlyAction === false;
			});
		}
		return $.grep(Array.intersection($.map(fields, function (el) {
			return el.supportedActions;
		})), function (el, _i) {
			return el && el.groupAction === true;
		});
	}
};

Fields.Field = $.klass({
	type: undefined,
	qlass: undefined,
	cssType: undefined,

	displayName: 'Field',
	helpText: '',
	isVisible: true,
	isEnabled: true,

	isQuestion: true,
	isGrouped: false,
	isCustom: false,
	isDynamic: false, // Determines whether children can be disabled via branching
	isBranchable: false,

	isScorable: false,
	hasScores: false,

	extractable: false,

	supportedActions: [Fields.Actions.cut, Fields.Actions.copy, Fields.Actions.paste, Fields.Actions.del_field, Fields.Actions.move_field, Fields.Actions.duplicate, Fields.Actions.edit_rules, Fields.Actions.mark_optional, Fields.Actions.mark_unoptional],

	options: {
		displayInline: Class.create(chide.opts.Checkbox, {
			label: gettext('Display side-by-side'),
			help: gettext("Display side-by-side - In order for two questions to display side-by-side, you'll have to enable this option for both questions. The first question will be on the left and the second on the right."),
			changed: function changed(value) {
				this.field.element.toggleClass('field-inline', value);
				this.field.survey.resizeSideBySide();
			}
		}),

		appendToPrevious: Class.create(chide.opts.Checkbox, {
			label: gettext('Append to previous question'),
			help: gettext("Append to previous question - Use this to make this question appear as if it's part of the previous question. This is great for adding a comment box to the previous question.")
		}),

		width: Class.create(chide.opts.Number, {
			label: gettext('Width'),
			inputClass: 'text inline medium',
			help: gettext('Question Width - Percentage of the survey width that this question will take up. (This will not be reflected in the editor)'),
			applyEdit: false,
			min: 0,
			max: 200,
			changed: function changed(value) {
				if (value > 0 && value <= 200) {
					this.field.element.width(value + '%').width(this.field.element.width() - 22);
				} else {
					this.field.element.width('auto');
					this.set(100);
				}
			}

		}),

		optional: Class.create(chide.opts.Checkbox, {
			label: gettext('Optional'),
			fromInfo: function fromInfo(info) {
				if (info && info.required !== undefined) {
					return !info.required;
				}
				if (info && info.children && info.children.length) {
					return info.children[0].required !== undefined ? !info.children[0].required : false;
				}
				return false;
			}
		})
	},

	initialize: function initialize(info, editor) {
		var that = this;

		info = info || {};

		this.info = info;
		this.editor = editor;
		this.survey = editor.survey;

		var id = (0, _utils.randomString)(10);
		var name = void 0;

		if (info.name && !info.id) {
			// old survey
			id = info.name;
			name = undefined;
		} else if (info.id) {
			id = info.id;
			name = info.name;
		} else if (info.children && info.children[0]) {
			// old survey
			if (info.children[0].name && !info.children[0].id) {
				id = info.children[0].name;
				name = undefined;
			} else if (info.children[0].id) {
				id = info.children[0].id;
				name = info.children[0].name;
			}
		}

		this.id = id;

		this.name = new (Class.create(chide.opts.Text, {
			label: gettext('Identifier'),
			help: gettext('Identifier - (e.g., \'question1\') Identifiers are used ' + 'to refer to questions when programming advanced logic conditions.'),
			applyEdit: true,
			translatable: false,
			blankText: function blankText() {
				return gettext('None');
			},
			changed: function changed(value, old) {
				var it = this;
				var error = function error(errorMessage, old) {
					alert(errorMessage);
					it.set(old);
				};

				if (value in that.survey.nameMapping && that.survey.nameMapping[value] !== that) {
					error(gettext('Question identifiers must be unique.'), old);
					return;
				}

				if (!/^[a-zA-Z][A-Za-z0-9_]*$/.test(value)) {
					error(gettext('Question identifiers must begin with a letter, ' + 'and may only contain letters, numbers, and underscores.'), old);
					return;
				}

				if (value === 'length') {
					error(gettext('\'length\' is a reserved keyword. Enter another identifier.'), old);
					return;
				}

				if (old) {
					$('ol.page.active').trigger('childChanged', [old, value]);
					delete that.survey.nameMapping[old];
				}

				if (value) {
					that.survey.nameMapping[value] = that;
				} else {
					delete that.survey.nameMapping[value];
				}

				if (value !== undefined) {
					$('span.name', that.element).html(value);
				} else {
					$('span.name', that.element).html('');
				}
			}
		}))({
			value: name === undefined ? '' : name
		});

		if (name) {
			this.survey.nameMapping[name] = this;
		}

		this.title = new (Class.create(chide.opts.Html, {
			label: gettext('Title'),
			changed: function changed(value) {
				var title = value + (that.optional && that.optional.get() ? ' <small>' + gettext('(optional)') + '</small>' : '');
				$('.title', that.element).html(that.survey.stripScriptTags(title));
			}
		}))({
			value: that.type != 'section-separator' ? that.type != 'javascript' ? info.title || gettext('Question') + ' ' + (this.survey.getFieldCount() + 1) : info.title || gettext('JavaScript') : info.title || gettext('Section Heading')
		});

		this.description = new (Class.create(chide.opts.Html, {
			label: gettext('Description'),
			changed: function changed(value) {
				$('.description', that.element).html(that.survey.stripScriptTags(value));
			}
		}))({
			value: info.description || ''
		});

		this.displayInline = new this.options.displayInline({
			value: info.display_inline !== undefined ? !!info.display_inline : false,
			field: this
		});

		this.widthOption = new this.options.width({ value: info.width || 100, field: this });

		this.appendToPrevious = new this.options.appendToPrevious({
			value: info.appendToPrevious || false
		});

		this.page = $('ol.page.active').length - 1;

		var looping = info && info.looping || info.children && info.children[0] && info.children[0].looping || undefined;

		if (looping) {
			this.survey.looping.addLoopRule(this.id, looping);
		}

		/* hack so that firstAttached will return the field attached to an element */
		if (!Fields.Field.instances) {
			Fields.Field.instances = [];
		}
		Fields.Field.instances.push(this);
	},

	showOptions: function showOptions(options, clearOnly) {
		// Clear options and add new set of options
		// Remove React component (support for new react fields)
		var element = options[0];
		_reactDom2.default.unmountComponentAtNode(element);
		// Clear non-react components
		options.html('');
		if (!clearOnly) {
			options.append(_options.Option.renderGroup(gettext('General'), [this.name.render(), this.title.render(), this.description.render()], false));
		}
	},

	serialize: function serialize() {
		var loops = this.survey.looping.loops;

		return $.extend({
			type: 'question',
			id: this.id,
			idname: this.qlass,
			title: this.title.value,
			description: this.description.value
		}, {
			display_inline: this.displayInline.get() || undefined,
			width: this.widthOption.get() || undefined,
			appendToPrevious: this.appendToPrevious.get() || undefined,
			name: this.name.value || undefined,
			looping: this.id in loops && loops[this.id].serialize() || undefined
		});
	},

	getIdentifier: function getIdentifier(labeled, limit) {
		labeled = labeled === undefined ? true : !!labeled;
		limit = limit === undefined ? 60 : limit <= 0 ? undefined : limit;

		var name = this.name.get();

		if (!labeled) {
			return name;
		}

		var id = name ? '[' + name + '] ' + this.title.get() : this.title.get();

		id = $($('<div/>').append(id)).text();

		return id.length > limit ? id.substring(0, limit - 3) + '...' : id;
	},

	getVariables: function getVariables() {
		return [];
	},

	formatInfo: function formatInfo() {
		return {
			type: this.type,
			id: this.id,
			title: this.title.get(),
			label: this.getIdentifier(true, 60),
			vars: $.map(this.getVariables(), function (el) {
				return el.id;
			})
		};
	},

	renderContent: function renderContent() {},

	render: function render() {
		// Clear the element
		this.element.empty();

		// Build new element
		var that = this;
		var inlineFieldOptions = $('<div class="sma-js-field-actions"></div>');

		if (that.supportedActions.indexOf(Fields.Actions.looping) > -1) {
			inlineFieldOptions.append($('<a href="#" class="nc-icon-mini arrows-1_loop-82 looping"' + ('title=' + gettext('Looping') + '></a>')).tooltip());
		}

		inlineFieldOptions.append($('<a data-variable-name="' + this.id + '"></a>')).append($('<a href="#" class="nc-icon-mini gestures_drag-31 move"' + ('title="' + gettext('Move') + '"></a>')).tooltip()).append($('<a href="#" class="nc-icon-mini files_single-copy-04 duplicate"' + ('title="' + gettext('Duplicate') + '"></a>')).tooltip()).append($('<a href="#" class="nc-icon-mini ui-1_trash-simple remove"' + ('title="' + gettext('Delete') + '"></a>')).tooltip()).toggleClass('rtl', this.editor.languages.selected() === 'ar' || this.editor.languages.selected() === 'fa');

		this.element.append(inlineFieldOptions);
		this.element.toggleClass('field-inline', this.displayInline.get());
		var newWidth = parseFloat(this.widthOption.get() || 100);

		if (newWidth < 90) {
			this.element.width(newWidth + '%');
		}

		var optionalText = '';
		if (this.optional !== undefined && this.optional.get()) {
			optionalText = '<small>' + gettext('(optional)') + '</small>';
		}

		this.element.append('<span class="status"></span>', '<span class="label label-primary name">' + (that.name.get() ? that.name.get() : '') + '</span>', '<span class="title fr-view">' + that.title.get() + ' ' + optionalText + '</span>', '<h7 class="sma-question-has-score">(Scored)</h7>', '<div class="description fr-view">' + that.description.get() + '</div>');

		if (that.guideStarMapping) {
			that.guideStarMapping.toggleGuidestarLogo();
		}

		this.renderContent();
	}
});

exports.default = Fields;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class = __webpack_require__(157);

var Variable = Class.create({
	type: undefined,
	id: undefined,
	label: undefined,

	initialize: function initialize(config) {
		$.extend(this, config);
	},

	serialize: function serialize() {
		return {
			id: this.id,
			type: this.type,
			label: this.label
		};
	}
});

Variable['String'] = Class.create(Variable, {
	type: 'string'
});

Variable['Boolean'] = Class.create(Variable, {
	type: 'boolean'
});

Variable['Choice'] = Class.create(Variable, {
	serialize: function serialize($super) {
		return $.extend($super(), {
			choices: this.choices
		});
	}
});

Variable['Single'] = Class.create(Variable['Choice'], {
	type: 'single'
});

Variable['Multi'] = Class.create(Variable['Choice'], {
	type: 'multi'
});

Variable['DateTime'] = Class.create(Variable, {
	type: 'datetime'
});

Variable['SingleMeta'] = Class.create(Variable['Choice'], {
	type: 'single-meta'
});

Variable['File'] = Class.create(Variable, {
	type: 'file'
});

module.exports = Variable;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _FileUploadField = __webpack_require__(407);

var _FileField = __webpack_require__(2350);

var _FileField2 = _interopRequireDefault(_FileField);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wdsReact = __webpack_require__(9);

var _wdsIcons = __webpack_require__(32);

var _configuration = __webpack_require__(845);

var _configuration2 = _interopRequireDefault(_configuration);

__webpack_require__(2354);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploadField = function (_React$Component) {
	_inherits(FileUploadField, _React$Component);

	function FileUploadField(props) {
		_classCallCheck(this, FileUploadField);

		var _this = _possibleConstructorReturn(this, (FileUploadField.__proto__ || Object.getPrototypeOf(FileUploadField)).call(this, props));

		var enableDraftButton = function enableDraftButton() {
			var draftButton = document.getElementsByClassName('sma-js-save-draft-btn');
			if (draftButton.length) {
				draftButton[0].disabled = false;
			}
		};

		var removeFileFromList = function removeFileFromList(index, filePath) {
			var nextIndex = _this.state.nextIndex;

			var fileList = _this.state.fileList.filter(function (item) {
				var keep = true;
				if (item.props.index === index) {
					keep = false;
				}
				return keep;
			});
			// If the last item has a file and we are below the max, then create a new file field
			var lastItem = fileList[fileList.length - 1];
			var createUploadButton = false;
			if (lastItem) {
				if (lastItem.props.hasFile) {
					createUploadButton = true;
				}
			} else {
				createUploadButton = true;
			}

			if (createUploadButton) {
				var newField = createNewFile(nextIndex);
				fileList.push(newField);
				nextIndex = nextIndex + 1;
			}

			if (fileList.length === 1) {
				fileList[0].props.first = true;
			}

			var deletedFiles = [].concat(_toConsumableArray(_this.state.deletedFiles));
			if (filePath) {
				var id = _this.props.id + '_' + index + '-delete';
				var deletionField = React.createElement('input', {
					type: 'hidden',
					key: index,
					name: id,
					id: id,
					value: filePath
				});
				deletedFiles.push(deletionField);
			}
			notifyApply(_this.props.id, fileList.length > 1);
			_this.setState({
				fileList: fileList,
				deletedFiles: deletedFiles,
				nextIndex: nextIndex
			});

			enableDraftButton();
		};

		var handleInputChange = function handleInputChange(index, event) {
			var _event$target = event.target,
			    name = _event$target.name,
			    value = _event$target.value;

			var fieldName = void 0;
			if (name.indexOf('name') > -1) {
				fieldName = 'fileName';
			} else if (name.indexOf('description') > -1) {
				fieldName = 'fileDescription';
			} else {}
			// Unknown field type;


			// Add file info to the field where the file was added
			fileList.forEach(function (file) {
				if (file.props.index === index) {
					file.props[fieldName] = value;
				}
			});
		};

		var createNewFile = function createNewFile(index, name, description, file, converted) {
			var hasFile = false;
			if (file && file.length > 1) {
				hasFile = true;
			}
			var newField = new _FileField2.default({
				id: _this.props.id,
				index: index,
				hasFile: hasFile,
				disabled: _this.props.disabled,
				addFileToList: addFileToList,
				notifyApply: notifyApply,
				fileFormats: _this.props.fileFormats,
				includeDescription: _this.props.includeDescription,
				limitFileFormat: _this.props.limitFileFormat,
				maxFileSize: _this.props.maxFileSize,
				handleFileDelete: removeFileFromList,
				handleInputChange: handleInputChange,
				fileName: name,
				fileDescription: description,
				file: file,
				converted: converted,
				mediaUrl: _this.props.mediaUrl
			});
			return newField;
		};

		var notifyApply = function notifyApply(id, hasFile) {
			window.uploadHasFile[id] = hasFile;
			window.fileUploadChanged(id);
		};

		var addFileToList = function addFileToList(index, name, size, type) {
			var valid = true;
			var nameRegex = /([\w-\.\(\\) ]+)/g;
			// Validate that there is a file (Not all change events are new files selected)
			if (!name) {
				valid = false;
				_this.setState({
					showErrorModal: true,
					errors: [gettext('A file name is required.')]
				});
				// Validate that the file is of accepted size
				// Size is bytes, convert to MB
			} else if (size / 1000000 > _this.props.maxFileSize) {
				valid = false;
				var errorMessage = gettext('The selected file size is too large.  Maximum file size is: ') + '\n\t\t\t\t\t' + _this.props.maxFileSize + 'MB.';
				_this.setState({
					showErrorModal: true,
					errors: [errorMessage]
				});
				// Validate if name contains invalid characters
			} else if (name.match(nameRegex)[0] != name) {
				valid = false;
				// To get the invalid characters replace the valid ones by an empty string
				var invalidCharacters = name.replace(nameRegex, '').split('');
				var _errorMessage = gettext('We are unable to upload the selected file') + ' (' + name + ').' + (gettext('The file name contains illegal characters: ') + ' ' + invalidCharacters.join(', '));
				_this.setState({
					showErrorModal: true,
					errors: [_errorMessage, gettext('Please rename the file and try again.')]
				});
			}

			if (valid) {
				var _fileList = [].concat(_toConsumableArray(_this.state.fileList));
				var _nextIndex = _this.state.nextIndex;


				if (_this.allowMore(_fileList.length)) {
					var newField = createNewFile(_nextIndex);
					_fileList.push(newField);
				}

				if (name) {
					// Add file info to the field where the file was added
					_fileList.forEach(function (file) {
						if (file.props.index === index) {
							file.props.fileName = name;
							file.props.fileSize = size;
							file.props.fileType = type;
							file.props.hasFile = true;
						}
					});
				}

				_this.setState({
					fileList: _fileList,
					nextIndex: _this.state.nextIndex + 1
				});
			}

			return valid;
		};

		var nextIndex = 0;
		var fileList = [];
		if (props.existing && Object.keys(props.existing).length > 0) {
			var existingValues = props.existing;
			var orderedValues = {};
			Object.keys(existingValues).sort().forEach(function (key) {
				orderedValues[key] = existingValues[key];
			});
			Object.entries(orderedValues).forEach(function (_ref) {
				var _ref2 = _slicedToArray(_ref, 2),
				    key = _ref2[0],
				    value = _ref2[1];

				var file = createNewFile(parseInt(key), value.name, value.description, value.file, value.converted);
				fileList.push(file);
			});
			// The next index is the last index in the list + 1
			nextIndex = fileList[fileList.length - 1].props.index + 1;
		}

		// Add button to add new file only if max files not already hit
		if (_this.allowMore(fileList.length)) {
			var nextField = createNewFile(nextIndex);
			if (fileList.length === 0) {
				nextField.props.first = true;
			}
			fileList.push(nextField);
			nextIndex = nextIndex + 1;
		}
		_this.state = {
			fileList: fileList,
			nextIndex: nextIndex,
			deletedFiles: [],
			errors: [],
			showErrorModal: false
		};

		_this.handleErrorModalClose = _this.handleErrorModalClose.bind(_this);
		return _this;
	}

	_createClass(FileUploadField, [{
		key: 'allowMore',
		value: function allowMore(listLength) {
			var allowMore = false;
			if (listLength === 0) {
				// Always allow at least 1 file
				allowMore = true;
			} else {
				if (this.props.allowMultiple) {
					if (this.props.limitUploads) {
						if (listLength < this.props.max) {
							// Limiting uploads, but have not reached the max number of files yet
							allowMore = true;
						}
					} else {
						// We are not limiting uploads
						allowMore = true;
					}
				}
			}
			return allowMore;
		}
	}, {
		key: 'handleErrorModalClose',
		value: function handleErrorModalClose() {
			this.setState({
				showErrorModal: false
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				React.Fragment,
				null,
				React.createElement(
					_wdsReact.Modal,
					{
						show: this.state.showErrorModal,
						onClose: this.handleErrorModalClose,
						className: 'error-modal'
					},
					React.createElement(_wdsReact.ModalHeader, { header: gettext('Invalid File Selection') }),
					React.createElement(
						_wdsReact.ModalBody,
						null,
						React.createElement(
							'div',
							{ className: 'modal-container' },
							React.createElement(
								'div',
								{ className: 'left' },
								React.createElement(_wdsIcons.IconWarning, { color: 'warning', size: 'lg' })
							),
							React.createElement(
								'div',
								{ className: 'right' },
								this.state.errors.map(function (error) {
									return React.createElement(
										'p',
										{ key: error },
										error
									);
								})
							)
						)
					),
					React.createElement(
						_wdsReact.ModalFooter,
						null,
						React.createElement(
							_wdsReact.Align,
							{ placement: 'right' },
							React.createElement(
								_wdsReact.Button,
								{ onClick: this.handleErrorModalClose },
								gettext('OK')
							)
						)
					)
				),
				React.createElement(
					'div',
					{ className: 'upload-field' },
					(this.props.allowMultiple && this.props.limitUploads || this.props.maxFileSize) && React.createElement(
						'div',
						{ style: _FileUploadField.fileOptions },
						this.props.allowMultiple && this.props.limitUploads && React.createElement(
							React.Fragment,
							null,
							this.props.required && React.createElement(
								'div',
								{ style: _FileUploadField.fileOption },
								React.createElement(
									'strong',
									null,
									gettext('Minimum'),
									':'
								),
								' ',
								this.props.min
							),
							React.createElement(
								'div',
								{ style: _FileUploadField.fileOption },
								React.createElement(
									'strong',
									null,
									gettext('Maximum'),
									':'
								),
								' ',
								this.props.max
							)
						),
						this.props.maxFileSize && parseInt(this.props.maxFileSize) !== parseInt(_configuration2.default.defaults.maxFileSize) && React.createElement(
							'div',
							{ style: _FileUploadField.fileOption },
							React.createElement(
								'strong',
								null,
								gettext('Max file size'),
								':'
							),
							' ',
							this.props.maxFileSize,
							' MB'
						)
					),
					React.createElement(
						'ol',
						null,
						this.state.fileList && this.state.fileList.map(function (fileField) {
							return fileField.render({
								disabled: _this2.props.disabled,
								fileFormats: _this2.props.fileFormats,
								includeDescription: _this2.props.includeDescription,
								limitFileFormat: _this2.props.limitFileFormat,
								maxFileSize: _this2.props.maxFileSize
							});
						})
					)
				),
				this.state.deletedFiles && this.state.deletedFiles.map(function (deletedFile) {
					return deletedFile;
				})
			);
		}
	}]);

	return FileUploadField;
}(React.Component);

exports.default = FileUploadField;


FileUploadField.propTypes = {
	allowMultiple: _propTypes2.default.bool.isRequired,
	fileFormats: _propTypes2.default.string.isRequired,
	maxFileSize: _propTypes2.default.number.isRequired,
	min: _propTypes2.default.number.isRequired,
	disabled: _propTypes2.default.bool.isRequired,
	includeDescription: _propTypes2.default.bool.isRequired,
	limitFileFormat: _propTypes2.default.bool.isRequired,
	limitUploads: _propTypes2.default.bool,
	max: _propTypes2.default.number,
	mediaUrl: _propTypes2.default.string,
	required: _propTypes2.default.bool.isRequired
};

FileUploadField.defaultProps = {
	maxFileSize: 1000,
	min: 0,
	limitUploads: false,
	allowMultiple: true,
	fileFormats: '*'
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base class to save values that do not render HTML templates.
 *
 * This is a drop-in replacement for the chide.ui.Value that is used
 * in React components.  The legacy chide.ui.Value class handles rendering
 * HTML, but in this case, the React components wil handle the rendering but we
 * need a class that has the same method calls as the chide.ui.Value for when
 * passing this object back up to the legacy parent components.
 *
 * @export
 * @class Value
 */
var Value = function () {
	function Value(value, defaultValue) {
		_classCallCheck(this, Value);

		if (defaultValue && value === undefined) {
			this.internalValue = defaultValue;
		} else {
			this.internalValue = value;
		}
	}

	_createClass(Value, [{
		key: "get",
		value: function get() {
			return this.internalValue;
		}
	}, {
		key: "set",
		value: function set(value) {
			this.internalValue = value;
		}
	}, {
		key: "value",
		get: function get() {
			return this.internalValue;
		},
		set: function set(value) {
			this.internalValue = value;
		}
	}]);

	return Value;
}();

exports.default = Value;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var searchTempl = __webpack_require__(2359);

var STRINGS = {
	search_questions: gettext('Search your questions...')
};

var ElementSearch = function () {
	function ElementSearch(options) {
		_classCallCheck(this, ElementSearch);

		this.container = options.container;
		this.showAllOnEmpty = options.showAllOnEmpty;
		this.render();
	}

	_createClass(ElementSearch, [{
		key: 'render',
		value: function render() {
			var _this = this;

			this.searchForm = $(searchTempl({ strings: STRINGS }));
			this.searchForm.insertBefore(this.container);

			this.input = this.searchForm.find('input[type="search"]');
			this.input.bind('keyup', function (e) {
				if (_this.input.val()) {
					_this.searchForm.find('.sma-js-search-clear').show();
				} else {
					_this.searchForm.find('.sma-js-search-clear').hide();
				}
				_this.search();
			});
			this.clearSearchButton = this.searchForm.find('.sma-js-search-clear');
			this.clearSearchButton.click(function (e) {
				_this.clearSearch();
			});
			if (this.showAllOnEmpty) {
				this.showAllResults();
			} else {
				this.hideAllResults();
			}
		}
	}, {
		key: 'search',
		value: function search() {
			var that = this;
			var query = this.input.val();

			this.clearCollapseOverride();
			if (query.length === 0 && this.showAllOnEmpty) {
				this.showAllResults();
				return;
			}
			this.hideAllResults();
			var searchElements = this.searchElements;
			var results = [];

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = searchElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var el = _step.value;

					var $el = $(el);
					var text = this.getTextIncludingParents($el);
					text = $el.text();

					var containsQuery = text.toLowerCase().includes(query.toLowerCase());

					if (containsQuery) this.showElementAndParents($el);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'getTextIncludingParents',
		value: function getTextIncludingParents($el) {
			var text = $el.text();

			while ($el.data('parent')) {
				var $parentEl = $('[field-type="' + $el.data('parent') + '"');
				text = $parentEl.text() + ' ' + text;
				$el = $parentEl;
			}
			return text;
		}
	}, {
		key: 'showElementAndParents',
		value: function showElementAndParents($el) {
			$el.show();
			$el.addClass('sma-override-collapse');

			while ($el.data('parent')) {
				var $parentEl = $('[field-type="' + $el.data('parent') + '"');
				$parentEl.show();
				$parentEl.find('.sma-guidestar-tree-expander').hide();
				$el = $parentEl;
			}
		}
	}, {
		key: 'clearCollapseOverride',
		value: function clearCollapseOverride() {
			$.each(this.searchElements, function (idx, el) {
				$(el).removeClass('sma-override-collapse');
			});
		}
	}, {
		key: 'hideAllResults',
		value: function hideAllResults() {
			$.each(this.searchElements, function (idx, el) {
				$(el).hide();
			});
		}
	}, {
		key: 'showAllResults',
		value: function showAllResults() {
			$.each(this.searchElements, function (idx, el) {
				$(el).show();
			});

			$('.sma-guidestar-tree-expander').each(function (i, el) {
				$(el).show();
			});
		}
	}, {
		key: 'clearSearch',
		value: function clearSearch() {
			this.input.val('');
			this.clearSearchButton.hide();
			this.clearCollapseOverride();
			if (this.showAllOnEmpty) {
				this.showAllResults();
			} else {
				this.hideAllResults();
			}
		}
	}, {
		key: 'getBigrams',
		value: function getBigrams(string) {
			var s = string.toLowerCase();
			var v = new Array(s.length - 1);
			for (var i = 0, end = v.length; i <= end; i++) {
				v[i] = s.slice(i, i + 2);
			}
			return v;
		}
	}, {
		key: 'searchElements',
		get: function get() {
			return this.container.children("[id!='sma-js-search-form']").toArray();
		}
	}]);

	return ElementSearch;
}();

module.exports = ElementSearch;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {


/*
Advanced branching interface implementation for the survey editor.
 */
var AdvancedBranching, BranchAction, BranchValidationError, BranchingRule, BranchingRuleView, Filter, LogicNode, Modals, Nodes, SurveyAction, Utils,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BranchingRule = __webpack_require__(408).BranchingRule;

LogicNode = __webpack_require__(408).LogicNode;

SurveyAction = __webpack_require__(408).SurveyAction;

Utils = __webpack_require__(2361);

Nodes = __webpack_require__(1183);

Filter = __webpack_require__(1182);

Modals = __webpack_require__(6);

BranchValidationError = (function(superClass) {
  extend(BranchValidationError, superClass);

  function BranchValidationError(config) {
    _.extend(this, config);
  }

  return BranchValidationError;

})(Error);


/*
Backbone view which renders a single action for a branching rule. If
no previous action is passed in as the config, then the dropdown starts
with a "please select" option and class="inactive". Selecting an action type
causes the row to become active and a new inactive row to appear below.
 */

BranchAction = (function(superClass) {
  extend(BranchAction, superClass);

  function BranchAction() {
    return BranchAction.__super__.constructor.apply(this, arguments);
  }

  BranchAction.prototype.transfix = [gettext('Edit Rule'), gettext('Save Rule')];

  BranchAction.prototype.events = {
    'change select.action': 'onActionChanged',
    'click a.remove': 'remove'
  };

  BranchAction.prototype.tagName = 'li';

  BranchAction.prototype.initialize = function(config) {
    _.bindAll(this, 'onActionChanged', 'remove');
    this.dialog = config.dialog;
    this.action = config != null ? config.action : void 0;
    this.actionOptions = $('<div class="action-options"/>');
    return this.$el.data('view', this);
  };

  BranchAction.prototype.remove = function() {
    this.$el.remove();
    return false;
  };

  BranchAction.prototype.actionType = function() {
    return this.$('.action').val();
  };

  BranchAction.prototype.onActionChanged = function() {
    var next;
    if (this.$el.hasClass('inactive') && this.actionType()) {
      this.$('.action .light').prop('disabled', true);
      this.$el.removeClass('inactive');
      next = new BranchAction({
        dialog: this.dialog
      });
      next.$el.insertAfter(this.$el);
      next.render().hide().slideDown().fadeIn();
    }
    return this.refreshActionOptions();
  };

  BranchAction.prototype.render = function() {
    var action, first, ref, ref1;
    this.$el.empty();
    first = this.$el.parent().children(':first').is(this.$el);
    if (!first) {
      this.$el.html('<div class="float-right"><a href="#" class="icon icon-only icon-delete remove">Delete</a></div>');
    }
    action = this.renderActions(first);
    if ((ref = this.action) != null ? ref.type : void 0) {
      action.find('.light').prop('disabled', true);
      action.val((ref1 = this.action) != null ? ref1.type : void 0);
    }
    if (!this.action) {
      this.$el.addClass('inactive');
    }
    this.$el.append(action, this.actionOptions);
    this.refreshActionOptions();
    return this.$el;
  };

  BranchAction.prototype.renderActions = function(branch) {
    var action, advancedActions, branchingActions, group, opt;
    if (branch == null) {
      branch = true;
    }
    opt = function(type) {
      return $('<option/>', {
        value: type,
        text: SurveyAction.TYPES[type].prototype.label
      });
    };
    group = function(label, items) {
      var item, ref;
      return (ref = $('<optgroup/>').attr('label', label)).append.apply(ref, (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = items.length; j < len; j++) {
          item = items[j];
          results.push(opt(item));
        }
        return results;
      })());
    };
    branchingActions = ['skip', 'finish', 'terminate', 'random'];
    if (this.dialog.survey.pages.length === 1 + this.dialog.survey.currentPage.index) {
      branchingActions = ['finish', 'terminate'];
    }
    if (this.dialog.survey.currentPage.isLooped()) {
      branchingActions.push('continue');
    }
    if (branch) {
      advancedActions = ['redirect', 'mark-complete', 'random-range'];
      if (this.dialog.survey.pages.length === 1 + this.dialog.survey.currentPage.index) {
        advancedActions = ['redirect', 'mark-complete'];
      }
    } else {
      advancedActions = ['mark-complete'];
    }
    action = $('<select class="action custom-select" name="action" />').append($('<option class="light" value="" />').html(gettext('Select an action...')));
    if (branch) {
      action.append(group(gettext('Branching'), branchingActions));
    }
    action.append(group(gettext('Dynamic'), ['hide', 'show', 'disable', 'mark-invalid', 'hide-page']), group(gettext('Advanced'), advancedActions));
    return action;
  };

  BranchAction.prototype.refreshActionOptions = function() {
    var el, j, k, len, len1, page, page_re, ref, ref1, ref10, ref11, ref12, ref13, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, selector;
    this.actionOptions.empty();
    switch (this.actionType()) {
      case 'hide':
      case 'show':
      case 'disable':
        selector = Utils.prototype.buildSourceDropdown(this.dialog.survey.formatInfo(), {
          showEmpty: true,
          varPred: true,
          questionPred: true,
          pagePred: (function(_this) {
            return function(page) {
              return page.index >= _this.dialog.page.index;
            };
          })(this),
          showRowsAndColumns: true,
          show3DVariables: false
        });
        selector.attr('name', 'target');
        if (((ref = this.action) != null ? ref.getTargetId : void 0) != null) {
          selector.val(this.action.getTargetId());
        }
        return this.actionOptions.append(selector);
      case 'mark-invalid':
        selector = Utils.prototype.buildSourceDropdown(this.dialog.survey.formatInfo(), {
          showEmpty: true,
          varPred: true,
          questionPred: true,
          pagePred: (function(_this) {
            return function(page) {
              return page.index >= _this.dialog.page.index;
            };
          })(this),
          showRowsAndColumns: true,
          show3DVariables: false
        });
        selector.attr('name', 'target');
        if (((ref1 = this.action) != null ? ref1.getTargetId : void 0) != null) {
          selector.val(this.action.getTargetId());
        }
        this.actionOptions.append(selector);
        el = $('<input type="text" class="text invalid-msg form-control" name="feedback" rel="tooltip" placeholder="Enter the message when the question is invalid"/>');
        if ((ref2 = this.action) != null ? ref2.feedback : void 0) {
          el.val((ref3 = this.action) != null ? ref3.feedback : void 0);
        }
        return this.actionOptions.append(el);
      case 'skip':
      case 'hide-page':
        selector = $('<select name="page" class="custom-select" />');
        ref4 = this.dialog.survey.pages;
        for (j = 0, len = ref4.length; j < len; j++) {
          page = ref4[j];
          if (page.index > this.dialog.page.index) {
            selector.append($('<option/>').val(page.id).text(page.label.display()));
          }
        }
        this.actionOptions.append(selector);
        if ((ref5 = this.action) != null ? ref5.page : void 0) {
          return selector.val(this.action.page);
        }
        break;
      case 'redirect':
        el = $('<input type="text" class="text form-control" name="url" />').appendTo(this.actionOptions);
        if ((ref6 = this.action) != null ? ref6.url : void 0) {
          return el.val((ref7 = this.action) != null ? ref7.url : void 0);
        }
        break;
      case 'random':
        el = $('<input type="text" class="text form-control" name="pages" />').appendTo(this.actionOptions);
        page_re = RegExp('^([0-9]+,)*[0-9]+$');
        el.bind('focusout', function() {
          $(this).val($(this).val().replace(/\s/g, ''));
          if (!page_re.test($(this).val())) {
            new sma.components.Alert({
              message: gettext('Please enter a comma-separated list of values (example: 4,5,6)'),
              type: 'warning'
            });
            return $(this).val('');
          }
        });
        if ((ref8 = this.action) != null ? ref8.pages : void 0) {
          return el.val((ref9 = this.action) != null ? ref9.pages : void 0);
        }
        break;
      case 'random-range':
        el = $('<input type="text" class="text form-control" name="pages" rel="tooltip" title="Enter a comma-separated list of pages"/>').appendTo(this.actionOptions);
        page_re = RegExp('^([0-9]+,)+[0-9]+$');
        el.bind('focusout', function() {
          $(this).val($(this).val().replace(/\s/g, ''));
          if (!page_re.test($(this).val())) {
            new sma.components.Alert({
              message: gettext('Please enter a comma-separated list of values (example: 4,5,6)'),
              type: 'warning'
            });
            return $(this).val('');
          }
        });
        if ((ref10 = this.action) != null ? ref10.pages : void 0) {
          el.val((ref11 = this.action) != null ? ref11.pages : void 0);
        }
        this.actionOptions.append(gettext(' then skip to '));
        selector = $('<select name="after" class="custom-select" />');
        ref12 = this.dialog.survey.pages;
        for (k = 0, len1 = ref12.length; k < len1; k++) {
          page = ref12[k];
          if (page.index > this.dialog.page.index) {
            selector.append($('<option/>').val(page.id).text(page.label.display()));
          }
        }
        this.actionOptions.append(selector);
        if ((ref13 = this.action) != null ? ref13.after : void 0) {
          return selector.val(this.action.after);
        }
    }
  };

  BranchAction.prototype.serialize = function() {
    var action, cls, error, j, len, name, options, ref, ref1, type, value;
    type = this.actionType();
    cls = SurveyAction.TYPES[type];
    options = {};
    ref = this.actionOptions.find(':input').serializeArray();
    for (j = 0, len = ref.length; j < len; j++) {
      ref1 = ref[j], name = ref1.name, value = ref1.value;
      options[name] = value;
    }
    error = (function(_this) {
      return function() {
        throw new BranchValidationError({
          target: _this
        });
      };
    })(this);
    action = (function() {
      switch (type) {
        case 'finish':
        case 'terminate':
        case 'continue':
        case 'mark-complete':
          return new cls();
        case 'skip':
        case 'hide-page':
          return new cls(options.page);
        case 'hide':
        case 'disable':
        case 'show':
          if (options.target === '-') {
            error();
          }
          return new cls(options.target);
        case 'mark-invalid':
          if (options.target === '-') {
            error();
          }
          return new cls(options.target, options.feedback);
        case 'redirect':
          if (!options.url) {
            error();
          }
          return new cls(options.url);
        case 'random':
          if (!options.pages) {
            error();
          }
          return new cls(options.pages);
        case 'random-range':
          if (!options.pages) {
            error();
          }
          return new cls(options.pages, options.after);
      }
    })();
    return action;
  };

  return BranchAction;

})(Backbone.View);


/*
Dialog pane for a single branching rule, allows editing both the rule
condition logic and the resulting survey actions. The @model is an
instance of BranchingRule.
 */

BranchingRuleView = (function(superClass) {
  extend(BranchingRuleView, superClass);

  function BranchingRuleView() {
    return BranchingRuleView.__super__.constructor.apply(this, arguments);
  }

  BranchingRuleView.prototype.trans = {
    ruleCondition: gettext("Conditions"),
    ruleActions: gettext("Do these Actions")
  };

  BranchingRuleView.prototype.initialize = function(config) {
    var ref;
    this.dialog = config != null ? config.dialog : void 0;
    return this.survey = (ref = this.dialog) != null ? ref.survey : void 0;
  };

  BranchingRuleView.prototype.render = function() {
    var action, current_filters, el, index, j, key, len, page, questions, ref, ref1, ref2, ref3, ref4, ref5, ref6, survey_info, that, value, variables;
    that = this;
    this.$el.html(_.template("<h3>" + BranchingRuleView.prototype.trans.ruleCondition + "</h3>\n<div class=\"branching-condition mb-4\"></div>\n<h3>" + BranchingRuleView.prototype.trans.ruleActions + "</h3>\n<ol class=\"branching-actions\"></ol>"));
    survey_info = this.survey.formatInfo();
    survey_info.collector_variables = [];
    survey_info.isBranching = true;
    questions = {};
    ref = survey_info.pages;
    for (index in ref) {
      page = ref[index];
      questions[page.page] = {
        data: []
      };
      ref1 = page.questions;
      for (key in ref1) {
        value = ref1[key];
        if ((ref2 = survey_info.questions[value].type) !== 'section-separator' && ref2 !== 'javascript') {
          questions[page.page].data.push(survey_info.questions[value]);
        }
      }
      if (questions[page.page].data.length === 0) {
        delete questions[page.page];
      }
    }
    variables = [];
    ref3 = survey_info.variables;
    for (key in ref3) {
      value = ref3[key];
      variables.push(value);
    }
    questions['Variables'] = {
      data: variables
    };
    if (this.model) {
      current_filters = this.model.condition.serialize(survey_info);
      if (current_filters.items == null) {
        current_filters = {
          type: 'AND',
          items: [current_filters]
        };
      }
    } else {
      current_filters = {};
    }
    this.condition = new Filter({}, {
      filters: questions,
      current_filters: current_filters
    });
    this.$('.branching-condition').append(this.condition.element);
    $(this.condition.element).find('select:eq(0)').blur(function(e) {
      if (!$(this).val()) {
        return $(this).val('-');
      }
    });
    ref6 = (ref4 = ((ref5 = this.model) != null ? ref5.actions : void 0)) != null ? ref4 : [];
    for (j = 0, len = ref6.length; j < len; j++) {
      action = ref6[j];
      el = new BranchAction({
        action: action,
        dialog: this.dialog
      });
      this.$('.branching-actions').append(el.$el);
      el.render();
    }
    el = new BranchAction({
      dialog: this.dialog
    });
    this.$('.branching-actions').append(el.$el);
    el.render();
    return this.$el;
  };

  BranchingRuleView.prototype.serialize = function() {
    var actions, condition, e;
    try {
      condition = LogicNode.prototype.parse(this.condition.serialize(true));
    } catch (error1) {
      e = error1;
      new sma.components.Alert({
        message: e.message,
        type: 'error'
      });
      $(e.element).stop().css('background-color', 'transparent').effect('highlight', {
        color: '#d06460'
      }, 6000);
      return;
    }
    actions = [];
    _.each(this.$('.branching-actions > li:not(.inactive)'), function(el) {
      var action;
      if ((action = $(el).data('view').serialize())) {
        return actions.push(action);
      }
    });
    return {
      condition: condition,
      actions: actions
    };
  };

  return BranchingRuleView;

})(Backbone.View);

AdvancedBranching = (function(superClass) {
  extend(AdvancedBranching, superClass);

  function AdvancedBranching() {
    return AdvancedBranching.__super__.constructor.apply(this, arguments);
  }

  AdvancedBranching.prototype.translatables = {
    addBranchingRule: gettext('Add Branching Rule'),
    deleteRule: gettext('Delete'),
    noBranchingRules: gettext('This page currently has no branching rules.'),
    addNewRule: gettext('Add a new rule'),
    otherwise: gettext('If no other branching conditions apply, skip to'),
    branchingOrder: gettext('Branching rules are applied in the order they appear in this list'),
    editRule: gettext('Edit'),
    reorderRule: gettext('Reorder')
  };

  AdvancedBranching.prototype.maketemplate = _.wrap(_.template, function(f, templateString, context) {
    var val;
    val = f(templateString, context);
    if (!_.isFunction(val)) {
      return val;
    } else {
      return _.wrap(val, function(func, context, isntance) {
        return func({
          data: _.extend({}, context),
          trans: this.translatables
        });
      });
    }
  });

  AdvancedBranching.prototype.template = AdvancedBranching.prototype.maketemplate("<div class='tools row'>\n	<div class=\"col-12\">\n		<a href='#' class='float-right btn btn-primary btn-loud new-rule'>\n			<span class='icon icon-add'><%- trans.addBranchingRule %></span>\n		</a>\n	</div>\n</div>\n<% if (data.branching.length) { %>\n	<div class=\"ml-5 mt-3\"><%- trans.branchingOrder %></div>\n	<ol class='branching-rules'>\n	<% _.each(data.branching, function(rule, i) { %>\n		<li data-index='<%- i %>'>\n			<div class='float-right'>\n				<div class=\"sma-branching-actions\">\n					<a href='#' class='edit ml-4' title=\"<%- trans.editRule %>\">\n						<i class=\"nc-icon-mini ui-1_pencil\"></i>\n					</a>\n					<a href='#' class='move ml-4' title=\"<%- trans.reorderRule %>\">\n						<i class=\"nc-icon-mini gestures_drag-31\"></i>\n					</a>\n					<a href='#' class='remove ml-4' title=\"<%- trans.deleteRule %>\">\n						<i class=\"nc-icon-mini ui-1_trash-simple\"></i>\n					</a>\n				</div>\n			</div>\n			<%- rule.format(data.survey.formatInfo()) %>\n		</li>\n	<% }) %>\n	</ol>\n<% } else { %>\n	<div class='empty-help'>\n		<%- trans.noBranchingRules %>\n	</div>\n<% } %>\n<% if (data.survey.pages.length > 1) { %>\n	<div class=\"text-center\">\n		<%- trans.otherwise %> <span class='otherwise'></span>\n	</div>\n<% } %>");

  AdvancedBranching.prototype.events = {
    'click .new-rule': 'newRuleClicked',
    'click .branching-rules li': 'ruleClicked',
    'click .branching-rules li a.remove': 'deleteRuleClicked'
  };

  AdvancedBranching.prototype.className = 'branching-dialog';

  AdvancedBranching.updateRules = function(survey, branching) {
    var j, len, ref, rule, rules;
    rules = [];
    ref = branching != null ? branching : [];
    for (j = 0, len = ref.length; j < len; j++) {
      rule = ref[j];
      rule = BranchingRule.prototype.parse(rule);
      if ((rule != null) && rule.validate(survey)) {
        rules.push(rule);
      }
    }
    return rules;
  };

  AdvancedBranching.formatRules = function(survey, branching) {
    var j, len, ref, results, rule;
    ref = this.updateRules(survey.formatInfo(), branching);
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      rule = ref[j];
      results.push(rule.format(survey.formatInfo()));
    }
    return results;
  };

  AdvancedBranching.unserializePageIDs = function(survey, branching) {
    var action, j, k, len, len1, ref, ref1, ref2, ref3, rule;
    for (j = 0, len = branching.length; j < len; j++) {
      rule = branching[j];
      ref1 = (ref = rule.actions) != null ? ref : [rule.action];
      for (k = 0, len1 = ref1.length; k < len1; k++) {
        action = ref1[k];
        if (action.page != null) {
          action.page = ((ref2 = survey.pageMapping) != null ? ref2 : survey.pages)[action.page].index;
        }
        if (action.after != null) {
          action.after = ((ref3 = survey.pageMapping) != null ? ref3 : survey.pages)[action.after].index;
        }
      }
    }
    return branching;
  };

  AdvancedBranching.prototype.initialize = function(config) {
    var e, ref;
    if (config == null) {
      config = {};
    }
    _.bindAll(this, 'newRuleClicked', 'ruleClicked', 'deleteRuleClicked', 'updateRuleOrder');
    this.survey = config.survey;
    this.page = config.page;
    this.callback = config.callback;
    this.branching = this.constructor.updateRules(this.survey.formatInfo(), (ref = config.branching) != null ? ref : []);
    try {
      this.initialBranching = this.serialize();
    } catch (error1) {
      e = error1;
      this.initialBranching = [];
    }
    return this.ruleView = new BranchingRuleView({
      dialog: this
    });
  };

  AdvancedBranching.prototype.serialize = function() {
    var j, len, ref, results, rule;
    ref = this.branching;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      rule = ref[j];
      results.push(rule.serialize(this.survey.formatInfo()));
    }
    return results;
  };

  AdvancedBranching.prototype.render = function() {
    return this.$el.html(this.template(this));
  };

  AdvancedBranching.prototype.show = function() {
    if (!this.dialog) {
      this.dialog = new Modals.ContentModal(this.el, {
        title: gettext('Branching Editor'),
        buttons: [],
        size: 'lg'
      });
    }
    this.dialog.show();
    return this.showRules();
  };

  AdvancedBranching.prototype.showRules = function() {
    this.$el.html(this.template(this));
    this.$('.branching-rules').sortable({
      update: this.updateRuleOrder
    });
    this.dialog.setButtons([
      {
        label: gettext('Cancel'),
        cls: 'btn btn-link btn-loud',
        handler: (function(_this) {
          return function(modal) {
            return modal.hide();
          };
        })(this)
      }, {
        label: gettext('Save'),
        cls: 'btn btn-primary btn-loud',
        handler: (function(_this) {
          return function(modal) {
            var branching;
            branching = _this.serialize();
            _this.callback(branching, _this.$('.otherwise select').val());
            return modal.hide();
          };
        })(this)
      }
    ]);
    this.$('.otherwise').append(this.page.renderBranchingSelect());
    this.$('.branching-rules').sortable({
      update: this.updateRuleOrder
    });
    return this.$el;
  };

  AdvancedBranching.prototype.updateRuleOrder = function() {
    var branching;
    branching = [];
    this.$('.branching-rules li').each((function(_this) {
      return function(i, el) {
        branching.push(_this.branching[$(el).data('index')]);
        return $(el).data('index', i);
      };
    })(this));
    return this.branching = branching;
  };

  AdvancedBranching.prototype.editRule = function(rule) {

    /*
    		Note that we disable closeOnEscape because with all the dropdowns and form inputs
    		in this dialog the user is likely to press escape, which would destroy all changes.
    		Passing rule=false skips the view rendering but updates the dialog title/buttons.
     */
    this.dialog.setTitle(gettext('Branching Editor') + ' &mdash; ' + gettext('Edit Rule'));
    this.dialog.setButtons([
      {
        label: gettext('Cancel'),
        cls: 'btn btn-link btn-loud',
        handler: (function(_this) {
          return function() {
            return _this.showRules();
          };
        })(this)
      }, {
        label: gettext('Save Rule'),
        cls: 'btn btn-primary btn-loud',
        handler: (function(_this) {
          return function() {
            var e, model, serialized;
            try {
              serialized = _this.ruleView.serialize();
            } catch (error1) {
              e = error1;
              e.target.$el.effect('highlight', {
                color: '#d06460'
              }, 6000);
            }
            if (serialized == null) {
              return;
            }
            if (!serialized.actions.length) {
              new sma.components.Alert({
                message: gettext('Please add at least one branching action.'),
                type: 'danger'
              });
              return;
            }
            model = _this.ruleView.model;
            if (!model) {
              _this.branching.push(model = new BranchingRule());
            }
            model.actions = serialized.actions;
            model.condition = serialized.condition;
            return _this.showRules();
          };
        })(this)
      }
    ]);
    if (rule !== false) {
      this.ruleView.model = rule;
      this.ruleView.page = this.page.index;
      return this.$el.empty().append(this.ruleView.render());
    }
  };

  AdvancedBranching.prototype.ruleClicked = function(e) {
    e.preventDefault();
    return this.editRule(this.branching[this.$('.branching-rules li').index(e.currentTarget)]);
  };

  AdvancedBranching.prototype.deleteRuleClicked = function(e) {
    e.preventDefault();
    new Modals.Confirm(gettext('Remove rule'), gettext("Are you sure you want to remove this rule?"), (function(_this) {
      return function() {
        var index, row;
        row = $(e.currentTarget).closest('li');
        index = _this.$('.branching-rules li').index(row);
        _this.branching.splice(index, 1);
        return _this.render();
      };
    })(this));
    return false;
  };

  AdvancedBranching.prototype.newRuleClicked = function(e) {
    e.preventDefault();
    this.editRule();
    return false;
  };

  return AdvancedBranching;

})(Backbone.View);

module.exports = AdvancedBranching;


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

var ContextObject, ListContext, QuestionContext, ThreeDMatrixContext, VariableContext,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ContextObject = (function() {
  function ContextObject() {}

  ContextObject.prototype.label = function() {};

  ContextObject.prototype.value = function() {};

  ContextObject.prototype.score = function() {};

  return ContextObject;

})();

QuestionContext = (function(superClass) {
  extend(QuestionContext, superClass);

  function QuestionContext(question, response) {
    var i, ref, variable;
    this.question = question;
    this.response = response;
    this.variables = [];
    ref = this.question.variables();
    for (i in ref) {
      variable = ref[i];
      if (!variable.get('choice') && !variable.id.endsWith('_na')) {
        this.variables.push(new VariableContext(variable, this.response));
      }
    }
  }

  QuestionContext.prototype.label = function() {
    var j, labels, len, ref, variable;
    labels = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        labels.push(variable.label());
      }
    }
    if (!labels.length) {
      return '';
    } else if (labels.length === 1) {
      return labels[0];
    } else {
      return labels;
    }
  };

  QuestionContext.prototype.value = function() {
    var j, len, ref, values, variable;
    values = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        values.push(variable.value());
      }
    }
    if (!values.length) {
      return '';
    } else if (values.length === 1) {
      return values[0];
    } else {
      return values;
    }
  };

  QuestionContext.prototype.score = function() {
    var j, len, ref, scores, variable;
    scores = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        scores.push(variable.score());
      }
    }
    if (!scores.length) {
      return 0;
    } else if (scores.length === 1) {
      return scores[0];
    } else {
      return scores;
    }
  };

  QuestionContext.prototype.slice = function(start, end) {
    return new ListContext(this.variables.slice(start, +(end - 1) + 1 || 9e9));
  };

  return QuestionContext;

})(ContextObject);

ThreeDMatrixContext = (function(superClass) {
  extend(ThreeDMatrixContext, superClass);

  function ThreeDMatrixContext(question, response) {
    var col, columns, i, j, k, l, len, len1, len2, ref, row, rows, variable;
    ThreeDMatrixContext.__super__.constructor.call(this, question, response);
    this.row_array = [];
    rows = question.rows || question.attributes.rows;
    columns = question.columns || question.attributes.columns;
    for (i = j = 0, len = rows.length; j < len; i = ++j) {
      row = rows[i];
      this.row_array.push(this.variables.slice(i * columns.length, +((i + 1) * columns.length - 1) + 1 || 9e9));
    }
    this.col_array = [];
    for (k = 0, len1 = columns.length; k < len1; k++) {
      col = columns[k];
      this.col_array.push([]);
    }
    ref = this.variables;
    for (i = l = 0, len2 = ref.length; l < len2; i = ++l) {
      variable = ref[i];
      this.col_array[i % columns.length].push(variable);
    }
  }

  ThreeDMatrixContext.prototype.row = function(index) {
    return new ListContext(this.row_array[index]);
  };

  ThreeDMatrixContext.prototype.col = function(index) {
    return new ListContext(this.col_array[index]);
  };

  return ThreeDMatrixContext;

})(QuestionContext);

VariableContext = (function(superClass) {
  extend(VariableContext, superClass);

  function VariableContext(variable1, response1) {
    var base, ref;
    this.variable = variable1;
    this.response = response1;
    this.has_other = false;
    this.choices = (ref = typeof (base = this.variable).choices === "function" ? base.choices() : void 0) != null ? ref : [];
  }

  VariableContext.prototype.label = function() {
    var choice, j, label, len, other, other_text, ref, value;
    value = this.value();
    if (this.choices.length) {
      label = [];
      ref = this.choices;
      for (j = 0, len = ref.length; j < len; j++) {
        choice = ref[j];
        if (_.include((value instanceof Array ? value != null ? value : [] : [parseInt(value)]), choice.id)) {
          if (!choice.get('other')) {
            label.push(choice.label());
          } else {
            other = $.extend({}, choice.get('other'));
            other_text = (new VariableContext(other, this.response)).value();
            label.push(other_text || choice.label());
          }
        }
      }
      return label;
    }
    return this.variable.getPipedValue(value);
  };

  VariableContext.prototype.value = function() {
    if (this.response[this.variable.id + '_0']) {
      return this.response[this.variable.id + '_0'];
    } else {
      return this.response[this.variable.id];
    }
  };

  VariableContext.prototype.score = function() {
    return this.variable.getScore(this.value());
  };

  return VariableContext;

})(ContextObject);

ListContext = (function(superClass) {
  extend(ListContext, superClass);

  function ListContext(object_list) {
    this.variables = object_list;
  }

  ListContext.prototype.label = function() {
    var j, labels, len, ref, variable;
    labels = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        labels.push(variable.label());
      }
    }
    if (!labels.length) {
      return '';
    } else if (labels.length === 1) {
      return labels[0];
    } else {
      return labels;
    }
  };

  ListContext.prototype.value = function() {
    var j, len, ref, values, variable;
    values = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        values.push(variable.value());
      }
    }
    if (!values.length) {
      return '';
    } else if (values.length === 1) {
      return values[0];
    } else {
      return values;
    }
  };

  ListContext.prototype.score = function() {
    var j, len, ref, scores, variable;
    scores = [];
    ref = this.variables;
    for (j = 0, len = ref.length; j < len; j++) {
      variable = ref[j];
      if (!EvaluationVisitor.prototype.is_empty(variable.value())) {
        scores.push(variable.score());
      }
    }
    if (!scores.length) {
      return 0;
    } else if (scores.length === 1) {
      return scores[0];
    } else {
      return scores;
    }
  };

  ListContext.prototype.slice = function(start, end) {
    return new ListContext(this.variables.slice(start, +(end - 1) + 1 || 9e9));
  };

  return ListContext;

})(ContextObject);

_.extend(exports, {
  QuestionContext: QuestionContext,
  VariableContext: VariableContext,
  ThreeDMatrixContext: ThreeDMatrixContext
});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var BooleanVariable, BranchingRule, DateTimeVariable, DisableAction, HiddenVariable, InvalidAction, MultipleChoiceVariable, OrNode, PredicateNode, Question, SingleChoiceVariable, Variable, cls, name,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

OrNode = __webpack_require__(45).OrNode;

PredicateNode = __webpack_require__(45).PredicateNode;

BranchingRule = __webpack_require__(45).BranchingRule;

DisableAction = __webpack_require__(45).DisableAction;

InvalidAction = __webpack_require__(45).InvalidAction;

SingleChoiceVariable = __webpack_require__(87).SingleChoiceVariable;

MultipleChoiceVariable = __webpack_require__(87).MultipleChoiceVariable;

BooleanVariable = __webpack_require__(87).BooleanVariable;

HiddenVariable = __webpack_require__(87).HiddenVariable;

Variable = __webpack_require__(87).Variable;

DateTimeVariable = __webpack_require__(87).DateTimeVariable;

Question = (function(superClass) {
  extend(Question, superClass);

  function Question() {
    return Question.__super__.constructor.apply(this, arguments);
  }

  Question.TYPES = {};

  Question.type = 'question';

  Question.create = function(info, options) {
    var cls, ref, ref1;
    cls = (ref = this.TYPES[(ref1 = info.idname) != null ? ref1 : info.type]) != null ? ref : this;
    return new cls(cls.parse(info), options);
  };

  Question.parse = function(info) {
    return {
      id: info.id,
      name: info.name,
      title: trans.make(info.title),
      description: info.description != null ? trans.make(info.description) : void 0,
      appendToPrevious: info.appendToPrevious || void 0,
      displayInline: info.display_inline || void 0,
      questionWidth: (info.width != null) && info.width < 100 ? info.width : void 0
    };
  };

  Question.prototype.escapedId = function() {

    /* Returns this question's identifier suitable for use in a jQuery selector. */
    return this.id.replace(/([\.:])/g, "\\$1");
  };

  Question.prototype.name = function(suffix) {
    if (suffix == null) {
      suffix = '';
    }
    if (this.get('name')) {
      return this.get('name') + suffix;
    } else {
      return void 0;
    }
  };

  Question.prototype.variables = function() {
    return {};
  };

  Question.prototype.validateResponse = function(response) {};

  Question.prototype.dynamics = function() {};

  Question.prototype.render = function() {
    return $('<div/>').attr('id', "x_" + this.id).addClass("question question-" + this.id + " question-" + this.constructor.type).toggleClass("append-to-previous", !!this.get('appendToPrevious')).toggleClass("question-inline", !!this.get('displayInline')).toggleClass("force-unique", !!this.get('unique') || this instanceof Question.Ranking).toggleClass("appearance-" + (this.get('appearance')), !!this.get('appearance')).css('width', this.get('questionWidth') ? (this.get('questionWidth')) + "%" : '').append(this.renderHeader(), $('<div class="question-body"/>').append(this.renderContents()));
  };

  Question.prototype.renderHeader = function() {
    var ref;
    return $('<div class="question-header"/>').append($('<h2 class="question-title"/>').html(Survey.pipe(this.get('title').toString())), Survey.pipe(((ref = this.get('description')) != null ? ref : '').toString()));
  };

  Question.prototype.renderContents = function() {
    var vars;
    if (this.template != null) {
      return CoffeeKup.render(this.template, {
        context: this
      });
    }
    vars = this.variables();
    if ('' in vars) {
      return vars[''].render();
    }
  };

  Question.prototype.onSurveyBuilt = function(survey) {};

  Question.prototype.setupElement = function(el, handler) {
    return el;
  };

  Question.prototype.replacePipedString = function(str) {
    var ids, piped, vars;
    vars = survey.variablesByName();
    ids = survey.variables();
    piped = function(value) {
      var ref, source;
      if (value === 'metas.weighted_score') {
        return this.response.weightedScore;
      } else if (piped[value] != null) {
        return piped[value];
      } else {
        source = (ref = vars[value]) != null ? ref : ids[value];
        if (source != null) {
          return source.getPipedValue(handler.response.values[source.id]);
        }
      }
    };
    if (str.match(/\{\{\s*([\w\-\.]+)\s*\}\}/g)) {
      return piped(str.replace(/\{\{\s*([\w\-\.]+)\s*\}\}/g, "$1"));
    } else {
      return str;
    }
  };

  return Question;

})(Backbone.Model);

Question.SectionSeparator = (function(superClass) {
  extend(SectionSeparator, superClass);

  function SectionSeparator() {
    return SectionSeparator.__super__.constructor.apply(this, arguments);
  }

  SectionSeparator.type = 'section-separator';

  return SectionSeparator;

})(Question);

Question.JavaScript = (function(superClass) {
  extend(JavaScript, superClass);

  function JavaScript() {
    return JavaScript.__super__.constructor.apply(this, arguments);
  }

  JavaScript.type = 'javascript';

  JavaScript.prototype.render = function() {
    var ref;
    return $('<script type="text/javascript"/>').append("setTimeout(function(){" + Survey.pipe(((ref = this.get('description')) != null ? ref : '').toString() + "}, 0);"));
  };

  return JavaScript;

})(Question);

Question.Hidden = (function(superClass) {
  extend(Hidden, superClass);

  function Hidden() {
    return Hidden.__super__.constructor.apply(this, arguments);
  }

  Hidden.type = 'hidden-field';

  Hidden.parse = function(info) {
    var initialValue, ref, ref1;
    initialValue = (ref = info.children) != null ? (ref1 = ref[0]) != null ? ref1.initialValue : void 0 : void 0;
    return _.extend(Question.parse(info), {
      initialValue: initialValue
    });
  };

  Hidden.prototype.variables = function() {
    return {
      '': new HiddenVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        initialValue: this.get('initialValue')
      })
    };
  };

  return Hidden;

})(Question);

Question.FileUpload = (function(superClass) {
  extend(FileUpload, superClass);

  function FileUpload() {
    return FileUpload.__super__.constructor.apply(this, arguments);
  }

  FileUpload.type = 'file-field';

  FileUpload.prototype.template = function() {
    var env;
    env = detect();
    if ((typeof cordova !== "undefined" && cordova !== null) && (typeof camera !== "undefined" && camera !== null)) {
      return div({
        "class": 'camera'
      }, function() {
        input({
          id: 'id_' + this.id,
          type: 'hidden',
          name: this.id
        });
        label({
          "class": 'no-picture'
        }, function() {
          return text('choose a picture');
        });
        div({
          "class": 'button delete',
          onclick: 'camera(this.parentNode)'
        });
        div({
          "class": 'button library',
          onclick: 'camera(this.parentNode, navigator.camera.PictureSourceType.PHOTOLIBRARY)'
        });
        return div({
          "class": 'button cam',
          onclick: 'camera(this.parentNode, navigator.camera.PictureSourceType.CAMERA)'
        });
      });
    } else {
      return div({
        "class": 'warning'
      }, function() {
        return text('File upload is not supported');
      });
    }
  };

  return FileUpload;

})(Question.Hidden);

Question.TextResponse = (function(superClass) {
  extend(TextResponse, superClass);

  function TextResponse() {
    return TextResponse.__super__.constructor.apply(this, arguments);
  }

  TextResponse.type = 'text-response';

  TextResponse.parse = function(info) {
    var appearance, columns, initialValue, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, required, rows, validation;
    rows = (ref = (ref1 = info.children) != null ? (ref2 = ref1[0]) != null ? ref2.rows : void 0 : void 0) != null ? ref : info.rows;
    columns = (ref3 = (ref4 = info.children) != null ? (ref5 = ref4[0]) != null ? ref5.cols : void 0 : void 0) != null ? ref3 : info.cols;
    required = (ref6 = (ref7 = info.children) != null ? (ref8 = ref7[0]) != null ? ref8.required : void 0 : void 0) != null ? ref6 : info.required;
    appearance = (ref9 = (ref10 = info.children) != null ? (ref11 = ref10[0]) != null ? ref11.appearance : void 0 : void 0) != null ? ref9 : info.appearance;
    validation = (ref12 = (ref13 = info.children) != null ? (ref14 = ref13[0]) != null ? ref14.validation : void 0 : void 0) != null ? ref12 : info.validation;
    initialValue = (ref15 = info.children) != null ? (ref16 = ref15[0]) != null ? ref16.initialValue : void 0 : void 0;
    return _.extend(Question.parse(info), {
      appearance: appearance,
      rows: rows,
      columns: columns,
      required: required,
      validation: validation,
      initialValue: initialValue
    });
  };

  TextResponse.prototype.variables = function() {
    return {
      '': new StringVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        appearance: this.get('appearance'),
        rows: this.get('rows'),
        columns: this.get('columns'),
        required: this.get('required'),
        validation: this.get('validation'),
        initialValue: this.get('initialValue')
      })
    };
  };

  TextResponse.prototype.getExtraction = function(response, options) {
    var j, number_of_loops, offset, result;
    if (options == null) {
      options = {};
    }
    result = [];
    number_of_loops = response != null ? parseInt(response.values[this.id], 10) : 10;
    if ((number_of_loops == null) || number_of_loops < 0) {
      number_of_loops = 1;
    }
    offset = number_of_loops + 1;
    while ((offset -= 1)) {
      j = Math.abs(number_of_loops - offset) + 1;
      result.push(new Choice(j - 1, {
        label: trans.make(j.toString())
      }));
    }
    return result;
  };

  return TextResponse;

})(Question);

Question.Slider = (function(superClass) {
  extend(Slider, superClass);

  function Slider() {
    return Slider.__super__.constructor.apply(this, arguments);
  }

  Slider.type = 'slider';

  Slider.prototype.variables = function() {
    return {
      '': new StringVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        initialValue: this.get('initialValue'),
        required: this.get('required')
      })
    };
  };

  Slider.parse = function(info) {
    var initialValue, leftLabel, maximumValue, minimumValue, ref, ref1, ref10, ref11, ref12, ref13, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, required, rightLabel, stepSize;
    initialValue = ((ref = info.children) != null ? (ref1 = ref[0]) != null ? ref1.initialValue : void 0 : void 0);
    leftLabel = trans.make((ref2 = info.children) != null ? (ref3 = ref2[0]) != null ? ref3.leftLabel : void 0 : void 0);
    rightLabel = trans.make((ref4 = info.children) != null ? (ref5 = ref4[0]) != null ? ref5.rightLabel : void 0 : void 0);
    minimumValue = ((ref6 = info.children) != null ? (ref7 = ref6[0]) != null ? ref7.minimumValue : void 0 : void 0);
    maximumValue = ((ref8 = info.children) != null ? (ref9 = ref8[0]) != null ? ref9.maximumValue : void 0 : void 0);
    stepSize = (ref10 = info.children) != null ? (ref11 = ref10[0]) != null ? ref11.stepSize : void 0 : void 0;
    required = (ref12 = info.children) != null ? (ref13 = ref12[0]) != null ? ref13.required : void 0 : void 0;
    initialValue = (trans.make(initialValue)).toString();
    return _.extend(Question.parse(info), {
      initialValue: initialValue,
      leftLabel: leftLabel,
      rightLabel: rightLabel,
      minimumValue: minimumValue || 0,
      maximumValue: maximumValue || 100,
      stepSize: stepSize,
      required: required
    });
  };

  Slider.prototype.template = function() {
    var variable;
    text("<div class=\"slider_question\">\n	<span class=\"minimumValue hidden\">" + this.attributes.minimumValue + "</span>\n	<span class=\"maximumValue hidden\">" + this.attributes.maximumValue + "</span>\n	<span class=\"stepSize hidden\">" + this.attributes.stepSize + "</span>\n	<span class=\"initialValue hidden\">" + this.attributes.initialValue + "</span>\n</div>\n\n<div class=\"labels\">\n<div class=\"label left\">" + (this.attributes.leftLabel.toString()) + "</div>\n<div class=\"label right\">" + (this.attributes.rightLabel.toString()) + "</div>\n</div>");
    variable = this.variables()[''];
    return text(variable.render());
  };

  return Slider;

})(Question.TextResponse);

Question._ChoiceBase = (function(superClass) {
  extend(_ChoiceBase, superClass);

  function _ChoiceBase() {
    return _ChoiceBase.__super__.constructor.apply(this, arguments);
  }

  _ChoiceBase.parse = function(info) {
    var alphabetize, appearance, choices, initialValue, randomize, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, required, simpleBranching;
    choices = (ref = (ref1 = (ref2 = info.children) != null ? (ref3 = ref2[0]) != null ? ref3.choices : void 0 : void 0) != null ? ref1 : info.choices) != null ? ref : [];
    required = (ref4 = (ref5 = info.children) != null ? (ref6 = ref5[0]) != null ? ref6.required : void 0 : void 0) != null ? ref4 : info.required;
    randomize = (ref7 = (ref8 = info.children) != null ? (ref9 = ref8[0]) != null ? ref9.randomize : void 0 : void 0) != null ? ref7 : info.randomize;
    appearance = (ref10 = (ref11 = info.children) != null ? (ref12 = ref11[0]) != null ? ref12.choiceAppearance : void 0 : void 0) != null ? ref10 : info.choiceAppearance;
    simpleBranching = (ref13 = (ref14 = info.children) != null ? (ref15 = ref14[0]) != null ? ref15.branch : void 0 : void 0) != null ? ref13 : info.simpleBranching;
    initialValue = (ref16 = info.children) != null ? (ref17 = ref16[0]) != null ? ref17.initialValue : void 0 : void 0;
    alphabetize = (ref18 = info.children) != null ? (ref19 = ref18[0]) != null ? ref19.alphabetize : void 0 : void 0;
    return _.extend(Question.parse(info), {
      choices: Choice.makeList(choices),
      required: required,
      randomize: randomize,
      appearance: appearance,
      simpleBranching: simpleBranching,
      initialValue: initialValue,
      alphabetize: alphabetize
    });
  };

  return _ChoiceBase;

})(Question);

Question._Choice = (function(superClass) {
  extend(_Choice, superClass);

  function _Choice() {
    return _Choice.__super__.constructor.apply(this, arguments);
  }

  _Choice.parse = function(info) {
    var extraction, ref, ref1, ref2;
    extraction = (ref = (ref1 = info.children) != null ? (ref2 = ref1[0]) != null ? ref2.extraction : void 0 : void 0) != null ? ref : info.extraction;
    return _.extend(Question._ChoiceBase.parse(info), {
      extraction: extraction != null ? new Extraction(extraction) : void 0
    });
  };

  _Choice.prototype.onSurveyBuilt = function(survey) {
    var extraction;
    if ((extraction = this.get('extraction')) != null) {
      return extraction.resolve(survey);
    }
  };

  _Choice.prototype.setupElement = function(el, handler) {
    var enabled, extraction;
    if ((extraction = this.get('extraction')) != null) {
      enabled = extraction.evaluate(handler);
      el.find('[data-extraction]').filter(function() {
        return (enabled == null) || !($(this).data('extraction') in enabled);
      }).remove();
    }
    return el;
  };

  return _Choice;

})(Question._ChoiceBase);

Question.MultipleChoice = (function(superClass) {
  extend(MultipleChoice, superClass);

  function MultipleChoice() {
    return MultipleChoice.__super__.constructor.apply(this, arguments);
  }

  MultipleChoice.type = 'single-choice';

  MultipleChoice.prototype.variables = function() {
    var choice, choices, i, k, len, result;
    choices = this.get('choices');
    result = {
      '': new SingleChoiceVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        choices: choices,
        extraction: this.get('extraction'),
        required: this.get('required'),
        randomize: this.get('randomize'),
        appearance: this.get('appearance'),
        initialValue: this.get('initialValue')
      })
    };
    for (i = k = 0, len = choices.length; k < len; i = ++k) {
      choice = choices[i];
      choice.set({
        variable: result['']
      });
      if (choice.get('other')) {
        result[i] = new StringVariable({
          id: this.id + "_other",
          title: this.get('title'),
          exportId: this.id + "\\other",
          name: this.name(".other"),
          validation: choice.get('validation'),
          required: choice.get('other_required'),
          choice: choice
        });
        choice.set({
          other: result[i]
        });
      }
    }
    return result;
  };

  MultipleChoice.prototype.getSimpleBranching = function() {
    return BranchingRule.prototype.parseSimple(this, this.get('simpleBranching'));
  };

  return MultipleChoice;

})(Question._Choice);

Question.Checkbox = (function(superClass) {
  extend(Checkbox, superClass);

  function Checkbox() {
    return Checkbox.__super__.constructor.apply(this, arguments);
  }

  Checkbox.type = 'multiple-choice';

  Checkbox.parse = function(info) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, restrictions;
    restrictions = {
      minChecked: (ref = info.children) != null ? (ref1 = ref[0]) != null ? (ref2 = ref1.restrictions) != null ? ref2.minChecked : void 0 : void 0 : void 0,
      maxChecked: (ref3 = info.children) != null ? (ref4 = ref3[0]) != null ? (ref5 = ref4.restrictions) != null ? ref5.maxChecked : void 0 : void 0 : void 0,
      message: ((ref6 = info.children) != null ? (ref7 = ref6[0]) != null ? ref7.err_msg : void 0 : void 0) != null ? trans.make((ref8 = info.children) != null ? (ref9 = ref8[0]) != null ? ref9.err_msg : void 0 : void 0) : void 0
    };
    if (!((restrictions.minChecked != null) || (restrictions.maxChecked != null))) {
      restrictions = void 0;
    }
    return _.extend(Question._Choice.parse(info), {
      restrictions: restrictions
    });
  };

  Checkbox.prototype.variables = function() {
    var choice, choices, i, k, len, result;
    choices = this.get('choices');
    result = {
      '': new MultipleChoiceVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        choices: choices,
        extraction: this.get('extraction'),
        required: this.get('required'),
        randomize: this.get('randomize'),
        appearance: this.get('appearance'),
        restrictions: this.get('restrictions')
      })
    };
    for (i = k = 0, len = choices.length; k < len; i = ++k) {
      choice = choices[i];
      choice.set({
        variable: result['']
      });
      if (choice.get('other')) {
        result[i] = new StringVariable({
          id: this.id + "_" + (choice.get('id')) + "_other",
          title: this.get('title'),
          exportId: this.id + "\\" + (choice.get('id')) + "\\text",
          name: this.name(".other." + (choice.get('id'))),
          validation: choice.get('validation'),
          required: choice.get('other_required'),
          choice: choice
        });
        choice.set({
          other: result[i]
        });
      }
    }
    return result;
  };

  Checkbox.prototype.getExtraction = function(response, options) {
    if (options == null) {
      options = {};
    }
    if (response == null) {
      return this.get('choices');
    }
    return _.filter(this.get('choices'), (function(_this) {
      return function(choice) {
        var ref;
        return (ref = choice.id, indexOf.call(response.values[_this.id], ref) >= 0) === !options.inverted;
      };
    })(this));
  };

  return Checkbox;

})(Question._Choice);

Question.Dropdown = (function(superClass) {
  extend(Dropdown, superClass);

  function Dropdown() {
    return Dropdown.__super__.constructor.apply(this, arguments);
  }

  Dropdown.type = 'dropdown-choice';

  Dropdown.prototype.variables = function() {
    return {
      '': new SingleChoiceVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        appearance: 'dropdown',
        choices: this.get('choices'),
        extraction: this.get('extraction'),
        required: this.get('required'),
        randomize: this.get('randomize'),
        initialValue: this.get('initialValue'),
        alphabetize: this.get('alphabetize')
      })
    };
  };

  Dropdown.prototype.getSimpleBranching = function() {
    return BranchingRule.prototype.parseSimple(this, this.get('simpleBranching'));
  };

  return Dropdown;

})(Question._Choice);

Question.Drilldown = (function(superClass) {
  extend(Drilldown, superClass);

  function Drilldown() {
    return Drilldown.__super__.constructor.apply(this, arguments);
  }

  Drilldown.type = 'drill-down';

  Drilldown.parse = function(info) {
    var appearance, categories, category, choice, choices, flipOrder, i, k, l, leftLabel, len, len1, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref2, ref20, ref21, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rightLabel, showCategoryLabels;
    appearance = (ref = (ref1 = (ref2 = info.children) != null ? (ref3 = ref2[0]) != null ? ref3.display : void 0 : void 0) != null ? ref1 : info.appearance) != null ? ref : 'default';
    categories = Choice.makeList((ref4 = (ref5 = (ref6 = info.children) != null ? (ref7 = ref6[0]) != null ? ref7.categories : void 0 : void 0) != null ? ref5 : info.categories) != null ? ref4 : []);
    leftLabel = (ref8 = (ref9 = (ref10 = info.children) != null ? (ref11 = ref10[0]) != null ? ref11.leftLabel : void 0 : void 0) != null ? ref9 : info.leftLabel) != null ? ref8 : '';
    rightLabel = (ref12 = (ref13 = (ref14 = info.children) != null ? (ref15 = ref14[0]) != null ? ref15.rightLabel : void 0 : void 0) != null ? ref13 : info.rightLabel) != null ? ref12 : '';
    flipOrder = (ref16 = info.children) != null ? (ref17 = ref16[0]) != null ? ref17.flipOrder : void 0 : void 0;
    showCategoryLabels = (ref18 = (ref19 = info.children) != null ? (ref20 = ref19[0]) != null ? ref20.showCatLabels : void 0 : void 0) != null ? ref18 : info.showCategoryLabels;
    i = 0;
    choices = [];
    for (k = 0, len = categories.length; k < len; k++) {
      category = categories[k];
      ref21 = category.get('choices');
      for (l = 0, len1 = ref21.length; l < len1; l++) {
        choice = ref21[l];
        choice.id = i++;
        choices.push(choice);
      }
    }
    return _.extend(Question._ChoiceBase.parse(info), {
      appearance: appearance,
      categories: categories,
      choices: choices,
      leftLabel: trans.make(leftLabel),
      rightLabel: trans.make(rightLabel),
      flipOrder: flipOrder,
      showCategoryLabels: showCategoryLabels
    });
  };

  Drilldown.prototype.leftLabel = function() {
    var ref;
    return (ref = this.get('leftLabel')) != null ? ref.toString() : void 0;
  };

  Drilldown.prototype.rightLabel = function() {
    var ref;
    return (ref = this.get('rightLabel')) != null ? ref.toString() : void 0;
  };

  Drilldown.prototype.variables = function() {
    return {
      '': new SingleChoiceVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        appearance: this.get('appearance') === 'dropdown' ? 'dropdown' : 'drilldown',
        categories: this.get('categories'),
        choices: this.get('choices'),
        required: this.get('required')
      })
    };
  };

  Drilldown.prototype.getSimpleBranching = function() {
    return BranchingRule.prototype.parseSimple(this, this.get('simpleBranching'));
  };

  Drilldown.prototype.template = function() {
    var categories, choices, flipOrder, variable;
    variable = this.variables()[''];
    if (this.get('appearance') === 'likert') {
      flipOrder = this.get('flipOrder');
      categories = this.get('categories');
      if (flipOrder) {
        categories = _.toArray(categories).reverse();
      }
      choices = variable.choices();
      if (flipOrder) {
        choices = _.toArray(choices).reverse();
      }
      return table({
        "class": "grouped-table"
      }, function() {
        thead(function() {
          if (this.get('showCategoryLabels')) {
            tr(function() {
              var category, k, len;
              th("");
              for (k = 0, len = categories.length; k < len; k++) {
                category = categories[k];
                th({
                  "class": "choice",
                  colspan: category.get('choices').length
                }, function() {
                  return category.label();
                });
              }
              return th("");
            });
          }
          return tr(function() {
            var choice, k, len;
            th("");
            for (k = 0, len = choices.length; k < len; k++) {
              choice = choices[k];
              th({
                "class": "choice",
                align: "center"
              }, function() {
                return choice.label();
              });
            }
            return th("");
          });
        });
        return tbody(function() {
          return tr(function() {
            var choice, k, len;
            th((flipOrder ? this.rightLabel() : this.leftLabel()));
            for (k = 0, len = choices.length; k < len; k++) {
              choice = choices[k];
              td({
                align: "center"
              }, function() {
                return input({
                  id: "id_" + this.id + "_" + choice.id,
                  name: "" + this.id,
                  type: 'radio',
                  value: choice.id
                });
              });
            }
            return th((flipOrder ? this.leftLabel() : this.rightLabel()));
          });
        });
      });
    } else {
      return text(variable.render());
    }
  };

  return Drilldown;

})(Question._ChoiceBase);

Question.NetPromoter = (function(superClass) {
  extend(NetPromoter, superClass);

  function NetPromoter() {
    return NetPromoter.__super__.constructor.apply(this, arguments);
  }

  NetPromoter.type = 'net-promoter';

  NetPromoter.parse = function(info) {
    return _.extend(Question.Drilldown.parse(info));
  };

  return NetPromoter;

})(Question.Drilldown);

Question.DateTime = (function(superClass) {
  extend(DateTime, superClass);

  function DateTime() {
    return DateTime.__super__.constructor.apply(this, arguments);
  }

  DateTime.type = 'datetime';

  DateTime.parse = function(info) {
    var format, ref, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, showNowButton, timezone;
    timezone = (ref = (ref1 = info.children) != null ? (ref2 = ref1[0]) != null ? ref2.timezone : void 0 : void 0) != null ? ref : info.timezone;
    format = parseInt((ref3 = (ref4 = (ref5 = info.children) != null ? (ref6 = ref5[0]) != null ? ref6.dateFormat : void 0 : void 0) != null ? ref4 : info.dateFormat) != null ? ref3 : "0", 10);
    format = (ref7 = ['datetime', 'date', 'time', 'monthday', 'yearmonth'][format]) != null ? ref7 : 'datetime';
    if (format === 'datetime' && timezone) {
      format = 'datetimetz';
    }
    showNowButton = (format === 'datetime' || format === 'datetimetz' || format === 'time') && ((ref8 = (ref9 = info.showNowButton) != null ? ref9 : (ref10 = info.children) != null ? (ref11 = ref10[0]) != null ? ref11.showNowButton : void 0 : void 0) != null ? ref8 : false);
    return _.extend(Question.parse(info), {
      format: format,
      showNowButton: showNowButton
    });
  };

  DateTime.prototype.variables = function() {
    return {
      '': new DateTimeVariable({
        id: this.id,
        title: this.get('title'),
        name: this.get('name'),
        required: this.get('required'),
        format: this.get('format'),
        showNowButton: this.get('showNowButton')
      })
    };
  };

  return DateTime;

})(Question);

Question._Grid = (function(superClass) {
  extend(_Grid, superClass);

  function _Grid() {
    return _Grid.__super__.constructor.apply(this, arguments);
  }

  _Grid.parse = function(info) {
    return _.extend(Question.parse(info), {
      children: Choice.makeList(info.children),
      randomize: info.randomize || void 0,
      unique: info.unique || void 0,
      firstColSize: Number(info.questionSize || 30)
    });
  };

  _Grid.prototype.variables = function() {
    var child, i, k, len, ref, result;
    result = {};
    ref = this.get('children');
    for (i = k = 0, len = ref.length; k < len; i = ++k) {
      child = ref[i];
      result[i] = this.createVariable(i, child);
      if (this.get('extraction')) {
        result[i].set('label', this.get('extraction').labelForChoice(i));
      }
      result[i].index = i;
    }
    return result;
  };

  _Grid.prototype.variablesDisplay = function() {
    var variables;
    variables = _(this.variables()).values();
    if (this.get('randomize')) {
      variables = _(variables).shuffled();
    }
    return variables;
  };

  _Grid.prototype.validateResponse = function(response) {
    var id, values, variable;
    if (this.get('unique')) {
      values = _((function() {
        var ref, results;
        ref = this.variables();
        results = [];
        for (id in ref) {
          variable = ref[id];
          results.push(response.values[variable.id] != null);
        }
        return results;
      }).call(this)).select(function(el) {
        return el != null ? el.length : void 0;
      });
      if (_(values).uniq().length !== values.length) {
        throw new UniqueError;
      }
    }
  };

  _Grid.prototype.renderContents = function() {
    if (this.template != null) {
      return CoffeeKup.render(this.template, {
        context: this
      });
    }
  };

  _Grid.prototype.onSurveyBuilt = function(survey) {
    var extraction;
    if ((extraction = this.get('extraction')) != null) {
      return extraction.resolve(survey);
    }
  };

  _Grid.prototype.setupElement = function(el, handler) {
    var enabled, extraction;
    if ((extraction = this.get('extraction')) != null) {
      enabled = extraction.evaluate(handler);
      el.find('[data-extraction]').filter(function() {
        return (enabled == null) || !($(this).data('extraction') in enabled);
      }).remove();
    }
    return el;
  };

  return _Grid;

})(Question);

Question._ChoiceGrid = (function(superClass) {
  extend(_ChoiceGrid, superClass);

  function _ChoiceGrid() {
    return _ChoiceGrid.__super__.constructor.apply(this, arguments);
  }

  _ChoiceGrid.prototype.variableClass = SingleChoiceVariable;

  _ChoiceGrid.prototype.hasRightLabels = false;

  _ChoiceGrid.parse = function(info) {
    var choices, extraction, ref, ref1, ref2, ref3;
    choices = (ref = (ref1 = info.choices) != null ? ref1 : (ref2 = info.children) != null ? (ref3 = ref2[0]) != null ? ref3.choices : void 0 : void 0) != null ? ref : [];
    extraction = info.extraction;
    return _.extend(Question._Grid.parse(info), {
      choices: Choice.makeList(choices),
      children: Choice.makeList(info.children),
      extraction: extraction != null ? new Extraction(extraction) : void 0,
      showBorders: info.showBorders || void 0
    });
  };

  _ChoiceGrid.prototype.createVariable = function(i, info) {
    return new this.variableClass({
      id: this.id + "_" + i,
      title: (this.get('title')) + " | " + (info.get('label')),
      name: this.get('name') ? (this.get('name')) + "." + i : void 0,
      label: info.get('label'),
      rightLabel: info.get('rightLabel'),
      choices: this.get('choices'),
      required: info.get('required')
    });
  };

  _ChoiceGrid.prototype.template = function() {
    var choiceColSize, choices, edgeColSize, tableClasses;
    choices = this.get('choices');
    edgeColSize = Number(this.get('firstColSize') || 30);
    choiceColSize = (100 - edgeColSize) / choices.length;
    edgeColSize = this.hasRightLabels ? edgeColSize / 2 : edgeColSize;
    tableClasses = 'grouped-table';
    if (this.get('showBorders')) {
      tableClasses += ' show-borders';
    }
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    return div({
      "class": 'grouped-table-container'
    }, function() {
      return table({
        "class": tableClasses
      }, function() {
        thead(function() {
          return tr(function() {
            var choice, k, len;
            th({
              width: (edgeColSize.toFixed(0)) + "%"
            }, function() {});
            for (k = 0, len = choices.length; k < len; k++) {
              choice = choices[k];
              th({
                width: (choiceColSize.toFixed(0)) + "%"
              }, function() {
                return choice.label();
              });
            }
            if (this.hasRightLabels) {
              return th({
                width: (edgeColSize.toFixed(0)) + "%"
              }, function() {});
            }
          });
        });
        return tbody(function() {
          var attrs, k, len, ref, results, row;
          ref = this.variablesDisplay();
          results = [];
          for (k = 0, len = ref.length; k < len; k++) {
            row = ref[k];
            attrs = {};
            if (this.get('extraction')) {
              attrs['data-extraction'] = row.index;
            }
            tr(attrs, {
              "class": 'error-row-container'
            }, function() {
              return td({
                "class": 'error-placeholder',
                id: "error_" + row.id,
                colspan: choices.length + 1
              });
            });
            results.push(tr(attrs, {
              "class": "variable",
              id: "x_" + row.id
            }, function() {
              var choice, l, len1;
              th(function() {
                return label({
                  "for": "id_" + row.id + "_0"
                }, function() {
                  return Survey.pipe(row.label());
                });
              });
              for (l = 0, len1 = choices.length; l < len1; l++) {
                choice = choices[l];
                td(function() {
                  return input({
                    type: this.variableClass.prototype.inputType,
                    name: row.id,
                    value: choice.id,
                    id: "id_" + row.id + "_" + choice.id
                  });
                });
              }
              if (this.hasRightLabels) {
                return th(function() {
                  return label({
                    "for": "id_" + row.id + "_0"
                  }, function() {
                    return row.rightLabel();
                  });
                });
              }
            }));
          }
          return results;
        });
      });
    });
  };

  _ChoiceGrid.prototype.getExtraction = function(response, options) {
    var i, ref, ref1, result, variable;
    if (options == null) {
      options = {};
    }
    result = [];
    ref = this.variables();
    for (i in ref) {
      variable = ref[i];
      if ((response != null) && !(ref1 = (response.values[variable.id] !== void 0 && response.values[variable.id] !== "" ? response.values[variable.id] : -1), indexOf.call(_.values(options != null ? options.choices : void 0), ref1) >= 0)) {
        continue;
      }
      result.push(new Choice(i, {
        label: variable.label()
      }));
    }
    return result;
  };

  return _ChoiceGrid;

})(Question._Grid);

Question.MultipleChoiceGrid = (function(superClass) {
  extend(MultipleChoiceGrid, superClass);

  function MultipleChoiceGrid() {
    return MultipleChoiceGrid.__super__.constructor.apply(this, arguments);
  }

  MultipleChoiceGrid.type = 'single-choice-grid';

  return MultipleChoiceGrid;

})(Question._ChoiceGrid);

Question.Ranking = (function(superClass) {
  extend(Ranking, superClass);

  function Ranking() {
    return Ranking.__super__.constructor.apply(this, arguments);
  }

  Ranking.type = 'ranking';

  Ranking.parse = function(info) {
    var ref;
    return _.extend(Question.MultipleChoiceGrid.parse(info), {
      required: (ref = info.required) != null ? ref : false
    });
  };

  Ranking.prototype.createVariable = function(i, info) {
    return _.extend(Ranking.__super__.createVariable.call(this, i, info), {
      required: false
    });
  };

  Ranking.prototype.validateResponse = function(r) {
    var i, ref, remaining, resp, v;
    Ranking.__super__.validateResponse.call(this, r);
    if (this.get('required')) {
      remaining = _.clone(this.attributes.choices);
      ref = this.variables();
      for (i in ref) {
        v = ref[i];
        resp = r.values[v.id];
        if (resp != null) {
          remaining = _.reject(remaining, function(x) {
            return x.id === resp;
          });
        }
      }
      if (remaining.length) {
        throw new RequiredError;
      }
    }
  };

  Ranking.prototype.template = function() {
    var choices, tableClasses, vars;
    if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/)) {
      choices = this.get('choices');
      tableClasses = 'grouped-table';
      if (this.get('showBorders')) {
        tableClasses += ' show-borders';
      }
      div({
        "class": 'error-placeholder',
        id: "error_" + this.id
      });
      return div({
        "class": 'grouped-table-container'
      }, function() {
        return table({
          "class": tableClasses
        }, function() {
          thead(function() {
            return tr(function() {
              var choice, k, len;
              th(function() {});
              for (k = 0, len = choices.length; k < len; k++) {
                choice = choices[k];
                th(function() {
                  return choice.label();
                });
              }
              if (this.hasRightLabels) {
                return th(function() {});
              }
            });
          });
          return tbody(function() {
            var attrs, k, len, ref, results, row;
            ref = this.variablesDisplay();
            results = [];
            for (k = 0, len = ref.length; k < len; k++) {
              row = ref[k];
              attrs = {};
              if (this.get('extraction')) {
                attrs['data-extraction'] = row.index;
              }
              tr(attrs, {
                "class": 'error-row-container'
              }, function() {
                return td({
                  "class": 'error-placeholder',
                  id: "error_" + row.id,
                  colspan: choices.length + 1
                });
              });
              results.push(tr(attrs, {
                "class": "variable",
                id: "x_" + row.id
              }, function() {
                var choice, l, len1;
                th(function() {
                  return label({
                    "for": "id_" + row.id + "_0"
                  }, function() {
                    return row.label();
                  });
                });
                for (l = 0, len1 = choices.length; l < len1; l++) {
                  choice = choices[l];
                  td(function() {
                    return input({
                      type: this.variableClass.prototype.inputType,
                      name: row.id,
                      value: choice.id,
                      id: "id_" + row.id + "_" + choice.id
                    });
                  });
                }
                if (this.hasRightLabels) {
                  return th(function() {
                    return label({
                      "for": "id_" + row.id + "_0"
                    }, function() {
                      return row.rightLabel();
                    });
                  });
                }
              }));
            }
            return results;
          });
        });
      });
    } else {
      choices = this.get('choices');
      vars = this.variablesDisplay();
      div({
        "class": 'error-placeholder',
        id: "error_" + this.id
      });
      return div({
        "class": 'ranking-question'
      }, function() {
        table({
          "class": 'var-choice-table'
        }, function() {
          return tr(function() {
            td(function() {
              return div({
                "class": 'rank-variable-bin',
                style: "width:210px"
              }, function() {
                var attrs, k, len, results, row;
                results = [];
                for (k = 0, len = vars.length; k < len; k++) {
                  row = vars[k];
                  attrs = {};
                  if (this.get('extraction')) {
                    attrs['data-extraction'] = row.index;
                  }
                  results.push(div(attrs, {
                    "class": 'draggable-rank-variable-box'
                  }, function() {
                    span({
                      "class": 'variable_index',
                      style: 'display:none;'
                    }, function() {
                      return row.id;
                    });
                    return div({
                      "class": 'draggable-rank-variable-text'
                    }, function() {
                      return row.label();
                    });
                  }));
                }
                return results;
              });
            });
            td({
              "class": 'rank-middle-cell'
            }, function() {
              return span({
                "class": 'drag-icon'
              });
            });
            return td(function() {
              var index;
              index = 0;
              return div({
                "class": 'rank-choice-bin',
                style: "width:210px"
              }, function() {
                var choice, k, len, results;
                results = [];
                for (k = 0, len = choices.length; k < len; k++) {
                  choice = choices[k];
                  results.push(div({
                    "class": 'droppable-rank-variable-box'
                  }, function() {
                    span({
                      "class": 'rank_index',
                      style: 'display:none;'
                    }, function() {
                      return "" + (index++);
                    });
                    return div({
                      "class": 'droppable-rank-variable-text'
                    }, function() {
                      return choice.label();
                    });
                  }));
                }
                return results;
              });
            });
          });
        });
        return div({
          id: 'original-question',
          style: 'display:none;'
        }, function() {
          return ul({
            "class": 'matrix textgridmatrix',
            style: 'width: 100%;'
          }, function() {
            var attrs, k, len, results, row, var_style;
            results = [];
            for (k = 0, len = vars.length; k < len; k++) {
              row = vars[k];
              attrs = {};
              if (this.get('extraction')) {
                attrs['data-extraction'] = row.index;
              }
              var_style = row.hidden ? 'display:none;' : '';
              results.push(li(attrs, {
                "class": 'variable',
                id: "x" + row.id,
                style: var_style
              }, function() {
                return row.render();
              }));
            }
            return results;
          });
        });
      });
    }
  };

  return Ranking;

})(Question.MultipleChoiceGrid);

Question.TextResponseGrid = (function(superClass) {
  extend(TextResponseGrid, superClass);

  function TextResponseGrid() {
    return TextResponseGrid.__super__.constructor.apply(this, arguments);
  }

  TextResponseGrid.type = 'text-response-grid';

  TextResponseGrid.parse = function(info) {
    var extraction;
    extraction = info.extraction;
    return _.extend(Question._Grid.parse(info), {
      sum: info.sum != null ? info.sum : void 0,
      sumLabel: trans.make(info.sum_label),
      extraction: extraction != null ? new Extraction(extraction) : void 0
    });
  };

  TextResponseGrid.prototype.createVariable = function(i, info) {
    var appearance, columns, initialValue, rows, validation;
    rows = info.get('rows');
    columns = info.get('columns');
    appearance = info.get('appearance');
    validation = info.get('validation');
    initialValue = info.get('initialValue');
    return new StringVariable({
      id: this.id + "_" + i,
      title: (this.get('title')) + " | " + (info.get('label')),
      name: this.get('name') ? (this.get('name')) + "." + i : void 0,
      label: info.label(),
      required: info.get('required'),
      rows: rows,
      columns: columns,
      appearance: appearance,
      validation: validation,
      initialValue: initialValue
    });
  };

  TextResponseGrid.prototype.getExtraction = function(response, options) {
    var i, ref, result, variable;
    if (options == null) {
      options = {};
    }
    result = [];
    ref = this.variables();
    for (i in ref) {
      variable = ref[i];
      if ((response != null) && !response.values[variable.id]) {
        continue;
      }
      result.push(new Choice(i, {
        label: response != null ? response.values[variable.id] : variable.label()
      }));
    }
    return result;
  };

  TextResponseGrid.prototype.validateResponse = function(response) {
    var id, k, len, piped_sum, total, v, values, variable, vx;
    TextResponseGrid.__super__.validateResponse.call(this, response);
    if (this.get('unique')) {
      values = _((function() {
        var ref, ref1, results;
        ref = this.variables();
        results = [];
        for (id in ref) {
          variable = ref[id];
          results.push((ref1 = response.values[variable.id].trim()) != null ? ref1 : 'N/A');
        }
        return results;
      }).call(this)).toArray();
      while (values.length) {
        v = values.pop();
        if (!(v === '')) {
          for (k = 0, len = values.length; k < len; k++) {
            vx = values[k];
            if (v === vx) {
              throw new UniqueError;
            }
          }
        }
      }
    }
    if (this.get('sum')) {
      total = 0;
      values = _((function() {
        var ref, ref1, results;
        ref = this.variables();
        results = [];
        for (id in ref) {
          variable = ref[id];
          results.push((ref1 = response.values[variable.id]) != null ? ref1 : 'N/A');
        }
        return results;
      }).call(this)).select(function(el) {
        return el != null ? el.match(/^(\d+)|(\d*\.\d+)$/) : void 0;
      });
      _(values).each(function(el) {
        return total += el.indexOf('.') < 0 ? parseInt(el, 10) : parseFloat(el);
      });
      piped_sum = this.replacePipedString(this.get('sum'));
      if (total !== parseInt(piped_sum, 10)) {
        throw new ValidationError(this.get('sumLabel').toString().replace('{x}', piped_sum).replace('{y}', total));
      }
    }
  };

  TextResponseGrid.prototype.template = function() {
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    ul({
      "class": 'matrix' + (this.get('sum') != null ? ' sum-inputs' : '')
    }, function() {
      var attrs, k, len, ref, results, row;
      ref = this.variablesDisplay();
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        row = ref[k];
        attrs = {};
        if (this.get('extraction')) {
          attrs['data-extraction'] = row.index;
        }
        results.push(li(attrs, {
          "class": 'variable',
          id: "x_" + row.id
        }, function() {
          label({
            "class": 'control-label',
            "for": "id_" + row.id
          }, function() {
            return row.label();
          });
          return div({
            "class": 'controls'
          }, function() {
            return row.render();
          });
        }));
      }
      return results;
    });
    if (this.get('sum') != null) {
      return span({
        "class": 'sum-label',
        'data:sum': this.get('sum'),
        'data:label': this.get('sumLabel')
      });
    }
  };

  return TextResponseGrid;

})(Question._Grid);

Question.DropdownGrid = (function(superClass) {
  extend(DropdownGrid, superClass);

  function DropdownGrid() {
    return DropdownGrid.__super__.constructor.apply(this, arguments);
  }

  DropdownGrid.type = 'dropdown-grid';

  DropdownGrid.prototype.createVariable = function(i, info) {
    return new SingleChoiceVariable({
      id: this.id + "_" + i,
      title: (this.get('title')) + " | " + (info.get('label')),
      name: this.get('name') ? (this.get('name')) + "." + i : void 0,
      label: info.label(),
      choices: this.get('choices'),
      appearance: 'dropdown',
      required: info.get('required')
    });
  };

  DropdownGrid.prototype.template = function() {
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    return ul({
      "class": 'matrix'
    }, function() {
      var k, len, ref, results, row;
      ref = this.variablesDisplay();
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        row = ref[k];
        results.push(li({
          "class": 'variable',
          id: "x_" + row.id
        }, function() {
          label({
            "class": 'control-label',
            "for": "id_" + row.id
          }, function() {
            return row.label();
          });
          return div({
            "class": 'controls'
          }, function() {
            return row.render();
          });
        }));
      }
      return results;
    });
  };

  return DropdownGrid;

})(Question._ChoiceGrid);

Question.Natrix = (function(superClass) {
  extend(Natrix, superClass);

  function Natrix() {
    return Natrix.__super__.constructor.apply(this, arguments);
  }

  Natrix.type = 'custom-grid';

  Natrix.parse = function(info) {
    return _.extend(Question.parse(info), {
      children: info.children
    });
  };

  Natrix.prototype.variables = function() {
    return Variable.makeList(this.id, this.name(), this.get('children'), this.get('title'));
  };

  Natrix.prototype.template = function() {
    return ul({
      "class": 'matrix'
    }, function() {
      var k, len, ref, results, row;
      ref = this.variablesDisplay();
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        row = ref[k];
        results.push(li({
          "class": 'variable',
          id: "x_" + row.id
        }, function() {
          if (row.type === 'single' && row.get('appearance') !== 'dropdown') {
            label({
              "class": 'control-label',
              "for": "id_" + row.id + "_0"
            }, function() {
              return row.label();
            });
          } else {
            label({
              "class": 'control-label',
              "for": "id_" + row.id
            }, function() {
              return row.label();
            });
          }
          return div({
            "class": 'controls'
          }, function() {
            return row.render();
          });
        }));
      }
      return results;
    });
  };

  return Natrix;

})(Question._Grid);

Question.ThreeDGrid = (function(superClass) {
  extend(ThreeDGrid, superClass);

  function ThreeDGrid() {
    return ThreeDGrid.__super__.constructor.apply(this, arguments);
  }

  ThreeDGrid.type = 'threed-grid';

  ThreeDGrid.parse = function(info) {
    var child, columns, extraction, rows;
    extraction = info.extraction;
    columns = (function() {
      var k, len, ref, results;
      ref = info.children;
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        child = ref[k];
        if (child.row === 0) {
          results.push({
            id: child.column,
            label: trans.make(child.colname),
            type: child.type,
            choices: child.choices != null ? Choice.makeList(child.choices) : void 0,
            appearance: (function() {
              switch (child.type) {
                case 'single':
                  return child.choiceAppearance;
                case 'dropdown':
                  return 'dropdown';
                default:
                  return child.appearance;
              }
            })(),
            rows: child.rows,
            columns: child.cols,
            validation: child.validation,
            sum: child.sum ? parseInt(child.sum, 10) : void 0,
            dynamics: child.dynamics,
            initialValue: child.initialValue
          });
        }
      }
      return results;
    })();
    rows = (function() {
      var k, len, ref, results;
      ref = info.children;
      results = [];
      for (k = 0, len = ref.length; k < len; k++) {
        child = ref[k];
        if (child.column === 0) {
          results.push({
            id: child.row,
            label: trans.make(child.label),
            required: child.required
          });
        }
      }
      return results;
    })();
    return _.extend(Question.parse(info), {
      rows: rows,
      columns: columns,
      unique: info.unique || void 0,
      sumLabel: info.sumLabel || void 0,
      showNotUsed: info.showNotUsed || void 0,
      notUsedText: info.notUsedText != null ? trans.make(info.notUsedText) : void 0,
      extraction: extraction != null ? new Extraction(extraction) : void 0,
      showBorders: info.showBorders || void 0
    });
  };

  ThreeDGrid.prototype.grouped = function(column) {
    return column.type === 'single' && column.appearance === 'column';
  };

  ThreeDGrid.prototype.hasGroupedColumn = function() {
    return _(this.get('columns')).any((function(_this) {
      return function(el) {
        return _this.grouped(el);
      };
    })(this));
  };

  ThreeDGrid.prototype.requiresTotalRow = function() {
    return this.get('sumLabel') && _(this.get('columns')).any(function(el) {
      return el.sum != null;
    });
  };

  ThreeDGrid.prototype.dynamics = function() {
    var column, columns, condition, conditions, dynamics, i, j, k, l, len, len1, len2, len3, m, n, ref, ref1, ref2, ref3, ref4, row, rule, rules, variable, variables;
    rules = [];
    if (this.get('showNotUsed')) {
      ref = this.get('rows');
      for (j = k = 0, len = ref.length; k < len; j = ++k) {
        row = ref[j];
        variable = this.id + "_" + row.id + "_na";
        rules.push(new BranchingRule(new PredicateNode(variable, 'yes'), new DisableAction(this.id + "[" + row.id + ":]", variable)));
      }
    }
    columns = this.get('columns');
    variables = this.variables();
    for (i = l = 0, len1 = columns.length; l < len1; i = ++l) {
      column = columns[i];
      if (column.dynamics == null) {
        continue;
      }
      dynamics = column.dynamics;
      variable = function(row) {
        return variables[row.id + "_" + column.id].id;
      };
      if ((ref1 = column.type) === 'boolean' || ref1 === 'checkbox') {
        condition = function(row) {
          return new PredicateNode(variable(row), 'yes');
        };
      } else if ((ref2 = column.type) === 'single' || ref2 === 'dropdown') {
        condition = function(row) {
          return new PredicateNode(variable(row), 'isoneof', {
            value: dynamics.choices
          });
        };
      } else {
        continue;
      }
      conditions = new OrNode((function() {
        var len2, m, ref3, results;
        ref3 = this.get('rows');
        results = [];
        for (m = 0, len2 = ref3.length; m < len2; m++) {
          row = ref3[m];
          results.push(condition(row));
        }
        return results;
      }).call(this));
      ref3 = dynamics.rules;
      for (m = 0, len2 = ref3.length; m < len2; m++) {
        rule = ref3[m];
        if (rule.target === 'current-row') {
          ref4 = this.get('rows');
          for (j = n = 0, len3 = ref4.length; n < len3; j = ++n) {
            row = ref4[j];
            rules.push(new BranchingRule(condition(row), new DisableAction(this.id + "[" + row.id + ":]", variable(row))));
          }
        } else {
          rules.push(new BranchingRule(conditions, new DisableAction(rule.target)));
        }
      }
    }
    return rules;
  };

  ThreeDGrid.prototype.variables = function() {
    var attrs, column, i, k, l, len, len1, ref, ref1, ref2, result, row;
    result = {};
    i = 0;
    ref = this.get('rows');
    for (k = 0, len = ref.length; k < len; k++) {
      row = ref[k];
      if (this.get('showNotUsed')) {
        result[row.id + "_na"] = new BooleanVariable({
          id: this.id + "_" + row.id + "_na",
          appearance: 'checkbox'
        });
      }
      ref1 = this.get('columns');
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        column = ref1[l];
        attrs = {
          id: this.id + "_" + i,
          title: (this.get('title')) + " | " + row.label + " | " + column.label,
          name: this.get('name') ? (this.get('name')) + "." + row.id + "." + column.id : void 0,
          choices: (ref2 = column.choices) != null ? ref2 : [],
          appearance: column.appearance,
          rows: column.rows,
          columns: column.columns,
          required: row.required,
          validation: column.validation,
          initialValue: column.initialValue
        };
        i++;
        result[row.id + "_" + column.id] = new ((function() {
          switch (column.type) {
            case 'checkbox':
            case 'boolean':
              return BooleanVariable;
            case 'string':
              return StringVariable;
            case 'single':
            case 'dropdown':
              return SingleChoiceVariable;
          }
        })())(attrs);
      }
    }
    return result;
  };

  ThreeDGrid.prototype.validateResponse = function(response) {
    var column, id, k, len, ref, results, row, total, values, variable, variables;
    variables = this.variables();
    if (this.get('unique')) {
      values = _((function() {
        var results;
        results = [];
        for (id in variables) {
          variable = variables[id];
          results.push(response.values[variable.id] != null);
        }
        return results;
      })()).select(function(el) {
        return el != null ? el.length : void 0;
      });
      if (_(values).uniq().length !== values.length) {
        throw new UniqueError;
      }
    }
    ref = this.get('columns');
    results = [];
    for (k = 0, len = ref.length; k < len; k++) {
      column = ref[k];
      if (column.sum) {
        total = 0;
        values = _((function() {
          var l, len1, ref1, results1;
          ref1 = this.get('rows');
          results1 = [];
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            row = ref1[l];
            results1.push(response.values[variables[row.id + "_" + column.id].id] != null);
          }
          return results1;
        }).call(this)).select(function(el) {
          return el != null ? el.match(/^(\d+)|(\d*\.\d+)$/) : void 0;
        });
        _(values).each(function(el) {
          return total += el.indexOf('.') < 0 ? parseInt(el, 10) : parseFloat(el);
        });
        if (total !== column.sum) {
          throw new ValidationError("The values in column \"" + column.label + "\" must sum to " + column.sum + " (currently " + total + ").");
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  ThreeDGrid.prototype.template = function() {
    var hasGroupedColumn, rowSpan, tableClasses, vars;
    vars = this.variables();
    hasGroupedColumn = this.hasGroupedColumn();
    rowSpan = hasGroupedColumn ? 2 : 1;
    tableClasses = 'grouped-table threed-matrix';
    if (this.get('showBorders')) {
      tableClasses += ' show-borders';
    }
    div({
      "class": 'error-placeholder',
      id: "error_" + this.id
    });
    return div({
      "class": 'grouped-table-container'
    }, function() {
      return table({
        "class": tableClasses
      }, function() {
        var column, k, len, ref;
        colgroup({
          span: 1
        });
        ref = this.get('columns');
        for (k = 0, len = ref.length; k < len; k++) {
          column = ref[k];
          if (this.grouped(column)) {
            colgroup({
              span: column.choices.length
            });
          } else {
            colgroup({
              span: 1
            });
          }
        }
        thead(function() {
          tr(function() {
            var l, len1, ref1, results;
            th({
              rowspan: rowSpan
            }, function() {});
            if (this.get('showNotUsed')) {
              th({
                "class": "x_" + this.id + "__na"
              }, function() {
                var ref1;
                return ((ref1 = this.get('notUsedText')) != null ? ref1 : "Not Used").toString();
              });
            }
            ref1 = this.get('columns');
            results = [];
            for (l = 0, len1 = ref1.length; l < len1; l++) {
              column = ref1[l];
              if (this.grouped(column)) {
                results.push(th({
                  "class": "x_" + this.id + "__" + column.id,
                  colspan: column.choices.length
                }, function() {
                  return column.label.toString();
                }));
              } else {
                results.push(th({
                  "class": "x_" + this.id + "__" + column.id,
                  rowspan: rowSpan
                }, function() {
                  return column.label.toString();
                }));
              }
            }
            return results;
          });
          if (hasGroupedColumn) {
            return tr(function() {
              var choice, l, len1, ref1, results;
              ref1 = this.get('columns');
              results = [];
              for (l = 0, len1 = ref1.length; l < len1; l++) {
                column = ref1[l];
                if (this.grouped(column)) {
                  results.push((function() {
                    var len2, m, ref2, results1;
                    ref2 = column.choices;
                    results1 = [];
                    for (m = 0, len2 = ref2.length; m < len2; m++) {
                      choice = ref2[m];
                      results1.push(th({
                        "class": "x_" + this.id + "__" + column.id + "__" + choice.id
                      }, function() {
                        return choice.label();
                      }));
                    }
                    return results1;
                  }).call(this));
                } else {
                  results.push(void 0);
                }
              }
              return results;
            });
          }
        });
        tbody(function() {
          var attrs, l, len1, ref1, results, row;
          ref1 = this.get('rows');
          results = [];
          for (l = 0, len1 = ref1.length; l < len1; l++) {
            row = ref1[l];
            attrs = {};
            if (this.get('extraction')) {
              attrs['data-extraction'] = row.id;
            }
            results.push(tr(attrs, {
              "class": "x_" + this.id + "_" + row.id
            }, function() {
              var choice, id, len2, m, ref2, results1;
              th(function() {
                return label({
                  "for": "id_" + vars[row.id + '_0'].id,
                  style: "width: 250px;"
                }, function() {
                  return row.label.toString();
                });
              });
              if (this.get('showNotUsed')) {
                td({
                  "class": "x_" + this.id + "__na"
                }, function() {
                  return vars[row.id + "_na"].render();
                });
              }
              ref2 = this.get('columns');
              results1 = [];
              for (m = 0, len2 = ref2.length; m < len2; m++) {
                column = ref2[m];
                if (this.grouped(column)) {
                  id = vars[row.id + "_" + column.id].id;
                  results1.push((function() {
                    var len3, n, ref3, results2;
                    ref3 = column.choices;
                    results2 = [];
                    for (n = 0, len3 = ref3.length; n < len3; n++) {
                      choice = ref3[n];
                      results2.push(td({
                        "class": "x_" + this.id + "__" + column.id + "__" + choice.id
                      }, function() {
                        return input({
                          type: 'radio',
                          name: id,
                          value: choice.id,
                          id: "id_" + id + "_" + choice.id
                        });
                      }));
                    }
                    return results2;
                  }).call(this));
                } else {
                  results1.push(td({
                    "class": ("x_" + this.id + "__" + column.id) + (column.sum ? ' sum-inputs' : ''),
                    id: "x_" + this.id + "_" + (row.id * this.get('columns').length + column.id)
                  }, function() {
                    return vars[row.id + "_" + column.id].render();
                  }));
                }
              }
              return results1;
            }));
          }
          return results;
        });
        if (this.requiresTotalRow()) {
          return tfoot(function() {
            return tr(function() {
              var l, len1, ref1, results;
              th(function() {
                return this.get('sumLabel');
              });
              ref1 = this.get('columns');
              results = [];
              for (l = 0, len1 = ref1.length; l < len1; l++) {
                column = ref1[l];
                results.push(td({
                  colspan: (this.grouped(column) ? column.choices.length : 1)
                }, function() {
                  if (column.sum) {
                    return span({
                      "class": 'sum-label',
                      'data:sum': this.get('sum'),
                      'data:target': "x_" + this.id + "__" + column.id
                    });
                  }
                }));
              }
              return results;
            });
          });
        }
      });
    });
  };

  ThreeDGrid.prototype.onSurveyBuilt = function(survey) {
    var extraction;
    if ((extraction = this.get('extraction')) != null) {
      return extraction.resolve(survey);
    }
  };

  ThreeDGrid.prototype.setupElement = function(el, handler) {
    var enabled, extraction;
    if ((extraction = this.get('extraction')) != null) {
      enabled = extraction.evaluate(handler);
      el.find('[data-extraction]').filter(function() {
        return (enabled == null) || !($(this).data('extraction') in enabled);
      }).remove();
    }
    return el;
  };

  return ThreeDGrid;

})(Question);

Question.Signature = (function(superClass) {
  extend(Signature, superClass);

  function Signature() {
    return Signature.__super__.constructor.apply(this, arguments);
  }

  Signature.type = 'signature';

  Signature.prototype.template = function() {
    div({
      "class": 'signature'
    });
    html(this.variables()[''].render());
    return a({
      href: '#',
      style: "float:right",
      "class": 'button reset-signature'
    }, function() {
      return span(function() {
        return 'Clear';
      });
    });
  };

  return Signature;

})(Question.Hidden);

for (name in Question) {
  cls = Question[name];
  if (cls.type != null) {
    Question.TYPES[cls.type] = cls;
  }
}

_.extend(exports, {
  Question: Question
});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var BranchingRule, ClientHandler, DateTimeVariable, Handler, LocalResponse, Looping, MultipleChoiceVariable, Page, Response, SingleChoiceVariable, StringVariable, Survey, SurveyAction, SurveyError, SurveyRedirectException, cacher, randomString,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

SurveyAction = __webpack_require__(45).SurveyAction;

BranchingRule = __webpack_require__(45).BranchingRule;

SurveyRedirectException = __webpack_require__(45).SurveyRedirectException;

StringVariable = __webpack_require__(87).StringVariable;

SingleChoiceVariable = __webpack_require__(87).SingleChoiceVariable;

MultipleChoiceVariable = __webpack_require__(87).MultipleChoiceVariable;

DateTimeVariable = __webpack_require__(87).DateTimeVariable;

randomString = (function(_this) {
  return function(length) {
    var chars, i, l, random, ref1, rnum;
    chars = '0123456789' + 'ABCDEFGHIJKLMNOPQRSTUVWXTZ' + 'abcdefghiklmnopqrstuvwxyz';
    random = '';
    for (i = l = 0, ref1 = length; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
      rnum = Math.floor(Math.random() * chars.length);
      random += chars.substring(rnum, rnum + 1);
    }
    return random;
  };
})(this);

SurveyError = (function(superClass) {
  extend(SurveyError, superClass);

  SurveyError.prototype.name = 'SurveyError';

  function SurveyError(message) {
    this.message = message;
  }

  return SurveyError;

})(Error);

Looping = (function() {
  function Looping() {}

  Looping.prototype.getLoopedObject = function(obj, loopedFor) {
    var copy, item, ref1, root;
    root = (ref1 = obj._underlying) != null ? ref1 : obj;
    copy = _.object(root);
    copy._underlying = root;
    copy.loopedFor = loopedFor;
    copy.id = root.id + ":" + ([
      (function() {
        var l, len, results;
        results = [];
        for (l = 0, len = loopedFor.length; l < len; l++) {
          item = loopedFor[l];
          results.push(item.id);
        }
        return results;
      })()
    ].join(':'));
    if (typeof copy.buildLoopedObject === "function") {
      copy.buildLoopedObject();
    }
    return copy;
  };

  return Looping;

})();

cacher = function(func) {
  var cached, result;
  cached = "_" + (randomString(10));
  result = function() {
    if (this[cached] != null) {
      return this[cached];
    }
    this[cached] = func.apply(this, arguments);
    return this[cached];
  };
  result.clear = function() {
    return this[cached] = null;
  };
  return result;
};

Page = (function() {
  Page.prototype.targetRules = void 0;

  Page.create = function(index, info) {
    var page;
    page = new this(info);
    page.index = index;
    return page;
  };

  function Page(info) {
    var question, ref1, ref2, ref3, ref4, ref5, rule;
    this.id = (ref1 = info.id) != null ? ref1 : randomString(5);
    if (info.label != null) {
      this.label = trans.make(info.label);
    }
    this.questions = (function() {
      var l, len, ref2, ref3, ref4, results;
      ref4 = (ref2 = (ref3 = info.children) != null ? ref3 : info.questions) != null ? ref2 : [];
      results = [];
      for (l = 0, len = ref4.length; l < len; l++) {
        question = ref4[l];
        results.push(Question.create(question));
      }
      return results;
    })();
    this.randomize = (ref2 = info.randomize) != null ? ref2 : false;
    this.skip = (ref3 = (ref4 = info.branching) != null ? (ref5 = ref4[0]) != null ? ref5.uncondition : void 0 : void 0) != null ? ref3 : info.skip;
    if (this.skip) {
      this.skip = BranchingRule.prototype.parseAction({
        skip: this.skip
      });
    }
    this.branching = info.branching != null ? (function() {
      var l, len, ref6, results;
      ref6 = info.branching;
      results = [];
      for (l = 0, len = ref6.length; l < len; l++) {
        rule = ref6[l];
        results.push(BranchingRule.prototype.parse(rule));
      }
      return results;
    })() : void 0;
  }

  Page.prototype.toString = function() {
    var el, label, loops, ref1;
    label = this.label != null ? this.label.toString() : "Page " + (this.index + 1);
    if (!((ref1 = this.loopedFor) != null ? ref1.length : void 0)) {
      return label;
    }
    loops = ((function() {
      var l, len, ref2, results;
      ref2 = this.loopedFor;
      results = [];
      for (l = 0, len = ref2.length; l < len; l++) {
        el = ref2[l];
        results.push((el.source.get('name')) + "=\"" + el.label + "\"");
      }
      return results;
    }).call(this)).join(', ');
    return label + " (looped: " + loops + ")";
  };

  Page.prototype.buildLoopedObject = function() {
    var question;
    return this.questions = (function() {
      var l, len, ref1, results;
      ref1 = this.questions;
      results = [];
      for (l = 0, len = ref1.length; l < len; l++) {
        question = ref1[l];
        results.push(Looping.prototype.getLoopedObject(question, this.loopedFor));
      }
      return results;
    }).call(this);
  };

  Page.prototype.variables = function() {
    var key, l, len, question, ref1, ref2, result, variable;
    result = {};
    ref1 = this.questions;
    for (l = 0, len = ref1.length; l < len; l++) {
      question = ref1[l];
      ref2 = question.variables();
      for (key in ref2) {
        variable = ref2[key];
        result[variable.id] = variable;
      }
    }
    return result;
  };

  Page.prototype.applyTargetRules = function(handler, el) {
    var action, deferred_actions, l, len, len1, m, ref1, ref2, ref3, ref4, results, rule, rule_type, rules, target, targets;
    deferred_actions = {
      'hide': {},
      'show': {}
    };
    ref2 = (ref1 = this.targetRules) != null ? ref1 : [];
    for (l = 0, len = ref2.length; l < len; l++) {
      rule = ref2[l];
      ref3 = rule.actions;
      for (m = 0, len1 = ref3.length; m < len1; m++) {
        action = ref3[m];
        if ((ref4 = action.type) === 'hide' || ref4 === 'show') {
          deferred_actions[action.type][action.target] = (deferred_actions[action.type][action.target] || []).concat([rule.condition]);
        } else if (action.hasTargets) {
          action.apply(handler.evaluateCondition(rule.condition), el);
        }
      }
    }
    results = [];
    for (rule_type in deferred_actions) {
      targets = deferred_actions[rule_type];
      results.push((function() {
        var results1;
        results1 = [];
        for (target in targets) {
          rules = targets[target];
          results1.push((new SurveyAction.TYPES[rule_type](target)).apply(handler.evaluateCondition(new OrNode(rules)), el));
        }
        return results1;
      })());
    }
    return results;
  };

  Page.prototype.dynamics = function() {
    var question;
    return _.flatten((function() {
      var l, len, ref1, ref2, results;
      ref1 = this.questions;
      results = [];
      for (l = 0, len = ref1.length; l < len; l++) {
        question = ref1[l];
        results.push((ref2 = question.dynamics()) != null ? ref2 : []);
      }
      return results;
    }).call(this), true);
  };

  Page.prototype.hiddenFor = function(handler) {
    var l, len, ref1, ref2, rule;
    ref2 = (ref1 = this.hideRules) != null ? ref1 : [];
    for (l = 0, len = ref2.length; l < len; l++) {
      rule = ref2[l];
      if (handler.evaluateCondition(rule.condition)) {
        return true;
      }
    }
    return false;
  };

  return Page;

})();

Survey = (function() {
  Survey.prototype.metaVariables = {
    _key: new StringVariable({
      id: '_key'
    }),
    _created_at: new DateTimeVariable({
      id: '_created_at',
      format: 'datetimetz'
    }),
    _updated_at: new DateTimeVariable({
      id: '_updated_at',
      format: 'datetimetz'
    }),
    _completed: new SingleChoiceVariable({
      id: '_completed'
    }),
    _weighted_score: new StringVariable({
      id: '_weighted_score'
    })
  };

  function Survey(info) {
    var action, index, l, language, len, len1, len2, len3, len4, m, n, o, page, q, question, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rule, targetPage;
    this.id = info.id;
    this.pages = (function() {
      var l, len, ref1, ref2, ref3, results;
      ref3 = (ref1 = (ref2 = info.form) != null ? ref2 : info.pages) != null ? ref1 : [];
      results = [];
      for (index = l = 0, len = ref3.length; l < len; index = ++l) {
        page = ref3[index];
        results.push(Page.create(index, page));
      }
      return results;
    })();
    this.title = trans.make((ref1 = info.title) != null ? ref1 : '');
    this.description = trans.make((ref2 = info.description) != null ? ref2 : '');
    this.options = {
      titleOnlyFirstPage: info.firstPageTitleDescription
    };
    this.languages = [];
    this.defaultLanguage = info.defaultLanguage;
    ref4 = (ref3 = info.languages) != null ? ref3 : ['en'];
    for (l = 0, len = ref4.length; l < len; l++) {
      language = ref4[l];
      if (language.code != null) {
        this.languages.push(language.code);
        if (!this.defaultLanguage || language.isDefault) {
          this.defaultLanguage = language.code;
        }
      } else {
        this.languages.push(language);
        if (!this.defaultLangauge) {
          this.defaultLanguage = language;
        }
      }
    }
    info.languages = trans.prototype.availableLanguages = this.languages;
    info.defaultLanguage = trans.prototype.defaultLanguage = this.defaultLanguage;
    trans.prototype.language = this.defaultLanguage;
    this.loops = this.parseLoops(info);
    ref5 = this.pages;
    for (m = 0, len1 = ref5.length; m < len1; m++) {
      page = ref5[m];
      ref6 = page.questions;
      for (n = 0, len2 = ref6.length; n < len2; n++) {
        question = ref6[n];
        question.onSurveyBuilt(this);
      }
      ref9 = ((ref8 = page.branching) != null ? ref8 : []).concat((ref7 = page.dynamics()) != null ? ref7 : []);
      for (o = 0, len3 = ref9.length; o < len3; o++) {
        rule = ref9[o];
        ref10 = rule.actions;
        for (q = 0, len4 = ref10.length; q < len4; q++) {
          action = ref10[q];
          if (action.hasTargets) {
            targetPage = this.resolvePage(action.target);
            if (targetPage == null) {
              console.warn("Branching rule target [" + action.target + "] cannot be found, skipping...");
              continue;
            }
            (targetPage.targetRules != null ? targetPage.targetRules : targetPage.targetRules = []).push(rule);
          } else if (action.type === 'hide-page') {
            targetPage = action.getPage(this);
            if (targetPage == null) {
              console.warn("Branching rule target [" + action.target + "] cannot be found, skipping...");
              continue;
            }
            (targetPage.hideRules != null ? targetPage.hideRules : targetPage.hideRules = []).push(rule);
          }
        }
      }
    }
  }

  Survey.prototype.loopedPages = function() {
    return this._loopedPages != null ? this._loopedPages : this._loopedPages = this.expandLoops(this.buildLoopTree(this.loops));
  };

  Survey.prototype.expandLoops = function(loops, pages, offset) {
    var base, children, el, j, l, len, len1, looped, m, ref1, ref2, ref3, source;
    if (offset == null) {
      offset = 0;
    }
    if (pages == null) {
      pages = this.pages.slice();
    }
    loops = loops.slice().reverse();
    for (l = 0, len = loops.length; l < len; l++) {
      ref1 = loops[l], el = ref1[0], children = ref1[1];
      base = pages.splice(el.range[0] - offset, el.range[1] - el.range[0] + 1);
      base = this.expandLoops(children, base, el.range[0]);
      looped = [];
      source = this.resolve(el.source);
      if (source == null) {
        console.warn("Could not find loop source [" + el.source + "] for pages " + (el.range[0] + 1) + "-" + (el.range[1] + 1) + ", skipping...");
        continue;
      }
      if (source.getExtraction == null) {
        console.warn("Loop source [" + el.source + "] for pages " + (el.range[0] + 1) + "-" + (el.range[1] + 1) + " does not support extraction, skipping...");
        continue;
      }
      ref3 = (ref2 = source.getExtraction(void 0, el.options)) != null ? ref2 : [];
      for (m = 0, len1 = ref3.length; m < len1; m++) {
        j = ref3[m];
        looped = looped.concat(_.map(base, function(obj) {
          var loopedFor, ref4;
          loopedFor = ((ref4 = obj.loopedFor) != null ? ref4 : []).slice();
          loopedFor.unshift({
            id: j.id,
            label: j.label(),
            source: source,
            loop: el
          });
          return Looping.prototype.getLoopedObject(obj, loopedFor);
        }));
      }
      pages.splice.apply(pages, [el.range[0] - offset, 0].concat(looped));
    }
    return pages;
  };

  Survey.prototype.buildLoopTree = function(loops) {
    var end, grouped, keyFunc;
    end = -1;
    keyFunc = function(el) {
      if (el.range[0] > end) {
        end = el.range[1];
      }
      return end;
    };
    grouped = _.groupBy(loops, keyFunc);
    return _.map(grouped, (function(_this) {
      return function(el) {
        var parent;
        parent = el.shift();
        return [parent, _this.buildLoopTree(el)];
      };
    })(this));
  };

  Survey.prototype.parseLoops = function(info) {
    var l, len, len1, loops, m, page, question, ref1, ref2, ref3, ref4, ref5, ref6;
    loops = [];
    ref3 = (ref1 = (ref2 = info.form) != null ? ref2 : info.pages) != null ? ref1 : [];
    for (l = 0, len = ref3.length; l < len; l++) {
      page = ref3[l];
      ref6 = (ref4 = (ref5 = page.children) != null ? ref5 : page.questions) != null ? ref4 : [];
      for (m = 0, len1 = ref6.length; m < len1; m++) {
        question = ref6[m];
        if (question.looping != null) {
          loops.push({
            source: question.id,
            range: question.looping.range,
            options: question.looping.options
          });
        }
      }
    }
    return loops;
  };

  Survey.pipe = function(txt) {
    return txt;
  };

  Survey.pipeAttr = function(txt) {
    if (txt.toString().search(/\{\{\s*([^\{\}]+)\s*\}\}/g) < 0) {
      return "";
    }
    txt = txt.toString().replace('"', '\\"');
    return "data-piping=\"" + txt + "\"";
  };

  Survey.prototype.resolveName = function(name) {
    var match, question;
    match = /^([a-zA-Z0-9\-]+)(?:_(\d+))?$/.exec(name);
    if (match == null) {
      return null;
    }
    question = this.nameMap()[match[1]];
    if (question == null) {
      return null;
    }
    if (match[2] != null) {
      return question.id + "_" + match[2];
    } else {
      return question.id;
    }
  };

  Survey.prototype.nameMap = cacher(function() {
    var l, len, len1, m, mapping, page, question, ref1, ref2;
    mapping = {};
    ref1 = this.pages;
    for (l = 0, len = ref1.length; l < len; l++) {
      page = ref1[l];
      ref2 = page.questions;
      for (m = 0, len1 = ref2.length; m < len1; m++) {
        question = ref2[m];
        if (question.get('name')) {
          mapping[question.get('name')] = question;
        }
      }
    }
    return mapping;
  });

  Survey.prototype.resolve = function(ref) {
    var match;
    if ((match = /([a-zA-Z0-9]+)_(\d+)/.exec(ref)) != null) {
      ref = match[1];
    }
    return this.questions()[ref];
  };

  Survey.prototype.resolvePage = function(ref) {
    var ref1;
    return (ref1 = this.resolve(ref)) != null ? ref1.page : void 0;
  };

  Survey.prototype.questions = cacher(function() {
    var l, len, len1, m, page, question, questions, ref1, ref2;
    questions = {};
    ref1 = this.pages;
    for (l = 0, len = ref1.length; l < len; l++) {
      page = ref1[l];
      ref2 = page.questions;
      for (m = 0, len1 = ref2.length; m < len1; m++) {
        question = ref2[m];
        questions[question.id] = _.extend(_.object(question), {
          page: page
        });
      }
    }
    return questions;
  });

  Survey.prototype.variables = cacher(function() {
    var page;
    return _.extend.apply(_, [{}].concat(slice.call((function() {
      var l, len, ref1, results;
      ref1 = this.loopedPages();
      results = [];
      for (l = 0, len = ref1.length; l < len; l++) {
        page = ref1[l];
        results.push(page.variables());
      }
      return results;
    }).call(this))));
  });

  Survey.prototype.variablesByName = function() {
    var id, ref1, result, variable;
    result = {};
    ref1 = this.variables();
    for (id in ref1) {
      variable = ref1[id];
      if (variable.name()) {
        result[variable.name()] = variable;
      }
    }
    return result;
  };

  Survey.prototype.resolveVariable = function(name) {
    var id, variables;
    variables = this.variables();
    if (name in variables) {
      return variables[name];
    }
    id = this.resolveName(name);
    if (id == null) {
      return null;
    }
    return variables[id];
  };

  Survey.prototype.getResponses = function() {
    var ref1;
    return JSON.parse((ref1 = localStorage["survey." + this.id + ".responses"]) != null ? ref1 : "[]");
  };

  Survey.prototype.setResponses = function(value) {
    delete localStorage["survey." + this.id + ".responses"];
    return localStorage["survey." + this.id + ".responses"] = JSON.stringify(value);
  };

  Survey.prototype.deleteResponses = function() {
    var key, keys, l, len;
    keys = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    for (l = 0, len = keys.length; l < len; l++) {
      key = keys[l];
      delete localStorage["responses." + key];
    }
    return this.setResponses(_.without.apply(_, [this.getResponses()].concat(slice.call(keys))));
  };

  return Survey;

})();

Response = (function() {
  function Response(survey, key) {
    this.survey = survey;
    this.key = key != null ? key : randomString(10);
    this.createdAt = new _.date();
    this.updatedAt = new _.date();
    this.completed = 0;
    this.weightedScore = 0;
    this.values = {};
    if (key != null) {
      this.load();
    }
  }

  Response.prototype.load = function() {};

  Response.prototype.save = function() {};

  Response.prototype.names = function(el) {
    return _.uniq($(':input[name]:not(:button,:submit)', el).map(function() {
      return $(this).attr('name');
    }));
  };

  Response.prototype.loadForm = function(el, page) {
    var name, names, variable, variables;
    if (this.values == null) {
      return;
    }
    names = this.names(el);
    variables = page.variables();
    for (name in variables) {
      variable = variables[name];
      if (name in this.values) {
        variable.loadForm(el, this.values[name]);
      }
    }
    return this.weightedScore = this.values['_weighted_score'] = this.getCurrentScore(page);
  };

  Response.prototype.saveForm = function(el, page) {
    var disabled, form, l, len, name, name1, val, vals, variable, variables;
    disabled = $("li:not(:has(:checked)) :input[name$=_other]:enabled", el).attr('disabled', 'disabled');
    vals = $('form', el).serializeArray();
    disabled.removeAttr('disabled');
    variables = page.variables();
    form = {};
    for (l = 0, len = vals.length; l < len; l++) {
      val = vals[l];
      (form[name1 = val.name] != null ? form[name1] : form[name1] = []).push(val.value);
    }
    if (this.values == null) {
      this.values = {};
    }
    for (name in variables) {
      variable = variables[name];
      variable.saveForm(form, this.values);
    }
    return this.save();
  };

  Response.prototype.getCurrentScore = function(current_page) {
    var l, len, name, page, ref1, ref2, score, variable, variables;
    score = 0;
    if (this.values == null) {
      return score;
    }
    ref1 = this.survey.pages;
    for (l = 0, len = ref1.length; l < len; l++) {
      page = ref1[l];
      if (!(page.index < current_page.index)) {
        continue;
      }
      variables = page.variables();
      for (name in variables) {
        variable = variables[name];
        if ((ref2 = variable.type) === 'boolean' || ref2 === 'single' || ref2 === 'multi') {
          score += variable.getScore(this.values[name]);
        }
      }
    }
    return score;
  };

  return Response;

})();

LocalResponse = (function(superClass) {
  extend(LocalResponse, superClass);

  function LocalResponse() {
    return LocalResponse.__super__.constructor.apply(this, arguments);
  }

  LocalResponse.prototype.load = function() {
    var ref1, ref2, ref3, ref4, value;
    value = localStorage["responses." + this.key];
    this.values = value != null ? JSON.parse(value) : {};
    this.updatedAt = ((ref1 = this.values) != null ? ref1._updated_at : void 0) ? new _.date(this.values._updated_at) : void 0;
    this.createdAt = ((ref2 = this.values) != null ? ref2._created_at : void 0) ? new _.date(this.values._created_at) : void 0;
    return this.completed = (ref3 = (ref4 = this.values) != null ? ref4._completed : void 0) != null ? ref3 : 0;
  };

  LocalResponse.prototype.save = function(skipUpdate) {
    var allResponses, ref1;
    if (skipUpdate == null) {
      skipUpdate = false;
    }
    if (!skipUpdate) {
      this.updatedAt = new _.date();
    }
    this.values._created_at = this.createdAt;
    this.values._updated_at = this.updatedAt;
    this.values._completed = this.completed;
    delete localStorage["responses." + this.key];
    localStorage["responses." + this.key] = JSON.stringify(this.values);
    allResponses = this.survey.getResponses();
    if (ref1 = this.key, indexOf.call(allResponses, ref1) < 0) {
      allResponses.push(this.key);
    }
    return this.survey.setResponses(allResponses);
  };

  LocalResponse.prototype.getTotalScore = function() {
    var l, len, name, page, ref1, ref2, score, variable, variables, vscore;
    score = 0;
    if (this.values == null) {
      return String(score);
    }
    ref1 = this.survey.pages;
    for (l = 0, len = ref1.length; l < len; l++) {
      page = ref1[l];
      variables = page.variables();
      for (name in variables) {
        variable = variables[name];
        if ((ref2 = variable.type) === 'boolean' || ref2 === 'single' || ref2 === 'multi') {
          vscore = variable.getScore(this.values[name]);
          if (vscore != null) {
            score += vscore;
          }
        }
      }
    }
    return String(score);
  };

  return LocalResponse;

})(Response);

Handler = (function() {
  function Handler(survey, response, options, style_json) {
    this.survey = survey;
    this.response = response;
    if (style_json == null) {
      style_json = {};
    }
    this.options = SurveyOptions.parse(options);
    this.style_json = style_json;
    this.expr_mapping = {};
    this.parser = new ExprParser();
  }

  Handler.prototype.validate = function(page) {
    var e, enabled, extraction, first, k, l, len, len1, m, placeholder, question, ref1, ref2, rule, valid, variable, variables;
    valid = true;
    $('.error-placeholder').empty().hide();
    if (page.branching) {
      ref1 = page.branching;
      for (l = 0, len = ref1.length; l < len; l++) {
        rule = ref1[l];
        if (rule.actions[0] instanceof InvalidAction && this.evaluateCondition(rule.condition)) {
          valid = false;
          placeholder = $("#error_" + rule.actions[0].target);
          placeholder.append("<ul class=\"errorlist\"><li>" + rule.actions[0].feedback + "</li></ul>");
          placeholder.show();
        }
      }
    }
    ref2 = page.questions;
    for (m = 0, len1 = ref2.length; m < len1; m++) {
      question = ref2[m];
      variables = question.variables();
      if ((extraction = question.get('extraction')) != null) {
        enabled = extraction.evaluate(this);
        for (k in variables) {
          variable = variables[k];
          if (!(k in enabled)) {
            delete variables[k];
          }
        }
      }
      for (k in variables) {
        variable = variables[k];
        if ($("[name=" + (variable.escapedId()) + "]").is('.hidden, :disabled')) {
          continue;
        }
        try {
          variable.validateResponse(this.response);
        } catch (error1) {
          e = error1;
          valid = false;
          placeholder = $("#error_" + (variable.escapedId()));
          placeholder.append("<ul class=\"errorlist\"><li>" + (e.message.toString()) + "</li></ul>");
          placeholder.show();
        }
      }
      try {
        if (!($('#x_' + question.escapedId()).css('display') === 'none')) {
          question.validateResponse(this.response);
        }
      } catch (error1) {
        e = error1;
        valid = false;
        placeholder = $("#error_" + (question.escapedId()));
        placeholder.append("<ul class=\"errorlist\"><li>" + (e.message.toString()) + "</li></ul>");
        placeholder.show();
      }
    }
    if (!valid) {
      first = $('.error-placeholder:not(:empty) .errorlist').eq(0).parents('.question:eq(0)');
      if (first.length) {
        first.scrollTo().end().flash({
          backgroundColor: '#A27D34'
        }, 1000).flash({
          backgroundColor: '#A27D34'
        }, 1000);
      }
    }
    return valid;
  };

  Handler.prototype.progressBarTemplate = _.template('<div class="progress-bar">\n	<div class="bar" style="width: <%= progress %>%;"></div>\n	<span class="progress"><%= progress %>%</span>\n</div>');

  Handler.prototype.getProgress = function(page) {
    var pages;
    pages = this.survey.loopedPages();
    if ((page == null) || page === 'f' || page === 't') {
      return 100;
    }
    return parseInt(pages.indexOf(page) * 100 / pages.length, 10);
  };

  Handler.prototype.createStyle = function(css) {
    var el;
    el = $('<style type="text/css"/>');
    if (el[0].styleSheet) {
      el[0].styleSheet.cssText = css;
    } else {
      el.text(css);
    }
    return el;
  };

  Handler.prototype.getThemeCss = function() {
    var formatStyles, items, l, len, options_dict, ref1, rules, selector;
    rules = {};
    if (this.options.get('style.background_image')) {
      rules['body.survey'] = {
        'background-image': "url(" + (this.options.get('style.background_image')) + ")"
      };
    }
    ref1 = [this.style_json, this.options.get('style.css')];
    for (l = 0, len = ref1.length; l < len; l++) {
      options_dict = ref1[l];
      for (selector in options_dict) {
        items = options_dict[selector];
        selector = selector.replace(/^(.*?)\ *(,?\ *html\ *,?)\ *(.*)/, '$1$3').replace(/^(body)/, '$1.survey').replace(/^(div#main div#survey)/, '#survey').replace(/^(#survey #x|#x)(.*)$/, '$1_$2').replace(/^.*?\.header-progress-container(.*)$/, '#survey .survey-header$1').replace(/^.*?\.survey-progress-outer(.*)$/, '#survey .progress-bar$1').replace(/^.*?\.survey-progress-inner(.*)$/, '#survey .progress-bar .bar$1');
        _.each(items, function(v, p) {
          if (selector.match(/\#survey$/)) {
            if (p === 'width') {
              delete items[p];
            }
          }
          if (selector.match(/body\.survey$/)) {
            if (p === 'margin-top') {
              return delete items[p];
            }
          }
        });
        if (!_.isEmpty(items)) {
          rules[selector] = items;
        }
      }
    }
    formatStyles = function(styles) {
      return (_.map(styles, function(value, property) {
        return property + ":" + value + ";";
      })).join('');
    };
    return (_.map(rules, function(styles, selector) {
      if (!_.isEmpty(styles)) {
        return selector + "{" + (formatStyles(styles)) + "}";
      }
    })).join('\n');
  };

  Handler.prototype.getThemeStyle = function() {
    return this.createStyle(this.getThemeCss());
  };

  Handler.prototype.invalidateContext = function() {
    return this.context = void 0;
  };

  Handler.prototype.buildContext = function() {
    var entry, extraction, fixName, i, index, item, l, len, len1, len2, len3, loopId, m, n, new_variable_name, o, page, q_name, question, question_name, ref1, ref2, ref3, ref4, ref5, ref6, ref7, sameLoop, variable, variable_name;
    if (this.context != null) {
      return this.context;
    }
    fixName = function(name) {
      name = name.replace(/\-/g, '_');
      if (!isNaN(name[0])) {
        return '_' + name;
      } else {
        return name;
      }
    };
    this.context = _.extend({
      'collector': {},
      'user': {},
      'invite': {},
      'get_variable': {},
      'metas': {}
    }, this.response.values);
    this.context.metas = {
      weighted_score: (function(_this) {
        return function() {
          return _this.response.weightedScore;
        };
      })(this)
    };
    ref1 = this.survey.loopedPages();
    for (l = 0, len = ref1.length; l < len; l++) {
      page = ref1[l];
      loopId = '';
      ref3 = (ref2 = page.loopedFor) != null ? ref2 : [];
      for (m = 0, len1 = ref3.length; m < len1; m++) {
        entry = ref3[m];
        loopId += ':' + entry.id;
      }
      sameLoop = this.currentPage.loopedFor && page.loopedFor && this.currentPage.loopedFor[0].loop === page.loopedFor[0].loop && this.currentPage.loopedFor[0].id === page.loopedFor[0].id;
      ref4 = page.questions;
      for (n = 0, len2 = ref4.length; n < len2; n++) {
        question = ref4[n];
        if (question.name()) {
          q_name = fixName(question.name());
          question_name = q_name + loopId;
          if (question instanceof Question.ThreeDGrid) {
            this.context[question_name] = new ThreeDMatrixContext(question, this.response.values);
          } else {
            this.context[question_name] = new QuestionContext(question, this.response.values);
          }
          if (sameLoop) {
            this.context[q_name] = this.context[question_name];
          }
          index = 0;
          ref5 = question.variables();
          for (i in ref5) {
            variable = ref5[i];
            variable_name = fixName(variable.name());
            if (variable_name.indexOf('other.') >= 0) {
              new_variable_name = variable_name.replace(/\./g, '_');
            } else {
              variable_name = variable_name.split('\.');
              new_variable_name = variable_name[0] + '_' + index;
            }
            variable_name = new_variable_name + loopId;
            this.context[variable_name] = new VariableContext(variable, this.response.values);
            if (sameLoop) {
              this.context[new_variable_name] = this.context[variable_name];
            }
            index++;
          }
        }
      }
      ref7 = (ref6 = this.currentPage.loopedFor) != null ? ref6 : [];
      for (o = 0, len3 = ref7.length; o < len3; o++) {
        entry = ref7[o];
        extraction = entry.source.getExtraction(this.response, entry.loop.options);
        item = _.find(extraction, function(item) {
          return item.id === entry.id;
        });
        this.context[entry.source.name()] = item != null ? typeof item.label === "function" ? item.label() : void 0 : void 0;
      }
    }
    return this.context;
  };

  Handler.prototype.renderSurveyHeader = function(page) {
    var dropdown, el, langForm, right;
    el = $('<div class="survey-header clearfix"/>');
    if (this.options.get('style.logo')) {
      el.append($('<img class="survey-logo"/>').attr('src', this.options.get('style.logo')));
    }
    right = $('<div class="right"/>').appendTo(el);
    if (this.survey.languages.length > 1) {
      langForm = $('<form class="language-select"/>').appendTo(right);
      dropdown = trans.localizedDropdown();
      langForm.append("Language: ", dropdown, " <input type=\"submit\" value=\"Go\" class=\"button-smaller\" />");
    }
    if (!this.survey.options.titleOnlyFirstPage || page.index === 0) {
      if (this.survey.title) {
        el.append($('<h1 class="survey-title"/>').html(this.survey.title.toString()));
      }
      if (this.survey.description) {
        el.append($('<div class="survey-description"/>').html(this.survey.description.toString()));
      }
    }
    return el;
  };

  Handler.prototype.updateExprPiping = function(piped) {
    var el, error, expression, i, j, matched, parsedNode, piped_value, replaced, results, value;
    i = 0;
    results = [];
    while (i < piped.el_list.length) {
      el = piped.el_list[i];
      matched = el.expr.match(/\{\{\s*([^\{\}]+)\s*\}\}/g);
      replaced = el.expr;
      j = 0;
      while (j < matched.length) {
        expression = $.trim(matched[j].replace("{{", "").replace("}}", ""));
        parsedNode = this.expr_mapping[expression].parsedNode;
        if (parsedNode) {
          try {
            piped_value = parsedNode.evaluate(this);
            if (piped_value.label) {
              value = piped_value.label();
            } else {
              value = piped_value;
            }
          } catch (error1) {
            error = error1;
            value = "error";
          }
        } else {
          value = "error";
        }
        replaced = replaced.replace(matched[j], value);
        j++;
      }
      el.el.nodeValue = replaced;
      results.push(i++);
    }
    return results;
  };

  Handler.prototype.updatePiping = function(form, page) {
    var entry, expr, extraction, ids, item, l, len, piped, ref1, ref2, results, vars;
    vars = this.survey.variablesByName();
    ids = this.survey.variables();
    piped = {};
    ref2 = (ref1 = page.loopedFor) != null ? ref1 : [];
    for (l = 0, len = ref2.length; l < len; l++) {
      entry = ref2[l];
      if (entry.source.name()) {
        extraction = entry.source.getExtraction(this.response, entry.loop.options);
        item = _.find(extraction, function(item) {
          return item.id === entry.id;
        });
        piped[entry.source.name()] = item != null ? typeof item.label === "function" ? item.label() : void 0 : void 0;
      }
    }
    results = [];
    for (expr in this.expr_mapping) {
      results.push(this.updateExprPiping(this.expr_mapping[expr]));
    }
    return results;
  };

  Handler.prototype.renderPage = function(page) {
    var buttons, el, l, len, question, renderQuestions, rendered;
    this.invalidateContext();
    el = document.createDocumentFragment();
    renderQuestions = page.randomize ? _(page.questions).shuffled() : page.questions;
    for (l = 0, len = renderQuestions.length; l < len; l++) {
      question = renderQuestions[l];
      rendered = question.render();
      question.setupElement(rendered, this);
      el.appendChild(rendered[0]);
    }
    buttons = $('<div class="buttons"/>');
    if (_.indexOf(this.survey.loopedPages(), page) > 0 && this.options.attributes['buttons.back'] !== false) {
      buttons.append($("<input class='button back' type='button' value='" + (this.options.get('strings.buttons.back')) + "' />"));
    }
    if (_.indexOf(this.survey.loopedPages(), page) === this.survey.loopedPages().length - 1) {
      buttons.append(" <input class='button' type='submit' value='" + (this.options.get('strings.buttons.submit')) + "' />");
    } else {
      buttons.append(" <input class='button' type='submit' value='" + (this.options.get('strings.buttons.next')) + "' />");
    }
    el.appendChild(buttons[0]);
    this.response.loadForm(el, page);
    this.generateExprMapping($(el)[0]);
    el = $('<form class="survey-form" method="post" action=""/>').append(el);
    this.updatePiping(el, page);
    page.applyTargetRules(this, el);
    setTimeout(((function(_this) {
      return function() {
        $('.question-body:visible', el).each(function() {
          if (/Android/.test(navigator.userAgent)) {
            return $(this).css('overflow', 'visible');
          }
        });
        if ($('.rank-variable-bin, .rank-choice-bin', el).is(':visible')) {
          return $('.rank-variable-bin, .rank-choice-bin', el).height(Math.max($('.rank-variable-bin').height(), $('.rank-choice-bin').height()));
        }
      };
    })(this)), 0);
    return el;
  };

  Handler.prototype.renderFinishPage = function() {
    return $('<div class="survey-finish" />').html(this.options.get('strings.thankyou').toString());
  };

  Handler.prototype.renderTerminatePage = function() {
    return $('<div class="survey-terminate" />').html(this.options.get('strings.terminated').toString());
  };

  Handler.prototype.buildPagePath = function(stop) {
    var e, page, pages, path;
    pages = this.survey.loopedPages();
    page = pages[0];
    path = [page];
    while (pages.indexOf(page) < pages.indexOf(stop)) {
      try {
        page = this.getNextPage(page);
      } catch (error1) {
        e = error1;
        break;
      }
      path.push(page);
    }
    return path;
  };

  Handler.prototype.getNextPage = function(page) {
    var action, choice, extraction, item, l, len, len1, len2, len3, len4, len5, m, n, nextPage, o, q, question, r, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rule, skipping;
    nextPage = null;
    ref2 = (ref1 = page.questions) != null ? ref1 : [];
    for (l = 0, len = ref2.length; l < len; l++) {
      question = ref2[l];
      ref4 = (ref3 = typeof question.getSimpleBranching === "function" ? question.getSimpleBranching() : void 0) != null ? ref3 : [];
      for (m = 0, len1 = ref4.length; m < len1; m++) {
        rule = ref4[m];
        ref5 = rule.actions;
        for (n = 0, len2 = ref5.length; n < len2; n++) {
          action = ref5[n];
          if (action.isBranch && this.evaluateCondition(rule.condition)) {
            nextPage = action.apply(this.survey);
            break;
          }
        }
        if (nextPage != null) {
          break;
        }
      }
      if (nextPage != null) {
        break;
      }
    }
    ref7 = (ref6 = page.branching) != null ? ref6 : [];
    for (o = 0, len3 = ref7.length; o < len3; o++) {
      rule = ref7[o];
      ref8 = rule.actions;
      for (q = 0, len4 = ref8.length; q < len4; q++) {
        action = ref8[q];
        if (action.isBranch && this.evaluateCondition(rule.condition)) {
          nextPage = action.apply(this.survey);
          break;
        }
      }
      if (nextPage != null) {
        break;
      }
    }
    if ((nextPage == null) && page.skip) {
      nextPage = page.skip.apply(this.survey);
    }
    if (nextPage == null) {
      nextPage = this.survey.loopedPages()[this.survey.loopedPages().indexOf(page) + 1];
    }
    page = nextPage;
    while (page != null) {
      skipping = page.hiddenFor(this);
      if (!skipping && (page != null ? (ref9 = page.loopedFor) != null ? ref9.length : void 0 : void 0)) {
        ref10 = page.loopedFor;
        for (r = 0, len5 = ref10.length; r < len5; r++) {
          item = ref10[r];
          extraction = (function() {
            var len6, ref11, results, s;
            ref11 = item.source.getExtraction(this.response, item.loop.options);
            results = [];
            for (s = 0, len6 = ref11.length; s < len6; s++) {
              choice = ref11[s];
              results.push(choice.id);
            }
            return results;
          }).call(this);
          if (ref11 = item.id, indexOf.call(extraction, ref11) < 0) {
            skipping = true;
            break;
          }
        }
      }
      if (!skipping) {
        break;
      }
      page = this.survey.loopedPages()[this.survey.loopedPages().indexOf(page) + 1];
    }
    return page;
  };

  Handler.prototype.getPreviousPage = function(page) {
    var path;
    path = this.buildPagePath(page);
    return path[path.length - 2];
  };

  Handler.prototype.evaluateCondition = function(condition) {
    return condition.evaluate(this);
  };

  Handler.prototype.extractExpr = function(node) {
    var expression, i, mapped, matched, results;
    matched = node.nodeValue.match(/\{\{\s*([^\{\}]+)\s*\}\}/g);
    if (matched && matched.length) {
      i = 0;
      results = [];
      while (i < matched.length) {
        expression = $.trim(matched[i].replace("{{", "").replace("}}", ""));
        if (expression in this.expr_mapping) {
          mapped = this.expr_mapping[expression];
          mapped.el_list.push({
            expr: node.nodeValue,
            el: node
          });
        } else {
          mapped = {};
          try {
            mapped.parsedNode = this.parser.parse(expression);
          } catch (error1) {}
          mapped.el_list = [
            {
              expr: node.nodeValue,
              el: node
            }
          ];
          this.expr_mapping[expression] = mapped;
        }
        results.push(i++);
      }
      return results;
    }
  };

  Handler.prototype.generateExprMapping = function(root) {
    var attr, i, results;
    if (root.nodeName.toLowerCase() === "#text") {
      return this.extractExpr(root);
    } else {
      for (attr in root.attributes) {
        if (root.attributes[attr] instanceof Attr) {
          this.extractExpr(root.attributes[attr]);
        }
      }
      i = 0;
      results = [];
      while (i < root.childNodes.length) {
        this.generateExprMapping(root.childNodes[i]);
        results.push(i++);
      }
      return results;
    }
  };

  Handler.prototype.initializeBehaviors = function(el) {
    var calcTotal, refreshCheckbox, update3dTotals, updateTotal;
    el.delegate('.force-unique :radio, .force-unique :checkbox', 'change', function(e) {
      var value;
      value = $(e.target).val();
      return $(e.target).closest('.force-unique').find(':input:checked').filter(function() {
        return this.value === value;
      }).not(e.target).attr('checked', false);
    });
    el.delegate(':radio', 'click', function(e) {
      if ($(e.target).data('checked')) {
        $(e.target).removeAttr('checked');
        $(e.target).data('checked', false);
        return e.preventDefault();
      } else {
        return $(e.target).data('checked', true);
      }
    });
    el.delegate(':radio', 'focus', function(e) {
      return $(e.target).data('checked', !!$(e.target).attr('checked'));
    });
    calcTotal = function(inputs) {
      var total;
      total = 0;
      inputs.each(function(i) {
        var value;
        value = $(this).val().replace(',', '.').replace(' ', '');
        if (value.match(/^(\d+)|(\d*\.\d+)$/)) {
          return total += value.indexOf('.') < 0 ? parseInt(value, 10) : parseFloat(value);
        }
      });
      return total;
    };
    updateTotal = function(question) {
      var label, value;
      label = $('.sum-label', question);
      value = label.attr('data:label').replace('{x}', label.attr('data:sum')).replace('{y}', calcTotal($('input', question)));
      value = Survey.pipe(value);
      label.empty();
      return label.append(value);
    };
    el.delegate('.question-text-response-grid .sum-inputs input', 'keyup change', function(e) {
      var question;
      question = $(e.target).closest('.question-text-response-grid');
      return updateTotal(question);
    });
    update3dTotals = function(question) {
      return $('.sum-label', question).each(function() {
        return $(this).text(calcTotal($("." + ($(this).attr('data:target')) + " input", question)));
      });
    };
    el.delegate('.question-threed-grid .sum-inputs input', 'keyup change', function(e) {
      var question;
      question = $(e.target).closest('.question-threed-grid');
      return update3dTotals(question);
    });
    el.bind('initialize', function() {
      $('.question-text-response-grid:has(.sum-inputs)', el).each(function() {
        return updateTotal(this);
      });
      return $('.question-threed-grid:has(.sum-label)', el).each(function() {
        return update3dTotals(this);
      });
    });
    el.bind('initialize', function() {
      return $('select.drilldown').hide().each(function(i, el) {
        var categories, choices, name;
        name = $(el).attr('name');
        choices = $('<select>', {
          size: 5,
          "class": 'drill-down-selector',
          change: function() {
            return $(el).val($('option:selected', this).val());
          }
        });
        categories = $('<select>', {
          size: 5,
          "class": 'drill-down-selector',
          change: function() {
            var group;
            choices.empty();
            group = $('option:selected', this).data('optgroup');
            if (group) {
              group.find('option').clone().appendTo(choices);
              return choices.val($(el).val());
            }
          }
        });
        $('optgroup', el).each(function(j, nl) {
          categories.append($('<option />', {
            val: j,
            text: $(nl).attr('label'),
            data: {
              optgroup: $(nl)
            }
          }));
          if ($('option:selected', nl).length) {
            return categories.val(j);
          }
        });
        choices.insertAfter(el);
        categories.insertAfter(el);
        return categories.trigger('change');
      });
    });
    el.bind('initialize', function() {
      $('.star-container input', el).rating();
      if (($().draggable != null) && ($().droppable != null)) {
        return $.each($('.ranking-question'), function(i, el) {
          var original;
          original = $('#original-question', el);
          $('#original-question input:checked', el).each(function(i) {
            var choice_div, choice_index, choice_index_span, ids, variable_div, variable_index, variable_index_span;
            ids = this.id.split('_');
            choice_index = ids[3];
            variable_index = ids[1] + "_" + ids[2];
            choice_index_span = $('.rank_index', el).filter(function() {
              return $(this).text() === choice_index;
            });
            choice_div = $(choice_index_span).parent();
            variable_index_span = $('.variable_index', el).filter(function() {
              return $(this).text() === variable_index;
            });
            variable_div = $(variable_index_span).parent();
            $(choice_div).children('.droppable-rank-variable-text').hide();
            $(choice_div).append($(variable_div));
            $(variable_div).css({
              'position': 'relative',
              'top': 0,
              'left': 0
            });
            return $(choice_div).data('dragged-item', variable_div);
          });
          $('.draggable-rank-variable-box', el).draggable({
            stack: "div",
            start: function(event, ui) {
              $(this).data('OrgPosition', $(this).position());
              return $(this).data('parent', $(this).parent());
            },
            stop: function(event, ui) {
              var relative_position;
              if ($(this).parent()[0] === $(this).data('parent')[0]) {
                $(this).css({
                  'position': 'absolute',
                  'top': $(this).data('OrgPosition').top,
                  'left': $(this).data('OrgPosition').left
                });
                relative_position = $(this).offset();
                $(this).css({
                  'position': 'relative'
                });
                return $(this).offset(relative_position);
              }
            }
          });
          $(".rank-variable-bin", el).droppable({
            accept: function(dropElem) {
              return $(dropElem).hasClass("draggable-rank-variable-box");
            },
            activeClass: "ui-state-hover",
            hoverClass: "ui-state-active",
            drop: function(event, ui) {
              var id, parent;
              parent = $(ui.draggable).parent();
              id = $('.variable_index', ui.draggable).text();
              if ($(parent).hasClass('droppable-rank-variable-box')) {
                $("input[name=" + id + "]", original).prop('checked', false).trigger('keyup');
                $(parent).data('dragged-item', '');
                $(this).append(ui.draggable);
                $(ui.draggable).css({
                  'position': 'relative',
                  'top': 0,
                  'left': 0
                });
                return $(parent).children('.droppable-rank-variable-text').show();
              }
            }
          });
          return $(".droppable-rank-variable-box", el).droppable({
            accept: function(dropElem) {
              return $(dropElem).hasClass("draggable-rank-variable-box");
            },
            activeClass: "ui-state-hover",
            hoverClass: "ui-state-active",
            drop: function(event, ui) {
              var drag_rank, parent, rank;
              parent = $(ui.draggable).parent();
              rank = $(this).find('.rank_index').text();
              drag_rank = $('.rank_index', parent).text();
              if ($(this).data('dragged-item') && $(this).data('dragged-item') !== '') {
                if ($(parent).hasClass('droppable-rank-variable-box')) {
                  $("input[value=" + rank + "]", original).prop('checked', false).trigger('change');
                  $("input#id_" + ($('.variable_index', $(this).data('dragged-item')).text()) + "_" + drag_rank).prop('checked', true).trigger('change');
                  parent.data('dragged-item', $(this).data('dragged-item'));
                  parent.children('.rank_index, .droppable-rank-variable-text').hide();
                  parent.append($(this).data('dragged-item'));
                  $(this).data('dragged-item').css({
                    'position': 'relative',
                    'top': 0,
                    'left': 0
                  });
                } else {
                  $("input#id_" + ($('.variable_index', $(this).data('dragged-item')).text()) + "_" + ($('.rank_index', this).text())).prop('checked', false).trigger('keyup');
                  $('.rank-variable-bin', el).append($(this).data('dragged-item'));
                }
              } else if ($(parent).hasClass('droppable-rank-variable-box')) {
                $(parent).data('dragged-item', '');
                $(parent).children('.droppable-rank-variable-text').show();
              }
              $("input[value=" + rank + "]", original).prop('checked', false).trigger('change');
              $("input#id_" + ($('.variable_index', ui.draggable).text()) + "_" + rank).prop('checked', true).trigger('change');
              $(this).children('.droppable-rank-variable-text').hide();
              $(this).append(ui.draggable);
              $(ui.draggable).css({
                'position': 'relative',
                'top': 0,
                'left': 0
              });
              return $(this).data('dragged-item', ui.draggable);
            }
          });
        });
      }
    });
    el.bind('initialize', function() {
      var delimiter;
      delimiter = '/~/';
      $('.signature').each(function(i, element) {
        var existingSig, existingbase30;
        $(element).jSignature({
          height: 200
        });
        existingSig = $(element).nextAll('input').first().val();
        existingbase30 = existingSig.split(delimiter)[0];
        if (existingbase30[0]) {
          return $(element).jSignature('setData', existingbase30);
        }
      });
      $('.signature').bind('change', function(e) {
        var base64, data, inputField, url;
        data = $(e.target).jSignature("getData", "base30");
        url = "data:" + data.join(",");
        base64 = $(e.target).jSignature("getData", "svgbase64")[1];
        inputField = $(e.target).nextAll('input').first();
        return inputField.val(url + delimiter + base64);
      });
      return $('.reset-signature').click(function(event) {
        $(event.target).parent().prevAll('.signature').first().jSignature('clear');
        return $(event.target).parent().prevAll('input').first().val('');
      });
    });
    el.bind('initialize', function() {
      $.each($(".slider_question"), function(i, el) {
        var initialValue, maximumValue, minimumValue, slideroptions, stepSize;
        $('input', $(el).parent()).hide();
        minimumValue = $('span.minimumValue', this).html();
        maximumValue = $('span.maximumValue', this).html();
        stepSize = $('span.stepSize', this).html();
        initialValue = $('input', $(this).parent()).val() || $('span.initialValue', this).html();
        if (minimumValue === 'undefined') {
          minimumValue = 1;
        }
        if (maximumValue === 'undefined') {
          maximumValue = 100;
        }
        if (stepSize === 'undefined') {
          stepSize = 1;
        }
        slideroptions = {
          min: parseFloat(minimumValue),
          max: parseFloat(maximumValue),
          step: parseFloat(stepSize),
          slide: function(event, ui) {
            $($('input', $(this).parent())[0]).val(ui.value).trigger('change');
            $('a', this).data('tooltip').text($($('input', $($(this).parent()).parent())[0]).val());
            return $('a', el).data('tooltip').position({
              my: 'center top',
              at: 'center bottom',
              of: $('a', el),
              offset: '0 -50'
            });
          },
          stop: function(event, ui) {
            return $('a', el).data('tooltip').position({
              my: 'center top',
              at: 'center bottom',
              of: $('a', el),
              offset: '0 -50'
            });
          },
          value: initialValue
        };
        return $(el).slider(slideroptions);
      });
      return chide.ui.Tooltip.init($('a.ui-slider-handle', '.slider_question'), {
        'focus': true,
        'offset': '0 -50'
      });
    });
    refreshCheckbox = function(el) {
      var boxes_not_checked, boxes_not_na;
      if (el.is('.na-choice')) {
        if (el.attr('checked')) {
          return el.closest('li').siblings().find(':checkbox').removeAttr('checked').end().find('input.other').val('').end();
        }
      } else if (el.is('.check-all')) {
        if (el.attr('checked')) {
          el.closest('li').siblings().find(':checkbox.na-choice').removeAttr('checked');
          return el.closest('li').siblings().find(':checkbox:not(.na-choice)').attr('checked', '');
        } else {
          return el.closest('li').siblings().find(':checkbox:not(.na-choice)').removeAttr('checked');
        }
      } else {
        boxes_not_na = el.closest('li').siblings().find(':checkbox:not(.na-choice):not(.check-all)');
        boxes_not_checked = el.closest('li').siblings().find(':checkbox[checked]:not(.na-choice):not(.check-all)');
        if (el.attr('checked')) {
          el.closest('li').siblings().find(':checkbox.na-choice').removeAttr('checked').end();
          if (boxes_not_na.size() === boxes_not_checked.size()) {
            return el.closest('li').siblings().find(':checkbox.check-all').attr('checked', '');
          }
        } else {
          return el.closest('li').siblings().find(':checkbox.check-all').removeAttr('checked');
        }
      }
    };
    el.delegate('.question:has(.na-choice) :checkbox,.question:has(.check-all) :checkbox', 'change', function(e) {
      return refreshCheckbox($(e.target));
    });
    el.delegate('input.other', 'keypress', function(e) {
      if (e.keyCode === 9) {
        return;
      }
      return refreshCheckbox($(e.target).closest('li').find(':checkbox, :radio').attr('checked', 'checked'));
    });
    el.delegate('td:has(:checkbox, :radio)', 'click', function(e) {
      if (e.target && $(e.target).is('td')) {
        return $(':checkbox, :radio', this).focus().click();
      }
    });
    el.delegate('input.date', 'focus', function(e) {
      $(this).datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: '-90:+20',
        dateFormat: 'yy/mm/dd'
      });
      return $(this).datepicker('show');
    });
    el.delegate('input.month-day', 'focus', function(e) {
      var maxDate, minDate;
      minDate = new _.date();
      minDate.setMonth(0);
      minDate.setDate(1);
      maxDate = new _.date();
      maxDate.setMonth(11);
      maxDate.setDate(31);
      $(this).datepicker({
        changeMonth: true,
        changeYear: false,
        minDate: minDate,
        maxDate: maxDate,
        dateFormat: 'mm/dd'
      });
      return $(this).datepicker('show');
    });
    return el.delegate('a.datetime-now', 'click', function(e) {
      var now;
      e.preventDefault();
      now = new _.date();
      $(this).closest('.question').find(':input[name$=_date]').val(now.format("yyyy/MM/dd"));
      return $(this).closest('.question').find(':input[name$=_time]').val(now.format("HH:mm:ss"));
    });
  };

  return Handler;

})();

ClientHandler = (function(superClass) {
  extend(ClientHandler, superClass);

  function ClientHandler() {
    return ClientHandler.__super__.constructor.apply(this, arguments);
  }

  ClientHandler.prototype.restartTimeout = void 0;

  ClientHandler.prototype.initializeContent = function(el, autorender) {
    this.el = el;
    _.bindAll(this, 'onFormSubmit', 'onLanguageChange', 'onBackClicked', 'restart', 'onAnyInputChanged', 'onPageLinkClicked');
    this.el.delegate('form.survey-form', 'submit', this.onFormSubmit);
    this.el.delegate('form.language-select', 'submit', this.onLanguageChange);
    this.el.delegate('input.back', 'click', this.onBackClicked);
    this.initializeBehaviors(this.el);
    this.currentPage = this.survey.pages[0];
    if ((autorender == null) || autorender) {
      this.renderPage(this.currentPage);
    }
    this.el.delegate(':input', 'change keyup', this.onAnyInputChanged);
    return this.el.delegate('a[data-goto-page]', 'click', this.onPageLinkClicked);
  };

  ClientHandler.prototype.onBackClicked = function(e) {
    var newPage;
    e.preventDefault();
    this.response.saveForm(this.el, this.currentPage);
    newPage = this.getPreviousPage(this.currentPage);
    if (newPage != null) {
      return this.renderPage(newPage);
    }
  };

  ClientHandler.prototype.onPageLinkClicked = function(e) {
    return this.renderPage(this.survey.loopedPages()[parseInt($(e.target).data('goto-page'), 10)]);
  };

  ClientHandler.prototype.onFormSubmit = function(e) {
    var newPage;
    e.preventDefault();
    this.response.saveForm(this.el, this.currentPage);
    if (!this.validate(this.currentPage)) {
      return;
    }
    newPage = this.getNextPage(this.currentPage);
    if ((newPage == null) || newPage === 'f') {
      this.response.completed = 1;
      this.response.save();
      return this.renderFinishPage();
    } else if (newPage === 't') {
      this.response.completed = 2;
      this.response.save();
      return this.renderTerminatePage();
    } else {
      return this.renderPage(newPage);
    }
  };

  ClientHandler.prototype.onLanguageChange = function(e) {
    e.preventDefault();
    this.response.saveForm(this.el, this.currentPage);
    trans.prototype.language = $('select[name=l]', e.target).val();
    return this.renderPage(this.currentPage);
  };

  ClientHandler.prototype.onAnyInputChanged = function(e) {
    this.response.saveForm(this.el, this.currentPage);
    this.updatePiping(this.el, this.currentPage);
    return this.currentPage.applyTargetRules(this, this.el);
  };

  ClientHandler.prototype.renderSurveyHeader = function(page) {
    var header, ref1;
    if (!this.progressBar && !this.options.get('disable_progress_bar')) {
      this.progressBar = $(this.progressBarTemplate({
        progress: this.getProgress(page)
      }));
    }
    return header = ClientHandler.__super__.renderSurveyHeader.call(this, page).find('.right').append((ref1 = this.progressBar) != null ? ref1 : '').end();
  };

  ClientHandler.prototype.renderPage = function(page) {
    var cont, el, myel;
    this.el.attr('data-enhance', 'false');
    this.el.empty().append(this.renderSurveyHeader(page));
    this.currentPage = page;
    el = ClientHandler.__super__.renderPage.call(this, page).appendTo(this.el);
    $(window).scrollTop(0);
    myel = this.el;
    cont = function() {
      myel.removeAttr('data-enhance');
      myel.trigger('create');
      return myel.trigger('initialize');
    };
    if (typeof Mobilizr !== "undefined" && Mobilizr !== null) {
      Mobilizr.reset();
      Mobilizr.auto((function(_this) {
        return function() {
          page.applyTargetRules(_this, myel);
          return cont();
        };
      })(this));
    } else {
      cont();
    }
    return $('#survey .progress-bar').find('.bar').width('100%').css('left', (-100 + this.getProgress(page)) + "%").end().find('.progress').text((this.getProgress(page)) + "%").end();
  };

  ClientHandler.prototype.restart = function() {
    this.restartTimeout = void 0;
    this.response = new LocalResponse(this.survey);
    return this.renderPage(this.survey.pages[0]);
  };

  ClientHandler.prototype.renderFinishPage = function() {
    ClientHandler.__super__.renderFinishPage.call(this).appendTo(this.el.empty().append(this.renderSurveyHeader('f')));
    $('#survey .progress-bar').find('.bar').width('100%').css('left', "0").end().find('.progress').text((this.getProgress('f')) + "%").end();
    return this.surveyFinished();
  };

  ClientHandler.prototype.renderTerminatePage = function() {
    ClientHandler.__super__.renderTerminatePage.call(this).appendTo(this.el.empty().append(this.renderSurveyHeader('t')));
    return this.surveyFinished();
  };

  ClientHandler.prototype.surveyFinished = function() {
    var e;
    e = $.Event('finished');
    $(this).trigger(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    this.restartTimeout = setTimeout(this.restart, 4000);
    return this.currentPage = null;
  };

  return ClientHandler;

})(Handler);

_.extend(exports, {
  Page: Page
});


/***/ }),
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1221);
__webpack_require__(1423);
__webpack_require__(1451);
__webpack_require__(1453);
__webpack_require__(1455);
__webpack_require__(1456);
__webpack_require__(1458);
__webpack_require__(1459);
__webpack_require__(1460);
__webpack_require__(1461);
__webpack_require__(1462);
__webpack_require__(1463);
__webpack_require__(1465);
__webpack_require__(1467);
__webpack_require__(1469);
__webpack_require__(1471);
__webpack_require__(1473);
__webpack_require__(1475);
__webpack_require__(1477);
__webpack_require__(1479);
__webpack_require__(1481);
__webpack_require__(1483);
__webpack_require__(1485);
__webpack_require__(1487);
__webpack_require__(1489);
__webpack_require__(1491);
__webpack_require__(1493);
__webpack_require__(1495);
__webpack_require__(1497);
__webpack_require__(1499);
__webpack_require__(1501);
__webpack_require__(1502);
__webpack_require__(1503);
__webpack_require__(1504);
__webpack_require__(1505);
__webpack_require__(1506);
__webpack_require__(895);
__webpack_require__(191);
__webpack_require__(896);
__webpack_require__(1507);
__webpack_require__(1508);
__webpack_require__(1510);
module.exports = __webpack_require__(1511);


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1222);

__webpack_require__(1419);

__webpack_require__(1420);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1223);
__webpack_require__(1226);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(1238);
__webpack_require__(1239);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(1288);
__webpack_require__(1289);
__webpack_require__(1290);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1303);
__webpack_require__(1304);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1309);
__webpack_require__(1310);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1314);
__webpack_require__(1315);
__webpack_require__(1316);
__webpack_require__(1317);
__webpack_require__(1318);
__webpack_require__(1319);
__webpack_require__(1320);
__webpack_require__(1321);
__webpack_require__(1322);
__webpack_require__(1323);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1326);
__webpack_require__(430);
__webpack_require__(1327);
__webpack_require__(876);
__webpack_require__(1328);
__webpack_require__(877);
__webpack_require__(1329);
__webpack_require__(1330);
__webpack_require__(1331);
__webpack_require__(1332);
__webpack_require__(1333);
__webpack_require__(880);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(1334);
__webpack_require__(1335);
__webpack_require__(1336);
__webpack_require__(1337);
__webpack_require__(1338);
__webpack_require__(1339);
__webpack_require__(1340);
__webpack_require__(1341);
__webpack_require__(1342);
__webpack_require__(1343);
__webpack_require__(1344);
__webpack_require__(1345);
__webpack_require__(1346);
__webpack_require__(1347);
__webpack_require__(1348);
__webpack_require__(1349);
__webpack_require__(1350);
__webpack_require__(1351);
__webpack_require__(1352);
__webpack_require__(1353);
__webpack_require__(1354);
__webpack_require__(1355);
__webpack_require__(1356);
__webpack_require__(1357);
__webpack_require__(1358);
__webpack_require__(1359);
__webpack_require__(1360);
__webpack_require__(1361);
__webpack_require__(1362);
__webpack_require__(1363);
__webpack_require__(1364);
__webpack_require__(1365);
__webpack_require__(1366);
__webpack_require__(1367);
__webpack_require__(1368);
__webpack_require__(1369);
__webpack_require__(1370);
__webpack_require__(1371);
__webpack_require__(1372);
__webpack_require__(1373);
__webpack_require__(1374);
__webpack_require__(1375);
__webpack_require__(1376);
__webpack_require__(1377);
__webpack_require__(1378);
__webpack_require__(1379);
__webpack_require__(1380);
__webpack_require__(1381);
__webpack_require__(1382);
__webpack_require__(1383);
__webpack_require__(1384);
__webpack_require__(1385);
__webpack_require__(1386);
__webpack_require__(1387);
__webpack_require__(1388);
__webpack_require__(1389);
__webpack_require__(1390);
__webpack_require__(1391);
__webpack_require__(1392);
__webpack_require__(1393);
__webpack_require__(1394);
__webpack_require__(1395);
__webpack_require__(1396);
__webpack_require__(1397);
__webpack_require__(1398);
__webpack_require__(1399);
__webpack_require__(1400);
__webpack_require__(1401);
__webpack_require__(1402);
__webpack_require__(1403);
__webpack_require__(1404);
__webpack_require__(1405);
__webpack_require__(1406);
__webpack_require__(1407);
__webpack_require__(1408);
__webpack_require__(1409);
__webpack_require__(1410);
__webpack_require__(1411);
__webpack_require__(1412);
__webpack_require__(1413);
__webpack_require__(1414);
__webpack_require__(1415);
__webpack_require__(1416);
__webpack_require__(1417);
__webpack_require__(1418);
module.exports = __webpack_require__(88);


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(66);
var META = __webpack_require__(135).KEY;
var $fails = __webpack_require__(21);
var shared = __webpack_require__(232);
var setToStringTag = __webpack_require__(187);
var uid = __webpack_require__(159);
var wks = __webpack_require__(30);
var wksExt = __webpack_require__(858);
var wksDefine = __webpack_require__(411);
var enumKeys = __webpack_require__(1225);
var isArray = __webpack_require__(287);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(24);
var toObject = __webpack_require__(39);
var toIObject = __webpack_require__(76);
var toPrimitive = __webpack_require__(98);
var createDesc = __webpack_require__(158);
var _create = __webpack_require__(162);
var gOPNExt = __webpack_require__(861);
var $GOPD = __webpack_require__(77);
var $GOPS = __webpack_require__(286);
var $DP = __webpack_require__(37);
var $keys = __webpack_require__(160);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(163).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(234).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(134)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(65)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(232)('native-function-to-string', Function.toString);


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(160);
var gOPS = __webpack_require__(286);
var pIE = __webpack_require__(234);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(162) });


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(37).f });


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(860) });


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(76);
var $getOwnPropertyDescriptor = __webpack_require__(77).f;

__webpack_require__(100)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(39);
var $getPrototypeOf = __webpack_require__(78);

__webpack_require__(100)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(39);
var $keys = __webpack_require__(160);

__webpack_require__(100)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(100)('getOwnPropertyNames', function () {
  return __webpack_require__(861).f;
});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(24);
var meta = __webpack_require__(135).onFreeze;

__webpack_require__(100)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(24);
var meta = __webpack_require__(135).onFreeze;

__webpack_require__(100)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(24);
var meta = __webpack_require__(135).onFreeze;

__webpack_require__(100)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(24);

__webpack_require__(100)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(24);

__webpack_require__(100)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(24);

__webpack_require__(100)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(862) });


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(863) });


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(415).set });


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(188);
var test = {};
test[__webpack_require__(30)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(66)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(864) });


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(37).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(33) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(78);
var HAS_INSTANCE = __webpack_require__(30)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(37).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(866);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(867);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(18);
var has = __webpack_require__(75);
var cof = __webpack_require__(90);
var inheritIfRequired = __webpack_require__(417);
var toPrimitive = __webpack_require__(98);
var fails = __webpack_require__(21);
var gOPN = __webpack_require__(163).f;
var gOPD = __webpack_require__(77).f;
var dP = __webpack_require__(37).f;
var $trim = __webpack_require__(189).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(162)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(33) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(66)(global, NUMBER, $Number);
}


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(91);
var aNumberValue = __webpack_require__(868);
var repeat = __webpack_require__(418);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(21)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(21);
var aNumberValue = __webpack_require__(868);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(18).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(869) });


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(869);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(867);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(866);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(870);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(419);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(420);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(871) });


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(21)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(870) });


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(419) });


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(420);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(21)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(420);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(161);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(76);
var toLength = __webpack_require__(31);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(189)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(288)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(421)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(288)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(31);
var context = __webpack_require__(423);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(424)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(423);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(424)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(418)
});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(31);
var context = __webpack_require__(423);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(424)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(67)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(67)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(67)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(67)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(67)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(67)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(67)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(67)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(67)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(67)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(67)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(67)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(67)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(98);

$export($export.P + $export.F * __webpack_require__(21)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(1302);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(21);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(66)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(30)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(65)(proto, TO_PRIMITIVE, __webpack_require__(1305));


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(98);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(287) });


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(89);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var call = __webpack_require__(872);
var isArrayIter = __webpack_require__(425);
var toLength = __webpack_require__(31);
var createProperty = __webpack_require__(426);
var getIterFn = __webpack_require__(427);

$export($export.S + $export.F * !__webpack_require__(290)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(426);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(21)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(76);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(233) != Object || !__webpack_require__(92)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(414);
var cof = __webpack_require__(90);
var toAbsoluteIndex = __webpack_require__(161);
var toLength = __webpack_require__(31);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(21)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(52);
var toObject = __webpack_require__(39);
var fails = __webpack_require__(21);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(92)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(101)(0);
var STRICT = __webpack_require__(92)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(24);
var isArray = __webpack_require__(287);
var SPECIES = __webpack_require__(30)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(101)(1);

$export($export.P + $export.F * !__webpack_require__(92)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(101)(2);

$export($export.P + $export.F * !__webpack_require__(92)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(101)(3);

$export($export.P + $export.F * !__webpack_require__(92)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(101)(4);

$export($export.P + $export.F * !__webpack_require__(92)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(873);

$export($export.P + $export.F * !__webpack_require__(92)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(873);

$export($export.P + $export.F * !__webpack_require__(92)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(285)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(92)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(76);
var toInteger = __webpack_require__(91);
var toLength = __webpack_require__(31);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(92)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(874) });

__webpack_require__(136)('copyWithin');


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(429) });

__webpack_require__(136)('fill');


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(101)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(136)(KEY);


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(101)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(136)(KEY);


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(164)('Array');


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var inheritIfRequired = __webpack_require__(417);
var dP = __webpack_require__(37).f;
var gOPN = __webpack_require__(163).f;
var isRegExp = __webpack_require__(289);
var $flags = __webpack_require__(235);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(33) && (!CORRECT_NEW || __webpack_require__(21)(function () {
  re2[__webpack_require__(30)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(66)(global, 'RegExp', $RegExp);
}

__webpack_require__(164)('RegExp');


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(877);
var anObject = __webpack_require__(13);
var $flags = __webpack_require__(235);
var DESCRIPTORS = __webpack_require__(33);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(66)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(21)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toLength = __webpack_require__(31);
var advanceStringIndex = __webpack_require__(432);
var regExpExec = __webpack_require__(291);

// @@match logic
__webpack_require__(292)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(31);
var toInteger = __webpack_require__(91);
var advanceStringIndex = __webpack_require__(432);
var regExpExec = __webpack_require__(291);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(292)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var sameValue = __webpack_require__(863);
var regExpExec = __webpack_require__(291);

// @@search logic
__webpack_require__(292)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(289);
var anObject = __webpack_require__(13);
var speciesConstructor = __webpack_require__(236);
var advanceStringIndex = __webpack_require__(432);
var toLength = __webpack_require__(31);
var callRegExpExec = __webpack_require__(291);
var regexpExec = __webpack_require__(431);
var fails = __webpack_require__(21);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(292)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(134);
var global = __webpack_require__(18);
var ctx = __webpack_require__(89);
var classof = __webpack_require__(188);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(24);
var aFunction = __webpack_require__(52);
var anInstance = __webpack_require__(165);
var forOf = __webpack_require__(166);
var speciesConstructor = __webpack_require__(236);
var task = __webpack_require__(433).set;
var microtask = __webpack_require__(434)();
var newPromiseCapabilityModule = __webpack_require__(435);
var perform = __webpack_require__(878);
var userAgent = __webpack_require__(293);
var promiseResolve = __webpack_require__(879);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(30)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(167)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(187)($Promise, PROMISE);
__webpack_require__(164)(PROMISE);
Wrapper = __webpack_require__(88)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(290)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(884);
var validate = __webpack_require__(168);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(294)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(295);
var buffer = __webpack_require__(436);
var anObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(161);
var toLength = __webpack_require__(31);
var isObject = __webpack_require__(24);
var ArrayBuffer = __webpack_require__(18).ArrayBuffer;
var speciesConstructor = __webpack_require__(236);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(21)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(164)(ARRAY_BUFFER);


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(295).ABV, {
  DataView: __webpack_require__(436).DataView
});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(13);
var rApply = (__webpack_require__(18).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(21)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(162);
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(24);
var fails = __webpack_require__(21);
var bind = __webpack_require__(864);
var rConstruct = (__webpack_require__(18).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(37);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(98);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(21)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(77).f;
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(422)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(77);
var getPrototypeOf = __webpack_require__(78);
var has = __webpack_require__(75);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(24);
var anObject = __webpack_require__(13);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(77);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(78);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(886) });


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(13);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(37);
var gOPD = __webpack_require__(77);
var getPrototypeOf = __webpack_require__(78);
var has = __webpack_require__(75);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(158);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(24);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(415);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(285)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(136)('includes');


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(887);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(31);
var aFunction = __webpack_require__(52);
var arraySpeciesCreate = __webpack_require__(428);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(136)('flatMap');


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(887);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(31);
var toInteger = __webpack_require__(91);
var arraySpeciesCreate = __webpack_require__(428);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(136)('flatten');


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(2);
var $at = __webpack_require__(288)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(888);
var userAgent = __webpack_require__(293);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(888);
var userAgent = __webpack_require__(293);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(189)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(189)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(2);
var defined = __webpack_require__(99);
var toLength = __webpack_require__(31);
var isRegExp = __webpack_require__(289);
var getFlags = __webpack_require__(235);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(422)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(411)('asyncIterator');


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(411)('observable');


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(886);
var toIObject = __webpack_require__(76);
var gOPD = __webpack_require__(77);
var createProperty = __webpack_require__(426);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(889)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(889)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var aFunction = __webpack_require__(52);
var $defineProperty = __webpack_require__(37);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(33) && $export($export.P + __webpack_require__(296), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var aFunction = __webpack_require__(52);
var $defineProperty = __webpack_require__(37);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(33) && $export($export.P + __webpack_require__(296), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(98);
var getPrototypeOf = __webpack_require__(78);
var getOwnPropertyDescriptor = __webpack_require__(77).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(296), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(98);
var getPrototypeOf = __webpack_require__(78);
var getOwnPropertyDescriptor = __webpack_require__(77).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(296), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(890)('Map') });


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(890)('Set') });


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(297)('Map');


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(297)('Set');


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(297)('WeakMap');


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(297)('WeakSet');


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(298)('Map');


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(298)('Set');


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(298)('WeakMap');


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(298)('WeakSet');


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.G, { global: __webpack_require__(18) });


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.S, 'System', { global: __webpack_require__(18) });


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(2);
var cof = __webpack_require__(90);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var scale = __webpack_require__(892);
var fround = __webpack_require__(871);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { scale: __webpack_require__(892) });


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(2);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(88);
var global = __webpack_require__(18);
var speciesConstructor = __webpack_require__(236);
var promiseResolve = __webpack_require__(879);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(435);
var perform = __webpack_require__(878);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(78);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(882);
var from = __webpack_require__(891);
var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(78);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(78);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(113);
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(52);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(2);
var microtask = __webpack_require__(434)();
var process = __webpack_require__(18).process;
var isNode = __webpack_require__(90)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(2);
var global = __webpack_require__(18);
var core = __webpack_require__(88);
var microtask = __webpack_require__(434)();
var OBSERVABLE = __webpack_require__(30)('observable');
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(13);
var anInstance = __webpack_require__(165);
var redefineAll = __webpack_require__(167);
var hide = __webpack_require__(65);
var forOf = __webpack_require__(166);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(164)('Observable');


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(18);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(293);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(433);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(430);
var getKeys = __webpack_require__(160);
var redefine = __webpack_require__(66);
var global = __webpack_require__(18);
var hide = __webpack_require__(65);
var Iterators = __webpack_require__(190);
var wks = __webpack_require__(30);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1419 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1421);
module.exports = __webpack_require__(88).RegExp.escape;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(2);
var $re = __webpack_require__(1422)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1424);
__webpack_require__(1425);
__webpack_require__(1426);
__webpack_require__(1427);
__webpack_require__(1428);
__webpack_require__(1429);
__webpack_require__(1430);
__webpack_require__(1431);
__webpack_require__(1432);

__webpack_require__(1433);
__webpack_require__(1434);

__webpack_require__(1435);
__webpack_require__(1436);
__webpack_require__(1438);
__webpack_require__(1441);
__webpack_require__(1444);
__webpack_require__(1449);
__webpack_require__(1450);


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Form Plugin
 * version: 3.51.0-2014.06.20
 * Requires jQuery v1.5 or later
 * Copyright (c) 2014 M. Alsup
 * Examples and documentation at: http://malsup.com/jquery/form/
 * Project repository: https://github.com/malsup/form
 * Dual licensed under the MIT and GPL licenses.
 * https://github.com/malsup/form#copyright-and-license
 */
/*global ActiveXObject */

// AMD support
(function (factory) {
    "use strict";
    if (true) {
        // using AMD; register as anon module
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(137)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        // no AMD; invoke directly
        factory( (typeof(jQuery) != 'undefined') ? jQuery : window.Zepto );
    }
}

(function($) {
"use strict";

/*
    Usage Note:
    -----------
    Do not use both ajaxSubmit and ajaxForm on the same form.  These
    functions are mutually exclusive.  Use ajaxSubmit if you want
    to bind your own submit handler to the form.  For example,

    $(document).ready(function() {
        $('#myForm').on('submit', function(e) {
            e.preventDefault(); // <-- important
            $(this).ajaxSubmit({
                target: '#output'
            });
        });
    });

    Use ajaxForm when you want the plugin to manage all the event binding
    for you.  For example,

    $(document).ready(function() {
        $('#myForm').ajaxForm({
            target: '#output'
        });
    });

    You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
    form does not have to exist when you invoke ajaxForm:

    $('#myForm').ajaxForm({
        delegation: true,
        target: '#output'
    });

    When using ajaxForm, the ajaxSubmit function will be invoked for you
    at the appropriate time.
*/

/**
 * Feature detection
 */
var feature = {};
feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
feature.formdata = window.FormData !== undefined;

var hasProp = !!$.fn.prop;

// attr2 uses prop when it can but checks the return type for
// an expected string.  this accounts for the case where a form 
// contains inputs with names like "action" or "method"; in those
// cases "prop" returns the element
$.fn.attr2 = function() {
    if ( ! hasProp ) {
        return this.attr.apply(this, arguments);
    }
    var val = this.prop.apply(this, arguments);
    if ( ( val && val.jquery ) || typeof val === 'string' ) {
        return val;
    }
    return this.attr.apply(this, arguments);
};

/**
 * ajaxSubmit() provides a mechanism for immediately submitting
 * an HTML form using AJAX.
 */
$.fn.ajaxSubmit = function(options) {
    /*jshint scripturl:true */

    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
    if (!this.length) {
        log('ajaxSubmit: skipping submit process - no element selected');
        return this;
    }

    var method, action, url, $form = this;

    if (typeof options == 'function') {
        options = { success: options };
    }
    else if ( options === undefined ) {
        options = {};
    }

    method = options.type || this.attr2('method');
    action = options.url  || this.attr2('action');

    url = (typeof action === 'string') ? $.trim(action) : '';
    url = url || window.location.href || '';
    if (url) {
        // clean url (don't include hash vaue)
        url = (url.match(/^([^#]+)/)||[])[1];
    }

    options = $.extend(true, {
        url:  url,
        success: $.ajaxSettings.success,
        type: method || $.ajaxSettings.type,
        iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
    }, options);

    // hook for manipulating the form data before it is extracted;
    // convenient for use with rich editors like tinyMCE or FCKEditor
    var veto = {};
    this.trigger('form-pre-serialize', [this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
        return this;
    }

    // provide opportunity to alter form data before it is serialized
    if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSerialize callback');
        return this;
    }

    var traditional = options.traditional;
    if ( traditional === undefined ) {
        traditional = $.ajaxSettings.traditional;
    }

    var elements = [];
    var qx, a = this.formToArray(options.semantic, elements);
    if (options.data) {
        options.extraData = options.data;
        qx = $.param(options.data, traditional);
    }

    // give pre-submit callback an opportunity to abort the submit
    if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
        log('ajaxSubmit: submit aborted via beforeSubmit callback');
        return this;
    }

    // fire vetoable 'validate' event
    this.trigger('form-submit-validate', [a, this, options, veto]);
    if (veto.veto) {
        log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
        return this;
    }

    var q = $.param(a, traditional);
    if (qx) {
        q = ( q ? (q + '&' + qx) : qx );
    }
    if (options.type.toUpperCase() == 'GET') {
        options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
        options.data = null;  // data is null for 'get'
    }
    else {
        options.data = q; // data is the query string for 'post'
    }

    var callbacks = [];
    if (options.resetForm) {
        callbacks.push(function() { $form.resetForm(); });
    }
    if (options.clearForm) {
        callbacks.push(function() { $form.clearForm(options.includeHidden); });
    }

    // perform a load on the target only if dataType is not provided
    if (!options.dataType && options.target) {
        var oldSuccess = options.success || function(){};
        callbacks.push(function(data) {
            var fn = options.replaceTarget ? 'replaceWith' : 'html';
            $(options.target)[fn](data).each(oldSuccess, arguments);
        });
    }
    else if (options.success) {
        callbacks.push(options.success);
    }

    options.success = function(data, status, xhr) { // jQuery 1.4+ passes xhr as 3rd arg
        var context = options.context || this ;    // jQuery 1.4+ supports scope context
        for (var i=0, max=callbacks.length; i < max; i++) {
            callbacks[i].apply(context, [data, status, xhr || $form, $form]);
        }
    };

    if (options.error) {
        var oldError = options.error;
        options.error = function(xhr, status, error) {
            var context = options.context || this;
            oldError.apply(context, [xhr, status, error, $form]);
        };
    }

     if (options.complete) {
        var oldComplete = options.complete;
        options.complete = function(xhr, status) {
            var context = options.context || this;
            oldComplete.apply(context, [xhr, status, $form]);
        };
    }

    // are there files to upload?

    // [value] (issue #113), also see comment:
    // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
    var fileInputs = $('input[type=file]:enabled', this).filter(function() { return $(this).val() !== ''; });

    var hasFileInputs = fileInputs.length > 0;
    var mp = 'multipart/form-data';
    var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);

    var fileAPI = feature.fileapi && feature.formdata;
    log("fileAPI :" + fileAPI);
    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;

    var jqxhr;

    // options.iframe allows user to force iframe mode
    // 06-NOV-09: now defaulting to iframe mode if file input is detected
    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
        // hack to fix Safari hang (thanks to Tim Molendijk for this)
        // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
        if (options.closeKeepAlive) {
            $.get(options.closeKeepAlive, function() {
                jqxhr = fileUploadIframe(a);
            });
        }
        else {
            jqxhr = fileUploadIframe(a);
        }
    }
    else if ((hasFileInputs || multipart) && fileAPI) {
        jqxhr = fileUploadXhr(a);
    }
    else {
        jqxhr = $.ajax(options);
    }

    $form.removeData('jqxhr').data('jqxhr', jqxhr);

    // clear element array
    for (var k=0; k < elements.length; k++) {
        elements[k] = null;
    }

    // fire 'notify' event
    this.trigger('form-submit-notify', [this, options]);
    return this;

    // utility fn for deep serialization
    function deepSerialize(extraData){
        var serialized = $.param(extraData, options.traditional).split('&');
        var len = serialized.length;
        var result = [];
        var i, part;
        for (i=0; i < len; i++) {
            // #252; undo param space replacement
            serialized[i] = serialized[i].replace(/\+/g,' ');
            part = serialized[i].split('=');
            // #278; use array instead of object storage, favoring array serializations
            result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
        }
        return result;
    }

     // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
    function fileUploadXhr(a) {
        var formdata = new FormData();

        for (var i=0; i < a.length; i++) {
            formdata.append(a[i].name, a[i].value);
        }

        if (options.extraData) {
            var serializedData = deepSerialize(options.extraData);
            for (i=0; i < serializedData.length; i++) {
                if (serializedData[i]) {
                    formdata.append(serializedData[i][0], serializedData[i][1]);
                }
            }
        }

        options.data = null;

        var s = $.extend(true, {}, $.ajaxSettings, options, {
            contentType: false,
            processData: false,
            cache: false,
            type: method || 'POST'
        });

        if (options.uploadProgress) {
            // workaround because jqXHR does not expose upload property
            s.xhr = function() {
                var xhr = $.ajaxSettings.xhr();
                if (xhr.upload) {
                    xhr.upload.addEventListener('progress', function(event) {
                        var percent = 0;
                        var position = event.loaded || event.position; /*event.position is deprecated*/
                        var total = event.total;
                        if (event.lengthComputable) {
                            percent = Math.ceil(position / total * 100);
                        }
                        options.uploadProgress(event, position, total, percent);
                    }, false);
                }
                return xhr;
            };
        }

        s.data = null;
        var beforeSend = s.beforeSend;
        s.beforeSend = function(xhr, o) {
            //Send FormData() provided by user
            if (options.formData) {
                o.data = options.formData;
            }
            else {
                o.data = formdata;
            }
            if(beforeSend) {
                beforeSend.call(this, xhr, o);
            }
        };
        return $.ajax(s);
    }

    // private function for handling file uploads (hat tip to YAHOO!)
    function fileUploadIframe(a) {
        var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
        var deferred = $.Deferred();

        // #341
        deferred.abort = function(status) {
            xhr.abort(status);
        };

        if (a) {
            // ensure that every serialized input is still enabled
            for (i=0; i < elements.length; i++) {
                el = $(elements[i]);
                if ( hasProp ) {
                    el.prop('disabled', false);
                }
                else {
                    el.removeAttr('disabled');
                }
            }
        }

        s = $.extend(true, {}, $.ajaxSettings, options);
        s.context = s.context || s;
        id = 'jqFormIO' + (new Date().getTime());
        if (s.iframeTarget) {
            $io = $(s.iframeTarget);
            n = $io.attr2('name');
            if (!n) {
                $io.attr2('name', id);
            }
            else {
                id = n;
            }
        }
        else {
            $io = $('<iframe name="' + id + '" src="'+ s.iframeSrc +'" />');
            $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
        }
        io = $io[0];


        xhr = { // mock object
            aborted: 0,
            responseText: null,
            responseXML: null,
            status: 0,
            statusText: 'n/a',
            getAllResponseHeaders: function() {},
            getResponseHeader: function() {},
            setRequestHeader: function() {},
            abort: function(status) {
                var e = (status === 'timeout' ? 'timeout' : 'aborted');
                log('aborting upload... ' + e);
                this.aborted = 1;

                try { // #214, #257
                    if (io.contentWindow.document.execCommand) {
                        io.contentWindow.document.execCommand('Stop');
                    }
                }
                catch(ignore) {}

                $io.attr('src', s.iframeSrc); // abort op in progress
                xhr.error = e;
                if (s.error) {
                    s.error.call(s.context, xhr, e, status);
                }
                if (g) {
                    $.event.trigger("ajaxError", [xhr, s, e]);
                }
                if (s.complete) {
                    s.complete.call(s.context, xhr, e);
                }
            }
        };

        g = s.global;
        // trigger ajax global events so that activity/block indicators work like normal
        if (g && 0 === $.active++) {
            $.event.trigger("ajaxStart");
        }
        if (g) {
            $.event.trigger("ajaxSend", [xhr, s]);
        }

        if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
            if (s.global) {
                $.active--;
            }
            deferred.reject();
            return deferred;
        }
        if (xhr.aborted) {
            deferred.reject();
            return deferred;
        }

        // add submitting element to data if we know it
        sub = form.clk;
        if (sub) {
            n = sub.name;
            if (n && !sub.disabled) {
                s.extraData = s.extraData || {};
                s.extraData[n] = sub.value;
                if (sub.type == "image") {
                    s.extraData[n+'.x'] = form.clk_x;
                    s.extraData[n+'.y'] = form.clk_y;
                }
            }
        }

        var CLIENT_TIMEOUT_ABORT = 1;
        var SERVER_ABORT = 2;
                
        function getDoc(frame) {
            /* it looks like contentWindow or contentDocument do not
             * carry the protocol property in ie8, when running under ssl
             * frame.document is the only valid response document, since
             * the protocol is know but not on the other two objects. strange?
             * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
             */
            
            var doc = null;
            
            // IE8 cascading access check
            try {
                if (frame.contentWindow) {
                    doc = frame.contentWindow.document;
                }
            } catch(err) {
                // IE8 access denied under ssl & missing protocol
                log('cannot get iframe.contentWindow document: ' + err);
            }

            if (doc) { // successful getting content
                return doc;
            }

            try { // simply checking may throw in ie8 under ssl or mismatched protocol
                doc = frame.contentDocument ? frame.contentDocument : frame.document;
            } catch(err) {
                // last attempt
                log('cannot get iframe.contentDocument: ' + err);
                doc = frame.document;
            }
            return doc;
        }

        // Rails CSRF hack (thanks to Yvan Barthelemy)
        var csrf_token = $('meta[name=csrf-token]').attr('content');
        var csrf_param = $('meta[name=csrf-param]').attr('content');
        if (csrf_param && csrf_token) {
            s.extraData = s.extraData || {};
            s.extraData[csrf_param] = csrf_token;
        }

        // take a breath so that pending repaints get some cpu time before the upload starts
        function doSubmit() {
            // make sure form attrs are set
            var t = $form.attr2('target'), 
                a = $form.attr2('action'), 
                mp = 'multipart/form-data',
                et = $form.attr('enctype') || $form.attr('encoding') || mp;

            // update form attrs in IE friendly way
            form.setAttribute('target',id);
            if (!method || /post/i.test(method) ) {
                form.setAttribute('method', 'POST');
            }
            if (a != s.url) {
                form.setAttribute('action', s.url);
            }

            // ie borks in some cases when setting encoding
            if (! s.skipEncodingOverride && (!method || /post/i.test(method))) {
                $form.attr({
                    encoding: 'multipart/form-data',
                    enctype:  'multipart/form-data'
                });
            }

            // support timout
            if (s.timeout) {
                timeoutHandle = setTimeout(function() { timedOut = true; cb(CLIENT_TIMEOUT_ABORT); }, s.timeout);
            }

            // look for server aborts
            function checkState() {
                try {
                    var state = getDoc(io).readyState;
                    log('state = ' + state);
                    if (state && state.toLowerCase() == 'uninitialized') {
                        setTimeout(checkState,50);
                    }
                }
                catch(e) {
                    log('Server abort: ' , e, ' (', e.name, ')');
                    cb(SERVER_ABORT);
                    if (timeoutHandle) {
                        clearTimeout(timeoutHandle);
                    }
                    timeoutHandle = undefined;
                }
            }

            // add "extra" data to form if provided in options
            var extraInputs = [];
            try {
                if (s.extraData) {
                    for (var n in s.extraData) {
                        if (s.extraData.hasOwnProperty(n)) {
                           // if using the $.param format that allows for multiple values with the same name
                           if($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
                               extraInputs.push(
                               $('<input type="hidden" name="'+s.extraData[n].name+'">').val(s.extraData[n].value)
                                   .appendTo(form)[0]);
                           } else {
                               extraInputs.push(
                               $('<input type="hidden" name="'+n+'">').val(s.extraData[n])
                                   .appendTo(form)[0]);
                           }
                        }
                    }
                }

                if (!s.iframeTarget) {
                    // add iframe to doc and submit the form
                    $io.appendTo('body');
                }
                if (io.attachEvent) {
                    io.attachEvent('onload', cb);
                }
                else {
                    io.addEventListener('load', cb, false);
                }
                setTimeout(checkState,15);

                try {
                    form.submit();
                } catch(err) {
                    // just in case form has element with name/id of 'submit'
                    var submitFn = document.createElement('form').submit;
                    submitFn.apply(form);
                }
            }
            finally {
                // reset attrs and remove "extra" input elements
                form.setAttribute('action',a);
                form.setAttribute('enctype', et); // #380
                if(t) {
                    form.setAttribute('target', t);
                } else {
                    $form.removeAttr('target');
                }
                $(extraInputs).remove();
            }
        }

        if (s.forceSync) {
            doSubmit();
        }
        else {
            setTimeout(doSubmit, 10); // this lets dom updates render
        }

        var data, doc, domCheckCount = 50, callbackProcessed;

        function cb(e) {
            if (xhr.aborted || callbackProcessed) {
                return;
            }
            
            doc = getDoc(io);
            if(!doc) {
                log('cannot access response document');
                e = SERVER_ABORT;
            }
            if (e === CLIENT_TIMEOUT_ABORT && xhr) {
                xhr.abort('timeout');
                deferred.reject(xhr, 'timeout');
                return;
            }
            else if (e == SERVER_ABORT && xhr) {
                xhr.abort('server abort');
                deferred.reject(xhr, 'error', 'server abort');
                return;
            }

            if (!doc || doc.location.href == s.iframeSrc) {
                // response not received yet
                if (!timedOut) {
                    return;
                }
            }
            if (io.detachEvent) {
                io.detachEvent('onload', cb);
            }
            else {
                io.removeEventListener('load', cb, false);
            }

            var status = 'success', errMsg;
            try {
                if (timedOut) {
                    throw 'timeout';
                }

                var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
                log('isXml='+isXml);
                if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
                    if (--domCheckCount) {
                        // in some browsers (Opera) the iframe DOM is not always traversable when
                        // the onload callback fires, so we loop a bit to accommodate
                        log('requeing onLoad callback, DOM not available');
                        setTimeout(cb, 250);
                        return;
                    }
                    // let this fall through because server response could be an empty document
                    //log('Could not access iframe DOM after mutiple tries.');
                    //throw 'DOMException: not available';
                }

                //log('response detected');
                var docRoot = doc.body ? doc.body : doc.documentElement;
                xhr.responseText = docRoot ? docRoot.innerHTML : null;
                xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
                if (isXml) {
                    s.dataType = 'xml';
                }
                xhr.getResponseHeader = function(header){
                    var headers = {'content-type': s.dataType};
                    return headers[header.toLowerCase()];
                };
                // support for XHR 'status' & 'statusText' emulation :
                if (docRoot) {
                    xhr.status = Number( docRoot.getAttribute('status') ) || xhr.status;
                    xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
                }

                var dt = (s.dataType || '').toLowerCase();
                var scr = /(json|script|text)/.test(dt);
                if (scr || s.textarea) {
                    // see if user embedded response in textarea
                    var ta = doc.getElementsByTagName('textarea')[0];
                    if (ta) {
                        xhr.responseText = ta.value;
                        // support for XHR 'status' & 'statusText' emulation :
                        xhr.status = Number( ta.getAttribute('status') ) || xhr.status;
                        xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
                    }
                    else if (scr) {
                        // account for browsers injecting pre around json response
                        var pre = doc.getElementsByTagName('pre')[0];
                        var b = doc.getElementsByTagName('body')[0];
                        if (pre) {
                            xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
                        }
                        else if (b) {
                            xhr.responseText = b.textContent ? b.textContent : b.innerText;
                        }
                    }
                }
                else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
                    xhr.responseXML = toXml(xhr.responseText);
                }

                try {
                    data = httpData(xhr, dt, s);
                }
                catch (err) {
                    status = 'parsererror';
                    xhr.error = errMsg = (err || status);
                }
            }
            catch (err) {
                log('error caught: ',err);
                status = 'error';
                xhr.error = errMsg = (err || status);
            }

            if (xhr.aborted) {
                log('upload aborted');
                status = null;
            }

            if (xhr.status) { // we've set xhr.status
                status = (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) ? 'success' : 'error';
            }

            // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
            if (status === 'success') {
                if (s.success) {
                    s.success.call(s.context, data, 'success', xhr);
                }
                deferred.resolve(xhr.responseText, 'success', xhr);
                if (g) {
                    $.event.trigger("ajaxSuccess", [xhr, s]);
                }
            }
            else if (status) {
                if (errMsg === undefined) {
                    errMsg = xhr.statusText;
                }
                if (s.error) {
                    s.error.call(s.context, xhr, status, errMsg);
                }
                deferred.reject(xhr, 'error', errMsg);
                if (g) {
                    $.event.trigger("ajaxError", [xhr, s, errMsg]);
                }
            }

            if (g) {
                $.event.trigger("ajaxComplete", [xhr, s]);
            }

            if (g && ! --$.active) {
                $.event.trigger("ajaxStop");
            }

            if (s.complete) {
                s.complete.call(s.context, xhr, status);
            }

            callbackProcessed = true;
            if (s.timeout) {
                clearTimeout(timeoutHandle);
            }

            // clean up
            setTimeout(function() {
                if (!s.iframeTarget) {
                    $io.remove();
                }
                else { //adding else to clean up existing iframe response.
                    $io.attr('src', s.iframeSrc);
                }
                xhr.responseXML = null;
            }, 100);
        }

        var toXml = $.parseXML || function(s, doc) { // use parseXML if available (jQuery 1.5+)
            if (window.ActiveXObject) {
                doc = new ActiveXObject('Microsoft.XMLDOM');
                doc.async = 'false';
                doc.loadXML(s);
            }
            else {
                doc = (new DOMParser()).parseFromString(s, 'text/xml');
            }
            return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
        };
        var parseJSON = $.parseJSON || function(s) {
            /*jslint evil:true */
            return window['eval']('(' + s + ')');
        };

        var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4

            var ct = xhr.getResponseHeader('content-type') || '',
                xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
                data = xml ? xhr.responseXML : xhr.responseText;

            if (xml && data.documentElement.nodeName === 'parsererror') {
                if ($.error) {
                    $.error('parsererror');
                }
            }
            if (s && s.dataFilter) {
                data = s.dataFilter(data, type);
            }
            if (typeof data === 'string') {
                if (type === 'json' || !type && ct.indexOf('json') >= 0) {
                    data = parseJSON(data);
                } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
                    $.globalEval(data);
                }
            }
            return data;
        };

        return deferred;
    }
};

/**
 * ajaxForm() provides a mechanism for fully automating form submission.
 *
 * The advantages of using this method instead of ajaxSubmit() are:
 *
 * 1: This method will include coordinates for <input type="image" /> elements (if the element
 *    is used to submit the form).
 * 2. This method will include the submit element's name/value data (for the element that was
 *    used to submit the form).
 * 3. This method binds the submit() method to the form for you.
 *
 * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
 * passes the options argument along after properly binding events for submit elements and
 * the form itself.
 */
$.fn.ajaxForm = function(options) {
    options = options || {};
    options.delegation = options.delegation && $.isFunction($.fn.on);

    // in jQuery 1.3+ we can fix mistakes with the ready state
    if (!options.delegation && this.length === 0) {
        var o = { s: this.selector, c: this.context };
        if (!$.isReady && o.s) {
            log('DOM not ready, queuing ajaxForm');
            $(function() {
                $(o.s,o.c).ajaxForm(options);
            });
            return this;
        }
        // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
        log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
        return this;
    }

    if ( options.delegation ) {
        $(document)
            .off('submit.form-plugin', this.selector, doAjaxSubmit)
            .off('click.form-plugin', this.selector, captureSubmittingElement)
            .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
            .on('click.form-plugin', this.selector, options, captureSubmittingElement);
        return this;
    }

    return this.ajaxFormUnbind()
        .bind('submit.form-plugin', options, doAjaxSubmit)
        .bind('click.form-plugin', options, captureSubmittingElement);
};

// private event handlers
function doAjaxSubmit(e) {
    /*jshint validthis:true */
    var options = e.data;
    if (!e.isDefaultPrevented()) { // if event has been canceled, don't proceed
        e.preventDefault();
        $(e.target).ajaxSubmit(options); // #365
    }
}

function captureSubmittingElement(e) {
    /*jshint validthis:true */
    var target = e.target;
    var $el = $(target);
    if (!($el.is("[type=submit],[type=image]"))) {
        // is this a child element of the submit el?  (ex: a span within a button)
        var t = $el.closest('[type=submit]');
        if (t.length === 0) {
            return;
        }
        target = t[0];
    }
    var form = this;
    form.clk = target;
    if (target.type == 'image') {
        if (e.offsetX !== undefined) {
            form.clk_x = e.offsetX;
            form.clk_y = e.offsetY;
        } else if (typeof $.fn.offset == 'function') {
            var offset = $el.offset();
            form.clk_x = e.pageX - offset.left;
            form.clk_y = e.pageY - offset.top;
        } else {
            form.clk_x = e.pageX - target.offsetLeft;
            form.clk_y = e.pageY - target.offsetTop;
        }
    }
    // clear form vars
    setTimeout(function() { form.clk = form.clk_x = form.clk_y = null; }, 100);
}


// ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
$.fn.ajaxFormUnbind = function() {
    return this.unbind('submit.form-plugin click.form-plugin');
};

/**
 * formToArray() gathers form element data into an array of objects that can
 * be passed to any of the following ajax functions: $.get, $.post, or load.
 * Each object in the array has both a 'name' and 'value' property.  An example of
 * an array for a simple login form might be:
 *
 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
 *
 * It is this array that is passed to pre-submit callback functions provided to the
 * ajaxSubmit() and ajaxForm() methods.
 */
$.fn.formToArray = function(semantic, elements) {
    var a = [];
    if (this.length === 0) {
        return a;
    }

    var form = this[0];
    var formId = this.attr('id');
    var els = semantic ? form.getElementsByTagName('*') : form.elements;
    var els2;

    if (els && !/MSIE [678]/.test(navigator.userAgent)) { // #390
        els = $(els).get();  // convert to standard array
    }

    // #386; account for inputs outside the form which use the 'form' attribute
    if ( formId ) {
        els2 = $(':input[form="' + formId + '"]').get(); // hat tip @thet
        if ( els2.length ) {
            els = (els || []).concat(els2);
        }
    }

    if (!els || !els.length) {
        return a;
    }

    var i,j,n,v,el,max,jmax;
    for(i=0, max=els.length; i < max; i++) {
        el = els[i];
        n = el.name;
        if (!n || el.disabled) {
            continue;
        }

        if (semantic && form.clk && el.type == "image") {
            // handle image inputs on the fly when semantic == true
            if(form.clk == el) {
                a.push({name: n, value: $(el).val(), type: el.type });
                a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
            }
            continue;
        }

        v = $.fieldValue(el, true);
        if (v && v.constructor == Array) {
            if (elements) {
                elements.push(el);
            }
            for(j=0, jmax=v.length; j < jmax; j++) {
                a.push({name: n, value: v[j]});
            }
        }
        else if (feature.fileapi && el.type == 'file') {
            if (elements) {
                elements.push(el);
            }
            var files = el.files;
            if (files.length) {
                for (j=0; j < files.length; j++) {
                    a.push({name: n, value: files[j], type: el.type});
                }
            }
            else {
                // #180
                a.push({ name: n, value: '', type: el.type });
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            if (elements) {
                elements.push(el);
            }
            a.push({name: n, value: v, type: el.type, required: el.required});
        }
    }

    if (!semantic && form.clk) {
        // input type=='image' are not found in elements array! handle it here
        var $input = $(form.clk), input = $input[0];
        n = input.name;
        if (n && !input.disabled && input.type == 'image') {
            a.push({name: n, value: $input.val()});
            a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
        }
    }
    return a;
};

/**
 * Serializes form data into a 'submittable' string. This method will return a string
 * in the format: name1=value1&amp;name2=value2
 */
$.fn.formSerialize = function(semantic) {
    //hand off to jQuery.param for proper encoding
    return $.param(this.formToArray(semantic));
};

/**
 * Serializes all field elements in the jQuery object into a query string.
 * This method will return a string in the format: name1=value1&amp;name2=value2
 */
$.fn.fieldSerialize = function(successful) {
    var a = [];
    this.each(function() {
        var n = this.name;
        if (!n) {
            return;
        }
        var v = $.fieldValue(this, successful);
        if (v && v.constructor == Array) {
            for (var i=0,max=v.length; i < max; i++) {
                a.push({name: n, value: v[i]});
            }
        }
        else if (v !== null && typeof v != 'undefined') {
            a.push({name: this.name, value: v});
        }
    });
    //hand off to jQuery.param for proper encoding
    return $.param(a);
};

/**
 * Returns the value(s) of the element in the matched set.  For example, consider the following form:
 *
 *  <form><fieldset>
 *      <input name="A" type="text" />
 *      <input name="A" type="text" />
 *      <input name="B" type="checkbox" value="B1" />
 *      <input name="B" type="checkbox" value="B2"/>
 *      <input name="C" type="radio" value="C1" />
 *      <input name="C" type="radio" value="C2" />
 *  </fieldset></form>
 *
 *  var v = $('input[type=text]').fieldValue();
 *  // if no values are entered into the text inputs
 *  v == ['','']
 *  // if values entered into the text inputs are 'foo' and 'bar'
 *  v == ['foo','bar']
 *
 *  var v = $('input[type=checkbox]').fieldValue();
 *  // if neither checkbox is checked
 *  v === undefined
 *  // if both checkboxes are checked
 *  v == ['B1', 'B2']
 *
 *  var v = $('input[type=radio]').fieldValue();
 *  // if neither radio is checked
 *  v === undefined
 *  // if first radio is checked
 *  v == ['C1']
 *
 * The successful argument controls whether or not the field element must be 'successful'
 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
 * The default value of the successful argument is true.  If this value is false the value(s)
 * for each element is returned.
 *
 * Note: This method *always* returns an array.  If no valid value can be determined the
 *    array will be empty, otherwise it will contain one or more values.
 */
$.fn.fieldValue = function(successful) {
    for (var val=[], i=0, max=this.length; i < max; i++) {
        var el = this[i];
        var v = $.fieldValue(el, successful);
        if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
            continue;
        }
        if (v.constructor == Array) {
            $.merge(val, v);
        }
        else {
            val.push(v);
        }
    }
    return val;
};

/**
 * Returns the value of the field element.
 */
$.fieldValue = function(el, successful) {
    var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
    if (successful === undefined) {
        successful = true;
    }

    if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
        (t == 'checkbox' || t == 'radio') && !el.checked ||
        (t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
        tag == 'select' && el.selectedIndex == -1)) {
            return null;
    }

    if (tag == 'select') {
        var index = el.selectedIndex;
        if (index < 0) {
            return null;
        }
        var a = [], ops = el.options;
        var one = (t == 'select-one');
        var max = (one ? index+1 : ops.length);
        for(var i=(one ? index : 0); i < max; i++) {
            var op = ops[i];
            if (op.selected) {
                var v = op.value;
                if (!v) { // extra pain for IE...
                    v = (op.attributes && op.attributes.value && !(op.attributes.value.specified)) ? op.text : op.value;
                }
                if (one) {
                    return v;
                }
                a.push(v);
            }
        }
        return a;
    }
    return $(el).val();
};

/**
 * Clears the form data.  Takes the following actions on the form's input fields:
 *  - input text fields will have their 'value' property set to the empty string
 *  - select elements will have their 'selectedIndex' property set to -1
 *  - checkbox and radio inputs will have their 'checked' property set to false
 *  - inputs of type submit, button, reset, and hidden will *not* be effected
 *  - button elements will *not* be effected
 */
$.fn.clearForm = function(includeHidden) {
    return this.each(function() {
        $('input,select,textarea', this).clearFields(includeHidden);
    });
};

/**
 * Clears the selected form elements.
 */
$.fn.clearFields = $.fn.clearInputs = function(includeHidden) {
    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
    return this.each(function() {
        var t = this.type, tag = this.tagName.toLowerCase();
        if (re.test(t) || tag == 'textarea') {
            this.value = '';
        }
        else if (t == 'checkbox' || t == 'radio') {
            this.checked = false;
        }
        else if (tag == 'select') {
            this.selectedIndex = -1;
        }
        else if (t == "file") {
            if (/MSIE/.test(navigator.userAgent)) {
                $(this).replaceWith($(this).clone(true));
            } else {
                $(this).val('');
            }
        }
        else if (includeHidden) {
            // includeHidden can be the value true, or it can be a selector string
            // indicating a special test; for example:
            //  $('#myForm').clearForm('.special:hidden')
            // the above would clean hidden inputs that have the class of 'special'
            if ( (includeHidden === true && /hidden/.test(t)) ||
                 (typeof includeHidden == 'string' && $(this).is(includeHidden)) ) {
                this.value = '';
            }
        }
    });
};

/**
 * Resets the form data.  Causes all form elements to be reset to their original value.
 */
$.fn.resetForm = function() {
    return this.each(function() {
        // guard against an input with the name of 'reset'
        // note that IE reports the reset function as an 'object'
        if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
            this.reset();
        }
    });
};

/**
 * Enables or disables any matching elements.
 */
$.fn.enable = function(b) {
    if (b === undefined) {
        b = true;
    }
    return this.each(function() {
        this.disabled = !b;
    });
};

/**
 * Checks/unchecks any matching checkboxes or radio buttons and
 * selects/deselects and matching option elements.
 */
$.fn.selected = function(select) {
    if (select === undefined) {
        select = true;
    }
    return this.each(function() {
        var t = this.type;
        if (t == 'checkbox' || t == 'radio') {
            this.checked = select;
        }
        else if (this.tagName.toLowerCase() == 'option') {
            var $sel = $(this).parent('select');
            if (select && $sel[0] && $sel[0].type == 'select-one') {
                // deselect all other options
                $sel.find('option').selected(false);
            }
            this.selected = select;
        }
    });
};

// expose debug var
$.fn.ajaxSubmit.debug = false;

// helper fn for console logging
function log() {
    if (!$.fn.ajaxSubmit.debug) {
        return;
    }
    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments,'');
    if (window.console && window.console.log) {
        window.console.log(msg);
    }
    else if (window.opera && window.opera.postError) {
        window.opera.postError(msg);
    }
}

}));


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Nanobar"] = __webpack_require__(1437);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

/* http://nanobar.micronube.com/  ||  https://github.com/jacoborus/nanobar/    MIT LICENSE */
(function (root) {
  'use strict'
  // container styles
  var css = '.nanobar{width:100%;height:4px;z-index:9999;top:0}.bar{width:0;height:100%;transition:height .3s;background:#000}'

  // add required css in head div
  function addCss () {
    var s = document.getElementById('nanobarcss')

    // check whether style tag is already inserted
    if (s === null) {
      s = document.createElement('style')
      s.type = 'text/css'
      s.id = 'nanobarcss'
      document.head.insertBefore(s, document.head.firstChild)
      // the world
      if (!s.styleSheet) return s.appendChild(document.createTextNode(css))
      // IE
      s.styleSheet.cssText = css
    }
  }

  function addClass (el, cls) {
    if (el.classList) el.classList.add(cls)
    else el.className += ' ' + cls
  }

  // create a progress bar
  // this will be destroyed after reaching 100% progress
  function createBar (rm) {
    // create progress element
    var el = document.createElement('div'),
        width = 0,
        here = 0,
        on = 0,
        bar = {
          el: el,
          go: go
        }

    addClass(el, 'bar')

    // animation loop
    function move () {
      var dist = width - here

      if (dist < 0.1 && dist > -0.1) {
        place(here)
        on = 0
        if (width === 100) {
          el.style.height = 0
          setTimeout(function () {
            rm(el)
          }, 300)
        }
      } else {
        place(width - dist / 4)
        setTimeout(go, 16)
      }
    }

    // set bar width
    function place (num) {
      width = num
      el.style.width = width + '%'
    }

    function go (num) {
      if (num >= 0) {
        here = num
        if (!on) {
          on = 1
          move()
        }
      } else if (on) {
        move()
      }
    }
    return bar
  }

  function Nanobar (opts) {
    opts = opts || {}
    // set options
    var el = document.createElement('div'),
        applyGo,
        nanobar = {
          el: el,
          go: function (p) {
            // expand bar
            applyGo(p)
            // create new bar when progress reaches 100%
            if (p === 100) {
              init()
            }
          }
        }

    // remove element from nanobar container
    function rm (child) {
      el.removeChild(child)
    }

    // create and insert progress var in nanobar container
    function init () {
      var bar = createBar(rm)
      el.appendChild(bar.el)
      applyGo = bar.go
    }

    addCss()

    addClass(el, 'nanobar')
    if (opts.id) el.id = opts.id
    if (opts.classname) addClass(el, opts.classname)

    // insert container
    if (opts.target) {
      // inside a div
      el.style.position = 'relative'
      opts.target.insertBefore(el, opts.target.firstChild)
    } else {
      // on top of the page
      el.style.position = 'fixed'
      document.getElementsByTagName('body')[0].appendChild(el)
    }

    init()
    return nanobar
  }

  if (true) {
    // CommonJS
    module.exports = Nanobar
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], function () { return Nanobar })
  } else {
    // Browser globals
    root.Nanobar = Nanobar
  }
}(this))


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jstz"] = __webpack_require__(1439);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {/*global exports, Intl*/
/**
 * This script gives you the zone info key representing your device's time zone setting.
 *
 * @name jsTimezoneDetect
 * @version 1.0.6
 * @author Jon Nylander
 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
 *
 * For usage and examples, visit:
 * http://pellepim.bitbucket.org/jstz/
 *
 * Copyright (c) Jon Nylander
 */


/**
 * Namespace to hold all the code for timezone detection.
 */
var jstz = (function () {
    'use strict';
    var HEMISPHERE_SOUTH = 's',

        consts = {
            DAY: 86400000,
            HOUR: 3600000,
            MINUTE: 60000,
            SECOND: 1000,
            BASELINE_YEAR: 2014,
            MAX_SCORE: 864000000, // 10 days
            AMBIGUITIES: {
                'America/Denver':       ['America/Mazatlan'],
                'Europe/London':        ['Africa/Casablanca'],
                'America/Chicago':      ['America/Mexico_City'],
                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
                // Europe/Minsk should not be in this list... but Windows.
                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
                'Pacific/Auckland':     ['Pacific/Fiji'],
                'America/Los_Angeles':  ['America/Santa_Isabel'],
                'America/New_York':     ['America/Havana'],
                'America/Halifax':      ['America/Goose_Bay'],
                'America/Godthab':      ['America/Miquelon'],
                'Asia/Dubai':           ['Asia/Yerevan'],
                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
                'Australia/Sydney':     ['Australia/Lord_Howe'],
                'Asia/Tokyo':           ['Asia/Yakutsk'],
                'Asia/Dhaka':           ['Asia/Omsk'],
                // In the real world Yerevan is not ambigous for Baku... but Windows.
                'Asia/Baku':            ['Asia/Yerevan'],
                'Australia/Brisbane':   ['Asia/Vladivostok'],
                'Pacific/Noumea':       ['Asia/Vladivostok'],
                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
                'Pacific/Tongatapu':    ['Pacific/Apia'],
                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
                'Asia/Karachi':         ['Asia/Yekaterinburg'],
                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
            }
        },

        /**
         * Gets the offset in minutes from UTC for a certain date.
         * @param {Date} date
         * @returns {Number}
         */
        get_date_offset = function get_date_offset(date) {
            var offset = -date.getTimezoneOffset();
            return (offset !== null ? offset : 0);
        },

        /**
         * This function does some basic calculations to create information about
         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
         * the script has been tested rather than depend on the year set by the
         * client device.
         *
         * Returns a key that can be used to do lookups in jstz.olson.timezones.
         * eg: "720,1,2".
         *
         * @returns {String}
         */
        lookup_key = function lookup_key() {
            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
                diff = january_offset - june_offset;

            if (diff < 0) {
                return january_offset + ",1";
            } else if (diff > 0) {
                return june_offset + ",1," + HEMISPHERE_SOUTH;
            }

            return january_offset + ",0";
        },


        /**
         * Tries to get the time zone key directly from the operating system for those
         * environments that support the ECMAScript Internationalization API.
         */
        get_from_internationalization_api = function get_from_internationalization_api() {
            var format, timezone;
            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
                return;
            }

            format = Intl.DateTimeFormat();

            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
                return;
            }

            timezone = format.resolvedOptions().timeZone;

            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC')) {
                return timezone;
            }

        },

        /**
         * Starting point for getting all the DST rules for a specific year
         * for the current timezone (as described by the client system).
         *
         * Returns an object with start and end attributes, or false if no
         * DST rules were found for the year.
         *
         * @param year
         * @returns {Object} || {Boolean}
         */
        dst_dates = function dst_dates(year) {
            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
            var current = yearstart;
            var offset = (new Date(current)).getTimezoneOffset();
            var dst_start = null;
            var dst_end = null;

            while (current < yearend - 86400000) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    if (dateToCheckOffset < offset) {
                        dst_start = dateToCheck;
                    }
                    if (dateToCheckOffset > offset) {
                        dst_end = dateToCheck;
                    }
                    offset = dateToCheckOffset;
                }

                current += 86400000;
            }

            if (dst_start && dst_end) {
                return {
                    s: find_dst_fold(dst_start).getTime(),
                    e: find_dst_fold(dst_end).getTime()
                };
            }

            return false;
        },

        /**
         * Probably completely unnecessary function that recursively finds the
         * exact (to the second) time when a DST rule was changed.
         *
         * @param a_date - The candidate Date.
         * @param padding - integer specifying the padding to allow around the candidate
         *                  date for finding the fold.
         * @param iterator - integer specifying how many milliseconds to iterate while
         *                   searching for the fold.
         *
         * @returns {Date}
         */
        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
            if (typeof padding === 'undefined') {
                padding = consts.DAY;
                iterator = consts.HOUR;
            }

            var date_start = new Date(a_date.getTime() - padding).getTime();
            var date_end = a_date.getTime() + padding;
            var offset = new Date(date_start).getTimezoneOffset();

            var current = date_start;

            var dst_change = null;
            while (current < date_end - iterator) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    dst_change = dateToCheck;
                    break;
                }
                current += iterator;
            }

            if (padding === consts.DAY) {
                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
            }

            if (padding === consts.HOUR) {
                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
            }

            return dst_change;
        },

        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
            if (score !== 'N/A') {
                return score;
            }
            if (preliminary_timezone === 'Asia/Beirut') {
                if (sample.name === 'Africa/Cairo') {
                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
                        return 0;
                    }
                }
                if (sample.name === 'Asia/Jerusalem') {
                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
                        return 0;
                }
            }
            } else if (preliminary_timezone === 'America/Santiago') {
                if (sample.name === 'America/Asuncion') {
                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
                        return 0;
                    }
                }
                if (sample.name === 'America/Campo_Grande') {
                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'America/Montevideo') {
                if (sample.name === 'America/Sao_Paulo') {
                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'Pacific/Auckland') {
                if (sample.name === 'Pacific/Fiji') {
                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
                        return 0;
                    }
                }
            }

            return score;
        },

        /**
         * Takes the DST rules for the current timezone, and proceeds to find matches
         * in the jstz.olson.dst_rules.zones array.
         *
         * Compares samples to the current timezone on a scoring basis.
         *
         * Candidates are ruled immediately if either the candidate or the current zone
         * has a DST rule where the other does not.
         *
         * Candidates are ruled out immediately if the current zone has a rule that is
         * outside the DST scope of the candidate.
         *
         * Candidates are included for scoring if the current zones rules fall within the
         * span of the samples rules.
         *
         * Low score is best, the score is calculated by summing up the differences in DST
         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
         *
         * Yah follow? :)
         *
         * @param rule_list
         * @param preliminary_timezone
         * @returns {*}
         */
        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
            var score_sample = function score_sample(sample) {
                var score = 0;

                for (var j = 0; j < rule_list.length; j++) {

                    // Both sample and current time zone report DST during the year.
                    if (!!sample.rules[j] && !!rule_list[j]) {

                        // The current time zone's DST rules are inside the sample's. Include.
                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
                            score = 0;
                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
                            score += Math.abs(sample.rules[j].e - rule_list[j].e);

                        // The current time zone's DST rules are outside the sample's. Discard.
                        } else {
                            score = 'N/A';
                            break;
                        }

                        // The max score has been reached. Discard.
                        if (score > consts.MAX_SCORE) {
                            score = 'N/A';
                            break;
                        }
                    }
                }

                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);

                return score;
            };
            var scoreboard = {};
            var dst_zones = jstz.olson.dst_rules.zones;
            var dst_zones_length = dst_zones.length;
            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];

            for (var i = 0; i < dst_zones_length; i++) {
                var sample = dst_zones[i];
                var score = score_sample(dst_zones[i]);

                if (score !== 'N/A') {
                    scoreboard[sample.name] = score;
                }
            }

            for (var tz in scoreboard) {
                if (scoreboard.hasOwnProperty(tz)) {
                    for (var j = 0; j < ambiguities.length; j++) {
                        if (ambiguities[j] === tz) {
                            return tz;
                        }
                    }
                }
            }

            return preliminary_timezone;
        },

        /**
         * Takes the preliminary_timezone as detected by lookup_key().
         *
         * Builds up the current timezones DST rules for the years defined
         * in the jstz.olson.dst_rules.years array.
         *
         * If there are no DST occurences for those years, immediately returns
         * the preliminary timezone. Otherwise proceeds and tries to solve
         * ambiguities.
         *
         * @param preliminary_timezone
         * @returns {String} timezone_name
         */
        get_by_dst = function get_by_dst(preliminary_timezone) {
            var get_rules = function get_rules() {
                var rule_list = [];
                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
                    rule_list.push(year_rules);
                }
                return rule_list;
            };
            var check_has_dst = function check_has_dst(rules) {
                for (var i = 0; i < rules.length; i++) {
                    if (rules[i] !== false) {
                        return true;
                    }
                }
                return false;
            };
            var rules = get_rules();
            var has_dst = check_has_dst(rules);

            if (has_dst) {
                return best_dst_match(rules, preliminary_timezone);
            }

            return preliminary_timezone;
        },

        /**
         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
         *
         * Returns an object with one function ".name()"
         *
         * @returns Object
         */
        determine = function determine() {
            var preliminary_tz = get_from_internationalization_api();

            if (!preliminary_tz) {
                preliminary_tz = jstz.olson.timezones[lookup_key()];

                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
                    preliminary_tz = get_by_dst(preliminary_tz);
                }
            }

            return {
                name: function () {
                    return preliminary_tz;
                }
            };
        };

    return {
        determine: determine
    };
}());


jstz.olson = jstz.olson || {};

/**
 * The keys in this dictionary are comma separated as such:
 *
 * First the offset compared to UTC time in minutes.
 *
 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
 * does.
 *
 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
 * only interesting for timezones with DST.
 *
 * The mapped arrays is used for constructing the jstz.TimeZone object from within
 * jstz.determine();
 */
jstz.olson.timezones = {
    '-720,0': 'Etc/GMT+12',
    '-660,0': 'Pacific/Pago_Pago',
    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
    '-600,1': 'America/Adak',
    '-600,0': 'Pacific/Honolulu',
    '-570,0': 'Pacific/Marquesas',
    '-540,0': 'Pacific/Gambier',
    '-540,1': 'America/Anchorage',
    '-480,1': 'America/Los_Angeles',
    '-480,0': 'Pacific/Pitcairn',
    '-420,0': 'America/Phoenix',
    '-420,1': 'America/Denver',
    '-360,0': 'America/Guatemala',
    '-360,1': 'America/Chicago',
    '-360,1,s': 'Pacific/Easter',
    '-300,0': 'America/Bogota',
    '-300,1': 'America/New_York',
    '-270,0': 'America/Caracas',
    '-240,1': 'America/Halifax',
    '-240,0': 'America/Santo_Domingo',
    '-240,1,s': 'America/Asuncion',
    '-210,1': 'America/St_Johns',
    '-180,1': 'America/Godthab',
    '-180,0': 'America/Argentina/Buenos_Aires',
    '-180,1,s': 'America/Montevideo',
    '-120,0': 'America/Noronha',
    '-120,1': 'America/Noronha',
    '-60,1': 'Atlantic/Azores',
    '-60,0': 'Atlantic/Cape_Verde',
    '0,0': 'UTC',
    '0,1': 'Europe/London',
    '60,1': 'Europe/Berlin',
    '60,0': 'Africa/Lagos',
    '60,1,s': 'Africa/Windhoek',
    '120,1': 'Asia/Beirut',
    '120,0': 'Africa/Johannesburg',
    '180,0': 'Asia/Baghdad',
    '180,1': 'Europe/Moscow',
    '210,1': 'Asia/Tehran',
    '240,0': 'Asia/Dubai',
    '240,1': 'Asia/Baku',
    '270,0': 'Asia/Kabul',
    '300,1': 'Asia/Yekaterinburg',
    '300,0': 'Asia/Karachi',
    '330,0': 'Asia/Kolkata',
    '345,0': 'Asia/Kathmandu',
    '360,0': 'Asia/Dhaka',
    '360,1': 'Asia/Omsk',
    '390,0': 'Asia/Rangoon',
    '420,1': 'Asia/Krasnoyarsk',
    '420,0': 'Asia/Jakarta',
    '480,0': 'Asia/Shanghai',
    '480,1': 'Asia/Irkutsk',
    '525,0': 'Australia/Eucla',
    '525,1,s': 'Australia/Eucla',
    '540,1': 'Asia/Yakutsk',
    '540,0': 'Asia/Tokyo',
    '570,0': 'Australia/Darwin',
    '570,1,s': 'Australia/Adelaide',
    '600,0': 'Australia/Brisbane',
    '600,1': 'Asia/Vladivostok',
    '600,1,s': 'Australia/Sydney',
    '630,1,s': 'Australia/Lord_Howe',
    '660,1': 'Asia/Kamchatka',
    '660,0': 'Pacific/Noumea',
    '690,0': 'Pacific/Norfolk',
    '720,1,s': 'Pacific/Auckland',
    '720,0': 'Pacific/Majuro',
    '765,1,s': 'Pacific/Chatham',
    '780,0': 'Pacific/Tongatapu',
    '780,1,s': 'Pacific/Apia',
    '840,0': 'Pacific/Kiritimati'
};

/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
jstz.olson.dst_rules = {
    "years": [
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
    ],
    "zones": [
        {
            "name": "Africa/Cairo",
            "rules": [
                {
                    "e": 1219957200000,
                    "s": 1209074400000
                },
                {
                    "e": 1250802000000,
                    "s": 1240524000000
                },
                {
                    "e": 1285880400000,
                    "s": 1284069600000
                },
                false,
                false,
                false,
                {
                    "e": 1411678800000,
                    "s": 1406844000000
                }
            ]
        },
        {
            "name": "Africa/Casablanca",
            "rules": [
                {
                    "e": 1220223600000,
                    "s": 1212278400000
                },
                {
                    "e": 1250809200000,
                    "s": 1243814400000
                },
                {
                    "e": 1281222000000,
                    "s": 1272758400000
                },
                {
                    "e": 1312066800000,
                    "s": 1301788800000
                },
                {
                    "e": 1348970400000,
                    "s": 1345428000000
                },
                {
                    "e": 1382839200000,
                    "s": 1376100000000
                },
                {
                    "e": 1414288800000,
                    "s": 1406944800000
                }
            ]
        },
        {
            "name": "America/Asuncion",
            "rules": [
                {
                    "e": 1205031600000,
                    "s": 1224388800000
                },
                {
                    "e": 1236481200000,
                    "s": 1255838400000
                },
                {
                    "e": 1270954800000,
                    "s": 1286078400000
                },
                {
                    "e": 1302404400000,
                    "s": 1317528000000
                },
                {
                    "e": 1333854000000,
                    "s": 1349582400000
                },
                {
                    "e": 1364094000000,
                    "s": 1381032000000
                },
                {
                    "e": 1395543600000,
                    "s": 1412481600000
                }
            ]
        },
        {
            "name": "America/Campo_Grande",
            "rules": [
                {
                    "e": 1203217200000,
                    "s": 1224388800000
                },
                {
                    "e": 1234666800000,
                    "s": 1255838400000
                },
                {
                    "e": 1266721200000,
                    "s": 1287288000000
                },
                {
                    "e": 1298170800000,
                    "s": 1318737600000
                },
                {
                    "e": 1330225200000,
                    "s": 1350792000000
                },
                {
                    "e": 1361070000000,
                    "s": 1382241600000
                },
                {
                    "e": 1392519600000,
                    "s": 1413691200000
                }
            ]
        },
        {
            "name": "America/Goose_Bay",
            "rules": [
                {
                    "e": 1225594860000,
                    "s": 1205035260000
                },
                {
                    "e": 1257044460000,
                    "s": 1236484860000
                },
                {
                    "e": 1289098860000,
                    "s": 1268539260000
                },
                {
                    "e": 1320555600000,
                    "s": 1299988860000
                },
                {
                    "e": 1352005200000,
                    "s": 1331445600000
                },
                {
                    "e": 1383454800000,
                    "s": 1362895200000
                },
                {
                    "e": 1414904400000,
                    "s": 1394344800000
                }
            ]
        },
        {
            "name": "America/Havana",
            "rules": [
                {
                    "e": 1224997200000,
                    "s": 1205643600000
                },
                {
                    "e": 1256446800000,
                    "s": 1236488400000
                },
                {
                    "e": 1288501200000,
                    "s": 1268542800000
                },
                {
                    "e": 1321160400000,
                    "s": 1300597200000
                },
                {
                    "e": 1352005200000,
                    "s": 1333256400000
                },
                {
                    "e": 1383454800000,
                    "s": 1362891600000
                },
                {
                    "e": 1414904400000,
                    "s": 1394341200000
                }
            ]
        },
        {
            "name": "America/Mazatlan",
            "rules": [
                {
                    "e": 1225008000000,
                    "s": 1207472400000
                },
                {
                    "e": 1256457600000,
                    "s": 1238922000000
                },
                {
                    "e": 1288512000000,
                    "s": 1270371600000
                },
                {
                    "e": 1319961600000,
                    "s": 1301821200000
                },
                {
                    "e": 1351411200000,
                    "s": 1333270800000
                },
                {
                    "e": 1382860800000,
                    "s": 1365325200000
                },
                {
                    "e": 1414310400000,
                    "s": 1396774800000
                }
            ]
        },
        {
            "name": "America/Mexico_City",
            "rules": [
                {
                    "e": 1225004400000,
                    "s": 1207468800000
                },
                {
                    "e": 1256454000000,
                    "s": 1238918400000
                },
                {
                    "e": 1288508400000,
                    "s": 1270368000000
                },
                {
                    "e": 1319958000000,
                    "s": 1301817600000
                },
                {
                    "e": 1351407600000,
                    "s": 1333267200000
                },
                {
                    "e": 1382857200000,
                    "s": 1365321600000
                },
                {
                    "e": 1414306800000,
                    "s": 1396771200000
                }
            ]
        },
        {
            "name": "America/Miquelon",
            "rules": [
                {
                    "e": 1225598400000,
                    "s": 1205038800000
                },
                {
                    "e": 1257048000000,
                    "s": 1236488400000
                },
                {
                    "e": 1289102400000,
                    "s": 1268542800000
                },
                {
                    "e": 1320552000000,
                    "s": 1299992400000
                },
                {
                    "e": 1352001600000,
                    "s": 1331442000000
                },
                {
                    "e": 1383451200000,
                    "s": 1362891600000
                },
                {
                    "e": 1414900800000,
                    "s": 1394341200000
                }
            ]
        },
        {
            "name": "America/Santa_Isabel",
            "rules": [
                {
                    "e": 1225011600000,
                    "s": 1207476000000
                },
                {
                    "e": 1256461200000,
                    "s": 1238925600000
                },
                {
                    "e": 1288515600000,
                    "s": 1270375200000
                },
                {
                    "e": 1319965200000,
                    "s": 1301824800000
                },
                {
                    "e": 1351414800000,
                    "s": 1333274400000
                },
                {
                    "e": 1382864400000,
                    "s": 1365328800000
                },
                {
                    "e": 1414314000000,
                    "s": 1396778400000
                }
            ]
        },
        {
            "name": "America/Santiago",
            "rules": [
                {
                    "e": 1206846000000,
                    "s": 1223784000000
                },
                {
                    "e": 1237086000000,
                    "s": 1255233600000
                },
                {
                    "e": 1270350000000,
                    "s": 1286683200000
                },
                {
                    "e": 1304823600000,
                    "s": 1313899200000
                },
                {
                    "e": 1335668400000,
                    "s": 1346558400000
                },
                {
                    "e": 1367118000000,
                    "s": 1378612800000
                },
                {
                    "e": 1398567600000,
                    "s": 1410062400000
                }
            ]
        },
        {
            "name": "America/Sao_Paulo",
            "rules": [
                {
                    "e": 1203213600000,
                    "s": 1224385200000
                },
                {
                    "e": 1234663200000,
                    "s": 1255834800000
                },
                {
                    "e": 1266717600000,
                    "s": 1287284400000
                },
                {
                    "e": 1298167200000,
                    "s": 1318734000000
                },
                {
                    "e": 1330221600000,
                    "s": 1350788400000
                },
                {
                    "e": 1361066400000,
                    "s": 1382238000000
                },
                {
                    "e": 1392516000000,
                    "s": 1413687600000
                }
            ]
        },
        {
            "name": "Asia/Amman",
            "rules": [
                {
                    "e": 1225404000000,
                    "s": 1206655200000
                },
                {
                    "e": 1256853600000,
                    "s": 1238104800000
                },
                {
                    "e": 1288303200000,
                    "s": 1269554400000
                },
                {
                    "e": 1319752800000,
                    "s": 1301608800000
                },
                false,
                false,
                {
                    "e": 1414706400000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Damascus",
            "rules": [
                {
                    "e": 1225486800000,
                    "s": 1207260000000
                },
                {
                    "e": 1256850000000,
                    "s": 1238104800000
                },
                {
                    "e": 1288299600000,
                    "s": 1270159200000
                },
                {
                    "e": 1319749200000,
                    "s": 1301608800000
                },
                {
                    "e": 1351198800000,
                    "s": 1333058400000
                },
                {
                    "e": 1382648400000,
                    "s": 1364508000000
                },
                {
                    "e": 1414702800000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Dubai",
            "rules": [
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Gaza",
            "rules": [
                {
                    "e": 1219957200000,
                    "s": 1206655200000
                },
                {
                    "e": 1252015200000,
                    "s": 1238104800000
                },
                {
                    "e": 1281474000000,
                    "s": 1269640860000
                },
                {
                    "e": 1312146000000,
                    "s": 1301608860000
                },
                {
                    "e": 1348178400000,
                    "s": 1333058400000
                },
                {
                    "e": 1380229200000,
                    "s": 1364508000000
                },
                {
                    "e": 1414098000000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Irkutsk",
            "rules": [
                {
                    "e": 1224957600000,
                    "s": 1206813600000
                },
                {
                    "e": 1256407200000,
                    "s": 1238263200000
                },
                {
                    "e": 1288461600000,
                    "s": 1269712800000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Jerusalem",
            "rules": [
                {
                    "e": 1223161200000,
                    "s": 1206662400000
                },
                {
                    "e": 1254006000000,
                    "s": 1238112000000
                },
                {
                    "e": 1284246000000,
                    "s": 1269561600000
                },
                {
                    "e": 1317510000000,
                    "s": 1301616000000
                },
                {
                    "e": 1348354800000,
                    "s": 1333065600000
                },
                {
                    "e": 1382828400000,
                    "s": 1364515200000
                },
                {
                    "e": 1414278000000,
                    "s": 1395964800000
                }
            ]
        },
        {
            "name": "Asia/Kamchatka",
            "rules": [
                {
                    "e": 1224943200000,
                    "s": 1206799200000
                },
                {
                    "e": 1256392800000,
                    "s": 1238248800000
                },
                {
                    "e": 1288450800000,
                    "s": 1269698400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Krasnoyarsk",
            "rules": [
                {
                    "e": 1224961200000,
                    "s": 1206817200000
                },
                {
                    "e": 1256410800000,
                    "s": 1238266800000
                },
                {
                    "e": 1288465200000,
                    "s": 1269716400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Omsk",
            "rules": [
                {
                    "e": 1224964800000,
                    "s": 1206820800000
                },
                {
                    "e": 1256414400000,
                    "s": 1238270400000
                },
                {
                    "e": 1288468800000,
                    "s": 1269720000000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Vladivostok",
            "rules": [
                {
                    "e": 1224950400000,
                    "s": 1206806400000
                },
                {
                    "e": 1256400000000,
                    "s": 1238256000000
                },
                {
                    "e": 1288454400000,
                    "s": 1269705600000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yakutsk",
            "rules": [
                {
                    "e": 1224954000000,
                    "s": 1206810000000
                },
                {
                    "e": 1256403600000,
                    "s": 1238259600000
                },
                {
                    "e": 1288458000000,
                    "s": 1269709200000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yekaterinburg",
            "rules": [
                {
                    "e": 1224968400000,
                    "s": 1206824400000
                },
                {
                    "e": 1256418000000,
                    "s": 1238274000000
                },
                {
                    "e": 1288472400000,
                    "s": 1269723600000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yerevan",
            "rules": [
                {
                    "e": 1224972000000,
                    "s": 1206828000000
                },
                {
                    "e": 1256421600000,
                    "s": 1238277600000
                },
                {
                    "e": 1288476000000,
                    "s": 1269727200000
                },
                {
                    "e": 1319925600000,
                    "s": 1301176800000
                },
                false,
                false,
                false
            ]
        },
        {
            "name": "Australia/Lord_Howe",
            "rules": [
                {
                    "e": 1207407600000,
                    "s": 1223134200000
                },
                {
                    "e": 1238857200000,
                    "s": 1254583800000
                },
                {
                    "e": 1270306800000,
                    "s": 1286033400000
                },
                {
                    "e": 1301756400000,
                    "s": 1317483000000
                },
                {
                    "e": 1333206000000,
                    "s": 1349537400000
                },
                {
                    "e": 1365260400000,
                    "s": 1380987000000
                },
                {
                    "e": 1396710000000,
                    "s": 1412436600000
                }
            ]
        },
        {
            "name": "Australia/Perth",
            "rules": [
                {
                    "e": 1206813600000,
                    "s": 1224957600000
                },
                false,
                false,
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Europe/Helsinki",
            "rules": [
                {
                    "e": 1224982800000,
                    "s": 1206838800000
                },
                {
                    "e": 1256432400000,
                    "s": 1238288400000
                },
                {
                    "e": 1288486800000,
                    "s": 1269738000000
                },
                {
                    "e": 1319936400000,
                    "s": 1301187600000
                },
                {
                    "e": 1351386000000,
                    "s": 1332637200000
                },
                {
                    "e": 1382835600000,
                    "s": 1364691600000
                },
                {
                    "e": 1414285200000,
                    "s": 1396141200000
                }
            ]
        },
        {
            "name": "Europe/Minsk",
            "rules": [
                {
                    "e": 1224979200000,
                    "s": 1206835200000
                },
                {
                    "e": 1256428800000,
                    "s": 1238284800000
                },
                {
                    "e": 1288483200000,
                    "s": 1269734400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Europe/Moscow",
            "rules": [
                {
                    "e": 1224975600000,
                    "s": 1206831600000
                },
                {
                    "e": 1256425200000,
                    "s": 1238281200000
                },
                {
                    "e": 1288479600000,
                    "s": 1269730800000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Pacific/Apia",
            "rules": [
                false,
                false,
                false,
                {
                    "e": 1301752800000,
                    "s": 1316872800000
                },
                {
                    "e": 1333202400000,
                    "s": 1348927200000
                },
                {
                    "e": 1365256800000,
                    "s": 1380376800000
                },
                {
                    "e": 1396706400000,
                    "s": 1411826400000
                }
            ]
        },
        {
            "name": "Pacific/Fiji",
            "rules": [
                false,
                false,
                {
                    "e": 1269698400000,
                    "s": 1287842400000
                },
                {
                    "e": 1327154400000,
                    "s": 1319292000000
                },
                {
                    "e": 1358604000000,
                    "s": 1350741600000
                },
                {
                    "e": 1390050000000,
                    "s": 1382796000000
                },
                {
                    "e": 1421503200000,
                    "s": 1414850400000
                }
            ]
        },
        {
            "name": "Europe/London",
            "rules": [
                {
                    "e": 1224982800000,
                    "s": 1206838800000
                },
                {
                    "e": 1256432400000,
                    "s": 1238288400000
                },
                {
                    "e": 1288486800000,
                    "s": 1269738000000
                },
                {
                    "e": 1319936400000,
                    "s": 1301187600000
                },
                {
                    "e": 1351386000000,
                    "s": 1332637200000
                },
                {
                    "e": 1382835600000,
                    "s": 1364691600000
                },
                {
                    "e": 1414285200000,
                    "s": 1396141200000
                }
            ]
        }
    ]
};
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = jstz;
} else if (("function" !== 'undefined' && __webpack_require__(1440) !== null) && (__webpack_require__(299) != null)) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return jstz;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
    if (typeof root === 'undefined') {
        window.jstz = jstz;
    } else {
        root.jstz = jstz;
    }
}
}());


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["dragula"] = __webpack_require__(1442);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.dragula = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var cache = {};
var start = '(?:^|\\s)';
var end = '(?:\\s|$)';

function lookupClass (className) {
  var cached = cache[className];
  if (cached) {
    cached.lastIndex = 0;
  } else {
    cache[className] = cached = new RegExp(start + className + end, 'g');
  }
  return cached;
}

function addClass (el, className) {
  var current = el.className;
  if (!current.length) {
    el.className = className;
  } else if (!lookupClass(className).test(current)) {
    el.className += ' ' + className;
  }
}

function rmClass (el, className) {
  el.className = el.className.replace(lookupClass(className), ' ').trim();
}

module.exports = {
  add: addClass,
  rm: rmClass
};

},{}],2:[function(require,module,exports){
(function (global){
'use strict';

var emitter = require('contra/emitter');
var crossvent = require('crossvent');
var classes = require('./classes');
var doc = document;
var documentElement = doc.documentElement;

function dragula (initialContainers, options) {
  var len = arguments.length;
  if (len === 1 && Array.isArray(initialContainers) === false) {
    options = initialContainers;
    initialContainers = [];
  }
  var _mirror; // mirror image
  var _source; // source container
  var _item; // item being dragged
  var _offsetX; // reference x
  var _offsetY; // reference y
  var _moveX; // reference move x
  var _moveY; // reference move y
  var _initialSibling; // reference sibling when grabbed
  var _currentSibling; // reference sibling now
  var _copy; // item used for copying
  var _renderTimer; // timer for setTimeout renderMirrorImage
  var _lastDropTarget = null; // last container item was over
  var _grabbed; // holds mousedown context until first mousemove

  var o = options || {};
  if (o.moves === void 0) { o.moves = always; }
  if (o.accepts === void 0) { o.accepts = always; }
  if (o.invalid === void 0) { o.invalid = invalidTarget; }
  if (o.containers === void 0) { o.containers = initialContainers || []; }
  if (o.isContainer === void 0) { o.isContainer = never; }
  if (o.copy === void 0) { o.copy = false; }
  if (o.copySortSource === void 0) { o.copySortSource = false; }
  if (o.revertOnSpill === void 0) { o.revertOnSpill = false; }
  if (o.removeOnSpill === void 0) { o.removeOnSpill = false; }
  if (o.direction === void 0) { o.direction = 'vertical'; }
  if (o.ignoreInputTextSelection === void 0) { o.ignoreInputTextSelection = true; }
  if (o.mirrorContainer === void 0) { o.mirrorContainer = doc.body; }

  var drake = emitter({
    containers: o.containers,
    start: manualStart,
    end: end,
    cancel: cancel,
    remove: remove,
    destroy: destroy,
    canMove: canMove,
    dragging: false
  });

  if (o.removeOnSpill === true) {
    drake.on('over', spillOver).on('out', spillOut);
  }

  events();

  return drake;

  function isContainer (el) {
    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
  }

  function events (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousedown', grab);
    touchy(documentElement, op, 'mouseup', release);
  }

  function eventualMovements (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
  }

  function movements (remove) {
    var op = remove ? 'remove' : 'add';
    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
    crossvent[op](documentElement, 'click', preventGrabbed);
  }

  function destroy () {
    events(true);
    release({});
  }

  function preventGrabbed (e) {
    if (_grabbed) {
      e.preventDefault();
    }
  }

  function grab (e) {
    _moveX = e.clientX;
    _moveY = e.clientY;

    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
    if (ignore) {
      return; // we only care about honest-to-god left clicks and touch events
    }
    var item = e.target;
    var context = canStart(item);
    if (!context) {
      return;
    }
    _grabbed = context;
    eventualMovements();
    if (e.type === 'mousedown') {
      if (isInput(item)) { // see also: https://github.com/bevacqua/dragula/issues/208
        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
      } else {
        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
      }
    }
  }

  function startBecauseMouseMoved (e) {
    if (!_grabbed) {
      return;
    }
    if (whichMouseButton(e) === 0) {
      release({});
      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
    }
    // truthy check fixes #239, equality fixes #207
    if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
      return;
    }
    if (o.ignoreInputTextSelection) {
      var clientX = getCoord('clientX', e);
      var clientY = getCoord('clientY', e);
      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
      if (isInput(elementBehindCursor)) {
        return;
      }
    }

    var grabbed = _grabbed; // call to end() unsets _grabbed
    eventualMovements(true);
    movements();
    end();
    start(grabbed);

    var offset = getOffset(_item);
    _offsetX = getCoord('pageX', e) - offset.left;
    _offsetY = getCoord('pageY', e) - offset.top;

    classes.add(_copy || _item, 'gu-transit');
    renderMirrorImage();
    drag(e);
  }

  function canStart (item) {
    if (drake.dragging && _mirror) {
      return;
    }
    if (isContainer(item)) {
      return; // don't drag container itself
    }
    var handle = item;
    while (getParent(item) && isContainer(getParent(item)) === false) {
      if (o.invalid(item, handle)) {
        return;
      }
      item = getParent(item); // drag target should be a top element
      if (!item) {
        return;
      }
    }
    var source = getParent(item);
    if (!source) {
      return;
    }
    if (o.invalid(item, handle)) {
      return;
    }

    var movable = o.moves(item, source, handle, nextEl(item));
    if (!movable) {
      return;
    }

    return {
      item: item,
      source: source
    };
  }

  function canMove (item) {
    return !!canStart(item);
  }

  function manualStart (item) {
    var context = canStart(item);
    if (context) {
      start(context);
    }
  }

  function start (context) {
    if (isCopy(context.item, context.source)) {
      _copy = context.item.cloneNode(true);
      drake.emit('cloned', _copy, context.item, 'copy');
    }

    _source = context.source;
    _item = context.item;
    _initialSibling = _currentSibling = nextEl(context.item);

    drake.dragging = true;
    drake.emit('drag', _item, _source);
  }

  function invalidTarget () {
    return false;
  }

  function end () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    drop(item, getParent(item));
  }

  function ungrab () {
    _grabbed = false;
    eventualMovements(true);
    movements(true);
  }

  function release (e) {
    ungrab();

    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    if (dropTarget && ((_copy && o.copySortSource) || (!_copy || dropTarget !== _source))) {
      drop(item, dropTarget);
    } else if (o.removeOnSpill) {
      remove();
    } else {
      cancel();
    }
  }

  function drop (item, target) {
    var parent = getParent(item);
    if (_copy && o.copySortSource && target === _source) {
      parent.removeChild(_item);
    }
    if (isInitialPlacement(target)) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, target, _source, _currentSibling);
    }
    cleanup();
  }

  function remove () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var parent = getParent(item);
    if (parent) {
      parent.removeChild(item);
    }
    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
    cleanup();
  }

  function cancel (revert) {
    if (!drake.dragging) {
      return;
    }
    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
    var item = _copy || _item;
    var parent = getParent(item);
    var initial = isInitialPlacement(parent);
    if (initial === false && reverts) {
      if (_copy) {
        parent.removeChild(_copy);
      } else {
        _source.insertBefore(item, _initialSibling);
      }
    }
    if (initial || reverts) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, parent, _source, _currentSibling);
    }
    cleanup();
  }

  function cleanup () {
    var item = _copy || _item;
    ungrab();
    removeMirrorImage();
    if (item) {
      classes.rm(item, 'gu-transit');
    }
    if (_renderTimer) {
      clearTimeout(_renderTimer);
    }
    drake.dragging = false;
    if (_lastDropTarget) {
      drake.emit('out', item, _lastDropTarget, _source);
    }
    drake.emit('dragend', item);
    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
  }

  function isInitialPlacement (target, s) {
    var sibling;
    if (s !== void 0) {
      sibling = s;
    } else if (_mirror) {
      sibling = _currentSibling;
    } else {
      sibling = nextEl(_copy || _item);
    }
    return target === _source && sibling === _initialSibling;
  }

  function findDropTarget (elementBehindCursor, clientX, clientY) {
    var target = elementBehindCursor;
    while (target && !accepted()) {
      target = getParent(target);
    }
    return target;

    function accepted () {
      var droppable = isContainer(target);
      if (droppable === false) {
        return false;
      }

      var immediate = getImmediateChild(target, elementBehindCursor);
      var reference = getReference(target, immediate, clientX, clientY);
      var initial = isInitialPlacement(target, reference);
      if (initial) {
        return true; // should always be able to drop it right back where it was
      }
      return o.accepts(_item, target, _source, reference);
    }
  }

  function drag (e) {
    if (!_mirror) {
      return;
    }
    e.preventDefault();

    var clientX = getCoord('clientX', e);
    var clientY = getCoord('clientY', e);
    var x = clientX - _offsetX;
    var y = clientY - _offsetY;

    _mirror.style.left = x + 'px';
    _mirror.style.top = y + 'px';

    var item = _copy || _item;
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
    if (changed || dropTarget === null) {
      out();
      _lastDropTarget = dropTarget;
      over();
    }
    var parent = getParent(item);
    if (dropTarget === _source && _copy && !o.copySortSource) {
      if (parent) {
        parent.removeChild(item);
      }
      return;
    }
    var reference;
    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
    if (immediate !== null) {
      reference = getReference(dropTarget, immediate, clientX, clientY);
    } else if (o.revertOnSpill === true && !_copy) {
      reference = _initialSibling;
      dropTarget = _source;
    } else {
      if (_copy && parent) {
        parent.removeChild(item);
      }
      return;
    }
    if (
      (reference === null && changed) ||
      reference !== item &&
      reference !== nextEl(item)
    ) {
      _currentSibling = reference;
      dropTarget.insertBefore(item, reference);
      drake.emit('shadow', item, dropTarget, _source);
    }
    function moved (type) { drake.emit(type, item, _lastDropTarget, _source); }
    function over () { if (changed) { moved('over'); } }
    function out () { if (_lastDropTarget) { moved('out'); } }
  }

  function spillOver (el) {
    classes.rm(el, 'gu-hide');
  }

  function spillOut (el) {
    if (drake.dragging) { classes.add(el, 'gu-hide'); }
  }

  function renderMirrorImage () {
    if (_mirror) {
      return;
    }
    var rect = _item.getBoundingClientRect();
    _mirror = _item.cloneNode(true);
    _mirror.style.width = getRectWidth(rect) + 'px';
    _mirror.style.height = getRectHeight(rect) + 'px';
    classes.rm(_mirror, 'gu-transit');
    classes.add(_mirror, 'gu-mirror');
    o.mirrorContainer.appendChild(_mirror);
    touchy(documentElement, 'add', 'mousemove', drag);
    classes.add(o.mirrorContainer, 'gu-unselectable');
    drake.emit('cloned', _mirror, _item, 'mirror');
  }

  function removeMirrorImage () {
    if (_mirror) {
      classes.rm(o.mirrorContainer, 'gu-unselectable');
      touchy(documentElement, 'remove', 'mousemove', drag);
      getParent(_mirror).removeChild(_mirror);
      _mirror = null;
    }
  }

  function getImmediateChild (dropTarget, target) {
    var immediate = target;
    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
      immediate = getParent(immediate);
    }
    if (immediate === documentElement) {
      return null;
    }
    return immediate;
  }

  function getReference (dropTarget, target, x, y) {
    var horizontal = o.direction === 'horizontal';
    var reference = target !== dropTarget ? inside() : outside();
    return reference;

    function outside () { // slower, but able to figure out any position
      var len = dropTarget.children.length;
      var i;
      var el;
      var rect;
      for (i = 0; i < len; i++) {
        el = dropTarget.children[i];
        rect = el.getBoundingClientRect();
        if (horizontal && (rect.left + rect.width / 2) > x) { return el; }
        if (!horizontal && (rect.top + rect.height / 2) > y) { return el; }
      }
      return null;
    }

    function inside () { // faster, but only available if dropped inside a child element
      var rect = target.getBoundingClientRect();
      if (horizontal) {
        return resolve(x > rect.left + getRectWidth(rect) / 2);
      }
      return resolve(y > rect.top + getRectHeight(rect) / 2);
    }

    function resolve (after) {
      return after ? nextEl(target) : target;
    }
  }

  function isCopy (item, container) {
    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
  }
}

function touchy (el, op, type, fn) {
  var touch = {
    mouseup: 'touchend',
    mousedown: 'touchstart',
    mousemove: 'touchmove'
  };
  var pointers = {
    mouseup: 'pointerup',
    mousedown: 'pointerdown',
    mousemove: 'pointermove'
  };
  var microsoft = {
    mouseup: 'MSPointerUp',
    mousedown: 'MSPointerDown',
    mousemove: 'MSPointerMove'
  };
  if (global.navigator.pointerEnabled) {
    crossvent[op](el, pointers[type], fn);
  } else if (global.navigator.msPointerEnabled) {
    crossvent[op](el, microsoft[type], fn);
  } else {
    crossvent[op](el, touch[type], fn);
    crossvent[op](el, type, fn);
  }
}

function whichMouseButton (e) {
  if (e.touches !== void 0) { return e.touches.length; }
  if (e.which !== void 0 && e.which !== 0) { return e.which; } // see https://github.com/bevacqua/dragula/issues/261
  if (e.buttons !== void 0) { return e.buttons; }
  var button = e.button;
  if (button !== void 0) { // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
    return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
  }
}

function getOffset (el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
    top: rect.top + getScroll('scrollTop', 'pageYOffset')
  };
}

function getScroll (scrollProp, offsetProp) {
  if (typeof global[offsetProp] !== 'undefined') {
    return global[offsetProp];
  }
  if (documentElement.clientHeight) {
    return documentElement[scrollProp];
  }
  return doc.body[scrollProp];
}

function getElementBehindPoint (point, x, y) {
  var p = point || {};
  var state = p.className;
  var el;
  p.className += ' gu-hide';
  el = doc.elementFromPoint(x, y);
  p.className = state;
  return el;
}

function never () { return false; }
function always () { return true; }
function getRectWidth (rect) { return rect.width || (rect.right - rect.left); }
function getRectHeight (rect) { return rect.height || (rect.bottom - rect.top); }
function getParent (el) { return el.parentNode === doc ? null : el.parentNode; }
function isInput (el) { return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el); }
function isEditable (el) {
  if (!el) { return false; } // no parents were editable
  if (el.contentEditable === 'false') { return false; } // stop the lookup
  if (el.contentEditable === 'true') { return true; } // found a contentEditable element in the chain
  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
}

function nextEl (el) {
  return el.nextElementSibling || manually();
  function manually () {
    var sibling = el;
    do {
      sibling = sibling.nextSibling;
    } while (sibling && sibling.nodeType !== 1);
    return sibling;
  }
}

function getEventHost (e) {
  // on touchend event, we have to use `e.changedTouches`
  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
  // see https://github.com/bevacqua/dragula/issues/34
  if (e.targetTouches && e.targetTouches.length) {
    return e.targetTouches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}

function getCoord (coord, e) {
  var host = getEventHost(e);
  var missMap = {
    pageX: 'clientX', // IE8
    pageY: 'clientY' // IE8
  };
  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
    coord = missMap[coord];
  }
  return host[coord];
}

module.exports = dragula;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./classes":1,"contra/emitter":4,"crossvent":8}],3:[function(require,module,exports){
'use strict';

var ticky = require('ticky');

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};

},{"ticky":6}],4:[function(require,module,exports){
'use strict';

var atoa = require('atoa');
var debounce = require('./debounce');

module.exports = function emitter (thing, options) {
  var opts = options || {};
  var evt = {};
  if (thing === undefined) { thing = {}; }
  thing.on = function (type, fn) {
    if (!evt[type]) {
      evt[type] = [fn];
    } else {
      evt[type].push(fn);
    }
    return thing;
  };
  thing.once = function (type, fn) {
    fn._once = true; // thing.off(fn) still works!
    thing.on(type, fn);
    return thing;
  };
  thing.off = function (type, fn) {
    var c = arguments.length;
    if (c === 1) {
      delete evt[type];
    } else if (c === 0) {
      evt = {};
    } else {
      var et = evt[type];
      if (!et) { return thing; }
      et.splice(et.indexOf(fn), 1);
    }
    return thing;
  };
  thing.emit = function () {
    var args = atoa(arguments);
    return thing.emitterSnapshot(args.shift()).apply(this, args);
  };
  thing.emitterSnapshot = function (type) {
    var et = (evt[type] || []).slice(0);
    return function () {
      var args = atoa(arguments);
      var ctx = this || thing;
      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
      et.forEach(function emitter (listen) {
        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
        if (listen._once) { thing.off(type, listen); }
      });
      return thing;
    };
  };
  return thing;
};

},{"./debounce":3,"atoa":5}],5:[function(require,module,exports){
module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }

},{}],6:[function(require,module,exports){
var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;
},{}],7:[function(require,module,exports){
(function (global){

var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],8:[function(require,module,exports){
(function (global){
'use strict';

var customEvent = require('custom-event');
var eventmap = require('./eventmap');
var doc = global.document;
var addEvent = addEventEasy;
var removeEvent = removeEventEasy;
var hardCache = [];

if (!global.addEventListener) {
  addEvent = addEventHard;
  removeEvent = removeEventHard;
}

module.exports = {
  add: addEvent,
  remove: removeEvent,
  fabricate: fabricateEvent
};

function addEventEasy (el, type, fn, capturing) {
  return el.addEventListener(type, fn, capturing);
}

function addEventHard (el, type, fn) {
  return el.attachEvent('on' + type, wrap(el, type, fn));
}

function removeEventEasy (el, type, fn, capturing) {
  return el.removeEventListener(type, fn, capturing);
}

function removeEventHard (el, type, fn) {
  var listener = unwrap(el, type, fn);
  if (listener) {
    return el.detachEvent('on' + type, listener);
  }
}

function fabricateEvent (el, type, model) {
  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
  if (el.dispatchEvent) {
    el.dispatchEvent(e);
  } else {
    el.fireEvent('on' + type, e);
  }
  function makeClassicEvent () {
    var e;
    if (doc.createEvent) {
      e = doc.createEvent('Event');
      e.initEvent(type, true, true);
    } else if (doc.createEventObject) {
      e = doc.createEventObject();
    }
    return e;
  }
  function makeCustomEvent () {
    return new customEvent(type, { detail: model });
  }
}

function wrapperFactory (el, type, fn) {
  return function wrapper (originalEvent) {
    var e = originalEvent || global.event;
    e.target = e.target || e.srcElement;
    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
    e.which = e.which || e.keyCode;
    fn.call(el, e);
  };
}

function wrap (el, type, fn) {
  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
  hardCache.push({
    wrapper: wrapper,
    element: el,
    type: type,
    fn: fn
  });
  return wrapper;
}

function unwrap (el, type, fn) {
  var i = find(el, type, fn);
  if (i) {
    var wrapper = hardCache[i].wrapper;
    hardCache.splice(i, 1); // free up a tad of memory
    return wrapper;
  }
}

function find (el, type, fn) {
  var i, item;
  for (i = 0; i < hardCache.length; i++) {
    item = hardCache[i];
    if (item.element === el && item.type === type && item.fn === fn) {
      return i;
    }
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./eventmap":9,"custom-event":7}],9:[function(require,module,exports){
(function (global){
'use strict';

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}]},{},[2])(2)
});
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(300).setImmediate))

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(301)))

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Quill"] = __webpack_require__(1445);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.0.6
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(53);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	var _break = __webpack_require__(33);

	var _break2 = _interopRequireDefault(_break);

	var _container = __webpack_require__(42);

	var _container2 = _interopRequireDefault(_container);

	var _cursor = __webpack_require__(37);

	var _cursor2 = _interopRequireDefault(_cursor);

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	var _scroll = __webpack_require__(43);

	var _scroll2 = _interopRequireDefault(_scroll);

	var _text = __webpack_require__(36);

	var _text2 = _interopRequireDefault(_text);

	var _clipboard = __webpack_require__(44);

	var _clipboard2 = _interopRequireDefault(_clipboard);

	var _history = __webpack_require__(51);

	var _history2 = _interopRequireDefault(_history);

	var _keyboard = __webpack_require__(52);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,

	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});

	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

	module.exports = _quill2.default;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var container_1 = __webpack_require__(3);
	var format_1 = __webpack_require__(7);
	var leaf_1 = __webpack_require__(12);
	var scroll_1 = __webpack_require__(13);
	var inline_1 = __webpack_require__(14);
	var block_1 = __webpack_require__(15);
	var embed_1 = __webpack_require__(16);
	var text_1 = __webpack_require__(17);
	var attributor_1 = __webpack_require__(8);
	var class_1 = __webpack_require__(10);
	var style_1 = __webpack_require__(11);
	var store_1 = __webpack_require__(9);
	var Registry = __webpack_require__(6);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = Parchment;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var linked_list_1 = __webpack_require__(4);
	var shadow_1 = __webpack_require__(5);
	var Registry = __webpack_require__(6);
	var ContainerBlot = (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot() {
	        _super.apply(this, arguments);
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        var _this = this;
	        _super.prototype.attach.call(this);
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice.call(this.domNode.childNodes).reverse().forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [], lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = (def == null) ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function (child) {
	            return childBlot instanceof child;
	        })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function () {
	        _super.prototype.optimize.call(this);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize();
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations) {
	        var _this = this;
	        var addedNodes = [], removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes.filter(function (node) {
	            return node.parentNode == _this.domNode;
	        }).sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        }).forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                blot.domNode.appendChild(child);
	            });
	            node.parentNode.replaceChild(blot.domNode, node);
	            blot.attach();
	        }
	    }
	    return blot;
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ContainerBlot;


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	var LinkedList = (function () {
	    function LinkedList() {
	        this.head = this.tail = undefined;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i - 0] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], undefined);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while (cur = next()) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = undefined;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while (cur = next()) {
	            var length_1 = cur.length();
	            if (index < length_1 || (inclusive && index === length_1 && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length_1;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while (cur = next()) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while (cur = next()) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LinkedList;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Registry = __webpack_require__(6);
	var ShadowBlot = (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        this.attach();
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode();
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent_1 = Registry.create(this.statics.scope);
	            blot.wrap(parent_1);
	            parent_1.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = (def == null) ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            var refDomNode = refBlot.domNode;
	        }
	        if (this.next == null || this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ;
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function () {
	        // TODO clean up once we use WeakMap
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations) {
	        if (mutations === void 0) { mutations = []; }
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ShadowBlot;


/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ParchmentError = (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        message = '[Parchment] ' + message;
	        _super.call(this, message);
	        this.message = message;
	        this.name = this.constructor.name;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(exports.Scope || (exports.Scope = {}));
	var Scope = exports.Scope;
	;
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = input instanceof Node ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	    }
	    else if (query instanceof Text) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    if ((scope & Scope.LEVEL & match.scope) && (scope & Scope.TYPE & match.scope))
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i - 0] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var attributor_1 = __webpack_require__(8);
	var store_1 = __webpack_require__(9);
	var container_1 = __webpack_require__(3);
	var Registry = __webpack_require__(6);
	var FormatBlot = (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot() {
	        _super.apply(this, arguments);
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.attributes = new store_1.default(this.domNode);
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = FormatBlot;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Registry = __webpack_require__(6);
	var Attributor = (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match != null && (this.whitelist == null || this.whitelist.indexOf(value) > -1)) {
	            return true;
	        }
	        return false;
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        return node.getAttribute(this.keyName);
	    };
	    return Attributor;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = Attributor;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var attributor_1 = __webpack_require__(8);
	var class_1 = __webpack_require__(10);
	var style_1 = __webpack_require__(11);
	var Registry = __webpack_require__(6);
	var AttributorStore = (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes.concat(classes).concat(styles).forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = AttributorStore;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var attributor_1 = __webpack_require__(8);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        _super.apply(this, arguments);
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name.split('-').slice(0, -1).join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        return result.slice(this.keyName.length + 1); // +1 for hyphen
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ClassAttributor;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var attributor_1 = __webpack_require__(8);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts.slice(1).map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    }).join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        _super.apply(this, arguments);
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        return node.style[camelize(this.keyName)];
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StyleAttributor;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var shadow_1 = __webpack_require__(5);
	var Registry = __webpack_require__(6);
	var LeafBlot = (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        _super.apply(this, arguments);
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (node !== this.domNode)
	            return -1;
	        return Math.min(offset, 1);
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        return (_a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a);
	        var _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LeafBlot;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var container_1 = __webpack_require__(3);
	var Registry = __webpack_require__(6);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = this;
	        _super.call(this, node);
	        this.parent = null;
	        this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        this.observer.observe(this.domNode, OBSERVER_CONFIG);
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        _super.prototype.optimize.call(this);
	        mutations.push.apply(mutations, this.observer.takeRecords());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            if (blot.domNode[Registry.DATA_KEY] == null || blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize();
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = this.observer.takeRecords();
	            mutations.push.apply(mutations, remaining);
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations) {
	        var _this = this;
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations.map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return;
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        }).forEach(function (blot) {
	            if (blot == null || blot === _this)
	                return;
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || []);
	        });
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations);
	        }
	        this.optimize(mutations);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ScrollBlot;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var format_1 = __webpack_require__(7);
	var Registry = __webpack_require__(6);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    for (var prop in obj1) {
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        _super.apply(this, arguments);
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function () {
	        _super.prototype.optimize.call(this);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = InlineBlot;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var format_1 = __webpack_require__(7);
	var Registry = __webpack_require__(6);
	var BlockBlot = (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        _super.apply(this, arguments);
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = BlockBlot;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var leaf_1 = __webpack_require__(12);
	var EmbedBlot = (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        _super.apply(this, arguments);
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = EmbedBlot;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var leaf_1 = __webpack_require__(12);
	var Registry = __webpack_require__(6);
	var TextBlot = (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        _super.call(this, node);
	        this.text = this.statics.value(this.domNode);
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        return domNode.data;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function () {
	        _super.prototype.optimize.call(this);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TextBlot;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	__webpack_require__(19);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _editor = __webpack_require__(27);

	var _editor2 = _interopRequireDefault(_editor);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _selection = __webpack_require__(40);

	var _selection2 = _interopRequireDefault(_selection);

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	var _theme = __webpack_require__(41);

	var _theme2 = _interopRequireDefault(_theme);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var debug = (0, _logger2.default)('quill');

	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;

	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        }
	      }
	    }
	  }]);

	  function Quill(container) {
	    var _this2 = this;

	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    _classCallCheck(this, Quill);

	    options = expandConfig(container, options);
	    this.container = options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (options.debug) {
	      Quill.debug(options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.root = this.addContainer('ql-editor');
	    this.emitter = new _emitter2.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: options.formats
	    });
	    this.editor = new _editor2.default(this.scroll, this.emitter);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new options.theme(this, options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (options.readOnly) {
	      this.disable();
	    }
	    if (options.placeholder) {
	      this.root.setAttribute('data-placeholder', options.placeholder);
	    }
	    this.root.classList.toggle('ql-blank', this.editor.isBlank());
	    this.emitter.on(_emitter2.default.events.TEXT_CHANGE, function (delta) {
	      _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	    });
	  }

	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _overload = overload(index, length, source);

	      var _overload2 = _slicedToArray(_overload, 4);

	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];

	      var range = this.getSelection();
	      var change = this.editor.deleteText(index, length, source);
	      range = shiftRange(range, index, -1 * length, source);
	      this.setSelection(range, _emitter2.default.sources.SILENT);
	      return change;
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.editor.enable(enabled);
	      if (!enabled) {
	        this.blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.selection.focus();
	      this.selection.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter2.default.sources.API;

	      var range = this.getSelection(true);
	      var change = new _delta2.default();
	      if (range == null) return change;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        change = this.formatLine(range, name, value, source);
	      } else if (range.length === 0) {
	        this.selection.format(name, value);
	        return change;
	      } else {
	        change = this.formatText(range, name, value, source);
	      }
	      this.setSelection(range, _emitter2.default.sources.SILENT);
	      return change;
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var formats = void 0;

	      var _overload3 = overload(index, length, name, value, source);

	      var _overload4 = _slicedToArray(_overload3, 4);

	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];

	      var range = this.getSelection();
	      var change = this.editor.formatLine(index, length, formats, source);
	      this.selection.setRange(range, true, _emitter2.default.sources.SILENT);
	      this.selection.scrollIntoView();
	      return change;
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var formats = void 0;

	      var _overload5 = overload(index, length, name, value, source);

	      var _overload6 = _slicedToArray(_overload5, 4);

	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];

	      var range = this.getSelection();
	      var change = this.editor.formatText(index, length, formats, source);
	      this.selection.setRange(range, true, _emitter2.default.sources.SILENT);
	      this.selection.scrollIntoView();
	      return change;
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      if (typeof index === 'number') {
	        return this.selection.getBounds(index, length);
	      } else {
	        return this.selection.getBounds(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

	      var _overload7 = overload(index, length);

	      var _overload8 = _slicedToArray(_overload7, 2);

	      index = _overload8[0];
	      length = _overload8[1];

	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection();
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

	      var _overload9 = overload(index, length);

	      var _overload10 = _slicedToArray(_overload9, 2);

	      index = _overload10[0];
	      length = _overload10[1];

	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

	      var range = this.getSelection();
	      var change = this.editor.insertEmbed(index, embed, value, source);
	      range = shiftRange(range, change, source);
	      this.setSelection(range, _emitter2.default.sources.SILENT);
	      return change;
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var formats = void 0,
	          range = this.getSelection();

	      var _overload11 = overload(index, 0, name, value, source);

	      var _overload12 = _slicedToArray(_overload11, 4);

	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];

	      var change = this.editor.insertText(index, text, formats, source);
	      range = shiftRange(range, index, text.length, source);
	      this.setSelection(range, _emitter2.default.sources.SILENT);
	      return change;
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var range = this.getSelection();

	      var _overload13 = overload(index, length, source);

	      var _overload14 = _slicedToArray(_overload13, 4);

	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];

	      var change = this.editor.removeFormat(index, length, source);
	      range = shiftRange(range, change, source);
	      this.setSelection(range, _emitter2.default.sources.SILENT);
	      return change;
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter2.default.sources.API;

	      delta = new _delta2.default(delta).slice();
	      var lastOp = delta.ops[delta.ops.length - 1];
	      // Quill contents must always end with newline
	      if (lastOp == null || lastOp.insert[lastOp.insert.length - 1] !== '\n') {
	        delta.insert('\n');
	      }
	      delta.delete(this.getLength());
	      return this.editor.applyDelta(delta, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);

	        var _overload16 = _slicedToArray(_overload15, 4);

	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];

	        this.selection.setRange(new _selection.Range(index, length), source);
	      }
	      this.selection.scrollIntoView();
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter2.default.sources.API;

	      var delta = new _delta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter2.default.sources.USER;

	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter2.default.sources.API;

	      var range = this.getSelection();
	      if (Array.isArray(delta)) {
	        delta = new _delta2.default(delta.slice());
	      }
	      var change = this.editor.applyDelta(delta, source);
	      if (range != null) {
	        range = shiftRange(range, change, source);
	        this.setSelection(range, _emitter2.default.sources.SILENT);
	      }
	      return change;
	    }
	  }]);

	  return Quill;
	}();

	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  theme: 'default'
	};
	Quill.events = _emitter2.default.events;
	Quill.sources = _emitter2.default.sources;
	Quill.version =  false ? 'dev' : ("1.0.6");

	Quill.imports = {
	  'delta': _delta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};

	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}

	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter2.default.sources.API;
	  return [index, length, formats, source];
	}

	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _delta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source === _emitter2.default.sources.USER);
	    });

	    var _map2 = _slicedToArray(_map, 2);

	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source !== _emitter2.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });

	    var _map4 = _slicedToArray(_map3, 2);

	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}

	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';

	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  (function () {
	    var _toggle = DOMTokenList.prototype.toggle;
	    DOMTokenList.prototype.toggle = function (token, force) {
	      if (arguments.length > 1 && !this.contains(token) === !force) {
	        return force;
	      } else {
	        return _toggle.call(this, token);
	      }
	    };
	  })();
	}

	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}

	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}

	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;

	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}

	// Disable resizing in Firefox
	document.addEventListener("DOMContentLoaded", function () {
	  document.execCommand("enableObjectResizing", false, false);
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var diff = __webpack_require__(21);
	var equal = __webpack_require__(22);
	var extend = __webpack_require__(25);
	var op = __webpack_require__(26);


	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};


	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
	  return this.push(newOp);
	};

	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};

	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
	  return this.push(newOp);
	};

	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};

	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};

	Delta.prototype.length = function () {
	  return this.ops.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};

	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};


	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};

	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};

	Delta.prototype.diff = function (other) {
	  var delta = new Delta();
	  if (this.ops === other.ops) {
	    return delta;
	  }
	  var strings = [this.ops, other.ops].map(function (ops) {
	    return ops.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (ops === other.ops) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var diffResult = diff(strings[0], strings[1]);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};

	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};

	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};


	module.exports = Delta;


/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */


	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;


	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }

	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);

	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);

	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);

	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  return diffs;
	};


	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;

	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }

	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }

	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }

	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }

	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }

	  return diff_bisect_(text1, text2);
	};


	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }

	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};


	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);

	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);

	  return diffs.concat(diffsb);
	};


	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }

	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }

	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }

	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};


	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }

	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};


	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;


	module.exports = diff;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(23);
	var isArguments = __webpack_require__(24);

	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;

	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();

	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;

	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}

	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}

	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}

	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 23 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;

	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 24 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';

	exports = module.exports = supportsArgumentsClass ? supported : unsupported;

	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};

	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';

	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;

	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}

		return toStr.call(arr) === '[object Array]';
	};

	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}

		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) {/**/}

		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};

	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[0],
			i = 1,
			length = arguments.length,
			deep = false;

		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		} else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
			target = {};
		}

		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];

					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}

							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);

						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}

		// Return the modified object
		return target;
	};



/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var equal = __webpack_require__(22);
	var extend = __webpack_require__(25);


	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },

	  iterator: function (ops) {
	    return new Iterator(ops);
	  },

	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};


	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};

	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};

	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};

	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};

	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};


	module.exports = lib;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _op = __webpack_require__(26);

	var _op2 = _interopRequireDefault(_op);

	var _emitter3 = __webpack_require__(28);

	var _emitter4 = _interopRequireDefault(_emitter3);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _code = __webpack_require__(31);

	var _code2 = _interopRequireDefault(_code);

	var _cursor = __webpack_require__(37);

	var _cursor2 = _interopRequireDefault(_cursor);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	var _clone = __webpack_require__(38);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(22);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Editor = function () {
	  function Editor(scroll, emitter) {
	    _classCallCheck(this, Editor);

	    this.scroll = scroll;
	    this.emitter = emitter;
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, this.update.bind(this, null));
	    this.delta = this.getDelta();
	    this.enable();
	  }

	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;

	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batch = true;
	      delta = normalizeDelta(delta);
	      delta.ops.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);

	            var _scroll$line = _this.scroll.line(index);

	            var _scroll$line2 = _slicedToArray(_scroll$line, 2);

	            var line = _scroll$line2[0];
	            var offset = _scroll$line2[1];

	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset);

	              var _line$descendant2 = _slicedToArray(_line$descendant, 1);

	              var leaf = _line$descendant2[0];

	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.ops.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batch = false;
	      this.scroll.optimize();
	      return this.update(delta, source);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

	      this.scroll.deleteAt(index, length);
	      return this.update(new _delta2.default().retain(index).delete(length), source);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.scroll.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _emitter4.default.sources.API;

	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line, i) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _delta2.default().retain(index).retain(length, (0, _clone2.default)(formats)), source);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _emitter4.default.sources.API;

	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _delta2.default().retain(index).retain(length, (0, _clone2.default)(formats)), source);
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _delta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1);

	          var blot = _path[0];

	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).ops.map(function (op) {
	        return typeof op.insert === 'string' ? op.insert : '';
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _emitter4.default.sources.API;

	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _delta2.default().retain(index).insert(_defineProperty({}, embed, value)), source);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;

	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _emitter4.default.sources.API;

	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _delta2.default().retain(index).insert(text, (0, _clone2.default)(formats)), source);
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var child = this.scroll.children.head;
	      return child.length() <= 1 && Object.keys(child.formats()).length == 0;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var text = this.getText(index, length);

	      var _scroll$line3 = this.scroll.line(index + length);

	      var _scroll$line4 = _slicedToArray(_scroll$line3, 2);

	      var line = _scroll$line4[0];
	      var offset = _scroll$line4[1];

	      var suffixLength = 0,
	          suffix = new _delta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _delta2.default().insert(text).concat(suffix));
	      var delta = new _delta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var _this5 = this;

	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.USER;
	      var mutations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && _parchment2.default.find(mutations[0].target)) {
	        (function () {
	          // Optimization for character changes
	          var textBlot = _parchment2.default.find(mutations[0].target);
	          var formats = (0, _block.bubbleFormats)(textBlot);
	          var index = textBlot.offset(_this5.scroll);
	          var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	          var oldText = new _delta2.default().insert(oldValue);
	          var newText = new _delta2.default().insert(textBlot.value());
	          var diffDelta = new _delta2.default().retain(index).concat(oldText.diff(newText));
	          change = diffDelta.ops.reduce(function (delta, op) {
	            if (op.insert) {
	              return delta.insert(op.insert, formats);
	            } else {
	              return delta.push(op);
	            }
	          }, new _delta2.default());
	          _this5.delta = oldDelta.compose(change);
	        })();
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta);
	        }
	      }
	      if (change.length() > 0) {
	        var _emitter;

	        var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;

	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	      return change;
	    }
	  }]);

	  return Editor;
	}();

	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}

	function normalizeDelta(delta) {
	  return delta.ops.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _delta2.default());
	}

	exports.default = Editor;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _eventemitter = __webpack_require__(29);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:events');

	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);

	  function Emitter() {
	    _classCallCheck(this, Emitter);

	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

	    _this.on('error', debug.error);
	    return _this;
	  }

	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }]);

	  return Emitter;
	}(_eventemitter2.default);

	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};

	exports.default = Emitter;

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];

	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];

	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }

	  return ee;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';

	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    console[method].apply(console, args);
	  }
	}

	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}

	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};

	exports.default = namespace;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	var _text = __webpack_require__(36);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Code = function (_Inline) {
	  _inherits(Code, _Inline);

	  function Code() {
	    _classCallCheck(this, Code);

	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }

	  return Code;
	}(_inline2.default);

	Code.blotName = 'code';
	Code.tagName = 'CODE';

	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);

	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);

	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }

	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;

	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _delta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;

	      var _descendant = this.descendant(_text2.default, this.length() - 1);

	      var _descendant2 = _slicedToArray(_descendant, 1);

	      var text = _descendant2[0];

	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;

	      var _descendant3 = this.descendant(_text2.default, index);

	      var _descendant4 = _slicedToArray(_descendant3, 2);

	      var text = _descendant4[0];
	      var offset = _descendant4[1];

	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize();
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return true;
	    }
	  }]);

	  return CodeBlock;
	}(_block2.default);

	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';

	exports.Code = Code;
	exports.default = CodeBlock;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _break = __webpack_require__(33);

	var _break2 = _interopRequireDefault(_break);

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	var _text = __webpack_require__(36);

	var _text2 = _interopRequireDefault(_text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var NEWLINE_LENGTH = 1;

	var BlockEmbed = function (_Embed) {
	  _inherits(BlockEmbed, _Embed);

	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);

	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }

	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _delta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);

	  return BlockEmbed;
	}(_embed2.default);

	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements


	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);

	  function Block(domNode) {
	    _classCallCheck(this, Block);

	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

	    _this2.cache = {};
	    return _this2;
	  }

	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _delta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);

	  return Block;
	}(_parchment2.default.Block);

	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _embed2.default, _text2.default];

	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}

	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Break = function (_Embed) {
	  _inherits(Break, _Embed);

	  function Break() {
	    _classCallCheck(this, Break);

	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }

	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value(domNode) {
	      return undefined;
	    }
	  }]);

	  return Break;
	}(_embed2.default);

	Break.blotName = 'break';
	Break.tagName = 'BR';

	exports.default = Break;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);

	  function Embed() {
	    _classCallCheck(this, Embed);

	    return _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).apply(this, arguments));
	  }

	  return Embed;
	}(_parchment2.default.Embed);

	exports.default = Embed;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _text = __webpack_require__(36);

	var _text2 = _interopRequireDefault(_text);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);

	  function Inline() {
	    _classCallCheck(this, Inline);

	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }

	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this);
	      var ref = this.parent.parent;
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);

	  return Inline;
	}(_parchment2.default.Inline);

	Inline.allowedChildren = [Inline, _embed2.default, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'code', 'underline', 'strike', 'italic', 'bold', 'script', 'link' // Must be higher
	];

	exports.default = Inline;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);

	  function TextBlot() {
	    _classCallCheck(this, TextBlot);

	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }

	  return TextBlot;
	}(_parchment2.default.Text);

	exports.default = TextBlot;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Cursor = function (_Embed) {
	  _inherits(Cursor, _Embed);

	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value(domNode) {
	      return undefined;
	    }
	  }]);

	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);

	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }

	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position(index) {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      var _this2 = this;

	      if (this.selection.composing) return;
	      if (this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        this.textNode.data = this.textNode.data.split(Cursor.CONTENTS).join('');
	        this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	        this.textNode = document.createTextNode(Cursor.CONTENTS);
	        this.domNode.appendChild(this.textNode);
	      }
	      this.remove();
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        this.selection.emitter.once(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	          var _map = [range.start.offset, range.end.offset].map(function (offset) {
	            return Math.max(0, Math.min(textNode.data.length, offset - 1));
	          });

	          var _map2 = _slicedToArray(_map, 2);

	          var start = _map2[0];
	          var end = _map2[1];

	          _this2.selection.setNativeRange(textNode, start, textNode, end);
	        });
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      var _this3 = this;

	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && mutation.target === _this3.textNode) {
	          _this3.restore();
	        }
	      });
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);

	  return Cursor;
	}(_embed2.default);

	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


	exports.default = Cursor;

/***/ },
/* 38 */
/***/ function(module, exports) {

	var clone = (function() {
	'use strict';

	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}

	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}

	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}

	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];

	  var useBuffer = typeof Buffer != 'undefined';

	  if (typeof circular == 'undefined')
	    circular = true;

	  if (typeof depth == 'undefined')
	    depth = Infinity;

	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;

	    if (depth === 0)
	      return parent;

	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }

	    if (parent instanceof nativeMap) {
	      child = new nativeMap();
	    } else if (parent instanceof nativeSet) {
	      child = new nativeSet();
	    } else if (parent instanceof nativePromise) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }

	    if (circular) {
	      var index = allParents.indexOf(parent);

	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }

	    if (parent instanceof nativeMap) {
	      var keyIterator = parent.keys();
	      while(true) {
	        var next = keyIterator.next();
	        if (next.done) {
	          break;
	        }
	        var keyChild = _clone(next.value, depth - 1);
	        var valueChild = _clone(parent.get(next.value), depth - 1);
	        child.set(keyChild, valueChild);
	      }
	    }
	    if (parent instanceof nativeSet) {
	      var iterator = parent.keys();
	      while(true) {
	        var next = iterator.next();
	        if (next.done) {
	          break;
	        }
	        var entryChild = _clone(next.value, depth - 1);
	        child.add(entryChild);
	      }
	    }

	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }

	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }

	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        child[symbol] = _clone(parent[symbol], depth - 1);
	      }
	    }

	    return child;
	  }

	  return _clone(parent, depth);
	}

	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;

	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};

	// private utility functions

	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;

	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;

	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;

	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;

	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;

	return clone;
	})();

	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}


/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  _classCallCheck(this, Module);

	  this.quill = quill;
	  this.options = options;
	};

	Module.DEFAULTS = {};

	exports.default = Module;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _clone = __webpack_require__(38);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(22);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _break = __webpack_require__(33);

	var _break2 = _interopRequireDefault(_break);

	var _emitter3 = __webpack_require__(28);

	var _emitter4 = _interopRequireDefault(_emitter3);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var debug = (0, _logger2.default)('quill:selection');

	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	  _classCallCheck(this, Range);

	  this.index = index;
	  this.length = length;
	};

	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;

	    _classCallCheck(this, Selection);

	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.root = this.scroll.domNode;
	    this.root.addEventListener('compositionstart', function () {
	      _this.composing = true;
	    });
	    this.root.addEventListener('compositionend', function () {
	      _this.composing = false;
	    });
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    ['keyup', 'mouseup', 'mouseleave', 'touchend', 'touchleave', 'focus', 'blur'].forEach(function (eventName) {
	      _this.root.addEventListener(eventName, function () {
	        // When range used to be a selection and user click within the selection,
	        // the range now being a cursor has not updated yet without setTimeout
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 100);
	      });
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }

	  _createClass(Selection, [{
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      var bodyTop = document.body.scrollTop;
	      this.root.focus();
	      document.body.scrollTop = bodyTop;
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var bounds = void 0;var node = void 0;
	      var _scroll$leaf = this.scroll.leaf(index);

	      var _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2);

	      var leaf = _scroll$leaf2[0];
	      var offset = _scroll$leaf2[1];

	      if (leaf == null) return null;

	      var _leaf$position = leaf.position(offset, true);

	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];

	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);

	        var _scroll$leaf3 = this.scroll.leaf(index + length);

	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];

	        if (leaf == null) return null;

	        var _leaf$position3 = leaf.position(offset, true);

	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];

	        range.setEnd(node, offset);
	        bounds = range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          var rect = range.getBoundingClientRect();
	        } else {
	          var rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        bounds = {
	          height: rect.height,
	          left: rect[side],
	          width: 0,
	          top: rect.top
	        };
	      }
	      var containerBounds = this.root.parentNode.getBoundingClientRect();
	      return {
	        left: bounds.left - containerBounds.left,
	        right: bounds.left + bounds.width - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        bottom: bounds.top + bounds.height - containerBounds.top,
	        height: bounds.height,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var _this2 = this;

	      var range = this.getNativeRange();
	      if (range == null) return [null, null];
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2);

	        var node = _position[0];
	        var offset = _position[1];

	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this2.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var start = Math.min.apply(Math, _toConsumableArray(indexes)),
	          end = Math.max.apply(Math, _toConsumableArray(indexes));
	      return [new Range(start, end - start), range];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.lastRange;

	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      if (this.root.offsetHeight < bounds.bottom) {
	        var _scroll$line = this.scroll.line(Math.min(range.index + range.length, this.scroll.length() - 1));

	        var _scroll$line2 = _slicedToArray(_scroll$line, 1);

	        var line = _scroll$line2[0];

	        this.root.scrollTop = line.domNode.offsetTop + line.domNode.offsetHeight - this.root.offsetHeight;
	      } else if (bounds.top < 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index, this.scroll.length() - 1));

	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

	        var _line = _scroll$line4[0];

	        this.root.scrollTop = _line.domNode.offsetTop;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var nativeRange = this.getNativeRange();
	        if (nativeRange == null || force || startNode !== nativeRange.start.node || startOffset !== nativeRange.start.offset || endNode !== nativeRange.end.node || endOffset !== nativeRange.end.offset) {
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var _this3 = this;

	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        (function () {
	          var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	          var args = [];
	          var scrollLength = _this3.scroll.length();
	          indexes.forEach(function (index, i) {
	            index = Math.min(scrollLength - 1, index);
	            var node = void 0;
	            var _scroll$leaf5 = _this3.scroll.leaf(index);

	            var _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2);

	            var leaf = _scroll$leaf6[0];
	            var offset = _scroll$leaf6[1];

	            var _leaf$position5 = leaf.position(offset, i !== 0);

	            var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

	            node = _leaf$position6[0];
	            offset = _leaf$position6[1];

	            args.push(node, offset);
	          });
	          if (args.length < 2) {
	            args = args.concat(args);
	          }
	          _this3.setNativeRange.apply(_this3, _toConsumableArray(args).concat([force]));
	        })();
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

	      var nativeRange = void 0,
	          oldRange = this.lastRange;

	      var _getRange = this.getRange();

	      var _getRange2 = _slicedToArray(_getRange, 2);

	      this.lastRange = _getRange2[0];
	      nativeRange = _getRange2[1];

	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;

	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;

	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);

	  return Selection;
	}();

	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}

	exports.Range = Range;
	exports.default = Selection;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);

	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }

	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;

	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);

	  return Theme;
	}();

	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};

	exports.default = Theme;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);

	  function Container() {
	    _classCallCheck(this, Container);

	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }

	  return Container;
	}(_parchment2.default.Container);

	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

	exports.default = Container;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	var _break = __webpack_require__(33);

	var _break2 = _interopRequireDefault(_break);

	var _container = __webpack_require__(42);

	var _container2 = _interopRequireDefault(_container);

	var _code = __webpack_require__(31);

	var _code2 = _interopRequireDefault(_code);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}

	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);

	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);

	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    _this.optimize();
	    return _this;
	  }

	  _createClass(Scroll, [{
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index);

	      var _line2 = _slicedToArray(_line, 2);

	      var first = _line2[0];
	      var offset = _line2[1];

	      var _line3 = this.line(index + length);

	      var _line4 = _slicedToArray(_line3, 1);

	      var last = _line4[0];

	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0 && !(first instanceof _block.BlockEmbed) && !(last instanceof _block.BlockEmbed)) {
	        if (last instanceof _code2.default) {
	          last.deleteAt(last.length() - 1, 1);
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);

	  return Scroll;
	}(_parchment2.default.Scroll);

	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

	exports.default = Scroll;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	var _align = __webpack_require__(45);

	var _background = __webpack_require__(46);

	var _color = __webpack_require__(47);

	var _direction = __webpack_require__(48);

	var _font = __webpack_require__(49);

	var _size = __webpack_require__(50);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:clipboard');

	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});

	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});

	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);

	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);

	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (pair) {
	      _this.addMatcher.apply(_this, _toConsumableArray(pair));
	    });
	    return _this;
	  }

	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      var _this2 = this;

	      var DOM_KEY = '__ql-matcher';
	      if (typeof html === 'string') {
	        this.container.innerHTML = html;
	      }
	      var textMatchers = [],
	          elementMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2);

	        var selector = _pair[0];
	        var matcher = _pair[1];

	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this2.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      var traverse = function traverse(node) {
	        // Post-order
	        if (node.nodeType === node.TEXT_NODE) {
	          return textMatchers.reduce(function (delta, matcher) {
	            return matcher(node, delta);
	          }, new _delta2.default());
	        } else if (node.nodeType === node.ELEMENT_NODE) {
	          return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	            var childrenDelta = traverse(childNode);
	            if (childNode.nodeType === node.ELEMENT_NODE) {
	              childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	                return matcher(childNode, childrenDelta);
	              }, childrenDelta);
	              childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	                return matcher(childNode, childrenDelta);
	              }, childrenDelta);
	            }
	            return delta.concat(childrenDelta);
	          }, new _delta2.default());
	        } else {
	          return new _delta2.default();
	        }
	      };
	      var delta = traverse(this.container);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _delta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

	      if (typeof index === 'string') {
	        return this.quill.setContents(this.convert(index), html);
	      } else {
	        var paste = this.convert(html);
	        return this.quill.updateContents(new _delta2.default().retain(index).concat(paste), source);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this3 = this;

	      if (e.defaultPrevented) return;
	      var range = this.quill.getSelection();
	      var delta = new _delta2.default().retain(range.index).delete(range.length);
	      var bodyTop = document.body.scrollTop;
	      this.container.focus();
	      setTimeout(function () {
	        _this3.quill.selection.update(_quill2.default.sources.SILENT);
	        delta = delta.concat(_this3.convert());
	        _this3.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this3.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        document.body.scrollTop = bodyTop;
	        _this3.quill.selection.scrollIntoView();
	      }, 1);
	    }
	  }]);

	  return Clipboard;
	}(_module2.default);

	Clipboard.DEFAULTS = {
	  matchers: []
	};

	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}

	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}

	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}

	function matchAlias(format, node, delta) {
	  return delta.compose(new _delta2.default().retain(delta.length(), _defineProperty({}, format, true)));
	}

	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    if (ATTRIBUTE_ATTRIBUTORS[name] != null) {
	      attr = ATTRIBUTE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node);
	    }
	    if (STYLE_ATTRIBUTORS[name] != null) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node);
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = delta.compose(new _delta2.default().retain(delta.length(), formats));
	  }
	  return delta;
	}

	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _delta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    var formats = _defineProperty({}, match.blotName, match.formats(node));
	    delta = delta.compose(new _delta2.default().retain(delta.length(), formats));
	  }
	  return delta;
	}

	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}

	function matchIgnore(node, delta) {
	  return new _delta2.default();
	}

	function matchNewline(node, delta) {
	  if (isLine(node) && !deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}

	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}

	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontWeight && computeStyle(node).fontWeight === 'bold') {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = delta.compose(new _delta2.default().retain(delta.length(), formats));
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _delta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}

	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };

	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}

	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};

	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _color = __webpack_require__(47);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});

	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);

	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);

	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }

	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);

	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);

	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});

	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};

	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};

	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);

	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);

	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }

	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);

	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);

	var FontStyle = new FontStyleAttributor('font', 'font-family', config);

	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});

	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var History = function (_Module) {
	  _inherits(History, _Module);

	  function History(quill, options) {
	    _classCallCheck(this, History);

	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }

	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	      this.quill.selection.scrollIntoView();
	      this.stack[dest].push(delta);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);

	  return History;
	}(_module2.default);

	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};

	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}

	function getLastChangeIndex(delta) {
	  var deleteLength = delta.ops.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}

	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _clone = __webpack_require__(38);

	var _clone2 = _interopRequireDefault(_clone);

	var _deepEqual = __webpack_require__(22);

	var _deepEqual2 = _interopRequireDefault(_deepEqual);

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _op = __webpack_require__(26);

	var _op2 = _interopRequireDefault(_op);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:keyboard');

	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);

	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (!!binding.shortKey !== evt[SHORTKEY] && binding.shortKey !== null) return false;
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return key != SHORTKEY && !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);

	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);

	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, function (range, context) {
	      if (range.index === 0) return;

	      var _quill$scroll$line = this.quill.scroll.line(range.index);

	      var _quill$scroll$line2 = _slicedToArray(_quill$scroll$line, 1);

	      var line = _quill$scroll$line2[0];

	      var formats = {};
	      if (context.offset === 0) {
	        var curFormats = line.formats();
	        var prevFormats = this.quill.getFormat(range.index - 1, 1);
	        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	      }
	      this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      if (Object.keys(formats).length > 0) {
	        this.quill.formatLine(range.index - 1, 1, formats, _quill2.default.sources.USER);
	      }
	      this.quill.selection.scrollIntoView();
	    });
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^$/ }, function (range) {
	      if (range.index >= this.quill.getLength() - 1) return;
	      this.quill.deleteText(range.index, 1, _quill2.default.sources.USER);
	    });
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDelete);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDelete);
	    _this.listen();
	    return _this;
	  }

	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;

	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null) return; // implies we do not have focus

	        var _quill$scroll$line3 = _this2.quill.scroll.line(range.index);

	        var _quill$scroll$line4 = _slicedToArray(_quill$scroll$line3, 2);

	        var line = _quill$scroll$line4[0];
	        var offset = _quill$scroll$line4[1];

	        var _quill$scroll$leaf = _this2.quill.scroll.leaf(range.index);

	        var _quill$scroll$leaf2 = _slicedToArray(_quill$scroll$leaf, 2);

	        var leafStart = _quill$scroll$leaf2[0];
	        var offsetStart = _quill$scroll$leaf2[1];

	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.scroll.leaf(range.index + range.length);

	        var _ref2 = _slicedToArray(_ref, 2);

	        var leafEnd = _ref2[0];
	        var offsetEnd = _ref2[1];

	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);

	  return Keyboard;
	}(_module2.default);

	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};

	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      format: ['blockquote', 'indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.blockquote != null) {
	          this.quill.format('blockquote', false, _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range, context) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range, context) {
	        if (!context.collapsed) {
	          this.quill.scroll.deleteAt(range.index, range.length);
	        }
	        this.quill.insertText(range.index, '\t', _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range) {
	        this.quill.scroll.insertAt(range.index, '\n');
	        this.quill.formatText(range.index + 1, 1, 'header', false, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.selection.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^(1\.|-)$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	        this.quill.scroll.deleteAt(range.index - length, length);
	        this.quill.formatLine(range.index - length, 1, 'list', length === 1 ? 'bullet' : 'ordered', _quill2.default.sources.USER);
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    }
	  }
	};

	function handleDelete(range) {
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.selection.scrollIntoView();
	}

	function handleEnter(range, context) {
	  var _this3 = this;

	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  this.quill.selection.scrollIntoView();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}

	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;

	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index);

	      var _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2);

	      var block = _quill$scroll$descend2[0];
	      var offset = _quill$scroll$descend2[1];

	      if (block == null) return;
	      var scrollOffset = this.quill.scroll.offset(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollOffset + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}

	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}

	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  return binding;
	}

	exports.default = Keyboard;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _core = __webpack_require__(1);

	var _core2 = _interopRequireDefault(_core);

	var _align = __webpack_require__(45);

	var _direction = __webpack_require__(48);

	var _indent = __webpack_require__(54);

	var _blockquote = __webpack_require__(55);

	var _blockquote2 = _interopRequireDefault(_blockquote);

	var _header = __webpack_require__(56);

	var _header2 = _interopRequireDefault(_header);

	var _list = __webpack_require__(57);

	var _list2 = _interopRequireDefault(_list);

	var _background = __webpack_require__(46);

	var _color = __webpack_require__(47);

	var _font = __webpack_require__(49);

	var _size = __webpack_require__(50);

	var _bold = __webpack_require__(58);

	var _bold2 = _interopRequireDefault(_bold);

	var _italic = __webpack_require__(59);

	var _italic2 = _interopRequireDefault(_italic);

	var _link = __webpack_require__(60);

	var _link2 = _interopRequireDefault(_link);

	var _script = __webpack_require__(61);

	var _script2 = _interopRequireDefault(_script);

	var _strike = __webpack_require__(62);

	var _strike2 = _interopRequireDefault(_strike);

	var _underline = __webpack_require__(63);

	var _underline2 = _interopRequireDefault(_underline);

	var _image = __webpack_require__(64);

	var _image2 = _interopRequireDefault(_image);

	var _video = __webpack_require__(65);

	var _video2 = _interopRequireDefault(_video);

	var _code = __webpack_require__(31);

	var _code2 = _interopRequireDefault(_code);

	var _formula = __webpack_require__(66);

	var _formula2 = _interopRequireDefault(_formula);

	var _syntax = __webpack_require__(67);

	var _syntax2 = _interopRequireDefault(_syntax);

	var _toolbar = __webpack_require__(68);

	var _toolbar2 = _interopRequireDefault(_toolbar);

	var _icons = __webpack_require__(69);

	var _icons2 = _interopRequireDefault(_icons);

	var _picker = __webpack_require__(101);

	var _picker2 = _interopRequireDefault(_picker);

	var _colorPicker = __webpack_require__(103);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _iconPicker = __webpack_require__(104);

	var _iconPicker2 = _interopRequireDefault(_iconPicker);

	var _tooltip = __webpack_require__(105);

	var _tooltip2 = _interopRequireDefault(_tooltip);

	var _bubble = __webpack_require__(106);

	var _bubble2 = _interopRequireDefault(_bubble);

	var _snow = __webpack_require__(108);

	var _snow2 = _interopRequireDefault(_snow);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,

	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,

	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);

	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,

	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,

	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,

	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,

	  'formats/image': _image2.default,
	  'formats/video': _video2.default,

	  'formats/list/item': _list.ListItem,

	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,

	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,

	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);

	module.exports = _core2.default;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);

	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);

	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }

	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);

	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);

	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});

	exports.IndentClass = IndentClass;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);

	  function Blockquote() {
	    _classCallCheck(this, Blockquote);

	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }

	  return Blockquote;
	}(_block2.default);

	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';

	exports.default = Blockquote;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Header = function (_Block) {
	  _inherits(Header, _Block);

	  function Header() {
	    _classCallCheck(this, Header);

	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }

	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);

	  return Header;
	}(_block2.default);

	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

	exports.default = Header;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _block = __webpack_require__(32);

	var _block2 = _interopRequireDefault(_block);

	var _container = __webpack_require__(42);

	var _container2 = _interopRequireDefault(_container);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);

	  function ListItem() {
	    _classCallCheck(this, ListItem);

	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }

	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);

	  return ListItem;
	}(_block2.default);

	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';

	var List = function (_Container) {
	  _inherits(List, _Container);

	  function List() {
	    _classCallCheck(this, List);

	    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	  }

	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'ordered') {
	        value = 'OL';
	      } else if (value === 'bullet') {
	        value = 'UL';
	      }
	      return _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, value);
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') return 'bullet';
	      return undefined;
	    }
	  }]);

	  return List;
	}(_container2.default);

	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];

	exports.ListItem = ListItem;
	exports.default = List;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);

	  function Bold() {
	    _classCallCheck(this, Bold);

	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }

	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize() {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return true;
	    }
	  }]);

	  return Bold;
	}(_inline2.default);

	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];

	exports.default = Bold;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _bold = __webpack_require__(58);

	var _bold2 = _interopRequireDefault(_bold);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);

	  function Italic() {
	    _classCallCheck(this, Italic);

	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }

	  return Italic;
	}(_bold2.default);

	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];

	exports.default = Italic;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Link = function (_Inline) {
	  _inherits(Link, _Inline);

	  function Link() {
	    _classCallCheck(this, Link);

	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }

	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, ['http', 'https', 'mailto']) ? url : this.SANITIZED_URL;
	    }
	  }]);

	  return Link;
	}(_inline2.default);

	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';

	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}

	exports.default = Link;
	exports.sanitize = _sanitize;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Script = function (_Inline) {
	  _inherits(Script, _Inline);

	  function Script() {
	    _classCallCheck(this, Script);

	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }

	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);

	  return Script;
	}(_inline2.default);

	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];

	exports.default = Script;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);

	  function Strike() {
	    _classCallCheck(this, Strike);

	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }

	  return Strike;
	}(_inline2.default);

	Strike.blotName = 'strike';
	Strike.tagName = 'S';

	exports.default = Strike;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _inline = __webpack_require__(35);

	var _inline2 = _interopRequireDefault(_inline);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);

	  function Underline() {
	    _classCallCheck(this, Underline);

	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }

	  return Underline;
	}(_inline2.default);

	Underline.blotName = 'underline';
	Underline.tagName = 'U';

	exports.default = Underline;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _link = __webpack_require__(60);

	var _link2 = _interopRequireDefault(_link);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ATTRIBUTES = ['alt', 'height', 'width'];

	var Image = function (_Embed) {
	  _inherits(Image, _Embed);

	  function Image() {
	    _classCallCheck(this, Image);

	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }

	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);

	  return Image;
	}(_embed2.default);

	Image.blotName = 'image';
	Image.tagName = 'IMG';

	exports.default = Image;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _block = __webpack_require__(32);

	var _link = __webpack_require__(60);

	var _link2 = _interopRequireDefault(_link);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ATTRIBUTES = ['height', 'width'];

	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);

	  function Video() {
	    _classCallCheck(this, Video);

	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }

	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);

	  return Video;
	}(_block.BlockEmbed);

	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';

	exports.default = Video;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _embed = __webpack_require__(34);

	var _embed2 = _interopRequireDefault(_embed);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);

	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);

	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }

	  _createClass(FormulaBlot, [{
	    key: 'index',
	    value: function index(node, offset) {
	      return 1;
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        katex.render(value, node);
	        node.setAttribute('data-value', value);
	      }
	      node.setAttribute('contenteditable', false);
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);

	  return FormulaBlot;
	}(_embed2.default);

	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';

	function Formula() {
	  if (window.katex == null) {
	    throw new Error('Formula module requires KaTeX.');
	  }
	  _quill2.default.register(FormulaBlot, true);
	}

	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	var _code = __webpack_require__(31);

	var _code2 = _interopRequireDefault(_code);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);

	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);

	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }

	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      if (this.cachedHTML !== this.domNode.innerHTML) {
	        var text = this.domNode.textContent;
	        if (text.trim().length > 0 || this.cachedHTML == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.attach();
	        }
	        this.cachedHTML = this.domNode.innerHTML;
	      }
	    }
	  }]);

	  return SyntaxCodeBlock;
	}(_code2.default);

	SyntaxCodeBlock.className = 'ql-syntax';

	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});

	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);

	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);

	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    _quill2.default.register(CodeToken, true);
	    _quill2.default.register(SyntaxCodeBlock, true);
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      if (timer != null) return;
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, 100);
	    });
	    _this2.highlight();
	    return _this2;
	  }

	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;

	      if (this.quill.selection.composing) return;
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);

	  return Syntax;
	}(_module2.default);

	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }()
	};

	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _parchment = __webpack_require__(2);

	var _parchment2 = _interopRequireDefault(_parchment);

	var _quill = __webpack_require__(18);

	var _quill2 = _interopRequireDefault(_quill);

	var _logger = __webpack_require__(30);

	var _logger2 = _interopRequireDefault(_logger);

	var _module = __webpack_require__(39);

	var _module2 = _interopRequireDefault(_module);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var debug = (0, _logger2.default)('quill:toolbar');

	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);

	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);

	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;

	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange();

	      var _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1);

	      var range = _this$quill$selection2[0]; // quill.getSelection triggers update

	      _this.update(range);
	    });
	    return _this;
	  }

	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;

	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();

	        var _quill$selection$getR = _this2.quill.selection.getRange();

	        var _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1);

	        var range = _quill$selection$getR2[0];

	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _delta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2);

	        var format = _pair[0];
	        var input = _pair[1];

	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);

	  return Toolbar;
	}(_module2.default);

	Toolbar.DEFAULTS = {};

	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}

	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}

	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}

	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean(value) {
	      var _this3 = this;

	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    }
	  }
	};

	exports.default = Toolbar;
	exports.addControls = addControls;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  'align': {
	    '': __webpack_require__(70),
	    'center': __webpack_require__(71),
	    'right': __webpack_require__(72),
	    'justify': __webpack_require__(73)
	  },
	  'background': __webpack_require__(74),
	  'blockquote': __webpack_require__(75),
	  'bold': __webpack_require__(76),
	  'clean': __webpack_require__(77),
	  'code': __webpack_require__(78),
	  'code-block': __webpack_require__(78),
	  'color': __webpack_require__(79),
	  'direction': {
	    '': __webpack_require__(80),
	    'rtl': __webpack_require__(81)
	  },
	  'float': {
	    'center': __webpack_require__(82),
	    'full': __webpack_require__(83),
	    'left': __webpack_require__(84),
	    'right': __webpack_require__(85)
	  },
	  'formula': __webpack_require__(86),
	  'header': {
	    '1': __webpack_require__(87),
	    '2': __webpack_require__(88)
	  },
	  'italic': __webpack_require__(89),
	  'image': __webpack_require__(90),
	  'indent': {
	    '+1': __webpack_require__(91),
	    '-1': __webpack_require__(92)
	  },
	  'link': __webpack_require__(93),
	  'list': {
	    'ordered': __webpack_require__(94),
	    'bullet': __webpack_require__(95)
	  },
	  'script': {
	    'sub': __webpack_require__(96),
	    'super': __webpack_require__(97)
	  },
	  'strike': __webpack_require__(98),
	  'underline': __webpack_require__(99),
	  'video': __webpack_require__(100)
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=3 y1=4 y2=14></line> <line class=ql-stroke x1=11 x2=11 y1=4 y2=14></line> <line class=ql-stroke x1=11 x2=3 y1=9 y2=9></line> <line class=\"ql-stroke ql-thin\" x1=13.5 x2=15.5 y1=14.5 y2=14.5></line> <path class=ql-fill d=M14.5,15a0.5,0.5,0,0,1-.5-0.5V12.085l-0.276.138A0.5,0.5,0,0,1,13.053,12c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,15,11.5v3A0.5,0.5,0,0,1,14.5,15Z></path> </svg>";

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=3 y1=4 y2=14></line> <line class=ql-stroke x1=11 x2=11 y1=4 y2=14></line> <line class=ql-stroke x1=11 x2=3 y1=9 y2=9></line> <path class=\"ql-stroke ql-thin\" d=M15.5,14.5h-2c0-.234,1.85-1.076,1.85-2.234a0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ },
/* 94 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _dropdown = __webpack_require__(102);

	var _dropdown2 = _interopRequireDefault(_dropdown);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Picker = function () {
	  function Picker(select) {
	    var _this = this;

	    _classCallCheck(this, Picker);

	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	    this.label.addEventListener('click', function (event) {
	      _this.container.classList.toggle('ql-expanded');
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }

	  _createClass(Picker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;

	      var item = document.createElement('span');
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function (event) {
	        _this2.selectItem(item, true);
	      });
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;

	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.hasAttribute('selected')) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;

	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item != null) {
	        item.classList.add('ql-selected');
	        this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	        if (item.hasAttribute('data-value')) {
	          this.label.setAttribute('data-value', item.getAttribute('data-value'));
	        } else {
	          this.label.removeAttribute('data-value');
	        }
	        if (item.hasAttribute('data-label')) {
	          this.label.setAttribute('data-label', item.getAttribute('data-label'));
	        } else {
	          this.label.removeAttribute('data-label');
	        }
	        if (trigger) {
	          if (typeof Event === 'function') {
	            this.select.dispatchEvent(new Event('change'));
	          } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	            // IE11
	            var event = document.createEvent('Event');
	            event.initEvent('change', true, true);
	            this.select.dispatchEvent(event);
	          }
	          this.close();
	        }
	      } else {
	        this.label.removeAttribute('data-value');
	        this.label.removeAttribute('data-label');
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);

	  return Picker;
	}();

	exports.default = Picker;

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _picker = __webpack_require__(101);

	var _picker2 = _interopRequireDefault(_picker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);

	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);

	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }

	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);

	  return ColorPicker;
	}(_picker2.default);

	exports.default = ColorPicker;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _picker = __webpack_require__(101);

	var _picker2 = _interopRequireDefault(_picker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);

	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);

	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }

	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);

	  return IconPicker;
	}(_picker2.default);

	exports.default = IconPicker;

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;

	    _classCallCheck(this, Tooltip);

	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    var offset = parseInt(window.getComputedStyle(this.root).marginTop);
	    this.quill.root.addEventListener('scroll', function () {
	      _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + offset + 'px';
	      _this.checkBounds();
	    });
	    this.hide();
	  }

	  _createClass(Tooltip, [{
	    key: 'checkBounds',
	    value: function checkBounds() {
	      this.root.classList.toggle('ql-out-top', this.root.offsetTop <= 0);
	      this.root.classList.remove('ql-out-bottom');
	      this.root.classList.toggle('ql-out-bottom', this.root.offsetTop + this.root.offsetHeight >= this.quill.root.offsetHeight);
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      this.checkBounds();
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);

	  return Tooltip;
	}();

	exports.default = Tooltip;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _keyboard = __webpack_require__(52);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	var _base = __webpack_require__(107);

	var _base2 = _interopRequireDefault(_base);

	var _icons = __webpack_require__(69);

	var _icons2 = _interopRequireDefault(_icons);

	var _selection = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);

	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);

	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }

	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }

	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')));
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')));
	    }
	  }]);

	  return BubbleTheme;
	}(_base2.default);

	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});

	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);

	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);

	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.scroll.lines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = lastLine.offset(_this2.quill.scroll);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }

	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;

	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function (event) {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      if (shift === 0) return shift;
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);

	  return BubbleTooltip;
	}(_base.BaseTooltip);

	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

	exports.default = BubbleTheme;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _delta = __webpack_require__(20);

	var _delta2 = _interopRequireDefault(_delta);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _keyboard = __webpack_require__(52);

	var _keyboard2 = _interopRequireDefault(_keyboard);

	var _theme = __webpack_require__(41);

	var _theme2 = _interopRequireDefault(_theme);

	var _colorPicker = __webpack_require__(103);

	var _colorPicker2 = _interopRequireDefault(_colorPicker);

	var _iconPicker = __webpack_require__(104);

	var _iconPicker2 = _interopRequireDefault(_iconPicker);

	var _picker = __webpack_require__(101);

	var _picker2 = _interopRequireDefault(_picker);

	var _tooltip = __webpack_require__(105);

	var _tooltip2 = _interopRequireDefault(_tooltip);

	var _icons = __webpack_require__(69);

	var _icons2 = _interopRequireDefault(_icons);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ALIGNS = [false, 'center', 'right', 'justify'];

	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

	var FONTS = [false, 'serif', 'monospace'];

	var HEADERS = ['1', '2', '3', false];

	var SIZES = ['small', false, 'large', 'huge'];

	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);

	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);

	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    document.body.addEventListener('click', listener);
	    return _this;
	  }

	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (_icons2.default[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = _icons2.default[name][''] + _icons2.default[name]['rtl'];
	          } else if (typeof _icons2.default[name] === 'string') {
	            button.innerHTML = _icons2.default[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && _icons2.default[name][value]) {
	              button.innerHTML = _icons2.default[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects) {
	      var _this2 = this;

	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, _icons2.default.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, _icons2.default[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, update).on(_emitter2.default.events.SCROLL_OPTIMIZE, update);
	    }
	  }]);

	  return BaseTheme;
	}(_theme2.default);

	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula(value) {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image(value) {
	          var _this3 = this;

	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/*');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _delta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video(value) {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});

	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);

	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);

	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }

	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;

	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.root.scrollTop;
	      this.quill.focus();
	      this.quill.root.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          var scrollTop = this.quill.root.scrollTop;
	          if (this.linkRange) {
	            this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	            delete this.linkRange;
	          } else {
	            this.restoreFocus();
	            this.quill.format('link', value, _emitter2.default.sources.USER);
	          }
	          this.quill.root.scrollTop = scrollTop;
	          break;
	        case 'video':
	          var match = value.match(/^(https?):\/\/(www\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || value.match(/^(https?):\/\/(www\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	          if (match) {
	            value = match[1] + '://www.youtube.com/embed/' + match[3] + '?showinfo=0';
	          } else if (match = value.match(/^(https?):\/\/(www\.)?vimeo\.com\/(\d+)/)) {
	            value = match[1] + '://player.vimeo.com/video/' + match[3] + '/';
	          }
	        // fallthrough
	        case 'formula':
	          var range = this.quill.getSelection(true);
	          var index = range.index + range.length;
	          if (range != null) {
	            this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	            if (this.root.getAttribute('data-mode') === 'formula') {
	              this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	            }
	            this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	          }
	          break;
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);

	  return BaseTooltip;
	}(_tooltip2.default);

	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}

	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extend = __webpack_require__(25);

	var _extend2 = _interopRequireDefault(_extend);

	var _emitter = __webpack_require__(28);

	var _emitter2 = _interopRequireDefault(_emitter);

	var _base = __webpack_require__(107);

	var _base2 = _interopRequireDefault(_base);

	var _link = __webpack_require__(60);

	var _link2 = _interopRequireDefault(_link);

	var _picker = __webpack_require__(101);

	var _picker2 = _interopRequireDefault(_picker);

	var _selection = __webpack_require__(40);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);

	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);

	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }

	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }

	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')));
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')));
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);

	  return SnowTheme;
	}(_base2.default);

	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});

	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);

	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);

	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }

	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;

	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          _this3.restoreFocus();
	          _this3.quill.formatText(_this3.linkRange, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range) {
	        if (range == null) return;
	        if (range.length === 0) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index);

	          var _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2);

	          var link = _quill$scroll$descend2[0];
	          var offset = _quill$scroll$descend2[1];

	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);

	  return SnowTooltip;
	}(_base.BaseTooltip);

	SnowTooltip.TEMPLATE = ['<a class="ql-preview" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

	exports.default = SnowTheme;

/***/ }
/******/ ])
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1446).Buffer))

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1447)
var ieee754 = __webpack_require__(1448)
var isArray = __webpack_require__(893)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Spectrum Colorpicker v1.8.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

(function (factory) {
    "use strict";

    if (true) { // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(137)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
        module.exports = factory(require('jquery'));
    }
    else { // Browser
        factory(jQuery);
    }
})(function($, undefined) {
    "use strict";

    var defaultOpts = {

        // Callbacks
        beforeShow: noop,
        move: noop,
        change: noop,
        show: noop,
        hide: noop,

        // Options
        color: false,
        flat: false,
        showInput: false,
        allowEmpty: false,
        showButtons: true,
        clickoutFiresChange: true,
        showInitial: false,
        showPalette: false,
        showPaletteOnly: false,
        hideAfterPaletteSelect: false,
        togglePaletteOnly: false,
        showSelectionPalette: true,
        localStorageKey: false,
        appendTo: "body",
        maxSelectionSize: 7,
        cancelText: "cancel",
        chooseText: "choose",
        togglePaletteMoreText: "more",
        togglePaletteLessText: "less",
        clearText: "Clear Color Selection",
        noColorSelectedText: "No Color Selected",
        preferredFormat: false,
        className: "", // Deprecated - use containerClassName and replacerClassName instead.
        containerClassName: "",
        replacerClassName: "",
        showAlpha: false,
        theme: "sp-light",
        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
        selectionPalette: [],
        disabled: false,
        offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
        function contains( str, substr ) {
            return !!~('' + str).indexOf(substr);
        }

        var elem = document.createElement('div');
        var style = elem.style;
        style.cssText = 'background-color:rgba(0,0,0,.5)';
        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    replaceInput = [
        "<div class='sp-replacer'>",
            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
            "<div class='sp-dd'>&#9660;</div>",
        "</div>"
    ].join(''),
    markup = (function () {

        // IE does not support gradients with multiple stops, so we need to simulate
        //  that for the rainbow slider with 8 divs that each have a single gradient
        var gradientFix = "";
        if (IE) {
            for (var i = 1; i <= 6; i++) {
                gradientFix += "<div class='sp-" + i + "'></div>";
            }
        }

        return [
            "<div class='sp-container sp-hidden'>",
                "<div class='sp-palette-container'>",
                    "<div class='sp-palette sp-thumb sp-cf'></div>",
                    "<div class='sp-palette-button-container sp-cf'>",
                        "<button type='button' class='sp-palette-toggle'></button>",
                    "</div>",
                "</div>",
                "<div class='sp-picker-container'>",
                    "<div class='sp-top sp-cf'>",
                        "<div class='sp-fill'></div>",
                        "<div class='sp-top-inner'>",
                            "<div class='sp-color'>",
                                "<div class='sp-sat'>",
                                    "<div class='sp-val'>",
                                        "<div class='sp-dragger'></div>",
                                    "</div>",
                                "</div>",
                            "</div>",
                            "<div class='sp-clear sp-clear-display'>",
                            "</div>",
                            "<div class='sp-hue'>",
                                "<div class='sp-slider'></div>",
                                gradientFix,
                            "</div>",
                        "</div>",
                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                    "</div>",
                    "<div class='sp-input-container sp-cf'>",
                        "<input class='sp-input' type='text' spellcheck='false'  />",
                    "</div>",
                    "<div class='sp-initial sp-thumb sp-cf'></div>",
                    "<div class='sp-button-container sp-cf'>",
                        "<a class='sp-cancel' href='#'></a>",
                        "<button type='button' class='sp-choose'></button>",
                    "</div>",
                "</div>",
            "</div>"
        ].join("");
    })();

    function paletteTemplate (p, color, className, opts) {
        var html = [];
        for (var i = 0; i < p.length; i++) {
            var current = p[i];
            if(current) {
                var tiny = tinycolor(current);
                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
            } else {
                var cls = 'sp-clear-display';
                html.push($('<div />')
                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
                        .attr('title', opts.noColorSelectedText)
                    )
                    .html()
                );
            }
        }
        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
    }

    function hideAll() {
        for (var i = 0; i < spectrums.length; i++) {
            if (spectrums[i]) {
                spectrums[i].hide();
            }
        }
    }

    function instanceOptions(o, callbackContext) {
        var opts = $.extend({}, defaultOpts, o);
        opts.callbacks = {
            'move': bind(opts.move, callbackContext),
            'change': bind(opts.change, callbackContext),
            'show': bind(opts.show, callbackContext),
            'hide': bind(opts.hide, callbackContext),
            'beforeShow': bind(opts.beforeShow, callbackContext)
        };

        return opts;
    }

    function spectrum(element, o) {

        var opts = instanceOptions(o, element),
            flat = opts.flat,
            showSelectionPalette = opts.showSelectionPalette,
            localStorageKey = opts.localStorageKey,
            theme = opts.theme,
            callbacks = opts.callbacks,
            resize = throttle(reflow, 10),
            visible = false,
            isDragging = false,
            dragWidth = 0,
            dragHeight = 0,
            dragHelperHeight = 0,
            slideHeight = 0,
            slideWidth = 0,
            alphaWidth = 0,
            alphaSlideHelperWidth = 0,
            slideHelperHeight = 0,
            currentHue = 0,
            currentSaturation = 0,
            currentValue = 0,
            currentAlpha = 1,
            palette = [],
            paletteArray = [],
            paletteLookup = {},
            selectionPalette = opts.selectionPalette.slice(0),
            maxSelectionSize = opts.maxSelectionSize,
            draggingClass = "sp-dragging",
            shiftMovementDirection = null;

        var doc = element.ownerDocument,
            body = doc.body,
            boundElement = $(element),
            disabled = false,
            container = $(markup, doc).addClass(theme),
            pickerContainer = container.find(".sp-picker-container"),
            dragger = container.find(".sp-color"),
            dragHelper = container.find(".sp-dragger"),
            slider = container.find(".sp-hue"),
            slideHelper = container.find(".sp-slider"),
            alphaSliderInner = container.find(".sp-alpha-inner"),
            alphaSlider = container.find(".sp-alpha"),
            alphaSlideHelper = container.find(".sp-alpha-handle"),
            textInput = container.find(".sp-input"),
            paletteContainer = container.find(".sp-palette"),
            initialColorContainer = container.find(".sp-initial"),
            cancelButton = container.find(".sp-cancel"),
            clearButton = container.find(".sp-clear"),
            chooseButton = container.find(".sp-choose"),
            toggleButton = container.find(".sp-palette-toggle"),
            isInput = boundElement.is("input"),
            isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
            shouldReplace = isInput && !flat,
            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
            offsetElement = (shouldReplace) ? replacer : boundElement,
            previewElement = replacer.find(".sp-preview-inner"),
            initialColor = opts.color || (isInput && boundElement.val()),
            colorOnShow = false,
            currentPreferredFormat = opts.preferredFormat,
            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
            isEmpty = !initialColor,
            allowEmpty = opts.allowEmpty && !isInputTypeColor;

        function applyOptions() {

            if (opts.showPaletteOnly) {
                opts.showPalette = true;
            }

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

            if (opts.palette) {
                palette = opts.palette.slice(0);
                paletteArray = $.isArray(palette[0]) ? palette : [palette];
                paletteLookup = {};
                for (var i = 0; i < paletteArray.length; i++) {
                    for (var j = 0; j < paletteArray[i].length; j++) {
                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                        paletteLookup[rgb] = true;
                    }
                }
            }

            container.toggleClass("sp-flat", flat);
            container.toggleClass("sp-input-disabled", !opts.showInput);
            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
            container.toggleClass("sp-clear-enabled", allowEmpty);
            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
            container.toggleClass("sp-palette-disabled", !opts.showPalette);
            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
            container.toggleClass("sp-initial-disabled", !opts.showInitial);
            container.addClass(opts.className).addClass(opts.containerClassName);

            reflow();
        }

        function initialize() {

            if (IE) {
                container.find("*:not(input)").attr("unselectable", "on");
            }

            applyOptions();

            if (shouldReplace) {
                boundElement.after(replacer).hide();
            }

            if (!allowEmpty) {
                clearButton.hide();
            }

            if (flat) {
                boundElement.after(container).hide();
            }
            else {

                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
                if (appendTo.length !== 1) {
                    appendTo = $("body");
                }

                appendTo.append(container);
            }

            updateSelectionPaletteFromStorage();

            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
                if (!disabled) {
                    toggle();
                }

                e.stopPropagation();

                if (!$(e.target).is("input")) {
                    e.preventDefault();
                }
            });

            if(boundElement.is(":disabled") || (opts.disabled === true)) {
                disable();
            }

            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
            container.click(stopPropagation);

            // Handle user typed input
            textInput.change(setFromTextInput);
            textInput.bind("paste", function () {
                setTimeout(setFromTextInput, 1);
            });
            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

            cancelButton.text(opts.cancelText);
            cancelButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                revert();
                hide();
            });

            clearButton.attr("title", opts.clearText);
            clearButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                isEmpty = true;
                move();

                if(flat) {
                    //for the flat style, this is a change event
                    updateOriginalInput(true);
                }
            });

            chooseButton.text(opts.chooseText);
            chooseButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                if (IE && textInput.is(":focus")) {
                    textInput.trigger('change');
                }

                if (isValid()) {
                    updateOriginalInput(true);
                    hide();
                }
            });

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
            toggleButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                opts.showPaletteOnly = !opts.showPaletteOnly;

                // To make sure the Picker area is drawn on the right, next to the
                // Palette area (and not below the palette), first move the Palette
                // to the left to make space for the picker, plus 5px extra.
                // The 'applyOptions' function puts the whole container back into place
                // and takes care of the button-text and the sp-palette-only CSS class.
                if (!opts.showPaletteOnly && !flat) {
                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
                }
                applyOptions();
            });

            draggable(alphaSlider, function (dragX, dragY, e) {
                currentAlpha = (dragX / alphaWidth);
                isEmpty = false;
                if (e.shiftKey) {
                    currentAlpha = Math.round(currentAlpha * 10) / 10;
                }

                move();
            }, dragStart, dragStop);

            draggable(slider, function (dragX, dragY) {
                currentHue = parseFloat(dragY / slideHeight);
                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }
                move();
            }, dragStart, dragStop);

            draggable(dragger, function (dragX, dragY, e) {

                // shift+drag should snap the movement to either the x or y axis.
                if (!e.shiftKey) {
                    shiftMovementDirection = null;
                }
                else if (!shiftMovementDirection) {
                    var oldDragX = currentSaturation * dragWidth;
                    var oldDragY = dragHeight - (currentValue * dragHeight);
                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                    shiftMovementDirection = furtherFromX ? "x" : "y";
                }

                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

                if (setSaturation) {
                    currentSaturation = parseFloat(dragX / dragWidth);
                }
                if (setValue) {
                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
                }

                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }

                move();

            }, dragStart, dragStop);

            if (!!initialColor) {
                set(initialColor);

                // In case color was black - update the preview UI and set the format
                // since the set function will not run (default color is black).
                updateUI();
                currentPreferredFormat = opts.preferredFormat || tinycolor(initialColor).format;

                addColorToSelectionPalette(initialColor);
            }
            else {
                updateUI();
            }

            if (flat) {
                show();
            }

            function paletteElementClick(e) {
                if (e.data && e.data.ignore) {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                }
                else {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                    updateOriginalInput(true);
                    if (opts.hideAfterPaletteSelect) {
                      hide();
                    }
                }

                return false;
            }

            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
        }

        function updateSelectionPaletteFromStorage() {

            if (localStorageKey && window.localStorage) {

                // Migrate old palettes over to new format.  May want to remove this eventually.
                try {
                    var oldPalette = window.localStorage[localStorageKey].split(",#");
                    if (oldPalette.length > 1) {
                        delete window.localStorage[localStorageKey];
                        $.each(oldPalette, function(i, c) {
                             addColorToSelectionPalette(c);
                        });
                    }
                }
                catch(e) { }

                try {
                    selectionPalette = window.localStorage[localStorageKey].split(";");
                }
                catch (e) { }
            }
        }

        function addColorToSelectionPalette(color) {
            if (showSelectionPalette) {
                var rgb = tinycolor(color).toRgbString();
                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                    selectionPalette.push(rgb);
                    while(selectionPalette.length > maxSelectionSize) {
                        selectionPalette.shift();
                    }
                }

                if (localStorageKey && window.localStorage) {
                    try {
                        window.localStorage[localStorageKey] = selectionPalette.join(";");
                    }
                    catch(e) { }
                }
            }
        }

        function getUniqueSelectionPalette() {
            var unique = [];
            if (opts.showPalette) {
                for (var i = 0; i < selectionPalette.length; i++) {
                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

                    if (!paletteLookup[rgb]) {
                        unique.push(selectionPalette[i]);
                    }
                }
            }

            return unique.reverse().slice(0, opts.maxSelectionSize);
        }

        function drawPalette() {

            var currentColor = get();

            var html = $.map(paletteArray, function (palette, i) {
                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
            });

            updateSelectionPaletteFromStorage();

            if (selectionPalette) {
                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
            }

            paletteContainer.html(html.join(""));
        }

        function drawInitial() {
            if (opts.showInitial) {
                var initial = colorOnShow;
                var current = get();
                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
            }
        }

        function dragStart() {
            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
                reflow();
            }
            isDragging = true;
            container.addClass(draggingClass);
            shiftMovementDirection = null;
            boundElement.trigger('dragstart.spectrum', [ get() ]);
        }

        function dragStop() {
            isDragging = false;
            container.removeClass(draggingClass);
            boundElement.trigger('dragstop.spectrum', [ get() ]);
        }

        function setFromTextInput() {

            var value = textInput.val();

            if ((value === null || value === "") && allowEmpty) {
                set(null);
                updateOriginalInput(true);
            }
            else {
                var tiny = tinycolor(value);
                if (tiny.isValid()) {
                    set(tiny);
                    updateOriginalInput(true);
                }
                else {
                    textInput.addClass("sp-validation-error");
                }
            }
        }

        function toggle() {
            if (visible) {
                hide();
            }
            else {
                show();
            }
        }

        function show() {
            var event = $.Event('beforeShow.spectrum');

            if (visible) {
                reflow();
                return;
            }

            boundElement.trigger(event, [ get() ]);

            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
                return;
            }

            hideAll();
            visible = true;

            $(doc).bind("keydown.spectrum", onkeydown);
            $(doc).bind("click.spectrum", clickout);
            $(window).bind("resize.spectrum", resize);
            replacer.addClass("sp-active");
            container.removeClass("sp-hidden");

            reflow();
            updateUI();

            colorOnShow = get();

            drawInitial();
            callbacks.show(colorOnShow);
            boundElement.trigger('show.spectrum', [ colorOnShow ]);
        }

        function onkeydown(e) {
            // Close on ESC
            if (e.keyCode === 27) {
                hide();
            }
        }

        function clickout(e) {
            // Return on right click.
            if (e.button == 2) { return; }

            // If a drag event was happening during the mouseup, don't hide
            // on click.
            if (isDragging) { return; }

            if (clickoutFiresChange) {
                updateOriginalInput(true);
            }
            else {
                revert();
            }
            hide();
        }

        function hide() {
            // Return if hiding is unnecessary
            if (!visible || flat) { return; }
            visible = false;

            $(doc).unbind("keydown.spectrum", onkeydown);
            $(doc).unbind("click.spectrum", clickout);
            $(window).unbind("resize.spectrum", resize);

            replacer.removeClass("sp-active");
            container.addClass("sp-hidden");

            callbacks.hide(get());
            boundElement.trigger('hide.spectrum', [ get() ]);
        }

        function revert() {
            set(colorOnShow, true);
        }

        function set(color, ignoreFormatChange) {
            if (tinycolor.equals(color, get())) {
                // Update UI just in case a validation error needs
                // to be cleared.
                updateUI();
                return;
            }

            var newColor, newHsv;
            if (!color && allowEmpty) {
                isEmpty = true;
            } else {
                isEmpty = false;
                newColor = tinycolor(color);
                newHsv = newColor.toHsv();

                currentHue = (newHsv.h % 360) / 360;
                currentSaturation = newHsv.s;
                currentValue = newHsv.v;
                currentAlpha = newHsv.a;
            }
            updateUI();

            if (newColor && newColor.isValid() && !ignoreFormatChange) {
                currentPreferredFormat = opts.preferredFormat || newColor.getFormat();
            }
        }

        function get(opts) {
            opts = opts || { };

            if (allowEmpty && isEmpty) {
                return null;
            }

            return tinycolor.fromRatio({
                h: currentHue,
                s: currentSaturation,
                v: currentValue,
                a: Math.round(currentAlpha * 100) / 100
            }, { format: opts.format || currentPreferredFormat });
        }

        function isValid() {
            return !textInput.hasClass("sp-validation-error");
        }

        function move() {
            updateUI();

            callbacks.move(get());
            boundElement.trigger('move.spectrum', [ get() ]);
        }

        function updateUI() {

            textInput.removeClass("sp-validation-error");

            updateHelperLocations();

            // Update dragger background color (gradients take care of saturation and value).
            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
            dragger.css("background-color", flatColor.toHexString());

            // Get a format that alpha will be included in (hex and names ignore alpha)
            var format = currentPreferredFormat;
            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                    format = "rgb";
                }
            }

            var realColor = get({ format: format }),
                displayColor = '';

             //reset background info for preview element
            previewElement.removeClass("sp-clear-display");
            previewElement.css('background-color', 'transparent');

            if (!realColor && allowEmpty) {
                // Update the replaced elements background with icon indicating no color selection
                previewElement.addClass("sp-clear-display");
            }
            else {
                var realHex = realColor.toHexString(),
                    realRgb = realColor.toRgbString();

                // Update the replaced elements background color (with actual selected color)
                if (rgbaSupport || realColor.alpha === 1) {
                    previewElement.css("background-color", realRgb);
                }
                else {
                    previewElement.css("background-color", "transparent");
                    previewElement.css("filter", realColor.toFilter());
                }

                if (opts.showAlpha) {
                    var rgb = realColor.toRgb();
                    rgb.a = 0;
                    var realAlpha = tinycolor(rgb).toRgbString();
                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                    if (IE) {
                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                    }
                    else {
                        alphaSliderInner.css("background", "-webkit-" + gradient);
                        alphaSliderInner.css("background", "-moz-" + gradient);
                        alphaSliderInner.css("background", "-ms-" + gradient);
                        // Use current syntax gradient on unprefixed property.
                        alphaSliderInner.css("background",
                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                    }
                }

                displayColor = realColor.toString(format);
            }

            // Update the text entry input as it changes happen
            if (opts.showInput) {
                textInput.val(displayColor);
            }

            if (opts.showPalette) {
                drawPalette();
            }

            drawInitial();
        }

        function updateHelperLocations() {
            var s = currentSaturation;
            var v = currentValue;

            if(allowEmpty && isEmpty) {
                //if selected color is empty, hide the helpers
                alphaSlideHelper.hide();
                slideHelper.hide();
                dragHelper.hide();
            }
            else {
                //make sure helpers are visible
                alphaSlideHelper.show();
                slideHelper.show();
                dragHelper.show();

                // Where to show the little circle in that displays your current selected color
                var dragX = s * dragWidth;
                var dragY = dragHeight - (v * dragHeight);
                dragX = Math.max(
                    -dragHelperHeight,
                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
                );
                dragY = Math.max(
                    -dragHelperHeight,
                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
                );
                dragHelper.css({
                    "top": dragY + "px",
                    "left": dragX + "px"
                });

                var alphaX = currentAlpha * alphaWidth;
                alphaSlideHelper.css({
                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
                });

                // Where to show the bar that displays your current selected hue
                var slideY = (currentHue) * slideHeight;
                slideHelper.css({
                    "top": (slideY - slideHelperHeight) + "px"
                });
            }
        }

        function updateOriginalInput(fireCallback) {
            var color = get(),
                displayColor = '',
                hasChanged = !tinycolor.equals(color, colorOnShow);

            if (color) {
                displayColor = color.toString(currentPreferredFormat);
                // Update the selection palette with the current color
                addColorToSelectionPalette(color);
            }

            if (isInput) {
                boundElement.val(displayColor);
            }

            if (fireCallback && hasChanged) {
                callbacks.change(color);
                boundElement.trigger('change', [ color ]);
            }
        }

        function reflow() {
            if (!visible) {
                return; // Calculations would be useless and wouldn't be reliable anyways
            }
            dragWidth = dragger.width();
            dragHeight = dragger.height();
            dragHelperHeight = dragHelper.height();
            slideWidth = slider.width();
            slideHeight = slider.height();
            slideHelperHeight = slideHelper.height();
            alphaWidth = alphaSlider.width();
            alphaSlideHelperWidth = alphaSlideHelper.width();

            if (!flat) {
                container.css("position", "absolute");
                if (opts.offset) {
                    container.offset(opts.offset);
                } else {
                    container.offset(getOffset(container, offsetElement));
                }
            }

            updateHelperLocations();

            if (opts.showPalette) {
                drawPalette();
            }

            boundElement.trigger('reflow.spectrum');
        }

        function destroy() {
            boundElement.show();
            offsetElement.unbind("click.spectrum touchstart.spectrum");
            container.remove();
            replacer.remove();
            spectrums[spect.id] = null;
        }

        function option(optionName, optionValue) {
            if (optionName === undefined) {
                return $.extend({}, opts);
            }
            if (optionValue === undefined) {
                return opts[optionName];
            }

            opts[optionName] = optionValue;

            if (optionName === "preferredFormat") {
                currentPreferredFormat = opts.preferredFormat;
            }
            applyOptions();
        }

        function enable() {
            disabled = false;
            boundElement.attr("disabled", false);
            offsetElement.removeClass("sp-disabled");
        }

        function disable() {
            hide();
            disabled = true;
            boundElement.attr("disabled", true);
            offsetElement.addClass("sp-disabled");
        }

        function setOffset(coord) {
            opts.offset = coord;
            reflow();
        }

        initialize();

        var spect = {
            show: show,
            hide: hide,
            toggle: toggle,
            reflow: reflow,
            option: option,
            enable: enable,
            disable: disable,
            offset: setOffset,
            set: function (c) {
                set(c);
                updateOriginalInput();
            },
            get: get,
            destroy: destroy,
            container: container
        };

        spect.id = spectrums.push(spect) - 1;

        return spect;
    }

    /**
    * checkOffset - get the offset below/above and left/right element depending on screen position
    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
    */
    function getOffset(picker, input) {
        var extraY = 0;
        var dpWidth = picker.outerWidth();
        var dpHeight = picker.outerHeight();
        var inputHeight = input.outerHeight();
        var doc = picker[0].ownerDocument;
        var docElem = doc.documentElement;
        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
        var offset = input.offset();
        offset.top += inputHeight;

        offset.left -=
            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
            Math.abs(offset.left + dpWidth - viewWidth) : 0);

        offset.top -=
            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
            Math.abs(dpHeight + inputHeight - extraY) : extraY));

        return offset;
    }

    /**
    * noop - do nothing
    */
    function noop() {

    }

    /**
    * stopPropagation - makes the code only doing this a little easier to read in line
    */
    function stopPropagation(e) {
        e.stopPropagation();
    }

    /**
    * Create a function bound to a given object
    * Thanks to underscore.js
    */
    function bind(func, obj) {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments, 2);
        return function () {
            return func.apply(obj, args.concat(slice.call(arguments)));
        };
    }

    /**
    * Lightweight drag helper.  Handles containment within the element, so that
    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
    */
    function draggable(element, onmove, onstart, onstop) {
        onmove = onmove || function () { };
        onstart = onstart || function () { };
        onstop = onstop || function () { };
        var doc = document;
        var dragging = false;
        var offset = {};
        var maxHeight = 0;
        var maxWidth = 0;
        var hasTouch = ('ontouchstart' in window);

        var duringDragEvents = {};
        duringDragEvents["selectstart"] = prevent;
        duringDragEvents["dragstart"] = prevent;
        duringDragEvents["touchmove mousemove"] = move;
        duringDragEvents["touchend mouseup"] = stop;

        function prevent(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        function move(e) {
            if (dragging) {
                // Mouseup happened outside of window
                if (IE && doc.documentMode < 9 && !e.button) {
                    return stop();
                }

                var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
                var pageX = t0 && t0.pageX || e.pageX;
                var pageY = t0 && t0.pageY || e.pageY;

                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

                if (hasTouch) {
                    // Stop scrolling in iOS
                    prevent(e);
                }

                onmove.apply(element, [dragX, dragY, e]);
            }
        }

        function start(e) {
            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

            if (!rightclick && !dragging) {
                if (onstart.apply(element, arguments) !== false) {
                    dragging = true;
                    maxHeight = $(element).height();
                    maxWidth = $(element).width();
                    offset = $(element).offset();

                    $(doc).bind(duringDragEvents);
                    $(doc.body).addClass("sp-dragging");

                    move(e);

                    prevent(e);
                }
            }
        }

        function stop() {
            if (dragging) {
                $(doc).unbind(duringDragEvents);
                $(doc.body).removeClass("sp-dragging");

                // Wait a tick before notifying observers to allow the click event
                // to fire in Chrome.
                setTimeout(function() {
                    onstop.apply(element, arguments);
                }, 0);
            }
            dragging = false;
        }

        $(element).bind("touchstart mousedown", start);
    }

    function throttle(func, wait, debounce) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var throttler = function () {
                timeout = null;
                func.apply(context, args);
            };
            if (debounce) clearTimeout(timeout);
            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
        };
    }

    function inputTypeColorSupport() {
        return $.fn.spectrum.inputTypeColorSupport();
    }

    /**
    * Define a jQuery plugin
    */
    var dataID = "spectrum.id";
    $.fn.spectrum = function (opts, extra) {

        if (typeof opts == "string") {

            var returnValue = this;
            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function () {
                var spect = spectrums[$(this).data(dataID)];
                if (spect) {
                    var method = spect[opts];
                    if (!method) {
                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
                    }

                    if (opts == "get") {
                        returnValue = spect.get();
                    }
                    else if (opts == "container") {
                        returnValue = spect.container;
                    }
                    else if (opts == "option") {
                        returnValue = spect.option.apply(spect, args);
                    }
                    else if (opts == "destroy") {
                        spect.destroy();
                        $(this).removeData(dataID);
                    }
                    else {
                        method.apply(spect, args);
                    }
                }
            });

            return returnValue;
        }

        // Initializing a new instance of spectrum
        return this.spectrum("destroy").each(function () {
            var options = $.extend({}, opts, $(this).data());
            var spect = spectrum(this, options);
            $(this).data(dataID, spect.id);
        });
    };

    $.fn.spectrum.load = true;
    $.fn.spectrum.loadOpts = {};
    $.fn.spectrum.draggable = draggable;
    $.fn.spectrum.defaults = defaultOpts;
    $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
        if (typeof inputTypeColorSupport._cachedResult === "undefined") {
            var colorInput = $("<input type='color'/>")[0]; // if color element is supported, value will default to not null
            inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "";
        }
        return inputTypeColorSupport._cachedResult;
    };

    $.spectrum = { };
    $.spectrum.localization = { };
    $.spectrum.palettes = { };

    $.fn.spectrum.processNativeColorInputs = function () {
        var colorInputs = $("input[type=color]");
        if (colorInputs.length && !inputTypeColorSupport()) {
            colorInputs.spectrum({
                preferredFormat: "hex6"
            });
        }
    };

    // TinyColor v1.1.2
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License

    (function() {

    var trimLeft = /^[\s,#]+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        math = Math,
        mathRound = math.round,
        mathMin = math.min,
        mathMax = math.max,
        mathRandom = math.random;

    var tinycolor = function(color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
           return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
        this._r = rgb.r,
        this._g = rgb.g,
        this._b = rgb.b,
        this._a = rgb.a,
        this._roundA = mathRound(100*this._a) / 100,
        this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
              "hsv("  + h + ", " + s + "%, " + v + "%)" :
              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
              "hsl("  + h + ", " + s + "%, " + l + "%)" :
              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function() {
            return rgbaToHex(this._r, this._g, this._b, this._a);
        },
        toHex8String: function() {
            return '#' + this.toHex8();
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = s.toHex8String();
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                color.s = convertToPercentage(color.s);
                color.v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, color.s, color.v);
                ok = true;
                format = "hsv";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                color.s = convertToPercentage(color.s);
                color.l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, color.s, color.l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
     function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        function rgbaToHex(r, g, b, a) {

            var hex = [
                pad2(convertDecimalToHex(a)),
                pad2(mathRound(r).toString(16)),
                pad2(mathRound(g).toString(16)),
                pad2(mathRound(b).toString(16))
            ];

            return hex.join("");
        }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (mathRound(hsl.h) + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;
        var w = p * 2 - 1;
        var a = rgb2.a - rgb1.a;

        var w1;

        if (w * a == -1) {
            w1 = w;
        } else {
            w1 = (w + a) / (1 + w * a);
        }

        w1 = (w1 + 1) / 2;

        var w2 = 1 - w1;

        var rgba = {
            r: rgb2.r * w1 + rgb1.r * w2,
            g: rgb2.g * w1 + rgb1.g * w2,
            b: rgb2.b * w1 + rgb1.b * w2,
            a: rgb2.a * p  + rgb1.a * (1 - p)
        };

        return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        var rgb1 = c1.toRgb();
        var rgb2 = c2.toRgb();
        var brightnessA = c1.getBrightness();
        var brightnessB = c2.getBrightness();
        var colorDiff = (
            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
        );

        return {
            brightness: Math.abs(brightnessA - brightnessB),
            color: colorDiff
        };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
        var readability = tinycolor.readability(color1, color2);
        return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
        var bestColor = null;
        var bestScore = 0;
        var bestIsReadable = false;
        for (var i=0; i < colorList.length; i++) {

            // We normalize both around the "acceptable" breaking point,
            // but rank brightness constrast higher than hue.

            var readability = tinycolor.readability(baseColor, colorList[i]);
            var readable = readability.brightness > 125 && readability.color > 500;
            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

            if ((readable && ! bestIsReadable) ||
                (readable && bestIsReadable && score > bestScore) ||
                ((! readable) && (! bestIsReadable) && score > bestScore)) {
                bestIsReadable = readable;
                bestScore = score;
                bestColor = tinycolor(colorList[i]);
            }
        }
        return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                a: convertHexToDecimal(match[1]),
                r: parseIntFromHex(match[2]),
                g: parseIntFromHex(match[3]),
                b: parseIntFromHex(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    window.tinycolor = tinycolor;
    })();

    $(function () {
        if ($.fn.spectrum.load) {
            $.fn.spectrum.processNativeColorInputs();
        }
    });

});


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(1452);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(137);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Tether"] = __webpack_require__(1454);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=e(require,exports,module):t.Tether=e()}(this,function(t,e,o){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t){var e=getComputedStyle(t)||{},o=e.position,n=[];if("fixed"===o)return[t];for(var i=t;(i=i.parentNode)&&i&&1===i.nodeType;){var r=void 0;try{r=getComputedStyle(i)}catch(s){}if("undefined"==typeof r||null===r)return n.push(i),n;var a=r,f=a.overflow,l=a.overflowX,h=a.overflowY;/(auto|scroll)/.test(f+h+l)&&("absolute"!==o||["relative","absolute","fixed"].indexOf(r.position)>=0)&&n.push(i)}return n.push(document.body),n}function r(){x&&document.body.removeChild(x),x=null}function s(t){var e=void 0;t===document?(e=document,t=document.documentElement):e=t.ownerDocument;var o=e.documentElement,n={},i=t.getBoundingClientRect();for(var r in i)n[r]=i[r];var s=S();return n.top-=s.top,n.left-=s.left,"undefined"==typeof n.width&&(n.width=document.body.scrollWidth-n.left-n.right),"undefined"==typeof n.height&&(n.height=document.body.scrollHeight-n.top-n.bottom),n.top=n.top-o.clientTop,n.left=n.left-o.clientLeft,n.right=e.body.clientWidth-n.width-n.left,n.bottom=e.body.clientHeight-n.height-n.top,n}function a(t){return t.offsetParent||document.documentElement}function f(){var t=document.createElement("div");t.style.width="100%",t.style.height="200px";var e=document.createElement("div");l(e.style,{position:"absolute",top:0,left:0,pointerEvents:"none",visibility:"hidden",width:"200px",height:"150px",overflow:"hidden"}),e.appendChild(t),document.body.appendChild(e);var o=t.offsetWidth;e.style.overflow="scroll";var n=t.offsetWidth;o===n&&(n=e.clientWidth),document.body.removeChild(e);var i=o-n;return{width:i,height:i}}function l(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],e=[];return Array.prototype.push.apply(e,arguments),e.slice(1).forEach(function(e){if(e)for(var o in e)({}).hasOwnProperty.call(e,o)&&(t[o]=e[o])}),t}function h(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.remove(e)});else{var o=new RegExp("(^| )"+e.split(" ").join("|")+"( |$)","gi"),n=p(t).replace(o," ");c(t,n)}}function d(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.add(e)});else{h(t,e);var o=p(t)+(" "+e);c(t,o)}}function u(t,e){if("undefined"!=typeof t.classList)return t.classList.contains(e);var o=p(t);return new RegExp("(^| )"+e+"( |$)","gi").test(o)}function p(t){return t.className instanceof SVGAnimatedString?t.className.baseVal:t.className}function c(t,e){t.setAttribute("class",e)}function g(t,e,o){o.forEach(function(o){-1===e.indexOf(o)&&u(t,o)&&h(t,o)}),e.forEach(function(e){u(t,e)||d(t,e)})}function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function m(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function v(t,e){var o=arguments.length<=2||void 0===arguments[2]?1:arguments[2];return t+o>=e&&e>=t-o}function y(){return"undefined"!=typeof performance&&"undefined"!=typeof performance.now?performance.now():+new Date}function b(){for(var t={top:0,left:0},e=arguments.length,o=Array(e),n=0;e>n;n++)o[n]=arguments[n];return o.forEach(function(e){var o=e.top,n=e.left;"string"==typeof o&&(o=parseFloat(o,10)),"string"==typeof n&&(n=parseFloat(n,10)),t.top+=o,t.left+=n}),t}function w(t,e){return"string"==typeof t.left&&-1!==t.left.indexOf("%")&&(t.left=parseFloat(t.left,10)/100*e.width),"string"==typeof t.top&&-1!==t.top.indexOf("%")&&(t.top=parseFloat(t.top,10)/100*e.height),t}function C(t,e){return"scrollParent"===e?e=t.scrollParents[0]:"window"===e&&(e=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),e===document&&(e=e.documentElement),"undefined"!=typeof e.nodeType&&!function(){var t=s(e),o=t,n=getComputedStyle(e);e=[o.left,o.top,t.width+o.left,t.height+o.top],V.forEach(function(t,o){t=t[0].toUpperCase()+t.substr(1),"Top"===t||"Left"===t?e[o]+=parseFloat(n["border"+t+"Width"]):e[o]-=parseFloat(n["border"+t+"Width"])})}(),e}var O=function(){function t(t,e){for(var o=0;o<e.length;o++){var n=e[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,o,n){return o&&t(e.prototype,o),n&&t(e,n),e}}(),E=void 0;"undefined"==typeof E&&(E={modules:[]});var x=null,T=function(){var t=0;return function(){return++t}}(),A={},S=function(){var t=x;t||(t=document.createElement("div"),t.setAttribute("data-tether-id",T()),l(t.style,{top:0,left:0,position:"absolute"}),document.body.appendChild(t),x=t);var e=t.getAttribute("data-tether-id");if("undefined"==typeof A[e]){A[e]={};var o=t.getBoundingClientRect();for(var n in o)A[e][n]=o[n];W(function(){delete A[e]})}return A[e]},P=[],W=function(t){P.push(t)},M=function(){for(var t=void 0;t=P.pop();)t()},_=function(){function t(){n(this,t)}return O(t,[{key:"on",value:function(t,e,o){var n=arguments.length<=3||void 0===arguments[3]?!1:arguments[3];"undefined"==typeof this.bindings&&(this.bindings={}),"undefined"==typeof this.bindings[t]&&(this.bindings[t]=[]),this.bindings[t].push({handler:e,ctx:o,once:n})}},{key:"once",value:function(t,e,o){this.on(t,e,o,!0)}},{key:"off",value:function(t,e){if("undefined"!=typeof this.bindings&&"undefined"!=typeof this.bindings[t])if("undefined"==typeof e)delete this.bindings[t];else for(var o=0;o<this.bindings[t].length;)this.bindings[t][o].handler===e?this.bindings[t].splice(o,1):++o}},{key:"trigger",value:function(t){if("undefined"!=typeof this.bindings&&this.bindings[t]){for(var e=0,o=arguments.length,n=Array(o>1?o-1:0),i=1;o>i;i++)n[i-1]=arguments[i];for(;e<this.bindings[t].length;){var r=this.bindings[t][e],s=r.handler,a=r.ctx,f=r.once,l=a;"undefined"==typeof l&&(l=this),s.apply(l,n),f?this.bindings[t].splice(e,1):++e}}}}]),t}();E.Utils={getScrollParents:i,getBounds:s,getOffsetParent:a,extend:l,addClass:d,removeClass:h,hasClass:u,updateClasses:g,defer:W,flush:M,uniqueId:T,Evented:_,getScrollBarSize:f,removeUtilElements:r};var k=function(){function t(t,e){var o=[],n=!0,i=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);n=!0);}catch(f){i=!0,r=f}finally{try{!n&&a["return"]&&a["return"]()}finally{if(i)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),O=function(){function t(t,e){for(var o=0;o<e.length;o++){var n=e[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,o,n){return o&&t(e.prototype,o),n&&t(e,n),e}}(),B=function(t,e,o){for(var n=!0;n;){var i=t,r=e,s=o;n=!1,null===i&&(i=Function.prototype);var a=Object.getOwnPropertyDescriptor(i,r);if(void 0!==a){if("value"in a)return a.value;var f=a.get;if(void 0===f)return;return f.call(s)}var l=Object.getPrototypeOf(i);if(null===l)return;t=l,e=r,o=s,n=!0,a=l=void 0}};if("undefined"==typeof E)throw new Error("You must include the utils.js file before tether.js");var z=E.Utils,i=z.getScrollParents,s=z.getBounds,a=z.getOffsetParent,l=z.extend,d=z.addClass,h=z.removeClass,g=z.updateClasses,W=z.defer,M=z.flush,f=z.getScrollBarSize,r=z.removeUtilElements,j=function(){if("undefined"==typeof document)return"";for(var t=document.createElement("div"),e=["transform","webkitTransform","OTransform","MozTransform","msTransform"],o=0;o<e.length;++o){var n=e[o];if(void 0!==t.style[n])return n}}(),L=[],Y=function(){L.forEach(function(t){t.position(!1)}),M()};!function(){var t=null,e=null,o=null,n=function i(){return"undefined"!=typeof e&&e>16?(e=Math.min(e-16,250),void(o=setTimeout(i,250))):void("undefined"!=typeof t&&y()-t<10||(null!=o&&(clearTimeout(o),o=null),t=y(),Y(),e=y()-t))};"undefined"!=typeof window&&"undefined"!=typeof window.addEventListener&&["resize","scroll","touchmove"].forEach(function(t){window.addEventListener(t,n)})}();var F={center:"center",left:"right",right:"left"},H={middle:"middle",top:"bottom",bottom:"top"},X={top:0,left:0,middle:"50%",center:"50%",bottom:"100%",right:"100%"},N=function(t,e){var o=t.left,n=t.top;return"auto"===o&&(o=F[e.left]),"auto"===n&&(n=H[e.top]),{left:o,top:n}},U=function(t){var e=t.left,o=t.top;return"undefined"!=typeof X[t.left]&&(e=X[t.left]),"undefined"!=typeof X[t.top]&&(o=X[t.top]),{left:e,top:o}},R=function(t){var e=t.split(" "),o=k(e,2),n=o[0],i=o[1];return{top:n,left:i}},q=R,D=function(t){function e(t){var o=this;n(this,e),B(Object.getPrototypeOf(e.prototype),"constructor",this).call(this),this.position=this.position.bind(this),L.push(this),this.history=[],this.setOptions(t,!1),E.modules.forEach(function(t){"undefined"!=typeof t.initialize&&t.initialize.call(o)}),this.position()}return m(e,t),O(e,[{key:"getClass",value:function(){var t=arguments.length<=0||void 0===arguments[0]?"":arguments[0],e=this.options.classes;return"undefined"!=typeof e&&e[t]?this.options.classes[t]:this.options.classPrefix?this.options.classPrefix+"-"+t:t}},{key:"setOptions",value:function(t){var e=this,o=arguments.length<=1||void 0===arguments[1]?!0:arguments[1],n={offset:"0 0",targetOffset:"0 0",targetAttachment:"auto auto",classPrefix:"tether"};this.options=l(n,t);var r=this.options,s=r.element,a=r.target,f=r.targetModifier;if(this.element=s,this.target=a,this.targetModifier=f,"viewport"===this.target?(this.target=document.body,this.targetModifier="visible"):"scroll-handle"===this.target&&(this.target=document.body,this.targetModifier="scroll-handle"),["element","target"].forEach(function(t){if("undefined"==typeof e[t])throw new Error("Tether Error: Both element and target must be defined");"undefined"!=typeof e[t].jquery?e[t]=e[t][0]:"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),d(this.element,this.getClass("element")),this.options.addTargetClasses!==!1&&d(this.target,this.getClass("target")),!this.options.attachment)throw new Error("Tether Error: You must provide an attachment");this.targetAttachment=q(this.options.targetAttachment),this.attachment=q(this.options.attachment),this.offset=R(this.options.offset),this.targetOffset=R(this.options.targetOffset),"undefined"!=typeof this.scrollParents&&this.disable(),"scroll-handle"===this.targetModifier?this.scrollParents=[this.target]:this.scrollParents=i(this.target),this.options.enabled!==!1&&this.enable(o)}},{key:"getTargetBounds",value:function(){if("undefined"==typeof this.targetModifier)return s(this.target);if("visible"===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var t=s(this.target),e={height:t.height,width:t.width,top:t.top,left:t.left};return e.height=Math.min(e.height,t.height-(pageYOffset-t.top)),e.height=Math.min(e.height,t.height-(t.top+t.height-(pageYOffset+innerHeight))),e.height=Math.min(innerHeight,e.height),e.height-=2,e.width=Math.min(e.width,t.width-(pageXOffset-t.left)),e.width=Math.min(e.width,t.width-(t.left+t.width-(pageXOffset+innerWidth))),e.width=Math.min(innerWidth,e.width),e.width-=2,e.top<pageYOffset&&(e.top=pageYOffset),e.left<pageXOffset&&(e.left=pageXOffset),e}if("scroll-handle"===this.targetModifier){var t=void 0,o=this.target;o===document.body?(o=document.documentElement,t={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):t=s(o);var n=getComputedStyle(o),i=o.scrollWidth>o.clientWidth||[n.overflow,n.overflowX].indexOf("scroll")>=0||this.target!==document.body,r=0;i&&(r=15);var a=t.height-parseFloat(n.borderTopWidth)-parseFloat(n.borderBottomWidth)-r,e={width:15,height:.975*a*(a/o.scrollHeight),left:t.left+t.width-parseFloat(n.borderLeftWidth)-15},f=0;408>a&&this.target===document.body&&(f=-11e-5*Math.pow(a,2)-.00727*a+22.58),this.target!==document.body&&(e.height=Math.max(e.height,24));var l=this.target.scrollTop/(o.scrollHeight-a);return e.top=l*(a-e.height-f)+t.top+parseFloat(n.borderTopWidth),this.target===document.body&&(e.height=Math.max(e.height,24)),e}}},{key:"clearCache",value:function(){this._cache={}}},{key:"cache",value:function(t,e){return"undefined"==typeof this._cache&&(this._cache={}),"undefined"==typeof this._cache[t]&&(this._cache[t]=e.call(this)),this._cache[t]}},{key:"enable",value:function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?!0:arguments[0];this.options.addTargetClasses!==!1&&d(this.target,this.getClass("enabled")),d(this.element,this.getClass("enabled")),this.enabled=!0,this.scrollParents.forEach(function(e){e!==document&&e.addEventListener("scroll",t.position)}),e&&this.position()}},{key:"disable",value:function(){var t=this;h(this.target,this.getClass("enabled")),h(this.element,this.getClass("enabled")),this.enabled=!1,"undefined"!=typeof this.scrollParents&&this.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.position)})}},{key:"destroy",value:function(){var t=this;this.disable(),L.forEach(function(e,o){e===t&&L.splice(o,1)}),0===L.length&&r()}},{key:"updateAttachClasses",value:function(t,e){var o=this;t=t||this.attachment,e=e||this.targetAttachment;var n=["left","top","bottom","right","middle","center"];"undefined"!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),"undefined"==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var i=this._addAttachClasses;t.top&&i.push(this.getClass("element-attached")+"-"+t.top),t.left&&i.push(this.getClass("element-attached")+"-"+t.left),e.top&&i.push(this.getClass("target-attached")+"-"+e.top),e.left&&i.push(this.getClass("target-attached")+"-"+e.left);var r=[];n.forEach(function(t){r.push(o.getClass("element-attached")+"-"+t),r.push(o.getClass("target-attached")+"-"+t)}),W(function(){"undefined"!=typeof o._addAttachClasses&&(g(o.element,o._addAttachClasses,r),o.options.addTargetClasses!==!1&&g(o.target,o._addAttachClasses,r),delete o._addAttachClasses)})}},{key:"position",value:function(){var t=this,e=arguments.length<=0||void 0===arguments[0]?!0:arguments[0];if(this.enabled){this.clearCache();var o=N(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,o);var n=this.cache("element-bounds",function(){return s(t.element)}),i=n.width,r=n.height;if(0===i&&0===r&&"undefined"!=typeof this.lastSize){var l=this.lastSize;i=l.width,r=l.height}else this.lastSize={width:i,height:r};var h=this.cache("target-bounds",function(){return t.getTargetBounds()}),d=h,u=w(U(this.attachment),{width:i,height:r}),p=w(U(o),d),c=w(this.offset,{width:i,height:r}),g=w(this.targetOffset,d);u=b(u,c),p=b(p,g);for(var m=h.left+p.left-u.left,v=h.top+p.top-u.top,y=0;y<E.modules.length;++y){var C=E.modules[y],O=C.position.call(this,{left:m,top:v,targetAttachment:o,targetPos:h,elementPos:n,offset:u,targetOffset:p,manualOffset:c,manualTargetOffset:g,scrollbarSize:T,attachment:this.attachment});if(O===!1)return!1;"undefined"!=typeof O&&"object"==typeof O&&(v=O.top,m=O.left)}var x={page:{top:v,left:m},viewport:{top:v-pageYOffset,bottom:pageYOffset-v-r+innerHeight,left:m-pageXOffset,right:pageXOffset-m-i+innerWidth}},T=void 0;return document.body.scrollWidth>window.innerWidth&&(T=this.cache("scrollbar-size",f),x.viewport.bottom-=T.height),document.body.scrollHeight>window.innerHeight&&(T=this.cache("scrollbar-size",f),x.viewport.right-=T.width),(-1===["","static"].indexOf(document.body.style.position)||-1===["","static"].indexOf(document.body.parentElement.style.position))&&(x.page.bottom=document.body.scrollHeight-v-r,x.page.right=document.body.scrollWidth-m-i),"undefined"!=typeof this.options.optimizations&&this.options.optimizations.moveElement!==!1&&"undefined"==typeof this.targetModifier&&!function(){var e=t.cache("target-offsetparent",function(){return a(t.target)}),o=t.cache("target-offsetparent-bounds",function(){return s(e)}),n=getComputedStyle(e),i=o,r={};if(["Top","Left","Bottom","Right"].forEach(function(t){r[t.toLowerCase()]=parseFloat(n["border"+t+"Width"])}),o.right=document.body.scrollWidth-o.left-i.width+r.right,o.bottom=document.body.scrollHeight-o.top-i.height+r.bottom,x.page.top>=o.top+r.top&&x.page.bottom>=o.bottom&&x.page.left>=o.left+r.left&&x.page.right>=o.right){var f=e.scrollTop,l=e.scrollLeft;x.offset={top:x.page.top-o.top+f-r.top,left:x.page.left-o.left+l-r.left}}}(),this.move(x),this.history.unshift(x),this.history.length>3&&this.history.pop(),e&&M(),!0}}},{key:"move",value:function(t){var e=this;if("undefined"!=typeof this.element.parentNode){var o={};for(var n in t){o[n]={};for(var i in t[n]){for(var r=!1,s=0;s<this.history.length;++s){var f=this.history[s];if("undefined"!=typeof f[n]&&!v(f[n][i],t[n][i])){r=!0;break}}r||(o[n][i]=!0)}}var h={top:"",left:"",right:"",bottom:""},d=function(t,o){var n="undefined"!=typeof e.options.optimizations,i=n?e.options.optimizations.gpu:null;if(i!==!1){var r=void 0,s=void 0;t.top?(h.top=0,r=o.top):(h.bottom=0,r=-o.bottom),t.left?(h.left=0,s=o.left):(h.right=0,s=-o.right),h[j]="translateX("+Math.round(s)+"px) translateY("+Math.round(r)+"px)","msTransform"!==j&&(h[j]+=" translateZ(0)")}else t.top?h.top=o.top+"px":h.bottom=o.bottom+"px",t.left?h.left=o.left+"px":h.right=o.right+"px"},u=!1;if((o.page.top||o.page.bottom)&&(o.page.left||o.page.right)?(h.position="absolute",d(o.page,t.page)):(o.viewport.top||o.viewport.bottom)&&(o.viewport.left||o.viewport.right)?(h.position="fixed",d(o.viewport,t.viewport)):"undefined"!=typeof o.offset&&o.offset.top&&o.offset.left?!function(){h.position="absolute";var n=e.cache("target-offsetparent",function(){return a(e.target)});a(e.element)!==n&&W(function(){e.element.parentNode.removeChild(e.element),n.appendChild(e.element)}),d(o.offset,t.offset),u=!0}():(h.position="absolute",d({top:!0,left:!0},t.page)),!u){for(var p=!0,c=this.element.parentNode;c&&1===c.nodeType&&"BODY"!==c.tagName;){if("static"!==getComputedStyle(c).position){p=!1;break}c=c.parentNode}p||(this.element.parentNode.removeChild(this.element),document.body.appendChild(this.element))}var g={},m=!1;for(var i in h){var y=h[i],b=this.element.style[i];b!==y&&(m=!0,g[i]=y)}m&&W(function(){l(e.element.style,g)})}}}]),e}(_);D.modules=[],E.position=Y;var I=l(D,E),k=function(){function t(t,e){var o=[],n=!0,i=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);n=!0);}catch(f){i=!0,r=f}finally{try{!n&&a["return"]&&a["return"]()}finally{if(i)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),z=E.Utils,s=z.getBounds,l=z.extend,g=z.updateClasses,W=z.defer,V=["left","top","right","bottom"];E.modules.push({position:function(t){var e=this,o=t.top,n=t.left,i=t.targetAttachment;if(!this.options.constraints)return!0;var r=this.cache("element-bounds",function(){return s(e.element)}),a=r.height,f=r.width;if(0===f&&0===a&&"undefined"!=typeof this.lastSize){var h=this.lastSize;f=h.width,a=h.height}var d=this.cache("target-bounds",function(){return e.getTargetBounds()}),u=d.height,p=d.width,c=[this.getClass("pinned"),this.getClass("out-of-bounds")];this.options.constraints.forEach(function(t){var e=t.outOfBoundsClass,o=t.pinnedClass;e&&c.push(e),o&&c.push(o)}),c.forEach(function(t){["left","top","right","bottom"].forEach(function(e){c.push(t+"-"+e)})});var m=[],v=l({},i),y=l({},this.attachment);return this.options.constraints.forEach(function(t){var r=t.to,s=t.attachment,l=t.pin;"undefined"==typeof s&&(s="");var h=void 0,d=void 0;if(s.indexOf(" ")>=0){var c=s.split(" "),g=k(c,2);d=g[0],h=g[1]}else h=d=s;var b=C(e,r);("target"===d||"both"===d)&&(o<b[1]&&"top"===v.top&&(o+=u,v.top="bottom"),o+a>b[3]&&"bottom"===v.top&&(o-=u,v.top="top")),"together"===d&&("top"===v.top&&("bottom"===y.top&&o<b[1]?(o+=u,v.top="bottom",o+=a,y.top="top"):"top"===y.top&&o+a>b[3]&&o-(a-u)>=b[1]&&(o-=a-u,v.top="bottom",y.top="bottom")),"bottom"===v.top&&("top"===y.top&&o+a>b[3]?(o-=u,v.top="top",o-=a,y.top="bottom"):"bottom"===y.top&&o<b[1]&&o+(2*a-u)<=b[3]&&(o+=a-u,v.top="top",y.top="top")),"middle"===v.top&&(o+a>b[3]&&"top"===y.top?(o-=a,y.top="bottom"):o<b[1]&&"bottom"===y.top&&(o+=a,y.top="top"))),("target"===h||"both"===h)&&(n<b[0]&&"left"===v.left&&(n+=p,v.left="right"),n+f>b[2]&&"right"===v.left&&(n-=p,v.left="left")),"together"===h&&(n<b[0]&&"left"===v.left?"right"===y.left?(n+=p,v.left="right",n+=f,y.left="left"):"left"===y.left&&(n+=p,v.left="right",n-=f,y.left="right"):n+f>b[2]&&"right"===v.left?"left"===y.left?(n-=p,v.left="left",n-=f,y.left="right"):"right"===y.left&&(n-=p,v.left="left",n+=f,y.left="left"):"center"===v.left&&(n+f>b[2]&&"left"===y.left?(n-=f,y.left="right"):n<b[0]&&"right"===y.left&&(n+=f,y.left="left"))),("element"===d||"both"===d)&&(o<b[1]&&"bottom"===y.top&&(o+=a,y.top="top"),o+a>b[3]&&"top"===y.top&&(o-=a,y.top="bottom")),("element"===h||"both"===h)&&(n<b[0]&&("right"===y.left?(n+=f,y.left="left"):"center"===y.left&&(n+=f/2,y.left="left")),n+f>b[2]&&("left"===y.left?(n-=f,y.left="right"):"center"===y.left&&(n-=f/2,y.left="right"))),"string"==typeof l?l=l.split(",").map(function(t){return t.trim()}):l===!0&&(l=["top","left","right","bottom"]),l=l||[];var w=[],O=[];o<b[1]&&(l.indexOf("top")>=0?(o=b[1],w.push("top")):O.push("top")),o+a>b[3]&&(l.indexOf("bottom")>=0?(o=b[3]-a,w.push("bottom")):O.push("bottom")),n<b[0]&&(l.indexOf("left")>=0?(n=b[0],w.push("left")):O.push("left")),n+f>b[2]&&(l.indexOf("right")>=0?(n=b[2]-f,w.push("right")):O.push("right")),w.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.pinnedClass?e.options.pinnedClass:e.getClass("pinned"),m.push(t),w.forEach(function(e){m.push(t+"-"+e)})}(),O.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.outOfBoundsClass?e.options.outOfBoundsClass:e.getClass("out-of-bounds"),m.push(t),O.forEach(function(e){m.push(t+"-"+e)})}(),(w.indexOf("left")>=0||w.indexOf("right")>=0)&&(y.left=v.left=!1),(w.indexOf("top")>=0||w.indexOf("bottom")>=0)&&(y.top=v.top=!1),(v.top!==i.top||v.left!==i.left||y.top!==e.attachment.top||y.left!==e.attachment.left)&&(e.updateAttachClasses(y,v),e.trigger("update",{attachment:y,targetAttachment:v}))}),W(function(){e.options.addTargetClasses!==!1&&g(e.target,m,c),g(e.element,m,c)}),{top:o,left:n}}});var z=E.Utils,s=z.getBounds,g=z.updateClasses,W=z.defer;E.modules.push({position:function(t){var e=this,o=t.top,n=t.left,i=this.cache("element-bounds",function(){return s(e.element)}),r=i.height,a=i.width,f=this.getTargetBounds(),l=o+r,h=n+a,d=[];o<=f.bottom&&l>=f.top&&["left","right"].forEach(function(t){var e=f[t];(e===n||e===h)&&d.push(t)}),n<=f.right&&h>=f.left&&["top","bottom"].forEach(function(t){var e=f[t];(e===o||e===l)&&d.push(t)});var u=[],p=[],c=["left","top","right","bottom"];return u.push(this.getClass("abutted")),c.forEach(function(t){u.push(e.getClass("abutted")+"-"+t)}),d.length&&p.push(this.getClass("abutted")),d.forEach(function(t){p.push(e.getClass("abutted")+"-"+t)}),W(function(){e.options.addTargetClasses!==!1&&g(e.target,p,u),g(e.element,p,u)}),!0}});var k=function(){function t(t,e){var o=[],n=!0,i=!1,r=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(o.push(s.value),!e||o.length!==e);n=!0);}catch(f){i=!0,r=f}finally{try{!n&&a["return"]&&a["return"]()}finally{if(i)throw r}}return o}return function(e,o){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,o);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();return E.modules.push({position:function(t){var e=t.top,o=t.left;if(this.options.shift){var n=this.options.shift;"function"==typeof this.options.shift&&(n=this.options.shift.call(this,{top:e,left:o}));var i=void 0,r=void 0;if("string"==typeof n){n=n.split(" "),n[1]=n[1]||n[0];var s=n,a=k(s,2);i=a[0],r=a[1],i=parseFloat(i,10),r=parseFloat(r,10)}else i=n.top,r=n.left;return e+=i,o+=r,{top:e,left:o}}}}),I});

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Clipboard"] = __webpack_require__(894);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["postal"] = __webpack_require__(1457);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * postal - Pub/Sub library providing wildcard subscriptions, complex message handling, etc.  Works server and client-side.
 * Author: Jim Cowart (http://ifandelse.com)
 * Version: v2.0.5
 * Url: http://github.com/postaljs/postal.js
 * License(s): MIT
 */

( function( root, factory ) {
	
	if ( true ) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(7) ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( _ ) {
			return factory( _, root );
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	} else if ( typeof module === "object" && module.exports ) {
		// Node, or CommonJS-Like environments
		module.exports = factory( require( "lodash" ), this );
	} else {
		// Browser globals
		root.postal = factory( root._, root );
	}
}( this, function( _, global, undefined ) {
	var prevPostal = global && global.postal;
	var prevLodash = global && global._;
	if ( prevLodash && prevLodash !== _ ) {
		_ = _.noConflict();
	}
	var _defaultConfig = {
		DEFAULT_CHANNEL: "/",
		SYSTEM_CHANNEL: "postal",
		enableSystemMessages: true,
		cacheKeyDelimiter: "|",
		autoCompactResolver: false
	};
	var postal = {
		configuration: _.extend( {}, _defaultConfig )
	};
	var _config = postal.configuration;

	

var ChannelDefinition = function( channelName, bus ) {
	this.bus = bus;
	this.channel = channelName || _config.DEFAULT_CHANNEL;
};

ChannelDefinition.prototype.subscribe = function() {
	return this.bus.subscribe( {
		channel: this.channel,
		topic: ( arguments.length === 1 ? arguments[ 0 ].topic : arguments[ 0 ] ),
		callback: ( arguments.length === 1 ? arguments[ 0 ].callback : arguments[ 1 ] )
	} );
};

/*
    publish( envelope [, callback ] );
    publish( topic, data [, callback ] );
*/
ChannelDefinition.prototype.publish = function() {
	var envelope = {};
	var callback;
	if ( typeof arguments[ 0 ] === "string" ) {
		envelope.topic = arguments[ 0 ];
		envelope.data = arguments[ 1 ];
		callback = arguments[ 2 ];
	} else {
		envelope = arguments[ 0 ];
		callback = arguments[ 1 ];
	}
	if ( typeof envelope !== "object" ) {
		throw new Error( "The first argument to ChannelDefinition.publish should be either an envelope object or a string topic." );
	}
	envelope.headers = _.extend( envelope.headers || { resolverNoCache: _config.resolverNoCache } );
	envelope.channel = this.channel;
	this.bus.publish( envelope, callback );
};

	
var SubscriptionDefinition = function( channel, topic, callback ) {
	if ( arguments.length !== 3 ) {
		throw new Error( "You must provide a channel, topic and callback when creating a SubscriptionDefinition instance." );
	}
	if ( topic.length === 0 ) {
		throw new Error( "Topics cannot be empty" );
	}
	this.channel = channel;
	this.topic = topic;
	this.callback = callback;
	this.pipeline = [];
	this.cacheKeys = [];
	this._context = undefined;
};

var ConsecutiveDistinctPredicate = function() {
	var previous;
	return function( data ) {
		var eq = false;
		if ( typeof data === "string" ) {
			eq = data === previous;
			previous = data;
		} else {
			eq = _.isEqual( data, previous );
			previous = _.extend( {}, data );
		}
		return !eq;
	};
};

var DistinctPredicate = function DistinctPredicateFactory() {
	var previous = [];
	return function DistinctPredicate( data ) {
		var isDistinct = !_.some( previous, function( p ) {
			return _.isEqual( data, p );
		} );
		if ( isDistinct ) {
			previous.push( data );
		}
		return isDistinct;
	};
};

SubscriptionDefinition.prototype = {

	"catch": function( errorHandler ) {
		var original = this.callback;
		var safeCallback = function() {
			try {
				original.apply( this, arguments );
			} catch ( err ) {
				errorHandler( err, arguments[ 0 ] );
			}
		};
		this.callback = safeCallback;
		return this;
	},

	defer: function defer() {
		return this.delay( 0 );
	},

	disposeAfter: function disposeAfter( maxCalls ) {
		if ( typeof maxCalls !== "number" || maxCalls <= 0 ) {
			throw new Error( "The value provided to disposeAfter (maxCalls) must be a number greater than zero." );
		}
		var dispose = _.after( maxCalls, this.unsubscribe.bind( this ) );
		this.pipeline.push( function( data, env, next ) {
			next( data, env );
			dispose();
		} );
		return this;
	},

	distinct: function distinct() {
		return this.constraint( new DistinctPredicate() );
	},

	distinctUntilChanged: function distinctUntilChanged() {
		return this.constraint( new ConsecutiveDistinctPredicate() );
	},

	invokeSubscriber: function invokeSubscriber( data, env ) {
		if ( !this.inactive ) {
			var self = this;
			var pipeline = self.pipeline;
			var len = pipeline.length;
			var context = self._context;
			var idx = -1;
			var invoked = false;
			if ( !len ) {
				self.callback.call( context, data, env );
				invoked = true;
			} else {
				pipeline = pipeline.concat( [ self.callback ] );
				var step = function step( d, e ) {
					idx += 1;
					if ( idx < len ) {
						pipeline[ idx ].call( context, d, e, step );
					} else {
						self.callback.call( context, d, e );
						invoked = true;
					}
				};
				step( data, env, 0 );
			}
			return invoked;
		}
	},

	logError: function logError() {
		
		if ( console ) {
			var report;
			if ( console.warn ) {
				report = console.warn;
			} else {
				report = console.log;
			}
			this.catch( report );
		}
		return this;
	},

	once: function once() {
		return this.disposeAfter( 1 );
	},

	subscribe: function subscribe( callback ) {
		this.callback = callback;
		return this;
	},

	unsubscribe: function unsubscribe() {
		
		if ( !this.inactive ) {
			postal.unsubscribe( this );
		}
	},

	constraint: function constraint( predicate ) {
		if ( typeof predicate !== "function" ) {
			throw new Error( "Predicate constraint must be a function" );
		}
		this.pipeline.push( function( data, env, next ) {
			if ( predicate.call( this, data, env ) ) {
				next( data, env );
			}
		} );
		return this;
	},

	constraints: function constraints( predicates ) {
		var self = this;
		
		_.each( predicates, function( predicate ) {
			self.constraint( predicate );
		} );
		return self;
	},

	context: function contextSetter( context ) {
		this._context = context;
		return this;
	},

	debounce: function debounce( milliseconds, immediate ) {
		if ( typeof milliseconds !== "number" ) {
			throw new Error( "Milliseconds must be a number" );
		}

		var options = {};

		if ( !!immediate === true ) { 
			options.leading = true;
			options.trailing = false;
		}

		this.pipeline.push(
			_.debounce( function( data, env, next ) {
				next( data, env );
			},
				milliseconds,
				options
			)
		);
		return this;
	},

	delay: function delay( milliseconds ) {
		if ( typeof milliseconds !== "number" ) {
			throw new Error( "Milliseconds must be a number" );
		}
		var self = this;
		self.pipeline.push( function( data, env, next ) {
			setTimeout( function() {
				next( data, env );
			}, milliseconds );
		} );
		return this;
	},

	throttle: function throttle( milliseconds ) {
		if ( typeof milliseconds !== "number" ) {
			throw new Error( "Milliseconds must be a number" );
		}
		var fn = function( data, env, next ) {
			next( data, env );
		};
		this.pipeline.push( _.throttle( fn, milliseconds ) );
		return this;
	}
};

	


var bindingsResolver = _config.resolver = {
	cache: {},
	regex: {},
	enableCache: true,

	compare: function compare( binding, topic, headerOptions ) {
		var pattern;
		var rgx;
		var prevSegment;
		var cacheKey = topic + _config.cacheKeyDelimiter + binding;
		var result = ( this.cache[ cacheKey ] );
		var opt = headerOptions || {};
		var saveToCache = this.enableCache && !opt.resolverNoCache;
		// result is cached?
		if ( result === true ) {
			return result;
		}
		// plain string matching?
		if ( binding.indexOf( "#" ) === -1 && binding.indexOf( "*" ) === -1 ) {
			result = ( topic === binding );
			if ( saveToCache ) {
				this.cache[ cacheKey ] = result;
			}
			return result;
		}
		// ah, regex matching, then
		if ( !( rgx = this.regex[ binding ] ) ) {
			pattern = "^" + _.map( binding.split( "." ), function mapTopicBinding( segment ) {
					var res = "";
					if ( !!prevSegment ) {
						res = prevSegment !== "#" ? "\\.\\b" : "\\b";
					}
					if ( segment === "#" ) {
						res += "[\\s\\S]*";
					} else if ( segment === "*" ) {
						res += "[^.]+";
					} else {
						res += segment;
					}
					prevSegment = segment;
					return res;
				} ).join( "" ) + "$";
			rgx = this.regex[ binding ] = new RegExp( pattern );
		}
		result = rgx.test( topic );
		if ( saveToCache ) {
			this.cache[ cacheKey ] = result;
		}
		return result;
	},

	reset: function reset() {
		this.cache = {};
		this.regex = {};
	},

	purge: function( options ) {
		var self = this;
		var keyDelimiter = _config.cacheKeyDelimiter;
		var matchPredicate = function( val, key ) {
			var split = key.split( keyDelimiter );
			var topic = split[ 0 ];
			var binding = split[ 1 ];
			if ( ( typeof options.topic === "undefined" || options.topic === topic ) &&
					( typeof options.binding === "undefined" || options.binding === binding ) ) {
				delete self.cache[ key ];
			}
		};

		var compactPredicate = function( val, key ) {
			var split = key.split( keyDelimiter );
			if ( postal.getSubscribersFor( { topic: split[ 0 ] } ).length === 0 ) {
				delete self.cache[ key ];
			}
		};

		if ( typeof options === "undefined" ) {
			this.reset();
		} else {
			var handler = options.compact === true ? compactPredicate : matchPredicate;
			_.each( this.cache, handler );
		}
	}
};

	


var pubInProgress = 0;
var unSubQueue = [];
var autoCompactIndex = 0;

function clearUnSubQueue() {
	while ( unSubQueue.length ) {
		postal.unsubscribe( unSubQueue.shift() );
	}
}

function getCachePurger( subDef, key, cache ) {
	return function( sub, i, list ) {
		if ( sub === subDef ) {
			list.splice( i, 1 );
		}
		if ( list.length === 0 ) {
			delete cache[ key ];
		}
	};
}

function getCacher( topic, pubCache, cacheKey, done, envelope ) {
	var headers = envelope && envelope.headers || {};
	return function( subDef ) {
		var cache;
		if ( _config.resolver.compare( subDef.topic, topic, headers ) ) {
			if ( !headers.resolverNoCache ) {
				cache = pubCache[ cacheKey ] = ( pubCache[ cacheKey ] || [] );
				cache.push( subDef );
				subDef.cacheKeys.push( cacheKey );
			}
			if ( done ) {
				done( subDef );
			}
		}
	};
}

function getSystemMessage( kind, subDef ) {
	return {
		channel: _config.SYSTEM_CHANNEL,
		topic: "subscription." + kind,
		data: {
			event: "subscription." + kind,
			channel: subDef.channel,
			topic: subDef.topic
		}
	};
}

var sysCreatedMessage = getSystemMessage.bind( undefined, "created" );
var sysRemovedMessage = getSystemMessage.bind( undefined, "removed" );

function getPredicate( options, resolver ) {
	if ( typeof options === "function" ) {
		return options;
	} else if ( !options ) {
		return function() {
			return true;
		};
	} else {
		return function( sub ) {
			var compared = 0;
			var matched = 0;
			_.each( options, function( val, prop ) {
				compared += 1;
				if (
				// We use the bindings resolver to compare the options.topic to subDef.topic
				( prop === "topic" && resolver.compare( sub.topic, options.topic, { resolverNoCache: true } ) ) ||
						( prop === "context" && options.context === sub._context ) ||
						// Any other potential prop/value matching outside topic & context...
						( sub[ prop ] === options[ prop ] ) ) {
					matched += 1;
				}
			} );
			return compared === matched;
		};
	}
}

_.extend( postal, {
	cache: {},
	subscriptions: {},
	wireTaps: [],

	ChannelDefinition: ChannelDefinition,
	SubscriptionDefinition: SubscriptionDefinition,

	channel: function channel( channelName ) {
		return new ChannelDefinition( channelName, this );
	},

	addWireTap: function addWireTap( callback ) {
		var self = this;
		self.wireTaps.push( callback );
		return function() {
			var idx = self.wireTaps.indexOf( callback );
			if ( idx !== -1 ) {
				self.wireTaps.splice( idx, 1 );
			}
		};
	},

	noConflict: function noConflict() {
		
		if ( typeof window === "undefined" || ( typeof window !== "undefined" && "function" === "function" && __webpack_require__(299) ) ) {
			throw new Error( "noConflict can only be used in browser clients which aren't using AMD modules" );
		}
		global.postal = prevPostal;
		return this;
	},

	getSubscribersFor: function getSubscribersFor( options ) {
		var result = [];
		var self = this;
		_.each( self.subscriptions, function( channel ) {
			_.each( channel, function( subList ) {
				result = result.concat( _.filter( subList, getPredicate( options, _config.resolver ) ) );
			} );
		} );
		return result;
	},

	publish: function publish( envelope, cb ) {
		++pubInProgress;
		var channel = envelope.channel = envelope.channel || _config.DEFAULT_CHANNEL;
		var topic = envelope.topic;
		envelope.timeStamp = new Date();
		if ( this.wireTaps.length ) {
			_.each( this.wireTaps, function( tap ) {
				tap( envelope.data, envelope, pubInProgress );
			} );
		}
		var cacheKey = channel + _config.cacheKeyDelimiter + topic;
		var cache = this.cache[ cacheKey ];
		var skipped = 0;
		var activated = 0;
		if ( !cache ) {
			var cacherFn = getCacher(
				topic,
				this.cache,
				cacheKey,
				function( candidate ) {
					if ( candidate.invokeSubscriber( envelope.data, envelope ) ) {
						activated++;
					} else {
						skipped++;
					}
				},
				envelope
			);
			_.each( this.subscriptions[ channel ], function( candidates ) {
				_.each( candidates, cacherFn );
			} );
		} else {
			_.each( cache, function( subDef ) {
				if ( subDef.invokeSubscriber( envelope.data, envelope ) ) {
					activated++;
				} else {
					skipped++;
				}
			} );
		}
		if ( --pubInProgress === 0 ) {
			clearUnSubQueue();
		}
		if ( cb ) {
			cb( {
				activated: activated,
				skipped: skipped
			} );
		}
	},

	reset: function reset() {
		this.unsubscribeFor();
		_config.resolver.reset();
		this.subscriptions = {};
		this.cache = {};
	},

	subscribe: function subscribe( options ) {
		var subscriptions = this.subscriptions;
		var subDef = new SubscriptionDefinition( options.channel || _config.DEFAULT_CHANNEL, options.topic, options.callback );
		var channel = subscriptions[ subDef.channel ];
		var channelLen = subDef.channel.length;
		var subs;
		if ( !channel ) {
			channel = subscriptions[ subDef.channel ] = {};
		}
		subs = subscriptions[ subDef.channel ][ subDef.topic ];
		if ( !subs ) {
			subs = subscriptions[ subDef.channel ][ subDef.topic ] = [];
		}
		// First, add the SubscriptionDefinition to the channel list
		subs.push( subDef );
		// Next, add the SubscriptionDefinition to any relevant existing cache(s)
		var cache = this.cache;
		_.each( _.keys( cache ), function( cacheKey ) {
			if ( cacheKey.substr( 0, channelLen ) === subDef.channel ) {
				getCacher(
					cacheKey.split( _config.cacheKeyDelimiter )[1],
					cache,
					cacheKey )( subDef );
			}
		} );
		
		if ( _config.enableSystemMessages ) {
			this.publish( sysCreatedMessage( subDef ) );
		}
		return subDef;
	},

	unsubscribe: function unsubscribe() {
		var unSubLen = arguments.length;
		var unSubIdx = 0;
		var subDef;
		var channelSubs;
		var topicSubs;
		var idx;
		for ( ; unSubIdx < unSubLen; unSubIdx++ ) {
			subDef = arguments[ unSubIdx ];
			subDef.inactive = true;
			if ( pubInProgress ) {
				unSubQueue.push( subDef );
				return;
			}
			channelSubs = this.subscriptions[ subDef.channel ];
			topicSubs = channelSubs && channelSubs[ subDef.topic ];
			
			if ( topicSubs ) {
				var len = topicSubs.length;
				idx = 0;
				// remove SubscriptionDefinition from channel list
				while ( idx < len ) {
					
					if ( topicSubs[ idx ] === subDef ) {
						topicSubs.splice( idx, 1 );
						break;
					}
					idx += 1;
				}
				if ( topicSubs.length === 0 ) {
					delete channelSubs[ subDef.topic ];
					if ( !_.keys( channelSubs ).length ) {
						delete this.subscriptions[ subDef.channel ];
					}
				}
				// remove SubscriptionDefinition from postal cache
				if ( subDef.cacheKeys && subDef.cacheKeys.length ) {
					var key;
					while ( key = subDef.cacheKeys.pop() ) {
						_.each( this.cache[ key ], getCachePurger( subDef, key, this.cache ) );
					}
				}
				if ( typeof _config.resolver.purge === "function" ) {
					// check to see if relevant resolver cache entries can be purged
					var autoCompact = _config.autoCompactResolver === true ?
						0 : typeof _config.autoCompactResolver === "number" ?
							( _config.autoCompactResolver - 1 ) : false;
					if ( autoCompact >= 0 && autoCompactIndex === autoCompact ) {
						_config.resolver.purge( { compact: true } );
						autoCompactIndex = 0;
					} else if ( autoCompact >= 0 && autoCompactIndex < autoCompact ) {
						autoCompactIndex += 1;
					}
				}
			}
			if ( _config.enableSystemMessages ) {
				this.publish( sysRemovedMessage( subDef ) );
			}
		}
	},

	unsubscribeFor: function unsubscribeFor( options ) {
		var toDispose = [];
		
		if ( this.subscriptions ) {
			toDispose = this.getSubscribersFor( options );
			this.unsubscribe.apply( this, toDispose );
		}
	}
} );


	
	if ( global && Object.prototype.hasOwnProperty.call( global, "__postalReady__" ) && _.isArray( global.__postalReady__ ) ) {
		while ( global.__postalReady__.length ) {
			global.__postalReady__.shift().onReady( postal );
		}
	}
	

	return postal;
} ) );


/***/ }),
/* 1458 */
/***/ (function(module, exports) {

var getCookie = function(name) {
	var cookieValue = null;
	if (document.cookie && document.cookie != '') {
		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var cookie = jQuery.trim(cookies[i]);
			// Does this cookie string begin with the name we want?
			if (cookie.substring(0, name.length + 1) == (name + '=')) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}

function csrfSafeMethod(method) {
	// these HTTP methods do not require CSRF protection
	return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

$.ajaxSetup({
	beforeSend: function(xhr, settings) {
		if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
			xhr.setRequestHeader("X-CSRFToken", getCookie('csrftoken'));
		}
	}
});


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(137)], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($) {
      return (root.returnExportsGlobal = factory($));
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function ($) {

/*
  Implement Github like autocomplete mentions
  http://ichord.github.com/At.js

  Copyright (c) 2013 chord.luo@gmail.com
  Licensed under the MIT license.
*/

/*
本插件操作 textarea 或者 input 内的插入符
只实现了获得插入符在文本框中的位置，我设置
插入符的位置.
*/

"use strict";
var EditableCaret, InputCaret, Mirror, Utils, discoveryIframeOf, methods, oDocument, oFrame, oWindow, pluginName, setContextBy;

pluginName = 'caret';

EditableCaret = (function() {
  function EditableCaret($inputor) {
    this.$inputor = $inputor;
    this.domInputor = this.$inputor[0];
  }

  EditableCaret.prototype.setPos = function(pos) {
    var fn, found, offset, sel;
    if (sel = oWindow.getSelection()) {
      offset = 0;
      found = false;
      (fn = function(pos, parent) {
        var node, range, _i, _len, _ref, _results;
        _ref = parent.childNodes;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          node = _ref[_i];
          if (found) {
            break;
          }
          if (node.nodeType === 3) {
            if (offset + node.length >= pos) {
              found = true;
              range = oDocument.createRange();
              range.setStart(node, pos - offset);
              sel.removeAllRanges();
              sel.addRange(range);
              break;
            } else {
              _results.push(offset += node.length);
            }
          } else {
            _results.push(fn(pos, node));
          }
        }
        return _results;
      })(pos, this.domInputor);
    }
    return this.domInputor;
  };

  EditableCaret.prototype.getIEPosition = function() {
    return this.getPosition();
  };

  EditableCaret.prototype.getPosition = function() {
    var inputor_offset, offset;
    offset = this.getOffset();
    inputor_offset = this.$inputor.offset();
    offset.left -= inputor_offset.left;
    offset.top -= inputor_offset.top;
    return offset;
  };

  EditableCaret.prototype.getOldIEPos = function() {
    var preCaretTextRange, textRange;
    textRange = oDocument.selection.createRange();
    preCaretTextRange = oDocument.body.createTextRange();
    preCaretTextRange.moveToElementText(this.domInputor);
    preCaretTextRange.setEndPoint("EndToEnd", textRange);
    return preCaretTextRange.text.length;
  };

  EditableCaret.prototype.getPos = function() {
    var clonedRange, pos, range;
    if (range = this.range()) {
      clonedRange = range.cloneRange();
      clonedRange.selectNodeContents(this.domInputor);
      clonedRange.setEnd(range.endContainer, range.endOffset);
      pos = clonedRange.toString().length;
      clonedRange.detach();
      return pos;
    } else if (oDocument.selection) {
      return this.getOldIEPos();
    }
  };

  EditableCaret.prototype.getOldIEOffset = function() {
    var range, rect;
    range = oDocument.selection.createRange().duplicate();
    range.moveStart("character", -1);
    rect = range.getBoundingClientRect();
    return {
      height: rect.bottom - rect.top,
      left: rect.left,
      top: rect.top
    };
  };

  EditableCaret.prototype.getOffset = function(pos) {
    var clonedRange, offset, range, rect, shadowCaret;
    if (oWindow.getSelection && (range = this.range())) {
      if (range.endOffset - 1 > 0 && range.endContainer !== this.domInputor) {
        clonedRange = range.cloneRange();
        clonedRange.setStart(range.endContainer, range.endOffset - 1);
        clonedRange.setEnd(range.endContainer, range.endOffset);
        rect = clonedRange.getBoundingClientRect();
        offset = {
          height: rect.height,
          left: rect.left + rect.width,
          top: rect.top
        };
        clonedRange.detach();
      }
      if (!offset || (offset != null ? offset.height : void 0) === 0) {
        clonedRange = range.cloneRange();
        shadowCaret = $(oDocument.createTextNode("|"));
        clonedRange.insertNode(shadowCaret[0]);
        clonedRange.selectNode(shadowCaret[0]);
        rect = clonedRange.getBoundingClientRect();
        offset = {
          height: rect.height,
          left: rect.left,
          top: rect.top
        };
        shadowCaret.remove();
        clonedRange.detach();
      }
    } else if (oDocument.selection) {
      offset = this.getOldIEOffset();
    }
    if (offset) {
      offset.top += $(oWindow).scrollTop();
      offset.left += $(oWindow).scrollLeft();
    }
    return offset;
  };

  EditableCaret.prototype.range = function() {
    var sel;
    if (!oWindow.getSelection) {
      return;
    }
    sel = oWindow.getSelection();
    if (sel.rangeCount > 0) {
      return sel.getRangeAt(0);
    } else {
      return null;
    }
  };

  return EditableCaret;

})();

InputCaret = (function() {
  function InputCaret($inputor) {
    this.$inputor = $inputor;
    this.domInputor = this.$inputor[0];
  }

  InputCaret.prototype.getIEPos = function() {
    var endRange, inputor, len, normalizedValue, pos, range, textInputRange;
    inputor = this.domInputor;
    range = oDocument.selection.createRange();
    pos = 0;
    if (range && range.parentElement() === inputor) {
      normalizedValue = inputor.value.replace(/\r\n/g, "\n");
      len = normalizedValue.length;
      textInputRange = inputor.createTextRange();
      textInputRange.moveToBookmark(range.getBookmark());
      endRange = inputor.createTextRange();
      endRange.collapse(false);
      if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
        pos = len;
      } else {
        pos = -textInputRange.moveStart("character", -len);
      }
    }
    return pos;
  };

  InputCaret.prototype.getPos = function() {
    if (oDocument.selection) {
      return this.getIEPos();
    } else {
      return this.domInputor.selectionStart;
    }
  };

  InputCaret.prototype.setPos = function(pos) {
    var inputor, range;
    inputor = this.domInputor;
    if (oDocument.selection) {
      range = inputor.createTextRange();
      range.move("character", pos);
      range.select();
    } else if (inputor.setSelectionRange) {
      inputor.setSelectionRange(pos, pos);
    }
    return inputor;
  };

  InputCaret.prototype.getIEOffset = function(pos) {
    var h, textRange, x, y;
    textRange = this.domInputor.createTextRange();
    pos || (pos = this.getPos());
    textRange.move('character', pos);
    x = textRange.boundingLeft;
    y = textRange.boundingTop;
    h = textRange.boundingHeight;
    return {
      left: x,
      top: y,
      height: h
    };
  };

  InputCaret.prototype.getOffset = function(pos) {
    var $inputor, offset, position;
    $inputor = this.$inputor;
    if (oDocument.selection) {
      offset = this.getIEOffset(pos);
      offset.top += $(oWindow).scrollTop() + $inputor.scrollTop();
      offset.left += $(oWindow).scrollLeft() + $inputor.scrollLeft();
      return offset;
    } else {
      offset = $inputor.offset();
      position = this.getPosition(pos);
      return offset = {
        left: offset.left + position.left - $inputor.scrollLeft(),
        top: offset.top + position.top - $inputor.scrollTop(),
        height: position.height
      };
    }
  };

  InputCaret.prototype.getPosition = function(pos) {
    var $inputor, at_rect, end_range, format, html, mirror, start_range;
    $inputor = this.$inputor;
    format = function(value) {
      value = value.replace(/<|>|`|"|&/g, '?').replace(/\r\n|\r|\n/g, "<br/>");
      if (/firefox/i.test(navigator.userAgent)) {
        value = value.replace(/\s/g, '&nbsp;');
      }
      return value;
    };
    if (pos === void 0) {
      pos = this.getPos();
    }
    start_range = $inputor.val().slice(0, pos);
    end_range = $inputor.val().slice(pos);
    html = "<span style='position: relative; display: inline;'>" + format(start_range) + "</span>";
    html += "<span id='caret' style='position: relative; display: inline;'>|</span>";
    html += "<span style='position: relative; display: inline;'>" + format(end_range) + "</span>";
    mirror = new Mirror($inputor);
    return at_rect = mirror.create(html).rect();
  };

  InputCaret.prototype.getIEPosition = function(pos) {
    var h, inputorOffset, offset, x, y;
    offset = this.getIEOffset(pos);
    inputorOffset = this.$inputor.offset();
    x = offset.left - inputorOffset.left;
    y = offset.top - inputorOffset.top;
    h = offset.height;
    return {
      left: x,
      top: y,
      height: h
    };
  };

  return InputCaret;

})();

Mirror = (function() {
  Mirror.prototype.css_attr = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontWeight", "height", "letterSpacing", "lineHeight", "marginBottom", "marginLeft", "marginRight", "marginTop", "outlineWidth", "overflow", "overflowX", "overflowY", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "textAlign", "textOverflow", "textTransform", "whiteSpace", "wordBreak", "wordWrap"];

  function Mirror($inputor) {
    this.$inputor = $inputor;
  }

  Mirror.prototype.mirrorCss = function() {
    var css,
      _this = this;
    css = {
      position: 'absolute',
      left: -9999,
      top: 0,
      zIndex: -20000
    };
    if (this.$inputor.prop('tagName') === 'TEXTAREA') {
      this.css_attr.push('width');
    }
    $.each(this.css_attr, function(i, p) {
      return css[p] = _this.$inputor.css(p);
    });
    return css;
  };

  Mirror.prototype.create = function(html) {
    this.$mirror = $('<div></div>');
    this.$mirror.css(this.mirrorCss());
    this.$mirror.html(html);
    this.$inputor.after(this.$mirror);
    return this;
  };

  Mirror.prototype.rect = function() {
    var $flag, pos, rect;
    $flag = this.$mirror.find("#caret");
    pos = $flag.position();
    rect = {
      left: pos.left,
      top: pos.top,
      height: $flag.height()
    };
    this.$mirror.remove();
    return rect;
  };

  return Mirror;

})();

Utils = {
  contentEditable: function($inputor) {
    return !!($inputor[0].contentEditable && $inputor[0].contentEditable === 'true');
  }
};

methods = {
  pos: function(pos) {
    if (pos || pos === 0) {
      return this.setPos(pos);
    } else {
      return this.getPos();
    }
  },
  position: function(pos) {
    if (oDocument.selection) {
      return this.getIEPosition(pos);
    } else {
      return this.getPosition(pos);
    }
  },
  offset: function(pos) {
    var offset;
    offset = this.getOffset(pos);
    return offset;
  }
};

oDocument = null;

oWindow = null;

oFrame = null;

setContextBy = function(settings) {
  var iframe;
  if (iframe = settings != null ? settings.iframe : void 0) {
    oFrame = iframe;
    oWindow = iframe.contentWindow;
    return oDocument = iframe.contentDocument || oWindow.document;
  } else {
    oFrame = void 0;
    oWindow = window;
    return oDocument = document;
  }
};

discoveryIframeOf = function($dom) {
  var error;
  oDocument = $dom[0].ownerDocument;
  oWindow = oDocument.defaultView || oDocument.parentWindow;
  try {
    return oFrame = oWindow.frameElement;
  } catch (_error) {
    error = _error;
  }
};

$.fn.caret = function(method, value, settings) {
  var caret;
  if (methods[method]) {
    if ($.isPlainObject(value)) {
      setContextBy(value);
      value = void 0;
    } else {
      setContextBy(settings);
    }
    caret = Utils.contentEditable(this) ? new EditableCaret(this) : new InputCaret(this);
    return methods[method].apply(caret, [value]);
  } else {
    return $.error("Method " + method + " does not exist on jQuery.caret");
  }
};

$.fn.caret.EditableCaret = EditableCaret;

$.fn.caret.InputCaret = InputCaret;

$.fn.caret.Utils = Utils;

$.fn.caret.apis = methods;


}));


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jquery.atwho - v1.4.0 %>
* Copyright (c) 2015 chord.luo <chord.luo@gmail.com>;
* homepage: http://ichord.github.com/At.js
* Licensed MIT
*/
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(137)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (a0) {
      return (factory(a0));
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function (jquery) {

var $, Api, App, Controller, DEFAULT_CALLBACKS, EditableController, KEY_CODE, Model, TextareaController, View,
  slice = [].slice,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

$ = jquery;

App = (function() {
  function App(inputor) {
    this.currentFlag = null;
    this.controllers = {};
    this.aliasMaps = {};
    this.$inputor = $(inputor);
    this.setupRootElement();
    this.listen();
  }

  App.prototype.createContainer = function(doc) {
    var ref;
    if ((ref = this.$el) != null) {
      ref.remove();
    }
    return $(doc.body).append(this.$el = $("<div class='atwho-container'></div>"));
  };

  App.prototype.setupRootElement = function(iframe, asRoot) {
    var error;
    if (asRoot == null) {
      asRoot = false;
    }
    if (iframe) {
      this.window = iframe.contentWindow;
      this.document = iframe.contentDocument || this.window.document;
      this.iframe = iframe;
    } else {
      this.document = this.$inputor[0].ownerDocument;
      this.window = this.document.defaultView || this.document.parentWindow;
      try {
        this.iframe = this.window.frameElement;
      } catch (_error) {
        error = _error;
        this.iframe = null;
        if ($.fn.atwho.debug) {
          throw new Error("iframe auto-discovery is failed.\nPlease use `setIframe` to set the target iframe manually.\n" + error);
        }
      }
    }
    return this.createContainer((this.iframeAsRoot = asRoot) ? this.document : document);
  };

  App.prototype.controller = function(at) {
    var c, current, currentFlag, ref;
    if (this.aliasMaps[at]) {
      current = this.controllers[this.aliasMaps[at]];
    } else {
      ref = this.controllers;
      for (currentFlag in ref) {
        c = ref[currentFlag];
        if (currentFlag === at) {
          current = c;
          break;
        }
      }
    }
    if (current) {
      return current;
    } else {
      return this.controllers[this.currentFlag];
    }
  };

  App.prototype.setContextFor = function(at) {
    this.currentFlag = at;
    return this;
  };

  App.prototype.reg = function(flag, setting) {
    var base, controller;
    controller = (base = this.controllers)[flag] || (base[flag] = this.$inputor.is('[contentEditable]') ? new EditableController(this, flag) : new TextareaController(this, flag));
    if (setting.alias) {
      this.aliasMaps[setting.alias] = flag;
    }
    controller.init(setting);
    return this;
  };

  App.prototype.listen = function() {
    return this.$inputor.on('compositionstart', (function(_this) {
      return function(e) {
        var ref;
        if ((ref = _this.controller()) != null) {
          ref.view.hide();
        }
        _this.isComposing = true;
        return null;
      };
    })(this)).on('compositionend', (function(_this) {
      return function(e) {
        _this.isComposing = false;
        return null;
      };
    })(this)).on('keyup.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeyup(e);
      };
    })(this)).on('keydown.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeydown(e);
      };
    })(this)).on('blur.atwhoInner', (function(_this) {
      return function(e) {
        var c;
        if (c = _this.controller()) {
          c.expectedQueryCBId = null;
          return c.view.hide(e, c.getOpt("displayTimeout"));
        }
      };
    })(this)).on('click.atwhoInner', (function(_this) {
      return function(e) {
        return _this.dispatch(e);
      };
    })(this)).on('scroll.atwhoInner', (function(_this) {
      return function() {
        var lastScrollTop;
        lastScrollTop = _this.$inputor.scrollTop();
        return function(e) {
          var currentScrollTop, ref;
          currentScrollTop = e.target.scrollTop;
          if (lastScrollTop !== currentScrollTop) {
            if ((ref = _this.controller()) != null) {
              ref.view.hide(e);
            }
          }
          lastScrollTop = currentScrollTop;
          return true;
        };
      };
    })(this)());
  };

  App.prototype.shutdown = function() {
    var _, c, ref;
    ref = this.controllers;
    for (_ in ref) {
      c = ref[_];
      c.destroy();
      delete this.controllers[_];
    }
    this.$inputor.off('.atwhoInner');
    return this.$el.remove();
  };

  App.prototype.dispatch = function(e) {
    var _, c, ref, results;
    ref = this.controllers;
    results = [];
    for (_ in ref) {
      c = ref[_];
      results.push(c.lookUp(e));
    }
    return results;
  };

  App.prototype.onKeyup = function(e) {
    var ref;
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        if ((ref = this.controller()) != null) {
          ref.view.hide();
        }
        break;
      case KEY_CODE.DOWN:
      case KEY_CODE.UP:
      case KEY_CODE.CTRL:
      case KEY_CODE.ENTER:
        $.noop();
        break;
      case KEY_CODE.P:
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          this.dispatch(e);
        }
        break;
      default:
        this.dispatch(e);
    }
  };

  App.prototype.onKeydown = function(e) {
    var ref, view;
    view = (ref = this.controller()) != null ? ref.view : void 0;
    if (!(view && view.visible())) {
      return;
    }
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        view.hide(e);
        break;
      case KEY_CODE.UP:
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.DOWN:
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.P:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.TAB:
      case KEY_CODE.ENTER:
      case KEY_CODE.SPACE:
        if (!view.visible()) {
          return;
        }
        if (!this.controller().getOpt('spaceSelectsMatch') && e.keyCode === KEY_CODE.SPACE) {
          return;
        }
        if (!this.controller().getOpt('tabSelectsMatch') && e.keyCode === KEY_CODE.TAB) {
          return;
        }
        if (view.highlighted()) {
          e.preventDefault();
          view.choose(e);
        } else {
          view.hide(e);
        }
        break;
      default:
        $.noop();
    }
  };

  return App;

})();

Controller = (function() {
  Controller.prototype.uid = function() {
    return (Math.random().toString(16) + "000000000").substr(2, 8) + (new Date().getTime());
  };

  function Controller(app1, at1) {
    this.app = app1;
    this.at = at1;
    this.$inputor = this.app.$inputor;
    this.id = this.$inputor[0].id || this.uid();
    this.expectedQueryCBId = null;
    this.setting = null;
    this.query = null;
    this.pos = 0;
    this.range = null;
    if ((this.$el = $("#atwho-ground-" + this.id, this.app.$el)).length === 0) {
      this.app.$el.append(this.$el = $("<div id='atwho-ground-" + this.id + "'></div>"));
    }
    this.model = new Model(this);
    this.view = new View(this);
  }

  Controller.prototype.init = function(setting) {
    this.setting = $.extend({}, this.setting || $.fn.atwho["default"], setting);
    this.view.init();
    return this.model.reload(this.setting.data);
  };

  Controller.prototype.destroy = function() {
    this.trigger('beforeDestroy');
    this.model.destroy();
    this.view.destroy();
    return this.$el.remove();
  };

  Controller.prototype.callDefault = function() {
    var args, error, funcName;
    funcName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    try {
      return DEFAULT_CALLBACKS[funcName].apply(this, args);
    } catch (_error) {
      error = _error;
      return $.error(error + " Or maybe At.js doesn't have function " + funcName);
    }
  };

  Controller.prototype.trigger = function(name, data) {
    var alias, eventName;
    if (data == null) {
      data = [];
    }
    data.push(this);
    alias = this.getOpt('alias');
    eventName = alias ? name + "-" + alias + ".atwho" : name + ".atwho";
    return this.$inputor.trigger(eventName, data);
  };

  Controller.prototype.callbacks = function(funcName) {
    return this.getOpt("callbacks")[funcName] || DEFAULT_CALLBACKS[funcName];
  };

  Controller.prototype.getOpt = function(at, default_value) {
    var e;
    try {
      return this.setting[at];
    } catch (_error) {
      e = _error;
      return null;
    }
  };

  Controller.prototype.insertContentFor = function($li) {
    var data, tpl;
    tpl = this.getOpt('insertTpl');
    data = $.extend({}, $li.data('item-data'), {
      'atwho-at': this.at
    });
    return this.callbacks("tplEval").call(this, tpl, data, "onInsert");
  };

  Controller.prototype.renderView = function(data) {
    var searchKey;
    searchKey = this.getOpt("searchKey");
    data = this.callbacks("sorter").call(this, this.query.text, data.slice(0, 1001), searchKey);
    return this.view.render(data.slice(0, this.getOpt('limit')));
  };

  Controller.arrayToDefaultHash = function(data) {
    var i, item, len, results;
    if (!$.isArray(data)) {
      return data;
    }
    results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if ($.isPlainObject(item)) {
        results.push(item);
      } else {
        results.push({
          name: item
        });
      }
    }
    return results;
  };

  Controller.prototype.lookUp = function(e) {
    var query, wait;
    if (e && e.type === 'click' && !this.getOpt('lookUpOnClick')) {
      return;
    }
    if (this.getOpt('suspendOnComposing') && this.app.isComposing) {
      return;
    }
    query = this.catchQuery(e);
    if (!query) {
      this.expectedQueryCBId = null;
      return query;
    }
    this.app.setContextFor(this.at);
    if (wait = this.getOpt('delay')) {
      this._delayLookUp(query, wait);
    } else {
      this._lookUp(query);
    }
    return query;
  };

  Controller.prototype._delayLookUp = function(query, wait) {
    var now, remaining;
    now = Date.now ? Date.now() : new Date().getTime();
    this.previousCallTime || (this.previousCallTime = now);
    remaining = wait - (now - this.previousCallTime);
    if ((0 < remaining && remaining < wait)) {
      this.previousCallTime = now;
      this._stopDelayedCall();
      return this.delayedCallTimeout = setTimeout((function(_this) {
        return function() {
          _this.previousCallTime = 0;
          _this.delayedCallTimeout = null;
          return _this._lookUp(query);
        };
      })(this), wait);
    } else {
      this._stopDelayedCall();
      if (this.previousCallTime !== now) {
        this.previousCallTime = 0;
      }
      return this._lookUp(query);
    }
  };

  Controller.prototype._stopDelayedCall = function() {
    if (this.delayedCallTimeout) {
      clearTimeout(this.delayedCallTimeout);
      return this.delayedCallTimeout = null;
    }
  };

  Controller.prototype._generateQueryCBId = function() {
    return {};
  };

  Controller.prototype._lookUp = function(query) {
    var _callback;
    _callback = function(queryCBId, data) {
      if (queryCBId !== this.expectedQueryCBId) {
        return;
      }
      if (data && data.length > 0) {
        return this.renderView(this.constructor.arrayToDefaultHash(data));
      } else {
        return this.view.hide();
      }
    };
    this.expectedQueryCBId = this._generateQueryCBId();
    return this.model.query(query.text, $.proxy(_callback, this, this.expectedQueryCBId));
  };

  return Controller;

})();

TextareaController = (function(superClass) {
  extend(TextareaController, superClass);

  function TextareaController() {
    return TextareaController.__super__.constructor.apply(this, arguments);
  }

  TextareaController.prototype.catchQuery = function() {
    var caretPos, content, end, isString, query, start, subtext;
    content = this.$inputor.val();
    caretPos = this.$inputor.caret('pos', {
      iframe: this.app.iframe
    });
    subtext = content.slice(0, caretPos);
    query = this.callbacks("matcher").call(this, this.at, subtext, this.getOpt('startWithSpace'));
    isString = typeof query === 'string';
    if (isString && query.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString && query.length <= this.getOpt('maxLen', 20)) {
      start = caretPos - query.length;
      end = start + query.length;
      this.pos = start;
      query = {
        'text': query,
        'headPos': start,
        'endPos': end
      };
      this.trigger("matched", [this.at, query.text]);
    } else {
      query = null;
      this.view.hide();
    }
    return this.query = query;
  };

  TextareaController.prototype.rect = function() {
    var c, iframeOffset, scaleBottom;
    if (!(c = this.$inputor.caret('offset', this.pos - 1, {
      iframe: this.app.iframe
    }))) {
      return;
    }
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = $(this.app.iframe).offset();
      c.left += iframeOffset.left;
      c.top += iframeOffset.top;
    }
    scaleBottom = this.app.document.selection ? 0 : 2;
    return {
      left: c.left,
      top: c.top,
      bottom: c.top + c.height + scaleBottom
    };
  };

  TextareaController.prototype.insert = function(content, $li) {
    var $inputor, source, startStr, suffix, text;
    $inputor = this.$inputor;
    source = $inputor.val();
    startStr = source.slice(0, Math.max(this.query.headPos - this.at.length, 0));
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || " ";
    content += suffix;
    text = "" + startStr + content + (source.slice(this.query['endPos'] || 0));
    $inputor.val(text);
    $inputor.caret('pos', startStr.length + content.length, {
      iframe: this.app.iframe
    });
    if (!$inputor.is(':focus')) {
      $inputor.focus();
    }
    return $inputor.change();
  };

  return TextareaController;

})(Controller);

EditableController = (function(superClass) {
  extend(EditableController, superClass);

  function EditableController() {
    return EditableController.__super__.constructor.apply(this, arguments);
  }

  EditableController.prototype._getRange = function() {
    var sel;
    sel = this.app.window.getSelection();
    if (sel.rangeCount > 0) {
      return sel.getRangeAt(0);
    }
  };

  EditableController.prototype._setRange = function(position, node, range) {
    if (range == null) {
      range = this._getRange();
    }
    if (!range) {
      return;
    }
    node = $(node)[0];
    if (position === 'after') {
      range.setEndAfter(node);
      range.setStartAfter(node);
    } else {
      range.setEndBefore(node);
      range.setStartBefore(node);
    }
    range.collapse(false);
    return this._clearRange(range);
  };

  EditableController.prototype._clearRange = function(range) {
    var sel;
    if (range == null) {
      range = this._getRange();
    }
    sel = this.app.window.getSelection();
    if (this.ctrl_a_pressed == null) {
      sel.removeAllRanges();
      return sel.addRange(range);
    }
  };

  EditableController.prototype._movingEvent = function(e) {
    var ref;
    return e.type === 'click' || ((ref = e.which) === KEY_CODE.RIGHT || ref === KEY_CODE.LEFT || ref === KEY_CODE.UP || ref === KEY_CODE.DOWN);
  };

  EditableController.prototype._unwrap = function(node) {
    var next;
    node = $(node).unwrap().get(0);
    if ((next = node.nextSibling) && next.nodeValue) {
      node.nodeValue += next.nodeValue;
      $(next).remove();
    }
    return node;
  };

  EditableController.prototype.catchQuery = function(e) {
    var $inserted, $query, _range, index, inserted, isString, lastNode, matched, offset, query, query_content, range;
    if (!(range = this._getRange())) {
      return;
    }
    if (!range.collapsed) {
      return;
    }
    if (e.which === KEY_CODE.ENTER) {
      ($query = $(range.startContainer).closest('.atwho-query')).contents().unwrap();
      if ($query.is(':empty')) {
        $query.remove();
      }
      ($query = $(".atwho-query", this.app.document)).text($query.text()).contents().last().unwrap();
      this._clearRange();
      return;
    }
    if (/firefox/i.test(navigator.userAgent)) {
      if ($(range.startContainer).is(this.$inputor)) {
        this._clearRange();
        return;
      }
      if (e.which === KEY_CODE.BACKSPACE && range.startContainer.nodeType === document.ELEMENT_NODE && (offset = range.startOffset - 1) >= 0) {
        _range = range.cloneRange();
        _range.setStart(range.startContainer, offset);
        if ($(_range.cloneContents()).contents().last().is('.atwho-inserted')) {
          inserted = $(range.startContainer).contents().get(offset);
          this._setRange('after', $(inserted).contents().last());
        }
      } else if (e.which === KEY_CODE.LEFT && range.startContainer.nodeType === document.TEXT_NODE) {
        $inserted = $(range.startContainer.previousSibling);
        if ($inserted.is('.atwho-inserted') && range.startOffset === 0) {
          this._setRange('after', $inserted.contents().last());
        }
      }
    }
    $(range.startContainer).closest('.atwho-inserted').addClass('atwho-query').siblings().removeClass('atwho-query');
    if (($query = $(".atwho-query", this.app.document)).length > 0 && $query.is(':empty') && $query.text().length === 0) {
      $query.remove();
    }
    if (!this._movingEvent(e)) {
      $query.removeClass('atwho-inserted');
    }
    if ($query.length > 0) {
      switch (e.which) {
        case KEY_CODE.LEFT:
          this._setRange('before', $query.get(0), range);
          $query.removeClass('atwho-query');
          return;
        case KEY_CODE.RIGHT:
          this._setRange('after', $query.get(0).nextSibling, range);
          $query.removeClass('atwho-query');
          return;
      }
    }
    if ($query.length > 0 && (query_content = $query.attr('data-atwho-at-query'))) {
      $query.empty().html(query_content).attr('data-atwho-at-query', null);
      this._setRange('after', $query.get(0), range);
    }
    _range = range.cloneRange();
    _range.setStart(range.startContainer, 0);
    matched = this.callbacks("matcher").call(this, this.at, _range.toString(), this.getOpt('startWithSpace'));
    isString = typeof matched === 'string';
    if ($query.length === 0 && isString && (index = range.startOffset - this.at.length - matched.length) >= 0) {
      range.setStart(range.startContainer, index);
      $query = $('<span/>', this.app.document).attr(this.getOpt("editableAtwhoQueryAttrs")).addClass('atwho-query');
      range.surroundContents($query.get(0));
      lastNode = $query.contents().last().get(0);
      if (/firefox/i.test(navigator.userAgent)) {
        range.setStart(lastNode, lastNode.length);
        range.setEnd(lastNode, lastNode.length);
        this._clearRange(range);
      } else {
        this._setRange('after', lastNode, range);
      }
    }
    if (isString && matched.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString && matched.length <= this.getOpt('maxLen', 20)) {
      query = {
        text: matched,
        el: $query
      };
      this.trigger("matched", [this.at, query.text]);
      return this.query = query;
    } else {
      this.view.hide();
      this.query = {
        el: $query
      };
      if ($query.text().indexOf(this.at) >= 0) {
        if (this._movingEvent(e) && $query.hasClass('atwho-inserted')) {
          $query.removeClass('atwho-query');
        } else if (false !== this.callbacks('afterMatchFailed').call(this, this.at, $query)) {
          this._setRange("after", this._unwrap($query.text($query.text()).contents().first()));
        }
      }
      return null;
    }
  };

  EditableController.prototype.rect = function() {
    var $iframe, iframeOffset, rect;
    rect = this.query.el.offset();
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = ($iframe = $(this.app.iframe)).offset();
      rect.left += iframeOffset.left - this.$inputor.scrollLeft();
      rect.top += iframeOffset.top - this.$inputor.scrollTop();
    }
    rect.bottom = rect.top + this.query.el.height();
    return rect;
  };

  EditableController.prototype.insert = function(content, $li) {
    var data, range, suffix, suffixNode;
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || "\u00A0";
    data = $li.data('item-data');
    this.query.el.removeClass('atwho-query').addClass('atwho-inserted').html(content).attr('data-atwho-at-query', "" + data['atwho-at'] + this.query.text);
    if (range = this._getRange()) {
      range.setEndAfter(this.query.el[0]);
      range.collapse(false);
      range.insertNode(suffixNode = this.app.document.createTextNode("\u200D" + suffix));
      this._setRange('after', suffixNode, range);
    }
    if (!this.$inputor.is(':focus')) {
      this.$inputor.focus();
    }
    return this.$inputor.change();
  };

  return EditableController;

})(Controller);

Model = (function() {
  function Model(context) {
    this.context = context;
    this.at = this.context.at;
    this.storage = this.context.$inputor;
  }

  Model.prototype.destroy = function() {
    return this.storage.data(this.at, null);
  };

  Model.prototype.saved = function() {
    return this.fetch() > 0;
  };

  Model.prototype.query = function(query, callback) {
    var _remoteFilter, data, searchKey;
    data = this.fetch();
    searchKey = this.context.getOpt("searchKey");
    data = this.context.callbacks('filter').call(this.context, query, data, searchKey) || [];
    _remoteFilter = this.context.callbacks('remoteFilter');
    if (data.length > 0 || (!_remoteFilter && data.length === 0)) {
      return callback(data);
    } else {
      return _remoteFilter.call(this.context, query, callback);
    }
  };

  Model.prototype.fetch = function() {
    return this.storage.data(this.at) || [];
  };

  Model.prototype.save = function(data) {
    return this.storage.data(this.at, this.context.callbacks("beforeSave").call(this.context, data || []));
  };

  Model.prototype.load = function(data) {
    if (!(this.saved() || !data)) {
      return this._load(data);
    }
  };

  Model.prototype.reload = function(data) {
    return this._load(data);
  };

  Model.prototype._load = function(data) {
    if (typeof data === "string") {
      return $.ajax(data, {
        dataType: "json"
      }).done((function(_this) {
        return function(data) {
          return _this.save(data);
        };
      })(this));
    } else {
      return this.save(data);
    }
  };

  return Model;

})();

View = (function() {
  function View(context) {
    this.context = context;
    this.$el = $("<div class='atwho-view'><ul class='atwho-view-ul'></ul></div>");
    this.timeoutID = null;
    this.context.$el.append(this.$el);
    this.bindEvent();
  }

  View.prototype.init = function() {
    var id;
    id = this.context.getOpt("alias") || this.context.at.charCodeAt(0);
    return this.$el.attr({
      'id': "at-view-" + id
    });
  };

  View.prototype.destroy = function() {
    return this.$el.remove();
  };

  View.prototype.bindEvent = function() {
    var $menu;
    $menu = this.$el.find('ul');
    return $menu.on('mouseenter.atwho-view', 'li', function(e) {
      $menu.find('.cur').removeClass('cur');
      return $(e.currentTarget).addClass('cur');
    }).on('click.atwho-view', 'li', (function(_this) {
      return function(e) {
        $menu.find('.cur').removeClass('cur');
        $(e.currentTarget).addClass('cur');
        _this.choose(e);
        return e.preventDefault();
      };
    })(this));
  };

  View.prototype.visible = function() {
    return this.$el.is(":visible");
  };

  View.prototype.highlighted = function() {
    return this.$el.find(".cur").length > 0;
  };

  View.prototype.choose = function(e) {
    var $li, content;
    if (($li = this.$el.find(".cur")).length) {
      content = this.context.insertContentFor($li);
      this.context._stopDelayedCall();
      this.context.insert(this.context.callbacks("beforeInsert").call(this.context, content, $li), $li);
      this.context.trigger("inserted", [$li, e]);
      this.hide(e);
    }
    if (this.context.getOpt("hideWithoutSuffix")) {
      return this.stopShowing = true;
    }
  };

  View.prototype.reposition = function(rect) {
    var _window, offset, overflowOffset, ref;
    _window = this.context.app.iframeAsRoot ? this.context.app.window : window;
    if (rect.bottom + this.$el.height() - $(_window).scrollTop() > $(_window).height()) {
      rect.bottom = rect.top - this.$el.height();
    }
    if (rect.left > (overflowOffset = $(_window).width() - this.$el.width() - 5)) {
      rect.left = overflowOffset;
    }
    offset = {
      left: rect.left,
      top: rect.bottom
    };
    if ((ref = this.context.callbacks("beforeReposition")) != null) {
      ref.call(this.context, offset);
    }
    this.$el.offset(offset);
    return this.context.trigger("reposition", [offset]);
  };

  View.prototype.next = function() {
    var cur, next;
    cur = this.$el.find('.cur').removeClass('cur');
    next = cur.next();
    if (!next.length) {
      next = this.$el.find('li:first');
    }
    next.addClass('cur');
    return this.scrollTop(Math.max(0, cur.innerHeight() * (next.index() + 2) - this.$el.height()));
  };

  View.prototype.prev = function() {
    var cur, prev;
    cur = this.$el.find('.cur').removeClass('cur');
    prev = cur.prev();
    if (!prev.length) {
      prev = this.$el.find('li:last');
    }
    prev.addClass('cur');
    return this.scrollTop(Math.max(0, cur.innerHeight() * (prev.index() + 2) - this.$el.height()));
  };

  View.prototype.scrollTop = function(scrollTop) {
    var scrollDuration;
    scrollDuration = this.context.getOpt('scrollDuration');
    if (scrollDuration) {
      return this.$el.animate({
        scrollTop: scrollTop
      }, scrollDuration);
    } else {
      return this.$el.scrollTop(scrollTop);
    }
  };

  View.prototype.show = function() {
    var rect;
    if (this.stopShowing) {
      this.stopShowing = false;
      return;
    }
    if (!this.visible()) {
      this.$el.show();
      this.$el.scrollTop(0);
      this.context.trigger('shown');
    }
    if (rect = this.context.rect()) {
      return this.reposition(rect);
    }
  };

  View.prototype.hide = function(e, time) {
    var callback;
    if (!this.visible()) {
      return;
    }
    if (isNaN(time)) {
      this.$el.hide();
      return this.context.trigger('hidden', [e]);
    } else {
      callback = (function(_this) {
        return function() {
          return _this.hide();
        };
      })(this);
      clearTimeout(this.timeoutID);
      return this.timeoutID = setTimeout(callback, time);
    }
  };

  View.prototype.render = function(list) {
    var $li, $ul, i, item, len, li, tpl;
    if (!($.isArray(list) && list.length > 0)) {
      this.hide();
      return;
    }
    this.$el.find('ul').empty();
    $ul = this.$el.find('ul');
    tpl = this.context.getOpt('displayTpl');
    for (i = 0, len = list.length; i < len; i++) {
      item = list[i];
      item = $.extend({}, item, {
        'atwho-at': this.context.at
      });
      li = this.context.callbacks("tplEval").call(this.context, tpl, item, "onDisplay");
      $li = $(this.context.callbacks("highlighter").call(this.context, li, this.context.query.text));
      $li.data("item-data", item);
      $ul.append($li);
    }
    this.show();
    if (this.context.getOpt('highlightFirst')) {
      return $ul.find("li:first").addClass("cur");
    }
  };

  return View;

})();

KEY_CODE = {
  DOWN: 40,
  UP: 38,
  ESC: 27,
  TAB: 9,
  ENTER: 13,
  CTRL: 17,
  A: 65,
  P: 80,
  N: 78,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  BACKSPACE: 8,
  SPACE: 32
};

DEFAULT_CALLBACKS = {
  beforeSave: function(data) {
    return Controller.arrayToDefaultHash(data);
  },
  matcher: function(flag, subtext, should_startWithSpace, acceptSpaceBar) {
    var _a, _y, match, regexp, space;
    flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    if (should_startWithSpace) {
      flag = '(?:^|\\s)' + flag;
    }
    _a = decodeURI("%C3%80");
    _y = decodeURI("%C3%BF");
    space = acceptSpaceBar ? "\ " : "";
    regexp = new RegExp(flag + "([A-Za-z" + _a + "-" + _y + "0-9_" + space + "\'\.\+\-]*)$|" + flag + "([^\\x00-\\xff]*)$", 'gi');
    match = regexp.exec(subtext);
    if (match) {
      return match[2] || match[1];
    } else {
      return null;
    }
  },
  filter: function(query, data, searchKey) {
    var _results, i, item, len;
    _results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if (~new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase())) {
        _results.push(item);
      }
    }
    return _results;
  },
  remoteFilter: null,
  sorter: function(query, items, searchKey) {
    var _results, i, item, len;
    if (!query) {
      return items;
    }
    _results = [];
    for (i = 0, len = items.length; i < len; i++) {
      item = items[i];
      item.atwho_order = new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase());
      if (item.atwho_order > -1) {
        _results.push(item);
      }
    }
    return _results.sort(function(a, b) {
      return a.atwho_order - b.atwho_order;
    });
  },
  tplEval: function(tpl, map) {
    var error, template;
    template = tpl;
    try {
      if (typeof tpl !== 'string') {
        template = tpl(map);
      }
      return template.replace(/\$\{([^\}]*)\}/g, function(tag, key, pos) {
        return map[key];
      });
    } catch (_error) {
      error = _error;
      return "";
    }
  },
  highlighter: function(li, query) {
    var regexp;
    if (!query) {
      return li;
    }
    regexp = new RegExp(">\\s*(\\w*?)(" + query.replace("+", "\\+") + ")(\\w*)\\s*<", 'ig');
    return li.replace(regexp, function(str, $1, $2, $3) {
      return '> ' + $1 + '<strong>' + $2 + '</strong>' + $3 + ' <';
    });
  },
  beforeInsert: function(value, $li) {
    return value;
  },
  beforeReposition: function(offset) {
    return offset;
  },
  afterMatchFailed: function(at, el) {}
};

Api = {
  load: function(at, data) {
    var c;
    if (c = this.controller(at)) {
      return c.model.load(data);
    }
  },
  isSelecting: function() {
    var ref;
    return !!((ref = this.controller()) != null ? ref.view.visible() : void 0);
  },
  hide: function() {
    var ref;
    return (ref = this.controller()) != null ? ref.view.hide() : void 0;
  },
  reposition: function() {
    var c;
    if (c = this.controller()) {
      return c.view.reposition(c.rect());
    }
  },
  setIframe: function(iframe, asRoot) {
    this.setupRootElement(iframe, asRoot);
    return null;
  },
  run: function() {
    return this.dispatch();
  },
  destroy: function() {
    this.shutdown();
    return this.$inputor.data('atwho', null);
  }
};

$.fn.atwho = function(method) {
  var _args, result;
  _args = arguments;
  result = null;
  this.filter('textarea, input, [contenteditable=""], [contenteditable=true]').each(function() {
    var $this, app;
    if (!(app = ($this = $(this)).data("atwho"))) {
      $this.data('atwho', (app = new App(this)));
    }
    if (typeof method === 'object' || !method) {
      return app.reg(method.at, method);
    } else if (Api[method] && app) {
      return result = Api[method].apply(app, Array.prototype.slice.call(_args, 1));
    } else {
      return $.error("Method " + method + " does not exist on jQuery.atwho");
    }
  });
  if (result != null) {
    return result;
  } else {
    return this;
  }
};

$.fn.atwho["default"] = {
  at: void 0,
  alias: void 0,
  data: null,
  displayTpl: "<li>${name}</li>",
  insertTpl: "${atwho-at}${name}",
  callbacks: DEFAULT_CALLBACKS,
  searchKey: "name",
  suffix: void 0,
  hideWithoutSuffix: false,
  startWithSpace: true,
  highlightFirst: true,
  limit: 5,
  maxLen: 20,
  minLen: 0,
  displayTimeout: 300,
  delay: null,
  spaceSelectsMatch: false,
  tabSelectsMatch: true,
  editableAtwhoQueryAttrs: {},
  scrollDuration: 150,
  suspendOnComposing: true,
  lookUpOnClick: true
};

$.fn.atwho.debug = false;


}));


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(53);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Backbone"] = __webpack_require__(40);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Chart"] = __webpack_require__(1464);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 2.6.0
 *
 * Copyright 2017 Nick Downie
 * Released under the MIT license
 * https://github.com/chartjs/Chart.js/blob/master/LICENSE.md
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Chart = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){

},{}],2:[function(require,module,exports){
/* MIT license */
var colorNames = require(6);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/,
       hex =  /^#([a-fA-F0-9]{6})$/,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}

},{"6":6}],3:[function(require,module,exports){
/* MIT license */
var convert = require(5);
var string = require(2);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;

},{"2":2,"5":5}],4:[function(require,module,exports){
/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}

},{}],5:[function(require,module,exports){
var conversions = require(4);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;
},{"4":4}],6:[function(require,module,exports){
module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};
},{}],7:[function(require,module,exports){
/**
 * @namespace Chart
 */
var Chart = require(28)();

require(26)(Chart);
require(40)(Chart);
require(22)(Chart);
require(25)(Chart);
require(30)(Chart);
require(21)(Chart);
require(23)(Chart);
require(24)(Chart);
require(29)(Chart);
require(32)(Chart);
require(33)(Chart);
require(31)(Chart);
require(27)(Chart);
require(34)(Chart);

require(35)(Chart);
require(36)(Chart);
require(37)(Chart);
require(38)(Chart);

require(46)(Chart);
require(44)(Chart);
require(45)(Chart);
require(47)(Chart);
require(48)(Chart);
require(49)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
require(15)(Chart);
require(16)(Chart);
require(17)(Chart);
require(18)(Chart);
require(19)(Chart);
require(20)(Chart);

require(8)(Chart);
require(9)(Chart);
require(10)(Chart);
require(11)(Chart);
require(12)(Chart);
require(13)(Chart);
require(14)(Chart);

// Loading built-it plugins
var plugins = [];

plugins.push(
    require(41)(Chart),
    require(42)(Chart),
    require(43)(Chart)
);

Chart.plugins.register(plugins);

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

},{"10":10,"11":11,"12":12,"13":13,"14":14,"15":15,"16":16,"17":17,"18":18,"19":19,"20":20,"21":21,"22":22,"23":23,"24":24,"25":25,"26":26,"27":27,"28":28,"29":29,"30":30,"31":31,"32":32,"33":33,"34":34,"35":35,"36":36,"37":37,"38":38,"40":40,"41":41,"42":42,"43":43,"44":44,"45":45,"46":46,"47":47,"48":48,"49":49,"8":8,"9":9}],8:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};

},{}],9:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};

},{}],11:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};

},{}],12:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};

},{}],13:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};

},{}],14:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var defaultConfig = {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				type: 'linear', // scatter should not use a category axis
				position: 'bottom',
				id: 'x-axis-1' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-1'
			}]
		},

		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(tooltipItem) {
					return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
				}
			}
		}
	};

	// Register the default config for this type
	Chart.defaults.scatter = defaultConfig;

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};

};

},{}],15:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.bar = {
		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',

				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,

				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],
			yAxes: [{
				type: 'linear'
			}]
		}
	};

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: Chart.elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var elements = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				me.updateElement(elements[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset? base : vpixels.base;
			model.x = horizontal? reset? base : vpixels.head : ipixels.center;
			model.y = horizontal? ipixels.center : reset? base : vpixels.head;
			model.height = horizontal? ipixels.size : undefined;
			model.width = horizontal? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks.length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @private
		 */
		getStackIndex: function(datasetIndex) {
			return this.getStackCount(datasetIndex) - 1;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var options = scale.options;
			var stackCount = me.getStackCount();
			var fullSize = scale.isHorizontal()? scale.width : scale.height;
			var tickSize = fullSize / scale.ticks.length;
			var categorySize = tickSize * options.categoryPercentage;
			var fullBarSize = categorySize / stackCount;
			var barSize = fullBarSize * options.barPercentage;

			barSize = Math.min(
				helpers.getValueOrDefault(options.barThickness, barSize),
				helpers.getValueOrDefault(options.maxBarThickness, Infinity));

			return {
				stackCount: stackCount,
				tickSize: tickSize,
				categorySize: categorySize,
				categorySpacing: tickSize - categorySize,
				fullBarSize: fullBarSize,
				barSize: barSize,
				barSpacing: fullBarSize - barSize,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = Number(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = Number(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var scale = ruler.scale;
			var isCombo = me.chart.isCombo;
			var stackIndex = me.getStackIndex(datasetIndex);
			var base = scale.getPixelForValue(null, index, datasetIndex, isCombo);
			var size = ruler.barSize;

			base -= isCombo? ruler.tickSize / 2 : 0;
			base += ruler.fullBarSize * stackIndex;
			base += ruler.categorySpacing / 2;
			base += ruler.barSpacing / 2;

			return {
				size: size,
				base: base,
				head: base + size,
				center: base + size / 2
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var elements = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = elements.length;
			var i = 0;
			var d;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i<ilen; ++i) {
				d = dataset.data[i];
				if (d !== null && d !== undefined && !isNaN(d)) {
					elements[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});


	// including horizontalBar in the bar file, instead of a file of its own
	// it extends bar (like pie extends doughnut)
	Chart.defaults.horizontalBar = {
		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
			yAxes: [{
				position: 'left',
				type: 'category',

				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,

				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
		tooltips: {
			callbacks: {
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';

					if (tooltipItems.length > 0) {
						if (tooltipItems[0].yLabel) {
							title = tooltipItems[0].yLabel;
						} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
							title = data.labels[tooltipItems[0].index];
						}
					}

					return title;
				},
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.xLabel;
				}
			}
		}
	};

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};

},{}],16:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.bubble = {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},

		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					return datasetLabel + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	};

	Chart.controllers.bubble = Chart.DatasetController.extend({

		dataElementType: Chart.elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);

			var custom = point.custom || {};
			var dataset = me.getDataset();
			var data = dataset.data[index];
			var pointElementOptions = me.chart.options.elements.point;
			var dsIndex = me.index;

			helpers.extend(point, {
				// Utility
				_xScale: xScale,
				_yScale: yScale,
				_datasetIndex: dsIndex,
				_index: index,

				// Desired view properties
				_model: {
					x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
					y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
					// Appearance
					radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
				}
			});

			// Trick to reset the styles of the point
			Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);

			var model = point._model;
			model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));

			point.pivot();
		},

		getRadius: function(value) {
			return value.r || this.chart.options.elements.point.radius;
		},

		setHoverStyle: function(point) {
			var me = this;
			Chart.DatasetController.prototype.setHoverStyle.call(me, point);

			// Radius
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;
			model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
		},

		removeHoverStyle: function(point) {
			var me = this;
			Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);

			var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
		}
	});
};

},{}],17:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers,
		defaults = Chart.defaults;

	defaults.doughnut = {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		aspectRatio: 1,
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}

				chart.update();
			}
		},

		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,

		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,

		// The total circumference of the chart.
		circumference: Math.PI * 2.0,

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

					if (helpers.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}

					return dataLabel;
				}
			}
		}
	};

	defaults.pie = helpers.clone(defaults.doughnut);
	helpers.extend(defaults.pie, {
		cutoutPercentage: 0
	});


	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: Chart.elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart,
				chartArea = chart.chartArea,
				opts = chart.options,
				arcOpts = opts.elements.arc,
				availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
				availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
				minSize = Math.min(availableWidth, availableHeight),
				offset = {
					x: 0,
					y: 0
				},
				meta = me.getMeta(),
				cutoutPercentage = opts.cutoutPercentage,
				circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart,
				chartArea = chart.chartArea,
				opts = chart.options,
				animationOpts = opts.animation,
				centerX = (chartArea.left + chartArea.right) / 2,
				centerY = (chartArea.top + chartArea.bottom) / 2,
				startAngle = opts.rotation, // non reset case handled later
				endAngle = opts.rotation, // non reset case handled later
				dataset = me.getDataset(),
				circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
				innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
				outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
				valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (value / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(elements) {
			var max = 0,
				index = this.index,
				length = elements.length,
				borderWidth,
				hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
				hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};

},{}],18:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.line = {
		showLines: true,
		spanGaps: false,

		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	};

	function lineEnabled(dataset, options) {
		return helpers.getValueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: Chart.elements.Line,

		dataElementType: Chart.elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i=0, ilen=points.length; i<ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i=0, ilen=points.length; i<ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth)) {
				borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;
			var labels = me.chart.data.labels || [];
			var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			Chart.canvasHelpers.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			Chart.canvasHelpers.unclipArea(chart.ctx);

			// Draw the points
			for (; i<ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};

},{}],19:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.polarArea = {

		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},

		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},

		startAngle: -0.5 * Math.PI,
		aspectRatio: 1,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}

				chart.update();
			}
		},

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
				}
			}
		}
	};

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: Chart.elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: getValueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};

},{}],20:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.radar = {
		aspectRatio: 1,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	};

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: Chart.elements.Line,

		dataElementType: Chart.elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};

},{}],21:[function(require,module,exports){
/* global window: false */
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.global.animation = {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	};

	Chart.Animation = Chart.Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i=0, ilen=animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};

},{}],22:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {
	// Global Chart canvas helpers object for drawing items to canvas
	var helpers = Chart.canvasHelpers = {};

	helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (typeof pointStyle === 'object') {
			type = pointStyle.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2, pointStyle.width, pointStyle.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (pointStyle) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			Chart.helpers.drawRoundedRectangle(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	};

	helpers.clipArea = function(ctx, clipArea) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(clipArea.left, clipArea.top, clipArea.right - clipArea.left, clipArea.bottom - clipArea.top);
		ctx.clip();
	};

	helpers.unclipArea = function(ctx) {
		ctx.restore();
	};

	helpers.lineTo = function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if (target.steppedLine === 'after') {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip? previous.controlPointPreviousX : previous.controlPointNextX,
			flip? previous.controlPointPreviousY : previous.controlPointNextY,
			flip? target.controlPointNextX : target.controlPointPreviousX,
			flip? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	};

	Chart.helpers.canvas = helpers;
};

},{}],23:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var plugins = Chart.plugins;
	var platform = Chart.platform;

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			Chart.defaults.global,
			Chart.defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		// Update Scale(s) with options
		if (newOptions.scale) {
			chart.scale.options = newOptions.scale;
		} else if (newOptions.scales) {
			newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
				chart.scales[scaleOptions.id].options = scaleOptions;
			});
		}

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me;  // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
			var newWidth = Math.floor(helpers.getMaximumWidth(canvas));
			var newHeight = Math.floor(aspectRatio? newWidth / aspectRatio : helpers.getMaximumHeight(canvas));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales = {};
			var items = [];

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
				var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				var scale = new scaleClass({
					id: scaleOptions.id,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});

				scales[scale.id] = scale;

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				if (!meta.type) {
					meta.type = dataset.type || me.config.type;
				}

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			if (types.length > 1) {
				for (var i = 1; i < types.length; i++) {
					if (types[i] !== types[i - 1]) {
						me.isCombo = true;
						break;
					}
				}
			}

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(animationDuration, lazy) {
			var me = this;

			updateConfig(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			helpers.each(newControllers, function(controller) {
				controller.reset();
			});

			me.updateDatasets();

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					lazy: lazy,
					duration: animationDuration
				};
			} else {
				me.render(animationDuration, lazy);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			Chart.layoutService.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(duration, lazy) {
			var me = this;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (easingValue === undefined || easingValue === null) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);

			// Finally draw the tooltip
			me.tooltip.draw();

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i=0, ilen=(me.data.datasets || []).length; i<ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i=(me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Chart.Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Chart.Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Chart.Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Chart.Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Chart.Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var meta, i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				meta = me.getDatasetMeta(i);
				if (meta.controller) {
					meta.controller.destroy();
					meta.controller = null;
				}
			}

			if (canvas) {
				me.unbindEvents();
				helpers.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me,            // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
			me.tooltip.initialize();
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Responsiveness is currently based on the use of an iframe, however this method causes
			// performance issues and could be troublesome when used with ad blockers. So make sure
			// that the user is still able to create a chart without iframe when responsive is false.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i=0, ilen=elements.length; i<ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			changed |= tooltip && tooltip.handleEvent(e);

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest.duration, bufferedRequest.lazy);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// On Hover hook
			if (hoverOptions.onHover) {
				// Need to call with native event here to not break backwards compatibility
				hoverOptions.onHover.call(me, e.native, me.active);
			}

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};

},{}],24:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i=0, ilen=data.length; i<ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i<ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i<ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex],
				index = element._index,
				custom = element.custom || {},
				valueOrDefault = helpers.getValueAtIndexOrDefault,
				model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex],
				index = element._index,
				custom = element.custom || {},
				valueOrDefault = helpers.getValueAtIndexOrDefault,
				getHoverColor = helpers.getHoverColor,
				model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i=0; i<count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length-1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};

},{}],25:[function(require,module,exports){
'use strict';

var color = require(3);

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;

		for (i=0, ilen=keys.length; i<ilen; ++i) {
			key = keys[i];

			target = model[key];

			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}

			actual = view[key];

			if (actual === target || key[0] === '_') {
				continue;
			}

			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}

			origin = start[key];

			type = typeof(target);

			if (type === typeof(origin)) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}

			view[key] = target;
		}
	}

	Chart.elements = {};

	Chart.Element = function(configuration) {
		helpers.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};

	helpers.extend(Chart.Element.prototype, {

		initialize: function() {
			this.hidden = false;
		},

		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers.clone(me._model);
			}
			me._start = {};
			return me;
		},

		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;

			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}

			if (!view) {
				view = me._view = {};
			}

			if (!start) {
				start = me._start = {};
			}

			interpolate(start, view, model, ease);

			return me;
		},

		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},

		hasValue: function() {
			return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
		}
	});

	Chart.Element.extend = helpers.inherits;
};

},{"3":3}],26:[function(require,module,exports){
/* global window: false */
/* global document: false */
'use strict';

var color = require(3);

module.exports = function(Chart) {
	// Global Chart helpers object for utility methods and classes
	var helpers = Chart.helpers = {};

	// -- Basic js utility methods
	helpers.each = function(loopable, callback, self, reverse) {
		// Check to see if null or undefined firstly.
		var i, len;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					callback.call(self, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[i], i);
				}
			}
		} else if (typeof loopable === 'object') {
			var keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				callback.call(self, loopable[keys[i]], keys[i]);
			}
		}
	};
	helpers.clone = function(obj) {
		var objClone = {};
		helpers.each(obj, function(value, key) {
			if (helpers.isArray(value)) {
				objClone[key] = value.slice(0);
			} else if (typeof value === 'object' && value !== null) {
				objClone[key] = helpers.clone(value);
			} else {
				objClone[key] = value;
			}
		});
		return objClone;
	};
	helpers.extend = function(base) {
		var setFn = function(value, key) {
			base[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; i++) {
			helpers.each(arguments[i], setFn);
		}
		return base;
	};
	// Need a special merge function to chart configs since they are now grouped
	helpers.configMerge = function(_base) {
		var base = helpers.clone(_base);
		helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
			helpers.each(extension, function(value, key) {
				var baseHasProperty = base.hasOwnProperty(key);
				var baseVal = baseHasProperty ? base[key] : {};

				if (key === 'scales') {
					// Scale config merging is complex. Add our own function here for that
					base[key] = helpers.scaleMerge(baseVal, value);
				} else if (key === 'scale') {
					// Used in polar area & radar charts since there is only one scale
					base[key] = helpers.configMerge(baseVal, Chart.scaleService.getScaleDefaults(value.type), value);
				} else if (baseHasProperty
						&& typeof baseVal === 'object'
						&& !helpers.isArray(baseVal)
						&& baseVal !== null
						&& typeof value === 'object'
						&& !helpers.isArray(value)) {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(baseVal, value);
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
		});

		return base;
	};
	helpers.scaleMerge = function(_base, extension) {
		var base = helpers.clone(_base);

		helpers.each(extension, function(value, key) {
			if (key === 'xAxes' || key === 'yAxes') {
				// These properties are arrays of items
				if (base.hasOwnProperty(key)) {
					helpers.each(value, function(valueObj, index) {
						var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
						var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
						if (index >= base[key].length || !base[key][index].type) {
							base[key].push(helpers.configMerge(axisDefaults, valueObj));
						} else if (valueObj.type && valueObj.type !== base[key][index].type) {
							// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
							base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
						} else {
							// Type is the same
							base[key][index] = helpers.configMerge(base[key][index], valueObj);
						}
					});
				} else {
					base[key] = [];
					helpers.each(value, function(valueObj) {
						var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
						base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
					});
				}
			} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
				// If we are overwriting an object with an object, do a merge of the properties.
				base[key] = helpers.configMerge(base[key], value);

			} else {
				// can just overwrite the value in this case
				base[key] = value;
			}
		});

		return base;
	};
	helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
		if (value === undefined || value === null) {
			return defaultValue;
		}

		if (helpers.isArray(value)) {
			return index < value.length ? value[index] : defaultValue;
		}

		return value;
	};
	helpers.getValueOrDefault = function(value, defaultValue) {
		return value === undefined ? defaultValue : value;
	};
	helpers.indexOf = Array.prototype.indexOf?
		function(array, item) {
			return array.indexOf(item);
		}:
		function(array, item) {
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (array[i] === item) {
					return i;
				}
			}
			return -1;
		};
	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (startIndex === undefined || startIndex === null) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (startIndex === undefined || startIndex === null) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.inherits = function(extensions) {
		// Basic javascript inheritance based on the model created in Backbone.js
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};
		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();

		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;

		return ChartElement;
	};
	helpers.noop = function() {};
	helpers.uid = (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}());
	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			return Math.log(x) / Math.LN10;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x,
			distanceFromYCenter = anglePoint.y - centrePoint.y,
			radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint,
			current = middlePoint,
			next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Easing functions adapted from Robert Penner's easing equations
	// http://www.robertpenner.com/easing/
	var easingEffects = helpers.easingEffects = {
		linear: function(t) {
			return t;
		},
		easeInQuad: function(t) {
			return t * t;
		},
		easeOutQuad: function(t) {
			return -1 * t * (t - 2);
		},
		easeInOutQuad: function(t) {
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * t * t;
			}
			return -1 / 2 * ((--t) * (t - 2) - 1);
		},
		easeInCubic: function(t) {
			return t * t * t;
		},
		easeOutCubic: function(t) {
			return 1 * ((t = t / 1 - 1) * t * t + 1);
		},
		easeInOutCubic: function(t) {
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * t * t * t;
			}
			return 1 / 2 * ((t -= 2) * t * t + 2);
		},
		easeInQuart: function(t) {
			return t * t * t * t;
		},
		easeOutQuart: function(t) {
			return -1 * ((t = t / 1 - 1) * t * t * t - 1);
		},
		easeInOutQuart: function(t) {
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * t * t * t * t;
			}
			return -1 / 2 * ((t -= 2) * t * t * t - 2);
		},
		easeInQuint: function(t) {
			return 1 * (t /= 1) * t * t * t * t;
		},
		easeOutQuint: function(t) {
			return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
		},
		easeInOutQuint: function(t) {
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * t * t * t * t * t;
			}
			return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
		},
		easeInSine: function(t) {
			return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
		},
		easeOutSine: function(t) {
			return 1 * Math.sin(t / 1 * (Math.PI / 2));
		},
		easeInOutSine: function(t) {
			return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
		},
		easeInExpo: function(t) {
			return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
		},
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
		},
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * Math.pow(2, 10 * (t - 1));
			}
			return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
		},
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
		},
		easeOutCirc: function(t) {
			return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
		},
		easeInOutCirc: function(t) {
			if ((t /= 1 / 2) < 1) {
				return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
			}
			return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 1) === 1) {
				return 1;
			}
			if (!p) {
				p = 1 * 0.3;
			}
			if (a < Math.abs(1)) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
		},
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 1) === 1) {
				return 1;
			}
			if (!p) {
				p = 1 * 0.3;
			}
			if (a < Math.abs(1)) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
		},
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 1 / 2) === 2) {
				return 1;
			}
			if (!p) {
				p = 1 * (0.3 * 1.5);
			}
			if (a < Math.abs(1)) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return 1 * (t /= 1) * t * ((s + 1) * t - s);
		},
		easeOutBack: function(t) {
			var s = 1.70158;
			return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
		},
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 1 / 2) < 1) {
				return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
		easeInBounce: function(t) {
			return 1 - easingEffects.easeOutBounce(1 - t);
		},
		easeOutBounce: function(t) {
			if ((t /= 1) < (1 / 2.75)) {
				return 1 * (7.5625 * t * t);
			} else if (t < (2 / 2.75)) {
				return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
			} else if (t < (2.5 / 2.75)) {
				return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
			}
			return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
		},
		easeInOutBounce: function(t) {
			if (t < 1 / 2) {
				return easingEffects.easeInBounce(t * 2) * 0.5;
			}
			return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
		}
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt,
			canvas = evt.currentTarget || evt.srcElement,
			boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};
	helpers.addEvent = function(node, eventType, method) {
		if (node.addEventListener) {
			node.addEventListener(eventType, method);
		} else if (node.attachEvent) {
			node.attachEvent('on' + eventType, method);
		} else {
			node['on' + eventType] = method;
		}
	};
	helpers.removeEvent = function(node, eventType, handler) {
		if (node.removeEventListener) {
			node.removeEventListener(eventType, handler, false);
		} else if (node.detachEvent) {
			node.detachEvent('on' + eventType, handler);
		} else {
			node['on' + eventType] = helpers.noop;
		}
	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof(styleValue) === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw)? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch)? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart) {
		var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		canvas.style.height = height + 'px';
		canvas.style.width = width + 'px';
	};
	// -- Canvas methods
	helpers.clear = function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	};
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};
	helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();
	};

	helpers.color = !color?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = Chart.defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.isArray = Array.isArray?
		function(obj) {
			return Array.isArray(obj);
		} :
		function(obj) {
			return Object.prototype.toString.call(obj) === '[object Array]';
		};
	// ! @see http://stackoverflow.com/a/14853974
	helpers.arrayEquals = function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen=a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	};
	helpers.callback = function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			fn.apply(thisArg, args);
		}
	};
	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};

	/**
	 * Provided for backward compatibility, use Chart.helpers#callback instead.
	 * @function Chart.helpers#callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	helpers.callCallback = helpers.callback;
};

},{"3":3}],27:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {
	var helpers = Chart.helpers;

	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}

		return helpers.getRelativePosition(e, chart);
	}

	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}

			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}

	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];

		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});

		return elements;
	}

	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} Optional function to provide the distance between
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];

		if (!distanceMetric) {
			distanceMetric = helpers.distanceBetweenPoints;
		}

		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}

			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);

			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});

		return nearestItems;
	}

	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		var distanceMetric = function(pt1, pt2) {
			return Math.abs(pt1.x - pt2.x);
		};
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];

		if (!items.length) {
			return [];
		}

		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex),
					element = meta.data[items[0]._index];

				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});

		return elements;
	}

	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */

	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	Chart.Interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];

				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});

				return elements.slice(0, 1);
			},

			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
	 		 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,

			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,

			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false);

				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}

				return items;
			},

			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, true);
			},

			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},

			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var nearestItems = getNearestItems(chart, position, options.intersect);

				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;

						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}

						return ret;
					});
				}

				// Return only 1 item
				return nearestItems.slice(0, 1);
			},

			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},

			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
};

},{}],28:[function(require,module,exports){
'use strict';

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	// Globally expose the defaults to allow for user updating/changing
	Chart.defaults = {
		global: {
			responsive: true,
			responsiveAnimationDuration: 0,
			maintainAspectRatio: true,
			events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
			hover: {
				onHover: null,
				mode: 'nearest',
				intersect: true,
				animationDuration: 400
			},
			onClick: null,
			defaultColor: 'rgba(0,0,0,0.1)',
			defaultFontColor: '#666',
			defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			defaultFontSize: 12,
			defaultFontStyle: 'normal',
			showLines: true,

			// Element defaults defined in element extensions
			elements: {},

			// Legend callback string
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
				for (var i = 0; i < chart.data.datasets.length; i++) {
					text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
					if (chart.data.datasets[i].label) {
						text.push(chart.data.datasets[i].label);
					}
					text.push('</li>');
				}
				text.push('</ul>');

				return text.join('');
			}
		}
	};

	Chart.Chart = Chart;

	return Chart;
};

},{}],29:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	function filterByPosition(array, position) {
		return helpers.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	Chart.layoutService = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i<ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout;
			var padding = layoutOptions ? layoutOptions.padding : null;

			var leftPadding = 0;
			var rightPadding = 0;
			var topPadding = 0;
			var bottomPadding = 0;

			if (!isNaN(padding)) {
				// options.layout.padding is a number. assign to all
				leftPadding = padding;
				rightPadding = padding;
				topPadding = padding;
				bottomPadding = padding;
			} else {
				leftPadding = padding.left || 0;
				rightPadding = padding.right || 0;
				topPadding = padding.top || 0;
				bottomPadding = padding.bottom || 0;
			}

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, chartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}

			helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;

			helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});

			helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers.each(leftBoxes.concat(rightBoxes), fitBox);

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			// Set the Left and Right margins for the horizontal boxes
			helpers.each(topBoxes.concat(bottomBoxes), fitBox);

			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});

			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};

				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				helpers.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers.each(rightBoxes, placeBox);
			helpers.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};

			// Step 9
			helpers.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
};

},{}],30:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.global.plugins = {};

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	Chart.plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i=0; i<ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart._plugins || (chart._plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var defaults = Chart.defaults.global.plugins;
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers.clone(defaults[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		}
	};

	/**
	 * Plugin extension hooks.
	 * @interface IPlugin
	 * @since 2.1.0
	 */
	/**
	 * @method IPlugin#beforeInit
	 * @desc Called before initializing `chart`.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterInit
	 * @desc Called after `chart` has been initialized and before the first update.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeUpdate
	 * @desc Called before updating `chart`. If any plugin returns `false`, the update
	 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart update.
	 */
	/**
	 * @method IPlugin#afterUpdate
	 * @desc Called after `chart` has been updated and before rendering. Note that this
	 * hook will not be called if the chart update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsUpdate
 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
	 * the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} false to cancel the datasets update.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#afterDatasetsUpdate
	 * @desc Called after the `chart` datasets have been updated. Note that this hook
	 * will not be called if the datasets update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#beforeDatasetUpdate
 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
	 * returns `false`, the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.index - The dataset index.
	 * @param {Number} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetUpdate
 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
	 * that this hook will not be called if the datasets update has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.index - The dataset index.
	 * @param {Number} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeLayout
	 * @desc Called before laying out `chart`. If any plugin returns `false`,
	 * the layout update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart layout.
	 */
	/**
	 * @method IPlugin#afterLayout
	 * @desc Called after the `chart` has been layed out. Note that this hook will not
	 * be called if the layout update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeRender
	 * @desc Called before rendering `chart`. If any plugin returns `false`,
	 * the rendering is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart rendering.
	 */
	/**
	 * @method IPlugin#afterRender
	 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
	 * that this hook will not be called if the rendering has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDraw
	 * @desc Called before drawing `chart` at every animation frame specified by the given
	 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
	 * another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart drawing.
	 */
	/**
	 * @method IPlugin#afterDraw
	 * @desc Called after the `chart` has been drawn for the specific easing value. Note
	 * that this hook will not be called if the drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsDraw
 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
	 * the datasets drawing is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetsDraw
	 * @desc Called after the `chart` datasets have been drawn. Note that this hook
	 * will not be called if the datasets drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetDraw
 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
	 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
	 * is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.index - The dataset index.
	 * @param {Number} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetDraw
 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
	 * (datasets are drawn in the reverse order). Note that this hook will not be called
	 * if the datasets drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.index - The dataset index.
	 * @param {Number} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeEvent
 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
	 * the event will be discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterEvent
	 * @desc Called after the `event` has been consumed. Note that this hook
	 * will not be called if the `event` has been previously discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#resize
	 * @desc Called after the chart as been resized.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#destroy
	 * @desc Called after the chart as been destroyed.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Chart.Element.extend({});
};

},{}],31:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.defaults.scale = {
		display: true,
		position: 'left',

		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},

		// scale label
		scaleLabel: {
			// actual label
			labelString: '',

			// display property
			display: false
		},

		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Chart.Ticks.formatters.values
		}
	};

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var getValueOrDefault = helpers.getValueOrDefault;
		var globalDefaults = Chart.defaults.global;
		var size = getValueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = getValueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = getValueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	Chart.Scale = Chart.Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks
			me.beforeBuildTicks();
			me.buildTicks();
			me.afterBuildTicks();

			me.beforeTickToLabelConversion();
			me.convertTicksToLabels();
			me.afterTickToLabelConversion();

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, me.ticks, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation;
				var sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var scaleLabelFontSize = parseFontOptions(scaleLabelOpts).size * 1.5;
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				if (isHorizontal) {
					minSize.height += scaleLabelFontSize;
				} else {
					minSize.width += scaleLabelFontSize;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, me.ticks, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
				var lineSpace = tickFont.size * 0.5;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * tallestLabelHeightInLines);

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
					me.ctx.font = tickFont.font;

					var firstTick = me.ticks[0];
					var firstLabelWidth = computeTextSize(me.ctx, firstTick, tickFont.font);

					var lastTick = me.ticks[me.ticks.length - 1];
					var lastLabelWidth = computeTextSize(me.ctx, lastTick, tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
					// by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom'? (cosRotation * firstLabelWidth) + 3: (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom'? (cosRotation * lineSpace) + 3: (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
					// Account for padding

					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						largestTextWidth += me.options.ticks.padding;
					}
					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (rawValue === null || typeof(rawValue) === 'undefined') {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof(rawValue) === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (typeof(rawValue) === 'object') {
				if ((rawValue instanceof Date) || (rawValue.isValid)) {
					return rawValue;
				}
				return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
			}

			// Value is good, return it
			return rawValue;
		},

		// Used to get the value to display in the tooltip for the data at the given index
		// function getLabelForIndex(index, datasetIndex)
		getLabelForIndex: helpers.noop,

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: helpers.noop,

		// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		getValueForPixel: helpers.noop,

		// Used for tick location, should
		getPixelForTick: function(index, includeOffset) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (includeOffset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me.ticks.length - 1)));
		},

		// Utility for getting the pixel location of a percentage of scale
		getPixelForDecimal: function(decimal /* , includeOffset*/) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0:
				min < 0 && max < 0? max :
				min > 0 && max > 0? min :
				0;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = Chart.defaults.global;
			var optionTicks = options.ticks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var skipRatio;
			var useAutoskipper = optionTicks.autoSkip;
			var isHorizontal = me.isHorizontal();

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);

			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;

			// Make sure we draw text in the correct color and font
			context.fillStyle = tickFontColor;

			var itemsToDraw = [];

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && me.ticks.length > maxTicks) {
					while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
						if (!skipRatio) {
							skipRatio = 1;
						}
						skipRatio += 1;
					}
				}

				if (!useAutoskipper) {
					skipRatio = false;
				}
			}


			var xTickStart = options.position === 'right' ? me.left : me.right - tl;
			var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
			var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;

			helpers.each(me.ticks, function(label, index) {
				// If the callback returned a null or undefined value, do not draw this line
				if (label === undefined || label === null) {
					return;
				}

				var isLastTick = me.ticks.length === index + 1;

				// Since we always show the last tick,we need may need to hide the last shown one before
				var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
				if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
					return;
				}

				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';

				if (isHorizontal) {

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated? 'top':'middle';
						textAlign = !isRotated? 'center': 'right';
						labelY = me.top + tl;
					} else {
						// top
						textBaseline = !isRotated? 'bottom':'middle';
						textAlign = !isRotated? 'center': 'left';
						labelY = me.bottom - tl;
					}

					var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
					labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom;
				} else {
					var isLeft = options.position === 'left';
					var tickPadding = optionTicks.padding;
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
					yLineValue += helpers.aliasPixel(lineWidth);
					labelY = me.getPixelForTick(index, gridLines.offsetGridLines);

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = tickFont.font;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						for (var i = 0, y = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += (tickFont.size * 1.5);
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFont.size / 2) : me.top + (scaleLabelFont.size / 2);
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft ? me.left + (scaleLabelFont.size / 2) : me.right - (scaleLabelFont.size / 2);
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left,
					x2 = me.right,
					y1 = me.top,
					y2 = me.bottom;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};

},{}],32:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, defaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(defaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var defaults = this.defaults;
			if (defaults.hasOwnProperty(type)) {
				defaults[type] = helpers.extend(defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				Chart.layoutService.addBox(chart, scale);
			});
		}
	};
};

},{}],33:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	Chart.Ticks = {
		/**
		 * Namespace to hold generators for different types of ticks
		 * @namespace Chart.Ticks.generators
		 */
		generators: {
			/**
			 * Interface for the options provided to the numeric tick generator
			 * @interface INumericTickGenerationOptions
			 */
			/**
			 * The maximum number of ticks to display
			 * @name INumericTickGenerationOptions#maxTicks
			 * @type Number
			 */
			/**
			 * The distance between each tick.
			 * @name INumericTickGenerationOptions#stepSize
			 * @type Number
			 * @optional
			 */
			/**
			 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
			 * @name INumericTickGenerationOptions#min
			 * @type Number
			 * @optional
			 */
			/**
			 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
			 * @name INumericTickGenerationOptions#max
			 * @type Number
			 * @optional
			 */

			/**
			 * Generate a set of linear ticks
			 * @method Chart.Ticks.generators.linear
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			linear: function(generationOptions, dataRange) {
				var ticks = [];
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.

				var spacing;
				if (generationOptions.stepSize && generationOptions.stepSize > 0) {
					spacing = generationOptions.stepSize;
				} else {
					var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
					spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
				}
				var niceMin = Math.floor(dataRange.min / spacing) * spacing;
				var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

				// If min, max and stepSize is set and they make an evenly spaced scale use it.
				if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
					// If very close to our whole number, use it.
					if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
						niceMin = generationOptions.min;
						niceMax = generationOptions.max;
					}
				}

				var numSpaces = (niceMax - niceMin) / spacing;
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}

				// Put the values into the ticks array
				ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

				return ticks;
			},

			/**
			 * Generate a set of logarithmic ticks
			 * @method Chart.Ticks.generators.logarithmic
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			logarithmic: function(generationOptions, dataRange) {
				var ticks = [];
				var getValueOrDefault = helpers.getValueOrDefault;

				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickVal = getValueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

				var endExp = Math.floor(helpers.log10(dataRange.max));
				var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
				var exp;
				var significand;

				if (tickVal === 0) {
					exp = Math.floor(helpers.log10(dataRange.minNotZero));
					significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

					ticks.push(tickVal);
					tickVal = significand * Math.pow(10, exp);
				} else {
					exp = Math.floor(helpers.log10(tickVal));
					significand = Math.floor(tickVal / Math.pow(10, exp));
				}

				do {
					ticks.push(tickVal);

					++significand;
					if (significand === 10) {
						significand = 1;
						++exp;
					}

					tickVal = significand * Math.pow(10, exp);
				} while (exp < endExp || (exp === endExp && significand < endSignificand));

				var lastTick = getValueOrDefault(generationOptions.max, tickVal);
				ticks.push(lastTick);

				return ticks;
			}
		},

		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers.isArray(value) ? value : '' + value;
			},

			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}

				var logDelta = helpers.log10(Math.abs(delta));
				var tickString = '';

				if (tickValue !== 0) {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				} else {
					tickString = '0'; // never show decimal places for 0
				}

				return tickString;
			},

			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
};

},{}],34:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	Chart.defaults.global.tooltips = {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	};

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index,
			datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = Chart.defaults.global;
		var getValueOrDefault = helpers.getValueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize,
			bodyFontSize = model.bodyFontSize,
			footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width > chart.width;
		};
		orf = function(x) {
			return x - size.width < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize,
			caretPadding = vm.caretPadding,
			cornerRadius = vm.cornerRadius,
			xAlign = alignment.xAlign,
			yAlign = alignment.yAlign,
			paddingAndSize = caretSize + caretPadding,
			radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Chart.Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
				title = callbacks.title.apply(me, arguments),
				afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position](active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				});

				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3;
			var y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign,
				yAlign = vm.yAlign;
			var ptX = tooltipPoint.x,
				ptY = tooltipPoint.y;
			var width = size.width,
				height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = ptX + (width / 2);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize,
					titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';

			var textColor = mergeOpacity(vm.bodyFontColor, opacity);
			ctx.fillStyle = textColor;
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);

						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// If tooltip didn't change, do not handle the target event
			if (!changed) {
				return false;
			}

			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				var model = me._model;
				me.update(true);
				me.pivot();

				// See if our tooltip position changed
				changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;

			var nearestElement;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len;
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};

},{}],35:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers,
		globalOpts = Chart.defaults.global;

	globalOpts.elements.arc = {
		backgroundColor: globalOpts.defaultColor,
		borderColor: '#fff',
		borderWidth: 2
	};

	Chart.elements.Arc = Chart.Element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;

			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
		inRange: function(chartX, chartY) {
			var vm = this._view;

			if (vm) {
				var pointRelativePosition = helpers.getAngleFromPoint(vm, {
						x: chartX,
						y: chartY
					}),
					angle = pointRelativePosition.angle,
					distance = pointRelativePosition.distance;

				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}

				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle),
					withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

				return (betweenAngles && withinRadius);
			}
			return false;
		},
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
		tooltipPosition: function() {
			var vm = this._view;

			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
				rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
		draw: function() {

			var ctx = this._chart.ctx,
				vm = this._view,
				sA = vm.startAngle,
				eA = vm.endAngle;

			ctx.beginPath();

			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;

			ctx.fillStyle = vm.backgroundColor;

			ctx.fill();
			ctx.lineJoin = 'bevel';

			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});
};

},{}],36:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var globalDefaults = Chart.defaults.global;

	Chart.defaults.global.elements.line = {
		tension: 0.4,
		backgroundColor: globalDefaults.defaultColor,
		borderWidth: 3,
		borderColor: globalDefaults.defaultColor,
		borderCapStyle: 'butt',
		borderDash: [],
		borderDashOffset: 0.0,
		borderJoinStyle: 'miter',
		capBezierPoints: true,
		fill: true, // do we fill in the area between the line and its base axis
	};

	Chart.elements.Line = Chart.Element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;

			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}

			ctx.save();

			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}

			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;

			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers.previousItem(points, index);
				currentVM = current._view;

				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}

			ctx.stroke();
			ctx.restore();
		}
	});
};

},{}],37:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers,
		globalOpts = Chart.defaults.global,
		defaultColor = globalOpts.defaultColor;

	globalOpts.elements.point = {
		radius: 3,
		pointStyle: 'circle',
		backgroundColor: defaultColor,
		borderWidth: 1,
		borderColor: defaultColor,
		// Hover
		hitRadius: 1,
		hoverRadius: 4,
		hoverBorderWidth: 1
	};

	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}

	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}

	Chart.elements.Point = Chart.Element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},

		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,

		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var color = Chart.helpers.color;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
			var ratio = 0;

			if (vm.skip) {
				return;
			}

			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;

			// Cliping for Points.
			// going out from inner charArea?
			if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right*errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom*errMargin < model.y))) {
				// Point fade out
				if (model.x < chartArea.left) {
					ratio = (x - model.x) / (chartArea.left - model.x);
				} else if (chartArea.right*errMargin < model.x) {
					ratio = (model.x - x) / (model.x - chartArea.right);
				} else if (model.y < chartArea.top) {
					ratio = (y - model.y) / (chartArea.top - model.y);
				} else if (chartArea.bottom*errMargin < model.y) {
					ratio = (model.y - y) / (model.y - chartArea.bottom);
				}
				ratio = Math.round(ratio*100) / 100;
				ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
				ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
			}

			Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
		}
	});
};

},{}],38:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var globalOpts = Chart.defaults.global;

	globalOpts.elements.rectangle = {
		backgroundColor: globalOpts.defaultColor,
		borderWidth: 0,
		borderColor: globalOpts.defaultColor,
		borderSkipped: 'bottom'
	};

	function isVertical(bar) {
		return bar._view.width !== undefined;
	}

	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @private
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;

		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}

		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}

	Chart.elements.Rectangle = Chart.Element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;

			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top? 1: -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left? 1: -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}

			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize? barSize: borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
				var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
				var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}

			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;

			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];

			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}

			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}

			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);

			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}

			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
		inRange: function(mouseX, mouseY) {
			var inRange = false;

			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}

			return inRange;
		},
		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}

			var inRange = false;
			var bounds = getBarBounds(me);

			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}

			return inRange;
		},
		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},
		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}

			return {x: x, y: y};
		},
		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});

};

},{}],39:[function(require,module,exports){
'use strict';

// Chart.Platform implementation for targeting a web browser
module.exports = function(Chart) {
	var helpers = Chart.helpers;

	// DOM event types -> Chart.js event types.
	// Note: only events with different types are mapped.
	// https://developer.mozilla.org/en-US/docs/Web/Events
	var eventTypeMap = {
		// Touch events
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',

		// Pointer events
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};

	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches? Number(matches[1]) : undefined;
	}

	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;

		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');

		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas._chartjs = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};

		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';

		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}

		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}

		return canvas;
	}

	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined? x : null,
			y: y !== undefined? y : null,
		};
	}

	function fromNativeEvent(event, chart) {
		var type = eventTypeMap[event.type] || event.type;
		var pos = helpers.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}

	function createResizer(handler) {
		var iframe = document.createElement('iframe');
		iframe.className = 'chartjs-hidden-iframe';
		iframe.style.cssText =
			'display:block;'+
			'overflow:hidden;'+
			'border:0;'+
			'margin:0;'+
			'top:0;'+
			'left:0;'+
			'bottom:0;'+
			'right:0;'+
			'height:100%;'+
			'width:100%;'+
			'position:absolute;'+
			'pointer-events:none;'+
			'z-index:-1;';

		// Prevent the iframe to gain focus on tab.
		// https://github.com/chartjs/Chart.js/issues/3090
		iframe.tabIndex = -1;

		// If the iframe is re-attached to the DOM, the resize listener is removed because the
		// content is reloaded, so make sure to install the handler after the iframe is loaded.
		// https://github.com/chartjs/Chart.js/issues/3521
		helpers.addEvent(iframe, 'load', function() {
			helpers.addEvent(iframe.contentWindow || iframe, 'resize', handler);

			// The iframe size might have changed while loading, which can also
			// happen if the size has been changed while detached from the DOM.
			handler();
		});

		return iframe;
	}

	function addResizeListener(node, listener, chart) {
		var stub = node._chartjs = {
			ticking: false
		};

		// Throttle the callback notification until the next animation frame.
		var notify = function() {
			if (!stub.ticking) {
				stub.ticking = true;
				helpers.requestAnimFrame.call(window, function() {
					if (stub.resizer) {
						stub.ticking = false;
						return listener(createEvent('resize', chart));
					}
				});
			}
		};

		// Let's keep track of this added iframe and thus avoid DOM query when removing it.
		stub.resizer = createResizer(notify);

		node.insertBefore(stub.resizer, node.firstChild);
	}

	function removeResizeListener(node) {
		if (!node || !node._chartjs) {
			return;
		}

		var resizer = node._chartjs.resizer;
		if (resizer) {
			resizer.parentNode.removeChild(resizer);
			node._chartjs.resizer = null;
		}

		delete node._chartjs;
	}

	return {
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}

			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');

			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}

			return null;
		},

		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas._chartjs) {
				return;
			}

			var initial = canvas._chartjs.initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (value === undefined || value === null) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});

			helpers.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});

			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;

			delete canvas._chartjs;
		},

		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas.parentNode, listener, chart);
				return;
			}

			var stub = listener._chartjs || (listener._chartjs = {});
			var proxies = stub.proxies || (stub.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};

			helpers.addEvent(canvas, type, proxy);
		},

		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas.parentNode, listener);
				return;
			}

			var stub = listener._chartjs || {};
			var proxies = stub.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}

			helpers.removeEvent(canvas, type, proxy);
		}
	};
};

},{}],40:[function(require,module,exports){
'use strict';

// By default, select the browser (DOM) platform.
// @TODO Make possible to select another platform at build time.
var implementation = require(39);

module.exports = function(Chart) {
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	Chart.platform = {
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},

		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},

		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},

		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	};

	/**
	 * @interface IPlatform
	 * Allows abstracting platform dependencies away from the chart
	 * @borrows Chart.platform.acquireContext as acquireContext
	 * @borrows Chart.platform.releaseContext as releaseContext
	 * @borrows Chart.platform.addEventListener as addEventListener
	 * @borrows Chart.platform.removeEventListener as removeEventListener
	 */

	/**
	 * @interface IEvent
	 * @prop {String} type - The event type name, possible values are:
	 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
	 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
	 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
	 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
	 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
	 */

	Chart.helpers.extend(Chart.platform, implementation(Chart));
};

},{"39":39}],41:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {
	/**
	 * Plugin based on discussion from the following Chart.js issues:
	 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
	 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
	 */
	Chart.defaults.global.plugins.filler = {
		propagate: true
	};

	var defaults = Chart.defaults;
	var helpers = Chart.helpers;
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];

			return !points.length? null : function(point, i) {
				return points[i]._view || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary? boundary.x : null;
			var y = boundary? boundary.y : null;

			return function(point) {
				return {
					x: x === null? point.x : x,
					y: y === null? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal? target : null,
					y: horizontal? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i=1; i<len0; ++i) {
			helpers.canvas.lineTo(ctx, curve0[i-1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1-1].x, curve1[len1-1].y);

		// building opposite area curve (reverse)
		for (i=len1-1; i>0; --i) {
			helpers.canvas.lineTo(ctx, curve1[i], curve1[i-1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i%count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	return {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof Chart.elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i=0; i<count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults.global.defaultColor;

			if (mapper && color && points.length) {
				doFill(chart.ctx, points, mapper, view, color, el._loop);
			}
		}
	};
};

},{}],42:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var layout = Chart.layoutService;
	var noop = helpers.noop;

	Chart.defaults.global.legend = {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	};

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}

	Chart.Legend = Chart.Element.extend({

		initialize: function(config) {
			helpers.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels;
			var legendItems = labelOpts.generateLabels.call(me, me.chart);

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var globalDefault = Chart.defaults.global,
				itemOrDefault = helpers.getValueOrDefault,
				fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
				fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
				fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
				labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = Chart.defaults.global,
				lineDefault = globalDefault.elements.line,
				legendWidth = me.width,
				lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx,
					cursor,
					itemOrDefault = helpers.getValueOrDefault,
					fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;

				var boxWidth = getBoxWidth(labelOpts, fontSize),
					hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;

						// Draw pointStyle as legend symbol
						Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
						ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width,
						width = boxWidth + (fontSize / 2) + textWidth,
						x = cursor.x,
						y = cursor.y;

					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;

			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			var x = e.x,
				y = e.y;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}

			return changed;
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Chart.Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		layout.configure(chart, legend, legendOpts);
		layout.addBox(chart, legend);
		chart.legend = legend;
	}

	return {
		id: 'legend',

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				legendOpts = helpers.configMerge(Chart.defaults.global.legend, legendOpts);

				if (legend) {
					layout.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layout.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
};

},{}],43:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var layout = Chart.layoutService;
	var noop = helpers.noop;

	Chart.defaults.global.title = {
		display: false,
		position: 'top',
		fullWidth: true,
		weight: 2000,        // by default greater than legend (1000) to be above
		fontStyle: 'bold',
		padding: 10,

		// actual title
		text: ''
	};

	Chart.Title = Chart.Element.extend({
		initialize: function(config) {
			var me = this;
			helpers.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: noop,
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this,
				valueOrDefault = helpers.getValueOrDefault,
				opts = me.options,
				globalDefaults = Chart.defaults.global,
				display = opts.display,
				fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
				minSize = me.minSize;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? fontSize + (opts.padding * 2) : 0;
			} else {
				minSize.width = display ? fontSize + (opts.padding * 2) : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this,
				ctx = me.ctx,
				valueOrDefault = helpers.getValueOrDefault,
				opts = me.options,
				globalDefaults = Chart.defaults.global;

			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
					fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
					titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
					rotation = 0,
					titleX,
					titleY,
					top = me.top,
					left = me.left,
					bottom = me.bottom,
					right = me.right,
					maxWidth;

				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + ((bottom - top) / 2); // midpoint of the height
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
				ctx.fillText(opts.text, 0, 0, maxWidth);
				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Chart.Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		layout.configure(chart, title, titleOpts);
		layout.addBox(chart, title);
		chart.titleBlock = title;
	}

	return {
		id: 'title',

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				titleOpts = helpers.configMerge(Chart.defaults.global.title, titleOpts);

				if (titleBlock) {
					layout.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				Chart.layoutService.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
};

},{}],44:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = helpers.indexOf(labels, me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = helpers.indexOf(labels, me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex, includeOffset) {
			var me = this;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (me.options.gridLines.offsetGridLines && includeOffset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index, includeOffset) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var value;
			var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (me.options.gridLines.offsetGridLines) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};

},{}],45:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Chart.Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
				return Math.round(pixel);
			}

			pixel = me.bottom - (me.height / range * (rightValue - start));
			return Math.round(pixel);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};

},{}],46:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers,
		noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = Chart.Ticks.generators.linear(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};

},{}],47:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Chart.Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var getValueOrDefault = helpers.getValueOrDefault;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							values[index] = values[index] || 0;

							if (opts.relativePoints) {
								values[index] = 100;
							} else {
								// Don't need to split positive and negative since the log scale can't handle a 0 crossing
								values[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var minVal = helpers.min(valuesForType);
					var maxVal = helpers.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			me.min = getValueOrDefault(tickOpts.min, me.min);
			me.max = getValueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = 1;
					me.max = 10;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = Chart.Ticks.generators.logarithmic(generationOptions, me);

			if (!me.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				ticks.reverse();
			}

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		getPixelForValue: function(value) {
			var me = this;
			var innerDimension;
			var pixel;

			var start = me.start;
			var newVal = +me.getRightValue(value);
			var range;
			var opts = me.options;
			var tickOpts = opts.ticks;

			if (me.isHorizontal()) {
				range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
				if (newVal === 0) {
					pixel = me.left;
				} else {
					innerDimension = me.width;
					pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			} else {
				// Bottom - top since pixels increase downward on a screen
				innerDimension = me.height;
				if (start === 0 && !tickOpts.reverse) {
					range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
					if (newVal === start) {
						pixel = me.bottom;
					} else if (newVal === me.minNotZero) {
						pixel = me.bottom - innerDimension * 0.02;
					} else {
						pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
					}
				} else if (me.end === 0 && tickOpts.reverse) {
					range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
					if (newVal === me.end) {
						pixel = me.top;
					} else if (newVal === me.minNotZero) {
						pixel = me.top + innerDimension * 0.02;
					} else {
						pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
					}
				} else if (newVal === 0) {
					pixel = tickOpts.reverse ? me.top : me.bottom;
				} else {
					range = helpers.log10(me.end) - helpers.log10(start);
					innerDimension = me.height;
					pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var range = helpers.log10(me.end) - helpers.log10(me.start);
			var value, innerDimension;

			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
			} else {  // todo: if start === 0
				innerDimension = me.height;
				value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};

},{}],48:[function(require,module,exports){
'use strict';

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var globalDefaults = Chart.defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Chart.Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.getValueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.getValueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.getValueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i;
		var textSize;
		var pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y+= spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var getValueOrDefault = helpers.getValueOrDefault;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;
			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea,
				maxLeft = leftMovement + me.drawingArea,
				maxTop = topMovement + me.drawingArea,
				maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero? 0:
				min < 0 && max < 0? max :
				min > 0 && max > 0? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var getValueOrDefault = helpers.getValueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;

				// Tick Font
				var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || opts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						var yHeight = me.yCenter - yCenterOffset;

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
									yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, me.xCenter, yHeight);
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};

},{}],49:[function(require,module,exports){
/* global window: false */
'use strict';

var moment = require(1);
moment = typeof(moment) === 'function' ? moment : window.moment;

module.exports = function(Chart) {

	var helpers = Chart.helpers;
	var interval = {
		millisecond: {
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			size: 1000,
			steps: [1, 2, 5, 10, 30]
		},
		minute: {
			size: 60000,
			steps: [1, 2, 5, 10, 30]
		},
		hour: {
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			size: 604800000,
			maxStep: 4
		},
		month: {
			size: 2.628e9,
			maxStep: 3
		},
		quarter: {
			size: 7.884e9,
			maxStep: 4
		},
		year: {
			size: 3.154e10,
			maxStep: false
		}
	};

	var defaultConfig = {
		position: 'bottom',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm:ss a', // 11:20:01 AM
				hour: 'MMM D, hA', // Sept 4, 5PM
				day: 'll', // Sep 4 2015
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false
		}
	};

	/**
	 * Helper function to parse time to a moment object
	 * @param axis {TimeAxis} the time axis
	 * @param label {Date|string|number|Moment} The thing to parse
	 * @return {Moment} parsed time
	 */
	function parseTime(axis, label) {
		var timeOpts = axis.options.time;
		if (typeof timeOpts.parser === 'string') {
			return moment(label, timeOpts.parser);
		}
		if (typeof timeOpts.parser === 'function') {
			return timeOpts.parser(label);
		}
		if (typeof label.getMonth === 'function' || typeof label === 'number') {
			// Date objects
			return moment(label);
		}
		if (label.isValid && label.isValid()) {
			// Moment support
			return label;
		}
		var format = timeOpts.format;
		if (typeof format !== 'string' && format.call) {
			// Custom parsing (return an instance of moment)
			console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			return format(label);
		}
		// Moment format parsing
		return moment(label, format);
	}

	/**
	 * Figure out which is the best unit for the scale
	 * @param minUnit {String} minimum unit to use
	 * @param min {Number} scale minimum
	 * @param max {Number} scale maximum
	 * @return {String} the unit to use
	 */
	function determineUnit(minUnit, min, max, maxTicks) {
		var units = Object.keys(interval);
		var unit;
		var numUnits = units.length;

		for (var i = units.indexOf(minUnit); i < numUnits; i++) {
			unit = units[i];
			var unitDetails = interval[unit];
			var steps = (unitDetails.steps && unitDetails.steps[unitDetails.steps.length - 1]) || unitDetails.maxStep;
			if (steps === undefined || Math.ceil((max - min) / (steps * unitDetails.size)) <= maxTicks) {
				break;
			}
		}

		return unit;
	}

	/**
	 * Determines how we scale the unit
	 * @param min {Number} the scale minimum
	 * @param max {Number} the scale maximum
	 * @param unit {String} the unit determined by the {@see determineUnit} method
	 * @return {Number} the axis step size as a multiple of unit
	 */
	function determineStepSize(min, max, unit, maxTicks) {
		// Using our unit, figoure out what we need to scale as
		var unitDefinition = interval[unit];
		var unitSizeInMilliSeconds = unitDefinition.size;
		var sizeInUnits = Math.ceil((max - min) / unitSizeInMilliSeconds);
		var multiplier = 1;
		var range = max - min;

		if (unitDefinition.steps) {
			// Have an array of steps
			var numSteps = unitDefinition.steps.length;
			for (var i = 0; i < numSteps && sizeInUnits > maxTicks; i++) {
				multiplier = unitDefinition.steps[i];
				sizeInUnits = Math.ceil(range / (unitSizeInMilliSeconds * multiplier));
			}
		} else {
			while (sizeInUnits > maxTicks && maxTicks > 0) {
				++multiplier;
				sizeInUnits = Math.ceil(range / (unitSizeInMilliSeconds * multiplier));
			}
		}

		return multiplier;
	}

	/**
	 * Helper for generating axis labels.
	 * @param options {ITimeGeneratorOptions} the options for generation
	 * @param dataRange {IRange} the data range
	 * @param niceRange {IRange} the pretty range to display
	 * @return {Number[]} ticks
	 */
	function generateTicks(options, dataRange, niceRange) {
		var ticks = [];
		if (options.maxTicks) {
			var stepSize = options.stepSize;
			ticks.push(options.min !== undefined ? options.min : niceRange.min);
			var cur = moment(niceRange.min);
			while (cur.add(stepSize, options.unit).valueOf() < niceRange.max) {
				ticks.push(cur.valueOf());
			}
			var realMax = options.max || niceRange.max;
			if (ticks[ticks.length - 1] !== realMax) {
				ticks.push(realMax);
			}
		}
		return ticks;
	}

	/**
	 * @function Chart.Ticks.generators.time
	 * @param options {ITimeGeneratorOptions} the options for generation
	 * @param dataRange {IRange} the data range
	 * @return {Number[]} ticks
	 */
	Chart.Ticks.generators.time = function(options, dataRange) {
		var niceMin;
		var niceMax;
		var isoWeekday = options.isoWeekday;
		if (options.unit === 'week' && isoWeekday !== false) {
			niceMin = moment(dataRange.min).startOf('isoWeek').isoWeekday(isoWeekday).valueOf();
			niceMax = moment(dataRange.max).startOf('isoWeek').isoWeekday(isoWeekday);
			if (dataRange.max - niceMax > 0) {
				niceMax.add(1, 'week');
			}
			niceMax = niceMax.valueOf();
		} else {
			niceMin = moment(dataRange.min).startOf(options.unit).valueOf();
			niceMax = moment(dataRange.max).startOf(options.unit);
			if (dataRange.max - niceMax > 0) {
				niceMax.add(1, options.unit);
			}
			niceMax = niceMax.valueOf();
		}
		return generateTicks(options, dataRange, {
			min: niceMin,
			max: niceMax
		});
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			Chart.Scale.prototype.initialize.call(this);
		},
		determineDataLimits: function() {
			var me = this;
			var timeOpts = me.options.time;

			// We store the data range as unix millisecond timestamps so dataMin and dataMax will always be integers.
			var dataMin = Number.MAX_SAFE_INTEGER;
			var dataMax = Number.MIN_SAFE_INTEGER;

			var chartData = me.chart.data;
			var parsedData = {
				labels: [],
				datasets: []
			};

			var timestamp;

			helpers.each(chartData.labels, function(label, labelIndex) {
				var labelMoment = parseTime(me, label);

				if (labelMoment.isValid()) {
					// We need to round the time
					if (timeOpts.round) {
						labelMoment.startOf(timeOpts.round);
					}

					timestamp = labelMoment.valueOf();
					dataMin = Math.min(timestamp, dataMin);
					dataMax = Math.max(timestamp, dataMax);

					// Store this value for later
					parsedData.labels[labelIndex] = timestamp;
				}
			});

			helpers.each(chartData.datasets, function(dataset, datasetIndex) {
				var timestamps = [];

				if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null && me.chart.isDatasetVisible(datasetIndex)) {
					// We have potential point data, so we need to parse this
					helpers.each(dataset.data, function(value, dataIndex) {
						var dataMoment = parseTime(me, me.getRightValue(value));

						if (dataMoment.isValid()) {
							if (timeOpts.round) {
								dataMoment.startOf(timeOpts.round);
							}

							timestamp = dataMoment.valueOf();
							dataMin = Math.min(timestamp, dataMin);
							dataMax = Math.max(timestamp, dataMax);
							timestamps[dataIndex] = timestamp;
						}
					});
				} else {
					// We have no x coordinates, so use the ones from the labels
					timestamps = parsedData.labels.slice();
				}

				parsedData.datasets[datasetIndex] = timestamps;
			});

			me.dataMin = dataMin;
			me.dataMax = dataMax;
			me._parsedData = parsedData;
		},
		buildTicks: function() {
			var me = this;
			var timeOpts = me.options.time;

			var minTimestamp;
			var maxTimestamp;
			var dataMin = me.dataMin;
			var dataMax = me.dataMax;

			if (timeOpts.min) {
				var minMoment = parseTime(me, timeOpts.min);
				if (timeOpts.round) {
					minMoment.round(timeOpts.round);
				}
				minTimestamp = minMoment.valueOf();
			}

			if (timeOpts.max) {
				maxTimestamp = parseTime(me, timeOpts.max).valueOf();
			}

			var maxTicks = me.getLabelCapacity(minTimestamp || dataMin);
			var unit = timeOpts.unit || determineUnit(timeOpts.minUnit, minTimestamp || dataMin, maxTimestamp || dataMax, maxTicks);
			me.displayFormat = timeOpts.displayFormats[unit];

			var stepSize = timeOpts.stepSize || determineStepSize(minTimestamp || dataMin, maxTimestamp || dataMax, unit, maxTicks);
			me.ticks = Chart.Ticks.generators.time({
				maxTicks: maxTicks,
				min: minTimestamp,
				max: maxTimestamp,
				stepSize: stepSize,
				unit: unit,
				isoWeekday: timeOpts.isoWeekday
			}, {
				min: dataMin,
				max: dataMax
			});

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(me.ticks);
			me.min = helpers.min(me.ticks);
		},
		// Get tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
			var value = me.chart.data.datasets[datasetIndex].data[index];

			if (value !== null && typeof value === 'object') {
				label = me.getRightValue(value);
			}

			// Format nicely
			if (me.options.time.tooltipFormat) {
				label = parseTime(me, label).format(me.options.time.tooltipFormat);
			}

			return label;
		},
		// Function to format an individual tick mark
		tickFormatFunction: function(tick, index, ticks) {
			var formattedTick = tick.format(this.displayFormat);
			var tickOpts = this.options.ticks;
			var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);

			if (callback) {
				return callback(formattedTick, index, ticks);
			}
			return formattedTick;
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsTimestamps = me.ticks;
			me.ticks = me.ticks.map(function(tick) {
				return moment(tick);
			}).map(me.tickFormatFunction, me);
		},
		getPixelForOffset: function(offset) {
			var me = this;
			var epochWidth = me.max - me.min;
			var decimal = epochWidth ? (offset - me.min) / epochWidth : 0;

			if (me.isHorizontal()) {
				var valueOffset = (me.width * decimal);
				return me.left + Math.round(valueOffset);
			}

			var heightOffset = (me.height * decimal);
			return me.top + Math.round(heightOffset);
		},
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var offset = null;
			if (index !== undefined && datasetIndex !== undefined) {
				offset = me._parsedData.datasets[datasetIndex][index];
			}

			if (offset === null) {
				if (!value || !value.isValid) {
					// not already a moment object
					value = parseTime(me, me.getRightValue(value));
				}

				if (value && value.isValid && value.isValid()) {
					offset = value.valueOf();
				}
			}

			if (offset !== null) {
				return me.getPixelForOffset(offset);
			}
		},
		getPixelForTick: function(index) {
			return this.getPixelForOffset(this.ticksAsTimestamps[index]);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var innerDimension = me.isHorizontal() ? me.width : me.height;
			var offset = (pixel - (me.isHorizontal() ? me.left : me.top)) / innerDimension;
			return moment(me.min + (offset * (me.max - me.min)));
		},
		// Crude approximation of what the label width might be
		getLabelWidth: function(label) {
			var me = this;
			var ticks = me.options.ticks;

			var tickLabelWidth = me.ctx.measureText(label).width;
			var cosRotation = Math.cos(helpers.toRadians(ticks.maxRotation));
			var sinRotation = Math.sin(helpers.toRadians(ticks.maxRotation));
			var tickFontSize = helpers.getValueOrDefault(ticks.fontSize, Chart.defaults.global.defaultFontSize);
			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},
		getLabelCapacity: function(exampleTime) {
			var me = this;

			me.displayFormat = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, []);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);

			var innerWidth = me.isHorizontal() ? me.width : me.height;
			var labelCapacity = innerWidth / tickLabelWidth;
			return labelCapacity;
		}
	});
	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);

};

},{"1":1}]},{},[7])(7)
});

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1466))

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){var b=function(c,d){this.id=++a.FE.ID,this.opts=a.extend(!0,{},a.extend({},b.DEFAULTS,\"object\"==typeof d&&d));var e=JSON.stringify(this.opts);a.FE.OPTS_MAPPING[e]=a.FE.OPTS_MAPPING[e]||this.id,this.sid=a.FE.OPTS_MAPPING[e],a.FE.SHARED[this.sid]=a.FE.SHARED[this.sid]||{},this.shared=a.FE.SHARED[this.sid],this.shared.count=(this.shared.count||0)+1,this.$oel=a(c),this.$oel.data(\"froala.editor\",this),this.o_doc=c.ownerDocument,this.o_win=\"defaultView\"in this.o_doc?this.o_doc.defaultView:this.o_doc.parentWindow;var f=a(this.o_win).scrollTop();this.$oel.on(\"froala.doInit\",a.proxy(function(){this.$oel.off(\"froala.doInit\"),this.doc=this.$el.get(0).ownerDocument,this.win=\"defaultView\"in this.doc?this.doc.defaultView:this.doc.parentWindow,this.$doc=a(this.doc),this.$win=a(this.win),this.opts.pluginsEnabled||(this.opts.pluginsEnabled=Object.keys(a.FE.PLUGINS)),this.opts.initOnClick?(this.load(a.FE.MODULES),this.$el.on(\"touchstart.init\",function(){a(this).data(\"touched\",!0)}),this.$el.on(\"touchmove.init\",function(){a(this).removeData(\"touched\")}),this.$el.on(\"mousedown.init touchend.init dragenter.init focus.init\",a.proxy(function(b){if(\"touchend\"==b.type&&!this.$el.data(\"touched\"))return!0;if(1===b.which||!b.which){this.$el.off(\"mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init\"),this.load(a.FE.MODULES),this.load(a.FE.PLUGINS);var c=b.originalEvent&&b.originalEvent.originalTarget;c&&\"IMG\"==c.tagName&&a(c).trigger(\"mousedown\"),void 0===this.ul&&this.destroy(),\"touchend\"==b.type&&this.image&&b.originalEvent&&b.originalEvent.target&&a(b.originalEvent.target).is(\"img\")&&setTimeout(a.proxy(function(){this.image.edit(a(b.originalEvent.target))},this),100),this.ready=!0,this.events.trigger(\"initialized\")}},this)),this.events.trigger(\"initializationDelayed\")):(this.load(a.FE.MODULES),this.load(a.FE.PLUGINS),a(this.o_win).scrollTop(f),void 0===this.ul&&this.destroy(),this.ready=!0,this.events.trigger(\"initialized\"))},this)),this._init()};b.DEFAULTS={initOnClick:!1,pluginsEnabled:null},b.MODULES={},b.PLUGINS={},b.VERSION=\"2.7.2\",b.INSTANCES=[],b.OPTS_MAPPING={},b.SHARED={},b.ID=0,b.prototype._init=function(){var b=this.$oel.prop(\"tagName\");this.$oel.closest(\"label\").length;var c=a.proxy(function(){\"TEXTAREA\"!=b&&(this._original_html=this._original_html||this.$oel.html()),this.$box=this.$box||this.$oel,this.opts.fullPage&&(this.opts.iframe=!0),this.opts.iframe?(this.$iframe=a('<iframe src=\"about:blank\" frameBorder=\"0\">'),this.$wp=a(\"<div></div>\"),this.$box.html(this.$wp),this.$wp.append(this.$iframe),this.$iframe.get(0).contentWindow.document.open(),this.$iframe.get(0).contentWindow.document.write(\"<!DOCTYPE html>\"),this.$iframe.get(0).contentWindow.document.write(\"<html><head></head><body></body></html>\"),this.$iframe.get(0).contentWindow.document.close(),this.$el=this.$iframe.contents().find(\"body\"),this.el=this.$el.get(0),this.$head=this.$iframe.contents().find(\"head\"),this.$html=this.$iframe.contents().find(\"html\"),this.iframe_document=this.$iframe.get(0).contentWindow.document,this.$oel.trigger(\"froala.doInit\")):(this.$el=a(\"<div></div>\"),this.el=this.$el.get(0),this.$wp=a(\"<div></div>\").append(this.$el),this.$box.html(this.$wp),this.$oel.trigger(\"froala.doInit\"))},this),d=a.proxy(function(){this.$box=a(\"<div>\"),this.$oel.before(this.$box).hide(),this._original_html=this.$oel.val(),this.$oel.parents(\"form\").on(\"submit.\"+this.id,a.proxy(function(){this.events.trigger(\"form.submit\")},this)),this.$oel.parents(\"form\").on(\"reset.\"+this.id,a.proxy(function(){this.events.trigger(\"form.reset\")},this)),c()},this),e=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.$el.attr(\"contenteditable\",!0).css(\"outline\",\"none\").css(\"display\",\"inline-block\"),this.opts.multiLine=!1,this.opts.toolbarInline=!1,this.$oel.trigger(\"froala.doInit\")},this),f=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,this.$oel.trigger(\"froala.doInit\")},this),g=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,this.$oel.on(\"click.popup\",function(a){a.preventDefault()}),this.$oel.trigger(\"froala.doInit\")},this);this.opts.editInPopup?g():\"TEXTAREA\"==b?d():\"A\"==b?e():\"IMG\"==b?f():\"BUTTON\"==b||\"INPUT\"==b?(this.opts.editInPopup=!0,this.opts.toolbarInline=!1,g()):c()},b.prototype.load=function(b){for(var c in b)if(b.hasOwnProperty(c)){if(this[c])continue;if(a.FE.PLUGINS[c]&&this.opts.pluginsEnabled.indexOf(c)<0)continue;if(this[c]=new b[c](this),this[c]._init&&(this[c]._init(),this.opts.initOnClick&&\"core\"==c))return!1}},b.prototype.destroy=function(){this.shared.count--,this.events.$off();var b=this.html.get();if(this.events.trigger(\"destroy\",[],!0),this.events.trigger(\"shared.destroy\",void 0,!0),0===this.shared.count){for(var c in this.shared)this.shared.hasOwnProperty(c)&&(this.shared[c],a.FE.SHARED[this.sid][c]=null);a.FE.SHARED[this.sid]={}}this.$oel.parents(\"form\").off(\".\"+this.id),this.$oel.off(\"click.popup\"),this.$oel.removeData(\"froala.editor\"),this.$oel.off(\"froalaEditor\"),this.core.destroy(b),a.FE.INSTANCES.splice(a.FE.INSTANCES.indexOf(this),1)},a.fn.froalaEditor=function(c){for(var d=[],e=0;e<arguments.length;e++)d.push(arguments[e]);if(\"string\"==typeof c){var f=[];return this.each(function(){var b=a(this),e=b.data(\"froala.editor\");if(e){var g,h;if(c.indexOf(\".\")>0&&e[c.split(\".\")[0]]?(e[c.split(\".\")[0]]&&(g=e[c.split(\".\")[0]]),h=c.split(\".\")[1]):(g=e,h=c.split(\".\")[0]),!g[h])return a.error(\"Method \"+c+\" does not exist in Froala Editor.\");var i=g[h].apply(e,d.slice(1));void 0===i?f.push(this):0===f.length&&f.push(i)}}),1==f.length?f[0]:f}if(\"object\"==typeof c||!c)return this.each(function(){a(this).data(\"froala.editor\")||new b(this,c)})},a.fn.froalaEditor.Constructor=b,a.FroalaEditor=b,a.FE=b,a.FE.XS=0,a.FE.SM=1,a.FE.MD=2,a.FE.LG=3;var c=\"a-z\\\\u0080-\\\\u009f\\\\u00a1-\\\\uffff0-9-_\";a.FE.LinkRegExCommon=\"(([\"+c+\"])|([\"+c+\"](\\\\.|-|_|--))){1,}[\"+c+\"]{1,}\",a.FE.LinkRegExEnd=\"((:[0-9]{1,5})|)(((\\\\/|\\\\?|#)[a-z\\\\u00a1-\\\\uffff0-9@?\\\\|!^=%&amp;/~+#-_{}]*)|())\",a.FE.LinkRegExTLD=\"((\"+a.FE.LinkRegExCommon+\")(\\\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))\",a.FE.LinkRegExHTTP=\"((ftp|http|https):\\\\/\\\\/\"+a.FE.LinkRegExCommon+\")\",a.FE.LinkRegExAuth=\"((ftp|http|https):\\\\/\\\\/[\\\\u0021-\\\\uffff]{1,}@\"+a.FE.LinkRegExCommon+\")\",a.FE.LinkRegExWWW=\"(www\\\\.\"+a.FE.LinkRegExCommon+\"\\\\.[a-z0-9-]{2,24})\",a.FE.LinkRegEx=\"(\"+a.FE.LinkRegExTLD+\"|\"+a.FE.LinkRegExHTTP+\"|\"+a.FE.LinkRegExWWW+\"|\"+a.FE.LinkRegExAuth+\")\"+a.FE.LinkRegExEnd,a.FE.LinkProtocols=[\"mailto\",\"tel\",\"sms\",\"notes\",\"data\"],a.FE.MAIL_REGEX=/.+@.+\\..+/i,a.FE.MODULES.helpers=function(b){function c(){var a,b,c=-1;return\"Microsoft Internet Explorer\"==navigator.appName?(a=navigator.userAgent,b=new RegExp(\"MSIE ([0-9]{1,}[\\\\.0-9]{0,})\"),null!==b.exec(a)&&(c=parseFloat(RegExp.$1))):\"Netscape\"==navigator.appName&&(a=navigator.userAgent,b=new RegExp(\"Trident/.*rv:([0-9]{1,}[\\\\.0-9]{0,})\"),null!==b.exec(a)&&(c=parseFloat(RegExp.$1))),c}function d(){var a={},b=c();if(b>0)a.msie=!0;else{var d=navigator.userAgent.toLowerCase(),e=/(edge)[ \\/]([\\w.]+)/.exec(d)||/(chrome)[ \\/]([\\w.]+)/.exec(d)||/(webkit)[ \\/]([\\w.]+)/.exec(d)||/(opera)(?:.*version|)[ \\/]([\\w.]+)/.exec(d)||/(msie) ([\\w.]+)/.exec(d)||d.indexOf(\"compatible\")<0&&/(mozilla)(?:.*? rv:([\\w.]+)|)/.exec(d)||[],f={browser:e[1]||\"\",version:e[2]||\"0\"};e[1]&&(a[f.browser]=!0),a.chrome?a.webkit=!0:a.webkit&&(a.safari=!0)}return a.msie&&(a.version=b),a}function e(){return/(iPad|iPhone|iPod)/g.test(navigator.userAgent)&&!h()}function f(){return/(Android)/g.test(navigator.userAgent)&&!h()}function g(){return/(Blackberry)/g.test(navigator.userAgent)}function h(){return/(Windows Phone)/gi.test(navigator.userAgent)}function i(){return f()||e()||g()}function j(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){window.setTimeout(a,1e3/60)}}function k(a){return parseInt(a,10)||0}function l(){var b=a('<div class=\"fr-visibility-helper\"></div>').appendTo(\"body:first\");try{var c=k(b.css(\"margin-left\"));return b.remove(),c}catch(d){return a.FE.LG}}function m(){return\"ontouchstart\"in window||window.DocumentTouch&&document instanceof DocumentTouch}function n(b){return!!/^(https?:|ftps?:|)\\/\\//i.test(b)&&(b=String(b).replace(/</g,\"%3C\").replace(/>/g,\"%3E\").replace(/\"/g,\"%22\").replace(/ /g,\"%20\"),new RegExp(\"^\"+a.FE.LinkRegEx+\"$\",\"gi\").test(b))}function o(b){return!/^(https?:|ftps?:|)\\/\\//i.test(b)&&a.FE.MAIL_REGEX.test(b)}function p(b){if(/^([A-Za-z]:(\\\\){1,2}|[A-Za-z]:((\\\\){1,2}[^\\\\]+)+)(\\\\)?$/i.test(b))return b;if(/^(https?:|ftps?:|)\\/\\//i.test(b)){if(!n(b)&&!n(\"http:\"+b))return\"\"}else{if(new RegExp(\"^(\"+a.FE.LinkProtocols.join(\"|\")+\"):\\\\/\\\\/\",\"i\").test(b))return b;b=encodeURIComponent(b).replace(/%23/g,\"#\").replace(/%2F/g,\"/\").replace(/%25/g,\"%\").replace(/mailto%3A/gi,\"mailto:\").replace(/file%3A/gi,\"file:\").replace(/sms%3A/gi,\"sms:\").replace(/tel%3A/gi,\"tel:\").replace(/notes%3A/gi,\"notes:\").replace(/data%3Aimage/gi,\"data:image\").replace(/blob%3A/gi,\"blob:\").replace(/webkit-fake-url%3A/gi,\"webkit-fake-url:\").replace(/%3F/g,\"?\").replace(/%3D/g,\"=\").replace(/%26/g,\"&\").replace(/&amp;/g,\"&\").replace(/%2C/g,\",\").replace(/%3B/g,\";\").replace(/%2B/g,\"+\").replace(/%40/g,\"@\").replace(/%5B/g,\"[\").replace(/%5D/g,\"]\").replace(/%7B/g,\"{\").replace(/%7D/g,\"}\")}return b}function q(a){return a&&!a.propertyIsEnumerable(\"length\")&&\"object\"==typeof a&&\"number\"==typeof a.length}function r(a){function b(a){return(\"0\"+parseInt(a,10).toString(16)).slice(-2)}try{return a&&\"transparent\"!==a?/^#[0-9A-F]{6}$/i.test(a)?a:(a=a.match(/^rgb\\((\\d+),\\s*(\\d+),\\s*(\\d+)\\)$/),(\"#\"+b(a[1])+b(a[2])+b(a[3])).toUpperCase()):\"\"}catch(c){return null}}function s(a){var b=/^#?([a-f\\d])([a-f\\d])([a-f\\d])$/i;a=a.replace(b,function(a,b,c,d){return b+b+c+c+d+d});var c=/^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$/i.exec(a);return c?\"rgb(\"+parseInt(c[1],16)+\", \"+parseInt(c[2],16)+\", \"+parseInt(c[3],16)+\")\":\"\"}function t(c){var d=(c.css(\"text-align\")||\"\").replace(/-(.*)-/g,\"\");if([\"left\",\"right\",\"justify\",\"center\"].indexOf(d)<0){if(!B){var e=a('<div dir=\"'+(\"rtl\"==b.opts.direction?\"rtl\":\"auto\")+'\" style=\"text-align: '+b.$el.css(\"text-align\")+'; position: fixed; left: -3000px;\"><span id=\"s1\">.</span><span id=\"s2\">.</span></div>');a(\"body:first\").append(e);var f=e.find(\"#s1\").get(0).getBoundingClientRect().left,g=e.find(\"#s2\").get(0).getBoundingClientRect().left;e.remove(),B=f<g?\"left\":\"right\"}d=B}return d}function u(){return null==C&&(C=navigator.platform.toUpperCase().indexOf(\"MAC\")>=0),C}function v(){function a(a,b){var e=a[b];a[b]=function(a){var b,f=!1,g=!1;if(a&&a.match(d)){a=a.replace(d,\"\"),this.parentNode||(c.appendChild(this),g=!0);var h=this.parentNode;return this.id||(this.id=\"rootedQuerySelector_id_\"+(new Date).getTime(),f=!0),b=e.call(h,\"#\"+this.id+\" \"+a),f&&(this.id=\"\"),g&&c.removeChild(this),b}return e.call(this,a)}}var c=b.o_doc.createElement(\"div\");try{c.querySelectorAll(\":scope *\")}catch(e){var d=/^\\s*:scope/gi;a(Element.prototype,\"querySelector\"),a(Element.prototype,\"querySelectorAll\"),a(HTMLElement.prototype,\"querySelector\"),a(HTMLElement.prototype,\"querySelectorAll\")}}function w(){return b.o_win.pageYOffset?b.o_win.pageYOffset:b.o_doc.documentElement&&b.o_doc.documentElement.scrollTop?b.o_doc.documentElement.scrollTop:b.o_doc.body.scrollTop?b.o_doc.body.scrollTop:0}function x(){return b.o_win.pageXOffset?b.o_win.pageXOffset:b.o_doc.documentElement&&b.o_doc.documentElement.scrollLeft?b.o_doc.documentElement.scrollLeft:b.o_doc.body.scrollLeft?b.o_doc.body.scrollLeft:0}function y(){Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(a){var b=this,c=this;if(!document.documentElement.contains(b))return null;do{if(c.matches(a))return c;c=c.parentElement}while(null!==c);return null})}function z(a){var b=a.getBoundingClientRect();return b.top>=0&&b.bottom<=(window.innerHeight||document.documentElement.clientHeight)||b.top<=0&&b.bottom>=(window.innerHeight||document.documentElement.clientHeight)}function A(){b.browser=d(),v(),y()}var B,C=null;return{_init:A,isIOS:e,isMac:u,isAndroid:f,isBlackberry:g,isWindowsPhone:h,isMobile:i,isEmail:o,requestAnimationFrame:j,getPX:k,screenSize:l,isTouch:m,sanitizeURL:p,isArray:q,RGBToHex:r,HEXtoRGB:s,isURL:n,getAlignment:t,scrollTop:w,scrollLeft:x,isInViewPort:z}},a.FE.MODULES.events=function(b){function c(a,b,c){s(a,b,c)}function d(){c(b.$el,\"cut copy paste beforepaste\",function(a){v(a.type,[a])})}function e(){c(b.$el,\"click mouseup mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart\",function(a){v(a.type,[a])}),r(\"mousedown\",function(){for(var c=0;c<a.FE.INSTANCES.length;c++)a.FE.INSTANCES[c]!=b&&a.FE.INSTANCES[c].popups&&a.FE.INSTANCES[c].popups.areVisible()&&a.FE.INSTANCES[c].$el.find(\".fr-marker\").remove()})}function f(){c(b.$el,\"keydown keypress keyup input\",function(a){v(a.type,[a])})}function g(){c(b.$win,b._mousedown,function(a){v(\"window.mousedown\",[a]),n()}),c(b.$win,b._mouseup,function(a){v(\"window.mouseup\",[a])}),c(b.$win,\"cut copy keydown keyup touchmove touchend\",function(a){v(\"window.\"+a.type,[a])})}function h(){c(b.$doc,\"dragend drop\",function(a){v(\"document.\"+a.type,[a])})}function i(c){var d;if(void 0===c&&(c=!0),!b.$wp)return!1;if(b.helpers.isIOS()&&b.$win.get(0).focus(),!b.core.hasFocus()&&c){var e=b.$win.scrollTop();if(b.browser.msie&&b.$box&&b.$box.css(\"position\",\"fixed\"),b.browser.msie&&b.$wp&&b.$wp.css(\"overflow\",\"visible\"),o(),b.$el.focus(),n(),b.browser.msie&&b.$box&&b.$box.css(\"position\",\"\"),b.browser.msie&&b.$wp&&b.$wp.css(\"overflow\",\"auto\"),e!=b.$win.scrollTop()&&b.$win.scrollTop(e),d=b.selection.info(b.el),!d.atStart)return!1}if(!b.core.hasFocus()||b.$el.find(\".fr-marker\").length>0)return!1;if(d=b.selection.info(b.el),d.atStart&&b.selection.isCollapsed()&&null!=b.html.defaultTag()){var f=b.markers.insert();if(f&&!b.node.blockParent(f)){a(f).remove();var g=b.$el.find(b.html.blockTagsQuery()).get(0);g&&(a(g).prepend(a.FE.MARKERS),b.selection.restore())}else f&&a(f).remove()}}function j(){c(b.$el,\"focus\",function(a){p()&&(i(!1),!1===C&&v(a.type,[a]))}),c(b.$el,\"blur\",function(a){p()&&!0===C&&(v(a.type,[a]),n())}),r(\"focus\",function(){C=!0}),r(\"blur\",function(){C=!1})}function k(){b.helpers.isMobile()?(b._mousedown=\"touchstart\",b._mouseup=\"touchend\",b._move=\"touchmove\",b._mousemove=\"touchmove\"):(b._mousedown=\"mousedown\",b._mouseup=\"mouseup\",b._move=\"\",b._mousemove=\"mousemove\")}function l(c){var d=a(c.currentTarget);return b.edit.isDisabled()||b.node.hasClass(d.get(0),\"fr-disabled\")?(c.preventDefault(),!1):\"mousedown\"===c.type&&1!==c.which||(b.helpers.isMobile()||c.preventDefault(),(b.helpers.isAndroid()||b.helpers.isWindowsPhone())&&0===d.parents(\".fr-dropdown-menu\").length&&(c.preventDefault(),c.stopPropagation()),d.addClass(\"fr-selected\"),void b.events.trigger(\"commands.mousedown\",[d]))}function m(c,d){var e=a(c.currentTarget);if(b.edit.isDisabled()||b.node.hasClass(e.get(0),\"fr-disabled\"))return c.preventDefault(),!1;if(\"mouseup\"===c.type&&1!==c.which)return!0;if(!b.node.hasClass(e.get(0),\"fr-selected\"))return!0;if(\"touchmove\"!=c.type){if(c.stopPropagation(),c.stopImmediatePropagation(),c.preventDefault(),!b.node.hasClass(e.get(0),\"fr-selected\"))return b.button.getButtons(\".fr-selected\",!0).removeClass(\"fr-selected\"),!1;if(b.button.getButtons(\".fr-selected\",!0).removeClass(\"fr-selected\"),e.data(\"dragging\")||e.attr(\"disabled\"))return e.removeData(\"dragging\"),!1;var f=e.data(\"timeout\");f&&(clearTimeout(f),e.removeData(\"timeout\")),d.apply(b,[c])}else e.data(\"timeout\")||e.data(\"timeout\",setTimeout(function(){e.data(\"dragging\",!0)},100))}function n(){A=!0}function o(){A=!1}function p(){return A}function q(a,c,d){s(a,b._mousedown,c,function(a){b.edit.isDisabled()||l(a)},!0),s(a,b._mouseup+\" \"+b._move,c,function(a){b.edit.isDisabled()||m(a,d)},!0),s(a,\"mousedown click mouseup\",c,function(a){b.edit.isDisabled()||a.stopPropagation()},!0),r(\"window.mouseup\",function(){b.edit.isDisabled()||(a.find(c).removeClass(\"fr-selected\"),n())})}function r(a,c,d){var e=a.split(\" \");if(e.length>1){for(var f=0;f<e.length;f++)r(e[f],c,d);return!0}void 0===d&&(d=!1);var g;g=0!==a.indexOf(\"shared.\")?B[a]=B[a]||[]:b.shared._events[a]=b.shared._events[a]||[],d?g.unshift(c):g.push(c)}function s(a,c,d,e,f){\"function\"==typeof d&&(f=e,e=d,d=!1);var g=f?b.shared.$_events:D,h=f?b.sid:b.id;d?a.on(c.split(\" \").join(\".ed\"+h+\" \")+\".ed\"+h,d,e):a.on(c.split(\" \").join(\".ed\"+h+\" \")+\".ed\"+h,e),g.push([a,c.split(\" \").join(\".ed\"+h+\" \")+\".ed\"+h])}function t(a){for(var b=0;b<a.length;b++)a[b][0].off(a[b][1])}function u(){t(D),D=[],0===b.shared.count&&(t(b.shared.$_events),b.shared.$_events=[])}function v(c,d,e){if(!b.edit.isDisabled()||e){var f;if(0!==c.indexOf(\"shared.\"))f=B[c];else{if(b.shared.count>0)return!1;f=b.shared._events[c]}var g;if(f)for(var h=0;h<f.length;h++)if(!1===(g=f[h].apply(b,d)))return!1;return!1!==(g=b.$oel.triggerHandler(\"froalaEditor.\"+c,a.merge([b],d||[])))&&g}}function w(c,d,e){if(!b.edit.isDisabled()||e){var f;if(0!==c.indexOf(\"shared.\"))f=B[c];else{if(b.shared.count>0)return!1;f=b.shared._events[c]}var g;if(f)for(var h=0;h<f.length;h++)void 0!==(g=f[h].apply(b,[d]))&&(d=g);return g=b.$oel.triggerHandler(\"froalaEditor.\"+c,a.merge([b],[d])),void 0!==g&&(d=g),d}}function x(){for(var a in B)B.hasOwnProperty(a)&&delete B[a]}function y(){for(var a in b.shared._events)b.shared._events.hasOwnProperty(a)&&delete b.shared._events[a]}function z(){b.shared.$_events=b.shared.$_events||[],b.shared._events={},k(),e(),g(),h(),f(),j(),n(),d(),r(\"destroy\",x),r(\"shared.destroy\",y)}var A,B={},C=!1,D=[];return{_init:z,on:r,trigger:v,bindClick:q,disableBlur:o,enableBlur:n,blurActive:p,focus:i,chainTrigger:w,$on:s,$off:u}},a.FE.MODULES.node=function(b){function c(a){return a&&\"IFRAME\"!=a.tagName?Array.prototype.slice.call(a.childNodes||[]):[]}function d(b){return!!b&&(b.nodeType==Node.ELEMENT_NODE&&a.FE.BLOCK_TAGS.indexOf(b.tagName.toLowerCase())>=0)}function e(a){return!!a&&(a.nodeType==Node.ELEMENT_NODE&&\"a\"==a.tagName.toLowerCase())}function f(e,f){if(!e)return!0;if(e.querySelector(\"table\"))return!1;var g=c(e);1==g.length&&d(g[0])&&(g=c(g[0]));for(var h=!1,i=0;i<g.length;i++){var j=g[i];if((!f||!b.node.hasClass(j,\"fr-marker\"))&&(j.nodeType!=Node.TEXT_NODE||0!==j.textContent.length)){if(\"BR\"!=j.tagName&&(j.textContent||\"\").replace(/\\u200B/gi,\"\").replace(/\\n/g,\"\").length>0)return!1;if(h)return!1;\"BR\"==j.tagName&&(h=!0)}}return!(e.querySelectorAll(a.FE.VOID_ELEMENTS.join(\",\")).length-e.querySelectorAll(\"br\").length)&&(!e.querySelector(b.opts.htmlAllowedEmptyTags.join(\":not(.fr-marker),\")+\":not(.fr-marker)\")&&(!(e.querySelectorAll(a.FE.BLOCK_TAGS.join(\",\")).length>1)&&!e.querySelector(b.opts.htmlDoNotWrapTags.join(\":not(.fr-marker),\")+\":not(.fr-marker)\")))}function g(a){for(;a&&a.parentNode!==b.el&&(!a.parentNode||!b.node.hasClass(a.parentNode,\"fr-inner\"));)if(a=a.parentNode,d(a))return a;return null}function h(c,e,f){if(void 0===e&&(e=[]),void 0===f&&(f=!0),e.push(b.el),e.indexOf(c.parentNode)>=0||c.parentNode&&b.node.hasClass(c.parentNode,\"fr-inner\")||c.parentNode&&a.FE.SIMPLE_ENTER_TAGS.indexOf(c.parentNode.tagName)>=0&&f)return null;for(;e.indexOf(c.parentNode)<0&&c.parentNode&&!b.node.hasClass(c.parentNode,\"fr-inner\")&&(a.FE.SIMPLE_ENTER_TAGS.indexOf(c.parentNode.tagName)<0||!f)&&(!d(c)||!d(c.parentNode)||!f);)c=c.parentNode;return c}function i(a){var b={},c=a.attributes;if(c)for(var d=0;d<c.length;d++){var e=c[d];b[e.nodeName]=e.value}return b}function j(a){for(var b=\"\",c=i(a),d=Object.keys(c).sort(),e=0;e<d.length;e++){var f=d[e],g=c[f];g.indexOf(\"'\")<0&&g.indexOf('\"')>=0?b+=\" \"+f+\"='\"+g+\"'\":g.indexOf('\"')>=0&&g.indexOf(\"'\")>=0?(g=g.replace(/\"/g,\"&quot;\"),b+=\" \"+f+'=\"'+g+'\"'):b+=\" \"+f+'=\"'+g+'\"'}return b}function k(a){for(var b=a.attributes,c=b.length-1;c>=0;c--){var d=b[c];a.removeAttribute(d.nodeName)}}function l(a){return\"<\"+a.tagName.toLowerCase()+j(a)+\">\"}function m(a){return\"</\"+a.tagName.toLowerCase()+\">\"}function n(a,c){void 0===c&&(c=!0);for(var d=a.previousSibling;d&&c&&b.node.hasClass(d,\"fr-marker\");)d=d.previousSibling;return!d||d.nodeType==Node.TEXT_NODE&&\"\"===d.textContent&&n(d)}function o(a,c){void 0===c&&(c=!0);for(var d=a.nextSibling;d&&c&&b.node.hasClass(d,\"fr-marker\");)d=d.nextSibling;return!d||d.nodeType==Node.TEXT_NODE&&\"\"===d.textContent&&o(d)}function p(b){return b&&b.nodeType==Node.ELEMENT_NODE&&a.FE.VOID_ELEMENTS.indexOf((b.tagName||\"\").toLowerCase())>=0}function q(a){return!!a&&[\"UL\",\"OL\"].indexOf(a.tagName)>=0}function r(a){return a===b.el}function s(a){return a&&a.nodeType==Node.ELEMENT_NODE&&a.getAttribute(\"class\")&&(a.getAttribute(\"class\")||\"\").indexOf(\"fr-deletable\")>=0}function t(a){return a===b.doc.activeElement&&(!b.doc.hasFocus||b.doc.hasFocus())&&!!(r(a)||a.type||a.href||~a.tabIndex)}function u(a){return(!a.getAttribute||\"false\"!=a.getAttribute(\"contenteditable\"))&&[\"STYLE\",\"SCRIPT\"].indexOf(a.tagName)<0}function v(b,c){return b instanceof a&&(b=b.get(0)),b&&b.classList&&b.classList.contains(c)}function w(a){return b.browser.msie?a:{acceptNode:a}}return{isBlock:d,isEmpty:f,blockParent:g,deepestParent:h,rawAttributes:i,attributes:j,clearAttributes:k,openTagString:l,closeTagString:m,isFirstSibling:n,isLastSibling:o,isList:q,isLink:e,isElement:r,contents:c,isVoid:p,hasFocus:t,isEditable:u,isDeletable:s,hasClass:v,filter:w}},a.FE.INVISIBLE_SPACE=\"&#8203;\",a.FE.START_MARKER='<span class=\"fr-marker\" data-id=\"0\" data-type=\"true\" style=\"display: none; line-height: 0;\">'+a.FE.INVISIBLE_SPACE+\"</span>\",a.FE.END_MARKER='<span class=\"fr-marker\" data-id=\"0\" data-type=\"false\" style=\"display: none; line-height: 0;\">'+a.FE.INVISIBLE_SPACE+\"</span>\",a.FE.MARKERS=a.FE.START_MARKER+a.FE.END_MARKER,a.FE.MODULES.markers=function(b){function c(c,d){return a('<span class=\"fr-marker\" data-id=\"'+d+'\" data-type=\"'+c+'\" style=\"display: '+(b.browser.safari?\"none\":\"inline-block\")+'; line-height: 0;\">'+a.FE.INVISIBLE_SPACE+\"</span>\",b.doc)[0]}function d(d,e,f){var g,h,i;try{var j=d.cloneRange();if(j.collapse(e),j.insertNode(c(e,f)),!0===e)for(g=b.$el.find('span.fr-marker[data-type=\"true\"][data-id=\"'+f+'\"]').get(0),i=g.nextSibling;i&&i.nodeType===Node.TEXT_NODE&&0===i.textContent.length;)a(i).remove(),i=g.nextSibling;if(!0===e&&!d.collapsed){for(;!b.node.isElement(g.parentNode)&&!i;)a(g.parentNode).after(g),i=g.nextSibling;if(i&&i.nodeType===Node.ELEMENT_NODE&&b.node.isBlock(i)){h=[i];do{i=h[0],h=b.node.contents(i)}while(h[0]&&b.node.isBlock(h[0]));a(i).prepend(a(g))}}if(!1===e&&!d.collapsed){if(g=b.$el.find('span.fr-marker[data-type=\"false\"][data-id=\"'+f+'\"]').get(0),(i=g.previousSibling)&&i.nodeType===Node.ELEMENT_NODE&&b.node.isBlock(i)){h=[i];do{i=h[h.length-1],h=b.node.contents(i)}while(h[h.length-1]&&b.node.isBlock(h[h.length-1]));a(i).append(a(g))}g.parentNode&&[\"TD\",\"TH\"].indexOf(g.parentNode.tagName)>=0&&g.parentNode.previousSibling&&!g.previousSibling&&a(g.parentNode.previousSibling).append(g)}var k=b.$el.find('span.fr-marker[data-type=\"'+e+'\"][data-id=\"'+f+'\"]').get(0);return k&&(k.style.display=\"none\"),k}catch(l){return null}}function e(){if(!b.$wp)return null;try{var c=b.selection.ranges(0),d=c.commonAncestorContainer;if(d!=b.el&&0===b.$el.find(d).length)return null;var e=c.cloneRange(),f=c.cloneRange();e.collapse(!0);var g=a('<span class=\"fr-marker\" style=\"display: none; line-height: 0;\">'+a.FE.INVISIBLE_SPACE+\"</span>\",b.doc)[0];if(e.insertNode(g),g=b.$el.find(\"span.fr-marker\").get(0)){for(var h=g.nextSibling;h&&h.nodeType===Node.TEXT_NODE&&0===h.textContent.length;)a(h).remove(),h=b.$el.find(\"span.fr-marker\").get(0).nextSibling;return b.selection.clear(),b.selection.get().addRange(f),g}return null}catch(i){}}function f(){b.selection.isCollapsed()||b.selection.remove();var c=b.$el.find(\".fr-marker\").get(0);if(null==c&&(c=e()),null==c)return null;var d=b.node.deepestParent(c);if(d||(d=b.node.blockParent(c))&&\"LI\"!=d.tagName&&(d=null),d)if(b.node.isBlock(d)&&b.node.isEmpty(d))\"LI\"!=d.tagName||d.parentNode.firstElementChild!=d||b.node.isEmpty(d.parentNode)?a(d).replaceWith('<span class=\"fr-marker\"></span>'):a(d).append('<span class=\"fr-marker\"></span>');else if(b.cursor.isAtStart(c,d))a(d).before('<span class=\"fr-marker\"></span>'),a(c).remove();else if(b.cursor.isAtEnd(c,d))a(d).after('<span class=\"fr-marker\"></span>'),a(c).remove();else{var f=c,g=\"\",h=\"\";do{f=f.parentNode,g+=b.node.closeTagString(f),h=b.node.openTagString(f)+h}while(f!=d);a(c).replaceWith('<span id=\"fr-break\"></span>');var i=b.node.openTagString(d)+a(d).html()+b.node.closeTagString(d);i=i.replace(/<span id=\"fr-break\"><\\/span>/g,g+'<span class=\"fr-marker\"></span>'+h),a(d).replaceWith(i)}return b.$el.find(\".fr-marker\").get(0)}function g(a){var c=a.clientX,d=a.clientY;h();var f,g=null;if(void 0!==b.doc.caretPositionFromPoint?(f=b.doc.caretPositionFromPoint(c,d),g=b.doc.createRange(),g.setStart(f.offsetNode,f.offset),g.setEnd(f.offsetNode,f.offset)):void 0!==b.doc.caretRangeFromPoint&&(f=b.doc.caretRangeFromPoint(c,d),g=b.doc.createRange(),g.setStart(f.startContainer,f.startOffset),g.setEnd(f.startContainer,f.startOffset)),null!==g&&void 0!==b.win.getSelection){var i=b.win.getSelection();i.removeAllRanges(),i.addRange(g)}else if(void 0!==b.doc.body.createTextRange)try{g=b.doc.body.createTextRange(),g.moveToPoint(c,d);var j=g.duplicate();j.moveToPoint(c,d),g.setEndPoint(\"EndToEnd\",j),g.select()}catch(k){return!1}e()}function h(){b.$el.find(\".fr-marker\").remove()}return{place:d,insert:e,split:f,insertAtPoint:g,remove:h}},a.FE.MODULES.selection=function(b){function c(){var a=\"\";return b.win.getSelection?a=b.win.getSelection():b.doc.getSelection?a=b.doc.getSelection():b.doc.selection&&(a=b.doc.selection.createRange().text),a.toString()}function d(){return b.win.getSelection?b.win.getSelection():b.doc.getSelection?b.doc.getSelection():b.doc.selection.createRange()}function e(a){var c=d(),e=[];if(c&&c.getRangeAt&&c.rangeCount){e=[];for(var f=0;f<c.rangeCount;f++)e.push(c.getRangeAt(f))}else e=b.doc.createRange?[b.doc.createRange()]:[];return void 0!==a?e[a]:e}function f(){var a=d();try{a.removeAllRanges?a.removeAllRanges():a.empty?a.empty():a.clear&&a.clear()}catch(b){}}function g(){var f=d();try{if(f.rangeCount){var g,h=e(0),i=h.startContainer;if(i.nodeType==Node.TEXT_NODE&&h.startOffset==(i.textContent||\"\").length&&i.nextSibling&&(i=i.nextSibling),i.nodeType==Node.ELEMENT_NODE){var j=!1;if(i.childNodes.length>0&&i.childNodes[h.startOffset]){for(g=i.childNodes[h.startOffset];g&&g.nodeType==Node.TEXT_NODE&&0===g.textContent.length;)g=g.nextSibling;if(g&&g.textContent.replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&(i=g,j=!0),!j&&i.childNodes.length>1&&h.startOffset>0&&i.childNodes[h.startOffset-1]){for(g=i.childNodes[h.startOffset-1];g&&g.nodeType==Node.TEXT_NODE&&0===g.textContent.length;)g=g.nextSibling;g&&g.textContent.replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&(i=g,j=!0)}}else!h.collapsed&&i.nextSibling&&i.nextSibling.nodeType==Node.ELEMENT_NODE&&(g=i.nextSibling)&&g.textContent.replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&(i=g,j=!0);!j&&i.childNodes.length>0&&a(i.childNodes[0]).text().replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&[\"BR\",\"IMG\",\"HR\"].indexOf(i.childNodes[0].tagName)<0&&(i=i.childNodes[0])}for(;i.nodeType!=Node.ELEMENT_NODE&&i.parentNode;)i=i.parentNode;for(var k=i;k&&\"HTML\"!=k.tagName;){if(k==b.el)return i;k=a(k).parent()[0]}}}catch(l){}return b.el}function h(){var f=d();try{if(f.rangeCount){var g,h=e(0),i=h.endContainer;if(i.nodeType==Node.ELEMENT_NODE){var j=!1;i.childNodes.length>0&&i.childNodes[h.endOffset]&&a(i.childNodes[h.endOffset]).text()===c()?(i=i.childNodes[h.endOffset],j=!0):!h.collapsed&&i.previousSibling&&i.previousSibling.nodeType==Node.ELEMENT_NODE?(g=i.previousSibling)&&g.textContent.replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&(i=g,j=!0):!h.collapsed&&i.childNodes.length>0&&i.childNodes[h.endOffset]&&(g=i.childNodes[h.endOffset].previousSibling,g.nodeType==Node.ELEMENT_NODE&&g&&g.textContent.replace(/\\u200B/g,\"\")===c().replace(/\\u200B/g,\"\")&&(i=g,j=!0)),!j&&i.childNodes.length>0&&a(i.childNodes[i.childNodes.length-1]).text()===c()&&[\"BR\",\"IMG\",\"HR\"].indexOf(i.childNodes[i.childNodes.length-1].tagName)<0&&(i=i.childNodes[i.childNodes.length-1])}for(i.nodeType==Node.TEXT_NODE&&0===h.endOffset&&i.previousSibling&&i.previousSibling.nodeType==Node.ELEMENT_NODE&&(i=i.previousSibling);i.nodeType!=Node.ELEMENT_NODE&&i.parentNode;)i=i.parentNode;for(var k=i;k&&\"HTML\"!=k.tagName;){if(k==b.el)return i;k=a(k).parent()[0]}}}catch(l){}return b.el}function i(a,b){var c=a;return c.nodeType==Node.ELEMENT_NODE&&c.childNodes.length>0&&c.childNodes[b]&&(c=c.childNodes[b]),c.nodeType==Node.TEXT_NODE&&(c=c.parentNode),c}function j(){var c,f=[],g=d();if(u()&&g.rangeCount){var h=e();for(c=0;c<h.length;c++){var j,k=h[c],l=i(k.startContainer,k.startOffset),m=i(k.endContainer,k.endOffset);b.node.isBlock(l)&&f.indexOf(l)<0&&f.push(l),j=b.node.blockParent(l),j&&f.indexOf(j)<0&&f.push(j);for(var n=[],o=l;o!==m&&o!==b.el;)n.indexOf(o)<0&&o.children&&o.children.length?(n.push(o),o=o.children[0]):o.nextSibling?o=o.nextSibling:o.parentNode&&(o=o.parentNode,n.push(o)),b.node.isBlock(o)&&n.indexOf(o)<0&&f.indexOf(o)<0&&(o!==m||k.endOffset>0)&&f.push(o);b.node.isBlock(m)&&f.indexOf(m)<0&&k.endOffset>0&&f.push(m),j=b.node.blockParent(m),j&&f.indexOf(j)<0&&f.push(j)}}for(c=f.length-1;c>0;c--)a(f[c]).find(f).length&&(\"LI\"!=f[c].tagName||f[c].children.length>0&&f.indexOf(f[c].children[0])>=0)&&f.splice(c,1);return f}function k(){if(b.$wp){b.markers.remove();var c,d,f=e(),g=[];for(d=0;d<f.length;d++)if(f[d].startContainer!==b.doc||b.browser.msie){c=f[d];var h=c.collapsed,i=b.markers.place(c,!0,d),j=b.markers.place(c,!1,d);void 0!==i&&i||!h||(a(\".fr-marker\").remove(),b.selection.setAtEnd(b.el)),b.el.normalize(),b.browser.safari&&!h&&(c=b.doc.createRange(),c.setStartAfter(i),c.setEndBefore(j),g.push(c))}if(b.browser.safari&&g.length)for(b.selection.clear(),d=0;d<g.length;d++)b.selection.get().addRange(g[d])}}function l(){var c,e=b.el.querySelectorAll('.fr-marker[data-type=\"true\"]');if(!b.$wp)return b.markers.remove(),!1;if(0===e.length)return!1;if(b.browser.msie||b.browser.edge)for(c=0;c<e.length;c++)e[c].style.display=\"inline-block\";b.core.hasFocus()||b.browser.msie||b.browser.webkit||b.$el.focus(),f();var g=d();for(c=0;c<e.length;c++){var h=a(e[c]).data(\"id\"),i=e[c],j=b.doc.createRange(),k=b.$el.find('.fr-marker[data-type=\"false\"][data-id=\"'+h+'\"]');(b.browser.msie||b.browser.edge)&&k.css(\"display\",\"inline-block\");var l=null;if(k.length>0){k=k[0];try{for(var n,o=!1,p=i.nextSibling;p&&p.nodeType==Node.TEXT_NODE&&0===p.textContent.length;)n=p,p=p.nextSibling,a(n).remove();for(var q=k.nextSibling;q&&q.nodeType==Node.TEXT_NODE&&0===q.textContent.length;)n=q,q=q.nextSibling,a(n).remove();if(i.nextSibling==k||k.nextSibling==i){for(var r=i.nextSibling==k?i:k,s=r==i?k:i,t=r.previousSibling;t&&t.nodeType==Node.TEXT_NODE&&0===t.length;)n=t,t=t.previousSibling,a(n).remove();if(t&&t.nodeType==Node.TEXT_NODE)for(;t&&t.previousSibling&&t.previousSibling.nodeType==Node.TEXT_NODE;)t.previousSibling.textContent=t.previousSibling.textContent+t.textContent,t=t.previousSibling,a(t.nextSibling).remove();for(var u=s.nextSibling;u&&u.nodeType==Node.TEXT_NODE&&0===u.length;)n=u,u=u.nextSibling,a(n).remove();if(u&&u.nodeType==Node.TEXT_NODE)for(;u&&u.nextSibling&&u.nextSibling.nodeType==Node.TEXT_NODE;)u.nextSibling.textContent=u.textContent+u.nextSibling.textContent,u=u.nextSibling,a(u.previousSibling).remove();if(t&&(b.node.isVoid(t)||b.node.isBlock(t))&&(t=null),u&&(b.node.isVoid(u)||b.node.isBlock(u))&&(u=null),t&&u&&t.nodeType==Node.TEXT_NODE&&u.nodeType==Node.TEXT_NODE){\na(i).remove(),a(k).remove();var v=t.textContent.length;t.textContent=t.textContent+u.textContent,a(u).remove(),b.spaces.normalize(t),j.setStart(t,v),j.setEnd(t,v),o=!0}else!t&&u&&u.nodeType==Node.TEXT_NODE?(a(i).remove(),a(k).remove(),b.spaces.normalize(u),l=a(b.doc.createTextNode(\"\\u200b\")),a(u).before(l),j.setStart(u,0),j.setEnd(u,0),o=!0):!u&&t&&t.nodeType==Node.TEXT_NODE&&(a(i).remove(),a(k).remove(),b.spaces.normalize(t),l=a(b.doc.createTextNode(\"\\u200b\")),a(t).after(l),j.setStart(t,t.textContent.length),j.setEnd(t,t.textContent.length),o=!0)}if(!o){var w,x;(b.browser.chrome||b.browser.edge)&&i.nextSibling==k?(w=m(k,j,!0)||j.setStartAfter(k),x=m(i,j,!1)||j.setEndBefore(i)):(i.previousSibling==k&&(i=k,k=i.nextSibling),k.nextSibling&&\"BR\"===k.nextSibling.tagName||!k.nextSibling&&b.node.isBlock(i.previousSibling)||i.previousSibling&&\"BR\"==i.previousSibling.tagName||(i.style.display=\"inline\",k.style.display=\"inline\",l=a(b.doc.createTextNode(\"\\u200b\"))),w=m(i,j,!0)||a(i).before(l)&&j.setStartBefore(i),x=m(k,j,!1)||a(k).after(l)&&j.setEndAfter(k)),\"function\"==typeof w&&w(),\"function\"==typeof x&&x()}}catch(y){}}l&&l.remove();try{g.addRange(j)}catch(y){}}b.markers.remove()}function m(c,d,e){var f,g=c.previousSibling,h=c.nextSibling;return g&&h&&g.nodeType==Node.TEXT_NODE&&h.nodeType==Node.TEXT_NODE?(f=g.textContent.length,e?(h.textContent=g.textContent+h.textContent,a(g).remove(),a(c).remove(),b.spaces.normalize(h),function(){d.setStart(h,f)}):(g.textContent=g.textContent+h.textContent,a(h).remove(),a(c).remove(),b.spaces.normalize(g),function(){d.setEnd(g,f)})):g&&!h&&g.nodeType==Node.TEXT_NODE?(f=g.textContent.length,e?(b.spaces.normalize(g),function(){d.setStart(g,f)}):(b.spaces.normalize(g),function(){d.setEnd(g,f)})):!(!h||g||h.nodeType!=Node.TEXT_NODE)&&(e?(b.spaces.normalize(h),function(){d.setStart(h,0)}):(b.spaces.normalize(h),function(){d.setEnd(h,0)}))}function n(){return!0}function o(){for(var a=e(),b=0;b<a.length;b++)if(!a[b].collapsed)return!1;return!0}function p(a){var c,d,e=!1,f=!1;if(b.win.getSelection){var g=b.win.getSelection();g.rangeCount&&(c=g.getRangeAt(0),d=c.cloneRange(),d.selectNodeContents(a),d.setEnd(c.startContainer,c.startOffset),e=\"\"===d.toString(),d.selectNodeContents(a),d.setStart(c.endContainer,c.endOffset),f=\"\"===d.toString())}else b.doc.selection&&\"Control\"!=b.doc.selection.type&&(c=b.doc.selection.createRange(),d=c.duplicate(),d.moveToElementText(a),d.setEndPoint(\"EndToStart\",c),e=\"\"===d.text,d.moveToElementText(a),d.setEndPoint(\"StartToEnd\",c),f=\"\"===d.text);return{atStart:e,atEnd:f}}function q(){if(o())return!1;b.$el.find(\"td, th, img, br:not(:last)\").prepend('<span class=\"fr-mk\">'+a.FE.INVISIBLE_SPACE+\"</span>\");var c=!1,d=p(b.el);return d.atStart&&d.atEnd&&(c=!0),b.$el.find(\".fr-mk\").remove(),c}function r(c,d){void 0===d&&(d=!0);var e=a(c).html();e&&e.replace(/\\u200b/g,\"\").length!=e.length&&a(c).html(e.replace(/\\u200b/g,\"\"));for(var f=b.node.contents(c),g=0;g<f.length;g++)f[g].nodeType!=Node.ELEMENT_NODE?a(f[g]).remove():(r(f[g],0===g),0===g&&(d=!1));c.nodeType==Node.TEXT_NODE?a(c).replaceWith('<span data-first=\"true\" data-text=\"true\"></span>'):d&&a(c).attr(\"data-first\",!0)}function s(){return 0===a(this).find(\"fr-inner\").length}function t(c,d){var e=b.node.contents(c.get(0));[\"TD\",\"TH\"].indexOf(c.get(0).tagName)>=0&&1==c.find(\".fr-marker\").length&&b.node.hasClass(e[0],\"fr-marker\")&&c.attr(\"data-del-cell\",!0);for(var f=0;f<e.length;f++){var g=e[f];b.node.hasClass(g,\"fr-marker\")?d=(d+1)%2:d?a(g).find(\".fr-marker\").length>0?d=t(a(g),d):[\"TD\",\"TH\"].indexOf(g.tagName)<0&&!b.node.hasClass(g,\"fr-inner\")?!b.opts.keepFormatOnDelete||b.$el.find(\"[data-first]\").length>0?a(g).remove():r(g):b.node.hasClass(g,\"fr-inner\")?0===a(g).find(\".fr-inner\").length?a(g).html(\"<br>\"):a(g).find(\".fr-inner\").filter(s).html(\"<br>\"):(a(g).empty(),a(g).attr(\"data-del-cell\",!0)):a(g).find(\".fr-marker\").length>0&&(d=t(a(g),d))}return d}function u(){try{if(!b.$wp)return!1;for(var a=e(0),c=a.commonAncestorContainer;c&&!b.node.isElement(c);)c=c.parentNode;return!!b.node.isElement(c)}catch(d){return!1}}function v(){if(o())return!0;var c;k();var d=function(b){for(var c=b.previousSibling;c&&c.nodeType==Node.TEXT_NODE&&0===c.textContent.length;){var d=c;c=c.previousSibling,a(d).remove()}return c},e=function(b){for(var c=b.nextSibling;c&&c.nodeType==Node.TEXT_NODE&&0===c.textContent.length;){var d=c;c=c.nextSibling,a(d).remove()}return c},f=b.$el.find('.fr-marker[data-type=\"true\"]');for(c=0;c<f.length;c++)for(var g=f[c];!(d(g)||b.node.isBlock(g.parentNode)||b.$el.is(g.parentNode)||b.node.hasClass(g.parentNode,\"fr-inner\"));)a(g.parentNode).before(g);var h=b.$el.find('.fr-marker[data-type=\"false\"]');for(c=0;c<h.length;c++){for(var i=h[c];!(e(i)||b.node.isBlock(i.parentNode)||b.$el.is(i.parentNode)||b.node.hasClass(i.parentNode,\"fr-inner\"));)a(i.parentNode).after(i);i.parentNode&&b.node.isBlock(i.parentNode)&&b.node.isEmpty(i.parentNode)&&!b.$el.is(i.parentNode)&&!b.node.hasClass(i.parentNode,\"fr-inner\")&&b.opts.keepFormatOnDelete&&a(i.parentNode).after(i)}if(n()){t(b.$el,0);var j=b.$el.find('[data-first=\"true\"]');if(j.length)b.$el.find(\".fr-marker\").remove(),j.append(a.FE.INVISIBLE_SPACE+a.FE.MARKERS).removeAttr(\"data-first\"),j.attr(\"data-text\")&&j.replaceWith(j.html());else for(b.$el.find(\"table\").filter(function(){return a(this).find(\"[data-del-cell]\").length>0&&a(this).find(\"[data-del-cell]\").length==a(this).find(\"td, th\").length}).remove(),b.$el.find(\"[data-del-cell]\").removeAttr(\"data-del-cell\"),f=b.$el.find('.fr-marker[data-type=\"true\"]'),c=0;c<f.length;c++){var m=f[c],p=m.nextSibling,q=b.$el.find('.fr-marker[data-type=\"false\"][data-id=\"'+a(m).data(\"id\")+'\"]').get(0);if(q){if(m&&(!p||p!=q)){var r=b.node.blockParent(m),s=b.node.blockParent(q),u=!1,v=!1;if(r&&[\"UL\",\"OL\"].indexOf(r.tagName)>=0&&(r=null,u=!0),s&&[\"UL\",\"OL\"].indexOf(s.tagName)>=0&&(s=null,v=!0),a(m).after(q),r!=s)if(null!=r||u)if(null!=s||v||0!==a(r).parentsUntil(b.$el,\"table\").length)r&&s&&0===a(r).parentsUntil(b.$el,\"table\").length&&0===a(s).parentsUntil(b.$el,\"table\").length&&0===a(r).find(s).length&&0===a(s).find(r).length&&(a(r).append(a(s).html()),a(s).remove());else{for(p=r;!p.nextSibling&&p.parentNode!=b.el;)p=p.parentNode;for(p=p.nextSibling;p&&\"BR\"!=p.tagName;){var w=p.nextSibling;a(r).append(p),p=w}p&&\"BR\"==p.tagName&&a(p).remove()}else{var x=b.node.deepestParent(m);x?(a(x).after(a(s).html()),a(s).remove()):0===a(s).parentsUntil(b.$el,\"table\").length&&(a(m).next().after(a(s).html()),a(s).remove())}}}else q=a(m).clone().attr(\"data-type\",!1),a(m).after(q)}}b.opts.keepFormatOnDelete||b.html.fillEmptyBlocks(),b.html.cleanEmptyTags(!0),b.clean.lists(),b.opts.htmlUntouched||b.spaces.normalize();var y=b.$el.find(\".fr-marker:last\").get(0),z=b.$el.find(\".fr-marker:first\").get(0);void 0!==y&&void 0!==z&&!y.nextSibling&&z.previousSibling&&\"BR\"==z.previousSibling.tagName&&b.node.isElement(y.parentNode)&&b.node.isElement(z.parentNode)&&b.$el.append(\"<br>\"),l()}function w(c,d){if(!c||c.getElementsByClassName(\"fr-marker\").length>0)return!1;for(var e=c.firstChild;e&&(b.node.isBlock(e)||d&&!b.node.isVoid(e)&&e.nodeType==Node.ELEMENT_NODE);)c=e,e=e.firstChild;c.innerHTML=a.FE.MARKERS+c.innerHTML}function x(c,d){if(!c||c.getElementsByClassName(\"fr-marker\").length>0)return!1;for(var e=c.lastChild;e&&(b.node.isBlock(e)||d&&!b.node.isVoid(e)&&e.nodeType==Node.ELEMENT_NODE);)c=e,e=e.lastChild;var f=b.doc.createElement(\"SPAN\");f.setAttribute(\"id\",\"fr-sel-markers\"),f.innerHTML=a.FE.MARKERS,c.appendChild(f);var g=c.querySelector(\"#fr-sel-markers\");g.outerHTML=g.innerHTML}function y(c,d){void 0===d&&(d=!0);for(var e=c.previousSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.previousSibling;return e?(b.node.isBlock(e)?x(e):\"BR\"==e.tagName?a(e).before(a.FE.MARKERS):a(e).after(a.FE.MARKERS),!0):!!d&&(b.node.isBlock(c)?w(c):a(c).before(a.FE.MARKERS),!0)}function z(c,d){void 0===d&&(d=!0);for(var e=c.nextSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.nextSibling;return e?(b.node.isBlock(e)?w(e):a(e).before(a.FE.MARKERS),!0):!!d&&(b.node.isBlock(c)?x(c):a(c).after(a.FE.MARKERS),!0)}return{text:c,get:d,ranges:e,clear:f,element:g,endElement:h,save:k,restore:l,isCollapsed:o,isFull:q,inEditor:u,remove:v,blocks:j,info:p,setAtEnd:x,setAtStart:w,setBefore:y,setAfter:z,rangeElement:i}},a.extend(a.FE.DEFAULTS,{htmlAllowedTags:[\"a\",\"abbr\",\"address\",\"area\",\"article\",\"aside\",\"audio\",\"b\",\"base\",\"bdi\",\"bdo\",\"blockquote\",\"br\",\"button\",\"canvas\",\"caption\",\"cite\",\"code\",\"col\",\"colgroup\",\"datalist\",\"dd\",\"del\",\"details\",\"dfn\",\"dialog\",\"div\",\"dl\",\"dt\",\"em\",\"embed\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"header\",\"hgroup\",\"hr\",\"i\",\"iframe\",\"img\",\"input\",\"ins\",\"kbd\",\"keygen\",\"label\",\"legend\",\"li\",\"link\",\"main\",\"map\",\"mark\",\"menu\",\"menuitem\",\"meter\",\"nav\",\"noscript\",\"object\",\"ol\",\"optgroup\",\"option\",\"output\",\"p\",\"param\",\"pre\",\"progress\",\"queue\",\"rp\",\"rt\",\"ruby\",\"s\",\"samp\",\"script\",\"style\",\"section\",\"select\",\"small\",\"source\",\"span\",\"strike\",\"strong\",\"sub\",\"summary\",\"sup\",\"table\",\"tbody\",\"td\",\"textarea\",\"tfoot\",\"th\",\"thead\",\"time\",\"tr\",\"track\",\"u\",\"ul\",\"var\",\"video\",\"wbr\"],htmlRemoveTags:[\"script\",\"style\"],htmlAllowedAttrs:[\"accept\",\"accept-charset\",\"accesskey\",\"action\",\"align\",\"allowfullscreen\",\"allowtransparency\",\"alt\",\"async\",\"autocomplete\",\"autofocus\",\"autoplay\",\"autosave\",\"background\",\"bgcolor\",\"border\",\"charset\",\"cellpadding\",\"cellspacing\",\"checked\",\"cite\",\"class\",\"color\",\"cols\",\"colspan\",\"content\",\"contenteditable\",\"contextmenu\",\"controls\",\"coords\",\"data\",\"data-.*\",\"datetime\",\"default\",\"defer\",\"dir\",\"dirname\",\"disabled\",\"download\",\"draggable\",\"dropzone\",\"enctype\",\"for\",\"form\",\"formaction\",\"frameborder\",\"headers\",\"height\",\"hidden\",\"high\",\"href\",\"hreflang\",\"http-equiv\",\"icon\",\"id\",\"ismap\",\"itemprop\",\"keytype\",\"kind\",\"label\",\"lang\",\"language\",\"list\",\"loop\",\"low\",\"max\",\"maxlength\",\"media\",\"method\",\"min\",\"mozallowfullscreen\",\"multiple\",\"muted\",\"name\",\"novalidate\",\"open\",\"optimum\",\"pattern\",\"ping\",\"placeholder\",\"playsinline\",\"poster\",\"preload\",\"pubdate\",\"radiogroup\",\"readonly\",\"rel\",\"required\",\"reversed\",\"rows\",\"rowspan\",\"sandbox\",\"scope\",\"scoped\",\"scrolling\",\"seamless\",\"selected\",\"shape\",\"size\",\"sizes\",\"span\",\"src\",\"srcdoc\",\"srclang\",\"srcset\",\"start\",\"step\",\"summary\",\"spellcheck\",\"style\",\"tabindex\",\"target\",\"title\",\"type\",\"translate\",\"usemap\",\"value\",\"valign\",\"webkitallowfullscreen\",\"width\",\"wrap\"],htmlAllowedStyleProps:[\".*\"],htmlAllowComments:!0,htmlUntouched:!1,fullPage:!1}),a.FE.HTML5Map={B:\"STRONG\",I:\"EM\",STRIKE:\"S\"},a.FE.MODULES.clean=function(b){function c(a){if(a.nodeType==Node.ELEMENT_NODE&&a.getAttribute(\"class\")&&a.getAttribute(\"class\").indexOf(\"fr-marker\")>=0)return!1;var d,e=b.node.contents(a),f=[];for(d=0;d<e.length;d++)e[d].nodeType!=Node.ELEMENT_NODE||b.node.isVoid(e[d])?e[d].nodeType==Node.TEXT_NODE&&(e[d].textContent=e[d].textContent.replace(/\\u200b/g,\"\")):e[d].textContent.replace(/\\u200b/g,\"\").length!=e[d].textContent.length&&c(e[d]);if(a.nodeType==Node.ELEMENT_NODE&&!b.node.isVoid(a)&&(a.normalize(),e=b.node.contents(a),f=a.querySelectorAll(\".fr-marker\"),e.length-f.length==0)){for(d=0;d<e.length;d++)if((e[d].getAttribute(\"class\")||\"\").indexOf(\"fr-marker\")<0)return!1;for(d=0;d<f.length;d++)a.parentNode.insertBefore(f[d].cloneNode(!0),a);return a.parentNode.removeChild(a),!1}}function d(a,c){if(a.nodeType==Node.COMMENT_NODE)return\"\\x3c!--\"+a.nodeValue+\"--\\x3e\";if(a.nodeType==Node.TEXT_NODE)return c?a.textContent.replace(/\\&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\"):a.textContent.replace(/\\&/g,\"&amp;\").replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\").replace(/\\u00A0/g,\"&nbsp;\").replace(/\\u0009/g,\"\");if(a.nodeType!=Node.ELEMENT_NODE)return a.outerHTML;if(a.nodeType==Node.ELEMENT_NODE&&[\"STYLE\",\"SCRIPT\",\"NOSCRIPT\"].indexOf(a.tagName)>=0)return a.outerHTML;if(a.nodeType==Node.ELEMENT_NODE&&\"svg\"==a.tagName){var e=document.createElement(\"div\"),f=a.cloneNode(!0);return e.appendChild(f),e.innerHTML}if(\"IFRAME\"==a.tagName)return a.outerHTML.replace(/\\&lt;/g,\"<\").replace(/\\&gt;/g,\">\");var g=a.childNodes;if(0===g.length)return a.outerHTML;for(var h=\"\",i=0;i<g.length;i++)\"PRE\"==a.tagName&&(c=!0),h+=d(g[i],c);return b.node.openTagString(a)+h+b.node.closeTagString(a)}function e(a){return I=[],a=a.replace(/<script\\b[^<]*(?:(?!<\\/script>)<[^<]*)*<\\/script>/gi,function(a){return I.push(a),\"[FROALA.EDITOR.SCRIPT \"+(I.length-1)+\"]\"}),a=a.replace(/<noscript\\b[^<]*(?:(?!<\\/noscript>)<[^<]*)*<\\/noscript>/gi,function(a){return I.push(a),\"[FROALA.EDITOR.NOSCRIPT \"+(I.length-1)+\"]\"}),a=a.replace(/<img((?:[\\w\\W]*?)) src=\"/g,'<img$1 data-fr-src=\"')}function f(a){return a=a.replace(/\\[FROALA\\.EDITOR\\.SCRIPT ([\\d]*)\\]/gi,function(a,c){return b.opts.htmlRemoveTags.indexOf(\"script\")>=0?\"\":I[parseInt(c,10)]}),a=a.replace(/\\[FROALA\\.EDITOR\\.NOSCRIPT ([\\d]*)\\]/gi,function(a,c){return b.opts.htmlRemoveTags.indexOf(\"noscript\")>=0?\"\":I[parseInt(c,10)].replace(/\\&lt;/g,\"<\").replace(/\\&gt;/g,\">\")}),a=a.replace(/<img((?:[\\w\\W]*?)) data-fr-src=\"/g,'<img$1 src=\"')}function g(a){var b=a.replace(/;;/gi,\";\");return b=b.replace(/^;/gi,\"\"),\";\"!=b.charAt(b.length)&&(b+=\";\"),b}function h(a){var c;for(c in a)if(a.hasOwnProperty(c)){var d=c.match(G),e=null;\"style\"==c&&b.opts.htmlAllowedStyleProps.length&&(e=a[c].match(H)),d&&e?a[c]=g(e.join(\";\")):d&&(\"style\"!=c||e)||delete a[c]}for(var f=\"\",h=Object.keys(a).sort(),i=0;i<h.length;i++)c=h[i],a[c].indexOf('\"')<0?f+=\" \"+c+'=\"'+a[c]+'\"':f+=\" \"+c+\"='\"+a[c]+\"'\";return f}function i(a,c,d){if(b.opts.fullPage){var e=b.html.extractDoctype(d),f=h(b.html.extractNodeAttrs(d,\"html\"));c=null==c?b.html.extractNode(d,\"head\")||\"<title></title>\":c;return e+\"<html\"+f+\"><head\"+h(b.html.extractNodeAttrs(d,\"head\"))+\">\"+c+\"</head><body\"+h(b.html.extractNodeAttrs(d,\"body\"))+\">\"+a+\"</body></html>\"}return a}function j(c,e){var f,g=a(\"<div>\"+c+\"</div>\"),h=\"\";if(g){var i=b.node.contents(g.get(0));for(f=0;f<i.length;f++)e(i[f]);for(i=b.node.contents(g.get(0)),f=0;f<i.length;f++)h+=d(i[f])}return h}function k(a,c,d){a=e(a);var g=a,h=null;return b.opts.fullPage&&(g=b.html.extractNode(a,\"body\")||(a.indexOf(\"<body\")>=0?\"\":a),d&&(h=b.html.extractNode(a,\"head\")||\"\")),g=j(g,c),h&&(h=j(h,c)),f(i(g,h,a))}function l(a){return a.replace(/\\u200b/g,\"\").length==a.length?a:b.clean.exec(a,c)}function m(){var c=b.el.querySelectorAll(Object.keys(a.FE.HTML5Map).join(\",\"));if(c.length){var d=!1;b.el.querySelector(\".fr-marker\")||(b.selection.save(),d=!0);for(var e=0;e<c.length;e++)\"\"===b.node.attributes(c[e])&&a(c[e]).replaceWith(\"<\"+a.FE.HTML5Map[c[e].tagName]+\">\"+c[e].innerHTML+\"</\"+a.FE.HTML5Map[c[e].tagName]+\">\");d&&b.selection.restore()}}function n(a){var c=b.doc.createElement(\"DIV\");return c.innerText=a,c.textContent}function o(c){if(\"SPAN\"==c.tagName&&(c.getAttribute(\"class\")||\"\").indexOf(\"fr-marker\")>=0)return!1;if(\"PRE\"==c.tagName&&q(c),c.nodeType==Node.ELEMENT_NODE&&(c.getAttribute(\"data-fr-src\")&&0!==c.getAttribute(\"data-fr-src\").indexOf(\"blob:\")&&c.setAttribute(\"data-fr-src\",b.helpers.sanitizeURL(n(c.getAttribute(\"data-fr-src\")))),c.getAttribute(\"href\")&&c.setAttribute(\"href\",b.helpers.sanitizeURL(n(c.getAttribute(\"href\")))),c.getAttribute(\"src\")&&c.setAttribute(\"src\",b.helpers.sanitizeURL(n(c.getAttribute(\"src\")))),[\"TABLE\",\"TBODY\",\"TFOOT\",\"TR\"].indexOf(c.tagName)>=0&&(c.innerHTML=c.innerHTML.trim())),!b.opts.pasteAllowLocalImages&&c.nodeType==Node.ELEMENT_NODE&&\"IMG\"==c.tagName&&c.getAttribute(\"data-fr-src\")&&0===c.getAttribute(\"data-fr-src\").indexOf(\"file://\"))return c.parentNode.removeChild(c),!1;if(c.nodeType==Node.ELEMENT_NODE&&a.FE.HTML5Map[c.tagName]&&\"\"===b.node.attributes(c)){var d=a.FE.HTML5Map[c.tagName],e=\"<\"+d+\">\"+c.innerHTML+\"</\"+d+\">\";c.insertAdjacentHTML(\"beforebegin\",e),c=c.previousSibling,c.parentNode.removeChild(c.nextSibling)}if(b.opts.htmlAllowComments||c.nodeType!=Node.COMMENT_NODE)if(c.tagName&&c.tagName.match(F))c.parentNode.removeChild(c);else if(c.tagName&&!c.tagName.match(E))\"svg\"===c.tagName?c.parentNode.removeChild(c):b.browser.safari&&\"path\"==c.tagName&&c.parentNode&&\"svg\"==c.parentNode.tagName||(c.outerHTML=c.innerHTML);else{var f=c.attributes;if(f)for(var h=f.length-1;h>=0;h--){var i=f[h],j=i.nodeName.match(G),k=null;\"style\"==i.nodeName&&b.opts.htmlAllowedStyleProps.length&&(k=i.value.match(H)),j&&k?i.value=g(k.join(\";\")):j&&(\"style\"!=i.nodeName||k)||c.removeAttribute(i.nodeName)}}else 0!==c.data.indexOf(\"[FROALA.EDITOR\")&&c.parentNode.removeChild(c)}function p(a){for(var c=b.node.contents(a),d=0;d<c.length;d++)c[d].nodeType!=Node.TEXT_NODE&&p(c[d]);o(a)}function q(a){var b=a.innerHTML;b.indexOf(\"\\n\")>=0&&(a.innerHTML=b.replace(/\\n/g,\"<br>\"))}function r(c,d,e,f){void 0===d&&(d=[]),void 0===e&&(e=[]),void 0===f&&(f=!1),c=c.replace(/<br> */g,\"<br>\");var g,h=a.merge([],b.opts.htmlAllowedTags);for(g=0;g<d.length;g++)h.indexOf(d[g])>=0&&h.splice(h.indexOf(d[g]),1);var i=a.merge([],b.opts.htmlAllowedAttrs);for(g=0;g<e.length;g++)i.indexOf(e[g])>=0&&i.splice(i.indexOf(e[g]),1);return i.push(\"data-fr-.*\"),i.push(\"fr-.*\"),E=new RegExp(\"^\"+h.join(\"$|^\")+\"$\",\"gi\"),G=new RegExp(\"^\"+i.join(\"$|^\")+\"$\",\"gi\"),F=new RegExp(\"^\"+b.opts.htmlRemoveTags.join(\"$|^\")+\"$\",\"gi\"),H=b.opts.htmlAllowedStyleProps.length?new RegExp(\"((^|;|\\\\s)\"+b.opts.htmlAllowedStyleProps.join(\":.+?(?=;|$))|((^|;|\\\\s)\")+\":.+?(?=(;)|$))\",\"gi\"):null,c=k(c,p,!0)}function s(){for(var a=b.el.querySelectorAll(\"tr\"),c=0;c<a.length;c++){for(var d=a[c].children,e=!0,f=0;f<d.length;f++)if(\"TH\"!=d[f].tagName){e=!1;break}if(!1!==e&&0!==d.length){for(var g=a[c];g&&\"TABLE\"!=g.tagName&&\"THEAD\"!=g.tagName;)g=g.parentNode;var h=g;\"THEAD\"!=h.tagName&&(h=b.doc.createElement(\"THEAD\"),g.insertBefore(h,g.firstChild)),h.appendChild(a[c])}}}function t(){s()}function u(){var a=[],c=function(a){return!b.node.isList(a.parentNode)};do{if(a.length){var d=a[0],e=b.doc.createElement(\"ul\");d.parentNode.insertBefore(e,d);do{var f=d;d=d.nextSibling,e.appendChild(f)}while(d&&\"LI\"==d.tagName)}a=[];for(var g=b.el.querySelectorAll(\"li\"),h=0;h<g.length;h++)c(g[h])&&a.push(g[h])}while(a.length>0)}function v(){for(var a=b.el.querySelectorAll(\"ol + ol, ul + ul\"),c=0;c<a.length;c++){var d=a[c];if(b.node.isList(d.previousSibling)&&b.node.openTagString(d)==b.node.openTagString(d.previousSibling)){for(var e=b.node.contents(d),f=0;f<e.length;f++)d.previousSibling.appendChild(e[f]);d.parentNode.removeChild(d)}}}function w(){var a,c,d=function(a){a.querySelector(\"LI\")||(c=!0,a.parentNode.removeChild(a))};do{c=!1;var e=b.el.querySelectorAll(\"li:empty\");for(a=0;a<e.length;a++)e[a].parentNode.removeChild(e[a]);var f=b.el.querySelectorAll(\"ul, ol\");for(a=0;a<f.length;a++)d(f[a])}while(!0===c)}function x(){for(var c=b.el.querySelectorAll(\"ul > ul, ol > ol, ul > ol, ol > ul\"),d=0;d<c.length;d++){var e=c[d],f=e.previousSibling;f&&(\"LI\"==f.tagName?f.appendChild(e):a(e).wrap(\"<li></li>\"))}}function y(){for(var c=b.el.querySelectorAll(\"li > ul, li > ol\"),d=0;d<c.length;d++){var e=c[d];if(e.nextSibling){var f=e.nextSibling,g=a(\"<li>\");a(e.parentNode).after(g);do{var h=f;f=f.nextSibling,g.append(h)}while(f)}}}function z(){for(var c=b.el.querySelectorAll(\"li > ul, li > ol\"),d=0;d<c.length;d++){var e=c[d];if(b.node.isFirstSibling(e))a(e).before(\"<br/>\");else if(e.previousSibling&&\"BR\"==e.previousSibling.tagName){for(var f=e.previousSibling.previousSibling;f&&b.node.hasClass(f,\"fr-marker\");)f=f.previousSibling;f&&\"BR\"!=f.tagName&&a(e.previousSibling).remove()}}}function A(){for(var c=b.el.querySelectorAll(\"li:empty\"),d=0;d<c.length;d++)a(c[d]).remove()}function B(){for(var c=b.el.querySelectorAll(\"ul, ol\"),d=0;d<c.length;d++)for(var e=b.node.contents(c[d]),f=null,g=e.length-1;g>=0;g--)\"LI\"!=e[g].tagName?(f||(f=a(\"<li>\"),f.insertBefore(e[g])),f.prepend(e[g])):f=null}function C(){u(),v(),B(),w(),x(),y(),z(),A()}function D(){b.opts.fullPage&&a.merge(b.opts.htmlAllowedTags,[\"head\",\"title\",\"style\",\"link\",\"base\",\"body\",\"html\",\"meta\"])}var E,F,G,H,I=[];return{_init:D,html:r,toHTML5:m,tables:t,lists:C,invisibleSpaces:l,exec:k}},a.FE.MODULES.spaces=function(b){function c(c,d){var e=c.previousSibling,f=c.nextSibling,g=c.textContent,h=c.parentNode;if(!b.html.isPreformatted(h)){d&&(g=g.replace(/[\\f\\n\\r\\t\\v ]{2,}/g,\" \"),f&&\"BR\"!==f.tagName&&!b.node.isBlock(f)||!(b.node.isBlock(h)||b.node.isLink(h)||b.node.isElement(h))||(g=g.replace(/[\\f\\n\\r\\t\\v ]{1,}$/g,\"\")),e&&\"BR\"!==e.tagName&&!b.node.isBlock(e)||!(b.node.isBlock(h)||b.node.isLink(h)||b.node.isElement(h))||(g=g.replace(/^[\\f\\n\\r\\t\\v ]{1,}/g,\"\")),\" \"===g&&(e&&b.node.isVoid(e)||f&&b.node.isVoid(f))&&(g=\"\")),g=g.replace(new RegExp(a.FE.UNICODE_NBSP,\"g\"),\" \");for(var i=\"\",j=0;j<g.length;j++)32!=g.charCodeAt(j)||0!==j&&32!=i.charCodeAt(j-1)?i+=g[j]:i+=a.FE.UNICODE_NBSP;(!f||f&&b.node.isBlock(f)||f&&f.nodeType==Node.ELEMENT_NODE&&b.win.getComputedStyle(f)&&\"block\"==b.win.getComputedStyle(f).display)&&(i=i.replace(/ $/,a.FE.UNICODE_NBSP)),!e||b.node.isVoid(e)||b.node.isBlock(e)||(i=i.replace(/^\\u00A0([^ $])/,\" $1\"),1!==i.length||160!==i.charCodeAt(0)||!f||b.node.isVoid(f)||b.node.isBlock(f)||(i=\" \")),i=i.replace(/([^ \\u00A0])\\u00A0([^ \\u00A0])/g,\"$1 $2\"),c.textContent!=i&&(c.textContent=i)}}function d(a,d){if(void 0!==a&&a||(a=b.el),void 0===d&&(d=!1),!a.getAttribute||\"false\"!=a.getAttribute(\"contenteditable\"))if(a.nodeType==Node.TEXT_NODE)c(a,d);else if(a.nodeType==Node.ELEMENT_NODE)for(var e=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){for(var c=a.parentNode;c&&c!==b.el;){if(\"STYLE\"==c.tagName||\"IFRAME\"==c.tagName)return!1;if(\"PRE\"===c.tagName)return!1;c=c.parentNode}return null!=a.textContent.match(/([ \\u00A0\\f\\n\\r\\t\\v]{2,})|(^[ \\u00A0\\f\\n\\r\\t\\v]{1,})|([ \\u00A0\\f\\n\\r\\t\\v]{1,}$)/g)&&!b.node.hasClass(a.parentNode,\"fr-marker\")}),!1);e.nextNode();)c(e.currentNode,d)}function e(){for(var a=[],c=b.el.querySelectorAll(\".fr-marker\"),e=0;e<c.length;e++){var f=null,g=b.node.blockParent(c[e]);f=g||c[e];for(var h=f.nextSibling,i=f.previousSibling;h&&\"BR\"==h.tagName;)h=h.nextSibling;for(;i&&\"BR\"==i.tagName;)i=i.previousSibling;f&&a.indexOf(f)<0&&a.push(f),i&&a.indexOf(i)<0&&a.push(i),h&&a.indexOf(h)<0&&a.push(h)}for(var j=0;j<a.length;j++)d(a[j])}return{normalize:d,normalizeAroundCursor:e}},a.FE.UNICODE_NBSP=String.fromCharCode(160),a.FE.VOID_ELEMENTS=[\"area\",\"base\",\"br\",\"col\",\"embed\",\"hr\",\"img\",\"input\",\"keygen\",\"link\",\"menuitem\",\"meta\",\"param\",\"source\",\"track\",\"wbr\"],a.FE.BLOCK_TAGS=[\"address\",\"article\",\"aside\",\"audio\",\"blockquote\",\"canvas\",\"dd\",\"div\",\"dl\",\"dt\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"header\",\"hgroup\",\"hr\",\"li\",\"main\",\"nav\",\"noscript\",\"ol\",\"output\",\"p\",\"pre\",\"section\",\"table\",\"tbody\",\"td\",\"tfoot\",\"th\",\"thead\",\"tr\",\"ul\",\"video\"],a.extend(a.FE.DEFAULTS,{htmlAllowedEmptyTags:[\"textarea\",\"a\",\"iframe\",\"object\",\"video\",\"style\",\"script\",\".fa\",\".fr-emoticon\",\".fr-inner\"],htmlDoNotWrapTags:[\"script\",\"style\"],htmlSimpleAmpersand:!1,htmlIgnoreCSSProperties:[],htmlExecuteScripts:!0}),a.FE.MODULES.html=function(b){function c(){return b.opts.enter==a.FE.ENTER_P?\"p\":b.opts.enter==a.FE.ENTER_DIV?\"div\":b.opts.enter==a.FE.ENTER_BR?null:void 0}function d(a,c){return!(!a||a===b.el)&&(c?-1!=[\"PRE\",\"SCRIPT\",\"STYLE\"].indexOf(a.tagName)||d(a.parentNode,c):-1!=[\"PRE\",\"SCRIPT\",\"STYLE\"].indexOf(a.tagName))}function e(c){var d,e=[],f=[];if(c){var h=b.el.querySelectorAll(\".fr-marker\");for(d=0;d<h.length;d++){var i=b.node.blockParent(h[d])||h[d];if(i){var j=i.nextSibling,k=i.previousSibling;i&&f.indexOf(i)<0&&b.node.isBlock(i)&&f.push(i),k&&b.node.isBlock(k)&&f.indexOf(k)<0&&f.push(k),j&&b.node.isBlock(j)&&f.indexOf(j)<0&&f.push(j)}}}else f=b.el.querySelectorAll(g());var l=g();for(l+=\",\"+a.FE.VOID_ELEMENTS.join(\",\"),l+=\", .fr-inner\",l+=\",\"+b.opts.htmlAllowedEmptyTags.join(\":not(.fr-marker),\")+\":not(.fr-marker)\",d=f.length-1;d>=0;d--)if(!(f[d].textContent&&f[d].textContent.replace(/\\u200B|\\n/g,\"\").length>0||f[d].querySelectorAll(l).length>0)){for(var m=b.node.contents(f[d]),n=!1,o=0;o<m.length;o++)if(m[o].nodeType!=Node.COMMENT_NODE&&m[o].textContent&&m[o].textContent.replace(/\\u200B|\\n/g,\"\").length>0){n=!0;break}n||e.push(f[d])}return e}function f(){return a.FE.BLOCK_TAGS.join(\":empty, \")+\":empty\"}function g(){return a.FE.BLOCK_TAGS.join(\", \")}function h(c){var d=a.merge([],a.FE.VOID_ELEMENTS);d=a.merge(d,b.opts.htmlAllowedEmptyTags),void 0===c&&(d=a.merge(d,a.FE.BLOCK_TAGS));var e,f;e=b.el.querySelectorAll(\"*:empty:not(\"+d.join(\"):not(\")+\"):not(.fr-marker)\");do{f=!1;for(var g=0;g<e.length;g++)0!==e[g].attributes.length&&void 0===e[g].getAttribute(\"href\")||(e[g].parentNode.removeChild(e[g]),f=!0);e=b.el.querySelectorAll(\"*:empty:not(\"+d.join(\"):not(\")+\"):not(.fr-marker)\")}while(e.length&&f)}function i(a,d){var e=c();if(d&&(e=\"div\"),e){for(var f=b.doc.createDocumentFragment(),g=null,h=!1,i=a.firstChild,j=!1;i;){var k=i.nextSibling;if(i.nodeType==Node.ELEMENT_NODE&&(b.node.isBlock(i)||b.opts.htmlDoNotWrapTags.indexOf(i.tagName.toLowerCase())>=0&&!b.node.hasClass(i,\"fr-marker\")))g=null,f.appendChild(i.cloneNode(!0));else if(i.nodeType!=Node.ELEMENT_NODE&&i.nodeType!=Node.TEXT_NODE)g=null,f.appendChild(i.cloneNode(!0));else if(\"BR\"==i.tagName)null==g?(g=b.doc.createElement(e),j=!0,d&&g.setAttribute(\"class\",\"fr-temp-div\"),g.setAttribute(\"data-empty\",!0),g.appendChild(i.cloneNode(!0)),f.appendChild(g)):!1===h&&(g.appendChild(b.doc.createElement(\"br\")),d&&g.setAttribute(\"class\",\"fr-temp-div\"),g.setAttribute(\"data-empty\",!0)),g=null;else{var l=i.textContent;(i.nodeType!==Node.TEXT_NODE||l.replace(/\\n/g,\"\").replace(/(^ *)|( *$)/g,\"\").length>0||l.length&&l.indexOf(\"\\n\")<0)&&(null==g&&(g=b.doc.createElement(e),j=!0,d&&g.setAttribute(\"class\",\"fr-temp-div\"),f.appendChild(g),h=!1),g.appendChild(i.cloneNode(!0)),h||b.node.hasClass(i,\"fr-marker\")||i.nodeType==Node.TEXT_NODE&&0===l.replace(/ /g,\"\").length||(h=!0))}i=k}j&&(a.innerHTML=\"\",a.appendChild(f))}}function j(a,b){for(var c=0;c<a.length;c++)i(a[c],b)}function k(a,c,d,e){if(!b.$wp)return!1;void 0===a&&(a=!1),void 0===c&&(c=!1),void 0===d&&(d=!1),void 0===e&&(e=!1);var f=b.$wp.scrollTop();i(b.el,a),e&&j(b.el.querySelectorAll(\".fr-inner\"),a),c&&j(b.el.querySelectorAll(\"td, th\"),a),d&&j(b.el.querySelectorAll(\"blockquote\"),a),f!=b.$wp.scrollTop()&&b.$wp.scrollTop(f)}function l(){b.$el.find(\"div.fr-temp-div\").each(function(){a(this).attr(\"data-empty\")||[\"LI\"].indexOf(this.parentNode.tagName)>=0||b.node.isBlock(this.nextSibling)&&!a(this.nextSibling).hasClass(\"fr-temp-div\")?a(this).replaceWith(a(this).html()):a(this).replaceWith(a(this).html()+\"<br>\")}),b.$el.find(\".fr-temp-div\").removeClass(\"fr-temp-div\").filter(function(){return\"\"===a(this).attr(\"class\")}).removeAttr(\"class\")}function m(c){for(var d=e(c),f=0;f<d.length;f++){var g=d[f];\"false\"===g.getAttribute(\"contenteditable\")||g.querySelector(b.opts.htmlAllowedEmptyTags.join(\":not(.fr-marker),\")+\":not(.fr-marker)\")||b.node.isVoid(g)||\"TABLE\"!=g.tagName&&\"TBODY\"!=g.tagName&&\"TR\"!=g.tagName&&\"UL\"!=g.tagName&&\"OL\"!=g.tagName&&g.appendChild(b.doc.createElement(\"br\"))}if(b.browser.msie&&b.opts.enter==a.FE.ENTER_BR){var h=b.node.contents(b.el);h.length&&h[h.length-1].nodeType==Node.TEXT_NODE&&b.$el.append(\"<br>\")}}function n(){return b.$el.get(0).querySelectorAll(g())}function o(a){if(void 0===a&&(a=b.el),a&&[\"SCRIPT\",\"STYLE\",\"PRE\"].indexOf(a.tagName)>=0)return!1;for(var c=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){return null!=a.textContent.match(/([ \\n]{2,})|(^[ \\n]{1,})|([ \\n]{1,}$)/g)}),!1);c.nextNode();){var e=c.currentNode;if(!d(e.parentNode,!0)){var f=b.node.isBlock(e.parentNode)||b.node.isElement(e.parentNode),g=e.textContent.replace(/(?!^)( ){2,}(?!$)/g,\" \").replace(/\\n/g,\" \").replace(/^[ ]{2,}/g,\" \").replace(/[ ]{2,}$/g,\" \");if(f){var h=e.previousSibling,i=e.nextSibling;h&&i&&\" \"==g?g=b.node.isBlock(h)&&b.node.isBlock(i)?\"\":\" \":(h||(g=g.replace(/^ */,\"\")),i||(g=g.replace(/ *$/,\"\")))}e.textContent=g}}}function p(a,b,c){var d=new RegExp(b,\"gi\"),e=d.exec(a);return e?e[c]:null}function q(a,b){var c=a.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?\"?([^\"]*)\"? ?\"?([^\"]*)\"?>/i);return c?b.implementation.createDocumentType(c[1],c[3],c[4]):b.implementation.createDocumentType(\"html\")}function r(a){var b=a.doctype,c=\"<!DOCTYPE html>\";return b&&(c=\"<!DOCTYPE \"+b.name+(b.publicId?' PUBLIC \"'+b.publicId+'\"':\"\")+(!b.publicId&&b.systemId?\" SYSTEM\":\"\")+(b.systemId?' \"'+b.systemId+'\"':\"\")+\">\"),c}function s(c){var d=c.parentNode;if(d&&(b.node.isBlock(d)||b.node.isElement(d))&&[\"TD\",\"TH\"].indexOf(d.tagName)<0){for(var e=c.previousSibling,f=c.nextSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.replace(/\\n|\\r/g,\"\").length;)e=e.previousSibling;e&&d&&\"BR\"!=e.tagName&&!b.node.isBlock(e)&&!f&&d.textContent.replace(/\\u200B/g,\"\").length>0&&e.textContent.length>0&&!b.node.hasClass(e,\"fr-marker\")&&(b.el==d&&!f&&b.opts.enter==a.FE.ENTER_BR&&b.browser.msie||c.parentNode.removeChild(c))}else!d||b.node.isBlock(d)||b.node.isElement(d)||c.previousSibling||c.nextSibling||s(c.parentNode)}function t(){for(var a=b.el.getElementsByTagName(\"br\"),c=0;c<a.length;c++)s(a[c])}function u(){b.opts.htmlUntouched||(h(),k()),o(),b.opts.htmlUntouched||(b.spaces.normalize(null,!0),b.html.fillEmptyBlocks(),b.clean.lists(),b.clean.tables(),b.clean.toHTML5(),b.html.cleanBRs()),b.selection.restore(),v(),b.placeholder.refresh()}function v(){b.core.isEmpty()&&(null!=c()?b.el.querySelector(g())||b.el.querySelector(b.opts.htmlDoNotWrapTags.join(\":not(.fr-marker),\")+\":not(.fr-marker)\")||(b.core.hasFocus()?(b.$el.html(\"<\"+c()+\">\"+a.FE.MARKERS+\"<br/></\"+c()+\">\"),b.selection.restore()):b.$el.html(\"<\"+c()+\"><br/></\"+c()+\">\")):b.el.querySelector(\"*:not(.fr-marker):not(br)\")||(b.core.hasFocus()?(b.$el.html(a.FE.MARKERS+\"<br/>\"),b.selection.restore()):b.$el.html(\"<br/>\")))}function w(a,b){return p(a,\"<\"+b+\"[^>]*?>([\\\\w\\\\W]*)</\"+b+\">\",1)}function x(c,d){var e=a(\"<div \"+(p(c,\"<\"+d+\"([^>]*?)>\",1)||\"\")+\">\");return b.node.rawAttributes(e.get(0))}function y(a){return(p(a,\"<!DOCTYPE([^>]*?)>\",0)||\"<!DOCTYPE html>\").replace(/\\n/g,\" \").replace(/ {2,}/g,\" \")}function z(a,c){b.opts.htmlExecuteScripts?a.html(c):a.get(0).innerHTML=c}function A(c){var d=b.clean.html((c||\"\").trim(),[],[],b.opts.fullPage);if(b.opts.fullPage){var e=w(d,\"body\")||(d.indexOf(\"<body\")>=0?\"\":d),f=x(d,\"body\"),g=w(d,\"head\")||\"<title></title>\",h=x(d,\"head\"),i=a(\"<div>\").append(g).contents().each(function(){(this.nodeType==Node.COMMENT_NODE||[\"BASE\",\"LINK\",\"META\",\"NOSCRIPT\",\"SCRIPT\",\"STYLE\",\"TEMPLATE\",\"TITLE\"].indexOf(this.tagName)>=0)&&this.parentNode.removeChild(this)}).end().html().trim();g=a(\"<div>\").append(g).contents().map(function(){return this.nodeType==Node.COMMENT_NODE?\"\\x3c!--\"+this.nodeValue+\"--\\x3e\":[\"BASE\",\"LINK\",\"META\",\"NOSCRIPT\",\"SCRIPT\",\"STYLE\",\"TEMPLATE\",\"TITLE\"].indexOf(this.tagName)>=0?this.outerHTML:\"\"}).toArray().join(\"\");var j=y(d),k=x(d,\"html\");z(b.$el,i+\"\\n\"+e),b.node.clearAttributes(b.el),b.$el.attr(f),b.$el.addClass(\"fr-view\"),b.$el.attr(\"spellcheck\",b.opts.spellcheck),b.$el.attr(\"dir\",b.opts.direction),z(b.$head,g),b.node.clearAttributes(b.$head.get(0)),b.$head.attr(h),b.node.clearAttributes(b.$html.get(0)),b.$html.attr(k),b.iframe_document.doctype.parentNode.replaceChild(q(j,b.iframe_document),b.iframe_document.doctype)}else z(b.$el,d);var l=b.edit.isDisabled();b.edit.on(),b.core.injectStyle(b.opts.iframeStyle),u(),b.opts.useClasses||(b.$el.find(\"[fr-original-class]\").each(function(){this.setAttribute(\"class\",this.getAttribute(\"fr-original-class\")),this.removeAttribute(\"fr-original-class\")}),b.$el.find(\"[fr-original-style]\").each(function(){this.setAttribute(\"style\",this.getAttribute(\"fr-original-style\")),this.removeAttribute(\"fr-original-style\")})),l&&b.edit.off(),b.events.trigger(\"html.set\")}function B(a){var b=/(#[^\\s\\+>~\\.\\[:]+)/g,c=/(\\[[^\\]]+\\])/g,d=/(\\.[^\\s\\+>~\\.\\[:]+)/g,e=/(::[^\\s\\+>~\\.\\[:]+|:first-line|:first-letter|:before|:after)/gi,f=/(:[\\w-]+\\([^\\)]*\\))/gi,g=/(:[^\\s\\+>~\\.\\[:]+)/g,h=/([^\\s\\+>~\\.\\[:]+)/g;!function(){var b=/:not\\(([^\\)]*)\\)/g;b.test(a)&&(a=a.replace(b,\"     $1 \"))}();var i=100*(a.match(b)||[]).length+10*(a.match(c)||[]).length+10*(a.match(d)||[]).length+10*(a.match(f)||[]).length+10*(a.match(g)||[]).length+(a.match(e)||[]).length\n;return a=a.replace(/[\\*\\s\\+>~]/g,\" \"),a=a.replace(/[#\\.]/g,\" \"),i+=(a.match(h)||[]).length}function C(a){if(b.events.trigger(\"html.processGet\",[a]),a&&a.getAttribute&&\"\"===a.getAttribute(\"class\")&&a.removeAttribute(\"class\"),a&&a.getAttribute&&\"\"===a.getAttribute(\"style\")&&a.removeAttribute(\"style\"),a&&a.nodeType==Node.ELEMENT_NODE){var c,d=a.querySelectorAll('[class=\"\"],[style=\"\"]');for(c=0;c<d.length;c++){var e=d[c];\"\"===e.getAttribute(\"class\")&&e.removeAttribute(\"class\"),\"\"===e.getAttribute(\"style\")&&e.removeAttribute(\"style\")}var f=a.querySelectorAll(\"br\");for(c=0;c<f.length;c++)s(f[c])}}function D(a,b){return a[3]-b[3]}function E(a,c){if(!b.$wp)return b.$oel.clone().removeClass(\"fr-view\").removeAttr(\"contenteditable\").get(0).outerHTML;var d=\"\";b.events.trigger(\"html.beforeGet\");var e,f,g=[],h={},i=[];if(!b.opts.useClasses&&!c){var j=new RegExp(\"^\"+b.opts.htmlIgnoreCSSProperties.join(\"$|^\")+\"$\",\"gi\");for(e=0;e<b.doc.styleSheets.length;e++){var k,l=0;try{k=b.doc.styleSheets[e].cssRules,b.doc.styleSheets[e].ownerNode&&\"STYLE\"==b.doc.styleSheets[e].ownerNode.nodeType&&(l=1)}catch(y){}if(k)for(var m=0,n=k.length;m<n;m++)if(k[m].selectorText&&k[m].style.cssText.length>0){var o,p=k[m].selectorText.replace(/body |\\.fr-view /g,\"\").replace(/::/g,\":\");try{o=b.el.querySelectorAll(p)}catch(y){o=[]}for(f=0;f<o.length;f++){!o[f].getAttribute(\"fr-original-style\")&&o[f].getAttribute(\"style\")?(o[f].setAttribute(\"fr-original-style\",o[f].getAttribute(\"style\")),g.push(o[f])):o[f].getAttribute(\"fr-original-style\")||(o[f].setAttribute(\"fr-original-style\",\"\"),g.push(o[f])),h[o[f]]||(h[o[f]]={});for(var q=1e3*l+B(k[m].selectorText),s=k[m].style.cssText.split(\";\"),t=0;t<s.length;t++){var u=s[t].trim().split(\":\")[0];u.match(j)||(h[o[f]][u]||(h[o[f]][u]=0,(o[f].getAttribute(\"fr-original-style\")||\"\").indexOf(u+\":\")>=0&&(h[o[f]][u]=1e4)),q>=h[o[f]][u]&&(h[o[f]][u]=q,s[t].trim().length&&i.push([o[f],u.trim(),s[t].trim().split(\":\")[1].trim(),q])))}}}}for(i.sort(D),e=0;e<i.length;e++){var v=i[e];v[0].style[v[1]]=v[2]}for(e=0;e<g.length;e++)if(g[e].getAttribute(\"class\")&&(g[e].setAttribute(\"fr-original-class\",g[e].getAttribute(\"class\")),g[e].removeAttribute(\"class\")),(g[e].getAttribute(\"fr-original-style\")||\"\").trim().length>0){var w=g[e].getAttribute(\"fr-original-style\").split(\";\");for(f=0;f<w.length;f++)w[f].indexOf(\":\")>0&&(g[e].style[w[f].split(\":\")[0].trim()]=w[f].split(\":\")[1].trim())}}if(b.core.isEmpty()?b.opts.fullPage&&(d=r(b.iframe_document),d+=\"<html\"+b.node.attributes(b.$html.get(0))+\">\"+b.$html.find(\"head\").get(0).outerHTML+\"<body></body></html>\"):(void 0===a&&(a=!1),b.opts.fullPage?(d=r(b.iframe_document),b.$el.removeClass(\"fr-view\"),d+=\"<html\"+b.node.attributes(b.$html.get(0))+\">\"+b.$html.html()+\"</html>\",b.$el.addClass(\"fr-view\")):d=b.$el.html()),!b.opts.useClasses&&!c)for(e=0;e<g.length;e++)g[e].getAttribute(\"fr-original-class\")&&(g[e].setAttribute(\"class\",g[e].getAttribute(\"fr-original-class\")),g[e].removeAttribute(\"fr-original-class\")),g[e].getAttribute(\"fr-original-style\")?(g[e].setAttribute(\"style\",g[e].getAttribute(\"fr-original-style\")),g[e].removeAttribute(\"fr-original-style\")):g[e].removeAttribute(\"style\");b.opts.fullPage&&(d=d.replace(/<style data-fr-style=\"true\">(?:[\\w\\W]*?)<\\/style>/g,\"\"),d=d.replace(/<link([^>]*)data-fr-style=\"true\"([^>]*)>/g,\"\"),d=d.replace(/<style(?:[\\w\\W]*?)class=\"firebugResetStyles\"(?:[\\w\\W]*?)>(?:[\\w\\W]*?)<\\/style>/g,\"\"),d=d.replace(/<body((?:[\\w\\W]*?)) spellcheck=\"true\"((?:[\\w\\W]*?))>((?:[\\w\\W]*?))<\\/body>/g,\"<body$1$2>$3</body>\"),d=d.replace(/<body((?:[\\w\\W]*?)) contenteditable=\"(true|false)\"((?:[\\w\\W]*?))>((?:[\\w\\W]*?))<\\/body>/g,\"<body$1$3>$4</body>\"),d=d.replace(/<body((?:[\\w\\W]*?)) dir=\"([\\w]*)\"((?:[\\w\\W]*?))>((?:[\\w\\W]*?))<\\/body>/g,\"<body$1$3>$4</body>\"),d=d.replace(/<body((?:[\\w\\W]*?))class=\"([\\w\\W]*?)(fr-rtl|fr-ltr)([\\w\\W]*?)\"((?:[\\w\\W]*?))>((?:[\\w\\W]*?))<\\/body>/g,'<body$1class=\"$2$4\"$5>$6</body>'),d=d.replace(/<body((?:[\\w\\W]*?)) class=\"\"((?:[\\w\\W]*?))>((?:[\\w\\W]*?))<\\/body>/g,\"<body$1$2>$3</body>\")),b.opts.htmlSimpleAmpersand&&(d=d.replace(/\\&amp;/gi,\"&\")),b.events.trigger(\"html.afterGet\"),a||(d=d.replace(/<span[^>]*? class\\s*=\\s*[\"']?fr-marker[\"']?[^>]+>\\u200b<\\/span>/gi,\"\")),d=b.clean.invisibleSpaces(d),d=b.clean.exec(d,C);var x=b.events.chainTrigger(\"html.get\",d);return\"string\"==typeof x&&(d=x),d=d.replace(/<pre(?:[\\w\\W]*?)>(?:[\\w\\W]*?)<\\/pre>/g,function(a){return a.replace(/<br>/g,\"\\n\")})}function F(){var c=function(c,d){for(;d&&(d.nodeType==Node.TEXT_NODE||!b.node.isBlock(d))&&!b.node.isElement(d);)d&&d.nodeType!=Node.TEXT_NODE&&a(c).wrapInner(b.node.openTagString(d)+b.node.closeTagString(d)),d=d.parentNode;d&&c.innerHTML==d.innerHTML&&(c.innerHTML=d.outerHTML)},d=function(){var c,d=null;return b.win.getSelection?(c=b.win.getSelection())&&c.rangeCount&&(d=c.getRangeAt(0).commonAncestorContainer,d.nodeType!=Node.ELEMENT_NODE&&(d=d.parentNode)):(c=b.doc.selection)&&\"Control\"!=c.type&&(d=c.createRange().parentElement()),null!=d&&(a.inArray(b.el,a(d).parents())>=0||d==b.el)?d:null},e=\"\";if(void 0!==b.win.getSelection){b.browser.mozilla&&(b.selection.save(),b.$el.find('.fr-marker[data-type=\"false\"]').length>1&&(b.$el.find('.fr-marker[data-type=\"false\"][data-id=\"0\"]').remove(),b.$el.find('.fr-marker[data-type=\"false\"]:last').attr(\"data-id\",\"0\"),b.$el.find(\".fr-marker\").not('[data-id=\"0\"]').remove()),b.selection.restore());for(var f=b.selection.ranges(),g=0;g<f.length;g++){var h=document.createElement(\"div\");h.appendChild(f[g].cloneContents());var i=h.children;if(i.length){var j=i[i.length-1];(\"P\"==j.tagName&&b.opts.enter==a.FroalaEditor.ENTER_P||\"DIV\"==j.tagName&&b.opts.enter==a.FroalaEditor.ENTER_DIV)&&b.node.isEmpty(j)&&h.removeChild(j)}c(h,d()),a(h).find(\".fr-element\").length>0&&(h=b.el),e+=h.innerHTML}}else void 0!==b.doc.selection&&\"Text\"==b.doc.selection.type&&(e=b.doc.selection.createRange().htmlText);return e}function G(a){var c=b.doc.createElement(\"div\");return c.innerHTML=a,null!==c.querySelector(g())}function H(a){var c=b.doc.createElement(\"div\");return c.innerHTML=a,b.selection.setAtEnd(c),c.innerHTML}function I(a){return a.replace(/</gi,\"&lt;\").replace(/>/gi,\"&gt;\").replace(/\"/gi,\"&quot;\").replace(/'/gi,\"&#39;\")}function J(c){if(!b.html.defaultTag())return c;var d=b.doc.createElement(\"div\");d.innerHTML=c;for(var e=d.querySelectorAll(\":scope > \"+b.html.defaultTag()),f=e.length-1;f>=0;f--){var g=e[f];b.node.isBlock(g.previousSibling)||(g.previousSibling&&!b.node.isEmpty(g)&&a(\"<br>\").insertAfter(g.previousSibling),g.outerHTML=g.innerHTML)}return d.innerHTML}function K(c,d,e){b.selection.isCollapsed()||b.selection.remove();var f;if(f=d?c:b.clean.html(c),f=f.replace(/\\r|\\n/g,\" \"),c.indexOf('class=\"fr-marker\"')<0&&(f=H(f)),b.core.isEmpty()&&!b.opts.keepFormatOnDelete&&G(f))b.el.innerHTML=f;else{var g=b.markers.insert();if(g){b.node.isLastSibling(g)&&a(g).parent().hasClass(\"fr-deletable\")&&a(g).insertAfter(a(g).parent());var h=b.node.blockParent(g);if((G(f)||e)&&(b.node.deepestParent(g)||h&&\"LI\"==h.tagName)){if(h&&\"LI\"==h.tagName&&(f=J(f)),!(g=b.markers.split()))return!1;g.outerHTML=f}else g.outerHTML=f}else b.el.innerHTML=b.el.innerHTML+f}u(),b.keys.positionCaret(),b.events.trigger(\"html.inserted\")}function L(c){var d=null;if(void 0===c&&(d=b.selection.element()),b.opts.keepFormatOnDelete)return!1;var e=d?(d.textContent.match(/\\u200B/g)||[]).length-d.querySelectorAll(\".fr-marker\").length:0;if((b.el.textContent.match(/\\u200B/g)||[]).length-b.el.querySelectorAll(\".fr-marker\").length==e)return!1;var f,g;do{g=!1,f=b.el.querySelectorAll(\"*:not(.fr-marker)\");for(var h=0;h<f.length;h++){var i=f[h];if(d!=i){var j=i.textContent;0===i.children.length&&1===j.length&&8203==j.charCodeAt(0)&&\"TD\"!==i.tagName&&(a(i).remove(),g=!0)}}}while(g)}function M(){if(b.$wp){var a=function(){L(),b.placeholder&&setTimeout(b.placeholder.refresh,0)};b.events.on(\"mouseup\",a),b.events.on(\"keydown\",a),b.events.on(\"contentChanged\",v)}}return{defaultTag:c,isPreformatted:d,emptyBlocks:e,emptyBlockTagsQuery:f,blockTagsQuery:g,fillEmptyBlocks:m,cleanEmptyTags:h,cleanWhiteTags:L,cleanBlankSpaces:o,blocks:n,getDoctype:r,set:A,get:E,getSelected:F,insert:K,wrap:k,unwrap:l,escapeEntities:I,checkIfEmpty:v,extractNode:w,extractNodeAttrs:x,extractDoctype:y,cleanBRs:t,_init:M}},a.extend(a.FE.DEFAULTS,{height:null,heightMax:null,heightMin:null,width:null}),a.FE.MODULES.size=function(a){function b(){c(),a.opts.height&&a.$el.css(\"minHeight\",a.opts.height-a.helpers.getPX(a.$el.css(\"padding-top\"))-a.helpers.getPX(a.$el.css(\"padding-bottom\"))),a.$iframe.height(a.$el.outerHeight(!0))}function c(){a.opts.heightMin?a.$el.css(\"minHeight\",a.opts.heightMin):a.$el.css(\"minHeight\",\"\"),a.opts.heightMax?(a.$wp.css(\"maxHeight\",a.opts.heightMax),a.$wp.css(\"overflow\",\"auto\")):(a.$wp.css(\"maxHeight\",\"\"),a.$wp.css(\"overflow\",\"\")),a.opts.height?(a.$wp.height(a.opts.height),a.$wp.css(\"overflow\",\"auto\"),a.$el.css(\"minHeight\",a.opts.height-a.helpers.getPX(a.$el.css(\"padding-top\"))-a.helpers.getPX(a.$el.css(\"padding-bottom\")))):(a.$wp.css(\"height\",\"\"),a.opts.heightMin||a.$el.css(\"minHeight\",\"\"),a.opts.heightMax||a.$wp.css(\"overflow\",\"\")),a.opts.width&&a.$box.width(a.opts.width)}function d(){if(!a.$wp)return!1;c(),a.$iframe&&(a.events.on(\"keyup keydown\",function(){setTimeout(b,0)},!0),a.events.on(\"commands.after html.set init initialized paste.after\",b))}return{_init:d,syncIframe:b,refresh:c}},a.extend(a.FE.DEFAULTS,{language:null}),a.FE.LANGUAGE={},a.FE.MODULES.language=function(b){function c(a){return e&&e.translation[a]&&e.translation[a].length?e.translation[a]:a}function d(){a.FE.LANGUAGE&&(e=a.FE.LANGUAGE[b.opts.language]),e&&e.direction&&(b.opts.direction=e.direction)}var e;return{_init:d,translate:c}},a.extend(a.FE.DEFAULTS,{placeholderText:\"Type something\"}),a.FE.MODULES.placeholder=function(b){function c(){b.$placeholder||g();var c=b.opts.iframe?b.$iframe.prev().outerHeight(!0):b.$el.prev().outerHeight(!0),d=0,e=0,f=0,h=0,i=0,j=0,k=b.node.contents(b.el),l=a(b.selection.element()).css(\"text-align\");if(k.length&&k[0].nodeType==Node.ELEMENT_NODE){var m=a(k[0]);(!b.opts.toolbarInline||b.$el.prev().length>0)&&b.ready&&(d=b.helpers.getPX(m.css(\"margin-top\")),h=b.helpers.getPX(m.css(\"padding-top\")),e=b.helpers.getPX(m.css(\"margin-left\")),f=b.helpers.getPX(m.css(\"margin-right\")),i=b.helpers.getPX(m.css(\"padding-left\")),j=b.helpers.getPX(m.css(\"padding-right\"))),b.$placeholder.css(\"font-size\",m.css(\"font-size\")),b.$placeholder.css(\"line-height\",m.css(\"line-height\"))}else b.$placeholder.css(\"font-size\",b.$el.css(\"font-size\")),b.$placeholder.css(\"line-height\",b.$el.css(\"line-height\"));b.$wp.addClass(\"show-placeholder\"),b.$placeholder.css({marginTop:Math.max(b.helpers.getPX(b.$el.css(\"margin-top\")),d)+c,paddingTop:Math.max(b.helpers.getPX(b.$el.css(\"padding-top\")),h),paddingLeft:Math.max(b.helpers.getPX(b.$el.css(\"padding-left\")),i),marginLeft:Math.max(b.helpers.getPX(b.$el.css(\"margin-left\")),e),paddingRight:Math.max(b.helpers.getPX(b.$el.css(\"padding-right\")),j),marginRight:Math.max(b.helpers.getPX(b.$el.css(\"margin-right\")),f),textAlign:l}).text(b.language.translate(b.opts.placeholderText||b.$oel.attr(\"placeholder\")||\"\")),b.$placeholder.html(b.$placeholder.text().replace(/\\n/g,\"<br>\"))}function d(){b.$wp.removeClass(\"show-placeholder\")}function e(){return!b.$wp||b.node.hasClass(b.$wp.get(0),\"show-placeholder\")}function f(){if(!b.$wp)return!1;b.core.isEmpty()?c():d()}function g(){b.$placeholder=a('<span class=\"fr-placeholder\"></span>'),b.$wp.append(b.$placeholder)}function h(){if(!b.$wp)return!1;b.events.on(\"init input keydown keyup contentChanged initialized\",f)}return{_init:h,show:c,hide:d,refresh:f,isVisible:e}},a.FE.MODULES.edit=function(a){function b(){if(a.browser.mozilla)try{a.doc.execCommand(\"enableObjectResizing\",!1,\"false\"),a.doc.execCommand(\"enableInlineTableEditing\",!1,\"false\")}catch(b){}if(a.browser.msie)try{a.doc.body.addEventListener(\"mscontrolselect\",function(a){return a.preventDefault(),!1})}catch(b){}}function c(){a.$wp?(a.$el.attr(\"contenteditable\",!0),a.$el.removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1),a.$tb&&a.$tb.removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1),b()):a.$el.is(\"a\")&&a.$el.attr(\"contenteditable\",!0),g=!1}function d(){a.events.disableBlur(),a.$wp?(a.$el.attr(\"contenteditable\",!1),a.$el.addClass(\"fr-disabled\").attr(\"aria-disabled\",!0),a.$tb&&a.$tb.addClass(\"fr-disabled\").attr(\"aria-disabled\",!0)):a.$el.is(\"a\")&&a.$el.attr(\"contenteditable\",!1),a.events.enableBlur(),g=!0}function e(){return g}function f(){a.events.on(\"focus\",function(){e()?a.edit.off():a.edit.on()})}var g=!1;return{_init:f,on:c,off:d,disableDesign:b,isDisabled:e}},a.extend(a.FE.DEFAULTS,{editorClass:null,typingTimer:500,iframe:!1,requestWithCORS:!0,requestWithCredentials:!1,requestHeaders:{},useClasses:!0,spellcheck:!0,iframeStyle:'html{margin:0px;height:auto;}body{height:auto;padding:10px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:\"\";display:block;clear:both;}',iframeStyleFiles:[],direction:\"auto\",zIndex:1,tabIndex:null,disableRightClick:!1,scrollableContainer:\"body\",keepFormatOnDelete:!1,theme:null}),a.FE.MODULES.core=function(b){function c(c){if(b.opts.iframe){b.$head.find(\"style[data-fr-style], link[data-fr-style]\").remove(),b.$head.append('<style data-fr-style=\"true\">'+c+\"</style>\");for(var d=0;d<b.opts.iframeStyleFiles.length;d++){var e=a('<link data-fr-style=\"true\" rel=\"stylesheet\" href=\"'+b.opts.iframeStyleFiles[d]+'\">');e.get(0).addEventListener(\"load\",b.size.syncIframe),b.$head.append(e)}}}function d(){b.opts.iframe||b.$el.addClass(\"fr-element fr-view\")}function e(){if(b.$box.addClass(\"fr-box\"+(b.opts.editorClass?\" \"+b.opts.editorClass:\"\")),b.$wp.addClass(\"fr-wrapper\"),d(),b.opts.iframe){b.$iframe.addClass(\"fr-iframe\"),b.$el.addClass(\"fr-view\");for(var a=0;a<b.o_doc.styleSheets.length;a++){var c;try{c=b.o_doc.styleSheets[a].cssRules}catch(g){}if(c)for(var e=0,f=c.length;e<f;e++)!c[e].selectorText||0!==c[e].selectorText.indexOf(\".fr-view\")&&0!==c[e].selectorText.indexOf(\".fr-element\")||c[e].style.cssText.length>0&&(0===c[e].selectorText.indexOf(\".fr-view\")?b.opts.iframeStyle+=c[e].selectorText.replace(/\\.fr-view/g,\"body\")+\"{\"+c[e].style.cssText+\"}\":b.opts.iframeStyle+=c[e].selectorText.replace(/\\.fr-element/g,\"body\")+\"{\"+c[e].style.cssText+\"}\")}}\"auto\"!=b.opts.direction&&b.$box.removeClass(\"fr-ltr fr-rtl\").addClass(\"fr-\"+b.opts.direction),b.$el.attr(\"dir\",b.opts.direction),b.$wp.attr(\"dir\",b.opts.direction),b.opts.zIndex>1&&b.$box.css(\"z-index\",b.opts.zIndex),b.opts.theme&&b.$box.addClass(b.opts.theme+\"-theme\"),b.opts.tabIndex=b.opts.tabIndex||b.$oel.attr(\"tabIndex\"),b.opts.tabIndex&&b.$el.attr(\"tabIndex\",b.opts.tabIndex)}function f(){return b.node.isEmpty(b.el)}function g(){b.drag_support={filereader:\"undefined\"!=typeof FileReader,formdata:!!b.win.FormData,progress:\"upload\"in new XMLHttpRequest}}function h(a,c){var d=new XMLHttpRequest;d.open(c,a,!0),b.opts.requestWithCredentials&&(d.withCredentials=!0);for(var e in b.opts.requestHeaders)b.opts.requestHeaders.hasOwnProperty(e)&&d.setRequestHeader(e,b.opts.requestHeaders[e]);return d}function i(a){\"TEXTAREA\"==b.$oel.get(0).tagName&&b.$oel.val(a),b.$wp&&(\"TEXTAREA\"==b.$oel.get(0).tagName?(b.$el.html(\"\"),b.$wp.html(\"\"),b.$box.replaceWith(b.$oel),b.$oel.show()):(b.$wp.replaceWith(a),b.$el.html(\"\"),b.$box.removeClass(\"fr-view fr-ltr fr-box \"+(b.opts.editorClass||\"\")),b.opts.theme&&b.$box.addClass(b.opts.theme+\"-theme\"))),this.$wp=null,this.$el=null,this.el=null,this.$box=null}function j(){return b.browser.mozilla&&b.helpers.isMobile()?b.selection.inEditor():b.node.hasFocus(b.el)||b.$el.find(\"*:focus\").length>0}function k(a){if(!a)return!1;var c=a.data(\"instance\");return!!c&&c.id==b.id}function l(){if(a.FE.INSTANCES.push(b),g(),b.$wp){e(),b.html.set(b._original_html),b.$el.attr(\"spellcheck\",b.opts.spellcheck),b.helpers.isMobile()&&(b.$el.attr(\"autocomplete\",b.opts.spellcheck?\"on\":\"off\"),b.$el.attr(\"autocorrect\",b.opts.spellcheck?\"on\":\"off\"),b.$el.attr(\"autocapitalize\",b.opts.spellcheck?\"on\":\"off\")),b.opts.disableRightClick&&b.events.$on(b.$el,\"contextmenu\",function(a){if(2==a.button)return!1});try{b.doc.execCommand(\"styleWithCSS\",!1,!1)}catch(c){}}\"TEXTAREA\"==b.$oel.get(0).tagName&&(b.events.on(\"contentChanged\",function(){b.$oel.val(b.html.get())}),b.events.on(\"form.submit\",function(){b.$oel.val(b.html.get())}),b.events.on(\"form.reset\",function(){b.html.set(b._original_html)}),b.$oel.val(b.html.get())),b.helpers.isIOS()&&b.events.$on(b.$doc,\"selectionchange\",function(){b.$doc.get(0).hasFocus()||b.$win.get(0).focus()}),b.events.trigger(\"init\")}return{_init:l,destroy:i,isEmpty:f,getXHR:h,injectStyle:c,hasFocus:j,sameInstance:k}},a.FE.MODULES.cursorLists=function(b){function c(a){for(var b=a;\"LI\"!=b.tagName;)b=b.parentNode;return b}function d(a){for(var c=a;!b.node.isList(c);)c=c.parentNode;return c}function e(e){var f,g=c(e),h=g.nextSibling,i=g.previousSibling,j=b.html.defaultTag();if(b.node.isEmpty(g,!0)&&h){for(var k=\"\",l=\"\",m=e.parentNode;!b.node.isList(m)&&m.parentNode&&\"LI\"!==m.parentNode.tagName;)k=b.node.openTagString(m)+k,l+=b.node.closeTagString(m),m=m.parentNode;k=b.node.openTagString(m)+k,l+=b.node.closeTagString(m);var n=\"\";for(n=m.parentNode&&\"LI\"==m.parentNode.tagName?l+\"<li>\"+a.FE.MARKERS+\"<br>\"+k:j?l+\"<\"+j+\">\"+a.FE.MARKERS+\"<br></\"+j+\">\"+k:l+a.FE.MARKERS+\"<br>\"+k,a(g).html('<span id=\"fr-break\"></span>');[\"UL\",\"OL\"].indexOf(m.tagName)<0||m.parentNode&&\"LI\"===m.parentNode.tagName;)m=m.parentNode;var o=b.node.openTagString(m)+a(m).html()+b.node.closeTagString(m);o=o.replace(/<span id=\"fr-break\"><\\/span>/g,n),a(m).replaceWith(o),b.$el.find(\"li:empty\").remove()}else if(i&&h||!b.node.isEmpty(g,!0)){for(var p=\"<br>\",q=e.parentNode;q&&\"LI\"!=q.tagName;)p=b.node.openTagString(q)+p+b.node.closeTagString(q),q=q.parentNode;a(g).before(\"<li>\"+p+\"</li>\"),a(e).remove()}else if(i){f=d(g);for(var r=a.FE.MARKERS+\"<br>\",s=e.parentNode;s&&\"LI\"!=s.tagName;)r=b.node.openTagString(s)+r+b.node.closeTagString(s),s=s.parentNode;f.parentNode&&\"LI\"==f.parentNode.tagName?a(f.parentNode).after(\"<li>\"+r+\"</li>\"):j?a(f).after(\"<\"+j+\">\"+r+\"</\"+j+\">\"):a(f).after(r),a(g).remove()}else f=d(g),f.parentNode&&\"LI\"==f.parentNode.tagName?h?a(f.parentNode).before(b.node.openTagString(g)+a.FE.MARKERS+\"<br></li>\"):a(f.parentNode).after(b.node.openTagString(g)+a.FE.MARKERS+\"<br></li>\"):j?a(f).before(\"<\"+j+\">\"+a.FE.MARKERS+\"<br></\"+j+\">\"):a(f).before(a.FE.MARKERS+\"<br>\"),a(g).remove()}function f(d){for(var e=c(d),f=\"\",g=d,h=\"\",i=\"\";g!=e;){g=g.parentNode;var j=\"A\"==g.tagName&&b.cursor.isAtEnd(d,g)?\"fr-to-remove\":\"\";h=b.node.openTagString(a(g).clone().addClass(j).get(0))+h,i=b.node.closeTagString(g)+i}f=i+f+h+a.FE.MARKERS+a.FE.INVISIBLE_SPACE,a(d).replaceWith('<span id=\"fr-break\"></span>');var k=b.node.openTagString(e)+a(e).html()+b.node.closeTagString(e);k=k.replace(/<span id=\"fr-break\"><\\/span>/g,f),a(e).replaceWith(k)}function g(d){for(var e=c(d),f=a.FE.MARKERS,g=\"\",h=d,i=!1;h!=e;){h=h.parentNode;var j=\"A\"==h.tagName&&b.cursor.isAtEnd(d,h)?\"fr-to-remove\":\"\";i||h==e||b.node.isBlock(h)||(i=!0,g+=a.FE.INVISIBLE_SPACE),g=b.node.openTagString(a(h).clone().addClass(j).get(0))+g,f+=b.node.closeTagString(h)}var k=g+f;a(d).remove(),a(e).after(k)}function h(e){var f=c(e),g=f.previousSibling;if(g){g=a(g).find(b.html.blockTagsQuery()).get(-1)||g,a(e).replaceWith(a.FE.MARKERS);var h=b.node.contents(g);h.length&&\"BR\"==h[h.length-1].tagName&&a(h[h.length-1]).remove(),a(f).find(b.html.blockTagsQuery()).not(\"ol, ul, table\").each(function(){this.parentNode==f&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?\"\":\"<br>\"))});for(var i,j=b.node.contents(f)[0];j&&!b.node.isList(j);)i=j.nextSibling,a(g).append(j),j=i;for(g=f.previousSibling;j;)i=j.nextSibling,a(g).append(j),j=i;a(f).remove()}else{var k=d(f);if(a(e).replaceWith(a.FE.MARKERS),k.parentNode&&\"LI\"==k.parentNode.tagName){var l=k.previousSibling;b.node.isBlock(l)?(a(f).find(b.html.blockTagsQuery()).not(\"ol, ul, table\").each(function(){this.parentNode==f&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?\"\":\"<br>\"))}),a(l).append(a(f).html())):a(k).before(a(f).html())}else{var m=b.html.defaultTag();m&&0===a(f).find(b.html.blockTagsQuery()).length?a(k).before(\"<\"+m+\">\"+a(f).html()+\"</\"+m+\">\"):a(k).before(a(f).html())}a(f).remove(),b.html.wrap(),0===a(k).find(\"li\").length&&a(k).remove()}}function i(d){var e,f=c(d),g=f.nextSibling;if(g){e=b.node.contents(g),e.length&&\"BR\"==e[0].tagName&&a(e[0]).remove(),a(g).find(b.html.blockTagsQuery()).not(\"ol, ul, table\").each(function(){this.parentNode==g&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?\"\":\"<br>\"))});for(var h,i=d,j=b.node.contents(g)[0];j&&!b.node.isList(j);)h=j.nextSibling,a(i).after(j),i=j,j=h;for(;j;)h=j.nextSibling,a(f).append(j),j=h;a(d).replaceWith(a.FE.MARKERS),a(g).remove()}else{for(var k=f;!k.nextSibling&&k!=b.el;)k=k.parentNode;if(k==b.el)return!1;if(k=k.nextSibling,b.node.isBlock(k))a.FE.NO_DELETE_TAGS.indexOf(k.tagName)<0&&(a(d).replaceWith(a.FE.MARKERS),e=b.node.contents(f),e.length&&\"BR\"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),a(f).append(a(k).html()),a(k).remove());else for(e=b.node.contents(f),e.length&&\"BR\"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),a(d).replaceWith(a.FE.MARKERS);k&&!b.node.isBlock(k)&&\"BR\"!=k.tagName;)a(f).append(a(k)),k=k.nextSibling}}return{_startEnter:e,_middleEnter:f,_endEnter:g,_backspace:h,_del:i}},a.FE.NO_DELETE_TAGS=[\"TH\",\"TD\",\"TR\",\"TABLE\",\"FORM\"],a.FE.SIMPLE_ENTER_TAGS=[\"TH\",\"TD\",\"LI\",\"DL\",\"DT\",\"FORM\"],a.FE.MODULES.cursor=function(b){function c(a){return!!a&&(!!b.node.isBlock(a)||(a.nextSibling&&a.nextSibling.nodeType==Node.TEXT_NODE&&0===a.nextSibling.textContent.replace(/\\u200b/g,\"\").length?c(a.nextSibling):!(a.nextSibling&&(!a.previousSibling||\"BR\"!=a.nextSibling.tagName||a.nextSibling.nextSibling))&&c(a.parentNode)))}function d(a){return!!a&&(!!b.node.isBlock(a)||(a.previousSibling&&a.previousSibling.nodeType==Node.TEXT_NODE&&0===a.previousSibling.textContent.replace(/\\u200b/g,\"\").length?d(a.previousSibling):!a.previousSibling&&(!(a.previousSibling||!b.node.hasClass(a.parentNode,\"fr-inner\"))||d(a.parentNode))))}function e(a,c){return!!a&&(a!=b.$wp.get(0)&&(a.previousSibling&&a.previousSibling.nodeType==Node.TEXT_NODE&&0===a.previousSibling.textContent.replace(/\\u200b/g,\"\").length?e(a.previousSibling,c):!a.previousSibling&&(a.parentNode==c||e(a.parentNode,c))))}function f(a,c){return!!a&&(a!=b.$wp.get(0)&&(a.nextSibling&&a.nextSibling.nodeType==Node.TEXT_NODE&&0===a.nextSibling.textContent.replace(/\\u200b/g,\"\").length?f(a.nextSibling,c):!(a.nextSibling&&(!a.previousSibling||\"BR\"!=a.nextSibling.tagName||a.nextSibling.nextSibling))&&(a.parentNode==c||f(a.parentNode,c))))}function g(c){return a(c).parentsUntil(b.$el,\"LI\").length>0&&0===a(c).parentsUntil(\"LI\",\"TABLE\").length}function h(a,b){var c=new RegExp(\"([\\\\uD83C-\\\\uDBFF\\\\uDC00-\\\\uDFFF\\\\u200D]+)\"+(b?\"\":\"$\"),\"i\"),d=a.match(c);return d?d[0].length:1}function i(c){var d=a(c).parentsUntil(b.$el,\"BLOCKQUOTE\").length>0,e=b.node.deepestParent(c,[],!d);if(e&&\"BLOCKQUOTE\"==e.tagName){var f=b.node.deepestParent(c,[a(c).parentsUntil(b.$el,\"BLOCKQUOTE\").get(0)]);f&&f.previousSibling&&(e=f)}if(null!==e){var g,h=e.previousSibling;if(b.node.isBlock(e)&&b.node.isEditable(e)&&h&&a.FE.NO_DELETE_TAGS.indexOf(h.tagName)<0)if(b.node.isDeletable(h))a(h).remove(),a(c).replaceWith(a.FE.MARKERS);else if(b.node.isEditable(h))if(b.node.isBlock(h))if(b.node.isEmpty(h)&&!b.node.isList(h))a(h).remove(),a(c).after(b.opts.keepFormatOnDelete?a.FE.INVISIBLE_SPACE:\"\");else{if(b.node.isList(h)&&(h=a(h).find(\"li:last\").get(0)),g=b.node.contents(h),g.length&&\"BR\"==g[g.length-1].tagName&&a(g[g.length-1]).remove(),\"BLOCKQUOTE\"==h.tagName&&\"BLOCKQUOTE\"!=e.tagName)for(g=b.node.contents(h);g.length&&b.node.isBlock(g[g.length-1]);)h=g[g.length-1],g=b.node.contents(h);else if(\"BLOCKQUOTE\"!=h.tagName&&\"BLOCKQUOTE\"==e.tagName)for(g=b.node.contents(e);g.length&&b.node.isBlock(g[0]);)e=g[0],g=b.node.contents(e);b.node.isEmpty(e)?(a(c).remove(),b.selection.setAtEnd(h,b.opts.keepFormatOnDelete)):(a(c).replaceWith(a.FE.MARKERS),a(h).append(e.innerHTML)),a(e).remove()}else a(c).replaceWith(a.FE.MARKERS),\"BLOCKQUOTE\"==e.tagName&&h.nodeType==Node.ELEMENT_NODE?a(h).remove():(a(h).after(b.node.isEmpty(e)?\"\":a(e).html()),a(e).remove(),\"BR\"==h.tagName&&a(h).remove())}}function j(c){for(var d=c;!d.previousSibling;)if(d=d.parentNode,b.node.isElement(d))return!1;d=d.previousSibling;var e;if(!b.node.isBlock(d)&&b.node.isEditable(d)){for(e=b.node.contents(d);d.nodeType!=Node.TEXT_NODE&&!b.node.isDeletable(d)&&e.length&&b.node.isEditable(d);)d=e[e.length-1],e=b.node.contents(d);if(d.nodeType==Node.TEXT_NODE){var f=d.textContent,g=f.length;if(b.opts.tabSpaces&&f.length>=b.opts.tabSpaces){0===f.substr(f.length-b.opts.tabSpaces,f.length-1).replace(/ /g,\"\").replace(new RegExp(a.FE.UNICODE_NBSP,\"g\"),\"\").length&&(g=f.length-b.opts.tabSpaces)}d.textContent=f.substring(0,g-h(f));var i=f.length!=d.textContent.length;0===d.textContent.length?i&&b.opts.keepFormatOnDelete?a(d).after(a.FE.INVISIBLE_SPACE+a.FE.MARKERS):(2!=d.parentNode.childNodes.length||d.parentNode!=c.parentNode)&&1!=d.parentNode.childNodes.length||b.node.isBlock(d.parentNode)||b.node.isElement(d.parentNode)?(a(d).after(a.FE.MARKERS),b.node.isElement(d.parentNode)&&!c.nextSibling&&d.previousSibling&&\"BR\"==d.previousSibling.tagName&&a(c).after(\"<br>\"),d.parentNode.removeChild(d)):(a(d.parentNode).after(a.FE.MARKERS),a(d.parentNode).remove()):a(d).after(a.FE.MARKERS)}else b.node.isDeletable(d)?(a(d).after(a.FE.MARKERS),a(d).remove()):c.nextSibling&&\"BR\"==c.nextSibling.tagName&&b.node.isVoid(d)&&\"BR\"!=d.tagName?(a(c.nextSibling).remove(),a(c).replaceWith(a.FE.MARKERS)):!1!==b.events.trigger(\"node.remove\",[a(d)])&&(a(d).after(a.FE.MARKERS),a(d).remove())}else if(a.FE.NO_DELETE_TAGS.indexOf(d.tagName)<0&&(b.node.isEditable(d)||b.node.isDeletable(d)))if(b.node.isDeletable(d))a(c).replaceWith(a.FE.MARKERS),a(d).remove();else if(b.node.isEmpty(d)&&!b.node.isList(d))a(d).remove(),a(c).replaceWith(a.FE.MARKERS);else{for(b.node.isList(d)&&(d=a(d).find(\"li:last\").get(0)),e=b.node.contents(d),e&&\"BR\"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),e=b.node.contents(d);e&&b.node.isBlock(e[e.length-1]);)d=e[e.length-1],e=b.node.contents(d);a(d).append(a.FE.MARKERS);for(var j=c;!j.previousSibling;)j=j.parentNode;for(;j&&\"BR\"!==j.tagName&&!b.node.isBlock(j);){var k=j;j=j.nextSibling,a(d).append(k)}j&&\"BR\"==j.tagName&&a(j).remove(),a(c).remove()}else c.nextSibling&&\"BR\"==c.nextSibling.tagName&&a(c.nextSibling).remove()}function k(){var f=!1,k=b.markers.insert();if(!k)return!0;for(var l=k.parentNode;l&&!b.node.isElement(l);){if(\"false\"===l.getAttribute(\"contenteditable\"))return a(k).replaceWith(a.FE.MARKERS),b.selection.restore(),!1;if(\"true\"===l.getAttribute(\"contenteditable\"))break;l=l.parentNode}b.el.normalize();var m=k.previousSibling;if(m){var n=m.textContent;n&&n.length&&8203==n.charCodeAt(n.length-1)&&(1==n.length?a(m).remove():m.textContent=m.textContent.substr(0,n.length-h(n)))}return c(k)?f=j(k):d(k)?g(k)&&e(k,a(k).parents(\"li:first\").get(0))?b.cursorLists._backspace(k):i(k):f=j(k),a(k).remove(),o(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore(),f}function l(c){var d=a(c).parentsUntil(b.$el,\"BLOCKQUOTE\").length>0,e=b.node.deepestParent(c,[],!d);if(e&&\"BLOCKQUOTE\"==e.tagName){var f=b.node.deepestParent(c,[a(c).parentsUntil(b.$el,\"BLOCKQUOTE\").get(0)]);f&&f.nextSibling&&(e=f)}if(null!==e){var g,h=e.nextSibling;if(b.node.isBlock(e)&&(b.node.isEditable(e)||b.node.isDeletable(e))&&h&&a.FE.NO_DELETE_TAGS.indexOf(h.tagName)<0)if(b.node.isDeletable(h))a(h).remove(),a(c).replaceWith(a.FE.MARKERS);else if(b.node.isBlock(h)&&b.node.isEditable(h))if(b.node.isList(h))if(b.node.isEmpty(e,!0))a(e).remove(),a(h).find(\"li:first\").prepend(a.FE.MARKERS);else{var i=a(h).find(\"li:first\");\"BLOCKQUOTE\"==e.tagName&&(g=b.node.contents(e),g.length&&b.node.isBlock(g[g.length-1])&&(e=g[g.length-1])),0===i.find(\"ul, ol\").length&&(a(c).replaceWith(a.FE.MARKERS),i.find(b.html.blockTagsQuery()).not(\"ol, ul, table\").each(function(){this.parentNode==i.get(0)&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?\"\":\"<br>\"))}),a(e).append(b.node.contents(i.get(0))),i.remove(),0===a(h).find(\"li\").length&&a(h).remove())}else{if(g=b.node.contents(h),g.length&&\"BR\"==g[0].tagName&&a(g[0]).remove(),\"BLOCKQUOTE\"!=h.tagName&&\"BLOCKQUOTE\"==e.tagName)for(g=b.node.contents(e);g.length&&b.node.isBlock(g[g.length-1]);)e=g[g.length-1],g=b.node.contents(e);else if(\"BLOCKQUOTE\"==h.tagName&&\"BLOCKQUOTE\"!=e.tagName)for(g=b.node.contents(h);g.length&&b.node.isBlock(g[0]);)h=g[0],g=b.node.contents(h);a(c).replaceWith(a.FE.MARKERS),a(e).append(h.innerHTML),a(h).remove()}else{for(a(c).replaceWith(a.FE.MARKERS);h&&\"BR\"!==h.tagName&&!b.node.isBlock(h)&&b.node.isEditable(h);){var j=h;h=h.nextSibling,a(e).append(j)}h&&\"BR\"==h.tagName&&b.node.isEditable(h)&&a(h).remove()}}}function m(d){for(var e=d;!e.nextSibling;)if(e=e.parentNode,b.node.isElement(e))return!1;if(e=e.nextSibling,\"BR\"==e.tagName&&b.node.isEditable(e))if(e.nextSibling){if(b.node.isBlock(e.nextSibling)&&b.node.isEditable(e.nextSibling)){if(!(a.FE.NO_DELETE_TAGS.indexOf(e.nextSibling.tagName)<0))return void a(e).remove();e=e.nextSibling,a(e.previousSibling).remove()}}else if(c(e)){if(g(d))b.cursorLists._del(d);else{var f=b.node.deepestParent(e);f&&((!b.node.isEmpty(b.node.blockParent(e))||(b.node.blockParent(e).nextSibling&&a.FE.NO_DELETE_TAGS.indexOf(b.node.blockParent(e).nextSibling.tagName))<0)&&a(e).remove(),l(d))}return}var i;if(!b.node.isBlock(e)&&b.node.isEditable(e)){for(i=b.node.contents(e);e.nodeType!=Node.TEXT_NODE&&i.length&&!b.node.isDeletable(e)&&b.node.isEditable(e);)e=i[0],i=b.node.contents(e);e.nodeType==Node.TEXT_NODE?(a(e).before(a.FE.MARKERS),e.textContent.length&&(e.textContent=e.textContent.substring(h(e.textContent,!0),e.textContent.length))):b.node.isDeletable(e)?(a(e).before(a.FE.MARKERS),a(e).remove()):!1!==b.events.trigger(\"node.remove\",[a(e)])&&(a(e).before(a.FE.MARKERS),a(e).remove()),a(d).remove()}else if(a.FE.NO_DELETE_TAGS.indexOf(e.tagName)<0&&(b.node.isEditable(e)||b.node.isDeletable(e)))if(b.node.isDeletable(e))a(d).replaceWith(a.FE.MARKERS),a(e).remove();else if(b.node.isList(e))d.previousSibling?(a(e).find(\"li:first\").prepend(d),b.cursorLists._backspace(d)):(a(e).find(\"li:first\").prepend(a.FE.MARKERS),a(d).remove());else if(i=b.node.contents(e),i&&\"BR\"==i[0].tagName&&a(i[0]).remove(),i&&\"BLOCKQUOTE\"==e.tagName){var j=i[0];for(a(d).before(a.FE.MARKERS);j&&\"BR\"!=j.tagName;){var k=j;j=j.nextSibling,a(d).before(k)}j&&\"BR\"==j.tagName&&a(j).remove()}else a(d).after(a(e).html()).after(a.FE.MARKERS),a(e).remove()}function n(){var e=b.markers.insert();if(!e)return!1;if(b.el.normalize(),c(e))if(g(e))if(0===a(e).parents(\"li:first\").find(\"ul, ol\").length)b.cursorLists._del(e);else{var f=a(e).parents(\"li:first\").find(\"ul:first, ol:first\").find(\"li:first\");f=f.find(b.html.blockTagsQuery()).get(-1)||f,f.prepend(e),b.cursorLists._backspace(e)}else l(e);else m(d(e)?e:e);a(e).remove(),o(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore()}function o(){for(var a=b.el.querySelectorAll(\"blockquote:empty\"),c=0;c<a.length;c++)a[c].parentNode.removeChild(a[c])}function p(){b.$el.find(\".fr-to-remove\").each(function(){for(var c=b.node.contents(this),d=0;d<c.length;d++)c[d].nodeType==Node.TEXT_NODE&&(c[d].textContent=c[d].textContent.replace(/\\u200B/g,\"\"));a(this).replaceWith(this.innerHTML)})}function q(c,d,e){var g,h=b.node.deepestParent(c,[],!e);if(h&&\"BLOCKQUOTE\"==h.tagName)return f(c,h)?(g=b.html.defaultTag(),g?a(h).after(\"<\"+g+\">\"+a.FE.MARKERS+\"<br></\"+g+\">\"):a(h).after(a.FE.MARKERS+\"<br>\"),a(c).remove(),!1):(s(c,d,e),!1);if(null==h)g=b.html.defaultTag(),\ng&&b.node.isElement(c.parentNode)?a(c).replaceWith(\"<\"+g+\">\"+a.FE.MARKERS+\"<br></\"+g+\">\"):!c.previousSibling||a(c.previousSibling).is(\"br\")||c.nextSibling?a(c).replaceWith(\"<br>\"+a.FE.MARKERS):a(c).replaceWith(\"<br>\"+a.FE.MARKERS+\"<br>\");else{var i=c,j=\"\";b.node.isBlock(h)&&!d||(j=\"<br/>\");var k=\"\",l=\"\";g=b.html.defaultTag();var m=\"\",n=\"\";g&&b.node.isBlock(h)&&(m=\"<\"+g+\">\",n=\"</\"+g+\">\",h.tagName==g.toUpperCase()&&(m=b.node.openTagString(a(h).clone().removeAttr(\"id\").get(0))));do{if(i=i.parentNode,!d||i!=h||d&&!b.node.isBlock(h))if(k+=b.node.closeTagString(i),i==h&&b.node.isBlock(h))l=m+l;else{var o=\"A\"==i.tagName&&f(c,i)?\"fr-to-remove\":\"\";l=b.node.openTagString(a(i).clone().addClass(o).get(0))+l}}while(i!=h);j=k+j+l+(c.parentNode==h&&b.node.isBlock(h)?\"\":a.FE.INVISIBLE_SPACE)+a.FE.MARKERS,b.node.isBlock(h)&&!a(h).find(\"*:last\").is(\"br\")&&a(h).append(\"<br/>\"),a(c).after('<span id=\"fr-break\"></span>'),a(c).remove(),h.nextSibling&&!b.node.isBlock(h.nextSibling)||b.node.isBlock(h)||a(h).after(\"<br>\");var p;p=!d&&b.node.isBlock(h)?b.node.openTagString(h)+a(h).html()+n:b.node.openTagString(h)+a(h).html()+b.node.closeTagString(h),p=p.replace(/<span id=\"fr-break\"><\\/span>/g,j),a(h).replaceWith(p)}}function r(c,d,g){var h,i=b.node.deepestParent(c,[],!g);if(i&&\"TABLE\"==i.tagName)return a(i).find(\"td:first, th:first\").prepend(c),r(c,d,g);if(i&&\"BLOCKQUOTE\"==i.tagName){if(e(c,i))return h=b.html.defaultTag(),h?a(i).before(\"<\"+h+\">\"+a.FE.MARKERS+\"<br></\"+h+\">\"):a(i).before(a.FE.MARKERS+\"<br>\"),a(c).remove(),!1;f(c,i)?q(c,d,!0):s(c,d,!0)}if(null==i)h=b.html.defaultTag(),h&&b.node.isElement(c.parentNode)?a(c).replaceWith(\"<\"+h+\">\"+a.FE.MARKERS+\"<br></\"+h+\">\"):a(c).replaceWith(\"<br>\"+a.FE.MARKERS);else{if(b.node.isBlock(i))if(\"PRE\"==i.tagName&&(d=!0),d)a(c).remove(),a(i).prepend(\"<br>\"+a.FE.MARKERS);else{if(b.node.isEmpty(i,!0))return q(c,d,g);if(b.opts.keepFormatOnDelete){for(var j=c,k=a.FE.INVISIBLE_SPACE;j!=i&&!b.node.isElement(j);)j=j.parentNode,k=b.node.openTagString(j)+k+b.node.closeTagString(j);a(i).before(k)}else a(i).before(b.node.openTagString(a(i).clone().removeAttr(\"id\").get(0))+\"<br>\"+b.node.closeTagString(i))}else a(i).before(\"<br>\");a(c).remove()}}function s(c,d,g){var h=b.node.deepestParent(c,[],!g);if(null==h)b.html.defaultTag()&&c.parentNode===b.el?a(c).replaceWith(\"<\"+b.html.defaultTag()+\">\"+a.FE.MARKERS+\"<br></\"+b.html.defaultTag()+\">\"):(c.nextSibling&&!b.node.isBlock(c.nextSibling)||a(c).after(\"<br>\"),a(c).replaceWith(\"<br>\"+a.FE.MARKERS));else{var i=c,j=\"\";\"PRE\"==h.tagName&&(d=!0),b.node.isBlock(h)&&!d||(j=\"<br>\");var k=\"\",l=\"\";do{var m=i;if(i=i.parentNode,\"BLOCKQUOTE\"==h.tagName&&b.node.isEmpty(m)&&!b.node.hasClass(m,\"fr-marker\")&&a(m).find(c).length>0&&a(m).after(c),(\"BLOCKQUOTE\"!=h.tagName||!f(c,i)&&!e(c,i))&&(!d||i!=h||d&&!b.node.isBlock(h))){k+=b.node.closeTagString(i);var n=\"A\"==i.tagName&&f(c,i)?\"fr-to-remove\":\"\";l=b.node.openTagString(a(i).clone().addClass(n).removeAttr(\"id\").get(0))+l}}while(i!=h);var o=h==c.parentNode&&b.node.isBlock(h)||c.nextSibling;if(\"BLOCKQUOTE\"==h.tagName){c.previousSibling&&b.node.isBlock(c.previousSibling)&&c.nextSibling&&\"BR\"==c.nextSibling.tagName&&(a(c.nextSibling).after(c),c.nextSibling&&\"BR\"==c.nextSibling.tagName&&a(c.nextSibling).remove());var p=b.html.defaultTag();j=k+j+(p?\"<\"+p+\">\":\"\")+a.FE.MARKERS+\"<br>\"+(p?\"</\"+p+\">\":\"\")+l}else j=k+j+l+(o?\"\":a.FE.INVISIBLE_SPACE)+a.FE.MARKERS;a(c).replaceWith('<span id=\"fr-break\"></span>');var q=b.node.openTagString(h)+a(h).html()+b.node.closeTagString(h);q=q.replace(/<span id=\"fr-break\"><\\/span>/g,j),a(h).replaceWith(q)}}function t(e){var f=b.markers.insert();if(!f)return!0;b.el.normalize();var h=!1;a(f).parentsUntil(b.$el,\"BLOCKQUOTE\").length>0&&(e=!1,h=!0),a(f).parentsUntil(b.$el,\"TD, TH\").length&&(h=!1),c(f)?!g(f)||e||h?q(f,e,h):b.cursorLists._endEnter(f):d(f)?!g(f)||e||h?r(f,e,h):b.cursorLists._startEnter(f):!g(f)||e||h?s(f,e,h):b.cursorLists._middleEnter(f),p(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore()}return{enter:t,backspace:k,del:n,isAtEnd:f,isAtStart:e}},a.FE.ENTER_P=0,a.FE.ENTER_DIV=1,a.FE.ENTER_BR=2,a.FE.KEYCODE={BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,ARROW_LEFT:37,ARROW_UP:38,ARROW_RIGHT:39,ARROW_DOWN:40,DELETE:46,ZERO:48,ONE:49,TWO:50,THREE:51,FOUR:52,FIVE:53,SIX:54,SEVEN:55,EIGHT:56,NINE:57,FF_SEMICOLON:59,FF_EQUALS:61,QUESTION_MARK:63,A:65,B:66,C:67,D:68,E:69,F:70,G:71,H:72,I:73,J:74,K:75,L:76,M:77,N:78,O:79,P:80,Q:81,R:82,S:83,T:84,U:85,V:86,W:87,X:88,Y:89,Z:90,META:91,NUM_ZERO:96,NUM_ONE:97,NUM_TWO:98,NUM_THREE:99,NUM_FOUR:100,NUM_FIVE:101,NUM_SIX:102,NUM_SEVEN:103,NUM_EIGHT:104,NUM_NINE:105,NUM_MULTIPLY:106,NUM_PLUS:107,NUM_MINUS:109,NUM_PERIOD:110,NUM_DIVISION:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,FF_HYPHEN:173,SEMICOLON:186,DASH:189,EQUALS:187,COMMA:188,HYPHEN:189,PERIOD:190,SLASH:191,APOSTROPHE:192,TILDE:192,SINGLE_QUOTE:222,OPEN_SQUARE_BRACKET:219,BACKSLASH:220,CLOSE_SQUARE_BRACKET:221,IME:229},a.extend(a.FE.DEFAULTS,{enter:a.FE.ENTER_P,multiLine:!0,tabSpaces:0}),a.FE.MODULES.keys=function(b){function c(a){b.opts.multiLine?b.helpers.isIOS()?I=b.snapshot.get():(a.preventDefault(),a.stopPropagation(),b.selection.isCollapsed()||b.selection.remove(),b.cursor.enter()):(a.preventDefault(),a.stopPropagation())}function d(a){a.preventDefault(),a.stopPropagation(),b.opts.multiLine&&(b.selection.isCollapsed()||b.selection.remove(),b.cursor.enter(!0))}function e(){setTimeout(function(){b.events.disableBlur(),b.events.focus()},0)}function f(a){b.selection.isCollapsed()?b.helpers.isIOS()?I=b.snapshot.get():(b.cursor.backspace(),a.preventDefault(),a.stopPropagation()):(a.preventDefault(),a.stopPropagation(),b.selection.remove(),b.html.fillEmptyBlocks()),b.placeholder.refresh()}function g(a){a.preventDefault(),a.stopPropagation(),\"\"===b.selection.text()?b.cursor.del():b.selection.remove(),b.placeholder.refresh()}function h(c){var d=b.selection.element();if(!b.helpers.isMobile()&&d&&\"A\"==d.tagName){c.preventDefault(),c.stopPropagation(),b.selection.isCollapsed()||b.selection.remove();var e=b.markers.insert();if(e){var f=e.previousSibling;!e.nextSibling&&e.parentNode&&\"A\"==e.parentNode.tagName?(e.parentNode.insertAdjacentHTML(\"afterend\",\"&nbsp;\"+a.FE.MARKERS),e.parentNode.removeChild(e)):(f&&f.nodeType==Node.TEXT_NODE&&1==f.textContent.length&&160==f.textContent.charCodeAt(0)?f.textContent=f.textContent+\" \":e.insertAdjacentHTML(\"beforebegin\",\"&nbsp;\"),e.outerHTML=a.FE.MARKERS),b.selection.restore()}}}function i(){if(b.browser.mozilla&&b.selection.isCollapsed()&&!H){var a=b.selection.ranges(0),c=a.startContainer,d=a.startOffset;c&&c.nodeType==Node.TEXT_NODE&&d<=c.textContent.length&&d>0&&32==c.textContent.charCodeAt(d-1)&&(b.selection.save(),b.spaces.normalize(),b.selection.restore())}}function j(){b.selection.isFull()&&setTimeout(function(){var c=b.html.defaultTag();c?b.$el.html(\"<\"+c+\">\"+a.FE.MARKERS+\"<br/></\"+c+\">\"):b.$el.html(a.FE.MARKERS+\"<br/>\"),b.selection.restore(),b.placeholder.refresh(),b.button.bulkRefresh(),b.undo.saveStep()},0)}function k(a){if(b.opts.tabSpaces>0)if(b.selection.isCollapsed()){b.undo.saveStep(),a.preventDefault(),a.stopPropagation();for(var c=\"\",d=0;d<b.opts.tabSpaces;d++)c+=\"&nbsp;\";b.html.insert(c),b.placeholder.refresh(),b.undo.saveStep()}else a.preventDefault(),a.stopPropagation(),a.shiftKey?b.commands.outdent():b.commands.indent()}function l(){H=!1}function m(){H=!1}function n(){return H}function o(){var c=b.html.defaultTag();c?b.$el.html(\"<\"+c+\">\"+a.FE.MARKERS+\"<br/></\"+c+\">\"):b.$el.html(a.FE.MARKERS+\"<br/>\"),b.selection.restore()}function p(i){b.events.disableBlur(),I=null;var j=i.which;if(16===j)return!0;if(E=j,j===a.FE.KEYCODE.IME)return H=!0,!0;H=!1;var l=w(j)&&!u(i),m=j==a.FE.KEYCODE.BACKSPACE||j==a.FE.KEYCODE.DELETE;if((b.selection.isFull()&&!b.opts.keepFormatOnDelete&&!b.placeholder.isVisible()||m&&b.placeholder.isVisible()&&b.opts.keepFormatOnDelete)&&(l||m)&&(o(),!w(j)))return i.preventDefault(),!0;j==a.FE.KEYCODE.ENTER?i.shiftKey?d(i):c(i):j===a.FE.KEYCODE.BACKSPACE&&(i.metaKey||i.ctrlKey)?e():j!=a.FE.KEYCODE.BACKSPACE||u(i)||i.altKey?j!=a.FE.KEYCODE.DELETE||u(i)||i.altKey||i.shiftKey?j==a.FE.KEYCODE.SPACE?h(i):j==a.FE.KEYCODE.TAB?k(i):u(i)||!w(i.which)||b.selection.isCollapsed()||i.ctrlKey||b.selection.remove():b.placeholder.isVisible()?(b.opts.keepFormatOnDelete||o(),i.preventDefault(),i.stopPropagation()):g(i):b.placeholder.isVisible()?(b.opts.keepFormatOnDelete||o(),i.preventDefault(),i.stopPropagation()):f(i),b.events.enableBlur()}function q(a){for(var c=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){return/\\u200B/gi.test(a.textContent)}),!1);c.nextNode();){var d=c.currentNode;d.textContent=d.textContent.replace(/\\u200B/gi,\"\")}}function r(){if(!b.$wp)return!0;var c;b.opts.height||b.opts.heightMax?(c=b.position.getBoundingRect().top,(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top),c>b.$wp.offset().top-b.helpers.scrollTop()+b.$wp.height()-20&&b.$wp.scrollTop(c+b.$wp.scrollTop()-(b.$wp.height()+b.$wp.offset().top)+b.helpers.scrollTop()+20)):(c=b.position.getBoundingRect().top,b.opts.toolbarBottom&&(c+=b.opts.toolbarStickyOffset),(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top,c-=b.helpers.scrollTop()),c+=b.opts.toolbarStickyOffset,c>b.o_win.innerHeight-20&&a(b.o_win).scrollTop(c+b.helpers.scrollTop()-b.o_win.innerHeight+20),c=b.position.getBoundingRect().top,b.opts.toolbarBottom||(c-=b.opts.toolbarStickyOffset),(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top,c-=b.helpers.scrollTop()),c<b.$tb.height()+20&&c>=0&&a(b.o_win).scrollTop(c+b.helpers.scrollTop()-b.$tb.height()-20))}function s(){var c=b.selection.element(),d=b.node.blockParent(c);if(d&&\"DIV\"==d.tagName&&b.selection.info(d).atStart){var e=b.html.defaultTag();d.previousSibling&&\"DIV\"!=d.previousSibling.tagName&&e&&\"div\"!=e&&(b.selection.save(),a(d).replaceWith(\"<\"+e+\">\"+d.innerHTML+\"</\"+e+\">\"),b.selection.restore())}}function t(c){if(c&&0===c.which&&E&&(c.which=E),b.helpers.isIOS()&&c&&I)if(c.which==a.FE.KEYCODE.ENTER)b.snapshot.restore(I),b.cursor.enter();else if(c.which==a.FE.KEYCODE.BACKSPACE){var d=b.snapshot.get();b.snapshot.restore(I),b.cursor.backspace(),b.el.innerHTML!==d.html&&b.snapshot.restore(d)}if(b.helpers.isAndroid()&&b.browser.mozilla)return!0;if(H)return!1;if(!b.selection.isCollapsed())return!0;if(c&&(c.which===a.FE.KEYCODE.META||c.which==a.FE.KEYCODE.CTRL))return!0;if(c&&v(c.which))return!0;c&&c.which==a.FE.KEYCODE.ENTER&&b.helpers.isIOS()&&s(),c&&(c.which==a.FE.KEYCODE.ENTER||c.which==a.FE.KEYCODE.BACKSPACE||c.which>=37&&c.which<=40&&!b.browser.msie)&&r();var e=function(a){if(!a)return!1;var b=a.innerHTML;return!!((b=b.replace(/<span[^>]*? class\\s*=\\s*[\"']?fr-marker[\"']?[^>]+>\\u200b<\\/span>/gi,\"\"))&&/\\u200B/.test(b)&&b.replace(/\\u200B/gi,\"\").length>0)},f=function(a){var c=/[\\u3041-\\u3096\\u30A0-\\u30FF\\u4E00-\\u9FFF\\u3130-\\u318F\\uAC00-\\uD7AF]/gi;return!b.helpers.isIOS()||0===((a.textContent||\"\").match(c)||[]).length},g=b.selection.element();e(g)&&!b.node.hasClass(g,\"fr-marker\")&&\"IFRAME\"!=g.tagName&&f(g)&&(b.selection.save(),q(g),b.selection.restore())}function u(a){if(-1!=navigator.userAgent.indexOf(\"Mac OS X\")){if(a.metaKey&&!a.altKey)return!0}else if(a.ctrlKey&&!a.altKey)return!0;return!1}function v(b){if(b>=a.FE.KEYCODE.ARROW_LEFT&&b<=a.FE.KEYCODE.ARROW_DOWN)return!0}function w(c){if(c>=a.FE.KEYCODE.ZERO&&c<=a.FE.KEYCODE.NINE)return!0;if(c>=a.FE.KEYCODE.NUM_ZERO&&c<=a.FE.KEYCODE.NUM_MULTIPLY)return!0;if(c>=a.FE.KEYCODE.A&&c<=a.FE.KEYCODE.Z)return!0;if(b.browser.webkit&&0===c)return!0;switch(c){case a.FE.KEYCODE.SPACE:case a.FE.KEYCODE.QUESTION_MARK:case a.FE.KEYCODE.NUM_PLUS:case a.FE.KEYCODE.NUM_MINUS:case a.FE.KEYCODE.NUM_PERIOD:case a.FE.KEYCODE.NUM_DIVISION:case a.FE.KEYCODE.SEMICOLON:case a.FE.KEYCODE.FF_SEMICOLON:case a.FE.KEYCODE.DASH:case a.FE.KEYCODE.EQUALS:case a.FE.KEYCODE.FF_EQUALS:case a.FE.KEYCODE.COMMA:case a.FE.KEYCODE.PERIOD:case a.FE.KEYCODE.SLASH:case a.FE.KEYCODE.APOSTROPHE:case a.FE.KEYCODE.SINGLE_QUOTE:case a.FE.KEYCODE.OPEN_SQUARE_BRACKET:case a.FE.KEYCODE.BACKSLASH:case a.FE.KEYCODE.CLOSE_SQUARE_BRACKET:return!0;default:return!1}}function x(c){var d=c.which;if(u(c)||d>=37&&d<=40||!w(d)&&d!=a.FE.KEYCODE.DELETE&&d!=a.FE.KEYCODE.BACKSPACE&&d!=a.FE.KEYCODE.ENTER&&d!=a.FE.KEYCODE.IME)return!0;F||(G=b.snapshot.get(),b.undo.canDo()||b.undo.saveStep()),clearTimeout(F),F=setTimeout(function(){F=null,b.undo.saveStep()},Math.max(250,b.opts.typingTimer))}function y(a){var c=a.which;if(u(a)||c>=37&&c<=40)return!0;G&&F?(b.undo.saveStep(G),G=null):void 0!==c&&0!==c||G||F||b.undo.saveStep()}function z(){F&&(clearTimeout(F),b.undo.saveStep(),G=null)}function A(b){var c=b.which;return u(b)||c==a.FE.KEYCODE.F5}function B(a){return(!a||\"BR\"!=a.tagName)&&(0===(a.textContent||\"\").length&&a.querySelector&&!a.querySelector(\":scope > br\"))}function C(c){var d=b.el.childNodes,e=b.html.defaultTag();return!(!c.target||c.target===b.el)||(0===d.length||void(b.$el.outerHeight()-c.offsetY<=10?B(d[d.length-1])&&(e?b.$el.append(\"<\"+e+\">\"+a.FE.MARKERS+\"<br></\"+e+\">\"):b.$el.append(a.FE.MARKERS+\"<br>\"),b.selection.restore(),r()):c.offsetY<=10&&B(d[0])&&(e?b.$el.prepend(\"<\"+e+\">\"+a.FE.MARKERS+\"<br></\"+e+\">\"):b.$el.prepend(a.FE.MARKERS+\"<br>\"),b.selection.restore(),r())))}function D(){if(b.events.on(\"keydown\",x),b.events.on(\"input\",i),b.events.on(\"mousedown\",m),b.events.on(\"keyup input\",y),b.events.on(\"keypress\",l),b.events.on(\"keydown\",p),b.events.on(\"keyup\",t),b.events.on(\"html.inserted\",t),b.events.on(\"cut\",j),b.events.on(\"click\",C),!b.browser.edge&&b.el.msGetInputContext)try{b.el.msGetInputContext().addEventListener(\"MSCandidateWindowShow\",function(){H=!0}),b.el.msGetInputContext().addEventListener(\"MSCandidateWindowHide\",function(){H=!1,t()})}catch(a){}}var E,F,G,H=!1,I=null;return{_init:D,ctrlKey:u,isCharacter:w,isArrow:v,forceUndo:z,isIME:n,isBrowserAction:A,positionCaret:r}},a.FE.MODULES.accessibility=function(b){function c(a){if(a&&a.length){a.data(\"blur-event-set\")||a.parents(\".fr-popup\").length||(b.events.$on(a,\"blur\",function(){var c=a.parents(\".fr-toolbar, .fr-popup\").data(\"instance\")||b;c.events.blurActive()&&c.events.trigger(\"blur\"),c.events.enableBlur()},!0),a.data(\"blur-event-set\",!0));(a.parents(\".fr-toolbar, .fr-popup\").data(\"instance\")||b).events.disableBlur(),a.focus(),b.shared.$f_el=a}}function d(a,b){var d=b?\"last\":\"first\",e=a.find(\"button:visible:not(.fr-disabled), .fr-group span.fr-command:visible\")[d]();if(e.length)return c(e),!0}function e(a){return a.is(\"input, textarea\")&&g(),b.events.disableBlur(),a.focus(),!0}function f(a,c){var d=a.find(\"input, textarea, button, select\").filter(\":visible\").not(\":disabled\").filter(c?\":last\":\":first\");if(d.length)return e(d);if(b.shared.with_kb){var f=a.find(\".fr-active-item:visible:first\");if(f.length)return e(f);var g=a.find(\"[tabIndex]:visible:first\");if(g.length)return e(g)}}function g(){0===b.$el.find(\".fr-marker\").length&&b.core.hasFocus()&&b.selection.save()}function h(a){a.$el.find(\".fr-marker\").length&&(a.events.disableBlur(),a.selection.restore(),a.events.enableBlur())}function i(a){var c=a.children().not(\".fr-buttons\");c.data(\"mouseenter-event-set\")||(b.events.$on(c,\"mouseenter\",\"[tabIndex]\",function(d){var e=a.data(\"instance\")||b;if(!F)return d.stopPropagation(),void d.preventDefault();var f=c.find(\":focus:first\");f.length&&!f.is(\"input, button, textarea\")&&(e.events.disableBlur(),f.blur(),e.events.disableBlur(),e.events.focus())}),c.data(\"mouseenter-event-set\",!0)),!f(c)&&b.shared.with_kb&&d(a.find(\".fr-buttons\"))}function j(a){b.core.hasFocus()||(b.events.disableBlur(),b.events.focus()),b.accessibility.saveSelection(),b.events.disableBlur(),b.$el.blur(),b.selection.clear(),b.events.disableBlur(),b.shared.with_kb?a.find(\".fr-command[tabIndex], [tabIndex]\").first().focus():a.find(\"[tabIndex]:first\").focus()}function k(){var a=b.popups.areVisible();if(a){var c=a.find(\".fr-buttons\");return c.find(\"button:focus, .fr-group span:focus\").length?!d(a.data(\"instance\").$tb):!d(c)}return!d(b.$tb)}function l(){var a=null;return b.shared.$f_el.is(\".fr-dropdown.fr-active\")?a=b.shared.$f_el:b.shared.$f_el.closest(\".fr-dropdown-menu\").prev().is(\".fr-dropdown.fr-active\")&&(a=b.shared.$f_el.closest(\".fr-dropdown-menu\").prev()),a}function m(e,g,h){if(b.shared.$f_el){var i=l();i&&(b.button.click(i),b.shared.$f_el=i);var j=e.find(\"button:visible:not(.fr-disabled), .fr-group span.fr-command:visible\"),k=j.index(b.shared.$f_el);if(0===k&&!h||k==j.length-1&&h){var m;if(g){if(e.parent().is(\".fr-popup\")){m=!f(e.parent().children().not(\".fr-buttons\"),!h)}!1===m&&(b.shared.$f_el=null)}g&&!1===m||d(e,!h)}else c(a(j.get(k+(h?1:-1))));return!1}}function n(a,b){return m(a,b,!0)}function o(a,b){return m(a,b)}function p(a){if(b.shared.$f_el){var d;if(b.shared.$f_el.is(\".fr-dropdown.fr-active\"))return d=a?b.shared.$f_el.next().find(\".fr-command:not(.fr-disabled)\").first():b.shared.$f_el.next().find(\".fr-command:not(.fr-disabled)\").last(),c(d),!1;if(b.shared.$f_el.is(\"a.fr-command\"))return d=a?b.shared.$f_el.closest(\"li\").nextAll(\":visible:first\").find(\".fr-command:not(.fr-disabled)\").first():b.shared.$f_el.closest(\"li\").prevAll(\":visible:first\").find(\".fr-command:not(.fr-disabled)\").first(),d.length||(d=a?b.shared.$f_el.closest(\".fr-dropdown-menu\").find(\".fr-command:not(.fr-disabled)\").first():b.shared.$f_el.closest(\".fr-dropdown-menu\").find(\".fr-command:not(.fr-disabled)\").last()),c(d),!1}}function q(){return b.shared.$f_el&&b.shared.$f_el.is(\".fr-dropdown:not(.fr-active)\")?s():p(!0)}function r(){return p()}function s(){if(b.shared.$f_el){if(b.shared.$f_el.hasClass(\"fr-dropdown\"))b.button.click(b.shared.$f_el);else if(b.shared.$f_el.is(\"button.fr-back\")){b.opts.toolbarInline&&(b.events.disableBlur(),b.events.focus());var a=b.popups.areVisible(b);a&&(b.shared.with_kb=!1),b.button.click(b.shared.$f_el),z(a)}else{if(b.events.disableBlur(),b.button.click(b.shared.$f_el),b.shared.$f_el.attr(\"data-popup\")){var c=b.popups.areVisible(b);c&&c.data(\"popup-button\",b.shared.$f_el)}else if(b.shared.$f_el.attr(\"data-modal\")){var d=b.modals.areVisible(b);d&&d.data(\"modal-button\",b.shared.$f_el)}b.shared.$f_el=null}return!1}}function t(){b.shared.$f_el&&(b.events.disableBlur(),b.shared.$f_el.blur(),b.shared.$f_el=null),!1!==b.events.trigger(\"toolbar.focusEditor\")&&(b.events.disableBlur(),b.$el.focus(),b.events.focus())}function u(a){if(b.shared.$f_el){var d=l();return d?(b.button.click(d),c(d)):a.parent().find(\".fr-back:visible\").length?(b.shared.with_kb=!1,b.opts.toolbarInline&&(b.events.disableBlur(),b.events.focus()),b.button.exec(a.parent().find(\".fr-back:visible:first\")),z(a.parent())):b.shared.$f_el.is(\"button, .fr-group span\")&&(a.parent().is(\".fr-popup\")?(h(b),b.shared.$f_el=null,!1!==b.events.trigger(\"toolbar.esc\")&&(b.popups.hide(a.parent()),b.opts.toolbarInline&&b.toolbar.showInline(null,!0),z(a.parent()))):t()),!1}}function v(c,d){var e=-1!=navigator.userAgent.indexOf(\"Mac OS X\")?c.metaKey:c.ctrlKey,f=c.which,g=!1;return f!=a.FE.KEYCODE.TAB||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_RIGHT||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.TAB||e||!c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_LEFT||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_UP||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_DOWN||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ENTER||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ESC||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.F10||e||c.shiftKey||!c.altKey||(g=k()):g=u(d):g=s():g=q():g=r():g=o(d):g=o(d,!0):g=n(d):g=n(d,!0),b.shared.$f_el||void 0!==g||(g=!0),!g&&b.keys.isBrowserAction(c)&&(g=!0),!!g||(c.preventDefault(),c.stopPropagation(),!1)}function w(c){c&&c.length&&(b.events.$on(c,\"keydown\",function(d){if(!a(d.target).is(\"a.fr-command, button.fr-command, .fr-group span.fr-command\"))return!0;var e=c.parents(\".fr-popup\").data(\"instance\")||c.data(\"instance\")||b;b.shared.with_kb=!0;var f=e.accessibility.exec(d,c);return b.shared.with_kb=!1,f},!0),b.events.$on(c,\"mouseenter\",\"[tabIndex]\",function(d){var e=c.parents(\".fr-popup\").data(\"instance\")||c.data(\"instance\")||b;if(!F)return d.stopPropagation(),void d.preventDefault();var f=a(d.currentTarget);e.shared.$f_el&&e.shared.$f_el.not(f)&&e.accessibility.focusEditor()},!0))}function x(a){var c=b.popups.get(a),d=y(a);w(c.find(\".fr-buttons\")),b.events.$on(c,\"mouseenter\",\"tabIndex\",d._tiMouseenter,!0),b.events.$on(c.children().not(\".fr-buttons\"),\"keydown\",\"[tabIndex]\",d._tiKeydown,!0),b.popups.onHide(a,function(){h(c.data(\"instance\")||b)}),b.popups.onShow(a,function(){F=!1,setTimeout(function(){F=!0},0)})}function y(c){var e=b.popups.get(c);return{_tiKeydown:function(g){var i=e.data(\"instance\")||b;if(!1===i.events.trigger(\"popup.tab\",[g]))return!1;var j=g.which,k=e.find(\":focus:first\");if(a.FE.KEYCODE.TAB==j){g.preventDefault();var l=e.children().not(\".fr-buttons\"),m=l.find(\"input, textarea, button, select\").filter(\":visible\").not(\".fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled\").toArray(),n=m.indexOf(this)+(g.shiftKey?-1:1);if(0<=n&&n<m.length)return i.events.disableBlur(),a(m[n]).focus(),g.stopPropagation(),!1;var o=e.find(\".fr-buttons\");if(o.length&&d(o,!!g.shiftKey))return g.stopPropagation(),!1;if(f(l))return g.stopPropagation(),!1}else{if(a.FE.KEYCODE.ENTER!=j)return a.FE.KEYCODE.ESC==j?(g.preventDefault(),g.stopPropagation(),h(i),i.popups.isVisible(c)&&e.find(\".fr-back:visible\").length?(i.opts.toolbarInline&&(i.events.disableBlur(),i.events.focus()),i.button.exec(e.find(\".fr-back:visible:first\")),z(e)):i.popups.isVisible(c)&&e.find(\".fr-dismiss:visible\").length?i.button.exec(e.find(\".fr-dismiss:visible:first\")):(i.popups.hide(c),i.opts.toolbarInline&&i.toolbar.showInline(null,!0),z(e)),!1):a.FE.KEYCODE.SPACE==j&&(k.is(\".fr-submit\")||k.is(\".fr-dismiss\"))?(g.preventDefault(),g.stopPropagation(),i.events.disableBlur(),i.button.exec(k),!0):i.keys.isBrowserAction(g)?void g.stopPropagation():k.is(\"input[type=text], textarea\")?void g.stopPropagation():a.FE.KEYCODE.SPACE==j&&(k.is(\".fr-link-attr\")||k.is(\"input[type=file]\"))?void g.stopPropagation():(g.stopPropagation(),g.preventDefault(),!1);var p=null;e.find(\".fr-submit:visible\").length>0?p=e.find(\".fr-submit:visible:first\"):e.find(\".fr-dismiss:visible\").length&&(p=e.find(\".fr-dismiss:visible:first\")),p&&(g.preventDefault(),g.stopPropagation(),i.events.disableBlur(),i.button.exec(p))}},_tiMouseenter:function(){C(e.data(\"instance\")||b)}}}function z(a){var b=a.data(\"popup-button\");b&&setTimeout(function(){c(b),a.data(\"popup-button\",null)},0)}function A(a){var b=a.data(\"modal-button\");b&&setTimeout(function(){c(b),a.data(\"modal-button\",null)},0)}function B(){return null!=b.shared.$f_el}function C(a){var c=b.popups.areVisible(a);c&&c.data(\"popup-button\",null)}function D(c){var d=-1!=navigator.userAgent.indexOf(\"Mac OS X\")?c.metaKey:c.ctrlKey;if(c.which==a.FE.KEYCODE.F10&&!d&&!c.shiftKey&&c.altKey){b.shared.with_kb=!0;var e=b.popups.areVisible(b),g=!1;return e&&(g=f(e.children().not(\".fr-buttons\"))),g||k(),b.shared.with_kb=!1,c.preventDefault(),c.stopPropagation(),!1}return!0}function E(){b.$wp?b.events.on(\"keydown\",D,!0):b.events.$on(b.$win,\"keydown\",D,!0),b.events.on(\"mousedown\",function(a){C(b),b.shared.$f_el&&(h(b),a.stopPropagation(),b.events.disableBlur(),b.shared.$f_el=null)},!0),b.events.on(\"blur\",function(){b.shared.$f_el=null,C(b)},!0)}var F=!0;return{_init:E,registerPopup:x,registerToolbar:w,focusToolbarElement:c,focusToolbar:d,focusContent:f,focusPopup:i,focusModal:j,focusEditor:t,focusPopupButton:z,focusModalButton:A,hasFocus:B,exec:v,saveSelection:g,restoreSelection:h}},a.FE.MODULES.format=function(b){function c(a,b){var c=\"<\"+a;for(var d in b)b.hasOwnProperty(d)&&(c+=\" \"+d+'=\"'+b[d]+'\"');return c+=\">\"}function d(a){return\"</\"+a+\">\"}function e(a,b){var c=a;for(var d in b)b.hasOwnProperty(d)&&(c+=\"id\"==d?\"#\"+b[d]:\"class\"==d?\".\"+b[d]:\"[\"+d+'=\"'+b[d]+'\"]');return c}function f(a,b){return!(!a||a.nodeType!=Node.ELEMENT_NODE)&&(a.matches||a.matchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.webkitMatchesSelector||a.oMatchesSelector).call(a,b)}function g(d,e,f){if(d){if(b.node.isBlock(d))return g(d.firstChild,e,f),!1;for(var h=a(c(e,f)).insertBefore(d),i=d;i&&!a(i).is(\".fr-marker\")&&0===a(i).find(\".fr-marker\").length&&\"UL\"!=i.tagName&&\"OL\"!=i.tagName;){var j=i;i=i.nextSibling,h.append(j)}if(i)(a(i).find(\".fr-marker\").length||\"UL\"==i.tagName||\"OL\"==i.tagName)&&g(i.firstChild,e,f);else{for(var k=h.get(0).parentNode;k&&!k.nextSibling&&!b.node.isElement(k);)k=k.parentNode;if(k){var l=k.nextSibling;l&&(b.node.isBlock(l)?g(l.firstChild,e,f):g(l,e,f))}}h.is(\":empty\")&&h.remove()}}function h(h,i){var j;if(void 0===i&&(i={}),i.style&&delete i.style,b.selection.isCollapsed()){b.markers.insert();b.$el.find(\".fr-marker\").replaceWith(c(h,i)+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+d(h)),b.selection.restore()}else{b.selection.save();g(b.$el.find('.fr-marker[data-type=\"true\"]').get(0).nextSibling,h,i);var k;do{for(k=b.$el.find(e(h,i)+\" > \"+e(h,i)),j=0;j<k.length;j++)k[j].outerHTML=k[j].innerHTML}while(k.length);b.el.normalize();var l=b.el.querySelectorAll(\".fr-marker\");for(j=0;j<l.length;j++){var m=a(l[j]);!0===m.data(\"type\")?f(m.get(0).nextSibling,e(h,i))&&m.next().prepend(m):f(m.get(0).previousSibling,e(h,i))&&m.prev().append(m)}b.selection.restore()}}function i(a,c,d,g){if(!g){var h=!1;if(!0===a.data(\"type\"))for(;b.node.isFirstSibling(a.get(0))&&!a.parent().is(b.$el)&&!a.parent().is(\"ol\")&&!a.parent().is(\"ul\");)a.parent().before(a),h=!0;else if(!1===a.data(\"type\"))for(;b.node.isLastSibling(a.get(0))&&!a.parent().is(b.$el)&&!a.parent().is(\"ol\")&&!a.parent().is(\"ul\");)a.parent().after(a),h=!0;if(h)return!0}if(a.parents(c).length||void 0===c){var i=\"\",j=\"\",k=a.parent();if(k.is(b.$el)||b.node.isBlock(k.get(0)))return!1;for(;!b.node.isBlock(k.parent().get(0))&&(void 0===c||void 0!==c&&!f(k.get(0),e(c,d)));)i+=b.node.closeTagString(k.get(0)),j=b.node.openTagString(k.get(0))+j,k=k.parent();var l=a.get(0).outerHTML;a.replaceWith('<span id=\"mark\"></span>');var m=k.html().replace(/<span id=\"mark\"><\\/span>/,i+b.node.closeTagString(k.get(0))+j+l+i+b.node.openTagString(k.get(0))+j);return k.replaceWith(b.node.openTagString(k.get(0))+m+b.node.closeTagString(k.get(0))),!0}return!1}function j(c,d,g,h){for(var i=b.node.contents(c.get(0)),k=0;k<i.length;k++){var l=i[k];if(b.node.hasClass(l,\"fr-marker\"))d=(d+1)%2;else if(d)if(a(l).find(\".fr-marker\").length>0)d=j(a(l),d,g,h);else{for(var m=a(l).find(g||\"*\"),n=m.length-1;n>=0;n--){var o=m[n];b.node.isBlock(o)||b.node.isVoid(o)||void 0!==g&&!f(o,e(g,h))||(o.outerHTML=o.innerHTML)}void 0===g&&l.nodeType==Node.ELEMENT_NODE&&!b.node.isVoid(l)&&!b.node.isBlock(l)||f(l,e(g,h))?a(l).replaceWith(l.innerHTML):void 0===g&&l.nodeType==Node.ELEMENT_NODE&&b.node.isBlock(l)&&b.node.clearAttributes(l)}else a(l).find(\".fr-marker\").length>0&&(d=j(a(l),d,g,h))}return d}function k(c,d){void 0===d&&(d={}),d.style&&delete d.style;var e=b.selection.isCollapsed();b.selection.save();for(var f=!0;f;){f=!1;for(var g=b.$el.find(\".fr-marker\"),h=0;h<g.length;h++){var k=a(g[h]),l=null;if(k.attr(\"data-cloned\")||e||(l=k.clone().removeClass(\"fr-marker\").addClass(\"fr-clone\"),!0===k.data(\"type\")?k.attr(\"data-cloned\",!0).after(l):k.attr(\"data-cloned\",!0).before(l)),i(k,c,d,e)){f=!0;break}}}j(b.$el,0,c,d),e||(b.$el.find(\".fr-marker\").remove(),b.$el.find(\".fr-clone\").removeClass(\"fr-clone\").addClass(\"fr-marker\")),e&&b.$el.find(\".fr-marker\").before(a.FE.INVISIBLE_SPACE).after(a.FE.INVISIBLE_SPACE),b.html.cleanEmptyTags(),b.el.normalize(),b.selection.restore()}function l(a,b){q(a,b)?k(a,b):h(a,b)}function m(b,c){var d=a(b);d.css(c,\"\"),\"\"===d.attr(\"style\")&&d.replaceWith(d.html())}function n(b,c){return 0===a(b).attr(\"style\").indexOf(c+\":\")||a(b).attr(\"style\").indexOf(\";\"+c+\":\")>=0||a(b).attr(\"style\").indexOf(\"; \"+c+\":\")>=0}function o(c,d){var e,f;if(b.selection.isCollapsed()){b.markers.insert(),f=b.$el.find(\".fr-marker\");var h=f.parent();if(b.node.openTagString(h.get(0))=='<span style=\"'+c+\": \"+h.css(c)+';\">'){if(b.node.isEmpty(h.get(0)))h.replaceWith('<span style=\"'+c+\": \"+d+';\">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+\"</span>\");else{var j={};j[\"style*\"]=c+\":\",i(f,\"span\",j,!0),f=b.$el.find(\".fr-marker\"),d?f.replaceWith('<span style=\"'+c+\": \"+d+';\">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+\"</span>\"):f.replaceWith(a.FE.INVISIBLE_SPACE+a.FE.MARKERS)}b.html.cleanEmptyTags()}else b.node.isEmpty(h.get(0))&&h.is(\"span\")?(f.replaceWith(a.FE.MARKERS),h.css(c,d)):f.replaceWith('<span style=\"'+c+\": \"+d+';\">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+\"</span>\");b.selection.restore()}else{if(b.selection.save(),null==d||\"color\"==c&&b.$el.find(\".fr-marker\").parents(\"u, a\").length>0){var k=b.$el.find(\".fr-marker\");for(e=0;e<k.length;e++)if(f=a(k[e]),!0===f.data(\"type\"))for(;b.node.isFirstSibling(f.get(0))&&!f.parent().is(b.$el)&&!b.node.isElement(f.parent().get(0))&&!b.node.isBlock(f.parent().get(0));)f.parent().before(f);else for(;b.node.isLastSibling(f.get(0))&&!f.parent().is(b.$el)&&!b.node.isElement(f.parent().get(0))&&!b.node.isBlock(f.parent().get(0));)f.parent().after(f)}var l=b.$el.find('.fr-marker[data-type=\"true\"]').get(0).nextSibling,o={class:\"fr-unprocessed\"};for(d&&(o.style=c+\": \"+d+\";\"),g(l,\"span\",o),b.$el.find(\".fr-marker + .fr-unprocessed\").each(function(){a(this).prepend(a(this).prev())}),b.$el.find(\".fr-unprocessed + .fr-marker\").each(function(){a(this).prev().append(this)}),(d||\"\").match(/\\dem$/)&&b.$el.find(\"span.fr-unprocessed\").removeClass(\"fr-unprocessed\");b.$el.find(\"span.fr-unprocessed\").length>0;){var p=b.$el.find(\"span.fr-unprocessed:first\").removeClass(\"fr-unprocessed\");if(p.parent().get(0).normalize(),p.parent().is(\"span\")&&1==p.parent().get(0).childNodes.length){p.parent().css(c,d);var q=p;p=p.parent(),q.replaceWith(q.html())}var r=p.find(\"span\");for(e=r.length-1;e>=0;e--)m(r[e],c);var s=p.parentsUntil(b.$el,\"span[style]\"),t=[];for(e=s.length-1;e>=0;e--)n(s[e],c)||t.push(s[e]);if(s=s.not(t),s.length){var u=\"\",v=\"\",w=\"\",x=\"\",y=p.get(0);do{y=y.parentNode,a(y).addClass(\"fr-split\"),u+=b.node.closeTagString(y),v=b.node.openTagString(a(y).clone().addClass(\"fr-split\").get(0))+v,s.get(0)!=y&&(w+=b.node.closeTagString(y),x=b.node.openTagString(a(y).clone().addClass(\"fr-split\").get(0))+x)}while(s.get(0)!=y);var z=u+b.node.openTagString(a(s.get(0)).clone().css(c,d||\"\").get(0))+x+p.css(c,\"\").get(0).outerHTML+w+\"</span>\"+v;p.replaceWith('<span id=\"fr-break\"></span>');var A=s.get(0).outerHTML;a(s.get(0)).replaceWith(A.replace(/<span id=\"fr-break\"><\\/span>/g,z))}}for(;b.$el.find(\".fr-split:empty\").length>0;)b.$el.find(\".fr-split:empty\").remove();b.$el.find(\".fr-split\").removeClass(\"fr-split\"),b.$el.find('span[style=\"\"]').removeAttr(\"style\"),b.$el.find('span[class=\"\"]').removeAttr(\"class\"),b.html.cleanEmptyTags(),a(b.$el.find(\"span\").get().reverse()).each(function(){this.attributes&&0!==this.attributes.length||a(this).replaceWith(this.innerHTML)}),b.el.normalize();var B=b.$el.find(\"span[style] + span[style]\");for(e=0;e<B.length;e++){var C=a(B[e]),D=a(B[e]).prev();C.get(0).previousSibling==D.get(0)&&b.node.openTagString(C.get(0))==b.node.openTagString(D.get(0))&&(C.prepend(D.html()),D.remove())}b.$el.find(\"span[style] span[style]\").each(function(){if(a(this).attr(\"style\").indexOf(\"font-size\")>=0){var b=a(this).parents(\"span[style]\");b.attr(\"style\").indexOf(\"background-color\")>=0&&(a(this).attr(\"style\",a(this).attr(\"style\")+\";\"+b.attr(\"style\")),i(a(this),\"span[style]\",{},!1))}}),b.el.normalize(),b.selection.restore()}}function p(a){o(a,null)}function q(a,c){void 0===c&&(c={}),c.style&&delete c.style;var d=b.selection.ranges(0),g=d.startContainer;if(g.nodeType==Node.ELEMENT_NODE&&g.childNodes.length>0&&g.childNodes[d.startOffset]&&(g=g.childNodes[d.startOffset]),!d.collapsed&&g.nodeType==Node.TEXT_NODE&&d.startOffset==(g.textContent||\"\").length){\nfor(;!b.node.isBlock(g.parentNode)&&!g.nextSibling;)g=g.parentNode;g.nextSibling&&(g=g.nextSibling)}for(var h=g;h&&h.nodeType==Node.ELEMENT_NODE&&!f(h,e(a,c));)h=h.firstChild;if(h&&h.nodeType==Node.ELEMENT_NODE&&f(h,e(a,c)))return!0;var i=g;for(i&&i.nodeType!=Node.ELEMENT_NODE&&(i=i.parentNode);i&&i.nodeType==Node.ELEMENT_NODE&&i!=b.el&&!f(i,e(a,c));)i=i.parentNode;return!(!i||i.nodeType!=Node.ELEMENT_NODE||i==b.el||!f(i,e(a,c)))}return{is:q,toggle:l,apply:h,remove:k,applyStyle:o,removeStyle:p}},a.extend(a.FE.DEFAULTS,{indentMargin:20}),a.FE.COMMANDS={bold:{title:\"Bold\",toggle:!0,refresh:function(a){var b=this.format.is(\"strong\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},italic:{title:\"Italic\",toggle:!0,refresh:function(a){var b=this.format.is(\"em\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},underline:{title:\"Underline\",toggle:!0,refresh:function(a){var b=this.format.is(\"u\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},strikeThrough:{title:\"Strikethrough\",toggle:!0,refresh:function(a){var b=this.format.is(\"s\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},subscript:{title:\"Subscript\",toggle:!0,refresh:function(a){var b=this.format.is(\"sub\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},superscript:{title:\"Superscript\",toggle:!0,refresh:function(a){var b=this.format.is(\"sup\");a.toggleClass(\"fr-active\",b).attr(\"aria-pressed\",b)}},outdent:{title:\"Decrease Indent\"},indent:{title:\"Increase Indent\"},undo:{title:\"Undo\",undo:!1,forcedRefresh:!0,disabled:!0},redo:{title:\"Redo\",undo:!1,forcedRefresh:!0,disabled:!0},insertHR:{title:\"Insert Horizontal Line\"},clearFormatting:{title:\"Clear Formatting\"},selectAll:{title:\"Select All\",undo:!1}},a.FE.RegisterCommand=function(b,c){a.FE.COMMANDS[b]=c},a.FE.MODULES.commands=function(b){function c(a){return b.html.defaultTag()&&(a=\"<\"+b.html.defaultTag()+\">\"+a+\"</\"+b.html.defaultTag()+\">\"),a}function d(c,d){if(!1!==b.events.trigger(\"commands.before\",a.merge([c],d||[]))){var e=a.FE.COMMANDS[c]&&a.FE.COMMANDS[c].callback||i[c],f=!0,g=!1;a.FE.COMMANDS[c]&&(void 0!==a.FE.COMMANDS[c].focus&&(f=a.FE.COMMANDS[c].focus),void 0!==a.FE.COMMANDS[c].accessibilityFocus&&(g=a.FE.COMMANDS[c].accessibilityFocus)),(!b.core.hasFocus()&&f&&!b.popups.areVisible()||!b.core.hasFocus()&&g&&b.accessibility.hasFocus())&&b.events.focus(!0),a.FE.COMMANDS[c]&&!1!==a.FE.COMMANDS[c].undo&&(b.$el.find(\".fr-marker\").length&&(b.events.disableBlur(),b.selection.restore()),b.undo.saveStep()),e&&e.apply(b,a.merge([c],d||[])),b.events.trigger(\"commands.after\",a.merge([c],d||[])),a.FE.COMMANDS[c]&&!1!==a.FE.COMMANDS[c].undo&&b.undo.saveStep()}}function e(a,c){b.format.toggle(c)}function f(c){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var d=b.selection.blocks(),e=0;e<d.length;e++)if(\"LI\"!=d[e].tagName&&\"LI\"!=d[e].parentNode.tagName){var f=a(d[e]),g=\"rtl\"==b.opts.direction||\"rtl\"==f.css(\"direction\")?\"margin-right\":\"margin-left\",h=b.helpers.getPX(f.css(g));f.css(g,Math.max(h+c*b.opts.indentMargin,0)||\"\"),f.removeClass(\"fr-temp-div\")}b.selection.save(),b.html.unwrap(),b.selection.restore()}function g(a){return function(){d(a)}}function h(){b.events.on(\"keydown\",function(a){var c=b.selection.element();if(c&&\"HR\"==c.tagName&&!b.keys.isArrow(a.which))return a.preventDefault(),!1}),b.events.on(\"keyup\",function(c){var d=b.selection.element();if(d&&\"HR\"==d.tagName)if(c.which==a.FE.KEYCODE.ARROW_LEFT||c.which==a.FE.KEYCODE.ARROW_UP){if(d.previousSibling)return b.node.isBlock(d.previousSibling)?b.selection.setAtEnd(d.previousSibling):a(d).before(a.FE.MARKERS),b.selection.restore(),!1}else if((c.which==a.FE.KEYCODE.ARROW_RIGHT||c.which==a.FE.KEYCODE.ARROW_DOWN)&&d.nextSibling)return b.node.isBlock(d.nextSibling)?b.selection.setAtStart(d.nextSibling):a(d).after(a.FE.MARKERS),b.selection.restore(),!1}),b.events.on(\"mousedown\",function(a){if(a.target&&\"HR\"==a.target.tagName)return a.preventDefault(),a.stopPropagation(),!1}),b.events.on(\"mouseup\",function(){var c=b.selection.element();c==b.selection.endElement()&&c&&\"HR\"==c.tagName&&(c.nextSibling&&(b.node.isBlock(c.nextSibling)?b.selection.setAtStart(c.nextSibling):a(c).after(a.FE.MARKERS)),b.selection.restore())})}var i={bold:function(){e(\"bold\",\"strong\")},subscript:function(){b.format.is(\"sup\")&&b.format.remove(\"sup\"),e(\"subscript\",\"sub\")},superscript:function(){b.format.is(\"sub\")&&b.format.remove(\"sub\"),e(\"superscript\",\"sup\")},italic:function(){e(\"italic\",\"em\")},strikeThrough:function(){e(\"strikeThrough\",\"s\")},underline:function(){e(\"underline\",\"u\")},undo:function(){b.undo.run()},redo:function(){b.undo.redo()},indent:function(){f(1)},outdent:function(){f(-1)},show:function(){b.opts.toolbarInline&&b.toolbar.showInline(null,!0)},insertHR:function(){b.selection.remove();var d=\"\";b.core.isEmpty()&&(d=\"<br>\",d=c(d)),b.html.insert('<hr id=\"fr-just\">'+d);var e=b.$el.find(\"hr#fr-just\");e.removeAttr(\"id\");var f;if(0===e.next().length){var g=b.html.defaultTag();g?e.after(a(\"<\"+g+\">\").append(\"<br>\")):e.after(\"<br>\")}e.prev().is(\"hr\")?f=b.selection.setAfter(e.get(0),!1):e.next().is(\"hr\")?f=b.selection.setBefore(e.get(0),!1):b.selection.setAfter(e.get(0),!1)||b.selection.setBefore(e.get(0),!1),f||void 0===f||(d=a.FE.MARKERS+\"<br>\",d=c(d),e.after(d)),b.selection.restore()},clearFormatting:function(){b.format.remove()},selectAll:function(){b.doc.execCommand(\"selectAll\",!1,!1)}},j={};for(var k in i)i.hasOwnProperty(k)&&(j[k]=g(k));return a.extend(j,{exec:d,_init:h})},a.FE.MODULES.data=function(a){function b(a){return a}function c(a){if(!a)return a;for(var c=\"\",f=b(\"charCodeAt\"),g=b(\"fromCharCode\"),h=l.indexOf(a[0]),i=1;i<a.length-2;i++){for(var j=d(++h),k=a[f](i),m=\"\";/[0-9-]/.test(a[i+1]);)m+=a[++i];m=parseInt(m,10)||0,k=e(k,j,m),k^=h-1&31,c+=String[g](k)}return c}function d(a){for(var b=a.toString(),c=0,d=0;d<b.length;d++)c+=parseInt(b.charAt(d),10);return c>10?c%9+1:c}function e(a,b,c){for(var d=Math.abs(c);d-- >0;)a-=b;return c<0&&(a+=123),a}function f(a){return!(!a||\"block\"===a.css(\"display\")||(a.remove(),0))}function g(){return f(j)||f(k)}function h(){if(o>10&&a.destroy(),!a.$box)return!1;a.$wp.prepend(n(b(n(\"NCKB1zwtPA9tqzajXC2c2A7B-16VD3spzJ1C9C3D5oOF2OB1NB1LD7VA5QF4TE3gytXB2A4C-8VA2AC4E1D3GB2EB2KC3KD1MF1juuSB1A8C6yfbmd1B2a1A5qdsdB2tivbC3CB1KC1CH1eLA2sTF1B4I4H-7B-21UB6b1F5bzzzyAB4JC3MG2hjdKC1JE6C1E1cj1pD-16pUE5B4prra2B5ZB3D3C3pxj1EA6A3rnJA2C-7I-7JD9D1E1wYH1F3sTB5TA2G4H4ZA22qZA5BB3mjcvcCC3JB1xillavC-21VE6PC5SI4YC5C8mb1A3WC3BD2B5aoDA2qqAE3A5D-17fOD1D5RD4WC10tE6OAZC3nF-7b1C4A4D3qCF2fgmapcromlHA2QA6a1E1D3e1A6C2bie2F4iddnIA7B2mvnwcIB5OA1DB2OLQA3PB10WC7WC5d1E3uI-7b1D5D6b1E4D2arlAA4EA1F-11srxI-7MB1D7PF1E5B4adB-21YD5vrZH3D3xAC4E1A2GF2CF2J-7yNC2JE1MI2hH-7QB1C6B5B-9bA-7XB13a1B5VievwpKB4LA3NF-10H-9I-8hhaC-16nqPG4wsleTD5zqYF3h1G2B7B4yvGE2Pi1H-7C-21OE6B1uLD1kI4WC1E7C5g1D-8fue1C8C6c1D4D3Hpi1CC4kvGC2E1legallyXB4axVA11rsA4A-9nkdtlmzBA2GD3A13A6CB1dabE1lezrUE6RD5TB4A-7f1C8c1B5d1D4D3tyfCD5C2D2==\")))),j=a.$wp.find(\"> div:first\"),k=j.find(\"> a\"),\"rtl\"==a.opts.direction&&j.css(\"left\",\"auto\").css(\"right\",0).setAttribute(\"direction\",\"rtl\"),o++}function i(){var c=a.o_win.FEK;try{c=c||localStorage&&localStorage.FEK}catch(k){}c=c||a.opts.key||[\"\"];var d=n(b(\"ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9==\"));\"string\"==typeof c&&(c=[c]),a.ul=!0;for(var e=0;e<c.length;e++){var f=n(c[e])||\"\";if(!(f!==n(b(n(\"mcVRDoB1BGILD7YFe1BTXBA7B6==\")))&&f.indexOf(m,f.length-m.length)<0&&[n(\"9qqG-7amjlwq==\"),n(\"KA3B3C2A6D1D5H5H1A3==\"),n(\"QzbzvxyB2yA-9m==\"),n(\"ji1kacwmgG5bc==\"),n(\"naamngiA3dA-16xtE-11C-9B1H-8sc==\")].indexOf(m)<0)){a.ul=!1;break}}var i=new Image;!0===a.ul&&(h(),i.src=b(n(d))+\"u\"),a.events.on(\"contentChanged\",function(){!0===a.ul&&g()&&h()}),a.events.on(\"destroy\",function(){j&&j.length&&j.remove()},!0)}var j,k,l=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\",m=function(){for(var a=0,b=document.domain,c=b.split(\".\"),d=\"_gd\"+(new Date).getTime();a<c.length-1&&-1==document.cookie.indexOf(d+\"=\"+d);)b=c.slice(-1-++a).join(\".\"),document.cookie=d+\"=\"+d+\";domain=\"+b+\";\";return document.cookie=d+\"=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=\"+b+\";\",(b||\"\").replace(/(^\\.*)|(\\.*$)/g,\"\")}(),n=b(c),o=0;return{_init:i}},a.extend(a.FE.DEFAULTS,{pastePlain:!1,pasteDeniedTags:[\"colgroup\",\"col\",\"meta\"],pasteDeniedAttrs:[\"class\",\"id\",\"style\"],pasteAllowedStyleProps:[],pasteAllowLocalImages:!1}),a.FE.COPIED_TOKEN='<span data-copied-from-froala-editor=\"true\"></span>',a.FE.MODULES.paste=function(b){function c(b,c,d){b&&b.clipboardData&&b.clipboardData.setData&&(b.clipboardData.setData(\"text/html\",c+a.FE.COPIED_TOKEN),b.clipboardData.setData(\"text/plain\",d),b.preventDefault())}function d(d){var e=b.html.getSelected();c(d,e,a(\"<div>\").html(e).text()),\"cut\"==d.type&&(b.undo.saveStep(),setTimeout(function(){b.selection.save(),b.html.wrap(),b.selection.restore(),b.events.focus(),b.undo.saveStep()},0))}function e(a){if(w)return!1;if(a.originalEvent&&(a=a.originalEvent),!1===b.events.trigger(\"paste.before\",[a]))return a.preventDefault(),!1;if(r=b.$win.scrollTop(),a&&a.clipboardData&&a.clipboardData.getData){var c=\"\",d=a.clipboardData.types;if(b.helpers.isArray(d))for(var e=0;e<d.length;e++)c+=d[e]+\";\";else c=d;if(/text\\/rtf/.test(c)&&(t=a.clipboardData.getData(\"text/rtf\")),/text\\/html/.test(c)?s=a.clipboardData.getData(\"text/html\"):/text\\/rtf/.test(c)&&b.browser.safari?s=t:/text\\/plain/.test(c)&&!b.browser.mozilla&&(s=b.html.escapeEntities(a.clipboardData.getData(\"text/plain\")).replace(/\\n/g,\"<br>\")),\"\"!==s)return j(),a.preventDefault&&(a.stopPropagation(),a.preventDefault()),!1;s=null}return g(),!1}function f(c){if(c.originalEvent&&(c=c.originalEvent),c&&c.dataTransfer&&c.dataTransfer.getData){var d=\"\",e=c.dataTransfer.types;if(b.helpers.isArray(e))for(var f=0;f<e.length;f++)d+=e[f]+\";\";else d=e;if(s=\"\",/text\\/rtf/.test(d)&&(t=c.dataTransfer.getData(\"text/rtf\")),/text\\/html/.test(d)?s=c.dataTransfer.getData(\"text/html\"):/text\\/rtf/.test(d)&&b.browser.safari?s=t:/text\\/plain/.test(d)&&!this.browser.mozilla&&(s=b.html.escapeEntities(c.dataTransfer.getData(\"text/plain\")).replace(/\\n/g,\"<br>\")),\"\"!==s){b.keys.forceUndo(),v=b.snapshot.get(),b.selection.remove();if(!1!==b.markers.insertAtPoint(c)){var g=b.el.querySelector(\".fr-marker\");return a(g).replaceWith(a.FE.MARKERS),j(),c.preventDefault&&(c.stopPropagation(),c.preventDefault()),!1}}else s=null}}function g(){b.selection.save(),b.events.disableBlur(),s=null,u?(u.html(\"\"),b.browser.edge&&b.opts.iframe&&b.$el.append(u)):(u=a('<div contenteditable=\"true\" style=\"position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%;\" tabIndex=\"-1\"></div>'),b.browser.safari?(u.css(\"top\",b.$sc.scrollTop()),b.$el.after(u)):b.browser.edge&&b.opts.iframe?b.$el.append(u):b.$box.after(u),b.events.on(\"destroy\",function(){u.remove()})),u.focus(),b.win.setTimeout(j,1)}function h(a){var c;a=a.replace(/<p(.*?)class=\"?'?MsoListParagraph\"?'? ([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<ul><li>$3</li></ul>\"),a=a.replace(/<p(.*?)class=\"?'?NumberedText\"?'? ([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<ol><li>$3</li></ol>\"),a=a.replace(/<p(.*?)class=\"?'?MsoListParagraphCxSpFirst\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<ul><li$3>$5</li>\"),a=a.replace(/<p(.*?)class=\"?'?NumberedTextCxSpFirst\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<ol><li$3>$5</li>\"),a=a.replace(/<p(.*?)class=\"?'?MsoListParagraphCxSpMiddle\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<li$3>$5</li>\"),a=a.replace(/<p(.*?)class=\"?'?NumberedTextCxSpMiddle\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<li$3>$5</li>\"),a=a.replace(/<p(.*?)class=\"?'?MsoListBullet\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<li$3>$5</li>\"),a=a.replace(/<p(.*?)class=\"?'?MsoListParagraphCxSpLast\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<li$3>$5</li></ul>\"),a=a.replace(/<p(.*?)class=\"?'?NumberedTextCxSpLast\"?'?([\\s\\S]*?)(level\\d)?([\\s\\S]*?)>([\\s\\S]*?)<\\/p>/gi,\"<li$3>$5</li></ol>\"),a=a.replace(/<span([^<]*?)style=\"?'?mso-list:Ignore\"?'?([\\s\\S]*?)>([\\s\\S]*?)<span/gi,\"<span><span\"),a=a.replace(/<!--\\[if \\!supportLists\\]-->([\\s\\S]*?)<!--\\[endif\\]-->/gi,\"\"),a=a.replace(/<!\\[if \\!supportLists\\]>([\\s\\S]*?)<!\\[endif\\]>/gi,\"\"),a=a.replace(/(\\n|\\r| class=(\")?Mso[a-zA-Z0-9]+(\")?)/gi,\" \"),a=a.replace(/<!--[\\s\\S]*?-->/gi,\"\"),a=a.replace(/<(\\/)*(meta|link|span|\\\\?xml:|st1:|o:|font)(.*?)>/gi,\"\");var d=[\"style\",\"script\",\"applet\",\"embed\",\"noframes\",\"noscript\"];for(c=0;c<d.length;c++){var e=new RegExp(\"<\"+d[c]+\".*?\"+d[c]+\"(.*?)>\",\"gi\");a=a.replace(e,\"\")}a=a.replace(/&nbsp;/gi,\" \"),a=a.replace(/<td([^>]*)><\\/td>/g,\"<td$1><br></td>\"),a=a.replace(/<th([^>]*)><\\/th>/g,\"<th$1><br></th>\");var f;do{f=a,a=a.replace(/<[^\\/>][^>]*><\\/[^>]+>/gi,\"\")}while(a!=f);a=a.replace(/<lilevel([^1])([^>]*)>/gi,'<li data-indent=\"true\"$2>'),a=a.replace(/<lilevel1([^>]*)>/gi,\"<li$1>\"),a=b.clean.html(a,b.opts.pasteDeniedTags,b.opts.pasteDeniedAttrs),a=a.replace(/<a>(.[^<]+)<\\/a>/gi,\"$1\"),a=a.replace(/<br> */g,\"<br>\");var g=b.o_doc.createElement(\"div\");g.innerHTML=a;var h=g.querySelectorAll(\"li[data-indent]\");for(c=0;c<h.length;c++){var i=h[c],j=i.previousElementSibling;if(j&&\"LI\"==j.tagName){var k=j.querySelector(\":scope > ul, :scope > ol\");k||(k=document.createElement(\"ul\"),j.appendChild(k)),k.appendChild(i)}else i.removeAttribute(\"data-indent\")}return b.html.cleanBlankSpaces(g),a=g.innerHTML}function i(a){var c,d=null,e=b.doc.createElement(\"div\");e.innerHTML=a;var f=e.querySelectorAll(\"p, div, h1, h2, h3, h4, h5, h6, pre, blockquote\");for(c=0;c<f.length;c++)d=f[c],d.outerHTML=\"<\"+(b.html.defaultTag()||\"DIV\")+\">\"+d.innerHTML+\"</\"+(b.html.defaultTag()||\"DIV\")+\">\";for(f=e.querySelectorAll(\"*:not(\"+\"p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img\".split(\",\").join(\"):not(\")+\")\"),c=f.length-1;c>=0;c--)d=f[c],d.outerHTML=d.innerHTML;var g=function(a){for(var c=b.node.contents(a),d=0;d<c.length;d++)c[d].nodeType!=Node.TEXT_NODE&&c[d].nodeType!=Node.ELEMENT_NODE?c[d].parentNode.removeChild(c[d]):g(c[d])};return g(e),e.innerHTML}function j(){b.browser.edge&&b.opts.iframe&&b.$box.after(u),v||(b.keys.forceUndo(),v=b.snapshot.get()),null===s&&(s=u.get(0).innerHTML,b.selection.restore(),b.events.enableBlur());var a=s.match(/(class=\\\"?Mso|class=\\'?Mso|class=\"?Xl|class='?Xl|class=Xl|style=\\\"[^\\\"]*\\bmso\\-|style=\\'[^\\']*\\bmso\\-|w:WordDocument)/gi),c=b.events.chainTrigger(\"paste.beforeCleanup\",s);c&&\"string\"==typeof c&&(s=c),(!a||a&&!1!==b.events.trigger(\"paste.wordPaste\",[s]))&&l(s,a)}function k(b){return!!b.match(new RegExp(a.FE.COPIED_TOKEN))}function l(c,d,e){var f,g=null,j=null;c.toLowerCase().indexOf(\"<body\")>=0&&(c=c.replace(/[.\\s\\S\\w\\W<>]*<body[^>]*>[\\s]*([.\\s\\S\\w\\W<>]*)[\\s]*<\\/body>[.\\s\\S\\w\\W<>]*/gi,\"$1\"),c=c.replace(/ \\n/g,\" \").replace(/\\n /g,\" \").replace(/([^>])\\n([^<])/g,\"$1 $2\"));var l=!1;if(c.indexOf('id=\"docs-internal-guid')>=0&&(c=c.replace(/^[\\w\\W\\s\\S]* id=\"docs-internal-guid[^>]*>([\\w\\W\\s\\S]*)<\\/b>[\\w\\W\\s\\S]*$/g,\"$1\"),l=!0),!d){var n=k(c);if(n&&(c=c.replace(new RegExp(a.FE.COPIED_TOKEN),\"\"),c=c.replace(/<meta charset='utf-8'>/g,\"\").replace(/<!--StartFragment-->/g,\"\").replace(/<!--EndFragment-->/g,\"\"),c=c.replace(/^(\\r|\\n|\\t)*/g,\"\").replace(/(\\r|\\n|\\t)*$/g,\"\")),!n){var p=b.opts.htmlAllowedStyleProps;b.opts.htmlAllowedStyleProps=b.opts.pasteAllowedStyleProps,b.opts.htmlAllowComments=!1,c=b.clean.html(c,b.opts.pasteDeniedTags,b.opts.pasteDeniedAttrs),b.opts.htmlAllowedStyleProps=p,b.opts.htmlAllowComments=!0,c=o(c),c=c.replace(/\\r|\\n|\\t/g,\"\"),c=c.replace(/^ */g,\"\").replace(/ *$/g,\"\")}}!d||b.wordPaste&&e||(c=c.replace(/^\\n*/g,\"\").replace(/^ /g,\"\"),0===c.indexOf(\"<colgroup>\")&&(c=\"<table>\"+c+\"</table>\"),c=h(c),c=o(c)),b.opts.pastePlain&&(c=i(c));var q=b.events.chainTrigger(\"paste.afterCleanup\",c);if(\"string\"==typeof q&&(c=q),\"\"!==c){var r=b.o_doc.createElement(\"div\");r.innerHTML=c,b.spaces.normalize(r);var s=r.getElementsByTagName(\"span\");for(f=s.length-1;f>=0;f--){var t=s[f];0===t.attributes.length&&(t.outerHTML=t.innerHTML)}var u=b.selection.element(),w=!1;if(u&&a(u).parentsUntil(b.el,\"ul, ol\").length&&(w=!0),w){var x=r.children;1==x.length&&[\"OL\",\"UL\"].indexOf(x[0].tagName)>=0&&(x[0].outerHTML=x[0].innerHTML)}if(!l){var y=r.getElementsByTagName(\"br\");for(f=y.length-1;f>=0;f--){var z=y[f];b.node.isBlock(z.previousSibling)&&z.parentNode.removeChild(z)}}if(b.opts.enter==a.FE.ENTER_BR)for(g=r.querySelectorAll(\"p, div\"),f=g.length-1;f>=0;f--)j=g[f],0===j.attributes.length&&(j.outerHTML=j.innerHTML+(j.nextSibling&&!b.node.isEmpty(j)?\"<br>\":\"\"));else if(b.opts.enter==a.FE.ENTER_DIV)for(g=r.getElementsByTagName(\"p\"),f=g.length-1;f>=0;f--)j=g[f],j.outerHTML=\"<div>\"+j.innerHTML+\"</div>\";else b.opts.enter==a.FE.ENTER_P&&1==r.childNodes.length&&\"P\"==r.childNodes[0].tagName&&(r.childNodes[0].outerHTML=r.childNodes[0].innerHTML);c=r.innerHTML,b.html.insert(c,!0)}m(),b.undo.saveStep(v),v=null,b.undo.saveStep()}function m(){b.events.trigger(\"paste.after\")}function n(){return t}function o(c){var d,e=b.o_doc.createElement(\"div\");e.innerHTML=c;for(var f=e.querySelectorAll(\"*:empty:not(td):not(th):not(iframe):not(svg):not(\"+a.FE.VOID_ELEMENTS.join(\"):not(\")+\")\");f.length;){for(d=0;d<f.length;d++)f[d].parentNode.removeChild(f[d]);f=e.querySelectorAll(\"*:empty:not(td):not(th):not(iframe):not(svg):not(\"+a.FE.VOID_ELEMENTS.join(\"):not(\")+\")\")}for(var g=e.querySelectorAll(\":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])\");g.length;){var h=g[g.length-1];if(b.html.defaultTag()&&\"div\"!=b.html.defaultTag())h.querySelector(b.html.blockTagsQuery())?h.outerHTML=h.innerHTML:h.outerHTML=\"<\"+b.html.defaultTag()+\">\"+h.innerHTML+\"</\"+b.html.defaultTag()+\">\";else{var i=h.querySelectorAll(\"*\");!i.length||\"BR\"!==i[i.length-1].tagName&&0===h.innerText.length?h.outerHTML=h.innerHTML+\"<br>\":h.outerHTML=h.innerHTML}g=e.querySelectorAll(\":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])\")}for(g=e.querySelectorAll(\"div:not([style])\");g.length;){for(d=0;d<g.length;d++){var j=g[d],k=j.innerHTML.replace(/\\u0009/gi,\"\").trim();j.outerHTML=k}g=e.querySelectorAll(\"div:not([style])\")}return e.innerHTML}function p(){b.el.addEventListener(\"copy\",d),b.el.addEventListener(\"cut\",d),b.el.addEventListener(\"paste\",e,{capture:!0}),b.events.on(\"drop\",f),b.browser.msie&&b.browser.version<11&&(b.events.on(\"mouseup\",function(a){2==a.button&&(setTimeout(function(){w=!1},50),w=!0)},!0),b.events.on(\"beforepaste\",e)),b.events.on(\"destroy\",q)}function q(){b.el.removeEventListener(\"copy\",d),b.el.removeEventListener(\"cut\",d),b.el.removeEventListener(\"paste\",e)}var r,s,t,u,v,w=!1;return{_init:p,removeEmptyTags:o,getRtfClipboard:n,saveCopiedText:c,clean:l}},a.extend(a.FE.DEFAULTS,{shortcutsEnabled:[],shortcutsHint:!0}),a.FE.SHORTCUTS_MAP={},a.FE.RegisterShortcut=function(b,c,d,e,f,g){a.FE.SHORTCUTS_MAP[(f?\"^\":\"\")+(g?\"@\":\"\")+b]={cmd:c,val:d,letter:e,shift:f,option:g},a.FE.DEFAULTS.shortcutsEnabled.push(c)},a.FE.RegisterShortcut(a.FE.KEYCODE.E,\"show\",null,\"E\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.B,\"bold\",null,\"B\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.I,\"italic\",null,\"I\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.U,\"underline\",null,\"U\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.S,\"strikeThrough\",null,\"S\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.CLOSE_SQUARE_BRACKET,\"indent\",null,\"]\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.OPEN_SQUARE_BRACKET,\"outdent\",null,\"[\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.Z,\"undo\",null,\"Z\",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.Z,\"redo\",null,\"Z\",!0,!1),a.FE.MODULES.shortcuts=function(b){function c(c){if(!b.opts.shortcutsHint)return null;if(!f){f={};for(var d in a.FE.SHORTCUTS_MAP)a.FE.SHORTCUTS_MAP.hasOwnProperty(d)&&b.opts.shortcutsEnabled.indexOf(a.FE.SHORTCUTS_MAP[d].cmd)>=0&&(f[a.FE.SHORTCUTS_MAP[d].cmd+\".\"+(a.FE.SHORTCUTS_MAP[d].val||\"\")]={shift:a.FE.SHORTCUTS_MAP[d].shift,option:a.FE.SHORTCUTS_MAP[d].option,letter:a.FE.SHORTCUTS_MAP[d].letter})}var e=f[c];return e?(b.helpers.isMac()?String.fromCharCode(8984):\"Ctrl+\")+(e.shift?b.helpers.isMac()?String.fromCharCode(8679):\"Shift+\":\"\")+(e.option?b.helpers.isMac()?String.fromCharCode(8997):\"Alt+\":\"\")+e.letter:null}function d(c){if(!b.core.hasFocus())return!0;var d=c.which,e=-1!=navigator.userAgent.indexOf(\"Mac OS X\")?c.metaKey:c.ctrlKey;if(\"keyup\"==c.type&&g&&d!=a.FE.KEYCODE.META)return g=!1,!1;\"keydown\"==c.type&&(g=!1);var f=(c.shiftKey?\"^\":\"\")+(c.altKey?\"@\":\"\")+d;if(e&&a.FE.SHORTCUTS_MAP[f]){var h=a.FE.SHORTCUTS_MAP[f].cmd;if(h&&b.opts.shortcutsEnabled.indexOf(h)>=0){var i,j=a.FE.SHORTCUTS_MAP[f].val;if(h&&!j?i=b.$tb.find('.fr-command[data-cmd=\"'+h+'\"]'):h&&j&&(i=b.$tb.find('.fr-command[data-cmd=\"'+h+'\"][data-param1=\"'+j+'\"]')),i.length)return c.preventDefault(),c.stopPropagation(),i.parents(\".fr-toolbar\").data(\"instance\",b),\"keydown\"==c.type&&(b.button.exec(i),g=!0),!1;if(h&&b.commands[h])return c.preventDefault(),c.stopPropagation(),\"keydown\"==c.type&&(b.commands[h](),g=!0),!1}}}function e(){b.events.on(\"keydown\",d,!0),b.events.on(\"keyup\",d,!0)}var f=null,g=!1;return{_init:e,get:c}},a.FE.MODULES.snapshot=function(a){function b(a){for(var b=a.parentNode.childNodes,c=0,d=null,e=0;e<b.length;e++){if(d){var f=b[e].nodeType===Node.TEXT_NODE&&\"\"===b[e].textContent,g=d.nodeType===Node.TEXT_NODE&&b[e].nodeType===Node.TEXT_NODE;f||g||c++}if(b[e]==a)return c;d=b[e]}}function c(c){var d=[];if(!c.parentNode)return[];for(;!a.node.isElement(c);)d.push(b(c)),c=c.parentNode;return d.reverse()}function d(a,b){for(;a&&a.nodeType===Node.TEXT_NODE;){var c=a.previousSibling;c&&c.nodeType==Node.TEXT_NODE&&(b+=c.textContent.length),a=c}return b}function e(a){return{scLoc:c(a.startContainer),scOffset:d(a.startContainer,a.startOffset),ecLoc:c(a.endContainer),ecOffset:d(a.endContainer,a.endOffset)}}function f(){var b={};if(a.events.trigger(\"snapshot.before\"),b.html=(a.$wp?a.$el.html():a.$oel.get(0).outerHTML).replace(/ style=\"\"/g,\"\"),b.ranges=[],a.$wp&&a.selection.inEditor()&&a.core.hasFocus())for(var c=a.selection.ranges(),d=0;d<c.length;d++)b.ranges.push(e(c[d]));return a.events.trigger(\"snapshot.after\",[b]),b}function g(b){for(var c=a.el,d=0;d<b.length;d++)c=c.childNodes[b[d]];return c}function h(b,c){try{var d=g(c.scLoc),e=c.scOffset,f=g(c.ecLoc),h=c.ecOffset,i=a.doc.createRange();i.setStart(d,e),i.setEnd(f,h),b.addRange(i)}catch(j){}}function i(b){a.$el.html()!=b.html&&(a.opts.htmlExecuteScripts?a.$el.html(b.html):a.el.innerHTML=b.html);var c=a.selection.get();a.selection.clear(),a.events.focus(!0);for(var d=0;d<b.ranges.length;d++)h(c,b.ranges[d])}function j(b,c){return b.html==c.html&&(!a.core.hasFocus()||JSON.stringify(b.ranges)==JSON.stringify(c.ranges))}return{get:f,restore:i,equal:j}},a.FE.MODULES.undo=function(a){function b(b){var c=b.which;a.keys.ctrlKey(b)&&(90==c&&b.shiftKey&&b.preventDefault(),90==c&&b.preventDefault())}function c(){return!(0===a.undo_stack.length||a.undo_index<=1)}function d(){return a.undo_index!=a.undo_stack.length}function e(b){if(!a.undo_stack||a.undoing||a.el.querySelector(\".fr-marker\"))return!1;void 0===b?(b=a.snapshot.get(),a.undo_stack[a.undo_index-1]&&a.snapshot.equal(a.undo_stack[a.undo_index-1],b)||(f(),a.undo_stack.push(b),a.undo_index++,b.html!=l&&(a.events.trigger(\"contentChanged\"),l=b.html))):(f(),a.undo_index>0?a.undo_stack[a.undo_index-1]=b:(a.undo_stack.push(b),a.undo_index++))}function f(){if(!a.undo_stack||a.undoing)return!1;for(;a.undo_stack.length>a.undo_index;)a.undo_stack.pop()}function g(){if(a.undo_index>1){a.undoing=!0;var b=a.undo_stack[--a.undo_index-1];clearTimeout(a._content_changed_timer),a.snapshot.restore(b),l=b.html,a.popups.hideAll(),a.toolbar.enable(),a.events.trigger(\"contentChanged\"),a.events.trigger(\"commands.undo\"),a.undoing=!1}}function h(){if(a.undo_index<a.undo_stack.length){a.undoing=!0;var b=a.undo_stack[a.undo_index++];clearTimeout(a._content_changed_timer),a.snapshot.restore(b),l=b.html,a.popups.hideAll(),a.toolbar.enable(),a.events.trigger(\"contentChanged\"),a.events.trigger(\"commands.redo\"),a.undoing=!1}}function i(){a.undo_index=0,a.undo_stack=[]}function j(){a.undo_stack=[]}function k(){i(),a.events.on(\"initialized\",function(){l=(a.$wp?a.$el.html():a.$oel.get(0).outerHTML).replace(/ style=\"\"/g,\"\")}),a.events.on(\"blur\",function(){a.el.querySelector(\".fr-dragging\")||a.undo.saveStep()}),a.events.on(\"keydown\",b),a.events.on(\"destroy\",j)}var l=null;return{_init:k,run:g,redo:h,canDo:c,canRedo:d,dropRedo:f,reset:i,saveStep:e}},a.FE.ICON_DEFAULT_TEMPLATE=\"font_awesome\",a.FE.ICON_TEMPLATES={font_awesome:'<i class=\"fa fa-[NAME]\" aria-hidden=\"true\"></i>',text:'<span style=\"text-align: center;\">[NAME]</span>',image:\"<img src=[SRC] alt=[ALT] />\",svg:'<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">[PATH]</svg>'},a.FE.ICONS={bold:{NAME:\"bold\"},italic:{NAME:\"italic\"},underline:{NAME:\"underline\"},strikeThrough:{NAME:\"strikethrough\"},subscript:{NAME:\"subscript\"},superscript:{NAME:\"superscript\"},color:{NAME:\"tint\"},outdent:{NAME:\"outdent\"},indent:{NAME:\"indent\"},undo:{NAME:\"rotate-left\"},redo:{NAME:\"rotate-right\"},insertHR:{NAME:\"minus\"},clearFormatting:{NAME:\"eraser\"},selectAll:{NAME:\"mouse-pointer\"}},a.FE.DefineIconTemplate=function(b,c){a.FE.ICON_TEMPLATES[b]=c},a.FE.DefineIcon=function(b,c){a.FE.ICONS[b]=c},a.FE.MODULES.icon=function(){function b(b){var c=null,d=a.FE.ICONS[b];if(void 0!==d){var e=d.template||a.FE.ICON_DEFAULT_TEMPLATE;e&&(e=a.FE.ICON_TEMPLATES[e])&&(c=e.replace(/\\[([a-zA-Z]*)\\]/g,function(a,c){return\"NAME\"==c?d[c]||b:d[c]}))}return c||b}function c(b){var c=a.FE.ICONS[b],d=a.FE.ICON_DEFAULT_TEMPLATE;return void 0!==c?d=c.template||a.FE.ICON_DEFAULT_TEMPLATE:d}return{create:b,getTemplate:c}},a.extend(a.FE.DEFAULTS,{tooltips:!0}),a.FE.MODULES.tooltip=function(b){function c(){if(b.helpers.isMobile())return!1;b.$tooltip&&b.$tooltip.removeClass(\"fr-visible\").css(\"left\",\"-3000px\").css(\"position\",\"fixed\")}function d(c,d){if(b.helpers.isMobile())return!1;if(c.data(\"title\")||c.data(\"title\",c.attr(\"title\")),!c.data(\"title\"))return!1;b.$tooltip||f(),c.removeAttr(\"title\"),b.$tooltip.text(b.language.translate(c.data(\"title\"))),b.$tooltip.addClass(\"fr-visible\");var e=c.offset().left+(c.outerWidth()-b.$tooltip.outerWidth())/2;e<0&&(e=0),e+b.$tooltip.outerWidth()>a(b.o_win).width()&&(e=a(b.o_win).width()-b.$tooltip.outerWidth()),void 0===d&&(d=b.opts.toolbarBottom);var g=d?c.offset().top-b.$tooltip.height():c.offset().top+c.outerHeight();b.$tooltip.css(\"position\",\"\"),b.$tooltip.css(\"left\",e),b.$tooltip.css(\"top\",Math.ceil(g)),\"static\"!=a(b.o_doc).find(\"body:first\").css(\"position\")?(b.$tooltip.css(\"margin-left\",-a(b.o_doc).find(\"body:first\").offset().left),b.$tooltip.css(\"margin-top\",-a(b.o_doc).find(\"body:first\").offset().top)):(b.$tooltip.css(\"margin-left\",\"\"),b.$tooltip.css(\"margin-top\",\"\"))}function e(e,f,g){b.opts.tooltips&&!b.helpers.isMobile()&&(b.events.$on(e,\"mouseenter\",f,function(c){b.node.hasClass(c.currentTarget,\"fr-disabled\")||b.edit.isDisabled()||d(a(c.currentTarget),g)},!0),b.events.$on(e,\"mouseleave \"+b._mousedown+\" \"+b._mouseup,f,function(){c()},!0))}function f(){b.opts.tooltips&&!b.helpers.isMobile()&&(b.shared.$tooltip?b.$tooltip=b.shared.$tooltip:(b.shared.$tooltip=a('<div class=\"fr-tooltip\"></div>'),b.$tooltip=b.shared.$tooltip,b.opts.theme&&b.$tooltip.addClass(b.opts.theme+\"-theme\"),a(b.o_doc).find(\"body:first\").append(b.$tooltip)),b.events.on(\"shared.destroy\",function(){b.$tooltip.html(\"\").removeData().remove(),b.$tooltip=null},!0))}return{hide:c,to:d,bind:e}},a.FE.MODULES.button=function(b){function c(b,c,d){for(var e=a(),f=0;f<b.length;f++){var g=a(b[f]);if(g.is(c)&&(e=e.add(g)),d&&g.is(\".fr-dropdown\")){var h=g.next().find(c);e=e.add(h)}}return e}function d(d,e){var f,g=a();if(!d)return g;g=g.add(c(w,d,e)),g=g.add(c(x,d,e));for(f in b.shared.popups)if(b.shared.popups.hasOwnProperty(f)){var h=b.shared.popups[f],i=h.children().find(d);g=g.add(i)}for(f in b.shared.modals)if(b.shared.modals.hasOwnProperty(f)){var j=b.shared.modals[f],k=j.$modal.find(d);g=g.add(k)}return g}function e(c){var e=c.next(),f=b.node.hasClass(c.get(0),\"fr-active\"),g=d(\".fr-dropdown.fr-active\").not(c),h=c.parents(\".fr-toolbar, .fr-popup\").data(\"instance\")||b;if(h.helpers.isIOS()&&!h.el.querySelector(\".fr-marker\")&&(h.selection.save(),h.selection.clear(),h.selection.restore()),!f){var i=c.data(\"cmd\");e.find(\".fr-command\").removeClass(\"fr-active\").attr(\"aria-selected\",!1),a.FE.COMMANDS[i]&&a.FE.COMMANDS[i].refreshOnShow&&a.FE.COMMANDS[i].refreshOnShow.apply(h,[c,e]),e.css(\"left\",c.offset().left-c.parent().offset().left-(\"rtl\"==b.opts.direction?e.width()-c.outerWidth():0)),e.addClass(\"test-height\");var j=e.outerHeight();e.removeClass(\"test-height\"),e.css(\"top\",\"\").css(\"bottom\",\"\"),!b.opts.toolbarBottom&&e.offset().top+c.outerHeight()+j<a(b.o_doc).height()?e.css(\"top\",c.position().top+c.outerHeight()):e.css(\"bottom\",c.parents(\".fr-popup, .fr-toolbar\").first().height()-c.position().top)}c.addClass(\"fr-blink\").toggleClass(\"fr-active\"),c.hasClass(\"fr-active\")?(e.attr(\"aria-hidden\",!1),c.attr(\"aria-expanded\",!0)):(e.attr(\"aria-hidden\",!0),c.attr(\"aria-expanded\",!1)),setTimeout(function(){c.removeClass(\"fr-blink\")},300),e.css(\"margin-left\",\"\"),e.offset().left+e.outerWidth()>b.$sc.offset().left+b.$sc.width()&&e.css(\"margin-left\",-(e.offset().left+e.outerWidth()-b.$sc.offset().left-b.$sc.width())),e.offset().left<b.$sc.offset().left&&\"rtl\"==b.opts.direction&&e.css(\"margin-left\",e.offset().left+e.outerWidth()-b.$sc.offset().left),g.removeClass(\"fr-active\").attr(\"aria-expanded\",!1).next().attr(\"aria-hidden\",!0),g.parent(\".fr-toolbar:not(.fr-inline)\").css(\"zIndex\",\"\"),0!==c.parents(\".fr-popup\").length||b.opts.toolbarInline||(b.node.hasClass(c.get(0),\"fr-active\")?b.$tb.css(\"zIndex\",(b.opts.zIndex||1)+4):b.$tb.css(\"zIndex\",\"\"));var k=e.find(\"a.fr-command.fr-active:first\");b.helpers.isMobile()||(k.length?b.accessibility.focusToolbarElement(k):b.accessibility.focusToolbarElement(c))}function f(a){a.addClass(\"fr-blink\"),setTimeout(function(){a.removeClass(\"fr-blink\")},500);for(var b=a.data(\"cmd\"),c=[];void 0!==a.data(\"param\"+(c.length+1));)c.push(a.data(\"param\"+(c.length+1)));var e=d(\".fr-dropdown.fr-active\");e.length&&(e.removeClass(\"fr-active\").attr(\"aria-expanded\",!1).next().attr(\"aria-hidden\",!0),e.parent(\".fr-toolbar:not(.fr-inline)\").css(\"zIndex\",\"\")),a.parents(\".fr-popup, .fr-toolbar\").data(\"instance\").commands.exec(b,c)}function g(a){f(a)}function h(c){var d=c.parents(\".fr-popup, .fr-toolbar\").data(\"instance\");if(0!==c.parents(\".fr-popup\").length||c.data(\"popup\")||d.popups.hideAll(),d.popups.areVisible()&&!d.popups.areVisible(d)){for(var f=0;f<a.FE.INSTANCES.length;f++)a.FE.INSTANCES[f]!=d&&a.FE.INSTANCES[f].popups&&a.FE.INSTANCES[f].popups.areVisible()&&a.FE.INSTANCES[f].$el.find(\".fr-marker\").remove();d.popups.hideAll()}b.node.hasClass(c.get(0),\"fr-dropdown\")?e(c):(g(c),a.FE.COMMANDS[c.data(\"cmd\")]&&!1!==a.FE.COMMANDS[c.data(\"cmd\")].refreshAfterCallback&&d.button.bulkRefresh())}function i(b){h(a(b.currentTarget))}function j(a){var b=a.find(\".fr-dropdown.fr-active\");b.length&&(b.removeClass(\"fr-active\").attr(\"aria-expanded\",!1).next().attr(\"aria-hidden\",!0),b.parent(\".fr-toolbar:not(.fr-inline)\").css(\"zIndex\",\"\"))}function k(a){a.preventDefault(),a.stopPropagation()}function l(a){if(a.stopPropagation(),!b.helpers.isMobile())return!1}function m(c,d){b.events.bindClick(c,\".fr-command:not(.fr-disabled)\",i),b.events.$on(c,b._mousedown+\" \"+b._mouseup+\" \"+b._move,\".fr-dropdown-menu\",k,!0),b.events.$on(c,b._mousedown+\" \"+b._mouseup+\" \"+b._move,\".fr-dropdown-menu .fr-dropdown-wrapper\",l,!0);var e=c.get(0).ownerDocument,f=\"defaultView\"in e?e.defaultView:e.parentWindow,g=function(d){(!d||d.type==b._mouseup&&d.target!=a(\"html\").get(0)||\"keydown\"==d.type&&(b.keys.isCharacter(d.which)&&!b.keys.ctrlKey(d)||d.which==a.FE.KEYCODE.ESC))&&j(c)};b.events.$on(a(f),b._mouseup+\" resize keydown\",g,!0),b.opts.iframe&&b.events.$on(b.$win,b._mouseup,g,!0),b.node.hasClass(c.get(0),\"fr-popup\")?a.merge(x,c.find(\".fr-btn\").toArray()):a.merge(w,c.find(\".fr-btn\").toArray()),\nb.tooltip.bind(c,\".fr-btn, .fr-title\",d)}function n(a,c){var d=\"\";if(c.html)\"function\"==typeof c.html?d+=c.html.call(b):d+=c.html;else{var e=c.options;\"function\"==typeof e&&(e=e()),d+='<ul class=\"fr-dropdown-list\" role=\"presentation\">';for(var f in e)if(e.hasOwnProperty(f)){var g=b.shortcuts.get(a+\".\"+f);g=g?'<span class=\"fr-shortcut\">'+g+\"</span>\":\"\",d+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"'+a+'\" data-param1=\"'+f+'\" title=\"'+e[f]+'\">'+b.language.translate(e[f])+\"</a></li>\"}d+=\"</ul>\"}return d}function o(a,c,d){if(b.helpers.isMobile()&&!1===c.showOnMobile)return\"\";var e=c.displaySelection;\"function\"==typeof e&&(e=e(b));var f;if(e){var g=\"function\"==typeof c.defaultSelection?c.defaultSelection(b):c.defaultSelection;f='<span style=\"width:'+(c.displaySelectionWidth||100)+'px\">'+b.language.translate(g||c.title)+\"</span>\"}else f=b.icon.create(c.icon||a),f+='<span class=\"fr-sr-only\">'+(b.language.translate(c.title)||\"\")+\"</span>\";var h=c.popup?' data-popup=\"true\"':\"\",i=c.modal?' data-modal=\"true\"':\"\",j=b.shortcuts.get(a+\".\");j=j?\" (\"+j+\")\":\"\";var k=a+\"-\"+b.id,l=\"dropdown-menu-\"+k,m='<button id=\"'+k+'\"type=\"button\" tabIndex=\"-1\" role=\"button\"'+(c.toggle?' aria-pressed=\"false\"':\"\")+(\"dropdown\"==c.type?' aria-controls=\"'+l+'\" aria-expanded=\"false\" aria-haspopup=\"true\"':\"\")+(c.disabled?' aria-disabled=\"true\"':\"\")+' title=\"'+(b.language.translate(c.title)||\"\")+j+'\" class=\"fr-command fr-btn'+(\"dropdown\"==c.type?\" fr-dropdown\":\"\")+\" fr-btn-\"+b.icon.getTemplate(c.icon)+(c.displaySelection?\" fr-selection\":\"\")+(c.back?\" fr-back\":\"\")+(c.disabled?\" fr-disabled\":\"\")+(d?\"\":\" fr-hidden\")+'\" data-cmd=\"'+a+'\"'+h+i+\">\"+f+\"</button>\";if(\"dropdown\"==c.type){var o='<div id=\"'+l+'\" class=\"fr-dropdown-menu\" role=\"listbox\" aria-labelledby=\"'+k+'\" aria-hidden=\"true\"><div class=\"fr-dropdown-wrapper\" role=\"presentation\"><div class=\"fr-dropdown-content\" role=\"presentation\">';o+=n(a,c),o+=\"</div></div></div>\",m+=o}return m}function p(c,d){for(var e=\"\",f=0;f<c.length;f++){var g=c[f],h=a.FE.COMMANDS[g];if(!(h&&void 0!==h.plugin&&b.opts.pluginsEnabled.indexOf(h.plugin)<0))if(h){var i=void 0===d||d.indexOf(g)>=0;e+=o(g,h,i)}else\"|\"==g?e+='<div class=\"fr-separator fr-vs\" role=\"separator\" aria-orientation=\"vertical\"></div>':\"-\"==g&&(e+='<div class=\"fr-separator fr-hs\" role=\"separator\" aria-orientation=\"horizontal\"></div>')}return e}function q(c){var d,e=c.parents(\".fr-popup, .fr-toolbar\").data(\"instance\")||b,f=c.data(\"cmd\");b.node.hasClass(c.get(0),\"fr-dropdown\")?d=c.next():(c.removeClass(\"fr-active\"),c.attr(\"aria-pressed\")&&c.attr(\"aria-pressed\",!1)),a.FE.COMMANDS[f]&&a.FE.COMMANDS[f].refresh?a.FE.COMMANDS[f].refresh.apply(e,[c,d]):b.refresh[f]&&e.refresh[f](c,d)}function r(c){var d=b.$tb?b.$tb.data(\"instance\")||b:b;if(!1===b.events.trigger(\"buttons.refresh\"))return!0;setTimeout(function(){for(var e=d.selection.inEditor()&&d.core.hasFocus(),f=0;f<c.length;f++){var g=a(c[f]),h=g.data(\"cmd\");0===g.parents(\".fr-popup\").length?e||a.FE.COMMANDS[h]&&a.FE.COMMANDS[h].forcedRefresh?d.button.refresh(g):b.node.hasClass(g.get(0),\"fr-dropdown\")||(g.removeClass(\"fr-active\"),g.attr(\"aria-pressed\")&&g.attr(\"aria-pressed\",!1)):g.parents(\".fr-popup\").is(\":visible\")&&d.button.refresh(g)}},0)}function s(){r(w),r(x)}function t(){w=[],x=[]}function u(){clearTimeout(y),y=setTimeout(s,50)}function v(){b.opts.toolbarInline?b.events.on(\"toolbar.show\",s):(b.events.on(\"mouseup\",u),b.events.on(\"keyup\",u),b.events.on(\"blur\",u),b.events.on(\"focus\",u),b.events.on(\"contentChanged\",u),b.helpers.isMobile()&&b.events.$on(b.$doc,\"selectionchange\",s)),b.events.on(\"shared.destroy\",t)}var w=[];(b.opts.toolbarInline||b.opts.toolbarContainer)&&(b.shared.buttons||(b.shared.buttons=[]),w=b.shared.buttons);var x=[];b.shared.popup_buttons||(b.shared.popup_buttons=[]),x=b.shared.popup_buttons;var y=null;return{_init:v,buildList:p,bindCommands:m,refresh:q,bulkRefresh:s,exec:f,click:h,hideActiveDropdowns:j,getButtons:d}},a.FE.MODULES.modals=function(b){function c(a){return n[a]}function d(c,d){var e='<div tabIndex=\"-1\" class=\"fr-modal'+(b.opts.theme?\" \"+b.opts.theme+\"-theme\":\"\")+'\"><div class=\"fr-modal-wrapper\">';return e+='<div class=\"fr-modal-head\">'+c+'<i title=\"'+b.language.translate(\"Cancel\")+'\" class=\"fa fa-times fr-modal-close\"></i></div>',e+='<div tabIndex=\"-1\" class=\"fr-modal-body\">'+d+\"</div>\",e+=\"</div></div>\",a(e)}function e(c,e,f){if(b.shared.$overlay||(b.shared.$overlay=a('<div class=\"fr-overlay\">').appendTo(\"body:first\")),m=b.shared.$overlay,b.opts.theme&&m.addClass(b.opts.theme+\"-theme\"),!n[c]){var g=d(e,f);n[c]={$modal:g,$head:g.find(\".fr-modal-head\"),$body:g.find(\".fr-modal-body\")},b.helpers.isMobile()||g.addClass(\"fr-desktop\"),g.appendTo(\"body:first\"),b.events.bindClick(g,\"i.fr-modal-close\",function(){h(c)}),n[c].$body.css(\"margin-top\",n[c].$head.outerHeight()),b.events.$on(g,\"keydown\",function(d){var e=d.which;return e==a.FE.KEYCODE.ESC?(h(c),b.accessibility.focusModalButton(g),!1):!(!a(d.currentTarget).is(\"input[type=text], textarea\")&&e!=a.FE.KEYCODE.ARROW_UP&&e!=a.FE.KEYCODE.ARROW_DOWN&&!b.keys.isBrowserAction(d))||(d.preventDefault(),d.stopPropagation(),!1)},!0),h(c,!0)}return n[c]}function f(){for(var a in n){var b=n[a];b&&b.$modal&&b.$modal.removeData().remove()}m&&m.removeData().remove(),n={}}function g(c){if(n[c]){var d=n[c].$modal;d.data(\"instance\",b),d.show(),m.show(),a(b.o_doc).find(\"body:first\").addClass(\"prevent-scroll\"),b.helpers.isMobile()&&a(b.o_doc).find(\"body:first\").addClass(\"fr-mobile\"),d.addClass(\"fr-active\"),b.accessibility.focusModal(d)}}function h(c,d){if(n[c]){var e=n[c].$modal,f=e.data(\"instance\")||b;f.events.enableBlur(),e.hide(),m.hide(),a(f.o_doc).find(\"body:first\").removeClass(\"prevent-scroll fr-mobile\"),e.removeClass(\"fr-active\"),d||(b.accessibility.restoreSelection(f),b.events.trigger(\"modals.hide\"))}}function i(c){if(n[c]){var d=n[c],e=d.$modal,f=d.$body,g=a(b.o_win).height(),h=e.find(\".fr-modal-wrapper\"),i=h.outerHeight(!0),j=h.height()-(f.outerHeight(!0)-f.height()),k=g-i+j,l=f.get(0).scrollHeight,m=\"auto\";l>k&&(m=k),f.height(m)}}function j(a){var c;if(\"string\"==typeof a){if(!n[a])return;c=n[a].$modal}else c=a;return c&&b.node.hasClass(c,\"fr-active\")&&b.core.sameInstance(c)||!1}function k(a){for(var b in n)if(n.hasOwnProperty(b)&&j(b)&&(void 0===a||n[b].$modal.data(\"instance\")==a))return n[b].$modal;return!1}function l(){b.events.on(\"shared.destroy\",f,!0)}b.shared.modals||(b.shared.modals={});var m,n=b.shared.modals;return{_init:l,get:c,create:e,show:g,hide:h,resize:i,isVisible:j,areVisible:k}},a.FE.POPUP_TEMPLATES={\"text.edit\":\"[_EDIT_]\"},a.FE.RegisterTemplate=function(b,c){a.FE.POPUP_TEMPLATES[b]=c},a.FE.MODULES.popups=function(b){function c(a,c){c.is(\":visible\")||(c=b.$sc),c.is(x[a].data(\"container\"))||(x[a].data(\"container\",c),c.append(x[a]))}function d(a,d,e,h){if(f(a)||(g()&&b.$el.find(\".fr-marker\").length>0?(b.events.disableBlur(),b.selection.restore()):g()||(b.events.disableBlur(),b.events.focus(),b.events.enableBlur())),m([a]),!x[a])return!1;var i=b.button.getButtons(\".fr-dropdown.fr-active\");i.removeClass(\"fr-active\").attr(\"aria-expanded\",!1).parent(\".fr-toolbar\").css(\"zIndex\",\"\"),i.next().attr(\"aria-hidden\",!0),x[a].data(\"instance\",b),b.$tb&&b.$tb.data(\"instance\",b);var j=x[a].outerWidth(),k=f(a);x[a].addClass(\"fr-active\").removeClass(\"fr-hidden\").find(\"input, textarea\").removeAttr(\"disabled\");var l=x[a].data(\"container\");b.opts.toolbarInline&&l&&b.$tb&&l.get(0)==b.$tb.get(0)&&(c(a,b.$sc),e=b.$tb.offset().top-b.helpers.getPX(b.$tb.css(\"margin-top\")),d=b.$tb.offset().left+b.$tb.outerWidth()/2+(parseFloat(b.$tb.find(\".fr-arrow\").css(\"margin-left\"))||0)+b.$tb.find(\".fr-arrow\").outerWidth()/2,b.node.hasClass(b.$tb.get(0),\"fr-above\")&&e&&(e+=b.$tb.outerHeight()),h=0),l=x[a].data(\"container\"),!b.opts.iframe||h||k||(d&&(d-=b.$iframe.offset().left),e&&(e-=b.$iframe.offset().top)),l.is(b.$tb)?b.$tb.css(\"zIndex\",(b.opts.zIndex||1)+4):x[a].css(\"zIndex\",(b.opts.zIndex||1)+4),d&&(d-=j/2),b.opts.toolbarBottom&&l&&b.$tb&&l.get(0)==b.$tb.get(0)&&(x[a].addClass(\"fr-above\"),e&&(e-=x[a].outerHeight())),x[a].removeClass(\"fr-active\"),b.position.at(d,e,x[a],h||0),x[a].addClass(\"fr-active\"),k||b.accessibility.focusPopup(x[a]),b.opts.toolbarInline&&b.toolbar.hide(),b.events.trigger(\"popups.show.\"+a),s(a)._repositionPopup(),o()}function e(a,c){b.events.on(\"popups.show.\"+a,c)}function f(a){return x[a]&&b.node.hasClass(x[a],\"fr-active\")&&b.core.sameInstance(x[a])||!1}function g(a){for(var b in x)if(x.hasOwnProperty(b)&&f(b)&&(void 0===a||x[b].data(\"instance\")==a))return x[b];return!1}function h(a){var c=null;(c=\"string\"!=typeof a?a:x[a])&&b.node.hasClass(c,\"fr-active\")&&(c.removeClass(\"fr-active fr-above\"),b.events.trigger(\"popups.hide.\"+a),b.$tb&&(b.opts.zIndex>1?b.$tb.css(\"zIndex\",b.opts.zIndex+1):b.$tb.css(\"zIndex\",\"\")),b.events.disableBlur(),c.find(\"input, textarea, button\").filter(\":focus\").blur(),c.find(\"input, textarea\").attr(\"disabled\",\"disabled\"))}function i(a,c){b.events.on(\"popups.hide.\"+a,c)}function j(a){var c=x[a];if(c&&!c.data(\"inst\"+b.id)){t(s(a),a)}return c}function k(a,c){b.events.on(\"popups.refresh.\"+a,c)}function l(c){x[c].data(\"instance\",b),b.events.trigger(\"popups.refresh.\"+c);for(var d=x[c].find(\".fr-command\"),e=0;e<d.length;e++){var f=a(d[e]);0===f.parents(\".fr-dropdown-menu\").length&&b.button.refresh(f)}}function m(a){void 0===a&&(a=[]);for(var b in x)x.hasOwnProperty(b)&&a.indexOf(b)<0&&h(b)}function n(){b.shared.exit_flag=!0}function o(){b.shared.exit_flag=!1}function p(){return b.shared.exit_flag}function q(c,d){var e=a.FE.POPUP_TEMPLATES[c];\"function\"==typeof e&&(e=e.apply(b));for(var f in d)d.hasOwnProperty(f)&&(e=e.replace(\"[_\"+f.toUpperCase()+\"_]\",d[f]));return e}function r(c,d){var e=q(c,d),f=a('<div class=\"fr-popup'+(b.helpers.isMobile()?\" fr-mobile\":\" fr-desktop\")+(b.opts.toolbarInline?\" fr-inline\":\"\")+'\"><span class=\"fr-arrow\"></span>'+e+\"</div>\");b.opts.theme&&f.addClass(b.opts.theme+\"-theme\"),b.opts.zIndex>1&&b.$tb.css(\"z-index\",b.opts.zIndex+2),\"auto\"!=b.opts.direction&&f.removeClass(\"fr-ltr fr-rtl\").addClass(\"fr-\"+b.opts.direction),f.find(\"input, textarea\").attr(\"dir\",b.opts.direction).attr(\"disabled\",\"disabled\");var g=a(\"body:first\");return g.append(f),f.data(\"container\",g),x[c]=f,b.button.bindCommands(f,!1),f}function s(c){var d=x[c];return{_windowResize:function(){var a=d.data(\"instance\")||b;!a.helpers.isMobile()&&d.is(\":visible\")&&(a.events.disableBlur(),a.popups.hide(c),a.events.enableBlur())},_inputFocus:function(c){var e=d.data(\"instance\")||b,f=a(c.currentTarget);if(f.is(\"input:file\")&&f.closest(\".fr-layer\").addClass(\"fr-input-focus\"),c.preventDefault(),c.stopPropagation(),setTimeout(function(){e.events.enableBlur()},100),e.helpers.isMobile()){var g=a(e.o_win).scrollTop();setTimeout(function(){a(e.o_win).scrollTop(g)},0)}},_inputBlur:function(c){var e=d.data(\"instance\")||b,f=a(c.currentTarget);f.is(\"input:file\")&&f.closest(\".fr-layer\").removeClass(\"fr-input-focus\"),document.activeElement!=this&&a(this).is(\":visible\")&&(e.events.blurActive()&&e.events.trigger(\"blur\"),e.events.enableBlur())},_editorKeydown:function(e){var g=d.data(\"instance\")||b;g.keys.ctrlKey(e)||e.which==a.FE.KEYCODE.ALT||e.which==a.FE.KEYCODE.ESC||(f(c)&&d.find(\".fr-back:visible\").length?g.button.exec(d.find(\".fr-back:visible:first\")):e.which!=a.FE.KEYCODE.ALT&&g.popups.hide(c))},_preventFocus:function(c){var e=d.data(\"instance\")||b,f=c.originalEvent?c.originalEvent.target||c.originalEvent.originalTarget:null;\"mouseup\"==c.type||a(f).is(\":focus\")||e.events.disableBlur(),\"mouseup\"!=c.type||a(f).hasClass(\"fr-command\")||a(f).parents(\".fr-command\").length>0||b.button.hideActiveDropdowns(d),(b.browser.safari||b.browser.mozilla)&&\"mousedown\"==c.type&&a(f).is(\"input[type=file]\")&&e.events.disableBlur();var g=\"input, textarea, button, select, label, .fr-command\";if(f&&!a(f).is(g)&&0===a(f).parents(g).length)return c.stopPropagation(),!1;f&&a(f).is(g)&&c.stopPropagation(),o()},_editorMouseup:function(){d.is(\":visible\")&&p()&&d.find(\"input:focus, textarea:focus, button:focus, select:focus\").filter(\":visible\").length>0&&b.events.disableBlur()},_windowMouseup:function(a){if(!b.core.sameInstance(d))return!0;var e=d.data(\"instance\")||b;d.is(\":visible\")&&p()&&(a.stopPropagation(),e.markers.remove(),e.popups.hide(c),o())},_windowKeydown:function(e){if(!b.core.sameInstance(d))return!0;var f=d.data(\"instance\")||b,g=e.which;if(a.FE.KEYCODE.ESC==g){if(f.popups.isVisible(c)&&f.opts.toolbarInline)return e.stopPropagation(),f.popups.isVisible(c)&&(d.find(\".fr-back:visible\").length?(f.button.exec(d.find(\".fr-back:visible:first\")),f.accessibility.focusPopupButton(d)):d.find(\".fr-dismiss:visible\").length?f.button.exec(d.find(\".fr-dismiss:visible:first\")):(f.popups.hide(c),f.toolbar.showInline(null,!0),f.accessibility.FocusPopupButton(d))),!1;if(f.popups.isVisible(c))return d.find(\".fr-back:visible\").length?(f.button.exec(d.find(\".fr-back:visible:first\")),f.accessibility.focusPopupButton(d)):d.find(\".fr-dismiss:visible\").length?f.button.exec(d.find(\".fr-dismiss:visible:first\")):(f.popups.hide(c),f.accessibility.focusPopupButton(d)),!1}},_doPlaceholder:function(){0===a(this).next().length&&a(this).attr(\"placeholder\")&&a(this).after('<label for=\"'+a(this).attr(\"id\")+'\">'+a(this).attr(\"placeholder\")+\"</label>\"),a(this).toggleClass(\"fr-not-empty\",\"\"!==a(this).val())},_repositionPopup:function(){if(!b.opts.height&&!b.opts.heightMax||b.opts.toolbarInline)return!0;if(b.$wp&&f(c)&&d.parent().get(0)==b.$sc.get(0)){var a=d.offset().top-b.$wp.offset().top,e=b.$wp.outerHeight();b.node.hasClass(d.get(0),\"fr-above\")&&(a+=d.outerHeight()),a>e||a<0?d.addClass(\"fr-hidden\"):d.removeClass(\"fr-hidden\")}}}}function t(a,c){b.events.on(\"mouseup\",a._editorMouseup,!0),b.$wp&&b.events.on(\"keydown\",a._editorKeydown),b.events.on(\"blur\",function(){g()&&b.markers.remove(),m()}),b.$wp&&!b.helpers.isMobile()&&b.events.$on(b.$wp,\"scroll.popup\"+c,a._repositionPopup),b.events.on(\"window.mouseup\",a._windowMouseup,!0),b.events.on(\"window.keydown\",a._windowKeydown,!0),x[c].data(\"inst\"+b.id,!0),b.events.on(\"destroy\",function(){b.core.sameInstance(x[c])&&x[c].removeClass(\"fr-active\").appendTo(\"body:first\")},!0)}function u(c,d){var e=r(c,d),f=s(c);return t(f,c),b.events.$on(e,\"mousedown mouseup touchstart touchend touch\",\"*\",f._preventFocus,!0),b.events.$on(e,\"focus\",\"input, textarea, button, select\",f._inputFocus,!0),b.events.$on(e,\"blur\",\"input, textarea, button, select\",f._inputBlur,!0),b.accessibility.registerPopup(c),b.events.$on(e,\"keydown keyup change input\",\"input, textarea\",f._doPlaceholder,!0),b.helpers.isIOS()&&b.events.$on(e,\"touchend\",\"label\",function(){a(\"#\"+a(this).attr(\"for\")).prop(\"checked\",function(a,b){return!b})},!0),b.events.$on(a(b.o_win),\"resize\",f._windowResize,!0),e}function v(){for(var a in x)if(x.hasOwnProperty(a)){var b=x[a];b&&(b.html(\"\").removeData().remove(),x[a]=null)}x=[]}function w(){b.events.on(\"shared.destroy\",v,!0),b.events.on(\"window.mousedown\",n),b.events.on(\"window.touchmove\",o),b.events.$on(a(b.o_win),\"scroll\",o),b.events.on(\"mousedown\",function(a){g()&&(a.stopPropagation(),b.$el.find(\".fr-marker\").remove(),n(),b.events.disableBlur())})}b.shared.popups||(b.shared.popups={});var x=b.shared.popups;return b.shared.exit_flag=!1,{_init:w,create:u,get:j,show:d,hide:h,onHide:i,hideAll:m,setContainer:c,refresh:l,onRefresh:k,onShow:e,isVisible:f,areVisible:g}},a.FE.MODULES.position=function(b){function c(){var a=b.selection.ranges(0),c=a.getBoundingClientRect();if(0===c.top&&0===c.left&&0===c.width||0===c.height){var d=!1;0===b.$el.find(\".fr-marker\").length&&(b.selection.save(),d=!0);var e=b.$el.find(\".fr-marker:first\");e.css(\"display\",\"inline\"),e.css(\"line-height\",\"\");var f=e.offset(),g=e.outerHeight();e.css(\"display\",\"none\"),e.css(\"line-height\",0),c={},c.left=f.left,c.width=0,c.height=g,c.top=f.top-(b.helpers.isMobile()&&!b.helpers.isIOS()?0:b.helpers.scrollTop()),c.right=1,c.bottom=1,c.ok=!0,d&&b.selection.restore()}return c}function d(a,c,d){var e=a.outerHeight(!0);if(!b.helpers.isMobile()&&b.$tb&&a.parent().get(0)!=b.$tb.get(0)){var f=a.parent().offset().top,g=c-e-(d||0);a.parent().get(0)==b.$sc.get(0)&&(f-=a.parent().position().top);var h=b.$sc.get(0).clientHeight;f+c+e>b.$sc.offset().top+h&&a.parent().offset().top+g>0&&g>0?(c=g,a.addClass(\"fr-above\")):a.removeClass(\"fr-above\")}return c}function e(a,c){var d=a.outerWidth(!0);return c+d>b.$sc.get(0).clientWidth-10&&(c=b.$sc.get(0).clientWidth-d-10),c<0&&(c=10),c}function f(a){var d=c();a.css({top:0,left:0});var e=d.top+d.height,f=d.left+d.width/2-a.get(0).offsetWidth/2+b.helpers.scrollLeft();b.opts.iframe||(e+=b.helpers.scrollTop()),g(f,e,a,d.height)}function g(a,c,f,g){var h=f.data(\"container\");!h||\"BODY\"===h.get(0).tagName&&\"static\"==h.css(\"position\")||(a&&(a-=h.offset().left),c&&(c-=h.offset().top),\"BODY\"!=h.get(0).tagName?(a&&(a+=h.get(0).scrollLeft),c&&(c+=h.get(0).scrollTop)):\"absolute\"==h.css(\"position\")&&(a&&(a+=h.position().left),c&&(c+=h.position().top))),b.opts.iframe&&h&&b.$tb&&h.get(0)!=b.$tb.get(0)&&(a&&(a+=b.$iframe.offset().left),c&&(c+=b.$iframe.offset().top));var i=e(f,a);if(a){f.css(\"left\",i);var j=f.data(\"fr-arrow\");j||(j=f.find(\".fr-arrow\"),f.data(\"fr-arrow\",j)),j.data(\"margin-left\")||j.data(\"margin-left\",b.helpers.getPX(j.css(\"margin-left\"))),j.css(\"margin-left\",a-i+j.data(\"margin-left\"))}c&&f.css(\"top\",d(f,c,g))}function h(c){var d=a(c),e=d.is(\".fr-sticky-on\"),f=d.data(\"sticky-top\"),g=d.data(\"sticky-scheduled\");if(void 0===f){d.data(\"sticky-top\",0);var h=a('<div class=\"fr-sticky-dummy\" style=\"height: '+d.outerHeight()+'px;\"></div>');b.$box.prepend(h)}else b.$box.find(\".fr-sticky-dummy\").css(\"height\",d.outerHeight());if(b.core.hasFocus()||b.$tb.find(\"input:visible:focus\").length>0){var i=b.helpers.scrollTop(),j=Math.min(Math.max(i-b.$tb.parent().offset().top,0),b.$tb.parent().outerHeight()-d.outerHeight());j!=f&&j!=g&&(clearTimeout(d.data(\"sticky-timeout\")),d.data(\"sticky-scheduled\",j),d.outerHeight()<i-b.$tb.parent().offset().top&&d.addClass(\"fr-opacity-0\"),d.data(\"sticky-timeout\",setTimeout(function(){var a=b.helpers.scrollTop(),c=Math.min(Math.max(a-b.$tb.parent().offset().top,0),b.$tb.parent().outerHeight()-d.outerHeight());c>0&&\"BODY\"==b.$tb.parent().get(0).tagName&&(c+=b.$tb.parent().position().top),c!=f&&(d.css(\"top\",Math.max(c,0)),d.data(\"sticky-top\",c),d.data(\"sticky-scheduled\",c)),d.removeClass(\"fr-opacity-0\")},100))),e||(d.css(\"top\",\"0\"),d.width(b.$tb.parent().width()),d.addClass(\"fr-sticky-on\"),b.$box.addClass(\"fr-sticky-box\"))}else clearTimeout(a(c).css(\"sticky-timeout\")),d.css(\"top\",\"0\"),d.css(\"position\",\"\"),d.width(\"\"),d.data(\"sticky-top\",0),d.removeClass(\"fr-sticky-on\"),b.$box.removeClass(\"fr-sticky-box\")}function i(c){if(c.offsetWidth){var d,e,f=a(c),g=f.outerHeight(),h=f.data(\"sticky-position\"),i=a(\"body\"==b.opts.scrollableContainer?b.o_win:b.opts.scrollableContainer).outerHeight(),j=0,k=0;\"body\"!==b.opts.scrollableContainer&&(j=b.$sc.offset().top,k=a(b.o_win).outerHeight()-j-i);var l=\"body\"==b.opts.scrollableContainer?b.helpers.scrollTop():j,m=f.is(\".fr-sticky-on\");f.data(\"sticky-parent\")||f.data(\"sticky-parent\",f.parent());var n=f.data(\"sticky-parent\"),o=n.offset().top,p=n.outerHeight();if(f.data(\"sticky-offset\")?b.$box.find(\".fr-sticky-dummy\").css(\"height\",g+\"px\"):(f.data(\"sticky-offset\",!0),f.after('<div class=\"fr-sticky-dummy\" style=\"height: '+g+'px;\"></div>')),!h){var q=\"auto\"!==f.css(\"top\")||\"auto\"!==f.css(\"bottom\");q||f.css(\"position\",\"fixed\"),h={top:b.node.hasClass(f.get(0),\"fr-top\"),bottom:b.node.hasClass(f.get(0),\"fr-bottom\")},q||f.css(\"position\",\"\"),f.data(\"sticky-position\",h),f.data(\"top\",b.node.hasClass(f.get(0),\"fr-top\")?f.css(\"top\"):\"auto\"),f.data(\"bottom\",b.node.hasClass(f.get(0),\"fr-bottom\")?f.css(\"bottom\"):\"auto\")}var r=function(){return o<l+d&&o+p-g>=l+d},s=function(){return o+g<l+i-e&&o+p>l+i-e};d=b.helpers.getPX(f.data(\"top\")),e=b.helpers.getPX(f.data(\"bottom\"));var t=h.top&&r()&&b.helpers.isInViewPort(b.$sc.get(0)),u=h.bottom&&s();t||u?(f.css(\"width\",n.get(0).getBoundingClientRect().width+\"px\"),m||(f.addClass(\"fr-sticky-on\"),f.removeClass(\"fr-sticky-off\"),f.css(\"top\")&&(\"auto\"!=f.data(\"top\")?f.css(\"top\",b.helpers.getPX(f.data(\"top\"))+j):f.data(\"top\",\"auto\")),f.css(\"bottom\")&&(\"auto\"!=f.data(\"bottom\")?f.css(\"bottom\",b.helpers.getPX(f.data(\"bottom\"))+k):f.css(\"bottom\",\"auto\")))):b.node.hasClass(f.get(0),\"fr-sticky-off\")||(f.width(\"\"),f.removeClass(\"fr-sticky-on\"),f.addClass(\"fr-sticky-off\"),f.css(\"top\")&&\"auto\"!=f.data(\"top\")&&h.top&&f.css(\"top\",0),f.css(\"bottom\")&&\"auto\"!=f.data(\"bottom\")&&h.bottom&&f.css(\"bottom\",0))}}function j(){var a=document.createElement(\"test\"),c=a.style;return c.cssText=\"position:\"+[\"-webkit-\",\"-moz-\",\"-ms-\",\"-o-\",\"\"].join(\"sticky; position:\")+\" sticky;\",-1!==c.position.indexOf(\"sticky\")&&!b.helpers.isIOS()&&!b.helpers.isAndroid()&&!b.browser.chrome}function k(){if(!j())if(b._stickyElements=[],b.helpers.isIOS()){var c=function(){b.helpers.requestAnimationFrame()(c);for(var a=0;a<b._stickyElements.length;a++)h(b._stickyElements[a])};c(),b.events.$on(a(b.o_win),\"scroll\",function(){if(b.core.hasFocus())for(var c=0;c<b._stickyElements.length;c++){var d=a(b._stickyElements[c]),e=d.parent(),f=b.helpers.scrollTop();d.outerHeight()<f-e.offset().top&&(d.addClass(\"fr-opacity-0\"),d.data(\"sticky-top\",-1),d.data(\"sticky-scheduled\",-1))}},!0)}else\"body\"!==b.opts.scrollableContainer&&b.events.$on(a(b.opts.scrollableContainer),\"scroll\",l,!0),b.events.$on(a(b.o_win),\"scroll\",l,!0),b.events.$on(a(b.o_win),\"resize\",l,!0),b.events.on(\"initialized\",l),b.events.on(\"focus\",l),b.events.$on(a(b.o_win),\"resize\",\"textarea\",l,!0);b.events.on(\"destroy\",function(){b._stickyElements=[]})}function l(){if(b._stickyElements)for(var a=0;a<b._stickyElements.length;a++)i(b._stickyElements[a])}function m(a){a.addClass(\"fr-sticky\"),b.helpers.isIOS()&&a.addClass(\"fr-sticky-ios\"),j()||(a.removeClass(\"fr-sticky\"),b._stickyElements.push(a.get(0)))}function n(){k()}return{_init:n,forSelection:f,addSticky:m,refresh:l,at:g,getBoundingRect:c}},a.FE.MODULES.refresh=function(b){function c(a){g(a,!b.undo.canDo())}function d(a){g(a,!b.undo.canRedo())}function e(a){if(b.node.hasClass(a.get(0),\"fr-no-refresh\"))return!1;for(var c=b.selection.blocks(),d=0;d<c.length;d++){for(var e=c[d].previousSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.previousSibling;if(\"LI\"!=c[d].tagName||e)return g(a,!1),!0;g(a,!0)}}function f(c){if(b.node.hasClass(c.get(0),\"fr-no-refresh\"))return!1;for(var d=b.selection.blocks(),e=0;e<d.length;e++){var f=\"rtl\"==b.opts.direction||\"rtl\"==a(d[e]).css(\"direction\")?\"margin-right\":\"margin-left\";if(\"LI\"==d[e].tagName||\"LI\"==d[e].parentNode.tagName)return g(c,!1),!0;if(b.helpers.getPX(a(d[e]).css(f))>0)return g(c,!1),!0}g(c,!0)}function g(a,b){a.toggleClass(\"fr-disabled\",b).attr(\"aria-disabled\",b)}return{undo:c,redo:d,outdent:f,indent:e}},a.extend(a.FE.DEFAULTS,{editInPopup:!1}),a.FE.MODULES.textEdit=function(a){function b(){var b='<div id=\"fr-text-edit-'+a.id+'\" class=\"fr-layer fr-text-edit-layer\"><div class=\"fr-input-line\"><input type=\"text\" placeholder=\"'+a.language.translate(\"Text\")+'\" tabIndex=\"1\"></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"updateText\" tabIndex=\"2\">'+a.language.translate(\"Update\")+\"</button></div></div>\",c={edit:b};a.popups.create(\"text.edit\",c)}function c(){var b,c=a.popups.get(\"text.edit\");b=\"INPUT\"===a.$el.prop(\"tagName\")?a.$el.attr(\"placeholder\"):a.$el.text(),c.find(\"input\").val(b).trigger(\"change\"),a.popups.setContainer(\"text.edit\",a.$sc),a.popups.show(\"text.edit\",a.$el.offset().left+a.$el.outerWidth()/2,a.$el.offset().top+a.$el.outerHeight(),a.$el.outerHeight())}function d(){a.events.$on(a.$el,a._mouseup,function(){setTimeout(function(){c()},10)})}function e(){var b=a.popups.get(\"text.edit\"),c=b.find(\"input\").val();0===c.length&&(c=a.opts.placeholderText),\"INPUT\"===a.$el.prop(\"tagName\")?a.$el.attr(\"placeholder\",c):a.$el.text(c),a.events.trigger(\"contentChanged\"),a.popups.hide(\"text.edit\")}function f(){a.opts.editInPopup&&(b(),d())}return{_init:f,update:e}},a.FE.RegisterCommand(\"updateText\",{focus:!1,undo:!1,callback:function(){this.textEdit.update()}}),a.extend(a.FE.DEFAULTS,{toolbarBottom:!1,toolbarButtons:[\"fullscreen\",\"bold\",\"italic\",\"underline\",\"strikeThrough\",\"subscript\",\"superscript\",\"|\",\"fontFamily\",\"fontSize\",\"color\",\"inlineStyle\",\"paragraphStyle\",\"|\",\"paragraphFormat\",\"align\",\"formatOL\",\"formatUL\",\"outdent\",\"indent\",\"quote\",\"-\",\"insertLink\",\"insertImage\",\"insertVideo\",\"embedly\",\"insertFile\",\"insertTable\",\"|\",\"emoticons\",\"specialCharacters\",\"insertHR\",\"selectAll\",\"clearFormatting\",\"|\",\"print\",\"spellChecker\",\"help\",\"html\",\"|\",\"undo\",\"redo\"],toolbarButtonsXS:[\"bold\",\"italic\",\"fontFamily\",\"fontSize\",\"|\",\"undo\",\"redo\"],toolbarButtonsSM:[\"bold\",\"italic\",\"underline\",\"|\",\"fontFamily\",\"fontSize\",\"insertLink\",\"insertImage\",\"table\",\"|\",\"undo\",\"redo\"],toolbarButtonsMD:null,toolbarContainer:null,toolbarInline:!1,toolbarSticky:!0,toolbarStickyOffset:0,toolbarVisibleWithoutSelection:!1}),a.FE.MODULES.toolbar=function(b){function c(a,b){for(var c=0;c<b.length;c++)\"-\"!=b[c]&&\"|\"!=b[c]&&a.indexOf(b[c])<0&&a.push(b[c])}function d(){var d=a.merge([],e());c(d,b.opts.toolbarButtonsXS||[]),c(d,b.opts.toolbarButtonsSM||[]),c(d,b.opts.toolbarButtonsMD||[]),c(d,b.opts.toolbarButtons);for(var f=d.length-1;f>=0;f--)\"-\"!=d[f]&&\"|\"!=d[f]&&d.indexOf(d[f])<f&&d.splice(f,1);var g=b.button.buildList(d,e());b.$tb.append(g),b.button.bindCommands(b.$tb)}function e(){var a=b.helpers.screenSize();return v[a]}function f(){var a=e();b.$tb.find(\".fr-separator\").remove(),b.$tb.find(\"> .fr-command\").addClass(\"fr-hidden\");for(var c=0;c<a.length;c++)if(\"|\"==a[c]||\"-\"==a[c])b.$tb.append(b.button.buildList([a[c]]));else{var d=b.$tb.find('> .fr-command[data-cmd=\"'+a[c]+'\"]'),f=null;b.node.hasClass(d.next().get(0),\"fr-dropdown-menu\")&&(f=d.next()),d.removeClass(\"fr-hidden\").appendTo(b.$tb),f&&f.appendTo(b.$tb)}}function g(){b.events.$on(a(b.o_win),\"resize\",f),b.events.$on(a(b.o_win),\"orientationchange\",f)}function h(c,d){setTimeout(function(){if((!c||c.which!=a.FE.KEYCODE.ESC)&&b.selection.inEditor()&&b.core.hasFocus()&&!b.popups.areVisible()&&(b.opts.toolbarVisibleWithoutSelection||!b.selection.isCollapsed()&&!b.keys.isIME()||d)){if(b.$tb.data(\"instance\",b),!1===b.events.trigger(\"toolbar.show\",[c]))return!1;b.$tb.show(),b.opts.toolbarContainer||b.position.forSelection(b.$tb),b.opts.zIndex>1?b.$tb.css(\"z-index\",b.opts.zIndex+1):b.$tb.css(\"z-index\",null)}},0)}function i(a){return(!a||\"blur\"!==a.type||document.activeElement!==b.el)&&(!(!a||\"keydown\"!==a.type||!b.keys.ctrlKey(a))||(!!b.button.getButtons(\".fr-dropdown.fr-active\").next().find(b.o_doc.activeElement).length||void(!1!==b.events.trigger(\"toolbar.hide\")&&b.$tb.hide())))}function j(){if(!1===b.events.trigger(\"toolbar.show\"))return!1;b.$tb.show()}function k(c){clearTimeout(w),c&&c.which==a.FE.KEYCODE.ESC||(w=setTimeout(h,b.opts.typingTimer))}function l(){b.events.on(\"window.mousedown\",i),b.events.on(\"keydown\",i),b.events.on(\"blur\",i),b.events.on(\"window.mouseup\",h),b.helpers.isMobile()?b.helpers.isIOS()||(b.events.on(\"window.touchend\",h),b.browser.mozilla&&setInterval(h,200)):b.events.on(\"window.keyup\",k),b.events.on(\"keydown\",function(b){b&&b.which==a.FE.KEYCODE.ESC&&i()}),b.events.on(\"keydown\",function(b){if(b.which==a.FE.KEYCODE.ALT)return b.stopPropagation(),!1},!0),b.events.$on(b.$wp,\"scroll.toolbar\",h),b.events.on(\"commands.after\",h),b.helpers.isMobile()&&(b.events.$on(b.$doc,\"selectionchange\",k),b.events.$on(b.$doc,\"orientationchange\",h))}function m(){b.opts.toolbarInline?(b.$sc.append(b.$tb),b.$tb.data(\"container\",b.$sc),b.$tb.addClass(\"fr-inline\"),b.$tb.prepend('<span class=\"fr-arrow\"></span>'),l(),b.opts.toolbarBottom=!1):(b.opts.toolbarBottom&&!b.helpers.isIOS()?(b.$box.append(b.$tb),b.$tb.addClass(\"fr-bottom\"),b.$box.addClass(\"fr-bottom\")):(b.opts.toolbarBottom=!1,b.$box.prepend(b.$tb),b.$tb.addClass(\"fr-top\"),b.$box.addClass(\"fr-top\")),b.$tb.addClass(\"fr-basic\"),b.opts.toolbarSticky&&(b.opts.toolbarStickyOffset&&(b.opts.toolbarBottom?b.$tb.css(\"bottom\",b.opts.toolbarStickyOffset):b.$tb.css(\"top\",b.opts.toolbarStickyOffset)),b.position.addSticky(b.$tb)))}function n(){b.$tb.html(\"\").removeData().remove(),b.$tb=null}function o(){b.$box.removeClass(\"fr-top fr-bottom fr-inline fr-basic\"),b.$box.find(\".fr-sticky-dummy\").remove()}function p(){b.opts.theme&&b.$tb.addClass(b.opts.theme+\"-theme\"),b.opts.zIndex>1&&b.$tb.css(\"z-index\",b.opts.zIndex+1),\"auto\"!=b.opts.direction&&b.$tb.removeClass(\"fr-ltr fr-rtl\").addClass(\"fr-\"+b.opts.direction),b.helpers.isMobile()?b.$tb.addClass(\"fr-mobile\"):b.$tb.addClass(\"fr-desktop\"),b.opts.toolbarContainer?(b.opts.toolbarInline&&(l(),i()),b.opts.toolbarBottom?b.$tb.addClass(\"fr-bottom\"):b.$tb.addClass(\"fr-top\")):m(),t=b.$tb.get(0).ownerDocument,u=\"defaultView\"in t?t.defaultView:t.parentWindow,d(),g(),b.accessibility.registerToolbar(b.$tb),b.events.$on(b.$tb,b._mousedown+\" \"+b._mouseup,function(a){var c=a.originalEvent?a.originalEvent.target||a.originalEvent.originalTarget:null;if(c&&\"INPUT\"!=c.tagName&&!b.edit.isDisabled())return a.stopPropagation(),a.preventDefault(),!1},!0)}function q(){if(b.$sc=a(b.opts.scrollableContainer).first(),!b.$wp)return!1;b.opts.toolbarContainer?(b.shared.$tb?(b.$tb=b.shared.$tb,b.opts.toolbarInline&&l()):(b.shared.$tb=a('<div class=\"fr-toolbar\"></div>'),b.$tb=b.shared.$tb,a(b.opts.toolbarContainer).append(b.$tb),p(),b.$tb.data(\"instance\",b)),b.opts.toolbarInline?b.$box.addClass(\"fr-inline\"):b.$box.addClass(\"fr-basic\"),b.events.on(\"focus\",function(){b.$tb.data(\"instance\",b)},!0),b.opts.toolbarInline=!1):b.opts.toolbarInline?(b.$box.addClass(\"fr-inline\"),b.shared.$tb?(b.$tb=b.shared.$tb,l()):(b.shared.$tb=a('<div class=\"fr-toolbar\"></div>'),b.$tb=b.shared.$tb,p())):(b.$box.addClass(\"fr-basic\"),b.$tb=a('<div class=\"fr-toolbar\"></div>'),p(),b.$tb.data(\"instance\",b)),b.events.on(\"destroy\",o,!0),b.events.on(b.opts.toolbarInline||b.opts.toolbarContainer?\"shared.destroy\":\"destroy\",n,!0)}function r(){!x&&b.$tb&&(b.$tb.find(\"> .fr-command\").addClass(\"fr-disabled fr-no-refresh\").attr(\"aria-disabled\",!0),x=!0)}function s(){x&&b.$tb&&(b.$tb.find(\"> .fr-command\").removeClass(\"fr-disabled fr-no-refresh\").attr(\"aria-disabled\",!1),x=!1),b.button.bulkRefresh()}var t,u,v=[];v[a.FE.XS]=b.opts.toolbarButtonsXS||b.opts.toolbarButtons,v[a.FE.SM]=b.opts.toolbarButtonsSM||b.opts.toolbarButtons,v[a.FE.MD]=b.opts.toolbarButtonsMD||b.opts.toolbarButtons,v[a.FE.LG]=b.opts.toolbarButtons;var w=null,x=!1;return{_init:q,hide:i,show:j,showInline:h,disable:r,enable:s}}});"

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1468))

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.PLUGINS.fullscreen=function(b){function c(){return b.$box.hasClass(\"fr-fullscreen\")}function d(){i=b.helpers.scrollTop(),b.$box.toggleClass(\"fr-fullscreen\"),a(\"body:first\").toggleClass(\"fr-fullscreen\"),j=a('<div style=\"display: none;\"></div>'),b.$box.after(j),b.helpers.isMobile()&&(b.$tb.data(\"parent\",b.$tb.parent()),b.$tb.prependTo(b.$box),b.$tb.data(\"sticky-dummy\")&&b.$tb.after(b.$tb.data(\"sticky-dummy\"))),k=b.opts.height,l=b.opts.heightMax,m=b.opts.zIndex,b.position.refresh(),b.opts.height=b.o_win.innerHeight-(b.opts.toolbarInline?0:b.$tb.outerHeight()),b.opts.zIndex=2147483641,b.opts.heightMax=null,b.size.refresh(),b.opts.toolbarInline&&b.toolbar.showInline();for(var c=b.$box.parent();!c.is(\"body:first\");)c.data(\"z-index\",c.css(\"z-index\")).data(\"overflow\",c.css(\"overflow\")).css(\"z-index\",\"2147483640\").css(\"overflow\",\"visible\"),c=c.parent();b.events.trigger(\"charCounter.update\"),b.$win.trigger(\"scroll\")}function e(){b.$box.toggleClass(\"fr-fullscreen\"),a(\"body:first\").toggleClass(\"fr-fullscreen\"),b.$tb.prependTo(b.$tb.data(\"parent\")),b.$tb.data(\"sticky-dummy\")&&b.$tb.after(b.$tb.data(\"sticky-dummy\")),b.opts.height=k,b.opts.heightMax=l,b.opts.zIndex=m,b.size.refresh(),a(b.o_win).scrollTop(i),b.opts.toolbarInline&&b.toolbar.showInline(),b.events.trigger(\"charCounter.update\"),b.opts.toolbarSticky&&b.opts.toolbarStickyOffset&&(b.opts.toolbarBottom?b.$tb.css(\"bottom\",b.opts.toolbarStickyOffset).data(\"bottom\",b.opts.toolbarStickyOffset):b.$tb.css(\"top\",b.opts.toolbarStickyOffset).data(\"top\",b.opts.toolbarStickyOffset));for(var c=b.$box.parent();!c.is(\"body:first\");)c.data(\"z-index\")&&(c.css(\"z-index\",\"\"),c.css(\"z-index\")!=c.data(\"z-index\")&&c.css(\"z-index\",c.data(\"z-index\")),c.removeData(\"z-index\")),c.data(\"overflow\")?(c.css(\"overflow\",\"\"),c.css(\"overflow\")!=c.data(\"overflow\")&&c.css(\"overflow\",c.data(\"overflow\")),c.removeData(\"overflow\")):(c.css(\"overflow\",\"\"),c.removeData(\"overflow\")),c=c.parent();b.$win.trigger(\"scroll\")}function f(){c()?e():d(),g(b.$tb.find('.fr-command[data-cmd=\"fullscreen\"]'))}function g(a){var d=c();a.toggleClass(\"fr-active\",d).attr(\"aria-pressed\",d),a.find(\"> *:not(.fr-sr-only)\").replaceWith(d?b.icon.create(\"fullscreenCompress\"):b.icon.create(\"fullscreen\"))}function h(){if(!b.$wp)return!1;b.events.$on(a(b.o_win),\"resize\",function(){c()&&(e(),d())}),b.events.on(\"toolbar.hide\",function(){if(c()&&b.helpers.isMobile())return!1}),b.events.on(\"destroy\",function(){c()&&e()},!0)}var i,j,k,l,m;return{_init:h,toggle:f,refresh:g,isActive:c}},a.FE.RegisterCommand(\"fullscreen\",{title:\"Fullscreen\",undo:!1,focus:!1,accessibilityFocus:!0,forcedRefresh:!0,toggle:!0,callback:function(){this.fullscreen.toggle()},refresh:function(a){this.fullscreen.refresh(a)},plugin:\"fullscreen\"}),a.FE.DefineIcon(\"fullscreen\",{NAME:\"expand\"}),a.FE.DefineIcon(\"fullscreenCompress\",{NAME:\"compress\"})});"

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1470))

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{codeMirror:window.CodeMirror,codeMirrorOptions:{lineNumbers:!0,tabMode:\"indent\",indentWithTabs:!0,lineWrapping:!0,mode:\"text/html\",tabSize:2},codeBeautifierOptions:{end_with_newline:!0,indent_inner_html:!0,extra_liners:[\"p\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"blockquote\",\"pre\",\"ul\",\"ol\",\"table\",\"dl\"],brace_style:\"expand\",indent_char:\"\\t\",indent_size:1,wrap_line_length:0},codeViewKeepActiveButtons:[\"fullscreen\"]}),a.FE.PLUGINS.codeView=function(b){function c(){return b.$box.hasClass(\"fr-code-view\")}function d(){return l?l.getValue():k.val()}function e(a){var c=d();b.html.set(c),b.$el.blur(),b.$tb.find(\" > .fr-command\").not(a).removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1),a.removeClass(\"fr-active\").attr(\"aria-pressed\",!1),b.selection.setAtStart(b.el),b.selection.restore(),b.placeholder.refresh(),b.undo.saveStep()}function f(c){k||(i(),!l&&b.opts.codeMirror?l=b.opts.codeMirror.fromTextArea(k.get(0),b.opts.codeMirrorOptions):b.events.$on(k,\"keydown keyup change input\",function(){b.opts.height?this.removeAttribute(\"rows\"):(this.rows=1,0===this.value.length?this.style.height=\"auto\":this.style.height=this.scrollHeight+\"px\")})),b.undo.saveStep(),b.html.cleanEmptyTags(),b.html.cleanWhiteTags(!0),b.core.hasFocus()&&(b.core.isEmpty()||(b.selection.save(),b.$el.find('.fr-marker[data-type=\"true\"]:first').replaceWith('<span class=\"fr-tmp fr-sm\">F</span>'),b.$el.find('.fr-marker[data-type=\"false\"]:last').replaceWith('<span class=\"fr-tmp fr-em\">F</span>')));var d=b.html.get(!1,!0);b.$el.find(\"span.fr-tmp\").remove(),b.$box.toggleClass(\"fr-code-view\",!0),b.core.hasFocus()&&b.$el.blur(),d=d.replace(/<span class=\"fr-tmp fr-sm\">F<\\/span>/,\"FROALA-SM\"),d=d.replace(/<span class=\"fr-tmp fr-em\">F<\\/span>/,\"FROALA-EM\"),b.codeBeautifier&&(d=b.codeBeautifier.run(d,b.opts.codeBeautifierOptions));var e,f;if(l){e=d.indexOf(\"FROALA-SM\"),f=d.indexOf(\"FROALA-EM\"),e>f?e=f:f-=9,d=d.replace(/FROALA-SM/g,\"\").replace(/FROALA-EM/g,\"\");var g=d.substring(0,e).length-d.substring(0,e).replace(/\\n/g,\"\").length,h=d.substring(0,f).length-d.substring(0,f).replace(/\\n/g,\"\").length;e=d.substring(0,e).length-d.substring(0,d.substring(0,e).lastIndexOf(\"\\n\")+1).length,f=d.substring(0,f).length-d.substring(0,d.substring(0,f).lastIndexOf(\"\\n\")+1).length,l.setSize(null,b.opts.height?b.opts.height:\"auto\"),b.opts.heightMin&&b.$box.find(\".CodeMirror-scroll\").css(\"min-height\",b.opts.heightMin),l.setValue(d),l.focus(),l.setSelection({line:g,ch:e},{line:h,ch:f}),l.refresh(),l.clearHistory()}else{e=d.indexOf(\"FROALA-SM\"),f=d.indexOf(\"FROALA-EM\")-9,b.opts.heightMin&&k.css(\"min-height\",b.opts.heightMin),b.opts.height&&k.css(\"height\",b.opts.height),b.opts.heightMax&&k.css(\"max-height\",b.opts.height||b.opts.heightMax),k.val(d.replace(/FROALA-SM/g,\"\").replace(/FROALA-EM/g,\"\")).trigger(\"change\");var j=a(b.o_doc).scrollTop();k.focus(),k.get(0).setSelectionRange(e,f),a(b.o_doc).scrollTop(j)}b.$tb.find(\" > .fr-command\").not(c).filter(function(){return b.opts.codeViewKeepActiveButtons.indexOf(a(this).data(\"cmd\"))<0}).addClass(\"fr-disabled\").attr(\"aria-disabled\",!0),c.addClass(\"fr-active\").attr(\"aria-pressed\",!0),!b.helpers.isMobile()&&b.opts.toolbarInline&&b.toolbar.hide()}function g(a){void 0===a&&(a=!c());var d=b.$tb.find('.fr-command[data-cmd=\"html\"]');a?(b.popups.hideAll(),f(d)):(b.$box.toggleClass(\"fr-code-view\",!1),e(d))}function h(){c()&&g(!1),l&&l.toTextArea(),k.val(\"\").removeData().remove(),k=null,m&&(m.remove(),m=null)}function i(){k=a('<textarea class=\"fr-code\" tabIndex=\"-1\">'),b.$wp.append(k),k.attr(\"dir\",b.opts.direction),b.$box.hasClass(\"fr-basic\")||(m=a('<a data-cmd=\"html\" title=\"Code View\" class=\"fr-command fr-btn html-switch'+(b.helpers.isMobile()?\"\":\" fr-desktop\")+'\" role=\"button\" tabIndex=\"-1\"><i class=\"fa fa-code\"></i></button>'),b.$box.append(m),b.events.bindClick(b.$box,\"a.html-switch\",function(){g(!1)}));var e=function(){return!c()};b.events.on(\"buttons.refresh\",e),b.events.on(\"copy\",e,!0),b.events.on(\"cut\",e,!0),b.events.on(\"paste\",e,!0),b.events.on(\"destroy\",h,!0),b.events.on(\"html.set\",function(){c()&&g(!0)}),b.events.on(\"form.submit\",function(){c()&&(b.html.set(d()),b.events.trigger(\"contentChanged\",[],!0))},!0)}function j(){if(!b.$wp)return!1}var k,l,m;return{_init:j,toggle:g,isActive:c,get:d}},a.FE.RegisterCommand(\"html\",{title:\"Code View\",undo:!1,focus:!1,forcedRefresh:!0,toggle:!0,callback:function(){this.codeView.toggle()},plugin:\"codeView\"}),a.FE.DefineIcon(\"html\",{NAME:\"code\"})});"

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1472))

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.PLUGINS.align=function(b){function c(c){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var d=b.selection.blocks(),e=0;e<d.length;e++)b.helpers.getAlignment(a(d[e].parentNode))==c?a(d[e]).css(\"text-align\",\"\").removeClass(\"fr-temp-div\"):a(d[e]).css(\"text-align\",c).removeClass(\"fr-temp-div\"),\"\"===a(d[e]).attr(\"class\")&&a(d[e]).removeAttr(\"class\"),\"\"===a(d[e]).attr(\"style\")&&a(d[e]).removeAttr(\"style\");b.selection.save(),b.html.unwrap(),b.selection.restore()}function d(c){var d=b.selection.blocks();if(d.length){var e=b.helpers.getAlignment(a(d[0]));c.find(\"> *:first\").replaceWith(b.icon.create(\"align-\"+e))}}function e(c,d){var e=b.selection.blocks();if(e.length){var f=b.helpers.getAlignment(a(e[0]));d.find('a.fr-command[data-param1=\"'+f+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}}return{apply:c,refresh:d,refreshOnShow:e}},a.FE.DefineIcon(\"align\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"align-left\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"align-right\",{NAME:\"align-right\"}),a.FE.DefineIcon(\"align-center\",{NAME:\"align-center\"}),a.FE.DefineIcon(\"align-justify\",{NAME:\"align-justify\"}),a.FE.RegisterCommand(\"align\",{type:\"dropdown\",title:\"Align\",options:{left:\"Align Left\",center:\"Align Center\",right:\"Align Right\",justify:\"Align Justify\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.align.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command fr-title\" tabIndex=\"-1\" role=\"option\" data-cmd=\"align\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.icon.create(\"align-\"+d)+'<span class=\"fr-sr-only\">'+this.language.translate(c[d])+\"</span></a></li>\");return b+=\"</ul>\"},callback:function(a,b){this.align.apply(b)},refresh:function(a){this.align.refresh(a)},refreshOnShow:function(a,b){this.align.refreshOnShow(a,b)},plugin:\"align\"})});"

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1474))

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{charCounterMax:-1,charCounterCount:!0}),a.FE.PLUGINS.charCounter=function(b){function c(){return(b.el.textContent||\"\").replace(/\\u200B/g,\"\").length}function d(d){if(b.opts.charCounterMax<0)return!0;if(c()<b.opts.charCounterMax)return!0;var e=d.which;return!(!b.keys.ctrlKey(d)&&b.keys.isCharacter(e)||e===a.FE.KEYCODE.IME)||(d.preventDefault(),d.stopPropagation(),b.events.trigger(\"charCounter.exceeded\"),!1)}function e(d){return b.opts.charCounterMax<0?d:a(\"<div>\").html(d).text().length+c()<=b.opts.charCounterMax?d:(b.events.trigger(\"charCounter.exceeded\"),\"\")}function f(){if(b.opts.charCounterCount){var a=c()+(b.opts.charCounterMax>0?\"/\"+b.opts.charCounterMax:\"\");h.text(a),b.opts.toolbarBottom&&h.css(\"margin-bottom\",b.$tb.outerHeight(!0));var d=b.$wp.get(0).offsetWidth-b.$wp.get(0).clientWidth;d>=0&&(\"rtl\"==b.opts.direction?h.css(\"margin-left\",d):h.css(\"margin-right\",d))}}function g(){return!!b.$wp&&(!!b.opts.charCounterCount&&(h=a('<span class=\"fr-counter\"></span>'),h.css(\"bottom\",b.$wp.css(\"border-bottom-width\")),b.$box.append(h),b.events.on(\"keydown\",d,!0),b.events.on(\"paste.afterCleanup\",e),b.events.on(\"keyup contentChanged input\",function(){b.events.trigger(\"charCounter.update\")}),b.events.on(\"charCounter.update\",f),b.events.trigger(\"charCounter.update\"),void b.events.on(\"destroy\",function(){a(b.o_win).off(\"resize.char\"+b.id),h.removeData().remove(),h=null})))}var h;return{_init:g,count:c}}});"

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1476))

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.PLUGINS.codeBeautifier=function(){function a(a,c){function d(a){return a.replace(/^\\s+/g,\"\")}function e(a){return a.replace(/\\s+$/g,\"\")}function g(){return this.pos=0,this.token=\"\",this.current_mode=\"CONTENT\",this.tags={parent:\"parent1\",parentcount:1,parent1:\"\"},this.tag_type=\"\",this.token_text=this.last_token=this.last_text=this.token_type=\"\",this.newlines=0,this.indent_content=i,this.Utils={whitespace:\"\\n\\r\\t \".split(\"\"),single_token:\"br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed\".split(\",\"),extra_liners:u,in_array:function(a,b){for(var c=0;c<b.length;c++)if(a==b[c])return!0;return!1}},this.is_whitespace=function(a){for(var b=0;b<a.length;a++)if(!this.Utils.in_array(a.charAt(b),this.Utils.whitespace))return!1;return!0},this.traverse_whitespace=function(){var a=\"\";if(a=this.input.charAt(this.pos),this.Utils.in_array(a,this.Utils.whitespace)){for(this.newlines=0;this.Utils.in_array(a,this.Utils.whitespace);)o&&\"\\n\"==a&&this.newlines<=p&&(this.newlines+=1),this.pos++,a=this.input.charAt(this.pos);return!0}return!1},this.space_or_wrap=function(a){this.line_char_count>=this.wrap_line_length?(this.print_newline(!1,a),this.print_indentation(a)):(this.line_char_count++,a.push(\" \"))},this.get_content=function(){for(var a=\"\",b=[];\"<\"!=this.input.charAt(this.pos);){if(this.pos>=this.input.length)return b.length?b.join(\"\"):[\"\",\"TK_EOF\"];if(this.traverse_whitespace())this.space_or_wrap(b);else{if(q){var c=this.input.substr(this.pos,3);if(\"{{#\"==c||\"{{/\"==c)break;if(\"{{!\"==c)return[this.get_tag(),\"TK_TAG_HANDLEBARS_COMMENT\"];if(\"{{\"==this.input.substr(this.pos,2)&&\"{{else}}\"==this.get_tag(!0))break}a=this.input.charAt(this.pos),this.pos++,this.line_char_count++,b.push(a)}}return b.length?b.join(\"\"):\"\"},this.get_contents_to=function(a){if(this.pos==this.input.length)return[\"\",\"TK_EOF\"];var b=\"\",c=new RegExp(\"</\"+a+\"\\\\s*>\",\"igm\");c.lastIndex=this.pos;var d=c.exec(this.input),e=d?d.index:this.input.length;return this.pos<e&&(b=this.input.substring(this.pos,e),this.pos=e),b},this.record_tag=function(a){this.tags[a+\"count\"]?(this.tags[a+\"count\"]++,this.tags[a+this.tags[a+\"count\"]]=this.indent_level):(this.tags[a+\"count\"]=1,this.tags[a+this.tags[a+\"count\"]]=this.indent_level),this.tags[a+this.tags[a+\"count\"]+\"parent\"]=this.tags.parent,this.tags.parent=a+this.tags[a+\"count\"]},this.retrieve_tag=function(a){if(this.tags[a+\"count\"]){for(var b=this.tags.parent;b&&a+this.tags[a+\"count\"]!=b;)b=this.tags[b+\"parent\"];b&&(this.indent_level=this.tags[a+this.tags[a+\"count\"]],this.tags.parent=this.tags[b+\"parent\"]),delete this.tags[a+this.tags[a+\"count\"]+\"parent\"],delete this.tags[a+this.tags[a+\"count\"]],1==this.tags[a+\"count\"]?delete this.tags[a+\"count\"]:this.tags[a+\"count\"]--}},this.indent_to_tag=function(a){if(this.tags[a+\"count\"]){for(var b=this.tags.parent;b&&a+this.tags[a+\"count\"]!=b;)b=this.tags[b+\"parent\"];b&&(this.indent_level=this.tags[a+this.tags[a+\"count\"]])}},this.get_tag=function(a){var b,c,d=\"\",e=[],f=\"\",g=!1,h=!0,i=this.pos,j=this.line_char_count;a=void 0!==a&&a;do{if(this.pos>=this.input.length)return a&&(this.pos=i,this.line_char_count=j),e.length?e.join(\"\"):[\"\",\"TK_EOF\"];if(d=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(d,this.Utils.whitespace))g=!0;else{if(\"'\"!=d&&'\"'!=d||(d+=this.get_unformatted(d),g=!0),\"=\"==d&&(g=!1),e.length&&\"=\"!=e[e.length-1]&&\">\"!=d&&g){if(this.space_or_wrap(e),g=!1,!h&&\"force\"==r&&\"/\"!=d){this.print_newline(!0,e),this.print_indentation(e);for(var l=0;l<s;l++)e.push(k)}for(var m=0;m<e.length;m++)if(\" \"==e[m]){h=!1;break}}if(q&&\"<\"==c&&d+this.input.charAt(this.pos)==\"{{\"&&(d+=this.get_unformatted(\"}}\"),e.length&&\" \"!=e[e.length-1]&&\"<\"!=e[e.length-1]&&(d=\" \"+d),g=!0),\"<\"!=d||c||(b=this.pos-1,c=\"<\"),q&&!c&&e.length>=2&&\"{\"==e[e.length-1]&&\"{\"==e[e.length-2]&&(b=\"#\"==d||\"/\"==d||\"!\"==d?this.pos-3:this.pos-2,c=\"{\"),this.line_char_count++,e.push(d),e[1]&&(\"!\"==e[1]||\"?\"==e[1]||\"%\"==e[1])){e=[this.get_comment(b)];break}if(q&&e[1]&&\"{\"==e[1]&&e[2]&&\"!\"==e[2]){e=[this.get_comment(b)];break}if(q&&\"{\"==c&&e.length>2&&\"}\"==e[e.length-2]&&\"}\"==e[e.length-1])break}}while(\">\"!=d);var o,p,t=e.join(\"\");o=-1!=t.indexOf(\" \")?t.indexOf(\" \"):\"{\"==t[0]?t.indexOf(\"}\"):t.indexOf(\">\"),p=\"<\"!=t[0]&&q?\"#\"==t[2]?3:2:1;var u=t.substring(p,o).toLowerCase();return\"/\"==t.charAt(t.length-2)||this.Utils.in_array(u,this.Utils.single_token)?a||(this.tag_type=\"SINGLE\"):q&&\"{\"==t[0]&&\"else\"==u?a||(this.indent_to_tag(\"if\"),this.tag_type=\"HANDLEBARS_ELSE\",this.indent_content=!0,this.traverse_whitespace()):this.is_unformatted(u,n)?(f=this.get_unformatted(\"</\"+u+\">\",t),e.push(f),this.pos-1,this.tag_type=\"SINGLE\"):\"script\"==u&&(-1==t.search(\"type\")||t.search(\"type\")>-1&&t.search(/\\b(text|application)\\/(x-)?(javascript|ecmascript|jscript|livescript)/)>-1)?a||(this.record_tag(u),this.tag_type=\"SCRIPT\"):\"style\"==u&&(-1==t.search(\"type\")||t.search(\"type\")>-1&&t.search(\"text/css\")>-1)?a||(this.record_tag(u),this.tag_type=\"STYLE\"):\"!\"==u.charAt(0)?a||(this.tag_type=\"SINGLE\",this.traverse_whitespace()):a||(\"/\"==u.charAt(0)?(this.retrieve_tag(u.substring(1)),this.tag_type=\"END\"):(this.record_tag(u),\"html\"!=u.toLowerCase()&&(this.indent_content=!0),this.tag_type=\"START\"),this.traverse_whitespace()&&this.space_or_wrap(e),this.Utils.in_array(u,this.Utils.extra_liners)&&(this.print_newline(!1,this.output),this.output.length&&\"\\n\"!=this.output[this.output.length-2]&&this.print_newline(!0,this.output))),a&&(this.pos=i,this.line_char_count=j),e.join(\"\")},this.get_comment=function(a){var b=\"\",c=\">\",d=!1;this.pos=a;var e=this.input.charAt(this.pos);for(this.pos++;this.pos<=this.input.length&&(b+=e,b[b.length-1]!=c[c.length-1]||-1==b.indexOf(c));)!d&&b.length<10&&(0===b.indexOf(\"<![if\")?(c=\"<![endif]>\",d=!0):0===b.indexOf(\"<![cdata[\")?(c=\"]]>\",d=!0):0===b.indexOf(\"<![\")?(c=\"]>\",d=!0):0===b.indexOf(\"\\x3c!--\")?(c=\"--\\x3e\",d=!0):0===b.indexOf(\"{{!\")?(c=\"}}\",d=!0):0===b.indexOf(\"<?\")?(c=\"?>\",d=!0):0===b.indexOf(\"<%\")&&(c=\"%>\",d=!0)),e=this.input.charAt(this.pos),this.pos++;return b},this.get_unformatted=function(a,b){if(b&&-1!=b.toLowerCase().indexOf(a))return\"\";var c=\"\",d=\"\",e=0,f=!0;do{if(this.pos>=this.input.length)return d;if(c=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(c,this.Utils.whitespace)){if(!f){this.line_char_count--;continue}if(\"\\n\"==c||\"\\r\"==c){d+=\"\\n\",this.line_char_count=0;continue}}d+=c,this.line_char_count++,f=!0,q&&\"{\"==c&&d.length&&\"{\"==d[d.length-2]&&(d+=this.get_unformatted(\"}}\"),e=d.length)}while(-1==d.toLowerCase().indexOf(a,e));return d},this.get_token=function(){var a;if(\"TK_TAG_SCRIPT\"==this.last_token||\"TK_TAG_STYLE\"==this.last_token){var b=this.last_token.substr(7);return a=this.get_contents_to(b),\"string\"!=typeof a?a:[a,\"TK_\"+b]}if(\"CONTENT\"==this.current_mode)return a=this.get_content(),\"string\"!=typeof a?a:[a,\"TK_CONTENT\"];if(\"TAG\"==this.current_mode){if(\"string\"!=typeof(a=this.get_tag()))return a;return[a,\"TK_TAG_\"+this.tag_type]}},this.get_full_indent=function(a){return a=this.indent_level+a||0,a<1?\"\":new Array(a+1).join(this.indent_string)},this.is_unformatted=function(a,b){if(!this.Utils.in_array(a,b))return!1;if(\"a\"!=a.toLowerCase()||!this.Utils.in_array(\"a\",b))return!0;var c=this.get_tag(!0),d=(c||\"\").match(/^\\s*<\\s*\\/?([a-z]*)\\s*[^>]*>\\s*$/);return!(d&&!this.Utils.in_array(d,b))},this.printer=function(a,b,c,f,g){this.input=a||\"\",this.output=[],this.indent_character=b,this.indent_string=\"\",this.indent_size=c,this.brace_style=g,this.indent_level=0,this.wrap_line_length=f,this.line_char_count=0;for(var h=0;h<this.indent_size;h++)this.indent_string+=this.indent_character;this.print_newline=function(a,b){this.line_char_count=0,b&&b.length&&(a||\"\\n\"!=b[b.length-1])&&(\"\\n\"!=b[b.length-1]&&(b[b.length-1]=e(b[b.length-1])),b.push(\"\\n\"))},this.print_indentation=function(a){for(var b=0;b<this.indent_level;b++)a.push(this.indent_string),this.line_char_count+=this.indent_string.length},this.print_token=function(a){this.is_whitespace(a)&&!this.output.length||((a||\"\"!==a)&&this.output.length&&\"\\n\"==this.output[this.output.length-1]&&(this.print_indentation(this.output),a=d(a)),this.print_token_raw(a))},this.print_token_raw=function(a){this.newlines>0&&(a=e(a)),a&&\"\"!==a&&(a.length>1&&\"\\n\"==a[a.length-1]?(this.output.push(a.slice(0,-1)),this.print_newline(!1,this.output)):this.output.push(a));for(var b=0;b<this.newlines;b++)this.print_newline(b>0,this.output);this.newlines=0},this.indent=function(){this.indent_level++},this.unindent=function(){this.indent_level>0&&this.indent_level--}},this}var h,i,j,k,l,m,n,o,p,q,r,s,t,u;for(c=c||{},void 0!==c.wrap_line_length&&0!==parseInt(c.wrap_line_length,10)||void 0===c.max_char||0===parseInt(c.max_char,10)||(c.wrap_line_length=c.max_char),i=void 0!==c.indent_inner_html&&c.indent_inner_html,j=void 0===c.indent_size?4:parseInt(c.indent_size,10),k=void 0===c.indent_char?\" \":c.indent_char,m=void 0===c.brace_style?\"collapse\":c.brace_style,l=0===parseInt(c.wrap_line_length,10)?32786:parseInt(c.wrap_line_length||250,10),n=c.unformatted||[\"a\",\"span\",\"img\",\"bdo\",\"em\",\"strong\",\"dfn\",\"code\",\"samp\",\"kbd\",\"var\",\"cite\",\"abbr\",\"acronym\",\"q\",\"sub\",\"sup\",\"tt\",\"i\",\"b\",\"big\",\"small\",\"u\",\"s\",\"strike\",\"font\",\"ins\",\"del\",\"address\",\"pre\"],o=void 0===c.preserve_newlines||c.preserve_newlines,p=o?isNaN(parseInt(c.max_preserve_newlines,10))?32786:parseInt(c.max_preserve_newlines,10):0,q=void 0!==c.indent_handlebars&&c.indent_handlebars,r=void 0===c.wrap_attributes?\"auto\":c.wrap_attributes,s=void 0===c.wrap_attributes_indent_size?j:parseInt(c.wrap_attributes_indent_size,10)||j,t=void 0!==c.end_with_newline&&c.end_with_newline,u=Array.isArray(c.extra_liners)?c.extra_liners.concat():\"string\"==typeof c.extra_liners?c.extra_liners.split(\",\"):\"head,body,/html\".split(\",\"),c.indent_with_tabs&&(k=\"\\t\",j=1),h=new g,h.printer(a,k,j,l,m);;){var v=h.get_token();if(h.token_text=v[0],h.token_type=v[1],\"TK_EOF\"==h.token_type)break;switch(h.token_type){case\"TK_TAG_START\":h.print_newline(!1,h.output),h.print_token(h.token_text),h.indent_content&&(h.indent(),h.indent_content=!1),h.current_mode=\"CONTENT\";break;case\"TK_TAG_STYLE\":case\"TK_TAG_SCRIPT\":h.print_newline(!1,h.output),h.print_token(h.token_text),h.current_mode=\"CONTENT\";break;case\"TK_TAG_END\":if(\"TK_CONTENT\"==h.last_token&&\"\"===h.last_text){var w=h.token_text.match(/\\w+/)[0],x=null;h.output.length&&(x=h.output[h.output.length-1].match(/(?:<|{{#)\\s*(\\w+)/)),(null==x||x[1]!=w&&!h.Utils.in_array(x[1],n))&&h.print_newline(!1,h.output)}h.print_token(h.token_text),h.current_mode=\"CONTENT\";break;case\"TK_TAG_SINGLE\":var y=h.token_text.match(/^\\s*<([a-z-]+)/i);y&&h.Utils.in_array(y[1],n)||h.print_newline(!1,h.output),h.print_token(h.token_text),h.current_mode=\"CONTENT\";break;case\"TK_TAG_HANDLEBARS_ELSE\":h.print_token(h.token_text),h.indent_content&&(h.indent(),h.indent_content=!1),h.current_mode=\"CONTENT\";break;case\"TK_TAG_HANDLEBARS_COMMENT\":case\"TK_CONTENT\":h.print_token(h.token_text),h.current_mode=\"TAG\";break;case\"TK_STYLE\":case\"TK_SCRIPT\":if(\"\"!==h.token_text){h.print_newline(!1,h.output);var z,A=h.token_text,B=1;\"TK_SCRIPT\"==h.token_type?z=\"function\"==typeof f&&f:\"TK_STYLE\"==h.token_type&&(z=\"function\"==typeof b&&b),\"keep\"==c.indent_scripts?B=0:\"separate\"==c.indent_scripts&&(B=-h.indent_level);var C=h.get_full_indent(B);if(z)A=z(A.replace(/^\\s*/,C),c);else{var D=A.match(/^\\s*/)[0],E=D.match(/[^\\n\\r]*$/)[0].split(h.indent_string).length-1,F=h.get_full_indent(B-E);A=A.replace(/^\\s*/,C).replace(/\\r\\n|\\r|\\n/g,\"\\n\"+F).replace(/\\s+$/,\"\")}A&&(h.print_token_raw(A),h.print_newline(!0,h.output))}h.current_mode=\"TAG\";break;default:\"\"!==h.token_text&&h.print_token(h.token_text)}h.last_token=h.token_type,h.last_text=h.token_text}var G=h.output.join(\"\").replace(/[\\r\\n\\t ]+$/,\"\");return t&&(G+=\"\\n\"),G}function b(a,b){function c(){return(v=a.charAt(++x))||\"\"}function d(b){var d=\"\",e=x;return b&&g(),d=a.charAt(x+1)||\"\",x=e-1,c(),d}function e(b){for(var d=x;c();)if(\"\\\\\"===v)c();else{if(-1!==b.indexOf(v))break;if(\"\\n\"===v)break}return a.substring(d,x+1)}function f(a){var b=x,d=e(a);return x=b-1,c(),d}function g(){for(var a=\"\";w.test(d());)c(),a+=v;return a}function h(){var a=\"\";for(v&&w.test(v)&&(a=v);w.test(c());)a+=v;return a}function i(b){var e=x;for(b=\"/\"===d(),c();c();){if(!b&&\"*\"===v&&\"/\"===d()){c();break}if(b&&\"\\n\"===v)return a.substring(e,x)}return a.substring(e,x)+v}function j(b){return a.substring(x-b.length,x).toLowerCase()===b}function k(){for(var b=0,c=x+1;c<a.length;c++){var d=a.charAt(c);if(\"{\"===d)return!0;if(\"(\"===d)b+=1;else if(\")\"===d){if(0==b)return!1;b-=1}else if(\";\"===d||\"}\"===d)return!1}return!1}function l(){B++,z+=A}function m(){B--,z=z.slice(0,-p)}var n={\"@page\":!0,\"@font-face\":!0,\"@keyframes\":!0,\"@media\":!0,\"@supports\":!0,\"@document\":!0},o={\"@media\":!0,\"@supports\":!0,\"@document\":!0};b=b||{},a=a||\"\",a=a.replace(/\\r\\n|[\\r\\u2028\\u2029]/g,\"\\n\");var p=b.indent_size||4,q=b.indent_char||\" \",r=void 0===b.selector_separator_newline||b.selector_separator_newline,s=void 0!==b.end_with_newline&&b.end_with_newline,t=void 0===b.newline_between_rules||b.newline_between_rules,u=b.eol?b.eol:\"\\n\";\"string\"==typeof p&&(p=parseInt(p,10)),b.indent_with_tabs&&(q=\"\\t\",p=1),u=u.replace(/\\\\r/,\"\\r\").replace(/\\\\n/,\"\\n\");var v,w=/^\\s+$/,x=-1,y=0,z=a.match(/^[\\t ]*/)[0],A=new Array(p+1).join(q),B=0,C=0,D={};D[\"{\"]=function(a){D.singleSpace(),E.push(a),D.newLine()},D[\"}\"]=function(a){D.newLine(),E.push(a),D.newLine()},D._lastCharWhitespace=function(){return w.test(E[E.length-1])},D.newLine=function(a){E.length&&(a||\"\\n\"===E[E.length-1]||D.trim(),E.push(\"\\n\"),z&&E.push(z))},D.singleSpace=function(){E.length&&!D._lastCharWhitespace()&&E.push(\" \")},D.preserveSingleSpace=function(){L&&D.singleSpace()},D.trim=function(){for(;D._lastCharWhitespace();)E.pop()};for(var E=[],F=!1,G=!1,H=!1,I=\"\",J=\"\";;){var K=h(),L=\"\"!==K,M=-1!==K.indexOf(\"\\n\");if(J=I,I=v,!v)break;if(\"/\"===v&&\"*\"===d()){var N=0===B;(M||N)&&D.newLine(),E.push(i()),D.newLine(),N&&D.newLine(!0)}else if(\"/\"===v&&\"/\"===d())M||\"{\"===J||D.trim(),D.singleSpace(),E.push(i()),D.newLine();else if(\"@\"===v){D.preserveSingleSpace(),E.push(v);var O=f(\": ,;{}()[]/='\\\"\");O.match(/[ :]$/)&&(c(),O=e(\": \").replace(/\\s$/,\"\"),E.push(O),D.singleSpace()),O=O.replace(/\\s$/,\"\"),O in n&&(C+=1,O in o&&(H=!0))}else\"#\"===v&&\"{\"===d()?(D.preserveSingleSpace(),E.push(e(\"}\"))):\"{\"===v?\"}\"===d(!0)?(g(),c(),D.singleSpace(),E.push(\"{}\"),D.newLine(),t&&0===B&&D.newLine(!0)):(l(),D[\"{\"](v),H?(H=!1,F=B>C):F=B>=C):\"}\"===v?(m(),D[\"}\"](v),F=!1,G=!1,C&&C--,t&&0===B&&D.newLine(!0)):\":\"===v?(g(),!F&&!H||j(\"&\")||k()?\":\"===d()?(c(),E.push(\"::\")):E.push(\":\"):(G=!0,E.push(\":\"),D.singleSpace())):'\"'===v||\"'\"===v?(D.preserveSingleSpace(),E.push(e(v))):\";\"===v?(G=!1,E.push(v),D.newLine()):\"(\"===v?j(\"url\")?(E.push(v),g(),c()&&(\")\"!==v&&'\"'!==v&&\"'\"!==v?E.push(e(\")\")):x--)):(y++,D.preserveSingleSpace(),E.push(v),g()):\")\"===v?(E.push(v),y--):\",\"===v?(E.push(v),g(),r&&!G&&y<1?D.newLine():D.singleSpace()):\"]\"===v?E.push(v):\"[\"===v?(D.preserveSingleSpace(),E.push(v)):\"=\"===v?(g(),v=\"=\",E.push(v)):(D.preserveSingleSpace(),E.push(v))}var P=\"\";return z&&(P+=z),P+=E.join(\"\").replace(/[\\r\\n\\t ]+$/,\"\"),s&&(P+=\"\\n\"),\"\\n\"!=u&&(P=P.replace(/[\\n]/g,u)),P}function c(a,b){for(var c=0;c<b.length;c+=1)if(b[c]===a)return!0;return!1}function d(a){return a.replace(/^\\s+|\\s+$/g,\"\")}function e(a){return a.replace(/^\\s+/g,\"\")}function f(a,b){return new g(a,b).beautify()}function g(a,b){function f(a,b){var c=0;return a&&(c=a.indentation_level,!R.just_added_newline()&&a.line_indent_level>c&&(c=a.line_indent_level)),{mode:b,parent:a,last_text:a?a.last_text:\"\",last_word:a?a.last_word:\"\",declaration_statement:!1,declaration_assignment:!1,multiline_frame:!1,if_block:!1,else_block:!1,do_block:!1,do_while:!1,in_case_statement:!1,in_case:!1,case_body:!1,indentation_level:c,line_indent_level:a?a.line_indent_level:c,start_line_index:R.get_line_number(),ternary_depth:0}}function g(a){var b=a.newlines;if(ba.keep_array_indentation&&t(Y.mode))for(c=0;c<b;c+=1)n(c>0);else if(ba.max_preserve_newlines&&b>ba.max_preserve_newlines&&(b=ba.max_preserve_newlines),ba.preserve_newlines&&a.newlines>1){n();for(var c=1;c<b;c+=1)n(!0)}U=a,aa[U.type]()}function h(a){a=a.replace(/\\x0d/g,\"\");for(var b=[],c=a.indexOf(\"\\n\");-1!==c;)b.push(a.substring(0,c)),a=a.substring(c+1),c=a.indexOf(\"\\n\");return a.length&&b.push(a),b}function m(a){if(a=void 0!==a&&a,!R.just_added_newline())if(ba.preserve_newlines&&U.wanted_newline||a)n(!1,!0);else if(ba.wrap_line_length){var b=R.current_line.get_character_count()+U.text.length+(R.space_before_token?1:0);b>=ba.wrap_line_length&&n(!1,!0)}}function n(a,b){if(!b&&\";\"!==Y.last_text&&\",\"!==Y.last_text&&\"=\"!==Y.last_text&&\"TK_OPERATOR\"!==V)for(;Y.mode===l.Statement&&!Y.if_block&&!Y.do_block;)v();R.add_new_line(a)&&(Y.multiline_frame=!0)}function o(){R.just_added_newline()&&(ba.keep_array_indentation&&t(Y.mode)&&U.wanted_newline?(R.current_line.push(U.whitespace_before),R.space_before_token=!1):R.set_indent(Y.indentation_level)&&(Y.line_indent_level=Y.indentation_level))}function p(a){if(R.raw)return void R.add_raw_token(U);ba.comma_first&&\"TK_COMMA\"===V&&R.just_added_newline()&&\",\"===R.previous_line.last()&&(R.previous_line.pop(),o(),R.add_token(\",\"),R.space_before_token=!0),a=a||U.text,o(),R.add_token(a)}function q(){Y.indentation_level+=1}function r(){Y.indentation_level>0&&(!Y.parent||Y.indentation_level>Y.parent.indentation_level)&&(Y.indentation_level-=1)}function s(a){Y?($.push(Y),Z=Y):Z=f(null,a),Y=f(Z,a)}function t(a){return a===l.ArrayLiteral}function u(a){return c(a,[l.Expression,l.ForInitializer,l.Conditional])}function v(){$.length>0&&(Z=Y,Y=$.pop(),Z.mode===l.Statement&&R.remove_redundant_indentation(Z))}function w(){return Y.parent.mode===l.ObjectLiteral&&Y.mode===l.Statement&&(\":\"===Y.last_text&&0===Y.ternary_depth||\"TK_RESERVED\"===V&&c(Y.last_text,[\"get\",\"set\"]))}function x(){return!!(\"TK_RESERVED\"===V&&c(Y.last_text,[\"var\",\"let\",\"const\"])&&\"TK_WORD\"===U.type||\"TK_RESERVED\"===V&&\"do\"===Y.last_text||\"TK_RESERVED\"===V&&\"return\"===Y.last_text&&!U.wanted_newline||\"TK_RESERVED\"===V&&\"else\"===Y.last_text&&(\"TK_RESERVED\"!==U.type||\"if\"!==U.text)||\"TK_END_EXPR\"===V&&(Z.mode===l.ForInitializer||Z.mode===l.Conditional)||\"TK_WORD\"===V&&Y.mode===l.BlockStatement&&!Y.in_case&&\"--\"!==U.text&&\"++\"!==U.text&&\"function\"!==W&&\"TK_WORD\"!==U.type&&\"TK_RESERVED\"!==U.type||Y.mode===l.ObjectLiteral&&(\":\"===Y.last_text&&0===Y.ternary_depth||\"TK_RESERVED\"===V&&c(Y.last_text,[\"get\",\"set\"])))&&(s(l.Statement),q(),\"TK_RESERVED\"===V&&c(Y.last_text,[\"var\",\"let\",\"const\"])&&\"TK_WORD\"===U.type&&(Y.declaration_statement=!0),w()||m(\"TK_RESERVED\"===U.type&&c(U.text,[\"do\",\"for\",\"if\",\"while\"])),!0)}function y(a,b){for(var c=0;c<a.length;c++){if(d(a[c]).charAt(0)!==b)return!1}return!0}function z(a,b){for(var c,d=0,e=a.length;d<e;d++)if((c=a[d])&&0!==c.indexOf(b))return!1;return!0}function A(a){return c(a,[\"case\",\"return\",\"do\",\"if\",\"throw\",\"else\"])}function B(a){var b=S+(a||0);return b<0||b>=ca.length?null:ca[b]}function C(){x();var a=l.Expression;if(\"[\"===U.text){if(\"TK_WORD\"===V||\")\"===Y.last_text)return\"TK_RESERVED\"===V&&c(Y.last_text,T.line_starters)&&(R.space_before_token=!0),s(a),p(),q(),void(ba.space_in_paren&&(R.space_before_token=!0));a=l.ArrayLiteral,t(Y.mode)&&(\"[\"!==Y.last_text&&(\",\"!==Y.last_text||\"]\"!==W&&\"}\"!==W)||ba.keep_array_indentation||n())}else\"TK_RESERVED\"===V&&\"for\"===Y.last_text?a=l.ForInitializer:\"TK_RESERVED\"===V&&c(Y.last_text,[\"if\",\"while\"])&&(a=l.Conditional);\";\"===Y.last_text||\"TK_START_BLOCK\"===V?n():\"TK_END_EXPR\"===V||\"TK_START_EXPR\"===V||\"TK_END_BLOCK\"===V||\".\"===Y.last_text?m(U.wanted_newline):\"TK_RESERVED\"===V&&\"(\"===U.text||\"TK_WORD\"===V||\"TK_OPERATOR\"===V?\"TK_RESERVED\"===V&&(\"function\"===Y.last_word||\"typeof\"===Y.last_word)||\"*\"===Y.last_text&&\"function\"===W?ba.space_after_anon_function&&(R.space_before_token=!0):\"TK_RESERVED\"!==V||!c(Y.last_text,T.line_starters)&&\"catch\"!==Y.last_text||ba.space_before_conditional&&(R.space_before_token=!0):R.space_before_token=!0,\"(\"===U.text&&\"TK_RESERVED\"===V&&\"await\"===Y.last_word&&(R.space_before_token=!0),\"(\"===U.text&&(\"TK_EQUALS\"!==V&&\"TK_OPERATOR\"!==V||w()||m()),s(a),p(),ba.space_in_paren&&(R.space_before_token=!0),q()}function D(){for(;Y.mode===l.Statement;)v();Y.multiline_frame&&m(\"]\"===U.text&&t(Y.mode)&&!ba.keep_array_indentation),ba.space_in_paren&&(\"TK_START_EXPR\"!==V||ba.space_in_empty_paren?R.space_before_token=!0:(R.trim(),R.space_before_token=!1)),\"]\"===U.text&&ba.keep_array_indentation?(p(),v()):(v(),p()),R.remove_redundant_indentation(Z),Y.do_while&&Z.mode===l.Conditional&&(Z.mode=l.Expression,Y.do_block=!1,Y.do_while=!1)}function E(){var a=B(1),b=B(2);s(b&&(\":\"===b.text&&c(a.type,[\"TK_STRING\",\"TK_WORD\",\"TK_RESERVED\"])||c(a.text,[\"get\",\"set\"])&&c(b.type,[\"TK_WORD\",\"TK_RESERVED\"]))?c(W,[\"class\",\"interface\"])?l.BlockStatement:l.ObjectLiteral:l.BlockStatement);var d=!a.comments_before.length&&\"}\"===a.text,e=d&&\"function\"===Y.last_word&&\"TK_END_EXPR\"===V;\"expand\"===ba.brace_style||\"none\"===ba.brace_style&&U.wanted_newline?\"TK_OPERATOR\"!==V&&(e||\"TK_EQUALS\"===V||\"TK_RESERVED\"===V&&A(Y.last_text)&&\"else\"!==Y.last_text)?R.space_before_token=!0:n(!1,!0):\"TK_OPERATOR\"!==V&&\"TK_START_EXPR\"!==V?\"TK_START_BLOCK\"===V?n():R.space_before_token=!0:t(Z.mode)&&\",\"===Y.last_text&&(\"}\"===W?R.space_before_token=!0:n()),p(),q()}function F(){for(;Y.mode===l.Statement;)v();var a=\"TK_START_BLOCK\"===V;\"expand\"===ba.brace_style?a||n():a||(t(Y.mode)&&ba.keep_array_indentation?(ba.keep_array_indentation=!1,n(),ba.keep_array_indentation=!0):n()),v(),p()}function G(){if(\"TK_RESERVED\"===U.type&&Y.mode!==l.ObjectLiteral&&c(U.text,[\"set\",\"get\"])&&(U.type=\"TK_WORD\"),\"TK_RESERVED\"===U.type&&Y.mode===l.ObjectLiteral){\":\"==B(1).text&&(U.type=\"TK_WORD\")}if(x()||!U.wanted_newline||u(Y.mode)||\"TK_OPERATOR\"===V&&\"--\"!==Y.last_text&&\"++\"!==Y.last_text||\"TK_EQUALS\"===V||!ba.preserve_newlines&&\"TK_RESERVED\"===V&&c(Y.last_text,[\"var\",\"let\",\"const\",\"set\",\"get\"])||n(),Y.do_block&&!Y.do_while){if(\"TK_RESERVED\"===U.type&&\"while\"===U.text)return R.space_before_token=!0,p(),R.space_before_token=!0,void(Y.do_while=!0);n(),Y.do_block=!1}if(Y.if_block)if(Y.else_block||\"TK_RESERVED\"!==U.type||\"else\"!==U.text){for(;Y.mode===l.Statement;)v();Y.if_block=!1,Y.else_block=!1}else Y.else_block=!0;if(\"TK_RESERVED\"===U.type&&(\"case\"===U.text||\"default\"===U.text&&Y.in_case_statement))return n(),(Y.case_body||ba.jslint_happy)&&(r(),Y.case_body=!1),p(),Y.in_case=!0,void(Y.in_case_statement=!0);if(\"TK_RESERVED\"===U.type&&\"function\"===U.text&&((c(Y.last_text,[\"}\",\";\"])||R.just_added_newline()&&!c(Y.last_text,[\"[\",\"{\",\":\",\"=\",\",\"]))&&(R.just_added_blankline()||U.comments_before.length||(n(),n(!0))),\"TK_RESERVED\"===V||\"TK_WORD\"===V?\"TK_RESERVED\"===V&&c(Y.last_text,[\"get\",\"set\",\"new\",\"return\",\"export\",\"async\"])?R.space_before_token=!0:\"TK_RESERVED\"===V&&\"default\"===Y.last_text&&\"export\"===W?R.space_before_token=!0:n():\"TK_OPERATOR\"===V||\"=\"===Y.last_text?R.space_before_token=!0:(Y.multiline_frame||!u(Y.mode)&&!t(Y.mode))&&n()),\"TK_COMMA\"!==V&&\"TK_START_EXPR\"!==V&&\"TK_EQUALS\"!==V&&\"TK_OPERATOR\"!==V||w()||m(),\"TK_RESERVED\"===U.type&&c(U.text,[\"function\",\"get\",\"set\"]))return p(),void(Y.last_word=U.text);if(_=\"NONE\",\"TK_END_BLOCK\"===V?\"TK_RESERVED\"===U.type&&c(U.text,[\"else\",\"catch\",\"finally\"])?\"expand\"===ba.brace_style||\"end-expand\"===ba.brace_style||\"none\"===ba.brace_style&&U.wanted_newline?_=\"NEWLINE\":(_=\"SPACE\",R.space_before_token=!0):_=\"NEWLINE\":\"TK_SEMICOLON\"===V&&Y.mode===l.BlockStatement?_=\"NEWLINE\":\"TK_SEMICOLON\"===V&&u(Y.mode)?_=\"SPACE\":\"TK_STRING\"===V?_=\"NEWLINE\":\"TK_RESERVED\"===V||\"TK_WORD\"===V||\"*\"===Y.last_text&&\"function\"===W?_=\"SPACE\":\"TK_START_BLOCK\"===V?_=\"NEWLINE\":\"TK_END_EXPR\"===V&&(R.space_before_token=!0,_=\"NEWLINE\"),\"TK_RESERVED\"===U.type&&c(U.text,T.line_starters)&&\")\"!==Y.last_text&&(_=\"else\"===Y.last_text||\"export\"===Y.last_text?\"SPACE\":\"NEWLINE\"),\"TK_RESERVED\"===U.type&&c(U.text,[\"else\",\"catch\",\"finally\"]))if(\"TK_END_BLOCK\"!==V||\"expand\"===ba.brace_style||\"end-expand\"===ba.brace_style||\"none\"===ba.brace_style&&U.wanted_newline)n();else{R.trim(!0);var a=R.current_line;\"}\"!==a.last()&&n(),R.space_before_token=!0}else\"NEWLINE\"===_?\"TK_RESERVED\"===V&&A(Y.last_text)?R.space_before_token=!0:\"TK_END_EXPR\"!==V?\"TK_START_EXPR\"===V&&\"TK_RESERVED\"===U.type&&c(U.text,[\"var\",\"let\",\"const\"])||\":\"===Y.last_text||(\"TK_RESERVED\"===U.type&&\"if\"===U.text&&\"else\"===Y.last_text?R.space_before_token=!0:n()):\"TK_RESERVED\"===U.type&&c(U.text,T.line_starters)&&\")\"!==Y.last_text&&n():Y.multiline_frame&&t(Y.mode)&&\",\"===Y.last_text&&\"}\"===W?n():\"SPACE\"===_&&(R.space_before_token=!0);p(),Y.last_word=U.text,\"TK_RESERVED\"===U.type&&\"do\"===U.text&&(Y.do_block=!0),\"TK_RESERVED\"===U.type&&\"if\"===U.text&&(Y.if_block=!0)}function H(){for(x()&&(R.space_before_token=!1);Y.mode===l.Statement&&!Y.if_block&&!Y.do_block;)v();p()}function I(){x()?R.space_before_token=!0:\"TK_RESERVED\"===V||\"TK_WORD\"===V?R.space_before_token=!0:\"TK_COMMA\"===V||\"TK_START_EXPR\"===V||\"TK_EQUALS\"===V||\"TK_OPERATOR\"===V?w()||m():n(),p()}function J(){x(),Y.declaration_statement&&(Y.declaration_assignment=!0),R.space_before_token=!0,p(),R.space_before_token=!0}function K(){if(Y.declaration_statement)return u(Y.parent.mode)&&(Y.declaration_assignment=!1),p(),void(Y.declaration_assignment?(Y.declaration_assignment=!1,n(!1,!0)):(R.space_before_token=!0,ba.comma_first&&m()));p(),Y.mode===l.ObjectLiteral||Y.mode===l.Statement&&Y.parent.mode===l.ObjectLiteral?(Y.mode===l.Statement&&v(),n()):(R.space_before_token=!0,ba.comma_first&&m())}function L(){if(x(),\"TK_RESERVED\"===V&&A(Y.last_text))return R.space_before_token=!0,void p();if(\"*\"===U.text&&\"TK_DOT\"===V)return void p();if(\":\"===U.text&&Y.in_case)return Y.case_body=!0,q(),p(),n(),void(Y.in_case=!1);if(\"::\"===U.text)return void p();\"TK_OPERATOR\"===V&&m();var a=!0,b=!0;c(U.text,[\"--\",\"++\",\"!\",\"~\"])||c(U.text,[\"-\",\"+\"])&&(c(V,[\"TK_START_BLOCK\",\"TK_START_EXPR\",\"TK_EQUALS\",\"TK_OPERATOR\"])||c(Y.last_text,T.line_starters)||\",\"===Y.last_text)?(a=!1,b=!1,!U.wanted_newline||\"--\"!==U.text&&\"++\"!==U.text||n(!1,!0),\";\"===Y.last_text&&u(Y.mode)&&(a=!0),\"TK_RESERVED\"===V?a=!0:\"TK_END_EXPR\"===V?a=!(\"]\"===Y.last_text&&(\"--\"===U.text||\"++\"===U.text)):\"TK_OPERATOR\"===V&&(a=c(U.text,[\"--\",\"-\",\"++\",\"+\"])&&c(Y.last_text,[\"--\",\"-\",\"++\",\"+\"]),c(U.text,[\"+\",\"-\"])&&c(Y.last_text,[\"--\",\"++\"])&&(b=!0)),Y.mode!==l.BlockStatement&&Y.mode!==l.Statement||\"{\"!==Y.last_text&&\";\"!==Y.last_text||n()):\":\"===U.text?0===Y.ternary_depth?a=!1:Y.ternary_depth-=1:\"?\"===U.text?Y.ternary_depth+=1:\"*\"===U.text&&\"TK_RESERVED\"===V&&\"function\"===Y.last_text&&(a=!1,b=!1),R.space_before_token=R.space_before_token||a,p(),R.space_before_token=b}function M(){if(R.raw)return R.add_raw_token(U),void(U.directives&&\"end\"===U.directives.preserve&&(ba.test_output_raw||(R.raw=!1)));if(U.directives)return n(!1,!0),p(),\"start\"===U.directives.preserve&&(R.raw=!0),void n(!1,!0);if(!k.newline.test(U.text)&&!U.wanted_newline)return R.space_before_token=!0,p(),void(R.space_before_token=!0);var a,b=h(U.text),c=!1,d=!1,f=U.whitespace_before,g=f.length;for(n(!1,!0),b.length>1&&(y(b.slice(1),\"*\")?c=!0:z(b.slice(1),f)&&(d=!0)),p(b[0]),a=1;a<b.length;a++)n(!1,!0),c?p(\" \"+e(b[a])):d&&b[a].length>g?p(b[a].substring(g)):R.add_token(b[a]);n(!1,!0)}function N(){U.wanted_newline?n(!1,!0):R.trim(!0),R.space_before_token=!0,p(),n(!1,!0)}function O(){x(),\"TK_RESERVED\"===V&&A(Y.last_text)?R.space_before_token=!0:m(\")\"===Y.last_text&&ba.break_chained_methods),p()}function P(){p(),\"\\n\"===U.text[U.text.length-1]&&n()}function Q(){for(;Y.mode===l.Statement;)v()}var R,S,T,U,V,W,X,Y,Z,$,_,aa,ba,ca=[],da=\"\";for(aa={TK_START_EXPR:C,TK_END_EXPR:D,TK_START_BLOCK:E,TK_END_BLOCK:F,TK_WORD:G,TK_RESERVED:G,TK_SEMICOLON:H,TK_STRING:I,TK_EQUALS:J,TK_OPERATOR:L,TK_COMMA:K,TK_BLOCK_COMMENT:M,TK_COMMENT:N,TK_DOT:O,TK_UNKNOWN:P,TK_EOF:Q},b=b||{},ba={},void 0!==b.braces_on_own_line&&(ba.brace_style=b.braces_on_own_line?\"expand\":\"collapse\"),ba.brace_style=b.brace_style?b.brace_style:ba.brace_style?ba.brace_style:\"collapse\",\"expand-strict\"===ba.brace_style&&(ba.brace_style=\"expand\"),ba.indent_size=b.indent_size?parseInt(b.indent_size,10):4,ba.indent_char=b.indent_char?b.indent_char:\" \",ba.eol=b.eol?b.eol:\"\\n\",ba.preserve_newlines=void 0===b.preserve_newlines||b.preserve_newlines,ba.break_chained_methods=void 0!==b.break_chained_methods&&b.break_chained_methods,ba.max_preserve_newlines=void 0===b.max_preserve_newlines?0:parseInt(b.max_preserve_newlines,10),ba.space_in_paren=void 0!==b.space_in_paren&&b.space_in_paren,ba.space_in_empty_paren=void 0!==b.space_in_empty_paren&&b.space_in_empty_paren,ba.jslint_happy=void 0!==b.jslint_happy&&b.jslint_happy,ba.space_after_anon_function=void 0!==b.space_after_anon_function&&b.space_after_anon_function,ba.keep_array_indentation=void 0!==b.keep_array_indentation&&b.keep_array_indentation,ba.space_before_conditional=void 0===b.space_before_conditional||b.space_before_conditional,ba.unescape_strings=void 0!==b.unescape_strings&&b.unescape_strings,ba.wrap_line_length=void 0===b.wrap_line_length?0:parseInt(b.wrap_line_length,10),ba.e4x=void 0!==b.e4x&&b.e4x,ba.end_with_newline=void 0!==b.end_with_newline&&b.end_with_newline,ba.comma_first=void 0!==b.comma_first&&b.comma_first,ba.test_output_raw=void 0!==b.test_output_raw&&b.test_output_raw,ba.jslint_happy&&(ba.space_after_anon_function=!0),b.indent_with_tabs&&(ba.indent_char=\"\\t\",ba.indent_size=1),ba.eol=ba.eol.replace(/\\\\r/,\"\\r\").replace(/\\\\n/,\"\\n\"),X=\"\";ba.indent_size>0;)X+=ba.indent_char,ba.indent_size-=1;var ea=0;if(a&&a.length){for(;\" \"===a.charAt(ea)||\"\\t\"===a.charAt(ea);)da+=a.charAt(ea),ea+=1;a=a.substring(ea)}V=\"TK_START_BLOCK\",W=\"\",R=new i(X,da),R.raw=ba.test_output_raw,$=[],s(l.BlockStatement),this.beautify=function(){var b,c;for(T=new j(a,ba,X),ca=T.tokenize(),S=0;b=B();){for(var d=0;d<b.comments_before.length;d++)g(b.comments_before[d]);g(b),W=Y.last_text,V=b.type,Y.last_text=b.text,S+=1}return c=R.get_code(),ba.end_with_newline&&(c+=\"\\n\"),\"\\n\"!=ba.eol&&(c=c.replace(/[\\n]/g,ba.eol)),c}}function h(a){var b=0,c=-1,d=[],e=!0;this.set_indent=function(d){b=a.baseIndentLength+d*a.indent_length,c=d},this.get_character_count=function(){return b},this.is_empty=function(){return e},this.last=function(){return this._empty?null:d[d.length-1]},this.push=function(a){d.push(a),b+=a.length,e=!1},this.pop=function(){var a=null;return e||(a=d.pop(),b-=a.length,e=0===d.length),a},this.remove_indent=function(){c>0&&(c-=1,b-=a.indent_length)},this.trim=function(){for(;\" \"===this.last();){d.pop();b-=1}e=0===d.length},this.toString=function(){var b=\"\";return this._empty||(c>=0&&(b=a.indent_cache[c]),b+=d.join(\"\")),b}}function i(a,b){b=b||\"\",this.indent_cache=[b],this.baseIndentLength=b.length,this.indent_length=a.length,this.raw=!1;var c=[];this.baseIndentString=b,this.indent_string=a,this.previous_line=null,this.current_line=null,this.space_before_token=!1,this.add_outputline=function(){this.previous_line=this.current_line,this.current_line=new h(this),c.push(this.current_line)},this.add_outputline(),this.get_line_number=function(){return c.length},this.add_new_line=function(a){return(1!==this.get_line_number()||!this.just_added_newline())&&(!(!a&&this.just_added_newline())&&(this.raw||this.add_outputline(),!0))},this.get_code=function(){return c.join(\"\\n\").replace(/[\\r\\n\\t ]+$/,\"\")},this.set_indent=function(a){if(c.length>1){for(;a>=this.indent_cache.length;)this.indent_cache.push(this.indent_cache[this.indent_cache.length-1]+this.indent_string);return this.current_line.set_indent(a),!0}return this.current_line.set_indent(0),!1},this.add_raw_token=function(a){for(var b=0;b<a.newlines;b++)this.add_outputline();this.current_line.push(a.whitespace_before),this.current_line.push(a.text),this.space_before_token=!1},this.add_token=function(a){this.add_space_before_token(),\nthis.current_line.push(a)},this.add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&this.current_line.push(\" \"),this.space_before_token=!1},this.remove_redundant_indentation=function(a){if(!a.multiline_frame&&a.mode!==l.ForInitializer&&a.mode!==l.Conditional)for(var b=a.start_line_index,d=c.length;b<d;)c[b].remove_indent(),b++},this.trim=function(d){for(d=void 0!==d&&d,this.current_line.trim(a,b);d&&c.length>1&&this.current_line.is_empty();)c.pop(),this.current_line=c[c.length-1],this.current_line.trim();this.previous_line=c.length>1?c[c.length-2]:null},this.just_added_newline=function(){return this.current_line.is_empty()},this.just_added_blankline=function(){if(this.just_added_newline()){if(1===c.length)return!0;return c[c.length-2].is_empty()}return!1}}function j(a,b,e){function f(a){if(!a.match(y))return null;var b={};z.lastIndex=0;for(var c=z.exec(a);c;)b[c[1]]=c[2],c=z.exec(a);return b}function g(){var e,g=[];if(p=0,q=\"\",t>=u)return[\"\",\"TK_EOF\"];var y;y=s.length?s[s.length-1]:new m(\"TK_START_BLOCK\",\"{\");var z=a.charAt(t);for(t+=1;c(z,i);){if(k.newline.test(z)?\"\\n\"===z&&\"\\r\"===a.charAt(t-2)||(p+=1,g=[]):g.push(z),t>=u)return[\"\",\"TK_EOF\"];z=a.charAt(t),t+=1}if(g.length&&(q=g.join(\"\")),j.test(z)){var C=!0,D=!0,E=j;for(\"0\"===z&&t<u&&/[Xxo]/.test(a.charAt(t))?(C=!1,D=!1,z+=a.charAt(t),t+=1,E=/[o]/.test(a.charAt(t))?l:n):(z=\"\",t-=1);t<u&&E.test(a.charAt(t));)z+=a.charAt(t),t+=1,C&&t<u&&\".\"===a.charAt(t)&&(z+=a.charAt(t),t+=1,C=!1),D&&t<u&&/[Ee]/.test(a.charAt(t))&&(z+=a.charAt(t),t+=1,t<u&&/[+-]/.test(a.charAt(t))&&(z+=a.charAt(t),t+=1),D=!1,C=!1);return[z,\"TK_WORD\"]}if(k.isIdentifierStart(a.charCodeAt(t-1))){if(t<u)for(;k.isIdentifierChar(a.charCodeAt(t))&&(z+=a.charAt(t),(t+=1)!==u););return\"TK_DOT\"===y.type||\"TK_RESERVED\"===y.type&&c(y.text,[\"set\",\"get\"])||!c(z,v)?[z,\"TK_WORD\"]:\"in\"===z?[z,\"TK_OPERATOR\"]:[z,\"TK_RESERVED\"]}if(\"(\"===z||\"[\"===z)return[z,\"TK_START_EXPR\"];if(\")\"===z||\"]\"===z)return[z,\"TK_END_EXPR\"];if(\"{\"===z)return[z,\"TK_START_BLOCK\"];if(\"}\"===z)return[z,\"TK_END_BLOCK\"];if(\";\"===z)return[z,\"TK_SEMICOLON\"];if(\"/\"===z){var F=\"\";if(\"*\"===a.charAt(t)){t+=1,w.lastIndex=t;var G=w.exec(a);F=\"/*\"+G[0],t+=G[0].length;var H=f(F);return H&&\"start\"===H.ignore&&(A.lastIndex=t,G=A.exec(a),F+=G[0],t+=G[0].length),F=F.replace(k.lineBreak,\"\\n\"),[F,\"TK_BLOCK_COMMENT\",H]}if(\"/\"===a.charAt(t)){t+=1,x.lastIndex=t;var G=x.exec(a);return F=\"//\"+G[0],t+=G[0].length,[F,\"TK_COMMENT\"]}}if(\"`\"===z||\"'\"===z||'\"'===z||(\"/\"===z||b.e4x&&\"<\"===z&&a.slice(t-1).match(/^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\\[CDATA\\[[\\s\\S]*?\\]\\])(\\s+[-a-zA-Z:0-9_.]+\\s*=\\s*('[^']*'|\"[^\"]*\"|{.*?}))*\\s*(\\/?)\\s*>/))&&(\"TK_RESERVED\"===y.type&&c(y.text,[\"return\",\"case\",\"throw\",\"else\",\"do\",\"typeof\",\"yield\"])||\"TK_END_EXPR\"===y.type&&\")\"===y.text&&y.parent&&\"TK_RESERVED\"===y.parent.type&&c(y.parent.text,[\"if\",\"while\",\"for\"])||c(y.type,[\"TK_COMMENT\",\"TK_START_EXPR\",\"TK_START_BLOCK\",\"TK_END_BLOCK\",\"TK_OPERATOR\",\"TK_EQUALS\",\"TK_EOF\",\"TK_SEMICOLON\",\"TK_COMMA\"]))){var I=z,J=!1,K=!1;if(e=z,\"/\"===I)for(var L=!1;t<u&&(J||L||a.charAt(t)!==I)&&!k.newline.test(a.charAt(t));)e+=a.charAt(t),J?J=!1:(J=\"\\\\\"===a.charAt(t),\"[\"===a.charAt(t)?L=!0:\"]\"===a.charAt(t)&&(L=!1)),t+=1;else if(b.e4x&&\"<\"===I){var M=/<(\\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\\[CDATA\\[[\\s\\S]*?\\]\\])(\\s+[-a-zA-Z:0-9_.]+\\s*=\\s*('[^']*'|\"[^\"]*\"|{.*?}))*\\s*(\\/?)\\s*>/g,N=a.slice(t-1),O=M.exec(N);if(O&&0===O.index){for(var P=O[2],Q=0;O;){var R=!!O[1],S=O[2],T=!!O[O.length-1]||\"![CDATA[\"===S.slice(0,8);if(S!==P||T||(R?--Q:++Q),Q<=0)break;O=M.exec(N)}var U=O?O.index+O[0].length:N.length;return N=N.slice(0,U),t+=U-1,N=N.replace(k.lineBreak,\"\\n\"),[N,\"TK_STRING\"]}}else for(;t<u&&(J||a.charAt(t)!==I&&(\"`\"===I||!k.newline.test(a.charAt(t))));)(J||\"`\"===I)&&k.newline.test(a.charAt(t))?(\"\\r\"===a.charAt(t)&&\"\\n\"===a.charAt(t+1)&&(t+=1),e+=\"\\n\"):e+=a.charAt(t),J?(\"x\"!==a.charAt(t)&&\"u\"!==a.charAt(t)||(K=!0),J=!1):J=\"\\\\\"===a.charAt(t),t+=1;if(K&&b.unescape_strings&&(e=h(e)),t<u&&a.charAt(t)===I&&(e+=I,t+=1,\"/\"===I))for(;t<u&&k.isIdentifierStart(a.charCodeAt(t));)e+=a.charAt(t),t+=1;return[e,\"TK_STRING\"]}if(\"#\"===z){if(0===s.length&&\"!\"===a.charAt(t)){for(e=z;t<u&&\"\\n\"!==z;)z=a.charAt(t),e+=z,t+=1;return[d(e)+\"\\n\",\"TK_UNKNOWN\"]}var V=\"#\";if(t<u&&j.test(a.charAt(t))){do{z=a.charAt(t),V+=z,t+=1}while(t<u&&\"#\"!==z&&\"=\"!==z);return\"#\"===z||(\"[\"===a.charAt(t)&&\"]\"===a.charAt(t+1)?(V+=\"[]\",t+=2):\"{\"===a.charAt(t)&&\"}\"===a.charAt(t+1)&&(V+=\"{}\",t+=2)),[V,\"TK_WORD\"]}}if(\"<\"===z&&(\"?\"===a.charAt(t)||\"%\"===a.charAt(t))){B.lastIndex=t-1;var W=B.exec(a);if(W)return z=W[0],t+=z.length-1,z=z.replace(k.lineBreak,\"\\n\"),[z,\"TK_STRING\"]}if(\"<\"===z&&\"\\x3c!--\"===a.substring(t-1,t+3)){for(t+=3,z=\"\\x3c!--\";!k.newline.test(a.charAt(t))&&t<u;)z+=a.charAt(t),t++;return r=!0,[z,\"TK_COMMENT\"]}if(\"-\"===z&&r&&\"--\\x3e\"===a.substring(t-1,t+2))return r=!1,t+=2,[\"--\\x3e\",\"TK_COMMENT\"];if(\".\"===z)return[z,\"TK_DOT\"];if(c(z,o)){for(;t<u&&c(z+a.charAt(t),o)&&(z+=a.charAt(t),!((t+=1)>=u)););return\",\"===z?[z,\"TK_COMMA\"]:\"=\"===z?[z,\"TK_EQUALS\"]:[z,\"TK_OPERATOR\"]}return[z,\"TK_UNKNOWN\"]}function h(a){for(var b,c=!1,d=\"\",e=0,f=\"\",g=0;c||e<a.length;)if(b=a.charAt(e),e++,c){if(c=!1,\"x\"===b)f=a.substr(e,2),e+=2;else{if(\"u\"!==b){d+=\"\\\\\"+b;continue}f=a.substr(e,4),e+=4}if(!f.match(/^[0123456789abcdefABCDEF]+$/))return a;if((g=parseInt(f,16))>=0&&g<32){d+=\"x\"===b?\"\\\\x\"+f:\"\\\\u\"+f;continue}if(34===g||39===g||92===g)d+=\"\\\\\"+String.fromCharCode(g);else{if(\"x\"===b&&g>126&&g<=255)return a;d+=String.fromCharCode(g)}}else\"\\\\\"===b?c=!0:d+=b;return d}var i=\"\\n\\r\\t \".split(\"\"),j=/[0-9]/,l=/[01234567]/,n=/[0123456789abcdefABCDEF]/,o=\"+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>\".split(\" \");this.line_starters=\"continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export\".split(\",\");var p,q,r,s,t,u,v=this.line_starters.concat([\"do\",\"in\",\"else\",\"get\",\"set\",\"new\",\"catch\",\"finally\",\"typeof\",\"yield\",\"async\",\"await\"]),w=/([\\s\\S]*?)((?:\\*\\/)|$)/g,x=/([^\\n\\r\\u2028\\u2029]*)/g,y=/\\/\\* beautify( \\w+[:]\\w+)+ \\*\\//g,z=/ (\\w+)[:](\\w+)/g,A=/([\\s\\S]*?)((?:\\/\\*\\sbeautify\\signore:end\\s\\*\\/)|$)/g,B=/((<\\?php|<\\?=)[\\s\\S]*?\\?>)|(<%[\\s\\S]*?%>)/g;this.tokenize=function(){u=a.length,t=0,r=!1,s=[];for(var b,c,d,e=null,f=[],h=[];!c||\"TK_EOF\"!==c.type;){for(d=g(),b=new m(d[1],d[0],p,q);\"TK_COMMENT\"===b.type||\"TK_BLOCK_COMMENT\"===b.type||\"TK_UNKNOWN\"===b.type;)\"TK_BLOCK_COMMENT\"===b.type&&(b.directives=d[2]),h.push(b),d=g(),b=new m(d[1],d[0],p,q);h.length&&(b.comments_before=h,h=[]),\"TK_START_BLOCK\"===b.type||\"TK_START_EXPR\"===b.type?(b.parent=c,f.push(e),e=b):(\"TK_END_BLOCK\"===b.type||\"TK_END_EXPR\"===b.type)&&e&&(\"]\"===b.text&&\"[\"===e.text||\")\"===b.text&&\"(\"===e.text||\"}\"===b.text&&\"{\"===e.text)&&(b.parent=e.parent,e=f.pop()),s.push(b),c=b}return s}}var k={};!function(a){var b=\"\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc\",c=\"\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f\",d=new RegExp(\"[\"+b+\"]\"),e=new RegExp(\"[\"+b+c+\"]\");a.newline=/[\\n\\r\\u2028\\u2029]/,a.lineBreak=new RegExp(\"\\r\\n|\"+a.newline.source),a.allLineBreaks=new RegExp(a.lineBreak.source,\"g\"),a.isIdentifierStart=function(a){return a<65?36===a||64===a:a<91||(a<97?95===a:a<123||a>=170&&d.test(String.fromCharCode(a)))},a.isIdentifierChar=function(a){return a<48?36===a:a<58||!(a<65)&&(a<91||(a<97?95===a:a<123||a>=170&&e.test(String.fromCharCode(a))))}}(k);var l={BlockStatement:\"BlockStatement\",Statement:\"Statement\",ObjectLiteral:\"ObjectLiteral\",ArrayLiteral:\"ArrayLiteral\",ForInitializer:\"ForInitializer\",Conditional:\"Conditional\",Expression:\"Expression\"},m=function(a,b,c,d,e,f){this.type=a,this.text=b,this.comments_before=[],this.newlines=c||0,this.wanted_newline=c>0,this.whitespace_before=d||\"\",this.parent=null,this.directives=null};return{run:a}}});"

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1478))

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.POPUP_TEMPLATES,{\"colors.picker\":\"[_BUTTONS_][_TEXT_COLORS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]\"}),a.extend(a.FE.DEFAULTS,{colorsText:[\"#61BD6D\",\"#1ABC9C\",\"#54ACD2\",\"#2C82C9\",\"#9365B8\",\"#475577\",\"#CCCCCC\",\"#41A85F\",\"#00A885\",\"#3D8EB9\",\"#2969B0\",\"#553982\",\"#28324E\",\"#000000\",\"#F7DA64\",\"#FBA026\",\"#EB6B56\",\"#E25041\",\"#A38F84\",\"#EFEFEF\",\"#FFFFFF\",\"#FAC51C\",\"#F37934\",\"#D14841\",\"#B8312F\",\"#7C706B\",\"#D1D5D8\",\"REMOVE\"],colorsBackground:[\"#61BD6D\",\"#1ABC9C\",\"#54ACD2\",\"#2C82C9\",\"#9365B8\",\"#475577\",\"#CCCCCC\",\"#41A85F\",\"#00A885\",\"#3D8EB9\",\"#2969B0\",\"#553982\",\"#28324E\",\"#000000\",\"#F7DA64\",\"#FBA026\",\"#EB6B56\",\"#E25041\",\"#A38F84\",\"#EFEFEF\",\"#FFFFFF\",\"#FAC51C\",\"#F37934\",\"#D14841\",\"#B8312F\",\"#7C706B\",\"#D1D5D8\",\"REMOVE\"],colorsStep:7,colorsHEXInput:!0,colorsDefaultTab:\"text\",colorsButtons:[\"colorsBack\",\"|\",\"-\"]}),a.FE.PLUGINS.colors=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd=\"color\"]'),c=b.popups.get(\"colors.picker\");if(c||(c=e()),!c.hasClass(\"fr-active\"))if(b.popups.setContainer(\"colors.picker\",b.$tb),i(c.find(\".fr-selected-tab\").attr(\"data-param1\")),a.is(\":visible\")){var d=a.offset().left+a.outerWidth()/2,f=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show(\"colors.picker\",d,f,a.outerHeight())}else b.position.forSelection(c),b.popups.show(\"colors.picker\")}function d(){b.popups.hide(\"colors.picker\")}function e(){var a='<div class=\"fr-buttons fr-colors-buttons\">';b.opts.toolbarInline&&b.opts.colorsButtons.length>0&&(a+=b.button.buildList(b.opts.colorsButtons)),a+=f()+\"</div>\";var c=\"\";b.opts.colorsHEXInput&&(c='<div class=\"fr-color-hex-layer fr-active fr-layer\" id=\"fr-color-hex-layer-'+b.id+'\"><div class=\"fr-input-line\"><input maxlength=\"7\" id=\"fr-color-hex-layer-text-'+b.id+'\" type=\"text\" placeholder=\"'+b.language.translate(\"HEX Color\")+'\" tabIndex=\"1\" aria-required=\"true\"></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"customColor\" tabIndex=\"2\" role=\"button\">'+b.language.translate(\"OK\")+\"</button></div></div>\");var d={buttons:a,text_colors:g(\"text\"),background_colors:g(\"background\"),custom_color:c},e=b.popups.create(\"colors.picker\",d);return h(e),e}function f(){var a='<div class=\"fr-colors-tabs fr-group\">';return a+='<span class=\"fr-colors-tab '+(\"background\"==b.opts.colorsDefaultTab?\"\":\"fr-selected-tab \")+'fr-command\" tabIndex=\"-1\" role=\"button\" aria-pressed=\"'+(\"background\"!=b.opts.colorsDefaultTab)+'\" data-param1=\"text\" data-cmd=\"colorChangeSet\" title=\"'+b.language.translate(\"Text\")+'\">'+b.language.translate(\"Text\")+\"</span>\",(a+='<span class=\"fr-colors-tab '+(\"background\"==b.opts.colorsDefaultTab?\"fr-selected-tab \":\"\")+'fr-command\" tabIndex=\"-1\" role=\"button\" aria-pressed=\"'+(\"background\"==b.opts.colorsDefaultTab)+'\" data-param1=\"background\" data-cmd=\"colorChangeSet\" title=\"'+b.language.translate(\"Background\")+'\">'+b.language.translate(\"Background\")+\"</span>\")+\"</div>\"}function g(a){for(var c=\"text\"==a?b.opts.colorsText:b.opts.colorsBackground,d='<div class=\"fr-color-set fr-'+a+\"-color\"+(b.opts.colorsDefaultTab==a||\"text\"!=b.opts.colorsDefaultTab&&\"background\"!=b.opts.colorsDefaultTab&&\"text\"==a?\" fr-selected-set\":\"\")+'\">',e=0;e<c.length;e++)0!==e&&e%b.opts.colorsStep==0&&(d+=\"<br>\"),\"REMOVE\"!=c[e]?d+='<span class=\"fr-command fr-select-color\" style=\"background: '+c[e]+';\" tabIndex=\"-1\" aria-selected=\"false\" role=\"button\" data-cmd=\"'+a+'Color\" data-param1=\"'+c[e]+'\"><span class=\"fr-sr-only\">'+b.language.translate(\"Color\")+\" \"+c[e]+\"&nbsp;&nbsp;&nbsp;</span></span>\":d+='<span class=\"fr-command fr-select-color\" data-cmd=\"'+a+'Color\" tabIndex=\"-1\" role=\"button\" data-param1=\"REMOVE\" title=\"'+b.language.translate(\"Clear Formatting\")+'\">'+b.icon.create(\"remove\")+'<span class=\"fr-sr-only\">'+b.language.translate(\"Clear Formatting\")+\"</span></span>\";return d+\"</div>\"}function h(c){b.events.on(\"popup.tab\",function(d){var e=a(d.currentTarget);if(!b.popups.isVisible(\"colors.picker\")||!e.is(\"span\"))return!0;var f=d.which,g=!0;if(a.FE.KEYCODE.TAB==f){var h=c.find(\".fr-buttons\");g=!b.accessibility.focusToolbar(h,!!d.shiftKey)}else if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){if(e.is(\"span.fr-select-color\")){var i=e.parent().find(\"span.fr-select-color\"),j=i.index(e),k=b.opts.colorsStep,l=Math.floor(i.length/k),m=j%k,n=Math.floor(j/k),o=n*k+m,p=l*k;a.FE.KEYCODE.ARROW_UP==f?o=((o-k)%p+p)%p:a.FE.KEYCODE.ARROW_DOWN==f?o=(o+k)%p:a.FE.KEYCODE.ARROW_LEFT==f?o=((o-1)%p+p)%p:a.FE.KEYCODE.ARROW_RIGHT==f&&(o=(o+1)%p);var q=a(i.get(o));b.events.disableBlur(),q.focus(),g=!1}}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(e),g=!1);return!1===g&&(d.preventDefault(),d.stopPropagation()),g},!0)}function i(c){var d,e=b.popups.get(\"colors.picker\"),f=a(b.selection.element());d=\"background\"==c?\"background-color\":\"color\";var g=e.find(\".fr-\"+c+\"-color .fr-select-color\");for(g.find(\".fr-selected-color\").remove(),g.removeClass(\"fr-active-item\"),g.not('[data-param1=\"REMOVE\"]').attr(\"aria-selected\",!1);f.get(0)!=b.el;){if(\"transparent\"!=f.css(d)&&\"rgba(0, 0, 0, 0)\"!=f.css(d)){var h=e.find(\".fr-\"+c+'-color .fr-select-color[data-param1=\"'+b.helpers.RGBToHex(f.css(d))+'\"]');h.append('<span class=\"fr-selected-color\" aria-hidden=\"true\">\\uf00c</span>'),h.addClass(\"fr-active-item\").attr(\"aria-selected\",!0);break}f=f.parent()}var i=e.find(\".fr-color-hex-layer input\");i.length&&i.val(b.helpers.RGBToHex(f.css(d))).trigger(\"change\")}function j(a,c){a.hasClass(\"fr-selected-tab\")||(a.siblings().removeClass(\"fr-selected-tab\").attr(\"aria-pressed\",!1),a.addClass(\"fr-selected-tab\").attr(\"aria-pressed\",!0),a.parents(\".fr-popup\").find(\".fr-color-set\").removeClass(\"fr-selected-set\"),a.parents(\".fr-popup\").find(\".fr-color-set.fr-\"+c+\"-color\").addClass(\"fr-selected-set\"),i(c)),b.accessibility.focusPopup(a.parents(\".fr-popup\"))}function k(a){\"REMOVE\"!=a?b.format.applyStyle(\"background-color\",b.helpers.HEXtoRGB(a)):b.format.removeStyle(\"background-color\"),d()}function l(a){\"REMOVE\"!=a?b.format.applyStyle(\"color\",b.helpers.HEXtoRGB(a)):b.format.removeStyle(\"color\"),d()}function m(){b.popups.hide(\"colors.picker\"),b.toolbar.showInline()}function n(){var a=b.popups.get(\"colors.picker\"),c=a.find(\".fr-color-hex-layer input\");if(c.length){var d=c.val();\"background\"==a.find(\".fr-selected-tab\").attr(\"data-param1\")?k(d):l(d)}}return{showColorsPopup:c,hideColorsPopup:d,changeSet:j,background:k,customColor:n,text:l,back:m}},a.FE.DefineIcon(\"colors\",{NAME:\"tint\"}),a.FE.RegisterCommand(\"color\",{title:\"Colors\",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible(\"colors.picker\")?(this.$el.find(\".fr-marker\").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide(\"colors.picker\")):this.colors.showColorsPopup()},plugin:\"colors\"}),a.FE.RegisterCommand(\"textColor\",{undo:!0,callback:function(a,b){this.colors.text(b)}}),a.FE.RegisterCommand(\"backgroundColor\",{undo:!0,callback:function(a,b){this.colors.background(b)}}),a.FE.RegisterCommand(\"colorChangeSet\",{undo:!1,focus:!1,callback:function(a,b){var c=this.popups.get(\"colors.picker\").find('.fr-command[data-cmd=\"'+a+'\"][data-param1=\"'+b+'\"]');this.colors.changeSet(c,b)}}),a.FE.DefineIcon(\"colorsBack\",{NAME:\"arrow-left\"}),a.FE.RegisterCommand(\"colorsBack\",{title:\"Back\",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.colors.back()}}),a.FE.RegisterCommand(\"customColor\",{title:\"OK\",undo:!0,callback:function(){this.colors.customColor()}}),a.FE.DefineIcon(\"remove\",{NAME:\"eraser\"})});"

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1480))

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{fontFamily:{\"Arial,Helvetica,sans-serif\":\"Arial\",\"Georgia,serif\":\"Georgia\",\"Impact,Charcoal,sans-serif\":\"Impact\",\"Tahoma,Geneva,sans-serif\":\"Tahoma\",\"Times New Roman,Times,serif,-webkit-standard\":\"Times New Roman\",\"Verdana,Geneva,sans-serif\":\"Verdana\"},fontFamilySelection:!1,fontFamilyDefaultSelection:\"Font Family\"}),a.FE.PLUGINS.fontFamily=function(b){function c(a){b.format.applyStyle(\"font-family\",a)}function d(a,b){b.find(\".fr-command.fr-active\").removeClass(\"fr-active\").attr(\"aria-selected\",!1),b.find('.fr-command[data-param1=\"'+g()+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0);var c=b.find(\".fr-dropdown-list\"),d=b.find(\".fr-active\").parent();d.length?c.parent().scrollTop(d.offset().top-c.offset().top-(c.parent().outerHeight()/2-d.outerHeight()/2)):c.parent().scrollTop(0)}function e(b){var c=b.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,\"\").replace(/\"|'| /g,\"\").split(\",\");return a.grep(c,function(a){return a.length>0})}function f(a,b){for(var c=0;c<a.length;c++)for(var d=0;d<b.length;d++)if(a[c]==b[d])return[c,d];return null}function g(){var c=a(b.selection.element()).css(\"font-family\"),d=e(c),g=[];for(var h in b.opts.fontFamily)if(b.opts.fontFamily.hasOwnProperty(h)){var i=e(h),j=f(d,i);j&&g.push([h,j])}return 0===g.length?null:(g.sort(function(a,b){var c=a[1][0]-b[1][0];return 0===c?a[1][1]-b[1][1]:c}),g[0][0])}function h(c){if(b.opts.fontFamilySelection){var d=a(b.selection.element()).css(\"font-family\").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,\"\").replace(/\"|'|/g,\"\").split(\",\");c.find(\"> span\").text(b.opts.fontFamily[g()]||d[0]||b.language.translate(b.opts.fontFamilyDefaultSelection))}}return{apply:c,refreshOnShow:d,refresh:h}},a.FE.RegisterCommand(\"fontFamily\",{type:\"dropdown\",displaySelection:function(a){return a.opts.fontFamilySelection},defaultSelection:function(a){return a.opts.fontFamilyDefaultSelection},displaySelectionWidth:120,html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.fontFamily;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"fontFamily\" data-param1=\"'+c+'\" style=\"font-family: '+c+'\" title=\"'+b[c]+'\">'+b[c]+\"</a></li>\");return a+=\"</ul>\"},title:\"Font Family\",callback:function(a,b){this.fontFamily.apply(b)},refresh:function(a){this.fontFamily.refresh(a)},refreshOnShow:function(a,b){this.fontFamily.refreshOnShow(a,b)},plugin:\"fontFamily\"}),a.FE.DefineIcon(\"fontFamily\",{NAME:\"font\"})});"

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1482))

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{fontSize:[\"8\",\"9\",\"10\",\"11\",\"12\",\"14\",\"18\",\"24\",\"30\",\"36\",\"48\",\"60\",\"72\",\"96\"],fontSizeSelection:!1,fontSizeDefaultSelection:\"12\"}),a.FE.PLUGINS.fontSize=function(b){function c(a){b.format.applyStyle(\"font-size\",a)}function d(c,d){var e=a(b.selection.element()).css(\"font-size\");d.find(\".fr-command.fr-active\").removeClass(\"fr-active\").attr(\"aria-selected\",!1),d.find('.fr-command[data-param1=\"'+e+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0);var f=d.find(\".fr-dropdown-list\"),g=d.find(\".fr-active\").parent();g.length?f.parent().scrollTop(g.offset().top-f.offset().top-(f.parent().outerHeight()/2-g.outerHeight()/2)):f.parent().scrollTop(0)}function e(c){if(b.opts.fontSizeSelection){var d=b.helpers.getPX(a(b.selection.element()).css(\"font-size\"));c.find(\"> span\").text(d)}}return{apply:c,refreshOnShow:d,refresh:e}},a.FE.RegisterCommand(\"fontSize\",{type:\"dropdown\",title:\"Font Size\",displaySelection:function(a){return a.opts.fontSizeSelection},displaySelectionWidth:30,defaultSelection:function(a){return a.opts.fontSizeDefaultSelection},html:function(){for(var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.fontSize,c=0;c<b.length;c++){var d=b[c];a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"fontSize\" data-param1=\"'+d+'px\" title=\"'+d+'\">'+d+\"</a></li>\"}return a+=\"</ul>\"},callback:function(a,b){this.fontSize.apply(b)},refresh:function(a){this.fontSize.refresh(a)},refreshOnShow:function(a,b){this.fontSize.refreshOnShow(a,b)},plugin:\"fontSize\"}),a.FE.DefineIcon(\"fontSize\",{NAME:\"text-height\"})});"

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1484))

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.POPUP_TEMPLATES,{\"image.insert\":\"[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]\",\"image.edit\":\"[_BUTTONS_]\",\"image.alt\":\"[_BUTTONS_][_ALT_LAYER_]\",\"image.size\":\"[_BUTTONS_][_SIZE_LAYER_]\"}),a.extend(a.FE.DEFAULTS,{imageInsertButtons:[\"imageBack\",\"|\",\"imageUpload\",\"imageByURL\"],imageEditButtons:[\"imageReplace\",\"imageAlign\",\"imageCaption\",\"imageRemove\",\"|\",\"imageLink\",\"linkOpen\",\"linkEdit\",\"linkRemove\",\"-\",\"imageDisplay\",\"imageStyle\",\"imageAlt\",\"imageSize\"],imageAltButtons:[\"imageBack\",\"|\"],imageSizeButtons:[\"imageBack\",\"|\"],imageUpload:!0,imageUploadURL:\"https://i.froala.com/upload\",imageCORSProxy:\"https://cors-anywhere.froala.com\",imageUploadRemoteUrls:!0,imageUploadParam:\"file\",imageUploadParams:{},imageUploadToS3:!1,imageUploadMethod:\"POST\",imageMaxSize:10485760,imageAllowedTypes:[\"jpeg\",\"jpg\",\"png\",\"gif\",\"svg+xml\"],imageResize:!0,imageResizeWithPercent:!1,imageRoundPercent:!1,imageDefaultWidth:300,imageDefaultAlign:\"center\",imageDefaultDisplay:\"block\",imageSplitHTML:!1,imageStyles:{\"fr-rounded\":\"Rounded\",\"fr-bordered\":\"Bordered\",\"fr-shadow\":\"Shadow\"},imageMove:!0,imageMultipleStyles:!0,imageTextNear:!0,imagePaste:!0,imagePasteProcess:!1,imageMinWidth:16,imageOutputSize:!1,imageDefaultMargin:5}),a.FE.PLUGINS.image=function(b){function c(){var a=b.popups.get(\"image.insert\"),c=a.find(\".fr-image-by-url-layer input\");c.val(\"\"),Da&&c.val(Da.attr(\"src\")),c.trigger(\"change\")}function d(){var a=b.$tb.find('.fr-command[data-cmd=\"insertImage\"]'),c=b.popups.get(\"image.insert\");if(c||(c=M()),s(),!c.hasClass(\"fr-active\"))if(b.popups.refresh(\"image.insert\"),b.popups.setContainer(\"image.insert\",b.$tb),a.is(\":visible\")){var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show(\"image.insert\",d,e,a.outerHeight())}else b.position.forSelection(c),b.popups.show(\"image.insert\")}function e(){var a=b.popups.get(\"image.edit\");if(a||(a=q()),a){var c=za();Ba()&&(c=c.find(\".fr-img-wrap\")),b.popups.setContainer(\"image.edit\",b.$sc),b.popups.refresh(\"image.edit\");var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show(\"image.edit\",d,e,c.outerHeight())}}function f(){s()}function g(a){a.hasClass(\"fr-dii\")||a.hasClass(\"fr-dib\")||(a.addClass(\"fr-fi\"+pa(a)[0]),a.addClass(\"fr-di\"+qa(a)[0]),a.css(\"margin\",\"\"),a.css(\"float\",\"\"),a.css(\"display\",\"\"),a.css(\"z-index\",\"\"),a.css(\"position\",\"\"),a.css(\"overflow\",\"\"),a.css(\"vertical-align\",\"\"))}function h(a){na(a,a.hasClass(\"fr-dib\")?\"block\":a.hasClass(\"fr-dii\")?\"inline\":null,a.hasClass(\"fr-fil\")?\"left\":a.hasClass(\"fr-fir\")?\"right\":pa(a)),a.removeClass(\"fr-dib fr-dii fr-fir fr-fil\")}function i(){for(var c=\"IMG\"==b.el.tagName?[b.el]:b.el.querySelectorAll(\"img\"),d=0;d<c.length;d++){var e=a(c[d]);!b.opts.htmlUntouched&&b.opts.useClasses?((b.opts.imageEditButtons.indexOf(\"imageAlign\")>=0||b.opts.imageEditButtons.indexOf(\"imageDisplay\")>=0)&&g(e),b.opts.imageTextNear||e.removeClass(\"fr-dii\").addClass(\"fr-dib\")):b.opts.htmlUntouched||b.opts.useClasses||(b.opts.imageEditButtons.indexOf(\"imageAlign\")>=0||b.opts.imageEditButtons.indexOf(\"imageDisplay\")>=0)&&h(e),b.opts.iframe&&e.on(\"load\",b.size.syncIframe)}}function j(c){void 0===c&&(c=!0);var d,e=Array.prototype.slice.call(b.el.querySelectorAll(\"img\")),f=[];for(d=0;d<e.length;d++)if(f.push(e[d].getAttribute(\"src\")),a(e[d]).toggleClass(\"fr-draggable\",b.opts.imageMove),\"\"===e[d].getAttribute(\"class\")&&e[d].removeAttribute(\"class\"),\"\"===e[d].getAttribute(\"style\")&&e[d].removeAttribute(\"style\"),e[d].parentNode&&e[d].parentNode.parentNode&&b.node.hasClass(e[d].parentNode.parentNode,\"fr-img-caption\")){var g=e[d].parentNode.parentNode;g.setAttribute(\"contenteditable\",!1),g.setAttribute(\"draggable\",!1),g.classList.add(\"fr-draggable\");var h=e[d].nextSibling;h&&h.setAttribute(\"contenteditable\",!0)}if(Qa)for(d=0;d<Qa.length;d++)f.indexOf(Qa[d].getAttribute(\"src\"))<0&&b.events.trigger(\"image.removed\",[a(Qa[d])]);if(Qa&&c){var i=[];for(d=0;d<Qa.length;d++)i.push(Qa[d].getAttribute(\"src\"));for(d=0;d<e.length;d++)i.indexOf(e[d].getAttribute(\"src\"))<0&&b.events.trigger(\"image.loaded\",[a(e[d])])}Qa=e}function k(){if(Ea||Z(),!Da)return!1;var a=b.$wp||b.$sc;a.append(Ea),Ea.data(\"instance\",b);var c=a.scrollTop()-(\"static\"!=a.css(\"position\")?a.offset().top:0),d=a.scrollLeft()-(\"static\"!=a.css(\"position\")?a.offset().left:0);d-=b.helpers.getPX(a.css(\"border-left-width\")),c-=b.helpers.getPX(a.css(\"border-top-width\")),b.$el.is(\"img\")&&b.$sc.is(\"body\")&&(c=0,d=0);var e=za();Ba()&&(e=e.find(\".fr-img-wrap\")),Ea.css(\"top\",(b.opts.iframe?e.offset().top:e.offset().top+c)-1).css(\"left\",(b.opts.iframe?e.offset().left:e.offset().left+d)-1).css(\"width\",e.get(0).getBoundingClientRect().width).css(\"height\",e.get(0).getBoundingClientRect().height).addClass(\"fr-active\")}function l(a){return'<div class=\"fr-handler fr-h'+a+'\"></div>'}function m(c){if(!b.core.sameInstance(Ea))return!0;if(c.preventDefault(),c.stopPropagation(),b.$el.find(\"img.fr-error\").left)return!1;b.undo.canDo()||b.undo.saveStep();var d=c.pageX||c.originalEvent.touches[0].pageX;if(\"mousedown\"==c.type){var e=b.$oel.get(0),f=e.ownerDocument,g=f.defaultView||f.parentWindow,h=!1;try{h=g.location!=g.parent.location&&!(g.$&&g.$.FE)}catch(k){}h&&g.frameElement&&(d+=b.helpers.getPX(a(g.frameElement).offset().left)+g.frameElement.clientLeft)}Fa=a(this),Fa.data(\"start-x\",d),Fa.data(\"start-width\",Da.width()),Fa.data(\"start-height\",Da.height());var i=Da.width();if(b.opts.imageResizeWithPercent){var j=Da.parentsUntil(b.$el,b.html.blockTagsQuery()).get(0)||b.el;Da.css(\"width\",(i/a(j).outerWidth()*100).toFixed(2)+\"%\")}else Da.css(\"width\",i);Ga.show(),b.popups.hideAll(),la()}function n(c){if(!b.core.sameInstance(Ea))return!0;var d;if(Fa&&Da){if(c.preventDefault(),b.$el.find(\"img.fr-error\").left)return!1;var e=c.pageX||(c.originalEvent.touches?c.originalEvent.touches[0].pageX:null);if(!e)return!1;var f=Fa.data(\"start-x\"),g=e-f,h=Fa.data(\"start-width\");if((Fa.hasClass(\"fr-hnw\")||Fa.hasClass(\"fr-hsw\"))&&(g=0-g),b.opts.imageResizeWithPercent){var i=Da.parentsUntil(b.$el,b.html.blockTagsQuery()).get(0)||b.el;h=((h+g)/a(i).outerWidth()*100).toFixed(2),b.opts.imageRoundPercent&&(h=Math.round(h)),Da.css(\"width\",h+\"%\"),d=(b.helpers.getPX(Da.css(\"width\"))/a(i).outerWidth()*100).toFixed(2),d!==h&&Da.css(\"width\",d+\"%\"),Da.css(\"height\",\"\").removeAttr(\"height\")}else h+g>=b.opts.imageMinWidth&&(Ba()&&Da.parent().css(\"width\",h+g),Da.css(\"width\",h+g)),d=b.helpers.getPX(Da.css(\"width\")),d!==h+g&&Da.css(\"width\",d),((Da.attr(\"style\")||\"\").match(/(^height:)|(; *height:)/)||Da.attr(\"height\"))&&(Da.css(\"height\",Fa.data(\"start-height\")*Da.width()/Fa.data(\"start-width\")),Da.removeAttr(\"height\"));k(),b.events.trigger(\"image.resize\",[ya()])}}function o(a){if(!b.core.sameInstance(Ea))return!0;if(Fa&&Da){if(a&&a.stopPropagation(),b.$el.find(\"img.fr-error\").left)return!1;Fa=null,Ga.hide(),k(),e(),b.undo.saveStep(),b.events.trigger(\"image.resizeEnd\",[ya()])}}function p(a,c,d){b.edit.on(),Da&&Da.addClass(\"fr-error\"),u(b.language.translate(\"Something went wrong. Please try again.\")),!Da&&d&&$(d),b.events.trigger(\"image.error\",[{code:a,message:Pa[a]},c,d])}function q(a){if(a)return b.$wp&&b.events.$on(b.$wp,\"scroll\",function(){Da&&b.popups.isVisible(\"image.edit\")&&(b.events.disableBlur(),w(Da))}),!0;var c=\"\";if(b.opts.imageEditButtons.length>0){c+='<div class=\"fr-buttons\">',c+=b.button.buildList(b.opts.imageEditButtons),c+=\"</div>\";var d={buttons:c};return b.popups.create(\"image.edit\",d)}return!1}function r(a){var c=b.popups.get(\"image.insert\");if(c||(c=M()),c.find(\".fr-layer.fr-active\").removeClass(\"fr-active\").addClass(\"fr-pactive\"),c.find(\".fr-image-progress-bar-layer\").addClass(\"fr-active\"),c.find(\".fr-buttons\").hide(),Da){var d=za();b.popups.setContainer(\"image.insert\",b.$sc);var e=d.offset().left+d.width()/2,f=d.offset().top+d.height();b.popups.show(\"image.insert\",e,f,d.outerHeight())}void 0===a&&t(b.language.translate(\"Uploading\"),0)}function s(a){var c=b.popups.get(\"image.insert\");if(c&&(c.find(\".fr-layer.fr-pactive\").addClass(\"fr-active\").removeClass(\"fr-pactive\"),c.find(\".fr-image-progress-bar-layer\").removeClass(\"fr-active\"),c.find(\".fr-buttons\").show(),a||b.$el.find(\"img.fr-error\").length)){if(b.events.focus(),b.$el.find(\"img.fr-error\").length&&(b.$el.find(\"img.fr-error\").remove(),b.undo.saveStep(),b.undo.run(),b.undo.dropRedo()),!b.$wp&&Da){var d=Da;ja(!0),b.selection.setAfter(d.get(0)),b.selection.restore()}b.popups.hide(\"image.insert\")}}function t(a,c){var d=b.popups.get(\"image.insert\");if(d){var e=d.find(\".fr-image-progress-bar-layer\");e.find(\"h3\").text(a+(c?\" \"+c+\"%\":\"\")),e.removeClass(\"fr-error\"),c?(e.find(\"div\").removeClass(\"fr-indeterminate\"),e.find(\"div > span\").css(\"width\",c+\"%\")):e.find(\"div\").addClass(\"fr-indeterminate\")}}function u(a){r();var c=b.popups.get(\"image.insert\"),d=c.find(\".fr-image-progress-bar-layer\");d.addClass(\"fr-error\");var e=d.find(\"h3\");e.text(a),b.events.disableBlur(),e.focus()}function v(){var a=b.popups.get(\"image.insert\"),c=a.find(\".fr-image-by-url-layer input\");if(c.val().length>0){if(r(),t(b.language.translate(\"Loading image\")),b.opts.imageUploadRemoteUrls&&b.opts.imageCORSProxy){var d=new XMLHttpRequest;d.open(\"GET\",b.opts.imageCORSProxy+\"/\"+c.val(),!0),d.responseType=\"blob\",d.onload=function(){200==this.status&&H([new Blob([this.response],{type:this.response.type||\"image/png\"})],Da)},d.send()}else y(c.val(),!0,[],Da);c.val(\"\"),c.blur()}}function w(a){ia.call(a.get(0))}function x(){var c=a(this);b.popups.hide(\"image.insert\"),c.removeClass(\"fr-uploading\"),c.next().is(\"br\")&&c.next().remove(),w(c),b.events.trigger(\"image.loaded\",[c])}function y(a,c,d,e,f){b.edit.off(),t(b.language.translate(\"Loading image\")),c&&(a=b.helpers.sanitizeURL(a));var g=new Image;g.onload=function(){var c,g;if(e){b.undo.canDo()||e.hasClass(\"fr-uploading\")||b.undo.saveStep();var h=e.data(\"fr-old-src\");e.data(\"fr-image-pasted\")&&(h=null),b.$wp?(c=e.clone().removeData(\"fr-old-src\").removeClass(\"fr-uploading\").removeAttr(\"data-fr-image-pasted\"),c.off(\"load\"),h&&e.attr(\"src\",h),e.replaceWith(c)):c=e;for(var i=c.get(0).attributes,k=0;k<i.length;k++){var l=i[k];0===l.nodeName.indexOf(\"data-\")&&c.removeAttr(l.nodeName)}if(void 0!==d)for(g in d)d.hasOwnProperty(g)&&\"link\"!=g&&c.attr(\"data-\"+g,d[g]);c.on(\"load\",x),c.attr(\"src\",a),b.edit.on(),j(!1),b.undo.saveStep(),b.$el.blur(),b.events.trigger(h?\"image.replaced\":\"image.inserted\",[c,f])}else c=E(a,d,x),j(!1),b.undo.saveStep(),b.$el.blur(),b.events.trigger(\"image.inserted\",[c,f])},g.onerror=function(){p(Ia)},r(b.language.translate(\"Loading image\")),g.src=a}function z(a){try{if(!1===b.events.trigger(\"image.uploaded\",[a],!0))return b.edit.on(),!1;var c=JSON.parse(a);return c.link?c:(p(Ja,a),!1)}catch(d){return p(La,a),!1}}function A(c){try{var d=a(c).find(\"Location\").text(),e=a(c).find(\"Key\").text();return!1===b.events.trigger(\"image.uploadedToS3\",[d,e,c],!0)?(b.edit.on(),!1):d}catch(f){return p(La,c),!1}}function B(a){t(b.language.translate(\"Loading image\"));var c=this.status,d=this.response,e=this.responseXML,f=this.responseText;try{if(b.opts.imageUploadToS3)if(201==c){var g=A(e);g&&y(g,!1,[],a,d||e)}else p(La,d||e,a);else if(c>=200&&c<300){var h=z(f);h&&y(h.link,!1,h,a,d||f)}else p(Ka,d||f,a)}catch(i){p(La,d||f,a)}}function C(){p(La,this.response||this.responseText||this.responseXML)}function D(a){if(a.lengthComputable){var c=a.loaded/a.total*100|0;t(b.language.translate(\"Uploading\"),c)}}function E(c,d,e){var f,g=\"\";if(d&&void 0!==d)for(f in d)d.hasOwnProperty(f)&&\"link\"!=f&&(g+=\" data-\"+f+'=\"'+d[f]+'\"');var h=b.opts.imageDefaultWidth;h&&\"auto\"!=h&&(h+=b.opts.imageResizeWithPercent?\"%\":\"px\");var i=a('<img src=\"'+c+'\"'+g+(h?' style=\"width: '+h+';\"':\"\")+\">\");na(i,b.opts.imageDefaultDisplay,b.opts.imageDefaultAlign),i.on(\"load\",e),i.on(\"error\",function(){a(this).addClass(\"fr-error\"),p(Oa)}),b.edit.on(),b.events.focus(!0),b.selection.restore(),b.undo.saveStep(),b.opts.imageSplitHTML?b.markers.split():b.markers.insert(),b.html.wrap();var j=b.$el.find(\".fr-marker\");return j.length?(j.parent().is(\"hr\")&&j.parent().after(j),b.node.isLastSibling(j)&&j.parent().hasClass(\"fr-deletable\")&&j.insertAfter(j.parent()),j.replaceWith(i)):b.$el.append(i),b.selection.clear(),i}function F(){b.edit.on(),s(!0)}function G(c,d,e,f){function g(){var e=a(this);e.off(\"load\"),e.addClass(\"fr-uploading\"),e.next().is(\"br\")&&e.next().remove(),b.placeholder.refresh(),w(e),k(),r(),b.edit.off(),c.onload=function(){B.call(c,e)},c.onerror=C,c.upload.onprogress=D,c.onabort=F,e.off(\"abortUpload\").on(\"abortUpload\",function(){4!=c.readyState&&c.abort()}),c.send(d)}var h,i=new FileReader;i.addEventListener(\"load\",function(){var a=i.result;if(i.result.indexOf(\"svg+xml\")<0){for(var c=atob(i.result.split(\",\")[1]),d=[],e=0;e<c.length;e++)d.push(c.charCodeAt(e));a=window.URL.createObjectURL(new Blob([new Uint8Array(d)],{type:\"image/jpeg\"}))}f?(f.on(\"load\",g),f.one(\"error\",function(){f.off(\"load\"),f.attr(\"src\",f.data(\"fr-old-src\")),p(Oa)}),b.edit.on(),b.undo.saveStep(),f.data(\"fr-old-src\",f.attr(\"src\")),f.attr(\"src\",a)):h=E(a,null,g)},!1),i.readAsDataURL(e)}function H(a,c){if(void 0!==a&&a.length>0){if(!1===b.events.trigger(\"image.beforeUpload\",[a,c]))return!1;var d=a[0];if(d.name||(d.name=(new Date).getTime()+\".jpg\"),d.size>b.opts.imageMaxSize)return p(Ma),!1;if(b.opts.imageAllowedTypes.indexOf(d.type.replace(/image\\//g,\"\"))<0)return p(Na),!1;var e;if(b.drag_support.formdata&&(e=b.drag_support.formdata?new FormData:null),e){var f;if(!1!==b.opts.imageUploadToS3){e.append(\"key\",b.opts.imageUploadToS3.keyStart+(new Date).getTime()+\"-\"+(d.name||\"untitled\")),e.append(\"success_action_status\",\"201\"),e.append(\"X-Requested-With\",\"xhr\"),e.append(\"Content-Type\",d.type);for(f in b.opts.imageUploadToS3.params)b.opts.imageUploadToS3.params.hasOwnProperty(f)&&e.append(f,b.opts.imageUploadToS3.params[f])}for(f in b.opts.imageUploadParams)b.opts.imageUploadParams.hasOwnProperty(f)&&e.append(f,b.opts.imageUploadParams[f]);e.append(b.opts.imageUploadParam,d,d.name);var g=b.opts.imageUploadURL;b.opts.imageUploadToS3&&(g=b.opts.imageUploadToS3.uploadURL?b.opts.imageUploadToS3.uploadURL:\"https://\"+b.opts.imageUploadToS3.region+\".amazonaws.com/\"+b.opts.imageUploadToS3.bucket);G(b.core.getXHR(g,b.opts.imageUploadMethod),e,d,c||Da)}}}function I(c){b.events.$on(c,\"dragover dragenter\",\".fr-image-upload-layer\",function(){return a(this).addClass(\"fr-drop\"),!1},!0),b.events.$on(c,\"dragleave dragend\",\".fr-image-upload-layer\",function(){return a(this).removeClass(\"fr-drop\"),!1},!0),b.events.$on(c,\"drop\",\".fr-image-upload-layer\",function(d){d.preventDefault(),d.stopPropagation(),a(this).removeClass(\"fr-drop\");var e=d.originalEvent.dataTransfer;if(e&&e.files){var f=c.data(\"instance\")||b;f.events.disableBlur(),f.image.upload(e.files),f.events.enableBlur()}},!0),b.helpers.isIOS()&&b.events.$on(c,\"touchstart\",'.fr-image-upload-layer input[type=\"file\"]',function(){a(this).trigger(\"click\")},!0),b.events.$on(c,\"change\",'.fr-image-upload-layer input[type=\"file\"]',function(){if(this.files){var d=c.data(\"instance\")||b;d.events.disableBlur(),c.find(\"input:focus\").blur(),d.events.enableBlur(),d.image.upload(this.files,Da)}a(this).val(\"\")},!0)}function J(a){if(a.is(\"img\")&&a.parents(\".fr-img-caption\").length>0)return a.parents(\".fr-img-caption\")}function K(c){var d=c.originalEvent.dataTransfer;if(d&&d.files&&d.files.length){var e=d.files[0];if(e&&e.type&&-1!==e.type.indexOf(\"image\")){if(!b.opts.imageUpload)return c.preventDefault(),c.stopPropagation(),!1;b.markers.remove(),b.markers.insertAtPoint(c.originalEvent),b.$el.find(\".fr-marker\").replaceWith(a.FE.MARKERS),0===b.$el.find(\".fr-marker\").length&&b.selection.setAtEnd(b.el),b.popups.hideAll();var f=b.popups.get(\"image.insert\");f||(f=M()),b.popups.setContainer(\"image.insert\",b.$sc);var g=c.originalEvent.pageX,h=c.originalEvent.pageY;return b.opts.iframe&&(h+=b.$iframe.offset().top,g+=b.$iframe.offset().left),b.popups.show(\"image.insert\",g,h),r(),b.opts.imageAllowedTypes.indexOf(e.type.replace(/image\\//g,\"\"))>=0?(ja(!0),H(d.files)):p(Na),c.preventDefault(),c.stopPropagation(),!1}}}function L(){b.events.$on(b.$el,b._mousedown,\"IMG\"==b.el.tagName?null:'img:not([contenteditable=\"false\"])',function(c){if(\"false\"==a(this).parents(\"[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first\").attr(\"contenteditable\"))return!0;b.helpers.isMobile()||b.selection.clear(),Ha=!0,b.popups.areVisible()&&b.events.disableBlur(),b.browser.msie&&(b.events.disableBlur(),b.$el.attr(\"contenteditable\",!1)),b.draggable||\"touchstart\"==c.type||c.preventDefault(),c.stopPropagation()}),b.events.$on(b.$el,b._mouseup,\"IMG\"==b.el.tagName?null:'img:not([contenteditable=\"false\"])',function(c){if(\"false\"==a(this).parents(\"[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first\").attr(\"contenteditable\"))return!0;Ha&&(Ha=!1,c.stopPropagation(),b.browser.msie&&(b.$el.attr(\"contenteditable\",!0),b.events.enableBlur()))}),b.events.on(\"keyup\",function(c){if(c.shiftKey&&\"\"===b.selection.text().replace(/\\n/g,\"\")&&b.keys.isArrow(c.which)){var d=b.selection.element(),e=b.selection.endElement();d&&\"IMG\"==d.tagName?w(a(d)):e&&\"IMG\"==e.tagName&&w(a(e))}},!0),b.events.on(\"drop\",K),b.events.on(\"element.beforeDrop\",J),b.events.on(\"mousedown window.mousedown\",ka),b.events.on(\"window.touchmove\",la),b.events.on(\"mouseup window.mouseup\",function(){if(Da)return ja(),!1;la()}),b.events.on(\"commands.mousedown\",function(a){a.parents(\".fr-toolbar\").length>0&&ja()}),b.events.on(\"blur image.hideResizer commands.undo commands.redo element.dropped\",function(){Ha=!1,ja(!0)}),b.events.on(\"modals.hide\",function(){Da&&(wa(),b.selection.clear())})}function M(a){if(a)return b.popups.onRefresh(\"image.insert\",c),b.popups.onHide(\"image.insert\",f),!0;var d,e=\"\";b.opts.imageUpload||b.opts.imageInsertButtons.splice(b.opts.imageInsertButtons.indexOf(\"imageUpload\"),1),b.opts.imageInsertButtons.length>1&&(e='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.imageInsertButtons)+\"</div>\");var g=b.opts.imageInsertButtons.indexOf(\"imageUpload\"),h=b.opts.imageInsertButtons.indexOf(\"imageByURL\"),i=\"\";g>=0&&(d=\" fr-active\",h>=0&&g>h&&(d=\"\"),i='<div class=\"fr-image-upload-layer'+d+' fr-layer\" id=\"fr-image-upload-layer-'+b.id+'\"><strong>'+b.language.translate(\"Drop image\")+\"</strong><br>(\"+b.language.translate(\"or click\")+')<div class=\"fr-form\"><input type=\"file\" accept=\"image/'+b.opts.imageAllowedTypes.join(\", image/\").toLowerCase()+'\" tabIndex=\"-1\" aria-labelledby=\"fr-image-upload-layer-'+b.id+'\" role=\"button\"></div></div>');var j=\"\";h>=0&&(d=\" fr-active\",g>=0&&h>g&&(d=\"\"),j='<div class=\"fr-image-by-url-layer'+d+' fr-layer\" id=\"fr-image-by-url-layer-'+b.id+'\"><div class=\"fr-input-line\"><input id=\"fr-image-by-url-layer-text-'+b.id+'\" type=\"text\" placeholder=\"http://\" tabIndex=\"1\" aria-required=\"true\"></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"imageInsertByURL\" tabIndex=\"2\" role=\"button\">'+b.language.translate(\"Insert\")+\"</button></div></div>\");var k='<div class=\"fr-image-progress-bar-layer fr-layer\"><h3 tabIndex=\"-1\" class=\"fr-message\">Uploading</h3><div class=\"fr-loader\"><span class=\"fr-progress\"></span></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-dismiss\" data-cmd=\"imageDismissError\" tabIndex=\"2\" role=\"button\">OK</button></div></div>',l={buttons:e,upload_layer:i,by_url_layer:j,progress_bar:k},m=b.popups.create(\"image.insert\",l);return b.$wp&&b.events.$on(b.$wp,\"scroll\",function(){Da&&b.popups.isVisible(\"image.insert\")&&va()}),I(m),m}function N(){if(Da){b.popups.get(\"image.alt\").find(\"input\").val(Da.attr(\"alt\")||\"\").trigger(\"change\")}}function O(){var a=b.popups.get(\"image.alt\");a||(a=P()),s(),b.popups.refresh(\"image.alt\"),b.popups.setContainer(\"image.alt\",b.$sc);var c=za();Ba()&&(c=c.find(\".fr-img-wrap\"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show(\"image.alt\",d,e,c.outerHeight())}function P(a){if(a)return b.popups.onRefresh(\"image.alt\",N),!0;var c=\"\";c='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.imageAltButtons)+\"</div>\";var d=\"\";d='<div class=\"fr-image-alt-layer fr-layer fr-active\" id=\"fr-image-alt-layer-'+b.id+'\"><div class=\"fr-input-line\"><input id=\"fr-image-alt-layer-text-'+b.id+'\" type=\"text\" placeholder=\"'+b.language.translate(\"Alternate Text\")+'\" tabIndex=\"1\"></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"imageSetAlt\" tabIndex=\"2\" role=\"button\">'+b.language.translate(\"Update\")+\"</button></div></div>\";var e={buttons:c,alt_layer:d},f=b.popups.create(\"image.alt\",e);return b.$wp&&b.events.$on(b.$wp,\"scroll.image-alt\",function(){Da&&b.popups.isVisible(\"image.alt\")&&O()}),f}function Q(a){if(Da){var c=b.popups.get(\"image.alt\");Da.attr(\"alt\",a||c.find(\"input\").val()||\"\"),c.find(\"input:focus\").blur(),w(Da)}}function R(){if(Da){var a=b.popups.get(\"image.size\");a.find('input[name=\"width\"]').val(Da.get(0).style.width).trigger(\"change\"),a.find('input[name=\"height\"]').val(Da.get(0).style.height).trigger(\"change\")}}function S(){var a=b.popups.get(\"image.size\");a||(a=T()),s(),b.popups.refresh(\"image.size\"),b.popups.setContainer(\"image.size\",b.$sc);var c=za();Ba()&&(c=c.find(\".fr-img-wrap\"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show(\"image.size\",d,e,c.outerHeight())}function T(a){if(a)return b.popups.onRefresh(\"image.size\",R),!0;var c=\"\";c='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.imageSizeButtons)+\"</div>\";var d=\"\";d='<div class=\"fr-image-size-layer fr-layer fr-active\" id=\"fr-image-size-layer-'+b.id+'\"><div class=\"fr-image-group\"><div class=\"fr-input-line\"><input id=\"fr-image-size-layer-width-'+b.id+'\" type=\"text\" name=\"width\" placeholder=\"'+b.language.translate(\"Width\")+'\" tabIndex=\"1\"></div><div class=\"fr-input-line\"><input id=\"fr-image-size-layer-height'+b.id+'\" type=\"text\" name=\"height\" placeholder=\"'+b.language.translate(\"Height\")+'\" tabIndex=\"1\"></div></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"imageSetSize\" tabIndex=\"2\" role=\"button\">'+b.language.translate(\"Update\")+\"</button></div></div>\";var e={buttons:c,size_layer:d},f=b.popups.create(\"image.size\",e);return b.$wp&&b.events.$on(b.$wp,\"scroll.image-size\",function(){Da&&b.popups.isVisible(\"image.size\")&&S()}),f}function U(a,c){if(Da){var d=b.popups.get(\"image.size\");a=a||d.find('input[name=\"width\"]').val()||\"\",c=c||d.find('input[name=\"height\"]').val()||\"\";var e=/^[\\d]+((px)|%)*$/g;Da.removeAttr(\"width\").removeAttr(\"height\"),a.match(e)?Da.css(\"width\",a):Da.css(\"width\",\"\"),c.match(e)?Da.css(\"height\",c):Da.css(\"height\",\"\"),Ba()&&(Da.parent().removeAttr(\"width\").removeAttr(\"height\"),a.match(e)?Da.parent().css(\"width\",a):Da.parent().css(\"width\",\"\"),c.match(e)?Da.parent().css(\"height\",c):Da.parent().css(\"height\",\"\")),d.find(\"input:focus\").blur(),w(Da)}}function V(a){var c,d,e=b.popups.get(\"image.insert\");if(Da||b.opts.toolbarInline){if(Da){var f=za();Ba()&&(f=f.find(\".fr-img-wrap\")),d=f.offset().top+f.outerHeight(),c=f.offset().left+f.outerWidth()/2}}else{var g=b.$tb.find('.fr-command[data-cmd=\"insertImage\"]');c=g.offset().left+g.outerWidth()/2,d=g.offset().top+(b.opts.toolbarBottom?10:g.outerHeight()-10)}!Da&&b.opts.toolbarInline&&(d=e.offset().top-b.helpers.getPX(e.css(\"margin-top\")),e.hasClass(\"fr-above\")&&(d+=e.outerHeight())),e.find(\".fr-layer\").removeClass(\"fr-active\"),e.find(\".fr-\"+a+\"-layer\").addClass(\"fr-active\"),b.popups.show(\"image.insert\",c,d,Da?Da.outerHeight():0),b.accessibility.focusPopup(e)}function W(a){b.popups.get(\"image.insert\").find(\".fr-image-upload-layer\").hasClass(\"fr-active\")&&a.addClass(\"fr-active\").attr(\"aria-pressed\",!0)}function X(a){b.popups.get(\"image.insert\").find(\".fr-image-by-url-layer\").hasClass(\"fr-active\")&&a.addClass(\"fr-active\").attr(\"aria-pressed\",!0)}function Y(a,b,c,d){return a.pageX=b,m.call(this,a),a.pageX=a.pageX+c*Math.floor(Math.pow(1.1,d)),n.call(this,a),o.call(this,a),++d}function Z(){var c;if(b.shared.$image_resizer?(Ea=b.shared.$image_resizer,Ga=b.shared.$img_overlay,b.events.on(\"destroy\",function(){Ea.removeClass(\"fr-active\").appendTo(a(\"body:first\"))},!0)):(b.shared.$image_resizer=a('<div class=\"fr-image-resizer\"></div>'),Ea=b.shared.$image_resizer,b.events.$on(Ea,\"mousedown\",function(a){a.stopPropagation()},!0),b.opts.imageResize&&(Ea.append(l(\"nw\")+l(\"ne\")+l(\"sw\")+l(\"se\")),b.shared.$img_overlay=a('<div class=\"fr-image-overlay\"></div>'),Ga=b.shared.$img_overlay,c=Ea.get(0).ownerDocument,a(c).find(\"body:first\").append(Ga))),b.events.on(\"shared.destroy\",function(){Ea.html(\"\").removeData().remove(),Ea=null,b.opts.imageResize&&(Ga.remove(),Ga=null)},!0),b.helpers.isMobile()||b.events.$on(a(b.o_win),\"resize\",function(){Da&&!Da.hasClass(\"fr-uploading\")?ja(!0):Da&&(k(),va(),r(!1))}),b.opts.imageResize){c=Ea.get(0).ownerDocument,b.events.$on(Ea,b._mousedown,\".fr-handler\",m),b.events.$on(a(c),b._mousemove,n),b.events.$on(a(c.defaultView||c.parentWindow),b._mouseup,o),b.events.$on(Ga,\"mouseleave\",o);var d=1,e=null,f=0;b.events.on(\"keydown\",function(c){if(Da){var g=-1!=navigator.userAgent.indexOf(\"Mac OS X\")?c.metaKey:c.ctrlKey,h=c.which;(h!==e||c.timeStamp-f>200)&&(d=1),(h==a.FE.KEYCODE.EQUALS||b.browser.mozilla&&h==a.FE.KEYCODE.FF_EQUALS)&&g&&!c.altKey?d=Y.call(this,c,1,1,d):(h==a.FE.KEYCODE.HYPHEN||b.browser.mozilla&&h==a.FE.KEYCODE.FF_HYPHEN)&&g&&!c.altKey?d=Y.call(this,c,2,-1,d):b.keys.ctrlKey(c)||h!=a.FE.KEYCODE.ENTER||(Da.before(\"<br>\"),w(Da)),e=h,f=c.timeStamp}},!0),b.events.on(\"keyup\",function(){d=1})}}function $(c){(c=c||za())&&!1!==b.events.trigger(\"image.beforeRemove\",[c])&&(b.popups.hideAll(),wa(),ja(!0),b.undo.canDo()||b.undo.saveStep(),c.get(0)==b.el?c.removeAttr(\"src\"):(\"A\"==c.get(0).parentNode.tagName?(b.selection.setBefore(c.get(0).parentNode)||b.selection.setAfter(c.get(0).parentNode)||c.parent().after(a.FE.MARKERS),a(c.get(0).parentNode).remove()):(b.selection.setBefore(c.get(0))||b.selection.setAfter(c.get(0))||c.after(a.FE.MARKERS),c.remove()),b.html.fillEmptyBlocks(),b.selection.restore()),b.undo.saveStep())}function _(c){var d=c.which;if(Da&&(d==a.FE.KEYCODE.BACKSPACE||d==a.FE.KEYCODE.DELETE))return c.preventDefault(),c.stopPropagation(),$(),!1;if(Da&&d==a.FE.KEYCODE.ESC){var e=Da;return ja(!0),b.selection.setAfter(e.get(0)),b.selection.restore(),c.preventDefault(),!1}if(Da&&(d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT)){var f=Da.get(0);return ja(!0),d==a.FE.KEYCODE.ARROW_LEFT?b.selection.setBefore(f):b.selection.setAfter(f),b.selection.restore(),c.preventDefault(),!1}return Da&&d!=a.FE.KEYCODE.F10&&!b.keys.isBrowserAction(c)?(c.preventDefault(),c.stopPropagation(),!1):void 0}function aa(a){if(a&&\"IMG\"==a.tagName){if(b.node.hasClass(a,\"fr-uploading\")||b.node.hasClass(a,\"fr-error\")?a.parentNode.removeChild(a):b.node.hasClass(a,\"fr-draggable\")&&a.classList.remove(\"fr-draggable\"),a.parentNode&&a.parentNode.parentNode&&b.node.hasClass(a.parentNode.parentNode,\"fr-img-caption\")){var c=a.parentNode.parentNode;c.removeAttribute(\"contenteditable\"),c.removeAttribute(\"draggable\"),c.classList.remove(\"fr-draggable\");var d=a.nextSibling;d&&d.removeAttribute(\"contenteditable\")}}else if(a&&a.nodeType==Node.ELEMENT_NODE)for(var e=a.querySelectorAll(\"img.fr-uploading, img.fr-error, img.fr-draggable\"),f=0;f<e.length;f++)aa(e[f])}function ba(){if(L(),\"IMG\"==b.el.tagName&&b.$el.addClass(\"fr-view\"),b.events.$on(b.$el,b.helpers.isMobile()&&!b.helpers.isWindowsPhone()?\"touchend\":\"click\",\"IMG\"==b.el.tagName?null:'img:not([contenteditable=\"false\"])',ia),b.helpers.isMobile()&&(b.events.$on(b.$el,\"touchstart\",\"IMG\"==b.el.tagName?null:'img:not([contenteditable=\"false\"])',function(){Ra=!1}),b.events.$on(b.$el,\"touchmove\",function(){Ra=!0})),b.$wp?(b.events.on(\"window.keydown keydown\",_,!0),b.events.on(\"keyup\",function(b){if(Da&&b.which==a.FE.KEYCODE.ENTER)return!1},!0)):b.events.$on(b.$win,\"keydown\",_),b.events.on(\"toolbar.esc\",function(){if(Da){if(b.$wp)b.events.disableBlur(),b.events.focus();else{var a=Da;ja(!0),b.selection.setAfter(a.get(0)),b.selection.restore()}return!1}},!0),b.events.on(\"toolbar.focusEditor\",function(){if(Da)return!1},!0),b.events.on(\"window.cut window.copy\",function(a){Da&&b.popups.isVisible(\"image.edit\")&&!b.popups.get(\"image.edit\").find(\":focus\").length&&(wa(),b.paste.saveCopiedText(a,Da.get(0).outerHTML,Da.attr(\"alt\")),\"copy\"==a.type?setTimeout(function(){w(Da)}):(ja(!0),b.undo.saveStep(),setTimeout(function(){b.undo.saveStep()},0)))},!0),b.browser.msie&&b.events.on(\"keydown\",function(c){if(!b.selection.isCollapsed()||!Da)return!0;var d=c.which;d==a.FE.KEYCODE.C&&b.keys.ctrlKey(c)?b.events.trigger(\"window.copy\"):d==a.FE.KEYCODE.X&&b.keys.ctrlKey(c)&&b.events.trigger(\"window.cut\")}),b.events.$on(a(b.o_win),\"keydown\",function(b){var c=b.which;if(Da&&c==a.FE.KEYCODE.BACKSPACE)return b.preventDefault(),!1}),b.events.$on(b.$win,\"keydown\",function(b){var c=b.which;Da&&Da.hasClass(\"fr-uploading\")&&c==a.FE.KEYCODE.ESC&&Da.trigger(\"abortUpload\")}),b.events.on(\"destroy\",function(){Da&&Da.hasClass(\"fr-uploading\")&&Da.trigger(\"abortUpload\")}),b.events.on(\"paste.before\",ga),b.events.on(\"paste.beforeCleanup\",ha),b.events.on(\"paste.after\",da),b.events.on(\"html.set\",i),b.events.on(\"html.inserted\",i),i(),b.events.on(\"destroy\",function(){Qa=[]}),b.events.on(\"html.processGet\",aa),b.opts.imageOutputSize){var c;b.events.on(\"html.beforeGet\",function(){c=b.el.querySelectorAll(\"img\");for(var d=0;d<c.length;d++){var e=c[d].style.width||a(c[d]).width(),f=c[d].style.height||a(c[d]).height();e&&c[d].setAttribute(\"width\",(\"\"+e).replace(/px/,\"\")),f&&c[d].setAttribute(\"height\",(\"\"+f).replace(/px/,\"\"))}})}b.opts.iframe&&b.events.on(\"image.loaded\",b.size.syncIframe),b.$wp&&(j(),b.events.on(\"contentChanged\",j)),b.events.$on(a(b.o_win),\"orientationchange.image\",function(){setTimeout(function(){Da&&w(Da)},100)}),q(!0),M(!0),T(!0),P(!0),b.events.on(\"node.remove\",function(a){if(\"IMG\"==a.get(0).tagName)return $(a),!1})}function ca(c){if(!1===b.events.trigger(\"image.beforePasteUpload\",[c]))return!1;Da=a(c),k(),e(),va(),r();for(var d=atob(a(c).attr(\"src\").split(\",\")[1]),f=[],g=0;g<d.length;g++)f.push(d.charCodeAt(g));H([new Blob([new Uint8Array(f)],{type:\"image/jpeg\"})],Da)}function da(){b.opts.imagePaste?b.$el.find(\"img[data-fr-image-pasted]\").each(function(c,d){if(b.opts.imagePasteProcess){var e=b.opts.imageDefaultWidth;e&&\"auto\"!=e&&(e+=b.opts.imageResizeWithPercent?\"%\":\"px\"),a(d).css(\"width\",e).removeClass(\"fr-dii fr-dib fr-fir fr-fil\").addClass((b.opts.imageDefaultDisplay?\"fr-di\"+b.opts.imageDefaultDisplay[0]:\"\")+(b.opts.imageDefaultAlign&&\"center\"!=b.opts.imageDefaultAlign?\" fr-fi\"+b.opts.imageDefaultAlign[0]:\"\"))}if(0===d.src.indexOf(\"data:\"))ca(d);else if(0===d.src.indexOf(\"blob:\")||0===d.src.indexOf(\"http\")&&b.opts.imageUploadRemoteUrls&&b.opts.imageCORSProxy){var f=new Image;f.crossOrigin=\"Anonymous\",f.onload=function(){var a=b.o_doc.createElement(\"CANVAS\"),c=a.getContext(\"2d\");a.height=this.naturalHeight,a.width=this.naturalWidth,c.drawImage(this,0,0),d.src=a.toDataURL(\"image/png\"),ca(d)},f.src=(0===d.src.indexOf(\"blob:\")?\"\":b.opts.imageCORSProxy+\"/\")+d.src}else 0!==d.src.indexOf(\"http\")||0===d.src.indexOf(\"https://mail.google.com/mail\")?(b.selection.save(),a(d).remove(),b.selection.restore()):a(d).removeAttr(\"data-fr-image-pasted\")}):b.$el.find(\"img[data-fr-image-pasted]\").remove()}function ea(a){var c=a.target.result,d=b.opts.imageDefaultWidth;d&&\"auto\"!=d&&(d+=b.opts.imageResizeWithPercent?\"%\":\"px\"),b.html.insert('<img data-fr-image-pasted=\"true\" class=\"'+(b.opts.imageDefaultDisplay?\"fr-di\"+b.opts.imageDefaultDisplay[0]:\"\")+(b.opts.imageDefaultAlign&&\"center\"!=b.opts.imageDefaultAlign?\" fr-fi\"+b.opts.imageDefaultAlign[0]:\"\")+'\" src=\"'+c+'\"'+(d?' style=\"width: '+d+';\"':\"\")+\">\"),b.events.trigger(\"paste.after\")}\nfunction fa(a){var b=new FileReader;b.onload=ea,b.readAsDataURL(a)}function ga(a){if(a&&a.clipboardData&&a.clipboardData.items){var b=null;if(a.clipboardData.getData(\"text/rtf\"))b=a.clipboardData.items[0].getAsFile();else for(var c=0;c<a.clipboardData.items.length&&!(b=a.clipboardData.items[c].getAsFile());c++);if(b)return fa(b),!1}}function ha(a){return a=a.replace(/<img /gi,'<img data-fr-image-pasted=\"true\" ')}function ia(c){if(\"false\"==a(this).parents(\"[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first\").attr(\"contenteditable\"))return!0;if(c&&\"touchend\"==c.type&&Ra)return!0;if(c&&b.edit.isDisabled())return c.stopPropagation(),c.preventDefault(),!1;for(var d=0;d<a.FE.INSTANCES.length;d++)a.FE.INSTANCES[d]!=b&&a.FE.INSTANCES[d].events.trigger(\"image.hideResizer\");b.toolbar.disable(),c&&(c.stopPropagation(),c.preventDefault()),b.helpers.isMobile()&&(b.events.disableBlur(),b.$el.blur(),b.events.enableBlur()),b.opts.iframe&&b.size.syncIframe(),Da=a(this),b.browser.msie||wa(),k(),e(),b.browser.msie||b.selection.clear(),b.helpers.isIOS()&&(b.events.disableBlur(),b.$el.blur()),b.button.bulkRefresh(),b.events.trigger(\"video.hideResizer\")}function ja(a){Da&&(ma()||!0===a)&&(b.toolbar.enable(),Ea.removeClass(\"fr-active\"),b.popups.hide(\"image.edit\"),Da=null,la(),Fa=null,Ga&&Ga.hide())}function ka(){Sa=!0}function la(){Sa=!1}function ma(){return Sa}function na(a,c,d){if(b.opts.imageEditButtons.indexOf(\"imageAlign\")<0&&b.opts.imageEditButtons.indexOf(\"imageDisplay\")<0)return!1;!b.opts.htmlUntouched&&b.opts.useClasses?(a.removeClass(\"fr-fil fr-fir fr-dib fr-dii\"),d&&a.addClass(\"fr-fi\"+d[0]),c&&a.addClass(\"fr-di\"+c[0])):\"inline\"==c?(a.css({display:\"inline-block\",verticalAlign:\"bottom\",margin:b.opts.imageDefaultMargin}),\"center\"==d?a.css({float:\"none\",marginBottom:\"\",marginTop:\"\",maxWidth:\"calc(100% - \"+2*b.opts.imageDefaultMargin+\"px)\"}):\"left\"==d?a.css({float:\"left\",marginLeft:0,maxWidth:\"calc(100% - \"+b.opts.imageDefaultMargin+\"px)\"}):a.css({float:\"right\",marginRight:0,maxWidth:\"calc(100% - \"+b.opts.imageDefaultMargin+\"px)\"})):\"block\"==c&&(a.css({display:\"block\",float:\"none\",verticalAlign:\"top\",margin:b.opts.imageDefaultMargin+\"px auto\"}),\"left\"==d?a.css({marginLeft:0}):\"right\"==d&&a.css({marginRight:0}))}function oa(a){var c=za();c.removeClass(\"fr-fir fr-fil\"),!b.opts.htmlUntouched&&b.opts.useClasses?\"left\"==a?c.addClass(\"fr-fil\"):\"right\"==a&&c.addClass(\"fr-fir\"):na(c,qa(),a),wa(),k(),e(),b.selection.clear()}function pa(a){if(void 0===a&&(a=za()),a){if(a.hasClass(\"fr-fil\"))return\"left\";if(a.hasClass(\"fr-fir\"))return\"right\";if(a.hasClass(\"fr-dib\")||a.hasClass(\"fr-dii\"))return\"center\";var b=a.css(\"float\");if(a.css(\"float\",\"none\"),\"block\"==a.css(\"display\")){if(a.css(\"float\",\"\"),a.css(\"float\")!=b&&a.css(\"float\",b),0===parseInt(a.css(\"margin-left\"),10))return\"left\";if(0===parseInt(a.css(\"margin-right\"),10))return\"right\"}else{if(a.css(\"float\",\"\"),a.css(\"float\")!=b&&a.css(\"float\",b),\"left\"==a.css(\"float\"))return\"left\";if(\"right\"==a.css(\"float\"))return\"right\"}}return\"center\"}function qa(a){void 0===a&&(a=za());var b=a.css(\"float\");return a.css(\"float\",\"none\"),\"block\"==a.css(\"display\")?(a.css(\"float\",\"\"),a.css(\"float\")!=b&&a.css(\"float\",b),\"block\"):(a.css(\"float\",\"\"),a.css(\"float\")!=b&&a.css(\"float\",b),\"inline\")}function ra(a){Da&&a.find(\"> *:first\").replaceWith(b.icon.create(\"image-align-\"+pa()))}function sa(a,b){Da&&b.find('.fr-command[data-param1=\"'+pa()+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}function ta(a){var c=za();c.removeClass(\"fr-dii fr-dib\"),!b.opts.htmlUntouched&&b.opts.useClasses?\"inline\"==a?c.addClass(\"fr-dii\"):\"block\"==a&&c.addClass(\"fr-dib\"):na(c,a,pa()),wa(),k(),e(),b.selection.clear()}function ua(a,b){Da&&b.find('.fr-command[data-param1=\"'+qa()+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}function va(){var a=b.popups.get(\"image.insert\");a||(a=M()),b.popups.isVisible(\"image.insert\")||(s(),b.popups.refresh(\"image.insert\"),b.popups.setContainer(\"image.insert\",b.$sc));var c=za();Ba()&&(c=c.find(\".fr-img-wrap\"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show(\"image.insert\",d,e,c.outerHeight(!0))}function wa(){if(Da){b.events.disableBlur(),b.selection.clear();var a=b.doc.createRange();a.selectNode(Da.get(0));b.selection.get().addRange(a),b.events.enableBlur()}}function xa(){Da?(b.events.disableBlur(),a(\".fr-popup input:focus\").blur(),w(Da)):(b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),b.popups.hide(\"image.insert\"),b.toolbar.showInline())}function ya(){return Da}function za(){return Ba()?Da.parents(\".fr-img-caption:first\"):Da}function Aa(a,c,d){if(void 0===c&&(c=b.opts.imageStyles),void 0===d&&(d=b.opts.imageMultipleStyles),!Da)return!1;var e=za();if(!d){var f=Object.keys(c);f.splice(f.indexOf(a),1),e.removeClass(f.join(\" \"))}\"object\"==typeof c[a]?(e.removeAttr(\"style\"),e.css(c[a].style)):e.toggleClass(a),w(e)}function Ba(){return!!Da&&Da.parents(\".fr-img-caption\").length>0}function Ca(){var c;Da&&!Ba()?(c=Da,Da.parent().is(\"a\")&&(c=Da.parent()),c.wrap('<span contenteditable=\"false\" class=\"fr-img-caption '+Da.attr(\"class\")+'\" draggable=\"false\"></span>'),c.wrap('<span class=\"fr-img-wrap\"></span>'),c.after('<span class=\"fr-inner\" contenteditable=\"true\">'+a.FE.START_MARKER+\"Image caption\"+a.FE.END_MARKER+\"</span>\"),Da.removeAttr(\"class\"),Da.parent().css(\"width\",Da.width()),ja(!0),b.selection.restore()):(c=za(),Da.insertAfter(c),Da.attr(\"class\",c.attr(\"class\").replace(\"fr-img-caption\",\"\")),c.remove(),w(Da))}var Da,Ea,Fa,Ga,Ha=!1,Ia=1,Ja=2,Ka=3,La=4,Ma=5,Na=6,Oa=8,Pa={};Pa[Ia]=\"Image cannot be loaded from the passed link.\",Pa[Ja]=\"No link in upload response.\",Pa[Ka]=\"Error during file upload.\",Pa[La]=\"Parsing response failed.\",Pa[Ma]=\"File is too large.\",Pa[Na]=\"Image file type is invalid.\",Pa[7]=\"Files can be uploaded only to same domain in IE 8 and IE 9.\",Pa[Oa]=\"Image file is corrupted.\";var Qa,Ra,Sa=!1;return{_init:ba,showInsertPopup:d,showLayer:V,refreshUploadButton:W,refreshByURLButton:X,upload:H,insertByURL:v,align:oa,refreshAlign:ra,refreshAlignOnShow:sa,display:ta,refreshDisplayOnShow:ua,replace:va,back:xa,get:ya,getEl:za,insert:y,showProgressBar:r,remove:$,hideProgressBar:s,applyStyle:Aa,showAltPopup:O,showSizePopup:S,setAlt:Q,setSize:U,toggleCaption:Ca,hasCaption:Ba,exitEdit:ja,edit:w}},a.FE.DefineIcon(\"insertImage\",{NAME:\"image\"}),a.FE.RegisterShortcut(a.FE.KEYCODE.P,\"insertImage\",null,\"P\"),a.FE.RegisterCommand(\"insertImage\",{title:\"Insert Image\",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible(\"image.insert\")?(this.$el.find(\".fr-marker\").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide(\"image.insert\")):this.image.showInsertPopup()},plugin:\"image\"}),a.FE.DefineIcon(\"imageUpload\",{NAME:\"upload\"}),a.FE.RegisterCommand(\"imageUpload\",{title:\"Upload Image\",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer(\"image-upload\")},refresh:function(a){this.image.refreshUploadButton(a)}}),a.FE.DefineIcon(\"imageByURL\",{NAME:\"link\"}),a.FE.RegisterCommand(\"imageByURL\",{title:\"By URL\",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer(\"image-by-url\")},refresh:function(a){this.image.refreshByURLButton(a)}}),a.FE.RegisterCommand(\"imageInsertByURL\",{title:\"Insert Image\",undo:!0,refreshAfterCallback:!1,callback:function(){this.image.insertByURL()},refresh:function(a){this.image.get()?a.text(this.language.translate(\"Replace\")):a.text(this.language.translate(\"Insert\"))}}),a.FE.DefineIcon(\"imageDisplay\",{NAME:\"star\"}),a.FE.RegisterCommand(\"imageDisplay\",{title:\"Display\",type:\"dropdown\",options:{inline:\"Inline\",block:\"Break Text\"},callback:function(a,b){this.image.display(b)},refresh:function(a){this.opts.imageTextNear||a.addClass(\"fr-hidden\")},refreshOnShow:function(a,b){this.image.refreshDisplayOnShow(a,b)}}),a.FE.DefineIcon(\"image-align\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"image-align-left\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"image-align-right\",{NAME:\"align-right\"}),a.FE.DefineIcon(\"image-align-center\",{NAME:\"align-justify\"}),a.FE.DefineIcon(\"imageAlign\",{NAME:\"align-justify\"}),a.FE.RegisterCommand(\"imageAlign\",{type:\"dropdown\",title:\"Align\",options:{left:\"Align Left\",center:\"None\",right:\"Align Right\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.imageAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command fr-title\" tabIndex=\"-1\" role=\"option\" data-cmd=\"imageAlign\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.icon.create(\"image-align-\"+d)+'<span class=\"fr-sr-only\">'+this.language.translate(c[d])+\"</span></a></li>\");return b+=\"</ul>\"},callback:function(a,b){this.image.align(b)},refresh:function(a){this.image.refreshAlign(a)},refreshOnShow:function(a,b){this.image.refreshAlignOnShow(a,b)}}),a.FE.DefineIcon(\"imageReplace\",{NAME:\"exchange\"}),a.FE.RegisterCommand(\"imageReplace\",{title:\"Replace\",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.image.replace()}}),a.FE.DefineIcon(\"imageRemove\",{NAME:\"trash\"}),a.FE.RegisterCommand(\"imageRemove\",{title:\"Remove\",callback:function(){this.image.remove()}}),a.FE.DefineIcon(\"imageBack\",{NAME:\"arrow-left\"}),a.FE.RegisterCommand(\"imageBack\",{title:\"Back\",undo:!1,focus:!1,back:!0,callback:function(){this.image.back()},refresh:function(a){this.image.get()||this.opts.toolbarInline?(a.removeClass(\"fr-hidden\"),a.next(\".fr-separator\").removeClass(\"fr-hidden\")):(a.addClass(\"fr-hidden\"),a.next(\".fr-separator\").addClass(\"fr-hidden\"))}}),a.FE.RegisterCommand(\"imageDismissError\",{title:\"OK\",undo:!1,callback:function(){this.image.hideProgressBar(!0)}}),a.FE.DefineIcon(\"imageStyle\",{NAME:\"magic\"}),a.FE.RegisterCommand(\"imageStyle\",{title:\"Style\",type:\"dropdown\",html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.imageStyles;for(var c in b)if(b.hasOwnProperty(c)){var d=b[c];\"object\"==typeof d&&(d=d.title),a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"imageStyle\" data-param1=\"'+c+'\">'+this.language.translate(d)+\"</a></li>\"}return a+=\"</ul>\"},callback:function(a,b){this.image.applyStyle(b)},refreshOnShow:function(b,c){var d=this.image.getEl();d&&c.find(\".fr-command\").each(function(){var b=a(this).data(\"param1\"),c=d.hasClass(b);a(this).toggleClass(\"fr-active\",c).attr(\"aria-selected\",c)})}}),a.FE.DefineIcon(\"imageAlt\",{NAME:\"info\"}),a.FE.RegisterCommand(\"imageAlt\",{undo:!1,focus:!1,popup:!0,title:\"Alternate Text\",callback:function(){this.image.showAltPopup()}}),a.FE.RegisterCommand(\"imageSetAlt\",{undo:!0,focus:!1,title:\"Update\",refreshAfterCallback:!1,callback:function(){this.image.setAlt()}}),a.FE.DefineIcon(\"imageSize\",{NAME:\"arrows-alt\"}),a.FE.RegisterCommand(\"imageSize\",{undo:!1,focus:!1,popup:!0,title:\"Change Size\",callback:function(){this.image.showSizePopup()}}),a.FE.RegisterCommand(\"imageSetSize\",{undo:!0,focus:!1,title:\"Update\",refreshAfterCallback:!1,callback:function(){this.image.setSize()}}),a.FE.DefineIcon(\"imageCaption\",{NAME:\"commenting\"}),a.FE.RegisterCommand(\"imageCaption\",{undo:!0,focus:!1,title:\"Image Caption\",refreshAfterCallback:!0,callback:function(){this.image.toggleCaption()},refresh:function(a){this.image.get()&&a.toggleClass(\"fr-active\",this.image.hasCaption())}})});"

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1486))

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.POPUP_TEMPLATES,{\"link.edit\":\"[_BUTTONS_]\",\"link.insert\":\"[_BUTTONS_][_INPUT_LAYER_]\"}),a.extend(a.FE.DEFAULTS,{linkEditButtons:[\"linkOpen\",\"linkStyle\",\"linkEdit\",\"linkRemove\"],linkInsertButtons:[\"linkBack\",\"|\",\"linkList\"],linkAttributes:{},linkAutoPrefix:\"http://\",linkStyles:{\"fr-green\":\"Green\",\"fr-strong\":\"Thick\"},linkMultipleStyles:!0,linkConvertEmailAddress:!0,linkAlwaysBlank:!1,linkAlwaysNoFollow:!1,linkList:[{text:\"Froala\",href:\"https://froala.com\",target:\"_blank\"},{text:\"Google\",href:\"https://google.com\",target:\"_blank\"},{displayText:\"Facebook\",href:\"https://facebook.com\"}],linkText:!0}),a.FE.PLUGINS.link=function(b){function c(){var c=b.image?b.image.get():null;if(!c&&b.$wp){var d=b.selection.ranges(0).commonAncestorContainer;if(d&&(d.contains&&d.contains(b.el)||!b.el.contains(d)||b.el==d)&&(d=null),d&&\"A\"===d.tagName)return d;var e=b.selection.element(),f=b.selection.endElement();return\"A\"==e.tagName||b.node.isElement(e)||(e=a(e).parentsUntil(b.$el,\"a:first\").get(0)),\"A\"==f.tagName||b.node.isElement(f)||(f=a(f).parentsUntil(b.$el,\"a:first\").get(0)),f&&(f.contains&&f.contains(b.el)||!b.el.contains(f)||b.el==f)&&(f=null),e&&(e.contains&&e.contains(b.el)||!b.el.contains(e)||b.el==e)&&(e=null),f&&f==e&&\"A\"==f.tagName?(b.browser.msie||b.helpers.isMobile())&&(b.selection.info(e).atEnd||b.selection.info(e).atStart)?null:e:null}return\"A\"==b.el.tagName?b.el:c&&c.get(0).parentNode&&\"A\"==c.get(0).parentNode.tagName?c.get(0).parentNode:void 0}function d(){var a=b.image?b.image.get():null,c=[];if(a)\"A\"==a.get(0).parentNode.tagName&&c.push(a.get(0).parentNode);else{var d,e,f,g;if(b.win.getSelection){var h=b.win.getSelection();if(h.getRangeAt&&h.rangeCount){g=b.doc.createRange();for(var i=0;i<h.rangeCount;++i)if(d=h.getRangeAt(i),e=d.commonAncestorContainer,e&&1!=e.nodeType&&(e=e.parentNode),e&&\"a\"==e.nodeName.toLowerCase())c.push(e);else{f=e.getElementsByTagName(\"a\");for(var j=0;j<f.length;++j)g.selectNodeContents(f[j]),g.compareBoundaryPoints(d.END_TO_START,d)<1&&g.compareBoundaryPoints(d.START_TO_END,d)>-1&&c.push(f[j])}}}else if(b.doc.selection&&\"Control\"!=b.doc.selection.type)if(d=b.doc.selection.createRange(),e=d.parentElement(),\"a\"==e.nodeName.toLowerCase())c.push(e);else{f=e.getElementsByTagName(\"a\"),g=b.doc.body.createTextRange();for(var k=0;k<f.length;++k)g.moveToElementText(f[k]),g.compareEndPoints(\"StartToEnd\",d)>-1&&g.compareEndPoints(\"EndToStart\",d)<1&&c.push(f[k])}}return c}function e(d){if(b.core.hasFocus()){if(g(),d&&\"keyup\"===d.type&&(d.altKey||d.which==a.FE.KEYCODE.ALT))return!0;setTimeout(function(){if(!d||d&&(1==d.which||\"mouseup\"!=d.type)){var e=c(),g=b.image?b.image.get():null;if(e&&!g){if(b.image){var h=b.node.contents(e);if(1==h.length&&\"IMG\"==h[0].tagName){var i=b.selection.ranges(0);return 0===i.startOffset&&0===i.endOffset?a(e).before(a.FE.MARKERS):a(e).after(a.FE.MARKERS),b.selection.restore(),!1}}d&&d.stopPropagation(),f(e)}}},b.helpers.isIOS()?100:0)}}function f(c){var d=b.popups.get(\"link.edit\");d||(d=h());var e=a(c);b.popups.isVisible(\"link.edit\")||b.popups.refresh(\"link.edit\"),b.popups.setContainer(\"link.edit\",b.$sc);var f=e.offset().left+a(c).outerWidth()/2,g=e.offset().top+e.outerHeight();b.popups.show(\"link.edit\",f,g,e.outerHeight())}function g(){b.popups.hide(\"link.edit\")}function h(){var a=\"\";b.opts.linkEditButtons.length>1&&(\"A\"==b.el.tagName&&b.opts.linkEditButtons.indexOf(\"linkRemove\")>=0&&b.opts.linkEditButtons.splice(b.opts.linkEditButtons.indexOf(\"linkRemove\"),1),a='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.linkEditButtons)+\"</div>\");var d={buttons:a},e=b.popups.create(\"link.edit\",d);return b.$wp&&b.events.$on(b.$wp,\"scroll.link-edit\",function(){c()&&b.popups.isVisible(\"link.edit\")&&f(c())}),e}function i(){}function j(){var d=b.popups.get(\"link.insert\"),e=c();if(e){var f,g,h=a(e),i=d.find('input.fr-link-attr[type=\"text\"]'),j=d.find('input.fr-link-attr[type=\"checkbox\"]');for(f=0;f<i.length;f++)g=a(i[f]),g.val(h.attr(g.attr(\"name\")||\"\"));for(j.prop(\"checked\",!1),f=0;f<j.length;f++)g=a(j[f]),h.attr(g.attr(\"name\"))==g.data(\"checked\")&&g.prop(\"checked\",!0);d.find('input.fr-link-attr[type=\"text\"][name=\"text\"]').val(h.text())}else d.find('input.fr-link-attr[type=\"text\"]').val(\"\"),d.find('input.fr-link-attr[type=\"checkbox\"]').prop(\"checked\",!1),d.find('input.fr-link-attr[type=\"text\"][name=\"text\"]').val(b.selection.text());d.find(\"input.fr-link-attr\").trigger(\"change\"),(b.image?b.image.get():null)?d.find('.fr-link-attr[name=\"text\"]').parent().hide():d.find('.fr-link-attr[name=\"text\"]').parent().show()}function k(){var a=b.$tb.find('.fr-command[data-cmd=\"insertLink\"]'),c=b.popups.get(\"link.insert\");if(c||(c=l()),!c.hasClass(\"fr-active\"))if(b.popups.refresh(\"link.insert\"),b.popups.setContainer(\"link.insert\",b.$tb||b.$sc),a.is(\":visible\")){var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show(\"link.insert\",d,e,a.outerHeight())}else b.position.forSelection(c),b.popups.show(\"link.insert\")}function l(a){if(a)return b.popups.onRefresh(\"link.insert\",j),b.popups.onHide(\"link.insert\",i),!0;var d=\"\";b.opts.linkInsertButtons.length>=1&&(d='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.linkInsertButtons)+\"</div>\");var e='<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"10\" height=\"10\" viewBox=\"0 0 32 32\"><path d=\"M27 4l-15 15-7-7-5 5 12 12 20-20z\" fill=\"#FFF\"></path></svg>',f=\"\",g=0;f='<div class=\"fr-link-insert-layer fr-layer fr-active\" id=\"fr-link-insert-layer-'+b.id+'\">',f+='<div class=\"fr-input-line\"><input id=\"fr-link-insert-layer-url-'+b.id+'\" name=\"href\" type=\"text\" class=\"fr-link-attr\" placeholder=\"'+b.language.translate(\"URL\")+'\" tabIndex=\"'+ ++g+'\"></div>',b.opts.linkText&&(f+='<div class=\"fr-input-line\"><input id=\"fr-link-insert-layer-text-'+b.id+'\" name=\"text\" type=\"text\" class=\"fr-link-attr\" placeholder=\"'+b.language.translate(\"Text\")+'\" tabIndex=\"'+ ++g+'\"></div>');for(var h in b.opts.linkAttributes)if(b.opts.linkAttributes.hasOwnProperty(h)){var k=b.opts.linkAttributes[h];f+='<div class=\"fr-input-line\"><input name=\"'+h+'\" type=\"text\" class=\"fr-link-attr\" placeholder=\"'+b.language.translate(k)+'\" tabIndex=\"'+ ++g+'\"></div>'}b.opts.linkAlwaysBlank||(f+='<div class=\"fr-checkbox-line\"><span class=\"fr-checkbox\"><input name=\"target\" class=\"fr-link-attr\" data-checked=\"_blank\" type=\"checkbox\" id=\"fr-link-target-'+b.id+'\" tabIndex=\"'+ ++g+'\"><span>'+e+'</span></span><label for=\"fr-link-target-'+b.id+'\">'+b.language.translate(\"Open in new tab\")+\"</label></div>\"),f+='<div class=\"fr-action-buttons\"><button class=\"fr-command fr-submit\" role=\"button\" data-cmd=\"linkInsert\" href=\"#\" tabIndex=\"'+ ++g+'\" type=\"button\">'+b.language.translate(\"Insert\")+\"</button></div></div>\";var l={buttons:d,input_layer:f},m=b.popups.create(\"link.insert\",l);return b.$wp&&b.events.$on(b.$wp,\"scroll.link-insert\",function(){(b.image?b.image.get():null)&&b.popups.isVisible(\"link.insert\")&&u(),c&&b.popups.isVisible(\"link.insert\")&&s()}),m}function m(){var d=c(),e=b.image?b.image.get():null;if(!1===b.events.trigger(\"link.beforeRemove\",[d]))return!1;e&&d?(e.unwrap(),b.image.edit(e)):d&&(b.selection.save(),a(d).replaceWith(a(d).html()),b.selection.restore(),g())}function n(){b.events.on(\"keyup\",function(b){b.which!=a.FE.KEYCODE.ESC&&e(b)}),b.events.on(\"window.mouseup\",e),b.events.$on(b.$el,\"click\",\"a\",function(a){b.edit.isDisabled()&&a.preventDefault()}),b.helpers.isMobile()&&b.events.$on(b.$doc,\"selectionchange\",e),l(!0),\"A\"==b.el.tagName&&b.$el.addClass(\"fr-view\"),b.events.on(\"toolbar.esc\",function(){if(b.popups.isVisible(\"link.edit\"))return b.events.disableBlur(),b.events.focus(),!1},!0)}function o(c){var d,e,f=b.opts.linkList[c],g=b.popups.get(\"link.insert\"),h=g.find('input.fr-link-attr[type=\"text\"]'),i=g.find('input.fr-link-attr[type=\"checkbox\"]');for(e=0;e<h.length;e++)d=a(h[e]),f[d.attr(\"name\")]?d.val(f[d.attr(\"name\")]):\"text\"!=d.attr(\"name\")&&d.val(\"\");for(e=0;e<i.length;e++)d=a(i[e]),d.prop(\"checked\",d.data(\"checked\")==f[d.attr(\"name\")]);b.accessibility.focusPopup(g)}function p(){var c,d,e=b.popups.get(\"link.insert\"),f=e.find('input.fr-link-attr[type=\"text\"]'),g=e.find('input.fr-link-attr[type=\"checkbox\"]'),h=(f.filter('[name=\"href\"]').val()||\"\").trim(),i=f.filter('[name=\"text\"]').val(),j={};for(d=0;d<f.length;d++)c=a(f[d]),[\"href\",\"text\"].indexOf(c.attr(\"name\"))<0&&(j[c.attr(\"name\")]=c.val());for(d=0;d<g.length;d++)c=a(g[d]),c.is(\":checked\")?j[c.attr(\"name\")]=c.data(\"checked\"):j[c.attr(\"name\")]=c.data(\"unchecked\")||null;var k=b.helpers.scrollTop();r(h,i,j),a(b.o_win).scrollTop(k)}function q(){if(!b.selection.isCollapsed()){b.selection.save();for(var c=b.$el.find(\".fr-marker\").addClass(\"fr-unprocessed\").toArray();c.length;){var d=a(c.pop());d.removeClass(\"fr-unprocessed\");var e=b.node.deepestParent(d.get(0));if(e){var f=d.get(0),g=\"\",h=\"\";do{f=f.parentNode,b.node.isBlock(f)||(g+=b.node.closeTagString(f),h=b.node.openTagString(f)+h)}while(f!=e);var i=b.node.openTagString(d.get(0))+d.html()+b.node.closeTagString(d.get(0));d.replaceWith('<span id=\"fr-break\"></span>');var j=e.outerHTML;j=j.replace(/<span id=\"fr-break\"><\\/span>/g,g+i+h),e.outerHTML=j}c=b.$el.find(\".fr-marker.fr-unprocessed\").toArray()}b.html.cleanEmptyTags(),b.selection.restore()}}function r(f,g,h){if(void 0===h&&(h={}),!1===b.events.trigger(\"link.beforeInsert\",[f,g,h]))return!1;var i=b.image?b.image.get():null;i||\"A\"==b.el.tagName?\"A\"==b.el.tagName&&b.$el.focus():(b.selection.restore(),b.popups.hide(\"link.insert\"));var j=f;b.opts.linkConvertEmailAddress&&b.helpers.isEmail(f)&&!/^mailto:.*/i.test(f)&&(f=\"mailto:\"+f);var k=/^([A-Za-z]:(\\\\){1,2}|[A-Za-z]:((\\\\){1,2}[^\\\\]+)+)(\\\\)?$/i;if(\"\"===b.opts.linkAutoPrefix||new RegExp(\"^(\"+a.FE.LinkProtocols.join(\"|\")+\"):.\",\"i\").test(f)||/^data:image.*/i.test(f)||/^(https?:|ftps?:|file:|)\\/\\//i.test(f)||k.test(f)||[\"/\",\"{\",\"[\",\"#\",\"(\"].indexOf((f||\"\")[0])<0&&(f=b.opts.linkAutoPrefix+f),f=b.helpers.sanitizeURL(f),b.opts.linkAlwaysBlank&&(h.target=\"_blank\"),b.opts.linkAlwaysNoFollow&&(h.rel=\"nofollow\"),\"_blank\"==h.target?h.rel?h.rel+=\" noopener noreferrer\":h.rel=\"noopener noreferrer\":null==h.target&&(h.rel?h.rel=h.rel.replace(/noopener/,\"\").replace(/noreferrer/,\"\"):h.rel=null),g=g||\"\",f===b.opts.linkAutoPrefix){return b.popups.get(\"link.insert\").find('input[name=\"href\"]').addClass(\"fr-error\"),b.events.trigger(\"link.bad\",[j]),!1}var l,m=c();if(m)l=a(m),l.attr(\"href\",f),g.length>0&&l.text()!=g&&!i&&l.text(g),i||l.prepend(a.FE.START_MARKER).append(a.FE.END_MARKER),l.attr(h),i||b.selection.restore();else{i?i.wrap('<a href=\"'+f+'\"></a>'):(b.format.remove(\"a\"),b.selection.isCollapsed()?(g=0===g.length?j:g,b.html.insert('<a href=\"'+f+'\">'+a.FE.START_MARKER+g+a.FE.END_MARKER+\"</a>\"),b.selection.restore()):g.length>0&&g!=b.selection.text().replace(/\\n/g,\"\")?(b.selection.remove(),b.html.insert('<a href=\"'+f+'\">'+a.FE.START_MARKER+g+a.FE.END_MARKER+\"</a>\"),b.selection.restore()):(q(),b.format.apply(\"a\",{href:f})));for(var n=d(),o=0;o<n.length;o++)l=a(n[o]),l.attr(h),l.removeAttr(\"_moz_dirty\");1==n.length&&b.$wp&&!i&&(a(n[0]).prepend(a.FE.START_MARKER).append(a.FE.END_MARKER),b.selection.restore())}if(i){var p=b.popups.get(\"link.insert\");p&&p.find(\"input:focus\").blur(),b.image.edit(i)}else e()}function s(){g();var d=c();if(d){var e=b.popups.get(\"link.insert\");e||(e=l()),b.popups.isVisible(\"link.insert\")||(b.popups.refresh(\"link.insert\"),b.selection.save(),b.helpers.isMobile()&&(b.events.disableBlur(),b.$el.blur(),b.events.enableBlur())),b.popups.setContainer(\"link.insert\",b.$sc);var f=(b.image?b.image.get():null)||a(d),h=f.offset().left+f.outerWidth()/2,i=f.offset().top+f.outerHeight();b.popups.show(\"link.insert\",h,i,f.outerHeight())}}function t(){(b.image?b.image.get():null)?b.image.back():(b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),c()&&b.$wp?(b.selection.restore(),g(),e()):\"A\"==b.el.tagName?(b.$el.focus(),e()):(b.popups.hide(\"link.insert\"),b.toolbar.showInline()))}function u(){var a=b.image?b.image.getEl():null;if(a){var c=b.popups.get(\"link.insert\");b.image.hasCaption()&&(a=a.find(\".fr-img-wrap\")),c||(c=l()),j(!0),b.popups.setContainer(\"link.insert\",b.$sc);var d=a.offset().left+a.outerWidth(!0)/2,e=a.offset().top+a.outerHeight(!0);b.popups.show(\"link.insert\",d,e,a.outerHeight())}}function v(d,f,g){void 0===g&&(g=b.opts.linkMultipleStyles),void 0===f&&(f=b.opts.linkStyles);var h=c();if(!h)return!1;if(!g){var i=Object.keys(f);i.splice(i.indexOf(d),1),a(h).removeClass(i.join(\" \"))}a(h).toggleClass(d),e()}return{_init:n,remove:m,showInsertPopup:k,usePredefined:o,insertCallback:p,insert:r,update:s,get:c,allSelected:d,back:t,imageLink:u,applyStyle:v}},a.FE.DefineIcon(\"insertLink\",{NAME:\"link\"}),a.FE.RegisterShortcut(a.FE.KEYCODE.K,\"insertLink\",null,\"K\"),a.FE.RegisterCommand(\"insertLink\",{title:\"Insert Link\",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible(\"link.insert\")?(this.$el.find(\".fr-marker\").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide(\"link.insert\")):this.link.showInsertPopup()},plugin:\"link\"}),a.FE.DefineIcon(\"linkOpen\",{NAME:\"external-link\"}),a.FE.RegisterCommand(\"linkOpen\",{title:\"Open Link\",undo:!1,refresh:function(a){this.link.get()?a.removeClass(\"fr-hidden\"):a.addClass(\"fr-hidden\")},callback:function(){var a=this.link.get();a&&(this.o_win.open(a.href,\"_blank\",\"noopener\"),this.popups.hide(\"link.edit\"))},plugin:\"link\"}),a.FE.DefineIcon(\"linkEdit\",{NAME:\"edit\"}),a.FE.RegisterCommand(\"linkEdit\",{title:\"Edit Link\",undo:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.link.update()},refresh:function(a){this.link.get()?a.removeClass(\"fr-hidden\"):a.addClass(\"fr-hidden\")},plugin:\"link\"}),a.FE.DefineIcon(\"linkRemove\",{NAME:\"unlink\"}),a.FE.RegisterCommand(\"linkRemove\",{title:\"Unlink\",callback:function(){this.link.remove()},refresh:function(a){this.link.get()?a.removeClass(\"fr-hidden\"):a.addClass(\"fr-hidden\")},plugin:\"link\"}),a.FE.DefineIcon(\"linkBack\",{NAME:\"arrow-left\"}),a.FE.RegisterCommand(\"linkBack\",{title:\"Back\",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.link.back()},refresh:function(a){var b=this.link.get()&&this.doc.hasFocus();(this.image?this.image.get():null)||b||this.opts.toolbarInline?(a.removeClass(\"fr-hidden\"),a.next(\".fr-separator\").removeClass(\"fr-hidden\")):(a.addClass(\"fr-hidden\"),a.next(\".fr-separator\").addClass(\"fr-hidden\"))},plugin:\"link\"}),a.FE.DefineIcon(\"linkList\",{NAME:\"search\"}),a.FE.RegisterCommand(\"linkList\",{title:\"Choose Link\",type:\"dropdown\",focus:!1,undo:!1,refreshAfterCallback:!1,html:function(){for(var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.linkList,c=0;c<b.length;c++)a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"linkList\" data-param1=\"'+c+'\">'+(b[c].displayText||b[c].text)+\"</a></li>\";return a+=\"</ul>\"},callback:function(a,b){this.link.usePredefined(b)},plugin:\"link\"}),a.FE.RegisterCommand(\"linkInsert\",{focus:!1,refreshAfterCallback:!1,callback:function(){this.link.insertCallback()},refresh:function(a){this.link.get()?a.text(this.language.translate(\"Update\")):a.text(this.language.translate(\"Insert\"))},plugin:\"link\"}),a.FE.DefineIcon(\"imageLink\",{NAME:\"link\"}),a.FE.RegisterCommand(\"imageLink\",{title:\"Insert Link\",undo:!1,focus:!1,popup:!0,callback:function(){this.link.imageLink()},refresh:function(a){var b,c=this.link.get();c?(b=a.prev(),b.hasClass(\"fr-separator\")&&b.removeClass(\"fr-hidden\"),a.addClass(\"fr-hidden\")):(b=a.prev(),b.hasClass(\"fr-separator\")&&b.addClass(\"fr-hidden\"),a.removeClass(\"fr-hidden\"))},plugin:\"link\"}),a.FE.DefineIcon(\"linkStyle\",{NAME:\"magic\"}),a.FE.RegisterCommand(\"linkStyle\",{title:\"Style\",type:\"dropdown\",html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.linkStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"linkStyle\" data-param1=\"'+c+'\">'+this.language.translate(b[c])+\"</a></li>\");return a+=\"</ul>\"},callback:function(a,b){this.link.applyStyle(b)},refreshOnShow:function(b,c){var d=this.link.get();if(d){var e=a(d);c.find(\".fr-command\").each(function(){var b=a(this).data(\"param1\"),c=e.hasClass(b);a(this).toggleClass(\"fr-active\",c).attr(\"aria-selected\",c)})}},refresh:function(a){this.link.get()?a.removeClass(\"fr-hidden\"):a.addClass(\"fr-hidden\")},plugin:\"link\"})});"

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1488))

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.PLUGINS.lists=function(b){function c(a){return'<span class=\"fr-open-'+a.toLowerCase()+'\"></span>'}function d(a){return'<span class=\"fr-close-'+a.toLowerCase()+'\"></span>'}function e(b,c){for(var d=[],e=0;e<b.length;e++){var f=b[e].parentNode;\"LI\"==b[e].tagName&&f.tagName!=c&&d.indexOf(f)<0&&d.push(f)}for(e=d.length-1;e>=0;e--){var g=a(d[e]);g.replaceWith(\"<\"+c.toLowerCase()+\">\"+g.html()+\"</\"+c.toLowerCase()+\">\")}}function f(c,d){e(c,d);var f,g=b.html.defaultTag(),h=null;c.length&&(f=\"rtl\"==b.opts.direction||\"rtl\"==a(c[0]).css(\"direction\")?\"margin-right\":\"margin-left\");for(var i=0;i<c.length;i++)if(\"LI\"!=c[i].tagName){var j=b.helpers.getPX(a(c[i]).css(f))||0;c[i].style.marginLeft=null,null===h&&(h=j);var k=h>0?\"<\"+d+' style=\"'+f+\": \"+h+'px;\">':\"<\"+d+\">\",l=\"</\"+d+\">\";for(j-=h;j/b.opts.indentMargin>0;)k+=\"<\"+d+\">\",l+=l,j-=b.opts.indentMargin;g&&c[i].tagName.toLowerCase()==g?a(c[i]).replaceWith(k+\"<li\"+b.node.attributes(c[i])+\">\"+a(c[i]).html()+\"</li>\"+l):a(c[i]).wrap(k+\"<li></li>\"+l)}b.clean.lists()}function g(e){var f,g;for(f=e.length-1;f>=0;f--)for(g=f-1;g>=0;g--)if(a(e[g]).find(e[f]).length||e[g]==e[f]){e.splice(f,1);break}var h=[];for(f=0;f<e.length;f++){var i=a(e[f]),j=e[f].parentNode,k=i.attr(\"class\");if(i.before(d(j.tagName)),\"LI\"==j.parentNode.tagName)i.before(d(\"LI\")),i.after(c(\"LI\"));else{var l=\"\";k&&(l+=' class=\"'+k+'\"');var m=\"rtl\"==b.opts.direction||\"rtl\"==i.css(\"direction\")?\"margin-right\":\"margin-left\";b.helpers.getPX(a(j).css(m))&&(a(j).attr(\"style\")||\"\").indexOf(m+\":\")>=0&&(l+=' style=\"'+m+\":\"+b.helpers.getPX(a(j).css(m))+'px;\"'),l&&i.wrapInner(\"<\"+b.html.defaultTag()+l+\"></\"+b.html.defaultTag()+\">\"),b.node.isEmpty(i.get(0),!0)||0!==i.find(b.html.blockTagsQuery()).length||i.append(\"<br>\"),i.append(c(\"LI\")),i.prepend(d(\"LI\"))}i.after(c(j.tagName)),\"LI\"==j.parentNode.tagName&&(j=j.parentNode.parentNode),h.indexOf(j)<0&&h.push(j)}for(f=0;f<h.length;f++){var n=a(h[f]),o=n.html();o=o.replace(/<span class=\"fr-close-([a-z]*)\"><\\/span>/g,\"</$1>\"),o=o.replace(/<span class=\"fr-open-([a-z]*)\"><\\/span>/g,\"<$1>\"),n.replaceWith(b.node.openTagString(n.get(0))+o+b.node.closeTagString(n.get(0)))}b.$el.find(\"li:empty\").remove(),b.$el.find(\"ul:empty, ol:empty\").remove(),b.clean.lists(),b.html.wrap()}function h(a,b){for(var c=!0,d=0;d<a.length;d++){if(\"LI\"!=a[d].tagName)return!1;a[d].parentNode.tagName!=b&&(c=!1)}return c}function i(a){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var c=b.selection.blocks(),d=0;d<c.length;d++)\"LI\"!=c[d].tagName&&\"LI\"==c[d].parentNode.tagName&&(c[d]=c[d].parentNode);b.selection.save(),h(c,a)?g(c):f(c,a),b.html.unwrap(),b.selection.restore()}function j(c,d){var e=a(b.selection.element());if(e.get(0)!=b.el){var f=e.get(0);f=\"LI\"!=f.tagName&&f.firstElementChild&&\"LI\"!=f.firstElementChild.tagName?e.parents(\"li\").get(0):\"LI\"==f.tagName||f.firstElementChild?f.firstElementChild&&\"LI\"==f.firstElementChild.tagName?e.get(0).firstChild:e.get(0):e.parents(\"li\").get(0),f&&f.parentNode.tagName==d&&b.el.contains(f.parentNode)&&c.addClass(\"fr-active\")}}function k(c){b.selection.save();for(var d=0;d<c.length;d++){var e=c[d].previousSibling;if(e){var f=a(c[d]).find(\"> ul, > ol\").last().get(0);if(f){for(var g=a(\"<li>\").prependTo(a(f)),h=b.node.contents(c[d])[0];h&&!b.node.isList(h);){var i=h.nextSibling;g.append(h),h=i}a(e).append(a(f)),a(c[d]).remove()}else{var j=a(e).find(\"> ul, > ol\").last().get(0);if(j)a(j).append(a(c[d]));else{var k=a(\"<\"+c[d].parentNode.tagName+\">\");a(e).append(k),k.append(a(c[d]))}}}}b.clean.lists(),b.selection.restore()}function l(a){b.selection.save(),g(a),b.selection.restore()}function m(a){if(\"indent\"==a||\"outdent\"==a){for(var c=!1,d=b.selection.blocks(),e=[],f=0;f<d.length;f++)\"LI\"==d[f].tagName?(c=!0,e.push(d[f])):\"LI\"==d[f].parentNode.tagName&&(c=!0,e.push(d[f].parentNode));c&&(\"indent\"==a?k(e):l(e))}}function n(){b.events.on(\"commands.after\",m),b.events.on(\"keydown\",function(c){if(c.which==a.FE.KEYCODE.TAB){for(var d=b.selection.blocks(),e=[],f=0;f<d.length;f++)\"LI\"==d[f].tagName?e.push(d[f]):\"LI\"==d[f].parentNode.tagName&&e.push(d[f].parentNode);if(e.length>1||e.length&&(b.selection.info(e[0]).atStart||b.node.isEmpty(e[0])))return c.preventDefault(),c.stopPropagation(),c.shiftKey?l(e):k(e),!1}},!0)}return{_init:n,format:i,refresh:j}},a.FE.RegisterCommand(\"formatUL\",{title:\"Unordered List\",refresh:function(a){this.lists.refresh(a,\"UL\")},callback:function(){this.lists.format(\"UL\")},plugin:\"lists\"}),a.FE.RegisterCommand(\"formatOL\",{title:\"Ordered List\",refresh:function(a){this.lists.refresh(a,\"OL\")},callback:function(){this.lists.format(\"OL\")},plugin:\"lists\"}),a.FE.DefineIcon(\"formatUL\",{NAME:\"list-ul\"}),a.FE.DefineIcon(\"formatOL\",{NAME:\"list-ol\"})});"

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1490))

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.PLUGINS.quote=function(b){function c(a){for(;a.parentNode&&a.parentNode!=b.el;)a=a.parentNode;return a}function d(){var d,e=b.selection.blocks();for(d=0;d<e.length;d++)e[d]=c(e[d]);b.selection.save();var f=a(\"<blockquote>\");for(f.insertBefore(e[0]),d=0;d<e.length;d++)f.append(e[d]);b.html.unwrap(),b.selection.restore()}function e(){var c,d=b.selection.blocks();for(c=0;c<d.length;c++)\"BLOCKQUOTE\"!=d[c].tagName&&(d[c]=a(d[c]).parentsUntil(b.$el,\"BLOCKQUOTE\").get(0));for(b.selection.save(),c=0;c<d.length;c++)d[c]&&a(d[c]).replaceWith(d[c].innerHTML);b.html.unwrap(),b.selection.restore()}function f(a){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore(),\"increase\"==a?d():\"decrease\"==a&&e()}return{apply:f}},a.FE.RegisterShortcut(a.FE.KEYCODE.SINGLE_QUOTE,\"quote\",\"increase\",\"'\"),a.FE.RegisterShortcut(a.FE.KEYCODE.SINGLE_QUOTE,\"quote\",\"decrease\",\"'\",!0),a.FE.RegisterCommand(\"quote\",{title:\"Quote\",type:\"dropdown\",options:{increase:\"Increase\",decrease:\"Decrease\"},callback:function(a,b){this.quote.apply(b)},plugin:\"quote\"}),a.FE.DefineIcon(\"quote\",{NAME:\"quote-left\"})});"

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1492))

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.POPUP_TEMPLATES,{\"table.insert\":\"[_BUTTONS_][_ROWS_COLUMNS_]\",\"table.edit\":\"[_BUTTONS_]\",\"table.colors\":\"[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]\"}),a.extend(a.FE.DEFAULTS,{tableInsertMaxSize:10,tableEditButtons:[\"tableHeader\",\"tableRemove\",\"|\",\"tableRows\",\"tableColumns\",\"tableStyle\",\"-\",\"tableCells\",\"tableCellBackground\",\"tableCellVerticalAlign\",\"tableCellHorizontalAlign\",\"tableCellStyle\"],tableInsertButtons:[\"tableBack\",\"|\"],tableResizer:!0,tableResizerOffset:5,tableResizingLimit:30,tableColorsButtons:[\"tableBack\",\"|\"],tableColors:[\"#61BD6D\",\"#1ABC9C\",\"#54ACD2\",\"#2C82C9\",\"#9365B8\",\"#475577\",\"#CCCCCC\",\"#41A85F\",\"#00A885\",\"#3D8EB9\",\"#2969B0\",\"#553982\",\"#28324E\",\"#000000\",\"#F7DA64\",\"#FBA026\",\"#EB6B56\",\"#E25041\",\"#A38F84\",\"#EFEFEF\",\"#FFFFFF\",\"#FAC51C\",\"#F37934\",\"#D14841\",\"#B8312F\",\"#7C706B\",\"#D1D5D8\",\"REMOVE\"],tableColorsStep:7,tableCellStyles:{\"fr-highlighted\":\"Highlighted\",\"fr-thick\":\"Thick\"},tableStyles:{\"fr-dashed-borders\":\"Dashed Borders\",\"fr-alternate-rows\":\"Alternate Rows\"},tableCellMultipleStyles:!0,tableMultipleStyles:!0,tableInsertHelper:!0,tableInsertHelperOffset:15}),a.FE.PLUGINS.table=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd=\"insertTable\"]'),c=b.popups.get(\"table.insert\");if(c||(c=g()),!c.hasClass(\"fr-active\")){b.popups.refresh(\"table.insert\"),b.popups.setContainer(\"table.insert\",b.$tb);var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show(\"table.insert\",d,e,a.outerHeight())}}function d(){var a=J();if(a){var c=b.popups.get(\"table.edit\");if(c||(c=k()),c){b.popups.setContainer(\"table.edit\",b.$sc);var d=R(a),e=(d.left+d.right)/2,f=d.bottom;b.popups.show(\"table.edit\",e,f,d.bottom-d.top),b.edit.isDisabled()&&(b.toolbar.disable(),b.$el.removeClass(\"fr-no-selection\"),b.edit.on(),b.button.bulkRefresh(),b.selection.setAtEnd(b.$el.find(\".fr-selected-cell:last\").get(0)),b.selection.restore())}}}function e(){var a=J();if(a){var c=b.popups.get(\"table.colors\");c||(c=l()),b.popups.setContainer(\"table.colors\",b.$sc);var d=R(a),e=(d.left+d.right)/2,f=d.bottom;p(),b.popups.show(\"table.colors\",e,f,d.bottom-d.top)}}function f(){0===ta().length&&b.toolbar.enable()}function g(c){if(c)return b.popups.onHide(\"table.insert\",function(){b.popups.get(\"table.insert\").find('.fr-table-size .fr-select-table-size > span[data-row=\"1\"][data-col=\"1\"]').trigger(\"mouseenter\")}),!0;var d=\"\";b.opts.tableInsertButtons.length>0&&(d='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.tableInsertButtons)+\"</div>\");var e={buttons:d,rows_columns:i()},f=b.popups.create(\"table.insert\",e);return b.events.$on(f,\"mouseenter\",\".fr-table-size .fr-select-table-size .fr-table-cell\",function(b){h(a(b.currentTarget))},!0),j(f),f}function h(a){var c=a.data(\"row\"),d=a.data(\"col\"),e=a.parent();e.siblings(\".fr-table-size-info\").html(c+\" &times; \"+d),e.find(\"> span\").removeClass(\"hover fr-active-item\");for(var f=1;f<=b.opts.tableInsertMaxSize;f++)for(var g=0;g<=b.opts.tableInsertMaxSize;g++){var h=e.find('> span[data-row=\"'+f+'\"][data-col=\"'+g+'\"]');f<=c&&g<=d?h.addClass(\"hover\"):f<=c+1||f<=2&&!b.helpers.isMobile()?h.css(\"display\",\"inline-block\"):f>2&&!b.helpers.isMobile()&&h.css(\"display\",\"none\")}a.addClass(\"fr-active-item\")}function i(){for(var a='<div class=\"fr-table-size\"><div class=\"fr-table-size-info\">1 &times; 1</div><div class=\"fr-select-table-size\">',c=1;c<=b.opts.tableInsertMaxSize;c++){for(var d=1;d<=b.opts.tableInsertMaxSize;d++){var e=\"inline-block\";c>2&&!b.helpers.isMobile()&&(e=\"none\");var f=\"fr-table-cell \";1==c&&1==d&&(f+=\" hover\"),a+='<span class=\"fr-command '+f+'\" tabIndex=\"-1\" data-cmd=\"tableInsert\" data-row=\"'+c+'\" data-col=\"'+d+'\" data-param1=\"'+c+'\" data-param2=\"'+d+'\" style=\"display: '+e+';\" role=\"button\"><span></span><span class=\"fr-sr-only\">'+c+\" &times; \"+d+\"&nbsp;&nbsp;&nbsp;</span></span>\"}a+='<div class=\"new-line\"></div>'}return a+=\"</div></div>\"}function j(c){b.events.$on(c,\"focus\",\"[tabIndex]\",function(b){h(a(b.currentTarget))}),b.events.on(\"popup.tab\",function(c){var d=a(c.currentTarget);if(!b.popups.isVisible(\"table.insert\")||!d.is(\"span, a\"))return!0;var e,f=c.which;if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){if(d.is(\"span.fr-table-cell\")){var g=d.parent().find(\"span.fr-table-cell\"),i=g.index(d),j=b.opts.tableInsertMaxSize,k=i%j,l=Math.floor(i/j);a.FE.KEYCODE.ARROW_UP==f?l=Math.max(0,l-1):a.FE.KEYCODE.ARROW_DOWN==f?l=Math.min(b.opts.tableInsertMaxSize-1,l+1):a.FE.KEYCODE.ARROW_LEFT==f?k=Math.max(0,k-1):a.FE.KEYCODE.ARROW_RIGHT==f&&(k=Math.min(b.opts.tableInsertMaxSize-1,k+1));var m=l*j+k,n=a(g.get(m));h(n),b.events.disableBlur(),n.focus(),e=!1}}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(d),e=!1);return!1===e&&(c.preventDefault(),c.stopPropagation()),e},!0)}function k(a){if(a)return b.popups.onHide(\"table.edit\",f),!0;var c=\"\";if(b.opts.tableEditButtons.length>0){c='<div class=\"fr-buttons\">'+b.button.buildList(b.opts.tableEditButtons)+\"</div>\";var e={buttons:c},g=b.popups.create(\"table.edit\",e);return b.events.$on(b.$wp,\"scroll.table-edit\",function(){b.popups.isVisible(\"table.edit\")&&d()}),g}return!1}function l(){var a=\"\";b.opts.tableColorsButtons.length>0&&(a='<div class=\"fr-buttons fr-table-colors-buttons\">'+b.button.buildList(b.opts.tableColorsButtons)+\"</div>\");var c=\"\";b.opts.colorsHEXInput&&(c='<div class=\"fr-table-colors-hex-layer fr-active fr-layer\" id=\"fr-table-colors-hex-layer-'+b.id+'\"><div class=\"fr-input-line\"><input maxlength=\"7\" id=\"fr-table-colors-hex-layer-text-'+b.id+'\" type=\"text\" placeholder=\"'+b.language.translate(\"HEX Color\")+'\" tabIndex=\"1\" aria-required=\"true\"></div><div class=\"fr-action-buttons\"><button type=\"button\" class=\"fr-command fr-submit\" data-cmd=\"tableCellBackgroundCustomColor\" tabIndex=\"2\" role=\"button\">'+b.language.translate(\"OK\")+\"</button></div></div>\");var d={buttons:a,colors:m(),custom_color:c},f=b.popups.create(\"table.colors\",d);return b.events.$on(b.$wp,\"scroll.table-colors\",function(){b.popups.isVisible(\"table.colors\")&&e()}),o(f),f}function m(){for(var a='<div class=\"fr-table-colors\">',c=0;c<b.opts.tableColors.length;c++)0!==c&&c%b.opts.tableColorsStep==0&&(a+=\"<br>\"),\"REMOVE\"!=b.opts.tableColors[c]?a+='<span class=\"fr-command\" style=\"background: '+b.opts.tableColors[c]+';\" tabIndex=\"-1\" role=\"button\" data-cmd=\"tableCellBackgroundColor\" data-param1=\"'+b.opts.tableColors[c]+'\"><span class=\"fr-sr-only\">'+b.language.translate(\"Color\")+\" \"+b.opts.tableColors[c]+\"&nbsp;&nbsp;&nbsp;</span></span>\":a+='<span class=\"fr-command\" data-cmd=\"tableCellBackgroundColor\" tabIndex=\"-1\" role=\"button\" data-param1=\"REMOVE\" title=\"'+b.language.translate(\"Clear Formatting\")+'\">'+b.icon.create(\"tableColorRemove\")+'<span class=\"fr-sr-only\">'+b.language.translate(\"Clear Formatting\")+\"</span></span>\";return a+=\"</div>\"}function n(){var a=b.popups.get(\"table.colors\"),c=a.find(\".fr-table-colors-hex-layer input\");c.length&&F(c.val())}function o(c){b.events.on(\"popup.tab\",function(d){var e=a(d.currentTarget);if(!b.popups.isVisible(\"table.colors\")||!e.is(\"span\"))return!0;var f=d.which,g=!0;if(a.FE.KEYCODE.TAB==f){var h=c.find(\".fr-buttons\");g=!b.accessibility.focusToolbar(h,!!d.shiftKey)}else if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){var i=e.parent().find(\"span.fr-command\"),j=i.index(e),k=b.opts.colorsStep,l=Math.floor(i.length/k),m=j%k,n=Math.floor(j/k),o=n*k+m,p=l*k;a.FE.KEYCODE.ARROW_UP==f?o=((o-k)%p+p)%p:a.FE.KEYCODE.ARROW_DOWN==f?o=(o+k)%p:a.FE.KEYCODE.ARROW_LEFT==f?o=((o-1)%p+p)%p:a.FE.KEYCODE.ARROW_RIGHT==f&&(o=(o+1)%p);var q=a(i.get(o));b.events.disableBlur(),q.focus(),g=!1}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(e),g=!1);return!1===g&&(d.preventDefault(),d.stopPropagation()),g},!0)}function p(){var a=b.popups.get(\"table.colors\"),c=b.$el.find(\".fr-selected-cell:first\"),d=b.helpers.RGBToHex(c.css(\"background-color\")),e=a.find(\".fr-table-colors-hex-layer input\");a.find(\".fr-selected-color\").removeClass(\"fr-selected-color fr-active-item\"),a.find('span[data-param1=\"'+d+'\"]').addClass(\"fr-selected-color fr-active-item\"),e.val(d).trigger(\"change\")}function q(c,d){var e,f,g='<table style=\"width: 100%;\" class=\"fr-inserted-table\"><tbody>',h=100/d;for(e=0;e<c;e++){for(g+=\"<tr>\",f=0;f<d;f++)g+='<td style=\"width: '+h.toFixed(4)+'%;\">',0===e&&0===f&&(g+=a.FE.MARKERS),g+=\"<br></td>\";g+=\"</tr>\"}g+=\"</tbody></table>\",b.html.insert(g),b.selection.restore();var i=b.$el.find(\".fr-inserted-table\");i.removeClass(\"fr-inserted-table\"),b.events.trigger(\"table.inserted\",[i.get(0)])}function r(){if(ta().length>0){var a=ua();b.selection.setBefore(a.get(0))||b.selection.setAfter(a.get(0)),b.selection.restore(),b.popups.hide(\"table.edit\"),a.remove(),b.toolbar.enable()}}function s(){var b=ua();if(b.length>0&&0===b.find(\"th\").length){var c,e=\"<thead><tr>\",f=0;for(b.find(\"tr:first > td\").each(function(){var b=a(this);f+=parseInt(b.attr(\"colspan\"),10)||1}),c=0;c<f;c++)e+=\"<th><br></th>\";e+=\"</tr></thead>\",b.prepend(e),d()}}function t(){var a=ua(),c=a.find(\"thead\");if(c.length>0)if(0===a.find(\"tbody tr\").length)r();else if(c.remove(),ta().length>0)d();else{b.popups.hide(\"table.edit\");var e=a.find(\"tbody tr:first td:first\").get(0);e&&(b.selection.setAtEnd(e),b.selection.restore())}}function u(c){var e=ua();if(e.length>0){if(b.$el.find(\"th.fr-selected-cell\").length>0&&\"above\"==c)return;var f,g,h,i=J(),j=P(i);g=\"above\"==c?j.min_i:j.max_i;var k=\"<tr>\";for(f=0;f<i[g].length;f++)if(\"below\"==c&&g<i.length-1&&i[g][f]==i[g+1][f]||\"above\"==c&&g>0&&i[g][f]==i[g-1][f]){if(0===f||f>0&&i[g][f]!=i[g][f-1]){var l=a(i[g][f]);l.attr(\"rowspan\",parseInt(l.attr(\"rowspan\"),10)+1)}}else k+=\"<td><br></td>\";k+=\"</tr>\",h=a(b.$el.find(\"th.fr-selected-cell\").length>0&&\"below\"==c?e.find(\"tbody\").not(e.find(\"table tbody\")):e.find(\"tr\").not(e.find(\"table tr\")).get(g)),\"below\"==c?\"TBODY\"==h.prop(\"tagName\")?h.prepend(k):h.after(k):\"above\"==c&&(h.before(k),b.popups.isVisible(\"table.edit\")&&d())}}function v(){var c=ua();if(c.length>0){var d,e,f,g=J(),h=P(g);if(0===h.min_i&&h.max_i==g.length-1)r();else{for(d=h.max_i;d>=h.min_i;d--){for(f=a(c.find(\"tr\").not(c.find(\"table tr\")).get(d)),e=0;e<g[d].length;e++)if(0===e||g[d][e]!=g[d][e-1]){var i=a(g[d][e]);if(parseInt(i.attr(\"rowspan\"),10)>1){var j=parseInt(i.attr(\"rowspan\"),10)-1;1==j?i.removeAttr(\"rowspan\"):i.attr(\"rowspan\",j)}if(d<g.length-1&&g[d][e]==g[d+1][e]&&(0===d||g[d][e]!=g[d-1][e])){for(var k=g[d][e],l=e;l>0&&g[d][l]==g[d][l-1];)l--;0===l?a(c.find(\"tr\").not(c.find(\"table tr\")).get(d+1)).prepend(k):a(g[d+1][l-1]).after(k)}}var m=f.parent();f.remove(),0===m.find(\"tr\").length&&m.remove(),g=J(c)}B(0,g.length-1,0,g[0].length-1,c),h.min_i>0?b.selection.setAtEnd(g[h.min_i-1][0]):b.selection.setAtEnd(g[0][0]),b.selection.restore(),b.popups.hide(\"table.edit\")}}}function w(c){var e=ua();if(e.length>0){var f,g=J(),h=P(g);f=\"before\"==c?h.min_j:h.max_j;var i,j=100/g[0].length,k=100/(g[0].length+1);e.find(\"th, td\").each(function(){i=a(this),i.data(\"old-width\",i.outerWidth()/e.outerWidth()*100)}),e.find(\"tr\").not(e.find(\"table tr\")).each(function(b){for(var d,e=a(this),h=0,i=0;h-1<f;){if(!(d=e.find(\"> th, > td\").get(i))){d=null;break}d==g[b][h]?(h+=parseInt(a(d).attr(\"colspan\"),10)||1,i++):(h+=parseInt(a(g[b][h]).attr(\"colspan\"),10)||1,\"after\"==c&&(d=0===i?-1:e.find(\"> th, > td\").get(i-1)))}var l=a(d);if(\"after\"==c&&h-1>f||\"before\"==c&&f>0&&g[b][f]==g[b][f-1]){if(0===b||b>0&&g[b][f]!=g[b-1][f]){var m=parseInt(l.attr(\"colspan\"),10)+1;l.attr(\"colspan\",m),l.css(\"width\",(l.data(\"old-width\")*k/j+k).toFixed(4)+\"%\"),l.removeData(\"old-width\")}}else{var n;n=e.find(\"th\").length>0?'<th style=\"width: '+k.toFixed(4)+'%;\"><br></th>':'<td style=\"width: '+k.toFixed(4)+'%;\"><br></td>',-1==d?e.prepend(n):null==d?e.append(n):\"before\"==c?l.before(n):\"after\"==c&&l.after(n)}}),e.find(\"th, td\").each(function(){i=a(this),i.data(\"old-width\")&&(i.css(\"width\",(i.data(\"old-width\")*k/j).toFixed(4)+\"%\"),i.removeData(\"old-width\"))}),b.popups.isVisible(\"table.edit\")&&d()}}function x(){var c=ua();if(c.length>0){var d,e,f,g=J(),h=P(g);if(0===h.min_j&&h.max_j==g[0].length-1)r();else{var i=100/g[0].length,j=100/(g[0].length-h.max_j+h.min_j-1);for(c.find(\"th, td\").each(function(){f=a(this),f.hasClass(\"fr-selected-cell\")||f.data(\"old-width\",f.outerWidth()/c.outerWidth()*100)}),e=h.max_j;e>=h.min_j;e--)for(d=0;d<g.length;d++)if(0===d||g[d][e]!=g[d-1][e])if(f=a(g[d][e]),(parseInt(f.attr(\"colspan\"),10)||1)>1){var k=parseInt(f.attr(\"colspan\"),10)-1;1==k?f.removeAttr(\"colspan\"):f.attr(\"colspan\",k),f.css(\"width\",((f.data(\"old-width\")-la(e,g))*j/i).toFixed(4)+\"%\"),f.removeData(\"old-width\")}else{var l=a(f.parent().get(0));f.remove(),0===l.find(\"> th, > td\").length&&(0===l.prev().length||0===l.next().length||l.prev().find(\"> th[rowspan], > td[rowspan]\").length<l.prev().find(\"> th, > td\").length)&&l.remove()}B(0,g.length-1,0,g[0].length-1,c),h.min_j>0?b.selection.setAtEnd(g[h.min_i][h.min_j-1]):b.selection.setAtEnd(g[h.min_i][0]),b.selection.restore(),b.popups.hide(\"table.edit\"),c.find(\"th, td\").each(function(){f=a(this),f.data(\"old-width\")&&(f.css(\"width\",(f.data(\"old-width\")*j/i).toFixed(4)+\"%\"),f.removeData(\"old-width\"))})}}}function y(a,b,c){var d,e,f,g,h,i=0,j=J(c);if((b=Math.min(b,j[0].length-1))>a)for(e=a;e<=b;e++)if(!(e>a&&j[0][e]==j[0][e-1])&&(g=Math.min(parseInt(j[0][e].getAttribute(\"colspan\"),10)||1,b-a+1))>1&&j[0][e]==j[0][e+1])for(i=g-1,d=1;d<j.length;d++)if(j[d][e]!=j[d-1][e]){for(f=e;f<e+g;f++)if((h=parseInt(j[d][f].getAttribute(\"colspan\"),10)||1)>1&&j[d][f]==j[d][f+1])i=Math.min(i,h-1),f+=i;else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&A(j,i,\"colspan\",0,j.length-1,a,b)}function z(a,b,c){var d,e,f,g,h,i=0,j=J(c);if((b=Math.min(b,j.length-1))>a)for(d=a;d<=b;d++)if(!(d>a&&j[d][0]==j[d-1][0])&&(g=Math.min(parseInt(j[d][0].getAttribute(\"rowspan\"),10)||1,b-a+1))>1&&j[d][0]==j[d+1][0])for(i=g-1,e=1;e<j[0].length;e++)if(j[d][e]!=j[d][e-1]){for(f=d;f<d+g;f++)if((h=parseInt(j[f][e].getAttribute(\"rowspan\"),10)||1)>1&&j[f][e]==j[f+1][e])i=Math.min(i,h-1),f+=i;else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&A(j,i,\"rowspan\",a,b,0,j[0].length-1)}function A(a,b,c,d,e,f,g){var h,i,j;for(h=d;h<=e;h++)for(i=f;i<=g;i++)h>d&&a[h][i]==a[h-1][i]||i>f&&a[h][i]==a[h][i-1]||(j=parseInt(a[h][i].getAttribute(c),10)||1)>1&&(j-b>1?a[h][i].setAttribute(c,j-b):a[h][i].removeAttribute(c))}function B(a,b,c,d,e){z(a,b,e),y(c,d,e)}function C(){if(ta().length>1&&(0===b.$el.find(\"th.fr-selected-cell\").length||0===b.$el.find(\"td.fr-selected-cell\").length)){M();var c,e,f=J(),g=P(f),h=b.$el.find(\".fr-selected-cell\"),i=a(h[0]),j=i.parent(),k=j.find(\".fr-selected-cell\"),l=i.closest(\"table\"),m=i.html(),n=0;for(c=0;c<k.length;c++)n+=a(k[c]).outerWidth();for(i.css(\"width\",(n/l.outerWidth()*100).toFixed(4)+\"%\"),g.min_j<g.max_j&&i.attr(\"colspan\",g.max_j-g.min_j+1),g.min_i<g.max_i&&i.attr(\"rowspan\",g.max_i-g.min_i+1),c=1;c<h.length;c++)e=a(h[c]),\"<br>\"!=e.html()&&\"\"!==e.html()&&(m+=\"<br>\"+e.html()),e.remove();i.html(m),b.selection.setAtEnd(i.get(0)),b.selection.restore(),b.toolbar.enable(),z(g.min_i,g.max_i,l);var o=l.find(\"tr:empty\");for(c=o.length-1;c>=0;c--)a(o[c]).remove();y(g.min_j,g.max_j,l),d()}}function D(){if(1==ta().length){var c=b.$el.find(\".fr-selected-cell\"),d=c.parent(),e=c.closest(\"table\"),f=parseInt(c.attr(\"rowspan\"),10),g=J(),h=K(c.get(0),g),i=c.clone().html(\"<br>\");if(f>1){var j=Math.ceil(f/2);j>1?c.attr(\"rowspan\",j):c.removeAttr(\"rowspan\"),f-j>1?i.attr(\"rowspan\",f-j):i.removeAttr(\"rowspan\");for(var k=h.row+j,l=0===h.col?h.col:h.col-1;l>=0&&(g[k][l]==g[k][l-1]||k>0&&g[k][l]==g[k-1][l]);)l--;-1==l?a(e.find(\"tr\").not(e.find(\"table tr\")).get(k)).prepend(i):a(g[k][l]).after(i)}else{var m,n=a(\"<tr>\").append(i);for(m=0;m<g[0].length;m++)if(0===m||g[h.row][m]!=g[h.row][m-1]){var o=a(g[h.row][m]);o.is(c)||o.attr(\"rowspan\",(parseInt(o.attr(\"rowspan\"),10)||1)+1)}d.after(n)}N(),b.popups.hide(\"table.edit\")}}function E(){if(1==ta().length){var c=b.$el.find(\".fr-selected-cell\"),d=parseInt(c.attr(\"colspan\"),10)||1,e=c.parent().outerWidth(),f=c.outerWidth(),g=c.clone().html(\"<br>\"),h=J(),i=K(c.get(0),h);if(d>1){var j=Math.ceil(d/2);f=ma(i.col,i.col+j-1,h)/e*100;var k=ma(i.col+j,i.col+d-1,h)/e*100;j>1?c.attr(\"colspan\",j):c.removeAttr(\"colspan\"),d-j>1?g.attr(\"colspan\",d-j):g.removeAttr(\"colspan\"),c.css(\"width\",f.toFixed(4)+\"%\"),g.css(\"width\",k.toFixed(4)+\"%\")}else{var l;for(l=0;l<h.length;l++)if(0===l||h[l][i.col]!=h[l-1][i.col]){var m=a(h[l][i.col]);if(!m.is(c)){var n=(parseInt(m.attr(\"colspan\"),10)||1)+1;m.attr(\"colspan\",n)}}f=f/e*100/2,c.css(\"width\",f.toFixed(4)+\"%\"),g.css(\"width\",f.toFixed(4)+\"%\")}c.after(g),N(),b.popups.hide(\"table.edit\")}}function F(a){var c=b.$el.find(\".fr-selected-cell\");\"REMOVE\"!=a?c.css(\"background-color\",b.helpers.HEXtoRGB(a)):c.css(\"background-color\",\"\"),d()}function G(a){b.$el.find(\".fr-selected-cell\").css(\"vertical-align\",a)}function H(a){b.$el.find(\".fr-selected-cell\").css(\"text-align\",a)}function I(a,b,c,d){if(b.length>0){if(!c){var e=Object.keys(d);e.splice(e.indexOf(a),1),b.removeClass(e.join(\" \"))}b.toggleClass(a)}}function J(b){b=b||null;var c=[];return null==b&&ta().length>0&&(b=ua()),b&&b.find(\"tr\").not(b.find(\"table tr\")).each(function(b,d){var e=a(d),f=0;e.find(\"> th, > td\").each(function(d,e){for(var g=a(e),h=parseInt(g.attr(\"colspan\"),10)||1,i=parseInt(g.attr(\"rowspan\"),10)||1,j=b;j<b+i;j++)for(var k=f;k<f+h;k++)c[j]||(c[j]=[]),c[j][k]?f++:c[j][k]=e;f+=h})}),c}function K(a,b){for(var c=0;c<b.length;c++)for(var d=0;d<b[c].length;d++)if(b[c][d]==a)return{row:c,col:d}}function L(a,b,c){for(var d=a+1,e=b+1;d<c.length;){if(c[d][b]!=c[a][b]){d--;break}d++}for(d==c.length&&d--;e<c[a].length;){if(c[a][e]!=c[a][b]){e--;break}e++}return e==c[a].length&&e--,{row:d,col:e}}function M(){b.el.querySelector(\".fr-cell-fixed\")&&b.el.querySelector(\".fr-cell-fixed\").classList.remove(\"fr-cell-fixed\"),b.el.querySelector(\".fr-cell-handler\")&&b.el.querySelector(\".fr-cell-handler\").classList.remove(\"fr-cell-handler\")}function N(){var c=b.$el.find(\".fr-selected-cell\");c.length>0&&c.each(function(){var b=a(this);b.removeClass(\"fr-selected-cell\"),\"\"===b.attr(\"class\")&&b.removeAttr(\"class\")}),M()}function O(){b.events.disableBlur(),b.selection.clear(),b.$el.addClass(\"fr-no-selection\"),b.$el.blur(),b.events.enableBlur()}function P(a){var c=b.$el.find(\".fr-selected-cell\");if(c.length>0){var d,e=a.length,f=0,g=a[0].length,h=0;for(d=0;d<c.length;d++){var i=K(c[d],a),j=L(i.row,i.col,a);e=Math.min(i.row,e),f=Math.max(j.row,f),g=Math.min(i.col,g),h=Math.max(j.col,h)}return{min_i:e,max_i:f,min_j:g,max_j:h}}return null}function Q(b,c,d,e,f){var g,h,i,j,k=b,l=c,m=d,n=e;for(g=k;g<=l;g++)((parseInt(a(f[g][m]).attr(\"rowspan\"),10)||1)>1||(parseInt(a(f[g][m]).attr(\"colspan\"),10)||1)>1)&&(i=K(f[g][m],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n)),((parseInt(a(f[g][n]).attr(\"rowspan\"),10)||1)>1||(parseInt(a(f[g][n]).attr(\"colspan\"),10)||1)>1)&&(i=K(f[g][n],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n));for(h=m;h<=n;h++)((parseInt(a(f[k][h]).attr(\"rowspan\"),10)||1)>1||(parseInt(a(f[k][h]).attr(\"colspan\"),10)||1)>1)&&(i=K(f[k][h],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n)),((parseInt(a(f[l][h]).attr(\"rowspan\"),10)||1)>1||(parseInt(a(f[l][h]).attr(\"colspan\"),10)||1)>1)&&(i=K(f[l][h],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n));return k==b&&l==c&&m==d&&n==e?{min_i:b,max_i:c,min_j:d,max_j:e}:Q(k,l,m,n,f)}function R(b){var c=P(b),d=a(b[c.min_i][c.min_j]),e=a(b[c.min_i][c.max_j]),f=a(b[c.max_i][c.min_j]);return{left:d.offset().left,right:e.offset().left+e.outerWidth(),top:d.offset().top,bottom:f.offset().top+f.outerHeight()}}function S(c,d){if(a(c).is(d))N(),b.edit.on(),a(c).addClass(\"fr-selected-cell\");else{O(),b.edit.off();var e=J(),f=K(c,e),g=K(d,e),h=Q(Math.min(f.row,g.row),Math.max(f.row,g.row),Math.min(f.col,g.col),Math.max(f.col,g.col),e);N(),c.classList.add(\"fr-cell-fixed\"),d.classList.add(\"fr-cell-handler\");for(var i=h.min_i;i<=h.max_i;i++)for(var j=h.min_j;j<=h.max_j;j++)a(e[i][j]).addClass(\"fr-selected-cell\")}}function T(c){var d=null,e=a(c.target);return\"TD\"==c.target.tagName||\"TH\"==c.target.tagName?d=c.target:e.closest(\"td\").length>0?d=e.closest(\"td\").get(0):e.closest(\"th\").length>0&&(d=e.closest(\"th\").get(0)),0===b.$el.find(d).length?null:d}function U(){N(),b.popups.hide(\"table.edit\")}function V(c){var d=T(c);if(ta().length>0&&!d&&U(),!b.edit.isDisabled()||b.popups.isVisible(\"table.edit\"))if(1!=c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)(3==c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)&&d&&U();else if(Ba=!0,d){ta().length>0&&!c.shiftKey&&U(),c.stopPropagation(),b.events.trigger(\"image.hideResizer\"),b.events.trigger(\"video.hideResizer\"),Aa=!0;var e=d.tagName.toLowerCase();c.shiftKey&&b.$el.find(e+\".fr-selected-cell\").length>0?a(b.$el.find(e+\".fr-selected-cell\").closest(\"table\")).is(a(d).closest(\"table\"))?S(Ca,d):O():((b.keys.ctrlKey(c)||c.shiftKey)&&(ta().length>1||0===a(d).find(b.selection.element()).length&&!a(d).is(b.selection.element()))&&O(),Ca=d,S(Ca,Ca))}}function W(c){if(Aa||b.$tb.is(c.target)||b.$tb.is(a(c.target).closest(b.$tb.get(0)))||(ta().length>0&&b.toolbar.enable(),N()),!(1!=c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)){if(Ba=!1,Aa){Aa=!1;T(c)||1!=ta().length?ta().length>0&&(b.selection.isCollapsed()?d():N()):N()}if(Ea){Ea=!1,ya.removeClass(\"fr-moving\"),b.$el.removeClass(\"fr-no-selection\"),b.edit.on();var e=parseFloat(ya.css(\"left\"))+b.opts.tableResizerOffset;b.opts.iframe&&(e-=b.$iframe.offset().left),ya.data(\"release-position\",e),ya.removeData(\"max-left\"),ya.removeData(\"max-right\"),ka(c),ca()}}}function X(c){if(!0===Aa){if(a(c.currentTarget).closest(\"table\").is(ua())){if(\"TD\"==c.currentTarget.tagName&&0===b.$el.find(\"th.fr-selected-cell\").length)return void S(Ca,c.currentTarget);if(\"TH\"==c.currentTarget.tagName&&0===b.$el.find(\"td.fr-selected-cell\").length)return void S(Ca,c.currentTarget)}O()}}function Y(c,d){for(var e=c;e&&\"TABLE\"!=e.tagName&&e.parentNode!=b.el;)e=e.parentNode;if(e&&\"TABLE\"==e.tagName){var f=J(a(e));\"up\"==d?$(K(c,f),e,f):\"down\"==d&&_(K(c,f),e,f)}}function Z(a,c,d,e){for(var f,g=c;g!=b.el&&\"TD\"!=g.tagName&&\"TH\"!=g.tagName&&(\"up\"==e?f=g.previousElementSibling:\"down\"==e&&(f=g.nextElementSibling),!f);)g=g.parentNode;\"TD\"==g.tagName||\"TH\"==g.tagName?Y(g,e):f&&(\"up\"==e&&b.selection.setAtEnd(f),\"down\"==e&&b.selection.setAtStart(f))}function $(a,c,d){a.row>0?b.selection.setAtEnd(d[a.row-1][a.col]):Z(a,c,d,\"up\")}function _(a,c,d){var e=parseInt(d[a.row][a.col].getAttribute(\"rowspan\"),10)||1;a.row<d.length-e?b.selection.setAtStart(d[a.row+e][a.col]):Z(a,c,d,\"down\")}function aa(c){var d=c.which,e=b.selection.blocks();if(e.length&&(e=e[0],\"TD\"==e.tagName||\"TH\"==e.tagName)){for(var f=e;f&&\"TABLE\"!=f.tagName&&f.parentNode!=b.el;)f=f.parentNode;if(f&&\"TABLE\"==f.tagName&&(a.FE.KEYCODE.ARROW_LEFT==d||a.FE.KEYCODE.ARROW_UP==d||a.FE.KEYCODE.ARROW_RIGHT==d||a.FE.KEYCODE.ARROW_DOWN==d)&&(ta().length>0&&U(),b.browser.webkit&&(a.FE.KEYCODE.ARROW_UP==d||a.FE.KEYCODE.ARROW_DOWN==d))){var g=b.selection.ranges(0).startContainer;if(g.nodeType==Node.TEXT_NODE&&(a.FE.KEYCODE.ARROW_UP==d&&g.previousSibling||a.FE.KEYCODE.ARROW_DOWN==d&&g.nextSibling))return;c.preventDefault(),c.stopPropagation();var h=J(a(f)),i=K(e,h);return a.FE.KEYCODE.ARROW_UP==d?$(i,f,h):a.FE.KEYCODE.ARROW_DOWN==d&&_(i,f,h),b.selection.restore(),!1}}}function ba(){b.shared.$table_resizer||(b.shared.$table_resizer=a('<div class=\"fr-table-resizer\"><div></div></div>')),ya=b.shared.$table_resizer,b.events.$on(ya,\"mousedown\",function(a){return!b.core.sameInstance(ya)||(ta().length>0&&U(),1==a.which?(b.selection.save(),Ea=!0,ya.addClass(\"fr-moving\"),O(),b.edit.off(),ya.find(\"div\").css(\"opacity\",1),!1):void 0)}),b.events.$on(ya,\"mousemove\",function(a){if(!b.core.sameInstance(ya))return!0;Ea&&(b.opts.iframe&&(a.pageX-=b.$iframe.offset().left),na(a))}),b.events.on(\"shared.destroy\",function(){ya.html(\"\").removeData().remove(),ya=null},!0),b.events.on(\"destroy\",function(){b.$el.find(\".fr-selected-cell\").removeClass(\"fr-selected-cell\"),ya.hide().appendTo(a(\"body:first\"))},!0)}function ca(){ya&&(ya.find(\"div\").css(\"opacity\",0),ya.css(\"top\",0),ya.css(\"left\",0),ya.css(\"height\",0),ya.find(\"div\").css(\"height\",0),ya.hide())}function da(){za&&za.removeClass(\"fr-visible\").css(\"left\",\"-9999px\")}function ea(c,d){var e=a(d),f=e.closest(\"table\"),g=f.parent();if(d&&\"TD\"!=d.tagName&&\"TH\"!=d.tagName&&(e.closest(\"td\").length>0?d=e.closest(\"td\"):e.closest(\"th\").length>0&&(d=e.closest(\"th\"))),!d||\"TD\"!=d.tagName&&\"TH\"!=d.tagName)ya&&e.get(0)!=ya.get(0)&&e.parent().get(0)!=ya.get(0)&&b.core.sameInstance(ya)&&ca();else{if(e=a(d),0===b.$el.find(e).length)return!1;var h=e.offset().left-1,i=h+e.outerWidth();if(Math.abs(c.pageX-h)<=b.opts.tableResizerOffset||Math.abs(i-c.pageX)<=b.opts.tableResizerOffset){var j,k,l,m,n,o=J(f),p=K(d,o),q=L(p.row,p.col,o),r=f.offset().top,s=f.outerHeight()-1;\"rtl\"!=b.opts.direction?c.pageX-h<=b.opts.tableResizerOffset?(l=h,p.col>0?(m=h-la(p.col-1,o)+b.opts.tableResizingLimit,n=h+la(p.col,o)-b.opts.tableResizingLimit,j=p.col-1,k=p.col):(j=null,k=0,m=f.offset().left-1-parseInt(f.css(\"margin-left\"),10),n=f.offset().left-1+f.width()-o[0].length*b.opts.tableResizingLimit)):i-c.pageX<=b.opts.tableResizerOffset&&(l=i,q.col<o[q.row].length&&o[q.row][q.col+1]?(m=i-la(q.col,o)+b.opts.tableResizingLimit,n=i+la(q.col+1,o)-b.opts.tableResizingLimit,j=q.col,k=q.col+1):(j=q.col,k=null,m=f.offset().left-1+o[0].length*b.opts.tableResizingLimit,n=g.offset().left-1+g.width()+parseFloat(g.css(\"padding-left\")))):i-c.pageX<=b.opts.tableResizerOffset?(l=i,p.col>0?(m=i-la(p.col,o)+b.opts.tableResizingLimit,n=i+la(p.col-1,o)-b.opts.tableResizingLimit,j=p.col,k=p.col-1):(j=null,k=0,m=f.offset().left+o[0].length*b.opts.tableResizingLimit,n=g.offset().left-1+g.width()+parseFloat(g.css(\"padding-left\")))):c.pageX-h<=b.opts.tableResizerOffset&&(l=h,q.col<o[q.row].length&&o[q.row][q.col+1]?(m=h-la(q.col+1,o)+b.opts.tableResizingLimit,n=h+la(q.col,o)-b.opts.tableResizingLimit,j=q.col+1,k=q.col):(j=q.col,k=null,m=g.offset().left+parseFloat(g.css(\"padding-left\")),n=f.offset().left-1+f.width()-o[0].length*b.opts.tableResizingLimit)),ya||ba(),ya.data(\"table\",f),ya.data(\"first\",j),ya.data(\"second\",k),ya.data(\"instance\",b),b.$wp.append(ya);var t=l-b.win.pageXOffset-b.opts.tableResizerOffset,u=r-b.win.pageYOffset;b.opts.iframe&&(t+=b.$iframe.offset().left-b.helpers.scrollLeft(),u+=b.$iframe.offset().top-b.helpers.scrollTop(),m+=b.$iframe.offset().left,n+=b.$iframe.offset().left),ya.data(\"max-left\",m),ya.data(\"max-right\",n),ya.data(\"origin\",l-b.win.pageXOffset),ya.css(\"top\",u),ya.css(\"left\",t),ya.css(\"height\",s),ya.find(\"div\").css(\"height\",s),ya.css(\"padding-left\",b.opts.tableResizerOffset),ya.css(\"padding-right\",b.opts.tableResizerOffset),ya.show()}else b.core.sameInstance(ya)&&ca()}}function fa(c,d){if(b.$box.find(\".fr-line-breaker\").is(\":visible\"))return!1;za||qa(),b.$box.append(za),za.data(\"instance\",b);var e=a(d),f=e.find(\"tr:first\"),g=c.pageX,h=0,i=0;b.opts.iframe&&(h+=b.$iframe.offset().left-b.helpers.scrollLeft(),i+=b.$iframe.offset().top-b.helpers.scrollTop());var j;f.find(\"th, td\").each(function(){var c=a(this);return c.offset().left<=g&&g<c.offset().left+c.outerWidth()/2?(j=parseInt(za.find(\"a\").css(\"width\"),10),za.css(\"top\",i+c.offset().top-b.win.pageYOffset-j-5),za.css(\"left\",h+c.offset().left-b.win.pageXOffset-j/2),za.data(\"selected-cell\",c),za.data(\"position\",\"before\"),za.addClass(\"fr-visible\"),!1):c.offset().left+c.outerWidth()/2<=g&&g<c.offset().left+c.outerWidth()?(j=parseInt(za.find(\"a\").css(\"width\"),10),za.css(\"top\",i+c.offset().top-b.win.pageYOffset-j-5),za.css(\"left\",h+c.offset().left+c.outerWidth()-b.win.pageXOffset-j/2),za.data(\"selected-cell\",c),za.data(\"position\",\"after\"),za.addClass(\"fr-visible\"),!1):void 0})}function ga(c,d){if(b.$box.find(\".fr-line-breaker\").is(\":visible\"))return!1;za||qa(),b.$box.append(za),za.data(\"instance\",b);var e=a(d),f=c.pageY,g=0,h=0;b.opts.iframe&&(g+=b.$iframe.offset().left-b.helpers.scrollLeft(),h+=b.$iframe.offset().top-b.helpers.scrollTop());var i;e.find(\"tr\").each(function(){var c=a(this);return c.offset().top<=f&&f<c.offset().top+c.outerHeight()/2?(i=parseInt(za.find(\"a\").css(\"width\"),10),za.css(\"top\",h+c.offset().top-b.win.pageYOffset-i/2),za.css(\"left\",g+c.offset().left-b.win.pageXOffset-i-5),za.data(\"selected-cell\",c.find(\"td:first\")),za.data(\"position\",\"above\"),za.addClass(\"fr-visible\"),!1):c.offset().top+c.outerHeight()/2<=f&&f<c.offset().top+c.outerHeight()?(i=parseInt(za.find(\"a\").css(\"width\"),10),za.css(\"top\",h+c.offset().top+c.outerHeight()-b.win.pageYOffset-i/2),za.css(\"left\",g+c.offset().left-b.win.pageXOffset-i-5),za.data(\"selected-cell\",c.find(\"td:first\")),za.data(\"position\",\"below\"),za.addClass(\"fr-visible\"),!1):void 0})}function ha(c,d){if(0===ta().length){var e,f,g;if(d&&(\"HTML\"==d.tagName||\"BODY\"==d.tagName||b.node.isElement(d)))for(e=1;e<=b.opts.tableInsertHelperOffset;e++){if(f=b.doc.elementFromPoint(c.pageX-b.win.pageXOffset,c.pageY-b.win.pageYOffset+e),a(f).hasClass(\"fr-tooltip\"))return!0;if(f&&(\"TH\"==f.tagName||\"TD\"==f.tagName||\"TABLE\"==f.tagName)&&(a(f).parents(\".fr-wrapper\").length||b.opts.iframe))return fa(c,a(f).closest(\"table\")),!0;if(g=b.doc.elementFromPoint(c.pageX-b.win.pageXOffset+e,c.pageY-b.win.pageYOffset),a(g).hasClass(\"fr-tooltip\"))return!0;if(g&&(\"TH\"==g.tagName||\"TD\"==g.tagName||\"TABLE\"==g.tagName)&&(a(g).parents(\".fr-wrapper\").length||b.opts.iframe))return ga(c,a(g).closest(\"table\")),!0}b.core.sameInstance(za)&&da()}}function ia(a){Da=null;var c=b.doc.elementFromPoint(a.pageX-b.win.pageXOffset,a.pageY-b.win.pageYOffset);b.opts.tableResizer&&(!b.popups.areVisible()||b.popups.areVisible()&&b.popups.isVisible(\"table.edit\"))&&ea(a,c),!b.opts.tableInsertHelper||b.popups.areVisible()||b.$tb.hasClass(\"fr-inline\")&&b.$tb.is(\":visible\")||ha(a,c)}function ja(){if(Ea){var a=ya.data(\"table\"),c=a.offset().top-b.win.pageYOffset;b.opts.iframe&&(c+=b.$iframe.offset().top-b.helpers.scrollTop()),ya.css(\"top\",c)}}function ka(){var c=ya.data(\"origin\"),d=ya.data(\"release-position\");if(c!==d){var e=ya.data(\"first\"),f=ya.data(\"second\"),g=ya.data(\"table\"),h=g.outerWidth();if(b.undo.canDo()||b.undo.saveStep(),null!==e&&null!==f){var i,j,k,l=J(g),m=[],n=[],o=[],p=[];for(i=0;i<l.length;i++)j=a(l[i][e]),k=a(l[i][f]),m[i]=j.outerWidth(),o[i]=k.outerWidth(),n[i]=m[i]/h*100,p[i]=o[i]/h*100;for(i=0;i<l.length;i++){j=a(l[i][e]),k=a(l[i][f]);var q=(n[i]*(m[i]+d-c)/m[i]).toFixed(4);j.css(\"width\",q+\"%\"),k.css(\"width\",(n[i]+p[i]-q).toFixed(4)+\"%\")}}else{var r,s=g.parent(),t=h/s.width()*100,u=(parseInt(g.css(\"margin-left\"),10)||0)/s.width()*100,v=(parseInt(g.css(\"margin-right\"),10)||0)/s.width()*100;\"rtl\"==b.opts.direction&&0===f||\"rtl\"!=b.opts.direction&&0!==f?(r=(h+d-c)/h*t,g.css(\"margin-right\",\"calc(100% - \"+Math.round(r).toFixed(4)+\"% - \"+Math.round(u).toFixed(4)+\"%)\")):(\"rtl\"==b.opts.direction&&0!==f||\"rtl\"!=b.opts.direction&&0===f)&&(r=(h-d+c)/h*t,g.css(\"margin-left\",\"calc(100% - \"+Math.round(r).toFixed(4)+\"% - \"+Math.round(v).toFixed(4)+\"%)\")),g.css(\"width\",Math.round(r).toFixed(4)+\"%\")}b.selection.restore(),b.undo.saveStep()}ya.removeData(\"origin\"),ya.removeData(\"release-position\"),ya.removeData(\"first\"),ya.removeData(\"second\"),ya.removeData(\"table\")}function la(b,c){var d,e=a(c[0][b]).outerWidth();for(d=1;d<c.length;d++)e=Math.min(e,a(c[d][b]).outerWidth());return e}function ma(a,b,c){var d,e=0;for(d=a;d<=b;d++)e+=la(d,c);return e}function na(a){if(ta().length>1&&Ba&&O(),!1===Ba&&!1===Aa&&!1===Ea)Da&&clearTimeout(Da),b.edit.isDisabled()&&!b.popups.isVisible(\"table.edit\")||(Da=setTimeout(ia,30,a));else if(Ea){\nvar c=a.pageX-b.win.pageXOffset;b.opts.iframe&&(c+=b.$iframe.offset().left);var d=ya.data(\"max-left\"),e=ya.data(\"max-right\");c>=d&&c<=e?ya.css(\"left\",c-b.opts.tableResizerOffset):c<d&&parseFloat(ya.css(\"left\"),10)>d-b.opts.tableResizerOffset?ya.css(\"left\",d-b.opts.tableResizerOffset):c>e&&parseFloat(ya.css(\"left\"),10)<e-b.opts.tableResizerOffset&&ya.css(\"left\",e-b.opts.tableResizerOffset)}else Ba&&da()}function oa(c){b.node.isEmpty(c.get(0))?c.prepend(a.FE.MARKERS):c.prepend(a.FE.START_MARKER).append(a.FE.END_MARKER)}function pa(c){if(c.which==a.FE.KEYCODE.TAB){var d;if(ta().length>0)d=b.$el.find(\".fr-selected-cell:last\");else{var e=b.selection.element();\"TD\"==e.tagName||\"TH\"==e.tagName?d=a(e):e!=b.el&&(a(e).parentsUntil(b.$el,\"td\").length>0?d=a(e).parents(\"td:first\"):a(e).parentsUntil(b.$el,\"th\").length>0&&(d=a(e).parents(\"th:first\")))}if(d)return c.preventDefault(),a(b.selection.element()).parents(\"ol, ul\").length>0||(U(),c.shiftKey?d.prev().length>0?oa(d.prev()):d.closest(\"tr\").length>0&&d.closest(\"tr\").prev().length>0?oa(d.closest(\"tr\").prev().find(\"td:last\")):d.closest(\"tbody\").length>0&&d.closest(\"table\").find(\"thead tr\").length>0&&oa(d.closest(\"table\").find(\"thead tr th:last\")):d.next().length>0?oa(d.next()):d.closest(\"tr\").length>0&&d.closest(\"tr\").next().length>0?oa(d.closest(\"tr\").next().find(\"td:first\")):d.closest(\"thead\").length>0&&d.closest(\"table\").find(\"tbody tr\").length>0?oa(d.closest(\"table\").find(\"tbody tr td:first\")):(d.addClass(\"fr-selected-cell\"),u(\"below\"),N(),oa(d.closest(\"tr\").next().find(\"td:first\"))),b.selection.restore(),!1)}}function qa(){b.shared.$ti_helper||(b.shared.$ti_helper=a('<div class=\"fr-insert-helper\"><a class=\"fr-floating-btn\" role=\"button\" tabIndex=\"-1\" title=\"'+b.language.translate(\"Insert\")+'\"><svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z\"/></svg></a></div>'),b.events.bindClick(b.shared.$ti_helper,\"a\",function(){var a=za.data(\"selected-cell\"),c=za.data(\"position\"),d=za.data(\"instance\")||b;\"before\"==c?(b.undo.saveStep(),a.addClass(\"fr-selected-cell\"),d.table.insertColumn(c),a.removeClass(\"fr-selected-cell\"),b.undo.saveStep()):\"after\"==c?(b.undo.saveStep(),a.addClass(\"fr-selected-cell\"),d.table.insertColumn(c),a.removeClass(\"fr-selected-cell\"),b.undo.saveStep()):\"above\"==c?(b.undo.saveStep(),a.addClass(\"fr-selected-cell\"),d.table.insertRow(c),a.removeClass(\"fr-selected-cell\"),b.undo.saveStep()):\"below\"==c&&(b.undo.saveStep(),a.addClass(\"fr-selected-cell\"),d.table.insertRow(c),a.removeClass(\"fr-selected-cell\"),b.undo.saveStep()),da()}),b.events.on(\"shared.destroy\",function(){b.shared.$ti_helper.html(\"\").removeData().remove(),b.shared.$ti_helper=null},!0),b.events.$on(b.shared.$ti_helper,\"mousemove\",function(a){a.stopPropagation()},!0),b.events.$on(a(b.o_win),\"scroll\",function(){da()},!0),b.events.$on(b.$wp,\"scroll\",function(){da()},!0)),za=b.shared.$ti_helper,b.events.on(\"destroy\",function(){za=null}),b.tooltip.bind(b.$box,\".fr-insert-helper > a.fr-floating-btn\")}function ra(){Ca=null,clearTimeout(Da)}function sa(){ta().length>0?d():(b.popups.hide(\"table.insert\"),b.toolbar.showInline())}function ta(){return b.el.querySelectorAll(\".fr-selected-cell\")}function ua(){var c=ta();if(c.length){for(var d=c[0];d&&\"TABLE\"!=d.tagName&&d.parentNode!=b.el;)d=d.parentNode;return a(d&&\"TABLE\"==d.tagName?d:[])}return a([])}function va(c){if(c.altKey&&c.which==a.FE.KEYCODE.SPACE){var e,f=b.selection.element();if(\"TD\"==f.tagName||\"TH\"==f.tagName?e=f:a(f).closest(\"td\").length>0?e=a(f).closest(\"td\").get(0):a(f).closest(\"th\").length>0&&(e=a(f).closest(\"th\").get(0)),e)return c.preventDefault(),S(e,e),d(),!1}}function wa(c){var d=ta();if(d.length>0){var e,f,g=J(),h=c.which;1==d.length?(e=d[0],f=e):(e=b.el.querySelector(\".fr-cell-fixed\"),f=b.el.querySelector(\".fr-cell-handler\"));var i=K(f,g);if(a.FE.KEYCODE.ARROW_RIGHT==h){if(i.col<g[0].length-1)return S(e,g[i.row][i.col+1]),!1}else if(a.FE.KEYCODE.ARROW_DOWN==h){if(i.row<g.length-1)return S(e,g[i.row+1][i.col]),!1}else if(a.FE.KEYCODE.ARROW_LEFT==h){if(i.col>0)return S(e,g[i.row][i.col-1]),!1}else if(a.FE.KEYCODE.ARROW_UP==h&&i.row>0)return S(e,g[i.row-1][i.col]),!1}}function xa(){if(!b.$wp)return!1;if(!b.helpers.isMobile()){Ba=!1,Aa=!1,Ea=!1,b.events.$on(b.$el,\"mousedown\",V),b.popups.onShow(\"image.edit\",function(){N(),Ba=!1,Aa=!1}),b.popups.onShow(\"link.edit\",function(){N(),Ba=!1,Aa=!1}),b.events.on(\"commands.mousedown\",function(a){a.parents(\".fr-toolbar\").length>0&&N()}),b.events.$on(b.$el,\"mouseenter\",\"th, td\",X),b.events.$on(b.$win,\"mouseup\",W),b.opts.iframe&&b.events.$on(a(b.o_win),\"mouseup\",W),b.events.$on(b.$win,\"mousemove\",na),b.events.$on(a(b.o_win),\"scroll\",ja),b.events.on(\"contentChanged\",function(){ta().length>0&&(d(),b.$el.find(\"img\").on(\"load.selected-cells\",function(){a(this).off(\"load.selected-cells\"),ta().length>0&&d()}))}),b.events.$on(a(b.o_win),\"resize\",function(){N()}),b.events.on(\"toolbar.esc\",function(){if(ta().length>0)return b.events.disableBlur(),b.events.focus(),!1},!0),b.events.$on(a(b.o_win),\"keydown\",function(){Ba&&Aa&&(Ba=!1,Aa=!1,b.$el.removeClass(\"fr-no-selection\"),b.edit.on(),b.selection.setAtEnd(b.$el.find(\".fr-selected-cell:last\").get(0)),b.selection.restore(),N())}),b.events.$on(b.$el,\"keydown\",function(a){a.shiftKey?!1===wa(a)&&setTimeout(function(){d()},0):aa(a)}),b.events.on(\"keydown\",function(c){if(!1===pa(c))return!1;var d=ta();if(d.length>0){if(d.length>0&&b.keys.ctrlKey(c)&&c.which==a.FE.KEYCODE.A)return N(),b.popups.isVisible(\"table.edit\")&&b.popups.hide(\"table.edit\"),d=[],!0;if(c.which==a.FE.KEYCODE.ESC&&b.popups.isVisible(\"table.edit\"))return N(),b.popups.hide(\"table.edit\"),c.preventDefault(),c.stopPropagation(),c.stopImmediatePropagation(),d=[],!1;if(d.length>1&&(c.which==a.FE.KEYCODE.BACKSPACE||c.which==a.FE.KEYCODE.DELETE)){b.undo.saveStep();for(var e=0;e<d.length;e++)a(d[e]).html(\"<br>\"),e==d.length-1&&a(d[e]).prepend(a.FE.MARKERS);return b.selection.restore(),b.undo.saveStep(),d=[],!1}if(d.length>1&&c.which!=a.FE.KEYCODE.F10&&!b.keys.isBrowserAction(c))return c.preventDefault(),d=[],!1}else if(d=[],!1===va(c))return!1},!0);var c=[];b.events.on(\"html.beforeGet\",function(){c=ta();for(var a=0;a<c.length;a++)c[a].className=(c[a].className||\"\").replace(/fr-selected-cell/g,\"\")}),b.events.on(\"html.afterGet\",function(){for(var a=0;a<c.length;a++)c[a].className=(c[a].className?c[a].className.trim()+\" \":\"\")+\"fr-selected-cell\";c=[]}),g(!0),k(!0)}b.events.on(\"destroy\",ra)}var ya,za,Aa,Ba,Ca,Da,Ea;return{_init:xa,insert:q,remove:r,insertRow:u,deleteRow:v,insertColumn:w,deleteColumn:x,mergeCells:C,splitCellVertically:E,splitCellHorizontally:D,addHeader:s,removeHeader:t,setBackground:F,showInsertPopup:c,showEditPopup:d,showColorsPopup:e,back:sa,verticalAlign:G,horizontalAlign:H,applyStyle:I,selectedTable:ua,selectedCells:ta,customColor:n}},a.FE.DefineIcon(\"insertTable\",{NAME:\"table\"}),a.FE.RegisterCommand(\"insertTable\",{title:\"Insert Table\",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible(\"table.insert\")?(this.$el.find(\".fr-marker\").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide(\"table.insert\")):this.table.showInsertPopup()},plugin:\"table\"}),a.FE.RegisterCommand(\"tableInsert\",{callback:function(a,b,c){this.table.insert(b,c),this.popups.hide(\"table.insert\")}}),a.FE.DefineIcon(\"tableHeader\",{NAME:\"header\"}),a.FE.RegisterCommand(\"tableHeader\",{title:\"Table Header\",focus:!1,toggle:!0,callback:function(){this.popups.get(\"table.edit\").find('.fr-command[data-cmd=\"tableHeader\"]').hasClass(\"fr-active\")?this.table.removeHeader():this.table.addHeader()},refresh:function(a){var b=this.table.selectedTable();b.length>0&&(0===b.find(\"th\").length?a.removeClass(\"fr-active\").attr(\"aria-pressed\",!1):a.addClass(\"fr-active\").attr(\"aria-pressed\",!0))}}),a.FE.DefineIcon(\"tableRows\",{NAME:\"bars\"}),a.FE.RegisterCommand(\"tableRows\",{type:\"dropdown\",focus:!1,title:\"Row\",options:{above:\"Insert row above\",below:\"Insert row below\",delete:\"Delete row\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.tableRows.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableRows\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.language.translate(c[d])+\"</a></li>\");return b+=\"</ul>\"},callback:function(a,b){\"above\"==b||\"below\"==b?this.table.insertRow(b):this.table.deleteRow()}}),a.FE.DefineIcon(\"tableColumns\",{NAME:\"bars fa-rotate-90\"}),a.FE.RegisterCommand(\"tableColumns\",{type:\"dropdown\",focus:!1,title:\"Column\",options:{before:\"Insert column before\",after:\"Insert column after\",delete:\"Delete column\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.tableColumns.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableColumns\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.language.translate(c[d])+\"</a></li>\");return b+=\"</ul>\"},callback:function(a,b){\"before\"==b||\"after\"==b?this.table.insertColumn(b):this.table.deleteColumn()}}),a.FE.DefineIcon(\"tableCells\",{NAME:\"square-o\"}),a.FE.RegisterCommand(\"tableCells\",{type:\"dropdown\",focus:!1,title:\"Cell\",options:{merge:\"Merge cells\",\"vertical-split\":\"Vertical split\",\"horizontal-split\":\"Horizontal split\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.tableCells.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableCells\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.language.translate(c[d])+\"</a></li>\");return b+=\"</ul>\"},callback:function(a,b){\"merge\"==b?this.table.mergeCells():\"vertical-split\"==b?this.table.splitCellVertically():this.table.splitCellHorizontally()},refreshOnShow:function(a,b){this.$el.find(\".fr-selected-cell\").length>1?(b.find('a[data-param1=\"vertical-split\"]').addClass(\"fr-disabled\").attr(\"aria-disabled\",!0),b.find('a[data-param1=\"horizontal-split\"]').addClass(\"fr-disabled\").attr(\"aria-disabled\",!0),b.find('a[data-param1=\"merge\"]').removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1)):(b.find('a[data-param1=\"merge\"]').addClass(\"fr-disabled\").attr(\"aria-disabled\",!0),b.find('a[data-param1=\"vertical-split\"]').removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1),b.find('a[data-param1=\"horizontal-split\"]').removeClass(\"fr-disabled\").attr(\"aria-disabled\",!1))}}),a.FE.DefineIcon(\"tableRemove\",{NAME:\"trash\"}),a.FE.RegisterCommand(\"tableRemove\",{title:\"Remove Table\",focus:!1,callback:function(){this.table.remove()}}),a.FE.DefineIcon(\"tableStyle\",{NAME:\"paint-brush\"}),a.FE.RegisterCommand(\"tableStyle\",{title:\"Table Style\",type:\"dropdown\",focus:!1,html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.tableStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableStyle\" data-param1=\"'+c+'\" title=\"'+this.language.translate(b[c])+'\">'+this.language.translate(b[c])+\"</a></li>\");return a+=\"</ul>\"},callback:function(a,b){this.table.applyStyle(b,this.$el.find(\".fr-selected-cell\").closest(\"table\"),this.opts.tableMultipleStyles,this.opts.tableStyles)},refreshOnShow:function(b,c){var d=this.$el.find(\".fr-selected-cell\").closest(\"table\");d&&c.find(\".fr-command\").each(function(){var b=a(this).data(\"param1\"),c=d.hasClass(b);a(this).toggleClass(\"fr-active\",c).attr(\"aria-selected\",c)})}}),a.FE.DefineIcon(\"tableCellBackground\",{NAME:\"tint\"}),a.FE.RegisterCommand(\"tableCellBackground\",{title:\"Cell Background\",focus:!1,popup:!0,callback:function(){this.table.showColorsPopup()}}),a.FE.RegisterCommand(\"tableCellBackgroundColor\",{undo:!0,focus:!1,callback:function(a,b){this.table.setBackground(b)}}),a.FE.DefineIcon(\"tableBack\",{NAME:\"arrow-left\"}),a.FE.RegisterCommand(\"tableBack\",{title:\"Back\",undo:!1,focus:!1,back:!0,callback:function(){this.table.back()},refresh:function(a){0!==this.table.selectedCells().length||this.opts.toolbarInline?(a.removeClass(\"fr-hidden\"),a.next(\".fr-separator\").removeClass(\"fr-hidden\")):(a.addClass(\"fr-hidden\"),a.next(\".fr-separator\").addClass(\"fr-hidden\"))}}),a.FE.DefineIcon(\"tableCellVerticalAlign\",{NAME:\"arrows-v\"}),a.FE.RegisterCommand(\"tableCellVerticalAlign\",{type:\"dropdown\",focus:!1,title:\"Vertical Align\",options:{Top:\"Align Top\",Middle:\"Align Middle\",Bottom:\"Align Bottom\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.tableCellVerticalAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableCellVerticalAlign\" data-param1=\"'+d.toLowerCase()+'\" title=\"'+this.language.translate(c[d])+'\">'+this.language.translate(d)+\"</a></li>\");return b+=\"</ul>\"},callback:function(a,b){this.table.verticalAlign(b)},refreshOnShow:function(a,b){b.find('.fr-command[data-param1=\"'+this.$el.find(\".fr-selected-cell\").css(\"vertical-align\")+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}}),a.FE.DefineIcon(\"tableCellHorizontalAlign\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"align-left\",{NAME:\"align-left\"}),a.FE.DefineIcon(\"align-right\",{NAME:\"align-right\"}),a.FE.DefineIcon(\"align-center\",{NAME:\"align-center\"}),a.FE.DefineIcon(\"align-justify\",{NAME:\"align-justify\"}),a.FE.RegisterCommand(\"tableCellHorizontalAlign\",{type:\"dropdown\",focus:!1,title:\"Horizontal Align\",options:{left:\"Align Left\",center:\"Align Center\",right:\"Align Right\",justify:\"Align Justify\"},html:function(){var b='<ul class=\"fr-dropdown-list\" role=\"presentation\">',c=a.FE.COMMANDS.tableCellHorizontalAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role=\"presentation\"><a class=\"fr-command fr-title\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableCellHorizontalAlign\" data-param1=\"'+d+'\" title=\"'+this.language.translate(c[d])+'\">'+this.icon.create(\"align-\"+d)+'<span class=\"fr-sr-only\">'+this.language.translate(c[d])+\"</span></a></li>\");return b+=\"</ul>\"},callback:function(a,b){this.table.horizontalAlign(b)},refresh:function(b){var c=this.table.selectedCells();c.length&&b.find(\"> *:first\").replaceWith(this.icon.create(\"align-\"+this.helpers.getAlignment(a(c[0]))))},refreshOnShow:function(a,b){b.find('.fr-command[data-param1=\"'+this.helpers.getAlignment(this.$el.find(\".fr-selected-cell:first\"))+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}}),a.FE.DefineIcon(\"tableCellStyle\",{NAME:\"magic\"}),a.FE.RegisterCommand(\"tableCellStyle\",{title:\"Cell Style\",type:\"dropdown\",focus:!1,html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.tableCellStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"tableCellStyle\" data-param1=\"'+c+'\" title=\"'+this.language.translate(b[c])+'\">'+this.language.translate(b[c])+\"</a></li>\");return a+=\"</ul>\"},callback:function(a,b){this.table.applyStyle(b,this.$el.find(\".fr-selected-cell\"),this.opts.tableCellMultipleStyles,this.opts.tableCellStyles)},refreshOnShow:function(b,c){var d=this.$el.find(\".fr-selected-cell:first\");d&&c.find(\".fr-command\").each(function(){var b=a(this).data(\"param1\"),c=d.hasClass(b);a(this).toggleClass(\"fr-active\",c).attr(\"aria-selected\",c)})}}),a.FE.RegisterCommand(\"tableCellBackgroundCustomColor\",{title:\"OK\",undo:!0,callback:function(){this.table.customColor()}}),a.FE.DefineIcon(\"tableColorRemove\",{NAME:\"eraser\"})});"

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1494))

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.FE.URLRegEx=\"(^| |\\\\u00A0)(\"+a.FE.LinkRegEx+\"|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\\\.[a-z0-9+-_]{1,}))$\",a.FE.PLUGINS.url=function(b){function c(a,c,d){for(var e=\"\";d.length&&\".\"==d[d.length-1];)e+=\".\",d=d.substring(0,d.length-1);var f=d;if(b.opts.linkConvertEmailAddress)b.helpers.isEmail(f)&&!/^mailto:.*/i.test(f)&&(f=\"mailto:\"+f);else if(b.helpers.isEmail(f))return c+d;return/^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\\:)/i.test(f)||(f=\"//\"+f),(c||\"\")+\"<a\"+(b.opts.linkAlwaysBlank?' target=\"_blank\"':\"\")+(j?' rel=\"'+j+'\"':\"\")+' href=\"'+f+'\">'+d.replace(/</g,\"&lt;\").replace(/>/g,\"&gt;\")+\"</a>\"+e}function d(){return new RegExp(a.FE.URLRegEx,\"gi\")}function e(a){return b.opts.linkAlwaysNoFollow&&(j=\"nofollow\"),b.opts.linkAlwaysBlank&&(j?j+=\" noopener noreferrer\":j=\"noopener noreferrer\"),a.replace(d(),c)}function f(a){return!!a&&(\"A\"===a.tagName||!(!a.parentNode||a.parentNode==b.el)&&f(a.parentNode))}function g(a){var b=a.split(\" \");return b[b.length-1]}function h(){var c=b.selection.ranges(0),h=c.startContainer;if(!h||h.nodeType!==Node.TEXT_NODE)return!1;if(f(h))return!1;if(d().test(g(h.textContent)))a(h).before(e(h.textContent)),h.parentNode.removeChild(h);else if(h.previousSibling&&\"A\"===h.previousSibling.tagName){var i=h.previousSibling.innerText+h.textContent;d().test(g(i))&&(a(h.previousSibling).replaceWith(e(i)),h.parentNode.removeChild(h))}}function i(){b.events.on(\"keydown\",function(c){var d=c.which;!b.selection.isCollapsed()||d!=a.FE.KEYCODE.ENTER&&d!=a.FE.KEYCODE.SPACE&&d!=a.FE.KEYCODE.PERIOD||h()},!0)}var j=null;return{_init:i}}});"

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1496))

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{wordDeniedTags:[],wordDeniedAttrs:[],wordAllowedStyleProps:[\"font-family\",\"font-size\",\"background\",\"color\",\"width\",\"text-align\",\"vertical-align\",\"background-color\",\"padding\",\"margin\",\"height\",\"margin-top\",\"margin-left\",\"margin-right\",\"margin-bottom\",\"text-decoration\",\"font-weight\",\"font-style\"],wordPasteModal:!0}),a.FE.PLUGINS.wordPaste=function(b){function c(){b.events.on(\"paste.wordPaste\",function(a){return C=a,b.opts.wordPasteModal?e():g(!0),!1})}function d(){var a='<div class=\"fr-word-paste-modal\" style=\"padding: 20px 20px 10px 20px;\">';return a+='<p style=\"text-align: left;\">'+b.language.translate(\"The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?\")+\"</p>\",a+='<div style=\"text-align: right; margin-top: 50px;\"><button class=\"fr-remove-word fr-command\">'+b.language.translate(\"Clean\")+'</button> <button class=\"fr-keep-word fr-command\">'+b.language.translate(\"Keep\")+\"</button></div>\",a+=\"</div>\"}function e(){if(!B){var c='<h4><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 74.95 73.23\" style=\"height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block\"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class=\"a\" d=\"M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z\" transform=\"translate(-575.97 -827.22)\"/><path class=\"b\" d=\"M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z\" transform=\"translate(-575.97 -827.22)\"/></svg> '+b.language.translate(\"Word Paste Detected\")+\"</h4>\",e=d(),f=b.modals.create(D,c,e),g=f.$body;B=f.$modal,f.$modal.addClass(\"fr-middle\"),b.events.bindClick(g,\"button.fr-remove-word\",function(){(B.data(\"instance\")||b).wordPaste.clean()}),b.events.bindClick(g,\"button.fr-keep-word\",function(){(B.data(\"instance\")||b).wordPaste.clean(!0)}),b.events.$on(a(b.o_win),\"resize\",function(){b.modals.resize(D)})}b.modals.show(D),b.modals.resize(D)}function f(){b.modals.hide(D)}function g(a){var c=b.opts.wordAllowedStyleProps;a||(b.opts.wordAllowedStyleProps=[]),0===C.indexOf(\"<colgroup>\")&&(C=\"<table>\"+C+\"</table>\"),C=A(C,b.paste.getRtfClipboard());var d=b.doc.createElement(\"DIV\");d.innerHTML=C,b.html.cleanBlankSpaces(d),C=d.innerHTML,C=b.paste.removeEmptyTags(C),C=C.replace(/\\u200b/g,\"\"),f(),b.paste.clean(C,!0,!0),b.opts.wordAllowedStyleProps=c}function h(a){a.parentNode&&a.parentNode.removeChild(a)}function i(a,b){if(b(a))for(var c=a.firstChild;c;){var d=c,e=c.previousSibling;c=c.nextSibling,i(d,b),d.previousSibling||d.nextSibling||d.parentNode||!c||e==c.previousSibling||!c.parentNode?d.previousSibling||d.nextSibling||d.parentNode||!c||c.previousSibling||c.nextSibling||c.parentNode||(e?c=e.nextSibling?e.nextSibling.nextSibling:null:a.firstChild&&(c=a.firstChild.nextSibling)):c=e?e.nextSibling:a.firstChild}}function j(a){if(!a.getAttribute(\"style\")||!/mso-list:[\\s]*l/gi.test(a.getAttribute(\"style\").replace(/\\n/gi,\"\")))return!1;try{if(!a.querySelector('[style=\"mso-list:Ignore\"]'))return!1}catch(b){return!1}return!0}function k(a){return a.getAttribute(\"style\").replace(/\\n/gi,\"\").replace(/.*level([0-9]+?).*/gi,\"$1\")}function l(a,b){var c=a.cloneNode(!0);if(c.firstElementChild&&\"A\"==c.firstElementChild.tagName&&(c=c.firstElementChild),-1!=[\"H1\",\"H2\",\"H3\",\"H4\",\"H5\",\"H6\"].indexOf(a.tagName)){var d=document.createElement(a.tagName.toLowerCase());d.setAttribute(\"style\",a.getAttribute(\"style\")),d.innerHTML=c.innerHTML,c.innerHTML=d.outerHTML}i(c,function(a){return a.nodeType==Node.ELEMENT_NODE&&(\"mso-list:Ignore\"==a.getAttribute(\"style\")&&a.parentNode.removeChild(a),x(a,b)),!0});var e=c.innerHTML;return e=e.replace(/<!--[\\s\\S]*?-->/gi,\"\")}function m(a,b){var c=/[0-9a-zA-Z]./gi,d=!1;a.firstElementChild&&a.firstElementChild.firstElementChild&&a.firstElementChild.firstElementChild.firstChild&&!(d=d||c.test(a.firstElementChild.firstElementChild.firstChild.data||\"\"))&&a.firstElementChild.firstElementChild.firstElementChild&&a.firstElementChild.firstElementChild.firstElementChild.firstChild&&(d=d||c.test(a.firstElementChild.firstElementChild.firstElementChild.firstChild.data||\"\"));var e=d?\"ol\":\"ul\",f=k(a),g=\"<\"+e+\"><li>\"+l(a,b),i=a.nextElementSibling,n=a.parentNode;for(h(a),a=null;i&&j(i);){var o=i.previousElementSibling,p=k(i);if(p>f)g+=m(i,b).outerHTML;else{if(p<f)break;g+=\"</li><li>\"+l(i,b)}if(f=p,i.previousElementSibling||i.nextElementSibling||i.parentNode){var q=i;i=i.nextElementSibling,h(q),q=null}else i=o?o.nextElementSibling:n.firstElementChild}g+=\"</li></\"+e+\">\";var r=document.createElement(\"div\");return r.innerHTML=g,r.firstElementChild}function n(a,b){for(var c=document.createElement(b),d=0;d<a.attributes.length;d++){var e=a.attributes[d].name;c.setAttribute(e,a.getAttribute(e))}return c.innerHTML=a.innerHTML,a.parentNode.replaceChild(c,a),c}function o(c,d){b.node.clearAttributes(c);for(var e=c.firstElementChild,f=0,g=!1,i=null;e;){e.firstElementChild&&-1!=e.firstElementChild.tagName.indexOf(\"W:\")&&(e.innerHTML=e.firstElementChild.innerHTML),i=e.getAttribute(\"width\"),i||g||(g=!0),f+=parseInt(i,10),(!e.firstChild||e.firstChild&&e.firstChild.data==a.FE.UNICODE_NBSP)&&(e.firstChild&&h(e.firstChild),e.innerHTML=\"<br>\");for(var k=e.firstElementChild,l=1==e.children.length;k;)\"P\"!=k.tagName||j(k)||l&&p(k),k=k.nextElementSibling;if(d){var m=e.getAttribute(\"class\");if(m){m=q(m);var n=m.match(/xl[0-9]+/gi);if(n){var o=n[0],s=\".\"+o;d[s]&&r(e,d[s])}}d.td&&r(e,d.td)}var t=e.getAttribute(\"style\");t&&(t=q(t))&&\";\"!=t.slice(-1)&&(t+=\";\");var u=e.getAttribute(\"valign\");if(!u&&t){var v=t.match(/vertical-align:.+?[; \"]{1,1}/gi);v&&(u=v[v.length-1].replace(/vertical-align:(.+?)[; \"]{1,1}/gi,\"$1\"))}var w=null;if(t){var x=t.match(/text-align:.+?[; \"]{1,1}/gi);x&&(w=x[x.length-1].replace(/text-align:(.+?)[; \"]{1,1}/gi,\"$1\")),\"general\"==w&&(w=null)}var y=null;if(t){var z=t.match(/background:.+?[; \"]{1,1}/gi);z&&(y=z[z.length-1].replace(/background:(.+?)[; \"]{1,1}/gi,\"$1\"))}var A=e.getAttribute(\"colspan\"),B=e.getAttribute(\"rowspan\");A&&e.setAttribute(\"colspan\",A),B&&e.setAttribute(\"rowspan\",B),u&&(e.style[\"vertical-align\"]=u),w&&(e.style[\"text-align\"]=w),y&&(e.style[\"background-color\"]=y),i&&e.setAttribute(\"width\",i),e=e.nextElementSibling}for(e=c.firstElementChild;e;)i=e.getAttribute(\"width\"),g?e.removeAttribute(\"width\"):e.setAttribute(\"width\",100*parseInt(i,10)/f+\"%\"),e=e.nextElementSibling}function p(a){var b=a.parentNode,c=a.getAttribute(\"align\");c&&(b&&\"TD\"==b.tagName?(b.setAttribute(\"style\",b.getAttribute(\"style\")+\"text-align:\"+c+\";\"),a.removeAttribute(\"align\")):(a.style[\"text-align\"]=c,a.removeAttribute(\"align\")))}function q(a){return a.replace(/\\n|\\r|\\n\\r|&quot;/g,\"\")}function r(a,b,c){if(b){var d=a.getAttribute(\"style\");d&&\";\"!=d.slice(-1)&&(d+=\";\"),b&&\";\"!=b.slice(-1)&&(b+=\";\"),b=b.replace(/\\n/gi,\"\");var e=null;e=c?(d||\"\")+b:b+(d||\"\"),a.setAttribute(\"style\",e)}}function s(a){var b=a.getAttribute(\"style\");if(b){b=q(b),b&&\";\"!=b.slice(-1)&&(b+=\";\");var c=b.match(/(^|\\S+?):.+?;{1,1}/gi);if(c){for(var d={},e=0;e<c.length;e++){var f=c[e],g=f.split(\":\");2==g.length&&(\"text-align\"==g[0]&&\"SPAN\"==a.tagName||(d[g[0]]=g[1]))}var h=\"\";for(var i in d)if(d.hasOwnProperty(i)){if(\"font-size\"==i&&\"pt;\"==d[i].slice(-3)){var j=null;try{j=parseFloat(d[i].slice(0,-3),10)}catch(k){}j&&(j=Math.round(1.33*j),d[i]=j+\"px;\")}h+=i+\":\"+d[i]}h&&a.setAttribute(\"style\",h)}}}function t(a){for(var b=a.match(/[0-9a-f]{2}/gi),c=[],d=0;d<b.length;d++)c.push(String.fromCharCode(parseInt(b[d],16)));var e=c.join(\"\");return btoa(e)}function u(a,b,c){for(var d=a.split(c),e=1;e<d.length;e++){var f=d[e];if(f=f.split(\"shplid\"),f.length>1){f=f[1];for(var g=\"\",h=0;h<f.length&&\"\\\\\"!=f[h]&&\"{\"!=f[h]&&\" \"!=f[h]&&\"\\r\"!=f[h]&&\"\\n\"!=f[h];)g+=f[h],h++;var i=f.split(\"bliptag\");if(i&&i.length<2)continue;var j=null;if(-1!=i[0].indexOf(\"pngblip\")?j=\"image/png\":-1!=i[0].indexOf(\"jpegblip\")&&(j=\"image/jpeg\"),!j)continue;var k=i[1].split(\"}\");if(k&&k.length<2)continue;var l;if(k.length>2&&-1!=k[0].indexOf(\"blipuid\"))l=k[1].split(\" \");else{if((l=k[0].split(\" \"))&&l.length<2)continue;l.shift()}var m=l.join(\"\");E[b+g]={image_hex:m,image_type:j}}}}function v(a){E={},u(a,\"i\",\"\\\\shppict\"),u(a,\"s\",\"\\\\shp{\")}function w(b,c){if(c){var d;if(\"IMG\"==b.tagName){var e=b.getAttribute(\"src\");if(!e||-1==e.indexOf(\"file://\"))return;d=F[b.getAttribute(\"v:shapes\")]}else d=b.parentNode.getAttribute(\"o:spid\");if(b.removeAttribute(\"height\"),d){E||v(c);var f=E[d.substring(7)];if(f){var g=t(f.image_hex),h=\"data:\"+f.image_type+\";base64,\"+g;\"IMG\"===b.tagName?(b.src=h,b.setAttribute(\"data-fr-image-pasted\",!0)):a(b.parentNode).before('<img data-fr-image-pasted=\"true\" src=\"'+h+'\" style=\"'+b.parentNode.getAttribute(\"style\")+'\">').remove()}}}}function x(a,b){var c=a.tagName,d=c.toLowerCase();if(a.firstElementChild&&(\"I\"==a.firstElementChild.tagName?n(a.firstElementChild,\"em\"):\"B\"==a.firstElementChild.tagName&&n(a.firstElementChild,\"strong\")),-1!=[\"SCRIPT\",\"APPLET\",\"EMBED\",\"NOFRAMES\",\"NOSCRIPT\"].indexOf(c))return h(a),!1;var e=-1,f=[\"META\",\"LINK\",\"XML\",\"ST1:\",\"O:\",\"W:\",\"FONT\"];for(e=0;e<f.length;e++)if(-1!=c.indexOf(f[e]))return a.innerHTML?(a.outerHTML=a.innerHTML,h(a),!1):(h(a),!1);if(\"TD\"!=c){var g=a.getAttribute(\"class\");if(b&&g){g=q(g);var i=g.split(\" \");for(e=0;e<i.length;e++){var j=i[e],k=[],l=\".\"+j;k.push(l),l=d+l,k.push(l);for(var m=0;m<k.length;m++)b[k[m]]&&r(a,b[k[m]])}a.removeAttribute(\"class\")}b&&b[d]&&r(a,b[d])}if(-1!=[\"P\",\"H1\",\"H2\",\"H3\",\"H4\",\"H5\",\"H6\",\"PRE\"].indexOf(c)){var s=a.getAttribute(\"class\");if(s&&(b&&b[c.toLowerCase()+\".\"+s]&&r(a,b[c.toLowerCase()+\".\"+s]),-1!=s.toLowerCase().indexOf(\"mso\"))){var t=q(s);t=t.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi,\"\"),t?a.setAttribute(\"class\",t):a.removeAttribute(\"class\")}var u=a.getAttribute(\"style\");if(u){var v=u.match(/text-align:.+?[; \"]{1,1}/gi);v&&v[v.length-1].replace(/(text-align:.+?[; \"]{1,1})/gi,\"$1\")}p(a)}if(\"TR\"==c&&o(a,b),\"A\"==c&&!a.attributes.getNamedItem(\"href\")&&a.innerHTML&&(a.outerHTML=a.innerHTML),\"TD\"!=c&&\"TH\"!=c||a.innerHTML||(a.innerHTML=\"<br>\"),\"TABLE\"==c&&(a.style.width=\"100%\"),a.getAttribute(\"lang\")&&a.removeAttribute(\"lang\"),a.getAttribute(\"style\")&&-1!=a.getAttribute(\"style\").toLowerCase().indexOf(\"mso\")){var w=q(a.getAttribute(\"style\"));w=w.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi,\"\"),w?a.setAttribute(\"style\",w):a.removeAttribute(\"style\")}return!0}function y(a){var b={},c=a.getElementsByTagName(\"style\");if(c.length){var d=c[0],e=d.innerHTML.match(/[\\S ]+\\s+{[\\s\\S]+?}/gi);if(e)for(var f=0;f<e.length;f++){var g=e[f],h=g.replace(/([\\S ]+\\s+){[\\s\\S]+?}/gi,\"$1\"),i=g.replace(/[\\S ]+\\s+{([\\s\\S]+?)}/gi,\"$1\");h=h.replace(/^[\\s]|[\\s]$/gm,\"\"),i=i.replace(/^[\\s]|[\\s]$/gm,\"\"),h=h.replace(/\\n|\\r|\\n\\r/g,\"\"),i=i.replace(/\\n|\\r|\\n\\r/g,\"\");for(var j=h.split(\", \"),k=0;k<j.length;k++)b[j[k]]=i}}return b}function z(a){for(var b=a.split(\"v:shape\"),c=1;c<b.length;c++){var d=b[c],e=d.split(' id=\"')[1];if(e&&e.length>1){e=e.split('\"')[0];var f=d.split(' o:spid=\"')[1];f&&f.length>1&&(f=f.split('\"')[0],F[e]=f)}}}function A(c,d){c=c.replace(/[.\\s\\S\\w\\W<>]*(<html[^>]*>[.\\s\\S\\w\\W<>]*<\\/html>)[.\\s\\S\\w\\W<>]*/i,\"$1\"),z(c);var e=new DOMParser,f=e.parseFromString(c,\"text/html\"),g=f.head,k=f.body,l=y(g);i(k,function(b){if(b.nodeType==Node.TEXT_NODE&&/\\n|\\u00a0/.test(b.data)){if(!/\\S| /.test(b.data))return b.data==a.FE.UNICODE_NBSP?(b.data=\"\\u200b\",!0):(h(b),!1);b.data=b.data.replace(/\\n/gi,\" \")}return!0}),i(k,function(a){return a.nodeType!=Node.ELEMENT_NODE||\"V:IMAGEDATA\"!=a.tagName&&\"IMG\"!=a.tagName||w(a,d),!0}),i(k,function(a){if(a.nodeType==Node.TEXT_NODE)return a.data=a.data.replace(/<br>(\\n|\\r)/gi,\"<br>\"),!1;if(a.nodeType==Node.ELEMENT_NODE){if(j(a)){var b=a.parentNode,c=a.previousSibling,d=m(a,l),e=null;return e=c?c.nextSibling:b.firstChild,e?b.insertBefore(d,e):b.appendChild(d),!1}return x(a,l)}return a.nodeType!=Node.COMMENT_NODE||(h(a),!1)}),i(k,function(a){if(a.nodeType==Node.ELEMENT_NODE){var b=a.tagName;if(!a.innerHTML&&-1==[\"BR\",\"IMG\"].indexOf(b)){for(var c=a.parentNode;c&&(h(a),a=c,!a.innerHTML);)c=a.parentNode;return!1}s(a)}return!0});var n=k.outerHTML,o=b.opts.htmlAllowedStyleProps;return b.opts.htmlAllowedStyleProps=b.opts.wordAllowedStyleProps,n=b.clean.html(n,b.opts.wordDeniedTags,b.opts.wordDeniedAttrs,!1),b.opts.htmlAllowedStyleProps=o,n}var B,C,D=\"word_paste\",E=null,F={};return{_init:c,clean:g}}});"

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1498))

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{paragraphFormat:{N:\"Normal\",H1:\"Heading 1\",H2:\"Heading 2\",H3:\"Heading 3\",H4:\"Heading 4\",PRE:\"Code\"},paragraphFormatSelection:!1}),a.FE.PLUGINS.paragraphFormat=function(b){function c(c,d){var e=b.html.defaultTag();if(d&&d.toLowerCase()!=e)if(c.find(\"ul, ol\").length>0){var f=a(\"<\"+d+\">\");c.prepend(f);for(var g=b.node.contents(c.get(0))[0];g&&[\"UL\",\"OL\"].indexOf(g.tagName)<0;){var h=g.nextSibling;f.append(g),g=h}}else c.html(\"<\"+d+\">\"+c.html()+\"</\"+d+\">\")}function d(c,d){var e=b.html.defaultTag();d||(d='div class=\"fr-temp-div\" data-empty=\"true\"'),d.toLowerCase()==e?c.replaceWith(c.html()):c.replaceWith(a(\"<\"+d+\">\").html(c.html()))}function e(c,d){var e=b.html.defaultTag();d||(d='div class=\"fr-temp-div\"'+(b.node.isEmpty(c.get(0),!0)?' data-empty=\"true\"':\"\")),d.toLowerCase()==e?(b.node.isEmpty(c.get(0),!0)||c.append(\"<br/>\"),c.replaceWith(c.html())):c.replaceWith(a(\"<\"+d+\">\").html(c.html()))}function f(c,d){d||(d='div class=\"fr-temp-div\"'+(b.node.isEmpty(c.get(0),!0)?' data-empty=\"true\"':\"\")),c.replaceWith(a(\"<\"+d+\" \"+b.node.attributes(c.get(0))+\">\").html(c.html()).removeAttr(\"data-empty\"))}function g(g){\"N\"==g&&(g=b.html.defaultTag()),b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();var h=b.selection.blocks();b.selection.save(),b.$el.find(\"pre\").attr(\"skip\",!0);for(var i=0;i<h.length;i++)if(h[i].tagName!=g&&!b.node.isList(h[i])){var j=a(h[i]);\"LI\"==h[i].tagName?c(j,g):\"LI\"==h[i].parentNode.tagName&&h[i]?d(j,g):[\"TD\",\"TH\"].indexOf(h[i].parentNode.tagName)>=0?e(j,g):f(j,g)}b.$el.find('pre:not([skip=\"true\"]) + pre:not([skip=\"true\"])').each(function(){a(this).prev().append(\"<br>\"+a(this).html()),a(this).remove()}),b.$el.find(\"pre\").removeAttr(\"skip\"),b.html.unwrap(),b.selection.restore()}function h(a,c){var d=b.selection.blocks();if(d.length){var e=d[0],f=\"N\",g=b.html.defaultTag();e.tagName.toLowerCase()!=g&&e!=b.el&&(f=e.tagName),c.find('.fr-command[data-param1=\"'+f+'\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}else c.find('.fr-command[data-param1=\"N\"]').addClass(\"fr-active\").attr(\"aria-selected\",!0)}function i(a){if(b.opts.paragraphFormatSelection){var c=b.selection.blocks();if(c.length){var d=c[0],e=\"N\",f=b.html.defaultTag();d.tagName.toLowerCase()!=f&&d!=b.el&&(e=d.tagName),[\"LI\",\"TD\",\"TH\"].indexOf(e)>=0&&(e=\"N\"),a.find(\"> span\").text(b.language.translate(b.opts.paragraphFormat[e]))}else a.find(\"> span\").text(b.language.translate(b.opts.paragraphFormat.N))}}return{apply:g,refreshOnShow:h,refresh:i}},a.FE.RegisterCommand(\"paragraphFormat\",{type:\"dropdown\",displaySelection:function(a){return a.opts.paragraphFormatSelection},defaultSelection:\"Normal\",displaySelectionWidth:100,html:function(){var a='<ul class=\"fr-dropdown-list\" role=\"presentation\">',b=this.opts.paragraphFormat;for(var c in b)if(b.hasOwnProperty(c)){var d=this.shortcuts.get(\"paragraphFormat.\"+c);d=d?'<span class=\"fr-shortcut\">'+d+\"</span>\":\"\",a+='<li role=\"presentation\"><'+(\"N\"==c?this.html.defaultTag()||\"DIV\":c)+' style=\"padding: 0 !important; margin: 0 !important;\" role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"paragraphFormat\" data-param1=\"'+c+'\" title=\"'+this.language.translate(b[c])+'\">'+this.language.translate(b[c])+\"</a></\"+(\"N\"==c?this.html.defaultTag()||\"DIV\":c)+\"></li>\"}return a+=\"</ul>\"},title:\"Paragraph Format\",callback:function(a,b){this.paragraphFormat.apply(b)},refresh:function(a){this.paragraphFormat.refresh(a)},refreshOnShow:function(a,b){this.paragraphFormat.refreshOnShow(a,b)},plugin:\"paragraphFormat\"}),a.FE.DefineIcon(\"paragraphFormat\",{NAME:\"paragraph\"})});"

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1500))

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

module.exports = "/*!\n * froala_editor v2.7.2 (https://www.froala.com/wysiwyg-editor)\n * License https://froala.com/wysiwyg-editor/terms/\n * Copyright 2014-2017 Froala Labs\n */\n\n!function(a){\"function\"==typeof define&&define.amd?define([\"jquery\"],a):\"object\"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c=\"undefined\"!=typeof window?require(\"jquery\"):require(\"jquery\")(b)),a(c)}:a(window.jQuery)}(function(a){a.extend(a.FE.DEFAULTS,{specialCharactersSets:[{title:\"Latin\",list:[{char:\"&iexcl;\",desc:\"INVERTED EXCLAMATION MARK\"},{char:\"&cent;\",desc:\"CENT SIGN\"},{char:\"&pound;\",desc:\"POUND SIGN\"},{char:\"&curren;\",desc:\"CURRENCY SIGN\"},{char:\"&yen;\",desc:\"YEN SIGN\"},{char:\"&brvbar;\",desc:\"BROKEN BAR\"},{char:\"&sect;\",desc:\"SECTION SIGN\"},{char:\"&uml;\",desc:\"DIAERESIS\"},{char:\"&copy;\",desc:\"COPYRIGHT SIGN\"},{char:\"&trade;\",desc:\"TRADEMARK SIGN\"},{char:\"&ordf;\",desc:\"FEMININE ORDINAL INDICATOR\"},{char:\"&laquo;\",desc:\"LEFT-POINTING DOUBLE ANGLE QUOTATION MARK\"},{char:\"&not;\",desc:\"NOT SIGN\"},{char:\"&reg;\",desc:\"REGISTERED SIGN\"},{char:\"&macr;\",desc:\"MACRON\"},{char:\"&deg;\",desc:\"DEGREE SIGN\"},{char:\"&plusmn;\",desc:\"PLUS-MINUS SIGN\"},{char:\"&sup2;\",desc:\"SUPERSCRIPT TWO\"},{char:\"&sup3;\",desc:\"SUPERSCRIPT THREE\"},{char:\"&acute;\",desc:\"ACUTE ACCENT\"},{char:\"&micro;\",desc:\"MICRO SIGN\"},{char:\"&para;\",desc:\"PILCROW SIGN\"},{char:\"&middot;\",desc:\"MIDDLE DOT\"},{char:\"&cedil;\",desc:\"CEDILLA\"},{char:\"&sup1;\",desc:\"SUPERSCRIPT ONE\"},{char:\"&ordm;\",desc:\"MASCULINE ORDINAL INDICATOR\"},{char:\"&raquo;\",desc:\"RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK\"},{char:\"&frac14;\",desc:\"VULGAR FRACTION ONE QUARTER\"},{char:\"&frac12;\",desc:\"VULGAR FRACTION ONE HALF\"},{char:\"&frac34;\",desc:\"VULGAR FRACTION THREE QUARTERS\"},{char:\"&iquest;\",desc:\"INVERTED QUESTION MARK\"},{char:\"&Agrave;\",desc:\"LATIN CAPITAL LETTER A WITH GRAVE\"},{char:\"&Aacute;\",desc:\"LATIN CAPITAL LETTER A WITH ACUTE\"},{char:\"&Acirc;\",desc:\"LATIN CAPITAL LETTER A WITH CIRCUMFLEX\"},{char:\"&Atilde;\",desc:\"LATIN CAPITAL LETTER A WITH TILDE\"},{char:\"&Auml;\",desc:\"LATIN CAPITAL LETTER A WITH DIAERESIS \"},{char:\"&Aring;\",desc:\"LATIN CAPITAL LETTER A WITH RING ABOVE\"},{char:\"&AElig;\",desc:\"LATIN CAPITAL LETTER AE\"},{char:\"&Ccedil;\",desc:\"LATIN CAPITAL LETTER C WITH CEDILLA\"},{char:\"&Egrave;\",desc:\"LATIN CAPITAL LETTER E WITH GRAVE\"},{char:\"&Eacute;\",desc:\"LATIN CAPITAL LETTER E WITH ACUTE\"},{char:\"&Ecirc;\",desc:\"LATIN CAPITAL LETTER E WITH CIRCUMFLEX\"},{char:\"&Euml;\",desc:\"LATIN CAPITAL LETTER E WITH DIAERESIS\"},{char:\"&Igrave;\",desc:\"LATIN CAPITAL LETTER I WITH GRAVE\"},{char:\"&Iacute;\",desc:\"LATIN CAPITAL LETTER I WITH ACUTE\"},{char:\"&Icirc;\",desc:\"LATIN CAPITAL LETTER I WITH CIRCUMFLEX\"},{char:\"&Iuml;\",desc:\"LATIN CAPITAL LETTER I WITH DIAERESIS\"},{char:\"&ETH;\",desc:\"LATIN CAPITAL LETTER ETH\"},{char:\"&Ntilde;\",desc:\"LATIN CAPITAL LETTER N WITH TILDE\"},{char:\"&Ograve;\",desc:\"LATIN CAPITAL LETTER O WITH GRAVE\"},{char:\"&Oacute;\",desc:\"LATIN CAPITAL LETTER O WITH ACUTE\"},{char:\"&Ocirc;\",desc:\"LATIN CAPITAL LETTER O WITH CIRCUMFLEX\"},{char:\"&Otilde;\",desc:\"LATIN CAPITAL LETTER O WITH TILDE\"},{char:\"&Ouml;\",desc:\"LATIN CAPITAL LETTER O WITH DIAERESIS\"},{char:\"&times;\",desc:\"MULTIPLICATION SIGN\"},{char:\"&Oslash;\",desc:\"LATIN CAPITAL LETTER O WITH STROKE\"},{char:\"&Ugrave;\",desc:\"LATIN CAPITAL LETTER U WITH GRAVE\"},{char:\"&Uacute;\",desc:\"LATIN CAPITAL LETTER U WITH ACUTE\"},{char:\"&Ucirc;\",desc:\"LATIN CAPITAL LETTER U WITH CIRCUMFLEX\"},{char:\"&Uuml;\",desc:\"LATIN CAPITAL LETTER U WITH DIAERESIS\"},{char:\"&Yacute;\",desc:\"LATIN CAPITAL LETTER Y WITH ACUTE\"},{char:\"&THORN;\",desc:\"LATIN CAPITAL LETTER THORN\"},{char:\"&szlig;\",desc:\"LATIN SMALL LETTER SHARP S\"},{char:\"&agrave;\",desc:\"LATIN SMALL LETTER A WITH GRAVE\"},{char:\"&aacute;\",desc:\"LATIN SMALL LETTER A WITH ACUTE \"},{char:\"&acirc;\",desc:\"LATIN SMALL LETTER A WITH CIRCUMFLEX\"},{char:\"&atilde;\",desc:\"LATIN SMALL LETTER A WITH TILDE\"},{char:\"&auml;\",desc:\"LATIN SMALL LETTER A WITH DIAERESIS\"},{char:\"&aring;\",desc:\"LATIN SMALL LETTER A WITH RING ABOVE\"},{char:\"&aelig;\",desc:\"LATIN SMALL LETTER AE\"},{char:\"&ccedil;\",desc:\"LATIN SMALL LETTER C WITH CEDILLA\"},{char:\"&egrave;\",desc:\"LATIN SMALL LETTER E WITH GRAVE\"},{char:\"&eacute;\",desc:\"LATIN SMALL LETTER E WITH ACUTE\"},{char:\"&ecirc;\",desc:\"LATIN SMALL LETTER E WITH CIRCUMFLEX\"},{char:\"&euml;\",desc:\"LATIN SMALL LETTER E WITH DIAERESIS\"},{char:\"&igrave;\",desc:\"LATIN SMALL LETTER I WITH GRAVE\"},{char:\"&iacute;\",desc:\"LATIN SMALL LETTER I WITH ACUTE\"},{char:\"&icirc;\",desc:\"LATIN SMALL LETTER I WITH CIRCUMFLEX\"},{char:\"&iuml;\",desc:\"LATIN SMALL LETTER I WITH DIAERESIS\"},{char:\"&eth;\",desc:\"LATIN SMALL LETTER ETH\"},{char:\"&ntilde;\",desc:\"LATIN SMALL LETTER N WITH TILDE\"},{char:\"&ograve;\",desc:\"LATIN SMALL LETTER O WITH GRAVE\"},{char:\"&oacute;\",desc:\"LATIN SMALL LETTER O WITH ACUTE\"},{char:\"&ocirc;\",desc:\"LATIN SMALL LETTER O WITH CIRCUMFLEX\"},{char:\"&otilde;\",desc:\"LATIN SMALL LETTER O WITH TILDE\"},{char:\"&ouml;\",desc:\"LATIN SMALL LETTER O WITH DIAERESIS\"},{char:\"&divide;\",desc:\"DIVISION SIGN\"},{char:\"&oslash;\",desc:\"LATIN SMALL LETTER O WITH STROKE\"},{char:\"&ugrave;\",desc:\"LATIN SMALL LETTER U WITH GRAVE\"},{char:\"&uacute;\",desc:\"LATIN SMALL LETTER U WITH ACUTE\"},{char:\"&ucirc;\",desc:\"LATIN SMALL LETTER U WITH CIRCUMFLEX\"},{char:\"&uuml;\",desc:\"LATIN SMALL LETTER U WITH DIAERESIS\"},{char:\"&yacute;\",desc:\"LATIN SMALL LETTER Y WITH ACUTE\"},{char:\"&thorn;\",desc:\"LATIN SMALL LETTER THORN\"},{char:\"&yuml;\",desc:\"LATIN SMALL LETTER Y WITH DIAERESIS\"}]},{title:\"Greek\",list:[{char:\"&Alpha;\",desc:\"GREEK CAPITAL LETTER ALPHA\"},{char:\"&Beta;\",desc:\"GREEK CAPITAL LETTER BETA\"},{char:\"&Gamma;\",desc:\"GREEK CAPITAL LETTER GAMMA\"},{char:\"&Delta;\",desc:\"GREEK CAPITAL LETTER DELTA\"},{char:\"&Epsilon;\",desc:\"GREEK CAPITAL LETTER EPSILON\"},{char:\"&Zeta;\",desc:\"GREEK CAPITAL LETTER ZETA\"},{char:\"&Eta;\",desc:\"GREEK CAPITAL LETTER ETA\"},{char:\"&Theta;\",desc:\"GREEK CAPITAL LETTER THETA\"},{char:\"&Iota;\",desc:\"GREEK CAPITAL LETTER IOTA\"},{char:\"&Kappa;\",desc:\"GREEK CAPITAL LETTER KAPPA\"},{char:\"&Lambda;\",desc:\"GREEK CAPITAL LETTER LAMBDA\"},{char:\"&Mu;\",desc:\"GREEK CAPITAL LETTER MU\"},{char:\"&Nu;\",desc:\"GREEK CAPITAL LETTER NU\"},{char:\"&Xi;\",desc:\"GREEK CAPITAL LETTER XI\"},{char:\"&Omicron;\",desc:\"GREEK CAPITAL LETTER OMICRON\"},{char:\"&Pi;\",desc:\"GREEK CAPITAL LETTER PI\"},{char:\"&Rho;\",desc:\"GREEK CAPITAL LETTER RHO\"},{char:\"&Sigma;\",desc:\"GREEK CAPITAL LETTER SIGMA\"},{char:\"&Tau;\",desc:\"GREEK CAPITAL LETTER TAU\"},{char:\"&Upsilon;\",desc:\"GREEK CAPITAL LETTER UPSILON\"},{char:\"&Phi;\",desc:\"GREEK CAPITAL LETTER PHI\"},{char:\"&Chi;\",desc:\"GREEK CAPITAL LETTER CHI\"},{char:\"&Psi;\",desc:\"GREEK CAPITAL LETTER PSI\"},{char:\"&Omega;\",desc:\"GREEK CAPITAL LETTER OMEGA\"},{char:\"&alpha;\",desc:\"GREEK SMALL LETTER ALPHA\"},{char:\"&beta;\",desc:\"GREEK SMALL LETTER BETA\"},{char:\"&gamma;\",desc:\"GREEK SMALL LETTER GAMMA\"},{char:\"&delta;\",desc:\"GREEK SMALL LETTER DELTA\"},{char:\"&epsilon;\",desc:\"GREEK SMALL LETTER EPSILON\"},{char:\"&zeta;\",desc:\"GREEK SMALL LETTER ZETA\"},{char:\"&eta;\",desc:\"GREEK SMALL LETTER ETA\"},{char:\"&theta;\",desc:\"GREEK SMALL LETTER THETA\"},{char:\"&iota;\",desc:\"GREEK SMALL LETTER IOTA\"},{char:\"&kappa;\",desc:\"GREEK SMALL LETTER KAPPA\"},{char:\"&lambda;\",desc:\"GREEK SMALL LETTER LAMBDA\"},{char:\"&mu;\",desc:\"GREEK SMALL LETTER MU\"},{char:\"&nu;\",desc:\"GREEK SMALL LETTER NU\"},{char:\"&xi;\",desc:\"GREEK SMALL LETTER XI\"},{char:\"&omicron;\",desc:\"GREEK SMALL LETTER OMICRON\"},{char:\"&pi;\",desc:\"GREEK SMALL LETTER PI\"},{char:\"&rho;\",desc:\"GREEK SMALL LETTER RHO\"},{char:\"&sigmaf;\",desc:\"GREEK SMALL LETTER FINAL SIGMA\"},{char:\"&sigma;\",desc:\"GREEK SMALL LETTER SIGMA\"},{char:\"&tau;\",desc:\"GREEK SMALL LETTER TAU\"},{char:\"&upsilon;\",desc:\"GREEK SMALL LETTER UPSILON\"},{char:\"&phi;\",desc:\"GREEK SMALL LETTER PHI\"},{char:\"&chi;\",desc:\"GREEK SMALL LETTER CHI\"},{char:\"&psi;\",desc:\"GREEK SMALL LETTER PSI\"},{char:\"&omega;\",desc:\"GREEK SMALL LETTER OMEGA\"},{char:\"&thetasym;\",desc:\"GREEK THETA SYMBOL\"},{char:\"&upsih;\",desc:\"GREEK UPSILON WITH HOOK SYMBOL\"},{char:\"&straightphi;\",desc:\"GREEK PHI SYMBOL\"},{char:\"&piv;\",desc:\"GREEK PI SYMBOL\"},{char:\"&Gammad;\",desc:\"GREEK LETTER DIGAMMA\"},{char:\"&gammad;\",desc:\"GREEK SMALL LETTER DIGAMMA\"},{char:\"&varkappa;\",desc:\"GREEK KAPPA SYMBOL\"},{char:\"&varrho;\",desc:\"GREEK RHO SYMBOL\"},{char:\"&straightepsilon;\",desc:\"GREEK LUNATE EPSILON SYMBOL\"},{char:\"&backepsilon;\",desc:\"GREEK REVERSED LUNATE EPSILON SYMBOL\"}]},{title:\"Cyrillic\",list:[{char:\"&#x400\",desc:\"CYRILLIC CAPITAL LETTER IE WITH GRAVE\"},{char:\"&#x401\",desc:\"CYRILLIC CAPITAL LETTER IO\"},{char:\"&#x402\",desc:\"CYRILLIC CAPITAL LETTER DJE\"},{char:\"&#x403\",desc:\"CYRILLIC CAPITAL LETTER GJE\"},{char:\"&#x404\",desc:\"CYRILLIC CAPITAL LETTER UKRAINIAN IE\"},{char:\"&#x405\",desc:\"CYRILLIC CAPITAL LETTER DZE\"},{char:\"&#x406\",desc:\"CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I\"},{char:\"&#x407\",desc:\"CYRILLIC CAPITAL LETTER YI\"},{char:\"&#x408\",desc:\"CYRILLIC CAPITAL LETTER JE\"},{char:\"&#x409\",desc:\"CYRILLIC CAPITAL LETTER LJE\"},{char:\"&#x40A\",desc:\"CYRILLIC CAPITAL LETTER NJE\"},{char:\"&#x40B\",desc:\"CYRILLIC CAPITAL LETTER TSHE\"},{char:\"&#x40C\",desc:\"CYRILLIC CAPITAL LETTER KJE\"},{char:\"&#x40D\",desc:\"CYRILLIC CAPITAL LETTER I WITH GRAVE\"},{char:\"&#x40E\",desc:\"CYRILLIC CAPITAL LETTER SHORT U\"},{char:\"&#x40F\",desc:\"CYRILLIC CAPITAL LETTER DZHE\"},{char:\"&#x410\",desc:\"CYRILLIC CAPITAL LETTER A\"},{char:\"&#x411\",desc:\"CYRILLIC CAPITAL LETTER BE\"},{char:\"&#x412\",desc:\"CYRILLIC CAPITAL LETTER VE\"},{char:\"&#x413\",desc:\"CYRILLIC CAPITAL LETTER GHE\"},{char:\"&#x414\",desc:\"CYRILLIC CAPITAL LETTER DE\"},{char:\"&#x415\",desc:\"CYRILLIC CAPITAL LETTER IE\"},{char:\"&#x416\",desc:\"CYRILLIC CAPITAL LETTER ZHE\"},{char:\"&#x417\",desc:\"CYRILLIC CAPITAL LETTER ZE\"},{char:\"&#x418\",desc:\"CYRILLIC CAPITAL LETTER I\"},{char:\"&#x419\",desc:\"CYRILLIC CAPITAL LETTER SHORT I\"},{char:\"&#x41A\",desc:\"CYRILLIC CAPITAL LETTER KA\"},{char:\"&#x41B\",desc:\"CYRILLIC CAPITAL LETTER EL\"},{char:\"&#x41C\",desc:\"CYRILLIC CAPITAL LETTER EM\"},{char:\"&#x41D\",desc:\"CYRILLIC CAPITAL LETTER EN\"},{char:\"&#x41E\",desc:\"CYRILLIC CAPITAL LETTER O\"},{char:\"&#x41F\",desc:\"CYRILLIC CAPITAL LETTER PE\"},{char:\"&#x420\",desc:\"CYRILLIC CAPITAL LETTER ER\"},{char:\"&#x421\",desc:\"CYRILLIC CAPITAL LETTER ES\"},{char:\"&#x422\",desc:\"CYRILLIC CAPITAL LETTER TE\"},{char:\"&#x423\",desc:\"CYRILLIC CAPITAL LETTER U\"},{char:\"&#x424\",desc:\"CYRILLIC CAPITAL LETTER EF\"},{char:\"&#x425\",desc:\"CYRILLIC CAPITAL LETTER HA\"},{char:\"&#x426\",desc:\"CYRILLIC CAPITAL LETTER TSE\"},{char:\"&#x427\",desc:\"CYRILLIC CAPITAL LETTER CHE\"},{char:\"&#x428\",desc:\"CYRILLIC CAPITAL LETTER SHA\"},{char:\"&#x429\",desc:\"CYRILLIC CAPITAL LETTER SHCHA\"},{char:\"&#x42A\",desc:\"CYRILLIC CAPITAL LETTER HARD SIGN\"},{char:\"&#x42B\",desc:\"CYRILLIC CAPITAL LETTER YERU\"},{char:\"&#x42C\",desc:\"CYRILLIC CAPITAL LETTER SOFT SIGN\"},{char:\"&#x42D\",desc:\"CYRILLIC CAPITAL LETTER E\"},{char:\"&#x42E\",desc:\"CYRILLIC CAPITAL LETTER YU\"},{char:\"&#x42F\",desc:\"CYRILLIC CAPITAL LETTER YA\"},{char:\"&#x430\",desc:\"CYRILLIC SMALL LETTER A\"},{char:\"&#x431\",desc:\"CYRILLIC SMALL LETTER BE\"},{char:\"&#x432\",desc:\"CYRILLIC SMALL LETTER VE\"},{char:\"&#x433\",desc:\"CYRILLIC SMALL LETTER GHE\"},{char:\"&#x434\",desc:\"CYRILLIC SMALL LETTER DE\"},{char:\"&#x435\",desc:\"CYRILLIC SMALL LETTER IE\"},{char:\"&#x436\",desc:\"CYRILLIC SMALL LETTER ZHE\"},{char:\"&#x437\",desc:\"CYRILLIC SMALL LETTER ZE\"},{char:\"&#x438\",desc:\"CYRILLIC SMALL LETTER I\"},{char:\"&#x439\",desc:\"CYRILLIC SMALL LETTER SHORT I\"},{char:\"&#x43A\",desc:\"CYRILLIC SMALL LETTER KA\"},{char:\"&#x43B\",desc:\"CYRILLIC SMALL LETTER EL\"},{char:\"&#x43C\",desc:\"CYRILLIC SMALL LETTER EM\"},{char:\"&#x43D\",desc:\"CYRILLIC SMALL LETTER EN\"},{char:\"&#x43E\",desc:\"CYRILLIC SMALL LETTER O\"},{char:\"&#x43F\",desc:\"CYRILLIC SMALL LETTER PE\"},{char:\"&#x440\",desc:\"CYRILLIC SMALL LETTER ER\"},{char:\"&#x441\",desc:\"CYRILLIC SMALL LETTER ES\"},{char:\"&#x442\",desc:\"CYRILLIC SMALL LETTER TE\"},{char:\"&#x443\",desc:\"CYRILLIC SMALL LETTER U\"},{char:\"&#x444\",desc:\"CYRILLIC SMALL LETTER EF\"},{char:\"&#x445\",desc:\"CYRILLIC SMALL LETTER HA\"},{char:\"&#x446\",desc:\"CYRILLIC SMALL LETTER TSE\"},{char:\"&#x447\",desc:\"CYRILLIC SMALL LETTER CHE\"},{char:\"&#x448\",desc:\"CYRILLIC SMALL LETTER SHA\"},{char:\"&#x449\",desc:\"CYRILLIC SMALL LETTER SHCHA\"},{char:\"&#x44A\",desc:\"CYRILLIC SMALL LETTER HARD SIGN\"},{char:\"&#x44B\",desc:\"CYRILLIC SMALL LETTER YERU\"},{char:\"&#x44C\",desc:\"CYRILLIC SMALL LETTER SOFT SIGN\"},{char:\"&#x44D\",desc:\"CYRILLIC SMALL LETTER E\"},{char:\"&#x44E\",desc:\"CYRILLIC SMALL LETTER YU\"},{char:\"&#x44F\",desc:\"CYRILLIC SMALL LETTER YA\"},{char:\"&#x450\",desc:\"CYRILLIC SMALL LETTER IE WITH GRAVE\"},{char:\"&#x451\",desc:\"CYRILLIC SMALL LETTER IO\"},{char:\"&#x452\",desc:\"CYRILLIC SMALL LETTER DJE\"},{char:\"&#x453\",desc:\"CYRILLIC SMALL LETTER GJE\"},{char:\"&#x454\",desc:\"CYRILLIC SMALL LETTER UKRAINIAN IE\"},{char:\"&#x455\",desc:\"CYRILLIC SMALL LETTER DZE\"},{char:\"&#x456\",desc:\"CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I\"},{char:\"&#x457\",desc:\"CYRILLIC SMALL LETTER YI\"},{char:\"&#x458\",desc:\"CYRILLIC SMALL LETTER JE\"},{char:\"&#x459\",desc:\"CYRILLIC SMALL LETTER LJE\"},{char:\"&#x45A\",desc:\"CYRILLIC SMALL LETTER NJE\"},{char:\"&#x45B\",desc:\"CYRILLIC SMALL LETTER TSHE\"},{char:\"&#x45C\",desc:\"CYRILLIC SMALL LETTER KJE\"},{char:\"&#x45D\",desc:\"CYRILLIC SMALL LETTER I WITH GRAVE\"},{char:\"&#x45E\",desc:\"CYRILLIC SMALL LETTER SHORT U\"},{char:\"&#x45F\",desc:\"CYRILLIC SMALL LETTER DZHE\"}]},{title:\"Punctuation\",list:[{char:\"&ndash;\",desc:\"EN DASH\"},{char:\"&mdash;\",desc:\"EM DASH\"},{char:\"&lsquo;\",desc:\"LEFT SINGLE QUOTATION MARK\"},{char:\"&rsquo;\",desc:\"RIGHT SINGLE QUOTATION MARK\"},{char:\"&sbquo;\",desc:\"SINGLE LOW-9 QUOTATION MARK\"},{char:\"&ldquo;\",desc:\"LEFT DOUBLE QUOTATION MARK\"},{char:\"&rdquo;\",desc:\"RIGHT DOUBLE QUOTATION MARK\"},{char:\"&bdquo;\",desc:\"DOUBLE LOW-9 QUOTATION MARK\"},{char:\"&dagger;\",desc:\"DAGGER\"},{char:\"&Dagger;\",desc:\"DOUBLE DAGGER\"},{char:\"&bull;\",desc:\"BULLET\"},{char:\"&hellip;\",desc:\"HORIZONTAL ELLIPSIS\"},{char:\"&permil;\",desc:\"PER MILLE SIGN\"},{char:\"&prime;\",desc:\"PRIME\"},{char:\"&Prime;\",desc:\"DOUBLE PRIME\"},{char:\"&lsaquo;\",desc:\"SINGLE LEFT-POINTING ANGLE QUOTATION MARK\"},{char:\"&rsaquo;\",desc:\"SINGLE RIGHT-POINTING ANGLE QUOTATION MARK\"},{char:\"&oline;\",desc:\"OVERLINE\"},{char:\"&frasl;\",desc:\"FRACTION SLASH\"}]},{title:\"Currency\",list:[{char:\"&#x20A0\",desc:\"EURO-CURRENCY SIGN\"},{char:\"&#x20A1\",desc:\"COLON SIGN\"},{char:\"&#x20A2\",desc:\"CRUZEIRO SIGN\"},{char:\"&#x20A3\",desc:\"FRENCH FRANC SIGN\"},{char:\"&#x20A4\",desc:\"LIRA SIGN\"},{char:\"&#x20A5\",desc:\"MILL SIGN\"},{char:\"&#x20A6\",desc:\"NAIRA SIGN\"},{char:\"&#x20A7\",desc:\"PESETA SIGN\"},{char:\"&#x20A8\",desc:\"RUPEE SIGN\"},{char:\"&#x20A9\",desc:\"WON SIGN\"},{char:\"&#x20AA\",desc:\"NEW SHEQEL SIGN\"},{char:\"&#x20AB\",desc:\"DONG SIGN\"},{char:\"&#x20AC\",desc:\"EURO SIGN\"},{char:\"&#x20AD\",desc:\"KIP SIGN\"},{char:\"&#x20AE\",desc:\"TUGRIK SIGN\"},{char:\"&#x20AF\",desc:\"DRACHMA SIGN\"},{char:\"&#x20B0\",desc:\"GERMAN PENNY SYMBOL\"},{char:\"&#x20B1\",desc:\"PESO SIGN\"},{char:\"&#x20B2\",desc:\"GUARANI SIGN\"},{char:\"&#x20B3\",desc:\"AUSTRAL SIGN\"},{char:\"&#x20B4\",desc:\"HRYVNIA SIGN\"},{char:\"&#x20B5\",desc:\"CEDI SIGN\"},{char:\"&#x20B6\",desc:\"LIVRE TOURNOIS SIGN\"},{char:\"&#x20B7\",desc:\"SPESMILO SIGN\"},{char:\"&#x20B8\",desc:\"TENGE SIGN\"},{char:\"&#x20B9\",desc:\"INDIAN RUPEE SIGN\"}]},{title:\"Arrows\",list:[{char:\"&#x2190\",desc:\"LEFTWARDS ARROW\"},{char:\"&#x2191\",desc:\"UPWARDS ARROW\"},{char:\"&#x2192\",desc:\"RIGHTWARDS ARROW\"},{char:\"&#x2193\",desc:\"DOWNWARDS ARROW\"},{char:\"&#x2194\",desc:\"LEFT RIGHT ARROW\"},{char:\"&#x2195\",desc:\"UP DOWN ARROW\"},{char:\"&#x2196\",desc:\"NORTH WEST ARROW\"},{char:\"&#x2197\",desc:\"NORTH EAST ARROW\"},{char:\"&#x2198\",desc:\"SOUTH EAST ARROW\"},{char:\"&#x2199\",desc:\"SOUTH WEST ARROW\"},{char:\"&#x219A\",desc:\"LEFTWARDS ARROW WITH STROKE\"},{char:\"&#x219B\",desc:\"RIGHTWARDS ARROW WITH STROKE\"},{char:\"&#x219C\",desc:\"LEFTWARDS WAVE ARROW\"},{char:\"&#x219D\",desc:\"RIGHTWARDS WAVE ARROW\"},{char:\"&#x219E\",desc:\"LEFTWARDS TWO HEADED ARROW\"},{char:\"&#x219F\",desc:\"UPWARDS TWO HEADED ARROW\"},{char:\"&#x21A0\",desc:\"RIGHTWARDS TWO HEADED ARROW\"},{char:\"&#x21A1\",desc:\"DOWNWARDS TWO HEADED ARROW\"},{char:\"&#x21A2\",desc:\"LEFTWARDS ARROW WITH TAIL\"},{char:\"&#x21A3\",desc:\"RIGHTWARDS ARROW WITH TAIL\"},{char:\"&#x21A4\",desc:\"LEFTWARDS ARROW FROM BAR\"},{char:\"&#x21A5\",desc:\"UPWARDS ARROW FROM BAR\"},{char:\"&#x21A6\",desc:\"RIGHTWARDS ARROW FROM BAR\"},{char:\"&#x21A7\",desc:\"DOWNWARDS ARROW FROM BAR\"},{char:\"&#x21A8\",desc:\"UP DOWN ARROW WITH BASE\"},{char:\"&#x21A9\",desc:\"LEFTWARDS ARROW WITH HOOK\"},{char:\"&#x21AA\",desc:\"RIGHTWARDS ARROW WITH HOOK\"},{char:\"&#x21AB\",desc:\"LEFTWARDS ARROW WITH LOOP\"},{char:\"&#x21AC\",desc:\"RIGHTWARDS ARROW WITH LOOP\"},{char:\"&#x21AD\",desc:\"LEFT RIGHT WAVE ARROW\"},{char:\"&#x21AE\",desc:\"LEFT RIGHT ARROW WITH STROKE\"},{char:\"&#x21AF\",desc:\"DOWNWARDS ZIGZAG ARROW\"},{char:\"&#x21B0\",desc:\"UPWARDS ARROW WITH TIP LEFTWARDS\"},{char:\"&#x21B1\",desc:\"UPWARDS ARROW WITH TIP RIGHTWARDS\"},{char:\"&#x21B2\",desc:\"DOWNWARDS ARROW WITH TIP LEFTWARDS\"},{char:\"&#x21B3\",desc:\"DOWNWARDS ARROW WITH TIP RIGHTWARDS\"},{char:\"&#x21B4\",desc:\"RIGHTWARDS ARROW WITH CORNER DOWNWARDS\"},{char:\"&#x21B5\",desc:\"DOWNWARDS ARROW WITH CORNER LEFTWARDS\"},{char:\"&#x21B6\",desc:\"ANTICLOCKWISE TOP SEMICIRCLE ARROW\"},{char:\"&#x21B7\",desc:\"CLOCKWISE TOP SEMICIRCLE ARROW\"},{char:\"&#x21B8\",desc:\"NORTH WEST ARROW TO LONG BAR\"},{char:\"&#x21B9\",desc:\"LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR\"},{char:\"&#x21BA\",desc:\"ANTICLOCKWISE OPEN CIRCLE ARROW\"},{char:\"&#x21BB\",desc:\"CLOCKWISE OPEN CIRCLE ARROW\"},{char:\"&#x21BC\",desc:\"LEFTWARDS HARPOON WITH BARB UPWARDS\"},{char:\"&#x21BD\",desc:\"LEFTWARDS HARPOON WITH BARB DOWNWARDS\"},{char:\"&#x21BE\",desc:\"UPWARDS HARPOON WITH BARB RIGHTWARDS\"},{char:\"&#x21BF\",desc:\"UPWARDS HARPOON WITH BARB LEFTWARDS\"},{char:\"&#x21C0\",desc:\"RIGHTWARDS HARPOON WITH BARB UPWARDS\"},{char:\"&#x21C1\",desc:\"RIGHTWARDS HARPOON WITH BARB DOWNWARDS\"},{char:\"&#x21C2\",desc:\"DOWNWARDS HARPOON WITH BARB RIGHTWARDS\"},{char:\"&#x21C3\",desc:\"DOWNWARDS HARPOON WITH BARB LEFTWARDS\"},{char:\"&#x21C4\",desc:\"RIGHTWARDS ARROW OVER LEFTWARDS ARROW\"},{char:\"&#x21C5\",desc:\"UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW\"},{char:\"&#x21C6\",desc:\"LEFTWARDS ARROW OVER RIGHTWARDS ARROW\"},{char:\"&#x21C7\",desc:\"LEFTWARDS PAIRED ARROWS\"},{char:\"&#x21C8\",desc:\"UPWARDS PAIRED ARROWS\"},{char:\"&#x21C9\",desc:\"RIGHTWARDS PAIRED ARROWS\"},{char:\"&#x21CA\",desc:\"DOWNWARDS PAIRED ARROWS\"},{char:\"&#x21CB\",desc:\"LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON\"},{char:\"&#x21CC\",desc:\"RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON\"},{char:\"&#x21CD\",desc:\"LEFTWARDS DOUBLE ARROW WITH STROKE\"},{char:\"&#x21CE\",desc:\"LEFT RIGHT DOUBLE ARROW WITH STROKE\"},{char:\"&#x21CF\",desc:\"RIGHTWARDS DOUBLE ARROW WITH STROKE\"},{char:\"&#x21D0\",desc:\"LEFTWARDS DOUBLE ARROW\"},{char:\"&#x21D1\",desc:\"UPWARDS DOUBLE ARROW\"},{char:\"&#x21D2\",desc:\"RIGHTWARDS DOUBLE ARROW\"},{char:\"&#x21D3\",desc:\"DOWNWARDS DOUBLE ARROW\"},{char:\"&#x21D4\",desc:\"LEFT RIGHT DOUBLE ARROW\"},{char:\"&#x21D5\",desc:\"UP DOWN DOUBLE ARROW\"},{char:\"&#x21D6\",desc:\"NORTH WEST DOUBLE ARROW\"},{char:\"&#x21D7\",desc:\"NORTH EAST DOUBLE ARROW\"},{char:\"&#x21D8\",desc:\"SOUTH EAST DOUBLE ARROW\"},{char:\"&#x21D9\",desc:\"SOUTH WEST DOUBLE ARROW\"},{char:\"&#x21DA\",desc:\"LEFTWARDS TRIPLE ARROW\"},{char:\"&#x21DB\",desc:\"RIGHTWARDS TRIPLE ARROW\"},{char:\"&#x21DC\",desc:\"LEFTWARDS SQUIGGLE ARROW\"},{char:\"&#x21DD\",desc:\"RIGHTWARDS SQUIGGLE ARROW\"},{char:\"&#x21DE\",desc:\"UPWARDS ARROW WITH DOUBLE STROKE\"},{char:\"&#x21DF\",desc:\"DOWNWARDS ARROW WITH DOUBLE STROKE\"},{char:\"&#x21E0\",desc:\"LEFTWARDS DASHED ARROW\"},{char:\"&#x21E1\",desc:\"UPWARDS DASHED ARROW\"},{char:\"&#x21E2\",desc:\"RIGHTWARDS DASHED ARROW\"},{char:\"&#x21E3\",desc:\"DOWNWARDS DASHED ARROW\"},{char:\"&#x21E4\",desc:\"LEFTWARDS ARROW TO BAR\"},{char:\"&#x21E5\",desc:\"RIGHTWARDS ARROW TO BAR\"},{char:\"&#x21E6\",desc:\"LEFTWARDS WHITE ARROW\"},{char:\"&#x21E7\",desc:\"UPWARDS WHITE ARROW\"},{char:\"&#x21E8\",desc:\"RIGHTWARDS WHITE ARROW\"},{char:\"&#x21E9\",desc:\"DOWNWARDS WHITE ARROW\"},{char:\"&#x21EA\",desc:\"UPWARDS WHITE ARROW FROM BAR\"},{char:\"&#x21EB\",desc:\"UPWARDS WHITE ARROW ON PEDESTAL\"},{char:\"&#x21EC\",desc:\"UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR\"},{char:\"&#x21ED\",desc:\"UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR\"},{char:\"&#x21EE\",desc:\"UPWARDS WHITE DOUBLE ARROW\"},{char:\"&#x21EF\",desc:\"UPWARDS WHITE DOUBLE ARROW ON PEDESTAL\"},{char:\"&#x21F0\",desc:\"RIGHTWARDS WHITE ARROW FROM WALL\"},{char:\"&#x21F1\",desc:\"NORTH WEST ARROW TO CORNER\"},{char:\"&#x21F2\",desc:\"SOUTH EAST ARROW TO CORNER\"},{char:\"&#x21F3\",desc:\"UP DOWN WHITE ARROW\"},{char:\"&#x21F4\",desc:\"RIGHT ARROW WITH SMALL CIRCLE\"},{char:\"&#x21F5\",desc:\"DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW\"},{char:\"&#x21F6\",desc:\"THREE RIGHTWARDS ARROWS\"},{char:\"&#x21F7\",desc:\"LEFTWARDS ARROW WITH VERTICAL STROKE\"},{char:\"&#x21F8\",desc:\"RIGHTWARDS ARROW WITH VERTICAL STROKE\"},{char:\"&#x21F9\",desc:\"LEFT RIGHT ARROW WITH VERTICAL STROKE\"},{char:\"&#x21FA\",desc:\"LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE\"},{char:\"&#x21FB\",desc:\"RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE\"},{char:\"&#x21FC\",desc:\"LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE\"},{char:\"&#x21FD\",desc:\"LEFTWARDS OPEN-HEADED ARROW\"},{char:\"&#x21FE\",desc:\"RIGHTWARDS OPEN-HEADED ARROW\"},{char:\"&#x21FF\",desc:\"LEFT RIGHT OPEN-HEADED ARROW\"}]},{title:\"Math\",list:[{char:\"&forall;\",desc:\"FOR ALL\"},{char:\"&part;\",desc:\"PARTIAL DIFFERENTIAL\"},{char:\"&exist;\",desc:\"THERE EXISTS\"},{char:\"&empty;\",desc:\"EMPTY SET\"},{char:\"&nabla;\",desc:\"NABLA\"},{char:\"&isin;\",desc:\"ELEMENT OF\"},{char:\"&notin;\",desc:\"NOT AN ELEMENT OF\"},{char:\"&ni;\",desc:\"CONTAINS AS MEMBER\"},{char:\"&prod;\",desc:\"N-ARY PRODUCT\"},{char:\"&sum;\",desc:\"N-ARY SUMMATION\"},{char:\"&minus;\",desc:\"MINUS SIGN\"},{char:\"&lowast;\",desc:\"ASTERISK OPERATOR\"},{char:\"&radic;\",desc:\"SQUARE ROOT\"},{char:\"&prop;\",desc:\"PROPORTIONAL TO\"},{char:\"&infin;\",desc:\"INFINITY\"},{char:\"&ang;\",desc:\"ANGLE\"},{char:\"&and;\",desc:\"LOGICAL AND\"},{char:\"&or;\",desc:\"LOGICAL OR\"},{char:\"&cap;\",desc:\"INTERSECTION\"},{char:\"&cup;\",desc:\"UNION\"},{char:\"&int;\",desc:\"INTEGRAL\"},{char:\"&there4;\",desc:\"THEREFORE\"},{char:\"&sim;\",desc:\"TILDE OPERATOR\"},{char:\"&cong;\",desc:\"APPROXIMATELY EQUAL TO\"},{char:\"&asymp;\",desc:\"ALMOST EQUAL TO\"},{char:\"&ne;\",desc:\"NOT EQUAL TO\"},{char:\"&equiv;\",desc:\"IDENTICAL TO\"},{char:\"&le;\",desc:\"LESS-THAN OR EQUAL TO\"},{char:\"&ge;\",desc:\"GREATER-THAN OR EQUAL TO\"},{char:\"&sub;\",desc:\"SUBSET OF\"},{char:\"&sup;\",desc:\"SUPERSET OF\"},{char:\"&nsub;\",desc:\"NOT A SUBSET OF\"},{char:\"&sube;\",desc:\"SUBSET OF OR EQUAL TO\"},{char:\"&supe;\",desc:\"SUPERSET OF OR EQUAL TO\"},{char:\"&oplus;\",desc:\"CIRCLED PLUS\"},{char:\"&otimes;\",desc:\"CIRCLED TIMES\"},{char:\"&perp;\",desc:\"UP TACK\"}]},{title:\"Misc\",list:[{char:\"&spades;\",desc:\"BLACK SPADE SUIT\"},{char:\"&clubs;\",desc:\"BLACK CLUB SUIT\"},{char:\"&hearts;\",desc:\"BLACK HEART SUIT\"},{char:\"&diams;\",desc:\"BLACK DIAMOND SUIT\"},{char:\"&#x2669\",desc:\"QUARTER NOTE\"},{char:\"&#x266A\",desc:\"EIGHTH NOTE\"},{char:\"&#x266B\",desc:\"BEAMED EIGHTH NOTES\"},{char:\"&#x266C\",desc:\"BEAMED SIXTEENTH NOTES\"},{char:\"&#x266D\",desc:\"MUSIC FLAT SIGN\"},{char:\"&#x266E\",desc:\"MUSIC NATURAL SIGN\"},{char:\"&#x2600\",desc:\"BLACK SUN WITH RAYS\"},{char:\"&#x2601\",desc:\"CLOUD\"},{char:\"&#x2602\",desc:\"UMBRELLA\"},{char:\"&#x2603\",desc:\"SNOWMAN\"},{char:\"&#x2615\",desc:\"HOT BEVERAGE\"},{char:\"&#x2618\",desc:\"SHAMROCK\"},{char:\"&#x262F\",desc:\"YIN YANG\"},{char:\"&#x2714\",desc:\"HEAVY CHECK MARK\"},{char:\"&#x2716\",desc:\"HEAVY MULTIPLICATION X\"},{char:\"&#x2744\",desc:\"SNOWFLAKE\"},{char:\"&#x275B\",desc:\"HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT\"},{char:\"&#x275C\",desc:\"HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT\"},{char:\"&#x275D\",desc:\"HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT\"},{char:\"&#x275E\",desc:\"HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT\"},{char:\"&#x2764\",desc:\"HEAVY BLACK HEART\"}]}]}),a.FE.PLUGINS.specialCharacters=function(b){function c(){}function d(){for(var c='<div class=\"fr-special-characters-modal\">',d=0;d<a.FE.DEFAULTS.specialCharactersSets.length;d++){for(var e=a.FE.DEFAULTS.specialCharactersSets[d],f=e.list,g='<div class=\"fr-special-characters-list\"><p class=\"fr-special-characters-title\">'+b.language.translate(e.title)+\"</p>\",h=0;h<f.length;h++){var i=f[h];g+='<span class=\"fr-command fr-special-character\" tabIndex=\"-1\" role=\"button\" value=\"'+i.char+'\" title=\"'+i.desc+'\">'+i.char+'<span class=\"fr-sr-only\">'+b.language.translate(i.desc)+\"&nbsp;&nbsp;&nbsp;</span></span>\"}c+=g+\"</div>\"}return c+=\"</div>\"}function e(a,c){b.events.disableBlur(),a.focus(),c.preventDefault(),c.stopPropagation()}function f(){b.events.$on(l,\"keydown\",function(c){var d=c.which,f=l.find(\"span.fr-special-character:focus:first\");if(!(f.length||d!=a.FE.KEYCODE.F10||b.keys.ctrlKey(c)||c.shiftKey)&&c.altKey){return e(l.find(\"span.fr-special-character:first\"),c),!1}if(d==a.FE.KEYCODE.TAB||d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT){var g=null,h=null,i=!1;return d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT?(h=d==a.FE.KEYCODE.ARROW_RIGHT,i=!0):h=!c.shiftKey,f.length?(i&&(g=h?f.nextAll(\"span.fr-special-character:first\"):f.prevAll(\"span.fr-special-character:first\")),g&&g.length||(g=h?f.parent().next().find(\"span.fr-special-character:first\"):f.parent().prev().find(\"span.fr-special-character:\"+(i?\"last\":\"first\")),g.length||(g=l.find(\"span.fr-special-character:\"+(h?\"first\":\"last\"))))):g=l.find(\"span.fr-special-character:\"+(h?\"first\":\"last\")),e(g,c),!1}if(d!=a.FE.KEYCODE.ENTER||!f.length)return!0;(j.data(\"instance\")||b).specialCharacters.insert(f)},!0)}function g(){if(!j){var c=\"<h4>\"+b.language.translate(\"Special Characters\")+\"</h4>\",e=d(),g=b.modals.create(m,c,e);j=g.$modal,k=g.$head,l=g.$body,b.events.$on(a(b.o_win),\"resize\",function(){(j.data(\"instance\")||b).modals.resize(m)}),b.events.bindClick(l,\".fr-special-character\",function(c){var d=j.data(\"instance\")||b,e=a(c.currentTarget);d.specialCharacters.insert(e)}),f()}b.modals.show(m),b.modals.resize(m)}function h(){b.modals.hide(m)}function i(a){b.specialCharacters.hide(),b.undo.saveStep(),b.html.insert(a.attr(\"value\"),!0),b.undo.saveStep()}var j,k,l,m=\"special_characters\";return{_init:c,show:g,hide:h,insert:i}},a.FroalaEditor.DefineIcon(\"specialCharacters\",{template:\"text\",NAME:\"&#937;\"}),a.FE.RegisterCommand(\"specialCharacters\",{title:\"Special Characters\",icon:\"specialCharacters\",undo:!1,focus:!1,modal:!0,callback:function(){this.specialCharacters.show()},plugin:\"specialCharacters\",showOnMobile:!1})});"

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(191);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Alert = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'alert';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.alert';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Selector = {
    DISMISS: '[data-dismiss="alert"]'
  };

  var Event = {
    CLOSE: 'close' + EVENT_KEY,
    CLOSED: 'closed' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    ALERT: 'alert',
    FADE: 'fade',
    SHOW: 'show'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Alert = function () {
    function Alert(element) {
      _classCallCheck(this, Alert);

      this._element = element;
    }

    // getters

    _createClass(Alert, [{
      key: 'close',


      // public

      value: function close(element) {
        element = element || this._element;

        var rootElement = this._getRootElement(element);
        var customEvent = this._triggerCloseEvent(rootElement);

        if (customEvent.isDefaultPrevented()) {
          return;
        }

        this._removeElement(rootElement);
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        $.removeData(this._element, DATA_KEY);
        this._element = null;
      }

      // private

    }, {
      key: '_getRootElement',
      value: function _getRootElement(element) {
        var selector = _util2.default.getSelectorFromElement(element);
        var parent = false;

        if (selector) {
          parent = $(selector)[0];
        }

        if (!parent) {
          parent = $(element).closest('.' + ClassName.ALERT)[0];
        }

        return parent;
      }
    }, {
      key: '_triggerCloseEvent',
      value: function _triggerCloseEvent(element) {
        var closeEvent = $.Event(Event.CLOSE);

        $(element).trigger(closeEvent);
        return closeEvent;
      }
    }, {
      key: '_removeElement',
      value: function _removeElement(element) {
        var _this = this;

        $(element).removeClass(ClassName.SHOW);

        if (!_util2.default.supportsTransitionEnd() || !$(element).hasClass(ClassName.FADE)) {
          this._destroyElement(element);
          return;
        }

        $(element).one(_util2.default.TRANSITION_END, function (event) {
          return _this._destroyElement(element, event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      }
    }, {
      key: '_destroyElement',
      value: function _destroyElement(element) {
        $(element).detach().trigger(Event.CLOSED).remove();
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var $element = $(this);
          var data = $element.data(DATA_KEY);

          if (!data) {
            data = new Alert(this);
            $element.data(DATA_KEY, data);
          }

          if (config === 'close') {
            data[config](this);
          }
        });
      }
    }, {
      key: '_handleDismiss',
      value: function _handleDismiss(alertInstance) {
        return function (event) {
          if (event) {
            event.preventDefault();
          }

          alertInstance.close(this);
        };
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Alert;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Alert._jQueryInterface;
  $.fn[NAME].Constructor = Alert;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Alert._jQueryInterface;
  };

  return Alert;
}(jQuery);

exports.default = Alert;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Button = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'button';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.button';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var ClassName = {
    ACTIVE: 'active',
    BUTTON: 'btn',
    FOCUS: 'focus'
  };

  var Selector = {
    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
    DATA_TOGGLE: '[data-toggle="buttons"]',
    INPUT: 'input',
    ACTIVE: '.active',
    BUTTON: '.btn'
  };

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUS_BLUR_DATA_API: 'focus' + EVENT_KEY + DATA_API_KEY + ' ' + ('blur' + EVENT_KEY + DATA_API_KEY)

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Button = function () {
    function Button(element) {
      _classCallCheck(this, Button);

      this._element = element;
    }

    // getters

    _createClass(Button, [{
      key: 'toggle',


      // public

      value: function toggle() {
        var triggerChangeEvent = true;
        var rootElement = $(this._element).closest(Selector.DATA_TOGGLE)[0];

        if (rootElement) {
          var input = $(this._element).find(Selector.INPUT)[0];

          if (input) {
            if (input.type === 'radio') {
              if (input.checked && $(this._element).hasClass(ClassName.ACTIVE)) {
                triggerChangeEvent = false;
              } else {
                var activeElement = $(rootElement).find(Selector.ACTIVE)[0];

                if (activeElement) {
                  $(activeElement).removeClass(ClassName.ACTIVE);
                }
              }
            }

            if (triggerChangeEvent) {
              input.checked = !$(this._element).hasClass(ClassName.ACTIVE);
              $(input).trigger('change');
            }

            input.focus();
          }
        }

        this._element.setAttribute('aria-pressed', !$(this._element).hasClass(ClassName.ACTIVE));

        if (triggerChangeEvent) {
          $(this._element).toggleClass(ClassName.ACTIVE);
        }
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        $.removeData(this._element, DATA_KEY);
        this._element = null;
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var data = $(this).data(DATA_KEY);

          if (!data) {
            data = new Button(this);
            $(this).data(DATA_KEY, data);
          }

          if (config === 'toggle') {
            data[config]();
          }
        });
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Button;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    event.preventDefault();

    var button = event.target;

    if (!$(button).hasClass(ClassName.BUTTON)) {
      button = $(button).closest(Selector.BUTTON);
    }

    Button._jQueryInterface.call($(button), 'toggle');
  }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    var button = $(event.target).closest(Selector.BUTTON)[0];
    $(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Button._jQueryInterface;
  $.fn[NAME].Constructor = Button;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Button._jQueryInterface;
  };

  return Button;
}(jQuery);

exports.default = Button;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(191);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Collapse = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'collapse';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.collapse';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;

  var Default = {
    toggle: true,
    parent: ''
  };

  var DefaultType = {
    toggle: 'boolean',
    parent: 'string'
  };

  var Event = {
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };

  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };

  var Selector = {
    ACTIVES: '.card > .show, .card > .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Collapse = function () {
    function Collapse(element, config) {
      _classCallCheck(this, Collapse);

      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    }

    // getters

    _createClass(Collapse, [{
      key: 'toggle',


      // public

      value: function toggle() {
        if ($(this._element).hasClass(ClassName.SHOW)) {
          this.hide();
        } else {
          this.show();
        }
      }
    }, {
      key: 'show',
      value: function show() {
        var _this = this;

        if (this._isTransitioning) {
          throw new Error('Collapse is transitioning');
        }

        if ($(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var actives = void 0;
        var activesData = void 0;

        if (this._parent) {
          actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
          if (!actives.length) {
            actives = null;
          }
        }

        if (actives) {
          activesData = $(actives).data(DATA_KEY);
          if (activesData && activesData._isTransitioning) {
            return;
          }
        }

        var startEvent = $.Event(Event.SHOW);
        $(this._element).trigger(startEvent);
        if (startEvent.isDefaultPrevented()) {
          return;
        }

        if (actives) {
          Collapse._jQueryInterface.call($(actives), 'hide');
          if (!activesData) {
            $(actives).data(DATA_KEY, null);
          }
        }

        var dimension = this._getDimension();

        $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);

        this._element.style[dimension] = 0;
        this._element.setAttribute('aria-expanded', true);

        if (this._triggerArray.length) {
          $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
        }

        this.setTransitioning(true);

        var complete = function complete() {
          $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);

          _this._element.style[dimension] = '';

          _this.setTransitioning(false);

          $(_this._element).trigger(Event.SHOWN);
        };

        if (!_util2.default.supportsTransitionEnd()) {
          complete();
          return;
        }

        var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        var scrollSize = 'scroll' + capitalizedDimension;

        $(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);

        this._element.style[dimension] = this._element[scrollSize] + 'px';
      }
    }, {
      key: 'hide',
      value: function hide() {
        var _this2 = this;

        if (this._isTransitioning) {
          throw new Error('Collapse is transitioning');
        }

        if (!$(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var startEvent = $.Event(Event.HIDE);
        $(this._element).trigger(startEvent);
        if (startEvent.isDefaultPrevented()) {
          return;
        }

        var dimension = this._getDimension();
        var offsetDimension = dimension === Dimension.WIDTH ? 'offsetWidth' : 'offsetHeight';

        this._element.style[dimension] = this._element[offsetDimension] + 'px';

        _util2.default.reflow(this._element);

        $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

        this._element.setAttribute('aria-expanded', false);

        if (this._triggerArray.length) {
          $(this._triggerArray).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
        }

        this.setTransitioning(true);

        var complete = function complete() {
          _this2.setTransitioning(false);
          $(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
        };

        this._element.style[dimension] = '';

        if (!_util2.default.supportsTransitionEnd()) {
          complete();
          return;
        }

        $(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      }
    }, {
      key: 'setTransitioning',
      value: function setTransitioning(isTransitioning) {
        this._isTransitioning = isTransitioning;
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        $.removeData(this._element, DATA_KEY);

        this._config = null;
        this._parent = null;
        this._element = null;
        this._triggerArray = null;
        this._isTransitioning = null;
      }

      // private

    }, {
      key: '_getConfig',
      value: function _getConfig(config) {
        config = $.extend({}, Default, config);
        config.toggle = Boolean(config.toggle); // coerce string values
        _util2.default.typeCheckConfig(NAME, config, DefaultType);
        return config;
      }
    }, {
      key: '_getDimension',
      value: function _getDimension() {
        var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
        return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
      }
    }, {
      key: '_getParent',
      value: function _getParent() {
        var _this3 = this;

        var parent = $(this._config.parent)[0];
        var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';

        $(parent).find(selector).each(function (i, element) {
          _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
        });

        return parent;
      }
    }, {
      key: '_addAriaAndCollapsedClass',
      value: function _addAriaAndCollapsedClass(element, triggerArray) {
        if (element) {
          var isOpen = $(element).hasClass(ClassName.SHOW);
          element.setAttribute('aria-expanded', isOpen);

          if (triggerArray.length) {
            $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
          }
        }
      }

      // static

    }], [{
      key: '_getTargetFromElement',
      value: function _getTargetFromElement(element) {
        var selector = _util2.default.getSelectorFromElement(element);
        return selector ? $(selector)[0] : null;
      }
    }, {
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $(this);
          var data = $this.data(DATA_KEY);
          var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

          if (!data && _config.toggle && /show|hide/.test(config)) {
            _config.toggle = false;
          }

          if (!data) {
            data = new Collapse(this, _config);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config]();
          }
        });
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Collapse;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();

    var target = Collapse._getTargetFromElement(this);
    var data = $(target).data(DATA_KEY);
    var config = data ? 'toggle' : $(this).data();

    Collapse._jQueryInterface.call($(target), config);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;
}(jQuery);

exports.default = Collapse;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(191);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Dropdown = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'dropdown';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.dropdown';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUSIN_DATA_API: 'focusin' + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    BACKDROP: 'dropdown-backdrop',
    DISABLED: 'disabled',
    SHOW: 'show'
  };

  var Selector = {
    BACKDROP: '.dropdown-backdrop',
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    ROLE_MENU: '[role="menu"]',
    ROLE_LISTBOX: '[role="listbox"]',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, ' + '[role="listbox"] li:not(.disabled) a'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Dropdown = function () {
    function Dropdown(element) {
      _classCallCheck(this, Dropdown);

      this._element = element;

      this._addEventListeners();
    }

    // getters

    _createClass(Dropdown, [{
      key: 'toggle',


      // public

      value: function toggle() {
        if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
          return false;
        }

        var parent = Dropdown._getParentFromElement(this);
        var isActive = $(parent).hasClass(ClassName.SHOW);

        Dropdown._clearMenus();

        if (isActive) {
          return false;
        }

        if ('ontouchstart' in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {

          // if mobile we use a backdrop because click events don't delegate
          var dropdown = document.createElement('div');
          dropdown.className = ClassName.BACKDROP;
          $(dropdown).insertBefore(this);
          $(dropdown).on('click', Dropdown._clearMenus);
        }

        var relatedTarget = {
          relatedTarget: this
        };
        var showEvent = $.Event(Event.SHOW, relatedTarget);

        $(parent).trigger(showEvent);

        if (showEvent.isDefaultPrevented()) {
          return false;
        }

        this.focus();
        this.setAttribute('aria-expanded', true);

        $(parent).toggleClass(ClassName.SHOW);
        $(parent).trigger($.Event(Event.SHOWN, relatedTarget));

        return false;
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        $.removeData(this._element, DATA_KEY);
        $(this._element).off(EVENT_KEY);
        this._element = null;
      }

      // private

    }, {
      key: '_addEventListeners',
      value: function _addEventListeners() {
        $(this._element).on(Event.CLICK, this.toggle);
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var data = $(this).data(DATA_KEY);

          if (!data) {
            data = new Dropdown(this);
            $(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config].call(this);
          }
        });
      }
    }, {
      key: '_clearMenus',
      value: function _clearMenus(event) {
        if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
          return;
        }

        var backdrop = $(Selector.BACKDROP)[0];
        if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
        }

        var toggles = $.makeArray($(Selector.DATA_TOGGLE));

        for (var i = 0; i < toggles.length; i++) {
          var parent = Dropdown._getParentFromElement(toggles[i]);
          var relatedTarget = {
            relatedTarget: toggles[i]
          };

          if (!$(parent).hasClass(ClassName.SHOW)) {
            continue;
          }

          if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'focusin') && $.contains(parent, event.target)) {
            continue;
          }

          var hideEvent = $.Event(Event.HIDE, relatedTarget);
          $(parent).trigger(hideEvent);
          if (hideEvent.isDefaultPrevented()) {
            continue;
          }

          toggles[i].setAttribute('aria-expanded', 'false');

          $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
        }
      }
    }, {
      key: '_getParentFromElement',
      value: function _getParentFromElement(element) {
        var parent = void 0;
        var selector = _util2.default.getSelectorFromElement(element);

        if (selector) {
          parent = $(selector)[0];
        }

        return parent || element.parentNode;
      }
    }, {
      key: '_dataApiKeydownHandler',
      value: function _dataApiKeydownHandler(event) {
        if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
          return;
        }

        var parent = Dropdown._getParentFromElement(this);
        var isActive = $(parent).hasClass(ClassName.SHOW);

        if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {

          if (event.which === ESCAPE_KEYCODE) {
            var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
            $(toggle).trigger('focus');
          }

          $(this).trigger('click');
          return;
        }

        var items = $(parent).find(Selector.VISIBLE_ITEMS).get();

        if (!items.length) {
          return;
        }

        var index = items.indexOf(event.target);

        if (event.which === ARROW_UP_KEYCODE && index > 0) {
          // up
          index--;
        }

        if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
          // down
          index++;
        }

        if (index < 0) {
          index = 0;
        }

        items[index].focus();
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Dropdown;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.FOCUSIN_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
    e.stopPropagation();
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Dropdown._jQueryInterface;
  $.fn[NAME].Constructor = Dropdown;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Dropdown._jQueryInterface;
  };

  return Dropdown;
}(jQuery);

exports.default = Dropdown;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tooltip = __webpack_require__(895);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Popover = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'popover';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.popover';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Default = $.extend({}, _tooltip2.default.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<h3 class="popover-title"></h3>' + '<div class="popover-content"></div></div>'
  });

  var DefaultType = $.extend({}, _tooltip2.default.DefaultType, {
    content: '(string|element|function)'
  });

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TITLE: '.popover-title',
    CONTENT: '.popover-content'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Popover = function (_Tooltip) {
    _inherits(Popover, _Tooltip);

    function Popover() {
      _classCallCheck(this, Popover);

      return _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
    }

    _createClass(Popover, [{
      key: 'isWithContent',


      // overrides

      value: function isWithContent() {
        return this.getTitle() || this._getContent();
      }
    }, {
      key: 'getTipElement',
      value: function getTipElement() {
        return this.tip = this.tip || $(this.config.template)[0];
      }
    }, {
      key: 'setContent',
      value: function setContent() {
        var $tip = $(this.getTipElement());

        // we use append for html objects to maintain js events
        this.setElementContent($tip.find(Selector.TITLE), this.getTitle());
        this.setElementContent($tip.find(Selector.CONTENT), this._getContent());

        $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

        this.cleanupTether();
      }

      // private

    }, {
      key: '_getContent',
      value: function _getContent() {
        return this.element.getAttribute('data-content') || (typeof this.config.content === 'function' ? this.config.content.call(this.element) : this.config.content);
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var data = $(this).data(DATA_KEY);
          var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

          if (!data && /destroy|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Popover(this, _config);
            $(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config]();
          }
        });
      }
    }, {
      key: 'VERSION',


      // getters

      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Popover;
  }(_tooltip2.default);

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Popover._jQueryInterface;
  $.fn[NAME].Constructor = Popover;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Popover._jQueryInterface;
  };

  return Popover;
}(jQuery);

exports.default = Popover;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(191);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tab = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tab';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tab';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    A: 'a',
    LI: 'li',
    DROPDOWN: '.dropdown',
    LIST: 'ul:not(.dropdown-menu), ol:not(.dropdown-menu), nav:not(.dropdown-menu)',
    FADE_CHILD: '> .nav-item .fade, > .fade',
    ACTIVE: '.active',
    ACTIVE_CHILD: '> .nav-item > .active, > .active',
    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"]',
    DROPDOWN_TOGGLE: '.dropdown-toggle',
    DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };
  var Tab = function () {
    function Tab(element) {
      _classCallCheck(this, Tab);

      this._element = element;
    }

    // getters

    _createClass(Tab, [{
      key: 'show',


      // public

      value: function show() {
        var _this = this;

        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName.ACTIVE) || $(this._element).hasClass(ClassName.DISABLED)) {
          return;
        }

        var target = void 0;
        var previous = void 0;
        var listElement = $(this._element).closest(Selector.LIST)[0];
        var selector = _util2.default.getSelectorFromElement(this._element);

        if (listElement) {
          previous = $.makeArray($(listElement).find(Selector.ACTIVE));
          previous = previous[previous.length - 1];
        }

        var hideEvent = $.Event(Event.HIDE, {
          relatedTarget: this._element
        });

        var showEvent = $.Event(Event.SHOW, {
          relatedTarget: previous
        });

        if (previous) {
          $(previous).trigger(hideEvent);
        }

        $(this._element).trigger(showEvent);

        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
          return;
        }

        if (selector) {
          target = $(selector)[0];
        }

        this._activate(this._element, listElement);

        var complete = function complete() {
          var hiddenEvent = $.Event(Event.HIDDEN, {
            relatedTarget: _this._element
          });

          var shownEvent = $.Event(Event.SHOWN, {
            relatedTarget: previous
          });

          $(previous).trigger(hiddenEvent);
          $(_this._element).trigger(shownEvent);
        };

        if (target) {
          this._activate(target, target.parentNode, complete);
        } else {
          complete();
        }
      }
    }, {
      key: 'dispose',
      value: function dispose() {
        $.removeClass(this._element, DATA_KEY);
        this._element = null;
      }

      // private

    }, {
      key: '_activate',
      value: function _activate(element, container, callback) {
        var _this2 = this;

        var active = $(container).find(Selector.ACTIVE_CHILD)[0];
        var isTransitioning = callback && _util2.default.supportsTransitionEnd() && (active && $(active).hasClass(ClassName.FADE) || Boolean($(container).find(Selector.FADE_CHILD)[0]));

        var complete = function complete() {
          return _this2._transitionComplete(element, active, isTransitioning, callback);
        };

        if (active && isTransitioning) {
          $(active).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
        } else {
          complete();
        }

        if (active) {
          $(active).removeClass(ClassName.SHOW);
        }
      }
    }, {
      key: '_transitionComplete',
      value: function _transitionComplete(element, active, isTransitioning, callback) {
        if (active) {
          $(active).removeClass(ClassName.ACTIVE);

          var dropdownChild = $(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

          if (dropdownChild) {
            $(dropdownChild).removeClass(ClassName.ACTIVE);
          }

          active.setAttribute('aria-expanded', false);
        }

        $(element).addClass(ClassName.ACTIVE);
        element.setAttribute('aria-expanded', true);

        if (isTransitioning) {
          _util2.default.reflow(element);
          $(element).addClass(ClassName.SHOW);
        } else {
          $(element).removeClass(ClassName.FADE);
        }

        if (element.parentNode && $(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {

          var dropdownElement = $(element).closest(Selector.DROPDOWN)[0];
          if (dropdownElement) {
            $(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
          }

          element.setAttribute('aria-expanded', true);
        }

        if (callback) {
          callback();
        }
      }

      // static

    }], [{
      key: '_jQueryInterface',
      value: function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $(this);
          var data = $this.data(DATA_KEY);

          if (!data) {
            data = new Tab(this);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config]();
          }
        });
      }
    }, {
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Tab;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    Tab._jQueryInterface.call($(this), 'show');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tab._jQueryInterface;
  $.fn[NAME].Constructor = Tab;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tab._jQueryInterface;
  };

  return Tab;
}(jQuery);

exports.default = Tab;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Date picker for pickadate.js v3.5.6
 * http://amsul.github.io/pickadate.js/date.htm
 */

(function ( factory ) {

    // AMD.
    if ( true )
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(896), __webpack_require__(137)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

    // Node.js/browserify.
    else if ( typeof exports == 'object' )
        module.exports = factory( require('./picker.js'), require('jquery') )

    // Browser globals.
    else factory( Picker, jQuery )

}(function( Picker, $ ) {


/**
 * Globals and constants
 */
var DAYS_IN_WEEK = 7,
    WEEKS_IN_CALENDAR = 6,
    _ = Picker._



/**
 * The date picker constructor
 */
function DatePicker( picker, settings ) {

    var calendar = this,
        element = picker.$node[ 0 ],
        elementValue = element.value,
        elementDataValue = picker.$node.data( 'value' ),
        valueString = elementDataValue || elementValue,
        formatString = elementDataValue ? settings.formatSubmit : settings.format,
        isRTL = function() {

            return element.currentStyle ?

                // For IE.
                element.currentStyle.direction == 'rtl' :

                // For normal browsers.
                getComputedStyle( picker.$root[0] ).direction == 'rtl'
        }

    calendar.settings = settings
    calendar.$node = picker.$node

    // The queue of methods that will be used to build item objects.
    calendar.queue = {
        min: 'measure create',
        max: 'measure create',
        now: 'now create',
        select: 'parse create validate',
        highlight: 'parse navigate create validate',
        view: 'parse create validate viewset',
        disable: 'deactivate',
        enable: 'activate'
    }

    // The component's item object.
    calendar.item = {}

    calendar.item.clear = null
    calendar.item.disable = ( settings.disable || [] ).slice( 0 )
    calendar.item.enable = -(function( collectionDisabled ) {
        return collectionDisabled[ 0 ] === true ? collectionDisabled.shift() : -1
    })( calendar.item.disable )

    calendar.
        set( 'min', settings.min ).
        set( 'max', settings.max ).
        set( 'now' )

    // When there’s a value, set the `select`, which in turn
    // also sets the `highlight` and `view`.
    if ( valueString ) {
        calendar.set( 'select', valueString, {
            format: formatString,
            defaultValue: true
        })
    }

    // If there’s no value, default to highlighting “today”.
    else {
        calendar.
            set( 'select', null ).
            set( 'highlight', calendar.item.now )
    }


    // The keycode to movement mapping.
    calendar.key = {
        40: 7, // Down
        38: -7, // Up
        39: function() { return isRTL() ? -1 : 1 }, // Right
        37: function() { return isRTL() ? 1 : -1 }, // Left
        go: function( timeChange ) {
            var highlightedObject = calendar.item.highlight,
                targetDate = new Date( highlightedObject.year, highlightedObject.month, highlightedObject.date + timeChange )
            calendar.set(
                'highlight',
                targetDate,
                { interval: timeChange }
            )
            this.render()
        }
    }


    // Bind some picker events.
    picker.
        on( 'render', function() {
            picker.$root.find( '.' + settings.klass.selectMonth ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ picker.get( 'view' ).year, value, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectMonth ).trigger( 'focus' )
                }
            })
            picker.$root.find( '.' + settings.klass.selectYear ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ value, picker.get( 'view' ).month, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectYear ).trigger( 'focus' )
                }
            })
        }, 1 ).
        on( 'open', function() {
            var includeToday = ''
            if ( calendar.disabled( calendar.get('now') ) ) {
                includeToday = ':not(.' + settings.klass.buttonToday + ')'
            }
            picker.$root.find( 'button' + includeToday + ', select' ).attr( 'disabled', false )
        }, 1 ).
        on( 'close', function() {
            picker.$root.find( 'button, select' ).attr( 'disabled', true )
        }, 1 )

} //DatePicker


/**
 * Set a datepicker item object.
 */
DatePicker.prototype.set = function( type, value, options ) {

    var calendar = this,
        calendarItem = calendar.item

    // If the value is `null` just set it immediately.
    if ( value === null ) {
        if ( type == 'clear' ) type = 'select'
        calendarItem[ type ] = value
        return calendar
    }

    // Otherwise go through the queue of methods, and invoke the functions.
    // Update this as the time unit, and set the final value as this item.
    // * In the case of `enable`, keep the queue but set `disable` instead.
    //   And in the case of `flip`, keep the queue but set `enable` instead.
    calendarItem[ ( type == 'enable' ? 'disable' : type == 'flip' ? 'enable' : type ) ] = calendar.queue[ type ].split( ' ' ).map( function( method ) {
        value = calendar[ method ]( type, value, options )
        return value
    }).pop()

    // Check if we need to cascade through more updates.
    if ( type == 'select' ) {
        calendar.set( 'highlight', calendarItem.select, options )
    }
    else if ( type == 'highlight' ) {
        calendar.set( 'view', calendarItem.highlight, options )
    }
    else if ( type.match( /^(flip|min|max|disable|enable)$/ ) ) {
        if ( calendarItem.select && calendar.disabled( calendarItem.select ) ) {
            calendar.set( 'select', calendarItem.select, options )
        }
        if ( calendarItem.highlight && calendar.disabled( calendarItem.highlight ) ) {
            calendar.set( 'highlight', calendarItem.highlight, options )
        }
    }

    return calendar
} //DatePicker.prototype.set


/**
 * Get a datepicker item object.
 */
DatePicker.prototype.get = function( type ) {
    return this.item[ type ]
} //DatePicker.prototype.get


/**
 * Create a picker date object.
 */
DatePicker.prototype.create = function( type, value, options ) {

    var isInfiniteValue,
        calendar = this

    // If there’s no value, use the type as the value.
    value = value === undefined ? type : value


    // If it’s infinity, update the value.
    if ( value == -Infinity || value == Infinity ) {
        isInfiniteValue = value
    }

    // If it’s an object, use the native date object.
    else if ( $.isPlainObject( value ) && _.isInteger( value.pick ) ) {
        value = value.obj
    }

    // If it’s an array, convert it into a date and make sure
    // that it’s a valid date – otherwise default to today.
    else if ( $.isArray( value ) ) {
        value = new Date( value[ 0 ], value[ 1 ], value[ 2 ] )
        value = _.isDate( value ) ? value : calendar.create().obj
    }

    // If it’s a number or date object, make a normalized date.
    else if ( _.isInteger( value ) || _.isDate( value ) ) {
        value = calendar.normalize( new Date( value ), options )
    }

    // If it’s a literal true or any other case, set it to now.
    else /*if ( value === true )*/ {
        value = calendar.now( type, value, options )
    }

    // Return the compiled object.
    return {
        year: isInfiniteValue || value.getFullYear(),
        month: isInfiniteValue || value.getMonth(),
        date: isInfiniteValue || value.getDate(),
        day: isInfiniteValue || value.getDay(),
        obj: isInfiniteValue || value,
        pick: isInfiniteValue || value.getTime()
    }
} //DatePicker.prototype.create


/**
 * Create a range limit object using an array, date object,
 * literal “true”, or integer relative to another time.
 */
DatePicker.prototype.createRange = function( from, to ) {

    var calendar = this,
        createDate = function( date ) {
            if ( date === true || $.isArray( date ) || _.isDate( date ) ) {
                return calendar.create( date )
            }
            return date
        }

    // Create objects if possible.
    if ( !_.isInteger( from ) ) {
        from = createDate( from )
    }
    if ( !_.isInteger( to ) ) {
        to = createDate( to )
    }

    // Create relative dates.
    if ( _.isInteger( from ) && $.isPlainObject( to ) ) {
        from = [ to.year, to.month, to.date + from ];
    }
    else if ( _.isInteger( to ) && $.isPlainObject( from ) ) {
        to = [ from.year, from.month, from.date + to ];
    }

    return {
        from: createDate( from ),
        to: createDate( to )
    }
} //DatePicker.prototype.createRange


/**
 * Check if a date unit falls within a date range object.
 */
DatePicker.prototype.withinRange = function( range, dateUnit ) {
    range = this.createRange(range.from, range.to)
    return dateUnit.pick >= range.from.pick && dateUnit.pick <= range.to.pick
}


/**
 * Check if two date range objects overlap.
 */
DatePicker.prototype.overlapRanges = function( one, two ) {

    var calendar = this

    // Convert the ranges into comparable dates.
    one = calendar.createRange( one.from, one.to )
    two = calendar.createRange( two.from, two.to )

    return calendar.withinRange( one, two.from ) || calendar.withinRange( one, two.to ) ||
        calendar.withinRange( two, one.from ) || calendar.withinRange( two, one.to )
}


/**
 * Get the date today.
 */
DatePicker.prototype.now = function( type, value, options ) {
    value = new Date()
    if ( options && options.rel ) {
        value.setDate( value.getDate() + options.rel )
    }
    return this.normalize( value, options )
}


/**
 * Navigate to next/prev month.
 */
DatePicker.prototype.navigate = function( type, value, options ) {

    var targetDateObject,
        targetYear,
        targetMonth,
        targetDate,
        isTargetArray = $.isArray( value ),
        isTargetObject = $.isPlainObject( value ),
        viewsetObject = this.item.view/*,
        safety = 100*/


    if ( isTargetArray || isTargetObject ) {

        if ( isTargetObject ) {
            targetYear = value.year
            targetMonth = value.month
            targetDate = value.date
        }
        else {
            targetYear = +value[0]
            targetMonth = +value[1]
            targetDate = +value[2]
        }

        // If we’re navigating months but the view is in a different
        // month, navigate to the view’s year and month.
        if ( options && options.nav && viewsetObject && viewsetObject.month !== targetMonth ) {
            targetYear = viewsetObject.year
            targetMonth = viewsetObject.month
        }

        // Figure out the expected target year and month.
        targetDateObject = new Date( targetYear, targetMonth + ( options && options.nav ? options.nav : 0 ), 1 )
        targetYear = targetDateObject.getFullYear()
        targetMonth = targetDateObject.getMonth()

        // If the month we’re going to doesn’t have enough days,
        // keep decreasing the date until we reach the month’s last date.
        while ( /*safety &&*/ new Date( targetYear, targetMonth, targetDate ).getMonth() !== targetMonth ) {
            targetDate -= 1
            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while navigating to ' + new Date( targetYear, targetMonth, targetDate ) + '.'
            }*/
        }

        value = [ targetYear, targetMonth, targetDate ]
    }

    return value
} //DatePicker.prototype.navigate


/**
 * Normalize a date by setting the hours to midnight.
 */
DatePicker.prototype.normalize = function( value/*, options*/ ) {
    value.setHours( 0, 0, 0, 0 )
    return value
}


/**
 * Measure the range of dates.
 */
DatePicker.prototype.measure = function( type, value/*, options*/ ) {

    var calendar = this
    
    // If it's an integer, get a date relative to today.
    if ( _.isInteger( value ) ) {
        value = calendar.now( type, value, { rel: value } )
    }

    // If it’s anything false-y, remove the limits.
    else if ( !value ) {
        value = type == 'min' ? -Infinity : Infinity
    }

    // If it’s a string, parse it.
    else if ( typeof value == 'string' ) {
        value = calendar.parse( type, value )
    }

    return value
} ///DatePicker.prototype.measure


/**
 * Create a viewset object based on navigation.
 */
DatePicker.prototype.viewset = function( type, dateObject/*, options*/ ) {
    return this.create([ dateObject.year, dateObject.month, 1 ])
}


/**
 * Validate a date as enabled and shift if needed.
 */
DatePicker.prototype.validate = function( type, dateObject, options ) {

    var calendar = this,

        // Keep a reference to the original date.
        originalDateObject = dateObject,

        // Make sure we have an interval.
        interval = options && options.interval ? options.interval : 1,

        // Check if the calendar enabled dates are inverted.
        isFlippedBase = calendar.item.enable === -1,

        // Check if we have any enabled dates after/before now.
        hasEnabledBeforeTarget, hasEnabledAfterTarget,

        // The min & max limits.
        minLimitObject = calendar.item.min,
        maxLimitObject = calendar.item.max,

        // Check if we’ve reached the limit during shifting.
        reachedMin, reachedMax,

        // Check if the calendar is inverted and at least one weekday is enabled.
        hasEnabledWeekdays = isFlippedBase && calendar.item.disable.filter( function( value ) {

            // If there’s a date, check where it is relative to the target.
            if ( $.isArray( value ) ) {
                var dateTime = calendar.create( value ).pick
                if ( dateTime < dateObject.pick ) hasEnabledBeforeTarget = true
                else if ( dateTime > dateObject.pick ) hasEnabledAfterTarget = true
            }

            // Return only integers for enabled weekdays.
            return _.isInteger( value )
        }).length/*,
        safety = 100*/



    // Cases to validate for:
    // [1] Not inverted and date disabled.
    // [2] Inverted and some dates enabled.
    // [3] Not inverted and out of range.
    //
    // Cases to **not** validate for:
    // • Navigating months.
    // • Not inverted and date enabled.
    // • Inverted and all dates disabled.
    // • ..and anything else.
    if ( !options || (!options.nav && !options.defaultValue) ) if (
        /* 1 */ ( !isFlippedBase && calendar.disabled( dateObject ) ) ||
        /* 2 */ ( isFlippedBase && calendar.disabled( dateObject ) && ( hasEnabledWeekdays || hasEnabledBeforeTarget || hasEnabledAfterTarget ) ) ||
        /* 3 */ ( !isFlippedBase && (dateObject.pick <= minLimitObject.pick || dateObject.pick >= maxLimitObject.pick) )
    ) {


        // When inverted, flip the direction if there aren’t any enabled weekdays
        // and there are no enabled dates in the direction of the interval.
        if ( isFlippedBase && !hasEnabledWeekdays && ( ( !hasEnabledAfterTarget && interval > 0 ) || ( !hasEnabledBeforeTarget && interval < 0 ) ) ) {
            interval *= -1
        }


        // Keep looping until we reach an enabled date.
        while ( /*safety &&*/ calendar.disabled( dateObject ) ) {

            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while validating ' + dateObject.obj + '.'
            }*/


            // If we’ve looped into the next/prev month with a large interval, return to the original date and flatten the interval.
            if ( Math.abs( interval ) > 1 && ( dateObject.month < originalDateObject.month || dateObject.month > originalDateObject.month ) ) {
                dateObject = originalDateObject
                interval = interval > 0 ? 1 : -1
            }


            // If we’ve reached the min/max limit, reverse the direction, flatten the interval and set it to the limit.
            if ( dateObject.pick <= minLimitObject.pick ) {
                reachedMin = true
                interval = 1
                dateObject = calendar.create([
                    minLimitObject.year,
                    minLimitObject.month,
                    minLimitObject.date + (dateObject.pick === minLimitObject.pick ? 0 : -1)
                ])
            }
            else if ( dateObject.pick >= maxLimitObject.pick ) {
                reachedMax = true
                interval = -1
                dateObject = calendar.create([
                    maxLimitObject.year,
                    maxLimitObject.month,
                    maxLimitObject.date + (dateObject.pick === maxLimitObject.pick ? 0 : 1)
                ])
            }


            // If we’ve reached both limits, just break out of the loop.
            if ( reachedMin && reachedMax ) {
                break
            }


            // Finally, create the shifted date using the interval and keep looping.
            dateObject = calendar.create([ dateObject.year, dateObject.month, dateObject.date + interval ])
        }

    } //endif


    // Return the date object settled on.
    return dateObject
} //DatePicker.prototype.validate


/**
 * Check if a date is disabled.
 */
DatePicker.prototype.disabled = function( dateToVerify ) {

    var
        calendar = this,

        // Filter through the disabled dates to check if this is one.
        isDisabledMatch = calendar.item.disable.filter( function( dateToDisable ) {

            // If the date is a number, match the weekday with 0index and `firstDay` check.
            if ( _.isInteger( dateToDisable ) ) {
                return dateToVerify.day === ( calendar.settings.firstDay ? dateToDisable : dateToDisable - 1 ) % 7
            }

            // If it’s an array or a native JS date, create and match the exact date.
            if ( $.isArray( dateToDisable ) || _.isDate( dateToDisable ) ) {
                return dateToVerify.pick === calendar.create( dateToDisable ).pick
            }

            // If it’s an object, match a date within the “from” and “to” range.
            if ( $.isPlainObject( dateToDisable ) ) {
                return calendar.withinRange( dateToDisable, dateToVerify )
            }
        })

    // If this date matches a disabled date, confirm it’s not inverted.
    isDisabledMatch = isDisabledMatch.length && !isDisabledMatch.filter(function( dateToDisable ) {
        return $.isArray( dateToDisable ) && dateToDisable[3] == 'inverted' ||
            $.isPlainObject( dateToDisable ) && dateToDisable.inverted
    }).length

    // Check the calendar “enabled” flag and respectively flip the
    // disabled state. Then also check if it’s beyond the min/max limits.
    return calendar.item.enable === -1 ? !isDisabledMatch : isDisabledMatch ||
        dateToVerify.pick < calendar.item.min.pick ||
        dateToVerify.pick > calendar.item.max.pick

} //DatePicker.prototype.disabled


/**
 * Parse a string into a usable type.
 */
DatePicker.prototype.parse = function( type, value, options ) {

    var calendar = this,
        parsingObject = {}

    // If it’s already parsed, we’re good.
    if ( !value || typeof value != 'string' ) {
        return value
    }

    // We need a `.format` to parse the value with.
    if ( !( options && options.format ) ) {
        options = options || {}
        options.format = calendar.settings.format
    }

    // Convert the format into an array and then map through it.
    calendar.formats.toArray( options.format ).map( function( label ) {

        var
            // Grab the formatting label.
            formattingLabel = calendar.formats[ label ],

            // The format length is from the formatting label function or the
            // label length without the escaping exclamation (!) mark.
            formatLength = formattingLabel ? _.trigger( formattingLabel, calendar, [ value, parsingObject ] ) : label.replace( /^!/, '' ).length

        // If there's a format label, split the value up to the format length.
        // Then add it to the parsing object with appropriate label.
        if ( formattingLabel ) {
            parsingObject[ label ] = value.substr( 0, formatLength )
        }

        // Update the value as the substring from format length to end.
        value = value.substr( formatLength )
    })

    // Compensate for month 0index.
    return [
        parsingObject.yyyy || parsingObject.yy,
        +( parsingObject.mm || parsingObject.m ) - 1,
        parsingObject.dd || parsingObject.d
    ]
} //DatePicker.prototype.parse


/**
 * Various formats to display the object in.
 */
DatePicker.prototype.formats = (function() {

    // Return the length of the first word in a collection.
    function getWordLengthFromCollection( string, collection, dateObject ) {

        // Grab the first word from the string.
        // Regex pattern from http://stackoverflow.com/q/150033
        var word = string.match( /[^\x00-\x7F]+|\w+/ )[ 0 ]

        // If there's no month index, add it to the date object
        if ( !dateObject.mm && !dateObject.m ) {
            dateObject.m = collection.indexOf( word ) + 1
        }

        // Return the length of the word.
        return word.length
    }

    // Get the length of the first word in a string.
    function getFirstWordLength( string ) {
        return string.match( /\w+/ )[ 0 ].length
    }

    return {

        d: function( string, dateObject ) {

            // If there's string, then get the digits length.
            // Otherwise return the selected date.
            return string ? _.digits( string ) : dateObject.date
        },
        dd: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected date with a leading zero.
            return string ? 2 : _.lead( dateObject.date )
        },
        ddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the short selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysShort[ dateObject.day ]
        },
        dddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the full selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysFull[ dateObject.day ]
        },
        m: function( string, dateObject ) {

            // If there's a string, then get the length of the digits
            // Otherwise return the selected month with 0index compensation.
            return string ? _.digits( string ) : dateObject.month + 1
        },
        mm: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected month with 0index and leading zero.
            return string ? 2 : _.lead( dateObject.month + 1 )
        },
        mmm: function( string, dateObject ) {

            var collection = this.settings.monthsShort

            // If there's a string, get length of the relevant month from the short
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        mmmm: function( string, dateObject ) {

            var collection = this.settings.monthsFull

            // If there's a string, get length of the relevant month from the full
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        yy: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected year by slicing out the first 2 digits.
            return string ? 2 : ( '' + dateObject.year ).slice( 2 )
        },
        yyyy: function( string, dateObject ) {

            // If there's a string, then the length is always 4.
            // Otherwise return the selected year.
            return string ? 4 : dateObject.year
        },

        // Create an array by splitting the formatting string passed.
        toArray: function( formatString ) { return formatString.split( /(d{1,4}|m{1,4}|y{4}|yy|!.)/g ) },

        // Format an object into a string using the formatting options.
        toString: function ( formatString, itemObject ) {
            var calendar = this
            return calendar.formats.toArray( formatString ).map( function( label ) {
                return _.trigger( calendar.formats[ label ], calendar, [ 0, itemObject ] ) || label.replace( /^!/, '' )
            }).join( '' )
        }
    }
})() //DatePicker.prototype.formats




/**
 * Check if two date units are the exact.
 */
DatePicker.prototype.isDateExact = function( one, two ) {

    var calendar = this

    // When we’re working with weekdays, do a direct comparison.
    if (
        ( _.isInteger( one ) && _.isInteger( two ) ) ||
        ( typeof one == 'boolean' && typeof two == 'boolean' )
     ) {
        return one === two
    }

    // When we’re working with date representations, compare the “pick” value.
    if (
        ( _.isDate( one ) || $.isArray( one ) ) &&
        ( _.isDate( two ) || $.isArray( two ) )
    ) {
        return calendar.create( one ).pick === calendar.create( two ).pick
    }

    // When we’re working with range objects, compare the “from” and “to”.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.isDateExact( one.from, two.from ) && calendar.isDateExact( one.to, two.to )
    }

    return false
}


/**
 * Check if two date units overlap.
 */
DatePicker.prototype.isDateOverlap = function( one, two ) {

    var calendar = this,
        firstDay = calendar.settings.firstDay ? 1 : 0

    // When we’re working with a weekday index, compare the days.
    if ( _.isInteger( one ) && ( _.isDate( two ) || $.isArray( two ) ) ) {
        one = one % 7 + firstDay
        return one === calendar.create( two ).day + 1
    }
    if ( _.isInteger( two ) && ( _.isDate( one ) || $.isArray( one ) ) ) {
        two = two % 7 + firstDay
        return two === calendar.create( one ).day + 1
    }

    // When we’re working with range objects, check if the ranges overlap.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.overlapRanges( one, two )
    }

    return false
}


/**
 * Flip the “enabled” state.
 */
DatePicker.prototype.flipEnable = function(val) {
    var itemObject = this.item
    itemObject.enable = val || (itemObject.enable == -1 ? 1 : -1)
}


/**
 * Mark a collection of dates as “disabled”.
 */
DatePicker.prototype.deactivate = function( type, datesToDisable ) {

    var calendar = this,
        disabledItems = calendar.item.disable.slice(0)


    // If we’re flipping, that’s all we need to do.
    if ( datesToDisable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToDisable === false ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToDisable === true ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the dates to disable.
    else {

        datesToDisable.map(function( unitToDisable ) {

            var matchFound

            // When we have disabled items, check for matches.
            // If something is matched, immediately break out.
            for ( var index = 0; index < disabledItems.length; index += 1 ) {
                if ( calendar.isDateExact( unitToDisable, disabledItems[index] ) ) {
                    matchFound = true
                    break
                }
            }

            // If nothing was found, add the validated unit to the collection.
            if ( !matchFound ) {
                if (
                    _.isInteger( unitToDisable ) ||
                    _.isDate( unitToDisable ) ||
                    $.isArray( unitToDisable ) ||
                    ( $.isPlainObject( unitToDisable ) && unitToDisable.from && unitToDisable.to )
                ) {
                    disabledItems.push( unitToDisable )
                }
            }
        })
    }

    // Return the updated collection.
    return disabledItems
} //DatePicker.prototype.deactivate


/**
 * Mark a collection of dates as “enabled”.
 */
DatePicker.prototype.activate = function( type, datesToEnable ) {

    var calendar = this,
        disabledItems = calendar.item.disable,
        disabledItemsCount = disabledItems.length

    // If we’re flipping, that’s all we need to do.
    if ( datesToEnable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToEnable === true ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToEnable === false ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the disabled dates.
    else {

        datesToEnable.map(function( unitToEnable ) {

            var matchFound,
                disabledUnit,
                index,
                isExactRange

            // Go through the disabled items and try to find a match.
            for ( index = 0; index < disabledItemsCount; index += 1 ) {

                disabledUnit = disabledItems[index]

                // When an exact match is found, remove it from the collection.
                if ( calendar.isDateExact( disabledUnit, unitToEnable ) ) {
                    matchFound = disabledItems[index] = null
                    isExactRange = true
                    break
                }

                // When an overlapped match is found, add the “inverted” state to it.
                else if ( calendar.isDateOverlap( disabledUnit, unitToEnable ) ) {
                    if ( $.isPlainObject( unitToEnable ) ) {
                        unitToEnable.inverted = true
                        matchFound = unitToEnable
                    }
                    else if ( $.isArray( unitToEnable ) ) {
                        matchFound = unitToEnable
                        if ( !matchFound[3] ) matchFound.push( 'inverted' )
                    }
                    else if ( _.isDate( unitToEnable ) ) {
                        matchFound = [ unitToEnable.getFullYear(), unitToEnable.getMonth(), unitToEnable.getDate(), 'inverted' ]
                    }
                    break
                }
            }

            // If a match was found, remove a previous duplicate entry.
            if ( matchFound ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateExact( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // In the event that we’re dealing with an exact range of dates,
            // make sure there are no “inverted” dates because of it.
            if ( isExactRange ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateOverlap( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // If something is still matched, add it into the collection.
            if ( matchFound ) {
                disabledItems.push( matchFound )
            }
        })
    }

    // Return the updated collection.
    return disabledItems.filter(function( val ) { return val != null })
} //DatePicker.prototype.activate


/**
 * Create a string for the nodes in the picker.
 */
DatePicker.prototype.nodes = function( isOpen ) {

    var
        calendar = this,
        settings = calendar.settings,
        calendarItem = calendar.item,
        nowObject = calendarItem.now,
        selectedObject = calendarItem.select,
        highlightedObject = calendarItem.highlight,
        viewsetObject = calendarItem.view,
        disabledCollection = calendarItem.disable,
        minLimitObject = calendarItem.min,
        maxLimitObject = calendarItem.max,


        // Create the calendar table head using a copy of weekday labels collection.
        // * We do a copy so we don't mutate the original array.
        tableHead = (function( collection, fullCollection ) {

            // If the first day should be Monday, move Sunday to the end.
            if ( settings.firstDay ) {
                collection.push( collection.shift() )
                fullCollection.push( fullCollection.shift() )
            }

            // Create and return the table head group.
            return _.node(
                'thead',
                _.node(
                    'tr',
                    _.group({
                        min: 0,
                        max: DAYS_IN_WEEK - 1,
                        i: 1,
                        node: 'th',
                        item: function( counter ) {
                            return [
                                collection[ counter ],
                                settings.klass.weekdays,
                                'scope=col title="' + fullCollection[ counter ] + '"'
                            ]
                        }
                    })
                )
            ) //endreturn
        })( ( settings.showWeekdaysFull ? settings.weekdaysFull : settings.weekdaysShort ).slice( 0 ), settings.weekdaysFull.slice( 0 ) ), //tableHead


        // Create the nav for next/prev month.
        createMonthNav = function( next ) {

            // Otherwise, return the created month tag.
            return _.node(
                'div',
                ' ',
                settings.klass[ 'nav' + ( next ? 'Next' : 'Prev' ) ] + (

                    // If the focused month is outside the range, disabled the button.
                    ( next && viewsetObject.year >= maxLimitObject.year && viewsetObject.month >= maxLimitObject.month ) ||
                    ( !next && viewsetObject.year <= minLimitObject.year && viewsetObject.month <= minLimitObject.month ) ?
                    ' ' + settings.klass.navDisabled : ''
                ),
                'data-nav=' + ( next || -1 ) + ' ' +
                _.ariaAttr({
                    role: 'button',
                    controls: calendar.$node[0].id + '_table'
                }) + ' ' +
                'title="' + (next ? settings.labelMonthNext : settings.labelMonthPrev ) + '"'
            ) //endreturn
        }, //createMonthNav


        // Create the month label.
        createMonthLabel = function() {

            var monthsCollection = settings.showMonthsShort ? settings.monthsShort : settings.monthsFull

            // If there are months to select, add a dropdown menu.
            if ( settings.selectMonths ) {

                return _.node( 'select',
                    _.group({
                        min: 0,
                        max: 11,
                        i: 1,
                        node: 'option',
                        item: function( loopedMonth ) {

                            return [

                                // The looped month and no classes.
                                monthsCollection[ loopedMonth ], 0,

                                // Set the value and selected index.
                                'value=' + loopedMonth +
                                ( viewsetObject.month == loopedMonth ? ' selected' : '' ) +
                                (
                                    (
                                        ( viewsetObject.year == minLimitObject.year && loopedMonth < minLimitObject.month ) ||
                                        ( viewsetObject.year == maxLimitObject.year && loopedMonth > maxLimitObject.month )
                                    ) ?
                                    ' disabled' : ''
                                )
                            ]
                        }
                    }),
                    settings.klass.selectMonth,
                    ( isOpen ? '' : 'disabled' ) + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelMonthSelect + '"'
                )
            }

            // If there's a need for a month selector
            return _.node( 'div', monthsCollection[ viewsetObject.month ], settings.klass.month )
        }, //createMonthLabel


        // Create the year label.
        createYearLabel = function() {

            var focusedYear = viewsetObject.year,

            // If years selector is set to a literal "true", set it to 5. Otherwise
            // divide in half to get half before and half after focused year.
            numberYears = settings.selectYears === true ? 5 : ~~( settings.selectYears / 2 )

            // If there are years to select, add a dropdown menu.
            if ( numberYears ) {

                var
                    minYear = minLimitObject.year,
                    maxYear = maxLimitObject.year,
                    lowestYear = focusedYear - numberYears,
                    highestYear = focusedYear + numberYears

                // If the min year is greater than the lowest year, increase the highest year
                // by the difference and set the lowest year to the min year.
                if ( minYear > lowestYear ) {
                    highestYear += minYear - lowestYear
                    lowestYear = minYear
                }

                // If the max year is less than the highest year, decrease the lowest year
                // by the lower of the two: available and needed years. Then set the
                // highest year to the max year.
                if ( maxYear < highestYear ) {

                    var availableYears = lowestYear - minYear,
                        neededYears = highestYear - maxYear

                    lowestYear -= availableYears > neededYears ? neededYears : availableYears
                    highestYear = maxYear
                }

                return _.node( 'select',
                    _.group({
                        min: lowestYear,
                        max: highestYear,
                        i: 1,
                        node: 'option',
                        item: function( loopedYear ) {
                            return [

                                // The looped year and no classes.
                                loopedYear, 0,

                                // Set the value and selected index.
                                'value=' + loopedYear + ( focusedYear == loopedYear ? ' selected' : '' )
                            ]
                        }
                    }),
                    settings.klass.selectYear,
                    ( isOpen ? '' : 'disabled' ) + ' ' + _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelYearSelect + '"'
                )
            }

            // Otherwise just return the year focused
            return _.node( 'div', focusedYear, settings.klass.year )
        } //createYearLabel


    // Create and return the entire calendar.
    return _.node(
        'div',
        ( settings.selectYears ? createYearLabel() + createMonthLabel() : createMonthLabel() + createYearLabel() ) +
        createMonthNav() + createMonthNav( 1 ),
        settings.klass.header
    ) + _.node(
        'table',
        tableHead +
        _.node(
            'tbody',
            _.group({
                min: 0,
                max: WEEKS_IN_CALENDAR - 1,
                i: 1,
                node: 'tr',
                item: function( rowCounter ) {

                    // If Monday is the first day and the month starts on Sunday, shift the date back a week.
                    var shiftDateBy = settings.firstDay && calendar.create([ viewsetObject.year, viewsetObject.month, 1 ]).day === 0 ? -7 : 0

                    return [
                        _.group({
                            min: DAYS_IN_WEEK * rowCounter - viewsetObject.day + shiftDateBy + 1, // Add 1 for weekday 0index
                            max: function() {
                                return this.min + DAYS_IN_WEEK - 1
                            },
                            i: 1,
                            node: 'td',
                            item: function( targetDate ) {

                                // Convert the time date from a relative date to a target date.
                                targetDate = calendar.create([ viewsetObject.year, viewsetObject.month, targetDate + ( settings.firstDay ? 1 : 0 ) ])

                                var isSelected = selectedObject && selectedObject.pick == targetDate.pick,
                                    isHighlighted = highlightedObject && highlightedObject.pick == targetDate.pick,
                                    isDisabled = disabledCollection && calendar.disabled( targetDate ) || targetDate.pick < minLimitObject.pick || targetDate.pick > maxLimitObject.pick,
                                    formattedDate = _.trigger( calendar.formats.toString, calendar, [ settings.format, targetDate ] )

                                return [
                                    _.node(
                                        'div',
                                        targetDate.date,
                                        (function( klasses ) {

                                            // Add the `infocus` or `outfocus` classes based on month in view.
                                            klasses.push( viewsetObject.month == targetDate.month ? settings.klass.infocus : settings.klass.outfocus )

                                            // Add the `today` class if needed.
                                            if ( nowObject.pick == targetDate.pick ) {
                                                klasses.push( settings.klass.now )
                                            }

                                            // Add the `selected` class if something's selected and the time matches.
                                            if ( isSelected ) {
                                                klasses.push( settings.klass.selected )
                                            }

                                            // Add the `highlighted` class if something's highlighted and the time matches.
                                            if ( isHighlighted ) {
                                                klasses.push( settings.klass.highlighted )
                                            }

                                            // Add the `disabled` class if something's disabled and the object matches.
                                            if ( isDisabled ) {
                                                klasses.push( settings.klass.disabled )
                                            }

                                            return klasses.join( ' ' )
                                        })([ settings.klass.day ]),
                                        'data-pick=' + targetDate.pick + ' ' + _.ariaAttr({
                                            role: 'gridcell',
                                            label: formattedDate,
                                            selected: isSelected && calendar.$node.val() === formattedDate ? true : null,
                                            activedescendant: isHighlighted ? true : null,
                                            disabled: isDisabled ? true : null
                                        })
                                    ),
                                    '',
                                    _.ariaAttr({ role: 'presentation' })
                                ] //endreturn
                            }
                        })
                    ] //endreturn
                }
            })
        ),
        settings.klass.table,
        'id="' + calendar.$node[0].id + '_table' + '" ' + _.ariaAttr({
            role: 'grid',
            controls: calendar.$node[0].id,
            readonly: true
        })
    ) +

    // * For Firefox forms to submit, make sure to set the buttons’ `type` attributes as “button”.
    _.node(
        'div',
        _.node( 'button', settings.today, settings.klass.buttonToday,
            'type=button data-pick=' + nowObject.pick +
            ( isOpen && !calendar.disabled(nowObject) ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ) +
        _.node( 'button', settings.clear, settings.klass.buttonClear,
            'type=button data-clear=1' +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ) +
        _.node('button', settings.close, settings.klass.buttonClose,
            'type=button data-close=true ' +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ),
        settings.klass.footer
    ) //endreturn
} //DatePicker.prototype.nodes




/**
 * The date picker defaults.
 */
DatePicker.defaults = (function( prefix ) {

    return {

        // The title label to use for the month nav buttons
        labelMonthNext: 'Next month',
        labelMonthPrev: 'Previous month',

        // The title label to use for the dropdown selectors
        labelMonthSelect: 'Select a month',
        labelYearSelect: 'Select a year',

        // Months and weekdays
        monthsFull: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
        monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
        weekdaysFull: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
        weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],

        // Today and clear
        today: 'Today',
        clear: 'Clear',
        close: 'Close',

        // Picker close behavior
        closeOnSelect: true,
        closeOnClear: true,

        // Update input value on select/clear
        updateInput: true,

        // The format to show on the `input` element
        format: 'd mmmm, yyyy',

        // Classes
        klass: {

            table: prefix + 'table',

            header: prefix + 'header',

            navPrev: prefix + 'nav--prev',
            navNext: prefix + 'nav--next',
            navDisabled: prefix + 'nav--disabled',

            month: prefix + 'month',
            year: prefix + 'year',

            selectMonth: prefix + 'select--month',
            selectYear: prefix + 'select--year',

            weekdays: prefix + 'weekday',

            day: prefix + 'day',
            disabled: prefix + 'day--disabled',
            selected: prefix + 'day--selected',
            highlighted: prefix + 'day--highlighted',
            now: prefix + 'day--today',
            infocus: prefix + 'day--infocus',
            outfocus: prefix + 'day--outfocus',

            footer: prefix + 'footer',

            buttonClear: prefix + 'button--clear',
            buttonToday: prefix + 'button--today',
            buttonClose: prefix + 'button--close'
        }
    }
})( Picker.klasses().picker + '__' )





/**
 * Extend the picker to add the date picker.
 */
Picker.extend( 'pickadate', DatePicker )


}));





/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17)(__webpack_require__(1509))

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports = "/*!\n * Timepicker Component for Twitter Bootstrap\n *\n * Copyright 2013 Joris de Wit and bootstrap-timepicker contributors\n *\n * Contributors https://github.com/jdewit/bootstrap-timepicker/graphs/contributors\n *\n * For the full copyright and license information, please view the LICENSE\n * file that was distributed with this source code.\n */\n(function($, window, document) {\n  'use strict';\n\n  // TIMEPICKER PUBLIC CLASS DEFINITION\n  var Timepicker = function(element, options) {\n    this.widget = '';\n    this.$element = $(element);\n    this.defaultTime = options.defaultTime;\n    this.disableFocus = options.disableFocus;\n    this.disableMousewheel = options.disableMousewheel;\n    this.isOpen = options.isOpen;\n    this.minuteStep = options.minuteStep;\n    this.modalBackdrop = options.modalBackdrop;\n    this.orientation = options.orientation;\n    this.secondStep = options.secondStep;\n    this.snapToStep = options.snapToStep;\n    this.showInputs = options.showInputs;\n    this.showMeridian = options.showMeridian;\n    this.showSeconds = options.showSeconds;\n    this.template = options.template;\n    this.appendWidgetTo = options.appendWidgetTo;\n    this.showWidgetOnAddonClick = options.showWidgetOnAddonClick;\n    this.icons = options.icons;\n    this.maxHours = options.maxHours;\n    this.explicitMode = options.explicitMode; // If true 123 = 1:23, 12345 = 1:23:45, else invalid.\n\n    this.handleDocumentClick = function (e) {\n      var self = e.data.scope;\n      // This condition was inspired by bootstrap-datepicker.\n      // The element the timepicker is invoked on is the input but it has a sibling for addon/button.\n      if (!(self.$element.parent().find(e.target).length ||\n          self.$widget.is(e.target) ||\n          self.$widget.find(e.target).length)) {\n        self.hideWidget();\n      }\n    };\n\n    this._init();\n  };\n\n  Timepicker.prototype = {\n\n    constructor: Timepicker,\n    _init: function() {\n      var self = this;\n\n      if (this.showWidgetOnAddonClick && (this.$element.parent().hasClass('input-group') && this.$element.parent().hasClass('bootstrap-timepicker'))) {\n        this.$element.parent('.input-group.bootstrap-timepicker').find('.input-group-addon').on({\n          'click.timepicker': $.proxy(this.showWidget, this)\n        });\n        this.$element.on({\n          'focus.timepicker': $.proxy(this.highlightUnit, this),\n          'click.timepicker': $.proxy(this.highlightUnit, this),\n          'keydown.timepicker': $.proxy(this.elementKeydown, this),\n          'blur.timepicker': $.proxy(this.blurElement, this),\n          'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)\n        });\n      } else {\n        if (this.template) {\n          this.$element.on({\n            'focus.timepicker': $.proxy(this.showWidget, this),\n            'click.timepicker': $.proxy(this.showWidget, this),\n            'blur.timepicker': $.proxy(this.blurElement, this),\n            'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)\n          });\n        } else {\n          this.$element.on({\n            'focus.timepicker': $.proxy(this.highlightUnit, this),\n            'click.timepicker': $.proxy(this.highlightUnit, this),\n            'keydown.timepicker': $.proxy(this.elementKeydown, this),\n            'blur.timepicker': $.proxy(this.blurElement, this),\n            'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)\n          });\n        }\n      }\n\n      if (this.template !== false) {\n        this.$widget = $(this.getTemplate()).on('click', $.proxy(this.widgetClick, this));\n      } else {\n        this.$widget = false;\n      }\n\n      if (this.showInputs && this.$widget !== false) {\n        this.$widget.find('input').each(function() {\n          $(this).on({\n            'click.timepicker': function() { $(this).select(); },\n            'keydown.timepicker': $.proxy(self.widgetKeydown, self),\n            'keyup.timepicker': $.proxy(self.widgetKeyup, self)\n          });\n        });\n      }\n\n      this.setDefaultTime(this.defaultTime);\n    },\n\n    blurElement: function() {\n      this.highlightedUnit = null;\n      this.updateFromElementVal();\n    },\n\n    clear: function() {\n      this.hour = '';\n      this.minute = '';\n      this.second = '';\n      this.meridian = '';\n\n      this.$element.val('');\n    },\n\n    decrementHour: function() {\n      if (this.showMeridian) {\n        if (this.hour === 1) {\n          this.hour = 12;\n        } else if (this.hour === 12) {\n          this.hour--;\n\n          return this.toggleMeridian();\n        } else if (this.hour === 0) {\n          this.hour = 11;\n\n          return this.toggleMeridian();\n        } else {\n          this.hour--;\n        }\n      } else {\n        if (this.hour <= 0) {\n          this.hour = this.maxHours - 1;\n        } else {\n          this.hour--;\n        }\n      }\n    },\n\n    decrementMinute: function(step) {\n      var newVal;\n\n      if (step) {\n        newVal = this.minute - step;\n      } else {\n        newVal = this.minute - this.minuteStep;\n      }\n\n      if (newVal < 0) {\n        this.decrementHour();\n        this.minute = newVal + 60;\n      } else {\n        this.minute = newVal;\n      }\n    },\n\n    decrementSecond: function() {\n      var newVal = this.second - this.secondStep;\n\n      if (newVal < 0) {\n        this.decrementMinute(true);\n        this.second = newVal + 60;\n      } else {\n        this.second = newVal;\n      }\n    },\n\n    elementKeydown: function(e) {\n      switch (e.which) {\n\t\tcase 13:\n\t\t\te.preventDefault();\n\t\t\treturn false;\n      case 9: //tab\n        if (e.shiftKey) {\n          if (this.highlightedUnit === 'hour') {\n            this.hideWidget();\n            break;\n          }\n          this.highlightPrevUnit();\n        } else if ((this.showMeridian && this.highlightedUnit === 'meridian') || (this.showSeconds && this.highlightedUnit === 'second') || (!this.showMeridian && !this.showSeconds && this.highlightedUnit ==='minute')) {\n          this.hideWidget();\n          break;\n        } else {\n          this.highlightNextUnit();\n        }\n        e.preventDefault();\n        this.updateFromElementVal();\n        break;\n      case 27: // escape\n        this.updateFromElementVal();\n        break;\n      case 37: // left arrow\n        e.preventDefault();\n        this.highlightPrevUnit();\n        this.updateFromElementVal();\n        break;\n      case 38: // up arrow\n        e.preventDefault();\n        switch (this.highlightedUnit) {\n        case 'hour':\n          this.incrementHour();\n          this.highlightHour();\n          break;\n        case 'minute':\n          this.incrementMinute();\n          this.highlightMinute();\n          break;\n        case 'second':\n          this.incrementSecond();\n          this.highlightSecond();\n          break;\n        case 'meridian':\n          this.toggleMeridian();\n          this.highlightMeridian();\n          break;\n        }\n        this.update();\n        break;\n      case 39: // right arrow\n        e.preventDefault();\n        this.highlightNextUnit();\n        this.updateFromElementVal();\n        break;\n      case 40: // down arrow\n        e.preventDefault();\n        switch (this.highlightedUnit) {\n        case 'hour':\n          this.decrementHour();\n          this.highlightHour();\n          break;\n        case 'minute':\n          this.decrementMinute();\n          this.highlightMinute();\n          break;\n        case 'second':\n          this.decrementSecond();\n          this.highlightSecond();\n          break;\n        case 'meridian':\n          this.toggleMeridian();\n          this.highlightMeridian();\n          break;\n        }\n\n        this.update();\n\t\t  break;\n\t\t}\n    },\n\n    getCursorPosition: function() {\n      var input = this.$element.get(0);\n\n      if ('selectionStart' in input) {// Standard-compliant browsers\n\n        return input.selectionStart;\n      } else if (document.selection) {// IE fix\n        input.focus();\n        var sel = document.selection.createRange(),\n          selLen = document.selection.createRange().text.length;\n\n        sel.moveStart('character', - input.value.length);\n\n        return sel.text.length - selLen;\n      }\n    },\n\n    getTemplate: function() {\n      var template,\n        hourTemplate,\n        minuteTemplate,\n        secondTemplate,\n        meridianTemplate,\n        templateContent;\n\n      if (this.showInputs) {\n        hourTemplate = '<input type=\"text\" class=\"bootstrap-timepicker-hour\" maxlength=\"2\"/>';\n        minuteTemplate = '<input type=\"text\" class=\"bootstrap-timepicker-minute\" maxlength=\"2\"/>';\n        secondTemplate = '<input type=\"text\" class=\"bootstrap-timepicker-second\" maxlength=\"2\"/>';\n        meridianTemplate = '<input type=\"text\" class=\"bootstrap-timepicker-meridian\" maxlength=\"2\"/>';\n      } else {\n        hourTemplate = '<span class=\"bootstrap-timepicker-hour\"></span>';\n        minuteTemplate = '<span class=\"bootstrap-timepicker-minute\"></span>';\n        secondTemplate = '<span class=\"bootstrap-timepicker-second\"></span>';\n        meridianTemplate = '<span class=\"bootstrap-timepicker-meridian\"></span>';\n      }\n\n      templateContent = '<table>'+\n         '<tr>'+\n           '<td><a href=\"#\" data-action=\"incrementHour\"><span class=\"'+ this.icons.up +'\"></span></a></td>'+\n           '<td class=\"separator\">&nbsp;</td>'+\n           '<td><a href=\"#\" data-action=\"incrementMinute\"><span class=\"'+ this.icons.up +'\"></span></a></td>'+\n           (this.showSeconds ?\n             '<td class=\"separator\">&nbsp;</td>'+\n             '<td><a href=\"#\" data-action=\"incrementSecond\"><span class=\"'+ this.icons.up +'\"></span></a></td>'\n           : '') +\n           (this.showMeridian ?\n             '<td class=\"separator\">&nbsp;</td>'+\n             '<td class=\"meridian-column\"><a href=\"#\" data-action=\"toggleMeridian\"><span class=\"'+ this.icons.up +'\"></span></a></td>'\n           : '') +\n         '</tr>'+\n         '<tr>'+\n           '<td>'+ hourTemplate +'</td> '+\n           '<td class=\"separator\">:</td>'+\n           '<td>'+ minuteTemplate +'</td> '+\n           (this.showSeconds ?\n            '<td class=\"separator\">:</td>'+\n            '<td>'+ secondTemplate +'</td>'\n           : '') +\n           (this.showMeridian ?\n            '<td class=\"separator\">&nbsp;</td>'+\n            '<td>'+ meridianTemplate +'</td>'\n           : '') +\n         '</tr>'+\n         '<tr>'+\n           '<td><a href=\"#\" data-action=\"decrementHour\"><span class=\"'+ this.icons.down +'\"></span></a></td>'+\n           '<td class=\"separator\"></td>'+\n           '<td><a href=\"#\" data-action=\"decrementMinute\"><span class=\"'+ this.icons.down +'\"></span></a></td>'+\n           (this.showSeconds ?\n            '<td class=\"separator\">&nbsp;</td>'+\n            '<td><a href=\"#\" data-action=\"decrementSecond\"><span class=\"'+ this.icons.down +'\"></span></a></td>'\n           : '') +\n           (this.showMeridian ?\n            '<td class=\"separator\">&nbsp;</td>'+\n            '<td><a href=\"#\" data-action=\"toggleMeridian\"><span class=\"'+ this.icons.down +'\"></span></a></td>'\n           : '') +\n         '</tr>'+\n       '</table>';\n\n      switch(this.template) {\n      case 'modal':\n        template = '<div class=\"bootstrap-timepicker-widget modal hide fade in\" data-backdrop=\"'+ (this.modalBackdrop ? 'true' : 'false') +'\">'+\n          '<div class=\"modal-header\">'+\n            '<a href=\"#\" class=\"close\" data-dismiss=\"modal\">&times;</a>'+\n            '<h3>Pick a Time</h3>'+\n          '</div>'+\n          '<div class=\"modal-content\">'+\n            templateContent +\n          '</div>'+\n          '<div class=\"modal-footer\">'+\n            '<a href=\"#\" class=\"btn btn-primary\" data-dismiss=\"modal\">OK</a>'+\n          '</div>'+\n        '</div>';\n        break;\n      case 'dropdown':\n        template = '<div class=\"bootstrap-timepicker-widget dropdown-menu\">'+ templateContent +'</div>';\n        break;\n      }\n\n      return template;\n    },\n\n    getTime: function() {\n      if (this.hour === '') {\n        return '';\n      }\n\n      return this.hour + ':' + (this.minute.toString().length === 1 ? '0' + this.minute : this.minute) + (this.showSeconds ? ':' + (this.second.toString().length === 1 ? '0' + this.second : this.second) : '') + (this.showMeridian ? ' ' + this.meridian : '');\n    },\n\n    hideWidget: function() {\n      if (this.isOpen === false) {\n        return;\n      }\n\n      this.$element.trigger({\n        'type': 'hide.timepicker',\n        'time': {\n          'value': this.getTime(),\n          'hours': this.hour,\n          'minutes': this.minute,\n          'seconds': this.second,\n          'meridian': this.meridian\n        }\n      });\n\n      if (this.template === 'modal' && this.$widget.modal) {\n        this.$widget.modal('hide');\n      } else {\n        this.$widget.removeClass('open');\n      }\n\n      $(document).off('mousedown.timepicker, touchend.timepicker', this.handleDocumentClick);\n\n      this.isOpen = false;\n      // show/hide approach taken by datepicker\n      this.$widget.detach();\n    },\n\n    highlightUnit: function() {\n      this.position = this.getCursorPosition();\n      if (this.position >= 0 && this.position <= 2) {\n        this.highlightHour();\n      } else if (this.position >= 3 && this.position <= 5) {\n        this.highlightMinute();\n      } else if (this.position >= 6 && this.position <= 8) {\n        if (this.showSeconds) {\n          this.highlightSecond();\n        } else {\n          this.highlightMeridian();\n        }\n      } else if (this.position >= 9 && this.position <= 11) {\n        this.highlightMeridian();\n      }\n    },\n\n    highlightNextUnit: function() {\n      switch (this.highlightedUnit) {\n      case 'hour':\n        this.highlightMinute();\n        break;\n      case 'minute':\n        if (this.showSeconds) {\n          this.highlightSecond();\n        } else if (this.showMeridian){\n          this.highlightMeridian();\n        } else {\n          this.highlightHour();\n        }\n        break;\n      case 'second':\n        if (this.showMeridian) {\n          this.highlightMeridian();\n        } else {\n          this.highlightHour();\n        }\n        break;\n      case 'meridian':\n        this.highlightHour();\n        break;\n      }\n    },\n\n    highlightPrevUnit: function() {\n      switch (this.highlightedUnit) {\n      case 'hour':\n        if(this.showMeridian){\n          this.highlightMeridian();\n        } else if (this.showSeconds) {\n          this.highlightSecond();\n        } else {\n          this.highlightMinute();\n        }\n        break;\n      case 'minute':\n        this.highlightHour();\n        break;\n      case 'second':\n        this.highlightMinute();\n        break;\n      case 'meridian':\n        if (this.showSeconds) {\n          this.highlightSecond();\n        } else {\n          this.highlightMinute();\n        }\n        break;\n      }\n    },\n\n    highlightHour: function() {\n      var $element = this.$element.get(0),\n          self = this;\n\n      this.highlightedUnit = 'hour';\n\n      if ($element.setSelectionRange) {\n        setTimeout(function() {\n          if (self.hour < 10) {\n            $element.setSelectionRange(0,1);\n          } else {\n            $element.setSelectionRange(0,2);\n          }\n        }, 0);\n      }\n    },\n\n    highlightMinute: function() {\n      var $element = this.$element.get(0),\n          self = this;\n\n      this.highlightedUnit = 'minute';\n\n      if ($element.setSelectionRange) {\n        setTimeout(function() {\n          if (self.hour < 10) {\n            $element.setSelectionRange(2,4);\n          } else {\n            $element.setSelectionRange(3,5);\n          }\n        }, 0);\n      }\n    },\n\n    highlightSecond: function() {\n      var $element = this.$element.get(0),\n          self = this;\n\n      this.highlightedUnit = 'second';\n\n      if ($element.setSelectionRange) {\n        setTimeout(function() {\n          if (self.hour < 10) {\n            $element.setSelectionRange(5,7);\n          } else {\n            $element.setSelectionRange(6,8);\n          }\n        }, 0);\n      }\n    },\n\n    highlightMeridian: function() {\n      var $element = this.$element.get(0),\n          self = this;\n\n      this.highlightedUnit = 'meridian';\n\n      if ($element.setSelectionRange) {\n        if (this.showSeconds) {\n          setTimeout(function() {\n            if (self.hour < 10) {\n              $element.setSelectionRange(8,10);\n            } else {\n              $element.setSelectionRange(9,11);\n            }\n          }, 0);\n        } else {\n          setTimeout(function() {\n            if (self.hour < 10) {\n              $element.setSelectionRange(5,7);\n            } else {\n              $element.setSelectionRange(6,8);\n            }\n          }, 0);\n        }\n      }\n    },\n\n    incrementHour: function() {\n      if (this.showMeridian) {\n        if (this.hour === 11) {\n          this.hour++;\n          return this.toggleMeridian();\n        } else if (this.hour === 12) {\n          this.hour = 0;\n        }\n      }\n      if (this.hour === this.maxHours - 1) {\n        this.hour = 0;\n\n        return;\n      }\n      this.hour++;\n    },\n\n    incrementMinute: function(step) {\n      var newVal;\n\n      if (step) {\n        newVal = this.minute + step;\n      } else {\n        newVal = this.minute + this.minuteStep - (this.minute % this.minuteStep);\n      }\n\n      if (newVal > 59) {\n        this.incrementHour();\n        this.minute = newVal - 60;\n      } else {\n        this.minute = newVal;\n      }\n    },\n\n    incrementSecond: function() {\n      var newVal = this.second + this.secondStep - (this.second % this.secondStep);\n\n      if (newVal > 59) {\n        this.incrementMinute(true);\n        this.second = newVal - 60;\n      } else {\n        this.second = newVal;\n      }\n    },\n\n    mousewheel: function(e) {\n      if (this.disableMousewheel) {\n        return;\n      }\n\n      e.preventDefault();\n      e.stopPropagation();\n\n      var delta = e.originalEvent.wheelDelta || -e.originalEvent.detail,\n          scrollTo = null;\n\n      if (e.type === 'mousewheel') {\n        scrollTo = (e.originalEvent.wheelDelta * -1);\n      }\n      else if (e.type === 'DOMMouseScroll') {\n        scrollTo = 40 * e.originalEvent.detail;\n      }\n\n      if (scrollTo) {\n        e.preventDefault();\n        $(this).scrollTop(scrollTo + $(this).scrollTop());\n      }\n\n      switch (this.highlightedUnit) {\n      case 'minute':\n        if (delta > 0) {\n          this.incrementMinute();\n        } else {\n          this.decrementMinute();\n        }\n        this.highlightMinute();\n        break;\n      case 'second':\n        if (delta > 0) {\n          this.incrementSecond();\n        } else {\n          this.decrementSecond();\n        }\n        this.highlightSecond();\n        break;\n      case 'meridian':\n        this.toggleMeridian();\n        this.highlightMeridian();\n        break;\n      default:\n        if (delta > 0) {\n          this.incrementHour();\n        } else {\n          this.decrementHour();\n        }\n        this.highlightHour();\n        break;\n      }\n\n      return false;\n    },\n\n    /**\n     * Given a segment value like 43, will round and snap the segment\n     * to the nearest \"step\", like 45 if step is 15. Segment will\n     * \"overflow\" to 0 if it's larger than 59 or would otherwise\n     * round up to 60.\n     */\n    changeToNearestStep: function (segment, step) {\n      if (segment % step === 0) {\n        return segment;\n      }\n      if (Math.round((segment % step) / step)) {\n        return (segment + (step - segment % step)) % 60;\n      } else {\n        return segment - segment % step;\n      }\n    },\n\n    // This method was adapted from bootstrap-datepicker.\n    place : function() {\n      if (this.isInline) {\n        return;\n      }\n      var widgetWidth = this.$widget.outerWidth(), widgetHeight = this.$widget.outerHeight(), visualPadding = 10, windowWidth =\n        $(window).width(), windowHeight = $(window).height(), scrollTop = $(window).scrollTop();\n\n      var zIndex = parseInt(this.$element.parents().filter(function() { return $(this).css('z-index') !== 'auto'; }).first().css('z-index'), 10) + 10;\n      var offset = this.component ? this.component.parent().offset() : this.$element.offset();\n      var height = this.component ? this.component.outerHeight(true) : this.$element.outerHeight(false);\n      var width = this.component ? this.component.outerWidth(true) : this.$element.outerWidth(false);\n      var left = offset.left, top = offset.top;\n\n      this.$widget.removeClass('timepicker-orient-top timepicker-orient-bottom timepicker-orient-right timepicker-orient-left');\n\n      if (this.orientation.x !== 'auto') {\n        this.$widget.addClass('timepicker-orient-' + this.orientation.x);\n        if (this.orientation.x === 'right') {\n          left -= widgetWidth - width;\n        }\n      } else{\n        // auto x orientation is best-placement: if it crosses a window edge, fudge it sideways\n        // Default to left\n        this.$widget.addClass('timepicker-orient-left');\n        if (offset.left < 0) {\n          left -= offset.left - visualPadding;\n        } else if (offset.left + widgetWidth > windowWidth) {\n          left = windowWidth - widgetWidth - visualPadding;\n        }\n      }\n      // auto y orientation is best-situation: top or bottom, no fudging, decision based on which shows more of the widget\n      var yorient = this.orientation.y, topOverflow, bottomOverflow;\n      if (yorient === 'auto') {\n        topOverflow = -scrollTop + offset.top - widgetHeight;\n        bottomOverflow = scrollTop + windowHeight - (offset.top + height + widgetHeight);\n        if (Math.max(topOverflow, bottomOverflow) === bottomOverflow) {\n          yorient = 'top';\n        } else {\n          yorient = 'bottom';\n        }\n      }\n      this.$widget.addClass('timepicker-orient-' + yorient);\n      if (yorient === 'top'){\n        top += height;\n      } else{\n        top -= widgetHeight + parseInt(this.$widget.css('padding-top'), 10);\n      }\n\n      this.$widget.css({\n        top : top,\n        left : left,\n        zIndex : zIndex\n      });\n    },\n\n    remove: function() {\n      $('document').off('.timepicker');\n      if (this.$widget) {\n        this.$widget.remove();\n      }\n      delete this.$element.data().timepicker;\n    },\n\n    setDefaultTime: function(defaultTime) {\n      if (!this.$element.val()) {\n        if (defaultTime === 'current') {\n          var dTime = new Date(),\n            hours = dTime.getHours(),\n            minutes = dTime.getMinutes(),\n            seconds = dTime.getSeconds(),\n            meridian = 'AM';\n\n          if (seconds !== 0) {\n            seconds = Math.ceil(dTime.getSeconds() / this.secondStep) * this.secondStep;\n            if (seconds === 60) {\n              minutes += 1;\n              seconds = 0;\n            }\n          }\n\n          if (minutes !== 0) {\n            minutes = Math.ceil(dTime.getMinutes() / this.minuteStep) * this.minuteStep;\n            if (minutes === 60) {\n              hours += 1;\n              minutes = 0;\n            }\n          }\n\n          if (this.showMeridian) {\n            if (hours === 0) {\n              hours = 12;\n            } else if (hours >= 12) {\n              if (hours > 12) {\n                hours = hours - 12;\n              }\n              meridian = 'PM';\n            } else {\n              meridian = 'AM';\n            }\n          }\n\n          this.hour = hours;\n          this.minute = minutes;\n          this.second = seconds;\n          this.meridian = meridian;\n\n          this.update();\n\n        } else if (defaultTime === false) {\n          this.hour = 0;\n          this.minute = 0;\n          this.second = 0;\n          this.meridian = 'AM';\n        } else {\n          this.setTime(defaultTime);\n        }\n      } else {\n        this.updateFromElementVal();\n      }\n    },\n\n    setTime: function(time, ignoreWidget) {\n      if (!time) {\n        this.clear();\n        return;\n      }\n\n      var timeMode,\n          timeArray,\n          hour,\n          minute,\n          second,\n          meridian;\n\n      if (typeof time === 'object' && time.getMonth){\n        // this is a date object\n        hour    = time.getHours();\n        minute  = time.getMinutes();\n        second  = time.getSeconds();\n\n        if (this.showMeridian){\n          meridian = 'AM';\n          if (hour > 12){\n            meridian = 'PM';\n            hour = hour % 12;\n          }\n\n          if (hour === 12){\n            meridian = 'PM';\n          }\n        }\n      } else {\n        timeMode = ((/a/i).test(time) ? 1 : 0) + ((/p/i).test(time) ? 2 : 0); // 0 = none, 1 = AM, 2 = PM, 3 = BOTH.\n        if (timeMode > 2) { // If both are present, fail.\n          this.clear();\n          return;\n        }\n\n        timeArray = time.replace(/[^0-9\\:]/g, '').split(':');\n\n        hour = timeArray[0] ? timeArray[0].toString() : timeArray.toString();\n\n        if(this.explicitMode && hour.length > 2 && (hour.length % 2) !== 0 ) {\n          this.clear();\n          return;\n        }\n\n        minute = timeArray[1] ? timeArray[1].toString() : '';\n        second = timeArray[2] ? timeArray[2].toString() : '';\n\n        // adaptive time parsing\n        if (hour.length > 4) {\n          second = hour.slice(-2);\n          hour = hour.slice(0, -2);\n        }\n\n        if (hour.length > 2) {\n          minute = hour.slice(-2);\n          hour = hour.slice(0, -2);\n        }\n\n        if (minute.length > 2) {\n          second = minute.slice(-2);\n          minute = minute.slice(0, -2);\n        }\n\n        hour = parseInt(hour, 10);\n        minute = parseInt(minute, 10);\n        second = parseInt(second, 10);\n\n        if (isNaN(hour)) {\n          hour = 0;\n        }\n        if (isNaN(minute)) {\n          minute = 0;\n        }\n        if (isNaN(second)) {\n          second = 0;\n        }\n\n        // Adjust the time based upon unit boundary.\n        // NOTE: Negatives will never occur due to time.replace() above.\n        if (second > 59) {\n          second = 59;\n        }\n\n        if (minute > 59) {\n          minute = 59;\n        }\n\n        if (hour >= this.maxHours) {\n          // No day/date handling.\n          hour = this.maxHours - 1;\n        }\n\n        if (this.showMeridian) {\n          if (hour > 12) {\n            // Force PM.\n            timeMode = 2;\n            hour -= 12;\n          }\n          if (!timeMode) {\n            timeMode = 1;\n          }\n          if (hour === 0) {\n            hour = 12; // AM or PM, reset to 12.  0 AM = 12 AM.  0 PM = 12 PM, etc.\n          }\n          meridian = timeMode === 1 ? 'AM' : 'PM';\n        } else if (hour < 12 && timeMode === 2) {\n          hour += 12;\n        } else {\n          if (hour >= this.maxHours) {\n            hour = this.maxHours - 1;\n          } else if ((hour < 0) || (hour === 12 && timeMode === 1)){\n            hour = 0;\n          }\n        }\n      }\n\n      this.hour = hour;\n      if (this.snapToStep) {\n        this.minute = this.changeToNearestStep(minute, this.minuteStep);\n        this.second = this.changeToNearestStep(second, this.secondStep);\n      } else {\n        this.minute = minute;\n        this.second = second;\n      }\n      this.meridian = meridian;\n\n      this.update(ignoreWidget);\n    },\n\n    showWidget: function() {\n      if (this.isOpen) {\n        return;\n      }\n\n      if (this.$element.is(':disabled')) {\n        return;\n      }\n\n      // show/hide approach taken by datepicker\n      this.$widget.appendTo(this.appendWidgetTo);\n      $(document).on('mousedown.timepicker, touchend.timepicker', {scope: this}, this.handleDocumentClick);\n\n      this.$element.trigger({\n        'type': 'show.timepicker',\n        'time': {\n          'value': this.getTime(),\n          'hours': this.hour,\n          'minutes': this.minute,\n          'seconds': this.second,\n          'meridian': this.meridian\n        }\n      });\n\n      this.place();\n      if (this.disableFocus) {\n        this.$element.blur();\n      }\n\n      // widget shouldn't be empty on open\n      if (this.hour === '') {\n        if (this.defaultTime) {\n          this.setDefaultTime(this.defaultTime);\n        } else {\n          this.setTime('0:0:0');\n        }\n      }\n\n      if (this.template === 'modal' && this.$widget.modal) {\n        this.$widget.modal('show').on('hidden', $.proxy(this.hideWidget, this));\n      } else {\n        if (this.isOpen === false) {\n          this.$widget.addClass('open');\n        }\n      }\n\n      this.isOpen = true;\n    },\n\n    toggleMeridian: function() {\n      this.meridian = this.meridian === 'AM' ? 'PM' : 'AM';\n    },\n\n    update: function(ignoreWidget) {\n      this.updateElement();\n      if (!ignoreWidget) {\n        this.updateWidget();\n      }\n\n      this.$element.trigger({\n        'type': 'changeTime.timepicker',\n        'time': {\n          'value': this.getTime(),\n          'hours': this.hour,\n          'minutes': this.minute,\n          'seconds': this.second,\n          'meridian': this.meridian\n        }\n      });\n    },\n\n    updateElement: function() {\n      this.$element.val(this.getTime()).change();\n    },\n\n    updateFromElementVal: function() {\n      this.setTime(this.$element.val());\n    },\n\n    updateWidget: function() {\n      if (this.$widget === false) {\n        return;\n      }\n\n      var hour = this.hour,\n          minute = this.minute.toString().length === 1 ? '0' + this.minute : this.minute,\n          second = this.second.toString().length === 1 ? '0' + this.second : this.second;\n\n      if (this.showInputs) {\n        this.$widget.find('input.bootstrap-timepicker-hour').val(hour);\n        this.$widget.find('input.bootstrap-timepicker-minute').val(minute);\n\n        if (this.showSeconds) {\n          this.$widget.find('input.bootstrap-timepicker-second').val(second);\n        }\n        if (this.showMeridian) {\n          this.$widget.find('input.bootstrap-timepicker-meridian').val(this.meridian);\n        }\n      } else {\n        this.$widget.find('span.bootstrap-timepicker-hour').text(hour);\n        this.$widget.find('span.bootstrap-timepicker-minute').text(minute);\n\n        if (this.showSeconds) {\n          this.$widget.find('span.bootstrap-timepicker-second').text(second);\n        }\n        if (this.showMeridian) {\n          this.$widget.find('span.bootstrap-timepicker-meridian').text(this.meridian);\n        }\n      }\n    },\n\n    updateFromWidgetInputs: function() {\n      if (this.$widget === false) {\n        return;\n      }\n\n      var t = this.$widget.find('input.bootstrap-timepicker-hour').val() + ':' +\n              this.$widget.find('input.bootstrap-timepicker-minute').val() +\n              (this.showSeconds ? ':' + this.$widget.find('input.bootstrap-timepicker-second').val() : '') +\n              (this.showMeridian ? this.$widget.find('input.bootstrap-timepicker-meridian').val() : '')\n      ;\n\n      this.setTime(t, true);\n    },\n\n    widgetClick: function(e) {\n      e.stopPropagation();\n      e.preventDefault();\n\n      var $input = $(e.target),\n          action = $input.closest('a').data('action');\n\n      if (action) {\n        this[action]();\n      }\n      this.update();\n\n      if ($input.is('input')) {\n        $input.get(0).setSelectionRange(0,2);\n      }\n    },\n\n    widgetKeydown: function(e) {\n      var $input = $(e.target),\n          name = $input.attr('class').replace('bootstrap-timepicker-', '');\n\n      switch (e.which) {\n      case 9: //tab\n        if (e.shiftKey) {\n          if (name === 'hour') {\n            return this.hideWidget();\n          }\n        } else if ((this.showMeridian && name === 'meridian') || (this.showSeconds && name === 'second') || (!this.showMeridian && !this.showSeconds && name === 'minute')) {\n          return this.hideWidget();\n        }\n        break;\n      case 27: // escape\n        this.hideWidget();\n        break;\n      case 38: // up arrow\n        e.preventDefault();\n        switch (name) {\n        case 'hour':\n          this.incrementHour();\n          break;\n        case 'minute':\n          this.incrementMinute();\n          break;\n        case 'second':\n          this.incrementSecond();\n          break;\n        case 'meridian':\n          this.toggleMeridian();\n          break;\n        }\n        this.setTime(this.getTime());\n        $input.get(0).setSelectionRange(0,2);\n        break;\n      case 40: // down arrow\n        e.preventDefault();\n        switch (name) {\n        case 'hour':\n          this.decrementHour();\n          break;\n        case 'minute':\n          this.decrementMinute();\n          break;\n        case 'second':\n          this.decrementSecond();\n          break;\n        case 'meridian':\n          this.toggleMeridian();\n          break;\n        }\n        this.setTime(this.getTime());\n        $input.get(0).setSelectionRange(0,2);\n        break;\n      }\n    },\n\n    widgetKeyup: function(e) {\n      if ((e.which === 65) || (e.which === 77) || (e.which === 80) || (e.which === 46) || (e.which === 8) || (e.which >= 48 && e.which <= 57) || (e.which >= 96 && e.which <= 105)) {\n        this.updateFromWidgetInputs();\n      }\n    }\n  };\n\n  //TIMEPICKER PLUGIN DEFINITION\n  $.fn.timepicker = function(option) {\n    var args = Array.apply(null, arguments);\n    args.shift();\n    return this.each(function() {\n      var $this = $(this),\n        data = $this.data('timepicker'),\n        options = typeof option === 'object' && option;\n\n      if (!data) {\n        $this.data('timepicker', (data = new Timepicker(this, $.extend({}, $.fn.timepicker.defaults, options, $(this).data()))));\n      }\n\n      if (typeof option === 'string') {\n        data[option].apply(data, args);\n      }\n    });\n  };\n\n  $.fn.timepicker.defaults = {\n    defaultTime: 'current',\n    disableFocus: false,\n    disableMousewheel: false,\n    isOpen: false,\n    minuteStep: 15,\n    modalBackdrop: false,\n    orientation: { x: 'auto', y: 'auto'},\n    secondStep: 15,\n    snapToStep: false,\n    showSeconds: false,\n    showInputs: true,\n    showMeridian: true,\n    template: 'dropdown',\n    appendWidgetTo: 'body',\n    showWidgetOnAddonClick: true,\n    icons: {\n      up: 'glyphicon glyphicon-chevron-up',\n      down: 'glyphicon glyphicon-chevron-down'\n    },\n    maxHours: 24,\n    explicitMode: false\n  };\n\n  $.fn.timepicker.Constructor = Timepicker;\n\n  $(document).on(\n    'focus.timepicker.data-api click.timepicker.data-api',\n    '[data-provide=\"timepicker\"]',\n    function(e){\n      var $this = $(this);\n      if ($this.data('timepicker')) {\n        return;\n      }\n      e.preventDefault();\n      // component click requires us to explicitly show it\n      $this.timepicker();\n    }\n  );\n\n})(jQuery, window, document);\n"

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})( true ? exports : Hogan);


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})( true ? exports : Hogan);


/***/ }),
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("isTranslated",c,p,1),c,p,0,17,65,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"sma-loader-container-");t.b(t.v(t.f("size",c,p,0)));t.b("\">");t.b("\n" + i);});c.pop();}if(!t.s(t.f("isTranslated",c,p,1),c,p,1,0,0,"")){t.b("	<div class=\"sma-loader-container-");t.b(t.v(t.f("size",c,p,0)));t.b(" sma-loader-no-transform\">");t.b("\n" + i);};t.b("	<div class=\"sma-loader\">");t.b("\n" + i);t.b("		<div class=\"sma-loader-rounded-edge-left\"></div>");t.b("\n" + i);t.b("		<div class=\"sma-loader-rounded-edge-right\"></div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "{{#isTranslated}}\n\t<div class=\"sma-loader-container-{{ size }}\">\n{{/isTranslated}}\n{{^isTranslated}}\n\t<div class=\"sma-loader-container-{{ size }} sma-loader-no-transform\">\n{{/isTranslated}}\n\t<div class=\"sma-loader\">\n\t\t<div class=\"sma-loader-rounded-edge-left\"></div>\n\t\t<div class=\"sma-loader-rounded-edge-right\"></div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-alert sma-");t.b(t.v(t.d("type.name",c,p,0)));t.b("\">");t.b("\n" + i);t.b("	<span class=\"sma-alert-placeholder\"></span>");t.b("\n" + i);t.b("	<span class=\"sma-alert-message\">");t.b("\n" + i);t.b("		<i class=\"nc-icon-mini ");t.b(t.v(t.d("type.icon",c,p,0)));t.b("\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("		<span>");t.b(t.v(t.f("message",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("	</span>");t.b("\n" + i);t.b("	<a href=\"#\" type=\"button\" class=\"sma-alert-close\" aria-label=\"Close\"> ");t.b("\n" + i);t.b("		<i class=\"nc-icon-mini ui-1_simple-remove\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("	</a>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-alert sma-{{ type.name }}\">\n\t<span class=\"sma-alert-placeholder\"></span>\n\t<span class=\"sma-alert-message\">\n\t\t<i class=\"nc-icon-mini {{ type.icon }}\" aria-hidden=\"true\"></i>\n\t\t<span>{{ message }}</span>\n\t</span>\n\t<a href=\"#\" type=\"button\" class=\"sma-alert-close\" aria-label=\"Close\"> \n\t\t<i class=\"nc-icon-mini ui-1_simple-remove\" aria-hidden=\"true\"></i>\n\t</a>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("tableWrap",c,p,1),c,p,0,14,37,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<tr>");t.b("\n" + i);t.b("	<td colspan=10>");t.b("\n" + i);});c.pop();}t.b("		<div class=\"row sma-file-progress\">");t.b("\n" + i);t.b("			<div class=\"col-md-6\">");t.b("\n" + i);t.b("				<h6>");t.b(t.v(t.f("filename",c,p,0)));t.b("</h6>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("			<div class=\"col-md-6\">");t.b("\n" + i);t.b("				<div class=\"row sma-js-percentage-wrap\">");t.b("\n" + i);t.b("					<div class=\"col-sm-2 text-sm-right\"><span class=\"sma-js-percentage\"></span>%</div>");t.b("\n" + i);t.b("					<div class=\"col-sm-8 sma-progress\">");t.b("\n" + i);t.b("						<progress class=\"progress bg-success progress-bar-striped\" role=\"progressbar\" value=\"0\" max=\"100\"></progress>");t.b("\n" + i);t.b("					</div>");t.b("\n" + i);t.b("					<div class=\"col-sm-2 text-sm-left\"><a class=\"sma-js-progress-cancel\" href=\"#\">");t.b(t.v(t.f("cancelText",c,p,0)));t.b("</a></div>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);if(t.s(t.f("tableWrap",c,p,1),c,p,0,632,646,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	</td>");t.b("\n" + i);t.b("</tr>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#tableWrap}}\n<tr>\n\t<td colspan=10>\n{{/tableWrap}}\n\t\t<div class=\"row sma-file-progress\">\n\t\t\t<div class=\"col-md-6\">\n\t\t\t\t<h6>{{filename}}</h6>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-6\">\n\t\t\t\t<div class=\"row sma-js-percentage-wrap\">\n\t\t\t\t\t<div class=\"col-sm-2 text-sm-right\"><span class=\"sma-js-percentage\"></span>%</div>\n\t\t\t\t\t<div class=\"col-sm-8 sma-progress\">\n\t\t\t\t\t\t<progress class=\"progress bg-success progress-bar-striped\" role=\"progressbar\" value=\"0\" max=\"100\"></progress>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-sm-2 text-sm-left\"><a class=\"sma-js-progress-cancel\" href=\"#\">{{cancelText}}</a></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n{{#tableWrap}}\n\t</td>\n</tr>\n{{/tableWrap}}\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-modal-responsive-wrap\">");t.b("\n" + i);t.b("	<div class=\"");t.b(t.v(t.f("cls",c,p,0)));t.b(" sma-modal-");t.b(t.v(t.f("size",c,p,0)));t.b("\" aria-modal=\"true\" aria-labelledby=\"sma-modal-title\" role=\"dialog\">");t.b("\n" + i);t.b("		<a class=\"sma-modal-close\" href=\"#\" aria-label=\"");t.b(t.v(t.d("strings.close",c,p,0)));t.b("\"><i class=\"nc-icon-mini ui-1_simple-remove\" aria-hidden=\"true\"></i></a>");t.b("\n" + i);t.b("		<div class=\"sma-modal-header\">");t.b("\n" + i);t.b("			<h1 class=\"sma-modal-title\" id=\"sma-modal-title\">");t.b(t.t(t.f("title",c,p,0)));t.b("</h1>");t.b("\n" + i);if(t.s(t.f("subtitle",c,p,1),c,p,0,410,473,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<h2 class=\"sma-modal-subtitle h4\">");t.b(t.t(t.f("subtitle",c,p,0)));t.b("</h2>");t.b("\n" + i);});c.pop();}t.b("		</div>");t.b("\n" + i);t.b("		<div class=\"sma-modal-content\"></div>");t.b("\n" + i);t.b("		<div class=\"sma-modal-footer\"></div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-modal-responsive-wrap\">\n\t<div class=\"{{cls}} sma-modal-{{size}}\" aria-modal=\"true\" aria-labelledby=\"sma-modal-title\" role=\"dialog\">\n\t\t<a class=\"sma-modal-close\" href=\"#\" aria-label=\"{{ strings.close }}\"><i class=\"nc-icon-mini ui-1_simple-remove\" aria-hidden=\"true\"></i></a>\n\t\t<div class=\"sma-modal-header\">\n\t\t\t<h1 class=\"sma-modal-title\" id=\"sma-modal-title\">{{{ title }}}</h1>\n\t\t\t{{#subtitle}}\n\t\t\t<h2 class=\"sma-modal-subtitle h4\">{{{ subtitle }}}</h2>\n\t\t\t{{/subtitle}}\n\t\t</div>\n\t\t<div class=\"sma-modal-content\"></div>\n\t\t<div class=\"sma-modal-footer\"></div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<button href=\"#\" id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"btn btn-loud ");t.b(t.v(t.f("cls",c,p,0)));t.b("\" type=\"");t.b(t.v(t.f("type",c,p,0)));t.b("\" form=\"");t.b(t.v(t.f("form",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("useButtonLoaders",c,p,1),c,p,0,116,203,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <div class=\"btn-label\">");t.b(t.v(t.f("label",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("        <div class=\"btn-loader\" />");t.b("\n" + i);});c.pop();}if(!t.s(t.f("useButtonLoaders",c,p,1),c,p,1,0,0,"")){t.b("        ");t.b(t.v(t.f("label",c,p,0)));t.b("\n" + i);};t.b("</button>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<button href=\"#\" id=\"{{id}}\" class=\"btn btn-loud {{cls}}\" type=\"{{type}}\" form=\"{{form}}\">\n    {{#useButtonLoaders}}\n        <div class=\"btn-label\">{{label}}</div>\n        <div class=\"btn-loader\" />\n    {{/useButtonLoaders}}\n    {{^useButtonLoaders}}\n        {{label}}\n    {{/useButtonLoaders}}\n</button>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<fieldset class=\"form-group\">");t.b("\n" + i);t.b("	<label for=\"modal-prompt-input\">");t.b(t.v(t.f("description",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("	<input maxlength=\"");t.b(t.v(t.f("maxLength",c,p,0)));t.b("\" name=\"modal-prompt-input\" value=\"");t.b(t.v(t.f("value",c,p,0)));t.b("\" aria-label=\"");t.b(t.v(t.f("title",c,p,0)));t.b("\" class=\"form-control sma-js-validate-input\"></input>");t.b("\n" + i);t.b("	<div class=\"text-right text-muted\">");t.b(t.v(t.f("maxLength",c,p,0)));t.b(" ");t.b(t.v(t.f("max_length_text",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("</fieldset>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<fieldset class=\"form-group\">\n\t<label for=\"modal-prompt-input\">{{description}}</label>\n\t<input maxlength=\"{{maxLength}}\" name=\"modal-prompt-input\" value=\"{{value}}\" aria-label=\"{{title}}\" class=\"form-control sma-js-validate-input\"></input>\n\t<div class=\"text-right text-muted\">{{maxLength}} {{max_length_text}}</div>\n</fieldset>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<fieldset class=\"form-group\">");t.b("\n" + i);t.b("	<label for=\"new-status\">");t.b(t.v(t.f("description",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("	<p>");t.b(t.v(t.f("replacement",c,p,0)));t.b("</p>");t.b("\n");t.b("\n" + i);t.b("    <select class=\"form-control\" name=\"new-status\">");t.b("\n" + i);if(t.s(t.f("statuses",c,p,1),c,p,0,177,239,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <option value=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.f("name",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("    </select>");t.b("\n" + i);t.b("</fieldset>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<fieldset class=\"form-group\">\n\t<label for=\"new-status\">{{description}}</label>\n\t<p>{{replacement}}</p>\n\n    <select class=\"form-control\" name=\"new-status\">\n        {{#statuses}}\n            <option value=\"{{id}}\">{{name}}</option>\n        {{/statuses}}\n    </select>\n</fieldset>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div>");t.b("\n" + i);t.b("	<span>");t.b(t.t(t.f("description",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("	<fieldset class=\"form-group mt-3\">");t.b("\n" + i);if(t.s(t.f("checkboxText",c,p,1),c,p,0,93,357,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("				<input type=\"checkbox\" class=\"custom-control-input sma-js-modal-checkbox\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b(t.v(t.f("checkboxText",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);});c.pop();}t.b("	</fieldset>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div>\n\t<span>{{{description}}}</span>\n\t<fieldset class=\"form-group mt-3\">\n\t\t{{#checkboxText}}\n\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t<input type=\"checkbox\" class=\"custom-control-input sma-js-modal-checkbox\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">{{checkboxText}}</span>\n\t\t\t</label>\n\t\t{{/checkboxText}}\n\t</fieldset>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(897),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),m=__webpack_require__(897),q=__webpack_require__(1564);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
function lh(a,b){return"function"===typeof b?b(a):b}
function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
var Oh={};
function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1565);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _wdsReact = __webpack_require__(9);

var _wdsIcons = __webpack_require__(32);

var _ads = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Piper = function (_React$Component) {
	_inherits(Piper, _React$Component);

	_createClass(Piper, null, [{
		key: 'paneHasParent',

		// Check if pane has an element that has children
		value: function paneHasParent(data) {
			var itemsWithParents = data.map(function (item) {
				return Object.keys(item).includes('data');
			});

			return itemsWithParents.length > 0;
		}
	}]);

	function Piper(props) {
		var _this$state;

		_classCallCheck(this, Piper);

		var _this = _possibleConstructorReturn(this, (Piper.__proto__ || Object.getPrototypeOf(Piper)).call(this, props));

		_this.state = (_this$state = {
			data: props.data,
			leftPane: props.data,
			parent: props.data[0],
			rightPane: []
		}, _defineProperty(_this$state, 'parent', null), _defineProperty(_this$state, 'selected', []), _defineProperty(_this$state, 'previouslySelected', null), _defineProperty(_this$state, 'previousGroup', []), _defineProperty(_this$state, 'depth', 0), _defineProperty(_this$state, 'searchTerm', ''), _this$state);

		// ES6 React.Component doesn't auto bind methods to itself
		_this.handleSearch = _this.handleSearch.bind(_this);
		_this.updateQueue = _this.updateQueue.bind(_this);
		_this.handleChildClick = _this.handleChildClick.bind(_this);
		_this.handleParentClick = _this.handleParentClick.bind(_this);
		_this.handlePreviousClick = _this.handlePreviousClick.bind(_this);
		_this.handleBadgeRemove = _this.handleBadgeRemove.bind(_this);
		return _this;
	}

	_createClass(Piper, [{
		key: 'handleBadgeRemove',
		value: function handleBadgeRemove(e, index) {
			var selected = this.state.selected;


			var newSelection = selected;
			newSelection.splice(index, 1);

			this.updateQueue(newSelection);
		}
	}, {
		key: 'updateQueue',
		value: function updateQueue(newSelection) {
			var updateQueue = this.props.updateQueue;


			this.setState({ selected: newSelection });
			updateQueue(newSelection);
		}
	}, {
		key: 'handleChildClick',
		value: function handleChildClick(e, item) {
			var _state = this.state,
			    parent = _state.parent,
			    selected = _state.selected;

			var newSelection = selected;

			newSelection.push({
				id: item.id,
				label: item.label,
				value: item.value,
				group: parent.label,
				isMulti: item.is_multi
			});

			this.updateQueue(newSelection);
		}
	}, {
		key: 'handlePreviousClick',
		value: function handlePreviousClick() {
			var _state2 = this.state,
			    depth = _state2.depth,
			    leftPane = _state2.leftPane,
			    previousGroup = _state2.previousGroup,
			    previouslySelected = _state2.previouslySelected;


			this.setState({
				rightPane: leftPane,
				leftPane: previousGroup,
				depth: depth - 1,
				parent: previouslySelected
			});
		}
	}, {
		key: 'handleParentClick',
		value: function handleParentClick(e, item, panel) {
			var _state3 = this.state,
			    depth = _state3.depth,
			    leftPane = _state3.leftPane,
			    parent = _state3.parent,
			    rightPane = _state3.rightPane;


			if (parent && item.id === parent.id) {
				return;
			}

			if (panel === 'right' && Piper.paneHasParent(rightPane)) {
				this.setState({
					previousGroup: leftPane,
					leftPane: rightPane,
					depth: depth + 1
				});
			}

			this.setState({
				previouslySelected: parent,
				parent: item,
				rightPane: item.data
			});
		}
	}, {
		key: 'handleSearch',
		value: function handleSearch(e) {
			var searchTerm = e.target.value;

			var data = this.state.data;


			var resultTree = this.search(searchTerm, data);

			var rightPane = void 0;

			if (!resultTree.length) {
				rightPane = [];
			} else {
				rightPane = resultTree[0].data || [];
			}

			this.setState({
				leftPane: resultTree,
				parent: resultTree[0],
				rightPane: rightPane,
				searchTerm: searchTerm
			});
		}
	}, {
		key: 'search',
		value: function search(searchTerm, treeNode) {
			var result = [];

			function childMatchesSearch(node, search) {
				var result = {
					label: node.label,
					id: node.id,
					value: node.value,
					isMulti: node.isMulti
				};

				if (node.hasOwnProperty('data')) {
					result = {
						label: node.label,
						id: node.id,
						data: node.data,
						extra_data: node.extra_data
					};
				}

				var hasMatch = false;

				if (node.label.toLowerCase().includes(search)) {
					hasMatch = true;
				} else if (node.hasOwnProperty('data')) {
					var matchedChildren = [];

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = node.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var subNode = _step.value;

							var childMatch = childMatchesSearch(subNode, search);

							if (childMatch) {
								matchedChildren.push(childMatch);
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					result.data = matchedChildren;
					hasMatch = matchedChildren.length > 0;
				}

				if (!hasMatch) {
					return null;
				}

				return result;
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = treeNode[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					var searchResult = childMatchesSearch(item, searchTerm.toLowerCase());
					if (searchResult !== null) {
						result.push(searchResult);
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return result;
		}
	}, {
		key: 'tooltipOnMouseExit',
		value: function tooltipOnMouseExit(e) {
			$(e.target).tooltip('hide');
		}
	}, {
		key: 'paneRenderer',
		value: function paneRenderer(data, panel) {
			var _this2 = this;

			var _state4 = this.state,
			    depth = _state4.depth,
			    parent = _state4.parent,
			    previouslySelected = _state4.previouslySelected;


			var menuItems = [];
			if (depth > 0 && panel === 'left') {
				menuItems.push(_react2.default.createElement(
					_ads.GroupedMenuItem,
					{
						onClick: function onClick(e) {
							return _this2.handlePreviousClick(e, previouslySelected);
						},
						className: 'wds-flex previous'
					},
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(_wdsIcons.IconCaretLeft, null)
					),
					_react2.default.createElement(
						'span',
						null,
						previouslySelected.label
					)
				));
			}

			menuItems.push(data.map(function (item) {
				var hasChildren = 'data' in item;

				if (hasChildren) {
					var isSelected = parent && item.id === parent.id;

					var hasExtraData = Object.entries(item.extra_data).length > 0;

					var tooltipText = '';
					if (hasExtraData) {
						tooltipText = 'Stage: ' + item.extra_data.round_name + '<br>Program: ' + item.extra_data.program_name;
					}

					return _react2.default.createElement(
						_ads.GroupedMenuItem,
						{
							key: item.id,
							onClick: function onClick(e) {
								return _this2.handleParentClick(e, item, panel);
							},
							onMouseLeave: function onMouseLeave(e) {
								return _this2.tooltipOnMouseExit(e);
							},
							className: 'wds-flex wds-flex--between parent ' + (isSelected ? 'selected' : ''),
							'data-toggle': hasExtraData ? 'tooltip' : undefined,
							'data-placement': hasExtraData ? 'top' : undefined,
							'data-html': hasExtraData ? 'true' : undefined,
							title: hasExtraData ? tooltipText : undefined,
							'data-delay': hasExtraData ? '{"show":"500"}' : undefined
						},
						_react2.default.createElement(
							'span',
							null,
							item.label
						),
						_react2.default.createElement(
							'div',
							{ className: '' + (isSelected ? '' : 'ads-invisible') },
							_react2.default.createElement(_wdsIcons.IconCaretRight, null)
						)
					);
				}

				return _react2.default.createElement(
					_ads.GroupedMenuItem,
					{
						key: item.id,
						onClick: function onClick(e) {
							return _this2.handleChildClick(e, item);
						}
					},
					item.label
				);
			}));

			return menuItems;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _state5 = this.state,
			    leftPane = _state5.leftPane,
			    rightPane = _state5.rightPane,
			    searchTerm = _state5.searchTerm,
			    selected = _state5.selected;


			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_ads.GroupedMenu,
					null,
					_react2.default.createElement(
						_ads.GroupedMenuHeader,
						null,
						_react2.default.createElement(
							_wdsReact.InputGroup,
							{ stretched: true },
							_react2.default.createElement(_wdsReact.Input, {
								onKeyPress: function onKeyPress(e) {
									if (e.charCode === 13) {
										e.preventDefault();
									}
								},
								value: searchTerm,
								onChange: this.handleSearch,
								placeholder: gettext('Search...')
							}),
							_react2.default.createElement(
								_wdsReact.InputGroupAddon,
								null,
								_react2.default.createElement(_wdsIcons.IconSearch, null)
							)
						)
					),
					_react2.default.createElement(
						_ads.GroupedMenuBody,
						{ className: 'wds-flex' },
						_react2.default.createElement(
							_ads.GroupedMenuBodyLeft,
							{ className: 'wds-flex__item--grow' },
							this.paneRenderer(leftPane, 'left')
						),
						_react2.default.createElement(
							_ads.GroupedMenuBodyRight,
							{ className: 'wds-flex__item--grow' },
							this.paneRenderer(rightPane, 'right')
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'wds-label mt-3' },
					gettext('Selected:')
				),
				selected.length > 0 ? selected.map(function (item, index) {
					return _react2.default.createElement(
						_wdsReact.Tooltip,
						{
							key: index + '-' + item.id,
							text: item.group
						},
						_react2.default.createElement(
							_wdsReact.Badge,
							{
								dismissible: true,
								onClose: function onClose(e) {
									return _this3.handleBadgeRemove(e, index);
								},
								show: true
							},
							item.label
						)
					);
				}) : _react2.default.createElement(
					'p',
					{ className: 'sma-piping-none-selected' },
					gettext('No items selected')
				),
				selected.some(function (item) {
					return item.isMulti;
				}) && _react2.default.createElement(
					'div',
					{ className: 'mt-2' },
					_react2.default.createElement(
						_wdsReact.Select,
						{
							id: 'sma-js-pipes-delim-selector',
							label: gettext('Set how to display fields that have multiple results'),
							value: '',
							stretched: true,
							native: true
						},
						_react2.default.createElement(
							_wdsReact.Option,
							{ value: '' },
							gettext('Bulleted list (multi-line)')
						),
						_react2.default.createElement(
							_wdsReact.Option,
							{ value: 'ol' },
							gettext('Numbered list (multi-line)')
						),
						_react2.default.createElement(
							_wdsReact.Option,
							{ value: 'comma' },
							gettext('Comma (", ")')
						),
						_react2.default.createElement(
							_wdsReact.Option,
							{ value: 'semicolon' },
							gettext('Semi-colon ("; ")')
						),
						_react2.default.createElement(
							_wdsReact.Option,
							{ value: 'pipe' },
							gettext('Vertical line (" | ")')
						)
					)
				)
			);
		}
	}]);

	return Piper;
}(_react2.default.Component);

exports.default = Piper;


Piper.propTypes = {
	data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		label: _propTypes2.default.string.isRequired,
		id: _propTypes2.default.number.isRequired,
		data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			id: _propTypes2.default.number.isRequired,
			is_multi: _propTypes2.default.bool.isRequired,
			label: _propTypes2.default.string.isRequired,
			value: _propTypes2.default.string.isRequired
		})),
		extra_data: _propTypes2.default.shape({
			program_name: _propTypes2.default.string,
			round_name: _propTypes2.default.string
		})
	})).isRequired,
	updateQueue: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1568);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<h5 type=\"button\" class=\"");t.b(t.v(t.f("extraClass",c,p,0)));t.b(" ");if(!t.s(t.f("noCaret",c,p,1),c,p,1,0,0,"")){t.b("dropdown-toggle");};t.b(" add-cursor\" data-toggle=\"dropdown\"");t.b("\n" + i);t.b("	aria-haspopup=\"true\" aria-expanded=\"false\">");t.b("\n" + i);t.b("	");t.b(t.t(t.f("title",c,p,0)));t.b("\n" + i);t.b("</h5>");t.b("\n");t.b("\n" + i);t.b("<div class=\"dropdown-menu ");if(t.s(t.f("rightAligned",c,p,1),c,p,0,225,244,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("dropdown-menu-right");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("items",c,p,1),c,p,0,275,559,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("header",c,p,1),c,p,0,289,338,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<h6 class=\"dropdown-header\">");t.b(t.t(t.f("text",c,p,0)));t.b("</h6>");t.b("\n" + i);});c.pop();}if(t.s(t.f("divider",c,p,1),c,p,0,364,407,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"dropdown-divider\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("header",c,p,1),c,p,1,0,0,"")){if(!t.s(t.f("divider",c,p,1),c,p,1,0,0,"")){t.b("		<a class=\"");t.b(t.v(t.f("extraItemClass",c,p,0)));t.b(" dropdown-item\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" href=\"#\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);};};});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<h5 type=\"button\" class=\"{{extraClass}} {{^noCaret}}dropdown-toggle{{/noCaret}} add-cursor\" data-toggle=\"dropdown\"\n\taria-haspopup=\"true\" aria-expanded=\"false\">\n\t{{{ title }}}\n</h5>\n\n<div class=\"dropdown-menu {{#rightAligned}}dropdown-menu-right{{/rightAligned}}\">\n\t{{#items}}\n\t\t{{#header}}\n\t\t<h6 class=\"dropdown-header\">{{{text}}}</h6>\n\t\t{{/header}}\n\t\t{{#divider}}\n\t\t\t<div class=\"dropdown-divider\"></div>\n\t\t{{/divider}}\n\t\t{{^header}}{{^divider}}\n\t\t<a class=\"{{extraItemClass}} dropdown-item\" name=\"{{name}}\" href=\"#\">{{{text}}}</a>\n\t\t{{/divider}}{{/header}}\n\t{{/items}}\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class='");if(!t.s(t.f("inline",c,p,1),c,p,1,0,0,"")){t.b("input-group");};t.b(" sma-dropselect-wrapper ");if(t.s(t.f("fullWidth",c,p,1),c,p,0,83,108,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-dropselect-full-width");});c.pop();}t.b(" ");if(t.s(t.f("dropup",c,p,1),c,p,0,134,140,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("dropup");});c.pop();}t.b("'>");t.b("\n" + i);if(!t.s(t.f("noDropdown",c,p,1),c,p,1,0,0,"")){t.b("	<button type=\"button\" class=\"");t.b(t.v(t.f("buttonSize",c,p,0)));t.b(" ");if(t.s(t.f("dropdownToggle",c,p,1),c,p,0,235,250,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("dropdown-toggle");});c.pop();}t.b(" btn btn-default sma-js-dropdown-toggle ");t.b("\n" + i);t.b("		");t.b(t.v(t.f("textStyleButton",c,p,0)));t.b("\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">");t.b("\n" + i);t.b("			");t.b(t.t(t.f("title",c,p,0)));t.b("\n" + i);t.b("		</button>");t.b("\n" + i);};t.b("	 <div class=\"dropdown-menu ");if(t.s(t.f("noDropdown",c,p,1),c,p,0,489,504,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-no-dropdown");});c.pop();}t.b(" ");if(t.s(t.f("alignRight",c,p,1),c,p,0,535,554,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("dropdown-menu-right");});c.pop();}t.b(" ");t.b("\n" + i);t.b("		 sma-dropselect ");if(t.s(t.f("drilldown",c,p,1),c,p,0,603,616,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-drilldown");});c.pop();}t.b(" ");if(t.s(t.f("editable",c,p,1),c,p,0,644,667,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-dropselect-editable");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("closeButton",c,p,1),c,p,0,701,897,"{{ }}")){t.rs(c,p,function(c,p,t){});c.pop();}t.b("		<!--");t.b("\n" + i);t.b("		<div class=\"input-group\">");t.b("\n" + i);t.b("			<input type=\"text\" class=\"form-control\" placeholder=\"");t.b(t.v(t.f("searchfor",c,p,0)));t.b("\">");t.b("\n" + i);t.b("			<span class=\"input-group-btn\">");t.b("\n" + i);t.b("					<button class=\"btn btn-default\" type=\"button\">");t.b(t.v(t.f("go",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		-->");t.b("\n" + i);t.b("		<div class=\"sma-dropselect-content ");if(t.s(t.f("drilldown",c,p,1),c,p,0,1204,1207,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("row");});c.pop();}t.b("\">");t.b("\n" + i);if(t.s(t.f("drilldown",c,p,1),c,p,0,1241,1301,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"sma-dropselect-sections col-md-6\"></div>");t.b("\n" + i);});c.pop();}t.b("			<div class=\"sma-dropselect-items");if(t.s(t.f("drilldown",c,p,1),c,p,0,1365,1374,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" col-md-6");});c.pop();}t.b("\"></div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);if(t.s(t.f("selectedCount",c,p,1),c,p,0,1426,1502,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<div class=\"sma-js-selected-count sma-dropselect-select-count\"></div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("noFooter",c,p,1),c,p,1,0,0,"")){t.b("			<div class=\"sma-dropselect-footer\">");t.b("\n" + i);if(t.s(t.f("showSelectControls",c,p,1),c,p,0,1603,2018,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("					<div class=\"sma-js-dropselect-select-controls d-flex justify-content-between\">");t.b("\n" + i);t.b("						<div>");t.b("\n" + i);t.b("							");t.b(t.v(t.d("strings.selected",c,p,0)));t.b(" <span class=\"sma-js-dropselect-selected-count\"></span>");t.b("\n" + i);t.b("						</div>");t.b("\n" + i);t.b("						<div>");t.b("\n" + i);t.b("							<a href=\"#\" class=\"sma-js-dropselect-select-all\">");t.b(t.v(t.d("strings.all",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("							&nbsp;|&nbsp;");t.b("\n" + i);t.b("							<a href=\"#\" class=\"sma-js-dropselect-select-none\">");t.b(t.v(t.d("strings.none",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("						</div>");t.b("\n" + i);t.b("					</div>");t.b("\n" + i);});c.pop();}t.b("				<div class=\"row\">");t.b("\n" + i);t.b("					<div class=\"col-md-12\">");t.b("\n" + i);t.b("						<div class=\"text-sm-right\">");t.b("\n" + i);if(t.s(t.f("createButton",c,p,1),c,p,0,2151,2334,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("								<button class=\"btn btn-default btn-sm sma-js-dropselect-create-new float-sm-left\" id=\"sma-btn-create\" type=\"button\" data-toggle=\"modal\">");t.b(t.v(t.f("createButtonLabel",c,p,0)));t.b("</button>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("noCancelButton",c,p,1),c,p,1,0,0,"")){t.b("								<button class=\"btn btn-default ");t.b(t.v(t.f("cancelClass",c,p,0)));t.b("\" type=\"button\">");t.b(t.v(t.f("cancel",c,p,0)));t.b("</button>");t.b("\n" + i);};if(!t.s(t.f("noDoneButton",c,p,1),c,p,1,0,0,"")){t.b("								<button class=\"");t.b(t.v(t.f("doneButtonSize",c,p,0)));t.b(" btn btn-primary ");t.b(t.v(t.f("doneClass",c,p,0)));t.b("\" type=\"button\">");t.b(t.v(t.f("done",c,p,0)));t.b("</button>");t.b("\n" + i);};t.b("						</div>");t.b("\n" + i);t.b("					</div>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);};t.b("	</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class='{{^inline}}input-group{{/inline}} sma-dropselect-wrapper {{#fullWidth}}sma-dropselect-full-width{{/fullWidth}} {{#dropup}}dropup{{/dropup}}'>\n\t{{^noDropdown}}\n\t<button type=\"button\" class=\"{{buttonSize}} {{#dropdownToggle}}dropdown-toggle{{/dropdownToggle}} btn btn-default sma-js-dropdown-toggle \n\t\t{{textStyleButton}}\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n\t\t\t{{{ title }}}\n\t\t</button>\n\t{{/noDropdown}}\n\t <div class=\"dropdown-menu {{#noDropdown}}sma-no-dropdown{{/noDropdown}} {{#alignRight}}dropdown-menu-right{{/alignRight}} \n\t\t sma-dropselect {{#drilldown}}sma-drilldown{{/drilldown}} {{#editable}}sma-dropselect-editable{{/editable}}\">\n\t\t{{#closeButton}}\n\t\t\t{{!<div class=\"sma-dropselect-header\">}}\n\t\t\t\t{{!<button type=\"button\" class=\"close\" aria-label=\"Close\">}}\n\t\t\t\t\t{{!<span aria-hidden=\"true\">&times;</span>}}\n\t\t\t\t{{!</button>}}\n\t\t\t{{!</div>}}\n\t\t{{/closeButton}}\n\t\t<!--\n\t\t<div class=\"input-group\">\n\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"{{ searchfor }}\">\n\t\t\t<span class=\"input-group-btn\">\n\t\t\t\t\t<button class=\"btn btn-default\" type=\"button\">{{ go }}</button>\n\t\t\t\t</span>\n\t\t</div>\n\t\t-->\n\t\t<div class=\"sma-dropselect-content {{#drilldown}}row{{/drilldown}}\">\n\t\t\t{{#drilldown}}\n\t\t\t<div class=\"sma-dropselect-sections col-md-6\"></div>\n\t\t\t{{/drilldown}}\n\t\t\t<div class=\"sma-dropselect-items{{#drilldown}} col-md-6{{/drilldown}}\"></div>\n\t\t</div>\n\t\t{{#selectedCount}}\n\t\t\t<div class=\"sma-js-selected-count sma-dropselect-select-count\"></div>\n\t\t{{/selectedCount}}\n\t\t{{^noFooter}}\n\t\t\t<div class=\"sma-dropselect-footer\">\n\t\t\t\t{{#showSelectControls}}\n\t\t\t\t\t<div class=\"sma-js-dropselect-select-controls d-flex justify-content-between\">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t{{ strings.selected }} <span class=\"sma-js-dropselect-selected-count\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<a href=\"#\" class=\"sma-js-dropselect-select-all\">{{ strings.all }}</a>\n\t\t\t\t\t\t\t&nbsp;|&nbsp;\n\t\t\t\t\t\t\t<a href=\"#\" class=\"sma-js-dropselect-select-none\">{{ strings.none }}</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t{{/showSelectControls}}\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t\t<div class=\"text-sm-right\">\n\t\t\t\t\t\t\t{{#createButton}}\n\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm sma-js-dropselect-create-new float-sm-left\" id=\"sma-btn-create\" type=\"button\" data-toggle=\"modal\">{{createButtonLabel}}</button>\n\t\t\t\t\t\t\t{{/createButton}}\n\t\t\t\t\t\t\t{{^noCancelButton}}\n\t\t\t\t\t\t\t\t<button class=\"btn btn-default {{ cancelClass }}\" type=\"button\">{{ cancel }}</button>\n\t\t\t\t\t\t\t{{/noCancelButton}}\n\t\t\t\t\t\t\t{{^noDoneButton}}\n\t\t\t\t\t\t\t\t<button class=\"{{doneButtonSize}} btn btn-primary {{ doneClass }}\" type=\"button\">{{ done }}</button>\n\t\t\t\t\t\t\t{{/noDoneButton}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t{{/noFooter}}\n\t</div>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("items",c,p,1),c,p,0,10,135,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div>");t.b("\n" + i);t.b("		<a class=\"sma-js-dropselect-popover-item\" name=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\" data-item=\"");t.b(t.v(t.f("itemName",c,p,0)));t.b("\" href=\"#\">");t.b(t.t(t.f("text",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#items}}\n\t<div>\n\t\t<a class=\"sma-js-dropselect-popover-item\" name=\"{{name}}\" data-item=\"{{itemName}}\" href=\"#\">{{{text}}}</a>\n\t</div>\n{{/items}}\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popover sma-dropselect-popover-wrapper\" role=\"tooltip\">\n   <div class=\"popover-arrow\"></div>\n   <div class=\"popover-content\"></div>\n</div>"

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropSelect = __webpack_require__(114);

var selectTempl = __webpack_require__(1579);
var itemsTempl = __webpack_require__(898);
var itemsExtendedTempl = __webpack_require__(1580);

var DropSelectExtendable = function (_DropSelect) {
	_inherits(DropSelectExtendable, _DropSelect);

	function DropSelectExtendable() {
		_classCallCheck(this, DropSelectExtendable);

		return _possibleConstructorReturn(this, (DropSelectExtendable.__proto__ || Object.getPrototypeOf(DropSelectExtendable)).apply(this, arguments));
	}

	_createClass(DropSelectExtendable, [{
		key: 'initialize',
		value: function initialize(options) {
			$(document).on('click', '.sma-dropselect, .sma-dropselect .dropdown-item', function (e) {
				e.stopPropagation();
			});

			this.extraItems = options.extraItems;
			this.setItems(options.items);

			this.onDone = options.onDone || function () {
				return;
			};

			this.title = options.title;

			this.render();

			if (this.$selectEl) {
				this.$selectEl.after(this.$el);
			}
		}
	}, {
		key: 'hideDropdown',
		value: function hideDropdown(e) {
			return false;
		}
	}, {
		key: 'renderItems',
		value: function renderItems() {
			this.$items = this.$el.find('.sma-dropselect-items');
			this.$items.empty();

			var context = {
				items: this.items,
				checkboxes: true,
				extraItems: this.extraItems
			};

			this.$items.append(itemsTempl(context));

			if (this.$selectEl) {
				this.selectItemFromSelect();
			}
		}
	}, {
		key: 'renderExtraItems',
		value: function renderExtraItems() {
			this.$extraItems = this.$el.find('.sma-dropselect-extra-items');
			this.$extraItems.empty();

			var items = {
				extraItems: this.extraItems
			};

			this.$extraItems.append(itemsExtendedTempl(items));
		}
	}, {
		key: 'renderContents',
		value: function renderContents() {
			this.renderItems();
			this.renderExtraItems();
		}
	}, {
		key: 'render',
		value: function render() {

			this._el = selectTempl({
				title: this.title,
				cancel: gettext('Cancel'),
				done: gettext('Done')
			});

			this.setElement(this._el);

			this.renderContents();

			if (this.$selectEl) {
				this.$selectEl.hide();
			}
		}
	}, {
		key: 'showExtraColumns',
		value: function showExtraColumns(e) {
			e.preventDefault();

			var key = $(e.currentTarget).attr('data-key');
			this.currentEl = $("#" + key);
			this.currentEl.show();

			this.$items.hide();
		}
	}, {
		key: 'showItems',
		value: function showItems(e) {
			this.currentEl.hide();
			this.$items.show();
		}
	}, {
		key: 'handleDone',
		value: function handleDone() {
			this.updateChangedItems();
			this.onDone(this.changedItems);
			this.$el.removeClass('show');
			return false;
		}
	}, {
		key: 'events',
		get: function get() {
			return {
				'click .sma-js-dropselect-done': 'handleDone',
				'click .sma-js-dropselect-cancel': 'handleCancel',
				'click .sma-js-action-item': 'selectItem',
				'change .dropdown-item input[type="checkbox"]': 'itemChanged',
				'hide.bs.dropdown': 'hideDropdown',
				'shown.bs.dropdown': 'getItems',
				'click .sma-js-select-parent': 'showExtraColumns',
				'click .sma-js-select-back': 'showItems'
			};
		}
	}, {
		key: 'displayedItems',
		get: function get() {
			var items = [];

			_.each(this.$items.children(), function (item) {
				var $item = $(item).find('input');

				items.push({
					name: $item.attr('name'),
					text: $item.parent().text(),
					checked: $item.is(':checked')
				});
			});

			_.each(this.$extraItems.children(), function (extraItem) {
				var $itemList = $(extraItem).find('input');

				_.each($itemList, function (item) {
					var $item = $(item);
					items.push({
						name: $item.attr('name'),
						text: $item.parent().text(),
						checked: $item.is(':checked')
					});
				});
			});

			return items;
		}
	}]);

	return DropSelectExtendable;
}(DropSelect);

module.exports = DropSelectExtendable;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class='input-group sma-dropselect-wrapper'>");t.b("\n" + i);t.b("	<button type=\"button\" class=\"btn-md btn btn-default sma-js-dropdown-toggle\" data-toggle=\"dropdown\"");t.b("\n" + i);t.b("		aria-haspopup=\"true\" aria-expanded=\"false\">");t.b("\n" + i);t.b("		");t.b(t.t(t.f("title",c,p,0)));t.b("\n" + i);t.b("	</button>");t.b("\n" + i);t.b("	<div class=\"dropdown-menu dropdown-menu-right sma-dropselect\">");t.b("\n" + i);t.b("		<div class=\"sma-dropselect-content\">");t.b("\n" + i);t.b("			<div class=\"sma-dropselect-items\"></div>");t.b("\n" + i);t.b("			<div class=\"sma-dropselect-extra-items\"></div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		<div class=\"sma-dropselect-footer\">");t.b("\n" + i);t.b("			<div class=\"row\">");t.b("\n" + i);t.b("				<div class=\"col-md-12\">");t.b("\n" + i);t.b("					<div class=\"text-sm-right\">");t.b("\n" + i);t.b("						<button class=\"btn btn-default sma-js-dropselect-cancel\" type=\"button\">");t.b(t.v(t.f("cancel",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("						<button class=\"btn-md btn btn-primary sma-js-dropselect-done\" type=\"button\">");t.b(t.v(t.f("done",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("					</div>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class='input-group sma-dropselect-wrapper'>\n\t<button type=\"button\" class=\"btn-md btn btn-default sma-js-dropdown-toggle\" data-toggle=\"dropdown\"\n\t\taria-haspopup=\"true\" aria-expanded=\"false\">\n\t\t{{{ title }}}\n\t</button>\n\t<div class=\"dropdown-menu dropdown-menu-right sma-dropselect\">\n\t\t<div class=\"sma-dropselect-content\">\n\t\t\t<div class=\"sma-dropselect-items\"></div>\n\t\t\t<div class=\"sma-dropselect-extra-items\"></div>\n\t\t</div>\n\t\t<div class=\"sma-dropselect-footer\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-12\">\n\t\t\t\t\t<div class=\"text-sm-right\">\n\t\t\t\t\t\t<button class=\"btn btn-default sma-js-dropselect-cancel\" type=\"button\">{{ cancel }}</button>\n\t\t\t\t\t\t<button class=\"btn-md btn btn-primary sma-js-dropselect-done\" type=\"button\">{{ done }}</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("extraItems",c,p,1),c,p,0,15,724,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"sma-js-select-container sma-dropselect-extra-items\" id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" style=\"display: none;\">");t.b("\n" + i);t.b("		<button type=\"button\" class=\"btn btn-default sma-js-select-back\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini arrows-1_minimal-left\"></i>");t.b("\n" + i);t.b("		</button>");t.b("\n" + i);t.b("		<strong>");t.b(t.v(t.f("name",c,p,0)));t.b("</strong>");t.b("\n");t.b("\n" + i);if(t.s(t.f("columns",c,p,1),c,p,0,296,703,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<span class=\"dropdown-item\">");t.b("\n" + i);t.b("				<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("					<input class=\"custom-control-input\" name=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" type=\"checkbox\" ");if(t.s(t.f("checked",c,p,1),c,p,0,463,500,"{{ }}")){t.rs(c,p,function(c,p,t){if(!t.s(t.f("mixedCheck",c,p,1),c,p,1,0,0,"")){t.b("checked");};});c.pop();}t.b(">");t.b("\n" + i);t.b("					<span class=\"custom-control-indicator ");if(t.s(t.f("mixedCheck",c,p,1),c,p,0,572,590,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("sma-js-mixed-check");});c.pop();}t.b("\"></span>");t.b("\n" + i);t.b("					<span class=\"custom-control-description\">");t.b(t.v(t.f("name",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);t.b("			</span>");t.b("\n" + i);});c.pop();}t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#extraItems}}\n\t<div class=\"sma-js-select-container sma-dropselect-extra-items\" id=\"{{ id }}\" style=\"display: none;\">\n\t\t<button type=\"button\" class=\"btn btn-default sma-js-select-back\">\n\t\t\t<i class=\"nc-icon-mini arrows-1_minimal-left\"></i>\n\t\t</button>\n\t\t<strong>{{name}}</strong>\n\n\t\t{{#columns}}\n\t\t\t<span class=\"dropdown-item\">\n\t\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input class=\"custom-control-input\" name=\"{{id}}\" type=\"checkbox\" {{#checked}}{{^mixedCheck}}checked{{/mixedCheck}}{{/checked}}>\n\t\t\t\t\t<span class=\"custom-control-indicator {{#mixedCheck}}sma-js-mixed-check{{/mixedCheck}}\"></span>\n\t\t\t\t\t<span class=\"custom-control-description\">{{name}}</span>\n\t\t\t\t</label>\n\t\t\t</span>\n\t\t{{/columns}}\n\t</div>\n{{/extraItems}}\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-grid-empty\">");t.b("\n" + i);t.b("   <div class=\"sma-grid-empty-message\">");t.b("\n" + i);t.b("      ");t.b(t.t(t.f("message",c,p,0)));t.b("\n" + i);t.b("   </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-grid-empty\">\n   <div class=\"sma-grid-empty-message\">\n      {{{ message }}}\n   </div>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<label class=\"custom-control custom-checkbox\">\r");t.b("\n" + i);t.b("	<input name=\"checkbox\" type=\"checkbox\" class=\"");if(t.s(t.f("class",c,p,1),c,p,0,105,114,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(t.v(t.f("class",c,p,0)));});c.pop();}t.b(" custom-control-input\">\r");t.b("\n" + i);t.b("	<span class=\"custom-control-indicator\"></span>\r");t.b("\n" + i);t.b("</label>");return t.fl(); },partials: {}, subs: {  }}, "<label class=\"custom-control custom-checkbox\">\r\n\t<input name=\"checkbox\" type=\"checkbox\" class=\"{{#class}}{{class}}{{/class}} custom-control-input\">\r\n\t<span class=\"custom-control-indicator\"></span>\r\n</label>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<tr id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"sma-grid-nested-row\">");t.b("\n" + i);t.b("	<td colspan=\"100%\">");t.b("\n" + i);t.b("		<div id=\"");t.b(t.v(t.f("nestedId",c,p,0)));t.b("\"></div>");t.b("\n" + i);t.b("	</td>");t.b("\n" + i);t.b("</tr>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<tr id=\"{{id}}\" class=\"sma-grid-nested-row\">\n\t<td colspan=\"100%\">\n\t\t<div id=\"{{nestedId}}\"></div>\n\t</td>\n</tr>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<select class=\"custom-select sma-js-rows-per-page-selector\">");t.b("\n" + i);if(t.s(t.f("items",c,p,1),c,p,0,75,171,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <option value=\"");t.b(t.v(t.f("value",c,p,0)));t.b("\" ");if(t.s(t.f("selected",c,p,1),c,p,0,125,133,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("selected");});c.pop();}t.b(">");t.b(t.v(t.f("name",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("</select>");return t.fl(); },partials: {}, subs: {  }}, "<select class=\"custom-select sma-js-rows-per-page-selector\">\n    {{#items}}\n        <option value=\"{{ value }}\" {{#selected}}selected{{/selected}}>{{ name }}</option>\n    {{/items}} \n</select>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<ul class=\"errorlist\">");t.b("\n" + i);t.b("	<li>");t.b(t.t(t.f("message",c,p,0)));t.b("</li>");t.b("\n" + i);t.b("</ul>");return t.fl(); },partials: {}, subs: {  }}, "<ul class=\"errorlist\">\n\t<li>{{{ message }}}</li>\n</ul>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"callout ");t.b(t.v(t.f("callout_class",c,p,0)));t.b("\" role=\"alert\">");t.b("\n" + i);t.b("	<div class=\"callout-content\">");t.b("\n" + i);t.b("		");t.b(t.t(t.f("content",c,p,0)));t.b("\n" + i);t.b("	</div>");t.b("\n");t.b("\n" + i);if(t.s(t.f("callout_close",c,p,1),c,p,0,132,234,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<a type=\"button\" class=\"close\" aria-label=\"Close\">");t.b("\n" + i);t.b("		<span aria-hidden=\"true\">&times;</span>");t.b("\n" + i);t.b("	</a>");t.b("\n" + i);});c.pop();}t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"callout {{ callout_class }}\" role=\"alert\">\n\t<div class=\"callout-content\">\n\t\t{{{ content }}}\n\t</div>\n\n\t{{#callout_close}}\n\t<a type=\"button\" class=\"close\" aria-label=\"Close\">\n\t\t<span aria-hidden=\"true\">&times;</span>\n\t</a>\n\t{{/callout_close}}\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-js-pwd-strength-reqs password-help\">");t.b("\n" + i);t.b("	<div><strong>");t.b(t.v(t.d("strings.helptext",c,p,0)));t.b(":</strong></div>");t.b("\n" + i);t.b("	");t.b("\n" + i);t.b("	<div class=\"password-help-criteria\">");t.b("\n" + i);t.b("		<div class=\"sma-js-pwd-chars\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> ");t.b(t.v(t.d("strings.chars",c,p,0)));t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		");t.b("\n" + i);t.b("		<div class=\"sma-js-pwd-uppercase\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> ");t.b(t.v(t.d("strings.uppercase",c,p,0)));t.b("\n" + i);t.b("		</div>");t.b("\n");t.b("\n" + i);t.b("		<div class=\"sma-js-pwd-lowercase\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> ");t.b(t.v(t.d("strings.lowercase",c,p,0)));t.b("\n" + i);t.b("		</div>");t.b("\n");t.b("\n" + i);t.b("		<div class=\"sma-js-pwd-number\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> ");t.b(t.v(t.d("strings.number",c,p,0)));t.b("\n" + i);t.b("		</div>");t.b("\n");t.b("\n" + i);t.b("		<div class=\"sma-js-pwd-specchar\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> ");t.b(t.v(t.d("strings.specchar",c,p,0)));t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-js-pwd-strength-reqs password-help\">\n\t<div><strong>{{strings.helptext}}:</strong></div>\n\t\n\t<div class=\"password-help-criteria\">\n\t\t<div class=\"sma-js-pwd-chars\">\n\t\t\t<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> {{strings.chars}}\n\t\t</div>\n\t\t\n\t\t<div class=\"sma-js-pwd-uppercase\">\n\t\t\t<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> {{strings.uppercase}}\n\t\t</div>\n\n\t\t<div class=\"sma-js-pwd-lowercase\">\n\t\t\t<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> {{strings.lowercase}}\n\t\t</div>\n\n\t\t<div class=\"sma-js-pwd-number\">\n\t\t\t<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> {{strings.number}}\n\t\t</div>\n\n\t\t<div class=\"sma-js-pwd-specchar\">\n\t\t\t<i class=\"nc-icon-mini ui-1_bold-delete\" aria-hidden=\"true\"></i> {{strings.specchar}}\n\t\t</div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*************************
 * Croppie
 * Copyright 2016
 * Foliotek
 * Version: 2.4.1
 *************************/
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports);
    } else {
        // Browser globals
        factory((root.commonJsStrict = {}));
    }
}(this, function (exports) {

    /* Polyfills */
    if (typeof Promise !== 'function') {
        /*! promise-polyfill 3.1.0 */
        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"==typeof a?a:null,this.onRejected="function"==typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"==typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"==typeof g||"function"==typeof g)){var h=g.then;if("function"==typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"==typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!=typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
    }

    if ( typeof window.CustomEvent !== "function" ) {
        (function(){
            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }
            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        }());
    }

    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function (callback, type, quality) {
                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                len = binStr.length,
                arr = new Uint8Array(len);

                for (var i=0; i<len; i++ ) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback( new Blob( [arr], {type: type || 'image/png'} ) );
            }
        });
    }
    /* End Polyfills */

    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
        emptyStyles = document.createElement('div').style,
        CSS_TRANS_ORG,
        CSS_TRANSFORM,
        CSS_USERSELECT;

    function vendorPrefix(prop) {
        if (prop in emptyStyles) {
            return prop;
        }

        var capProp = prop[0].toUpperCase() + prop.slice(1),
            i = cssPrefixes.length;

        while (i--) {
            prop = cssPrefixes[i] + capProp;
            if (prop in emptyStyles) {
                return prop;
            }
        }
    }

    CSS_TRANSFORM = vendorPrefix('transform');
    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
    CSS_USERSELECT = vendorPrefix('userSelect');

    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
    function deepExtend(destination, source) {
        destination = destination || {};
        for (var property in source) {
            if (source[property] && source[property].constructor && source[property].constructor === Object) {
                destination[property] = destination[property] || {};
                deepExtend(destination[property], source[property]);
            } else {
                destination[property] = source[property];
            }
        }
        return destination;
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function dispatchChange(element) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            element.dispatchEvent(evt);
        }
        else {
            element.fireEvent("onchange");
        }
    }

    //http://jsperf.com/vanilla-css
    function css(el, styles, val) {
        if (typeof (styles) === 'string') {
            var tmp = styles;
            styles = {};
            styles[tmp] = val;
        }

        for (var prop in styles) {
            el.style[prop] = styles[prop];
        }
    }

    function addClass(el, c) {
        if (el.classList) {
            el.classList.add(c);
        }
        else {
            el.className += ' ' + c;
        }
    }

    function removeClass(el, c) {
        if (el.classList) {
            el.classList.remove(c);
        }
        else {
            el.className = el.className.replace(c, '');
        }
    }

    function num(v) {
        return parseInt(v, 10);
    }

    /* Utilities */
    function loadImage(src, imageEl) {
        var img = imageEl || new Image();
        img.style.opacity = 0;

        return new Promise(function (resolve) {
            if (img.src === src) {
                // If image source hasn't changed resolve immediately
                resolve(img);
            } 
            else {
                img.removeAttribute('crossOrigin');
                if (src.match(/^https?:\/\/|^\/\//)) {
                    img.setAttribute('crossOrigin', 'anonymous');
                }
                img.onload = function () {
                    setTimeout(function () {
                        resolve(img);
                    }, 1);
                }
                img.src = src;
            }
        });
    }


    /* CSS Transform Prototype */
    var TRANSLATE_OPTS = {
        'translate3d': {
            suffix: ', 0px'
        },
        'translate': {
            suffix: ''
        }
    };
    var Transform = function (x, y, scale) {
        this.x = parseFloat(x);
        this.y = parseFloat(y);
        this.scale = parseFloat(scale);
    };

    Transform.parse = function (v) {
        if (v.style) {
            return Transform.parse(v.style[CSS_TRANSFORM]);
        }
        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
            return Transform.fromMatrix(v);
        }
        else {
            return Transform.fromString(v);
        }
    };

    Transform.fromMatrix = function (v) {
        var vals = v.substring(7).split(',');
        if (!vals.length || v === 'none') {
            vals = [1, 0, 0, 1, 0, 0];
        }

        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
    };

    Transform.fromString = function (v) {
        var values = v.split(') '),
            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
            scale = values.length > 1 ? values[1].substring(6) : 1,
            x = translate.length > 1 ? translate[0] : 0,
            y = translate.length > 1 ? translate[1] : 0;

        return new Transform(x, y, scale);
    };

    Transform.prototype.toString = function () {
        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
    };

    var TransformOrigin = function (el) {
        if (!el || !el.style[CSS_TRANS_ORG]) {
            this.x = 0;
            this.y = 0;
            return;
        }
        var css = el.style[CSS_TRANS_ORG].split(' ');
        this.x = parseFloat(css[0]);
        this.y = parseFloat(css[1]);
    };

    TransformOrigin.prototype.toString = function () {
        return this.x + 'px ' + this.y + 'px';
    };

    function getExifOrientation (img, cb) {
        if (!window.EXIF) {
            cb(0);
        }

        EXIF.getData(img, function () {
            var orientation = EXIF.getTag(this, 'Orientation');
            cb(orientation);
        });
    }

    function drawCanvas(canvas, img, orientation) {
        var width = img.width,
            height = img.height,
            ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.save();
        switch (orientation) {
          case 2:
             ctx.translate(width, 0);
             ctx.scale(-1, 1);
             break;

          case 3:
              ctx.translate(width, height);
              ctx.rotate(180*Math.PI/180);
              break;

          case 4:
              ctx.translate(0, height);
              ctx.scale(1, -1);
              break;

          case 5:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.scale(1, -1);
              break;

          case 6:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.translate(0, -height);
              break;

          case 7:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(-90*Math.PI/180);
              ctx.translate(-width, height);
              ctx.scale(1, -1);
              break;

          case 8:
              canvas.width = height;
              canvas.height = width;
              ctx.translate(0, width);
              ctx.rotate(-90*Math.PI/180);
              break;
        }
        ctx.drawImage(img, 0,0, width, height);
        ctx.restore();
    }

    /* Private Methods */
    function _create() {
        var self = this,
            contClass = 'croppie-container',
            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
            boundary, img, viewport, overlay, canvas, bw, bh;

        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
        // Properties on class
        self.data = {};
        self.elements = {};

        // Generating Markup
        boundary = self.elements.boundary = document.createElement('div');
        viewport = self.elements.viewport = document.createElement('div');
        img = self.elements.img = document.createElement('img');
        overlay = self.elements.overlay = document.createElement('div');

        if (self.options.useCanvas) {
            self.elements.canvas = document.createElement('canvas');
            self.elements.preview = self.elements.canvas;
        }
        else {
            self.elements.preview = self.elements.img;
        }

        addClass(boundary, 'cr-boundary');
        bw = self.options.boundary.width;
        bh = self.options.boundary.height;
        css(boundary, {
            width: (bw + (isNaN(bw) ? '' : 'px')),
            height: (bh + (isNaN(bh) ? '' : 'px'))
        });

        addClass(viewport, 'cr-viewport');
        if (customViewportClass) {
            addClass(viewport, customViewportClass);
        }
        css(viewport, {
            width: self.options.viewport.width + 'px',
            height: self.options.viewport.height + 'px'
        });
        viewport.setAttribute('tabindex', 0);

        addClass(self.elements.preview, 'cr-image');
        addClass(overlay, 'cr-overlay');

        self.element.appendChild(boundary);
        boundary.appendChild(self.elements.preview);
        boundary.appendChild(viewport);
        boundary.appendChild(overlay);

        addClass(self.element, contClass);
        if (self.options.customClass) {
            addClass(self.element, self.options.customClass);
        }

        _initDraggable.call(this);

        if (self.options.enableZoom) {
            _initializeZoom.call(self);
        }

        // if (self.options.enableOrientation) {
        //     _initRotationControls.call(self);
        // }
    }

    // function _initRotationControls () {
    //     var self = this,
    //         wrap, btnLeft, btnRight, iLeft, iRight;

    //     wrap = document.createElement('div');
    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');

    //     wrap.appendChild(btnLeft);
    //     wrap.appendChild(btnRight);

    //     iLeft = document.createElement('i');
    //     iRight = document.createElement('i');
    //     btnLeft.appendChild(iLeft);
    //     btnRight.appendChild(iRight);

    //     addClass(wrap, 'cr-rotate-controls');
    //     addClass(btnLeft, 'cr-rotate-l');
    //     addClass(btnRight, 'cr-rotate-r');

    //     self.elements.boundary.appendChild(wrap);

    //     btnLeft.addEventListener('click', function () {
    //         self.rotate(-90);
    //     });
    //     btnRight.addEventListener('click', function () {
    //         self.rotate(90);
    //     });
    // }

    function _hasExif() {
        return this.options.enableExif && window.EXIF;
    }

    function _setZoomerVal(v) {
        if (this.options.enableZoom) {
            var z = this.elements.zoomer,
                val = fix(v, 4);

            z.value = Math.max(z.min, Math.min(z.max, val));
        }
    }

    function _initializeZoom() {
        var self = this,
            wrap = self.elements.zoomerWrap = document.createElement('div'),
            zoomer = self.elements.zoomer = document.createElement('input');

        addClass(wrap, 'cr-slider-wrap');
        addClass(zoomer, 'cr-slider');
        zoomer.type = 'range';
        zoomer.step = '0.0001';
        zoomer.value = 1;
        zoomer.style.display = self.options.showZoomer ? '' : 'none';

        self.element.appendChild(wrap);
        wrap.appendChild(zoomer);

        self._currentZoom = 1;

        function change() {
            _onZoom.call(self, {
                value: parseFloat(zoomer.value),
                origin: new TransformOrigin(self.elements.preview),
                viewportRect: self.elements.viewport.getBoundingClientRect(),
                transform: Transform.parse(self.elements.preview)
            });
        }

        function scroll(ev) {
            var delta, targetZoom;

            if (ev.wheelDelta) {
                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
            } else if (ev.deltaY) {
                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
            } else if (ev.detail) {
                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
            } else {
                delta = 0;
            }

            targetZoom = self._currentZoom + (delta * self._currentZoom);

            ev.preventDefault();
            _setZoomerVal.call(self, targetZoom);
            change.call(self);
        }

        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
        self.elements.zoomer.addEventListener('change', change);

        if (self.options.mouseWheelZoom) {
            self.elements.boundary.addEventListener('mousewheel', scroll);
            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
        }
    }

    function _onZoom(ui) {
        var self = this,
            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview),
            transCss = {};

        function applyCss() {
            var transCss = {};
            transCss[CSS_TRANSFORM] = transform.toString();
            transCss[CSS_TRANS_ORG] = origin.toString();
            css(self.elements.preview, transCss);
        }

        self._currentZoom = ui ? ui.value : self._currentZoom;
        transform.scale = self._currentZoom;
        applyCss();


        if (self.options.enforceBoundary) {
            var boundaries = _getVirtualBoundaries.call(self, vpRect),
                transBoundaries = boundaries.translate,
                oBoundaries = boundaries.origin;

            if (transform.x >= transBoundaries.maxX) {
                origin.x = oBoundaries.minX;
                transform.x = transBoundaries.maxX;
            }

            if (transform.x <= transBoundaries.minX) {
                origin.x = oBoundaries.maxX;
                transform.x = transBoundaries.minX;
            }

            if (transform.y >= transBoundaries.maxY) {
                origin.y = oBoundaries.minY;
                transform.y = transBoundaries.maxY;
            }

            if (transform.y <= transBoundaries.minY) {
                origin.y = oBoundaries.maxY;
                transform.y = transBoundaries.minY;
            }
        }
        applyCss();
        _debouncedOverlay.call(self);
        _triggerUpdate.call(self);
    }

    function _getVirtualBoundaries(viewport) {
        var self = this,
            scale = self._currentZoom,
            vpWidth = viewport.width,
            vpHeight = viewport.height,
            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
            imgRect = self.elements.preview.getBoundingClientRect(),
            curImgWidth = imgRect.width,
            curImgHeight = imgRect.height,
            halfWidth = vpWidth / 2,
            halfHeight = vpHeight / 2;

        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

        var originMinX = (1 / scale) * halfWidth;
        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

        var originMinY = (1 / scale) * halfHeight;
        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

        return {
            translate: {
                maxX: maxX,
                minX: minX,
                maxY: maxY,
                minY: minY
            },
            origin: {
                maxX: originMaxX,
                minX: originMinX,
                maxY: originMaxY,
                minY: originMinY
            }
        };
    }

    function _updateCenterPoint() {
        var self = this,
            scale = self._currentZoom,
            data = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
            pc = new TransformOrigin(self.elements.preview),
            top = (vpData.top - data.top) + (vpData.height / 2),
            left = (vpData.left - data.left) + (vpData.width / 2),
            center = {},
            adj = {};

        center.y = top / scale;
        center.x = left / scale;

        adj.y = (center.y - pc.y) * (1 - scale);
        adj.x = (center.x - pc.x) * (1 - scale);

        transform.x -= adj.x;
        transform.y -= adj.y;

        var newCss = {};
        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
        newCss[CSS_TRANSFORM] = transform.toString();
        css(self.elements.preview, newCss);
    }

    function _initDraggable() {
        var self = this,
            isDragging = false,
            originalX,
            originalY,
            originalDistance,
            vpRect,
            transform;

        function assignTransformCoordinates(deltaX, deltaY) {
            var imgRect = self.elements.preview.getBoundingClientRect(),
                top = transform.y + deltaY,
                left = transform.x + deltaX;

            if (self.options.enforceBoundary) {
                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
                    transform.y = top;
                }

                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
                    transform.x = left;
                }
            }
            else {
                transform.y = top;
                transform.x = left;
            }
        }

        function keyDown(ev) {
            var LEFT_ARROW  = 37,
                UP_ARROW    = 38,
                RIGHT_ARROW = 39,
                DOWN_ARROW  = 40;

            if (ev.shiftKey && (ev.keyCode == UP_ARROW || ev.keyCode == DOWN_ARROW)) {
                var zoom = 0.0;
                if (ev.keyCode == UP_ARROW) {
                    zoom = parseFloat(self.elements.zoomer.value, 10) + parseFloat(self.elements.zoomer.step, 10)
                }
                else {
                    zoom = parseFloat(self.elements.zoomer.value, 10) - parseFloat(self.elements.zoomer.step, 10)
                }
                self.setZoom(zoom);
            }
            else if (ev.keyCode >= 37 && ev.keyCode <= 40) {
                ev.preventDefault();
                var movement = parseKeyDown(ev.keyCode);

                transform = Transform.parse(self.elements.preview);
                document.body.style[CSS_USERSELECT] = 'none';
                vpRect = self.elements.viewport.getBoundingClientRect();
                keyMove(movement);
            };

            function parseKeyDown(key) {
                switch (key) {
                    case LEFT_ARROW:
                        return [1, 0];
                    case UP_ARROW:
                        return [0, 1];
                    case RIGHT_ARROW:
                        return [-1, 0];
                    case DOWN_ARROW:
                        return [0, -1];
                };
            };
        }

        function keyMove(movement) {
            var deltaX = movement[0],
                deltaY = movement[1],
                newCss = {};

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        function mouseDown(ev) {
            ev.preventDefault();
            if (isDragging) return;
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }

            transform = Transform.parse(self.elements.preview);
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
            vpRect = self.elements.viewport.getBoundingClientRect();
        }

        function mouseMove(ev) {
            ev.preventDefault();
            var pageX = ev.pageX,
                pageY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX,
                deltaY = pageY - originalY,
                newCss = {};

            if (ev.type == 'touchmove') {
                if (ev.touches.length > 1) {
                    var touch1 = ev.touches[0];
                    var touch2 = ev.touches[1];
                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

                    if (!originalDistance) {
                        originalDistance = dist / self._currentZoom;
                    }

                    var scale = dist / originalDistance;

                    _setZoomerVal.call(self, scale);
                    dispatchChange(self.elements.zoomer);
                    return;
                }
            }

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        self.elements.overlay.addEventListener('mousedown', mouseDown);
        self.elements.viewport.addEventListener('keydown', keyDown);
        self.elements.overlay.addEventListener('touchstart', mouseDown);
    }

    function _updateOverlay() {
        var self = this,
            boundRect = self.elements.boundary.getBoundingClientRect(),
            imgData = self.elements.preview.getBoundingClientRect();

        css(self.elements.overlay, {
            width: imgData.width + 'px',
            height: imgData.height + 'px',
            top: (imgData.top - boundRect.top) + 'px',
            left: (imgData.left - boundRect.left) + 'px'
        });
    }
    var _debouncedOverlay = debounce(_updateOverlay, 500);

    function _triggerUpdate() {
        var self = this,
            data = self.get(),
            ev;

        if (!_isVisible.call(self)) {
            return;
        }

        self.options.update.call(self, data);
        if (self.$ && typeof Prototype == 'undefined') {
            self.$(self.element).trigger('update', data); 
        }
        else {
            var ev;
            if (window.CustomEvent) {
                ev = new CustomEvent('update', { detail: data });
            } else {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('update', true, true, data);
            }

            self.element.dispatchEvent(ev);
        }
    }

    function _isVisible() {
        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
    }

    function _updatePropertiesFromImage() {
        var self = this,
            minZoom = 0,
            maxZoom = 1.5,
            initialZoom = 1,
            cssReset = {},
            img = self.elements.preview,
            zoomer = self.elements.zoomer,
            transformReset = new Transform(0, 0, initialZoom),
            originReset = new TransformOrigin(),
            isVisible = _isVisible.call(self),
            imgData,
            vpData,
            boundaryData,
            minW,
            minH;

        if (!isVisible || self.data.bound) {
            // if the croppie isn't visible or it doesn't need binding
            return;
        }

        self.data.bound = true;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        cssReset[CSS_TRANS_ORG] = originReset.toString();
        cssReset['opacity'] = 1;
        css(img, cssReset);

        imgData = img.getBoundingClientRect();
        vpData = self.elements.viewport.getBoundingClientRect();
        boundaryData = self.elements.boundary.getBoundingClientRect();
        self._originalImageWidth = imgData.width;
        self._originalImageHeight = imgData.height;

        if (self.options.enableZoom) {
            if (self.options.enforceBoundary) {
                minW = vpData.width / imgData.width;
                minH = vpData.height / imgData.height;
                minZoom = Math.max(minW, minH);
            }

            if (minZoom >= maxZoom) {
                maxZoom = minZoom + 1;
            }

            zoomer.min = fix(minZoom, 4);
            zoomer.max = fix(maxZoom, 4);
            var defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
            _setZoomerVal.call(self, initialZoom);
            dispatchChange(zoomer);
        }
        else {
            self._currentZoom = initialZoom;
        }

        transformReset.scale = self._currentZoom;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        css(img, cssReset);

        if (self.data.points.length) {
            _bindPoints.call(self, self.data.points);
        }
        else {
            _centerImage.call(self);
        }

        _updateCenterPoint.call(self);
        _updateOverlay.call(self);
    }

    function _bindPoints(points) {
        if (points.length != 4) {
            throw "Croppie - Invalid number of points supplied: " + points;
        }
        var self = this,
            pointsWidth = points[2] - points[0],
            // pointsHeight = points[3] - points[1],
            vpData = self.elements.viewport.getBoundingClientRect(),
            boundRect = self.elements.boundary.getBoundingClientRect(),
            vpOffset = {
                left: vpData.left - boundRect.left,
                top: vpData.top - boundRect.top
            },
            scale = vpData.width / pointsWidth,
            originTop = points[1],
            originLeft = points[0],
            transformTop = (-1 * points[1]) + vpOffset.top,
            transformLeft = (-1 * points[0]) + vpOffset.left,
            newCss = {};

        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
        css(self.elements.preview, newCss);

        _setZoomerVal.call(self, scale);
        self._currentZoom = scale;
    }

    function _centerImage() {
        var self = this,
            imgDim = self.elements.preview.getBoundingClientRect(),
            vpDim = self.elements.viewport.getBoundingClientRect(),
            boundDim = self.elements.boundary.getBoundingClientRect(),
            vpLeft = vpDim.left - boundDim.left,
            vpTop = vpDim.top - boundDim.top,
            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
            h = vpTop - ((imgDim.height - vpDim.height) / 2),
            transform = new Transform(w, h, self._currentZoom);

        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
    }

    function _transferImageToCanvas(customOrientation) {
        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            ctx = canvas.getContext('2d'),
            exif = _hasExif.call(self),
            customOrientation = self.options.enableOrientation && customOrientation;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = img.width;
        canvas.height = img.height;

        if (exif) {
            getExifOrientation(img, function (orientation) {
                drawCanvas(canvas, img, num(orientation, 10));
                if (customOrientation) {
                    drawCanvas(canvas, img, customOrientation);
                }
            });
        } else if (customOrientation) {
            drawCanvas(canvas, img, customOrientation);
        }
    }

    function _getCanvas(data) {
        var self = this,
            points = data.points,
            left = num(points[0]),
            top = num(points[1]),
            right = num(points[2]),
            bottom = num(points[3]),
            width = right-left,
            height = bottom-top,
            circle = data.circle,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            outWidth = width,
            outHeight = height,
            startX = 0,
            startY = 0,
            canvasWidth = outWidth,
            canvasHeight = outHeight,
            customDimensions = (data.outputWidth && data.outputHeight),
            outputRatio = 1;

        if (customDimensions) {
            canvasWidth = data.outputWidth;
            canvasHeight = data.outputHeight;
            outputRatio = canvasWidth / outWidth;
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        if (data.backgroundColor) {
            ctx.fillStyle = data.backgroundColor;
            ctx.fillRect(0, 0, outWidth, outHeight);
        }
        // start fixing data to send to draw image for enforceBoundary: false
        if (left < 0) {
            startX = Math.abs(left);
            left = 0;
        }
        if (top < 0) {
            startY = Math.abs(top);
            top = 0;
        }
        if (right > self._originalImageWidth) {
            width = self._originalImageWidth - left;
            outWidth = width;
        }
        if (bottom > self._originalImageHeight) {
            height = self._originalImageHeight - top;
            outHeight = height;
        }

        if (outputRatio !== 1) {
            startX *= outputRatio;
            startY *= outputRatio;
            outWidth *= outputRatio;
            outHeight *= outputRatio;
        }

        ctx.drawImage(this.elements.preview, left, top, width, height, startX, startY, outWidth, outHeight);
        if (circle) {
            ctx.fillStyle = '#fff';
            ctx.globalCompositeOperation = 'destination-in';
            ctx.beginPath();
            ctx.arc(outWidth / 2, outHeight / 2, outWidth / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
        }
        return canvas;
    }

    function _getHtmlResult(data) {
        var points = data.points,
            div = document.createElement('div'),
            img = document.createElement('img'),
            width = points[2] - points[0],
            height = points[3] - points[1];

        addClass(div, 'croppie-result');
        div.appendChild(img);
        css(img, {
            left: (-1 * points[0]) + 'px',
            top: (-1 * points[1]) + 'px'
        });
        img.src = data.url;
        css(div, {
            width: width + 'px',
            height: height + 'px'
        });

        return div;
    }

    function _getBase64Result(data) {
        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
    }

    function _getBlobResult(data) {
        var self = this;
        return new Promise(function (resolve, reject) {
            _getCanvas.call(self, data).toBlob(function (blob) {
                resolve(blob);
            }, data.format, data.quality);
        });
    }

    function _bind(options, cb) {
        var self = this,
            url,
            points = [],
            zoom = null;

        if (typeof (options) === 'string') {
            url = options;
            options = {};
        }
        else if (Array.isArray(options)) {
            points = options.slice();
        }
        else if (typeof (options) == 'undefined' && self.data.url) { //refreshing
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            return null;
        }
        else {
            url = options.url;
            points = options.points || [];
            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
        }

        self.data.bound = false;
        self.data.url = url || self.data.url;
        self.data.boundZoom = zoom;

        return loadImage(url, self.elements.img).then(function (img) {
            if(!points.length){
                var iWidth = img.naturalWidth;
                var iHeight = img.naturalHeight;

                var rect = self.elements.viewport.getBoundingClientRect();
                var aspectRatio = rect.width / rect.height;
                var width, height;

                if( iWidth / iHeight > aspectRatio){
                    height = iHeight;
                    width = height * aspectRatio;
                }else{
                    width = iWidth;
                    height = width / aspectRatio;
                }

                var x0 = (iWidth - width) / 2;
                var y0 = (iHeight - height) / 2;
                var x1 = x0 + width;
                var y1 = y0 + height;

                self.data.points = [x0, y0, x1, y1];
            } else {
                if(self.options.relative){
                    // de-relative points
                    points = [
                        points[0] * img.naturalWidth / 100,
                        points[1] * img.naturalHeight / 100,
                        points[2] * img.naturalWidth / 100,
                        points[3] * img.naturalHeight / 100
                    ];
                }

                self.data.points = points.map(function (p) {
                    return parseFloat(p);
                });
            }

            if (self.options.useCanvas) {
                self.elements.img.exifdata = null;
                _transferImageToCanvas.call(self, options.orientation || 1);
            }
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            cb && cb();
        });
    }

    function fix(v, decimalPoints) {
        return parseFloat(v).toFixed(decimalPoints || 0);
    }

    function _get() {
        var self = this,
            imgData = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            x1 = vpData.left - imgData.left,
            y1 = vpData.top - imgData.top,
            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2,
            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
            scale = self._currentZoom;

        if (scale === Infinity || isNaN(scale)) {
            scale = 1;
        }

        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
        x1 = Math.max(max, x1 / scale);
        y1 = Math.max(max, y1 / scale);
        x2 = Math.max(max, x2 / scale);
        y2 = Math.max(max, y2 / scale);

        return {
            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
            zoom: scale
        };
    }

    var RESULT_DEFAULTS = {
            type: 'canvas',
            format: 'png',
            quality: 1
        },
        RESULT_FORMATS = ['jpeg', 'webp', 'png'];

    function _result(options) {
        var self = this,
            data = _get.call(self),
            opts = deepExtend(RESULT_DEFAULTS, deepExtend({}, options)),
            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
            size = opts.size,
            format = opts.format,
            quality = opts.quality,
            backgroundColor = opts.backgroundColor,
            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
            vpRect = self.elements.viewport.getBoundingClientRect(),
            ratio = vpRect.width / vpRect.height,
            prom;

        if (size === 'viewport') {
            data.outputWidth = vpRect.width;
            data.outputHeight = vpRect.height;
        } else if (typeof size === 'object') {
            if (size.width && size.height) {
                data.outputWidth = size.width;
                data.outputHeight = size.height;
            } else if (size.width) {
                data.outputWidth = size.width;
                data.outputHeight = size.width / ratio;
            } else if (size.height) {
                data.outputWidth = size.height * ratio;
                data.outputHeight = size.height;
            }
        }

        if (RESULT_FORMATS.indexOf(format) > -1) {
            data.format = 'image/' + format;
            data.quality = quality;
        }

        data.circle = circle;
        data.url = self.data.url;
        data.backgroundColor = backgroundColor;

        prom = new Promise(function (resolve, reject) {
            switch(resultType.toLowerCase())
            {
                case 'rawcanvas':
                    resolve(_getCanvas.call(self, data));
                    break;
                case 'canvas':
                case 'base64':
                    resolve(_getBase64Result.call(self, data));
                    break;
                case 'blob':
                    _getBlobResult.call(self, data).then(resolve);
                    break;
                default:
                    resolve(_getHtmlResult.call(self, data));
                    break;
            }
        });
        return prom;
    }

    function _refresh() {
        _updatePropertiesFromImage.call(this);
    }

    function _rotate(deg) {
        if (!this.options.useCanvas) {
            throw 'Croppie: Cannot rotate without enableOrientation';
        }

        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            copy = document.createElement('canvas'),
            ornt = 1;

        copy.width = canvas.width;
        copy.height = canvas.height;
        var ctx = copy.getContext('2d');
        ctx.drawImage(canvas, 0, 0);

        if (deg === 90 || deg === -270) ornt = 6;
        if (deg === -90 || deg === 270) ornt = 8;
        if (deg === 180 || deg === -180) ornt = 3;

        drawCanvas(canvas, copy, ornt);
        _onZoom.call(self);
    }

    function _destroy() {
        var self = this;
        self.element.removeChild(self.elements.boundary);
        removeClass(self.element, 'croppie-container');
        if (self.options.enableZoom) {
            self.element.removeChild(self.elements.zoomerWrap);
        }
        delete self.elements;
    }

    if (window.jQuery) {
        var $ = window.jQuery;
        $.fn.croppie = function (opts) {
            var ot = typeof opts;

            if (ot === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var singleInst = $(this).data('croppie');

                if (opts === 'get') {
                    return singleInst.get();
                }
                else if (opts === 'result') {
                    return singleInst.result.apply(singleInst, args);
                }
                else if (opts === 'bind') {
                    return singleInst.bind.apply(singleInst, args);
                }

                return this.each(function () {
                    var i = $(this).data('croppie');
                    if (!i) return;

                    var method = i[opts];
                    if ($.isFunction(method)) {
                        method.apply(i, args);
                        if (opts === 'destroy') {
                            $(this).removeData('croppie');
                        }
                    }
                    else {
                        throw 'Croppie ' + opts + ' method not found';
                    }
                });
            }
            else {
                return this.each(function () {
                    var i = new Croppie(this, opts);
                    i.$ = $;
                    $(this).data('croppie', i);
                });
            }
        };
    }

    function Croppie(element, opts) {
        this.element = element;
        this.options = deepExtend(deepExtend({}, Croppie.defaults), opts);

        if (this.element.tagName.toLowerCase() === 'img') {
            var origImage = this.element;
            addClass(origImage, 'cr-original-image');
            var replacementDiv = document.createElement('div');
            this.element.parentNode.appendChild(replacementDiv);
            replacementDiv.appendChild(origImage);
            this.element = replacementDiv;
            this.options.url = this.options.url || origImage.src;
        }

        _create.call(this);
        if (this.options.url) {
            var bindOpts = {
                url: this.options.url,
                points: this.options.points
            };
            delete this.options['url'];
            delete this.options['points'];
            _bind.call(this, bindOpts);
        }
    }

    Croppie.defaults = {
        viewport: {
            width: 100,
            height: 100,
            type: 'square'
        },
        boundary: { },
        orientationControls: {
            enabled: true,
            leftClass: '',
            rightClass: ''
        },
        customClass: '',
        showZoomer: true,
        enableZoom: true,
        mouseWheelZoom: true,
        enableExif: false,
        enforceBoundary: true,
        enableOrientation: false,
        update: function () { }
    };

    Croppie.globals = {
        translate: 'translate3d'
    };

    deepExtend(Croppie.prototype, {
        bind: function (options, cb) {
            return _bind.call(this, options, cb);
        },
        get: function () {
            var data = _get.call(this);
            var points = data.points;
            if (this.options.relative) {
                //
                // Relativize points
                //
                points[0] /= this.elements.img.naturalWidth / 100;
                points[1] /= this.elements.img.naturalHeight / 100;
                points[2] /= this.elements.img.naturalWidth / 100;
                points[3] /= this.elements.img.naturalHeight / 100;
            }
            return data;
        },
        result: function (type) {
            return _result.call(this, type);
        },
        refresh: function () {
            return _refresh.call(this);
        },
        setZoom: function (v) {
            _setZoomerVal.call(this, v);
            dispatchChange(this.elements.zoomer);
        },
        rotate: function (deg) {
            _rotate.call(this, deg);
        },
        destroy: function () {
            return _destroy.call(this);
        }
    });

    exports.Croppie = window.Croppie = Croppie;

    if (typeof module === 'object' && !!module.exports) {
        module.exports = Croppie;
    }
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(300).setImmediate))

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"row\">");t.b("\n" + i);t.b("    <div class=\"col-12\">");t.b("\n" + i);t.b("         <div id=\"sma-js-picture-preview\"></div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"row\">\n    <div class=\"col-12\">\n         <div id=\"sma-js-picture-preview\"></div>\n    </div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<form id=\"sma-profile-picture-form\" method=\"POST\">");t.b("\n" + i);t.b("	<div class=\"row\">");t.b("\n" + i);t.b("		<div class=\"col-12 col-sm-auto\">");t.b("\n" + i);if(t.s(t.f("picture",c,p,1),c,p,0,120,308,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<div class=\"sma-app-view-user-avatar-wrapper\">");t.b("\n" + i);t.b("					<img class=\"sma-app-view-user-avatar sma-js-app-view-user-avatar\" src=");t.b(t.v(t.f("picture",c,p,0)));t.b(" alt=\"");t.b(t.v(t.d("strings.profile_picture",c,p,0)));t.b("\">");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("picture",c,p,1),c,p,1,0,0,"")){t.b("				<div class=\"sma-profile-picture-container\">");t.b("\n" + i);t.b("					<div class=\"sma-avatar-lg\">");t.b("\n" + i);t.b("						");t.b(t.v(t.f("initials",c,p,0)));t.b("\n" + i);t.b("					</div>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);};t.b("		</div>");t.b("\n");t.b("\n" + i);t.b("		<div class=\"col-12 col-sm\">");t.b("\n" + i);t.b("			<div class=\"sma-picture-upload-container\">");t.b("\n" + i);t.b("				<label class=\"custom-file\">");t.b("\n" + i);t.b("					<input class=\"custom-file-input sma-js-img-upload-field\" id=\"id_profile_picture\" type=\"file\" aria-label=\"");t.b(t.v(t.d("strings.upload_picture",c,p,0)));t.b("\">");t.b("\n" + i);t.b("					<input type=\"hidden\" name=\"profile_picture\" value=\"\" id=\"sma-hidden-profile-img\"/>");t.b("\n" + i);t.b("					<span class=\"custom-file-control\"></span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);if(t.s(t.f("picture",c,p,1),c,p,0,899,995,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("					<button class=\"btn btn-default\" id=\"remove_picture\">");t.b(t.v(t.d("strings.remove_photo",c,p,0)));t.b("</button>");t.b("\n" + i);});c.pop();}t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</form>");return t.fl(); },partials: {}, subs: {  }}, "<form id=\"sma-profile-picture-form\" method=\"POST\">\n\t<div class=\"row\">\n\t\t<div class=\"col-12 col-sm-auto\">\n\t\t\t{{#picture}}\n\t\t\t\t<div class=\"sma-app-view-user-avatar-wrapper\">\n\t\t\t\t\t<img class=\"sma-app-view-user-avatar sma-js-app-view-user-avatar\" src={{picture}} alt=\"{{strings.profile_picture}}\">\n\t\t\t\t</div>\n\t\t\t{{/picture}}\n\t\t\t{{^picture}}\n\t\t\t\t<div class=\"sma-profile-picture-container\">\n\t\t\t\t\t<div class=\"sma-avatar-lg\">\n\t\t\t\t\t\t{{initials}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t{{/picture}}\n\t\t</div>\n\n\t\t<div class=\"col-12 col-sm\">\n\t\t\t<div class=\"sma-picture-upload-container\">\n\t\t\t\t<label class=\"custom-file\">\n\t\t\t\t\t<input class=\"custom-file-input sma-js-img-upload-field\" id=\"id_profile_picture\" type=\"file\" aria-label=\"{{ strings.upload_picture }}\">\n\t\t\t\t\t<input type=\"hidden\" name=\"profile_picture\" value=\"\" id=\"sma-hidden-profile-img\"/>\n\t\t\t\t\t<span class=\"custom-file-control\"></span>\n\t\t\t\t</label>\n\t\t\t\t{{#picture}}\n\t\t\t\t\t<button class=\"btn btn-default\" id=\"remove_picture\">{{strings.remove_photo}}</button>\n\t\t\t\t{{/picture}}\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</form>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("temp_email",c,p,1),c,p,0,15,335,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"row\">");t.b("\n" + i);t.b("		<p class=\"col-md-12\">");t.b("\n" + i);t.b("			");t.b(t.v(t.d("strings.temp_email",c,p,0)));t.b("\n" + i);t.b("		</p>");t.b("\n" + i);t.b("		<a name=\"resend-confirmation\" class=\"btn btn-link\" id=\"resend_confirmation\" href=\"#\">");t.b("\n" + i);t.b("			");t.b(t.v(t.d("strings.resend",c,p,0)));t.b("\n" + i);t.b("		</a>");t.b("\n" + i);t.b("		<a name=\"cancel-change\" class=\"btn btn-link\" id=\"cancel_change\" href=\"#\">");t.b("\n" + i);t.b("			");t.b(t.v(t.d("strings.cancel_change",c,p,0)));t.b("\n" + i);t.b("		</a>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#temp_email}}\n\t<div class=\"row\">\n\t\t<p class=\"col-md-12\">\n\t\t\t{{ strings.temp_email }}\n\t\t</p>\n\t\t<a name=\"resend-confirmation\" class=\"btn btn-link\" id=\"resend_confirmation\" href=\"#\">\n\t\t\t{{ strings.resend }}\n\t\t</a>\n\t\t<a name=\"cancel-change\" class=\"btn btn-link\" id=\"cancel_change\" href=\"#\">\n\t\t\t{{ strings.cancel_change }}\n\t\t</a>\n\t</div>\n{{/temp_email}}", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.accountDeleteDialog = accountDeleteDialog;
exports.cancelAccountDeletionDialog = cancelAccountDeletionDialog;
var modals = __webpack_require__(6);

var deleteTemplates = {
	deleteDialog: __webpack_require__(1627),
	cancelDeleteDialog: __webpack_require__(1628)
};

function accountDeleteDialog(options) {
	var modalBody = $(deleteTemplates.deleteDialog({
		strings: options.strings,
		sites: options.sites
	}));

	var dialogButtons = [{
		label: gettext('CANCEL'),
		cls: 'btn-link',
		handler: function handler(modal) {
			modal.hide();
		}
	}, {
		label: gettext('DELETE'),
		cls: 'btn-danger sma-js-delete-dialog-delete-button disabled',
		handler: options.handler
	}];

	modalBody.find('.sma-js-delete-dialog-delete-button').attr('disabled', 'disabled');

	var validateButtonState = function validateButtonState(e) {
		var checked = modalBody.find('.sma-js-account-delete-confirm').is(':checked');
		var hasPassword = modalBody.find('input[type="password"]').val().trim().length;

		if (checked && hasPassword) {
			$('.sma-js-delete-dialog-delete-button').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.sma-js-delete-dialog-delete-button').addClass('disabled').attr('disabled', 'disabled');
		}
	};

	modalBody.on('change', '.sma-js-account-delete-confirm', validateButtonState);
	modalBody.on('input', 'input[type="password"]', validateButtonState);

	var modal = new modals.ContentModal(modalBody, {
		title: options.title,
		destroyOnClose: true,
		autoShow: true,
		buttons: dialogButtons
	});
}

function cancelAccountDeletionDialog(options) {
	var dialogButtons = [{
		label: gettext('NO, KEEP DELETION REQUEST'),
		cls: 'btn-link',
		handler: function handler(modal) {
			modal.hide();
		}
	}, {
		label: gettext('YES, CANCEL DELETION'),
		cls: 'btn-primary',
		id: 'sma-js-cancel-account-deletion',
		handler: options.handler
	}];

	var modalBody = deleteTemplates.cancelDeleteDialog({
		strings: options.strings
	});

	var modal = new modals.ContentModal(modalBody, {
		title: options.title,
		destroyOnClose: true,
		autoShow: true,
		buttons: dialogButtons
	});
}

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"row sma-account-deletion-dialog justify-content-center\">");t.b("\n" + i);t.b("	<div class=\"col-11\">");t.b("\n" + i);t.b("		<i class=\"nc-icon-mini ui-3_alert\"></i>");t.b("\n" + i);t.b("		<div class=\"row\">");t.b("\n" + i);t.b("			<div class=\"col-md-12\">");t.b("\n" + i);t.b("				<p>");t.b("\n" + i);t.b("					");t.b(t.v(t.d("strings.accountDeletionWarning",c,p,0)));t.b("\n" + i);t.b("				</p>");t.b("\n" + i);t.b("				<ul>");t.b("\n" + i);if(t.s(t.f("sites",c,p,1),c,p,0,262,365,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<li><span class=\"sma-delete-account-site\">");t.b(t.v(t.f("name",c,p,0)));t.b("</span>: <a href=\"");t.b(t.v(t.f("url",c,p,0)));t.b("\">");t.b(t.v(t.f("url",c,p,0)));t.b("</a></li>");t.b("\n" + i);});c.pop();}t.b("				</ul>");t.b("\n" + i);t.b("				<p>");t.b("\n" + i);t.b("					");t.b(t.t(t.d("strings.accountDeletionInfo",c,p,0)));t.b("\n" + i);t.b("				</p>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		<div class=\"row\">");t.b("\n" + i);t.b("			<div class=\"col-md-12\">");t.b("\n" + i);t.b("				<ul class=\"errorlist sma-account-password-error\" style=\"display: none;\">");t.b("\n" + i);t.b("					<li>");t.b(t.v(t.d("strings.invalidPassword",c,p,0)));t.b("</li>");t.b("\n" + i);t.b("				</ul>");t.b("\n" + i);t.b("				<label>");t.b(t.v(t.d("strings.enterPassword",c,p,0)));t.b("</label><br/>");t.b("\n" + i);t.b("				<input type=\"password\" class=\"form-control\" />");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		<div class=\"row sma-account-gdpr-delete-confirmation\">");t.b("\n" + i);t.b("			<div class=\"col-md-12\">");t.b("\n" + i);t.b("				<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("					<input name=\"checkbox\" class=\"custom-control-input sma-js-account-delete-confirm\" id=\"sma-account-gdpr-delete\" type=\"checkbox\" />");t.b("\n" + i);t.b("					<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("					<span class=\"custom-control-description\">");t.b("\n" + i);t.b("						<label for=\"sma-account-gdpr-delete\">");t.b(t.v(t.d("strings.gdprConfirmation",c,p,0)));t.b("</label>										");t.b("\n" + i);t.b("					</span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"row sma-account-deletion-dialog justify-content-center\">\n\t<div class=\"col-11\">\n\t\t<i class=\"nc-icon-mini ui-3_alert\"></i>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<p>\n\t\t\t\t\t{{ strings.accountDeletionWarning }}\n\t\t\t\t</p>\n\t\t\t\t<ul>\n\t\t\t\t{{#sites}}\n\t\t\t\t<li><span class=\"sma-delete-account-site\">{{name}}</span>: <a href=\"{{url}}\">{{url}}</a></li>\n\t\t\t\t{{/sites}}\n\t\t\t\t</ul>\n\t\t\t\t<p>\n\t\t\t\t\t{{{ strings.accountDeletionInfo }}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<ul class=\"errorlist sma-account-password-error\" style=\"display: none;\">\n\t\t\t\t\t<li>{{ strings.invalidPassword }}</li>\n\t\t\t\t</ul>\n\t\t\t\t<label>{{ strings.enterPassword }}</label><br/>\n\t\t\t\t<input type=\"password\" class=\"form-control\" />\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row sma-account-gdpr-delete-confirmation\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input name=\"checkbox\" class=\"custom-control-input sma-js-account-delete-confirm\" id=\"sma-account-gdpr-delete\" type=\"checkbox\" />\n\t\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t\t<label for=\"sma-account-gdpr-delete\">{{ strings.gdprConfirmation }}</label>\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t</span>\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"row sma-account-cancel-deletion-dialog\">");t.b("\n" + i);t.b("		<p>");t.b("\n" + i);t.b("			");t.b(t.v(t.d("strings.cancelDeletionConfirmation",c,p,0)));t.b("\n" + i);t.b("		</p>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"row sma-account-cancel-deletion-dialog\">\n\t\t<p>\n\t\t\t{{ strings.cancelDeletionConfirmation }}\n\t\t</p>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"form-block\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"");t.b(t.v(t.f("msg",c,p,0)));t.b("\"></div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"form-block\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"{{msg}}\"></div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-download-modal\">");t.b("\n" + i);t.b("	<!-- download filetype -->");t.b("\n" + i);t.b("	<div class=\"form-group\">");t.b("\n" + i);t.b("		<label>");t.b(t.v(t.d("STRINGS.downloadSelectedApplicationsAs",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("		<select class=\"form-control custom-select\" name=\"download_format\" id=\"id_download_format\">");t.b("\n" + i);t.b("			<option value=\"as_merged_applications\">");t.b(t.v(t.d("STRINGS.pdfPerApplication",c,p,0)));t.b("</option>");t.b("\n" + i);t.b("			<option value=\"as_zip\">");t.b(t.v(t.d("STRINGS.pdfWithAttachments",c,p,0)));t.b("</option>");t.b("\n" + i);t.b("			<option value=\"as_single_file\">");t.b(t.v(t.d("STRINGS.singleFile",c,p,0)));t.b("</option>");t.b("\n" + i);t.b("		</select>");t.b("\n" + i);t.b("	</div>");t.b("\n");t.b("\n" + i);t.b("	<div class=\"sma-js-filename-prefix-container\">");t.b("\n" + i);t.b("		<!-- filename prefix -->");t.b("\n" + i);t.b("		<label>");t.b(t.v(t.d("STRINGS.includeInDownloadedFilename",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("		<div class=\"form-group custom-controls-stacked\">");t.b("\n" + i);t.b("			<label class=\"custom-control custom-radio\">");t.b("\n" + i);t.b("				<input checked=\"checked\" id=\"prefix_app_id\" value=\"application_id\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"prefix_app_id\">");t.b(t.v(t.d("STRINGS.applicationId",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n");t.b("\n" + i);if(t.s(t.f("name_visible",c,p,1),c,p,0,1049,1414,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<label class=\"custom-control custom-radio\">");t.b("\n" + i);t.b("				<input value=\"applicant_fullname\" id=\"prefix_app_name\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"prefix_app_name\">");t.b(t.v(t.d("STRINGS.applicantName",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("title_visible",c,p,1),c,p,0,1454,1823,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<label class=\"custom-control custom-radio\">");t.b("\n" + i);t.b("				<input value=\"application_title\" id=\"prefix_app_title\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"prefix_app_title\">");t.b(t.v(t.d("STRINGS.applicationTitle",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);});c.pop();}t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n");t.b("\n" + i);t.b("	<!-- task selection -->");t.b("\n" + i);if(t.s(t.d("tasks.length",c,p,1),c,p,0,1903,3206,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<label>");t.b(t.v(t.d("STRINGS.applicationTasksToInclude",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("		<div class=\"form-group custom-controls-stacked\">");t.b("\n" + i);t.b("			<label class=\"custom-control custom-radio\">");t.b("\n" + i);t.b("				<input value=\"include_all_tasks\" id=\"include_all_tasks\" name=\"tasks_select\" type=\"radio\" class=\"custom-control-input\" checked=\"checked\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"include_all_tasks\">");t.b(t.v(t.d("STRINGS.allApplicationTasks",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);t.b("			<div class=\"row\">");t.b("\n" + i);t.b("				<div class=\"col-6\">");t.b("\n" + i);t.b("					<label class=\"custom-control custom-radio\">");t.b("\n" + i);t.b("						<input value=\"include_selected_tasks\" id=\"include_selected_tasks\" name=\"tasks_select\" type=\"radio\" class=\"custom-control-input\">");t.b("\n" + i);t.b("						<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("						<span class=\"custom-control-description\">");t.b("\n" + i);t.b("							<label for=\"include_selected_tasks\">");t.b(t.v(t.d("STRINGS.choose_application_tasks",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("						</span>");t.b("\n" + i);t.b("					</label>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("				<div class=\"col-6\" id=\"sma-js-task-selection-wrap\">");t.b("\n" + i);t.b("					<select class='choices' multiple=\"multiple\" id=\"sma-js-task-selector\">");t.b("\n" + i);if(t.s(t.f("tasks",c,p,1),c,p,0,3000,3149,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("							<optgroup label=\"");t.b(t.v(t.f("name",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("tasks",c,p,1),c,p,0,3054,3113,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("									<option value='");t.b(t.v(t.f("id",c,p,0)));t.b("'>");t.b(t.v(t.f("name",c,p,0)));t.b("</option>");t.b("\n" + i);});c.pop();}t.b("							</optgroup>");t.b("\n" + i);});c.pop();}t.b("					</select>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("isFullDownload",c,p,1),c,p,0,3245,5602,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<!-- misc information -->");t.b("\n" + i);t.b("		<label>");t.b(t.v(t.d("STRINGS.includeEllipses",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("		<div class=\"form-group custom-controls-stacked\">");t.b("\n" + i);t.b("			<!-- Application profile -->");t.b("\n" + i);t.b("			<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("				<input checked=\"checked\" name=\"include_application_profiles\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_profiles\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"include_application_profiles\">");t.b(t.v(t.d("STRINGS.applicationProfiles",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);t.b("			<!-- Notes -->");t.b("\n" + i);t.b("			<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("				<input name=\"include_application_notes\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_notes\">");t.b("\n" + i);t.b("				<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("				<span class=\"custom-control-description\">");t.b("\n" + i);t.b("					<label for=\"include_application_notes\">");t.b(t.v(t.d("STRINGS.notes",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("				</span>");t.b("\n" + i);t.b("			</label>");t.b("\n" + i);t.b("			<!-- Application metadata -->");t.b("\n" + i);if(t.s(t.f("application_fields",c,p,1),c,p,0,4244,4659,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("					<input name=\"include_application_custom_fields\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_custom_fields\">");t.b("\n" + i);t.b("					<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("					<span class=\"custom-control-description\">");t.b("\n" + i);t.b("						<label for=\"include_application_custom_fields\">");t.b(t.v(t.d("STRINGS.applicationCustomFields",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("					</span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);});c.pop();}t.b("			<!-- User's custom fields metadata -->");t.b("\n" + i);if(t.s(t.f("applicant_fields",c,p,1),c,p,0,4749,5156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("					<input name=\"include_applicant_custom_fields\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_applicant_custom_fields\">");t.b("\n" + i);t.b("					<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("					<span class=\"custom-control-description\">");t.b("\n" + i);t.b("						<label for=\"include_applicant_custom_fields\">");t.b(t.v(t.d("STRINGS.applicantCustomFields",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("					</span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);});c.pop();}if(t.s(t.f("review_stages",c,p,1),c,p,0,5199,5573,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("				<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("					<input name=\"include_stage__");t.b(t.v(t.f("id",c,p,0)));t.b("\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_stage__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("					<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("					<span class=\"custom-control-description\">");t.b("\n" + i);t.b("						<label for=\"include_stage__");t.b(t.v(t.f("id",c,p,0)));t.b("\">");t.b(t.v(t.d("STRINGS.reviews",c,p,0)));t.b(" - ");t.b(t.v(t.f("name",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("					</span>");t.b("\n" + i);t.b("				</label>");t.b("\n" + i);});c.pop();}t.b("		</div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("	<!-- download buttons -->");t.b("\n" + i);t.b("	<div class=\"form-group\">");t.b("\n" + i);t.b("		<button type=\"button\" id=\"download-btn\" class=\"btn btn-primary\">");t.b(t.v(t.d("STRINGS.download",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("		<button type=\"button\" id=\"cancel-btn\" class=\"btn btn-default\">");t.b(t.v(t.d("STRINGS.cancel",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-download-modal\">\n\t<!-- download filetype -->\n\t<div class=\"form-group\">\n\t\t<label>{{STRINGS.downloadSelectedApplicationsAs}}</label>\n\t\t<select class=\"form-control custom-select\" name=\"download_format\" id=\"id_download_format\">\n\t\t\t<option value=\"as_merged_applications\">{{STRINGS.pdfPerApplication}}</option>\n\t\t\t<option value=\"as_zip\">{{STRINGS.pdfWithAttachments}}</option>\n\t\t\t<option value=\"as_single_file\">{{STRINGS.singleFile}}</option>\n\t\t</select>\n\t</div>\n\n\t<div class=\"sma-js-filename-prefix-container\">\n\t\t<!-- filename prefix -->\n\t\t<label>{{STRINGS.includeInDownloadedFilename}}</label>\n\t\t<div class=\"form-group custom-controls-stacked\">\n\t\t\t<label class=\"custom-control custom-radio\">\n\t\t\t\t<input checked=\"checked\" id=\"prefix_app_id\" value=\"application_id\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"prefix_app_id\">{{STRINGS.applicationId}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\n\t\t\t{{#name_visible}}\n\t\t\t<label class=\"custom-control custom-radio\">\n\t\t\t\t<input value=\"applicant_fullname\" id=\"prefix_app_name\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"prefix_app_name\">{{STRINGS.applicantName}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\t\t\t{{/name_visible}}\n\n\t\t\t{{#title_visible}}\n\t\t\t<label class=\"custom-control custom-radio\">\n\t\t\t\t<input value=\"application_title\" id=\"prefix_app_title\" name=\"filename_prefix\" type=\"radio\" class=\"custom-control-input\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"prefix_app_title\">{{STRINGS.applicationTitle}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\t\t\t{{/title_visible}}\n\t\t</div>\n\t</div>\n\n\t<!-- task selection -->\n\t{{#tasks.length}}\n\t\t<label>{{STRINGS.applicationTasksToInclude}}</label>\n\t\t<div class=\"form-group custom-controls-stacked\">\n\t\t\t<label class=\"custom-control custom-radio\">\n\t\t\t\t<input value=\"include_all_tasks\" id=\"include_all_tasks\" name=\"tasks_select\" type=\"radio\" class=\"custom-control-input\" checked=\"checked\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"include_all_tasks\">{{STRINGS.allApplicationTasks}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-6\">\n\t\t\t\t\t<label class=\"custom-control custom-radio\">\n\t\t\t\t\t\t<input value=\"include_selected_tasks\" id=\"include_selected_tasks\" name=\"tasks_select\" type=\"radio\" class=\"custom-control-input\">\n\t\t\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t\t\t<label for=\"include_selected_tasks\">{{STRINGS.choose_application_tasks}}</label>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-6\" id=\"sma-js-task-selection-wrap\">\n\t\t\t\t\t<select class='choices' multiple=\"multiple\" id=\"sma-js-task-selector\">\n\t\t\t\t\t\t{{#tasks}}\n\t\t\t\t\t\t\t<optgroup label=\"{{name}}\">\n\t\t\t\t\t\t\t\t{{#tasks}}\n\t\t\t\t\t\t\t\t\t<option value='{{id}}'>{{name}}</option>\n\t\t\t\t\t\t\t\t{{/tasks}}\n\t\t\t\t\t\t\t</optgroup>\n\t\t\t\t\t\t{{/tasks}}\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t{{/tasks.length}}\n\n\t{{#isFullDownload}}\n\t\t<!-- misc information -->\n\t\t<label>{{STRINGS.includeEllipses}}</label>\n\t\t<div class=\"form-group custom-controls-stacked\">\n\t\t\t<!-- Application profile -->\n\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t<input checked=\"checked\" name=\"include_application_profiles\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_profiles\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"include_application_profiles\">{{STRINGS.applicationProfiles}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\t\t\t<!-- Notes -->\n\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t<input name=\"include_application_notes\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_notes\">\n\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t<label for=\"include_application_notes\">{{STRINGS.notes}}</label>\n\t\t\t\t</span>\n\t\t\t</label>\n\t\t\t<!-- Application metadata -->\n\t\t\t{{#application_fields}}\n\t\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input name=\"include_application_custom_fields\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_application_custom_fields\">\n\t\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t\t<label for=\"include_application_custom_fields\">{{STRINGS.applicationCustomFields}}</label>\n\t\t\t\t\t</span>\n\t\t\t\t</label>\n\t\t\t{{/application_fields}}\n\t\t\t<!-- User's custom fields metadata -->\n\t\t\t{{#applicant_fields}}\n\t\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input name=\"include_applicant_custom_fields\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_applicant_custom_fields\">\n\t\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t\t<label for=\"include_applicant_custom_fields\">{{STRINGS.applicantCustomFields}}</label>\n\t\t\t\t\t</span>\n\t\t\t\t</label>\n\t\t\t{{/applicant_fields}}\n\t\t\t{{#review_stages}}\n\t\t\t\t<label class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input name=\"include_stage__{{id}}\" type=\"checkbox\" class=\"custom-control-input\" id=\"include_stage__{{id}}\">\n\t\t\t\t\t<span class=\"custom-control-indicator\"></span>\n\t\t\t\t\t<span class=\"custom-control-description\">\n\t\t\t\t\t\t<label for=\"include_stage__{{id}}\">{{STRINGS.reviews}} - {{name}}</label>\n\t\t\t\t\t</span>\n\t\t\t\t</label>\n\t\t\t{{/review_stages}}\n\t\t</div>\n\t{{/isFullDownload}}\n\n\t<!-- download buttons -->\n\t<div class=\"form-group\">\n\t\t<button type=\"button\" id=\"download-btn\" class=\"btn btn-primary\">{{STRINGS.download}}</button>\n\t\t<button type=\"button\" id=\"cancel-btn\" class=\"btn btn-default\">{{STRINGS.cancel}}</button>\n\t</div>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(909);
var bytesToUuid = __webpack_require__(910);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-js-popover sma-popover\" data-placement=\"");t.b(t.v(t.f("placement",c,p,0)));t.b("\" role=\"tooltip\">");t.b("\n" + i);t.b("	<a class=\"sma-popover-x sma-js-popover-x\" href=\"#\">x</a>");t.b("\n" + i);t.b("	<div class=\"sma-popover-content sma-js-popover-content\">");t.b(t.t(t.f("content",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-js-popover sma-popover\" data-placement=\"{{placement}}\" role=\"tooltip\">\n\t<a class=\"sma-popover-x sma-js-popover-x\" href=\"#\">x</a>\n\t<div class=\"sma-popover-content sma-js-popover-content\">{{{content}}}</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("id",c,p,1),c,p,0,7,54,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div id=\"sma-js-stage-preview-");t.b(t.v(t.f("id",c,p,0)));t.b("\"></div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#id}}\n\t<div id=\"sma-js-stage-preview-{{id}}\"></div>\n{{/id}}", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("collaborators",c,p,1),c,p,0,18,421,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("	<div class=\"d-flex flex-row mt-1 mb-1\">");t.b("\n" + i);if(t.s(t.f("picture",c,p,1),c,p,0,74,183,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("			<img class=\"sma-avatar-sm sma-app-view-user-avatar\" src=");t.b(t.v(t.f("picture",c,p,0)));t.b(" alt=\"");t.b(t.v(t.d("strings.profile_picture",c,p,0)));t.b("\">");t.b("\n" + i);});c.pop();}if(!t.s(t.f("picture",c,p,1),c,p,1,0,0,"")){t.b("			<div class=\"sma-avatar-sm\">");t.b("\n" + i);t.b("				");t.b(t.t(t.f("initials",c,p,0)));t.b("\n" + i);t.b("			</div>");t.b("\n" + i);};t.b("		<div class=\"sma-user-info\">");t.b("\n" + i);t.b("			<div>");t.b(t.v(t.f("name",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("			<small class=\"sma-user-email-address\">");t.b(t.v(t.f("email",c,p,0)));t.b("</small>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#collaborators}}\n\t<div class=\"d-flex flex-row mt-1 mb-1\">\n\t\t{{#picture}}\n\t\t\t<img class=\"sma-avatar-sm sma-app-view-user-avatar\" src={{picture}} alt=\"{{strings.profile_picture}}\">\n\t\t{{/picture}}\n\t\t{{^picture}}\n\t\t\t<div class=\"sma-avatar-sm\">\n\t\t\t\t{{{ initials }}}\n\t\t\t</div>\n\t\t{{/picture}}\n\t\t<div class=\"sma-user-info\">\n\t\t\t<div>{{ name }}</div>\n\t\t\t<small class=\"sma-user-email-address\">{{ email }}</small>\n\t\t</div>\n\t</div>\n{{/collaborators}}", H);return T.render.apply(T, arguments); };

/***/ }),
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__(1758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Avatar__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var Avatar = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.square, square = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? null : _d;
    var _e;
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-avatar", "wds-avatar--" + size, { "wds-avatar--square": square }, (_e = {}, _e["wds-avatar--" + color] = !!color, _e));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-avatar__body" }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (Avatar);
//# sourceMappingURL=Avatar.js.map

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Button = function (_a) {
    var children = _a.children, _b = _a.stretched, stretched = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.theme, theme = _d === void 0 ? "primary" : _d, _e = _a.kind, kind = _e === void 0 ? "solid" : _e, _f = _a.icon, icon = _f === void 0 ? null : _f, className = _a.className, otherProps = __rest(_a, ["children", "stretched", "size", "theme", "kind", "icon", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-button", "wds-button--" + theme, "wds-button--" + size, "wds-button--" + kind, { "wds-button--stretched": stretched }, { "wds-button--icon-left": icon === "left" }, { "wds-button--icon-right": icon === "right" }, { "wds-button--icon-only": icon === "only" }) }, otherProps), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Button);
//# sourceMappingURL=Button.js.map

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(1761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(242);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var enhance = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])("isCollapsed", "setIsCollapsed", false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["setDisplayName"])("Card"));
var Card = enhance(function (_a) {
    var children = _a.children, className = _a.className, wdsTitle = _a.wdsTitle, collapsible = _a.collapsible, isCollapsed = _a.isCollapsed, setIsCollapsed = _a.setIsCollapsed, otherProps = __rest(_a, ["children", "className", "wdsTitle", "collapsible", "isCollapsed", "setIsCollapsed"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-card", className) }, otherProps),
        wdsTitle && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-card__header", {
                "wds-card__header--collapsed": isCollapsed
            }) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "wds-card__title wds-type--card-title" }, wdsTitle),
            collapsible && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */], { style: { cursor: "pointer" }, onClick: function () { return setIsCollapsed(!isCollapsed); } }, isCollapsed ? "á" : "Ÿ")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-card__body", {
                "wds-card__body--collapsed": isCollapsed
            }) }, children)));
});
/* harmony default export */ __webpack_exports__["a"] = (Card);
//# sourceMappingURL=Card.js.map

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Icon = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? null : _c, otherProps = __rest(_a, ["children", "className", "size"]);
    var _d;
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-icon", className, (_d = {},
        _d["wds-icon--" + size] = !!size,
        _d));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", __assign({ className: classNames, "aria-hidden": "true" }, otherProps), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Icon);
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Checkbox = function (_a) {
    var label = _a.label, className = _a.className, otherProps = __rest(_a, ["label", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-checkbox" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ type: "checkbox", className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-checkbox__native") }, otherProps)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-checkbox__faux" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "wds-checkbox__label", htmlFor: otherProps.id }, label)));
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);
//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Error__ = __webpack_require__(1769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Error__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var Error = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-type--body wds-type--warning", className) }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Error);
//# sourceMappingURL=Error.js.map

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup__ = __webpack_require__(1771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormField__ = __webpack_require__(1772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__FormField__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var FormGroup = function (_a) {
    var children = _a.children, _b = _a.inline, inline = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? "" : _c;
    var className = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-form-group", {
        "wds-form-group--inline": inline
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("fieldset", { className: className },
        label && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("legend", { className: "wds-form-group__legend wds-label" }, label)),
        children));
};
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);
//# sourceMappingURL=FormGroup.js.map

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var FormField = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    var formFieldClassName = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-form-group__field", className);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: formFieldClassName }, children);
};
/* harmony default export */ __webpack_exports__["a"] = (FormField);
//# sourceMappingURL=FormField.js.map

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Col__ = __webpack_require__(1775);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Row__ = __webpack_require__(1776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Row__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Grid = function (_a) {
    var children = _a.children, _b = _a.noBleeds, noBleeds = _b === void 0 ? false : _b, _c = _a.noGutters, noGutters = _c === void 0 ? false : _c, _d = _a.fluid, fluid = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? "" : _e, other = __rest(_a, ["children", "noBleeds", "noGutters", "fluid", "className"]);
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-grid", { "wds-grid--no-bleeds": noBleeds }, { "wds-grid--no-gutters": noGutters }, { "wds-grid--fluid": fluid }, className);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: classNames }, other), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);
//# sourceMappingURL=Grid.js.map

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Col = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.lg, lg = _b === void 0 ? null : _b, _c = _a.md, md = _c === void 0 ? null : _c, _d = _a.sm, sm = _d === void 0 ? null : _d, _e = _a.xs, xs = _e === void 0 ? null : _e, _f = _a.xl, xl = _f === void 0 ? null : _f, other = __rest(_a, ["className", "children", "lg", "md", "sm", "xs", "xl"]);
    var _g, _h, _j, _k, _l;
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-grid__col", (_g = {}, _g["wds-grid__col-lg-" + lg] = !!lg, _g), (_h = {}, _h["wds-grid__col-md-" + md] = !!md, _h), (_j = {}, _j["wds-grid__col-sm-" + sm] = !!sm, _j), (_k = {}, _k["wds-grid__col-xl-" + xl] = !!xl, _k), (_l = {}, _l["wds-grid__col-" + xs] = !!xs, _l));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: classNames }, other), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Col);
//# sourceMappingURL=Col.js.map

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Row = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, other = __rest(_a, ["children", "className"]);
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-grid__row", className);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: classNames }, other), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Row);
//# sourceMappingURL=Row.js.map

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Input = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.wdsSize, wdsSize = _c === void 0 ? "md" : _c, theme = _a.theme, _d = _a.stretched, stretched = _d === void 0 ? false : _d, className = _a.className, children = _a.children, otherProps = __rest(_a, ["label", "wdsSize", "theme", "stretched", "className", "children"]);
    var _e;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: { position: "relative", display: "inline-block" }, className: __WEBPACK_IMPORTED_MODULE_1_classnames__({
            "wds-input--stretched": stretched
        }) },
        label && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: otherProps.id, className: "wds-label" }, label)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-input", "wds-input--" + wdsSize, (_e = {},
                _e["wds-input--" + theme] = !!theme,
                _e["wds-input--has-inner"] = !!children,
                _e["wds-input--stretched"] = stretched,
                _e)) }, otherProps)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-input__inner" }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (Input);
//# sourceMappingURL=Input.js.map

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tooltip__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Tooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__d8660091_react_popper__ = __webpack_require__(116);


function Tooltip(props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__d8660091_react_popper__["default"], { options: {
            placement: "bottom-start"
        }, renderRef: function (_a) {
            var setReference = _a.setReference, open = _a.open, close = _a.close;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: props.className, ref: setReference, onMouseEnter: open, onMouseLeave: close }, props.children)));
        }, renderPop: function (_a) {
            var setPop = _a.setPop;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: setPop, className: "sui-tooltip" },
                props.icon,
                props.title));
        } }));
}
//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputGroup__ = __webpack_require__(1782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputGroupAddon__ = __webpack_require__(1784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__InputGroupAddon__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_Label__ = __webpack_require__(920);




var InputGroup = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.id, id = _c === void 0 ? "" : _c, _d = _a.label, label = _d === void 0 ? "" : _d, _e = _a.stretched, stretched = _e === void 0 ? false : _e;
    var inputID = id || __WEBPACK_IMPORTED_MODULE_2_uuid_v4__();
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-input-group", { "wds-input-group--stretched": stretched }, className);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        label && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_Label__["a" /* default */], { htmlFor: inputID }, label),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { id: inputID, className: classNames }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (InputGroup);
//# sourceMappingURL=InputGroup.js.map

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var Label = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, htmlFor = _a.htmlFor, _c = _a.muted, muted = _c === void 0 ? false : _c;
    var cx = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-label", { "wds-label--muted": muted }, className);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: cx, htmlFor: htmlFor }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Label);
//# sourceMappingURL=Label.js.map

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var InputGroupAddon = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-input-group__addon" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (InputGroupAddon);
//# sourceMappingURL=InputGroupAddon.js.map

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var List = function (_a) {
    var _b = _a.dense, dense = _b === void 0 ? false : _b, _c = _a.interactive, interactive = _c === void 0 ? false : _c, _d = _a.noRules, noRules = _d === void 0 ? false : _d, _e = _a.transparent, transparent = _e === void 0 ? false : _e, children = _a.children, _f = _a.role, role = _f === void 0 ? "" : _f, _g = _a.id, id = _g === void 0 ? "" : _g;
    var outerClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-list", { "wds-list--no-rules": noRules }, { "wds-list--interactive": interactive }, { "wds-list--transparent": transparent }, { "wds-list--dense": dense });
    var newChildren = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, { interactive: interactive, index: index });
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { className: outerClassNames, role: role, id: id }, newChildren));
};
/* harmony default export */ __webpack_exports__["a"] = (List);
//# sourceMappingURL=List.js.map

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(1787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var Label = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, otherProps = __rest(_a, ["children", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", __assign({ className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-label", className) }, otherProps), children));
};
/* harmony default export */ __webpack_exports__["a"] = (Label);
//# sourceMappingURL=Label.js.map

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuItem__ = __webpack_require__(1791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuGroup__ = __webpack_require__(923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuGroup__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuGroup__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_a11y__ = __webpack_require__(1790);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var renderListItems = function (children, groupIndex) {
    if (groupIndex === void 0) { groupIndex = 0; }
    return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, { groupIndex: groupIndex });
    });
};
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.getOuterClassNames = function () {
            var _a = _this.props, noMaxHeight = _a.noMaxHeight, stretched = _a.stretched;
            /**
             * If any of the menu items is navigable, the menu should lose
             * its max height.
             */
            __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(_this.props.children, function (element) {
                if (element && element.props && element.props.isNavigable) {
                    noMaxHeight = true;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-has-menu", "wds-has-menu--show", { "wds-has-menu--stretched": stretched }, { "wds-menu--no-max-height": noMaxHeight });
        };
        _this.getMenuClassNames = function () {
            var _a;
            var direction = _this.props.direction;
            return __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-menu", (_a = {}, _a["wds-menu--" + direction] = !!direction, _a));
        };
        _this.handleAutoCloseClick = function (e) {
            if (_this.menu && !_this.menu.contains(e.target)) {
                _this.menuChange(false);
            }
        };
        _this.handleAutoCloseBlur = function () {
            setTimeout(function () {
                if (_this.menu && !_this.menu.contains(document.activeElement)) {
                    _this.menuChange(false);
                }
            }, 0);
        };
        _this.handleClick = function () {
            var show = _this.state.show;
            _this.menuChange(!show);
        };
        _this.renderTrigger = function () {
            var menuTrigger = _this.props.menuTrigger;
            return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](menuTrigger, {
                "aria-haspopup": true,
                //TODO this doesn't work
                // "aria-owns": show ? this.id : null,
                onClick: _this.handleClick,
                onKeyPress: Object(__WEBPACK_IMPORTED_MODULE_4__utils_a11y__["a" /* default */])("Enter", _this.handleClick)
            });
        };
        _this.renderList = function () {
            // TODO make sure only MenuItem or MenuGroup are passed in
            var items = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(_this.props.children, function (child, index) {
                if (child.type && child.type.displayName === "MenuGroup") {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MenuGroup__["a" /* default */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__List__["b" /* default */], __assign({ interactive: true, noRules: true, dense: _this.props.dense }, _this.props), renderListItems(child.props.children, index))));
                }
                return null;
            });
            if (items.length)
                return items;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__List__["b" /* default */], __assign({ noRules: true, interactive: true, dense: _this.props.dense }, _this.props), renderListItems(_this.props.children)));
        };
        _this.renderMenu = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: _this.getMenuClassNames(), role: "menu" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-menu__body" }, _this.renderList()))); };
        _this.state = { show: props.show };
        return _this;
    }
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.show !== this.state.show) {
            this.setState({ show: nextProps.show });
        }
    };
    Menu.prototype.componentDidUpdate = function () {
        var autoClose = this.props.autoClose;
        var show = this.state.show;
        if (autoClose) {
            if (show) {
                document.addEventListener("click", this.handleAutoCloseClick);
            }
            else {
                document.removeEventListener("click", this.handleAutoCloseClick);
            }
        }
    };
    Menu.prototype.menuChange = function (show) {
        this.setState({ show: show });
        if (this.props.onChange) {
            this.props.onChange({ show: show });
        }
    };
    Menu.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: this.getOuterClassNames(), onBlur: this.handleAutoCloseBlur, ref: function (menu) {
                _this.menu = menu;
            } },
            this.renderTrigger(),
            this.state.show && this.renderMenu()));
    };
    Menu.defaultProps = {
        autoClose: false,
        dense: false,
        direction: null,
        noMaxHeight: false,
        onChange: null,
        stretched: false,
        show: false
    };
    return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Menu);
//# sourceMappingURL=Menu.js.map

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Only fire the supplied callback if the event
// was triggered by the specified key
var keyPressed = function (key, func) { return function (event) {
    if (event.key === key) {
        func(event);
    }
}; };
/* harmony default export */ __webpack_exports__["a"] = (keyPressed);
//# sourceMappingURL=a11y.js.map

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List_ListItem__ = __webpack_require__(922);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var MenuItem = function (_a) {
    var _b = _a.addOn, addOn = _b === void 0 ? null : _b, _c = _a.addOnDirection, addOnDirection = _c === void 0 ? null : _c, _d = _a.color, color = _d === void 0 ? undefined : _d, onClick = _a.onClick, _e = _a.children, children = _e === void 0 ? null : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.marked, marked = _g === void 0 ? false : _g, _h = _a.upgrade, upgrade = _h === void 0 ? false : _h, _j = _a.groupIndex, groupIndex = _j === void 0 ? null : _j, _k = _a.index, index = _k === void 0 ? null : _k, props = __rest(_a, ["addOn", "addOnDirection", "color", "onClick", "children", "disabled", "marked", "upgrade", "groupIndex", "index"]);
    var getProps = function () { return ({
        tabIndex: disabled ? -1 : 0,
        role: "menuItem"
    }); };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__List_ListItem__["a" /* default */], __assign({ addOn: addOn, addOnDirection: addOnDirection, color: color, onClick: onClick, disabled: disabled, marked: marked, upgrade: upgrade, index: index, "data-group": groupIndex }, props, getProps()), children));
};
/* harmony default export */ __webpack_exports__["a"] = (MenuItem);
//# sourceMappingURL=MenuItem.js.map

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalBody__ = __webpack_require__(1798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ModalBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalHeader__ = __webpack_require__(1800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ModalHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalFooter__ = __webpack_require__(1801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__ModalFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Align__ = __webpack_require__(1802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Align__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_Overlay__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_CloseButton__ = __webpack_require__(1796);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeButton = function () {
            return _this.props.dismissible ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_CloseButton__["a" /* default */], { onClick: _this.handleClick, ariaLabel: _this.props.ariaLabel })) : null;
        };
        _this.handleClick = function () {
            if (_this.props.dismissible) {
                var onClose = _this.props.onClose;
                if (onClose)
                    onClose();
            }
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        if (this.modal) {
            this.modal.focus();
        }
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, size = _a.size, show = _a.show;
        var modalClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-modal", className, { "wds-modal--enter": show }, { "wds-modal--exit": !show }, "wds-modal--" + size);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: modalClassNames },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__internal_Overlay__["a" /* default */], { onClick: this.handleClick }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { role: "dialog", className: "wds-modal__modal", ref: function (modal) {
                    _this.modal = modal;
                }, tabIndex: -1 },
                this.closeButton(),
                this.props.children)));
    };
    return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
Modal.defaultProps = {
    className: "",
    dismissible: true,
    onClose: null,
    show: false,
    size: "sm",
    ariaLabel: "Close Modal"
};
/* harmony default export */ __webpack_exports__["a"] = (Modal);
//# sourceMappingURL=Modal.js.map

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overlay__ = __webpack_require__(1795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Overlay__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Overlay = function (_a) {
    var onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-modal__overlay", onClick: onClick }));
};
/* harmony default export */ __webpack_exports__["a"] = (Overlay);
//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CloseButton__ = __webpack_require__(1797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CloseButton__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(242);




var CloseButton = function (_a) {
    var onClick = _a.onClick, _b = _a.variant, variant = _b === void 0 ? "dark" : _b, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? "Close" : _c;
    var cx = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-close", "wds-button--icon-only", "wds-button--" + variant);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], { kind: "text", color: "secondary", size: "sm", className: cx, onClick: onClick, "aria-label": ariaLabel },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["a" /* default */], null, "\u00E5")));
};
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);
//# sourceMappingURL=CloseButton.js.map

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pane__ = __webpack_require__(467);


var ModalBody = function (_a) {
    var children = _a.children, _b = _a.padding, padding = _b === void 0 ? true : _b;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("section", { className: "wds-modal__body" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Pane__["a" /* default */], { padding: padding, transparent: true }, children)));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalBody);
//# sourceMappingURL=ModalBody.js.map

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var Pane = function (_a) {
    var children = _a.children, _b = _a.hide, hide = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? false : _c, _d = _a.transparent, transparent = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? null : _e, _f = _a.role, role = _f === void 0 ? null : _f;
    var renderPaneBody = function () {
        var body = children;
        if (padding) {
            body = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-pane__body" }, children);
            return body;
        }
        return body;
    };
    var getPaneClassNames = function () {
        return __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-pane", { "wds-pane--transparent": transparent }, { "wds-pane--hide": hide });
    };
    var outerProps = __assign({}, (role && { role: role }), (id && { id: id }));
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ className: getPaneClassNames() }, outerProps), renderPaneBody()));
};
/* harmony default export */ __webpack_exports__["a"] = (Pane);
//# sourceMappingURL=Pane.js.map

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var ModalHeader = function (_a) {
    var _b = _a.addOn, addOn = _b === void 0 ? null : _b, _c = _a.header, header = _c === void 0 ? "" : _c, _d = _a.subHeader, subHeader = _d === void 0 ? "" : _d, _e = _a.stretched, stretched = _e === void 0 ? false : _e;
    if (subHeader && addOn) {
        throw new Error("You cannot have both subHeader and addon");
    }
    else if (!header && subHeader) {
        throw new Error("You must provide a header if you provide a subHeader");
    }
    var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-modal__addon", {
        "wds-modal__addon--stretched": stretched || !header
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "wds-modal__head" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-modal__title" },
            header && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", { className: "wds-modal__text" }, header),
            subHeader && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "wds-modal__sub-text" }, subHeader),
            addOn && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames }, addOn))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);
//# sourceMappingURL=ModalHeader.js.map

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ModalFooter = function (_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("footer", { className: "wds-modal__foot" }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalFooter);
//# sourceMappingURL=ModalFooter.js.map

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Align = function (_a) {
    var direction = _a.direction, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-modal__actions-" + direction }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Align);
//# sourceMappingURL=Align.js.map

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(1804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Radio__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


function Radio(_a) {
    var label = _a.label, className = _a.className, otherProps = __rest(_a, ["label", "className"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-radio" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ type: "radio", className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-radio__native") }, otherProps)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "wds-radio__faux" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "wds-radio__label", htmlFor: otherProps.id }, label)));
}
/* harmony default export */ __webpack_exports__["a"] = (Radio);
//# sourceMappingURL=Radio.js.map

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Option__ = __webpack_require__(1807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Option__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_Label__ = __webpack_require__(920);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var Select = function (_a) {
    var label = _a.label, className = _a.className, _b = _a.stretched, stretched = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_2_uuid_v4__() : _c, color = _a.color, children = _a.children, _d = _a.wdsSize, wdsSize = _d === void 0 ? "md" : _d, otherProps = __rest(_a, ["label", "className", "stretched", "id", "color", "children", "wdsSize"]);
    var _e;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        label && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_Label__["a" /* default */], { htmlFor: id }, label),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-select", { "wds-select--stretched": stretched }, (_e = {}, _e["wds-select--" + color] = !!color, _e), { "wds-select--multi": otherProps.multiple }, "wds-select--" + wdsSize, className) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("select", __assign({ "aria-label": label, id: id }, otherProps), children))));
};
/* harmony default export */ __webpack_exports__["a"] = (Select);
//# sourceMappingURL=Select.js.map

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Option = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, value = _a.value;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option", { disabled: disabled, value: value }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Option);
//# sourceMappingURL=Option.js.map

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner__ = __webpack_require__(1809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Spinner__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.centered, centered = _c === void 0 ? false : _c;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-spinner wds-spinner--" + size, {
            "sui-spinner-center": centered
        }), viewBox: "25 25 50 50" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { className: "wds-spinner__path-border", cx: "50", cy: "50", r: "20" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { className: "wds-spinner__path-fill", cx: "50", cy: "50", r: "20" })));
};
/* harmony default export */ __webpack_exports__["a"] = (Spinner);
//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(1811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Switch__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Switch = function (_a) {
    var className = _a.className, _b = _a.id, id = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2_uuid_v4__() : _b, otherProps = __rest(_a, ["className", "id"]);
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-switch", className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ id: id, className: "sui-switch__native" }, otherProps, { type: "checkbox" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "sui-switch__faux", htmlFor: id })));
};
/* harmony default export */ __webpack_exports__["a"] = (Switch);
//# sourceMappingURL=Switch.js.map

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tab__ = __webpack_require__(1814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Tab__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pane__ = __webpack_require__(467);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};




var renderActivePane = function (children, fullWidth, id) {
    var paneProps = fullWidth ? { transparent: true } : { padding: true };
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "wds-tab__panes", "labelled-by": id },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Pane__["a" /* default */], __assign({}, paneProps), children)));
};
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (_a, value, id) {
            if (value !== _this.state.value) {
                _this.setState({ value: value });
                if (_this.props.onChange) {
                    _this.props.onChange(value, id);
                }
            }
        };
        var selectedIndex = _this.getSelectedIndex();
        _this.state = { value: selectedIndex || 0 };
        return _this;
    }
    // this is triggered when react router path change
    Tabs.prototype.componentDidUpdate = function (_prevProps, prevState) {
        var selectedIndex = this.getSelectedIndex();
        if (selectedIndex != prevState.value) {
            this.setState({ value: selectedIndex || 0 });
        }
    };
    Tabs.prototype.getSelectedIndex = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(this.props.children, function (child, index) {
            var props = child.props;
            if (!__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](child)) {
                return null;
            }
            if (props.selected) {
                return index;
            }
            return null;
        })[0];
    };
    Tabs.prototype.getClassNames = function () {
        var _a = this.props, color = _a.color, align = _a.align;
        return __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-tab", "wds-tab--" + color, "wds-tab--" + align);
    };
    Tabs.prototype.renderTabElement = function (child, index, selected, id) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child, {
            selected: selected,
            onChange: this.handleChange,
            value: index,
            children: child.props.title,
            id: id,
            key: id
        });
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, children = _a.children;
        var TabList = [];
        var ActivePane = null;
        __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child, index) {
            var props = child.props;
            if (__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](child)) {
                var id = props.id || "tab-" + index + "-" + __WEBPACK_IMPORTED_MODULE_2_uuid_v4__();
                var selected = index === _this.state.value;
                TabList.push(_this.renderTabElement(child, index, selected, id));
                if (selected && props.children) {
                    ActivePane = renderActivePane(props.children, fullWidth, id);
                }
            }
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: this.getClassNames() },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", { role: "tablist", className: "wds-tab__tabs" }, TabList),
            ActivePane));
    };
    Tabs.defaultProps = {
        align: "left",
        fullWidth: false,
        onChange: null,
        color: "light"
    };
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Tabs);
//# sourceMappingURL=Tabs.js.map

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOuterTabClasses = function () {
            var _a = _this.props, selected = _a.selected, disabled = _a.disabled;
            return __WEBPACK_IMPORTED_MODULE_1_classnames__("wds-tab__tab", { "wds-tab__tab--selected": selected }, { "wds-tab__tab--disabled": disabled });
        };
        _this.handleClick = function (event) {
            var _a = _this.props, onChange = _a.onChange, value = _a.value, id = _a.id;
            if (!!onChange) {
                onChange(event, value, id);
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, value = _a.value, selected = _a.selected, id = _a.id, innerRef = _a.innerRef;
        var component = this.props.component ? this.props.component : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", null);
        var NewComponent = __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](component, {
            disabled: disabled,
            value: value,
            role: "tab",
            tabIndex: disabled ? -1 : 0,
            "aria-selected": selected,
            className: "wds-tab__tab-btn",
            onClick: this.handleClick,
            id: id,
            ref: innerRef,
            children: this.props.children
        });
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", { className: this.getOuterTabClasses() }, NewComponent);
    };
    Tab.defaultProps = {
        children: "",
        disabled: false,
        id: null,
        innerRef: null,
        onChange: null,
        selected: false,
        value: 0,
        component: null
    };
    return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Tab);
//# sourceMappingURL=Tab.js.map

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Textarea__ = __webpack_require__(1816);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Textarea__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var Textarea = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.wdsSize, wdsSize = _c === void 0 ? "md" : _c, theme = _a.theme, _d = _a.stretched, stretched = _d === void 0 ? false : _d, className = _a.className, _e = _a.id, id = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_2_uuid_v4__() : _e, otherProps = __rest(_a, ["label", "wdsSize", "theme", "stretched", "className", "id"]);
    var _f;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        label && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: id, className: "wds-label" }, label)),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", __assign({ id: id, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className, "wds-textarea", "wds-textarea--" + wdsSize, (_f = {},
                _f["wds-textarea--" + theme] = !!theme,
                _f["wds-textarea--stretched"] = stretched,
                _f)) }, otherProps))));
};
/* harmony default export */ __webpack_exports__["a"] = (Textarea);
//# sourceMappingURL=Textarea.js.map

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdvancedSelect__ = __webpack_require__(1818);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AdvancedSelect__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__d8660091_react_popper__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Input__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(242);







var enhance = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["defaultProps"])({
    placeholder: "Select a value",
    emptyPlaceholder: "No items to be shown",
    items: [],
    isMultiple: false,
    selectedText: " selected"
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])("searchString", "setSearchString", ""), 
// modify items prop by searchString
Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    activeItem: Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["b" /* find */])(props.items, { value: props.value }),
    items: props.items.filter(function (item) {
        return (typeof item.label === "string" &&
            Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["e" /* includes */])(item.label.toLocaleLowerCase(), props.searchString.toLocaleLowerCase()));
    })
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    groups: props.groups || Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["g" /* uniq */])(props.items.map(function (item) { return item.group; })) || []
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])("activeGroup", "setActiveGroup", function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["c" /* get */])(props.activeItem, "group", props.groups[0]);
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    groupedItems: props.items.filter(function (item) {
        if (props.isGrouped) {
            return item.group === props.activeGroup;
        }
        else {
            return true;
        }
    }),
    buttonText: (function () {
        if (props.activeItem) {
            return props.activeItem.label;
        }
        if (props.items.length === 0) {
            return props.emptyPlaceholder;
        }
        if (Array.isArray(props.value) && props.value.length > 0) {
            return props.value.length + props.selectedText;
        }
        return props.placeholder;
    })()
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withHandlers"])({
    onItemClick: function (props) { return function (_a) {
        var value = _a.value, closePopper = _a.closePopper;
        return function () {
            if (props.isMultiple) {
                props.onChange(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["g" /* uniq */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["a" /* compact */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["i" /* xor */])(props.value, [value]))));
            }
            else {
                props.onChange(value);
                closePopper();
            }
        };
    }; }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["setDisplayName"])("AdvancedSelect"));
var AdvancedSelect = enhance(function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__d8660091_react_popper__["default"], { options: {
            placement: "bottom-start",
            modifiers: {
                offset: {
                    offset: 1
                }
            },
            onUpdate: function (_a) {
                var popper = _a.instance.popper, width = _a.offsets.reference.width;
                popper.style.minWidth = width + "px"; // min width should be the trigger's width
            }
        }, renderRef: function (_a) {
            var setReference = _a.setReference, toggle = _a.toggle;
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                props.label && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "wds-label" }, props.label),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", ref: setReference, onClick: toggle, className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-advanced-select__trigger", props.className), style: props.style, disabled: props.disabled }, props.buttonText)));
        }, renderPop: function (_a) {
            var setPop = _a.setPop, close = _a.close;
            return props.items.length > 0 || props.isSearchable || props.renderFooter ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: setPop, className: "sui-advanced-select__menu" },
                props.isSearchable && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__search" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Input__["a" /* default */], { value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); }, stretched: true },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */], null, "s")))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: props.groupsItemsStyle, className: "sui-advanced-select__groups-items" },
                    props.isGrouped && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__groups", style: props.groupsStyle }, props.isGrouped &&
                        props.groups.map(function (group) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: (props.activeItem &&
                                props.activeItem.value) + "_" + group, onClick: function () {
                                props.setActiveGroup(group);
                            }, className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-advanced-select__item", {
                                "sui-advanced-select__item--active": props.activeGroup === group
                            }) }, group)); }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__items" }, props.groupedItems.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: (props.activeItem && props.activeItem.value) + "_" + item.value, onClick: props.onItemClick({
                            value: item.value,
                            closePopper: close
                        }), className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-advanced-select__item", {
                            "sui-advanced-select__item--active": props.value === item.value ||
                                (Array.isArray(props.value) &&
                                    Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["e" /* includes */])(props.value, item.value))
                        }) },
                        item.label,
                        item.context && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "sui-advanced-select_item__context d-block float-right" }, item.context))); }))),
                props.renderFooter && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__footer" }, props.renderFooter(props))))) : null;
        } }));
});
/* harmony default export */ __webpack_exports__["a"] = (AdvancedSelect);
//# sourceMappingURL=AdvancedSelect.js.map

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(68);


/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  return +value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToNumber);


/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(929);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCtor_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = Object(__WEBPACK_IMPORTED_MODULE_0__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var fn = (this && this !== __WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createBind);


/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCtor_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createHybrid_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createRecurry_js__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getHolder_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__replaceHolders_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root_js__ = __webpack_require__(46);








/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = Object(__WEBPACK_IMPORTED_MODULE_1__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = Object(__WEBPACK_IMPORTED_MODULE_4__getHolder_js__["a" /* default */])(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : Object(__WEBPACK_IMPORTED_MODULE_5__replaceHolders_js__["a" /* default */])(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__createRecurry_js__["a" /* default */])(
        func, bitmask, __WEBPACK_IMPORTED_MODULE_2__createHybrid_js__["a" /* default */], wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== __WEBPACK_IMPORTED_MODULE_6__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(fn, this, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createCurry);


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (countHolders);


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (getWrapDetails);


/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/* harmony default export */ __webpack_exports__["a"] = (insertWrapDetails);


/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(47);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(319);



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  Object(__WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */])(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !Object(__WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */])(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/* harmony default export */ __webpack_exports__["a"] = (updateWrapDetails);


/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIndex_js__ = __webpack_require__(119);



/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = Object(__WEBPACK_IMPORTED_MODULE_0__copyArray_js__["a" /* default */])(array);

  while (length--) {
    var index = indexes[length];
    array[length] = Object(__WEBPACK_IMPORTED_MODULE_1__isIndex_js__["a" /* default */])(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (reorder);


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCtor_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_js__ = __webpack_require__(46);




/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = Object(__WEBPACK_IMPORTED_MODULE_1__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== __WEBPACK_IMPORTED_MODULE_2__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createPartial);


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeArgs_js__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__ = __webpack_require__(174);




/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? Object(__WEBPACK_IMPORTED_MODULE_0__composeArgs_js__["a" /* default */])(partials, value, source[4]) : value;
    data[4] = partials ? Object(__WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__["a" /* default */])(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? Object(__WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__["a" /* default */])(partials, value, source[6]) : value;
    data[6] = partials ? Object(__WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__["a" /* default */])(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

/* harmony default export */ __webpack_exports__["a"] = (mergeData);


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(34);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(945);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1839);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(322);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(482);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1847);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(323);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(323);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(323);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(323);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(325);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(325);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(325);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(325);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(326);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(326);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(326);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(326);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);




/** Built-in value references. */
var spreadableSymbol = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ __webpack_exports__["a"] = (isFlattenable);


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ __webpack_exports__["a"] = (asciiToArray);


/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeToArray);


/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__ = __webpack_require__(487);


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = Object(__WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__["a" /* default */])(deburredLetters);

/* harmony default export */ __webpack_exports__["a"] = (deburrLetter);


/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (asciiWords);


/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicodeWord);


/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeWords);


/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(324);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(481);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(55);



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignIn);


/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(494);



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbols);


/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(950);



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbolsIn);


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(46);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneArray);


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__ = __webpack_require__(955);






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return Object(__WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__["a" /* default */])(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return Object(__WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return Object(__WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__["a" /* default */])(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return Object(__WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__["a" /* default */])(object);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneByTag);


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(496);


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDataView);


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneRegExp);


/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);


/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ __webpack_exports__["a"] = (cloneSymbol);


/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == setTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsSet);


/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(143);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(343);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(951);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(206);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseConformsTo_js__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(41);



/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source);
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseConformsTo_js__["a" /* default */])(object, source, props);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseConforms);


/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayAggregator);


/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(149);


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseAggregator);


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(36);



/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(objValue) && Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/* harmony default export */ __webpack_exports__["a"] = (customDefaultsMerge);


/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(348);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEachRight);


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(38);


/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return [key, object[key]];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseToPairs);


/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToPairs);


/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__ = __webpack_require__(487);


/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = Object(__WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__["a" /* default */])(htmlEscapes);

/* harmony default export */ __webpack_exports__["a"] = (escapeHtmlChar);


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(149);


/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseEvery);


/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toLength_js__ = __webpack_require__(356);



/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_js__["a" /* default */])(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_js__["a" /* default */])(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__toLength_js__["a" /* default */])(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFill);


/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHas);


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (baseInRange);


/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(150);


/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseInverter);


/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == arrayBufferTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArrayBuffer);


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == dateTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsDate);


/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stubFalse_js__ = __webpack_require__(247);




/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMaskable);


/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(34);



/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == regexpTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsRegExp);


/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (strictLastIndexOf);


/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (iteratorToArray);


/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject_js__ = __webpack_require__(123);


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject_js__["a" /* default */])(value) ? undefined : value;
}

/* harmony default export */ __webpack_exports__["a"] = (customOmitClone);


/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSortBy);


/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compareAscending_js__ = __webpack_require__(984);


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_0__compareAscending_js__["a" /* default */])(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/* harmony default export */ __webpack_exports__["a"] = (compareMultiple);


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(15);


/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = __WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (castRest);


/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(507);


/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])('length');

/* harmony default export */ __webpack_exports__["a"] = (asciiSize);


/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeSize);


/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePickBy_js__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasIn_js__ = __webpack_require__(253);



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__basePickBy_js__["a" /* default */])(object, paths, function(value, path) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__hasIn_js__["a" /* default */])(object, path);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (basePick);


/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOfWith);


/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseRange);


/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayReduceRight);


/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySample_js__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(151);



/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arraySample_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(collection));
}

/* harmony default export */ __webpack_exports__["a"] = (baseSample);


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shuffleSelf_js__ = __webpack_require__(373);




/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__shuffleSelf_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(array), Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(n, 0, array.length));
}

/* harmony default export */ __webpack_exports__["a"] = (arraySampleSize);


/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shuffleSelf_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_js__ = __webpack_require__(151);




/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = Object(__WEBPACK_IMPORTED_MODULE_2__values_js__["a" /* default */])(collection);
  return Object(__WEBPACK_IMPORTED_MODULE_1__shuffleSelf_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(n, 0, array.length));
}

/* harmony default export */ __webpack_exports__["a"] = (baseSampleSize);


/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyArray_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shuffleSelf_js__ = __webpack_require__(373);



/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__shuffleSelf_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__copyArray_js__["a" /* default */])(array));
}

/* harmony default export */ __webpack_exports__["a"] = (arrayShuffle);


/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shuffleSelf_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(151);



/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__shuffleSelf_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(collection));
}

/* harmony default export */ __webpack_exports__["a"] = (baseShuffle);


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(149);


/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  Object(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSome);


/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(69);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/* harmony default export */ __webpack_exports__["a"] = (customDefaultsAssignIn);


/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/* harmony default export */ __webpack_exports__["a"] = (escapeStringChar);


/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/* harmony default export */ __webpack_exports__["a"] = (reEscape);


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/* harmony default export */ __webpack_exports__["a"] = (reEvaluate);


/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__ = __webpack_require__(487);


/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = Object(__WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__["a" /* default */])(htmlUnescapes);

/* harmony default export */ __webpack_exports__["a"] = (unescapeHtmlChar);


/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Set_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToArray_js__ = __webpack_require__(343);




/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(__WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */] && (1 / Object(__WEBPACK_IMPORTED_MODULE_2__setToArray_js__["a" /* default */])(new __WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */]([,-0]))[1]) == INFINITY) ? __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */] : function(values) {
  return new __WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */](values);
};

/* harmony default export */ __webpack_exports__["a"] = (createSet);


/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperValue_js__ = __webpack_require__(214);
/* unused harmony reexport default */



/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collection_js__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_js__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_js__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_js__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math_js__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__number_js__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__object_js__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__seq_js__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string_js__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_js__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LodashWrapper_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Symbol_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__arrayEach_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__arrayPush_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__baseForOwn_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__baseFunctions_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__baseInvoke_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__baseIteratee_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__baseRest_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__createHybrid_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__keys_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__last_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lazyClone_js__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lazyReverse_js__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lazyValue_js__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mixin_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__negate_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__realNames_js__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__thru_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__ = __webpack_require__(171);
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */





































/** Used as the semantic version number. */
var VERSION = '4.17.15';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_KEY_FLAG = 2;

/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
    LAZY_WHILE_FLAG = 3;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var symIterator = __WEBPACK_IMPORTED_MODULE_13__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_13__Symbol_js__["a" /* default */].iterator : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

// wrap `_.mixin` so it works when provided only one argument
var mixin = (function(func) {
  return function(object, source, options) {
    if (options == null) {
      var isObj = Object(__WEBPACK_IMPORTED_MODULE_24__isObject_js__["a" /* default */])(source),
          props = isObj && Object(__WEBPACK_IMPORTED_MODULE_25__keys_js__["a" /* default */])(source),
          methodNames = props && props.length && Object(__WEBPACK_IMPORTED_MODULE_17__baseFunctions_js__["a" /* default */])(source, props);

      if (!(methodNames ? methodNames.length : isObj)) {
        options = source;
        source = object;
        object = this;
      }
    }
    return func(object, source, options);
  };
}(__WEBPACK_IMPORTED_MODULE_30__mixin_js__["a" /* default */]));

// Add methods that return wrapped values in chain sequences.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].after = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].after;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].ary = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].ary;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].assign = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assign;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].assignIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assignIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].assignInWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assignInWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].assignWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assignWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].at = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].at;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].before = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].before;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].bind = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].bind;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].bindAll = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].bindAll;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].bindKey = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].bindKey;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].castArray = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].castArray;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].chain = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].chain;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].chunk = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].chunk;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].compact = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].compact;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].concat = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].concat;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].cond = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].cond;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].conforms = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].conforms;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].constant = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].constant;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].countBy = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].countBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].create = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].create;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].curry = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].curry;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].curryRight = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].curryRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].debounce = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].debounce;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].defaults = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].defaults;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].defaultsDeep = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].defaultsDeep;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].defer = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].defer;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].delay = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].delay;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].difference = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].difference;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].differenceBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].differenceBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].differenceWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].differenceWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].drop = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].drop;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].dropRight = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].dropRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].dropRightWhile = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].dropRightWhile;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].dropWhile = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].dropWhile;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].fill = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].fill;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].filter = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].filter;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flatMap = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].flatMap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flatMapDeep = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].flatMapDeep;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flatMapDepth = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].flatMapDepth;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flatten = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].flatten;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flattenDeep = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].flattenDeep;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flattenDepth = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].flattenDepth;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flip = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].flip;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flow = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].flow;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].flowRight = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].flowRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].fromPairs = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].fromPairs;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].functions = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].functions;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].functionsIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].functionsIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].groupBy = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].groupBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].initial = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].initial;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].intersection = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].intersection;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].intersectionBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].intersectionBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].intersectionWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].intersectionWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].invert = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].invert;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].invertBy = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].invertBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].invokeMap = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].invokeMap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].iteratee = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].iteratee;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].keyBy = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].keyBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].keys = __WEBPACK_IMPORTED_MODULE_25__keys_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].keysIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].keysIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].map = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].map;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].mapKeys = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].mapKeys;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].mapValues = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].mapValues;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].matches = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].matches;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].matchesProperty = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].matchesProperty;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].memoize = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].memoize;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].merge = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].merge;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].mergeWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].mergeWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].method = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].method;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].methodOf = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].methodOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].mixin = mixin;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].negate = __WEBPACK_IMPORTED_MODULE_31__negate_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].nthArg = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].nthArg;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].omit = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].omit;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].omitBy = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].omitBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].once = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].once;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].orderBy = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].orderBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].over = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].over;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].overArgs = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].overArgs;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].overEvery = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].overEvery;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].overSome = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].overSome;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].partial = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].partial;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].partialRight = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].partialRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].partition = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].partition;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pick = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].pick;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pickBy = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].pickBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].property = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].property;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].propertyOf = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].propertyOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pull = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].pull;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pullAll = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].pullAll;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pullAllBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].pullAllBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pullAllWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].pullAllWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pullAt = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].pullAt;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].range = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].range;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].rangeRight = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].rangeRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].rearg = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].rearg;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].reject = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].reject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].remove = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].remove;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].rest = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].rest;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].reverse = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].reverse;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sampleSize = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].sampleSize;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].set = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].set;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].setWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].setWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].shuffle = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].shuffle;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].slice = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].slice;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortBy = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].sortBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedUniq = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedUniq;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedUniqBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedUniqBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].split = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].split;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].spread = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].spread;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].tail = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].tail;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].take = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].take;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].takeRight = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].takeRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].takeRightWhile = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].takeRightWhile;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].takeWhile = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].takeWhile;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].tap = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].tap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].throttle = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].throttle;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].thru = __WEBPACK_IMPORTED_MODULE_33__thru_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toArray = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toArray;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toPairs = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].toPairs;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toPairsIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].toPairsIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toPath = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].toPath;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toPlainObject = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toPlainObject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].transform = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].transform;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unary = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].unary;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].union = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].union;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unionBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].unionBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unionWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].unionWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].uniq = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].uniq;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].uniqBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].uniqBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].uniqWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].uniqWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unset = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].unset;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unzip = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].unzip;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unzipWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].unzipWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].update = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].update;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].updateWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].updateWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].values = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].values;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].valuesIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].valuesIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].without = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].without;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].words = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].words;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].wrap = __WEBPACK_IMPORTED_MODULE_3__function_js__["a" /* default */].wrap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].xor = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].xor;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].xorBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].xorBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].xorWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].xorWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].zip = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].zip;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].zipObject = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].zipObject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].zipObjectDeep = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].zipObjectDeep;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].zipWith = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].zipWith;

// Add aliases.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].entries = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].toPairs;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].entriesIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].toPairsIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].extend = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assignIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].extendWith = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].assignInWith;

// Add methods to `lodash.prototype`.
mixin(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */]);

// Add methods that return unwrapped values in chain sequences.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].add = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].add;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].attempt = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].attempt;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].camelCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].camelCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].capitalize = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].capitalize;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].ceil = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].ceil;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].clamp = __WEBPACK_IMPORTED_MODULE_6__number_js__["a" /* default */].clamp;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].clone = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].clone;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].cloneDeep = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].cloneDeep;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].cloneDeepWith = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].cloneDeepWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].cloneWith = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].cloneWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].conformsTo = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].conformsTo;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].deburr = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].deburr;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].defaultTo = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].defaultTo;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].divide = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].divide;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].endsWith = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].endsWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].eq = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].eq;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].escape = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].escape;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].escapeRegExp = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].escapeRegExp;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].every = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].every;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].find = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].find;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].findIndex = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].findIndex;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].findKey = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].findKey;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].findLast = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].findLast;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].findLastIndex = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].findLastIndex;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].findLastKey = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].findLastKey;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].floor = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].floor;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forEach = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].forEach;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forEachRight = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].forEachRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].forIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forInRight = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].forInRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forOwn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].forOwn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].forOwnRight = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].forOwnRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].get = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].get;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].gt = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].gt;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].gte = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].gte;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].has = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].has;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].hasIn = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].hasIn;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].head = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].head;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].identity = __WEBPACK_IMPORTED_MODULE_22__identity_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].includes = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].includes;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].indexOf = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].indexOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].inRange = __WEBPACK_IMPORTED_MODULE_6__number_js__["a" /* default */].inRange;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].invoke = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].invoke;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isArguments = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isArguments;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isArray = __WEBPACK_IMPORTED_MODULE_23__isArray_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isArrayBuffer = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isArrayBuffer;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isArrayLike = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isArrayLike;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isArrayLikeObject = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isArrayLikeObject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isBoolean = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isBoolean;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isBuffer = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isBuffer;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isDate = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isDate;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isElement = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isElement;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isEmpty = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isEmpty;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isEqual = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isEqual;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isEqualWith = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isEqualWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isError = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isError;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isFinite = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isFinite;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isFunction = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isFunction;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isInteger = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isInteger;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isLength = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isLength;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isMap = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isMap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isMatch = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isMatch;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isMatchWith = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isMatchWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isNaN = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isNaN;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isNative = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isNative;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isNil = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isNil;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isNull = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isNull;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isNumber = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isNumber;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isObject = __WEBPACK_IMPORTED_MODULE_24__isObject_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isObjectLike = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isObjectLike;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isPlainObject = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isPlainObject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isRegExp = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isRegExp;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isSafeInteger = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isSafeInteger;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isSet = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isSet;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isString = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isString;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isSymbol = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isSymbol;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isTypedArray = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isTypedArray;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isUndefined = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isUndefined;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isWeakMap = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isWeakMap;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].isWeakSet = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].isWeakSet;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].join = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].join;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].kebabCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].kebabCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].last = __WEBPACK_IMPORTED_MODULE_26__last_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].lastIndexOf = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].lastIndexOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].lowerCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].lowerCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].lowerFirst = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].lowerFirst;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].lt = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].lt;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].lte = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].lte;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].max = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].max;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].maxBy = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].maxBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].mean = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].mean;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].meanBy = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].meanBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].min = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].min;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].minBy = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].minBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].stubArray = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].stubArray;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].stubFalse = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].stubFalse;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].stubObject = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].stubObject;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].stubString = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].stubString;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].stubTrue = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].stubTrue;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].multiply = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].multiply;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].nth = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].nth;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].noop = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].noop;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].now = __WEBPACK_IMPORTED_MODULE_2__date_js__["a" /* default */].now;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].pad = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].pad;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].padEnd = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].padEnd;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].padStart = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].padStart;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].parseInt = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].parseInt;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].random = __WEBPACK_IMPORTED_MODULE_6__number_js__["a" /* default */].random;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].reduce = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].reduce;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].reduceRight = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].reduceRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].repeat = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].repeat;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].replace = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].replace;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].result = __WEBPACK_IMPORTED_MODULE_7__object_js__["a" /* default */].result;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].round = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].round;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sample = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].sample;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].size = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].size;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].snakeCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].snakeCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].some = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].some;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedIndex = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedIndex;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedIndexBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedIndexBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedIndexOf = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedIndexOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedLastIndex = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedLastIndex;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedLastIndexBy = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedLastIndexBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sortedLastIndexOf = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].sortedLastIndexOf;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].startCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].startCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].startsWith = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].startsWith;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].subtract = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].subtract;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sum = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].sum;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].sumBy = __WEBPACK_IMPORTED_MODULE_5__math_js__["a" /* default */].sumBy;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].template = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].template;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].times = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].times;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toFinite = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toFinite;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toInteger = __WEBPACK_IMPORTED_MODULE_34__toInteger_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toLength = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toLength;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toLower = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].toLower;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toNumber = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toNumber;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toSafeInteger = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toSafeInteger;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toString = __WEBPACK_IMPORTED_MODULE_4__lang_js__["a" /* default */].toString;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].toUpper = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].toUpper;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].trim = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].trim;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].trimEnd = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].trimEnd;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].trimStart = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].trimStart;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].truncate = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].truncate;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].unescape = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].unescape;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].uniqueId = __WEBPACK_IMPORTED_MODULE_10__util_js__["a" /* default */].uniqueId;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].upperCase = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].upperCase;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].upperFirst = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].upperFirst;

// Add aliases.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].each = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].forEach;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].eachRight = __WEBPACK_IMPORTED_MODULE_1__collection_js__["a" /* default */].forEachRight;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].first = __WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */].head;

mixin(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */], (function() {
  var source = {};
  Object(__WEBPACK_IMPORTED_MODULE_16__baseForOwn_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */], function(func, methodName) {
    if (!hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype, methodName)) {
      source[methodName] = func;
    }
  });
  return source;
}()), { 'chain': false });

/**
 * The semantic version number.
 *
 * @static
 * @memberOf _
 * @type {string}
 */
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].VERSION = VERSION;
(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].templateSettings = __WEBPACK_IMPORTED_MODULE_9__string_js__["a" /* default */].templateSettings).imports._ = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */];

// Assign default placeholders.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
  __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */][methodName].placeholder = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */];
});

// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['drop', 'take'], function(methodName, index) {
  __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype[methodName] = function(n) {
    n = n === undefined ? 1 : nativeMax(Object(__WEBPACK_IMPORTED_MODULE_34__toInteger_js__["a" /* default */])(n), 0);

    var result = (this.__filtered__ && !index)
      ? new __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */](this)
      : this.clone();

    if (result.__filtered__) {
      result.__takeCount__ = nativeMin(n, result.__takeCount__);
    } else {
      result.__views__.push({
        'size': nativeMin(n, MAX_ARRAY_LENGTH),
        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
      });
    }
    return result;
  };

  __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype[methodName + 'Right'] = function(n) {
    return this.reverse()[methodName](n).reverse();
  };
});

// Add `LazyWrapper` methods that accept an `iteratee` value.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['filter', 'map', 'takeWhile'], function(methodName, index) {
  var type = index + 1,
      isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

  __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype[methodName] = function(iteratee) {
    var result = this.clone();
    result.__iteratees__.push({
      'iteratee': Object(__WEBPACK_IMPORTED_MODULE_19__baseIteratee_js__["a" /* default */])(iteratee, 3),
      'type': type
    });
    result.__filtered__ = result.__filtered__ || isFilter;
    return result;
  };
});

// Add `LazyWrapper` methods for `_.head` and `_.last`.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['head', 'last'], function(methodName, index) {
  var takeName = 'take' + (index ? 'Right' : '');

  __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype[methodName] = function() {
    return this[takeName](1).value()[0];
  };
});

// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['initial', 'tail'], function(methodName, index) {
  var dropName = 'drop' + (index ? '' : 'Right');

  __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype[methodName] = function() {
    return this.__filtered__ ? new __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */](this) : this[dropName](1);
  };
});

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.compact = function() {
  return this.filter(__WEBPACK_IMPORTED_MODULE_22__identity_js__["a" /* default */]);
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.find = function(predicate) {
  return this.filter(predicate).head();
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.findLast = function(predicate) {
  return this.reverse().find(predicate);
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.invokeMap = Object(__WEBPACK_IMPORTED_MODULE_20__baseRest_js__["a" /* default */])(function(path, args) {
  if (typeof path == 'function') {
    return new __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */](this);
  }
  return this.map(function(value) {
    return Object(__WEBPACK_IMPORTED_MODULE_18__baseInvoke_js__["a" /* default */])(value, path, args);
  });
});

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.reject = function(predicate) {
  return this.filter(Object(__WEBPACK_IMPORTED_MODULE_31__negate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_19__baseIteratee_js__["a" /* default */])(predicate)));
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.slice = function(start, end) {
  start = Object(__WEBPACK_IMPORTED_MODULE_34__toInteger_js__["a" /* default */])(start);

  var result = this;
  if (result.__filtered__ && (start > 0 || end < 0)) {
    return new __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */](result);
  }
  if (start < 0) {
    result = result.takeRight(-start);
  } else if (start) {
    result = result.drop(start);
  }
  if (end !== undefined) {
    end = Object(__WEBPACK_IMPORTED_MODULE_34__toInteger_js__["a" /* default */])(end);
    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
  }
  return result;
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.takeRightWhile = function(predicate) {
  return this.reverse().takeWhile(predicate).reverse();
};

__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.toArray = function() {
  return this.take(MAX_ARRAY_LENGTH);
};

// Add `LazyWrapper` methods to `lodash.prototype`.
Object(__WEBPACK_IMPORTED_MODULE_16__baseForOwn_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype, function(func, methodName) {
  var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
      isTaker = /^(?:head|last)$/.test(methodName),
      lodashFunc = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */][isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
      retUnwrapped = isTaker || /^find/.test(methodName);

  if (!lodashFunc) {
    return;
  }
  __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype[methodName] = function() {
    var value = this.__wrapped__,
        args = isTaker ? [1] : arguments,
        isLazy = value instanceof __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */],
        iteratee = args[0],
        useLazy = isLazy || Object(__WEBPACK_IMPORTED_MODULE_23__isArray_js__["a" /* default */])(value);

    var interceptor = function(value) {
      var result = lodashFunc.apply(__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_15__arrayPush_js__["a" /* default */])([value], args));
      return (isTaker && chainAll) ? result[0] : result;
    };

    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
      // Avoid lazy use if the iteratee has a "length" value other than `1`.
      isLazy = useLazy = false;
    }
    var chainAll = this.__chain__,
        isHybrid = !!this.__actions__.length,
        isUnwrapped = retUnwrapped && !chainAll,
        onlyLazy = isLazy && !isHybrid;

    if (!retUnwrapped && useLazy) {
      value = onlyLazy ? value : new __WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */](this);
      var result = func.apply(value, args);
      result.__actions__.push({ 'func': __WEBPACK_IMPORTED_MODULE_33__thru_js__["a" /* default */], 'args': [interceptor], 'thisArg': undefined });
      return new __WEBPACK_IMPORTED_MODULE_12__LodashWrapper_js__["a" /* default */](result, chainAll);
    }
    if (isUnwrapped && onlyLazy) {
      return func.apply(this, args);
    }
    result = this.thru(interceptor);
    return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
  };
});

// Add `Array` methods to `lodash.prototype`.
Object(__WEBPACK_IMPORTED_MODULE_14__arrayEach_js__["a" /* default */])(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
  var func = arrayProto[methodName],
      chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
      retUnwrapped = /^(?:pop|shift)$/.test(methodName);

  __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype[methodName] = function() {
    var args = arguments;
    if (retUnwrapped && !this.__chain__) {
      var value = this.value();
      return func.apply(Object(__WEBPACK_IMPORTED_MODULE_23__isArray_js__["a" /* default */])(value) ? value : [], args);
    }
    return this[chainName](function(value) {
      return func.apply(Object(__WEBPACK_IMPORTED_MODULE_23__isArray_js__["a" /* default */])(value) ? value : [], args);
    });
  };
});

// Map minified method names to their real names.
Object(__WEBPACK_IMPORTED_MODULE_16__baseForOwn_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype, function(func, methodName) {
  var lodashFunc = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */][methodName];
  if (lodashFunc) {
    var key = lodashFunc.name + '';
    if (!hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_32__realNames_js__["a" /* default */], key)) {
      __WEBPACK_IMPORTED_MODULE_32__realNames_js__["a" /* default */][key] = [];
    }
    __WEBPACK_IMPORTED_MODULE_32__realNames_js__["a" /* default */][key].push({ 'name': methodName, 'func': lodashFunc });
  }
});

__WEBPACK_IMPORTED_MODULE_32__realNames_js__["a" /* default */][Object(__WEBPACK_IMPORTED_MODULE_21__createHybrid_js__["a" /* default */])(undefined, WRAP_BIND_KEY_FLAG).name] = [{
  'name': 'wrapper',
  'func': undefined
}];

// Add methods to `LazyWrapper`.
__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.clone = __WEBPACK_IMPORTED_MODULE_27__lazyClone_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.reverse = __WEBPACK_IMPORTED_MODULE_28__lazyReverse_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_11__LazyWrapper_js__["a" /* default */].prototype.value = __WEBPACK_IMPORTED_MODULE_29__lazyValue_js__["a" /* default */];

// Add chain sequence methods to the `lodash` wrapper.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.at = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].at;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.chain = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].wrapperChain;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.commit = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].commit;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.next = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].next;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.plant = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].plant;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.reverse = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].reverse;
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.toJSON = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.valueOf = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.value = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].value;

// Add lazy aliases.
__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.first = __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype.head;

if (symIterator) {
  __WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */].prototype[symIterator] = __WEBPACK_IMPORTED_MODULE_8__seq_js__["a" /* default */].toIterator;
}

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_35__wrapperLodash_js__["a" /* default */]);


/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_js__ = __webpack_require__(491);
/* unused harmony reexport chunk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compact_js__ = __webpack_require__(500);
/* unused harmony reexport compact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__concat_js__ = __webpack_require__(501);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__difference_js__ = __webpack_require__(521);
/* unused harmony reexport difference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__differenceBy_js__ = __webpack_require__(523);
/* unused harmony reexport differenceBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__differenceWith_js__ = __webpack_require__(524);
/* unused harmony reexport differenceWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__drop_js__ = __webpack_require__(526);
/* unused harmony reexport drop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropRight_js__ = __webpack_require__(527);
/* unused harmony reexport dropRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dropRightWhile_js__ = __webpack_require__(528);
/* unused harmony reexport dropRightWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropWhile_js__ = __webpack_require__(529);
/* unused harmony reexport dropWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fill_js__ = __webpack_require__(540);
/* unused harmony reexport fill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__findIndex_js__ = __webpack_require__(357);
/* unused harmony reexport findIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__findLastIndex_js__ = __webpack_require__(358);
/* unused harmony reexport findLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__first_js__ = __webpack_require__(546);
/* unused harmony reexport first */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flatten_js__ = __webpack_require__(327);
/* unused harmony reexport flatten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__flattenDeep_js__ = __webpack_require__(550);
/* unused harmony reexport flattenDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__flattenDepth_js__ = __webpack_require__(551);
/* unused harmony reexport flattenDepth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fromPairs_js__ = __webpack_require__(560);
/* unused harmony reexport fromPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__head_js__ = __webpack_require__(359);
/* unused harmony reexport head */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__indexOf_js__ = __webpack_require__(571);
/* unused harmony reexport indexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__initial_js__ = __webpack_require__(572);
/* unused harmony reexport initial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__intersection_js__ = __webpack_require__(573);
/* unused harmony reexport intersection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__intersectionBy_js__ = __webpack_require__(576);
/* unused harmony reexport intersectionBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__intersectionWith_js__ = __webpack_require__(577);
/* unused harmony reexport intersectionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__join_js__ = __webpack_require__(601);
/* unused harmony reexport join */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__last_js__ = __webpack_require__(63);
/* unused harmony reexport last */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lastIndexOf_js__ = __webpack_require__(604);
/* unused harmony reexport lastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__nth_js__ = __webpack_require__(625);
/* unused harmony reexport nth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pull_js__ = __webpack_require__(646);
/* unused harmony reexport pull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pullAll_js__ = __webpack_require__(371);
/* unused harmony reexport pullAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pullAllBy_js__ = __webpack_require__(648);
/* unused harmony reexport pullAllBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pullAllWith_js__ = __webpack_require__(649);
/* unused harmony reexport pullAllWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pullAt_js__ = __webpack_require__(650);
/* unused harmony reexport pullAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__remove_js__ = __webpack_require__(659);
/* unused harmony reexport remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reverse_js__ = __webpack_require__(372);
/* unused harmony reexport reverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__slice_js__ = __webpack_require__(671);
/* unused harmony reexport slice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sortedIndex_js__ = __webpack_require__(675);
/* unused harmony reexport sortedIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sortedIndexBy_js__ = __webpack_require__(677);
/* unused harmony reexport sortedIndexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sortedIndexOf_js__ = __webpack_require__(678);
/* unused harmony reexport sortedIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sortedLastIndex_js__ = __webpack_require__(679);
/* unused harmony reexport sortedLastIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__sortedLastIndexBy_js__ = __webpack_require__(680);
/* unused harmony reexport sortedLastIndexBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__sortedLastIndexOf_js__ = __webpack_require__(681);
/* unused harmony reexport sortedLastIndexOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__sortedUniq_js__ = __webpack_require__(682);
/* unused harmony reexport sortedUniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sortedUniqBy_js__ = __webpack_require__(683);
/* unused harmony reexport sortedUniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tail_js__ = __webpack_require__(694);
/* unused harmony reexport tail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__take_js__ = __webpack_require__(695);
/* unused harmony reexport take */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__takeRight_js__ = __webpack_require__(696);
/* unused harmony reexport takeRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__takeRightWhile_js__ = __webpack_require__(697);
/* unused harmony reexport takeRightWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__takeWhile_js__ = __webpack_require__(698);
/* unused harmony reexport takeWhile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__union_js__ = __webpack_require__(715);
/* unused harmony reexport union */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__unionBy_js__ = __webpack_require__(716);
/* unused harmony reexport unionBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__unionWith_js__ = __webpack_require__(717);
/* unused harmony reexport unionWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__uniq_js__ = __webpack_require__(718);
/* unused harmony reexport uniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__uniqBy_js__ = __webpack_require__(719);
/* unused harmony reexport uniqBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__uniqWith_js__ = __webpack_require__(720);
/* unused harmony reexport uniqWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__unzip_js__ = __webpack_require__(258);
/* unused harmony reexport unzip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__unzipWith_js__ = __webpack_require__(377);
/* unused harmony reexport unzipWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__without_js__ = __webpack_require__(728);
/* unused harmony reexport without */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__xor_js__ = __webpack_require__(733);
/* unused harmony reexport xor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__xorBy_js__ = __webpack_require__(735);
/* unused harmony reexport xorBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__xorWith_js__ = __webpack_require__(736);
/* unused harmony reexport xorWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__zip_js__ = __webpack_require__(737);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__zipObject_js__ = __webpack_require__(738);
/* unused harmony reexport zipObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__zipObjectDeep_js__ = __webpack_require__(739);
/* unused harmony reexport zipObjectDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__zipWith_js__ = __webpack_require__(740);
/* unused harmony reexport zipWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__array_default_js__ = __webpack_require__(1934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_65__array_default_js__["a"]; });




































































/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chunk_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compact_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__concat_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__difference_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__differenceBy_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__differenceWith_js__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__drop_js__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropRight_js__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dropRightWhile_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropWhile_js__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fill_js__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__findIndex_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__findLastIndex_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__first_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flatten_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__flattenDeep_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__flattenDepth_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fromPairs_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__head_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__indexOf_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__initial_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__intersection_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__intersectionBy_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__intersectionWith_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__join_js__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__last_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lastIndexOf_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__nth_js__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pull_js__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pullAll_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pullAllBy_js__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pullAllWith_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pullAt_js__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__remove_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reverse_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__slice_js__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__sortedIndex_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__sortedIndexBy_js__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sortedIndexOf_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sortedLastIndex_js__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__sortedLastIndexBy_js__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__sortedLastIndexOf_js__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__sortedUniq_js__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sortedUniqBy_js__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tail_js__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__take_js__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__takeRight_js__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__takeRightWhile_js__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__takeWhile_js__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__union_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__unionBy_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__unionWith_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__uniq_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__uniqBy_js__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__uniqWith_js__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__unzip_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__unzipWith_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__without_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__xor_js__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__xorBy_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__xorWith_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__zip_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__zipObject_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__zipObjectDeep_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__zipWith_js__ = __webpack_require__(740);


































































/* harmony default export */ __webpack_exports__["a"] = ({
  chunk: __WEBPACK_IMPORTED_MODULE_0__chunk_js__["a" /* default */], compact: __WEBPACK_IMPORTED_MODULE_1__compact_js__["a" /* default */], concat: __WEBPACK_IMPORTED_MODULE_2__concat_js__["a" /* default */], difference: __WEBPACK_IMPORTED_MODULE_3__difference_js__["a" /* default */], differenceBy: __WEBPACK_IMPORTED_MODULE_4__differenceBy_js__["a" /* default */],
  differenceWith: __WEBPACK_IMPORTED_MODULE_5__differenceWith_js__["a" /* default */], drop: __WEBPACK_IMPORTED_MODULE_6__drop_js__["a" /* default */], dropRight: __WEBPACK_IMPORTED_MODULE_7__dropRight_js__["a" /* default */], dropRightWhile: __WEBPACK_IMPORTED_MODULE_8__dropRightWhile_js__["a" /* default */], dropWhile: __WEBPACK_IMPORTED_MODULE_9__dropWhile_js__["a" /* default */],
  fill: __WEBPACK_IMPORTED_MODULE_10__fill_js__["a" /* default */], findIndex: __WEBPACK_IMPORTED_MODULE_11__findIndex_js__["a" /* default */], findLastIndex: __WEBPACK_IMPORTED_MODULE_12__findLastIndex_js__["a" /* default */], first: __WEBPACK_IMPORTED_MODULE_13__first_js__["a" /* default */], flatten: __WEBPACK_IMPORTED_MODULE_14__flatten_js__["a" /* default */],
  flattenDeep: __WEBPACK_IMPORTED_MODULE_15__flattenDeep_js__["a" /* default */], flattenDepth: __WEBPACK_IMPORTED_MODULE_16__flattenDepth_js__["a" /* default */], fromPairs: __WEBPACK_IMPORTED_MODULE_17__fromPairs_js__["a" /* default */], head: __WEBPACK_IMPORTED_MODULE_18__head_js__["a" /* default */], indexOf: __WEBPACK_IMPORTED_MODULE_19__indexOf_js__["a" /* default */],
  initial: __WEBPACK_IMPORTED_MODULE_20__initial_js__["a" /* default */], intersection: __WEBPACK_IMPORTED_MODULE_21__intersection_js__["a" /* default */], intersectionBy: __WEBPACK_IMPORTED_MODULE_22__intersectionBy_js__["a" /* default */], intersectionWith: __WEBPACK_IMPORTED_MODULE_23__intersectionWith_js__["a" /* default */], join: __WEBPACK_IMPORTED_MODULE_24__join_js__["a" /* default */],
  last: __WEBPACK_IMPORTED_MODULE_25__last_js__["a" /* default */], lastIndexOf: __WEBPACK_IMPORTED_MODULE_26__lastIndexOf_js__["a" /* default */], nth: __WEBPACK_IMPORTED_MODULE_27__nth_js__["a" /* default */], pull: __WEBPACK_IMPORTED_MODULE_28__pull_js__["a" /* default */], pullAll: __WEBPACK_IMPORTED_MODULE_29__pullAll_js__["a" /* default */],
  pullAllBy: __WEBPACK_IMPORTED_MODULE_30__pullAllBy_js__["a" /* default */], pullAllWith: __WEBPACK_IMPORTED_MODULE_31__pullAllWith_js__["a" /* default */], pullAt: __WEBPACK_IMPORTED_MODULE_32__pullAt_js__["a" /* default */], remove: __WEBPACK_IMPORTED_MODULE_33__remove_js__["a" /* default */], reverse: __WEBPACK_IMPORTED_MODULE_34__reverse_js__["a" /* default */],
  slice: __WEBPACK_IMPORTED_MODULE_35__slice_js__["a" /* default */], sortedIndex: __WEBPACK_IMPORTED_MODULE_36__sortedIndex_js__["a" /* default */], sortedIndexBy: __WEBPACK_IMPORTED_MODULE_37__sortedIndexBy_js__["a" /* default */], sortedIndexOf: __WEBPACK_IMPORTED_MODULE_38__sortedIndexOf_js__["a" /* default */], sortedLastIndex: __WEBPACK_IMPORTED_MODULE_39__sortedLastIndex_js__["a" /* default */],
  sortedLastIndexBy: __WEBPACK_IMPORTED_MODULE_40__sortedLastIndexBy_js__["a" /* default */], sortedLastIndexOf: __WEBPACK_IMPORTED_MODULE_41__sortedLastIndexOf_js__["a" /* default */], sortedUniq: __WEBPACK_IMPORTED_MODULE_42__sortedUniq_js__["a" /* default */], sortedUniqBy: __WEBPACK_IMPORTED_MODULE_43__sortedUniqBy_js__["a" /* default */], tail: __WEBPACK_IMPORTED_MODULE_44__tail_js__["a" /* default */],
  take: __WEBPACK_IMPORTED_MODULE_45__take_js__["a" /* default */], takeRight: __WEBPACK_IMPORTED_MODULE_46__takeRight_js__["a" /* default */], takeRightWhile: __WEBPACK_IMPORTED_MODULE_47__takeRightWhile_js__["a" /* default */], takeWhile: __WEBPACK_IMPORTED_MODULE_48__takeWhile_js__["a" /* default */], union: __WEBPACK_IMPORTED_MODULE_49__union_js__["a" /* default */],
  unionBy: __WEBPACK_IMPORTED_MODULE_50__unionBy_js__["a" /* default */], unionWith: __WEBPACK_IMPORTED_MODULE_51__unionWith_js__["a" /* default */], uniq: __WEBPACK_IMPORTED_MODULE_52__uniq_js__["a" /* default */], uniqBy: __WEBPACK_IMPORTED_MODULE_53__uniqBy_js__["a" /* default */], uniqWith: __WEBPACK_IMPORTED_MODULE_54__uniqWith_js__["a" /* default */],
  unzip: __WEBPACK_IMPORTED_MODULE_55__unzip_js__["a" /* default */], unzipWith: __WEBPACK_IMPORTED_MODULE_56__unzipWith_js__["a" /* default */], without: __WEBPACK_IMPORTED_MODULE_57__without_js__["a" /* default */], xor: __WEBPACK_IMPORTED_MODULE_58__xor_js__["a" /* default */], xorBy: __WEBPACK_IMPORTED_MODULE_59__xorBy_js__["a" /* default */],
  xorWith: __WEBPACK_IMPORTED_MODULE_60__xorWith_js__["a" /* default */], zip: __WEBPACK_IMPORTED_MODULE_61__zip_js__["a" /* default */], zipObject: __WEBPACK_IMPORTED_MODULE_62__zipObject_js__["a" /* default */], zipObjectDeep: __WEBPACK_IMPORTED_MODULE_63__zipObjectDeep_js__["a" /* default */], zipWith: __WEBPACK_IMPORTED_MODULE_64__zipWith_js__["a" /* default */]
});


/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countBy_js__ = __webpack_require__(510);
/* unused harmony reexport countBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(530);
/* unused harmony reexport each */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachRight_js__ = __webpack_require__(531);
/* unused harmony reexport eachRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__every_js__ = __webpack_require__(537);
/* unused harmony reexport every */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_js__ = __webpack_require__(541);
/* unused harmony reexport filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__find_js__ = __webpack_require__(542);
/* unused harmony reexport find */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findLast_js__ = __webpack_require__(544);
/* unused harmony reexport findLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flatMap_js__ = __webpack_require__(547);
/* unused harmony reexport flatMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flatMapDeep_js__ = __webpack_require__(548);
/* unused harmony reexport flatMapDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flatMapDepth_js__ = __webpack_require__(549);
/* unused harmony reexport flatMapDepth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forEach_js__ = __webpack_require__(351);
/* unused harmony reexport forEach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forEachRight_js__ = __webpack_require__(352);
/* unused harmony reexport forEachRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__groupBy_js__ = __webpack_require__(563);
/* unused harmony reexport groupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__includes_js__ = __webpack_require__(569);
/* unused harmony reexport includes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__invokeMap_js__ = __webpack_require__(581);
/* unused harmony reexport invokeMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__keyBy_js__ = __webpack_require__(603);
/* unused harmony reexport keyBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__map_js__ = __webpack_require__(209);
/* unused harmony reexport map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orderBy_js__ = __webpack_require__(631);
/* unused harmony reexport orderBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__partition_js__ = __webpack_require__(643);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reduce_js__ = __webpack_require__(656);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reduceRight_js__ = __webpack_require__(657);
/* unused harmony reexport reduceRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reject_js__ = __webpack_require__(658);
/* unused harmony reexport reject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sample_js__ = __webpack_require__(665);
/* unused harmony reexport sample */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sampleSize_js__ = __webpack_require__(666);
/* unused harmony reexport sampleSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shuffle_js__ = __webpack_require__(669);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__size_js__ = __webpack_require__(670);
/* unused harmony reexport size */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__some_js__ = __webpack_require__(673);
/* unused harmony reexport some */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sortBy_js__ = __webpack_require__(674);
/* unused harmony reexport sortBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__collection_default_js__ = __webpack_require__(1936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_28__collection_default_js__["a"]; });































/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__countBy_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachRight_js__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__every_js__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_js__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__find_js__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findLast_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flatMap_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flatMapDeep_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flatMapDepth_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forEach_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__forEachRight_js__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__groupBy_js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__includes_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__invokeMap_js__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__keyBy_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__map_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orderBy_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__partition_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reduce_js__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__reduceRight_js__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reject_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sample_js__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sampleSize_js__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shuffle_js__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__size_js__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__some_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sortBy_js__ = __webpack_require__(674);





























/* harmony default export */ __webpack_exports__["a"] = ({
  countBy: __WEBPACK_IMPORTED_MODULE_0__countBy_js__["a" /* default */], each: __WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */], eachRight: __WEBPACK_IMPORTED_MODULE_2__eachRight_js__["a" /* default */], every: __WEBPACK_IMPORTED_MODULE_3__every_js__["a" /* default */], filter: __WEBPACK_IMPORTED_MODULE_4__filter_js__["a" /* default */],
  find: __WEBPACK_IMPORTED_MODULE_5__find_js__["a" /* default */], findLast: __WEBPACK_IMPORTED_MODULE_6__findLast_js__["a" /* default */], flatMap: __WEBPACK_IMPORTED_MODULE_7__flatMap_js__["a" /* default */], flatMapDeep: __WEBPACK_IMPORTED_MODULE_8__flatMapDeep_js__["a" /* default */], flatMapDepth: __WEBPACK_IMPORTED_MODULE_9__flatMapDepth_js__["a" /* default */],
  forEach: __WEBPACK_IMPORTED_MODULE_10__forEach_js__["a" /* default */], forEachRight: __WEBPACK_IMPORTED_MODULE_11__forEachRight_js__["a" /* default */], groupBy: __WEBPACK_IMPORTED_MODULE_12__groupBy_js__["a" /* default */], includes: __WEBPACK_IMPORTED_MODULE_13__includes_js__["a" /* default */], invokeMap: __WEBPACK_IMPORTED_MODULE_14__invokeMap_js__["a" /* default */],
  keyBy: __WEBPACK_IMPORTED_MODULE_15__keyBy_js__["a" /* default */], map: __WEBPACK_IMPORTED_MODULE_16__map_js__["a" /* default */], orderBy: __WEBPACK_IMPORTED_MODULE_17__orderBy_js__["a" /* default */], partition: __WEBPACK_IMPORTED_MODULE_18__partition_js__["a" /* default */], reduce: __WEBPACK_IMPORTED_MODULE_19__reduce_js__["a" /* default */],
  reduceRight: __WEBPACK_IMPORTED_MODULE_20__reduceRight_js__["a" /* default */], reject: __WEBPACK_IMPORTED_MODULE_21__reject_js__["a" /* default */], sample: __WEBPACK_IMPORTED_MODULE_22__sample_js__["a" /* default */], sampleSize: __WEBPACK_IMPORTED_MODULE_23__sampleSize_js__["a" /* default */], shuffle: __WEBPACK_IMPORTED_MODULE_24__shuffle_js__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_25__size_js__["a" /* default */], some: __WEBPACK_IMPORTED_MODULE_26__some_js__["a" /* default */], sortBy: __WEBPACK_IMPORTED_MODULE_27__sortBy_js__["a" /* default */]
});


/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(347);
/* unused harmony reexport now */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_default_js__ = __webpack_require__(1938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__date_default_js__["a"]; });




/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(347);


/* harmony default export */ __webpack_exports__["a"] = ({
  now: __WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */]
});


/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__after_js__ = __webpack_require__(470);
/* unused harmony reexport after */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ary_js__ = __webpack_require__(316);
/* unused harmony reexport ary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__before_js__ = __webpack_require__(330);
/* unused harmony reexport before */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bind_js__ = __webpack_require__(331);
/* unused harmony reexport bind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bindKey_js__ = __webpack_require__(484);
/* unused harmony reexport bindKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__curry_js__ = __webpack_require__(513);
/* unused harmony reexport curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__curryRight_js__ = __webpack_require__(514);
/* unused harmony reexport curryRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__debounce_js__ = __webpack_require__(346);
/* unused harmony reexport debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defer_js__ = __webpack_require__(519);
/* unused harmony reexport defer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delay_js__ = __webpack_require__(520);
/* unused harmony reexport delay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flip_js__ = __webpack_require__(552);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__memoize_js__ = __webpack_require__(322);
/* unused harmony reexport memoize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__negate_js__ = __webpack_require__(211);
/* unused harmony reexport negate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__once_js__ = __webpack_require__(630);
/* unused harmony reexport once */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__overArgs_js__ = __webpack_require__(634);
/* unused harmony reexport overArgs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partial_js__ = __webpack_require__(369);
/* unused harmony reexport partial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__partialRight_js__ = __webpack_require__(642);
/* unused harmony reexport partialRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rearg_js__ = __webpack_require__(655);
/* unused harmony reexport rearg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rest_js__ = __webpack_require__(662);
/* unused harmony reexport rest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__spread_js__ = __webpack_require__(685);
/* unused harmony reexport spread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__throttle_js__ = __webpack_require__(701);
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__unary_js__ = __webpack_require__(713);
/* unused harmony reexport unary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wrap_js__ = __webpack_require__(729);
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__function_default_js__ = __webpack_require__(1940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__function_default_js__["a"]; });


























/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__after_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ary_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__before_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bind_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bindKey_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__curry_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__curryRight_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__debounce_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defer_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__delay_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flip_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__memoize_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__negate_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__once_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__overArgs_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partial_js__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__partialRight_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rearg_js__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rest_js__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__spread_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__throttle_js__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__unary_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__wrap_js__ = __webpack_require__(729);
























/* harmony default export */ __webpack_exports__["a"] = ({
  after: __WEBPACK_IMPORTED_MODULE_0__after_js__["a" /* default */], ary: __WEBPACK_IMPORTED_MODULE_1__ary_js__["a" /* default */], before: __WEBPACK_IMPORTED_MODULE_2__before_js__["a" /* default */], bind: __WEBPACK_IMPORTED_MODULE_3__bind_js__["a" /* default */], bindKey: __WEBPACK_IMPORTED_MODULE_4__bindKey_js__["a" /* default */],
  curry: __WEBPACK_IMPORTED_MODULE_5__curry_js__["a" /* default */], curryRight: __WEBPACK_IMPORTED_MODULE_6__curryRight_js__["a" /* default */], debounce: __WEBPACK_IMPORTED_MODULE_7__debounce_js__["a" /* default */], defer: __WEBPACK_IMPORTED_MODULE_8__defer_js__["a" /* default */], delay: __WEBPACK_IMPORTED_MODULE_9__delay_js__["a" /* default */],
  flip: __WEBPACK_IMPORTED_MODULE_10__flip_js__["a" /* default */], memoize: __WEBPACK_IMPORTED_MODULE_11__memoize_js__["a" /* default */], negate: __WEBPACK_IMPORTED_MODULE_12__negate_js__["a" /* default */], once: __WEBPACK_IMPORTED_MODULE_13__once_js__["a" /* default */], overArgs: __WEBPACK_IMPORTED_MODULE_14__overArgs_js__["a" /* default */],
  partial: __WEBPACK_IMPORTED_MODULE_15__partial_js__["a" /* default */], partialRight: __WEBPACK_IMPORTED_MODULE_16__partialRight_js__["a" /* default */], rearg: __WEBPACK_IMPORTED_MODULE_17__rearg_js__["a" /* default */], rest: __WEBPACK_IMPORTED_MODULE_18__rest_js__["a" /* default */], spread: __WEBPACK_IMPORTED_MODULE_19__spread_js__["a" /* default */],
  throttle: __WEBPACK_IMPORTED_MODULE_20__throttle_js__["a" /* default */], unary: __WEBPACK_IMPORTED_MODULE_21__unary_js__["a" /* default */], wrap: __WEBPACK_IMPORTED_MODULE_22__wrap_js__["a" /* default */]
});


/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castArray_js__ = __webpack_require__(488);
/* unused harmony reexport castArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_js__ = __webpack_require__(493);
/* unused harmony reexport clone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneDeep_js__ = __webpack_require__(497);
/* unused harmony reexport cloneDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneDeepWith_js__ = __webpack_require__(498);
/* unused harmony reexport cloneDeepWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneWith_js__ = __webpack_require__(499);
/* unused harmony reexport cloneWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conformsTo_js__ = __webpack_require__(509);
/* unused harmony reexport conformsTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eq_js__ = __webpack_require__(69);
/* unused harmony reexport eq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gt_js__ = __webpack_require__(564);
/* unused harmony reexport gt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gte_js__ = __webpack_require__(566);
/* unused harmony reexport gte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isArguments_js__ = __webpack_require__(142);
/* unused harmony reexport isArguments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isArray_js__ = __webpack_require__(14);
/* unused harmony reexport isArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isArrayBuffer_js__ = __webpack_require__(582);
/* unused harmony reexport isArrayBuffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isArrayLike_js__ = __webpack_require__(48);
/* unused harmony reexport isArrayLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayLikeObject_js__ = __webpack_require__(50);
/* unused harmony reexport isArrayLikeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isBoolean_js__ = __webpack_require__(583);
/* unused harmony reexport isBoolean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isBuffer_js__ = __webpack_require__(121);
/* unused harmony reexport isBuffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isDate_js__ = __webpack_require__(584);
/* unused harmony reexport isDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isElement_js__ = __webpack_require__(585);
/* unused harmony reexport isElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isEmpty_js__ = __webpack_require__(586);
/* unused harmony reexport isEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isEqual_js__ = __webpack_require__(587);
/* unused harmony reexport isEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isEqualWith_js__ = __webpack_require__(588);
/* unused harmony reexport isEqualWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isError_js__ = __webpack_require__(250);
/* unused harmony reexport isError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isFinite_js__ = __webpack_require__(589);
/* unused harmony reexport isFinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isFunction_js__ = __webpack_require__(94);
/* unused harmony reexport isFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isInteger_js__ = __webpack_require__(362);
/* unused harmony reexport isInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isLength_js__ = __webpack_require__(204);
/* unused harmony reexport isLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isMap_js__ = __webpack_require__(337);
/* unused harmony reexport isMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isMatch_js__ = __webpack_require__(590);
/* unused harmony reexport isMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isMatchWith_js__ = __webpack_require__(591);
/* unused harmony reexport isMatchWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isNaN_js__ = __webpack_require__(592);
/* unused harmony reexport isNaN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isNative_js__ = __webpack_require__(593);
/* unused harmony reexport isNative */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__isNil_js__ = __webpack_require__(594);
/* unused harmony reexport isNil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__isNull_js__ = __webpack_require__(595);
/* unused harmony reexport isNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__isNumber_js__ = __webpack_require__(363);
/* unused harmony reexport isNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__isObject_js__ = __webpack_require__(36);
/* unused harmony reexport isObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__isObjectLike_js__ = __webpack_require__(34);
/* unused harmony reexport isObjectLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__isPlainObject_js__ = __webpack_require__(123);
/* unused harmony reexport isPlainObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__isRegExp_js__ = __webpack_require__(256);
/* unused harmony reexport isRegExp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__isSafeInteger_js__ = __webpack_require__(596);
/* unused harmony reexport isSafeInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__isSet_js__ = __webpack_require__(338);
/* unused harmony reexport isSet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__isString_js__ = __webpack_require__(210);
/* unused harmony reexport isString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__isSymbol_js__ = __webpack_require__(68);
/* unused harmony reexport isSymbol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__isTypedArray_js__ = __webpack_require__(143);
/* unused harmony reexport isTypedArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__isUndefined_js__ = __webpack_require__(597);
/* unused harmony reexport isUndefined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__isWeakMap_js__ = __webpack_require__(598);
/* unused harmony reexport isWeakMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__isWeakSet_js__ = __webpack_require__(599);
/* unused harmony reexport isWeakSet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__lt_js__ = __webpack_require__(607);
/* unused harmony reexport lt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__lte_js__ = __webpack_require__(609);
/* unused harmony reexport lte */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__toArray_js__ = __webpack_require__(367);
/* unused harmony reexport toArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__toFinite_js__ = __webpack_require__(169);
/* unused harmony reexport toFinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__toInteger_js__ = __webpack_require__(16);
/* unused harmony reexport toInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__toLength_js__ = __webpack_require__(356);
/* unused harmony reexport toLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__toNumber_js__ = __webpack_require__(104);
/* unused harmony reexport toNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__toPlainObject_js__ = __webpack_require__(348);
/* unused harmony reexport toPlainObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__toSafeInteger_js__ = __webpack_require__(706);
/* unused harmony reexport toSafeInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__toString_js__ = __webpack_require__(25);
/* unused harmony reexport toString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__lang_default_js__ = __webpack_require__(1942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_56__lang_default_js__["a"]; });



























































/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castArray_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneDeep_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneDeepWith_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneWith_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conformsTo_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eq_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gt_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gte_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isArguments_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isArray_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isArrayBuffer_js__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isArrayLike_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayLikeObject_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isBoolean_js__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isBuffer_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isDate_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isElement_js__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isEmpty_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isEqual_js__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isEqualWith_js__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isError_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isFinite_js__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isFunction_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isInteger_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isLength_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isMap_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isMatch_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isMatchWith_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isNaN_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isNative_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__isNil_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__isNull_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__isNumber_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__isObject_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__isObjectLike_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__isPlainObject_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__isRegExp_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__isSafeInteger_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__isSet_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__isString_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__isSymbol_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__isTypedArray_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__isUndefined_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__isWeakMap_js__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__isWeakSet_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__lt_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__lte_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__toArray_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__toFinite_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__toInteger_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__toLength_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__toNumber_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__toPlainObject_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__toSafeInteger_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__toString_js__ = __webpack_require__(25);

























































/* harmony default export */ __webpack_exports__["a"] = ({
  castArray: __WEBPACK_IMPORTED_MODULE_0__castArray_js__["a" /* default */], clone: __WEBPACK_IMPORTED_MODULE_1__clone_js__["a" /* default */], cloneDeep: __WEBPACK_IMPORTED_MODULE_2__cloneDeep_js__["a" /* default */], cloneDeepWith: __WEBPACK_IMPORTED_MODULE_3__cloneDeepWith_js__["a" /* default */], cloneWith: __WEBPACK_IMPORTED_MODULE_4__cloneWith_js__["a" /* default */],
  conformsTo: __WEBPACK_IMPORTED_MODULE_5__conformsTo_js__["a" /* default */], eq: __WEBPACK_IMPORTED_MODULE_6__eq_js__["a" /* default */], gt: __WEBPACK_IMPORTED_MODULE_7__gt_js__["a" /* default */], gte: __WEBPACK_IMPORTED_MODULE_8__gte_js__["a" /* default */], isArguments: __WEBPACK_IMPORTED_MODULE_9__isArguments_js__["a" /* default */],
  isArray: __WEBPACK_IMPORTED_MODULE_10__isArray_js__["a" /* default */], isArrayBuffer: __WEBPACK_IMPORTED_MODULE_11__isArrayBuffer_js__["a" /* default */], isArrayLike: __WEBPACK_IMPORTED_MODULE_12__isArrayLike_js__["a" /* default */], isArrayLikeObject: __WEBPACK_IMPORTED_MODULE_13__isArrayLikeObject_js__["a" /* default */], isBoolean: __WEBPACK_IMPORTED_MODULE_14__isBoolean_js__["a" /* default */],
  isBuffer: __WEBPACK_IMPORTED_MODULE_15__isBuffer_js__["a" /* default */], isDate: __WEBPACK_IMPORTED_MODULE_16__isDate_js__["a" /* default */], isElement: __WEBPACK_IMPORTED_MODULE_17__isElement_js__["a" /* default */], isEmpty: __WEBPACK_IMPORTED_MODULE_18__isEmpty_js__["a" /* default */], isEqual: __WEBPACK_IMPORTED_MODULE_19__isEqual_js__["a" /* default */],
  isEqualWith: __WEBPACK_IMPORTED_MODULE_20__isEqualWith_js__["a" /* default */], isError: __WEBPACK_IMPORTED_MODULE_21__isError_js__["a" /* default */], isFinite: __WEBPACK_IMPORTED_MODULE_22__isFinite_js__["a" /* default */], isFunction: __WEBPACK_IMPORTED_MODULE_23__isFunction_js__["a" /* default */], isInteger: __WEBPACK_IMPORTED_MODULE_24__isInteger_js__["a" /* default */],
  isLength: __WEBPACK_IMPORTED_MODULE_25__isLength_js__["a" /* default */], isMap: __WEBPACK_IMPORTED_MODULE_26__isMap_js__["a" /* default */], isMatch: __WEBPACK_IMPORTED_MODULE_27__isMatch_js__["a" /* default */], isMatchWith: __WEBPACK_IMPORTED_MODULE_28__isMatchWith_js__["a" /* default */], isNaN: __WEBPACK_IMPORTED_MODULE_29__isNaN_js__["a" /* default */],
  isNative: __WEBPACK_IMPORTED_MODULE_30__isNative_js__["a" /* default */], isNil: __WEBPACK_IMPORTED_MODULE_31__isNil_js__["a" /* default */], isNull: __WEBPACK_IMPORTED_MODULE_32__isNull_js__["a" /* default */], isNumber: __WEBPACK_IMPORTED_MODULE_33__isNumber_js__["a" /* default */], isObject: __WEBPACK_IMPORTED_MODULE_34__isObject_js__["a" /* default */],
  isObjectLike: __WEBPACK_IMPORTED_MODULE_35__isObjectLike_js__["a" /* default */], isPlainObject: __WEBPACK_IMPORTED_MODULE_36__isPlainObject_js__["a" /* default */], isRegExp: __WEBPACK_IMPORTED_MODULE_37__isRegExp_js__["a" /* default */], isSafeInteger: __WEBPACK_IMPORTED_MODULE_38__isSafeInteger_js__["a" /* default */], isSet: __WEBPACK_IMPORTED_MODULE_39__isSet_js__["a" /* default */],
  isString: __WEBPACK_IMPORTED_MODULE_40__isString_js__["a" /* default */], isSymbol: __WEBPACK_IMPORTED_MODULE_41__isSymbol_js__["a" /* default */], isTypedArray: __WEBPACK_IMPORTED_MODULE_42__isTypedArray_js__["a" /* default */], isUndefined: __WEBPACK_IMPORTED_MODULE_43__isUndefined_js__["a" /* default */], isWeakMap: __WEBPACK_IMPORTED_MODULE_44__isWeakMap_js__["a" /* default */],
  isWeakSet: __WEBPACK_IMPORTED_MODULE_45__isWeakSet_js__["a" /* default */], lt: __WEBPACK_IMPORTED_MODULE_46__lt_js__["a" /* default */], lte: __WEBPACK_IMPORTED_MODULE_47__lte_js__["a" /* default */], toArray: __WEBPACK_IMPORTED_MODULE_48__toArray_js__["a" /* default */], toFinite: __WEBPACK_IMPORTED_MODULE_49__toFinite_js__["a" /* default */],
  toInteger: __WEBPACK_IMPORTED_MODULE_50__toInteger_js__["a" /* default */], toLength: __WEBPACK_IMPORTED_MODULE_51__toLength_js__["a" /* default */], toNumber: __WEBPACK_IMPORTED_MODULE_52__toNumber_js__["a" /* default */], toPlainObject: __WEBPACK_IMPORTED_MODULE_53__toPlainObject_js__["a" /* default */], toSafeInteger: __WEBPACK_IMPORTED_MODULE_54__toSafeInteger_js__["a" /* default */],
  toString: __WEBPACK_IMPORTED_MODULE_55__toString_js__["a" /* default */]
});


/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(469);
/* unused harmony reexport add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ceil_js__ = __webpack_require__(489);
/* unused harmony reexport ceil */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__divide_js__ = __webpack_require__(525);
/* unused harmony reexport divide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__floor_js__ = __webpack_require__(553);
/* unused harmony reexport floor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__max_js__ = __webpack_require__(614);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__maxBy_js__ = __webpack_require__(615);
/* unused harmony reexport maxBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mean_js__ = __webpack_require__(616);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__meanBy_js__ = __webpack_require__(618);
/* unused harmony reexport meanBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__min_js__ = __webpack_require__(622);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__minBy_js__ = __webpack_require__(623);
/* unused harmony reexport minBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multiply_js__ = __webpack_require__(624);
/* unused harmony reexport multiply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__round_js__ = __webpack_require__(664);
/* unused harmony reexport round */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__subtract_js__ = __webpack_require__(691);
/* unused harmony reexport subtract */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sum_js__ = __webpack_require__(692);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sumBy_js__ = __webpack_require__(693);
/* unused harmony reexport sumBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__math_default_js__ = __webpack_require__(1944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__math_default_js__["a"]; });


















/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ceil_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__divide_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__floor_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__max_js__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__maxBy_js__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mean_js__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__meanBy_js__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__min_js__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__minBy_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__multiply_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__round_js__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__subtract_js__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sum_js__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sumBy_js__ = __webpack_require__(693);
















/* harmony default export */ __webpack_exports__["a"] = ({
  add: __WEBPACK_IMPORTED_MODULE_0__add_js__["a" /* default */], ceil: __WEBPACK_IMPORTED_MODULE_1__ceil_js__["a" /* default */], divide: __WEBPACK_IMPORTED_MODULE_2__divide_js__["a" /* default */], floor: __WEBPACK_IMPORTED_MODULE_3__floor_js__["a" /* default */], max: __WEBPACK_IMPORTED_MODULE_4__max_js__["a" /* default */],
  maxBy: __WEBPACK_IMPORTED_MODULE_5__maxBy_js__["a" /* default */], mean: __WEBPACK_IMPORTED_MODULE_6__mean_js__["a" /* default */], meanBy: __WEBPACK_IMPORTED_MODULE_7__meanBy_js__["a" /* default */], min: __WEBPACK_IMPORTED_MODULE_8__min_js__["a" /* default */], minBy: __WEBPACK_IMPORTED_MODULE_9__minBy_js__["a" /* default */],
  multiply: __WEBPACK_IMPORTED_MODULE_10__multiply_js__["a" /* default */], round: __WEBPACK_IMPORTED_MODULE_11__round_js__["a" /* default */], subtract: __WEBPACK_IMPORTED_MODULE_12__subtract_js__["a" /* default */], sum: __WEBPACK_IMPORTED_MODULE_13__sum_js__["a" /* default */], sumBy: __WEBPACK_IMPORTED_MODULE_14__sumBy_js__["a" /* default */]
});


/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clamp_js__ = __webpack_require__(492);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inRange_js__ = __webpack_require__(568);
/* unused harmony reexport inRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__random_js__ = __webpack_require__(651);
/* unused harmony reexport random */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number_default_js__ = __webpack_require__(1946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__number_default_js__["a"]; });






/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clamp_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inRange_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__random_js__ = __webpack_require__(651);




/* harmony default export */ __webpack_exports__["a"] = ({
  clamp: __WEBPACK_IMPORTED_MODULE_0__clamp_js__["a" /* default */], inRange: __WEBPACK_IMPORTED_MODULE_1__inRange_js__["a" /* default */], random: __WEBPACK_IMPORTED_MODULE_2__random_js__["a" /* default */]
});


/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assign_js__ = __webpack_require__(474);
/* unused harmony reexport assign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignIn_js__ = __webpack_require__(321);
/* unused harmony reexport assignIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignInWith_js__ = __webpack_require__(248);
/* unused harmony reexport assignInWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assignWith_js__ = __webpack_require__(477);
/* unused harmony reexport assignWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__at_js__ = __webpack_require__(478);
/* unused harmony reexport at */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_js__ = __webpack_require__(512);
/* unused harmony reexport create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaults_js__ = __webpack_require__(516);
/* unused harmony reexport defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultsDeep_js__ = __webpack_require__(517);
/* unused harmony reexport defaultsDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entries_js__ = __webpack_require__(534);
/* unused harmony reexport entries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__entriesIn_js__ = __webpack_require__(535);
/* unused harmony reexport entriesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extend_js__ = __webpack_require__(538);
/* unused harmony reexport extend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__extendWith_js__ = __webpack_require__(539);
/* unused harmony reexport extendWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__findKey_js__ = __webpack_require__(543);
/* unused harmony reexport findKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__findLastKey_js__ = __webpack_require__(545);
/* unused harmony reexport findLastKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forIn_js__ = __webpack_require__(556);
/* unused harmony reexport forIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forInRight_js__ = __webpack_require__(557);
/* unused harmony reexport forInRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__forOwn_js__ = __webpack_require__(558);
/* unused harmony reexport forOwn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__forOwnRight_js__ = __webpack_require__(559);
/* unused harmony reexport forOwnRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__functions_js__ = __webpack_require__(561);
/* unused harmony reexport functions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__functionsIn_js__ = __webpack_require__(562);
/* unused harmony reexport functionsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__get_js__ = __webpack_require__(249);
/* unused harmony reexport get */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__has_js__ = __webpack_require__(567);
/* unused harmony reexport has */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hasIn_js__ = __webpack_require__(253);
/* unused harmony reexport hasIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__invert_js__ = __webpack_require__(578);
/* unused harmony reexport invert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__invertBy_js__ = __webpack_require__(579);
/* unused harmony reexport invertBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__invoke_js__ = __webpack_require__(580);
/* unused harmony reexport invoke */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__keys_js__ = __webpack_require__(41);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__keysIn_js__ = __webpack_require__(55);
/* unused harmony reexport keysIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mapKeys_js__ = __webpack_require__(610);
/* unused harmony reexport mapKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__mapValues_js__ = __webpack_require__(611);
/* unused harmony reexport mapValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__merge_js__ = __webpack_require__(619);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mergeWith_js__ = __webpack_require__(349);
/* unused harmony reexport mergeWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__omit_js__ = __webpack_require__(627);
/* unused harmony reexport omit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__omitBy_js__ = __webpack_require__(629);
/* unused harmony reexport omitBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pick_js__ = __webpack_require__(644);
/* unused harmony reexport pick */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pickBy_js__ = __webpack_require__(368);
/* unused harmony reexport pickBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__result_js__ = __webpack_require__(663);
/* unused harmony reexport result */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__set_js__ = __webpack_require__(667);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__setWith_js__ = __webpack_require__(668);
/* unused harmony reexport setWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__toPairs_js__ = __webpack_require__(353);
/* unused harmony reexport toPairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__toPairsIn_js__ = __webpack_require__(354);
/* unused harmony reexport toPairsIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__transform_js__ = __webpack_require__(708);
/* unused harmony reexport transform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__unset_js__ = __webpack_require__(722);
/* unused harmony reexport unset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__update_js__ = __webpack_require__(723);
/* unused harmony reexport update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__updateWith_js__ = __webpack_require__(724);
/* unused harmony reexport updateWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__values_js__ = __webpack_require__(151);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__valuesIn_js__ = __webpack_require__(727);
/* unused harmony reexport valuesIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__object_default_js__ = __webpack_require__(1948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_47__object_default_js__["a"]; });


















































/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assign_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignIn_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignInWith_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assignWith_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__at_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaults_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultsDeep_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entries_js__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__entriesIn_js__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extend_js__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__extendWith_js__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__findKey_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__findLastKey_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forIn_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forInRight_js__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__forOwn_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__forOwnRight_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__functions_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__functionsIn_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__get_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__has_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hasIn_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__invert_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__invertBy_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__invoke_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__keys_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__keysIn_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mapKeys_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__mapValues_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__merge_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__mergeWith_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__omit_js__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__omitBy_js__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pick_js__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pickBy_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__result_js__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__set_js__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__setWith_js__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__toPairs_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__toPairsIn_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__transform_js__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__unset_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__update_js__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__updateWith_js__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__values_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__valuesIn_js__ = __webpack_require__(727);
















































/* harmony default export */ __webpack_exports__["a"] = ({
  assign: __WEBPACK_IMPORTED_MODULE_0__assign_js__["a" /* default */], assignIn: __WEBPACK_IMPORTED_MODULE_1__assignIn_js__["a" /* default */], assignInWith: __WEBPACK_IMPORTED_MODULE_2__assignInWith_js__["a" /* default */], assignWith: __WEBPACK_IMPORTED_MODULE_3__assignWith_js__["a" /* default */], at: __WEBPACK_IMPORTED_MODULE_4__at_js__["a" /* default */],
  create: __WEBPACK_IMPORTED_MODULE_5__create_js__["a" /* default */], defaults: __WEBPACK_IMPORTED_MODULE_6__defaults_js__["a" /* default */], defaultsDeep: __WEBPACK_IMPORTED_MODULE_7__defaultsDeep_js__["a" /* default */], entries: __WEBPACK_IMPORTED_MODULE_8__entries_js__["a" /* default */], entriesIn: __WEBPACK_IMPORTED_MODULE_9__entriesIn_js__["a" /* default */],
  extend: __WEBPACK_IMPORTED_MODULE_10__extend_js__["a" /* default */], extendWith: __WEBPACK_IMPORTED_MODULE_11__extendWith_js__["a" /* default */], findKey: __WEBPACK_IMPORTED_MODULE_12__findKey_js__["a" /* default */], findLastKey: __WEBPACK_IMPORTED_MODULE_13__findLastKey_js__["a" /* default */], forIn: __WEBPACK_IMPORTED_MODULE_14__forIn_js__["a" /* default */],
  forInRight: __WEBPACK_IMPORTED_MODULE_15__forInRight_js__["a" /* default */], forOwn: __WEBPACK_IMPORTED_MODULE_16__forOwn_js__["a" /* default */], forOwnRight: __WEBPACK_IMPORTED_MODULE_17__forOwnRight_js__["a" /* default */], functions: __WEBPACK_IMPORTED_MODULE_18__functions_js__["a" /* default */], functionsIn: __WEBPACK_IMPORTED_MODULE_19__functionsIn_js__["a" /* default */],
  get: __WEBPACK_IMPORTED_MODULE_20__get_js__["a" /* default */], has: __WEBPACK_IMPORTED_MODULE_21__has_js__["a" /* default */], hasIn: __WEBPACK_IMPORTED_MODULE_22__hasIn_js__["a" /* default */], invert: __WEBPACK_IMPORTED_MODULE_23__invert_js__["a" /* default */], invertBy: __WEBPACK_IMPORTED_MODULE_24__invertBy_js__["a" /* default */],
  invoke: __WEBPACK_IMPORTED_MODULE_25__invoke_js__["a" /* default */], keys: __WEBPACK_IMPORTED_MODULE_26__keys_js__["a" /* default */], keysIn: __WEBPACK_IMPORTED_MODULE_27__keysIn_js__["a" /* default */], mapKeys: __WEBPACK_IMPORTED_MODULE_28__mapKeys_js__["a" /* default */], mapValues: __WEBPACK_IMPORTED_MODULE_29__mapValues_js__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_30__merge_js__["a" /* default */], mergeWith: __WEBPACK_IMPORTED_MODULE_31__mergeWith_js__["a" /* default */], omit: __WEBPACK_IMPORTED_MODULE_32__omit_js__["a" /* default */], omitBy: __WEBPACK_IMPORTED_MODULE_33__omitBy_js__["a" /* default */], pick: __WEBPACK_IMPORTED_MODULE_34__pick_js__["a" /* default */],
  pickBy: __WEBPACK_IMPORTED_MODULE_35__pickBy_js__["a" /* default */], result: __WEBPACK_IMPORTED_MODULE_36__result_js__["a" /* default */], set: __WEBPACK_IMPORTED_MODULE_37__set_js__["a" /* default */], setWith: __WEBPACK_IMPORTED_MODULE_38__setWith_js__["a" /* default */], toPairs: __WEBPACK_IMPORTED_MODULE_39__toPairs_js__["a" /* default */],
  toPairsIn: __WEBPACK_IMPORTED_MODULE_40__toPairsIn_js__["a" /* default */], transform: __WEBPACK_IMPORTED_MODULE_41__transform_js__["a" /* default */], unset: __WEBPACK_IMPORTED_MODULE_42__unset_js__["a" /* default */], update: __WEBPACK_IMPORTED_MODULE_43__update_js__["a" /* default */], updateWith: __WEBPACK_IMPORTED_MODULE_44__updateWith_js__["a" /* default */],
  values: __WEBPACK_IMPORTED_MODULE_45__values_js__["a" /* default */], valuesIn: __WEBPACK_IMPORTED_MODULE_46__valuesIn_js__["a" /* default */]
});


/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperAt_js__ = __webpack_require__(730);
/* unused harmony reexport at */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chain_js__ = __webpack_require__(335);
/* unused harmony reexport chain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commit_js__ = __webpack_require__(339);
/* unused harmony reexport commit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__ = __webpack_require__(171);
/* unused harmony reexport lodash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__next_js__ = __webpack_require__(366);
/* unused harmony reexport next */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plant_js__ = __webpack_require__(370);
/* unused harmony reexport plant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wrapperReverse_js__ = __webpack_require__(732);
/* unused harmony reexport reverse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tap_js__ = __webpack_require__(699);
/* unused harmony reexport tap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__thru_js__ = __webpack_require__(213);
/* unused harmony reexport thru */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toIterator_js__ = __webpack_require__(376);
/* unused harmony reexport toIterator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toJSON_js__ = __webpack_require__(703);
/* unused harmony reexport toJSON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wrapperValue_js__ = __webpack_require__(214);
/* unused harmony reexport value */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__valueOf_js__ = __webpack_require__(726);
/* unused harmony reexport valueOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wrapperChain_js__ = __webpack_require__(731);
/* unused harmony reexport wrapperChain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__seq_default_js__ = __webpack_require__(1950);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__seq_default_js__["a"]; });

















/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapperAt_js__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chain_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commit_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__next_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plant_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wrapperReverse_js__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tap_js__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__thru_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toIterator_js__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toJSON_js__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__wrapperValue_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__valueOf_js__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__wrapperChain_js__ = __webpack_require__(731);















/* harmony default export */ __webpack_exports__["a"] = ({
  at: __WEBPACK_IMPORTED_MODULE_0__wrapperAt_js__["a" /* default */], chain: __WEBPACK_IMPORTED_MODULE_1__chain_js__["a" /* default */], commit: __WEBPACK_IMPORTED_MODULE_2__commit_js__["a" /* default */], lodash: __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__["a" /* default */], next: __WEBPACK_IMPORTED_MODULE_4__next_js__["a" /* default */],
  plant: __WEBPACK_IMPORTED_MODULE_5__plant_js__["a" /* default */], reverse: __WEBPACK_IMPORTED_MODULE_6__wrapperReverse_js__["a" /* default */], tap: __WEBPACK_IMPORTED_MODULE_7__tap_js__["a" /* default */], thru: __WEBPACK_IMPORTED_MODULE_8__thru_js__["a" /* default */], toIterator: __WEBPACK_IMPORTED_MODULE_9__toIterator_js__["a" /* default */],
  toJSON: __WEBPACK_IMPORTED_MODULE_10__toJSON_js__["a" /* default */], value: __WEBPACK_IMPORTED_MODULE_11__wrapperValue_js__["a" /* default */], valueOf: __WEBPACK_IMPORTED_MODULE_12__valueOf_js__["a" /* default */], wrapperChain: __WEBPACK_IMPORTED_MODULE_13__wrapperChain_js__["a" /* default */]
});


/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase_js__ = __webpack_require__(485);
/* unused harmony reexport camelCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capitalize_js__ = __webpack_require__(332);
/* unused harmony reexport capitalize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deburr_js__ = __webpack_require__(333);
/* unused harmony reexport deburr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__endsWith_js__ = __webpack_require__(533);
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__escape_js__ = __webpack_require__(355);
/* unused harmony reexport escape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__escapeRegExp_js__ = __webpack_require__(536);
/* unused harmony reexport escapeRegExp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kebabCase_js__ = __webpack_require__(602);
/* unused harmony reexport kebabCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lowerCase_js__ = __webpack_require__(605);
/* unused harmony reexport lowerCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lowerFirst_js__ = __webpack_require__(606);
/* unused harmony reexport lowerFirst */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pad_js__ = __webpack_require__(637);
/* unused harmony reexport pad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__padEnd_js__ = __webpack_require__(639);
/* unused harmony reexport padEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__padStart_js__ = __webpack_require__(640);
/* unused harmony reexport padStart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parseInt_js__ = __webpack_require__(641);
/* unused harmony reexport parseInt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__repeat_js__ = __webpack_require__(660);
/* unused harmony reexport repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__replace_js__ = __webpack_require__(661);
/* unused harmony reexport replace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__snakeCase_js__ = __webpack_require__(672);
/* unused harmony reexport snakeCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__split_js__ = __webpack_require__(684);
/* unused harmony reexport split */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__startCase_js__ = __webpack_require__(686);
/* unused harmony reexport startCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__startsWith_js__ = __webpack_require__(687);
/* unused harmony reexport startsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__template_js__ = __webpack_require__(700);
/* unused harmony reexport template */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__templateSettings_js__ = __webpack_require__(375);
/* unused harmony reexport templateSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__toLower_js__ = __webpack_require__(704);
/* unused harmony reexport toLower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__toUpper_js__ = __webpack_require__(707);
/* unused harmony reexport toUpper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__trim_js__ = __webpack_require__(709);
/* unused harmony reexport trim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__trimEnd_js__ = __webpack_require__(710);
/* unused harmony reexport trimEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__trimStart_js__ = __webpack_require__(711);
/* unused harmony reexport trimStart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__truncate_js__ = __webpack_require__(712);
/* unused harmony reexport truncate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__unescape_js__ = __webpack_require__(714);
/* unused harmony reexport unescape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__upperCase_js__ = __webpack_require__(725);
/* unused harmony reexport upperCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__upperFirst_js__ = __webpack_require__(251);
/* unused harmony reexport upperFirst */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__words_js__ = __webpack_require__(334);
/* unused harmony reexport words */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__string_default_js__ = __webpack_require__(1952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_31__string_default_js__["a"]; });


































/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__capitalize_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deburr_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__endsWith_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__escape_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__escapeRegExp_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kebabCase_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lowerCase_js__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lowerFirst_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pad_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__padEnd_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__padStart_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parseInt_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__repeat_js__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__replace_js__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__snakeCase_js__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__split_js__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__startCase_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__startsWith_js__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__template_js__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__templateSettings_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__toLower_js__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__toUpper_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__trim_js__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__trimEnd_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__trimStart_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__truncate_js__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__unescape_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__upperCase_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__upperFirst_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__words_js__ = __webpack_require__(334);
































/* harmony default export */ __webpack_exports__["a"] = ({
  camelCase: __WEBPACK_IMPORTED_MODULE_0__camelCase_js__["a" /* default */], capitalize: __WEBPACK_IMPORTED_MODULE_1__capitalize_js__["a" /* default */], deburr: __WEBPACK_IMPORTED_MODULE_2__deburr_js__["a" /* default */], endsWith: __WEBPACK_IMPORTED_MODULE_3__endsWith_js__["a" /* default */], escape: __WEBPACK_IMPORTED_MODULE_4__escape_js__["a" /* default */],
  escapeRegExp: __WEBPACK_IMPORTED_MODULE_5__escapeRegExp_js__["a" /* default */], kebabCase: __WEBPACK_IMPORTED_MODULE_6__kebabCase_js__["a" /* default */], lowerCase: __WEBPACK_IMPORTED_MODULE_7__lowerCase_js__["a" /* default */], lowerFirst: __WEBPACK_IMPORTED_MODULE_8__lowerFirst_js__["a" /* default */], pad: __WEBPACK_IMPORTED_MODULE_9__pad_js__["a" /* default */],
  padEnd: __WEBPACK_IMPORTED_MODULE_10__padEnd_js__["a" /* default */], padStart: __WEBPACK_IMPORTED_MODULE_11__padStart_js__["a" /* default */], parseInt: __WEBPACK_IMPORTED_MODULE_12__parseInt_js__["a" /* default */], repeat: __WEBPACK_IMPORTED_MODULE_13__repeat_js__["a" /* default */], replace: __WEBPACK_IMPORTED_MODULE_14__replace_js__["a" /* default */],
  snakeCase: __WEBPACK_IMPORTED_MODULE_15__snakeCase_js__["a" /* default */], split: __WEBPACK_IMPORTED_MODULE_16__split_js__["a" /* default */], startCase: __WEBPACK_IMPORTED_MODULE_17__startCase_js__["a" /* default */], startsWith: __WEBPACK_IMPORTED_MODULE_18__startsWith_js__["a" /* default */], template: __WEBPACK_IMPORTED_MODULE_19__template_js__["a" /* default */],
  templateSettings: __WEBPACK_IMPORTED_MODULE_20__templateSettings_js__["a" /* default */], toLower: __WEBPACK_IMPORTED_MODULE_21__toLower_js__["a" /* default */], toUpper: __WEBPACK_IMPORTED_MODULE_22__toUpper_js__["a" /* default */], trim: __WEBPACK_IMPORTED_MODULE_23__trim_js__["a" /* default */], trimEnd: __WEBPACK_IMPORTED_MODULE_24__trimEnd_js__["a" /* default */],
  trimStart: __WEBPACK_IMPORTED_MODULE_25__trimStart_js__["a" /* default */], truncate: __WEBPACK_IMPORTED_MODULE_26__truncate_js__["a" /* default */], unescape: __WEBPACK_IMPORTED_MODULE_27__unescape_js__["a" /* default */], upperCase: __WEBPACK_IMPORTED_MODULE_28__upperCase_js__["a" /* default */], upperFirst: __WEBPACK_IMPORTED_MODULE_29__upperFirst_js__["a" /* default */],
  words: __WEBPACK_IMPORTED_MODULE_30__words_js__["a" /* default */]
});


/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attempt_js__ = __webpack_require__(328);
/* unused harmony reexport attempt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bindAll_js__ = __webpack_require__(483);
/* unused harmony reexport bindAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cond_js__ = __webpack_require__(502);
/* unused harmony reexport cond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conforms_js__ = __webpack_require__(508);
/* unused harmony reexport conforms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant_js__ = __webpack_require__(244);
/* unused harmony reexport constant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultTo_js__ = __webpack_require__(515);
/* unused harmony reexport defaultTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flow_js__ = __webpack_require__(554);
/* unused harmony reexport flow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowRight_js__ = __webpack_require__(555);
/* unused harmony reexport flowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__identity_js__ = __webpack_require__(47);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__iteratee_js__ = __webpack_require__(600);
/* unused harmony reexport iteratee */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__matches_js__ = __webpack_require__(612);
/* unused harmony reexport matches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchesProperty_js__ = __webpack_require__(613);
/* unused harmony reexport matchesProperty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__method_js__ = __webpack_require__(620);
/* unused harmony reexport method */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__methodOf_js__ = __webpack_require__(621);
/* unused harmony reexport methodOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixin_js__ = __webpack_require__(365);
/* unused harmony reexport mixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__noop_js__ = __webpack_require__(243);
/* unused harmony reexport noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__nthArg_js__ = __webpack_require__(626);
/* unused harmony reexport nthArg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__over_js__ = __webpack_require__(632);
/* unused harmony reexport over */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__overEvery_js__ = __webpack_require__(635);
/* unused harmony reexport overEvery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__overSome_js__ = __webpack_require__(636);
/* unused harmony reexport overSome */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__property_js__ = __webpack_require__(344);
/* unused harmony reexport property */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__propertyOf_js__ = __webpack_require__(645);
/* unused harmony reexport propertyOf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__range_js__ = __webpack_require__(653);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rangeRight_js__ = __webpack_require__(654);
/* unused harmony reexport rangeRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__stubArray_js__ = __webpack_require__(252);
/* unused harmony reexport stubArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__stubFalse_js__ = __webpack_require__(247);
/* unused harmony reexport stubFalse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__stubObject_js__ = __webpack_require__(688);
/* unused harmony reexport stubObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__stubString_js__ = __webpack_require__(689);
/* unused harmony reexport stubString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__stubTrue_js__ = __webpack_require__(690);
/* unused harmony reexport stubTrue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__times_js__ = __webpack_require__(702);
/* unused harmony reexport times */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__toPath_js__ = __webpack_require__(705);
/* unused harmony reexport toPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__uniqueId_js__ = __webpack_require__(721);
/* unused harmony reexport uniqueId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__util_default_js__ = __webpack_require__(1954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_32__util_default_js__["a"]; });



































/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attempt_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bindAll_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cond_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conforms_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultTo_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flow_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowRight_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__identity_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__iteratee_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__matches_js__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchesProperty_js__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__method_js__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__methodOf_js__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixin_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__noop_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__nthArg_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__over_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__overEvery_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__overSome_js__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__property_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__propertyOf_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__range_js__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rangeRight_js__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__stubArray_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__stubFalse_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__stubObject_js__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__stubString_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__stubTrue_js__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__times_js__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__toPath_js__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__uniqueId_js__ = __webpack_require__(721);

































/* harmony default export */ __webpack_exports__["a"] = ({
  attempt: __WEBPACK_IMPORTED_MODULE_0__attempt_js__["a" /* default */], bindAll: __WEBPACK_IMPORTED_MODULE_1__bindAll_js__["a" /* default */], cond: __WEBPACK_IMPORTED_MODULE_2__cond_js__["a" /* default */], conforms: __WEBPACK_IMPORTED_MODULE_3__conforms_js__["a" /* default */], constant: __WEBPACK_IMPORTED_MODULE_4__constant_js__["a" /* default */],
  defaultTo: __WEBPACK_IMPORTED_MODULE_5__defaultTo_js__["a" /* default */], flow: __WEBPACK_IMPORTED_MODULE_6__flow_js__["a" /* default */], flowRight: __WEBPACK_IMPORTED_MODULE_7__flowRight_js__["a" /* default */], identity: __WEBPACK_IMPORTED_MODULE_8__identity_js__["a" /* default */], iteratee: __WEBPACK_IMPORTED_MODULE_9__iteratee_js__["a" /* default */],
  matches: __WEBPACK_IMPORTED_MODULE_10__matches_js__["a" /* default */], matchesProperty: __WEBPACK_IMPORTED_MODULE_11__matchesProperty_js__["a" /* default */], method: __WEBPACK_IMPORTED_MODULE_12__method_js__["a" /* default */], methodOf: __WEBPACK_IMPORTED_MODULE_13__methodOf_js__["a" /* default */], mixin: __WEBPACK_IMPORTED_MODULE_14__mixin_js__["a" /* default */],
  noop: __WEBPACK_IMPORTED_MODULE_15__noop_js__["a" /* default */], nthArg: __WEBPACK_IMPORTED_MODULE_16__nthArg_js__["a" /* default */], over: __WEBPACK_IMPORTED_MODULE_17__over_js__["a" /* default */], overEvery: __WEBPACK_IMPORTED_MODULE_18__overEvery_js__["a" /* default */], overSome: __WEBPACK_IMPORTED_MODULE_19__overSome_js__["a" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_20__property_js__["a" /* default */], propertyOf: __WEBPACK_IMPORTED_MODULE_21__propertyOf_js__["a" /* default */], range: __WEBPACK_IMPORTED_MODULE_22__range_js__["a" /* default */], rangeRight: __WEBPACK_IMPORTED_MODULE_23__rangeRight_js__["a" /* default */], stubArray: __WEBPACK_IMPORTED_MODULE_24__stubArray_js__["a" /* default */],
  stubFalse: __WEBPACK_IMPORTED_MODULE_25__stubFalse_js__["a" /* default */], stubObject: __WEBPACK_IMPORTED_MODULE_26__stubObject_js__["a" /* default */], stubString: __WEBPACK_IMPORTED_MODULE_27__stubString_js__["a" /* default */], stubTrue: __WEBPACK_IMPORTED_MODULE_28__stubTrue_js__["a" /* default */], times: __WEBPACK_IMPORTED_MODULE_29__times_js__["a" /* default */],
  toPath: __WEBPACK_IMPORTED_MODULE_30__toPath_js__["a" /* default */], uniqueId: __WEBPACK_IMPORTED_MODULE_31__uniqueId_js__["a" /* default */]
});


/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(83);



/**
 * Creates a clone of the lazy wrapper object.
 *
 * @private
 * @name clone
 * @memberOf LazyWrapper
 * @returns {Object} Returns the cloned `LazyWrapper` object.
 */
function lazyClone() {
  var result = new __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */](this.__wrapped__);
  result.__actions__ = Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(this.__actions__);
  result.__dir__ = this.__dir__;
  result.__filtered__ = this.__filtered__;
  result.__iteratees__ = Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(this.__iteratees__);
  result.__takeCount__ = this.__takeCount__;
  result.__views__ = Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(this.__views__);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (lazyClone);


/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(118);


/**
 * Reverses the direction of lazy iteration.
 *
 * @private
 * @name reverse
 * @memberOf LazyWrapper
 * @returns {Object} Returns the new reversed `LazyWrapper` object.
 */
function lazyReverse() {
  if (this.__filtered__) {
    var result = new __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */](this);
    result.__dir__ = -1;
    result.__filtered__ = true;
  } else {
    result = this.clone();
    result.__dir__ *= -1;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (lazyReverse);


/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseWrapperValue_js__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getView_js__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(14);




/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
    LAZY_MAP_FLAG = 2;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Extracts the unwrapped value from its lazy wrapper.
 *
 * @private
 * @name value
 * @memberOf LazyWrapper
 * @returns {*} Returns the unwrapped value.
 */
function lazyValue() {
  var array = this.__wrapped__.value(),
      dir = this.__dir__,
      isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(array),
      isRight = dir < 0,
      arrLength = isArr ? array.length : 0,
      view = Object(__WEBPACK_IMPORTED_MODULE_1__getView_js__["a" /* default */])(0, arrLength, this.__views__),
      start = view.start,
      end = view.end,
      length = end - start,
      index = isRight ? end : (start - 1),
      iteratees = this.__iteratees__,
      iterLength = iteratees.length,
      resIndex = 0,
      takeCount = nativeMin(length, this.__takeCount__);

  if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseWrapperValue_js__["a" /* default */])(array, this.__actions__);
  }
  var result = [];

  outer:
  while (length-- && resIndex < takeCount) {
    index += dir;

    var iterIndex = -1,
        value = array[index];

    while (++iterIndex < iterLength) {
      var data = iteratees[iterIndex],
          iteratee = data.iteratee,
          type = data.type,
          computed = iteratee(value);

      if (type == LAZY_MAP_FLAG) {
        value = computed;
      } else if (!computed) {
        if (type == LAZY_FILTER_FLAG) {
          continue outer;
        } else {
          break outer;
        }
      }
    }
    result[resIndex++] = value;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (lazyValue);


/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the view, applying any `transforms` to the `start` and `end` positions.
 *
 * @private
 * @param {number} start The start of the view.
 * @param {number} end The end of the view.
 * @param {Array} transforms The transformations to apply to the view.
 * @returns {Object} Returns an object containing the `start` and `end`
 *  positions of the view.
 */
function getView(start, end, transforms) {
  var index = -1,
      length = transforms.length;

  while (++index < length) {
    var data = transforms[index],
        size = data.size;

    switch (data.type) {
      case 'drop':      start += size; break;
      case 'dropRight': end -= size; break;
      case 'take':      end = nativeMin(end, start + size); break;
      case 'takeRight': start = nativeMax(start, end - size); break;
    }
  }
  return { 'start': start, 'end': end };
}

/* harmony default export */ __webpack_exports__["a"] = (getView);


/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GroupedInline__ = __webpack_require__(1960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GroupedInline__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Input__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(242);






var enhance = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["defaultProps"])({
    items: [],
    isMultiple: false,
    selectedText: " selected",
    emptyPlaceholder: 'No items found'
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])("searchString", "setSearchString", ""), 
// modify items prop by searchString
Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    activeItem: Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["b" /* find */])(props.items, { value: props.value }),
    items: props.items.filter(function (item) {
        return (typeof item.label === "string" &&
            (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["e" /* includes */])(item.label.toLocaleLowerCase(), props.searchString.toLocaleLowerCase()) || Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["e" /* includes */])((item.group || '').toLocaleLowerCase(), props.searchString.toLocaleLowerCase())));
    })
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    groups: props.groups || Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["g" /* uniq */])(props.items.map(function (item) { return item.group; })) || []
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withState"])("activeGroup", "setActiveGroup", function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["c" /* get */])(props.activeItem, "group", props.groups[0]);
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withProps"])(function (props) { return ({
    groupedItems: props.items.filter(function (item) {
        return item.group === props.activeGroup;
    }),
}); }), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["withHandlers"])({
    onItemClick: function (props) { return function (_a) {
        var value = _a.value;
        return function () {
            if (props.isMultiple) {
                props.onChange(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["g" /* uniq */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["a" /* compact */])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["i" /* xor */])(props.value, [value]))));
            }
            else {
                props.onChange(value);
            }
        };
    }; }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["setDisplayName"])("GroupedInline"));
var GroupedInline = enhance(function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-grouped-inline__wrap" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-grouped-inline__search" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Input__["a" /* default */], { value: props.searchString, onChange: function (e) { return props.setSearchString(e.target.value); }, stretched: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* default */], null, "s"))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: props.groupsItemsStyle, className: "sui-grouped-inline__groups-items" },
            props.groups.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__groups", style: props.groupsStyle }, props.groups.map(function (group) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: (props.activeItem &&
                        props.activeItem.value) + "_" + group, onClick: function () {
                        props.setActiveGroup(group);
                    }, className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-advanced-select__item", {
                        "sui-advanced-select__item--active": props.activeGroup === group
                    }) }, group)); })),
            props.groupedItems.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sui-advanced-select__items" }, props.groupedItems.map(function (item) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: (props.activeItem && props.activeItem.value) + "_" + item.value, onClick: props.onItemClick({
                        value: item.value
                    }), className: __WEBPACK_IMPORTED_MODULE_1_classnames__("sui-advanced-select__item", {
                        "sui-advanced-select__item--active": props.value === item.value ||
                            (Array.isArray(props.value) &&
                                Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["e" /* includes */])(props.value, item.value))
                    }) }, item.label)); })),
            props.groups.length == 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: 'sui-advanced-select__empty' }, props.emptyPlaceholder))));
});
/* harmony default export */ __webpack_exports__["a"] = (GroupedInline);
//# sourceMappingURL=GroupedInline.js.map

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withFetcher__ = __webpack_require__(1962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withFetcher__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es__ = __webpack_require__(468);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


// Handle all backend APIs
function withFetcher(name, fetch, _a) {
    var _b = (_a === void 0 ? {} : _a).fetchOnMount, fetchOnMount = _b === void 0 ? false : _b;
    var _c, _d, _e;
    return Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withStateHandlers"])((_c = {},
        _c[name + "Fetcher"] = {
            data: null,
            loading: false,
            error: null
        },
        _c), (_d = {},
        _d["receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Data"] = function () { return function (data) {
            var _a;
            return (_a = {},
                _a[name + "Fetcher"] = {
                    data: data,
                    loading: false,
                    error: null
                },
                _a);
        }; },
        _d["receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Error"] = function (_a) {
            var _b = name + "Fetcher", data = _a[_b].data;
            return function (error) {
                var _a;
                return (_a = {},
                    _a[name + "Fetcher"] = {
                        data: data,
                        loading: false,
                        error: error || true
                    },
                    _a);
            };
        },
        _d["start" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Fetch"] = function (_a) {
            var _b = name + "Fetcher", prevState = _a[_b];
            return function () {
                var _a;
                return (_a = {},
                    _a[name + "Fetcher"] = __assign({}, prevState, { loading: true }),
                    _a);
            };
        },
        _d)), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["withHandlers"])((_e = {},
        _e["fetch" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name)] = function (props) { return function () {
            props["start" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Fetch"]();
            fetch(props).then(props["receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Data"], props["receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Error"]);
        }; },
        _e)), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["mapProps"])(function (props) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["f" /* omit */])(props, [
            "receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Data",
            "receive" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Error",
            "start" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name) + "Fetch"
        ]);
    }), fetchOnMount
        ? Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["lifecycle"])({
            componentDidMount: function () {
                this.props["fetch" + Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es__["h" /* upperFirst */])(name)]();
            }
        })
        : __WEBPACK_IMPORTED_MODULE_1_lodash_es__["d" /* identity */]);
}
/* harmony default export */ __webpack_exports__["a"] = (withFetcher);
//# sourceMappingURL=withFetcher.js.map

/***/ }),
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-banner-container sma-js-cookie-banner\">");t.b("\n" + i);t.b("	<i class=\"nc-icon-mini ui-2_alert-circle-i\"></i>");t.b("\n" + i);t.b("	<span id=\"sma-cookie-banner-title\">");t.b(t.t(t.d("strings.title",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("	<button id=\"sma-btn-reject-cookies\" type=\"button\" class=\"btn btn-hollow-white sma-js-cookie-reject mr-2\">");t.b(t.v(t.d("strings.no",c,p,0)));t.b("</buton>");t.b("\n" + i);t.b("	<button id=\"sma-btn-accept-cookies\" type=\"button\" class=\"btn btn-hollow-white-primary sma-js-cookie-accept\">");t.b(t.v(t.d("strings.accept",c,p,0)));t.b("</buton>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-banner-container sma-js-cookie-banner\">\n\t<i class=\"nc-icon-mini ui-2_alert-circle-i\"></i>\n\t<span id=\"sma-cookie-banner-title\">{{{strings.title}}}</span>\n\t<button id=\"sma-btn-reject-cookies\" type=\"button\" class=\"btn btn-hollow-white sma-js-cookie-reject mr-2\">{{strings.no}}</buton>\n\t<button id=\"sma-btn-accept-cookies\" type=\"button\" class=\"btn btn-hollow-white-primary sma-js-cookie-accept\">{{strings.accept}}</buton>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("\" class=\"sma-file-viewer-container\">");t.b("\n" + i);t.b("    <div class=\"sma-file-viewer-shade\"></div>");t.b("\n" + i);t.b("    <div class=\"sma-file-viewer\">");t.b("\n" + i);t.b("        <div class=\"container px-0\">");t.b("\n" + i);t.b("            <div class=\"row\">");t.b("\n" + i);t.b("                <div class=\"col-12\">");t.b("\n" + i);t.b("                    <div class=\"sma-file-viewer-bar\"></div>");t.b("\n" + i);t.b("                    <button class=\"btn btn-icononly sma-file-viewer-close\"><i class=\"nc-icon-mini ui-1_simple-remove\"></i></button>");t.b("\n" + i);t.b("                    <div class=\"sma-file-viewer-content\"></div>");t.b("\n" + i);t.b("                </div>");t.b("\n" + i);t.b("            </div>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"{{id}}\" class=\"sma-file-viewer-container\">\n    <div class=\"sma-file-viewer-shade\"></div>\n    <div class=\"sma-file-viewer\">\n        <div class=\"container px-0\">\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <div class=\"sma-file-viewer-bar\"></div>\n                    <button class=\"btn btn-icononly sma-file-viewer-close\"><i class=\"nc-icon-mini ui-1_simple-remove\"></i></button>\n                    <div class=\"sma-file-viewer-content\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-file-viewer-bar-left\">");t.b("\n" + i);t.b("    <div class=\"d-flex align-items-center\">");t.b("\n" + i);t.b("        <i class=\"mr-3 nc-icon-glyph ");t.b(t.v(t.d("file.icon",c,p,0)));t.b("\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("        <div>");t.b(t.v(t.d("file.name",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);if(t.s(t.f("enableDownload",c,p,1),c,p,0,226,327,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a href=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\" class=\"btn btn-default btn-sm\" download>");t.b(t.v(t.d("strings.download",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}t.b("</div>	");t.b("\n" + i);t.b("<div class=\"sma-file-viewer-bar-right\">");t.b("\n" + i);t.b("    <div>");t.b(t.v(t.f("index",c,p,0)));t.b("/");t.b(t.v(t.f("numFiles",c,p,0)));t.b(" ");t.b(t.v(t.d("strings.files",c,p,0)));t.b("</div>");t.b("\n" + i);t.b("    ");t.b("\n" + i);t.b("    <button ");if(t.s(t.f("disableNavButtons",c,p,1),c,p,0,490,498,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("disabled");});c.pop();}t.b(" class=\"ml-3 btn btn-crammed sma-file-viewer-previous-file\">");t.b("\n" + i);t.b("        <i class=\"nc-icon-mini arrows-1_minimal-left\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("    </button>");t.b("\n" + i);t.b("    <button ");if(t.s(t.f("disableNavButtons",c,p,1),c,p,0,707,715,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("disabled");});c.pop();}t.b(" class=\"btn btn-crammed sma-file-viewer-next-file\">");t.b("\n" + i);t.b("        <i class=\"nc-icon-mini arrows-1_minimal-right\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("    </button>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-file-viewer-bar-left\">\n    <div class=\"d-flex align-items-center\">\n        <i class=\"mr-3 nc-icon-glyph {{file.icon}}\" aria-hidden=\"true\"></i>\n        <div>{{file.name}}</div>\n    </div>\n    {{#enableDownload}}\n        <a href=\"{{file.url}}\" class=\"btn btn-default btn-sm\" download>{{strings.download}}</a>\n    {{/enableDownload}}\n</div>\t\n<div class=\"sma-file-viewer-bar-right\">\n    <div>{{index}}/{{numFiles}} {{strings.files}}</div>\n    \n    <button {{#disableNavButtons}}disabled{{/disableNavButtons}} class=\"ml-3 btn btn-crammed sma-file-viewer-previous-file\">\n        <i class=\"nc-icon-mini arrows-1_minimal-left\" aria-hidden=\"true\"></i>\n    </button>\n    <button {{#disableNavButtons}}disabled{{/disableNavButtons}} class=\"btn btn-crammed sma-file-viewer-next-file\">\n        <i class=\"nc-icon-mini arrows-1_minimal-right\" aria-hidden=\"true\"></i>\n    </button>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<iframe");t.b("\n" + i);t.b("    src=\"");t.b(t.v(t.d("file.src",c,p,0)));t.b("\"");t.b("\n" + i);t.b("    width=\"100%\"");t.b("\n" + i);t.b("    style=\"border: none;\" />");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<iframe\n    src=\"{{file.src}}\"\n    width=\"100%\"\n    style=\"border: none;\" />\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<img class=\"sma-file-viewer-media\" src=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\">");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<img class=\"sma-file-viewer-media\" src=\"{{file.url}}\">\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<video controls");t.b("\n" + i);t.b("    src=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\"");t.b("\n" + i);t.b("    class=\"sma-file-viewer-media\">");t.b("\n" + i);t.b("</video>");return t.fl(); },partials: {}, subs: {  }}, "<video controls\n    src=\"{{file.url}}\"\n    class=\"sma-file-viewer-media\">\n</video>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<audio class=\"sma-file-viewer-media\" controls src=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\"></audio>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<audio class=\"sma-file-viewer-media\" controls src=\"{{file.url}}\"></audio>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-file-viewer-linked-video-inner-wrap\">");t.b("\n" + i);t.b("    <iframe class=\"sma-linked-video-iframe\" src=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\"></iframe>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-file-viewer-linked-video-inner-wrap\">\n    <iframe class=\"sma-linked-video-iframe\" src=\"{{file.url}}\"></iframe>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-file-viewer-bad-format sma-file-viewer-media\">");t.b("\n" + i);t.b("    <p>");t.b(t.v(t.d("strings.cantDisplay",c,p,0)));t.b("</p>");t.b("\n" + i);t.b("    <a href=\"");t.b(t.v(t.d("file.url",c,p,0)));t.b("\" class=\"btn btn-default mt-2\" download>");t.b(t.v(t.d("strings.download",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-file-viewer-bad-format sma-file-viewer-media\">\n    <p>{{ strings.cantDisplay }}</p>\n    <a href=\"{{file.url}}\" class=\"btn btn-default mt-2\" download>{{strings.download}}</a>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<input type=\"checkbox\" class=\"sma-js-slide-toggle-checkbox sma-checkbox-input\" id=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-slide-toggler\" />\r");t.b("\n" + i);t.b("<label class=\"sma-checkbox-label\" for=\"");t.b(t.v(t.f("id",c,p,0)));t.b("-slide-toggler\">");t.b(t.v(t.f("label",c,p,0)));t.b("</label>");return t.fl(); },partials: {}, subs: {  }}, "<input type=\"checkbox\" class=\"sma-js-slide-toggle-checkbox sma-checkbox-input\" id=\"{{id}}-slide-toggler\" />\r\n<label class=\"sma-checkbox-label\" for=\"{{id}}-slide-toggler\">{{ label }}</label>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dropselector = __webpack_require__(115);

var _dropselector2 = _interopRequireDefault(_dropselector);

var _multi_select_search = __webpack_require__(303);

var _utils = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatePicker = __webpack_require__(35);

var multiSelectSearch = __webpack_require__(2228);

var Value = function () {
	function Value(filterInfo) {
		_classCallCheck(this, Value);

		this.initialize(filterInfo);
	}

	_createClass(Value, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.filterInfo = filterInfo;

			this.input = null;
			this.value = null;

			this.buildElement();
			this.delegate();
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.value = value;

			if (this.input !== null) {
				this.input.val(this.value);
			}
		}
	}, {
		key: 'getElement',
		value: function getElement() {
			return this.input;
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {}
	}, {
		key: 'afterAppended',
		value: function afterAppended() {}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.input.on('change', $.proxy(function (e) {
				this.set($(e.target).val());
			}, this));
		}
	}, {
		key: 'serialize',
		value: function serialize() {
			this.input.trigger('change');
			return { value: this.value };
		}
	}]);

	return Value;
}();

var Text = function (_Value) {
	_inherits(Text, _Value);

	function Text() {
		_classCallCheck(this, Text);

		return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
	}

	_createClass(Text, [{
		key: 'buildElement',
		value: function buildElement() {
			this.input = $('<input>', {
				type: 'text',
				'class': 'text form-control'
			});
		}
	}]);

	return Text;
}(Value);

var Choice = function (_Value2) {
	_inherits(Choice, _Value2);

	function Choice() {
		_classCallCheck(this, Choice);

		return _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).apply(this, arguments));
	}

	_createClass(Choice, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.multiple = this.multiple || false;
			this.choices = [];

			if (filterInfo !== undefined && filterInfo.choices !== undefined) {
				this.choices = filterInfo.choices;
			}

			_get(Choice.prototype.__proto__ || Object.getPrototypeOf(Choice.prototype), 'initialize', this).call(this, filterInfo);
		}
	}, {
		key: 'getElement',
		value: function getElement() {
			return this.selector.wrapped;
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.value = value;
			this.selector.val(value);
		}
	}, {
		key: 'createInput',
		value: function createInput(choiceOptions, multiple) {
			var choices = [];

			//TODO Make sure this is the only format
			//There maybe another format in use,
			for (var i in choiceOptions) {
				if (_typeof(choiceOptions[i]) != 'object') {
					// Surveys format, don't change
					choices.push({
						value: i,
						label: choiceOptions[i]
					});
				} else if (choiceOptions[i].header) choices.push({
					value: null,
					header: true,
					label: choiceOptions[i].text
				});else choices.push({
					value: choiceOptions[i].id,
					header: false,
					label: choiceOptions[i].label
				});
			}

			var input = $(Choice.SelectTemplate({ choices: choices }));

			if (multiple) {
				input.attr('multiple', 'multiple');
			}

			if (this.value == null && (this.autoSetDefault === undefined || this.autoSetDefault)) {
				input.find('option:first').attr('selected', 'selected');

				if (!multiple) {
					this.value = input.find('option:first').attr('value');
				} else {
					this.value = [input.find('option:first').attr('value')];
				}
			}

			return input;
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.input = this.createInput(this.choices, this.multiple);

			this.selector = this.input;
			this.input.show();

			this.selector = new _dropselector2.default({
				multiple: !!this.multiple,
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: this.input
			});
		}
	}]);

	return Choice;
}(Value);

Choice.SelectTemplate = _.template("\
<select class='choices'>\
<% var firstHeader = true; _.each(choices, function(choice) { %>\
<% if (choice.header) { %>\
    <% if (!firstHeader) { %>\
    	<% firstHeader = false; %>\
    <% } else { %>\
    	</optgroup>\
    <% } %>\
    <optgroup label='<%= choice.label %>'>\
<% } else { %>\
	<option value='<%= choice.value %>'><%= choice.label %></option>\
<% } %>\
<% }); %>\
<% if (!firstHeader) { %>\
	</optgroup>\
<% } %>\
</select>\
");

var MultipleChoice = function (_Choice) {
	_inherits(MultipleChoice, _Choice);

	function MultipleChoice() {
		_classCallCheck(this, MultipleChoice);

		return _possibleConstructorReturn(this, (MultipleChoice.__proto__ || Object.getPrototypeOf(MultipleChoice)).apply(this, arguments));
	}

	_createClass(MultipleChoice, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.multiple = true;
			_get(MultipleChoice.prototype.__proto__ || Object.getPrototypeOf(MultipleChoice.prototype), 'initialize', this).call(this, filterInfo);
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.value = value;
			this.selector.val(value);
		}
	}]);

	return MultipleChoice;
}(Choice);

var MultipleChoiceAndSearch = function (_MultipleChoice) {
	_inherits(MultipleChoiceAndSearch, _MultipleChoice);

	function MultipleChoiceAndSearch() {
		_classCallCheck(this, MultipleChoiceAndSearch);

		return _possibleConstructorReturn(this, (MultipleChoiceAndSearch.__proto__ || Object.getPrototypeOf(MultipleChoiceAndSearch)).apply(this, arguments));
	}

	_createClass(MultipleChoiceAndSearch, [{
		key: 'getElement',
		value: function getElement() {
			return this.input;
		}
	}, {
		key: 'createInput',
		value: function createInput(choiceOptions, multiple) {
			var choices = [];

			this.prefix = this.filterInfo.id || 'multi_select_search_el';
			this.suffix = (0, _utils.randomString)(20);

			for (var i in choiceOptions) {
				if (_typeof(choiceOptions[i]) != 'object') {
					choices.push({
						inputLabel: choiceOptions[i],
						value: i,
						inputId: this.prefix + '_' + i + '_' + this.suffix,
						inputName: this.prefix
					});
				} else {
					choices.push({
						inputLabel: choiceOptions[i].label,
						value: choiceOptions[i].value,
						inputId: this.prefix + '_' + i + '_' + this.suffix,
						inputName: this.prefix
					});
				}
			}

			var input = $(multiSelectSearch({
				strings: {
					done: gettext('done'),
					selected: gettext('Selected:'),
					search: gettext('Search...')
				},
				checkedItems: gettext('Select...'),
				checkedItemsLength: 0,
				choices: choices
			}));

			if (multiple) {
				input.attr('multiple', 'multiple');
			}

			if (this.value == null && (this.autoSetDefault === undefined || this.autoSetDefault)) {
				input.find('option:first').attr('selected', 'selected');

				if (!multiple) {
					this.value = input.find('option:first').attr('value');
				} else {
					this.value = [input.find('option:first').attr('value')];
				}
			}

			return input;
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.input = this.createInput(this.choices, this.multiple);
			this.input.show();
			this.selector = this.input;

			this.multiSelectSearch = new _multi_select_search.MultiSelectSearch();
		}
	}, {
		key: 'set',
		value: function set(value) {
			var _this5 = this;

			this.value = value;
			value.forEach(function (i, val) {
				_this5.input.find('input[value="' + i + '"]').attr('checked', 'checked');
			});
			if (value.length > 0) {
				this.input.find('.sma-multi-select-selected-count').text(value.length);
			}
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			var _this6 = this;

			this.input.on('change', function (e) {
				var selected = [].slice.call(e.currentTarget.querySelectorAll('input[name="' + _this6.prefix + '"]:checked')).map(function (input) {
					return input.value;
				});
				_this6.set(selected);
			});
		}
	}]);

	return MultipleChoiceAndSearch;
}(MultipleChoice);

var ValueAndMultipleChoice = function (_MultipleChoice2) {
	_inherits(ValueAndMultipleChoice, _MultipleChoice2);

	function ValueAndMultipleChoice() {
		_classCallCheck(this, ValueAndMultipleChoice);

		return _possibleConstructorReturn(this, (ValueAndMultipleChoice.__proto__ || Object.getPrototypeOf(ValueAndMultipleChoice)).apply(this, arguments));
	}

	_createClass(ValueAndMultipleChoice, [{
		key: 'buildElement',
		value: function buildElement() {
			this.input1 = $('<input>', {
				type: 'text',
				'class': 'text form-control'
			});
			_get(ValueAndMultipleChoice.prototype.__proto__ || Object.getPrototypeOf(ValueAndMultipleChoice.prototype), 'buildElement', this).call(this);
			this.selector.selectAll();
		}
	}, {
		key: 'getElement',
		value: function getElement() {
			var div = $('<div class="sma-condition-value-multi">');
			div.append(this.input1);
			div.append(this.selector.wrapped);
			return div;
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.value = value;
			if (value.indexOf(":") == "-1") {
				this.input1.val(value);
			} else {
				var values = value.split(':');
				this.input1.val(values[0]);
				var selectorVals = values[1].split(',');
				this.selector.val(selectorVals);
			}
		}
	}, {
		key: 'setSelector',
		value: function setSelector(value) {
			var inputVal = this.input1.val();
			this.value = inputVal + ':' + value;
			this.selector.val(value);
		}
	}, {
		key: 'setInput',
		value: function setInput(value) {
			var selectorVal = this.selector.val();
			this.value = value + ':' + selectorVal;
			this.input1.val(value);
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.input1.on('change', $.proxy(function (e) {
				this.setInput($(e.target).val());
			}, this));

			this.input.on('change', $.proxy(function (e) {
				this.setSelector($(e.target).val());
			}, this));
		}
	}]);

	return ValueAndMultipleChoice;
}(MultipleChoice);

var ChoiceAndChoice = function (_Choice2) {
	_inherits(ChoiceAndChoice, _Choice2);

	function ChoiceAndChoice() {
		_classCallCheck(this, ChoiceAndChoice);

		return _possibleConstructorReturn(this, (ChoiceAndChoice.__proto__ || Object.getPrototypeOf(ChoiceAndChoice)).apply(this, arguments));
	}

	_createClass(ChoiceAndChoice, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.multiple = this.multiple || false;
			this.choices1 = [];

			if (filterInfo !== undefined && filterInfo.choices1 !== undefined) {
				this.choices1 = filterInfo.choices1;
			}

			if (filterInfo !== undefined && filterInfo.choices2 !== undefined) {
				this.choices2 = filterInfo.choices2;
			}
			_get(ChoiceAndChoice.prototype.__proto__ || Object.getPrototypeOf(ChoiceAndChoice.prototype), 'initialize', this).call(this, filterInfo);
		}
	}, {
		key: 'getElement',
		value: function getElement() {
			var div = $('<div class="sma-condition-select-select">');
			div.append(this.selector1.wrapped);
			div.append(this.selector2.wrapped);
			return div;
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.value = value;
			if (value.indexOf(":") == "-1") {
				this.selector1.val(value);
			} else {
				var values = value.split(':');

				var selector1Vals = values[0].split(',');
				this.selector1.val(selector1Vals);

				this.selector2.val(values[1]);
			}
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.input1 = this.createInput(this.choices1, this.multiple);
			this.input1.show();

			this.selector1 = new _dropselector2.default({
				multiple: this.multiple,
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: this.input1
			});

			this.input2 = this.createInput(this.choices2, false);
			this.input2.show();

			this.selector2 = new _dropselector2.default({
				multiple: false,
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: this.input2
			});

			_get(ChoiceAndChoice.prototype.__proto__ || Object.getPrototypeOf(ChoiceAndChoice.prototype), 'buildElement', this).call(this);
		}
	}, {
		key: 'setSelector1',
		value: function setSelector1(value) {
			var selector2 = this.selector2.val();
			this.value = value + ':' + selector2;
			this.selector1.val(value);
		}
	}, {
		key: 'setSelector2',
		value: function setSelector2(value) {
			var selector1 = this.selector1.val();
			this.value = selector1 + ':' + value;
			this.selector2.val(value);
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.input1.on('change', $.proxy(function (e) {
				this.setSelector1($(e.target).val());
			}, this));

			this.input2.on('change', $.proxy(function (e) {
				this.setSelector2($(e.target).val());
			}, this));
		}
	}]);

	return ChoiceAndChoice;
}(Choice);

var MultiAndChoice = function (_ChoiceAndChoice) {
	_inherits(MultiAndChoice, _ChoiceAndChoice);

	function MultiAndChoice() {
		_classCallCheck(this, MultiAndChoice);

		return _possibleConstructorReturn(this, (MultiAndChoice.__proto__ || Object.getPrototypeOf(MultiAndChoice)).apply(this, arguments));
	}

	_createClass(MultiAndChoice, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.multiple = true;
			_get(MultiAndChoice.prototype.__proto__ || Object.getPrototypeOf(MultiAndChoice.prototype), 'initialize', this).call(this, filterInfo);
		}
	}]);

	return MultiAndChoice;
}(ChoiceAndChoice);

var DateTime = function (_Value3) {
	_inherits(DateTime, _Value3);

	function DateTime() {
		_classCallCheck(this, DateTime);

		return _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).apply(this, arguments));
	}

	_createClass(DateTime, [{
		key: 'buildElement',
		value: function buildElement() {
			this.input = $('<input>', {
				class: 'form-control',
				type: 'text'
			});
		}
	}, {
		key: 'afterAppended',
		value: function afterAppended() {
			new DatePicker(this.input);
		}
	}]);

	return DateTime;
}(Value);

var TeamAndStage = function (_MultipleChoice3) {
	_inherits(TeamAndStage, _MultipleChoice3);

	function TeamAndStage() {
		_classCallCheck(this, TeamAndStage);

		return _possibleConstructorReturn(this, (TeamAndStage.__proto__ || Object.getPrototypeOf(TeamAndStage)).apply(this, arguments));
	}

	_createClass(TeamAndStage, [{
		key: 'initialize',
		value: function initialize(filterInfo) {
			this.stageChoices = filterInfo.stage_choices;
			this.noPredicate = true;
			this.autoSetDefault = false;

			_get(TeamAndStage.prototype.__proto__ || Object.getPrototypeOf(TeamAndStage.prototype), 'initialize', this).call(this, filterInfo);

			if (this.value === null) {
				this.value = {
					teams: [],
					stage: this.stageChoices[0].id
				};
			}
		}
	}, {
		key: 'buildElement',
		value: function buildElement() {
			this.stageSelectorInput = $('<select>');

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.stageChoices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var stage = _step.value;

					var option = $('<option>', { value: stage.id, text: stage.label });
					this.stageSelectorInput.append(option);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.stageSelector = new _dropselector2.default({
				multiple: false,
				fullWidth: true,
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: this.stageSelectorInput
			});

			_get(TeamAndStage.prototype.__proto__ || Object.getPrototypeOf(TeamAndStage.prototype), 'buildElement', this).call(this);
		}
	}, {
		key: 'getElement',
		value: function getElement() {
			var div = $('<div class="sma-condition-team-and-stage row">');

			var stageColumn = $('<div>').addClass('col');
			var teamColumn = $('<div>').addClass('col');

			stageColumn.append($('<span>').text(gettext('In stage')));
			stageColumn.append(this.stageSelector.wrapped);

			teamColumn.append($('<span>').text(gettext('By team')));
			teamColumn.append($('<small>').addClass('text-muted').text(gettext('(Optional)')));
			teamColumn.append(this.selector.wrapped);

			return div.append(stageColumn, teamColumn);
		}
	}, {
		key: 'set',
		value: function set(value) {
			this.setTeams(value.teams);
			this.setStage(value.stage);

			if (this.value.teams !== undefined && this.value.teams.length > 0) {
				this.selector.val(value.teams);
			} else {
				this.value.teams = [];
			}

			if (this.value.stage !== undefined) {
				this.stageSelector.val(this.value.stage);
			} else {
				this.value.stage = this.stageChoices[0].id;
			}
		}
	}, {
		key: 'setTeams',
		value: function setTeams(value) {
			this.value.teams = value.filter(function (x) {
				return x !== '-1';
			});
		}
	}, {
		key: 'setStage',
		value: function setStage(value) {
			this.value.stage = value;
		}
	}, {
		key: 'delegate',
		value: function delegate() {
			this.stageSelector.$selectEl.on('change', $.proxy(function (e) {
				this.setStage($(e.target).val());
			}, this));

			this.input.on('change', $.proxy(function (e) {
				this.setTeams($(e.target).val());
			}, this));
		}
	}, {
		key: 'serialize',
		value: function serialize() {
			return this.value;
		}
	}]);

	return TeamAndStage;
}(MultipleChoice);

Value.TypeMap = {
	'text': Text,
	'choice': Choice,
	'multiplechoice': MultipleChoice,
	'datetime': DateTime,
	'noop': null,
	'value_and_multi': ValueAndMultipleChoice,
	'team_and_stage': TeamAndStage,
	'choice_and_choice': ChoiceAndChoice,
	'multi_and_choice': MultiAndChoice,
	'multi_with_search': MultipleChoiceAndSearch
};

module.exports = {
	Value: Value,
	Text: Text,
	Choice: Choice,
	MultipleChoice: MultipleChoice,
	DateTime: DateTime,
	ValueAndMultipleChoice: ValueAndMultipleChoice,
	TeamAndStage: TeamAndStage
};

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-multi-select-dropdown dropdown\">");t.b("\n" + i);t.b("	<a class=\"btn btn-select dropdown-toggle text-truncate sma-multi-select-dropdown-button\" data-toggle=\"dropdown\">");t.b(t.v(t.f("checkedItems",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("	");t.b("\n" + i);t.b("	<div class=\"dropdown-menu sma-multi-select-menu\">");t.b("\n" + i);t.b("		<div class=\"sma-multi-select-container\">");t.b("\n" + i);t.b("			<div class=\"sma-multi-select-search-container\">");t.b("\n" + i);t.b("				<div class=\"sma-input-icon-right\">");t.b("\n" + i);t.b("					<input class=\"form-control sma-multi-select-search\" type=\"text\" placeholder=\"");t.b(t.v(t.d("strings.search",c,p,0)));t.b("\">");t.b("\n" + i);t.b("					<i class=\"nc-icon-mini ui-1_zoom\"></i>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("			</div>		");t.b("\n" + i);t.b("			<div class=\"sma-multi-select-content\">");t.b("\n" + i);if(t.s(t.f("choices",c,p,1),c,p,0,597,868,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("					<div class=\"sma-multi-select-row\">");t.b("\n" + i);t.b("						<input class=\"sma-checkbox-input\" ");if(t.s(t.f("value",c,p,1),c,p,0,688,705,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("value=\"");t.b(t.v(t.f("value",c,p,0)));t.b("\"");});c.pop();}t.b(" type=\"checkbox\" name=\"");t.b(t.v(t.f("inputName",c,p,0)));t.b("\" id=\"");t.b(t.v(t.f("inputId",c,p,0)));t.b("\">");t.b("\n" + i);t.b("						<label class=\"sma-checkbox-label\" for=\"");t.b(t.v(t.f("inputId",c,p,0)));t.b("\">");t.b(t.v(t.f("inputLabel",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("					</div>");t.b("\n" + i);});c.pop();}t.b("			</div>");t.b("\n" + i);t.b("			<div class=\"sma-multi-select-footer\">");t.b("\n" + i);t.b("				<div>");t.b("\n" + i);t.b("					<span>");t.b(t.v(t.d("strings.selected",c,p,0)));t.b("</span> <span class=\"sma-multi-select-selected-count\">");t.b(t.v(t.f("checkedItemsLength",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("				</div>");t.b("\n" + i);t.b("				<button class=\"btn btn-loud btn-primary sma-multi-select-done\" type=\"button\">");t.b(t.v(t.d("strings.done",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("			</div>	");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-multi-select-dropdown dropdown\">\n\t<a class=\"btn btn-select dropdown-toggle text-truncate sma-multi-select-dropdown-button\" data-toggle=\"dropdown\">{{checkedItems}}</a>\n\t\n\t<div class=\"dropdown-menu sma-multi-select-menu\">\n\t\t<div class=\"sma-multi-select-container\">\n\t\t\t<div class=\"sma-multi-select-search-container\">\n\t\t\t\t<div class=\"sma-input-icon-right\">\n\t\t\t\t\t<input class=\"form-control sma-multi-select-search\" type=\"text\" placeholder=\"{{strings.search}}\">\n\t\t\t\t\t<i class=\"nc-icon-mini ui-1_zoom\"></i>\n\t\t\t\t</div>\n\t\t\t</div>\t\t\n\t\t\t<div class=\"sma-multi-select-content\">\n\t\t\t\t{{#choices}}\n\t\t\t\t\t<div class=\"sma-multi-select-row\">\n\t\t\t\t\t\t<input class=\"sma-checkbox-input\" {{#value}}value=\"{{value}}\"{{/value}} type=\"checkbox\" name=\"{{inputName}}\" id=\"{{inputId}}\">\n\t\t\t\t\t\t<label class=\"sma-checkbox-label\" for=\"{{inputId}}\">{{inputLabel}}</label>\n\t\t\t\t\t</div>\n\t\t\t\t{{/choices}}\n\t\t\t</div>\n\t\t\t<div class=\"sma-multi-select-footer\">\n\t\t\t\t<div>\n\t\t\t\t\t<span>{{strings.selected}}</span> <span class=\"sma-multi-select-selected-count\">{{checkedItemsLength}}</span>\n\t\t\t\t</div>\n\t\t\t\t<button class=\"btn btn-loud btn-primary sma-multi-select-done\" type=\"button\">{{strings.done}}</button>\n\t\t\t</div>\t\n\t\t</div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function(){;
var DateTimeFormatter, _, _DateTime, i, j, len1, len2, method, property, proxyMethod, ref, ref1;

_ = (typeof window === "undefined" || window === null) && (typeof module !== "undefined" && module !== null) ? __webpack_require__(53) : window._;

DateTimeFormatter = (function() {
  function DateTimeFormatter() {}

  DateTimeFormatter.prototype.TOKEN = /d{1,4}|M{1,4}|yy(?:yy)?|([HhmsTt])\1?|[LloSZ]|\"[^\"]*\"|\'[^']*\'/g;

  DateTimeFormatter.prototype.TIMEZONE = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[\-+]\d{4})?)\b/g;

  DateTimeFormatter.prototype.TIMEZONE_CLIP = /[^\-+\dA-Z]/g;

  DateTimeFormatter.prototype.MASKS = {
    "default": "ddd MMM dd yyyy HH:mm:ss",
    isoTime: "HH:mm:ss",
    isoDateTime: "yyyy-MM-dd'T'HH:mm:ss.lo"
  };

  DateTimeFormatter.prototype.strings = {
    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daysLong: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monthsLong: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  };

  DateTimeFormatter.prototype.pad = function(val, len, pad) {
    if (len == null) {
      len = 2;
    }
    if (pad == null) {
      pad = "0";
    }
    val = String(val);
    while (val.length < len) {
      val = pad + val;
    }
    return val;
  };

  DateTimeFormatter.prototype.format = function(date, mask) {
    var D, H, L, M, d, flags, m, o, pre, ref, ref1, s, utc, y;
    mask = (ref = (ref1 = this.MASKS[mask]) != null ? ref1 : mask) != null ? ref : this.MASKS["default"];
    utc = mask.slice(0, 4) === "UTC:";
    if (utc) {
      mask = mask.slice(4);
    }
    pre = utc ? "getUTC" : "get";
    d = date[pre + "Date"]();
    D = date[pre + "Day"]();
    M = date[pre + "Month"]();
    y = date[pre + "FullYear"]();
    H = date[pre + "Hours"]();
    m = date[pre + "Minutes"]();
    s = date[pre + "Seconds"]();
    L = date[pre + "Milliseconds"]();
    o = utc ? 0 : date.getTimezoneOffset();
    flags = {
      d: d,
      dd: this.pad(d),
      ddd: this.strings.days[D],
      dddd: this.strings.daysLong[D],
      M: M + 1,
      MM: this.pad(M + 1),
      MMM: this.strings.months[M],
      MMMM: this.strings.monthsLong[M],
      yy: String(y).slice(2),
      yyyy: y,
      h: H % 12 || 12,
      hh: this.pad(H % 12 || 12),
      H: H,
      HH: this.pad(H),
      m: m,
      mm: this.pad(m),
      s: s,
      ss: this.pad(s),
      l: this.pad(L, 3),
      L: this.pad(L > 99 ? Math.round(L / 10) : L),
      t: H < 12 ? "a" : "p",
      tt: H < 12 ? "am" : "pm",
      T: H < 12 ? "A" : "P",
      TT: H < 12 ? "AM" : "PM",
      Z: utc ? "UTC" : (String(date).match(this.TIMEZONE) || [""]).pop().replace(this.TIMEZONE_CLIP, ""),
      o: (o > 0 ? "-" : "+") + this.pad(Math.floor(Math.abs(o) / 60.0) * 100 + Math.abs(o) % 60, 4),
      S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10]
    };
    return mask.replace(this.TOKEN, function(match) {
      if (match in flags) {
        return flags[match];
      } else {
        return match.slice(1, match.length - 1);
      }
    });
  };

  return DateTimeFormatter;

})();

_DateTime = (function() {
  _DateTime.prototype.formatter = new DateTimeFormatter();

  function _DateTime(value, format) {
    this.date = value == null ? new Date() : _.isDate(value) ? value : _.isArray(value) ? _DateTime.fromArray(value) : format != null ? _DateTime.fromFormat(value, format) : _DateTime.parse(value);
  }

  _DateTime.prototype.clone = function() {
    return new _DateTime(new Date(this.date));
  };

  _DateTime.prototype.setHMS = function(h, m, s, ms) {
    if (h instanceof _DateTime || _.isDate(h)) {
      ms = h.getMilliseconds();
      s = h.getSeconds();
      m = h.getMinutes();
      h = h.getHours();
    }
    this.setHours(h);
    this.setMinutes(m);
    this.setSeconds(s);
    if (ms != null) {
      this.setMilliseconds(ms);
    }
    return this;
  };

  _DateTime.prototype.setYMD = function(y, m, d) {
    if (y instanceof _DateTime || _.isDate(y)) {
      d = y.getDate();
      m = y.getMonth();
      y = y.getFullYear();
    }
    this.setFullYear(y);
    this.setMonth(m);
    this.setDate(d);
    return this;
  };

  _DateTime.prototype.combine = function(time) {
    return this.clone().setHMS(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
  };

  _DateTime.prototype.format = function(mask) {
    return this.formatter.format(this, mask);
  };

  _DateTime.parse = function(value) {
    var i, k, len1, minutesOffset, numericKeys, struct;
    numericKeys = [1, 4, 5, 6, 7, 10, 11];
    struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/.exec(value);
    if (struct) {
      for (i = 0, len1 = numericKeys.length; i < len1; i++) {
        k = numericKeys[i];
        struct[k] = (+struct[k]) || 0;
      }
      struct[2] = (+struct[2] || 1) - 1;
      struct[3] = +struct[3] || 1;
      if ((struct[8] != null) || (struct[9] != null)) {
        minutesOffset = 0;
        if (struct[8] !== 'Z' && (struct[9] != null)) {
          minutesOffset = struct[10] * 60 + struct[11];
          if (struct[9] === '+') {
            minutesOffset = 0 - minutesOffset;
          }
        }
        return new Date(Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]));
      }
      return new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
    }
    return new Date(value);
  };

  _DateTime.parseTime = function(str) {
    var bits, date, h, m, ms, ref, ref1, ref2, ref3, s;
    date = new this();
    if (str.toLowerCase() === 'now') {
      return date;
    }
    bits = /(\d{1,2})(?::(\d{1,2})(?::(\d{1,4})(?:\.(\d{3}))?)?)?(?:\s*([ap])\.?m?\.?)?$/i.exec(str);
    h = parseInt((ref = bits[1]) != null ? ref : 0, 10);
    m = parseInt((ref1 = bits[2]) != null ? ref1 : 0, 10);
    s = parseInt((ref2 = bits[3]) != null ? ref2 : 0, 10);
    ms = parseInt((ref3 = bits[4]) != null ? ref3 : 0, 10);
    if (bits[5]) {
      h = h % 12;
      if (bits[5].toLowerCase() === 'p') {
        h += 12;
      }
    } else if (bits[1].length === 1) {
      if (h < 6) {
        h += 12;
      }
    }
    date.setHMS(h % 24, m % 60, s % 60, ms);
    return date;
  };

  return _DateTime;

})();

proxyMethod = function(method) {
  return _DateTime.prototype[method] = function() {
    return Date.prototype[method].apply(this.date, arguments);
  };
};

ref = "Date Time FullYear Month Day Hours Minutes Seconds Milliseconds".split(" ");
for (i = 0, len1 = ref.length; i < len1; i++) {
  property = ref[i];
  proxyMethod("get" + property);
  proxyMethod("set" + property);
  proxyMethod("getUTC" + property);
  proxyMethod("setUTC" + property);
}

ref1 = "toLocaleString toLocaleDateString toLocaleTimeString toString toDateString toTimeString toUTCString toJSON getTimezoneOffset".split(" ");
for (j = 0, len2 = ref1.length; j < len2; j++) {
  method = ref1[j];
  proxyMethod(method);
}

if ((typeof window === "undefined" || window === null) && (typeof module !== "undefined" && module !== null)) {
  module.exports = _DateTime;
  _.mixin({
    date: _DateTime
  });
} else {
  this._.mixin({
    date: _DateTime
  });
}

})();;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)(module)))

/***/ }),
/* 2343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CodeMirror = window.CodeMirror;

var Javascripter = $.klass({
	supportedTypes: ['section-separator', 'text-response', 'boolean-choice', 'single-choice', 'dropdown-choice', 'multiple-choice', 'text-response-grid', 'single-choice-grid', 'dropdown-grid', 'datetime', 'hidden-field', 'custom-grid', 'slider', 'multiple-choice-grid', 'drill-down', 'threed-grid', 'likert', 'file-field', 'net-promoter', 'timer'],

	initialize: function initialize(survey, editor) {
		var that = this;
		this.survey = survey;
		this.editor = editor;

		this.default_script = '$(function(){\n//place script here\n\n\n});';

		this.script = {};

		this.element = $('<form id="scriptform" method="" action="#" style=""/>').addClass('form-dialog javascripter_div');

		$('<div>', { 'class': 'codeMirrorToolBar' }).append($('<label />', { 'text': gettext("Script:") }), $('<textarea></textarea>', { 'class': 'script_area', 'name': 'script', 'style': 'width:500px;height:150px' }), $('<a></a>', { 'class': 'clean-button undo', 'alt': 'Undo', 'title': 'Undo' }), $('<a></a>', { 'class': 'clean-button redo', 'alt': 'Redo', 'title': 'Redo' }), $('<a></a>', { 'class': 'clean-button clear', 'alt': 'Clear', 'title': 'Clear' })).appendTo(this.element);

		$('.undo', this.element).click(function () {
			that.scriptEditor.undo();
		});

		$('.redo', this.element).click(function () {
			that.scriptEditor.redo();
		});

		$('.full-screen', this.element).click(function () {
			that.open_dialog();
		});

		$('.builder', this.element).click(function () {
			that.javascript_builder();
		});

		$('.clear', this.element).click(function () {
			that.scriptEditor.setValue(that.default_script);
		});

		$(this.element).bind('submit', function (e) {
			// prevent default on the form
			e.preventDefault();
		});
	},

	javascript_builder: function javascript_builder() {
		var that = this;
		if (this.builder_dialog) {
			this.builder_dialog.dialog('destroy');
			this.builder_dialog = null;
			return;
		}
		if (!this.builder) {
			this.builder = $('<form id="buildform" method="" action="#" style="width:385px"/>').addClass('form-dialog javabuilder_div');
			this.questions = $('<select>');
			this.options = $('<select>');
			$('<div>', { 'style': 'margin-bottom:20px' }).append($('<label />', { 'text': gettext("Question") + ': ' }), this.questions, $('<a></a>', { 'href': '#', 'style': 'margin-left:5px;', 'class': 'help', 'text': '(?)', 'title': gettext('Question - Select a question that you would like to build JavaScript for.') }), $('<br /><br />'), $('<label />', { 'text': gettext("Option") + ': ', 'style': 'margin-left:14px;' }), this.options, $('<a></a>', { 'href': '#', 'style': 'margin-left:5px;', 'class': 'help', 'text': '(?)', 'title': gettext('Option - Select an option to build the associated JavaScript.') }), $('<br />')).appendTo(this.builder);

			$('<div>', { 'class': 'codeMirrorToolBar', 'style': 'width:355px' }).append($('<label />', { 'text': gettext("Script:") }), $('<textarea></textarea>', { 'class': 'build_area', 'name': 'build', 'style': 'width:380px;height:250px' })).appendTo(this.builder);
		}

		this.update_builder_questions();
		$(this.questions).change(function () {
			that.update_builder_options($(that.questions).val());
		});

		if (this.dialog) {
			if ($('#buildform', this.dialog).length > 0) {
				$('h3', this.dialog).remove();
				$('.scriptinsert', this.dialog).remove();
				$('#buildform', this.dialog).remove();
				$(this.dialog).parents('.ui-dialog').css('width', 930);
				$('#scriptform', this.dialog).css('margin-right', '0px');
				$('#scriptform', this.dialog).css('float', '');
				$(this.builder).css('float', '');
				$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 7px');
				$('#scriptform', this.dialog).css('width', '100%');
				$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left')) + 210);
			} else {
				$(this.dialog).parents('.ui-dialog').css('width', 1350);
				$('#scriptform', this.dialog).css('margin-right', '20px');
				$('#scriptform', this.dialog).css('float', 'left');
				$('#scriptform', this.dialog).css('width', '900px');
				$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left')) - 210);
				$('.codeMirrorToolBar', this.builder).append($('<a></a>', { 'class': 'clean-button scriptinsert', 'style': 'float:right', 'text': gettext('Insert') }));
				$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 29px');
				$(this.builder).css('float', 'right');
				$(this.builder).prepend($('<h3>JavaScript Builder</h3>'));
				$(this.dialog).append(this.builder);
				$('.scriptinsert', this.builder).click(function (e) {
					e.preventDefault();
					that.scriptEditor.replaceSelection(that.buildEditor.getValue());
				});
			}
		} else {
			this.builder_dialog = $('<div/>').dialog({
				title: gettext('JavaScript Builder'),
				dialogClass: DIALOG_CLASS,
				width: 405,
				height: 465,
				position: [$('.pages').offset().left + $('.pages').width() + 45, 'center'],
				modal: false,
				resizable: false,
				zIndex: 1020,
				close: function close() {
					$(this).dialog('destroy');
					that.builder_dialog = null;
				}
			}).dialog('option', 'buttons', [{
				'class': 'icon icon-down',
				text: gettext('Insert'),
				click: function click(e) {
					that.scriptEditor.replaceSelection(that.buildEditor.getValue());
				}
			}, {
				'class': 'icon icon-cancel',
				text: gettext('Cancel'),
				click: function click(e) {
					$(this).dialog('destroy');
					that.builder_dialog = null;
				}
			}]);

			this.builder_dialog.append(this.builder);
		}

		if (!this.buildEditor) {
			this.buildEditor = CodeMirror.fromTextArea($('.build_area', this.builder)[0], {
				theme: 'monokai',
				mode: 'javascript',
				lineNumbers: false,
				smartIndent: false
			});
			this.buildEditor.setSize(null, 214);
		}
	},

	update_builder_questions: function update_builder_questions() {
		var that = this;
		$(this.questions).empty();
		$(this.questions).append($('<option><\/option>').val(null).append('---'));
		$(this.questions).append($('<option><\/option>').val('general').append('General'));

		$(this.options).empty();
		$(this.options).append($('<option><\/option>').val('').append('---'));

		$.each(this.editor.survey.nameMapping, function (name, field) {
			if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
				return;
			} else {
				$(that.questions).append($('<option><\/option>').val(name).append(field.name.get()));
			}
		});
	},

	update_builder_options: function update_builder_options(question) {
		var that = this;
		this.buildEditor.setValue('');
		$(this.options).empty();
		$(this.options).unbind();
		$(this.options).append($('<option><\/option>').val('').append('---'));

		if (question != '') {
			if (question == 'general') {
				$(this.options).append($('<option><\/option>').val("$('title').text('INSERT TEXT HERE');\n").append(gettext('Change Webpage Title')));
				$(this.options).append($('<option><\/option>').val("$('.survey-title').text('INSERT TEXT HERE');\n").append(gettext('Change Survey Title')));
				$(this.options).append($('<option><\/option>').val("$('input[name=next]').val('INSERT TEXT HERE');\n").append(gettext('Change Text of Next Button')));
				$(this.options).append($('<option><\/option>').val("$('input[name=back]').val('INSERT TEXT HERE');\n").append(gettext('Change Text of Back Button')));
				$(this.options).append($('<option><\/option>').val("$('input[name=submitbutton]').val('INSERT TEXT HERE');\n").append(gettext('Change Text of Submit Button')));
				$(this.options).append($('<option><\/option>').val("chide.ui.Tooltip.init($('span[class=tool]'));\n").append(gettext('Convert Tooltip HTML')));
			} else {
				$(this.options).append($('<option><\/option>').val("$('.question-title', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n").append(gettext('Modify Question Title')));
				if (this.editor.survey.nameMapping[question].type == 'section-separator') {} else if (this.editor.survey.nameMapping[question].type == 'boolean-choice') {
					$(this.options).append($('<option><\/option>').val("$('li:first', '#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.appendTo('#id_" + this.editor.survey.nameMapping[question].id + "');\n").append(gettext('Swap Yes and No Position')));
				} else if (this.editor.survey.nameMapping[question].type == 'text-response') {
					$(this.options).append($('<option><\/option>').val("$('#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Box')));
					$(this.options).append($('<option><\/option>').val("$('#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Box')));
				} else if (this.editor.survey.nameMapping[question].type == 'multiple-choice') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Choices')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Choices')));
					$(this.options).append($('<option><\/option>').val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Choices')));
					$(this.options).append($('<option><\/option>').val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Choices')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Choice')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Each Choice')));
				} else if (this.editor.survey.nameMapping[question].type == 'single-choice') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Choices')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Choices')));
					$(this.options).append($('<option><\/option>').val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Choices')));
					$(this.options).append($('<option><\/option>').val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Choices')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Choice')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Each Choice')));
				} else if (this.editor.survey.nameMapping[question].type == 'dropdown-choice') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Drop Down')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Drop Down')));
				} else if (this.editor.survey.nameMapping[question].type == 'datetime') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Date/Time')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Date/Time')));
					$(this.options).append($('<option><\/option>').val("$('tr', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend($('<td>', {'text': 'INSERT TEXT HERE', 'style': 'vertical-align:top;padding-top:9px;'}));\n").append(gettext('Insert Text Before Date/Time')));
					$(this.options).append($('<option><\/option>').val("$('tr', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append($('<td>', {'text': 'INSERT TEXT HERE', 'style': 'vertical-align:top;padding:9px 0 0 85px;'}));\n").append(gettext('Insert Text After Date/Time')));
					$(this.options).append($('<option><\/option>').val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "').each(function(i,e){\n\tif($(e).text() == '@'){\n\t\t$(e).text('INSERT TEXT HERE');\n\t}\n});\n").append(gettext('Insert Text Between Date/Time')));
				} else if (this.editor.survey.nameMapping[question].type == 'text-response-grid') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly Before Each Box')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly After Each Box')));
				} else if (this.editor.survey.nameMapping[question].type == 'single-choice-grid') {
					$(this.options).append($('<option><\/option>').val("$('th:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n").append(gettext('Add Top Left Label')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.prepend($('<div>', {'text': 'INSERT TEXT HERE'}));\n").append(gettext('Insert Text Above Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.append($('<div>', {'text': 'INSERT TEXT HERE'}));\n").append(gettext('Insert Text Below Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Radio Button')));
				} else if (this.editor.survey.nameMapping[question].type == 'dropdown-grid') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>').val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly Before Each Drop Down')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly After Each Drop Down')));
				} else if (this.editor.survey.nameMapping[question].type == 'slider') {
					$(this.options).append($('<option><\/option>').val("$('.slider_question', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.css('background','blue');\n").append(gettext('Change Slider Bar Colour')));
					$(this.options).append($('<option><\/option>').val("$('a', $('.slider_question', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.css('background','black');\n").append(gettext('Change Slider Bar Colour')));
				} else if (this.editor.survey.nameMapping[question].type == 'multiple-choice-grid') {
					$(this.options).append($('<option><\/option>').val("$('th:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n").append(gettext('Add Top Left Label')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.prepend($('<div>', {'text': 'INSERT TEXT HERE'}));\n").append(gettext('Insert Text Above Checkbox')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.append($('<div>', {'text': 'INSERT TEXT HERE'}));\n").append(gettext('Insert Text Below Checkbox')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Checkbox')));
					$(this.options).append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Checkbox')));
				} else if (this.editor.survey.nameMapping[question].type == 'custom-grid') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>').val("$('li.variable', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>').val("$(':first', $('.variable', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly Before Each Input')));
					$(this.options).append($('<option><\/option>').val("$('li.variable', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Directly After Each Input')));
					$(this.options).append($('<option><\/option>').val("$('li', $('.variable ul', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Each Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('li', $('.variable ul', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Each Radio Button')));
				} else if (this.editor.survey.nameMapping[question].type == 'drill-down') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Selection')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Selection')));
					$(this.options).append($('<option><\/option>').val("$('.drill-down-selector', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.css('background','yellow');\n").append(gettext('Change Box Background Colour')));
					$(this.options).append($('<option><\/option>').val("$('.drill-down-selector:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text Between Boxes')));
				} else if (this.editor.survey.nameMapping[question].type == 'threed-grid') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>').val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Every Input')));
					$(this.options).append($('<option><\/option>').val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Every Input')));
					$(this.options).append($('<option><\/option>').val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Drop Down')));
					$(this.options).append($('<option><\/option>').val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Drop Down')));
					$(this.options).append($('<option><\/option>').val("$(':text', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Textbox')));
					$(this.options).append($('<option><\/option>').val("$(':text', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Textbox')));
					$(this.options).append($('<option><\/option>').val("$(':checkbox', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Checkbox')));
					$(this.options).append($('<option><\/option>').val("$(':checkbox', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n").append(gettext('Insert Text After Checkbox')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Radio Button')));
					$(this.options).append($('<option><\/option>').val("$('tr', $('tbody', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.before($('<tr>')\n\t\t.append($('<td>', {'text': 'INSERT TEXT HERE', 'colspan':'" + (this.editor.survey.nameMapping[question].columns.value.length + 1) + "', 'style': 'background:LightGray'})));\n").append(gettext('Insert Row Separators')));
				} else if (this.editor.survey.nameMapping[question].type == 'likert') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
				} else if (this.editor.survey.nameMapping[question].type == 'file-field') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before File Field')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After File Field')));
				} else if (this.editor.survey.nameMapping[question].type == 'net-promoter') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text Below Grid')));
				} else if (this.editor.survey.nameMapping[question].type == 'hidden-field') {
					this.options.append($('<option><\/option>').val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.val('INSERT VALUE HERE');\n").append(gettext('Set Value of Hidden Field')));
				} else if (this.editor.survey.nameMapping[question].type == 'timer') {
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n").append(gettext('Insert Text Before Start Button/Link')));
					$(this.options).append($('<option><\/option>').val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n").append(gettext('Insert Text After Start Button/Link')));
					this.options.append($('<option><\/option>').val("$('span', $('a', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.html('INSERT TEXT HERE');\n").append(gettext('Change Text of Start Button/Link')));
				}
			}
		}
		$(this.options).change(function () {
			that.buildEditor.setValue($(that.options).val());
		});
	},

	open_dialog: function open_dialog() {
		var that = this;

		this.parent_element = this.element.parent();

		this.dialog = $('<div/>').append(this.element).dialog({
			title: gettext('JavaScript Editor'),
			dialogClass: DIALOG_CLASS,
			width: 930,
			height: 475,
			modal: true,
			resizable: false,
			close: function close() {
				if ($('#buildform', that.dialog).length > 0) {
					$('h3', that.dialog).remove();
					$('.scriptinsert', that.dialog).remove();
					$('#scriptform', that.dialog).css('width', '100%');
					$(that.builder).css('float', '');
					$('.codeMirrorToolBar', that.builder).css('padding', '3px 7px 7px');
					that.javascript_builder();
				}
				$('.full-screen', that.element).show();
				that.parent_element.append(that.element);
				$(this).dialog('destroy');
				that.dialog = null;
			}
		});

		$('.full-screen', this.element).hide();
		if (this.builder_dialog) {
			$(this.builder_dialog).dialog('destroy');
			this.builder_dialog = null;
			$(this.dialog).parents('.ui-dialog').css('width', 1350);
			$('#scriptform', this.dialog).css('margin-right', '20px');
			$('#scriptform', this.dialog).css('float', 'left');
			$('#scriptform', this.dialog).css('width', '900px');
			$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left')) - 210);
			$('.codeMirrorToolBar', this.builder).append($('<a></a>', { 'class': 'clean-button scriptinsert', 'style': 'float:right', 'text': gettext('Insert') }));
			$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 29px');
			$(this.builder).css('float', 'right');
			$(this.builder).prepend($('<h3>JavaScript Builder</h3>'));
			$(this.dialog).append(this.builder);
			$('.scriptinsert', this.builder).click(function (e) {
				e.preventDefault();
				that.scriptEditor.replaceSelection(that.buildEditor.getValue());
			});
		}
	},

	update_piper: function update_piper(survey, limit_to_page, noids) {
		var that = this;
		this.limit_to_page = limit_to_page;
		this.noids = noids;
		this.survey._formatInfo = null;
		this.survey = survey;
		this.currentPage = 0; //Fields.Helpers.getPageIndexByPageId(that.survey.currentPage.id);
		$(that.piper).empty();
		if (!that.limit_to_page) {
			if (!that.noids) {
				$(that.piper).append($('<option/>', { value: '', html: gettext('Please select a question or variable...') }));
				this.idGroup = $('<optgroup/>', {
					label: gettext('Question IDs')
				}).appendTo(this.piper);

				var selector = chide.fs.Utils.buildSourceDropdown(this.survey.formatInfo(), {
					'showEmpty': true,
					'varPred': true,
					'questionPred': true,
					'pagePred': function pagePred(page) {
						return page.index == that.currentPage;
					},
					'showRowsAndColumns': true,
					'show3DVariables': true,
					'showMetas': false,
					'forceIndent': true
				});
				$(this.piper).append($(selector).children()[1]);
				$(this.piper)[0].selectedIndex = 0;
			} else {
				$(that.piper).append($('<option/>', { value: '', html: gettext('Please select a question or variable...') }));
			}
			this.pipedGroup = $('<optgroup/>', {
				label: gettext('Piped Variables')
			}).appendTo(this.piper);

			$.each(this.editor.survey.nameMapping, function (name, field) {
				j = 0;
				if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
					return;
				} else if (field.page.index == that.currentPage) {
					return;
				} else {
					if (field.isGrouped && field.type != 'drill-down' && field.type != 'net-promoter') {
						_.each(field.variables.value, function (el, i) {
							that.pipedGroup.append($('<option><\/option>').val("{{ " + name + '.' + j++ + " }}").append(field.name.get() + " :: " + field.variables.getAt(i) + ' Answer'));
						});
					} else {
						that.pipedGroup.append($('<option><\/option>').val("{{ " + name + " }}").append(field.name.get() + ' Answer'));
					}
				}
			});

			this.inviteGroup = $('<optgroup/>', {
				label: gettext('Invite Variables')
			}).appendTo(this.piper);

			this.inviteGroup.append($('<option>', { 'val': '{{ invite.first_name }}', 'text': gettext("Invite: First Name") }), $('<option>', { 'val': '{{ invite.last_name }}', 'text': gettext("Invite: Last Name") }), $('<option>', { 'val': '{{ invite.full_name }}', 'text': gettext("Invite: Full Name") }), $('<option>', { 'val': '{{ invite.email }}', 'text': gettext("Invite: E-Mail Address") }), $('<option>', { 'val': '{{ invite.code }}', 'text': gettext("Invite: Code") }));

			this.miscGroup = $('<optgroup/>', {
				label: gettext('Miscellaneous')
			}).appendTo(this.piper);

			this.miscGroup.append($('<option>', { 'val': "$('html').attr('lang')", 'text': gettext("Current Survey Language") }));
		} else {
			$(that.piper).append($('<option/>', { value: '', html: gettext('Please select a question or variable...') }));

			if (!that.noids) {
				this.idGroup = $('<optgroup/>', {
					label: gettext('Question IDs')
				}).appendTo(this.piper);
			}

			this.pipedGroup = $('<optgroup/>', {
				label: gettext('Piped Variables')
			}).appendTo(this.piper);

			$.each(this.editor.survey.nameMapping, function (name, field) {
				var j = 0;
				if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
					return;
				} else if (field.page.index == that.currentPage) {
					if (!that.noids) {
						that.idGroup.append($('<option><\/option>').val(field.id).append(field.name.get() + " ID"));
					} else {
						return;
					}
				} else {
					if (field.isGrouped && field.type != 'drill-down' && field.type != 'net-promoter') {
						_.each(field.variables.value, function (el, i) {
							that.pipedGroup.append($('<option><\/option>').val("{{ " + name + '.' + j++ + " }}").append(field.name.get() + " :: " + field.variables.getAt(i) + ' Answer'));
						});
					} else {
						that.pipedGroup.append($('<option><\/option>').val("{{ " + name + " }}").append(field.name.get() + ' Answer'));
					}
				}
			});
			this.inviteGroup = $('<optgroup/>', {
				label: gettext('Invite Variables')
			}).appendTo(this.piper);

			this.inviteGroup.append($('<option>', { 'val': '{{ invite.first_name }}', 'text': gettext("Invite: First Name") }), $('<option>', { 'val': '{{ invite.last_name }}', 'text': gettext("Invite: Last Name") }), $('<option>', { 'val': '{{ invite.full_name }}', 'text': gettext("Invite: Full Name") }), $('<option>', { 'val': '{{ invite.email }}', 'text': gettext("Invite: E-Mail Address") }), $('<option>', { 'val': '{{ invite.code }}', 'text': gettext("Invite: Code") }));
			this.miscGroup = $('<optgroup/>', {
				label: gettext('Miscellaneous')
			}).appendTo(this.piper);

			this.miscGroup.append($('<option>', { 'val': "$('html').attr('lang')", 'text': gettext("Current Survey Language") }));
		}
	},

	set: function set(scriptsettings) {
		var that = this;
		try {
			this.script = scriptsettings['field'].description['value'].replace('<script type="text/javascript">\n', '').replace('<script>\n', '').replace('<script type="text/javascript">', '').replace('<script>', '').replace('</script>', '');
		} catch (e) {
			this.script = this.default_script;
		}
		if (this.scriptEditor) {
			this.scriptEditor.toTextArea();
		}
		this.scriptEditor = CodeMirror.fromTextArea($('.script_area', scriptsettings['field'].element)[0], {
			theme: 'monokai',
			mode: 'javascript',
			lineNumbers: true,
			smartIndent: false
		});

		this.scriptEditor.on('change', function (editor) {
			var temp = editor.getValue();
			temp = temp.replace('<script type="text/javascript">\n', '').replace('<script>\n', '').replace('<script type="text/javascript">', '').replace('<script>', '').replace('</script>', '');
			scriptsettings['field'].description.set(temp);
		});
		this.scriptEditor.setValue(this.script);
		this.scriptEditor.clearHistory();

		this.update_piper(this.survey, scriptsettings['globalpiper'], scriptsettings['noids']);
	},

	serialize: function serialize() {
		var that = this;
		var result = {};

		return result;
	}
});

module.exports = Javascripter;

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Class = __webpack_require__(157);
var chide = __webpack_require__(230);
var Option = __webpack_require__(231).Option;

$.cloneObj = $.cloneObject = function (obj) {
	var clone = obj.constructor.toString().indexOf('Array') != -1 ? [] : {};
	for (var property in obj) {
		if (obj[property] && _typeof(obj[property]) == 'object') {
			clone[property] = $.cloneObject(obj[property]);
		} else {
			clone[property] = obj[property];
		}
	}
	return clone;
};

var Validation = $.klass(Option.Value, {
	label: gettext('Validation'),
	displayInline: true,

	validationTypes: [{
		type: 'email',
		label: gettext('Email'),
		showRange: false,
		showValueRange: false,
		showPrecision: false,
		showDomain: true,
		regex: '^.*$',
		errorMsg: {
			en: 'Invalid Email address.',
			fr: 'Adresse de courriel invalide.',
			trans: gettext('Invalid Email address.')
		}
	}, {
		type: 'num',
		label: gettext('Integers (Positive)'),
		showRange: true,
		showValueRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]*$',
		errorMsg: {
			en: 'This field can only consist of positive numbers.',
			fr: 'Ce champ ne peut contenir que des nombres positifs.',
			trans: gettext('This field can only consist of positive numbers.')
		}
	}, {
		type: 'pos-neg-num',
		label: gettext('Integers (Positive & Negative)'),
		showRange: true,
		showValueRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^-?[0-9]*$',
		errorMsg: {
			en: 'This field can only consist of numbers.',
			fr: 'Ce champ ne peut contenir que des nombres.',
			trans: gettext('This field can only consist of numbers.')
		}
	}, {
		type: 'float',
		label: gettext('Floating Point'),
		showRange: true,
		showPrecision: true,
		showDomain: false,
		regex: '^-{0,1}[0-9]*((\\.|,)?[0-9]+)?$',
		errorMsg: {
			en: 'This field can only consist of numbers and decimals.',
			fr: 'Ce champ ne peut contenir que des nombres et des décimales.',
			trans: gettext('This field can only consist of numbers and decimals.')
		}
	}, {
		type: 'alpha',
		label: gettext('Letters'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[À-ÿA-Za-z \\r\\n]*$',
		errorMsg: {
			en: 'This field can only consist of letters.',
			fr: 'Ce champ ne peut contenir que des lettres.',
			trans: gettext('This field can only consist of letters.')
		}
	}, {
		type: 'alphanum',
		label: gettext('Letters and Numbers'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^[À-ÿA-Za-z0-9 \\r\\n]*$',
		errorMsg: {
			en: 'This field can only consist of letters or numbers.',
			fr: 'Ce champ ne peut contenir que des lettres ou des nombres.',
			trans: gettext('This field can only consist of letters or numbers.')
		}
	}, {
		type: 'date-year',
		label: gettext('Date (YYYY/MM/DD)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^\\d{4}\\\/(0?[1-9]|1[012])\\\/(0?[1-9]|[12][0-9]|3[01])$',
		errorMsg: {
			en: 'This field can only be a date in the form YYYY/MM/DD.',
			fr: 'Ce champ doit contenir une date en forme AAAA/MM/JJ',
			trans: gettext('This field can only be a date in the form YYYY/MM/DD.')
		}
	}, {
		type: 'date-day',
		label: gettext('Date (DD/MM/YYYY)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^(0?[1-9]|[12][0-9]|3[01])\\\/(0?[1-9]|1[012])\\\/\\d{4}$',
		errorMsg: {
			en: 'This field can only be a date in the form DD/MM/YYYY.',
			fr: 'Ce champ doit contenir une date en forme JJ/MM/AAAA',
			trans: gettext('This field can only be a date in the form DD/MM/YYYY.')
		}
	}, {
		type: 'date-month',
		label: gettext('Date (MM/DD/YYYY)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^(0?[1-9]|1[012])\\\/(0?[1-9]|[12][0-9]|3[01])\\\/\\d{4}$',
		errorMsg: {
			en: 'This field can only be a date in the form MM/DD/YYYY.',
			fr: 'Ce champ doit contenir une date en forme MM/JJ/AAAA',
			trans: gettext('This field can only be a date in the form MM/DD/YYYY.')
		}
	}, {
		type: 'phoneint',
		label: gettext('Phone Number: International'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[+]*[0-9 \\-().]*$',
		errorMsg: {
			en: 'This field can only be a valid phone number.',
			fr: 'Ce champ ne peut contenir qu’un numéro de téléphone valide.',
			trans: gettext('This field can only be a valid phone number.')
		}
	}, {
		type: 'phone10',
		label: gettext('Phone Number: 10 digit'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
		errorMsg: {
			en: 'This field must be a 10 digit phone number in ###-###-#### format.',
			fr: 'Ce champ doit être un numéro de téléphone comprenant 10 caractères numériques dont le format est ###-###-####.',
			trans: gettext('This field must be a 10 digit phone number in ###-###-#### format.')
		}
	}, {
		type: 'phoneint-ext',
		label: gettext('Phone Number: International (Allow Extension)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^\\+?[0-9]{1,3}[0-9 \\-().]+?[0-9]$',
		errorMsg: {
			en: 'This field can only be a valid phone number, with extension in "-extension" format.',
			fr: 'Ce champ ne peut contenir qu’un numéro de téléphone valide.',
			trans: gettext('This field can only be a valid phone number.')
		}
	}, {
		type: 'phone10-ext',
		label: gettext('Phone Number: 10 digit (Allow Extension)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[0-9]{3}-[0-9]{3}-[0-9]{4}(-[0-9]{1,10})?$',
		errorMsg: {
			en: 'This field must be a 10 digit phone number with extension in 123-456-7890-extension format.',
			fr: 'Ce champ doit être un numéro de téléphone comprenant 10 caractères numériques et un numéro de poste dont le format est 123-456-7890-poste.',
			trans: 'This field must be a 10 digit phone number with extension in 123-456-7890-extension format.'
		}
	}, {
		type: 'uk-phone-number',
		label: gettext('Phone Number: United Kingdom'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^((\\+44)?)([ ]?)(0?)([0-9]{2,5})([ ]?)(([0-9]{3,4})?)([ ]?)([0-9]{4,6})$',
		errorMsg: {
			en: 'Must be in format +44 0xx(2-5 numbers) xxx(optional 3-4 numbers) xxxx(4-6 numbers)',
			fr: 'Ce champ doit être au format 44 0xx (2-5 chiffres) xxx (optionnels numéros 3-4) xxxx (4-6 chiffres)',
			trans: 'Must be in format +44 0xx(2-5 numbers) xxx(optional 3-4 numbers) xxxx(4-6 numbers)'
		}
	}, {
		type: 'uk-postal-code',
		label: gettext('Post Code (United Kingdom)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([A-Z][A-Z]?)(([0-9][0-9]?)|([0-9][A-Z]))[ ][0-9][A-Z][A-Z]$',
		errorMsg: {
			en: 'Must be in format [L-Letter N-Number]: LN NLL or LNN NLL or LLN NLL or LLNN NLL or LNL NLL or LLNL NLL',
			fr: 'Ce champ doit être au format [L-Lettre N-Nombre]: LN NLL ou LNN NLL NLL ou LLN ou LLNN NLL ou LNL NLL NLL ou LLNL',
			trans: 'Must be in format [L-Letter N-Number]: LN NLL or LNN NLL or LLN NLL or LLNN NLL or LNL NLL or LLNL NLL'
		}
	}, {
		type: 'postal',
		label: gettext('ZIP/Postal Code (US/Canada)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{1,5}|[A-Za-z][0-9][A-Za-z]\ ?[0-9][A-Za-z][0-9])$',
		errorMsg: {
			en: 'This field must be a valid zip code.',
			fr: 'Ce champ doit contenir un code zip valide.',
			trans: gettext('This field must be a valid zip code.')
		}
	}, {
		type: 'postal-ca',
		label: gettext('Postal Code (Canada)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[A-Za-z][0-9][A-Za-z]\ ?[0-9][A-Za-z][0-9]$',
		errorMsg: {
			en: 'This field must be a valid postal code.',
			fr: 'Ce champ doit contenir un code postal valide.',
			trans: gettext('This field must be a valid postal code.')
		}
	}, {
		type: 'postal-three-digit',
		label: gettext('Postal Code (Canada - First Three Digits)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^[A-Za-z][0-9][A-Za-z]$',
		errorMsg: {
			en: 'This field must be a valid 3-digit postal code.',
			fr: 'Ce champ doit être valide code postal de 3 chiffres',
			trans: gettext('This field must be a valid 3-digit postal code.')
		}
	}, {
		type: 'uniform-resource-locator',
		label: gettext('URL (web address)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '((https?://)|(HTTPS?://))((([A-Za-z0-9\\-]+)(\\.{1}))+)?([A-Za-z0-9\\-])+(\\.{1})([A-Za-z0-9]{2,4})',
		errorMsg: {
			en: 'This field must be a valid URL',
			fr: 'Ce champ doit être une URL valide',
			trans: gettext('This field must be a valid URL')
		}
	}, {
		type: 'domain-validation',
		label: gettext('Domain (web address with no path)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '((https?://)|(HTTPS?://))?((([A-Za-z0-9\\-]+)(\\.{1}))+)?([A-Za-z0-9\\-])+(\\.{1})([A-Za-z0-9]{2,4})$',
		errorMsg: {
			en: 'This field must be a valid Domain',
			fr: 'Ce champ doit être un nom de demaine valide',
			trans: gettext('This field must be a valid Domain')
		}
	}, {
		type: 'postal-us',
		label: gettext('ZIP Code (US)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{5})$|^([0-9]{5}-[0-9]{4})$',
		errorMsg: {
			en: 'This field must be a valid postal code.',
			fr: 'Ce champ doit contenir un code postal valide.',
			trans: gettext('This field must be a valid postal code.')
		}
	}, {
		type: 'ssn-us',
		label: gettext('Social Security Number (US)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{3}-?[0-9]{2}-?[0-9]{4})$',
		errorMsg: {
			en: 'This field must be a valid social security number.',
			trans: gettext('This field must be a valid social security number.')
		}
	}, {
		type: 'ssn-can',
		label: gettext('Social Insurance Number (Canada)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		regex: '^([0-9]{3}-?[0-9]{3}-?[0-9]{3})$',
		errorMsg: {
			en: 'This field must be a valid social insurance number.',
			trans: gettext('This field must be a valid social insurance number.')
		}
	}, {
		type: 'currency',
		label: gettext('Currency (Dollar)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		hasDollar: true,
		regex: '(^-?[\\$]?\\d+((,|\\s)?\\d{3})*((\\.|,)[0-9]{1,2})?[\\$]?$)',
		errorMsg: {
			en: 'This field must be a numerical amount in dollars with optional cents.',
			fr: 'Ce champ doit être un montant en dollars pour lequel les cents sont facultatifs.',
			trans: gettext('This field must be a numerical amount in dollars with optional cents.')
		}
	}, {
		type: 'currency-euro',
		label: gettext('Currency (Euro)'),
		showRange: false,
		showPrecision: false,
		showDomain: false,
		hasEuro: true,
		regex: '(^€?\\d+((,|\\s)?\\d{3})*((,)[0-9]{1,2})?€?$)',
		errorMsg: {
			en: 'This field must be a numerical amount in euro with optional cents.',
			fr: 'Ce champ doit être un montant en euro pour lequel les cents sont facultatifs.',
			trans: gettext('This field must be a numerical amount in euros with optional cents.')
		}
	}, {
		type: 'percentage-bound',
		label: gettext('Percentage (0-100)'),
		showRange: false,
		showPrecision: true,
		showDomain: false,
		hasPercentage: true,
		regex: '^((([0-9][0-9]?)([\.,][0-9]*)?)|100)\\%?$',
		errorMsg: {
			en: 'This field must be a percentage between 0-100.',
			fr: 'Ce champ doit être un pourcentage se situant entre 0 et 100.',
			trans: gettext('This field must be a percentage between 0-100.')
		}
	}, {
		type: 'percentage-unbound',
		label: gettext('Percentage (Unbound)'),
		showRange: false,
		showPrecision: true,
		showDomain: false,
		hasPercentage: true,
		regex: '^(\\%)?[0-9]*([\.,][0-9]*)?(\\%)?$',
		errorMsg: {
			en: 'This field can only consist of numbers.',
			fr: 'Ce champ ne peut contenir que des nombres.',
			trans: gettext('This field can only consist of numbers.')
		}
	}, {
		type: 'wordCount',
		label: gettext('Word Limits'),
		showRange: false,
		showWordRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^.*$',
		errorMsg: {
			en: 'This value must be between {min} and {max} words.',
			fr: 'Cette valeur doit être comprise entre {min} et {max} môts.',
			trans: gettext('This value must be between {min} and {max} words.')
		}
	}, {
		type: 'all',
		label: gettext('All Characters'),
		showRange: true,
		showPrecision: false,
		showDomain: false,
		regex: '^.*$',
		errorMsg: {
			en: 'Invalid entry.',
			fr: 'Entrée incorrecte.',
			trans: gettext('Invalid entry.')
		}
	}],

	initialize: function initialize($super, field, config) {
		var that = this;

		$super(field, config);

		if (!this.value) {
			this.value = {
				errorMsg: {
					en: 'Invalid entry.'
				}
			};
		}

		this.lengthRange = new Validation.Range({
			field: field,
			value: this.value,
			keys: { min: 'minLength', max: 'maxLength' }
		});

		this.wordRange = new Validation.Range({
			field: field,
			value: this.value,
			format: gettext('{0} - {1} words'),
			keys: { min: 'minWords', max: 'maxWords' }
		});

		this.valueRange = new Validation.Range({
			field: field,
			value: this.value,
			label: gettext('Limit Value'),
			format: gettext('Between') + ' {0} - {1}',
			keys: { min: 'minValue', max: 'maxValue' }
		});

		this.errorMessage = new chide.opts.Text({
			field: this,
			inputClass: "text short",
			label: gettext('Current Count'),
			help: gettext('Error Message - In order to override default error messages for min/max validation, include {min} and {max} in your error message.'),
			value: this.value.errorMsg,
			changed: function changed(value) {
				this.field.value.errorMsg = this.value;
			}
		});

		this.verEmailDomain = new chide.opts.Checkbox({
			field: this,
			label: gettext('Verify Email Domain'),
			value: this.value.verifydomain,
			changed: function changed(value) {
				this.field.value.verifydomain = value;
			}
		});

		this.precision = new chide.opts.Number({
			field: this,
			label: gettext('Precision'),
			value: this.value.precision || 3,
			min: 0,
			max: 100,
			type: 'int',
			changed: function changed(value) {
				that.value.precision = value;
			}
		});
	},

	getType: function getType(type) {
		for (var i = 0; i < this.validationTypes.length; i++) {
			if (this.validationTypes[i].type == type) {
				return $.cloneObj(this.validationTypes[i]);
			}
		}
		return {};
	},

	render: function render($super) {
		var that = this;

		var lengthRangeDisplay = this.lengthRange.render();
		var valueRangeDisplay = this.valueRange.render();
		var precisionDisplay = this.precision.render();
		var domainDisplay = this.verEmailDomain.render();
		var wordRangeDisplay = this.wordRange.render();

		var errorMsg = this.errorMessage.render();

		var validationSelect = $('<select class="custom-select custom-select-sm"><option value="none">' + gettext('None') + '<\/option><\/select>').css('width', '145px');

		var validationDetails = $('<div><\/div>').append(lengthRangeDisplay).append(valueRangeDisplay).append(domainDisplay).append(precisionDisplay).append(errorMsg).append(wordRangeDisplay);

		_.each(this.validationTypes, function (el) {
			validationSelect.append($.format('<option value="{0}">{1}<\/option>', [el.type, el.label]));
		});

		if (this.getType(this.value.type).showRange) {
			lengthRangeDisplay.show();
		} else {
			lengthRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showWordRange) {
			wordRangeDisplay.show();
		} else {
			wordRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showValueRange) {
			valueRangeDisplay.show();
		} else {
			valueRangeDisplay.hide();
		}

		if (this.getType(this.value.type).showDomain) {
			domainDisplay.show();
		} else {
			domainDisplay.hide();
		}

		if (this.getType(this.value.type).showPrecision) {
			precisionDisplay.show();
		} else {
			precisionDisplay.hide();
		}

		validationSelect.val(this.value && this.value.type ? this.value.type : '').change(function (e) {
			if (that.field.prefix) {
				that.field.prefix.empty();
			}
			if (that.field.suffix) {
				that.field.suffix.empty();
			}

			that.value.type = $(this).val();

			that.errorMessage.set(that.value.errorMsg = that.getType(this.value).errorMsg);

			if ($(this).val() == 'none') {
				validationDetails.fadeOut();
				errorMsg.fadeOut();
				that.value = { type: 'none' };
			} else {
				validationDetails.fadeIn();
				errorMsg.fadeIn();

				var entry = that.getType(this.value);

				if (entry.showRange) {
					var inputs = $(lengthRangeDisplay).find('input');
					that.value['minLength'] = inputs[0].value;
					that.value['maxLength'] = inputs[1].value;
					lengthRangeDisplay.show();
				} else {
					lengthRangeDisplay.hide();
					delete that.value['minLength'];
					delete that.value['maxLength'];
				}

				if (entry.showValueRange) {
					valueRangeDisplay.show();
				} else {
					valueRangeDisplay.hide();
					delete that.value['minValue'];
					delete that.value['maxValue'];
				}

				if (entry.showWordRange) {
					wordRangeDisplay.show();
				} else {
					wordRangeDisplay.hide();
				}

				if (entry.showDomain) {
					domainDisplay.show();
				} else {
					domainDisplay.hide();
				}

				if (entry.showPrecision) {
					precisionDisplay.show();
					that.value.precision = that.precision.value;
				} else {
					precisionDisplay.hide();
					delete that.value.precision;
				}

				that.value.regex = entry.regex;
				that.value.errorMsg = entry.errorMsg;
				that.errorMessage.set(entry.errorMsg);

				if (entry.hasDollar && that.field.prefix) {
					that.field.prefix.text(' $ ');
				}
				if (entry.hasEuro && that.field.prefix) {
					that.field.prefix.text(' € ');
				}
				if (entry.hasPercentage && that.field.suffix) {
					that.field.suffix.text(' % ');
				}
			}
		});

		validationDetails.css('margin-top', '0');

		if (!this.value || !this.value.type || this.value.type == "none") {
			validationDetails.css('display', 'none');
			errorMsg.css('display', 'none');
		}

		if (this.getType(this.value.type).hasDollar && this.field.prefix) {
			this.field.prefix.text(' $ ');
		}
		if (this.getType(this.value.type).hasEuro && this.field.prefix) {
			this.field.prefix.text(' € ');
		}
		if (this.getType(this.value.type).hasPercentage && this.field.suffix) {
			this.field.suffix.text(' % ');
		}

		var result = $super().addClass('validation col-sm-12');

		if (this.displayInline) {
			result.append("<strong class='inline'>" + this.label + "</strong>");
			validationSelect.css('margin-bottom', '0');
		}

		result.append(validationSelect);
		result.append(validationDetails);
		return result;
	},

	get: function get() {
		return $.extend({}, this.value, {
			minLength: this.lengthRange.value[0],
			maxLength: this.lengthRange.value[1]
		});
	}
});

Validation.Range = Class.create(chide.opts.Value, {
	label: gettext('Limit length:'),
	format: gettext("{0} - {1} characters"),
	config: { type: 'int', inputClass: 'text number', size: 1 },
	keys: { min: 0, max: 1 },
	render: function render($super) {
		var that = this;
		this.minLength = new chide.opts.Number($.extend({}, this.config, { field: this,
			value: that.value[that.keys.min] || undefined,
			max: parseInt(that.value[that.keys.max]) || null,
			changed: function changed(val) {
				that.maxLength.min = val;
				that.value[that.keys.min] = val;
			}
		}));
		this.maxLength = new chide.opts.Number($.extend({}, this.config, { field: this,
			value: that.value[that.keys.max] || undefined,
			min: parseInt(that.value[that.keys.min]) || null,
			changed: function changed(val) {
				that.value[that.keys.max] = val;
				that.minLength.max = val;
			}
		}));
		var minEl = this.minLength.render().find('input');
		var maxEl = this.maxLength.render().find('input');
		var rendered = $super().append(this.format.replace('{0}', '<span class="min" />').replace('{1}', '<span class="max" />')).find('span.min').replaceWith(minEl).end().find('span.max').replaceWith(maxEl).end();
		return rendered;
	}
});

Validation.Restriction = Class.create(chide.opts.Checkbox, {
	label: gettext('Restrict number of selected choices'),
	help: gettext('Restrict number of selected choices - Check this option if you would like to specify the range of choices that must be selected for this question.'),

	options: {
		range: Class.create(Validation.Range, {
			label: '',
			format: gettext('{0} and {1} choices'),
			optionClass: 'opt inline'
		}),

		errorMsg: Class.create(chide.opts.Text, {
			label: gettext('Error message:'),
			inputClass: 'text short',
			initialValue: gettext('Invalid entry.')
		})
	},

	initialize: function initialize($super, config) {
		$super(config);

		var range = this.value ? this.value : [undefined, undefined];

		this.value = !!this.value;

		this.range = new this.options.range({ value: range });
		this.errorMsg = new this.options.errorMsg({ value: config.errorMsg || undefined });
	},

	render: function render($super) {
		var that = this;

		var range = $('<span/>').append(this.range.render().unwrap());
		var errorMsg = this.errorMsg.render();

		var subs = range.add(errorMsg);

		var rendered = $super().append(range, errorMsg).bind('changed', function (e, value) {
			$('span.label', rendered).text(value ? gettext('Restrict to between') : that.label);
			if (value) {
				$('a.help', rendered).hide();
			} else {
				$('a.help', rendered).show();
			}
			subs.toggle(value);
		});
		this.set(this.value);

		return rendered;
	},

	serialize: function serialize() {
		return this.value ? $.extend({}, {
			minChecked: this.range.value[0],
			maxChecked: this.range.value[1]
		}) : undefined;
	}
});

module.exports = Validation;

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _FileUploadField = __webpack_require__(1205);

var _FileUploadField2 = _interopRequireDefault(_FileUploadField);

var _FileUploadOptions = __webpack_require__(2355);

var _FileUploadOptions2 = _interopRequireDefault(_FileUploadOptions);

var _baseField = __webpack_require__(1203);

var _baseField2 = _interopRequireDefault(_baseField);

var _value = __webpack_require__(1206);

var _value2 = _interopRequireDefault(_value);

var _variable = __webpack_require__(1204);

var _variable2 = _interopRequireDefault(_variable);

var _configuration = __webpack_require__(845);

var _configuration2 = _interopRequireDefault(_configuration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UploadField = $.klass(_baseField2.default.Field, {
	type: 'file-upload',
	qlass: 'upload-field',
	cssType: 'upload-field',
	displayName: gettext('File Upload'),
	isEnabled: true,
	isVisible: true,
	isCustom: true,

	// Initialize with default configurations
	config: {
		allowMultiple: _configuration2.default.defaults.allowMultiple,
		limitUploads: _configuration2.default.defaults.limitUploads,
		limitFileFormat: _configuration2.default.defaults.limitFileFormat,
		includeDescription: _configuration2.default.defaults.includeDescription,
		min: _configuration2.default.defaults.minFiles,
		max: _configuration2.default.defaults.maxFiles,
		maxFileSize: _configuration2.default.defaults.maxFileSize,
		fileFormats: _configuration2.default.defaults.fileFormats,
		required: _configuration2.default.defaults.required
	},

	initialize: function initialize($super, info, editor) {
		var config = info || {};
		$super(config, editor);

		// Set default values on initialize (seems that .klass lowepro stuff copies instances :\)
		this.config = {
			allowMultiple: _configuration2.default.defaults.allowMultiple,
			limitUploads: _configuration2.default.defaults.limitUploads,
			limitFileFormat: _configuration2.default.defaults.limitFileFormat,
			includeDescription: _configuration2.default.defaults.includeDescription,
			min: _configuration2.default.defaults.minFiles,
			max: _configuration2.default.defaults.maxFiles,
			maxFileSize: _configuration2.default.defaults.maxFileSize,
			fileFormats: _configuration2.default.defaults.fileFormats,
			required: _configuration2.default.defaults.required
		}, this.deserialize(config);
		this.input = $('<div class="file-upload"></div>');
	},

	render: function render($super) {
		$super();
		this.element.append(this.input);
		var element = React.createElement(_FileUploadField2.default, _extends({}, this.config, {
			required: !this.optional.value,
			appendToPrevious: this.appendToPrevious,
			disabled: true // Field is always disabled on the survey builder
		}));
		_reactDom2.default.render(element, this.input[0]);
	},

	showOptions: function showOptions($super, options) {
		var _this = this;

		$super(options);
		var handleValueChange = function handleValueChange(state) {
			_this.optional = state.optional;
			_this.appendToPrevious = state.appendToPrevious;
			_this.description = state.description;
			_this.title = state.title;
			_this.name = state.name;
			Object.keys(_this.config).forEach(function (field) {
				_this.config[field] = state[field];
			});
			_this.render();
		};

		var element = React.createElement(_FileUploadOptions2.default, _extends({}, this.config, {
			optional: this.optional,
			appendToPrevious: this.appendToPrevious,
			handleValueChange: handleValueChange,
			title: this.title,
			description: this.description,
			name: this.name
		}));
		_reactDom2.default.render(element, options[0]);
	},

	serialize: function serialize($super) {
		/**
   * Super will take care of serializing:
   * - appendToPrevious
   * - description
   * - id
   * - idname
   * - name
   * - title
   * - type
   * - width
   * */
		var info = $super();
		info.children = [{
			type: this.type,
			maxFileSize: this.config.maxFileSize,
			includeDescription: this.config.includeDescription
		}];

		if (this.optional.value) {
			info.children[0].required = false;
		} else {
			info.children[0].required = true;
		}

		if (this.config.allowMultiple) {
			info.children[0]['allowMultiple'] = true;
			if (this.config.limitUploads) {
				info.children[0]['limitUploads'] = true;
				info.children[0]['min'] = this.config.min;
				info.children[0]['max'] = this.config.max;
			}
		}
		if (this.config.limitFileFormat) {
			info.children[0]['limitFileFormat'] = true;
			info.children[0]['fileFormats'] = this.config.fileFormats;
		}
		return info;
	},

	deserialize: function deserialize(info) {
		var _this2 = this;

		// Default values
		var optional = false;
		var appendToPrevious = false;

		var config = void 0;
		if (info) {
			if (info.appendToPrevious) {
				appendToPrevious = info.appendToPrevious;
			}
			if (info.children && info.children.length) {
				config = info.children[0];
			}
		}

		if (config) {
			// Deal with params outside of config (that make it into the super Field class)
			if (config.required !== undefined) {
				optional = !info.children[0].required;
			} else {
				optional = true;
			}
			delete config.optional;
			delete config.type;

			// Remaining are field specific configuration
			Object.keys(config).forEach(function (field) {
				_this2.config[field] = config[field];
			});
		}

		this.optional = new _value2.default(optional);
		this.appendToPrevious = new _value2.default(appendToPrevious);
	},

	getVariables: function getVariables() {
		return [new _variable2.default.File({
			id: this.id,
			label: this.getIdentifier()
		})];
	}
});

module.exports = UploadField;

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileInput = __webpack_require__(2351);

var _FileInput2 = _interopRequireDefault(_FileInput);

var _ActionMenu = __webpack_require__(2352);

var _ActionMenu2 = _interopRequireDefault(_ActionMenu);

var _FileNameInput = __webpack_require__(2353);

var _FileNameInput2 = _interopRequireDefault(_FileNameInput);

var _ads = __webpack_require__(57);

var _wdsIcons = __webpack_require__(32);

var _wdsReact = __webpack_require__(9);

var _FileUploadField = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This is the component that will contain individual files or the button to
 * add more file.
 *
 * The file input and button to add another file is in here since in the end,
 * we need the inputs to contain the file, even if they are not shown.
 *
 * @export
 * @class FileField
 * @extends {Component}
 */
var FileField = function (_Component) {
	_inherits(FileField, _Component);

	function FileField(props) {
		_classCallCheck(this, FileField);

		var _this = _possibleConstructorReturn(this, (FileField.__proto__ || Object.getPrototypeOf(FileField)).call(this, props));

		_this.state = {
			id: props.id + '_' + props.index,
			showErrorModal: false,
			errors: ''
		};

		_this.handleFileInputChange = _this.handleFileInputChange.bind(_this);
		_this.handleInputChange = _this.handleInputChange.bind(_this);
		return _this;
	}

	_createClass(FileField, [{
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			this.props.handleInputChange(this.props.index, event);
		}
	}, {
		key: 'handleFileInputChange',
		value: function handleFileInputChange(event) {
			if (event.target.files) {
				var _event$target$files$ = event.target.files[0],
				    name = _event$target$files$.name,
				    size = _event$target$files$.size,
				    type = _event$target$files$.type;

				var added = this.props.addFileToList(this.props.index, name, size, type);
				this.props.notifyApply(this.props.id, this.props.hasFile);
				if (!added) {
					event.target.value = '';
				}
			}
		}
	}, {
		key: 'render',
		value: function render(config) {
			var _this2 = this;

			for (var key in config) {
				this.props[key] = config[key];
			}
			return _react2.default.createElement(
				_react2.default.Fragment,
				{
					key: this.props.index
				},
				this.props.hasFile && _react2.default.createElement(
					'li',
					{
						style: _FileUploadField.fileFieldList
					},
					_react2.default.createElement(
						'div',
						{
							style: _FileUploadField.fileUploadSelector
						},
						_react2.default.createElement(_FileNameInput2.default, {
							type: 'text',
							name: this.state.id + '-name',
							id: this.state.id + '-name',
							fileName: this.props.fileName
						}),
						_react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(_ActionMenu2.default, {
								index: this.props.index,
								fileName: this.props.fileName,
								filePath: this.props.file,
								convertedFilePath: this.props.converted,
								handleFileDelete: this.props.handleFileDelete,
								mediaUrl: this.props.mediaUrl
							})
						),
						!this.props.file && _react2.default.createElement(
							'span',
							{ className: 'unsaved-file-info' },
							_react2.default.createElement(
								_wdsReact.Popout,
								{ trigger: _react2.default.createElement(_wdsIcons.IconInfo, null) },
								_react2.default.createElement(
									_wdsReact.PopoutBody,
									null,
									gettext('This file will not be uploaded until you save or ' + 'submit this form.')
								)
							)
						),
						this.props.includeDescription && this.props.hasFile && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ style: _FileUploadField.fileDescription },
								_react2.default.createElement(
									'label',
									{
										htmlFor: this.state.id + '-description'
									},
									gettext('Description'),
									' :'
								),
								_react2.default.createElement(_ads.Textarea, {
									strings: {
										charactersEntered: gettext('Characters Entered: '),
										maximum: gettext('Maximum:')
									},
									characterCount: true,
									characterLimit: '255',
									className: 'form-control',
									style: _FileUploadField.fileDescriptionTextarea,
									name: this.state.id + '-description',
									id: this.state.id + '-description',
									stretched: true,
									value: this.props.fileDescription
								})
							)
						)
					)
				),
				this.state.errors && _react2.default.createElement(
					'p',
					{ className: 'error' },
					this.state.errors
				),
				_react2.default.createElement(_FileInput2.default, {
					id: this.state.id + '-file',
					index: this.props.index,
					disabled: this.props.disabled,
					handleFileInputChange: function handleFileInputChange(event) {
						_this2.handleFileInputChange(event);
					},
					limitFileFormat: this.props.limitFileFormat,
					fileFormats: this.props.fileFormats,
					hasFile: this.props.hasFile,
					first: this.props.first
				})
			);
		}
	}]);

	return FileField;
}(_react.Component);

exports.default = FileField;


FileField.propTypes = {
	id: _propTypes2.default.string.isRequired,
	disabled: _propTypes2.default.bool.isRequired,
	fileFormats: _propTypes2.default.string.isRequired,
	limitFileFormat: _propTypes2.default.bool.isRequired,
	includeDescription: _propTypes2.default.bool.isRequired,
	addFileToList: _propTypes2.default.func.isRequired,
	index: _propTypes2.default.number.isRequired,
	mediaUrl: _propTypes2.default.string.isRequired,
	handleFileView: _propTypes2.default.func,
	handleFileDelete: _propTypes2.default.func,
	handleFileDownload: _propTypes2.default.func,
	fileName: _propTypes2.default.string,
	fileDescription: _propTypes2.default.string,
	file: _propTypes2.default.string,
	fileSize: _propTypes2.default.number,
	hasFile: _propTypes2.default.bool
};

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileUploadField = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileInput = function (_Component) {
	_inherits(FileInput, _Component);

	function FileInput() {
		_classCallCheck(this, FileInput);

		return _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).apply(this, arguments));
	}

	_createClass(FileInput, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ style: (0, _FileUploadField.displayWithFile)(this.props.hasFile) },
					_react2.default.createElement(
						'label',
						{
							style: _FileUploadField.fileUploadButton,
							className: 'wds-button wds-button--secondary\n\t\t\t\t\t\t\twds-button--solid wds-button--md ' + (this.props.disabled ? 'disabled' : '')
						},
						_react2.default.createElement('i', {
							className: 'nc-icon-mini arrows-2_square-upload',
							style: _FileUploadField.fileUploadButtonIcon
						}),
						this.props.first ? gettext('Upload a file') : gettext('Upload another file'),
						_react2.default.createElement('input', {
							id: this.props.id,
							name: this.props.id,
							type: 'file',
							disabled: this.props.disabled,
							style: _FileUploadField.fileInput,
							onChange: this.props.handleFileInputChange,
							accept: this.props.limitFileFormat ? this.props.fileFormats : ''
						})
					),
					this.props.limitFileFormat && _react2.default.createElement(
						'div',
						{ style: _FileUploadField.acceptedFormats },
						_react2.default.createElement(
							'strong',
							null,
							gettext('Accepted formats'),
							':'
						),
						' ',
						this.props.fileFormats
					)
				)
			);
		}
	}]);

	return FileInput;
}(_react.Component);

exports.default = FileInput;


FileInput.propTypes = {
	id: _propTypes2.default.string.isRequired,
	index: _propTypes2.default.number.isRequired,
	disabled: _propTypes2.default.bool.isRequired,
	handleFileInputChange: _propTypes2.default.func.isRequired,
	limitFileFormat: _propTypes2.default.bool.isRequired,
	fileFormats: _propTypes2.default.string,
	hasFile: _propTypes2.default.bool
};

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = ActionMenu;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _wdsIcons = __webpack_require__(32);

var _wdsReact = __webpack_require__(9);

var _file_previewer = __webpack_require__(226);

var _file_previewer2 = _interopRequireDefault(_file_previewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ActionMenu(props) {
	var handleViewClick = function handleViewClick() {
		var file = {
			url: '' + props.mediaUrl + props.filePath,
			type: 'file',
			name: props.fileName
		};
		if (props.convertedFilePath) {
			file['converted_url'] = '' + props.mediaUrl + props.convertedFilePath;
		}
		var config = {
			files: [file]
		};

		new _file_previewer2.default(config);
	};

	var handleDeleteClick = function handleDeleteClick() {
		props.handleFileDelete(props.index, props.filePath);
	};

	var menuTrigger = _react2.default.createElement(
		_wdsReact.Button,
		{
			color: 'secondary',
			icon: 'only',
			buttonType: 'button'
		},
		_react2.default.createElement(_wdsIcons.IconMore, null)
	);

	var menuItems = _react2.default.createElement(
		_react.Fragment,
		null,
		props.filePath && _react2.default.createElement(
			_react.Fragment,
			null,
			_react2.default.createElement(
				_wdsReact.MenuItem,
				{ onClick: handleViewClick },
				gettext('View')
			),
			_react2.default.createElement(
				_wdsReact.MenuItem,
				{
					navigationTarget: '' + props.mediaUrl + props.filePath,
					isNavigable: true,
					download: true
				},
				gettext('Download')
			)
		),
		_react2.default.createElement(
			_wdsReact.MenuItem,
			{ onClick: handleDeleteClick },
			gettext('Delete')
		)
	);

	return _react2.default.createElement(
		_react.Fragment,
		null,
		_react2.default.createElement(
			_wdsReact.Menu,
			{
				autoClose: 'false',
				dense: true,
				noRules: true,
				menuTrigger: menuTrigger
			},
			menuItems
		)
	);
}

ActionMenu.propTypes = {
	index: _propTypes.PropTypes.number.isRequired,
	mediaUrl: _propTypes.PropTypes.string.isRequired,
	handleFileView: _propTypes.PropTypes.func,
	handleFileDelete: _propTypes.PropTypes.func,
	handleFileDownload: _propTypes.PropTypes.func,
	filePath: _propTypes.PropTypes.string,
	convertedFilePath: _propTypes.PropTypes.string,
	fileName: _propTypes.PropTypes.string
};

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileUploadField = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Abstracts the file name display.
 *
 * @export
 * @class FileNameInput
 * @extends {Component}
 */
var FileNameInput = function (_Component) {
	_inherits(FileNameInput, _Component);

	function FileNameInput(props) {
		_classCallCheck(this, FileNameInput);

		var _this = _possibleConstructorReturn(this, (FileNameInput.__proto__ || Object.getPrototypeOf(FileNameInput)).call(this, props));

		var parts = _this.props.fileName.split('.');
		var extension = void 0;
		var name = void 0;
		if (parts.length > 1) {
			extension = parts.pop();
			name = parts.join('.');
		} else {
			extension = '';
			name = _this.props.fileName;
		}
		_this.state = {
			name: name,
			extension: extension,
			fullName: name + '.' + extension
		};

		_this.handleChange = _this.handleChange.bind(_this);
		return _this;
	}

	_createClass(FileNameInput, [{
		key: 'handleChange',
		value: function handleChange(event) {
			var value = event.target.value;

			this.setState({
				name: value,
				fullName: value + '.' + this.state.extension
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement('input', {
					style: _FileUploadField.fileNameInput,
					type: 'text',
					className: 'form-control',
					name: this.props.name + '_edit',
					id: this.props.id + '_edit',
					value: this.state.name,
					onChange: this.handleChange
				}),
				_react2.default.createElement('input', {
					type: 'hidden',
					name: this.props.name,
					id: this.props.id,
					value: this.state.fullName
				}),
				_react2.default.createElement(
					'span',
					{ className: 'file-extension' },
					'.',
					this.state.extension
				)
			);
		}
	}]);

	return FileNameInput;
}(_react.Component);

exports.default = FileNameInput;


FileNameInput.propTypes = {
	name: _propTypes2.default.string.isRequired,
	id: _propTypes2.default.string.isRequired,
	fileName: _propTypes2.default.string.isRequired
};

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _smapplyUi = __webpack_require__(28);

var _modals = __webpack_require__(6);

var _Checkbox = __webpack_require__(2356);

var _HtmlTextarea = __webpack_require__(2357);

var _HtmlTextarea2 = _interopRequireDefault(_HtmlTextarea);

var _InlineText = __webpack_require__(2358);

var _InlineText2 = _interopRequireDefault(_InlineText);

var _configuration = __webpack_require__(845);

var _configuration2 = _interopRequireDefault(_configuration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noneStyle = {
	display: 'none'
};

var FileUploadOptions = function (_React$Component) {
	_inherits(FileUploadOptions, _React$Component);

	function FileUploadOptions(props) {
		_classCallCheck(this, FileUploadOptions);

		var _this = _possibleConstructorReturn(this, (FileUploadOptions.__proto__ || Object.getPrototypeOf(FileUploadOptions)).call(this, props));

		_this.switchingFileFormats = false;

		_this.state = {
			name: props.name,
			title: props.title,
			description: props.description,
			allowMultiple: props.allowMultiple,
			appendToPrevious: props.appendToPrevious,
			fileFormats: props.fileFormats,
			includeDescription: props.includeDescription,
			limitUploads: props.limitUploads,
			limitFileFormat: props.limitFileFormat,
			max: props.max,
			maxFileSize: props.maxFileSize,
			min: props.min,
			optional: props.optional,
			formErrors: {
				minFiles: '',
				maxFiles: '',
				maxFileSize: '',
				fileFormats: ''
			}
		};

		_this.fileExtensionTextarea = React.createRef();

		_this.handleInputChange = _this.handleInputChange.bind(_this);
		_this.handleNumberInputChange = _this.handleNumberInputChange.bind(_this);
		_this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
		_this.hideOptionGroup = _this.toggleOptionGroup.bind(_this);
		_this.preventEmptyFileFormats = _this.preventEmptyFileFormats.bind(_this);
		_this.handleMouseDownOnSwitch = _this.handleMouseDownOnSwitch.bind(_this);
		return _this;
	}

	_createClass(FileUploadOptions, [{
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var _setState,
			    _this2 = this;

			var _event$target = event.target,
			    value = _event$target.value,
			    name = _event$target.name;
			var min = this.state.min;

			if (name === 'optional') {
				if (value.value) {
					// Question is optional, min should be 0 and disabled
					min = 0;
				} else {
					// Question is required, min has to be greater or equal to 1
					if (min < 1) {
						min = 1;
					}
				}
			}

			this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'min', min), _setState), _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var valid;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return _this2.validateField(name, value);

							case 2:
								valid = _context.sent;

								if (valid) {
									_this2.props.handleValueChange(_this2.state);
								}

							case 4:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2);
			})));
		}
	}, {
		key: 'handleNumberInputChange',
		value: function handleNumberInputChange(event) {
			var _this3 = this;

			var name = event.target.name;
			var value = event.target.value;


			value = parseInt(value);
			var updateValue = value;
			if (isNaN(value)) {
				// Allow the user to erase data
				updateValue = '';
			}
			this.setState(_defineProperty({}, name, updateValue), _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				var valid;
				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_context2.next = 2;
								return _this3.validateField(name, value);

							case 2:
								valid = _context2.sent;

								if (valid) {
									_this3.props.handleValueChange(_this3.state);
								}

							case 4:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this3);
			})));
		}

		/**
   * Will handle the change events from checkboxes
   *
   * @param {Event} event
   * @memberof FileUploadOptions
   */

	}, {
		key: 'handleCheckboxChange',
		value: function handleCheckboxChange(event) {
			var _this4 = this;

			var _event$target2 = event.target,
			    checked = _event$target2.checked,
			    name = _event$target2.name;


			this.setState(_defineProperty({}, name, checked), function () {
				if (name === 'limitFileFormat') {
					if (checked === true) {
						_this4.fileExtensionTextarea.current.focus();
					} else {
						// If un-checked, remove errors
						_this4.state.formErrors.fileFormats = '';
					}
				}
				_this4.props.handleValueChange(_this4.state);
			});
		}

		/**
   * This function will handle toggling (expanding - minimizing) an option group.
   * In theory this would be generalized into another React Component, but there
   * exists similar components (cards / accordion) in WDS and smapply-ui.  Since
   * these libaries aren't used and don't match the styles of the form builder this
   * will live here until we migrate to those libraries / UIs.
   *
   * @param {*} event
   * @memberof FileUploadOptions
   */

	}, {
		key: 'toggleOptionGroup',
		value: function toggleOptionGroup(event) {
			var optionGroup = event.target.parentElement.parentElement;
			var optionGroupContent = event.target.parentElement.nextSibling;
			var expand = void 0;

			if (optionGroup.classList.contains('collapsed')) {
				expand = true;
			} else {
				expand = false;
			}

			if (expand) {
				optionGroup.classList.remove('collapsed');
				optionGroupContent.style.display = 'unset';
			} else {
				optionGroup.classList.add('collapsed');
				optionGroupContent.style.display = 'none';
			}
		}
	}, {
		key: 'validateField',
		value: function validateField(name, value) {
			var _this5 = this;

			var fieldValidationErrors = this.state.formErrors;
			var validateMin = function validateMin(minValue) {
				var valid = true;
				// min must be greater than 0 (or 1 if required) and smaller or equal to max
				var absoluteMin = 0;
				if (_this5.state.allowMultiple && _this5.state.limitUploads && !_this5.state.optional.value) {
					absoluteMin = 1;
				}
				if (isNaN(minValue)) {
					valid = false;
					fieldValidationErrors.minFiles = gettext('Minimum value must be a number and cannot be blank');
				} else if (minValue < absoluteMin || minValue > _this5.state.max) {
					valid = false;
					fieldValidationErrors.minFiles = interpolate(gettext('Minimum value must be greater or equal to %(absoluteMin)s and smaller or equal to maximum'), { absoluteMin: absoluteMin }, true);
				} else {
					// Remove the error
					fieldValidationErrors.minFiles = '';
				}
				return valid;
			};

			var validateMax = function validateMax(maxValue) {
				var valid = true;
				// max must be greater or equal to min
				if (isNaN(maxValue)) {
					valid = false;
					fieldValidationErrors.maxfiles = gettext('Maximum value must be a number and cannot be blank');
				} else if (maxValue <= 0) {
					valid = false;
					fieldValidationErrors.maxFiles = gettext('Maximum value must be greater than 0');
				} else if (maxValue < _this5.state.min) {
					valid = false;
					fieldValidationErrors.maxFiles = gettext('Maximum value must be greater or equal to the minimum value');
				} else {
					fieldValidationErrors.maxFiles = '';
				}
				return valid;
			};

			return new Promise(function (resolve) {
				var valid = true;
				switch (name) {
					case 'min':
						{
							valid = validateMin(value) && validateMax(_this5.state.max);
							break;
						}
					case 'max':
						valid = validateMax(value) && validateMin(_this5.state.min);
						break;
					case 'maxFileSize':
						if (isNaN(value)) {
							valid = false;
							fieldValidationErrors.maxFileSize = gettext('Maximum file size must be a number and is required');
						} else if (value < 1 || value > _configuration2.default.defaults.maxFileSize) {
							// Must be greater than 0 and smaller than max (default)
							valid = false;
							fieldValidationErrors.maxFileSize = interpolate(gettext('Maximum file size must be between 0 and %(maxFileSize)s'), { maxFileSize: _configuration2.default.defaults.maxFileSize }, true);
						} else {
							fieldValidationErrors.maxFileSize = '';
						}
						break;
					case 'fileFormats':
						{
							// Must have at least 1 value
							var validFormatRegex = /(^\.[0-9A-Za-z]+$)/;
							if (value !== undefined) {
								var fileFormats = value.split(',');
								if (fileFormats.length > 0 && fileFormats[0].trim() !== '') {
									fileFormats.map(function (fileFormat) {
										return fileFormat.trim();
									}).forEach(function (fileFormat) {
										// Empty values are fine as they are ignored.
										if (fileFormat !== '') {
											var matches = fileFormat.match(validFormatRegex);
											if (!matches) {
												valid = false;
												fieldValidationErrors.fileFormats = interpolate(gettext('\'%(fileFormat)s\' does not match a valid file format'), { fileFormat: fileFormat }, true);
											} else if (matches[0] !== fileFormat) {
												valid = false;
												fieldValidationErrors.fileFormats = interpolate(gettext('\'%(fileFormat)s\' is invalid.  File formats should be ' + 'restricted to alphanumeric characters.'), { fileFormat: fileFormat }, true);
											}
										}
									});
								} else {
									valid = false;
									fieldValidationErrors.fileFormats = gettext('You must specify at least 1 file format');
								}
							} else {
								// Value is undefined
								valid = false;
								fieldValidationErrors.fileFormats = gettext('You must specify at least 1 file format');
							}

							if (valid) {
								// clear out the error message
								fieldValidationErrors.fileFormats = '';
							}
							break;
						}
					default:
						valid = true;
				}

				_this5.setState({
					formErrors: fieldValidationErrors
				});
				resolve(valid);
			});
		}

		/**
   * Will handle the mouse down event from the parent of the switch to handle
   * the limiting of the file formats.  This will allow us to prevent the blur
   * event of taking over when trying to turn off the option.
   *
   * @memberof FileUploadOptions
   */

	}, {
		key: 'handleMouseDownOnSwitch',
		value: function handleMouseDownOnSwitch() {
			if (this.state.limitFileFormat) {
				this.switchingFileFormats = true;
			} else {
				this.switchingFileFormats = false;
			}
		}

		/**
   * This method is to prevent the limited file formats field
   * from being empty.  This is done on blur of the filed since
   * validation on the form level is too late as the context will
   * be lost.
   *
   * @param {*} event
   * @memberof FileUploadOptions
   */

	}, {
		key: 'preventEmptyFileFormats',
		value: function preventEmptyFileFormats(event) {
			var _this6 = this;

			if (!this.switchingFileFormats) {
				var formatsTextarea = event.target;
				var _event$target3 = event.target,
				    name = _event$target3.name,
				    value = _event$target3.value;

				this.validateField(name, value).then(function (valid) {
					if (!valid) {
						new _modals.Confirm(gettext('Invalid File Formats'), gettext('Entered file extensions contain errors.  This is a mandatory field.  ' + 'Please fix any errors before proceeding.'), function () {
							// Turn off limiting file formats
							_this6.setState({
								limitFileFormat: false,
								fileFormats: ''
							});

							_this6.props.handleValueChange(_this6.state);
						}, {
							yes: gettext('Do not limit file formats'),
							no: gettext('Let me change file format values'),
							noCallback: function noCallback() {
								// focus textarea
								formatsTextarea.focus();
							}
						});
					}
				});
			}
			this.switchingFileFormats = false;
		}
	}, {
		key: 'render',
		value: function render() {
			return React.createElement(
				React.Fragment,
				null,
				React.createElement(
					'div',
					{ className: 'optgroup collapsable' },
					React.createElement(
						'h3',
						{ className: 'collapsable-title' },
						React.createElement(
							'a',
							{ onClick: this.toggleOptionGroup },
							gettext('General')
						)
					),
					React.createElement(
						'div',
						null,
						React.createElement(
							'div',
							{ className: 'opt row col-12' },
							React.createElement(_InlineText2.default, {
								label: gettext('Identifier'),
								value: this.state.name,
								name: 'name',
								change: this.handleInputChange
							})
						),
						React.createElement(
							'div',
							{ className: 'opt row col-12' },
							React.createElement(_HtmlTextarea2.default, {
								label: gettext('Title'),
								value: this.state.title,
								name: 'title',
								change: this.handleInputChange
							})
						),
						React.createElement(
							'div',
							{ className: 'opt row col-12' },
							React.createElement(_HtmlTextarea2.default, {
								label: gettext('Description'),
								value: this.state.description,
								name: 'description',
								change: this.handleInputChange
							})
						)
					)
				),
				React.createElement(
					'div',
					{ className: 'optgroup collapsable collapsed' },
					React.createElement(
						'h3',
						{ className: 'collapsable-title' },
						React.createElement(
							'a',
							{ onClick: this.toggleOptionGroup },
							gettext('Display')
						)
					),
					React.createElement(
						'div',
						{ style: noneStyle },
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(_Checkbox.Checkbox, {
								label: gettext('Append to previous question'),
								name: 'appendToPrevious',
								value: this.state.appendToPrevious,
								change: this.handleInputChange
							})
						)
					)
				),
				React.createElement(
					'div',
					{ className: 'optgroup collapsable collapsed' },
					React.createElement(
						'h3',
						{ className: 'collapsable-title' },
						React.createElement(
							'a',
							{ onClick: this.toggleOptionGroup },
							gettext('Options')
						)
					),
					React.createElement(
						'div',
						{ style: noneStyle },
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(_Checkbox.Checkbox, {
								label: gettext('Optional'),
								name: 'optional',
								value: this.state.optional,
								change: this.handleInputChange })
						),
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'label',
								{ className: 'col-sm-8' },
								React.createElement(
									'strong',
									{ className: 'inline' },
									gettext('Include an optional description field')
								)
							),
							React.createElement(
								'div',
								{ className: 'col-sm-4' },
								React.createElement(_smapplyUi.Switch, {
									checked: this.state.includeDescription,
									value: this.state.includeDescription,
									name: 'includeDescription',
									onChange: this.handleCheckboxChange })
							)
						),
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'label',
								{ className: 'col-sm-8' },
								React.createElement(
									'strong',
									{ className: 'inline' },
									gettext('Allow multiple uploads')
								)
							),
							React.createElement(
								'div',
								{ className: 'col-sm-4' },
								React.createElement(_smapplyUi.Switch, {
									checked: this.state.allowMultiple,
									value: this.state.allowMultiple,
									name: 'allowMultiple',
									onChange: this.handleCheckboxChange })
							)
						),
						this.state.allowMultiple && React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'label',
								{ className: 'col-sm-8' },
								React.createElement(
									'strong',
									{ className: 'inline' },
									gettext('Set a minimum/maximum number of uploads')
								)
							),
							React.createElement(
								'div',
								{ className: 'col-sm-4' },
								React.createElement(_smapplyUi.Switch, {
									checked: this.state.limitUploads,
									value: this.state.limitUploads,
									name: 'limitUploads',
									onChange: this.handleCheckboxChange })
							)
						),
						this.state.limitUploads && this.state.allowMultiple && React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'div',
								{ className: 'min col-6' },
								React.createElement(
									'label',
									{ htmlFor: 'min' },
									gettext('min') + ': '
								),
								React.createElement('input', {
									name: 'min',
									type: 'number',
									min: this.state.optional.value ? 0 : 1,
									max: this.state.max,
									value: this.state.min,
									onChange: this.handleNumberInputChange,
									disabled: this.state.optional.value
								})
							),
							React.createElement(
								'div',
								{ className: 'max col-6' },
								React.createElement(
									'label',
									{ htmlFor: 'max' },
									gettext('max') + ': '
								),
								React.createElement('input', {
									name: 'max',
									type: 'number',
									min: this.state.min,
									value: this.state.max,
									onChange: this.handleNumberInputChange })
							),
							React.createElement(
								'div',
								{ className: 'error col-12' },
								(this.state.formErrors.minFiles || this.state.formErrors.maxFiles) && React.createElement(
									'ul',
									{ className: 'errorlist' },
									this.state.formErrors.minFiles && React.createElement(
										'li',
										null,
										this.state.formErrors.minFiles
									),
									this.state.formErrors.maxFiles && React.createElement(
										'li',
										null,
										this.state.formErrors.maxFiles
									)
								)
							)
						),
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'div',
								{ className: 'max col-12' },
								React.createElement(
									'label',
									{ htmlFor: 'max' },
									gettext('Maximum individual file size:')
								),
								React.createElement('input', {
									name: 'maxFileSize',
									type: 'number',
									min: '0',
									max: '1000',
									value: this.state.maxFileSize,
									onChange: this.handleNumberInputChange
								}),
								' MB',
								React.createElement(
									'p',
									null,
									gettext('Maximum 1000MB (1GB)')
								)
							),
							React.createElement(
								'div',
								{ className: 'error col-12' },
								this.state.formErrors.maxFileSize && React.createElement(
									'ul',
									{ className: 'errorlist' },
									React.createElement(
										'li',
										null,
										this.state.formErrors.maxFileSize
									)
								)
							)
						),
						React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'label',
								{ className: 'col-8' },
								React.createElement(
									'strong',
									{ className: 'inline' },
									gettext('Limit file formats')
								)
							),
							React.createElement(
								'div',
								{
									className: 'col-4',
									onMouseDown: this.handleMouseDownOnSwitch },
								React.createElement(_smapplyUi.Switch, {
									checked: this.state.limitFileFormat,
									value: this.state.limitFileFormat,
									name: 'limitFileFormat',
									onChange: this.handleCheckboxChange
								})
							)
						),
						this.state.limitFileFormat && React.createElement(
							'div',
							{ className: 'opt row' },
							React.createElement(
								'div',
								{ className: 'col-12' },
								React.createElement(
									'p',
									null,
									gettext('Enter the extensions of accepted file formats	separated by a comma (e.g.: .pdf, .doc)')
								),
								React.createElement('textarea', {
									ref: this.fileExtensionTextarea,
									className: 'form-control',
									value: this.state.fileFormats,
									name: 'fileFormats',
									onChange: this.handleInputChange,
									onBlur: this.preventEmptyFileFormats })
							),
							React.createElement(
								'div',
								{ className: 'error col-12' },
								this.state.formErrors.fileFormats && React.createElement(
									'ul',
									{ className: 'errorlist' },
									React.createElement(
										'li',
										null,
										this.state.formErrors.fileFormats
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return FileUploadOptions;
}(React.Component);

exports.default = FileUploadOptions;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Checkbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _smapplyUi = __webpack_require__(28);

var _value = __webpack_require__(1206);

var _value2 = _interopRequireDefault(_value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is to wrap a checkbox (in this case a SMApply UI switch component) around a
 * `Value` class.  This is to abstract the logic of setting and getting the internal value of
 * this class away from the element using it.
 *
 * @export
 * @class Checkbox
 * @extends {React.Component}
 */
var Checkbox = exports.Checkbox = function (_React$Component) {
	_inherits(Checkbox, _React$Component);

	function Checkbox(props) {
		_classCallCheck(this, Checkbox);

		var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

		_this.state = {
			name: props.name,
			label: props.label,
			value: props.value
		};
		_this.handleInputChange = _this.handleInputChange.bind(_this);
		return _this;
	}

	_createClass(Checkbox, [{
		key: 'handleInputChange',
		value: function handleInputChange() {
			var newValue = new _value2.default(!this.state.value.get());
			this.setState({
				value: newValue
			});

			var returnEvent = {
				target: {
					name: this.state.name,
					value: newValue
				}
			};
			this.props.change(returnEvent);
		}
	}, {
		key: 'render',
		value: function render() {
			return React.createElement(
				React.Fragment,
				null,
				React.createElement(
					'label',
					{ className: 'col-sm-8' },
					React.createElement(
						'strong',
						{ className: 'inline' },
						this.state.label
					)
				),
				React.createElement(
					'div',
					{ className: 'col-sm-4 sma-js-toggle-field' },
					React.createElement(_smapplyUi.Switch, { checked: this.state.value.get(), onChange: this.handleInputChange })
				)
			);
		}
	}]);

	return Checkbox;
}(React.Component);

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _texteditor = __webpack_require__(80);

var _texteditor2 = _interopRequireDefault(_texteditor);

var _modals = __webpack_require__(6);

var _uuid = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HtmlTextarea = function (_React$Component) {
	_inherits(HtmlTextarea, _React$Component);

	_createClass(HtmlTextarea, null, [{
		key: 'escapeScript',
		value: function escapeScript(value) {
			return value.replace(/<script/g, '<!--<script').replace(/<\/script>/g, '</script>-->');
		}
	}, {
		key: 'unescapeScript',
		value: function unescapeScript(value) {
			return value.replace(/<!--<script/g, '<script').replace(/<\/script>-->/g, '</script>');
		}
	}]);

	function HtmlTextarea(props) {
		_classCallCheck(this, HtmlTextarea);

		var _this = _possibleConstructorReturn(this, (HtmlTextarea.__proto__ || Object.getPrototypeOf(HtmlTextarea)).call(this, props));

		_this.id = (0, _uuid.v4)();
		_this.state = {
			value: props.value,
			name: props.name,
			showEditorButton: false
		};
		_this.openHtmlEditor = _this.openHtmlEditor.bind(_this);
		_this.handleInputChange = _this.handleInputChange.bind(_this);
		_this.showFocus = _this.showFocus.bind(_this);
		_this.hideFocus = _this.hideFocus.bind(_this);
		return _this;
	}

	_createClass(HtmlTextarea, [{
		key: 'openHtmlEditor',
		value: function openHtmlEditor() {
			var _this2 = this;

			var targetTextArea = document.getElementById(this.id);
			var textarea = document.createElement('textarea');
			document.getElementsByTagName('body')[0].appendChild(textarea);

			var dialog = new _modals.ContentModal(textarea, {
				title: gettext('Visual Editor'),
				destroyOnClose: true,
				buttons: [{
					label: gettext('OK'),
					cls: 'button-default',
					handler: function handler() {
						var event = {
							target: {
								// eslint-disable-next-line no-use-before-define
								value: editor.getContent()
							}
						};
						_this2.handleInputChange(event);
						targetTextArea.focus();
						dialog.hide();
					}
				}]
			});

			// This needs to be defined after the dialog (ask Nathan why)
			var editor = new _texteditor2.default({
				textarea: textarea,
				piping: ['all']
			});

			editor.setContent(this.state.value.get());
			dialog.show();
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var valueObject = this.state.value;
			valueObject.set(HtmlTextarea.escapeScript(event.target.value));
			valueObject.changed(valueObject.get());
			this.setState({
				value: valueObject
			});

			var returnEvent = {
				target: {
					name: this.state.name,
					value: valueObject
				}
			};
			this.props.change(returnEvent);
		}
	}, {
		key: 'showFocus',
		value: function showFocus() {
			this.setState({
				showEditorButton: true
			});
		}
	}, {
		key: 'hideFocus',
		value: function hideFocus() {
			this.setState({
				showEditorButton: false
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return React.createElement(
				React.Fragment,
				null,
				React.createElement(
					'label',
					{ id: this.id, htmlFor: this.id },
					React.createElement(
						'strong',
						null,
						this.props.label
					)
				),
				React.createElement('textarea', {
					className: 'form-control text',
					id: this.id,
					value: HtmlTextarea.unescapeScript(this.state.value.get()),
					onChange: this.handleInputChange,
					onFocus: this.showFocus,
					onBlur: this.hideFocus
				}),
				this.state.showEditorButton &&
				// This has to be onMouseDown to be triggered before the textare onBlur
				React.createElement(
					'a',
					{ className: 'edit-html',
						onMouseDown: this.openHtmlEditor
					},
					'Open Visual Editor'
				)
			);
		}
	}]);

	return HtmlTextarea;
}(React.Component);

exports.default = HtmlTextarea;

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _uuid = __webpack_require__(196);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineText = function (_React$Component) {
	_inherits(InlineText, _React$Component);

	_createClass(InlineText, null, [{
		key: 'escapeScript',
		value: function escapeScript(value) {
			return value.replace(/<script/g, '<!--<script').replace(/<\/script>/g, '</script>-->');
		}
	}]);

	function InlineText(props) {
		_classCallCheck(this, InlineText);

		var _this = _possibleConstructorReturn(this, (InlineText.__proto__ || Object.getPrototypeOf(InlineText)).call(this, props));

		_this.id = (0, _uuid.v4)();
		_this.state = {
			value: props.value,
			name: props.name,
			showInputBox: false
		};
		_this.handleInputChange = _this.handleInputChange.bind(_this);
		_this.showFocus = _this.showFocus.bind(_this);
		_this.hideFocus = _this.hideFocus.bind(_this);
		return _this;
	}

	_createClass(InlineText, [{
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var valueObject = this.state.value;
			valueObject.set(InlineText.escapeScript(event.target.value));
			valueObject.changed(valueObject.get());
			this.setState({
				value: valueObject
			});

			var returnEvent = {
				target: {
					name: this.state.name,
					value: valueObject
				}
			};
			this.props.change(returnEvent);
		}
	}, {
		key: 'showFocus',
		value: function showFocus() {
			this.setState({
				showInputBox: true
			});
		}
	}, {
		key: 'hideFocus',
		value: function hideFocus(event) {
			this.handleInputChange(event);
			this.setState({
				showInputBox: false
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return React.createElement(
				React.Fragment,
				null,
				React.createElement(
					'label',
					{ id: 'mylabelid', htmlFor: this.id },
					React.createElement(
						'strong',
						{ className: 'inline' },
						this.props.label,
						React.createElement(
							'a',
							{
								'data-toggle': 'tooltip',
								className: 'help',
								title: gettext('Identifier - (e.g., \'question1\') Identifiers are used to refer to ' + 'questions when programming advanced logic conditions.')
							},
							'(?)'
						)
					),
					this.state.showInputBox ? React.createElement('input', {
						type: 'text',
						name: 'identifier',
						id: this.id,
						onBlur: this.hideFocus,
						value: this.state.value.get() ? this.state.value.get() : '',
						onChange: this.handleInputChange
					}) : React.createElement(
						'a',
						{
							className: 'label label-primary identifier',
							onClick: this.showFocus },
						this.state.value.get() ? this.state.value.get() : gettext('None')
					)
				)
			);
		}
	}]);

	return InlineText;
}(React.Component);

exports.default = InlineText;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div id=\"sma-js-search-form\" class=\"form\">");t.b("\n" + i);t.b("    <div class=\"sma-input-icon-right\">");t.b("\n" + i);t.b("        <input class=\"form-control\" type=\"search\" placeholder=\"");t.b(t.v(t.d("strings.search_questions",c,p,0)));t.b("\"></input>");t.b("\n" + i);t.b("        <a class=\"sma-js-search-clear\" style=\"display: none\"><i class=\"m-1 nc-icon-mini ui-1_simple-remove\"></i></a>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div id=\"sma-js-search-form\" class=\"form\">\n    <div class=\"sma-input-icon-right\">\n        <input class=\"form-control\" type=\"search\" placeholder=\"{{strings.search_questions}}\"></input>\n        <a class=\"sma-js-search-clear\" style=\"display: none\"><i class=\"m-1 nc-icon-mini ui-1_simple-remove\"></i></a>\n    </div>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {


/*
Page status icons in survey editor.
 */
var AdvancedBranching, BranchingRule, PageStatus,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

BranchingRule = __webpack_require__(408).BranchingRule;

AdvancedBranching = __webpack_require__(1208);

PageStatus = (function(superClass) {
  extend(PageStatus, superClass);

  function PageStatus() {
    return PageStatus.__super__.constructor.apply(this, arguments);
  }

  PageStatus.prototype.translatables = {
    looped: gettext('This page is looped for %(question)s on %(page)s'),
    simpleSkipping: gettext('Simple Skipping Information'),
    advancedBranching: gettext('Advanced Branching Information'),
    noOtherRules: gettext('If no other rules apply')
  };

  PageStatus.prototype.loopingTemplate = _.template('<ul>\n<% _.each(survey.looping.getLoopedQuestions(), function(loop) { %>\n	<li><%= interpolate(translatables.looped, {question: loop.field.getIdentifier(), page: survey.pages[loop.page].label.display()}) %></li>\n<% }) %>\n</ul>');

  PageStatus.prototype.branchingTemplate = _.template('<% if (hasSimpleSkipping()) { %>\n	<h4><%= translatables.simpleSkipping %></h4>\n	<ul>\n	<% _.each(simpleSkipping(), function(rule) { %>\n		<li><%= rule %></li>\n	<% }) %>\n	</ul>\n<% } %>\n<% if (hasAdvancedBranching()) { %>\n	<h4><%= translatables.advancedBranching %></h4>\n	<ul>\n	<% _.each(advancedBranching(), function(rule) { %>\n		<li><%= rule %></li>\n	<% }) %>\n	</ul>\n<% } %>');

  PageStatus.prototype.events = {
    'click a.show-branching-info': 'showBranchingInfo',
    'click a.show-looping-info': 'showLoopingInfo'
  };

  PageStatus.prototype.initialize = function(config) {
    _.bindAll(this, 'showBranchingInfo', 'showLoopingInfo');
    return this.survey = config.survey;
  };

  PageStatus.prototype.render = function() {
    this.$el.empty();
    return this.$el;
  };

  PageStatus.prototype.showTooltip = function(e, contents) {
    var info, target;
    e.preventDefault();
    target = $(e.target);
    info = target.data('tooltip');
    if (info) {
      target.data('tooltip', null);
      info.remove();
      return;
    }
    info = $('<div class="tooltip tooltip-bottom info-tooltip"/>').html(contents);
    target.data('tooltip', info);
    info.appendTo('body').position({
      my: 'center top',
      at: 'center bottom',
      of: target,
      offset: '-4 9',
      collision: 'none none'
    });
    return setTimeout((function() {
      return $('body').one('mousedown keydown', function(e) {
        if ($(e.target).is(target)) {
          return;
        }
        target.data('tooltip', null);
        return info.remove();
      });
    }), 0);
  };

  PageStatus.prototype.showBranchingInfo = function(e) {
    return this.showTooltip(e, this.branchingTemplate(this));
  };

  PageStatus.prototype.showLoopingInfo = function(e) {
    return this.showTooltip(e, this.loopingTemplate(this));
  };

  PageStatus.prototype.hasLooping = function() {
    return this.survey.currentPage.isLooped();
  };

  PageStatus.prototype.hasSimpleSkipping = function() {
    var field, i, len, question, ref, ref1, ref2, ref3;
    ref = this.survey.currentPage.fields;
    for (i = 0, len = ref.length; i < len; i++) {
      field = ref[i];
      question = field.serialize();
      if (((ref1 = question.children) != null ? (ref2 = ref1[0]) != null ? (ref3 = ref2.branch) != null ? ref3.length : void 0 : void 0 : void 0) != null) {
        return true;
      }
    }
    return false;
  };

  PageStatus.prototype.hasAdvancedBranching = function() {
    var ref;
    return (ref = AdvancedBranching.formatRules(this.survey, this.survey.currentPage.branching)) != null ? ref.length : void 0;
  };

  PageStatus.prototype.simpleSkipping = function() {
    var field, i, j, len, len1, question, ref, ref1, ref2, result, rule, rules;
    result = [];
    ref = this.survey.currentPage.fields;
    for (i = 0, len = ref.length; i < len; i++) {
      field = ref[i];
      question = field.serialize();
      if (((ref1 = question.children) != null ? (ref2 = ref1[0]) != null ? ref2.branch : void 0 : void 0) != null) {
        rules = BranchingRule.prototype.parseSimple(question, question.children[0].branch);
        for (j = 0, len1 = rules.length; j < len1; j++) {
          rule = rules[j];
          if (rule.validate(this.survey.formatInfo())) {
            result.push(rule.format(this.survey.formatInfo()));
          }
        }
      }
    }
    return result;
  };

  PageStatus.prototype.advancedBranching = function() {
    return AdvancedBranching.formatRules(this.survey, this.survey.currentPage.branching);
  };

  return PageStatus;

})(Backbone.View);

module.exports = PageStatus;


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = $.klass({
	getOption: function getOption(value, label, disabled) {
		return $('<option/>', { value: value, html: label, disabled: !!disabled });
	},

	indent1: '&nbsp;&nbsp;&nbsp;&#8627;&nbsp;',
	indent2: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#8627;&nbsp;',

	addDropdownQuestion3D: function addDropdownQuestion3D(survey, select, question, config) {
		if (config.showRowsAndColumns) {
			select.append($('<option/>', {
				html: this.indent1 + gettext('Rows'),
				disabled: true
			}));

			for (var i = 0; i < question.rows.length; i++) {
				var row = question.rows[i];

				select.append($('<option/>', {
					html: this.indent2 + (row.label || interpolate(gettext('Row %s'), [i + 1])),
					value: row.id
				}));
			}

			select.append($('<option/>', {
				html: this.indent1 + gettext('Columns'),
				disabled: true
			}));

			for (var i = 0; i < question.types.length; i++) {
				var col = question.types[i];

				select.append($('<option/>', {
					html: this.indent2 + (col.label || interpolate(gettext('Column %s'), [i + 1])),
					value: col.id
				}));
			}

			select.append($('<option/>', {
				html: this.indent1 + gettext('Variables'),
				disabled: true
			}));

			for (var i = 0; i < question.vars.length; i++) {
				var variable = survey.variables[question.vars[i]];

				select.append($('<option/>', {
					html: this.indent2 + variable.label,
					value: variable.id
				}));
			}

			return true;
		}
		for (var k = 0; k < question.types.length; k++) {
			var col = question.types[k];
			if (config.varFilter(col)) {
				select.append($('<option/>', { html: this.indent1 + (col.label || interpolate(gettext('Column %s'), [k + 1])), disabled: !config.grouping, value: question.id + "#" + k }));
				for (var l = 0; l < question.rows.length; l++) {
					var row = question.rows[l];
					select.append($('<option/>', {
						value: row.items[k],
						html: this.indent2 + (survey.variables[row.items[k]] ? survey.variables[row.items[k]].label : '')
					}));
				}
			}
		}

		return true;
	},

	addDropdownQuestion: function addDropdownQuestion(survey, select, question, config) {
		if (question.vars.length < 1) {
			if (!config.showEmpty) {
				return false;
			}

			$('<option/>', { value: question.id, html: question.label }).appendTo(select);

			return true;
		}

		if (question.vars.length == 1 && question.vars[0] === question.id) {
			var variable = survey.variables[question.vars[0]];

			if (!config.varFilter(variable)) return false;

			$('<option/>', { value: question.vars[0], html: variable.label }).appendTo(select);

			return true;
		}

		var empty = true;
		var disabled = !config.questionFilter(question);
		var group = $('<option/>', { value: question.id, html: question.label }).appendTo(select);

		if (question.rows && question.rows.length > 1 && question.types && question.types.length > 1 || question.type == 'threed-grid') {
			empty = !this.addDropdownQuestion3D(survey, select, question, config);
		} else {
			for (var k = 0; k < question.vars.length; k++) {
				var variable = survey.variables[question.vars[k]];

				if (config.varFilter(variable)) {
					select.append($('<option/>', { value: question.vars[k], html: this.indent1 + variable.label }));
					empty = false;
				}
			}
		}

		if (empty && disabled) {
			group.remove();
			return false;
		}

		if (disabled) {
			group.attr('disabled', true);
		}

		return true;
	},

	addDropdownPage: function addDropdownPage(survey, select, page, config) {
		var group = $('<optgroup/>', { label: page.page });
		var empty = true;
		for (var i = 0; i < page.questions.length; i++) {
			if (this.addDropdownQuestion(survey, group, survey.questions[page.questions[i]], config)) {
				empty = false;
			}
		}

		if (!empty) {
			select.append(group);
		}
	},

	buildSourceDropdown: function buildSourceDropdown(survey, config) {
		config = $.extend({}, config || {}, {
			varFilter: $.isFunction(config.varPred) ? config.varPred : function () {
				return !!config.varPred;
			},
			questionFilter: $.isFunction(config.questionPred) ? config.questionPred : function () {
				return !!config.questionPred;
			},
			pageFilter: $.isFunction(config.pagePred) ? config.pagePred : function () {
				return config.pagePred === undefined ? true : !!config.pagePred;
			}
		});

		var select = $('<select class="custom-select"/>');

		if (config.multiple) {
			select.attr('multiple', 'multiple');
		} else {
			select.append($('<option/>', { value: '-', html: gettext('Please select a question or variable...') }));
		}

		if (!!config.showMetas && !FS_EMBEDDED) {
			var metaGroup = $('<optgroup/>', {
				label: gettext('Response Variables')
			}).appendTo(select);

			for (var i = 0; i < survey.metas.length; i++) {
				var variable = survey.variables[survey.metas[i]];
				if (config.varFilter(variable)) {
					metaGroup.append($('<option/>', {
						value: survey.metas[i],
						html: variable.label
					}));
				}
			}
			if (survey.variables['_gv']) {
				metaGroup.append($('<option/>', {
					value: survey.variables['_gv'].id,
					html: survey.variables['_gv'].label
				}));
			}
		}
		if (survey.collector_variables && survey.collector_variables.length > 0) {
			var collectorGroup = $('<optgroup/>', {
				label: gettext('Collector Variables')
			}).appendTo(select);

			for (var i = 0; i < survey.collector_variables.length; i++) {
				collectorGroup.append($('<option/>', {
					value: '_cv_' + survey.collector_variables[i],
					html: survey.variables['_cv_' + survey.collector_variables[i]].label
				}));
			}
		}

		for (var i = 0; i < survey.pages.length; i++) {
			if (config.pageFilter(survey.pages[i])) {
				this.addDropdownPage(survey, select, survey.pages[i], config);
			}
		}

		return select;
	}
});

module.exports = Utils;

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(301)))

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 jSignature uses FlashCanvas ONLY for old browser support (aka IE8 and below).
 */
window.FlashCanvasOptions = {
	/*
  Tell flashcanvas.js where to find it's swf file. Note that the default behaviour
  is to search for the swf in the same directory from which flashcanvas.js was
  loaded from. When cramming is turned off (default for dev) this isn't needed
  because both files will be served from the same directory. It should also be
  noted that cramming needs to be turned on in order to support IE8 due to
  limitations on the number of external js and css files. 
  */
	swfPath: '/media/js/surveys/'
};

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/

(function () { 'use strict';

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
function getSqDist(p1, p2) {

    var dx = p1.x - p2.x,
        dy = p1.y - p2.y;

    return dx * dx + dy * dy;
}

// square distance from a point to a segment
function getSqSegDist(p, p1, p2) {

    var x = p1.x,
        y = p1.y,
        dx = p2.x - x,
        dy = p2.y - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = p2.x;
            y = p2.y;

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = p.x - x;
    dy = p.y - y;

    return dx * dx + dy * dy;
}
// rest of the code doesn't care about point format

// basic distance-based simplification
function simplifyRadialDist(points, sqTolerance) {

    var prevPoint = points[0],
        newPoints = [prevPoint],
        point;

    for (var i = 1, len = points.length; i < len; i++) {
        point = points[i];

        if (getSqDist(point, prevPoint) > sqTolerance) {
            newPoints.push(point);
            prevPoint = point;
        }
    }

    if (prevPoint !== point) newPoints.push(point);

    return newPoints;
}

function simplifyDPStep(points, first, last, sqTolerance, simplified) {
    var maxSqDist = sqTolerance,
        index;

    for (var i = first + 1; i < last; i++) {
        var sqDist = getSqSegDist(points[i], points[first], points[last]);

        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }

    if (maxSqDist > sqTolerance) {
        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
        simplified.push(points[index]);
        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
    }
}

// simplification using Ramer-Douglas-Peucker algorithm
function simplifyDouglasPeucker(points, sqTolerance) {
    var last = points.length - 1;

    var simplified = [points[0]];
    simplifyDPStep(points, 0, last, sqTolerance, simplified);
    simplified.push(points[last]);

    return simplified;
}

// both algorithms combined for awesome performance
function simplify(points, tolerance, highestQuality) {

    if (points.length <= 2) return points;

    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

    points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
    points = simplifyDouglasPeucker(points, sqTolerance);

    return points;
}

// export as AMD module / Node module / browser or worker variable
if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return simplify; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else if (typeof module !== 'undefined') {
    module.exports = simplify;
    module.exports.default = simplify;
} else if (typeof self !== 'undefined') self.simplify = simplify;
else window.simplify = simplify;

})();


/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 
jSignature v2 "2012-11-01T22:48" "commit ID 1c15dfafecc75925c3b7d529356a558b59220edb"
Copyright (c) 2012 Willow Systems Corp http://willow-systems.com
Copyright (c) 2010 Brinley Ang http://www.unbolt.net
MIT License <http://www.opensource.org/licenses/mit-license.php> 


Simplify.js BSD 
(c) 2012, Vladimir Agafonkin
mourner.github.com/simplify-js


base64 encoder
MIT, GPL
http://phpjs.org/functions/base64_encode
+   original by: Tyler Akins (http://rumkin.com)
+   improved by: Bayron Guevara
+   improved by: Thunder.m
+   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
+   bugfixed by: Pellentesque Malesuada
+   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
+   improved by: Rafal Kukawski (http://kukawski.pl)


jSignature v2 jSignature's Undo Button and undo functionality plugin


jSignature v2 jSignature's custom "base30" format export and import plugins.


jSignature v2 SVG export plugin.

*/
(function () {
  function q(b) {
    for (var j, s = b.css("color"), g, b = b[0], c = !1; b && !g && !c;) {
      try {
        j = $(b).css("background-color");
      } catch (d) {
        j = "transparent";
      }"transparent" !== j && "rgba(0, 0, 0, 0)" !== j && (g = j);c = b.body;b = b.parentNode;
    }var b = /rgb[a]*\((\d+),\s*(\d+),\s*(\d+)/,
        c = /#([AaBbCcDdEeFf\d]{2})([AaBbCcDdEeFf\d]{2})([AaBbCcDdEeFf\d]{2})/,
        a;j = void 0;(j = s.match(b)) ? a = { r: parseInt(j[1], 10), g: parseInt(j[2], 10), b: parseInt(j[3], 10) } : (j = s.match(c)) && (a = { r: parseInt(j[1], 16), g: parseInt(j[2], 16), b: parseInt(j[3], 16) });var f;g ? (j = void 0, (j = g.match(b)) ? f = { r: parseInt(j[1], 10), g: parseInt(j[2], 10), b: parseInt(j[3], 10) } : (j = g.match(c)) && (f = { r: parseInt(j[1], 16), g: parseInt(j[2], 16), b: parseInt(j[3], 16) })) : f = a ? 127 < Math.max.apply(null, [a.r, a.g, a.b]) ? { r: 0, g: 0, b: 0 } : { r: 255, g: 255, b: 255 } : { r: 255, g: 255, b: 255 };j = function j(b) {
      return "rgb(" + [b.r, b.g, b.b].join(", ") + ")";
    };a && f ? (b = Math.max.apply(null, [a.r, a.g, a.b]), a = Math.max.apply(null, [f.r, f.g, f.b]), a = Math.round(a + -0.75 * (a - b)), a = { r: a, g: a, b: a }) : a ? (a = Math.max.apply(null, [a.r, a.g, a.b]), b = 1, 127 < a && (b = -1), a = Math.round(a + 96 * b), a = { r: a, g: a, b: a }) : a = { r: 191, g: 191, b: 191 };return { color: s, "background-color": f ? j(f) : g, "decor-color": j(a) };
  }function m(b, j) {
    this.x = b;this.y = j;this.reverse = function () {
      return new this.constructor(-1 * this.x, -1 * this.y);
    };this._length = null;this.getLength = function () {
      this._length || (this._length = Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2)));return this._length;
    };var s = function s(b) {
      return Math.round(b / Math.abs(b));
    };this.resizeTo = function (b) {
      if (0 === this.x && 0 === this.y) this._length = 0;else if (0 === this.x) this._length = b, this.y = b * s(this.y);else if (0 === this.y) this._length = b, this.x = b * s(this.x);else {
        var j = Math.abs(this.y / this.x),
            a = Math.sqrt(Math.pow(b, 2) / (1 + Math.pow(j, 2))),
            j = j * a;this._length = b;this.x = a * s(this.x);this.y = j * s(this.y);
      }return this;
    };this.angleTo = function (b) {
      var j = this.getLength() * b.getLength();return 0 === j ? 0 : Math.acos(Math.min(Math.max((this.x * b.x + this.y * b.y) / j, -1), 1)) / Math.PI;
    };
  }function k(b, j) {
    this.x = b;this.y = j;this.getVectorToCoordinates = function (b, j) {
      return new m(b - this.x, j - this.y);
    };
    this.getVectorFromCoordinates = function (b, j) {
      return this.getVectorToCoordinates(b, j).reverse();
    };this.getVectorToPoint = function (b) {
      return new m(b.x - this.x, b.y - this.y);
    };this.getVectorFromPoint = function (b) {
      return this.getVectorToPoint(b).reverse();
    };
  }function t(b, j, a, g, c) {
    this.data = b;this.context = j;if (b.length) for (var d = b.length, f, l, i = 0; i < d; i++) {
      f = b[i];l = f.x.length;a.call(j, f);for (var e = 1; e < l; e++) {
        g.call(j, f, e);
      }c.call(j, f);
    }this.changed = function () {};this.startStrokeFn = a;this.addToStrokeFn = g;this.endStrokeFn = c;this.inStroke = !1;this._stroke = this._lastPoint = null;this.startStroke = function (b) {
      if (b && "number" == typeof b.x && "number" == typeof b.y) {
        this._stroke = { x: [b.x], y: [b.y] };this.data.push(this._stroke);this._lastPoint = b;this.inStroke = !0;var j = this._stroke,
            a = this.startStrokeFn,
            g = this.context;setTimeout(function () {
          a.call(g, j);
        }, 3);return b;
      }return null;
    };this.addToStroke = function (b) {
      if (this.inStroke && "number" === typeof b.x && "number" === typeof b.y && 4 < Math.abs(b.x - this._lastPoint.x) + Math.abs(b.y - this._lastPoint.y)) {
        var j = this._stroke.x.length;this._stroke.x.push(b.x);this._stroke.y.push(b.y);this._lastPoint = b;var a = this._stroke,
            g = this.addToStrokeFn,
            s = this.context;setTimeout(function () {
          g.call(s, a, j);
        }, 3);return b;
      }return null;
    };this.endStroke = function () {
      var b = this.inStroke;this.inStroke = !1;this._lastPoint = null;if (b) {
        var j = this._stroke,
            a = this.endStrokeFn,
            g = this.context,
            s = this.changed;setTimeout(function () {
          a.call(g, j);s.call(g);
        }, 3);return !0;
      }return null;
    };
  }function r(b, j, a) {
    var g = this.$parent = $(b),
        b = this.eventTokens = {};this.events = new v(this);var c = $.fn[e]("globalEvents"),
        d = { width: "ratio", height: "ratio", sizeRatio: 4, color: "#000", "background-color": "#fff", "decor-color": "#eee", lineWidth: 0, minFatFingerCompensation: -10, showUndoButton: !1, data: [] };$.extend(d, q(g));j && $.extend(d, j);this.settings = d;for (var f in a) {
      a.hasOwnProperty(f) && a[f].call(this, f);
    }this.events.publish(e + ".initializing");this.$controlbarUpper = $('<div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1em !important;margin-bottom:1em !important;"></div>').appendTo(g);
    this.isCanvasEmulator = !1;a = this.canvas = this.initializeCanvas(d);j = $(a);this.$controlbarLower = $('<div style="padding:0 !important;margin:0 !important;width: 100% !important; height: 0 !important;margin-top:-1.5em !important;margin-bottom:1.5em !important;"></div>').appendTo(g);this.canvasContext = a.getContext("2d");j.data(e + ".this", this);g = (g = d.lineWidth) ? g : Math.max(Math.round(a.width / 400), 2);d.lineWidth = g;this.lineCurveThreshold = 3 * d.lineWidth;d.cssclass && "" != $.trim(d.cssclass) && j.addClass(d.cssclass);
    this.fatFingerCompensation = 0;var g = function (b) {
      var j,
          a,
          g = function g(_g) {
        _g = _g.changedTouches && 0 < _g.changedTouches.length ? _g.changedTouches[0] : _g;return new k(Math.round(_g.pageX + j), Math.round(_g.pageY + a) + b.fatFingerCompensation);
      },
          d = new y(750, function () {
        b.dataEngine.endStroke();
      });this.drawEndHandler = function (j) {
        try {
          j.preventDefault();
        } catch (a) {}d.clear();b.dataEngine.endStroke();
      };this.drawStartHandler = function (c) {
        c.preventDefault();var s = $(b.canvas).offset();j = -1 * s.left;a = -1 * s.top;b.dataEngine.startStroke(g(c));
        d.kick();
      };this.drawMoveHandler = function (j) {
        j.preventDefault();b.dataEngine.inStroke && (b.dataEngine.addToStroke(g(j)), d.kick());
      };return this;
    }.call({}, this),
        l = g.drawEndHandler,
        i = g.drawStartHandler,
        p = g.drawMoveHandler,
        h = this.canvas,
        j = $(h);this.isCanvasEmulator ? (j.bind("mousemove." + e, p), j.bind("mouseup." + e, l), j.bind("mousedown." + e, i)) : (h.ontouchstart = function (b) {
      h.onmousedown = void 0;h.onmouseup = void 0;h.onmousemove = void 0;this.fatFingerCompensation = d.minFatFingerCompensation && -3 * d.lineWidth > d.minFatFingerCompensation ? -3 * d.lineWidth : d.minFatFingerCompensation;i(b);h.ontouchend = l;h.ontouchstart = i;h.ontouchmove = p;
    }, h.onmousedown = function (b) {
      h.ontouchstart = void 0;h.ontouchend = void 0;h.ontouchmove = void 0;i(b);h.onmousedown = i;h.onmouseup = l;h.onmousemove = p;
    });b[e + ".windowmouseup"] = c.subscribe(e + ".windowmouseup", g.drawEndHandler);this.events.publish(e + ".attachingEventHandlers");var n = this,
        b = d.width.toString(10),
        w = e;if ("ratio" === b || "%" === b.split("")[b.length - 1]) this.eventTokens[w + ".parentresized"] = c.subscribe(w + ".parentresized", function (b, j, a) {
      return function () {
        var g = j.width();if (g !== a) {
          for (var d in b) {
            b.hasOwnProperty(d) && (c.unsubscribe(b[d]), delete b[d]);
          }var s = n.settings;n.$parent.children().remove();for (d in n) {
            n.hasOwnProperty(d) && delete n[d];
          }d = s.data;var g = 1 * g / a,
              f = [],
              l,
              i,
              e,
              h,
              k,
              p;i = 0;for (e = d.length; i < e; i++) {
            p = d[i];l = { x: [], y: [] };h = 0;for (k = p.x.length; h < k; h++) {
              l.x.push(p.x[h] * g), l.y.push(p.y[h] * g);
            }f.push(l);
          }s.data = f;j[w](s);
        }
      };
    }(this.eventTokens, this.$parent, this.$parent.width(), 1 * this.canvas.width / this.canvas.height));this.resetCanvas(d.data);
    this.events.publish(e + ".initialized");return this;
  }var e = "jSignature",
      y = function y(b, j) {
    var a;this.kick = function () {
      clearTimeout(a);a = setTimeout(j, b);
    };this.clear = function () {
      clearTimeout(a);
    };return this;
  },
      v = function v(b) {
    this.topics = {};this.context = b ? b : this;this.publish = function (b, a, g, d) {
      if (this.topics[b]) {
        var c = this.topics[b],
            f = Array.prototype.slice.call(arguments, 1),
            l = [],
            i,
            e,
            h,
            p;e = 0;for (h = c.length; e < h; e++) {
          p = c[e], i = p[0], p[1] && (p[0] = function () {}, l.push(e)), i.apply(this.context, f);
        }e = 0;for (h = l.length; e < h; e++) {
          c.splice(l[e], 1);
        }
      }
    };this.subscribe = function (b, a, g) {
      this.topics[b] ? this.topics[b].push([a, g]) : this.topics[b] = [[a, g]];return { topic: b, callback: a };
    };this.unsubscribe = function (b) {
      if (this.topics[b.topic]) for (var a = this.topics[b.topic], g = 0, d = a.length; g < d; g++) {
        a[g][0] === b.callback && a.splice(g, 1);
      }
    };
  },
      z = function z(b) {
    var a = this.canvasContext,
        d = b.x[0],
        b = b.y[0],
        g = this.settings.lineWidth,
        c = a.fillStyle;a.fillStyle = a.strokeStyle;a.fillRect(d + g / -2, b + g / -2, g, g);a.fillStyle = c;
  },
      u = function u(b, a) {
    var d = new k(b.x[a - 1], b.y[a - 1]),
        g = new k(b.x[a], b.y[a]),
        c = d.getVectorToPoint(g);if (1 < a) {
      var f = new k(b.x[a - 2], b.y[a - 2]),
          l = f.getVectorToPoint(d),
          i;if (l.getLength() > this.lineCurveThreshold) {
        i = 2 < a ? new k(b.x[a - 3], b.y[a - 3]).getVectorToPoint(f) : new m(0, 0);var e = 0.35 * l.getLength(),
            h = l.angleTo(i.reverse()),
            p = c.angleTo(l.reverse());i = new m(i.x + l.x, i.y + l.y).resizeTo(Math.max(0.05, h) * e);var n = new m(l.x + c.x, l.y + c.y).reverse().resizeTo(Math.max(0.05, p) * e),
            l = this.canvasContext,
            e = f.x,
            p = f.y,
            h = d.x,
            w = d.y,
            A = f.x + i.x,
            f = f.y + i.y;i = d.x + n.x;n = d.y + n.y;l.beginPath();
        l.moveTo(e, p);l.bezierCurveTo(A, f, i, n, h, w);l.stroke();
      }
    }c.getLength() <= this.lineCurveThreshold && (c = this.canvasContext, f = d.x, d = d.y, i = g.x, g = g.y, c.beginPath(), c.moveTo(f, d), c.lineTo(i, g), c.stroke());
  },
      x = function x(b) {
    var a = b.x.length - 1;if (0 < a) {
      var d = new k(b.x[a], b.y[a]),
          g = new k(b.x[a - 1], b.y[a - 1]),
          c = g.getVectorToPoint(d);if (c.getLength() > this.lineCurveThreshold) {
        if (1 < a) {
          var b = new k(b.x[a - 2], b.y[a - 2]).getVectorToPoint(g),
              f = new m(b.x + c.x, b.y + c.y).resizeTo(c.getLength() / 2),
              c = this.canvasContext,
              b = g.x,
              a = g.y,
              l = d.x,
              i = d.y,
              e = g.x + f.x,
              g = g.y + f.y,
              f = d.x,
              d = d.y;c.beginPath();c.moveTo(b, a);c.bezierCurveTo(e, g, f, d, l, i);
        } else c = this.canvasContext, b = g.x, g = g.y, a = d.x, d = d.y, c.beginPath(), c.moveTo(b, g), c.lineTo(a, d);c.stroke();
      }
    }
  };r.prototype.resetCanvas = function (b) {
    var a = this.canvas,
        d = this.settings,
        c = this.canvasContext,
        f = this.isCanvasEmulator,
        l = a.width,
        i = a.height;c.clearRect(0, 0, l + 30, i + 30);c.shadowColor = c.fillStyle = d["background-color"];f && c.fillRect(0, 0, l + 30, i + 30);c.lineWidth = Math.ceil(parseInt(d.lineWidth, 10));c.lineCap = c.lineJoin = "round";c.strokeStyle = d["decor-color"];c.shadowOffsetX = 0;c.shadowOffsetY = 0;var h = Math.round(i / 5),
        p = 1.5 * h,
        k = i - h,
        l = l - 1.5 * h,
        i = i - h;c.beginPath();c.moveTo(p, k);c.lineTo(l, i);c.stroke();c.strokeStyle = d.color;f || (c.shadowColor = c.strokeStyle, c.shadowOffsetX = 0.5 * c.lineWidth, c.shadowOffsetY = -0.6 * c.lineWidth, c.shadowBlur = 0);b || (b = []);c = this.dataEngine = new t(b, this, z, u, x);d.data = b;$(a).data(e + ".data", b).data(e + ".settings", d);var n = this.$parent,
        w = this.events,
        A = e;c.changed = function () {
      w.publish(A + ".change");
      n.trigger("change");
    };c.changed();return !0;
  };r.prototype.initializeCanvas = function (b) {
    var a = document.createElement("canvas"),
        c = $(a);b.width === b.height && "ratio" === b.height && (b.width = "100%");c.css("margin", 0).css("padding", 0).css("border", "none").css("height", "ratio" === b.height || !b.height ? 1 : b.height.toString(10)).css("width", "ratio" === b.width || !b.width ? 1 : b.width.toString(10));c.appendTo(this.$parent);"ratio" === b.height ? c.css("height", Math.round(c.width() / b.sizeRatio)) : "ratio" === b.width && c.css("width", Math.round(c.height() * b.sizeRatio));c.addClass(e);a.width = c.width();a.height = c.height();b = a;if (b.getContext) b = !1;else {
      var c = b.ownerDocument.parentWindow,
          d = c.FlashCanvas ? b.ownerDocument.parentWindow.FlashCanvas : "undefined" === typeof FlashCanvas ? void 0 : FlashCanvas;if (d) {
        b = d.initElement(b);d = 1;c && c.screen && c.screen.deviceXDPI && c.screen.logicalXDPI && (d = 1 * c.screen.deviceXDPI / c.screen.logicalXDPI);if (1 !== d) try {
          $(b).children("object").get(0).resize(Math.ceil(b.width * d), Math.ceil(b.height * d)), b.getContext("2d").scale(d, d);
        } catch (f) {}b = !0;
      } else throw Error("Canvas element does not support 2d context. jSignature cannot proceed.");
    }this.isCanvasEmulator = b;a.onselectstart = function (b) {
      b && b.preventDefault && b.preventDefault();b && b.stopPropagation && b.stopPropagation();return !1;
    };return a;
  };var p = window,
      h = function h(b, a) {
    var c = new Image(),
        d = this;c.onload = function () {
      d.getContext("2d").drawImage(c, 0, 0, c.width < d.width ? c.width : d.width, c.height < d.height ? c.height : d.height);
    };c.src = "data:" + a + "," + b;
  },
      a = function a(b) {
    this.find("canvas." + e).add(this.filter("canvas." + e)).data(e + ".this").resetCanvas(b);return this;
  },
      f = function f(b, a) {
    if (void 0 === a && "string" === typeof b && "data:" === b.substr(0, 5) && (a = b.slice(5).split(",")[0], b = b.slice(6 + a.length), a === b)) return;var c = this.find("canvas." + e).add(this.filter("canvas." + e));if (n.hasOwnProperty(a)) 0 !== c.length && n[a].call(c[0], b, a, function (b) {
      return function () {
        return b.resetCanvas.apply(b, arguments);
      };
    }(c.data(e + ".this")));else throw Error(e + " is unable to find import plugin with for format '" + String(a) + "'");return this;
  },
      d = new v(),
      c = e,
      l,
      i = function i() {
    d.publish(c + ".parentresized");
  };$(p).bind("resize." + c, function () {
    l && clearTimeout(l);l = setTimeout(i, 500);
  }).bind("mouseup." + c, function () {
    d.publish(c + ".windowmouseup");
  });var w = {},
      A = { "default": function _default() {
      return this.toDataURL();
    }, "native": function native(b) {
      return b;
    }, image: function image() {
      var b = this.toDataURL();if ("string" === typeof b && 4 < b.length && "data:" === b.slice(0, 5) && -1 !== b.indexOf(",")) {
        var a = b.indexOf(",");return [b.slice(5, a), b.substr(a + 1)];
      }return [];
    } },
      n = { "native": function native(b, a, c) {
      c(b);
    }, image: h,
    "image/png;base64": h, "image/jpeg;base64": h, "image/jpg;base64": h },
      B = { "export": A, "import": n, instance: w },
      C = { init: function init(b) {
      return this.each(function () {
        var a,
            c = !1;for (a = this.parentNode; a && !c;) {
          c = a.body, a = a.parentNode;
        }!c || new r(this, b, w);
      });
    }, getSettings: function getSettings() {
      return this.find("canvas." + e).add(this.filter("canvas." + e)).data(e + ".this").settings;
    }, clear: a, reset: a, addPlugin: function addPlugin(b, a, c) {
      B.hasOwnProperty(b) && (B[b][a] = c);return this;
    }, listPlugins: function listPlugins(b) {
      var a = [];if (B.hasOwnProperty(b)) {
        var b = B[b],
            c;for (c in b) {
          b.hasOwnProperty(c) && a.push(c);
        }
      }return a;
    }, getData: function getData(b) {
      var a = this.find("canvas." + e).add(this.filter("canvas." + e));void 0 === b && (b = "default");if (0 !== a.length && A.hasOwnProperty(b)) return A[b].call(a.get(0), a.data(e + ".data"));
    }, importData: f, setData: f, globalEvents: function globalEvents() {
      return d;
    }, events: function events() {
      return this.find("canvas." + e).add(this.filter("canvas." + e)).data(e + ".this").events;
    } };$.fn[e] = function (b) {
    if (!b || "object" === (typeof b === "undefined" ? "undefined" : _typeof(b))) return C.init.apply(this, arguments);if ("string" === typeof b && C[b]) return C[b].apply(this, Array.prototype.slice.call(arguments, 1));$.error("Method " + String(b) + " does not exist on jQuery." + e);
  };
})();
(function () {
  $.fn.jSignature("addPlugin", "instance", "UndoButton", function (q) {
    this.events.subscribe("jSignature.attachingEventHandlers", function () {
      if (this.settings[q]) {
        var m = this.settings[q];"function" !== typeof m && (m = function m() {
          var e = $('<input type="button" value="Undo last stroke" style="position:absolute;display:none;margin:0 !important;top:auto" />').appendTo(this.$controlbarLower),
              k = e.width();e.css("left", Math.round((this.canvas.width - k) / 2));k !== e.width() && e.width(k);return e;
        });var k = m.call(this),
            t = this;t.events.subscribe("jSignature.change", function () {
          t.dataEngine.data.length ? k.show() : k.hide();
        });var r = this,
            e = (this.events.topics.hasOwnProperty("jSignature.undo") ? q : "jSignature") + ".undo";k.bind("click", function () {
          r.events.publish(e);
        });r.events.subscribe(e, function () {
          var e = r.dataEngine.data;e.length && (e.pop(), r.resetCanvas(e));
        });
      }
    });
  });
})();
(function () {
  for (var q = {}, m = {}, k = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWX".split(""), t = k.length / 2, r = t - 1; -1 < r; r--) {
    q[k[r]] = k[r + t], m[k[r + t]] = k[r];
  }var e = function e(e) {
    for (var e = e.split(""), h = e.length, a = 1; a < h; a++) {
      e[a] = q[e[a]];
    }return e.join("");
  },
      y = function y(k) {
    for (var h = [], a = 0, f = 1, d = k.length, c, l, i = 0; i < d; i++) {
      c = Math.round(k[i]), l = c - a, a = c, 0 > l && 0 < f ? (f = -1, h.push("Z")) : 0 < l && 0 > f && (f = 1, h.push("Y")), c = Math.abs(l), c >= t ? h.push(e(c.toString(t))) : h.push(c.toString(t));
    }return h.join("");
  },
      v = function v(e) {
    for (var h = [], e = e.split(""), a = e.length, f, d = 1, c = [], l = 0, i = 0; i < a; i++) {
      f = e[i], f in q || "Z" === f || "Y" === f ? (0 !== c.length && (c = parseInt(c.join(""), t) * d + l, h.push(c), l = c), "Z" === f ? (d = -1, c = []) : "Y" === f ? (d = 1, c = []) : c = [f]) : c.push(m[f]);
    }h.push(parseInt(c.join(""), t) * d + l);return h;
  },
      z = function z(e) {
    for (var h = [], a = e.length, f, d = 0; d < a; d++) {
      f = e[d], h.push(y(f.x)), h.push(y(f.y));
    }return h.join("_");
  },
      u = function u(e) {
    for (var h = [], e = e.split("_"), a = e.length / 2, f = 0; f < a; f++) {
      h.push({ x: v(e[2 * f]), y: v(e[2 * f + 1]) });
    }return h;
  },
      k = function k(e) {
    return ["image/jsignature;base30", z(e)];
  },
      r = function r(e, h, a) {
    "string" === typeof e && ("image/jsignature;base30" === e.substring(0, 23).toLowerCase() && (e = e.substring(24)), a(u(e)));
  };if (null == this.jQuery) throw Error("We need jQuery for some of the functionality. jQuery is not detected. Failing to initialize...");var x = this.jQuery.fn.jSignature;x("addPlugin", "export", "base30", k);x("addPlugin", "export", "image/jsignature;base30", k);x("addPlugin", "import", "base30", r);x("addPlugin", "import", "image/jsignature;base30", r);this.jSignatureDebug && (this.jSignatureDebug.base30 = { remapTailChars: e, compressstrokeleg: y, uncompressstrokeleg: v, compressstrokes: z, uncompressstrokes: u, charmap: q });
}).call("undefined" !== typeof window ? window : undefined);
(function () {
  function q(a, f) {
    this.x = a;this.y = f;this.reverse = function () {
      return new this.constructor(-1 * this.x, -1 * this.y);
    };this._length = null;this.getLength = function () {
      this._length || (this._length = Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2)));return this._length;
    };var d = function d(a) {
      return Math.round(a / Math.abs(a));
    };this.resizeTo = function (a) {
      if (0 === this.x && 0 === this.y) this._length = 0;else if (0 === this.x) this._length = a, this.y = a * d(this.y);else if (0 === this.y) this._length = a, this.x = a * d(this.x);else {
        var f = Math.abs(this.y / this.x),
            e = Math.sqrt(Math.pow(a, 2) / (1 + Math.pow(f, 2))),
            f = f * e;this._length = a;this.x = e * d(this.x);this.y = f * d(this.y);
      }return this;
    };this.angleTo = function (a) {
      var d = this.getLength() * a.getLength();return 0 === d ? 0 : Math.acos(Math.min(Math.max((this.x * a.x + this.y * a.y) / d, -1), 1)) / Math.PI;
    };
  }function m(a, f) {
    this.x = a;this.y = f;this.getVectorToCoordinates = function (a, c) {
      return new q(a - this.x, c - this.y);
    };this.getVectorFromCoordinates = function (a, c) {
      return this.getVectorToCoordinates(a, c).reverse();
    };this.getVectorToPoint = function (a) {
      return new q(a.x - this.x, a.y - this.y);
    };this.getVectorFromPoint = function (a) {
      return this.getVectorToPoint(a).reverse();
    };
  }function k(a, f) {
    var d = Math.pow(10, f);return Math.round(a * d) / d;
  }function t(a, f, d) {
    var f = f + 1,
        c = new m(a.x[f - 1], a.y[f - 1]),
        e = new m(a.x[f], a.y[f]),
        e = c.getVectorToPoint(e),
        i = new m(a.x[f - 2], a.y[f - 2]),
        c = i.getVectorToPoint(c);return c.getLength() > d ? (d = 2 < f ? new m(a.x[f - 3], a.y[f - 3]).getVectorToPoint(i) : new q(0, 0), a = 0.35 * c.getLength(), i = c.angleTo(d.reverse()), f = e.angleTo(c.reverse()), d = new q(d.x + c.x, d.y + c.y).resizeTo(Math.max(0.05, i) * a), e = new q(c.x + e.x, c.y + e.y).reverse().resizeTo(Math.max(0.05, f) * a), e = new q(c.x + e.x, c.y + e.y), ["c", k(d.x, 2), k(d.y, 2), k(e.x, 2), k(e.y, 2), k(c.x, 2), k(c.y, 2)]) : ["l", k(c.x, 2), k(c.y, 2)];
  }function r(a, f) {
    var d = a.x.length - 1,
        c = new m(a.x[d], a.y[d]),
        e = new m(a.x[d - 1], a.y[d - 1]),
        c = e.getVectorToPoint(c);if (1 < d && c.getLength() > f) {
      var d = new m(a.x[d - 2], a.y[d - 2]).getVectorToPoint(e),
          e = c.angleTo(d.reverse()),
          i = 0.35 * c.getLength(),
          d = new q(d.x + c.x, d.y + c.y).resizeTo(Math.max(0.05, e) * i);return ["c", k(d.x, 2), k(d.y, 2), k(c.x, 2), k(c.y, 2), k(c.x, 2), k(c.y, 2)];
    }return ["l", k(c.x, 2), k(c.y, 2)];
  }function e(a, e, d) {
    for (var e = ["M", k(a.x[0] - e, 2), k(a.y[0] - d, 2)], d = 1, c = a.x.length - 1; d < c; d++) {
      e.push.apply(e, t(a, d, 1));
    }0 < c ? e.push.apply(e, r(a, d, 1)) : 0 === c && e.push.apply(e, ["l", 1, 1]);return e.join(" ");
  }function y(a) {
    var f = ['<?xml version="1.0" encoding="UTF-8" standalone="no"?>', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">'],
        d,
        c = a.length,
        l,
        i = [],
        h = [],
        k = l = d = 0,
        n = 0,
        p = [];if (0 !== c) {
      for (d = 0; d < c; d++) {
        k = a[d];n = [];l = { x: [], y: [] };for (var m = void 0, b = void 0, m = 0, b = k.x.length; m < b; m++) {
          n.push({ x: k.x[m], y: k.y[m] });
        }n = simplify(n, 0.7, !0);m = 0;for (b = n.length; m < b; m++) {
          l.x.push(n[m].x), l.y.push(n[m].y);
        }p.push(l);i = i.concat(l.x);h = h.concat(l.y);
      }a = Math.min.apply(null, i) - 1;c = Math.max.apply(null, i) + 1;i = Math.min.apply(null, h) - 1;h = Math.max.apply(null, h) + 1;k = 0 > a ? 0 : a;n = 0 > i ? 0 : i;d = c - a;l = h - i;
    }f.push('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + d.toString() + '" height="' + l.toString() + '">');d = 0;for (c = p.length; d < c; d++) {
      l = p[d], f.push('<path fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="' + e(l, k, n) + '"/>');
    }f.push("</svg>");return f.join("");
  }function v(a) {
    return [p, y(a)];
  }function z(a) {
    return [h, x(y(a))];
  }var u = window;"use strict";( true ? exports : u).simplify = function (a, e, d) {
    e = void 0 !== e ? e * e : 1;if (!d) {
      for (var c = a.length, l, i = a[0], h = [i], d = 1; d < c; d++) {
        l = a[d];var k = l.x - i.x,
            n = l.y - i.y;k * k + n * n > e && (h.push(l), i = l);
      }a = (i !== l && h.push(l), h);
    }l = a;var d = l.length,
        c = new ("undefined" != typeof Uint8Array ? Uint8Array : Array)(d),
        i = 0,
        h = d - 1,
        m,
        p,
        b = [],
        j = [],
        s = [];for (c[i] = c[h] = 1; h;) {
      n = 0;for (k = i + 1; k < h; k++) {
        m = l[k];var g = l[i],
            r = l[h],
            q = g.x,
            t = g.y,
            g = r.x - q,
            u = r.y - t,
            v = void 0;if (0 !== g || 0 !== u) v = ((m.x - q) * g + (m.y - t) * u) / (g * g + u * u), 1 < v ? (q = r.x, t = r.y) : 0 < v && (q += g * v, t += u * v);m = (g = m.x - q, u = m.y - t, g * g + u * u);m > n && (p = k, n = m);
      }n > e && (c[p] = 1, b.push(i), j.push(p), b.push(p), j.push(h));i = b.pop();h = j.pop();
    }for (k = 0; k < d; k++) {
      c[k] && s.push(l[k]);
    }return a = s, a;
  };if ("function" !== typeof x) var x = function x(a) {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split(""),
        d,
        c,
        h,
        i,
        k = 0,
        m = 0,
        n = "",
        n = [];do {
      d = a.charCodeAt(k++), c = a.charCodeAt(k++), h = a.charCodeAt(k++), i = d << 16 | c << 8 | h, d = i >> 18 & 63, c = i >> 12 & 63, h = i >> 6 & 63, i &= 63, n[m++] = e[d] + e[c] + e[h] + e[i];
    } while (k < a.length);n = n.join("");a = a.length % 3;return (a ? n.slice(0, a - 3) : n) + "===".slice(a || 3);
  };var p = "image/svg+xml",
      h = "image/svg+xml;base64";if ("undefined" === typeof $) throw Error("We need jQuery for some of the functionality. jQuery is not detected. Failing to initialize...");u = $.fn.jSignature;u("addPlugin", "export", "svg", v);u("addPlugin", "export", p, v);u("addPlugin", "export", "svgbase64", z);u("addPlugin", "export", h, z);
})();

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 FlashCanvas, 2012-11-01T22:38 commit ID 34a50cbe6aeb11e050c7d41e8e2cf266a345aeed
 Copyright 2012 Willow Systems Corp
 Copyright (c) 2009      Tim Cameron Ryan
 Copyright (c) 2009-2011 FlashCanvas Project
 Released under the MIT/X License
*/
window.ActiveXObject && !window.CanvasRenderingContext2D && function () {
  function D(a) {
    return ((a[C + "Options"] || {}).swfPath || K) + "flashcanvas.swf";
  }function s(a) {
    return ("" + a).replace(/&/g, "&amp;").replace(/</g, "&lt;");
  }function i(a) {
    throw new E(a);
  }function F(a) {
    var b = parseInt(a.width, 10),
        c = parseInt(a.height, 10);if (isNaN(b) || 0 > b) b = 300;if (isNaN(c) || 0 > c) c = 150;a.width = b;a.height = c;
  }var G = this.document,
      t = "canvas",
      C = "FlashCanvas",
      H = "onreadystatechange",
      n;a: {
    n = this.document.getElementsByTagName("script");var I = "",
        u = n.length;if (u) for (I = n[u - 1].src || ""; u;) {
      script = n[u - 1];if (script.src && script.src.match("flashcanvas")) {
        n = 8 <= G.documentMode ? script.src : script.getAttribute("src", 4);break a;
      }u--;
    }n = I;
  }var K = n.replace(/[^\/]+$/, ""),
      e = new function (a) {
    for (var b = 0, c = a.length; b < c; b++) {
      this[a[b]] = b;
    }
  }("toDataURL save restore scale rotate translate transform setTransform globalAlpha globalCompositeOperation strokeStyle fillStyle createLinearGradient createRadialGradient createPattern lineWidth lineCap lineJoin miterLimit shadowOffsetX shadowOffsetY shadowBlur shadowColor clearRect fillRect strokeRect beginPath closePath moveTo lineTo quadraticCurveTo bezierCurveTo arcTo rect arc fill stroke clip isPointInPath font textAlign textBaseline fillText strokeText measureText drawImage createImageData getImageData putImageData addColorStop direction resize".split(" ")),
      v = {},
      p = {},
      q = {},
      x = {},
      y = {},
      w = function w(a, b) {
    this.canvas = a;this._swf = b;this._canvasId = b.id.slice(8);this._initialize();this._gradientPatternId = 0;this._font = this._direction = "";var c = this;this._executeCommandIntervalID = setInterval(function () {
      for (var a = c.canvas, b = !1, a = a.parentNode; a && !b;) {
        b = a.body, a = a.parentNode;
      }b ? 0 === q[c._canvasId] && c._executeCommand() : clearInterval(c._executeCommandIntervalID);
    }, 30);
  };w.prototype = { save: function save() {
      this._setCompositing();this._setShadows();this._setStrokeStyle();this._setFillStyle();
      this._setLineStyles();this._setFontStyles();this._stateStack.push([this._globalAlpha, this._globalCompositeOperation, this._strokeStyle, this._fillStyle, this._lineWidth, this._lineCap, this._lineJoin, this._miterLimit, this._shadowOffsetX, this._shadowOffsetY, this._shadowBlur, this._shadowColor, this._font, this._textAlign, this._textBaseline]);this._queue.push(e.save);
    }, restore: function restore() {
      var a = this._stateStack;a.length && (a = a.pop(), this.globalAlpha = a[0], this.globalCompositeOperation = a[1], this.strokeStyle = a[2], this.fillStyle = a[3], this.lineWidth = a[4], this.lineCap = a[5], this.lineJoin = a[6], this.miterLimit = a[7], this.shadowOffsetX = a[8], this.shadowOffsetY = a[9], this.shadowBlur = a[10], this.shadowColor = a[11], this.font = a[12], this.textAlign = a[13], this.textBaseline = a[14]);this._queue.push(e.restore);
    }, scale: function scale(a, b) {
      this._queue.push(e.scale, a, b);
    }, rotate: function rotate(a) {
      this._queue.push(e.rotate, a);
    }, translate: function translate(a, b) {
      this._queue.push(e.translate, a, b);
    }, transform: function transform(a, b, c, d, f, g) {
      this._queue.push(e.transform, a, b, c, d, f, g);
    }, setTransform: function setTransform(a, b, c, d, f, g) {
      this._queue.push(e.setTransform, a, b, c, d, f, g);
    }, _setCompositing: function _setCompositing() {
      var a = this._queue;this._globalAlpha !== this.globalAlpha && (this._globalAlpha = this.globalAlpha, a.push(e.globalAlpha, this._globalAlpha));this._globalCompositeOperation !== this.globalCompositeOperation && (this._globalCompositeOperation = this.globalCompositeOperation, a.push(e.globalCompositeOperation, this._globalCompositeOperation));
    }, _setStrokeStyle: function _setStrokeStyle() {
      if (this._strokeStyle !== this.strokeStyle) {
        var a = this._strokeStyle = this.strokeStyle;if ("string" !== typeof a) if (a instanceof r || a instanceof z) a = a.id;else return;this._queue.push(e.strokeStyle, a);
      }
    }, _setFillStyle: function _setFillStyle() {
      if (this._fillStyle !== this.fillStyle) {
        var a = this._fillStyle = this.fillStyle;if ("string" !== typeof a) if (a instanceof r || a instanceof z) a = a.id;else return;this._queue.push(e.fillStyle, a);
      }
    }, createLinearGradient: function createLinearGradient(a, b, c, d) {
      (!isFinite(a) || !isFinite(b) || !isFinite(c) || !isFinite(d)) && i(9);this._queue.push(e.createLinearGradient, a, b, c, d);return new r(this);
    }, createRadialGradient: function createRadialGradient(a, b, c, d, f, g) {
      (!isFinite(a) || !isFinite(b) || !isFinite(c) || !isFinite(d) || !isFinite(f) || !isFinite(g)) && i(9);(0 > c || 0 > g) && i(1);this._queue.push(e.createRadialGradient, a, b, c, d, f, g);return new r(this);
    }, createPattern: function createPattern(a, b) {
      a || i(17);var c = a.tagName,
          d,
          f = this._canvasId;if (c) {
        if (c = c.toLowerCase(), "img" === c) d = a.getAttribute("src", 2);else {
          if (c === t || "video" === c) return;i(17);
        }
      } else a.src ? d = a.src : i(17);"repeat" === b || "no-repeat" === b || "repeat-x" === b || "repeat-y" === b || "" === b || null === b || i(12);this._queue.push(e.createPattern, s(d), b);!p[f][d] && v[f] && (this._executeCommand(), ++q[f], p[f][d] = !0);return new z(this);
    }, _setLineStyles: function _setLineStyles() {
      var a = this._queue;this._lineWidth !== this.lineWidth && (this._lineWidth = this.lineWidth, a.push(e.lineWidth, this._lineWidth));this._lineCap !== this.lineCap && (this._lineCap = this.lineCap, a.push(e.lineCap, this._lineCap));this._lineJoin !== this.lineJoin && (this._lineJoin = this.lineJoin, a.push(e.lineJoin, this._lineJoin));this._miterLimit !== this.miterLimit && (this._miterLimit = this.miterLimit, a.push(e.miterLimit, this._miterLimit));
    }, _setShadows: function _setShadows() {
      var a = this._queue;this._shadowOffsetX !== this.shadowOffsetX && (this._shadowOffsetX = this.shadowOffsetX, a.push(e.shadowOffsetX, this._shadowOffsetX));this._shadowOffsetY !== this.shadowOffsetY && (this._shadowOffsetY = this.shadowOffsetY, a.push(e.shadowOffsetY, this._shadowOffsetY));this._shadowBlur !== this.shadowBlur && (this._shadowBlur = this.shadowBlur, a.push(e.shadowBlur, this._shadowBlur));this._shadowColor !== this.shadowColor && (this._shadowColor = this.shadowColor, a.push(e.shadowColor, this._shadowColor));
    }, clearRect: function clearRect(a, b, c, d) {
      this._queue.push(e.clearRect, a, b, c, d);
    }, fillRect: function fillRect(a, b, c, d) {
      this._setCompositing();this._setShadows();this._setFillStyle();this._queue.push(e.fillRect, a, b, c, d);
    }, strokeRect: function strokeRect(a, b, c, d) {
      this._setCompositing();this._setShadows();this._setStrokeStyle();this._setLineStyles();this._queue.push(e.strokeRect, a, b, c, d);
    }, beginPath: function beginPath() {
      this._queue.push(e.beginPath);
    }, closePath: function closePath() {
      this._queue.push(e.closePath);
    },
    moveTo: function moveTo(a, b) {
      this._queue.push(e.moveTo, a, b);
    }, lineTo: function lineTo(a, b) {
      this._queue.push(e.lineTo, a, b);
    }, quadraticCurveTo: function quadraticCurveTo(a, b, c, d) {
      this._queue.push(e.quadraticCurveTo, a, b, c, d);
    }, bezierCurveTo: function bezierCurveTo(a, b, c, d, f, g) {
      this._queue.push(e.bezierCurveTo, a, b, c, d, f, g);
    }, arcTo: function arcTo(a, b, c, d, f) {
      0 > f && isFinite(f) && i(1);this._queue.push(e.arcTo, a, b, c, d, f);
    }, rect: function rect(a, b, c, d) {
      this._queue.push(e.rect, a, b, c, d);
    }, arc: function arc(a, b, c, d, f, g) {
      0 > c && isFinite(c) && i(1);this._queue.push(e.arc, a, b, c, d, f, g ? 1 : 0);
    },
    fill: function fill() {
      this._setCompositing();this._setShadows();this._setFillStyle();this._queue.push(e.fill);
    }, stroke: function stroke() {
      this._setCompositing();this._setShadows();this._setStrokeStyle();this._setLineStyles();this._queue.push(e.stroke);
    }, clip: function clip() {
      this._queue.push(e.clip);
    }, isPointInPath: function isPointInPath() {}, _setFontStyles: function _setFontStyles() {
      var a = this._queue;if (this._font !== this.font) try {
        var b = y[this._canvasId];b.style.font = this._font = this.font;var c = b.currentStyle,
            d = [c.fontStyle, c.fontWeight, b.offsetHeight, c.fontFamily].join(" ");a.push(e.font, d);
      } catch (f) {}this._textAlign !== this.textAlign && (this._textAlign = this.textAlign, a.push(e.textAlign, this._textAlign));this._textBaseline !== this.textBaseline && (this._textBaseline = this.textBaseline, a.push(e.textBaseline, this._textBaseline));this._direction !== this.canvas.currentStyle.direction && (this._direction = this.canvas.currentStyle.direction, a.push(e.direction, this._direction));
    }, fillText: function fillText(a, b, c, d) {
      this._setCompositing();this._setFillStyle();this._setShadows();
      this._setFontStyles();this._queue.push(e.fillText, s(a), b, c, void 0 === d ? Infinity : d);
    }, strokeText: function strokeText(a, b, c, d) {
      this._setCompositing();this._setStrokeStyle();this._setShadows();this._setFontStyles();this._queue.push(e.strokeText, s(a), b, c, void 0 === d ? Infinity : d);
    }, measureText: function measureText(a) {
      var b = y[this._canvasId];try {
        b.style.font = this.font;
      } catch (c) {}b.innerText = a.replace(/[ \n\f\r]/g, "\t");return new L(b.offsetWidth);
    }, drawImage: function drawImage(a, b, c, d, f, g, j, M, N) {
      a || i(17);var h = a.tagName,
          k,
          l = arguments.length,
          A = this._canvasId;if (h) {
        if (h = h.toLowerCase(), "img" === h) k = a.getAttribute("src", 2);else {
          if (h === t || "video" === h) return;i(17);
        }
      } else a.src ? k = a.src : i(17);this._setCompositing();this._setShadows();k = s(k);if (3 === l) this._queue.push(e.drawImage, l, k, b, c);else if (5 === l) this._queue.push(e.drawImage, l, k, b, c, d, f);else if (9 === l) (0 === d || 0 === f) && i(1), this._queue.push(e.drawImage, l, k, b, c, d, f, g, j, M, N);else return;!p[A][k] && v[A] && (this._executeCommand(), ++q[A], p[A][k] = !0);
    }, createImageData: function createImageData() {}, getImageData: function getImageData() {},
    putImageData: function putImageData() {}, loadImage: function loadImage(a, b, c) {
      var d = a.tagName,
          f,
          g = this._canvasId;d ? "img" === d.toLowerCase() && (f = a.getAttribute("src", 2)) : a.src && (f = a.src);if (f && !p[g][f]) {
        if (b || c) x[g][f] = [a, b, c];this._queue.push(e.drawImage, 1, s(f));v[g] && (this._executeCommand(), ++q[g], p[g][f] = !0);
      }
    }, _initialize: function _initialize() {
      this.globalAlpha = this._globalAlpha = 1;this.globalCompositeOperation = this._globalCompositeOperation = "source-over";this.fillStyle = this._fillStyle = this.strokeStyle = this._strokeStyle = "#000000";this.lineWidth = this._lineWidth = 1;this.lineCap = this._lineCap = "butt";this.lineJoin = this._lineJoin = "miter";this.miterLimit = this._miterLimit = 10;this.shadowBlur = this._shadowBlur = this.shadowOffsetY = this._shadowOffsetY = this.shadowOffsetX = this._shadowOffsetX = 0;this.shadowColor = this._shadowColor = "rgba(0, 0, 0, 0.0)";this.font = this._font = "10px sans-serif";this.textAlign = this._textAlign = "start";this.textBaseline = this._textBaseline = "alphabetic";this._queue = [];this._stateStack = [];
    }, _flush: function _flush() {
      var a = this._queue;this._queue = [];return a;
    }, _executeCommand: function _executeCommand() {
      var a = this._flush();if (0 < a.length) try {
        return eval(this._swf.CallFunction('<invoke name="executeCommand" returntype="javascript"><arguments><string>' + a.join("&#0;") + "</string></arguments></invoke>"));
      } catch (b) {}
    }, _resize: function _resize(a, b) {
      this._executeCommand();this._initialize();0 < a && (this._swf.width = a);0 < b && (this._swf.height = b);this._queue.push(e.resize, a, b);
    } };var r = function r(a) {
    this._ctx = a;this.id = a._gradientPatternId++;
  };r.prototype = { addColorStop: function addColorStop(a, b) {
      (isNaN(a) || 0 > a || 1 < a) && i(1);this._ctx._queue.push(e.addColorStop, this.id, a, b);
    } };var z = function z(a) {
    this.id = a._gradientPatternId++;
  },
      L = function L(a) {
    this.width = a;
  },
      E = function E(a) {
    this.code = a;this.message = { 1: "INDEX_SIZE_ERR", 9: "NOT_SUPPORTED_ERR", 11: "INVALID_STATE_ERR", 12: "SYNTAX_ERR", 17: "TYPE_MISMATCH_ERR", 18: "SECURITY_ERR" }[a];
  };E.prototype = Error();var J = "initElement",
      m = { registeredEvents: {}, canvases: {}, initWindow: function initWindow(a) {
      function b() {
        if ("complete" === a.document.readyState) {
          a.document.detachEvent(H, b);for (var c = a.document.getElementsByTagName(t), d = 0, e = c.length; d < e; ++d) {
            m[J](c[d]);
          }
        }
      }var c = a.document;c.createElement(t);c.createStyleSheet().cssText = t + "{display:inline-block;overflow:hidden;width:300px;height:150px}";var d = this.canvases,
          e = this.registeredEvents,
          g = function g() {
        a.detachEvent("onunload", g);var b, c, h, k, l, j, B;for (B in d) {
          if (b = d[B], c = b.firstChild, k = b.ownerDocument.defaultView ? b.ownerDocument.defaultView : b.ownerDocument.parentWindow, a === k) {
            for (h in c) {
              "function" === typeof c[h] && (c[h] = null);
            }for (h in b) {
              "function" === typeof b[h] && (b[h] = null);
            }k = 0;for (l = e[B].length; k !== l; k++) {
              j = e[B][k], c.detachEvent(j[0], j[1]), b.detachEvent(j[0], j[1]);
            }
          }
        }a.CanvasRenderingContext2D = null;a.CanvasGradient = null;a.CanvasPattern = null;a[C] = null;
      };a.attachEvent("onunload", g);a.CanvasRenderingContext2D = w;a.CanvasGradient = r;a.CanvasPattern = z;a[C] = m;var j = D(a);0 === j.indexOf(a.location.protocol + "//" + a.location.host + "/") && a.setTimeout(function () {
        var a = new ActiveXObject("Microsoft.XMLHTTP");a.open("GET", j, !1);a.send(null);
      }, 0);"complete" === a.document.readyState ? b() : a.document.attachEvent(H, b);
    } };m[J] = function (a) {
    if (a.getContext) return a;var b = a.ownerDocument,
        c = b.defaultView ? b.defaultView : b.parentWindow;c.CanvasRenderingContext2D || this.initWindow(c);var d = Math.random().toString(36).slice(2) || "0",
        f = "external" + d;v[d] = !1;p[d] = {};q[d] = 1;x[d] = {};this.registeredEvents[d] = [];F(a);var g = D(c);a.innerHTML = '<object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" codebase="' + ("https:" === c.location.protocol ? "https:" : "http:") + '//fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,0,0" width="100%" height="100%" id="' + f + '"><param name="allowScriptAccess" value="always"><param name="flashvars" value="id=' + f + '"><param name="wmode" value="transparent"></object><span style="margin:0;padding:0;border:0;display:inline-block;position:static;height:1em;overflow:visible;white-space:nowrap"></span>';this.canvases[d] = a;var j = a.firstChild;y[d] = a.lastChild;var i = b.body.contains;if (i(a)) j.movie = g;else var m = c.setInterval(function () {
      i(a) && (c.clearInterval(m), j.movie = g);
    }, 2);if ("BackCompat" === b.compatMode || !c.XMLHttpRequest) y[d].style.overflow = "hidden";var h = new w(a, j);a.getContext = function (a) {
      return "2d" === a ? h : null;
    };a.toDataURL = function (a, b) {
      "image/jpeg" === ("" + a).toLowerCase() ? h._queue.push(e.toDataURL, a, "number" === typeof b ? b : "") : h._queue.push(e.toDataURL, a);return h._executeCommand();
    };b = function b(a) {
      var a = a ? a.srcElement : c.event.srcElement,
          b = a.parentNode;a.blur();b.focus();
    };this.registeredEvents[d].push(["onfocus", b]);j.attachEvent("onfocus", b);return a;
  };m.saveImage = function (a) {
    a.firstChild.saveImage();
  };m.setOptions = function () {};m.trigger = function (a, b) {
    this.canvases[a].fireEvent("on" + b);
  };m.unlock = function (a, b, c) {
    try {
      var d, e, g, j, i, m, h, k, l;if (void 0 === b) d = this.canvases[a], e = d.firstChild, k = d.ownerDocument, l = k.defaultView ? k.defaultView : k.parentWindow, F(d), g = d.width, j = d.height, d.style.width = g + "px", d.style.height = j + "px", 0 < g && (e.width = g), 0 < j && (e.height = j), e.resize(g, j), b = function b(a) {
        var a = a ? a : l.event,
            b = a.propertyName;if ("width" === b || "height" === b) {
          var a = a.srcElement,
              c = a[b],
              d = parseInt(c, 10);if (isNaN(d) || 0 > d) d = "width" === b ? 300 : 150;c === d ? (a.style[b] = d + "px", a.getContext("2d")._resize(a.width, a.height)) : a[b] = d;
        }
      }, this.registeredEvents[a].push(["onpropertychange", b]), d.attachEvent("onpropertychange", b), v[a] = !0, "function" === typeof d.onload && l.setTimeout(function () {
        d.onload();
      }, 0);else if (i = x[a][b]) m = i[0], h = i[1 + c], delete x[a][b], "function" === typeof h && h.call(m);q[a] && --q[a];
    } catch (n) {
      throw console.log("Call to FlashCanvas.unlock had thrown an error: ", n.message), n;
    }
  };m.initWindow(this, G);keep = [w.measureText, w.loadImage];
}.call(window);

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * SurveyLogic
                                                                                                                                                                                                                                                                   * This class should handle all client side business logic associated with a survey.
                                                                                                                                                                                                                                                                   * This includes, but should not be limited to:
                                                                                                                                                                                                                                                                   * 		Client side validation bindings
                                                                                                                                                                                                                                                                   * 		Immediate branching rules or actions
                                                                                                                                                                                                                                                                   * 		Local (page) branching/piping logic
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * @param {Object} logic
                                                                                                                                                                                                                                                                   * 		variables: Array of objects containing at least an 'id' attribute
                                                                                                                                                                                                                                                                   */

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _FileUploadField = __webpack_require__(1205);

var _FileUploadField2 = _interopRequireDefault(_FileUploadField);

var _modals = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var STRINGS = __webpack_require__(2368);

function getVariableQuery(variable) {
	variable = variable.replace(/(:|\.)/g, '\\$1');

	var res = $('#x' + variable + ' input ,' + '#x' + variable + ' select ,' + '#x' + variable + ' textarea ,' + '.x' + variable + ' input ,' + '.x' + variable + ' select, ' + '.x' + variable + ' textarea ').not('#x' + variable + ' .append-to-previous *, .x' + variable + '.append-to-previous *');

	return res;
}

function SurveyLogic(config) {
	var that = this;

	if (!config) {
		config = {};
	}
	if (!config.variables) {
		config.variables = [];
	}

	var wordCountValidation = function wordCountValidation(ele, variable) {
		var errorMsg = WORD_ENTERED + ": {count}. ";

		if (variable.validation.minWords) {
			errorMsg += MINIMUM + ": {min} ";
		}
		if (variable.validation.maxWords) {
			errorMsg += MAXIMUM + ": {max}";
		}

		if (variable.validation.errorMsg != gettext('Invalid entry.') && variable.validation.errorMsg) {
			errorMsg = variable.validation.errorMsg;
		}

		var parent = ele.parents('div:first');

		if (!parent.find('.word-count').length) {
			parent.append($('<div class="word-count"/>').html(errorMsg.replace('{count}', '<span class="entered"/>').replace('{min}', '<span class="min"/>').replace('{max}', '<span class="max"/>')));
		}

		parent.find('.word-count .min').text(variable.validation.minWords);
		parent.find('.word-count .max').text(variable.validation.maxWords);
		var val = ele.val();

		val = val.replace(/[\n\r\ ]/gi, ' ');
		val = val.replace(/-/g, ''); //replace with dashes with nothing

		var val_split = val.split(' ');
		var count = 0;

		for (var i = 0; i < val_split.length; i++) {
			if (val_split[i].trim() != '') {
				count++;
			}
		}

		parent.find('.word-count .entered').text(count);
	};

	var characterCountValidation = function characterCountValidation(ele, variable) {
		var parent = ele.parents('div:first');
		if (!parent.find('.character-count').length) {
			parent.append($('<span><\/span>', { 'class': 'character-count' }).html('<br/>' + CHAR_ENTERED + ': <span class="entered"></span><br />' + MINIMUM + ': <span class="min"></span> ' + MAXIMUM + ': <span class="max"></span>'));
			parent.find('.character-count .min').text(variable.validation.minLength);
			parent.find('.character-count .max').text(variable.validation.maxLength);
		}
		var val = ele.val();

		parent.find('.character-count .entered').text(val.length);
		if (val.length > variable.validation.maxLength || val.length < variable.validation.minLength) {
			parent.find('.character-count').css({ 'color': 'red' });
		} else {
			parent.find('.character-count').css({ 'color': 'black' });
		}
	};

	$.each(config.variables, function (i, variable) {
		(function (variable) {
			that[variable.id] = {};
			$.extend(that[variable.id], variable, {
				element: getVariableQuery(variable.id)
			});

			if (variable.validation) {
				//On page load if the textarea has wordCount validation and has a value show some info
				if (variable.validation.type == 'wordCount' && that[variable.id].element.val() != '') {
					wordCountValidation(that[variable.id].element, variable);
				} else if (variable.validation.type == 'all' && that[variable.id].element.val() != '') {
					characterCountValidation(that[variable.id].element, variable);
				}

				variable.validation.regex = variable.validation.regex || '.*';
				that[variable.id].element.bind('keyup mouseup', function (e) {
					if (variable.validation.maxLength && $(this).val().length > variable.validation.maxLength) {
						//$(this).val($(this).val().substr(0, variable.validation.maxLength));
					}

					if (variable.validation.type == 'wordCount') {
						wordCountValidation($(this), variable);
					} else if (variable.validation.type == 'all') {
						characterCountValidation($(this), variable);
					}
				}).blur(function (e) {
					var valid = true;
					if (new RegExp(variable.validation.regex, 'm').test($(this).val())) {
						if (variable.validation.maxLength && $(this).val().length > variable.validation.maxLength) {
							//$(this).val($(this).val().substr(0, variable.validation.maxLength));

						}
					} else {
						valid = false;
					}

					if (variable.validation.precision) {
						try {
							if ($(this).val().split('.')[1].length > variable.validation.precision) {
								valid = false;
							}
						} catch (e) {
							// Do nothing
						}
					}
					if (valid) {
						var curVal = $(this).val();
						if (variable.validation.type == 'postal-ca' && curVal.charAt(3) != ' ' || variable.validation.type == 'postal' && curVal.length == 6 && curVal.charAt(3) != ' ') {
							curVal = curVal.replace(/(\S{3})/, "$1 ");
							$(this).val(curVal);
						}
						if (variable.validation.type == 'percentage-bound' || variable.validation.type == 'percentage-unbound') {
							curVal = curVal.replace(/%$/, '');
							$(this).val(curVal);
						}
						if (variable.validation.type == 'currency' | variable.validation.type == 'currency-euro') {
							curVal = curVal.replace(/[^\d.,-]/g, '');
							$(this).val(curVal);
						}
						that[variable.id]._cached_value = curVal;
						$(this).parent().find('.inlineValidationError').remove();
						//$('input[type="submit"]').removeAttr('disabled');
					} else if ($(this).val() === '') {
						//empty string, do nothing
					} else {
						var errorDiv = $(this).parent().find('.inlineValidationError');

						if (errorDiv.length > 0) {
							errorDiv.html('<li>' + $(this).val() + " : " + (variable.validation.errorMsg ? variable.validation.errorMsg : gettext("Invalid entry")) + '<\/li>');
						} else {
							$('<ul><\/ul>').addClass('inlineValidationError').addClass('errorlist').append($('<li></li>', {
								text: $(this).val() + " : " + variable.validation.errorMsg ? variable.validation.errorMsg : gettext("Invalid entry")
							})).insertBefore($(this));
							//$('input[type="submit"]').attr('disabled', 'disabled');
						}
						//$(this).val(that[variable.id]._cached_value || '');
					}
				});
			}
		})(variable);
	});
}

/* Must be a global*/
var onSurveyLoad = function onSurveyLoad() {
	$('input[type="submit"]').removeAttr('disabled');

	$('#survey-form').submit(function (event) {

		setTimeout(function () {
			$('input[type="submit"]').attr('disabled', 'disabled');
		}, 5);
	});

	/***************** Ranking *********************/

	var escapeSelector = function escapeSelector(id) {
		return id.replace(/([\.:])/g, '\\$1');
	};

	$.each($('.ranking-question'), function (i, el) {
		var original = $('.original-question', el);
		$('.original-question input:checked', el).each(function (i) {
			var ids = this.id.split('_');
			var choice_index = ids[3];
			var variable_index = ids[1] + '_' + ids[2];
			var choice_index_span = $('.rank_index', el).filter(function () {
				return $(this).text() == choice_index;
			});
			var choice_div = $(choice_index_span).parent();
			var variable_index_span = $('.variable_index', el).filter(function () {
				return $(this).text() == variable_index;
			});
			var variable_div = $(variable_index_span).parent();
			$(choice_div).children('.droppable-rank-variable-text').hide();
			$(choice_div).append($(variable_div));
			$(variable_div).css({
				position: 'relative',
				top: 0,
				left: 0
			});
			$(choice_div).data('dragged-item', variable_div);
		});
		// for each variable make a draggable
		$('.draggable-rank-variable-box', el).draggable({
			stack: "div",
			start: function start(event, ui) {
				$(this).data('OrgPosition', $(this).position());
				$(this).data('parent', $(this).parent());
				$('.droppable-rank-variable-box', el).eq(0).css('margin-top', 35 + $(window).scrollTop() - $('.rank-choice-bin', el).offset().top > 5 ? 35 + $(window).scrollTop() - $('.rank-choice-bin', el).offset().top : 5);
			},
			stop: function stop(event, ui) {
				if ($(this).parent()[0] == $(this).data('parent')[0]) {
					$(this).css({ 'position': 'absolute', 'top': $(this).data('OrgPosition').top, 'left': $(this).data('OrgPosition').left });
					var relative_position = $(this).offset();
					$(this).css({ 'position': 'relative' });
					$(this).offset(relative_position);
				}
			}
		});

		// for each choice make it a droppable
		$('.rank-variable-bin', el).droppable({
			accept: function accept(dropElem) {
				if ($(dropElem).hasClass("draggable-rank-variable-box")) {
					return true;
				}

				// not a correct droppable element
				return false;
			},
			activeClass: "ui-state-hover",
			hoverClass: "ui-state-active",
			drop: function drop(event, ui) {
				var parent = $(ui.draggable).parent();
				var id = $('.variable_index', ui.draggable).text();

				if ($(parent).hasClass('droppable-rank-variable-box')) {
					$(parent).data('dragged-item', '');
					$(this).append(ui.draggable);
					$(ui.draggable).css({ 'position': 'relative', 'top': 0, 'left': 0 });
					$(parent).children('.droppable-rank-variable-text').show();

					$('input[name=' + escapeSelector(id) + ']', original).prop('checked', false).trigger('change');
				}
			}
		});
		$(".droppable-rank-variable-box", el).droppable({
			accept: function accept(dropElem) {
				if ($(dropElem).hasClass("draggable-rank-variable-box")) {
					return true;
				}

				// not a correct droppable element
				return false;
			},
			activeClass: "ui-state-hover",
			hoverClass: "ui-state-active",
			drop: function drop(event, ui) {
				var parent = $(ui.draggable).parent();
				var rank = $(this).find('.rank_index').text();
				// this draggable already belonged to a droppable
				if ($(this).data('dragged-item') && $(this).data('dragged-item') != '') {
					// if this had something, swap them...
					if ($(parent).hasClass('droppable-rank-variable-box')) {
						$('input[value=' + rank + ']', original).prop('checked', false).trigger('change');
						$('input#id_' + escapeSelector($('.variable_index', $(this).data('dragged-item')).text()) + "_" + $('.rank_index', parent).text()).prop('checked', true).trigger('change');
						parent.data('dragged-item', $(this).data('dragged-item'));
						parent.children('.rank_index, .droppable-rank-variable-text').hide();
						parent.append($(this).data('dragged-item'));
						$(this).data('dragged-item').css({ 'position': 'relative', 'top': 0, 'left': 0 });
					} else {
						//do a position swap
						$('input#id_' + escapeSelector($('.variable_index', $(this).data('dragged-item')).text()) + "_" + $('.rank_index', this).text()).prop('checked', false).trigger('change');
						$('.rank-variable-bin', el).append($(this).data('dragged-item'));
					}
				} else {

					if ($(parent).hasClass('droppable-rank-variable-box')) {
						$(parent).data('dragged-item', '');
						$(parent).children('.droppable-rank-variable-text').show();
					}
				}

				$('input[value=' + rank + ']', original).prop('checked', false).trigger('change');
				$('input#id_' + escapeSelector($('.variable_index', ui.draggable).text()) + "_" + rank).prop('checked', true).trigger('change');
				$(this).children('.droppable-rank-variable-text').hide();
				$(this).append(ui.draggable);
				$(ui.draggable).css({ 'position': 'relative', 'top': 0, 'left': 0 });
				$(this).data('dragged-item', ui.draggable);
			}
		});
	});

	/*************** END Ranking ******************/

	//Bind signature changes:
	$('.signature').bind('change', function (e) {
		/* 'e.target' will refer to div with "#signature" */
		var inputField, data, b30data;

		var $target = $(e.target);

		data = $target.jSignature('getData', 'svgbase64');
		b30data = $target.jSignature('getData', 'base30');

		inputField = $target.nextAll('input').first();

		if (b30data && b30data[1].length > 1) {
			inputField.val(data[1]);
			inputField.removeAttr('disabled');
		} else {
			inputField.val('');
			inputField.attr('disabled', 'disabled');
		}
	});

	setTimeout(function () {
		$(window).resize();
	}, 10);

	function initializeSignature() {
		$(".signaturePad").each(function (i, el) {
			if ($(el).children().length === 0) {
				//only apply jSignature if it doesn't already exist
				$(el).jSignature({ height: 200 });
				$(el).find('canvas').width("100%");
			}
		});
	}

	$(document).ready(function () {
		setTimeout(initializeSignature, 100);
	});

	$('.reset-signature').click(function (evnt) {
		var $signature = $(evnt.target).closest('.question.signature');
		var existing = $signature.find('.pre-existing-signature').hide();

		$signature.find('.signaturePad').first().show().jSignature('clear');
		$signature.find('input').first().removeAttr('disabled').val('');
		$signature.find('canvas').width("100%");
	});

	/***************** SLIDER ********************/

	// Multiple Choice Slider Appearance
	$.each($('.slider-container'), function (i, el) {
		var slider_info = $('.slider-info', $(this).parent());
		var checked_choice = $('li input:checked', slider_info);

		var num_options = $('li', slider_info).length;
		var header_percentage = 100 / num_options;

		var slider_el = $(el).slider({
			'min': 0,
			'max': num_options - 1,
			'value': checked_choice ? checked_choice.val() : 0,
			'create': function create(event, ui) {

				var question_id = $('input[type=text]', $(this).parent()).attr('id');
				$('label[for="' + question_id + '"]').remove();

				// Set slider if valid choice, else fallback to 0th
				if (checked_choice.length > 0) {
					checked_choice.prop('checked', true);
					checked_choice.trigger('change');
				} else {
					$($('li input', slider_info)[0]).prop('checked', true);
				}

				// Build Headers
				var that_parent = $(this).parent();
				var num_headers = $('li', slider_info).length;

				$('li', slider_info).each(function (i, el) {
					var text_align = "center";
					if (i == 0) {
						text_align = "right";
					} else if (i == num_headers - 1) {
						text_align = "left";
					};

					var slider_cell = $("<td/>", {
						'display': 'inline',
						'style': 'text-align:' + text_align + ';word-wrap: break-word;',
						'html': $($('li label', slider_info)[i]).html()
					});
					slider_cell.width(header_percentage + '%');

					$('.slider-headers', that_parent).append(slider_cell);
				});
			},
			'change': function change(event, ui) {
				var radio_query = $($('li input', $('.slider-info', $(this).parent()))[ui.value]);
				if (radio_query.prop('checked') == false) {
					radio_query.prop('checked', true);
					radio_query.trigger('change');
				}
				var labels = $(".slider-top-labels td", $(this).parent());

				//move the slider manually to halfway through the current label
				var total_left = 0;
				$.each(labels, function (i, el) {
					if (i <= ui.value) {
						var el_width = $(el).outerWidth();
						total_left += el_width;

						if (i == ui.value) {
							total_left -= el_width / 2;
							total_left -= $(ui.handle).outerWidth() / 2;

							$(ui.handle).css("left", total_left);
						};
					};
				});
			}
		});

		var value = slider_el.slider("option", "value");
		slider_el.slider("option", "value", value);
	});

	$('.slider-info').hide();
	$('.slider-hide').hide();

	/*************** END SLIDER ******************/

	/************** FILE UPLOAD FIELD ***************/

	// FR-ONLY: Legacy file upload from FluidReview
	$('div.question.file-upload').each(function () {
		var q = $(this);

		q.find('input.delete[type=checkbox]').bind('click change keydown', function () {
			if ($(this).prop('checked')) {
				q.find('.upload').hide('fast');
				q.find('input[type=file]').val('');
			} else {
				q.find('.upload').show('fast');
			}
		}).trigger('change');
	});

	// New file upload field for Apply (React based)
	$('div.file-upload-field').each(function () {
		var question = $(this);

		var config = $.data(question[0], 'config');
		var reactContainerElement = React.createElement(_FileUploadField2.default, _extends({}, config, {
			disabled: false
		}));
		_reactDom2.default.render(reactContainerElement, question[0]);
	});

	/************ END FILE UPLOAD FIELD ************/

	$('#survey div.question fieldset').hide();
	setTimeout(function () {
		$('#survey div.question fieldset').show();
	}, 0);

	$('.matrix.textgridmatrix').each(function (i, el) {
		var original = $('.sum-label-hidden', $(el).parent());
		var inputs = $('input[type=text], textarea', el);

		var calcTotal = function calcTotal() {
			var total = 0;
			inputs.each(function () {
				var matched = $(this).val().replace(/,/g, '').replace(/ /g, '').match(/([^\d])?(\d*(\.\d+)?)/);
				if (matched && matched[0]) {
					var val = parseFloat(matched[2]);
					if (!isNaN(val)) {
						total += val;
					}
				}
			});
			return parseFloat(total.toFixed(12));
		};

		var update = function update(e) {
			if (original.html() != null) {
				$('.sum-label', $(el).parent()).html(original.html().replace(/\{x\}/g, $('span.sumtotal', $(el).parent()).html()).replace(/\{y\}/g, calcTotal()).replace(/\{z\}/g, parseFloat($('span.sumtotal', $(el).parent()).html()) - calcTotal()));
			}
		};

		inputs.keyup(update);
		inputs.blur(update);

		update();
	});

	$('.matrix.threedMatrix').each(function () {
		var that = this;
		var columns = $('tbody tr:has(.variable):first td.variable', this).map(function (i, el) {
			return $('td:eq(' + i + ')', $('tbody tr, tfoot tr', that));
		});
		$.each(columns, function () {
			var that = this;
			var original = $('.sum-label-hidden', this);
			var inputs = $('input[type=text], textarea', this);

			var calcTotal = function calcTotal() {
				var total = 0;
				inputs.each(function () {
					var matched = $(this).val().replace(/,/g, '').replace(/ /g, '').match(/(-?\d*(\.\d+)?)/);
					if (matched && matched[0]) {
						var val = parseFloat(matched[1]);
						if (!isNaN(val)) {
							total += val;
						}
					}
				});
				return parseFloat(total.toFixed(12));
			};

			var update = function update(e) {
				$('.sum-label', that).text(original.text().replace(/\{x\}/g, $('span.sumtotal', that).text()).replace(/\{y\}/g, calcTotal()));
			};

			inputs.keyup(update);
			inputs.blur(update);

			update();
		});
	});

	$('.datetime').each(function () {
		var dateInput = $('input.date', this);
		var timeInput = $('input.time', this);
		var zoneInput = $('select.zone', this);

		var dateFormat = '';
		var altFormat = dateInput.attr('alt');
		var submitFormat = 'yyyy/mm/dd';
		var selectYears = 200;
		var now = dateInput.attr('now') == "True";

		if (altFormat == 'mm/yy') {
			dateInput.attr('placeholder', 'MM/YYYY');
			return;
		}

		if (altFormat == 'dd/mm') {
			dateFormat = 'dd mmm';
			submitFormat = 'dd/mm';
			selectYears = false;
		} else if (window.DATE_FORMAT == '0') {
			dateFormat = 'mmm dd yyyy';
		} else if (window.DATE_FORMAT == '1') {
			dateFormat = 'dd mmm yyyy';
		} else if (window.DATE_FORMAT == '2') {
			dateFormat = 'yyyy mmm dd';
		}

		if (dateInput.val()) {
			// http://amsul.ca/pickadate.js/date/#formats_prefill
			dateInput.data('value', dateInput.val());
		} else if (now) {
			var date = new Date();
			dateInput.data('value', date);
		}

		$(dateInput).pickadate({
			selectMonths: true,
			format: dateFormat,
			formatSubmit: submitFormat,
			hiddenName: true,
			selectYears: selectYears,
			defaultTime: false
		});

		var showMeridian = window.TIME_FORMAT != '1';

		$(timeInput).timepicker({
			template: false,
			minuteStep: 1,
			showMeridian: showMeridian
		});
	});

	$('a.datetime-now').click(function (e) {
		e.preventDefault();

		var now = new Date();

		$(this).closest('.question').find(':input[name$=_date]').data('value', now.format("yyyy/mm/dd"));
		$(this).closest('.question').find(':input[name$=_date]').val(now.format("yyyy/mm/dd"));
		$(this).closest('.question').find(':input[name$=_time]').val(now.format("HH:MM:ss"));
	});

	//Allow clicking a cell to toggle the checkbox or radio button
	$('.group-table-container table, .grouped-table').delegate('td', 'click', function (e) {
		if (!$(e.target).is('input') && $(e.target).find('input:enabled').length == 1) {
			$(this).find('input:enabled').focus().click().change();
		}
	});

	var checkbox_done = [];
	$('input[type="checkbox"]').each(function (e) {
		var that = this;
		var parent = $(that).parents('.question-body');
		if (checkbox_done.indexOf(parent[0]) < 0) {
			checkbox_done.push(parent[0]);
		} else {
			return;
		}

		var exclusives = parent.find('input[type="checkbox"].na-choice');
		var inclusives = parent.find('input[type="checkbox"]:not(.na-choice):not(.check-all)');
		var selectAll = parent.find('input[type="checkbox"].check-all');
		exclusives.unbind('click').bind('click change', function () {
			parent.find('input[type="checkbox"]').not($(this)).prop('checked', false);
			$(this).parent().parent().siblings().find('input[type=text]').val('').trigger('change');
			var current;
			if ($(this).prop('checked') == false) current = 0;else current = 1;
			$('.current-checked', parent).text(current);
		});
		selectAll.unbind('click').bind('click change', function () {
			if ($(this).prop('checked')) {
				inclusives.prop('checked', true);
				exclusives.prop('checked', false);
			} else {
				inclusives.prop('checked', false);
			}
			$('.current-checked', parent).text(inclusives.filter(':checked').length);
		});

		var checkSelectAll = function checkSelectAll() {
			if (inclusives.filter(':checked').length == inclusives.length) {
				selectAll.prop('checked', 'true');
			} else {
				selectAll.prop('checked', false);
			}
		};
		inclusives.unbind('click').bind('click change', function () {
			var current = 0;
			parent.find('.na-choice').prop('checked', false);
			current = inclusives.filter(':checked').length;
			$('.current-checked', parent).text(current);
			checkSelectAll();
		});
		checkSelectAll();
		$('.current-checked', parent).text(inclusives.filter(':checked').length);
	});

	$('select.drilldown').hide().each(function () {
		var that = this;
		var name = $(this).attr('name');

		var choices = $('<select>', {
			'size': 5,
			'class': 'drill-down-selector',
			change: function change() {
				$(that).val($('option:selected', this).val());
			}
		});

		var categories = $('<select>', {
			'size': 5,
			'class': 'drill-down-selector',
			change: function change() {
				choices.empty();
				var group = $('option:selected', this).data('optgroup');
				if (group) {
					group.find('option').clone().appendTo(choices);
					choices.val($(that).val());
					choices.find('option').each(function () {
						$(this).prop('title', $(this).text());
					});
				}
			}
		});

		categories.delegate('option', 'mousedown', function () {
			if ($(this).attr("selected")) {
				$(this).removeAttr("selected");
				choices.empty();
				$(that).val('');
				return false;
			} else {
				$(this).attr("selected", "selected");
				categories.trigger('change');
			}
		});

		$('optgroup', this).each(function (i) {
			categories.append($('<option />', {
				val: i,
				text: $(this).attr('label'),
				data: {
					optgroup: $(this)
				}
			}));

			if ($('option:selected', this).length) {
				categories.val(i);
			}
		});
		choices.insertAfter(this);
		categories.insertAfter(this);
		categories.trigger('change');
	});

	//Allow unchecking of radio buttons
	$('input[type="radio"]').each(function () {
		var checked = $(this).is(':checked');
		$(this).data('wasChecked', checked);
	});

	$('input[type="radio"]').click(function (e) {
		if ($(this).data('wasChecked')) {
			$(this).removeAttr('checked');
			$(this).data('wasChecked', false);
		} else {
			$('input[name="' + $(this).attr('name') + '"]').data('wasChecked', false);
			$(this).data('wasChecked', true);
		}
	});

	$('.grouped-error-row').each(function (i) {
		var that = this;
		$('input', this).click(function (e) {
			$('.grouped-error-box', that).removeClass('grouped-error-box');
			$(that).removeClass('grouped-error-row');
		});
	});

	$('.grouped-error-row').each(function (i) {
		if ($('input[type="radio"]:checked', this).length > 0) {
			$('input[type="radio"]:checked', this).parent().addClass('grouped-error-box');
			$(this).removeClass('grouped-error-row');
		}
	});

	$('.funique').each(function (i) {
		var that = this;
		$('input', this).click(function (x) {
			var that2 = this;
			$('input', that).each(function (z) {
				if (this.value == that2.value && that2 != this) {

					$(this).removeAttr('checked');
				}
			});
		});
	});

	//disable form submission on enter key in text input fields
	$('input[type="text"]').keypress(function (e) {
		if (window.event) var key = window.event.keyCode;else var key = e.which; //for firefox
		if (key == 13) e.preventDefault();
	});

	$('input[type="reset"]').click(function (e) {
		e.preventDefault();
		$('input[type="text"]').val('');
		$('textarea').val('');
		$('input[type="radio"]').removeAttr('checked');
		$('input[type="checkbox"]').removeAttr('checked');
		$('option').attr('selected', '');
	});

	$('input[name="exit"]').click(function (e) {
		if (!confirm(gettext('Are you sure you wish to exit this survey? Any responses you have provided will be discarded.'))) {
			e.preventDefault();
		} else {
			if ($('input[name="_terminated_redirect"]').length > 0) if ($('input[name="_terminated_redirect"]')[0].value) {
				e.preventDefault();
				window.location = $('input[name="_terminated_redirect"]')[0].value;
			}
		}
	});

	// Choice clearing

	$('.surveys-clear-choice').each(function (i, el) {
		var btn = $(this);
		if ($(this).parents('tr').length > 0) {
			var question = $(this).parents('tr:first');
		} else {
			var question = $(this).parents('.question:first');
		}
		var selects = $('input[type="radio"]', question);

		btn.hide();

		btn.click(function (e) {
			e.preventDefault();
			selects.prop('checked', false);
			selects.trigger('change');
			btn.hide();
		});

		selects.change(function (e) {
			btn.show();
		});

		if (selects.is(':checked')) {
			btn.show();
		}
	});

	/********** Dynamic grid client side script *********/

	$('input.grid-select-all').click(function () {
		var scope = $(this).parents('tr:first');
		if ($(this).prop('checked')) {
			$('input[type="checkbox"]:not(.grid-select-all)', scope).prop('checked', true).each(function () {
				$(this).trigger('change');
			});
		} else {
			$('input[type="checkbox"]:not(.grid-select-all)', scope).prop('checked', false).each(function () {
				$(this).trigger('change');
			});
		}
	});

	$('.dynamic-grid-question').find('input[type="checkbox"]:not(.grid-select-all)').bind('click', function () {
		if (!$(this).prop('checked')) {
			$('.grid-select-all:checked', $(this).parents('tr:first')).prop('checked', false);
		}
	});

	/****************************************************/

	/************** Branching Info JS *******************/
	var branchingInfo = $('#survey div.branching-info');
	//If this runs they have JS so use the JS Suited class
	branchingInfo.removeClass('branching-info');
	branchingInfo.addClass('branching-info-js');

	var branchUl = $('span:first', branchingInfo).hide();
	var branchingInfoToggler = $('<div>').prependTo(branchingInfo);
	branchingInfoToggler.append($('<a href="#" title="' + gettext('Toggle Branching Info') + '">').click(function (e) {
		e.preventDefault();
		if (branchUl.is(':visible')) {
			branchUl.slideUp();
			$(this).removeClass('open');
		} else {
			branchUl.slideDown();
			$(this).addClass('open');
		}
	}).html('<img src="/media/img/icons/page_skip.png" />'));
	/****************************************************/

	$('input.other').keyup(function (event) {
		if (event.keyCode != '9') {

			$(this).parents('li:first').find('input[type="radio"]').prop('checked', true).trigger('change');

			if (typeof AUTOSELECT_CHECKBOXES != "undefined" && AUTOSELECT_CHECKBOXES) {
				$(this).parents('li:first').find('input[type="checkbox"]').prop('checked', true).trigger('change').end().siblings().find('input[type="checkbox"].na-choice').prop('checked', false);
				//.trigger('change');
			}
		}
	});

	$('#sma-js-use-guidestar').click(function (e) {
		var link = $(e.target);
		var importGuideStarValuesUrl = link.attr('href');
		e.preventDefault();

		var modal = new _modals.AjaxFormModal({
			autoShow: true,
			destroyOnClose: true,
			onSuccess: function onSuccess(response) {
				modal.hide();
				$.each(response.guidestar_mapped_values, function (variable_id, value) {
					var $variable = $('#id_' + variable_id);
					if (!response.overwrite_fields_with_data && $variable.val()) {
						return;
					}
					$variable.val(value);
					$variable.effect('highlight', 1000);
				});
			}
		});

		var content = new _modals.AjaxFormContent(importGuideStarValuesUrl, {
			title: STRINGS.guideStarModalTitle,
			buttons: [{
				cls: 'btn btn-link btn-loud',
				label: STRINGS.cancel,
				handler: function handler(modal) {
					modal.hide();
				}
			}, {
				cls: 'btn btn-primary btn-loud',
				label: STRINGS.ok,
				handler: function handler() {
					modal.modalBody.find('form').submit();
				}
			}]
		});

		modal.addToStack('modal', content);
	});
};

module.exports = {
	SurveyLogic: SurveyLogic,
	onSurveyLoad: onSurveyLoad,
	getVariableQuery: getVariableQuery
};

$(document).ready(onSurveyLoad);

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	ok: gettext('Ok'),
	cancel: gettext('Cancel'),
	guideStarModalTitle: gettext('Use GuideStar')
};

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

var ArrayNode, AttrNode, CompareNode, ConnectiveNode, ConstNode, EvaluationVisitor, ExprNode, ExprParser, FuncNode, IdentifierNode, IndexNode, exprParser;

ExprNode = __webpack_require__(45).ExprNode;

CompareNode = __webpack_require__(45).CompareNode;

ConnectiveNode = __webpack_require__(45).ConnectiveNode;

ArrayNode = __webpack_require__(45).ArrayNode;

FuncNode = __webpack_require__(45).FuncNode;

IndexNode = __webpack_require__(45).IndexNode;

AttrNode = __webpack_require__(45).AttrNode;

IdentifierNode = __webpack_require__(45).IdentifierNode;

ConstNode = __webpack_require__(45).ConstNode;

EvaluationVisitor = __webpack_require__(45).EvaluationVisitor;

exprParser = __webpack_require__(1201);

ExprParser = (function() {
  function ExprParser() {}

  ExprParser.prototype.parse = function(input) {
    var root;
    root = exprParser.parse(input);
    return this.buildExprTree(root);
  };

  ExprParser.prototype.buildExprTree = function(parsed) {
    var i, len, param, params, ref;
    switch (parsed.type) {
      case 'connective':
      case 'math':
      case 'compare':
        parsed.left = this.buildExprTree(parsed.left);
        parsed.right = parsed.right ? this.buildExprTree(parsed.right) : parsed.right;
        if (parsed.type === 'connective') {
          return ConnectiveNode.prototype.parse(parsed);
        } else if (parsed.type === 'math') {
          return ExprNode.prototype.parse(parsed);
        } else {
          return CompareNode.prototype.parse(parsed);
        }
      case 'array':
        parsed.id = this.buildExprTree(parsed.id);
        parsed.start = parsed.start ? this.buildExprTree(parsed.start) : void 0;
        parsed.end = parsed.end ? this.buildExprTree(parsed.end) : parsed.end;
        return ArrayNode.prototype.parse(parsed);
      case 'func':
        parsed.id = this.buildExprTree(parsed.id);
        params = [];
        ref = parsed.params;
        for (i = 0, len = ref.length; i < len; i++) {
          param = ref[i];
          params.push(this.buildExprTree(param));
        }
        parsed.params = params;
        return FuncNode.prototype.parse(parsed);
      case 'index':
        parsed.id = this.buildExprTree(parsed.id);
        parsed.index = this.buildExprTree(parsed.index);
        return IndexNode.prototype.parse(parsed);
      case 'attr':
        parsed.id = this.buildExprTree(parsed.id);
        parsed.attr = this.buildExprTree(parsed.attr);
        return AttrNode.prototype.parse(parsed);
      case 'id':
        return IdentifierNode.prototype.parse(parsed);
      case 'const':
        return ConstNode.prototype.parse(parsed);
    }
  };

  return ExprParser;

})();

module.exports = ExprParser;


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var Backbone, CSV, CSVWriter, Choice, Extraction, escapeSelector, randomString, trans,
  slice = [].slice,
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Backbone = (typeof window === "undefined" || window === null) && (typeof module !== "undefined" && module !== null) ? __webpack_require__(40) : window.Backbone;

_.mixin({
  shuffled: function(array) {
    return this.sortBy(array, function(el) {
      return 0.5 - Math.random();
    });
  },
  beget: function(obj) {
    var ctor;
    ctor = function() {};
    ctor.prototype = obj;
    return new ctor();
  },
  extendAttrs: function() {
    var attrs, extendWith, obj;
    obj = arguments[0], attrs = arguments[1], extendWith = 3 <= arguments.length ? slice.call(arguments, 2) : [];
    _.each(extendWith, function(source) {
      var prop, results;
      results = [];
      for (prop in source) {
        if (_.contains(attrs, prop)) {
          results.push(obj[prop] = source[prop]);
        }
      }
      return results;
    });
    return obj;
  }
});

escapeSelector = function(id) {
  return id.replace(/([\.:])/g, "\\$1");
};

randomString = function(len) {
  var chars, i;
  if (len == null) {
    len = 10;
  }
  chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  return ((function() {
    var j, ref, results;
    results = [];
    for (i = j = 0, ref = len; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      results.push(chars[Math.floor(Math.random() * chars.length)]);
    }
    return results;
  })()).join('');
};

CSV = {
  Writer: CSVWriter = (function() {
    function CSVWriter() {
      this.buffer = [];
    }

    CSVWriter.prototype.encodeCell = function(value) {
      return '"' + (value != null ? value : "").replace(/\"/g, '""') + '"';
    };

    CSVWriter.prototype.writeRow = function(row) {
      var cell;
      return this.buffer.push(((function() {
        var j, len1, results;
        results = [];
        for (j = 0, len1 = row.length; j < len1; j++) {
          cell = row[j];
          results.push(this.encodeCell(cell));
        }
        return results;
      }).call(this)).join(","));
    };

    CSVWriter.prototype.getText = function() {
      return this.buffer.join("\n");
    };

    CSVWriter.prototype.getEncoded = function() {
      return base64.encode(this.getText());
    };

    CSVWriter.prototype.getUri = function() {
      var chrome, safari;
      safari = navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.indexOf('Chrome') === -1;
      chrome = navigator.userAgent.indexOf('Chrome') >= 0;
      if (safari) {
        return "data:application/csv;base64," + this.getEncoded();
      } else if (chrome) {
        return "data:application/octet-stream;base64," + this.getEncoded();
      } else {
        return "data:text/csv;base64," + this.getEncoded();
      }
    };

    return CSVWriter;

  })(),
  parse: function(text, delimiter) {
    var cell, data, matches, pattern, ref;
    if (delimiter == null) {
      delimiter = ',';
    }
    pattern = new RegExp(("(\\" + delimiter + "|\\r?\\n|\\r|^)") + "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" + ("([^\"\\" + delimiter + "\\r\\n]*))"), "gi");
    data = [[]];
    while ((matches = pattern.exec(text))) {
      if (matches[1].length && matches[1] !== delimiter) {
        data.push([]);
      }
      if (matches[2]) {
        cell = matches[2].replace(new RegExp("\"\"", "g"), "\"");
      } else {
        cell = (ref = matches[3]) != null ? ref : "";
      }
      data[data.length - 1].push(cell);
    }
    return data;
  }
};

trans = (function() {
  trans.prototype.language = 'en';

  trans.prototype.defaultLanguage = 'en';

  trans.prototype.availableLanguages = ['en'];

  trans.first = function(obj) {
    var k, v;
    for (k in obj) {
      if (!hasProp.call(obj, k)) continue;
      v = obj[k];
      return v;
    }
  };

  trans.prototype.toString = function(lang) {
    var ref, ref1;
    if (lang == null) {
      lang = this.language;
    }
    return (ref = (ref1 = this[lang]) != null ? ref1 : trans.first(this)) != null ? ref : '';
  };

  trans.prototype.toJSON = function() {
    var lang, ref, result;
    if (_.size(this) === 0) {
      return '';
    }
    if (_.size(this) === 1) {
      return trans.first(this);
    }
    result = {};
    if (this.defaultLanguage in this) {
      result[this.defaultLanguage] = this[this.defaultLanguage];
    }
    ref = this;
    for (lang in ref) {
      if (!hasProp.call(ref, lang)) continue;
      if (indexOf.call(this.availableLanguages, lang) >= 0) {
        result[lang] = this[lang];
      }
    }
    return result;
  };

  function trans(obj) {
    var lang;
    if (typeof obj === 'string') {
      this[this.language] = obj;
    } else if (obj != null) {
      if (this.defaultLanguage in obj) {
        this[this.defaultLanguage] = obj[this.defaultLanguage];
      }
      for (lang in obj) {
        if (!hasProp.call(obj, lang)) continue;
        this[lang] = obj[lang];
      }
    }
  }

  trans.make = function(obj) {
    return new trans(obj);
  };

  trans.localizedDropdown = function() {
    var dropdown, j, lang, len1, option, ref;
    dropdown = $('<select name="l"/>');
    ref = this.prototype.availableLanguages;
    for (j = 0, len1 = ref.length; j < len1; j++) {
      lang = ref[j];
      option = $("<option value=\"" + lang + "\">" + LANGUAGES[lang] + "</option>");
      if (this.prototype.language === lang) {
        option.attr('selected', 'selected');
      }
      dropdown.append(option);
    }
    return dropdown;
  };

  return trans;

})();

Choice = (function(superClass) {
  extend(Choice, superClass);

  function Choice(index, info) {
    var ref, ref1, ref2, ref3, ref4, rightLabel;
    rightLabel = (ref = info.rightLabel) != null ? ref : info.rlabel;
    Choice.__super__.constructor.call(this, {
      id: (ref1 = info.id) != null ? ref1 : index,
      label: trans.make(info.label),
      score: info.score,
      other: info.other,
      na: (ref2 = info.na) != null ? ref2 : void 0,
      check_all: (ref3 = info.check_all) != null ? ref3 : void 0,
      required: info.required,
      other_required: info.other_required != null,
      type: info.type,
      appearance: info.appearance,
      columns: (ref4 = info.columns) != null ? ref4 : info.cols,
      rows: info.rows,
      choices: info.choices != null ? Choice.makeList(info.choices) : void 0,
      rightLabel: rightLabel != null ? trans.make(rightLabel) : void 0,
      validation: info.validation,
      initialValue: info.initialValue,
      "static": info["static"]
    });
  }

  Choice.prototype.label = function() {
    return this.get('label').toString();
  };

  Choice.prototype.score = function() {
    var ref;
    return (ref = this.get('score')) != null ? ref : this.id + 1;
  };

  Choice.makeList = function(info) {
    var i, j, ref, results;
    results = [];
    for (i = j = 0, ref = info.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      results.push(new this(i, info[i]));
    }
    return results;
  };

  return Choice;

})(Backbone.Model);

Extraction = (function() {
  function Extraction(info) {
    this.source = info.question;
    this.options = info.options;
  }

  Extraction.prototype.resolve = function(survey) {
    var id, source;
    id = survey.resolveName(this.source);
    source = survey.questions()[id];
    if ((source != null ? source.getExtraction : void 0) == null) {
      console.warn("Extraction from invalid source [" + this.source + "], skipping...");
      return null;
    }
    this._source = source;
    return this.choices = source.getExtraction(null, this.options);
  };

  Extraction.prototype.labelForChoice = function(id) {
    if (this.choices[id].get('other')) {
      return "{{ COALESCE(" + (this.choices[id].get('other').get('name').replace(/\./g, '_')) + ",'" + (this.choices[id].label()) + "') }}";
    }
    return this.choices[id].label();
  };

  Extraction.prototype.evaluate = function(handler) {
    var choice, id, j, len1, ref, result, source;
    id = handler.survey.resolveName(this.source);
    source = handler.survey.questions()[id];
    if ((source != null ? source.getExtraction : void 0) == null) {
      console.warn("Extraction from invalid source [" + this.source + "], skipping...");
      return null;
    }
    result = {};
    ref = source.getExtraction(handler.response, this.options);
    for (j = 0, len1 = ref.length; j < len1; j++) {
      choice = ref[j];
      result[choice.id] = true;
    }
    return result;
  };

  Extraction.prototype.bind = function(id) {
    console.log('BINDING:', this, id);
    return this;
  };

  return Extraction;

})();

module.exports = {
  randomString: randomString,
  trans: trans,
  Choice: Choice
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)(module)))

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TimeZoneInspector = function TimeZoneInspector() {
	this.detect = function () {
		//http://www.onlineaspect.com/2007/06/08/auto-detect-a-time-zone-with-javascript/
		//Compares the local time to gmt time and determines the offset
		//Then checks if dst is in effect, allowing us to get the correct offset
		var rightNow = new Date();
		var jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);
		var temp = jan1.toGMTString();
		var jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
		var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);

		var june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0);
		temp = june1.toGMTString();
		var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
		var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
		var dst = !!!(std_time_offset == daylight_time_offset);

		return { offset: std_time_offset, dst: dst };
	};

	this.as_string = function (dt) {
		if (dt === undefined) dt = this.detect();
		var timezone_str = '';
		//if (dt.dst) {
		//	var dst_offset = dt.offset + ((dt.offset > 0)? -1 : 1);
		//} else {
		var dst_offset = dt.offset;
		//}
		var timezone_str = '';
		if (dst_offset < 0) {
			timezone_str += '-';
		} else {
			timezone_str += '+';
		}
		var surplus = 0;
		if (Math.abs(dst_offset) % 1 > 0) {
			var surplus = Math.abs(dst_offset) % 1;
			dst_offset -= surplus;
			surplus = 60 * (surplus / 100) * 100;
		}
		if (Math.abs(dst_offset) >= 10) {
			timezone_str += Math.abs(dst_offset).toString();
		} else {
			timezone_str += '0' + Math.abs(dst_offset).toString();
		}
		if (surplus > 0) {
			timezone_str += surplus.toString();
		} else {
			timezone_str += '00';
		}

		return timezone_str;
	};

	this.get_timezone = function (timezone_str, preferred_tzs, tzs) {
		var timezone = null;
		for (var i = 0; i < preferred_tzs.length; i++) {
			if (preferred_tzs[i][1].indexOf(timezone_str) >= 0) {
				timezone = preferred_tzs[i];
				break;
			}
		}
		if (timezone == null) {
			for (var i = 0; i < tzs.length; i++) {
				if (tzs[i][1].indexOf(timezone_str) >= 0) {
					timezone = tzs[i];
					break;
				}
			}
		}
		return timezone;
	};
};

//Utility for displaying time in various formats
function prettyTime(time) {
	this.time = time ? time : new Date();

	this._update = function () {
		this.minute = this.time.getMinutes() < 10 ? '0' + this.time.getMinutes.toString() : this.time.getMinutes().toString();
		this.hour = this.time.getHours();
		this.ampm = this.hour > 12 ? 'pm' : 'am';
	};

	this.update = function () {
		this.time = new Date();
		this._update();
	};

	this.get24Current = function () {
		this.update();
		return this.get24();
	};

	this.get24 = function () {
		return $.format("{0}:{1}", this.hour, this.minute);
	};

	this.get12Current = function () {
		this.update();
		return this.get12();
	};

	this.get12 = function () {
		return $.format("{0}:{1} {2}", this.hour < 12 ? this.hour : this.hour - 12, this.minute, this.ampm);
	};

	//Good through 24 hours.
	//TODO right now, due to not using delta time, if this is triggered at 55 seconds into a minute 5 seconds later it will say a minute passed instead of 5 seconds.
	this.getTimePassed = function () {
		var current_time = new Date();
		if (this.time.getDay() == current_time.getDay()) {
			if (this.time.getHours() == current_time.getHours()) {
				if (this.time.getMinutes() == current_time.getMinutes()) {
					var difference = current_time.getSeconds() - this.time.getSeconds();
					return $.format(interpolate(ngettext('%s second ago.', '%s seconds ago.', difference), [difference.toString()]));
				} else {
					var difference = current_time.getMinutes() - this.time.getMinutes();
					return $.format(interpolate(ngettext('%s minute ago.', '%s minutes ago.', difference), [difference.toString()]));
				}
			} else {
				var difference = current_time.getHours() - this.time.getHours();
				return $.format(interpolate(ngettext('%s hour ago.', '%s hours ago.', difference), [difference.toString()]));
			}
		} else {
			var difference = current_time.getDay() - this.time.getDay();
			return $.format(interpolate(ngettext('Yesterday', '%s days ago.', difference), [difference.toString()]));
		}
	};

	this.updateElement = function () {
		$('span.time-counter', this.element).text(this.getTimePassed());
		setTimeout(this.updateElement.scope(this), 15000);
	};

	//Takes a jQuery object and uses getTimePassed every 15 seconds to update it
	this.timePassedElement = function (element) {
		if (element) {
			this.element = element;
			element.append($('<span>').addClass('time-counter').text(this.getTimePassed()));
			setTimeout(this.updateElement.scope(this), 15000);
			return element;
		}
	};

	this._update();
}

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

Date.prototype.format = function () {
	var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
	    timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[\-+]\d{4})?)\b/g,
	    timezoneClip = /[^\-+\dA-Z]/g,
	    pad = function pad(val, len) {
		val = String(val);
		len = len || 2;
		while (val.length < len) {
			val = "0" + val;
		}
		return val;
	};

	// Regexes and supporting functions are cached through closure
	var dF = function dF(mask, utc) {
		var date = this;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date();
		if (isNaN(date)) {
			throw SyntaxError("invalid date");
		}

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
		    d = date[_ + "Date"](),
		    D = date[_ + "Day"](),
		    m = date[_ + "Month"](),
		    y = date[_ + "FullYear"](),
		    H = date[_ + "Hours"](),
		    M = date[_ + "Minutes"](),
		    s = date[_ + "Seconds"](),
		    L = date[_ + "Milliseconds"](),
		    o = utc ? 0 : date.getTimezoneOffset(),
		    flags = {
			d: d,
			dd: pad(d),
			ddd: dF.i18n.dayNames[D],
			dddd: dF.i18n.dayNames[D + 7],
			m: m + 1,
			mm: pad(m + 1),
			mmm: dF.i18n.monthNames[m],
			mmmm: dF.i18n.monthNames[m + 12],
			yy: String(y).slice(2),
			yyyy: y,
			h: H % 12 || 12,
			hh: pad(H % 12 || 12),
			H: H,
			HH: pad(H),
			M: M,
			MM: pad(M),
			s: s,
			ss: pad(s),
			l: pad(L, 3),
			L: pad(L > 99 ? Math.round(L / 10) : L),
			t: H < 12 ? "a" : "p",
			tt: H < 12 ? "am" : "pm",
			T: H < 12 ? "A" : "P",
			TT: H < 12 ? "AM" : "PM",
			Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
			o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
			S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
		};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};

	return dF;
}();

// Some common format strings
Date.prototype.format.masks = {
	"default": "ddd mmm dd yyyy HH:MM:ss",
	shortDate: "m/d/yy",
	mediumDate: "mmm d, yyyy",
	longDate: "mmmm d, yyyy",
	fullDate: "dddd, mmmm d, yyyy",
	shortTime: "h:MM TT",
	mediumTime: "h:MM:ss TT",
	longTime: "h:MM:ss TT Z",
	isoDate: "yyyy-mm-dd",
	isoTime: "HH:MM:ss",
	isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
Date.prototype.format.i18n = {
	dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};

/**
 * Magic time parsing, based on Simon Willison's Magic date parser
 * @see http://simon.incutio.com/archive/2003/10/06/betterDateInput
 * @author Stoyan Stefanov &lt;stoyan@phpied.com&gt;
 */

/**
 * Array of objects, each has:
 * <ul><li>'re' - a regular expression</li>
 * <li>'handler' - a function for creating a date from something
 *     that matches the regular expression</li>
 * <li>'example' - an array of examples that show matching examples</li>
 * Handlers may throw errors if string is unparseable.
 * Examples are used for automated testing, so they should be updated
 *   once a regexp is added/modified.
 */
var timeParsePatterns = [
// Now
{ re: /^now/i,
	example: new Array('now'),
	handler: function handler() {
		return new Date();
	}
},

// 12 AM
{ re: /^12:{0,1}(\d*)(?:a| a)/i,
	example: new Array('now'),
	handler: function handler(bits) {
		var d = new Date();
		var m = parseInt(bits[1].substring(0, 2));
		d.setHours(0);
		if (isNaN(m)) {
			m = 0;
		}
		d.setMinutes(m);
		d.setSeconds(0);
		return d;
	}
},

// a.m.
{ re: /(\d{1,2}):(\d{1,2}):(\d{1,2})(?:a| a)/i,
	example: new Array('9:55:00 am', '12:55:00 a.m.', '9:55:00 a', '11:5:10am', '9:5:1a'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		d.setHours(h);
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(parseInt(bits[3], 10));
		return d;
	}
},

// p.m.
{ re: /(\d{1,2}):(\d{1,2}):(\d{1,2})(?:p| p)/i,
	example: new Array('9:55:00 pm', '12:55:00 p.m.', '9:55:00 p', '11:5:10pm', '9:5:1p'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		if (h < 12) {
			h += 12;
		}
		d.setHours(h);
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(parseInt(bits[3], 10));
		return d;
	}
},

// a.m., no seconds
{ re: /(\d{1,2}):(\d{1,2})(?:a| a)/i,
	example: new Array('9:55 am', '12:55 a.m.', '9:55 a', '11:5am', '9:5a'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		d.setHours(h);
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(0);
		return d;
	}
},

// p.m., no seconds
{ re: /(\d{1,2}):(\d{1,2})(?:p| p)/i,
	example: new Array('9:55 pm', '12:55 p.m.', '9:55 p', '11:5pm', '9:5p'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		if (h < 12) {
			h += 12;
		}
		d.setHours(h);
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(0);
		return d;
	}
},

// hmmpm
{ re: /(\d{3})(?:p| p)/i,
	example: new Array('900pm', '345p', '9pm', '19 p', '1950 pm'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1].substring(0, 1));
		var m = parseInt(bits[1].substring(1, 3), 10);
		var s = parseInt(bits[1].substring(3, 5), 10);
		if (h < 12) {
			h += 12;
		}
		if (isNaN(m)) {
			m = 0;
		}
		if (isNaN(s)) {
			s = 0;
		}
		d.setHours(parseInt(h, 10));
		d.setMinutes(parseInt(m, 10));
		d.setSeconds(parseInt(s, 10));
		return d;
	}
},

// p.m., hour only
{ re: /(\d{1,2})(?:p| p)/i,
	example: new Array('9 pm', '12 p.m.', '9 p', '11pm', '9p'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		if (h < 12) {
			h += 12;
		}
		d.setHours(h);
		d.setMinutes(0);
		d.setSeconds(0);
		return d;
	}
},

// a.m., hour only
{ re: /(\d{1,2})(?:a| a)/i,
	example: new Array('9 am', '12 a.m.', '9 a', '11am', '9a'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1], 10);
		d.setHours(h);
		d.setMinutes(0);
		d.setSeconds(0);
		return d;
	}
},

// hh:mm:ss
{ re: /(\d{1,2}):(\d{1,2}):(\d{1,2})/,
	example: new Array('9:55:00', '19:55:00', '19:5:10', '9:5:1', '9:55:00 a.m.', '11:55:00a'),
	handler: function handler(bits) {
		var d = new Date();
		d.setHours(parseInt(bits[1], 10));
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(parseInt(bits[3], 10));
		return d;
	}
},
// hh:mm
{ re: /(\d{1,2}):(\d{1,2})/,
	example: new Array('9:55', '19:55', '19:5', '9:55 a.m.', '11:55a'),
	handler: function handler(bits) {
		var d = new Date();
		d.setHours(parseInt(bits[1], 10));
		d.setMinutes(parseInt(bits[2], 10));
		d.setSeconds(0);
		return d;
	}
},

// hmm
{ re: /(^\d{3}$)/,
	example: new Array('900', '345', '9am', '19', '1950', '195510', '0955'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1].substring(0, 1));
		var m = parseInt(bits[1].substring(1, 3), 10);
		var s = parseInt(bits[1].substring(3, 5), 10);
		if (isNaN(m)) {
			m = 0;
		}
		if (isNaN(s)) {
			s = 0;
		}
		d.setHours(parseInt(h, 10));
		d.setMinutes(parseInt(m, 10));
		d.setSeconds(parseInt(s, 10));
		return d;
	}
},

// hhmmss
{ re: /(^\d{1,6})$/,
	example: new Array('9', '9a', '9am', '19', '1950', '195510', '0955'),
	handler: function handler(bits) {
		var d = new Date();
		var h = parseInt(bits[1].substring(0, 2));
		var m = parseInt(bits[1].substring(2, 4), 10);
		var s = parseInt(bits[1].substring(4, 6), 10);
		if (isNaN(m)) {
			m = 0;
		}
		if (isNaN(s)) {
			s = 0;
		}
		d.setHours(parseInt(h, 10));
		d.setMinutes(parseInt(m, 10));
		d.setSeconds(parseInt(s, 10));
		return d;
	}
}];

/**
 * Parses a string to figure out the time it represents
 *
 * @param string s String to parse
 * @return Date a valid Date object
 * @throws Error
 */
function parseTimeString(s) {
	//console.log(s)
	for (var i = 0; i < timeParsePatterns.length; i++) {

		var re = timeParsePatterns[i].re;
		var handler = timeParsePatterns[i].handler;
		var bits = re.exec(s);
		//console.log(re, bits)
		if (bits) {
			return handler(bits);
		}
	}
	throw new Error("Invalid time string");
}

function calculateTimeZone() {
	var rightNow = new Date();
	var jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0); // jan 1st
	var june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0); // june 1st
	var temp = jan1.toGMTString();
	var jan2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
	temp = june1.toGMTString();
	var june2 = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
	var std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
	var daylight_time_offset = (june1 - june2) / (1000 * 60 * 60);
	var dst;
	if (std_time_offset == daylight_time_offset) {
		dst = "0"; // daylight savings time is NOT observed
	} else {
		// positive is southern, negative is northern hemisphere
		var hemisphere = std_time_offset - daylight_time_offset;
		if (hemisphere >= 0) std_time_offset = daylight_time_offset;
		dst = "1"; // daylight savings time is observed
	}

	var value = std_time_offset;
	var hours = parseInt(value);
	value -= parseInt(value);
	value *= 60;
	var mins = parseInt(value);
	value -= parseInt(value);
	value *= 60;
	var secs = parseInt(value);
	var display_hours = hours;
	// handle GMT case (00:00)
	if (hours == 0) {
		display_hours = "00";
	} else if (hours > 0) {
		// add a plus sign and perhaps an extra 0
		display_hours = hours < 10 ? "+0" + hours : "+" + hours;
	} else {
		// add an extra 0 if needed 
		display_hours = hours > -10 ? "-0" + Math.abs(hours) : hours;
	}

	mins = mins < 10 ? "0" + mins : mins;
	return display_hours + ":" + mins;
}

module.exports = {
	calculateTimeZone: calculateTimeZone
};

/***/ }),
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e55198d6fcd57630f0617639e2f6da90.woff2";

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5bc68beaa268b82c7dcc0e9efe15a9b.woff";

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13244bd99451605c61b32c9617162c1f.woff2";

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "378190cee34340e512bec161ad49a4ce.woff";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1ebab08781dd6eebbe312e6f97f6e26a.woff2";

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a921243c4101d28a6ecb76d6fc786646.woff";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "05c88e41fc725cb1974b99534a8f8357.woff";

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8ffdeb3144d5055756ef01ef98e8486.woff";

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dc95b864b51e1551c77c1f1adb4c3601.woff";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vendor-06f34aa5ef530712b08c.js